import { a as __toESM, n as __export, t as __commonJSMin } from "./rolldown-runtime-x13byRvb.js";
var Events$1;
(function(e12) {
  e12.ERROR_EVENT = "CORNERSTONE_ERROR", e12.CACHE_SIZE_EXCEEDED = "CACHE_SIZE_EXCEEDED", e12.IMAGE_LOAD_ERROR = "IMAGE_LOAD_ERROR", e12.CAMERA_MODIFIED = "CORNERSTONE_CAMERA_MODIFIED", e12.CAMERA_RESET = "CORNERSTONE_CAMERA_RESET", e12.VOI_MODIFIED = "CORNERSTONE_VOI_MODIFIED", e12.PRESET_MODIFIED = "CORNERSTONE_VIEWPORT_RENDERING_PRESET_MODIFIED", e12.DISPLAY_AREA_MODIFIED = "CORNERSTONE_DISPLAY_AREA_MODIFIED", e12.ELEMENT_DISABLED = "CORNERSTONE_ELEMENT_DISABLED", e12.ELEMENT_ENABLED = "CORNERSTONE_ELEMENT_ENABLED", e12.IMAGE_RENDERED = "CORNERSTONE_IMAGE_RENDERED", e12.IMAGE_VOLUME_MODIFIED = "CORNERSTONE_IMAGE_VOLUME_MODIFIED", e12.IMAGE_VOLUME_LOADING_COMPLETED = "CORNERSTONE_IMAGE_VOLUME_LOADING_COMPLETED", e12.IMAGE_LOADED = "CORNERSTONE_IMAGE_LOADED", e12.IMAGE_RETRIEVAL_STAGE = "CORNERSTONE_IMAGE_RETRIEVAL_STAGE", e12.IMAGE_LOAD_FAILED = "CORNERSTONE_IMAGE_LOAD_FAILED", e12.VOLUME_VIEWPORT_NEW_VOLUME = "CORNERSTONE_VOLUME_VIEWPORT_NEW_VOLUME", e12.VOLUME_LOADED = "CORNERSTONE_VOLUME_LOADED", e12.VOLUME_LOADED_FAILED = "CORNERSTONE_VOLUME_LOADED_FAILED", e12.IMAGE_CACHE_IMAGE_ADDED = "CORNERSTONE_IMAGE_CACHE_IMAGE_ADDED", e12.IMAGE_CACHE_IMAGE_REMOVED = "CORNERSTONE_IMAGE_CACHE_IMAGE_REMOVED", e12.VOLUME_CACHE_VOLUME_ADDED = "CORNERSTONE_VOLUME_CACHE_VOLUME_ADDED", e12.VOLUME_CACHE_VOLUME_REMOVED = "CORNERSTONE_VOLUME_CACHE_VOLUME_REMOVED", e12.STACK_NEW_IMAGE = "CORNERSTONE_STACK_NEW_IMAGE", e12.VOLUME_NEW_IMAGE = "CORNERSTONE_VOLUME_NEW_IMAGE", e12.PRE_STACK_NEW_IMAGE = "CORNERSTONE_PRE_STACK_NEW_IMAGE", e12.IMAGE_SPACING_CALIBRATED = "CORNERSTONE_IMAGE_SPACING_CALIBRATED", e12.VIEWPORT_NEW_IMAGE_SET = "CORNERSTONE_VIEWPORT_NEW_IMAGE_SET", e12.STACK_VIEWPORT_SCROLL = "CORNERSTONE_STACK_VIEWPORT_SCROLL", e12.STACK_SCROLL_OUT_OF_BOUNDS = "STACK_SCROLL_OUT_OF_BOUNDS", e12.GEOMETRY_CACHE_GEOMETRY_ADDED = "CORNERSTONE_GEOMETRY_CACHE_GEOMETRY_ADDED", e12.GEOMETRY_CACHE_GEOMETRY_REMOVED = "CORNERSTONE_GEOMETRY_CACHE_GEOMETRY_REMOVED", e12.VOLUME_VIEWPORT_SCROLL_OUT_OF_BOUNDS = "VOLUME_VIEWPORT_SCROLL_OUT_OF_BOUNDS", e12.VOLUME_VIEWPORT_SCROLL = "VOLUME_VIEWPORT_SCROLL", e12.CLIPPING_PLANES_UPDATED = "CORNERSTONE_CLIPPING_PLANES_UPDATED", e12.WEB_WORKER_PROGRESS = "CORNERSTONE_WEB_WORKER_PROGRESS", e12.COLORMAP_MODIFIED = "CORNERSTONE_COLORMAP_MODIFIED", e12.DYNAMIC_VOLUME_DIMENSION_GROUP_CHANGED = "DYNAMIC_VOLUME_DIMENSION_GROUP_CHANGED", e12.DYNAMIC_VOLUME_TIME_POINT_INDEX_CHANGED = "DYNAMIC_VOLUME_TIME_POINT_INDEX_CHANGED", e12.DYNAMIC_VOLUME_DIMENSION_GROUP_LOADED = "DYNAMIC_VOLUME_DIMENSION_GROUP_LOADED", e12.DYNAMIC_VOLUME_TIME_POINT_LOADED = "DYNAMIC_VOLUME_TIME_POINT_LOADED", e12.GEOMETRY_LOADED = "GEOMETRY_LOADED", e12.GEOMETRY_LOAD_PROGRESS = "GEOMETRY_LOAD_PROGRESS", e12.GEOMETRY_LOADED_FAILED = "GEOMETRY_LOADED_FAILED", e12.ACTORS_CHANGED = "CORNERSTONE_ACTORS_CHANGED";
})(Events$1 ||= {});
var Events_default = Events$1, RequestType;
(function(e12) {
  e12.Interaction = "interaction", e12.Thumbnail = "thumbnail", e12.Prefetch = "prefetch", e12.Compute = "compute";
})(RequestType ||= {});
var RequestType_default = RequestType, ViewportType;
(function(e12) {
  e12.STACK = "stack", e12.ORTHOGRAPHIC = "orthographic", e12.PERSPECTIVE = "perspective", e12.VOLUME_3D = "volume3d", e12.VIDEO = "video", e12.WHOLE_SLIDE = "wholeSlide", e12.ECG = "ecg";
})(ViewportType ||= {});
var ViewportType_default = ViewportType, InterpolationType$4;
(function(e12) {
  e12[e12.NEAREST = 0] = "NEAREST", e12[e12.LINEAR = 1] = "LINEAR", e12[e12.FAST_LINEAR = 2] = "FAST_LINEAR";
})(InterpolationType$4 ||= {});
var InterpolationType_default = InterpolationType$4, BlendMode$1 = {
  COMPOSITE_BLEND: 0,
  MAXIMUM_INTENSITY_BLEND: 1,
  MINIMUM_INTENSITY_BLEND: 2,
  AVERAGE_INTENSITY_BLEND: 3,
  ADDITIVE_INTENSITY_BLEND: 4,
  RADON_TRANSFORM_BLEND: 5,
  LABELMAP_EDGE_PROJECTION_BLEND: 6
}, Constants$4 = { BlendMode: BlendMode$1 }, { BlendMode: BlendMode$2 } = Constants$4, BlendModes;
(function(e12) {
  e12[e12.COMPOSITE = BlendMode$2.COMPOSITE_BLEND] = "COMPOSITE", e12[e12.MAXIMUM_INTENSITY_BLEND = BlendMode$2.MAXIMUM_INTENSITY_BLEND] = "MAXIMUM_INTENSITY_BLEND", e12[e12.MINIMUM_INTENSITY_BLEND = BlendMode$2.MINIMUM_INTENSITY_BLEND] = "MINIMUM_INTENSITY_BLEND", e12[e12.AVERAGE_INTENSITY_BLEND = BlendMode$2.AVERAGE_INTENSITY_BLEND] = "AVERAGE_INTENSITY_BLEND", e12[e12.LABELMAP_EDGE_PROJECTION_BLEND = BlendMode$2.LABELMAP_EDGE_PROJECTION_BLEND] = "LABELMAP_EDGE_PROJECTION_BLEND";
})(BlendModes ||= {});
var BlendModes_default = BlendModes, OrientationAxis$1;
(function(e12) {
  e12.AXIAL = "axial", e12.CORONAL = "coronal", e12.SAGITTAL = "sagittal", e12.ACQUISITION = "acquisition", e12.AXIAL_REFORMAT = "axial_reformat", e12.CORONAL_REFORMAT = "coronal_reformat", e12.SAGITTAL_REFORMAT = "sagittal_reformat", e12.REFORMAT = "reformat";
})(OrientationAxis$1 ||= {});
var OrientationAxis_default = OrientationAxis$1, GeometryType;
(function(e12) {
  e12.CONTOUR = "CONTOUR", e12.SURFACE = "SURFACE", e12.MESH = "MESH";
})(GeometryType ||= {});
var GeometryType_default = GeometryType, ContourType;
(function(e12) {
  e12.CLOSED_PLANAR = "CLOSED_PLANAR", e12.OPEN_PLANAR = "OPEN_PLANAR";
})(ContourType ||= {});
var ContourType_default = ContourType, MeshType;
(function(e12) {
  e12.PLY = "PLY", e12.STL = "STL", e12.OBJ = "OBJ", e12.VTP = "VTP";
})(MeshType ||= {});
var MeshType_default = MeshType, VOILUTFunctionType;
(function(e12) {
  e12.LINEAR = "LINEAR", e12.SAMPLED_SIGMOID = "SIGMOID", e12.LINEAR_EXACT = "LINEAR_EXACT";
})(VOILUTFunctionType ||= {});
var VOILUTFunctionType_default = VOILUTFunctionType, DynamicOperatorType;
(function(e12) {
  e12.SUM = "SUM", e12.AVERAGE = "AVERAGE", e12.SUBTRACT = "SUBTRACT";
})(DynamicOperatorType ||= {});
var DynamicOperatorType_default = DynamicOperatorType, CalibrationTypes;
(function(e12) {
  e12.NOT_APPLICABLE = "", e12.ERMF = "ERMF", e12.USER = "User", e12.PROJECTION = "Proj", e12.REGION = "Region", e12.ERROR = "Error", e12.UNCALIBRATED = "Uncalibrated", e12.CALIBRATED = "Calibrated", e12.UNKNOWN = "Unknown";
})(CalibrationTypes ||= {});
var CalibrationTypes_default = CalibrationTypes, ViewportStatus;
(function(e12) {
  e12.NO_DATA = "noData", e12.LOADING = "loading", e12.PRE_RENDER = "preRender", e12.NEEDS_RENDER = "needsRender", e12.RESIZE = "resize", e12.RENDERED = "rendered";
})(ViewportStatus ||= {});
var ViewportStatus_default = ViewportStatus, ImageQualityStatus;
(function(e12) {
  e12[e12.FAR_REPLICATE = 1] = "FAR_REPLICATE", e12[e12.ADJACENT_REPLICATE = 3] = "ADJACENT_REPLICATE", e12[e12.SUBRESOLUTION = 6] = "SUBRESOLUTION", e12[e12.LOSSY = 7] = "LOSSY", e12[e12.FULL_RESOLUTION = 8] = "FULL_RESOLUTION";
})(ImageQualityStatus ||= {});
var ImageQualityStatus_default = ImageQualityStatus, VideoEnums_exports = /* @__PURE__ */ __export({ SpeedUnit: () => SpeedUnit }), SpeedUnit;
(function(e12) {
  e12.FRAME = "f", e12.SECOND = "s";
})(SpeedUnit ||= {});
var MetadataModules;
(function(e12) {
  e12.CALIBRATION = "calibrationModule", e12.CINE = "cineModule", e12.GENERAL_IMAGE = "generalImageModule", e12.GENERAL_SERIES = "generalSeriesModule", e12.GENERAL_STUDY = "generalStudyModule", e12.IMAGE_PIXEL = "imagePixelModule", e12.IMAGE_PLANE = "imagePlaneModule", e12.IMAGE_URL = "imageUrlModule", e12.MODALITY_LUT = "modalityLutModule", e12.MULTIFRAME = "multiframeModule", e12.NM_MULTIFRAME_GEOMETRY = "nmMultiframeGeometryModule", e12.OVERLAY_PLANE = "overlayPlaneModule", e12.PATIENT = "patientModule", e12.PATIENT_STUDY = "patientStudyModule", e12.PET_IMAGE = "petImageModule", e12.PET_ISOTOPE = "petIsotopeModule", e12.PET_SERIES = "petSeriesModule", e12.SOP_COMMON = "sopCommonModule", e12.ULTRASOUND_ENHANCED_REGION = "ultrasoundEnhancedRegionModule", e12.ECG = "ecgModule", e12.VOI_LUT = "voiLutModule", e12.FRAME_MODULE = "frameModule", e12.WADO_WEB_CLIENT = "wadoWebClient", e12.INSTANCE = "instance", e12.IMAGE_SOP_INSTANCE_REFERENCE = "ImageSopInstanceReference", e12.REFERENCED_SERIES_REFERENCE = "ReferencedSeriesReference", e12.PREDECESSOR_SEQUENCE = "PredecessorSequence", e12.STUDY_DATA = "StudyData", e12.SERIES_DATA = "SeriesData", e12.IMAGE_DATA = "ImageData", e12.RTSS_INSTANCE_DATA = "RtssInstanceData", e12.NEW_INSTANCE_DATA = "NewInstanceData", e12.RTSS_CONTOUR = "metaRTSSContour", e12.SEG_BIT = "metaSegBitmap", e12.SR_ANNOTATION = "metaSrAnnotation";
})(MetadataModules ||= {});
var MetadataModules_default = MetadataModules, GenerateImageType;
(function(e12) {
  e12.SUM = "SUM", e12.SUBTRACT = "SUBTRACT", e12.AVERAGE = "AVERAGE";
})(GenerateImageType ||= {});
var VoxelManagerEnum;
(function(e12) {
  e12.RLE = "RLE", e12.Volume = "Volume";
})(VoxelManagerEnum ||= {});
var VoxelManagerEnum_default = VoxelManagerEnum, RenderingEngineModeEnum;
(function(e12) {
  e12.Tiled = "tiled", e12.ContextPool = "contextPool";
})(RenderingEngineModeEnum ||= {});
var RenderingEngineModeEnum_default = RenderingEngineModeEnum, enums_exports = /* @__PURE__ */ __export({
  BlendModes: () => BlendModes_default,
  CalibrationTypes: () => CalibrationTypes_default,
  ContourType: () => ContourType_default,
  DynamicOperatorType: () => DynamicOperatorType_default,
  Events: () => Events_default,
  GenerateImageType: () => GenerateImageType,
  GeometryType: () => GeometryType_default,
  ImageQualityStatus: () => ImageQualityStatus_default,
  InterpolationType: () => InterpolationType_default,
  MeshType: () => MeshType_default,
  MetadataModules: () => MetadataModules_default,
  OrientationAxis: () => OrientationAxis_default,
  RenderingEngineModeEnum: () => RenderingEngineModeEnum_default,
  RequestType: () => RequestType_default,
  VOILUTFunctionType: () => VOILUTFunctionType_default,
  VideoEnums: () => VideoEnums_exports,
  ViewportStatus: () => ViewportStatus_default,
  ViewportType: () => ViewportType_default,
  VoxelManagerEnum: () => VoxelManagerEnum_default
}), cpuColormaps_default = {
  hotIron: {
    name: "Hot Iron",
    numOfColors: 256,
    colors: [
      [
        0,
        0,
        0,
        255
      ],
      [
        2,
        0,
        0,
        255
      ],
      [
        4,
        0,
        0,
        255
      ],
      [
        6,
        0,
        0,
        255
      ],
      [
        8,
        0,
        0,
        255
      ],
      [
        10,
        0,
        0,
        255
      ],
      [
        12,
        0,
        0,
        255
      ],
      [
        14,
        0,
        0,
        255
      ],
      [
        16,
        0,
        0,
        255
      ],
      [
        18,
        0,
        0,
        255
      ],
      [
        20,
        0,
        0,
        255
      ],
      [
        22,
        0,
        0,
        255
      ],
      [
        24,
        0,
        0,
        255
      ],
      [
        26,
        0,
        0,
        255
      ],
      [
        28,
        0,
        0,
        255
      ],
      [
        30,
        0,
        0,
        255
      ],
      [
        32,
        0,
        0,
        255
      ],
      [
        34,
        0,
        0,
        255
      ],
      [
        36,
        0,
        0,
        255
      ],
      [
        38,
        0,
        0,
        255
      ],
      [
        40,
        0,
        0,
        255
      ],
      [
        42,
        0,
        0,
        255
      ],
      [
        44,
        0,
        0,
        255
      ],
      [
        46,
        0,
        0,
        255
      ],
      [
        48,
        0,
        0,
        255
      ],
      [
        50,
        0,
        0,
        255
      ],
      [
        52,
        0,
        0,
        255
      ],
      [
        54,
        0,
        0,
        255
      ],
      [
        56,
        0,
        0,
        255
      ],
      [
        58,
        0,
        0,
        255
      ],
      [
        60,
        0,
        0,
        255
      ],
      [
        62,
        0,
        0,
        255
      ],
      [
        64,
        0,
        0,
        255
      ],
      [
        66,
        0,
        0,
        255
      ],
      [
        68,
        0,
        0,
        255
      ],
      [
        70,
        0,
        0,
        255
      ],
      [
        72,
        0,
        0,
        255
      ],
      [
        74,
        0,
        0,
        255
      ],
      [
        76,
        0,
        0,
        255
      ],
      [
        78,
        0,
        0,
        255
      ],
      [
        80,
        0,
        0,
        255
      ],
      [
        82,
        0,
        0,
        255
      ],
      [
        84,
        0,
        0,
        255
      ],
      [
        86,
        0,
        0,
        255
      ],
      [
        88,
        0,
        0,
        255
      ],
      [
        90,
        0,
        0,
        255
      ],
      [
        92,
        0,
        0,
        255
      ],
      [
        94,
        0,
        0,
        255
      ],
      [
        96,
        0,
        0,
        255
      ],
      [
        98,
        0,
        0,
        255
      ],
      [
        100,
        0,
        0,
        255
      ],
      [
        102,
        0,
        0,
        255
      ],
      [
        104,
        0,
        0,
        255
      ],
      [
        106,
        0,
        0,
        255
      ],
      [
        108,
        0,
        0,
        255
      ],
      [
        110,
        0,
        0,
        255
      ],
      [
        112,
        0,
        0,
        255
      ],
      [
        114,
        0,
        0,
        255
      ],
      [
        116,
        0,
        0,
        255
      ],
      [
        118,
        0,
        0,
        255
      ],
      [
        120,
        0,
        0,
        255
      ],
      [
        122,
        0,
        0,
        255
      ],
      [
        124,
        0,
        0,
        255
      ],
      [
        126,
        0,
        0,
        255
      ],
      [
        128,
        0,
        0,
        255
      ],
      [
        130,
        0,
        0,
        255
      ],
      [
        132,
        0,
        0,
        255
      ],
      [
        134,
        0,
        0,
        255
      ],
      [
        136,
        0,
        0,
        255
      ],
      [
        138,
        0,
        0,
        255
      ],
      [
        140,
        0,
        0,
        255
      ],
      [
        142,
        0,
        0,
        255
      ],
      [
        144,
        0,
        0,
        255
      ],
      [
        146,
        0,
        0,
        255
      ],
      [
        148,
        0,
        0,
        255
      ],
      [
        150,
        0,
        0,
        255
      ],
      [
        152,
        0,
        0,
        255
      ],
      [
        154,
        0,
        0,
        255
      ],
      [
        156,
        0,
        0,
        255
      ],
      [
        158,
        0,
        0,
        255
      ],
      [
        160,
        0,
        0,
        255
      ],
      [
        162,
        0,
        0,
        255
      ],
      [
        164,
        0,
        0,
        255
      ],
      [
        166,
        0,
        0,
        255
      ],
      [
        168,
        0,
        0,
        255
      ],
      [
        170,
        0,
        0,
        255
      ],
      [
        172,
        0,
        0,
        255
      ],
      [
        174,
        0,
        0,
        255
      ],
      [
        176,
        0,
        0,
        255
      ],
      [
        178,
        0,
        0,
        255
      ],
      [
        180,
        0,
        0,
        255
      ],
      [
        182,
        0,
        0,
        255
      ],
      [
        184,
        0,
        0,
        255
      ],
      [
        186,
        0,
        0,
        255
      ],
      [
        188,
        0,
        0,
        255
      ],
      [
        190,
        0,
        0,
        255
      ],
      [
        192,
        0,
        0,
        255
      ],
      [
        194,
        0,
        0,
        255
      ],
      [
        196,
        0,
        0,
        255
      ],
      [
        198,
        0,
        0,
        255
      ],
      [
        200,
        0,
        0,
        255
      ],
      [
        202,
        0,
        0,
        255
      ],
      [
        204,
        0,
        0,
        255
      ],
      [
        206,
        0,
        0,
        255
      ],
      [
        208,
        0,
        0,
        255
      ],
      [
        210,
        0,
        0,
        255
      ],
      [
        212,
        0,
        0,
        255
      ],
      [
        214,
        0,
        0,
        255
      ],
      [
        216,
        0,
        0,
        255
      ],
      [
        218,
        0,
        0,
        255
      ],
      [
        220,
        0,
        0,
        255
      ],
      [
        222,
        0,
        0,
        255
      ],
      [
        224,
        0,
        0,
        255
      ],
      [
        226,
        0,
        0,
        255
      ],
      [
        228,
        0,
        0,
        255
      ],
      [
        230,
        0,
        0,
        255
      ],
      [
        232,
        0,
        0,
        255
      ],
      [
        234,
        0,
        0,
        255
      ],
      [
        236,
        0,
        0,
        255
      ],
      [
        238,
        0,
        0,
        255
      ],
      [
        240,
        0,
        0,
        255
      ],
      [
        242,
        0,
        0,
        255
      ],
      [
        244,
        0,
        0,
        255
      ],
      [
        246,
        0,
        0,
        255
      ],
      [
        248,
        0,
        0,
        255
      ],
      [
        250,
        0,
        0,
        255
      ],
      [
        252,
        0,
        0,
        255
      ],
      [
        254,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        2,
        0,
        255
      ],
      [
        255,
        4,
        0,
        255
      ],
      [
        255,
        6,
        0,
        255
      ],
      [
        255,
        8,
        0,
        255
      ],
      [
        255,
        10,
        0,
        255
      ],
      [
        255,
        12,
        0,
        255
      ],
      [
        255,
        14,
        0,
        255
      ],
      [
        255,
        16,
        0,
        255
      ],
      [
        255,
        18,
        0,
        255
      ],
      [
        255,
        20,
        0,
        255
      ],
      [
        255,
        22,
        0,
        255
      ],
      [
        255,
        24,
        0,
        255
      ],
      [
        255,
        26,
        0,
        255
      ],
      [
        255,
        28,
        0,
        255
      ],
      [
        255,
        30,
        0,
        255
      ],
      [
        255,
        32,
        0,
        255
      ],
      [
        255,
        34,
        0,
        255
      ],
      [
        255,
        36,
        0,
        255
      ],
      [
        255,
        38,
        0,
        255
      ],
      [
        255,
        40,
        0,
        255
      ],
      [
        255,
        42,
        0,
        255
      ],
      [
        255,
        44,
        0,
        255
      ],
      [
        255,
        46,
        0,
        255
      ],
      [
        255,
        48,
        0,
        255
      ],
      [
        255,
        50,
        0,
        255
      ],
      [
        255,
        52,
        0,
        255
      ],
      [
        255,
        54,
        0,
        255
      ],
      [
        255,
        56,
        0,
        255
      ],
      [
        255,
        58,
        0,
        255
      ],
      [
        255,
        60,
        0,
        255
      ],
      [
        255,
        62,
        0,
        255
      ],
      [
        255,
        64,
        0,
        255
      ],
      [
        255,
        66,
        0,
        255
      ],
      [
        255,
        68,
        0,
        255
      ],
      [
        255,
        70,
        0,
        255
      ],
      [
        255,
        72,
        0,
        255
      ],
      [
        255,
        74,
        0,
        255
      ],
      [
        255,
        76,
        0,
        255
      ],
      [
        255,
        78,
        0,
        255
      ],
      [
        255,
        80,
        0,
        255
      ],
      [
        255,
        82,
        0,
        255
      ],
      [
        255,
        84,
        0,
        255
      ],
      [
        255,
        86,
        0,
        255
      ],
      [
        255,
        88,
        0,
        255
      ],
      [
        255,
        90,
        0,
        255
      ],
      [
        255,
        92,
        0,
        255
      ],
      [
        255,
        94,
        0,
        255
      ],
      [
        255,
        96,
        0,
        255
      ],
      [
        255,
        98,
        0,
        255
      ],
      [
        255,
        100,
        0,
        255
      ],
      [
        255,
        102,
        0,
        255
      ],
      [
        255,
        104,
        0,
        255
      ],
      [
        255,
        106,
        0,
        255
      ],
      [
        255,
        108,
        0,
        255
      ],
      [
        255,
        110,
        0,
        255
      ],
      [
        255,
        112,
        0,
        255
      ],
      [
        255,
        114,
        0,
        255
      ],
      [
        255,
        116,
        0,
        255
      ],
      [
        255,
        118,
        0,
        255
      ],
      [
        255,
        120,
        0,
        255
      ],
      [
        255,
        122,
        0,
        255
      ],
      [
        255,
        124,
        0,
        255
      ],
      [
        255,
        126,
        0,
        255
      ],
      [
        255,
        128,
        4,
        255
      ],
      [
        255,
        130,
        8,
        255
      ],
      [
        255,
        132,
        12,
        255
      ],
      [
        255,
        134,
        16,
        255
      ],
      [
        255,
        136,
        20,
        255
      ],
      [
        255,
        138,
        24,
        255
      ],
      [
        255,
        140,
        28,
        255
      ],
      [
        255,
        142,
        32,
        255
      ],
      [
        255,
        144,
        36,
        255
      ],
      [
        255,
        146,
        40,
        255
      ],
      [
        255,
        148,
        44,
        255
      ],
      [
        255,
        150,
        48,
        255
      ],
      [
        255,
        152,
        52,
        255
      ],
      [
        255,
        154,
        56,
        255
      ],
      [
        255,
        156,
        60,
        255
      ],
      [
        255,
        158,
        64,
        255
      ],
      [
        255,
        160,
        68,
        255
      ],
      [
        255,
        162,
        72,
        255
      ],
      [
        255,
        164,
        76,
        255
      ],
      [
        255,
        166,
        80,
        255
      ],
      [
        255,
        168,
        84,
        255
      ],
      [
        255,
        170,
        88,
        255
      ],
      [
        255,
        172,
        92,
        255
      ],
      [
        255,
        174,
        96,
        255
      ],
      [
        255,
        176,
        100,
        255
      ],
      [
        255,
        178,
        104,
        255
      ],
      [
        255,
        180,
        108,
        255
      ],
      [
        255,
        182,
        112,
        255
      ],
      [
        255,
        184,
        116,
        255
      ],
      [
        255,
        186,
        120,
        255
      ],
      [
        255,
        188,
        124,
        255
      ],
      [
        255,
        190,
        128,
        255
      ],
      [
        255,
        192,
        132,
        255
      ],
      [
        255,
        194,
        136,
        255
      ],
      [
        255,
        196,
        140,
        255
      ],
      [
        255,
        198,
        144,
        255
      ],
      [
        255,
        200,
        148,
        255
      ],
      [
        255,
        202,
        152,
        255
      ],
      [
        255,
        204,
        156,
        255
      ],
      [
        255,
        206,
        160,
        255
      ],
      [
        255,
        208,
        164,
        255
      ],
      [
        255,
        210,
        168,
        255
      ],
      [
        255,
        212,
        172,
        255
      ],
      [
        255,
        214,
        176,
        255
      ],
      [
        255,
        216,
        180,
        255
      ],
      [
        255,
        218,
        184,
        255
      ],
      [
        255,
        220,
        188,
        255
      ],
      [
        255,
        222,
        192,
        255
      ],
      [
        255,
        224,
        196,
        255
      ],
      [
        255,
        226,
        200,
        255
      ],
      [
        255,
        228,
        204,
        255
      ],
      [
        255,
        230,
        208,
        255
      ],
      [
        255,
        232,
        212,
        255
      ],
      [
        255,
        234,
        216,
        255
      ],
      [
        255,
        236,
        220,
        255
      ],
      [
        255,
        238,
        224,
        255
      ],
      [
        255,
        240,
        228,
        255
      ],
      [
        255,
        242,
        232,
        255
      ],
      [
        255,
        244,
        236,
        255
      ],
      [
        255,
        246,
        240,
        255
      ],
      [
        255,
        248,
        244,
        255
      ],
      [
        255,
        250,
        248,
        255
      ],
      [
        255,
        252,
        252,
        255
      ],
      [
        255,
        255,
        255,
        255
      ]
    ]
  },
  pet: {
    name: "PET",
    numColors: 256,
    colors: [
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        2,
        1,
        255
      ],
      [
        0,
        4,
        3,
        255
      ],
      [
        0,
        6,
        5,
        255
      ],
      [
        0,
        8,
        7,
        255
      ],
      [
        0,
        10,
        9,
        255
      ],
      [
        0,
        12,
        11,
        255
      ],
      [
        0,
        14,
        13,
        255
      ],
      [
        0,
        16,
        15,
        255
      ],
      [
        0,
        18,
        17,
        255
      ],
      [
        0,
        20,
        19,
        255
      ],
      [
        0,
        22,
        21,
        255
      ],
      [
        0,
        24,
        23,
        255
      ],
      [
        0,
        26,
        25,
        255
      ],
      [
        0,
        28,
        27,
        255
      ],
      [
        0,
        30,
        29,
        255
      ],
      [
        0,
        32,
        31,
        255
      ],
      [
        0,
        34,
        33,
        255
      ],
      [
        0,
        36,
        35,
        255
      ],
      [
        0,
        38,
        37,
        255
      ],
      [
        0,
        40,
        39,
        255
      ],
      [
        0,
        42,
        41,
        255
      ],
      [
        0,
        44,
        43,
        255
      ],
      [
        0,
        46,
        45,
        255
      ],
      [
        0,
        48,
        47,
        255
      ],
      [
        0,
        50,
        49,
        255
      ],
      [
        0,
        52,
        51,
        255
      ],
      [
        0,
        54,
        53,
        255
      ],
      [
        0,
        56,
        55,
        255
      ],
      [
        0,
        58,
        57,
        255
      ],
      [
        0,
        60,
        59,
        255
      ],
      [
        0,
        62,
        61,
        255
      ],
      [
        0,
        65,
        63,
        255
      ],
      [
        0,
        67,
        65,
        255
      ],
      [
        0,
        69,
        67,
        255
      ],
      [
        0,
        71,
        69,
        255
      ],
      [
        0,
        73,
        71,
        255
      ],
      [
        0,
        75,
        73,
        255
      ],
      [
        0,
        77,
        75,
        255
      ],
      [
        0,
        79,
        77,
        255
      ],
      [
        0,
        81,
        79,
        255
      ],
      [
        0,
        83,
        81,
        255
      ],
      [
        0,
        85,
        83,
        255
      ],
      [
        0,
        87,
        85,
        255
      ],
      [
        0,
        89,
        87,
        255
      ],
      [
        0,
        91,
        89,
        255
      ],
      [
        0,
        93,
        91,
        255
      ],
      [
        0,
        95,
        93,
        255
      ],
      [
        0,
        97,
        95,
        255
      ],
      [
        0,
        99,
        97,
        255
      ],
      [
        0,
        101,
        99,
        255
      ],
      [
        0,
        103,
        101,
        255
      ],
      [
        0,
        105,
        103,
        255
      ],
      [
        0,
        107,
        105,
        255
      ],
      [
        0,
        109,
        107,
        255
      ],
      [
        0,
        111,
        109,
        255
      ],
      [
        0,
        113,
        111,
        255
      ],
      [
        0,
        115,
        113,
        255
      ],
      [
        0,
        117,
        115,
        255
      ],
      [
        0,
        119,
        117,
        255
      ],
      [
        0,
        121,
        119,
        255
      ],
      [
        0,
        123,
        121,
        255
      ],
      [
        0,
        125,
        123,
        255
      ],
      [
        0,
        128,
        125,
        255
      ],
      [
        1,
        126,
        127,
        255
      ],
      [
        3,
        124,
        129,
        255
      ],
      [
        5,
        122,
        131,
        255
      ],
      [
        7,
        120,
        133,
        255
      ],
      [
        9,
        118,
        135,
        255
      ],
      [
        11,
        116,
        137,
        255
      ],
      [
        13,
        114,
        139,
        255
      ],
      [
        15,
        112,
        141,
        255
      ],
      [
        17,
        110,
        143,
        255
      ],
      [
        19,
        108,
        145,
        255
      ],
      [
        21,
        106,
        147,
        255
      ],
      [
        23,
        104,
        149,
        255
      ],
      [
        25,
        102,
        151,
        255
      ],
      [
        27,
        100,
        153,
        255
      ],
      [
        29,
        98,
        155,
        255
      ],
      [
        31,
        96,
        157,
        255
      ],
      [
        33,
        94,
        159,
        255
      ],
      [
        35,
        92,
        161,
        255
      ],
      [
        37,
        90,
        163,
        255
      ],
      [
        39,
        88,
        165,
        255
      ],
      [
        41,
        86,
        167,
        255
      ],
      [
        43,
        84,
        169,
        255
      ],
      [
        45,
        82,
        171,
        255
      ],
      [
        47,
        80,
        173,
        255
      ],
      [
        49,
        78,
        175,
        255
      ],
      [
        51,
        76,
        177,
        255
      ],
      [
        53,
        74,
        179,
        255
      ],
      [
        55,
        72,
        181,
        255
      ],
      [
        57,
        70,
        183,
        255
      ],
      [
        59,
        68,
        185,
        255
      ],
      [
        61,
        66,
        187,
        255
      ],
      [
        63,
        64,
        189,
        255
      ],
      [
        65,
        63,
        191,
        255
      ],
      [
        67,
        61,
        193,
        255
      ],
      [
        69,
        59,
        195,
        255
      ],
      [
        71,
        57,
        197,
        255
      ],
      [
        73,
        55,
        199,
        255
      ],
      [
        75,
        53,
        201,
        255
      ],
      [
        77,
        51,
        203,
        255
      ],
      [
        79,
        49,
        205,
        255
      ],
      [
        81,
        47,
        207,
        255
      ],
      [
        83,
        45,
        209,
        255
      ],
      [
        85,
        43,
        211,
        255
      ],
      [
        86,
        41,
        213,
        255
      ],
      [
        88,
        39,
        215,
        255
      ],
      [
        90,
        37,
        217,
        255
      ],
      [
        92,
        35,
        219,
        255
      ],
      [
        94,
        33,
        221,
        255
      ],
      [
        96,
        31,
        223,
        255
      ],
      [
        98,
        29,
        225,
        255
      ],
      [
        100,
        27,
        227,
        255
      ],
      [
        102,
        25,
        229,
        255
      ],
      [
        104,
        23,
        231,
        255
      ],
      [
        106,
        21,
        233,
        255
      ],
      [
        108,
        19,
        235,
        255
      ],
      [
        110,
        17,
        237,
        255
      ],
      [
        112,
        15,
        239,
        255
      ],
      [
        114,
        13,
        241,
        255
      ],
      [
        116,
        11,
        243,
        255
      ],
      [
        118,
        9,
        245,
        255
      ],
      [
        120,
        7,
        247,
        255
      ],
      [
        122,
        5,
        249,
        255
      ],
      [
        124,
        3,
        251,
        255
      ],
      [
        126,
        1,
        253,
        255
      ],
      [
        128,
        0,
        255,
        255
      ],
      [
        130,
        2,
        252,
        255
      ],
      [
        132,
        4,
        248,
        255
      ],
      [
        134,
        6,
        244,
        255
      ],
      [
        136,
        8,
        240,
        255
      ],
      [
        138,
        10,
        236,
        255
      ],
      [
        140,
        12,
        232,
        255
      ],
      [
        142,
        14,
        228,
        255
      ],
      [
        144,
        16,
        224,
        255
      ],
      [
        146,
        18,
        220,
        255
      ],
      [
        148,
        20,
        216,
        255
      ],
      [
        150,
        22,
        212,
        255
      ],
      [
        152,
        24,
        208,
        255
      ],
      [
        154,
        26,
        204,
        255
      ],
      [
        156,
        28,
        200,
        255
      ],
      [
        158,
        30,
        196,
        255
      ],
      [
        160,
        32,
        192,
        255
      ],
      [
        162,
        34,
        188,
        255
      ],
      [
        164,
        36,
        184,
        255
      ],
      [
        166,
        38,
        180,
        255
      ],
      [
        168,
        40,
        176,
        255
      ],
      [
        170,
        42,
        172,
        255
      ],
      [
        171,
        44,
        168,
        255
      ],
      [
        173,
        46,
        164,
        255
      ],
      [
        175,
        48,
        160,
        255
      ],
      [
        177,
        50,
        156,
        255
      ],
      [
        179,
        52,
        152,
        255
      ],
      [
        181,
        54,
        148,
        255
      ],
      [
        183,
        56,
        144,
        255
      ],
      [
        185,
        58,
        140,
        255
      ],
      [
        187,
        60,
        136,
        255
      ],
      [
        189,
        62,
        132,
        255
      ],
      [
        191,
        64,
        128,
        255
      ],
      [
        193,
        66,
        124,
        255
      ],
      [
        195,
        68,
        120,
        255
      ],
      [
        197,
        70,
        116,
        255
      ],
      [
        199,
        72,
        112,
        255
      ],
      [
        201,
        74,
        108,
        255
      ],
      [
        203,
        76,
        104,
        255
      ],
      [
        205,
        78,
        100,
        255
      ],
      [
        207,
        80,
        96,
        255
      ],
      [
        209,
        82,
        92,
        255
      ],
      [
        211,
        84,
        88,
        255
      ],
      [
        213,
        86,
        84,
        255
      ],
      [
        215,
        88,
        80,
        255
      ],
      [
        217,
        90,
        76,
        255
      ],
      [
        219,
        92,
        72,
        255
      ],
      [
        221,
        94,
        68,
        255
      ],
      [
        223,
        96,
        64,
        255
      ],
      [
        225,
        98,
        60,
        255
      ],
      [
        227,
        100,
        56,
        255
      ],
      [
        229,
        102,
        52,
        255
      ],
      [
        231,
        104,
        48,
        255
      ],
      [
        233,
        106,
        44,
        255
      ],
      [
        235,
        108,
        40,
        255
      ],
      [
        237,
        110,
        36,
        255
      ],
      [
        239,
        112,
        32,
        255
      ],
      [
        241,
        114,
        28,
        255
      ],
      [
        243,
        116,
        24,
        255
      ],
      [
        245,
        118,
        20,
        255
      ],
      [
        247,
        120,
        16,
        255
      ],
      [
        249,
        122,
        12,
        255
      ],
      [
        251,
        124,
        8,
        255
      ],
      [
        253,
        126,
        4,
        255
      ],
      [
        255,
        128,
        0,
        255
      ],
      [
        255,
        130,
        4,
        255
      ],
      [
        255,
        132,
        8,
        255
      ],
      [
        255,
        134,
        12,
        255
      ],
      [
        255,
        136,
        16,
        255
      ],
      [
        255,
        138,
        20,
        255
      ],
      [
        255,
        140,
        24,
        255
      ],
      [
        255,
        142,
        28,
        255
      ],
      [
        255,
        144,
        32,
        255
      ],
      [
        255,
        146,
        36,
        255
      ],
      [
        255,
        148,
        40,
        255
      ],
      [
        255,
        150,
        44,
        255
      ],
      [
        255,
        152,
        48,
        255
      ],
      [
        255,
        154,
        52,
        255
      ],
      [
        255,
        156,
        56,
        255
      ],
      [
        255,
        158,
        60,
        255
      ],
      [
        255,
        160,
        64,
        255
      ],
      [
        255,
        162,
        68,
        255
      ],
      [
        255,
        164,
        72,
        255
      ],
      [
        255,
        166,
        76,
        255
      ],
      [
        255,
        168,
        80,
        255
      ],
      [
        255,
        170,
        85,
        255
      ],
      [
        255,
        172,
        89,
        255
      ],
      [
        255,
        174,
        93,
        255
      ],
      [
        255,
        176,
        97,
        255
      ],
      [
        255,
        178,
        101,
        255
      ],
      [
        255,
        180,
        105,
        255
      ],
      [
        255,
        182,
        109,
        255
      ],
      [
        255,
        184,
        113,
        255
      ],
      [
        255,
        186,
        117,
        255
      ],
      [
        255,
        188,
        121,
        255
      ],
      [
        255,
        190,
        125,
        255
      ],
      [
        255,
        192,
        129,
        255
      ],
      [
        255,
        194,
        133,
        255
      ],
      [
        255,
        196,
        137,
        255
      ],
      [
        255,
        198,
        141,
        255
      ],
      [
        255,
        200,
        145,
        255
      ],
      [
        255,
        202,
        149,
        255
      ],
      [
        255,
        204,
        153,
        255
      ],
      [
        255,
        206,
        157,
        255
      ],
      [
        255,
        208,
        161,
        255
      ],
      [
        255,
        210,
        165,
        255
      ],
      [
        255,
        212,
        170,
        255
      ],
      [
        255,
        214,
        174,
        255
      ],
      [
        255,
        216,
        178,
        255
      ],
      [
        255,
        218,
        182,
        255
      ],
      [
        255,
        220,
        186,
        255
      ],
      [
        255,
        222,
        190,
        255
      ],
      [
        255,
        224,
        194,
        255
      ],
      [
        255,
        226,
        198,
        255
      ],
      [
        255,
        228,
        202,
        255
      ],
      [
        255,
        230,
        206,
        255
      ],
      [
        255,
        232,
        210,
        255
      ],
      [
        255,
        234,
        214,
        255
      ],
      [
        255,
        236,
        218,
        255
      ],
      [
        255,
        238,
        222,
        255
      ],
      [
        255,
        240,
        226,
        255
      ],
      [
        255,
        242,
        230,
        255
      ],
      [
        255,
        244,
        234,
        255
      ],
      [
        255,
        246,
        238,
        255
      ],
      [
        255,
        248,
        242,
        255
      ],
      [
        255,
        250,
        246,
        255
      ],
      [
        255,
        252,
        250,
        255
      ],
      [
        255,
        255,
        255,
        255
      ]
    ]
  },
  hotMetalBlue: {
    name: "Hot Metal Blue",
    numColors: 256,
    colors: [
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        2,
        255
      ],
      [
        0,
        0,
        4,
        255
      ],
      [
        0,
        0,
        6,
        255
      ],
      [
        0,
        0,
        8,
        255
      ],
      [
        0,
        0,
        10,
        255
      ],
      [
        0,
        0,
        12,
        255
      ],
      [
        0,
        0,
        14,
        255
      ],
      [
        0,
        0,
        16,
        255
      ],
      [
        0,
        0,
        17,
        255
      ],
      [
        0,
        0,
        19,
        255
      ],
      [
        0,
        0,
        21,
        255
      ],
      [
        0,
        0,
        23,
        255
      ],
      [
        0,
        0,
        25,
        255
      ],
      [
        0,
        0,
        27,
        255
      ],
      [
        0,
        0,
        29,
        255
      ],
      [
        0,
        0,
        31,
        255
      ],
      [
        0,
        0,
        33,
        255
      ],
      [
        0,
        0,
        35,
        255
      ],
      [
        0,
        0,
        37,
        255
      ],
      [
        0,
        0,
        39,
        255
      ],
      [
        0,
        0,
        41,
        255
      ],
      [
        0,
        0,
        43,
        255
      ],
      [
        0,
        0,
        45,
        255
      ],
      [
        0,
        0,
        47,
        255
      ],
      [
        0,
        0,
        49,
        255
      ],
      [
        0,
        0,
        51,
        255
      ],
      [
        0,
        0,
        53,
        255
      ],
      [
        0,
        0,
        55,
        255
      ],
      [
        0,
        0,
        57,
        255
      ],
      [
        0,
        0,
        59,
        255
      ],
      [
        0,
        0,
        61,
        255
      ],
      [
        0,
        0,
        63,
        255
      ],
      [
        0,
        0,
        65,
        255
      ],
      [
        0,
        0,
        67,
        255
      ],
      [
        0,
        0,
        69,
        255
      ],
      [
        0,
        0,
        71,
        255
      ],
      [
        0,
        0,
        73,
        255
      ],
      [
        0,
        0,
        75,
        255
      ],
      [
        0,
        0,
        77,
        255
      ],
      [
        0,
        0,
        79,
        255
      ],
      [
        0,
        0,
        81,
        255
      ],
      [
        0,
        0,
        83,
        255
      ],
      [
        0,
        0,
        84,
        255
      ],
      [
        0,
        0,
        86,
        255
      ],
      [
        0,
        0,
        88,
        255
      ],
      [
        0,
        0,
        90,
        255
      ],
      [
        0,
        0,
        92,
        255
      ],
      [
        0,
        0,
        94,
        255
      ],
      [
        0,
        0,
        96,
        255
      ],
      [
        0,
        0,
        98,
        255
      ],
      [
        0,
        0,
        100,
        255
      ],
      [
        0,
        0,
        102,
        255
      ],
      [
        0,
        0,
        104,
        255
      ],
      [
        0,
        0,
        106,
        255
      ],
      [
        0,
        0,
        108,
        255
      ],
      [
        0,
        0,
        110,
        255
      ],
      [
        0,
        0,
        112,
        255
      ],
      [
        0,
        0,
        114,
        255
      ],
      [
        0,
        0,
        116,
        255
      ],
      [
        0,
        0,
        117,
        255
      ],
      [
        0,
        0,
        119,
        255
      ],
      [
        0,
        0,
        121,
        255
      ],
      [
        0,
        0,
        123,
        255
      ],
      [
        0,
        0,
        125,
        255
      ],
      [
        0,
        0,
        127,
        255
      ],
      [
        0,
        0,
        129,
        255
      ],
      [
        0,
        0,
        131,
        255
      ],
      [
        0,
        0,
        133,
        255
      ],
      [
        0,
        0,
        135,
        255
      ],
      [
        0,
        0,
        137,
        255
      ],
      [
        0,
        0,
        139,
        255
      ],
      [
        0,
        0,
        141,
        255
      ],
      [
        0,
        0,
        143,
        255
      ],
      [
        0,
        0,
        145,
        255
      ],
      [
        0,
        0,
        147,
        255
      ],
      [
        0,
        0,
        149,
        255
      ],
      [
        0,
        0,
        151,
        255
      ],
      [
        0,
        0,
        153,
        255
      ],
      [
        0,
        0,
        155,
        255
      ],
      [
        0,
        0,
        157,
        255
      ],
      [
        0,
        0,
        159,
        255
      ],
      [
        0,
        0,
        161,
        255
      ],
      [
        0,
        0,
        163,
        255
      ],
      [
        0,
        0,
        165,
        255
      ],
      [
        0,
        0,
        167,
        255
      ],
      [
        3,
        0,
        169,
        255
      ],
      [
        6,
        0,
        171,
        255
      ],
      [
        9,
        0,
        173,
        255
      ],
      [
        12,
        0,
        175,
        255
      ],
      [
        15,
        0,
        177,
        255
      ],
      [
        18,
        0,
        179,
        255
      ],
      [
        21,
        0,
        181,
        255
      ],
      [
        24,
        0,
        183,
        255
      ],
      [
        26,
        0,
        184,
        255
      ],
      [
        29,
        0,
        186,
        255
      ],
      [
        32,
        0,
        188,
        255
      ],
      [
        35,
        0,
        190,
        255
      ],
      [
        38,
        0,
        192,
        255
      ],
      [
        41,
        0,
        194,
        255
      ],
      [
        44,
        0,
        196,
        255
      ],
      [
        47,
        0,
        198,
        255
      ],
      [
        50,
        0,
        200,
        255
      ],
      [
        52,
        0,
        197,
        255
      ],
      [
        55,
        0,
        194,
        255
      ],
      [
        57,
        0,
        191,
        255
      ],
      [
        59,
        0,
        188,
        255
      ],
      [
        62,
        0,
        185,
        255
      ],
      [
        64,
        0,
        182,
        255
      ],
      [
        66,
        0,
        179,
        255
      ],
      [
        69,
        0,
        176,
        255
      ],
      [
        71,
        0,
        174,
        255
      ],
      [
        74,
        0,
        171,
        255
      ],
      [
        76,
        0,
        168,
        255
      ],
      [
        78,
        0,
        165,
        255
      ],
      [
        81,
        0,
        162,
        255
      ],
      [
        83,
        0,
        159,
        255
      ],
      [
        85,
        0,
        156,
        255
      ],
      [
        88,
        0,
        153,
        255
      ],
      [
        90,
        0,
        150,
        255
      ],
      [
        93,
        2,
        144,
        255
      ],
      [
        96,
        4,
        138,
        255
      ],
      [
        99,
        6,
        132,
        255
      ],
      [
        102,
        8,
        126,
        255
      ],
      [
        105,
        9,
        121,
        255
      ],
      [
        108,
        11,
        115,
        255
      ],
      [
        111,
        13,
        109,
        255
      ],
      [
        114,
        15,
        103,
        255
      ],
      [
        116,
        17,
        97,
        255
      ],
      [
        119,
        19,
        91,
        255
      ],
      [
        122,
        21,
        85,
        255
      ],
      [
        125,
        23,
        79,
        255
      ],
      [
        128,
        24,
        74,
        255
      ],
      [
        131,
        26,
        68,
        255
      ],
      [
        134,
        28,
        62,
        255
      ],
      [
        137,
        30,
        56,
        255
      ],
      [
        140,
        32,
        50,
        255
      ],
      [
        143,
        34,
        47,
        255
      ],
      [
        146,
        36,
        44,
        255
      ],
      [
        149,
        38,
        41,
        255
      ],
      [
        152,
        40,
        38,
        255
      ],
      [
        155,
        41,
        35,
        255
      ],
      [
        158,
        43,
        32,
        255
      ],
      [
        161,
        45,
        29,
        255
      ],
      [
        164,
        47,
        26,
        255
      ],
      [
        166,
        49,
        24,
        255
      ],
      [
        169,
        51,
        21,
        255
      ],
      [
        172,
        53,
        18,
        255
      ],
      [
        175,
        55,
        15,
        255
      ],
      [
        178,
        56,
        12,
        255
      ],
      [
        181,
        58,
        9,
        255
      ],
      [
        184,
        60,
        6,
        255
      ],
      [
        187,
        62,
        3,
        255
      ],
      [
        190,
        64,
        0,
        255
      ],
      [
        194,
        66,
        0,
        255
      ],
      [
        198,
        68,
        0,
        255
      ],
      [
        201,
        70,
        0,
        255
      ],
      [
        205,
        72,
        0,
        255
      ],
      [
        209,
        73,
        0,
        255
      ],
      [
        213,
        75,
        0,
        255
      ],
      [
        217,
        77,
        0,
        255
      ],
      [
        221,
        79,
        0,
        255
      ],
      [
        224,
        81,
        0,
        255
      ],
      [
        228,
        83,
        0,
        255
      ],
      [
        232,
        85,
        0,
        255
      ],
      [
        236,
        87,
        0,
        255
      ],
      [
        240,
        88,
        0,
        255
      ],
      [
        244,
        90,
        0,
        255
      ],
      [
        247,
        92,
        0,
        255
      ],
      [
        251,
        94,
        0,
        255
      ],
      [
        255,
        96,
        0,
        255
      ],
      [
        255,
        98,
        3,
        255
      ],
      [
        255,
        100,
        6,
        255
      ],
      [
        255,
        102,
        9,
        255
      ],
      [
        255,
        104,
        12,
        255
      ],
      [
        255,
        105,
        15,
        255
      ],
      [
        255,
        107,
        18,
        255
      ],
      [
        255,
        109,
        21,
        255
      ],
      [
        255,
        111,
        24,
        255
      ],
      [
        255,
        113,
        26,
        255
      ],
      [
        255,
        115,
        29,
        255
      ],
      [
        255,
        117,
        32,
        255
      ],
      [
        255,
        119,
        35,
        255
      ],
      [
        255,
        120,
        38,
        255
      ],
      [
        255,
        122,
        41,
        255
      ],
      [
        255,
        124,
        44,
        255
      ],
      [
        255,
        126,
        47,
        255
      ],
      [
        255,
        128,
        50,
        255
      ],
      [
        255,
        130,
        53,
        255
      ],
      [
        255,
        132,
        56,
        255
      ],
      [
        255,
        134,
        59,
        255
      ],
      [
        255,
        136,
        62,
        255
      ],
      [
        255,
        137,
        65,
        255
      ],
      [
        255,
        139,
        68,
        255
      ],
      [
        255,
        141,
        71,
        255
      ],
      [
        255,
        143,
        74,
        255
      ],
      [
        255,
        145,
        76,
        255
      ],
      [
        255,
        147,
        79,
        255
      ],
      [
        255,
        149,
        82,
        255
      ],
      [
        255,
        151,
        85,
        255
      ],
      [
        255,
        152,
        88,
        255
      ],
      [
        255,
        154,
        91,
        255
      ],
      [
        255,
        156,
        94,
        255
      ],
      [
        255,
        158,
        97,
        255
      ],
      [
        255,
        160,
        100,
        255
      ],
      [
        255,
        162,
        103,
        255
      ],
      [
        255,
        164,
        106,
        255
      ],
      [
        255,
        166,
        109,
        255
      ],
      [
        255,
        168,
        112,
        255
      ],
      [
        255,
        169,
        115,
        255
      ],
      [
        255,
        171,
        118,
        255
      ],
      [
        255,
        173,
        121,
        255
      ],
      [
        255,
        175,
        124,
        255
      ],
      [
        255,
        177,
        126,
        255
      ],
      [
        255,
        179,
        129,
        255
      ],
      [
        255,
        181,
        132,
        255
      ],
      [
        255,
        183,
        135,
        255
      ],
      [
        255,
        184,
        138,
        255
      ],
      [
        255,
        186,
        141,
        255
      ],
      [
        255,
        188,
        144,
        255
      ],
      [
        255,
        190,
        147,
        255
      ],
      [
        255,
        192,
        150,
        255
      ],
      [
        255,
        194,
        153,
        255
      ],
      [
        255,
        196,
        156,
        255
      ],
      [
        255,
        198,
        159,
        255
      ],
      [
        255,
        200,
        162,
        255
      ],
      [
        255,
        201,
        165,
        255
      ],
      [
        255,
        203,
        168,
        255
      ],
      [
        255,
        205,
        171,
        255
      ],
      [
        255,
        207,
        174,
        255
      ],
      [
        255,
        209,
        176,
        255
      ],
      [
        255,
        211,
        179,
        255
      ],
      [
        255,
        213,
        182,
        255
      ],
      [
        255,
        215,
        185,
        255
      ],
      [
        255,
        216,
        188,
        255
      ],
      [
        255,
        218,
        191,
        255
      ],
      [
        255,
        220,
        194,
        255
      ],
      [
        255,
        222,
        197,
        255
      ],
      [
        255,
        224,
        200,
        255
      ],
      [
        255,
        226,
        203,
        255
      ],
      [
        255,
        228,
        206,
        255
      ],
      [
        255,
        229,
        210,
        255
      ],
      [
        255,
        231,
        213,
        255
      ],
      [
        255,
        233,
        216,
        255
      ],
      [
        255,
        235,
        219,
        255
      ],
      [
        255,
        237,
        223,
        255
      ],
      [
        255,
        239,
        226,
        255
      ],
      [
        255,
        240,
        229,
        255
      ],
      [
        255,
        242,
        232,
        255
      ],
      [
        255,
        244,
        236,
        255
      ],
      [
        255,
        246,
        239,
        255
      ],
      [
        255,
        248,
        242,
        255
      ],
      [
        255,
        250,
        245,
        255
      ],
      [
        255,
        251,
        249,
        255
      ],
      [
        255,
        253,
        252,
        255
      ],
      [
        255,
        255,
        255,
        255
      ]
    ]
  },
  pet20Step: {
    name: "PET 20 Step",
    numColors: 256,
    colors: [
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        0,
        0,
        0,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        96,
        0,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        80,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        48,
        48,
        112,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        80,
        80,
        128,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        96,
        96,
        176,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        112,
        112,
        192,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        128,
        128,
        224,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        96,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        48,
        144,
        48,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        80,
        192,
        80,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        64,
        224,
        64,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        224,
        224,
        80,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        208,
        96,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        176,
        64,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        208,
        144,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        192,
        96,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        176,
        48,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        0,
        0,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ],
      [
        255,
        255,
        255,
        255
      ]
    ]
  },
  gray: {
    name: "Gray",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [[
        0,
        0,
        0
      ], [
        1,
        1,
        1
      ]],
      green: [[
        0,
        0,
        0
      ], [
        1,
        1,
        1
      ]],
      blue: [[
        0,
        0,
        0
      ], [
        1,
        1,
        1
      ]]
    }
  },
  jet: {
    name: "Jet",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [
        [
          0,
          0,
          0
        ],
        [
          0.35,
          0,
          0
        ],
        [
          0.66,
          1,
          1
        ],
        [
          0.89,
          1,
          1
        ],
        [
          1,
          0.5,
          0.5
        ]
      ],
      green: [
        [
          0,
          0,
          0
        ],
        [
          0.125,
          0,
          0
        ],
        [
          0.375,
          1,
          1
        ],
        [
          0.64,
          1,
          1
        ],
        [
          0.91,
          0,
          0
        ],
        [
          1,
          0,
          0
        ]
      ],
      blue: [
        [
          0,
          0.5,
          0.5
        ],
        [
          0.11,
          1,
          1
        ],
        [
          0.34,
          1,
          1
        ],
        [
          0.65,
          0,
          0
        ],
        [
          1,
          0,
          0
        ]
      ]
    }
  },
  hsv: {
    name: "HSV",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [
        [
          0,
          1,
          1
        ],
        [
          0.15873,
          1,
          1
        ],
        [
          0.174603,
          0.96875,
          0.96875
        ],
        [
          0.333333,
          0.03125,
          0.03125
        ],
        [
          0.349206,
          0,
          0
        ],
        [
          0.666667,
          0,
          0
        ],
        [
          0.68254,
          0.03125,
          0.03125
        ],
        [
          0.84127,
          0.96875,
          0.96875
        ],
        [
          0.857143,
          1,
          1
        ],
        [
          1,
          1,
          1
        ]
      ],
      green: [
        [
          0,
          0,
          0
        ],
        [
          0.15873,
          0.9375,
          0.9375
        ],
        [
          0.174603,
          1,
          1
        ],
        [
          0.507937,
          1,
          1
        ],
        [
          0.666667,
          0.0625,
          0.0625
        ],
        [
          0.68254,
          0,
          0
        ],
        [
          1,
          0,
          0
        ]
      ],
      blue: [
        [
          0,
          0,
          0
        ],
        [
          0.333333,
          0,
          0
        ],
        [
          0.349206,
          0.0625,
          0.0625
        ],
        [
          0.507937,
          1,
          1
        ],
        [
          0.84127,
          1,
          1
        ],
        [
          0.857143,
          0.9375,
          0.9375
        ],
        [
          1,
          0.09375,
          0.09375
        ]
      ]
    }
  },
  hot: {
    name: "Hot",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [
        [
          0,
          0.0416,
          0.0416
        ],
        [
          0.365079,
          1,
          1
        ],
        [
          1,
          1,
          1
        ]
      ],
      green: [
        [
          0,
          0,
          0
        ],
        [
          0.365079,
          0,
          0
        ],
        [
          0.746032,
          1,
          1
        ],
        [
          1,
          1,
          1
        ]
      ],
      blue: [
        [
          0,
          0,
          0
        ],
        [
          0.746032,
          0,
          0
        ],
        [
          1,
          1,
          1
        ]
      ]
    }
  },
  cool: {
    name: "Cool",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [[
        0,
        0,
        0
      ], [
        1,
        1,
        1
      ]],
      green: [[
        0,
        1,
        1
      ], [
        1,
        0,
        0
      ]],
      blue: [[
        0,
        1,
        1
      ], [
        1,
        1,
        1
      ]]
    }
  },
  spring: {
    name: "Spring",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [[
        0,
        1,
        1
      ], [
        1,
        1,
        1
      ]],
      green: [[
        0,
        0,
        0
      ], [
        1,
        1,
        1
      ]],
      blue: [[
        0,
        1,
        1
      ], [
        1,
        0,
        0
      ]]
    }
  },
  summer: {
    name: "Summer",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [[
        0,
        0,
        0
      ], [
        1,
        1,
        1
      ]],
      green: [[
        0,
        0.5,
        0.5
      ], [
        1,
        1,
        1
      ]],
      blue: [[
        0,
        0.4,
        0.4
      ], [
        1,
        0.4,
        0.4
      ]]
    }
  },
  autumn: {
    name: "Autumn",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [[
        0,
        1,
        1
      ], [
        1,
        1,
        1
      ]],
      green: [[
        0,
        0,
        0
      ], [
        1,
        1,
        1
      ]],
      blue: [[
        0,
        0,
        0
      ], [
        1,
        0,
        0
      ]]
    }
  },
  winter: {
    name: "Winter",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [[
        0,
        0,
        0
      ], [
        1,
        0,
        0
      ]],
      green: [[
        0,
        0,
        0
      ], [
        1,
        1,
        1
      ]],
      blue: [[
        0,
        1,
        1
      ], [
        1,
        0.5,
        0.5
      ]]
    }
  },
  bone: {
    name: "Bone",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [
        [
          0,
          0,
          0
        ],
        [
          0.746032,
          0.652778,
          0.652778
        ],
        [
          1,
          1,
          1
        ]
      ],
      green: [
        [
          0,
          0,
          0
        ],
        [
          0.365079,
          0.319444,
          0.319444
        ],
        [
          0.746032,
          0.777778,
          0.777778
        ],
        [
          1,
          1,
          1
        ]
      ],
      blue: [
        [
          0,
          0,
          0
        ],
        [
          0.365079,
          0.444444,
          0.444444
        ],
        [
          1,
          1,
          1
        ]
      ]
    }
  },
  copper: {
    name: "Copper",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [
        [
          0,
          0,
          0
        ],
        [
          0.809524,
          1,
          1
        ],
        [
          1,
          1,
          1
        ]
      ],
      green: [[
        0,
        0,
        0
      ], [
        1,
        0.7812,
        0.7812
      ]],
      blue: [[
        0,
        0,
        0
      ], [
        1,
        0.4975,
        0.4975
      ]]
    }
  },
  spectral: {
    name: "Spectral",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [
        [
          0,
          0,
          0
        ],
        [
          0.05,
          0.4667,
          0.4667
        ],
        [
          0.1,
          0.5333,
          0.5333
        ],
        [
          0.15,
          0,
          0
        ],
        [
          0.2,
          0,
          0
        ],
        [
          0.25,
          0,
          0
        ],
        [
          0.3,
          0,
          0
        ],
        [
          0.35,
          0,
          0
        ],
        [
          0.4,
          0,
          0
        ],
        [
          0.45,
          0,
          0
        ],
        [
          0.5,
          0,
          0
        ],
        [
          0.55,
          0,
          0
        ],
        [
          0.6,
          0,
          0
        ],
        [
          0.65,
          0.7333,
          0.7333
        ],
        [
          0.7,
          0.9333,
          0.9333
        ],
        [
          0.75,
          1,
          1
        ],
        [
          0.8,
          1,
          1
        ],
        [
          0.85,
          1,
          1
        ],
        [
          0.9,
          0.8667,
          0.8667
        ],
        [
          0.95,
          0.8,
          0.8
        ],
        [
          1,
          0.8,
          0.8
        ]
      ],
      green: [
        [
          0,
          0,
          0
        ],
        [
          0.05,
          0,
          0
        ],
        [
          0.1,
          0,
          0
        ],
        [
          0.15,
          0,
          0
        ],
        [
          0.2,
          0,
          0
        ],
        [
          0.25,
          0.4667,
          0.4667
        ],
        [
          0.3,
          0.6,
          0.6
        ],
        [
          0.35,
          0.6667,
          0.6667
        ],
        [
          0.4,
          0.6667,
          0.6667
        ],
        [
          0.45,
          0.6,
          0.6
        ],
        [
          0.5,
          0.7333,
          0.7333
        ],
        [
          0.55,
          0.8667,
          0.8667
        ],
        [
          0.6,
          1,
          1
        ],
        [
          0.65,
          1,
          1
        ],
        [
          0.7,
          0.9333,
          0.9333
        ],
        [
          0.75,
          0.8,
          0.8
        ],
        [
          0.8,
          0.6,
          0.6
        ],
        [
          0.85,
          0,
          0
        ],
        [
          0.9,
          0,
          0
        ],
        [
          0.95,
          0,
          0
        ],
        [
          1,
          0.8,
          0.8
        ]
      ],
      blue: [
        [
          0,
          0,
          0
        ],
        [
          0.05,
          0.5333,
          0.5333
        ],
        [
          0.1,
          0.6,
          0.6
        ],
        [
          0.15,
          0.6667,
          0.6667
        ],
        [
          0.2,
          0.8667,
          0.8667
        ],
        [
          0.25,
          0.8667,
          0.8667
        ],
        [
          0.3,
          0.8667,
          0.8667
        ],
        [
          0.35,
          0.6667,
          0.6667
        ],
        [
          0.4,
          0.5333,
          0.5333
        ],
        [
          0.45,
          0,
          0
        ],
        [
          0.5,
          0,
          0
        ],
        [
          0.55,
          0,
          0
        ],
        [
          0.6,
          0,
          0
        ],
        [
          0.65,
          0,
          0
        ],
        [
          0.7,
          0,
          0
        ],
        [
          0.75,
          0,
          0
        ],
        [
          0.8,
          0,
          0
        ],
        [
          0.85,
          0,
          0
        ],
        [
          0.9,
          0,
          0
        ],
        [
          0.95,
          0,
          0
        ],
        [
          1,
          0.8,
          0.8
        ]
      ]
    }
  },
  coolwarm: {
    name: "CoolWarm",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [
        [
          0,
          0.2298057,
          0.2298057
        ],
        [
          0.03125,
          0.26623388,
          0.26623388
        ],
        [
          0.0625,
          0.30386891,
          0.30386891
        ],
        [
          0.09375,
          0.342804478,
          0.342804478
        ],
        [
          0.125,
          0.38301334,
          0.38301334
        ],
        [
          0.15625,
          0.424369608,
          0.424369608
        ],
        [
          0.1875,
          0.46666708,
          0.46666708
        ],
        [
          0.21875,
          0.509635204,
          0.509635204
        ],
        [
          0.25,
          0.552953156,
          0.552953156
        ],
        [
          0.28125,
          0.596262162,
          0.596262162
        ],
        [
          0.3125,
          0.639176211,
          0.639176211
        ],
        [
          0.34375,
          0.681291281,
          0.681291281
        ],
        [
          0.375,
          0.722193294,
          0.722193294
        ],
        [
          0.40625,
          0.761464949,
          0.761464949
        ],
        [
          0.4375,
          0.798691636,
          0.798691636
        ],
        [
          0.46875,
          0.833466556,
          0.833466556
        ],
        [
          0.5,
          0.865395197,
          0.865395197
        ],
        [
          0.53125,
          0.897787179,
          0.897787179
        ],
        [
          0.5625,
          0.924127593,
          0.924127593
        ],
        [
          0.59375,
          0.944468518,
          0.944468518
        ],
        [
          0.625,
          0.958852946,
          0.958852946
        ],
        [
          0.65625,
          0.96732803,
          0.96732803
        ],
        [
          0.6875,
          0.969954137,
          0.969954137
        ],
        [
          0.71875,
          0.966811177,
          0.966811177
        ],
        [
          0.75,
          0.958003065,
          0.958003065
        ],
        [
          0.78125,
          0.943660866,
          0.943660866
        ],
        [
          0.8125,
          0.923944917,
          0.923944917
        ],
        [
          0.84375,
          0.89904617,
          0.89904617
        ],
        [
          0.875,
          0.869186849,
          0.869186849
        ],
        [
          0.90625,
          0.834620542,
          0.834620542
        ],
        [
          0.9375,
          0.795631745,
          0.795631745
        ],
        [
          0.96875,
          0.752534934,
          0.752534934
        ],
        [
          1,
          0.705673158,
          0.705673158
        ]
      ],
      green: [
        [
          0,
          0.298717966,
          0.298717966
        ],
        [
          0.03125,
          0.353094838,
          0.353094838
        ],
        [
          0.0625,
          0.406535296,
          0.406535296
        ],
        [
          0.09375,
          0.458757618,
          0.458757618
        ],
        [
          0.125,
          0.50941904,
          0.50941904
        ],
        [
          0.15625,
          0.558148092,
          0.558148092
        ],
        [
          0.1875,
          0.604562568,
          0.604562568
        ],
        [
          0.21875,
          0.648280772,
          0.648280772
        ],
        [
          0.25,
          0.688929332,
          0.688929332
        ],
        [
          0.28125,
          0.726149107,
          0.726149107
        ],
        [
          0.3125,
          0.759599947,
          0.759599947
        ],
        [
          0.34375,
          0.788964712,
          0.788964712
        ],
        [
          0.375,
          0.813952739,
          0.813952739
        ],
        [
          0.40625,
          0.834302879,
          0.834302879
        ],
        [
          0.4375,
          0.849786142,
          0.849786142
        ],
        [
          0.46875,
          0.860207984,
          0.860207984
        ],
        [
          0.5,
          0.86541021,
          0.86541021
        ],
        [
          0.53125,
          0.848937047,
          0.848937047
        ],
        [
          0.5625,
          0.827384882,
          0.827384882
        ],
        [
          0.59375,
          0.800927443,
          0.800927443
        ],
        [
          0.625,
          0.769767752,
          0.769767752
        ],
        [
          0.65625,
          0.734132809,
          0.734132809
        ],
        [
          0.6875,
          0.694266682,
          0.694266682
        ],
        [
          0.71875,
          0.650421156,
          0.650421156
        ],
        [
          0.75,
          0.602842431,
          0.602842431
        ],
        [
          0.78125,
          0.551750968,
          0.551750968
        ],
        [
          0.8125,
          0.49730856,
          0.49730856
        ],
        [
          0.84375,
          0.439559467,
          0.439559467
        ],
        [
          0.875,
          0.378313092,
          0.378313092
        ],
        [
          0.90625,
          0.312874446,
          0.312874446
        ],
        [
          0.9375,
          0.24128379,
          0.24128379
        ],
        [
          0.96875,
          0.157246067,
          0.157246067
        ],
        [
          1,
          0.01555616,
          0.01555616
        ]
      ],
      blue: [
        [
          0,
          0.753683153,
          0.753683153
        ],
        [
          0.03125,
          0.801466763,
          0.801466763
        ],
        [
          0.0625,
          0.84495867,
          0.84495867
        ],
        [
          0.09375,
          0.883725899,
          0.883725899
        ],
        [
          0.125,
          0.917387822,
          0.917387822
        ],
        [
          0.15625,
          0.945619588,
          0.945619588
        ],
        [
          0.1875,
          0.968154911,
          0.968154911
        ],
        [
          0.21875,
          0.98478814,
          0.98478814
        ],
        [
          0.25,
          0.995375608,
          0.995375608
        ],
        [
          0.28125,
          0.999836203,
          0.999836203
        ],
        [
          0.3125,
          0.998151185,
          0.998151185
        ],
        [
          0.34375,
          0.990363227,
          0.990363227
        ],
        [
          0.375,
          0.976574709,
          0.976574709
        ],
        [
          0.40625,
          0.956945269,
          0.956945269
        ],
        [
          0.4375,
          0.931688648,
          0.931688648
        ],
        [
          0.46875,
          0.901068838,
          0.901068838
        ],
        [
          0.5,
          0.865395561,
          0.865395561
        ],
        [
          0.53125,
          0.820880546,
          0.820880546
        ],
        [
          0.5625,
          0.774508472,
          0.774508472
        ],
        [
          0.59375,
          0.726736146,
          0.726736146
        ],
        [
          0.625,
          0.678007945,
          0.678007945
        ],
        [
          0.65625,
          0.628751763,
          0.628751763
        ],
        [
          0.6875,
          0.579375448,
          0.579375448
        ],
        [
          0.71875,
          0.530263762,
          0.530263762
        ],
        [
          0.75,
          0.481775914,
          0.481775914
        ],
        [
          0.78125,
          0.434243684,
          0.434243684
        ],
        [
          0.8125,
          0.387970225,
          0.387970225
        ],
        [
          0.84375,
          0.343229596,
          0.343229596
        ],
        [
          0.875,
          0.300267182,
          0.300267182
        ],
        [
          0.90625,
          0.259301199,
          0.259301199
        ],
        [
          0.9375,
          0.220525627,
          0.220525627
        ],
        [
          0.96875,
          0.184115123,
          0.184115123
        ],
        [
          1,
          0.150232812,
          0.150232812
        ]
      ]
    }
  },
  blues: {
    name: "Blues",
    numColors: 256,
    gamma: 1,
    segmentedData: {
      red: [
        [
          0,
          0.9686274528503418,
          0.9686274528503418
        ],
        [
          0.125,
          0.8705882430076599,
          0.8705882430076599
        ],
        [
          0.25,
          0.7764706015586853,
          0.7764706015586853
        ],
        [
          0.375,
          0.6196078658103943,
          0.6196078658103943
        ],
        [
          0.5,
          0.41960784792900085,
          0.41960784792900085
        ],
        [
          0.625,
          0.25882354378700256,
          0.25882354378700256
        ],
        [
          0.75,
          0.12941177189350128,
          0.12941177189350128
        ],
        [
          0.875,
          0.0313725508749485,
          0.0313725508749485
        ],
        [
          1,
          0.0313725508749485,
          0.0313725508749485
        ]
      ],
      green: [
        [
          0,
          0.9843137264251709,
          0.9843137264251709
        ],
        [
          0.125,
          0.9215686321258545,
          0.9215686321258545
        ],
        [
          0.25,
          0.8588235378265381,
          0.8588235378265381
        ],
        [
          0.375,
          0.7921568751335144,
          0.7921568751335144
        ],
        [
          0.5,
          0.6823529601097107,
          0.6823529601097107
        ],
        [
          0.625,
          0.572549045085907,
          0.572549045085907
        ],
        [
          0.75,
          0.4431372582912445,
          0.4431372582912445
        ],
        [
          0.875,
          0.3176470696926117,
          0.3176470696926117
        ],
        [
          1,
          0.1882352977991104,
          0.1882352977991104
        ]
      ],
      blue: [
        [
          0,
          1,
          1
        ],
        [
          0.125,
          0.9686274528503418,
          0.9686274528503418
        ],
        [
          0.25,
          0.9372549057006836,
          0.9372549057006836
        ],
        [
          0.375,
          0.8823529481887817,
          0.8823529481887817
        ],
        [
          0.5,
          0.8392156958580017,
          0.8392156958580017
        ],
        [
          0.625,
          0.7764706015586853,
          0.7764706015586853
        ],
        [
          0.75,
          0.7098039388656616,
          0.7098039388656616
        ],
        [
          0.875,
          0.6117647290229797,
          0.6117647290229797
        ],
        [
          1,
          0.41960784792900085,
          0.41960784792900085
        ]
      ]
    }
  }
}, RENDERING_DEFAULTS = {
  MINIMUM_SLAB_THICKNESS: 0.05,
  MAXIMUM_RAY_DISTANCE: 1e6
};
Object.freeze(RENDERING_DEFAULTS);
var rendering_default = RENDERING_DEFAULTS, epsilon_default = 1e-3;
function deepFreeze(e12) {
  let t = Object.getOwnPropertyNames(e12);
  for (let n of t) {
    let t2 = e12[n];
    t2 && typeof t2 == "object" && deepFreeze(t2);
  }
  return Object.freeze(e12);
}
var mprCameraValues_default = deepFreeze({
  axial: {
    viewPlaneNormal: [
      0,
      0,
      -1
    ],
    viewUp: [
      0,
      -1,
      0
    ],
    viewRight: [
      1,
      0,
      0
    ]
  },
  sagittal: {
    viewPlaneNormal: [
      1,
      0,
      0
    ],
    viewUp: [
      0,
      0,
      1
    ],
    viewRight: [
      0,
      1,
      0
    ]
  },
  coronal: {
    viewPlaneNormal: [
      0,
      -1,
      0
    ],
    viewUp: [
      0,
      0,
      1
    ],
    viewRight: [
      1,
      0,
      0
    ]
  }
}), viewportPresets_default = [
  {
    name: "CT-AAA",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "12 -3024 0 143.556 0 166.222 0.686275 214.389 0.696078 419.736 0.833333 3071 0.803922",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "24 -3024 0 0 0 143.556 0.615686 0.356863 0.184314 166.222 0.882353 0.603922 0.290196 214.389 1 1 1 419.736 1 0.937033 0.954531 3071 0.827451 0.658824 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-AAA2",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "16 -3024 0 129.542 0 145.244 0.166667 157.02 0.5 169.918 0.627451 395.575 0.8125 1578.73 0.8125 3071 0.8125",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "32 -3024 0 0 0 129.542 0.54902 0.25098 0.14902 145.244 0.6 0.627451 0.843137 157.02 0.890196 0.47451 0.6 169.918 0.992157 0.870588 0.392157 395.575 1 0.886275 0.658824 1578.73 1 0.829256 0.957922 3071 0.827451 0.658824 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-Bone",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "8 -3024 0 -16.4458 0 641.385 0.715686 3071 0.705882",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "16 -3024 0 0 0 -16.4458 0.729412 0.254902 0.301961 641.385 0.905882 0.815686 0.552941 3071 1 1 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-Bones",
    gradientOpacity: "4 0 1 985.12 1",
    specularPower: "1",
    scalarOpacity: "8 -1000 0 152.19 0 278.93 0.190476 952 0.2",
    specular: "0",
    shade: "1",
    ambient: "0.2",
    colorTransfer: "20 -1000 0.3 0.3 1 -488 0.3 1 0.3 463.28 1 0 0 659.15 1 0.912535 0.0374849 953 1 0.3 0.3",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-Cardiac",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "12 -3024 0 -77.6875 0 94.9518 0.285714 179.052 0.553571 260.439 0.848214 3071 0.875",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "24 -3024 0 0 0 -77.6875 0.54902 0.25098 0.14902 94.9518 0.882353 0.603922 0.290196 179.052 1 0.937033 0.954531 260.439 0.615686 0 0 3071 0.827451 0.658824 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-Cardiac2",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "12 -3024 0 42.8964 0 163.488 0.428571 277.642 0.776786 1587 0.754902 3071 0.754902",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "24 -3024 0 0 0 42.8964 0.54902 0.25098 0.14902 163.488 0.917647 0.639216 0.0588235 277.642 1 0.878431 0.623529 1587 1 1 1 3071 0.827451 0.658824 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-Cardiac3",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "14 -3024 0 -86.9767 0 45.3791 0.169643 139.919 0.589286 347.907 0.607143 1224.16 0.607143 3071 0.616071",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "28 -3024 0 0 0 -86.9767 0 0.25098 1 45.3791 1 0 0 139.919 1 0.894893 0.894893 347.907 1 1 0.25098 1224.16 1 1 1 3071 0.827451 0.658824 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-Chest-Contrast-Enhanced",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "10 -3024 0 67.0106 0 251.105 0.446429 439.291 0.625 3071 0.616071",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "20 -3024 0 0 0 67.0106 0.54902 0.25098 0.14902 251.105 0.882353 0.603922 0.290196 439.291 1 0.937033 0.954531 3071 0.827451 0.658824 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-Chest-Vessels",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "10 -3024 0 -1278.35 0 22.8277 0.428571 439.291 0.625 3071 0.616071",
    specular: "0",
    shade: "1",
    ambient: "0.2",
    colorTransfer: "20 -3024 0 0 0 -1278.35 0.54902 0.25098 0.14902 22.8277 0.882353 0.603922 0.290196 439.291 1 0.937033 0.954531 3071 0.827451 0.658824 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-Coronary-Arteries",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "12 -2048 0 136.47 0 159.215 0.258929 318.43 0.571429 478.693 0.776786 3661 1",
    specular: "0",
    shade: "0",
    ambient: "0.2",
    colorTransfer: "24 -2048 0 0 0 136.47 0 0 0 159.215 0.159804 0.159804 0.159804 318.43 0.764706 0.764706 0.764706 478.693 1 1 1 3661 1 1 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-Coronary-Arteries-2",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "14 -2048 0 142.677 0 145.016 0.116071 192.174 0.5625 217.24 0.776786 384.347 0.830357 3661 0.830357",
    specular: "0",
    shade: "1",
    ambient: "0.2",
    colorTransfer: "28 -2048 0 0 0 142.677 0 0 0 145.016 0.615686 0 0.0156863 192.174 0.909804 0.454902 0 217.24 0.972549 0.807843 0.611765 384.347 0.909804 0.909804 1 3661 1 1 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-Coronary-Arteries-3",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "14 -2048 0 128.643 0 129.982 0.0982143 173.636 0.669643 255.884 0.857143 584.878 0.866071 3661 1",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "28 -2048 0 0 0 128.643 0 0 0 129.982 0.615686 0 0.0156863 173.636 0.909804 0.454902 0 255.884 0.886275 0.886275 0.886275 584.878 0.968627 0.968627 0.968627 3661 1 1 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-Cropped-Volume-Bone",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "10 -2048 0 -451 0 -450 1 1050 1 3661 1",
    specular: "0",
    shade: "0",
    ambient: "0.2",
    colorTransfer: "20 -2048 0 0 0 -451 0 0 0 -450 0.0556356 0.0556356 0.0556356 1050 1 1 1 3661 1 1 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-Fat",
    gradientOpacity: "6 0 1 985.12 1 988 1",
    specularPower: "1",
    scalarOpacity: "14 -1000 0 -100 0 -99 0.15 -60 0.15 -59 0 101.2 0 952 0",
    specular: "0",
    shade: "0",
    ambient: "0.2",
    colorTransfer: "36 -1000 0.3 0.3 1 -497.5 0.3 1 0.3 -99 0 0 1 -76.946 0 1 0 -65.481 0.835431 0.888889 0.0165387 83.89 1 0 0 463.28 1 0 0 659.15 1 0.912535 0.0374849 2952 1 0.300267 0.299886",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-Liver-Vasculature",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "14 -2048 0 149.113 0 157.884 0.482143 339.96 0.660714 388.526 0.830357 1197.95 0.839286 3661 0.848214",
    specular: "0",
    shade: "0",
    ambient: "0.2",
    colorTransfer: "28 -2048 0 0 0 149.113 0 0 0 157.884 0.501961 0.25098 0 339.96 0.695386 0.59603 0.36886 388.526 0.854902 0.85098 0.827451 1197.95 1 1 1 3661 1 1 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-Lung",
    gradientOpacity: "6 0 1 985.12 1 988 1",
    specularPower: "1",
    scalarOpacity: "12 -1000 0 -600 0 -599 0.15 -400 0.15 -399 0 2952 0",
    specular: "0",
    shade: "1",
    ambient: "0.2",
    colorTransfer: "24 -1000 0.3 0.3 1 -600 0 0 1 -530 0.134704 0.781726 0.0724558 -460 0.929244 1 0.109473 -400 0.888889 0.254949 0.0240258 2952 1 0.3 0.3",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-MIP",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "8 -3024 0 -637.62 0 700 1 3071 1",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "16 -3024 0 0 0 -637.62 1 1 1 700 1 1 1 3071 1 1 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-Muscle",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "10 -3024 0 -155.407 0 217.641 0.676471 419.736 0.833333 3071 0.803922",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "20 -3024 0 0 0 -155.407 0.54902 0.25098 0.14902 217.641 0.882353 0.603922 0.290196 419.736 1 0.937033 0.954531 3071 0.827451 0.658824 1",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "CT-Pulmonary-Arteries",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "14 -2048 0 -568.625 0 -364.081 0.0714286 -244.813 0.401786 18.2775 0.607143 447.798 0.830357 3592.73 0.839286",
    specular: "0",
    shade: "1",
    ambient: "0.2",
    colorTransfer: "28 -2048 0 0 0 -568.625 0 0 0 -364.081 0.396078 0.301961 0.180392 -244.813 0.611765 0.352941 0.0705882 18.2775 0.843137 0.0156863 0.156863 447.798 0.752941 0.752941 0.752941 3592.73 1 1 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-Soft-Tissue",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "10 -2048 0 -167.01 0 -160 1 240 1 3661 1",
    specular: "0",
    shade: "0",
    ambient: "0.2",
    colorTransfer: "20 -2048 0 0 0 -167.01 0 0 0 -160 0.0556356 0.0556356 0.0556356 240 1 1 1 3661 1 1 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "CT-Air",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "10",
    scalarOpacity: "8 -3024 0.705882 -900.0 0.715686 -500.0 0 3071 0",
    specular: "0.2",
    shade: "1",
    ambient: "0.1",
    colorTransfer: "16 -3024 1 1 1 -900.0 0.2 1.0 1.0 -500.0 0.3 0.3 1.0 3071 0 0 0 ",
    diffuse: "0.9",
    interpolation: "1"
  },
  {
    name: "MR-Angio",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "12 -2048 0 151.354 0 158.279 0.4375 190.112 0.580357 200.873 0.732143 3661 0.741071",
    specular: "0",
    shade: "1",
    ambient: "0.2",
    colorTransfer: "24 -2048 0 0 0 151.354 0 0 0 158.279 0.74902 0.376471 0 190.112 1 0.866667 0.733333 200.873 0.937255 0.937255 0.937255 3661 1 1 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "MR-Default",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "12 0 0 20 0 40 0.15 120 0.3 220 0.375 1024 0.5",
    specular: "0",
    shade: "1",
    ambient: "0.2",
    colorTransfer: "24 0 0 0 0 20 0.168627 0 0 40 0.403922 0.145098 0.0784314 120 0.780392 0.607843 0.380392 220 0.847059 0.835294 0.788235 1024 1 1 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "MR-MIP",
    gradientOpacity: "4 0 1 255 1",
    specularPower: "1",
    scalarOpacity: "8 0 0 98.3725 0 416.637 1 2800 1",
    specular: "0",
    shade: "0",
    ambient: "0.2",
    colorTransfer: "16 0 1 1 1 98.3725 1 1 1 416.637 1 1 1 2800 1 1 1",
    diffuse: "1",
    interpolation: "1"
  },
  {
    name: "MR-T2-Brain",
    gradientOpacity: "4 0 1 160.25 1",
    specularPower: "40",
    scalarOpacity: "10 0 0 36.05 0 218.302 0.171429 412.406 1 641 1",
    specular: "0.5",
    shade: "1",
    ambient: "0.3",
    colorTransfer: "16 0 0 0 0 98.7223 0.956863 0.839216 0.192157 412.406 0 0.592157 0.807843 641 1 1 1",
    diffuse: "0.6",
    interpolation: "1"
  },
  {
    name: "DTI-FA-Brain",
    gradientOpacity: "4 0 1 0.9950 1",
    specularPower: "40",
    scalarOpacity: "16 0 0 0 0 0.3501 0.0158 0.49379 0.7619 0.6419 1 0.9920 1 0.9950 0 0.9950 0",
    specular: "0.5",
    shade: "1",
    ambient: "0.3",
    colorTransfer: "28 0 1 0 0 0 1 0 0 0.24974 0.4941 1 0 0.49949 0 0.9882 1 0.7492 0.51764 0 1 0.9950 1 0 0 0.9950 1 0 0",
    diffuse: "0.9",
    interpolation: "1"
  }
], backgroundColors_default = { slicer3D: [
  160 / 255,
  164 / 255,
  217 / 255
] }, constants_exports = /* @__PURE__ */ __export({
  BACKGROUND_COLORS: () => backgroundColors_default,
  CPU_COLORMAPS: () => cpuColormaps_default,
  EPSILON: () => epsilon_default,
  MPR_CAMERA_VALUES: () => mprCameraValues_default,
  RENDERING_DEFAULTS: () => rendering_default,
  VIEWPORT_PRESETS: () => viewportPresets_default
}), cache$1 = {}, renderingEngineCache_default = {
  get: (e12) => cache$1[e12],
  set: (e12) => {
    let t = e12.id;
    cache$1[t] = e12;
  },
  delete: (e12) => delete cache$1[e12],
  getAll: () => {
    let e12 = Object.keys(cache$1).map((e13) => cache$1[e13]);
    return e12.sort((e13, t) => e13.id[0] === "_" && t.id[0] !== "_" ? 1 : e13.id[0] !== "_" && t.id[0] === "_" ? -1 : 0), e12;
  }
};
function getRenderingEngine(e12) {
  return renderingEngineCache_default.get(e12);
}
function getRenderingEngines() {
  return renderingEngineCache_default.getAll();
}
var getRenderingEngine_default = getRenderingEngine, isMergeableObject = (e12) => e12 && typeof e12 == "object" && Object.prototype.toString.call(e12) !== "[object RegExp]" && Object.prototype.toString.call(e12) !== "[object Date]", emptyTarget = (e12) => Array.isArray(e12) ? [] : {}, cloneIfNecessary = (e12, t) => t && t.clone === true && isMergeableObject(e12) ? deepMerge(emptyTarget(e12), e12, t) : e12, defaultArrayMerge = (e12, t, n) => {
  let r = e12.slice();
  return t.forEach(function(t2, a) {
    r[a] === void 0 ? r[a] = cloneIfNecessary(t2, n) : isMergeableObject(t2) ? r[a] = deepMerge(e12[a], t2, n) : e12.indexOf(t2) === -1 && (r[a] = cloneIfNecessary(t2, n));
  }), r;
}, mergeObject = (e12, t, n) => {
  let r = {};
  return isMergeableObject(e12) && Object.keys(e12).forEach(function(t2) {
    r[t2] = cloneIfNecessary(e12[t2], n);
  }), Object.keys(t).forEach(function(a) {
    !isMergeableObject(t[a]) || !e12[a] ? r[a] = cloneIfNecessary(t[a], n) : r[a] = deepMerge(e12[a], t[a], n);
  }), r;
}, deepMerge = (e12 = {}, t = {}, n = void 0) => {
  let r = Array.isArray(t), a = (n || { arrayMerge: defaultArrayMerge }).arrayMerge || defaultArrayMerge;
  return r ? Array.isArray(e12) ? a(e12, t, n) : cloneIfNecessary(t, n) : mergeObject(e12, t, n);
}, deepMerge_default = deepMerge, proxyMarker = Symbol("Comlink.proxy"), createEndpoint = Symbol("Comlink.endpoint"), releaseProxy = Symbol("Comlink.releaseProxy"), finalizer = Symbol("Comlink.finalizer"), throwMarker = Symbol("Comlink.thrown"), isObject = (e12) => typeof e12 == "object" && !!e12 || typeof e12 == "function", transferHandlers = /* @__PURE__ */ new Map([["proxy", {
  canHandle: (e12) => isObject(e12) && e12[proxyMarker],
  serialize(e12) {
    let { port1: t, port2: n } = new MessageChannel();
    return expose(e12, t), [n, [n]];
  },
  deserialize(e12) {
    return e12.start(), wrap(e12);
  }
}], ["throw", {
  canHandle: (e12) => isObject(e12) && throwMarker in e12,
  serialize({ value: e12 }) {
    let t;
    return t = e12 instanceof Error ? {
      isError: true,
      value: {
        message: e12.message,
        name: e12.name,
        stack: e12.stack
      }
    } : {
      isError: false,
      value: e12
    }, [t, []];
  },
  deserialize(e12) {
    throw e12.isError ? Object.assign(Error(e12.value.message), e12.value) : e12.value;
  }
}]]);
function isAllowedOrigin(e12, t) {
  for (let n of e12)
    if (t === n || n === "*" || n instanceof RegExp && n.test(t))
      return true;
  return false;
}
function expose(e12, t = globalThis, n = ["*"]) {
  t.addEventListener("message", function r(a) {
    if (!a || !a.data)
      return;
    if (!isAllowedOrigin(n, a.origin)) {
      console.warn(`Invalid origin '${a.origin}' for comlink proxy`);
      return;
    }
    let { id: o, type: s, path: c } = Object.assign({ path: [] }, a.data), l = (a.data.argumentList || []).map(fromWireValue), u;
    try {
      let t2 = c.slice(0, -1).reduce((e13, t3) => e13[t3], e12), n2 = c.reduce((e13, t3) => e13[t3], e12);
      switch (s) {
        case "GET":
          u = n2;
          break;
        case "SET":
          t2[c.slice(-1)[0]] = fromWireValue(a.data.value), u = true;
          break;
        case "APPLY":
          u = n2.apply(t2, l);
          break;
        case "CONSTRUCT":
          u = proxy$1(new n2(...l));
          break;
        case "ENDPOINT":
          {
            let { port1: t3, port2: n3 } = new MessageChannel();
            expose(e12, n3), u = transfer(t3, [t3]);
          }
          break;
        case "RELEASE":
          u = void 0;
          break;
        default:
          return;
      }
    } catch (e13) {
      u = {
        value: e13,
        [throwMarker]: 0
      };
    }
    Promise.resolve(u).catch((e13) => ({
      value: e13,
      [throwMarker]: 0
    })).then((n2) => {
      let [a2, c2] = toWireValue(n2);
      t.postMessage(Object.assign(Object.assign({}, a2), { id: o }), c2), s === "RELEASE" && (t.removeEventListener("message", r), closeEndPoint(t), finalizer in e12 && typeof e12[finalizer] == "function" && e12[finalizer]());
    }).catch((e13) => {
      let [n2, r2] = toWireValue({
        value: /* @__PURE__ */ TypeError("Unserializable return value"),
        [throwMarker]: 0
      });
      t.postMessage(Object.assign(Object.assign({}, n2), { id: o }), r2);
    });
  }), t.start && t.start();
}
function isMessagePort(e12) {
  return e12.constructor.name === "MessagePort";
}
function closeEndPoint(e12) {
  isMessagePort(e12) && e12.close();
}
function wrap(e12, t) {
  let n = /* @__PURE__ */ new Map();
  return e12.addEventListener("message", function(e13) {
    let { data: t2 } = e13;
    if (!t2 || !t2.id)
      return;
    let r = n.get(t2.id);
    if (r)
      try {
        r(t2);
      } finally {
        n.delete(t2.id);
      }
  }), createProxy(e12, n, [], t);
}
function throwIfProxyReleased(e12) {
  if (e12)
    throw Error("Proxy has been released and is not useable");
}
function releaseEndpoint(e12) {
  return requestResponseMessage(e12, /* @__PURE__ */ new Map(), { type: "RELEASE" }).then(() => {
    closeEndPoint(e12);
  });
}
var proxyCounter = /* @__PURE__ */ new WeakMap(), proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry((e12) => {
  let t = (proxyCounter.get(e12) || 0) - 1;
  proxyCounter.set(e12, t), t === 0 && releaseEndpoint(e12);
});
function registerProxy(e12, t) {
  let n = (proxyCounter.get(t) || 0) + 1;
  proxyCounter.set(t, n), proxyFinalizers && proxyFinalizers.register(e12, t, e12);
}
function unregisterProxy(e12) {
  proxyFinalizers && proxyFinalizers.unregister(e12);
}
function createProxy(e12, t, n = [], r = function() {
}) {
  let a = false, o = new Proxy(r, {
    get(r2, s) {
      if (throwIfProxyReleased(a), s === releaseProxy)
        return () => {
          unregisterProxy(o), releaseEndpoint(e12), t.clear(), a = true;
        };
      if (s === "then") {
        if (n.length === 0)
          return { then: () => o };
        let r3 = requestResponseMessage(e12, t, {
          type: "GET",
          path: n.map((e13) => e13.toString())
        }).then(fromWireValue);
        return r3.then.bind(r3);
      }
      return createProxy(e12, t, [...n, s]);
    },
    set(r2, o2, s) {
      throwIfProxyReleased(a);
      let [c, l] = toWireValue(s);
      return requestResponseMessage(e12, t, {
        type: "SET",
        path: [...n, o2].map((e13) => e13.toString()),
        value: c
      }, l).then(fromWireValue);
    },
    apply(r2, o2, s) {
      throwIfProxyReleased(a);
      let c = n[n.length - 1];
      if (c === createEndpoint)
        return requestResponseMessage(e12, t, { type: "ENDPOINT" }).then(fromWireValue);
      if (c === "bind")
        return createProxy(e12, t, n.slice(0, -1));
      let [l, u] = processArguments(s);
      return requestResponseMessage(e12, t, {
        type: "APPLY",
        path: n.map((e13) => e13.toString()),
        argumentList: l
      }, u).then(fromWireValue);
    },
    construct(r2, o2) {
      throwIfProxyReleased(a);
      let [s, c] = processArguments(o2);
      return requestResponseMessage(e12, t, {
        type: "CONSTRUCT",
        path: n.map((e13) => e13.toString()),
        argumentList: s
      }, c).then(fromWireValue);
    }
  });
  return registerProxy(o, e12), o;
}
function myFlat(e12) {
  return Array.prototype.concat.apply([], e12);
}
function processArguments(e12) {
  let t = e12.map(toWireValue);
  return [t.map((e13) => e13[0]), myFlat(t.map((e13) => e13[1]))];
}
var transferCache = /* @__PURE__ */ new WeakMap();
function transfer(e12, t) {
  return transferCache.set(e12, t), e12;
}
function proxy$1(e12) {
  return Object.assign(e12, { [proxyMarker]: true });
}
function toWireValue(e12) {
  for (let [t, n] of transferHandlers)
    if (n.canHandle(e12)) {
      let [r, a] = n.serialize(e12);
      return [{
        type: "HANDLER",
        name: t,
        value: r
      }, a];
    }
  return [{
    type: "RAW",
    value: e12
  }, transferCache.get(e12) || []];
}
function fromWireValue(e12) {
  switch (e12.type) {
    case "HANDLER":
      return transferHandlers.get(e12.name).deserialize(e12.value);
    case "RAW":
      return e12.value;
  }
}
function requestResponseMessage(e12, t, n, r) {
  return new Promise((a) => {
    let o = generateUUID();
    t.set(o, a), e12.start && e12.start(), e12.postMessage(Object.assign({ id: o }, n), r);
  });
}
function generateUUID() {
  return [
    ,
    ,
    ,
    ,
  ].fill(0).map(() => Math.floor(Math.random() * (2 ** 53 - 1)).toString(16)).join("-");
}
function uuidv4() {
  return typeof crypto.randomUUID == "function" ? crypto.randomUUID() : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (e12) => (e12 ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e12 / 4).toString(16));
}
var RequestPoolManager = class {
  constructor(e12) {
    this.numRequests = {
      [RequestType_default.Interaction]: 0,
      [RequestType_default.Thumbnail]: 0,
      [RequestType_default.Prefetch]: 0,
      [RequestType_default.Compute]: 0
    }, this.id = e12 || uuidv4(), this.requestPool = {
      [RequestType_default.Interaction]: { 0: [] },
      [RequestType_default.Thumbnail]: { 0: [] },
      [RequestType_default.Prefetch]: { 0: [] },
      [RequestType_default.Compute]: { 0: [] }
    }, this.grabDelay = 5, this.awake = false, this.numRequests = {
      [RequestType_default.Interaction]: 0,
      [RequestType_default.Thumbnail]: 0,
      [RequestType_default.Prefetch]: 0,
      [RequestType_default.Compute]: 0
    }, this.maxNumRequests = {
      [RequestType_default.Interaction]: 6,
      [RequestType_default.Thumbnail]: 6,
      [RequestType_default.Prefetch]: 5,
      [RequestType_default.Compute]: 1e3
    };
  }
  setMaxSimultaneousRequests(e12, t) {
    this.maxNumRequests[e12] = t;
  }
  getMaxSimultaneousRequests(e12) {
    return this.maxNumRequests[e12];
  }
  destroy() {
    this.timeoutHandle && window.clearTimeout(this.timeoutHandle);
  }
  addRequest(e12, t, n, r = 0) {
    let a = {
      requestFn: e12,
      type: t,
      additionalDetails: n
    };
    this.requestPool[t][r] === void 0 && (this.requestPool[t][r] = []), this.requestPool[t][r].push(a), this.startGrabbing();
  }
  filterRequests(e12) {
    Object.keys(this.requestPool).forEach((t) => {
      let n = this.requestPool[t];
      Object.keys(n).forEach((t2) => {
        n[t2] = n[t2].filter((t3) => e12(t3));
      });
    });
  }
  clearRequestStack(e12) {
    if (!this.requestPool[e12])
      throw Error(`No category for the type ${e12} found`);
    this.requestPool[e12] = { 0: [] };
  }
  sendRequests(e12) {
    let t = this.maxNumRequests[e12] - this.numRequests[e12], n = 0;
    for (let r = 0; r < t; r++) {
      let t2 = this.getNextRequest(e12);
      if (t2 === null)
        return false;
      if (t2) {
        this.numRequests[e12]++, this.awake = true;
        let r2;
        try {
          r2 = t2.requestFn();
        } catch (e13) {
          console.warn("sendRequest failed", e13);
        }
        r2?.finally ? r2.finally(() => {
          this.numRequests[e12]--, this.startAgain();
        }) : (this.numRequests[e12]--, n++);
      }
    }
    return n && this.startAgain(), true;
  }
  getNextRequest(e12) {
    let t = this.getSortedPriorityGroups(e12);
    for (let n of t)
      if (this.requestPool[e12][n].length)
        return this.requestPool[e12][n].shift();
    return null;
  }
  startGrabbing() {
    let e12 = this.sendRequests(RequestType_default.Interaction), t = this.sendRequests(RequestType_default.Thumbnail), n = this.sendRequests(RequestType_default.Prefetch), r = this.sendRequests(RequestType_default.Compute);
    !e12 && !t && !n && !r && (this.awake = false);
  }
  startAgain() {
    this.awake && (this.grabDelay === void 0 ? this.startGrabbing() : this.timeoutHandle ||= window.setTimeout(() => {
      this.timeoutHandle = null, this.startGrabbing();
    }, this.grabDelay));
  }
  getSortedPriorityGroups(e12) {
    return Object.keys(this.requestPool[e12]).map(Number).filter((t) => this.requestPool[e12][t].length).sort((e13, t) => e13 - t);
  }
  getRequestPool() {
    return this.requestPool;
  }
}, webWorkerManager_default = class {
  constructor() {
    this.workerRegistry = {}, this.workerPoolManager = new RequestPoolManager("webworker");
  }
  registerWorker(e12, t, n = {}) {
    let { maxWorkerInstances: r = 1, overwrite: a = false, autoTerminateOnIdle: o = {
      enabled: false,
      idleTimeThreshold: 3e3
    } } = n;
    if (this.workerRegistry[e12] && !a) {
      console.warn(`Worker type '${e12}' is already registered...`);
      return;
    }
    a && this.workerRegistry[e12]?.idleCheckIntervalId && clearInterval(this.workerRegistry[e12].idleCheckIntervalId);
    let s = {
      workerFn: null,
      instances: [],
      loadCounters: [],
      lastActiveTime: [],
      nativeWorkers: [],
      autoTerminateOnIdle: o.enabled,
      idleCheckIntervalId: null,
      idleTimeThreshold: o.idleTimeThreshold
    };
    s.loadCounters = Array(r).fill(0), s.lastActiveTime = Array(r).fill(null);
    for (let e13 = 0; e13 < r; e13++) {
      let e14 = t();
      s.instances.push(wrap(e14)), s.nativeWorkers.push(e14), s.workerFn = t;
    }
    this.workerRegistry[e12] = s;
  }
  getNextWorkerAPI(e12) {
    let t = this.workerRegistry[e12];
    if (!t)
      return console.error(`Worker type '${e12}' is not registered.`), null;
    let n = t.instances.filter((e13) => e13 !== null), r = 0, a = t.loadCounters[0] || 0;
    for (let e13 = 1; e13 < n.length; e13++) {
      let n2 = t.loadCounters[e13] || 0;
      n2 < a && (r = e13, a = n2);
    }
    if (t.instances[r] === null) {
      let e13 = t.workerFn();
      t.instances[r] = wrap(e13), t.nativeWorkers[r] = e13;
    }
    return t.loadCounters[r] += 1, {
      api: t.instances[r],
      index: r
    };
  }
  executeTask(e12, t, n = {}, { requestType: r = RequestType_default.Compute, priority: a = 0, options: o = {}, callbacks: c = [] } = {}) {
    return new Promise((s, l) => {
      this.workerPoolManager.addRequest(async () => {
        let { api: r2, index: a2 } = this.getNextWorkerAPI(e12);
        if (!r2) {
          let t2 = /* @__PURE__ */ Error(`No available worker instance for '${e12}'`);
          console.error(t2), l(t2);
          return;
        }
        try {
          let o2 = [];
          c.length && (o2 = c.map((e13) => proxy$1(e13)));
          let l2 = this.workerRegistry[e12];
          l2.processing = true;
          let u = await r2[t](n, ...o2);
          l2.processing = false, l2.lastActiveTime[a2] = Date.now(), l2.autoTerminateOnIdle && !l2.idleCheckIntervalId && l2.idleTimeThreshold && (l2.idleCheckIntervalId = setInterval(() => {
            this.terminateIdleWorkers(e12, l2.idleTimeThreshold);
          }, l2.idleTimeThreshold)), s(u);
        } catch (n2) {
          console.error(`Error executing method '${t}' on worker '${e12}':`, n2), l(n2);
        } finally {
          this.workerRegistry[e12].loadCounters[a2]--;
        }
      }, r, o, a);
    });
  }
  terminateIdleWorkers(e12, t) {
    let n = this.workerRegistry[e12];
    if (n.processing)
      return;
    let r = Date.now();
    n.instances.forEach((a, o) => {
      let s = n.lastActiveTime[o], c = s !== null && n.loadCounters[o] > 0, l = r - s;
      !c && l > t && this.terminateWorkerInstance(e12, o);
    });
  }
  terminate(e12) {
    let t = this.workerRegistry[e12];
    if (!t) {
      console.error(`Worker type '${e12}' is not registered.`);
      return;
    }
    t.instances.forEach((t2, n) => {
      this.terminateWorkerInstance(e12, n);
    });
  }
  terminateWorkerInstance(e12, t) {
    let n = this.workerRegistry[e12], r = n.instances[t];
    r !== null && (r[releaseProxy](), n.nativeWorkers[t].terminate(), n.instances[t] = null, n.lastActiveTime[t] = null);
  }
}, canvasSize = 4, texWidth = 5, texHeight = 1, pixelToCheck = [1, 1];
function main({ ext: e12, filterType: t, texData: n, internalFormat: r, glDataType: a }) {
  try {
    let o = document.createElement("canvas");
    o.width = canvasSize, o.height = canvasSize;
    let s = o.getContext("webgl2");
    if (!s)
      return false;
    let c = `#version 300 es
    void main() {
      gl_PointSize = ${canvasSize.toFixed(1)};
      gl_Position = vec4(0, 0, 0, 1);
    }
  `, l;
    if (e12 && (l = s.getExtension(e12), !l))
      return false;
    let u = s.createShader(s.VERTEX_SHADER);
    if (s.shaderSource(u, c), s.compileShader(u), !s.getShaderParameter(u, s.COMPILE_STATUS))
      return false;
    let d = s.createShader(s.FRAGMENT_SHADER);
    if (s.shaderSource(d, "#version 300 es\n    precision highp float;\n    precision highp int;\n    precision highp sampler2D;\n\n    uniform sampler2D u_image;\n\n    out vec4 color;\n\n    void main() {\n        vec4 intColor = texture(u_image, gl_PointCoord.xy);\n        color = vec4(vec3(intColor.rrr), 1);\n    }\n    "), s.compileShader(d), !s.getShaderParameter(d, s.COMPILE_STATUS))
      return false;
    let f = s.createProgram();
    if (s.attachShader(f, u), s.attachShader(f, d), s.linkProgram(f), !s.getProgramParameter(f, s.LINK_STATUS))
      return false;
    let p = s.createTexture();
    s.bindTexture(s.TEXTURE_2D, p), s.texImage2D(s.TEXTURE_2D, 0, r(s, l), texWidth, texHeight, 0, s.RED, a(s, l), n);
    let m = t === "LINEAR" ? s.LINEAR : s.NEAREST;
    s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, m), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, m), s.useProgram(f), s.drawArrays(s.POINTS, 0, 1);
    let h = new Uint8Array(4);
    s.readPixels(pixelToCheck[0], pixelToCheck[1], 1, 1, s.RGBA, s.UNSIGNED_BYTE, h);
    let [g, _, v] = h, y = s.getExtension("WEBGL_lose_context");
    return y && y.loseContext(), g === _ && _ === v && g !== 0;
  } catch {
    return false;
  }
}
function getSupportedTextureFormats() {
  let e12 = new Int16Array([
    32767,
    2e3,
    3e3,
    4e3,
    5e3,
    16784,
    7e3,
    8e3,
    9e3,
    32767
  ]);
  return {
    norm16: main({
      ext: "EXT_texture_norm16",
      filterType: "NEAREST",
      texData: e12,
      internalFormat: (e13, t) => t.R16_SNORM_EXT,
      glDataType: (e13) => e13.SHORT
    }),
    norm16Linear: main({
      ext: "EXT_texture_norm16",
      filterType: "LINEAR",
      texData: e12,
      internalFormat: (e13, t) => t.R16_SNORM_EXT,
      glDataType: (e13) => e13.SHORT
    })
  };
}
var csRenderInitialized = false, defaultConfig = {
  gpuTier: { tier: 2 },
  isMobile: false,
  rendering: {
    useCPURendering: false,
    preferSizeOverAccuracy: false,
    useLegacyCameraFOV: false,
    strictZSpacingForVolumeViewport: true,
    renderingEngineMode: RenderingEngineModeEnum_default.ContextPool,
    webGlContextCount: 7,
    volumeRendering: { sampleDistanceMultiplier: 1 }
  },
  debug: { statsOverlay: false },
  peerImport: (e12) => null
}, config = {
  ...defaultConfig,
  rendering: { ...defaultConfig.rendering }
}, webWorkerManager = null, canUseNorm16Texture = false;
function _getGLContext() {
  let e12 = document.createElement("canvas");
  return e12.getContext("webgl2") || e12.getContext("webgl") || e12.getContext("experimental-webgl");
}
function _hasActiveWebGLContext() {
  let e12 = _getGLContext();
  return e12 instanceof WebGLRenderingContext || e12 instanceof WebGL2RenderingContext;
}
function _hasNorm16TextureSupport() {
  let e12 = getSupportedTextureFormats();
  return e12.norm16 && e12.norm16Linear;
}
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.platform) ? true : navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && navigator.platform.includes("MacIntel");
}
function init(e12 = config) {
  return csRenderInitialized || (canUseNorm16Texture = _hasNorm16TextureSupport(), config = deepMerge_default(defaultConfig, e12), config.isMobile && (config.rendering.webGlContextCount = 1), isIOS() && (e12.rendering?.preferSizeOverAccuracy ? config.rendering.preferSizeOverAccuracy = true : console.log("norm16 texture not supported, you can turn on the preferSizeOverAccuracy flag to use native data type, but be aware of the inaccuracy of the rendering in high bits")), _hasActiveWebGLContext() ? console.log("CornerstoneRender: using GPU rendering") : (console.log("CornerstoneRender: GPU not detected, using CPU rendering"), config.rendering.useCPURendering = true), csRenderInitialized = true, webWorkerManager ||= new webWorkerManager_default(), csRenderInitialized);
}
function getCanUseNorm16Texture() {
  return canUseNorm16Texture;
}
function setPreferSizeOverAccuracy(e12) {
  config.rendering.preferSizeOverAccuracy = e12, csRenderInitialized = true, _updateRenderingPipelinesForAllViewports();
}
function canRenderFloatTextures() {
  return !isIOS();
}
function getShouldUseCPURendering() {
  return config.rendering.useCPURendering;
}
function isCornerstoneInitialized() {
  return csRenderInitialized;
}
function getConfiguration() {
  return config;
}
function _updateRenderingPipelinesForAllViewports() {
  getRenderingEngines().forEach((e12) => {
    e12.getViewports().forEach((e13) => {
      e13.updateRenderingPipeline();
    });
  });
}
function getWebWorkerManager() {
  return webWorkerManager ||= new webWorkerManager_default(), webWorkerManager;
}
async function peerImport(e12) {
  return config.peerImport(e12);
}
var eventTarget_default = new class {
  constructor() {
    this.listeners = {}, this.debouncedListeners = {};
  }
  reset() {
    this.listeners = {}, this.debouncedListeners = {};
  }
  addEventListenerOnce(e12, t) {
    let n = (r) => {
      this.removeEventListener(e12, n), t.call(this, r);
    };
    this.addEventListener(e12, n);
  }
  addEventListener(e12, t) {
    this.listeners[e12] || (this.listeners[e12] = []), this.listeners[e12].indexOf(t) === -1 && this.listeners[e12].push(t);
  }
  addEventListenerDebounced(e12, t, n) {
    this.debouncedListeners[e12] = this.debouncedListeners[e12] || {};
    let r = this.debouncedListeners[e12];
    if (!r[t]) {
      let a = (e13) => {
        r[t] && clearTimeout(r[t].timeoutId), r[t].timeoutId = setTimeout(() => {
          t.call(this, e13);
        }, n);
      };
      r[t] = {
        original: t,
        handle: a,
        timeoutId: null
      }, this.addEventListener(e12, a);
    }
  }
  removeEventListenerDebounced(e12, t) {
    if (this.debouncedListeners[e12]?.[t]) {
      let n = this.debouncedListeners[e12][t];
      this.removeEventListener(e12, n.handle), clearTimeout(n.timeoutId), delete this.debouncedListeners[e12][t];
    }
  }
  removeEventListener(e12, t) {
    if (!this.listeners[e12])
      return;
    let n = this.listeners[e12], r = n.length;
    for (let e13 = 0; e13 < r; e13++)
      if (n[e13] === t) {
        n.splice(e13, 1);
        return;
      }
  }
  dispatchEvent(e12) {
    if (!this.listeners[e12.type])
      return !e12.defaultPrevented;
    let t = this.listeners[e12.type].slice(), n = t.length;
    for (let r = 0; r < n; r++)
      try {
        t[r].call(this, e12);
      } catch (t2) {
        console.error(`error in event listener of type:  ${e12.type}`, t2);
      }
    return !e12.defaultPrevented;
  }
}();
function triggerEvent(e12 = eventTarget_default, t, n = null) {
  if (!t)
    throw Error("Event type was not defined");
  let r = new CustomEvent(t, {
    detail: n,
    cancelable: true
  });
  return e12?.dispatchEvent(r);
}
var require_fast_deep_equal = /* @__PURE__ */ __commonJSMin((e12, t) => {
  t.exports = function e13(t2, n) {
    if (t2 === n)
      return true;
    if (t2 && n && typeof t2 == "object" && typeof n == "object") {
      if (t2.constructor !== n.constructor)
        return false;
      var r, a, o;
      if (Array.isArray(t2)) {
        if (r = t2.length, r != n.length)
          return false;
        for (a = r; a-- !== 0; )
          if (!e13(t2[a], n[a]))
            return false;
        return true;
      }
      if (t2.constructor === RegExp)
        return t2.source === n.source && t2.flags === n.flags;
      if (t2.valueOf !== Object.prototype.valueOf)
        return t2.valueOf() === n.valueOf();
      if (t2.toString !== Object.prototype.toString)
        return t2.toString() === n.toString();
      if (o = Object.keys(t2), r = o.length, r !== Object.keys(n).length)
        return false;
      for (a = r; a-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, o[a]))
          return false;
      for (a = r; a-- !== 0; ) {
        var s = o[a];
        if (!e13(t2[s], n[s]))
          return false;
      }
      return true;
    }
    return t2 !== t2 && n !== n;
  };
}), require_isArguments = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = Object.prototype.toString;
  t.exports = function(e13) {
    var t2 = n.call(e13), r = t2 === "[object Arguments]";
    return r ||= t2 !== "[object Array]" && typeof e13 == "object" && !!e13 && typeof e13.length == "number" && e13.length >= 0 && n.call(e13.callee) === "[object Function]", r;
  };
}), require_implementation = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n;
  if (!Object.keys) {
    var r = Object.prototype.hasOwnProperty, a = Object.prototype.toString, o = require_isArguments(), s = Object.prototype.propertyIsEnumerable, c = !s.call({ toString: null }, "toString"), l = s.call(function() {
    }, "prototype"), u = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], d = function(e13) {
      var t2 = e13.constructor;
      return t2 && t2.prototype === e13;
    }, f = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    }, p = function() {
      if (typeof window > "u")
        return false;
      for (var e13 in window)
        try {
          if (!f["$" + e13] && r.call(window, e13) && window[e13] !== null && typeof window[e13] == "object")
            try {
              d(window[e13]);
            } catch {
              return true;
            }
        } catch {
          return true;
        }
      return false;
    }(), m = function(e13) {
      if (typeof window > "u" || !p)
        return d(e13);
      try {
        return d(e13);
      } catch {
        return false;
      }
    };
    n = function(e13) {
      var t2 = typeof e13 == "object" && !!e13, n2 = a.call(e13) === "[object Function]", s2 = o(e13), d2 = t2 && a.call(e13) === "[object String]", f2 = [];
      if (!t2 && !n2 && !s2)
        throw TypeError("Object.keys called on a non-object");
      var p2 = l && n2;
      if (d2 && e13.length > 0 && !r.call(e13, 0))
        for (var h = 0; h < e13.length; ++h)
          f2.push(String(h));
      if (s2 && e13.length > 0)
        for (var g = 0; g < e13.length; ++g)
          f2.push(String(g));
      else
        for (var _ in e13)
          !(p2 && _ === "prototype") && r.call(e13, _) && f2.push(String(_));
      if (c)
        for (var v = m(e13), y = 0; y < u.length; ++y)
          !(v && u[y] === "constructor") && r.call(e13, u[y]) && f2.push(u[y]);
      return f2;
    };
  }
  t.exports = n;
}), require_object_keys = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = Array.prototype.slice, r = require_isArguments(), a = Object.keys, o = a ? function(e13) {
    return a(e13);
  } : require_implementation(), s = Object.keys;
  o.shim = function() {
    return Object.keys ? function() {
      var e13 = Object.keys(arguments);
      return e13 && e13.length === arguments.length;
    }(1, 2) || (Object.keys = function(e13) {
      return r(e13) ? s(n.call(e13)) : s(e13);
    }) : Object.keys = o, Object.keys || o;
  }, t.exports = o;
}), require_es_define_property = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = Object.defineProperty || false;
  if (n)
    try {
      n({}, "a", { value: 1 });
    } catch {
      n = false;
    }
  t.exports = n;
}), require_syntax = /* @__PURE__ */ __commonJSMin((e12, t) => {
  t.exports = SyntaxError;
}), require_type = /* @__PURE__ */ __commonJSMin((e12, t) => {
  t.exports = TypeError;
}), require_gOPD = /* @__PURE__ */ __commonJSMin((e12, t) => {
  t.exports = Object.getOwnPropertyDescriptor;
}), require_gopd = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = require_gOPD();
  if (n)
    try {
      n([], "length");
    } catch {
      n = null;
    }
  t.exports = n;
}), require_define_data_property = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = require_es_define_property(), r = require_syntax(), a = require_type(), o = require_gopd();
  t.exports = function(e13, t2, s) {
    if (!e13 || typeof e13 != "object" && typeof e13 != "function")
      throw new a("`obj` must be an object or a function`");
    if (typeof t2 != "string" && typeof t2 != "symbol")
      throw new a("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new a("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new a("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new a("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new a("`loose`, if provided, must be a boolean");
    var c = arguments.length > 3 ? arguments[3] : null, l = arguments.length > 4 ? arguments[4] : null, u = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 ? arguments[6] : false, f = !!o && o(e13, t2);
    if (n)
      n(e13, t2, {
        configurable: u === null && f ? f.configurable : !u,
        enumerable: c === null && f ? f.enumerable : !c,
        value: s,
        writable: l === null && f ? f.writable : !l
      });
    else if (d || !c && !l && !u)
      e13[t2] = s;
    else
      throw new r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  };
}), require_has_property_descriptors = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = require_es_define_property(), r = function() {
    return !!n;
  };
  r.hasArrayLengthDefineBug = function() {
    if (!n)
      return null;
    try {
      return n([], "length", { value: 1 }).length !== 1;
    } catch {
      return true;
    }
  }, t.exports = r;
}), require_define_properties = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = require_object_keys(), r = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", a = Object.prototype.toString, o = Array.prototype.concat, s = require_define_data_property(), c = function(e13) {
    return typeof e13 == "function" && a.call(e13) === "[object Function]";
  }, l = require_has_property_descriptors()(), u = function(e13, t2, n2, r2) {
    if (t2 in e13) {
      if (r2 === true) {
        if (e13[t2] === n2)
          return;
      } else if (!c(r2) || !r2())
        return;
    }
    l ? s(e13, t2, n2, true) : s(e13, t2, n2);
  }, d = function(e13, t2) {
    var a2 = arguments.length > 2 ? arguments[2] : {}, s2 = n(t2);
    r && (s2 = o.call(s2, Object.getOwnPropertySymbols(t2)));
    for (var c2 = 0; c2 < s2.length; c2 += 1)
      u(e13, s2[c2], t2[s2[c2]], a2[s2[c2]]);
  };
  d.supportsDescriptors = !!l, t.exports = d;
}), require_implementation_browser = /* @__PURE__ */ __commonJSMin((e12, t) => {
  typeof self < "u" ? t.exports = self : typeof window < "u" ? t.exports = window : t.exports = Function("return this")();
}), require_polyfill = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = require_implementation_browser();
  t.exports = function() {
    return typeof global != "object" || !global || global.Math !== Math || global.Array !== Array ? n : global;
  };
}), require_shim = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = require_define_properties(), r = require_polyfill();
  t.exports = function() {
    var e13 = r();
    if (n.supportsDescriptors) {
      var t2 = Object.getOwnPropertyDescriptor(e13, "globalThis");
      (!t2 || t2.configurable && (t2.enumerable || !t2.writable || globalThis !== e13)) && Object.defineProperty(e13, "globalThis", {
        configurable: true,
        enumerable: false,
        value: e13,
        writable: true
      });
    } else
      (typeof globalThis != "object" || globalThis !== e13) && (e13.globalThis = e13);
    return e13;
  };
}), vtkGlobal = (0, (/* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = require_define_properties(), r = require_implementation_browser(), a = require_polyfill(), o = require_shim(), s = a(), c = function() {
    return s;
  };
  n(c, {
    getPolyfill: a,
    implementation: r,
    shim: o
  }), t.exports = c;
}))(), 1)).default)(), factoryMapping = { vtkObject: () => null };
function vtk(e12) {
  if (e12 == null || e12.isA)
    return e12;
  if (!e12.vtkClass)
    return vtkGlobal.console && vtkGlobal.console.error && vtkGlobal.console.error("Invalid VTK object"), null;
  let t = factoryMapping[e12.vtkClass];
  if (!t)
    return vtkGlobal.console && vtkGlobal.console.error && vtkGlobal.console.error(`No vtk class found for Object of type ${e12.vtkClass}`), null;
  let n = { ...e12 };
  Object.keys(n).forEach((e13) => {
    n[e13] && typeof n[e13] == "object" && n[e13].vtkClass && (n[e13] = vtk(n[e13]));
  });
  let r = t(n);
  return r && r.modified && r.modified(), r;
}
function register(e12, t) {
  factoryMapping[e12] = t;
}
vtk.register = register;
var ClassHierarchy = class extends Array {
  push() {
    for (let e12 = 0; e12 < arguments.length; e12++)
      this.includes(arguments[e12]) || super.push(arguments[e12]);
    return this.length;
  }
}, import_fast_deep_equal$3 = /* @__PURE__ */ __toESM(require_fast_deep_equal(), 1), globalMTime = 0, requiredParam = (e12) => {
  throw Error(`Named parameter '${e12}' is missing`);
}, VOID = Symbol("void");
function getCurrentGlobalMTime() {
  return globalMTime;
}
var fakeConsole = {};
function noOp$1() {
}
[
  "log",
  "debug",
  "info",
  "warn",
  "error",
  "time",
  "timeEnd",
  "group",
  "groupEnd"
].forEach((e12) => {
  fakeConsole[e12] = noOp$1;
}), vtkGlobal.console = console.hasOwnProperty("log") ? console : fakeConsole;
var loggerFunctions = {
  debug: noOp$1,
  error: vtkGlobal.console.error || noOp$1,
  info: vtkGlobal.console.info || noOp$1,
  log: vtkGlobal.console.log || noOp$1,
  warn: vtkGlobal.console.warn || noOp$1
};
function setLoggerFunction(e12, t) {
  loggerFunctions[e12] && (loggerFunctions[e12] = t || noOp$1);
}
function vtkLogMacro() {
  loggerFunctions.log(...arguments);
}
function vtkInfoMacro() {
  loggerFunctions.info(...arguments);
}
function vtkDebugMacro$4() {
  loggerFunctions.debug(...arguments);
}
function vtkErrorMacro() {
  loggerFunctions.error(...arguments);
}
function vtkWarningMacro$2() {
  loggerFunctions.warn(...arguments);
}
var ERROR_ONCE_MAP = {};
function vtkOnceErrorMacro$1(e12) {
  ERROR_ONCE_MAP[e12] || (loggerFunctions.error(e12), ERROR_ONCE_MAP[e12] = true);
}
var TYPED_ARRAYS = /* @__PURE__ */ Object.create(null);
TYPED_ARRAYS.Float32Array = Float32Array, TYPED_ARRAYS.Float64Array = Float64Array, TYPED_ARRAYS.Uint8Array = Uint8Array, TYPED_ARRAYS.Int8Array = Int8Array, TYPED_ARRAYS.Uint16Array = Uint16Array, TYPED_ARRAYS.Int16Array = Int16Array, TYPED_ARRAYS.Uint32Array = Uint32Array, TYPED_ARRAYS.Int32Array = Int32Array, TYPED_ARRAYS.Uint8ClampedArray = Uint8ClampedArray;
try {
  TYPED_ARRAYS.BigInt64Array = BigInt64Array, TYPED_ARRAYS.BigUint64Array = BigUint64Array;
} catch {
}
function newTypedArray(e12) {
  var t = [...arguments].slice(1);
  return new (TYPED_ARRAYS[e12] || Float64Array)(...t);
}
function newTypedArrayFrom(e12) {
  var t = [...arguments].slice(1);
  return (TYPED_ARRAYS[e12] || Float64Array).from(...t);
}
function capitalize(e12) {
  return e12.charAt(0).toUpperCase() + e12.slice(1);
}
function _capitalize(e12) {
  return capitalize(e12[0] === "_" ? e12.slice(1) : e12);
}
function uncapitalize(e12) {
  return e12.charAt(0).toLowerCase() + e12.slice(1);
}
function formatBytesToProperUnit(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e3, r = [
    "TB",
    "GB",
    "MB",
    "KB"
  ], a = Number(e12), o = "B";
  for (; a > n; )
    a /= n, o = r.pop();
  return `${a.toFixed(t)} ${o}`;
}
function formatNumbersWithThousandSeparator(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ", n = [], r = e12;
  for (; r > 1e3; )
    n.push(`000${r % 1e3}`.slice(-3)), r = Math.floor(r / 1e3);
  return r > 0 && n.push(r), n.reverse(), n.join(t);
}
function safeArrays(e12) {
  Object.keys(e12).forEach((t) => {
    Array.isArray(e12[t]) && (e12[t] = [].concat(e12[t]));
  });
}
function isTypedArray(e12) {
  return Object.values(TYPED_ARRAYS).some((t) => e12 instanceof t);
}
function shallowEquals(e12, t) {
  if (e12 === t)
    return true;
  if (Array.isArray(e12) && Array.isArray(t)) {
    if (e12.length !== t.length)
      return false;
    for (let n = 0; n < e12.length; n++)
      if (e12[n] !== t[n])
        return false;
    return true;
  }
  return false;
}
function enumToString(e12, t) {
  return Object.keys(e12).find((n) => e12[n] === t);
}
function getStateArrayMapFunc(e12) {
  return e12 && e12.isA ? e12.getState() : e12;
}
function setImmediateVTK(e12) {
  setTimeout(e12, 0);
}
function measurePromiseExecution(e12, t) {
  let n = performance.now();
  e12.finally(() => {
    t(performance.now() - n);
  });
}
function obj() {
  let e12 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  safeArrays(t);
  let n = [];
  if (Number.isInteger(t.mtime) || (t.mtime = ++globalMTime), !("classHierarchy" in t))
    t.classHierarchy = new ClassHierarchy("vtkObject");
  else if (!(t.classHierarchy instanceof ClassHierarchy)) {
    let e13 = new ClassHierarchy();
    for (let n2 = 0; n2 < t.classHierarchy.length; n2++)
      e13.push(t.classHierarchy[n2]);
    t.classHierarchy = e13;
  }
  function r(e13) {
    n[e13] = null;
  }
  function a(e13) {
    function t2() {
      r(e13);
    }
    return Object.freeze({ unsubscribe: t2 });
  }
  return e12.isDeleted = () => !!t.deleted, e12.modified = (r2) => {
    if (t.deleted) {
      vtkErrorMacro("instance deleted - cannot call any method");
      return;
    }
    r2 && r2 < e12.getMTime() || (t.mtime = ++globalMTime, n.forEach((t2) => t2 && t2(e12)));
  }, e12.onModified = (e13) => {
    if (t.deleted)
      return vtkErrorMacro("instance deleted - cannot call any method"), null;
    let r2 = n.length;
    return n.push(e13), a(r2);
  }, e12.getMTime = () => t.mtime, e12.isA = (e13) => {
    let n2 = t.classHierarchy.length;
    for (; n2--; )
      if (t.classHierarchy[n2] === e13)
        return true;
    return false;
  }, e12.getClassName = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.classHierarchy[t.classHierarchy.length - 1 - e13];
  }, e12.set = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, a2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, o = false;
    return Object.keys(n2).forEach((s) => {
      let c = a2 ? null : e12[`set${capitalize(s)}`];
      c && Array.isArray(n2[s]) && c.length > 1 ? o = c(...n2[s]) || o : c ? o = c(n2[s]) || o : (["mtime"].indexOf(s) === -1 && !r2 && vtkWarningMacro$2(`Warning: Set value to model directly ${s}, ${n2[s]}`), o = t[s] !== n2[s] || o, t[s] = n2[s]);
    }), o;
  }, e12.get = function() {
    var e13 = [...arguments];
    if (!e13.length)
      return t;
    let n2 = {};
    return e13.forEach((e14) => {
      n2[e14] = t[e14];
    }), n2;
  }, e12.getReferenceByName = (e13) => t[e13], e12.delete = () => {
    Object.keys(t).forEach((e13) => delete t[e13]), n.forEach((e13, t2) => r(t2)), t.deleted = true;
  }, e12.getState = () => {
    if (t.deleted)
      return null;
    let n2 = {
      ...t,
      vtkClass: e12.getClassName()
    };
    Object.keys(n2).forEach((e13) => {
      n2[e13] === null || n2[e13] === void 0 || e13[0] === "_" ? delete n2[e13] : n2[e13].isA ? n2[e13] = n2[e13].getState() : Array.isArray(n2[e13]) ? n2[e13] = n2[e13].map(getStateArrayMapFunc) : isTypedArray(n2[e13]) && (n2[e13] = Array.from(n2[e13]));
    });
    let r2 = {};
    return Object.keys(n2).sort().forEach((e13) => {
      r2[e13] = n2[e13];
    }), r2.mtime && delete r2.mtime, r2;
  }, e12.shallowCopy = function(n2) {
    let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (n2.getClassName() !== e12.getClassName())
      throw Error(`Cannot ShallowCopy ${n2.getClassName()} into ${e12.getClassName()}`);
    let a2 = n2.get(), o = Object.keys(t).sort();
    Object.keys(a2).sort().forEach((e13) => {
      let n3 = o.indexOf(e13);
      n3 === -1 ? r2 && vtkDebugMacro$4(`add ${e13} in shallowCopy`) : o.splice(n3, 1), t[e13] = a2[e13];
    }), o.length && r2 && vtkDebugMacro$4(`Untouched keys: ${o.join(", ")}`), e12.modified();
  }, e12.toJSON = function() {
    return e12.getState();
  }, e12;
}
var objectGetterMap = { object(e12, t, n) {
  return function() {
    return { ...t[n.name] };
  };
} };
function get(e12, t, n) {
  n.forEach((n2) => {
    if (typeof n2 == "object") {
      let r = objectGetterMap[n2.type];
      r ? e12[`get${_capitalize(n2.name)}`] = r(e12, t, n2) : e12[`get${_capitalize(n2.name)}`] = () => t[n2.name];
    } else
      e12[`get${_capitalize(n2)}`] = () => t[n2];
  });
}
var objectSetterMap = {
  enum(e12, t, n) {
    let r = `_on${_capitalize(n.name)}Changed`;
    return (a) => {
      if (typeof a == "string") {
        if (n.enum[a] !== void 0)
          return t[n.name] === n.enum[a] ? false : (t[n.name] = n.enum[a], e12.modified(), true);
        throw vtkErrorMacro(`Set Enum with invalid argument ${n}, ${a}`), RangeError("Set Enum with invalid string argument");
      }
      if (typeof a == "number") {
        if (t[n.name] !== a) {
          if (Object.keys(n.enum).map((e13) => n.enum[e13]).indexOf(a) !== -1) {
            let o = t[n.name];
            return t[n.name] = a, t[r]?.(e12, t, a, o), e12.modified(), true;
          }
          throw vtkErrorMacro(`Set Enum outside numeric range ${n}, ${a}`), RangeError("Set Enum outside numeric range");
        }
        return false;
      }
      throw vtkErrorMacro(`Set Enum with invalid argument (String/Number) ${n}, ${a}`), TypeError("Set Enum with invalid argument (String/Number)");
    };
  },
  object(e12, t, n) {
    n.params?.length === 1 && vtkWarningMacro$2('Setter of type "object" with a single "param" field is not supported');
    let r = `_on${_capitalize(n.name)}Changed`;
    return function() {
      var a = [...arguments];
      let o;
      if (o = a.length > 1 && n.params?.length ? n.params.reduce((e13, t2, n2) => Object.assign(e13, { [t2]: a[n2] }), {}) : a[0], !(0, import_fast_deep_equal$3.default)(t[n.name], o)) {
        let a2 = t[n.name];
        return t[n.name] = o, t[r]?.(e12, t, o, a2), e12.modified(), true;
      }
      return false;
    };
  }
};
function findSetter(e12) {
  if (typeof e12 == "object") {
    let t = objectSetterMap[e12.type];
    if (t)
      return (n, r) => t(n, r, e12);
    throw vtkErrorMacro(`No setter for field ${e12}`), TypeError("No setter for field");
  }
  return function(t, n) {
    let r = `_on${_capitalize(e12)}Changed`;
    return function(a) {
      if (n.deleted)
        return vtkErrorMacro("instance deleted - cannot call any method"), false;
      if (n[e12] !== a) {
        let o = n[e12.name];
        return n[e12] = a, n[r]?.(t, n, a, o), t.modified(), true;
      }
      return false;
    };
  };
}
function set$1(e12, t, n) {
  n.forEach((n2) => {
    typeof n2 == "object" ? e12[`set${_capitalize(n2.name)}`] = findSetter(n2)(e12, t) : e12[`set${_capitalize(n2)}`] = findSetter(n2)(e12, t);
  });
}
function setGet(e12, t, n) {
  get(e12, t, n), set$1(e12, t, n);
}
function getArray(e12, t, n) {
  n.forEach((n2) => {
    e12[`get${_capitalize(n2)}`] = () => t[n2] ? Array.from(t[n2]) : t[n2], e12[`get${_capitalize(n2)}ByReference`] = () => t[n2];
  });
}
function setArray(e12, t, n, r) {
  let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : void 0;
  n.forEach((n2) => {
    if (t[n2] && r && t[n2].length !== r)
      throw RangeError(`Invalid initial number of values for array (${n2})`);
    let o = `_on${_capitalize(n2)}Changed`;
    e12[`set${_capitalize(n2)}`] = function() {
      if (t.deleted)
        return vtkErrorMacro("instance deleted - cannot call any method"), false;
      let s = [...arguments], c, l = false;
      if (s.length === 1 && (s[0] == null || s[0].length >= 0) && (s = s[0], l = true), s == null)
        c = t[n2] !== s;
      else {
        if (r && s.length !== r)
          if (s.length < r && a !== void 0)
            for (s = Array.from(s), l = false; s.length < r; )
              s.push(a);
          else
            throw RangeError(`Invalid number of values for array setter (${n2})`);
        c = t[n2] == null || t[n2].length !== s.length;
        for (let e13 = 0; !c && e13 < s.length; ++e13)
          c = t[n2][e13] !== s[e13];
        c && l && (s = Array.from(s));
      }
      if (c) {
        let r2 = t[n2.name];
        t[n2] = s, t[o]?.(e12, t, s, r2), e12.modified();
      }
      return c;
    }, e12[`set${_capitalize(n2)}From`] = (e13) => {
      let r2 = t[n2];
      e13.forEach((e14, t2) => {
        r2[t2] = e14;
      });
    };
  });
}
function setGetArray(e12, t, n, r) {
  let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : void 0;
  getArray(e12, t, n), setArray(e12, t, n, r, a);
}
function moveToProtected(e12, t, n) {
  for (let e13 = 0; e13 < n.length; e13++) {
    let r = n[e13];
    t[r] !== void 0 && (t[`_${r}`] = t[r], delete t[r]);
  }
}
function algo(e12, t, n, r) {
  t.inputData ? t.inputData = t.inputData.map(vtk) : t.inputData = [], t.inputConnection ? t.inputConnection = t.inputConnection.map(vtk) : t.inputConnection = [], t.output ? t.output = t.output.map(vtk) : t.output = [], t.inputArrayToProcess ? t.inputArrayToProcess = t.inputArrayToProcess.map(vtk) : t.inputArrayToProcess = [], t.numberOfInputs = n;
  function a(n2) {
    let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (t.deleted) {
      vtkErrorMacro("instance deleted - cannot call any method");
      return;
    }
    if (r2 >= t.numberOfInputs) {
      vtkErrorMacro(`algorithm ${e12.getClassName()} only has ${t.numberOfInputs} input ports. To add more input ports, use addInputData()`);
      return;
    }
    (t.inputData[r2] !== n2 || t.inputConnection[r2]) && (t.inputData[r2] = n2, t.inputConnection[r2] = null, e12.modified && e12.modified());
  }
  function o() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.inputConnection[e13] && (t.inputData[e13] = t.inputConnection[e13]()), t.inputData[e13];
  }
  function s(n2) {
    let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (t.deleted) {
      vtkErrorMacro("instance deleted - cannot call any method");
      return;
    }
    if (r2 >= t.numberOfInputs) {
      let n3 = `algorithm ${e12.getClassName()} only has `;
      n3 += `${t.numberOfInputs}`, n3 += " input ports. To add more input ports, use addInputConnection()", vtkErrorMacro(n3);
      return;
    }
    t.inputData[r2] = null, t.inputConnection[r2] = n2;
  }
  function c() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.inputConnection[e13];
  }
  function l() {
    let e13 = t.numberOfInputs;
    for (; e13 && !t.inputData[e13 - 1] && !t.inputConnection[e13 - 1]; )
      e13--;
    return e13 === t.numberOfInputs && t.numberOfInputs++, e13;
  }
  function u(e13) {
    if (t.deleted) {
      vtkErrorMacro("instance deleted - cannot call any method");
      return;
    }
    s(e13, l());
  }
  function d(e13) {
    if (t.deleted) {
      vtkErrorMacro("instance deleted - cannot call any method");
      return;
    }
    a(e13, l());
  }
  function f() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.deleted ? (vtkErrorMacro("instance deleted - cannot call any method"), null) : (e12.shouldUpdate() && e12.update(), t.output[n2]);
  }
  e12.shouldUpdate = () => {
    let n2 = e12.getMTime(), a2 = Infinity, o2 = r;
    for (; o2--; ) {
      if (!t.output[o2] || t.output[o2].isDeleted())
        return true;
      let e13 = t.output[o2].getMTime();
      if (e13 < n2)
        return true;
      e13 < a2 && (a2 = e13);
    }
    for (o2 = t.numberOfInputs; o2--; )
      if (t.inputConnection[o2]?.filter.shouldUpdate() || e12.getInputData(o2)?.getMTime() > a2)
        return true;
    return false;
  };
  function p() {
    let t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n2 = () => f(t2);
    return n2.filter = e12, n2;
  }
  if (t.numberOfInputs) {
    let n2 = t.numberOfInputs;
    for (; n2--; )
      t.inputData.push(null), t.inputConnection.push(null);
    e12.setInputData = a, e12.setInputConnection = s, e12.addInputData = d, e12.addInputConnection = u, e12.getInputData = o, e12.getInputConnection = c;
  }
  r && (e12.getOutputData = f, e12.getOutputPort = p), e12.update = () => {
    let n2 = [];
    if (t.numberOfInputs) {
      let r2 = 0;
      for (; r2 < t.numberOfInputs; )
        n2[r2] = e12.getInputData(r2), r2++;
    }
    e12.requestData && !e12.isDeleted() && e12.shouldUpdate() && e12.requestData(n2, t.output);
  }, e12.getNumberOfInputPorts = () => t.numberOfInputs, e12.getNumberOfOutputPorts = () => r || t.output.length, e12.getInputArrayToProcess = (e13) => {
    let n2 = t.inputArrayToProcess[e13], r2 = t.inputData[e13];
    return n2 && r2 ? r2[`get${n2.fieldAssociation}`]().getArray(n2.arrayName) : null;
  }, e12.setInputArrayToProcess = function(e13, n2, r2) {
    let a2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Scalars";
    for (; t.inputArrayToProcess.length < e13; )
      t.inputArrayToProcess.push(null);
    t.inputArrayToProcess[e13] = {
      arrayName: n2,
      fieldAssociation: r2,
      attributeType: a2
    };
  };
}
var EVENT_ABORT = Symbol("Event abort");
function event(e12, t, n) {
  let r = [], a = e12.delete, o = 1;
  function s(e13) {
    for (let t2 = 0; t2 < r.length; ++t2) {
      let [n2] = r[t2];
      if (n2 === e13) {
        r.splice(t2, 1);
        return;
      }
    }
  }
  function c(e13) {
    function t2() {
      s(e13);
    }
    return Object.freeze({ unsubscribe: t2 });
  }
  function l() {
    if (t.deleted) {
      vtkErrorMacro("instance deleted - cannot call any method");
      return;
    }
    let n2 = r.slice();
    for (let t2 = 0; t2 < n2.length; ++t2) {
      let [, r2, a2] = n2[t2];
      if (r2) {
        if (a2 < 0)
          setTimeout(() => r2.apply(e12, arguments), 1 - a2);
        else if (r2.apply(e12, arguments) === EVENT_ABORT)
          break;
      }
    }
  }
  e12[`invoke${_capitalize(n)}`] = l, e12[`on${_capitalize(n)}`] = function(e13) {
    let a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!e13.apply)
      return console.error(`Invalid callback for event ${n}`), null;
    if (t.deleted)
      return vtkErrorMacro("instance deleted - cannot call any method"), null;
    let s2 = o++;
    return r.push([
      s2,
      e13,
      a2
    ]), r.sort((e14, t2) => t2[2] - e14[2]), c(s2);
  }, e12.delete = () => {
    a(), r.forEach((e13) => {
      let [t2] = e13;
      return s(t2);
    });
  };
}
function newInstance(e12, t) {
  let n = function() {
    let t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n2 = {}, r = {};
    return e12(r, n2, t2), Object.freeze(r);
  };
  return t && vtk.register(t, n), n;
}
function chain() {
  var e12 = [...arguments];
  return function() {
    var t = [...arguments];
    return e12.filter((e13) => !!e13).map((e13) => e13(...t));
  };
}
function isVtkObject(e12) {
  return e12 && e12.isA && e12.isA("vtkObject");
}
function traverseInstanceTree(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
  if (isVtkObject(e12)) {
    if (r.indexOf(e12) >= 0)
      return n;
    r.push(e12);
    let a = t(e12);
    a !== void 0 && n.push(a);
    let o = e12.get();
    Object.keys(o).forEach((e13) => {
      let a2 = o[e13];
      Array.isArray(a2) ? a2.forEach((e14) => {
        traverseInstanceTree(e14, t, n, r);
      }) : traverseInstanceTree(a2, t, n, r);
    });
  }
  return n;
}
function debounce(e12, t, n) {
  var r = this;
  let a, o = function() {
    var o2 = [...arguments];
    let s = r, c = () => {
      a = null, n || e12.apply(s, o2);
    }, l = n && !a;
    clearTimeout(a), a = setTimeout(c, t), l && e12.apply(s, o2);
  };
  return o.cancel = () => clearTimeout(a), o;
}
function throttle(e12, t) {
  let n = false, r = null;
  function a() {
    n = false, r !== null && (o(...r), r = null);
  }
  function o() {
    var o2 = [...arguments];
    if (n) {
      r = o2;
      return;
    }
    n = true, e12(...o2), setTimeout(a, t);
  }
  return o;
}
function keystore(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  t.keystore = Object.assign(t.keystore || {}, n), e12.setKey = (e13, n2) => {
    t.keystore[e13] = n2;
  }, e12.getKey = (e13) => t.keystore[e13], e12.getAllKeys = () => Object.keys(t.keystore), e12.deleteKey = (e13) => delete t.keystore[e13], e12.clearKeystore = () => e12.getAllKeys().forEach((e13) => delete t.keystore[e13]);
}
var nextProxyId = 1, ROOT_GROUP_NAME = "__root__";
function proxy(e12, t) {
  keystore(e12, t);
  let n = e12.delete;
  t.proxyId = `${nextProxyId++}`, t.ui = JSON.parse(JSON.stringify(t.ui || [])), get(e12, t, [
    "proxyId",
    "proxyGroup",
    "proxyName"
  ]), setGet(e12, t, ["proxyManager"]);
  let r = {}, a = {};
  function o(e13, t2) {
    a[t2] || (a[t2] = []);
    let n2 = a[t2];
    for (let t3 = 0; t3 < e13.length; t3++)
      n2.push(e13[t3].name), r[e13[t3].name] = e13[t3], e13[t3].children && e13[t3].children.length && o(e13[t3].children, e13[t3].name);
  }
  o(t.ui, ROOT_GROUP_NAME), e12.updateUI = (n2) => {
    t.ui = JSON.parse(JSON.stringify(n2 || [])), Object.keys(r).forEach((e13) => delete r[e13]), Object.keys(a).forEach((e13) => delete a[e13]), o(t.ui, ROOT_GROUP_NAME), e12.modified();
  };
  function s() {
    return a[arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ROOT_GROUP_NAME];
  }
  e12.updateProxyProperty = (e13, t2) => {
    let n2 = r[e13];
    n2 ? Object.assign(n2, t2) : r[e13] = { ...t2 };
  }, e12.activate = () => {
    if (t.proxyManager) {
      let n2 = `setActive${_capitalize(e12.getProxyGroup().slice(0, -1))}`;
      t.proxyManager[n2] && t.proxyManager[n2](e12);
    }
  }, t.propertyLinkSubscribers = {}, e12.registerPropertyLinkForGC = (e13, n2) => {
    n2 in t.propertyLinkSubscribers || (t.propertyLinkSubscribers[n2] = []), t.propertyLinkSubscribers[n2].push(e13);
  }, e12.gcPropertyLinks = (n2) => {
    let r2 = t.propertyLinkSubscribers[n2] || [];
    for (; r2.length; )
      r2.pop().unbind(e12);
  }, t.propertyLinkMap = {}, e12.getPropertyLink = function(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (t.propertyLinkMap[e13])
      return t.propertyLinkMap[e13];
    let r2 = null, a2 = [], o2 = 0, s2 = false;
    function c2(n3) {
      let c3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      if (s2)
        return null;
      let l3 = [], u2 = null;
      for (o2 = a2.length; o2--; ) {
        let e14 = a2[o2];
        e14.instance === n3 ? u2 = e14 : l3.push(e14);
      }
      if (!u2)
        return null;
      let d2 = u2.instance[`get${_capitalize(u2.propertyName)}`]();
      if (!shallowEquals(d2, r2) || c3) {
        for (r2 = d2, s2 = true; l3.length; ) {
          let e14 = l3.pop();
          e14.instance.set({ [e14.propertyName]: r2 });
        }
        s2 = false;
      }
      return t.propertyLinkMap[e13].persistent && (t.propertyLinkMap[e13].value = d2), d2;
    }
    function l2(e14, t2) {
      let n3 = [];
      for (o2 = a2.length; o2--; ) {
        let r3 = a2[o2];
        r3.instance === e14 && (r3.propertyName === t2 || t2 === void 0) && (r3.subscription.unsubscribe(), n3.push(o2));
      }
      for (; n3.length; )
        a2.splice(n3.pop(), 1);
    }
    function u(n3, r3) {
      let o3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s3 = n3.onModified(c2), u2 = a2[0];
      return a2.push({
        instance: n3,
        propertyName: r3,
        subscription: s3
      }), o3 && (t.propertyLinkMap[e13].persistent && t.propertyLinkMap[e13].value !== void 0 ? n3.set({ [r3]: t.propertyLinkMap[e13].value }) : u2 && c2(u2.instance, true)), { unsubscribe: () => l2(n3, r3) };
    }
    function d() {
      for (; a2.length; )
        a2.pop().subscription.unsubscribe();
    }
    let f = {
      bind: u,
      unbind: l2,
      unsubscribe: d,
      persistent: n2
    };
    return t.propertyLinkMap[e13] = f, f;
  };
  function c() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ROOT_GROUP_NAME, r2 = [], a2 = t.proxyId, o2 = s(n2) || [];
    for (let t2 = 0; t2 < o2.length; t2++) {
      let n3 = o2[t2], s2 = e12[`get${_capitalize(n3)}`], l2 = {
        id: a2,
        name: n3,
        value: s2 ? s2() : void 0
      }, u = c(n3);
      u.length && (l2.children = u), r2.push(l2);
    }
    return r2;
  }
  e12.listPropertyNames = () => c().map((e13) => e13.name), e12.getPropertyByName = (e13) => c().find((t2) => t2.name === e13), e12.getPropertyDomainByName = (e13) => (r[e13] || {}).domain, e12.getProxySection = () => ({
    id: t.proxyId,
    name: t.proxyGroup,
    ui: t.ui,
    properties: c()
  }), e12.delete = () => {
    let r2 = Object.keys(t.propertyLinkMap), a2 = r2.length;
    for (; a2--; )
      t.propertyLinkMap[r2[a2]].unsubscribe();
    Object.keys(t.propertyLinkSubscribers).forEach(e12.gcPropertyLinks), n();
  }, e12.getState = () => null;
  function l() {
    if (t.links)
      for (let n2 = 0; n2 < t.links.length; n2++) {
        let { link: r2, property: a2, persistent: o2, updateOnBind: s2, type: c2 } = t.links[n2];
        if (c2 === "application") {
          let n3 = t.proxyManager.getPropertyLink(r2, o2);
          e12.registerPropertyLinkForGC(n3, "application"), n3.bind(e12, a2, s2);
        }
      }
  }
  setImmediateVTK(l);
}
function proxyPropertyMapping(e12, t, n) {
  let r = e12.delete, a = [], o = Object.keys(n), s = o.length;
  for (; s--; ) {
    let r2 = o[s], { modelKey: c, property: l, modified: u = true } = n[r2], d = _capitalize(l), f = _capitalize(r2);
    e12[`get${f}`] = t[c][`get${d}`], e12[`set${f}`] = t[c][`set${d}`], u && a.push(t[c].onModified(e12.modified));
  }
  e12.delete = () => {
    for (; a.length; )
      a.pop().unsubscribe();
    r();
  };
}
function proxyPropertyState(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  t.this = e12;
  function a(e13) {
    let n2 = Object.keys(e13), r2 = n2.length;
    for (; r2--; ) {
      let a2 = n2[r2];
      t[a2].set(e13[a2]);
    }
  }
  let o = Object.keys(r), s = o.length;
  for (; s--; ) {
    let c = o[s];
    t[c] = r[c];
    let l = n[c];
    e12[`set${_capitalize(c)}`] = (n2) => {
      if (n2 !== t[c]) {
        t[c] = n2;
        let r2 = l[n2];
        a(r2), e12.modified();
      }
    };
  }
  o.length && get(e12, t, o);
}
var PIXEL_STEP = 10, LINE_HEIGHT = 40, PAGE_HEIGHT = 800;
function normalizeWheel$1(e12) {
  let t = 0, n = 0, r = 0, a = 0;
  return "detail" in e12 && (n = e12.detail), "wheelDelta" in e12 && (n = -e12.wheelDelta / 120), "wheelDeltaY" in e12 && (n = -e12.wheelDeltaY / 120), "wheelDeltaX" in e12 && (t = -e12.wheelDeltaX / 120), "axis" in e12 && e12.axis === e12.HORIZONTAL_AXIS && (t = n, n = 0), r = t * PIXEL_STEP, a = n * PIXEL_STEP, "deltaY" in e12 && (a = e12.deltaY), "deltaX" in e12 && (r = e12.deltaX), (r || a) && e12.deltaMode && (e12.deltaMode === 1 ? (r *= LINE_HEIGHT, a *= LINE_HEIGHT) : (r *= PAGE_HEIGHT, a *= PAGE_HEIGHT)), r && !t && (t = r < 1 ? -1 : 1), a && !n && (n = a < 1 ? -1 : 1), {
    spinX: t,
    spinY: n || t,
    pixelX: r,
    pixelY: a || r
  };
}
var macro = {
  algo,
  capitalize,
  chain,
  debounce,
  enumToString,
  event,
  EVENT_ABORT,
  formatBytesToProperUnit,
  formatNumbersWithThousandSeparator,
  get,
  getArray,
  getCurrentGlobalMTime,
  getStateArrayMapFunc,
  isVtkObject,
  keystore,
  measurePromiseExecution,
  moveToProtected,
  newInstance,
  newTypedArray,
  newTypedArrayFrom,
  normalizeWheel: normalizeWheel$1,
  obj,
  proxy,
  proxyPropertyMapping,
  proxyPropertyState,
  safeArrays,
  set: set$1,
  setArray,
  setGet,
  setGetArray,
  setImmediate: setImmediateVTK,
  setLoggerFunction,
  throttle,
  traverseInstanceTree,
  TYPED_ARRAYS,
  uncapitalize,
  VOID,
  vtkDebugMacro: vtkDebugMacro$4,
  vtkErrorMacro,
  vtkInfoMacro,
  vtkLogMacro,
  vtkOnceErrorMacro: vtkOnceErrorMacro$1,
  vtkWarningMacro: vtkWarningMacro$2,
  objectSetterMap,
  requiredParam
}, macro$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  requiredParam,
  VOID,
  setLoggerFunction,
  vtkLogMacro,
  vtkInfoMacro,
  vtkDebugMacro: vtkDebugMacro$4,
  vtkErrorMacro,
  vtkWarningMacro: vtkWarningMacro$2,
  vtkOnceErrorMacro: vtkOnceErrorMacro$1,
  TYPED_ARRAYS,
  newTypedArray,
  newTypedArrayFrom,
  capitalize,
  _capitalize,
  uncapitalize,
  formatBytesToProperUnit,
  formatNumbersWithThousandSeparator,
  setImmediateVTK,
  measurePromiseExecution,
  obj,
  get,
  set: set$1,
  setGet,
  getArray,
  setArray,
  setGetArray,
  moveToProtected,
  algo,
  EVENT_ABORT,
  event,
  newInstance,
  chain,
  isVtkObject,
  traverseInstanceTree,
  debounce,
  throttle,
  keystore,
  proxy,
  proxyPropertyMapping,
  proxyPropertyState,
  normalizeWheel: normalizeWheel$1,
  default: macro
}), require_alea = /* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(e13, t2, n) {
    function r(e14) {
      var t3 = this, n2 = s();
      t3.next = function() {
        var e15 = 2091639 * t3.s0 + t3.c * 23283064365386963e-26;
        return t3.s0 = t3.s1, t3.s1 = t3.s2, t3.s2 = e15 - (t3.c = e15 | 0);
      }, t3.c = 1, t3.s0 = n2(" "), t3.s1 = n2(" "), t3.s2 = n2(" "), t3.s0 -= n2(e14), t3.s0 < 0 && (t3.s0 += 1), t3.s1 -= n2(e14), t3.s1 < 0 && (t3.s1 += 1), t3.s2 -= n2(e14), t3.s2 < 0 && (t3.s2 += 1), n2 = null;
    }
    function a(e14, t3) {
      return t3.c = e14.c, t3.s0 = e14.s0, t3.s1 = e14.s1, t3.s2 = e14.s2, t3;
    }
    function o(e14, t3) {
      var n2 = new r(e14), o2 = t3 && t3.state, s2 = n2.next;
      return s2.int32 = function() {
        return n2.next() * 4294967296 | 0;
      }, s2.double = function() {
        return s2() + (s2() * 2097152 | 0) * 11102230246251565e-32;
      }, s2.quick = s2, o2 && (typeof o2 == "object" && a(o2, n2), s2.state = function() {
        return a(n2, {});
      }), s2;
    }
    function s() {
      var e14 = 4022871197;
      return function(t3) {
        t3 = String(t3);
        for (var n2 = 0; n2 < t3.length; n2++) {
          e14 += t3.charCodeAt(n2);
          var r2 = 0.02519603282416938 * e14;
          e14 = r2 >>> 0, r2 -= e14, r2 *= e14, e14 = r2 >>> 0, r2 -= e14, e14 += r2 * 4294967296;
        }
        return (e14 >>> 0) * 23283064365386963e-26;
      };
    }
    t2 && t2.exports ? t2.exports = o : n && n.amd ? n(function() {
      return o;
    }) : this.alea = o;
  })(e12, typeof t == "object" && t, typeof define == "function" && define);
}), require_xor128 = /* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(e13, t2, n) {
    function r(e14) {
      var t3 = this, n2 = "";
      t3.x = 0, t3.y = 0, t3.z = 0, t3.w = 0, t3.next = function() {
        var e15 = t3.x ^ t3.x << 11;
        return t3.x = t3.y, t3.y = t3.z, t3.z = t3.w, t3.w ^= t3.w >>> 19 ^ e15 ^ e15 >>> 8;
      }, e14 === (e14 | 0) ? t3.x = e14 : n2 += e14;
      for (var r2 = 0; r2 < n2.length + 64; r2++)
        t3.x ^= n2.charCodeAt(r2) | 0, t3.next();
    }
    function a(e14, t3) {
      return t3.x = e14.x, t3.y = e14.y, t3.z = e14.z, t3.w = e14.w, t3;
    }
    function o(e14, t3) {
      var n2 = new r(e14), o2 = t3 && t3.state, s = function() {
        return (n2.next() >>> 0) / 4294967296;
      };
      return s.double = function() {
        do
          var e15 = ((n2.next() >>> 11) + (n2.next() >>> 0) / 4294967296) / (1 << 21);
        while (e15 === 0);
        return e15;
      }, s.int32 = n2.next, s.quick = s, o2 && (typeof o2 == "object" && a(o2, n2), s.state = function() {
        return a(n2, {});
      }), s;
    }
    t2 && t2.exports ? t2.exports = o : n && n.amd ? n(function() {
      return o;
    }) : this.xor128 = o;
  })(e12, typeof t == "object" && t, typeof define == "function" && define);
}), require_xorwow = /* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(e13, t2, n) {
    function r(e14) {
      var t3 = this, n2 = "";
      t3.next = function() {
        var e15 = t3.x ^ t3.x >>> 2;
        return t3.x = t3.y, t3.y = t3.z, t3.z = t3.w, t3.w = t3.v, (t3.d = t3.d + 362437 | 0) + (t3.v = t3.v ^ t3.v << 4 ^ (e15 ^ e15 << 1)) | 0;
      }, t3.x = 0, t3.y = 0, t3.z = 0, t3.w = 0, t3.v = 0, e14 === (e14 | 0) ? t3.x = e14 : n2 += e14;
      for (var r2 = 0; r2 < n2.length + 64; r2++)
        t3.x ^= n2.charCodeAt(r2) | 0, r2 == n2.length && (t3.d = t3.x << 10 ^ t3.x >>> 4), t3.next();
    }
    function a(e14, t3) {
      return t3.x = e14.x, t3.y = e14.y, t3.z = e14.z, t3.w = e14.w, t3.v = e14.v, t3.d = e14.d, t3;
    }
    function o(e14, t3) {
      var n2 = new r(e14), o2 = t3 && t3.state, s = function() {
        return (n2.next() >>> 0) / 4294967296;
      };
      return s.double = function() {
        do
          var e15 = ((n2.next() >>> 11) + (n2.next() >>> 0) / 4294967296) / (1 << 21);
        while (e15 === 0);
        return e15;
      }, s.int32 = n2.next, s.quick = s, o2 && (typeof o2 == "object" && a(o2, n2), s.state = function() {
        return a(n2, {});
      }), s;
    }
    t2 && t2.exports ? t2.exports = o : n && n.amd ? n(function() {
      return o;
    }) : this.xorwow = o;
  })(e12, typeof t == "object" && t, typeof define == "function" && define);
}), require_xorshift7 = /* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(e13, t2, n) {
    function r(e14) {
      var t3 = this;
      t3.next = function() {
        var e15 = t3.x, n3 = t3.i, r2 = e15[n3], a2;
        return r2 ^= r2 >>> 7, a2 = r2 ^ r2 << 24, r2 = e15[n3 + 1 & 7], a2 ^= r2 ^ r2 >>> 10, r2 = e15[n3 + 3 & 7], a2 ^= r2 ^ r2 >>> 3, r2 = e15[n3 + 4 & 7], a2 ^= r2 ^ r2 << 7, r2 = e15[n3 + 7 & 7], r2 ^= r2 << 13, a2 ^= r2 ^ r2 << 9, e15[n3] = a2, t3.i = n3 + 1 & 7, a2;
      };
      function n2(e15, t4) {
        var n3, r2 = [];
        if (t4 === (t4 | 0))
          r2[0] = t4;
        else
          for (t4 = "" + t4, n3 = 0; n3 < t4.length; ++n3)
            r2[n3 & 7] = r2[n3 & 7] << 15 ^ t4.charCodeAt(n3) + r2[n3 + 1 & 7] << 13;
        for (; r2.length < 8; )
          r2.push(0);
        for (n3 = 0; n3 < 8 && r2[n3] === 0; ++n3)
          ;
        for (n3 == 8 ? r2[7] = -1 : r2[n3], e15.x = r2, e15.i = 0, n3 = 256; n3 > 0; --n3)
          e15.next();
      }
      n2(t3, e14);
    }
    function a(e14, t3) {
      return t3.x = e14.x.slice(), t3.i = e14.i, t3;
    }
    function o(e14, t3) {
      e14 ??= +/* @__PURE__ */ new Date();
      var n2 = new r(e14), o2 = t3 && t3.state, s = function() {
        return (n2.next() >>> 0) / 4294967296;
      };
      return s.double = function() {
        do
          var e15 = ((n2.next() >>> 11) + (n2.next() >>> 0) / 4294967296) / (1 << 21);
        while (e15 === 0);
        return e15;
      }, s.int32 = n2.next, s.quick = s, o2 && (o2.x && a(o2, n2), s.state = function() {
        return a(n2, {});
      }), s;
    }
    t2 && t2.exports ? t2.exports = o : n && n.amd ? n(function() {
      return o;
    }) : this.xorshift7 = o;
  })(e12, typeof t == "object" && t, typeof define == "function" && define);
}), require_xor4096 = /* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(e13, t2, n) {
    function r(e14) {
      var t3 = this;
      t3.next = function() {
        var e15 = t3.w, n3 = t3.X, r2 = t3.i, a2, o2;
        return t3.w = e15 = e15 + 1640531527 | 0, o2 = n3[r2 + 34 & 127], a2 = n3[r2 = r2 + 1 & 127], o2 ^= o2 << 13, a2 ^= a2 << 17, o2 ^= o2 >>> 15, a2 ^= a2 >>> 12, o2 = n3[r2] = o2 ^ a2, t3.i = r2, o2 + (e15 ^ e15 >>> 16) | 0;
      };
      function n2(e15, t4) {
        var n3, r2, a2, o2, s, c = [], l = 128;
        for (t4 === (t4 | 0) ? (r2 = t4, t4 = null) : (t4 += "\0", r2 = 0, l = Math.max(l, t4.length)), a2 = 0, o2 = -32; o2 < l; ++o2)
          t4 && (r2 ^= t4.charCodeAt((o2 + 32) % t4.length)), o2 === 0 && (s = r2), r2 ^= r2 << 10, r2 ^= r2 >>> 15, r2 ^= r2 << 4, r2 ^= r2 >>> 13, o2 >= 0 && (s = s + 1640531527 | 0, n3 = c[o2 & 127] ^= r2 + s, a2 = n3 == 0 ? a2 + 1 : 0);
        for (a2 >= 128 && (c[(t4 && t4.length || 0) & 127] = -1), a2 = 127, o2 = 512; o2 > 0; --o2)
          r2 = c[a2 + 34 & 127], n3 = c[a2 = a2 + 1 & 127], r2 ^= r2 << 13, n3 ^= n3 << 17, r2 ^= r2 >>> 15, n3 ^= n3 >>> 12, c[a2] = r2 ^ n3;
        e15.w = s, e15.X = c, e15.i = a2;
      }
      n2(t3, e14);
    }
    function a(e14, t3) {
      return t3.i = e14.i, t3.w = e14.w, t3.X = e14.X.slice(), t3;
    }
    function o(e14, t3) {
      e14 ??= +/* @__PURE__ */ new Date();
      var n2 = new r(e14), o2 = t3 && t3.state, s = function() {
        return (n2.next() >>> 0) / 4294967296;
      };
      return s.double = function() {
        do
          var e15 = ((n2.next() >>> 11) + (n2.next() >>> 0) / 4294967296) / (1 << 21);
        while (e15 === 0);
        return e15;
      }, s.int32 = n2.next, s.quick = s, o2 && (o2.X && a(o2, n2), s.state = function() {
        return a(n2, {});
      }), s;
    }
    t2 && t2.exports ? t2.exports = o : n && n.amd ? n(function() {
      return o;
    }) : this.xor4096 = o;
  })(e12, typeof t == "object" && t, typeof define == "function" && define);
}), require_tychei = /* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(e13, t2, n) {
    function r(e14) {
      var t3 = this, n2 = "";
      t3.next = function() {
        var e15 = t3.b, n3 = t3.c, r3 = t3.d, a2 = t3.a;
        return e15 = e15 << 25 ^ e15 >>> 7 ^ n3, n3 = n3 - r3 | 0, r3 = r3 << 24 ^ r3 >>> 8 ^ a2, a2 = a2 - e15 | 0, t3.b = e15 = e15 << 20 ^ e15 >>> 12 ^ n3, t3.c = n3 = n3 - r3 | 0, t3.d = r3 << 16 ^ n3 >>> 16 ^ a2, t3.a = a2 - e15 | 0;
      }, t3.a = 0, t3.b = 0, t3.c = -1640531527, t3.d = 1367130551, e14 === Math.floor(e14) ? (t3.a = e14 / 4294967296 | 0, t3.b = e14 | 0) : n2 += e14;
      for (var r2 = 0; r2 < n2.length + 20; r2++)
        t3.b ^= n2.charCodeAt(r2) | 0, t3.next();
    }
    function a(e14, t3) {
      return t3.a = e14.a, t3.b = e14.b, t3.c = e14.c, t3.d = e14.d, t3;
    }
    function o(e14, t3) {
      var n2 = new r(e14), o2 = t3 && t3.state, s = function() {
        return (n2.next() >>> 0) / 4294967296;
      };
      return s.double = function() {
        do
          var e15 = ((n2.next() >>> 11) + (n2.next() >>> 0) / 4294967296) / (1 << 21);
        while (e15 === 0);
        return e15;
      }, s.int32 = n2.next, s.quick = s, o2 && (typeof o2 == "object" && a(o2, n2), s.state = function() {
        return a(n2, {});
      }), s;
    }
    t2 && t2.exports ? t2.exports = o : n && n.amd ? n(function() {
      return o;
    }) : this.tychei = o;
  })(e12, typeof t == "object" && t, typeof define == "function" && define);
}), require___vite_browser_external = /* @__PURE__ */ __commonJSMin((e12, t) => {
  t.exports = {};
}), require_seedrandom$1 = /* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(e13, n, r) {
    var a = 256, o = 6, s = 52, c = "random", l = r.pow(a, o), u = r.pow(2, s), d = u * 2, f = a - 1, p;
    function m(e14, t2, s2) {
      var f2 = [];
      t2 = t2 == 1 ? { entropy: true } : t2 || {};
      var p2 = v(_(t2.entropy ? [e14, b(n)] : e14 ?? y(), 3), f2), m2 = new h(f2), S = function() {
        for (var e15 = m2.g(o), t3 = l, n2 = 0; e15 < u; )
          e15 = (e15 + n2) * a, t3 *= a, n2 = m2.g(1);
        for (; e15 >= d; )
          e15 /= 2, t3 /= 2, n2 >>>= 1;
        return (e15 + n2) / t3;
      };
      return S.int32 = function() {
        return m2.g(4) | 0;
      }, S.quick = function() {
        return m2.g(4) / 4294967296;
      }, S.double = S, v(b(m2.S), n), (t2.pass || s2 || function(e15, t3, n2, a2) {
        return a2 && (a2.S && g(a2, m2), e15.state = function() {
          return g(m2, {});
        }), n2 ? (r[c] = e15, t3) : e15;
      })(S, p2, "global" in t2 ? t2.global : this == r, t2.state);
    }
    function h(e14) {
      var t2, n2 = e14.length, r2 = this, o2 = 0, s2 = r2.i = r2.j = 0, c2 = r2.S = [];
      for (n2 || (e14 = [n2++]); o2 < a; )
        c2[o2] = o2++;
      for (o2 = 0; o2 < a; o2++)
        c2[o2] = c2[s2 = f & s2 + e14[o2 % n2] + (t2 = c2[o2])], c2[s2] = t2;
      (r2.g = function(e15) {
        for (var t3, n3 = 0, o3 = r2.i, s3 = r2.j, c3 = r2.S; e15--; )
          t3 = c3[o3 = f & o3 + 1], n3 = n3 * a + c3[f & (c3[o3] = c3[s3 = f & s3 + t3]) + (c3[s3] = t3)];
        return r2.i = o3, r2.j = s3, n3;
      })(a);
    }
    function g(e14, t2) {
      return t2.i = e14.i, t2.j = e14.j, t2.S = e14.S.slice(), t2;
    }
    function _(e14, t2) {
      var n2 = [], r2 = typeof e14, a2;
      if (t2 && r2 == "object")
        for (a2 in e14)
          try {
            n2.push(_(e14[a2], t2 - 1));
          } catch {
          }
      return n2.length ? n2 : r2 == "string" ? e14 : e14 + "\0";
    }
    function v(e14, t2) {
      for (var n2 = e14 + "", r2, a2 = 0; a2 < n2.length; )
        t2[f & a2] = f & (r2 ^= t2[f & a2] * 19) + n2.charCodeAt(a2++);
      return b(t2);
    }
    function y() {
      try {
        var t2;
        return p && (t2 = p.randomBytes) ? t2 = t2(a) : (t2 = new Uint8Array(a), (e13.crypto || e13.msCrypto).getRandomValues(t2)), b(t2);
      } catch {
        var r2 = e13.navigator, o2 = r2 && r2.plugins;
        return [
          +/* @__PURE__ */ new Date(),
          e13,
          o2,
          e13.screen,
          b(n)
        ];
      }
    }
    function b(e14) {
      return String.fromCharCode.apply(0, e14);
    }
    if (v(r.random(), n), typeof t == "object" && t.exports) {
      t.exports = m;
      try {
        p = require___vite_browser_external();
      } catch {
      }
    } else
      typeof define == "function" && define.amd ? define(function() {
        return m;
      }) : r["seed" + c] = m;
  })(typeof self < "u" ? self : e12, [], Math);
}), require_seedrandom = /* @__PURE__ */ __commonJSMin((e12, t) => {
  var n = require_alea(), r = require_xor128(), a = require_xorwow(), o = require_xorshift7(), s = require_xor4096(), c = require_tychei(), l = require_seedrandom$1();
  l.alea = n, l.xor128 = r, l.xorwow = a, l.xorshift7 = o, l.xor4096 = s, l.tychei = c, t.exports = l;
}), IDENTITY = [
  1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1
], IDENTITY_3X3 = [
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  1
], EPSILON$6 = 1e-6, import_seedrandom$1 = /* @__PURE__ */ __toESM(require_seedrandom(), 1), { vtkErrorMacro: vtkErrorMacro$43, vtkWarningMacro: vtkWarningMacro$10 } = macro, randomSeedValue = 0, VTK_MAX_ROTATIONS = 20;
function notImplemented$6(e12) {
  return () => vtkErrorMacro$43(`vtkMath::${e12} - NOT IMPLEMENTED`);
}
function swapRowsMatrix_nxn(e12, t, n, r) {
  let a;
  for (let o = 0; o < t; o++)
    a = e12[n * t + o], e12[n * t + o] = e12[r * t + o], e12[r * t + o] = a;
}
function swapColumnsMatrix_nxn(e12, t, n, r) {
  let a;
  for (let o = 0; o < t; o++)
    a = e12[o * t + n], e12[o * t + n] = e12[o * t + r], e12[o * t + r] = a;
}
function createArray() {
  let e12 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3, t = Array(e12);
  for (let n = 0; n < e12; ++n)
    t[n] = 0;
  return t;
}
var Pi = () => Math.PI;
function ldexp(e12, t) {
  return t > 1023 ? e12 * 2 ** 1023 * 2 ** (t - 1023) : t < -1074 ? e12 * 2 ** -1074 * 2 ** (t + 1074) : e12 * 2 ** t;
}
function radiansFromDegrees(e12) {
  return e12 / 180 * Math.PI;
}
function degreesFromRadians(e12) {
  return e12 * 180 / Math.PI;
}
var { round, floor, ceil, min, max: max$1 } = Math;
function arrayMin(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, r = Infinity;
  for (let a = t, o = e12.length; a < o; a += n)
    e12[a] < r && (r = e12[a]);
  return r;
}
function arrayMax(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, r = -Infinity;
  for (let a = t, o = e12.length; a < o; a += n)
    r < e12[a] && (r = e12[a]);
  return r;
}
function arrayRange(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, r = Infinity, a = -Infinity;
  for (let o = t, s = e12.length; o < s; o += n)
    e12[o] < r && (r = e12[o]), a < e12[o] && (a = e12[o]);
  return [r, a];
}
var ceilLog2 = notImplemented$6("ceilLog2"), factorial = notImplemented$6("factorial");
function nearestPowerOfTwo(e12) {
  let t = 1;
  for (; t < e12; )
    t *= 2;
  return t;
}
function isPowerOfTwo(e12) {
  return e12 === nearestPowerOfTwo(e12);
}
function binomial(e12, t) {
  let n = 1;
  for (let r = 1; r <= t; ++r)
    n *= (e12 - r + 1) / r;
  return Math.floor(n);
}
function beginCombination(e12, t) {
  if (e12 < t)
    return 0;
  let n = createArray(t);
  for (let e13 = 0; e13 < t; ++e13)
    n[e13] = e13;
  return n;
}
function nextCombination(e12, t, n) {
  let r = 0;
  for (let a = t - 1; a >= 0; --a)
    if (n[a] < e12 - t + a) {
      let e13 = n[a] + 1;
      for (; a < t; )
        n[a++] = e13++;
      r = 1;
      break;
    }
  return r;
}
function randomSeed(e12) {
  (0, import_seedrandom$1.default)(`${e12}`, { global: true }), randomSeedValue = e12;
}
function getSeed() {
  return randomSeedValue;
}
function random() {
  let e12 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  return e12 + ((arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1) - e12) * Math.random();
}
var gaussian = notImplemented$6("gaussian");
function add(e12, t, n) {
  return n[0] = e12[0] + t[0], n[1] = e12[1] + t[1], n[2] = e12[2] + t[2], n;
}
function subtract(e12, t, n) {
  return n[0] = e12[0] - t[0], n[1] = e12[1] - t[1], n[2] = e12[2] - t[2], n;
}
function multiplyScalar(e12, t) {
  return e12[0] *= t, e12[1] *= t, e12[2] *= t, e12;
}
function multiplyScalar2D(e12, t) {
  return e12[0] *= t, e12[1] *= t, e12;
}
function multiplyAccumulate(e12, t, n, r) {
  return r[0] = e12[0] + t[0] * n, r[1] = e12[1] + t[1] * n, r[2] = e12[2] + t[2] * n, r;
}
function multiplyAccumulate2D(e12, t, n, r) {
  return r[0] = e12[0] + t[0] * n, r[1] = e12[1] + t[1] * n, r;
}
function dot(e12, t) {
  return e12[0] * t[0] + e12[1] * t[1] + e12[2] * t[2];
}
function outer(e12, t, n) {
  n[0] = e12[0] * t[0], n[1] = e12[0] * t[1], n[2] = e12[0] * t[2], n[3] = e12[1] * t[0], n[4] = e12[1] * t[1], n[5] = e12[1] * t[2], n[6] = e12[2] * t[0], n[7] = e12[2] * t[1], n[8] = e12[2] * t[2];
}
function cross(e12, t, n) {
  let r = e12[1] * t[2] - e12[2] * t[1], a = e12[2] * t[0] - e12[0] * t[2], o = e12[0] * t[1] - e12[1] * t[0];
  return n[0] = r, n[1] = a, n[2] = o, n;
}
function norm(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
  switch (t) {
    case 1:
      return Math.abs(e12);
    case 2:
      return Math.sqrt(e12[0] * e12[0] + e12[1] * e12[1]);
    case 3:
      return Math.sqrt(e12[0] * e12[0] + e12[1] * e12[1] + e12[2] * e12[2]);
    default: {
      let n = 0;
      for (let r = 0; r < t; r++)
        n += e12[r] * e12[r];
      return Math.sqrt(n);
    }
  }
}
function normalize$1(e12) {
  let t = norm(e12);
  return t !== 0 && (e12[0] /= t, e12[1] /= t, e12[2] /= t), t;
}
function normalize4D(e12) {
  let t = norm(e12, 3);
  return t !== 0 && (e12[0] /= t, e12[1] /= t, e12[2] /= t, e12[3] /= t), t;
}
function perpendiculars(e12, t, n, r) {
  let a = e12[0] * e12[0], o = e12[1] * e12[1], s = e12[2] * e12[2], c = Math.sqrt(a + o + s), l, u, d;
  a > o && a > s ? (l = 0, u = 1, d = 2) : o > s ? (l = 1, u = 2, d = 0) : (l = 2, u = 0, d = 1);
  let f = e12[l] / c, p = e12[u] / c, m = e12[d] / c, h = Math.sqrt(f * f + m * m);
  if (r !== 0) {
    let e13 = Math.sin(r), a2 = Math.cos(r);
    t && (t[l] = (m * a2 - f * p * e13) / h, t[u] = e13 * h, t[d] = (-(f * a2) - p * m * e13) / h), n && (n[l] = (-(m * e13) - f * p * a2) / h, n[u] = a2 * h, n[d] = (f * e13 - p * m * a2) / h);
  } else
    t && (t[l] = m / h, t[u] = 0, t[d] = -f / h), n && (n[l] = -f * p / h, n[u] = h, n[d] = -p * m / h);
}
function projectVector(e12, t, n) {
  let r = dot(t, t);
  if (r === 0)
    return n[0] = 0, n[1] = 0, n[2] = 0, false;
  let a = dot(e12, t) / r;
  for (let e13 = 0; e13 < 3; e13++)
    n[e13] = t[e13];
  return multiplyScalar(n, a), true;
}
function dot2D(e12, t) {
  return e12[0] * t[0] + e12[1] * t[1];
}
function projectVector2D(e12, t, n) {
  let r = dot2D(t, t);
  if (r === 0)
    return n[0] = 0, n[1] = 0, false;
  let a = dot2D(e12, t) / r;
  for (let e13 = 0; e13 < 2; e13++)
    n[e13] = t[e13];
  return multiplyScalar2D(n, a), true;
}
function distance2BetweenPoints(e12, t) {
  return (e12[0] - t[0]) * (e12[0] - t[0]) + (e12[1] - t[1]) * (e12[1] - t[1]) + (e12[2] - t[2]) * (e12[2] - t[2]);
}
function angleBetweenVectors(e12, t) {
  let n = [
    0,
    0,
    0
  ];
  return cross(e12, t, n), Math.atan2(norm(n), dot(e12, t));
}
function gaussianAmplitude(e12, t, n) {
  let r = Math.abs(e12 - n);
  return 1 / Math.sqrt(2 * Math.PI * t) * Math.exp(-(r ** 2) / (2 * t));
}
function gaussianWeight(e12, t, n) {
  let r = Math.abs(e12 - n);
  return Math.exp(-(r ** 2) / (2 * t));
}
function outer2D(e12, t, n) {
  n[0] = e12[0] * t[0], n[1] = e12[0] * t[1], n[2] = e12[1] * t[0], n[3] = e12[1] * t[1];
}
function norm2D(e12) {
  return Math.sqrt(e12[0] * e12[0] + e12[1] * e12[1]);
}
function normalize2D(e12) {
  let t = norm2D(e12);
  return t !== 0 && (e12[0] /= t, e12[1] /= t), t;
}
function determinant2x2() {
  var e12 = [...arguments];
  return e12.length === 2 ? e12[0][0] * e12[1][1] - e12[1][0] * e12[0][1] : e12.length === 4 ? e12[0] * e12[3] - e12[1] * e12[2] : NaN;
}
function LUFactor3x3(e12, t) {
  let n, r, a, o = [
    0,
    0,
    0
  ];
  for (let t2 = 0; t2 < 3; t2++)
    a = Math.abs(e12[t2 * 3]), (r = Math.abs(e12[t2 * 3 + 1])) > a && (a = r), (r = Math.abs(e12[t2 * 3 + 2])) > a && (a = r), o[t2] = 1 / a;
  a = o[0] * Math.abs(e12[0]), n = 0, (r = o[1] * Math.abs(e12[3])) >= a && (a = r, n = 1), (r = o[2] * Math.abs(e12[6])) >= a && (n = 2), n !== 0 && (swapRowsMatrix_nxn(e12, 3, n, 0), o[n] = o[0]), t[0] = n, e12[3] /= e12[0], e12[6] /= e12[0], e12[4] -= e12[3] * e12[1], e12[7] -= e12[6] * e12[1], a = o[1] * Math.abs(e12[4]), n = 1, (r = o[2] * Math.abs(e12[7])) >= a && (n = 2, swapRowsMatrix_nxn(e12, 3, 1, 2), o[2] = o[1]), t[1] = n, e12[7] /= e12[4], e12[5] -= e12[3] * e12[2], e12[8] -= e12[6] * e12[2] + e12[7] * e12[5], t[2] = 2;
}
function LUSolve3x3(e12, t, n) {
  let r = n[t[0]];
  n[t[0]] = n[0], n[0] = r, r = n[t[1]], n[t[1]] = n[1], n[1] = r - e12[3] * n[0], r = n[t[2]], n[t[2]] = n[2], n[2] = r - e12[6] * n[0] - e12[7] * n[1], n[2] /= e12[8], n[1] = (n[1] - e12[5] * n[2]) / e12[4], n[0] = (n[0] - e12[1] * n[1] - e12[2] * n[2]) / e12[0];
}
function linearSolve3x3(e12, t, n) {
  let r = e12[0], a = e12[1], o = e12[2], s = e12[3], c = e12[4], l = e12[5], u = e12[6], d = e12[7], f = e12[8], p = +determinant2x2(c, d, l, f), m = -determinant2x2(s, u, l, f), h = +determinant2x2(s, u, c, d), g = -determinant2x2(a, d, o, f), _ = +determinant2x2(r, u, o, f), v = -determinant2x2(r, u, a, d), y = +determinant2x2(a, c, o, l), b = -determinant2x2(r, s, o, l), S = +determinant2x2(r, s, a, c), C = r * p + a * m + o * h, w = p * t[0] + g * t[1] + y * t[2], T = m * t[0] + _ * t[1] + b * t[2], E = h * t[0] + v * t[1] + S * t[2];
  n[0] = w / C, n[1] = T / C, n[2] = E / C;
}
function multiply3x3_vect3(e12, t, n) {
  let r = e12[0] * t[0] + e12[1] * t[1] + e12[2] * t[2], a = e12[3] * t[0] + e12[4] * t[1] + e12[5] * t[2], o = e12[6] * t[0] + e12[7] * t[1] + e12[8] * t[2];
  n[0] = r, n[1] = a, n[2] = o;
}
function multiply3x3_mat3(e12, t, n) {
  let r = [...e12], a = [...t];
  for (let e13 = 0; e13 < 3; e13++)
    n[e13] = r[0] * a[e13] + r[1] * a[e13 + 3] + r[2] * a[e13 + 6], n[e13 + 3] = r[3] * a[e13] + r[4] * a[e13 + 3] + r[5] * a[e13 + 6], n[e13 + 6] = r[6] * a[e13] + r[7] * a[e13 + 3] + r[8] * a[e13 + 6];
}
function multiplyMatrix(e12, t, n, r, a, o, s) {
  r !== a && vtkErrorMacro$43("Number of columns of A must match number of rows of B.");
  let c = [...e12], l = [...t];
  for (let e13 = 0; e13 < n; e13++)
    for (let t2 = 0; t2 < o; t2++) {
      s[e13 * o + t2] = 0;
      for (let n2 = 0; n2 < r; n2++)
        s[e13 * o + t2] += c[e13 * r + n2] * l[t2 + o * n2];
    }
}
function transpose3x3(e12, t) {
  let n;
  n = e12[3], t[3] = e12[1], t[1] = n, n = e12[6], t[6] = e12[2], t[2] = n, n = e12[7], t[7] = e12[5], t[5] = n, t[0] = e12[0], t[4] = e12[4], t[8] = e12[8];
}
function invert3x3(e12, t) {
  let n = e12[0], r = e12[1], a = e12[2], o = e12[3], s = e12[4], c = e12[5], l = e12[6], u = e12[7], d = e12[8], f = +determinant2x2(s, u, c, d), p = -determinant2x2(o, l, c, d), m = +determinant2x2(o, l, s, u), h = -determinant2x2(r, u, a, d), g = +determinant2x2(n, l, a, d), _ = -determinant2x2(n, l, r, u), v = +determinant2x2(r, s, a, c), y = -determinant2x2(n, o, a, c), b = +determinant2x2(n, o, r, s), S = n * f + r * p + a * m;
  S === 0 && vtkWarningMacro$10("Matrix has 0 determinant"), t[0] = f / S, t[3] = p / S, t[6] = m / S, t[1] = h / S, t[4] = g / S, t[7] = _ / S, t[2] = v / S, t[5] = y / S, t[8] = b / S;
}
function determinant3x3(e12) {
  return e12[0] * e12[4] * e12[8] + e12[3] * e12[7] * e12[2] + e12[6] * e12[1] * e12[5] - e12[0] * e12[7] * e12[5] - e12[3] * e12[1] * e12[8] - e12[6] * e12[4] * e12[2];
}
function areEquals(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : EPSILON$6;
  if (e12.length !== t.length)
    return false;
  function r(e13, r2) {
    return Math.abs(e13 - t[r2]) <= n;
  }
  return e12.every(r);
}
var areMatricesEqual = areEquals;
function identity3x3(e12) {
  for (let t = 0; t < 3; t++)
    e12[t * 3] = e12[t * 3 + 1] = e12[t * 3 + 2] = 0, e12[t * 3 + t] = 1;
}
function identity$1(e12, t) {
  for (let n = 0; n < e12; n++) {
    for (let r = 0; r < e12; r++)
      t[n * e12 + r] = 0;
    t[n * e12 + n] = 1;
  }
  return t;
}
function isIdentity(e12) {
  return areMatricesEqual(e12, IDENTITY, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : EPSILON$6);
}
function isIdentity3x3(e12) {
  return areMatricesEqual(e12, IDENTITY_3X3, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : EPSILON$6);
}
function quaternionToMatrix3x3(e12, t) {
  let n = e12[0] * e12[0], r = e12[0] * e12[1], a = e12[0] * e12[2], o = e12[0] * e12[3], s = e12[1] * e12[1], c = e12[2] * e12[2], l = e12[3] * e12[3], u = e12[1] * e12[2], d = e12[1] * e12[3], f = e12[2] * e12[3], p = s + c + l, m = 1 / (n + p), h = (n - p) * m;
  m *= 2, t[0] = s * m + h, t[3] = (u + o) * m, t[6] = (d - a) * m, t[1] = (u - o) * m, t[4] = c * m + h, t[7] = (f + r) * m, t[2] = (d + a) * m, t[5] = (f - r) * m, t[8] = l * m + h;
}
function roundNumber$1(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!`${e12}`.includes("e"))
    return +`${Math.round(`${e12}e+${t}`)}e-${t}`;
  let n = `${e12}`.split("e"), r = "";
  return +n[1] + t > 0 && (r = "+"), +`${Math.round(`${+n[0]}e${r}${+n[1] + t}`)}e-${t}`;
}
function roundVector(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
    0,
    0,
    0
  ], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  return t[0] = roundNumber$1(e12[0], n), t[1] = roundNumber$1(e12[1], n), t[2] = roundNumber$1(e12[2], n), t;
}
function jacobiN(e12, t, n, r) {
  let a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, S = createArray(t), C = createArray(t), w = (e13, t2, n2) => {
    v = e13[t2], _ = e13[n2], e13[t2] = v - g * (_ + v * m), e13[n2] = _ + g * (v - _ * m);
  };
  for (identity$1(t, r), l = 0; l < t; l++)
    S[l] = n[l] = e12[l + l * t], C[l] = 0;
  for (a = 0; a < VTK_MAX_ROTATIONS; a++) {
    for (h = 0, l = 0; l < t - 1; l++)
      for (c = l + 1; c < t; c++)
        h += Math.abs(e12[l * t + c]);
    if (h === 0)
      break;
    for (d = a < 3 ? 0.2 * h / (t * t) : 0, l = 0; l < t - 1; l++)
      for (c = l + 1; c < t; c++)
        if (v = 100 * Math.abs(e12[l * t + c]), a > 3 && Math.abs(n[l]) + v === Math.abs(n[l]) && Math.abs(n[c]) + v === Math.abs(n[c]))
          e12[l * t + c] = 0;
        else if (Math.abs(e12[l * t + c]) > d) {
          for (_ = n[c] - n[l], Math.abs(_) + v === Math.abs(_) ? p = e12[l * t + c] / _ : (f = 0.5 * _ / e12[l * t + c], p = 1 / (Math.abs(f) + Math.sqrt(1 + f * f)), f < 0 && (p = -p)), y = 1 / Math.sqrt(1 + p * p), g = p * y, m = g / (1 + y), _ = p * e12[l * t + c], C[l] -= _, C[c] += _, n[l] -= _, n[c] += _, e12[l * t + c] = 0, o = 0; o <= l - 1; o++)
            w(e12, o * t + l, o * t + c);
          for (o = l + 1; o <= c - 1; o++)
            w(e12, l * t + o, o * t + c);
          for (o = c + 1; o < t; o++)
            w(e12, l * t + o, c * t + o);
          for (o = 0; o < t; o++)
            w(r, o * t + l, o * t + c);
        }
    for (l = 0; l < t; l++)
      S[l] += C[l], n[l] = S[l], C[l] = 0;
  }
  if (a >= VTK_MAX_ROTATIONS)
    return vtkWarningMacro$10("vtkMath::Jacobi: Error extracting eigenfunctions"), 0;
  for (o = 0; o < t - 1; o++) {
    for (s = o, b = n[s], a = o + 1; a < t; a++)
      (n[a] >= b || Math.abs(n[a] - b) < 1e-12) && (s = a, b = n[s]);
    s !== o && (n[s] = n[o], n[o] = b, swapColumnsMatrix_nxn(r, t, o, s));
  }
  let T = (t >> 1) + (t & 1);
  for (u = 0, a = 0; a < t * t; a++)
    r[a] >= 0 && u++;
  if (u < T)
    for (a = 0; a < t; a++)
      r[a * t + o] *= -1;
  return 1;
}
function matrix3x3ToQuaternion(e12, t) {
  let n = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ];
  n[0] = e12[0] + e12[4] + e12[8], n[5] = e12[0] - e12[4] - e12[8], n[10] = -e12[0] + e12[4] - e12[8], n[15] = -e12[0] - e12[4] + e12[8], n[1] = n[4] = e12[7] - e12[5], n[2] = n[8] = e12[2] - e12[6], n[3] = n[12] = e12[3] - e12[1], n[6] = n[9] = e12[3] + e12[1], n[7] = n[13] = e12[2] + e12[6], n[11] = n[14] = e12[7] + e12[5];
  let r = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ], a = [
    0,
    0,
    0,
    0
  ];
  jacobiN([...n], 4, a, r), t[0] = r[0], t[1] = r[4], t[2] = r[8], t[3] = r[12];
}
function multiplyQuaternion(e12, t, n) {
  let r = e12[0] * t[0], a = e12[0] * t[1], o = e12[0] * t[2], s = e12[0] * t[3], c = e12[1] * t[0], l = e12[1] * t[1], u = e12[1] * t[2], d = e12[1] * t[3], f = e12[2] * t[0], p = e12[2] * t[1], m = e12[2] * t[2], h = e12[2] * t[3], g = e12[3] * t[0], _ = e12[3] * t[1], v = e12[3] * t[2], y = e12[3] * t[3];
  n[0] = r - l - m - y, n[1] = a + c + h - v, n[2] = o - d + f + _, n[3] = s + u - p + g;
}
function orthogonalize3x3(e12, t) {
  for (let n2 = 0; n2 < 9; n2++)
    t[n2] = e12[n2];
  let n = createArray(3), r = createArray(3), a;
  for (let e13 = 0; e13 < 3; e13++) {
    let r2 = Math.abs(t[e13 * 3]), o2 = Math.abs(t[e13 * 3 + 1]), s2 = Math.abs(t[e13 * 3 + 2]);
    a = o2 > r2 ? o2 : r2, a = s2 > a ? s2 : a, n[e13] = 1, a !== 0 && (n[e13] /= a);
  }
  let o = Math.abs(t[0]) * n[0], s = Math.abs(t[3]) * n[1], c = Math.abs(t[6]) * n[2];
  r[0] = 0, a = o, s >= a && (a = s, r[0] = 1), c >= a && (r[0] = 2), r[0] !== 0 && (swapColumnsMatrix_nxn(t, 3, r[0], 0), n[r[0]] = n[0]);
  let l = Math.abs(t[4]) * n[1], u = Math.abs(t[7]) * n[2];
  r[1] = 1, a = l, u >= a && (r[1] = 2, swapColumnsMatrix_nxn(t, 3, 1, 2)), r[2] = 2;
  let d = 0;
  if (determinant3x3(t) < 0) {
    d = 1;
    for (let e13 = 0; e13 < 9; e13++)
      t[e13] = -t[e13];
  }
  let f = createArray(4);
  if (matrix3x3ToQuaternion(t, f), quaternionToMatrix3x3(f, t), d)
    for (let e13 = 0; e13 < 9; e13++)
      t[e13] = -t[e13];
  r[1] !== 1 && swapColumnsMatrix_nxn(t, 3, r[1], 1), r[0] !== 0 && swapColumnsMatrix_nxn(t, 3, r[0], 0);
}
function diagonalize3x3(e12, t, n) {
  let r, a, o, s, c, l;
  if (jacobiN([...e12], 3, t, n), t[0] === t[1] && t[0] === t[2]) {
    identity3x3(n);
    return;
  }
  for (transpose3x3(n, n), r = 0; r < 3; r++)
    if (t[(r + 1) % 3] === t[(r + 2) % 3]) {
      for (l = Math.abs(n[r * 3]), s = 0, a = 1; a < 3; a++)
        l < (c = Math.abs(n[r * 3 + a])) && (l = c, s = a);
      s !== r && (c = t[s], t[s] = t[r], t[r] = c, swapRowsMatrix_nxn(n, 3, r, s)), n[s * 3 + s] < 0 && (n[s * 3] = -n[s * 3], n[s * 3 + 1] = -n[s * 3 + 1], n[s * 3 + 2] = -n[s * 3 + 2]), a = (s + 1) % 3, o = (s + 2) % 3, n[a * 3] = 0, n[a * 3 + 1] = 0, n[a * 3 + 2] = 0, n[a * 3 + a] = 1;
      let e13 = cross([
        n[s * 3],
        n[s * 3 + 1],
        n[s * 3 + 2]
      ], [
        n[a * 3],
        n[a * 3 + 1],
        n[a * 3 + 2]
      ], []);
      normalize$1(e13);
      let u = cross(e13, [
        n[s * 3],
        n[s * 3 + 1],
        n[s * 3 + 2]
      ], []);
      for (let t2 = 0; t2 < 3; t2++)
        n[o * 3 + t2] = e13[t2], n[a * 3 + t2] = u[t2];
      transpose3x3(n, n);
      return;
    }
  for (l = Math.abs(n[0]), s = 0, r = 1; r < 3; r++)
    l < (c = Math.abs(n[r * 3])) && (l = c, s = r);
  if (s !== 0) {
    let e13 = t[s];
    t[s] = t[0], t[0] = e13, swapRowsMatrix_nxn(n, 3, s, 0);
  }
  if (Math.abs(n[4]) < Math.abs(n[7])) {
    let e13 = t[2];
    t[2] = t[1], t[1] = e13, swapRowsMatrix_nxn(n, 3, 1, 2);
  }
  for (r = 0; r < 2; r++)
    n[r * 3 + r] < 0 && (n[r * 3] = -n[r * 3], n[r * 3 + 1] = -n[r * 3 + 1], n[r * 3 + 2] = -n[r * 3 + 2]);
  determinant3x3(n) < 0 && (n[6] = -n[6], n[7] = -n[7], n[8] = -n[8]), transpose3x3(n, n);
}
function singularValueDecomposition3x3(e12, t, n, r) {
  let a, o = [...e12], s = determinant3x3(o);
  if (s < 0)
    for (a = 0; a < 9; a++)
      o[a] = -o[a];
  orthogonalize3x3(o, t), transpose3x3(o, o), multiply3x3_mat3(o, t, r), diagonalize3x3(r, n, r), multiply3x3_mat3(t, r, t), transpose3x3(r, r), s < 0 && (n[0] = -n[0], n[1] = -n[1], n[2] = -n[2]);
}
function luFactorLinearSystem(e12, t, n) {
  let r, a, o, s, c = 0, l, u, d, f = createArray(n);
  for (r = 0; r < n; r++) {
    for (s = 0, a = 0; a < n; a++)
      (d = Math.abs(e12[r * n + a])) > s && (s = d);
    if (s === 0)
      return vtkWarningMacro$10("Unable to factor linear system"), 0;
    f[r] = 1 / s;
  }
  for (a = 0; a < n; a++) {
    for (r = 0; r < a; r++) {
      for (l = e12[r * n + a], o = 0; o < r; o++)
        l -= e12[r * n + o] * e12[o * n + a];
      e12[r * n + a] = l;
    }
    for (s = 0, r = a; r < n; r++) {
      for (l = e12[r * n + a], o = 0; o < a; o++)
        l -= e12[r * n + o] * e12[o * n + a];
      e12[r * n + a] = l, (u = f[r] * Math.abs(l)) >= s && (s = u, c = r);
    }
    if (a !== c) {
      for (o = 0; o < n; o++)
        u = e12[c * n + o], e12[c * n + o] = e12[a * n + o], e12[a * n + o] = u;
      f[c] = f[a];
    }
    if (t[a] = c, Math.abs(e12[a * n + a]) <= 1e-12)
      return vtkWarningMacro$10("Unable to factor linear system"), 0;
    if (a !== n - 1)
      for (u = 1 / e12[a * n + a], r = a + 1; r < n; r++)
        e12[r * n + a] *= u;
  }
  return 1;
}
function luSolveLinearSystem(e12, t, n, r) {
  let a, o, s, c, l;
  for (s = -1, a = 0; a < r; a++) {
    if (c = t[a], l = n[c], n[c] = n[a], s >= 0)
      for (o = s; o <= a - 1; o++)
        l -= e12[a * r + o] * n[o];
    else
      l !== 0 && (s = a);
    n[a] = l;
  }
  for (a = r - 1; a >= 0; a--) {
    for (l = n[a], o = a + 1; o < r; o++)
      l -= e12[a * r + o] * n[o];
    n[a] = l / e12[a * r + a];
  }
}
function solveLinearSystem(e12, t, n) {
  if (n === 2) {
    let n2 = createArray(2), r2 = determinant2x2(e12[0], e12[1], e12[2], e12[3]);
    return r2 === 0 ? 0 : (n2[0] = (e12[3] * t[0] - e12[1] * t[1]) / r2, n2[1] = (-(e12[2] * t[0]) + e12[0] * t[1]) / r2, t[0] = n2[0], t[1] = n2[1], 1);
  }
  if (n === 1)
    return e12[0] === 0 ? 0 : (t[0] /= e12[0], 1);
  let r = createArray(n);
  return luFactorLinearSystem(e12, r, n) === 0 ? 0 : (luSolveLinearSystem(e12, r, t, n), 1);
}
function invertMatrix(e12, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, o = r || createArray(n), s = a || createArray(n);
  if (luFactorLinearSystem(e12, o, n) === 0)
    return null;
  for (let r2 = 0; r2 < n; r2++) {
    for (let e13 = 0; e13 < n; e13++)
      s[e13] = 0;
    s[r2] = 1, luSolveLinearSystem(e12, o, s, n);
    for (let e13 = 0; e13 < n; e13++)
      t[e13 * n + r2] = s[e13];
  }
  return t;
}
function estimateMatrixCondition(e12, t) {
  let n = +Number.MAX_VALUE, r = -Number.MAX_VALUE;
  for (let n2 = 0; n2 < t; n2++)
    for (let a = n2; a < t; a++)
      Math.abs(e12[n2 * t + a]) > r && (r = Math.abs(e12[n2 * t + a]));
  for (let r2 = 0; r2 < t; r2++)
    Math.abs(e12[r2 * t + r2]) < n && (n = Math.abs(e12[r2 * t + r2]));
  return n === 0 ? Number.MAX_VALUE : r / n;
}
function jacobi(e12, t, n) {
  return jacobiN(e12, 3, t, n);
}
function solveHomogeneousLeastSquares(e12, t, n, r) {
  if (e12 < n)
    return vtkWarningMacro$10("Insufficient number of samples. Underdetermined."), 0;
  let a, o, s, c = createArray(n * n), l = createArray(n), u = createArray(n * n);
  for (s = 0; s < e12; s++)
    for (a = 0; a < n; a++)
      for (o = a; o < n; o++)
        c[a * n + o] += t[s * n + a] * t[s * n + o];
  for (a = 0; a < n; a++)
    for (o = 0; o < a; o++)
      c[a * n + o] = c[o * n + a];
  for (jacobiN(c, n, l, u), a = 0; a < n; a++)
    r[a] = u[a * n + n - 1];
  return 1;
}
function solveLeastSquares(e12, t, n, r, a, o) {
  let s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : true;
  if (e12 < n || e12 < a)
    return vtkWarningMacro$10("Insufficient number of samples. Underdetermined."), 0;
  let c = createArray(a), l = 1, u, d = 0, f, p, m, h = 0;
  if (s) {
    for (p = 0; p < a; p++)
      c[p] = 1;
    for (f = 0; f < e12; f++)
      for (p = 0; p < a; p++)
        Math.abs(r[f * a + p]) > 1e-12 && (l = 0, c[p] = 0);
    if (l && a === 1)
      return vtkWarningMacro$10("Detected homogeneous system (Y=0), calling SolveHomogeneousLeastSquares()"), solveHomogeneousLeastSquares(e12, t, n, o);
    if (l)
      h = 1;
    else
      for (p = 0; p < a; p++)
        c[p] && (h = 1);
  }
  h && (u = createArray(n), d = solveHomogeneousLeastSquares(e12, t, n, u));
  let g = createArray(n * n), _ = createArray(n * n), v = createArray(n * a);
  for (m = 0; m < e12; m++)
    for (f = 0; f < n; f++) {
      for (p = f; p < n; p++)
        g[f * n + p] += t[m * n + f] * t[m * n + p];
      for (p = 0; p < a; p++)
        v[f * a + p] += t[m * n + f] * r[m * a + p];
    }
  for (f = 0; f < n; f++)
    for (p = 0; p < f; p++)
      g[f * n + p] = g[p * n + f];
  let y = invertMatrix(g, _, n);
  if (y)
    for (f = 0; f < n; f++)
      for (p = 0; p < a; p++)
        for (o[f * a + p] = 0, m = 0; m < n; m++)
          o[f * a + p] += _[f * n + m] * v[m * a + p];
  if (h) {
    for (p = 0; p < a; p++)
      if (c[p])
        for (f = 0; f < n; f++)
          o[f * a + p] = u[f * a];
  }
  return h ? d && y : y;
}
function hex2float(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
    0,
    0.5,
    1
  ];
  switch (e12.length) {
    case 3:
      return t[0] = parseInt(e12[0], 16) * 17 / 255, t[1] = parseInt(e12[1], 16) * 17 / 255, t[2] = parseInt(e12[2], 16) * 17 / 255, t;
    case 4:
      return t[0] = parseInt(e12[1], 16) * 17 / 255, t[1] = parseInt(e12[2], 16) * 17 / 255, t[2] = parseInt(e12[3], 16) * 17 / 255, t;
    case 6:
      return t[0] = parseInt(e12.substr(0, 2), 16) / 255, t[1] = parseInt(e12.substr(2, 2), 16) / 255, t[2] = parseInt(e12.substr(4, 2), 16) / 255, t;
    case 7:
      return t[0] = parseInt(e12.substr(1, 2), 16) / 255, t[1] = parseInt(e12.substr(3, 2), 16) / 255, t[2] = parseInt(e12.substr(5, 2), 16) / 255, t;
    case 9:
      return t[0] = parseInt(e12.substr(1, 2), 16) / 255, t[1] = parseInt(e12.substr(3, 2), 16) / 255, t[2] = parseInt(e12.substr(5, 2), 16) / 255, t[3] = parseInt(e12.substr(7, 2), 16) / 255, t;
    default:
      return t;
  }
}
function rgb2hsv(e12, t) {
  let n, r, [a, o, s] = e12, c = 1 / 6, l = a, u = a;
  o > l ? l = o : o < u && (u = o), s > l ? l = s : s < u && (u = s);
  let d = l;
  r = d > 0 ? (l - u) / l : 0, r > 0 ? (n = a === l ? c * (o - s) / (l - u) : o === l ? 0.3333333333333333 + c * (s - a) / (l - u) : 0.6666666666666666 + c * (a - o) / (l - u), n < 0 && (n += 1)) : n = 0, t[0] = n, t[1] = r, t[2] = d;
}
function hsv2rgb(e12, t) {
  let [n, r, a] = e12, o = 1 / 3, s = 1 / 6, c = 2 / 3, l = 5 / 6, u, d, f;
  n > s && n <= o ? (d = 1, u = (o - n) / s, f = 0) : n > o && n <= 0.5 ? (d = 1, f = (n - o) / s, u = 0) : n > 0.5 && n <= c ? (f = 1, d = (c - n) / s, u = 0) : n > c && n <= l ? (f = 1, u = (n - c) / s, d = 0) : n > l && n <= 1 ? (u = 1, f = (1 - n) / s, d = 0) : (u = 1, d = n / s, f = 0), u = r * u + (1 - r), d = r * d + (1 - r), f = r * f + (1 - r), u *= a, d *= a, f *= a, t[0] = u, t[1] = d, t[2] = f;
}
function lab2xyz(e12, t) {
  let [n, r, a] = e12, o = (n + 16) / 116, s = r / 500 + o, c = o - a / 200;
  o ** 3 > 8856e-6 ? o **= 3 : o = (o - 16 / 116) / 7.787, s ** 3 > 8856e-6 ? s **= 3 : s = (s - 16 / 116) / 7.787, c ** 3 > 8856e-6 ? c **= 3 : c = (c - 16 / 116) / 7.787, t[0] = 0.9505 * s, t[1] = 1 * o, t[2] = 1.089 * c;
}
function xyz2lab(e12, t) {
  let [n, r, a] = e12, o = n / 0.9505, s = r / 1, c = a / 1.089;
  o > 8856e-6 ? o **= 1 / 3 : o = 7.787 * o + 16 / 116, s > 8856e-6 ? s **= 1 / 3 : s = 7.787 * s + 16 / 116, c > 8856e-6 ? c **= 1 / 3 : c = 7.787 * c + 16 / 116, t[0] = 116 * s - 16, t[1] = 500 * (o - s), t[2] = 200 * (s - c);
}
function xyz2rgb(e12, t) {
  let [n, r, a] = e12, o = n * 3.2406 + r * -1.5372 + a * -0.4986, s = n * -0.9689 + r * 1.8758 + a * 0.0415, c = n * 0.0557 + r * -0.204 + a * 1.057;
  o > 31308e-7 ? o = 1.055 * o ** (1 / 2.4) - 0.055 : o *= 12.92, s > 31308e-7 ? s = 1.055 * s ** (1 / 2.4) - 0.055 : s *= 12.92, c > 31308e-7 ? c = 1.055 * c ** (1 / 2.4) - 0.055 : c *= 12.92;
  let l = o;
  l < s && (l = s), l < c && (l = c), l > 1 && (o /= l, s /= l, c /= l), o < 0 && (o = 0), s < 0 && (s = 0), c < 0 && (c = 0), t[0] = o, t[1] = s, t[2] = c;
}
function rgb2xyz(e12, t) {
  let [n, r, a] = e12;
  n > 0.04045 ? n = ((n + 0.055) / 1.055) ** 2.4 : n /= 12.92, r > 0.04045 ? r = ((r + 0.055) / 1.055) ** 2.4 : r /= 12.92, a > 0.04045 ? a = ((a + 0.055) / 1.055) ** 2.4 : a /= 12.92, t[0] = n * 0.4124 + r * 0.3576 + a * 0.1805, t[1] = n * 0.2126 + r * 0.7152 + a * 0.0722, t[2] = n * 0.0193 + r * 0.1192 + a * 0.9505;
}
function rgb2lab(e12, t) {
  let n = [
    0,
    0,
    0
  ];
  rgb2xyz(e12, n), xyz2lab(n, t);
}
function lab2rgb(e12, t) {
  let n = [
    0,
    0,
    0
  ];
  lab2xyz(e12, n), xyz2rgb(n, t);
}
function uninitializeBounds(e12) {
  return e12[0] = 1, e12[1] = -1, e12[2] = 1, e12[3] = -1, e12[4] = 1, e12[5] = -1, e12;
}
function areBoundsInitialized(e12) {
  return !(e12[1] - e12[0] < 0);
}
function computeBoundsFromPoints(e12, t, n) {
  return n[0] = Math.min(e12[0], t[0]), n[1] = Math.max(e12[0], t[0]), n[2] = Math.min(e12[1], t[1]), n[3] = Math.max(e12[1], t[1]), n[4] = Math.min(e12[2], t[2]), n[5] = Math.max(e12[2], t[2]), n;
}
function clampValue(e12, t, n) {
  return e12 < t ? t : e12 > n ? n : e12;
}
function clampVector(e12, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [
    0,
    0,
    0
  ];
  return r[0] = clampValue(e12[0], t[0], n[0]), r[1] = clampValue(e12[1], t[1], n[1]), r[2] = clampValue(e12[2], t[2], n[2]), r;
}
function clampAndNormalizeValue(e12, t) {
  let n = 0;
  return t[0] !== t[1] && (n = e12 < t[0] ? t[0] : e12 > t[1] ? t[1] : e12, n = (n - t[0]) / (t[1] - t[0])), n;
}
var getScalarTypeFittingRange = notImplemented$6("GetScalarTypeFittingRange"), getAdjustedScalarRange = notImplemented$6("GetAdjustedScalarRange");
function extentIsWithinOtherExtent(e12, t) {
  if (!e12 || !t)
    return 0;
  for (let n = 0; n < 6; n += 2)
    if (e12[n] < t[n] || e12[n] > t[n + 1] || e12[n + 1] < t[n] || e12[n + 1] > t[n + 1])
      return 0;
  return 1;
}
function boundsIsWithinOtherBounds(e12, t, n) {
  if (!e12 || !t)
    return 0;
  for (let r = 0; r < 6; r += 2)
    if (e12[r] + n[r / 2] < t[r] || e12[r] - n[r / 2] > t[r + 1] || e12[r + 1] + n[r / 2] < t[r] || e12[r + 1] - n[r / 2] > t[r + 1])
      return 0;
  return 1;
}
function pointIsWithinBounds(e12, t, n) {
  if (!e12 || !t || !n)
    return 0;
  for (let r = 0; r < 3; r++)
    if (e12[r] + n[r] < t[2 * r] || e12[r] - n[r] > t[2 * r + 1])
      return 0;
  return 1;
}
function solve3PointCircle(e12, t, n, r) {
  let a = createArray(3), o = createArray(3), s = createArray(3), c = createArray(3), l = createArray(3), u = createArray(3);
  for (let r2 = 0; r2 < 3; ++r2)
    a[r2] = e12[r2] - t[r2], o[r2] = t[r2] - n[r2], s[r2] = n[r2] - e12[r2], c[r2] = -a[r2], l[r2] = -o[r2], u[r2] = -s[r2];
  let d = norm(c), f = norm(l), p = norm(s), m = createArray(3);
  cross(a, o, m);
  let h = norm(m), g = d * f * p / (2 * h), _ = 2 * h * h, v = f * f * dot(a, u) / _, y = p * p * dot(c, o) / _, b = d * d * dot(s, l) / _;
  for (let a2 = 0; a2 < 3; ++a2)
    r[a2] = v * e12[a2] + y * t[a2] + b * n[a2];
  return g;
}
var inf = Infinity, negInf = -Infinity, isInf = (e12) => !Number.isFinite(e12), { isFinite: isFinite$1, isNaN: isNaN$1 } = Number, isNan = isNaN$1;
function createUninitializedBounds() {
  return [
    Number.MAX_VALUE,
    -Number.MAX_VALUE,
    Number.MAX_VALUE,
    -Number.MAX_VALUE,
    Number.MAX_VALUE,
    -Number.MAX_VALUE
  ];
}
function getMajorAxisIndex(e12) {
  let t = -1, n = -1;
  for (let r = 0; r < e12.length; r++) {
    let a = Math.abs(e12[r]);
    a > t && (n = r, t = a);
  }
  return n;
}
function getSparseOrthogonalMatrix(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, n = Array(t), r = Array(t);
  for (let e13 = 0; e13 < t; ++e13)
    n[e13] = e13, r[e13] = e13;
  for (let a2 = t - 1; a2 > 0; a2--) {
    let o = -Infinity, s = 0, c = 0;
    for (let l = 0; l <= a2; ++l) {
      let u = n[l];
      for (let n2 = 0; n2 <= a2; ++n2) {
        let a3 = r[n2], d = Math.abs(e12[u + t * a3]);
        d > o && (o = d, s = l, c = n2);
      }
    }
    [n[a2], n[s]] = [n[s], n[a2]], [r[a2], r[c]] = [r[c], r[a2]];
  }
  let a = Array(t * t).fill(0);
  for (let o = 0; o < t; ++o) {
    let s = n[o] + t * r[o];
    a[s] = e12[s] < 0 ? -1 : 1;
  }
  return a;
}
function floatToHex2(e12) {
  let t = Math.floor(e12 * 255);
  return t > 15 ? t.toString(16) : `0${t.toString(16)}`;
}
function floatRGB2HexCode(e12) {
  return `${arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "#"}${e12.map(floatToHex2).join("")}`;
}
function floatToChar(e12) {
  return Math.round(e12 * 255);
}
function float2CssRGBA(e12) {
  return e12.length === 3 ? `rgb(${e12.map(floatToChar).join(", ")})` : `rgba(${floatToChar(e12[0] || 0)}, ${floatToChar(e12[1] || 0)}, ${floatToChar(e12[2] || 0)}, ${e12[3] || 0})`;
}
var vtkMath = {
  Pi,
  ldexp,
  radiansFromDegrees,
  degreesFromRadians,
  round,
  floor,
  ceil,
  ceilLog2,
  min,
  max: max$1,
  arrayMin,
  arrayMax,
  arrayRange,
  isPowerOfTwo,
  nearestPowerOfTwo,
  factorial,
  binomial,
  beginCombination,
  nextCombination,
  randomSeed,
  getSeed,
  random,
  gaussian,
  add,
  subtract,
  multiplyScalar,
  multiplyScalar2D,
  multiplyAccumulate,
  multiplyAccumulate2D,
  dot,
  outer,
  cross,
  norm,
  normalize: normalize$1,
  perpendiculars,
  projectVector,
  projectVector2D,
  distance2BetweenPoints,
  angleBetweenVectors,
  gaussianAmplitude,
  gaussianWeight,
  dot2D,
  outer2D,
  norm2D,
  normalize2D,
  determinant2x2,
  LUFactor3x3,
  LUSolve3x3,
  linearSolve3x3,
  multiply3x3_vect3,
  multiply3x3_mat3,
  multiplyMatrix,
  transpose3x3,
  invert3x3,
  identity3x3,
  identity: identity$1,
  isIdentity,
  isIdentity3x3,
  determinant3x3,
  quaternionToMatrix3x3,
  areEquals,
  areMatricesEqual,
  roundNumber: roundNumber$1,
  roundVector,
  matrix3x3ToQuaternion,
  multiplyQuaternion,
  orthogonalize3x3,
  diagonalize3x3,
  singularValueDecomposition3x3,
  solveLinearSystem,
  invertMatrix,
  luFactorLinearSystem,
  luSolveLinearSystem,
  estimateMatrixCondition,
  jacobi,
  jacobiN,
  solveHomogeneousLeastSquares,
  solveLeastSquares,
  hex2float,
  rgb2hsv,
  hsv2rgb,
  lab2xyz,
  xyz2lab,
  xyz2rgb,
  rgb2xyz,
  rgb2lab,
  lab2rgb,
  uninitializeBounds,
  areBoundsInitialized,
  computeBoundsFromPoints,
  clampValue,
  clampVector,
  clampAndNormalizeValue,
  getScalarTypeFittingRange,
  getAdjustedScalarRange,
  extentIsWithinOtherExtent,
  boundsIsWithinOtherBounds,
  pointIsWithinBounds,
  solve3PointCircle,
  inf,
  negInf,
  isInf,
  isNan: isNaN$1,
  isNaN: isNaN$1,
  isFinite: isFinite$1,
  createUninitializedBounds,
  getMajorAxisIndex,
  getSparseOrthogonalMatrix,
  floatToHex2,
  floatRGB2HexCode,
  float2CssRGBA
}, DataTypeByteSize = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
}, VtkDataTypes = {
  VOID: "",
  CHAR: "Int8Array",
  SIGNED_CHAR: "Int8Array",
  UNSIGNED_CHAR: "Uint8Array",
  UNSIGNED_CHAR_CLAMPED: "Uint8ClampedArray",
  SHORT: "Int16Array",
  UNSIGNED_SHORT: "Uint16Array",
  INT: "Int32Array",
  UNSIGNED_INT: "Uint32Array",
  FLOAT: "Float32Array",
  DOUBLE: "Float64Array"
}, Constants$19 = {
  DefaultDataType: VtkDataTypes.FLOAT,
  DataTypeByteSize,
  VtkDataTypes
}, { vtkErrorMacro: vtkErrorMacro$42 } = macro$1, { DefaultDataType } = Constants$19, EPSILON$5 = 1e-6;
function fastComputeRange(e12, t, n) {
  let r = e12.length, a = Number.MAX_VALUE, o = -Number.MAX_VALUE, s, c;
  for (c = t; c < r; c += n)
    if (!Number.isNaN(e12[c])) {
      a = e12[c], o = a;
      break;
    }
  for (; c < r; c += n)
    s = e12[c], s < a ? a = s : s > o && (o = s);
  return {
    min: a,
    max: o
  };
}
function createRangeHelper() {
  let e12 = Number.MAX_VALUE, t = -Number.MAX_VALUE, n = 0, r = 0;
  return {
    add(a) {
      e12 > a && (e12 = a), t < a && (t = a), n++, r += a;
    },
    get() {
      return {
        min: e12,
        max: t,
        count: n,
        sum: r,
        mean: r / n
      };
    },
    getRange() {
      return {
        min: e12,
        max: t
      };
    }
  };
}
function computeRange(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  if (t < 0 && n > 1) {
    let t2 = e12.length / n, r = new Float64Array(t2);
    for (let a = 0, o = 0; a < t2; ++a) {
      for (let t3 = o + n; o < t3; ++o)
        r[a] += e12[o] * e12[o];
      r[a] **= 0.5;
    }
    return fastComputeRange(r, 0, 1);
  }
  return fastComputeRange(e12, t < 0 ? 0 : t, n);
}
function ensureRangeSize(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = e12 || [];
  for (; n.length <= t; )
    n.push(null);
  return n;
}
function getDataType(e12) {
  return Object.prototype.toString.call(e12).slice(8, -1);
}
function getMaxNorm(e12) {
  let t = e12.getNumberOfComponents(), n = 0, r = Array(t);
  for (let a = 0; a < e12.getNumberOfTuples(); ++a) {
    e12.getTuple(a, r);
    let o = norm(r, t);
    o > n && (n = o);
  }
  return n;
}
var STATIC$14 = {
  computeRange,
  createRangeHelper,
  fastComputeRange,
  getDataType,
  getMaxNorm
};
function vtkDataArray(e12, t) {
  t.classHierarchy.push("vtkDataArray");
  function n(n2) {
    if (n2 < 0)
      return false;
    let r = e12.getNumberOfComponents(), a = t.values.length / (r > 0 ? r : 1);
    if (n2 === a)
      return true;
    if (n2 > a) {
      let e13 = t.values;
      return t.values = newTypedArray(t.dataType, (n2 + a) * r), t.values.set(e13), true;
    }
    return t.size > n2 * r && (t.size = n2 * r, e12.dataChange()), true;
  }
  e12.dataChange = () => {
    t.ranges = null, e12.modified();
  }, e12.allocate = (t2) => {
    n(e12.getNumberOfTuples() + t2);
  }, e12.resize = (r) => {
    n(r);
    let a = r * e12.getNumberOfComponents();
    return t.size === a ? false : (t.size = a, e12.dataChange(), true);
  }, e12.initialize = () => (e12.resize(0), e12), e12.getElementComponentSize = () => t.values.BYTES_PER_ELEMENT, e12.getComponent = function(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return t.values[e13 * t.numberOfComponents + n2];
  }, e12.setComponent = (n2, r, a) => {
    a !== t.values[n2 * t.numberOfComponents + r] && (t.values[n2 * t.numberOfComponents + r] = a, e12.dataChange());
  }, e12.getValue = (n2) => {
    let r = n2 / t.numberOfComponents, a = n2 % t.numberOfComponents;
    return e12.getComponent(r, a);
  }, e12.setValue = (n2, r) => {
    let a = n2 / t.numberOfComponents, o = n2 % t.numberOfComponents;
    e12.setComponent(a, o, r);
  }, e12.getData = () => t.size === t.values.length ? t.values : t.values.subarray(0, t.size), e12.getRange = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, r = n2;
    r < 0 && (r = t.numberOfComponents === 1 ? 0 : t.numberOfComponents);
    let a = null;
    return t.ranges ||= ensureRangeSize(t.ranges, t.numberOfComponents), a = t.ranges[r], a ? (t.rangeTuple[0] = a.min, t.rangeTuple[1] = a.max, t.rangeTuple) : (a = computeRange(e12.getData(), n2, t.numberOfComponents), t.ranges[r] = a, t.rangeTuple[0] = a.min, t.rangeTuple[1] = a.max, t.rangeTuple);
  }, e12.setRange = (e13, n2) => {
    t.ranges ||= ensureRangeSize(t.ranges, t.numberOfComponents);
    let r = {
      min: e13.min,
      max: e13.max
    };
    return t.ranges[n2] = r, t.rangeTuple[0] = r.min, t.rangeTuple[1] = r.max, t.rangeTuple;
  }, e12.getRanges = function() {
    if (!(!(arguments.length > 0 && arguments[0] !== void 0) || arguments[0]))
      return structuredClone(t.ranges);
    let n2 = [];
    for (let r = 0; r < t.numberOfComponents; r++) {
      let [t2, a] = e12.getRange(r), o = {
        min: t2,
        max: a
      };
      n2.push(o);
    }
    if (t.numberOfComponents > 1) {
      let [t2, r] = e12.getRange(-1), a = {
        min: t2,
        max: r
      };
      n2.push(a);
    }
    return n2;
  }, e12.setTuple = (e13, n2) => {
    let r = e13 * t.numberOfComponents;
    for (let e14 = 0; e14 < t.numberOfComponents; e14++)
      t.values[r + e14] = n2[e14];
  }, e12.setTuples = (e13, n2) => {
    let r = e13 * t.numberOfComponents, a = Math.min(n2.length, t.size - r);
    for (let e14 = 0; e14 < a; )
      t.values[r++] = n2[e14++];
  }, e12.insertTuple = (r, a) => (t.size <= r * t.numberOfComponents && (t.size = (r + 1) * t.numberOfComponents, n(r + 1)), e12.setTuple(r, a), r), e12.insertTuples = (r, a) => {
    let o = r + a.length / t.numberOfComponents;
    return t.size < o * t.numberOfComponents && (t.size = o * t.numberOfComponents, n(o)), e12.setTuples(r, a), o;
  }, e12.insertNextTuple = (n2) => {
    let r = t.size / t.numberOfComponents;
    return e12.insertTuple(r, n2);
  }, e12.insertNextTuples = (n2) => {
    let r = t.size / t.numberOfComponents;
    return e12.insertTuples(r, n2);
  }, e12.findTuple = function(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : EPSILON$5;
    for (let r = 0; r < t.size; r += t.numberOfComponents)
      if (Math.abs(e13[0] - t.values[r]) <= n2) {
        let a = true;
        for (let o = 1; o < t.numberOfComponents; ++o)
          if (Math.abs(e13[o] - t.values[r + o]) > n2) {
            a = false;
            break;
          }
        if (a)
          return r / t.numberOfComponents;
      }
    return -1;
  }, e12.getTuple = function(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = t.numberOfComponents || 1, a = e13 * r;
    switch (r) {
      case 4:
        n2[3] = t.values[a + 3];
      case 3:
        n2[2] = t.values[a + 2];
      case 2:
        n2[1] = t.values[a + 1];
      case 1:
        n2[0] = t.values[a];
        break;
      default:
        for (let e14 = r - 1; e14 >= 0; --e14)
          n2[e14] = t.values[a + e14];
    }
    return n2;
  }, e12.getTuples = (n2, r) => {
    let a = (n2 ?? 0) * t.numberOfComponents, o = (r ?? e12.getNumberOfTuples()) * t.numberOfComponents, s = e12.getData().subarray(a, o);
    return s.length > 0 ? s : null;
  }, e12.getTupleLocation = function() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1) * t.numberOfComponents;
  }, e12.getNumberOfComponents = () => t.numberOfComponents, e12.getNumberOfValues = () => t.size, e12.getNumberOfTuples = () => t.size / t.numberOfComponents, e12.getDataType = () => t.dataType, e12.newClone = () => newInstance$135({
    empty: true,
    name: t.name,
    dataType: t.dataType,
    numberOfComponents: t.numberOfComponents
  }), e12.getName = () => (t.name ||= (e12.modified(), `vtkDataArray${e12.getMTime()}`), t.name), e12.setData = (n2, r) => {
    t.values = n2, t.size = n2.length, t.dataType = getDataType(n2), r && (t.numberOfComponents = r), t.size % t.numberOfComponents !== 0 && (t.numberOfComponents = 1), e12.dataChange();
  }, e12.getState = () => {
    if (t.deleted)
      return null;
    let n2 = {
      ...t,
      vtkClass: e12.getClassName()
    };
    n2.values = Array.from(n2.values), delete n2.buffer, Object.keys(n2).forEach((e13) => {
      n2[e13] || delete n2[e13];
    });
    let r = {};
    return Object.keys(n2).sort().forEach((e13) => {
      r[e13] = n2[e13];
    }), r.mtime && delete r.mtime, r;
  }, e12.deepCopy = (n2) => {
    let r = e12.getDataType(), a = t.values;
    e12.shallowCopy(n2), t.ranges = structuredClone(n2.getRanges()), a?.length >= n2.getNumberOfValues() && r === n2.getDataType() ? (a.set(n2.getData()), t.values = a, e12.dataChange()) : e12.setData(n2.getData().slice());
  }, e12.interpolateTuple = (n2, r, a, o, s, c) => {
    let l = t.numberOfComponents || 1;
    (l !== r.getNumberOfComponents() || l !== o.getNumberOfComponents()) && vtkErrorMacro$42("numberOfComponents must match");
    let u = r.getTuple(a), d = o.getTuple(s), f = [];
    switch (f.length = l, l) {
      case 4:
        f[3] = u[3] + (d[3] - u[3]) * c;
      case 3:
        f[2] = u[2] + (d[2] - u[2]) * c;
      case 2:
        f[1] = u[1] + (d[1] - u[1]) * c;
      case 1:
        f[0] = u[0] + (d[0] - u[0]) * c;
        break;
      default:
        for (let e13 = 0; e13 < l; e13++)
          f[e13] = u[e13] + (d[e13] - u[e13]) * c;
    }
    return e12.insertTuple(n2, f);
  };
}
var DEFAULT_VALUES$130 = {
  name: "",
  numberOfComponents: 1,
  dataType: DefaultDataType,
  rangeTuple: [0, 0]
};
function extend$141(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (Object.assign(t, DEFAULT_VALUES$130, n), Array.isArray(n.values) && n.dataType === void 0 && console.warn("vtkDataArray.newInstance: no dataType provided, converting to Float32Array"), !t.empty && !t.values && !t.size)
    throw TypeError("Cannot create vtkDataArray object without: size > 0, values");
  if (t.values ? Array.isArray(t.values) && (t.values = newTypedArrayFrom(t.dataType, t.values)) : t.values = newTypedArray(t.dataType, t.size), t.values && (t.size = t.size ?? t.values.length, t.dataType = getDataType(t.values)), obj(e12, t), set$1(e12, t, ["name", "numberOfComponents"]), t.size % t.numberOfComponents !== 0)
    throw RangeError("model.size is not a multiple of model.numberOfComponents");
  vtkDataArray(e12, t);
}
var newInstance$135 = newInstance(extend$141, "vtkDataArray"), vtkDataArray$1 = {
  newInstance: newInstance$135,
  extend: extend$141,
  ...STATIC$14,
  ...Constants$19
}, VectorMode$3 = {
  MAGNITUDE: 0,
  COMPONENT: 1,
  RGBCOLORS: 2
}, ScalarMappingTarget = {
  LUMINANCE: 1,
  LUMINANCE_ALPHA: 2,
  RGB: 3,
  RGBA: 4
}, vtkScalarsToColors = {
  VectorMode: VectorMode$3,
  ScalarMappingTarget,
  Scale: {
    LINEAR: 0,
    LOG10: 1
  }
}, Constants$6 = {
  ColorMode: {
    DEFAULT: 0,
    MAP_SCALARS: 1,
    DIRECT_SCALARS: 2
  },
  GetArray: {
    BY_ID: 0,
    BY_NAME: 1
  },
  ScalarMode: {
    DEFAULT: 0,
    USE_POINT_DATA: 1,
    USE_CELL_DATA: 2,
    USE_POINT_FIELD_DATA: 3,
    USE_CELL_FIELD_DATA: 4,
    USE_FIELD_DATA: 5
  }
}, { ScalarMappingTarget: ScalarMappingTarget$2, Scale: Scale$2, VectorMode: VectorMode$2 } = vtkScalarsToColors, { VtkDataTypes: VtkDataTypes$4 } = vtkDataArray$1, { ColorMode: ColorMode$1 } = Constants$6, { vtkErrorMacro: vtkErrorMacro$41 } = macro;
function intColorToUChar(e12) {
  return e12;
}
function floatColorToUChar(e12) {
  return Math.floor(e12 * 255 + 0.5);
}
function vtkScalarsToColors$2(e12, t) {
  t.classHierarchy.push("vtkScalarsToColors"), e12.setVectorModeToMagnitude = () => e12.setVectorMode(VectorMode$2.MAGNITUDE), e12.setVectorModeToComponent = () => e12.setVectorMode(VectorMode$2.COMPONENT), e12.setVectorModeToRGBColors = () => e12.setVectorMode(VectorMode$2.RGBCOLORS), e12.build = () => {
  }, e12.isOpaque = () => true, e12.setAnnotations = (n, r) => {
    if (!(n && !r || !n && r)) {
      if (n && r && n.length !== r.length) {
        vtkErrorMacro$41("Values and annotations do not have the same number of tuples so ignoring");
        return;
      }
      if (t.annotationArray = [], r && n) {
        let e13 = r.length;
        for (let a = 0; a < e13; a++)
          t.annotationArray.push({
            value: n[a],
            annotation: String(r[a])
          });
      }
      e12.updateAnnotatedValueMap(), e12.modified();
    }
  }, e12.setAnnotation = (n, r) => {
    let a = e12.checkForAnnotatedValue(n), o = false;
    return a >= 0 ? t.annotationArray[a].annotation !== r && (t.annotationArray[a].annotation = r, o = true) : (t.annotationArray.push({
      value: n,
      annotation: r
    }), a = t.annotationArray.length - 1, o = true), o && (e12.updateAnnotatedValueMap(), e12.modified()), a;
  }, e12.getNumberOfAnnotatedValues = () => t.annotationArray.length, e12.getAnnotatedValue = (e13) => e13 < 0 || e13 >= t.annotationArray.length ? null : t.annotationArray[e13].value, e12.getAnnotation = (e13) => t.annotationArray[e13] === void 0 ? null : t.annotationArray[e13].annotation, e12.getAnnotatedValueIndex = (n) => t.annotationArray.length ? e12.checkForAnnotatedValue(n) : -1, e12.removeAnnotation = (n) => {
    let r = e12.checkForAnnotatedValue(n), a = r >= 0;
    return a && (t.annotationArray.splice(r, 1), e12.updateAnnotatedValueMap(), e12.modified()), a;
  }, e12.resetAnnotations = () => {
    t.annotationArray = [], t.annotatedValueMap = [], e12.modified();
  }, e12.getAnnotationColor = (n, r) => {
    if (t.indexedLookup) {
      let t2 = e12.getAnnotatedValueIndex(n);
      e12.getIndexedColor(t2, r);
    } else
      e12.getColor(parseFloat(n), r), r[3] = 1;
  }, e12.checkForAnnotatedValue = (t2) => e12.getAnnotatedValueIndexInternal(t2), e12.getAnnotatedValueIndexInternal = (e13) => {
    if (t.annotatedValueMap[e13] !== void 0) {
      let n = t.annotationArray.length;
      return t.annotatedValueMap[e13] % n;
    }
    return -1;
  }, e12.getIndexedColor = (e13, t2) => {
    t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 0;
  }, e12.updateAnnotatedValueMap = () => {
    t.annotatedValueMap = [];
    let e13 = t.annotationArray.length;
    for (let n = 0; n < e13; n++)
      t.annotatedValueMap[t.annotationArray[n].value] = n;
  }, e12.mapScalars = (t2, n, r) => {
    let a = t2.getNumberOfComponents(), o = null;
    if (n === ColorMode$1.DEFAULT && (t2.getDataType() === VtkDataTypes$4.UNSIGNED_CHAR || t2.getDataType() === VtkDataTypes$4.UNSIGNED_CHAR_CLAMPED) || n === ColorMode$1.DIRECT_SCALARS && t2)
      o = e12.convertToRGBA(t2, a, t2.getNumberOfTuples());
    else {
      let n2 = {
        type: "vtkDataArray",
        name: "temp",
        numberOfComponents: 4,
        dataType: VtkDataTypes$4.UNSIGNED_CHAR
      }, s = macro.newTypedArray(n2.dataType, 4 * t2.getNumberOfTuples());
      n2.values = s, n2.size = s.length, o = vtkDataArray$1.newInstance(n2);
      let c = r;
      c < 0 && a > 1 ? e12.mapVectorsThroughTable(t2, o, ScalarMappingTarget$2.RGBA, -1, -1) : (c < 0 && (c = 0), c >= a && (c = a - 1), e12.mapScalarsThroughTable(t2, o, ScalarMappingTarget$2.RGBA, c));
    }
    return o;
  }, e12.mapVectorsToMagnitude = (e13, t2, n) => {
    let r = e13.getNumberOfTuples(), a = e13.getNumberOfComponents(), o = t2.getData(), s = e13.getData();
    for (let e14 = 0; e14 < r; e14++) {
      let t3 = 0;
      for (let r2 = 0; r2 < n; r2++)
        t3 += s[e14 * a + r2] * s[e14 * a + r2];
      o[e14] = Math.sqrt(t3);
    }
  }, e12.mapVectorsThroughTable = (t2, n, r, a, o) => {
    let s = e12.getVectorMode(), c = o, l = a, u = t2.getNumberOfComponents();
    s === VectorMode$2.COMPONENT ? (l === -1 && (l = e12.getVectorComponent()), l < 0 && (l = 0), l >= u && (l = u - 1)) : (c === -1 && (c = e12.getVectorSize()), c <= 0 ? (l = 0, c = u) : (l < 0 && (l = 0), l >= u && (l = u - 1), l + c > u && (c = u - l)), s === VectorMode$2.MAGNITUDE && (u === 1 || c === 1) && (s = VectorMode$2.COMPONENT));
    let d = 0;
    switch (l > 0 && (d = l), s) {
      case VectorMode$2.COMPONENT:
        e12.mapScalarsThroughTable(t2, n, r, d);
        break;
      case VectorMode$2.RGBCOLORS:
        break;
      case VectorMode$2.MAGNITUDE:
      default: {
        let a2 = vtkDataArray$1.newInstance({
          numberOfComponents: 1,
          values: new Float32Array(t2.getNumberOfTuples())
        });
        e12.mapVectorsToMagnitude(t2, a2, c), e12.mapScalarsThroughTable(a2, n, r, 0);
        break;
      }
    }
  }, e12.luminanceToRGBA = (e13, t2, n, r) => {
    let a = r(n), o = t2.getData(), s = e13.getData(), c = o.length, l = 0;
    for (let e14 = 0; e14 < c; e14 += 1) {
      let t3 = r(o[e14]);
      s[l * 4] = t3, s[l * 4 + 1] = t3, s[l * 4 + 2] = t3, s[l * 4 + 3] = a, l++;
    }
  }, e12.luminanceAlphaToRGBA = (e13, t2, n, r) => {
    let a = t2.getData(), o = e13.getData(), s = a.length, c = 0;
    for (let e14 = 0; e14 < s; e14 += 2) {
      let t3 = r(a[e14]);
      o[c] = t3, o[c + 1] = t3, o[c + 2] = t3, o[c + 3] = r(a[e14 + 1]) * n, c += 4;
    }
  }, e12.rGBToRGBA = (e13, t2, n, r) => {
    let a = floatColorToUChar(n), o = t2.getData(), s = e13.getData(), c = o.length, l = 0;
    for (let e14 = 0; e14 < c; e14 += 3)
      s[l * 4] = r(o[e14]), s[l * 4 + 1] = r(o[e14 + 1]), s[l * 4 + 2] = r(o[e14 + 2]), s[l * 4 + 3] = a, l++;
  }, e12.rGBAToRGBA = (e13, t2, n, r) => {
    let a = t2.getData(), o = e13.getData(), s = a.length, c = 0;
    for (let e14 = 0; e14 < s; e14 += 4)
      o[c * 4] = r(a[e14]), o[c * 4 + 1] = r(a[e14 + 1]), o[c * 4 + 2] = r(a[e14 + 2]), o[c * 4 + 3] = r(a[e14 + 3]) * n, c++;
  }, e12.convertToRGBA = (n, r, a) => {
    let { alpha: o } = t;
    if (r === 4 && o >= 1 && n.getDataType() === VtkDataTypes$4.UNSIGNED_CHAR)
      return n;
    let s = vtkDataArray$1.newInstance({
      numberOfComponents: 4,
      empty: true,
      size: 4 * a,
      dataType: VtkDataTypes$4.UNSIGNED_CHAR
    });
    if (a <= 0)
      return s;
    o = o > 0 ? o : 0, o = o < 1 ? o : 1;
    let c = intColorToUChar;
    switch ((n.getDataType() === VtkDataTypes$4.FLOAT || n.getDataType() === VtkDataTypes$4.DOUBLE) && (c = floatColorToUChar), r) {
      case 1:
        e12.luminanceToRGBA(s, n, o, c);
        break;
      case 2:
        e12.luminanceAlphaToRGBA(s, n, c);
        break;
      case 3:
        e12.rGBToRGBA(s, n, o, c);
        break;
      case 4:
        e12.rGBAToRGBA(s, n, o, c);
        break;
      default:
        return vtkErrorMacro$41("Cannot convert colors"), null;
    }
    return s;
  }, e12.usingLogScale = () => false, e12.getNumberOfAvailableColors = () => 256 * 256 * 256, e12.setRange = (t2, n) => e12.setMappingRange(t2, n), e12.getRange = () => e12.getMappingRange(), e12.areScalarsOpaque = (n, r, a) => {
    if (!n)
      return e12.isOpaque();
    let o = n.getNumberOfComponents();
    return r === ColorMode$1.DEFAULT && n.getDataType() === VtkDataTypes$4.UNSIGNED_CHAR || r === ColorMode$1.DIRECT_SCALARS ? o === 3 || o === 1 ? t.alpha >= 1 : n.getRange(o - 1)[0] === 255 : true;
  };
}
var DEFAULT_VALUES$129 = {
  alpha: 1,
  vectorComponent: 0,
  vectorSize: -1,
  vectorMode: VectorMode$2.COMPONENT,
  mappingRange: null,
  annotationArray: null,
  annotatedValueMap: null,
  indexedLookup: false,
  scale: Scale$2.LINEAR
};
function extend$140(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$129, n), macro.obj(e12, t), t.mappingRange = [0, 255], t.annotationArray = [], t.annotatedValueMap = [], macro.setGet(e12, t, [
    "vectorSize",
    "vectorComponent",
    "vectorMode",
    "alpha",
    "indexedLookup"
  ]), macro.setArray(e12, t, ["mappingRange"], 2), macro.getArray(e12, t, ["mappingRange"]), vtkScalarsToColors$2(e12, t);
}
var vtkScalarsToColors$1 = {
  newInstance: macro.newInstance(extend$140, "vtkScalarsToColors"),
  extend: extend$140,
  ...vtkScalarsToColors
}, Constants$18 = {
  ColorSpace: {
    RGB: 0,
    HSV: 1,
    LAB: 2,
    DIVERGING: 3
  },
  Scale: {
    LINEAR: 0,
    LOG10: 1
  }
}, { ColorSpace, Scale } = Constants$18, { ScalarMappingTarget: ScalarMappingTarget$1 } = vtkScalarsToColors$1, { vtkDebugMacro: vtkDebugMacro$9, vtkErrorMacro: vtkErrorMacro$40, vtkWarningMacro: vtkWarningMacro$9 } = macro;
function vtkColorTransferFunctionLabToMsh(e12, t) {
  let n = e12[0], r = e12[1], a = e12[2], o = Math.sqrt(n * n + r * r + a * a), s = o > 1e-3 ? Math.acos(n / o) : 0, c = s > 1e-3 ? Math.atan2(a, r) : 0;
  t[0] = o, t[1] = s, t[2] = c;
}
function vtkColorTransferFunctionMshToLab(e12, t) {
  let n = e12[0], r = e12[1], a = e12[2];
  t[0] = n * Math.cos(r), t[1] = n * Math.sin(r) * Math.cos(a), t[2] = n * Math.sin(r) * Math.sin(a);
}
function vtkColorTransferFunctionAdjustHue(e12, t) {
  if (e12[0] >= t - 0.1)
    return e12[2];
  let n = e12[1] * Math.sqrt(t * t - e12[0] * e12[0]) / (e12[0] * Math.sin(e12[1]));
  return e12[2] > -0.3 * Math.PI ? e12[2] + n : e12[2] - n;
}
function vtkColorTransferFunctionAngleDiff(e12, t) {
  let n = e12 - t;
  for (n < 0 && (n = -n); n >= 2 * Math.PI; )
    n -= 2 * Math.PI;
  return n > Math.PI && (n = 2 * Math.PI - n), n;
}
function vtkColorTransferFunctionInterpolateDiverging(e12, t, n, r) {
  let a = [], o = [];
  rgb2lab(t, a), rgb2lab(n, o);
  let s = [], c = [];
  vtkColorTransferFunctionLabToMsh(a, s), vtkColorTransferFunctionLabToMsh(o, c);
  let l = e12;
  if (s[1] > 0.05 && c[1] > 0.05 && vtkColorTransferFunctionAngleDiff(s[2], c[2]) > 0.33 * Math.PI) {
    let t2 = Math.max(s[0], c[0]);
    t2 = Math.max(88, t2), e12 < 0.5 ? (c[0] = t2, c[1] = 0, c[2] = 0, l *= 2) : (s[0] = t2, s[1] = 0, s[2] = 0, l = 2 * l - 1);
  }
  s[1] < 0.05 && c[1] > 0.05 ? s[2] = vtkColorTransferFunctionAdjustHue(c, s[0]) : c[1] < 0.05 && s[1] > 0.05 && (c[2] = vtkColorTransferFunctionAdjustHue(s, c[0]));
  let u = [];
  u[0] = (1 - l) * s[0] + l * c[0], u[1] = (1 - l) * s[1] + l * c[1], u[2] = (1 - l) * s[2] + l * c[2];
  let d = [];
  vtkColorTransferFunctionMshToLab(u, d), lab2rgb(d, r);
}
function vtkColorTransferFunction(e12, t) {
  t.classHierarchy.push("vtkColorTransferFunction"), e12.getSize = () => t.nodes.length, e12.addRGBPoint = (t2, n, r, a) => e12.addRGBPointLong(t2, n, r, a, 0.5, 0), e12.addRGBPointLong = function(n, r, a, o) {
    let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5, c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    if (s < 0 || s > 1)
      return vtkErrorMacro$40("Midpoint outside range [0.0, 1.0]"), -1;
    if (c < 0 || c > 1)
      return vtkErrorMacro$40("Sharpness outside range [0.0, 1.0]"), -1;
    t.allowDuplicateScalars || e12.removePoint(n);
    let l = {
      x: n,
      r,
      g: a,
      b: o,
      midpoint: s,
      sharpness: c
    };
    t.nodes.push(l), e12.sortAndUpdateRange();
    let u = 0;
    for (; u < t.nodes.length && t.nodes[u].x !== n; u++)
      ;
    return u < t.nodes.length ? u : -1;
  }, e12.addHSVPoint = (t2, n, r, a) => e12.addHSVPointLong(t2, n, r, a, 0.5, 0), e12.addHSVPointLong = function(t2, n, r, a) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, c = [];
    return hsv2rgb([
      n,
      r,
      a
    ], c), e12.addRGBPoint(t2, c[0], c[1], c[2], o, s);
  }, e12.setNodes = (n) => {
    if (t.nodes !== n) {
      let r = JSON.stringify(t.nodes);
      t.nodes = n;
      let a = JSON.stringify(t.nodes);
      if (e12.sortAndUpdateRange() || r !== a)
        return e12.modified(), true;
    }
    return false;
  }, e12.sortAndUpdateRange = () => {
    let n = JSON.stringify(t.nodes);
    t.nodes.sort((e13, t2) => e13.x - t2.x);
    let r = JSON.stringify(t.nodes), a = e12.updateRange();
    return !a && n !== r ? (e12.modified(), true) : a;
  }, e12.updateRange = () => {
    let n = [2];
    n[0] = t.mappingRange[0], n[1] = t.mappingRange[1];
    let r = t.nodes.length;
    return r ? (t.mappingRange[0] = t.nodes[0].x, t.mappingRange[1] = t.nodes[r - 1].x) : (t.mappingRange[0] = 0, t.mappingRange[1] = 0), n[0] === t.mappingRange[0] && n[1] === t.mappingRange[1] ? false : (e12.modified(), true);
  }, e12.removePoint = (n) => {
    let r = 0;
    for (; r < t.nodes.length && t.nodes[r].x !== n; r++)
      ;
    let a = r;
    if (r >= t.nodes.length)
      return -1;
    let o = false;
    return t.nodes.splice(r, 1), (r === 0 || r === t.nodes.length) && (o = e12.updateRange()), o || e12.modified(), a;
  }, e12.movePoint = (n, r) => {
    if (n !== r) {
      e12.removePoint(r);
      for (let a = 0; a < t.nodes.length; a++)
        if (t.nodes[a].x === n) {
          t.nodes[a].x = r, e12.sortAndUpdateRange();
          break;
        }
    }
  }, e12.removeAllPoints = () => {
    t.nodes = [], e12.sortAndUpdateRange();
  }, e12.addRGBSegment = (n, r, a, o, s, c, l, u) => {
    e12.sortAndUpdateRange();
    for (let e13 = 0; e13 < t.nodes.length; )
      t.nodes[e13].x >= n && t.nodes[e13].x <= s ? t.nodes.splice(e13, 1) : e13++;
    e12.addRGBPointLong(n, r, a, o, 0.5, 0), e12.addRGBPointLong(s, c, l, u, 0.5, 0), e12.modified();
  }, e12.addHSVSegment = (t2, n, r, a, o, s, c, l) => {
    let u = [
      n,
      r,
      a
    ], d = [
      s,
      c,
      l
    ], f = [], p = [];
    hsv2rgb(u, f), hsv2rgb(d, p), e12.addRGBSegment(t2, f[0], f[1], f[2], o, p[0], p[1], p[2]);
  }, e12.mapValue = (t2) => {
    let n = [];
    return e12.getColor(t2, n), [
      Math.floor(255 * n[0] + 0.5),
      Math.floor(255 * n[1] + 0.5),
      Math.floor(255 * n[2] + 0.5),
      255
    ];
  }, e12.getColor = (n, r) => {
    if (t.indexedLookup) {
      let t2 = e12.getSize(), a = e12.getAnnotatedValueIndexInternal(n);
      if (a < 0 || t2 === 0) {
        let t3 = e12.getNanColorByReference();
        r[0] = t3[0], r[1] = t3[1], r[2] = t3[2];
      } else {
        let n2 = [];
        e12.getNodeValue(a % t2, n2), r[0] = n2[1], r[1] = n2[2], r[2] = n2[3];
      }
      return;
    }
    e12.getTable(n, n, 1, r);
  }, e12.getRedValue = (t2) => {
    let n = [];
    return e12.getColor(t2, n), n[0];
  }, e12.getGreenValue = (t2) => {
    let n = [];
    return e12.getColor(t2, n), n[1];
  }, e12.getBlueValue = (t2) => {
    let n = [];
    return e12.getColor(t2, n), n[2];
  }, e12.logScaleEnabled = () => t.scale === Scale.LOG10, e12.usingLogScale = () => e12.logScaleEnabled() && t.mappingRange[0] > 0, e12.getTable = (n, r, a, o) => {
    let s = e12.usingLogScale(), c = s ? Math.log10(Number(n)) : Number(n), l = s ? Math.log10(Number(r)) : Number(r);
    if (isNan(c) || isNan(l)) {
      for (let e13 = 0; e13 < a; e13++)
        o[e13 * 3 + 0] = t.nanColor[0], o[e13 * 3 + 1] = t.nanColor[1], o[e13 * 3 + 2] = t.nanColor[2];
      return;
    }
    let u = 0, d = t.nodes.length, f = 0, p = 0, m = 0;
    d !== 0 && (f = t.nodes[d - 1].r, p = t.nodes[d - 1].g, m = t.nodes[d - 1].b);
    let h = 0, g = 0, _ = 0, v = [
      0,
      0,
      0
    ], y = [
      0,
      0,
      0
    ], b = 0, S = 0, C = [], w = t.mappingRange;
    s && (w = [Math.log10(t.mappingRange[0]), Math.log10(t.mappingRange[1])]);
    for (let n2 = 0; n2 < a; n2++) {
      let r2 = 3 * n2;
      if (h = a > 1 ? c + n2 / (a - 1) * (l - c) : 0.5 * (c + l), t.discretize) {
        let e13 = w;
        if (h >= e13[0] && h <= e13[1]) {
          let n3 = t.numberOfValues, r3 = e13[1] - e13[0];
          if (n3 <= 1)
            h = e13[0] + r3 / 2;
          else {
            let t2 = floor(n3 * ((h - e13[0]) / r3));
            h = e13[0] + t2 / (n3 - 1) * r3;
          }
        }
      }
      for (; u < d && h > t.nodes[u].x; )
        u++, u < d && (g = t.nodes[u - 1].x, _ = t.nodes[u].x, v[0] = t.nodes[u - 1].r, y[0] = t.nodes[u].r, v[1] = t.nodes[u - 1].g, y[1] = t.nodes[u].g, v[2] = t.nodes[u - 1].b, y[2] = t.nodes[u].b, b = t.nodes[u - 1].midpoint, S = t.nodes[u - 1].sharpness, b < 1e-5 && (b = 1e-5), b > 0.99999 && (b = 0.99999));
      if (h > w[1])
        o[r2] = 0, o[r2 + 1] = 0, o[r2 + 2] = 0, t.clamping && (e12.getUseAboveRangeColor() ? (o[r2] = t.aboveRangeColor[0], o[r2 + 1] = t.aboveRangeColor[1], o[r2 + 2] = t.aboveRangeColor[2]) : (o[r2] = f, o[r2 + 1] = p, o[r2 + 2] = m));
      else if (h < w[0] || isInf(h) && h < 0)
        o[r2] = 0, o[r2 + 1] = 0, o[r2 + 2] = 0, t.clamping && (e12.getUseBelowRangeColor() ? (o[r2] = t.belowRangeColor[0], o[r2 + 1] = t.belowRangeColor[1], o[r2 + 2] = t.belowRangeColor[2]) : d > 0 && (o[r2] = t.nodes[0].r, o[r2 + 1] = t.nodes[0].g, o[r2 + 2] = t.nodes[0].b));
      else if (u === 0 && (Math.abs(h - c) < 1e-6 || t.discretize))
        d > 0 ? (o[r2] = t.nodes[0].r, o[r2 + 1] = t.nodes[0].g, o[r2 + 2] = t.nodes[0].b) : (o[r2] = 0, o[r2 + 1] = 0, o[r2 + 2] = 0);
      else {
        let e13 = 0;
        if (e13 = (h - g) / (_ - g), e13 = e13 < b ? 0.5 * e13 / b : 0.5 + 0.5 * (e13 - b) / (1 - b), S > 0.99)
          if (e13 < 0.5) {
            o[r2] = v[0], o[r2 + 1] = v[1], o[r2 + 2] = v[2];
            continue;
          } else {
            o[r2] = y[0], o[r2 + 1] = y[1], o[r2 + 2] = y[2];
            continue;
          }
        if (S < 0.01) {
          if (t.colorSpace === ColorSpace.RGB)
            o[r2] = (1 - e13) * v[0] + e13 * y[0], o[r2 + 1] = (1 - e13) * v[1] + e13 * y[1], o[r2 + 2] = (1 - e13) * v[2] + e13 * y[2];
          else if (t.colorSpace === ColorSpace.HSV) {
            let n4 = [], a3 = [];
            rgb2hsv(v, n4), rgb2hsv(y, a3), t.hSVWrap && (n4[0] - a3[0] > 0.5 || a3[0] - n4[0] > 0.5) && (n4[0] > a3[0] ? --n4[0] : --a3[0]);
            let s3 = [];
            s3[0] = (1 - e13) * n4[0] + e13 * a3[0], s3[0] < 0 && (s3[0] += 1), s3[1] = (1 - e13) * n4[1] + e13 * a3[1], s3[2] = (1 - e13) * n4[2] + e13 * a3[2], hsv2rgb(s3, C), o[r2] = C[0], o[r2 + 1] = C[1], o[r2 + 2] = C[2];
          } else if (t.colorSpace === ColorSpace.LAB) {
            let t2 = [], n4 = [];
            rgb2lab(v, t2), rgb2lab(y, n4);
            let a3 = [];
            a3[0] = (1 - e13) * t2[0] + e13 * n4[0], a3[1] = (1 - e13) * t2[1] + e13 * n4[1], a3[2] = (1 - e13) * t2[2] + e13 * n4[2], lab2rgb(a3, C), o[r2] = C[0], o[r2 + 1] = C[1], o[r2 + 2] = C[2];
          } else
            t.colorSpace === ColorSpace.DIVERGING ? (vtkColorTransferFunctionInterpolateDiverging(e13, v, y, C), o[r2] = C[0], o[r2 + 1] = C[1], o[r2 + 2] = C[2]) : vtkErrorMacro$40("ColorSpace set to invalid value.", t.colorSpace);
          continue;
        }
        e13 < 0.5 ? e13 = 0.5 * (e13 * 2) ** (1 + 10 * S) : e13 > 0.5 && (e13 = 1 - 0.5 * ((1 - e13) * 2) ** (1 + 10 * S));
        let n3 = e13 * e13, a2 = n3 * e13, s2 = 2 * a2 - 3 * n3 + 1, c2 = -2 * a2 + 3 * n3, l2 = a2 - 2 * n3 + e13, u2 = a2 - n3, d2, f2;
        if (t.colorSpace === ColorSpace.RGB)
          for (let e14 = 0; e14 < 3; e14++)
            d2 = y[e14] - v[e14], f2 = (1 - S) * d2, o[r2 + e14] = s2 * v[e14] + c2 * y[e14] + l2 * f2 + u2 * f2;
        else if (t.colorSpace === ColorSpace.HSV) {
          let e14 = [], n4 = [];
          rgb2hsv(v, e14), rgb2hsv(y, n4), t.hSVWrap && (e14[0] - n4[0] > 0.5 || n4[0] - e14[0] > 0.5) && (e14[0] > n4[0] ? --e14[0] : --n4[0]);
          let a3 = [];
          for (let t2 = 0; t2 < 3; t2++)
            d2 = n4[t2] - e14[t2], f2 = (1 - S) * d2, a3[t2] = s2 * e14[t2] + c2 * n4[t2] + l2 * f2 + u2 * f2, t2 === 0 && a3[t2] < 0 && (a3[t2] += 1);
          hsv2rgb(a3, C), o[r2] = C[0], o[r2 + 1] = C[1], o[r2 + 2] = C[2];
        } else if (t.colorSpace === ColorSpace.LAB) {
          let e14 = [], t2 = [];
          rgb2lab(v, e14), rgb2lab(y, t2);
          let n4 = [];
          for (let r3 = 0; r3 < 3; r3++)
            d2 = t2[r3] - e14[r3], f2 = (1 - S) * d2, n4[r3] = s2 * e14[r3] + c2 * t2[r3] + l2 * f2 + u2 * f2;
          lab2rgb(n4, C), o[r2] = C[0], o[r2 + 1] = C[1], o[r2 + 2] = C[2];
        } else
          t.colorSpace === ColorSpace.DIVERGING ? (vtkColorTransferFunctionInterpolateDiverging(e13, v, y, C), o[r2] = C[0], o[r2 + 1] = C[1], o[r2 + 2] = C[2]) : vtkErrorMacro$40("ColorSpace set to invalid value.");
        for (let e14 = 0; e14 < 3; e14++)
          o[r2 + e14] = o[r2 + e14] < 0 ? 0 : o[r2 + e14], o[r2 + e14] = o[r2 + e14] > 1 ? 1 : o[r2 + e14];
      }
    }
  }, e12.getUint8Table = function(n, r, a) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (e12.getMTime() <= t.buildTime && t.tableSize === a && t.tableWithAlpha !== o)
      return t.table;
    if (t.nodes.length === 0)
      return vtkErrorMacro$40("Attempting to lookup a value with no points in the function"), t.table;
    let s = o ? 4 : 3;
    (t.tableSize !== a || t.tableWithAlpha !== o) && (t.table = new Uint8Array(a * s), t.tableSize = a, t.tableWithAlpha = o);
    let c = [];
    e12.getTable(n, r, a, c);
    for (let e13 = 0; e13 < a; e13++)
      t.table[e13 * s + 0] = Math.floor(c[e13 * 3 + 0] * 255 + 0.5), t.table[e13 * s + 1] = Math.floor(c[e13 * 3 + 1] * 255 + 0.5), t.table[e13 * s + 2] = Math.floor(c[e13 * 3 + 2] * 255 + 0.5), o && (t.table[e13 * s + 3] = 255);
    return t.buildTime.modified(), t.table;
  }, e12.buildFunctionFromArray = (n) => {
    e12.removeAllPoints();
    let r = n.getNumberOfComponents();
    for (let e13 = 0; e13 < n.getNumberOfTuples(); e13++)
      switch (r) {
        case 3:
          t.nodes.push({
            x: e13,
            r: n.getComponent(e13, 0),
            g: n.getComponent(e13, 1),
            b: n.getComponent(e13, 2),
            midpoint: 0.5,
            sharpness: 0
          });
          break;
        case 4:
          t.nodes.push({
            x: n.getComponent(e13, 0),
            r: n.getComponent(e13, 1),
            g: n.getComponent(e13, 2),
            b: n.getComponent(e13, 3),
            midpoint: 0.5,
            sharpness: 0
          });
          break;
        case 5:
          t.nodes.push({
            x: e13,
            r: n.getComponent(e13, 0),
            g: n.getComponent(e13, 1),
            b: n.getComponent(e13, 2),
            midpoint: n.getComponent(e13, 4),
            sharpness: n.getComponent(e13, 5)
          });
          break;
        case 6:
          t.nodes.push({
            x: n.getComponent(e13, 0),
            r: n.getComponent(e13, 1),
            g: n.getComponent(e13, 2),
            b: n.getComponent(e13, 3),
            midpoint: n.getComponent(e13, 4),
            sharpness: n.getComponent(e13, 5)
          });
          break;
      }
    e12.sortAndUpdateRange();
  }, e12.buildFunctionFromTable = (n, r, a, o) => {
    let s = 0;
    e12.removeAllPoints(), a > 1 && (s = (r - n) / (a - 1));
    for (let e13 = 0; e13 < a; e13++) {
      let r2 = {
        x: n + s * e13,
        r: o[e13 * 3],
        g: o[e13 * 3 + 1],
        b: o[e13 * 3 + 2],
        sharpness: 0,
        midpoint: 0.5
      };
      t.nodes.push(r2);
    }
    e12.sortAndUpdateRange();
  }, e12.getNodeValue = (e13, n) => e13 < 0 || e13 >= t.nodes.length ? (vtkErrorMacro$40("Index out of range!"), -1) : (n[0] = t.nodes[e13].x, n[1] = t.nodes[e13].r, n[2] = t.nodes[e13].g, n[3] = t.nodes[e13].b, n[4] = t.nodes[e13].midpoint, n[5] = t.nodes[e13].sharpness, 1), e12.setNodeValue = (n, r) => {
    if (n < 0 || n >= t.nodes.length)
      return vtkErrorMacro$40("Index out of range!"), -1;
    let a = t.nodes[n].x;
    return t.nodes[n].x = r[0], t.nodes[n].r = r[1], t.nodes[n].g = r[2], t.nodes[n].b = r[3], t.nodes[n].midpoint = r[4], t.nodes[n].sharpness = r[5], a === r[0] ? e12.modified() : e12.sortAndUpdateRange(), 1;
  }, e12.getNumberOfAvailableColors = () => {
    if (t.indexedLookup && e12.getSize())
      return e12.getSize();
    if (t.tableSize)
      return t.tableSize;
    let n = t.nodes?.length ?? 0;
    return Math.max(4094, n);
  }, e12.getIndexedColor = (t2, n) => {
    let r = e12.getSize();
    if (r > 0 && t2 >= 0) {
      let a2 = [];
      e12.getNodeValue(t2 % r, a2);
      for (let e13 = 0; e13 < 3; ++e13)
        n[e13] = a2[e13 + 1];
      n[3] = 1;
      return;
    }
    let a = e12.getNanColorByReference();
    n[0] = a[0], n[1] = a[1], n[2] = a[2], n[3] = 1;
  }, e12.fillFromDataPointer = (t2, n) => {
    if (!(t2 <= 0 || !n)) {
      e12.removeAllPoints();
      for (let r = 0; r < t2; r++)
        e12.addRGBPoint(n[r * 4], n[r * 4 + 1], n[r * 4 + 2], n[r * 4 + 3]);
    }
  }, e12.setMappingRange = (n, r) => {
    let a = [n, r], o = [n, r], s = e12.getRange(), c = e12.logScaleEnabled();
    if (s[1] === a[1] && s[0] === a[0])
      return;
    if (a[1] === a[0]) {
      vtkErrorMacro$40("attempt to set zero width color range");
      return;
    }
    c && (a[0] <= 0 ? console.warn("attempt to set log scale color range with non-positive minimum") : (o[0] = Math.log10(a[0]), o[1] = Math.log10(a[1])));
    let l = (o[1] - o[0]) / (s[1] - s[0]), u = o[0] - s[0] * l;
    for (let e13 = 0; e13 < t.nodes.length; ++e13)
      t.nodes[e13].x = t.nodes[e13].x * l + u;
    t.mappingRange[0] = a[0], t.mappingRange[1] = a[1], e12.modified();
  }, e12.adjustRange = (n) => {
    let r = e12.getRange(), a = [];
    r[0] < n[0] ? (e12.getColor(n[0], a), e12.addRGBPoint(n[0], a[0], a[1], a[2])) : (e12.getColor(r[0], a), e12.addRGBPoint(n[0], a[0], a[1], a[2])), r[1] > n[1] ? (e12.getColor(n[1], a), e12.addRGBPoint(n[1], a[0], a[1], a[2])) : (e12.getColor(r[1], a), e12.addRGBPoint(n[1], a[0], a[1], a[2])), e12.sortAndUpdateRange();
    for (let e13 = 0; e13 < t.nodes.length; )
      t.nodes[e13].x >= n[0] && t.nodes[e13].x <= n[1] ? t.nodes.splice(e13, 1) : ++e13;
    return 1;
  }, e12.estimateMinNumberOfSamples = (t2, n) => {
    let r = e12.findMinimumXDistance();
    return Math.ceil((n - t2) / r);
  }, e12.findMinimumXDistance = () => {
    if (t.nodes.length < 2)
      return -1;
    let e13 = Number.MAX_VALUE;
    for (let n = 0; n < t.nodes.length - 1; n++) {
      let r = t.nodes[n + 1].x - t.nodes[n].x;
      r < e13 && (e13 = r);
    }
    return e13;
  }, e12.mapScalarsThroughTable = (n, r, a, o) => {
    if (e12.getSize() === 0) {
      vtkDebugMacro$9("Transfer Function Has No Points!");
      return;
    }
    t.indexedLookup ? e12.mapDataIndexed(n, r, a, o) : e12.mapData(n, r, a, o);
  }, e12.mapData = (t2, n, r, a) => {
    if (e12.getSize() === 0) {
      vtkWarningMacro$9("Transfer Function Has No Points!");
      return;
    }
    let o = Math.floor(e12.getAlpha() * 255 + 0.5), s = t2.getNumberOfTuples(), c = t2.getNumberOfComponents(), l = n.getData(), u = t2.getData(), d = [];
    if (r === ScalarMappingTarget$1.RGBA)
      for (let t3 = 0; t3 < s; t3++) {
        let n2 = u[t3 * c + a];
        e12.getColor(n2, d), l[t3 * 4] = Math.floor(d[0] * 255 + 0.5), l[t3 * 4 + 1] = Math.floor(d[1] * 255 + 0.5), l[t3 * 4 + 2] = Math.floor(d[2] * 255 + 0.5), l[t3 * 4 + 3] = o;
      }
    if (r === ScalarMappingTarget$1.RGB)
      for (let t3 = 0; t3 < s; t3++) {
        let n2 = u[t3 * c + a];
        e12.getColor(n2, d), l[t3 * 3] = Math.floor(d[0] * 255 + 0.5), l[t3 * 3 + 1] = Math.floor(d[1] * 255 + 0.5), l[t3 * 3 + 2] = Math.floor(d[2] * 255 + 0.5);
      }
    if (r === ScalarMappingTarget$1.LUMINANCE)
      for (let t3 = 0; t3 < s; t3++) {
        let n2 = u[t3 * c + a];
        e12.getColor(n2, d), l[t3] = Math.floor(d[0] * 76.5 + d[1] * 150.45 + d[2] * 28.05 + 0.5);
      }
    if (r === ScalarMappingTarget$1.LUMINANCE_ALPHA)
      for (let t3 = 0; t3 < s; t3++) {
        let n2 = u[t3 * c + a];
        e12.getColor(n2, d), l[t3 * 2] = Math.floor(d[0] * 76.5 + d[1] * 150.45 + d[2] * 28.05 + 0.5), l[t3 * 2 + 1] = o;
      }
  }, e12.applyColorMap = (n) => {
    let r = JSON.stringify(t.colorSpace);
    n.ColorSpace && (t.colorSpace = ColorSpace[n.ColorSpace.toUpperCase()], t.colorSpace === void 0 && (vtkErrorMacro$40(`ColorSpace ${n.ColorSpace} not supported, using RGB instead`), t.colorSpace = ColorSpace.RGB));
    let a = r !== JSON.stringify(t.colorSpace), o = a || JSON.stringify(t.nanColor);
    if (n.NanColor)
      for (t.nanColor = [].concat(n.NanColor); t.nanColor.length < 4; )
        t.nanColor.push(1);
    a ||= o !== JSON.stringify(t.nanColor);
    let s = a || JSON.stringify(t.nodes);
    if (n.RGBPoints) {
      let e13 = n.RGBPoints.length;
      t.nodes = [];
      for (let r2 = 0; r2 < e13; r2 += 4)
        t.nodes.push({
          x: n.RGBPoints[r2],
          r: n.RGBPoints[r2 + 1],
          g: n.RGBPoints[r2 + 2],
          b: n.RGBPoints[r2 + 3],
          midpoint: 0.5,
          sharpness: 0
        });
    }
    let c = e12.sortAndUpdateRange(), l = !c && (a || s !== JSON.stringify(t.nodes));
    return l && e12.modified(), c || l;
  };
}
var DEFAULT_VALUES$128 = {
  clamping: true,
  colorSpace: ColorSpace.RGB,
  hSVWrap: true,
  scale: Scale.LINEAR,
  nanColor: null,
  belowRangeColor: null,
  aboveRangeColor: null,
  useAboveRangeColor: false,
  useBelowRangeColor: false,
  allowDuplicateScalars: false,
  table: null,
  tableSize: 0,
  buildTime: null,
  nodes: null,
  discretize: false,
  numberOfValues: 256
};
function extend$139(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$128, n), vtkScalarsToColors$1.extend(e12, t, n), t.table = [], t.nodes = [], t.nanColor = [
    0.5,
    0,
    0,
    1
  ], t.belowRangeColor = [
    0,
    0,
    0,
    1
  ], t.aboveRangeColor = [
    1,
    1,
    1,
    1
  ], t.buildTime = {}, macro.obj(t.buildTime), macro.get(e12, t, ["buildTime", "mappingRange"]), macro.setGet(e12, t, [
    "useAboveRangeColor",
    "useBelowRangeColor",
    "discretize",
    "numberOfValues",
    {
      type: "enum",
      name: "colorSpace",
      enum: ColorSpace
    },
    {
      type: "enum",
      name: "scale",
      enum: Scale
    }
  ]), macro.setArray(e12, t, [
    "nanColor",
    "belowRangeColor",
    "aboveRangeColor"
  ], 4), macro.getArray(e12, t, [
    "nanColor",
    "belowRangeColor",
    "aboveRangeColor"
  ]), vtkColorTransferFunction(e12, t);
}
var vtkColorTransferFunction$1 = {
  newInstance: macro.newInstance(extend$139, "vtkColorTransferFunction"),
  extend: extend$139,
  ...Constants$18
}, vtkColorMaps$1 = [
  {
    Name: "KAAMS",
    IndexedColors: [
      1,
      1,
      1,
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      1,
      1,
      0,
      1,
      0,
      1,
      0,
      1,
      1,
      0.63,
      0.63,
      1,
      0.67,
      0.5,
      0.33,
      1,
      0.5,
      0.75,
      0.53,
      0.35,
      0.7,
      1,
      0.75,
      0.5
    ],
    Annotations: [
      0,
      0,
      1,
      1,
      2,
      2,
      3,
      3,
      4,
      4,
      5,
      5,
      6,
      6,
      7,
      7,
      8,
      8,
      9,
      9,
      10,
      10,
      11,
      11
    ]
  },
  {
    ColorSpace: "Diverging",
    Name: "Cool to Warm",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0.23137254902,
      0.298039215686,
      0.752941176471,
      0.5,
      0.865,
      0.865,
      0.865,
      1,
      0.705882352941,
      0.0156862745098,
      0.149019607843
    ]
  },
  {
    ColorSpace: "Lab",
    Creator: "Francesca Samsel",
    Name: "Cool to Warm (Extended)",
    NanColor: [
      0.25,
      0,
      0
    ],
    RGBPoints: [
      0,
      0,
      0,
      0.34902,
      0.03125,
      0.039216,
      0.062745,
      0.380392,
      0.0625,
      0.062745,
      0.117647,
      0.411765,
      0.09375,
      0.090196,
      0.184314,
      0.45098,
      0.125,
      0.12549,
      0.262745,
      0.501961,
      0.15625,
      0.160784,
      0.337255,
      0.541176,
      0.1875,
      0.2,
      0.396078,
      0.568627,
      0.21875,
      0.239216,
      0.454902,
      0.6,
      0.25,
      0.286275,
      0.521569,
      0.65098,
      0.28125,
      0.337255,
      0.592157,
      0.701961,
      0.3125,
      0.388235,
      0.654902,
      0.74902,
      0.34375,
      0.466667,
      0.737255,
      0.819608,
      0.375,
      0.572549,
      0.819608,
      0.878431,
      0.40625,
      0.654902,
      0.866667,
      0.909804,
      0.4375,
      0.752941,
      0.917647,
      0.941176,
      0.46875,
      0.823529,
      0.956863,
      0.968627,
      0.5,
      0.988235,
      0.960784,
      0.901961,
      0.5,
      0.941176,
      0.984314,
      0.988235,
      0.52,
      0.988235,
      0.945098,
      0.85098,
      0.54,
      0.980392,
      0.898039,
      0.784314,
      0.5625,
      0.968627,
      0.835294,
      0.698039,
      0.59375,
      0.94902,
      0.733333,
      0.588235,
      0.625,
      0.929412,
      0.65098,
      0.509804,
      0.65625,
      0.909804,
      0.564706,
      0.435294,
      0.6875,
      0.878431,
      0.458824,
      0.352941,
      0.71875,
      0.839216,
      0.388235,
      0.286275,
      0.75,
      0.760784,
      0.294118,
      0.211765,
      0.78125,
      0.701961,
      0.211765,
      0.168627,
      0.8125,
      0.65098,
      0.156863,
      0.129412,
      0.84375,
      0.6,
      0.094118,
      0.094118,
      0.875,
      0.54902,
      0.066667,
      0.098039,
      0.90625,
      0.501961,
      0.05098,
      0.12549,
      0.9375,
      0.45098,
      0.054902,
      0.172549,
      0.96875,
      0.4,
      0.054902,
      0.192157,
      1,
      0.34902,
      0.070588,
      0.211765
    ]
  },
  {
    ColorSpace: "Diverging",
    Name: "Warm to Cool",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0.705882352941,
      0.0156862745098,
      0.149019607843,
      0.5,
      0.865,
      0.865,
      0.865,
      1,
      0.23137254902,
      0.298039215686,
      0.752941176471
    ]
  },
  {
    ColorSpace: "Lab",
    Creator: "Francesca Samsel",
    Name: "Warm to Cool (Extended)",
    NanColor: [
      0.250004,
      0,
      0
    ],
    RGBPoints: [
      0,
      0.34902,
      0,
      0.129412,
      0.025,
      0.4,
      392157e-8,
      0.101961,
      0.05,
      0.470588,
      0.0156863,
      0.0901961,
      0.075,
      0.54902,
      0.027451,
      0.0705882,
      0.1,
      0.619608,
      0.0627451,
      0.0431373,
      0.125,
      0.690196,
      0.12549,
      0.0627451,
      0.15,
      0.741176,
      0.184314,
      0.0745098,
      0.175,
      0.788235,
      0.266667,
      0.0941176,
      0.2,
      0.811765,
      0.345098,
      0.113725,
      0.225,
      0.831373,
      0.411765,
      0.133333,
      0.25,
      0.85098,
      0.47451,
      0.145098,
      0.275,
      0.870588,
      0.54902,
      0.156863,
      0.3,
      0.878431,
      0.619608,
      0.168627,
      0.325,
      0.890196,
      0.658824,
      0.196078,
      0.35,
      0.909804,
      0.717647,
      0.235294,
      0.375,
      0.929412,
      0.776471,
      0.278431,
      0.395522,
      0.94902,
      0.823529,
      0.321569,
      0.418905,
      0.968627,
      0.87451,
      0.407843,
      0.444278,
      0.980392,
      0.917647,
      0.509804,
      0.470149,
      0.988235,
      0.956863,
      0.643137,
      0.483582,
      0.992157,
      0.964706,
      0.713725,
      0.499,
      0.988235,
      0.980392,
      0.870588,
      0.5,
      1,
      1,
      1,
      0.501,
      0.913725,
      0.988235,
      0.937255,
      0.516418,
      0.827451,
      0.980392,
      0.886275,
      0.531343,
      0.764706,
      0.980392,
      0.866667,
      0.546766,
      0.658824,
      0.980392,
      0.843137,
      0.564179,
      0.572549,
      0.964706,
      0.835294,
      0.587562,
      0.423529,
      0.941176,
      0.87451,
      0.60597,
      0.262745,
      0.901961,
      0.862745,
      0.629851,
      0.0705882,
      0.854902,
      0.870588,
      0.651741,
      0.0509804,
      0.8,
      0.85098,
      0.681592,
      0.0235294,
      0.709804,
      0.831373,
      0.712935,
      0.0313725,
      0.615686,
      0.811765,
      0.75,
      0.0313725,
      0.537255,
      0.788235,
      0.775,
      0.0392157,
      0.466667,
      0.768627,
      0.8,
      0.0509804,
      0.396078,
      0.741176,
      0.825,
      0.054902,
      0.317647,
      0.709804,
      0.85,
      0.054902,
      0.243137,
      0.678431,
      0.875,
      0.0431373,
      0.164706,
      0.639216,
      0.9,
      0.0313725,
      0.0980392,
      0.6,
      0.925,
      0.0392157,
      0.0392157,
      0.560784,
      0.95,
      0.105882,
      0.0509804,
      0.509804,
      0.975,
      0.113725,
      0.0235294,
      0.45098,
      1,
      0.12549,
      0,
      0.380392
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Rainbow Desaturated",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0.278431372549,
      0.278431372549,
      0.858823529412,
      0.143,
      0,
      0,
      0.360784313725,
      0.285,
      0,
      1,
      1,
      0.429,
      0,
      0.501960784314,
      0,
      0.571,
      1,
      1,
      0,
      0.714,
      1,
      0.380392156863,
      0,
      0.857,
      0.419607843137,
      0,
      0,
      1,
      0.878431372549,
      0.301960784314,
      0.301960784314
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Cold and Hot",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0,
      1,
      1,
      0.45,
      0,
      0,
      1,
      0.5,
      0,
      0,
      0.501960784314,
      0.55,
      1,
      0,
      0,
      1,
      1,
      1,
      0
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Black-Body Radiation",
    NanColor: [
      0,
      0.498039215686,
      1
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      0.4,
      0.901960784314,
      0,
      0,
      0.8,
      0.901960784314,
      0.901960784314,
      0,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "X Ray",
    NanColor: [
      1,
      0,
      0
    ],
    RGBPoints: [
      0,
      1,
      1,
      1,
      1,
      0,
      0,
      0
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Grayscale",
    NanColor: [
      1,
      0,
      0
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "BkRd",
    NanColor: [
      0,
      1,
      1
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      1,
      1,
      0,
      0
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "BkGn",
    NanColor: [
      1,
      0,
      1
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      1,
      0,
      1,
      0
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "BkBu",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "BkMa",
    NanColor: [
      0,
      1,
      0
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      1,
      1,
      0,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "BkCy",
    NanColor: [
      0,
      1,
      1
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      1,
      0,
      1,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Black, Blue and White",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      0.333,
      0,
      0,
      0.501960784314,
      0.666,
      0,
      0.501960784314,
      1,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Black, Orange and White",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      0.333,
      0.501960784314,
      0,
      0,
      0.666,
      1,
      0.501960784314,
      0,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Creator: "Francesca Samsel",
    Name: "Linear YGB 1211g",
    NanColor: [
      0.25,
      0,
      0
    ],
    RGBPoints: [
      0,
      1,
      0.988235,
      0.968627,
      0.02,
      1,
      0.952941,
      0.878431,
      0.05,
      0.968627,
      0.905882,
      0.776471,
      0.1,
      0.94902,
      0.898039,
      0.647059,
      0.15,
      0.901961,
      0.878431,
      0.556863,
      0.2,
      0.847059,
      0.858824,
      0.482353,
      0.25,
      0.690196,
      0.819608,
      0.435294,
      0.3,
      0.513725,
      0.768627,
      0.384314,
      0.35,
      0.337255,
      0.721569,
      0.337255,
      0.4,
      0.278431,
      0.658824,
      0.392157,
      0.45,
      0.231373,
      0.639216,
      0.435294,
      0.5,
      0.203922,
      0.6,
      0.486275,
      0.55,
      0.172549,
      0.568627,
      0.537255,
      0.6,
      0.141176,
      0.517647,
      0.54902,
      0.65,
      0.133333,
      0.458824,
      0.541176,
      0.7,
      0.12549,
      0.396078,
      0.529412,
      0.75,
      0.117647,
      0.321569,
      0.521569,
      0.8,
      0.121569,
      0.258824,
      0.509804,
      0.85,
      0.133333,
      0.227451,
      0.501961,
      0.9,
      0.145098,
      0.192157,
      0.490196,
      0.95,
      0.188235,
      0.164706,
      0.470588,
      1,
      0.258824,
      0.196078,
      0.439216
    ]
  },
  {
    ColorSpace: "CIELAB",
    Creator: "Francesca Samsel",
    Name: "Linear Green (Gr4L)",
    NanColor: [
      0.25,
      0,
      0
    ],
    RGBPoints: [
      0,
      0.054902,
      0.109804,
      0.121569,
      0.05,
      0.07451,
      0.172549,
      0.180392,
      0.1,
      0.086275,
      0.231373,
      0.219608,
      0.15,
      0.094118,
      0.278431,
      0.25098,
      0.2,
      0.109804,
      0.34902,
      0.278431,
      0.25,
      0.113725,
      0.4,
      0.278431,
      0.3,
      0.117647,
      0.45098,
      0.270588,
      0.35,
      0.117647,
      0.490196,
      0.243137,
      0.4,
      0.113725,
      0.521569,
      0.203922,
      0.45,
      0.109804,
      0.54902,
      0.152941,
      0.5,
      0.082353,
      0.588235,
      0.082353,
      0.55,
      0.109804,
      0.631373,
      0.05098,
      0.6,
      0.211765,
      0.678431,
      0.082353,
      0.65,
      0.317647,
      0.721569,
      0.113725,
      0.7,
      0.431373,
      0.760784,
      0.160784,
      0.75,
      0.556863,
      0.8,
      0.239216,
      0.8,
      0.666667,
      0.839216,
      0.294118,
      0.85,
      0.784314,
      0.878431,
      0.396078,
      0.9,
      0.886275,
      0.921569,
      0.533333,
      0.95,
      0.960784,
      0.94902,
      0.670588,
      1,
      1,
      0.984314,
      0.901961
    ]
  },
  {
    ColorSpace: "Lab",
    Creator: "Francesca Samsel",
    Name: "Linear Blue (8_31f)",
    NanColor: [
      0.25,
      0,
      0
    ],
    RGBPoints: [
      0,
      0.960784,
      1,
      0.980392,
      0.05,
      0.815686,
      0.960784,
      0.913725,
      0.1,
      0.670588,
      0.929412,
      0.870588,
      0.15,
      0.556863,
      0.901961,
      0.843137,
      0.2,
      0.478431,
      0.870588,
      0.823529,
      0.25,
      0.439216,
      0.831373,
      0.803922,
      0.3,
      0.4,
      0.8,
      0.788235,
      0.35,
      0.376471,
      0.768627,
      0.768627,
      0.4,
      0.34902,
      0.709804,
      0.729412,
      0.45,
      0.32549,
      0.654902,
      0.690196,
      0.5,
      0.301961,
      0.607843,
      0.658824,
      0.55,
      0.247059,
      0.545098,
      0.619608,
      0.6,
      0.239216,
      0.494118,
      0.580392,
      0.65,
      0.227451,
      0.439216,
      0.541176,
      0.7,
      0.227451,
      0.403922,
      0.521569,
      0.75,
      0.231373,
      0.368627,
      0.501961,
      0.8,
      0.227451,
      0.321569,
      0.470588,
      0.85,
      0.219608,
      0.282353,
      0.439216,
      0.9,
      0.192157,
      0.235294,
      0.4,
      0.95,
      0.160784,
      0.184314,
      0.34902,
      1,
      0.133333,
      0.12549,
      0.301961
    ]
  },
  {
    ColorSpace: "HSV",
    Name: "Blue to Red Rainbow",
    NanColor: [
      0.498039215686,
      0.498039215686,
      0.498039215686
    ],
    RGBPoints: [
      0,
      0,
      0,
      1,
      1,
      1,
      0,
      0
    ]
  },
  {
    ColorSpace: "HSV",
    Name: "Red to Blue Rainbow",
    NanColor: [
      0.498039215686,
      0.498039215686,
      0.498039215686
    ],
    RGBPoints: [
      0,
      1,
      0,
      0,
      1,
      0,
      0,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Rainbow Blended White",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      1,
      1,
      1,
      0.17,
      0,
      0,
      1,
      0.34,
      0,
      1,
      1,
      0.5,
      0,
      1,
      0,
      0.67,
      1,
      1,
      0,
      0.84,
      1,
      0,
      0,
      1,
      0.878431372549,
      0,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Rainbow Blended Grey",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0.317647058824,
      0.341176470588,
      0.43137254902,
      0.17,
      0,
      0,
      1,
      0.34,
      0,
      1,
      1,
      0.5,
      0,
      1,
      0,
      0.67,
      1,
      1,
      0,
      0.84,
      1,
      0,
      0,
      1,
      0.878431372549,
      0,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Rainbow Blended Black",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0,
      0,
      0,
      0.17,
      0,
      0,
      1,
      0.34,
      0,
      1,
      1,
      0.5,
      0,
      1,
      0,
      0.67,
      1,
      1,
      0,
      0.84,
      1,
      0,
      0,
      1,
      0.878431372549,
      0,
      1
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Blue to Yellow",
    NanColor: [
      1,
      0,
      0
    ],
    RGBPoints: [
      0,
      0.0392156862745,
      0.0392156862745,
      0.949019607843,
      1,
      0.949019607843,
      0.949019607843,
      0.0392156862745
    ]
  },
  {
    ColorSpace: "HSV",
    Name: "blot",
    RGBPoints: [
      0,
      0,
      0,
      1,
      0.166,
      0,
      0,
      1,
      0.167,
      1,
      0,
      1,
      0.332,
      1,
      0,
      1,
      0.333,
      0,
      1,
      1,
      0.5,
      0,
      1,
      1,
      0.501,
      0,
      1,
      0,
      0.666,
      0,
      1,
      0,
      0.667,
      1,
      1,
      0,
      0.832,
      1,
      1,
      0,
      0.833,
      1,
      0,
      0,
      1,
      1,
      0,
      0
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "CIELab Blue to Red",
    NanColor: [
      1,
      1,
      0
    ],
    RGBPoints: [
      0,
      0,
      0.6,
      0.749019607843,
      1,
      0.76862745098,
      0.466666666667,
      0.341176470588
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "jet",
    RGBPoints: [
      -1,
      0,
      0,
      0.5625,
      -0.777778,
      0,
      0,
      1,
      -0.269841,
      0,
      1,
      1,
      -0.015873,
      0.5,
      1,
      0.5,
      0.238095,
      1,
      1,
      0,
      0.746032,
      1,
      0,
      0,
      1,
      0.5,
      0,
      0
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "rainbow",
    RGBPoints: [
      -1,
      0,
      0,
      1,
      -0.5,
      0,
      1,
      1,
      0,
      0,
      1,
      0,
      0.5,
      1,
      1,
      0,
      1,
      1,
      0,
      0
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_rainbow_bright",
    RGBPoints: [
      -1,
      0.32549,
      0.14902,
      0.960784,
      -0.866221,
      0.297047,
      0.375586,
      0.963836,
      -0.732441,
      0.180302,
      0.536818,
      0.964627,
      -0.598662,
      0.1302,
      0.649207,
      0.929647,
      -0.464883,
      0.0445143,
      0.749654,
      0.855998,
      -0.331104,
      0.0271325,
      0.830713,
      0.721527,
      -0.197324,
      0.259504,
      0.866145,
      0.543555,
      -0.0635452,
      0.428364,
      0.890725,
      0.329819,
      0.0702341,
      0.568503,
      0.898508,
      0.187623,
      0.204013,
      0.738259,
      0.890317,
      0.0825461,
      0.337793,
      0.84546,
      0.86136,
      0.0147555,
      0.471572,
      0.912191,
      0.808018,
      0,
      0.605351,
      0.962848,
      0.710445,
      0,
      0.73913,
      0.999469,
      0.600258,
      0.0176284,
      0.87291,
      0.994156,
      0.445975,
      0.193912,
      1,
      0.980407,
      0.247105,
      0.262699
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_rainbow_dark",
    RGBPoints: [
      -1,
      0,
      0,
      0.423499,
      -0.866221,
      0,
      0.119346,
      0.529237,
      -0.732441,
      0,
      0.238691,
      0.634976,
      -0.598662,
      0,
      0.346852,
      0.68788,
      -0.464883,
      0,
      0.45022,
      0.718141,
      -0.331104,
      0,
      0.553554,
      0.664839,
      -0.197324,
      0,
      0.651082,
      0.519303,
      -0.0635452,
      0.115841,
      0.72479,
      0.352857,
      0.0702341,
      0.326771,
      0.781195,
      0.140187,
      0.204013,
      0.522765,
      0.798524,
      0.0284624,
      0.337793,
      0.703162,
      0.788685,
      885756e-8,
      0.471572,
      0.845118,
      0.751133,
      0,
      0.605351,
      0.955734,
      0.690825,
      0,
      0.73913,
      0.995402,
      0.567916,
      0.0618524,
      0.87291,
      0.987712,
      0.403398,
      0.164851,
      1,
      0.980407,
      0.247105,
      0.262699
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "nic_CubicL",
    RGBPoints: [
      -1,
      0.479965,
      0.0118108,
      0.5307,
      -0.87451,
      0.522213,
      0.0551282,
      0.706919,
      -0.74902,
      0.50839,
      0.237278,
      0.867764,
      -0.623529,
      0.451617,
      0.373834,
      0.987255,
      -0.498039,
      0.39365,
      0.497255,
      0.97506,
      -0.372549,
      0.328631,
      0.599639,
      0.891843,
      -0.247059,
      0.250043,
      0.690286,
      0.778553,
      -0.121569,
      0.249656,
      0.764905,
      0.645857,
      392157e-8,
      0.297954,
      0.821466,
      0.50449,
      0.129412,
      0.337509,
      0.872595,
      0.358447,
      0.254902,
      0.430011,
      0.913789,
      0.297079,
      0.380392,
      0.587191,
      0.931381,
      0.333353,
      0.505882,
      0.727937,
      0.93591,
      0.353742,
      0.631373,
      0.826403,
      0.921081,
      0.365066,
      0.756863,
      0.893201,
      0.846317,
      0.372662,
      0.882353,
      0.965347,
      0.73884,
      0.378506,
      1,
      0.983235,
      0.597451,
      0.366856
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "nic_CubicYF",
    RGBPoints: [
      -1,
      0.5151,
      0.0482,
      0.6697,
      -0.87451,
      0.520711,
      0.168955,
      0.800574,
      -0.74902,
      0.493694,
      0.278596,
      0.911824,
      -0.623529,
      0.440026,
      0.369475,
      0.984978,
      -0.498039,
      0.398932,
      0.457593,
      0.987053,
      -0.372549,
      0.350651,
      0.540644,
      0.929608,
      -0.247059,
      0.298827,
      0.615625,
      0.857729,
      -0.121569,
      0.239928,
      0.685061,
      0.769531,
      392157e-8,
      0.228832,
      0.739349,
      0.673287,
      0.129412,
      0.263297,
      0.78608,
      0.569988,
      0.254902,
      0.298107,
      0.828337,
      0.460214,
      0.380392,
      0.33092,
      0.864071,
      0.352674,
      0.505882,
      0.38306,
      0.898169,
      0.287309,
      0.631373,
      0.49023,
      0.917481,
      0.307961,
      0.756863,
      0.62372,
      0.926026,
      0.332309,
      0.882353,
      0.717458,
      0.92527,
      0.342476,
      1,
      0.8,
      0.9255,
      0.3529
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "gist_earth",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.239216,
      0.027451,
      0.415686,
      -0.74902,
      0.0901961,
      0.254902,
      0.556863,
      -0.623529,
      0.0941176,
      0.352941,
      0.54902,
      -0.498039,
      0.105882,
      0.435294,
      0.533333,
      -0.372549,
      0.12549,
      0.52549,
      0.501961,
      -0.247059,
      0.156863,
      0.596078,
      0.443137,
      -0.121569,
      0.196078,
      0.65098,
      0.380392,
      392157e-8,
      0.282353,
      0.717647,
      0.301961,
      0.129412,
      0.466667,
      0.772549,
      0.27451,
      0.254902,
      0.678431,
      0.784314,
      0.309804,
      0.380392,
      0.901961,
      0.756863,
      0.376471,
      0.505882,
      0.992157,
      0.705882,
      0.521569,
      0.631373,
      1,
      0.721569,
      0.701961,
      0.756863,
      1,
      0.784314,
      0.784314,
      0.882353,
      1,
      0.866667,
      0.866667,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "2hot",
    RGBPoints: [
      -1,
      0.0416667,
      0,
      0,
      -0.873016,
      0.208333,
      0,
      0,
      -0.746032,
      0.375,
      0,
      0,
      -0.619048,
      0.541667,
      0,
      0,
      -0.492063,
      0.708333,
      0,
      0,
      -0.365079,
      0.854137,
      0,
      0,
      -0.238095,
      0.937488,
      0.039062,
      0,
      -0.111111,
      1,
      0.208333,
      0,
      0.015873,
      1,
      0.375,
      0,
      0.142857,
      1,
      0.541667,
      0,
      0.269841,
      1,
      0.708333,
      0,
      0.396825,
      1,
      0.858805,
      0.03125,
      0.52381,
      1,
      0.947392,
      0.15625,
      0.650794,
      1,
      1,
      0.3125,
      0.777778,
      1,
      1,
      0.5625,
      0.904762,
      1,
      1,
      0.8125,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_red2yellow_BW",
    RGBPoints: [
      -1,
      754296e-12,
      0,
      109827e-10,
      -0.87451,
      0.18285,
      0.0264094,
      0,
      -0.74902,
      0.3066,
      0,
      0,
      -0.623529,
      0.422841,
      0,
      0,
      -0.498039,
      0.522945,
      0,
      0,
      -0.372549,
      0.605721,
      0,
      0,
      -0.247059,
      0.672502,
      0.14168,
      0,
      -0.121569,
      0.728167,
      0.244025,
      0,
      392157e-8,
      0.781215,
      0.333454,
      0,
      0.129412,
      0.825,
      0.423586,
      0,
      0.254902,
      0.855893,
      0.516793,
      0,
      0.380392,
      0.880491,
      0.608846,
      0,
      0.505882,
      0.910305,
      0.695505,
      0,
      0.631373,
      0.94109,
      0.779067,
      0.223528,
      0.756863,
      0.967873,
      0.858572,
      0.473521,
      0.882353,
      0.986815,
      0.933211,
      0.751583,
      1,
      1,
      1,
      0.999997
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_marine2gold_BW",
    RGBPoints: [
      -1,
      111641e-12,
      0,
      162551e-11,
      -0.87451,
      0.0413146,
      0.0619808,
      0.209857,
      -0.74902,
      0.0185557,
      0.101341,
      0.350684,
      -0.623529,
      486405e-8,
      0.149847,
      0.461054,
      -0.498039,
      0.0836345,
      0.210845,
      0.517906,
      -0.372549,
      0.173222,
      0.276134,
      0.541793,
      -0.247059,
      0.259857,
      0.343877,
      0.535869,
      -0.121569,
      0.362299,
      0.408124,
      0.504293,
      392157e-8,
      0.468266,
      0.468276,
      0.468257,
      0.129412,
      0.582781,
      0.527545,
      0.374914,
      0.254902,
      0.691591,
      0.585251,
      0.274266,
      0.380392,
      0.784454,
      0.645091,
      0.247332,
      0.505882,
      0.862299,
      0.710383,
      0.27518,
      0.631373,
      0.920863,
      0.782923,
      0.351563,
      0.756863,
      0.955792,
      0.859699,
      0.533541,
      0.882353,
      0.976162,
      0.93433,
      0.780671,
      1,
      1,
      1,
      0.999983
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_blue2gold_BW",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.0742735,
      0.0440331,
      0.230013,
      -0.74902,
      0.125276,
      0.0258685,
      0.415826,
      -0.623529,
      0.143879,
      0.0163031,
      0.591346,
      -0.498039,
      0.212261,
      0.0627855,
      0.705239,
      -0.372549,
      0.306048,
      0.141178,
      0.763636,
      -0.247059,
      0.391537,
      0.232286,
      0.773263,
      -0.121569,
      0.461734,
      0.336633,
      0.708321,
      392157e-8,
      0.54209,
      0.427581,
      0.590007,
      0.129412,
      0.61704,
      0.508623,
      0.460978,
      0.254902,
      0.702703,
      0.579586,
      0.309117,
      0.380392,
      0.790336,
      0.644811,
      0.170397,
      0.505882,
      0.870173,
      0.710733,
      0.117134,
      0.631373,
      0.93656,
      0.781991,
      0.157144,
      0.756863,
      0.965672,
      0.862068,
      0.409836,
      0.882353,
      0.985751,
      0.936296,
      0.714162,
      1,
      1,
      1,
      0.999999
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_sapphire2gold_BW",
    RGBPoints: [
      -1,
      0.107704,
      0.107708,
      0.107694,
      -0.87451,
      0.1851,
      0.112354,
      0.308554,
      -0.74902,
      0.236782,
      0.114233,
      0.48788,
      -0.623529,
      0.28296,
      0.126187,
      0.639464,
      -0.498039,
      0.344787,
      0.171643,
      0.739713,
      -0.372549,
      0.413325,
      0.242371,
      0.76913,
      -0.247059,
      0.481863,
      0.3131,
      0.719841,
      -0.121569,
      0.550402,
      0.383829,
      0.612222,
      392157e-8,
      0.61894,
      0.454558,
      0.51126,
      0.129412,
      0.687478,
      0.525287,
      0.39993,
      0.254902,
      0.756017,
      0.596016,
      0.289923,
      0.380392,
      0.824555,
      0.666745,
      0.255498,
      0.505882,
      0.892979,
      0.736822,
      0.27696,
      0.631373,
      0.938851,
      0.804966,
      0.351734,
      0.756863,
      0.966491,
      0.874853,
      0.53572,
      0.882353,
      0.982105,
      0.94153,
      0.782579,
      1,
      1,
      1,
      0.999986
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_red2purple_BW",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.167793,
      0.0166271,
      0.0431278,
      -0.74902,
      0.262608,
      0.0107595,
      0.0791181,
      -0.623529,
      0.351902,
      0.0101858,
      0.100926,
      -0.498039,
      0.441257,
      0.0160835,
      0.131919,
      -0.372549,
      0.5221,
      0.0555972,
      0.195625,
      -0.247059,
      0.593852,
      0.104294,
      0.310234,
      -0.121569,
      0.654628,
      0.158115,
      0.448486,
      392157e-8,
      0.707443,
      0.220914,
      0.570253,
      0.129412,
      0.749504,
      0.293268,
      0.67897,
      0.254902,
      0.781587,
      0.370517,
      0.779269,
      0.380392,
      0.809951,
      0.451099,
      0.855831,
      0.505882,
      0.84424,
      0.531462,
      0.900451,
      0.631373,
      0.865174,
      0.620901,
      0.91606,
      0.756863,
      0.875041,
      0.714054,
      0.910284,
      0.882353,
      0.880764,
      0.80554,
      0.896276,
      1,
      0.887572,
      0.887591,
      0.887556
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_purple2pink_BW",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.117562,
      0.0291202,
      0.175876,
      -0.74902,
      0.178368,
      0.0458476,
      0.285454,
      -0.623529,
      0.237731,
      0.0680173,
      0.387717,
      -0.498039,
      0.300877,
      0.0956291,
      0.484802,
      -0.372549,
      0.370929,
      0.136858,
      0.554985,
      -0.247059,
      0.449033,
      0.189273,
      0.58863,
      -0.121569,
      0.529971,
      0.245796,
      0.598587,
      392157e-8,
      0.609914,
      0.300643,
      0.610244,
      0.129412,
      0.697079,
      0.351286,
      0.616371,
      0.254902,
      0.785858,
      0.401991,
      0.617376,
      0.380392,
      0.862517,
      0.45745,
      0.64463,
      0.505882,
      0.91359,
      0.525462,
      0.705336,
      0.631373,
      0.932583,
      0.61064,
      0.767412,
      0.756863,
      0.922478,
      0.706966,
      0.817522,
      0.882353,
      0.901302,
      0.803071,
      0.856311,
      1,
      0.887571,
      0.887591,
      0.887549
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_pbj_lin",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.091821,
      0.0611476,
      0.10617,
      -0.74902,
      0.160311,
      0.0900022,
      0.192713,
      -0.623529,
      0.22484,
      0.12126,
      0.272128,
      -0.498039,
      0.291263,
      0.157469,
      0.340828,
      -0.372549,
      0.360015,
      0.200388,
      0.388903,
      -0.247059,
      0.437497,
      0.250058,
      0.387201,
      -0.121569,
      0.512636,
      0.304969,
      0.355955,
      392157e-8,
      0.582603,
      0.360874,
      0.33488,
      0.129412,
      0.655126,
      0.416374,
      0.306351,
      0.254902,
      0.725889,
      0.473329,
      0.279051,
      0.380392,
      0.778125,
      0.537928,
      0.302697,
      0.505882,
      0.815894,
      0.606931,
      0.382431,
      0.631373,
      0.839159,
      0.679308,
      0.497608,
      0.756863,
      0.854748,
      0.751666,
      0.631792,
      0.882353,
      0.869483,
      0.822508,
      0.768592,
      1,
      0.887572,
      0.887589,
      0.887565
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_blue2green_muted",
    RGBPoints: [
      -1,
      0.107704,
      0.107708,
      0.107695,
      -0.87451,
      0.141522,
      0.13066,
      0.270741,
      -0.74902,
      0.180123,
      0.146119,
      0.42308,
      -0.623529,
      0.210161,
      0.169674,
      0.551795,
      -0.498039,
      0.239701,
      0.212939,
      0.634969,
      -0.372549,
      0.253916,
      0.282947,
      0.653641,
      -0.247059,
      0.242791,
      0.366933,
      0.608521,
      -0.121569,
      0.226302,
      0.446776,
      0.52693,
      392157e-8,
      0.236237,
      0.514689,
      0.458798,
      0.129412,
      0.274641,
      0.577589,
      0.376069,
      0.254902,
      0.349625,
      0.633993,
      0.288131,
      0.380392,
      0.4437,
      0.683677,
      0.260497,
      0.505882,
      0.536247,
      0.731214,
      0.285424,
      0.631373,
      0.628472,
      0.777128,
      0.349151,
      0.756863,
      0.718259,
      0.819287,
      0.496825,
      0.882353,
      0.804768,
      0.856164,
      0.703299,
      1,
      0.887571,
      0.887591,
      0.887548
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_blue2green_BW",
    RGBPoints: [
      -1,
      363578e-12,
      0,
      529374e-11,
      -0.87451,
      0.0539915,
      0.0577948,
      0.212806,
      -0.74902,
      0.0620393,
      0.0758942,
      0.388959,
      -0.623529,
      0.0697499,
      0.102032,
      0.54177,
      -0.498039,
      0.113295,
      0.156156,
      0.64334,
      -0.372549,
      0.152047,
      0.243196,
      0.670283,
      -0.247059,
      0.158096,
      0.344084,
      0.622864,
      -0.121569,
      0.151142,
      0.43922,
      0.532767,
      392157e-8,
      0.17155,
      0.521588,
      0.457719,
      0.129412,
      0.225861,
      0.599141,
      0.363997,
      0.254902,
      0.32328,
      0.67007,
      0.259083,
      0.380392,
      0.442344,
      0.733697,
      0.223754,
      0.505882,
      0.558409,
      0.794941,
      0.257411,
      0.631373,
      0.673875,
      0.854344,
      0.340822,
      0.756863,
      0.787244,
      0.909326,
      0.524717,
      0.882353,
      0.896483,
      0.958063,
      0.775914,
      1,
      1,
      1,
      0.999982
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "GREEN-WHITE_LINEAR",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0,
      0.062745,
      0,
      -0.74902,
      0,
      0.12549,
      0,
      -0.623529,
      0,
      0.188235,
      0,
      -0.498039,
      0,
      0.25098,
      0,
      -0.372549,
      0,
      0.313725,
      0,
      -0.247059,
      0,
      0.376471,
      0,
      -0.121569,
      0.094118,
      0.439216,
      0,
      392157e-8,
      0.196078,
      0.501961,
      0,
      0.129412,
      0.294118,
      0.564706,
      0,
      0.254902,
      0.396078,
      0.627451,
      0,
      0.380392,
      0.498039,
      0.690196,
      0,
      0.505882,
      0.6,
      0.752941,
      0.145098,
      0.631373,
      0.701961,
      0.815686,
      0.364706,
      0.756863,
      0.8,
      0.878431,
      0.580392,
      0.882353,
      0.901961,
      0.941176,
      0.796078,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_green2yellow_BW",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0,
      0.105542,
      0.0603919,
      -0.74902,
      0,
      0.159454,
      0.104148,
      -0.623529,
      0,
      0.219502,
      0.15542,
      -0.498039,
      0,
      0.282276,
      0.203811,
      -0.372549,
      0,
      0.346331,
      0.235652,
      -0.247059,
      0,
      0.411765,
      0.235428,
      -0.121569,
      0,
      0.477177,
      0.217977,
      392157e-8,
      0.0593644,
      0.541635,
      0.21361,
      0.129412,
      0.233081,
      0.604722,
      0.210591,
      0.254902,
      0.369803,
      0.664942,
      0.226536,
      0.380392,
      0.498446,
      0.722367,
      0.288237,
      0.505882,
      0.601929,
      0.782244,
      0.380815,
      0.631373,
      0.703207,
      0.840497,
      0.512134,
      0.756863,
      0.803186,
      0.896433,
      0.674462,
      0.882353,
      0.903834,
      0.950266,
      0.846715,
      1,
      1,
      1,
      0.999981
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "blue2cyan",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0,
      0.152941,
      0.364706,
      -0.74902,
      0,
      0.254902,
      0.470588,
      -0.623529,
      0,
      0.34902,
      0.572549,
      -0.498039,
      0,
      0.443137,
      0.670588,
      -0.372549,
      0,
      0.537255,
      0.772549,
      -0.247059,
      0,
      0.627451,
      0.870588,
      -0.121569,
      0,
      0.717647,
      0.964706,
      392157e-8,
      0.0784314,
      0.772549,
      1,
      0.129412,
      0.207843,
      0.858824,
      1,
      0.254902,
      0.32549,
      0.941176,
      1,
      0.380392,
      0.45098,
      1,
      1,
      0.505882,
      0.560784,
      1,
      1,
      0.631373,
      0.662745,
      1,
      1,
      0.756863,
      0.760784,
      1,
      1,
      0.882353,
      0.870588,
      1,
      1,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_blue2cyan_BW",
    RGBPoints: [
      -1,
      405298e-12,
      0,
      59012e-10,
      -0.87451,
      0.0207526,
      0.0740933,
      0.18093,
      -0.74902,
      0,
      0.121033,
      0.30343,
      -0.623529,
      0,
      0.166892,
      0.416095,
      -0.498039,
      0,
      0.216768,
      0.524796,
      -0.372549,
      0.0164769,
      0.275471,
      0.608585,
      -0.247059,
      0.0544527,
      0.344824,
      0.659267,
      -0.121569,
      0.0880643,
      0.419118,
      0.688675,
      392157e-8,
      0.127938,
      0.492556,
      0.720256,
      0.129412,
      0.149476,
      0.566946,
      0.756918,
      0.254902,
      0.188961,
      0.641333,
      0.792122,
      0.380392,
      0.245482,
      0.715336,
      0.827609,
      0.505882,
      0.329216,
      0.786235,
      0.874761,
      0.631373,
      0.453558,
      0.852803,
      0.918466,
      0.756863,
      0.626281,
      0.910493,
      0.954,
      0.882353,
      0.82257,
      0.958709,
      0.980146,
      1,
      1,
      1,
      0.999989
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_blue_BW",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.0425591,
      0.0763529,
      0.150682,
      -0.74902,
      0.0569472,
      0.119154,
      0.275403,
      -0.623529,
      0.0635978,
      0.164772,
      0.395427,
      -0.498039,
      0.0774342,
      0.213851,
      0.510014,
      -0.372549,
      0.106815,
      0.267034,
      0.615102,
      -0.247059,
      0.122093,
      0.324649,
      0.720068,
      -0.121569,
      0.160851,
      0.387068,
      0.806956,
      392157e-8,
      0.213754,
      0.453516,
      0.878012,
      0.129412,
      0.26722,
      0.524656,
      0.932436,
      0.254902,
      0.326844,
      0.599279,
      0.968038,
      0.380392,
      0.403403,
      0.674712,
      0.984784,
      0.505882,
      0.499703,
      0.745519,
      1,
      0.631373,
      0.615055,
      0.813983,
      1,
      0.756863,
      0.74405,
      0.879228,
      1,
      0.882353,
      0.877909,
      0.941913,
      1,
      1,
      1,
      1,
      0.999996
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "BLUE-WHITE",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0,
      0,
      0.082353,
      -0.74902,
      0,
      0,
      0.168627,
      -0.623529,
      0,
      0,
      0.254902,
      -0.498039,
      0,
      0,
      0.337255,
      -0.372549,
      0,
      0,
      0.423529,
      -0.247059,
      0,
      0,
      0.509804,
      -0.121569,
      0,
      0.101961,
      0.592157,
      392157e-8,
      0,
      0.203922,
      0.678431,
      0.129412,
      0,
      0.301961,
      0.764706,
      0.254902,
      0,
      0.403922,
      0.85098,
      0.380392,
      0,
      0.505882,
      0.933333,
      0.505882,
      0,
      0.603922,
      1,
      0.631373,
      0.254902,
      0.705882,
      1,
      0.756863,
      0.509804,
      0.807843,
      1,
      0.882353,
      0.764706,
      0.905882,
      1,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_purple_BW",
    RGBPoints: [
      -1,
      4264e-11,
      0,
      620844e-12,
      -0.87451,
      0.100579,
      0.0593111,
      0.145666,
      -0.74902,
      0.167794,
      0.0889224,
      0.254953,
      -0.623529,
      0.231446,
      0.123339,
      0.360511,
      -0.498039,
      0.296699,
      0.163027,
      0.461278,
      -0.372549,
      0.363211,
      0.209286,
      0.55306,
      -0.247059,
      0.431136,
      0.260776,
      0.637195,
      -0.121569,
      0.498202,
      0.320012,
      0.705799,
      392157e-8,
      0.567456,
      0.380459,
      0.778091,
      0.129412,
      0.629381,
      0.445284,
      0.8448,
      0.254902,
      0.688373,
      0.517374,
      0.895694,
      0.380392,
      0.74891,
      0.590906,
      0.93976,
      0.505882,
      0.805017,
      0.667956,
      0.977626,
      0.631373,
      0.850914,
      0.752618,
      0.992396,
      0.756863,
      0.89724,
      0.838454,
      0.994093,
      0.882353,
      0.948461,
      0.922603,
      0.994449,
      1,
      1,
      1,
      0.999967
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_magenta_BW",
    RGBPoints: [
      -1,
      0,
      0,
      254023e-10,
      -0.87451,
      0.128696,
      0.0456782,
      0.11635,
      -0.74902,
      0.228133,
      0.0476299,
      0.201452,
      -0.623529,
      0.327273,
      0.0374065,
      0.282107,
      -0.498039,
      0.420953,
      0.0408166,
      0.35709,
      -0.372549,
      0.511562,
      0.0642203,
      0.430511,
      -0.247059,
      0.599552,
      0.102686,
      0.504257,
      -0.121569,
      0.684646,
      0.150536,
      0.579429,
      392157e-8,
      0.765817,
      0.205978,
      0.656062,
      0.129412,
      0.839176,
      0.27229,
      0.731807,
      0.254902,
      0.89536,
      0.357594,
      0.797309,
      0.380392,
      0.930238,
      0.457825,
      0.846984,
      0.505882,
      0.945921,
      0.564536,
      0.880571,
      0.631373,
      0.948995,
      0.670753,
      0.902279,
      0.756863,
      0.947124,
      0.772819,
      0.918171,
      0.882353,
      0.947265,
      0.869424,
      0.934352,
      1,
      0.954719,
      0.95475,
      0.954726
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "magenta",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.364706,
      0,
      0.152941,
      -0.74902,
      0.470588,
      0,
      0.254902,
      -0.623529,
      0.572549,
      0,
      0.34902,
      -0.498039,
      0.670588,
      0,
      0.443137,
      -0.372549,
      0.772549,
      0,
      0.537255,
      -0.247059,
      0.870588,
      0,
      0.627451,
      -0.121569,
      0.964706,
      0,
      0.717647,
      392157e-8,
      1,
      0.0784314,
      0.772549,
      0.129412,
      1,
      0.207843,
      0.858824,
      0.254902,
      1,
      0.32549,
      0.941176,
      0.380392,
      1,
      0.45098,
      1,
      0.505882,
      1,
      0.560784,
      1,
      0.631373,
      1,
      0.662745,
      1,
      0.756863,
      1,
      0.760784,
      1,
      0.882353,
      1,
      0.870588,
      1,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "RED-PURPLE",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.188235,
      0,
      7843e-6,
      -0.74902,
      0.345098,
      0,
      0.035294,
      -0.623529,
      0.439216,
      0,
      0.098039,
      -0.498039,
      0.533333,
      0,
      0.152941,
      -0.372549,
      0.627451,
      0.015686,
      0.211765,
      -0.247059,
      0.721569,
      0.031373,
      0.266667,
      -0.121569,
      0.8,
      0.047059,
      0.329412,
      392157e-8,
      0.862745,
      0.047059,
      0.403922,
      0.129412,
      0.941176,
      0.062745,
      0.466667,
      0.254902,
      0.988235,
      0.078431,
      0.54902,
      0.380392,
      0.988235,
      0.141176,
      0.643137,
      0.505882,
      0.988235,
      0.25098,
      0.729412,
      0.631373,
      0.988235,
      0.376471,
      0.811765,
      0.756863,
      0.988235,
      0.54902,
      0.886275,
      0.882353,
      0.988235,
      0.752941,
      0.952941,
      1,
      0.996078,
      0.996078,
      0.996078
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_red_BW",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.147204,
      0.0480135,
      0.0401815,
      -0.74902,
      0.253411,
      0.0617478,
      0.0301333,
      -0.623529,
      0.356059,
      0.0746331,
      0.0446897,
      -0.498039,
      0.457731,
      0.0934935,
      0.0636931,
      -0.372549,
      0.557199,
      0.122714,
      0.0860013,
      -0.247059,
      0.665179,
      0.144238,
      0.105585,
      -0.121569,
      0.763833,
      0.187056,
      0.138326,
      392157e-8,
      0.847035,
      0.254558,
      0.189407,
      0.129412,
      0.905663,
      0.345937,
      0.258215,
      0.254902,
      0.941431,
      0.447111,
      0.346277,
      0.380392,
      0.962608,
      0.546927,
      0.457571,
      0.505882,
      0.987833,
      0.637276,
      0.569944,
      0.631373,
      0.994202,
      0.732176,
      0.687958,
      0.756863,
      0.993304,
      0.826268,
      0.800567,
      0.882353,
      0.994413,
      0.917205,
      0.906393,
      1,
      1,
      1,
      0.999979
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "RED_TEMPERATURE",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.090196,
      0,
      0,
      -0.74902,
      0.180392,
      0,
      0,
      -0.623529,
      0.270588,
      0,
      0,
      -0.498039,
      0.360784,
      0,
      0,
      -0.372549,
      0.45098,
      0,
      0,
      -0.247059,
      0.545098,
      0,
      0,
      -0.121569,
      0.635294,
      0,
      0,
      392157e-8,
      0.72549,
      0.058824,
      0,
      0.129412,
      0.815686,
      0.176471,
      0,
      0.254902,
      0.905882,
      0.294118,
      0,
      0.380392,
      1,
      0.411765,
      0,
      0.505882,
      1,
      0.533333,
      0.027451,
      0.631373,
      1,
      0.65098,
      0.27451,
      0.756863,
      1,
      0.768627,
      0.521569,
      0.882353,
      1,
      0.886275,
      0.768627,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_orange_BW",
    RGBPoints: [
      -1,
      0,
      0,
      253806e-10,
      -0.87451,
      0.135871,
      0.0593824,
      0,
      -0.74902,
      0.224328,
      0.0907216,
      0,
      -0.623529,
      0.318083,
      0.119647,
      0,
      -0.498039,
      0.414443,
      0.150246,
      0,
      -0.372549,
      0.511077,
      0.184884,
      0,
      -0.247059,
      0.605501,
      0.226033,
      0,
      -0.121569,
      0.695274,
      0.275491,
      0,
      392157e-8,
      0.777826,
      0.334445,
      0,
      0.129412,
      0.851498,
      0.402441,
      0,
      0.254902,
      0.915899,
      0.47759,
      602975e-9,
      0.380392,
      0.971984,
      0.557882,
      0.0361443,
      0.505882,
      1,
      0.641287,
      0.135967,
      0.631373,
      1,
      0.725198,
      0.27997,
      0.756863,
      1,
      0.808205,
      0.438135,
      0.882353,
      1,
      0.89306,
      0.587036,
      1,
      1,
      0.977928,
      0.721599
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "heated_object",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.34902,
      0.0862745,
      0,
      -0.74902,
      0.45098,
      0.172549,
      0,
      -0.623529,
      0.52549,
      0.231373,
      0,
      -0.498039,
      0.580392,
      0.278431,
      0,
      -0.372549,
      0.623529,
      0.313725,
      0,
      -0.247059,
      0.670588,
      0.352941,
      0,
      -0.121569,
      0.717647,
      0.392157,
      0,
      392157e-8,
      0.772549,
      0.439216,
      0,
      0.129412,
      0.839216,
      0.494118,
      0,
      0.254902,
      0.901961,
      0.541176,
      0,
      0.380392,
      0.968627,
      0.6,
      0,
      0.505882,
      1,
      0.658824,
      0,
      0.631373,
      1,
      0.721569,
      0,
      0.756863,
      1,
      0.827451,
      0.298039,
      0.882353,
      1,
      0.976471,
      0.72549,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_gold_BW",
    RGBPoints: [
      -1,
      0,
      0,
      190933e-10,
      -0.87451,
      0.128363,
      0.0636265,
      0,
      -0.74902,
      0.193795,
      0.111057,
      0,
      -0.623529,
      0.25976,
      0.15987,
      0,
      -0.498039,
      0.328546,
      0.210589,
      0,
      -0.372549,
      0.399726,
      0.26332,
      0,
      -0.247059,
      0.472969,
      0.318261,
      0,
      -0.121569,
      0.546245,
      0.375827,
      0,
      392157e-8,
      0.61745,
      0.436719,
      0,
      0.129412,
      0.685545,
      0.501113,
      0,
      0.254902,
      0.749578,
      0.568799,
      0,
      0.380392,
      0.80962,
      0.6394,
      0,
      0.505882,
      0.865572,
      0.712699,
      0.10257,
      0.631373,
      0.917709,
      0.787569,
      0.233665,
      0.756863,
      0.966914,
      0.863138,
      0.369608,
      0.882353,
      1,
      0.939405,
      0.496104,
      1,
      0.999225,
      1,
      0.612275
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_brown_BW",
    RGBPoints: [
      -1,
      33216e-11,
      0,
      483629e-11,
      -0.87451,
      0.14693,
      0.0518172,
      0,
      -0.74902,
      0.225806,
      0.0814996,
      0,
      -0.623529,
      0.301681,
      0.111452,
      0,
      -0.498039,
      0.370487,
      0.150664,
      0,
      -0.372549,
      0.43108,
      0.199477,
      0,
      -0.247059,
      0.4849,
      0.255107,
      0,
      -0.121569,
      0.536798,
      0.313486,
      0,
      392157e-8,
      0.59286,
      0.371167,
      0,
      0.129412,
      0.653119,
      0.428135,
      0,
      0.254902,
      0.714589,
      0.485917,
      0.0379541,
      0.380392,
      0.774667,
      0.54565,
      0.116634,
      0.505882,
      0.831222,
      0.608047,
      0.183895,
      0.631373,
      0.880305,
      0.674199,
      0.260298,
      0.756863,
      0.922314,
      0.742472,
      0.367086,
      0.882353,
      0.959408,
      0.811222,
      0.497258,
      1,
      0.993548,
      0.875183,
      0.622093
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "copper_Matlab",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.0784314,
      0.0501961,
      0.0313725,
      -0.74902,
      0.156863,
      0.100392,
      0.0627451,
      -0.623529,
      0.235294,
      0.150588,
      0.0941176,
      -0.498039,
      0.313725,
      0.200784,
      0.12549,
      -0.372549,
      0.392157,
      0.25098,
      0.156863,
      -0.247059,
      0.470588,
      0.301176,
      0.188235,
      -0.121569,
      0.54902,
      0.351373,
      0.219608,
      392157e-8,
      0.627451,
      0.401569,
      0.25098,
      0.129412,
      0.705882,
      0.451765,
      0.282353,
      0.254902,
      0.784314,
      0.501961,
      0.313725,
      0.380392,
      0.862745,
      0.552157,
      0.345098,
      0.505882,
      0.941176,
      0.602353,
      0.376471,
      0.631373,
      1,
      0.652549,
      0.407843,
      0.756863,
      1,
      0.702745,
      0.439216,
      0.882353,
      1,
      0.752941,
      0.470588,
      1,
      1,
      0.8,
      0.5
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "pink_Matlab",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.312416,
      0.204524,
      0.204524,
      -0.74902,
      0.441822,
      0.289241,
      0.289241,
      -0.623529,
      0.54112,
      0.354246,
      0.354246,
      -0.498039,
      0.624831,
      0.409048,
      0.409048,
      -0.372549,
      0.698582,
      0.45733,
      0.45733,
      -0.247059,
      0.764404,
      0.502282,
      0.500979,
      -0.121569,
      0.791292,
      0.591516,
      0.54112,
      392157e-8,
      0.817297,
      0.66895,
      0.578481,
      0.129412,
      0.842499,
      0.738308,
      0.613572,
      0.254902,
      0.866968,
      0.801687,
      0.646762,
      0.380392,
      0.890766,
      0.86041,
      0.678329,
      0.505882,
      0.913944,
      0.913944,
      0.711254,
      0.631373,
      0.936549,
      0.936549,
      0.79459,
      0.756863,
      0.958621,
      0.958621,
      0.869979,
      0.882353,
      0.980196,
      0.980196,
      0.939336,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "bone_Matlab",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.054902,
      0.054902,
      0.075817,
      -0.74902,
      0.109804,
      0.109804,
      0.151634,
      -0.623529,
      0.164706,
      0.164706,
      0.227451,
      -0.498039,
      0.219608,
      0.219608,
      0.303268,
      -0.372549,
      0.27451,
      0.27451,
      0.379085,
      -0.247059,
      0.329412,
      0.329902,
      0.454412,
      -0.121569,
      0.384314,
      0.405719,
      0.509314,
      392157e-8,
      0.439216,
      0.481536,
      0.564216,
      0.129412,
      0.494118,
      0.557353,
      0.619118,
      0.254902,
      0.54902,
      0.63317,
      0.67402,
      0.380392,
      0.603922,
      0.708987,
      0.728922,
      0.505882,
      0.660294,
      0.783824,
      0.783824,
      0.631373,
      0.746569,
      0.838725,
      0.838725,
      0.756863,
      0.832843,
      0.893627,
      0.893627,
      0.882353,
      0.919118,
      0.948529,
      0.948529,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "gray_Matlab",
    RGBPoints: [
      -1,
      0,
      0,
      0,
      -0.87451,
      0.0627451,
      0.0627451,
      0.0627451,
      -0.74902,
      0.12549,
      0.12549,
      0.12549,
      -0.623529,
      0.188235,
      0.188235,
      0.188235,
      -0.498039,
      0.25098,
      0.25098,
      0.25098,
      -0.372549,
      0.313725,
      0.313725,
      0.313725,
      -0.247059,
      0.376471,
      0.376471,
      0.376471,
      -0.121569,
      0.439216,
      0.439216,
      0.439216,
      392157e-8,
      0.501961,
      0.501961,
      0.501961,
      0.129412,
      0.564706,
      0.564706,
      0.564706,
      0.254902,
      0.627451,
      0.627451,
      0.627451,
      0.380392,
      0.690196,
      0.690196,
      0.690196,
      0.505882,
      0.752941,
      0.752941,
      0.752941,
      0.631373,
      0.815686,
      0.815686,
      0.815686,
      0.756863,
      0.878431,
      0.878431,
      0.878431,
      0.882353,
      0.941176,
      0.941176,
      0.941176,
      1,
      1,
      1,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "Purples",
    RGBPoints: [
      -1,
      0.247059,
      0,
      0.490196,
      -0.87451,
      0.288397,
      0.07677,
      0.525629,
      -0.74902,
      0.32975,
      0.153587,
      0.561092,
      -0.623529,
      0.373057,
      0.236263,
      0.600461,
      -0.498039,
      0.416363,
      0.319,
      0.639923,
      -0.372549,
      0.459669,
      0.405613,
      0.685198,
      -0.247059,
      0.503345,
      0.491534,
      0.730058,
      -0.121569,
      0.562399,
      0.54862,
      0.757616,
      392157e-8,
      0.621453,
      0.606075,
      0.785544,
      0.129412,
      0.680508,
      0.674971,
      0.824914,
      0.254902,
      0.739562,
      0.743406,
      0.863899,
      0.380392,
      0.798616,
      0.800492,
      0.893426,
      0.505882,
      0.85684,
      0.856655,
      0.922491,
      0.631373,
      0.898178,
      0.894056,
      0.942176,
      0.756863,
      0.938654,
      0.930919,
      0.961646,
      0.882353,
      0.964245,
      0.958478,
      0.977393,
      1,
      0.988235,
      0.984314,
      0.992157
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "Blues",
    RGBPoints: [
      -1,
      0.031373,
      0.188235,
      0.419608,
      -0.87451,
      0.031373,
      0.253195,
      0.516063,
      -0.74902,
      0.031757,
      0.318139,
      0.612149,
      -0.623529,
      0.080969,
      0.38113,
      0.661361,
      -0.498039,
      0.130427,
      0.444152,
      0.710327,
      -0.372549,
      0.195386,
      0.509112,
      0.743791,
      -0.247059,
      0.260715,
      0.573841,
      0.777209,
      -0.121569,
      0.341423,
      0.628958,
      0.808704,
      392157e-8,
      0.422745,
      0.684075,
      0.839892,
      0.129412,
      0.523137,
      0.739193,
      0.861546,
      0.254902,
      0.622684,
      0.793464,
      0.883429,
      0.380392,
      0.701423,
      0.826928,
      0.910988,
      0.505882,
      0.778685,
      0.8603,
      0.937993,
      0.631373,
      0.825928,
      0.891795,
      0.953741,
      0.756863,
      0.87328,
      0.923291,
      0.969489,
      0.882353,
      0.922491,
      0.954787,
      0.985236,
      1,
      0.968627,
      0.984314,
      1
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "Greens",
    RGBPoints: [
      -1,
      0,
      0.266667,
      0.105882,
      -0.87451,
      0,
      0.347374,
      0.139346,
      -0.74902,
      538e-6,
      0.427912,
      0.172933,
      -0.623529,
      0.069435,
      0.486967,
      0.222145,
      -0.498039,
      0.138178,
      0.546082,
      0.271326,
      -0.372549,
      0.197232,
      0.609073,
      0.31857,
      -0.247059,
      0.257255,
      0.671742,
      0.365859,
      -0.121569,
      0.357647,
      0.720953,
      0.415071,
      392157e-8,
      0.45767,
      0.769919,
      0.465021,
      0.129412,
      0.546251,
      0.811257,
      0.537855,
      0.254902,
      0.634295,
      0.852211,
      0.610688,
      0.380392,
      0.709097,
      0.883706,
      0.683522,
      0.505882,
      0.78316,
      0.914833,
      0.755894,
      0.631373,
      0.842215,
      0.938454,
      0.818885,
      0.756863,
      0.899977,
      0.961538,
      0.880692,
      0.882353,
      0.935409,
      0.975317,
      0.92203,
      1,
      0.968627,
      0.988235,
      0.960784
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "PuBu",
    RGBPoints: [
      -1,
      0.301961,
      0,
      0.294118,
      -0.87451,
      0.404321,
      0.029527,
      0.390573,
      -0.74902,
      0.50599,
      0.059592,
      0.486782,
      -0.623529,
      0.519769,
      0.158016,
      0.551742,
      -0.498039,
      0.533456,
      0.256194,
      0.616301,
      -0.372549,
      0.54133,
      0.33887,
      0.655671,
      -0.247059,
      0.54902,
      0.421592,
      0.695087,
      -0.121569,
      0.54902,
      0.506236,
      0.736424,
      392157e-8,
      0.550127,
      0.590573,
      0.777701,
      0.129412,
      0.585559,
      0.665375,
      0.81707,
      0.254902,
      0.622145,
      0.739023,
      0.855825,
      0.380392,
      0.687105,
      0.784298,
      0.879446,
      0.505882,
      0.752065,
      0.829758,
      0.903253,
      0.631373,
      0.817024,
      0.87897,
      0.930811,
      0.756863,
      0.880907,
      0.927213,
      0.957832,
      0.882353,
      0.926182,
      0.958708,
      0.975548,
      1,
      0.968627,
      0.988235,
      0.992157
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "BuPu",
    RGBPoints: [
      -1,
      7843e-6,
      0.219608,
      0.345098,
      -0.87451,
      0.01178,
      0.286536,
      0.449427,
      -0.74902,
      0.015702,
      0.35328,
      0.553479,
      -0.623529,
      0.01767,
      0.396586,
      0.622376,
      -0.498039,
      0.021115,
      0.4402,
      0.690688,
      -0.372549,
      0.11757,
      0.503191,
      0.722184,
      -0.247059,
      0.214625,
      0.565859,
      0.753633,
      -0.121569,
      0.336671,
      0.615071,
      0.78316,
      392157e-8,
      0.457978,
      0.663975,
      0.812503,
      0.129412,
      0.556401,
      0.703345,
      0.836125,
      0.254902,
      0.65421,
      0.742714,
      0.859669,
      0.380392,
      0.736886,
      0.782084,
      0.881323,
      0.505882,
      0.81827,
      0.821638,
      0.903068,
      0.631373,
      0.873387,
      0.864944,
      0.92669,
      0.756863,
      0.927536,
      0.907605,
      0.949988,
      0.882353,
      0.964937,
      0.9391,
      0.967705,
      1,
      1,
      0.968627,
      0.984314
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "BuGn",
    RGBPoints: [
      -1,
      0.031373,
      0.25098,
      0.505882,
      -0.87451,
      0.031373,
      0.329719,
      0.590527,
      -0.74902,
      0.031911,
      0.408397,
      0.674787,
      -0.623529,
      0.100807,
      0.479262,
      0.710219,
      -0.498039,
      0.169704,
      0.550219,
      0.745744,
      -0.372549,
      0.238601,
      0.62699,
      0.787082,
      -0.247059,
      0.307958,
      0.703114,
      0.826759,
      -0.121569,
      0.39654,
      0.752326,
      0.797232,
      392157e-8,
      0.485121,
      0.801046,
      0.767705,
      0.129412,
      0.573702,
      0.83451,
      0.738178,
      0.254902,
      0.661592,
      0.867743,
      0.711034,
      0.380392,
      0.732457,
      0.895302,
      0.74253,
      0.505882,
      0.801845,
      0.922307,
      0.774579,
      0.631373,
      0.841215,
      0.938055,
      0.817885,
      0.756863,
      0.880907,
      0.95391,
      0.861084,
      0.882353,
      0.926182,
      0.971626,
      0.902422,
      1,
      0.968627,
      0.988235,
      0.941176
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "GnBu",
    RGBPoints: [
      -1,
      0,
      0.266667,
      0.105882,
      -0.87451,
      0,
      0.347374,
      0.139346,
      -0.74902,
      538e-6,
      0.427912,
      0.172933,
      -0.623529,
      0.069435,
      0.486967,
      0.222145,
      -0.498039,
      0.138178,
      0.546175,
      0.272095,
      -0.372549,
      0.197232,
      0.615071,
      0.368551,
      -0.247059,
      0.256609,
      0.683276,
      0.464867,
      -0.121569,
      0.329443,
      0.722645,
      0.555417,
      392157e-8,
      0.403137,
      0.762138,
      0.645413,
      0.129412,
      0.503529,
      0.805444,
      0.718247,
      0.254902,
      0.603922,
      0.848597,
      0.790465,
      0.380392,
      0.704314,
      0.887966,
      0.847551,
      0.505882,
      0.802307,
      0.926321,
      0.903714,
      0.631373,
      0.851519,
      0.944037,
      0.941115,
      0.756863,
      0.899977,
      0.961538,
      0.976901,
      0.882353,
      0.935409,
      0.975317,
      0.984775,
      1,
      0.968627,
      0.988235,
      0.992157
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "GnBuPu",
    RGBPoints: [
      -1,
      3922e-6,
      0.27451,
      0.211765,
      -0.87451,
      3922e-6,
      0.349312,
      0.280661,
      -0.74902,
      3937e-6,
      0.423852,
      0.349773,
      -0.623529,
      5905e-6,
      0.46519,
      0.446228,
      -0.498039,
      9443e-6,
      0.506344,
      0.542837,
      -0.372549,
      0.111803,
      0.535871,
      0.649135,
      -0.247059,
      0.214025,
      0.565859,
      0.753633,
      -0.121569,
      0.310481,
      0.615071,
      0.78316,
      392157e-8,
      0.407797,
      0.663975,
      0.812503,
      0.129412,
      0.531811,
      0.703345,
      0.836125,
      0.254902,
      0.65421,
      0.742714,
      0.859669,
      0.380392,
      0.736886,
      0.782084,
      0.881323,
      0.505882,
      0.81827,
      0.821176,
      0.902884,
      0.631373,
      0.873387,
      0.854641,
      0.922568,
      0.756863,
      0.927536,
      0.888535,
      0.942361,
      0.882353,
      0.964937,
      0.929873,
      0.964014,
      1,
      1,
      0.968627,
      0.984314
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "BuGnYl",
    RGBPoints: [
      -1,
      0.031373,
      0.113725,
      0.345098,
      -0.87451,
      0.088458,
      0.159,
      0.463206,
      -0.74902,
      0.145052,
      0.204567,
      0.5807,
      -0.623529,
      0.139146,
      0.287243,
      0.620069,
      -0.498039,
      0.13318,
      0.370196,
      0.659562,
      -0.372549,
      0.123337,
      0.470588,
      0.706805,
      -0.247059,
      0.115386,
      0.570335,
      0.753126,
      -0.121569,
      0.186251,
      0.643168,
      0.761,
      392157e-8,
      0.258716,
      0.71514,
      0.768074,
      0.129412,
      0.380761,
      0.760415,
      0.750358,
      0.254902,
      0.503576,
      0.806075,
      0.732795,
      0.380392,
      0.645306,
      0.861192,
      0.719016,
      0.505882,
      0.783899,
      0.91511,
      0.705606,
      0.631373,
      0.858701,
      0.944637,
      0.6997,
      0.756863,
      0.931349,
      0.973303,
      0.698424,
      0.882353,
      0.966782,
      0.987082,
      0.777163,
      1,
      1,
      1,
      0.85098
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "PuRd",
    RGBPoints: [
      -1,
      0.286275,
      0,
      0.415686,
      -0.87451,
      0.38273,
      1968e-6,
      0.441276,
      -0.74902,
      0.479231,
      3922e-6,
      0.466774,
      -0.623529,
      0.581592,
      3922e-6,
      0.480554,
      -0.498039,
      0.683799,
      549e-5,
      0.494887,
      -0.372549,
      0.776317,
      0.105882,
      0.544098,
      -0.247059,
      0.867866,
      0.206321,
      0.592618,
      -0.121569,
      0.919047,
      0.308681,
      0.612303,
      392157e-8,
      0.968812,
      0.411226,
      0.632603,
      0.129412,
      0.974717,
      0.519493,
      0.671972,
      0.254902,
      0.980546,
      0.626451,
      0.71065,
      0.380392,
      0.984483,
      0.701253,
      0.732303,
      0.505882,
      0.988328,
      0.77504,
      0.755617,
      0.631373,
      0.990296,
      0.828189,
      0.812703,
      0.756863,
      0.992372,
      0.880907,
      0.869035,
      0.882353,
      0.996309,
      0.926182,
      0.912341,
      1,
      1,
      0.968627,
      0.952941
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "RdPu",
    RGBPoints: [
      -1,
      0.403922,
      0,
      0.121569,
      -0.87451,
      0.500377,
      0,
      0.192434,
      -0.74902,
      0.596909,
      277e-6,
      0.263037,
      -0.623529,
      0.703206,
      0.035709,
      0.300438,
      -0.498039,
      0.808612,
      0.071296,
      0.338854,
      -0.372549,
      0.857824,
      0.116571,
      0.441215,
      -0.247059,
      0.905513,
      0.163552,
      0.54293,
      -0.121569,
      0.889765,
      0.281661,
      0.617732,
      392157e-8,
      0.873156,
      0.39897,
      0.691611,
      0.129412,
      0.82985,
      0.491488,
      0.736886,
      0.254902,
      0.789081,
      0.583237,
      0.781853,
      0.380392,
      0.810734,
      0.656071,
      0.819254,
      0.505882,
      0.833126,
      0.729181,
      0.85684,
      0.631373,
      0.870527,
      0.80792,
      0.898178,
      0.756863,
      0.907605,
      0.884398,
      0.938331,
      0.882353,
      0.9391,
      0.921799,
      0.958016,
      1,
      0.968627,
      0.956863,
      0.976471
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "Oranges",
    RGBPoints: [
      -1,
      0.498039,
      0.152941,
      0.015686,
      -0.87451,
      0.57481,
      0.182468,
      0.013718,
      -0.74902,
      0.651765,
      0.212042,
      0.011734,
      -0.623529,
      0.752157,
      0.247474,
      7797e-6,
      -0.498039,
      0.851719,
      0.283368,
      4475e-6,
      -0.372549,
      0.898962,
      0.348328,
      0.039908,
      -0.247059,
      0.945652,
      0.413426,
      0.076401,
      -0.121569,
      0.969273,
      0.484291,
      0.157109,
      392157e-8,
      0.992157,
      0.554971,
      0.238185,
      0.129412,
      0.992157,
      0.619931,
      0.330704,
      0.254902,
      0.992157,
      0.684967,
      0.423837,
      0.380392,
      0.992157,
      0.751895,
      0.532103,
      0.505882,
      0.992249,
      0.817716,
      0.639354,
      0.631373,
      0.994218,
      0.861023,
      0.725967,
      0.756863,
      0.996186,
      0.903576,
      0.810965,
      0.882353,
      0.998155,
      0.933103,
      0.868051,
      1,
      1,
      0.960784,
      0.921569
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "Reds",
    RGBPoints: [
      -1,
      0.403922,
      0,
      0.05098,
      -0.87451,
      0.525967,
      0.029527,
      0.066728,
      -0.74902,
      0.647643,
      0.058962,
      0.082476,
      -0.623529,
      0.722445,
      0.076678,
      0.098224,
      -0.498039,
      0.797186,
      0.095194,
      0.114187,
      -0.372549,
      0.868051,
      0.164091,
      0.143714,
      -0.247059,
      0.937809,
      0.233541,
      0.173933,
      -0.121569,
      0.96143,
      0.326059,
      0.232987,
      392157e-8,
      0.984375,
      0.418147,
      0.292657,
      0.129412,
      0.986344,
      0.496886,
      0.371396,
      0.254902,
      0.988235,
      0.575702,
      0.450673,
      0.380392,
      0.988235,
      0.656409,
      0.543191,
      0.505882,
      0.98842,
      0.736747,
      0.635894,
      0.631373,
      0.992357,
      0.809581,
      0.732349,
      0.756863,
      0.996186,
      0.880692,
      0.826759,
      0.882353,
      0.998155,
      0.92203,
      0.885813,
      1,
      1,
      0.960784,
      0.941176
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "RdOr",
    RGBPoints: [
      -1,
      0.498039,
      0,
      0,
      -0.87451,
      0.6004,
      0,
      0,
      -0.74902,
      0.702514,
      738e-6,
      477e-6,
      -0.623529,
      0.773379,
      0.095225,
      0.061499,
      -0.498039,
      0.843875,
      0.189865,
      0.12283,
      -0.372549,
      0.891119,
      0.294195,
      0.203537,
      -0.247059,
      0.937855,
      0.397924,
      0.283137,
      -0.121569,
      0.963445,
      0.476663,
      0.316601,
      392157e-8,
      0.988297,
      0.555771,
      0.351665,
      0.129412,
      0.990265,
      0.646321,
      0.436309,
      0.254902,
      0.992157,
      0.735256,
      0.519646,
      0.380392,
      0.992157,
      0.784468,
      0.570827,
      0.505882,
      0.992249,
      0.833218,
      0.623483,
      0.631373,
      0.994218,
      0.872587,
      0.706159,
      0.756863,
      0.996186,
      0.911419,
      0.788189,
      0.882353,
      0.998155,
      0.940946,
      0.859054,
      1,
      1,
      0.968627,
      0.92549
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "BrOrYl",
    RGBPoints: [
      -1,
      0.4,
      0.145098,
      0.023529,
      -0.87451,
      0.500392,
      0.174625,
      0.019592,
      -0.74902,
      0.600784,
      0.204291,
      0.015656,
      -0.623529,
      0.701176,
      0.251534,
      0.011719,
      -0.498039,
      0.800984,
      0.299146,
      8397e-6,
      -0.372549,
      0.863975,
      0.370012,
      0.043829,
      -0.247059,
      0.926321,
      0.441107,
      0.0794,
      -0.121569,
      0.961753,
      0.521815,
      0.120738,
      392157e-8,
      0.996078,
      0.602645,
      0.163122,
      0.129412,
      0.996078,
      0.68729,
      0.237924,
      0.254902,
      0.996078,
      0.771011,
      0.314879,
      0.380392,
      0.996078,
      0.832034,
      0.444798,
      0.505882,
      0.996171,
      0.892042,
      0.572595,
      0.631373,
      0.998139,
      0.931411,
      0.65724,
      0.756863,
      1,
      0.969489,
      0.741669,
      0.882353,
      1,
      0.985236,
      0.822376,
      1,
      1,
      1,
      0.898039
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "RdOrYl",
    RGBPoints: [
      -1,
      0.501961,
      0,
      0.14902,
      -0.87451,
      0.622038,
      0,
      0.14902,
      -0.74902,
      0.741761,
      4e-4,
      0.148866,
      -0.623529,
      0.816563,
      0.05158,
      0.129181,
      -0.498039,
      0.890965,
      0.10356,
      0.110235,
      -0.372549,
      0.940177,
      0.205921,
      0.137793,
      -0.247059,
      0.988281,
      0.308789,
      0.165536,
      -0.121569,
      0.99025,
      0.432803,
      0.200969,
      392157e-8,
      0.992218,
      0.555217,
      0.236278,
      0.129412,
      0.994187,
      0.628051,
      0.267774,
      0.254902,
      0.996078,
      0.701038,
      0.301269,
      0.380392,
      0.996078,
      0.777809,
      0.383945,
      0.505882,
      0.996171,
      0.852826,
      0.466621,
      0.631373,
      0.998139,
      0.892195,
      0.549296,
      0.756863,
      1,
      0.931349,
      0.632188,
      0.882353,
      1,
      0.966782,
      0.7188,
      1,
      1,
      1,
      0.8
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "CIELab_blue2red",
    RGBPoints: [
      -1,
      0,
      0.6,
      0.74902,
      1,
      0.76863,
      0.46667,
      0.34118
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "blue2yellow",
    RGBPoints: [
      -1,
      0,
      0,
      1,
      0,
      0.5,
      0.5,
      0.5,
      1,
      1,
      1,
      0
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_blue2gold",
    RGBPoints: [
      -1,
      0.175119,
      0.0438468,
      1,
      -0.874016,
      0.22383,
      0.159771,
      0.94557,
      -0.748031,
      0.27254,
      0.233611,
      0.891216,
      -0.622047,
      0.321251,
      0.296526,
      0.836857,
      -0.496063,
      0.369962,
      0.354296,
      0.782359,
      -0.370079,
      0.418672,
      0.409139,
      0.72754,
      -0.244094,
      0.467383,
      0.462152,
      0.672148,
      -0.11811,
      0.51609,
      0.51396,
      0.615825,
      787402e-8,
      0.572863,
      0.55452,
      0.559172,
      0.133858,
      0.630269,
      0.593822,
      0.517729,
      0.259843,
      0.689588,
      0.624668,
      0.47446,
      0.385827,
      0.745394,
      0.656113,
      0.428638,
      0.511811,
      0.798624,
      0.688104,
      0.379105,
      0.637795,
      0.849926,
      0.720593,
      0.323834,
      0.76378,
      0.899765,
      0.753543,
      0.258657,
      0.889764,
      0.948487,
      0.78692,
      0.171778,
      1,
      0.990413,
      0.816451,
      729848e-8
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_blue2yellow",
    RGBPoints: [
      -1,
      0.0830122,
      0,
      0.495617,
      -0.87451,
      0.141973,
      0.0551288,
      0.57363,
      -0.74902,
      0.193048,
      0.110258,
      0.604561,
      -0.623529,
      0.234231,
      0.165386,
      0.57643,
      -0.498039,
      0.275413,
      0.220515,
      0.548299,
      -0.372549,
      0.316596,
      0.275644,
      0.520169,
      -0.247059,
      0.357778,
      0.330773,
      0.492038,
      -0.121569,
      0.398961,
      0.385901,
      0.463908,
      392157e-8,
      0.449929,
      0.438487,
      0.426815,
      0.129412,
      0.511572,
      0.488299,
      0.379944,
      0.254902,
      0.581222,
      0.53603,
      0.325741,
      0.380392,
      0.650871,
      0.583761,
      0.271538,
      0.505882,
      0.720521,
      0.631493,
      0.217335,
      0.631373,
      0.79017,
      0.679224,
      0.163132,
      0.756863,
      0.85982,
      0.726955,
      0.108929,
      0.882353,
      0.910254,
      0.774159,
      0.14112,
      1,
      0.927513,
      0.81759,
      0.306289
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_cyan2orange",
    RGBPoints: [
      -1,
      0.0471513,
      0.213874,
      0.414329,
      -0.87451,
      0.0674702,
      0.256648,
      0.439027,
      -0.74902,
      0.0959957,
      0.299331,
      0.462089,
      -0.623529,
      0.132428,
      0.341872,
      0.483212,
      -0.498039,
      0.188743,
      0.38277,
      0.500597,
      -0.372549,
      0.268511,
      0.420229,
      0.512179,
      -0.247059,
      0.352945,
      0.455602,
      0.519101,
      -0.121569,
      0.43893,
      0.489368,
      0.521538,
      392157e-8,
      0.522445,
      0.522495,
      0.522436,
      0.129412,
      0.600089,
      0.555682,
      0.53205,
      0.254902,
      0.67988,
      0.587981,
      0.539163,
      0.380392,
      0.761011,
      0.619586,
      0.544439,
      0.505882,
      0.84278,
      0.650741,
      0.548567,
      0.631373,
      0.910713,
      0.687347,
      0.557822,
      0.756863,
      0.952232,
      0.734972,
      0.577775,
      0.882353,
      0.975642,
      0.789858,
      0.604868,
      1,
      0.990752,
      0.843643,
      0.632857
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_purple2green",
    RGBPoints: [
      -1,
      0.235006,
      0.0483128,
      0.530899,
      -0.87451,
      0.302968,
      0.108419,
      0.552391,
      -0.74902,
      0.360241,
      0.166059,
      0.569502,
      -0.623529,
      0.406746,
      0.226782,
      0.579373,
      -0.498039,
      0.444073,
      0.28964,
      0.582094,
      -0.372549,
      0.473648,
      0.353774,
      0.577947,
      -0.247059,
      0.497636,
      0.418154,
      0.567911,
      -0.121569,
      0.519086,
      0.481741,
      0.553968,
      392157e-8,
      0.542884,
      0.542914,
      0.542875,
      0.129412,
      0.566303,
      0.603989,
      0.527499,
      0.254902,
      0.595218,
      0.662965,
      0.516857,
      0.380392,
      0.628641,
      0.720701,
      0.510673,
      0.505882,
      0.665373,
      0.777849,
      0.508165,
      0.631373,
      0.704182,
      0.834921,
      0.508303,
      0.756863,
      0.743846,
      0.892328,
      0.50999,
      0.882353,
      0.783158,
      0.950422,
      0.512181,
      1,
      0.818617,
      1,
      0.513888
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_purple2green_dark",
    RGBPoints: [
      -1,
      0.107656,
      0,
      0.428682,
      -0.87451,
      0.1924,
      0,
      0.449799,
      -0.74902,
      0.255118,
      0.0648939,
      0.466726,
      -0.623529,
      0.304256,
      0.133066,
      0.476703,
      -0.498039,
      0.343202,
      0.19716,
      0.479793,
      -0.372549,
      0.373876,
      0.260353,
      0.476241,
      -0.247059,
      0.398497,
      0.322872,
      0.466953,
      -0.121569,
      0.420016,
      0.384252,
      0.453785,
      392157e-8,
      0.44319,
      0.443216,
      0.443186,
      0.129412,
      0.465553,
      0.502139,
      0.428233,
      0.254902,
      0.492959,
      0.559151,
      0.417591,
      0.380392,
      0.524654,
      0.615092,
      0.411016,
      0.505882,
      0.55959,
      0.670583,
      0.40779,
      0.631373,
      0.596614,
      0.726102,
      0.406948,
      0.756863,
      0.634544,
      0.782032,
      0.407439,
      0.882353,
      0.672183,
      0.838703,
      0.408237,
      1,
      0.706131,
      0.892759,
      0.408452
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "coolwarm",
    RGBPoints: [
      -1,
      0.229806,
      0.298718,
      0.753683,
      -0.875,
      0.303869,
      0.406535,
      0.844959,
      -0.75,
      0.383013,
      0.509419,
      0.917388,
      -0.625,
      0.466667,
      0.604563,
      0.968155,
      -0.5,
      0.552953,
      0.688929,
      0.995376,
      -0.375,
      0.639176,
      0.7596,
      0.998151,
      -0.25,
      0.722193,
      0.813953,
      0.976575,
      -0.125,
      0.798692,
      0.849786,
      0.931689,
      0,
      0.865395,
      0.86541,
      0.865396,
      0.125,
      0.924128,
      0.827385,
      0.774508,
      0.25,
      0.958853,
      0.769768,
      0.678008,
      0.375,
      0.969954,
      0.694267,
      0.579375,
      0.5,
      0.958003,
      0.602842,
      0.481776,
      0.625,
      0.923945,
      0.497309,
      0.38797,
      0.75,
      0.869187,
      0.378313,
      0.300267,
      0.875,
      0.795632,
      0.241284,
      0.220526,
      1,
      0.705673,
      0.0155562,
      0.150233
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "BuRd",
    RGBPoints: [
      -1,
      0.019608,
      0.188235,
      0.380392,
      -0.87451,
      0.088504,
      0.321107,
      0.564937,
      -0.74902,
      0.163399,
      0.444983,
      0.697501,
      -0.623529,
      0.247059,
      0.555709,
      0.754095,
      -0.498039,
      0.420684,
      0.676432,
      0.818685,
      -0.372549,
      0.606459,
      0.789773,
      0.880277,
      -0.247059,
      0.761476,
      0.868512,
      0.924567,
      -0.121569,
      0.878047,
      0.925721,
      0.951942,
      392157e-8,
      0.969089,
      0.966474,
      0.964937,
      0.129412,
      0.983852,
      0.897578,
      0.846828,
      0.254902,
      0.982468,
      0.800692,
      0.706113,
      0.380392,
      0.960323,
      0.66782,
      0.536332,
      0.505882,
      0.894579,
      0.503806,
      0.399769,
      0.631373,
      0.81707,
      0.33218,
      0.281046,
      0.756863,
      0.728489,
      0.155017,
      0.197386,
      0.882353,
      0.576932,
      0.055363,
      0.14925,
      1,
      0.403922,
      0,
      0.121569
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "Spectral_lowBlue",
    RGBPoints: [
      -1,
      0.368627,
      0.309804,
      0.635294,
      -0.87451,
      0.260361,
      0.450058,
      0.70173,
      -0.74902,
      0.248058,
      0.591311,
      0.717186,
      -0.623529,
      0.376009,
      0.734025,
      0.658132,
      -0.498039,
      0.537947,
      0.814764,
      0.64506,
      -0.372549,
      0.702345,
      0.879585,
      0.636678,
      -0.247059,
      0.84752,
      0.938639,
      0.607151,
      -0.121569,
      0.940408,
      0.976163,
      0.656055,
      392157e-8,
      0.999923,
      0.997616,
      0.745021,
      0.129412,
      0.997463,
      0.921338,
      0.61707,
      0.254902,
      0.995002,
      0.824606,
      0.499885,
      0.380392,
      0.992541,
      0.701576,
      0.39654,
      0.505882,
      0.973472,
      0.547405,
      0.318108,
      0.631373,
      0.937793,
      0.398539,
      0.270127,
      0.756863,
      0.861515,
      0.282891,
      0.299654,
      0.882353,
      0.746482,
      0.144637,
      0.288812,
      1,
      0.619608,
      3922e-6,
      0.258824
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "GnRP",
    RGBPoints: [
      -1,
      0,
      0.266667,
      0.105882,
      -0.87451,
      0.066436,
      0.394617,
      0.174779,
      -0.74902,
      0.168858,
      0.524567,
      0.25767,
      -0.623529,
      0.323875,
      0.657439,
      0.361015,
      -0.498039,
      0.504883,
      0.772318,
      0.506344,
      -0.372549,
      0.678431,
      0.870127,
      0.654902,
      -0.247059,
      0.803922,
      0.921799,
      0.780392,
      -0.121569,
      0.897116,
      0.951942,
      0.882814,
      392157e-8,
      0.967397,
      0.965936,
      0.967474,
      0.129412,
      0.928028,
      0.879815,
      0.930565,
      0.254902,
      0.866052,
      0.780777,
      0.882891,
      0.380392,
      0.77501,
      0.665129,
      0.821376,
      0.505882,
      0.675663,
      0.537024,
      0.737024,
      0.631373,
      0.57847,
      0.396155,
      0.645982,
      0.756863,
      0.492349,
      0.223914,
      0.547559,
      0.882353,
      0.375548,
      0.096886,
      0.423299,
      1,
      0.25098,
      0,
      0.294118
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "GYPi",
    RGBPoints: [
      -1,
      0.152941,
      0.392157,
      0.098039,
      -0.87451,
      0.246444,
      0.505344,
      0.117724,
      -0.74902,
      0.351942,
      0.614533,
      0.161399,
      -0.623529,
      0.474971,
      0.717878,
      0.240138,
      -0.498039,
      0.611995,
      0.811226,
      0.392849,
      -0.372549,
      0.746328,
      0.893118,
      0.565321,
      -0.247059,
      0.859516,
      0.94233,
      0.747405,
      -0.121569,
      0.928105,
      0.96386,
      0.875663,
      392157e-8,
      0.969089,
      0.966859,
      0.968012,
      0.129412,
      0.983852,
      0.910265,
      0.948328,
      0.254902,
      0.979239,
      0.833218,
      0.914648,
      0.380392,
      0.949712,
      0.729873,
      0.862976,
      0.505882,
      0.905652,
      0.58293,
      0.763552,
      0.631373,
      0.85521,
      0.410073,
      0.652211,
      0.756863,
      0.793695,
      0.183699,
      0.531642,
      0.882353,
      0.683737,
      0.063899,
      0.420761,
      1,
      0.556863,
      3922e-6,
      0.321569
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "GnYlRd",
    RGBPoints: [
      -1,
      0,
      0.407843,
      0.215686,
      -0.87451,
      0.063975,
      0.525952,
      0.277201,
      -0.74902,
      0.177932,
      0.633064,
      0.332718,
      -0.623529,
      0.364937,
      0.724106,
      0.379469,
      -0.498039,
      0.527951,
      0.797155,
      0.40223,
      -0.372549,
      0.678431,
      0.862822,
      0.433449,
      -0.247059,
      0.803922,
      0.916955,
      0.514648,
      -0.121569,
      0.909419,
      0.961861,
      0.625067,
      392157e-8,
      0.999923,
      0.997616,
      0.745021,
      0.129412,
      0.997463,
      0.921338,
      0.61707,
      0.254902,
      0.995002,
      0.824606,
      0.499885,
      0.380392,
      0.992541,
      0.701576,
      0.39654,
      0.505882,
      0.973472,
      0.547405,
      0.318108,
      0.631373,
      0.939023,
      0.389927,
      0.245521,
      0.756863,
      0.867666,
      0.239831,
      0.176624,
      0.882353,
      0.762399,
      0.110727,
      0.151326,
      1,
      0.647059,
      0,
      0.14902
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "GBBr",
    RGBPoints: [
      -1,
      0,
      0.235294,
      0.188235,
      -0.87451,
      2461e-6,
      0.338639,
      0.301423,
      -0.74902,
      0.055902,
      0.448981,
      0.417609,
      -0.623529,
      0.183852,
      0.56955,
      0.538178,
      -0.498039,
      0.357785,
      0.700115,
      0.660746,
      -0.372549,
      0.540177,
      0.819531,
      0.77624,
      -0.247059,
      0.714879,
      0.890888,
      0.864821,
      -0.121569,
      0.851134,
      0.934564,
      0.922645,
      392157e-8,
      0.960861,
      0.959785,
      0.95694,
      0.129412,
      0.963322,
      0.927797,
      0.83391,
      0.254902,
      0.939946,
      0.868897,
      0.68935,
      0.380392,
      0.883353,
      0.775394,
      0.517109,
      0.505882,
      0.808074,
      0.625836,
      0.324106,
      0.631373,
      0.717647,
      0.476355,
      0.15494,
      0.756863,
      0.592157,
      0.358247,
      0.06882,
      0.882353,
      0.458593,
      0.26436,
      0.031142,
      1,
      0.329412,
      0.188235,
      0.019608
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "PuOr",
    RGBPoints: [
      -1,
      0.498039,
      0.231373,
      0.031373,
      -0.87451,
      0.62599,
      0.30273,
      0.026451,
      -0.74902,
      0.746943,
      0.387082,
      0.037524,
      -0.623529,
      0.85767,
      0.490427,
      0.071972,
      -0.498039,
      0.936409,
      0.617762,
      0.236371,
      -0.372549,
      0.992695,
      0.743099,
      0.43291,
      -0.247059,
      0.995156,
      0.841523,
      0.63714,
      -0.121569,
      0.985313,
      0.913802,
      0.813687,
      392157e-8,
      0.966244,
      0.966398,
      0.967705,
      0.129412,
      0.889965,
      0.89504,
      0.938178,
      0.254902,
      0.806151,
      0.804306,
      0.894656,
      0.380392,
      0.712649,
      0.688658,
      0.833141,
      0.505882,
      0.594233,
      0.554325,
      0.744637,
      0.631373,
      0.474894,
      0.404229,
      0.652364,
      0.756863,
      0.366628,
      0.217224,
      0.563783,
      0.882353,
      0.266436,
      0.089965,
      0.434833,
      1,
      0.176471,
      0,
      0.294118
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "PRGn",
    RGBPoints: [
      -1,
      0.25098,
      0,
      0.294118,
      -0.87451,
      0.383852,
      0.103345,
      0.431911,
      -0.74902,
      0.497732,
      0.234679,
      0.55371,
      -0.623529,
      0.583852,
      0.40692,
      0.652134,
      -0.498039,
      0.681968,
      0.545175,
      0.742561,
      -0.372549,
      0.7807,
      0.672357,
      0.825221,
      -0.247059,
      0.871742,
      0.788005,
      0.886736,
      -0.121569,
      0.930488,
      0.885198,
      0.932872,
      392157e-8,
      0.966321,
      0.968089,
      0.965859,
      0.129412,
      0.892503,
      0.950865,
      0.877278,
      0.254902,
      0.796078,
      0.91857,
      0.772549,
      0.380392,
      0.670588,
      0.866897,
      0.647059,
      0.505882,
      0.493195,
      0.765398,
      0.496655,
      0.631373,
      0.314187,
      0.649135,
      0.354556,
      0.756863,
      0.15917,
      0.516263,
      0.251211,
      0.882353,
      0.062284,
      0.386621,
      0.170473,
      1,
      0,
      0.266667,
      0.105882
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "PiYG",
    RGBPoints: [
      -1,
      0.556863,
      3922e-6,
      0.321569,
      -0.87451,
      0.692195,
      0.067897,
      0.427374,
      -0.74902,
      0.797539,
      0.197847,
      0.539177,
      -0.623529,
      0.859054,
      0.424221,
      0.659746,
      -0.498039,
      0.908574,
      0.592618,
      0.770319,
      -0.372549,
      0.951557,
      0.736332,
      0.866205,
      -0.247059,
      0.981084,
      0.839677,
      0.917878,
      -0.121569,
      0.98293,
      0.913802,
      0.949558,
      392157e-8,
      0.96732,
      0.968474,
      0.965629,
      0.129412,
      0.92549,
      0.963552,
      0.869666,
      0.254902,
      0.852441,
      0.939254,
      0.736025,
      0.380392,
      0.739254,
      0.890042,
      0.553941,
      0.505882,
      0.60323,
      0.805536,
      0.382238,
      0.631373,
      0.467282,
      0.711419,
      0.235217,
      0.756863,
      0.344252,
      0.608074,
      0.156478,
      0.882353,
      0.2406,
      0.49827,
      0.116494,
      1,
      0.152941,
      0.392157,
      0.098039
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "OrPu",
    RGBPoints: [
      -1,
      0.176471,
      0,
      0.294118,
      -0.87451,
      0.272434,
      0.095963,
      0.444214,
      -0.74902,
      0.373395,
      0.228912,
      0.56932,
      -0.623529,
      0.481661,
      0.415917,
      0.657901,
      -0.498039,
      0.601922,
      0.562937,
      0.750481,
      -0.372549,
      0.718493,
      0.695886,
      0.836986,
      -0.247059,
      0.811995,
      0.811534,
      0.898501,
      -0.121569,
      0.894733,
      0.8995,
      0.940023,
      392157e-8,
      0.969166,
      0.966859,
      0.963629,
      0.129412,
      0.98639,
      0.910265,
      0.803691,
      0.254902,
      0.995002,
      0.835371,
      0.624375,
      0.380392,
      0.992541,
      0.736947,
      0.420146,
      0.505882,
      0.931949,
      0.609458,
      0.224221,
      0.631373,
      0.85075,
      0.483968,
      0.069819,
      0.756863,
      0.740023,
      0.380623,
      0.035371,
      0.882353,
      0.617993,
      0.29827,
      0.026759,
      1,
      0.498039,
      0.231373,
      0.031373
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "BrBG",
    RGBPoints: [
      -1,
      0.329412,
      0.188235,
      0.019608,
      -0.87451,
      0.467205,
      0.269435,
      0.031911,
      -0.74902,
      0.6,
      0.365629,
      0.074202,
      -0.623529,
      0.72549,
      0.483737,
      0.160323,
      -0.498039,
      0.812995,
      0.635832,
      0.336409,
      -0.372549,
      0.88689,
      0.781238,
      0.527874,
      -0.247059,
      0.943483,
      0.87474,
      0.700115,
      -0.121569,
      0.963168,
      0.929796,
      0.841599,
      392157e-8,
      0.957247,
      0.959938,
      0.959554,
      0.129412,
      0.84406,
      0.932872,
      0.920185,
      0.254902,
      0.70396,
      0.886428,
      0.859285,
      0.380392,
      0.529258,
      0.815071,
      0.770704,
      0.505882,
      0.346251,
      0.691811,
      0.653057,
      0.631373,
      0.175855,
      0.562015,
      0.530642,
      0.756863,
      0.047905,
      0.441446,
      0.410073,
      0.882353,
      2307e-6,
      0.33218,
      0.294348,
      1,
      0,
      0.235294,
      0.188235
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "GyRd",
    RGBPoints: [
      -1,
      0.101961,
      0.101961,
      0.101961,
      -0.87451,
      0.227451,
      0.227451,
      0.227451,
      -0.74902,
      0.359939,
      0.359939,
      0.359939,
      -0.623529,
      0.502653,
      0.502653,
      0.502653,
      -0.498039,
      0.631373,
      0.631373,
      0.631373,
      -0.372549,
      0.749865,
      0.749865,
      0.749865,
      -0.247059,
      0.843368,
      0.843368,
      0.843368,
      -0.121569,
      0.926105,
      0.926105,
      0.926105,
      392157e-8,
      0.999846,
      0.997232,
      0.995694,
      0.129412,
      0.994925,
      0.908651,
      0.857901,
      0.254902,
      0.982468,
      0.800692,
      0.706113,
      0.380392,
      0.960323,
      0.66782,
      0.536332,
      0.505882,
      0.894579,
      0.503806,
      0.399769,
      0.631373,
      0.81707,
      0.33218,
      0.281046,
      0.756863,
      0.728489,
      0.155017,
      0.197386,
      0.882353,
      0.576932,
      0.055363,
      0.14925,
      1,
      0.403922,
      0,
      0.121569
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_divHi_purpleGreen",
    RGBPoints: [
      -1,
      0.297553,
      0,
      0.489074,
      -0.87451,
      0.40259,
      0.151146,
      0.567754,
      -0.74902,
      0.516038,
      0.284843,
      0.658231,
      -0.623529,
      0.629783,
      0.423646,
      0.750938,
      -0.498039,
      0.735198,
      0.563697,
      0.835956,
      -0.372549,
      0.82408,
      0.695541,
      0.903582,
      -0.247059,
      0.889091,
      0.807454,
      0.944862,
      -0.121569,
      0.92334,
      0.886917,
      0.951839,
      392157e-8,
      0.921045,
      0.921084,
      0.921003,
      0.129412,
      0.877324,
      0.907455,
      0.845381,
      0.254902,
      0.797649,
      0.849713,
      0.734695,
      0.380392,
      0.691646,
      0.75964,
      0.600532,
      0.505882,
      0.568981,
      0.649159,
      0.453807,
      0.631373,
      0.438945,
      0.529756,
      0.304259,
      0.756863,
      0.30973,
      0.412001,
      0.158303,
      0.882353,
      0.187078,
      0.305111,
      251458e-8,
      1,
      0.101655,
      0.220836,
      0
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_divHi_purpleGreen_dim",
    RGBPoints: [
      -1,
      0.404088,
      0.131038,
      0.592767,
      -0.87451,
      0.486469,
      0.230957,
      0.651243,
      -0.74902,
      0.575165,
      0.339335,
      0.717723,
      -0.623529,
      0.662741,
      0.454332,
      0.784263,
      -0.498039,
      0.742071,
      0.570213,
      0.842918,
      -0.372549,
      0.806935,
      0.678992,
      0.886227,
      -0.247059,
      0.852219,
      0.771315,
      0.90763,
      -0.121569,
      0.873345,
      0.837327,
      0.901572,
      392157e-8,
      0.866783,
      0.86682,
      0.866745,
      0.129412,
      0.82839,
      0.858225,
      0.796812,
      0.254902,
      0.762578,
      0.814287,
      0.700202,
      0.380392,
      0.676429,
      0.744229,
      0.585735,
      0.505882,
      0.577033,
      0.65732,
      0.461526,
      0.631373,
      0.47128,
      0.562476,
      0.33476,
      0.756863,
      0.365461,
      0.467957,
      0.21076,
      0.882353,
      0.264758,
      0.381138,
      0.0878313,
      1,
      0.182591,
      0.312249,
      0
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_divLow_icePeach",
    RGBPoints: [
      -1,
      0.480048,
      0.817441,
      0.998056,
      -0.87451,
      0.425898,
      0.726921,
      0.883187,
      -0.74902,
      0.366682,
      0.629445,
      0.761936,
      -0.623529,
      0.308756,
      0.531002,
      0.640217,
      -0.498039,
      0.258021,
      0.43705,
      0.523433,
      -0.372549,
      0.219244,
      0.352381,
      0.416348,
      -0.247059,
      0.195127,
      0.281032,
      0.322979,
      -0.121569,
      0.186286,
      0.22627,
      0.246525,
      392157e-8,
      0.192352,
      0.19236,
      0.192364,
      0.129412,
      0.255927,
      0.214469,
      0.191756,
      0.254902,
      0.340459,
      0.254426,
      0.206666,
      0.380392,
      0.444655,
      0.309315,
      0.234029,
      0.505882,
      0.565353,
      0.376004,
      0.270969,
      0.631373,
      0.697917,
      0.450748,
      0.314293,
      0.756863,
      0.836657,
      0.529064,
      0.360227,
      0.882353,
      0.972695,
      0.614884,
      0.413123,
      1,
      1,
      0.705904,
      0.472699
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_divLow_purpleGreen",
    RGBPoints: [
      -1,
      0.956034,
      0.666487,
      0.952663,
      -0.87451,
      0.874457,
      0.572698,
      0.936352,
      -0.74902,
      0.753465,
      0.488253,
      0.909063,
      -0.623529,
      0.63309,
      0.413507,
      0.763833,
      -0.498039,
      0.514491,
      0.345878,
      0.620015,
      -0.372549,
      0.405008,
      0.288141,
      0.484376,
      -0.247059,
      0.311388,
      0.241986,
      0.363556,
      -0.121569,
      0.238722,
      0.209044,
      0.263449,
      392157e-8,
      0.192352,
      0.192366,
      0.192362,
      0.129412,
      0.200379,
      0.233201,
      0.168618,
      0.254902,
      0.230151,
      0.291737,
      0.165227,
      0.380392,
      0.279481,
      0.366076,
      0.178607,
      0.505882,
      0.344927,
      0.453267,
      0.205703,
      0.631373,
      0.421554,
      0.549449,
      0.242643,
      0.756863,
      0.503334,
      0.649999,
      0.284377,
      0.882353,
      0.583497,
      0.749672,
      0.324969,
      1,
      0.650705,
      0.837228,
      0.356264
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "Haze_green",
    RGBPoints: [
      -1,
      1,
      0.835294,
      0.886275,
      -0.87451,
      0.937255,
      0.756863,
      0.870443,
      -0.74902,
      0.875817,
      0.666376,
      0.857807,
      -0.623529,
      0.778359,
      0.583007,
      0.808134,
      -0.498039,
      0.676253,
      0.494118,
      0.745098,
      -0.372549,
      0.561365,
      0.390123,
      0.682353,
      -0.247059,
      0.438344,
      0.262745,
      0.621496,
      -0.121569,
      0.321133,
      0.141031,
      0.558751,
      392157e-8,
      0.203922,
      0.0217865,
      0.495861,
      0.129412,
      0.265505,
      0.129412,
      0.433261,
      0.254902,
      0.311692,
      0.255338,
      0.37008,
      0.380392,
      0.356282,
      0.377342,
      0.310821,
      0.505882,
      0.39971,
      0.488889,
      0.258243,
      0.631373,
      0.442556,
      0.604357,
      0.205519,
      0.756863,
      0.48671,
      0.71968,
      0.152941,
      0.882353,
      0.529847,
      0.830356,
      0.100944,
      1,
      0.572549,
      0.933333,
      0.054902
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "Haze_lime",
    RGBPoints: [
      -1,
      0.704034,
      0.784196,
      1,
      -0.87451,
      0.633111,
      0.691418,
      0.956078,
      -0.74902,
      0.564021,
      0.600606,
      0.912157,
      -0.623529,
      0.496827,
      0.51189,
      0.868235,
      -0.498039,
      0.43157,
      0.425416,
      0.824314,
      -0.372549,
      0.368248,
      0.341347,
      0.780392,
      -0.247059,
      0.306767,
      0.259855,
      0.736471,
      -0.121569,
      0.246862,
      0.181069,
      0.692549,
      392157e-8,
      0.191619,
      0.109542,
      0.648627,
      0.129412,
      0.257404,
      0.194031,
      0.604706,
      0.254902,
      0.321794,
      0.278775,
      0.560784,
      0.380392,
      0.387909,
      0.364617,
      0.516863,
      0.505882,
      0.456569,
      0.451881,
      0.472941,
      0.631373,
      0.527424,
      0.540773,
      0.42902,
      0.756863,
      0.599759,
      0.631427,
      0.385098,
      0.882353,
      0.673065,
      0.723898,
      0.341176,
      1,
      0.742751,
      0.812252,
      0.3
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "Haze",
    RGBPoints: [
      -1,
      1,
      0.835294,
      0.996078,
      -392157e-8,
      0.023529,
      0.141176,
      0.498039,
      392157e-8,
      0.015686,
      0.137255,
      0.494118,
      1,
      0.984314,
      0.764706,
      0
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "Haze_cyan",
    RGBPoints: [
      -1,
      0.956863,
      1,
      0.835294,
      -0.87451,
      0.933188,
      0.921714,
      0.760784,
      -0.74902,
      0.870588,
      0.803486,
      0.671605,
      -0.623529,
      0.807843,
      0.684096,
      0.583297,
      -0.498039,
      0.745098,
      0.569208,
      0.494118,
      -0.372549,
      0.682353,
      0.437763,
      0.390123,
      -0.247059,
      0.621496,
      0.288163,
      0.262745,
      -0.121569,
      0.558751,
      0.144517,
      0.141031,
      392157e-8,
      0.495861,
      0.0217865,
      0.0413943,
      0.129412,
      0.433261,
      0.137255,
      0.129412,
      0.254902,
      0.37008,
      0.263181,
      0.255338,
      0.380392,
      0.306318,
      0.381845,
      0.372694,
      0.505882,
      0.243137,
      0.503994,
      0.494263,
      0.631373,
      0.180392,
      0.629484,
      0.619753,
      0.756863,
      0.117647,
      0.754975,
      0.747131,
      0.882353,
      0.054902,
      0.876398,
      0.866812,
      1,
      0,
      0.988235,
      0.976471
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "nic_Edge",
    RGBPoints: [
      -1,
      0.191208,
      0.191208,
      0.191208,
      -0.87451,
      0.239484,
      545035e-8,
      0.614821,
      -0.74902,
      0.220593,
      0.0617459,
      0.863547,
      -0.623529,
      0.17509,
      0.278988,
      0.97794,
      -0.498039,
      0.143526,
      0.576069,
      0.998553,
      -0.372549,
      0.166456,
      0.871883,
      0.96594,
      -0.247059,
      0.376202,
      0.993555,
      0.981833,
      -0.121569,
      0.681996,
      0.991297,
      0.999239,
      392157e-8,
      0.954172,
      0.952734,
      0.94374,
      0.129412,
      0.999735,
      0.99301,
      0.662896,
      0.254902,
      0.979399,
      0.991466,
      0.357973,
      0.380392,
      0.968771,
      0.854967,
      0.162659,
      0.505882,
      0.999245,
      0.556697,
      0.144323,
      0.631373,
      0.973959,
      0.26223,
      0.177946,
      0.756863,
      0.852358,
      0.0526707,
      0.222974,
      0.882353,
      0.593889,
      912724e-8,
      0.238855,
      1,
      0.191208,
      0.191208,
      0.191208
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_iceFire_H",
    RGBPoints: [
      -1,
      405432e-12,
      0,
      590122e-11,
      -0.87451,
      0,
      0.120401,
      0.302675,
      -0.74902,
      0,
      0.216583,
      0.524574,
      -0.623529,
      0.0552475,
      0.345025,
      0.6595,
      -0.498039,
      0.128047,
      0.492588,
      0.720288,
      -0.372549,
      0.188955,
      0.641309,
      0.792092,
      -0.247059,
      0.327673,
      0.784935,
      0.873434,
      -0.121569,
      0.60824,
      0.892164,
      0.935547,
      392157e-8,
      0.881371,
      0.912178,
      0.818099,
      0.129412,
      0.951407,
      0.835621,
      0.449279,
      0.254902,
      0.904481,
      0.690489,
      0,
      0.380392,
      0.85407,
      0.510864,
      0,
      0.505882,
      0.777093,
      0.33018,
      88199e-8,
      0.631373,
      0.672862,
      0.139087,
      269398e-8,
      0.756863,
      0.508815,
      0,
      0,
      0.882353,
      0.299417,
      366289e-9,
      547829e-9,
      1,
      0.0157519,
      332021e-8,
      455569e-13
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "erdc_iceFire_L",
    RGBPoints: [
      -1,
      0.870485,
      0.913768,
      0.832905,
      -0.87451,
      0.586919,
      0.887865,
      0.934003,
      -0.74902,
      0.31583,
      0.776442,
      0.867858,
      -0.623529,
      0.18302,
      0.632034,
      0.787722,
      -0.498039,
      0.117909,
      0.484134,
      0.713825,
      -0.372549,
      0.0507239,
      0.335979,
      0.654741,
      -0.247059,
      0,
      0.209874,
      0.511832,
      -0.121569,
      0,
      0.114689,
      0.28935,
      392157e-8,
      0.0157519,
      332021e-8,
      455569e-13,
      0.129412,
      0.312914,
      0,
      0,
      0.254902,
      0.520865,
      0,
      0,
      0.380392,
      0.680105,
      0.15255,
      25996e-7,
      0.505882,
      0.785109,
      0.339479,
      797922e-9,
      0.631373,
      0.857354,
      0.522494,
      0,
      0.756863,
      0.910974,
      0.699774,
      0,
      0.882353,
      0.951921,
      0.842817,
      0.478545,
      1,
      0.881371,
      0.912178,
      0.818099
    ]
  },
  {
    ColorSpace: "RGB",
    Name: "hsv",
    RGBPoints: [
      -1,
      1,
      0,
      0,
      -0.666666,
      1,
      0,
      1,
      -0.333333,
      0,
      0,
      1,
      0,
      0,
      1,
      1,
      0.33333,
      0,
      1,
      0,
      0.66666,
      1,
      1,
      0,
      1,
      1,
      0,
      0
    ]
  },
  {
    ColorSpace: "Lab",
    Name: "hue_L60",
    RGBPoints: [
      -1,
      0.964784,
      0.400592,
      0.349549,
      -0.87451,
      0.964915,
      0.372498,
      0.53785,
      -0.74902,
      0.892353,
      0.401039,
      0.759569,
      -0.623529,
      0.79263,
      0.446956,
      0.903017,
      -0.498039,
      0.682208,
      0.49954,
      0.966673,
      -0.372549,
      0.56392,
      0.553082,
      0.968836,
      -0.247059,
      0.442031,
      0.606396,
      0.901601,
      -0.121569,
      0.305499,
      0.65701,
      0.765784,
      392157e-8,
      0.197251,
      0.687914,
      0.620914,
      0.129412,
      0.193882,
      0.701887,
      0.472654,
      0.254902,
      0.249866,
      0.706123,
      0.320005,
      0.380392,
      0.35132,
      0.697417,
      0.202919,
      0.505882,
      0.498097,
      0.669467,
      0.125232,
      0.631373,
      0.637477,
      0.626239,
      0.107431,
      0.756863,
      0.762115,
      0.56872,
      0.155812,
      0.882353,
      0.889434,
      0.481116,
      0.240445,
      1,
      0.964784,
      0.400592,
      0.349549
    ]
  },
  {
    IndexedColors: [
      0,
      0,
      0,
      0.8941176470588236,
      0.1019607843137255,
      0.1098039215686274,
      0.2156862745098039,
      0.4941176470588236,
      0.7215686274509804,
      0.3019607843137255,
      0.6862745098039216,
      0.2901960784313726,
      0.596078431372549,
      0.3058823529411765,
      0.6392156862745098,
      1,
      0.4980392156862745,
      0,
      0.6509803921568628,
      0.3372549019607843,
      0.1568627450980392
    ],
    Name: "Spectrum",
    NanColor: [
      0.6509803921568628,
      0.3372549019607843,
      0.1568627450980392
    ]
  },
  {
    IndexedColors: [
      0.4745098039215686,
      0.09019607843137255,
      0.09019607843137255,
      0.7098039215686275,
      0.00392156862745098,
      0.00392156862745098,
      0.9372549019607843,
      0.2784313725490196,
      0.09803921568627451,
      0.9764705882352941,
      0.5137254901960784,
      0.1411764705882353,
      1,
      0.7058823529411765,
      0,
      1,
      0.8980392156862745,
      0.02352941176470588
    ],
    Name: "Warm",
    NanColor: [
      1,
      0.8980392156862745,
      0.02352941176470588
    ]
  },
  {
    IndexedColors: [
      0.4588235294117647,
      0.6941176470588235,
      0.00392156862745098,
      0.3450980392156863,
      0.5019607843137255,
      0.1607843137254902,
      0.3137254901960784,
      0.8431372549019608,
      0.7490196078431373,
      0.1098039215686274,
      0.5843137254901961,
      0.803921568627451,
      0.2313725490196079,
      0.407843137254902,
      0.6705882352941176,
      0.6039215686274509,
      0.407843137254902,
      1,
      0.3725490196078431,
      0.2,
      0.5019607843137255
    ],
    Name: "Cool",
    NanColor: [
      0.3725490196078431,
      0.2,
      0.5019607843137255
    ]
  },
  {
    IndexedColors: [
      0.2313725490196079,
      0.407843137254902,
      0.6705882352941176,
      0.1098039215686274,
      0.5843137254901961,
      0.803921568627451,
      0.3058823529411765,
      0.8509803921568627,
      0.9176470588235294,
      0.4509803921568628,
      0.6039215686274509,
      0.8352941176470589,
      0.2588235294117647,
      0.2392156862745098,
      0.6627450980392157,
      0.3137254901960784,
      0.3294117647058823,
      0.5294117647058824,
      0.06274509803921569,
      0.1647058823529412,
      0.3215686274509804
    ],
    Name: "Blues",
    NanColor: [
      0.06274509803921569,
      0.1647058823529412,
      0.3215686274509804
    ]
  },
  {
    IndexedColors: [
      0.1098039215686274,
      0.5843137254901961,
      0.803921568627451,
      0.2313725490196079,
      0.407843137254902,
      0.6705882352941176,
      0.4,
      0.2431372549019608,
      0.7176470588235294,
      0.6352941176470588,
      0.3294117647058823,
      0.8117647058823529,
      0.8705882352941177,
      0.3803921568627451,
      0.807843137254902,
      0.8627450980392157,
      0.3803921568627451,
      0.5843137254901961,
      0.2392156862745098,
      0.06274509803921569,
      0.3215686274509804
    ],
    Name: "Wild Flower",
    NanColor: [
      0.2392156862745098,
      0.06274509803921569,
      0.3215686274509804
    ]
  },
  {
    IndexedColors: [
      0.396078431372549,
      0.4862745098039216,
      0.2156862745098039,
      0.4588235294117647,
      0.6941176470588235,
      0.00392156862745098,
      0.6980392156862745,
      0.7294117647058823,
      0.1882352941176471,
      1,
      0.8980392156862745,
      0.02352941176470588,
      1,
      0.7058823529411765,
      0,
      0.9764705882352941,
      0.5137254901960784,
      0.1411764705882353
    ],
    Name: "Citrus",
    NanColor: [
      0.9764705882352941,
      0.5137254901960784,
      0.1411764705882353
    ]
  },
  {
    IndexedColors: [
      0.4980392156862745,
      0.2313725490196079,
      0.03137254901960784,
      0.7019607843137254,
      0.3450980392156863,
      0.02352941176470588,
      0.8784313725490196,
      0.5098039215686274,
      0.0784313725490196,
      0.9921568627450981,
      0.7215686274509804,
      0.3882352941176471,
      0.996078431372549,
      0.8784313725490196,
      0.7137254901960784,
      0.9686274509803922,
      0.9686274509803922,
      0.9686274509803922,
      0.8470588235294118,
      0.8549019607843137,
      0.9215686274509803,
      0.6980392156862745,
      0.6705882352941176,
      0.8235294117647058,
      0.5019607843137255,
      0.4509803921568628,
      0.6745098039215687,
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333,
      0.1764705882352941,
      0,
      0.2941176470588235
    ],
    Name: "Brewer Diverging Purple-Orange (11)",
    NanColor: [
      0.1764705882352941,
      0,
      0.2941176470588235
    ]
  },
  {
    IndexedColors: [
      0.4980392156862745,
      0.2313725490196079,
      0.03137254901960784,
      0.7019607843137254,
      0.3450980392156863,
      0.02352941176470588,
      0.8784313725490196,
      0.5098039215686274,
      0.0784313725490196,
      0.9921568627450981,
      0.7215686274509804,
      0.3882352941176471,
      0.996078431372549,
      0.8784313725490196,
      0.7137254901960784,
      0.8470588235294118,
      0.8549019607843137,
      0.9215686274509803,
      0.6980392156862745,
      0.6705882352941176,
      0.8235294117647058,
      0.5019607843137255,
      0.4509803921568628,
      0.6745098039215687,
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333,
      0.1764705882352941,
      0,
      0.2941176470588235
    ],
    Name: "Brewer Diverging Purple-Orange (10)",
    NanColor: [
      0.1764705882352941,
      0,
      0.2941176470588235
    ]
  },
  {
    IndexedColors: [
      0.7019607843137254,
      0.3450980392156863,
      0.02352941176470588,
      0.8784313725490196,
      0.5098039215686274,
      0.0784313725490196,
      0.9921568627450981,
      0.7215686274509804,
      0.3882352941176471,
      0.996078431372549,
      0.8784313725490196,
      0.7137254901960784,
      0.9686274509803922,
      0.9686274509803922,
      0.9686274509803922,
      0.8470588235294118,
      0.8549019607843137,
      0.9215686274509803,
      0.6980392156862745,
      0.6705882352941176,
      0.8235294117647058,
      0.5019607843137255,
      0.4509803921568628,
      0.6745098039215687,
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333
    ],
    Name: "Brewer Diverging Purple-Orange (9)",
    NanColor: [
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333
    ]
  },
  {
    IndexedColors: [
      0.7019607843137254,
      0.3450980392156863,
      0.02352941176470588,
      0.8784313725490196,
      0.5098039215686274,
      0.0784313725490196,
      0.9921568627450981,
      0.7215686274509804,
      0.3882352941176471,
      0.996078431372549,
      0.8784313725490196,
      0.7137254901960784,
      0.8470588235294118,
      0.8549019607843137,
      0.9215686274509803,
      0.6980392156862745,
      0.6705882352941176,
      0.8235294117647058,
      0.5019607843137255,
      0.4509803921568628,
      0.6745098039215687,
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333
    ],
    Name: "Brewer Diverging Purple-Orange (8)",
    NanColor: [
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333
    ]
  },
  {
    IndexedColors: [
      0.7019607843137254,
      0.3450980392156863,
      0.02352941176470588,
      0.9450980392156862,
      0.6392156862745098,
      0.2509803921568627,
      0.996078431372549,
      0.8784313725490196,
      0.7137254901960784,
      0.9686274509803922,
      0.9686274509803922,
      0.9686274509803922,
      0.8470588235294118,
      0.8549019607843137,
      0.9215686274509803,
      0.6,
      0.5568627450980392,
      0.7647058823529411,
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333
    ],
    Name: "Brewer Diverging Purple-Orange (7)",
    NanColor: [
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333
    ]
  },
  {
    IndexedColors: [
      0.7019607843137254,
      0.3450980392156863,
      0.02352941176470588,
      0.9450980392156862,
      0.6392156862745098,
      0.2509803921568627,
      0.996078431372549,
      0.8784313725490196,
      0.7137254901960784,
      0.8470588235294118,
      0.8549019607843137,
      0.9215686274509803,
      0.6,
      0.5568627450980392,
      0.7647058823529411,
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333
    ],
    Name: "Brewer Diverging Purple-Orange (6)",
    NanColor: [
      0.3294117647058823,
      0.1529411764705882,
      0.5333333333333333
    ]
  },
  {
    IndexedColors: [
      0.9019607843137255,
      0.3803921568627451,
      0.00392156862745098,
      0.9921568627450981,
      0.7215686274509804,
      0.3882352941176471,
      0.9686274509803922,
      0.9686274509803922,
      0.9686274509803922,
      0.6980392156862745,
      0.6705882352941176,
      0.8235294117647058,
      0.3686274509803922,
      0.2352941176470588,
      0.6
    ],
    Name: "Brewer Diverging Purple-Orange (5)",
    NanColor: [
      0.3686274509803922,
      0.2352941176470588,
      0.6
    ]
  },
  {
    IndexedColors: [
      0.9019607843137255,
      0.3803921568627451,
      0.00392156862745098,
      0.9921568627450981,
      0.7215686274509804,
      0.3882352941176471,
      0.6980392156862745,
      0.6705882352941176,
      0.8235294117647058,
      0.3686274509803922,
      0.2352941176470588,
      0.6
    ],
    Name: "Brewer Diverging Purple-Orange (4)",
    NanColor: [
      0.3686274509803922,
      0.2352941176470588,
      0.6
    ]
  },
  {
    IndexedColors: [
      0.9450980392156862,
      0.6392156862745098,
      0.2509803921568627,
      0.9686274509803922,
      0.9686274509803922,
      0.9686274509803922,
      0.6,
      0.5568627450980392,
      0.7647058823529411
    ],
    Name: "Brewer Diverging Purple-Orange (3)",
    NanColor: [
      0.6,
      0.5568627450980392,
      0.7647058823529411
    ]
  },
  {
    IndexedColors: [
      0.6196078431372549,
      0.00392156862745098,
      0.2588235294117647,
      0.8352941176470589,
      0.2431372549019608,
      0.3098039215686275,
      0.9568627450980393,
      0.4274509803921568,
      0.2627450980392157,
      0.9921568627450981,
      0.6823529411764706,
      0.3803921568627451,
      0.996078431372549,
      0.8784313725490196,
      0.5450980392156862,
      1,
      1,
      0.7490196078431373,
      0.9019607843137255,
      0.9607843137254902,
      0.596078431372549,
      0.6705882352941176,
      0.8666666666666667,
      0.6431372549019608,
      0.4,
      0.7607843137254902,
      0.6470588235294118,
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353,
      0.3686274509803922,
      0.3098039215686275,
      0.6352941176470588
    ],
    Name: "Brewer Diverging Spectral (11)",
    NanColor: [
      0.3686274509803922,
      0.3098039215686275,
      0.6352941176470588
    ]
  },
  {
    IndexedColors: [
      0.6196078431372549,
      0.00392156862745098,
      0.2588235294117647,
      0.8352941176470589,
      0.2431372549019608,
      0.3098039215686275,
      0.9568627450980393,
      0.4274509803921568,
      0.2627450980392157,
      0.9921568627450981,
      0.6823529411764706,
      0.3803921568627451,
      0.996078431372549,
      0.8784313725490196,
      0.5450980392156862,
      0.9019607843137255,
      0.9607843137254902,
      0.596078431372549,
      0.6705882352941176,
      0.8666666666666667,
      0.6431372549019608,
      0.4,
      0.7607843137254902,
      0.6470588235294118,
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353,
      0.3686274509803922,
      0.3098039215686275,
      0.6352941176470588
    ],
    Name: "Brewer Diverging Spectral (10)",
    NanColor: [
      0.3686274509803922,
      0.3098039215686275,
      0.6352941176470588
    ]
  },
  {
    IndexedColors: [
      0.8352941176470589,
      0.2431372549019608,
      0.3098039215686275,
      0.9568627450980393,
      0.4274509803921568,
      0.2627450980392157,
      0.9921568627450981,
      0.6823529411764706,
      0.3803921568627451,
      0.996078431372549,
      0.8784313725490196,
      0.5450980392156862,
      1,
      1,
      0.7490196078431373,
      0.9019607843137255,
      0.9607843137254902,
      0.596078431372549,
      0.6705882352941176,
      0.8666666666666667,
      0.6431372549019608,
      0.4,
      0.7607843137254902,
      0.6470588235294118,
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353
    ],
    Name: "Brewer Diverging Spectral (9)",
    NanColor: [
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353
    ]
  },
  {
    IndexedColors: [
      0.8352941176470589,
      0.2431372549019608,
      0.3098039215686275,
      0.9568627450980393,
      0.4274509803921568,
      0.2627450980392157,
      0.9921568627450981,
      0.6823529411764706,
      0.3803921568627451,
      0.996078431372549,
      0.8784313725490196,
      0.5450980392156862,
      0.9019607843137255,
      0.9607843137254902,
      0.596078431372549,
      0.6705882352941176,
      0.8666666666666667,
      0.6431372549019608,
      0.4,
      0.7607843137254902,
      0.6470588235294118,
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353
    ],
    Name: "Brewer Diverging Spectral (8)",
    NanColor: [
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353
    ]
  },
  {
    IndexedColors: [
      0.8352941176470589,
      0.2431372549019608,
      0.3098039215686275,
      0.9882352941176471,
      0.5529411764705883,
      0.3490196078431372,
      0.996078431372549,
      0.8784313725490196,
      0.5450980392156862,
      1,
      1,
      0.7490196078431373,
      0.9019607843137255,
      0.9607843137254902,
      0.596078431372549,
      0.6,
      0.8352941176470589,
      0.5803921568627451,
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353
    ],
    Name: "Brewer Diverging Spectral (7)",
    NanColor: [
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353
    ]
  },
  {
    IndexedColors: [
      0.8352941176470589,
      0.2431372549019608,
      0.3098039215686275,
      0.9882352941176471,
      0.5529411764705883,
      0.3490196078431372,
      0.996078431372549,
      0.8784313725490196,
      0.5450980392156862,
      0.9019607843137255,
      0.9607843137254902,
      0.596078431372549,
      0.6,
      0.8352941176470589,
      0.5803921568627451,
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353
    ],
    Name: "Brewer Diverging Spectral (6)",
    NanColor: [
      0.196078431372549,
      0.5333333333333333,
      0.7411764705882353
    ]
  },
  {
    IndexedColors: [
      0.8431372549019608,
      0.09803921568627451,
      0.1098039215686274,
      0.9921568627450981,
      0.6823529411764706,
      0.3803921568627451,
      1,
      1,
      0.7490196078431373,
      0.6705882352941176,
      0.8666666666666667,
      0.6431372549019608,
      0.1686274509803922,
      0.5137254901960784,
      0.7294117647058823
    ],
    Name: "Brewer Diverging Spectral (5)",
    NanColor: [
      0.1686274509803922,
      0.5137254901960784,
      0.7294117647058823
    ]
  },
  {
    IndexedColors: [
      0.8431372549019608,
      0.09803921568627451,
      0.1098039215686274,
      0.9921568627450981,
      0.6823529411764706,
      0.3803921568627451,
      0.6705882352941176,
      0.8666666666666667,
      0.6431372549019608,
      0.1686274509803922,
      0.5137254901960784,
      0.7294117647058823
    ],
    Name: "Brewer Diverging Spectral (4)",
    NanColor: [
      0.1686274509803922,
      0.5137254901960784,
      0.7294117647058823
    ]
  },
  {
    IndexedColors: [
      0.9882352941176471,
      0.5529411764705883,
      0.3490196078431372,
      1,
      1,
      0.7490196078431373,
      0.6,
      0.8352941176470589,
      0.5803921568627451
    ],
    Name: "Brewer Diverging Spectral (3)",
    NanColor: [
      0.6,
      0.8352941176470589,
      0.5803921568627451
    ]
  },
  {
    IndexedColors: [
      0.3294117647058823,
      0.1882352941176471,
      0.0196078431372549,
      0.5490196078431373,
      0.3176470588235294,
      0.0392156862745098,
      0.7490196078431373,
      0.5058823529411764,
      0.1764705882352941,
      0.8745098039215686,
      0.7607843137254902,
      0.4901960784313725,
      0.9647058823529412,
      0.9098039215686274,
      0.7647058823529411,
      0.9607843137254902,
      0.9607843137254902,
      0.9607843137254902,
      0.7803921568627451,
      0.9176470588235294,
      0.8980392156862745,
      0.5019607843137255,
      0.803921568627451,
      0.7568627450980392,
      0.207843137254902,
      0.592156862745098,
      0.5607843137254902,
      0.00392156862745098,
      0.4,
      0.3686274509803922,
      0,
      0.2352941176470588,
      0.1882352941176471
    ],
    Name: "Brewer Diverging Brown-Blue-Green (11)",
    NanColor: [
      0,
      0.2352941176470588,
      0.1882352941176471
    ]
  },
  {
    IndexedColors: [
      0.3294117647058823,
      0.1882352941176471,
      0.0196078431372549,
      0.5490196078431373,
      0.3176470588235294,
      0.0392156862745098,
      0.7490196078431373,
      0.5058823529411764,
      0.1764705882352941,
      0.8745098039215686,
      0.7607843137254902,
      0.4901960784313725,
      0.9647058823529412,
      0.9098039215686274,
      0.7647058823529411,
      0.7803921568627451,
      0.9176470588235294,
      0.8980392156862745,
      0.5019607843137255,
      0.803921568627451,
      0.7568627450980392,
      0.207843137254902,
      0.592156862745098,
      0.5607843137254902,
      0.00392156862745098,
      0.4,
      0.3686274509803922,
      0,
      0.2352941176470588,
      0.1882352941176471
    ],
    Name: "Brewer Diverging Brown-Blue-Green (10)",
    NanColor: [
      0,
      0.2352941176470588,
      0.1882352941176471
    ]
  },
  {
    IndexedColors: [
      0.5490196078431373,
      0.3176470588235294,
      0.0392156862745098,
      0.7490196078431373,
      0.5058823529411764,
      0.1764705882352941,
      0.8745098039215686,
      0.7607843137254902,
      0.4901960784313725,
      0.9647058823529412,
      0.9098039215686274,
      0.7647058823529411,
      0.9607843137254902,
      0.9607843137254902,
      0.9607843137254902,
      0.7803921568627451,
      0.9176470588235294,
      0.8980392156862745,
      0.5019607843137255,
      0.803921568627451,
      0.7568627450980392,
      0.207843137254902,
      0.592156862745098,
      0.5607843137254902,
      0.00392156862745098,
      0.4,
      0.3686274509803922
    ],
    Name: "Brewer Diverging Brown-Blue-Green (9)",
    NanColor: [
      0.00392156862745098,
      0.4,
      0.3686274509803922
    ]
  },
  {
    IndexedColors: [
      0.5490196078431373,
      0.3176470588235294,
      0.0392156862745098,
      0.7490196078431373,
      0.5058823529411764,
      0.1764705882352941,
      0.8745098039215686,
      0.7607843137254902,
      0.4901960784313725,
      0.9647058823529412,
      0.9098039215686274,
      0.7647058823529411,
      0.7803921568627451,
      0.9176470588235294,
      0.8980392156862745,
      0.5019607843137255,
      0.803921568627451,
      0.7568627450980392,
      0.207843137254902,
      0.592156862745098,
      0.5607843137254902,
      0.00392156862745098,
      0.4,
      0.3686274509803922
    ],
    Name: "Brewer Diverging Brown-Blue-Green (8)",
    NanColor: [
      0.00392156862745098,
      0.4,
      0.3686274509803922
    ]
  },
  {
    IndexedColors: [
      0.5490196078431373,
      0.3176470588235294,
      0.0392156862745098,
      0.8470588235294118,
      0.7019607843137254,
      0.396078431372549,
      0.9647058823529412,
      0.9098039215686274,
      0.7647058823529411,
      0.9607843137254902,
      0.9607843137254902,
      0.9607843137254902,
      0.7803921568627451,
      0.9176470588235294,
      0.8980392156862745,
      0.3529411764705883,
      0.7058823529411765,
      0.6745098039215687,
      0.00392156862745098,
      0.4,
      0.3686274509803922
    ],
    Name: "Brewer Diverging Brown-Blue-Green (7)",
    NanColor: [
      0.00392156862745098,
      0.4,
      0.3686274509803922
    ]
  },
  {
    IndexedColors: [
      0.5490196078431373,
      0.3176470588235294,
      0.0392156862745098,
      0.8470588235294118,
      0.7019607843137254,
      0.396078431372549,
      0.9647058823529412,
      0.9098039215686274,
      0.7647058823529411,
      0.7803921568627451,
      0.9176470588235294,
      0.8980392156862745,
      0.3529411764705883,
      0.7058823529411765,
      0.6745098039215687,
      0.00392156862745098,
      0.4,
      0.3686274509803922
    ],
    Name: "Brewer Diverging Brown-Blue-Green (6)",
    NanColor: [
      0.00392156862745098,
      0.4,
      0.3686274509803922
    ]
  },
  {
    IndexedColors: [
      0.6509803921568628,
      0.3803921568627451,
      0.1019607843137255,
      0.8745098039215686,
      0.7607843137254902,
      0.4901960784313725,
      0.9607843137254902,
      0.9607843137254902,
      0.9607843137254902,
      0.5019607843137255,
      0.803921568627451,
      0.7568627450980392,
      0.00392156862745098,
      0.5215686274509804,
      0.4431372549019608
    ],
    Name: "Brewer Diverging Brown-Blue-Green (5)",
    NanColor: [
      0.00392156862745098,
      0.5215686274509804,
      0.4431372549019608
    ]
  },
  {
    IndexedColors: [
      0.6509803921568628,
      0.3803921568627451,
      0.1019607843137255,
      0.8745098039215686,
      0.7607843137254902,
      0.4901960784313725,
      0.5019607843137255,
      0.803921568627451,
      0.7568627450980392,
      0.00392156862745098,
      0.5215686274509804,
      0.4431372549019608
    ],
    Name: "Brewer Diverging Brown-Blue-Green (4)",
    NanColor: [
      0.00392156862745098,
      0.5215686274509804,
      0.4431372549019608
    ]
  },
  {
    IndexedColors: [
      0.8470588235294118,
      0.7019607843137254,
      0.396078431372549,
      0.9607843137254902,
      0.9607843137254902,
      0.9607843137254902,
      0.3529411764705883,
      0.7058823529411765,
      0.6745098039215687
    ],
    Name: "Brewer Diverging Brown-Blue-Green (3)",
    NanColor: [
      0.3529411764705883,
      0.7058823529411765,
      0.6745098039215687
    ]
  },
  {
    IndexedColors: [
      0.9686274509803922,
      0.9882352941176471,
      0.9921568627450981,
      0.8980392156862745,
      0.9607843137254902,
      0.9764705882352941,
      0.8,
      0.9254901960784314,
      0.9019607843137255,
      0.6,
      0.8470588235294118,
      0.788235294117647,
      0.4,
      0.7607843137254902,
      0.6431372549019608,
      0.2549019607843137,
      0.6823529411764706,
      0.4627450980392157,
      0.1372549019607843,
      0.5450980392156862,
      0.2705882352941176,
      0,
      0.4274509803921568,
      0.1725490196078431,
      0,
      0.2666666666666667,
      0.1058823529411765
    ],
    Name: "Brewer Sequential Blue-Green (9)",
    NanColor: [
      0,
      0.2666666666666667,
      0.1058823529411765
    ]
  },
  {
    IndexedColors: [
      0.9686274509803922,
      0.9882352941176471,
      0.9921568627450981,
      0.8980392156862745,
      0.9607843137254902,
      0.9764705882352941,
      0.8,
      0.9254901960784314,
      0.9019607843137255,
      0.6,
      0.8470588235294118,
      0.788235294117647,
      0.4,
      0.7607843137254902,
      0.6431372549019608,
      0.2549019607843137,
      0.6823529411764706,
      0.4627450980392157,
      0.1372549019607843,
      0.5450980392156862,
      0.2705882352941176,
      0,
      0.3450980392156863,
      0.1411764705882353
    ],
    Name: "Brewer Sequential Blue-Green (8)",
    NanColor: [
      0,
      0.3450980392156863,
      0.1411764705882353
    ]
  },
  {
    IndexedColors: [
      0.9294117647058824,
      0.9725490196078431,
      0.984313725490196,
      0.8,
      0.9254901960784314,
      0.9019607843137255,
      0.8,
      0.9254901960784314,
      0.9019607843137255,
      0.4,
      0.7607843137254902,
      0.6431372549019608,
      0.2549019607843137,
      0.6823529411764706,
      0.4627450980392157,
      0.1372549019607843,
      0.5450980392156862,
      0.2705882352941176,
      0,
      0.3450980392156863,
      0.1411764705882353
    ],
    Name: "Brewer Sequential Blue-Green (7)",
    NanColor: [
      0,
      0.3450980392156863,
      0.1411764705882353
    ]
  },
  {
    IndexedColors: [
      0.9294117647058824,
      0.9725490196078431,
      0.984313725490196,
      0.8,
      0.9254901960784314,
      0.9019607843137255,
      0.6,
      0.8470588235294118,
      0.788235294117647,
      0.4,
      0.7607843137254902,
      0.6431372549019608,
      0.1725490196078431,
      0.6352941176470588,
      0.3725490196078431,
      0,
      0.4274509803921568,
      0.1725490196078431
    ],
    Name: "Brewer Sequential Blue-Green (6)",
    NanColor: [
      0,
      0.4274509803921568,
      0.1725490196078431
    ]
  },
  {
    IndexedColors: [
      0.9294117647058824,
      0.9725490196078431,
      0.984313725490196,
      0.6980392156862745,
      0.8862745098039215,
      0.8862745098039215,
      0.4,
      0.7607843137254902,
      0.6431372549019608,
      0.1725490196078431,
      0.6352941176470588,
      0.3725490196078431,
      0,
      0.4274509803921568,
      0.1725490196078431
    ],
    Name: "Brewer Sequential Blue-Green (5)",
    NanColor: [
      0,
      0.4274509803921568,
      0.1725490196078431
    ]
  },
  {
    IndexedColors: [
      0.9294117647058824,
      0.9725490196078431,
      0.984313725490196,
      0.6980392156862745,
      0.8862745098039215,
      0.8862745098039215,
      0.4,
      0.7607843137254902,
      0.6431372549019608,
      0.1372549019607843,
      0.5450980392156862,
      0.2705882352941176
    ],
    Name: "Brewer Sequential Blue-Green (4)",
    NanColor: [
      0.1372549019607843,
      0.5450980392156862,
      0.2705882352941176
    ]
  },
  {
    IndexedColors: [
      0.8980392156862745,
      0.9607843137254902,
      0.9764705882352941,
      0.6,
      0.8470588235294118,
      0.788235294117647,
      0.1725490196078431,
      0.6352941176470588,
      0.3725490196078431
    ],
    Name: "Brewer Sequential Blue-Green (3)",
    NanColor: [
      0.1725490196078431,
      0.6352941176470588,
      0.3725490196078431
    ]
  },
  {
    IndexedColors: [
      1,
      1,
      0.8980392156862745,
      1,
      0.9686274509803922,
      0.7372549019607844,
      0.996078431372549,
      0.8901960784313725,
      0.5686274509803921,
      0.996078431372549,
      0.7686274509803922,
      0.3098039215686275,
      0.996078431372549,
      0.6,
      0.1607843137254902,
      0.9254901960784314,
      0.4392156862745098,
      0.0784313725490196,
      0.8,
      0.2980392156862745,
      0.00784313725490196,
      0.6,
      0.203921568627451,
      0.01568627450980392,
      0.4,
      0.1450980392156863,
      0.02352941176470588
    ],
    Name: "Brewer Sequential Yellow-Orange-Brown (9)",
    NanColor: [
      0.4,
      0.1450980392156863,
      0.02352941176470588
    ]
  },
  {
    IndexedColors: [
      1,
      1,
      0.8980392156862745,
      1,
      0.9686274509803922,
      0.7372549019607844,
      0.996078431372549,
      0.8901960784313725,
      0.5686274509803921,
      0.996078431372549,
      0.7686274509803922,
      0.3098039215686275,
      0.996078431372549,
      0.6,
      0.1607843137254902,
      0.9254901960784314,
      0.4392156862745098,
      0.0784313725490196,
      0.8,
      0.2980392156862745,
      0.00784313725490196,
      0.5490196078431373,
      0.1764705882352941,
      0.01568627450980392
    ],
    Name: "Brewer Sequential Yellow-Orange-Brown (8)",
    NanColor: [
      0.5490196078431373,
      0.1764705882352941,
      0.01568627450980392
    ]
  },
  {
    IndexedColors: [
      1,
      1,
      0.8313725490196079,
      0.996078431372549,
      0.8901960784313725,
      0.5686274509803921,
      0.996078431372549,
      0.7686274509803922,
      0.3098039215686275,
      0.996078431372549,
      0.6,
      0.1607843137254902,
      0.9254901960784314,
      0.4392156862745098,
      0.0784313725490196,
      0.8,
      0.2980392156862745,
      0.00784313725490196,
      0.5490196078431373,
      0.1764705882352941,
      0.01568627450980392
    ],
    Name: "Brewer Sequential Yellow-Orange-Brown (7)",
    NanColor: [
      0.5490196078431373,
      0.1764705882352941,
      0.01568627450980392
    ]
  },
  {
    IndexedColors: [
      1,
      1,
      0.8313725490196079,
      0.996078431372549,
      0.8901960784313725,
      0.5686274509803921,
      0.996078431372549,
      0.7686274509803922,
      0.3098039215686275,
      0.996078431372549,
      0.6,
      0.1607843137254902,
      0.8509803921568627,
      0.3725490196078431,
      0.05490196078431372,
      0.6,
      0.203921568627451,
      0.01568627450980392
    ],
    Name: "Brewer Sequential Yellow-Orange-Brown (6)",
    NanColor: [
      0.6,
      0.203921568627451,
      0.01568627450980392
    ]
  },
  {
    IndexedColors: [
      1,
      1,
      0.8313725490196079,
      0.996078431372549,
      0.8509803921568627,
      0.5568627450980392,
      0.996078431372549,
      0.6,
      0.1607843137254902,
      0.8509803921568627,
      0.3725490196078431,
      0.05490196078431372,
      0.6,
      0.203921568627451,
      0.01568627450980392
    ],
    Name: "Brewer Sequential Yellow-Orange-Brown (5)",
    NanColor: [
      0.6,
      0.203921568627451,
      0.01568627450980392
    ]
  },
  {
    IndexedColors: [
      1,
      1,
      0.8313725490196079,
      0.996078431372549,
      0.8509803921568627,
      0.5568627450980392,
      0.996078431372549,
      0.6,
      0.1607843137254902,
      0.8,
      0.2980392156862745,
      0.00784313725490196
    ],
    Name: "Brewer Sequential Yellow-Orange-Brown (4)",
    NanColor: [
      0.8,
      0.2980392156862745,
      0.00784313725490196
    ]
  },
  {
    IndexedColors: [
      1,
      0.9686274509803922,
      0.7372549019607844,
      0.996078431372549,
      0.7686274509803922,
      0.3098039215686275,
      0.8509803921568627,
      0.3725490196078431,
      0.05490196078431372
    ],
    Name: "Brewer Sequential Yellow-Orange-Brown (3)",
    NanColor: [
      0.8509803921568627,
      0.3725490196078431,
      0.05490196078431372
    ]
  },
  {
    IndexedColors: [
      0.9686274509803922,
      0.9882352941176471,
      0.9921568627450981,
      0.8784313725490196,
      0.9254901960784314,
      0.9568627450980393,
      0.7490196078431373,
      0.8274509803921568,
      0.9019607843137255,
      0.6196078431372549,
      0.7372549019607844,
      0.8549019607843137,
      0.5490196078431373,
      0.5882352941176471,
      0.7764705882352941,
      0.5490196078431373,
      0.4196078431372549,
      0.6941176470588235,
      0.5333333333333333,
      0.2549019607843137,
      0.615686274509804,
      0.5058823529411764,
      0.05882352941176471,
      0.4862745098039216,
      0.3019607843137255,
      0,
      0.2941176470588235
    ],
    Name: "Brewer Sequential Blue-Purple (9)",
    NanColor: [
      0.3019607843137255,
      0,
      0.2941176470588235
    ]
  },
  {
    IndexedColors: [
      0.9686274509803922,
      0.9882352941176471,
      0.9921568627450981,
      0.8784313725490196,
      0.9254901960784314,
      0.9568627450980393,
      0.7490196078431373,
      0.8274509803921568,
      0.9019607843137255,
      0.6196078431372549,
      0.7372549019607844,
      0.8549019607843137,
      0.5490196078431373,
      0.5882352941176471,
      0.7764705882352941,
      0.5490196078431373,
      0.4196078431372549,
      0.6941176470588235,
      0.5333333333333333,
      0.2549019607843137,
      0.615686274509804,
      0.4313725490196079,
      0.00392156862745098,
      0.4196078431372549
    ],
    Name: "Brewer Sequential Blue-Purple (8)",
    NanColor: [
      0.4313725490196079,
      0.00392156862745098,
      0.4196078431372549
    ]
  },
  {
    IndexedColors: [
      0.9294117647058824,
      0.9725490196078431,
      0.984313725490196,
      0.7490196078431373,
      0.8274509803921568,
      0.9019607843137255,
      0.6196078431372549,
      0.7372549019607844,
      0.8549019607843137,
      0.5490196078431373,
      0.5882352941176471,
      0.7764705882352941,
      0.5490196078431373,
      0.4196078431372549,
      0.6941176470588235,
      0.5333333333333333,
      0.2549019607843137,
      0.615686274509804,
      0.4313725490196079,
      0.00392156862745098,
      0.4196078431372549
    ],
    Name: "Brewer Sequential Blue-Purple (7)",
    NanColor: [
      0.4313725490196079,
      0.00392156862745098,
      0.4196078431372549
    ]
  },
  {
    IndexedColors: [
      0.9294117647058824,
      0.9725490196078431,
      0.984313725490196,
      0.7490196078431373,
      0.8274509803921568,
      0.9019607843137255,
      0.6196078431372549,
      0.7372549019607844,
      0.8549019607843137,
      0.5490196078431373,
      0.5882352941176471,
      0.7764705882352941,
      0.5333333333333333,
      0.3372549019607843,
      0.6549019607843137,
      0.5058823529411764,
      0.05882352941176471,
      0.4862745098039216
    ],
    Name: "Brewer Sequential Blue-Purple (6)",
    NanColor: [
      0.5058823529411764,
      0.05882352941176471,
      0.4862745098039216
    ]
  },
  {
    IndexedColors: [
      0.9294117647058824,
      0.9725490196078431,
      0.984313725490196,
      0.7019607843137254,
      0.803921568627451,
      0.8901960784313725,
      0.5490196078431373,
      0.5882352941176471,
      0.7764705882352941,
      0.5333333333333333,
      0.3372549019607843,
      0.6549019607843137,
      0.5058823529411764,
      0.05882352941176471,
      0.4862745098039216
    ],
    Name: "Brewer Sequential Blue-Purple (5)",
    NanColor: [
      0.5058823529411764,
      0.05882352941176471,
      0.4862745098039216
    ]
  },
  {
    IndexedColors: [
      0.9294117647058824,
      0.9725490196078431,
      0.984313725490196,
      0.7019607843137254,
      0.803921568627451,
      0.8901960784313725,
      0.5490196078431373,
      0.5882352941176471,
      0.7764705882352941,
      0.5333333333333333,
      0.2549019607843137,
      0.615686274509804
    ],
    Name: "Brewer Sequential Blue-Purple (4)",
    NanColor: [
      0.5333333333333333,
      0.2549019607843137,
      0.615686274509804
    ]
  },
  {
    IndexedColors: [
      0.8784313725490196,
      0.9254901960784314,
      0.9568627450980393,
      0.6196078431372549,
      0.7372549019607844,
      0.8549019607843137,
      0.5333333333333333,
      0.3372549019607843,
      0.6549019607843137
    ],
    Name: "Brewer Sequential Blue-Purple (3)",
    NanColor: [
      0.5333333333333333,
      0.3372549019607843,
      0.6549019607843137
    ]
  },
  {
    IndexedColors: [
      0.4980392156862745,
      0.788235294117647,
      0.4980392156862745,
      0.7450980392156863,
      0.6823529411764706,
      0.8313725490196079,
      0.9921568627450981,
      0.7529411764705882,
      0.5254901960784314,
      1,
      1,
      0.6,
      0.2196078431372549,
      0.4235294117647059,
      0.6901960784313725,
      0.9411764705882353,
      0.00784313725490196,
      0.4980392156862745,
      0.7490196078431373,
      0.3568627450980392,
      0.09019607843137255,
      0.4,
      0.4,
      0.4
    ],
    Name: "Brewer Qualitative Accent",
    NanColor: [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    IndexedColors: [
      0.1058823529411765,
      0.6196078431372549,
      0.4666666666666667,
      0.8509803921568627,
      0.3725490196078431,
      0.00784313725490196,
      0.4588235294117647,
      0.4392156862745098,
      0.7019607843137254,
      0.9058823529411765,
      0.1607843137254902,
      0.5411764705882353,
      0.4,
      0.6509803921568628,
      0.1176470588235294,
      0.9019607843137255,
      0.6705882352941176,
      0.00784313725490196,
      0.6509803921568628,
      0.4627450980392157,
      0.1137254901960784,
      0.4,
      0.4,
      0.4
    ],
    Name: "Brewer Qualitative Dark2",
    NanColor: [
      0.4,
      0.4,
      0.4
    ]
  },
  {
    IndexedColors: [
      0.4,
      0.7607843137254902,
      0.6470588235294118,
      0.9882352941176471,
      0.5529411764705883,
      0.3843137254901961,
      0.5529411764705883,
      0.6274509803921569,
      0.796078431372549,
      0.9058823529411765,
      0.5411764705882353,
      0.7647058823529411,
      0.6509803921568628,
      0.8470588235294118,
      0.3294117647058823,
      1,
      0.8509803921568627,
      0.1843137254901961,
      0.8980392156862745,
      0.7686274509803922,
      0.5803921568627451,
      0.7019607843137254,
      0.7019607843137254,
      0.7019607843137254
    ],
    Name: "Brewer Qualitative Set2",
    NanColor: [
      0.7019607843137254,
      0.7019607843137254,
      0.7019607843137254
    ]
  },
  {
    IndexedColors: [
      0.7019607843137254,
      0.8862745098039215,
      0.803921568627451,
      0.9921568627450981,
      0.803921568627451,
      0.6745098039215687,
      0.796078431372549,
      0.8352941176470589,
      0.9098039215686274,
      0.9568627450980393,
      0.792156862745098,
      0.8941176470588236,
      0.9019607843137255,
      0.9607843137254902,
      0.788235294117647,
      1,
      0.9490196078431372,
      0.6823529411764706,
      0.9450980392156862,
      0.8862745098039215,
      0.8,
      0.8,
      0.8,
      0.8
    ],
    Name: "Brewer Qualitative Pastel2",
    NanColor: [
      0.8,
      0.8,
      0.8
    ]
  },
  {
    IndexedColors: [
      0.984313725490196,
      0.7058823529411765,
      0.6823529411764706,
      0.7019607843137254,
      0.803921568627451,
      0.8901960784313725,
      0.8,
      0.9215686274509803,
      0.7725490196078432,
      0.8705882352941177,
      0.796078431372549,
      0.8941176470588236,
      0.996078431372549,
      0.8509803921568627,
      0.6509803921568628,
      1,
      1,
      0.8,
      0.8980392156862745,
      0.8470588235294118,
      0.7411764705882353,
      0.9921568627450981,
      0.8549019607843137,
      0.9254901960784314,
      0.9490196078431372,
      0.9490196078431372,
      0.9490196078431372
    ],
    Name: "Brewer Qualitative Pastel1",
    NanColor: [
      0.9490196078431372,
      0.9490196078431372,
      0.9490196078431372
    ]
  },
  {
    IndexedColors: [
      0.8941176470588236,
      0.1019607843137255,
      0.1098039215686274,
      0.2156862745098039,
      0.4941176470588236,
      0.7215686274509804,
      0.3019607843137255,
      0.6862745098039216,
      0.2901960784313726,
      0.596078431372549,
      0.3058823529411765,
      0.6392156862745098,
      1,
      0.4980392156862745,
      0,
      1,
      1,
      0.2,
      0.6509803921568628,
      0.3372549019607843,
      0.1568627450980392,
      0.9686274509803922,
      0.5058823529411764,
      0.7490196078431373,
      0.6,
      0.6,
      0.6
    ],
    Name: "Brewer Qualitative Set1",
    NanColor: [
      0.6,
      0.6,
      0.6
    ]
  },
  {
    IndexedColors: [
      0.6509803921568628,
      0.807843137254902,
      0.8901960784313725,
      0.1215686274509804,
      0.4705882352941176,
      0.7058823529411765,
      0.6980392156862745,
      0.8745098039215686,
      0.5411764705882353,
      0.2,
      0.6274509803921569,
      0.1725490196078431,
      0.984313725490196,
      0.6039215686274509,
      0.6,
      0.8901960784313725,
      0.1019607843137255,
      0.1098039215686274,
      0.9921568627450981,
      0.7490196078431373,
      0.4352941176470588,
      1,
      0.4980392156862745,
      0,
      0.792156862745098,
      0.6980392156862745,
      0.8392156862745098,
      0.4156862745098039,
      0.2392156862745098,
      0.6039215686274509,
      1,
      1,
      0.6
    ],
    Name: "Brewer Qualitative Paired",
    NanColor: [
      1,
      1,
      0.6
    ]
  },
  {
    IndexedColors: [
      0.5529411764705883,
      0.8274509803921568,
      0.7803921568627451,
      1,
      1,
      0.7019607843137254,
      0.7450980392156863,
      0.7294117647058823,
      0.8549019607843137,
      0.984313725490196,
      0.5019607843137255,
      0.4470588235294118,
      0.5019607843137255,
      0.6941176470588235,
      0.8274509803921568,
      0.9921568627450981,
      0.7058823529411765,
      0.3843137254901961,
      0.7019607843137254,
      0.8705882352941177,
      0.4117647058823529,
      0.9882352941176471,
      0.803921568627451,
      0.8980392156862745,
      0.8509803921568627,
      0.8509803921568627,
      0.8509803921568627,
      0.7372549019607844,
      0.5019607843137255,
      0.7411764705882353,
      0.8,
      0.9215686274509803,
      0.7725490196078432,
      1,
      0.9294117647058824,
      0.4352941176470588
    ],
    Name: "Brewer Qualitative Set3",
    NanColor: [
      1,
      0.9294117647058824,
      0.4352941176470588
    ]
  },
  {
    IndexedColors: [
      1,
      0,
      0,
      1,
      0.862745,
      0,
      0,
      0.695201,
      0
    ],
    Name: "Traffic Lights",
    NanColor: [
      0.803922,
      0,
      0.803922
    ]
  },
  {
    IndexedColors: [
      0.908659,
      0.604013,
      0.581857,
      1,
      0.862745,
      0,
      0,
      0.695201,
      0
    ],
    Name: "Traffic Lights For Deuteranopes",
    NanColor: [
      0.803922,
      0,
      0.803922
    ]
  },
  {
    IndexedColors: [
      0.4196078431372549,
      0,
      0.07058823529411765,
      0.9019607843137255,
      0.9411764705882353,
      0.0196078431372549,
      0.01568627450980392,
      0.6196078431372549,
      0.00784313725490196
    ],
    Name: "Traffic Lights For Deuteranopes 2",
    NanColor: [
      0.803922,
      0,
      0.803922
    ]
  },
  {
    ColorSpace: "Lab",
    Creator: "Francesca Samsel",
    Name: "Muted Blue-Green",
    NanColor: [
      0.25,
      0,
      0
    ],
    RGBPoints: [
      0,
      0.109804,
      0.27451,
      0.301961,
      0.02,
      0.129412,
      0.309804,
      0.341176,
      0.05,
      0.14902,
      0.341176,
      0.380392,
      0.1,
      0.188235,
      0.403922,
      0.458824,
      0.15,
      0.227451,
      0.447059,
      0.521569,
      0.2,
      0.290196,
      0.494118,
      0.588235,
      0.25,
      0.368627,
      0.552941,
      0.670588,
      0.3,
      0.458824,
      0.619608,
      0.74902,
      0.35,
      0.588235,
      0.713725,
      0.85098,
      0.4,
      0.72549,
      0.815686,
      0.941176,
      0.45,
      0.831373,
      0.882353,
      0.980392,
      0.475,
      0.909804,
      0.933333,
      1,
      0.5,
      0.980392,
      0.984314,
      1,
      0.5,
      0.996078,
      1,
      0.94902,
      0.5,
      1,
      1,
      0.980392,
      0.5,
      0.980392,
      0.984314,
      1,
      0.525,
      0.972549,
      0.988235,
      0.890196,
      0.55,
      0.917647,
      0.960784,
      0.835294,
      0.6,
      0.835294,
      0.921569,
      0.772549,
      0.65,
      0.768627,
      0.901961,
      0.737255,
      0.7,
      0.670588,
      0.831373,
      0.654902,
      0.75,
      0.576471,
      0.760784,
      0.584314,
      0.8,
      0.498039,
      0.678431,
      0.521569,
      0.85,
      0.392157,
      0.560784,
      0.427451,
      0.9,
      0.294118,
      0.45098,
      0.333333,
      0.95,
      0.211765,
      0.34902,
      0.254902,
      1,
      0.152941,
      0.278431,
      0.196078
    ]
  },
  {
    ColorSpace: "Lab",
    Creator: "Francesca Samsel",
    Name: "Green-Blue Asymmetric Divergent (62Blbc)",
    NanColor: [
      0.25,
      0,
      0
    ],
    RGBPoints: [
      0,
      0.121569,
      0.2,
      0.145098,
      0.05,
      0.196078,
      0.301961,
      0.223529,
      0.1,
      0.258824,
      0.4,
      0.278431,
      0.2,
      0.341176,
      0.54902,
      0.341176,
      0.25,
      0.419608,
      0.619608,
      0.376471,
      0.3,
      0.545098,
      0.701961,
      0.392157,
      0.35,
      0.643137,
      0.780392,
      0.403922,
      0.4,
      0.729412,
      0.819608,
      0.45098,
      0.45,
      0.811765,
      0.870588,
      0.521569,
      0.5,
      0.898039,
      0.909804,
      0.564706,
      0.55,
      0.941176,
      0.92549,
      0.686275,
      0.6,
      0.960784,
      0.94902,
      0.776471,
      0.64,
      1,
      1,
      1,
      0.65,
      0.890196,
      0.988235,
      0.972549,
      0.7,
      0.721569,
      0.894118,
      0.901961,
      0.75,
      0.631373,
      0.823529,
      0.839216,
      0.8,
      0.517647,
      0.662745,
      0.701961,
      0.85,
      0.384314,
      0.494118,
      0.54902,
      0.9,
      0.298039,
      0.360784,
      0.45098,
      0.95,
      0.223529,
      0.25098,
      0.34902,
      0.99,
      0.156863,
      0.172549,
      0.25098,
      1,
      0.137255,
      0.137255,
      0.188235
    ]
  },
  {
    ColorSpace: "Lab",
    Creator: "Francesca Samsel",
    Name: "Asymmtrical Earth Tones (6_21b)",
    NanColor: [
      0.25,
      0,
      0
    ],
    RGBPoints: [
      0,
      0.141176,
      0.14902,
      0.2,
      0.05,
      0.215686,
      0.258824,
      0.321569,
      0.1,
      0.243137,
      0.368627,
      0.380392,
      0.15,
      0.27451,
      0.439216,
      0.4,
      0.2,
      0.32549,
      0.501961,
      0.384314,
      0.25,
      0.403922,
      0.6,
      0.419608,
      0.3,
      0.486275,
      0.701961,
      0.454902,
      0.35,
      0.556863,
      0.74902,
      0.494118,
      0.4,
      0.670588,
      0.8,
      0.545098,
      0.5,
      0.854902,
      0.901961,
      0.631373,
      0.55,
      0.92549,
      0.941176,
      0.694118,
      0.6,
      0.960784,
      0.94902,
      0.776471,
      0.65,
      0.988235,
      0.968627,
      0.909804,
      0.7,
      0.839216,
      0.815686,
      0.772549,
      0.75,
      0.701961,
      0.662745,
      0.615686,
      0.8,
      0.6,
      0.529412,
      0.478431,
      0.85,
      0.501961,
      0.403922,
      0.360784,
      0.9,
      0.439216,
      0.313725,
      0.290196,
      1,
      0.301961,
      0.164706,
      0.176471
    ]
  },
  {
    ColorSpace: "Lab",
    Creator: "Francesca Samsel",
    Name: "Yellow 15",
    NanColor: [
      0.25,
      0,
      0
    ],
    RGBPoints: [
      0,
      1,
      1,
      0.988235,
      2e-3,
      1,
      1,
      0.988235,
      0.05,
      0.984314,
      0.988235,
      0.843137,
      0.1,
      0.988235,
      0.988235,
      0.741176,
      0.15,
      0.980392,
      0.968627,
      0.654902,
      0.2,
      0.980392,
      0.945098,
      0.576471,
      0.25,
      0.968627,
      0.905882,
      0.486275,
      0.3,
      0.968627,
      0.862745,
      0.388235,
      0.35,
      0.960784,
      0.803922,
      0.286275,
      0.4,
      0.94902,
      0.741176,
      0.219608,
      0.45,
      0.941176,
      0.678431,
      0.14902,
      0.5,
      0.929412,
      0.607843,
      0.094118,
      0.55,
      0.921569,
      0.545098,
      0.054902,
      0.6,
      0.909804,
      0.486275,
      0.035294,
      0.65,
      0.890196,
      0.411765,
      0.019608,
      0.7,
      0.8,
      0.305882,
      0,
      0.75,
      0.760784,
      0.239216,
      0,
      0.8,
      0.678431,
      0.180392,
      0.011765,
      0.85,
      0.6,
      0.121569,
      0.023529,
      0.9,
      0.501961,
      0.054902,
      0.031373,
      0.95,
      0.4,
      0.039216,
      0.058824,
      1,
      0.301961,
      0.047059,
      0.090196
    ]
  },
  {
    ColorSpace: "Diverging",
    Name: "Magma (matplotlib)",
    NanColor: [
      0,
      1,
      0
    ],
    Source: "https://github.com/BIDS/colormap/blob/master/colormaps.py",
    License: "CC0",
    Creator: "Nathaniel J. Smith & Stefan van der Walt",
    RGBPoints: [
      0,
      1462e-6,
      466e-6,
      0.013866,
      3922e-6,
      2258e-6,
      1295e-6,
      0.018331,
      7843e-6,
      3279e-6,
      2305e-6,
      0.023708,
      0.011765,
      4512e-6,
      349e-5,
      0.029965,
      0.015686,
      595e-5,
      4843e-6,
      0.03713,
      0.019608,
      7588e-6,
      6356e-6,
      0.044973,
      0.023529,
      9426e-6,
      8022e-6,
      0.052844,
      0.027451,
      0.011465,
      9828e-6,
      0.06075,
      0.031373,
      0.013708,
      0.011771,
      0.068667,
      0.035294,
      0.016156,
      0.01384,
      0.076603,
      0.039216,
      0.018815,
      0.016026,
      0.084584,
      0.043137,
      0.021692,
      0.01832,
      0.09261,
      0.047059,
      0.024792,
      0.020715,
      0.100676,
      0.05098,
      0.028123,
      0.023201,
      0.108787,
      0.054902,
      0.031696,
      0.025765,
      0.116965,
      0.058824,
      0.03552,
      0.028397,
      0.125209,
      0.062745,
      0.039608,
      0.03109,
      0.133515,
      0.066667,
      0.04383,
      0.03383,
      0.141886,
      0.070588,
      0.048062,
      0.036607,
      0.150327,
      0.07451,
      0.05232,
      0.039407,
      0.158841,
      0.078431,
      0.056615,
      0.04216,
      0.167446,
      0.082353,
      0.060949,
      0.044794,
      0.176129,
      0.086275,
      0.06533,
      0.047318,
      0.184892,
      0.090196,
      0.069764,
      0.049726,
      0.193735,
      0.094118,
      0.074257,
      0.052017,
      0.20266,
      0.098039,
      0.078815,
      0.054184,
      0.211667,
      0.101961,
      0.083446,
      0.056225,
      0.220755,
      0.105882,
      0.088155,
      0.058133,
      0.229922,
      0.109804,
      0.092949,
      0.059904,
      0.239164,
      0.113725,
      0.097833,
      0.061531,
      0.248477,
      0.117647,
      0.102815,
      0.06301,
      0.257854,
      0.121569,
      0.107899,
      0.064335,
      0.267289,
      0.12549,
      0.113094,
      0.065492,
      0.276784,
      0.129412,
      0.118405,
      0.066479,
      0.286321,
      0.133333,
      0.123833,
      0.067295,
      0.295879,
      0.137255,
      0.12938,
      0.067935,
      0.305443,
      0.141176,
      0.135053,
      0.068391,
      0.315,
      0.145098,
      0.140858,
      0.068654,
      0.324538,
      0.14902,
      0.146785,
      0.068738,
      0.334011,
      0.152941,
      0.152839,
      0.068637,
      0.343404,
      0.156863,
      0.159018,
      0.068354,
      0.352688,
      0.160784,
      0.165308,
      0.067911,
      0.361816,
      0.164706,
      0.171713,
      0.067305,
      0.370771,
      0.168627,
      0.178212,
      0.066576,
      0.379497,
      0.172549,
      0.184801,
      0.065732,
      0.387973,
      0.176471,
      0.19146,
      0.064818,
      0.396152,
      0.180392,
      0.198177,
      0.063862,
      0.404009,
      0.184314,
      0.204935,
      0.062907,
      0.411514,
      0.188235,
      0.211718,
      0.061992,
      0.418647,
      0.192157,
      0.218512,
      0.061158,
      0.425392,
      0.196078,
      0.225302,
      0.060445,
      0.431742,
      0.2,
      0.232077,
      0.059889,
      0.437695,
      0.203922,
      0.238826,
      0.059517,
      0.443256,
      0.207843,
      0.245543,
      0.059352,
      0.448436,
      0.211765,
      0.25222,
      0.059415,
      0.453248,
      0.215686,
      0.258857,
      0.059706,
      0.45771,
      0.219608,
      0.265447,
      0.060237,
      0.46184,
      0.223529,
      0.271994,
      0.060994,
      0.46566,
      0.227451,
      0.278493,
      0.061978,
      0.46919,
      0.231373,
      0.284951,
      0.063168,
      0.472451,
      0.235294,
      0.291366,
      0.064553,
      0.475462,
      0.239216,
      0.29774,
      0.066117,
      0.478243,
      0.243137,
      0.304081,
      0.067835,
      0.480812,
      0.247059,
      0.310382,
      0.069702,
      0.483186,
      0.25098,
      0.316654,
      0.07169,
      0.48538,
      0.254902,
      0.322899,
      0.073782,
      0.487408,
      0.258824,
      0.329114,
      0.075972,
      0.489287,
      0.262745,
      0.335308,
      0.078236,
      0.491024,
      0.266667,
      0.341482,
      0.080564,
      0.492631,
      0.270588,
      0.347636,
      0.082946,
      0.494121,
      0.27451,
      0.353773,
      0.085373,
      0.495501,
      0.278431,
      0.359898,
      0.087831,
      0.496778,
      0.282353,
      0.366012,
      0.090314,
      0.49796,
      0.286275,
      0.372116,
      0.092816,
      0.499053,
      0.290196,
      0.378211,
      0.095332,
      0.500067,
      0.294118,
      0.384299,
      0.097855,
      0.501002,
      0.298039,
      0.390384,
      0.100379,
      0.501864,
      0.301961,
      0.396467,
      0.102902,
      0.502658,
      0.305882,
      0.402548,
      0.10542,
      0.503386,
      0.309804,
      0.408629,
      0.10793,
      0.504052,
      0.313725,
      0.414709,
      0.110431,
      0.504662,
      0.317647,
      0.420791,
      0.11292,
      0.505215,
      0.321569,
      0.426877,
      0.115395,
      0.505714,
      0.32549,
      0.432967,
      0.117855,
      0.50616,
      0.329412,
      0.439062,
      0.120298,
      0.506555,
      0.333333,
      0.445163,
      0.122724,
      0.506901,
      0.337255,
      0.451271,
      0.125132,
      0.507198,
      0.341176,
      0.457386,
      0.127522,
      0.507448,
      0.345098,
      0.463508,
      0.129893,
      0.507652,
      0.34902,
      0.46964,
      0.132245,
      0.507809,
      0.352941,
      0.47578,
      0.134577,
      0.507921,
      0.356863,
      0.481929,
      0.136891,
      0.507989,
      0.360784,
      0.488088,
      0.139186,
      0.508011,
      0.364706,
      0.494258,
      0.141462,
      0.507988,
      0.368627,
      0.500438,
      0.143719,
      0.50792,
      0.372549,
      0.506629,
      0.145958,
      0.507806,
      0.376471,
      0.512831,
      0.148179,
      0.507648,
      0.380392,
      0.519045,
      0.150383,
      0.507443,
      0.384314,
      0.52527,
      0.152569,
      0.507192,
      0.388235,
      0.531507,
      0.154739,
      0.506895,
      0.392157,
      0.537755,
      0.156894,
      0.506551,
      0.396078,
      0.544015,
      0.159033,
      0.506159,
      0.4,
      0.550287,
      0.161158,
      0.505719,
      0.403922,
      0.556571,
      0.163269,
      0.50523,
      0.407843,
      0.562866,
      0.165368,
      0.504692,
      0.411765,
      0.569172,
      0.167454,
      0.504105,
      0.415686,
      0.57549,
      0.16953,
      0.503466,
      0.419608,
      0.581819,
      0.171596,
      0.502777,
      0.423529,
      0.588158,
      0.173652,
      0.502035,
      0.427451,
      0.594508,
      0.175701,
      0.501241,
      0.431373,
      0.600868,
      0.177743,
      0.500394,
      0.435294,
      0.607238,
      0.179779,
      0.499492,
      0.439216,
      0.613617,
      0.181811,
      0.498536,
      0.443137,
      0.620005,
      0.18384,
      0.497524,
      0.447059,
      0.626401,
      0.185867,
      0.496456,
      0.45098,
      0.632805,
      0.187893,
      0.495332,
      0.454902,
      0.639216,
      0.189921,
      0.49415,
      0.458824,
      0.645633,
      0.191952,
      0.49291,
      0.462745,
      0.652056,
      0.193986,
      0.491611,
      0.466667,
      0.658483,
      0.196027,
      0.490253,
      0.470588,
      0.664915,
      0.198075,
      0.488836,
      0.47451,
      0.671349,
      0.200133,
      0.487358,
      0.478431,
      0.677786,
      0.202203,
      0.485819,
      0.482353,
      0.684224,
      0.204286,
      0.484219,
      0.486275,
      0.690661,
      0.206384,
      0.482558,
      0.490196,
      0.697098,
      0.208501,
      0.480835,
      0.494118,
      0.703532,
      0.210638,
      0.479049,
      0.498039,
      0.709962,
      0.212797,
      0.477201,
      0.501961,
      0.716387,
      0.214982,
      0.47529,
      0.505882,
      0.722805,
      0.217194,
      0.473316,
      0.509804,
      0.729216,
      0.219437,
      0.471279,
      0.513725,
      0.735616,
      0.221713,
      0.46918,
      0.517647,
      0.742004,
      0.224025,
      0.467018,
      0.521569,
      0.748378,
      0.226377,
      0.464794,
      0.52549,
      0.754737,
      0.228772,
      0.462509,
      0.529412,
      0.761077,
      0.231214,
      0.460162,
      0.533333,
      0.767398,
      0.233705,
      0.457755,
      0.537255,
      0.773695,
      0.236249,
      0.455289,
      0.541176,
      0.779968,
      0.238851,
      0.452765,
      0.545098,
      0.786212,
      0.241514,
      0.450184,
      0.54902,
      0.792427,
      0.244242,
      0.447543,
      0.552941,
      0.798608,
      0.24704,
      0.444848,
      0.556863,
      0.804752,
      0.249911,
      0.442102,
      0.560784,
      0.810855,
      0.252861,
      0.439305,
      0.564706,
      0.816914,
      0.255895,
      0.436461,
      0.568627,
      0.822926,
      0.259016,
      0.433573,
      0.572549,
      0.828886,
      0.262229,
      0.430644,
      0.576471,
      0.834791,
      0.26554,
      0.427671,
      0.580392,
      0.840636,
      0.268953,
      0.424666,
      0.584314,
      0.846416,
      0.272473,
      0.421631,
      0.588235,
      0.852126,
      0.276106,
      0.418573,
      0.592157,
      0.857763,
      0.279857,
      0.415496,
      0.596078,
      0.86332,
      0.283729,
      0.412403,
      0.6,
      0.868793,
      0.287728,
      0.409303,
      0.603922,
      0.874176,
      0.291859,
      0.406205,
      0.607843,
      0.879464,
      0.296125,
      0.403118,
      0.611765,
      0.884651,
      0.30053,
      0.400047,
      0.615686,
      0.889731,
      0.305079,
      0.397002,
      0.619608,
      0.8947,
      0.309773,
      0.393995,
      0.623529,
      0.899552,
      0.314616,
      0.391037,
      0.627451,
      0.904281,
      0.31961,
      0.388137,
      0.631373,
      0.908884,
      0.324755,
      0.385308,
      0.635294,
      0.913354,
      0.330052,
      0.382563,
      0.639216,
      0.917689,
      0.3355,
      0.379915,
      0.643137,
      0.921884,
      0.341098,
      0.377376,
      0.647059,
      0.925937,
      0.346844,
      0.374959,
      0.65098,
      0.929845,
      0.352734,
      0.372677,
      0.654902,
      0.933606,
      0.358764,
      0.370541,
      0.658824,
      0.937221,
      0.364929,
      0.368567,
      0.662745,
      0.940687,
      0.371224,
      0.366762,
      0.666667,
      0.944006,
      0.377643,
      0.365136,
      0.670588,
      0.94718,
      0.384178,
      0.363701,
      0.67451,
      0.95021,
      0.39082,
      0.362468,
      0.678431,
      0.953099,
      0.397563,
      0.361438,
      0.682353,
      0.955849,
      0.4044,
      0.360619,
      0.686275,
      0.958464,
      0.411324,
      0.360014,
      0.690196,
      0.960949,
      0.418323,
      0.35963,
      0.694118,
      0.96331,
      0.42539,
      0.359469,
      0.698039,
      0.965549,
      0.432519,
      0.359529,
      0.701961,
      0.967671,
      0.439703,
      0.35981,
      0.705882,
      0.96968,
      0.446936,
      0.360311,
      0.709804,
      0.971582,
      0.45421,
      0.36103,
      0.713725,
      0.973381,
      0.46152,
      0.361965,
      0.717647,
      0.975082,
      0.468861,
      0.363111,
      0.721569,
      0.97669,
      0.476226,
      0.364466,
      0.72549,
      0.97821,
      0.483612,
      0.366025,
      0.729412,
      0.979645,
      0.491014,
      0.367783,
      0.733333,
      0.981,
      0.498428,
      0.369734,
      0.737255,
      0.982279,
      0.505851,
      0.371874,
      0.741176,
      0.983485,
      0.51328,
      0.374198,
      0.745098,
      0.984622,
      0.520713,
      0.376698,
      0.74902,
      0.985693,
      0.528148,
      0.379371,
      0.752941,
      0.9867,
      0.535582,
      0.38221,
      0.756863,
      0.987646,
      0.543015,
      0.38521,
      0.760784,
      0.988533,
      0.550446,
      0.388365,
      0.764706,
      0.989363,
      0.557873,
      0.391671,
      0.768627,
      0.990138,
      0.565296,
      0.395122,
      0.772549,
      0.990871,
      0.572706,
      0.398714,
      0.776471,
      0.991558,
      0.580107,
      0.402441,
      0.780392,
      0.992196,
      0.587502,
      0.406299,
      0.784314,
      0.992785,
      0.594891,
      0.410283,
      0.788235,
      0.993326,
      0.602275,
      0.41439,
      0.792157,
      0.993834,
      0.609644,
      0.418613,
      0.796078,
      0.994309,
      0.616999,
      0.42295,
      0.8,
      0.994738,
      0.62435,
      0.427397,
      0.803922,
      0.995122,
      0.631696,
      0.431951,
      0.807843,
      0.99548,
      0.639027,
      0.436607,
      0.811765,
      0.99581,
      0.646344,
      0.441361,
      0.815686,
      0.996096,
      0.653659,
      0.446213,
      0.819608,
      0.996341,
      0.660969,
      0.45116,
      0.823529,
      0.99658,
      0.668256,
      0.456192,
      0.827451,
      0.996775,
      0.675541,
      0.461314,
      0.831373,
      0.996925,
      0.682828,
      0.466526,
      0.835294,
      0.997077,
      0.690088,
      0.471811,
      0.839216,
      0.997186,
      0.697349,
      0.477182,
      0.843137,
      0.997254,
      0.704611,
      0.482635,
      0.847059,
      0.997325,
      0.711848,
      0.488154,
      0.85098,
      0.997351,
      0.719089,
      0.493755,
      0.854902,
      0.997351,
      0.726324,
      0.499428,
      0.858824,
      0.997341,
      0.733545,
      0.505167,
      0.862745,
      0.997285,
      0.740772,
      0.510983,
      0.866667,
      0.997228,
      0.747981,
      0.516859,
      0.870588,
      0.997138,
      0.75519,
      0.522806,
      0.87451,
      0.997019,
      0.762398,
      0.528821,
      0.878431,
      0.996898,
      0.769591,
      0.534892,
      0.882353,
      0.996727,
      0.776795,
      0.541039,
      0.886275,
      0.996571,
      0.783977,
      0.547233,
      0.890196,
      0.996369,
      0.791167,
      0.553499,
      0.894118,
      0.996162,
      0.798348,
      0.55982,
      0.898039,
      0.995932,
      0.805527,
      0.566202,
      0.901961,
      0.99568,
      0.812706,
      0.572645,
      0.905882,
      0.995424,
      0.819875,
      0.57914,
      0.909804,
      0.995131,
      0.827052,
      0.585701,
      0.913725,
      0.994851,
      0.834213,
      0.592307,
      0.917647,
      0.994524,
      0.841387,
      0.598983,
      0.921569,
      0.994222,
      0.84854,
      0.605696,
      0.92549,
      0.993866,
      0.855711,
      0.612482,
      0.929412,
      0.993545,
      0.862859,
      0.619299,
      0.933333,
      0.99317,
      0.870024,
      0.626189,
      0.937255,
      0.992831,
      0.877168,
      0.633109,
      0.941176,
      0.99244,
      0.88433,
      0.640099,
      0.945098,
      0.992089,
      0.89147,
      0.647116,
      0.94902,
      0.991688,
      0.898627,
      0.654202,
      0.952941,
      0.991332,
      0.905763,
      0.661309,
      0.956863,
      0.99093,
      0.912915,
      0.668481,
      0.960784,
      0.99057,
      0.920049,
      0.675675,
      0.964706,
      0.990175,
      0.927196,
      0.682926,
      0.968627,
      0.989815,
      0.934329,
      0.690198,
      0.972549,
      0.989434,
      0.94147,
      0.697519,
      0.976471,
      0.989077,
      0.948604,
      0.704863,
      0.980392,
      0.988717,
      0.955742,
      0.712242,
      0.984314,
      0.988367,
      0.962878,
      0.719649,
      0.988235,
      0.988033,
      0.970012,
      0.727077,
      0.992157,
      0.987691,
      0.977154,
      0.734536,
      0.996078,
      0.987387,
      0.984288,
      0.742002,
      1,
      0.987053,
      0.991438,
      0.749504
    ]
  },
  {
    ColorSpace: "Diverging",
    Name: "Inferno (matplotlib)",
    NanColor: [
      0,
      1,
      0
    ],
    Source: "https://github.com/BIDS/colormap/blob/master/colormaps.py",
    License: "CC0",
    Creator: "Nathaniel J. Smith & Stefan van der Walt",
    RGBPoints: [
      0,
      1462e-6,
      466e-6,
      0.013866,
      3922e-6,
      2267e-6,
      127e-5,
      0.01857,
      7843e-6,
      3299e-6,
      2249e-6,
      0.024239,
      0.011765,
      4547e-6,
      3392e-6,
      0.030909,
      0.015686,
      6006e-6,
      4692e-6,
      0.038558,
      0.019608,
      7676e-6,
      6136e-6,
      0.046836,
      0.023529,
      9561e-6,
      7713e-6,
      0.055143,
      0.027451,
      0.011663,
      9417e-6,
      0.06346,
      0.031373,
      0.013995,
      0.011225,
      0.071862,
      0.035294,
      0.016561,
      0.013136,
      0.080282,
      0.039216,
      0.019373,
      0.015133,
      0.088767,
      0.043137,
      0.022447,
      0.017199,
      0.097327,
      0.047059,
      0.025793,
      0.019331,
      0.10593,
      0.05098,
      0.029432,
      0.021503,
      0.114621,
      0.054902,
      0.033385,
      0.023702,
      0.123397,
      0.058824,
      0.037668,
      0.025921,
      0.132232,
      0.062745,
      0.042253,
      0.028139,
      0.141141,
      0.066667,
      0.046915,
      0.030324,
      0.150164,
      0.070588,
      0.051644,
      0.032474,
      0.159254,
      0.07451,
      0.056449,
      0.034569,
      0.168414,
      0.078431,
      0.06134,
      0.03659,
      0.177642,
      0.082353,
      0.066331,
      0.038504,
      0.186962,
      0.086275,
      0.071429,
      0.040294,
      0.196354,
      0.090196,
      0.076637,
      0.041905,
      0.205799,
      0.094118,
      0.081962,
      0.043328,
      0.215289,
      0.098039,
      0.087411,
      0.044556,
      0.224813,
      0.101961,
      0.09299,
      0.045583,
      0.234358,
      0.105882,
      0.098702,
      0.046402,
      0.243904,
      0.109804,
      0.104551,
      0.047008,
      0.25343,
      0.113725,
      0.110536,
      0.047399,
      0.262912,
      0.117647,
      0.116656,
      0.047574,
      0.272321,
      0.121569,
      0.122908,
      0.047536,
      0.281624,
      0.12549,
      0.129285,
      0.047293,
      0.290788,
      0.129412,
      0.135778,
      0.046856,
      0.299776,
      0.133333,
      0.142378,
      0.046242,
      0.308553,
      0.137255,
      0.149073,
      0.045468,
      0.317085,
      0.141176,
      0.15585,
      0.044559,
      0.325338,
      0.145098,
      0.162689,
      0.043554,
      0.333277,
      0.14902,
      0.169575,
      0.042489,
      0.340874,
      0.152941,
      0.176493,
      0.041402,
      0.348111,
      0.156863,
      0.183429,
      0.040329,
      0.354971,
      0.160784,
      0.190367,
      0.039309,
      0.361447,
      0.164706,
      0.197297,
      0.0384,
      0.367535,
      0.168627,
      0.204209,
      0.037632,
      0.373238,
      0.172549,
      0.211095,
      0.03703,
      0.378563,
      0.176471,
      0.217949,
      0.036615,
      0.383522,
      0.180392,
      0.224763,
      0.036405,
      0.388129,
      0.184314,
      0.231538,
      0.036405,
      0.3924,
      0.188235,
      0.238273,
      0.036621,
      0.396353,
      0.192157,
      0.244967,
      0.037055,
      0.400007,
      0.196078,
      0.25162,
      0.037705,
      0.403378,
      0.2,
      0.258234,
      0.038571,
      0.406485,
      0.203922,
      0.26481,
      0.039647,
      0.409345,
      0.207843,
      0.271347,
      0.040922,
      0.411976,
      0.211765,
      0.27785,
      0.042353,
      0.414392,
      0.215686,
      0.284321,
      0.043933,
      0.416608,
      0.219608,
      0.290763,
      0.045644,
      0.418637,
      0.223529,
      0.297178,
      0.04747,
      0.420491,
      0.227451,
      0.303568,
      0.049396,
      0.422182,
      0.231373,
      0.309935,
      0.051407,
      0.423721,
      0.235294,
      0.316282,
      0.05349,
      0.425116,
      0.239216,
      0.32261,
      0.055634,
      0.426377,
      0.243137,
      0.328921,
      0.057827,
      0.427511,
      0.247059,
      0.335217,
      0.06006,
      0.428524,
      0.25098,
      0.3415,
      0.062325,
      0.429425,
      0.254902,
      0.347771,
      0.064616,
      0.430217,
      0.258824,
      0.354032,
      0.066925,
      0.430906,
      0.262745,
      0.360284,
      0.069247,
      0.431497,
      0.266667,
      0.366529,
      0.071579,
      0.431994,
      0.270588,
      0.372768,
      0.073915,
      0.4324,
      0.27451,
      0.379001,
      0.076253,
      0.432719,
      0.278431,
      0.385228,
      0.078591,
      0.432955,
      0.282353,
      0.391453,
      0.080927,
      0.433109,
      0.286275,
      0.397674,
      0.083257,
      0.433183,
      0.290196,
      0.403894,
      0.08558,
      0.433179,
      0.294118,
      0.410113,
      0.087896,
      0.433098,
      0.298039,
      0.416331,
      0.090203,
      0.432943,
      0.301961,
      0.422549,
      0.092501,
      0.432714,
      0.305882,
      0.428768,
      0.09479,
      0.432412,
      0.309804,
      0.434987,
      0.097069,
      0.432039,
      0.313725,
      0.441207,
      0.099338,
      0.431594,
      0.317647,
      0.447428,
      0.101597,
      0.43108,
      0.321569,
      0.453651,
      0.103848,
      0.430498,
      0.32549,
      0.459875,
      0.106089,
      0.429846,
      0.329412,
      0.4661,
      0.108322,
      0.429125,
      0.333333,
      0.472328,
      0.110547,
      0.428334,
      0.337255,
      0.478558,
      0.112764,
      0.427475,
      0.341176,
      0.484789,
      0.114974,
      0.426548,
      0.345098,
      0.491022,
      0.117179,
      0.425552,
      0.34902,
      0.497257,
      0.119379,
      0.424488,
      0.352941,
      0.503493,
      0.121575,
      0.423356,
      0.356863,
      0.50973,
      0.123769,
      0.422156,
      0.360784,
      0.515967,
      0.12596,
      0.420887,
      0.364706,
      0.522206,
      0.12815,
      0.419549,
      0.368627,
      0.528444,
      0.130341,
      0.418142,
      0.372549,
      0.534683,
      0.132534,
      0.416667,
      0.376471,
      0.54092,
      0.134729,
      0.415123,
      0.380392,
      0.547157,
      0.136929,
      0.413511,
      0.384314,
      0.553392,
      0.139134,
      0.411829,
      0.388235,
      0.559624,
      0.141346,
      0.410078,
      0.392157,
      0.565854,
      0.143567,
      0.408258,
      0.396078,
      0.572081,
      0.145797,
      0.406369,
      0.4,
      0.578304,
      0.148039,
      0.404411,
      0.403922,
      0.584521,
      0.150294,
      0.402385,
      0.407843,
      0.590734,
      0.152563,
      0.40029,
      0.411765,
      0.59694,
      0.154848,
      0.398125,
      0.415686,
      0.603139,
      0.157151,
      0.395891,
      0.419608,
      0.60933,
      0.159474,
      0.393589,
      0.423529,
      0.615513,
      0.161817,
      0.391219,
      0.427451,
      0.621685,
      0.164184,
      0.388781,
      0.431373,
      0.627847,
      0.166575,
      0.386276,
      0.435294,
      0.633998,
      0.168992,
      0.383704,
      0.439216,
      0.640135,
      0.171438,
      0.381065,
      0.443137,
      0.64626,
      0.173914,
      0.378359,
      0.447059,
      0.652369,
      0.176421,
      0.375586,
      0.45098,
      0.658463,
      0.178962,
      0.372748,
      0.454902,
      0.66454,
      0.181539,
      0.369846,
      0.458824,
      0.670599,
      0.184153,
      0.366879,
      0.462745,
      0.676638,
      0.186807,
      0.363849,
      0.466667,
      0.682656,
      0.189501,
      0.360757,
      0.470588,
      0.688653,
      0.192239,
      0.357603,
      0.47451,
      0.694627,
      0.195021,
      0.354388,
      0.478431,
      0.700576,
      0.197851,
      0.351113,
      0.482353,
      0.7065,
      0.200728,
      0.347777,
      0.486275,
      0.712396,
      0.203656,
      0.344383,
      0.490196,
      0.718264,
      0.206636,
      0.340931,
      0.494118,
      0.724103,
      0.20967,
      0.337424,
      0.498039,
      0.729909,
      0.212759,
      0.333861,
      0.501961,
      0.735683,
      0.215906,
      0.330245,
      0.505882,
      0.741423,
      0.219112,
      0.326576,
      0.509804,
      0.747127,
      0.222378,
      0.322856,
      0.513725,
      0.752794,
      0.225706,
      0.319085,
      0.517647,
      0.758422,
      0.229097,
      0.315266,
      0.521569,
      0.76401,
      0.232554,
      0.311399,
      0.52549,
      0.769556,
      0.236077,
      0.307485,
      0.529412,
      0.775059,
      0.239667,
      0.303526,
      0.533333,
      0.780517,
      0.243327,
      0.299523,
      0.537255,
      0.785929,
      0.247056,
      0.295477,
      0.541176,
      0.791293,
      0.250856,
      0.29139,
      0.545098,
      0.796607,
      0.254728,
      0.287264,
      0.54902,
      0.801871,
      0.258674,
      0.283099,
      0.552941,
      0.807082,
      0.262692,
      0.278898,
      0.556863,
      0.812239,
      0.266786,
      0.274661,
      0.560784,
      0.817341,
      0.270954,
      0.27039,
      0.564706,
      0.822386,
      0.275197,
      0.266085,
      0.568627,
      0.827372,
      0.279517,
      0.26175,
      0.572549,
      0.832299,
      0.283913,
      0.257383,
      0.576471,
      0.837165,
      0.288385,
      0.252988,
      0.580392,
      0.841969,
      0.292933,
      0.248564,
      0.584314,
      0.846709,
      0.297559,
      0.244113,
      0.588235,
      0.851384,
      0.30226,
      0.239636,
      0.592157,
      0.855992,
      0.307038,
      0.235133,
      0.596078,
      0.860533,
      0.311892,
      0.230606,
      0.6,
      0.865006,
      0.316822,
      0.226055,
      0.603922,
      0.869409,
      0.321827,
      0.221482,
      0.607843,
      0.873741,
      0.326906,
      0.216886,
      0.611765,
      0.878001,
      0.33206,
      0.212268,
      0.615686,
      0.882188,
      0.337287,
      0.207628,
      0.619608,
      0.886302,
      0.342586,
      0.202968,
      0.623529,
      0.890341,
      0.347957,
      0.198286,
      0.627451,
      0.894305,
      0.353399,
      0.193584,
      0.631373,
      0.898192,
      0.358911,
      0.18886,
      0.635294,
      0.902003,
      0.364492,
      0.184116,
      0.639216,
      0.905735,
      0.37014,
      0.17935,
      0.643137,
      0.90939,
      0.375856,
      0.174563,
      0.647059,
      0.912966,
      0.381636,
      0.169755,
      0.65098,
      0.916462,
      0.387481,
      0.164924,
      0.654902,
      0.919879,
      0.393389,
      0.16007,
      0.658824,
      0.923215,
      0.399359,
      0.155193,
      0.662745,
      0.92647,
      0.405389,
      0.150292,
      0.666667,
      0.929644,
      0.411479,
      0.145367,
      0.670588,
      0.932737,
      0.417627,
      0.140417,
      0.67451,
      0.935747,
      0.423831,
      0.13544,
      0.678431,
      0.938675,
      0.430091,
      0.130438,
      0.682353,
      0.941521,
      0.436405,
      0.125409,
      0.686275,
      0.944285,
      0.442772,
      0.120354,
      0.690196,
      0.946965,
      0.449191,
      0.115272,
      0.694118,
      0.949562,
      0.45566,
      0.110164,
      0.698039,
      0.952075,
      0.462178,
      0.105031,
      0.701961,
      0.954506,
      0.468744,
      0.099874,
      0.705882,
      0.956852,
      0.475356,
      0.094695,
      0.709804,
      0.959114,
      0.482014,
      0.089499,
      0.713725,
      0.961293,
      0.488716,
      0.084289,
      0.717647,
      0.963387,
      0.495462,
      0.079073,
      0.721569,
      0.965397,
      0.502249,
      0.073859,
      0.72549,
      0.967322,
      0.509078,
      0.068659,
      0.729412,
      0.969163,
      0.515946,
      0.063488,
      0.733333,
      0.970919,
      0.522853,
      0.058367,
      0.737255,
      0.97259,
      0.529798,
      0.053324,
      0.741176,
      0.974176,
      0.53678,
      0.048392,
      0.745098,
      0.975677,
      0.543798,
      0.043618,
      0.74902,
      0.977092,
      0.55085,
      0.03905,
      0.752941,
      0.978422,
      0.557937,
      0.034931,
      0.756863,
      0.979666,
      0.565057,
      0.031409,
      0.760784,
      0.980824,
      0.572209,
      0.028508,
      0.764706,
      0.981895,
      0.579392,
      0.02625,
      0.768627,
      0.982881,
      0.586606,
      0.024661,
      0.772549,
      0.983779,
      0.593849,
      0.02377,
      0.776471,
      0.984591,
      0.601122,
      0.023606,
      0.780392,
      0.985315,
      0.608422,
      0.024202,
      0.784314,
      0.985952,
      0.61575,
      0.025592,
      0.788235,
      0.986502,
      0.623105,
      0.027814,
      0.792157,
      0.986964,
      0.630485,
      0.030908,
      0.796078,
      0.987337,
      0.63789,
      0.034916,
      0.8,
      0.987622,
      0.64532,
      0.039886,
      0.803922,
      0.987819,
      0.652773,
      0.045581,
      0.807843,
      0.987926,
      0.66025,
      0.05175,
      0.811765,
      0.987945,
      0.667748,
      0.058329,
      0.815686,
      0.987874,
      0.675267,
      0.065257,
      0.819608,
      0.987714,
      0.682807,
      0.072489,
      0.823529,
      0.987464,
      0.690366,
      0.07999,
      0.827451,
      0.987124,
      0.697944,
      0.087731,
      0.831373,
      0.986694,
      0.70554,
      0.095694,
      0.835294,
      0.986175,
      0.713153,
      0.103863,
      0.839216,
      0.985566,
      0.720782,
      0.112229,
      0.843137,
      0.984865,
      0.728427,
      0.120785,
      0.847059,
      0.984075,
      0.736087,
      0.129527,
      0.85098,
      0.983196,
      0.743758,
      0.138453,
      0.854902,
      0.982228,
      0.751442,
      0.147565,
      0.858824,
      0.981173,
      0.759135,
      0.156863,
      0.862745,
      0.980032,
      0.766837,
      0.166353,
      0.866667,
      0.978806,
      0.774545,
      0.176037,
      0.870588,
      0.977497,
      0.782258,
      0.185923,
      0.87451,
      0.976108,
      0.789974,
      0.196018,
      0.878431,
      0.974638,
      0.797692,
      0.206332,
      0.882353,
      0.973088,
      0.805409,
      0.216877,
      0.886275,
      0.971468,
      0.813122,
      0.227658,
      0.890196,
      0.969783,
      0.820825,
      0.238686,
      0.894118,
      0.968041,
      0.828515,
      0.249972,
      0.898039,
      0.966243,
      0.836191,
      0.261534,
      0.901961,
      0.964394,
      0.843848,
      0.273391,
      0.905882,
      0.962517,
      0.851476,
      0.285546,
      0.909804,
      0.960626,
      0.859069,
      0.29801,
      0.913725,
      0.95872,
      0.866624,
      0.31082,
      0.917647,
      0.956834,
      0.874129,
      0.323974,
      0.921569,
      0.954997,
      0.881569,
      0.337475,
      0.92549,
      0.953215,
      0.888942,
      0.351369,
      0.929412,
      0.951546,
      0.896226,
      0.365627,
      0.933333,
      0.950018,
      0.903409,
      0.380271,
      0.937255,
      0.948683,
      0.910473,
      0.395289,
      0.941176,
      0.947594,
      0.917399,
      0.410665,
      0.945098,
      0.946809,
      0.924168,
      0.426373,
      0.94902,
      0.946392,
      0.930761,
      0.442367,
      0.952941,
      0.946403,
      0.937159,
      0.458592,
      0.956863,
      0.946903,
      0.943348,
      0.47497,
      0.960784,
      0.947937,
      0.949318,
      0.491426,
      0.964706,
      0.949545,
      0.955063,
      0.50786,
      0.968627,
      0.95174,
      0.960587,
      0.524203,
      0.972549,
      0.954529,
      0.965896,
      0.540361,
      0.976471,
      0.957896,
      0.971003,
      0.556275,
      0.980392,
      0.961812,
      0.975924,
      0.571925,
      0.984314,
      0.966249,
      0.980678,
      0.587206,
      0.988235,
      0.971162,
      0.985282,
      0.602154,
      0.992157,
      0.976511,
      0.989753,
      0.61676,
      0.996078,
      0.982257,
      0.994109,
      0.631017,
      1,
      0.988362,
      0.998364,
      0.644924
    ]
  },
  {
    ColorSpace: "Diverging",
    Name: "Plasma (matplotlib)",
    NanColor: [
      0,
      1,
      0
    ],
    Source: "https://github.com/BIDS/colormap/blob/master/colormaps.py",
    License: "CC0",
    Creator: "Nathaniel J. Smith & Stefan van der Walt",
    RGBPoints: [
      0,
      0.050383,
      0.029803,
      0.527975,
      3922e-6,
      0.063536,
      0.028426,
      0.533124,
      7843e-6,
      0.075353,
      0.027206,
      0.538007,
      0.011765,
      0.086222,
      0.026125,
      0.542658,
      0.015686,
      0.096379,
      0.025165,
      0.547103,
      0.019608,
      0.10598,
      0.024309,
      0.551368,
      0.023529,
      0.115124,
      0.023556,
      0.555468,
      0.027451,
      0.123903,
      0.022878,
      0.559423,
      0.031373,
      0.132381,
      0.022258,
      0.56325,
      0.035294,
      0.140603,
      0.021687,
      0.566959,
      0.039216,
      0.148607,
      0.021154,
      0.570562,
      0.043137,
      0.156421,
      0.020651,
      0.574065,
      0.047059,
      0.16407,
      0.020171,
      0.577478,
      0.05098,
      0.171574,
      0.019706,
      0.580806,
      0.054902,
      0.17895,
      0.019252,
      0.584054,
      0.058824,
      0.186213,
      0.018803,
      0.587228,
      0.062745,
      0.193374,
      0.018354,
      0.59033,
      0.066667,
      0.200445,
      0.017902,
      0.593364,
      0.070588,
      0.207435,
      0.017442,
      0.596333,
      0.07451,
      0.21435,
      0.016973,
      0.599239,
      0.078431,
      0.221197,
      0.016497,
      0.602083,
      0.082353,
      0.227983,
      0.016007,
      0.604867,
      0.086275,
      0.234715,
      0.015502,
      0.607592,
      0.090196,
      0.241396,
      0.014979,
      0.610259,
      0.094118,
      0.248032,
      0.014439,
      0.612868,
      0.098039,
      0.254627,
      0.013882,
      0.615419,
      0.101961,
      0.261183,
      0.013308,
      0.617911,
      0.105882,
      0.267703,
      0.012716,
      0.620346,
      0.109804,
      0.274191,
      0.012109,
      0.622722,
      0.113725,
      0.280648,
      0.011488,
      0.625038,
      0.117647,
      0.287076,
      0.010855,
      0.627295,
      0.121569,
      0.293478,
      0.010213,
      0.62949,
      0.12549,
      0.299855,
      9561e-6,
      0.631624,
      0.129412,
      0.30621,
      8902e-6,
      0.633694,
      0.133333,
      0.312543,
      8239e-6,
      0.6357,
      0.137255,
      0.318856,
      7576e-6,
      0.63764,
      0.141176,
      0.32515,
      6915e-6,
      0.639512,
      0.145098,
      0.331426,
      6261e-6,
      0.641316,
      0.14902,
      0.337683,
      5618e-6,
      0.643049,
      0.152941,
      0.343925,
      4991e-6,
      0.64471,
      0.156863,
      0.35015,
      4382e-6,
      0.646298,
      0.160784,
      0.356359,
      3798e-6,
      0.64781,
      0.164706,
      0.362553,
      3243e-6,
      0.649245,
      0.168627,
      0.368733,
      2724e-6,
      0.650601,
      0.172549,
      0.374897,
      2245e-6,
      0.651876,
      0.176471,
      0.381047,
      1814e-6,
      0.653068,
      0.180392,
      0.387183,
      1434e-6,
      0.654177,
      0.184314,
      0.393304,
      1114e-6,
      0.655199,
      0.188235,
      0.399411,
      859e-6,
      0.656133,
      0.192157,
      0.405503,
      678e-6,
      0.656977,
      0.196078,
      0.41158,
      577e-6,
      0.65773,
      0.2,
      0.417642,
      564e-6,
      0.65839,
      0.203922,
      0.423689,
      646e-6,
      0.658956,
      0.207843,
      0.429719,
      831e-6,
      0.659425,
      0.211765,
      0.435734,
      1127e-6,
      0.659797,
      0.215686,
      0.441732,
      154e-5,
      0.660069,
      0.219608,
      0.447714,
      208e-5,
      0.66024,
      0.223529,
      0.453677,
      2755e-6,
      0.66031,
      0.227451,
      0.459623,
      3574e-6,
      0.660277,
      0.231373,
      0.46555,
      4545e-6,
      0.660139,
      0.235294,
      0.471457,
      5678e-6,
      0.659897,
      0.239216,
      0.477344,
      698e-5,
      0.659549,
      0.243137,
      0.48321,
      846e-5,
      0.659095,
      0.247059,
      0.489055,
      0.010127,
      0.658534,
      0.25098,
      0.494877,
      0.01199,
      0.657865,
      0.254902,
      0.500678,
      0.014055,
      0.657088,
      0.258824,
      0.506454,
      0.016333,
      0.656202,
      0.262745,
      0.512206,
      0.018833,
      0.655209,
      0.266667,
      0.517933,
      0.021563,
      0.654109,
      0.270588,
      0.523633,
      0.024532,
      0.652901,
      0.27451,
      0.529306,
      0.027747,
      0.651586,
      0.278431,
      0.534952,
      0.031217,
      0.650165,
      0.282353,
      0.54057,
      0.03495,
      0.64864,
      0.286275,
      0.546157,
      0.038954,
      0.64701,
      0.290196,
      0.551715,
      0.043136,
      0.645277,
      0.294118,
      0.557243,
      0.047331,
      0.643443,
      0.298039,
      0.562738,
      0.051545,
      0.641509,
      0.301961,
      0.568201,
      0.055778,
      0.639477,
      0.305882,
      0.573632,
      0.060028,
      0.637349,
      0.309804,
      0.579029,
      0.064296,
      0.635126,
      0.313725,
      0.584391,
      0.068579,
      0.632812,
      0.317647,
      0.589719,
      0.072878,
      0.630408,
      0.321569,
      0.595011,
      0.07719,
      0.627917,
      0.32549,
      0.600266,
      0.081516,
      0.625342,
      0.329412,
      0.605485,
      0.085854,
      0.622686,
      0.333333,
      0.610667,
      0.090204,
      0.619951,
      0.337255,
      0.615812,
      0.094564,
      0.61714,
      0.341176,
      0.620919,
      0.098934,
      0.614257,
      0.345098,
      0.625987,
      0.103312,
      0.611305,
      0.34902,
      0.631017,
      0.107699,
      0.608287,
      0.352941,
      0.636008,
      0.112092,
      0.605205,
      0.356863,
      0.640959,
      0.116492,
      0.602065,
      0.360784,
      0.645872,
      0.120898,
      0.598867,
      0.364706,
      0.650746,
      0.125309,
      0.595617,
      0.368627,
      0.65558,
      0.129725,
      0.592317,
      0.372549,
      0.660374,
      0.134144,
      0.588971,
      0.376471,
      0.665129,
      0.138566,
      0.585582,
      0.380392,
      0.669845,
      0.142992,
      0.582154,
      0.384314,
      0.674522,
      0.147419,
      0.578688,
      0.388235,
      0.67916,
      0.151848,
      0.575189,
      0.392157,
      0.683758,
      0.156278,
      0.57166,
      0.396078,
      0.688318,
      0.160709,
      0.568103,
      0.4,
      0.69284,
      0.165141,
      0.564522,
      0.403922,
      0.697324,
      0.169573,
      0.560919,
      0.407843,
      0.701769,
      0.174005,
      0.557296,
      0.411765,
      0.706178,
      0.178437,
      0.553657,
      0.415686,
      0.710549,
      0.182868,
      0.550004,
      0.419608,
      0.714883,
      0.187299,
      0.546338,
      0.423529,
      0.719181,
      0.191729,
      0.542663,
      0.427451,
      0.723444,
      0.196158,
      0.538981,
      0.431373,
      0.72767,
      0.200586,
      0.535293,
      0.435294,
      0.731862,
      0.205013,
      0.531601,
      0.439216,
      0.736019,
      0.209439,
      0.527908,
      0.443137,
      0.740143,
      0.213864,
      0.524216,
      0.447059,
      0.744232,
      0.218288,
      0.520524,
      0.45098,
      0.748289,
      0.222711,
      0.516834,
      0.454902,
      0.752312,
      0.227133,
      0.513149,
      0.458824,
      0.756304,
      0.231555,
      0.509468,
      0.462745,
      0.760264,
      0.235976,
      0.505794,
      0.466667,
      0.764193,
      0.240396,
      0.502126,
      0.470588,
      0.76809,
      0.244817,
      0.498465,
      0.47451,
      0.771958,
      0.249237,
      0.494813,
      0.478431,
      0.775796,
      0.253658,
      0.491171,
      0.482353,
      0.779604,
      0.258078,
      0.487539,
      0.486275,
      0.783383,
      0.2625,
      0.483918,
      0.490196,
      0.787133,
      0.266922,
      0.480307,
      0.494118,
      0.790855,
      0.271345,
      0.476706,
      0.498039,
      0.794549,
      0.27577,
      0.473117,
      0.501961,
      0.798216,
      0.280197,
      0.469538,
      0.505882,
      0.801855,
      0.284626,
      0.465971,
      0.509804,
      0.805467,
      0.289057,
      0.462415,
      0.513725,
      0.809052,
      0.293491,
      0.45887,
      0.517647,
      0.812612,
      0.297928,
      0.455338,
      0.521569,
      0.816144,
      0.302368,
      0.451816,
      0.52549,
      0.819651,
      0.306812,
      0.448306,
      0.529412,
      0.823132,
      0.311261,
      0.444806,
      0.533333,
      0.826588,
      0.315714,
      0.441316,
      0.537255,
      0.830018,
      0.320172,
      0.437836,
      0.541176,
      0.833422,
      0.324635,
      0.434366,
      0.545098,
      0.836801,
      0.329105,
      0.430905,
      0.54902,
      0.840155,
      0.33358,
      0.427455,
      0.552941,
      0.843484,
      0.338062,
      0.424013,
      0.556863,
      0.846788,
      0.342551,
      0.420579,
      0.560784,
      0.850066,
      0.347048,
      0.417153,
      0.564706,
      0.853319,
      0.351553,
      0.413734,
      0.568627,
      0.856547,
      0.356066,
      0.410322,
      0.572549,
      0.85975,
      0.360588,
      0.406917,
      0.576471,
      0.862927,
      0.365119,
      0.403519,
      0.580392,
      0.866078,
      0.36966,
      0.400126,
      0.584314,
      0.869203,
      0.374212,
      0.396738,
      0.588235,
      0.872303,
      0.378774,
      0.393355,
      0.592157,
      0.875376,
      0.383347,
      0.389976,
      0.596078,
      0.878423,
      0.387932,
      0.3866,
      0.6,
      0.881443,
      0.392529,
      0.383229,
      0.603922,
      0.884436,
      0.397139,
      0.37986,
      0.607843,
      0.887402,
      0.401762,
      0.376494,
      0.611765,
      0.89034,
      0.406398,
      0.37313,
      0.615686,
      0.89325,
      0.411048,
      0.369768,
      0.619608,
      0.896131,
      0.415712,
      0.366407,
      0.623529,
      0.898984,
      0.420392,
      0.363047,
      0.627451,
      0.901807,
      0.425087,
      0.359688,
      0.631373,
      0.904601,
      0.429797,
      0.356329,
      0.635294,
      0.907365,
      0.434524,
      0.35297,
      0.639216,
      0.910098,
      0.439268,
      0.34961,
      0.643137,
      0.9128,
      0.444029,
      0.346251,
      0.647059,
      0.915471,
      0.448807,
      0.34289,
      0.65098,
      0.918109,
      0.453603,
      0.339529,
      0.654902,
      0.920714,
      0.458417,
      0.336166,
      0.658824,
      0.923287,
      0.463251,
      0.332801,
      0.662745,
      0.925825,
      0.468103,
      0.329435,
      0.666667,
      0.928329,
      0.472975,
      0.326067,
      0.670588,
      0.930798,
      0.477867,
      0.322697,
      0.67451,
      0.933232,
      0.48278,
      0.319325,
      0.678431,
      0.93563,
      0.487712,
      0.315952,
      0.682353,
      0.93799,
      0.492667,
      0.312575,
      0.686275,
      0.940313,
      0.497642,
      0.309197,
      0.690196,
      0.942598,
      0.502639,
      0.305816,
      0.694118,
      0.944844,
      0.507658,
      0.302433,
      0.698039,
      0.947051,
      0.512699,
      0.299049,
      0.701961,
      0.949217,
      0.517763,
      0.295662,
      0.705882,
      0.951344,
      0.52285,
      0.292275,
      0.709804,
      0.953428,
      0.52796,
      0.288883,
      0.713725,
      0.95547,
      0.533093,
      0.28549,
      0.717647,
      0.957469,
      0.53825,
      0.282096,
      0.721569,
      0.959424,
      0.543431,
      0.278701,
      0.72549,
      0.961336,
      0.548636,
      0.275305,
      0.729412,
      0.963203,
      0.553865,
      0.271909,
      0.733333,
      0.965024,
      0.559118,
      0.268513,
      0.737255,
      0.966798,
      0.564396,
      0.265118,
      0.741176,
      0.968526,
      0.5697,
      0.261721,
      0.745098,
      0.970205,
      0.575028,
      0.258325,
      0.74902,
      0.971835,
      0.580382,
      0.254931,
      0.752941,
      0.973416,
      0.585761,
      0.25154,
      0.756863,
      0.974947,
      0.591165,
      0.248151,
      0.760784,
      0.976428,
      0.596595,
      0.244767,
      0.764706,
      0.977856,
      0.602051,
      0.241387,
      0.768627,
      0.979233,
      0.607532,
      0.238013,
      0.772549,
      0.980556,
      0.613039,
      0.234646,
      0.776471,
      0.981826,
      0.618572,
      0.231287,
      0.780392,
      0.983041,
      0.624131,
      0.227937,
      0.784314,
      0.984199,
      0.629718,
      0.224595,
      0.788235,
      0.985301,
      0.63533,
      0.221265,
      0.792157,
      0.986345,
      0.640969,
      0.217948,
      0.796078,
      0.987332,
      0.646633,
      0.214648,
      0.8,
      0.98826,
      0.652325,
      0.211364,
      0.803922,
      0.989128,
      0.658043,
      0.2081,
      0.807843,
      0.989935,
      0.663787,
      0.204859,
      0.811765,
      0.990681,
      0.669558,
      0.201642,
      0.815686,
      0.991365,
      0.675355,
      0.198453,
      0.819608,
      0.991985,
      0.681179,
      0.195295,
      0.823529,
      0.992541,
      0.68703,
      0.19217,
      0.827451,
      0.993032,
      0.692907,
      0.189084,
      0.831373,
      0.993456,
      0.69881,
      0.186041,
      0.835294,
      0.993814,
      0.704741,
      0.183043,
      0.839216,
      0.994103,
      0.710698,
      0.180097,
      0.843137,
      0.994324,
      0.716681,
      0.177208,
      0.847059,
      0.994474,
      0.722691,
      0.174381,
      0.85098,
      0.994553,
      0.728728,
      0.171622,
      0.854902,
      0.994561,
      0.734791,
      0.168938,
      0.858824,
      0.994495,
      0.74088,
      0.166335,
      0.862745,
      0.994355,
      0.746995,
      0.163821,
      0.866667,
      0.994141,
      0.753137,
      0.161404,
      0.870588,
      0.993851,
      0.759304,
      0.159092,
      0.87451,
      0.993482,
      0.765499,
      0.156891,
      0.878431,
      0.993033,
      0.77172,
      0.154808,
      0.882353,
      0.992505,
      0.777967,
      0.152855,
      0.886275,
      0.991897,
      0.784239,
      0.151042,
      0.890196,
      0.991209,
      0.790537,
      0.149377,
      0.894118,
      0.990439,
      0.796859,
      0.14787,
      0.898039,
      0.989587,
      0.803205,
      0.146529,
      0.901961,
      0.988648,
      0.809579,
      0.145357,
      0.905882,
      0.987621,
      0.815978,
      0.144363,
      0.909804,
      0.986509,
      0.822401,
      0.143557,
      0.913725,
      0.985314,
      0.828846,
      0.142945,
      0.917647,
      0.984031,
      0.835315,
      0.142528,
      0.921569,
      0.982653,
      0.841812,
      0.142303,
      0.92549,
      0.98119,
      0.848329,
      0.142279,
      0.929412,
      0.979644,
      0.854866,
      0.142453,
      0.933333,
      0.977995,
      0.861432,
      0.142808,
      0.937255,
      0.976265,
      0.868016,
      0.143351,
      0.941176,
      0.974443,
      0.874622,
      0.144061,
      0.945098,
      0.97253,
      0.88125,
      0.144923,
      0.94902,
      0.970533,
      0.887896,
      0.145919,
      0.952941,
      0.968443,
      0.894564,
      0.147014,
      0.956863,
      0.966271,
      0.901249,
      0.14818,
      0.960784,
      0.964021,
      0.90795,
      0.14937,
      0.964706,
      0.961681,
      0.914672,
      0.15052,
      0.968627,
      0.959276,
      0.921407,
      0.151566,
      0.972549,
      0.956808,
      0.928152,
      0.152409,
      0.976471,
      0.954287,
      0.934908,
      0.152921,
      0.980392,
      0.951726,
      0.941671,
      0.152925,
      0.984314,
      0.949151,
      0.948435,
      0.152178,
      0.988235,
      0.946602,
      0.95519,
      0.150328,
      0.992157,
      0.944152,
      0.961916,
      0.146861,
      0.996078,
      0.941896,
      0.96859,
      0.140956,
      1,
      0.940015,
      0.975158,
      0.131326
    ]
  },
  {
    ColorSpace: "Diverging",
    Name: "Viridis (matplotlib)",
    NanColor: [
      1,
      0,
      0
    ],
    Source: "https://github.com/BIDS/colormap/blob/master/colormaps.py",
    License: "CC0",
    Creator: "Eric Firing",
    RGBPoints: [
      0,
      0.267004,
      4874e-6,
      0.329415,
      3922e-6,
      0.26851,
      9605e-6,
      0.335427,
      7843e-6,
      0.269944,
      0.014625,
      0.341379,
      0.011765,
      0.271305,
      0.019942,
      0.347269,
      0.015686,
      0.272594,
      0.025563,
      0.353093,
      0.019608,
      0.273809,
      0.031497,
      0.358853,
      0.023529,
      0.274952,
      0.037752,
      0.364543,
      0.027451,
      0.276022,
      0.044167,
      0.370164,
      0.031373,
      0.277018,
      0.050344,
      0.375715,
      0.035294,
      0.277941,
      0.056324,
      0.381191,
      0.039216,
      0.278791,
      0.062145,
      0.386592,
      0.043137,
      0.279566,
      0.067836,
      0.391917,
      0.047059,
      0.280267,
      0.073417,
      0.397163,
      0.05098,
      0.280894,
      0.078907,
      0.402329,
      0.054902,
      0.281446,
      0.08432,
      0.407414,
      0.058824,
      0.281924,
      0.089666,
      0.412415,
      0.062745,
      0.282327,
      0.094955,
      0.417331,
      0.066667,
      0.282656,
      0.100196,
      0.42216,
      0.070588,
      0.28291,
      0.105393,
      0.426902,
      0.07451,
      0.283091,
      0.110553,
      0.431554,
      0.078431,
      0.283197,
      0.11568,
      0.436115,
      0.082353,
      0.283229,
      0.120777,
      0.440584,
      0.086275,
      0.283187,
      0.125848,
      0.44496,
      0.090196,
      0.283072,
      0.130895,
      0.449241,
      0.094118,
      0.282884,
      0.13592,
      0.453427,
      0.098039,
      0.282623,
      0.140926,
      0.457517,
      0.101961,
      0.28229,
      0.145912,
      0.46151,
      0.105882,
      0.281887,
      0.150881,
      0.465405,
      0.109804,
      0.281412,
      0.155834,
      0.469201,
      0.113725,
      0.280868,
      0.160771,
      0.472899,
      0.117647,
      0.280255,
      0.165693,
      0.476498,
      0.121569,
      0.279574,
      0.170599,
      0.479997,
      0.12549,
      0.278826,
      0.17549,
      0.483397,
      0.129412,
      0.278012,
      0.180367,
      0.486697,
      0.133333,
      0.277134,
      0.185228,
      0.489898,
      0.137255,
      0.276194,
      0.190074,
      0.493001,
      0.141176,
      0.275191,
      0.194905,
      0.496005,
      0.145098,
      0.274128,
      0.199721,
      0.498911,
      0.14902,
      0.273006,
      0.20452,
      0.501721,
      0.152941,
      0.271828,
      0.209303,
      0.504434,
      0.156863,
      0.270595,
      0.214069,
      0.507052,
      0.160784,
      0.269308,
      0.218818,
      0.509577,
      0.164706,
      0.267968,
      0.223549,
      0.512008,
      0.168627,
      0.26658,
      0.228262,
      0.514349,
      0.172549,
      0.265145,
      0.232956,
      0.516599,
      0.176471,
      0.263663,
      0.237631,
      0.518762,
      0.180392,
      0.262138,
      0.242286,
      0.520837,
      0.184314,
      0.260571,
      0.246922,
      0.522828,
      0.188235,
      0.258965,
      0.251537,
      0.524736,
      0.192157,
      0.257322,
      0.25613,
      0.526563,
      0.196078,
      0.255645,
      0.260703,
      0.528312,
      0.2,
      0.253935,
      0.265254,
      0.529983,
      0.203922,
      0.252194,
      0.269783,
      0.531579,
      0.207843,
      0.250425,
      0.27429,
      0.533103,
      0.211765,
      0.248629,
      0.278775,
      0.534556,
      0.215686,
      0.246811,
      0.283237,
      0.535941,
      0.219608,
      0.244972,
      0.287675,
      0.53726,
      0.223529,
      0.243113,
      0.292092,
      0.538516,
      0.227451,
      0.241237,
      0.296485,
      0.539709,
      0.231373,
      0.239346,
      0.300855,
      0.540844,
      0.235294,
      0.237441,
      0.305202,
      0.541921,
      0.239216,
      0.235526,
      0.309527,
      0.542944,
      0.243137,
      0.233603,
      0.313828,
      0.543914,
      0.247059,
      0.231674,
      0.318106,
      0.544834,
      0.25098,
      0.229739,
      0.322361,
      0.545706,
      0.254902,
      0.227802,
      0.326594,
      0.546532,
      0.258824,
      0.225863,
      0.330805,
      0.547314,
      0.262745,
      0.223925,
      0.334994,
      0.548053,
      0.266667,
      0.221989,
      0.339161,
      0.548752,
      0.270588,
      0.220057,
      0.343307,
      0.549413,
      0.27451,
      0.21813,
      0.347432,
      0.550038,
      0.278431,
      0.21621,
      0.351535,
      0.550627,
      0.282353,
      0.214298,
      0.355619,
      0.551184,
      0.286275,
      0.212395,
      0.359683,
      0.55171,
      0.290196,
      0.210503,
      0.363727,
      0.552206,
      0.294118,
      0.208623,
      0.367752,
      0.552675,
      0.298039,
      0.206756,
      0.371758,
      0.553117,
      0.301961,
      0.204903,
      0.375746,
      0.553533,
      0.305882,
      0.203063,
      0.379716,
      0.553925,
      0.309804,
      0.201239,
      0.38367,
      0.554294,
      0.313725,
      0.19943,
      0.387607,
      0.554642,
      0.317647,
      0.197636,
      0.391528,
      0.554969,
      0.321569,
      0.19586,
      0.395433,
      0.555276,
      0.32549,
      0.1941,
      0.399323,
      0.555565,
      0.329412,
      0.192357,
      0.403199,
      0.555836,
      0.333333,
      0.190631,
      0.407061,
      0.556089,
      0.337255,
      0.188923,
      0.41091,
      0.556326,
      0.341176,
      0.187231,
      0.414746,
      0.556547,
      0.345098,
      0.185556,
      0.41857,
      0.556753,
      0.34902,
      0.183898,
      0.422383,
      0.556944,
      0.352941,
      0.182256,
      0.426184,
      0.55712,
      0.356863,
      0.180629,
      0.429975,
      0.557282,
      0.360784,
      0.179019,
      0.433756,
      0.55743,
      0.364706,
      0.177423,
      0.437527,
      0.557565,
      0.368627,
      0.175841,
      0.44129,
      0.557685,
      0.372549,
      0.174274,
      0.445044,
      0.557792,
      0.376471,
      0.172719,
      0.448791,
      0.557885,
      0.380392,
      0.171176,
      0.45253,
      0.557965,
      0.384314,
      0.169646,
      0.456262,
      0.55803,
      0.388235,
      0.168126,
      0.459988,
      0.558082,
      0.392157,
      0.166617,
      0.463708,
      0.558119,
      0.396078,
      0.165117,
      0.467423,
      0.558141,
      0.4,
      0.163625,
      0.471133,
      0.558148,
      0.403922,
      0.162142,
      0.474838,
      0.55814,
      0.407843,
      0.160665,
      0.47854,
      0.558115,
      0.411765,
      0.159194,
      0.482237,
      0.558073,
      0.415686,
      0.157729,
      0.485932,
      0.558013,
      0.419608,
      0.15627,
      0.489624,
      0.557936,
      0.423529,
      0.154815,
      0.493313,
      0.55784,
      0.427451,
      0.153364,
      0.497,
      0.557724,
      0.431373,
      0.151918,
      0.500685,
      0.557587,
      0.435294,
      0.150476,
      0.504369,
      0.55743,
      0.439216,
      0.149039,
      0.508051,
      0.55725,
      0.443137,
      0.147607,
      0.511733,
      0.557049,
      0.447059,
      0.14618,
      0.515413,
      0.556823,
      0.45098,
      0.144759,
      0.519093,
      0.556572,
      0.454902,
      0.143343,
      0.522773,
      0.556295,
      0.458824,
      0.141935,
      0.526453,
      0.555991,
      0.462745,
      0.140536,
      0.530132,
      0.555659,
      0.466667,
      0.139147,
      0.533812,
      0.555298,
      0.470588,
      0.13777,
      0.537492,
      0.554906,
      0.47451,
      0.136408,
      0.541173,
      0.554483,
      0.478431,
      0.135066,
      0.544853,
      0.554029,
      0.482353,
      0.133743,
      0.548535,
      0.553541,
      0.486275,
      0.132444,
      0.552216,
      0.553018,
      0.490196,
      0.131172,
      0.555899,
      0.552459,
      0.494118,
      0.129933,
      0.559582,
      0.551864,
      0.498039,
      0.128729,
      0.563265,
      0.551229,
      0.501961,
      0.127568,
      0.566949,
      0.550556,
      0.505882,
      0.126453,
      0.570633,
      0.549841,
      0.509804,
      0.125394,
      0.574318,
      0.549086,
      0.513725,
      0.124395,
      0.578002,
      0.548287,
      0.517647,
      0.123463,
      0.581687,
      0.547445,
      0.521569,
      0.122606,
      0.585371,
      0.546557,
      0.52549,
      0.121831,
      0.589055,
      0.545623,
      0.529412,
      0.121148,
      0.592739,
      0.544641,
      0.533333,
      0.120565,
      0.596422,
      0.543611,
      0.537255,
      0.120092,
      0.600104,
      0.54253,
      0.541176,
      0.119738,
      0.603785,
      0.5414,
      0.545098,
      0.119512,
      0.607464,
      0.540218,
      0.54902,
      0.119423,
      0.611141,
      0.538982,
      0.552941,
      0.119483,
      0.614817,
      0.537692,
      0.556863,
      0.119699,
      0.61849,
      0.536347,
      0.560784,
      0.120081,
      0.622161,
      0.534946,
      0.564706,
      0.120638,
      0.625828,
      0.533488,
      0.568627,
      0.12138,
      0.629492,
      0.531973,
      0.572549,
      0.122312,
      0.633153,
      0.530398,
      0.576471,
      0.123444,
      0.636809,
      0.528763,
      0.580392,
      0.12478,
      0.640461,
      0.527068,
      0.584314,
      0.126326,
      0.644107,
      0.525311,
      0.588235,
      0.128087,
      0.647749,
      0.523491,
      0.592157,
      0.130067,
      0.651384,
      0.521608,
      0.596078,
      0.132268,
      0.655014,
      0.519661,
      0.6,
      0.134692,
      0.658636,
      0.517649,
      0.603922,
      0.137339,
      0.662252,
      0.515571,
      0.607843,
      0.14021,
      0.665859,
      0.513427,
      0.611765,
      0.143303,
      0.669459,
      0.511215,
      0.615686,
      0.146616,
      0.67305,
      0.508936,
      0.619608,
      0.150148,
      0.676631,
      0.506589,
      0.623529,
      0.153894,
      0.680203,
      0.504172,
      0.627451,
      0.157851,
      0.683765,
      0.501686,
      0.631373,
      0.162016,
      0.687316,
      0.499129,
      0.635294,
      0.166383,
      0.690856,
      0.496502,
      0.639216,
      0.170948,
      0.694384,
      0.493803,
      0.643137,
      0.175707,
      0.6979,
      0.491033,
      0.647059,
      0.180653,
      0.701402,
      0.488189,
      0.65098,
      0.185783,
      0.704891,
      0.485273,
      0.654902,
      0.19109,
      0.708366,
      0.482284,
      0.658824,
      0.196571,
      0.711827,
      0.479221,
      0.662745,
      0.202219,
      0.715272,
      0.476084,
      0.666667,
      0.20803,
      0.718701,
      0.472873,
      0.670588,
      0.214,
      0.722114,
      0.469588,
      0.67451,
      0.220124,
      0.725509,
      0.466226,
      0.678431,
      0.226397,
      0.728888,
      0.462789,
      0.682353,
      0.232815,
      0.732247,
      0.459277,
      0.686275,
      0.239374,
      0.735588,
      0.455688,
      0.690196,
      0.24607,
      0.73891,
      0.452024,
      0.694118,
      0.252899,
      0.742211,
      0.448284,
      0.698039,
      0.259857,
      0.745492,
      0.444467,
      0.701961,
      0.266941,
      0.748751,
      0.440573,
      0.705882,
      0.274149,
      0.751988,
      0.436601,
      0.709804,
      0.281477,
      0.755203,
      0.432552,
      0.713725,
      0.288921,
      0.758394,
      0.428426,
      0.717647,
      0.296479,
      0.761561,
      0.424223,
      0.721569,
      0.304148,
      0.764704,
      0.419943,
      0.72549,
      0.311925,
      0.767822,
      0.415586,
      0.729412,
      0.319809,
      0.770914,
      0.411152,
      0.733333,
      0.327796,
      0.77398,
      0.40664,
      0.737255,
      0.335885,
      0.777018,
      0.402049,
      0.741176,
      0.344074,
      0.780029,
      0.397381,
      0.745098,
      0.35236,
      0.783011,
      0.392636,
      0.74902,
      0.360741,
      0.785964,
      0.387814,
      0.752941,
      0.369214,
      0.788888,
      0.382914,
      0.756863,
      0.377779,
      0.791781,
      0.377939,
      0.760784,
      0.386433,
      0.794644,
      0.372886,
      0.764706,
      0.395174,
      0.797475,
      0.367757,
      0.768627,
      0.404001,
      0.800275,
      0.362552,
      0.772549,
      0.412913,
      0.803041,
      0.357269,
      0.776471,
      0.421908,
      0.805774,
      0.35191,
      0.780392,
      0.430983,
      0.808473,
      0.346476,
      0.784314,
      0.440137,
      0.811138,
      0.340967,
      0.788235,
      0.449368,
      0.813768,
      0.335384,
      0.792157,
      0.458674,
      0.816363,
      0.329727,
      0.796078,
      0.468053,
      0.818921,
      0.323998,
      0.8,
      0.477504,
      0.821444,
      0.318195,
      0.803922,
      0.487026,
      0.823929,
      0.312321,
      0.807843,
      0.496615,
      0.826376,
      0.306377,
      0.811765,
      0.506271,
      0.828786,
      0.300362,
      0.815686,
      0.515992,
      0.831158,
      0.294279,
      0.819608,
      0.525776,
      0.833491,
      0.288127,
      0.823529,
      0.535621,
      0.835785,
      0.281908,
      0.827451,
      0.545524,
      0.838039,
      0.275626,
      0.831373,
      0.555484,
      0.840254,
      0.269281,
      0.835294,
      0.565498,
      0.84243,
      0.262877,
      0.839216,
      0.575563,
      0.844566,
      0.256415,
      0.843137,
      0.585678,
      0.846661,
      0.249897,
      0.847059,
      0.595839,
      0.848717,
      0.243329,
      0.85098,
      0.606045,
      0.850733,
      0.236712,
      0.854902,
      0.616293,
      0.852709,
      0.230052,
      0.858824,
      0.626579,
      0.854645,
      0.223353,
      0.862745,
      0.636902,
      0.856542,
      0.21662,
      0.866667,
      0.647257,
      0.8584,
      0.209861,
      0.870588,
      0.657642,
      0.860219,
      0.203082,
      0.87451,
      0.668054,
      0.861999,
      0.196293,
      0.878431,
      0.678489,
      0.863742,
      0.189503,
      0.882353,
      0.688944,
      0.865448,
      0.182725,
      0.886275,
      0.699415,
      0.867117,
      0.175971,
      0.890196,
      0.709898,
      0.868751,
      0.169257,
      0.894118,
      0.720391,
      0.87035,
      0.162603,
      0.898039,
      0.730889,
      0.871916,
      0.156029,
      0.901961,
      0.741388,
      0.873449,
      0.149561,
      0.905882,
      0.751884,
      0.874951,
      0.143228,
      0.909804,
      0.762373,
      0.876424,
      0.137064,
      0.913725,
      0.772852,
      0.877868,
      0.131109,
      0.917647,
      0.783315,
      0.879285,
      0.125405,
      0.921569,
      0.79376,
      0.880678,
      0.120005,
      0.92549,
      0.804182,
      0.882046,
      0.114965,
      0.929412,
      0.814576,
      0.883393,
      0.110347,
      0.933333,
      0.82494,
      0.88472,
      0.106217,
      0.937255,
      0.83527,
      0.886029,
      0.102646,
      0.941176,
      0.845561,
      0.887322,
      0.099702,
      0.945098,
      0.85581,
      0.888601,
      0.097452,
      0.94902,
      0.866013,
      0.889868,
      0.095953,
      0.952941,
      0.876168,
      0.891125,
      0.09525,
      0.956863,
      0.886271,
      0.892374,
      0.095374,
      0.960784,
      0.89632,
      0.893616,
      0.096335,
      0.964706,
      0.906311,
      0.894855,
      0.098125,
      0.968627,
      0.916242,
      0.896091,
      0.100717,
      0.972549,
      0.926106,
      0.89733,
      0.104071,
      0.976471,
      0.935904,
      0.89857,
      0.108131,
      0.980392,
      0.945636,
      0.899815,
      0.112838,
      0.984314,
      0.9553,
      0.901065,
      0.118128,
      0.988235,
      0.964894,
      0.902323,
      0.123941,
      0.992157,
      0.974417,
      0.90359,
      0.130215,
      0.996078,
      0.983868,
      0.904867,
      0.136897,
      1,
      0.993248,
      0.906157,
      0.143936
    ]
  },
  {
    ShowIndexedColorActiveValues: 1,
    IndexedColors: [
      0.07,
      0.5,
      0.7,
      1,
      1,
      1,
      0.85,
      1,
      1,
      0.8,
      0.5,
      1,
      0.76,
      1,
      0,
      1,
      0.71,
      0.71,
      0.5,
      0.5,
      0.5,
      0.05,
      0.05,
      1,
      1,
      0.05,
      0.05,
      0.7,
      1,
      1,
      0.7,
      0.89,
      0.96,
      0.67,
      0.36,
      0.95,
      0.54,
      1,
      0,
      0.75,
      0.65,
      0.65,
      0.5,
      0.6,
      0.6,
      1,
      0.5,
      0,
      1,
      1,
      0.19,
      0.12,
      0.94,
      0.12,
      0.5,
      0.82,
      0.89,
      0.56,
      0.25,
      0.83,
      0.24,
      1,
      0,
      0.9,
      0.9,
      0.9,
      0.75,
      0.76,
      0.78,
      0.65,
      0.65,
      0.67,
      0.54,
      0.6,
      0.78,
      0.61,
      0.48,
      0.78,
      0.5,
      0.48,
      0.78,
      0.44,
      0.48,
      0.78,
      0.36,
      0.48,
      0.76,
      1,
      0.48,
      0.38,
      0.49,
      0.5,
      0.69,
      0.76,
      0.56,
      0.56,
      0.4,
      0.56,
      0.56,
      0.74,
      0.5,
      0.89,
      1,
      0.63,
      0,
      0.65,
      0.16,
      0.16,
      0.36,
      0.72,
      0.82,
      0.44,
      0.18,
      0.69,
      0,
      1,
      0,
      0.58,
      1,
      1,
      0.58,
      0.88,
      0.88,
      0.45,
      0.76,
      0.79,
      0.33,
      0.71,
      0.71,
      0.23,
      0.62,
      0.62,
      0.14,
      0.56,
      0.56,
      0.04,
      0.49,
      0.55,
      0,
      0.41,
      0.52,
      0.88,
      0.88,
      1,
      1,
      0.85,
      0.56,
      0.65,
      0.46,
      0.45,
      0.4,
      0.5,
      0.5,
      0.62,
      0.39,
      0.71,
      0.83,
      0.48,
      0,
      0.58,
      0,
      0.58,
      0.26,
      0.62,
      0.69,
      0.34,
      0.09,
      0.56,
      0,
      0.79,
      0,
      0.44,
      0.83,
      1,
      1,
      1,
      0.78,
      0.85,
      1,
      0.78,
      0.78,
      1,
      0.78,
      0.64,
      1,
      0.78,
      0.56,
      1,
      0.78,
      0.38,
      1,
      0.78,
      0.27,
      1,
      0.78,
      0.19,
      1,
      0.78,
      0.12,
      1,
      0.78,
      0,
      1,
      0.61,
      0,
      0.9,
      0.46,
      0,
      0.83,
      0.32,
      0,
      0.75,
      0.22,
      0,
      0.67,
      0.14,
      0.3,
      0.76,
      1,
      0.3,
      0.65,
      1,
      0.13,
      0.58,
      0.84,
      0.15,
      0.49,
      0.67,
      0.15,
      0.4,
      0.59,
      0.09,
      0.33,
      0.53,
      0.96,
      0.93,
      0.82,
      0.8,
      0.82,
      0.12,
      0.71,
      0.71,
      0.76,
      0.65,
      0.33,
      0.3,
      0.34,
      0.35,
      0.38,
      0.62,
      0.31,
      0.71,
      0.67,
      0.36,
      0,
      0.46,
      0.31,
      0.27,
      0.26,
      0.51,
      0.59,
      0.26,
      0,
      0.4,
      0,
      0.49,
      0,
      0.44,
      0.67,
      0.98,
      0,
      0.73,
      1,
      0,
      0.63,
      1,
      0,
      0.56,
      1,
      0,
      0.5,
      1,
      0,
      0.42,
      1,
      0.33,
      0.36,
      0.95,
      0.47,
      0.36,
      0.89,
      0.54,
      0.31,
      0.89,
      0.63,
      0.21,
      0.83,
      0.7,
      0.12,
      0.83,
      0.7,
      0.12,
      0.73,
      0.7,
      0.05,
      0.65,
      0.74,
      0.05,
      0.53,
      0.78,
      0,
      0.4,
      0.8,
      0,
      0.35,
      0.82,
      0,
      0.31,
      0.85,
      0,
      0.27,
      0.88,
      0,
      0.22,
      0.9,
      0,
      0.18,
      0.91,
      0,
      0.15,
      0.92,
      0,
      0.14,
      0.93,
      0,
      0.13,
      0.94,
      0,
      0.12,
      0.95,
      0,
      0.11,
      0.96,
      0,
      0.1,
      0.97,
      0,
      0.09,
      0.98,
      0,
      0.08,
      0.99,
      0,
      0.07,
      1,
      0,
      0.06
    ],
    Annotations: [
      0,
      "Xx",
      1,
      "H",
      2,
      "He",
      3,
      "Li",
      4,
      "Be",
      5,
      "B",
      6,
      "C",
      7,
      "N",
      8,
      "O",
      9,
      "F",
      10,
      "Ne",
      11,
      "Na",
      12,
      "Mg",
      13,
      "Al",
      14,
      "Si",
      15,
      "P",
      16,
      "S",
      17,
      "Cl",
      18,
      "Ar",
      19,
      "K",
      20,
      "Ca",
      21,
      "Sc",
      22,
      "Ti",
      23,
      "V",
      24,
      "Cr",
      25,
      "Mn",
      26,
      "Fe",
      27,
      "Co",
      28,
      "Ni",
      29,
      "Cu",
      30,
      "Zn",
      31,
      "Ga",
      32,
      "Ge",
      33,
      "As",
      34,
      "Se",
      35,
      "Br",
      36,
      "Kr",
      37,
      "Rb",
      38,
      "Sr",
      39,
      "Y",
      40,
      "Zr",
      41,
      "Nb",
      42,
      "Mo",
      43,
      "Tc",
      44,
      "Ru",
      45,
      "Rh",
      46,
      "Pd",
      47,
      "Ag",
      48,
      "Cd",
      49,
      "In",
      50,
      "Sn",
      51,
      "Sb",
      52,
      "Te",
      53,
      "I",
      54,
      "Xe",
      55,
      "Cs",
      56,
      "Ba",
      57,
      "La",
      58,
      "Ce",
      59,
      "Pr",
      60,
      "Nd",
      61,
      "Pm",
      62,
      "Sm",
      63,
      "Eu",
      64,
      "Gd",
      65,
      "Tb",
      66,
      "Dy",
      67,
      "Ho",
      68,
      "Er",
      69,
      "Tm",
      70,
      "Yb",
      71,
      "Lu",
      72,
      "Hf",
      73,
      "Ta",
      74,
      "W",
      75,
      "Re",
      76,
      "Os",
      77,
      "Ir",
      78,
      "Pt",
      79,
      "Au",
      80,
      "Hg",
      81,
      "Tl",
      82,
      "Pb",
      83,
      "Bi",
      84,
      "Po",
      85,
      "At",
      86,
      "Rn",
      87,
      "Fr",
      88,
      "Ra",
      89,
      "Ac",
      90,
      "Th",
      91,
      "Pa",
      92,
      "U",
      93,
      "Np",
      94,
      "Pu",
      95,
      "Am",
      96,
      "Cm",
      97,
      "Bk",
      98,
      "Cf",
      99,
      "Es",
      100,
      "Fm",
      101,
      "Md",
      102,
      "No",
      103,
      "Lr",
      104,
      "Rf",
      105,
      "Db",
      106,
      "Sg",
      107,
      "Bh",
      108,
      "Hs",
      109,
      "Mt",
      110,
      "Ds",
      111,
      "Rg",
      112,
      "Cn",
      113,
      "Uut",
      114,
      "Uuq",
      115,
      "Uup",
      116,
      "Uuh",
      117,
      "Uus",
      118,
      "Uuo"
    ],
    Name: "BlueObeliskElements"
  }
], presetMap = /* @__PURE__ */ Object.create(null);
vtkColorMaps$1.filter((e12) => e12.RGBPoints).filter((e12) => e12.ColorSpace !== "CIELAB").forEach((e12) => {
  presetMap[e12.Name] = e12;
});
var rgbPresetNames = Object.keys(presetMap);
rgbPresetNames.sort();
function getPresetByName(e12) {
  return presetMap[e12];
}
function addPreset(e12) {
  !e12.RGBPoints || e12.ColorSpace === "CIELAB" || (presetMap[e12.Name] || (rgbPresetNames.push(e12.Name), rgbPresetNames.sort()), presetMap[e12.Name] = e12);
}
function removePresetByName(e12) {
  let t = rgbPresetNames.indexOf(e12);
  t > -1 && rgbPresetNames.splice(t, 1), delete presetMap[e12];
}
var vtkColorMaps = {
  addPreset,
  removePresetByName,
  getPresetByName,
  rgbPresetNames
}, { vtkErrorMacro: vtkErrorMacro$39 } = macro;
function vtkPiecewiseFunction(e12, t) {
  t.classHierarchy.push("vtkPiecewiseFunction"), e12.getSize = () => t.nodes.length, e12.getType = () => {
    let e13, n = 0, r = 0;
    t.nodes.length > 0 && (n = t.nodes[0].y);
    for (let a = 1; a < t.nodes.length; a++) {
      if (e13 = t.nodes[a].y, e13 !== n)
        if (e13 > n)
          switch (r) {
            case 0:
            case 1:
              r = 1;
              break;
            case 2:
            default:
              r = 3;
              break;
          }
        else
          switch (r) {
            case 0:
            case 2:
              r = 2;
              break;
            case 1:
            default:
              r = 3;
              break;
          }
      if (n = e13, r === 3)
        break;
    }
    switch (r) {
      case 0:
        return "Constant";
      case 1:
        return "NonDecreasing";
      case 2:
        return "NonIncreasing";
      case 3:
      default:
        return "Varied";
    }
  }, e12.getDataPointer = () => {
    let e13 = t.nodes.length;
    if (t.function = null, e13 > 0) {
      t.function = [];
      for (let n = 0; n < e13; n++)
        t.function[2 * n] = t.nodes[n].x, t.function[2 * n + 1] = t.nodes[n].y;
    }
    return t.function;
  }, e12.getFirstNonZeroValue = () => {
    if (t.nodes.length === 0)
      return 0;
    let e13 = 1, n = 0, r = 0;
    for (; r < t.nodes.length; r++)
      if (t.nodes[r].y !== 0) {
        e13 = 0;
        break;
      }
    return n = e13 ? Number.MAX_VALUE : r > 0 ? t.nodes[r - 1].x : t.clamping ? -Number.MAX_VALUE : t.nodes[0].x, n;
  }, e12.getNodeValue = (e13, n) => {
    let r = t.nodes.length;
    return e13 < 0 || e13 >= r ? (vtkErrorMacro$39("Index out of range!"), -1) : (n[0] = t.nodes[e13].x, n[1] = t.nodes[e13].y, n[2] = t.nodes[e13].midpoint, n[3] = t.nodes[e13].sharpness, 1);
  }, e12.setNodeValue = (n, r) => {
    let a = t.nodes.length;
    if (n < 0 || n >= a)
      return vtkErrorMacro$39("Index out of range!"), -1;
    let o = t.nodes[n].x;
    return t.nodes[n].x = r[0], t.nodes[n].y = r[1], t.nodes[n].midpoint = r[2], t.nodes[n].sharpness = r[3], o === r[0] ? e12.modified() : e12.sortAndUpdateRange(), 1;
  }, e12.addPoint = (t2, n) => e12.addPointLong(t2, n, 0.5, 0), e12.addPointLong = (n, r, a, o) => {
    if (a < 0 || a > 1)
      return vtkErrorMacro$39("Midpoint outside range [0.0, 1.0]"), -1;
    if (o < 0 || o > 1)
      return vtkErrorMacro$39("Sharpness outside range [0.0, 1.0]"), -1;
    t.allowDuplicateScalars || e12.removePoint(n);
    let s = {
      x: n,
      y: r,
      midpoint: a,
      sharpness: o
    };
    t.nodes.push(s), e12.sortAndUpdateRange();
    let c;
    for (c = 0; c < t.nodes.length && t.nodes[c].x !== n; c++)
      ;
    return c < t.nodes.length ? c : -1;
  }, e12.setNodes = (n) => {
    t.nodes !== n && (t.nodes = n, e12.sortAndUpdateRange());
  }, e12.sortAndUpdateRange = () => {
    t.nodes.sort((e13, t2) => e13.x - t2.x), e12.updateRange() || e12.modified();
  }, e12.updateRange = () => {
    let n = t.range.slice(), r = t.nodes.length;
    return r ? (t.range[0] = t.nodes[0].x, t.range[1] = t.nodes[r - 1].x) : (t.range[0] = 0, t.range[1] = 0), n[0] === t.range[0] && n[1] === t.range[1] ? false : (e12.modified(), true);
  }, e12.removePoint = (n) => {
    let r;
    for (r = 0; r < t.nodes.length && t.nodes[r].x !== n; r++)
      ;
    if (r >= t.nodes.length)
      return -1;
    let a = r, o = false;
    return t.nodes.splice(r, 1), (r === 0 || r === t.nodes.length) && (o = e12.updateRange()), o || e12.modified(), a;
  }, e12.removeAllPoints = () => {
    t.nodes = [], e12.sortAndUpdateRange();
  }, e12.addSegment = (n, r, a, o) => {
    e12.sortAndUpdateRange();
    for (let e13 = 0; e13 < t.nodes.length; )
      t.nodes[e13].x >= n && t.nodes[e13].x <= a ? t.nodes.splice(e13, 1) : e13++;
    e12.addPoint(n, r, 0.5, 0), e12.addPoint(a, o, 0.5, 0);
  }, e12.getValue = (t2) => {
    let n = [];
    return e12.getTable(t2, t2, 1, n), n[0];
  }, e12.adjustRange = (n) => {
    if (n.length < 2)
      return 0;
    let r = e12.getRange();
    r[0] < n[0] ? e12.addPoint(n[0], e12.getValue(n[0])) : e12.addPoint(n[0], e12.getValue(r[0])), r[1] > n[1] ? e12.addPoint(n[1], e12.getValue(n[1])) : e12.addPoint(n[1], e12.getValue(r[1])), e12.sortAndUpdateRange();
    for (let e13 = 0; e13 < t.nodes.length; )
      t.nodes[e13].x >= n[0] && t.nodes[e13].x <= n[1] ? t.nodes.splice(e13, 1) : ++e13;
    return e12.sortAndUpdateRange(), 1;
  }, e12.estimateMinNumberOfSamples = (t2, n) => {
    let r = e12.findMinimumXDistance();
    return Math.ceil((n - t2) / r);
  }, e12.findMinimumXDistance = () => {
    let e13 = t.nodes.length;
    if (e13 < 2)
      return -1;
    let n = t.nodes[1].x - t.nodes[0].x;
    for (let r = 0; r < e13 - 1; r++) {
      let e14 = t.nodes[r + 1].x - t.nodes[r].x;
      e14 < n && (n = e14);
    }
    return n;
  }, e12.getTable = function(e13, n, r, a) {
    let o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, s, c = 0, l = t.nodes.length, u = 0;
    l !== 0 && (u = t.nodes[l - 1].y);
    let d = 0, f = 0, p = 0, m = 0, h = 0, g = 0, _ = 0;
    for (s = 0; s < r; s++) {
      let v = o * s;
      for (d = r > 1 ? e13 + s / (r - 1) * (n - e13) : 0.5 * (e13 + n); c < l && d > t.nodes[c].x; )
        c++, c < l && (f = t.nodes[c - 1].x, p = t.nodes[c].x, m = t.nodes[c - 1].y, h = t.nodes[c].y, g = t.nodes[c - 1].midpoint, _ = t.nodes[c - 1].sharpness, g < 1e-5 && (g = 1e-5), g > 0.99999 && (g = 0.99999));
      if (c >= l)
        a[v] = t.clamping ? u : 0;
      else if (c === 0)
        a[v] = t.clamping ? t.nodes[0].y : 0;
      else {
        let e14 = (d - f) / (p - f);
        if (e14 = e14 < g ? 0.5 * e14 / g : 0.5 + 0.5 * (e14 - g) / (1 - g), _ > 0.99)
          if (e14 < 0.5) {
            a[v] = m;
            continue;
          } else {
            a[v] = h;
            continue;
          }
        if (_ < 0.01) {
          a[v] = (1 - e14) * m + e14 * h;
          continue;
        }
        e14 < 0.5 ? e14 = 0.5 * (e14 * 2) ** (1 + 10 * _) : e14 > 0.5 && (e14 = 1 - 0.5 * ((1 - e14) * 2) ** (1 + 10 * _));
        let t2 = e14 * e14, n2 = t2 * e14, r2 = 2 * n2 - 3 * t2 + 1, o2 = -2 * n2 + 3 * t2, s2 = n2 - 2 * t2 + e14, c2 = n2 - t2, l2 = h - m, u2 = (1 - _) * l2;
        a[v] = r2 * m + o2 * h + s2 * u2 + c2 * u2;
        let y = m < h ? m : h, b = m > h ? m : h;
        a[v] = a[v] < y ? y : a[v], a[v] = a[v] > b ? b : a[v];
      }
    }
  };
}
var DEFAULT_VALUES$127 = {
  range: [0, 0],
  clamping: true,
  allowDuplicateScalars: false
};
function extend$138(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$127, n), macro.obj(e12, t), t.nodes = [], macro.setGet(e12, t, ["allowDuplicateScalars", "clamping"]), macro.setArray(e12, t, ["range"], 2), macro.getArray(e12, t, ["range"]), vtkPiecewiseFunction(e12, t);
}
var vtkPiecewiseFunction$1 = {
  newInstance: macro.newInstance(extend$138, "vtkPiecewiseFunction"),
  extend: extend$138
}, EPSILON$4 = 1e-6, ARRAY_TYPE = typeof Float32Array < "u" ? Float32Array : Array, degree = Math.PI / 180;
function toRadian(e12) {
  return e12 * degree;
}
function equals$6(e12, t) {
  return Math.abs(e12 - t) <= EPSILON$4 * Math.max(1, Math.abs(e12), Math.abs(t));
}
Math.hypot || (Math.hypot = function() {
  for (var e12 = 0, t = arguments.length; t--; )
    e12 += arguments[t] * arguments[t];
  return Math.sqrt(e12);
});
var mat3_exports = /* @__PURE__ */ __export({
  add: () => add$6,
  adjoint: () => adjoint$1,
  clone: () => clone$4,
  copy: () => copy$5,
  create: () => create$6,
  determinant: () => determinant$1,
  equals: () => equals$5,
  exactEquals: () => exactEquals$4,
  frob: () => frob$1,
  fromMat2d: () => fromMat2d,
  fromMat4: () => fromMat4,
  fromQuat: () => fromQuat$1,
  fromRotation: () => fromRotation$1,
  fromScaling: () => fromScaling$1,
  fromTranslation: () => fromTranslation$1,
  fromValues: () => fromValues$5,
  identity: () => identity$3,
  invert: () => invert$1,
  mul: () => mul$2,
  multiply: () => multiply$3,
  multiplyScalar: () => multiplyScalar$2,
  multiplyScalarAndAdd: () => multiplyScalarAndAdd$1,
  normalFromMat4: () => normalFromMat4,
  projection: () => projection,
  rotate: () => rotate$1,
  scale: () => scale$5,
  set: () => set$6,
  str: () => str$1,
  sub: () => sub$3,
  subtract: () => subtract$5,
  translate: () => translate$1,
  transpose: () => transpose$1
});
function create$6() {
  var e12 = new ARRAY_TYPE(9);
  return ARRAY_TYPE != Float32Array && (e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[5] = 0, e12[6] = 0, e12[7] = 0), e12[0] = 1, e12[4] = 1, e12[8] = 1, e12;
}
function fromMat4(e12, t) {
  return e12[0] = t[0], e12[1] = t[1], e12[2] = t[2], e12[3] = t[4], e12[4] = t[5], e12[5] = t[6], e12[6] = t[8], e12[7] = t[9], e12[8] = t[10], e12;
}
function clone$4(e12) {
  var t = new ARRAY_TYPE(9);
  return t[0] = e12[0], t[1] = e12[1], t[2] = e12[2], t[3] = e12[3], t[4] = e12[4], t[5] = e12[5], t[6] = e12[6], t[7] = e12[7], t[8] = e12[8], t;
}
function copy$5(e12, t) {
  return e12[0] = t[0], e12[1] = t[1], e12[2] = t[2], e12[3] = t[3], e12[4] = t[4], e12[5] = t[5], e12[6] = t[6], e12[7] = t[7], e12[8] = t[8], e12;
}
function fromValues$5(e12, t, n, r, a, o, s, c, l) {
  var u = new ARRAY_TYPE(9);
  return u[0] = e12, u[1] = t, u[2] = n, u[3] = r, u[4] = a, u[5] = o, u[6] = s, u[7] = c, u[8] = l, u;
}
function set$6(e12, t, n, r, a, o, s, c, l, u) {
  return e12[0] = t, e12[1] = n, e12[2] = r, e12[3] = a, e12[4] = o, e12[5] = s, e12[6] = c, e12[7] = l, e12[8] = u, e12;
}
function identity$3(e12) {
  return e12[0] = 1, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 1, e12[5] = 0, e12[6] = 0, e12[7] = 0, e12[8] = 1, e12;
}
function transpose$1(e12, t) {
  if (e12 === t) {
    var n = t[1], r = t[2], a = t[5];
    e12[1] = t[3], e12[2] = t[6], e12[3] = n, e12[5] = t[7], e12[6] = r, e12[7] = a;
  } else
    e12[0] = t[0], e12[1] = t[3], e12[2] = t[6], e12[3] = t[1], e12[4] = t[4], e12[5] = t[7], e12[6] = t[2], e12[7] = t[5], e12[8] = t[8];
  return e12;
}
function invert$1(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8], f = d * s - c * u, p = -d * o + c * l, m = u * o - s * l, h = n * f + r * p + a * m;
  return h ? (h = 1 / h, e12[0] = f * h, e12[1] = (-d * r + a * u) * h, e12[2] = (c * r - a * s) * h, e12[3] = p * h, e12[4] = (d * n - a * l) * h, e12[5] = (-c * n + a * o) * h, e12[6] = m * h, e12[7] = (-u * n + r * l) * h, e12[8] = (s * n - r * o) * h, e12) : null;
}
function adjoint$1(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8];
  return e12[0] = s * d - c * u, e12[1] = a * u - r * d, e12[2] = r * c - a * s, e12[3] = c * l - o * d, e12[4] = n * d - a * l, e12[5] = a * o - n * c, e12[6] = o * u - s * l, e12[7] = r * l - n * u, e12[8] = n * s - r * o, e12;
}
function determinant$1(e12) {
  var t = e12[0], n = e12[1], r = e12[2], a = e12[3], o = e12[4], s = e12[5], c = e12[6], l = e12[7], u = e12[8];
  return t * (u * o - s * l) + n * (-u * a + s * c) + r * (l * a - o * c);
}
function multiply$3(e12, t, n) {
  var r = t[0], a = t[1], o = t[2], s = t[3], c = t[4], l = t[5], u = t[6], d = t[7], f = t[8], p = n[0], m = n[1], h = n[2], g = n[3], _ = n[4], v = n[5], y = n[6], b = n[7], S = n[8];
  return e12[0] = p * r + m * s + h * u, e12[1] = p * a + m * c + h * d, e12[2] = p * o + m * l + h * f, e12[3] = g * r + _ * s + v * u, e12[4] = g * a + _ * c + v * d, e12[5] = g * o + _ * l + v * f, e12[6] = y * r + b * s + S * u, e12[7] = y * a + b * c + S * d, e12[8] = y * o + b * l + S * f, e12;
}
function translate$1(e12, t, n) {
  var r = t[0], a = t[1], o = t[2], s = t[3], c = t[4], l = t[5], u = t[6], d = t[7], f = t[8], p = n[0], m = n[1];
  return e12[0] = r, e12[1] = a, e12[2] = o, e12[3] = s, e12[4] = c, e12[5] = l, e12[6] = p * r + m * s + u, e12[7] = p * a + m * c + d, e12[8] = p * o + m * l + f, e12;
}
function rotate$1(e12, t, n) {
  var r = t[0], a = t[1], o = t[2], s = t[3], c = t[4], l = t[5], u = t[6], d = t[7], f = t[8], p = Math.sin(n), m = Math.cos(n);
  return e12[0] = m * r + p * s, e12[1] = m * a + p * c, e12[2] = m * o + p * l, e12[3] = m * s - p * r, e12[4] = m * c - p * a, e12[5] = m * l - p * o, e12[6] = u, e12[7] = d, e12[8] = f, e12;
}
function scale$5(e12, t, n) {
  var r = n[0], a = n[1];
  return e12[0] = r * t[0], e12[1] = r * t[1], e12[2] = r * t[2], e12[3] = a * t[3], e12[4] = a * t[4], e12[5] = a * t[5], e12[6] = t[6], e12[7] = t[7], e12[8] = t[8], e12;
}
function fromTranslation$1(e12, t) {
  return e12[0] = 1, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 1, e12[5] = 0, e12[6] = t[0], e12[7] = t[1], e12[8] = 1, e12;
}
function fromRotation$1(e12, t) {
  var n = Math.sin(t), r = Math.cos(t);
  return e12[0] = r, e12[1] = n, e12[2] = 0, e12[3] = -n, e12[4] = r, e12[5] = 0, e12[6] = 0, e12[7] = 0, e12[8] = 1, e12;
}
function fromScaling$1(e12, t) {
  return e12[0] = t[0], e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = t[1], e12[5] = 0, e12[6] = 0, e12[7] = 0, e12[8] = 1, e12;
}
function fromMat2d(e12, t) {
  return e12[0] = t[0], e12[1] = t[1], e12[2] = 0, e12[3] = t[2], e12[4] = t[3], e12[5] = 0, e12[6] = t[4], e12[7] = t[5], e12[8] = 1, e12;
}
function fromQuat$1(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = t[3], s = n + n, c = r + r, l = a + a, u = n * s, d = r * s, f = r * c, p = a * s, m = a * c, h = a * l, g = o * s, _ = o * c, v = o * l;
  return e12[0] = 1 - f - h, e12[3] = d - v, e12[6] = p + _, e12[1] = d + v, e12[4] = 1 - u - h, e12[7] = m - g, e12[2] = p - _, e12[5] = m + g, e12[8] = 1 - u - f, e12;
}
function normalFromMat4(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8], f = t[9], p = t[10], m = t[11], h = t[12], g = t[13], _ = t[14], v = t[15], y = n * c - r * s, b = n * l - a * s, S = n * u - o * s, C = r * l - a * c, w = r * u - o * c, T = a * u - o * l, E = d * g - f * h, D = d * _ - p * h, O = d * v - m * h, k = f * _ - p * g, A = f * v - m * g, j = p * v - m * _, M = y * j - b * A + S * k + C * O - w * D + T * E;
  return M ? (M = 1 / M, e12[0] = (c * j - l * A + u * k) * M, e12[1] = (l * O - s * j - u * D) * M, e12[2] = (s * A - c * O + u * E) * M, e12[3] = (a * A - r * j - o * k) * M, e12[4] = (n * j - a * O + o * D) * M, e12[5] = (r * O - n * A - o * E) * M, e12[6] = (g * T - _ * w + v * C) * M, e12[7] = (_ * S - h * T - v * b) * M, e12[8] = (h * w - g * S + v * y) * M, e12) : null;
}
function projection(e12, t, n) {
  return e12[0] = 2 / t, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = -2 / n, e12[5] = 0, e12[6] = -1, e12[7] = 1, e12[8] = 1, e12;
}
function str$1(e12) {
  return "mat3(" + e12[0] + ", " + e12[1] + ", " + e12[2] + ", " + e12[3] + ", " + e12[4] + ", " + e12[5] + ", " + e12[6] + ", " + e12[7] + ", " + e12[8] + ")";
}
function frob$1(e12) {
  return Math.hypot(e12[0], e12[1], e12[2], e12[3], e12[4], e12[5], e12[6], e12[7], e12[8]);
}
function add$6(e12, t, n) {
  return e12[0] = t[0] + n[0], e12[1] = t[1] + n[1], e12[2] = t[2] + n[2], e12[3] = t[3] + n[3], e12[4] = t[4] + n[4], e12[5] = t[5] + n[5], e12[6] = t[6] + n[6], e12[7] = t[7] + n[7], e12[8] = t[8] + n[8], e12;
}
function subtract$5(e12, t, n) {
  return e12[0] = t[0] - n[0], e12[1] = t[1] - n[1], e12[2] = t[2] - n[2], e12[3] = t[3] - n[3], e12[4] = t[4] - n[4], e12[5] = t[5] - n[5], e12[6] = t[6] - n[6], e12[7] = t[7] - n[7], e12[8] = t[8] - n[8], e12;
}
function multiplyScalar$2(e12, t, n) {
  return e12[0] = t[0] * n, e12[1] = t[1] * n, e12[2] = t[2] * n, e12[3] = t[3] * n, e12[4] = t[4] * n, e12[5] = t[5] * n, e12[6] = t[6] * n, e12[7] = t[7] * n, e12[8] = t[8] * n, e12;
}
function multiplyScalarAndAdd$1(e12, t, n, r) {
  return e12[0] = t[0] + n[0] * r, e12[1] = t[1] + n[1] * r, e12[2] = t[2] + n[2] * r, e12[3] = t[3] + n[3] * r, e12[4] = t[4] + n[4] * r, e12[5] = t[5] + n[5] * r, e12[6] = t[6] + n[6] * r, e12[7] = t[7] + n[7] * r, e12[8] = t[8] + n[8] * r, e12;
}
function exactEquals$4(e12, t) {
  return e12[0] === t[0] && e12[1] === t[1] && e12[2] === t[2] && e12[3] === t[3] && e12[4] === t[4] && e12[5] === t[5] && e12[6] === t[6] && e12[7] === t[7] && e12[8] === t[8];
}
function equals$5(e12, t) {
  var n = e12[0], r = e12[1], a = e12[2], o = e12[3], s = e12[4], c = e12[5], l = e12[6], u = e12[7], d = e12[8], f = t[0], p = t[1], m = t[2], h = t[3], g = t[4], _ = t[5], v = t[6], y = t[7], b = t[8];
  return Math.abs(n - f) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(f)) && Math.abs(r - p) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(p)) && Math.abs(a - m) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(m)) && Math.abs(o - h) <= 1e-6 * Math.max(1, Math.abs(o), Math.abs(h)) && Math.abs(s - g) <= 1e-6 * Math.max(1, Math.abs(s), Math.abs(g)) && Math.abs(c - _) <= 1e-6 * Math.max(1, Math.abs(c), Math.abs(_)) && Math.abs(l - v) <= 1e-6 * Math.max(1, Math.abs(l), Math.abs(v)) && Math.abs(u - y) <= 1e-6 * Math.max(1, Math.abs(u), Math.abs(y)) && Math.abs(d - b) <= 1e-6 * Math.max(1, Math.abs(d), Math.abs(b));
}
var mul$2 = multiply$3, sub$3 = subtract$5, mat4_exports = /* @__PURE__ */ __export({
  add: () => add$5,
  adjoint: () => adjoint,
  clone: () => clone$3,
  copy: () => copy$4,
  create: () => create$5,
  determinant: () => determinant,
  equals: () => equals$4,
  exactEquals: () => exactEquals$3,
  frob: () => frob,
  fromQuat: () => fromQuat,
  fromQuat2: () => fromQuat2,
  fromRotation: () => fromRotation,
  fromRotationTranslation: () => fromRotationTranslation,
  fromRotationTranslationScale: () => fromRotationTranslationScale,
  fromRotationTranslationScaleOrigin: () => fromRotationTranslationScaleOrigin,
  fromScaling: () => fromScaling,
  fromTranslation: () => fromTranslation,
  fromValues: () => fromValues$4,
  fromXRotation: () => fromXRotation,
  fromYRotation: () => fromYRotation,
  fromZRotation: () => fromZRotation,
  frustum: () => frustum,
  getRotation: () => getRotation,
  getScaling: () => getScaling,
  getTranslation: () => getTranslation,
  identity: () => identity$2,
  invert: () => invert,
  lookAt: () => lookAt,
  mul: () => mul$1,
  multiply: () => multiply$2,
  multiplyScalar: () => multiplyScalar$1,
  multiplyScalarAndAdd: () => multiplyScalarAndAdd,
  ortho: () => ortho,
  orthoNO: () => orthoNO,
  orthoZO: () => orthoZO,
  perspective: () => perspective,
  perspectiveFromFieldOfView: () => perspectiveFromFieldOfView,
  perspectiveNO: () => perspectiveNO,
  perspectiveZO: () => perspectiveZO,
  rotate: () => rotate,
  rotateX: () => rotateX,
  rotateY: () => rotateY,
  rotateZ: () => rotateZ,
  scale: () => scale$4,
  set: () => set$5,
  str: () => str,
  sub: () => sub$2,
  subtract: () => subtract$4,
  targetTo: () => targetTo,
  translate: () => translate,
  transpose: () => transpose
});
function create$5() {
  var e12 = new ARRAY_TYPE(16);
  return ARRAY_TYPE != Float32Array && (e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[6] = 0, e12[7] = 0, e12[8] = 0, e12[9] = 0, e12[11] = 0, e12[12] = 0, e12[13] = 0, e12[14] = 0), e12[0] = 1, e12[5] = 1, e12[10] = 1, e12[15] = 1, e12;
}
function clone$3(e12) {
  var t = new ARRAY_TYPE(16);
  return t[0] = e12[0], t[1] = e12[1], t[2] = e12[2], t[3] = e12[3], t[4] = e12[4], t[5] = e12[5], t[6] = e12[6], t[7] = e12[7], t[8] = e12[8], t[9] = e12[9], t[10] = e12[10], t[11] = e12[11], t[12] = e12[12], t[13] = e12[13], t[14] = e12[14], t[15] = e12[15], t;
}
function copy$4(e12, t) {
  return e12[0] = t[0], e12[1] = t[1], e12[2] = t[2], e12[3] = t[3], e12[4] = t[4], e12[5] = t[5], e12[6] = t[6], e12[7] = t[7], e12[8] = t[8], e12[9] = t[9], e12[10] = t[10], e12[11] = t[11], e12[12] = t[12], e12[13] = t[13], e12[14] = t[14], e12[15] = t[15], e12;
}
function fromValues$4(e12, t, n, r, a, o, s, c, l, u, d, f, p, m, h, g) {
  var _ = new ARRAY_TYPE(16);
  return _[0] = e12, _[1] = t, _[2] = n, _[3] = r, _[4] = a, _[5] = o, _[6] = s, _[7] = c, _[8] = l, _[9] = u, _[10] = d, _[11] = f, _[12] = p, _[13] = m, _[14] = h, _[15] = g, _;
}
function set$5(e12, t, n, r, a, o, s, c, l, u, d, f, p, m, h, g, _) {
  return e12[0] = t, e12[1] = n, e12[2] = r, e12[3] = a, e12[4] = o, e12[5] = s, e12[6] = c, e12[7] = l, e12[8] = u, e12[9] = d, e12[10] = f, e12[11] = p, e12[12] = m, e12[13] = h, e12[14] = g, e12[15] = _, e12;
}
function identity$2(e12) {
  return e12[0] = 1, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = 1, e12[6] = 0, e12[7] = 0, e12[8] = 0, e12[9] = 0, e12[10] = 1, e12[11] = 0, e12[12] = 0, e12[13] = 0, e12[14] = 0, e12[15] = 1, e12;
}
function transpose(e12, t) {
  if (e12 === t) {
    var n = t[1], r = t[2], a = t[3], o = t[6], s = t[7], c = t[11];
    e12[1] = t[4], e12[2] = t[8], e12[3] = t[12], e12[4] = n, e12[6] = t[9], e12[7] = t[13], e12[8] = r, e12[9] = o, e12[11] = t[14], e12[12] = a, e12[13] = s, e12[14] = c;
  } else
    e12[0] = t[0], e12[1] = t[4], e12[2] = t[8], e12[3] = t[12], e12[4] = t[1], e12[5] = t[5], e12[6] = t[9], e12[7] = t[13], e12[8] = t[2], e12[9] = t[6], e12[10] = t[10], e12[11] = t[14], e12[12] = t[3], e12[13] = t[7], e12[14] = t[11], e12[15] = t[15];
  return e12;
}
function invert(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8], f = t[9], p = t[10], m = t[11], h = t[12], g = t[13], _ = t[14], v = t[15], y = n * c - r * s, b = n * l - a * s, S = n * u - o * s, C = r * l - a * c, w = r * u - o * c, T = a * u - o * l, E = d * g - f * h, D = d * _ - p * h, O = d * v - m * h, k = f * _ - p * g, A = f * v - m * g, j = p * v - m * _, M = y * j - b * A + S * k + C * O - w * D + T * E;
  return M ? (M = 1 / M, e12[0] = (c * j - l * A + u * k) * M, e12[1] = (a * A - r * j - o * k) * M, e12[2] = (g * T - _ * w + v * C) * M, e12[3] = (p * w - f * T - m * C) * M, e12[4] = (l * O - s * j - u * D) * M, e12[5] = (n * j - a * O + o * D) * M, e12[6] = (_ * S - h * T - v * b) * M, e12[7] = (d * T - p * S + m * b) * M, e12[8] = (s * A - c * O + u * E) * M, e12[9] = (r * O - n * A - o * E) * M, e12[10] = (h * w - g * S + v * y) * M, e12[11] = (f * S - d * w - m * y) * M, e12[12] = (c * D - s * k - l * E) * M, e12[13] = (n * k - r * D + a * E) * M, e12[14] = (g * b - h * C - _ * y) * M, e12[15] = (d * C - f * b + p * y) * M, e12) : null;
}
function adjoint(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = t[3], s = t[4], c = t[5], l = t[6], u = t[7], d = t[8], f = t[9], p = t[10], m = t[11], h = t[12], g = t[13], _ = t[14], v = t[15];
  return e12[0] = c * (p * v - m * _) - f * (l * v - u * _) + g * (l * m - u * p), e12[1] = -(r * (p * v - m * _) - f * (a * v - o * _) + g * (a * m - o * p)), e12[2] = r * (l * v - u * _) - c * (a * v - o * _) + g * (a * u - o * l), e12[3] = -(r * (l * m - u * p) - c * (a * m - o * p) + f * (a * u - o * l)), e12[4] = -(s * (p * v - m * _) - d * (l * v - u * _) + h * (l * m - u * p)), e12[5] = n * (p * v - m * _) - d * (a * v - o * _) + h * (a * m - o * p), e12[6] = -(n * (l * v - u * _) - s * (a * v - o * _) + h * (a * u - o * l)), e12[7] = n * (l * m - u * p) - s * (a * m - o * p) + d * (a * u - o * l), e12[8] = s * (f * v - m * g) - d * (c * v - u * g) + h * (c * m - u * f), e12[9] = -(n * (f * v - m * g) - d * (r * v - o * g) + h * (r * m - o * f)), e12[10] = n * (c * v - u * g) - s * (r * v - o * g) + h * (r * u - o * c), e12[11] = -(n * (c * m - u * f) - s * (r * m - o * f) + d * (r * u - o * c)), e12[12] = -(s * (f * _ - p * g) - d * (c * _ - l * g) + h * (c * p - l * f)), e12[13] = n * (f * _ - p * g) - d * (r * _ - a * g) + h * (r * p - a * f), e12[14] = -(n * (c * _ - l * g) - s * (r * _ - a * g) + h * (r * l - a * c)), e12[15] = n * (c * p - l * f) - s * (r * p - a * f) + d * (r * l - a * c), e12;
}
function determinant(e12) {
  var t = e12[0], n = e12[1], r = e12[2], a = e12[3], o = e12[4], s = e12[5], c = e12[6], l = e12[7], u = e12[8], d = e12[9], f = e12[10], p = e12[11], m = e12[12], h = e12[13], g = e12[14], _ = e12[15], v = t * s - n * o, y = t * c - r * o, b = t * l - a * o, S = n * c - r * s, C = n * l - a * s, w = r * l - a * c, T = u * h - d * m, E = u * g - f * m, D = u * _ - p * m, O = d * g - f * h, k = d * _ - p * h;
  return v * (f * _ - p * g) - y * k + b * O + S * D - C * E + w * T;
}
function multiply$2(e12, t, n) {
  var r = t[0], a = t[1], o = t[2], s = t[3], c = t[4], l = t[5], u = t[6], d = t[7], f = t[8], p = t[9], m = t[10], h = t[11], g = t[12], _ = t[13], v = t[14], y = t[15], b = n[0], S = n[1], C = n[2], w = n[3];
  return e12[0] = b * r + S * c + C * f + w * g, e12[1] = b * a + S * l + C * p + w * _, e12[2] = b * o + S * u + C * m + w * v, e12[3] = b * s + S * d + C * h + w * y, b = n[4], S = n[5], C = n[6], w = n[7], e12[4] = b * r + S * c + C * f + w * g, e12[5] = b * a + S * l + C * p + w * _, e12[6] = b * o + S * u + C * m + w * v, e12[7] = b * s + S * d + C * h + w * y, b = n[8], S = n[9], C = n[10], w = n[11], e12[8] = b * r + S * c + C * f + w * g, e12[9] = b * a + S * l + C * p + w * _, e12[10] = b * o + S * u + C * m + w * v, e12[11] = b * s + S * d + C * h + w * y, b = n[12], S = n[13], C = n[14], w = n[15], e12[12] = b * r + S * c + C * f + w * g, e12[13] = b * a + S * l + C * p + w * _, e12[14] = b * o + S * u + C * m + w * v, e12[15] = b * s + S * d + C * h + w * y, e12;
}
function translate(e12, t, n) {
  var r = n[0], a = n[1], o = n[2], s, c, l, u, d, f, p, m, h, g, _, v;
  return t === e12 ? (e12[12] = t[0] * r + t[4] * a + t[8] * o + t[12], e12[13] = t[1] * r + t[5] * a + t[9] * o + t[13], e12[14] = t[2] * r + t[6] * a + t[10] * o + t[14], e12[15] = t[3] * r + t[7] * a + t[11] * o + t[15]) : (s = t[0], c = t[1], l = t[2], u = t[3], d = t[4], f = t[5], p = t[6], m = t[7], h = t[8], g = t[9], _ = t[10], v = t[11], e12[0] = s, e12[1] = c, e12[2] = l, e12[3] = u, e12[4] = d, e12[5] = f, e12[6] = p, e12[7] = m, e12[8] = h, e12[9] = g, e12[10] = _, e12[11] = v, e12[12] = s * r + d * a + h * o + t[12], e12[13] = c * r + f * a + g * o + t[13], e12[14] = l * r + p * a + _ * o + t[14], e12[15] = u * r + m * a + v * o + t[15]), e12;
}
function scale$4(e12, t, n) {
  var r = n[0], a = n[1], o = n[2];
  return e12[0] = t[0] * r, e12[1] = t[1] * r, e12[2] = t[2] * r, e12[3] = t[3] * r, e12[4] = t[4] * a, e12[5] = t[5] * a, e12[6] = t[6] * a, e12[7] = t[7] * a, e12[8] = t[8] * o, e12[9] = t[9] * o, e12[10] = t[10] * o, e12[11] = t[11] * o, e12[12] = t[12], e12[13] = t[13], e12[14] = t[14], e12[15] = t[15], e12;
}
function rotate(e12, t, n, r) {
  var a = r[0], o = r[1], s = r[2], c = Math.hypot(a, o, s), l, u, d, f, p, m, h, g, _, v, y, b, S, C, w, T, E, D, O, k, A, j, M, N;
  return c < 1e-6 ? null : (c = 1 / c, a *= c, o *= c, s *= c, l = Math.sin(n), u = Math.cos(n), d = 1 - u, f = t[0], p = t[1], m = t[2], h = t[3], g = t[4], _ = t[5], v = t[6], y = t[7], b = t[8], S = t[9], C = t[10], w = t[11], T = a * a * d + u, E = o * a * d + s * l, D = s * a * d - o * l, O = a * o * d - s * l, k = o * o * d + u, A = s * o * d + a * l, j = a * s * d + o * l, M = o * s * d - a * l, N = s * s * d + u, e12[0] = f * T + g * E + b * D, e12[1] = p * T + _ * E + S * D, e12[2] = m * T + v * E + C * D, e12[3] = h * T + y * E + w * D, e12[4] = f * O + g * k + b * A, e12[5] = p * O + _ * k + S * A, e12[6] = m * O + v * k + C * A, e12[7] = h * O + y * k + w * A, e12[8] = f * j + g * M + b * N, e12[9] = p * j + _ * M + S * N, e12[10] = m * j + v * M + C * N, e12[11] = h * j + y * M + w * N, t !== e12 && (e12[12] = t[12], e12[13] = t[13], e12[14] = t[14], e12[15] = t[15]), e12);
}
function rotateX(e12, t, n) {
  var r = Math.sin(n), a = Math.cos(n), o = t[4], s = t[5], c = t[6], l = t[7], u = t[8], d = t[9], f = t[10], p = t[11];
  return t !== e12 && (e12[0] = t[0], e12[1] = t[1], e12[2] = t[2], e12[3] = t[3], e12[12] = t[12], e12[13] = t[13], e12[14] = t[14], e12[15] = t[15]), e12[4] = o * a + u * r, e12[5] = s * a + d * r, e12[6] = c * a + f * r, e12[7] = l * a + p * r, e12[8] = u * a - o * r, e12[9] = d * a - s * r, e12[10] = f * a - c * r, e12[11] = p * a - l * r, e12;
}
function rotateY(e12, t, n) {
  var r = Math.sin(n), a = Math.cos(n), o = t[0], s = t[1], c = t[2], l = t[3], u = t[8], d = t[9], f = t[10], p = t[11];
  return t !== e12 && (e12[4] = t[4], e12[5] = t[5], e12[6] = t[6], e12[7] = t[7], e12[12] = t[12], e12[13] = t[13], e12[14] = t[14], e12[15] = t[15]), e12[0] = o * a - u * r, e12[1] = s * a - d * r, e12[2] = c * a - f * r, e12[3] = l * a - p * r, e12[8] = o * r + u * a, e12[9] = s * r + d * a, e12[10] = c * r + f * a, e12[11] = l * r + p * a, e12;
}
function rotateZ(e12, t, n) {
  var r = Math.sin(n), a = Math.cos(n), o = t[0], s = t[1], c = t[2], l = t[3], u = t[4], d = t[5], f = t[6], p = t[7];
  return t !== e12 && (e12[8] = t[8], e12[9] = t[9], e12[10] = t[10], e12[11] = t[11], e12[12] = t[12], e12[13] = t[13], e12[14] = t[14], e12[15] = t[15]), e12[0] = o * a + u * r, e12[1] = s * a + d * r, e12[2] = c * a + f * r, e12[3] = l * a + p * r, e12[4] = u * a - o * r, e12[5] = d * a - s * r, e12[6] = f * a - c * r, e12[7] = p * a - l * r, e12;
}
function fromTranslation(e12, t) {
  return e12[0] = 1, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = 1, e12[6] = 0, e12[7] = 0, e12[8] = 0, e12[9] = 0, e12[10] = 1, e12[11] = 0, e12[12] = t[0], e12[13] = t[1], e12[14] = t[2], e12[15] = 1, e12;
}
function fromScaling(e12, t) {
  return e12[0] = t[0], e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = t[1], e12[6] = 0, e12[7] = 0, e12[8] = 0, e12[9] = 0, e12[10] = t[2], e12[11] = 0, e12[12] = 0, e12[13] = 0, e12[14] = 0, e12[15] = 1, e12;
}
function fromRotation(e12, t, n) {
  var r = n[0], a = n[1], o = n[2], s = Math.hypot(r, a, o), c, l, u;
  return s < 1e-6 ? null : (s = 1 / s, r *= s, a *= s, o *= s, c = Math.sin(t), l = Math.cos(t), u = 1 - l, e12[0] = r * r * u + l, e12[1] = a * r * u + o * c, e12[2] = o * r * u - a * c, e12[3] = 0, e12[4] = r * a * u - o * c, e12[5] = a * a * u + l, e12[6] = o * a * u + r * c, e12[7] = 0, e12[8] = r * o * u + a * c, e12[9] = a * o * u - r * c, e12[10] = o * o * u + l, e12[11] = 0, e12[12] = 0, e12[13] = 0, e12[14] = 0, e12[15] = 1, e12);
}
function fromXRotation(e12, t) {
  var n = Math.sin(t), r = Math.cos(t);
  return e12[0] = 1, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = r, e12[6] = n, e12[7] = 0, e12[8] = 0, e12[9] = -n, e12[10] = r, e12[11] = 0, e12[12] = 0, e12[13] = 0, e12[14] = 0, e12[15] = 1, e12;
}
function fromYRotation(e12, t) {
  var n = Math.sin(t), r = Math.cos(t);
  return e12[0] = r, e12[1] = 0, e12[2] = -n, e12[3] = 0, e12[4] = 0, e12[5] = 1, e12[6] = 0, e12[7] = 0, e12[8] = n, e12[9] = 0, e12[10] = r, e12[11] = 0, e12[12] = 0, e12[13] = 0, e12[14] = 0, e12[15] = 1, e12;
}
function fromZRotation(e12, t) {
  var n = Math.sin(t), r = Math.cos(t);
  return e12[0] = r, e12[1] = n, e12[2] = 0, e12[3] = 0, e12[4] = -n, e12[5] = r, e12[6] = 0, e12[7] = 0, e12[8] = 0, e12[9] = 0, e12[10] = 1, e12[11] = 0, e12[12] = 0, e12[13] = 0, e12[14] = 0, e12[15] = 1, e12;
}
function fromRotationTranslation(e12, t, n) {
  var r = t[0], a = t[1], o = t[2], s = t[3], c = r + r, l = a + a, u = o + o, d = r * c, f = r * l, p = r * u, m = a * l, h = a * u, g = o * u, _ = s * c, v = s * l, y = s * u;
  return e12[0] = 1 - (m + g), e12[1] = f + y, e12[2] = p - v, e12[3] = 0, e12[4] = f - y, e12[5] = 1 - (d + g), e12[6] = h + _, e12[7] = 0, e12[8] = p + v, e12[9] = h - _, e12[10] = 1 - (d + m), e12[11] = 0, e12[12] = n[0], e12[13] = n[1], e12[14] = n[2], e12[15] = 1, e12;
}
function fromQuat2(e12, t) {
  var n = new ARRAY_TYPE(3), r = -t[0], a = -t[1], o = -t[2], s = t[3], c = t[4], l = t[5], u = t[6], d = t[7], f = r * r + a * a + o * o + s * s;
  return f > 0 ? (n[0] = (c * s + d * r + l * o - u * a) * 2 / f, n[1] = (l * s + d * a + u * r - c * o) * 2 / f, n[2] = (u * s + d * o + c * a - l * r) * 2 / f) : (n[0] = (c * s + d * r + l * o - u * a) * 2, n[1] = (l * s + d * a + u * r - c * o) * 2, n[2] = (u * s + d * o + c * a - l * r) * 2), fromRotationTranslation(e12, t, n), e12;
}
function getTranslation(e12, t) {
  return e12[0] = t[12], e12[1] = t[13], e12[2] = t[14], e12;
}
function getScaling(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = t[4], s = t[5], c = t[6], l = t[8], u = t[9], d = t[10];
  return e12[0] = Math.hypot(n, r, a), e12[1] = Math.hypot(o, s, c), e12[2] = Math.hypot(l, u, d), e12;
}
function getRotation(e12, t) {
  var n = new ARRAY_TYPE(3);
  getScaling(n, t);
  var r = 1 / n[0], a = 1 / n[1], o = 1 / n[2], s = t[0] * r, c = t[1] * a, l = t[2] * o, u = t[4] * r, d = t[5] * a, f = t[6] * o, p = t[8] * r, m = t[9] * a, h = t[10] * o, g = s + d + h, _ = 0;
  return g > 0 ? (_ = Math.sqrt(g + 1) * 2, e12[3] = 0.25 * _, e12[0] = (f - m) / _, e12[1] = (p - l) / _, e12[2] = (c - u) / _) : s > d && s > h ? (_ = Math.sqrt(1 + s - d - h) * 2, e12[3] = (f - m) / _, e12[0] = 0.25 * _, e12[1] = (c + u) / _, e12[2] = (p + l) / _) : d > h ? (_ = Math.sqrt(1 + d - s - h) * 2, e12[3] = (p - l) / _, e12[0] = (c + u) / _, e12[1] = 0.25 * _, e12[2] = (f + m) / _) : (_ = Math.sqrt(1 + h - s - d) * 2, e12[3] = (c - u) / _, e12[0] = (p + l) / _, e12[1] = (f + m) / _, e12[2] = 0.25 * _), e12;
}
function fromRotationTranslationScale(e12, t, n, r) {
  var a = t[0], o = t[1], s = t[2], c = t[3], l = a + a, u = o + o, d = s + s, f = a * l, p = a * u, m = a * d, h = o * u, g = o * d, _ = s * d, v = c * l, y = c * u, b = c * d, S = r[0], C = r[1], w = r[2];
  return e12[0] = (1 - (h + _)) * S, e12[1] = (p + b) * S, e12[2] = (m - y) * S, e12[3] = 0, e12[4] = (p - b) * C, e12[5] = (1 - (f + _)) * C, e12[6] = (g + v) * C, e12[7] = 0, e12[8] = (m + y) * w, e12[9] = (g - v) * w, e12[10] = (1 - (f + h)) * w, e12[11] = 0, e12[12] = n[0], e12[13] = n[1], e12[14] = n[2], e12[15] = 1, e12;
}
function fromRotationTranslationScaleOrigin(e12, t, n, r, a) {
  var o = t[0], s = t[1], c = t[2], l = t[3], u = o + o, d = s + s, f = c + c, p = o * u, m = o * d, h = o * f, g = s * d, _ = s * f, v = c * f, y = l * u, b = l * d, S = l * f, C = r[0], w = r[1], T = r[2], E = a[0], D = a[1], O = a[2], k = (1 - (g + v)) * C, A = (m + S) * C, j = (h - b) * C, M = (m - S) * w, N = (1 - (p + v)) * w, P = (_ + y) * w, F = (h + b) * T, I = (_ - y) * T, L = (1 - (p + g)) * T;
  return e12[0] = k, e12[1] = A, e12[2] = j, e12[3] = 0, e12[4] = M, e12[5] = N, e12[6] = P, e12[7] = 0, e12[8] = F, e12[9] = I, e12[10] = L, e12[11] = 0, e12[12] = n[0] + E - (k * E + M * D + F * O), e12[13] = n[1] + D - (A * E + N * D + I * O), e12[14] = n[2] + O - (j * E + P * D + L * O), e12[15] = 1, e12;
}
function fromQuat(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = t[3], s = n + n, c = r + r, l = a + a, u = n * s, d = r * s, f = r * c, p = a * s, m = a * c, h = a * l, g = o * s, _ = o * c, v = o * l;
  return e12[0] = 1 - f - h, e12[1] = d + v, e12[2] = p - _, e12[3] = 0, e12[4] = d - v, e12[5] = 1 - u - h, e12[6] = m + g, e12[7] = 0, e12[8] = p + _, e12[9] = m - g, e12[10] = 1 - u - f, e12[11] = 0, e12[12] = 0, e12[13] = 0, e12[14] = 0, e12[15] = 1, e12;
}
function frustum(e12, t, n, r, a, o, s) {
  var c = 1 / (n - t), l = 1 / (a - r), u = 1 / (o - s);
  return e12[0] = o * 2 * c, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = o * 2 * l, e12[6] = 0, e12[7] = 0, e12[8] = (n + t) * c, e12[9] = (a + r) * l, e12[10] = (s + o) * u, e12[11] = -1, e12[12] = 0, e12[13] = 0, e12[14] = s * o * 2 * u, e12[15] = 0, e12;
}
function perspectiveNO(e12, t, n, r, a) {
  var o = 1 / Math.tan(t / 2), s;
  return e12[0] = o / n, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = o, e12[6] = 0, e12[7] = 0, e12[8] = 0, e12[9] = 0, e12[11] = -1, e12[12] = 0, e12[13] = 0, e12[15] = 0, a != null && a !== Infinity ? (s = 1 / (r - a), e12[10] = (a + r) * s, e12[14] = 2 * a * r * s) : (e12[10] = -1, e12[14] = -2 * r), e12;
}
var perspective = perspectiveNO;
function perspectiveZO(e12, t, n, r, a) {
  var o = 1 / Math.tan(t / 2), s;
  return e12[0] = o / n, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = o, e12[6] = 0, e12[7] = 0, e12[8] = 0, e12[9] = 0, e12[11] = -1, e12[12] = 0, e12[13] = 0, e12[15] = 0, a != null && a !== Infinity ? (s = 1 / (r - a), e12[10] = a * s, e12[14] = a * r * s) : (e12[10] = -1, e12[14] = -r), e12;
}
function perspectiveFromFieldOfView(e12, t, n, r) {
  var a = Math.tan(t.upDegrees * Math.PI / 180), o = Math.tan(t.downDegrees * Math.PI / 180), s = Math.tan(t.leftDegrees * Math.PI / 180), c = Math.tan(t.rightDegrees * Math.PI / 180), l = 2 / (s + c), u = 2 / (a + o);
  return e12[0] = l, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = u, e12[6] = 0, e12[7] = 0, e12[8] = -((s - c) * l * 0.5), e12[9] = (a - o) * u * 0.5, e12[10] = r / (n - r), e12[11] = -1, e12[12] = 0, e12[13] = 0, e12[14] = r * n / (n - r), e12[15] = 0, e12;
}
function orthoNO(e12, t, n, r, a, o, s) {
  var c = 1 / (t - n), l = 1 / (r - a), u = 1 / (o - s);
  return e12[0] = -2 * c, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = -2 * l, e12[6] = 0, e12[7] = 0, e12[8] = 0, e12[9] = 0, e12[10] = 2 * u, e12[11] = 0, e12[12] = (t + n) * c, e12[13] = (a + r) * l, e12[14] = (s + o) * u, e12[15] = 1, e12;
}
var ortho = orthoNO;
function orthoZO(e12, t, n, r, a, o, s) {
  var c = 1 / (t - n), l = 1 / (r - a), u = 1 / (o - s);
  return e12[0] = -2 * c, e12[1] = 0, e12[2] = 0, e12[3] = 0, e12[4] = 0, e12[5] = -2 * l, e12[6] = 0, e12[7] = 0, e12[8] = 0, e12[9] = 0, e12[10] = u, e12[11] = 0, e12[12] = (t + n) * c, e12[13] = (a + r) * l, e12[14] = o * u, e12[15] = 1, e12;
}
function lookAt(e12, t, n, r) {
  var a, o, s, c, l, u, d, f, p, m, h = t[0], g = t[1], _ = t[2], v = r[0], y = r[1], b = r[2], S = n[0], C = n[1], w = n[2];
  return Math.abs(h - S) < 1e-6 && Math.abs(g - C) < 1e-6 && Math.abs(_ - w) < 1e-6 ? identity$2(e12) : (d = h - S, f = g - C, p = _ - w, m = 1 / Math.hypot(d, f, p), d *= m, f *= m, p *= m, a = y * p - b * f, o = b * d - v * p, s = v * f - y * d, m = Math.hypot(a, o, s), m ? (m = 1 / m, a *= m, o *= m, s *= m) : (a = 0, o = 0, s = 0), c = f * s - p * o, l = p * a - d * s, u = d * o - f * a, m = Math.hypot(c, l, u), m ? (m = 1 / m, c *= m, l *= m, u *= m) : (c = 0, l = 0, u = 0), e12[0] = a, e12[1] = c, e12[2] = d, e12[3] = 0, e12[4] = o, e12[5] = l, e12[6] = f, e12[7] = 0, e12[8] = s, e12[9] = u, e12[10] = p, e12[11] = 0, e12[12] = -(a * h + o * g + s * _), e12[13] = -(c * h + l * g + u * _), e12[14] = -(d * h + f * g + p * _), e12[15] = 1, e12);
}
function targetTo(e12, t, n, r) {
  var a = t[0], o = t[1], s = t[2], c = r[0], l = r[1], u = r[2], d = a - n[0], f = o - n[1], p = s - n[2], m = d * d + f * f + p * p;
  m > 0 && (m = 1 / Math.sqrt(m), d *= m, f *= m, p *= m);
  var h = l * p - u * f, g = u * d - c * p, _ = c * f - l * d;
  return m = h * h + g * g + _ * _, m > 0 && (m = 1 / Math.sqrt(m), h *= m, g *= m, _ *= m), e12[0] = h, e12[1] = g, e12[2] = _, e12[3] = 0, e12[4] = f * _ - p * g, e12[5] = p * h - d * _, e12[6] = d * g - f * h, e12[7] = 0, e12[8] = d, e12[9] = f, e12[10] = p, e12[11] = 0, e12[12] = a, e12[13] = o, e12[14] = s, e12[15] = 1, e12;
}
function str(e12) {
  return "mat4(" + e12[0] + ", " + e12[1] + ", " + e12[2] + ", " + e12[3] + ", " + e12[4] + ", " + e12[5] + ", " + e12[6] + ", " + e12[7] + ", " + e12[8] + ", " + e12[9] + ", " + e12[10] + ", " + e12[11] + ", " + e12[12] + ", " + e12[13] + ", " + e12[14] + ", " + e12[15] + ")";
}
function frob(e12) {
  return Math.hypot(e12[0], e12[1], e12[2], e12[3], e12[4], e12[5], e12[6], e12[7], e12[8], e12[9], e12[10], e12[11], e12[12], e12[13], e12[14], e12[15]);
}
function add$5(e12, t, n) {
  return e12[0] = t[0] + n[0], e12[1] = t[1] + n[1], e12[2] = t[2] + n[2], e12[3] = t[3] + n[3], e12[4] = t[4] + n[4], e12[5] = t[5] + n[5], e12[6] = t[6] + n[6], e12[7] = t[7] + n[7], e12[8] = t[8] + n[8], e12[9] = t[9] + n[9], e12[10] = t[10] + n[10], e12[11] = t[11] + n[11], e12[12] = t[12] + n[12], e12[13] = t[13] + n[13], e12[14] = t[14] + n[14], e12[15] = t[15] + n[15], e12;
}
function subtract$4(e12, t, n) {
  return e12[0] = t[0] - n[0], e12[1] = t[1] - n[1], e12[2] = t[2] - n[2], e12[3] = t[3] - n[3], e12[4] = t[4] - n[4], e12[5] = t[5] - n[5], e12[6] = t[6] - n[6], e12[7] = t[7] - n[7], e12[8] = t[8] - n[8], e12[9] = t[9] - n[9], e12[10] = t[10] - n[10], e12[11] = t[11] - n[11], e12[12] = t[12] - n[12], e12[13] = t[13] - n[13], e12[14] = t[14] - n[14], e12[15] = t[15] - n[15], e12;
}
function multiplyScalar$1(e12, t, n) {
  return e12[0] = t[0] * n, e12[1] = t[1] * n, e12[2] = t[2] * n, e12[3] = t[3] * n, e12[4] = t[4] * n, e12[5] = t[5] * n, e12[6] = t[6] * n, e12[7] = t[7] * n, e12[8] = t[8] * n, e12[9] = t[9] * n, e12[10] = t[10] * n, e12[11] = t[11] * n, e12[12] = t[12] * n, e12[13] = t[13] * n, e12[14] = t[14] * n, e12[15] = t[15] * n, e12;
}
function multiplyScalarAndAdd(e12, t, n, r) {
  return e12[0] = t[0] + n[0] * r, e12[1] = t[1] + n[1] * r, e12[2] = t[2] + n[2] * r, e12[3] = t[3] + n[3] * r, e12[4] = t[4] + n[4] * r, e12[5] = t[5] + n[5] * r, e12[6] = t[6] + n[6] * r, e12[7] = t[7] + n[7] * r, e12[8] = t[8] + n[8] * r, e12[9] = t[9] + n[9] * r, e12[10] = t[10] + n[10] * r, e12[11] = t[11] + n[11] * r, e12[12] = t[12] + n[12] * r, e12[13] = t[13] + n[13] * r, e12[14] = t[14] + n[14] * r, e12[15] = t[15] + n[15] * r, e12;
}
function exactEquals$3(e12, t) {
  return e12[0] === t[0] && e12[1] === t[1] && e12[2] === t[2] && e12[3] === t[3] && e12[4] === t[4] && e12[5] === t[5] && e12[6] === t[6] && e12[7] === t[7] && e12[8] === t[8] && e12[9] === t[9] && e12[10] === t[10] && e12[11] === t[11] && e12[12] === t[12] && e12[13] === t[13] && e12[14] === t[14] && e12[15] === t[15];
}
function equals$4(e12, t) {
  var n = e12[0], r = e12[1], a = e12[2], o = e12[3], s = e12[4], c = e12[5], l = e12[6], u = e12[7], d = e12[8], f = e12[9], p = e12[10], m = e12[11], h = e12[12], g = e12[13], _ = e12[14], v = e12[15], y = t[0], b = t[1], S = t[2], C = t[3], w = t[4], T = t[5], E = t[6], D = t[7], O = t[8], k = t[9], A = t[10], j = t[11], M = t[12], N = t[13], P = t[14], F = t[15];
  return Math.abs(n - y) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(y)) && Math.abs(r - b) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(b)) && Math.abs(a - S) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(S)) && Math.abs(o - C) <= 1e-6 * Math.max(1, Math.abs(o), Math.abs(C)) && Math.abs(s - w) <= 1e-6 * Math.max(1, Math.abs(s), Math.abs(w)) && Math.abs(c - T) <= 1e-6 * Math.max(1, Math.abs(c), Math.abs(T)) && Math.abs(l - E) <= 1e-6 * Math.max(1, Math.abs(l), Math.abs(E)) && Math.abs(u - D) <= 1e-6 * Math.max(1, Math.abs(u), Math.abs(D)) && Math.abs(d - O) <= 1e-6 * Math.max(1, Math.abs(d), Math.abs(O)) && Math.abs(f - k) <= 1e-6 * Math.max(1, Math.abs(f), Math.abs(k)) && Math.abs(p - A) <= 1e-6 * Math.max(1, Math.abs(p), Math.abs(A)) && Math.abs(m - j) <= 1e-6 * Math.max(1, Math.abs(m), Math.abs(j)) && Math.abs(h - M) <= 1e-6 * Math.max(1, Math.abs(h), Math.abs(M)) && Math.abs(g - N) <= 1e-6 * Math.max(1, Math.abs(g), Math.abs(N)) && Math.abs(_ - P) <= 1e-6 * Math.max(1, Math.abs(_), Math.abs(P)) && Math.abs(v - F) <= 1e-6 * Math.max(1, Math.abs(v), Math.abs(F));
}
var mul$1 = multiply$2, sub$2 = subtract$4;
function create$4() {
  var e12 = new ARRAY_TYPE(3);
  return ARRAY_TYPE != Float32Array && (e12[0] = 0, e12[1] = 0, e12[2] = 0), e12;
}
function clone$2(e12) {
  var t = new ARRAY_TYPE(3);
  return t[0] = e12[0], t[1] = e12[1], t[2] = e12[2], t;
}
function length$2(e12) {
  var t = e12[0], n = e12[1], r = e12[2];
  return Math.hypot(t, n, r);
}
function fromValues$3(e12, t, n) {
  var r = new ARRAY_TYPE(3);
  return r[0] = e12, r[1] = t, r[2] = n, r;
}
function copy$3(e12, t) {
  return e12[0] = t[0], e12[1] = t[1], e12[2] = t[2], e12;
}
function set$4(e12, t, n, r) {
  return e12[0] = t, e12[1] = n, e12[2] = r, e12;
}
function add$4(e12, t, n) {
  return e12[0] = t[0] + n[0], e12[1] = t[1] + n[1], e12[2] = t[2] + n[2], e12;
}
function subtract$3(e12, t, n) {
  return e12[0] = t[0] - n[0], e12[1] = t[1] - n[1], e12[2] = t[2] - n[2], e12;
}
function multiply$1(e12, t, n) {
  return e12[0] = t[0] * n[0], e12[1] = t[1] * n[1], e12[2] = t[2] * n[2], e12;
}
function scale$3(e12, t, n) {
  return e12[0] = t[0] * n, e12[1] = t[1] * n, e12[2] = t[2] * n, e12;
}
function scaleAndAdd(e12, t, n, r) {
  return e12[0] = t[0] + n[0] * r, e12[1] = t[1] + n[1] * r, e12[2] = t[2] + n[2] * r, e12;
}
function distance(e12, t) {
  var n = t[0] - e12[0], r = t[1] - e12[1], a = t[2] - e12[2];
  return Math.hypot(n, r, a);
}
function negate(e12, t) {
  return e12[0] = -t[0], e12[1] = -t[1], e12[2] = -t[2], e12;
}
function inverse(e12, t) {
  return e12[0] = 1 / t[0], e12[1] = 1 / t[1], e12[2] = 1 / t[2], e12;
}
function normalize$4(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = n * n + r * r + a * a;
  return o > 0 && (o = 1 / Math.sqrt(o)), e12[0] = t[0] * o, e12[1] = t[1] * o, e12[2] = t[2] * o, e12;
}
function dot$3(e12, t) {
  return e12[0] * t[0] + e12[1] * t[1] + e12[2] * t[2];
}
function cross$1(e12, t, n) {
  var r = t[0], a = t[1], o = t[2], s = n[0], c = n[1], l = n[2];
  return e12[0] = a * l - o * c, e12[1] = o * s - r * l, e12[2] = r * c - a * s, e12;
}
function lerp$2(e12, t, n, r) {
  var a = t[0], o = t[1], s = t[2];
  return e12[0] = a + r * (n[0] - a), e12[1] = o + r * (n[1] - o), e12[2] = s + r * (n[2] - s), e12;
}
function transformMat4$1(e12, t, n) {
  var r = t[0], a = t[1], o = t[2], s = n[3] * r + n[7] * a + n[11] * o + n[15];
  return s ||= 1, e12[0] = (n[0] * r + n[4] * a + n[8] * o + n[12]) / s, e12[1] = (n[1] * r + n[5] * a + n[9] * o + n[13]) / s, e12[2] = (n[2] * r + n[6] * a + n[10] * o + n[14]) / s, e12;
}
function transformMat3(e12, t, n) {
  var r = t[0], a = t[1], o = t[2];
  return e12[0] = r * n[0] + a * n[3] + o * n[6], e12[1] = r * n[1] + a * n[4] + o * n[7], e12[2] = r * n[2] + a * n[5] + o * n[8], e12;
}
function angle(e12, t) {
  var n = e12[0], r = e12[1], a = e12[2], o = t[0], s = t[1], c = t[2], l = Math.sqrt(n * n + r * r + a * a) * Math.sqrt(o * o + s * s + c * c), u = l && dot$3(e12, t) / l;
  return Math.acos(Math.min(Math.max(u, -1), 1));
}
function zero$2(e12) {
  return e12[0] = 0, e12[1] = 0, e12[2] = 0, e12;
}
function exactEquals$2(e12, t) {
  return e12[0] === t[0] && e12[1] === t[1] && e12[2] === t[2];
}
function equals$3(e12, t) {
  var n = e12[0], r = e12[1], a = e12[2], o = t[0], s = t[1], c = t[2];
  return Math.abs(n - o) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(r - s) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(a - c) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(c));
}
var sub$1 = subtract$3, mul = multiply$1, dist = distance, len = length$2;
(function() {
  var e12 = create$4();
  return function(t, n, r, a, o, s) {
    var c, l;
    for (n ||= 3, r ||= 0, l = a ? Math.min(a * n + r, t.length) : t.length, c = r; c < l; c += n)
      e12[0] = t[c], e12[1] = t[c + 1], e12[2] = t[c + 2], o(e12, e12, s), t[c] = e12[0], t[c + 1] = e12[1], t[c + 2] = e12[2];
    return t;
  };
})();
function create$3() {
  var e12 = new ARRAY_TYPE(4);
  return ARRAY_TYPE != Float32Array && (e12[0] = 0, e12[1] = 0, e12[2] = 0, e12[3] = 0), e12;
}
function fromValues$2(e12, t, n, r) {
  var a = new ARRAY_TYPE(4);
  return a[0] = e12, a[1] = t, a[2] = n, a[3] = r, a;
}
function subtract$2(e12, t, n) {
  return e12[0] = t[0] - n[0], e12[1] = t[1] - n[1], e12[2] = t[2] - n[2], e12[3] = t[3] - n[3], e12;
}
function normalize$3(e12, t) {
  var n = t[0], r = t[1], a = t[2], o = t[3], s = n * n + r * r + a * a + o * o;
  return s > 0 && (s = 1 / Math.sqrt(s)), e12[0] = n * s, e12[1] = r * s, e12[2] = a * s, e12[3] = o * s, e12;
}
function transformMat4(e12, t, n) {
  var r = t[0], a = t[1], o = t[2], s = t[3];
  return e12[0] = n[0] * r + n[4] * a + n[8] * o + n[12] * s, e12[1] = n[1] * r + n[5] * a + n[9] * o + n[13] * s, e12[2] = n[2] * r + n[6] * a + n[10] * o + n[14] * s, e12[3] = n[3] * r + n[7] * a + n[11] * o + n[15] * s, e12;
}
(function() {
  var e12 = create$3();
  return function(t, n, r, a, o, s) {
    var c, l;
    for (n ||= 4, r ||= 0, l = a ? Math.min(a * n + r, t.length) : t.length, c = r; c < l; c += n)
      e12[0] = t[c], e12[1] = t[c + 1], e12[2] = t[c + 2], e12[3] = t[c + 3], o(e12, e12, s), t[c] = e12[0], t[c + 1] = e12[1], t[c + 2] = e12[2], t[c + 3] = e12[3];
    return t;
  };
})();
function create$2() {
  var e12 = new ARRAY_TYPE(4);
  return ARRAY_TYPE != Float32Array && (e12[0] = 0, e12[1] = 0, e12[2] = 0), e12[3] = 1, e12;
}
function setAxisAngle(e12, t, n) {
  n *= 0.5;
  var r = Math.sin(n);
  return e12[0] = r * t[0], e12[1] = r * t[1], e12[2] = r * t[2], e12[3] = Math.cos(n), e12;
}
function getAxisAngle(e12, t) {
  var n = Math.acos(t[3]) * 2, r = Math.sin(n / 2);
  return r > 1e-6 ? (e12[0] = t[0] / r, e12[1] = t[1] / r, e12[2] = t[2] / r) : (e12[0] = 1, e12[1] = 0, e12[2] = 0), n;
}
function multiply(e12, t, n) {
  var r = t[0], a = t[1], o = t[2], s = t[3], c = n[0], l = n[1], u = n[2], d = n[3];
  return e12[0] = r * d + s * c + a * u - o * l, e12[1] = a * d + s * l + o * c - r * u, e12[2] = o * d + s * u + r * l - a * c, e12[3] = s * d - r * c - a * l - o * u, e12;
}
function slerp(e12, t, n, r) {
  var a = t[0], o = t[1], s = t[2], c = t[3], l = n[0], u = n[1], d = n[2], f = n[3], p, m = a * l + o * u + s * d + c * f, h, g, _;
  return m < 0 && (m = -m, l = -l, u = -u, d = -d, f = -f), 1 - m > 1e-6 ? (p = Math.acos(m), h = Math.sin(p), g = Math.sin((1 - r) * p) / h, _ = Math.sin(r * p) / h) : (g = 1 - r, _ = r), e12[0] = g * a + _ * l, e12[1] = g * o + _ * u, e12[2] = g * s + _ * d, e12[3] = g * c + _ * f, e12;
}
function conjugate(e12, t) {
  return e12[0] = -t[0], e12[1] = -t[1], e12[2] = -t[2], e12[3] = t[3], e12;
}
function fromMat3(e12, t) {
  var n = t[0] + t[4] + t[8], r;
  if (n > 0)
    r = Math.sqrt(n + 1), e12[3] = 0.5 * r, r = 0.5 / r, e12[0] = (t[5] - t[7]) * r, e12[1] = (t[6] - t[2]) * r, e12[2] = (t[1] - t[3]) * r;
  else {
    var a = 0;
    t[4] > t[0] && (a = 1), t[8] > t[a * 3 + a] && (a = 2);
    var o = (a + 1) % 3, s = (a + 2) % 3;
    r = Math.sqrt(t[a * 3 + a] - t[o * 3 + o] - t[s * 3 + s] + 1), e12[a] = 0.5 * r, r = 0.5 / r, e12[3] = (t[o * 3 + s] - t[s * 3 + o]) * r, e12[o] = (t[o * 3 + a] + t[a * 3 + o]) * r, e12[s] = (t[s * 3 + a] + t[a * 3 + s]) * r;
  }
  return e12;
}
var fromValues$1 = fromValues$2, normalize$2 = normalize$3;
(function() {
  var e12 = create$4(), t = fromValues$3(1, 0, 0), n = fromValues$3(0, 1, 0);
  return function(r, a, o) {
    var s = dot$3(a, o);
    return s < -0.999999 ? (cross$1(e12, t, a), len(e12) < 1e-6 && cross$1(e12, n, a), normalize$4(e12, e12), setAxisAngle(r, e12, Math.PI), r) : s > 0.999999 ? (r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 1, r) : (cross$1(e12, a, o), r[0] = e12[0], r[1] = e12[1], r[2] = e12[2], r[3] = 1 + s, normalize$2(r, r));
  };
})(), function() {
  var e12 = create$2(), t = create$2();
  return function(n, r, a, o, s, c) {
    return slerp(e12, r, s, c), slerp(t, a, o, c), slerp(n, e12, t, 2 * c * (1 - c)), n;
  };
}(), function() {
  var e12 = create$6();
  return function(t, n, r, a) {
    return e12[0] = r[0], e12[3] = r[1], e12[6] = r[2], e12[1] = a[0], e12[4] = a[1], e12[7] = a[2], e12[2] = -n[0], e12[5] = -n[1], e12[8] = -n[2], normalize$2(t, fromMat3(t, e12));
  };
}();
function create$1() {
  var e12 = new ARRAY_TYPE(2);
  return ARRAY_TYPE != Float32Array && (e12[0] = 0, e12[1] = 0), e12;
}
function fromValues(e12, t) {
  var n = new ARRAY_TYPE(2);
  return n[0] = e12, n[1] = t, n;
}
function add$1(e12, t, n) {
  return e12[0] = t[0] + n[0], e12[1] = t[1] + n[1], e12;
}
function subtract$1(e12, t, n) {
  return e12[0] = t[0] - n[0], e12[1] = t[1] - n[1], e12;
}
var sub = subtract$1;
(function() {
  var e12 = create$1();
  return function(t, n, r, a, o, s) {
    var c, l;
    for (n ||= 2, r ||= 0, l = a ? Math.min(a * n + r, t.length) : t.length, c = r; c < l; c += n)
      e12[0] = t[c], e12[1] = t[c + 1], o(e12, e12, s), t[c] = e12[0], t[c + 1] = e12[1];
    return t;
  };
})();
function imageIdToURI(e12) {
  if (!e12)
    return "";
  let t = e12.indexOf(":");
  return t === -1 ? e12 : e12.substring(t + 1);
}
function fnv1aHash(e12) {
  let t = 2166136261;
  for (let n = 0; n < e12.length; n++)
    t ^= e12.charCodeAt(n), t += (t << 1) + (t << 4) + (t << 7) + (t << 8) + (t << 24);
  return (t >>> 0).toString(36);
}
var ONE_GB = 1073741824, cache_default = new class {
  constructor() {
    this._imageCache = /* @__PURE__ */ new Map(), this._volumeCache = /* @__PURE__ */ new Map(), this._imageIdsToVolumeIdCache = /* @__PURE__ */ new Map(), this._referencedImageIdToImageIdCache = /* @__PURE__ */ new Map(), this._geometryCache = /* @__PURE__ */ new Map(), this._imageCacheSize = 0, this._maxCacheSize = 3 * ONE_GB, this._geometryCacheSize = 0, this.setMaxCacheSize = (e12) => {
      if (!e12 || typeof e12 != "number") {
        let e13 = `New max cacheSize ${this._maxCacheSize} should be defined and should be a number.`;
        throw Error(e13);
      }
      this._maxCacheSize = e12;
    }, this.isCacheable = (e12) => this.getBytesAvailable() + Array.from(this._imageCache.values()).reduce((e13, t) => t.sharedCacheKey ? e13 : e13 + t.sizeInBytes, 0) >= e12, this.getMaxCacheSize = () => this._maxCacheSize, this.getCacheSize = () => this._imageCacheSize, this._decacheImage = (e12, t = false) => {
      let n = this._imageCache.get(e12);
      if (!n)
        return;
      if (n.sharedCacheKey && !t)
        throw Error("Cannot decache an image with a shared cache key. You need to manually decache the volume first.");
      let { imageLoadObject: r } = n;
      n.image?.referencedImageId && this._referencedImageIdToImageIdCache.delete(n.image.referencedImageId), r?.cancelFn && r.cancelFn(), r?.decache && r.decache(), this._imageCache.delete(e12);
    }, this._decacheVolume = (e12) => {
      let t = this._volumeCache.get(e12);
      if (!t)
        return;
      let { volumeLoadObject: n, volume: r } = t;
      r && (r.cancelLoading && r.cancelLoading(), r.imageData && r.imageData.delete(), n.cancelFn && n.cancelFn(), r.imageIds && r.imageIds.forEach((t2) => {
        let n2 = this._imageCache.get(t2);
        n2 && n2.sharedCacheKey === e12 && (n2.sharedCacheKey = void 0);
      }), this._volumeCache.delete(e12));
    }, this.purgeCache = () => {
      let e12 = this._imageCache.keys();
      for (this.purgeVolumeCache(); ; ) {
        let { value: t, done: n } = e12.next();
        if (n)
          break;
        this.removeImageLoadObject(t, { force: true }), triggerEvent(eventTarget_default, Events_default.IMAGE_CACHE_IMAGE_REMOVED, { imageId: t });
      }
    }, this.purgeVolumeCache = () => {
      let e12 = this._volumeCache.keys();
      for (; ; ) {
        let { value: t, done: n } = e12.next();
        if (n)
          break;
        this.removeVolumeLoadObject(t), triggerEvent(eventTarget_default, Events_default.VOLUME_CACHE_VOLUME_REMOVED, { volumeId: t });
      }
    }, this.getVolumeLoadObject = (e12) => {
      if (e12 === void 0)
        throw Error("getVolumeLoadObject: volumeId must not be undefined");
      let t = this._volumeCache.get(e12);
      if (t)
        return t.timeStamp = Date.now(), t.volumeLoadObject;
    }, this.putGeometryLoadObject = (e12, t) => {
      if (e12 === void 0)
        throw Error("putGeometryLoadObject: geometryId must not be undefined");
      if (t.promise === void 0)
        throw Error("putGeometryLoadObject: geometryLoadObject.promise must not be undefined");
      if (this._geometryCache.has(e12))
        throw Error("putGeometryLoadObject: geometryId already present in geometryCache");
      if (t.cancelFn && typeof t.cancelFn != "function")
        throw Error("putGeometryLoadObject: geometryLoadObject.cancel must be a function");
      let n = {
        loaded: false,
        geometryId: e12,
        geometryLoadObject: t,
        timeStamp: Date.now(),
        sizeInBytes: 0
      };
      return this._geometryCache.set(e12, n), t.promise.then((t2) => {
        try {
          this._putGeometryCommon(e12, t2, n);
        } catch (t3) {
          throw console.debug(`Error in _putGeometryCommon for geometry ${e12}:`, t3), t3;
        }
      }).catch((t2) => {
        throw console.debug(`Error caching geometry ${e12}:`, t2), this._geometryCache.delete(e12), t2;
      });
    }, this.getGeometry = (e12) => {
      if (e12 === void 0)
        throw Error("getGeometry: geometryId must not be undefined");
      let t = this._geometryCache.get(e12);
      if (t)
        return t.timeStamp = Date.now(), t.geometry;
    }, this.removeGeometryLoadObject = (e12) => {
      if (e12 === void 0)
        throw Error("removeGeometryLoadObject: geometryId must not be undefined");
      let t = this._geometryCache.get(e12);
      if (!t)
        throw Error("removeGeometryLoadObject: geometryId was not present in geometryCache");
      this.decrementGeometryCacheSize(t.sizeInBytes);
      let n = {
        geometry: t,
        geometryId: e12
      };
      triggerEvent(eventTarget_default, Events_default.GEOMETRY_CACHE_GEOMETRY_REMOVED, n), this._decacheGeometry(e12);
    }, this._decacheGeometry = (e12) => {
      let t = this._geometryCache.get(e12);
      if (!t)
        return;
      let { geometryLoadObject: n } = t;
      n.cancelFn && n.cancelFn(), n.decache && n.decache(), this._geometryCache.delete(e12);
    }, this.incrementGeometryCacheSize = (e12) => {
      this._geometryCacheSize += e12;
    }, this.decrementGeometryCacheSize = (e12) => {
      this._geometryCacheSize -= e12;
    }, this.getImageByReferencedImageId = (e12) => {
      let t = this._referencedImageIdToImageIdCache.get(e12);
      if (t)
        return this._imageCache.get(t)?.image;
    }, this.getImage = (e12, t = ImageQualityStatus_default.FAR_REPLICATE) => {
      if (e12 === void 0)
        throw Error("getImage: imageId must not be undefined");
      let n = this._imageCache.get(e12);
      if (n && (n.timeStamp = Date.now(), !(n.image?.imageQualityStatus < t)))
        return n.image;
    }, this.getVolume = (e12, t = false) => {
      if (e12 === void 0)
        throw Error("getVolume: volumeId must not be undefined");
      let n = this._volumeCache.get(e12);
      return n ? (n.timeStamp = Date.now(), n.volume) : t ? [...this._volumeCache.values()].find((t2) => t2.volumeId.includes(e12))?.volume : void 0;
    }, this.getVolumes = () => Array.from(this._volumeCache.values()).map((e12) => e12.volume), this.filterVolumesByReferenceId = (e12) => this.getVolumes().filter((t) => t.referencedVolumeId === e12), this.removeImageLoadObject = (e12, { force: t = false } = {}) => {
      if (e12 === void 0)
        throw Error("removeImageLoadObject: imageId must not be undefined");
      let n = this._imageCache.get(e12);
      if (!n)
        throw Error("removeImageLoadObject: imageId was not present in imageCache");
      this._decacheImage(e12, t), this.incrementImageCacheSize(-n.sizeInBytes);
      let r = {
        image: n,
        imageId: e12
      };
      triggerEvent(eventTarget_default, Events_default.IMAGE_CACHE_IMAGE_REMOVED, r);
    }, this.removeVolumeLoadObject = (e12) => {
      if (e12 === void 0)
        throw Error("removeVolumeLoadObject: volumeId must not be undefined");
      let t = this._volumeCache.get(e12);
      if (!t)
        throw Error("removeVolumeLoadObject: volumeId was not present in volumeCache");
      let n = {
        volume: t,
        volumeId: e12
      };
      triggerEvent(eventTarget_default, Events_default.VOLUME_CACHE_VOLUME_REMOVED, n), this._decacheVolume(e12);
    }, this.incrementImageCacheSize = (e12) => {
      this._imageCacheSize += e12;
    }, this.decrementImageCacheSize = (e12) => {
      this._imageCacheSize -= e12;
    }, this.getGeometryLoadObject = (e12) => {
      if (e12 === void 0)
        throw Error("getGeometryLoadObject: geometryId must not be undefined");
      let t = this._geometryCache.get(e12);
      if (t)
        return t.timeStamp = Date.now(), t.geometryLoadObject;
    };
  }
  generateVolumeId(e12) {
    let t = e12.map(imageIdToURI).sort(), n = 2166136261;
    for (let e13 of t) {
      let t2 = fnv1aHash(e13);
      for (let e14 = 0; e14 < t2.length; e14++)
        n ^= t2.charCodeAt(e14), n += (n << 1) + (n << 4) + (n << 7) + (n << 8) + (n << 24);
    }
    return `volume-${(n >>> 0).toString(36)}`;
  }
  getImageIdsForVolumeId(e12) {
    return Array.from(this._imageIdsToVolumeIdCache.entries()).filter(([t, n]) => n === e12).map(([e13]) => e13);
  }
  getBytesAvailable() {
    return this.getMaxCacheSize() - this.getCacheSize();
  }
  decacheIfNecessaryUntilBytesAvailable(e12, t) {
    let n = this.getBytesAvailable();
    if (n >= e12)
      return n;
    let r = Array.from(this._imageCache.values()).filter((e13) => !e13.sharedCacheKey);
    function o(e13, t2) {
      return e13.timeStamp > t2.timeStamp ? 1 : e13.timeStamp < t2.timeStamp ? -1 : 0;
    }
    r.sort(o);
    let s = r.map((e13) => e13.imageId), c = s;
    t && (c = s.filter((e13) => !t.includes(e13)));
    for (let t2 of c)
      if (this.removeImageLoadObject(t2), triggerEvent(eventTarget_default, Events_default.IMAGE_CACHE_IMAGE_REMOVED, { imageId: t2 }), n = this.getBytesAvailable(), n >= e12)
        return n;
    for (let t2 of s)
      if (this.removeImageLoadObject(t2), triggerEvent(eventTarget_default, Events_default.IMAGE_CACHE_IMAGE_REMOVED, { imageId: t2 }), n = this.getBytesAvailable(), n >= e12)
        return n;
  }
  _putImageCommon(e12, t, n) {
    if (!this._imageCache.has(e12)) {
      console.warn("The image was purged from the cache before it completed loading.");
      return;
    }
    if (!t) {
      console.warn("Image is undefined");
      return;
    }
    if (t.sizeInBytes === void 0 || Number.isNaN(t.sizeInBytes))
      throw Error("_putImageCommon: image.sizeInBytes must not be undefined");
    if (t.sizeInBytes.toFixed === void 0)
      throw Error("_putImageCommon: image.sizeInBytes is not a number");
    if (!this.isCacheable(t.sizeInBytes))
      throw Error(Events_default.CACHE_SIZE_EXCEEDED);
    this.decacheIfNecessaryUntilBytesAvailable(t.sizeInBytes), n.loaded = true, n.image = t, n.sizeInBytes = t.sizeInBytes, this.incrementImageCacheSize(n.sizeInBytes);
    let r = { image: n };
    t.referencedImageId && this._referencedImageIdToImageIdCache.set(t.referencedImageId, e12), triggerEvent(eventTarget_default, Events_default.IMAGE_CACHE_IMAGE_ADDED, r), n.sharedCacheKey = t.sharedCacheKey;
  }
  async putImageLoadObject(e12, t) {
    if (e12 === void 0)
      throw console.error("putImageLoadObject: imageId must not be undefined"), Error("putImageLoadObject: imageId must not be undefined");
    if (t.promise === void 0)
      throw console.error("putImageLoadObject: imageLoadObject.promise must not be undefined"), Error("putImageLoadObject: imageLoadObject.promise must not be undefined");
    let n = this._imageCache.get(e12);
    if (n?.imageLoadObject)
      throw console.warn(`putImageLoadObject: imageId ${e12} already in cache`), Error("putImageLoadObject: imageId already in cache");
    if (t.cancelFn && typeof t.cancelFn != "function")
      throw console.error("putImageLoadObject: imageLoadObject.cancel must be a function"), Error("putImageLoadObject: imageLoadObject.cancel must be a function");
    let r = {
      ...n,
      loaded: false,
      imageId: e12,
      sharedCacheKey: void 0,
      imageLoadObject: t,
      timeStamp: Date.now(),
      sizeInBytes: 0
    };
    return this._imageCache.set(e12, r), t.promise.then((t2) => {
      try {
        this._putImageCommon(e12, t2, r);
      } catch (t3) {
        throw console.debug(`Error in _putImageCommon for image ${e12}:`, t3), t3;
      }
    }).catch((t2) => {
      throw console.debug(`Error caching image ${e12}:`, t2), this._imageCache.delete(e12), t2;
    });
  }
  putImageSync(e12, t) {
    if (e12 === void 0)
      throw Error("putImageSync: imageId must not be undefined");
    if (this._imageCache.has(e12))
      throw Error("putImageSync: imageId already in cache");
    let n = {
      loaded: false,
      imageId: e12,
      sharedCacheKey: void 0,
      imageLoadObject: { promise: Promise.resolve(t) },
      timeStamp: Date.now(),
      sizeInBytes: 0
    };
    this._imageCache.set(e12, n);
    try {
      this._putImageCommon(e12, t, n);
    } catch (t2) {
      throw this._imageCache.delete(e12), t2;
    }
  }
  getImageLoadObject(e12) {
    if (e12 === void 0)
      throw Error("getImageLoadObject: imageId must not be undefined");
    let t = this._imageCache.get(e12);
    if (t)
      return t.timeStamp = Date.now(), t.imageLoadObject;
  }
  isLoaded(e12) {
    let t = this._imageCache.get(e12);
    return t ? t.loaded : false;
  }
  getVolumeContainingImageId(e12) {
    let t = Array.from(this._volumeCache.keys()), n = imageIdToURI(e12);
    for (let e13 of t) {
      let t2 = this._volumeCache.get(e13);
      if (!t2)
        return;
      let { volume: r } = t2;
      if (!r.imageIds.length)
        return;
      let a = r.getImageURIIndex(n);
      if (a > -1)
        return {
          volume: r,
          imageIdIndex: a
        };
    }
  }
  getCachedImageBasedOnImageURI(e12) {
    let t = imageIdToURI(e12), n = Array.from(this._imageCache.keys()).find((e13) => imageIdToURI(e13) === t);
    if (n)
      return this._imageCache.get(n);
  }
  _putVolumeCommon(e12, t, n) {
    if (!this._volumeCache.get(e12)) {
      console.warn("The volume was purged from the cache before it completed loading.");
      return;
    }
    n.loaded = true, n.volume = t, t.imageIds?.forEach((t2) => {
      let n2 = this._imageCache.get(t2);
      n2 && (n2.sharedCacheKey = e12);
    });
    let r = { volume: n };
    triggerEvent(eventTarget_default, Events_default.VOLUME_CACHE_VOLUME_ADDED, r);
  }
  putVolumeSync(e12, t) {
    if (e12 === void 0)
      throw Error("putVolumeSync: volumeId must not be undefined");
    if (this._volumeCache.has(e12))
      throw Error("putVolumeSync: volumeId already in cache");
    let n = {
      loaded: false,
      volumeId: e12,
      volumeLoadObject: { promise: Promise.resolve(t) },
      timeStamp: Date.now(),
      sizeInBytes: 0
    };
    this._volumeCache.set(e12, n);
    try {
      this._putVolumeCommon(e12, t, n);
    } catch (t2) {
      throw this._volumeCache.delete(e12), t2;
    }
  }
  async putVolumeLoadObject(e12, t) {
    if (e12 === void 0)
      throw Error("putVolumeLoadObject: volumeId must not be undefined");
    if (t.promise === void 0)
      throw Error("putVolumeLoadObject: volumeLoadObject.promise must not be undefined");
    if (this._volumeCache.has(e12))
      throw Error(`putVolumeLoadObject: volumeId:${e12} already in cache`);
    if (t.cancelFn && typeof t.cancelFn != "function")
      throw Error("putVolumeLoadObject: volumeLoadObject.cancel must be a function");
    let n = {
      loaded: false,
      volumeId: e12,
      volumeLoadObject: t,
      timeStamp: Date.now(),
      sizeInBytes: 0
    };
    return this._volumeCache.set(e12, n), t.promise.then((t2) => {
      try {
        this._putVolumeCommon(e12, t2, n);
      } catch (t3) {
        throw console.error(`Error in _putVolumeCommon for volume ${e12}:`, t3), this._volumeCache.delete(e12), t3;
      }
    }).catch((t2) => {
      throw this._volumeCache.delete(e12), t2;
    });
  }
  _putGeometryCommon(e12, t, n) {
    if (!this._geometryCache.get(e12)) {
      console.warn("The geometry was purged from the cache before it completed loading.");
      return;
    }
    if (!t) {
      console.warn("Geometry is undefined");
      return;
    }
    if (t.sizeInBytes === void 0 || Number.isNaN(t.sizeInBytes))
      throw Error("_putGeometryCommon: geometry.sizeInBytes must not be undefined");
    if (t.sizeInBytes.toFixed === void 0)
      throw Error("_putGeometryCommon: geometry.sizeInBytes is not a number");
    if (!this.isCacheable(t.sizeInBytes))
      throw Error(Events_default.CACHE_SIZE_EXCEEDED);
    this.decacheIfNecessaryUntilBytesAvailable(t.sizeInBytes), n.loaded = true, n.geometry = t, n.sizeInBytes = t.sizeInBytes, this.incrementGeometryCacheSize(n.sizeInBytes);
    let r = { geometry: n };
    triggerEvent(eventTarget_default, Events_default.GEOMETRY_CACHE_GEOMETRY_ADDED, r);
  }
  putGeometrySync(e12, t) {
    if (e12 === void 0)
      throw Error("putGeometrySync: geometryId must not be undefined");
    if (this._geometryCache.has(e12))
      throw Error("putGeometrySync: geometryId already in cache");
    let n = {
      loaded: false,
      geometryId: e12,
      geometryLoadObject: { promise: Promise.resolve(t) },
      timeStamp: Date.now(),
      sizeInBytes: 0
    };
    this._geometryCache.set(e12, n);
    try {
      this._putGeometryCommon(e12, t, n);
    } catch (t2) {
      throw this._geometryCache.delete(e12), t2;
    }
  }
  setPartialImage(e12, t) {
    let n = this._imageCache.get(e12);
    if (!n) {
      t && this._imageCache.set(e12, {
        image: t,
        imageId: e12,
        loaded: false,
        timeStamp: Date.now(),
        sizeInBytes: 0
      });
      return;
    }
    n.loaded ? (n.loaded = false, n.imageLoadObject = null, this.incrementImageCacheSize(-n.sizeInBytes), n.sizeInBytes = 0, n.image = t || n.image) : n.image = t || n.image;
  }
  getImageQuality(e12) {
    let t = this._imageCache.get(e12)?.image;
    return t ? t.imageQualityStatus || ImageQualityStatus_default.FULL_RESOLUTION : void 0;
  }
}();
function areNumbersEqualWithTolerance(e12, t, n) {
  return Math.abs(e12 - t) <= n;
}
function areArraysEqual(e12, t, n = 1e-5) {
  if (e12.length !== t.length)
    return false;
  for (let r = 0; r < e12.length; r++)
    if (!areNumbersEqualWithTolerance(e12[r], t[r], n))
      return false;
  return true;
}
function isNumberType(e12) {
  return typeof e12 == "number";
}
function isNumberArrayLike(e12) {
  return e12 && typeof e12 == "object" && "length" in e12 && typeof e12.length == "number" && e12.length > 0 && typeof e12[0] == "number";
}
function isEqual(e12, t, n = 1e-5) {
  return typeof e12 != typeof t || e12 === null || t === null ? false : isNumberType(e12) && isNumberType(t) ? areNumbersEqualWithTolerance(e12, t, n) : isNumberArrayLike(e12) && isNumberArrayLike(t) ? areArraysEqual(e12, t, n) : false;
}
var negative = (e12) => typeof e12 == "number" ? -e12 : e12?.map ? e12.map(negative) : !e12, abs = (e12) => typeof e12 == "number" ? Math.abs(e12) : e12?.map ? e12.map(abs) : e12;
const isEqualNegative = (e12, t, n = void 0) => isEqual(e12, negative(t), n), isEqualAbs = (e12, t, n = void 0) => isEqual(abs(e12), abs(t), n);
function isNumber(e12) {
  return Array.isArray(e12) ? isNumber(e12[0]) : isFinite(e12) && !isNaN(e12);
}
var isEqual_default = isEqual;
function isImageActor(e12) {
  return actorIsA(e12, "vtkVolume") || actorIsA(e12, "vtkImageSlice");
}
function actorIsA(e12, t) {
  let n = "isA" in e12 ? e12 : e12.actor;
  return n ? !!n.isA(t) : false;
}
var colormap_exports = /* @__PURE__ */ __export({
  findMatchingColormap: () => findMatchingColormap,
  getColormap: () => getColormap$1,
  getColormapNames: () => getColormapNames,
  getMaxOpacity: () => getMaxOpacity,
  getThresholdValue: () => getThresholdValue,
  registerColormap: () => registerColormap,
  setColorMapTransferFunctionForVolumeActor: () => setColorMapTransferFunctionForVolumeActor,
  updateOpacity: () => updateOpacity,
  updateThreshold: () => updateThreshold
}), _colormaps = /* @__PURE__ */ new Map();
function registerColormap(e12) {
  e12.name = e12.name || e12.Name, _colormaps.set(e12.name, e12);
}
function getColormap$1(e12) {
  return _colormaps.get(e12);
}
function getColormapNames() {
  return Array.from(_colormaps.keys());
}
function findMatchingColormap(e12, t) {
  let n = vtkColorMaps.rgbPresetNames.map((e13) => vtkColorMaps.getPresetByName(e13)), r = getColormapNames().map((e13) => getColormap$1(e13)), a = n.concat(r).find((t2) => {
    let { RGBPoints: n2 } = t2;
    if (n2.length !== e12.length)
      return false;
    for (let t3 = 0; t3 < n2.length; t3 += 4)
      if (!isEqual_default(n2.slice(t3 + 1, t3 + 4), e12.slice(t3 + 1, t3 + 4)))
        return false;
    return true;
  });
  if (!a)
    return null;
  let o = [];
  if (actorIsA(t, "vtkVolume")) {
    let e13 = t.getProperty().getScalarOpacity(0).getDataPointer();
    if (!e13)
      return { name: a.Name };
    for (let t2 = 0; t2 < e13.length; t2 += 2)
      o.push({
        value: e13[t2],
        opacity: e13[t2 + 1]
      });
  }
  return {
    name: a.Name,
    ...Array.isArray(o) && o.length > 0 && { opacity: o },
    ...typeof o == "number" && { opacity: o }
  };
}
function setColorMapTransferFunctionForVolumeActor(e12) {
  let { volumeActor: t, preset: n, opacity: r = 0.9, threshold: a = null, colorRange: o = [0, 5] } = e12;
  t.getMapper().setSampleDistance(1);
  let s = vtkColorTransferFunction$1.newInstance(), c = n || vtkColorMaps.getPresetByName("hsv");
  s.applyColorMap(c), s.setMappingRange(o[0], o[1]), t.getProperty().setRGBTransferFunction(0, s), updateOpacityWithThreshold(t, r, a);
}
function updateOpacity(e12, t) {
  updateOpacityWithThreshold(e12, t, getThresholdValue(e12));
}
function updateThreshold(e12, t) {
  updateOpacityWithThreshold(e12, getMaxOpacity(e12), t);
}
function updateOpacityWithThreshold(e12, t, n) {
  let r = e12.getMapper().getInputData().get("voxelManager");
  if (!r?.voxelManager)
    throw Error("No voxel manager was found for the volume actor, or you cannot yet update opacity with a threshold using stacked images");
  let a = r.voxelManager.getRange(), o = vtkPiecewiseFunction$1.newInstance();
  if (n !== null) {
    let e13 = Math.abs(a[1] - a[0]) * 1e-3, r2 = Math.max(a[0], Math.min(a[1], n));
    o.addPoint(a[0], 0), o.addPoint(r2 - e13, 0), o.addPoint(r2, t), o.addPoint(a[1], t);
  } else
    o.addPoint(a[0], t), o.addPoint(a[1], t);
  e12.getProperty().setScalarOpacity(0, o);
}
function getThresholdValue(e12) {
  let t = e12.getProperty().getScalarOpacity(0);
  if (!t)
    return null;
  let n = t.getDataPointer();
  if (!n || n.length <= 4)
    return null;
  for (let e13 = 0; e13 < n.length - 2; e13 += 2) {
    n[e13];
    let t2 = n[e13 + 1], r = n[e13 + 2], a = n[e13 + 3];
    if (t2 === 0 && a > 0)
      return r;
  }
  return null;
}
function getMaxOpacity(e12) {
  let t = e12.getProperty().getScalarOpacity(0);
  if (!t)
    return 1;
  let n = t.getDataPointer();
  if (!n || n.length === 0)
    return 1;
  let r = 0;
  for (let e13 = 1; e13 < n.length; e13 += 2)
    n[e13] > r && (r = n[e13]);
  return r;
}
function invertRgbTransferFunction(e12) {
  if (!e12)
    return;
  let t = e12.getSize();
  for (let n = 0; n < t; n++) {
    let t2 = [];
    e12.getNodeValue(n, t2), t2[1] = 1 - t2[1], t2[2] = 1 - t2[2], t2[3] = 1 - t2[3], e12.setNodeValue(n, t2);
  }
}
const logit = (e12, t, n) => t - n / 4 * Math.log((1 - e12) / e12);
var windowLevel_exports = /* @__PURE__ */ __export({
  toLowHighRange: () => toLowHighRange,
  toWindowLevel: () => toWindowLevel
});
function toWindowLevel(e12, t) {
  return {
    windowWidth: Math.abs(t - e12) + 1,
    windowCenter: (e12 + t + 1) / 2
  };
}
function toLowHighRange(e12, t, n = VOILUTFunctionType_default.LINEAR) {
  if (n === VOILUTFunctionType_default.LINEAR || n === VOILUTFunctionType_default.SAMPLED_SIGMOID)
    return {
      lower: t - 0.5 - (e12 - 1) / 2,
      upper: t - 0.5 + (e12 - 1) / 2
    };
  if (n === VOILUTFunctionType_default.LINEAR_EXACT)
    return {
      lower: t - e12 / 2,
      upper: t + e12 / 2
    };
  throw Error("Invalid VOI LUT function");
}
function createSigmoidRGBTransferFunction(e12, t = 1024) {
  let { windowWidth: n, windowCenter: r } = toWindowLevel(e12.lower, e12.upper), a = Array.from({ length: t }, (e13, n2) => (n2 + 1) / (t + 2)).flatMap((e13) => [
    logit(e13, r, n),
    e13,
    e13,
    e13,
    0.5,
    0
  ]), o = vtkColorTransferFunction$1.newInstance();
  return o.buildFunctionFromArray(vtkDataArray$1.newInstance({
    values: a,
    numberOfComponents: 6
  })), o;
}
function transformWorldToIndex(e12, t) {
  return e12.worldToIndex(t).map(Math.round);
}
function transformWorldToIndexContinuous(e12, t) {
  return e12.worldToIndex(t);
}
var transferFunctionUtils_exports = /* @__PURE__ */ __export({
  getTransferFunctionNodes: () => getTransferFunctionNodes,
  setTransferFunctionNodes: () => setTransferFunctionNodes
});
function getTransferFunctionNodes(e12) {
  let t = e12.getSize(), n = [];
  for (let r = 0; r < t; r++) {
    let t2 = [];
    e12.getNodeValue(r, t2), n.push(t2);
  }
  return n;
}
function setTransferFunctionNodes(e12, t) {
  t?.length && (e12.removeAllPoints(), t.forEach((t2) => {
    e12.addRGBPoint(...t2);
  }));
}
function vtkImplicitFunction(e12, t) {
  t.classHierarchy.push("vtkImplicitFunction"), e12.functionValue = (n) => {
    if (!t.transform)
      return e12.evaluateFunction(n);
    let r = [];
    return t.transform.transformPoint(n, r), e12.evaluateFunction(r);
  }, e12.evaluateFunction = (e13) => {
    macro.vtkErrorMacro("not implemented");
  };
}
var DEFAULT_VALUES$126 = {};
function extend$137(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$126, n), macro.obj(e12, t), macro.setGet(e12, t, ["transform"]), vtkImplicitFunction(e12, t);
}
var vtkImplicitFunction$1 = {
  newInstance: macro.newInstance(extend$137, "vtkImplicitFunction"),
  extend: extend$137
}, PLANE_TOLERANCE = 1e-6, COINCIDE = "coincide", DISJOINT = "disjoint";
function evaluate(e12, t, n) {
  return e12[0] * (n[0] - t[0]) + e12[1] * (n[1] - t[1]) + e12[2] * (n[2] - t[2]);
}
function distanceToPlane(e12, t, n) {
  let r = n[0] * (e12[0] - t[0]) + n[1] * (e12[1] - t[1]) + n[2] * (e12[2] - t[2]);
  return Math.abs(r);
}
function projectPoint(e12, t, n, r) {
  let a = [];
  subtract(e12, t, a);
  let o = dot(n, a);
  r[0] = e12[0] - o * n[0], r[1] = e12[1] - o * n[1], r[2] = e12[2] - o * n[2];
}
function projectVector$1(e12, t, n) {
  let r = dot(e12, t), a = dot(t, t);
  return a === 0 && (a = 1), n[0] = e12[0] - r * t[0] / a, n[1] = e12[1] - r * t[1] / a, n[2] = e12[2] - r * t[2] / a, n;
}
function generalizedProjectPoint(e12, t, n, r) {
  let a = [];
  subtract(e12, t, a);
  let o = dot(n, a), s = dot(n, n);
  s === 0 ? (r[0] = e12[0], r[1] = e12[1], r[2] = e12[2]) : (r[0] = e12[0] - o * n[0] / s, r[1] = e12[1] - o * n[1] / s, r[2] = e12[2] - o * n[2] / s);
}
function intersectWithLine(e12, t, n, r) {
  let a = {
    intersection: false,
    betweenPoints: false,
    t: Number.MAX_VALUE,
    x: []
  }, o = [], s = [];
  subtract(t, e12, o), subtract(n, e12, s);
  let c = dot(r, s), l = dot(r, o), u, d;
  return u = l < 0 ? -l : l, d = c < 0 ? -c * PLANE_TOLERANCE : c * PLANE_TOLERANCE, u <= d ? a : (a.t = c / l, a.x[0] = e12[0] + a.t * o[0], a.x[1] = e12[1] + a.t * o[1], a.x[2] = e12[2] + a.t * o[2], a.intersection = true, a.betweenPoints = a.t >= 0 && a.t <= 1, a);
}
function intersectWithPlane(e12, t, n, r) {
  let a = {
    intersection: false,
    l0: [],
    l1: [],
    error: null
  }, o = [];
  cross(t, r, o);
  let s = o.map((e13) => Math.abs(e13));
  if (s[0] + s[1] + s[2] < PLANE_TOLERANCE) {
    let r2 = [];
    return subtract(e12, n, r2), dot(t, r2) === 0 ? a.error = COINCIDE : a.error = DISJOINT, a;
  }
  let c;
  c = s[0] > s[1] && s[0] > s[2] ? "x" : s[1] > s[2] ? "y" : "z";
  let l = [], u = -dot(t, e12), d = -dot(r, n);
  switch (c) {
    case "x":
      l[0] = 0, l[1] = (d * t[2] - u * r[2]) / o[0], l[2] = (u * r[1] - d * t[1]) / o[0];
      break;
    case "y":
      l[0] = (u * r[2] - d * t[2]) / o[1], l[1] = 0, l[2] = (d * t[0] - u * r[0]) / o[1];
      break;
    case "z":
      l[0] = (d * t[1] - u * r[1]) / o[2], l[1] = (u * r[0] - d * t[0]) / o[2], l[2] = 0;
      break;
  }
  return a.l0 = l, add(l, o, a.l1), a.intersection = true, a;
}
var STATIC$13 = {
  evaluate,
  distanceToPlane,
  projectPoint,
  projectVector: projectVector$1,
  generalizedProjectPoint,
  intersectWithLine,
  intersectWithPlane,
  DISJOINT,
  COINCIDE
};
function vtkPlane(e12, t) {
  t.classHierarchy.push("vtkPlane"), e12.distanceToPlane = (e13) => distanceToPlane(e13, t.origin, t.normal), e12.projectPoint = (e13, n) => {
    projectPoint(e13, t.origin, t.normal, n);
  }, e12.projectVector = (e13, n) => projectVector$1(e13, t.normal, n), e12.push = (e13) => {
    if (e13 !== 0)
      for (let n = 0; n < 3; n++)
        t.origin[n] += e13 * t.normal[n];
  }, e12.generalizedProjectPoint = (e13, n) => {
    generalizedProjectPoint(e13, t.origin, t.normal, n);
  }, e12.evaluateFunction = (e13, n, r) => Array.isArray(e13) ? t.normal[0] * (e13[0] - t.origin[0]) + t.normal[1] * (e13[1] - t.origin[1]) + t.normal[2] * (e13[2] - t.origin[2]) : t.normal[0] * (e13 - t.origin[0]) + t.normal[1] * (n - t.origin[1]) + t.normal[2] * (r - t.origin[2]), e12.evaluateGradient = (e13) => [
    t.normal[0],
    t.normal[1],
    t.normal[2]
  ], e12.intersectWithLine = (e13, n) => intersectWithLine(e13, n, t.origin, t.normal), e12.intersectWithPlane = (e13, n) => intersectWithPlane(e13, n, t.origin, t.normal);
}
var DEFAULT_VALUES$125 = {
  normal: [
    0,
    0,
    1
  ],
  origin: [
    0,
    0,
    0
  ]
};
function extend$136(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$125, n), vtkImplicitFunction$1.extend(e12, t, n), macro.setGetArray(e12, t, ["normal", "origin"], 3), vtkPlane(e12, t);
}
var newInstance$130 = macro.newInstance(extend$136, "vtkPlane"), vtkPlane$1 = {
  newInstance: newInstance$130,
  extend: extend$136,
  ...STATIC$13
}, INIT_BOUNDS = [
  Number.MAX_VALUE,
  -Number.MAX_VALUE,
  Number.MAX_VALUE,
  -Number.MAX_VALUE,
  Number.MAX_VALUE,
  -Number.MAX_VALUE
];
function equals(e12, t) {
  return e12[0] === t[0] && e12[1] === t[1] && e12[2] === t[2] && e12[3] === t[3] && e12[4] === t[4] && e12[5] === t[5];
}
function isValid(e12) {
  return e12?.length >= 6 && e12[0] <= e12[1] && e12[2] <= e12[3] && e12[4] <= e12[5];
}
function setBounds(e12, t) {
  return e12[0] = t[0], e12[1] = t[1], e12[2] = t[2], e12[3] = t[3], e12[4] = t[4], e12[5] = t[5], e12;
}
function reset(e12) {
  return setBounds(e12, INIT_BOUNDS);
}
function addPoint(e12, t, n, r) {
  let [a, o, s, c, l, u] = e12;
  return e12[0] = a < t ? a : t, e12[1] = o > t ? o : t, e12[2] = s < n ? s : n, e12[3] = c > n ? c : n, e12[4] = l < r ? l : r, e12[5] = u > r ? u : r, e12;
}
function addPoints(e12, t) {
  if (t.length === 0)
    return e12;
  if (Array.isArray(t[0]))
    for (let n = 0; n < t.length; ++n)
      addPoint(e12, ...t[n]);
  else
    for (let n = 0; n < t.length; n += 3)
      addPoint(e12, ...t.slice(n, n + 3));
  return e12;
}
function addBounds(e12, t, n, r, a, o, s) {
  let [c, l, u, d, f, p] = e12;
  return s === void 0 ? (e12[0] = Math.min(t[0], c), e12[1] = Math.max(t[1], l), e12[2] = Math.min(t[2], u), e12[3] = Math.max(t[3], d), e12[4] = Math.min(t[4], f), e12[5] = Math.max(t[5], p)) : (e12[0] = Math.min(t, c), e12[1] = Math.max(n, l), e12[2] = Math.min(r, u), e12[3] = Math.max(a, d), e12[4] = Math.min(o, f), e12[5] = Math.max(s, p)), e12;
}
function setMinPoint(e12, t, n, r) {
  let [a, o, s, c, l, u] = e12;
  return e12[0] = t, e12[1] = t > o ? t : o, e12[2] = n, e12[3] = n > c ? n : c, e12[4] = r, e12[5] = r > u ? r : u, a !== t || s !== n || l !== r;
}
function setMaxPoint(e12, t, n, r) {
  let [a, o, s, c, l, u] = e12;
  return e12[0] = t < a ? t : a, e12[1] = t, e12[2] = n < s ? n : s, e12[3] = n, e12[4] = r < l ? r : l, e12[5] = r, o !== t || c !== n || u !== r;
}
function inflate(e12, t) {
  return t == null ? minInflate(e12) : (e12[0] -= t, e12[1] += t, e12[2] -= t, e12[3] += t, e12[4] -= t, e12[5] += t, e12);
}
function minInflate(e12) {
  let t = [
    0,
    0,
    0
  ], n = -1, r = 0, a = 0;
  for (let o = 0; o < 3; ++o)
    a = e12[o * 2 + 1] - e12[o * 2], a > r && (r = a, n = o), t[o] = a > 0 ? 1 : 0;
  if (n < 0)
    return inflate(e12, 0.5);
  for (let n2 = 0; n2 < 3; ++n2)
    if (!t[n2]) {
      let t2 = 5e-3 * r;
      e12[n2 * 2] -= t2, e12[n2 * 2 + 1] += t2;
    }
  return e12;
}
function scale(e12, t, n, r) {
  return isValid(e12) ? (t >= 0 ? (e12[0] *= t, e12[1] *= t) : (e12[0] = t * e12[1], e12[1] = t * e12[0]), n >= 0 ? (e12[2] *= n, e12[3] *= n) : (e12[2] = n * e12[3], e12[3] = n * e12[2]), r >= 0 ? (e12[4] *= r, e12[5] *= r) : (e12[4] = r * e12[5], e12[5] = r * e12[4]), true) : false;
}
function getCenter(e12) {
  return [
    0.5 * (e12[0] + e12[1]),
    0.5 * (e12[2] + e12[3]),
    0.5 * (e12[4] + e12[5])
  ];
}
function scaleAboutCenter(e12, t, n, r) {
  if (!isValid(e12))
    return false;
  let a = getCenter(e12);
  return e12[0] -= a[0], e12[1] -= a[0], e12[2] -= a[1], e12[3] -= a[1], e12[4] -= a[2], e12[5] -= a[2], scale(e12, t, n, r), e12[0] += a[0], e12[1] += a[0], e12[2] += a[1], e12[3] += a[1], e12[4] += a[2], e12[5] += a[2], true;
}
function getLength(e12, t) {
  return e12[t * 2 + 1] - e12[t * 2];
}
function getLengths(e12) {
  return [
    getLength(e12, 0),
    getLength(e12, 1),
    getLength(e12, 2)
  ];
}
function getXRange(e12) {
  return e12.slice(0, 2);
}
function getYRange(e12) {
  return e12.slice(2, 4);
}
function getZRange(e12) {
  return e12.slice(4, 6);
}
function getMaxLength(e12) {
  let t = getLengths(e12);
  return t[0] > t[1] ? t[0] > t[2] ? t[0] : t[2] : t[1] > t[2] ? t[1] : t[2];
}
function getDiagonalLength2(e12) {
  if (isValid(e12)) {
    let t = getLengths(e12);
    return t[0] * t[0] + t[1] * t[1] + t[2] * t[2];
  }
  return null;
}
function getDiagonalLength(e12) {
  let t = getDiagonalLength2(e12);
  return t === null ? null : Math.sqrt(t);
}
function getMinPoint(e12) {
  return [
    e12[0],
    e12[2],
    e12[4]
  ];
}
function getMaxPoint(e12) {
  return [
    e12[1],
    e12[3],
    e12[5]
  ];
}
function oppositeSign(e12, t) {
  return e12 <= 0 && t >= 0 || e12 >= 0 && t <= 0;
}
function getCorners(e12, t) {
  return t[0] = [
    e12[0],
    e12[2],
    e12[4]
  ], t[1] = [
    e12[0],
    e12[2],
    e12[5]
  ], t[2] = [
    e12[0],
    e12[3],
    e12[4]
  ], t[3] = [
    e12[0],
    e12[3],
    e12[5]
  ], t[4] = [
    e12[1],
    e12[2],
    e12[4]
  ], t[5] = [
    e12[1],
    e12[2],
    e12[5]
  ], t[6] = [
    e12[1],
    e12[3],
    e12[4]
  ], t[7] = [
    e12[1],
    e12[3],
    e12[5]
  ], t;
}
function computeCornerPoints(e12, t, n) {
  return t[0] = e12[0], t[1] = e12[2], t[2] = e12[4], n[0] = e12[1], n[1] = e12[3], n[2] = e12[5], t;
}
function transformBounds(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = getCorners(e12, []);
  for (let e13 = 0; e13 < r.length; ++e13)
    transformMat4$1(r[e13], r[e13], t);
  return reset(n), addPoints(n, r);
}
function computeScale3(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t[0] = 0.5 * (e12[1] - e12[0]), t[1] = 0.5 * (e12[3] - e12[2]), t[2] = 0.5 * (e12[5] - e12[4]), t;
}
function computeLocalBounds(e12, t, n, r) {
  let a = [].concat(INIT_BOUNDS), o = e12.getData();
  for (let e13 = 0; e13 < o.length; e13 += 3) {
    let s = [
      o[e13],
      o[e13 + 1],
      o[e13 + 2]
    ], c = dot(s, t);
    a[0] = Math.min(c, a[0]), a[1] = Math.max(c, a[1]);
    let l = dot(s, n);
    a[2] = Math.min(l, a[2]), a[3] = Math.max(l, a[3]);
    let u = dot(s, r);
    a[4] = Math.min(u, a[4]), a[5] = Math.max(u, a[5]);
  }
  return a;
}
function intersectBox(e12, t, n, r, a) {
  let o = true, s = [], c = 0, l = [], u = [
    0,
    0,
    0
  ];
  for (let n2 = 0; n2 < 3; n2++)
    t[n2] < e12[2 * n2] ? (s[n2] = 1, u[n2] = e12[2 * n2], o = false) : t[n2] > e12[2 * n2 + 1] ? (s[n2] = 0, u[n2] = e12[2 * n2 + 1], o = false) : s[n2] = 2;
  if (o)
    return r[0] = t[0], r[1] = t[1], r[2] = t[2], a[0] = 0, 1;
  for (let e13 = 0; e13 < 3; e13++)
    s[e13] !== 2 && n[e13] !== 0 ? l[e13] = (u[e13] - t[e13]) / n[e13] : l[e13] = -1;
  for (let e13 = 0; e13 < 3; e13++)
    l[c] < l[e13] && (c = e13);
  if (l[c] > 1 || l[c] < 0)
    return 0;
  a[0] = l[c];
  for (let a2 = 0; a2 < 3; a2++)
    if (c !== a2) {
      if (r[a2] = t[a2] + l[c] * n[a2], r[a2] < e12[2 * a2] || r[a2] > e12[2 * a2 + 1])
        return 0;
    } else
      r[a2] = u[a2];
  return 1;
}
function intersectPlane(e12, t, n) {
  let r = [], a = 0, o = 1, s = 1;
  for (let c = 4; c <= 5; ++c) {
    r[2] = e12[c];
    for (let c2 = 2; c2 <= 3; ++c2) {
      r[1] = e12[c2];
      for (let c3 = 0; c3 <= 1; ++c3)
        if (r[0] = e12[c3], a = vtkPlane$1.evaluate(n, t, r), s &&= (o = a >= 0 ? 1 : -1, 0), a === 0 || o > 0 && a < 0 || o < 0 && a > 0)
          return 1;
    }
  }
  return 0;
}
function intersect(e12, t) {
  if (!(isValid(e12) && isValid(t)))
    return false;
  let n = [
    0,
    0,
    0,
    0,
    0,
    0
  ], r;
  for (let a = 0; a < 3; a++)
    if (r = false, t[a * 2] >= e12[a * 2] && t[a * 2] <= e12[a * 2 + 1] ? (r = true, n[a * 2] = t[a * 2]) : e12[a * 2] >= t[a * 2] && e12[a * 2] <= t[a * 2 + 1] && (r = true, n[a * 2] = e12[a * 2]), t[a * 2 + 1] >= e12[a * 2] && t[a * 2 + 1] <= e12[a * 2 + 1] ? (r = true, n[a * 2 + 1] = t[2 * a + 1]) : e12[a * 2 + 1] >= t[a * 2] && e12[a * 2 + 1] <= t[a * 2 + 1] && (r = true, n[a * 2 + 1] = e12[a * 2 + 1]), !r)
      return false;
  return e12[0] = n[0], e12[1] = n[1], e12[2] = n[2], e12[3] = n[3], e12[4] = n[4], e12[5] = n[5], true;
}
function intersects(e12, t) {
  if (!(isValid(e12) && isValid(t)))
    return false;
  for (let n = 0; n < 3; n++)
    if (!(t[n * 2] >= e12[n * 2] && t[n * 2] <= e12[n * 2 + 1]) && !(e12[n * 2] >= t[n * 2] && e12[n * 2] <= t[n * 2 + 1]) && !(t[n * 2 + 1] >= e12[n * 2] && t[n * 2 + 1] <= e12[n * 2 + 1]) && !(e12[n * 2 + 1] >= t[n * 2] && e12[n * 2 + 1] <= t[n * 2 + 1]))
      return false;
  return true;
}
function containsPoint(e12, t, n, r) {
  return !(t < e12[0] || t > e12[1] || n < e12[2] || n > e12[3] || r < e12[4] || r > e12[5]);
}
function contains(e12, t) {
  return !(!intersects(e12, t) || !containsPoint(e12, ...getMinPoint(t)) || !containsPoint(e12, ...getMaxPoint(t)));
}
function cutWithPlane(e12, t, n) {
  let r = [
    [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7
    ],
    [
      0,
      1,
      4,
      5,
      2,
      3,
      6,
      7
    ],
    [
      0,
      2,
      4,
      6,
      1,
      3,
      5,
      7
    ]
  ], a = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
  ], o = 0;
  for (let r2 = 0; r2 < 2; r2++)
    for (let s2 = 2; s2 < 4; s2++)
      for (let c2 = 4; c2 < 6; c2++) {
        let l2 = [
          e12[r2],
          e12[s2],
          e12[c2]
        ];
        a[o++] = vtkPlane$1.evaluate(n, t, l2);
      }
  let s = 2;
  for (; s-- && !(oppositeSign(a[r[s][0]], a[r[s][4]]) && oppositeSign(a[r[s][1]], a[r[s][5]]) && oppositeSign(a[r[s][2]], a[r[s][6]]) && oppositeSign(a[r[s][3]], a[r[s][7]])); )
    ;
  if (s < 0)
    return false;
  let c = Math.sign(n[s]), l = Math.abs((e12[s * 2 + 1] - e12[s * 2]) * n[s]), u = c > 0 ? 1 : 0;
  for (let e13 = 0; e13 < 4; e13++) {
    if (l === 0)
      continue;
    let t2 = Math.abs(a[r[s][e13]]) / l;
    c > 0 && t2 < u && (u = t2), c < 0 && t2 > u && (u = t2);
  }
  let d = (1 - u) * e12[s * 2] + u * e12[s * 2 + 1];
  return c > 0 ? e12[s * 2] = d : e12[s * 2 + 1] = d, true;
}
function clampDivisions(e12, t) {
  for (let e13 = 0; e13 < 3; ++e13)
    t[e13] = t[e13] < 1 ? 1 : t[e13];
  let n = t[0] * t[1] * t[2];
  for (; n > e12; ) {
    for (let e13 = 0; e13 < 3; ++e13)
      t[e13] = t[e13] > 1 ? t[e13] - 1 : 1;
    n = t[0] * t[1] * t[2];
  }
}
function computeDivisions(e12, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
  t = t <= 0 ? 1 : t;
  let a = 0, o = [
    0,
    0,
    0
  ], s = -1, c = 0, l = getLengths(e12), u = l[0] + l[1] + l[2], d = u * (1e-3 / 3);
  for (let e13 = 0; e13 < 3; ++e13)
    l[e13] > c && (s = e13, c = l[e13]), l[e13] > d ? (o[e13] = 1, a++) : o[e13] = 0;
  let f = getMinPoint(e12), p = getMaxPoint(e12);
  if (a < 1)
    return n[0] = 1, n[1] = 1, n[2] = 1, r[0] = f[0] - 0.5, r[1] = p[0] + 0.5, r[2] = f[1] - 0.5, r[3] = p[1] + 0.5, r[4] = f[2] - 0.5, r[5] = p[2] + 0.5, 1;
  let m = t;
  m /= o[0] ? l[0] / u : 1, m /= o[1] ? l[1] / u : 1, m /= o[2] ? l[2] / u : 1, m **= 1 / a;
  for (let e13 = 0; e13 < 3; ++e13)
    n[e13] = o[e13] ? Math.floor(m * l[e13] / u) : 1, n[e13] = n[e13] < 1 ? 1 : n[e13];
  clampDivisions(t, n);
  let h = 0.5 * l[s] / n[s];
  for (let e13 = 0; e13 < 3; ++e13)
    o[e13] ? (r[2 * e13] = f[e13], r[2 * e13 + 1] = p[e13]) : (r[2 * e13] = f[e13] - h, r[2 * e13 + 1] = p[e13] + h);
  return n[0] * n[1] * n[2];
}
function distance2ToBounds(e12, t) {
  if (e12[0] >= t[0] && e12[0] <= t[1] && e12[1] >= t[2] && e12[1] <= t[3] && e12[2] >= t[4] && e12[2] <= t[5])
    return 0;
  let n = [
    0,
    0,
    0
  ];
  return e12[0] < t[0] ? n[0] = t[0] - e12[0] : e12[0] > t[1] && (n[0] = e12[0] - t[1]), e12[1] < t[2] ? n[1] = t[2] - e12[1] : e12[1] > t[3] && (n[1] = e12[1] - t[3]), e12[2] < t[4] ? n[2] = t[4] - e12[2] : e12[2] > t[5] && (n[2] = e12[2] - t[5]), dot(n, n);
}
var BoundingBox = class {
  constructor(e12) {
    this.bounds = e12, this.bounds ||= new Float64Array(INIT_BOUNDS);
  }
  getBounds() {
    return this.bounds;
  }
  equals(e12) {
    return equals(this.bounds, e12);
  }
  isValid() {
    return isValid(this.bounds);
  }
  setBounds(e12) {
    return setBounds(this.bounds, e12);
  }
  reset() {
    return reset(this.bounds);
  }
  addPoint() {
    var e12 = [...arguments];
    return addPoint(this.bounds, ...e12);
  }
  addPoints(e12) {
    return addPoints(this.bounds, e12);
  }
  addBounds(e12, t, n, r, a, o) {
    return addBounds(this.bounds, e12, t, n, r, a, o);
  }
  setMinPoint(e12, t, n) {
    return setMinPoint(this.bounds, e12, t, n);
  }
  setMaxPoint(e12, t, n) {
    return setMaxPoint(this.bounds, e12, t, n);
  }
  inflate(e12) {
    return inflate(this.bounds, e12);
  }
  scale(e12, t, n) {
    return scale(this.bounds, e12, t, n);
  }
  getCenter() {
    return getCenter(this.bounds);
  }
  getLength(e12) {
    return getLength(this.bounds, e12);
  }
  getLengths() {
    return getLengths(this.bounds);
  }
  getMaxLength() {
    return getMaxLength(this.bounds);
  }
  getDiagonalLength() {
    return getDiagonalLength(this.bounds);
  }
  getDiagonalLength2() {
    return getDiagonalLength2(this.bounds);
  }
  getMinPoint() {
    return getMinPoint(this.bounds);
  }
  getMaxPoint() {
    return getMaxPoint(this.bounds);
  }
  getXRange() {
    return getXRange(this.bounds);
  }
  getYRange() {
    return getYRange(this.bounds);
  }
  getZRange() {
    return getZRange(this.bounds);
  }
  getCorners(e12) {
    return getCorners(this.bounds, e12);
  }
  computeCornerPoints(e12, t) {
    return computeCornerPoints(this.bounds, e12, t);
  }
  computeLocalBounds(e12, t, n) {
    return computeLocalBounds(this.bounds, e12, t, n);
  }
  transformBounds(e12) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return transformBounds(this.bounds, e12, t);
  }
  computeScale3(e12) {
    return computeScale3(this.bounds, e12);
  }
  cutWithPlane(e12, t) {
    return cutWithPlane(this.bounds, e12, t);
  }
  intersectBox(e12, t, n, r) {
    return intersectBox(this.bounds, e12, t, n, r);
  }
  intersectPlane(e12, t) {
    return intersectPlane(this.bounds, e12, t);
  }
  intersect(e12) {
    return intersect(this.bounds, e12);
  }
  intersects(e12) {
    return intersects(this.bounds, e12);
  }
  containsPoint(e12, t, n) {
    return containsPoint(this.bounds, e12, t, n);
  }
  contains(e12) {
    return intersects(this.bounds, e12);
  }
  computeDivisions(e12, t) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return computeDivisions(this.bounds, e12, t, n);
  }
  distance2ToBounds(e12) {
    return distance2ToBounds(e12, this.bounds);
  }
};
function newInstance$129(e12) {
  return new BoundingBox(e12 && e12.bounds);
}
var vtkBoundingBox = {
  newInstance: newInstance$129,
  equals,
  isValid,
  setBounds,
  reset,
  addPoint,
  addPoints,
  addBounds,
  setMinPoint,
  setMaxPoint,
  inflate,
  scale,
  scaleAboutCenter,
  getCenter,
  getLength,
  getLengths,
  getMaxLength,
  getDiagonalLength,
  getDiagonalLength2,
  getMinPoint,
  getMaxPoint,
  getXRange,
  getYRange,
  getZRange,
  getCorners,
  computeCornerPoints,
  computeLocalBounds,
  transformBounds,
  computeScale3,
  cutWithPlane,
  intersectBox,
  intersectPlane,
  intersect,
  intersects,
  containsPoint,
  contains,
  computeDivisions,
  clampDivisions,
  distance2ToBounds,
  INIT_BOUNDS
}, Constants$17 = { CoordinateSystem: {
  DISPLAY: 0,
  WORLD: 1
} }, { CoordinateSystem: CoordinateSystem$4 } = Constants$17;
function notImplemented$5(e12) {
  return () => macro.vtkErrorMacro(`vtkProp::${e12} - NOT IMPLEMENTED`);
}
function vtkProp(e12, t) {
  t.classHierarchy.push("vtkProp"), e12.getMTime = () => {
    let e13 = t.mtime;
    for (let n = 0; n < t.textures.length; ++n) {
      let r = t.textures[n].getMTime();
      r > e13 && (e13 = r);
    }
    return e13;
  }, e12.processSelectorPixelBuffers = (e13, t2) => {
  }, e12.getNestedProps = () => null, e12.getActors = () => [], e12.getActors2D = () => [], e12.getVolumes = () => [], e12.pick = notImplemented$5("pick"), e12.hasKey = notImplemented$5("hasKey"), e12.getNestedVisibility = () => t.visibility && (!t._parentProp || t._parentProp.getNestedVisibility()), e12.getNestedPickable = () => t.pickable && (!t._parentProp || t._parentProp.getNestedPickable()), e12.getNestedDragable = () => t.dragable && (!t._parentProp || t._parentProp.getNestedDragable()), e12.getRedrawMTime = () => t.mtime, e12.setEstimatedRenderTime = (e13) => {
    t.estimatedRenderTime = e13, t.savedEstimatedRenderTime = e13;
  }, e12.restoreEstimatedRenderTime = () => {
    t.estimatedRenderTime = t.savedEstimatedRenderTime;
  }, e12.addEstimatedRenderTime = (e13) => {
    t.estimatedRenderTime += e13;
  }, e12.setAllocatedRenderTime = (e13) => {
    t.allocatedRenderTime = e13, t.savedEstimatedRenderTime = t.estimatedRenderTime, t.estimatedRenderTime = 0;
  }, e12.getSupportsSelection = () => false, e12.getTextures = () => t.textures, e12.hasTexture = (e13) => t.textures.indexOf(e13) !== -1, e12.addTexture = (n) => {
    n && !e12.hasTexture(n) && (t.textures = t.textures.concat(n), e12.modified());
  }, e12.removeTexture = (n) => {
    let r = t.textures.filter((e13) => e13 !== n);
    t.textures.length !== r.length && (t.textures = r, e12.modified());
  }, e12.removeAllTextures = () => {
    t.textures = [], e12.modified();
  }, e12.setCoordinateSystemToWorld = () => e12.setCoordinateSystem(CoordinateSystem$4.WORLD), e12.setCoordinateSystemToDisplay = () => e12.setCoordinateSystem(CoordinateSystem$4.DISPLAY);
}
var DEFAULT_VALUES$124 = {
  allocatedRenderTime: 10,
  coordinateSystem: CoordinateSystem$4.WORLD,
  dragable: true,
  estimatedRenderTime: 0,
  paths: null,
  pickable: true,
  renderTimeMultiplier: 1,
  savedEstimatedRenderTime: 0,
  textures: [],
  useBounds: true,
  visibility: true
};
function extend$135(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$124, n), macro.obj(e12, t), macro.get(e12, t, ["estimatedRenderTime", "allocatedRenderTime"]), macro.setGet(e12, t, [
    "_parentProp",
    "coordinateSystem",
    "dragable",
    "pickable",
    "renderTimeMultiplier",
    "useBounds",
    "visibility"
  ]), macro.moveToProtected(e12, t, ["parentProp"]), vtkProp(e12, t);
}
var vtkProp$1 = {
  newInstance: macro.newInstance(extend$135, "vtkProp"),
  extend: extend$135,
  ...Constants$17
}, VTK_EPSILON = 1e-6;
function vtkProp3D(e12, t) {
  t.classHierarchy.push("vtkProp3D"), e12.addPosition = (n2) => {
    t.position = t.position.map((e13, t2) => e13 + n2[t2]), e12.modified();
  }, e12.getOrientationWXYZ = () => {
    let e13 = create$2();
    getRotation(e13, t.rotation);
    let n2 = new Float64Array(3);
    return [
      degreesFromRadians(getAxisAngle(n2, e13)),
      n2[0],
      n2[1],
      n2[2]
    ];
  }, e12.getOrientationQuaternion = function() {
    return getRotation(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t.rotation);
  }, e12.rotateX = (n2) => {
    n2 !== 0 && (rotateX(t.rotation, t.rotation, radiansFromDegrees(n2)), e12.modified());
  }, e12.rotateY = (n2) => {
    n2 !== 0 && (rotateY(t.rotation, t.rotation, radiansFromDegrees(n2)), e12.modified());
  }, e12.rotateZ = (n2) => {
    n2 !== 0 && (rotateZ(t.rotation, t.rotation, radiansFromDegrees(n2)), e12.modified());
  }, e12.rotateWXYZ = (n2, r, a, o) => {
    if (n2 === 0 || r === 0 && a === 0 && o === 0)
      return;
    let s = radiansFromDegrees(n2), c = create$2();
    setAxisAngle(c, [
      r,
      a,
      o
    ], s);
    let l = new Float64Array(16);
    fromQuat(l, c), multiply$2(t.rotation, t.rotation, l), e12.modified();
  }, e12.rotateQuaternion = (n2) => {
    if (Math.abs(n2[3]) >= 1 - VTK_EPSILON)
      return;
    let r = fromQuat(new Float64Array(16), n2);
    multiply$2(t.rotation, t.rotation, r), e12.modified();
  }, e12.setOrientation = (n2, r, a) => n2 === t.orientation[0] && r === t.orientation[1] && a === t.orientation[2] ? false : (t.orientation = [
    n2,
    r,
    a
  ], identity$2(t.rotation), e12.rotateZ(a), e12.rotateX(n2), e12.rotateY(r), e12.modified(), true), e12.setOrientationFromQuaternion = (n2) => {
    let r = create$5();
    return fromQuat(r, n2), areMatricesEqual(r, t.rotation) ? false : (t.rotation = r, e12.modified(), true);
  }, e12.setUserMatrix = (n2) => areMatricesEqual(t.userMatrix, n2) ? false : (copy$4(t.userMatrix, n2), e12.modified(), true), e12.getMatrix = () => (e12.computeMatrix(), t.matrix), e12.computeMatrix = () => {
    if (e12.getMTime() > t.matrixMTime.getMTime()) {
      identity$2(t.matrix), t.userMatrix && multiply$2(t.matrix, t.matrix, t.userMatrix), translate(t.matrix, t.matrix, t.origin), translate(t.matrix, t.matrix, t.position), multiply$2(t.matrix, t.matrix, t.rotation), scale$4(t.matrix, t.matrix, t.scale), translate(t.matrix, t.matrix, [
        -t.origin[0],
        -t.origin[1],
        -t.origin[2]
      ]), transpose(t.matrix, t.matrix), t.isIdentity = true;
      for (let e13 = 0; e13 < 4; ++e13)
        for (let n2 = 0; n2 < 4; ++n2)
          (e13 === n2 ? 1 : 0) !== t.matrix[e13 + n2 * 4] && (t.isIdentity = false);
      t.matrixMTime.modified();
    }
  }, e12.getBoundsByReference = () => {
    if (t.mapper === null)
      return t.bounds;
    let n2 = t.mapper.getBounds();
    if (!n2 || n2.length !== 6)
      return n2;
    if (n2[0] > n2[1])
      return t.mapperBounds = n2, t.bounds = [...vtkBoundingBox.INIT_BOUNDS], t.boundsMTime.modified(), n2;
    if (!t.mapperBounds || !n2.every((e13, r) => n2[r] === t.mapperBounds[r]) || e12.getMTime() > t.boundsMTime.getMTime()) {
      macro.vtkDebugMacro("Recomputing bounds..."), t.mapperBounds = n2, e12.computeMatrix();
      let r = new Float64Array(16);
      transpose(r, t.matrix), vtkBoundingBox.transformBounds(n2, r, t.bounds), t.boundsMTime.modified();
    }
    return t.bounds;
  }, e12.getBounds = () => {
    let t2 = e12.getBoundsByReference();
    try {
      return [...t2];
    } catch {
      return t2;
    }
  }, e12.getCenter = () => vtkBoundingBox.getCenter(t.bounds), e12.getLength = () => vtkBoundingBox.getLength(t.bounds), e12.getXRange = () => vtkBoundingBox.getXRange(t.bounds), e12.getYRange = () => vtkBoundingBox.getYRange(t.bounds), e12.getZRange = () => vtkBoundingBox.getZRange(t.bounds), e12.getUserMatrix = () => t.userMatrix;
  function n() {
    e12.computeMatrix();
  }
  e12.onModified(n), e12.getProperty = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.properties[n2] ?? (t.properties[n2] = e12.makeProperty?.()), t.properties[n2];
  }, e12.getProperties = () => (t.properties.length === 0 && (t.properties[0] = e12.makeProperty?.()), t.properties), e12.setProperty = (e13, n2) => {
    let [r, a] = Number.isInteger(e13) ? [e13, n2] : [0, e13];
    return t.properties[r] === a ? false : (t.properties[r] = a, true);
  }, e12.getMTime = () => {
    let e13 = t.mtime;
    return t.properties.forEach((t2) => {
      if (t2 !== null) {
        let n2 = t2.getMTime();
        e13 = n2 > e13 ? n2 : e13;
      }
    }), e13;
  };
}
var DEFAULT_VALUES$123 = {
  origin: [
    0,
    0,
    0
  ],
  position: [
    0,
    0,
    0
  ],
  orientation: [
    0,
    0,
    0
  ],
  rotation: null,
  scale: [
    1,
    1,
    1
  ],
  bounds: [...vtkBoundingBox.INIT_BOUNDS],
  properties: [],
  userMatrix: null,
  userMatrixMTime: null,
  cachedProp3D: null,
  isIdentity: true,
  matrixMTime: null
};
function extend$134(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$123, n), vtkProp$1.extend(e12, t, n), t.matrixMTime = {}, macro.obj(t.matrixMTime), macro.get(e12, t, ["isIdentity"]), macro.getArray(e12, t, ["orientation"]), macro.setGetArray(e12, t, [
    "origin",
    "position",
    "scale"
  ], 3), macro.setGet(e12, t, ["properties"]), t.matrix = identity$2(new Float64Array(16)), t.rotation = identity$2(new Float64Array(16)), t.userMatrix = identity$2(new Float64Array(16)), t.transform = null, vtkProp3D(e12, t);
}
var vtkProp3D$1 = {
  newInstance: macro.newInstance(extend$134, "vtkProp3D"),
  extend: extend$134
}, InterpolationType$2 = {
  NEAREST: 0,
  LINEAR: 1,
  FAST_LINEAR: 2
}, OpacityMode = {
  FRACTIONAL: 0,
  PROPORTIONAL: 1
}, ColorMixPreset = {
  DEFAULT: 0,
  ADDITIVE: 1,
  COLORIZE: 2,
  CUSTOM: 3
}, Constants$16 = {
  InterpolationType: InterpolationType$2,
  OpacityMode,
  ColorMixPreset,
  FilterMode: {
    OFF: 0,
    NORMALIZED: 1,
    RAW: 2
  }
}, { InterpolationType: InterpolationType$3, OpacityMode: OpacityMode$1, FilterMode, ColorMixPreset: ColorMixPreset$1 } = Constants$16, { vtkErrorMacro: vtkErrorMacro$38 } = macro, VTK_MAX_VRCOMP$1 = 4;
function vtkVolumeProperty(e12, t) {
  t.classHierarchy.push("vtkVolumeProperty");
  let n = { ...e12 };
  e12.getMTime = () => {
    let e13 = t.mtime, n2;
    for (let r = 0; r < VTK_MAX_VRCOMP$1; r++)
      t.componentData[r].colorChannels === 1 ? t.componentData[r].grayTransferFunction && (n2 = t.componentData[r].grayTransferFunction.getMTime(), e13 = e13 > n2 ? e13 : n2) : t.componentData[r].colorChannels === 3 && t.componentData[r].rGBTransferFunction && (n2 = t.componentData[r].rGBTransferFunction.getMTime(), e13 = e13 > n2 ? e13 : n2), t.componentData[r].scalarOpacity && (n2 = t.componentData[r].scalarOpacity.getMTime(), e13 = e13 > n2 ? e13 : n2), t.componentData[r].gradientOpacity && (t.componentData[r].disableGradientOpacity || (n2 = t.componentData[r].gradientOpacity.getMTime(), e13 = e13 > n2 ? e13 : n2));
    return e13;
  }, e12.getColorChannels = (e13) => e13 < 0 || e13 > 3 ? (vtkErrorMacro$38("Bad index - must be between 0 and 3"), 0) : t.componentData[e13].colorChannels, e12.setGrayTransferFunction = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = false;
    return t.componentData[n2].grayTransferFunction !== r && (t.componentData[n2].grayTransferFunction = r, a = true), t.componentData[n2].colorChannels !== 1 && (t.componentData[n2].colorChannels = 1, a = true), a && e12.modified(), a;
  }, e12.getGrayTransferFunction = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[n2].grayTransferFunction === null && (t.componentData[n2].grayTransferFunction = vtkPiecewiseFunction$1.newInstance(), t.componentData[n2].grayTransferFunction.addPoint(0, 0), t.componentData[n2].grayTransferFunction.addPoint(1024, 1), t.componentData[n2].colorChannels !== 1 && (t.componentData[n2].colorChannels = 1), e12.modified()), t.componentData[n2].grayTransferFunction;
  }, e12.setRGBTransferFunction = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = false;
    return t.componentData[n2].rGBTransferFunction !== r && (t.componentData[n2].rGBTransferFunction = r, a = true), t.componentData[n2].colorChannels !== 3 && (t.componentData[n2].colorChannels = 3, a = true), a && e12.modified(), a;
  }, e12.getRGBTransferFunction = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[n2].rGBTransferFunction === null && (t.componentData[n2].rGBTransferFunction = vtkColorTransferFunction$1.newInstance(), t.componentData[n2].rGBTransferFunction.addRGBPoint(0, 0, 0, 0), t.componentData[n2].rGBTransferFunction.addRGBPoint(1024, 1, 1, 1), t.componentData[n2].colorChannels !== 3 && (t.componentData[n2].colorChannels = 3), e12.modified()), t.componentData[n2].rGBTransferFunction;
  }, e12.setScalarOpacity = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return t.componentData[n2].scalarOpacity === r ? false : (t.componentData[n2].scalarOpacity = r, e12.modified(), true);
  }, e12.getScalarOpacity = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[n2].scalarOpacity === null && (t.componentData[n2].scalarOpacity = vtkPiecewiseFunction$1.newInstance(), t.componentData[n2].scalarOpacity.addPoint(0, 1), t.componentData[n2].scalarOpacity.addPoint(1024, 1), e12.modified()), t.componentData[n2].scalarOpacity;
  }, e12.setComponentWeight = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (n2 < 0 || n2 >= VTK_MAX_VRCOMP$1)
      return vtkErrorMacro$38("Invalid index"), false;
    let a = Math.min(1, Math.max(0, r));
    return t.componentData[n2].componentWeight === a ? false : (t.componentData[n2].componentWeight = a, e12.modified(), true);
  }, e12.getComponentWeight = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return e13 < 0 || e13 >= VTK_MAX_VRCOMP$1 ? (vtkErrorMacro$38("Invalid index"), 0) : t.componentData[e13].componentWeight;
  }, e12.setInterpolationTypeToNearest = () => e12.setInterpolationType(InterpolationType$3.NEAREST), e12.setInterpolationTypeToLinear = () => e12.setInterpolationType(InterpolationType$3.LINEAR), e12.setInterpolationTypeToFastLinear = () => e12.setInterpolationType(InterpolationType$3.FAST_LINEAR), e12.getInterpolationTypeAsString = () => macro.enumToString(InterpolationType$3, t.interpolationType), [
    "useGradientOpacity",
    "scalarOpacityUnitDistance",
    "gradientOpacityMinimumValue",
    "gradientOpacityMinimumOpacity",
    "gradientOpacityMaximumValue",
    "gradientOpacityMaximumOpacity",
    "opacityMode",
    "forceNearestInterpolation"
  ].forEach((n2) => {
    let r = macro.capitalize(n2);
    e12[`set${r}`] = (r2, a) => t.componentData[r2][`${n2}`] === a ? false : (t.componentData[r2][`${n2}`] = a, e12.modified(), true);
  }), [
    "useGradientOpacity",
    "scalarOpacityUnitDistance",
    "gradientOpacityMinimumValue",
    "gradientOpacityMinimumOpacity",
    "gradientOpacityMaximumValue",
    "gradientOpacityMaximumOpacity",
    "opacityMode",
    "forceNearestInterpolation"
  ].forEach((n2) => {
    let r = macro.capitalize(n2);
    e12[`get${r}`] = (e13) => t.componentData[e13][`${n2}`];
  }), e12.setAverageIPScalarRange = (t2, n2) => {
    console.warn("setAverageIPScalarRange is deprecated use setIpScalarRange"), e12.setIpScalarRange(t2, n2);
  }, e12.getFilterModeAsString = () => macro.enumToString(FilterMode, t.filterMode), e12.setFilterModeToOff = () => {
    e12.setFilterMode(FilterMode.OFF);
  }, e12.setFilterModeToNormalized = () => {
    e12.setFilterMode(FilterMode.NORMALIZED);
  }, e12.setFilterModeToRaw = () => {
    e12.setFilterMode(FilterMode.RAW);
  }, e12.setGlobalIlluminationReach = (e13) => n.setGlobalIlluminationReach(clampValue(e13, 0, 1)), e12.setVolumetricScatteringBlending = (e13) => n.setVolumetricScatteringBlending(clampValue(e13, 0, 1)), e12.setAnisotropy = (e13) => n.setAnisotropy(clampValue(e13, -0.99, 0.99)), e12.setLAOKernelSize = (e13) => n.setLAOKernelSize(floor(clampValue(e13, 1, 32))), e12.setLAOKernelRadius = (e13) => n.setLAOKernelRadius(e13 >= 1 ? e13 : 1);
}
var defaultValues$8 = (e12) => ({
  colorMixPreset: ColorMixPreset$1.DEFAULT,
  independentComponents: true,
  interpolationType: InterpolationType$3.FAST_LINEAR,
  shade: false,
  ambient: 0.1,
  diffuse: 0.7,
  specular: 0.2,
  specularPower: 10,
  useLabelOutline: false,
  labelOutlineThickness: [1],
  labelOutlineOpacity: 1,
  ipScalarRange: [-1e6, 1e6],
  filterMode: FilterMode.OFF,
  preferSizeOverAccuracy: false,
  computeNormalFromOpacity: false,
  volumetricScatteringBlending: 0,
  globalIlluminationReach: 0,
  anisotropy: 0,
  localAmbientOcclusion: false,
  LAOKernelSize: 15,
  LAOKernelRadius: 7,
  updatedExtents: [],
  ...e12
});
function extend$133(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (Object.assign(t, defaultValues$8(n)), macro.obj(e12, t), !t.componentData) {
    t.componentData = [];
    for (let e13 = 0; e13 < VTK_MAX_VRCOMP$1; ++e13)
      t.componentData.push({
        colorChannels: 1,
        grayTransferFunction: null,
        rGBTransferFunction: null,
        scalarOpacity: null,
        scalarOpacityUnitDistance: 1,
        opacityMode: OpacityMode$1.FRACTIONAL,
        gradientOpacityMinimumValue: 0,
        gradientOpacityMinimumOpacity: 0,
        gradientOpacityMaximumValue: 1,
        gradientOpacityMaximumOpacity: 1,
        useGradientOpacity: false,
        componentWeight: 1,
        forceNearestInterpolation: false
      });
  }
  macro.setGet(e12, t, [
    "colorMixPreset",
    "independentComponents",
    "interpolationType",
    "shade",
    "ambient",
    "diffuse",
    "specular",
    "specularPower",
    "useLabelOutline",
    "labelOutlineOpacity",
    "filterMode",
    "preferSizeOverAccuracy",
    "computeNormalFromOpacity",
    "volumetricScatteringBlending",
    "globalIlluminationReach",
    "anisotropy",
    "localAmbientOcclusion",
    "LAOKernelSize",
    "LAOKernelRadius",
    "updatedExtents"
  ]), macro.setGetArray(e12, t, ["ipScalarRange"], 2), macro.setGetArray(e12, t, ["labelOutlineThickness"]), vtkVolumeProperty(e12, t);
}
var vtkVolumeProperty$1 = {
  newInstance: macro.newInstance(extend$133, "vtkVolumeProperty"),
  extend: extend$133,
  ...Constants$16
};
function vtkVolume$2(e12, t) {
  t.classHierarchy.push("vtkVolume"), e12.getVolumes = () => [e12], e12.makeProperty = vtkVolumeProperty$1.newInstance, e12.getRedrawMTime = () => {
    let e13 = t.mtime;
    if (t.mapper !== null) {
      let n = t.mapper.getMTime();
      e13 = n > e13 ? n : e13, t.mapper.getInput() !== null && (t.mapper.getInputAlgorithm().update(), n = t.mapper.getInput().getMTime(), e13 = n > e13 ? n : e13);
    }
    return e13;
  };
}
var DEFAULT_VALUES$122 = { mapper: null };
function extend$132(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$122, n), vtkProp3D$1.extend(e12, t, n), t.boundsMTime = {}, macro.obj(t.boundsMTime), macro.setGet(e12, t, ["mapper"]), vtkVolume$2(e12, t);
}
var vtkVolume$1 = {
  newInstance: macro.newInstance(extend$132, "vtkVolume"),
  extend: extend$132
}, { vtkErrorMacro: vtkErrorMacro$37 } = macro, PASS_TYPES = ["Build", "Render"];
function vtkViewNode(e12, t) {
  t.classHierarchy.push("vtkViewNode"), e12.build = (e13) => {
  }, e12.render = (e13) => {
  }, e12.traverse = (n2) => {
    let r = e12[n2.getTraverseOperation()];
    if (r) {
      r(n2);
      return;
    }
    e12.apply(n2, true);
    for (let e13 = 0; e13 < t.children.length; e13++)
      t.children[e13].traverse(n2);
    e12.apply(n2, false);
  }, e12.apply = (t2, n2) => {
    let r = e12[t2.getOperation()];
    r && r(n2, t2);
  }, e12.getViewNodeFor = (n2) => {
    if (t.renderable === n2)
      return e12;
    for (let e13 = 0; e13 < t.children.length; ++e13) {
      let r = t.children[e13].getViewNodeFor(n2);
      if (r)
        return r;
    }
  }, e12.getFirstAncestorOfType = (e13) => t._parent ? t._parent.isA(e13) ? t._parent : t._parent.getFirstAncestorOfType(e13) : null, e12.getLastAncestorOfType = (e13) => t._parent ? t._parent.getLastAncestorOfType(e13) || (t._parent.isA(e13) ? t._parent : null) : null, e12.addMissingNode = (n2) => {
    if (!n2)
      return;
    let r = t._renderableChildMap.get(n2);
    if (r !== void 0)
      return r.setVisited(true), r;
    let a = e12.createViewNode(n2);
    if (a)
      return a.setParent(e12), a.setVisited(true), t._renderableChildMap.set(n2, a), t.children.push(a), a;
  }, e12.addMissingNodes = function(n2) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!(!n2 || !n2.length))
      for (let a = 0; a < n2.length; ++a) {
        let o = n2[a], s = e12.addMissingNode(o);
        if (r && s !== void 0 && t.children[a] !== s) {
          for (let e13 = a + 1; e13 < t.children.length; ++e13)
            if (t.children[e13] === s) {
              t.children.splice(e13, 1), t.children.splice(a, 0, s);
              break;
            }
        }
      }
  }, e12.addMissingChildren = (n2) => {
    if (!(!n2 || !n2.length))
      for (let r = 0; r < n2.length; ++r) {
        let a = n2[r];
        if (t.children.indexOf(a) === -1) {
          a.setParent(e12), t.children.push(a);
          let n3 = a.getRenderable();
          n3 && t._renderableChildMap.set(n3, a);
        }
        a.setVisited(true);
      }
  }, e12.removeNode = (e13) => {
    let n2 = t.children.findIndex((t2) => t2 === e13);
    if (n2 < 0)
      return false;
    let r = e13.getRenderable();
    return r && t._renderableChildMap.delete(r), e13.delete(), t.children.splice(n2, 1), true;
  }, e12.prepareNodes = () => {
    for (let e13 = 0; e13 < t.children.length; ++e13)
      t.children[e13].setVisited(false);
  }, e12.setVisited = (e13) => {
    t.visited = e13;
  }, e12.removeUnusedNodes = () => {
    let e13 = 0;
    for (let n2 = 0; n2 < t.children.length; ++n2) {
      let r = t.children[n2];
      if (r.getVisited())
        t.children[e13++] = r, r.setVisited(false);
      else {
        let e14 = r.getRenderable();
        e14 && t._renderableChildMap.delete(e14), r.delete();
      }
    }
    t.children.length = e13;
  }, e12.createViewNode = (e13) => {
    if (!t.myFactory)
      return vtkErrorMacro$37("Cannot create view nodes without my own factory"), null;
    let n2 = t.myFactory.createNode(e13);
    return n2 && n2.setRenderable(e13), n2;
  };
  let n = e12.delete;
  e12.delete = () => {
    for (let e13 = 0; e13 < t.children.length; e13++)
      t.children[e13].delete();
    n();
  };
}
var DEFAULT_VALUES$121 = {
  renderable: null,
  myFactory: null,
  children: [],
  visited: false
};
function extend$131(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$121, n), macro.obj(e12, t), macro.event(e12, t, "event"), t._renderableChildMap = /* @__PURE__ */ new Map(), macro.get(e12, t, ["visited"]), macro.setGet(e12, t, [
    "_parent",
    "renderable",
    "myFactory"
  ]), macro.getArray(e12, t, ["children"]), macro.moveToProtected(e12, t, ["parent"]), vtkViewNode(e12, t);
}
var vtkViewNode$1 = {
  newInstance: macro.newInstance(extend$131, "vtkViewNode"),
  extend: extend$131,
  PASS_TYPES
};
function vtkViewNodeFactory$2(e12, t) {
  t.overrides ||= {}, t.classHierarchy.push("vtkViewNodeFactory"), e12.createNode = (n) => {
    if (n.isDeleted())
      return null;
    let r = 0, a = n.getClassName(r++), o = false, s = Object.keys(t.overrides);
    for (; a && !o; )
      s.indexOf(a) === -1 ? a = n.getClassName(r++) : o = true;
    if (!o)
      return null;
    let c = t.overrides[a]();
    return c.setMyFactory(e12), c;
  };
}
var DEFAULT_VALUES$120 = {};
function extend$130(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$120, n), macro.obj(e12, t), vtkViewNodeFactory$2(e12, t);
}
var vtkViewNodeFactory$1 = {
  newInstance: macro.newInstance(extend$130, "vtkViewNodeFactory"),
  extend: extend$130
}, CLASS_MAPPING$2 = /* @__PURE__ */ Object.create(null);
function registerOverride$1(e12, t) {
  CLASS_MAPPING$2[e12] = t;
}
function vtkOpenGLViewNodeFactory(e12, t) {
  t.classHierarchy.push("vtkOpenGLViewNodeFactory");
}
var DEFAULT_VALUES$119 = {};
function extend$129(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$119, n), t.overrides = CLASS_MAPPING$2, vtkViewNodeFactory$1.extend(e12, t, n), vtkOpenGLViewNodeFactory(e12, t);
}
var vtkViewNodeFactory = {
  newInstance: macro.newInstance(extend$129, "vtkOpenGLViewNodeFactory"),
  extend: extend$129
};
function vtkOpenGLCamera(e12, t) {
  t.classHierarchy.push("vtkOpenGLCamera"), e12.buildPass = (n) => {
    n && (t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.context = t._openGLRenderWindow.getContext());
  }, e12.opaquePass = (e13) => {
    if (e13) {
      let e14 = t._openGLRenderer.getTiledSizeAndOrigin();
      t.context.viewport(e14.lowerLeftU, e14.lowerLeftV, e14.usize, e14.vsize), t.context.scissor(e14.lowerLeftU, e14.lowerLeftV, e14.usize, e14.vsize);
    }
  }, e12.translucentPass = e12.opaquePass, e12.zBufferPass = e12.opaquePass, e12.opaqueZBufferPass = e12.opaquePass, e12.volumePass = e12.opaquePass, e12.getKeyMatrices = (n) => {
    if (n !== t.lastRenderer || t._openGLRenderWindow.getMTime() > t.keyMatrixTime.getMTime() || e12.getMTime() > t.keyMatrixTime.getMTime() || n.getMTime() > t.keyMatrixTime.getMTime() || t.renderable.getMTime() > t.keyMatrixTime.getMTime()) {
      copy$4(t.keyMatrices.wcvc, t.renderable.getViewMatrix()), fromMat4(t.keyMatrices.normalMatrix, t.keyMatrices.wcvc), invert$1(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), transpose(t.keyMatrices.wcvc, t.keyMatrices.wcvc);
      let e13 = t._openGLRenderer.getAspectRatio();
      copy$4(t.keyMatrices.vcpc, t.renderable.getProjectionMatrix(e13, -1, 1)), transpose(t.keyMatrices.vcpc, t.keyMatrices.vcpc), multiply$2(t.keyMatrices.wcpc, t.keyMatrices.vcpc, t.keyMatrices.wcvc), t.keyMatrixTime.modified(), t.lastRenderer = n;
    }
    return t.keyMatrices;
  };
}
var DEFAULT_VALUES$118 = {
  context: null,
  lastRenderer: null,
  keyMatrixTime: null,
  keyMatrices: null
};
function extend$128(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$118, n), vtkViewNode$1.extend(e12, t, n), t.keyMatrixTime = {}, obj(t.keyMatrixTime), t.keyMatrices = {
    normalMatrix: new Float64Array(9),
    vcpc: new Float64Array(16),
    wcvc: new Float64Array(16),
    wcpc: new Float64Array(16)
  }, setGet(e12, t, ["context", "keyMatrixTime"]), vtkOpenGLCamera(e12, t);
}
var newInstance$122 = newInstance(extend$128), vtkCamera$2 = {
  newInstance: newInstance$122,
  extend: extend$128
};
registerOverride$1("vtkCamera", newInstance$122);
var { vtkDebugMacro: vtkDebugMacro$8 } = macro$1;
function vtkOpenGLRenderer(e12, t) {
  t.classHierarchy.push("vtkOpenGLRenderer"), e12.buildPass = (n) => {
    if (n) {
      if (!t.renderable)
        return;
      e12.updateLights(), e12.prepareNodes(), e12.addMissingNode(t.renderable.getActiveCamera()), e12.addMissingNodes(t.renderable.getViewPropsWithNestedProps(), true), e12.removeUnusedNodes();
    }
  }, e12.updateLights = () => {
    let e13 = 0, n = t.renderable.getLightsByReference();
    for (let t2 = 0; t2 < n.length; ++t2)
      n[t2].getSwitch() > 0 && e13++;
    return e13 || (vtkDebugMacro$8("No lights are on, creating one."), t.renderable.createLight()), e13;
  }, e12.zBufferPass = (n) => {
    if (n) {
      let n2 = 0, r = t.context;
      t.renderable.getTransparent() || (t.context.clearColor(1, 0, 0, 1), n2 |= r.COLOR_BUFFER_BIT), t.renderable.getPreserveDepthBuffer() || (r.clearDepth(1), n2 |= r.DEPTH_BUFFER_BIT, t.context.depthMask(true));
      let a = e12.getTiledSizeAndOrigin();
      r.enable(r.SCISSOR_TEST), r.scissor(a.lowerLeftU, a.lowerLeftV, a.usize, a.vsize), r.viewport(a.lowerLeftU, a.lowerLeftV, a.usize, a.vsize), r.colorMask(true, true, true, true), n2 && r.clear(n2), r.enable(r.DEPTH_TEST);
    }
  }, e12.opaqueZBufferPass = (t2) => e12.zBufferPass(t2), e12.cameraPass = (t2) => {
    t2 && e12.clear();
  }, e12.getAspectRatio = () => {
    let e13 = t._parent.getSizeByReference(), n = t.renderable.getViewportByReference();
    return e13[0] * (n[2] - n[0]) / ((n[3] - n[1]) * e13[1]);
  }, e12.getTiledSizeAndOrigin = () => {
    let e13 = t.renderable.getViewportByReference(), n = [
      0,
      0,
      1,
      1
    ], r = e13[0] - n[0], a = e13[1] - n[1], o = t._parent.normalizedDisplayToDisplay(r, a), s = Math.round(o[0]), c = Math.round(o[1]), l = e13[2] - n[0], u = e13[3] - n[1], d = t._parent.normalizedDisplayToDisplay(l, u), f = Math.round(d[0]) - s, p = Math.round(d[1]) - c;
    return f < 0 && (f = 0), p < 0 && (p = 0), {
      usize: f,
      vsize: p,
      lowerLeftU: s,
      lowerLeftV: c
    };
  }, e12.clear = () => {
    let n = 0, r = t.context;
    if (!t.renderable.getTransparent()) {
      let e13 = t.renderable.getBackgroundByReference();
      r.clearColor(e13[0], e13[1], e13[2], e13[3]), n |= r.COLOR_BUFFER_BIT;
    }
    t.renderable.getPreserveDepthBuffer() || (r.clearDepth(1), n |= r.DEPTH_BUFFER_BIT, r.depthMask(true)), r.colorMask(true, true, true, true);
    let a = e12.getTiledSizeAndOrigin();
    r.enable(r.SCISSOR_TEST), r.scissor(a.lowerLeftU, a.lowerLeftV, a.usize, a.vsize), r.viewport(a.lowerLeftU, a.lowerLeftV, a.usize, a.vsize), n && r.clear(n), r.enable(r.DEPTH_TEST);
  }, e12.releaseGraphicsResources = () => {
    t.selector !== null && t.selector.releaseGraphicsResources(), t.renderable && t.renderable.getViewProps().forEach((e13) => {
      e13.modified();
    });
  }, e12.setOpenGLRenderWindow = (n) => {
    t._openGLRenderWindow !== n && (e12.releaseGraphicsResources(), t._openGLRenderWindow = n, t.context = null, n && (t.context = t._openGLRenderWindow.getContext()));
  };
}
var DEFAULT_VALUES$117 = {
  context: null,
  _openGLRenderWindow: null,
  selector: null
};
function extend$127(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$117, n), vtkViewNode$1.extend(e12, t, n), get(e12, t, ["shaderCache"]), setGet(e12, t, ["selector"]), moveToProtected(e12, t, ["openGLRenderWindow"]), vtkOpenGLRenderer(e12, t);
}
var newInstance$121 = newInstance(extend$127, "vtkOpenGLRenderer"), vtkRenderer$2 = {
  newInstance: newInstance$121,
  extend: extend$127
};
registerOverride$1("vtkRenderer", newInstance$121);
var { isVtkObject: isVtkObject$1 } = macro;
function extractCellSizes(e12) {
  let t = 0;
  return e12.filter((e13, n) => n === t ? (t += e13 + 1, true) : false);
}
function getNumberOfCells(e12) {
  let t = 0;
  for (let n = 0; n < e12.length; )
    n += e12[n] + 1, t++;
  return t;
}
var STATIC$11 = {
  extractCellSizes,
  getNumberOfCells
};
function vtkCellArray(e12, t) {
  t.classHierarchy.push("vtkCellArray");
  let n = { ...e12 };
  e12.getNumberOfCells = (n2) => (t.numberOfCells !== void 0 && !n2 || (t.cellSizes ? t.numberOfCells = t.cellSizes.length : t.numberOfCells = getNumberOfCells(e12.getData())), t.numberOfCells), e12.getCellSizes = (n2) => (t.cellSizes !== void 0 && !n2 || (t.cellSizes = extractCellSizes(e12.getData())), t.cellSizes), e12.resize = (r) => {
    let a = e12.getNumberOfTuples();
    n.resize(r);
    let o = e12.getNumberOfTuples();
    o < a && (o === 0 ? (t.numberOfCells = 0, t.cellSizes = []) : (t.numberOfCells = void 0, t.cellSizes = void 0));
  }, e12.setData = (e13) => {
    n.setData(e13, 1), t.numberOfCells = void 0, t.cellSizes = void 0;
  }, e12.getCell = (e13) => {
    let n2 = e13, r = t.values[n2++];
    return t.values.subarray(n2, n2 + r);
  }, e12.insertNextCell = (n2) => {
    let r;
    r = isVtkObject$1(n2) ? n2.getPointsIds() : n2;
    let a = e12.getNumberOfCells();
    return e12.insertNextTuples([r.length, ...r]), ++t.numberOfCells, t.cellSizes != null && t.cellSizes.push(r.length), a;
  }, e12.getMaxCellSize = () => e12.getCellSizes().reduce((e13, t2) => Math.max(e13, t2), 0);
}
function defaultValues$7(e12) {
  return {
    empty: true,
    numberOfComponents: 1,
    dataType: VtkDataTypes.UNSIGNED_INT,
    ...e12
  };
}
function extend$126(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  vtkDataArray$1.extend(e12, t, defaultValues$7(n)), vtkCellArray(e12, t);
}
var vtkCellArray$1 = {
  newInstance: macro.newInstance(extend$126, "vtkCellArray"),
  extend: extend$126,
  ...STATIC$11
}, { vtkErrorMacro: vtkErrorMacro$36 } = macro;
function vtkPoints(e12, t) {
  let n = 0;
  t.classHierarchy.push("vtkPoints"), e12.getNumberOfPoints = e12.getNumberOfTuples, e12.setNumberOfPoints = function(n2) {
    let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    e12.getNumberOfPoints() !== n2 && (t.size = n2 * r2, t.values = macro.newTypedArray(t.dataType, t.size), e12.setNumberOfComponents(r2), e12.modified());
  }, e12.setPoint = function(t2) {
    var n2 = [...arguments].slice(1);
    e12.setTuple(t2, n2);
  }, e12.getPoint = e12.getTuple, e12.findPoint = e12.findTuple, e12.insertNextPoint = (t2, n2, r2) => e12.insertNextTuple([
    t2,
    n2,
    r2
  ]), e12.insertPoint = (t2, n2) => e12.insertTuple(t2, n2);
  let r = e12.getBounds;
  e12.getBounds = () => (n < t.mtime && e12.computeBounds(), r());
  let a = e12.getBoundsByReference;
  e12.getBoundsByReference = () => (n < t.mtime && e12.computeBounds(), a()), e12.computeBounds = () => {
    if (e12.getNumberOfComponents() === 3) {
      let n2 = e12.getRange(0);
      t.bounds[0] = n2[0], t.bounds[1] = n2[1];
      let r2 = e12.getRange(1);
      t.bounds[2] = r2[0], t.bounds[3] = r2[1];
      let a2 = e12.getRange(2);
      t.bounds[4] = a2[0], t.bounds[5] = a2[1];
    } else if (e12.getNumberOfComponents() === 2) {
      let n2 = e12.getRange(0);
      t.bounds[0] = n2[0], t.bounds[1] = n2[1];
      let r2 = e12.getRange(1);
      t.bounds[2] = r2[0], t.bounds[3] = r2[1], t.bounds[4] = 0, t.bounds[5] = 0;
    } else
      vtkErrorMacro$36(`getBounds called on an array with components of ${e12.getNumberOfComponents()}`), uninitializeBounds(t.bounds);
    n = macro.getCurrentGlobalMTime();
  }, e12.setNumberOfComponents(t.numberOfComponents < 2 ? 3 : t.numberOfComponents);
}
var DEFAULT_VALUES$116 = {
  empty: true,
  numberOfComponents: 3,
  dataType: VtkDataTypes.FLOAT,
  bounds: [
    1,
    -1,
    1,
    -1,
    1,
    -1
  ]
};
function extend$125(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$116, n), vtkDataArray$1.extend(e12, t, n), macro.getArray(e12, t, ["bounds"], 6), vtkPoints(e12, t);
}
var vtkPoints$1 = {
  newInstance: macro.newInstance(extend$125, "vtkPoints"),
  extend: extend$125
};
function vtkCell(e12, t) {
  t.classHierarchy.push("vtkCell"), e12.initialize = function(e13) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (n) {
      t.pointsIds = n;
      let r = t.points.getData();
      r.length !== 3 * t.pointsIds.length && (r = macro.newTypedArray(e13.getDataType(), 3 * t.pointsIds.length));
      let a = e13.getData();
      t.pointsIds.forEach((e14, t2) => {
        let n2 = 3 * e14, o = 3 * t2;
        r[o] = a[n2], r[++o] = a[++n2], r[++o] = a[++n2];
      }), t.points.setData(r);
    } else {
      t.points = e13, t.pointsIds = Array(e13.getNumberOfPoints());
      for (let n2 = e13.getNumberOfPoints() - 1; n2 >= 0; --n2)
        t.pointsIds[n2] = n2;
    }
  }, e12.getBounds = () => t.points.getBounds(), e12.getLength2 = () => {
    let t2 = vtkBoundingBox.getLengths(e12.getBounds());
    return t2[0] * t2[0] + t2[1] * t2[1] + t2[2] * t2[2];
  }, e12.getParametricDistance = (e13) => {
    let t2, n = 0;
    for (let r = 0; r < 3; r++)
      t2 = e13[r] < 0 ? -e13[r] : e13[r] > 1 ? e13[r] - 1 : 0, t2 > n && (n = t2);
    return n;
  }, e12.getNumberOfPoints = () => t.points.getNumberOfPoints(), e12.deepCopy = (e13) => {
    e13.initialize(t.points, t.pointsIds);
  }, e12.getCellDimension = () => {
  }, e12.intersectWithLine = (e13, t2, n, r, a, o, s) => {
  }, e12.evaluatePosition = (e13, t2, n, r, a, o) => {
    macro.vtkErrorMacro("vtkCell.evaluatePosition is not implemented.");
  };
}
var DEFAULT_VALUES$115 = {
  bounds: [
    -1,
    -1,
    -1,
    -1,
    -1,
    -1
  ],
  pointsIds: []
};
function extend$124(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$115, n), macro.obj(e12, t), t.points ||= vtkPoints$1.newInstance(), macro.get(e12, t, ["points", "pointsIds"]), vtkCell(e12, t);
}
var vtkCell$1 = {
  newInstance: macro.newInstance(extend$124, "vtkCell"),
  extend: extend$124
};
function resize(e12, t) {
  let n = t;
  for (t >= e12.array.length && (n += e12.array.length); n > e12.array.length; )
    e12.array.push({
      ncells: 0,
      cells: null
    });
  e12.array.length = n;
}
function vtkCellLinks(e12, t) {
  t.classHierarchy.push("vtkCellLinks"), e12.buildLinks = (n) => {
    let r = n.getPoints().getNumberOfPoints(), a = n.getNumberOfCells(), o = new Uint32Array(r);
    if (n.isA("vtkPolyData")) {
      for (let t2 = 0; t2 < a; ++t2) {
        let { cellPointIds: r2 } = n.getCellPoints(t2);
        r2.forEach((t3) => {
          e12.incrementLinkCount(t3);
        });
      }
      e12.allocateLinks(r), t.maxId = r - 1;
      for (let t2 = 0; t2 < a; ++t2) {
        let { cellPointIds: r2 } = n.getCellPoints(t2);
        r2.forEach((n2) => {
          e12.insertCellReference(n2, o[n2]++, t2);
        });
      }
    } else {
      for (let t2 = 0; t2 < a; t2++)
        vtkCell$1.newInstance().getPointsIds().forEach((t3) => {
          e12.incrementLinkCount(t3);
        });
      e12.allocateLinks(r), t.maxId = r - 1;
      for (let t2 = 0; t2 < a; ++t2)
        vtkCell$1.newInstance().getPointsIds().forEach((n2) => {
          e12.insertCellReference(n2, o[n2]++, t2);
        });
    }
  }, e12.allocate = function(e13) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3;
    t.array = Array(e13).fill().map(() => ({
      ncells: 0,
      cells: null
    })), t.extend = n, t.maxId = -1;
  }, e12.initialize = () => {
    t.array = null;
  }, e12.getLink = (e13) => t.array[e13], e12.getNcells = (e13) => t.array[e13].ncells, e12.getCells = (e13) => t.array[e13].cells, e12.insertNextPoint = (e13) => {
    t.array.push({
      ncells: e13,
      cells: Array(e13)
    }), ++t.maxId;
  }, e12.insertNextCellReference = (e13, n) => {
    t.array[e13].cells[t.array[e13].ncells++] = n;
  }, e12.deletePoint = (e13) => {
    t.array[e13].ncells = 0, t.array[e13].cells = null;
  }, e12.removeCellReference = (e13, n) => {
    t.array[n].cells = t.array[n].cells.filter((t2) => t2 !== e13), t.array[n].ncells = t.array[n].cells.length;
  }, e12.addCellReference = (e13, n) => {
    t.array[n].cells[t.array[n].ncells++] = e13;
  }, e12.resizeCellList = (e13, n) => {
    t.array[e13].cells.length = n;
  }, e12.squeeze = () => {
    resize(t, t.maxId + 1);
  }, e12.reset = () => {
    t.maxId = -1;
  }, e12.deepCopy = (e13) => {
    t.array = [...e13.array], t.extend = e13.extend, t.maxId = e13.maxId;
  }, e12.incrementLinkCount = (e13) => {
    ++t.array[e13].ncells;
  }, e12.allocateLinks = (e13) => {
    for (let n = 0; n < e13; ++n)
      t.array[n].cells = Array(t.array[n].ncells);
  }, e12.insertCellReference = (e13, n, r) => {
    t.array[e13].cells[n] = r;
  };
}
var DEFAULT_VALUES$114 = {
  array: null,
  maxId: 0,
  extend: 0
};
function extend$123(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$114, n), macro.obj(e12, t), vtkCellLinks(e12, t);
}
var vtkCellLinks$1 = {
  newInstance: macro.newInstance(extend$123, "vtkCellLinks"),
  extend: extend$123
}, CellType = {
  VTK_EMPTY_CELL: 0,
  VTK_VERTEX: 1,
  VTK_POLY_VERTEX: 2,
  VTK_LINE: 3,
  VTK_POLY_LINE: 4,
  VTK_TRIANGLE: 5,
  VTK_TRIANGLE_STRIP: 6,
  VTK_POLYGON: 7,
  VTK_PIXEL: 8,
  VTK_QUAD: 9,
  VTK_TETRA: 10,
  VTK_VOXEL: 11,
  VTK_HEXAHEDRON: 12,
  VTK_WEDGE: 13,
  VTK_PYRAMID: 14,
  VTK_PENTAGONAL_PRISM: 15,
  VTK_HEXAGONAL_PRISM: 16,
  VTK_QUADRATIC_EDGE: 21,
  VTK_QUADRATIC_TRIANGLE: 22,
  VTK_QUADRATIC_QUAD: 23,
  VTK_QUADRATIC_POLYGON: 36,
  VTK_QUADRATIC_TETRA: 24,
  VTK_QUADRATIC_HEXAHEDRON: 25,
  VTK_QUADRATIC_WEDGE: 26,
  VTK_QUADRATIC_PYRAMID: 27,
  VTK_BIQUADRATIC_QUAD: 28,
  VTK_TRIQUADRATIC_HEXAHEDRON: 29,
  VTK_QUADRATIC_LINEAR_QUAD: 30,
  VTK_QUADRATIC_LINEAR_WEDGE: 31,
  VTK_BIQUADRATIC_QUADRATIC_WEDGE: 32,
  VTK_BIQUADRATIC_QUADRATIC_HEXAHEDRON: 33,
  VTK_BIQUADRATIC_TRIANGLE: 34,
  VTK_CUBIC_LINE: 35,
  VTK_CONVEX_POINT_SET: 41,
  VTK_POLYHEDRON: 42,
  VTK_PARAMETRIC_CURVE: 51,
  VTK_PARAMETRIC_SURFACE: 52,
  VTK_PARAMETRIC_TRI_SURFACE: 53,
  VTK_PARAMETRIC_QUAD_SURFACE: 54,
  VTK_PARAMETRIC_TETRA_REGION: 55,
  VTK_PARAMETRIC_HEX_REGION: 56,
  VTK_HIGHER_ORDER_EDGE: 60,
  VTK_HIGHER_ORDER_TRIANGLE: 61,
  VTK_HIGHER_ORDER_QUAD: 62,
  VTK_HIGHER_ORDER_POLYGON: 63,
  VTK_HIGHER_ORDER_TETRAHEDRON: 64,
  VTK_HIGHER_ORDER_WEDGE: 65,
  VTK_HIGHER_ORDER_PYRAMID: 66,
  VTK_HIGHER_ORDER_HEXAHEDRON: 67,
  VTK_LAGRANGE_CURVE: 68,
  VTK_LAGRANGE_TRIANGLE: 69,
  VTK_LAGRANGE_QUADRILATERAL: 70,
  VTK_LAGRANGE_TETRAHEDRON: 71,
  VTK_LAGRANGE_HEXAHEDRON: 72,
  VTK_LAGRANGE_WEDGE: 73,
  VTK_LAGRANGE_PYRAMID: 74,
  VTK_NUMBER_OF_CELL_TYPES: 75
}, CellTypesStrings = /* @__PURE__ */ "vtkEmptyCell.vtkVertex.vtkPolyVertex.vtkLine.vtkPolyLine.vtkTriangle.vtkTriangleStrip.vtkPolygon.vtkPixel.vtkQuad.vtkTetra.vtkVoxel.vtkHexahedron.vtkWedge.vtkPyramid.vtkPentagonalPrism.vtkHexagonalPrism.UnknownClass.UnknownClass.UnknownClass.UnknownClass.vtkQuadraticEdge.vtkQuadraticTriangle.vtkQuadraticQuad.vtkQuadraticTetra.vtkQuadraticHexahedron.vtkQuadraticWedge.vtkQuadraticPyramid.vtkBiQuadraticQuad.vtkTriQuadraticHexahedron.vtkQuadraticLinearQuad.vtkQuadraticLinearWedge.vtkBiQuadraticQuadraticWedge.vtkBiQuadraticQuadraticHexahedron.vtkBiQuadraticTriangle.vtkCubicLine.vtkQuadraticPolygon.UnknownClass.UnknownClass.UnknownClass.UnknownClass.vtkConvexPointSet.UnknownClass.UnknownClass.UnknownClass.UnknownClass.UnknownClass.UnknownClass.UnknownClass.UnknownClass.UnknownClass.vtkParametricCurve.vtkParametricSurface.vtkParametricTriSurface.vtkParametricQuadSurface.vtkParametricTetraRegion.vtkParametricHexRegion.UnknownClass.UnknownClass.UnknownClass.vtkHigherOrderEdge.vtkHigherOrderTriangle.vtkHigherOrderQuad.vtkHigherOrderPolygon.vtkHigherOrderTetrahedron.vtkHigherOrderWedge.vtkHigherOrderPyramid.vtkHigherOrderHexahedron".split(".");
function getClassNameFromTypeId(e12) {
  return e12 < CellTypesStrings.length ? CellTypesStrings[e12] : "UnknownClass";
}
function getTypeIdFromClassName(e12) {
  return CellTypesStrings.findIndex(e12);
}
function isLinear(e12) {
  return e12 < CellType.VTK_QUADRATIC_EDGE || e12 === CellType.VTK_CONVEX_POINT_SET || e12 === CellType.VTK_POLYHEDRON;
}
function hasSubCells(e12) {
  return e12 === CellType.VTK_TRIANGLE_STRIP || e12 === CellType.VTK_POLY_LINE || e12 === CellType.VTK_POLY_VERTEX;
}
var STATIC$10 = {
  getClassNameFromTypeId,
  getTypeIdFromClassName,
  isLinear,
  hasSubCells
};
function vtkCellTypes(e12, t) {
  t.classHierarchy.push("vtkCellTypes"), e12.allocate = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 512, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3;
    t.size = e13 > 0 ? e13 : 1, t.extend = n > 0 ? n : 1, t.maxId = -1, t.typeArray = new Uint8Array(e13), t.locationArray = new Uint32Array(e13);
  }, e12.insertCell = (e13, n, r) => {
    t.typeArray[e13] = n, t.locationArray[e13] = r, e13 > t.maxId && (t.maxId = e13);
  }, e12.insertNextCell = (n, r) => (e12.insertCell(++t.maxId, n, r), t.maxId), e12.setCellTypes = (e13, n, r) => {
    t.size = e13, t.typeArray = n, t.locationArray = r, t.maxId = e13 - 1;
  }, e12.getCellLocation = (e13) => t.locationArray[e13], e12.deleteCell = (e13) => {
    t.typeArray[e13] = CellType.VTK_EMPTY_CELL;
  }, e12.getNumberOfTypes = () => t.maxId + 1, e12.isType = (t2) => {
    let n = e12.getNumberOfTypes();
    for (let r = 0; r < n; ++r)
      if (t2 === e12.getCellType(r))
        return true;
    return false;
  }, e12.insertNextType = (t2) => e12.insertNextCell(t2, -1), e12.getCellType = (e13) => t.typeArray[e13], e12.reset = () => {
    t.maxId = -1;
  }, e12.deepCopy = (n) => {
    e12.allocate(n.getSize(), n.getExtend()), t.typeArray.set(n.getTypeArray()), t.locationArray.set(n.getLocationArray()), t.maxId = n.getMaxId();
  };
}
var DEFAULT_VALUES$113 = {
  size: 0,
  maxId: -1,
  extend: 1e3
};
function extend$122(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$113, n), macro.obj(e12, t), macro.get(e12, t, [
    "size",
    "maxId",
    "extend"
  ]), macro.getArray(e12, t, ["typeArray", "locationArray"]), vtkCellTypes(e12, t);
}
var vtkCellTypes$1 = {
  newInstance: macro.newInstance(extend$122, "vtkCellTypes"),
  extend: extend$122,
  ...STATIC$10
}, IntersectionState = {
  NO_INTERSECTION: 0,
  YES_INTERSECTION: 1,
  ON_LINE: 2
}, Constants$15 = { IntersectionState }, { IntersectionState: IntersectionState$1 } = Constants$15;
function distanceToLine(e12, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, a = {
    t: Number.MIN_VALUE,
    distance: 0
  }, o = [], s;
  o[0] = n[0] - t[0], o[1] = n[1] - t[1], o[2] = n[2] - t[2];
  let c = o[0] * (e12[0] - t[0]) + o[1] * (e12[1] - t[1]) + o[2] * (e12[2] - t[2]), l = dot(o, o), u = 1e-5 * c;
  return l !== 0 && (a.t = c / l), u < 0 && (u = -u), -u < l && l < u || l <= 0 || a.t < 0 ? s = t : a.t > 1 ? s = n : (s = o, o[0] = t[0] + a.t * o[0], o[1] = t[1] + a.t * o[1], o[2] = t[2] + a.t * o[2]), r && (r[0] = s[0], r[1] = s[1], r[2] = s[2]), a.distance = distance2BetweenPoints(s, e12), a;
}
function intersection(e12, t, n, r, a, o) {
  let s = [], c = [], l = [];
  a[0] = 0, o[0] = 0, subtract(t, e12, s), subtract(r, n, c), subtract(n, e12, l);
  let u = [
    dot(s, s),
    -dot(s, c),
    -dot(s, c),
    dot(c, c)
  ], d = [];
  if (d[0] = dot(s, l), d[1] = -dot(c, l), solveLinearSystem(u, d, 2) === 0) {
    let s2 = Number.MAX_VALUE, c2 = [
      e12,
      t,
      n,
      r
    ], l2 = [
      n,
      n,
      e12,
      e12
    ], u2 = [
      r,
      r,
      t,
      t
    ];
    o[0], o[0], a[0], a[0], a[0], a[0], o[0], o[0];
    let d2;
    for (let e13 = 0; e13 < 4; e13++)
      d2 = distanceToLine(c2[e13], l2[e13], u2[e13]), d2.distance < s2 && (s2 = d2.distance, d2.t);
    return IntersectionState$1.ON_LINE;
  }
  return a[0] = d[0], o[0] = d[1], a[0] >= 0 && a[0] <= 1 && o[0] >= 0 && o[0] <= 1 ? IntersectionState$1.YES_INTERSECTION : IntersectionState$1.NO_INTERSECTION;
}
var STATIC$9 = {
  distanceToLine,
  intersection
};
function vtkLine(e12, t) {
  t.classHierarchy.push("vtkLine");
  function n(e13) {
    return e13 >= 0 && e13 <= 1;
  }
  e12.getCellDimension = () => 1, e12.intersectWithLine = (e13, r, a, o, s) => {
    let c = {
      intersect: 0,
      t: Number.MAX_VALUE,
      subId: 0,
      betweenPoints: null
    };
    s[1] = 0, s[2] = 0;
    let l = [], u = [], d = [];
    t.points.getPoint(0, u), t.points.getPoint(1, d);
    let f = [], p = [], m = intersection(e13, r, u, d, f, p);
    if (c.t = f[0], c.betweenPoints = n(c.t), s[0] = p[0], m === IntersectionState$1.YES_INTERSECTION) {
      for (let t2 = 0; t2 < 3; t2++)
        o[t2] = u[t2] + s[0] * (d[t2] - u[t2]), l[t2] = e13[t2] + c.t * (r[t2] - e13[t2]);
      if (distance2BetweenPoints(o, l) <= a * a)
        return c.intersect = 1, c;
    } else {
      let t2;
      if (c.t < 0)
        return t2 = distanceToLine(e13, u, d, o), t2.distance <= a * a ? (c.t = 0, c.intersect = 1, c.betweenPoints = true, c) : c;
      if (c.t > 1)
        return t2 = distanceToLine(r, u, d, o), t2.distance <= a * a ? (c.t = 1, c.intersect = 1, c.betweenPoints = true, c) : c;
      if (s[0] < 0)
        return s[0] = 0, t2 = distanceToLine(u, e13, r, o), c.t = t2.t, t2.distance <= a * a && (c.intersect = 1), c;
      if (s[0] > 1)
        return s[0] = 1, t2 = distanceToLine(d, e13, r, o), c.t = t2.t, t2.distance <= a * a && (c.intersect = 1), c;
    }
    return c;
  }, e12.evaluateLocation = (e13, n2, r) => {
    let a = [], o = [];
    t.points.getPoint(0, a), t.points.getPoint(1, o);
    for (let t2 = 0; t2 < 3; t2++)
      n2[t2] = a[t2] + e13[0] * (o[t2] - a[t2]);
    r[0] = 1 - e13[0], r[1] = e13[0];
  }, e12.evaluateOrientation = (e13, n2, r) => t.orientations ? (slerp(n2, t.orientations[0], t.orientations[1], e13[0]), r[0] = 1 - e13[0], r[1] = e13[0], true) : false;
}
var DEFAULT_VALUES$112 = { orientations: null };
function extend$121(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$112, n), vtkCell$1.extend(e12, t, n), macro.setGet(e12, t, ["orientations"]), vtkLine(e12, t);
}
var vtkLine$1 = {
  newInstance: macro.newInstance(extend$121, "vtkLine"),
  extend: extend$121,
  ...STATIC$9,
  ...Constants$15
}, { vtkErrorMacro: vtkErrorMacro$35, vtkWarningMacro: vtkWarningMacro$8 } = macro;
function vtkFieldData(e12, t) {
  t.classHierarchy.push("vtkFieldData");
  let n = e12.getState;
  t.arrays &&= t.arrays.map((e13) => ({ data: vtk(e13.data) })), e12.initialize = () => {
    e12.initializeFields(), e12.copyAllOn(), e12.clearFieldFlags();
  }, e12.initializeFields = () => {
    t.arrays = [], t.copyFieldFlags = {}, e12.modified();
  }, e12.copyStructure = (n2) => {
    e12.initializeFields(), t.copyFieldFlags = n2.getCopyFieldFlags().map((e13) => e13), t.arrays = n2.getArrays().map((e13) => ({ data: e13 }));
  }, e12.getNumberOfArrays = () => t.arrays.length, e12.getNumberOfActiveArrays = () => t.arrays.length, e12.addArray = (n2) => {
    let r = n2.getName(), { array: a, index: o } = e12.getArrayWithIndex(r);
    return a == null ? (t.arrays = [].concat(t.arrays, { data: n2 }), t.arrays.length - 1) : (t.arrays[o] = { data: n2 }, o);
  }, e12.removeAllArrays = () => {
    t.arrays = [];
  }, e12.removeArray = (n2) => {
    let r = t.arrays.findIndex((e13) => e13.data.getName() === n2);
    return e12.removeArrayByIndex(r);
  }, e12.removeArrayByIndex = (e13) => e13 !== -1 && e13 < t.arrays.length ? (t.arrays.splice(e13, 1), true) : false, e12.getArrays = () => t.arrays.map((e13) => e13.data), e12.getArray = (t2) => typeof t2 == "number" ? e12.getArrayByIndex(t2) : e12.getArrayByName(t2), e12.getArrayByName = (e13) => t.arrays.reduce((t2, n2, r) => n2.data.getName() === e13 ? n2.data : t2, null), e12.getArrayWithIndex = (e13) => {
    let n2 = t.arrays.findIndex((t2) => t2.data.getName() === e13);
    return {
      array: n2 === -1 ? null : t.arrays[n2].data,
      index: n2
    };
  }, e12.getArrayByIndex = (e13) => e13 >= 0 && e13 < t.arrays.length ? t.arrays[e13].data : null, e12.hasArray = (t2) => e12.getArrayWithIndex(t2).index >= 0, e12.getArrayName = (e13) => {
    let n2 = t.arrays[e13];
    return n2 ? n2.data.getName() : "";
  }, e12.getCopyFieldFlags = () => t.copyFieldFlags, e12.getFlag = (e13) => t.copyFieldFlags[e13], e12.passData = function(n2) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    n2.getArrays().forEach((o) => {
      let s = e12.getFlag(o.getName());
      if (s !== false && !(t.doCopyAllOff && s !== true) && o) {
        let t2 = e12.getArrayByName(o.getName());
        if (t2)
          if (o.getNumberOfComponents() === t2.getNumberOfComponents())
            if (r > -1 && r < o.getNumberOfTuples()) {
              let e13 = a > -1 ? a : r;
              t2.insertTuple(e13, o.getTuple(r));
            } else
              t2.insertTuples(0, o.getTuples());
          else
            vtkErrorMacro$35("Unhandled case in passData");
        else if (r < 0 || r > o.getNumberOfTuples())
          e12.addArray(o), n2.getAttributes(o).forEach((t3) => {
            e12.setAttribute(o, t3);
          });
        else {
          let s2 = o.getNumberOfComponents(), c = o.getNumberOfValues(), l = a > -1 ? a : r;
          c <= l * s2 && (c = (l + 1) * s2), t2 = vtkDataArray$1.newInstance({
            name: o.getName(),
            dataType: o.getDataType(),
            numberOfComponents: s2,
            values: macro.newTypedArray(o.getDataType(), c),
            size: 0
          }), t2.insertTuple(l, o.getTuple(r)), e12.addArray(t2), n2.getAttributes(o).forEach((n3) => {
            e12.setAttribute(t2, n3);
          });
        }
      }
    });
  }, e12.interpolateData = function(n2) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5;
    n2.getArrays().forEach((c) => {
      let l = e12.getFlag(c.getName());
      if (l !== false && !(t.doCopyAllOff && l !== true) && c) {
        let t2 = e12.getArrayByName(c.getName());
        if (t2)
          if (c.getNumberOfComponents() === t2.getNumberOfComponents())
            if (r > -1 && r < c.getNumberOfTuples()) {
              let e13 = o > -1 ? o : r;
              t2.interpolateTuple(e13, c, r, c, a, s), vtkWarningMacro$8("Unexpected case in interpolateData");
            } else
              t2.insertTuples(c.getTuples());
          else
            vtkErrorMacro$35("Unhandled case in interpolateData");
        else if (r < 0 || a < 0 || r > c.getNumberOfTuples())
          e12.addArray(c), n2.getAttributes(c).forEach((t3) => {
            e12.setAttribute(c, t3);
          });
        else {
          let l2 = c.getNumberOfComponents(), u = c.getNumberOfValues(), d = o > -1 ? o : r;
          u <= d * l2 && (u = (d + 1) * l2), t2 = vtkDataArray$1.newInstance({
            name: c.getName(),
            dataType: c.getDataType(),
            numberOfComponents: l2,
            values: macro.newTypedArray(c.getDataType(), u),
            size: 0
          }), t2.interpolateTuple(d, c, r, c, a, s), e12.addArray(t2), n2.getAttributes(c).forEach((n3) => {
            e12.setAttribute(t2, n3);
          });
        }
      }
    });
  }, e12.copyFieldOn = (e13) => {
    t.copyFieldFlags[e13] = true;
  }, e12.copyFieldOff = (e13) => {
    t.copyFieldFlags[e13] = false;
  }, e12.copyAllOn = () => {
    (!t.doCopyAllOn || t.doCopyAllOff) && (t.doCopyAllOn = true, t.doCopyAllOff = false, e12.modified());
  }, e12.copyAllOff = () => {
    (t.doCopyAllOn || !t.doCopyAllOff) && (t.doCopyAllOn = false, t.doCopyAllOff = true, e12.modified());
  }, e12.clearFieldFlags = () => {
    t.copyFieldFlags = {};
  }, e12.deepCopy = (e13) => {
    t.arrays = e13.getArrays().map((e14) => {
      let t2 = e14.newClone();
      return t2.deepCopy(e14), { data: t2 };
    });
  }, e12.copyFlags = (e13) => e13.getCopyFieldFlags().map((e14) => e14), e12.reset = () => t.arrays.forEach((e13) => e13.data.reset()), e12.getMTime = () => t.arrays.reduce((e13, t2) => t2.data.getMTime() > e13 ? t2.data.getMTime() : e13, t.mtime), e12.getNumberOfComponents = () => t.arrays.reduce((e13, t2) => e13 + t2.data.getNumberOfComponents(), 0), e12.getNumberOfTuples = () => t.arrays.length > 0 ? t.arrays[0].getNumberOfTuples() : 0, e12.getState = () => {
    let e13 = n();
    return e13 && (e13.arrays = t.arrays.map((e14) => ({ data: e14.data.getState() }))), e13;
  };
}
var DEFAULT_VALUES$111 = {
  arrays: [],
  copyFieldFlags: [],
  doCopyAllOn: true,
  doCopyAllOff: false
};
function extend$120(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$111, n), macro.obj(e12, t), vtkFieldData(e12, t);
}
var vtkFieldData$1 = {
  newInstance: macro.newInstance(extend$120, "vtkFieldData"),
  extend: extend$120
}, AttributeTypes$1 = {
  SCALARS: 0,
  VECTORS: 1,
  NORMALS: 2,
  TCOORDS: 3,
  TENSORS: 4,
  GLOBALIDS: 5,
  PEDIGREEIDS: 6,
  EDGEFLAG: 7,
  NUM_ATTRIBUTES: 8
}, AttributeLimitTypes = {
  MAX: 0,
  EXACT: 1,
  NOLIMIT: 2
}, CellGhostTypes = {
  DUPLICATECELL: 1,
  HIGHCONNECTIVITYCELL: 2,
  LOWCONNECTIVITYCELL: 4,
  REFINEDCELL: 8,
  EXTERIORCELL: 16,
  HIDDENCELL: 32
}, PointGhostTypes = {
  DUPLICATEPOINT: 1,
  HIDDENPOINT: 2
}, AttributeCopyOperations$1 = {
  COPYTUPLE: 0,
  INTERPOLATE: 1,
  PASSDATA: 2,
  ALLCOPY: 3
}, ghostArrayName = "vtkGhostType", DesiredOutputPrecision = {
  DEFAULT: 0,
  SINGLE: 1,
  DOUBLE: 2
}, Constants$14 = {
  AttributeCopyOperations: AttributeCopyOperations$1,
  AttributeLimitTypes,
  AttributeTypes: AttributeTypes$1,
  CellGhostTypes,
  DesiredOutputPrecision,
  PointGhostTypes,
  ghostArrayName
}, { AttributeTypes, AttributeCopyOperations } = Constants$14, { vtkWarningMacro: vtkWarningMacro$7 } = macro;
function vtkDataSetAttributes(e12, t) {
  let n = [
    "Scalars",
    "Vectors",
    "Normals",
    "TCoords",
    "Tensors",
    "GlobalIds",
    "PedigreeIds"
  ];
  function r(e13) {
    let t2 = n.find((t3) => AttributeTypes[t3.toUpperCase()] === e13 || typeof e13 != "number" && t3.toLowerCase() === e13.toLowerCase());
    return t2 === void 0 && (t2 = null), t2;
  }
  t.classHierarchy.push("vtkDataSetAttributes");
  let a = { ...e12 };
  e12.checkNumberOfComponents = (e13) => true, e12.setAttribute = (n2, a2) => {
    let o2 = r(a2);
    if (n2 && o2.toUpperCase() === "PEDIGREEIDS" && !n2.isA("vtkDataArray"))
      return vtkWarningMacro$7(`Cannot set attribute ${o2}. The attribute must be a vtkDataArray.`), -1;
    if (n2 && !e12.checkNumberOfComponents(n2, o2))
      return vtkWarningMacro$7(`Cannot set attribute ${o2}. Incorrect number of components.`), -1;
    let s = t[`active${o2}`];
    if (s >= 0 && s < t.arrays.length) {
      if (t.arrays[s] === n2)
        return s;
      e12.removeArrayByIndex(s);
    }
    return n2 ? (s = e12.addArray(n2), t[`active${o2}`] = s) : t[`active${o2}`] = -1, e12.modified(), t[`active${o2}`];
  }, e12.getAttributes = (t2) => n.filter((n2) => e12[`get${n2}`]() === t2), e12.setActiveAttributeByName = (t2, n2) => e12.setActiveAttributeByIndex(e12.getArrayWithIndex(t2).index, n2), e12.setActiveAttributeByIndex = (n2, a2) => {
    let o2 = r(a2);
    if (n2 >= 0 && n2 < t.arrays.length) {
      if (o2.toUpperCase() !== "PEDIGREEIDS") {
        let t2 = e12.getArrayByIndex(n2);
        if (!t2.isA("vtkDataArray"))
          return vtkWarningMacro$7(`Cannot set attribute ${o2}. Only vtkDataArray subclasses can be set as active attributes.`), -1;
        if (!e12.checkNumberOfComponents(t2, o2))
          return vtkWarningMacro$7(`Cannot set attribute ${o2}. Incorrect number of components.`), -1;
      }
      return t[`active${o2}`] = n2, e12.modified(), n2;
    }
    return n2 === -1 && (t[`active${o2}`] = n2, e12.modified()), -1;
  }, e12.getActiveAttribute = (t2) => e12[`get${r(t2)}`](), e12.removeAllArrays = () => {
    n.forEach((e13) => {
      t[`active${e13}`] = -1;
    }), a.removeAllArrays();
  }, e12.removeArrayByIndex = (e13) => (e13 !== -1 && n.forEach((n2) => {
    e13 === t[`active${n2}`] ? t[`active${n2}`] = -1 : e13 < t[`active${n2}`] && --t[`active${n2}`];
  }), a.removeArrayByIndex(e13)), n.forEach((n2) => {
    let r2 = `active${n2}`;
    e12[`get${n2}`] = () => e12.getArrayByIndex(t[r2]), e12[`set${n2}`] = (t2) => e12.setAttribute(t2, n2), e12[`setActive${n2}`] = (t2) => e12.setActiveAttributeByIndex(e12.getArrayWithIndex(t2).index, n2), e12[`copy${n2}Off`] = () => {
      let e13 = n2.toUpperCase();
      t.copyAttributeFlags[AttributeCopyOperations.PASSDATA][AttributeTypes[e13]] = false;
    }, e12[`copy${n2}On`] = () => {
      let e13 = n2.toUpperCase();
      t.copyAttributeFlags[AttributeCopyOperations.PASSDATA][AttributeTypes[e13]] = true;
    };
  }), e12.initializeAttributeCopyFlags = () => {
    t.copyAttributeFlags = [], Object.keys(AttributeCopyOperations).filter((e13) => e13 !== "ALLCOPY").forEach((e13) => {
      t.copyAttributeFlags[AttributeCopyOperations[e13]] = Object.keys(AttributeTypes).filter((e14) => e14 !== "NUM_ATTRIBUTES").reduce((e14, t2) => (e14[AttributeTypes[t2]] = true, e14), []);
    }), t.copyAttributeFlags[AttributeCopyOperations.COPYTUPLE][AttributeTypes.GLOBALIDS] = false, t.copyAttributeFlags[AttributeCopyOperations.INTERPOLATE][AttributeTypes.GLOBALIDS] = false, t.copyAttributeFlags[AttributeCopyOperations.COPYTUPLE][AttributeTypes.PEDIGREEIDS] = false;
  }, e12.initialize = macro.chain(e12.initialize, e12.initializeAttributeCopyFlags), t.dataArrays && Object.keys(t.dataArrays).length && Object.keys(t.dataArrays).forEach((n2) => {
    !t.dataArrays[n2].ref && t.dataArrays[n2].type === "vtkDataArray" && e12.addArray(vtkDataArray$1.newInstance(t.dataArrays[n2]));
  });
  let o = e12.shallowCopy;
  e12.shallowCopy = (e13, n2) => {
    o(e13, n2), t.arrays = e13.getArrays().map((e14) => {
      let t2 = e14.newClone();
      return t2.shallowCopy(e14, n2), { data: t2 };
    });
  }, e12.initializeAttributeCopyFlags();
}
var DEFAULT_VALUES$110 = {
  activeScalars: -1,
  activeVectors: -1,
  activeTensors: -1,
  activeNormals: -1,
  activeTCoords: -1,
  activeGlobalIds: -1,
  activePedigreeIds: -1
};
function extend$119(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$110, n), vtkFieldData$1.extend(e12, t, n), macro.setGet(e12, t, [
    "activeScalars",
    "activeNormals",
    "activeTCoords",
    "activeVectors",
    "activeTensors",
    "activeGlobalIds",
    "activePedigreeIds"
  ]), t.arrays ||= {}, vtkDataSetAttributes(e12, t);
}
var vtkDataSetAttributes$1 = {
  newInstance: macro.newInstance(extend$119, "vtkDataSetAttributes"),
  extend: extend$119,
  ...Constants$14
}, Constants$13 = {
  FieldDataTypes: {
    UNIFORM: 0,
    DATA_OBJECT_FIELD: 0,
    COORDINATE: 1,
    POINT_DATA: 1,
    POINT: 2,
    POINT_FIELD_DATA: 2,
    CELL: 3,
    CELL_FIELD_DATA: 3,
    VERTEX: 4,
    VERTEX_FIELD_DATA: 4,
    EDGE: 5,
    EDGE_FIELD_DATA: 5,
    ROW: 6,
    ROW_DATA: 6
  },
  FieldAssociations: {
    FIELD_ASSOCIATION_POINTS: 0,
    FIELD_ASSOCIATION_CELLS: 1,
    FIELD_ASSOCIATION_NONE: 2,
    FIELD_ASSOCIATION_POINTS_THEN_CELLS: 3,
    FIELD_ASSOCIATION_VERTICES: 4,
    FIELD_ASSOCIATION_EDGES: 5,
    FIELD_ASSOCIATION_ROWS: 6,
    NUMBER_OF_ASSOCIATIONS: 7
  }
}, DATASET_FIELDS = [
  "pointData",
  "cellData",
  "fieldData"
];
function vtkDataSet(e12, t) {
  t.classHierarchy.push("vtkDataSet"), DATASET_FIELDS.forEach((e13) => {
    t[e13] ? t[e13] = vtk(t[e13]) : t[e13] = vtkDataSetAttributes$1.newInstance();
  }), e12.computeBounds = () => {
    if (t.modifiedTime && t.computeTime && t.modifiedTime > t.computeTime || !t.computeTime) {
      let n2 = e12.getPoints();
      n2?.getNumberOfPoints() ? vtkBoundingBox.setBounds(t.bounds, n2.getBoundsByReference()) : t.bounds = vtkMath.createUninitializedBounds(), t.computeTime = macro.getCurrentGlobalMTime();
    }
  }, e12.getLength2 = () => {
    let t2 = e12.getBoundsByReference();
    return !t2 || t2.length !== 6 ? 0 : vtkBoundingBox.getDiagonalLength2(t2);
  }, e12.getLength = () => Math.sqrt(e12.getLength2()), e12.getCenter = () => {
    let t2 = e12.getBoundsByReference();
    return !t2 || t2.length !== 6 ? [
      0,
      0,
      0
    ] : vtkBoundingBox.getCenter(t2);
  }, e12.getCellBounds = (t2) => {
    let n2 = e12.getCell(t2);
    return n2 ? n2.getBounds() : vtkMath.createUninitializedBounds();
  }, e12.getBounds = macro.chain(() => e12.computeBounds, e12.getBounds), e12.getBoundsByReference = macro.chain(() => e12.computeBounds, e12.getBoundsByReference);
  let n = e12.shallowCopy;
  e12.shallowCopy = function(e13) {
    n(e13, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false), DATASET_FIELDS.forEach((n2) => {
      t[n2] = vtkDataSetAttributes$1.newInstance(), t[n2].shallowCopy(e13.getReferenceByName(n2));
    });
  };
  let r = e12.getMTime;
  e12.getMTime = () => DATASET_FIELDS.reduce((e13, n2) => Math.max(e13, t[n2]?.getMTime() ?? e13), r()), e12.initialize = () => (DATASET_FIELDS.forEach((e13) => t[e13]?.initialize()), e12);
}
var DEFAULT_VALUES$109 = {};
function extend$118(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$109, n), macro.obj(e12, t), macro.setGet(e12, t, DATASET_FIELDS), macro.getArray(e12, t, ["bounds"], 6), vtkDataSet(e12, t);
}
var vtkDataSet$1 = {
  newInstance: macro.newInstance(extend$118, "vtkDataSet"),
  extend: extend$118,
  ...Constants$13
};
function vtkPointSet(e12, t) {
  t.classHierarchy.push("vtkPointSet"), t.points ? t.points = vtk(t.points) : t.points = vtkPoints$1.newInstance(), e12.getNumberOfPoints = () => t.points.getNumberOfPoints(), e12.getBounds = () => t.points.getBounds(), e12.computeBounds = () => {
    e12.getBounds();
  };
  let n = e12.shallowCopy;
  e12.shallowCopy = function(e13) {
    n(e13, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false), t.points = vtkPoints$1.newInstance(), t.points.shallowCopy(e13.getPoints());
  };
  let r = e12.getMTime;
  e12.getMTime = () => {
    let e13 = r();
    return Math.max(e13, t.points?.getMTime() ?? e13);
  };
  let a = e12.initialize;
  e12.initialize = () => (t.points?.initialize(), a());
}
var DEFAULT_VALUES$108 = {};
function extend$117(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$108, n), vtkDataSet$1.extend(e12, t, n), macro.setGet(e12, t, ["points"]), vtkPointSet(e12, t);
}
var vtkPointSet$1 = {
  newInstance: macro.newInstance(extend$117, "vtkPointSet"),
  extend: extend$117
};
function vtkPolyLine(e12, t) {
  t.classHierarchy.push("vtkPolyLine");
  let n = vtkLine$1.newInstance();
  n.getPoints().setNumberOfPoints(2), e12.getCellDimension = () => 1, e12.intersectWithLine = (r, a, o, s, c, l, u) => {
    let d = {
      intersect: 0,
      t: Number.MAX_VALUE,
      subId: 0,
      betweenPoints: null
    }, f = e12.getNumberOfPoints() - 1, p = Number.MAX_VALUE;
    for (let e13 = 0; e13 < f; e13++) {
      let f2 = [
        0,
        0,
        0
      ];
      n.getPoints().getData().set(t.points.getData().subarray(3 * e13, 3 * (e13 + 2)));
      let m = n.intersectWithLine(o, s, c, l, u);
      if (m.intersect === 1 && m.t <= d.t + c && m.t >= r && m.t <= a) {
        d.intersect = 1;
        let t2 = n.getParametricDistance(f2);
        if (t2 < p || t2 === p && m.t < d.t) {
          d.subId = e13, d.t = m.t, p = t2;
          for (let e14 = 0; e14 < 3; e14++)
            l[e14], f2[e14];
        }
      }
    }
    return d;
  }, e12.evaluateLocation = (e13, r, a, o) => (n.getPoints().getData().set(t.points.getData().subarray(3 * e13, 3 * (e13 + 2))), n.evaluateLocation(r, a, o)), e12.evaluateOrientation = (e13, r, a, o) => (t.orientations ? n.setOrientations([t.orientations[e13], t.orientations[e13 + 1]]) : n.setOrientations(null), n.evaluateOrientation(r, a, o)), e12.getDistancesToFirstPoint = () => {
    let n2 = t.distancesTime.getMTime();
    if (n2 < t.points.getMTime() || n2 < e12.getMTime()) {
      let n3 = e12.getNumberOfPoints();
      if (t.distances ? t.distances.length = n3 : t.distances = Array(n3), n3 > 0) {
        let e13 = [
          ,
          ,
          ,
        ], r = [
          ,
          ,
          ,
        ], a = 0;
        t.distances[0] = a, t.points.getPoint(0, e13);
        for (let o = 1; o < n3; ++o)
          t.points.getPoint(o, r), a += t.distanceFunction(e13, r), t.distances[o] = a, copy$3(e13, r);
      }
      t.distancesTime.modified();
    }
    return t.distances;
  }, e12.findPointIdAtDistanceFromFirstPoint = (t2) => {
    let n2 = e12.getDistancesToFirstPoint();
    if (n2.length < 2)
      return -1;
    let r = 0, a = n2.length - 1;
    if (t2 < n2[r] || t2 > n2[a] || n2[a] === 0)
      return -1;
    for (; a - r > 1; ) {
      let e13 = Math.floor((r + a) / 2);
      n2[e13] <= t2 ? r = e13 : a = e13;
    }
    return r;
  };
}
var DEFAULT_VALUES$107 = {
  orientations: null,
  distanceFunction: dist
};
function extend$116(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$107, n), vtkCell$1.extend(e12, t, n), macro.setGet(e12, t, ["orientations", "distanceFunction"]), t.distancesTime = {}, macro.obj(t.distancesTime, { mtime: 0 }), vtkPolyLine(e12, t);
}
var vtkPolyLine$1 = {
  newInstance: macro.newInstance(extend$116, "vtkPolyLine"),
  extend: extend$116
};
function vtkPriorityQueue(e12, t) {
  t.classHierarchy.push("vtkPriorityQueue"), e12.push = (e13, n) => {
    let r = t.elements.findIndex((t2) => t2.priority > e13);
    t.elements.splice(r, 0, {
      priority: e13,
      element: n
    });
  }, e12.pop = () => t.elements.length > 0 ? t.elements.shift().element : null, e12.deleteById = (e13) => {
    t.elements = t.elements.filter((t2) => {
      let { element: n } = t2;
      return n.id !== e13;
    });
  }, e12.length = () => t.elements.length;
}
var DEFAULT_VALUES$106 = { elements: [] };
function extend$115(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$106, n), macro.obj(e12, t), vtkPriorityQueue(e12, t);
}
var vtkPriorityQueue$1 = {
  newInstance: macro.newInstance(extend$115, "vtkPriorityQueue"),
  extend: extend$115
}, FLOAT_EPSILON = 11920929e-14, TOLERANCE = 1e-8, PolygonWithPointIntersectionState = {
  FAILURE: -1,
  OUTSIDE: 0,
  INSIDE: 1,
  INTERSECTION: 2,
  ON_LINE: 3
};
function pointLocation(e12, t, n, r, a) {
  return (r[e12] - n[e12]) * (a[t] - n[t]) - (a[e12] - n[e12]) * (r[t] - n[t]);
}
function pointInPolygon(e12, t, n, r) {
  if (e12[0] < n[0] || e12[0] > n[1] || e12[1] < n[2] || e12[1] > n[3] || e12[2] < n[4] || e12[2] > n[5])
    return PolygonWithPointIntersectionState.OUTSIDE;
  if (normalize$1(r) <= 11920929e-14)
    return PolygonWithPointIntersectionState.FAILURE;
  let a = TOLERANCE * ((n[1] - n[0]) * (n[1] - n[0]) + (n[3] - n[2]) * (n[3] - n[2]) + (n[5] - n[4]) * (n[5] - n[4]));
  a *= a, a = a === 0 ? FLOAT_EPSILON : a;
  let o = [], s = [];
  for (let n2 = 0; n2 < t.length; ) {
    if (o[0] = t[n2++], o[1] = t[n2++], o[2] = t[n2++], distance2BetweenPoints(e12, o) <= a)
      return PolygonWithPointIntersectionState.INSIDE;
    let { distance: r2, t: c2 } = vtkLine$1.distanceToLine(e12, o, s);
    if (r2 <= a && c2 > 0 && c2 < 1)
      return PolygonWithPointIntersectionState.INSIDE;
  }
  let c, l;
  Math.abs(r[0]) > Math.abs(r[1]) ? Math.abs(r[0]) > Math.abs(r[2]) ? (c = 1, l = 2) : (c = 0, l = 1) : Math.abs(r[1]) > Math.abs(r[2]) ? (c = 0, l = 2) : (c = 0, l = 1);
  let u = 0;
  for (let n2 = 0; n2 < t.length; )
    o[0] = t[n2++], o[1] = t[n2++], o[2] = t[n2++], n2 < t.length ? (s[0] = t[n2], s[1] = t[n2 + 1], s[2] = t[n2 + 2]) : (s[0] = t[0], s[1] = t[1], s[2] = t[2]), o[l] <= e12[l] ? s[l] > e12[l] && pointLocation(c, l, o, s, e12) > 0 && ++u : s[l] <= e12[l] && pointLocation(c, l, o, s, e12) < 0 && --u;
  return u === 0 ? PolygonWithPointIntersectionState.OUTSIDE : PolygonWithPointIntersectionState.INSIDE;
}
function getBounds(e12, t, n) {
  let r = e12.length, a = [];
  t.getPoint(e12[0], a), n[0] = a[0], n[1] = a[0], n[2] = a[1], n[3] = a[1], n[4] = a[2], n[5] = a[2];
  for (let o2 = 1; o2 < r; o2++)
    t.getPoint(e12[o2], a), vtkBoundingBox.addPoint(n, ...a);
  let o = vtkBoundingBox.getLengths(n);
  return dot(o, o);
}
function getNormal$1(e12, t, n) {
  n.length = 3, n[0] = 0, n[1] = 0, n[2] = 0;
  let r = [], a = [], o = [], s = [], c = [];
  t.getPoint(e12[0], r), t.getPoint(e12[1], a);
  for (let l = 2; l < e12.length; l++) {
    t.getPoint(e12[l], o), subtract(o, a, s), subtract(r, a, c);
    let u = [
      0,
      0,
      0
    ];
    cross(s, c, u), add(n, u, n), [a, o] = [o, a];
  }
  return normalize$1(n);
}
function computeCentroid(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
    0,
    0,
    0
  ];
  n[0] = 0, n[1] = 0, n[2] = 0;
  let r = e12.length, a = [];
  for (let o = 0; o < r; o++)
    t.getPoint(e12[o], a), n[0] += a[0], n[1] += a[1], n[2] += a[2];
  return n[0] /= r, n[1] /= r, n[2] /= r, n;
}
var STATIC$8 = {
  PolygonWithPointIntersectionState,
  pointInPolygon,
  getBounds,
  getNormal: getNormal$1,
  computeCentroid
};
function vtkPolygon(e12, t) {
  t.classHierarchy.push("vtkPolygon");
  function n() {
    let e13 = [
      0,
      0,
      0
    ], n2 = [
      0,
      0,
      0
    ];
    t.normal = [
      0,
      0,
      0
    ];
    let r2 = [...t.firstPoint.point], a2 = t.firstPoint;
    for (let o2 = 0; o2 < t.pointCount; o2++) {
      subtract(a2.point, r2, e13), subtract(a2.next.point, r2, n2);
      let o3 = [
        0,
        0,
        0
      ];
      cross(e13, n2, o3), add(t.normal, o3, t.normal), a2 = a2.next;
    }
    return normalize$1(t.normal);
  }
  function r(e13) {
    let n2 = [
      0,
      0,
      0
    ], r2 = [
      0,
      0,
      0
    ], a2 = [
      0,
      0,
      0
    ], o2 = [
      0,
      0,
      0
    ];
    subtract(e13.point, e13.previous.point, n2), subtract(e13.next.point, e13.point, r2), subtract(e13.previous.point, e13.next.point, a2), cross(n2, r2, o2);
    let s2 = dot(o2, t.normal);
    if (s2 <= 0)
      return -1;
    let c = norm(n2) + norm(r2) + norm(a2);
    return c * c / s2;
  }
  function a(e13) {
    if (t.pointCount <= 3)
      return true;
    let n2 = e13.previous, r2 = e13.next, a2 = [
      0,
      0,
      0
    ];
    subtract(r2.point, n2.point, a2);
    let o2 = [
      0,
      0,
      0
    ];
    if (cross(a2, t.normal, o2), normalize$1(o2), norm(o2) === 0)
      return false;
    let s2 = vtkPlane$1.evaluate(o2, n2.point, r2.next.point), c = s2 > 1e-6 ? 1 : s2 < -1e-6 ? -1 : 0, l = c < 0 ? 1 : 0;
    for (let e14 = r2.next.next; e14.id !== n2.id; e14 = e14.next) {
      let t2 = e14.previous;
      s2 = vtkPlane$1.evaluate(o2, n2.point, e14.point);
      let a3 = s2 > 1e-6 ? 1 : s2 < -1e-6 ? -1 : 0;
      if (a3 !== c) {
        if (l ||= a3 <= 0 ? 1 : 0, vtkLine$1.intersection(n2.point, r2.point, e14.point, t2.point, [0], [0]) === IntersectionState.YES_INTERSECTION)
          return false;
        c = a3;
      }
    }
    return l === 1;
  }
  function o(e13, n2) {
    --t.pointCount;
    let a2 = e13.previous, o2 = e13.next;
    t.tris = t.tris.concat(e13.point), t.tris = t.tris.concat(o2.point), t.tris = t.tris.concat(a2.point), a2.next = o2, o2.previous = a2, n2.deleteById(a2.id), n2.deleteById(o2.id);
    let s2 = r(a2);
    s2 > 0 && n2.push(s2, a2);
    let c = r(o2);
    c > 0 && n2.push(c, o2), e13.id === t.firstPoint.id && (t.firstPoint = o2);
  }
  function s() {
    n();
    let e13 = vtkPriorityQueue$1.newInstance(), s2 = t.firstPoint;
    for (let n2 = 0; n2 < t.pointCount; n2++) {
      let t2 = r(s2);
      t2 > 0 && e13.push(t2, s2), s2 = s2.next;
    }
    for (; t.pointCount > 2 && e13.length() > 0; )
      if (t.pointCount === e13.length())
        o(e13.pop(), e13);
      else {
        let t2 = e13.pop();
        a(t2) && o(t2, e13);
      }
    return t.pointCount <= 2;
  }
  e12.triangulate = () => t.firstPoint ? s() : null, e12.setPoints = (e13) => {
    t.pointCount = e13.length, t.firstPoint = {
      id: 0,
      point: e13[0],
      next: null,
      previous: null
    };
    let n2 = t.firstPoint;
    for (let r2 = 1; r2 < t.pointCount; r2++)
      n2.next = {
        id: r2,
        point: e13[r2],
        next: null,
        previous: n2
      }, n2 = n2.next;
    t.firstPoint.previous = n2, n2.next = t.firstPoint;
  }, e12.getPointArray = () => t.tris;
}
var DEFAULT_VALUES$105 = {
  firstPoint: null,
  pointCount: 0,
  tris: []
};
function extend$114(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$105, n), macro.obj(e12, t), vtkPolygon(e12, t);
}
var vtkPolygon$1 = {
  newInstance: macro.newInstance(extend$114, "vtkPolygon"),
  extend: extend$114,
  ...STATIC$8
};
function computeNormalDirection(e12, t, n, r) {
  let a = n[0] - t[0], o = n[1] - t[1], s = n[2] - t[2], c = e12[0] - t[0], l = e12[1] - t[1], u = e12[2] - t[2];
  r[0] = o * u - s * l, r[1] = s * c - a * u, r[2] = a * l - o * c;
}
function computeNormal(e12, t, n, r) {
  computeNormalDirection(e12, t, n, r);
  let a = Math.sqrt(r[0] * r[0] + r[1] * r[1] + r[2] * r[2]);
  a !== 0 && (r[0] /= a, r[1] /= a, r[2] /= a);
}
function interpolationDerivs(e12) {
  e12[0] = -1, e12[1] = 1, e12[2] = 0, e12[3] = -1, e12[4] = 0, e12[5] = 1;
}
function intersectWithTriangle(e12, t, n, r, a, o) {
  let s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1e-6, c = false, l = [], u = [], d = [], f = [], p = [];
  computeNormal(e12, t, n, f), computeNormal(r, a, o, p);
  let m = -dot(f, e12), h = -dot(p, r), g = [
    dot(p, e12) + h,
    dot(p, t) + h,
    dot(p, n) + h
  ];
  if (g[0] * g[1] > s && g[0] * g[2] > s)
    return {
      intersect: false,
      coplanar: c,
      pt1: l,
      pt2: u,
      surfaceId: d
    };
  let _ = [
    dot(f, r) + m,
    dot(f, a) + m,
    dot(f, o) + m
  ];
  if (_[0] * _[1] > s && _[0] * _[2] > s)
    return {
      intersect: false,
      coplanar: c,
      pt1: l,
      pt2: u,
      surfaceId: d
    };
  if (Math.abs(f[0] - p[0]) < 1e-9 && Math.abs(f[1] - p[1]) < 1e-9 && Math.abs(f[2] - p[2]) < 1e-9 && Math.abs(m - h) < 1e-9)
    return c = true, {
      intersect: false,
      coplanar: c,
      pt1: l,
      pt2: u,
      surfaceId: d
    };
  let v = [
    e12,
    t,
    n
  ], y = [
    r,
    a,
    o
  ], b = dot(f, p), S = (m - h * b) / (b * b - 1), C = (h - m * b) / (b * b - 1), w = [
    S * f[0] + C * p[0],
    S * f[1] + C * p[1],
    S * f[2] + C * p[2]
  ], T = cross(f, p, []);
  normalize$1(T);
  let E = 0, D = 0, O = [], k = [], A = 50, j = 50;
  for (let t2 = 0; t2 < 3; t2++) {
    let n2 = t2, a2 = (t2 + 1) % 3, o2 = vtkPlane$1.intersectWithLine(v[n2], v[a2], r, p);
    o2.intersection && o2.t > 0 - s && o2.t < 1 + s && (o2.t < 1 + s && o2.t > 1 - s && (A = E), O[E++] = dot(o2.x, T) - dot(w, T));
    let c2 = vtkPlane$1.intersectWithLine(y[n2], y[a2], e12, f);
    c2.intersection && c2.t > 0 - s && c2.t < 1 + s && (c2.t < 1 + s && c2.t > 1 - s && (j = D), k[D++] = dot(c2.x, T) - dot(w, T));
  }
  if (E > 2) {
    E--;
    let e13 = O[2];
    O[2] = O[A], O[A] = e13;
  }
  if (D > 2) {
    D--;
    let e13 = k[2];
    k[2] = k[j], k[j] = e13;
  }
  if (E !== 2 || D !== 2 || Number.isNaN(O[0]) || Number.isNaN(O[1]) || Number.isNaN(k[0]) || Number.isNaN(k[1]))
    return {
      intersect: false,
      coplanar: c,
      pt1: l,
      pt2: u,
      surfaceId: d
    };
  if (O[0] > O[1]) {
    let e13 = O[1];
    O[1] = O[0], O[0] = e13;
  }
  if (k[0] > k[1]) {
    let e13 = k[1];
    k[1] = k[0], k[0] = e13;
  }
  let M, N;
  return O[1] < k[0] || k[1] < O[0] ? {
    intersect: false,
    coplanar: c,
    pt1: l,
    pt2: u,
    surfaceId: d
  } : (O[0] < k[0] ? O[1] < k[1] ? (d[0] = 2, d[1] = 1, M = k[0], N = O[1]) : (d[0] = 2, d[1] = 2, M = k[0], N = k[1]) : O[1] < k[1] ? (d[0] = 1, d[1] = 1, M = O[0], N = O[1]) : (d[0] = 1, d[1] = 2, M = O[0], N = k[1]), multiplyAccumulate(w, T, M, l), multiplyAccumulate(w, T, N, u), {
    intersect: true,
    coplanar: c,
    pt1: l,
    pt2: u,
    surfaceId: d
  });
}
var STATIC$7 = {
  computeNormalDirection,
  computeNormal,
  interpolationDerivs,
  intersectWithTriangle
};
function vtkTriangle(e12, t) {
  t.classHierarchy.push("vtkTriangle"), e12.getCellDimension = () => 2, e12.intersectWithLine = (n, r, a, o, s) => {
    let c = {
      subId: 0,
      t: Number.MAX_VALUE,
      intersect: 0,
      betweenPoints: false
    };
    s[2] = 0;
    let l = [], u = a * a, d = [], f = [], p = [];
    t.points.getPoint(0, d), t.points.getPoint(1, f), t.points.getPoint(2, p);
    let m = [], h = [];
    if (computeNormal(d, f, p, m), m[0] !== 0 || m[1] !== 0 || m[2] !== 0) {
      let t2 = vtkPlane$1.intersectWithLine(n, r, d, m);
      if (c.betweenPoints = t2.betweenPoints, c.t = t2.t, o[0] = t2.x[0], o[1] = t2.x[1], o[2] = t2.x[2], !t2.intersection)
        return s[0] = 0, s[1] = 0, c.intersect = 0, c;
      let a2 = e12.evaluatePosition(o, l, s, h);
      if (a2.evaluation >= 0)
        return a2.dist2 <= u ? (c.intersect = 1, c) : (c.intersect = a2.evaluation, c);
    }
    let g = distance2BetweenPoints(d, f), _ = distance2BetweenPoints(f, p), v = distance2BetweenPoints(p, d);
    t.line ||= vtkLine$1.newInstance(), g > _ && g > v ? (t.line.getPoints().setPoint(0, d), t.line.getPoints().setPoint(1, f)) : _ > v && _ > g ? (t.line.getPoints().setPoint(0, f), t.line.getPoints().setPoint(1, p)) : (t.line.getPoints().setPoint(0, p), t.line.getPoints().setPoint(1, d));
    let y = t.line.intersectWithLine(n, r, a, o, s);
    if (c.betweenPoints = y.betweenPoints, c.t = y.t, y.intersect) {
      let e13 = [], t2 = [], n2 = [];
      for (let r2 = 0; r2 < 3; r2++)
        e13[r2] = d[r2] - p[r2], t2[r2] = f[r2] - p[r2], n2[r2] = o[r2] - p[r2];
      return s[0] = dot(n2, e13) / v, s[1] = dot(n2, t2) / _, c.intersect = 1, c;
    }
    return s[0] = 0, s[1] = 0, c.intersect = 0, c;
  }, e12.evaluatePosition = (e13, n, r, a) => {
    let o = {
      subId: 0,
      dist2: 0,
      evaluation: -1
    }, s, c, l = [], u = [], d = [], f = [], p, m = [], h = [], g = [], _ = 0, v = 0, y = [], b, S, C, w = [], T = [], E = [], D = [];
    o.subId = 0, r[2] = 0, t.points.getPoint(1, l), t.points.getPoint(2, u), t.points.getPoint(0, d), computeNormalDirection(l, u, d, f), vtkPlane$1.generalizedProjectPoint(e13, l, f, D);
    let O = 0;
    for (s = 0; s < 3; s++)
      p = f[s] < 0 ? -f[s] : f[s], p > O && (O = p, v = s);
    for (c = 0, s = 0; s < 3; s++)
      s !== v && (y[c++] = s);
    for (s = 0; s < 2; s++)
      m[s] = D[y[s]] - d[y[s]], h[s] = l[y[s]] - d[y[s]], g[s] = u[y[s]] - d[y[s]];
    if (_ = determinant2x2(h, g), _ === 0)
      return r[0] = 0, r[1] = 0, o.evaluation = -1, o;
    if (r[0] = determinant2x2(m, g) / _, r[1] = determinant2x2(h, m) / _, a[0] = 1 - (r[0] + r[1]), a[1] = r[0], a[2] = r[1], a[0] >= 0 && a[0] <= 1 && a[1] >= 0 && a[1] <= 1 && a[2] >= 0 && a[2] <= 1)
      n && (o.dist2 = distance2BetweenPoints(D, e13), n[0] = D[0], n[1] = D[1], n[2] = D[2]), o.evaluation = 1;
    else {
      if (n)
        if (a[1] < 0 && a[2] < 0)
          for (b = distance2BetweenPoints(e13, d), S = vtkLine$1.distanceToLine(e13, l, d, void 0, T), C = vtkLine$1.distanceToLine(e13, d, u, void 0, E), b < S ? (o.dist2 = b, w = d) : (o.dist2 = S, w = T), C < o.dist2 && (o.dist2 = C, w = E), s = 0; s < 3; s++)
            n[s] = w[s];
        else if (a[2] < 0 && a[0] < 0)
          for (b = distance2BetweenPoints(e13, l), S = vtkLine$1.distanceToLine(e13, l, d, void 0, T), C = vtkLine$1.distanceToLine(e13, l, u, void 0, E), b < S ? (o.dist2 = b, w = l) : (o.dist2 = S, w = T), C < o.dist2 && (o.dist2 = C, w = E), s = 0; s < 3; s++)
            n[s] = w[s];
        else if (a[1] < 0 && a[0] < 0)
          for (b = distance2BetweenPoints(e13, u), S = vtkLine$1.distanceToLine(e13, u, d, void 0, T), C = vtkLine$1.distanceToLine(e13, l, u, void 0, E), b < S ? (o.dist2 = b, w = u) : (o.dist2 = S, w = T), C < o.dist2 && (o.dist2 = C, w = E), s = 0; s < 3; s++)
            n[s] = w[s];
        else
          a[0] < 0 ? o.dist2 = vtkLine$1.distanceToLine(e13, l, u, n).distance : a[1] < 0 ? o.dist2 = vtkLine$1.distanceToLine(e13, u, d, n).distance : a[2] < 0 && (o.dist2 = vtkLine$1.distanceToLine(e13, l, d, n).distance);
      o.evaluation = 0;
    }
    return o;
  }, e12.evaluateLocation = (e13, n, r) => {
    let a = [], o = [], s = [];
    t.points.getPoint(0, a), t.points.getPoint(1, o), t.points.getPoint(2, s);
    let c = 1 - e13[0] - e13[1];
    for (let t2 = 0; t2 < 3; t2++)
      n[t2] = a[t2] * c + o[t2] * e13[0] + s[t2] * e13[1];
    r[0] = c, r[1] = e13[0], r[2] = e13[1];
  }, e12.getParametricDistance = (e13) => {
    let t2, n = 0, r = [];
    r[0] = e13[0], r[1] = e13[1], r[2] = 1 - e13[0] - e13[1];
    for (let e14 = 0; e14 < 3; e14++)
      t2 = r[e14] < 0 ? -r[e14] : r[e14] > 1 ? r[e14] - 1 : 0, t2 > n && (n = t2);
    return n;
  }, e12.derivatives = (e13, n, r, a, o) => {
    let s = t.points.getPoint(0), c = t.points.getPoint(1), l = t.points.getPoint(2), u = [], d = [], f = [], p = [];
    computeNormal(s, c, l, u), subtract(c, s, d), subtract(l, s, p), cross(u, d, f);
    let m = normalize$1(d);
    if (m <= 0 || normalize$1(f) <= 0) {
      for (let e14 = 0; e14 < a; e14++)
        for (let t2 = 0; t2 < 3; t2++)
          o[e14 * a + t2] = 0;
      return;
    }
    let h = [0, 0], g = [m, 0], _ = [dot(p, d), dot(p, f)], v = [
      ,
      ,
      ,
      ,
      ,
      ,
    ];
    interpolationDerivs(v);
    let y = [
      g[0] - h[0],
      g[1] - h[1],
      _[0] - h[0],
      _[1] - h[1]
    ], b = macro.newTypedArray(TYPED_ARRAYS.Float64Array, 4);
    invertMatrix(y, b, 2);
    for (let e14 = 0; e14 < a; e14++) {
      let t2 = 0, n2 = 0;
      for (let o2 = 0; o2 < 3; o2++)
        t2 += v[o2] * r[a * o2 + e14], n2 += v[3 + o2] * r[a * o2 + e14];
      let s2 = t2 * b[0] + n2 * b[1], c2 = t2 * b[2] + n2 * b[3];
      o[3 * e14] = s2 * d[0] + c2 * f[0], o[3 * e14 + 1] = s2 * d[1] + c2 * f[1], o[3 * e14 + 2] = s2 * d[2] + c2 * f[2];
    }
  }, e12.cellBoundary = (e13, n, r) => {
    let a = n[0] - n[1], o = 0.5 * (1 - n[0]) - n[1], s = 2 * n[0] + n[1] - 1;
    return a >= 0 && o >= 0 ? (r[0] = t.pointsIds[0], r[1] = t.pointsIds[1]) : o < 0 && s >= 0 ? (r[0] = t.pointsIds[1], r[1] = t.pointsIds[2]) : (r[0] = t.pointsIds[2], r[1] = t.pointsIds[0]), !(n[0] < 0 || n[1] < 0 || n[0] > 1 || n[1] > 1 || 1 - n[0] - n[1] < 0);
  };
}
var DEFAULT_VALUES$104 = {};
function extend$113(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$104, n), vtkCell$1.extend(e12, t, n), vtkTriangle(e12, t);
}
var vtkTriangle$1 = {
  newInstance: macro.newInstance(extend$113, "vtkTriangle"),
  extend: extend$113,
  ...STATIC$7
};
function intersectionStruct() {
  return {
    intersected: false,
    subId: -1,
    x: [
      0,
      0,
      0
    ],
    pCoords: [
      0,
      0,
      0
    ],
    t: -1
  };
}
function vtkQuad(e12, t) {
  t.classHierarchy.push("vtkQuad"), e12.getCellDimension = () => 2, e12.getCellType = () => CellType.VTK_QUAD, e12.getNumberOfEdges = () => 4, e12.getNumberOfFaces = () => 0, e12.intersectWithLine = (e13, n, r, a, o) => {
    let s = {
      subId: 0,
      t: Number.MAX_VALUE,
      intersect: 0,
      betweenPoints: false
    }, c, l = t.points.getPoint(0, []), u = t.points.getPoint(1, []), d = t.points.getPoint(2, []), f = t.points.getPoint(3, []), p = distance2BetweenPoints(l, d), m = distance2BetweenPoints(u, f);
    if (p === m) {
      let e14, n2 = 0, r2 = 0;
      for (let a2 = 0; a2 < 4; a2++)
        e14 = t.pointsIds[a2], e14 > n2 && (n2 = e14, r2 = a2);
      c = r2 === 0 || r2 === 2 ? 0 : 1;
    } else
      c = p < m ? 0 : 1;
    let h = null;
    t.triangle ? h = t.triangle.getPoints() : (t.triangle = vtkTriangle$1.newInstance(), h = vtkPoints$1.newInstance(), h.setNumberOfPoints(3), t.triangle.initialize(h));
    let g, _ = intersectionStruct(), v, y = intersectionStruct(), b, S;
    switch (c) {
      case 0:
        h.setPoint(0, ...l), h.setPoint(1, ...u), h.setPoint(2, ...d), g = t.triangle.intersectWithLine(e13, n, r, _.x, _.pCoords), h.setPoint(0, ...d), h.setPoint(1, ...f), h.setPoint(2, ...l), v = t.triangle.intersectWithLine(e13, n, r, y.x, y.pCoords), b = g.intersect && v.intersect ? g.t <= v.t : g.intersect, S = g.intersect && v.intersect ? v.t < g.t : v.intersect, b ? (s = g, a[0] = _.x[0], a[1] = _.x[1], a[2] = _.x[2], o[0] = _.pCoords[0] + _.pCoords[1], o[1] = _.pCoords[1], o[2] = _.pCoords[2]) : S && (s = v, a[0] = y.x[0], a[1] = y.x[1], a[2] = y.x[2], o[0] = 1 - (y.pCoords[0] + y.pCoords[1]), o[1] = 1 - y.pCoords[1], o[2] = y.pCoords[2]);
        break;
      case 1:
        h.setPoint(0, ...l), h.setPoint(1, ...u), h.setPoint(2, ...f), g = t.triangle.intersectWithLine(e13, n, r, _.x, _.pCoords), h.setPoint(0, ...d), h.setPoint(1, ...f), h.setPoint(2, ...u), v = t.triangle.intersectWithLine(e13, n, r, y.x, y.pCoords), b = g.intersect && v.intersect ? g.t <= v.t : g.intersect, S = g.intersect && v.intersect ? v.t < g.t : v.intersect, b ? (s = g, a[0] = _.x[0], a[1] = _.x[1], a[2] = _.x[2], o[0] = _.pCoords[0], o[1] = _.pCoords[1], o[2] = _.pCoords[2]) : S && (s = v, a[0] = y.x[0], a[1] = y.x[1], a[2] = y.x[2], o[0] = 1 - y.pCoords[0], o[1] = 1 - y.pCoords[1], o[2] = y.pCoords[2]);
        break;
    }
    return s;
  }, e12.interpolationFunctions = (e13, t2) => {
    let n = 1 - e13[0], r = 1 - e13[1];
    t2[0] = n * r, t2[1] = e13[0] * r, t2[2] = e13[0] * e13[1], t2[3] = n * e13[1];
  }, e12.evaluateLocation = (n, r, a) => {
    let o = [];
    e12.interpolationFunctions(n, a), r[0] = 0, r[1] = 0, r[2] = 0;
    for (let e13 = 0; e13 < 4; e13++) {
      t.points.getPoint(e13, o);
      for (let t2 = 0; t2 < 3; t2++)
        r[t2] += o[t2] * a[e13];
    }
  };
}
var DEFAULT_VALUES$103 = {};
function extend$112(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$103, n), vtkCell$1.extend(e12, t, n), vtkQuad(e12, t);
}
var vtkQuad$1 = {
  newInstance: macro.newInstance(extend$112, "vtkQuad"),
  extend: extend$112
}, { vtkErrorMacro: vtkErrorMacro$34 } = macro;
function notImplemented$4(e12) {
  return () => vtkErrorMacro$34(`vtkTriangleStrip.${e12} - NOT IMPLEMENTED`);
}
function decomposeStrip(e12, t) {
  if (!Array.isArray(e12) || e12.length < 3) {
    vtkErrorMacro$34("decomposeStrip - Invalid points array");
    return;
  }
  let n = e12[0], r = e12[1];
  for (let a = 0; a < e12.length - 2; a++) {
    let o = e12[a + 2];
    a % 2 ? t.insertNextCell([
      r,
      n,
      o
    ]) : t.insertNextCell([
      n,
      r,
      o
    ]), n = r, r = o;
  }
}
var STATIC$6 = { decomposeStrip };
function vtkTriangleStrip(e12, t) {
  t.classHierarchy.push("vtkTriangleStrip");
  let n = e12.initialize;
  e12.initialize = (e13, r) => {
    t.triangle.initialize(e13, r), n(e13, r);
  }, e12.getCellType = () => CellType.VTK_TRIANGLE_STRIP, e12.getCellDimension = () => 2, e12.getNumberOfEdges = () => t.pointsIds.length, e12.getNumberOfFaces = () => 0, e12.evaluatePosition = (e13, n2, r, a, o) => {
    let s = [
      0,
      0,
      0
    ], c = Number.MAX_VALUE, l = 0, u = [], d = [], f = [];
    r[2] = 0, d[0] = 0, d[1] = 0, d[2] = 0;
    let p = t.triangle.getPoints();
    p.setNumberOfPoints(3);
    let m = t.triangle.getPointsIds().length;
    for (let e14 = 0; e14 < m; e14++)
      o[e14] = 0;
    for (let a2 = 0; a2 < m - 2; a2++) {
      let o2 = [];
      p.getPoint(a2, o2);
      let m2 = [];
      p.getPoint(a2 + 1, m2);
      let h = [];
      p.getPoint(a2 + 2, h), p.setData(Float32Array.from([
        ...o2,
        ...m2,
        ...h
      ]), 3);
      let g = t.triangle.evaluatePosition(e13, f, s, u), _ = g.dist2;
      g.evaluation >= 0 && (_ < c || _ === c && l === 0) && (l = g, n2 && (n2[0] = f[0], n2[1] = f[1], n2[2] = f[2]), r[0] = s[0], r[1] = s[1], c = _, d[0] = u[0], d[1] = u[1], d[2] = u[2]);
    }
    return a[0] = c, o[0] = d[0], o[1] = d[1], o[2] = d[2], l;
  }, e12.evaluateLocation = (e13, n2, r, a) => {
    let o = [[
      0,
      1,
      2
    ], [
      1,
      0,
      2
    ]], s = e13 % 2, c = t.pointsIds.length;
    for (let e14 = 0; e14 < c; e14++)
      a[e14] = 0;
    a[e13] = 1 - n2[0] - n2[1], a[e13 + 1] = n2[0], a[e13 + 2] = n2[1];
    let l = [];
    t.points.getPoint(e13 + o[s][0], l);
    let u = [];
    t.points.getPoint(e13 + o[s][1], u);
    let d = [];
    t.points.getPoint(e13 + o[s][2], d);
    for (let t2 = 0; t2 < 3; t2++)
      r[t2] = l[t2] * a[e13] + u[t2] * a[e13 + 1] + d[t2] * a[e13 + 2];
  }, e12.cellBoundary = (e13, n2, r) => {
    let a = [[
      0,
      1,
      2
    ], [
      1,
      0,
      2
    ]], o = e13 % 2, s = t.triangle.getPointsIds();
    return s[0] = t.pointsIds[a[o][0]], s[1] = t.pointsIds[a[o][1]], s[2] = t.pointsIds[a[o][2]], t.triangle.cellBoundary(0, n2, r);
  }, e12.getEdge = (e13) => {
    let n2, r, a = t.pointsIds.length;
    return e13 === 0 ? (n2 = 0, r = 1) : e13 === a - 1 ? (n2 = e13 - 1, r = e13) : (n2 = e13 - 1, r = e13 + 1), t.line.getPointsIds()[0] = t.pointsIds[n2], t.line.getPointsIds()[1] = t.pointsIds[r], t.line.getPoints().setPoint(0, t.points.getPoint(n2)), t.line.getPoints().setPoint(1, t.points.getPoint(r)), t.line;
  }, e12.intersectWithLine = (e13, n2, r, a, o) => {
    let s = t.pointsIds.length - 2, c = t.triangle.getPoints();
    c.setNumberOfPoints(3);
    for (let l = 0; l < s; l++) {
      let s2 = [];
      t.points.getPoint(t.pointsIds[l], s2);
      let u = [];
      t.points.getPoint(t.pointsIds[l + 1], u);
      let d = [];
      t.points.getPoint(t.pointsIds[l + 2], d), c.setData(Float32Array.from([
        ...s2,
        ...u,
        ...d
      ]), 3);
      let f = t.triangle.intersectWithLine(e13, n2, r, a, o);
      if (f.intersect)
        return f;
    }
    return false;
  }, e12.triangulate = () => {
    let e13 = t.points.getNumberOfPoints() - 2;
    t.tris = Array(3 * e13);
    let n2 = [[
      0,
      1,
      2
    ], [
      1,
      0,
      2
    ]];
    for (let r = 0; r < e13; r++) {
      let e14 = r % 2;
      for (let a = 0; a < 3; a++)
        t.tris[r * 3 + a] = r + n2[e14][a];
    }
    return true;
  }, e12.getPointArray = () => t.tris, e12.derivatives = (e13, n2, r, a, o) => {
    let s = [];
    t.points.getPoint(e13, s);
    let c = [];
    t.points.getPoint(e13 + 1, c);
    let l = [];
    t.points.getPoint(e13 + 2, l);
    let u = t.triangle.getPoints();
    u.setPoint(0, ...s), u.setPoint(1, ...c), u.setPoint(2, ...l), t.triangle.derivatives(0, n2, r, a, o);
  }, e12.getParametricCenter = (e13) => (e13[0] = 0.333333, e13[1] = 0.333333, e13[2] = 0, Math.floor((t.pointsIds.length - 2) / 2)), e12.contour = (e13, t2, n2, r, a, o, s, c, l, u, d) => notImplemented$4("contour")(), e12.clip = (e13, t2, n2, r, a, o, s, c, l, u) => notImplemented$4("clip")();
}
var DEFAULT_VALUES$102 = {
  line: null,
  triangle: null,
  tris: null
};
function extend$111(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$102, n), vtkCell$1.extend(e12, t, n), t.line ||= vtkLine$1.newInstance(), t.triangle ||= vtkTriangle$1.newInstance(), vtkTriangleStrip(e12, t);
}
var vtkTriangleStrip$1 = {
  newInstance: macro.newInstance(extend$111, "vtkTriangleStrip"),
  extend: extend$111,
  ...STATIC$6
}, POLYDATA_FIELDS = [
  "verts",
  "lines",
  "polys",
  "strips"
], { vtkWarningMacro: vtkWarningMacro$6 } = macro, CELL_FACTORY = {
  [CellType.VTK_LINE]: vtkLine$1,
  [CellType.VTK_QUAD]: vtkQuad$1,
  [CellType.VTK_POLY_LINE]: vtkLine$1,
  [CellType.VTK_TRIANGLE]: vtkTriangle$1,
  [CellType.VTK_TRIANGLE_STRIP]: vtkTriangleStrip$1,
  [CellType.VTK_POLY_LINE]: vtkPolyLine$1,
  [CellType.VTK_POLYGON]: vtkPolygon$1
};
function vtkPolyData(e12, t) {
  t.classHierarchy.push("vtkPolyData");
  function n(e13) {
    return e13.replace(/(?:^\w|[A-Z]|\b\w)/g, (e14) => e14.toUpperCase()).replace(/\s+/g, "");
  }
  function r() {
    t.cells = void 0, t.links = void 0;
  }
  POLYDATA_FIELDS.forEach((a2) => {
    e12[`getNumberOf${n(a2)}`] = () => t[a2].getNumberOfCells(), t[a2] ? t[a2] = vtk(t[a2]) : t[a2] = vtkCellArray$1.newInstance(), t[`_on${n(a2)}Changed`] = r;
  }), e12.getNumberOfCells = () => POLYDATA_FIELDS.reduce((e13, n2) => e13 + t[n2].getNumberOfCells(), 0);
  let a = e12.shallowCopy;
  e12.shallowCopy = function(e13) {
    a(e13, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false), POLYDATA_FIELDS.forEach((n2) => {
      t[n2] = vtkCellArray$1.newInstance(), t[n2].shallowCopy(e13.getReferenceByName(n2));
    });
  };
  let o = e12.getMTime;
  e12.getMTime = () => POLYDATA_FIELDS.reduce((e13, n2) => Math.max(e13, t[n2]?.getMTime() ?? e13), o());
  let s = e12.initialize;
  e12.initialize = () => (POLYDATA_FIELDS.forEach((e13) => t[e13]?.initialize()), r(), s()), e12.buildCells = () => {
    let n2 = e12.getNumberOfVerts(), r2 = e12.getNumberOfLines(), a2 = e12.getNumberOfPolys(), o2 = e12.getNumberOfStrips(), s2 = n2 + r2 + a2 + o2, c = new Uint8Array(s2), l = c, u = new Uint32Array(s2), d = u;
    if (n2) {
      let e13 = 0;
      t.verts.getCellSizes().forEach((t2, n3) => {
        d[n3] = e13, l[n3] = t2 > 1 ? CellType.VTK_POLY_VERTEX : CellType.VTK_VERTEX, e13 += t2 + 1;
      }), d = d.subarray(n2), l = l.subarray(n2);
    }
    if (r2) {
      let e13 = 0;
      t.lines.getCellSizes().forEach((t2, n3) => {
        d[n3] = e13, l[n3] = t2 > 2 ? CellType.VTK_POLY_LINE : CellType.VTK_LINE, t2 === 1 && vtkWarningMacro$6("Building VTK_LINE ", n3, " with only one point, but VTK_LINE needs at least two points. Check the input."), e13 += t2 + 1;
      }), d = d.subarray(r2), l = l.subarray(r2);
    }
    if (a2) {
      let e13 = 0;
      t.polys.getCellSizes().forEach((t2, n3) => {
        switch (d[n3] = e13, t2) {
          case 3:
            l[n3] = CellType.VTK_TRIANGLE;
            break;
          case 4:
            l[n3] = CellType.VTK_QUAD;
            break;
          default:
            l[n3] = CellType.VTK_POLYGON;
            break;
        }
        t2 < 3 && vtkWarningMacro$6("Building VTK_TRIANGLE ", n3, " with less than three points, but VTK_TRIANGLE needs at least three points. Check the input."), e13 += t2 + 1;
      }), d += d.subarray(a2), l += l.subarray(a2);
    }
    if (o2) {
      let e13 = 0;
      l.fill(CellType.VTK_TRIANGLE_STRIP, 0, o2), t.strips.getCellSizes().forEach((t2, n3) => {
        d[n3] = e13, e13 += t2 + 1;
      });
    }
    t.cells = vtkCellTypes$1.newInstance(), t.cells.setCellTypes(s2, c, u);
  }, e12.buildLinks = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    t.cells ?? e12.buildCells(), t.links = vtkCellLinks$1.newInstance(), n2 > 0 ? t.links.allocate(n2) : t.links.allocate(e12.getPoints().getNumberOfPoints()), t.links.buildLinks(e12);
  }, e12.getCellType = (e13) => t.cells.getCellType(e13), e12.getCellPoints = (n2) => {
    let r2 = e12.getCellType(n2), a2 = null;
    switch (r2) {
      case CellType.VTK_VERTEX:
      case CellType.VTK_POLY_VERTEX:
        a2 = t.verts;
        break;
      case CellType.VTK_LINE:
      case CellType.VTK_POLY_LINE:
        a2 = t.lines;
        break;
      case CellType.VTK_TRIANGLE:
      case CellType.VTK_QUAD:
      case CellType.VTK_POLYGON:
        a2 = t.polys;
        break;
      case CellType.VTK_TRIANGLE_STRIP:
        a2 = t.strips;
        break;
      default:
        return a2 = null, {
          type: 0,
          cellPointIds: null
        };
    }
    let o2 = t.cells.getCellLocation(n2);
    return {
      cellType: r2,
      cellPointIds: a2.getCell(o2)
    };
  }, e12.getPointCells = (e13) => t.links.getCells(e13), e12.getCellEdgeNeighbors = (e13, n2, r2) => {
    let a2 = t.links.getLink(n2), o2 = t.links.getLink(r2);
    return a2.cells.filter((t2) => t2 !== e13 && o2.cells.indexOf(t2) !== -1);
  }, e12.getCell = function(t2) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r2 = e12.getCellPoints(t2), a2 = n2 || CELL_FACTORY[r2.cellType].newInstance();
    return a2.initialize(e12.getPoints(), r2.cellPointIds), a2;
  }, e12.getMaxCellSize = () => POLYDATA_FIELDS.reduce((e13, n2) => Math.max(e13, t[n2]?.getMaxCellSize?.() ?? 0), 0);
}
var DEFAULT_VALUES$101 = {};
function extend$110(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$101, n), vtkPointSet$1.extend(e12, t, n), macro.get(e12, t, ["cells", "links"]), macro.setGet(e12, t, [
    "verts",
    "lines",
    "polys",
    "strips"
  ]), vtkPolyData(e12, t);
}
var vtkPolyData$1 = {
  newInstance: macro.newInstance(extend$110, "vtkPolyData"),
  extend: extend$110
}, { vtkErrorMacro: vtkErrorMacro$33 } = macro, SegmentAgregator = class {
  constructor() {
    this.segmentMapping = {}, this.segments = [null], this.faces = [];
  }
  addSegment(e12) {
    let t = e12[0], n = e12[e12.length - 1];
    if (t === n || e12.length < 2)
      return;
    let r = this.segmentMapping[t], a = this.segmentMapping[n];
    if (r !== void 0 && a !== void 0)
      if (Math.abs(r) === Math.abs(a)) {
        let o = r < a ? a : r, s = this.segments[o];
        if (r > 0)
          for (let t2 = 1; t2 < e12.length - 1; t2++)
            s.push(e12[t2]);
        else
          for (let t2 = 1; t2 < e12.length - 1; t2++)
            s.unshift(e12[e12.length - 1 - t2]);
        this.faces.push(s), this.segments[o] = null, this.segmentMapping[t] = void 0, this.segmentMapping[n] = void 0;
      } else {
        let t2 = Math.abs(r), n2 = Math.abs(a), o = this.segments[t2], s = this.segments[n2];
        this.segments[t2] = null, this.segments[n2] = null, this.segmentMapping[o[0]] = void 0, this.segmentMapping[s[0]] = void 0, this.segmentMapping[o[o.length - 1]] = void 0, this.segmentMapping[s[s.length - 1]] = void 0, this.addSegment(e12), this.addSegment(o), this.addSegment(s);
      }
    else if (r !== void 0) {
      if (r > 0) {
        let t2 = this.segments[r];
        for (let n2 = 1; n2 < e12.length; n2++)
          t2.push(e12[n2]);
        this.segmentMapping[n] = r;
      } else {
        let t2 = this.segments[-r];
        this.segmentMapping[n] = r;
        for (let n2 = 1; n2 < e12.length; n2++)
          t2.unshift(e12[n2]);
      }
      this.segmentMapping[t] = void 0;
    } else if (a !== void 0) {
      if (a > 0) {
        let n2 = this.segments[a];
        for (let t2 = 1; t2 < e12.length; t2++)
          n2.push(e12[e12.length - 1 - t2]);
        this.segmentMapping[t] = a;
      } else {
        let n2 = this.segments[-a];
        this.segmentMapping[t] = a;
        for (let t2 = 1; t2 < e12.length; t2++)
          n2.unshift(e12[e12.length - t2 - 1]);
      }
      this.segmentMapping[n] = void 0;
    } else {
      let r2 = this.segments.length;
      this.segments.push(e12), this.segmentMapping[t] = -r2, this.segmentMapping[n] = r2;
    }
  }
};
function vtkClosedPolyLineToSurfaceFilter(e12, t) {
  t.classHierarchy.push("vtkClosedPolyLineToSurfaceFilter"), e12.requestData = (e13, t2) => {
    let n = e13[0];
    if (!n) {
      vtkErrorMacro$33("Invalid or missing input");
      return;
    }
    let r = t2[0]?.initialize() || vtkPolyData$1.newInstance();
    r.shallowCopy(n);
    let a = new SegmentAgregator(), o = n.getLines().getData(), s = 0;
    for (; s < o.length; ) {
      let e14 = o[s++], t3 = [];
      for (let n2 = 0; n2 < e14; n2++)
        t3.push(o[s + n2]);
      a.addSegment(t3), s += e14;
    }
    let { faces: c } = a, l = c.length;
    for (let e14 = 0; e14 < c.length; e14++)
      l += c[e14].length;
    let u = new Uint16Array(l);
    s = 0;
    for (let e14 = 0; e14 < c.length; e14++) {
      let t3 = c[e14];
      u[s++] = t3.length;
      for (let e15 = 0; e15 < t3.length; e15++)
        u[s++] = t3[e15];
    }
    r.setPolys(vtkCellArray$1.newInstance({
      values: u,
      name: "faces"
    })), t2[0] = r;
  };
}
var DEFAULT_VALUES$100 = {};
function extend$109(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$100, n), macro.obj(e12, t), macro.algo(e12, t, 1, 1), vtkClosedPolyLineToSurfaceFilter(e12, t);
}
var vtkClosedPolyLineToSurfaceFilter$1 = {
  newInstance: macro.newInstance(extend$109, "vtkClosedPolyLineToSurfaceFilter"),
  extend: extend$109
}, { vtkErrorMacro: vtkErrorMacro$32 } = macro$1;
function initPolyIterator(e12) {
  let t = e12.getPolys().getData(), n = e12.getStrips().getData(), r = {
    cellSize: 0,
    cell: [],
    done: false,
    polyIdx: 0,
    stripIdx: 0,
    remainingStripLength: 0,
    next() {
      if (r.polyIdx < t.length) {
        r.cellSize = t[r.polyIdx];
        let e13 = r.polyIdx + 1, n2 = e13 + r.cellSize;
        r.polyIdx = n2;
        let a = 0;
        for (let o = e13; o < n2; ++o)
          r.cell[a++] = t[o];
      } else if (r.stripIdx < n.length) {
        r.cellSize = 3, r.remainingStripLength === 0 && (r.remainingStripLength = n[r.stripIdx] - 2, r.stripIdx += 3);
        let e13 = r.stripIdx - 2, t2 = r.stripIdx + 1;
        r.stripIdx++, r.remainingStripLength--;
        let a = 0;
        for (let o = e13; o < t2; ++o)
          r.cell[a++] = n[o];
      } else if (!r.done)
        r.done = true;
      else
        throw Error("Iterator is done");
    }
  };
  return r.next(), r;
}
function vtkCutter(e12, t) {
  t.classHierarchy.push("vtkCutter");
  let n = { ...e12 };
  e12.getMTime = () => {
    let e13 = n.getMTime();
    return t.cutFunction && (e13 = Math.max(e13, t.cutFunction.getMTime())), e13;
  };
  function r(e13, n2) {
    let r2 = e13.getPoints(), a = r2.getData(), o = e13.getPointData(), s = r2.getNumberOfPoints(), c = [], l = [], u = [], d = {}, f = o.getNumberOfArrays();
    for (let e14 = 0; e14 < f; e14++)
      d[o.getArrayName(e14)] = [];
    (!t.cutScalars || t.cutScalars.length < s) && (t.cutScalars = new Float32Array(s));
    let p = 0, m = 0;
    for (; p < a.length; )
      t.cutScalars[m++] = t.cutFunction.evaluateFunction(a[p++], a[p++], a[p++]);
    let h = [], g = [
      ,
      ,
      ,
    ], _ = [
      ,
      ,
      ,
    ], v = [];
    for (let n3 = initPolyIterator(e13); !n3.done; n3.next()) {
      if (n3.cellSize <= 2)
        continue;
      for (let e15 = 0; e15 < n3.cellSize; )
        v[e15] = t.cutScalars[n3.cell[e15++]];
      let e14 = v[0] > 0, r3 = true;
      for (let t2 = 1; t2 < n3.cell.length; t2++)
        if (v[t2] > 0 !== e14) {
          r3 = false;
          break;
        }
      if (r3)
        continue;
      let s2 = [];
      for (let e15 = 0; e15 < n3.cellSize; e15++) {
        let r4 = e15 + 1 === n3.cellSize ? 0 : e15 + 1, c2 = v[e15] > 0;
        if (v[r4] > 0 === c2)
          continue;
        let l2 = e15, u2 = r4, d2 = v[u2] - v[l2];
        d2 <= 0 && (l2 = r4, u2 = e15, d2 *= -1);
        let p3 = 0;
        d2 !== 0 && (p3 = (t.cutValue - v[l2]) / d2);
        let m2 = n3.cell[l2], h2 = n3.cell[u2];
        g[0] = a[m2 * 3], g[1] = a[m2 * 3 + 1], g[2] = a[m2 * 3 + 2], _[0] = a[h2 * 3], _[1] = a[h2 * 3 + 1], _[2] = a[h2 * 3 + 2];
        let y2 = [
          g[0] + p3 * (_[0] - g[0]),
          g[1] + p3 * (_[1] - g[1]),
          g[2] + p3 * (_[2] - g[2])
        ], b = {};
        for (let e16 = 0; e16 < f; e16++) {
          let t2 = o.getArrayByIndex(e16), n4 = o.getArrayName(e16), r5 = t2.getData(), a2 = t2.getNumberOfComponents(), s3 = Array(a2);
          for (let e17 = 0; e17 < a2; e17++) {
            let t3 = r5[a2 * m2 + e17], n5 = r5[a2 * h2 + e17];
            s3.push(t3 + p3 * (n5 - t3));
          }
          b[n4] = s3;
        }
        s2.push({
          pointEdge1: m2,
          pointEdge2: h2,
          intersectedPoint: y2,
          intersectedArrays: b,
          newPointID: -1
        });
      }
      for (let e15 = 0; e15 < s2.length; e15++) {
        let t2 = s2[e15], n4 = false;
        for (let r4 = 0; r4 < h.length; r4++) {
          let a2 = h[r4], o2 = t2.pointEdge1 === a2.pointEdge1 && t2.pointEdge2 === a2.pointEdge2, c2 = t2.intersectedPoint[0] === a2.intersectedPoint[0] && t2.intersectedPoint[1] === a2.intersectedPoint[1] && t2.intersectedPoint[2] === a2.intersectedPoint[2];
          if (o2 || c2) {
            n4 = true, s2[e15].newPointID = h[r4].newPointID;
            break;
          }
        }
        n4 || (c.push(t2.intersectedPoint[0]), c.push(t2.intersectedPoint[1]), c.push(t2.intersectedPoint[2]), Object.keys(t2.intersectedArrays).forEach((e16) => {
          d[e16].push(...t2.intersectedArrays[e16]);
        }), s2[e15].newPointID = c.length / 3 - 1, h.push(s2[e15]));
      }
      let p2 = s2.length;
      p2 === 2 ? l.push(p2, s2[0].newPointID, s2[1].newPointID) : p2 > 2 && (u.push(p2), s2.forEach((e15) => {
        u.push(e15.newPointID);
      }));
    }
    n2.getPoints().setData(newTypedArrayFrom(r2.getDataType(), c), 3);
    let y = n2.getPointData();
    for (let e14 = 0; e14 < f; e14++) {
      let t2 = o.getArrayName(e14), n3 = vtkDataArray$1.newInstance({
        name: t2,
        dataType: o.getArrayByIndex(e14).getDataType(),
        values: d[t2],
        numberOfComponents: o.getArrayByIndex(e14).getNumberOfComponents()
      });
      y.addArray(n3);
    }
    l.length !== 0 && n2.getLines().setData(Uint16Array.from(l)), u.length !== 0 && n2.getPolys().setData(Uint16Array.from(u));
  }
  e12.requestData = (e13, n2) => {
    let a = e13[0];
    if (!a) {
      vtkErrorMacro$32("Invalid or missing input");
      return;
    }
    if (!t.cutFunction) {
      vtkErrorMacro$32("Missing cut function");
      return;
    }
    let o = n2[0]?.initialize() || vtkPolyData$1.newInstance();
    r(a, o), n2[0] = o;
  };
}
var DEFAULT_VALUES$99 = {
  cutFunction: null,
  cutScalars: null,
  cutValue: 0
};
function extend$108(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$99, n), obj(e12, t), algo(e12, t, 1, 1), setGet(e12, t, ["cutFunction", "cutValue"]), vtkCutter(e12, t);
}
var vtkCutter$1 = {
  newInstance: newInstance(extend$108, "vtkCutter"),
  extend: extend$108
}, ObjectType = {
  ARRAY_BUFFER: 0,
  ELEMENT_ARRAY_BUFFER: 1,
  TEXTURE_BUFFER: 2
}, Constants$12 = { ObjectType }, { ObjectType: ObjectType$2 } = Constants$12, STATIC$5 = {};
function vtkOpenGLBufferObject(e12, t) {
  t.classHierarchy.push("vtkOpenGLBufferObject");
  function n(e13) {
    switch (e13) {
      case ObjectType$2.ELEMENT_ARRAY_BUFFER:
        return t.context.ELEMENT_ARRAY_BUFFER;
      case ObjectType$2.TEXTURE_BUFFER:
        if ("TEXTURE_BUFFER" in t.context)
          return t.context.TEXTURE_BUFFER;
      case ObjectType$2.ARRAY_BUFFER:
      default:
        return t.context.ARRAY_BUFFER;
    }
  }
  let r = null, a = null, o = true, s = "";
  e12.getType = () => r, e12.setType = (e13) => {
    r = e13;
  }, e12.getHandle = () => a, e12.isReady = () => o === false, e12.generateBuffer = (e13) => {
    let o2 = n(e13);
    return a === null && (a = t.context.createBuffer(), r = e13), n(r) === o2;
  }, e12.upload = (c, l) => e12.generateBuffer(l) ? (t.context.bindBuffer(n(r), a), t.context.bufferData(n(r), c, t.context.STATIC_DRAW), t.allocatedGPUMemoryInBytes = c.length * c.BYTES_PER_ELEMENT, o = false, true) : (s = "Trying to upload array buffer to incompatible buffer.", false), e12.bind = () => a ? (t.context.bindBuffer(n(r), a), true) : false, e12.release = () => a ? (t.context.bindBuffer(n(r), null), true) : false, e12.releaseGraphicsResources = () => {
    a !== null && (t.context.bindBuffer(n(r), null), t.context.deleteBuffer(a), a = null, t.allocatedGPUMemoryInBytes = 0);
  }, e12.setOpenGLRenderWindow = (n2) => {
    t._openGLRenderWindow !== n2 && (e12.releaseGraphicsResources(), t._openGLRenderWindow = n2, t.context = null, n2 && (t.context = t._openGLRenderWindow.getContext()));
  }, e12.getError = () => s;
}
var DEFAULT_VALUES$98 = {
  objectType: ObjectType$2.ARRAY_BUFFER,
  context: null,
  allocatedGPUMemoryInBytes: 0
};
function extend$107(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$98, n), macro.obj(e12, t), macro.get(e12, t, ["_openGLRenderWindow", "allocatedGPUMemoryInBytes"]), macro.moveToProtected(e12, t, ["openGLRenderWindow"]), vtkOpenGLBufferObject(e12, t);
}
var vtkBufferObject = {
  newInstance: macro.newInstance(extend$107),
  extend: extend$107,
  ...STATIC$5,
  ...Constants$12
}, Shading$1 = {
  FLAT: 0,
  GOURAUD: 1,
  PHONG: 2
}, Representation$1 = {
  POINTS: 0,
  WIREFRAME: 1,
  SURFACE: 2
}, PropertyConst = {
  Shading: Shading$1,
  Representation: Representation$1,
  Interpolation: Shading$1
};
function computeCoordShiftAndScale(e12) {
  let t = 0, n = 0;
  for (let r2 = 0; r2 < 3; ++r2) {
    let a = e12.getRange(r2), o = a[1] - a[0];
    t += o * o;
    let s = 0.5 * (a[1] + a[0]);
    n += s * s;
  }
  let r = t > 0 && (Math.abs(n) / t > 1e6 || Math.abs(Math.log10(t)) > 3 || t === 0 && n > 1e6);
  if (r) {
    let t2 = new Float64Array(3), n2 = new Float64Array(3);
    for (let r2 = 0; r2 < 3; ++r2) {
      let a = e12.getRange(r2), o = a[1] - a[0];
      t2[r2] = 0.5 * (a[1] + a[0]), n2[r2] = o > 0 ? 1 / o : 1;
    }
    return {
      useShiftAndScale: r,
      coordShift: t2,
      coordScale: n2
    };
  }
  return {
    useShiftAndScale: r,
    coordShift: new Float32Array([
      0,
      0,
      0
    ]),
    coordScale: new Float32Array([
      1,
      1,
      1
    ])
  };
}
var { vtkErrorMacro: vtkErrorMacro$31 } = macro;
function computeInverseShiftAndScaleMatrix(e12, t) {
  let n = new Float64Array(3);
  inverse(n, t);
  let r = new Float64Array(16);
  return fromRotationTranslationScale(r, create$2(), e12, n), r;
}
function shouldApplyCoordShiftAndScale(e12, t) {
  return e12 === null || t === null ? false : !(exactEquals$2(e12, [
    0,
    0,
    0
  ]) && exactEquals$2(t, [
    1,
    1,
    1
  ]));
}
function vtkOpenGLCellArrayBufferObject(e12, t) {
  t.classHierarchy.push("vtkOpenGLCellArrayBufferObject"), e12.setType(ObjectType.ARRAY_BUFFER), e12.createVBO = function(n, r, a, o) {
    let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (!n.getData() || !n.getData().length)
      return t.elementCount = 0, 0;
    t.blockSize = 3, t.vertexOffset = 0, t.normalOffset = 0, t.tCoordOffset = 0, t.tCoordComponents = 0, t.colorComponents = 0, t.colorOffset = 0, t.customData = [];
    let c = o.points.getData(), l = null, u = null, d = null, f = o.colors ? o.colors.getNumberOfComponents() : 0, p = o.tcoords ? o.tcoords.getNumberOfComponents() : 0;
    o.normals && (t.normalOffset = 4 * t.blockSize, t.blockSize += 3, l = o.normals.getData()), o.customAttributes && o.customAttributes.forEach((e13) => {
      e13 && (t.customData.push({
        data: e13.getData(),
        offset: 4 * t.blockSize,
        components: e13.getNumberOfComponents(),
        name: e13.getName()
      }), t.blockSize += e13.getNumberOfComponents());
    }), o.tcoords && (t.tCoordOffset = 4 * t.blockSize, t.tCoordComponents = p, t.blockSize += p, u = o.tcoords.getData()), o.colors ? (t.colorComponents = o.colors.getNumberOfComponents(), t.colorOffset = 0, d = o.colors.getData(), t.colorBO ||= vtkBufferObject.newInstance(), t.colorBO.setOpenGLRenderWindow(t._openGLRenderWindow)) : t.colorBO = null, t.stride = 4 * t.blockSize;
    let m = 0, h = 0, g = 0, _ = 0, v = 0, y = 0, b, S = {
      anythingToPoints(e13, t2, n2, r2) {
        for (let a2 = 0; a2 < e13; ++a2)
          b(t2[n2 + a2], r2);
      },
      linesToWireframe(e13, t2, n2, r2) {
        for (let a2 = 0; a2 < e13 - 1; ++a2)
          b(t2[n2 + a2], r2), b(t2[n2 + a2 + 1], r2);
      },
      polysToWireframe(e13, t2, n2, r2) {
        if (e13 > 2)
          for (let a2 = 0; a2 < e13; ++a2)
            b(t2[n2 + a2], r2), b(t2[n2 + (a2 + 1) % e13], r2);
      },
      stripsToWireframe(e13, t2, n2, r2) {
        if (e13 > 2) {
          for (let a2 = 0; a2 < e13 - 1; ++a2)
            b(t2[n2 + a2], r2), b(t2[n2 + a2 + 1], r2);
          for (let a2 = 0; a2 < e13 - 2; a2++)
            b(t2[n2 + a2], r2), b(t2[n2 + a2 + 2], r2);
        }
      },
      polysToSurface(e13, t2, n2, r2) {
        for (let a2 = 0; a2 < e13 - 2; a2++)
          b(t2[n2 + 0], r2), b(t2[n2 + a2 + 1], r2), b(t2[n2 + a2 + 2], r2);
      },
      stripsToSurface(e13, t2, n2, r2) {
        for (let a2 = 0; a2 < e13 - 2; a2++)
          b(t2[n2 + a2], r2), b(t2[n2 + a2 + 1 + a2 % 2], r2), b(t2[n2 + a2 + 1 + (a2 + 1) % 2], r2);
      }
    }, C = {
      anythingToPoints(e13, t2) {
        return e13;
      },
      linesToWireframe(e13, t2) {
        return e13 > 1 ? (e13 - 1) * 2 : 0;
      },
      polysToWireframe(e13, t2) {
        return e13 > 2 ? e13 * 2 : 0;
      },
      stripsToWireframe(e13, t2) {
        return e13 > 2 ? e13 * 4 - 6 : 0;
      },
      polysToSurface(e13, t2) {
        return e13 > 2 ? (e13 - 2) * 3 : 0;
      },
      stripsToSurface(e13, t2, n2) {
        return e13 > 2 ? (e13 - 2) * 3 : 0;
      }
    }, w = null, T = null;
    a === Representation$1.POINTS || r === "verts" ? (w = S.anythingToPoints, T = C.anythingToPoints) : a === Representation$1.WIREFRAME || r === "lines" ? (w = S[`${r}ToWireframe`], T = C[`${r}ToWireframe`]) : (w = S[`${r}ToSurface`], T = C[`${r}ToSurface`]);
    let E = n.getData(), D = E.length, O = 0;
    for (let e13 = 0; e13 < D; )
      O += T(E[e13], E), e13 += E[e13] + 1;
    let k = null, A = new Float32Array(O * t.blockSize);
    d && (k = new Uint8Array(O * 4));
    let j = 0, M = 0, { useShiftAndScale: N, coordShift: P, coordScale: F } = computeCoordShiftAndScale(o.points);
    if (N ? e12.setCoordShiftAndScale(P, F) : t.coordShiftAndScaleEnabled === true && e12.setCoordShiftAndScale(null, null), s)
      if (!s.points && !s.cells)
        s.points = new Int32Array(O), s.cells = new Int32Array(O);
      else {
        let e13 = new Int32Array(O + s.points.length);
        e13.set(s.points), s.points = e13;
        let t2 = new Int32Array(O + s.cells.length);
        t2.set(s.cells), s.cells = t2;
      }
    let I = o.vertexOffset;
    b = function(e13, n2) {
      if (s && (s.points[I] = e13, s.cells[I] = y + o.cellOffset), ++I, m = e13 * 3, t.coordShiftAndScaleEnabled ? (A[j++] = (c[m++] - t.coordShift[0]) * t.coordScale[0], A[j++] = (c[m++] - t.coordShift[1]) * t.coordScale[1], A[j++] = (c[m++] - t.coordShift[2]) * t.coordScale[2]) : (A[j++] = c[m++], A[j++] = c[m++], A[j++] = c[m++]), l !== null && (h = o.haveCellNormals ? (y + o.cellOffset) * 3 : e13 * 3, A[j++] = l[h++], A[j++] = l[h++], A[j++] = l[h++]), t.customData.forEach((t2) => {
        v = e13 * t2.components;
        for (let e14 = 0; e14 < t2.components; ++e14)
          A[j++] = t2.data[v++];
      }), u !== null) {
        g = o.useTCoordsPerCell ? n2 * p : e13 * p;
        for (let e14 = 0; e14 < p; ++e14)
          A[j++] = u[g++];
      }
      d !== null && (_ = o.haveCellScalars ? (y + o.cellOffset) * f : e13 * f, k[M++] = d[_++], k[M++] = d[_++], k[M++] = d[_++], k[M++] = f === 4 ? d[_++] : 255);
    };
    for (let e13 = 0; e13 < D; e13 += E[e13] + 1, y++)
      w(E[e13], E, e13 + 1, y + o.cellOffset);
    return t.elementCount = O, e12.upload(A, ObjectType.ARRAY_BUFFER), t.colorBO && (t.colorBOStride = 4, t.colorBO.upload(k, ObjectType.ARRAY_BUFFER)), y;
  }, e12.setCoordShiftAndScale = (e13, n) => {
    if (e13 !== null && (e13.constructor !== Float64Array || e13.length !== 3)) {
      vtkErrorMacro$31("Wrong type for coordShift, expected vec3 or null");
      return;
    }
    if (n !== null && (n.constructor !== Float64Array || n.length !== 3)) {
      vtkErrorMacro$31("Wrong type for coordScale, expected vec3 or null");
      return;
    }
    (t.coordShift === null || e13 === null || !equals$3(e13, t.coordShift)) && (t.coordShift = e13), (t.coordScale === null || n === null || !equals$3(n, t.coordScale)) && (t.coordScale = n), t.coordShiftAndScaleEnabled = shouldApplyCoordShiftAndScale(t.coordShift, t.coordScale), t.coordShiftAndScaleEnabled ? t.inverseShiftAndScaleMatrix = computeInverseShiftAndScaleMatrix(t.coordShift, t.coordScale) : t.inverseShiftAndScaleMatrix = null;
  };
}
var DEFAULT_VALUES$97 = {
  elementCount: 0,
  stride: 0,
  colorBOStride: 0,
  vertexOffset: 0,
  normalOffset: 0,
  tCoordOffset: 0,
  tCoordComponents: 0,
  colorOffset: 0,
  colorComponents: 0,
  tcoordBO: null,
  customData: [],
  coordShift: null,
  coordScale: null,
  coordShiftAndScaleEnabled: false,
  inverseShiftAndScaleMatrix: null
};
function extend$106(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$97, n), vtkBufferObject.extend(e12, t, n), macro.setGet(e12, t, [
    "colorBO",
    "elementCount",
    "stride",
    "colorBOStride",
    "vertexOffset",
    "normalOffset",
    "tCoordOffset",
    "tCoordComponents",
    "colorOffset",
    "colorComponents",
    "customData"
  ]), macro.get(e12, t, [
    "coordShift",
    "coordScale",
    "coordShiftAndScaleEnabled",
    "inverseShiftAndScaleMatrix"
  ]), vtkOpenGLCellArrayBufferObject(e12, t);
}
var vtkCellArrayBufferObject = {
  newInstance: macro.newInstance(extend$106),
  extend: extend$106
}, { vtkErrorMacro: vtkErrorMacro$30 } = macro;
function vtkShader(e12, t) {
  t.classHierarchy.push("vtkShader"), e12.compile = () => {
    let e13 = t.context.VERTEX_SHADER;
    if (!t.source || !t.source.length || t.shaderType === "Unknown")
      return false;
    switch (t.handle !== 0 && (t.context.deleteShader(t.handle), t.handle = 0), t.shaderType) {
      case "Fragment":
        e13 = t.context.FRAGMENT_SHADER;
        break;
      case "Vertex":
      default:
        e13 = t.context.VERTEX_SHADER;
        break;
    }
    if (t.handle = t.context.createShader(e13), t.context.shaderSource(t.handle, t.source), t.context.compileShader(t.handle), !t.context.getShaderParameter(t.handle, t.context.COMPILE_STATUS)) {
      let e14 = t.context.getShaderInfoLog(t.handle);
      return vtkErrorMacro$30(`Error compiling shader '${t.source}': ${e14}`), t.context.deleteShader(t.handle), t.handle = 0, false;
    }
    return true;
  }, e12.cleanup = () => {
    t.shaderType === "Unknown" || t.handle === 0 || (t.context.deleteShader(t.handle), t.handle = 0, t.dirty = true);
  };
}
var DEFAULT_VALUES$96 = {
  shaderType: "Unknown",
  source: "",
  error: "",
  handle: 0,
  dirty: false,
  context: null
};
function extend$105(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$96, n), macro.obj(e12, t), macro.setGet(e12, t, [
    "shaderType",
    "source",
    "error",
    "handle",
    "context"
  ]), vtkShader(e12, t);
}
var vtkShader$1 = {
  newInstance: macro.newInstance(extend$105, "vtkShader"),
  extend: extend$105
}, { vtkErrorMacro: vtkErrorMacro$29 } = macro;
function substitute$1(e12, t, n, r) {
  let a = typeof n == "string" ? n : n.join("\n"), o = r === false ? t : new RegExp(t, "g"), s = e12.replace(o, a);
  return {
    replace: s !== a,
    result: s
  };
}
function vtkShaderProgram(e12, t) {
  t.classHierarchy.push("vtkShaderProgram"), e12.compileShader = () => t.vertexShader.compile() ? t.fragmentShader.compile() ? !e12.attachShader(t.vertexShader) || !e12.attachShader(t.fragmentShader) ? (vtkErrorMacro$29(t.error), 0) : e12.link() ? (e12.setCompiled(true), 1) : (vtkErrorMacro$29(`Links failed: ${t.error}`), 0) : (vtkErrorMacro$29(t.fragmentShader.getSource().split("\n").map((e13, t2) => `${t2}: ${e13}`).join("\n")), vtkErrorMacro$29(t.fragmentShader.getError()), 0) : (vtkErrorMacro$29(t.vertexShader.getSource().split("\n").map((e13, t2) => `${t2}: ${e13}`).join("\n")), vtkErrorMacro$29(t.vertexShader.getError()), 0), e12.cleanup = () => {
    t.shaderType === "Unknown" || t.handle === 0 || (e12.release(), t.vertexShaderHandle !== 0 && (t.context.detachShader(t.handle, t.vertexShaderHandle), t.vertexShaderHandle = 0), t.fragmentShaderHandle !== 0 && (t.context.detachShader(t.handle, t.fragmentShaderHandle), t.fragmentShaderHandle = 0), t.context.deleteProgram(t.handle), t.handle = 0, e12.setCompiled(false));
  }, e12.bind = () => !t.linked && !e12.link() ? false : (t.context.useProgram(t.handle), e12.setBound(true), true), e12.isBound = () => !!t.bound, e12.release = () => {
    t.context.useProgram(null), e12.setBound(false);
  }, e12.setContext = (e13) => {
    t.vertexShader.setContext(e13), t.fragmentShader.setContext(e13), t.geometryShader.setContext(e13);
  }, e12.link = () => t.linked ? true : t.handle === 0 ? (t.error = "Program has not been initialized, and/or does not have shaders.", false) : (t.uniformLocs = {}, t.context.linkProgram(t.handle), t.context.getProgramParameter(t.handle, t.context.LINK_STATUS) ? (e12.setLinked(true), t.attributeLocs = {}, true) : (vtkErrorMacro$29(`Error linking shader ${t.context.getProgramInfoLog(t.handle)}`), t.handle = 0, false)), e12.setUniformMatrix = (n, r) => {
    let a = e12.findUniform(n);
    if (a === -1)
      return t.error = `Could not set uniform ${n} . No such uniform.`, false;
    let o = new Float32Array(r);
    return t.context.uniformMatrix4fv(a, false, o), true;
  }, e12.setUniformMatrix3x3 = (n, r) => {
    let a = e12.findUniform(n);
    if (a === -1)
      return t.error = `Could not set uniform ${n} . No such uniform.`, false;
    let o = new Float32Array(r);
    return t.context.uniformMatrix3fv(a, false, o), true;
  }, e12.setUniformf = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform1f(a, r), true);
  }, e12.setUniformfv = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform1fv(a, r), true);
  }, e12.setUniformi = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform1i(a, r), true);
  }, e12.setUniformiv = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform1iv(a, r), true);
  }, e12.setUniform2f = (n, r, a) => {
    let o = e12.findUniform(n);
    if (o === -1)
      return t.error = `Could not set uniform ${n} . No such uniform.`, false;
    if (a === void 0)
      throw RangeError("Invalid number of values for array");
    return t.context.uniform2f(o, r, a), true;
  }, e12.setUniform2fv = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform2fv(a, r), true);
  }, e12.setUniform2i = (n, r, a) => {
    let o = e12.findUniform(n);
    if (o === -1)
      return t.error = `Could not set uniform ${n} . No such uniform.`, false;
    if (a === void 0)
      throw RangeError("Invalid number of values for array");
    return t.context.uniform2i(o, r, a), true;
  }, e12.setUniform2iv = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform2iv(a, r), true);
  }, e12.setUniform3f = (n, r, a, o) => {
    let s = e12.findUniform(n);
    if (s === -1)
      return t.error = `Could not set uniform ${n} . No such uniform.`, false;
    if (o === void 0)
      throw RangeError("Invalid number of values for array");
    return t.context.uniform3f(s, r, a, o), true;
  }, e12.setUniform3fArray = (n, r) => {
    let a = e12.findUniform(n);
    if (a === -1)
      return t.error = `Could not set uniform ${n} . No such uniform.`, false;
    if (!Array.isArray(r) || r.length !== 3)
      throw RangeError("Invalid number of values for array");
    return t.context.uniform3f(a, r[0], r[1], r[2]), true;
  }, e12.setUniform3fv = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform3fv(a, r), true);
  }, e12.setUniform3i = function(n) {
    let r = e12.findUniform(n);
    if (r === -1)
      return t.error = `Could not set uniform ${n} . No such uniform.`, false;
    let a = [...arguments].slice(1);
    if (a.length === 1 && Array.isArray(a[0]) && (a = a[0]), a.length !== 3)
      throw RangeError("Invalid number of values for array");
    return t.context.uniform3i(r, a[0], a[1], a[2]), true;
  }, e12.setUniform3iv = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform3iv(a, r), true);
  }, e12.setUniform4f = function(n) {
    let r = e12.findUniform(n);
    if (r === -1)
      return t.error = `Could not set uniform ${n} . No such uniform.`, false;
    let a = [...arguments].slice(1);
    if (a.length === 1 && Array.isArray(a[0]) && (a = a[0]), a.length !== 4)
      throw RangeError("Invalid number of values for array");
    return t.context.uniform4f(r, a[0], a[1], a[2], a[3]), true;
  }, e12.setUniform4fv = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform4fv(a, r), true);
  }, e12.setUniform4i = function(n) {
    let r = e12.findUniform(n);
    if (r === -1)
      return t.error = `Could not set uniform ${n} . No such uniform.`, false;
    let a = [...arguments].slice(1);
    if (a.length === 1 && Array.isArray(a[0]) && (a = a[0]), a.length !== 4)
      throw RangeError("Invalid number of values for array");
    return t.context.uniform4i(r, a[0], a[1], a[2], a[3]), true;
  }, e12.setUniform4iv = (n, r) => {
    let a = e12.findUniform(n);
    return a === -1 ? (t.error = `Could not set uniform ${n} . No such uniform.`, false) : (t.context.uniform4iv(a, r), true);
  }, e12.findUniform = (e13) => {
    if (!e13 || !t.linked)
      return -1;
    let n = t.uniformLocs[e13];
    return n === void 0 ? (n = t.context.getUniformLocation(t.handle, e13), n === null ? (t.error = `Uniform ${e13} not found in current shader program.`, t.uniformLocs[e13] = -1, -1) : (t.uniformLocs[e13] = n, n)) : n;
  }, e12.isUniformUsed = (e13) => {
    if (!e13)
      return false;
    let n = t.uniformLocs[e13];
    return n === void 0 ? t.linked ? (n = t.context.getUniformLocation(t.handle, e13), t.uniformLocs[e13] = n, n !== null) : (vtkErrorMacro$29("attempt to find uniform when the shader program is not linked"), false) : n !== null;
  }, e12.isAttributeUsed = (e13) => {
    if (!e13)
      return false;
    if (e13 in t.attributeLocs)
      return true;
    if (!t.linked)
      return vtkErrorMacro$29("attempt to find uniform when the shader program is not linked"), false;
    let n = t.context.getAttribLocation(t.handle, e13);
    return n === -1 ? false : (t.attributeLocs[e13] = n, true);
  }, e12.attachShader = (n) => {
    if (n.getHandle() === 0)
      return t.error = "Shader object was not initialized, cannot attach it.", false;
    if (n.getShaderType() === "Unknown")
      return t.error = "Shader object is of type Unknown and cannot be used.", false;
    if (t.handle === 0) {
      let e13 = t.context.createProgram();
      if (e13 === 0)
        return t.error = "Could not create shader program.", false;
      t.handle = e13, t.linked = false;
    }
    return n.getShaderType() === "Vertex" && (t.vertexShaderHandle !== 0 && t.context.detachShader(t.handle, t.vertexShaderHandle), t.vertexShaderHandle = n.getHandle()), n.getShaderType() === "Fragment" && (t.fragmentShaderHandle !== 0 && t.context.detachShader(t.handle, t.fragmentShaderHandle), t.fragmentShaderHandle = n.getHandle()), t.context.attachShader(t.handle, n.getHandle()), e12.setLinked(false), true;
  }, e12.detachShader = (e13) => {
    if (e13.getHandle() === 0)
      return t.error = "shader object was not initialized, cannot attach it.", false;
    if (e13.getShaderType() === "Unknown")
      return t.error = "Shader object is of type Unknown and cannot be used.", false;
    switch (t.handle === 0 && (t.error = "This shader program has not been initialized yet."), e13.getShaderType()) {
      case "Vertex":
        return t.vertexShaderHandle === e13.getHandle() ? (t.context.detachShader(t.handle, e13.getHandle()), t.vertexShaderHandle = 0, t.linked = false, true) : (t.error = "The supplied shader was not attached to this program.", false);
      case "Fragment":
        return t.fragmentShaderHandle === e13.getHandle() ? (t.context.detachShader(t.handle, e13.getHandle()), t.fragmentShaderHandle = 0, t.linked = false, true) : (t.error = "The supplied shader was not attached to this program.", false);
      default:
        return false;
    }
  }, e12.setContext = (e13) => {
    t.context = e13, t.vertexShader.setContext(e13), t.fragmentShader.setContext(e13), t.geometryShader.setContext(e13);
  }, e12.setLastCameraMTime = (e13) => {
    t.lastCameraMTime = e13;
  };
}
var DEFAULT_VALUES$95 = {
  vertexShaderHandle: 0,
  fragmentShaderHandle: 0,
  geometryShaderHandle: 0,
  vertexShader: null,
  fragmentShader: null,
  geometryShader: null,
  linked: false,
  bound: false,
  compiled: false,
  error: "",
  handle: 0,
  numberOfOutputs: 0,
  attributesLocs: null,
  uniformLocs: null,
  md5Hash: 0,
  context: null,
  lastCameraMTime: null
};
function extend$104(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$95, n), t.attributesLocs = {}, t.uniformLocs = {}, t.vertexShader = vtkShader$1.newInstance(), t.vertexShader.setShaderType("Vertex"), t.fragmentShader = vtkShader$1.newInstance(), t.fragmentShader.setShaderType("Fragment"), t.geometryShader = vtkShader$1.newInstance(), t.geometryShader.setShaderType("Geometry"), macro.obj(e12, t), macro.get(e12, t, ["lastCameraMTime"]), macro.setGet(e12, t, [
    "error",
    "handle",
    "compiled",
    "bound",
    "md5Hash",
    "vertexShader",
    "fragmentShader",
    "geometryShader",
    "linked"
  ]), vtkShaderProgram(e12, t);
}
var vtkShaderProgram$1 = {
  newInstance: macro.newInstance(extend$104, "vtkShaderProgram"),
  extend: extend$104,
  substitute: substitute$1
};
function vtkOpenGLVertexArrayObject(e12, t) {
  t.classHierarchy.push("vtkOpenGLVertexArrayObject"), e12.exposedMethod = () => {
  }, e12.initialize = () => {
    t.instancingExtension = null, t._openGLRenderWindow.getWebgl2() || (t.instancingExtension = t.context.getExtension("ANGLE_instanced_arrays")), !t.forceEmulation && t._openGLRenderWindow && t._openGLRenderWindow.getWebgl2() ? (t.extension = null, t.supported = true, t.handleVAO = t.context.createVertexArray()) : (t.extension = t.context.getExtension("OES_vertex_array_object"), !t.forceEmulation && t.extension ? (t.supported = true, t.handleVAO = t.extension.createVertexArrayOES()) : t.supported = false);
  }, e12.isReady = () => t.handleVAO !== 0 || t.supported === false, e12.bind = () => {
    if (e12.isReady() || e12.initialize(), e12.isReady() && t.supported)
      t.extension ? t.extension.bindVertexArrayOES(t.handleVAO) : t.context.bindVertexArray(t.handleVAO);
    else if (e12.isReady()) {
      let e13 = t.context;
      for (let n = 0; n < t.buffers.length; ++n) {
        let r = t.buffers[n];
        t.context.bindBuffer(e13.ARRAY_BUFFER, r.buffer);
        for (let n2 = 0; n2 < r.attributes.length; ++n2) {
          let a = r.attributes[n2], o = a.isMatrix ? a.size : 1;
          for (let n3 = 0; n3 < o; ++n3)
            e13.enableVertexAttribArray(a.index + n3), e13.vertexAttribPointer(a.index + n3, a.size, a.type, a.normalize, a.stride, a.offset + a.stride * n3 / a.size), a.divisor > 0 && (t.instancingExtension ? t.instancingExtension.vertexAttribDivisorANGLE(a.index + n3, 1) : e13.vertexAttribDivisor(a.index + n3, 1));
        }
      }
    }
  }, e12.release = () => {
    if (e12.isReady() && t.supported)
      t.extension ? t.extension.bindVertexArrayOES(null) : t.context.bindVertexArray(null);
    else if (e12.isReady()) {
      let e13 = t.context;
      for (let n = 0; n < t.buffers.length; ++n) {
        let r = t.buffers[n];
        t.context.bindBuffer(e13.ARRAY_BUFFER, r.buffer);
        for (let n2 = 0; n2 < r.attributes.length; ++n2) {
          let a = r.attributes[n2], o = a.isMatrix ? a.size : 1;
          for (let n3 = 0; n3 < o; ++n3)
            e13.enableVertexAttribArray(a.index + n3), e13.vertexAttribPointer(a.index + n3, a.size, a.type, a.normalize, a.stride, a.offset + a.stride * n3 / a.size), a.divisor > 0 && (t.instancingExtension ? t.instancingExtension.vertexAttribDivisorANGLE(a.index + n3, 0) : e13.vertexAttribDivisor(a.index + n3, 0)), e13.disableVertexAttribArray(a.index + n3);
        }
      }
    }
  }, e12.shaderProgramChanged = () => {
    e12.release(), t.handleVAO && (t.extension ? t.extension.deleteVertexArrayOES(t.handleVAO) : t.context.deleteVertexArray(t.handleVAO)), t.handleVAO = 0, t.handleProgram = 0;
  }, e12.releaseGraphicsResources = () => {
    e12.shaderProgramChanged(), t.handleVAO && (t.extension ? t.extension.deleteVertexArrayOES(t.handleVAO) : t.context.deleteVertexArray(t.handleVAO)), t.handleVAO = 0, t.supported = true, t.handleProgram = 0;
  }, e12.addAttributeArray = (t2, n, r, a, o, s, c, l) => e12.addAttributeArrayWithDivisor(t2, n, r, a, o, s, c, l, 0, false), e12.addAttributeArrayWithDivisor = (n, r, a, o, s, c, l, u, d, f) => {
    if (!n || !n.isBound() || r.getHandle() === 0 || r.getType() !== ObjectType.ARRAY_BUFFER || (t.handleProgram === 0 && (t.handleProgram = n.getHandle()), e12.isReady() || e12.initialize(), !e12.isReady() || t.handleProgram !== n.getHandle()))
      return false;
    let p = t.context, m = {};
    if (m.name = a, m.index = p.getAttribLocation(t.handleProgram, a), m.offset = o, m.stride = s, m.type = c, m.size = l, m.normalize = u, m.isMatrix = f, m.divisor = d, m.Index === -1)
      return false;
    if (r.bind(), p.enableVertexAttribArray(m.index), p.vertexAttribPointer(m.index, m.size, m.type, m.normalize, m.stride, m.offset), d > 0 && (t.instancingExtension ? t.instancingExtension.vertexAttribDivisorANGLE(m.index, 1) : p.vertexAttribDivisor(m.index, 1)), m.buffer = r.getHandle(), !t.supported) {
      let e13 = false;
      for (let n2 = 0; n2 < t.buffers.length; ++n2) {
        let r2 = t.buffers[n2];
        if (r2.buffer === m.buffer) {
          e13 = true;
          let t2 = false;
          for (let e14 = 0; e14 < r2.attributes.length; ++e14)
            r2.attributes[e14].name === a && (t2 = true, r2.attributes[e14] = m);
          t2 || r2.attributes.push(m);
        }
      }
      e13 || t.buffers.push({
        buffer: m.buffer,
        attributes: [m]
      });
    }
    return true;
  }, e12.addAttributeMatrixWithDivisor = (n, r, a, o, s, c, l, u, d) => {
    let f = e12.addAttributeArrayWithDivisor(n, r, a, o, s, c, l, u, d, true);
    if (!f)
      return f;
    let p = t.context, m = p.getAttribLocation(t.handleProgram, a);
    for (let e13 = 1; e13 < l; e13++)
      p.enableVertexAttribArray(m + e13), p.vertexAttribPointer(m + e13, l, c, u, s, o + s * e13 / l), d > 0 && (t.instancingExtension ? t.instancingExtension.vertexAttribDivisorANGLE(m + e13, 1) : p.vertexAttribDivisor(m + e13, 1));
    return true;
  }, e12.removeAttributeArray = (n) => {
    if (!e12.isReady() || t.handleProgram === 0)
      return false;
    if (!t.supported)
      for (let e13 = 0; e13 < t.buffers.length; ++e13) {
        let r = t.buffers[e13];
        for (let a = 0; a < r.attributes.length; ++a)
          if (r.attributes[a].name === n)
            return r.attributes.splice(a, 1), r.attributes.length || t.buffers.splice(e13, 1), true;
      }
    return true;
  }, e12.setOpenGLRenderWindow = (n) => {
    t._openGLRenderWindow !== n && (e12.releaseGraphicsResources(), t._openGLRenderWindow = n, t.context = null, n && (t.context = t._openGLRenderWindow.getContext()));
  };
}
var DEFAULT_VALUES$94 = {
  forceEmulation: false,
  handleVAO: 0,
  handleProgram: 0,
  supported: true,
  buffers: null,
  context: null
};
function extend$103(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$94, n), t.buffers = [], macro.obj(e12, t), macro.get(e12, t, ["supported"]), macro.setGet(e12, t, ["forceEmulation"]), vtkOpenGLVertexArrayObject(e12, t);
}
var vtkVertexArrayObject = {
  newInstance: macro.newInstance(extend$103, "vtkOpenGLVertexArrayObject"),
  extend: extend$103
}, primTypes$1 = {
  Start: 0,
  Points: 0,
  Lines: 1,
  Tris: 2,
  TriStrips: 3,
  TrisEdges: 4,
  TriStripsEdges: 5,
  End: 6
};
function vtkOpenGLHelper(e12, t) {
  t.classHierarchy.push("vtkOpenGLHelper"), e12.setOpenGLRenderWindow = (e13) => {
    t.context = e13.getContext(), t.program.setContext(t.context), t.VAO.setOpenGLRenderWindow(e13), t.CABO.setOpenGLRenderWindow(e13);
  }, e12.releaseGraphicsResources = (e13) => {
    t.VAO.releaseGraphicsResources(), t.CABO.releaseGraphicsResources(), t.CABO.setElementCount(0);
  }, e12.drawArrays = (n, r, a, o) => {
    if (t.CABO.getElementCount()) {
      let s = e12.getOpenGLMode(a), c = e12.haveWideLines(n, r), l = t.context, u = l.getParameter(l.DEPTH_WRITEMASK);
      t.pointPicking && l.depthMask(false), s === l.LINES && c ? (e12.updateShaders(n, r, o), l.drawArraysInstanced(s, 0, t.CABO.getElementCount(), 2 * Math.ceil(r.getProperty().getLineWidth()))) : (l.lineWidth(r.getProperty().getLineWidth()), e12.updateShaders(n, r, o), l.drawArrays(s, 0, t.CABO.getElementCount()), l.lineWidth(1));
      let d = (s === l.POINTS ? 1 : 0) || (s === l.LINES ? 2 : 3);
      return t.pointPicking && l.depthMask(u), t.CABO.getElementCount() / d;
    }
    return 0;
  }, e12.getOpenGLMode = (e13) => {
    if (t.pointPicking)
      return t.context.POINTS;
    let n = t.primitiveType;
    return e13 === Representation$1.POINTS || n === primTypes$1.Points ? t.context.POINTS : e13 === Representation$1.WIREFRAME || n === primTypes$1.Lines || n === primTypes$1.TrisEdges || n === primTypes$1.TriStripsEdges ? t.context.LINES : t.context.TRIANGLES;
  }, e12.haveWideLines = (e13, n) => n.getProperty().getLineWidth() > 1 ? !(t.CABO.getOpenGLRenderWindow() && t.CABO.getOpenGLRenderWindow().getHardwareMaximumLineWidth() >= n.getProperty().getLineWidth()) : false, e12.getNeedToRebuildShaders = (t2, n, r) => !!(r.getNeedToRebuildShaders(e12, t2, n) || e12.getProgram() === 0 || e12.getShaderSourceTime().getMTime() < r.getMTime() || e12.getShaderSourceTime().getMTime() < n.getMTime()), e12.updateShaders = (n, r, a) => {
    if (e12.getNeedToRebuildShaders(n, r, a)) {
      let o = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      a.buildShaders(o, n, r);
      let s = t.CABO.getOpenGLRenderWindow().getShaderCache().readyShaderProgramArray(o.Vertex, o.Fragment, o.Geometry);
      s !== e12.getProgram() && (e12.setProgram(s), e12.getVAO().releaseGraphicsResources()), e12.getShaderSourceTime().modified();
    } else
      t.CABO.getOpenGLRenderWindow().getShaderCache().readyShaderProgram(e12.getProgram());
    e12.getVAO().bind(), a.setMapperShaderParameters(e12, n, r), a.setPropertyShaderParameters(e12, n, r), a.setCameraShaderParameters(e12, n, r), a.setLightingShaderParameters(e12, n, r), a.invokeShaderCallbacks(e12, n, r);
  }, e12.setMapperShaderParameters = (n, r, a) => {
    if (e12.haveWideLines(n, r)) {
      e12.getProgram().setUniform2f("viewportSize", a.usize, a.vsize);
      let t2 = parseFloat(r.getProperty().getLineWidth()), n2 = t2 / 2;
      e12.getProgram().setUniformf("lineWidthStepSize", t2 / Math.ceil(t2)), e12.getProgram().setUniformf("halfLineWidth", n2);
    }
    t.primitiveType === primTypes$1.Points || r.getProperty().getRepresentation() === Representation$1.POINTS ? e12.getProgram().setUniformf("pointSize", r.getProperty().getPointSize()) : t.pointPicking && e12.getProgram().setUniformf("pointSize", e12.getPointPickingPrimitiveSize());
  }, e12.replaceShaderPositionVC = (n, r, a) => {
    let o = n.Vertex;
    o = vtkShaderProgram$1.substitute(o, "//VTK::PositionVC::Dec", ["//VTK::PositionVC::Dec", "uniform float pointSize;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::PositionVC::Impl", ["//VTK::PositionVC::Impl", "  gl_PointSize = pointSize;"], false).result, e12.getOpenGLMode(a.getProperty().getRepresentation()) === t.context.LINES && e12.haveWideLines(r, a) && (o = vtkShaderProgram$1.substitute(o, "//VTK::PositionVC::Dec", [
      "//VTK::PositionVC::Dec",
      "uniform vec2 viewportSize;",
      "uniform float lineWidthStepSize;",
      "uniform float halfLineWidth;"
    ]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::PositionVC::Impl", [
      "//VTK::PositionVC::Impl",
      " if (halfLineWidth > 0.0)",
      "   {",
      "   float offset = float(gl_InstanceID / 2) * lineWidthStepSize - halfLineWidth;",
      "   vec4 tmpPos = gl_Position;",
      "   vec3 tmpPos2 = tmpPos.xyz / tmpPos.w;",
      "   tmpPos2.x = tmpPos2.x + 2.0 * mod(float(gl_InstanceID), 2.0) * offset / viewportSize[0];",
      "   tmpPos2.y = tmpPos2.y + 2.0 * mod(float(gl_InstanceID + 1), 2.0) * offset / viewportSize[1];",
      "   gl_Position = vec4(tmpPos2.xyz * tmpPos.w, tmpPos.w);",
      "   }"
    ]).result), n.Vertex = o;
  }, e12.getPointPickingPrimitiveSize = () => t.primitiveType === primTypes$1.Points ? 2 : t.primitiveType === primTypes$1.Lines ? 4 : 6, e12.getAllocatedGPUMemoryInBytes = () => e12.getCABO().getAllocatedGPUMemoryInBytes();
}
var DEFAULT_VALUES$93 = {
  context: null,
  program: null,
  shaderSourceTime: null,
  VAO: null,
  attributeUpdateTime: null,
  CABO: null,
  primitiveType: 0,
  pointPicking: false
};
function extend$102(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$93, n), macro.obj(e12, t), t.shaderSourceTime = {}, macro.obj(t.shaderSourceTime), t.attributeUpdateTime = {}, macro.obj(t.attributeUpdateTime), macro.setGet(e12, t, [
    "program",
    "shaderSourceTime",
    "VAO",
    "attributeUpdateTime",
    "CABO",
    "primitiveType",
    "pointPicking"
  ]), t.program = vtkShaderProgram$1.newInstance(), t.VAO = vtkVertexArrayObject.newInstance(), t.CABO = vtkCellArrayBufferObject.newInstance(), vtkOpenGLHelper(e12, t);
}
var vtkHelper = {
  newInstance: macro.newInstance(extend$102),
  extend: extend$102,
  primTypes: primTypes$1
}, NoOp = (e12) => e12, EPSILON$2 = 1e-6, Transform$1 = class {
  constructor() {
    let e12 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    this.matrix = identity$2(new Float64Array(16)), this.tmp = new Float64Array(3), this.angleConv = e12 ? toRadian : NoOp;
  }
  rotateFromDirections(e12, t) {
    let n = new Float64Array(3), r = new Float64Array(3), a = new Float64Array(16);
    set$4(n, e12[0], e12[1], e12[2]), set$4(r, t[0], t[1], t[2]), normalize$4(n, n), normalize$4(r, r);
    let o = dot$3(n, r);
    return o >= 1 ? this : (cross$1(this.tmp, n, r), length$2(this.tmp) < EPSILON$2 && (cross$1(this.tmp, [
      1,
      0,
      0
    ], e12), length$2(this.tmp) < EPSILON$2 && cross$1(this.tmp, [
      0,
      1,
      0
    ], e12)), fromRotation(a, Math.acos(o), this.tmp), multiply$2(this.matrix, this.matrix, a), this);
  }
  rotate(e12, t) {
    return set$4(this.tmp, ...t), normalize$4(this.tmp, this.tmp), rotate(this.matrix, this.matrix, this.angleConv(e12), this.tmp), this;
  }
  rotateX(e12) {
    return rotateX(this.matrix, this.matrix, this.angleConv(e12)), this;
  }
  rotateY(e12) {
    return rotateY(this.matrix, this.matrix, this.angleConv(e12)), this;
  }
  rotateZ(e12) {
    return rotateZ(this.matrix, this.matrix, this.angleConv(e12)), this;
  }
  translate(e12, t, n) {
    return set$4(this.tmp, e12, t, n), translate(this.matrix, this.matrix, this.tmp), this;
  }
  scale(e12, t, n) {
    return set$4(this.tmp, e12, t, n), scale$4(this.matrix, this.matrix, this.tmp), this;
  }
  multiply(e12) {
    return multiply$2(this.matrix, this.matrix, e12), this;
  }
  multiply3x3(e12) {
    return multiply$2(this.matrix, this.matrix, [
      e12[0],
      e12[1],
      e12[2],
      0,
      e12[3],
      e12[4],
      e12[5],
      0,
      e12[6],
      e12[7],
      e12[8],
      0,
      0,
      0,
      0,
      1
    ]), this;
  }
  invert() {
    return invert(this.matrix, this.matrix), this;
  }
  identity() {
    return identity$2(this.matrix), this;
  }
  apply(e12) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    if (areMatricesEqual(IDENTITY, this.matrix))
      return this;
    let r = n === -1 ? e12.length : t + n * 3;
    for (let n2 = t; n2 < r; n2 += 3)
      set$4(this.tmp, e12[n2], e12[n2 + 1], e12[n2 + 2]), transformMat4$1(this.tmp, this.tmp, this.matrix), e12[n2] = this.tmp[0], e12[n2 + 1] = this.tmp[1], e12[n2 + 2] = this.tmp[2];
    return this;
  }
  getMatrix() {
    return this.matrix;
  }
  setMatrix(e12) {
    return e12 && e12.length === 16 && copy$4(this.matrix, e12), this;
  }
};
function buildFromDegree() {
  return new Transform$1(true);
}
function buildFromRadian() {
  return new Transform$1(false);
}
var vtkMatrixBuilder = {
  buildFromDegree,
  buildFromRadian
}, LINE_ARRAY = [
  2,
  0,
  1,
  2,
  2,
  3,
  2,
  4,
  5,
  2,
  6,
  7,
  2,
  0,
  2,
  2,
  1,
  3,
  2,
  4,
  6,
  2,
  5,
  7,
  2,
  0,
  4,
  2,
  1,
  5,
  2,
  2,
  6,
  2,
  3,
  7
], POLY_ARRAY = [
  4,
  0,
  1,
  3,
  2,
  4,
  4,
  6,
  7,
  5,
  4,
  8,
  10,
  11,
  9,
  4,
  12,
  13,
  15,
  14,
  4,
  16,
  18,
  19,
  17,
  4,
  20,
  21,
  23,
  22
];
function vtkCubeSource(e12, t) {
  t.classHierarchy.push("vtkCubeSource"), e12.requestData = (e13, n) => {
    let r = n[0]?.initialize() || vtkPolyData$1.newInstance();
    n[0] = r;
    let a = macro.newTypedArray(t.pointType, 72);
    r.getPoints().setData(a, 3);
    let o = macro.newTypedArray(t.pointType, 72), s = vtkDataArray$1.newInstance({
      name: "Normals",
      values: o,
      numberOfComponents: 3
    });
    r.getPointData().setNormals(s);
    let c = 2;
    t.generate3DTextureCoordinates === true && (c = 3);
    let l = macro.newTypedArray(t.pointType, 24 * c), u = vtkDataArray$1.newInstance({
      name: "TextureCoordinates",
      values: l,
      numberOfComponents: c
    });
    r.getPointData().setTCoords(u);
    let d = [
      0,
      0,
      0
    ], f = [
      0,
      0,
      0
    ], p = [0, 0], m = 0;
    d[0] = -t.xLength / 2, f[0] = -1, f[1] = 0, f[2] = 0;
    for (let e14 = 0; e14 < 2; e14++) {
      d[1] = -t.yLength / 2;
      for (let n2 = 0; n2 < 2; n2++) {
        p[1] = d[1] + 0.5, d[2] = -t.zLength / 2;
        for (let r2 = 0; r2 < 2; r2++)
          p[0] = (d[2] + 0.5) * (1 - 2 * e14), a[m * 3] = d[0], a[m * 3 + 1] = d[1], a[m * 3 + 2] = d[2], o[m * 3] = f[0], o[m * 3 + 1] = f[1], o[m * 3 + 2] = f[2], c === 2 ? (l[m * c] = p[0], l[m * c + 1] = p[1]) : (l[m * c] = 2 * e14 - 1, l[m * c + 1] = 2 * n2 - 1, l[m * c + 2] = 2 * r2 - 1), m++, d[2] += t.zLength;
        d[1] += t.yLength;
      }
      d[0] += t.xLength, f[0] += 2;
    }
    d[1] = -t.yLength / 2, f[1] = -1, f[0] = 0, f[2] = 0;
    for (let e14 = 0; e14 < 2; e14++) {
      d[0] = -t.xLength / 2;
      for (let n2 = 0; n2 < 2; n2++) {
        p[0] = (d[0] + 0.5) * (2 * e14 - 1), d[2] = -t.zLength / 2;
        for (let r2 = 0; r2 < 2; r2++)
          p[1] = (d[2] + 0.5) * -1, a[m * 3] = d[0], a[m * 3 + 1] = d[1], a[m * 3 + 2] = d[2], o[m * 3] = f[0], o[m * 3 + 1] = f[1], o[m * 3 + 2] = f[2], c === 2 ? (l[m * c] = p[0], l[m * c + 1] = p[1]) : (l[m * c] = 2 * n2 - 1, l[m * c + 1] = 2 * e14 - 1, l[m * c + 2] = 2 * r2 - 1), m++, d[2] += t.zLength;
        d[0] += t.xLength;
      }
      d[1] += t.yLength, f[1] += 2;
    }
    d[2] = -t.zLength / 2, f[2] = -1, f[0] = 0, f[1] = 0;
    for (let e14 = 0; e14 < 2; e14++) {
      d[1] = -t.yLength / 2;
      for (let n2 = 0; n2 < 2; n2++) {
        p[1] = d[1] + 0.5, d[0] = -t.xLength / 2;
        for (let r2 = 0; r2 < 2; r2++)
          p[0] = (d[0] + 0.5) * (2 * e14 - 1), a[m * 3] = d[0], a[m * 3 + 1] = d[1], a[m * 3 + 2] = d[2], o[m * 3] = f[0], o[m * 3 + 1] = f[1], o[m * 3 + 2] = f[2], c === 2 ? (l[m * c] = p[0], l[m * c + 1] = p[1]) : (l[m * c] = 2 * r2 - 1, l[m * c + 1] = 2 * n2 - 1, l[m * c + 2] = 2 * e14 - 1), m++, d[0] += t.xLength;
        d[1] += t.yLength;
      }
      d[2] += t.zLength, f[2] += 2;
    }
    if (t.rotations && vtkMatrixBuilder.buildFromDegree().rotateX(t.rotations[0]).rotateY(t.rotations[1]).rotateZ(t.rotations[2]).apply(a).apply(o), t.center && vtkMatrixBuilder.buildFromRadian().translate(...t.center).apply(a), t.matrix) {
      vtkMatrixBuilder.buildFromRadian().setMatrix(t.matrix).apply(a);
      let e14 = [
        t.matrix[0],
        t.matrix[1],
        t.matrix[2],
        0,
        t.matrix[4],
        t.matrix[5],
        t.matrix[6],
        0,
        t.matrix[8],
        t.matrix[9],
        t.matrix[10],
        0,
        0,
        0,
        0,
        1
      ];
      vtkMatrixBuilder.buildFromRadian().setMatrix(e14).apply(o);
    }
    t.generateFaces ? r.getPolys().deepCopy(t._polys) : r.getPolys().initialize(), t.generateLines ? (r.getLines().deepCopy(t._lineCells), r.getPointData().setNormals(null)) : r.getLines().initialize(), r.modified();
  }, e12.setBounds = function() {
    let t2 = [];
    if (Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]))
      t2 = arguments.length <= 0 ? void 0 : arguments[0];
    else
      for (let e13 = 0; e13 < arguments.length; e13++)
        t2.push(e13 < 0 || arguments.length <= e13 ? void 0 : arguments[e13]);
    t2.length === 6 && (e12.setXLength(t2[1] - t2[0]), e12.setYLength(t2[3] - t2[2]), e12.setZLength(t2[5] - t2[4]), e12.setCenter([
      (t2[0] + t2[1]) / 2,
      (t2[2] + t2[3]) / 2,
      (t2[4] + t2[5]) / 2
    ]));
  };
}
var DEFAULT_VALUES$92 = {
  xLength: 1,
  yLength: 1,
  zLength: 1,
  pointType: "Float64Array",
  generate3DTextureCoordinates: false,
  generateFaces: true,
  generateLines: false
};
function extend$101(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$92, n), macro.obj(e12, t), macro.setGet(e12, t, [
    "xLength",
    "yLength",
    "zLength",
    "generate3DTextureCoordinates",
    "generateFaces",
    "generateLines"
  ]), macro.setGetArray(e12, t, ["center", "rotations"], 3), macro.setGetArray(e12, t, ["matrix"], 16), t._polys = vtkCellArray$1.newInstance({ values: Uint16Array.from(POLY_ARRAY) }), t._lineCells = vtkCellArray$1.newInstance({ values: Uint16Array.from(LINE_ARRAY) }), macro.moveToProtected(e12, t, ["polys", "lineCells"]), macro.algo(e12, t, 0, 1), vtkCubeSource(e12, t);
}
var vtkCubeSource$1 = {
  newInstance: macro.newInstance(extend$101, "vtkCubeSource"),
  extend: extend$101
}, { vtkErrorMacro: vtkErrorMacro$28 } = macro;
function vtkImageDataOutlineFilter(e12, t) {
  t.classHierarchy.push("vtkImageDataOutlineFilter");
  let n = { ...e12 };
  e12.requestData = (e13, n2) => {
    let r = e13[0];
    if (!r || !r.isA("vtkImageData")) {
      vtkErrorMacro$28("Invalid or missing input");
      return;
    }
    let a = r.getSpatialExtent();
    if (!a) {
      vtkErrorMacro$28("Unable to fetch spatial extents of input image.");
      return;
    }
    t._cubeSource.setBounds(a), t._cubeSource.setMatrix(r.getIndexToWorld()), n2[0] = t._cubeSource.getOutputData();
  }, e12.getMTime = () => Math.max(n.getMTime(), t._cubeSource.getMTime()), e12.setGenerateFaces = t._cubeSource.setGenerateFaces, e12.setGenerateLines = t._cubeSource.setGenerateLines, e12.getGenerateFaces = t._cubeSource.getGenerateFaces, e12.getGenerateLines = t._cubeSource.getGenerateLines;
}
var DEFAULT_VALUES$91 = {};
function extend$100(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$91, n), macro.obj(e12, t), macro.algo(e12, t, 1, 1), t._cubeSource = vtkCubeSource$1.newInstance(), macro.moveToProtected(e12, t, ["cubeSource", "tmpOut"]), vtkImageDataOutlineFilter(e12, t);
}
var vtkImageDataOutlineFilter$1 = {
  newInstance: macro.newInstance(extend$100, "vtkImageDataOutlineFilter"),
  extend: extend$100
}, Wrap$2 = {
  CLAMP_TO_EDGE: 0,
  REPEAT: 1,
  MIRRORED_REPEAT: 2
}, Filter$1 = {
  NEAREST: 0,
  LINEAR: 1,
  NEAREST_MIPMAP_NEAREST: 2,
  NEAREST_MIPMAP_LINEAR: 3,
  LINEAR_MIPMAP_NEAREST: 4,
  LINEAR_MIPMAP_LINEAR: 5
}, Constants$11 = {
  Wrap: Wrap$2,
  Filter: Filter$1
}, floatView = new Float32Array(1), int32View = new Int32Array(floatView.buffer);
function toHalf$1(e12) {
  floatView[0] = e12;
  let t = int32View[0], n = t >> 16 & 32768, r = t >> 12 & 2047, a = t >> 23 & 255;
  return a < 103 ? n : a > 142 ? (n |= 31744, n |= (a === 255 ? 0 : 1) && t & 8388607, n) : a < 113 ? (r |= 2048, n |= (r >> 114 - a) + (r >> 113 - a & 1), n) : (n |= a - 112 << 10 | r >> 1, n += r & 1, n);
}
function fromHalf(e12) {
  let t = (e12 & 32768) >> 15, n = (e12 & 31744) >> 10, r = e12 & 1023;
  return n === 0 ? (t ? -1 : 1) * 2 ** -14 * (r / 2 ** 10) : n === 31 ? r ? NaN : (t ? -1 : 1) * Infinity : (t ? -1 : 1) * 2 ** (n - 15) * (1 + r / 2 ** 10);
}
var HalfFloat = {
  fromHalf,
  toHalf: toHalf$1
};
function supportsNorm16Linear() {
  try {
    let e12 = new Int16Array([0, 2 ** 15 - 1]), t = [1, 1], n = document.createElement("canvas");
    n.width = 4, n.height = 4;
    let r = n.getContext("webgl2");
    if (!r)
      return false;
    let a = r.getExtension("EXT_texture_norm16");
    if (!a)
      return false;
    let o = `#version 300 es
    void main() {
      gl_PointSize = ${4 .toFixed(1)};
      gl_Position = vec4(0, 0, 0, 1);
    }
  `, s = r.createShader(r.VERTEX_SHADER);
    if (r.shaderSource(s, o), r.compileShader(s), !r.getShaderParameter(s, r.COMPILE_STATUS))
      return false;
    let c = r.createShader(r.FRAGMENT_SHADER);
    if (r.shaderSource(c, "#version 300 es\n    precision highp float;\n    precision highp int;\n    precision highp sampler2D;\n\n    uniform sampler2D u_image;\n\n    out vec4 color;\n\n    void main() {\n        vec4 intColor = texture(u_image, gl_PointCoord.xy);\n        color = vec4(vec3(intColor.rrr), 1);\n    }\n    "), r.compileShader(c), !r.getShaderParameter(c, r.COMPILE_STATUS))
      return false;
    let l = r.createProgram();
    if (r.attachShader(l, s), r.attachShader(l, c), r.linkProgram(l), !r.getProgramParameter(l, r.LINK_STATUS))
      return false;
    let u = r.createTexture();
    r.bindTexture(r.TEXTURE_2D, u), r.texImage2D(r.TEXTURE_2D, 0, a.R16_SNORM_EXT, 2, 1, 0, r.RED, r.SHORT, e12), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), r.useProgram(l), r.drawArrays(r.POINTS, 0, 1);
    let d = new Uint8Array(4);
    r.readPixels(t[0], t[1], 1, 1, r.RGBA, r.UNSIGNED_BYTE, d);
    let [f, p, m] = d, h = r.getExtension("WEBGL_lose_context");
    return h && h.loseContext(), f === p && p === m && f !== 0;
  } catch {
    return false;
  }
}
var supportsNorm16LinearCache;
function supportsNorm16LinearCached() {
  return supportsNorm16LinearCache === void 0 && (supportsNorm16LinearCache = supportsNorm16Linear()), supportsNorm16LinearCache;
}
var import_fast_deep_equal$2 = /* @__PURE__ */ __toESM(require_fast_deep_equal(), 1), { Wrap: Wrap$3, Filter: Filter$3 } = Constants$11, { VtkDataTypes: VtkDataTypes$3 } = vtkDataArray$1, { vtkDebugMacro: vtkDebugMacro$7, vtkErrorMacro: vtkErrorMacro$27, vtkWarningMacro: vtkWarningMacro$5, requiredParam: requiredParam$1 } = macro$1, { toHalf } = HalfFloat;
function vtkOpenGLTexture(e12, t) {
  t.classHierarchy.push("vtkOpenGLTexture");
  function n() {
    return {
      internalFormat: t.internalFormat,
      format: t.format,
      openGLDataType: t.openGLDataType,
      width: t.width,
      height: t.height
    };
  }
  e12.render = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    if (n2 ? t._openGLRenderWindow = n2 : (t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getLastAncestorOfType("vtkOpenGLRenderWindow")), t.context = t._openGLRenderWindow.getContext(), t.renderable.getInterpolate() ? (t.generateMipmap ? e12.setMinificationFilter(Filter$3.LINEAR_MIPMAP_LINEAR) : e12.setMinificationFilter(Filter$3.LINEAR), e12.setMagnificationFilter(Filter$3.LINEAR)) : (e12.setMinificationFilter(Filter$3.NEAREST), e12.setMagnificationFilter(Filter$3.NEAREST)), t.renderable.getRepeat() && (e12.setWrapR(Wrap$3.REPEAT), e12.setWrapS(Wrap$3.REPEAT), e12.setWrapT(Wrap$3.REPEAT)), t.renderable.getInputData() && t.renderable.setImage(null), !t.handle || t.renderable.getMTime() > t.textureBuildTime.getMTime()) {
      if (t.renderable.getImageBitmap() !== null && (t.renderable.getInterpolate() && (t.generateMipmap = true, e12.setMinificationFilter(Filter$3.LINEAR_MIPMAP_LINEAR)), t.renderable.getImageBitmap() && t.renderable.getImageLoaded() && (e12.create2DFromImageBitmap(t.renderable.getImageBitmap()), e12.activate(), e12.sendParameters(), t.textureBuildTime.modified())), t.renderable.getImage() !== null && (t.renderable.getInterpolate() && (t.generateMipmap = true, e12.setMinificationFilter(Filter$3.LINEAR_MIPMAP_LINEAR)), t.renderable.getImage() && t.renderable.getImageLoaded() && (e12.create2DFromImage(t.renderable.getImage()), e12.activate(), e12.sendParameters(), t.textureBuildTime.modified())), t.renderable.getCanvas() !== null) {
        t.renderable.getInterpolate() && (t.generateMipmap = true, e12.setMinificationFilter(Filter$3.LINEAR_MIPMAP_LINEAR));
        let n4 = t.renderable.getCanvas();
        e12.create2DFromRaw({
          width: n4.width,
          height: n4.height,
          numComps: 4,
          dataType: VtkDataTypes$3.UNSIGNED_CHAR,
          data: n4,
          flip: true
        }), e12.activate(), e12.sendParameters(), t.textureBuildTime.modified();
      }
      if (t.renderable.getJsImageData() !== null) {
        let n4 = t.renderable.getJsImageData();
        t.renderable.getInterpolate() && (t.generateMipmap = true, e12.setMinificationFilter(Filter$3.LINEAR_MIPMAP_LINEAR)), e12.create2DFromRaw({
          width: n4.width,
          height: n4.height,
          numComps: 4,
          dataType: VtkDataTypes$3.UNSIGNED_CHAR,
          data: n4.data,
          flip: true
        }), e12.activate(), e12.sendParameters(), t.textureBuildTime.modified();
      }
      let n3 = t.renderable.getInputData(0);
      if (n3 && n3.getPointData().getScalars()) {
        let r2 = n3.getExtent(), a2 = n3.getPointData().getScalars(), o2 = [];
        for (let e13 = 0; e13 < t.renderable.getNumberOfInputPorts(); ++e13) {
          let n4 = t.renderable.getInputData(e13), r3 = n4 ? n4.getPointData().getScalars().getData() : null;
          r3 && o2.push(r3);
        }
        t.renderable.getInterpolate() && a2.getNumberOfComponents() === 4 && (t.generateMipmap = true, e12.setMinificationFilter(Filter$3.LINEAR_MIPMAP_LINEAR)), o2.length % 6 == 0 ? e12.createCubeFromRaw({
          width: r2[1] - r2[0] + 1,
          height: r2[3] - r2[2] + 1,
          numComps: a2.getNumberOfComponents(),
          dataType: a2.getDataType(),
          data: o2
        }) : e12.create2DFromRaw({
          width: r2[1] - r2[0] + 1,
          height: r2[3] - r2[2] + 1,
          numComps: a2.getNumberOfComponents(),
          dataType: a2.getDataType(),
          data: a2.getData()
        }), e12.activate(), e12.sendParameters(), t.textureBuildTime.modified();
      }
    }
    t.handle && e12.activate();
  };
  let r = () => {
    if (!((t.minificationFilter === Filter$3.LINEAR || t.magnificationFilter === Filter$3.LINEAR) && !supportsNorm16LinearCached()))
      return t.oglNorm16Ext;
  };
  e12.destroyTexture = () => {
    e12.deactivate(), t.context && t.handle && t.context.deleteTexture(t.handle), t._prevTexParams = null, t.handle = 0, t.numberOfDimensions = 0, t.target = 0, t.components = 0, t.width = 0, t.height = 0, t.depth = 0, e12.resetFormatAndType();
  }, e12.createTexture = () => {
    t.handle || (t.handle = t.context.createTexture(), t.target && (t.context.bindTexture(t.target, t.handle), t.context.texParameteri(t.target, t.context.TEXTURE_MIN_FILTER, e12.getOpenGLFilterMode(t.minificationFilter)), t.context.texParameteri(t.target, t.context.TEXTURE_MAG_FILTER, e12.getOpenGLFilterMode(t.magnificationFilter)), t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_S, e12.getOpenGLWrapMode(t.wrapS)), t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_T, e12.getOpenGLWrapMode(t.wrapT)), t._openGLRenderWindow.getWebgl2() && t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_R, e12.getOpenGLWrapMode(t.wrapR)), t.context.bindTexture(t.target, null)));
  }, e12.getTextureUnit = () => t._openGLRenderWindow ? t._openGLRenderWindow.getTextureUnitForTexture(e12) : -1, e12.activate = () => {
    t._openGLRenderWindow.activateTexture(e12), e12.bind();
  }, e12.deactivate = () => {
    t._openGLRenderWindow && t._openGLRenderWindow.deactivateTexture(e12);
  }, e12.releaseGraphicsResources = (n2) => {
    n2 && t.handle && (n2.activateTexture(e12), n2.deactivateTexture(e12), t.context.deleteTexture(t.handle), t._prevTexParams = null, t.handle = 0, t.numberOfDimensions = 0, t.target = 0, t.internalFormat = 0, t.format = 0, t.openGLDataType = 0, t.components = 0, t.width = 0, t.height = 0, t.depth = 0, t.allocatedGPUMemoryInBytes = 0), t.shaderProgram &&= (t.shaderProgram.releaseGraphicsResources(n2), null);
  }, e12.bind = () => {
    t.context.bindTexture(t.target, t.handle), t.autoParameters && e12.getMTime() > t.sendParametersTime.getMTime() && e12.sendParameters();
  }, e12.isBound = () => {
    let e13 = false;
    if (t.context && t.handle) {
      let n2 = 0;
      switch (t.target) {
        case t.context.TEXTURE_2D:
          n2 = t.context.TEXTURE_BINDING_2D;
          break;
        default:
          vtkWarningMacro$5("impossible case");
          break;
      }
      e13 = t.context.getIntegerv(n2) === t.handle;
    }
    return e13;
  }, e12.sendParameters = () => {
    t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_S, e12.getOpenGLWrapMode(t.wrapS)), t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_T, e12.getOpenGLWrapMode(t.wrapT)), t._openGLRenderWindow.getWebgl2() && t.context.texParameteri(t.target, t.context.TEXTURE_WRAP_R, e12.getOpenGLWrapMode(t.wrapR)), t.context.texParameteri(t.target, t.context.TEXTURE_MIN_FILTER, e12.getOpenGLFilterMode(t.minificationFilter)), t.context.texParameteri(t.target, t.context.TEXTURE_MAG_FILTER, e12.getOpenGLFilterMode(t.magnificationFilter)), t._openGLRenderWindow.getWebgl2() && (t.context.texParameteri(t.target, t.context.TEXTURE_BASE_LEVEL, t.baseLevel), t.context.texParameteri(t.target, t.context.TEXTURE_MAX_LEVEL, t.maxLevel)), t.sendParametersTime.modified();
  }, e12.getInternalFormat = (n2, r2) => (t._forceInternalFormat || (t.internalFormat = e12.getDefaultInternalFormat(n2, r2)), t.internalFormat || vtkDebugMacro$7(`Unable to find suitable internal format for T=${n2} NC= ${r2}`), [
    t.context.R32F,
    t.context.RG32F,
    t.context.RGB32F,
    t.context.RGBA32F
  ].includes(t.internalFormat) && !t.context.getExtension("OES_texture_float_linear") && vtkWarningMacro$5("Failed to load OES_texture_float_linear. Texture filtering is not available for *32F internal formats."), t.internalFormat), e12.getDefaultInternalFormat = (n2, a2) => {
    let o2 = 0;
    return o2 = t._openGLRenderWindow.getDefaultTextureInternalFormat(n2, a2, r(), e12.useHalfFloat()), o2 || (o2 || (vtkDebugMacro$7("Unsupported internal texture type!"), vtkDebugMacro$7(`Unable to find suitable internal format for T=${n2} NC= ${a2}`)), o2);
  }, e12.useHalfFloat = () => t.enableUseHalfFloat && t.canUseHalfFloat, e12.setInternalFormat = (n2) => {
    t._forceInternalFormat = true, n2 !== t.internalFormat && (t.internalFormat = n2, e12.modified());
  }, e12.getFormat = (n2, r2) => (t.format = e12.getDefaultFormat(n2, r2), t.format), e12.getDefaultFormat = (e13, n2) => {
    if (t._openGLRenderWindow.getWebgl2())
      switch (n2) {
        case 1:
          return t.context.RED;
        case 2:
          return t.context.RG;
        case 3:
          return t.context.RGB;
        case 4:
          return t.context.RGBA;
        default:
          return t.context.RGB;
      }
    else
      switch (n2) {
        case 1:
          return t.context.LUMINANCE;
        case 2:
          return t.context.LUMINANCE_ALPHA;
        case 3:
          return t.context.RGB;
        case 4:
          return t.context.RGBA;
        default:
          return t.context.RGB;
      }
  }, e12.resetFormatAndType = () => {
    t._prevTexParams = null, t.format = 0, t.internalFormat = 0, t._forceInternalFormat = false, t.openGLDataType = 0;
  }, e12.getDefaultDataType = (n2) => {
    let a2 = e12.useHalfFloat();
    if (t._openGLRenderWindow.getWebgl2())
      switch (n2) {
        case VtkDataTypes$3.UNSIGNED_CHAR:
          return t.context.UNSIGNED_BYTE;
        case (r() && !a2 && VtkDataTypes$3.SHORT):
          return t.context.SHORT;
        case (r() && !a2 && VtkDataTypes$3.UNSIGNED_SHORT):
          return t.context.UNSIGNED_SHORT;
        case (a2 && VtkDataTypes$3.SHORT):
          return t.context.HALF_FLOAT;
        case (a2 && VtkDataTypes$3.UNSIGNED_SHORT):
          return t.context.HALF_FLOAT;
        case VtkDataTypes$3.FLOAT:
        case VtkDataTypes$3.VOID:
        default:
          return t.context.FLOAT;
      }
    switch (n2) {
      case VtkDataTypes$3.UNSIGNED_CHAR:
        return t.context.UNSIGNED_BYTE;
      case VtkDataTypes$3.FLOAT:
      case VtkDataTypes$3.VOID:
      default:
        if (t.context.getExtension("OES_texture_float") && t.context.getExtension("OES_texture_float_linear"))
          return t.context.FLOAT;
        {
          let e13 = t.context.getExtension("OES_texture_half_float");
          if (e13 && t.context.getExtension("OES_texture_half_float_linear"))
            return e13.HALF_FLOAT_OES;
        }
        return t.context.UNSIGNED_BYTE;
    }
  }, e12.getOpenGLDataType = function(n2) {
    let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (!t.openGLDataType || r2) && (t.openGLDataType = e12.getDefaultDataType(n2)), t.openGLDataType;
  }, e12.getShiftAndScale = () => {
    let e13 = 0, n2 = 1;
    switch (t.openGLDataType) {
      case t.context.BYTE:
        n2 = 127.5, e13 = n2 - 128;
        break;
      case t.context.UNSIGNED_BYTE:
        n2 = 255, e13 = 0;
        break;
      case t.context.SHORT:
        n2 = 32767.5, e13 = n2 - 32768;
        break;
      case t.context.UNSIGNED_SHORT:
        n2 = 65536, e13 = 0;
        break;
      case t.context.INT:
        n2 = 21474836475e-1, e13 = n2 - 2147483648;
        break;
      case t.context.UNSIGNED_INT:
        n2 = 4294967295, e13 = 0;
        break;
      case t.context.FLOAT:
    }
    return {
      shift: e13,
      scale: n2
    };
  }, e12.getOpenGLFilterMode = (e13) => {
    switch (e13) {
      case Filter$3.NEAREST:
        return t.context.NEAREST;
      case Filter$3.LINEAR:
        return t.context.LINEAR;
      case Filter$3.NEAREST_MIPMAP_NEAREST:
        return t.context.NEAREST_MIPMAP_NEAREST;
      case Filter$3.NEAREST_MIPMAP_LINEAR:
        return t.context.NEAREST_MIPMAP_LINEAR;
      case Filter$3.LINEAR_MIPMAP_NEAREST:
        return t.context.LINEAR_MIPMAP_NEAREST;
      case Filter$3.LINEAR_MIPMAP_LINEAR:
        return t.context.LINEAR_MIPMAP_LINEAR;
      default:
        return t.context.NEAREST;
    }
  }, e12.getOpenGLWrapMode = (e13) => {
    switch (e13) {
      case Wrap$3.CLAMP_TO_EDGE:
        return t.context.CLAMP_TO_EDGE;
      case Wrap$3.REPEAT:
        return t.context.REPEAT;
      case Wrap$3.MIRRORED_REPEAT:
        return t.context.MIRRORED_REPEAT;
      default:
        return t.context.CLAMP_TO_EDGE;
    }
  };
  function a(e13) {
    let [t2, n2, r2, a2, o2, s2] = e13;
    return [
      n2 - t2 + 1,
      a2 - r2 + 1,
      s2 - o2 + 1
    ];
  }
  function o(e13) {
    let [t2, n2, r2] = a(e13);
    return t2 * n2 * r2;
  }
  function s(e13, t2, n2, r2, a2) {
    let [o2, s2, c2, l2, u2, d2] = n2, [f2, p2] = t2, m2 = f2 * p2, h = a2;
    for (let t3 = u2; t3 <= d2; t3++) {
      let n3 = t3 * m2;
      for (let t4 = c2; t4 <= l2; t4++) {
        let a3 = n3 + t4 * f2;
        for (let t5 = a3 + o2, n4 = a3 + s2; t5 <= n4; t5++, h++)
          r2[h] = e13[t5];
      }
    }
  }
  function c(e13, n2) {
    let r2 = new ((arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null) || e13.constructor)(n2.reduce((e14, t2) => e14 + o(t2), 0)), a2 = [
      t.width,
      t.height,
      t.depth
    ], c2 = 0;
    return n2.forEach((t2) => {
      s(e13, a2, t2, r2, c2), c2 += o(t2);
    }), r2;
  }
  e12.updateArrayDataTypeForGL = function(e13, n2) {
    let r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, a2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], o2 = [], s2 = t.width * t.height * t.components;
    r2 && (s2 *= t.depth);
    let l2 = !!a2.length;
    if (e13 !== VtkDataTypes$3.FLOAT && t.openGLDataType === t.context.FLOAT)
      for (let e14 = 0; e14 < n2.length; e14++)
        if (n2[e14])
          if (l2)
            o2.push(c(n2[e14], a2, Float32Array));
          else {
            let t2 = n2[e14].length > s2 ? n2[e14].subarray(0, s2) : n2[e14];
            o2.push(new Float32Array(t2));
          }
        else
          o2.push(null);
    if (e13 !== VtkDataTypes$3.UNSIGNED_CHAR && t.openGLDataType === t.context.UNSIGNED_BYTE)
      for (let e14 = 0; e14 < n2.length; e14++)
        if (n2[e14])
          if (l2)
            o2.push(c(n2[e14], a2, Uint8Array));
          else {
            let t2 = n2[e14].length > s2 ? n2[e14].subarray(0, s2) : n2[e14];
            o2.push(new Uint8Array(t2));
          }
        else
          o2.push(null);
    let u2 = false;
    if (t._openGLRenderWindow.getWebgl2())
      u2 = t.openGLDataType === t.context.HALF_FLOAT;
    else {
      let e14 = t.context.getExtension("OES_texture_half_float");
      u2 = e14 && t.openGLDataType === e14.HALF_FLOAT_OES;
    }
    if (u2)
      for (let e14 = 0; e14 < n2.length; e14++)
        if (n2[e14]) {
          let t2 = l2 ? c(n2[e14], a2) : n2[e14], r3 = new Uint16Array(l2 ? t2.length : s2), u3 = r3.length;
          for (let e15 = 0; e15 < u3; e15++)
            r3[e15] = toHalf(t2[e15]);
          o2.push(r3);
        } else
          o2.push(null);
    if (o2.length === 0)
      for (let e14 = 0; e14 < n2.length; e14++)
        o2.push(l2 && n2[e14] ? c(n2[e14], a2) : n2[e14]);
    return o2;
  };
  function l(e13) {
    if (t._openGLRenderWindow.getWebgl2())
      return e13;
    let n2 = [], r2 = t.width, a2 = t.height, o2 = t.components;
    if (e13 && (!isPowerOfTwo(r2) || !isPowerOfTwo(a2))) {
      let s2 = t.context.getExtension("OES_texture_half_float"), c2 = nearestPowerOfTwo(r2), l2 = nearestPowerOfTwo(a2), u2 = c2 * l2 * t.components;
      for (let d2 = 0; d2 < e13.length; d2++)
        if (e13[d2] !== null) {
          let f2 = null, p2 = a2 / l2, m2 = r2 / c2, h = false;
          t.openGLDataType === t.context.FLOAT ? f2 = new Float32Array(u2) : s2 && t.openGLDataType === s2.HALF_FLOAT_OES ? (f2 = new Uint16Array(u2), h = true) : f2 = new Uint8Array(u2);
          for (let t2 = 0; t2 < l2; t2++) {
            let n3 = t2 * c2 * o2, s3 = t2 * p2, l3 = Math.floor(s3), u3 = Math.ceil(s3);
            u3 >= a2 && (u3 = a2 - 1);
            let g = s3 - l3, _ = 1 - g;
            l3 = l3 * r2 * o2, u3 = u3 * r2 * o2;
            for (let t3 = 0; t3 < c2; t3++) {
              let a3 = t3 * o2, s4 = t3 * m2, c3 = Math.floor(s4), p3 = Math.ceil(s4);
              p3 >= r2 && (p3 = r2 - 1);
              let v = s4 - c3;
              c3 *= o2, p3 *= o2;
              for (let t4 = 0; t4 < o2; t4++)
                h ? f2[n3 + a3 + t4] = HalfFloat.toHalf(HalfFloat.fromHalf(e13[d2][l3 + c3 + t4]) * _ * (1 - v) + HalfFloat.fromHalf(e13[d2][l3 + p3 + t4]) * _ * v + HalfFloat.fromHalf(e13[d2][u3 + c3 + t4]) * g * (1 - v) + HalfFloat.fromHalf(e13[d2][u3 + p3 + t4]) * g * v) : f2[n3 + a3 + t4] = e13[d2][l3 + c3 + t4] * _ * (1 - v) + e13[d2][l3 + p3 + t4] * _ * v + e13[d2][u3 + c3 + t4] * g * (1 - v) + e13[d2][u3 + p3 + t4] * g * v;
            }
          }
          n2.push(f2), t.width = c2, t.height = l2;
        } else
          n2.push(null);
    }
    if (n2.length === 0)
      for (let t2 = 0; t2 < e13.length; t2++)
        n2.push(e13[t2]);
    return n2;
  }
  function u(e13) {
    return t._openGLRenderWindow ? t.resizable || t.renderable?.getResizable() ? false : t._openGLRenderWindow.getWebgl2() ? !(t._openGLRenderWindow.getGLInformations().RENDERER.value.match(/WebKit/gi) && navigator.platform.match(/Mac/gi) && r() && (e13 === VtkDataTypes$3.UNSIGNED_SHORT || e13 === VtkDataTypes$3.SHORT)) : false : false;
  }
  e12.create2DFromRaw = function() {
    let { width: n2 = requiredParam$1("width"), height: a2 = requiredParam$1("height"), numComps: o2 = requiredParam$1("numComps"), dataType: s2 = requiredParam$1("dataType"), data: c2 = requiredParam$1("data"), flip: d2 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (e12.getOpenGLDataType(s2, true), e12.getInternalFormat(s2, o2), e12.getFormat(s2, o2), !t.internalFormat || !t.format || !t.openGLDataType)
      return vtkErrorMacro$27("Failed to determine texture parameters."), false;
    t.target = t.context.TEXTURE_2D, t.components = o2, t.width = n2, t.height = a2, t.depth = 1, t.numberOfDimensions = 2, t._openGLRenderWindow.activateTexture(e12), e12.createTexture(), e12.bind();
    let f2 = [c2], p2 = l(e12.updateArrayDataTypeForGL(s2, f2));
    return t.context.pixelStorei(t.context.UNPACK_FLIP_Y_WEBGL, d2), t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), u(s2) ? (t.context.texStorage2D(t.target, 1, t.internalFormat, t.width, t.height), p2[0] != null && t.context.texSubImage2D(t.target, 0, 0, 0, t.width, t.height, t.format, t.openGLDataType, p2[0])) : t.context.texImage2D(t.target, 0, t.internalFormat, t.width, t.height, 0, t.format, t.openGLDataType, p2[0]), t.generateMipmap && t.context.generateMipmap(t.target), d2 && t.context.pixelStorei(t.context.UNPACK_FLIP_Y_WEBGL, false), t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * o2 * t._openGLRenderWindow.getDefaultTextureByteSize(s2, r(), e12.useHalfFloat()), e12.deactivate(), true;
  }, e12.createCubeFromRaw = function() {
    let { width: n2 = requiredParam$1("width"), height: a2 = requiredParam$1("height"), numComps: o2 = requiredParam$1("numComps"), dataType: s2 = requiredParam$1("dataType"), data: c2 = requiredParam$1("data") } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (e12.getOpenGLDataType(s2), e12.getInternalFormat(s2, o2), e12.getFormat(s2, o2), !t.internalFormat || !t.format || !t.openGLDataType)
      return vtkErrorMacro$27("Failed to determine texture parameters."), false;
    t.target = t.context.TEXTURE_CUBE_MAP, t.components = o2, t.width = n2, t.height = a2, t.depth = 1, t.numberOfDimensions = 2, t._openGLRenderWindow.activateTexture(e12), t.maxLevel = c2.length / 6 - 1, e12.createTexture(), e12.bind();
    let d2 = l(e12.updateArrayDataTypeForGL(s2, c2)), f2 = [], p2 = t.width, m2 = t.height;
    for (let e13 = 0; e13 < d2.length; e13++) {
      e13 % 6 == 0 && e13 !== 0 && (p2 /= 2, m2 /= 2), f2[e13] = newTypedArray(s2, m2 * p2 * t.components);
      for (let n3 = 0; n3 < m2; ++n3) {
        let r2 = n3 * p2 * t.components, a3 = (m2 - n3 - 1) * p2 * t.components;
        f2[e13].set(d2[e13].slice(a3, a3 + p2 * t.components), r2);
      }
    }
    t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), u(s2) && t.context.texStorage2D(t.target, 6, t.internalFormat, t.width, t.height);
    for (let e13 = 0; e13 < 6; e13++) {
      let n3 = 0, r2 = t.width, a3 = t.height;
      for (; r2 >= 1 && a3 >= 1; ) {
        let o3 = null;
        n3 <= t.maxLevel && (o3 = f2[6 * n3 + e13]), u(s2) ? o3 != null && t.context.texSubImage2D(t.context.TEXTURE_CUBE_MAP_POSITIVE_X + e13, n3, 0, 0, r2, a3, t.format, t.openGLDataType, o3) : t.context.texImage2D(t.context.TEXTURE_CUBE_MAP_POSITIVE_X + e13, n3, t.internalFormat, r2, a3, 0, t.format, t.openGLDataType, o3), n3++, r2 /= 2, a3 /= 2;
      }
    }
    return t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * o2 * t._openGLRenderWindow.getDefaultTextureByteSize(s2, r(), e12.useHalfFloat()), e12.deactivate(), true;
  }, e12.createDepthFromRaw = function() {
    let { width: n2 = requiredParam$1("width"), height: a2 = requiredParam$1("height"), dataType: o2 = requiredParam$1("dataType"), data: s2 = requiredParam$1("data") } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e12.getOpenGLDataType(o2), t.format = t.context.DEPTH_COMPONENT, t._openGLRenderWindow.getWebgl2() ? o2 === VtkDataTypes$3.FLOAT ? t.internalFormat = t.context.DEPTH_COMPONENT32F : t.internalFormat = t.context.DEPTH_COMPONENT16 : t.internalFormat = t.context.DEPTH_COMPONENT, !t.internalFormat || !t.format || !t.openGLDataType ? (vtkErrorMacro$27("Failed to determine texture parameters."), false) : (t.target = t.context.TEXTURE_2D, t.components = 1, t.width = n2, t.height = a2, t.depth = 1, t.numberOfDimensions = 2, t._openGLRenderWindow.activateTexture(e12), e12.createTexture(), e12.bind(), t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), u(o2) ? (t.context.texStorage2D(t.target, 1, t.internalFormat, t.width, t.height), s2 != null && t.context.texSubImage2D(t.target, 0, 0, 0, t.width, t.height, t.format, t.openGLDataType, s2)) : t.context.texImage2D(t.target, 0, t.internalFormat, t.width, t.height, 0, t.format, t.openGLDataType, s2), t.generateMipmap && t.context.generateMipmap(t.target), t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * t.components * t._openGLRenderWindow.getDefaultTextureByteSize(o2, r(), e12.useHalfFloat()), e12.deactivate(), true);
  }, e12.create2DFromImage = (n2) => {
    if (e12.getOpenGLDataType(VtkDataTypes$3.UNSIGNED_CHAR), e12.getInternalFormat(VtkDataTypes$3.UNSIGNED_CHAR, 4), e12.getFormat(VtkDataTypes$3.UNSIGNED_CHAR, 4), !t.internalFormat || !t.format || !t.openGLDataType)
      return vtkErrorMacro$27("Failed to determine texture parameters."), false;
    t.target = t.context.TEXTURE_2D, t.components = 4, t.depth = 1, t.numberOfDimensions = 2, t._openGLRenderWindow.activateTexture(e12), e12.createTexture(), e12.bind();
    let a2 = !t._openGLRenderWindow.getWebgl2() && (!isPowerOfTwo(n2.width) || !isPowerOfTwo(n2.height)), o2 = n2, s2 = n2.width, c2 = n2.height, l2 = true, d2 = window.chrome;
    if (a2 || d2) {
      let e13 = new OffscreenCanvas(nearestPowerOfTwo(n2.width), nearestPowerOfTwo(n2.height));
      s2 = e13.width, c2 = e13.height;
      let t2 = e13.getContext("2d");
      t2.translate(0, e13.height), t2.scale(1, -1), t2.drawImage(n2, 0, 0, n2.width, n2.height, 0, 0, e13.width, e13.height), o2 = e13, l2 = false;
    }
    return t.width = s2, t.height = c2, t.context.pixelStorei(t.context.UNPACK_FLIP_Y_WEBGL, l2), t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), u(VtkDataTypes$3.UNSIGNED_CHAR) ? (t.context.texStorage2D(t.target, 1, t.internalFormat, t.width, t.height), t.context.texSubImage2D(t.target, 0, 0, 0, t.width, t.height, t.format, t.openGLDataType, o2)) : t.context.texImage2D(t.target, 0, t.internalFormat, t.width, t.height, 0, t.format, t.openGLDataType, o2), t.generateMipmap && t.context.generateMipmap(t.target), t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * t.components * t._openGLRenderWindow.getDefaultTextureByteSize(VtkDataTypes$3.UNSIGNED_CHAR, r(), e12.useHalfFloat()), e12.deactivate(), true;
  }, e12.create2DFromImageBitmap = (n2) => (e12.getOpenGLDataType(VtkDataTypes$3.UNSIGNED_CHAR), e12.getInternalFormat(VtkDataTypes$3.UNSIGNED_CHAR, 4), e12.getFormat(VtkDataTypes$3.UNSIGNED_CHAR, 4), !t.internalFormat || !t.format || !t.openGLDataType ? (vtkErrorMacro$27("Failed to determine texture parameters."), false) : (t.target = t.context.TEXTURE_2D, t.components = 4, t.depth = 1, t.numberOfDimensions = 2, t._openGLRenderWindow.activateTexture(e12), e12.createTexture(), e12.bind(), t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), t.width = n2.width, t.height = n2.height, u(VtkDataTypes$3.UNSIGNED_CHAR) ? (t.context.texStorage2D(t.target, 1, t.internalFormat, t.width, t.height), t.context.texSubImage2D(t.target, 0, 0, 0, t.width, t.height, t.format, t.openGLDataType, n2)) : t.context.texImage2D(t.target, 0, t.internalFormat, t.width, t.height, 0, t.format, t.openGLDataType, n2), t.generateMipmap && t.context.generateMipmap(t.target), t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * t.components * t._openGLRenderWindow.getDefaultTextureByteSize(VtkDataTypes$3.UNSIGNED_CHAR, r(), e12.useHalfFloat()), e12.deactivate(), true));
  function d(e13, t2, n2) {
    let r2 = Array(n2), a2 = Array(n2);
    for (let o2 = 0; o2 < n2; ++o2)
      r2[o2] = e13[o2], a2[o2] = t2[o2] - e13[o2] || 1;
    return {
      scale: a2,
      offset: r2
    };
  }
  function f(e13, t2) {
    for (let n2 = 0; n2 < e13.length; n2++) {
      let r2 = e13[n2], a2 = t2[n2] + r2;
      if (r2 < -2048 || r2 > 2048 || a2 < -2048 || a2 > 2048)
        return false;
    }
    return true;
  }
  function p(n2, r2, a2, o2) {
    e12.getOpenGLDataType(n2);
    let s2 = f(r2, a2) || o2, c2 = false;
    if (t._openGLRenderWindow.getWebgl2())
      c2 = t.openGLDataType === t.context.FLOAT && t.context.getExtension("OES_texture_float_linear") === null && s2 || t.openGLDataType === t.context.HALF_FLOAT;
    else {
      let e13 = t.context.getExtension("OES_texture_half_float");
      c2 = e13 && t.openGLDataType === e13.HALF_FLOAT_OES;
    }
    t.canUseHalfFloat = c2 && s2;
  }
  function m(t2, n2) {
    let r2 = t2.getNumberOfComponents(), a2 = t2.getDataType(), o2 = t2.getData(), s2 = Array(r2), c2 = Array(r2);
    for (let e13 = 0; e13 < r2; ++e13) {
      let [n3, r3] = t2.getRange(e13);
      s2[e13] = n3, c2[e13] = r3;
    }
    let l2 = d(s2, c2, r2);
    return p(a2, l2.offset, l2.scale, n2), e12.useHalfFloat() || e12.getOpenGLDataType(a2, true), {
      numComps: r2,
      dataType: a2,
      data: o2,
      scaleOffsets: l2
    };
  }
  e12.create2DFilterableFromRaw = function() {
    let { width: t2 = requiredParam$1("width"), height: n2 = requiredParam$1("height"), numComps: r2 = requiredParam$1("numComps"), dataType: a2 = requiredParam$1("dataType"), data: o2 = requiredParam$1("data"), preferSizeOverAccuracy: s2 = false, ranges: c2 = void 0 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e12.create2DFilterableFromDataArray({
      width: t2,
      height: n2,
      dataArray: vtkDataArray$1.newInstance({
        numberOfComponents: r2,
        dataType: a2,
        values: o2,
        ranges: c2
      }),
      preferSizeOverAccuracy: s2
    });
  }, e12.create2DFilterableFromDataArray = function() {
    let { width: t2 = requiredParam$1("width"), height: n2 = requiredParam$1("height"), dataArray: r2 = requiredParam$1("dataArray"), preferSizeOverAccuracy: a2 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { numComps: o2, dataType: s2, data: c2 } = m(r2, a2);
    e12.create2DFromRaw({
      width: t2,
      height: n2,
      numComps: o2,
      dataType: s2,
      data: c2
    });
  }, e12.updateVolumeInfoForGL = (n2, a2) => {
    let o2 = false, s2 = e12.useHalfFloat();
    (!t.volumeInfo?.scale || !t.volumeInfo?.offset) && (t.volumeInfo = {
      scale: Array(a2),
      offset: Array(a2)
    });
    for (let e13 = 0; e13 < a2; ++e13)
      t.volumeInfo.scale[e13] = 1, t.volumeInfo.offset[e13] = 0;
    if (r() && !s2 && n2 === VtkDataTypes$3.SHORT) {
      for (let e13 = 0; e13 < a2; ++e13)
        t.volumeInfo.scale[e13] = 32767;
      o2 = true;
    }
    if (r() && !s2 && n2 === VtkDataTypes$3.UNSIGNED_SHORT) {
      for (let e13 = 0; e13 < a2; ++e13)
        t.volumeInfo.scale[e13] = 65535;
      o2 = true;
    }
    if (n2 === VtkDataTypes$3.UNSIGNED_CHAR) {
      for (let e13 = 0; e13 < a2; ++e13)
        t.volumeInfo.scale[e13] = 255;
      o2 = true;
    }
    return (n2 === VtkDataTypes$3.FLOAT || s2 && (n2 === VtkDataTypes$3.SHORT || n2 === VtkDataTypes$3.UNSIGNED_SHORT)) && (o2 = true), o2;
  }, e12.create3DFromRaw = function() {
    let { width: s2 = requiredParam$1("width"), height: c2 = requiredParam$1("height"), depth: d2 = requiredParam$1("depth"), numComps: f2 = requiredParam$1("numComps"), dataType: p2 = requiredParam$1("dataType"), data: m2 = requiredParam$1("data"), updatedExtents: h = [] } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = p2, _ = m2;
    if (!e12.updateVolumeInfoForGL(g, f2) && _) {
      let e13 = s2 * c2 * d2, n2 = structuredClone(t.volumeInfo), r2 = new Float32Array(e13 * f2);
      t.volumeInfo.offset = n2.offset, t.volumeInfo.scale = n2.scale;
      let a2 = 0, o2 = n2.scale.map((e14) => 1 / e14);
      for (let t2 = 0; t2 < e13; t2++)
        for (let e14 = 0; e14 < f2; e14++)
          r2[a2] = (_[a2] - n2.offset[e14]) * o2[e14], a2++;
      g = VtkDataTypes$3.FLOAT, _ = r2;
    }
    if (e12.getOpenGLDataType(g), e12.getInternalFormat(g, f2), e12.getFormat(g, f2), !t.internalFormat || !t.format || !t.openGLDataType)
      return vtkErrorMacro$27("Failed to determine texture parameters."), false;
    t.target = t.context.TEXTURE_3D, t.components = f2, t.width = s2, t.height = c2, t.depth = d2, t.numberOfDimensions = 3, t._openGLRenderWindow.activateTexture(e12), e12.createTexture(), e12.bind();
    let v = h.length > 0, y = !v || !(0, import_fast_deep_equal$2.default)(t._prevTexParams, n()), b = [_], S = l(e12.updateArrayDataTypeForGL(g, b, true, y ? [] : h));
    if (t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), y)
      u(g) ? (t.context.texStorage3D(t.target, 1, t.internalFormat, t.width, t.height, t.depth), S[0] != null && t.context.texSubImage3D(t.target, 0, 0, 0, 0, t.width, t.height, t.depth, t.format, t.openGLDataType, S[0])) : t.context.texImage3D(t.target, 0, t.internalFormat, t.width, t.height, t.depth, 0, t.format, t.openGLDataType, S[0]), t._prevTexParams = n();
    else if (v) {
      let e13 = S[0], n2 = 0;
      for (let r2 = 0; r2 < h.length; r2++) {
        let s3 = h[r2], c3 = a(s3), l2 = o(s3), u2 = new e13.constructor(e13.buffer, n2, l2);
        n2 += u2.byteLength, t.context.texSubImage3D(t.target, 0, s3[0], s3[2], s3[4], c3[0], c3[1], c3[2], t.format, t.openGLDataType, u2);
      }
    }
    return t.generateMipmap && t.context.generateMipmap(t.target), t.allocatedGPUMemoryInBytes = t.width * t.height * t.depth * t.components * t._openGLRenderWindow.getDefaultTextureByteSize(g, r(), e12.useHalfFloat()), e12.deactivate(), true;
  }, e12.create3DFilterableFromRaw = function() {
    let { width: t2 = requiredParam$1("width"), height: n2 = requiredParam$1("height"), depth: r2 = requiredParam$1("depth"), numComps: a2 = requiredParam$1("numComps"), dataType: o2 = requiredParam$1("dataType"), data: s2 = requiredParam$1("data"), preferSizeOverAccuracy: c2 = false, ranges: l2 = void 0, updatedExtents: u2 = [] } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e12.create3DFilterableFromDataArray({
      width: t2,
      height: n2,
      depth: r2,
      dataArray: vtkDataArray$1.newInstance({
        numberOfComponents: a2,
        dataType: o2,
        values: s2,
        ranges: l2
      }),
      preferSizeOverAccuracy: c2,
      updatedExtents: u2
    });
  }, e12.create3DFilterableFromDataArray = function() {
    let { width: n2 = requiredParam$1("width"), height: r2 = requiredParam$1("height"), depth: a2 = requiredParam$1("depth"), dataArray: o2 = requiredParam$1("dataArray"), preferSizeOverAccuracy: s2 = false, updatedExtents: c2 = [] } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { numComps: l2, dataType: d2, data: f2, scaleOffsets: p2 } = m(o2, s2), h = [], g = [];
    for (let e13 = 0; e13 < l2; ++e13)
      h[e13] = 0, g[e13] = 1;
    if (t.volumeInfo = {
      scale: g,
      offset: h,
      dataComputedScale: p2.scale,
      dataComputedOffset: p2.offset,
      width: n2,
      height: r2,
      depth: a2
    }, t._openGLRenderWindow.getWebgl2())
      return e12.create3DFromRaw({
        width: n2,
        height: r2,
        depth: a2,
        numComps: l2,
        dataType: d2,
        data: f2,
        updatedExtents: c2
      });
    let _ = n2 * r2 * a2, v = structuredClone(p2), y = (e13, t2, n3, r3, a3) => {
      e13[t2] = n3;
    }, b = VtkDataTypes$3.UNSIGNED_CHAR;
    if (d2 === VtkDataTypes$3.UNSIGNED_CHAR)
      for (let e13 = 0; e13 < l2; ++e13)
        v.offset[e13] = 0, v.scale[e13] = 255;
    else
      t.context.getExtension("OES_texture_float") && t.context.getExtension("OES_texture_float_linear") ? (b = VtkDataTypes$3.FLOAT, y = (e13, t2, n3, r3, a3) => {
        e13[t2] = (n3 - r3) / a3;
      }) : (b = VtkDataTypes$3.UNSIGNED_CHAR, y = (e13, t2, n3, r3, a3) => {
        e13[t2] = 255 * (n3 - r3) / a3;
      });
    if (e12.getOpenGLDataType(b), e12.getInternalFormat(b, l2), e12.getFormat(b, l2), !t.internalFormat || !t.format || !t.openGLDataType)
      return vtkErrorMacro$27("Failed to determine texture parameters."), false;
    t.target = t.context.TEXTURE_2D, t.components = l2, t.depth = 1, t.numberOfDimensions = 2;
    let S = t.context.getParameter(t.context.MAX_TEXTURE_SIZE);
    S > 4096 && (b === VtkDataTypes$3.FLOAT || l2 >= 3) && (S = 4096);
    let C = 1, w = 1;
    _ > S * S && (C = Math.ceil(Math.sqrt(_ / (S * S))), w = C);
    let T = Math.sqrt(_) / C;
    T = nearestPowerOfTwo(T);
    let E = Math.floor(T * C / n2), D = Math.ceil(a2 / E), O = nearestPowerOfTwo(r2 * D / w);
    t.width = T, t.height = O, t._openGLRenderWindow.activateTexture(e12), e12.createTexture(), e12.bind(), t.volumeInfo.xreps = E, t.volumeInfo.yreps = D, t.volumeInfo.xstride = C, t.volumeInfo.ystride = w, t.volumeInfo.offset = v.offset, t.volumeInfo.scale = v.scale;
    let k, A = T * O * l2;
    k = b === VtkDataTypes$3.FLOAT ? new Float32Array(A) : new Uint8Array(A);
    let j = 0, M = Math.floor(n2 / C), N = Math.floor(r2 / w);
    for (let e13 = 0; e13 < D; e13++) {
      let o3 = Math.min(E, a2 - e13 * E), s3 = l2 * (t.width - o3 * Math.floor(n2 / C));
      for (let t2 = 0; t2 < N; t2++) {
        for (let a3 = 0; a3 < o3; a3++) {
          let o4 = l2 * ((e13 * E + a3) * n2 * r2 + w * t2 * n2);
          for (let e14 = 0; e14 < M; e14++)
            for (let t3 = 0; t3 < l2; t3++)
              y(k, j, f2[o4 + C * e14 * l2 + t3], v.offset[t3], v.scale[t3]), j++;
        }
        j += s3;
      }
    }
    return t.context.pixelStorei(t.context.UNPACK_ALIGNMENT, 1), u(b) ? (t.context.texStorage2D(t.target, 1, t.internalFormat, t.width, t.height), k != null && t.context.texSubImage2D(t.target, 0, 0, 0, t.width, t.height, t.format, t.openGLDataType, k)) : t.context.texImage2D(t.target, 0, t.internalFormat, t.width, t.height, 0, t.format, t.openGLDataType, k), e12.deactivate(), true;
  }, e12.setOpenGLRenderWindow = (n2) => {
    t._openGLRenderWindow !== n2 && (e12.releaseGraphicsResources(), t._openGLRenderWindow = n2, t.context = null, n2 && (t.context = t._openGLRenderWindow.getContext()));
  }, e12.getMaximumTextureSize = (e13) => e13 && e13.isCurrent() ? e13.getIntegerv(e13.MAX_TEXTURE_SIZE) : -1, e12.enableUseHalfFloat = (e13) => {
    t.enableUseHalfFloat = e13;
  };
}
var DEFAULT_VALUES$90 = {
  _openGLRenderWindow: null,
  _forceInternalFormat: false,
  _prevTexParams: null,
  context: null,
  handle: 0,
  sendParametersTime: null,
  textureBuildTime: null,
  numberOfDimensions: 0,
  target: 0,
  format: 0,
  openGLDataType: 0,
  components: 0,
  width: 0,
  height: 0,
  depth: 0,
  autoParameters: true,
  wrapS: Wrap$3.CLAMP_TO_EDGE,
  wrapT: Wrap$3.CLAMP_TO_EDGE,
  wrapR: Wrap$3.CLAMP_TO_EDGE,
  minificationFilter: Filter$3.NEAREST,
  magnificationFilter: Filter$3.NEAREST,
  minLOD: -1e3,
  maxLOD: 1e3,
  baseLevel: 0,
  maxLevel: 1e3,
  generateMipmap: false,
  oglNorm16Ext: null,
  allocatedGPUMemoryInBytes: 0,
  enableUseHalfFloat: true,
  canUseHalfFloat: false
};
function extend$99(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$90, n), vtkViewNode$1.extend(e12, t, n), t.sendParametersTime = {}, obj(t.sendParametersTime, { mtime: 0 }), t.textureBuildTime = {}, obj(t.textureBuildTime, { mtime: 0 }), set$1(e12, t, ["format", "openGLDataType"]), setGet(e12, t, [
    "keyMatrixTime",
    "minificationFilter",
    "magnificationFilter",
    "wrapS",
    "wrapT",
    "wrapR",
    "generateMipmap",
    "oglNorm16Ext"
  ]), get(e12, t, [
    "width",
    "height",
    "volumeInfo",
    "components",
    "handle",
    "target",
    "allocatedGPUMemoryInBytes"
  ]), moveToProtected(e12, t, ["openGLRenderWindow"]), vtkOpenGLTexture(e12, t);
}
var newInstance$94 = newInstance(extend$99, "vtkOpenGLTexture"), vtkOpenGLTexture$1 = {
  newInstance: newInstance$94,
  extend: extend$99,
  ...Constants$11
};
registerOverride$1("vtkTexture", newInstance$94);
function implementReplaceShaderCoincidentOffset(e12, t) {
  e12.replaceShaderCoincidentOffset = (n, r, a) => {
    let o = e12.getCoincidentParameters(r, a);
    if (o && (o.factor !== 0 || o.offset !== 0)) {
      let e13 = n.Fragment;
      e13 = vtkShaderProgram$1.substitute(e13, "//VTK::Coincident::Dec", ["uniform float cfactor;", "uniform float coffset;"]).result, t.context.getExtension("EXT_frag_depth") && (o.factor === 0 ? e13 = vtkShaderProgram$1.substitute(e13, "//VTK::Depth::Impl", "gl_FragDepthEXT = gl_FragCoord.z + 0.000016*coffset;").result : (e13 = vtkShaderProgram$1.substitute(e13, "//VTK::UniformFlow::Impl", ["float cscale = length(vec2(dFdx(gl_FragCoord.z),dFdy(gl_FragCoord.z)));", "//VTK::UniformFlow::Impl"], false).result, e13 = vtkShaderProgram$1.substitute(e13, "//VTK::Depth::Impl", "gl_FragDepthEXT = gl_FragCoord.z + cfactor*cscale + 0.000016*coffset;").result)), t._openGLRenderWindow.getWebgl2() && (o.factor === 0 ? e13 = vtkShaderProgram$1.substitute(e13, "//VTK::Depth::Impl", "gl_FragDepth = gl_FragCoord.z + 0.000016*coffset;").result : (e13 = vtkShaderProgram$1.substitute(e13, "//VTK::UniformFlow::Impl", ["float cscale = length(vec2(dFdx(gl_FragCoord.z),dFdy(gl_FragCoord.z)));", "//VTK::UniformFlow::Impl"], false).result, e13 = vtkShaderProgram$1.substitute(e13, "//VTK::Depth::Impl", "gl_FragDepth = gl_FragCoord.z + cfactor*cscale + 0.000016*coffset;").result)), n.Fragment = e13;
    }
  };
}
function implementBuildShadersWithReplacements(e12, t) {
  e12.applyShaderReplacements = (e13, t2, n) => {
    let r = null;
    if (t2 && (r = t2.ShaderReplacements), r)
      for (let t3 = 0; t3 < r.length; t3++) {
        let a = r[t3];
        if (n && a.replaceFirst || !n && !a.replaceFirst) {
          let t4 = a.shaderType, n2 = e13[t4];
          e13[t4] = vtkShaderProgram$1.substitute(n2, a.originalValue, a.replacementValue, a.replaceAll).result;
        }
      }
  }, e12.buildShaders = (n, r, a) => {
    e12.getReplacedShaderTemplate(n, r, a), t.lastRenderPassShaderReplacement = t.currentRenderPass ? t.currentRenderPass.getShaderReplacement() : null, t.lastRenderPassShaderReplacement && t.lastRenderPassShaderReplacement(n);
    let o = t.renderable.getViewSpecificProperties().OpenGL;
    e12.applyShaderReplacements(n, o, true), e12.replaceShaderValues(n, r, a), e12.applyShaderReplacements(n, o);
  }, e12.getReplacedShaderTemplate = (n, r, a) => {
    let o = t.renderable.getViewSpecificProperties().OpenGL;
    e12.getShaderTemplate(n, r, a);
    let s = n.Vertex;
    if (o) {
      let e13 = o.VertexShaderCode;
      e13 !== void 0 && e13 !== "" && (s = e13);
    }
    n.Vertex = s;
    let c = n.Fragment;
    if (o) {
      let e13 = o.FragmentShaderCode;
      e13 !== void 0 && e13 !== "" && (c = e13);
    }
    n.Fragment = c;
    let l = n.Geometry;
    if (o) {
      let e13 = o.GeometryShaderCode;
      e13 !== void 0 && (l = e13);
    }
    n.Geometry = l;
  };
}
var vtkReplacementShaderMapper = {
  implementReplaceShaderCoincidentOffset,
  implementBuildShadersWithReplacements
}, { vtkWarningMacro: vtkWarningMacro$4 } = macro, newInstance$93;
function vtkTransform(e12, t) {
  t.classHierarchy.push("vtkAbstractTransform", "vtkHomogeneousTransform", "vtkTransform"), e12.transformPoint = (e13, n) => (transformMat4$1(n, e13, t.matrix), n), e12.transformPoints = (e13, n) => {
    let r = new Float64Array(3), a = new Float64Array(3);
    for (let o = 0; o < e13.length; o += 3)
      r[0] = e13[o], r[1] = e13[o + 1], r[2] = e13[o + 2], transformMat4$1(a, r, t.matrix), n[o] = a[0], n[o + 1] = a[1], n[o + 2] = a[2];
    return n;
  }, e12.preMultiply = () => {
    e12.setPreMultiplyFlag(true);
  }, e12.postMultiply = () => {
    e12.setPreMultiplyFlag(false);
  }, e12.transformMatrix = (e13, n) => (t.preMultiplyFlag ? multiply$2(n, t.matrix, e13) : multiply$2(n, e13, t.matrix), n), e12.transformMatrices = (e13, n) => {
    let r = new Float64Array(16), a = new Float64Array(16), o = t.preMultiplyFlag ? () => multiply$2(a, t.matrix, r) : () => multiply$2(a, r, t.matrix);
    for (let t2 = 0; t2 < e13.length; t2 += 16) {
      for (let n2 = 0; n2 < 16; ++n2)
        r[n2] = e13[t2 + n2];
      o();
      for (let e14 = 0; e14 < 16; ++e14)
        n[t2 + e14] = a[e14];
    }
    return n;
  }, e12.getInverse = () => newInstance$93({
    matrix: vtkMath.invertMatrix(Array.from(t.matrix), [], 4),
    preMultiplyFlag: t.preMultiplyFlag
  }), e12.translate = (n, r, a) => {
    if (n === 0 && r === 0 && a === 0)
      return;
    let o = create$5();
    fromTranslation(o, [
      n,
      r,
      a
    ]), t.preMultiplyFlag ? multiply$2(t.matrix, t.matrix, o) : multiply$2(t.matrix, o, t.matrix), e12.modified();
  }, e12.rotateWXYZ = (n, r, a, o) => {
    if (r === 0 && a === 0 && o === 0) {
      vtkWarningMacro$4("No rotation applied, axis is zero vector.");
      return;
    }
    if (n === 0)
      return;
    let s = vtkMath.radiansFromDegrees(n), c = create$2();
    setAxisAngle(c, [
      r,
      a,
      o
    ], s);
    let l = new Float64Array(16);
    fromQuat(l, c), t.preMultiplyFlag ? multiply$2(t.matrix, t.matrix, l) : multiply$2(t.matrix, l, t.matrix), e12.modified();
  }, e12.rotateX = (t2) => {
    e12.rotateWXYZ(t2, 1, 0, 0);
  }, e12.rotateY = (t2) => {
    e12.rotateWXYZ(t2, 0, 1, 0);
  }, e12.rotateZ = (t2) => {
    e12.rotateWXYZ(t2, 0, 0, 1);
  }, e12.scale = (n, r, a) => {
    if (n === 1 && r === 1 && a === 1)
      return;
    let o = create$5();
    fromScaling(o, [
      n,
      r,
      a
    ]), t.preMultiplyFlag ? multiply$2(t.matrix, t.matrix, o) : multiply$2(t.matrix, o, t.matrix), e12.modified();
  }, e12.transformNormal = function(n) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = fromMat4(create$6(), t.matrix), o = create$6();
    invert$1(o, a);
    let s = create$6();
    return transpose$1(s, o), e12.transformVector(n, r, s), vtkMath.normalize(r), r;
  }, e12.transformNormals = (n, r) => {
    let a = n.getData(), o = r.getData(), s = [
      0,
      0,
      0
    ], c = fromMat4(create$6(), t.matrix), l = create$6();
    invert$1(l, c);
    let u = create$6();
    transpose$1(u, l);
    for (let t2 = 0; t2 < a.length; t2 += 3)
      s[0] = a[t2], s[1] = a[t2 + 1], s[2] = a[t2 + 2], e12.transformVector(s, s, u), vtkMath.normalize(s), o[t2] = s[0], o[t2 + 1] = s[1], o[t2 + 2] = s[2];
  }, e12.transformVector = function(e13) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return transformMat3(n, e13, (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null) || fromMat4(create$6(), t.matrix)), n;
  }, e12.transformVectors = (t2, n) => {
    let r = t2.getData(), a = n.getData(), o = [
      0,
      0,
      0
    ];
    for (let t3 = 0; t3 < r.length; t3 += 3)
      o[0] = r[t3], o[1] = r[t3 + 1], o[2] = r[t3 + 2], e12.transformVector(o, o), vtkMath.normalize(o), a[t3] = o[0], a[t3 + 1] = o[1], a[t3 + 2] = o[2];
  }, e12.transformPointsNormalsVectors = function(t2, n, r, a, o, s) {
    let c = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, l = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, u = t2.getNumberOfPoints(), d = c?.length ?? 0, f = new Float64Array(3), p = new Float64Array(3), m = new Float64Array(3), h = new Float64Array(3), g = false, _ = false, v = false, y = [];
    for (let b = 0; b < u; b++) {
      if (t2.getPoint(b, f), p.set(f), e12.transformPoint(f, f), n.setPoint(b, ...f), vtkMath.areEquals(p, f) || (g = true), o) {
        let t3 = o.getData(), n2 = s.getData();
        f[0] = t3[b * 3], f[1] = t3[b * 3 + 1], f[2] = t3[b * 3 + 2], m.set(f), e12.transformVector(f, f), n2[b * 3] = f[0], n2[b * 3 + 1] = f[1], n2[b * 3 + 2] = f[2], vtkMath.areEquals(m, f) || (_ = true);
      }
      if (r) {
        let t3 = r.getData(), n2 = a.getData();
        f[0] = t3[b * 3], f[1] = t3[b * 3 + 1], f[2] = t3[b * 3 + 2], h.set(f), e12.transformNormal(f, f), n2[b * 3] = f[0], n2[b * 3 + 1] = f[1], n2[b * 3 + 2] = f[2], vtkMath.areEquals(h, f) || (v = true);
      }
      if (c)
        for (let t3 = 0; t3 < d; t3++) {
          let n2 = c[t3].getData(), r2 = l[t3].getData();
          f[0] = n2[b * 3], f[1] = n2[b * 3 + 1], f[2] = n2[b * 3 + 2], m.set(f), e12.transformVector(f, f), r2[b * 3] = f[0], r2[b * 3 + 1] = f[1], r2[b * 3 + 2] = f[2], !vtkMath.arrayEqual(m, f) && !y.includes(t3) && y.push(t3);
        }
    }
    g && n.modified(), _ && s.modified(), v && a.modified(), y.forEach((e13) => l[e13].modified());
  };
}
var DEFAULT_VALUES$89 = {
  preMultiplyFlag: false,
  matrix: [...IDENTITY]
};
function extend$98(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$89, n), macro.obj(e12, t), macro.setGet(e12, t, ["preMultiplyFlag"]), macro.setGetArray(e12, t, ["matrix"], 16), vtkTransform(e12, t);
}
newInstance$93 = macro.newInstance(extend$98, "vtkTransform");
var vtkTransform$1 = {
  newInstance: newInstance$93,
  extend: extend$98
};
function getTransferFunctionsHash(e12, t, n) {
  return e12.length > 0 ? `${e12.map((e13) => e13?.getMTime() ?? "x").join("/")}-${t}-${n}` : "0";
}
function getImageDataHash(e12, t) {
  return `${t.getMTime()}`;
}
var vtkImageResliceMapperVS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkImageResliceMapperVS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n\n// all variables that represent positions or directions have a suffix\n// indicating the coordinate system they are in. The possible values are\n// MC - Model coordinates\n// WC - World coordinates\n// VC - View coordinates\n// DC - Display coordinates\n// TC - Texture coordinates\n\n// frag position in VC\n//VTK::PositionVC::Dec\n\n// Texture coordinates\n//VTK::TCoord::Dec\n\n// picking support\n//VTK::Picking::Dec\n\n// camera and actor matrix values\n//VTK::Camera::Dec\n\nvoid main()\n{\n  //VTK::PositionVC::Impl\n\n  //VTK::TCoord::Impl\n\n  //VTK::Picking::Impl\n}\n", vtkImageResliceMapperFS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkImageResliceMapperFS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n// Template for the gpu image mapper fragment shader\n\n// VC position of this fragment\n//VTK::PositionVC::Dec\n\n// Texture coordinates\n//VTK::TCoord::Dec\n\n// picking support\n//VTK::Picking::Dec\n\n// handle coincident offsets\n//VTK::Coincident::Dec\n\n//VTK::ZBuffer::Dec\n\n// the output of this shader\n//VTK::Output::Dec\n\nvoid main()\n{\n  // VC position of this fragment. This should not branch/return/discard.\n  //VTK::PositionVC::Impl\n\n  // Place any calls that require uniform flow (e.g. dFdx) here.\n  //VTK::UniformFlow::Impl\n\n  // Set gl_FragDepth here (gl_FragCoord.z by default)\n  //VTK::Depth::Impl\n\n  // Early depth peeling abort:\n  //VTK::DepthPeeling::PreColor\n\n  //VTK::TCoord::Impl\n\n  if (gl_FragData[0].a <= 0.0)\n    {\n    discard;\n    }\n\n  //VTK::DepthPeeling::Impl\n\n  //VTK::Picking::Impl\n\n  // handle coincident offsets\n  //VTK::Coincident::Impl\n\n  //VTK::ZBuffer::Impl\n\n  //VTK::RenderPassFragmentShader::Impl\n}\n", InterpolationType$1 = {
  NEAREST: 0,
  LINEAR: 1
}, Constants$2 = { InterpolationType: InterpolationType$1 }, Resolve = {
  Off: 0,
  PolygonOffset: 1
}, resolveCoincidentTopologyPolygonOffsetFaces = Resolve.PolygonOffset, resolveCoincidentTopology = Resolve.Off, RESOLVE_COINCIDENT_TOPOLOGY_MODE = ["VTK_RESOLVE_OFF", "VTK_RESOLVE_POLYGON_OFFSET"];
function getResolveCoincidentTopologyPolygonOffsetFaces() {
  return resolveCoincidentTopologyPolygonOffsetFaces;
}
function setResolveCoincidentTopologyPolygonOffsetFaces(e12) {
  let t = resolveCoincidentTopologyPolygonOffsetFaces === e12;
  return resolveCoincidentTopologyPolygonOffsetFaces = e12, t;
}
function getResolveCoincidentTopology() {
  return resolveCoincidentTopology;
}
function setResolveCoincidentTopology() {
  let e12 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = resolveCoincidentTopology === e12;
  return resolveCoincidentTopology = e12, t;
}
function setResolveCoincidentTopologyToDefault() {
  return setResolveCoincidentTopology(Resolve.Off);
}
function setResolveCoincidentTopologyToOff() {
  return setResolveCoincidentTopology(Resolve.Off);
}
function setResolveCoincidentTopologyToPolygonOffset() {
  return setResolveCoincidentTopology(Resolve.PolygonOffset);
}
function getResolveCoincidentTopologyAsString() {
  return RESOLVE_COINCIDENT_TOPOLOGY_MODE[resolveCoincidentTopology];
}
var otherStaticMethods$2 = {
  Resolve,
  getResolveCoincidentTopologyAsString,
  getResolveCoincidentTopologyPolygonOffsetFaces,
  getResolveCoincidentTopology,
  setResolveCoincidentTopology,
  setResolveCoincidentTopologyPolygonOffsetFaces,
  setResolveCoincidentTopologyToDefault,
  setResolveCoincidentTopologyToOff,
  setResolveCoincidentTopologyToPolygonOffset
};
function addCoincidentTopologyMethods(e12, t, n) {
  n.forEach((n2) => {
    e12[`get${n2.method}`] = () => t[n2.key], e12[`set${n2.method}`] = macro.objectSetterMap.object(e12, t, {
      name: n2.key,
      params: ["factor", "offset"]
    });
  });
}
var CATEGORIES = [
  "Polygon",
  "Line",
  "Point"
], staticOffsetModel = {
  Polygon: {
    factor: 2,
    offset: 0
  },
  Line: {
    factor: 1,
    offset: -1
  },
  Point: {
    factor: 0,
    offset: -2
  }
}, staticOffsetAPI$2 = { modified: () => void 0 };
addCoincidentTopologyMethods(staticOffsetAPI$2, staticOffsetModel, CATEGORIES.map((e12) => ({
  key: e12,
  method: `ResolveCoincidentTopology${e12}OffsetParameters`
})));
function implementCoincidentTopologyMethods(e12, t) {
  t.resolveCoincidentTopology === void 0 && (t.resolveCoincidentTopology = false), macro.setGet(e12, t, ["resolveCoincidentTopology"]), t.topologyOffset = {
    Polygon: {
      factor: 0,
      offset: 0
    },
    Line: {
      factor: 0,
      offset: 0
    },
    Point: {
      factor: 0,
      offset: 0
    }
  }, Object.keys(otherStaticMethods$2).forEach((t2) => {
    e12[t2] = otherStaticMethods$2[t2];
  }), Object.keys(staticOffsetAPI$2).filter((e13) => e13 !== "modified").forEach((t2) => {
    e12[t2] = staticOffsetAPI$2[t2];
  }), addCoincidentTopologyMethods(e12, t.topologyOffset, CATEGORIES.map((e13) => ({
    key: e13,
    method: `RelativeCoincidentTopology${e13}OffsetParameters`
  }))), e12.getCoincidentTopologyPolygonOffsetParameters = () => {
    let t2 = staticOffsetAPI$2.getResolveCoincidentTopologyPolygonOffsetParameters(), n = e12.getRelativeCoincidentTopologyPolygonOffsetParameters();
    return {
      factor: t2.factor + n.factor,
      offset: t2.offset + n.offset
    };
  }, e12.getCoincidentTopologyLineOffsetParameters = () => {
    let t2 = staticOffsetAPI$2.getResolveCoincidentTopologyLineOffsetParameters(), n = e12.getRelativeCoincidentTopologyLineOffsetParameters();
    return {
      factor: t2.factor + n.factor,
      offset: t2.offset + n.offset
    };
  }, e12.getCoincidentTopologyPointOffsetParameter = () => {
    let t2 = staticOffsetAPI$2.getResolveCoincidentTopologyPointOffsetParameters(), n = e12.getRelativeCoincidentTopologyPointOffsetParameters();
    return {
      factor: t2.factor + n.factor,
      offset: t2.offset + n.offset
    };
  };
}
var CoincidentTopologyHelper = {
  implementCoincidentTopologyMethods,
  staticOffsetAPI: staticOffsetAPI$2,
  otherStaticMethods: otherStaticMethods$2,
  CATEGORIES,
  Resolve
}, { vtkErrorMacro: vtkErrorMacro$26 } = macro$1;
function safeMatrixMultiply(e12, t, n) {
  return t.identity(n), e12.reduce((e13, n2, r) => r === 0 ? n2 ? t.copy(e13, n2) : t.identity(e13) : n2 ? t.multiply(e13, e13, n2) : e13, n);
}
function vtkOpenGLImageResliceMapper(e12, t) {
  t.classHierarchy.push("vtkOpenGLImageResliceMapper");
  let n = /* @__PURE__ */ new Map();
  function r(t2, r2) {
    if (!r2)
      return;
    let a2 = (n.get(r2) ?? 0) - 1;
    a2 <= 0 ? (t2.unregisterGraphicsResourceUser(r2, e12), n.delete(r2)) : n.set(r2, a2);
  }
  function a(t2, r2) {
    if (!r2)
      return;
    let a2 = n.get(r2) ?? 0, o2 = a2 + 1;
    n.set(r2, o2), a2 <= 0 && t2.registerGraphicsResourceUser(r2, e12);
  }
  function o(e13, t2, n2) {
    t2 !== n2 && (r(e13, t2), a(e13, n2));
  }
  function s(t2) {
    [...n.keys()].forEach((n2) => t2.unregisterGraphicsResourceUser(n2, e12));
  }
  e12.buildPass = (n2) => {
    if (n2) {
      t.currentRenderPass = null, t._openGLImageSlice = e12.getFirstAncestorOfType("vtkOpenGLImageSlice"), t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer");
      let n3 = t._openGLRenderer.getRenderable();
      t._openGLCamera = t._openGLRenderer.getViewNodeFor(n3.getActiveCamera());
      let r2 = t._openGLRenderWindow;
      t._openGLRenderWindow = t._openGLRenderer.getLastAncestorOfType("vtkOpenGLRenderWindow"), r2 && !r2.isDeleted() && r2 !== t._openGLRenderWindow && s(r2), t.context = t._openGLRenderWindow.getContext(), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow);
    }
  }, e12.translucentPass = (n2, r2) => {
    n2 && (t.currentRenderPass = r2, e12.render());
  }, e12.zBufferPass = (n2) => {
    n2 && (t.haveSeenDepthRequest = true, t.renderDepth = true, e12.render(), t.renderDepth = false);
  }, e12.opaqueZBufferPass = (t2) => e12.zBufferPass(t2), e12.opaquePass = (t2) => {
    t2 && e12.render();
  }, e12.getCoincidentParameters = (e13, n2) => t.renderable.getResolveCoincidentTopology() == Resolve.PolygonOffset ? t.renderable.getCoincidentTopologyPolygonOffsetParameters() : null, e12.render = () => {
    let n2 = t._openGLImageSlice.getRenderable(), r2 = t._openGLRenderer.getRenderable();
    e12.renderPiece(r2, n2);
  }, e12.renderPiece = (n2, r2) => {
    e12.invokeEvent({ type: "StartEvent" }), t.renderable.update();
    let a2 = t.renderable.getNumberOfInputPorts();
    t.currentValidInputs = [];
    for (let e13 = 0; e13 < a2; ++e13) {
      let n3 = t.renderable.getInputData(e13);
      n3 && !n3.isDeleted() && t.currentValidInputs.push({
        imageData: n3,
        inputIndex: e13
      });
    }
    let o2 = t.currentValidInputs.length;
    if (o2 <= 0) {
      vtkErrorMacro$26("No input!");
      return;
    }
    let s2 = t.currentValidInputs[0].imageData.getPointData().getScalars();
    t.multiTexturePerVolumeEnabled = o2 > 1, t.numberOfComponents = t.multiTexturePerVolumeEnabled ? o2 : s2.getNumberOfComponents(), e12.updateResliceGeometry(), e12.renderPieceStart(n2, r2), e12.renderPieceDraw(n2, r2), e12.renderPieceFinish(n2, r2), e12.invokeEvent({ type: "EndEvent" });
  }, e12.renderPieceStart = (n2, r2) => {
    e12.updateBufferObjects(n2, r2);
    let a2 = r2.getProperties();
    t.currentValidInputs.forEach((e13) => {
      let { inputIndex: n3 } = e13, r3 = a2[n3].getInterpolationType(), o2 = t.scalarTextures[n3];
      r3 === InterpolationType$1.NEAREST ? (o2.setMinificationFilter(Filter$1.NEAREST), o2.setMagnificationFilter(Filter$1.NEAREST)) : (o2.setMinificationFilter(Filter$1.LINEAR), o2.setMagnificationFilter(Filter$1.LINEAR));
    }), a2[t.currentValidInputs[0].inputIndex].getInterpolationType() === InterpolationType$1.NEAREST ? (t.colorTexture.setMinificationFilter(Filter$1.NEAREST), t.colorTexture.setMagnificationFilter(Filter$1.NEAREST), t.pwfTexture.setMinificationFilter(Filter$1.NEAREST), t.pwfTexture.setMagnificationFilter(Filter$1.NEAREST)) : (t.colorTexture.setMinificationFilter(Filter$1.LINEAR), t.colorTexture.setMagnificationFilter(Filter$1.LINEAR), t.pwfTexture.setMinificationFilter(Filter$1.LINEAR), t.pwfTexture.setMagnificationFilter(Filter$1.LINEAR)), t.lastBoundBO = null;
  }, e12.renderPieceDraw = (n2, r2) => {
    let a2 = t.context, o2 = [
      ...t.scalarTextures,
      t.colorTexture,
      t.pwfTexture
    ];
    o2.forEach((e13) => e13.activate()), e12.updateShaders(t.tris, n2, r2), a2.drawArrays(a2.TRIANGLES, 0, t.tris.getCABO().getElementCount()), t.tris.getVAO().release(), o2.forEach((e13) => e13.deactivate());
  }, e12.renderPieceFinish = (e13, t2) => {
  }, e12.updateBufferObjects = (t2, n2) => {
    e12.getNeedToRebuildBufferObjects(t2, n2) && e12.buildBufferObjects(t2, n2);
  }, e12.getNeedToRebuildBufferObjects = (n2, r2) => t.VBOBuildTime.getMTime() < e12.getMTime() || t.VBOBuildTime.getMTime() < r2.getMTime() || t.VBOBuildTime.getMTime() < t.renderable.getMTime() || t.VBOBuildTime.getMTime() < r2.getProperty(t.currentValidInputs[0].inputIndex)?.getMTime() || t.currentValidInputs.some((e13) => {
    let { imageData: n3 } = e13;
    return t.VBOBuildTime.getMTime() < n3.getMTime();
  }) || t.VBOBuildTime.getMTime() < t.resliceGeom.getMTime() || t.scalarTextures.length !== t.currentValidInputs.length || !t.scalarTextures.every((e13) => !!e13?.getHandle()) || !t.colorTexture?.getHandle() || !t.pwfTexture?.getHandle(), e12.buildBufferObjects = (e13, n2) => {
    let r2 = n2.getProperties();
    t.currentValidInputs.forEach((e14, n3) => {
      let { imageData: a3 } = e14, s3 = a3.getPointData().getScalars(), c3 = t._openGLRenderWindow.getGraphicsResourceForObject(s3), l2 = getImageDataHash(a3, s3), u2 = !c3?.oglObject?.getHandle() || c3?.hash !== l2, d2 = r2[n3], f2 = d2.getUpdatedExtents(), p2 = !!f2.length;
      if (u2 && !p2) {
        let e15 = vtkOpenGLTexture$1.newInstance();
        e15.setOpenGLRenderWindow(t._openGLRenderWindow);
        let r3 = a3.getDimensions();
        e15.setOglNorm16Ext(t.context.getExtension("EXT_texture_norm16")), e15.resetFormatAndType(), e15.create3DFilterableFromDataArray({
          width: r3[0],
          height: r3[1],
          depth: r3[2],
          dataArray: s3
        }), t._openGLRenderWindow.setGraphicsResourceForObject(s3, e15, l2), t.scalarTextures[n3] = e15;
      } else
        t.scalarTextures[n3] = c3.oglObject;
      if (p2) {
        d2.setUpdatedExtents([]);
        let e15 = a3.getDimensions();
        t.scalarTextures[n3].create3DFilterableFromDataArray({
          width: e15[0],
          height: e15[1],
          depth: e15[2],
          dataArray: s3,
          updatedExtents: f2
        });
      }
      o(t._openGLRenderWindow, t._scalarTexturesCore[n3], s3), t._scalarTexturesCore[n3] = s3;
    });
    let a2 = r2[t.currentValidInputs[0].inputIndex], s2 = a2.getIndependentComponents(), c2 = s2 ? t.numberOfComponents : 1, l = s2 ? 2 * c2 : 1, u = [];
    for (let e14 = 0; e14 < c2; ++e14)
      u.push(a2.getRGBTransferFunction(e14));
    let d = getTransferFunctionsHash(u, s2, c2), f = a2.getRGBTransferFunction(), p = t._openGLRenderWindow.getGraphicsResourceForObject(f);
    if (!p?.oglObject?.getHandle() || p?.hash !== d) {
      let e14 = t.renderable.getColorTextureWidth();
      e14 <= 0 && (e14 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let n3 = e14 * l * 3, r3 = new Uint8ClampedArray(n3), o2 = vtkOpenGLTexture$1.newInstance();
      if (o2.setOpenGLRenderWindow(t._openGLRenderWindow), f) {
        let t2 = new Float32Array(e14 * 3);
        for (let n4 = 0; n4 < c2; n4++) {
          let o3 = a2.getRGBTransferFunction(n4), c3 = o3.getRange();
          if (o3.getTable(c3[0], c3[1], e14, t2, 1), s2)
            for (let a3 = 0; a3 < e14 * 3; a3++)
              r3[n4 * e14 * 6 + a3] = 255 * t2[a3], r3[n4 * e14 * 6 + a3 + e14 * 3] = 255 * t2[a3];
          else
            for (let a3 = 0; a3 < e14 * 3; a3++)
              r3[n4 * e14 * 3 + a3] = 255 * t2[a3];
        }
        o2.resetFormatAndType(), o2.create2DFromRaw({
          width: e14,
          height: l,
          numComps: 3,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: r3
        });
      } else {
        for (let t2 = 0; t2 < e14 * 3; ++t2) {
          let n4 = 255 * t2 / ((e14 - 1) * 3);
          for (let a3 = 0; a3 < l; ++a3)
            r3[a3 * e14 * 3 + t2 + 0] = n4, r3[a3 * e14 * 3 + t2 + 1] = n4, r3[a3 * e14 * 3 + t2 + 2] = n4;
        }
        o2.resetFormatAndType(), o2.create2DFromRaw({
          width: e14,
          height: 1,
          numComps: 3,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: r3
        });
      }
      f && t._openGLRenderWindow.setGraphicsResourceForObject(f, o2, d), t.colorTexture = o2;
    } else
      t.colorTexture = p.oglObject;
    o(t._openGLRenderWindow, t._colorTextureCore, f), t._colorTextureCore = f;
    let m = [];
    for (let e14 = 0; e14 < c2; ++e14)
      m.push(a2.getPiecewiseFunction(e14));
    let h = getTransferFunctionsHash(m, s2, c2), g = a2.getPiecewiseFunction(), _ = t._openGLRenderWindow.getGraphicsResourceForObject(g);
    if (!_?.oglObject?.getHandle() || _?.hash !== h) {
      let e14 = t.renderable.getOpacityTextureWidth();
      e14 <= 0 && (e14 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let n3 = e14 * l, r3 = new Uint8ClampedArray(n3), o2 = vtkOpenGLTexture$1.newInstance();
      if (o2.setOpenGLRenderWindow(t._openGLRenderWindow), g) {
        let t2 = new Float32Array(n3), r4 = new Float32Array(e14);
        for (let n4 = 0; n4 < c2; ++n4) {
          let o3 = a2.getPiecewiseFunction(n4);
          if (o3 === null)
            t2.fill(1);
          else {
            let a3 = o3.getRange();
            if (o3.getTable(a3[0], a3[1], e14, r4, 1), s2)
              for (let a4 = 0; a4 < e14; a4++)
                t2[n4 * e14 * 2 + a4] = r4[a4], t2[n4 * e14 * 2 + a4 + e14] = r4[a4];
            else
              for (let n5 = 0; n5 < e14; n5++)
                t2[n5] = r4[n5];
          }
        }
        o2.resetFormatAndType(), o2.create2DFromRaw({
          width: e14,
          height: l,
          numComps: 1,
          dataType: VtkDataTypes.FLOAT,
          data: t2
        });
      } else
        r3.fill(255), o2.resetFormatAndType(), o2.create2DFromRaw({
          width: e14,
          height: l,
          numComps: 1,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: r3
        });
      g && t._openGLRenderWindow.setGraphicsResourceForObject(g, o2, h), t.pwfTexture = o2;
    } else
      t.pwfTexture = _.oglObject;
    o(t._openGLRenderWindow, t._pwfTextureCore, g), t._pwfTextureCore = g;
    let v = `${t.resliceGeom.getMTime()}A${t.renderable.getSlabThickness()}`;
    if (!t.tris.getCABO().getElementCount() || t.VBOBuildString !== v) {
      let e14 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        values: t.resliceGeom.getPoints().getData()
      });
      e14.setName("points");
      let n3 = vtkDataArray$1.newInstance({
        numberOfComponents: 1,
        values: t.resliceGeom.getPolys().getData()
      }), r3 = {
        points: e14,
        cellOffset: 0
      };
      if (t.renderable.getSlabThickness() > 0) {
        let e15 = t.resliceGeom.getPointData().getNormals();
        e15 ? r3.normals = e15 : vtkErrorMacro$26("Slab mode requested without normals");
      }
      t.tris.getCABO().createVBO(n3, "polys", Representation$1.SURFACE, r3);
    }
    t.VBOBuildString = v, t.VBOBuildTime.modified();
  }, e12.updateShaders = (n2, r2, a2) => {
    if (t.lastBoundBO = n2, e12.getNeedToRebuildShaders(n2, r2, a2)) {
      let o2 = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      e12.buildShaders(o2, r2, a2);
      let s2 = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(o2.Vertex, o2.Fragment, o2.Geometry);
      s2 !== n2.getProgram() && (n2.setProgram(s2), n2.getVAO().releaseGraphicsResources()), n2.getShaderSourceTime().modified();
    } else
      t._openGLRenderWindow.getShaderCache().readyShaderProgram(n2.getProgram());
    n2.getVAO().bind(), e12.setMapperShaderParameters(n2, r2, a2), e12.setCameraShaderParameters(n2, r2, a2), e12.setPropertyShaderParameters(n2, r2, a2);
  }, e12.setMapperShaderParameters = (n2, r2, a2) => {
    let o2 = n2.getProgram(), s2 = t.currentValidInputs[0].imageData;
    if (n2.getCABO().getElementCount() && (t.VBOBuildTime.getMTime() > n2.getAttributeUpdateTime().getMTime() || n2.getShaderSourceTime().getMTime() > n2.getAttributeUpdateTime().getMTime())) {
      t.scalarTextures.forEach((e14, t2) => {
        o2.setUniformi(`volumeTexture[${t2}]`, e14.getTextureUnit());
      }), o2.isAttributeUsed("vertexWC") && (n2.getVAO().addAttributeArray(o2, n2.getCABO(), "vertexWC", n2.getCABO().getVertexOffset(), n2.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || vtkErrorMacro$26("Error setting vertexWC in shader VAO.")), o2.isAttributeUsed("normalWC") && (n2.getVAO().addAttributeArray(o2, n2.getCABO(), "normalWC", n2.getCABO().getNormalOffset(), n2.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || vtkErrorMacro$26("Error setting normalWC in shader VAO.")), o2.isUniformUsed("slabThickness") && o2.setUniformf("slabThickness", t.renderable.getSlabThickness()), o2.isUniformUsed("spacing") && o2.setUniform3fv("spacing", s2.getSpacing()), o2.isUniformUsed("slabType") && o2.setUniformi("slabType", t.renderable.getSlabType()), o2.isUniformUsed("slabType") && o2.setUniformi("slabType", t.renderable.getSlabType()), o2.isUniformUsed("slabTrapezoid") && o2.setUniformi("slabTrapezoid", t.renderable.getSlabTrapezoidIntegration());
      let e13 = n2.getCABO().getCoordShiftAndScaleEnabled() ? n2.getCABO().getInverseShiftAndScaleMatrix() : null;
      if (o2.isUniformUsed("WCTCMatrix")) {
        let n3 = s2.getDimensions();
        copy$4(t.tmpMat4, s2.getIndexToWorld()), translate(t.tmpMat4, t.tmpMat4, [
          -0.5,
          -0.5,
          -0.5
        ]), scale$4(t.tmpMat4, t.tmpMat4, n3), invert(t.tmpMat4, t.tmpMat4), e13 && multiply$2(t.tmpMat4, t.tmpMat4, e13), o2.setUniformMatrix("WCTCMatrix", t.tmpMat4);
      }
      o2.isUniformUsed("vboScaling") && o2.setUniform3fv("vboScaling", n2.getCABO().getCoordScale() ?? [
        1,
        1,
        1
      ]), n2.getAttributeUpdateTime().modified();
    }
    if (t.haveSeenDepthRequest && n2.getProgram().setUniformi("depthRequest", t.renderDepth ? 1 : 0), n2.getProgram().isUniformUsed("coffset")) {
      let t2 = e12.getCoincidentParameters(r2, a2);
      n2.getProgram().setUniformf("coffset", t2.offset), n2.getProgram().isUniformUsed("cfactor") && n2.getProgram().setUniformf("cfactor", t2.factor);
    }
  }, e12.setCameraShaderParameters = (e13, n2, r2) => {
    let a2 = t._openGLCamera.getKeyMatrices(n2), o2 = t._openGLImageSlice.getKeyMatrices(), s2 = e13.getCABO().getCoordShiftAndScaleEnabled() ? e13.getCABO().getInverseShiftAndScaleMatrix() : null, c2 = e13.getProgram();
    c2.isUniformUsed("MCPCMatrix") && (identity$2(t.tmpMat4), c2.setUniformMatrix("MCPCMatrix", safeMatrixMultiply([
      a2.wcpc,
      o2.mcwc,
      s2
    ], mat4_exports, t.tmpMat4))), c2.isUniformUsed("MCVCMatrix") && (identity$2(t.tmpMat4), c2.setUniformMatrix("MCVCMatrix", safeMatrixMultiply([
      a2.wcvc,
      o2.mcwc,
      s2
    ], mat4_exports, t.tmpMat4)));
  }, e12.setPropertyShaderParameters = (e13, n2, r2) => {
    let a2 = e13.getProgram(), o2 = r2.getProperty(t.currentValidInputs[0].inputIndex), s2 = o2.getOpacity();
    a2.setUniformf("opacity", s2);
    let c2 = t.numberOfComponents, l = o2.getIndependentComponents();
    if (l)
      for (let e14 = 0; e14 < c2; ++e14)
        a2.setUniformf(`mix${e14}`, o2.getComponentWeight(e14));
    for (let e14 = 0; e14 < c2; e14++) {
      let n3 = t.multiTexturePerVolumeEnabled, r3 = n3 ? e14 : 0, s3 = n3 ? 0 : e14, c3 = t.scalarTextures[r3].getVolumeInfo(), u2 = c3.scale[s3], d2 = c3.offset[s3], f = l ? e14 : 0, p = o2.getColorWindow(), m = o2.getColorLevel(), h = o2.getRGBTransferFunction(f);
      if (h && o2.getUseLookupTableScalarRange()) {
        let e15 = h.getRange();
        p = e15[1] - e15[0], m = 0.5 * (e15[1] + e15[0]);
      }
      let g = u2 / p, _ = (d2 - m) / p + 0.5;
      a2.setUniformf(`cshift${e14}`, _), a2.setUniformf(`cscale${e14}`, g);
      let v = 1, y = 0, b = o2.getPiecewiseFunction(f);
      if (b) {
        let e15 = b.getRange(), t2 = e15[1] - e15[0], n4 = 0.5 * (e15[0] + e15[1]);
        v = u2 / t2, y = (d2 - n4) / t2 + 0.5;
      }
      a2.setUniformf(`pwfshift${e14}`, y), a2.setUniformf(`pwfscale${e14}`, v);
    }
    let u = t.colorTexture.getTextureUnit();
    a2.setUniformi("colorTexture1", u);
    let d = t.pwfTexture.getTextureUnit();
    a2.setUniformi("pwfTexture1", d), a2.setUniform4fv("backgroundColor", t.renderable.getBackgroundColor());
  }, e12.getNeedToRebuildShaders = (e13, n2, r2) => {
    let a2 = r2.getProperty(t.currentValidInputs[0].inputIndex).getIndependentComponents(), o2 = t.renderable.getSlabThickness(), s2 = t.renderable.getSlabType(), c2 = t.renderable.getSlabTrapezoidIntegration(), l = false;
    return (!t.currentRenderPass && t.lastRenderPassShaderReplacement || t.currentRenderPass && t.currentRenderPass.getShaderReplacement() !== t.lastRenderPassShaderReplacement) && (l = true), l || t.lastHaveSeenDepthRequest !== t.haveSeenDepthRequest || t.lastNumberOfComponents !== t.numberOfComponents || t.lastMultiTexturePerVolumeEnabled !== t.multiTexturePerVolumeEnabled || e13.getProgram()?.getHandle() === 0 || t.lastIndependentComponents !== a2 || t.lastSlabThickness !== o2 || t.lastSlabType !== s2 || t.lastSlabTrapezoidIntegration !== c2 ? (t.lastHaveSeenDepthRequest = t.haveSeenDepthRequest, t.lastNumberOfComponents = t.numberOfComponents, t.lastMultiTexturePerVolumeEnabled = t.multiTexturePerVolumeEnabled, t.lastIndependentComponents = a2, t.lastSlabThickness = o2, t.lastSlabType = s2, t.lastSlabTrapezoidIntegration = c2, true) : false;
  }, e12.getShaderTemplate = (e13, t2, n2) => {
    e13.Vertex = vtkImageResliceMapperVS, e13.Fragment = vtkImageResliceMapperFS, e13.Geometry = "";
  }, e12.replaceShaderValues = (n2, r2, a2) => {
    if (e12.replaceShaderTCoord(n2, r2, a2), e12.replaceShaderPositionVC(n2, r2, a2), t.haveSeenDepthRequest) {
      let e13 = n2.Fragment;
      e13 = vtkShaderProgram$1.substitute(e13, "//VTK::ZBuffer::Dec", "uniform int depthRequest;").result, e13 = vtkShaderProgram$1.substitute(e13, "//VTK::ZBuffer::Impl", [
        "if (depthRequest == 1) {",
        "float iz = floor(gl_FragCoord.z*65535.0 + 0.1);",
        "float rf = floor(iz/256.0)/255.0;",
        "float gf = mod(iz,256.0)/255.0;",
        "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"
      ]).result, n2.Fragment = e13;
    }
    e12.replaceShaderCoincidentOffset(n2, r2, a2);
  }, e12.replaceShaderTCoord = (e13, n2, r2) => {
    let a2 = e13.Vertex, o2 = e13.Geometry, s2 = e13.Fragment, c2 = ["uniform mat4 WCTCMatrix;", "out vec3 fragTexCoord;"], l = t.renderable.getSlabThickness();
    a2 = vtkShaderProgram$1.substitute(a2, "//VTK::TCoord::Dec", c2).result, a2 = vtkShaderProgram$1.substitute(a2, "//VTK::TCoord::Impl", ["fragTexCoord = (WCTCMatrix * vertexWC).xyz;"]).result;
    let u = t.numberOfComponents, d = r2.getProperty(t.currentValidInputs[0].inputIndex).getIndependentComponents(), f = [
      "in vec3 fragTexCoord;",
      `uniform highp sampler3D volumeTexture[${t.scalarTextures.length}];`,
      "uniform mat4 WCTCMatrix;",
      "uniform float cshift0;",
      "uniform float cscale0;",
      "uniform float pwfshift0;",
      "uniform float pwfscale0;",
      "uniform sampler2D colorTexture1;",
      "uniform sampler2D pwfTexture1;",
      "uniform float opacity;",
      "uniform vec4 backgroundColor;"
    ];
    if (f.push("vec4 rawSampleTexture(vec3 pos) {"), !t.multiTexturePerVolumeEnabled)
      f.push("return texture(volumeTexture[0], pos);", "}");
    else {
      f.push("vec4 rawSample;");
      for (let e14 = 0; e14 < t.scalarTextures.length; ++e14)
        f.push(`rawSample[${e14}] = texture(volumeTexture[${e14}], pos)[0];`);
      f.push("return rawSample;", "}");
    }
    if (d) {
      for (let e14 = 1; e14 < u; e14++)
        f = f.concat([
          `uniform float cshift${e14};`,
          `uniform float cscale${e14};`,
          `uniform float pwfshift${e14};`,
          `uniform float pwfscale${e14};`
        ]);
      switch (u) {
        case 1:
          f = f.concat(["uniform float mix0;", "#define height0 0.5"]);
          break;
        case 2:
          f = f.concat([
            "uniform float mix0;",
            "uniform float mix1;",
            "#define height0 0.25",
            "#define height1 0.75"
          ]);
          break;
        case 3:
          f = f.concat([
            "uniform float mix0;",
            "uniform float mix1;",
            "uniform float mix2;",
            "#define height0 0.17",
            "#define height1 0.5",
            "#define height2 0.83"
          ]);
          break;
        case 4:
          f = f.concat([
            "uniform float mix0;",
            "uniform float mix1;",
            "uniform float mix2;",
            "uniform float mix3;",
            "#define height0 0.125",
            "#define height1 0.375",
            "#define height2 0.625",
            "#define height3 0.875"
          ]);
          break;
        default:
          vtkErrorMacro$26("Unsupported number of independent coordinates.");
      }
    }
    l > 0 && (f = f.concat([
      "uniform vec3 spacing;",
      "uniform float slabThickness;",
      "uniform int slabType;",
      "uniform int slabTrapezoid;",
      "uniform vec3 vboScaling;"
    ]), f = f.concat([
      "vec4 compositeValue(vec4 currVal, vec4 valToComp, int trapezoid)",
      "{",
      "  vec4 retVal = vec4(1.0);",
      "  if (slabType == 0) // min",
      "  {",
      "    retVal = min(currVal, valToComp);",
      "  }",
      "  else if (slabType == 1) // max",
      "  {",
      "    retVal = max(currVal, valToComp);",
      "  }",
      "  else if (slabType == 3) // sum",
      "  {",
      "    retVal = currVal + (trapezoid > 0 ? 0.5 * valToComp : valToComp); ",
      "  }",
      "  else // mean",
      "  {",
      "    retVal = currVal + (trapezoid > 0 ? 0.5 * valToComp : valToComp); ",
      "  }",
      "  return retVal;",
      "}"
    ])), s2 = vtkShaderProgram$1.substitute(s2, "//VTK::TCoord::Dec", f).result;
    let p = [
      "if (any(greaterThan(fragTexCoord, vec3(1.0))) || any(lessThan(fragTexCoord, vec3(0.0))))",
      "{",
      "  // set the background color and exit",
      "  gl_FragData[0] = backgroundColor;",
      "  return;",
      "}",
      "vec4 tvalue = rawSampleTexture(fragTexCoord);"
    ];
    if (l > 0 && (p = p.concat([
      "// Get the first and last samples",
      "int numSlices = 1;",
      "float scaling = min(min(spacing.x, spacing.y), spacing.z) * 0.5;",
      "vec3 normalxspacing = scaling * normalWCVSOutput;",
      "float distTraveled = length(normalxspacing);",
      "int trapezoid = 0;",
      "while (distTraveled < slabThickness * 0.5)",
      "{",
      "  distTraveled += length(normalxspacing);",
      "  float fnumSlices = float(numSlices);",
      "  if (distTraveled > slabThickness * 0.5)",
      "  {",
      "    // Before stepping outside the slab, sample at the boundaries",
      "    normalxspacing = normalWCVSOutput * slabThickness * 0.5 / fnumSlices;",
      "    trapezoid = slabTrapezoid;",
      "  }",
      "  vec3 fragTCoordNeg = (WCTCMatrix * vec4(vertexWCVSOutput.xyz - fnumSlices * normalxspacing * vboScaling, 1.0)).xyz;",
      "  if (!any(greaterThan(fragTCoordNeg, vec3(1.0))) && !any(lessThan(fragTCoordNeg, vec3(0.0))))",
      "  {",
      "    vec4 newVal = rawSampleTexture(fragTCoordNeg);",
      "    tvalue = compositeValue(tvalue, newVal, trapezoid);",
      "    numSlices += 1;",
      "  }",
      "  vec3 fragTCoordPos = (WCTCMatrix * vec4(vertexWCVSOutput.xyz + fnumSlices * normalxspacing * vboScaling, 1.0)).xyz;",
      "  if (!any(greaterThan(fragTCoordNeg, vec3(1.0))) && !any(lessThan(fragTCoordNeg, vec3(0.0))))",
      "  {",
      "    vec4 newVal = rawSampleTexture(fragTCoordPos);",
      "    tvalue = compositeValue(tvalue, newVal, trapezoid);",
      "    numSlices += 1;",
      "  }",
      "}",
      "// Finally, if slab type is *mean*, divide the sum by the numSlices",
      "if (slabType == 2)",
      "{",
      "  tvalue = tvalue / float(numSlices);",
      "}"
    ])), d) {
      let e14 = [
        "r",
        "g",
        "b",
        "a"
      ];
      for (let t2 = 0; t2 < u; ++t2)
        p = p.concat([`vec3 tcolor${t2} = texture2D(colorTexture1, vec2(tvalue.${e14[t2]} * cscale${t2} + cshift${t2}, height${t2})).rgb;`, `float compWeight${t2} = mix${t2} * texture2D(pwfTexture1, vec2(tvalue.${e14[t2]} * pwfscale${t2} + pwfshift${t2}, height${t2})).r;`]);
      switch (u) {
        case 1:
          p = p.concat(["gl_FragData[0] = vec4(tcolor0.rgb, compWeight0 * opacity);"]);
          break;
        case 2:
          p = p.concat(["float weightSum = compWeight0 + compWeight1;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum))), opacity);"]);
          break;
        case 3:
          p = p.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum))), opacity);"]);
          break;
        case 4:
          p = p.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2 + compWeight3;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum)) + (tcolor3.rgb * (compWeight3 / weightSum))), opacity);"]);
          break;
        default:
          vtkErrorMacro$26("Unsupported number of independent coordinates.");
      }
    } else
      switch (u) {
        case 1:
          p = p.concat([
            "// Dependent components",
            "float intensity = tvalue.r;",
            "vec3 tcolor = texture2D(colorTexture1, vec2(intensity * cscale0 + cshift0, 0.5)).rgb;",
            "float scalarOpacity = texture2D(pwfTexture1, vec2(intensity * pwfscale0 + pwfshift0, 0.5)).r;",
            "gl_FragData[0] = vec4(tcolor, scalarOpacity * opacity);"
          ]);
          break;
        case 2:
          p = p.concat(["float intensity = tvalue.r*cscale0 + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(intensity, 0.5)).rgb, pwfscale0*tvalue.g + pwfshift0);"]);
          break;
        case 3:
          p = p.concat([
            "vec4 tcolor = cscale0*tvalue + cshift0;",
            "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, opacity);"
          ]);
          break;
        default:
          p = p.concat([
            "vec4 tcolor = cscale0*tvalue + cshift0;",
            "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, tcolor.a);"
          ]);
      }
    s2 = vtkShaderProgram$1.substitute(s2, "//VTK::TCoord::Impl", p).result, e13.Vertex = a2, e13.Fragment = s2, e13.Geometry = o2;
  }, e12.replaceShaderPositionVC = (n2, r2, a2) => {
    let o2 = n2.Vertex, s2 = n2.Geometry, c2 = n2.Fragment, l = t.renderable.getSlabThickness(), u = ["attribute vec4 vertexWC;"];
    u = u.concat([`//${e12.getMTime()}${t.resliceGeomUpdateString}`]), l > 0 && (u = u.concat([
      "attribute vec3 normalWC;",
      "varying vec3 normalWCVSOutput;",
      "varying vec4 vertexWCVSOutput;"
    ])), o2 = vtkShaderProgram$1.substitute(o2, "//VTK::PositionVC::Dec", u).result;
    let d = ["gl_Position = MCPCMatrix * vertexWC;"];
    l > 0 && (d = d.concat(["normalWCVSOutput = normalWC;", "vertexWCVSOutput = vertexWC;"])), o2 = vtkShaderProgram$1.substitute(o2, "//VTK::PositionVC::Impl", d).result, o2 = vtkShaderProgram$1.substitute(o2, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;", "uniform mat4 MCVCMatrix;"]).result;
    let f = [];
    l > 0 && (f = f.concat(["varying vec3 normalWCVSOutput;", "varying vec4 vertexWCVSOutput;"])), c2 = vtkShaderProgram$1.substitute(c2, "//VTK::PositionVC::Dec", f).result, n2.Vertex = o2, n2.Geometry = s2, n2.Fragment = c2;
  };
  function c(e13) {
    vtkMath.normalize(e13);
    let t2 = [
      0,
      0,
      0
    ];
    for (let n2 = 0; n2 < 3; ++n2) {
      zero$2(t2), t2[n2] = 1;
      let r2 = vtkMath.dot(e13, t2);
      if (r2 < -0.999999 || r2 > 0.999999)
        return [true, n2];
    }
    return [false, 2];
  }
  e12.updateResliceGeometry = () => {
    let e13 = "", n2 = t.currentValidInputs[0].imageData, r2 = n2?.getBounds(), a2 = true, o2 = 2, s2 = t.renderable.getSlicePolyData(), l = t.renderable.getSlicePlane();
    if (s2)
      e13 = e13.concat(`PolyData${s2.getMTime()}`);
    else if (l) {
      e13 = e13.concat(`Plane${l.getMTime()}`);
      let t2 = create$6();
      n2 && (e13 = e13.concat(`Image${n2.getMTime()}`), set$6(t2, ...n2.getDirection()), invert$1(t2, t2));
      let r3 = [...l.getNormal()];
      transformMat3(r3, r3, t2), [a2, o2] = c(r3);
    } else {
      let a3 = vtkPlane$1.newInstance();
      a3.setNormal(0, 0, 1);
      let o3 = [
        0,
        1,
        0,
        1,
        0,
        1
      ];
      n2 && (o3 = r2), a3.setOrigin(o3[0], o3[2], 0.5 * (o3[5] + o3[4])), t.renderable.setSlicePlane(a3), e13 = e13.concat(`Plane${l?.getMTime()}`), n2 && (e13 = e13.concat(`Image${n2.getMTime()}`));
    }
    if (!t.resliceGeom || t.resliceGeomUpdateString !== e13) {
      if (s2)
        t.resliceGeom ||= vtkPolyData$1.newInstance(), t.resliceGeom.getPoints().setData(s2.getPoints().getData(), 3), t.resliceGeom.getPolys().setData(s2.getPolys().getData(), 1), t.resliceGeom.getPointData().setNormals(s2.getPointData().getNormals());
      else if (l)
        if (a2) {
          let e14 = new Float32Array(12), r3 = n2.worldToIndex(l.getOrigin(), [
            0,
            0,
            0
          ]), a3 = [(o2 + 1) % 3, (o2 + 2) % 3].sort(), s3 = n2.getSpatialExtent(), c2 = 0;
          for (let t2 = 0; t2 < 2; ++t2)
            for (let n3 = 0; n3 < 2; ++n3)
              e14[c2 + o2] = r3[o2], e14[c2 + a3[0]] = s3[2 * a3[0] + n3], e14[c2 + a3[1]] = s3[2 * a3[1] + t2], c2 += 3;
          t.transform.setMatrix(n2.getIndexToWorld()), t.transform.transformPoints(e14, e14);
          let u = new Uint16Array(8);
          u[0] = 3, u[1] = 0, u[2] = 1, u[3] = 3, u[4] = 3, u[5] = 0, u[6] = 3, u[7] = 2;
          let d = l.getNormal();
          vtkMath.normalize(d);
          let f = new Float32Array(12);
          for (let e15 = 0; e15 < 4; ++e15)
            f[3 * e15] = d[0], f[3 * e15 + 1] = d[1], f[3 * e15 + 2] = d[2];
          t.resliceGeom ||= vtkPolyData$1.newInstance(), t.resliceGeom.getPoints().setData(e14, 3), t.resliceGeom.getPolys().setData(u, 1);
          let p = vtkDataArray$1.newInstance({
            numberOfComponents: 3,
            values: f,
            name: "Normals"
          });
          t.resliceGeom.getPointData().setNormals(p);
        } else {
          t.outlineFilter.setInputData(n2), t.cutter.setInputConnection(t.outlineFilter.getOutputPort()), t.cutter.setCutFunction(l), t.lineToSurfaceFilter.setInputConnection(t.cutter.getOutputPort()), t.lineToSurfaceFilter.update(), t.resliceGeom ||= vtkPolyData$1.newInstance();
          let e14 = t.lineToSurfaceFilter.getOutputData();
          t.resliceGeom.getPoints().setData(e14.getPoints().getData(), 3), t.resliceGeom.getPolys().setData(e14.getPolys().getData(), 1), t.resliceGeom.getPointData().setNormals(e14.getPointData().getNormals());
          let r3 = l.getNormal(), a3 = t.resliceGeom.getNumberOfPoints();
          vtkMath.normalize(r3);
          let o3 = new Float32Array(a3 * 3);
          for (let e15 = 0; e15 < a3; ++e15)
            o3[3 * e15] = r3[0], o3[3 * e15 + 1] = r3[1], o3[3 * e15 + 2] = r3[2];
          let s3 = vtkDataArray$1.newInstance({
            numberOfComponents: 3,
            values: o3,
            name: "Normals"
          });
          t.resliceGeom.getPointData().setNormals(s3);
        }
      else
        vtkErrorMacro$26("Something went wrong.", "A default slice plane should have been created in the beginning of", "updateResliceGeometry.");
      t.resliceGeomUpdateString = e13, t.resliceGeom?.modified();
    }
  }, e12.setScalarTextures = (e13) => {
    t.scalarTextures = [...e13], t._externalOpenGLTexture = true;
  }, e12.delete = chain(() => {
    t._openGLRenderWindow && s(t._openGLRenderWindow);
  }, e12.delete);
}
var DEFAULT_VALUES$88 = {
  VBOBuildTime: {},
  VBOBuildString: null,
  haveSeenDepthRequest: false,
  lastHaveSeenDepthRequest: false,
  lastIndependentComponents: false,
  lastNumberOfComponents: 0,
  lastMultiTexturePerVolumeEnabled: false,
  lastSlabThickness: 0,
  lastSlabTrapezoidIntegration: 0,
  lastSlabType: -1,
  scalarTextures: [],
  _scalarTexturesCore: [],
  colorTexture: null,
  _colorTextureCore: null,
  pwfTexture: null,
  _pwfTextureCore: null,
  _externalOpenGLTexture: false,
  resliceGeom: null,
  resliceGeomUpdateString: null,
  tris: null
};
function extend$97(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$88, n), vtkViewNode$1.extend(e12, t, n), vtkReplacementShaderMapper.implementReplaceShaderCoincidentOffset(e12, t, n), vtkReplacementShaderMapper.implementBuildShadersWithReplacements(e12, t, n), t.tris = vtkHelper.newInstance(), t.scalarTextures = [], t.colorTexture = null, t.pwfTexture = null, t.VBOBuildTime = {}, obj(t.VBOBuildTime), t.tmpMat4 = identity$2(new Float64Array(16)), t.outlineFilter = vtkImageDataOutlineFilter$1.newInstance(), t.outlineFilter.setGenerateFaces(true), t.outlineFilter.setGenerateLines(false), t.cubePolyData = vtkPolyData$1.newInstance(), t.cutter = vtkCutter$1.newInstance(), t.lineToSurfaceFilter = vtkClosedPolyLineToSurfaceFilter$1.newInstance(), t.transform = vtkTransform$1.newInstance(), get(e12, t, ["scalarTextures"]), vtkOpenGLImageResliceMapper(e12, t);
}
registerOverride$1("vtkImageResliceMapper", newInstance(extend$97, "vtkOpenGLImageResliceMapper"));
var Constants$3 = { SlicingMode: {
  NONE: -1,
  I: 0,
  J: 1,
  K: 2,
  X: 3,
  Y: 4,
  Z: 5
} }, vtkPolyDataVS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkPolyDataVS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n\nattribute vec4 vertexMC;\n\n// frag position in VC\n//VTK::PositionVC::Dec\n\n// optional normal declaration\n//VTK::Normal::Dec\n\n// extra lighting parameters\n//VTK::Light::Dec\n\n// Texture coordinates\n//VTK::TCoord::Dec\n\n// material property values\n//VTK::Color::Dec\n\n// clipping plane vars\n//VTK::Clip::Dec\n\n// camera and actor matrix values\n//VTK::Camera::Dec\n\n// Apple Bug\n//VTK::PrimID::Dec\n\n// picking support\n//VTK::Picking::Dec\n\nvoid main()\n{\n  //VTK::Color::Impl\n\n  //VTK::Normal::Impl\n\n  //VTK::TCoord::Impl\n\n  //VTK::Clip::Impl\n\n  //VTK::PrimID::Impl\n\n  //VTK::PositionVC::Impl\n\n  //VTK::Light::Impl\n\n  //VTK::Picking::Impl\n}\n", vtkPolyDataFS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkPolyDataFS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n// Template for the polydata mappers fragment shader\n\nuniform int PrimitiveIDOffset;\n\n// VC position of this fragment\n//VTK::PositionVC::Dec\n\n// optional color passed in from the vertex shader, vertexColor\n//VTK::Color::Dec\n\n// optional surface normal declaration\n//VTK::Normal::Dec\n\n// extra lighting parameters\n//VTK::Light::Dec\n\n// define vtkImageLabelOutlineOn\n//VTK::ImageLabelOutlineOn\n\n// Texture coordinates\n//VTK::TCoord::Dec\n\n// picking support\n//VTK::Picking::Dec\n\n// Depth Peeling Support\n//VTK::DepthPeeling::Dec\n\n// clipping plane vars\n//VTK::Clip::Dec\n\n// label outline \n//VTK::LabelOutline::Dec\n\n// the output of this shader\n//VTK::Output::Dec\n\n// Apple Bug\n//VTK::PrimID::Dec\n\n// handle coincident offsets\n//VTK::Coincident::Dec\n\n//VTK::ZBuffer::Dec\n\n//VTK::LabelOutlineHelperFunction\n\nvoid main()\n{\n  // VC position of this fragment. This should not branch/return/discard.\n  //VTK::PositionVC::Impl\n\n  // Place any calls that require uniform flow (e.g. dFdx) here.\n  //VTK::UniformFlow::Impl\n\n  // Set gl_FragDepth here (gl_FragCoord.z by default)\n  //VTK::Depth::Impl\n\n  // Early depth peeling abort:\n  //VTK::DepthPeeling::PreColor\n\n  // Apple Bug\n  //VTK::PrimID::Impl\n\n  //VTK::Clip::Impl\n\n  //VTK::Color::Impl\n\n  // Generate the normal if we are not passed in one\n  //VTK::Normal::Impl\n\n  //VTK::TCoord::Impl\n\n  //VTK::Light::Impl\n\n  if (gl_FragData[0].a <= 0.0)\n    {\n    discard;\n    }\n\n  //VTK::DepthPeeling::Impl\n\n  //VTK::Picking::Impl\n\n  // handle coincident offsets\n  //VTK::Coincident::Impl\n\n  //VTK::ZBuffer::Impl\n\n  //VTK::RenderPassFragmentShader::Impl\n}\n", { vtkErrorMacro: vtkErrorMacro$25 } = macro$1, { SlicingMode: SlicingMode$2 } = Constants$3;
function splitStringOnEnter(e12) {
  let t = e12.split("\n"), n = [];
  for (let e13 = 0; e13 < t.length; ++e13) {
    let r = t[e13].trim();
    r.length > 0 && n.push(r);
  }
  return n;
}
function vtkOpenGLImageMapper(e12, t) {
  t.classHierarchy.push("vtkOpenGLImageMapper");
  function n(n2) {
    t.openGLTexture.releaseGraphicsResources(n2), [
      t._colorTransferFunc,
      t._pwFunc,
      t._labelOutlineThicknessArray,
      t._labelOutlineOpacity
    ].forEach((t2) => n2.unregisterGraphicsResourceUser(t2, e12));
  }
  e12.buildPass = (r) => {
    if (r) {
      t.currentRenderPass = null, t.openGLImageSlice = e12.getFirstAncestorOfType("vtkOpenGLImageSlice"), t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer");
      let r2 = t._openGLRenderWindow;
      t._openGLRenderWindow = t._openGLRenderer.getLastAncestorOfType("vtkOpenGLRenderWindow"), r2 && !r2.isDeleted() && r2 !== t._openGLRenderWindow && n(r2), t.context = t._openGLRenderWindow.getContext(), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow);
      let a = t._openGLRenderer.getRenderable();
      t.openGLCamera = t._openGLRenderer.getViewNodeFor(a.getActiveCamera()), t.renderable.isA("vtkImageMapper") && t.renderable.getSliceAtFocalPoint() && t.renderable.setSliceFromCamera(a.getActiveCamera());
    }
  }, e12.translucentPass = (n2, r) => {
    n2 && (t.currentRenderPass = r, e12.render());
  }, e12.zBufferPass = (n2) => {
    n2 && (t.haveSeenDepthRequest = true, t.renderDepth = true, e12.render(), t.renderDepth = false);
  }, e12.opaqueZBufferPass = (t2) => e12.zBufferPass(t2), e12.opaquePass = (t2) => {
    t2 && e12.render();
  }, e12.getCoincidentParameters = (e13, n2) => t.renderable.getResolveCoincidentTopology() == Resolve.PolygonOffset ? t.renderable.getCoincidentTopologyPolygonOffsetParameters() : null, e12.render = () => {
    let n2 = t.openGLImageSlice.getRenderable(), r = t._openGLRenderer.getRenderable();
    e12.renderPiece(r, n2);
  }, e12.getShaderTemplate = (e13, t2, n2) => {
    e13.Vertex = vtkPolyDataVS, e13.Fragment = vtkPolyDataFS, e13.Geometry = "";
  }, e12.replaceShaderValues = (n2, r, a) => {
    let o = n2.Vertex, s = n2.Fragment;
    o = vtkShaderProgram$1.substitute(o, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::PositionVC::Impl", ["  gl_Position = MCPCMatrix * vertexMC;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::TCoord::Impl", "tcoordVCVSOutput = tcoordMC;").result, o = vtkShaderProgram$1.substitute(o, "//VTK::TCoord::Dec", "attribute vec2 tcoordMC; varying vec2 tcoordVCVSOutput;").result;
    let c = t.openGLTexture.getComponents(), l = a.getProperty().getIndependentComponents(), u = [
      "varying vec2 tcoordVCVSOutput;",
      "uniform float cshift0;",
      "uniform float cscale0;",
      "uniform float pwfshift0;",
      "uniform float pwfscale0;",
      "uniform sampler2D texture1;",
      "uniform sampler2D colorTexture1;",
      "uniform sampler2D pwfTexture1;",
      "uniform float opacity;"
    ];
    if (a.getProperty().getUseLabelOutline() && (u = u.concat(["uniform sampler2D labelOutlineTexture1;", "uniform sampler2D labelOutlineOpacityTexture1;"])), l) {
      for (let e13 = 1; e13 < c; e13++)
        u = u.concat([
          `uniform float cshift${e13};`,
          `uniform float cscale${e13};`,
          `uniform float pwfshift${e13};`,
          `uniform float pwfscale${e13};`
        ]);
      switch (c) {
        case 1:
          u = u.concat(["uniform float mix0;", "#define height0 0.5"]);
          break;
        case 2:
          u = u.concat([
            "uniform float mix0;",
            "uniform float mix1;",
            "#define height0 0.25",
            "#define height1 0.75"
          ]);
          break;
        case 3:
          u = u.concat([
            "uniform float mix0;",
            "uniform float mix1;",
            "uniform float mix2;",
            "#define height0 0.17",
            "#define height1 0.5",
            "#define height2 0.83"
          ]);
          break;
        case 4:
          u = u.concat([
            "uniform float mix0;",
            "uniform float mix1;",
            "uniform float mix2;",
            "uniform float mix3;",
            "#define height0 0.125",
            "#define height1 0.375",
            "#define height2 0.625",
            "#define height3 0.875"
          ]);
          break;
        default:
          vtkErrorMacro$25("Unsupported number of independent coordinates.");
      }
    }
    if (s = vtkShaderProgram$1.substitute(s, "//VTK::TCoord::Dec", u).result, a.getProperty().getUseLabelOutline() === true && (s = vtkShaderProgram$1.substitute(s, "//VTK::LabelOutline::Dec", [
      "uniform float vpWidth;",
      "uniform float vpHeight;",
      "uniform float vpOffsetX;",
      "uniform float vpOffsetY;",
      "uniform mat4 PCWCMatrix;",
      "uniform mat4 vWCtoIDX;",
      "uniform ivec3 imageDimensions;",
      "uniform int sliceAxis;"
    ]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::ImageLabelOutlineOn", "#define vtkImageLabelOutlineOn").result, s = vtkShaderProgram$1.substitute(s, "//VTK::LabelOutlineHelperFunction", [
      "#ifdef vtkImageLabelOutlineOn",
      "vec3 fragCoordToIndexSpace(vec4 fragCoord) {",
      "  vec4 pcPos = vec4(",
      "    (fragCoord.x / vpWidth - vpOffsetX - 0.5) * 2.0,",
      "    (fragCoord.y / vpHeight - vpOffsetY - 0.5) * 2.0,",
      "    (fragCoord.z - 0.5) * 2.0,",
      "    1.0);",
      "",
      "  vec4 worldCoord = PCWCMatrix * pcPos;",
      "  vec4 vertex = (worldCoord/worldCoord.w);",
      "",
      "  vec3 index = (vWCtoIDX * vertex).xyz;",
      "",
      "  // half voxel fix for labelmapOutline",
      "  return (index + vec3(0.5)) / vec3(imageDimensions);",
      "}",
      "vec2 getSliceCoords(vec3 coord, int axis) {",
      "  if (axis == 0) return coord.yz;",
      "  if (axis == 1) return coord.xz;",
      "  if (axis == 2) return coord.xy;",
      "}",
      "#endif"
    ]).result), l) {
      let e13 = [
        "r",
        "g",
        "b",
        "a"
      ], t2 = ["vec4 tvalue = texture2D(texture1, tcoordVCVSOutput);"];
      for (let n3 = 0; n3 < c; n3++)
        t2 = t2.concat([`vec3 tcolor${n3} = mix${n3} * texture2D(colorTexture1, vec2(tvalue.${e13[n3]} * cscale${n3} + cshift${n3}, height${n3})).rgb;`, `float compWeight${n3} = mix${n3} * texture2D(pwfTexture1, vec2(tvalue.${e13[n3]} * pwfscale${n3} + pwfshift${n3}, height${n3})).r;`]);
      switch (c) {
        case 1:
          t2 = t2.concat(["gl_FragData[0] = vec4(tcolor0.rgb, opacity);"]);
          break;
        case 2:
          t2 = t2.concat(["float weightSum = compWeight0 + compWeight1;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum))), opacity);"]);
          break;
        case 3:
          t2 = t2.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum))), opacity);"]);
          break;
        case 4:
          t2 = t2.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2 + compWeight3;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum)) + (tcolor3.rgb * (compWeight3 / weightSum))), opacity);"]);
          break;
        default:
          vtkErrorMacro$25("Unsupported number of independent coordinates.");
      }
      s = vtkShaderProgram$1.substitute(s, "//VTK::TCoord::Impl", t2).result;
    } else
      switch (c) {
        case 1:
          s = vtkShaderProgram$1.substitute(s, "//VTK::TCoord::Impl", [...splitStringOnEnter("\n                #ifdef vtkImageLabelOutlineOn\n                  vec3 centerPosIS = fragCoordToIndexSpace(gl_FragCoord);\n                  float centerValue = texture2D(texture1, getSliceCoords(centerPosIS, sliceAxis)).r;\n                  bool pixelOnBorder = false;\n                  vec3 tColor = texture2D(colorTexture1, vec2(centerValue * cscale0 + cshift0, 0.5)).rgb;\n                  float scalarOpacity = texture2D(pwfTexture1, vec2(centerValue * pwfscale0 + pwfshift0, 0.5)).r;\n                  float opacityToUse = scalarOpacity * opacity;\n                  int segmentIndex = int(centerValue * 255.0);\n                  float textureCoordinate = float(segmentIndex - 1) / 1024.0;\n                  float textureValue = texture2D(labelOutlineTexture1, vec2(textureCoordinate, 0.5)).r;\n                  float outlineOpacity = texture2D(labelOutlineOpacityTexture1, vec2(textureCoordinate, 0.5)).r;\n                  int actualThickness = int(textureValue * 255.0);\n\n                  if (segmentIndex == 0){\n                    gl_FragData[0] = vec4(0.0, 0.0, 0.0, 0.0);\n                    return;\n                  }\n\n                  for (int i = -actualThickness; i <= actualThickness; i++) {\n                    for (int j = -actualThickness; j <= actualThickness; j++) {\n                      if (i == 0 || j == 0) {\n                        continue;\n                      }\n                      vec4 neighborPixelCoord = vec4(gl_FragCoord.x + float(i),\n                        gl_FragCoord.y + float(j),\n                        gl_FragCoord.z, gl_FragCoord.w);\n                      vec3 neighborPosIS = fragCoordToIndexSpace(neighborPixelCoord);\n                      float value = texture2D(texture1, getSliceCoords(neighborPosIS, sliceAxis)).r;\n                      if (value != centerValue) {\n                        pixelOnBorder = true;\n                        break;\n                      }\n                    }\n                    if (pixelOnBorder == true) {\n                      break;\n                    }\n                  }\n                  if (pixelOnBorder == true) {\n                    gl_FragData[0] = vec4(tColor, outlineOpacity);\n                  }\n                  else {\n                    gl_FragData[0] = vec4(tColor, opacityToUse);\n                  }\n                #else\n                  float intensity = texture2D(texture1, tcoordVCVSOutput).r;\n                  vec3 tcolor = texture2D(colorTexture1, vec2(intensity * cscale0 + cshift0, 0.5)).rgb;\n                  float scalarOpacity = texture2D(pwfTexture1, vec2(intensity * pwfscale0 + pwfshift0, 0.5)).r;\n                  gl_FragData[0] = vec4(tcolor, scalarOpacity * opacity);\n                #endif\n                ")]).result;
          break;
        case 2:
          s = vtkShaderProgram$1.substitute(s, "//VTK::TCoord::Impl", [
            "vec4 tcolor = texture2D(texture1, tcoordVCVSOutput);",
            "float intensity = tcolor.r*cscale0 + cshift0;",
            "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(intensity, 0.5)).rgb, pwfscale0*tcolor.g + pwfshift0);"
          ]).result;
          break;
        case 3:
          s = vtkShaderProgram$1.substitute(s, "//VTK::TCoord::Impl", [
            "vec4 tcolor = cscale0*texture2D(texture1, tcoordVCVSOutput.st) + cshift0;",
            "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, opacity);"
          ]).result;
          break;
        default:
          s = vtkShaderProgram$1.substitute(s, "//VTK::TCoord::Impl", [
            "vec4 tcolor = cscale0*texture2D(texture1, tcoordVCVSOutput.st) + cshift0;",
            "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, tcolor.a);"
          ]).result;
      }
    t.haveSeenDepthRequest && (s = vtkShaderProgram$1.substitute(s, "//VTK::ZBuffer::Dec", "uniform int depthRequest;").result, s = vtkShaderProgram$1.substitute(s, "//VTK::ZBuffer::Impl", [
      "if (depthRequest == 1) {",
      "float iz = floor(gl_FragCoord.z*65535.0 + 0.1);",
      "float rf = floor(iz/256.0)/255.0;",
      "float gf = mod(iz,256.0)/255.0;",
      "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"
    ]).result), n2.Vertex = o, n2.Fragment = s, e12.replaceShaderClip(n2, r, a), e12.replaceShaderCoincidentOffset(n2, r, a);
  }, e12.replaceShaderClip = (e13, n2, r) => {
    let a = e13.Vertex, o = e13.Fragment;
    if (t.renderable.getNumberOfClippingPlanes()) {
      let e14 = t.renderable.getNumberOfClippingPlanes();
      e14 > 6 && (vtkErrorMacro("OpenGL has a limit of 6 clipping planes"), e14 = 6), a = vtkShaderProgram$1.substitute(a, "//VTK::Clip::Dec", [
        "uniform int numClipPlanes;",
        "uniform vec4 clipPlanes[6];",
        "varying float clipDistancesVSOutput[6];"
      ]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::Clip::Impl", [
        "for (int planeNum = 0; planeNum < 6; planeNum++)",
        "    {",
        "    if (planeNum >= numClipPlanes)",
        "        {",
        "        break;",
        "        }",
        "    clipDistancesVSOutput[planeNum] = dot(clipPlanes[planeNum], vertexMC);",
        "    }"
      ]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", "varying float clipDistancesVSOutput[6];"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Clip::Impl", [
        "for (int planeNum = 0; planeNum < 6; planeNum++)",
        "    {",
        "    if (planeNum >= numClipPlanes)",
        "        {",
        "        break;",
        "        }",
        "    if (clipDistancesVSOutput[planeNum] < 0.0) discard;",
        "    }"
      ]).result;
    }
    e13.Vertex = a, e13.Fragment = o;
  }, e12.getNeedToRebuildShaders = (e13, n2, r) => {
    let a = t.openGLTexture.getComponents(), o = r.getProperty().getIndependentComponents(), s = false;
    return (!t.currentRenderPass && t.lastRenderPassShaderReplacement || t.currentRenderPass && t.currentRenderPass.getShaderReplacement() !== t.lastRenderPassShaderReplacement) && (s = true), s || t.lastHaveSeenDepthRequest !== t.haveSeenDepthRequest || e13.getProgram()?.getHandle() === 0 || e13.getShaderSourceTime().getMTime() < t.renderable.getMTime() || e13.getShaderSourceTime().getMTime() < t.currentInput.getMTime() || e13.getShaderSourceTime().getMTime() < r.getProperty().getMTime() || t.lastTextureComponents !== a || t.lastIndependentComponents !== o ? (t.lastHaveSeenDepthRequest = t.haveSeenDepthRequest, t.lastTextureComponents = a, t.lastIndependentComponents = o, true) : false;
  }, e12.updateShaders = (n2, r, a) => {
    if (t.lastBoundBO = n2, e12.getNeedToRebuildShaders(n2, r, a)) {
      let o = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      e12.buildShaders(o, r, a);
      let s = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(o.Vertex, o.Fragment, o.Geometry);
      s !== n2.getProgram() && (n2.setProgram(s), n2.getVAO().releaseGraphicsResources()), n2.getShaderSourceTime().modified();
    } else
      t._openGLRenderWindow.getShaderCache().readyShaderProgram(n2.getProgram());
    n2.getVAO().bind(), e12.setMapperShaderParameters(n2, r, a), e12.setCameraShaderParameters(n2, r, a), e12.setPropertyShaderParameters(n2, r, a);
  }, e12.setMapperShaderParameters = (n2, r, a) => {
    n2.getCABO().getElementCount() && (t.VBOBuildTime > n2.getAttributeUpdateTime().getMTime() || n2.getShaderSourceTime().getMTime() > n2.getAttributeUpdateTime().getMTime()) && (n2.getProgram().isAttributeUsed("vertexMC") && (n2.getVAO().addAttributeArray(n2.getProgram(), n2.getCABO(), "vertexMC", n2.getCABO().getVertexOffset(), n2.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || vtkErrorMacro$25("Error setting vertexMC in shader VAO.")), n2.getProgram().isAttributeUsed("tcoordMC") && n2.getCABO().getTCoordOffset() && (n2.getVAO().addAttributeArray(n2.getProgram(), n2.getCABO(), "tcoordMC", n2.getCABO().getTCoordOffset(), n2.getCABO().getStride(), t.context.FLOAT, n2.getCABO().getTCoordComponents(), t.context.FALSE) || vtkErrorMacro$25("Error setting tcoordMC in shader VAO.")), n2.getAttributeUpdateTime().modified());
    let o = t.openGLTexture.getTextureUnit();
    n2.getProgram().setUniformi("texture1", o);
    let s = t.openGLTexture.getComponents(), c = a.getProperty().getIndependentComponents();
    if (c)
      for (let e13 = 0; e13 < s; e13++)
        n2.getProgram().setUniformf(`mix${e13}`, a.getProperty().getComponentWeight(e13));
    let l = t.openGLTexture.getShiftAndScale();
    for (let e13 = 0; e13 < s; e13++) {
      let t2 = a.getProperty().getColorWindow(), r2 = a.getProperty().getColorLevel(), o2 = c ? e13 : 0, s2 = a.getProperty().getRGBTransferFunction(o2);
      if (s2 && a.getProperty().getUseLookupTableScalarRange()) {
        let e14 = s2.getRange();
        t2 = e14[1] - e14[0], r2 = 0.5 * (e14[1] + e14[0]);
      }
      let u2 = l.scale / t2, d2 = (l.shift - r2) / t2 + 0.5;
      n2.getProgram().setUniformf(`cshift${e13}`, d2), n2.getProgram().setUniformf(`cscale${e13}`, u2);
    }
    for (let e13 = 0; e13 < s; e13++) {
      let t2 = 1, r2 = 0, o2 = c ? e13 : 0, s2 = a.getProperty().getPiecewiseFunction(o2);
      if (s2) {
        let e14 = s2.getRange(), n3 = e14[1] - e14[0], a2 = 0.5 * (e14[0] + e14[1]);
        t2 = l.scale / n3, r2 = (l.shift - a2) / n3 + 0.5;
      }
      n2.getProgram().setUniformf(`pwfshift${e13}`, r2), n2.getProgram().setUniformf(`pwfscale${e13}`, t2);
    }
    if (t.haveSeenDepthRequest && n2.getProgram().setUniformi("depthRequest", t.renderDepth ? 1 : 0), n2.getProgram().isUniformUsed("coffset")) {
      let t2 = e12.getCoincidentParameters(r, a);
      n2.getProgram().setUniformf("coffset", t2.offset), n2.getProgram().isUniformUsed("cfactor") && n2.getProgram().setUniformf("cfactor", t2.factor);
    }
    let u = t.colorTexture.getTextureUnit();
    n2.getProgram().setUniformi("colorTexture1", u);
    let d = t.pwfTexture.getTextureUnit();
    if (n2.getProgram().setUniformi("pwfTexture1", d), a.getProperty().getUseLabelOutline()) {
      let e13 = t.labelOutlineThicknessTexture.getTextureUnit();
      n2.getProgram().setUniformi("labelOutlineTexture1", e13);
      let r2 = t.labelOutlineOpacityTexture.getTextureUnit();
      n2.getProgram().setUniformi("labelOutlineOpacityTexture1", r2);
    }
    if (t.renderable.getNumberOfClippingPlanes()) {
      let e13 = t.renderable.getNumberOfClippingPlanes();
      e13 > 6 && (vtkErrorMacro("OpenGL has a limit of 6 clipping planes"), e13 = 6);
      let r2 = n2.getCABO().getCoordShiftAndScaleEnabled() ? n2.getCABO().getInverseShiftAndScaleMatrix() : null, o2 = r2 ? copy$4(t.imagematinv, a.getMatrix()) : a.getMatrix();
      r2 && (transpose(o2, o2), multiply$2(o2, o2, r2), transpose(o2, o2)), transpose(t.imagemat, t.currentInput.getIndexToWorld()), multiply$2(t.imagematinv, o2, t.imagemat);
      let s2 = [];
      for (let n3 = 0; n3 < e13; n3++) {
        let e14 = [];
        t.renderable.getClippingPlaneInDataCoords(t.imagematinv, n3, e14);
        for (let t2 = 0; t2 < 4; t2++)
          s2.push(e14[t2]);
      }
      n2.getProgram().setUniformi("numClipPlanes", e13), n2.getProgram().setUniform4fv("clipPlanes", s2);
    }
  }, e12.setCameraShaderParameters = (n2, r, a) => {
    let o = n2.getProgram(), s = t.openGLImageSlice.getKeyMatrices(), c = t.currentInput, l = c.getIndexToWorld();
    multiply$2(t.imagemat, s.mcwc, l);
    let u = t.openGLCamera.getKeyMatrices(r);
    if (multiply$2(t.imagemat, u.wcpc, t.imagemat), n2.getCABO().getCoordShiftAndScaleEnabled()) {
      let e13 = n2.getCABO().getInverseShiftAndScaleMatrix();
      multiply$2(t.imagemat, t.imagemat, e13);
    }
    if (o.setUniformMatrix("MCPCMatrix", t.imagemat), a.getProperty().getUseLabelOutline() === true) {
      let n3 = c.getWorldToIndex(), a2 = c.getDimensions(), s2 = t.renderable.getClosestIJKAxis().ijkMode;
      s2 === SlicingMode$2.NONE && (s2 = SlicingMode$2.K), o.setUniform3i("imageDimensions", a2[0], a2[1], a2[2]), o.setUniformi("sliceAxis", s2), o.setUniformMatrix("vWCtoIDX", n3);
      let l2 = t.openGLCamera.getKeyMatrices(r);
      invert(t.projectionToWorld, l2.wcpc), t.openGLCamera.getKeyMatrices(r), o.setUniformMatrix("PCWCMatrix", t.projectionToWorld);
      let u2 = e12.getRenderTargetSize();
      o.setUniformf("vpWidth", u2[0]), o.setUniformf("vpHeight", u2[1]);
      let d = e12.getRenderTargetOffset();
      o.setUniformf("vpOffsetX", d[0] / u2[0]), o.setUniformf("vpOffsetY", d[1] / u2[1]);
    }
  }, e12.setPropertyShaderParameters = (e13, t2, n2) => {
    let r = e13.getProgram(), a = n2.getProperty().getOpacity();
    r.setUniformf("opacity", a);
  }, e12.renderPieceStart = (n2, r) => {
    e12.updateBufferObjects(n2, r), t.lastBoundBO = null;
  }, e12.renderPieceDraw = (n2, r) => {
    let a = t.context;
    t.openGLTexture.activate(), t.colorTexture.activate(), r.getProperty().getUseLabelOutline() && (t.labelOutlineThicknessTexture.activate(), t.labelOutlineOpacityTexture.activate()), t.pwfTexture.activate(), t.tris.getCABO().getElementCount() && (e12.updateShaders(t.tris, n2, r), a.drawArrays(a.TRIANGLES, 0, t.tris.getCABO().getElementCount()), t.tris.getVAO().release()), t.openGLTexture.deactivate(), t.colorTexture.deactivate(), r.getProperty().getUseLabelOutline() && (t.labelOutlineThicknessTexture.deactivate(), t.labelOutlineOpacityTexture.deactivate()), t.pwfTexture.deactivate();
  }, e12.renderPieceFinish = (e13, t2) => {
  }, e12.renderPiece = (n2, r) => {
    if (e12.invokeEvent({ type: "StartEvent" }), t.renderable.update(), t.currentInput = t.renderable.getCurrentImage(), e12.invokeEvent({ type: "EndEvent" }), !t.currentInput) {
      vtkErrorMacro$25("No input!");
      return;
    }
    e12.renderPieceStart(n2, r), e12.renderPieceDraw(n2, r), e12.renderPieceFinish(n2, r);
  }, e12.updateBufferObjects = (t2, n2) => {
    e12.getNeedToRebuildBufferObjects(t2, n2) && e12.buildBufferObjects(t2, n2);
  }, e12.getNeedToRebuildBufferObjects = (n2, r) => t.VBOBuildTime.getMTime() < e12.getMTime() || t.VBOBuildTime.getMTime() < r.getMTime() || t.VBOBuildTime.getMTime() < t.renderable.getMTime() || t.VBOBuildTime.getMTime() < r.getProperty().getMTime() || t.VBOBuildTime.getMTime() < t.currentInput.getMTime() || !t.openGLTexture?.getHandle() || !t.colorTexture?.getHandle() || r.getProperty().getUseLabelOutline() && (!t.labelOutlineThicknessTexture?.getHandle() || !t.labelOutlineOpacityTexture?.getHandle()) || !t.pwfTexture?.getHandle(), e12.buildBufferObjects = (n2, r) => {
    let a = t.currentInput;
    if (!a)
      return;
    let o = a.getPointData() && a.getPointData().getScalars();
    if (!o)
      return;
    let s = o.getDataType(), c = o.getNumberOfComponents(), l = r.getProperty(), u = l.getInterpolationType(), d = l.getIndependentComponents(), f = d ? c : 1, p = d ? 2 * f : 1, m = [];
    for (let e13 = 0; e13 < f; ++e13)
      m.push(l.getRGBTransferFunction(e13));
    let h = getTransferFunctionsHash(m, d, f), g = l.getRGBTransferFunction(), _ = t._openGLRenderWindow.getGraphicsResourceForObject(g);
    if (!_?.oglObject?.getHandle() || _?.hash !== h) {
      t.colorTexture = vtkOpenGLTexture$1.newInstance({ resizable: true }), t.colorTexture.setOpenGLRenderWindow(t._openGLRenderWindow);
      let n3 = t.renderable.getColorTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let r2 = n3 * p * 3, a2 = new Uint8ClampedArray(r2);
      if (u === InterpolationType$1.NEAREST ? (t.colorTexture.setMinificationFilter(Filter$1.NEAREST), t.colorTexture.setMagnificationFilter(Filter$1.NEAREST)) : (t.colorTexture.setMinificationFilter(Filter$1.LINEAR), t.colorTexture.setMagnificationFilter(Filter$1.LINEAR)), g) {
        let e13 = new Float32Array(n3 * 3);
        for (let t2 = 0; t2 < f; t2++) {
          let r3 = l.getRGBTransferFunction(t2), o2 = r3.getRange();
          if (r3.getTable(o2[0], o2[1], n3, e13, 1), d)
            for (let r4 = 0; r4 < n3 * 3; r4++)
              a2[t2 * n3 * 6 + r4] = 255 * e13[r4], a2[t2 * n3 * 6 + r4 + n3 * 3] = 255 * e13[r4];
          else
            for (let r4 = 0; r4 < n3 * 3; r4++)
              a2[t2 * n3 * 6 + r4] = 255 * e13[r4];
        }
        t.colorTexture.resetFormatAndType(), t.colorTexture.create2DFromRaw({
          width: n3,
          height: p,
          numComps: 3,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: a2
        });
      } else {
        for (let e13 = 0; e13 < n3 * 3; ++e13)
          a2[e13] = 255 * e13 / ((n3 - 1) * 3), a2[e13 + 1] = 255 * e13 / ((n3 - 1) * 3), a2[e13 + 2] = 255 * e13 / ((n3 - 1) * 3);
        t.colorTexture.create2DFromRaw({
          width: n3,
          height: 1,
          numComps: 3,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: a2
        });
      }
      g && (t._openGLRenderWindow.setGraphicsResourceForObject(g, t.colorTexture, h), g !== t._colorTransferFunc && (t._openGLRenderWindow.registerGraphicsResourceUser(g, e12), t._openGLRenderWindow.unregisterGraphicsResourceUser(t._colorTransferFunc, e12)), t._colorTransferFunc = g);
    } else
      t.colorTexture = _.oglObject;
    let v = [];
    for (let e13 = 0; e13 < f; ++e13)
      v.push(l.getPiecewiseFunction(e13));
    let y = getTransferFunctionsHash(v, d, f), b = l.getPiecewiseFunction(), S = t._openGLRenderWindow.getGraphicsResourceForObject(b);
    if (!S?.oglObject?.getHandle() || S?.hash !== y) {
      let n3 = t.renderable.getOpacityTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let r2 = n3 * p, a2 = new Uint8ClampedArray(r2);
      if (t.pwfTexture = vtkOpenGLTexture$1.newInstance({ resizable: true }), t.pwfTexture.setOpenGLRenderWindow(t._openGLRenderWindow), u === InterpolationType$1.NEAREST ? (t.pwfTexture.setMinificationFilter(Filter$1.NEAREST), t.pwfTexture.setMagnificationFilter(Filter$1.NEAREST)) : (t.pwfTexture.setMinificationFilter(Filter$1.LINEAR), t.pwfTexture.setMagnificationFilter(Filter$1.LINEAR)), b) {
        let e13 = new Float32Array(r2), a3 = new Float32Array(n3);
        for (let t2 = 0; t2 < f; ++t2) {
          let r3 = l.getPiecewiseFunction(t2);
          if (r3 === null)
            e13.fill(1);
          else {
            let o2 = r3.getRange();
            if (r3.getTable(o2[0], o2[1], n3, a3, 1), d)
              for (let r4 = 0; r4 < n3; r4++)
                e13[t2 * n3 * 2 + r4] = a3[r4], e13[t2 * n3 * 2 + r4 + n3] = a3[r4];
            else
              for (let r4 = 0; r4 < n3; r4++)
                e13[t2 * n3 * 2 + r4] = a3[r4];
          }
        }
        t.pwfTexture.resetFormatAndType(), t.pwfTexture.create2DFromRaw({
          width: n3,
          height: p,
          numComps: 1,
          dataType: VtkDataTypes.FLOAT,
          data: e13
        });
      } else
        a2.fill(255), t.pwfTexture.create2DFromRaw({
          width: n3,
          height: 1,
          numComps: 1,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: a2
        });
      b && (t._openGLRenderWindow.setGraphicsResourceForObject(b, t.pwfTexture, y), b !== t._pwFunc && (t._openGLRenderWindow.registerGraphicsResourceUser(b, e12), t._openGLRenderWindow.unregisterGraphicsResourceUser(t._pwFunc, e12)), t._pwFunc = b);
    } else
      t.pwfTexture = S.oglObject;
    r.getProperty().getUseLabelOutline() && (e12.updatelabelOutlineThicknessTexture(r), e12.updateLabelOutlineOpacityTexture(r));
    let { ijkMode: C } = t.renderable.getClosestIJKAxis(), w = t.renderable.getSlice();
    C !== t.renderable.getSlicingMode() && (w = t.renderable.getSliceAtPosition(w));
    let T = t.renderable.isA("vtkImageArrayMapper") ? t.renderable.getSubSlice() : Math.round(w), E = a.getExtent(), D;
    C === SlicingMode$2.I && (D = T - E[0]), C === SlicingMode$2.J && (D = T - E[2]), (C === SlicingMode$2.K || C === SlicingMode$2.NONE) && (D = T - E[4]);
    let O = `${w}A${a.getMTime()}A${o.getMTime()}B${e12.getMTime()}C${t.renderable.getSlicingMode()}D${r.getProperty().getInterpolationType()}`;
    if (t.VBOBuildString !== O) {
      let e13 = a.getDimensions();
      t.openGLTexture ||= vtkOpenGLTexture$1.newInstance({ resizable: true }), t.openGLTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.openGLTexture.setOglNorm16Ext(t.context.getExtension("EXT_texture_norm16")), u === InterpolationType$1.NEAREST ? ((/* @__PURE__ */ new Set([
        1,
        3,
        4
      ])).has(c) && s === VtkDataTypes.UNSIGNED_CHAR && !d && t.openGLTexture.setGenerateMipmap(true), t.openGLTexture.setMinificationFilter(Filter$1.NEAREST), t.openGLTexture.setMagnificationFilter(Filter$1.NEAREST)) : (c === 4 && s === VtkDataTypes.UNSIGNED_CHAR && !d ? (t.openGLTexture.setGenerateMipmap(true), t.openGLTexture.setMinificationFilter(Filter$1.LINEAR_MIPMAP_LINEAR)) : t.openGLTexture.setMinificationFilter(Filter$1.LINEAR), t.openGLTexture.setMagnificationFilter(Filter$1.LINEAR)), t.openGLTexture.setWrapS(Wrap$2.CLAMP_TO_EDGE), t.openGLTexture.setWrapT(Wrap$2.CLAMP_TO_EDGE);
      let n3 = e13[0] * e13[1] * c, r2 = new Float32Array(12), l2 = new Float32Array(8);
      for (let e14 = 0; e14 < 4; e14++)
        l2[e14 * 2] = e14 % 2 ? 1 : 0, l2[e14 * 2 + 1] = e14 > 1 ? 1 : 0;
      let f2 = [
        SlicingMode$2.X,
        SlicingMode$2.Y,
        SlicingMode$2.Z
      ].includes(t.renderable.getSlicingMode()) ? w : T, p2 = a.getSpatialExtent(), m2 = o.getData(), h2 = null;
      if (C === SlicingMode$2.I) {
        h2 = new m2.constructor(e13[2] * e13[1] * c);
        let t2 = 0;
        for (let n4 = 0; n4 < e13[2]; n4++)
          for (let r3 = 0; r3 < e13[1]; r3++) {
            let a2 = (D + r3 * e13[0] + n4 * e13[0] * e13[1]) * c;
            t2 = (n4 * e13[1] + r3) * c;
            let o2 = a2 + c;
            for (; a2 < o2; )
              h2[t2++] = m2[a2++];
          }
        e13[0] = e13[1], e13[1] = e13[2], r2[0] = f2, r2[1] = p2[2], r2[2] = p2[4], r2[3] = f2, r2[4] = p2[3], r2[5] = p2[4], r2[6] = f2, r2[7] = p2[2], r2[8] = p2[5], r2[9] = f2, r2[10] = p2[3], r2[11] = p2[5];
      } else if (C === SlicingMode$2.J) {
        h2 = new m2.constructor(e13[2] * e13[0] * c);
        let t2 = 0;
        for (let n4 = 0; n4 < e13[2]; n4++)
          for (let r3 = 0; r3 < e13[0]; r3++) {
            let a2 = (r3 + D * e13[0] + n4 * e13[0] * e13[1]) * c;
            t2 = (n4 * e13[0] + r3) * c;
            let o2 = a2 + c;
            for (; a2 < o2; )
              h2[t2++] = m2[a2++];
          }
        e13[1] = e13[2], r2[0] = p2[0], r2[1] = f2, r2[2] = p2[4], r2[3] = p2[1], r2[4] = f2, r2[5] = p2[4], r2[6] = p2[0], r2[7] = f2, r2[8] = p2[5], r2[9] = p2[1], r2[10] = f2, r2[11] = p2[5];
      } else
        C === SlicingMode$2.K || C === SlicingMode$2.NONE ? (h2 = m2.subarray(D * n3, (D + 1) * n3), r2[0] = p2[0], r2[1] = p2[2], r2[2] = f2, r2[3] = p2[1], r2[4] = p2[2], r2[5] = f2, r2[6] = p2[0], r2[7] = p2[3], r2[8] = f2, r2[9] = p2[1], r2[10] = p2[3], r2[11] = f2) : vtkErrorMacro$25("Reformat slicing not yet supported.");
      let g2 = o.getRanges();
      t.openGLTexture.resetFormatAndType(), t.openGLTexture.create2DFilterableFromRaw({
        width: e13[0],
        height: e13[1],
        numComps: c,
        dataType: o.getDataType(),
        data: h2,
        preferSizeOverAccuracy: !!t.renderable.getPreferSizeOverAccuracy?.(),
        ranges: g2
      }), t.openGLTexture.activate(), t.openGLTexture.sendParameters(), t.openGLTexture.deactivate();
      let _2 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        values: r2
      });
      _2.setName("points");
      let v2 = vtkDataArray$1.newInstance({
        numberOfComponents: 2,
        values: l2
      });
      v2.setName("tcoords");
      let y2 = new Uint16Array(8);
      y2[0] = 3, y2[1] = 0, y2[2] = 1, y2[3] = 3, y2[4] = 3, y2[5] = 0, y2[6] = 3, y2[7] = 2;
      let b2 = vtkDataArray$1.newInstance({
        numberOfComponents: 1,
        values: y2
      });
      t.tris.getCABO().createVBO(b2, "polys", Representation$1.SURFACE, {
        points: _2,
        tcoords: v2,
        cellOffset: 0
      }), t.VBOBuildTime.modified(), t.VBOBuildString = O;
    }
  }, e12.updateLabelOutlineOpacityTexture = (n2) => {
    let r = n2.getProperty().getLabelOutlineOpacity();
    typeof r == "number" && (r = t._cachedLabelOutlineOpacityObj?.[0] === r ? t._cachedLabelOutlineOpacityObj : [r], t._cachedLabelOutlineOpacityObj = r);
    let a = t._openGLRenderWindow.getGraphicsResourceForObject(r), o = `${r.join("-")}`;
    if (!a?.oglObject?.getHandle() || a?.hash !== o) {
      let n3 = t.renderable.getLabelOutlineTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let a2 = n3 * 1, s = new Float32Array(a2);
      for (let e13 = 0; e13 < n3; ++e13)
        s[e13] = r[e13] ?? r[0];
      t.labelOutlineOpacityTexture = vtkOpenGLTexture$1.newInstance({ resizable: false }), t.labelOutlineOpacityTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.labelOutlineOpacityTexture.resetFormatAndType(), t.labelOutlineOpacityTexture.setMinificationFilter(Filter$1.NEAREST), t.labelOutlineOpacityTexture.setMagnificationFilter(Filter$1.NEAREST), t.labelOutlineOpacityTexture.create2DFromRaw({
        width: n3,
        height: 1,
        numComps: 1,
        dataType: VtkDataTypes.FLOAT,
        data: s
      }), r && (t._openGLRenderWindow.setGraphicsResourceForObject(r, t.labelOutlineOpacityTexture, o), r !== t._labelOutlineOpacity && (t._openGLRenderWindow.registerGraphicsResourceUser(r, e12), t._openGLRenderWindow.unregisterGraphicsResourceUser(t._labelOutlineOpacity, e12)), t._labelOutlineOpacity = r);
    } else
      t.labelOutlineOpacityTexture = a.oglObject;
  }, e12.updatelabelOutlineThicknessTexture = (n2) => {
    let r = n2.getProperty().getLabelOutlineThicknessByReference(), a = t._openGLRenderWindow.getGraphicsResourceForObject(r), o = `${r.join("-")}`;
    if (!a?.oglObject?.getHandle() || a?.hash !== o) {
      let n3 = t.renderable.getLabelOutlineTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let a2 = n3 * 1, s = new Uint8Array(a2);
      for (let e13 = 0; e13 < n3; ++e13)
        s[e13] = r[e13] === void 0 ? r[0] : r[e13];
      t.labelOutlineThicknessTexture = vtkOpenGLTexture$1.newInstance({ resizable: false }), t.labelOutlineThicknessTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.labelOutlineThicknessTexture.resetFormatAndType(), t.labelOutlineThicknessTexture.setMinificationFilter(Filter$1.NEAREST), t.labelOutlineThicknessTexture.setMagnificationFilter(Filter$1.NEAREST), t.labelOutlineThicknessTexture.create2DFromRaw({
        width: n3,
        height: 1,
        numComps: 1,
        dataType: VtkDataTypes.UNSIGNED_CHAR,
        data: s
      }), r && (t._openGLRenderWindow.setGraphicsResourceForObject(r, t.labelOutlineThicknessTexture, o), r !== t._labelOutlineThicknessArray && (t._openGLRenderWindow.registerGraphicsResourceUser(r, e12), t._openGLRenderWindow.unregisterGraphicsResourceUser(t._labelOutlineThicknessArray, e12)), t._labelOutlineThicknessArray = r);
    } else
      t.labelOutlineThicknessTexture = a.oglObject;
  }, e12.getRenderTargetSize = () => {
    if (t._useSmallViewport)
      return [t._smallViewportWidth, t._smallViewportHeight];
    let { usize: e13, vsize: n2 } = t._openGLRenderer.getTiledSizeAndOrigin();
    return [e13, n2];
  }, e12.getRenderTargetOffset = () => {
    let { lowerLeftU: e13, lowerLeftV: n2 } = t._openGLRenderer.getTiledSizeAndOrigin();
    return [e13, n2];
  }, e12.delete = chain(() => {
    t._openGLRenderWindow && n(t._openGLRenderWindow);
  }, e12.delete);
}
var DEFAULT_VALUES$87 = {
  VBOBuildTime: 0,
  VBOBuildString: null,
  openGLTexture: null,
  tris: null,
  imagemat: null,
  imagematinv: null,
  colorTexture: null,
  pwfTexture: null,
  labelOutlineThicknessTexture: null,
  labelOutlineOpacityTexture: null,
  lastHaveSeenDepthRequest: false,
  haveSeenDepthRequest: false,
  lastTextureComponents: 0
};
function extend$96(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$87, n), vtkViewNode$1.extend(e12, t, n), vtkReplacementShaderMapper.implementReplaceShaderCoincidentOffset(e12, t, n), vtkReplacementShaderMapper.implementBuildShadersWithReplacements(e12, t, n), t.tris = vtkHelper.newInstance(), t.imagemat = identity$2(new Float64Array(16)), t.imagematinv = identity$2(new Float64Array(16)), t.projectionToWorld = identity$2(new Float64Array(16)), t.idxToView = identity$2(new Float64Array(16)), t.idxNormalMatrix = identity$3(new Float64Array(9)), t.modelToView = identity$2(new Float64Array(16)), t.projectionToView = identity$2(new Float64Array(16)), setGet(e12, t, []), t.VBOBuildTime = {}, obj(t.VBOBuildTime), vtkOpenGLImageMapper(e12, t);
}
var newInstance$91 = newInstance(extend$96, "vtkOpenGLImageMapper"), vtkImageMapper$2 = {
  newInstance: newInstance$91,
  extend: extend$96
};
registerOverride$1("vtkAbstractImageMapper", newInstance$91);
var ProjectionMode = {
  MAX: 0,
  MIN: 1,
  AVERAGE: 2
}, { vtkErrorMacro: vtkErrorMacro$24 } = macro;
function vtkOpenGLImageCPRMapper(e12, t) {
  t.classHierarchy.push("vtkOpenGLImageCPRMapper");
  function n(n2) {
    [
      t._scalars,
      t._colorTransferFunc,
      t._pwFunc
    ].forEach((t2) => n2.unregisterGraphicsResourceUser(t2, e12));
  }
  e12.buildPass = (r) => {
    if (r) {
      t.currentRenderPass = null, t.openGLImageSlice = e12.getFirstAncestorOfType("vtkOpenGLImageSlice"), t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer");
      let r2 = t._openGLRenderWindow;
      t._openGLRenderWindow = t._openGLRenderer.getLastAncestorOfType("vtkOpenGLRenderWindow"), r2 && !r2.isDeleted() && r2 !== t._openGLRenderWindow && n(r2), t.context = t._openGLRenderWindow.getContext(), t.openGLCamera = t._openGLRenderer.getViewNodeFor(t._openGLRenderer.getRenderable().getActiveCamera()), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow);
    }
  }, e12.opaquePass = (n2, r) => {
    n2 && (t.currentRenderPass = r, e12.render());
  }, e12.opaqueZBufferPass = (n2) => {
    n2 && (t.haveSeenDepthRequest = true, t.renderDepth = true, e12.render(), t.renderDepth = false);
  }, e12.getCoincidentParameters = (e13, n2) => t.renderable.getResolveCoincidentTopology() === Resolve.PolygonOffset ? t.renderable.getCoincidentTopologyPolygonOffsetParameters() : null, e12.render = () => {
    let n2 = t.openGLImageSlice.getRenderable(), r = t._openGLRenderer.getRenderable();
    e12.renderPiece(r, n2);
  }, e12.renderPiece = (n2, r) => {
    e12.invokeEvent({ type: "StartEvent" }), t.renderable.update(), e12.invokeEvent({ type: "EndEvent" }), t.renderable.preRenderCheck() && (t.currentImageDataInput = t.renderable.getInputData(0), t.currentCenterlineInput = t.renderable.getOrientedCenterline(), e12.renderPieceStart(n2, r), e12.renderPieceDraw(n2, r), e12.renderPieceFinish(n2, r));
  }, e12.renderPieceStart = (t2, n2) => {
    e12.updateBufferObjects(t2, n2);
  }, e12.renderPieceDraw = (n2, r) => {
    let a = t.context;
    t.volumeTexture.activate(), t.colorTexture.activate(), t.pwfTexture.activate(), t.tris.getCABO().getElementCount() && (e12.updateShaders(t.tris, n2, r), a.drawArrays(a.TRIANGLES, 0, t.tris.getCABO().getElementCount()), t.tris.getVAO().release()), t.volumeTexture.deactivate(), t.colorTexture.deactivate(), t.pwfTexture.deactivate();
  }, e12.renderPieceFinish = (e13, t2) => {
  }, e12.updateBufferObjects = (n2, r) => {
    e12.getNeedToRebuildBufferObjects(n2, r) && e12.buildBufferObjects(n2, r), r.getProperty().getInterpolationType() === InterpolationType$1.NEAREST ? (t.volumeTexture.setMinificationFilter(Filter$1.NEAREST), t.volumeTexture.setMagnificationFilter(Filter$1.NEAREST), t.colorTexture.setMinificationFilter(Filter$1.NEAREST), t.colorTexture.setMagnificationFilter(Filter$1.NEAREST), t.pwfTexture.setMinificationFilter(Filter$1.NEAREST), t.pwfTexture.setMagnificationFilter(Filter$1.NEAREST)) : (t.volumeTexture.setMinificationFilter(Filter$1.LINEAR), t.volumeTexture.setMagnificationFilter(Filter$1.LINEAR), t.colorTexture.setMinificationFilter(Filter$1.LINEAR), t.colorTexture.setMagnificationFilter(Filter$1.LINEAR), t.pwfTexture.setMinificationFilter(Filter$1.LINEAR), t.pwfTexture.setMagnificationFilter(Filter$1.LINEAR));
  }, e12.getNeedToRebuildBufferObjects = (n2, r) => {
    let a = t.VBOBuildTime.getMTime();
    return a < e12.getMTime() || a < t.renderable.getMTime() || a < r.getMTime() || a < t.currentImageDataInput.getMTime() || a < t.currentCenterlineInput.getMTime() || !t.volumeTexture?.getHandle();
  }, e12.buildBufferObjects = (n2, r) => {
    let a = t.currentImageDataInput, o = t.currentCenterlineInput, s = r.getProperty(), c = a?.getPointData()?.getScalars();
    if (!c)
      return;
    let l = t._openGLRenderWindow.getGraphicsResourceForObject(c), u = getImageDataHash(a, c), d = !l?.oglObject?.getHandle() || l?.hash !== u, f = s.getUpdatedExtents(), p = !!f.length;
    if (d) {
      t.volumeTexture = vtkOpenGLTexture$1.newInstance(), t.volumeTexture.setOpenGLRenderWindow(t._openGLRenderWindow);
      let n3 = a.getDimensions();
      t.volumeTexture.setOglNorm16Ext(t.context.getExtension("EXT_texture_norm16")), t.volumeTexture.resetFormatAndType(), t.volumeTexture.create3DFilterableFromDataArray({
        width: n3[0],
        height: n3[1],
        depth: n3[2],
        dataArray: c,
        preferSizeOverAccuracy: t.renderable.getPreferSizeOverAccuracy()
      }), t._openGLRenderWindow.setGraphicsResourceForObject(c, t.volumeTexture, u), c !== t._scalars && (t._openGLRenderWindow.registerGraphicsResourceUser(c, e12), t._openGLRenderWindow.unregisterGraphicsResourceUser(t._scalars, e12)), t._scalars = c;
    } else
      t.volumeTexture = l.oglObject;
    if (p) {
      s.setUpdatedExtents([]);
      let e13 = a.getDimensions();
      t.volumeTexture.create3DFilterableFromDataArray({
        width: e13[0],
        height: e13[1],
        depth: e13[2],
        dataArray: c,
        updatedExtents: f
      });
    }
    let m = c.getNumberOfComponents(), h = r.getProperty(), g = h.getIndependentComponents(), _ = g ? m : 1, v = g ? 2 * _ : 1, y = [];
    for (let e13 = 0; e13 < _; ++e13)
      y.push(h.getRGBTransferFunction(e13));
    let b = getTransferFunctionsHash(y, g, _), S = h.getRGBTransferFunction(), C = t._openGLRenderWindow.getGraphicsResourceForObject(S);
    if (!C?.oglObject?.getHandle() || C?.hash !== b) {
      let n3 = t.renderable.getColorTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let r2 = n3 * v * 3, a2 = new Uint8ClampedArray(r2);
      if (t.colorTexture = vtkOpenGLTexture$1.newInstance(), t.colorTexture.setOpenGLRenderWindow(t._openGLRenderWindow), S) {
        let e13 = new Float32Array(n3 * 3);
        for (let t2 = 0; t2 < _; t2++) {
          let r3 = h.getRGBTransferFunction(t2), o2 = r3.getRange();
          if (r3.getTable(o2[0], o2[1], n3, e13, 1), g)
            for (let r4 = 0; r4 < n3 * 3; r4++)
              a2[t2 * n3 * 6 + r4] = 255 * e13[r4], a2[t2 * n3 * 6 + r4 + n3 * 3] = 255 * e13[r4];
          else
            for (let r4 = 0; r4 < n3 * 3; r4++)
              a2[t2 * n3 * 6 + r4] = 255 * e13[r4];
        }
        t.colorTexture.resetFormatAndType(), t.colorTexture.create2DFromRaw({
          width: n3,
          height: v,
          numComps: 3,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: a2
        });
      } else {
        for (let e13 = 0; e13 < n3 * 3; ++e13)
          a2[e13] = 255 * e13 / ((n3 - 1) * 3), a2[e13 + 1] = 255 * e13 / ((n3 - 1) * 3), a2[e13 + 2] = 255 * e13 / ((n3 - 1) * 3);
        t.colorTexture.resetFormatAndType(), t.colorTexture.create2DFromRaw({
          width: n3,
          height: 1,
          numComps: 3,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: a2
        });
      }
      S && (t._openGLRenderWindow.setGraphicsResourceForObject(S, t.colorTexture, b), S !== t._colorTransferFunc && (t._openGLRenderWindow.registerGraphicsResourceUser(S, e12), t._openGLRenderWindow.unregisterGraphicsResourceUser(t._colorTransferFunc, e12)), t._colorTransferFunc = S);
    } else
      t.colorTexture = C.oglObject;
    let w = [];
    for (let e13 = 0; e13 < _; ++e13)
      w.push(h.getPiecewiseFunction(e13));
    let T = getTransferFunctionsHash(w, g, _), E = h.getPiecewiseFunction(), D = t._openGLRenderWindow.getGraphicsResourceForObject(E);
    if (!D?.oglObject?.getHandle() || D?.hash !== T) {
      let n3 = t.renderable.getOpacityTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let r2 = n3 * v, a2 = new Uint8ClampedArray(r2);
      if (t.pwfTexture = vtkOpenGLTexture$1.newInstance(), t.pwfTexture.setOpenGLRenderWindow(t._openGLRenderWindow), E) {
        let e13 = new Float32Array(r2), a3 = new Float32Array(n3);
        for (let t2 = 0; t2 < _; ++t2) {
          let r3 = h.getPiecewiseFunction(t2);
          if (r3 === null)
            e13.fill(1);
          else {
            let o2 = r3.getRange();
            if (r3.getTable(o2[0], o2[1], n3, a3, 1), g)
              for (let r4 = 0; r4 < n3; r4++)
                e13[t2 * n3 * 2 + r4] = a3[r4], e13[t2 * n3 * 2 + r4 + n3] = a3[r4];
            else
              for (let r4 = 0; r4 < n3; r4++)
                e13[t2 * n3 * 2 + r4] = a3[r4];
          }
        }
        t.pwfTexture.resetFormatAndType(), t.pwfTexture.create2DFromRaw({
          width: n3,
          height: v,
          numComps: 1,
          dataType: VtkDataTypes.FLOAT,
          data: e13
        });
      } else
        a2.fill(255), t.pwfTexture.resetFormatAndType(), t.pwfTexture.create2DFromRaw({
          width: n3,
          height: 1,
          numComps: 1,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: a2
        });
      E && (t._openGLRenderWindow.setGraphicsResourceForObject(E, t.pwfTexture, T), E !== t._pwFunc && (t._openGLRenderWindow.registerGraphicsResourceUser(E, e12), t._openGLRenderWindow.unregisterGraphicsResourceUser(t._pwFunc, e12)), t._pwFunc = E);
    } else
      t.pwfTexture = D.oglObject;
    if (t.VBOBuildTime.getMTime() < t.renderable.getMTime() || t.VBOBuildTime.getMTime() < o.getMTime()) {
      let e13 = o.getNumberOfPoints(), n3 = e13 <= 1 ? 0 : e13 - 1, r2 = o.getDistancesToFirstPoint(), a2 = t.renderable.getHeight(), s2 = 4 * n3, c2 = new Float32Array(3 * s2), l2 = t.renderable.getWidth();
      for (let e14 = 0, t2 = 0; e14 < n3; ++e14)
        c2.set([
          0,
          a2 - r2[e14],
          0
        ], t2), t2 += 3, c2.set([
          l2,
          a2 - r2[e14],
          0
        ], t2), t2 += 3, c2.set([
          l2,
          a2 - r2[e14 + 1],
          0
        ], t2), t2 += 3, c2.set([
          0,
          a2 - r2[e14 + 1],
          0
        ], t2), t2 += 3;
      let u2 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        values: c2
      });
      u2.setName("points");
      let d2 = new Uint16Array(5 * n3);
      for (let e14 = 0, t2 = 0, r3 = 0; e14 < n3; ++e14)
        d2.set([
          4,
          r3 + 3,
          r3 + 2,
          r3 + 1,
          r3
        ], t2), t2 += 5, r3 += 4;
      let f2 = vtkDataArray$1.newInstance({
        numberOfComponents: 1,
        values: d2
      }), p2 = o.getPoints(), m2 = new Float32Array(3 * s2), h2 = [
        ,
        ,
        ,
      ], g2 = [
        ,
        ,
        ,
      ];
      for (let e14 = 0, t2 = 0; e14 < n3; ++e14)
        p2.getPoint(e14, h2), p2.getPoint(e14 + 1, g2), m2.set(h2, t2), t2 += 3, m2.set(h2, t2), t2 += 3, m2.set(g2, t2), t2 += 3, m2.set(g2, t2), t2 += 3;
      let _2 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        values: m2,
        name: "centerlinePosition"
      }), v2 = new Float32Array(s2);
      for (let e14 = 0, t2 = 0; e14 < n3; ++e14)
        v2.set([
          0,
          1,
          3,
          2
        ], t2), t2 += 4;
      let y2 = [_2, vtkDataArray$1.newInstance({
        numberOfComponents: 1,
        values: v2,
        name: "quadIndex"
      })];
      if (!t.renderable.getUseUniformOrientation()) {
        let e14 = t.renderable.getOrientedCenterline().getOrientations() ?? [], r3 = new Float32Array(4 * s2), a3 = new Float32Array(4 * s2);
        for (let t2 = 0; t2 < n3; ++t2) {
          let n4 = e14[t2], o3 = e14[t2 + 1];
          for (let e15 = 0; e15 < 4; ++e15) {
            let s3 = 4 * (e15 + 4 * t2);
            r3.set(n4, s3), a3.set(o3, s3);
          }
        }
        let o2 = vtkDataArray$1.newInstance({
          numberOfComponents: 4,
          values: r3,
          name: "centerlineTopOrientation"
        }), c3 = vtkDataArray$1.newInstance({
          numberOfComponents: 4,
          values: a3,
          name: "centerlineBotOrientation"
        });
        y2.push(o2, c3);
      }
      t.tris.getCABO().createVBO(f2, "polys", Representation$1.SURFACE, {
        points: u2,
        customAttributes: y2
      }), t.VBOBuildTime.modified();
    }
  }, e12.getNeedToRebuildShaders = (e13, n2, r) => {
    let a = t.volumeTexture.getComponents(), o = r.getProperty().getIndependentComponents(), s = !!t.renderable.getCenterPoint(), c = t.renderable.getUseUniformOrientation(), l = t.renderable.isProjectionEnabled() && t.renderable.getProjectionMode();
    return e13.getProgram() === 0 || t.lastUseCenterPoint !== s || t.lastUseUniformOrientation !== c || t.lastProjectionMode !== l || t.lastHaveSeenDepthRequest !== t.haveSeenDepthRequest || t.lastTextureComponents !== a || t.lastIndependentComponents !== o ? (t.lastUseCenterPoint = s, t.lastUseUniformOrientation = c, t.lastProjectionMode = l, t.lastHaveSeenDepthRequest = t.haveSeenDepthRequest, t.lastTextureComponents = a, t.lastIndependentComponents = o, true) : false;
  }, e12.buildShaders = (t2, n2, r) => {
    e12.getShaderTemplate(t2, n2, r), e12.replaceShaderValues(t2, n2, r);
  }, e12.replaceShaderValues = (n2, r, a) => {
    let o = n2.Vertex, s = n2.Fragment, c = [
      "vec3 applyQuaternionToVec(vec4 q, vec3 v) {",
      "  float uvx = q.y * v.z - q.z * v.y;",
      "  float uvy = q.z * v.x - q.x * v.z;",
      "  float uvz = q.x * v.y - q.y * v.x;",
      "  float uuvx = q.y * uvz - q.z * uvy;",
      "  float uuvy = q.z * uvx - q.x * uvz;",
      "  float uuvz = q.x * uvy - q.y * uvx;",
      "  float w2 = q.w * 2.0;",
      "  uvx *= w2;",
      "  uvy *= w2;",
      "  uvz *= w2;",
      "  uuvx *= 2.0;",
      "  uuvy *= 2.0;",
      "  uuvz *= 2.0;",
      "  return vec3(v.x + uvx + uuvx, v.y + uvy + uuvy, v.z + uvz + uuvz);",
      "}"
    ];
    o = vtkShaderProgram$1.substitute(o, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::PositionVC::Impl", ["  gl_Position = MCPCMatrix * vertexMC;"]).result;
    let l = [
      "attribute vec3 centerlinePosition;",
      "attribute float quadIndex;",
      "uniform float width;",
      "out vec2 quadOffsetVSOutput;",
      "out vec3 centerlinePosVSOutput;"
    ], u = t.renderable.isProjectionEnabled(), d = t.renderable.getUseUniformOrientation();
    d ? (l.push("out vec3 samplingDirVSOutput;", "uniform vec4 centerlineOrientation;", "uniform vec3 tangentDirection;", ...c), u && l.push("out vec3 projectionDirVSOutput;", "uniform vec3 bitangentDirection;")) : l.push("out vec4 centerlineTopOrientationVSOutput;", "out vec4 centerlineBotOrientationVSOutput;", "attribute vec4 centerlineTopOrientation;", "attribute vec4 centerlineBotOrientation;"), o = vtkShaderProgram$1.substitute(o, "//VTK::Color::Dec", l).result;
    let f = ["quadOffsetVSOutput = vec2(width * (mod(quadIndex, 2.0) == 0.0 ? -0.5 : 0.5), quadIndex > 1.0 ? 0.0 : 1.0);", "centerlinePosVSOutput = centerlinePosition;"];
    d ? (f.push("samplingDirVSOutput = applyQuaternionToVec(centerlineOrientation, tangentDirection);"), u && f.push("projectionDirVSOutput = applyQuaternionToVec(centerlineOrientation, bitangentDirection);")) : f.push("centerlineTopOrientationVSOutput = centerlineTopOrientation;", "centerlineBotOrientationVSOutput = centerlineBotOrientation;"), o = vtkShaderProgram$1.substitute(o, "//VTK::Color::Impl", f).result;
    let p = t.volumeTexture.getComponents(), m = a.getProperty().getIndependentComponents(), h = [
      "uniform mat4 MCTCMatrix; // Model coordinates to texture coordinates",
      "in vec2 quadOffsetVSOutput;",
      "in vec3 centerlinePosVSOutput;",
      "uniform highp sampler3D volumeTexture;",
      "uniform sampler2D colorTexture1;",
      "uniform sampler2D pwfTexture1;",
      "uniform float opacity;",
      "uniform vec4 backgroundColor;",
      "uniform float cshift0;",
      "uniform float cscale0;",
      "uniform float pwfshift0;",
      "uniform float pwfscale0;"
    ];
    u && h.push("uniform vec3 volumeSizeMC;", "uniform int projectionSlabNumberOfSamples;", "uniform float projectionConstantOffset;", "uniform float projectionStepLength;"), d ? (h.push("in vec3 samplingDirVSOutput;"), u && h.push("in vec3 projectionDirVSOutput;")) : (h.push("uniform vec3 tangentDirection;", "in vec4 centerlineTopOrientationVSOutput;", "in vec4 centerlineBotOrientationVSOutput;", ...c), u && h.push("uniform vec3 bitangentDirection;"));
    let g = t.renderable.getCenterPoint();
    if (g && h.push("uniform vec3 globalCenterPoint;"), m) {
      for (let e13 = 1; e13 < p; e13++)
        h = h.concat([
          `uniform float cshift${e13};`,
          `uniform float cscale${e13};`,
          `uniform float pwfshift${e13};`,
          `uniform float pwfscale${e13};`
        ]);
      switch (p) {
        case 1:
          h = h.concat(["uniform float mix0;", "#define height0 0.5"]);
          break;
        case 2:
          h = h.concat([
            "uniform float mix0;",
            "uniform float mix1;",
            "#define height0 0.25",
            "#define height1 0.75"
          ]);
          break;
        case 3:
          h = h.concat([
            "uniform float mix0;",
            "uniform float mix1;",
            "uniform float mix2;",
            "#define height0 0.17",
            "#define height1 0.5",
            "#define height2 0.83"
          ]);
          break;
        case 4:
          h = h.concat([
            "uniform float mix0;",
            "uniform float mix1;",
            "uniform float mix2;",
            "uniform float mix3;",
            "#define height0 0.125",
            "#define height1 0.375",
            "#define height2 0.625",
            "#define height3 0.875"
          ]);
          break;
        default:
          vtkErrorMacro$24("Unsupported number of independent coordinates.");
      }
    }
    s = vtkShaderProgram$1.substitute(s, "//VTK::TCoord::Dec", h).result;
    let _ = [];
    if (d ? (_.push("vec3 samplingDirection = samplingDirVSOutput;"), u && _.push("vec3 projectionDirection = projectionDirVSOutput;")) : (_.push("vec4 q0 = centerlineBotOrientationVSOutput;", "vec4 q1 = centerlineTopOrientationVSOutput;", "float qCosAngle = dot(q0, q1);", "vec4 interpolatedOrientation;", "if (qCosAngle > 0.999 || qCosAngle < -0.999) {", "  // Use LERP instead of SLERP when the two quaternions are close or opposite", "  interpolatedOrientation = normalize(mix(q0, q1, quadOffsetVSOutput.y));", "} else {", "  float omega = acos(qCosAngle);", "  interpolatedOrientation = normalize(sin((1.0 - quadOffsetVSOutput.y) * omega) * q0 + sin(quadOffsetVSOutput.y * omega) * q1);", "}", "vec3 samplingDirection = applyQuaternionToVec(interpolatedOrientation, tangentDirection);"), u && _.push("vec3 projectionDirection = applyQuaternionToVec(interpolatedOrientation, bitangentDirection);")), g ? _.push("float baseOffset = dot(samplingDirection, globalCenterPoint - centerlinePosVSOutput);", "float horizontalOffset = quadOffsetVSOutput.x + baseOffset;") : _.push("float horizontalOffset = quadOffsetVSOutput.x;"), _.push("vec3 volumePosMC = centerlinePosVSOutput + horizontalOffset * samplingDirection;", "vec3 volumePosTC = (MCTCMatrix * vec4(volumePosMC, 1.0)).xyz;", "if (any(lessThan(volumePosTC, vec3(0.0))) || any(greaterThan(volumePosTC, vec3(1.0))))", "{", "  // set the background color and exit", "  gl_FragData[0] = backgroundColor;", "  return;", "}"), u) {
      let e13 = t.renderable.getProjectionMode();
      switch (e13) {
        case ProjectionMode.MIN:
          _.push("const vec4 initialProjectionTextureValue = vec4(1.0);");
          break;
        case ProjectionMode.MAX:
        case ProjectionMode.AVERAGE:
        default:
          _.push("const vec4 initialProjectionTextureValue = vec4(0.0);");
          break;
      }
      switch (_.push("vec3 projectionScaledDirection = projectionDirection / volumeSizeMC;", "vec3 projectionStep = projectionStepLength * projectionScaledDirection;", "vec3 projectionStartPosition = volumePosTC + projectionConstantOffset * projectionScaledDirection;", "vec4 tvalue = initialProjectionTextureValue;", "for (int projectionSampleIdx = 0; projectionSampleIdx < projectionSlabNumberOfSamples; ++projectionSampleIdx) {", "  vec3 projectionSamplePosition = projectionStartPosition + float(projectionSampleIdx) * projectionStep;", "  vec4 sampledTextureValue = texture(volumeTexture, projectionSamplePosition);"), e13) {
        case ProjectionMode.MAX:
          _.push("  tvalue = max(tvalue, sampledTextureValue);");
          break;
        case ProjectionMode.MIN:
          _.push("  tvalue = min(tvalue, sampledTextureValue);");
          break;
        case ProjectionMode.AVERAGE:
        default:
          _.push("  tvalue = tvalue + sampledTextureValue;");
          break;
      }
      _.push("}"), e13 === ProjectionMode.AVERAGE && _.push("tvalue = tvalue / float(projectionSlabNumberOfSamples);");
    } else
      _.push("vec4 tvalue = texture(volumeTexture, volumePosTC);");
    if (m) {
      let e13 = [
        "r",
        "g",
        "b",
        "a"
      ];
      for (let t2 = 0; t2 < p; ++t2)
        _ = _.concat([`vec3 tcolor${t2} = mix${t2} * texture2D(colorTexture1, vec2(tvalue.${e13[t2]} * cscale${t2} + cshift${t2}, height${t2})).rgb;`, `float compWeight${t2} = mix${t2} * texture2D(pwfTexture1, vec2(tvalue.${e13[t2]} * pwfscale${t2} + pwfshift${t2}, height${t2})).r;`]);
      switch (p) {
        case 1:
          _ = _.concat(["gl_FragData[0] = vec4(tcolor0.rgb, compWeight0 * opacity);"]);
          break;
        case 2:
          _ = _.concat(["float weightSum = compWeight0 + compWeight1;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum))), opacity);"]);
          break;
        case 3:
          _ = _.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum))), opacity);"]);
          break;
        case 4:
          _ = _.concat(["float weightSum = compWeight0 + compWeight1 + compWeight2 + compWeight3;", "gl_FragData[0] = vec4(vec3((tcolor0.rgb * (compWeight0 / weightSum)) + (tcolor1.rgb * (compWeight1 / weightSum)) + (tcolor2.rgb * (compWeight2 / weightSum)) + (tcolor3.rgb * (compWeight3 / weightSum))), opacity);"]);
          break;
        default:
          vtkErrorMacro$24("Unsupported number of independent coordinates.");
      }
    } else
      switch (p) {
        case 1:
          _ = _.concat([
            "// Dependent components",
            "float intensity = tvalue.r;",
            "vec3 tcolor = texture2D(colorTexture1, vec2(intensity * cscale0 + cshift0, 0.5)).rgb;",
            "float scalarOpacity = texture2D(pwfTexture1, vec2(intensity * pwfscale0 + pwfshift0, 0.5)).r;",
            "gl_FragData[0] = vec4(tcolor, scalarOpacity * opacity);"
          ]);
          break;
        case 2:
          _ = _.concat(["float intensity = tvalue.r*cscale0 + cshift0;", "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(intensity, 0.5)).rgb, pwfscale0*tvalue.g + pwfshift0);"]);
          break;
        case 3:
          _ = _.concat([
            "vec4 tcolor = cscale0*tvalue + cshift0;",
            "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, opacity);"
          ]);
          break;
        default:
          _ = _.concat([
            "vec4 tcolor = cscale0*tvalue + cshift0;",
            "gl_FragData[0] = vec4(texture2D(colorTexture1, vec2(tcolor.r,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.g,0.5)).r,",
            "  texture2D(colorTexture1, vec2(tcolor.b,0.5)).r, tcolor.a);"
          ]);
      }
    s = vtkShaderProgram$1.substitute(s, "//VTK::TCoord::Impl", _).result, t.haveSeenDepthRequest && (s = vtkShaderProgram$1.substitute(s, "//VTK::ZBuffer::Dec", "uniform int depthRequest;").result, s = vtkShaderProgram$1.substitute(s, "//VTK::ZBuffer::Impl", [
      "if (depthRequest == 1) {",
      "float iz = floor(gl_FragCoord.z*65535.0 + 0.1);",
      "float rf = floor(iz/256.0)/255.0;",
      "float gf = mod(iz,256.0)/255.0;",
      "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"
    ]).result), n2.Vertex = o, n2.Fragment = s, e12.replaceShaderClip(n2, r, a), e12.replaceShaderCoincidentOffset(n2, r, a);
  }, e12.replaceShaderClip = (e13, n2, r) => {
    let a = e13.Vertex, o = e13.Fragment;
    if (t.renderable.getNumberOfClippingPlanes()) {
      let e14 = t.renderable.getNumberOfClippingPlanes();
      e14 > 6 && (macro.vtkErrorMacro("OpenGL has a limit of 6 clipping planes"), e14 = 6), a = vtkShaderProgram$1.substitute(a, "//VTK::Clip::Dec", [
        "uniform int numClipPlanes;",
        "uniform vec4 clipPlanes[6];",
        "varying float clipDistancesVSOutput[6];"
      ]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::Clip::Impl", [
        "for (int planeNum = 0; planeNum < 6; planeNum++)",
        "    {",
        "    if (planeNum >= numClipPlanes)",
        "        {",
        "        break;",
        "        }",
        "    clipDistancesVSOutput[planeNum] = dot(clipPlanes[planeNum], vertexMC);",
        "    }"
      ]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", "varying float clipDistancesVSOutput[6];"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Clip::Impl", [
        "for (int planeNum = 0; planeNum < 6; planeNum++)",
        "    {",
        "    if (planeNum >= numClipPlanes)",
        "        {",
        "        break;",
        "        }",
        "    if (clipDistancesVSOutput[planeNum] < 0.0) discard;",
        "    }"
      ]).result;
    }
    e13.Vertex = a, e13.Fragment = o;
  }, e12.getShaderTemplate = (e13, t2, n2) => {
    e13.Vertex = vtkPolyDataVS, e13.Fragment = vtkPolyDataFS, e13.Geometry = "";
  }, e12.setMapperShaderParameters = (n2, r, a) => {
    let o = n2.getProgram(), s = n2.getCABO();
    s.getElementCount() && (t.VBOBuildTime.getMTime() > n2.getAttributeUpdateTime().getMTime() || n2.getShaderSourceTime().getMTime() > n2.getAttributeUpdateTime().getMTime()) && (o.isAttributeUsed("vertexMC") && (n2.getVAO().addAttributeArray(o, s, "vertexMC", s.getVertexOffset(), s.getStride(), t.context.FLOAT, 3, t.context.FALSE) || vtkErrorMacro$24("Error setting vertexMC in shader VAO.")), n2.getCABO().getCustomData().forEach((e13) => {
      e13 && o.isAttributeUsed(e13.name) && !n2.getVAO().addAttributeArray(o, s, e13.name, e13.offset, s.getStride(), t.context.FLOAT, e13.components, t.context.FALSE) && vtkErrorMacro$24(`Error setting ${e13.name} in shader VAO.`);
    }), n2.getAttributeUpdateTime().modified());
    let c = t.volumeTexture.getTextureUnit();
    if (o.setUniformi("volumeTexture", c), o.setUniformf("width", t.renderable.getWidth()), n2.getProgram().setUniform4fv("backgroundColor", t.renderable.getBackgroundColor()), o.isUniformUsed("tangentDirection")) {
      let e13 = t.renderable.getTangentDirection();
      n2.getProgram().setUniform3fArray("tangentDirection", e13);
    }
    if (o.isUniformUsed("bitangentDirection")) {
      let e13 = t.renderable.getBitangentDirection();
      n2.getProgram().setUniform3fArray("bitangentDirection", e13);
    }
    if (o.isUniformUsed("centerlineOrientation")) {
      let e13 = t.renderable.getUniformOrientation();
      n2.getProgram().setUniform4fv("centerlineOrientation", e13);
    }
    if (o.isUniformUsed("globalCenterPoint")) {
      let e13 = t.renderable.getCenterPoint();
      o.setUniform3fArray("globalCenterPoint", e13);
    }
    if (t.renderable.isProjectionEnabled()) {
      let e13 = t.currentImageDataInput, n3 = e13.getSpacing(), r2 = e13.getDimensions(), a2 = t.renderable.getProjectionSlabThickness(), s2 = t.renderable.getProjectionSlabNumberOfSamples(), c2 = mul([], n3, r2);
      o.setUniform3fArray("volumeSizeMC", c2), o.setUniformi("projectionSlabNumberOfSamples", s2);
      let l2 = -0.5 * a2;
      o.setUniformf("projectionConstantOffset", l2);
      let u2 = a2 / (s2 - 1);
      o.setUniformf("projectionStepLength", u2);
    }
    let l = t.currentImageDataInput, u = l.getWorldToIndex(), d = fromScaling(new Float32Array(16), inverse([], l.getDimensions())), f = mul$1(d, d, u);
    if (o.setUniformMatrix("MCTCMatrix", f), t.haveSeenDepthRequest && n2.getProgram().setUniformi("depthRequest", t.renderDepth ? 1 : 0), t.renderable.getNumberOfClippingPlanes()) {
      let e13 = t.renderable.getNumberOfClippingPlanes();
      e13 > 6 && (macro.vtkErrorMacro("OpenGL has a limit of 6 clipping planes"), e13 = 6);
      let n3 = s.getCoordShiftAndScaleEnabled() ? s.getInverseShiftAndScaleMatrix() : null, r2 = n3 ? copy$4(t.imagematinv, a.getMatrix()) : a.getMatrix();
      n3 && (transpose(r2, r2), multiply$2(r2, r2, n3), transpose(r2, r2)), transpose(t.imagemat, t.currentImageDataInput.getIndexToWorld()), multiply$2(t.imagematinv, r2, t.imagemat);
      let c2 = [];
      for (let n4 = 0; n4 < e13; n4++) {
        let e14 = [];
        t.renderable.getClippingPlaneInDataCoords(t.imagematinv, n4, e14);
        for (let t2 = 0; t2 < 4; t2++)
          c2.push(e14[t2]);
      }
      o.setUniformi("numClipPlanes", e13), o.setUniform4fv("clipPlanes", c2);
    }
    if (o.isUniformUsed("coffset")) {
      let t2 = e12.getCoincidentParameters(r, a);
      o.setUniformf("coffset", t2.offset), o.isUniformUsed("cfactor") && o.setUniformf("cfactor", t2.factor);
    }
  }, e12.setCameraShaderParameters = (e13, n2, r) => {
    let a = t.openGLImageSlice.getKeyMatrices().mcwc, o = t.openGLCamera.getKeyMatrices(n2).wcpc;
    if (multiply$2(t.imagemat, o, a), e13.getCABO().getCoordShiftAndScaleEnabled()) {
      let n3 = e13.getCABO().getInverseShiftAndScaleMatrix();
      multiply$2(t.imagemat, t.imagemat, n3);
    }
    e13.getProgram().setUniformMatrix("MCPCMatrix", t.imagemat);
  }, e12.setPropertyShaderParameters = (e13, n2, r) => {
    let a = e13.getProgram(), o = r.getProperty(), s = o.getOpacity();
    a.setUniformf("opacity", s);
    let c = t.volumeTexture.getComponents(), l = o.getIndependentComponents();
    if (l)
      for (let e14 = 0; e14 < c; ++e14)
        a.setUniformf(`mix${e14}`, o.getComponentWeight(e14));
    let u = t.volumeTexture.getVolumeInfo();
    for (let e14 = 0; e14 < c; e14++) {
      let t2 = o.getColorWindow(), n3 = o.getColorLevel(), r2 = l ? e14 : 0, s2 = o.getRGBTransferFunction(r2);
      if (s2 && o.getUseLookupTableScalarRange()) {
        let e15 = s2.getRange();
        t2 = e15[1] - e15[0], n3 = 0.5 * (e15[1] + e15[0]);
      }
      let c2 = u.scale[e14] / t2, d2 = (u.offset[e14] - n3) / t2 + 0.5;
      a.setUniformf(`cshift${e14}`, d2), a.setUniformf(`cscale${e14}`, c2);
    }
    let d = t.colorTexture.getTextureUnit();
    a.setUniformi("colorTexture1", d);
    for (let e14 = 0; e14 < c; e14++) {
      let t2 = 1, n3 = 0, r2 = l ? e14 : 0, s2 = o.getPiecewiseFunction(r2);
      if (s2) {
        let r3 = s2.getRange(), a2 = r3[1] - r3[0], o2 = 0.5 * (r3[0] + r3[1]);
        t2 = u.scale[e14] / a2, n3 = (u.offset[e14] - o2) / a2 + 0.5;
      }
      a.setUniformf(`pwfshift${e14}`, n3), a.setUniformf(`pwfscale${e14}`, t2);
    }
    let f = t.pwfTexture.getTextureUnit();
    a.setUniformi("pwfTexture1", f);
  }, e12.updateShaders = (n2, r, a) => {
    if (e12.getNeedToRebuildShaders(n2, r, a)) {
      let o = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      e12.buildShaders(o, r, a);
      let s = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(o.Vertex, o.Fragment, o.Geometry);
      s !== n2.getProgram() && (n2.setProgram(s), n2.getVAO().releaseGraphicsResources()), n2.getShaderSourceTime().modified();
    } else
      t._openGLRenderWindow.getShaderCache().readyShaderProgram(n2.getProgram());
    n2.getVAO().bind(), e12.setMapperShaderParameters(n2, r, a), e12.setCameraShaderParameters(n2, r, a), e12.setPropertyShaderParameters(n2, r, a);
  }, e12.delete = macro.chain(() => {
    t._openGLRenderWindow && n(t._openGLRenderWindow);
  }, e12.delete);
}
var DEFAULT_VALUES$86 = {
  currentRenderPass: null,
  volumeTexture: null,
  colorTexture: null,
  pwfTexture: null,
  tris: null,
  lastHaveSeenDepthRequest: false,
  haveSeenDepthRequest: false,
  lastTextureComponents: 0,
  lastIndependentComponents: 0,
  imagemat: null,
  imagematinv: null
};
function extend$95(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$86, n), vtkViewNode$1.extend(e12, t, n), vtkReplacementShaderMapper.implementReplaceShaderCoincidentOffset(e12, t, n), macro.algo(e12, t, 2, 0), t.tris = vtkHelper.newInstance(), t.volumeTexture = null, t.colorTexture = null, t.pwfTexture = null, t.imagemat = identity$2(new Float64Array(16)), t.imagematinv = identity$2(new Float64Array(16)), t.VBOBuildTime = {}, macro.obj(t.VBOBuildTime, { mtime: 0 }), vtkOpenGLImageCPRMapper(e12, t);
}
var newInstance$90 = macro.newInstance(extend$95, "vtkOpenGLImageCPRMapper"), index = {
  newInstance: newInstance$90,
  extend: extend$95
};
registerOverride$1("vtkImageCPRMapper", newInstance$90);
function vtkOpenGLImageSlice(e12, t) {
  t.classHierarchy.push("vtkOpenGLImageSlice"), e12.buildPass = (n) => {
    if (!(!t.renderable || !t.renderable.getVisibility()) && n) {
      if (!t.renderable)
        return;
      t._openGLRenderWindow = e12.getLastAncestorOfType("vtkOpenGLRenderWindow"), t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t.context = t._openGLRenderWindow.getContext(), e12.prepareNodes(), e12.addMissingNode(t.renderable.getMapper()), e12.removeUnusedNodes();
    }
  }, e12.traverseZBufferPass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children.forEach((e13) => {
      e13.traverse(n);
    }), e12.apply(n, false));
  }, e12.traverseOpaqueZBufferPass = (t2) => e12.traverseOpaquePass(t2), e12.traverseOpaquePass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children.forEach((e13) => {
      e13.traverse(n);
    }), e12.apply(n, false));
  }, e12.traverseTranslucentPass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children.forEach((e13) => {
      e13.traverse(n);
    }), e12.apply(n, false));
  }, e12.queryPass = (e13, n) => {
    if (e13) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, e12.zBufferPass = (t2, n) => e12.opaquePass(t2, n), e12.opaqueZBufferPass = (t2, n) => e12.opaquePass(t2, n), e12.opaquePass = (e13, n) => {
    e13 && t.context.depthMask(true);
  }, e12.translucentPass = (e13, n) => {
    t.context.depthMask(!e13);
  }, e12.getKeyMatrices = () => (t.renderable.getMTime() > t.keyMatrixTime.getMTime() && (copy$4(t.keyMatrices.mcwc, t.renderable.getMatrix()), transpose(t.keyMatrices.mcwc, t.keyMatrices.mcwc), t.keyMatrixTime.modified()), t.keyMatrices);
}
var DEFAULT_VALUES$85 = {
  context: null,
  keyMatrixTime: null,
  keyMatrices: null
};
function extend$94(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$85, n), vtkViewNode$1.extend(e12, t, n), t.keyMatrixTime = {}, obj(t.keyMatrixTime, { mtime: 0 }), t.keyMatrices = { mcwc: identity$2(new Float64Array(16)) }, setGet(e12, t, ["context"]), vtkOpenGLImageSlice(e12, t);
}
var newInstance$89 = newInstance(extend$94, "vtkOpenGLImageSlice"), vtkImageSlice$2 = {
  newInstance: newInstance$89,
  extend: extend$94
};
registerOverride$1("vtkImageSlice", newInstance$89);
function vtkOpenGLVolume(e12, t) {
  t.classHierarchy.push("vtkOpenGLVolume"), e12.buildPass = (n) => {
    !t.renderable || !t.renderable.getVisibility() || n && (t._openGLRenderWindow = e12.getLastAncestorOfType("vtkOpenGLRenderWindow"), t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t.context = t._openGLRenderWindow.getContext(), e12.prepareNodes(), e12.addMissingNode(t.renderable.getMapper()), e12.removeUnusedNodes());
  }, e12.queryPass = (e13, n) => {
    if (e13) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      n.incrementVolumeCount();
    }
  }, e12.traverseVolumePass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children[0].traverse(n), e12.apply(n, false));
  }, e12.volumePass = (e13) => {
    !t.renderable || !t.renderable.getVisibility() || t.context.depthMask(!e13);
  }, e12.getKeyMatrices = () => (t.renderable.getMTime() > t.keyMatrixTime.getMTime() && (t.renderable.computeMatrix(), copy$4(t.MCWCMatrix, t.renderable.getMatrix()), transpose(t.MCWCMatrix, t.MCWCMatrix), t.renderable.getIsIdentity() ? identity$3(t.normalMatrix) : (fromMat4(t.normalMatrix, t.MCWCMatrix), invert$1(t.normalMatrix, t.normalMatrix), transpose$1(t.normalMatrix, t.normalMatrix)), t.keyMatrixTime.modified()), {
    mcwc: t.MCWCMatrix,
    normalMatrix: t.normalMatrix
  });
}
var DEFAULT_VALUES$84 = {};
function extend$93(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$84, n), vtkViewNode$1.extend(e12, t, n), t.keyMatrixTime = {}, obj(t.keyMatrixTime, { mtime: 0 }), t.normalMatrix = new Float64Array(9), t.MCWCMatrix = new Float64Array(16), setGet(e12, t, ["context"]), vtkOpenGLVolume(e12, t);
}
var newInstance$88 = newInstance(extend$93, "vtkOpenGLVolume"), vtkVolume = {
  newInstance: newInstance$88,
  extend: extend$93
};
registerOverride$1("vtkVolume", newInstance$88);
function vtkFramebuffer(e12, t) {
  t.classHierarchy.push("vtkFramebuffer"), e12.getBothMode = () => t.context.FRAMEBUFFER, e12.saveCurrentBindingsAndBuffers = (t2) => {
    let n = t2 === void 0 ? e12.getBothMode() : t2;
    e12.saveCurrentBindings(n), e12.saveCurrentBuffers(n);
  }, e12.saveCurrentBindings = (e13) => {
    if (!t.context) {
      vtkErrorMacro("you must set the OpenGLRenderWindow before calling saveCurrentBindings");
      return;
    }
    t.previousDrawBinding = t.context.getParameter(t.context.FRAMEBUFFER_BINDING), t.previousActiveFramebuffer = t._openGLRenderWindow.getActiveFramebuffer();
  }, e12.saveCurrentBuffers = (e13) => {
  }, e12.restorePreviousBindingsAndBuffers = (t2) => {
    let n = t2 === void 0 ? e12.getBothMode() : t2;
    e12.restorePreviousBindings(n), e12.restorePreviousBuffers(n);
  }, e12.restorePreviousBindings = (e13) => {
    if (!t.context) {
      vtkErrorMacro("you must set the OpenGLRenderWindow before calling restorePreviousBindings");
      return;
    }
    let n = t.context;
    n.bindFramebuffer(n.FRAMEBUFFER, t.previousDrawBinding), t._openGLRenderWindow.setActiveFramebuffer(t.previousActiveFramebuffer);
  }, e12.restorePreviousBuffers = (e13) => {
  }, e12.bind = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    n === null && (n = t.context.FRAMEBUFFER), t.context.bindFramebuffer(n, t.glFramebuffer);
    for (let e13 = 0; e13 < t.colorBuffers.length; e13++)
      t.colorBuffers[e13].bind();
    t._openGLRenderWindow.setActiveFramebuffer(e12);
  }, e12.create = (e13, n) => {
    if (!t.context) {
      vtkErrorMacro("you must set the OpenGLRenderWindow before calling create");
      return;
    }
    t.glFramebuffer = t.context.createFramebuffer(), t.glFramebuffer.width = e13, t.glFramebuffer.height = n;
  }, e12.setColorBuffer = function(e13) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = t.context;
    if (!r) {
      vtkErrorMacro("you must set the OpenGLRenderWindow before calling setColorBuffer");
      return;
    }
    let a = r.COLOR_ATTACHMENT0;
    if (n > 0)
      if (t._openGLRenderWindow.getWebgl2())
        a += n;
      else {
        vtkErrorMacro("Using multiple framebuffer attachments requires WebGL 2");
        return;
      }
    t.colorBuffers[n] = e13, r.framebufferTexture2D(r.FRAMEBUFFER, a, r.TEXTURE_2D, e13.getHandle(), 0);
  }, e12.removeColorBuffer = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = t.context;
    if (!n) {
      vtkErrorMacro("you must set the OpenGLRenderWindow before calling removeColorBuffer");
      return;
    }
    let r = n.COLOR_ATTACHMENT0;
    if (e13 > 0)
      if (t._openGLRenderWindow.getWebgl2())
        r += e13;
      else {
        vtkErrorMacro("Using multiple framebuffer attachments requires WebGL 2");
        return;
      }
    n.framebufferTexture2D(n.FRAMEBUFFER, r, n.TEXTURE_2D, null, 0), t.colorBuffers = t.colorBuffers.splice(e13, 1);
  }, e12.setDepthBuffer = (e13) => {
    if (!t.context) {
      vtkErrorMacro("you must set the OpenGLRenderWindow before calling setDepthBuffer");
      return;
    }
    if (t._openGLRenderWindow.getWebgl2()) {
      let n = t.context;
      n.framebufferTexture2D(n.FRAMEBUFFER, n.DEPTH_ATTACHMENT, n.TEXTURE_2D, e13.getHandle(), 0);
    } else
      vtkErrorMacro("Attaching depth buffer textures to fbo requires WebGL 2");
  }, e12.removeDepthBuffer = () => {
    if (!t.context) {
      vtkErrorMacro("you must set the OpenGLRenderWindow before calling removeDepthBuffer");
      return;
    }
    if (t._openGLRenderWindow.getWebgl2()) {
      let e13 = t.context;
      e13.framebufferTexture2D(e13.FRAMEBUFFER, e13.DEPTH_ATTACHMENT, e13.TEXTURE_2D, null, 0);
    } else
      vtkErrorMacro("Attaching depth buffer textures to framebuffers requires WebGL 2");
  }, e12.getGLFramebuffer = () => t.glFramebuffer, e12.setOpenGLRenderWindow = (n) => {
    t._openGLRenderWindow !== n && (e12.releaseGraphicsResources(), t._openGLRenderWindow = n, t.context = null, n && (t.context = t._openGLRenderWindow.getContext()));
  }, e12.releaseGraphicsResources = () => {
    t.glFramebuffer && t.context.deleteFramebuffer(t.glFramebuffer);
  }, e12.getSize = () => t.glFramebuffer == null ? null : [t.glFramebuffer.width, t.glFramebuffer.height], e12.populateFramebuffer = () => {
    if (!t.context) {
      vtkErrorMacro("you must set the OpenGLRenderWindow before calling populateFrameBuffer");
      return;
    }
    e12.bind();
    let n = t.context, r = vtkOpenGLTexture$1.newInstance();
    r.setOpenGLRenderWindow(t._openGLRenderWindow), r.setMinificationFilter(Filter$1.LINEAR), r.setMagnificationFilter(Filter$1.LINEAR), r.create2DFromRaw({
      width: t.glFramebuffer.width,
      height: t.glFramebuffer.height,
      numComps: 4,
      dataType: VtkDataTypes.UNSIGNED_CHAR,
      data: null
    }), e12.setColorBuffer(r), t.depthTexture = n.createRenderbuffer(), n.bindRenderbuffer(n.RENDERBUFFER, t.depthTexture), n.renderbufferStorage(n.RENDERBUFFER, n.DEPTH_COMPONENT16, t.glFramebuffer.width, t.glFramebuffer.height), n.framebufferRenderbuffer(n.FRAMEBUFFER, n.DEPTH_ATTACHMENT, n.RENDERBUFFER, t.depthTexture);
  }, e12.getColorTexture = () => t.colorBuffers[0];
}
var DEFAULT_VALUES$83 = {
  glFramebuffer: null,
  colorBuffers: null,
  depthTexture: null,
  previousDrawBinding: 0,
  previousReadBinding: 0,
  previousDrawBuffer: 0,
  previousReadBuffer: 0,
  previousActiveFramebuffer: null
};
function extend$92(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$83, n), obj(e12, t), t.colorBuffers && vtkErrorMacro("you cannot initialize colorBuffers through the constructor. You should call setColorBuffer() instead."), t.colorBuffers = [], getArray(e12, t, ["colorBuffers"]), vtkFramebuffer(e12, t);
}
var vtkOpenGLFramebuffer = {
  newInstance: newInstance(extend$92, "vtkFramebuffer"),
  extend: extend$92
}, vtkVolumeVS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkVolumeVS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n\nattribute vec4 vertexDC;\n\nvarying vec3 vertexVCVSOutput;\nuniform mat4 PCVCMatrix;\n\nuniform float dcxmin;\nuniform float dcxmax;\nuniform float dcymin;\nuniform float dcymax;\n\nvoid main()\n{\n  // dcsmall is the device coords reduced to the\n  // x y area covered by the volume\n  vec4 dcsmall = vec4(\n    dcxmin + 0.5 * (vertexDC.x + 1.0) * (dcxmax - dcxmin),\n    dcymin + 0.5 * (vertexDC.y + 1.0) * (dcymax - dcymin),\n    vertexDC.z,\n    vertexDC.w);\n  vec4 vcpos = PCVCMatrix * dcsmall;\n  vertexVCVSOutput = vcpos.xyz/vcpos.w;\n  gl_Position = dcsmall;\n}\n", vtkVolumeFS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkVolumeFS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n// Template for the volume mappers fragment shader\n\nconst float infinity = 3.402823466e38;\n\n// the output of this shader\n//VTK::Output::Dec\n\nin vec3 vertexVCVSOutput;\n\n// From Sources\\Rendering\\Core\\VolumeProperty\\Constants.js\n#define COMPOSITE_BLEND 0\n#define MAXIMUM_INTENSITY_BLEND 1\n#define MINIMUM_INTENSITY_BLEND 2\n#define AVERAGE_INTENSITY_BLEND 3\n#define ADDITIVE_INTENSITY_BLEND 4\n#define RADON_TRANSFORM_BLEND 5\n#define LABELMAP_EDGE_PROJECTION_BLEND 6\n\n#define vtkNumberOfLights //VTK::NumberOfLights\n#define vtkMaxLaoKernelSize //VTK::MaxLaoKernelSize\n#define vtkNumberOfComponents //VTK::NumberOfComponents\n#define vtkBlendMode //VTK::BlendMode\n#define vtkMaximumNumberOfSamples //VTK::MaximumNumberOfSamples\n\n//VTK::EnabledColorFunctions\n\n//VTK::EnabledLightings\n\n//VTK::EnabledMultiTexturePerVolume\n\n//VTK::EnabledGradientOpacity\n\n//VTK::EnabledIndependentComponents\n\n//VTK::vtkProportionalComponents\n\n//VTK::vtkForceNearestComponents\n\nuniform int twoSidedLighting;\n\n#if vtkMaxLaoKernelSize > 0\n  vec2 kernelSample[vtkMaxLaoKernelSize];\n#endif\n\n// Textures\n#ifdef EnabledMultiTexturePerVolume\n  #define vtkNumberOfVolumeTextures vtkNumberOfComponents\n#else\n  #define vtkNumberOfVolumeTextures 1\n#endif\nuniform highp sampler3D volumeTexture[vtkNumberOfVolumeTextures];\nuniform sampler2D colorTexture;\nuniform sampler2D opacityTexture;\nuniform sampler2D jtexture;\nuniform sampler2D labelOutlineThicknessTexture;\n\nstruct Volume {\n  // ---- Volume geometry settings ----\n\n  vec3 originVC;          // in VC\n  vec3 spacing;           // in VC per IC\n  vec3 inverseSpacing;    // 1/spacing\n  ivec3 dimensions;       // in IC\n  vec3 inverseDimensions; // 1/vec3(dimensions)\n  mat3 vecISToVCMatrix;   // convert from IS to VC without translation\n  mat3 vecVCToISMatrix;   // convert from VC to IS without translation\n  mat4 PCWCMatrix;\n  mat4 worldToIndex;\n  float diagonalLength; // in VC, this is: length(size)\n\n  // ---- Texture settings ----\n\n  // Texture shift and scale\n  vec4 colorTextureScale;\n  vec4 colorTextureShift;\n  vec4 opacityTextureScale;\n  vec4 opacityTextureShift;\n\n  // The heights defined below are the locations for the up to four components\n  // of the transfer functions. The transfer functions have a height of (2 *\n  // numberOfComponents) pixels so the values are computed to hit the middle of\n  // the two rows for that component\n  vec4 transferFunctionsSampleHeight;\n\n  // ---- Mode specific settings ----\n\n  // Independent component default preset settings per component\n  vec4 independentComponentMix;\n\n  // Additive / average blending mode settings\n  vec4 ipScalarRangeMin;\n  vec4 ipScalarRangeMax;\n\n  // ---- Rendering settings ----\n\n  // Lighting\n  float ambient;\n  float diffuse;\n  float specular;\n  float specularPower;\n  int computeNormalFromOpacity;\n\n  // Gradient opacity\n  vec4 gradientOpacityScale;\n  vec4 gradientOpacityShift;\n  vec4 gradientOpacityMin;\n  vec4 gradientOpacityMax;\n\n  // Volume shadow\n  float volumetricScatteringBlending;\n  float globalIlluminationReach;\n  float anisotropy;\n  float anisotropySquared;\n\n  // LAO\n  int kernelSize;\n  int kernelRadius;\n\n  // Label outline\n  float outlineOpacity;\n};\nuniform Volume volume;\n\nstruct Light {\n  vec3 color;\n  vec3 positionVC;\n  vec3 directionVC; // normalized\n  vec3 halfAngleVC;\n  vec3 attenuation;\n  float exponent;\n  float coneAngle;\n  int isPositional;\n};\n#if vtkNumberOfLights > 0\n  uniform Light lights[vtkNumberOfLights];\n#endif\n\nuniform float vpWidth;\nuniform float vpHeight;\nuniform float vpOffsetX;\nuniform float vpOffsetY;\n\n// Bitmasks for label outline\nconst int MAX_SEGMENT_INDEX = 256; // Define as per expected maximum\n#define MAX_SEGMENTS 256\n#define UINT_SIZE 32\n// We add UINT_SIZE - 1, as we want the ceil of the division instead of the\n// floor\n#define BITMASK_SIZE ((MAX_SEGMENTS + UINT_SIZE - 1) / UINT_SIZE)\nuint labelOutlineBitmasks[BITMASK_SIZE];\n\n// Set the corresponding bit in the bitmask\nvoid setLabelOutlineBit(int segmentIndex) {\n  int arrayIndex = segmentIndex / UINT_SIZE;\n  int bitIndex = segmentIndex % UINT_SIZE;\n  labelOutlineBitmasks[arrayIndex] |= 1u << bitIndex;\n}\n\n// Check if a bit is set in the bitmask\nbool isLabelOutlineBitSet(int segmentIndex) {\n  int arrayIndex = segmentIndex / UINT_SIZE;\n  int bitIndex = segmentIndex % UINT_SIZE;\n  return ((labelOutlineBitmasks[arrayIndex] & (1u << bitIndex)) != 0u);\n}\n\n// if you want to see the raw tiled\n// data in webgl1 uncomment the following line\n// #define debugtile\n\n// camera values\nuniform float camThick;\nuniform float camNear;\nuniform float camFar;\nuniform int cameraParallel;\n\n//VTK::ClipPlane::Dec\n\n// A random number between 0 and 1 that only depends on the fragment\n// It uses the jtexture, so this random seed repeats by blocks of 32 fragments\n// in screen space\nfloat fragmentSeed;\n\n// sample texture is global\nuniform float sampleDistance;\nuniform float volumeShadowSampleDistance;\n\n// declaration for intermixed geometry\n//VTK::ZBuffer::Dec\n\n//=======================================================================\n// global and custom variables (a temporary section before photorealistics\n// rendering module is complete)\nvec3 rayDirVC;\n\n#define INV4PI 0.0796\n#define EPSILON 0.001\n#define PI 3.1415\n#define PI2 9.8696\n\nvec4 rawSampleTexture(vec3 pos) {\n  #ifdef EnabledMultiTexturePerVolume\n    vec4 rawSample;\n    rawSample[0] = texture(volumeTexture[0], pos)[0];\n  #if vtkNumberOfComponents > 1\n    rawSample[1] = texture(volumeTexture[1], pos)[0];\n  #endif\n  #if vtkNumberOfComponents > 2\n    rawSample[2] = texture(volumeTexture[2], pos)[0];\n  #endif\n  #if vtkNumberOfComponents > 3\n    rawSample[3] = texture(volumeTexture[3], pos)[0];\n  #endif\n    return rawSample;\n  #else\n    return texture(volumeTexture[0], pos);\n  #endif\n}\n\nvec4 rawFetchTexture(ivec3 pos) {\n  #ifdef EnabledMultiTexturePerVolume\n    vec4 rawSample;\n    #if vtkNumberOfComponents > 0\n      rawSample[0] = texelFetch(volumeTexture[0], pos, 0)[0];\n    #endif\n    #if vtkNumberOfComponents > 1\n      rawSample[1] = texelFetch(volumeTexture[1], pos, 0)[0];\n    #endif\n    #if vtkNumberOfComponents > 2\n      rawSample[2] = texelFetch(volumeTexture[2], pos, 0)[0];\n    #endif\n    #if vtkNumberOfComponents > 3\n      rawSample[3] = texelFetch(volumeTexture[3], pos, 0)[0];\n    #endif\n    return rawSample;\n  #else\n    return texelFetch(volumeTexture[0], pos, 0);\n  #endif\n}\n\nvec4 getTextureValue(vec3 pos) {\n  vec4 tmp = rawSampleTexture(pos);\n\n  // Force nearest\n  #if defined(vtkComponent0ForceNearest) || \\\n      defined(vtkComponent1ForceNearest) || \\\n      defined(vtkComponent2ForceNearest) || \\\n      defined(vtkComponent3ForceNearest)\n    vec3 nearestPos = (floor(pos * vec3(volume.dimensions)) + 0.5) *\n                      volume.inverseDimensions;\n    vec4 nearestValue = rawSampleTexture(nearestPos);\n    #ifdef vtkComponent0ForceNearest\n      tmp[0] = nearestValue[0];\n    #endif\n    #ifdef vtkComponent1ForceNearest\n      tmp[1] = nearestValue[1];\n    #endif\n    #ifdef vtkComponent2ForceNearest\n      tmp[2] = nearestValue[2];\n    #endif\n    #ifdef vtkComponent3ForceNearest\n      tmp[3] = nearestValue[3];\n    #endif\n  #endif\n\n  // Set alpha when using dependent components\n  #ifndef EnabledIndependentComponents\n    #if vtkNumberOfComponents == 1\n      tmp.a = tmp.r;\n    #endif\n    #if vtkNumberOfComponents == 2\n      tmp.a = tmp.g;\n    #endif\n    #if vtkNumberOfComponents == 3\n      tmp.a = length(tmp.rgb);\n    #endif\n  #endif\n\n  return tmp;\n}\n\n// `height` is usually `volume.transferFunctionsSampleHeight[component]`\n// when using independent component and `0.5` otherwise. Don't move the if\n// statement in these function, as the callers usually already knows if it is\n// using independent component or not\nfloat getOpacityFromTexture(float scalar, int component, float height) {\n  float scaledScalar = scalar * volume.opacityTextureScale[component] +\n                       volume.opacityTextureShift[component];\n  return texture2D(opacityTexture, vec2(scaledScalar, height)).r;\n}\nvec3 getColorFromTexture(float scalar, int component, float height) {\n  float scaledScalar = scalar * volume.colorTextureScale[component] +\n                       volume.colorTextureShift[component];\n  return texture2D(colorTexture, vec2(scaledScalar, height)).rgb;\n}\n\n//=======================================================================\n// transformation between VC and IS space\n\n// convert vector position from idx to vc\nvec3 posIStoVC(vec3 posIS) {\n  return volume.vecISToVCMatrix * posIS + volume.originVC;\n}\n\n// convert vector position from vc to idx\nvec3 posVCtoIS(vec3 posVC) {\n  return volume.vecVCToISMatrix * (posVC - volume.originVC);\n}\n\n// Rotate vector to view coordinate\nvec3 vecISToVC(vec3 dirIS) {\n  return volume.vecISToVCMatrix * dirIS;\n}\n\n// Rotate vector to idx coordinate\nvec3 vecVCToIS(vec3 dirVC) {\n  return volume.vecVCToISMatrix * dirVC;\n}\n\n//=======================================================================\n// Given a normal compute the gradient opacity factors\nfloat computeGradientOpacityFactor(float normalMag, int component) {\n  float goscale = volume.gradientOpacityScale[component];\n  float goshift = volume.gradientOpacityShift[component];\n  float gomin = volume.gradientOpacityMin[component];\n  float gomax = volume.gradientOpacityMax[component];\n  return clamp(normalMag * goscale + goshift, gomin, gomax);\n}\n\n#ifdef vtkClippingPlanesOn\n  bool isPointClipped(vec3 posVC) {\n    for (int i = 0; i < clip_numPlanes; ++i) {\n      if (dot(vec3(vClipPlaneOrigins[i] - posVC), vClipPlaneNormals[i]) > 0.0) {\n        return true;\n      }\n    }\n    return false;\n  }\n#endif\n\n//=======================================================================\n// compute the normal and gradient magnitude for a position, uses forward\n// difference\n\n// The output normal is in VC\nvec4 computeDensityNormal(vec3 opacityUCoords[2], float opacityTextureHeight,\n                          float gradientOpacity, int component) {\n  // Pass the scalars through the opacity functions\n  vec4 opacityG;\n  opacityG.x += getOpacityFromTexture(opacityUCoords[0].x, component,\n                                      opacityTextureHeight);\n  opacityG.y += getOpacityFromTexture(opacityUCoords[0].y, component,\n                                      opacityTextureHeight);\n  opacityG.z += getOpacityFromTexture(opacityUCoords[0].z, component,\n                                      opacityTextureHeight);\n  opacityG.x -= getOpacityFromTexture(opacityUCoords[1].x, component,\n                                      opacityTextureHeight);\n  opacityG.y -= getOpacityFromTexture(opacityUCoords[1].y, component,\n                                      opacityTextureHeight);\n  opacityG.z -= getOpacityFromTexture(opacityUCoords[1].z, component,\n                                      opacityTextureHeight);\n\n  // Divide by spacing and convert to VC\n  opacityG.xyz *= gradientOpacity * volume.inverseSpacing;\n  opacityG.w = length(opacityG.xyz);\n  if (opacityG.w == 0.0) {\n    return vec4(0.0);\n  }\n\n  // Normalize\n  opacityG.xyz = normalize(vecISToVC(opacityG.xyz));\n\n  return opacityG;\n}\n\n// The output normal is in VC\nvec4 computeNormalForDensity(vec3 posIS, out vec3 scalarInterp[2],\n                             const int opacityComponent) {\n  vec3 offsetedPosIS;\n  for (int axis = 0; axis < 3; ++axis) {\n    // Positive direction\n    offsetedPosIS = posIS;\n    offsetedPosIS[axis] += volume.inverseDimensions[axis];\n    scalarInterp[0][axis] =\n        getTextureValue(offsetedPosIS)[opacityComponent];\n    #ifdef vtkClippingPlanesOn\n      if (isPointClipped(posIStoVC(offsetedPosIS))) {\n        scalarInterp[0][axis] = 0.0;\n      }\n    #endif\n\n    // Negative direction\n    offsetedPosIS = posIS;\n    offsetedPosIS[axis] -= volume.inverseDimensions[axis];\n    scalarInterp[1][axis] =\n        getTextureValue(offsetedPosIS)[opacityComponent];\n    #ifdef vtkClippingPlanesOn\n      if (isPointClipped(posIStoVC(offsetedPosIS))) {\n        scalarInterp[1][axis] = 0.0;\n      }\n    #endif\n  }\n\n  vec4 result;\n  result.xyz = (scalarInterp[0] - scalarInterp[1]) * volume.inverseSpacing;\n  result.w = length(result.xyz);\n  if (result.w == 0.0) {\n    return vec4(0.0);\n  }\n  result.xyz = normalize(vecISToVC(result.xyz));\n  return result;\n}\n\nvec4 fragCoordToPCPos(vec4 fragCoord) {\n  return vec4((fragCoord.x / vpWidth - vpOffsetX - 0.5) * 2.0,\n              (fragCoord.y / vpHeight - vpOffsetY - 0.5) * 2.0,\n              (fragCoord.z - 0.5) * 2.0, 1.0);\n}\n\nvec4 pcPosToWorldCoord(vec4 pcPos) {\n  return volume.PCWCMatrix * pcPos;\n}\n\nvec3 fragCoordToIndexSpace(vec4 fragCoord) {\n  vec4 pcPos = fragCoordToPCPos(fragCoord);\n  vec4 worldCoord = pcPosToWorldCoord(pcPos);\n  vec4 vertex = (worldCoord / worldCoord.w);\n\n  vec3 index = (volume.worldToIndex * vertex).xyz;\n\n  // half voxel fix for labelmapOutline\n  return (index + vec3(0.5)) * volume.inverseDimensions;\n}\n\nvec3 fragCoordToWorld(vec4 fragCoord) {\n  vec4 pcPos = fragCoordToPCPos(fragCoord);\n  vec4 worldCoord = pcPosToWorldCoord(pcPos);\n  return worldCoord.xyz;\n}\n\n//=======================================================================\n// Compute the normals and gradient magnitudes for a position for independent\n// components The output normals are in VC\nmat4 computeMat4Normal(vec3 posIS, vec4 tValue) {\n  vec3 xvec = vec3(volume.inverseDimensions.x, 0.0, 0.0);\n  vec3 yvec = vec3(0.0, volume.inverseDimensions.y, 0.0);\n  vec3 zvec = vec3(0.0, 0.0, volume.inverseDimensions.z);\n\n  vec4 distX = getTextureValue(posIS + xvec) - getTextureValue(posIS - xvec);\n  vec4 distY = getTextureValue(posIS + yvec) - getTextureValue(posIS - yvec);\n  vec4 distZ = getTextureValue(posIS + zvec) - getTextureValue(posIS - zvec);\n\n  // divide by spacing\n  distX *= 0.5 * volume.inverseSpacing.x;\n  distY *= 0.5 * volume.inverseSpacing.y;\n  distZ *= 0.5 * volume.inverseSpacing.z;\n\n  mat4 result;\n\n  // optionally compute the 1st component\n  #if vtkNumberOfComponents > 0 && !defined(vtkComponent0Proportional)\n    {\n      const int component = 0;\n      vec3 normal = vec3(distX[component], distY[component], distZ[component]);\n      float normalLength = length(normal);\n      if (normalLength > 0.0) {\n        normal = normalize(vecISToVC(normal));\n      }\n      result[component] = vec4(normal, normalLength);\n    }\n  #endif\n\n  // optionally compute the 2nd component\n  #if vtkNumberOfComponents > 1 && !defined(vtkComponent1Proportional)\n    {\n      const int component = 1;\n      vec3 normal = vec3(distX[component], distY[component], distZ[component]);\n      float normalLength = length(normal);\n      if (normalLength > 0.0) {\n        normal = normalize(vecISToVC(normal));\n      }\n      result[component] = vec4(normal, normalLength);\n    }\n  #endif\n\n  // optionally compute the 3rd component\n  #if vtkNumberOfComponents > 2 && !defined(vtkComponent2Proportional)\n    {\n      const int component = 2;\n      vec3 normal = vec3(distX[component], distY[component], distZ[component]);\n      float normalLength = length(normal);\n      if (normalLength > 0.0) {\n        normal = normalize(vecISToVC(normal));\n      }\n      result[component] = vec4(normal, normalLength);\n    }\n  #endif\n\n  // optionally compute the 4th component\n  #if vtkNumberOfComponents > 3 && !defined(vtkComponent3Proportional)\n    {\n      const int component = 3;\n      vec3 normal = vec3(distX[component], distY[component], distZ[component]);\n      float normalLength = length(normal);\n      if (normalLength > 0.0) {\n        normal = normalize(vecISToVC(normal));\n      }\n      result[component] = vec4(normal, normalLength);\n    }\n  #endif\n\n  return result;\n}\n\n//=======================================================================\n// global shadow - secondary ray\n\n// henyey greenstein phase function\nfloat phaseFunction(float cos_angle) {\n  // divide by 2.0 instead of 4pi to increase intensity\n  float anisotropy = volume.anisotropy;\n  if (abs(anisotropy) <= EPSILON) {\n    // isotropic scatter returns 0.5 instead of 1/4pi to increase intensity\n    return 0.5;\n  }\n  float anisotropy2 = volume.anisotropySquared;\n  return ((1.0 - anisotropy2) /\n          pow(1.0 + anisotropy2 - 2.0 * anisotropy * cos_angle, 1.5)) /\n         2.0;\n}\n\n// Compute the two intersection distances of the ray with the volume in VC\n// The entry point is `rayOriginVC + distanceMin * rayDirVC` and the exit point\n// is `rayOriginVC + distanceMax * rayDirVC` If distanceMin < distanceMax, the\n// volume is not intersected The ray origin is inside the box when distanceMin <\n// 0.0 < distanceMax\nvec2 rayIntersectVolumeDistances(vec3 rayOriginVC, vec3 rayDirVC) {\n  // Compute origin and direction in IS\n  vec3 rayOriginIS = posVCtoIS(rayOriginVC);\n  vec3 rayDirIS = vecVCToIS(rayDirVC);\n  // Don't check for infinity as the min/max combination afterward will always\n  // find an intersection before infinity\n  vec3 invDir = 1.0 / rayDirIS;\n\n  // We have: bound = origin + t * dir\n  // So: t = (1/dir) * (bound - origin)\n  vec3 distancesTo0 = invDir * (vec3(0.0) - rayOriginIS);\n  vec3 distancesTo1 = invDir * (vec3(1.0) - rayOriginIS);\n  // Min and max distances to plane intersection per plane\n  vec3 dMinPerAxis = min(distancesTo0, distancesTo1);\n  vec3 dMaxPerAxis = max(distancesTo0, distancesTo1);\n  // Overall first and last intersection\n  float distanceMin = max(dMinPerAxis.x, max(dMinPerAxis.y, dMinPerAxis.z));\n  float distanceMax = min(dMaxPerAxis.x, min(dMaxPerAxis.y, dMaxPerAxis.z));\n  return vec2(distanceMin, distanceMax);\n}\n\n//=======================================================================\n// local ambient occlusion\n#if vtkMaxLaoKernelSize > 0\n\n  // Return a random point on the unit sphere\n  vec3 sampleDirectionUniform(int rayIndex) {\n    // Each ray of each fragment should be different, two sources of randomness\n    // are used. Only depends on ray index\n    vec2 rayRandomness = kernelSample[rayIndex];\n    // Only depends on fragment\n    float fragmentRandomness = fragmentSeed;\n    // Merge both source of randomness in a single uniform random variable using\n    // the formula (x+y < 1 ? x+y : x+y-1). The simpler formula (x+y)/2 doesn't\n    // result in a uniform distribution\n    vec2 mergedRandom = rayRandomness + vec2(fragmentRandomness);\n    mergedRandom -= vec2(greaterThanEqual(mergedRandom, vec2(1.0)));\n\n    // Insipred by:\n    // https://karthikkaranth.me/blog/generating-random-points-in-a-sphere/#better-choice-of-spherical-coordinates\n    float u = mergedRandom[0];\n    float v = mergedRandom[1];\n    float theta = u * 2.0 * PI;\n    float phi = acos(2.0 * v - 1.0);\n    float sinTheta = sin(theta);\n    float cosTheta = cos(theta);\n    float sinPhi = sin(phi);\n    float cosPhi = cos(phi);\n    return vec3(sinPhi * cosTheta, sinPhi * sinTheta, cosPhi);\n  }\n\n  float computeLAO(vec3 posVC, vec4 normalVC, float originalOpacity) {\n    // apply LAO only at selected locations, otherwise return full brightness\n    if (normalVC.w <= 0.0 || originalOpacity <= 0.05) {\n      return 1.0;\n    }\n\n    #ifdef EnabledGradientOpacity\n      float gradientOpacityFactor = computeGradientOpacityFactor(normalVC.w, 0);\n    #endif\n\n    float visibilitySum = 0.0;\n    float weightSum = 0.0;\n    for (int i = 0; i < volume.kernelSize; i++) {\n      // Only sample on an hemisphere around the normalVC.xyz axis, so\n      // normalDotRay should be negative\n      vec3 rayDirectionVC = sampleDirectionUniform(i);\n      float normalDotRay = dot(normalVC.xyz, rayDirectionVC);\n      if (normalDotRay > 0.0) {\n        // Flip rayDirectionVC when it is in the wrong hemisphere\n        rayDirectionVC = -rayDirectionVC;\n        normalDotRay = -normalDotRay;\n      }\n\n      vec3 currPosIS = posVCtoIS(posVC);\n      float visibility = 1.0;\n      vec3 randomDirStepIS = vecVCToIS(rayDirectionVC * sampleDistance);\n      for (int j = 0; j < volume.kernelRadius; j++) {\n        currPosIS += randomDirStepIS;\n        // If out of the volume, we are done\n        if (any(lessThan(currPosIS, vec3(0.0))) ||\n            any(greaterThan(currPosIS, vec3(1.0)))) {\n          break;\n        }\n        float opacity = getOpacityFromTexture(getTextureValue(currPosIS).r, 0, 0.5);\n        #ifdef EnabledGradientOpacity\n          opacity *= gradientOpacityFactor;\n        #endif\n        visibility *= 1.0 - opacity;\n        // If visibility is less than EPSILON, consider it to be 0\n        if (visibility < EPSILON) {\n          visibility = 0.0;\n          break;\n        }\n      }\n      float rayWeight = -normalDotRay;\n      visibilitySum += visibility * rayWeight;\n      weightSum += rayWeight;\n    }\n\n    // If no sample, LAO factor is one\n    if (weightSum == 0.0) {\n      return 1.0;\n    }\n\n    // LAO factor is the average visibility:\n    // - visibility low => ambient low\n    // - visibility high => ambient high\n    float lao = visibilitySum / weightSum;\n\n    // Reduce variance by clamping\n    return clamp(lao, 0.3, 1.0);\n  }\n#endif\n\n//=======================================================================\n// Volume shadows\n#if vtkNumberOfLights > 0\n\n  // Non-memoised version\n  float computeVolumeShadowWithoutCache(vec3 posVC, vec3 lightDirNormVC) {\n    // modify sample distance with a random number between 1.5 and 3.0\n    float rayStepLength =\n        volumeShadowSampleDistance * mix(1.5, 3.0, fragmentSeed);\n\n    // in case the first sample near surface has a very tiled light ray, we need\n    // to offset start position\n    vec3 initialPosVC = posVC + rayStepLength * lightDirNormVC;\n\n    #ifdef vtkClippingPlanesOn\n      float clippingPlanesMaxDistance = infinity;\n      for (int i = 0; i < clip_numPlanes; ++i) {\n        // Find distance of intersection with the plane\n        // Points are clipped when:\n        // dot(planeOrigin - (rayOrigin + distance * rayDirection), planeNormal) > 0\n        // This is equivalent to:\n        // dot(planeOrigin - rayOrigin, planeNormal) - distance * dot(rayDirection,\n        // planeNormal) > 0.0\n        // We precompute the dot products, so we clip ray points when:\n        // dotOrigin - distance * dotDirection > 0.0\n        float dotOrigin =\n            dot(vClipPlaneOrigins[i] - initialPosVC, vClipPlaneNormals[i]);\n        if (dotOrigin > 0.0) {\n          // The initialPosVC is clipped by this plane\n          return 1.0;\n        }\n        float dotDirection = dot(lightDirNormVC, vClipPlaneNormals[i]);\n        if (dotDirection < 0.0) {\n          // We only hit the plane if dotDirection is negative, as (distance is\n          // positive)\n          float intersectionDistance =\n              dotOrigin / dotDirection; // negative divided by negative => positive\n          clippingPlanesMaxDistance =\n              min(clippingPlanesMaxDistance, intersectionDistance);\n        }\n      }\n    #endif\n\n    vec2 intersectionDistances =\n        rayIntersectVolumeDistances(initialPosVC, lightDirNormVC);\n\n    if (intersectionDistances[1] <= intersectionDistances[0] ||\n        intersectionDistances[1] <= 0.0) {\n      // Volume not hit or behind the ray\n      return 1.0;\n    }\n\n    // When globalIlluminationReach is 0, no sample at all\n    // When globalIlluminationReach is 1, the ray will go through the whole\n    // volume\n    float maxTravelDistance = mix(0.0, volume.diagonalLength,\n                                  volume.globalIlluminationReach);\n    float startDistance = max(intersectionDistances[0], 0.0);\n    float endDistance = min(intersectionDistances[1], startDistance + maxTravelDistance);\n    #ifdef vtkClippingPlanesOn\n      endDistance = min(endDistance, clippingPlanesMaxDistance);\n    #endif\n    if (endDistance - startDistance < 0.0) {\n      return 1.0;\n    }\n\n    // These two variables are used to compute posIS, without having to call\n    // VCtoIS at each step\n    vec3 initialPosIS = posVCtoIS(initialPosVC);\n    // The light dir is scaled and rotated, but not translated, as it is a\n    // vector (w = 0)\n    vec3 scaledLightDirIS = vecVCToIS(lightDirNormVC);\n\n    float shadow = 1.0;\n    for (float currentDistance = startDistance; currentDistance <= endDistance;\n          currentDistance += rayStepLength) {\n      vec3 posIS = initialPosIS + currentDistance * scaledLightDirIS;\n      vec4 scalar = getTextureValue(posIS);\n      float opacity = getOpacityFromTexture(scalar.r, 0, 0.5);\n      #if defined(EnabledGradientOpacity) && !defined(EnabledIndependentComponents)\n        vec3 scalarInterp[2];\n        vec4 normal = computeNormalForDensity(posIS, scalarInterp, 3);\n        float opacityFactor = computeGradientOpacityFactor(normal.w, 0);\n        opacity *= opacityFactor;\n      #endif\n      shadow *= 1.0 - opacity;\n\n      // Early termination if shadow coeff is near 0.0\n      if (shadow < EPSILON) {\n        return 0.0;\n      }\n    }\n    return shadow;\n  }\n\n  // Some cache for volume shadows\n  struct {\n    vec3 posVC;\n    float shadow;\n  } cachedShadows[vtkNumberOfLights];\n\n  // Memoised version\n  float computeVolumeShadow(vec3 posVC, vec3 lightDirNormVC, int lightIdx) {\n    if (posVC == cachedShadows[lightIdx].posVC) {\n      return cachedShadows[lightIdx].shadow;\n    }\n    float shadow = computeVolumeShadowWithoutCache(posVC, lightDirNormVC);\n    cachedShadows[lightIdx].posVC = posVC;\n    cachedShadows[lightIdx].shadow = shadow;\n    return shadow;\n  }\n\n#endif\n\n//=======================================================================\n// surface light contribution\n#if vtkNumberOfLights > 0\n  vec3 applyLighting(vec3 tColor, vec4 normalVC) {\n    vec3 diffuse = vec3(0.0, 0.0, 0.0);\n    vec3 specular = vec3(0.0, 0.0, 0.0);\n    for (int lightIdx = 0; lightIdx < vtkNumberOfLights; lightIdx++) {\n      float df = dot(normalVC.xyz, lights[lightIdx].directionVC);\n      if (df > 0.0) {\n        diffuse += df * lights[lightIdx].color;\n        float sf = dot(normalVC.xyz, -lights[lightIdx].halfAngleVC);\n        if (sf > 0.0) {\n          specular += pow(sf, volume.specularPower) * lights[lightIdx].color;\n        }\n      }\n    }\n    return tColor * (diffuse * volume.diffuse + volume.ambient) +\n          specular * volume.specular;\n  }\n\n  vec3 applySurfaceShadowLighting(vec3 tColor, float alpha, vec3 posVC,\n                                  vec4 normalVC) {\n    // everything in VC\n    vec3 diffuse = vec3(0.0);\n    vec3 specular = vec3(0.0);\n    for (int ligthIdx = 0; ligthIdx < vtkNumberOfLights; ligthIdx++) {\n      vec3 vertLightDirection;\n      float attenuation;\n      if (lights[ligthIdx].isPositional == 1) {\n        vertLightDirection = posVC - lights[ligthIdx].positionVC;\n        float lightDistance = length(vertLightDirection);\n        // Normalize with precomputed length\n        vertLightDirection = vertLightDirection / lightDistance;\n        // Base attenuation\n        vec3 attenuationPolynom = lights[ligthIdx].attenuation;\n        attenuation =\n            1.0 / (attenuationPolynom[0] +\n                  lightDistance * (attenuationPolynom[1] +\n                                    lightDistance * attenuationPolynom[2]));\n        // Cone attenuation\n        float coneDot = dot(vertLightDirection, lights[ligthIdx].directionVC);\n        // Per OpenGL standard cone angle is 90 or less for a spot light\n        if (lights[ligthIdx].coneAngle <= 90.0) {\n          if (coneDot >= cos(radians(lights[ligthIdx].coneAngle))) {\n            // Inside the cone\n            attenuation *= pow(coneDot, lights[ligthIdx].exponent);\n          } else {\n            // Outside the cone\n            attenuation = 0.0;\n          }\n        }\n      } else {\n        vertLightDirection = lights[ligthIdx].directionVC;\n        attenuation = 1.0;\n      }\n\n      float ndotL = dot(normalVC.xyz, vertLightDirection);\n      if (ndotL < 0.0 && twoSidedLighting == 1) {\n        ndotL = -ndotL;\n      }\n      if (ndotL > 0.0) {\n        // Diffuse\n        diffuse += ndotL * attenuation * lights[ligthIdx].color;\n        // Specular\n        float vdotR =\n            dot(-rayDirVC, normalize(vertLightDirection - 2.0 * ndotL * normalVC.xyz));\n        if (vdotR > 0.0) {\n          specular += pow(vdotR, volume.specularPower) * attenuation *\n                      lights[ligthIdx].color;\n        }\n      }\n    }\n    #if vtkMaxLaoKernelSize > 0\n      float laoFactor = computeLAO(posVC, normalVC, alpha);\n    #else\n      const float laoFactor = 1.0;\n    #endif\n    return tColor * (diffuse * volume.diffuse +\n                    volume.ambient * laoFactor) +\n          specular * volume.specular;\n  }\n\n  vec3 applyVolumeShadowLighting(vec3 tColor, vec3 posVC) {\n    // Here we have no effect of cones and no attenuation\n    vec3 diffuse = vec3(0.0);\n    for (int lightIdx = 0; lightIdx < vtkNumberOfLights; lightIdx++) {\n      vec3 lightDirVC = lights[lightIdx].isPositional == 1\n                            ? normalize(lights[lightIdx].positionVC - posVC)\n                            : -lights[lightIdx].directionVC;\n      float shadowCoeff = computeVolumeShadow(posVC, lightDirVC, lightIdx);\n      float phaseAttenuation = phaseFunction(dot(rayDirVC, lightDirVC));\n      diffuse += phaseAttenuation * shadowCoeff * lights[lightIdx].color;\n    }\n    return tColor * (diffuse * volume.diffuse + volume.ambient);\n  }\n#endif\n\n// LAO of surface shadows and volume shadows only work with dependent components\nvec3 applyAllLightning(vec3 tColor, float alpha, vec3 posVC,\n                       vec4 surfaceNormalVC) {\n  #if vtkNumberOfLights > 0\n    // 0 <= volCoeff < EPSILON => only surface shadows\n    // EPSILON <= volCoeff < 1 - EPSILON => mix of surface and volume shadows\n    // 1 - EPSILON <= volCoeff => only volume shadows\n    float volCoeff = volume.volumetricScatteringBlending *\n                    (1.0 - alpha / 2.0) *\n                    (1.0 - atan(surfaceNormalVC.w) * INV4PI);\n\n    // Compute surface lighting if needed\n    vec3 surfaceShadedColor = tColor;\n    #ifdef EnableSurfaceLighting\n      if (volCoeff < 1.0 - EPSILON) {\n        surfaceShadedColor =\n            applySurfaceShadowLighting(tColor, alpha, posVC, surfaceNormalVC);\n      }\n    #endif\n\n    // Compute volume lighting if needed\n    vec3 volumeShadedColor = tColor;\n    #ifdef EnableVolumeLighting\n      if (volCoeff >= EPSILON) {\n        volumeShadedColor = applyVolumeShadowLighting(tColor, posVC);\n      }\n    #endif\n\n    // Return the right mix\n    if (volCoeff < EPSILON) {\n      // Surface shadows\n      return surfaceShadedColor;\n    }\n    if (volCoeff >= 1.0 - EPSILON) {\n      // Volume shadows\n      return volumeShadedColor;\n    }\n    // Mix of surface and volume shadows\n    return mix(surfaceShadedColor, volumeShadedColor, volCoeff);\n  #endif\n  return tColor;\n}\n\nvec4 getColorForLabelOutline() {\n  vec3 centerPosIS =\n      fragCoordToIndexSpace(gl_FragCoord); // pos in texture space\n  vec4 centerValue = getTextureValue(centerPosIS);\n  bool pixelOnBorder = false;\n  vec4 tColor = vec4(getColorFromTexture(centerValue.r, 0, 0.5),\n                     getOpacityFromTexture(centerValue.r, 0, 0.5));\n\n  int segmentIndex = int(centerValue.r * 255.0);\n\n  // Use texture sampling for outlineThickness\n  float textureCoordinate = float(segmentIndex - 1) / 1024.0;\n  float textureValue =\n      texture2D(labelOutlineThicknessTexture, vec2(textureCoordinate, 0.5)).r;\n  int actualThickness = int(textureValue * 255.0);\n\n  // If it is the background (segment index 0), we should quickly bail out.\n  // Previously, this was determined by tColor.a, which was incorrect as it\n  // prevented the outline from appearing when the fill is 0.\n  if (segmentIndex == 0) {\n    return vec4(0, 0, 0, 0);\n  }\n\n  // Only perform outline check on fragments rendering voxels that aren't\n  // invisible. Saves a bunch of needless checks on the background.\n  // TODO define epsilon when building shader?\n  for (int i = -actualThickness; i <= actualThickness; i++) {\n    for (int j = -actualThickness; j <= actualThickness; j++) {\n      if (i == 0 || j == 0) {\n        continue;\n      }\n\n      vec4 neighborPixelCoord =\n          vec4(gl_FragCoord.x + float(i), gl_FragCoord.y + float(j),\n               gl_FragCoord.z, gl_FragCoord.w);\n\n      vec3 neighborPosIS = fragCoordToIndexSpace(neighborPixelCoord);\n      vec4 value = getTextureValue(neighborPosIS);\n\n      // If any of my neighbours are not the same value as I\n      // am, this means I am on the border of the segment.\n      // We can break the loops\n      if (any(notEqual(value, centerValue))) {\n        pixelOnBorder = true;\n        break;\n      }\n    }\n\n    if (pixelOnBorder == true) {\n      break;\n    }\n  }\n\n  // If I am on the border, I am displayed at full opacity\n  if (pixelOnBorder == true) {\n    tColor.a = volume.outlineOpacity;\n  }\n\n  return tColor;\n}\n\nvec4 getColorForAdditivePreset(vec4 tValue, vec3 posVC, vec3 posIS) {\n  // compute normals\n  mat4 normalMat = computeMat4Normal(posIS, tValue);\n  vec4 normalLights[2];\n  normalLights[0] = normalMat[0];\n  normalLights[1] = normalMat[1];\n  #if vtkNumberOfLights > 0\n    if (volume.computeNormalFromOpacity == 1) {\n      for (int component = 0; component < 2; ++component) {\n        vec3 scalarInterp[2];\n        float height = volume.transferFunctionsSampleHeight[component];\n        computeNormalForDensity(posIS, scalarInterp, component);\n        normalLights[component] =\n            computeDensityNormal(scalarInterp, height, 1.0, component);\n      }\n    }\n  #endif\n\n  // compute opacities\n  float opacities[2];\n  opacities[0] = getOpacityFromTexture(\n      tValue[0], 0, volume.transferFunctionsSampleHeight[0]);\n  opacities[1] = getOpacityFromTexture(\n      tValue[1], 1, volume.transferFunctionsSampleHeight[1]);\n  #ifdef EnabledGradientOpacity\n    for (int component = 0; component < 2; ++component) {\n      opacities[component] *=\n          computeGradientOpacityFactor(normalMat[component].a, component);\n    }\n  #endif\n  float opacitySum = opacities[0] + opacities[1];\n  if (opacitySum <= 0.0) {\n    return vec4(0.0);\n  }\n\n  // mix the colors and opacities\n  vec3 colors[2];\n  for (int component = 0; component < 2; ++component) {\n    float sampleHeight = volume.transferFunctionsSampleHeight[component];\n    vec3 color = getColorFromTexture(tValue[component], component, sampleHeight);\n    color = applyAllLightning(color, opacities[component], posVC,\n                              normalLights[component]);\n    colors[component] = color;\n  }\n  vec3 mixedColor =\n      (opacities[0] * colors[0] + opacities[1] * colors[1]) / opacitySum;\n  return vec4(mixedColor, min(1.0, opacitySum));\n}\n\nvec4 getColorForColorizePreset(vec4 tValue, vec3 posVC, vec3 posIS) {\n  // compute normals\n  mat4 normalMat = computeMat4Normal(posIS, tValue);\n  vec4 normalLight = normalMat[0];\n  #if vtkNumberOfLights > 0\n    if (volume.computeNormalFromOpacity == 1) {\n      vec3 scalarInterp[2];\n      float height = volume.transferFunctionsSampleHeight[0];\n      computeNormalForDensity(posIS, scalarInterp, 0);\n      normalLight = computeDensityNormal(scalarInterp, height, 1.0, 0);\n    }\n  #endif\n\n  // compute opacities\n  float opacity = getOpacityFromTexture(\n      tValue[0], 0, volume.transferFunctionsSampleHeight[0]);\n  #ifdef EnabledGradientOpacity\n    opacity *= computeGradientOpacityFactor(normalMat[0].a, 0);\n  #endif\n\n  // colorizing component\n  vec3 colorizingColor = getColorFromTexture(\n      tValue[0], 1, volume.transferFunctionsSampleHeight[1]);\n  float colorizingOpacity = getOpacityFromTexture(\n      tValue[1], 1, volume.transferFunctionsSampleHeight[1]);\n\n  // mix the colors and opacities\n  vec3 color =\n      getColorFromTexture(tValue[0], 0,\n                          volume.transferFunctionsSampleHeight[0]) *\n      mix(vec3(1.0), colorizingColor, colorizingOpacity);\n  color = applyAllLightning(color, opacity, posVC, normalLight);\n  return vec4(color, opacity);\n}\n\nvec4 getColorForDefaultIndependentPreset(vec4 tValue, vec3 posIS) {\n\n  // compute the normal vectors as needed\n  #if defined(EnabledGradientOpacity) || vtkNumberOfLights > 0\n    mat4 normalMat = computeMat4Normal(posIS, tValue);\n  #endif\n\n  // process color and opacity for each component\n  // initial value of alpha is determined by wether the first component is\n  // proportional or not\n  #if defined(vtkComponent0Proportional)\n    // when it is proportional, it starts at 1 (neutral for multiplications)\n    float alpha = 1.0;\n  #else\n    // when it is not proportional, it starts at 0 (neutral for additions)\n    float alpha = 0.0;\n  #endif\n\n  vec3 mixedColor = vec3(0.0);\n  #if vtkNumberOfComponents > 0\n    {\n      const int component = 0;\n      vec3 color = getColorFromTexture(\n          tValue[component], component,\n          volume.transferFunctionsSampleHeight[component]);\n      float opacity = getOpacityFromTexture(\n          tValue[component], component,\n          volume.transferFunctionsSampleHeight[component]);\n      #if !defined(vtkComponent0Proportional)\n        float alphaContribution = volume.independentComponentMix[component] * opacity;\n        #ifdef EnabledGradientOpacity\n          alphaContribution *= computeGradientOpacityFactor(normalMat[component].a, component);\n        #endif\n        alpha += alphaContribution;\n        #if vtkNumberOfLights > 0\n          color = applyLighting(color, normalMat[component]);\n        #endif\n      #else\n        color *= opacity;\n        alpha *= mix(opacity, 1.0,\n                    (1.0 - volume.independentComponentMix[component]));\n      #endif\n      mixedColor += volume.independentComponentMix[component] * color;\n    }\n  #endif\n  #if vtkNumberOfComponents > 1\n    {\n      const int component = 1;\n      vec3 color = getColorFromTexture(\n          tValue[component], component,\n          volume.transferFunctionsSampleHeight[component]);\n      float opacity = getOpacityFromTexture(\n          tValue[component], component,\n          volume.transferFunctionsSampleHeight[component]);\n      #if !defined(vtkComponent1Proportional)\n        float alphaContribution = volume.independentComponentMix[component] * opacity;\n        #ifdef EnabledGradientOpacity\n          alphaContribution *= computeGradientOpacityFactor(normalMat[component].a, component);\n        #endif\n        alpha += alphaContribution;\n        #if vtkNumberOfLights > 0\n          color = applyLighting(color, normalMat[component]);\n        #endif\n      #else\n        color *= opacity;\n        alpha *= mix(opacity, 1.0,\n                    (1.0 - volume.independentComponentMix[component]));\n      #endif\n      mixedColor += volume.independentComponentMix[component] * color;\n    }\n  #endif\n  #if vtkNumberOfComponents > 2\n    {\n      const int component = 2;\n      vec3 color = getColorFromTexture(\n          tValue[component], component,\n          volume.transferFunctionsSampleHeight[component]);\n      float opacity = getOpacityFromTexture(\n          tValue[component], component,\n          volume.transferFunctionsSampleHeight[component]);\n      #if !defined(vtkComponent2Proportional)\n        float alphaContribution = volume.independentComponentMix[component] * opacity;\n        #ifdef EnabledGradientOpacity\n          alphaContribution *= computeGradientOpacityFactor(normalMat[component].a, component);\n        #endif\n        alpha += alphaContribution;\n        #if vtkNumberOfLights > 0\n          color = applyLighting(color, normalMat[component]);\n        #endif\n      #else\n        color *= opacity;\n        alpha *= mix(opacity, 1.0,\n                    (1.0 - volume.independentComponentMix[component]));\n      #endif\n      mixedColor += volume.independentComponentMix[component] * color;\n    }\n  #endif\n  #if vtkNumberOfComponents > 3\n    {\n      const int component = 3;\n      vec3 color = getColorFromTexture(\n          tValue[component], component,\n          volume.transferFunctionsSampleHeight[component]);\n      float opacity = getOpacityFromTexture(\n          tValue[component], component,\n          volume.transferFunctionsSampleHeight[component]);\n      #if !defined(vtkComponent3Proportional)\n        float alphaContribution = volume.independentComponentMix[component] * opacity;\n        #ifdef EnabledGradientOpacity\n          alphaContribution *= computeGradientOpacityFactor(normalMat[component].a, component);\n        #endif\n        alpha += alphaContribution;\n        #if vtkNumberOfLights > 0\n          color = applyLighting(color, normalMat[component]);\n        #endif\n      #else\n        color *= opacity;\n        alpha *= mix(opacity, 1.0,\n                    (1.0 - volume.independentComponentMix[component]));\n      #endif\n      mixedColor += volume.independentComponentMix[component] * color;\n    }\n  #endif\n\n  return vec4(mixedColor, alpha);\n}\n\nvec4 getColorForDependentComponents(vec4 tValue, vec3 posVC, vec3 posIS) {\n  #if defined(EnabledGradientOpacity) || vtkNumberOfLights > 0\n    // use component 3 of the opacity texture as getTextureValue() sets alpha to\n    // the opacity value\n    vec3 scalarInterp[2];\n    vec4 normal0 = computeNormalForDensity(posIS, scalarInterp, 3);\n    float gradientOpacity = computeGradientOpacityFactor(normal0.a, 0);\n  #endif\n\n  // get color and opacity\n  #if vtkNumberOfComponents == 1\n    vec3 tColor = getColorFromTexture(tValue.r, 0, 0.5);\n    float alpha = getOpacityFromTexture(tValue.r, 0, 0.5);\n  #endif\n  #if vtkNumberOfComponents == 2\n    vec3 tColor = vec3(tValue.r * volume.colorTextureScale[0] +\n                  volume.colorTextureShift[0]);\n    float alpha = getOpacityFromTexture(tValue.a, 1, 0.5);\n  #endif\n  #if vtkNumberOfComponents == 3\n      vec3 tColor = tValue.rgb * volume.colorTextureScale.rgb +\n              volume.colorTextureShift.rgb;\n      float alpha = getOpacityFromTexture(tValue.a, 0, 0.5);\n  #endif\n  #if vtkNumberOfComponents == 4\n      vec3 tColor = tValue.rgb * volume.colorTextureScale.rgb +\n              volume.colorTextureShift.rgb;\n      float alpha = getOpacityFromTexture(tValue.a, 3, 0.5);\n  #endif\n\n  // Apply gradient opacity\n  #if defined(EnabledGradientOpacity)\n    alpha *= gradientOpacity;\n  #endif\n\n  #if vtkNumberOfComponents == 1\n    if (alpha < EPSILON) {\n      return vec4(0.0);\n    }\n  #endif\n\n  // lighting\n  #if vtkNumberOfLights > 0\n    vec4 normalLight;\n    if (volume.computeNormalFromOpacity == 1) {\n      if (normal0[3] != 0.0) {\n        normalLight =\n            computeDensityNormal(scalarInterp, 0.5, gradientOpacity, 0);\n        if (normalLight[3] == 0.0) {\n          normalLight = normal0;\n        }\n      }\n    } else {\n      normalLight = normal0;\n    }\n    tColor = applyAllLightning(tColor, alpha, posVC, normalLight);\n  #endif\n\n  return vec4(tColor, alpha);\n}\n\nvec4 getColorForValue(vec4 tValue, vec3 posVC, vec3 posIS) {\n  #ifdef EnableColorForValueFunctionId0\n    return getColorForDependentComponents(tValue, posVC, posIS);\n  #endif\n\n  #ifdef EnableColorForValueFunctionId1\n    return getColorForAdditivePreset(tValue, posVC, posIS);\n  #endif\n\n  #ifdef EnableColorForValueFunctionId2\n    return getColorForColorizePreset(tValue, posVC, posIS);\n  #endif\n\n  #ifdef EnableColorForValueFunctionId3\n    /*\n      * Mix the color information from all the independent components to get a\n      * single rgba output. See other shader functions like\n      * `getColorForAdditivePreset` to learn how to create a custom color mix.\n      * The custom color mix should return a value, but if it doesn't, it will\n      * fallback on the default shading\n      */\n    //VTK::CustomColorMix\n  #endif\n\n  #if defined(EnableColorForValueFunctionId4) || defined(EnableColorForValueFunctionId3)\n    return getColorForDefaultIndependentPreset(tValue, posIS);\n  #endif\n\n  #ifdef EnableColorForValueFunctionId5\n    return getColorForLabelOutline();\n  #endif\n}\n\nbool valueWithinScalarRange(vec4 val) {\n  #if vtkNumberOfComponents > 1 && !defined(EnabledIndependentComponents)\n    return false;\n  #endif\n  vec4 rangeMin = volume.ipScalarRangeMin;\n  vec4 rangeMax = volume.ipScalarRangeMax;\n  for (int component = 0; component < vtkNumberOfComponents; ++component) {\n    if (val[component] < rangeMin[component] ||\n        rangeMax[component] < val[component]) {\n      return false;\n    }\n  }\n  return true;\n}\n\n#if vtkBlendMode == LABELMAP_EDGE_PROJECTION_BLEND\n  bool checkOnEdgeForNeighbor(int xFragmentOffset, int yFragmentOffset,\n                              int segmentIndex, vec3 stepIS) {\n    vec3 volumeDimensions = vec3(volume.dimensions);\n    vec4 neighborPixelCoord = vec4(gl_FragCoord.x + float(xFragmentOffset),\n                                  gl_FragCoord.y + float(yFragmentOffset),\n                                  gl_FragCoord.z, gl_FragCoord.w);\n    vec3 originalNeighborPosIS = fragCoordToIndexSpace(neighborPixelCoord);\n\n    vec3 neighborPosIS = originalNeighborPosIS;\n    for (int k = 0; k < vtkMaximumNumberOfSamples / 2; ++k) {\n      ivec3 texCoord = ivec3(neighborPosIS * volumeDimensions);\n      vec4 texValue = rawFetchTexture(texCoord);\n      if (int(texValue.g) == segmentIndex) {\n        // not on edge\n        return false;\n      }\n      neighborPosIS += stepIS;\n    }\n\n    neighborPosIS = originalNeighborPosIS;\n    for (int k = 0; k < vtkMaximumNumberOfSamples / 2; ++k) {\n      ivec3 texCoord = ivec3(neighborPosIS * volumeDimensions);\n      vec4 texValue = rawFetchTexture(texCoord);\n      if (int(texValue.g) == segmentIndex) {\n        // not on edge\n        return false;\n      }\n      neighborPosIS -= stepIS;\n    }\n\n    // onedge\n    float sampleHeight = volume.transferFunctionsSampleHeight[1];\n    vec3 tColorSegment =\n        getColorFromTexture(float(segmentIndex), 1, sampleHeight);\n    float pwfValueSegment =\n        getOpacityFromTexture(float(segmentIndex), 1, sampleHeight);\n    gl_FragData[0] = vec4(tColorSegment, pwfValueSegment);\n    return true;\n  }\n#endif\n\nvec4 getColorAtPos(vec3 posVC) {\n  vec3 posIS = posVCtoIS(posVC);\n  vec4 texValue = getTextureValue(posIS);\n  return getColorForValue(texValue, posVC, posIS);\n}\n\n//=======================================================================\n// Apply the specified blend mode operation along the ray's path.\n//\nvoid applyBlend(vec3 rayOriginVC, vec3 rayDirVC, float minDistance,\n                float maxDistance) {\n  // start slightly inside and apply some jitter\n  vec3 stepVC = rayDirVC * sampleDistance;\n  float raySteps = (maxDistance - minDistance) / sampleDistance;\n\n  // Avoid 0.0 jitter\n  float jitter = 0.01 + 0.99 * fragmentSeed;\n\n  #if vtkBlendMode == COMPOSITE_BLEND\n    // now map through opacity and color\n    vec3 firstPosVC = rayOriginVC + minDistance * rayDirVC;\n    vec4 firstColor = getColorAtPos(firstPosVC);\n\n    // handle very thin volumes\n    if (raySteps <= 1.0) {\n      firstColor.a = 1.0 - pow(1.0 - firstColor.a, raySteps);\n      gl_FragData[0] = firstColor;\n      return;\n    }\n\n    // first color only counts for `jitter` factor of the step\n    firstColor.a = 1.0 - pow(1.0 - firstColor.a, jitter);\n    vec4 color = vec4(firstColor.rgb * firstColor.a, firstColor.a);\n    vec3 posVC = firstPosVC + jitter * stepVC;\n    float stepsTraveled = jitter;\n\n    for (int i = 0; i < vtkMaximumNumberOfSamples; ++i) {\n      // If we have reached the last step, break\n      if (stepsTraveled + 1.0 >= raySteps) {\n        break;\n      }\n      vec4 tColor = getColorAtPos(posVC);\n\n      color = color + vec4(tColor.rgb * tColor.a, tColor.a) * (1.0 - color.a);\n      stepsTraveled++;\n      posVC += stepVC;\n      if (color.a > 0.99) {\n        color.a = 1.0;\n        break;\n      }\n    }\n\n    if (color.a < 0.99 && (raySteps - stepsTraveled) > 0.0) {\n      vec3 endPosVC = rayOriginVC + maxDistance * rayDirVC;\n      vec4 tColor = getColorAtPos(endPosVC);\n      tColor.a = 1.0 - pow(1.0 - tColor.a, raySteps - stepsTraveled);\n\n      float mix = (1.0 - color.a);\n      color = color + vec4(tColor.rgb * tColor.a, tColor.a) * mix;\n    }\n\n    gl_FragData[0] = vec4(color.rgb / color.a, color.a);\n  #endif\n\n  #if vtkBlendMode == MAXIMUM_INTENSITY_BLEND ||                                 \\\n      vtkBlendMode == MINIMUM_INTENSITY_BLEND\n    // Find maximum/minimum intensity along the ray.\n\n    // Define the operation we will use (min or max)\n    #if vtkBlendMode == MAXIMUM_INTENSITY_BLEND\n      #define OP max\n    #else\n      #define OP min\n    #endif\n\n    vec3 posVC = rayOriginVC + minDistance * rayDirVC;\n    float stepsTraveled = 0.0;\n\n    // Find a value to initialize the selected variables\n    vec4 selectedValue;\n    vec3 selectedPosVC;\n    vec3 selectedPosIS;\n    {\n      vec3 posIS = posVCtoIS(posVC);\n      selectedValue = getTextureValue(posIS);\n      selectedPosVC = posVC;\n      selectedPosIS = posIS;\n    }\n\n    // If the clipping range is shorter than the sample distance\n    // we can skip the sampling loop along the ray.\n    if (raySteps <= 1.0) {\n      gl_FragData[0] = getColorForValue(selectedValue, selectedPosVC, selectedPosIS);\n      return;\n    }\n\n    posVC += jitter * stepVC;\n    stepsTraveled += jitter;\n\n    // Sample along the ray until vtkMaximumNumberOfSamples,\n    // ending slightly inside the total distance\n    for (int i = 0; i < vtkMaximumNumberOfSamples; ++i) {\n      // If we have reached the last step, break\n      if (stepsTraveled + 1.0 >= raySteps) {\n        break;\n      }\n\n      // Get selected values\n      vec3 posIS = posVCtoIS(posVC);\n      vec4 previousSelectedValue = selectedValue;\n      vec4 currentValue = getTextureValue(posIS);\n      selectedValue = OP(selectedValue, currentValue);\n      if (previousSelectedValue != selectedValue) {\n        selectedPosVC = posVC;\n        selectedPosIS = posIS;\n      }\n\n      // Otherwise, continue along the ray\n      stepsTraveled++;\n      posVC += stepVC;\n    }\n\n    // Perform the last step along the ray using the\n    // residual distance\n    posVC = rayOriginVC + maxDistance * rayDirVC;\n    {\n      vec3 posIS = posVCtoIS(posVC);\n      vec4 previousSelectedValue = selectedValue;\n      vec4 currentValue = getTextureValue(posIS);\n      selectedValue = OP(selectedValue, currentValue);\n      if (previousSelectedValue != selectedValue) {\n        selectedPosVC = posVC;\n        selectedPosIS = posIS;\n      }\n    }\n\n    gl_FragData[0] = getColorForValue(selectedValue, selectedPosVC, selectedPosIS);\n  #endif\n\n  #if vtkBlendMode == ADDITIVE_INTENSITY_BLEND ||                                \\\n      vtkBlendMode == AVERAGE_INTENSITY_BLEND\n    vec4 sum = vec4(0.);\n    #if vtkBlendMode == AVERAGE_INTENSITY_BLEND\n      float totalWeight = 0.0;\n    #endif\n    vec3 posVC = rayOriginVC + minDistance * rayDirVC;\n    float stepsTraveled = 0.0;\n\n    vec3 posIS = posVCtoIS(posVC);\n    vec4 value = getTextureValue(posIS);\n\n    if (raySteps <= 1.0) {\n      gl_FragData[0] = getColorForValue(value * raySteps, posVC, posIS);\n      return;\n    }\n\n    if (valueWithinScalarRange(value)) {\n      sum += value * jitter;\n      #if vtkBlendMode == AVERAGE_INTENSITY_BLEND\n        totalWeight += jitter;\n      #endif\n    }\n    posVC += jitter * stepVC;\n    stepsTraveled += jitter;\n\n    // Sample along the ray until vtkMaximumNumberOfSamples,\n    // ending slightly inside the total distance\n    for (int i = 0; i < vtkMaximumNumberOfSamples; ++i) {\n      // If we have reached the last step, break\n      if (stepsTraveled + 1.0 >= raySteps) {\n        break;\n      }\n\n      posIS = posVCtoIS(posVC);\n      value = getTextureValue(posIS);\n      // One can control the scalar range by setting the AverageIPScalarRange to\n      // disregard scalar values, not in the range of interest, from the average\n      // computation. Notes:\n      // - We are comparing all values in the texture to see if any of them\n      //   are outside of the scalar range. In the future we might want to allow\n      //   scalar ranges for each component.\n      if (valueWithinScalarRange(value)) {\n        sum += value;\n        #if vtkBlendMode == AVERAGE_INTENSITY_BLEND\n          totalWeight++;\n        #endif\n      }\n\n      stepsTraveled++;\n      posVC += stepVC;\n    }\n\n    // Perform the last step along the ray using the\n    // residual distance\n    posVC = rayOriginVC + maxDistance * rayDirVC;\n    posIS = posVCtoIS(posVC);\n    value = getTextureValue(posIS);\n    if (valueWithinScalarRange(value)) {\n      sum += value;\n      #if vtkBlendMode == AVERAGE_INTENSITY_BLEND\n        totalWeight += raySteps - stepsTraveled;\n      #endif\n    }\n\n    #if vtkBlendMode == AVERAGE_INTENSITY_BLEND\n      sum /= vec4(totalWeight, totalWeight, totalWeight, 1.0);\n    #endif\n\n    gl_FragData[0] = getColorForValue(sum, posVC, posIS);\n  #endif\n\n  #if vtkBlendMode == RADON_TRANSFORM_BLEND\n    float normalizedRayIntensity = 1.0;\n    vec3 posVC = rayOriginVC + minDistance * rayDirVC;\n    float stepsTraveled = 0.0;\n\n    // handle very thin volumes\n    if (raySteps <= 1.0) {\n      vec3 posIS = posVCtoIS(posVC);\n      vec4 tValue = getTextureValue(posIS);\n      normalizedRayIntensity -= raySteps * sampleDistance *\n                                getOpacityFromTexture(tValue.r, 0, 0.5);\n      gl_FragData[0] =\n          vec4(getColorFromTexture(normalizedRayIntensity, 0, 0.5), 1.0);\n      return;\n    }\n\n    posVC += jitter * stepVC;\n    stepsTraveled += jitter;\n\n    for (int i = 0; i < vtkMaximumNumberOfSamples; ++i) {\n      if (stepsTraveled + 1.0 >= raySteps) {\n        break;\n      }\n\n      vec3 posIS = posVCtoIS(posVC);\n      vec4 value = getTextureValue(posIS);\n      // Convert scalar value to normalizedRayIntensity coefficient and\n      // accumulate normalizedRayIntensity\n      normalizedRayIntensity -=\n          sampleDistance * getOpacityFromTexture(value.r, 0, 0.5);\n\n      posVC += stepVC;\n      stepsTraveled++;\n    }\n\n    // map normalizedRayIntensity to color\n    gl_FragData[0] =\n        vec4(getColorFromTexture(normalizedRayIntensity, 0, 0.5), 1.0);\n  #endif\n\n  #if vtkBlendMode == LABELMAP_EDGE_PROJECTION_BLEND\n    // Only works with a single volume\n    vec3 posVC = rayOriginVC + minDistance * rayDirVC;\n    float stepsTraveled = 0.0;\n    vec3 posIS = posVCtoIS(posVC);\n    vec4 tValue = getTextureValue(posIS);\n    if (raySteps <= 1.0) {\n      gl_FragData[0] = getColorForValue(tValue, posVC, posIS);\n      return;\n    }\n\n    vec3 stepIS = vecVCToIS(stepVC);\n    vec4 value = tValue;\n    posIS += jitter * stepIS;\n    stepsTraveled += jitter;\n    vec3 maxPosIS = posIS; // Store the position of the max value\n    int segmentIndex = int(value.g);\n    bool originalPosHasSeenNonZero = false;\n\n    if (segmentIndex != 0) {\n      // Tried using the segment index in an boolean array but reading\n      // from the array by dynamic indexing was horrondously slow\n      // so use bit masking instead and assign 1 to the bit corresponding to the\n      // segment index and later check if the bit is set via bit operations\n      setLabelOutlineBit(segmentIndex);\n    }\n\n    // Sample along the ray until vtkMaximumNumberOfSamples,\n    // ending slightly inside the total distance\n    for (int i = 0; i < vtkMaximumNumberOfSamples; ++i) {\n      // If we have reached the last step, break\n      if (stepsTraveled + 1.0 >= raySteps) {\n        break;\n      }\n\n      // compute the scalar\n      tValue = getTextureValue(posIS);\n      segmentIndex = int(tValue.g);\n\n      if (segmentIndex != 0) {\n        originalPosHasSeenNonZero = true;\n        setLabelOutlineBit(segmentIndex);\n      }\n\n      if (tValue.r > value.r) {\n        value = tValue;   // Update the max value\n        maxPosIS = posIS; // Update the position where max occurred\n      }\n\n      // Otherwise, continue along the ray\n      stepsTraveled++;\n      posIS += stepIS;\n    }\n\n    // Perform the last step along the ray using the\n    // residual distance\n    posIS = posVCtoIS(rayOriginVC + maxDistance * rayDirVC);\n    tValue = getTextureValue(posIS);\n\n    if (tValue.r > value.r) {\n      value = tValue;   // Update the max value\n      maxPosIS = posIS; // Update the position where max occurred\n    }\n\n    // If we have not seen any non-zero segments, we can return early\n    // and grab color from the actual center value first component (image)\n    if (!originalPosHasSeenNonZero) {\n      vec3 maxPosVC = posIStoVC(maxPosIS);\n      gl_FragData[0] = getColorForValue(value, maxPosVC, maxPosIS);\n      return;\n    }\n\n    vec3 neighborRayStepsIS = stepIS;\n    float neighborRaySteps = raySteps;\n    bool shouldLookInAllNeighbors = false;\n\n    vec3 volumeSpacings = volume.spacing;\n    float minVoxelSpacing =\n        min(volumeSpacings[0], min(volumeSpacings[1], volumeSpacings[2]));\n    vec4 base =\n        vec4(gl_FragCoord.x, gl_FragCoord.y, gl_FragCoord.z, gl_FragCoord.w);\n\n    vec4 baseXPlus = vec4(gl_FragCoord.x + 1.0, gl_FragCoord.y, gl_FragCoord.z,\n                          gl_FragCoord.w);\n    vec4 baseYPlus = vec4(gl_FragCoord.x, gl_FragCoord.y + 1.0, gl_FragCoord.z,\n                          gl_FragCoord.w);\n\n    vec3 baseWorld = fragCoordToWorld(base);\n    vec3 baseXPlusWorld = fragCoordToWorld(baseXPlus);\n    vec3 baseYPlusWorld = fragCoordToWorld(baseYPlus);\n\n    float XPlusDiff = length(baseXPlusWorld - baseWorld);\n    float YPlusDiff = length(baseYPlusWorld - baseWorld);\n\n    float minFragSpacingWorld = min(XPlusDiff, YPlusDiff);\n\n    for (int s = 1; s < MAX_SEGMENT_INDEX; s++) {\n      // bail out quickly if the segment index has not\n      // been seen by the center segment\n      if (!isLabelOutlineBitSet(s)) {\n        continue;\n      }\n\n      // Use texture sampling for outlineThickness so that we can have\n      // per segment thickness\n      float textureCoordinate = float(s - 1) / 1024.0;\n      float textureValue =\n          texture2D(labelOutlineThicknessTexture, vec2(textureCoordinate, 0.5)).r;\n\n      int actualThickness = int(textureValue * 255.0);\n\n      // check the extreme points in the neighborhood since there is a better\n      // chance of finding the edge there, so that we can bail out\n      // faster if we find the edge\n      bool onEdge = checkOnEdgeForNeighbor(-actualThickness, -actualThickness, s,\n                                          stepIS) ||\n                    checkOnEdgeForNeighbor(actualThickness, actualThickness, s,\n                                          stepIS) ||\n                    checkOnEdgeForNeighbor(actualThickness, -actualThickness, s,\n                                          stepIS) ||\n                    checkOnEdgeForNeighbor(-actualThickness, +actualThickness, s,\n                                          stepIS);\n\n      if (onEdge) {\n        return;\n      }\n\n      // since the next step is computationally expensive, we need to perform\n      // some optimizations to avoid it if possible. One of the optimizations\n      // is to check the whether the minimum of the voxel spacing is greater than\n      // the 2 * the thickness of the outline segment. If that is the case\n      // then we can safely skip the next step since we can be sure that the\n      // the previous 4 checks on the extreme points would caught the entirety\n      // of the all the fragments inside. i.e., this happens when we zoom out,\n      if (minVoxelSpacing >\n          (2.0 * float(actualThickness) - 1.0) * minFragSpacingWorld) {\n        continue;\n      }\n\n      // Loop through the rest, skipping the processed extremes and the center\n      for (int i = -actualThickness; i <= actualThickness; i++) {\n        for (int j = -actualThickness; j <= actualThickness; j++) {\n          if (i == 0 && j == 0)\n            continue; // Skip the center\n          if (abs(i) == actualThickness && abs(j) == actualThickness)\n            continue; // Skip corners\n          if (checkOnEdgeForNeighbor(i, j, s, stepIS)) {\n            return;\n          }\n        }\n      }\n    }\n\n    float sampleHeight = volume.transferFunctionsSampleHeight[0];\n    vec3 tColor0 = getColorFromTexture(value.r, 0, sampleHeight);\n    float pwfValue0 = getOpacityFromTexture(value.r, 0, sampleHeight);\n    gl_FragData[0] = vec4(tColor0, pwfValue0);\n  #endif\n}\n\n//=======================================================================\n// given a\n// - ray direction (rayDir)\n// - starting point (vertexVCVSOutput)\n// - bounding planes of the volume\n// - optionally depth buffer values\n// - far clipping plane\n// compute the start/end distances of the ray we need to cast\nvec2 computeRayDistances(vec3 rayOriginVC, vec3 rayDirVC) {\n  vec2 dists = rayIntersectVolumeDistances(rayOriginVC, rayDirVC);\n\n  //VTK::ClipPlane::Impl\n\n  // do not go behind front clipping plane\n  dists.x = max(0.0, dists.x);\n\n  // do not go PAST far clipping plane\n  float farDist = -camThick / rayDirVC.z;\n  dists.y = min(farDist, dists.y);\n\n  // Do not go past the zbuffer value if set\n  // This is used for intermixing opaque geometry\n  //VTK::ZBuffer::Impl\n\n  return dists;\n}\n\nfloat getFragmentSeed() {\n  // This first noise has a diagonal pattern\n  float firstNoise =\n      fract(sin(dot(gl_FragCoord.xy, vec2(12.9898, 78.233))) * 43758.5453);\n  // This second noise is made out of blocks of CPU generated noise\n  float secondNoise = texture2D(jtexture, gl_FragCoord.xy / 32.0).r;\n  // Combine the two sources of noise in a way that the distribution is uniform\n  // in [0,1[\n  float noiseSum = firstNoise + secondNoise;\n  return noiseSum < 1.0 ? noiseSum : noiseSum - 1.0;\n}\n\nvoid main() {\n  fragmentSeed = getFragmentSeed();\n\n  if (cameraParallel == 1) {\n    // Camera is parallel, so the rayDir is just the direction of the camera.\n    rayDirVC = vec3(0.0, 0.0, -1.0);\n  } else {\n    // camera is at 0,0,0 so rayDir for perspective is just the vc coord\n    rayDirVC = normalize(vertexVCVSOutput);\n  }\n\n  vec3 rayOriginVC = vertexVCVSOutput;\n  vec2 rayStartEndDistancesVC = computeRayDistances(rayOriginVC, rayDirVC);\n  if (rayStartEndDistancesVC[1] <= rayStartEndDistancesVC[0] ||\n      rayStartEndDistancesVC[1] <= 0.0) {\n    // Volume not hit or behind the ray\n    discard;\n  }\n\n  // Perform the blending operation along the ray\n  applyBlend(rayOriginVC, rayDirVC, rayStartEndDistancesVC[0], rayStartEndDistancesVC[1]);\n}\n", import_fast_deep_equal$1 = /* @__PURE__ */ __toESM(require_fast_deep_equal(), 1), { vtkWarningMacro: vtkWarningMacro$3, vtkErrorMacro: vtkErrorMacro$23 } = macro$1, preAllocatedMatrices = {
  idxToView: identity$2(new Float64Array(16)),
  vecISToVCMatrix: identity$3(new Float64Array(9)),
  modelToView: identity$2(new Float64Array(16)),
  projectionToView: identity$2(new Float64Array(16)),
  projectionToWorld: identity$2(new Float64Array(16))
};
function vtkOpenGLVolumeMapper(e12, t) {
  t.classHierarchy.push("vtkOpenGLVolumeMapper");
  function n(e13, t2) {
    let n2 = e13.getIndependentComponents(), r2 = e13.getColorMixPreset();
    return n2 && t2 >= 2 || !!r2;
  }
  function r(e13) {
    return e13.getUseLabelOutline() || t.renderable.getBlendMode() === BlendMode$1.LABELMAP_EDGE_PROJECTION_BLEND;
  }
  let a = /* @__PURE__ */ new Map();
  function o(t2, n2) {
    if (!n2)
      return;
    let r2 = (a.get(n2) ?? 0) - 1;
    r2 <= 0 ? (t2.unregisterGraphicsResourceUser(n2, e12), a.delete(n2)) : a.set(n2, r2);
  }
  function s(t2, n2) {
    if (!n2)
      return;
    let r2 = a.get(n2) ?? 0, o2 = r2 + 1;
    a.set(n2, o2), r2 <= 0 && t2.registerGraphicsResourceUser(n2, e12);
  }
  function c(e13, t2, n2) {
    t2 !== n2 && (o(e13, t2), s(e13, n2));
  }
  function l(t2) {
    [...a.keys()].forEach((n2) => t2.unregisterGraphicsResourceUser(n2, e12));
  }
  e12.buildPass = () => {
    t.zBufferTexture = null;
  }, e12.zBufferPass = (e13, n2) => {
    if (e13) {
      let e14 = n2.getZBufferTexture();
      e14 !== t.zBufferTexture && (t.zBufferTexture = e14);
    }
  }, e12.opaqueZBufferPass = (t2, n2) => e12.zBufferPass(t2, n2), e12.volumePass = (n2, r2) => {
    if (n2) {
      let n3 = t._openGLRenderWindow;
      t._openGLRenderWindow = e12.getLastAncestorOfType("vtkOpenGLRenderWindow"), n3 && !n3.isDeleted() && n3 !== t._openGLRenderWindow && l(n3), t.context = t._openGLRenderWindow.getContext(), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow), t.jitterTexture.setOpenGLRenderWindow(t._openGLRenderWindow), t.framebuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.openGLVolume = e12.getFirstAncestorOfType("vtkOpenGLVolume");
      let r3 = t.openGLVolume.getRenderable();
      t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer");
      let a2 = t._openGLRenderer.getRenderable();
      t.openGLCamera = t._openGLRenderer.getViewNodeFor(a2.getActiveCamera()), e12.renderPiece(a2, r3);
    }
  }, e12.getShaderTemplate = (e13, t2, n2) => {
    e13.Vertex = vtkVolumeVS, e13.Fragment = vtkVolumeFS, e13.Geometry = "";
  }, e12.replaceShaderValues = (e13, n2, r2) => {
    let a2 = e13.Fragment;
    a2 = vtkShaderProgram$1.substitute(a2, "//VTK::EnabledColorFunctions", `#define EnableColorForValueFunctionId${t.previousState.colorForValueFunctionId}`).result;
    let o2 = [];
    t.previousState.surfaceLightingEnabled && o2.push("Surface"), t.previousState.volumeLightingEnabled && o2.push("Volume"), a2 = vtkShaderProgram$1.substitute(a2, "//VTK::EnabledLightings", o2.map((e14) => `#define Enable${e14}Lighting`)).result, t.previousState.multiTexturePerVolumeEnabled && (a2 = vtkShaderProgram$1.substitute(a2, "//VTK::EnabledMultiTexturePerVolume", "#define EnabledMultiTexturePerVolume").result), t.previousState.useIndependentComponents && (a2 = vtkShaderProgram$1.substitute(a2, "//VTK::EnabledIndependentComponents", "#define EnabledIndependentComponents").result), t.previousState.gradientOpacityEnabled && (a2 = vtkShaderProgram$1.substitute(a2, "//VTK::EnabledGradientOpacity", "#define EnabledGradientOpacity").result), a2 = vtkShaderProgram$1.substitute(a2, "//VTK::vtkProportionalComponents", t.previousState.proportionalComponents.map((e14) => `#define vtkComponent${e14}Proportional`).join("\n")).result, a2 = vtkShaderProgram$1.substitute(a2, "//VTK::vtkForceNearestComponents", t.previousState.forceNearestComponents.map((e14) => `#define vtkComponent${e14}ForceNearest`).join("\n")).result, t.previousState.hasZBufferTexture && (a2 = vtkShaderProgram$1.substitute(a2, "//VTK::ZBuffer::Dec", [
      "uniform sampler2D zBufferTexture;",
      "uniform float vpZWidth;",
      "uniform float vpZHeight;"
    ]).result, a2 = vtkShaderProgram$1.substitute(a2, "//VTK::ZBuffer::Impl", [
      "vec4 depthVec = texture2D(zBufferTexture, vec2(gl_FragCoord.x / vpZWidth, gl_FragCoord.y/vpZHeight));",
      "float zdepth = (depthVec.r*256.0 + depthVec.g)/257.0;",
      "zdepth = zdepth * 2.0 - 1.0;",
      "if (cameraParallel == 0) {",
      "zdepth = -2.0 * camFar * camNear / (zdepth*(camFar-camNear)-(camFar+camNear)) - camNear;}",
      "else {",
      "zdepth = (zdepth + 1.0) * 0.5 * (camFar - camNear);}\n",
      "zdepth = -zdepth/rayDirVC.z;",
      "dists.y = min(zdepth,dists.y);"
    ]).result), a2 = vtkShaderProgram$1.substitute(a2, "//VTK::BlendMode", `${t.previousState.blendMode}`).result, a2 = vtkShaderProgram$1.substitute(a2, "//VTK::NumberOfLights", `${t.previousState.numberOfLights}`).result, a2 = vtkShaderProgram$1.substitute(a2, "//VTK::MaxLaoKernelSize", `${t.previousState.maxLaoKernelSize}`).result, a2 = vtkShaderProgram$1.substitute(a2, "//VTK::NumberOfComponents", `${t.previousState.numberOfComponents}`).result, a2 = vtkShaderProgram$1.substitute(a2, "//VTK::MaximumNumberOfSamples", `${t.previousState.maximumNumberOfSamples}`).result, e13.Fragment = a2;
    let s2 = t.previousState.numberOfClippingPlanes;
    s2 > 0 && (a2 = vtkShaderProgram$1.substitute(a2, "//VTK::ClipPlane::Dec", [
      "uniform vec3 vClipPlaneNormals[6];",
      "uniform float vClipPlaneDistances[6];",
      "uniform vec3 vClipPlaneOrigins[6];",
      "uniform int clip_numPlanes;",
      "//VTK::ClipPlane::Dec",
      "#define vtkClippingPlanesOn"
    ], false).result, a2 = vtkShaderProgram$1.substitute(a2, "//VTK::ClipPlane::Impl", [
      `for(int i = 0; i < ${s2}; i++) {`,
      "  float rayDirRatio = dot(rayDirVC, vClipPlaneNormals[i]);",
      "  float equationResult = dot(vertexVCVSOutput, vClipPlaneNormals[i]) + vClipPlaneDistances[i];",
      "  if (rayDirRatio == 0.0)",
      "  {",
      "    if (equationResult < 0.0) dists.x = dists.y;",
      "    continue;",
      "  }",
      "  float result = -1.0 * equationResult / rayDirRatio;",
      "  if (rayDirRatio < 0.0) dists.y = min(dists.y, result);",
      "  else dists.x = max(dists.x, result);",
      "}",
      "//VTK::ClipPlane::Impl"
    ], false).result), e13.Fragment = a2;
  }, e12.getNeedToRebuildShaders = (n2, a2, o2) => {
    let s2 = !!t.zBufferTexture, c2 = t.currentValidInputs.length, l2 = t.numberOfLights, u = t.numberOfComponents, d = t.useIndependentComponents, p = o2.getProperties(), m = t.currentValidInputs[0], h = p[m.inputIndex], g = c2 > 1, _ = m.imageData.getBounds(), v = vtkBoundingBox.getDiagonalLength(_), y = Math.ceil(v / e12.getCurrentSampleDistance(a2));
    y > t.renderable.getMaximumSamplesPerRay() && vtkWarningMacro$3(`The number of steps required ${y} is larger than the specified maximum number of steps ${t.renderable.getMaximumSamplesPerRay()}.
Please either change the volumeMapper sampleDistance or its maximum number of samples.`);
    let b = d ? u : 1, S = false;
    for (let e13 = 0; e13 < b; ++e13)
      if (h.getUseGradientOpacity(e13)) {
        S = true;
        break;
      }
    let C = 0, w = h.getLAOKernelSize();
    w > C && h.getLocalAmbientOcclusion() && h.getAmbient() > 0 && (C = w);
    let T = t.renderable.getClippingPlanes().length, E = t.renderable.getViewSpecificProperties().OpenGL?.ShaderReplacements, D = t.currentRenderPass?.getShaderReplacement(), O = t.renderable.getBlendMode(), k = (() => {
      if (O !== BlendMode$1.LABELMAP_EDGE_PROJECTION_BLEND && r(h))
        return 5;
      if (d)
        switch (h.getColorMixPreset()) {
          case ColorMixPreset.ADDITIVE:
            return 1;
          case ColorMixPreset.COLORIZE:
            return 2;
          case ColorMixPreset.CUSTOM:
            return 3;
          default:
            return 4;
        }
      return 0;
    })(), A = h.getVolumetricScatteringBlending() < 1, j = h.getVolumetricScatteringBlending() > 0, M = false;
    for (let e13 = 0; e13 < u; ++e13)
      if (h.getForceNearestInterpolation(e13)) {
        M = true;
        break;
      }
    let N = [], P = [];
    for (let e13 = 0; e13 < u; e13++)
      h.getOpacityMode(e13) === OpacityMode.PROPORTIONAL && N.push(e13), h.getForceNearestInterpolation(e13) && P.push(e13);
    let F = {
      numberOfComponents: u,
      useIndependentComponents: d,
      proportionalComponents: N,
      forceNearestComponents: P,
      blendMode: O,
      numberOfLights: l2,
      numberOfValidInputs: c2,
      maximumNumberOfSamples: y,
      hasZBufferTexture: s2,
      maxLaoKernelSize: C,
      numberOfClippingPlanes: T,
      mapperShaderReplacements: E,
      renderPassShaderReplacements: D,
      colorForValueFunctionId: k,
      surfaceLightingEnabled: A,
      volumeLightingEnabled: j,
      forceNearestInterpolationEnabled: M,
      multiTexturePerVolumeEnabled: g,
      gradientOpacityEnabled: S
    };
    return n2.getProgram()?.getHandle() === 0 || !t.previousState || !(0, import_fast_deep_equal$1.default)(t.previousState, F) ? (t.previousState = F, true) : false;
  }, e12.updateShaders = (n2, r2, a2) => {
    if (e12.getNeedToRebuildShaders(n2, r2, a2)) {
      let o2 = {
        Vertex: null,
        Fragment: null,
        Geometry: null
      };
      e12.buildShaders(o2, r2, a2);
      let s2 = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray(o2.Vertex, o2.Fragment, o2.Geometry);
      s2 !== n2.getProgram() && (n2.setProgram(s2), n2.getVAO().releaseGraphicsResources()), n2.getShaderSourceTime().modified();
    } else
      t._openGLRenderWindow.getShaderCache().readyShaderProgram(n2.getProgram());
    n2.getVAO().bind(), e12.setMapperShaderParameters(n2, r2, a2), e12.setCameraShaderParameters(n2, r2, a2), e12.setPropertyShaderParameters(n2, r2, a2), e12.getClippingPlaneShaderParameters(n2, r2, a2);
  }, e12.setMapperShaderParameters = (n2, r2, a2) => {
    let o2 = n2.getProgram();
    n2.getCABO().getElementCount() && (t.VBOBuildTime.getMTime() > n2.getAttributeUpdateTime().getMTime() || n2.getShaderSourceTime().getMTime() > n2.getAttributeUpdateTime().getMTime()) && (o2.isAttributeUsed("vertexDC") && (n2.getVAO().addAttributeArray(o2, n2.getCABO(), "vertexDC", n2.getCABO().getVertexOffset(), n2.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || vtkErrorMacro$23("Error setting vertexDC in shader VAO.")), n2.getAttributeUpdateTime().modified());
    let s2 = e12.getCurrentSampleDistance(r2);
    o2.setUniformf("sampleDistance", s2);
    let c2 = s2 * t.renderable.getVolumeShadowSamplingDistFactor();
    o2.setUniformf("volumeShadowSampleDistance", c2), t.scalarTextures.forEach((e13, t2) => {
      o2.setUniformi(`volumeTexture[${t2}]`, e13.getTextureUnit());
    });
    let l2 = a2.getProperties()[t.currentValidInputs[0].inputIndex].getIpScalarRange(), u = new Float32Array(4), d = new Float32Array(4), f = (e13, t2, n3) => {
      t2?.dataComputedScale?.length && (u[e13] = l2[0] * t2.dataComputedScale[n3] + t2.dataComputedOffset[n3], d[e13] = l2[1] * t2.dataComputedScale[n3] + t2.dataComputedOffset[n3], u[e13] = (u[e13] - t2.offset[n3]) / t2.scale[n3], d[e13] = (d[e13] - t2.offset[n3]) / t2.scale[n3]);
    };
    if (t.previousState.multiTexturePerVolumeEnabled)
      t.scalarTextures.forEach((e13, t2) => {
        f(t2, e13.getVolumeInfo(), 0);
      });
    else {
      let e13 = t.scalarTextures[0].getVolumeInfo();
      for (let t2 = 0; t2 < 4; ++t2)
        f(t2, e13, t2);
    }
    let p = "volume";
    if (o2.setUniform4f(`${p}.ipScalarRangeMin`, u[0], u[1], u[2], u[3]), o2.setUniform4f(`${p}.ipScalarRangeMax`, d[0], d[1], d[2], d[3]), t.zBufferTexture !== null) {
      o2.setUniformi("zBufferTexture", t.zBufferTexture.getTextureUnit());
      let e13 = t._useSmallViewport ? [t._smallViewportWidth, t._smallViewportHeight] : t._openGLRenderWindow.getFramebufferSize();
      o2.setUniformf("vpZWidth", e13[0]), o2.setUniformf("vpZHeight", e13[1]);
    }
  }, e12.setCameraShaderParameters = (n2, a2, o2) => {
    let { idxToView: s2, vecISToVCMatrix: c2, modelToView: l2, projectionToView: u, projectionToWorld: d } = preAllocatedMatrices, f = t.openGLCamera.getKeyMatrices(a2), p = t.openGLVolume.getKeyMatrices();
    multiply$2(l2, f.wcvc, p.mcwc);
    let m = n2.getProgram(), h = t.openGLCamera.getRenderable(), g = h.getParallelProjection(), _ = h.getClippingRange();
    m.setUniformf("camThick", _[1] - _[0]), m.setUniformf("camNear", _[0]), m.setUniformf("camFar", _[1]), m.setUniformi("cameraParallel", g);
    let v = t.currentValidInputs[0], y = v.imageData.getBounds(), b = vtkBoundingBox.getCorners(y, []).map((e13) => (transformMat4$1(e13, e13, l2), g || scale$3(e13, e13, -_[0] / (e13[2] * length$2(e13))), transformMat4$1(e13, e13, f.vcpc), e13)), S = vtkBoundingBox.addPoints([...vtkBoundingBox.INIT_BOUNDS], b);
    m.setUniformf("dcxmin", S[0]), m.setUniformf("dcxmax", S[1]), m.setUniformf("dcymin", S[2]), m.setUniformf("dcymax", S[3]);
    let C = e12.getRenderTargetSize();
    m.setUniformf("vpWidth", C[0]), m.setUniformf("vpHeight", C[1]);
    let w = e12.getRenderTargetOffset();
    m.setUniformf("vpOffsetX", w[0] / C[0]), m.setUniformf("vpOffsetY", w[1] / C[1]), invert(u, f.vcpc), m.setUniformMatrix("PCVCMatrix", u), m.setUniformi("twoSidedLighting", a2.getTwoSidedLighting());
    let T = Array(2 * t.previousState.maxLaoKernelSize);
    for (let e13 = 0; e13 < t.previousState.maxLaoKernelSize; e13++)
      T[e13 * 2] = Math.random(), T[e13 * 2 + 1] = Math.random();
    if (m.setUniform2fv("kernelSample", T), t.numberOfLights > 0) {
      let e13 = 0;
      a2.getLights().forEach((t2) => {
        if (t2.getSwitch() > 0) {
          let n3 = `lights[${e13}]`, r2 = scale$3([], t2.getColor(), t2.getIntensity());
          m.setUniform3fv(`${n3}.color`, r2);
          let a3 = t2.getTransformedPosition();
          transformMat4$1(a3, a3, l2), m.setUniform3fv(`${n3}.positionVC`, a3);
          let o3 = [...t2.getDirection()];
          transformMat3(o3, o3, f.normalMatrix), normalize$4(o3, o3), m.setUniform3fv(`${n3}.directionVC`, o3);
          let s3 = [
            -0.5 * o3[0],
            -0.5 * o3[1],
            -0.5 * (o3[2] - 1)
          ];
          m.setUniform3fv(`${n3}.halfAngleVC`, s3);
          let c3 = t2.getAttenuationValues();
          m.setUniform3fv(`${n3}.attenuation`, c3);
          let u2 = t2.getExponent();
          m.setUniformf(`${n3}.exponent`, u2);
          let d2 = t2.getConeAngle();
          m.setUniformf(`${n3}.coneAngle`, d2);
          let p2 = t2.getPositional();
          m.setUniformi(`${n3}.isPositional`, p2), e13++;
        }
      });
    }
    let E = "volume", D = o2.getProperties()[v.inputIndex], O = v.imageData, k = O.getSpatialExtent(), A = O.getSpacing(), j = O.getDimensions(), M = O.getIndexToWorld(), N = O.getWorldToIndex(), P = O.getDirectionByReference();
    multiply$2(s2, l2, M), m.setUniform3fv(`${E}.spacing`, A);
    let F = inverse([], A);
    m.setUniform3fv(`${E}.inverseSpacing`, F), m.setUniform3iv(`${E}.dimensions`, j), m.setUniform3fv(`${E}.inverseDimensions`, inverse([], j)), m.setUniformMatrix(`${E}.worldToIndex`, N), c2.fill(0);
    let I = multiply$1(new Float64Array(3), j, A);
    c2[0] = I[0], c2[4] = I[1], c2[8] = I[2], multiply$3(c2, P, c2), multiply$3(c2, p.normalMatrix, c2), multiply$3(c2, f.normalMatrix, c2), m.setUniformMatrix3x3(`${E}.vecISToVCMatrix`, c2), m.setUniformMatrix3x3(`${E}.vecVCToISMatrix`, invert$1(new Float32Array(9), c2));
    let L = fromValues$3(k[0], k[2], k[4]), R = transformMat4$1(new Float64Array(3), L, s2);
    m.setUniform3fv(`${E}.originVC`, R);
    let z = length$2(I);
    if (m.setUniformf(`${E}.diagonalLength`, z), r(D)) {
      let e13 = h.getDistance();
      h.setClippingRange(e13, e13 + 0.1), invert(d, t.openGLCamera.getKeyMatrices(a2).wcpc), h.setClippingRange(_[0], _[1]), t.openGLCamera.getKeyMatrices(a2), m.setUniformMatrix(`${E}.PCWCMatrix`, d);
    }
    if (D.getVolumetricScatteringBlending() > 0 && (m.setUniformf(`${E}.globalIlluminationReach`, D.getGlobalIlluminationReach()), m.setUniformf(`${E}.volumetricScatteringBlending`, D.getVolumetricScatteringBlending()), m.setUniformf(`${E}.anisotropy`, D.getAnisotropy()), m.setUniformf(`${E}.anisotropySquared`, D.getAnisotropy() ** 2)), D.getLocalAmbientOcclusion() && D.getAmbient() > 0) {
      let e13 = D.getLAOKernelSize();
      m.setUniformi(`${E}.kernelSize`, e13);
      let t2 = D.getLAOKernelRadius();
      m.setUniformi(`${E}.kernelRadius`, t2);
    } else
      m.setUniformi(`${E}.kernelSize`, 0);
  }, e12.setPropertyShaderParameters = (e13, n2, r2) => {
    let a2 = e13.getProgram();
    a2.setUniformi("jtexture", t.jitterTexture.getTextureUnit());
    let o2 = r2.getProperties();
    a2.setUniformi("labelOutlineThicknessTexture", t.labelOutlineThicknessTexture.getTextureUnit()), a2.setUniformi("opacityTexture", t.opacityTexture.getTextureUnit()), a2.setUniformi("colorTexture", t.colorTexture.getTextureUnit());
    let s2 = "volume", c2 = o2[t.currentValidInputs[0].inputIndex], l2 = t.previousState.numberOfComponents, u = t.previousState.useIndependentComponents;
    if (u) {
      let e14 = new Float32Array(4);
      for (let t3 = 0; t3 < l2; t3++)
        e14[t3] = c2.getComponentWeight(t3);
      a2.setUniform4fv(`${s2}.independentComponentMix`, e14);
      let t2 = new Float32Array(4), n3 = 1 / l2;
      for (let e15 = 0; e15 < l2; ++e15)
        t2[e15] = (e15 + 0.5) * n3;
      a2.setUniform4fv(`${s2}.transferFunctionsSampleHeight`, t2);
    }
    let d = t.colorForValueFunctionId;
    a2.setUniformi(`${s2}.colorForValueFunctionId`, d);
    let f = c2.getComputeNormalFromOpacity();
    a2.setUniformi(`${s2}.computeNormalFromOpacity`, f);
    let p = new Float32Array(4), m = new Float32Array(4), h = new Float32Array(4), g = new Float32Array(4);
    for (let e14 = 0; e14 < l2; e14++) {
      let n3 = t.previousState.multiTexturePerVolumeEnabled, r3 = n3 ? e14 : 0, a3 = n3 ? 0 : e14, o3 = t.scalarTextures[r3].getVolumeInfo(), s3 = u ? e14 : 0, l3 = o3.scale[a3], d2 = c2.getRGBTransferFunction(s3).getRange();
      p[e14] = l3 / (d2[1] - d2[0]), m[e14] = (o3.offset[a3] - d2[0]) / (d2[1] - d2[0]);
      let f2 = c2.getScalarOpacity(s3).getRange();
      h[e14] = l3 / (f2[1] - f2[0]), g[e14] = (o3.offset[a3] - f2[0]) / (f2[1] - f2[0]);
    }
    if (a2.setUniform4fv(`${s2}.colorTextureScale`, p), a2.setUniform4fv(`${s2}.colorTextureShift`, m), a2.setUniform4fv(`${s2}.opacityTextureScale`, h), a2.setUniform4fv(`${s2}.opacityTextureShift`, g), t.previousState.gradientOpacityEnabled) {
      let e14 = [
        ,
        ,
        ,
        ,
      ], n3 = [
        ,
        ,
        ,
        ,
      ], r3 = [
        ,
        ,
        ,
        ,
      ], o3 = [
        ,
        ,
        ,
        ,
      ];
      if (u)
        for (let a3 = 0; a3 < l2; ++a3) {
          let s3 = t.previousState.multiTexturePerVolumeEnabled, l3 = s3 ? a3 : 0, u2 = s3 ? 0 : a3, d2 = t.scalarTextures[l3].getVolumeInfo().scale[u2];
          if (c2.getUseGradientOpacity(a3)) {
            let t2 = [c2.getGradientOpacityMinimumOpacity(a3), c2.getGradientOpacityMaximumOpacity(a3)], s4 = [c2.getGradientOpacityMinimumValue(a3), c2.getGradientOpacityMaximumValue(a3)];
            r3[a3] = t2[0], o3[a3] = t2[1], e14[a3] = d2 * (t2[1] - t2[0]) / (s4[1] - s4[0]), n3[a3] = -s4[0] * (t2[1] - t2[0]) / (s4[1] - s4[0]) + t2[0];
          } else
            r3[a3] = 1, o3[a3] = 1, e14[a3] = 0, n3[a3] = 1;
        }
      else {
        let a3 = l2 - 1, s3 = t.previousState.multiTexturePerVolumeEnabled, u2 = s3 ? a3 : 0, d2 = s3 ? 0 : a3, f2 = t.scalarTextures[u2].getVolumeInfo().scale[d2], p2 = [c2.getGradientOpacityMinimumOpacity(0), c2.getGradientOpacityMaximumOpacity(0)], m2 = [c2.getGradientOpacityMinimumValue(0), c2.getGradientOpacityMaximumValue(0)];
        r3[0] = p2[0], o3[0] = p2[1], e14[0] = f2 * (p2[1] - p2[0]) / (m2[1] - m2[0]), n3[0] = -m2[0] * (p2[1] - p2[0]) / (m2[1] - m2[0]) + p2[0];
      }
      a2.setUniform4f(`${s2}.gradientOpacityScale`, e14), a2.setUniform4f(`${s2}.gradientOpacityShift`, n3), a2.setUniform4f(`${s2}.gradientOpacityMin`, r3), a2.setUniform4f(`${s2}.gradientOpacityMax`, o3);
    }
    let _ = c2.getLabelOutlineOpacity();
    if (a2.setUniformf(`${s2}.outlineOpacity`, _), t.numberOfLights > 0) {
      a2.setUniformf(`${s2}.ambient`, c2.getAmbient()), a2.setUniformf(`${s2}.diffuse`, c2.getDiffuse()), a2.setUniformf(`${s2}.specular`, c2.getSpecular());
      let e14 = c2.getSpecularPower();
      a2.setUniformf(`${s2}.specularPower`, e14 === 0 ? 1 : e14);
    }
  }, e12.getClippingPlaneShaderParameters = (e13, n2, r2) => {
    if (t.renderable.getClippingPlanes().length > 0) {
      let r3 = t.openGLCamera.getKeyMatrices(n2), a2 = [], o2 = [], s2 = [], c2 = t.renderable.getClippingPlanes(), l2 = c2.length;
      for (let e14 = 0; e14 < l2; ++e14) {
        let t2 = c2[e14].getNormal(), n3 = c2[e14].getOrigin();
        transformMat3(t2, t2, r3.normalMatrix), transformMat4$1(n3, n3, r3.wcvc);
        let l3 = -1 * dot$3(n3, t2);
        a2.push(t2[0]), a2.push(t2[1]), a2.push(t2[2]), o2.push(l3), s2.push(n3[0]), s2.push(n3[1]), s2.push(n3[2]);
      }
      let u = e13.getProgram();
      u.setUniform3fv("vClipPlaneNormals", a2), u.setUniformfv("vClipPlaneDistances", o2), u.setUniform3fv("vClipPlaneOrigins", s2), u.setUniformi("clip_numPlanes", l2);
    }
  }, e12.delete = chain(() => {
    t._animationRateSubscription &&= (t._animationRateSubscription.unsubscribe(), null);
  }, () => {
    t._openGLRenderWindow && l(t._openGLRenderWindow);
  }, e12.delete), e12.getRenderTargetSize = () => {
    if (t._useSmallViewport)
      return [t._smallViewportWidth, t._smallViewportHeight];
    let { usize: e13, vsize: n2 } = t._openGLRenderer.getTiledSizeAndOrigin();
    return [e13, n2];
  }, e12.getRenderTargetOffset = () => {
    let { lowerLeftU: e13, lowerLeftV: n2 } = t._openGLRenderer.getTiledSizeAndOrigin();
    return [e13, n2];
  }, e12.getCurrentSampleDistance = (e13) => {
    let n2 = e13.getVTKWindow().getInteractor(), r2 = t.renderable.getSampleDistance();
    return n2.isAnimating() ? r2 * t.renderable.getInteractionSampleDistanceFactor() : r2;
  }, e12.renderPieceStart = (n2, r2) => {
    let a2 = n2.getVTKWindow().getInteractor();
    if (t._lastScale ||= t.renderable.getInitialInteractionScale(), t._useSmallViewport = false, a2.isAnimating() && t._lastScale > 1.5 && (t._useSmallViewport = true), t._animationRateSubscription ||= a2.onAnimationFrameRateUpdate(() => {
      if (t.renderable.getAutoAdjustSampleDistances()) {
        let e13 = a2.getRecentAnimationFrameRate(), n3 = a2.getDesiredUpdateRate() / e13;
        (n3 > 1.15 || n3 < 0.85) && (t._lastScale *= n3), t._lastScale > 400 && (t._lastScale = 400), t._lastScale < 1.5 && (t._lastScale = 1.5);
      } else
        t._lastScale = t.renderable.getImageSampleDistance() * t.renderable.getImageSampleDistance();
    }), t._useSmallViewport) {
      let e13 = t._openGLRenderWindow.getFramebufferSize(), n3 = 1 / Math.sqrt(t._lastScale);
      if (t._smallViewportWidth = Math.ceil(n3 * e13[0]), t._smallViewportHeight = Math.ceil(n3 * e13[1]), t._smallViewportHeight > e13[1] && (t._smallViewportHeight = e13[1]), t._smallViewportWidth > e13[0] && (t._smallViewportWidth = e13[0]), t.framebuffer.saveCurrentBindingsAndBuffers(), t.framebuffer.getGLFramebuffer() === null)
        t.framebuffer.create(e13[0], e13[1]), t.framebuffer.populateFramebuffer();
      else {
        let n4 = t.framebuffer.getSize();
        (!n4 || n4[0] !== e13[0] || n4[1] !== e13[1]) && (t.framebuffer.create(e13[0], e13[1]), t.framebuffer.populateFramebuffer());
      }
      t.framebuffer.bind();
      let r3 = t.context;
      r3.clearColor(0, 0, 0, 0), r3.colorMask(true, true, true, true), r3.clear(r3.COLOR_BUFFER_BIT), r3.viewport(0, 0, t._smallViewportWidth, t._smallViewportHeight), t.fvp = [t._smallViewportWidth / e13[0], t._smallViewportHeight / e13[1]];
    }
    t.context.disable(t.context.DEPTH_TEST), e12.updateBufferObjects(n2, r2);
    let o2 = r2.getProperties();
    t.currentValidInputs.forEach((e13) => {
      let { inputIndex: n3 } = e13, r3 = o2[n3].getInterpolationType(), a3 = t.scalarTextures[n3];
      r3 === InterpolationType$2.NEAREST ? (a3.setMinificationFilter(Filter$1.NEAREST), a3.setMagnificationFilter(Filter$1.NEAREST)) : (a3.setMinificationFilter(Filter$1.LINEAR), a3.setMagnificationFilter(Filter$1.LINEAR));
    }), t.zBufferTexture !== null && t.zBufferTexture.activate();
  }, e12.renderPieceDraw = (n2, r2) => {
    let a2 = t.context, o2 = [
      ...t.scalarTextures,
      t.colorTexture,
      t.opacityTexture,
      t.labelOutlineThicknessTexture,
      t.jitterTexture
    ];
    o2.forEach((e13) => e13.activate()), e12.updateShaders(t.tris, n2, r2), a2.drawArrays(a2.TRIANGLES, 0, t.tris.getCABO().getElementCount()), t.tris.getVAO().release(), o2.forEach((e13) => e13.deactivate());
  }, e12.renderPieceFinish = (e13, n2) => {
    if (t.zBufferTexture !== null && t.zBufferTexture.deactivate(), t._useSmallViewport) {
      if (t.framebuffer.restorePreviousBindingsAndBuffers(), t.copyShader === null) {
        t.copyShader = t._openGLRenderWindow.getShaderCache().readyShaderProgramArray([
          "//VTK::System::Dec",
          "attribute vec4 vertexDC;",
          "uniform vec2 tfactor;",
          "varying vec2 tcoord;",
          "void main() { tcoord = vec2(vertexDC.x*0.5 + 0.5, vertexDC.y*0.5 + 0.5) * tfactor; gl_Position = vertexDC; }"
        ].join("\n"), [
          "//VTK::System::Dec",
          "//VTK::Output::Dec",
          "uniform sampler2D texture1;",
          "varying vec2 tcoord;",
          "void main() { gl_FragData[0] = texture2D(texture1,tcoord); }"
        ].join("\n"), "");
        let e15 = t.copyShader;
        t.copyVAO = vtkVertexArrayObject.newInstance(), t.copyVAO.setOpenGLRenderWindow(t._openGLRenderWindow), t.tris.getCABO().bind(), t.copyVAO.addAttributeArray(e15, t.tris.getCABO(), "vertexDC", t.tris.getCABO().getVertexOffset(), t.tris.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || vtkErrorMacro$23("Error setting vertexDC in copy shader VAO.");
      } else
        t._openGLRenderWindow.getShaderCache().readyShaderProgram(t.copyShader);
      let e14 = t._openGLRenderWindow.getFramebufferSize();
      t.context.viewport(0, 0, e14[0], e14[1]);
      let n3 = t.framebuffer.getColorTexture();
      n3.activate(), t.copyShader.setUniformi("texture", n3.getTextureUnit()), t.copyShader.setUniform2f("tfactor", t.fvp[0], t.fvp[1]);
      let r2 = t.context;
      r2.blendFuncSeparate(r2.ONE, r2.ONE_MINUS_SRC_ALPHA, r2.ONE, r2.ONE_MINUS_SRC_ALPHA), t.context.drawArrays(t.context.TRIANGLES, 0, t.tris.getCABO().getElementCount()), n3.deactivate(), r2.blendFuncSeparate(r2.SRC_ALPHA, r2.ONE_MINUS_SRC_ALPHA, r2.ONE, r2.ONE_MINUS_SRC_ALPHA);
    }
  }, e12.renderPiece = (r2, a2) => {
    e12.invokeEvent({ type: "StartEvent" }), t.renderable.update();
    let o2 = t.renderable.getNumberOfInputPorts();
    t.currentValidInputs = [];
    for (let e13 = 0; e13 < o2; ++e13) {
      let n2 = t.renderable.getInputData(e13);
      n2 && !n2.isDeleted() && t.currentValidInputs.push({
        imageData: n2,
        inputIndex: e13
      });
    }
    let s2 = 0;
    if (t.currentValidInputs.length > 0) {
      let e13 = a2.getProperties(), o3 = t.currentValidInputs[0], c2 = o3.imageData.getPointData().getScalars(), l2 = e13[o3.inputIndex];
      l2.getShade() && t.renderable.getBlendMode() === BlendMode$1.COMPOSITE_BLEND && r2.getLights().forEach((e14) => {
        e14.getSwitch() > 0 && s2++;
      });
      let u = t.currentValidInputs.length;
      t.numberOfComponents = u > 1 ? u : c2.getNumberOfComponents(), t.useIndependentComponents = n(l2, t.numberOfComponents);
    }
    s2 !== t.numberOfLights && (t.numberOfLights = s2, e12.modified()), e12.invokeEvent({ type: "EndEvent" }), t.currentValidInputs.length !== 0 && (e12.renderPieceStart(r2, a2), e12.renderPieceDraw(r2, a2), e12.renderPieceFinish(r2, a2));
  }, e12.updateBufferObjects = (t2, n2) => {
    e12.getNeedToRebuildBufferObjects(t2, n2) && e12.buildBufferObjects(t2, n2);
  }, e12.getNeedToRebuildBufferObjects = (n2, r2) => t.VBOBuildTime.getMTime() < e12.getMTime() || t.VBOBuildTime.getMTime() < r2.getMTime() || t.VBOBuildTime.getMTime() < r2.getProperty(t.currentValidInputs[0].inputIndex)?.getMTime() || t.VBOBuildTime.getMTime() < t.renderable.getMTime() || t.currentValidInputs.some((e13) => {
    let { imageData: n3 } = e13;
    return t.VBOBuildTime.getMTime() < n3.getMTime();
  }) || t.scalarTextures.length !== t.currentValidInputs.length || !t.scalarTextures.every((e13) => !!e13?.getHandle()) || !t.colorTexture?.getHandle() || !t.opacityTexture?.getHandle() || !t.labelOutlineThicknessTexture?.getHandle() || !t.jitterTexture?.getHandle(), e12.buildBufferObjects = (n2, r2) => {
    if (!t.jitterTexture.getHandle()) {
      let e13 = new Float32Array(1024);
      for (let t2 = 0; t2 < 1024; ++t2)
        e13[t2] = Math.random();
      t.jitterTexture.setMinificationFilter(Filter$1.NEAREST), t.jitterTexture.setMagnificationFilter(Filter$1.NEAREST), t.jitterTexture.create2DFromRaw({
        width: 32,
        height: 32,
        numComps: 1,
        dataType: VtkDataTypes.FLOAT,
        data: e13
      });
    }
    let a2 = r2.getProperties(), o2 = a2[t.currentValidInputs[0].inputIndex], s2 = t.numberOfComponents, l2 = t.useIndependentComponents, u = l2 ? s2 : 1, d = [];
    for (let e13 = 0; e13 < u; ++e13)
      d.push(o2.getScalarOpacity(e13));
    let f = getTransferFunctionsHash(d, l2, u), p = o2.getScalarOpacity(), m = t._openGLRenderWindow.getGraphicsResourceForObject(p);
    if (!m?.oglObject?.getHandle() || m.hash !== f) {
      let r3 = vtkOpenGLTexture$1.newInstance();
      r3.setOpenGLRenderWindow(t._openGLRenderWindow);
      let a3 = t.renderable.getOpacityTextureWidth();
      a3 <= 0 && (a3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let s3 = a3 * 2 * u, c2 = new Float32Array(s3), l3 = new Float32Array(a3);
      for (let t2 = 0; t2 < u; ++t2) {
        let r4 = o2.getScalarOpacity(t2), s4 = e12.getCurrentSampleDistance(n2) / o2.getScalarOpacityUnitDistance(t2), u2 = r4.getRange();
        r4.getTable(u2[0], u2[1], a3, l3, 1);
        for (let e13 = 0; e13 < a3; ++e13)
          c2[t2 * a3 * 2 + e13] = 1 - (1 - l3[e13]) ** s4, c2[t2 * a3 * 2 + e13 + a3] = c2[t2 * a3 * 2 + e13];
      }
      if (r3.resetFormatAndType(), r3.setMinificationFilter(Filter$1.LINEAR), r3.setMagnificationFilter(Filter$1.LINEAR), t._openGLRenderWindow.getWebgl2() || t.context.getExtension("OES_texture_float") && t.context.getExtension("OES_texture_float_linear"))
        r3.create2DFromRaw({
          width: a3,
          height: 2 * u,
          numComps: 1,
          dataType: VtkDataTypes.FLOAT,
          data: c2
        });
      else {
        let e13 = new Uint8ClampedArray(s3);
        for (let t2 = 0; t2 < s3; ++t2)
          e13[t2] = 255 * c2[t2];
        r3.create2DFromRaw({
          width: a3,
          height: 2 * u,
          numComps: 1,
          dataType: VtkDataTypes.UNSIGNED_CHAR,
          data: e13
        });
      }
      p && t._openGLRenderWindow.setGraphicsResourceForObject(p, r3, f), t.opacityTexture = r3;
    } else
      t.opacityTexture = m.oglObject;
    c(t._openGLRenderWindow, t._opacityTextureCore, p), t._opacityTextureCore = p;
    let h = [];
    for (let e13 = 0; e13 < u; ++e13)
      h.push(o2.getRGBTransferFunction(e13));
    let g = getTransferFunctionsHash(h, l2, u), _ = o2.getRGBTransferFunction(), v = t._openGLRenderWindow.getGraphicsResourceForObject(_);
    if (!v?.oglObject?.getHandle() || v?.hash !== g) {
      let e13 = vtkOpenGLTexture$1.newInstance();
      e13.setOpenGLRenderWindow(t._openGLRenderWindow);
      let n3 = t.renderable.getColorTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let r3 = n3 * 2 * u * 3, a3 = new Uint8ClampedArray(r3), s3 = new Float32Array(n3 * 3);
      for (let e14 = 0; e14 < u; ++e14) {
        let t2 = o2.getRGBTransferFunction(e14), r4 = t2.getRange();
        t2.getTable(r4[0], r4[1], n3, s3, 1);
        for (let t3 = 0; t3 < n3 * 3; ++t3)
          a3[e14 * n3 * 6 + t3] = 255 * s3[t3], a3[e14 * n3 * 6 + t3 + n3 * 3] = 255 * s3[t3];
      }
      e13.resetFormatAndType(), e13.setMinificationFilter(Filter$1.LINEAR), e13.setMagnificationFilter(Filter$1.LINEAR), e13.create2DFromRaw({
        width: n3,
        height: 2 * u,
        numComps: 3,
        dataType: VtkDataTypes.UNSIGNED_CHAR,
        data: a3
      }), t._openGLRenderWindow.setGraphicsResourceForObject(_, e13, g), t.colorTexture = e13;
    } else
      t.colorTexture = v.oglObject;
    c(t._openGLRenderWindow, t._colorTextureCore, _), t._colorTextureCore = _, t.currentValidInputs.forEach((e13, n3) => {
      let { imageData: r3, inputIndex: o3 } = e13, s3 = a2[o3], l3 = r3.getPointData().getScalars(), u2 = t._openGLRenderWindow.getGraphicsResourceForObject(l3), d2 = getImageDataHash(r3, l3), f2 = !u2?.oglObject?.getHandle() || u2?.hash !== d2, p2 = s3.getUpdatedExtents(), m2 = !!p2.length;
      if (f2 && !m2) {
        let e14 = vtkOpenGLTexture$1.newInstance();
        e14.setOpenGLRenderWindow(t._openGLRenderWindow);
        let a3 = r3.getDimensions();
        e14.setOglNorm16Ext(t.context.getExtension("EXT_texture_norm16")), e14.resetFormatAndType(), e14.create3DFilterableFromDataArray({
          width: a3[0],
          height: a3[1],
          depth: a3[2],
          dataArray: l3,
          preferSizeOverAccuracy: s3.getPreferSizeOverAccuracy()
        }), t._openGLRenderWindow.setGraphicsResourceForObject(l3, e14, d2), t.scalarTextures[n3] = e14;
      } else
        t.scalarTextures[n3] = u2.oglObject;
      if (m2) {
        s3.setUpdatedExtents([]);
        let e14 = r3.getDimensions();
        t.scalarTextures[n3].create3DFilterableFromDataArray({
          width: e14[0],
          height: e14[1],
          depth: e14[2],
          dataArray: l3,
          updatedExtents: p2
        });
      }
      c(t._openGLRenderWindow, t._scalarTexturesCore[n3], l3), t._scalarTexturesCore[n3] = l3;
    });
    let y = o2.getLabelOutlineThickness(), b = t._openGLRenderWindow.getGraphicsResourceForObject(y), S = y.join("-");
    if (!b?.oglObject?.getHandle() || b?.hash !== S) {
      let e13 = vtkOpenGLTexture$1.newInstance();
      e13.setOpenGLRenderWindow(t._openGLRenderWindow);
      let n3 = t.renderable.getLabelOutlineTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let r3 = n3 * 1, a3 = new Uint8Array(r3);
      for (let e14 = 0; e14 < n3; ++e14)
        a3[e14] = y[e14] === void 0 ? y[0] : y[e14];
      e13.resetFormatAndType(), e13.setMinificationFilter(Filter$1.NEAREST), e13.setMagnificationFilter(Filter$1.NEAREST), e13.create2DFromRaw({
        width: n3,
        height: 1,
        numComps: 1,
        dataType: VtkDataTypes.UNSIGNED_CHAR,
        data: a3
      }), y && t._openGLRenderWindow.setGraphicsResourceForObject(y, e13, S), t.labelOutlineThicknessTexture = e13;
    } else
      t.labelOutlineThicknessTexture = b.oglObject;
    if (c(t._openGLRenderWindow, t._labelOutlineThicknessTextureCore, y), t._labelOutlineThicknessTextureCore = y, !t.tris.getCABO().getElementCount()) {
      let e13 = new Float32Array(12);
      for (let t2 = 0; t2 < 4; t2++)
        e13[t2 * 3] = t2 % 2 * 2 - 1, e13[t2 * 3 + 1] = t2 > 1 ? 1 : -1, e13[t2 * 3 + 2] = -1;
      let n3 = new Uint16Array(8);
      n3[0] = 3, n3[1] = 0, n3[2] = 1, n3[3] = 3, n3[4] = 3, n3[5] = 0, n3[6] = 3, n3[7] = 2;
      let r3 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        values: e13
      });
      r3.setName("points");
      let a3 = vtkDataArray$1.newInstance({
        numberOfComponents: 1,
        values: n3
      });
      t.tris.getCABO().createVBO(a3, "polys", Representation$1.SURFACE, {
        points: r3,
        cellOffset: 0
      });
    }
    t.VBOBuildTime.modified();
  };
}
var DEFAULT_VALUES$82 = {
  context: null,
  VBOBuildTime: null,
  scalarTextures: [],
  _scalarTexturesCore: [],
  opacityTexture: null,
  _opacityTextureCore: null,
  colorTexture: null,
  _colorTextureCore: null,
  labelOutlineThicknessTexture: null,
  _labelOutlineThicknessTextureCore: null,
  jitterTexture: null,
  tris: null,
  framebuffer: null,
  copyShader: null,
  copyVAO: null,
  lastXYF: 1,
  targetXYF: 1,
  zBufferTexture: null,
  lastZBufferTexture: null,
  fullViewportTime: 1,
  idxToView: null,
  vecISToVCMatrix: null,
  modelToView: null,
  projectionToView: null,
  avgWindowArea: 0,
  avgFrameTime: 0
};
function extend$91(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$82, n), vtkViewNode$1.extend(e12, t, n), vtkReplacementShaderMapper.implementBuildShadersWithReplacements(e12, t, n), t.VBOBuildTime = {}, obj(t.VBOBuildTime, { mtime: 0 }), t.tris = vtkHelper.newInstance(), t.jitterTexture = vtkOpenGLTexture$1.newInstance(), t.jitterTexture.setWrapS(Wrap$2.REPEAT), t.jitterTexture.setWrapT(Wrap$2.REPEAT), t.framebuffer = vtkOpenGLFramebuffer.newInstance(), setGet(e12, t, ["context"]), vtkOpenGLVolumeMapper(e12, t);
}
var newInstance$86 = newInstance(extend$91, "vtkOpenGLVolumeMapper"), vtkVolumeMapper$2 = {
  newInstance: newInstance$86,
  extend: extend$91
};
registerOverride$1("vtkVolumeMapper", newInstance$86);
var { vtkDebugMacro: vtkDebugMacro$6 } = macro$1;
function vtkOpenGLPixelSpaceCallbackMapper(e12, t) {
  t.classHierarchy.push("vtkOpenGLPixelSpaceCallbackMapper"), e12.opaquePass = (n, r) => {
    t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getLastAncestorOfType("vtkOpenGLRenderWindow");
    let a = t._openGLRenderer.getAspectRatio(), o = t._openGLRenderer ? t._openGLRenderer.getRenderable().getActiveCamera() : null, s = t._openGLRenderer.getTiledSizeAndOrigin(), c = null;
    if (t.renderable.getUseZValues()) {
      let e13 = r.getZBufferTexture(), n2 = Math.floor(e13.getWidth()), a2 = Math.floor(e13.getHeight()), o2 = t._openGLRenderWindow.getContext();
      e13.bind();
      let s2 = r.getFramebuffer();
      s2 ? s2.saveCurrentBindingsAndBuffers() : vtkDebugMacro$6("No framebuffer to save/restore");
      let l = o2.createFramebuffer();
      o2.bindFramebuffer(o2.FRAMEBUFFER, l), o2.framebufferTexture2D(o2.FRAMEBUFFER, o2.COLOR_ATTACHMENT0, o2.TEXTURE_2D, e13.getHandle(), 0), o2.checkFramebufferStatus(o2.FRAMEBUFFER) === o2.FRAMEBUFFER_COMPLETE && (c = new Uint8Array(n2 * a2 * 4), o2.viewport(0, 0, n2, a2), o2.readPixels(0, 0, n2, a2, o2.RGBA, o2.UNSIGNED_BYTE, c)), s2 && s2.restorePreviousBindingsAndBuffers(), o2.deleteFramebuffer(l);
    }
    t.renderable.invokeCallback(t.renderable.getInputData(), o, a, s, c);
  }, e12.queryPass = (e13, n) => {
    e13 && t.renderable.getUseZValues() && n.requestDepth();
  };
}
var DEFAULT_VALUES$81 = {};
function extend$90(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$81, n), vtkViewNode$1.extend(e12, t, n), vtkOpenGLPixelSpaceCallbackMapper(e12, t);
}
var newInstance$85 = newInstance(extend$90, "vtkOpenGLPixelSpaceCallbackMapper"), vtkPixelSpaceCallbackMapper = {
  newInstance: newInstance$85,
  extend: extend$90
};
registerOverride$1("vtkPixelSpaceCallbackMapper", newInstance$85);
var CLASS_MAPPING$1 = /* @__PURE__ */ Object.create(null);
function registerOverride(e12, t) {
  CLASS_MAPPING$1[e12] = t;
}
function vtkWebGPUViewNodeFactory(e12, t) {
  t.classHierarchy.push("vtkWebGPUViewNodeFactory");
}
var DEFAULT_VALUES$80 = {};
function extend$89(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$80, n), t.overrides = CLASS_MAPPING$1, vtkViewNodeFactory$1.extend(e12, t, n), vtkWebGPUViewNodeFactory(e12, t);
}
macro.newInstance(extend$89, "vtkWebGPUViewNodeFactory");
function vtkWebGPUCamera(e12, t) {
  t.classHierarchy.push("vtkWebGPUCamera"), e12.getProjectionMatrix = (e13, n, r, a) => {
    if (identity$2(e13), t.renderable.getParallelProjection()) {
      let o = t.renderable.getParallelScale(), s = o * n, c = o, l = (a[0] - 1) * s, u = (a[0] + 1) * s, d = (a[1] - 1) * c, f = (a[1] + 1) * c, p = 1 / (u - l), m = 1 / (f - d);
      e13[0] = 2 * p, e13[5] = 2 * m, e13[10] = 1 / (r[1] - r[0]), e13[12] = (u + l) * p, e13[13] = (f + d) * m, e13[14] = r[1] / (r[1] - r[0]);
    } else {
      let o = Math.tan(Math.PI * t.renderable.getViewAngle() / 360), s, c;
      t.renderable.getUseHorizontalViewAngle() === true ? (s = r[0] * o, c = r[0] * o / n) : (s = r[0] * o * n, c = r[0] * o);
      let l = (a[0] - 1) * s, u = (a[0] + 1) * s, d = (a[1] - 1) * c, f = (a[1] + 1) * c;
      e13[0] = 2 * r[0] / (u - l), e13[5] = 2 * r[0] / (f - d), e13[12] = (l + u) / (u - l), e13[13] = (d + f) / (f - d), e13[10] = 0, e13[14] = r[0], e13[11] = -1, e13[15] = 0;
    }
  }, e12.convertToOpenGLDepth = (e13) => {
    if (t.renderable.getParallelProjection())
      return 1 - e13;
    let n = t.renderable.getClippingRangeByReference(), r = -n[0] / e13;
    return r = (n[0] + n[1]) / (n[1] - n[0]) + 2 * n[0] * n[1] / (r * (n[1] - n[0])), 0.5 * r + 0.5;
  }, e12.getKeyMatrices = (n) => {
    let r = n.getRenderable(), a = n.getParent();
    if (Math.max(a.getMTime(), e12.getMTime(), r.getMTime(), t.renderable.getMTime(), n.getStabilizedTime()) > t.keyMatrixTime.getMTime()) {
      let r2 = t.renderable.getViewMatrix();
      copy$4(t.keyMatrices.normalMatrix, r2), t.keyMatrices.normalMatrix[3] = 0, t.keyMatrices.normalMatrix[7] = 0, t.keyMatrices.normalMatrix[11] = 0, invert(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), transpose(t.keyMatrices.wcvc, r2);
      let a2 = n.getStabilizedCenterByReference();
      translate(t.keyMatrices.scvc, t.keyMatrices.wcvc, a2);
      let o = n.getAspectRatio(), s = t.renderable.getClippingRangeByReference();
      e12.getProjectionMatrix(t.keyMatrices.vcpc, o, s, t.renderable.getWindowCenterByReference()), multiply$2(t.keyMatrices.scpc, t.keyMatrices.vcpc, t.keyMatrices.scvc), invert(t.keyMatrices.pcsc, t.keyMatrices.scpc), t.keyMatrixTime.modified();
    }
    return t.keyMatrices;
  };
}
var DEFAULT_VALUES$79 = {
  keyMatrixTime: null,
  keyMatrices: null
};
function extend$88(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$79, n), vtkViewNode$1.extend(e12, t, n), t.keyMatrixTime = {}, macro.obj(t.keyMatrixTime), t.keyMatrices = {
    normalMatrix: new Float64Array(16),
    vcpc: new Float64Array(16),
    pcsc: new Float64Array(16),
    wcvc: new Float64Array(16),
    scpc: new Float64Array(16),
    scvc: new Float64Array(16)
  }, macro.setGet(e12, t, ["keyMatrixTime"]), vtkWebGPUCamera(e12, t);
}
registerOverride("vtkCamera", macro.newInstance(extend$88));
function vtkWebGPUBindGroup(e12, t) {
  t.classHierarchy.push("vtkWebGPUBindGroup"), e12.setBindables = (n) => {
    if (t.bindables.length === n.length) {
      let e13 = true;
      for (let r = 0; r < t.bindables.length; r++)
        t.bindables[r] !== n[r] && (e13 = false);
      if (e13)
        return;
    }
    t.bindables = n, e12.modified();
  }, e12.getBindGroupLayout = (e13) => {
    let n = [];
    for (let e14 = 0; e14 < t.bindables.length; e14++) {
      let r = t.bindables[e14].getBindGroupLayoutEntry();
      r.binding = e14, n.push(r);
    }
    return e13.getBindGroupLayout({ entries: n });
  }, e12.getBindGroup = (n) => {
    let r = e12.getMTime();
    for (let e13 = 0; e13 < t.bindables.length; e13++) {
      let n2 = t.bindables[e13].getBindGroupTime().getMTime();
      r = n2 > r ? n2 : r;
    }
    if (r < t.bindGroupTime.getMTime())
      return t.bindGroup;
    let a = [];
    for (let e13 = 0; e13 < t.bindables.length; e13++) {
      let n2 = t.bindables[e13].getBindGroupEntry();
      n2.binding = e13, a.push(n2);
    }
    return t.bindGroup = n.getHandle().createBindGroup({
      layout: e12.getBindGroupLayout(n),
      entries: a,
      label: t.label
    }), t.bindGroupTime.modified(), t.bindGroup;
  }, e12.getShaderCode = (e13) => {
    let n = [], r = e13.getBindGroupLayoutCount(t.label);
    for (let e14 = 0; e14 < t.bindables.length; e14++)
      n.push(t.bindables[e14].getShaderCode(e14, r));
    return n.join("\n");
  };
}
var DEFAULT_VALUES$78 = {
  device: null,
  handle: null,
  label: null
};
function extend$87(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$78, n), macro.obj(e12, t), t.bindables = [], t.bindGroupTime = {}, macro.obj(t.bindGroupTime, { mtime: 0 }), macro.get(e12, t, [
    "bindGroupTime",
    "handle",
    "sizeInBytes",
    "usage"
  ]), macro.setGet(e12, t, [
    "label",
    "device",
    "arrayInformation"
  ]), vtkWebGPUBindGroup(e12, t);
}
var vtkWebGPUBindGroup$1 = {
  newInstance: macro.newInstance(extend$87),
  extend: extend$87
};
function vtkWebGPUShaderModule(e12, t) {
  t.classHierarchy.push("vtkWebGPUShaderModule"), e12.initialize = (e13, n) => {
    t.device = e13, t.handle = t.device.getHandle().createShaderModule({ code: n.getCode() });
  };
}
var DEFAULT_VALUES$77 = {
  device: null,
  handle: null
};
function extend$86(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$77, n), macro.obj(e12, t), macro.get(e12, t, ["lastCameraMTime"]), macro.setGet(e12, t, ["device", "handle"]), vtkWebGPUShaderModule(e12, t);
}
var vtkWebGPUShaderModule$1 = {
  newInstance: macro.newInstance(extend$86, "vtkWebGPUShaderModule"),
  extend: extend$86
};
function substitute(e12, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, a = Array.isArray(n) ? n.join("\n") : n, o = false;
  e12.search(t) !== -1 && (o = true);
  let s = "";
  r && (s = "g");
  let c = new RegExp(t, s), l = e12.replace(c, a);
  return {
    replace: o,
    result: l
  };
}
function vtkWebGPUShaderCache(e12, t) {
  t.classHierarchy.push("vtkWebGPUShaderCache"), e12.getShaderModule = (e13) => {
    let n = e13.getType(), r = e13.getHash(), a = t._shaderModules.keys();
    for (let e14 = 0; e14 < a.length; e14++) {
      let o2 = a[e14];
      if (o2.getHash() === r && o2.getType() === n)
        return t._shaderModules.get(o2);
    }
    let o = vtkWebGPUShaderModule$1.newInstance();
    return o.initialize(t.device, e13), t._shaderModules.set(e13, o), o;
  };
}
var DEFAULT_VALUES$76 = {
  shaderModules: null,
  device: null,
  window: null
};
function extend$85(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$76, n), t._shaderModules = /* @__PURE__ */ new Map(), macro.obj(e12, t), macro.setGet(e12, t, ["device", "window"]), vtkWebGPUShaderCache(e12, t);
}
var vtkWebGPUShaderCache$1 = {
  newInstance: macro.newInstance(extend$85, "vtkWebGPUShaderCache"),
  extend: extend$85,
  substitute
};
function vtkWebGPUPipeline(e12, t) {
  t.classHierarchy.push("vtkWebGPUPipeline"), e12.getShaderDescriptions = () => t.shaderDescriptions, e12.initialize = (e13, n) => {
    t.pipelineDescription = t.renderEncoder.getPipelineSettings(), t.pipelineDescription.primitive.topology = t.topology, t.pipelineDescription.vertex = t.vertexState, t.pipelineDescription.label = n;
    let r = [];
    for (let e14 = 0; e14 < t.layouts.length; e14++)
      r.push(t.layouts[e14].layout);
    t.pipelineLayout = e13.getHandle().createPipelineLayout({ bindGroupLayouts: r }), t.pipelineDescription.layout = t.pipelineLayout;
    for (let n2 = 0; n2 < t.shaderDescriptions.length; n2++) {
      let r2 = t.shaderDescriptions[n2], a = e13.getShaderModule(r2);
      r2.getType() === "vertex" && (t.pipelineDescription.vertex.module = a.getHandle(), t.pipelineDescription.vertex.entryPoint = "main"), r2.getType() === "fragment" && (t.pipelineDescription.fragment.module = a.getHandle(), t.pipelineDescription.fragment.entryPoint = "main");
    }
    t.handle = e13.getHandle().createRenderPipeline(t.pipelineDescription);
  }, e12.getShaderDescription = (e13) => {
    for (let n = 0; n < t.shaderDescriptions.length; n++)
      if (t.shaderDescriptions[n].getType() === e13)
        return t.shaderDescriptions[n];
    return null;
  }, e12.addBindGroupLayout = (e13) => {
    e13 && t.layouts.push({
      layout: e13.getBindGroupLayout(t.device),
      label: e13.getLabel()
    });
  }, e12.getBindGroupLayout = (e13) => t.layouts[e13].layout, e12.getBindGroupLayoutCount = (e13) => {
    for (let n = 0; n < t.layouts.length; n++)
      if (t.layouts[n].label === e13)
        return n;
    return 0;
  }, e12.bindVertexInput = (e13, t2) => {
    t2.bindBuffers(e13);
  };
}
var DEFAULT_VALUES$75 = {
  handle: null,
  layouts: null,
  renderEncoder: null,
  shaderDescriptions: null,
  vertexState: null,
  topology: null,
  pipelineDescription: null
};
function extend$84(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$75, n), obj(e12, t), t.layouts = [], t.shaderDescriptions = [], get(e12, t, ["handle", "pipelineDescription"]), setGet(e12, t, [
    "device",
    "renderEncoder",
    "topology",
    "vertexState"
  ]), vtkWebGPUPipeline(e12, t);
}
var vtkWebGPUPipeline$1 = {
  newInstance: newInstance(extend$84, "vtkWebGPUPipeline"),
  extend: extend$84
};
function vtkWebGPUShaderDescription(e12, t) {
  t.classHierarchy.push("vtkWebGPUShaderDescription"), e12.hasOutput = (e13) => t.outputNames.includes(e13), e12.addOutput = function(e13, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
    t.outputTypes.push(e13), t.outputNames.push(n), t.outputInterpolations.push(r);
  }, e12.addBuiltinOutput = (e13, n) => {
    t.builtinOutputTypes.push(e13), t.builtinOutputNames.push(n);
  }, e12.addBuiltinInput = (e13, n) => {
    t.builtinInputTypes.push(e13), t.builtinInputNames.push(n);
  }, e12.replaceShaderCode = (e13, n) => {
    let r = [], a = [];
    if (n && r.push(n.getShaderCode()), e13 || t.builtinInputNames.length) {
      let n2 = [];
      if (n2.push(`struct ${t.type}Input
{`), e13) {
        let t2 = e13.getOutputNamesByReference(), r2 = e13.getOutputTypesByReference(), a2 = e13.getOutputInterpolationsByReference();
        for (let e14 = 0; e14 < t2.length; e14++)
          a2[e14] === void 0 ? n2.push(`  @location(${e14}) ${t2[e14]} : ${r2[e14]},`) : n2.push(`  @location(${e14}) @interpolate(${a2[e14]}) ${t2[e14]} : ${r2[e14]},`);
      }
      for (let e14 = 0; e14 < t.builtinInputNames.length; e14++)
        n2.push(`  ${t.builtinInputNames[e14]} : ${t.builtinInputTypes[e14]},`);
      n2.length > 1 && (n2.push("};"), a = n2, r[r.length - 1] += ",", r.push(`input: ${t.type}Input`));
    }
    if (r.length && (t.code = vtkWebGPUShaderCache$1.substitute(t.code, "//VTK::IOStructs::Input", r).result), t.outputNames.length + t.builtinOutputNames.length) {
      let e14 = [`struct ${t.type}Output
{`];
      for (let n2 = 0; n2 < t.outputNames.length; n2++)
        t.outputInterpolations[n2] === void 0 ? e14.push(`  @location(${n2}) ${t.outputNames[n2]} : ${t.outputTypes[n2]},`) : e14.push(`  @location(${n2}) @interpolate(${t.outputInterpolations[n2]}) ${t.outputNames[n2]} : ${t.outputTypes[n2]},`);
      for (let n2 = 0; n2 < t.builtinOutputNames.length; n2++)
        e14.push(`  ${t.builtinOutputNames[n2]} : ${t.builtinOutputTypes[n2]},`);
      e14.push("};"), a = a.concat(e14), t.code = vtkWebGPUShaderCache$1.substitute(t.code, "//VTK::IOStructs::Output", [`-> ${t.type}Output`]).result;
    }
    t.code = vtkWebGPUShaderCache$1.substitute(t.code, "//VTK::IOStructs::Dec", a).result;
  };
}
var DEFAULT_VALUES$74 = {
  type: null,
  hash: null,
  code: null,
  outputNames: null,
  outputTypes: null
};
function extend$83(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$74, n), t.outputNames = [], t.outputTypes = [], t.outputInterpolations = [], t.builtinOutputNames = [], t.builtinOutputTypes = [], t.builtinInputNames = [], t.builtinInputTypes = [], macro.obj(e12, t), macro.setGet(e12, t, [
    "type",
    "hash",
    "code"
  ]), macro.getArray(e12, t, [
    "outputTypes",
    "outputNames",
    "outputInterpolations"
  ]), vtkWebGPUShaderDescription(e12, t);
}
var vtkWebGPUShaderDescription$1 = {
  newInstance: macro.newInstance(extend$83, "vtkWebGPUShaderDescription"),
  extend: extend$83
}, textureDetails = {
  r8unorm: {
    numComponents: 1,
    nativeType: Uint8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "float"
  },
  r8snorm: {
    numComponents: 1,
    nativeType: Int8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "float"
  },
  r8uint: {
    numComponents: 1,
    nativeType: Uint8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "uint"
  },
  r8sint: {
    numComponents: 1,
    nativeType: Int8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "sint"
  },
  r16uint: {
    numComponents: 1,
    nativeType: Uint16Array,
    stride: 2,
    elementSize: 2,
    sampleType: "uint"
  },
  r16sint: {
    numComponents: 1,
    nativeType: Int16Array,
    stride: 2,
    elementSize: 2,
    sampleType: "sint"
  },
  r16float: {
    numComponents: 1,
    nativeType: Float32Array,
    stride: 2,
    elementSize: 2,
    sampleType: "float"
  },
  rg8unorm: {
    numComponents: 2,
    nativeType: Uint8Array,
    stride: 2,
    elementSize: 1,
    sampleType: "float"
  },
  rg8snorm: {
    numComponents: 2,
    nativeType: Int8Array,
    stride: 2,
    elementSize: 1,
    sampleType: "float"
  },
  rg8uint: {
    numComponents: 2,
    nativeType: Uint8Array,
    stride: 2,
    elementSize: 1,
    sampleType: "uint"
  },
  rg8sint: {
    numComponents: 2,
    nativeType: Int8Array,
    stride: 2,
    elementSize: 1,
    sampleType: "sint"
  },
  r32uint: {
    numComponents: 1,
    nativeType: Uint32Array,
    stride: 4,
    elementSize: 4,
    sampleType: "uint"
  },
  r32sint: {
    numComponents: 1,
    nativeType: Int32Array,
    stride: 4,
    elementSize: 4,
    sampleType: "sint"
  },
  r32float: {
    numComponents: 1,
    nativeType: Float32Array,
    stride: 4,
    elementSize: 4,
    sampleType: "unfilterable-float"
  },
  rg16uint: {
    numComponents: 2,
    nativeType: Uint16Array,
    stride: 4,
    elementSize: 2,
    sampleType: "uint"
  },
  rg16sint: {
    numComponents: 2,
    nativeType: Int16Array,
    stride: 4,
    elementSize: 2,
    sampleType: "sint"
  },
  rg16float: {
    numComponents: 2,
    nativeType: Float32Array,
    stride: 4,
    elementSize: 2,
    sampleType: "float"
  },
  rgba8unorm: {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  "rgba8unorm-srgb": {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  rgba8snorm: {
    numComponents: 4,
    nativeType: Int8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  rgba8uint: {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "uint"
  },
  rgba8sint: {
    numComponents: 4,
    nativeType: Int8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "sint"
  },
  bgra8unorm: {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  "bgra8unorm-srgb": {
    numComponents: 4,
    nativeType: Uint8Array,
    stride: 4,
    elementSize: 1,
    sampleType: "float"
  },
  rgb9e5ufloat: {
    numComponents: 4,
    nativeType: Uint32Array,
    stride: 4,
    sampleType: "float"
  },
  rgb10a2unorm: {
    numComponents: 4,
    nativeType: Uint32Array,
    stride: 4,
    sampleType: "float"
  },
  rg11b10ufloat: {
    numComponents: 4,
    nativeType: Float32Array,
    stride: 4,
    sampleType: "float"
  },
  rg32uint: {
    numComponents: 2,
    nativeType: Uint32Array,
    stride: 8,
    elementSize: 4,
    sampleType: "uint"
  },
  rg32sint: {
    numComponents: 2,
    nativeType: Int32Array,
    stride: 8,
    elementSize: 4,
    sampleType: "sint"
  },
  rg32float: {
    numComponents: 2,
    nativeType: Float32Array,
    stride: 8,
    elementSize: 4,
    sampleType: "unfilterable-float"
  },
  rgba16uint: {
    numComponents: 4,
    nativeType: Uint16Array,
    stride: 8,
    elementSize: 2,
    sampleType: "uint"
  },
  rgba16sint: {
    numComponents: 4,
    nativeType: Int16Array,
    stride: 8,
    elementSize: 2,
    sampleType: "sint"
  },
  rgba16float: {
    numComponents: 4,
    nativeType: Float32Array,
    stride: 8,
    elementSize: 2,
    sampleType: "float"
  },
  rgba32uint: {
    numComponents: 4,
    nativeType: Uint32Array,
    stride: 16,
    elementSize: 4,
    sampleType: "uint"
  },
  rgba32sint: {
    numComponents: 4,
    nativeType: Int32Array,
    stride: 16,
    elementSize: 4,
    sampleType: "sint"
  },
  rgba32float: {
    numComponents: 4,
    nativeType: Float32Array,
    stride: 16,
    elementSize: 4,
    sampleType: "unfilterable-float"
  },
  stencil8: {
    numComponents: 1,
    nativeType: Uint8Array,
    stride: 1,
    elementSize: 1,
    sampleType: "uint"
  },
  depth16unorm: {
    numComponents: 1,
    nativeType: Uint16Array,
    stride: 2,
    elementSize: 2,
    sampleType: "depth"
  },
  depth24plus: {
    numComponents: 1,
    nativeType: Uint32Array,
    stride: 4,
    elementSize: 3,
    sampleType: "depth"
  },
  "depth24plus-stencil8": {
    numComponents: 2,
    nativeType: Uint32Array,
    stride: 4,
    sampleType: "mixed"
  },
  depth32float: {
    numComponents: 1,
    nativeType: Float32Array,
    stride: 4,
    elementSize: 4,
    sampleType: "depth"
  }
};
function getDetailsFromTextureFormat(e12) {
  return !e12 || e12.length < 6 ? 0 : e12 in textureDetails ? textureDetails[e12] : (vtkErrorMacro(`unknown format ${e12}`), null);
}
function getByteStrideFromBufferFormat(e12) {
  if (!e12 || e12.length < 5)
    return 0;
  let t = 1;
  e12[e12.length - 2] === "x" && (t = Number(e12[e12.length - 1]));
  let n = t === 1 ? e12.length - 1 : e12.length - 3, r = Number(e12[n]);
  if (Number.isNaN(r))
    return vtkErrorMacro(`unknown format ${e12}`), 0;
  let a = 5 - r / 2;
  return t * a;
}
function getNumberOfComponentsFromBufferFormat(e12) {
  if (!e12 || e12.length < 5)
    return 0;
  let t = 1;
  return e12[e12.length - 2] === "x" && (t = Number(e12[e12.length - 1])), t;
}
function getNativeTypeFromBufferFormat(e12) {
  if (!e12 || e12.length < 5)
    return 0;
  let t;
  if (e12[0] === "f")
    t = "Float";
  else if (e12[0] === "s")
    t = "Int";
  else if (e12[0] === "u")
    t = "Uint";
  else {
    vtkErrorMacro(`unknown format ${e12}`);
    return;
  }
  let n = e12.split("x")[0], r = Number(n[n.length - 1]);
  if (Number.isNaN(r)) {
    vtkErrorMacro(`unknown format ${e12}`);
    return;
  }
  return t += 8 * (5 - r / 2), t += "Array", t;
}
function getShaderTypeFromBufferFormat(e12) {
  let t;
  if (e12[0] === "f" || e12[1] === "n")
    t = "f32";
  else if (e12[0] === "s" && e12[1] === "i")
    t = "i32";
  else if (e12[0] === "u" && e12[1] === "i")
    t = "u32";
  else {
    vtkErrorMacro(`unknown format ${e12}`);
    return;
  }
  let n = 1;
  return e12[e12.length - 2] === "x" && (n = Number(e12[e12.length - 1])), n === 4 ? `vec4<${t}>` : n === 3 ? `vec3<${t}>` : n === 2 ? `vec2<${t}>` : t;
}
function getByteStrideFromShaderFormat(e12) {
  if (!e12)
    return 0;
  let t = 1;
  return e12.substring(0, 3) === "vec" ? t = Number(e12[3]) : e12.substring(0, 3) === "mat" && (t = e12[3] * e12[5]), t * 4;
}
function getNativeTypeFromShaderFormat(e12) {
  if (e12) {
    if (e12.includes("f32"))
      return "Float32Array";
    if (e12.includes("i32"))
      return "Int32Array";
    if (e12.includes("u32"))
      return "Uint32Array";
    vtkErrorMacro(`unknown format ${e12}`);
  }
}
var vtkWebGPUTypes = {
  getDetailsFromTextureFormat,
  getByteStrideFromBufferFormat,
  getNumberOfComponentsFromBufferFormat,
  getNativeTypeFromBufferFormat,
  getShaderTypeFromBufferFormat,
  getByteStrideFromShaderFormat,
  getNativeTypeFromShaderFormat
};
function arraysEqual(e12, t) {
  if (e12 === t)
    return true;
  if (e12 == null || t == null || e12.length !== t.length)
    return false;
  for (let n = 0; n < e12.length; ++n)
    if (!t.includes(e12[n]))
      return false;
  return true;
}
function vtkWebGPUVertexInput(e12, t) {
  t.classHierarchy.push("vtkWebGPUVertexInput"), e12.addBuffer = function(e13, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "vertex", a = n;
    Array.isArray(a) || (a = [a]);
    for (let n2 = 0; n2 < t.inputs.length; n2++)
      if (arraysEqual(t.inputs[n2].names, a)) {
        if (t.inputs[n2].buffer === e13)
          return;
        t.inputs[n2].buffer = e13;
        return;
      }
    t.inputs.push({
      buffer: e13,
      stepMode: r,
      names: a
    }), t.inputs = t.inputs.sort((e14, t2) => e14.names[0] < t2.names[0] ? -1 : e14.names[0] > t2.names[0] ? 1 : 0);
  }, e12.removeBufferIfPresent = (e13) => {
    for (let n = 0; n < t.inputs.length; n++)
      t.inputs[n].names.includes(e13) && t.inputs.splice(n, 1);
  }, e12.getBuffer = (e13) => {
    for (let n = 0; n < t.inputs.length; n++)
      if (t.inputs[n].names.includes(e13))
        return t.inputs[n].buffer;
    return null;
  }, e12.hasAttribute = (e13) => {
    for (let n = 0; n < t.inputs.length; n++)
      if (t.inputs[n].names.includes(e13))
        return true;
    return false;
  }, e12.getAttributeTime = (e13) => {
    for (let n = 0; n < t.inputs.length; n++)
      if (t.inputs[n].names.includes(e13))
        return t.inputs[n].buffer.getSourceTime();
    return 0;
  }, e12.getShaderCode = () => {
    let e13 = "", n = 0;
    for (let r = 0; r < t.inputs.length; r++)
      for (let a = 0; a < t.inputs[r].names.length; a++) {
        let o = t.inputs[r].buffer.getArrayInformation()[a], s = vtkWebGPUTypes.getShaderTypeFromBufferFormat(o.format);
        n > 0 && (e13 += ",\n"), e13 = `${e13}  @location(${n}) ${t.inputs[r].names[a]} : ${s}`, n++;
      }
    return e13;
  }, e12.getVertexInputInformation = () => {
    let e13 = {};
    if (t.inputs.length) {
      let n = [], r = 0;
      for (let e14 = 0; e14 < t.inputs.length; e14++) {
        let a = t.inputs[e14].buffer, o = {
          arrayStride: a.getStrideInBytes(),
          stepMode: t.inputs[e14].stepMode,
          attributes: []
        }, s = a.getArrayInformation();
        for (let n2 = 0; n2 < t.inputs[e14].names.length; n2++)
          o.attributes.push({
            shaderLocation: r,
            offset: s[n2].offset,
            format: s[n2].format
          }), r++;
        n.push(o);
      }
      e13.buffers = n;
    }
    return e13;
  }, e12.bindBuffers = (e13) => {
    for (let n = 0; n < t.inputs.length; n++)
      e13.setVertexBuffer(n, t.inputs[n].buffer.getHandle());
    t.indexBuffer && e13.setIndexBuffer(t.indexBuffer.getHandle(), t.indexBuffer.getArrayInformation()[0].format);
  }, e12.getReady = () => {
  }, e12.releaseGraphicsResources = () => {
    t.created && (t.inputs = [], t.bindingDescriptions = [], t.attributeDescriptions = []);
  };
}
var DEFAULT_VALUES$73 = {
  inputs: null,
  bindingDescriptions: false,
  attributeDescriptions: null,
  indexBuffer: null
};
function extend$82(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$73, n), obj(e12, t), t.bindingDescriptions = [], t.attributeDescriptions = [], t.inputs = [], setGet(e12, t, [
    "created",
    "device",
    "handle",
    "indexBuffer"
  ]), vtkWebGPUVertexInput(e12, t);
}
var vtkWebGPUVertexInput$1 = {
  newInstance: newInstance(extend$82, "vtkWebGPUVertexInput"),
  extend: extend$82
}, vtkWebGPUSimpleMapperVS = "\n//VTK::Renderer::Dec\n\n//VTK::Color::Dec\n\n//VTK::Normal::Dec\n\n//VTK::TCoord::Dec\n\n//VTK::Select::Dec\n\n//VTK::Mapper::Dec\n\n//VTK::IOStructs::Dec\n\n@vertex\nfn main(\n//VTK::IOStructs::Input\n)\n//VTK::IOStructs::Output\n{\n  var output : vertexOutput;\n\n  // var vertex: vec4<f32> = vertexBC;\n\n  //VTK::Color::Impl\n\n  //VTK::Normal::Impl\n\n  //VTK::TCoord::Impl\n\n  //VTK::Select::Impl\n\n  //VTK::Position::Impl\n\n  return output;\n}\n", vtkWebGPUSimpleMapperFS = "\n//VTK::Renderer::Dec\n\n//VTK::Color::Dec\n\n//VTK::Normal::Dec\n\n//VTK::TCoord::Dec\n\n//VTK::Select::Dec\n\n//VTK::RenderEncoder::Dec\n\n//VTK::Mapper::Dec\n\n//VTK::IOStructs::Dec\n\n@fragment\nfn main(\n//VTK::IOStructs::Input\n)\n//VTK::IOStructs::Output\n{\n  var output : fragmentOutput;\n\n  //VTK::Color::Impl\n\n  //VTK::Normal::Impl\n\n  //VTK::Light::Impl\n\n  //VTK::TCoord::Impl\n\n  //VTK::Select::Impl\n\n  // var computedColor:vec4<f32> = vec4<f32>(1.0,0.5,0.5,1.0);\n\n  //VTK::RenderEncoder::Impl\n  return output;\n}\n";
function vtkWebGPUSimpleMapper(e12, t) {
  t.classHierarchy.push("vtkWebGPUSimpleMapper"), e12.generateShaderDescriptions = (n, r, a) => {
    let o = vtkWebGPUShaderDescription$1.newInstance({
      type: "vertex",
      hash: n,
      code: t.vertexShaderTemplate
    }), s = vtkWebGPUShaderDescription$1.newInstance({
      type: "fragment",
      hash: n,
      code: t.fragmentShaderTemplate
    }), c = r.getShaderDescriptions();
    c.push(o), c.push(s);
    let l = t.vertexShaderTemplate + t.fragmentShaderTemplate, u = RegExp("//VTK::[^:]*::", "g"), d = l.match(u).filter((e13, t2, n2) => n2.indexOf(e13) === t2).map((e13) => `replaceShader${e13.substring(7, e13.length - 2)}`);
    for (let e13 = 0; e13 < d.length; e13++) {
      let o2 = d[e13];
      o2 !== "replaceShaderIOStructs" && t.shaderReplacements.has(o2) && t.shaderReplacements.get(o2)(n, r, a);
    }
    e12.replaceShaderIOStructs(n, r, a);
  }, e12.replaceShaderIOStructs = (e13, t2, n) => {
    let r = t2.getShaderDescription("vertex");
    r.replaceShaderCode(null, n), t2.getShaderDescription("fragment").replaceShaderCode(r);
  }, e12.replaceShaderRenderEncoder = (e13, n, r) => {
    t.renderEncoder.replaceShaderCode(n);
  }, t.shaderReplacements.set("replaceShaderRenderEncoder", e12.replaceShaderRenderEncoder), e12.replaceShaderRenderer = (e13, n, r) => {
    if (!t.WebGPURenderer)
      return;
    let a = t.WebGPURenderer.getBindGroup().getShaderCode(n), o = n.getShaderDescription("vertex"), s = o.getCode();
    s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Renderer::Dec", [a]).result, o.setCode(s);
    let c = n.getShaderDescription("fragment");
    s = c.getCode(), s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Renderer::Dec", [a]).result, c.setCode(s);
  }, t.shaderReplacements.set("replaceShaderRenderer", e12.replaceShaderRenderer), e12.replaceShaderMapper = (e13, n, r) => {
    let a = t.bindGroup.getShaderCode(n), o = n.getShaderDescription("vertex"), s = o.getCode();
    s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Mapper::Dec", [a]).result, o.setCode(s);
    let c = n.getShaderDescription("fragment");
    c.addBuiltinInput("bool", "@builtin(front_facing) frontFacing"), s = c.getCode(), s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Mapper::Dec", [a]).result, c.setCode(s);
  }, t.shaderReplacements.set("replaceShaderMapper", e12.replaceShaderMapper), e12.replaceShaderPosition = (e13, t2, n) => {
    let r = t2.getShaderDescription("vertex");
    r.addBuiltinOutput("vec4<f32>", "@builtin(position) Position");
    let a = r.getCode();
    a = vtkWebGPUShaderCache$1.substitute(a, "//VTK::Position::Impl", ["    output.Position = rendererUBO.SCPCMatrix*vertexBC;"]).result, r.setCode(a);
  }, t.shaderReplacements.set("replaceShaderPosition", e12.replaceShaderPosition), e12.replaceShaderTCoord = (e13, t2, n) => {
    t2.getShaderDescription("vertex").addOutput("vec2<f32>", "tcoordVS");
  }, t.shaderReplacements.set("replaceShaderTCoord", e12.replaceShaderTCoord), e12.addTextureView = (e13) => {
    t.textureViews.includes(e13) || t.textureViews.push(e13);
  }, e12.prepareToDraw = (n) => {
    t.renderEncoder = n, e12.updateInput(), e12.updateBuffers(), e12.updateBindings(), e12.updatePipeline();
  }, e12.updateInput = () => {
  }, e12.updateBuffers = () => {
  }, e12.updateBindings = () => {
    t.bindGroup.setBindables(e12.getBindables());
  }, e12.computePipelineHash = () => {
  }, e12.registerDrawCallback = (n) => {
    n.registerDrawCallback(t.pipeline, e12.draw);
  }, e12.prepareAndDraw = (n) => {
    e12.prepareToDraw(n), n.setPipeline(t.pipeline), e12.draw(n);
  }, e12.draw = (e13) => {
    let n = e13.getBoundPipeline();
    e13.activateBindGroup(t.bindGroup), t.WebGPURenderer && t.WebGPURenderer.bindUBO(e13), n.bindVertexInput(e13, t.vertexInput);
    let r = t.vertexInput.getIndexBuffer();
    r ? e13.drawIndexed(r.getIndexCount(), t.numberOfInstances, 0, 0, 0) : e13.draw(t.numberOfVertices, t.numberOfInstances, 0, 0);
  }, e12.getBindables = () => {
    let e13 = [...t.additionalBindables];
    t.UBO && e13.push(t.UBO), t.SSBO && e13.push(t.SSBO);
    for (let n = 0; n < t.textureViews.length; n++) {
      e13.push(t.textureViews[n]);
      let r = t.textureViews[n].getSampler();
      r && e13.push(r);
    }
    return e13;
  }, e12.updatePipeline = () => {
    e12.computePipelineHash(), t.pipeline = t.device.getPipeline(t.pipelineHash), t.pipeline || (t.pipeline = vtkWebGPUPipeline$1.newInstance(), t.pipeline.setDevice(t.device), t.WebGPURenderer && t.pipeline.addBindGroupLayout(t.WebGPURenderer.getBindGroup()), t.pipeline.addBindGroupLayout(t.bindGroup), e12.generateShaderDescriptions(t.pipelineHash, t.pipeline, t.vertexInput), t.pipeline.setTopology(t.topology), t.pipeline.setRenderEncoder(t.renderEncoder), t.pipeline.setVertexState(t.vertexInput.getVertexInputInformation()), t.device.createPipeline(t.pipelineHash, t.pipeline));
  };
}
var DEFAULT_VALUES$72 = {
  additionalBindables: void 0,
  bindGroup: null,
  device: null,
  fragmentShaderTemplate: null,
  numberOfInstances: 1,
  numberOfVertices: 0,
  pipelineHash: null,
  shaderReplacements: null,
  SSBO: null,
  textureViews: null,
  topology: "triangle-list",
  UBO: null,
  vertexShaderTemplate: null,
  WebGPURenderer: null
};
function extend$81(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$72, n), vtkViewNode$1.extend(e12, t, n), t.textureViews = [], t.vertexInput = vtkWebGPUVertexInput$1.newInstance(), t.bindGroup = vtkWebGPUBindGroup$1.newInstance({ label: "mapperBG" }), t.additionalBindables = [], t.fragmentShaderTemplate = t.fragmentShaderTemplate || vtkWebGPUSimpleMapperFS, t.vertexShaderTemplate = t.vertexShaderTemplate || vtkWebGPUSimpleMapperVS, t.shaderReplacements = /* @__PURE__ */ new Map(), macro.get(e12, t, ["pipeline", "vertexInput"]), macro.setGet(e12, t, [
    "additionalBindables",
    "device",
    "fragmentShaderTemplate",
    "interpolate",
    "numberOfInstances",
    "numberOfVertices",
    "pipelineHash",
    "shaderReplacements",
    "SSBO",
    "textureViews",
    "topology",
    "UBO",
    "vertexShaderTemplate",
    "WebGPURenderer"
  ]), vtkWebGPUSimpleMapper(e12, t);
}
var vtkWebGPUSimpleMapper$1 = {
  newInstance: macro.newInstance(extend$81, "vtkWebGPUSimpleMapper"),
  extend: extend$81
};
function vtkWebGPUFullScreenQuad(e12, t) {
  t.classHierarchy.push("vtkWebGPUFullScreenQuad"), e12.replaceShaderPosition = (e13, t2, n) => {
    let r = t2.getShaderDescription("vertex");
    r.addBuiltinOutput("vec4<f32>", "@builtin(position) Position"), r.addOutput("vec4<f32>", "vertexVC");
    let a = r.getCode();
    a = vtkWebGPUShaderCache$1.substitute(a, "//VTK::Position::Impl", [
      "output.tcoordVS = vec2<f32>(vertexBC.x * 0.5 + 0.5, 1.0 - vertexBC.y * 0.5 - 0.5);",
      "output.Position = vec4<f32>(vertexBC, 1.0);",
      "output.vertexVC = vec4<f32>(vertexBC, 1);"
    ]).result, r.setCode(a);
  }, t.shaderReplacements.set("replaceShaderPosition", e12.replaceShaderPosition), e12.updateBuffers = () => {
    let e13 = t.device.getBufferManager().getFullScreenQuadBuffer();
    t.vertexInput.addBuffer(e13, ["vertexBC"]), t.numberOfVertices = 6;
  };
}
var DEFAULT_VALUES$71 = {};
function extend$80(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$71, n), vtkWebGPUSimpleMapper$1.extend(e12, t, n), vtkWebGPUFullScreenQuad(e12, t);
}
var vtkWebGPUFullScreenQuad$1 = {
  newInstance: macro.newInstance(extend$80, "vtkWebGPUFullScreenQuad"),
  extend: extend$80
}, Constants$10 = {
  BufferUsage: {
    Verts: 0,
    Lines: 1,
    Triangles: 2,
    Strips: 3,
    LinesFromStrips: 4,
    LinesFromTriangles: 5,
    Points: 6,
    UniformArray: 7,
    PointArray: 8,
    NormalsFromPoints: 9,
    Texture: 10,
    RawVertex: 11,
    Storage: 12,
    Index: 13
  },
  PrimitiveTypes: {
    Start: 0,
    Points: 0,
    Lines: 1,
    Triangles: 2,
    TriangleStrips: 3,
    TriangleEdges: 4,
    TriangleStripEdges: 5,
    End: 6
  }
}, forwarded = [
  "getMappedRange",
  "mapAsync",
  "unmap"
];
function bufferSubData(e12, t, n, r) {
  let a = r.byteLength, o = e12.createBuffer({
    size: a,
    usage: GPUBufferUsage.COPY_SRC,
    mappedAtCreation: true
  }), s = o.getMappedRange(0, a);
  new Uint8Array(s).set(new Uint8Array(r)), o.unmap();
  let c = e12.createCommandEncoder();
  c.copyBufferToBuffer(o, 0, t, n, a);
  let l = c.finish();
  e12.queue.submit([l]), o.destroy();
}
function vtkWebGPUBuffer(e12, t) {
  t.classHierarchy.push("vtkWebGPUBuffer"), e12.create = (e13, n) => {
    t.handle = t.device.getHandle().createBuffer({
      size: e13,
      usage: n,
      label: t.label
    }), t.sizeInBytes = e13, t.usage = n;
  }, e12.write = (e13) => {
    bufferSubData(t.device.getHandle(), t.handle, 0, e13.buffer);
  }, e12.createAndWrite = (e13, n) => {
    let r = Math.ceil(e13.byteLength / 4) * 4;
    t.handle = t.device.getHandle().createBuffer({
      size: r,
      usage: n,
      mappedAtCreation: true,
      label: t.label
    }), t.sizeInBytes = r, t.usage = n, new Uint8Array(t.handle.getMappedRange()).set(new Uint8Array(e13.buffer)), t.handle.unmap();
  };
  for (let n = 0; n < forwarded.length; n++)
    e12[forwarded[n]] = function() {
      return t.handle[forwarded[n]](...arguments);
    };
}
var DEFAULT_VALUES$70 = {
  device: null,
  handle: null,
  sizeInBytes: 0,
  strideInBytes: 0,
  arrayInformation: null,
  usage: null,
  label: null,
  sourceTime: null
};
function extend$79(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$70, n), macro.obj(e12, t), macro.get(e12, t, [
    "handle",
    "sizeInBytes",
    "usage"
  ]), macro.setGet(e12, t, [
    "strideInBytes",
    "device",
    "arrayInformation",
    "label",
    "sourceTime"
  ]), vtkWebGPUBuffer(e12, t);
}
var vtkWebGPUBuffer$1 = {
  newInstance: macro.newInstance(extend$79),
  extend: extend$79,
  ...Constants$10
}, { Representation: Representation$6, Interpolation } = PropertyConst;
function notImplemented$3(e12) {
  return () => macro.vtkErrorMacro(`vtkProperty::${e12} - NOT IMPLEMENTED`);
}
function vtkProperty(e12, t) {
  t.classHierarchy.push("vtkProperty"), e12.setColor = (n, r, a) => {
    Array.isArray(n) ? (t.color[0] !== n[0] || t.color[1] !== n[1] || t.color[2] !== n[2]) && (t.color[0] = n[0], t.color[1] = n[1], t.color[2] = n[2], e12.modified()) : (t.color[0] !== n || t.color[1] !== r || t.color[2] !== a) && (t.color[0] = n, t.color[1] = r, t.color[2] = a, e12.modified()), e12.setDiffuseColor(t.color), e12.setAmbientColor(t.color), e12.setSpecularColor(t.color);
  }, e12.computeCompositeColor = notImplemented$3("ComputeCompositeColor"), e12.getColor = () => {
    let e13 = 0;
    t.ambient + t.diffuse + t.specular > 0 && (e13 = 1 / (t.ambient + t.diffuse + t.specular));
    for (let n = 0; n < 3; n++)
      t.color[n] = e13 * (t.ambient * t.ambientColor[n] + t.diffuse * t.diffuseColor[n] + t.specular * t.specularColor[n]);
    return [].concat(t.color);
  }, e12.setSpecularPower = (n) => {
    let r = 1 / Math.max(1, n);
    (t.roughness !== r || t.specularPower !== n) && (t.specularPower = n, t.roughness = r, e12.modified());
  }, e12.addShaderVariable = notImplemented$3("AddShaderVariable"), e12.setInterpolationToFlat = () => e12.setInterpolation(Interpolation.FLAT), e12.setInterpolationToGouraud = () => e12.setInterpolation(Interpolation.GOURAUD), e12.setInterpolationToPhong = () => e12.setInterpolation(Interpolation.PHONG), e12.getInterpolationAsString = () => macro.enumToString(Interpolation, t.interpolation), e12.setRepresentationToWireframe = () => e12.setRepresentation(Representation$6.WIREFRAME), e12.setRepresentationToSurface = () => e12.setRepresentation(Representation$6.SURFACE), e12.setRepresentationToPoints = () => e12.setRepresentation(Representation$6.POINTS), e12.getRepresentationAsString = () => macro.enumToString(Representation$6, t.representation);
}
var DEFAULT_VALUES$69 = {
  color: [
    1,
    1,
    1
  ],
  ambientColor: [
    1,
    1,
    1
  ],
  diffuseColor: [
    1,
    1,
    1
  ],
  specularColor: [
    1,
    1,
    1
  ],
  edgeColor: [
    0,
    0,
    0
  ],
  ambient: 0,
  diffuse: 1,
  metallic: 0,
  roughness: 0.6,
  normalStrength: 1,
  emission: 1,
  baseIOR: 1.45,
  specular: 0,
  specularPower: 1,
  opacity: 1,
  interpolation: Interpolation.GOURAUD,
  representation: Representation$6.SURFACE,
  edgeVisibility: false,
  backfaceCulling: false,
  frontfaceCulling: false,
  pointSize: 1,
  lineWidth: 1,
  lighting: true,
  shading: false,
  materialName: null,
  ORMTexture: null,
  RMTexture: null
};
function extend$78(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$69, n), macro.obj(e12, t), macro.setGet(e12, t, /* @__PURE__ */ "lighting.interpolation.ambient.diffuse.metallic.roughness.normalStrength.emission.baseIOR.specular.specularPower.opacity.edgeVisibility.lineWidth.pointSize.backfaceCulling.frontfaceCulling.representation.diffuseTexture.metallicTexture.roughnessTexture.normalTexture.ambientOcclusionTexture.emissionTexture.ORMTexture.RMTexture".split(".")), macro.setGetArray(e12, t, [
    "ambientColor",
    "specularColor",
    "diffuseColor",
    "edgeColor"
  ], 3), vtkProperty(e12, t);
}
var vtkProperty$1 = {
  newInstance: macro.newInstance(extend$78, "vtkProperty"),
  extend: extend$78,
  ...PropertyConst
}, { Representation: Representation$5 } = vtkProperty$1, { PrimitiveTypes: PrimitiveTypes$3 } = Constants$10, _LimitedMap = class {
  constructor() {
    this.keys = new Uint32Array(10), this.values = new Uint32Array(10), this.count = 0;
  }
  clear() {
    this.count = 0;
  }
  has(e12) {
    for (let t = 0; t < this.count; t++)
      if (this.keys[t] === e12)
        return true;
  }
  get(e12) {
    for (let t = 0; t < this.count; t++)
      if (this.keys[t] === e12)
        return this.values[t];
  }
  set(e12, t) {
    this.count < 9 && (this.keys[this.count] = e12, this.values[this.count++] = t);
  }
};
function getPrimitiveName(e12) {
  switch (e12) {
    case PrimitiveTypes$3.Points:
      return "points";
    case PrimitiveTypes$3.Lines:
      return "lines";
    case PrimitiveTypes$3.Triangles:
    case PrimitiveTypes$3.TriangleEdges:
      return "polys";
    case PrimitiveTypes$3.TriangleStripEdges:
    case PrimitiveTypes$3.TriangleStrips:
      return "strips";
    default:
      return "";
  }
}
function _getOrAddFlatId(e12, t, n) {
  let r = e12.pointIdToFlatId[t];
  return r < 0 && (r = e12.flatId, e12.pointIdToFlatId[t] = r, e12.flatIdToPointId[e12.flatId] = t, e12.flatIdToCellId[e12.flatId] = n, e12.flatId++), r;
}
function fillCell(e12, t, n) {
  let r = e12.length;
  for (let a2 = 0; a2 < r; a2++) {
    let o2 = e12[a2];
    if (n.cellProvokedMap.has(o2)) {
      n.ibo[n.iboId++] = n.cellProvokedMap.get(o2);
      for (let s = a2 + 1; s < a2 + r; s++) {
        o2 = e12[s % r];
        let a3 = _getOrAddFlatId(n, o2, t);
        n.ibo[n.iboId++] = a3;
      }
      return;
    }
  }
  for (let a2 = 0; a2 < r; a2++) {
    let o2 = e12[a2];
    if (!n.provokedPointIds[o2]) {
      let s = _getOrAddFlatId(n, o2, t);
      n.provokedPointIds[o2] = 1, n.cellProvokedMap.set(o2, s), n.flatIdToCellId[s] = t, n.ibo[n.iboId++] = s;
      for (let c = a2 + 1; c < a2 + r; c++)
        o2 = e12[c % r], s = _getOrAddFlatId(n, o2, t), n.ibo[n.iboId++] = s;
      return;
    }
  }
  let a = e12[0], o = n.flatId;
  n.cellProvokedMap.set(a, o), n.flatIdToPointId[n.flatId] = a, n.flatIdToCellId[n.flatId] = t, n.flatId++, n.ibo[n.iboId++] = o;
  for (let s = 1; s < r; s++)
    a = e12[s], o = _getOrAddFlatId(n, a, t), n.ibo[n.iboId++] = o;
}
function countCell(e12, t, n) {
  let r = e12.length;
  n.iboSize += r;
  for (let t2 = 0; t2 < r; t2++) {
    let r2 = e12[t2];
    if (n.cellProvokedMap.has(r2))
      return;
  }
  for (let t2 = 0; t2 < r; t2++) {
    let r2 = e12[t2];
    if (!n.provokedPointIds[r2]) {
      n.provokedPointIds[r2] = 1, n.cellProvokedMap.set(r2, 1);
      return;
    }
  }
  n.cellProvokedMap.set(e12[0], 1), n.extraPoints++;
}
var processCell, _single = new Uint32Array(1), _double = new Uint32Array(2), _triple = new Uint32Array(3), _indexCellBuilders = {
  anythingToPoints(e12, t, n, r, a) {
    for (let o = 0; o < e12; ++o)
      _single[0] = t[n + o], processCell(_single, r, a);
  },
  linesToWireframe(e12, t, n, r, a) {
    for (let o = 0; o < e12 - 1; ++o)
      _double[0] = t[n + o], _double[1] = t[n + o + 1], processCell(_double, r, a);
  },
  polysToWireframe(e12, t, n, r, a) {
    if (e12 > 2)
      for (let o = 0; o < e12; ++o)
        _double[0] = t[n + o], _double[1] = t[n + (o + 1) % e12], processCell(_double, r, a);
  },
  stripsToWireframe(e12, t, n, r, a) {
    if (e12 > 2) {
      for (let o = 0; o < e12 - 1; ++o)
        _double[0] = t[n + o], _double[1] = t[n + o + 1], processCell(_double, r, a);
      for (let o = 0; o < e12 - 2; o++)
        _double[0] = t[n + o], _double[1] = t[n + o + 2], processCell(_double, r, a);
    }
  },
  polysToSurface(e12, t, n, r, a) {
    for (let o = 0; o < e12 - 2; o++)
      _triple[0] = t[n], _triple[1] = t[n + o + 1], _triple[2] = t[n + o + 2], processCell(_triple, r, a);
  },
  stripsToSurface(e12, t, n, r, a) {
    for (let o = 0; o < e12 - 2; o++)
      _triple[0] = t[n + o], _triple[1] = t[n + o + 1 + o % 2], _triple[2] = t[n + o + 1 + (o + 1) % 2], processCell(_triple, r, a);
  }
};
function vtkWebGPUIndexBuffer(e12, t) {
  t.classHierarchy.push("vtkWebGPUIndexBuffer"), e12.buildIndexBuffer = (e13) => {
    let n = e13.cells, r = e13.primitiveType, a = e13.representation, o = e13.cellOffset, s = n.getData(), c = s.length, l = getPrimitiveName(r), u = e13.numberOfPoints, d = {
      provokedPointIds: new Uint8Array(u),
      extraPoints: 0,
      iboSize: 0,
      flatId: 0,
      iboId: 0,
      cellProvokedMap: new _LimitedMap()
    }, f = null;
    f = a === Representation$5.POINTS || r === PrimitiveTypes$3.Points ? _indexCellBuilders.anythingToPoints : a === Representation$5.WIREFRAME || r === PrimitiveTypes$3.Lines ? _indexCellBuilders[`${l}ToWireframe`] : _indexCellBuilders[`${l}ToSurface`], processCell = countCell;
    let p = o || 0;
    for (let e14 = 0; e14 < c; )
      d.cellProvokedMap.clear(), f(s[e14], s, e14 + 1, p, d), e14 += s[e14] + 1, p++;
    u <= 65535 ? d.flatIdToPointId = new Uint16Array(u + d.extraPoints) : d.flatIdToPointId = new Uint32Array(u + d.extraPoints), u + d.extraPoints < 36863 ? d.pointIdToFlatId = new Int16Array(u) : d.pointIdToFlatId = new Int32Array(u), u + d.extraPoints <= 65535 ? (d.ibo = new Uint16Array(d.iboSize), e13.format = "uint16") : (d.ibo = new Uint32Array(d.iboSize), e13.format = "uint32"), p <= 65535 ? d.flatIdToCellId = new Uint16Array(u + d.extraPoints) : d.flatIdToCellId = new Uint32Array(u + d.extraPoints), d.pointIdToFlatId.fill(-1), d.provokedPointIds.fill(0), processCell = fillCell, p = o || 0;
    for (let e14 = 0; e14 < c; )
      d.cellProvokedMap.clear(), f(s[e14], s, e14 + 1, p, d), e14 += s[e14] + 1, p++;
    delete d.provokedPointIds, delete d.pointIdToFlatId, e13.nativeArray = d.ibo, t.flatIdToPointId = d.flatIdToPointId, t.flatIdToCellId = d.flatIdToCellId, t.flatSize = d.flatId, t.indexCount = d.iboId;
  };
}
var DEFAULT_VALUES$68 = {
  flatIdToPointId: null,
  flatIdToCellId: null,
  flatSize: 0,
  indexCount: 0
};
function extend$77(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$68, n), vtkWebGPUBuffer$1.extend(e12, t, n), macro.setGet(e12, t, [
    "flatIdToPointId",
    "flatIdToCellId",
    "flatSize",
    "indexCount"
  ]), vtkWebGPUIndexBuffer(e12, t);
}
var vtkWebGPUIndexBuffer$1 = {
  newInstance: macro.newInstance(extend$77),
  extend: extend$77,
  ...Constants$10
}, { BufferUsage: BufferUsage$3 } = Constants$10, { vtkErrorMacro: vtkErrorMacro$22 } = macro$1, { VtkDataTypes: VtkDataTypes$2 } = vtkDataArray$1, STATIC$3 = {};
function _getFormatForDataArray(e12) {
  let t;
  switch (e12.getDataType()) {
    case VtkDataTypes$2.UNSIGNED_CHAR:
      t = "uint8";
      break;
    case VtkDataTypes$2.FLOAT:
      t = "float32";
      break;
    case VtkDataTypes$2.UNSIGNED_INT:
      t = "uint32";
      break;
    case VtkDataTypes$2.INT:
      t = "sint32";
      break;
    case VtkDataTypes$2.DOUBLE:
      t = "float32";
      break;
    case VtkDataTypes$2.UNSIGNED_SHORT:
      t = "uint16";
      break;
    case VtkDataTypes$2.SHORT:
      t = "sin16";
      break;
    default:
      t = "float32";
      break;
  }
  switch (e12.getNumberOfComponents()) {
    case 2:
      t += "x2";
      break;
    case 3:
      t.includes("32") || vtkErrorMacro$22(`unsupported x3 type for ${t}`), t += "x3";
      break;
    case 4:
      t += "x4";
      break;
  }
  return t;
}
function packArray(e12, t, n, r, a) {
  let o = {}, s = e12.getFlatSize();
  if (!s)
    return o;
  let c = [
    0,
    0,
    0,
    0
  ];
  a.shift && (a.shift.length ? c = a.shift : c.fill(a.shift));
  let l = [
    1,
    1,
    1,
    1
  ];
  a.scale && (a.scale.length ? l = a.scale : l.fill(a.scale));
  let u = Object.prototype.hasOwnProperty.call(a, "packExtra") ? a.packExtra : false, d, f = 0, p = newTypedArray(r, s * (n + (u ? 1 : 0))), m = e12.getFlatIdToPointId();
  a.cellData && (m = e12.getFlatIdToCellId()), n === 1 ? d = function(e13) {
    p[f++] = l[0] * t[e13] + c[0];
  } : n === 2 ? d = function(e13) {
    p[f++] = l[0] * t[e13] + c[0], p[f++] = l[1] * t[e13 + 1] + c[1];
  } : n === 3 && !u ? d = function(e13) {
    p[f++] = l[0] * t[e13] + c[0], p[f++] = l[1] * t[e13 + 1] + c[1], p[f++] = l[2] * t[e13 + 2] + c[2];
  } : n === 3 && u ? d = function(e13) {
    p[f++] = l[0] * t[e13] + c[0], p[f++] = l[1] * t[e13 + 1] + c[1], p[f++] = l[2] * t[e13 + 2] + c[2], p[f++] = l[3] * 1 + c[3];
  } : n === 4 && (d = function(e13) {
    p[f++] = l[0] * t[e13] + c[0], p[f++] = l[1] * t[e13 + 1] + c[1], p[f++] = l[2] * t[e13 + 2] + c[2], p[f++] = l[3] * t[e13 + 3] + c[3];
  });
  for (let e13 = 0; e13 < s; e13++) {
    let t2 = n * m[e13];
    d(t2);
  }
  return o.nativeArray = p, o;
}
function getNormal(e12, t, n, r) {
  let a = [
    e12[r * 3] - e12[n * 3],
    e12[r * 3 + 1] - e12[n * 3 + 1],
    e12[r * 3 + 2] - e12[n * 3 + 2]
  ], o = [
    e12[t * 3] - e12[n * 3],
    e12[t * 3 + 1] - e12[n * 3 + 1],
    e12[t * 3 + 2] - e12[n * 3 + 2]
  ], s = [];
  return cross(a, o, s), normalize$1(s), s;
}
function generateNormals(e12, t) {
  let n = t.getData(), r = e12.getData();
  if (!r || !n)
    return null;
  let a = new Int8Array(e12.getNumberOfCells() * 4), o = r.length, s = 0;
  for (let e13 = 0; e13 < o; ) {
    let t2 = getNormal(n, r[e13 + 1], r[e13 + 2], r[e13 + 3]);
    a[s++] = 127 * t2[0], a[s++] = 127 * t2[1], a[s++] = 127 * t2[2], a[s++] = 127, e13 += r[e13] + 1;
  }
  return a;
}
function vtkWebGPUBufferManager(e12, t) {
  t.classHierarchy.push("vtkWebGPUBufferManager");
  function n(e13) {
    e13.dataArray && !e13.nativeArray && (e13.nativeArray = e13.dataArray.getData());
    let n2, r;
    if (e13.usage === BufferUsage$3.Index && (n2 = vtkWebGPUIndexBuffer$1.newInstance({ label: e13.label }), n2.setDevice(t.device), r = GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST, n2.buildIndexBuffer(e13), n2.createAndWrite(e13.nativeArray, r), n2.setArrayInformation([{ format: e13.format }])), n2 || (n2 = vtkWebGPUBuffer$1.newInstance({ label: e13.label }), n2.setDevice(t.device)), e13.usage === BufferUsage$3.UniformArray && (r = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST, n2.createAndWrite(e13.nativeArray, r)), e13.usage === BufferUsage$3.Storage && (r = GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST, n2.createAndWrite(e13.nativeArray, r)), e13.usage === BufferUsage$3.Texture && (r = GPUBufferUsage.COPY_SRC, n2.createAndWrite(e13.nativeArray, r)), e13.usage === BufferUsage$3.PointArray) {
      r = GPUBufferUsage.VERTEX;
      let t2 = vtkWebGPUTypes.getNativeTypeFromBufferFormat(e13.format), a = packArray(e13.indexBuffer, e13.dataArray.getData(), e13.dataArray.getNumberOfComponents(), t2, {
        packExtra: e13.packExtra,
        shift: e13.shift,
        scale: e13.scale,
        cellData: e13.cellData,
        cellOffset: e13.cellOffset
      });
      n2.createAndWrite(a.nativeArray, r), n2.setStrideInBytes(vtkWebGPUTypes.getByteStrideFromBufferFormat(e13.format)), n2.setArrayInformation([{
        offset: 0,
        format: e13.format,
        interpolation: e13.cellData ? "flat" : "perspective"
      }]);
    }
    if (e13.usage === BufferUsage$3.NormalsFromPoints) {
      r = GPUBufferUsage.VERTEX;
      let t2 = vtkWebGPUTypes.getNativeTypeFromBufferFormat(e13.format), a = generateNormals(e13.cells, e13.dataArray), o = packArray(e13.indexBuffer, a, 4, t2, { cellData: true });
      n2.createAndWrite(o.nativeArray, r), n2.setStrideInBytes(vtkWebGPUTypes.getByteStrideFromBufferFormat(e13.format)), n2.setArrayInformation([{
        offset: 0,
        format: e13.format,
        interpolation: "flat"
      }]);
    }
    return e13.usage === BufferUsage$3.RawVertex && (r = GPUBufferUsage.VERTEX, n2.createAndWrite(e13.nativeArray, r), n2.setStrideInBytes(vtkWebGPUTypes.getByteStrideFromBufferFormat(e13.format)), n2.setArrayInformation([{
      offset: 0,
      format: e13.format
    }])), n2.setSourceTime(e13.time), n2;
  }
  e12.hasBuffer = (e13) => t.device.hasCachedObject(e13), e12.getBuffer = (e13) => e13.hash ? t.device.getCachedObject(e13.hash, n, e13) : n(e13), e12.getBufferForPointArray = (t2, n2) => {
    let r = _getFormatForDataArray(t2), a = {
      hash: `${t2.getMTime()}I${n2.getMTime()}${r}`,
      usage: BufferUsage$3.PointArray,
      format: r,
      dataArray: t2,
      indexBuffer: n2
    };
    return e12.getBuffer(a);
  }, e12.getFullScreenQuadBuffer = () => {
    if (t.fullScreenQuadBuffer)
      return t.fullScreenQuadBuffer;
    t.fullScreenQuadBuffer = vtkWebGPUBuffer$1.newInstance(), t.fullScreenQuadBuffer.setDevice(t.device);
    let e13 = new Float32Array([
      -1,
      -1,
      0,
      1,
      -1,
      0,
      1,
      1,
      0,
      -1,
      -1,
      0,
      1,
      1,
      0,
      -1,
      1,
      0
    ]);
    return t.fullScreenQuadBuffer.createAndWrite(e13, GPUBufferUsage.VERTEX), t.fullScreenQuadBuffer.setStrideInBytes(12), t.fullScreenQuadBuffer.setArrayInformation([{
      offset: 0,
      format: "float32x3"
    }]), t.fullScreenQuadBuffer;
  };
}
var DEFAULT_VALUES$67 = {
  device: null,
  fullScreenQuadBuffer: null
};
function extend$76(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$67, n), obj(e12, t), setGet(e12, t, ["device"]), vtkWebGPUBufferManager(e12, t);
}
var vtkWebGPUBufferManager$1 = {
  newInstance: newInstance(extend$76),
  extend: extend$76,
  ...STATIC$3,
  ...Constants$10
}, { BufferUsage: BufferUsage$2 } = vtkWebGPUBufferManager$1, { vtkErrorMacro: vtkErrorMacro$21 } = macro;
function vtkWebGPUStorageBuffer(e12, t) {
  t.classHierarchy.push("vtkWebGPUStorageBuffer"), e12.addEntry = (e13, n) => {
    if (t._bufferEntryNames.has(e13)) {
      vtkErrorMacro$21(`entry named ${e13} already exists`);
      return;
    }
    t._bufferEntryNames.set(e13, t.bufferEntries.length);
    let r = vtkWebGPUTypes.getByteStrideFromShaderFormat(n);
    t.bufferEntries.push({
      name: e13,
      type: n,
      sizeInBytes: r,
      offset: t.sizeInBytes,
      nativeType: vtkWebGPUTypes.getNativeTypeFromShaderFormat(n)
    }), t.sizeInBytes += r;
  }, e12.send = (e13) => {
    if (!t._buffer) {
      let n = {
        nativeArray: t.Float32Array,
        usage: BufferUsage$2.Storage,
        label: t.label
      };
      t._buffer = e13.getBufferManager().getBuffer(n), t.bindGroupTime.modified(), t._sendTime.modified();
      return;
    }
    e13.getHandle().queue.writeBuffer(t._buffer.getHandle(), 0, t.arrayBuffer, 0, t.sizeInBytes * t.numberOfInstances), t._sendTime.modified();
  }, e12.createView = (e13) => {
    e13 in t || (t.arrayBuffer ||= new ArrayBuffer(t.sizeInBytes * t.numberOfInstances), t[e13] = macro.newTypedArray(e13, t.arrayBuffer));
  }, e12.setValue = (n, r, a) => {
    let o = t._bufferEntryNames.get(n);
    if (o === void 0) {
      vtkErrorMacro$21(`entry named ${n} not found in UBO`);
      return;
    }
    let s = t.bufferEntries[o];
    e12.createView(s.nativeType);
    let c = t[s.nativeType];
    c[(s.offset + r * t.sizeInBytes) / c.BYTES_PER_ELEMENT] = a;
  }, e12.setArray = (n, r, a) => {
    let o = t._bufferEntryNames.get(n);
    if (o === void 0) {
      vtkErrorMacro$21(`entry named ${n} not found in UBO`);
      return;
    }
    let s = t.bufferEntries[o];
    e12.createView(s.nativeType);
    let c = t[s.nativeType], l = (s.offset + r * t.sizeInBytes) / c.BYTES_PER_ELEMENT;
    for (let e13 = 0; e13 < a.length; e13++)
      c[l + e13] = a[e13];
  }, e12.setAllInstancesFromArray = (n, r) => {
    let a = t._bufferEntryNames.get(n);
    if (a === void 0) {
      vtkErrorMacro$21(`entry named ${n} not found in UBO`);
      return;
    }
    let o = t.bufferEntries[a];
    e12.createView(o.nativeType);
    let s = t[o.nativeType], c = r.length / t.numberOfInstances;
    for (let e13 = 0; e13 < t.numberOfInstances; e13++) {
      let n2 = (o.offset + e13 * t.sizeInBytes) / s.BYTES_PER_ELEMENT;
      for (let t2 = 0; t2 < c; t2++)
        s[n2 + t2] = r[e13 * c + t2];
    }
  }, e12.setAllInstancesFromArrayColorToFloat = (n, r) => {
    let a = t._bufferEntryNames.get(n);
    if (a === void 0) {
      vtkErrorMacro$21(`entry named ${n} not found in UBO`);
      return;
    }
    let o = t.bufferEntries[a];
    e12.createView(o.nativeType);
    let s = t[o.nativeType], c = r.length / t.numberOfInstances;
    for (let e13 = 0; e13 < t.numberOfInstances; e13++) {
      let n2 = (o.offset + e13 * t.sizeInBytes) / s.BYTES_PER_ELEMENT;
      for (let t2 = 0; t2 < c; t2++)
        s[n2 + t2] = r[e13 * c + t2] / 255;
    }
  }, e12.setAllInstancesFromArray3x3To4x4 = (n, r) => {
    let a = t._bufferEntryNames.get(n);
    if (a === void 0) {
      vtkErrorMacro$21(`entry named ${n} not found in UBO`);
      return;
    }
    let o = t.bufferEntries[a];
    e12.createView(o.nativeType);
    let s = t[o.nativeType];
    for (let e13 = 0; e13 < t.numberOfInstances; e13++) {
      let n2 = (o.offset + e13 * t.sizeInBytes) / s.BYTES_PER_ELEMENT;
      for (let t2 = 0; t2 < 3; t2++)
        for (let a2 = 0; a2 < 3; a2++)
          s[n2 + t2 * 4 + a2] = r[e13 * 9 + t2 * 3 + a2];
    }
  }, e12.getSendTime = () => t._sendTime.getMTime(), e12.getShaderCode = (e13, n) => {
    let r = [`struct ${t.label}StructEntry
{`];
    for (let e14 = 0; e14 < t.bufferEntries.length; e14++) {
      let n2 = t.bufferEntries[e14];
      r.push(`  ${n2.name}: ${n2.type},`);
    }
    return r.push(`
};
struct ${t.label}Struct
{
  values: array<${t.label}StructEntry>,
};
@binding(${e13}) @group(${n}) var<storage, read> ${t.label}: ${t.label}Struct;
`), r.join("\n");
  }, e12.getBindGroupEntry = () => ({ resource: { buffer: t._buffer.getHandle() } }), e12.clearData = () => {
    t.numberOfInstances = 0, t.sizeInBytes = 0, t.bufferEntries = [], t._bufferEntryNames = /* @__PURE__ */ new Map(), t._buffer = null, delete t.arrayBuffer, delete t.Float32Array;
  };
}
var DEFAULT_VALUES$66 = {
  bufferEntries: null,
  bufferEntryNames: null,
  sizeInBytes: 0,
  label: null,
  numberOfInstances: 1
};
function extend$75(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$66, n), macro.obj(e12, t), t._bufferEntryNames = /* @__PURE__ */ new Map(), t.bufferEntries = [], t._sendTime = {}, macro.obj(t._sendTime, { mtime: 0 }), t.bindGroupTime = {}, macro.obj(t.bindGroupTime, { mtime: 0 }), t.bindGroupLayoutEntry = t.bindGroupLayoutEntry || { buffer: { type: "read-only-storage" } }, macro.get(e12, t, ["bindGroupTime"]), macro.setGet(e12, t, [
    "device",
    "bindGroupLayoutEntry",
    "label",
    "numberOfInstances",
    "sizeInBytes"
  ]), vtkWebGPUStorageBuffer(e12, t);
}
var vtkWebGPUStorageBuffer$1 = {
  newInstance: macro.newInstance(extend$75, "vtkWebGPUStorageBuffer"),
  extend: extend$75
}, { BufferUsage: BufferUsage$1 } = vtkWebGPUBufferManager$1, { vtkErrorMacro: vtkErrorMacro$20 } = macro;
function vtkWebGPUUniformBuffer(e12, t) {
  t.classHierarchy.push("vtkWebGPUUniformBuffer"), e12.addEntry = (e13, n) => {
    if (t._bufferEntryNames.has(e13)) {
      vtkErrorMacro$20(`entry named ${e13} already exists`);
      return;
    }
    t.sortDirty = true, t._bufferEntryNames.set(e13, t.bufferEntries.length), t.bufferEntries.push({
      name: e13,
      type: n,
      sizeInBytes: vtkWebGPUTypes.getByteStrideFromShaderFormat(n),
      offset: -1,
      nativeType: vtkWebGPUTypes.getNativeTypeFromShaderFormat(n),
      packed: false
    });
  }, e12.sortBufferEntries = () => {
    if (!t.sortDirty)
      return;
    let e13 = 0, n = [], r = 4;
    for (let e14 = 0; e14 < t.bufferEntries.length; e14++) {
      let n2 = t.bufferEntries[e14];
      n2.sizeInBytes % 16 == 0 && (r = Math.max(16, r)), n2.sizeInBytes % 8 == 0 && (r = Math.max(8, r));
    }
    for (let r2 = 0; r2 < t.bufferEntries.length; r2++) {
      let a = t.bufferEntries[r2];
      a.packed === false && a.sizeInBytes % 16 == 0 && (a.packed = true, a.offset = e13, n.push(a), e13 += a.sizeInBytes);
    }
    for (let r2 = 0; r2 < t.bufferEntries.length; r2++) {
      let a = t.bufferEntries[r2];
      if (a.packed === false && a.sizeInBytes === 12)
        for (let r3 = 0; r3 < t.bufferEntries.length; r3++) {
          let o = t.bufferEntries[r3];
          if (o.packed === false && o.sizeInBytes === 4) {
            a.packed = true, a.offset = e13, n.push(a), e13 += a.sizeInBytes, o.packed = true, o.offset = e13, n.push(o), e13 += o.sizeInBytes;
            break;
          }
        }
    }
    for (let r2 = 0; r2 < t.bufferEntries.length; r2++) {
      let a = t.bufferEntries[r2];
      if (!a.packed && a.sizeInBytes % 8 == 0)
        for (let o = r2 + 1; o < t.bufferEntries.length; o++) {
          let r3 = t.bufferEntries[o];
          if (!r3.packed && r3.sizeInBytes % 8 == 0) {
            a.packed = true, a.offset = e13, n.push(a), e13 += a.sizeInBytes, r3.packed = true, r3.offset = e13, n.push(r3), e13 += r3.sizeInBytes;
            break;
          }
        }
    }
    for (let r2 = 0; r2 < t.bufferEntries.length; r2++) {
      let a = t.bufferEntries[r2];
      if (!a.packed && a.sizeInBytes % 8 == 0) {
        let r3 = false;
        for (let o = 0; !r3 && o < t.bufferEntries.length; o++) {
          let s = t.bufferEntries[o];
          if (!s.packed && s.sizeInBytes === 4)
            for (let c = o + 1; c < t.bufferEntries.length; c++) {
              let o2 = t.bufferEntries[c];
              if (!o2.packed && o2.sizeInBytes === 4) {
                a.packed = true, a.offset = e13, n.push(a), e13 += a.sizeInBytes, s.packed = true, s.offset = e13, n.push(s), e13 += s.sizeInBytes, o2.packed = true, o2.offset = e13, n.push(o2), e13 += o2.sizeInBytes, r3 = true;
                break;
              }
            }
        }
      }
    }
    for (let r2 = 0; r2 < t.bufferEntries.length; r2++) {
      let a = t.bufferEntries[r2];
      !a.packed && a.sizeInBytes > 4 && (a.packed = true, a.offset = e13, n.push(a), e13 += a.sizeInBytes);
    }
    for (let r2 = 0; r2 < t.bufferEntries.length; r2++) {
      let a = t.bufferEntries[r2];
      a.packed || (a.packed = true, a.offset = e13, n.push(a), e13 += a.sizeInBytes);
    }
    t.bufferEntries = n, t._bufferEntryNames.clear();
    for (let e14 = 0; e14 < t.bufferEntries.length; e14++)
      t._bufferEntryNames.set(t.bufferEntries[e14].name, e14);
    t.sizeInBytes = e13, t.sizeInBytes = r * Math.ceil(t.sizeInBytes / r), t.sortDirty = false;
  }, e12.sendIfNeeded = (e13) => {
    if (!t.UBO) {
      let n = {
        nativeArray: t.Float32Array,
        usage: BufferUsage$1.UniformArray,
        label: t.label
      };
      t.UBO = e13.getBufferManager().getBuffer(n), t.bindGroupTime.modified(), t.sendDirty = false;
    }
    t.sendDirty &&= (e13.getHandle().queue.writeBuffer(t.UBO.getHandle(), 0, t.arrayBuffer, 0, t.sizeInBytes), false), t.sendTime.modified();
  }, e12.createView = (e13) => {
    e13 in t || (t.arrayBuffer ||= new ArrayBuffer(t.sizeInBytes), t[e13] = macro.newTypedArray(e13, t.arrayBuffer));
  }, e12.setValue = (n, r) => {
    e12.sortBufferEntries();
    let a = t._bufferEntryNames.get(n);
    if (a === void 0) {
      vtkErrorMacro$20(`entry named ${n} not found in UBO`);
      return;
    }
    let o = t.bufferEntries[a];
    e12.createView(o.nativeType);
    let s = t[o.nativeType];
    o.lastValue !== r && (s[o.offset / s.BYTES_PER_ELEMENT] = r, t.sendDirty = true), o.lastValue = r;
  }, e12.setArray = (n, r) => {
    e12.sortBufferEntries();
    let a = t._bufferEntryNames.get(n);
    if (a === void 0) {
      vtkErrorMacro$20(`entry named ${n} not found in UBO`);
      return;
    }
    let o = t.bufferEntries[a];
    e12.createView(o.nativeType);
    let s = t[o.nativeType], c = false;
    for (let e13 = 0; e13 < r.length; e13++)
      (!o.lastValue || o.lastValue[e13] !== r[e13]) && (s[o.offset / s.BYTES_PER_ELEMENT + e13] = r[e13], c = true);
    c && (t.sendDirty = true, o.lastValue = [...r]);
  }, e12.getBindGroupEntry = () => ({ resource: { buffer: t.UBO.getHandle() } }), e12.getSendTime = () => t.sendTime.getMTime(), e12.getShaderCode = (n, r) => {
    e12.sortBufferEntries();
    let a = [`struct ${t.label}Struct
{`];
    for (let e13 = 0; e13 < t.bufferEntries.length; e13++) {
      let n2 = t.bufferEntries[e13];
      a.push(`  ${n2.name}: ${n2.type},`);
    }
    return a.push(`};
@binding(${n}) @group(${r}) var<uniform> ${t.label}: ${t.label}Struct;`), a.join("\n");
  };
}
var DEFAULT_VALUES$65 = {
  bufferEntries: null,
  bufferEntryNames: null,
  sizeInBytes: 0,
  label: null,
  bindGroupLayoutEntry: null,
  bindGroupEntry: null
};
function extend$74(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$65, n), macro.obj(e12, t), t._bufferEntryNames = /* @__PURE__ */ new Map(), t.bufferEntries = [], t.bindGroupLayoutEntry = t.bindGroupLayoutEntry || { buffer: { type: "uniform" } }, t.sendTime = {}, macro.obj(t.sendTime, { mtime: 0 }), t.bindGroupTime = {}, macro.obj(t.bindGroupTime, { mtime: 0 }), t.sendDirty = true, t.sortDirty = true, macro.get(e12, t, ["binding", "bindGroupTime"]), macro.setGet(e12, t, [
    "bindGroupLayoutEntry",
    "device",
    "label",
    "sizeInBytes"
  ]), vtkWebGPUUniformBuffer(e12, t);
}
var vtkWebGPUUniformBuffer$1 = {
  newInstance: macro.newInstance(extend$74, "vtkWebGPUUniformBuffer"),
  extend: extend$74
}, { vtkDebugMacro: vtkDebugMacro$5 } = macro$1, clearFragColorTemplate = "\n//VTK::Renderer::Dec\n\n//VTK::Mapper::Dec\n\n//VTK::TCoord::Dec\n\n//VTK::RenderEncoder::Dec\n\n//VTK::IOStructs::Dec\n\n@fragment\nfn main(\n//VTK::IOStructs::Input\n)\n//VTK::IOStructs::Output\n{\n  var output: fragmentOutput;\n\n  var computedColor: vec4<f32> = mapperUBO.BackgroundColor;\n\n  //VTK::RenderEncoder::Impl\n  return output;\n}\n", clearFragTextureTemplate = "\nfn vecToRectCoord(dir: vec3<f32>) -> vec2<f32> {\n  var tau: f32 = 6.28318530718;\n  var pi: f32 = 3.14159265359;\n  var out: vec2<f32> = vec2<f32>(0.0);\n\n  out.x = atan2(dir.z, dir.x) / tau;\n  out.x += 0.5;\n\n  var phix: f32 = length(vec2(dir.x, dir.z));\n  out.y = atan2(dir.y, phix) / pi + 0.5;\n\n  return out;\n}\n\n//VTK::Renderer::Dec\n\n//VTK::Mapper::Dec\n\n//VTK::TCoord::Dec\n\n//VTK::RenderEncoder::Dec\n\n//VTK::IOStructs::Dec\n\n@fragment\nfn main(\n//VTK::IOStructs::Input\n)\n//VTK::IOStructs::Output\n{\n  var output: fragmentOutput;\n\n  var tcoord: vec4<f32> = vec4<f32>(input.vertexVC.xy, -1, 1);\n  var V: vec4<f32> = normalize(mapperUBO.FSQMatrix * tcoord); // vec2<f32>((input.tcoordVS.x - 0.5) * 2, -(input.tcoordVS.y - 0.5) * 2);\n  // textureSampleLevel gets rid of some ugly artifacts\n  var background = textureSampleLevel(EnvironmentTexture, EnvironmentTextureSampler, vecToRectCoord(V.xyz), 0.0);\n  var computedColor: vec4<f32> = vec4<f32>(background.rgb, 1);\n\n  //VTK::RenderEncoder::Impl\n  return output;\n}\n", _fsqClearMat4 = new Float64Array(16), _tNormalMat4 = new Float64Array(16);
function getLightTypeIndex(e12) {
  return e12.getPositional() ? e12.getConeAngle() >= 90 ? 0 : 2 : 1;
}
function vtkWebGPURenderer(e12, t) {
  t.classHierarchy.push("vtkWebGPURenderer"), e12.buildPass = (n) => {
    if (n) {
      if (!t.renderable)
        return;
      t.camera = t.renderable.getActiveCamera(), e12.updateLights(), e12.prepareNodes(), e12.addMissingNode(t.camera), e12.addMissingNodes(t.renderable.getViewPropsWithNestedProps()), e12.removeUnusedNodes(), t.webgpuCamera = e12.getViewNodeFor(t.camera), e12.updateStabilizedMatrix();
    }
  }, e12.updateStabilizedMatrix = () => {
    let e13 = t.camera.getClippingRange(), n = t.camera.getPositionByReference(), r = t.camera.getDirectionOfProjectionByReference(), a = [], o = [];
    scale$3(o, r, 0.5 * (e13[0] + e13[1])), add$4(a, n, o), sub$1(o, a, t.stabilizedCenter), len(o) / (e13[1] - e13[0]) > t.recenterThreshold && (t.stabilizedCenter = a, t.stabilizedTime.modified());
  }, e12.updateLights = () => {
    let e13 = 0, n = t.renderable.getLightsByReference();
    for (let t2 = 0; t2 < n.length; ++t2)
      n[t2].getSwitch() > 0 && e13++;
    return e13 || (vtkDebugMacro$5("No lights are on, creating one."), t.renderable.createLight()), e13;
  }, e12.updateUBO = () => {
    let n = t.UBO.getSendTime();
    if (t._parent.getMTime() > n || e12.getMTime() > n || t.camera.getMTime() > n || t.renderable.getMTime() > n) {
      let n2 = t.webgpuCamera.getKeyMatrices(e12);
      t.UBO.setArray("WCVCMatrix", n2.wcvc), t.UBO.setArray("SCPCMatrix", n2.scpc), t.UBO.setArray("PCSCMatrix", n2.pcsc), t.UBO.setArray("SCVCMatrix", n2.scvc), t.UBO.setArray("VCPCMatrix", n2.vcpc), t.UBO.setArray("WCVCNormals", n2.normalMatrix), t.UBO.setValue("LightCount", t.renderable.getLights().length), t.UBO.setValue("MaxEnvironmentMipLevel", t.renderable.getEnvironmentTexture()?.getMipLevel()), t.UBO.setValue("BackgroundDiffuseStrength", t.renderable.getEnvironmentTextureDiffuseStrength()), t.UBO.setValue("BackgroundSpecularStrength", t.renderable.getEnvironmentTextureSpecularStrength());
      let r = e12.getYInvertedTiledSizeAndOrigin();
      t.UBO.setArray("viewportSize", [r.usize, r.vsize]), t.UBO.setValue("cameraParallel", t.camera.getParallelProjection());
      let a = t._parent.getDevice();
      t.UBO.sendIfNeeded(a);
    }
  }, e12.updateSSBO = () => {
    let n = t.renderable.getLights(), r = t.webgpuCamera.getKeyMatrices(e12), a = `${t.renderable.getMTime()}`;
    for (let e13 = 0; e13 < n.length; e13++)
      a += n[e13].getMTime();
    if (a !== t.lightTimeString) {
      let e13 = new Float32Array(n.length * 4), a2 = new Float32Array(n.length * 4), o = new Float32Array(n.length * 4), s = new Float32Array(n.length * 4);
      for (let t2 = 0; t2 < n.length; t2++) {
        let c2 = t2 * 4, l = n[t2].getPosition();
        transformMat4$1(l, l, r.wcvc), e13[c2] = l[0], e13[c2 + 1] = l[1], e13[c2 + 2] = l[2], e13[c2 + 3] = 0, a2[c2] = -n[t2].getDirection()[0], a2[c2 + 1] = -n[t2].getDirection()[1], a2[c2 + 2] = -n[t2].getDirection()[2], a2[c2 + 3] = 0, o[c2] = n[t2].getColor()[0], o[c2 + 1] = n[t2].getColor()[1], o[c2 + 2] = n[t2].getColor()[2], o[c2 + 3] = n[t2].getIntensity() * 5, s[c2] = getLightTypeIndex(n[t2]), s[c2 + 1] = Math.cos(radiansFromDegrees(n[t2].getConeAngle())), s[c2 + 2] = Math.cos(radiansFromDegrees(n[t2].getConeAngle() + n[t2].getConeFalloff())), s[c2 + 3] = 0;
      }
      t.SSBO.clearData(), t.SSBO.setNumberOfInstances(n.length), t.SSBO.addEntry("LightPos", "vec4<f32>"), t.SSBO.addEntry("LightDir", "vec4<f32>"), t.SSBO.addEntry("LightColor", "vec4<f32>"), t.SSBO.addEntry("LightData", "vec4<f32>"), t.SSBO.setAllInstancesFromArray("LightPos", e13), t.SSBO.setAllInstancesFromArray("LightDir", a2), t.SSBO.setAllInstancesFromArray("LightColor", o), t.SSBO.setAllInstancesFromArray("LightData", s);
      let c = t._parent.getDevice();
      t.SSBO.send(c);
    }
    t.lightTimeString = a;
  }, e12.scissorAndViewport = (t2) => {
    let n = e12.getYInvertedTiledSizeAndOrigin();
    t2.getHandle().setViewport(n.lowerLeftU, n.lowerLeftV, n.usize, n.vsize, 0, 1), t2.getHandle().setScissorRect(n.lowerLeftU, n.lowerLeftV, n.usize, n.vsize);
  }, e12.bindUBO = (e13) => {
    e13.activateBindGroup(t.bindGroup);
  }, e12.opaquePass = (n) => {
    n ? (t.renderEncoder.begin(t._parent.getCommandEncoder()), e12.updateUBO(), e12.updateSSBO()) : (e12.scissorAndViewport(t.renderEncoder), e12.clear(), t.renderEncoder.end());
  }, e12.clear = () => {
    if (t.renderable.getTransparent() || t.suppressClear)
      return;
    let n = t._parent.getDevice();
    if (!t.clearFSQ) {
      t.clearFSQ = vtkWebGPUFullScreenQuad$1.newInstance(), t.clearFSQ.setDevice(n), t.clearFSQ.setPipelineHash("clearfsq"), t.clearFSQ.setFragmentShaderTemplate(clearFragColorTemplate);
      let e13 = vtkWebGPUUniformBuffer$1.newInstance({ label: "mapperUBO" });
      e13.addEntry("FSQMatrix", "mat4x4<f32>"), e13.addEntry("BackgroundColor", "vec4<f32>"), t.clearFSQ.setUBO(e13), t.backgroundTex = t.renderable.getEnvironmentTexture();
    }
    if (t.clearFSQ.getPipelineHash() !== "clearfsqwithtexture" && t.renderable.getUseEnvironmentTextureAsBackground() && t.backgroundTex?.getImageLoaded()) {
      t.clearFSQ.setFragmentShaderTemplate(clearFragTextureTemplate);
      let e13 = vtkWebGPUUniformBuffer$1.newInstance({ label: "mapperUBO" });
      e13.addEntry("FSQMatrix", "mat4x4<f32>"), e13.addEntry("BackgroundColor", "vec4<f32>"), t.clearFSQ.setUBO(e13);
      let r2 = n.getTextureManager().getTextureForVTKTexture(t.backgroundTex, "EnvironmentTexture");
      if (r2.getReady()) {
        let e14 = r2.createView("EnvironmentTexture");
        t.clearFSQ.setTextureViews([e14]), t.backgroundTexLoaded = true;
        let a2 = t.backgroundTex.getInterpolate() ? "linear" : "nearest";
        e14.addSampler(n, {
          addressModeU: "repeat",
          addressModeV: "clamp-to-edge",
          addressModeW: "repeat",
          minFilter: a2,
          magFilter: a2,
          mipmapFilter: "linear"
        });
      }
      t.clearFSQ.setPipelineHash("clearfsqwithtexture");
    } else if (t.clearFSQ.getPipelineHash() === "clearfsqwithtexture" && !t.renderable.getUseEnvironmentTextureAsBackground()) {
      t.clearFSQ = vtkWebGPUFullScreenQuad$1.newInstance(), t.clearFSQ.setDevice(n), t.clearFSQ.setPipelineHash("clearfsq"), t.clearFSQ.setFragmentShaderTemplate(clearFragColorTemplate);
      let e13 = vtkWebGPUUniformBuffer$1.newInstance({ label: "mapperUBO" });
      e13.addEntry("FSQMatrix", "mat4x4<f32>"), e13.addEntry("BackgroundColor", "vec4<f32>"), t.clearFSQ.setUBO(e13);
    }
    let r = t.webgpuCamera.getKeyMatrices(e12), a = t.renderable.getBackgroundByReference();
    t.clearFSQ.getUBO().setArray("BackgroundColor", a), transpose(_tNormalMat4, r.normalMatrix), mul$1(_fsqClearMat4, r.scvc, r.pcsc), mul$1(_fsqClearMat4, _tNormalMat4, _fsqClearMat4), t.clearFSQ.getUBO().setArray("FSQMatrix", _fsqClearMat4), t.clearFSQ.getUBO().sendIfNeeded(n), t.clearFSQ.prepareAndDraw(t.renderEncoder);
  }, e12.translucentPass = (n) => {
    n ? t.renderEncoder.begin(t._parent.getCommandEncoder()) : (e12.scissorAndViewport(t.renderEncoder), t.renderEncoder.end());
  }, e12.volumeDepthRangePass = (n) => {
    n ? t.renderEncoder.begin(t._parent.getCommandEncoder()) : (e12.scissorAndViewport(t.renderEncoder), t.renderEncoder.end());
  }, e12.getAspectRatio = () => {
    let e13 = t._parent.getSizeByReference(), n = t.renderable.getViewportByReference();
    return e13[0] * (n[2] - n[0]) / ((n[3] - n[1]) * e13[1]);
  }, e12.convertToOpenGLDepth = (e13) => t.webgpuCamera.convertToOpenGLDepth(e13), e12.getYInvertedTiledSizeAndOrigin = () => {
    let n = e12.getTiledSizeAndOrigin();
    return n.lowerLeftV = t._parent.getSizeByReference()[1] - n.vsize - n.lowerLeftV, n;
  }, e12.getTiledSizeAndOrigin = () => {
    let e13 = t.renderable.getViewportByReference(), n = [
      0,
      0,
      1,
      1
    ], r = e13[0] - n[0], a = e13[1] - n[1], o = t._parent.normalizedDisplayToDisplay(r, a), s = Math.round(o[0]), c = Math.round(o[1]), l = e13[2] - n[0], u = e13[3] - n[1], d = t._parent.normalizedDisplayToDisplay(l, u), f = Math.round(d[0]) - s, p = Math.round(d[1]) - c;
    return f < 0 && (f = 0), p < 0 && (p = 0), {
      usize: f,
      vsize: p,
      lowerLeftU: s,
      lowerLeftV: c
    };
  }, e12.getPropFromID = (e13) => {
    for (let n = 0; n < t.children.length; n++)
      if ((t.children[n].getPropID ? t.children[n].getPropID() : -1) === e13)
        return t.children[n];
    return null;
  }, e12.getStabilizedTime = () => t.stabilizedTime.getMTime(), e12.releaseGraphicsResources = () => {
    t.selector !== null && t.selector.releaseGraphicsResources();
  };
}
var DEFAULT_VALUES$64 = {
  bindGroup: null,
  selector: null,
  renderEncoder: null,
  recenterThreshold: 20,
  suppressClear: false,
  stabilizedCenter: [
    0,
    0,
    0
  ]
};
function extend$73(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$64, n), vtkViewNode$1.extend(e12, t, n), t.UBO = vtkWebGPUUniformBuffer$1.newInstance({ label: "rendererUBO" }), t.UBO.addEntry("WCVCMatrix", "mat4x4<f32>"), t.UBO.addEntry("SCPCMatrix", "mat4x4<f32>"), t.UBO.addEntry("PCSCMatrix", "mat4x4<f32>"), t.UBO.addEntry("SCVCMatrix", "mat4x4<f32>"), t.UBO.addEntry("VCPCMatrix", "mat4x4<f32>"), t.UBO.addEntry("WCVCNormals", "mat4x4<f32>"), t.UBO.addEntry("viewportSize", "vec2<f32>"), t.UBO.addEntry("LightCount", "i32"), t.UBO.addEntry("MaxEnvironmentMipLevel", "f32"), t.UBO.addEntry("BackgroundDiffuseStrength", "f32"), t.UBO.addEntry("BackgroundSpecularStrength", "f32"), t.UBO.addEntry("cameraParallel", "u32"), t.SSBO = vtkWebGPUStorageBuffer$1.newInstance({ label: "rendererLightSSBO" }), t.lightTimeString = "", t.bindGroup = vtkWebGPUBindGroup$1.newInstance({ label: "rendererBG" }), t.bindGroup.setBindables([t.UBO, t.SSBO]), t.tmpMat4 = identity$2(new Float64Array(16)), t.stabilizedTime = {}, obj(t.stabilizedTime, { mtime: 0 }), get(e12, t, ["bindGroup", "stabilizedTime"]), getArray(e12, t, ["stabilizedCenter"]), setGet(e12, t, [
    "renderEncoder",
    "selector",
    "suppressClear",
    "UBO"
  ]), vtkWebGPURenderer(e12, t);
}
registerOverride("vtkRenderer", newInstance(extend$73, "vtkWebGPURenderer"));
function vtkWebGPUSampler(e12, t) {
  t.classHierarchy.push("vtkWebGPUSampler"), e12.create = function(e13) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    t.device = e13, t.options.addressModeU = n.addressModeU ? n.addressModeU : "clamp-to-edge", t.options.addressModeV = n.addressModeV ? n.addressModeV : "clamp-to-edge", t.options.addressModeW = n.addressModeW ? n.addressModeW : "clamp-to-edge", t.options.magFilter = n.magFilter ? n.magFilter : "nearest", t.options.minFilter = n.minFilter ? n.minFilter : "nearest", t.options.mipmapFilter = n.mipmapFilter ? n.mipmapFilter : "nearest", t.options.label = t.label, t.handle = t.device.getHandle().createSampler(t.options), t.bindGroupTime.modified();
  }, e12.getShaderCode = (e13, n) => `@binding(${e13}) @group(${n}) var ${t.label}: sampler;`, e12.getBindGroupEntry = () => ({ resource: t.handle });
}
var DEFAULT_VALUES$63 = {
  device: null,
  handle: null,
  label: null,
  options: null
};
function extend$72(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$63, n), macro.obj(e12, t), t.options = {}, t.bindGroupLayoutEntry = {
    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
    sampler: {}
  }, t.bindGroupTime = {}, macro.obj(t.bindGroupTime, { mtime: 0 }), macro.get(e12, t, [
    "bindGroupTime",
    "handle",
    "options"
  ]), macro.setGet(e12, t, [
    "bindGroupLayoutEntry",
    "device",
    "label"
  ]), vtkWebGPUSampler(e12, t);
}
var vtkWebGPUSampler$1 = {
  newInstance: macro.newInstance(extend$72),
  extend: extend$72
}, { SlicingMode: SlicingMode$1 } = Constants$3, imgFragTemplate = "\n//VTK::Renderer::Dec\n\n//VTK::Mapper::Dec\n\n//VTK::TCoord::Dec\n\n//VTK::Image::Dec\n\n//VTK::RenderEncoder::Dec\n\n//VTK::IOStructs::Dec\n\n@fragment\nfn main(\n//VTK::IOStructs::Input\n)\n//VTK::IOStructs::Output\n{\n  var output: fragmentOutput;\n\n  //VTK::Image::Sample\n\n  // var computedColor: vec4<f32> = vec4<f32>(1.0,0.7, 0.5, 1.0);\n\n//VTK::RenderEncoder::Impl\n\n  return output;\n}\n";
function computeFnToString(e12, t, n) {
  if (t.apply(e12)) {
    let t2 = e12.getIndependentComponents();
    return `${e12.getMTime()}-${t2}-${n}`;
  }
  return "0";
}
var tmpMat4 = new Float64Array(16), tmp2Mat4 = new Float64Array(16), tmp3Mat4 = new Float64Array(16), ptsArray1 = new Float64Array(4), ptsArray2 = new Float64Array(4);
function vtkWebGPUImageMapper(e12, t) {
  t.classHierarchy.push("vtkWebGPUImageMapper"), e12.buildPass = (n2) => {
    if (n2) {
      t.WebGPUImageSlice = e12.getFirstAncestorOfType("vtkWebGPUImageSlice"), t.WebGPURenderer = t.WebGPUImageSlice.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent(), t.device = t.WebGPURenderWindow.getDevice();
      let n3 = t.WebGPURenderer.getRenderable();
      t.renderable.getSliceAtFocalPoint() && t.renderable.setSliceFromCamera(n3.getActiveCamera());
    }
  }, e12.translucentPass = (t2) => {
    t2 && e12.render();
  }, e12.opaquePass = (t2) => {
    t2 && e12.render();
  }, e12.render = () => {
    t.renderable.update(), t.currentInput = t.renderable.getInputData(), e12.prepareToDraw(t.WebGPURenderer.getRenderEncoder()), t.renderEncoder.registerDrawCallback(t.pipeline, e12.draw);
  }, e12.computePipelineHash = () => {
    let e13 = t.currentInput.getExtent();
    e13[0] === e13[1] || e13[2] === e13[3] || e13[4] === e13[5] ? (t.dimensions = 2, t.pipelineHash = "img2") : (t.dimensions = 3, t.pipelineHash = "img3");
  }, e12.updateUBO = () => {
    let n2 = t.UBO.getSendTime(), r2 = t.WebGPUImageSlice.getRenderable(), a = r2.getMapper();
    if (e12.getMTime() > n2 || t.renderable.getMTime() > n2 || r2.getProperty().getMTime() > n2) {
      let e13 = a.getInputData(), n3 = t.WebGPURenderer.getStabilizedCenterByReference();
      identity$2(tmpMat4), translate(tmpMat4, tmpMat4, n3), transpose(tmp2Mat4, r2.getMatrix()), invert(tmp2Mat4, tmp2Mat4), multiply$2(tmpMat4, tmp2Mat4, tmpMat4), multiply$2(tmpMat4, e13.getWorldToIndex(), tmpMat4), invert(tmp3Mat4, tmpMat4), fromTranslation(tmp2Mat4, [
        0.5,
        0.5,
        0.5
      ]), multiply$2(tmpMat4, tmp2Mat4, tmpMat4);
      let o = e13.getDimensions();
      identity$2(tmp2Mat4), scale$4(tmp2Mat4, tmp2Mat4, [
        1 / o[0],
        1 / o[1],
        1 / o[2]
      ]), multiply$2(tmpMat4, tmp2Mat4, tmpMat4), t.UBO.setArray("SCTCMatrix", tmpMat4);
      let s = t.currentInput.getExtent(), { ijkMode: c } = t.renderable.getClosestIJKAxis(), l = t.renderable.getSlice();
      c !== t.renderable.getSlicingMode() && (l = t.renderable.getSliceAtPosition(l));
      let u = 2, d = 0, f = 1;
      c === SlicingMode$1.I ? (u = 0, d = 1, f = 2) : c === SlicingMode$1.J && (u = 1, d = 2, f = 0), ptsArray1[u] = l, ptsArray1[d] = s[d * 2] - 0.5, ptsArray1[f] = s[f * 2] - 0.5, ptsArray1[3] = 1, transformMat4(ptsArray1, ptsArray1, tmp3Mat4), t.UBO.setArray("Origin", ptsArray1), ptsArray2[u] = l, ptsArray2[d] = s[d * 2 + 1] + 0.5, ptsArray2[f] = s[f * 2] - 0.5, ptsArray2[3] = 1, transformMat4(ptsArray2, ptsArray2, tmp3Mat4), subtract$2(ptsArray2, ptsArray2, ptsArray1), ptsArray2[3] = 1, t.UBO.setArray("Axis1", ptsArray2), ptsArray2[u] = l, ptsArray2[d] = s[d * 2] - 0.5, ptsArray2[f] = s[f * 2 + 1] + 0.5, ptsArray2[3] = 1, transformMat4(ptsArray2, ptsArray2, tmp3Mat4), subtract$2(ptsArray2, ptsArray2, ptsArray1), ptsArray2[3] = 1, t.UBO.setArray("Axis2", ptsArray2);
      let p = [
        1,
        1,
        1,
        1
      ], m = [
        0,
        0,
        0,
        0
      ], h = t.textureViews[0], g = h.getTexture().getScale(), _ = h.getTexture().getNumberOfComponents();
      for (let e14 = 0; e14 < _; e14++) {
        let t2 = r2.getProperty().getColorWindow(), n4 = r2.getProperty().getColorLevel(), a2 = r2.getProperty().getRGBTransferFunction(0);
        if (a2) {
          let e15 = a2.getRange();
          t2 = e15[1] - e15[0], n4 = 0.5 * (e15[1] + e15[0]);
        }
        p[e14] = g / t2, m[e14] = -n4 / t2 + 0.5;
      }
      t.UBO.setArray("cScale", p), t.UBO.setArray("cShift", m), t.UBO.sendIfNeeded(t.device);
    }
  }, e12.updateLUTImage = () => {
    let n2 = t.WebGPUImageSlice.getRenderable().getProperty();
    e12.getTextureViews()[0].getTexture().getNumberOfComponents();
    let r2 = computeFnToString(n2, n2.getRGBTransferFunction, 1);
    if (t.colorTextureString !== r2) {
      t.numRows = 1;
      let e13 = new Uint8ClampedArray(t.numRows * 2 * t.rowLength * 4), a = n2.getRGBTransferFunction();
      if (a) {
        let r3 = new Float32Array(t.rowLength * 3);
        for (let o = 0; o < 1; o++) {
          a = n2.getRGBTransferFunction(o);
          let s = a.getRange();
          a.getTable(s[0], s[1], t.rowLength, r3, 1);
          for (let n3 = 0; n3 < t.rowLength; n3++) {
            let a2 = o * t.rowLength * 8 + n3 * 4;
            e13[a2] = 255 * r3[n3 * 3], e13[a2 + 1] = 255 * r3[n3 * 3 + 1], e13[a2 + 2] = 255 * r3[n3 * 3 + 2], e13[a2 + 3] = 255;
            for (let n4 = 0; n4 < 4; n4++)
              e13[a2 + t.rowLength * 4 + n4] = e13[a2 + n4];
          }
        }
      } else
        for (let n3 = 0; n3 < t.rowLength; ++n3) {
          let r3 = 255 * n3 / (t.rowLength - 1);
          e13[n3 * 4] = r3, e13[n3 * 4 + 1] = r3, e13[n3 * 4 + 2] = r3, e13[n3 * 4 + 3] = 255;
          for (let r4 = 0; r4 < 4; r4++)
            e13[n3 * 4 + t.rowLength * 4 + r4] = e13[n3 * 4 + r4];
        }
      {
        let n3 = {
          nativeArray: e13,
          width: t.rowLength,
          height: t.numRows * 2,
          depth: 1,
          format: "rgba8unorm"
        }, r3 = t.device.getTextureManager().getTexture(n3).createView("tfunTexture");
        t.textureViews[1] = r3;
      }
      t.colorTextureString = r2;
    }
  };
  let n = e12.updateBuffers;
  e12.updateBuffers = () => {
    n();
    let r2 = t.device.getTextureManager().getTextureForImageData(t.currentInput), a = t.textureViews;
    (!a[0] || a[0].getTexture() !== r2) && (a[0] = r2.createView("imgTexture")), e12.updateLUTImage(), e12.updateUBO();
    let o = t.WebGPUImageSlice.getRenderable().getProperty().getInterpolationType() === InterpolationType$1.NEAREST ? "nearest" : "linear";
    (!t.clampSampler || o !== t.clampSampler.getOptions().minFilter) && (t.clampSampler = vtkWebGPUSampler$1.newInstance({ label: "clampSampler" }), t.clampSampler.create(t.device, {
      minFilter: o,
      magFilter: o
    }), t.additionalBindables = [t.clampSampler]);
  };
  let r = e12.getShaderReplacements();
  e12.replaceShaderPosition = (e13, n2, r2) => {
    let a = n2.getShaderDescription("vertex");
    a.addBuiltinOutput("vec4<f32>", "@builtin(position) Position");
    let o = a.getCode(), s = [
      "var pos: vec4<f32> = mapperUBO.Origin +",
      "   (vertexBC.x * 0.5 + 0.5) * mapperUBO.Axis1 + (vertexBC.y * 0.5 + 0.5) * mapperUBO.Axis2;",
      "pos.w = 1.0;"
    ];
    t.dimensions === 2 ? s.push("var tcoord : vec2<f32> = (mapperUBO.SCTCMatrix * pos).xy;") : s.push("var tcoord : vec3<f32> = (mapperUBO.SCTCMatrix * pos).xyz;"), s.push("output.tcoordVS = tcoord;", "output.Position = rendererUBO.SCPCMatrix * pos;"), o = vtkWebGPUShaderCache$1.substitute(o, "//VTK::Position::Impl", s).result, a.setCode(o);
  }, r.set("replaceShaderPosition", e12.replaceShaderPosition), e12.replaceShaderTCoord = (e13, n2, r2) => {
    let a = n2.getShaderDescription("vertex");
    t.dimensions === 2 ? a.addOutput("vec2<f32>", "tcoordVS") : a.addOutput("vec3<f32>", "tcoordVS");
  }, r.set("replaceShaderTCoord", e12.replaceShaderTCoord), e12.replaceShaderImage = (e13, n2, r2) => {
    let a = n2.getShaderDescription("fragment"), o = a.getCode();
    o = (t.dimensions, vtkWebGPUShaderCache$1.substitute(o, "//VTK::Image::Sample", [
      "    var computedColor: vec4<f32> =",
      "      textureSampleLevel(imgTexture, clampSampler, input.tcoordVS, 0.0);",
      "//VTK::Image::Sample"
    ]).result), o = vtkWebGPUShaderCache$1.substitute(o, "//VTK::Image::Sample", [
      "    var coord: vec2<f32> =",
      "      vec2<f32>(computedColor.r * mapperUBO.cScale.r + mapperUBO.cShift.r, 0.5);",
      "    computedColor = textureSampleLevel(tfunTexture, clampSampler, coord, 0.0);"
    ]).result, a.setCode(o);
  }, r.set("replaceShaderImage", e12.replaceShaderImage);
}
var DEFAULT_VALUES$62 = { rowLength: 1024 };
function extend$71(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$62, n), vtkWebGPUFullScreenQuad$1.extend(e12, t, n), e12.setFragmentShaderTemplate(imgFragTemplate), t.UBO = vtkWebGPUUniformBuffer$1.newInstance({ label: "mapperUBO" }), t.UBO.addEntry("SCTCMatrix", "mat4x4<f32>"), t.UBO.addEntry("Origin", "vec4<f32>"), t.UBO.addEntry("Axis2", "vec4<f32>"), t.UBO.addEntry("Axis1", "vec4<f32>"), t.UBO.addEntry("cScale", "vec4<f32>"), t.UBO.addEntry("cShift", "vec4<f32>"), t.lutBuildTime = {}, obj(t.lutBuildTime, { mtime: 0 }), t.imagemat = identity$2(new Float64Array(16)), t.imagematinv = identity$2(new Float64Array(16)), t.VBOBuildTime = {}, obj(t.VBOBuildTime), vtkWebGPUImageMapper(e12, t);
}
registerOverride("vtkImageMapper", newInstance(extend$71, "vtkWebGPUImageMapper"));
function vtkWebGPUImageSlice(e12, t) {
  t.classHierarchy.push("vtkWebGPUImageSlice"), e12.buildPass = (n) => {
    if (!(!t.renderable || !t.renderable.getVisibility()) && n) {
      if (!t.renderable)
        return;
      t.WebGPURenderer = e12.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getFirstAncestorOfType("vtkWebGPURenderWindow"), t.propID === void 0 && (t.propID = t.WebGPURenderWindow.getUniquePropID()), e12.prepareNodes(), e12.addMissingNode(t.renderable.getMapper()), e12.removeUnusedNodes();
    }
  }, e12.traverseOpaquePass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children.forEach((e13) => {
      e13.traverse(n);
    }), e12.apply(n, false));
  }, e12.traverseTranslucentPass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children.forEach((e13) => {
      e13.traverse(n);
    }), e12.apply(n, false));
  }, e12.queryPass = (e13, n) => {
    if (e13) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, e12.getBufferShift = (n) => (e12.getKeyMatrices(n), t.bufferShift), e12.getKeyMatrices = (e13) => {
    if (Math.max(t.renderable.getMTime(), e13.getStabilizedTime()) > t.keyMatricesTime.getMTime()) {
      t.renderable.computeMatrix();
      let n = t.renderable.getMatrix(), r = e13.getStabilizedCenterByReference();
      t.bufferShift[0] = n[3] - r[0], t.bufferShift[1] = n[7] - r[1], t.bufferShift[2] = n[11] - r[2], transpose(t.keyMatrices.bcwc, n), t.renderable.getIsIdentity() ? identity$2(t.keyMatrices.normalMatrix) : (copy$4(t.keyMatrices.normalMatrix, t.keyMatrices.bcwc), t.keyMatrices.normalMatrix[3] = 0, t.keyMatrices.normalMatrix[7] = 0, t.keyMatrices.normalMatrix[11] = 0, invert(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), transpose(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix)), translate(t.keyMatrices.bcwc, t.keyMatrices.bcwc, [
        -t.bufferShift[0],
        -t.bufferShift[1],
        -t.bufferShift[2]
      ]), translate(t.keyMatrices.bcsc, t.keyMatrices.bcwc, [
        -r[0],
        -r[1],
        -r[2]
      ]), t.keyMatricesTime.modified();
    }
    return t.keyMatrices;
  };
}
var DEFAULT_VALUES$61 = {
  bufferShift: void 0,
  keyMatrixTime: null,
  keyMatrices: null,
  propID: void 0
};
function extend$70(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$61, n), vtkViewNode$1.extend(e12, t, n), t.keyMatricesTime = {}, obj(t.keyMatricesTime, { mtime: 0 }), t.keyMatrices = {
    normalMatrix: new Float64Array(16),
    bcwc: new Float64Array(16),
    bcsc: new Float64Array(16)
  }, t.keyMatrixTime = {}, obj(t.keyMatrixTime, { mtime: 0 }), t.keyMatrices = { mcwc: identity$2(new Float64Array(16)) }, t.bufferShift = [
    0,
    0,
    0,
    0
  ], get(e12, t, ["propID", "keyMatricesTime"]), vtkWebGPUImageSlice(e12, t);
}
registerOverride("vtkImageSlice", newInstance(extend$70, "vtkWebGPUImageSlice"));
function vtkWebGPUVolume(e12, t) {
  t.classHierarchy.push("vtkWebGPUVolume"), e12.buildPass = (n2) => {
    !t.renderable || !t.renderable.getVisibility() || n2 && (t.WebGPURenderer = e12.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getFirstAncestorOfType("vtkWebGPURenderWindow"), t.propID === void 0 && (t.propID = t.WebGPURenderWindow.getUniquePropID()), t.renderable.getMapper().update());
  }, e12.queryPass = (n2, r2) => {
    if (n2) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      let n3 = t.renderable.getMapper().getBounds();
      if (!n3 || n3.length !== 6 || n3[0] > n3[1])
        return;
      r2.addVolume(e12);
    }
  };
  let n = new Float64Array(3), r = new Float64Array(3);
  e12.getBoundingCubePoints = (e13, a) => {
    let o = t.renderable.getMapper().getInputData();
    if (!o)
      return;
    let s = o.getExtent(), c = t.renderable.getMatrix(), l = 0;
    for (let t2 = 4; t2 < 6; t2++) {
      n[2] = s[t2];
      for (let t3 = 2; t3 < 4; t3++) {
        n[1] = s[t3];
        for (let t4 = 0; t4 < 2; t4++) {
          n[0] = s[t4], o.indexToWorld(n, r);
          let u = a + l * 3;
          e13[u++] = c[0] * r[0] + c[1] * r[1] + c[2] * r[2] + c[3], e13[u++] = c[4] * r[0] + c[5] * r[1] + c[6] * r[2] + c[7], e13[u++] = c[8] * r[0] + c[9] * r[1] + c[10] * r[2] + c[11], l++;
        }
      }
    }
  }, e12.getKeyMatrices = (e13) => {
    if (Math.max(t.renderable.getMTime(), e13.getStabilizedTime()) > t.keyMatricesTime.getMTime()) {
      t.renderable.computeMatrix();
      let n2 = t.renderable.getMatrix(), r2 = e13.getStabilizedCenterByReference();
      transpose(t.keyMatrices.bcwc, n2), translate(t.keyMatrices.bcsc, t.keyMatrices.bcwc, [
        -r2[0],
        -r2[1],
        -r2[2]
      ]), t.keyMatricesTime.modified();
    }
    return t.keyMatrices;
  };
}
var DEFAULT_VALUES$60 = {
  propID: void 0,
  keyMatricesTime: null
};
function extend$69(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$60, n), vtkViewNode$1.extend(e12, t, n), t.keyMatricesTime = {}, macro.obj(t.keyMatricesTime, { mtime: 0 }), t.keyMatrices = {
    bcwc: new Float64Array(16),
    bcsc: new Float64Array(16)
  }, macro.get(e12, t, ["propID", "keyMatricesTime"]), vtkWebGPUVolume(e12, t);
}
registerOverride("vtkVolume", macro.newInstance(extend$69, "vtkWebGPUVolume"));
function vtkWebGPUPixelSpaceCallbackMapper(e12, t) {
  t.classHierarchy.push("vtkWebGPUPixelSpaceCallbackMapper"), e12.opaquePass = (n, r) => {
    t.WebGPURenderer = e12.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent();
    let a = t.WebGPURenderer.getAspectRatio(), o = t.WebGPURenderer ? t.WebGPURenderer.getRenderable().getActiveCamera() : null, s = t.WebGPURenderer.getTiledSizeAndOrigin();
    t.renderable.getUseZValues(), t.renderable.invokeCallback(t.renderable.getInputData(), o, a, s, null);
  };
}
var DEFAULT_VALUES$59 = {};
function extend$68(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$59, n), vtkViewNode$1.extend(e12, t, n), vtkWebGPUPixelSpaceCallbackMapper(e12, t);
}
registerOverride("vtkPixelSpaceCallbackMapper", macro.newInstance(extend$68, "vtkWebGPUPixelSpaceCallbackMapper"));
var StructuredType = {
  UNCHANGED: 0,
  SINGLE_POINT: 1,
  X_LINE: 2,
  Y_LINE: 3,
  Z_LINE: 4,
  XY_PLANE: 5,
  YZ_PLANE: 6,
  XZ_PLANE: 7,
  XYZ_GRID: 8,
  EMPTY: 9
}, Constants$9 = { StructuredType }, { StructuredType: StructuredType$1 } = Constants$9;
function getDataDescriptionFromExtent(e12) {
  let t = 0;
  for (let n = 0; n < 3; ++n)
    e12[n * 2] < e12[n * 2 + 1] && t++;
  return e12[0] > e12[1] || e12[2] > e12[3] || e12[4] > e12[5] ? StructuredType$1.EMPTY : t === 3 ? StructuredType$1.XYZ_GRID : t === 2 ? e12[0] === e12[1] ? StructuredType$1.YZ_PLANE : e12[2] === e12[3] ? StructuredType$1.XZ_PLANE : StructuredType$1.XY_PLANE : t === 1 ? e12[0] < e12[1] ? StructuredType$1.X_LINE : e12[2] < e12[3] ? StructuredType$1.Y_LINE : StructuredType$1.Z_LINE : StructuredType$1.SINGLE_POINT;
}
var vtkStructuredData = {
  getDataDescriptionFromExtent,
  ...Constants$9
}, { vtkErrorMacro: vtkErrorMacro$19 } = macro;
function vtkImageData(e12, t) {
  t.classHierarchy.push("vtkImageData"), e12.setExtent = function() {
    if (t.deleted)
      return vtkErrorMacro$19("instance deleted - cannot call any method"), false;
    var n2 = [...arguments];
    let r = n2.length === 1 ? n2[0] : n2;
    if (r.length !== 6)
      return false;
    let a = t.extent.some((e13, t2) => e13 !== r[t2]);
    return a && (t.extent = r.slice(), t.dataDescription = vtkStructuredData.getDataDescriptionFromExtent(t.extent), e12.modified()), a;
  }, e12.setDimensions = function() {
    let n2, r, a;
    if (t.deleted) {
      vtkErrorMacro$19("instance deleted - cannot call any method");
      return;
    }
    if (arguments.length === 1) {
      let e13 = arguments.length <= 0 ? void 0 : arguments[0];
      n2 = e13[0], r = e13[1], a = e13[2];
    } else if (arguments.length === 3)
      n2 = arguments.length <= 0 ? void 0 : arguments[0], r = arguments.length <= 1 ? void 0 : arguments[1], a = arguments.length <= 2 ? void 0 : arguments[2];
    else {
      vtkErrorMacro$19("Bad dimension specification");
      return;
    }
    e12.setExtent(0, n2 - 1, 0, r - 1, 0, a - 1);
  }, e12.getDimensions = () => [
    t.extent[1] - t.extent[0] + 1,
    t.extent[3] - t.extent[2] + 1,
    t.extent[5] - t.extent[4] + 1
  ], e12.getNumberOfCells = () => {
    let t2 = e12.getDimensions(), n2 = 1;
    for (let e13 = 0; e13 < 3; e13++) {
      if (t2[e13] === 0)
        return 0;
      t2[e13] > 1 && (n2 *= t2[e13] - 1);
    }
    return n2;
  }, e12.getNumberOfPoints = () => {
    let t2 = e12.getDimensions();
    return t2[0] * t2[1] * t2[2];
  }, e12.getPoint = (n2) => {
    let r = e12.getDimensions();
    if (r[0] === 0 || r[1] === 0 || r[2] === 0)
      return vtkErrorMacro$19("Requesting a point from an empty image."), null;
    let a = new Float64Array(3);
    switch (t.dataDescription) {
      case StructuredType.EMPTY:
        return null;
      case StructuredType.SINGLE_POINT:
        break;
      case StructuredType.X_LINE:
        a[0] = n2;
        break;
      case StructuredType.Y_LINE:
        a[1] = n2;
        break;
      case StructuredType.Z_LINE:
        a[2] = n2;
        break;
      case StructuredType.XY_PLANE:
        a[0] = n2 % r[0], a[1] = n2 / r[0];
        break;
      case StructuredType.YZ_PLANE:
        a[1] = n2 % r[1], a[2] = n2 / r[1];
        break;
      case StructuredType.XZ_PLANE:
        a[0] = n2 % r[0], a[2] = n2 / r[0];
        break;
      case StructuredType.XYZ_GRID:
        a[0] = n2 % r[0], a[1] = n2 / r[0] % r[1], a[2] = n2 / (r[0] * r[1]);
        break;
      default:
        vtkErrorMacro$19("Invalid dataDescription");
        break;
    }
    let o = [
      0,
      0,
      0
    ];
    return e12.indexToWorld(a, o), o;
  }, e12.getBounds = () => e12.extentToBounds(e12.getSpatialExtent()), e12.extentToBounds = (e13) => vtkBoundingBox.transformBounds(e13, t.indexToWorld), e12.getSpatialExtent = () => vtkBoundingBox.inflate([...t.extent], 0.5), e12.computeTransforms = () => {
    fromTranslation(t.indexToWorld, t.origin), t.indexToWorld[0] = t.direction[0], t.indexToWorld[1] = t.direction[1], t.indexToWorld[2] = t.direction[2], t.indexToWorld[4] = t.direction[3], t.indexToWorld[5] = t.direction[4], t.indexToWorld[6] = t.direction[5], t.indexToWorld[8] = t.direction[6], t.indexToWorld[9] = t.direction[7], t.indexToWorld[10] = t.direction[8], scale$4(t.indexToWorld, t.indexToWorld, t.spacing), invert(t.worldToIndex, t.indexToWorld);
  }, e12.indexToWorld = function(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return transformMat4$1(n2, e13, t.indexToWorld), n2;
  }, e12.indexToWorldVec3 = e12.indexToWorld, e12.worldToIndex = function(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return transformMat4$1(n2, e13, t.worldToIndex), n2;
  }, e12.worldToIndexVec3 = e12.worldToIndex, e12.indexToWorldBounds = function(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return vtkBoundingBox.transformBounds(e13, t.indexToWorld, n2);
  }, e12.worldToIndexBounds = function(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return vtkBoundingBox.transformBounds(e13, t.worldToIndex, n2);
  }, t._onOriginChanged = e12.computeTransforms, t._onDirectionChanged = e12.computeTransforms, t._onSpacingChanged = e12.computeTransforms, e12.computeTransforms(), e12.getCenter = () => vtkBoundingBox.getCenter(e12.getBounds()), e12.computeHistogram = function(t2) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = [
      0,
      0,
      0,
      0,
      0,
      0
    ];
    e12.worldToIndexBounds(t2, r);
    let a = [
      0,
      0,
      0
    ], o = [
      0,
      0,
      0
    ];
    vtkBoundingBox.computeCornerPoints(r, a, o), roundVector(a, a), roundVector(o, o);
    let s = e12.getDimensions();
    clampVector(a, [
      0,
      0,
      0
    ], [
      s[0] - 1,
      s[1] - 1,
      s[2] - 1
    ], a), clampVector(o, [
      0,
      0,
      0
    ], [
      s[0] - 1,
      s[1] - 1,
      s[2] - 1
    ], o);
    let c = s[0], l = s[0] * s[1], u = e12.getPointData().getScalars().getData(), d = -Infinity, f = Infinity, p = 0, m = 0, h = 0;
    for (let e13 = a[2]; e13 <= o[2]; e13++)
      for (let t3 = a[1]; t3 <= o[1]; t3++) {
        let s2 = a[0] + t3 * c + e13 * l;
        for (let c2 = a[0]; c2 <= o[0]; c2++) {
          if (!n2 || n2([
            c2,
            t3,
            e13
          ], r)) {
            let e14 = u[s2];
            e14 > d && (d = e14), e14 < f && (f = e14), p += e14 * e14, m += e14, h += 1;
          }
          ++s2;
        }
      }
    let g = h > 0 ? m / h : 0, _ = h ? Math.abs(p / h - g * g) : 0;
    return {
      minimum: f,
      maximum: d,
      average: g,
      variance: _,
      sigma: Math.sqrt(_),
      count: h
    };
  }, e12.computeIncrements = function(e13) {
    let t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, n2 = [], r = t2;
    for (let t3 = 0; t3 < 3; ++t3)
      n2[t3] = r, r *= e13[t3 * 2 + 1] - e13[t3 * 2] + 1;
    return n2;
  }, e12.computeOffsetIndex = (t2) => {
    let [n2, r, a] = t2, o = e12.getExtent(), s = e12.getPointData().getScalars().getNumberOfComponents(), c = e12.computeIncrements(o, s);
    return Math.floor((Math.round(n2) - o[0]) * c[0] + (Math.round(r) - o[2]) * c[1] + (Math.round(a) - o[4]) * c[2]);
  }, e12.getOffsetIndexFromWorld = (t2) => {
    let n2 = e12.getExtent(), r = e12.worldToIndex(t2);
    for (let e13 = 0; e13 < 3; ++e13)
      if (r[e13] < n2[e13 * 2] || r[e13] > n2[e13 * 2 + 1])
        return vtkErrorMacro$19(`GetScalarPointer: Pixel ${r} is not in memory. Current extent = ${n2}`), NaN;
    return e12.computeOffsetIndex(r);
  }, e12.getScalarValueFromWorld = function(t2) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = e12.getPointData().getScalars().getNumberOfComponents();
    if (n2 < 0 || n2 >= r)
      return vtkErrorMacro$19(`GetScalarPointer: Scalar Component ${n2} is not within bounds. Current Scalar numberOfComponents: ${r}`), NaN;
    let a = e12.getOffsetIndexFromWorld(t2);
    return Number.isNaN(a) ? a : e12.getPointData().getScalars().getComponent(a, n2);
  };
  let n = e12.initialize;
  e12.initialize = () => (e12.set({
    direction: identity$3(t.direction),
    spacing: [
      1,
      1,
      1
    ],
    origin: [
      0,
      0,
      0
    ],
    extent: [
      0,
      -1,
      0,
      -1,
      0,
      -1
    ],
    dataDescription: StructuredType.EMPTY
  }), n());
}
var DEFAULT_VALUES$58 = {
  direction: null,
  indexToWorld: null,
  worldToIndex: null,
  spacing: [
    1,
    1,
    1
  ],
  origin: [
    0,
    0,
    0
  ],
  extent: [
    0,
    -1,
    0,
    -1,
    0,
    -1
  ],
  dataDescription: StructuredType.EMPTY
};
function extend$67(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$58, n), vtkDataSet$1.extend(e12, t, n), t.direction ? Array.isArray(t.direction) && (t.direction = new Float64Array(t.direction.slice(0, 9))) : t.direction = identity$3(new Float64Array(9)), t.indexToWorld = new Float64Array(16), t.worldToIndex = new Float64Array(16), macro.get(e12, t, ["indexToWorld", "worldToIndex"]), macro.setGetArray(e12, t, ["origin", "spacing"], 3), macro.setGetArray(e12, t, ["direction"], 9), macro.getArray(e12, t, ["extent"], 6), vtkImageData(e12, t);
}
var vtkImageData$1 = {
  newInstance: macro.newInstance(extend$67, "vtkImageData"),
  extend: extend$67
}, ADJACENT_ALL = [
  [
    0,
    -1,
    0
  ],
  [
    0,
    1,
    0
  ],
  [
    0,
    0,
    -1
  ],
  [
    0,
    0,
    1
  ]
], ADJACENT_SINGLE_PLANE = [[
  0,
  -1,
  0
], [
  0,
  1,
  0
]], ADJACENT_IN = [
  [
    0,
    -1,
    0
  ],
  [
    0,
    1,
    0
  ],
  [
    0,
    0,
    -1
  ]
], ADJACENT_OUT = [
  [
    0,
    -1,
    0
  ],
  [
    0,
    1,
    0
  ],
  [
    0,
    0,
    1
  ]
], RLEVoxelMap = class {
  static copyMap(e12, t) {
    for (let [n, r] of t.rows)
      e12.rows.set(n, structuredClone(r));
  }
  constructor(e12, t, n = 1) {
    this.rows = /* @__PURE__ */ new Map(), this.height = 1, this.width = 1, this.depth = 1, this.jMultiple = 1, this.kMultiple = 1, this.numComps = 1, this.pixelDataConstructor = Uint8Array, this.updateScalarData = function(e13) {
      e13.fill(0), this.forEach((t2, n2, r) => {
        let { start: a, end: o, value: s } = n2;
        for (let n3 = a; n3 < o; n3++)
          e13[t2 + n3] = s;
      });
    }, this.get = (e13) => {
      let t2 = e13 % this.jMultiple, n2 = (e13 - t2) / this.jMultiple;
      return this.getRLE(t2, n2)?.value ?? this.defaultValue;
    }, this.getRun = (e13, t2) => {
      let n2 = e13 + t2 * this.height;
      return this.rows.get(n2);
    }, this.set = (e13, t2) => {
      if (t2 === void 0)
        return;
      let n2 = e13 % this.width, r = (e13 - n2) / this.width, a = this.rows.get(r);
      if (!a) {
        this.rows.set(r, [{
          start: n2,
          end: n2 + 1,
          value: t2
        }]);
        return;
      }
      let o = this.findIndex(a, n2), s = a[o], c = a[o - 1];
      if (!s) {
        if (!c || c.value !== t2 || c.end !== n2) {
          a[o] = {
            start: n2,
            end: n2 + 1,
            value: t2
          };
          return;
        }
        c.end++;
        return;
      }
      let { start: l, end: u, value: d } = s;
      if (t2 === d && n2 >= l)
        return;
      let f = {
        start: n2,
        end: n2 + 1,
        value: t2
      }, p = n2 > l, m = p ? o + 1 : o, h = p ? s : c, g = p ? a[o + 1] : s;
      if (h?.value === t2 && h?.end === n2) {
        h.end++, g?.value === t2 && g.start === n2 + 1 ? (h.end = g.end, a.splice(o, 1)) : g?.start === n2 && (g.start++, g.start === g.end && (a.splice(o, 1), g = a[o], g?.start === n2 + 1 && g.value === t2 && (h.end = g.end, a.splice(o, 1))));
        return;
      }
      if (g?.value === t2 && g.start === n2 + 1) {
        g.start--, h?.end > n2 && (h.end = n2, h.end === h.start && a.splice(o, 1));
        return;
      }
      if (g?.start === n2 && g.end === n2 + 1) {
        g.value = t2;
        let e14 = a[o + 1];
        e14?.start == n2 + 1 && e14.value === t2 && (a.splice(o + 1, 1), g.end = e14.end);
        return;
      }
      n2 === g?.start && g.start++, p && u > n2 + 1 ? a.splice(m, 0, f, {
        start: n2 + 1,
        end: h.end,
        value: h.value
      }) : a.splice(m, 0, f), h?.end > n2 && (h.end = n2);
    }, this.width = e12, this.height = t, this.depth = n, this.jMultiple = e12, this.kMultiple = this.jMultiple * t;
  }
  static {
    this.getScalarData = function(e12 = Uint8ClampedArray) {
      let t = new e12(this.frameSize);
      return this.map.updateScalarData(t), t;
    };
  }
  toIJK(e12) {
    let t = e12 % this.jMultiple;
    return [
      t,
      (e12 - t) / this.jMultiple % this.height,
      Math.floor(e12 / this.kMultiple)
    ];
  }
  toIndex([e12, t, n]) {
    return e12 + n * this.kMultiple + t * this.jMultiple;
  }
  getRLE(e12, t, n = 0) {
    let r = this.rows.get(t + n * this.height);
    if (!r)
      return;
    let a = r[this.findIndex(r, e12)];
    return e12 >= a?.start ? a : void 0;
  }
  has(e12) {
    let t = e12 % this.jMultiple, n = (e12 - t) / this.jMultiple;
    return this.getRLE(t, n)?.value !== void 0;
  }
  delete(e12) {
    let t = e12 % this.width, n = (e12 - t) / this.width, r = this.rows.get(n);
    if (!r)
      return;
    let a = this.findIndex(r, t), o = r[a];
    if (!o || o.start > t)
      return;
    if (o.end === t + 1) {
      o.end--, o.start >= o.end && (r.splice(a, 1), r.length || this.rows.delete(n));
      return;
    }
    if (o.start === t) {
      o.start++;
      return;
    }
    let s = {
      value: o.value,
      start: t + 1,
      end: o.end
    };
    o.end = t, r.splice(a + 1, 0, s);
  }
  findIndex(e12, t) {
    for (let n = 0; n < e12.length; n++) {
      let { end: r } = e12[n];
      if (t < r)
        return n;
    }
    return e12.length;
  }
  forEach(e12, t) {
    let n = t?.rowModified;
    for (let [t2, r] of this.rows) {
      let a = n ? [...r] : r;
      for (let n2 of a)
        e12(t2 * this.width, n2, r);
    }
  }
  forEachRow(e12) {
    for (let [t, n] of this.rows)
      e12(t * this.width, n);
  }
  clear() {
    this.rows.clear();
  }
  keys() {
    return [...this.rows.keys()];
  }
  getPixelData(e12 = 0, t) {
    t ? t.fill(0) : t = new this.pixelDataConstructor(this.width * this.height * this.numComps);
    let { width: n, height: r, numComps: a } = this;
    for (let o = 0; o < r; o++) {
      let r2 = this.getRun(o, e12);
      if (r2)
        if (a === 1)
          for (let e13 of r2) {
            let r3 = o * n, { start: a2, end: s, value: c } = e13;
            for (let e14 = a2; e14 < s; e14++)
              t[r3 + e14] = c;
          }
        else
          for (let e13 of r2) {
            let r3 = o * n * a, { start: s, end: c, value: l } = e13;
            for (let e14 = s; e14 < c; e14 += a)
              for (let n2 = 0; n2 < a; n2++)
                t[r3 + e14 + n2] = l[n2];
          }
    }
    return t;
  }
  floodFill(e12, t, n, r, a) {
    let o = this.getRLE(e12, t, n);
    if (!o)
      throw Error(`Initial point ${e12},${t},${n} isn't in the RLE`);
    let s = [[
      o,
      t,
      n
    ]], c = o.value;
    if (c === r)
      throw Error(`source (${c}) and destination (${r}) are identical`);
    return this.flood(s, c, r, a);
  }
  flood(e12, t, n, r) {
    let a = 0, { planar: o = true, diagonals: s = true, singlePlane: c = false } = r || {}, l = {
      planar: o,
      diagonals: s,
      singlePlane: c
    };
    for (; e12.length; ) {
      let r2 = e12.pop(), [o2] = r2;
      if (o2.value !== t)
        continue;
      o2.value = n, a += o2.end - o2.start;
      let s2 = this.findAdjacents(r2, l).filter((e13) => e13 && e13[0].value === t);
      e12.push(...s2);
    }
    return a;
  }
  fillFrom(e12, t) {
    for (let n = t[2][0]; n <= t[2][1]; n++)
      for (let r = t[1][0]; r <= t[1][1]; r++) {
        let a, o;
        for (let s = t[0][0]; s <= t[0][1]; s++) {
          let t2 = e12(s, r, n);
          if (t2 === void 0) {
            a = void 0;
            continue;
          }
          o || (o = [], this.rows.set(r + n * this.height, o)), a && a.value !== t2 && (a = void 0), a || (a = {
            start: s,
            end: s,
            value: t2
          }, o.push(a)), a.end++;
        }
      }
  }
  findAdjacents(e12, { diagonals: t = true, planar: n = true, singlePlane: r = false }) {
    let [a, o, s, c] = e12, { start: l, end: u } = a, d = l > 0 && this.getRLE(l - 1, o, s), f = u < this.width && this.getRLE(u, o, s), p = t ? [l > 0 ? l - 1 : l, u < this.width ? u + 1 : u] : [l, u], m = [];
    d && m.push([
      d,
      o,
      s
    ]), f && m.push([
      f,
      o,
      s
    ]);
    for (let e13 of c || (r ? ADJACENT_SINGLE_PLANE : ADJACENT_ALL)) {
      let [, t2, a2] = e13, l2 = t2 + o, u2 = a2 + s;
      if (l2 < 0 || l2 >= this.height || u2 < 0 || u2 >= this.depth)
        continue;
      let d2 = this.getRun(l2, u2);
      if (d2)
        for (let e14 of d2) {
          let t3 = c || r && ADJACENT_SINGLE_PLANE || n && a2 > 0 && ADJACENT_OUT || n && a2 < 0 && ADJACENT_IN || ADJACENT_ALL;
          e14.end <= p[0] || e14.start >= p[1] || m.push([
            e14,
            l2,
            u2,
            t3
          ]);
        }
    }
    return m;
  }
}, PointsManager = class e {
  constructor(e12 = {}) {
    this._dimensions = 3, this._length = 0, this._byteSize = 4, this.growSize = 128;
    let { initialSize: t = 1024, dimensions: n = 3, growSize: r = 128 } = e12, a = t * n;
    this.growSize = r, this.array = new ArrayBuffer(a * this._byteSize), this.data = new Float32Array(this.array), this._dimensions = n;
  }
  forEach(e12) {
    for (let t = 0; t < this._length; t++)
      e12(this.getPoint(t), t);
  }
  get length() {
    return this._length;
  }
  get dimensions() {
    return this._dimensions;
  }
  get dimensionLength() {
    return this._length * this._dimensions;
  }
  getPoint(e12) {
    if (e12 < 0 && (e12 += this._length), e12 < 0 || e12 >= this._length)
      return;
    let t = this._dimensions * e12;
    return this.data.subarray(t, t + this._dimensions);
  }
  getPointArray(e12) {
    let t = [];
    if (e12 < 0 && (e12 += this._length), e12 < 0 || e12 >= this._length)
      return;
    let n = this._dimensions * e12;
    for (let e13 = 0; e13 < this._dimensions; e13++)
      t.push(this.data[e13 + n]);
    return t;
  }
  grow(e12 = 1, t = this.growSize) {
    if (this.dimensionLength + e12 * this._dimensions <= this.data.length)
      return;
    let n = this.data.length + t, r = new ArrayBuffer(n * this._dimensions * this._byteSize), a = new Float32Array(r);
    a.set(this.data), this.data = a, this.array = r;
  }
  reverse() {
    let e12 = Math.floor(this._length / 2);
    for (let t = 0; t < e12; t++) {
      let e13 = t * this._dimensions, n = (this._length - 1 - t) * this._dimensions;
      for (let t2 = 0; t2 < this._dimensions; t2++) {
        let r = this.data[e13 + t2];
        this.data[e13 + t2] = this.data[n + t2], this.data[n + t2] = r;
      }
    }
  }
  getTypedArray() {
    return this.data;
  }
  push(e12) {
    this.grow(1);
    let t = this.length * this._dimensions;
    for (let n = 0; n < this._dimensions; n++)
      this.data[n + t] = e12[n];
    this._length++;
  }
  map(e12) {
    let t = [];
    for (let n = 0; n < this._length; n++)
      t.push(e12(this.getPoint(n), n));
    return t;
  }
  get points() {
    return this.map((e12) => e12);
  }
  toXYZ() {
    let e12 = {
      x: [],
      y: []
    };
    this._dimensions >= 3 && (e12.z = []);
    let { x: t, y: n, z: r } = e12;
    return this.forEach((e13) => {
      t.push(e13[0]), n.push(e13[1]), r && r.push(e13[2]);
    }), e12;
  }
  static fromXYZ({ x: t, y: n, z: r }) {
    let a = e.create3(t.length), o = 0;
    for (let e12 = 0; e12 < t.length; e12++)
      a.data[o++] = t[e12], a.data[o++] = n[e12], a.data[o++] = r ? r[e12] : 0;
    return a._length = t.length, a;
  }
  subselect(t = 10, n = 0) {
    let r = new e({
      initialSize: t,
      dimensions: this._dimensions
    });
    for (let e12 = 0; e12 < t; e12++) {
      let a = (n + Math.floor(this.length * e12 / t)) % this.length;
      r.push(this.getPoint(a));
    }
    return r;
  }
  static create3(t = 128, n) {
    t = Math.max(t, n?.length || 0);
    let r = new e({
      initialSize: t,
      dimensions: 3
    });
    return n && n.forEach((e12) => r.push(e12)), r;
  }
  static create2(t = 128) {
    return new e({
      initialSize: t,
      dimensions: 2
    });
  }
};
function createPositionCallback(e12) {
  let t = create$4(), n = e12.getDimensions(), r = PointsManager.create3(n[0]), a = PointsManager.create3(n[1]), o = PointsManager.create3(n[2]), s = e12.getDirection(), c = s.slice(0, 3), l = s.slice(3, 6), u = s.slice(6, 9), [d, f, p] = e12.getSpacing(), m = e12.indexToWorld([
    0,
    0,
    0
  ]), h = fromValues$3(c[0] * d, c[1] * d, c[2] * d), g = fromValues$3(l[0] * f, l[1] * f, l[2] * f), _ = fromValues$3(u[0] * p, u[1] * p, u[2] * p), v = create$4();
  for (let e13 = 0; e13 < n[0]; e13++)
    r.push(add$4(v, m, scale$3(v, h, e13)));
  for (let e13 = 0; e13 < n[1]; e13++)
    a.push(scale$3(v, g, e13));
  for (let e13 = 0; e13 < n[2]; e13++)
    o.push(scale$3(v, _, e13));
  let y = r.getTypedArray(), b = a.getTypedArray(), S = o.getTypedArray();
  return (e13, n2 = t) => {
    let [r2, a2, o2] = e13, s2 = r2 * 3, c2 = a2 * 3, l2 = o2 * 3;
    return n2[0] = y[s2] + b[c2] + S[l2], n2[1] = y[s2 + 1] + b[c2 + 1] + S[l2 + 1], n2[2] = y[s2 + 2] + b[c2 + 2] + S[l2 + 2], n2;
  };
}
function pointInShapeCallback(e12, t) {
  let { pointInShapeFn: n, callback: r, boundsIJK: a, returnPoints: o = false } = t, s;
  if (e12.getScalarData)
    s = e12.getScalarData();
  else {
    let t2 = e12.getPointData().getScalars();
    if (t2)
      s = t2.getData();
    else {
      let { voxelManager: t3 } = e12.get("voxelManager") || {};
      t3 && (s = t3.getCompleteScalarDataArray());
    }
  }
  let c = e12.getDimensions(), l = [
    [0, c[0]],
    [0, c[1]],
    [0, c[2]]
  ], u = iterateOverPointsInShape({
    imageData: e12,
    bounds: a || l,
    scalarData: s,
    pointInShapeFn: n,
    callback: r
  });
  return o ? u : void 0;
}
function iterateOverPointsInShape({ imageData: e12, bounds: t, scalarData: n, pointInShapeFn: r, callback: a }) {
  let [[o, s], [c, l], [u, d]] = t, { numComps: f } = e12, p = e12.getDimensions(), m = createPositionCallback(e12), h = [
    0,
    0,
    0
  ], g = f || n.length / p[2] / p[1] / p[0], _ = p[0] * g, v = p[1] * _, y = [];
  for (let e13 = u; e13 <= d; e13++) {
    h[2] = e13;
    let t2 = e13 * v;
    for (let e14 = c; e14 <= l; e14++) {
      h[1] = e14;
      let c2 = t2 + e14 * _;
      for (let e15 = o; e15 <= s; e15++) {
        h[0] = e15;
        let t3 = m(h);
        if (r(t3, h)) {
          let r2 = c2 + e15 * g, o2;
          o2 = g > 2 ? [
            n[r2],
            n[r2 + 1],
            n[r2 + 2]
          ] : n[r2], y.push({
            value: o2,
            index: r2,
            pointIJK: h,
            pointLPS: t3.slice()
          }), a({
            value: o2,
            index: r2,
            pointIJK: h,
            pointLPS: t3
          });
        }
      }
    }
  }
  return y;
}
function iterateOverPointsInShapeVoxelManager({ voxelManager: e12, bounds: t, imageData: n, pointInShapeFn: r, callback: a, returnPoints: o }) {
  let [[s, c], [l, u], [d, f]] = t, p = createPositionCallback(n), m = [
    0,
    0,
    0
  ], h = [];
  for (let t2 = d; t2 <= f; t2++) {
    m[2] = t2;
    for (let t3 = l; t3 <= u; t3++) {
      m[1] = t3;
      for (let t4 = s; t4 <= c; t4++) {
        m[0] = t4;
        let n2 = p(m);
        if (r(n2, m)) {
          let t5 = e12.toIndex(m), r2 = e12.getAtIndex(t5);
          o && h.push({
            value: r2,
            index: t5,
            pointIJK: [...m],
            pointLPS: n2.slice()
          }), a?.({
            value: r2,
            index: t5,
            pointIJK: m,
            pointLPS: n2
          });
        }
      }
    }
  }
  return h;
}
var DEFAULT_RLE_SIZE = 5 * 1024, VoxelManager = class e2 {
  get id() {
    return this._id;
  }
  constructor(t, n) {
    this.modifiedSlices = /* @__PURE__ */ new Set(), this.boundsIJK = [
      [Infinity, -Infinity],
      [Infinity, -Infinity],
      [Infinity, -Infinity]
    ], this.scalarData = null, this._sliceDataCache = null, this.getAtIJK = (e12, t2, n2) => {
      let r = this.toIndex([
        e12,
        t2,
        n2
      ]);
      return this._get(r);
    }, this.setAtIJK = (t2, n2, r, a) => {
      let o = this.toIndex([
        t2,
        n2,
        r
      ]), s = this._set(o, a);
      return s !== false && (this.modifiedSlices.add(r), e2.addBounds(this.boundsIJK, [
        t2,
        n2,
        r
      ])), s;
    }, this.getAtIJKPoint = ([e12, t2, n2]) => this.getAtIJK(e12, t2, n2), this.setAtIJKPoint = ([e12, t2, n2], r) => {
      this.setAtIJK(e12, t2, n2, r);
    }, this.getAtIndex = (e12) => this._get(e12), this.setAtIndex = (t2, n2) => {
      let r = this._set(t2, n2);
      if (r !== false) {
        let n3 = this.toIJK(t2);
        this.modifiedSlices.add(n3[2]), e2.addBounds(this.boundsIJK, n3);
      }
      return r;
    }, this.getMiddleSliceData = () => {
      let e12 = Math.floor(this.dimensions[2] / 2);
      return this.getSliceData({
        sliceIndex: e12,
        slicePlane: 2
      });
    }, this.forEach = (e12, t2 = {}) => {
      let n2 = t2.boundsIJK || this.getBoundsIJK(), r = t2.isInObject || this.isInObject || (() => true), a = t2.returnPoints || false, o = t2.imageData, s = Math.min(n2[0][0], n2[0][1]), c = Math.max(n2[0][0], n2[0][1]), l = Math.min(n2[1][0], n2[1][1]), u = Math.max(n2[1][0], n2[1][1]), d = Math.min(n2[2][0], n2[2][1]), f = Math.max(n2[2][0], n2[2][1]), p = [];
      if (o)
        return iterateOverPointsInShapeVoxelManager({
          voxelManager: this,
          imageData: t2.imageData,
          bounds: [
            [s, c],
            [l, u],
            [d, f]
          ],
          pointInShapeFn: r,
          callback: e12,
          returnPoints: a
        });
      if (this.map) {
        if (this.map instanceof RLEVoxelMap)
          return this.rleForEach(e12, t2);
        for (let t3 of this.map.keys()) {
          let n3 = this.toIJK(t3);
          if (!r(null, n3))
            continue;
          let o2 = this._get(t3);
          a && p.push({
            value: o2,
            index: t3,
            pointIJK: n3,
            pointLPS: null
          }), e12({
            value: o2,
            index: t3,
            pointIJK: n3,
            pointLPS: null
          });
        }
        return p;
      } else {
        for (let t3 = d; t3 <= f; t3++) {
          let n3 = t3 * this.frameSize;
          for (let o2 = l; o2 <= u; o2++) {
            let l2 = n3 + o2 * this.width;
            for (let n4 = s, u2 = l2 + n4; n4 <= c; n4++, u2++) {
              let s2 = this.getAtIndex(u2), c2 = [
                n4,
                o2,
                t3
              ];
              r(null, c2) && (a && p.push({
                value: s2,
                index: u2,
                pointIJK: c2,
                pointLPS: null
              }), e12({
                value: s2,
                index: u2,
                pointIJK: [
                  n4,
                  o2,
                  t3
                ],
                pointLPS: null
              }));
            }
          }
        }
        return p;
      }
    }, this.getSliceData = ({ sliceIndex: e12, slicePlane: t2 }) => {
      let [n2, r, a] = this.dimensions, o = n2 * r, s = e12 * o, c, l = this.getConstructor();
      function u(e13) {
        return typeof e13 == "function";
      }
      if (!u(l))
        return new Uint8Array();
      let d;
      switch (t2) {
        case 0:
          c = r * a, d = new l(c);
          for (let t3 = 0; t3 < r; t3++)
            for (let r2 = 0; r2 < a; r2++) {
              let s2 = e12 + t3 * n2 + r2 * o;
              this.setSliceDataValue(d, t3 * a + r2, this._get(s2));
            }
          break;
        case 1:
          c = n2 * a, d = new l(c);
          for (let t3 = 0; t3 < n2; t3++)
            for (let r2 = 0; r2 < a; r2++) {
              let a2 = t3 + e12 * n2 + r2 * o;
              this.setSliceDataValue(d, t3 + r2 * n2, this._get(a2));
            }
          break;
        case 2:
          c = n2 * r, d = new l(c);
          for (let e13 = 0; e13 < c; e13++)
            this.setSliceDataValue(d, e13, this._get(s + e13));
          break;
        default:
          throw Error("Oblique plane - todo - implement as ortho normal vector");
      }
      return d;
    }, this.dimensions = t, this.width = t[0], this.frameSize = this.width * t[1], this._get = n._get, this._set = n._set, this._id = n._id || "", this._getConstructor = n._getConstructor, this.numberOfComponents = n.numberOfComponents || 1, this.scalarData = n.scalarData, this._getScalarData = n._getScalarData, this._updateScalarData = n._updateScalarData;
  }
  getMinMax() {
    let e12, t;
    return this.forEach(({ value: n }) => {
      let r = Array.isArray(n);
      if (e12 === void 0 && (e12 = r ? [...n] : n, t = r ? [...n] : n), r)
        for (let r2 = 0; r2 < n.length; r2++)
          e12[r2] = Math.min(e12[r2], n[r2]), t[r2] = Math.max(t[r2], n[r2]);
      else
        e12 = Math.min(e12, n), t = Math.max(t, n);
    }, { boundsIJK: this.getDefaultBounds() }), {
      min: e12,
      max: t
    };
  }
  toIJK(e12) {
    return [
      e12 % this.width,
      Math.floor(e12 % this.frameSize / this.width),
      Math.floor(e12 / this.frameSize)
    ];
  }
  toIndex(e12) {
    return e12[0] + e12[1] * this.width + e12[2] * this.frameSize;
  }
  getDefaultBounds() {
    return this.dimensions.map((e12) => [0, e12 - 1]);
  }
  getBoundsIJK() {
    return this.boundsIJK[0][0] < this.dimensions[0] ? this.boundsIJK : this.getDefaultBounds();
  }
  rleForEach(e12, t) {
    let n = t?.boundsIJK || this.getBoundsIJK(), { isWithinObject: r } = t || {}, a = this.map;
    if (!a) {
      console.warn("No map found, you need to use a map voxel manager to use rleForEach");
      return;
    }
    a.defaultValue = void 0;
    for (let t2 = n[2][0]; t2 <= n[2][1]; t2++)
      for (let o = n[1][0]; o <= n[1][1]; o++) {
        let n2 = a.getRun(o, t2);
        if (n2)
          for (let a2 of n2) {
            let { start: n3, end: s, value: c } = a2, l = this.toIndex([
              0,
              o,
              t2
            ]);
            for (let a3 = n3; a3 < s; a3++) {
              let n4 = {
                value: c,
                index: l + a3,
                pointIJK: [
                  a3,
                  o,
                  t2
                ]
              };
              r?.(n4) !== false && e12(n4);
            }
          }
      }
  }
  getScalarData(e12 = false) {
    if (this.scalarData)
      return this._updateScalarData?.(this.scalarData), this.scalarData;
    if (this._getScalarData) {
      let t = this._getScalarData();
      return e12 && console.log("Not transient, should store value", t), t;
    }
    throw Error("No scalar data available");
  }
  setScalarData(e12) {
    this.scalarData = e12;
  }
  getScalarDataLength() {
    if (this.scalarData)
      return this.scalarData.length;
    if (this._getScalarDataLength)
      return this._getScalarDataLength();
    throw Error("No scalar data available");
  }
  get sizeInBytes() {
    return this.getScalarDataLength() * this.bytePerVoxel;
  }
  get bytePerVoxel() {
    return this.scalarData ? this.scalarData.BYTES_PER_ELEMENT : this._get(0).BYTES_PER_ELEMENT;
  }
  clearBounds() {
    this.boundsIJK.map((e12) => {
      e12[0] = Infinity, e12[1] = -Infinity;
    });
  }
  clear() {
    this.map?.clear(), this.clearBounds(), this.modifiedSlices.clear(), this.points?.clear();
  }
  getConstructor() {
    return this.scalarData ? this.scalarData.constructor : this._getConstructor ? this._getConstructor() : (console.warn("No scalar data available or can be used to get the constructor"), Float32Array);
  }
  getArrayOfModifiedSlices() {
    return Array.from(this.modifiedSlices);
  }
  resetModifiedSlices() {
    this.modifiedSlices.clear();
  }
  setBounds(e12) {
    this.boundsIJK = e12;
  }
  static addBounds(e12, t) {
    e12 ||= [
      [Infinity, -Infinity],
      [Infinity, -Infinity],
      [Infinity, -Infinity]
    ], e12[0][0] = Math.min(t[0], e12[0][0]), e12[0][1] = Math.max(t[0], e12[0][1]), e12[1][0] = Math.min(t[1], e12[1][0]), e12[1][1] = Math.max(t[1], e12[1][1]), e12[2][0] = Math.min(t[2], e12[2][0]), e12[2][1] = Math.max(t[2], e12[2][1]);
  }
  addPoint(e12) {
    let t = Array.isArray(e12) ? e12[0] + this.width * e12[1] + this.frameSize * e12[2] : e12;
    this.points ||= /* @__PURE__ */ new Set(), this.points.add(t);
  }
  getPoints() {
    return this.points ? [...this.points].map((e12) => this.toIJK(e12)) : [];
  }
  setSliceDataValue(e12, t, n) {
    if (Array.isArray(n))
      for (let r = 0; r < n.length; r++)
        e12[t * n.length + r] = this.toNumber(n[r]);
    else
      e12[t] = this.toNumber(n);
  }
  toNumber(e12) {
    return typeof e12 == "number" ? e12 : Array.isArray(e12) && e12[0] || 0;
  }
  static _createRGBScalarVolumeVoxelManager({ dimensions: t, scalarData: n, numberOfComponents: r = 3, id: a }) {
    let o = new e2(t, {
      _get: (e12) => (e12 *= r, [
        n[e12++],
        n[e12++],
        n[e12++]
      ]),
      _id: a || "_createRGBScalarVolumeVoxelManager",
      _set: (e12, t2) => {
        e12 *= 3;
        let r2 = !isEqual_default(n[e12], t2);
        return n[e12++] = t2[0], n[e12++] = t2[1], n[e12++] = t2[2], r2;
      },
      numberOfComponents: r,
      scalarData: n
    });
    return o.clear = () => {
      n.fill(0);
    }, o;
  }
  static createImageVolumeVoxelManager({ dimensions: t, imageIds: n, numberOfComponents: r = 1, id: a }) {
    let o = t[0] * t[1];
    function s(e12) {
      let r2 = Math.floor(e12 / o);
      if (r2 < 0 || r2 >= t[2])
        return {};
      let a2 = n[r2];
      if (!a2)
        return console.warn(`ImageId not found for sliceIndex: ${r2}`), {
          pixelData: null,
          pixelIndex: null
        };
      let s2 = cache_default.getImage(a2);
      return s2 ? {
        voxelManager: s2.voxelManager,
        pixelIndex: e12 % o
      } : (console.warn(`Image not found for imageId: ${a2}`), {
        pixelData: null,
        pixelIndex: null
      });
    }
    function c(e12) {
      let { voxelManager: t2, pixelIndex: n2 } = s(e12);
      return !t2 || n2 === null ? null : t2.getAtIndex(n2);
    }
    function l(e12, t2) {
      let { voxelManager: n2, pixelIndex: r2 } = s(e12);
      return !n2 || r2 === null ? false : !isEqual_default(t2, n2.getAtIndex(r2)) && (n2.setAtIndex(r2, t2), true);
    }
    let u = new e2(t, {
      _get: c,
      _set: l,
      numberOfComponents: r,
      _getConstructor: () => {
        let { voxelManager: e12, pixelIndex: t2 } = s(0);
        return !e12 || t2 === null ? null : e12.getConstructor();
      },
      _id: a || "createImageVolumeVoxelManager"
    });
    return u.getMiddleSliceData = () => {
      let e12 = Math.floor(t[2] / 2);
      return u.getSliceData({
        sliceIndex: e12,
        slicePlane: 2
      });
    }, u.clear = () => {
      for (let e12 of n)
        cache_default.getImage(e12).voxelManager.clear();
    }, u.getRange = () => {
      let e12 = Infinity, t2 = -Infinity;
      for (let r2 of n) {
        let n2 = cache_default.getImage(r2);
        n2 && (n2.minPixelValue < e12 && (e12 = n2.minPixelValue), n2.maxPixelValue > t2 && (t2 = n2.maxPixelValue));
      }
      return e12 === Infinity && t2 === -Infinity ? [0, 0] : [e12, t2];
    }, u._getScalarDataLength = () => {
      let { voxelManager: e12, pixelIndex: n2 } = s(0);
      return !e12 || n2 === null ? 0 : e12.getScalarDataLength() * t[2];
    }, u.getCompleteScalarDataArray = () => {
      let e12 = u._getConstructor();
      if (!e12)
        return new Uint8Array();
      let n2 = new e12(u.getScalarDataLength()), a2 = t[0] * t[1] * r;
      for (let e13 = 0; e13 < t[2]; e13++) {
        let { voxelManager: t2, pixelIndex: o2 } = s(e13 * a2 / r);
        if (t2 && o2 !== null) {
          let o3 = e13 * a2, s2 = t2.getScalarData();
          if (r === 1)
            n2.set(s2, o3);
          else
            for (let e14 = 0; e14 < s2.length; e14 += r)
              for (let t3 = 0; t3 < r; t3++)
                n2[o3 + e14 + t3] = s2[e14 + t3];
        }
      }
      return n2;
    }, u.setCompleteScalarDataArray = (e12) => {
      let a2 = t[0] * t[1] * r, o2 = u._getConstructor(), c2 = Infinity, l2 = -Infinity;
      for (let u2 = 0; u2 < t[2]; u2++) {
        let { voxelManager: t2 } = s(u2 * a2 / r);
        if (t2 && o2) {
          let r2 = u2 * a2, s2 = r2 + a2, d = new o2(a2);
          if (d.set(e12.subarray(r2, s2)), t2.scalarData)
            t2.scalarData.set(d), t2.modifiedSlices.add(u2);
          else
            for (let e13 = 0; e13 < a2; e13++)
              t2.setAtIndex(e13, d[e13]);
          for (let e13 = 0; e13 < d.length; e13++) {
            let t3 = d[e13];
            c2 = Math.min(c2, t3), l2 = Math.max(l2, t3);
          }
          let f = n[u2], p = cache_default.getImage(f);
          p && (p.minPixelValue = c2, p.maxPixelValue = l2);
        }
      }
      for (let e13 = 0; e13 < t[2]; e13++)
        u.modifiedSlices.add(e13);
      u.boundsIJK = [
        [0, t[0] - 1],
        [0, t[1] - 1],
        [0, t[2] - 1]
      ];
    }, u;
  }
  static createScalarVolumeVoxelManager({ dimensions: t, scalarData: n, numberOfComponents: r, id: a }) {
    if (t.length !== 3)
      throw Error("Dimensions must be provided as [number, number, number] for [width, height, depth]");
    if (!r && (r = n.length / t[0] / t[1] / t[2], r > 4 || r < 1 || r === 2))
      throw Error(`Number of components ${r} must be 1, 3 or 4`);
    return r > 1 ? e2._createRGBScalarVolumeVoxelManager({
      dimensions: t,
      scalarData: n,
      numberOfComponents: r,
      id: a
    }) : e2._createNumberVolumeVoxelManager({
      dimensions: t,
      scalarData: n,
      id: a
    });
  }
  static createScalarDynamicVolumeVoxelManager({ imageIdGroups: t, dimensions: n, dimensionGroupNumber: r = 1, timePoint: a = 0, numberOfComponents: o = 1, id: s }) {
    let c = 0;
    if (r === void 0 ? a !== void 0 && (console.warn("Warning: timePoint parameter is deprecated. Please use dimensionGroupNumber instead. timePoint is zero-based while dimensionGroupNumber starts at 1."), c = a) : c = r - 1, !o) {
      let e12 = cache_default.getImage(t[0][0]);
      if (!e12)
        throw Error("Unable to determine number of components: No image found");
      if (o = e12.getPixelData().length / (n[0] * n[1]), o > 4 || o < 1 || o === 2)
        throw Error(`Number of components ${o} must be 1, 3 or 4`);
    }
    let l = t.map((t2) => e2.createImageVolumeVoxelManager({
      dimensions: n,
      imageIds: t2,
      numberOfComponents: o,
      id: s
    })), u = new e2(n, {
      _get: (e12) => l[c]._get(e12),
      _set: (e12, t2) => l[c]._set(e12, t2),
      numberOfComponents: o,
      _id: s || "createScalarDynamicVolumeVoxelManager"
    });
    return u.getScalarDataLength = () => l[c].getScalarDataLength(), u.getConstructor = () => l[c].getConstructor(), u.getRange = () => l[c].getRange(), u.getMiddleSliceData = () => l[c].getMiddleSliceData(), u.setTimePoint = (e12) => {
      console.warn("Warning: setTimePoint is deprecated. Please use setDimensionGroupNumber instead. Note that timePoint is zero-based while dimensionGroupNumber starts at 1."), u.setDimensionGroupNumber(e12 + 1);
    }, u.setDimensionGroupNumber = (e12) => {
      c = e12 - 1, u._get = (e13) => l[c]._get(e13), u._set = (e13, t2) => l[c]._set(e13, t2);
    }, u.getAtIndexAndTimePoint = (e12, t2) => (console.warn("Warning: getAtIndexAndTimePoint is deprecated. Please use getAtIndexAndDimensionGroup instead. Note that timePoint is zero-based while dimensionGroupNumber starts at 1."), u.getAtIndexAndDimensionGroup(e12, t2 + 1)), u.getAtIndexAndDimensionGroup = (e12, t2) => l[t2 - 1]._get(e12), u.getTimePointScalarData = (e12) => (console.warn("Warning: getTimePointScalarData is deprecated. Please use getDimensionGroupScalarData instead. Note that timePoint is zero-based while dimensionGroupNumber starts at 1."), u.getDimensionGroupScalarData(e12 + 1)), u.getDimensionGroupScalarData = (e12) => l[e12 - 1].getCompleteScalarDataArray(), u.getCurrentTimePointScalarData = () => (console.warn("Warning: getCurrentTimePointScalarData is deprecated. Please use getCurrentDimensionGroupScalarData instead."), u.getCurrentDimensionGroupScalarData()), u.getCurrentDimensionGroupScalarData = () => l[c].getCompleteScalarDataArray(), u.getCurrentTimePoint = () => (console.warn("Warning: getCurrentTimePoint is deprecated. Please use getCurrentDimensionGroupNumber instead. Note that timePoint is zero-based while dimensionGroupNumber starts at 1."), c), u.getCurrentDimensionGroupNumber = () => c + 1, u;
  }
  static createImageVoxelManager({ width: t, height: n, scalarData: r, numberOfComponents: a = 1, id: o }) {
    let s = [
      t,
      n,
      1
    ];
    if (!a && (a = r.length / t / n, a > 4 || a < 1 || a === 2))
      throw Error(`Number of components ${a} must be 1, 3 or 4`);
    return a > 1 ? e2._createRGBScalarVolumeVoxelManager({
      dimensions: s,
      scalarData: r,
      numberOfComponents: a,
      id: o
    }) : e2._createNumberVolumeVoxelManager({
      dimensions: s,
      scalarData: r,
      id: o
    });
  }
  static _createNumberVolumeVoxelManager({ dimensions: t, scalarData: n, id: r }) {
    let a = new e2(t, {
      _get: (e12) => n[e12],
      _set: (e12, t2) => {
        let r2 = n[e12] !== t2;
        return n[e12] = t2, r2;
      },
      _getConstructor: () => n.constructor,
      _id: r || "_createNumberVolumeVoxelManager"
    });
    return a.scalarData = n, a.clear = () => {
      a.scalarData.fill(0);
    }, a.getMiddleSliceData = () => {
      let e12 = Math.floor(t[2] / 2);
      return a.getSliceData({
        sliceIndex: e12,
        slicePlane: 2
      });
    }, a;
  }
  static createMapVoxelManager({ dimension: t, id: n }) {
    let r = /* @__PURE__ */ new Map(), a = new e2(t, {
      _get: r.get.bind(r),
      _set: (e12, t2) => r.set(e12, t2) && true,
      _id: n || "createMapVoxelManager"
    });
    return a.map = r, a;
  }
  static createHistoryVoxelManager(t, n) {
    let r = /* @__PURE__ */ new Map(), { dimensions: a } = t, o = new e2(a, {
      _get: (e12) => r.get(e12),
      _set: function(e12, t2) {
        if (r.has(e12))
          t2 === r.get(e12) && r.delete(e12);
        else {
          let n2 = this.sourceVoxelManager.getAtIndex(e12);
          if (n2 === t2)
            return false;
          r.set(e12, n2);
        }
        this.sourceVoxelManager.setAtIndex(e12, t2);
      },
      _id: n || "createHistoryVoxelManager"
    });
    return o.map = r, o.scalarData = t.scalarData, o.sourceVoxelManager = t, o;
  }
  static createRLEHistoryVoxelManager(t, n) {
    let { dimensions: r } = t, a = new RLEVoxelMap(r[0], r[1], r[2]), o = new e2(r, {
      _get: (e12) => a.get(e12),
      _set: function(e12, t2) {
        let n2 = a.get(e12);
        if (n2 === void 0) {
          let n3 = this.sourceVoxelManager.getAtIndex(e12);
          if (n3 === t2 || n3 === void 0 && t2 === 0 || t2 === null)
            return false;
          a.set(e12, n3 ?? 0);
        } else
          (t2 === n2 || t2 === null) && (a.delete(e12), t2 = n2);
        this.sourceVoxelManager.setAtIndex(e12, t2);
      },
      _getScalarData: RLEVoxelMap.getScalarData,
      _updateScalarData: (e12) => (a.updateScalarData(e12), e12),
      _id: n || "createRLEHistoryVoxelManager"
    });
    return o.map = a, o.sourceVoxelManager = t, o;
  }
  static createLazyVoxelManager({ dimensions: t, planeFactory: n, id: r }) {
    let a = /* @__PURE__ */ new Map(), [o, s] = t, c = o * s, l = new e2(t, {
      _get: (e12) => a.get(Math.floor(e12 / c))[e12 % c],
      _set: (e12, t2) => {
        let r2 = Math.floor(e12 / c), l2 = a.get(r2);
        return l2 || (l2 = n(o, s), a.set(r2, l2)), l2[e12 % c] = t2, true;
      },
      _id: r || "createLazyVoxelManager"
    });
    return l.map = a, l;
  }
  static createRLEVolumeVoxelManager({ dimensions: t, id: n }) {
    let [r, a, o] = t, s = new RLEVoxelMap(r, a, o), c = new e2(t, {
      _get: (e12) => s.get(e12),
      _set: (e12, t2) => (s.set(e12, t2), true),
      _getScalarData: RLEVoxelMap.getScalarData,
      _updateScalarData: (e12) => (s.updateScalarData(e12), e12),
      _id: n || "createRLEVolumeVoxelManager"
    });
    return c.map = s, c.getPixelData = s.getPixelData.bind(s), c;
  }
  static createRLEImageVoxelManager({ dimensions: t, id: n }) {
    let [r, a] = t;
    return e2.createRLEVolumeVoxelManager({
      dimensions: [
        r,
        a,
        1
      ],
      id: n
    });
  }
  static addInstanceToImage(t) {
    let { width: n, height: r } = t, a = t.voxelManager.getScalarData();
    if (a.length >= n * r) {
      t.voxelManager = e2.createScalarVolumeVoxelManager({
        dimensions: [
          n,
          r,
          1
        ],
        scalarData: a
      });
      return;
    }
    t.voxelManager = e2.createRLEVolumeVoxelManager({ dimensions: [
      n,
      r,
      1
    ] }), t.getPixelData = t.voxelManager.getPixelData, t.sizeInBytes = DEFAULT_RLE_SIZE;
  }
};
require_fast_deep_equal();
var DEFAULT_VIEW_API = "WebGL", VIEW_CONSTRUCTORS = /* @__PURE__ */ Object.create(null);
function registerViewConstructor(e12, t) {
  VIEW_CONSTRUCTORS[e12] = t;
}
function listViewAPIs() {
  return Object.keys(VIEW_CONSTRUCTORS);
}
function newAPISpecificView(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return VIEW_CONSTRUCTORS[e12] && VIEW_CONSTRUCTORS[e12](t);
}
function vtkRenderWindow$2(e12, t) {
  t.classHierarchy.push("vtkRenderWindow"), e12.addRenderer = (n) => {
    e12.hasRenderer(n) || (n.setRenderWindow(e12), t.renderers.push(n), e12.modified());
  }, e12.removeRenderer = (n) => {
    t.renderers = t.renderers.filter((e13) => e13 !== n), e12.modified();
  }, e12.hasRenderer = (e13) => t.renderers.indexOf(e13) !== -1, e12.newAPISpecificView = function(e13) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return newAPISpecificView(e13 || t.defaultViewAPI, n);
  }, e12.addView = (n) => {
    e12.hasView(n) || (n.setRenderable(e12), t._views.push(n), e12.modified());
  }, e12.removeView = (n) => {
    t._views = t._views.filter((e13) => e13 !== n), e12.modified();
  }, e12.hasView = (e13) => t._views.indexOf(e13) !== -1, e12.preRender = () => {
    t.renderers.forEach((e13) => {
      e13.isActiveCameraCreated() || e13.resetCamera();
    });
  }, e12.render = () => {
    e12.preRender(), t.interactor ? t.interactor.render() : t._views.forEach((e13) => e13.traverseAllPasses());
  }, e12.getStatistics = () => {
    let e13 = {
      propCount: 0,
      invisiblePropCount: 0,
      gpuMemoryMB: 0
    };
    return t._views.forEach((t2) => {
      t2.getGraphicsMemoryInfo && (e13.gpuMemoryMB += t2.getGraphicsMemoryInfo() / 1e6);
    }), t.renderers.forEach((n) => {
      let r = n.getViewProps(), a = t._views[0].getViewNodeFor(n);
      r.forEach((t2) => {
        if (t2.getVisibility()) {
          e13.propCount += 1;
          let n2 = t2.getMapper && t2.getMapper();
          if (n2 && n2.getPrimitiveCount) {
            let t3 = a.getViewNodeFor(n2);
            if (t3) {
              t3.getAllocatedGPUMemoryInBytes && (e13.gpuMemoryMB += t3.getAllocatedGPUMemoryInBytes() / 1e6);
              let r2 = n2.getPrimitiveCount();
              Object.keys(r2).forEach((t4) => {
                e13[t4] || (e13[t4] = 0), e13[t4] += r2[t4];
              });
            }
          }
        } else
          e13.invisiblePropCount += 1;
      });
    }), e13.str = Object.keys(e13).map((t2) => `${t2}: ${e13[t2]}`).join("\n"), e13;
  }, e12.captureImages = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "image/png", r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return macro.setImmediate(e12.render), t._views.map((e13) => e13.captureNextImage ? e13.captureNextImage(n, r) : void 0).filter((e13) => !!e13);
  }, e12.addRenderWindow = (n) => t.childRenderWindows.includes(n) ? false : (t.childRenderWindows.push(n), e12.modified(), true), e12.removeRenderWindow = (n) => {
    let r = t.childRenderWindows.findIndex((e13) => e13 === n);
    return r < 0 ? false : (t.childRenderWindows.splice(r, 1), e12.modified(), true);
  };
}
var DEFAULT_VALUES$57 = {
  defaultViewAPI: DEFAULT_VIEW_API,
  renderers: [],
  views: [],
  interactor: null,
  neverRendered: true,
  numberOfLayers: 1,
  childRenderWindows: []
};
function extend$66(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$57, n), macro.obj(e12, t), macro.setGet(e12, t, [
    "interactor",
    "numberOfLayers",
    "_views",
    "defaultViewAPI"
  ]), macro.get(e12, t, ["neverRendered"]), macro.getArray(e12, t, ["renderers", "childRenderWindows"]), macro.moveToProtected(e12, t, ["views"]), macro.event(e12, t, "completion"), vtkRenderWindow$2(e12, t);
}
var vtkRenderWindow$1 = {
  newInstance: macro.newInstance(extend$66, "vtkRenderWindow"),
  extend: extend$66,
  registerViewConstructor,
  listViewAPIs,
  newAPISpecificView
};
function vtkRenderPass(e12, t) {
  t.classHierarchy.push("vtkRenderPass"), e12.getOperation = () => t.currentOperation, e12.setCurrentOperation = (e13) => {
    t.currentOperation = e13, t.currentTraverseOperation = `traverse${macro.capitalize(t.currentOperation)}`;
  }, e12.getTraverseOperation = () => t.currentTraverseOperation, e12.traverse = function(n) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    t.deleted || (t._currentParent = r, t.preDelegateOperations.forEach((t2) => {
      e12.setCurrentOperation(t2), n.traverse(e12);
    }), t.delegates.forEach((t2) => {
      t2.traverse(n, e12);
    }), t.postDelegateOperations.forEach((t2) => {
      e12.setCurrentOperation(t2), n.traverse(e12);
    }));
  };
}
var DEFAULT_VALUES$56 = {
  delegates: [],
  currentOperation: null,
  preDelegateOperations: [],
  postDelegateOperations: [],
  currentParent: null
};
function extend$65(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$56, n), macro.obj(e12, t), macro.get(e12, t, ["currentOperation"]), macro.setGet(e12, t, [
    "delegates",
    "_currentParent",
    "preDelegateOperations",
    "postDelegateOperations"
  ]), macro.moveToProtected(e12, t, ["currentParent"]), vtkRenderPass(e12, t);
}
var vtkRenderPass$1 = {
  newInstance: macro.newInstance(extend$65, "vtkRenderPass"),
  extend: extend$65
}, { Representation: Representation$4 } = vtkProperty$1, { vtkErrorMacro: vtkErrorMacro$18 } = macro;
function translucentShaderReplacement(e12) {
  e12.Fragment = vtkShaderProgram$1.substitute(e12.Fragment, "//VTK::RenderPassFragmentShader::Impl", "\n      float weight = gl_FragData[0].a * pow(max(1.1 - gl_FragCoord.z, 0.0), 2.0);\n      gl_FragData[0] = vec4(gl_FragData[0].rgb*weight, gl_FragData[0].a);\n      gl_FragData[1].r = weight;\n    ", false).result;
}
var oitpFragTemplate = "//VTK::System::Dec\n\nin vec2 tcoord;\n\nuniform sampler2D translucentRTexture;\nuniform sampler2D translucentRGBATexture;\n\n// the output of this shader\n//VTK::Output::Dec\n\nvoid main()\n{\n  vec4 t1Color = texture(translucentRGBATexture, tcoord);\n  float t2Color = texture(translucentRTexture, tcoord).r;\n  gl_FragData[0] = vec4(t1Color.rgb/max(t2Color,0.01), 1.0 - t1Color.a);\n}\n";
function vtkOpenGLOrderIndependentTranslucentPass(e12, t) {
  t.classHierarchy.push("vtkOpenGLOrderIndependentTranslucentPass"), e12.createVertexBuffer = () => {
    let e13 = new Float32Array([
      -1,
      -1,
      -1,
      1,
      -1,
      -1,
      -1,
      1,
      -1,
      1,
      1,
      -1
    ]), n = new Float32Array([
      0,
      0,
      1,
      0,
      0,
      1,
      1,
      1
    ]), r = new Uint16Array([
      4,
      0,
      1,
      3,
      2
    ]), a = vtkDataArray$1.newInstance({
      numberOfComponents: 3,
      values: e13
    });
    a.setName("points");
    let o = vtkDataArray$1.newInstance({
      numberOfComponents: 2,
      values: n
    });
    o.setName("tcoords");
    let s = vtkDataArray$1.newInstance({
      numberOfComponents: 1,
      values: r
    });
    t.tris.getCABO().createVBO(s, "polys", Representation$4.SURFACE, {
      points: a,
      tcoords: o,
      cellOffset: 0
    }), t.VBOBuildTime.modified();
  }, e12.createFramebuffer = (e13) => {
    let n = e13.getSize(), r = e13.getContext();
    t.framebuffer = vtkOpenGLFramebuffer.newInstance(), t.framebuffer.setOpenGLRenderWindow(e13), t.framebuffer.create(...n), t.framebuffer.saveCurrentBindingsAndBuffers(), t.framebuffer.bind(), t.translucentRGBATexture = vtkOpenGLTexture$1.newInstance(), t.translucentRGBATexture.setInternalFormat(r.RGBA16F), t.translucentRGBATexture.setFormat(r.RGBA), t.translucentRGBATexture.setOpenGLDataType(r.HALF_FLOAT), t.translucentRGBATexture.setOpenGLRenderWindow(e13), t.translucentRGBATexture.create2DFromRaw({
      width: n[0],
      height: n[1],
      numComps: 4,
      dataType: "Float32Array",
      data: null
    }), t.translucentRTexture = vtkOpenGLTexture$1.newInstance(), t.translucentRTexture.setInternalFormat(r.R16F), t.translucentRTexture.setFormat(r.RED), t.translucentRTexture.setOpenGLDataType(r.HALF_FLOAT), t.translucentRTexture.setOpenGLRenderWindow(e13), t.translucentRTexture.create2DFromRaw({
      width: n[0],
      height: n[1],
      numComps: 1,
      dataType: "Float32Array",
      data: null
    }), t.translucentZTexture = vtkOpenGLTexture$1.newInstance(), t.translucentZTexture.setOpenGLRenderWindow(e13), t.translucentZTexture.createDepthFromRaw({
      width: n[0],
      height: n[1],
      dataType: "Float32Array",
      data: null
    }), t.framebuffer.setColorBuffer(t.translucentRGBATexture, 0), t.framebuffer.setColorBuffer(t.translucentRTexture, 1), t.framebuffer.setDepthBuffer(t.translucentZTexture);
  }, e12.createCopyShader = (e13) => {
    t.copyShader = e13.getShaderCache().readyShaderProgramArray([
      "//VTK::System::Dec",
      "attribute vec4 vertexDC;",
      "attribute vec2 tcoordTC;",
      "varying vec2 tcoord;",
      "void main() { tcoord = tcoordTC; gl_Position = vertexDC; }"
    ].join("\n"), oitpFragTemplate, "");
  }, e12.createVBO = (n) => {
    let r = n.getContext();
    t.tris.setOpenGLRenderWindow(n), e12.createVertexBuffer();
    let a = t.copyShader;
    t.tris.getCABO().bind(), t.copyVAO.addAttributeArray(a, t.tris.getCABO(), "vertexDC", t.tris.getCABO().getVertexOffset(), t.tris.getCABO().getStride(), r.FLOAT, 3, r.FALSE) || vtkErrorMacro$18("Error setting vertexDC in copy shader VAO."), t.copyVAO.addAttributeArray(a, t.tris.getCABO(), "tcoordTC", t.tris.getCABO().getTCoordOffset(), t.tris.getCABO().getStride(), r.FLOAT, 2, r.FALSE) || vtkErrorMacro$18("Error setting vertexDC in copy shader VAO.");
  }, e12.traverse = (n, r, a) => {
    if (t.deleted)
      return;
    let o = n.getSize(), s = n.getContext();
    if (t._supported = false, r.getSelector() || !s || !n.getWebgl2() || !s.getExtension("EXT_color_buffer_half_float") && !s.getExtension("EXT_color_buffer_float")) {
      e12.setCurrentOperation("translucentPass"), r.traverse(e12);
      return;
    }
    if (t._supported = true, t.framebuffer === null)
      e12.createFramebuffer(n);
    else {
      let r2 = t.framebuffer.getSize();
      r2 === null || r2[0] !== o[0] || r2[1] !== o[1] ? (t.framebuffer.releaseGraphicsResources(), t.translucentRGBATexture.releaseGraphicsResources(n), t.translucentRTexture.releaseGraphicsResources(n), t.translucentZTexture.releaseGraphicsResources(n), e12.createFramebuffer(n)) : (t.framebuffer.saveCurrentBindingsAndBuffers(), t.framebuffer.bind());
    }
    s.drawBuffers([s.COLOR_ATTACHMENT0]), s.clearBufferfv(s.COLOR, 0, [
      0,
      0,
      0,
      0
    ]), s.clearBufferfv(s.DEPTH, 0, [1]), s.colorMask(false, false, false, false), a.getOpaqueActorCount() > 0 && (a.setCurrentOperation("opaqueZBufferPass"), r.traverse(a)), s.colorMask(true, true, true, true), s.drawBuffers([s.COLOR_ATTACHMENT0, s.COLOR_ATTACHMENT1]), s.viewport(0, 0, o[0], o[1]), s.scissor(0, 0, o[0], o[1]), s.clearBufferfv(s.COLOR, 0, [
      0,
      0,
      0,
      1
    ]), s.clearBufferfv(s.COLOR, 1, [
      0,
      0,
      0,
      0
    ]), s.enable(s.DEPTH_TEST), s.enable(s.BLEND), s.blendFuncSeparate(s.ONE, s.ONE, s.ZERO, s.ONE_MINUS_SRC_ALPHA), e12.setCurrentOperation("translucentPass"), r.traverse(e12), s.drawBuffers([s.NONE]), t.framebuffer.restorePreviousBindingsAndBuffers(), t.copyShader === null ? e12.createCopyShader(n) : n.getShaderCache().readyShaderProgram(t.copyShader), t.copyVAO || (t.copyVAO = vtkVertexArrayObject.newInstance(), t.copyVAO.setOpenGLRenderWindow(n)), t.copyVAO.bind(), t.VBOBuildTime.getMTime() < e12.getMTime() && e12.createVBO(n), s.blendFuncSeparate(s.SRC_ALPHA, s.ONE_MINUS_SRC_ALPHA, s.ONE, s.ONE_MINUS_SRC_ALPHA), s.depthMask(false), s.depthFunc(s.ALWAYS), s.viewport(0, 0, o[0], o[1]), s.scissor(0, 0, o[0], o[1]), t.translucentRGBATexture.activate(), t.copyShader.setUniformi("translucentRGBATexture", t.translucentRGBATexture.getTextureUnit()), t.translucentRTexture.activate(), t.copyShader.setUniformi("translucentRTexture", t.translucentRTexture.getTextureUnit()), s.drawArrays(s.TRIANGLES, 0, t.tris.getCABO().getElementCount()), s.depthMask(true), s.depthFunc(s.LEQUAL), t.translucentRGBATexture.deactivate(), t.translucentRTexture.deactivate();
    let c = r.getTiledSizeAndOrigin();
    s.scissor(c.lowerLeftU, c.lowerLeftV, c.usize, c.vsize), s.viewport(c.lowerLeftU, c.lowerLeftV, c.usize, c.vsize);
  }, e12.getShaderReplacement = () => t._supported ? translucentShaderReplacement : null, e12.releaseGraphicsResources = (n) => {
    t.framebuffer &&= (t.framebuffer.releaseGraphicsResources(n), null), t.translucentRGBATexture &&= (t.translucentRGBATexture.releaseGraphicsResources(n), null), t.translucentRTexture &&= (t.translucentRTexture.releaseGraphicsResources(n), null), t.translucentZTexture &&= (t.translucentZTexture.releaseGraphicsResources(n), null), t.copyVAO &&= (t.copyVAO.releaseGraphicsResources(n), null), t.copyShader &&= (t.copyShader.releaseGraphicsResources(n), null), t.tris &&= (t.tris.releaseGraphicsResources(n), null), e12.modified();
  };
}
var DEFAULT_VALUES$55 = {
  framebuffer: null,
  copyShader: null,
  tris: null
};
function extend$64(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$55, n), vtkRenderPass$1.extend(e12, t, n), t.VBOBuildTime = {}, macro.obj(t.VBOBuildTime, { mtime: 0 }), t.tris = vtkHelper.newInstance(), macro.get(e12, t, ["framebuffer"]), vtkOpenGLOrderIndependentTranslucentPass(e12, t);
}
var vtkOpenGLOrderIndependentTranslucentPass$1 = {
  newInstance: macro.newInstance(extend$64, "vtkOpenGLOrderIndependentTranslucentPass"),
  extend: extend$64
};
function vtkForwardPass(e12, t) {
  t.classHierarchy.push("vtkForwardPass"), e12.traverse = function(n) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (t.deleted)
      return;
    t._currentParent = r, e12.setCurrentOperation("buildPass"), n.traverse(e12);
    let a = n.getRenderable().getNumberOfLayers(), o = n.getRenderable().getRenderersByReference();
    for (let r2 = 0; r2 < a; r2++)
      for (let a2 = 0; a2 < o.length; a2++) {
        let s = o[a2], c = n.getViewNodeFor(s);
        if (s.getDraw() && s.getLayer() === r2) {
          if (t.opaqueActorCount = 0, t.translucentActorCount = 0, t.volumeCount = 0, t.overlayActorCount = 0, e12.setCurrentOperation("queryPass"), c.traverse(e12), (t.opaqueActorCount > 0 || t.translucentActorCount > 0) && t.volumeCount > 0 || t.depthRequested) {
            let r3 = n.getFramebufferSize();
            t.framebuffer === null && (t.framebuffer = vtkOpenGLFramebuffer.newInstance()), t.framebuffer.setOpenGLRenderWindow(n), t.framebuffer.saveCurrentBindingsAndBuffers();
            let a3 = t.framebuffer.getSize();
            (a3 === null || a3[0] !== r3[0] || a3[1] !== r3[1]) && (t.framebuffer.create(r3[0], r3[1]), t.framebuffer.populateFramebuffer()), t.framebuffer.bind(), e12.setCurrentOperation("zBufferPass"), c.traverse(e12), t.framebuffer.restorePreviousBindingsAndBuffers(), t.depthRequested = false;
          }
          e12.setCurrentOperation("cameraPass"), c.traverse(e12), t.opaqueActorCount > 0 && (e12.setCurrentOperation("opaquePass"), c.traverse(e12)), t.translucentActorCount > 0 && (t.translucentPass ||= vtkOpenGLOrderIndependentTranslucentPass$1.newInstance(), t.translucentPass.traverse(n, c, e12)), t.volumeCount > 0 && (e12.setCurrentOperation("volumePass"), c.traverse(e12)), t.overlayActorCount > 0 && (e12.setCurrentOperation("overlayPass"), c.traverse(e12));
        }
      }
  }, e12.getZBufferTexture = () => t.framebuffer ? t.framebuffer.getColorTexture() : null, e12.requestDepth = () => {
    t.depthRequested = true;
  }, e12.incrementOpaqueActorCount = () => t.opaqueActorCount++, e12.incrementTranslucentActorCount = () => t.translucentActorCount++, e12.incrementVolumeCount = () => t.volumeCount++, e12.incrementOverlayActorCount = () => t.overlayActorCount++;
}
var DEFAULT_VALUES$54 = {
  opaqueActorCount: 0,
  translucentActorCount: 0,
  volumeCount: 0,
  overlayActorCount: 0,
  framebuffer: null,
  depthRequested: false
};
function extend$63(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$54, n), vtkRenderPass$1.extend(e12, t, n), macro.get(e12, t, [
    "framebuffer",
    "opaqueActorCount",
    "translucentActorCount",
    "volumeCount"
  ]), vtkForwardPass(e12, t);
}
var vtkForwardPass$1 = {
  newInstance: macro.newInstance(extend$63, "vtkForwardPass"),
  extend: extend$63
}, PassTypes$1 = {
  MIN_KNOWN_PASS: 0,
  ACTOR_PASS: 0,
  COMPOSITE_INDEX_PASS: 1,
  ID_LOW24: 2,
  ID_HIGH24: 3,
  MAX_KNOWN_PASS: 3
}, Constants$7 = { PassTypes: PassTypes$1 }, { FieldAssociations: FieldAssociations$3 } = vtkDataSet$1;
function vtkHardwareSelector$2(e12, t) {
  t.classHierarchy.push("vtkHardwareSelector"), e12.getSourceDataAsync = async (e13, t2, n, r, a) => {
  }, e12.selectAsync = async (t2, n, r, a, o) => {
    let s = await e12.getSourceDataAsync(t2, n, r, a, o);
    return s ? s.generateSelection(n, r, a, o) : [];
  };
}
var DEFAULT_VALUES$53 = {
  fieldAssociation: FieldAssociations$3.FIELD_ASSOCIATION_CELLS,
  captureZValues: false
};
function extend$62(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$53, n), macro.obj(e12, t), macro.setGet(e12, t, ["fieldAssociation", "captureZValues"]), vtkHardwareSelector$2(e12, t);
}
var vtkHardwareSelector$1 = {
  newInstance: macro.newInstance(extend$62, "vtkHardwareSelector"),
  extend: extend$62
}, Constants$8 = {
  SelectionContent: {
    GLOBALIDS: 0,
    PEDIGREEIDS: 1,
    VALUES: 2,
    INDICES: 3,
    FRUSTUM: 4,
    LOCATIONS: 5,
    THRESHOLDS: 6,
    BLOCKS: 7,
    QUERY: 8
  },
  SelectionField: {
    CELL: 0,
    POINT: 1,
    FIELD: 2,
    VERTEX: 3,
    EDGE: 4,
    ROW: 5
  }
};
function vtkSelectionNode(e12, t) {
  t.classHierarchy.push("vtkSelectionNode"), e12.getBounds = () => t.points.getBounds();
}
var DEFAULT_VALUES$52 = {
  contentType: -1,
  fieldType: -1,
  properties: null,
  selectionList: []
};
function extend$61(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$52, n), macro.obj(e12, t), t.properties = {}, macro.setGet(e12, t, [
    "contentType",
    "fieldType",
    "properties",
    "selectionList"
  ]), vtkSelectionNode(e12, t);
}
var vtkSelectionNode$1 = {
  newInstance: macro.newInstance(extend$61, "vtkSelectionNode"),
  extend: extend$61,
  ...Constants$8
}, { PassTypes: PassTypes$2 } = Constants$7, { SelectionContent, SelectionField } = vtkSelectionNode$1, { FieldAssociations: FieldAssociations$2 } = vtkDataSet$1, { vtkErrorMacro: vtkErrorMacro$17 } = macro, idOffset = 1;
function getInfoHash(e12) {
  return `${e12.propID} ${e12.compositeID}`;
}
function getAlpha(e12, t, n, r) {
  return n ? n[(t * (r[2] - r[0] + 1) + e12) * 4 + 3] : 0;
}
function convert(e12, t, n, r) {
  if (!n)
    return 0;
  let a = (t * (r[2] - r[0] + 1) + e12) * 4, o = n[a], s = n[a + 1];
  return (n[a + 2] * 256 + s) * 256 + o;
}
function getID(e12, t) {
  let n = t;
  return n <<= 24, n |= e12, n;
}
function getPixelInformationWithData(e12, t, n, r) {
  let a = n < 0 ? 0 : n;
  if (a === 0) {
    if (r[0] = t[0], r[1] = t[1], t[0] < e12.area[0] || t[0] > e12.area[2] || t[1] < e12.area[1] || t[1] > e12.area[3])
      return null;
    let n2 = [t[0] - e12.area[0], t[1] - e12.area[1]], a2 = convert(n2[0], n2[1], e12.pixBuffer[PassTypes$2.ACTOR_PASS], e12.area);
    if (a2 <= 0 || a2 - idOffset >= e12.props.length)
      return null;
    let o2 = {};
    o2.valid = true, o2.propID = a2 - idOffset, o2.prop = e12.props[o2.propID];
    let s2 = convert(n2[0], n2[1], e12.pixBuffer[PassTypes$2.COMPOSITE_INDEX_PASS], e12.area);
    if ((s2 < 0 || s2 > 16777215) && (s2 = 0), o2.compositeID = s2 - idOffset, e12.captureZValues) {
      let r2 = (n2[1] * (e12.area[2] - e12.area[0] + 1) + n2[0]) * 4;
      o2.zValue = (256 * e12.zBuffer[r2] + e12.zBuffer[r2 + 1]) / 65535, o2.displayPosition = t;
    }
    return e12.pixBuffer[PassTypes$2.ID_LOW24] && getAlpha(n2[0], n2[1], e12.pixBuffer[PassTypes$2.ID_LOW24], e12.area) === 0 || (o2.attributeID = getID(convert(n2[0], n2[1], e12.pixBuffer[PassTypes$2.ID_LOW24], e12.area), convert(n2[0], n2[1], e12.pixBuffer[PassTypes$2.ID_HIGH24], e12.area))), o2;
  }
  let o = [t[0], t[1]], s = [0, 0], c = getPixelInformationWithData(e12, t, 0, r);
  if (c && c.valid)
    return c;
  for (let t2 = 1; t2 < a; ++t2) {
    for (let n2 = o[1] > t2 ? o[1] - t2 : 0; n2 <= o[1] + t2; ++n2)
      if (s[1] = n2, o[0] >= t2 && (s[0] = o[0] - t2, c = getPixelInformationWithData(e12, s, 0, r), c && c.valid) || (s[0] = o[0] + t2, c = getPixelInformationWithData(e12, s, 0, r), c && c.valid))
        return c;
    for (let n2 = o[0] >= t2 ? o[0] - (t2 - 1) : 0; n2 <= o[0] + (t2 - 1); ++n2)
      if (s[0] = n2, o[1] >= t2 && (s[1] = o[1] - t2, c = getPixelInformationWithData(e12, s, 0, r), c && c.valid) || (s[1] = o[1] + t2, c = getPixelInformationWithData(e12, s, 0, r), c && c.valid))
        return c;
  }
  return r[0] = t[0], r[1] = t[1], null;
}
function convertSelection(e12, t, n, r, a) {
  let o = [], s = 0;
  return t.forEach((t2, c) => {
    let l = vtkSelectionNode$1.newInstance();
    switch (l.setContentType(SelectionContent.INDICES), e12) {
      case FieldAssociations$2.FIELD_ASSOCIATION_CELLS:
        l.setFieldType(SelectionField.CELL);
        break;
      case FieldAssociations$2.FIELD_ASSOCIATION_POINTS:
        l.setFieldType(SelectionField.POINT);
        break;
      default:
        vtkErrorMacro$17("Unknown field association");
    }
    l.getProperties().propID = t2.info.propID, l.getProperties().prop = t2.info.prop, l.getProperties().compositeID = t2.info.compositeID, l.getProperties().attributeID = t2.info.attributeID, l.getProperties().pixelCount = t2.pixelCount, n && (l.getProperties().displayPosition = [
      t2.info.displayPosition[0],
      t2.info.displayPosition[1],
      t2.info.zValue
    ], l.getProperties().worldPosition = a.displayToWorld(t2.info.displayPosition[0], t2.info.displayPosition[1], t2.info.zValue, r)), l.setSelectionList(t2.attributeIDs), o[s] = l, s++;
  }), o;
}
function generateSelectionWithData(e12, t, n, r, a) {
  let o = Math.floor(t), s = Math.floor(n), c = Math.floor(r), l = Math.floor(a), u = /* @__PURE__ */ new Map(), d = [0, 0];
  for (let t2 = s; t2 <= l; t2++)
    for (let n2 = o; n2 <= c; n2++) {
      let r2 = getPixelInformationWithData(e12, [n2, t2], 0, d);
      if (r2 && r2.valid) {
        let t3 = getInfoHash(r2);
        if (!u.has(t3))
          u.set(t3, {
            info: r2,
            pixelCount: 1,
            attributeIDs: [r2.attributeID]
          });
        else {
          let n3 = u.get(t3);
          n3.pixelCount++, e12.captureZValues && r2.zValue < n3.info.zValue && (n3.info = r2), n3.attributeIDs.indexOf(r2.attributeID) === -1 && n3.attributeIDs.push(r2.attributeID);
        }
      }
    }
  return convertSelection(e12.fieldAssociation, u, e12.captureZValues, e12.renderer, e12.openGLRenderWindow);
}
function vtkOpenGLHardwareSelector(e12, t) {
  t.classHierarchy.push("vtkOpenGLHardwareSelector"), e12.releasePixBuffers = () => {
    t.rawPixBuffer = [], t.pixBuffer = [], t.zBuffer = null;
  }, e12.beginSelection = () => {
    t._openGLRenderer = t._openGLRenderWindow.getViewNodeFor(t._renderer), t.maxAttributeId = 0;
    let n2 = t._openGLRenderWindow.getSize();
    if (!t.framebuffer)
      t.framebuffer = vtkOpenGLFramebuffer.newInstance(), t.framebuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.framebuffer.saveCurrentBindingsAndBuffers(), t.framebuffer.create(n2[0], n2[1]), t.framebuffer.populateFramebuffer();
    else {
      t.framebuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.framebuffer.saveCurrentBindingsAndBuffers();
      let e13 = t.framebuffer.getSize();
      !e13 || e13[0] !== n2[0] || e13[1] !== n2[1] ? (t.framebuffer.create(n2[0], n2[1]), t.framebuffer.populateFramebuffer()) : t.framebuffer.bind();
    }
    if (t._openGLRenderer.clear(), t._openGLRenderer.setSelector(e12), t.hitProps = {}, t.propPixels = {}, t.props = [], e12.releasePixBuffers(), t.fieldAssociation === FieldAssociations$2.FIELD_ASSOCIATION_POINTS) {
      let e13 = t._openGLRenderWindow.getContext(), n3 = e13.isEnabled(e13.BLEND);
      e13.disable(e13.BLEND), t._openGLRenderWindow.traverseAllPasses(), n3 && e13.enable(e13.BLEND);
    }
  }, e12.endSelection = () => {
    t.hitProps = {}, t._openGLRenderer.setSelector(null), t.framebuffer.restorePreviousBindingsAndBuffers();
  }, e12.preCapturePass = () => {
    let e13 = t._openGLRenderWindow.getContext();
    t.originalBlending = e13.isEnabled(e13.BLEND), e13.disable(e13.BLEND);
  }, e12.postCapturePass = () => {
    let e13 = t._openGLRenderWindow.getContext();
    t.originalBlending && e13.enable(e13.BLEND);
  }, e12.select = () => {
    let n2 = null;
    return e12.captureBuffers() && (n2 = e12.generateSelection(t.area[0], t.area[1], t.area[2], t.area[3]), e12.releasePixBuffers()), n2;
  }, e12.getSourceDataAsync = async (n2, r, a, o, s) => {
    if (t._renderer = n2, r === void 0) {
      let n3 = t._openGLRenderWindow.getSize();
      e12.setArea(0, 0, n3[0] - 1, n3[1] - 1);
    } else
      e12.setArea(r, a, o, s);
    if (!e12.captureBuffers())
      return false;
    let c = {
      area: [...t.area],
      pixBuffer: [...t.pixBuffer],
      captureZValues: t.captureZValues,
      zBuffer: t.zBuffer,
      props: [...t.props],
      fieldAssociation: t.fieldAssociation,
      renderer: n2,
      openGLRenderWindow: t._openGLRenderWindow
    };
    return c.generateSelection = function() {
      return generateSelectionWithData(c, ...arguments);
    }, c;
  }, e12.captureBuffers = () => {
    if (!t._renderer || !t._openGLRenderWindow)
      return vtkErrorMacro$17("Renderer and view must be set before calling Select."), false;
    t._openGLRenderer = t._openGLRenderWindow.getViewNodeFor(t._renderer), t._openGLRenderWindow.getRenderable().preRender(), e12.invokeEvent({ type: "StartEvent" }), t.originalBackground = t._renderer.getBackgroundByReference(), t._renderer.setBackground(0, 0, 0, 0);
    let n2 = t._openGLRenderWindow.getRenderPasses();
    e12.beginSelection();
    let r = [];
    for (t.currentPass = PassTypes$2.MIN_KNOWN_PASS; t.currentPass <= PassTypes$2.MAX_KNOWN_PASS; t.currentPass++)
      e12.passRequired(t.currentPass) && (e12.preCapturePass(t.currentPass), t.captureZValues && t.currentPass === PassTypes$2.ACTOR_PASS && typeof n2[0].requestDepth == "function" && typeof n2[0].getFramebuffer == "function" && n2[0].requestDepth(), t._openGLRenderWindow.traverseAllPasses(), e12.postCapturePass(t.currentPass), e12.savePixelBuffer(t.currentPass), r.push(t.currentPass));
    return r.forEach((n3) => {
      t.currentPass = n3, e12.processPixelBuffers();
    }), t.currentPass = PassTypes$2.MAX_KNOWN_PASS, e12.endSelection(), t._renderer.setBackground(t.originalBackground), e12.invokeEvent({ type: "EndEvent" }), true;
  }, e12.processPixelBuffers = () => {
    t.props.forEach((n2, r) => {
      e12.isPropHit(r) && n2.processSelectorPixelBuffers(e12, t.propPixels[r]);
    });
  }, e12.passRequired = (e13) => {
    if (e13 === PassTypes$2.ID_HIGH24) {
      if (t.fieldAssociation === FieldAssociations$2.FIELD_ASSOCIATION_POINTS)
        return t.maximumPointId > 16777215;
      if (t.fieldAssociation === FieldAssociations$2.FIELD_ASSOCIATION_CELLS)
        return t.maximumCellId > 16777215;
    }
    return true;
  }, e12.savePixelBuffer = (n2) => {
    if (t.pixBuffer[n2] = t._openGLRenderWindow.getPixelData(t.area[0], t.area[1], t.area[2], t.area[3]), !t.rawPixBuffer[n2]) {
      let e13 = (t.area[2] - t.area[0] + 1) * (t.area[3] - t.area[1] + 1) * 4;
      t.rawPixBuffer[n2] = new Uint8Array(e13), t.rawPixBuffer[n2].set(t.pixBuffer[n2]);
    }
    if (n2 === PassTypes$2.ACTOR_PASS) {
      if (t.captureZValues) {
        let e13 = t._openGLRenderWindow.getRenderPasses();
        if (typeof e13[0].requestDepth == "function" && typeof e13[0].getFramebuffer == "function") {
          let n3 = e13[0].getFramebuffer();
          n3.saveCurrentBindingsAndBuffers(), n3.bind(), t.zBuffer = t._openGLRenderWindow.getPixelData(t.area[0], t.area[1], t.area[2], t.area[3]), n3.restorePreviousBindingsAndBuffers();
        }
      }
      e12.buildPropHitList(t.rawPixBuffer[n2]);
    }
  }, e12.buildPropHitList = (e13) => {
    let n2 = 0;
    for (let r = 0; r <= t.area[3] - t.area[1]; r++)
      for (let a = 0; a <= t.area[2] - t.area[0]; a++) {
        let o = convert(a, r, e13, t.area);
        o > 0 && (o--, o in t.hitProps || (t.hitProps[o] = true, t.propPixels[o] = []), t.propPixels[o].push(n2 * 4)), ++n2;
      }
  }, e12.renderProp = (n2) => {
    t.currentPass === PassTypes$2.ACTOR_PASS && (e12.setPropColorValueFromInt(t.props.length + idOffset), t.props.push(n2));
  }, e12.renderCompositeIndex = (n2) => {
    t.currentPass === PassTypes$2.COMPOSITE_INDEX_PASS && e12.setPropColorValueFromInt(n2 + idOffset);
  }, e12.renderAttributeId = (e13) => {
    e13 < 0 || (t.maxAttributeId = e13 > t.maxAttributeId ? e13 : t.maxAttributeId);
  }, e12.passTypeToString = (e13) => macro.enumToString(PassTypes$2, e13), e12.isPropHit = (e13) => !!t.hitProps[e13], e12.setPropColorValueFromInt = (e13) => {
    t.propColorValue[0] = e13 % 256 / 255, t.propColorValue[1] = Math.floor(e13 / 256) % 256 / 255, t.propColorValue[2] = Math.floor(e13 / 65536) % 256 / 255;
  }, e12.getPixelInformation = (n2, r, a) => {
    let o = r < 0 ? 0 : r;
    if (console.log("getPixelInformation called", o), o === 0) {
      if (a[0] = n2[0], a[1] = n2[1], n2[0] < t.area[0] || n2[0] > t.area[2] || n2[1] < t.area[1] || n2[1] > t.area[3])
        return null;
      console.log(n2), console.log(t.area);
      let e13 = [n2[0] - t.area[0], n2[1] - t.area[1]];
      console.log("adjusted displayPosition", e13);
      let r2 = convert(e13[0], e13[1], t.pixBuffer[PassTypes$2.ACTOR_PASS], t.area);
      if (console.log("actorid", r2), r2 <= 0 || r2 - idOffset >= t.props.length)
        return null;
      let o2 = {};
      o2.valid = true, o2.propID = r2 - idOffset, o2.prop = t.props[o2.propID];
      let s2 = convert(e13[0], e13[1], t.pixBuffer[PassTypes$2.COMPOSITE_INDEX_PASS], t.area);
      if ((s2 < 0 || s2 > 16777215) && (s2 = 0), o2.compositeID = s2 - idOffset, t.captureZValues) {
        let r3 = (e13[1] * (t.area[2] - t.area[0] + 1) + e13[0]) * 4;
        o2.zValue = (256 * t.zBuffer[r3] + t.zBuffer[r3 + 1]) / 65535, o2.displayPosition = n2;
      }
      return t.pixBuffer[PassTypes$2.ID_LOW24] && getAlpha(e13[0], e13[1], t.pixBuffer[PassTypes$2.ID_LOW24], t.area) === 0 || (o2.attributeID = getID(convert(e13[0], e13[1], t.pixBuffer[PassTypes$2.ID_LOW24], t.area), convert(e13[0], e13[1], t.pixBuffer[PassTypes$2.ID_HIGH24], t.area))), o2;
    }
    let s = [n2[0], n2[1]], c = [0, 0], l = e12.getPixelInformation(n2, 0, a);
    if (l && l.valid)
      return l;
    for (let t2 = 1; t2 < o; ++t2) {
      for (let n3 = s[1] > t2 ? s[1] - t2 : 0; n3 <= s[1] + t2; ++n3)
        if (c[1] = n3, s[0] >= t2 && (c[0] = s[0] - t2, l = e12.getPixelInformation(c, 0, a), l && l.valid) || (c[0] = s[0] + t2, l = e12.getPixelInformation(c, 0, a), l && l.valid))
          return l;
      for (let n3 = s[0] >= t2 ? s[0] - (t2 - 1) : 0; n3 <= s[0] + (t2 - 1); ++n3)
        if (c[0] = n3, s[1] >= t2 && (c[1] = s[1] - t2, l = e12.getPixelInformation(c, 0, a), l && l.valid) || (c[1] = s[1] + t2, l = e12.getPixelInformation(c, 0, a), l && l.valid))
          return l;
    }
    return a[0] = n2[0], a[1] = n2[1], null;
  }, e12.generateSelection = (n2, r, a, o) => {
    let s = Math.floor(n2), c = Math.floor(r), l = Math.floor(a), u = Math.floor(o), d = /* @__PURE__ */ new Map(), f = [0, 0];
    for (let n3 = c; n3 <= u; n3++)
      for (let r2 = s; r2 <= l; r2++) {
        let a2 = [r2, n3], o2 = e12.getPixelInformation(a2, 0, f);
        if (o2 && o2.valid) {
          let e13 = getInfoHash(o2);
          if (!d.has(e13))
            d.set(e13, {
              info: o2,
              pixelCount: 1,
              attributeIDs: [o2.attributeID]
            });
          else {
            let n4 = d.get(e13);
            n4.pixelCount++, t.captureZValues && o2.zValue < n4.info.zValue && (n4.info = o2), n4.attributeIDs.indexOf(o2.attributeID) === -1 && n4.attributeIDs.push(o2.attributeID);
          }
        }
      }
    return convertSelection(t.fieldAssociation, d, t.captureZValues, t._renderer, t._openGLRenderWindow);
  }, e12.getRawPixelBuffer = (e13) => t.rawPixBuffer[e13], e12.getPixelBuffer = (e13) => t.pixBuffer[e13], e12.attach = (e13, n2) => {
    t._openGLRenderWindow = e13, t._renderer = n2;
  };
  let n = e12.setArea;
  e12.setArea = function() {
    return n(...arguments) ? (t.area[0] = Math.floor(t.area[0]), t.area[1] = Math.floor(t.area[1]), t.area[2] = Math.floor(t.area[2]), t.area[3] = Math.floor(t.area[3]), true) : false;
  };
}
var DEFAULT_VALUES$51 = {
  area: void 0,
  currentPass: -1,
  propColorValue: null,
  props: null,
  maximumPointId: 0,
  maximumCellId: 0,
  idOffset: 1
};
function extend$60(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$51, n), vtkHardwareSelector$1.extend(e12, t, n), t.propColorValue = [
    0,
    0,
    0
  ], t.props = [], t.area ||= [
    0,
    0,
    0,
    0
  ], macro.setGetArray(e12, t, ["area"], 4), macro.setGet(e12, t, [
    "_renderer",
    "currentPass",
    "_openGLRenderWindow",
    "maximumPointId",
    "maximumCellId"
  ]), macro.setGetArray(e12, t, ["propColorValue"], 3), macro.moveToProtected(e12, t, ["renderer", "openGLRenderWindow"]), macro.event(e12, t, "event"), vtkOpenGLHardwareSelector(e12, t);
}
var vtkHardwareSelector = {
  newInstance: macro.newInstance(extend$60, "vtkOpenGLHardwareSelector"),
  extend: extend$60,
  ...Constants$7
}, import_spark_md5 = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(n) {
    if (typeof e12 == "object")
      t.exports = n();
    else if (typeof define == "function" && define.amd)
      define(n);
    else {
      var r;
      try {
        r = window;
      } catch {
        r = self;
      }
      r.SparkMD5 = n();
    }
  })(function(e13) {
    var t2 = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f"
    ];
    function n(e14, t3) {
      var n2 = e14[0], r2 = e14[1], a2 = e14[2], o2 = e14[3];
      n2 += (r2 & a2 | ~r2 & o2) + t3[0] - 680876936 | 0, n2 = (n2 << 7 | n2 >>> 25) + r2 | 0, o2 += (n2 & r2 | ~n2 & a2) + t3[1] - 389564586 | 0, o2 = (o2 << 12 | o2 >>> 20) + n2 | 0, a2 += (o2 & n2 | ~o2 & r2) + t3[2] + 606105819 | 0, a2 = (a2 << 17 | a2 >>> 15) + o2 | 0, r2 += (a2 & o2 | ~a2 & n2) + t3[3] - 1044525330 | 0, r2 = (r2 << 22 | r2 >>> 10) + a2 | 0, n2 += (r2 & a2 | ~r2 & o2) + t3[4] - 176418897 | 0, n2 = (n2 << 7 | n2 >>> 25) + r2 | 0, o2 += (n2 & r2 | ~n2 & a2) + t3[5] + 1200080426 | 0, o2 = (o2 << 12 | o2 >>> 20) + n2 | 0, a2 += (o2 & n2 | ~o2 & r2) + t3[6] - 1473231341 | 0, a2 = (a2 << 17 | a2 >>> 15) + o2 | 0, r2 += (a2 & o2 | ~a2 & n2) + t3[7] - 45705983 | 0, r2 = (r2 << 22 | r2 >>> 10) + a2 | 0, n2 += (r2 & a2 | ~r2 & o2) + t3[8] + 1770035416 | 0, n2 = (n2 << 7 | n2 >>> 25) + r2 | 0, o2 += (n2 & r2 | ~n2 & a2) + t3[9] - 1958414417 | 0, o2 = (o2 << 12 | o2 >>> 20) + n2 | 0, a2 += (o2 & n2 | ~o2 & r2) + t3[10] - 42063 | 0, a2 = (a2 << 17 | a2 >>> 15) + o2 | 0, r2 += (a2 & o2 | ~a2 & n2) + t3[11] - 1990404162 | 0, r2 = (r2 << 22 | r2 >>> 10) + a2 | 0, n2 += (r2 & a2 | ~r2 & o2) + t3[12] + 1804603682 | 0, n2 = (n2 << 7 | n2 >>> 25) + r2 | 0, o2 += (n2 & r2 | ~n2 & a2) + t3[13] - 40341101 | 0, o2 = (o2 << 12 | o2 >>> 20) + n2 | 0, a2 += (o2 & n2 | ~o2 & r2) + t3[14] - 1502002290 | 0, a2 = (a2 << 17 | a2 >>> 15) + o2 | 0, r2 += (a2 & o2 | ~a2 & n2) + t3[15] + 1236535329 | 0, r2 = (r2 << 22 | r2 >>> 10) + a2 | 0, n2 += (r2 & o2 | a2 & ~o2) + t3[1] - 165796510 | 0, n2 = (n2 << 5 | n2 >>> 27) + r2 | 0, o2 += (n2 & a2 | r2 & ~a2) + t3[6] - 1069501632 | 0, o2 = (o2 << 9 | o2 >>> 23) + n2 | 0, a2 += (o2 & r2 | n2 & ~r2) + t3[11] + 643717713 | 0, a2 = (a2 << 14 | a2 >>> 18) + o2 | 0, r2 += (a2 & n2 | o2 & ~n2) + t3[0] - 373897302 | 0, r2 = (r2 << 20 | r2 >>> 12) + a2 | 0, n2 += (r2 & o2 | a2 & ~o2) + t3[5] - 701558691 | 0, n2 = (n2 << 5 | n2 >>> 27) + r2 | 0, o2 += (n2 & a2 | r2 & ~a2) + t3[10] + 38016083 | 0, o2 = (o2 << 9 | o2 >>> 23) + n2 | 0, a2 += (o2 & r2 | n2 & ~r2) + t3[15] - 660478335 | 0, a2 = (a2 << 14 | a2 >>> 18) + o2 | 0, r2 += (a2 & n2 | o2 & ~n2) + t3[4] - 405537848 | 0, r2 = (r2 << 20 | r2 >>> 12) + a2 | 0, n2 += (r2 & o2 | a2 & ~o2) + t3[9] + 568446438 | 0, n2 = (n2 << 5 | n2 >>> 27) + r2 | 0, o2 += (n2 & a2 | r2 & ~a2) + t3[14] - 1019803690 | 0, o2 = (o2 << 9 | o2 >>> 23) + n2 | 0, a2 += (o2 & r2 | n2 & ~r2) + t3[3] - 187363961 | 0, a2 = (a2 << 14 | a2 >>> 18) + o2 | 0, r2 += (a2 & n2 | o2 & ~n2) + t3[8] + 1163531501 | 0, r2 = (r2 << 20 | r2 >>> 12) + a2 | 0, n2 += (r2 & o2 | a2 & ~o2) + t3[13] - 1444681467 | 0, n2 = (n2 << 5 | n2 >>> 27) + r2 | 0, o2 += (n2 & a2 | r2 & ~a2) + t3[2] - 51403784 | 0, o2 = (o2 << 9 | o2 >>> 23) + n2 | 0, a2 += (o2 & r2 | n2 & ~r2) + t3[7] + 1735328473 | 0, a2 = (a2 << 14 | a2 >>> 18) + o2 | 0, r2 += (a2 & n2 | o2 & ~n2) + t3[12] - 1926607734 | 0, r2 = (r2 << 20 | r2 >>> 12) + a2 | 0, n2 += (r2 ^ a2 ^ o2) + t3[5] - 378558 | 0, n2 = (n2 << 4 | n2 >>> 28) + r2 | 0, o2 += (n2 ^ r2 ^ a2) + t3[8] - 2022574463 | 0, o2 = (o2 << 11 | o2 >>> 21) + n2 | 0, a2 += (o2 ^ n2 ^ r2) + t3[11] + 1839030562 | 0, a2 = (a2 << 16 | a2 >>> 16) + o2 | 0, r2 += (a2 ^ o2 ^ n2) + t3[14] - 35309556 | 0, r2 = (r2 << 23 | r2 >>> 9) + a2 | 0, n2 += (r2 ^ a2 ^ o2) + t3[1] - 1530992060 | 0, n2 = (n2 << 4 | n2 >>> 28) + r2 | 0, o2 += (n2 ^ r2 ^ a2) + t3[4] + 1272893353 | 0, o2 = (o2 << 11 | o2 >>> 21) + n2 | 0, a2 += (o2 ^ n2 ^ r2) + t3[7] - 155497632 | 0, a2 = (a2 << 16 | a2 >>> 16) + o2 | 0, r2 += (a2 ^ o2 ^ n2) + t3[10] - 1094730640 | 0, r2 = (r2 << 23 | r2 >>> 9) + a2 | 0, n2 += (r2 ^ a2 ^ o2) + t3[13] + 681279174 | 0, n2 = (n2 << 4 | n2 >>> 28) + r2 | 0, o2 += (n2 ^ r2 ^ a2) + t3[0] - 358537222 | 0, o2 = (o2 << 11 | o2 >>> 21) + n2 | 0, a2 += (o2 ^ n2 ^ r2) + t3[3] - 722521979 | 0, a2 = (a2 << 16 | a2 >>> 16) + o2 | 0, r2 += (a2 ^ o2 ^ n2) + t3[6] + 76029189 | 0, r2 = (r2 << 23 | r2 >>> 9) + a2 | 0, n2 += (r2 ^ a2 ^ o2) + t3[9] - 640364487 | 0, n2 = (n2 << 4 | n2 >>> 28) + r2 | 0, o2 += (n2 ^ r2 ^ a2) + t3[12] - 421815835 | 0, o2 = (o2 << 11 | o2 >>> 21) + n2 | 0, a2 += (o2 ^ n2 ^ r2) + t3[15] + 530742520 | 0, a2 = (a2 << 16 | a2 >>> 16) + o2 | 0, r2 += (a2 ^ o2 ^ n2) + t3[2] - 995338651 | 0, r2 = (r2 << 23 | r2 >>> 9) + a2 | 0, n2 += (a2 ^ (r2 | ~o2)) + t3[0] - 198630844 | 0, n2 = (n2 << 6 | n2 >>> 26) + r2 | 0, o2 += (r2 ^ (n2 | ~a2)) + t3[7] + 1126891415 | 0, o2 = (o2 << 10 | o2 >>> 22) + n2 | 0, a2 += (n2 ^ (o2 | ~r2)) + t3[14] - 1416354905 | 0, a2 = (a2 << 15 | a2 >>> 17) + o2 | 0, r2 += (o2 ^ (a2 | ~n2)) + t3[5] - 57434055 | 0, r2 = (r2 << 21 | r2 >>> 11) + a2 | 0, n2 += (a2 ^ (r2 | ~o2)) + t3[12] + 1700485571 | 0, n2 = (n2 << 6 | n2 >>> 26) + r2 | 0, o2 += (r2 ^ (n2 | ~a2)) + t3[3] - 1894986606 | 0, o2 = (o2 << 10 | o2 >>> 22) + n2 | 0, a2 += (n2 ^ (o2 | ~r2)) + t3[10] - 1051523 | 0, a2 = (a2 << 15 | a2 >>> 17) + o2 | 0, r2 += (o2 ^ (a2 | ~n2)) + t3[1] - 2054922799 | 0, r2 = (r2 << 21 | r2 >>> 11) + a2 | 0, n2 += (a2 ^ (r2 | ~o2)) + t3[8] + 1873313359 | 0, n2 = (n2 << 6 | n2 >>> 26) + r2 | 0, o2 += (r2 ^ (n2 | ~a2)) + t3[15] - 30611744 | 0, o2 = (o2 << 10 | o2 >>> 22) + n2 | 0, a2 += (n2 ^ (o2 | ~r2)) + t3[6] - 1560198380 | 0, a2 = (a2 << 15 | a2 >>> 17) + o2 | 0, r2 += (o2 ^ (a2 | ~n2)) + t3[13] + 1309151649 | 0, r2 = (r2 << 21 | r2 >>> 11) + a2 | 0, n2 += (a2 ^ (r2 | ~o2)) + t3[4] - 145523070 | 0, n2 = (n2 << 6 | n2 >>> 26) + r2 | 0, o2 += (r2 ^ (n2 | ~a2)) + t3[11] - 1120210379 | 0, o2 = (o2 << 10 | o2 >>> 22) + n2 | 0, a2 += (n2 ^ (o2 | ~r2)) + t3[2] + 718787259 | 0, a2 = (a2 << 15 | a2 >>> 17) + o2 | 0, r2 += (o2 ^ (a2 | ~n2)) + t3[9] - 343485551 | 0, r2 = (r2 << 21 | r2 >>> 11) + a2 | 0, e14[0] = n2 + e14[0] | 0, e14[1] = r2 + e14[1] | 0, e14[2] = a2 + e14[2] | 0, e14[3] = o2 + e14[3] | 0;
    }
    function r(e14) {
      var t3 = [], n2;
      for (n2 = 0; n2 < 64; n2 += 4)
        t3[n2 >> 2] = e14.charCodeAt(n2) + (e14.charCodeAt(n2 + 1) << 8) + (e14.charCodeAt(n2 + 2) << 16) + (e14.charCodeAt(n2 + 3) << 24);
      return t3;
    }
    function a(e14) {
      var t3 = [], n2;
      for (n2 = 0; n2 < 64; n2 += 4)
        t3[n2 >> 2] = e14[n2] + (e14[n2 + 1] << 8) + (e14[n2 + 2] << 16) + (e14[n2 + 3] << 24);
      return t3;
    }
    function o(e14) {
      var t3 = e14.length, a2 = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
      ], o2, s2, c2, l2, u2, d2;
      for (o2 = 64; o2 <= t3; o2 += 64)
        n(a2, r(e14.substring(o2 - 64, o2)));
      for (e14 = e14.substring(o2 - 64), s2 = e14.length, c2 = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ], o2 = 0; o2 < s2; o2 += 1)
        c2[o2 >> 2] |= e14.charCodeAt(o2) << (o2 % 4 << 3);
      if (c2[o2 >> 2] |= 128 << (o2 % 4 << 3), o2 > 55)
        for (n(a2, c2), o2 = 0; o2 < 16; o2 += 1)
          c2[o2] = 0;
      return l2 = t3 * 8, l2 = l2.toString(16).match(/(.*?)(.{0,8})$/), u2 = parseInt(l2[2], 16), d2 = parseInt(l2[1], 16) || 0, c2[14] = u2, c2[15] = d2, n(a2, c2), a2;
    }
    function s(e14) {
      var t3 = e14.length, r2 = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
      ], o2, s2, c2, l2, u2, d2;
      for (o2 = 64; o2 <= t3; o2 += 64)
        n(r2, a(e14.subarray(o2 - 64, o2)));
      for (e14 = o2 - 64 < t3 ? e14.subarray(o2 - 64) : new Uint8Array(), s2 = e14.length, c2 = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ], o2 = 0; o2 < s2; o2 += 1)
        c2[o2 >> 2] |= e14[o2] << (o2 % 4 << 3);
      if (c2[o2 >> 2] |= 128 << (o2 % 4 << 3), o2 > 55)
        for (n(r2, c2), o2 = 0; o2 < 16; o2 += 1)
          c2[o2] = 0;
      return l2 = t3 * 8, l2 = l2.toString(16).match(/(.*?)(.{0,8})$/), u2 = parseInt(l2[2], 16), d2 = parseInt(l2[1], 16) || 0, c2[14] = u2, c2[15] = d2, n(r2, c2), r2;
    }
    function c(e14) {
      var n2 = "", r2;
      for (r2 = 0; r2 < 4; r2 += 1)
        n2 += t2[e14 >> r2 * 8 + 4 & 15] + t2[e14 >> r2 * 8 & 15];
      return n2;
    }
    function l(e14) {
      var t3;
      for (t3 = 0; t3 < e14.length; t3 += 1)
        e14[t3] = c(e14[t3]);
      return e14.join("");
    }
    l(o("hello")), typeof ArrayBuffer < "u" && !ArrayBuffer.prototype.slice && function() {
      function t3(e14, t4) {
        return e14 = e14 | 0 || 0, e14 < 0 ? Math.max(e14 + t4, 0) : Math.min(e14, t4);
      }
      ArrayBuffer.prototype.slice = function(n2, r2) {
        var a2 = this.byteLength, o2 = t3(n2, a2), s2 = a2, c2, l2, u2, d2;
        return r2 !== e13 && (s2 = t3(r2, a2)), o2 > s2 ? /* @__PURE__ */ new ArrayBuffer(0) : (c2 = s2 - o2, l2 = new ArrayBuffer(c2), u2 = new Uint8Array(l2), d2 = new Uint8Array(this, o2, c2), u2.set(d2), l2);
      };
    }();
    function u(e14) {
      return /[\u0080-\uFFFF]/.test(e14) && (e14 = unescape(encodeURIComponent(e14))), e14;
    }
    function d(e14, t3) {
      var n2 = e14.length, r2 = new ArrayBuffer(n2), a2 = new Uint8Array(r2), o2;
      for (o2 = 0; o2 < n2; o2 += 1)
        a2[o2] = e14.charCodeAt(o2);
      return t3 ? a2 : r2;
    }
    function f(e14) {
      return String.fromCharCode.apply(null, new Uint8Array(e14));
    }
    function p(e14, t3, n2) {
      var r2 = new Uint8Array(e14.byteLength + t3.byteLength);
      return r2.set(new Uint8Array(e14)), r2.set(new Uint8Array(t3), e14.byteLength), n2 ? r2 : r2.buffer;
    }
    function m(e14) {
      var t3 = [], n2 = e14.length, r2;
      for (r2 = 0; r2 < n2 - 1; r2 += 2)
        t3.push(parseInt(e14.substr(r2, 2), 16));
      return String.fromCharCode.apply(String, t3);
    }
    function h() {
      this.reset();
    }
    return h.prototype.append = function(e14) {
      return this.appendBinary(u(e14)), this;
    }, h.prototype.appendBinary = function(e14) {
      this._buff += e14, this._length += e14.length;
      var t3 = this._buff.length, a2;
      for (a2 = 64; a2 <= t3; a2 += 64)
        n(this._hash, r(this._buff.substring(a2 - 64, a2)));
      return this._buff = this._buff.substring(a2 - 64), this;
    }, h.prototype.end = function(e14) {
      var t3 = this._buff, n2 = t3.length, r2, a2 = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ], o2;
      for (r2 = 0; r2 < n2; r2 += 1)
        a2[r2 >> 2] |= t3.charCodeAt(r2) << (r2 % 4 << 3);
      return this._finish(a2, n2), o2 = l(this._hash), e14 && (o2 = m(o2)), this.reset(), o2;
    }, h.prototype.reset = function() {
      return this._buff = "", this._length = 0, this._hash = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
      ], this;
    }, h.prototype.getState = function() {
      return {
        buff: this._buff,
        length: this._length,
        hash: this._hash.slice()
      };
    }, h.prototype.setState = function(e14) {
      return this._buff = e14.buff, this._length = e14.length, this._hash = e14.hash, this;
    }, h.prototype.destroy = function() {
      delete this._hash, delete this._buff, delete this._length;
    }, h.prototype._finish = function(e14, t3) {
      var r2 = t3, a2, o2, s2;
      if (e14[r2 >> 2] |= 128 << (r2 % 4 << 3), r2 > 55)
        for (n(this._hash, e14), r2 = 0; r2 < 16; r2 += 1)
          e14[r2] = 0;
      a2 = this._length * 8, a2 = a2.toString(16).match(/(.*?)(.{0,8})$/), o2 = parseInt(a2[2], 16), s2 = parseInt(a2[1], 16) || 0, e14[14] = o2, e14[15] = s2, n(this._hash, e14);
    }, h.hash = function(e14, t3) {
      return h.hashBinary(u(e14), t3);
    }, h.hashBinary = function(e14, t3) {
      var n2 = l(o(e14));
      return t3 ? m(n2) : n2;
    }, h.ArrayBuffer = function() {
      this.reset();
    }, h.ArrayBuffer.prototype.append = function(e14) {
      var t3 = p(this._buff.buffer, e14, true), r2 = t3.length, o2;
      for (this._length += e14.byteLength, o2 = 64; o2 <= r2; o2 += 64)
        n(this._hash, a(t3.subarray(o2 - 64, o2)));
      return this._buff = o2 - 64 < r2 ? new Uint8Array(t3.buffer.slice(o2 - 64)) : new Uint8Array(), this;
    }, h.ArrayBuffer.prototype.end = function(e14) {
      var t3 = this._buff, n2 = t3.length, r2 = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ], a2, o2;
      for (a2 = 0; a2 < n2; a2 += 1)
        r2[a2 >> 2] |= t3[a2] << (a2 % 4 << 3);
      return this._finish(r2, n2), o2 = l(this._hash), e14 && (o2 = m(o2)), this.reset(), o2;
    }, h.ArrayBuffer.prototype.reset = function() {
      return this._buff = new Uint8Array(), this._length = 0, this._hash = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
      ], this;
    }, h.ArrayBuffer.prototype.getState = function() {
      var e14 = h.prototype.getState.call(this);
      return e14.buff = f(e14.buff), e14;
    }, h.ArrayBuffer.prototype.setState = function(e14) {
      return e14.buff = d(e14.buff, true), h.prototype.setState.call(this, e14);
    }, h.ArrayBuffer.prototype.destroy = h.prototype.destroy, h.ArrayBuffer.prototype._finish = h.prototype._finish, h.ArrayBuffer.hash = function(e14, t3) {
      var n2 = l(s(new Uint8Array(e14)));
      return t3 ? m(n2) : n2;
    }, h;
  });
}))(), 1), SET_GET_FIELDS = [
  "lastShaderProgramBound",
  "context",
  "_openGLRenderWindow"
];
function vtkShaderCache(e12, t) {
  t.classHierarchy.push("vtkShaderCache"), e12.replaceShaderValues = (e13, n, r) => {
    let a = n;
    r.length > 0 && (a = vtkShaderProgram$1.substitute(a, "VSOut", "GSOut").result);
    let o = t._openGLRenderWindow.getWebgl2(), s = "\n", c = "#version 100\n";
    o ? c = "#version 300 es\n#define attribute in\n#define textureCube texture\n#define texture2D texture\n#define textureCubeLod textureLod\n#define texture2DLod textureLod\n" : (t.context.getExtension("OES_standard_derivatives"), t.context.getExtension("EXT_frag_depth") && (s = "#extension GL_EXT_frag_depth : enable\n"), t.context.getExtension("EXT_shader_texture_lod") && (s += "#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod textureCubeLodEXT\n#define texture2DLod texture2DLodEXT")), a = vtkShaderProgram$1.substitute(a, "//VTK::System::Dec", [
      `${c}
`,
      o ? "" : "#extension GL_OES_standard_derivatives : enable\n",
      s,
      "#ifdef GL_FRAGMENT_PRECISION_HIGH",
      "precision highp float;",
      "precision highp int;",
      "#else",
      "precision mediump float;",
      "precision mediump int;",
      "#endif"
    ]).result;
    let l = vtkShaderProgram$1.substitute(e13, "//VTK::System::Dec", [
      `${c}
`,
      "#ifdef GL_FRAGMENT_PRECISION_HIGH",
      "precision highp float;",
      "precision highp int;",
      "#else",
      "precision mediump float;",
      "precision mediump int;",
      "#endif"
    ]).result;
    if (o) {
      l = vtkShaderProgram$1.substitute(l, "varying", "out").result, a = vtkShaderProgram$1.substitute(a, "varying", "in").result;
      let e14 = "", t2 = 0;
      for (; a.includes(`gl_FragData[${t2}]`); )
        a = vtkShaderProgram$1.substitute(a, `gl_FragData\\[${t2}\\]`, `fragOutput${t2}`).result, e14 += `layout(location = ${t2}) out vec4 fragOutput${t2};
`, t2++;
      a = vtkShaderProgram$1.substitute(a, "//VTK::Output::Dec", e14).result;
    }
    let u = vtkShaderProgram$1.substitute(r, "//VTK::System::Dec", c).result;
    return {
      VSSource: l,
      FSSource: a,
      GSSource: u
    };
  }, e12.readyShaderProgramArray = (t2, n, r) => {
    let a = e12.replaceShaderValues(t2, n, r), o = e12.getShaderProgram(a.VSSource, a.FSSource, a.GSSource);
    return e12.readyShaderProgram(o);
  }, e12.readyShaderProgram = (t2) => !t2 || !t2.getCompiled() && !t2.compileShader() || !e12.bindShaderProgram(t2) ? null : t2, e12.getShaderProgram = (e13, n, r) => {
    let a = `${e13}${n}${r}`, o = import_spark_md5.default.hash(a);
    if (!(o in t.shaderPrograms)) {
      let a2 = vtkShaderProgram$1.newInstance();
      return a2.setContext(t.context), a2.getVertexShader().setSource(e13), a2.getFragmentShader().setSource(n), r && a2.getGeometryShader().setSource(r), a2.setMd5Hash(o), t.shaderPrograms[o] = a2, a2;
    }
    return t.shaderPrograms[o];
  }, e12.releaseGraphicsResources = (n) => {
    e12.releaseCurrentShaderProgram(), Object.keys(t.shaderPrograms).map((e13) => t.shaderPrograms[e13]).forEach((e13) => e13.cleanup()), t.shaderPrograms = {};
  }, e12.releaseCurrentShaderProgram = () => {
    t.lastShaderProgramBound &&= (t.lastShaderProgramBound.cleanup(), null);
  }, e12.bindShaderProgram = (e13) => t.lastShaderProgramBound === e13 ? 1 : (t.lastShaderProgramBound && t.lastShaderProgramBound.release(), e13.bind(), t.lastShaderProgramBound = e13, 1);
}
var DEFAULT_VALUES$50 = {
  lastShaderProgramBound: null,
  shaderPrograms: null,
  context: null
};
function extend$59(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$50, n), t.shaderPrograms = {}, macro.obj(e12, t), macro.setGet(e12, t, SET_GET_FIELDS), macro.moveToProtected(e12, t, ["openGLRenderWindow"]), vtkShaderCache(e12, t);
}
var vtkShaderCache$1 = {
  newInstance: macro.newInstance(extend$59, "vtkShaderCache"),
  extend: extend$59
}, { vtkErrorMacro: vtkErrorMacro$16 } = macro;
function vtkOpenGLTextureUnitManager(e12, t) {
  t.classHierarchy.push("vtkOpenGLTextureUnitManager"), e12.deleteTable = () => {
    for (let e13 = 0; e13 < t.numberOfTextureUnits; ++e13)
      t.textureUnits[e13] === true && vtkErrorMacro$16("some texture units  were not properly released");
    t.textureUnits = [], t.numberOfTextureUnits = 0;
  }, e12.setContext = (n) => {
    if (t.context !== n) {
      if (t.context !== 0 && e12.deleteTable(), t.context = n, t.context) {
        t.numberOfTextureUnits = n.getParameter(n.MAX_TEXTURE_IMAGE_UNITS);
        for (let e13 = 0; e13 < t.numberOfTextureUnits; ++e13)
          t.textureUnits[e13] = false;
      }
      e12.modified();
    }
  }, e12.allocate = () => {
    for (let n = 0; n < t.numberOfTextureUnits; n++)
      if (!e12.isAllocated(n))
        return t.textureUnits[n] = true, n;
    return -1;
  }, e12.allocateUnit = (n) => e12.isAllocated(n) ? -1 : (t.textureUnits[n] = true, n), e12.isAllocated = (e13) => t.textureUnits[e13], e12.free = (e13) => {
    t.textureUnits[e13] = false;
  }, e12.freeAll = () => {
    for (let e13 = 0; e13 < t.numberOfTextureUnits; ++e13)
      t.textureUnits[e13] = false;
  };
}
var DEFAULT_VALUES$49 = {
  context: null,
  numberOfTextureUnits: 0,
  textureUnits: 0
};
function extend$58(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$49, n), macro.obj(e12, t), t.textureUnits = [], macro.get(e12, t, ["numberOfTextureUnits"]), macro.setGet(e12, t, ["context"]), vtkOpenGLTextureUnitManager(e12, t);
}
var vtkTextureUnitManager = {
  newInstance: macro.newInstance(extend$58, "vtkOpenGLTextureUnitManager"),
  extend: extend$58
};
function vtkRenderWindowViewNode(e12, t) {
  t.classHierarchy.push("vtkRenderWindowViewNode"), e12.getViewNodeFactory = () => null, e12.getAspectRatio = () => t.size[0] / t.size[1], e12.getAspectRatioForRenderer = (e13) => {
    let n = e13.getViewportByReference();
    return t.size[0] * (n[2] - n[0]) / ((n[3] - n[1]) * t.size[1]);
  }, e12.isInViewport = (t2, n, r) => {
    let a = r.getViewportByReference(), o = e12.getFramebufferSize();
    return a[0] * o[0] <= t2 && a[2] * o[0] >= t2 && a[1] * o[1] <= n && a[3] * o[1] >= n;
  }, e12.getViewportSize = (t2) => {
    let n = t2.getViewportByReference(), r = e12.getFramebufferSize();
    return [(n[2] - n[0]) * r[0], (n[3] - n[1]) * r[1]];
  }, e12.getViewportCenter = (t2) => {
    let n = e12.getViewportSize(t2);
    return [n[0] * 0.5, n[1] * 0.5];
  }, e12.displayToNormalizedDisplay = (t2, n, r) => {
    let a = e12.getFramebufferSize();
    return [
      t2 / a[0],
      n / a[1],
      r
    ];
  }, e12.normalizedDisplayToDisplay = (t2, n, r) => {
    let a = e12.getFramebufferSize();
    return [
      t2 * a[0],
      n * a[1],
      r
    ];
  }, e12.worldToView = (e13, t2, n, r) => r.worldToView(e13, t2, n), e12.viewToWorld = (e13, t2, n, r) => r.viewToWorld(e13, t2, n), e12.worldToDisplay = (t2, n, r, a) => {
    let o = a.worldToView(t2, n, r), s = e12.getViewportSize(a), c = a.viewToProjection(o[0], o[1], o[2], s[0] / s[1]), l = a.projectionToNormalizedDisplay(c[0], c[1], c[2]);
    return e12.normalizedDisplayToDisplay(l[0], l[1], l[2]);
  }, e12.displayToWorld = (t2, n, r, a) => {
    let o = e12.displayToNormalizedDisplay(t2, n, r), s = a.normalizedDisplayToProjection(o[0], o[1], o[2]), c = e12.getViewportSize(a), l = a.projectionToView(s[0], s[1], s[2], c[0] / c[1]);
    return a.viewToWorld(l[0], l[1], l[2]);
  }, e12.normalizedDisplayToViewport = (t2, n, r, a) => {
    let o = a.getViewportByReference();
    o = e12.normalizedDisplayToDisplay(o[0], o[1], 0);
    let s = e12.normalizedDisplayToDisplay(t2, n, r);
    return [
      s[0] - o[0] - 0.5,
      s[1] - o[1] - 0.5,
      r
    ];
  }, e12.viewportToNormalizedViewport = (t2, n, r, a) => {
    let o = e12.getViewportSize(a);
    return o && o[0] !== 0 && o[1] !== 0 ? [
      t2 / (o[0] - 1),
      n / (o[1] - 1),
      r
    ] : [
      t2,
      n,
      r
    ];
  }, e12.normalizedViewportToViewport = (t2, n, r, a) => {
    let o = e12.getViewportSize(a);
    return [
      t2 * (o[0] - 1),
      n * (o[1] - 1),
      r
    ];
  }, e12.displayToLocalDisplay = (t2, n, r) => [
    t2,
    e12.getFramebufferSize()[1] - n - 1,
    r
  ], e12.viewportToNormalizedDisplay = (t2, n, r, a) => {
    let o = a.getViewportByReference();
    o = e12.normalizedDisplayToDisplay(o[0], o[1], 0);
    let s = t2 + o[0] + 0.5, c = n + o[1] + 0.5;
    return e12.displayToNormalizedDisplay(s, c, r);
  }, e12.getComputedDevicePixelRatio = () => t.size[0] / e12.getContainerSize()[0], e12.getContainerSize = () => {
    macro.vtkErrorMacro("not implemented");
  }, e12.getPixelData = (e13, t2, n, r) => {
    macro.vtkErrorMacro("not implemented");
  }, e12.createSelector = () => {
    macro.vtkErrorMacro("not implemented");
  };
}
var DEFAULT_VALUES$48 = {
  size: void 0,
  selector: void 0
};
function extend$57(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$48, n), t.size ||= [300, 300], macro.getArray(e12, t, ["size"], 2), macro.get(e12, t, ["selector"]), vtkViewNode$1.extend(e12, t, n), vtkRenderWindowViewNode(e12, t);
}
var vtkRenderWindowViewNode$1 = {
  newInstance: macro.newInstance(extend$57, "vtkRenderWindowViewNode"),
  extend: extend$57
};
function createContextProxyHandler() {
  let e12 = /* @__PURE__ */ new Map(), t = { apply(t2, n2, r2) {
    return e12.has(r2[0]) ? e12.get(r2[0]) : t2.apply(n2, r2);
  } };
  function n(t2) {
    return { apply(n2, r2, a) {
      return e12.set(t2, a[0]), n2.apply(r2, a);
    } };
  }
  let r = /* @__PURE__ */ Object.create(null);
  return r.getParameter = (e13, n2, r2, a) => new Proxy(a.bind(e13), t), r.depthMask = (e13, t2, r2, a) => new Proxy(a.bind(e13), n(e13.DEPTH_WRITEMASK)), { get(e13, t2, n2) {
    if (t2 === "__getUnderlyingContext")
      return () => e13;
    let a = Reflect.get(e13, t2, e13);
    a instanceof Function && (a = a.bind(e13));
    let o = r[t2];
    return o ? o(e13, t2, n2, a) : a;
  } };
}
var { vtkDebugMacro: vtkDebugMacro$3, vtkErrorMacro: vtkErrorMacro$15 } = macro, SCREENSHOT_PLACEHOLDER = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%"
}, parentMethodsToProxy = /* @__PURE__ */ "activateTexture.deactivateTexture.disableCullFace.enableCullFace.get3DContext.getActiveFramebuffer.getContext.getDefaultTextureByteSize.getDefaultTextureInternalFormat.getDefaultToWebgl2.getGLInformations.getGraphicsMemoryInfo.getGraphicsResourceForObject.getHardwareMaximumLineWidth.getPixelData.getShaderCache.getTextureUnitForTexture.getTextureUnitManager.getWebgl2.makeCurrent.releaseGraphicsResources.registerGraphicsResourceUser.unregisterGraphicsResourceUser.restoreContext.setActiveFramebuffer.setContext.setDefaultToWebgl2.setGraphicsResourceForObject".split(".");
function checkRenderTargetSupport(e12, t, n) {
  let r = e12.createFramebuffer(), a = e12.createTexture();
  e12.bindTexture(e12.TEXTURE_2D, a), e12.texImage2D(e12.TEXTURE_2D, 0, t, 2, 2, 0, t, n, null), e12.bindFramebuffer(e12.FRAMEBUFFER, r), e12.framebufferTexture2D(e12.FRAMEBUFFER, e12.COLOR_ATTACHMENT0, e12.TEXTURE_2D, a, 0);
  let o = e12.checkFramebufferStatus(e12.FRAMEBUFFER);
  return e12.bindFramebuffer(e12.FRAMEBUFFER, null), e12.bindTexture(e12.TEXTURE_2D, null), o === e12.FRAMEBUFFER_COMPLETE;
}
var GL_CONTEXT_COUNT = 0, GL_CONTEXT_LISTENERS = [];
function createGLContext() {
  GL_CONTEXT_COUNT++, GL_CONTEXT_LISTENERS.forEach((e12) => e12(GL_CONTEXT_COUNT));
}
function deleteGLContext() {
  GL_CONTEXT_COUNT--, GL_CONTEXT_LISTENERS.forEach((e12) => e12(GL_CONTEXT_COUNT));
}
function pushMonitorGLContextCount(e12) {
  GL_CONTEXT_LISTENERS.push(e12);
}
function popMonitorGLContextCount(e12) {
  return GL_CONTEXT_LISTENERS.pop();
}
function _preventDefault(e12) {
  e12.preventDefault();
}
function vtkOpenGLRenderWindow(e12, t) {
  t.classHierarchy.push("vtkOpenGLRenderWindow");
  let n;
  function r() {
    return n ||= createContextProxyHandler(), n;
  }
  e12.getViewNodeFactory = () => t.myFactory, t.canvas.addEventListener("webglcontextlost", _preventDefault, false), t.canvas.addEventListener("webglcontextrestored", e12.restoreContext, false);
  let a = [0, 0];
  function o() {
    t.renderable && (t.size[0] !== a[0] || t.size[1] !== a[1]) && (a[0] = t.size[0], a[1] = t.size[1], t.canvas.setAttribute("width", t.size[0]), t.canvas.setAttribute("height", t.size[1])), t.viewStream && t.viewStream.setSize(t.size[0], t.size[1]), t.canvas.style.display = t.useOffScreen ? "none" : "block", t.el && (t.el.style.cursor = t.cursorVisibility ? t.cursor : "none"), t.containerSize = null;
  }
  e12.onModified(o), e12.buildPass = (n2) => {
    if (n2) {
      if (!t.renderable)
        return;
      e12.prepareNodes(), e12.addMissingNodes(t.renderable.getRenderersByReference()), e12.addMissingNodes(t.renderable.getChildRenderWindowsByReference()), e12.removeUnusedNodes(), e12.initialize(), t.children.forEach((t2) => {
        t2.setOpenGLRenderWindow?.(e12);
      });
    }
  }, e12.initialize = () => {
    if (!t.initialized) {
      if (t.rootOpenGLRenderWindow = e12.getLastAncestorOfType("vtkOpenGLRenderWindow"), t.rootOpenGLRenderWindow)
        t.context2D = e12.get2DContext();
      else {
        t.context = e12.get3DContext(), e12.resizeFromChildRenderWindows(), t.context && createGLContext(), t.textureUnitManager = vtkTextureUnitManager.newInstance(), t.textureUnitManager.setContext(t.context), t.shaderCache.setContext(t.context);
        let n2 = t.context;
        n2.blendFuncSeparate(n2.SRC_ALPHA, n2.ONE_MINUS_SRC_ALPHA, n2.ONE, n2.ONE_MINUS_SRC_ALPHA), n2.depthFunc(n2.LEQUAL), n2.enable(n2.BLEND);
      }
      t.initialized = true;
    }
  }, e12.makeCurrent = () => {
    t.context.makeCurrent();
  }, e12.setContainer = (n2) => {
    t.el && t.el !== n2 && (t.canvas.parentNode !== t.el && vtkErrorMacro$15("Error: canvas parent node does not match container"), t.el.removeChild(t.canvas), t.el.contains(t.bgImage) && t.el.removeChild(t.bgImage)), t.el !== n2 && (t.el = n2, t.el && (t.el.appendChild(t.canvas), t.useBackgroundImage && t.el.appendChild(t.bgImage)), e12.modified());
  }, e12.getContainer = () => t.el, e12.getContainerSize = () => {
    if (!t.containerSize && t.el) {
      let { width: e13, height: n2 } = t.el.getBoundingClientRect();
      t.containerSize = [e13, n2];
    }
    return t.containerSize || t.size;
  }, e12.getFramebufferSize = () => t.activeFramebuffer?.getSize() || t.size, e12.getPixelData = (e13, n2, r2, a2) => {
    let o2 = new Uint8Array((r2 - e13 + 1) * (a2 - n2 + 1) * 4);
    return t.context.readPixels(e13, n2, r2 - e13 + 1, a2 - n2 + 1, t.context.RGBA, t.context.UNSIGNED_BYTE, o2), o2;
  }, e12.get3DContext = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      preserveDrawingBuffer: false,
      depth: true,
      alpha: true,
      powerPreference: "high-performance"
    }, n2 = null, a2 = typeof WebGL2RenderingContext < "u";
    return t.webgl2 = false, t.defaultToWebgl2 && a2 && (n2 = t.canvas.getContext("webgl2", e13), n2 && (t.webgl2 = true, vtkDebugMacro$3("using webgl2"))), n2 ||= (vtkDebugMacro$3("using webgl1"), t.canvas.getContext("webgl", e13) || t.canvas.getContext("experimental-webgl", e13)), new Proxy(n2, r());
  }, e12.get2DContext = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return t.canvas.getContext("2d", e13);
  }, e12.restoreContext = () => {
    let t2 = vtkRenderPass$1.newInstance();
    t2.setCurrentOperation("Release"), t2.traverse(e12, null);
  }, e12.activateTexture = (n2) => {
    let r2 = t._textureResourceIds.get(n2);
    if (r2 !== void 0) {
      t.context.activeTexture(t.context.TEXTURE0 + r2);
      return;
    }
    let a2 = e12.getTextureUnitManager().allocate();
    if (a2 < 0) {
      vtkErrorMacro$15("Hardware does not support the number of textures defined.");
      return;
    }
    t._textureResourceIds.set(n2, a2), t.context.activeTexture(t.context.TEXTURE0 + a2);
  }, e12.deactivateTexture = (n2) => {
    let r2 = t._textureResourceIds.get(n2);
    r2 !== void 0 && (e12.getTextureUnitManager().free(r2), t._textureResourceIds.delete(n2));
  }, e12.getTextureUnitForTexture = (e13) => {
    let n2 = t._textureResourceIds.get(e13);
    return n2 === void 0 ? -1 : n2;
  }, e12.getDefaultTextureByteSize = function(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (t.webgl2)
      switch (e13) {
        case VtkDataTypes.CHAR:
        case VtkDataTypes.SIGNED_CHAR:
        case VtkDataTypes.UNSIGNED_CHAR:
          return 1;
        case n2:
        case r2:
        case VtkDataTypes.UNSIGNED_SHORT:
        case VtkDataTypes.SHORT:
        case VtkDataTypes.VOID:
          return 2;
        default:
          return 4;
      }
    return 1;
  }, e12.getDefaultTextureInternalFormat = function(e13, n2) {
    let r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (t.webgl2)
      switch (e13) {
        case VtkDataTypes.UNSIGNED_CHAR:
          switch (n2) {
            case 1:
              return t.context.R8;
            case 2:
              return t.context.RG8;
            case 3:
              return t.context.RGB8;
            case 4:
            default:
              return t.context.RGBA8;
          }
        case (r2 && !a2 && VtkDataTypes.UNSIGNED_SHORT):
          switch (n2) {
            case 1:
              return r2.R16_EXT;
            case 2:
              return r2.RG16_EXT;
            case 3:
              return r2.RGB16_EXT;
            case 4:
            default:
              return r2.RGBA16_EXT;
          }
        case (r2 && !a2 && VtkDataTypes.SHORT):
          switch (n2) {
            case 1:
              return r2.R16_SNORM_EXT;
            case 2:
              return r2.RG16_SNORM_EXT;
            case 3:
              return r2.RGB16_SNORM_EXT;
            case 4:
            default:
              return r2.RGBA16_SNORM_EXT;
          }
        case VtkDataTypes.UNSIGNED_SHORT:
        case VtkDataTypes.SHORT:
        case VtkDataTypes.FLOAT:
        default:
          switch (n2) {
            case 1:
              return a2 ? t.context.R16F : t.context.R32F;
            case 2:
              return a2 ? t.context.RG16F : t.context.RG32F;
            case 3:
              return a2 ? t.context.RGB16F : t.context.RGB32F;
            case 4:
            default:
              return a2 ? t.context.RGBA16F : t.context.RGBA32F;
          }
      }
    switch (n2) {
      case 1:
        return t.context.LUMINANCE;
      case 2:
        return t.context.LUMINANCE_ALPHA;
      case 3:
        return t.context.RGB;
      case 4:
      default:
        return t.context.RGBA;
    }
  }, e12.setBackgroundImage = (e13) => {
    t.bgImage.src = e13.src;
  }, e12.setUseBackgroundImage = (e13) => {
    t.useBackgroundImage = e13, t.useBackgroundImage && !t.el.contains(t.bgImage) ? t.el.appendChild(t.bgImage) : !t.useBackgroundImage && t.el.contains(t.bgImage) && t.el.removeChild(t.bgImage);
  };
  function s() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t.imageFormat, r2 = document.createElement("canvas"), a2 = r2.getContext("2d");
    r2.width = t.canvas.width, r2.height = t.canvas.height, a2.drawImage(t.canvas, 0, 0);
    let o2 = t.canvas.getBoundingClientRect();
    t.renderable.getRenderers().forEach((e13) => {
      e13.getViewProps().forEach((e14) => {
        if (e14.getContainer) {
          let t2 = e14.getContainer().getElementsByTagName("canvas");
          for (let e15 = 0; e15 < t2.length; e15++) {
            let n3 = t2[e15], r3 = n3.getBoundingClientRect(), s3 = r3.x - o2.x, c2 = r3.y - o2.y;
            a2.drawImage(n3, s3, c2);
          }
        }
      });
    });
    let s2 = r2.toDataURL(n2);
    r2.remove(), e12.invokeImageReady(s2);
  }
  e12.captureNextImage = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "image/png", { resetCamera: r2 = false, size: a2 = null, scale: o2 = 1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t.deleted)
      return null;
    t.imageFormat = n2;
    let s2 = t.notifyStartCaptureImage;
    return t.notifyStartCaptureImage = true, t._screenshot = { size: a2 || o2 !== 1 ? a2 || t.size.map((e13) => e13 * o2) : null }, new Promise((n3, a3) => {
      let o3 = e12.onImageReady((a4) => {
        if (t._screenshot.size === null)
          t.notifyStartCaptureImage = s2, o3.unsubscribe(), t._screenshot.placeHolder && (t.size = t._screenshot.originalSize, e12.modified(), t._screenshot.cameras && t._screenshot.cameras.forEach((e13) => {
            let { restoreParamsFn: t2, arg: n4 } = e13;
            return t2(n4);
          }), e12.traverseAllPasses(), t.el.removeChild(t._screenshot.placeHolder), t._screenshot.placeHolder.remove(), t._screenshot = null), n3(a4);
        else {
          let n4 = document.createElement("img");
          if (n4.style = SCREENSHOT_PLACEHOLDER, n4.src = a4, t._screenshot.placeHolder = t.el.appendChild(n4), t.canvas.style.display = "none", t._screenshot.originalSize = t.size, t.size = t._screenshot.size, t.rootOpenGLRenderWindow?.resizeFromChildRenderWindows(), t._screenshot.size = null, e12.modified(), r2) {
            let e13 = r2 !== true;
            t._screenshot.cameras = t.renderable.getRenderers().map((t2) => {
              let n5 = t2.getActiveCamera(), a5 = n5.get("focalPoint", "position", "parallelScale");
              return {
                resetCameraArgs: e13 ? { renderer: t2 } : void 0,
                resetCameraFn: e13 ? r2 : t2.resetCamera,
                restoreParamsFn: n5.set,
                arg: JSON.parse(JSON.stringify(a5))
              };
            }), t._screenshot.cameras.forEach((e14) => {
              let { resetCameraFn: t2, resetCameraArgs: n5 } = e14;
              return t2(n5);
            });
          }
          e12.traverseAllPasses();
        }
      });
    });
  };
  let c;
  e12.getHardwareMaximumLineWidth = () => {
    if (c != null)
      return c;
    let t2 = e12.get3DContext(), n2 = t2.getParameter(t2.ALIASED_LINE_WIDTH_RANGE);
    return c = n2[1], n2[1];
  }, e12.getGLInformations = () => {
    if (t._glInformation)
      return t._glInformation;
    let n2 = e12.get3DContext(), r2 = n2.getExtension("OES_texture_float"), a2 = n2.getExtension("OES_texture_half_float"), o2 = n2.getExtension("WEBGL_debug_renderer_info"), s2 = n2.getExtension("WEBGL_draw_buffers"), c2 = n2.getExtension("EXT_texture_filter_anisotropic") || n2.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), l2 = [
      [
        "Max Vertex Attributes",
        "MAX_VERTEX_ATTRIBS",
        n2.getParameter(n2.MAX_VERTEX_ATTRIBS)
      ],
      [
        "Max Varying Vectors",
        "MAX_VARYING_VECTORS",
        n2.getParameter(n2.MAX_VARYING_VECTORS)
      ],
      [
        "Max Vertex Uniform Vectors",
        "MAX_VERTEX_UNIFORM_VECTORS",
        n2.getParameter(n2.MAX_VERTEX_UNIFORM_VECTORS)
      ],
      [
        "Max Fragment Uniform Vectors",
        "MAX_FRAGMENT_UNIFORM_VECTORS",
        n2.getParameter(n2.MAX_FRAGMENT_UNIFORM_VECTORS)
      ],
      [
        "Max Fragment Texture Image Units",
        "MAX_TEXTURE_IMAGE_UNITS",
        n2.getParameter(n2.MAX_TEXTURE_IMAGE_UNITS)
      ],
      [
        "Max Vertex Texture Image Units",
        "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
        n2.getParameter(n2.MAX_VERTEX_TEXTURE_IMAGE_UNITS)
      ],
      [
        "Max Combined Texture Image Units",
        "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
        n2.getParameter(n2.MAX_COMBINED_TEXTURE_IMAGE_UNITS)
      ],
      [
        "Max 2D Texture Size",
        "MAX_TEXTURE_SIZE",
        n2.getParameter(n2.MAX_TEXTURE_SIZE)
      ],
      [
        "Max Cube Texture Size",
        "MAX_CUBE_MAP_TEXTURE_SIZE",
        n2.getParameter(n2.MAX_CUBE_MAP_TEXTURE_SIZE)
      ],
      [
        "Max Texture Anisotropy",
        "MAX_TEXTURE_MAX_ANISOTROPY_EXT",
        c2 && n2.getParameter(c2.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
      ],
      [
        "Point Size Range",
        "ALIASED_POINT_SIZE_RANGE",
        n2.getParameter(n2.ALIASED_POINT_SIZE_RANGE).join(" - ")
      ],
      [
        "Line Width Range",
        "ALIASED_LINE_WIDTH_RANGE",
        n2.getParameter(n2.ALIASED_LINE_WIDTH_RANGE).join(" - ")
      ],
      [
        "Max Viewport Dimensions",
        "MAX_VIEWPORT_DIMS",
        n2.getParameter(n2.MAX_VIEWPORT_DIMS).join(" - ")
      ],
      [
        "Max Renderbuffer Size",
        "MAX_RENDERBUFFER_SIZE",
        n2.getParameter(n2.MAX_RENDERBUFFER_SIZE)
      ],
      [
        "Framebuffer Red Bits",
        "RED_BITS",
        n2.getParameter(n2.RED_BITS)
      ],
      [
        "Framebuffer Green Bits",
        "GREEN_BITS",
        n2.getParameter(n2.GREEN_BITS)
      ],
      [
        "Framebuffer Blue Bits",
        "BLUE_BITS",
        n2.getParameter(n2.BLUE_BITS)
      ],
      [
        "Framebuffer Alpha Bits",
        "ALPHA_BITS",
        n2.getParameter(n2.ALPHA_BITS)
      ],
      [
        "Framebuffer Depth Bits",
        "DEPTH_BITS",
        n2.getParameter(n2.DEPTH_BITS)
      ],
      [
        "Framebuffer Stencil Bits",
        "STENCIL_BITS",
        n2.getParameter(n2.STENCIL_BITS)
      ],
      [
        "Framebuffer Subpixel Bits",
        "SUBPIXEL_BITS",
        n2.getParameter(n2.SUBPIXEL_BITS)
      ],
      [
        "MSAA Samples",
        "SAMPLES",
        n2.getParameter(n2.SAMPLES)
      ],
      [
        "MSAA Sample Buffers",
        "SAMPLE_BUFFERS",
        n2.getParameter(n2.SAMPLE_BUFFERS)
      ],
      [
        "Supported Formats for UByte Render Targets     ",
        "UNSIGNED_BYTE RENDER TARGET FORMATS",
        [
          r2 && checkRenderTargetSupport(n2, n2.RGBA, n2.UNSIGNED_BYTE) ? "RGBA" : "",
          r2 && checkRenderTargetSupport(n2, n2.RGB, n2.UNSIGNED_BYTE) ? "RGB" : "",
          r2 && checkRenderTargetSupport(n2, n2.LUMINANCE, n2.UNSIGNED_BYTE) ? "LUMINANCE" : "",
          r2 && checkRenderTargetSupport(n2, n2.ALPHA, n2.UNSIGNED_BYTE) ? "ALPHA" : "",
          r2 && checkRenderTargetSupport(n2, n2.LUMINANCE_ALPHA, n2.UNSIGNED_BYTE) ? "LUMINANCE_ALPHA" : ""
        ].join(" ")
      ],
      [
        "Supported Formats for Half Float Render Targets",
        "HALF FLOAT RENDER TARGET FORMATS",
        [
          a2 && checkRenderTargetSupport(n2, n2.RGBA, a2.HALF_FLOAT_OES) ? "RGBA" : "",
          a2 && checkRenderTargetSupport(n2, n2.RGB, a2.HALF_FLOAT_OES) ? "RGB" : "",
          a2 && checkRenderTargetSupport(n2, n2.LUMINANCE, a2.HALF_FLOAT_OES) ? "LUMINANCE" : "",
          a2 && checkRenderTargetSupport(n2, n2.ALPHA, a2.HALF_FLOAT_OES) ? "ALPHA" : "",
          a2 && checkRenderTargetSupport(n2, n2.LUMINANCE_ALPHA, a2.HALF_FLOAT_OES) ? "LUMINANCE_ALPHA" : ""
        ].join(" ")
      ],
      [
        "Supported Formats for Full Float Render Targets",
        "FLOAT RENDER TARGET FORMATS",
        [
          r2 && checkRenderTargetSupport(n2, n2.RGBA, n2.FLOAT) ? "RGBA" : "",
          r2 && checkRenderTargetSupport(n2, n2.RGB, n2.FLOAT) ? "RGB" : "",
          r2 && checkRenderTargetSupport(n2, n2.LUMINANCE, n2.FLOAT) ? "LUMINANCE" : "",
          r2 && checkRenderTargetSupport(n2, n2.ALPHA, n2.FLOAT) ? "ALPHA" : "",
          r2 && checkRenderTargetSupport(n2, n2.LUMINANCE_ALPHA, n2.FLOAT) ? "LUMINANCE_ALPHA" : ""
        ].join(" ")
      ],
      [
        "Max Multiple Render Targets Buffers",
        "MAX_DRAW_BUFFERS_WEBGL",
        s2 ? n2.getParameter(s2.MAX_DRAW_BUFFERS_WEBGL) : 0
      ],
      [
        "High Float Precision in Vertex Shader",
        "HIGH_FLOAT VERTEX_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.HIGH_FLOAT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.HIGH_FLOAT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.HIGH_FLOAT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "Medium Float Precision in Vertex Shader",
        "MEDIUM_FLOAT VERTEX_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.MEDIUM_FLOAT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.MEDIUM_FLOAT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.MEDIUM_FLOAT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "Low Float Precision in Vertex Shader",
        "LOW_FLOAT VERTEX_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.LOW_FLOAT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.LOW_FLOAT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.LOW_FLOAT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "High Float Precision in Fragment Shader",
        "HIGH_FLOAT FRAGMENT_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.HIGH_FLOAT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.HIGH_FLOAT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.HIGH_FLOAT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "Medium Float Precision in Fragment Shader",
        "MEDIUM_FLOAT FRAGMENT_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.MEDIUM_FLOAT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.MEDIUM_FLOAT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.MEDIUM_FLOAT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "Low Float Precision in Fragment Shader",
        "LOW_FLOAT FRAGMENT_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.LOW_FLOAT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.LOW_FLOAT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.LOW_FLOAT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "High Int Precision in Vertex Shader",
        "HIGH_INT VERTEX_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.HIGH_INT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.HIGH_INT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.HIGH_INT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "Medium Int Precision in Vertex Shader",
        "MEDIUM_INT VERTEX_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.MEDIUM_INT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.MEDIUM_INT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.MEDIUM_INT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "Low Int Precision in Vertex Shader",
        "LOW_INT VERTEX_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.LOW_INT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.LOW_INT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.VERTEX_SHADER, n2.LOW_INT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "High Int Precision in Fragment Shader",
        "HIGH_INT FRAGMENT_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.HIGH_INT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.HIGH_INT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.HIGH_INT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "Medium Int Precision in Fragment Shader",
        "MEDIUM_INT FRAGMENT_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.MEDIUM_INT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.MEDIUM_INT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.MEDIUM_INT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "Low Int Precision in Fragment Shader",
        "LOW_INT FRAGMENT_SHADER",
        [
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.LOW_INT).precision,
          " (-2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.LOW_INT).rangeMin,
          "</sup> - 2<sup>",
          n2.getShaderPrecisionFormat(n2.FRAGMENT_SHADER, n2.LOW_INT).rangeMax,
          "</sup>)"
        ].join("")
      ],
      [
        "Supported Extensions",
        "EXTENSIONS",
        n2.getSupportedExtensions().join("<br/>					    ")
      ],
      [
        "WebGL Renderer",
        "RENDERER",
        n2.getParameter(n2.RENDERER)
      ],
      [
        "WebGL Vendor",
        "VENDOR",
        n2.getParameter(n2.VENDOR)
      ],
      [
        "WebGL Version",
        "VERSION",
        n2.getParameter(n2.VERSION)
      ],
      [
        "Shading Language Version",
        "SHADING_LANGUAGE_VERSION",
        n2.getParameter(n2.SHADING_LANGUAGE_VERSION)
      ],
      [
        "Unmasked Renderer",
        "UNMASKED_RENDERER",
        o2 && n2.getParameter(o2.UNMASKED_RENDERER_WEBGL)
      ],
      [
        "Unmasked Vendor",
        "UNMASKED_VENDOR",
        o2 && n2.getParameter(o2.UNMASKED_VENDOR_WEBGL)
      ],
      [
        "WebGL Version",
        "WEBGL_VERSION",
        t.webgl2 ? 2 : 1
      ]
    ], u2 = {};
    for (; l2.length; ) {
      let [e13, t2, n3] = l2.pop();
      t2 && (u2[t2] = {
        label: e13,
        value: n3
      });
    }
    return t._glInformation = u2, u2;
  }, e12.traverseAllPasses = () => {
    if (t.renderPasses)
      for (let n3 = 0; n3 < t.renderPasses.length; ++n3)
        t.renderPasses[n3].traverse(e12, null);
    e12.copyParentContent(), t.notifyStartCaptureImage && s();
    let n2 = t.renderable.getChildRenderWindowsByReference();
    for (let t2 = 0; t2 < n2.length; ++t2)
      e12.getViewNodeFor(n2[t2])?.traverseAllPasses();
  }, e12.copyParentContent = () => {
    let e13 = t.rootOpenGLRenderWindow;
    if (!e13 || !t.context2D || t.children.some((e14) => !!e14.getSelector?.()))
      return;
    let n2 = e13.getCanvas(), r2 = t.canvas;
    t.context2D.drawImage(n2, 0, n2.height - r2.height, r2.width, r2.height, 0, 0, r2.width, r2.height);
  }, e12.resizeFromChildRenderWindows = () => {
    let n2 = t.renderable.getChildRenderWindowsByReference();
    if (n2.length > 0) {
      let t2 = [0, 0];
      for (let r2 = 0; r2 < n2.length; ++r2) {
        let a2 = e12.getViewNodeFor(n2[r2])?.getSize();
        a2 && (t2[0] = a2[0] > t2[0] ? a2[0] : t2[0], t2[1] = a2[1] > t2[1] ? a2[1] : t2[1]);
      }
      e12.setSize(...t2);
    }
  }, e12.disableCullFace = () => {
    t.cullFaceEnabled &&= (t.context.disable(t.context.CULL_FACE), false);
  }, e12.enableCullFace = () => {
    t.cullFaceEnabled ||= (t.context.enable(t.context.CULL_FACE), true);
  }, e12.setViewStream = (n2) => {
    if (t.viewStream === n2)
      return false;
    if (t.subscription &&= (t.subscription.unsubscribe(), null), t.viewStream = n2, t.viewStream) {
      let n3 = t.renderable.getRenderers()[0];
      n3.getBackgroundByReference()[3] = 0, e12.setUseBackgroundImage(true), t.subscription = t.viewStream.onImageReady((t2) => e12.setBackgroundImage(t2.image)), t.viewStream.setSize(t.size[0], t.size[1]), t.viewStream.invalidateCache(), t.viewStream.render(), e12.modified();
    }
    return true;
  }, e12.createSelector = () => {
    let t2 = vtkHardwareSelector.newInstance();
    return t2.setOpenGLRenderWindow(e12), t2;
  };
  function l() {
    t.canvas.removeEventListener("webglcontextlost", _preventDefault), t.canvas.removeEventListener("webglcontextrestored", e12.restoreContext);
  }
  e12.delete = macro.chain(() => {
    t.context && deleteGLContext(), e12.setContainer(), e12.setViewStream();
  }, l, e12.delete), e12.setActiveFramebuffer = (e13) => {
    t.activeFramebuffer = e13;
  };
  let u = e12.setSize;
  e12.setSize = (t2, n2) => {
    let r2 = u(t2, n2);
    return r2 && e12.invokeWindowResizeEvent({
      width: t2,
      height: n2
    }), r2;
  }, e12.registerGraphicsResourceUser = (n2, r2) => {
    t._graphicsResources.has(n2) || e12.setGraphicsResourceForObject(n2, null, null), t._graphicsResources.get(n2)?.users.add(r2);
  }, e12.unregisterGraphicsResourceUser = (n2, r2) => {
    let a2 = t._graphicsResources.get(n2);
    a2 && (a2.users.delete(r2), a2.users.size || (a2.oglObject?.releaseGraphicsResources(e12), t._graphicsResources.delete(n2)));
  }, e12.getGraphicsResourceForObject = (e13) => t._graphicsResources.get(e13), e12.setGraphicsResourceForObject = (n2, r2, a2) => {
    if (!n2)
      return;
    let o2 = t._graphicsResources.get(n2);
    o2?.oglObject?.releaseGraphicsResources(e12), t._graphicsResources.set(n2, {
      coreObject: n2,
      oglObject: r2,
      hash: a2,
      users: o2?.users ?? /* @__PURE__ */ new Set()
    });
  }, e12.getGraphicsMemoryInfo = () => {
    let e13 = 0;
    return t._graphicsResources.forEach((t2) => {
      let { oglObject: n2 } = t2;
      e13 += n2.getAllocatedGPUMemoryInBytes();
    }), e13;
  }, e12.releaseGraphicsResources = () => {
    t.shaderCache !== null && t.shaderCache.releaseGraphicsResources(e12), t._graphicsResources.forEach((t2) => {
      let { oglObject: n2 } = t2;
      n2.releaseGraphicsResources(e12);
    }), t._graphicsResources.clear(), t.textureUnitManager !== null && t.textureUnitManager.freeAll(), t.renderable.getRenderersByReference().forEach((t2) => {
      e12.getViewNodeFor(t2)?.releaseGraphicsResources();
    });
  };
  let d = { ...e12 };
  parentMethodsToProxy.forEach((n2) => {
    e12[n2] = function() {
      return t.rootOpenGLRenderWindow ? t.rootOpenGLRenderWindow[n2](...arguments) : d[n2](...arguments);
    };
  });
}
var DEFAULT_VALUES$47 = {
  cullFaceEnabled: false,
  shaderCache: null,
  initialized: false,
  context: null,
  context2D: null,
  canvas: null,
  cursorVisibility: true,
  cursor: "pointer",
  textureUnitManager: null,
  textureResourceIds: null,
  containerSize: null,
  renderPasses: [],
  notifyStartCaptureImage: false,
  webgl2: false,
  defaultToWebgl2: true,
  activeFramebuffer: null,
  imageFormat: "image/png",
  useOffScreen: false,
  useBackgroundImage: false
};
function extend$56(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$47, n), vtkRenderWindowViewNode$1.extend(e12, t, n), t.canvas || (t.canvas = document.createElement("canvas"), t.canvas.style.width = "100%"), t.selector || (t.selector = vtkHardwareSelector.newInstance(), t.selector.setOpenGLRenderWindow(e12)), t.bgImage = new Image(), t.bgImage.style.position = "absolute", t.bgImage.style.left = "0", t.bgImage.style.top = "0", t.bgImage.style.width = "100%", t.bgImage.style.height = "100%", t.bgImage.style.zIndex = "-1", t._textureResourceIds = /* @__PURE__ */ new Map(), t._graphicsResources = /* @__PURE__ */ new Map(), t._glInformation = null, t.myFactory = vtkViewNodeFactory.newInstance(), t.shaderCache = vtkShaderCache$1.newInstance(), t.shaderCache.setOpenGLRenderWindow(e12), t.renderPasses[0] = vtkForwardPass$1.newInstance(), macro.get(e12, t, [
    "shaderCache",
    "textureUnitManager",
    "webgl2",
    "useBackgroundImage",
    "activeFramebuffer",
    "rootOpenGLRenderWindow"
  ]), macro.setGet(e12, t, [
    "initialized",
    "context",
    "context2D",
    "canvas",
    "renderPasses",
    "notifyStartCaptureImage",
    "defaultToWebgl2",
    "cursor",
    "useOffScreen"
  ]), macro.setGetArray(e12, t, ["size"], 2), macro.event(e12, t, "imageReady"), macro.event(e12, t, "windowResizeEvent"), vtkOpenGLRenderWindow(e12, t);
}
var newInstance$52 = macro.newInstance(extend$56, "vtkOpenGLRenderWindow");
registerViewConstructor("WebGL", newInstance$52);
var vtkRenderWindow = {
  newInstance: newInstance$52,
  extend: extend$56,
  pushMonitorGLContextCount,
  popMonitorGLContextCount
};
registerOverride$1("vtkRenderWindow", newInstance$52);
function vtkOpenGLActor(e12, t) {
  t.classHierarchy.push("vtkOpenGLActor"), e12.buildPass = (n) => {
    if (n) {
      t._openGLRenderWindow = e12.getLastAncestorOfType("vtkOpenGLRenderWindow"), t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t.context = t._openGLRenderWindow.getContext(), e12.prepareNodes(), e12.addMissingNodes(t.renderable.getTextures()), e12.addMissingNode(t.renderable.getMapper()), e12.removeUnusedNodes(), t.ogltextures = null, t.activeTextures = null;
      for (let e13 = 0; e13 < t.children.length; e13++) {
        let n2 = t.children[e13];
        n2.isA("vtkOpenGLTexture") ? (t.ogltextures ||= [], t.ogltextures.push(n2)) : t.oglmapper = n2;
      }
    }
  }, e12.traverseZBufferPass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.oglmapper.traverse(n), e12.apply(n, false));
  }, e12.traverseOpaqueZBufferPass = (t2) => e12.traverseOpaquePass(t2), e12.traverseOpaquePass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.oglmapper.traverse(n), e12.apply(n, false));
  }, e12.traverseTranslucentPass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.oglmapper.traverse(n), e12.apply(n, false));
  }, e12.activateTextures = () => {
    if (t.ogltextures) {
      t.activeTextures = [];
      for (let e13 = 0; e13 < t.ogltextures.length; e13++) {
        let n = t.ogltextures[e13];
        n.render(), n.getHandle() && t.activeTextures.push(n);
      }
    }
  }, e12.queryPass = (e13, n) => {
    if (e13) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, e12.zBufferPass = (t2, n) => e12.opaquePass(t2, n), e12.opaqueZBufferPass = (t2, n) => e12.opaquePass(t2, n), e12.opaquePass = (n, r) => {
    if (n)
      t.context.depthMask(true), e12.activateTextures();
    else if (t.activeTextures)
      for (let e13 = 0; e13 < t.activeTextures.length; e13++)
        t.activeTextures[e13].deactivate();
  }, e12.translucentPass = (n, r) => {
    if (n)
      t.context.depthMask(t._openGLRenderer.getSelector() && t.renderable.getNestedPickable()), e12.activateTextures();
    else if (t.activeTextures)
      for (let e13 = 0; e13 < t.activeTextures.length; e13++)
        t.activeTextures[e13].deactivate();
  }, e12.getKeyMatrices = () => (t.renderable.getMTime() > t.keyMatrixTime.getMTime() && (t.renderable.computeMatrix(), copy$4(t.keyMatrices.mcwc, t.renderable.getMatrix()), transpose(t.keyMatrices.mcwc, t.keyMatrices.mcwc), t.renderable.getIsIdentity() ? identity$3(t.keyMatrices.normalMatrix) : (fromMat4(t.keyMatrices.normalMatrix, t.keyMatrices.mcwc), invert$1(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), transpose$1(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix)), t.keyMatrixTime.modified()), t.keyMatrices);
}
var DEFAULT_VALUES$46 = {
  context: null,
  keyMatrixTime: null,
  keyMatrices: null,
  activeTextures: null
};
function extend$55(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$46, n), vtkViewNode$1.extend(e12, t, n), t.keyMatrixTime = {}, obj(t.keyMatrixTime, { mtime: 0 }), t.keyMatrices = {
    normalMatrix: identity$3(new Float64Array(9)),
    mcwc: identity$2(new Float64Array(16))
  }, setGet(e12, t, ["context"]), get(e12, t, ["activeTextures"]), vtkOpenGLActor(e12, t);
}
var newInstance$51 = newInstance(extend$55), vtkActor$2 = {
  newInstance: newInstance$51,
  extend: extend$55
};
registerOverride$1("vtkActor", newInstance$51);
function vtkOpenGLActor2D(e12, t) {
  t.classHierarchy.push("vtkOpenGLActor2D"), e12.buildPass = (n) => {
    if (n) {
      if (!t.renderable)
        return;
      t._openGLRenderWindow = e12.getLastAncestorOfType("vtkOpenGLRenderWindow"), t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t.context = t._openGLRenderWindow.getContext(), e12.prepareNodes(), e12.addMissingNodes(t.renderable.getTextures()), e12.addMissingNode(t.renderable.getMapper()), e12.removeUnusedNodes(), t.ogltextures = null, t.activeTextures = null;
      for (let e13 = 0; e13 < t.children.length; e13++) {
        let n2 = t.children[e13];
        n2.isA("vtkOpenGLTexture") ? (t.ogltextures ||= [], t.ogltextures.push(n2)) : t.oglmapper = n2;
      }
    }
  }, e12.queryPass = (e13, n) => {
    if (e13) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      n.incrementOverlayActorCount();
    }
  }, e12.traverseOpaquePass = (n) => {
    !t.oglmapper || !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.oglmapper.traverse(n), e12.apply(n, false));
  }, e12.traverseTranslucentPass = (n) => {
    !t.oglmapper || !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.oglmapper.traverse(n), e12.apply(n, false));
  }, e12.traverseOverlayPass = (n) => {
    !t.oglmapper || !t.renderable || !t.renderable.getNestedVisibility() || t._openGLRenderer.getSelector() && !t.renderable.getNestedPickable || (e12.apply(n, true), t.oglmapper.traverse(n), e12.apply(n, false));
  }, e12.activateTextures = () => {
    if (t.ogltextures) {
      t.activeTextures = [];
      for (let e13 = 0; e13 < t.ogltextures.length; e13++) {
        let n = t.ogltextures[e13];
        n.render(), n.getHandle() && t.activeTextures.push(n);
      }
    }
  }, e12.opaquePass = (n, r) => {
    if (n)
      t.context.depthMask(true), e12.activateTextures();
    else if (t.activeTextures)
      for (let e13 = 0; e13 < t.activeTextures.length; e13++)
        t.activeTextures[e13].deactivate();
  }, e12.translucentPass = (n, r) => {
    if (n)
      t.context.depthMask(false), e12.activateTextures();
    else if (t.activeTextures)
      for (let e13 = 0; e13 < t.activeTextures.length; e13++)
        t.activeTextures[e13].deactivate();
  }, e12.overlayPass = (n, r) => {
    if (n)
      t.context.depthMask(true), e12.activateTextures();
    else if (t.activeTextures)
      for (let e13 = 0; e13 < t.activeTextures.length; e13++)
        t.activeTextures[e13].deactivate();
  };
}
var DEFAULT_VALUES$45 = {
  context: null,
  activeTextures: null
};
function extend$54(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$45, n), vtkViewNode$1.extend(e12, t, n), setGet(e12, t, ["context"]), get(e12, t, ["activeTextures"]), vtkOpenGLActor2D(e12, t);
}
var newInstance$50 = newInstance(extend$54), vtkActor2D = {
  newInstance: newInstance$50,
  extend: extend$54
};
registerOverride$1("vtkActor2D", newInstance$50);
function vtkAbstractMapper(e12, t) {
  t.classHierarchy.push("vtkAbstractMapper"), e12.update = () => {
    e12.getInputData();
  }, e12.addClippingPlane = (n) => n.isA("vtkPlane") ? t.clippingPlanes.includes(n) ? false : (t.clippingPlanes.push(n), e12.modified(), true) : false, e12.getNumberOfClippingPlanes = () => t.clippingPlanes.length, e12.removeAllClippingPlanes = () => t.clippingPlanes.length === 0 ? false : (t.clippingPlanes.length = 0, e12.modified(), true), e12.removeClippingPlane = (n) => {
    let r = t.clippingPlanes.indexOf(n);
    return r === -1 ? false : (t.clippingPlanes.splice(r, 1), e12.modified(), true);
  }, e12.getClippingPlanes = () => t.clippingPlanes, e12.setClippingPlanes = (t2) => {
    if (t2)
      if (!Array.isArray(t2))
        e12.addClippingPlane(t2);
      else {
        let n = t2.length;
        for (let r = 0; r < n && r < 6; r++)
          e12.addClippingPlane(t2[r]);
      }
  }, e12.getClippingPlaneInDataCoords = (e13, n, r) => {
    let a = t.clippingPlanes, o = e13;
    if (a) {
      let e14 = a.length;
      if (n >= 0 && n < e14) {
        let e15 = a[n], t2 = e15.getNormal(), s = e15.getOrigin(), c = t2[0], l = t2[1], u = t2[2], d = -(c * s[0] + l * s[1] + u * s[2]);
        r[0] = c * o[0] + l * o[4] + u * o[8] + d * o[12], r[1] = c * o[1] + l * o[5] + u * o[9] + d * o[13], r[2] = c * o[2] + l * o[6] + u * o[10] + d * o[14], r[3] = c * o[3] + l * o[7] + u * o[11] + d * o[15];
        return;
      }
    }
    macro.vtkErrorMacro(`Clipping plane index ${n} is out of range.`);
  };
}
var DEFAULT_VALUES$44 = { clippingPlanes: [] };
function extend$53(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$44, n), macro.obj(e12, t), macro.algo(e12, t, 1, 0), t.clippingPlanes ||= [], vtkAbstractMapper(e12, t);
}
var vtkAbstractMapper$1 = { extend: extend$53 };
function vtkAbstractMapper3D(e12, t) {
  e12.getBounds = () => (macro.vtkErrorMacro("vtkAbstractMapper3D.getBounds - NOT IMPLEMENTED"), createUninitializedBounds()), e12.getCenter = () => {
    let n = e12.getBounds();
    return t.center = vtkBoundingBox.isValid(n) ? vtkBoundingBox.getCenter(n) : null, t.center?.slice();
  }, e12.getLength = () => {
    let t2 = e12.getBounds();
    return vtkBoundingBox.getDiagonalLength(t2);
  };
}
var defaultValues$6 = (e12) => ({
  bounds: [...vtkBoundingBox.INIT_BOUNDS],
  center: [
    0,
    0,
    0
  ],
  viewSpecificProperties: {},
  ...e12
});
function extend$52(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, defaultValues$6(n)), vtkAbstractMapper$1.extend(e12, t, n), macro.setGet(e12, t, ["viewSpecificProperties"]), vtkAbstractMapper3D(e12, t);
}
var vtkAbstractMapper3D$1 = { extend: extend$52 }, { vtkErrorMacro: vtkErrorMacro$14 } = macro, BELOW_RANGE_COLOR_INDEX$1 = 0, ABOVE_RANGE_COLOR_INDEX$1 = 1, NAN_COLOR_INDEX$1 = 2;
function vtkLookupTable(e12, t) {
  t.classHierarchy.push("vtkLookupTable"), e12.isOpaque = () => {
    if (t.opaqueFlagBuildTime.getMTime() < e12.getMTime()) {
      let e13 = true;
      t.nanColor[3] < 1 && (e13 = 0), t.useBelowRangeColor && t.belowRangeColor[3] < 1 && (e13 = 0), t.useAboveRangeColor && t.aboveRangeColor[3] < 1 && (e13 = 0);
      for (let n = 3; n < t.table.length && e13; n += 4)
        t.table[n] < 255 && (e13 = false);
      t.opaqueFlag = e13, t.opaqueFlagBuildTime.modified();
    }
    return t.opaqueFlag;
  }, e12.usingLogScale = () => false, e12.getNumberOfAvailableColors = () => t.table.length / 4 - 3, e12.linearIndexLookup = (e13, t2) => {
    let n = 0, r = Number(e13);
    return r < t2.range[0] ? n = t2.maxIndex + BELOW_RANGE_COLOR_INDEX$1 + 1.5 : r > t2.range[1] ? n = t2.maxIndex + ABOVE_RANGE_COLOR_INDEX$1 + 1.5 : (n = (r + t2.shift) * t2.scale, n = n < t2.maxIndex ? n : t2.maxIndex), Math.floor(n);
  }, e12.linearLookup = (t2, n, r) => {
    let a = 0;
    a = isNan(t2) ? Math.floor(r.maxIndex + 1.5 + NAN_COLOR_INDEX$1) : e12.linearIndexLookup(t2, r);
    let o = 4 * a;
    return n.slice(o, o + 4);
  }, e12.indexedLookupFunction = (n, r, a) => {
    let o = e12.getAnnotatedValueIndexInternal(n);
    o === -1 && (o = t.numberOfColors + NAN_COLOR_INDEX$1);
    let s = 4 * o;
    return [
      r[s],
      r[s + 1],
      r[s + 2],
      r[s + 3]
    ];
  }, e12.lookupShiftAndScale = (e13, t2) => {
    t2.shift = -e13[0], t2.scale = Number.MAX_VALUE, e13[1] > e13[0] && (t2.scale = (t2.maxIndex + 1) / (e13[1] - e13[0]));
  }, e12.mapScalarsThroughTable = (n, r, a, o) => {
    let s = e12.linearLookup;
    t.indexedLookup && (s = e12.indexedLookupFunction);
    let c = e12.getMappingRange(), l = {
      maxIndex: e12.getNumberOfColors() - 1,
      range: c,
      shift: 0,
      scale: 0
    };
    e12.lookupShiftAndScale(c, l);
    let u = e12.getAlpha(), d = n.getNumberOfTuples(), f = n.getNumberOfComponents(), p = r.getData(), m = n.getData();
    if (u >= 1) {
      if (a === ScalarMappingTarget.RGBA)
        for (let e13 = 0; e13 < d; e13++) {
          let n2 = s(m[e13 * f + o], t.table, l);
          p[e13 * 4] = n2[0], p[e13 * 4 + 1] = n2[1], p[e13 * 4 + 2] = n2[2], p[e13 * 4 + 3] = n2[3];
        }
    } else if (a === ScalarMappingTarget.RGBA)
      for (let e13 = 0; e13 < d; e13++) {
        let n2 = s(m[e13 * f + o], t.table, l);
        p[e13 * 4] = n2[0], p[e13 * 4 + 1] = n2[1], p[e13 * 4 + 2] = n2[2], p[e13 * 4 + 3] = Math.floor(n2[3] * u + 0.5);
      }
  }, e12.forceBuild = () => {
    let n = 0, r = 0, a = 0, o = 0, s = t.numberOfColors - 1;
    s && (n = (t.hueRange[1] - t.hueRange[0]) / s, r = (t.saturationRange[1] - t.saturationRange[0]) / s, a = (t.valueRange[1] - t.valueRange[0]) / s, o = (t.alphaRange[1] - t.alphaRange[0]) / s), t.table.length = 4 * s + 16;
    let c = [], l = [];
    for (let e13 = 0; e13 <= s; e13++)
      c[0] = t.hueRange[0] + e13 * n, c[1] = t.saturationRange[0] + e13 * r, c[2] = t.valueRange[0] + e13 * a, hsv2rgb(c, l), l[3] = t.alphaRange[0] + e13 * o, t.table[e13 * 4] = l[0] * 255 + 0.5, t.table[e13 * 4 + 1] = l[1] * 255 + 0.5, t.table[e13 * 4 + 2] = l[2] * 255 + 0.5, t.table[e13 * 4 + 3] = l[3] * 255 + 0.5;
    e12.buildSpecialColors(), t.buildTime.modified();
  }, e12.setTable = (n) => {
    if (Array.isArray(n)) {
      let r2 = n[0].length;
      t.numberOfColors = n.length;
      let a = 4 - r2, o = 0;
      for (let e13 = 0; e13 < t.numberOfColors; e13++)
        t.table[e13 * 4] = 255, t.table[e13 * 4 + 1] = 255, t.table[e13 * 4 + 2] = 255, t.table[e13 * 4 + 3] = 255;
      for (let e13 = 0; e13 < n.length; e13++) {
        let s = n[e13];
        for (let e14 = 0; e14 < r2; e14++)
          t.table[o++] = s[e14];
        o += a;
      }
      return e12.buildSpecialColors(), t.insertTime.modified(), e12.modified(), true;
    }
    if (n.getNumberOfComponents() !== 4)
      return vtkErrorMacro$14("Expected 4 components for RGBA colors"), false;
    if (n.getDataType() !== VtkDataTypes.UNSIGNED_CHAR)
      return vtkErrorMacro$14("Expected unsigned char values for RGBA colors"), false;
    t.numberOfColors = n.getNumberOfTuples();
    let r = n.getData();
    t.table.length = r.length;
    for (let e13 = 0; e13 < r.length; e13++)
      t.table[e13] = r[e13];
    return e12.buildSpecialColors(), t.insertTime.modified(), e12.modified(), true;
  }, e12.buildSpecialColors = () => {
    let { numberOfColors: e13 } = t, n = t.table, r = (e13 + BELOW_RANGE_COLOR_INDEX$1) * 4;
    t.useBelowRangeColor || e13 === 0 ? (n[r] = t.belowRangeColor[0] * 255 + 0.5, n[r + 1] = t.belowRangeColor[1] * 255 + 0.5, n[r + 2] = t.belowRangeColor[2] * 255 + 0.5, n[r + 3] = t.belowRangeColor[3] * 255 + 0.5) : (n[r] = n[0], n[r + 1] = n[1], n[r + 2] = n[2], n[r + 3] = n[3]), r = (e13 + ABOVE_RANGE_COLOR_INDEX$1) * 4, t.useAboveRangeColor || e13 === 0 ? (n[r] = t.aboveRangeColor[0] * 255 + 0.5, n[r + 1] = t.aboveRangeColor[1] * 255 + 0.5, n[r + 2] = t.aboveRangeColor[2] * 255 + 0.5, n[r + 3] = t.aboveRangeColor[3] * 255 + 0.5) : (n[r] = n[4 * (e13 - 1) + 0], n[r + 1] = n[4 * (e13 - 1) + 1], n[r + 2] = n[4 * (e13 - 1) + 2], n[r + 3] = n[4 * (e13 - 1) + 3]), r = (e13 + NAN_COLOR_INDEX$1) * 4, n[r] = t.nanColor[0] * 255 + 0.5, n[r + 1] = t.nanColor[1] * 255 + 0.5, n[r + 2] = t.nanColor[2] * 255 + 0.5, n[r + 3] = t.nanColor[3] * 255 + 0.5;
  }, e12.build = () => {
    (t.table.length < 1 || e12.getMTime() > t.buildTime.getMTime() && t.insertTime.getMTime() <= t.buildTime.getMTime()) && e12.forceBuild();
  }, t.table.length > 0 && (e12.buildSpecialColors(), t.insertTime.modified());
}
var DEFAULT_VALUES$43 = {
  numberOfColors: 256,
  hueRange: [0, 0.66667],
  saturationRange: [1, 1],
  valueRange: [1, 1],
  alphaRange: [1, 1],
  nanColor: [
    0.5,
    0,
    0,
    1
  ],
  belowRangeColor: [
    0,
    0,
    0,
    1
  ],
  aboveRangeColor: [
    1,
    1,
    1,
    1
  ],
  useAboveRangeColor: false,
  useBelowRangeColor: false,
  alpha: 1
};
function extend$51(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$43, n), vtkScalarsToColors$1.extend(e12, t, n), t.table ||= [], t.buildTime = {}, macro.obj(t.buildTime), t.opaqueFlagBuildTime = {}, macro.obj(t.opaqueFlagBuildTime, { mtime: 0 }), t.insertTime = {}, macro.obj(t.insertTime, { mtime: 0 }), macro.get(e12, t, ["buildTime"]), macro.setGet(e12, t, [
    "numberOfColors",
    "useAboveRangeColor",
    "useBelowRangeColor"
  ]), macro.setArray(e12, t, [
    "alphaRange",
    "hueRange",
    "saturationRange",
    "valueRange"
  ], 2), macro.setArray(e12, t, [
    "nanColor",
    "belowRangeColor",
    "aboveRangeColor"
  ], 4), macro.getArray(e12, t, [
    "hueRange",
    "saturationRange",
    "valueRange",
    "alphaRange",
    "nanColor",
    "belowRangeColor",
    "aboveRangeColor"
  ]), vtkLookupTable(e12, t);
}
var vtkLookupTable$1 = {
  newInstance: macro.newInstance(extend$51, "vtkLookupTable"),
  extend: extend$51
}, { FieldAssociations: FieldAssociations$1 } = vtkDataSet$1, { staticOffsetAPI: staticOffsetAPI$1, otherStaticMethods: otherStaticMethods$1 } = CoincidentTopologyHelper, { ColorMode, ScalarMode: ScalarMode$2, GetArray } = Constants$6, { VectorMode: VectorMode$1 } = vtkScalarsToColors, { VtkDataTypes: VtkDataTypes$1 } = vtkDataArray$1;
function notImplemented$2(e12) {
  return () => macro.vtkErrorMacro(`vtkMapper::${e12} - NOT IMPLEMENTED`);
}
function updateZigzaggingCoordinates(e12, t) {
  let n = e12[1] % 2 == 0 ? 1 : -1;
  if (e12[0] += n, e12[0] >= t[0] || e12[0] < 0) {
    let r = e12[2] % 2 == 0 ? 1 : -1;
    e12[0] -= n, e12[1] += r, (e12[1] >= t[1] || e12[1] < 0) && (e12[1] -= r, e12[2]++);
  }
}
function getIndexFromCoordinates(e12, t) {
  return e12[0] + t[0] * (e12[1] + t[1] * e12[2]);
}
function getZigZagTextureCoordinatesFromTexelPosition(e12, t, n) {
  let r = Math.floor(t), a = r % (2 * n[0]), o, s;
  a < n[0] ? (e12[0] = a, o = 1, s = e12[0] === n[0] - 1) : (e12[0] = 2 * n[0] - 1 - a, o = -1, s = e12[0] === 0);
  let c = Math.floor(r / n[0]), l = c % (2 * n[1]), u, d;
  l < n[1] ? (e12[1] = l, u = 1, d = e12[1] === n[1] - 1) : (e12[1] = 2 * n[1] - 1 - l, u = -1, d = e12[1] === 0), e12[2] = Math.floor(c / n[1]);
  let f = t - r;
  s ? d ? e12[2] += f : e12[1] += u * f : e12[0] += o * f, e12[0] = (e12[0] + 0.5) / n[0], e12[1] = (e12[1] + 0.5) / n[1], e12[2] = (e12[2] + 0.5) / n[2];
}
var colorTextureCoordinatesCache = /* @__PURE__ */ new WeakMap();
function getOrCreateColorTextureCoordinates(e12, t, n, r, a, o, s) {
  let c = Array(arguments.length);
  for (let e13 = 0; e13 < arguments.length; ++e13) {
    let t2 = arguments[e13];
    c[e13] = t2.getMTime?.() ?? t2;
  }
  let l = c.join("/"), u = colorTextureCoordinatesCache.get(e12);
  if (u && u.stringHash === l)
    return u.textureCoordinates;
  let d = (n[1] - n[0]) / (a - 1), [f, p] = [n[0] - d, n[1] + d], m = f - 0.5 * d, h = 1 / (p - f + d), g = f, _ = (a + 1) / (p - f), v = e12.getData(), y = e12.getNumberOfTuples(), b = e12.getNumberOfComponents(), S = t < 0 || t >= b, C = o[2] <= 1 ? 2 : 3, w = vtkDataArray$1.newInstance({
    numberOfComponents: C,
    values: new Float32Array(y * C)
  }), T = w.getData(), E = [
    0,
    0,
    0
  ];
  getZigZagTextureCoordinatesFromTexelPosition(E, a + 2, o);
  let D = 0, O = 0, k = [
    0.5,
    0.5,
    0.5
  ];
  for (let e13 = 0; e13 < y; ++e13) {
    let e14;
    if (S) {
      let t2 = 0;
      for (let e15 = 0; e15 < b; ++e15) {
        let n2 = Number(v[D + e15]);
        t2 += n2 * n2;
      }
      e14 = Math.sqrt(t2);
    } else
      e14 = Number(v[D + t]);
    if (r && (e14 = Math.log10(e14)), D += b, isNan(e14))
      k[0] = E[0], k[1] = E[1], k[2] = E[2];
    else if (s) {
      let t2 = (e14 - g) * _;
      t2 < 1 ? t2 = 0 : t2 > a && (t2 = a + 1), getZigZagTextureCoordinatesFromTexelPosition(k, t2, o);
    } else {
      k[1] = 0.49;
      let t2 = (e14 - m) * h;
      t2 > 1e3 ? k[0] = 1e3 : t2 < -1e3 ? k[0] = -1e3 : k[0] = t2;
    }
    for (let e15 = 0; e15 < C; ++e15)
      T[O++] = k[e15];
  }
  return colorTextureCoordinatesCache.set(e12, {
    stringHash: l,
    textureCoordinates: w
  }), w;
}
function vtkMapper(e12, t) {
  t.classHierarchy.push("vtkMapper"), e12.getBounds = () => {
    let n = e12.getInputData();
    return n ? (t.static || e12.update(), t.bounds = n.getBounds()) : t.bounds = createUninitializedBounds(), t.bounds;
  }, e12.setForceCompileOnly = (e13) => {
    t.forceCompileOnly = e13;
  }, e12.setSelectionWebGLIdsToVTKIds = (e13) => {
    t.selectionWebGLIdsToVTKIds = e13;
  }, e12.createDefaultLookupTable = () => {
    t.lookupTable = vtkLookupTable$1.newInstance();
  }, e12.getColorModeAsString = () => macro.enumToString(ColorMode, t.colorMode), e12.setColorModeToDefault = () => e12.setColorMode(0), e12.setColorModeToMapScalars = () => e12.setColorMode(1), e12.setColorModeToDirectScalars = () => e12.setColorMode(2), e12.getScalarModeAsString = () => macro.enumToString(ScalarMode$2, t.scalarMode), e12.setScalarModeToDefault = () => e12.setScalarMode(0), e12.setScalarModeToUsePointData = () => e12.setScalarMode(1), e12.setScalarModeToUseCellData = () => e12.setScalarMode(2), e12.setScalarModeToUsePointFieldData = () => e12.setScalarMode(3), e12.setScalarModeToUseCellFieldData = () => e12.setScalarMode(4), e12.setScalarModeToUseFieldData = () => e12.setScalarMode(5), e12.getAbstractScalars = (e13, n, r, a, o) => {
    if (!e13 || !t.scalarVisibility)
      return {
        scalars: null,
        cellFlag: false
      };
    let s = null, c = false;
    if (n === ScalarMode$2.DEFAULT)
      s = e13.getPointData().getScalars(), s || (s = e13.getCellData().getScalars(), c = true);
    else if (n === ScalarMode$2.USE_POINT_DATA)
      s = e13.getPointData().getScalars();
    else if (n === ScalarMode$2.USE_CELL_DATA)
      s = e13.getCellData().getScalars(), c = true;
    else if (n === ScalarMode$2.USE_POINT_FIELD_DATA) {
      let t2 = e13.getPointData();
      s = r === GetArray.BY_ID ? t2.getArrayByIndex(a) : t2.getArrayByName(o);
    } else if (n === ScalarMode$2.USE_CELL_FIELD_DATA) {
      let t2 = e13.getCellData();
      c = true, s = r === GetArray.BY_ID ? t2.getArrayByIndex(a) : t2.getArrayByName(o);
    } else if (n === ScalarMode$2.USE_FIELD_DATA) {
      let t2 = e13.getFieldData();
      s = r === GetArray.BY_ID ? t2.getArrayByIndex(a) : t2.getArrayByName(o);
    }
    return {
      scalars: s,
      cellFlag: c
    };
  }, e12.mapScalars = (n, r) => {
    let { scalars: a, cellFlag: o } = e12.getAbstractScalars(n, t.scalarMode, t.arrayAccessMode, t.arrayId, t.colorByArrayName);
    if (t.areScalarsMappedFromCells = o, !a) {
      t.colorCoordinates = null, t.colorTextureMap = null, t.colorMapColors = null;
      return;
    }
    let s = `${e12.getMTime()}${a.getMTime()}${r}`;
    if (t.colorBuildString !== s) {
      if (t.useLookupTableScalarRange || e12.getLookupTable().setRange(t.scalarRange[0], t.scalarRange[1]), e12.canUseTextureMapForColoring(a, o))
        t.mapScalarsToTexture(a, o, r);
      else {
        t.colorCoordinates = null, t.colorTextureMap = null;
        let n2 = e12.getLookupTable();
        n2 && (n2.build(), t.colorMapColors = n2.mapScalars(a, t.colorMode, t.fieldDataTupleId));
      }
      t.colorBuildString = `${e12.getMTime()}${a.getMTime()}${r}`;
    }
  }, t.mapScalarsToTexture = (n, r, a) => {
    let o = t.lookupTable.getRange(), s = t.lookupTable.usingLogScale(), c = t.lookupTable.getAlpha(), l = s ? [Math.log10(o[0]), Math.log10(o[1])] : o;
    if (t.colorMapColors = null, t.colorTextureMap == null || e12.getMTime() > t.colorTextureMap.getMTime() || t.lookupTable.getMTime() > t.colorTextureMap.getMTime() || t.lookupTable.getAlpha() !== a) {
      t.lookupTable.setAlpha(a), t.colorTextureMap = null, t.lookupTable.build();
      let e13 = t.lookupTable.getNumberOfAvailableColors(), n2 = 2048, o2 = n2 ** 3 - 3, u = r ? o2 : 4094;
      t.numberOfColorsInRange = Math.min(Math.max(e13, 2), u);
      let d = t.numberOfColorsInRange + 3, f = t.numberOfColorsInRange + 2, p = r ? [
        Math.min(Math.ceil(d / n2 ** 0), n2),
        Math.min(Math.ceil(d / n2 ** 1), n2),
        Math.min(Math.ceil(d / n2 ** 2), n2)
      ] : [
        f,
        2,
        1
      ], m = p[0] * p[1] * p[2], h = new Float64Array(m);
      h.fill(NaN);
      let g = t.numberOfColorsInRange, _ = g + 2, v = [
        0,
        0,
        0
      ], y = l[0], b = l[1] - l[0];
      for (let e14 = 0; e14 < _; ++e14) {
        let t2 = getIndexFromCoordinates(v, p), n3 = y + b * (e14 - 1) / (g - 1);
        h[t2] = s ? 10 ** n3 : n3, updateZigzaggingCoordinates(v, p);
      }
      let S = vtkDataArray$1.newInstance({
        numberOfComponents: 1,
        values: h
      }), C = t.lookupTable.mapScalars(S, t.colorMode, 0);
      t.colorTextureMap = vtkImageData$1.newInstance(), t.colorTextureMap.setDimensions(p), t.colorTextureMap.getPointData().setScalars(C), t.lookupTable.setAlpha(c);
    }
    t.colorCoordinates = getOrCreateColorTextureCoordinates(n, t.lookupTable.getVectorMode() === VectorMode$1.MAGNITUDE && n.getNumberOfComponents() > 1 ? -1 : t.lookupTable.getVectorComponent(), l, s, t.numberOfColorsInRange, t.colorTextureMap.getDimensions(), r);
  }, e12.getIsOpaque = () => {
    let n = e12.getInputData(), r = e12.getAbstractScalars(n, t.scalarMode, t.arrayAccessMode, t.arrayId, t.colorByArrayName).scalars;
    if (!t.scalarVisibility || r == null)
      return true;
    let a = e12.getLookupTable();
    return a ? (a.build(), a.areScalarsOpaque(r, t.colorMode, -1)) : true;
  }, e12.canUseTextureMapForColoring = (e13, n) => n && t.colorMode !== ColorMode.DIRECT_SCALARS ? true : !(!t.interpolateScalarsBeforeMapping || t.lookupTable && t.lookupTable.getIndexedLookup() || !e13 || t.colorMode === ColorMode.DEFAULT && e13.getDataType() === VtkDataTypes$1.UNSIGNED_CHAR || t.colorMode === ColorMode.DIRECT_SCALARS), e12.clearColorArrays = () => {
    t.colorMapColors = null, t.colorCoordinates = null, t.colorTextureMap = null;
  }, e12.getLookupTable = () => (t.lookupTable || e12.createDefaultLookupTable(), t.lookupTable), e12.getMTime = () => {
    let e13 = t.mtime;
    if (t.lookupTable !== null) {
      let n = t.lookupTable.getMTime();
      e13 = n > e13 ? n : e13;
    }
    return e13;
  }, e12.getPrimitiveCount = () => {
    let t2 = e12.getInputData();
    return {
      points: t2.getPoints().getNumberOfValues() / 3,
      verts: t2.getVerts().getNumberOfValues() - t2.getVerts().getNumberOfCells(),
      lines: t2.getLines().getNumberOfValues() - 2 * t2.getLines().getNumberOfCells(),
      triangles: t2.getPolys().getNumberOfValues() - 3 * t2.getPolys().getNumberOfCells()
    };
  }, e12.acquireInvertibleLookupTable = notImplemented$2("AcquireInvertibleLookupTable"), e12.valueToColor = notImplemented$2("ValueToColor"), e12.colorToValue = notImplemented$2("ColorToValue"), e12.useInvertibleColorFor = notImplemented$2("UseInvertibleColorFor"), e12.clearInvertibleColor = notImplemented$2("ClearInvertibleColor"), e12.processSelectorPixelBuffers = (e13, n) => {
    if (!e13 || !t.selectionWebGLIdsToVTKIds || !t.populateSelectionSettings)
      return;
    let r = e13.getRawPixelBuffer(PassTypes$1.ID_LOW24), a = e13.getRawPixelBuffer(PassTypes$1.ID_HIGH24), o = e13.getCurrentPass(), s = e13.getFieldAssociation(), c = null;
    s === FieldAssociations$1.FIELD_ASSOCIATION_POINTS ? c = t.selectionWebGLIdsToVTKIds.points : s === FieldAssociations$1.FIELD_ASSOCIATION_CELLS && (c = t.selectionWebGLIdsToVTKIds.cells), c && n.forEach((t2) => {
      if (o === PassTypes$1.ID_LOW24) {
        let n2 = 0;
        a && (n2 += a[t2], n2 *= 256), n2 += r[t2 + 2], n2 *= 256, n2 += r[t2 + 1], n2 *= 256, n2 += r[t2];
        let o2 = c[n2], s2 = e13.getPixelBuffer(PassTypes$1.ID_LOW24);
        s2[t2] = o2 & 255, s2[t2 + 1] = (o2 & 65280) >> 8, s2[t2 + 2] = (o2 & 16711680) >> 16;
      } else if (o === PassTypes$1.ID_HIGH24 && a) {
        let n2 = 0;
        n2 += a[t2], n2 *= 256, n2 += r[t2 + 2], n2 *= 256, n2 += r[t2 + 1], n2 *= 256, n2 += r[t2];
        let o2 = c[n2], s2 = e13.getPixelBuffer(PassTypes$1.ID_HIGH24);
        s2[t2] = (o2 & 4278190080) >> 24;
      }
    });
  };
}
var DEFAULT_VALUES$42 = {
  colorMapColors: null,
  areScalarsMappedFromCells: false,
  static: false,
  lookupTable: null,
  scalarVisibility: true,
  scalarRange: [0, 1],
  useLookupTableScalarRange: false,
  colorMode: 0,
  scalarMode: 0,
  arrayAccessMode: 1,
  renderTime: 0,
  colorByArrayName: null,
  fieldDataTupleId: -1,
  populateSelectionSettings: true,
  selectionWebGLIdsToVTKIds: null,
  interpolateScalarsBeforeMapping: false,
  colorCoordinates: null,
  colorTextureMap: null,
  numberOfColorsInRange: 0,
  forceCompileOnly: 0,
  useInvertibleColors: false,
  invertibleScalars: null,
  customShaderAttributes: []
};
function extend$50(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$42, n), vtkAbstractMapper3D$1.extend(e12, t, n), macro.get(e12, t, [
    "areScalarsMappedFromCells",
    "colorCoordinates",
    "colorMapColors",
    "colorTextureMap",
    "numberOfColorsInRange",
    "selectionWebGLIdsToVTKIds"
  ]), macro.setGet(e12, t, [
    "colorByArrayName",
    "arrayAccessMode",
    "colorMode",
    "fieldDataTupleId",
    "interpolateScalarsBeforeMapping",
    "lookupTable",
    "populateSelectionSettings",
    "renderTime",
    "scalarMode",
    "scalarVisibility",
    "static",
    "useLookupTableScalarRange",
    "customShaderAttributes"
  ]), macro.setGetArray(e12, t, ["scalarRange"], 2), CoincidentTopologyHelper.implementCoincidentTopologyMethods(e12, t), vtkMapper(e12, t);
}
var vtkMapper$1 = {
  newInstance: macro.newInstance(extend$50, "vtkMapper"),
  extend: extend$50,
  ...staticOffsetAPI$1,
  ...otherStaticMethods$1,
  ...Constants$6
}, { FieldAssociations } = vtkDataSet$1, { primTypes: primTypes$2 } = vtkHelper, { Representation: Representation$3, Shading } = vtkProperty$1, { ScalarMode: ScalarMode$1 } = vtkMapper$1, { Filter: Filter$2, Wrap: Wrap$1 } = vtkOpenGLTexture$1, { vtkErrorMacro: vtkErrorMacro$13 } = macro$1, StartEvent$2 = { type: "StartEvent" }, EndEvent$2 = { type: "EndEvent" }, { CoordinateSystem: CoordinateSystem$3 } = vtkProp$1;
function getPickState(e12) {
  let t = e12.getSelector();
  return t ? t.getCurrentPass() : PassTypes$1.MIN_KNOWN_PASS - 1;
}
function vtkOpenGLPolyDataMapper(e12, t) {
  t.classHierarchy.push("vtkOpenGLPolyDataMapper"), e12.buildPass = (n2) => {
    n2 && (t.currentRenderPass = null, t.openGLActor = e12.getFirstAncestorOfType("vtkOpenGLActor"), t._openGLRenderer = t.openGLActor.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getLastAncestorOfType("vtkOpenGLRenderWindow"), t.openGLCamera = t._openGLRenderer.getViewNodeFor(t._openGLRenderer.getRenderable().getActiveCamera()));
  }, e12.translucentPass = (n2, r) => {
    n2 && (t.currentRenderPass = r, e12.render());
  }, e12.zBufferPass = (n2) => {
    n2 && (t.haveSeenDepthRequest = true, t.renderDepth = true, e12.render(), t.renderDepth = false);
  }, e12.opaqueZBufferPass = (t2) => e12.zBufferPass(t2), e12.opaquePass = (t2) => {
    t2 && e12.render();
  }, e12.render = () => {
    let n2 = t._openGLRenderWindow.getContext();
    if (t.context !== n2) {
      t.context = n2;
      for (let e13 = primTypes$2.Start; e13 < primTypes$2.End; e13++)
        t.primitives[e13].setOpenGLRenderWindow(t._openGLRenderWindow);
    }
    let r = t.openGLActor.getRenderable(), a = t._openGLRenderer.getRenderable();
    e12.renderPiece(a, r);
  }, e12.getShaderTemplate = (e13, t2, n2) => {
    e13.Vertex = vtkPolyDataVS, e13.Fragment = vtkPolyDataFS, e13.Geometry = "";
  }, e12.replaceShaderColor = (e13, n2, r) => {
    let a = e13.Vertex, o = e13.Geometry, s = e13.Fragment, c = t.lastBoundBO.getReferenceByName("lastLightComplexity"), l = [
      "uniform float ambient;",
      "uniform float diffuse;",
      "uniform float specular;",
      "uniform float opacityUniform; // the fragment opacity",
      "uniform vec3 ambientColorUniform;",
      "uniform vec3 diffuseColorUniform;"
    ];
    c && (l = l.concat(["uniform vec3 specularColorUniform;", "uniform float specularPowerUniform;"]));
    let u = [
      "vec3 ambientColor;",
      "  vec3 diffuseColor;",
      "  float opacity;"
    ];
    c && (u = u.concat(["  vec3 specularColor;", "  float specularPower;"])), u = u.concat([
      "  ambientColor = ambientColorUniform;",
      "  diffuseColor = diffuseColorUniform;",
      "  opacity = opacityUniform;"
    ]), c && (u = u.concat(["  specularColor = specularColorUniform;", "  specularPower = specularPowerUniform;"])), t.lastBoundBO.getCABO().getColorComponents() !== 0 && !t.drawingEdges && (l = l.concat(["varying vec4 vertexColorVSOutput;"]), a = vtkShaderProgram$1.substitute(a, "//VTK::Color::Dec", ["attribute vec4 scalarColor;", "varying vec4 vertexColorVSOutput;"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::Color::Impl", ["vertexColorVSOutput =  scalarColor;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Color::Dec", ["in vec4 vertexColorVSOutput[];", "out vec4 vertexColorGSOutput;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Color::Impl", ["vertexColorGSOutput = vertexColorVSOutput[i];"]).result), t.lastBoundBO.getCABO().getColorComponents() !== 0 && !t.drawingEdges ? s = vtkShaderProgram$1.substitute(s, "//VTK::Color::Impl", u.concat([
      "  diffuseColor = vertexColorVSOutput.rgb;",
      "  ambientColor = vertexColorVSOutput.rgb;",
      "  opacity = opacity*vertexColorVSOutput.a;"
    ])).result : (t.renderable.getAreScalarsMappedFromCells() || t.renderable.getInterpolateScalarsBeforeMapping()) && t.renderable.getColorCoordinates() && !t.drawingEdges ? s = vtkShaderProgram$1.substitute(s, "//VTK::Color::Impl", u.concat([
      "  vec4 texColor = texture2D(texture1, tcoordVCVSOutput.st);",
      "  diffuseColor = texColor.rgb;",
      "  ambientColor = texColor.rgb;",
      "  opacity = opacity*texColor.a;"
    ])).result : (r.getBackfaceProperty() && !t.drawingEdges && (l = l.concat([
      "uniform float opacityUniformBF; // the fragment opacity",
      "uniform float ambientIntensityBF; // the material ambient",
      "uniform float diffuseIntensityBF; // the material diffuse",
      "uniform vec3 ambientColorUniformBF; // ambient material color",
      "uniform vec3 diffuseColorUniformBF; // diffuse material color"
    ]), c ? (l = l.concat([
      "uniform float specularIntensityBF; // the material specular intensity",
      "uniform vec3 specularColorUniformBF; // intensity weighted color",
      "uniform float specularPowerUniformBF;"
    ]), u = u.concat([
      "if (gl_FrontFacing == false) {",
      "  ambientColor = ambientIntensityBF * ambientColorUniformBF;",
      "  diffuseColor = diffuseIntensityBF * diffuseColorUniformBF;",
      "  specularColor = specularIntensityBF * specularColorUniformBF;",
      "  specularPower = specularPowerUniformBF;",
      "  opacity = opacityUniformBF; }"
    ])) : u = u.concat([
      "if (gl_FrontFacing == false) {",
      "  ambientColor = ambientIntensityBF * ambientColorUniformBF;",
      "  diffuseColor = diffuseIntensityBF * diffuseColorUniformBF;",
      "  opacity = opacityUniformBF; }"
    ])), t.haveCellScalars && !t.drawingEdges && (l = l.concat(["uniform samplerBuffer texture1;"])), s = vtkShaderProgram$1.substitute(s, "//VTK::Color::Impl", u).result), s = vtkShaderProgram$1.substitute(s, "//VTK::Color::Dec", l).result, e13.Vertex = a, e13.Geometry = o, e13.Fragment = s;
  }, e12.replaceShaderLight = (e13, n2, r) => {
    let a = e13.Fragment, o = t.lastBoundBO.getReferenceByName("lastLightComplexity"), s = t.lastBoundBO.getReferenceByName("lastLightCount"), c = [];
    switch (o) {
      case 0:
        a = vtkShaderProgram$1.substitute(a, "//VTK::Light::Impl", ["  gl_FragData[0] = vec4(ambientColor * ambient + diffuseColor * diffuse, opacity);", "  //VTK::Light::Impl"], false).result;
        break;
      case 1:
        a = vtkShaderProgram$1.substitute(a, "//VTK::Light::Impl", [
          "  float df = max(0.0, normalVCVSOutput.z);",
          "  float sf = pow(df, specularPower);",
          "  vec3 diffuseL = df * diffuseColor;",
          "  vec3 specularL = sf * specularColor;",
          "  gl_FragData[0] = vec4(ambientColor * ambient + diffuseL * diffuse + specularL * specular, opacity);",
          "  //VTK::Light::Impl"
        ], false).result;
        break;
      case 2:
        for (let e14 = 0; e14 < s; ++e14)
          c = c.concat([
            `uniform vec3 lightColor${e14};`,
            `uniform vec3 lightDirectionVC${e14}; // normalized`,
            `uniform vec3 lightHalfAngleVC${e14}; // normalized`
          ]);
        a = vtkShaderProgram$1.substitute(a, "//VTK::Light::Dec", c).result, c = [
          "vec3 diffuseL = vec3(0,0,0);",
          "  vec3 specularL = vec3(0,0,0);",
          "  float df;"
        ];
        for (let e14 = 0; e14 < s; ++e14)
          c = c.concat([
            `  df = max(0.0, dot(normalVCVSOutput, -lightDirectionVC${e14}));`,
            `  diffuseL += ((df) * lightColor${e14});`,
            `  if (dot(normalVCVSOutput, lightDirectionVC${e14}) < 0.0)`,
            "    {",
            `    float sf = sign(df)*pow(max(1e-5,
                                              dot(reflect(lightDirectionVC${e14},normalVCVSOutput),
                                                  normalize(-vertexVC.xyz))),
                                         specularPower);`,
            `    specularL += (sf * lightColor${e14});`,
            "    }"
          ]);
        c = c.concat([
          "  diffuseL = diffuseL * diffuseColor;",
          "  specularL = specularL * specularColor;",
          "  gl_FragData[0] = vec4(ambientColor * ambient + diffuseL * diffuse + specularL * specular, opacity);",
          "  //VTK::Light::Impl"
        ]), a = vtkShaderProgram$1.substitute(a, "//VTK::Light::Impl", c, false).result;
        break;
      case 3:
        for (let e14 = 0; e14 < s; ++e14)
          c = c.concat([
            `uniform vec3 lightColor${e14};`,
            `uniform vec3 lightDirectionVC${e14}; // normalized`,
            `uniform vec3 lightHalfAngleVC${e14}; // normalized`,
            `uniform vec3 lightPositionVC${e14};`,
            `uniform vec3 lightAttenuation${e14};`,
            `uniform float lightConeAngle${e14};`,
            `uniform float lightExponent${e14};`,
            `uniform int lightPositional${e14};`
          ]);
        a = vtkShaderProgram$1.substitute(a, "//VTK::Light::Dec", c).result, c = [
          "vec3 diffuseL = vec3(0,0,0);",
          "  vec3 specularL = vec3(0,0,0);",
          "  vec3 vertLightDirectionVC;",
          "  float attenuation;",
          "  float df;"
        ];
        for (let e14 = 0; e14 < s; ++e14)
          c = c.concat([
            "  attenuation = 1.0;",
            `  if (lightPositional${e14} == 0)`,
            "    {",
            `      vertLightDirectionVC = lightDirectionVC${e14};`,
            "    }",
            "  else",
            "    {",
            `    vertLightDirectionVC = vertexVC.xyz - lightPositionVC${e14};`,
            "    float distanceVC = length(vertLightDirectionVC);",
            "    vertLightDirectionVC = normalize(vertLightDirectionVC);",
            "    attenuation = 1.0 /",
            `      (lightAttenuation${e14}.x`,
            `       + lightAttenuation${e14}.y * distanceVC`,
            `       + lightAttenuation${e14}.z * distanceVC * distanceVC);`,
            "    // per OpenGL standard cone angle is 90 or less for a spot light",
            `    if (lightConeAngle${e14} <= 90.0)`,
            "      {",
            `      float coneDot = dot(vertLightDirectionVC, lightDirectionVC${e14});`,
            "      // if inside the cone",
            `      if (coneDot >= cos(radians(lightConeAngle${e14})))`,
            "        {",
            `        attenuation = attenuation * pow(coneDot, lightExponent${e14});`,
            "        }",
            "      else",
            "        {",
            "        attenuation = 0.0;",
            "        }",
            "      }",
            "    }",
            "    df = max(0.0, attenuation*dot(normalVCVSOutput, -vertLightDirectionVC));",
            `    diffuseL += ((df) * lightColor${e14});`,
            "    if (dot(normalVCVSOutput, vertLightDirectionVC) < 0.0)",
            "      {",
            `      float sf = sign(df)*attenuation*pow(max(1e-5,
                                                           dot(reflect(lightDirectionVC${e14},
                                                                       normalVCVSOutput),
                                                               normalize(-vertexVC.xyz))),
                                                       specularPower);`,
            `    specularL += ((sf) * lightColor${e14});`,
            "    }"
          ]);
        c = c.concat([
          "  diffuseL = diffuseL * diffuseColor;",
          "  specularL = specularL * specularColor;",
          "  gl_FragData[0] = vec4(ambientColor * ambient + diffuseL * diffuse + specularL * specular, opacity);",
          "  //VTK::Light::Impl"
        ]), a = vtkShaderProgram$1.substitute(a, "//VTK::Light::Impl", c, false).result;
        break;
      default:
        vtkErrorMacro$13("bad light complexity");
    }
    e13.Fragment = a;
  }, e12.replaceShaderNormal = (e13, n2, r) => {
    if (t.lastBoundBO.getReferenceByName("lastLightComplexity") > 0) {
      let n3 = e13.Vertex, a = e13.Geometry, o = e13.Fragment;
      t.lastBoundBO.getCABO().getNormalOffset() ? (n3 = vtkShaderProgram$1.substitute(n3, "//VTK::Normal::Dec", [
        "attribute vec3 normalMC;",
        "uniform mat3 normalMatrix;",
        "varying vec3 normalVCVSOutput;"
      ]).result, n3 = vtkShaderProgram$1.substitute(n3, "//VTK::Normal::Impl", ["normalVCVSOutput = normalMatrix * normalMC;"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::Normal::Dec", ["in vec3 normalVCVSOutput[];", "out vec3 normalVCGSOutput;"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::Normal::Impl", ["normalVCGSOutput = normalVCVSOutput[i];"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Normal::Dec", ["varying vec3 normalVCVSOutput;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Normal::Impl", ["vec3 normalVCVSOutput = normalize(normalVCVSOutput);", "  if (gl_FrontFacing == false) { normalVCVSOutput = -normalVCVSOutput; }"]).result) : t.haveCellNormals ? (o = vtkShaderProgram$1.substitute(o, "//VTK::Normal::Dec", ["uniform mat3 normalMatrix;", "uniform samplerBuffer textureN;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Normal::Impl", [
        "vec3 normalVCVSOutput = normalize(normalMatrix *",
        "    texelFetchBuffer(textureN, gl_PrimitiveID + PrimitiveIDOffset).xyz);",
        "  if (gl_FrontFacing == false) { normalVCVSOutput = -normalVCVSOutput; }"
      ]).result) : t.lastBoundBO.getOpenGLMode(r.getProperty().getRepresentation()) === t.context.LINES ? (o = vtkShaderProgram$1.substitute(o, "//VTK::UniformFlow::Impl", [
        "  vec3 fdx = dFdx(vertexVC.xyz);",
        "  vec3 fdy = dFdy(vertexVC.xyz);",
        "  //VTK::UniformFlow::Impl"
      ]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Normal::Impl", [
        "vec3 normalVCVSOutput;",
        "  if (abs(fdx.x) > 0.0)",
        "    { fdx = normalize(fdx); normalVCVSOutput = normalize(cross(vec3(fdx.y, -fdx.x, 0.0), fdx)); }",
        "  else { fdy = normalize(fdy); normalVCVSOutput = normalize(cross(vec3(fdy.y, -fdy.x, 0.0), fdy));}"
      ]).result) : (o = vtkShaderProgram$1.substitute(o, "//VTK::Normal::Dec", ["uniform int cameraParallel;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::UniformFlow::Impl", [
        "  vec3 fdx = dFdx(vertexVC.xyz);",
        "  vec3 fdy = dFdy(vertexVC.xyz);",
        "  //VTK::UniformFlow::Impl"
      ]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Normal::Impl", [
        "  fdx = normalize(fdx);",
        "  fdy = normalize(fdy);",
        "  vec3 normalVCVSOutput = normalize(cross(fdx,fdy));",
        "  if (cameraParallel == 1 && normalVCVSOutput.z < 0.0) { normalVCVSOutput = -1.0*normalVCVSOutput; }",
        "  if (cameraParallel == 0 && dot(normalVCVSOutput,vertexVC.xyz) > 0.0) { normalVCVSOutput = -1.0*normalVCVSOutput; }"
      ]).result), e13.Vertex = n3, e13.Geometry = a, e13.Fragment = o;
    }
  }, e12.replaceShaderPositionVC = (e13, n2, r) => {
    t.lastBoundBO.replaceShaderPositionVC(e13, n2, r);
    let a = e13.Vertex, o = e13.Geometry, s = e13.Fragment;
    t.lastBoundBO.getReferenceByName("lastLightComplexity") > 0 ? (a = vtkShaderProgram$1.substitute(a, "//VTK::PositionVC::Dec", ["varying vec4 vertexVCVSOutput;"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::PositionVC::Impl", ["vertexVCVSOutput = MCVCMatrix * vertexMC;", "  gl_Position = MCPCMatrix * vertexMC;"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;", "uniform mat4 MCVCMatrix;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::PositionVC::Dec", ["in vec4 vertexVCVSOutput[];", "out vec4 vertexVCGSOutput;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::PositionVC::Impl", ["vertexVCGSOutput = vertexVCVSOutput[i];"]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::PositionVC::Dec", ["varying vec4 vertexVCVSOutput;"]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::PositionVC::Impl", ["vec4 vertexVC = vertexVCVSOutput;"]).result) : (a = vtkShaderProgram$1.substitute(a, "//VTK::Camera::Dec", ["uniform mat4 MCPCMatrix;"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::PositionVC::Impl", ["  gl_Position = MCPCMatrix * vertexMC;"]).result), e13.Vertex = a, e13.Geometry = o, e13.Fragment = s;
  }, e12.replaceShaderTCoord = (e13, n2, r) => {
    if (t.lastBoundBO.getCABO().getTCoordOffset()) {
      let n3 = e13.Vertex, r2 = e13.Geometry, a = e13.Fragment;
      if (t.drawingEdges)
        return;
      n3 = vtkShaderProgram$1.substitute(n3, "//VTK::TCoord::Impl", "tcoordVCVSOutput = tcoordMC;").result;
      let o = t.openGLActor.getActiveTextures(), s = 2, c = 2;
      if (o && o.length > 0 && (s = o[0].getComponents(), o[0].getTarget() === t.context.TEXTURE_CUBE_MAP && (c = 3)), t.renderable.getColorTextureMap() && (s = t.renderable.getColorTextureMap().getPointData().getScalars().getNumberOfComponents(), c = 2), c === 2) {
        if (n3 = vtkShaderProgram$1.substitute(n3, "//VTK::TCoord::Dec", "attribute vec2 tcoordMC; varying vec2 tcoordVCVSOutput;").result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::TCoord::Dec", ["in vec2 tcoordVCVSOutput[];", "out vec2 tcoordVCGSOutput;"]).result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::TCoord::Impl", "tcoordVCGSOutput = tcoordVCVSOutput[i];").result, a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Dec", ["varying vec2 tcoordVCVSOutput;", "uniform sampler2D texture1;"]).result, o && o.length >= 1)
          switch (s) {
            case 1:
              a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Impl", [
                "  vec4 tcolor = texture2D(texture1, tcoordVCVSOutput);",
                "  ambientColor = ambientColor*tcolor.r;",
                "  diffuseColor = diffuseColor*tcolor.r;"
              ]).result;
              break;
            case 2:
              a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Impl", [
                "  vec4 tcolor = texture2D(texture1, tcoordVCVSOutput);",
                "  ambientColor = ambientColor*tcolor.r;",
                "  diffuseColor = diffuseColor*tcolor.r;",
                "  opacity = opacity * tcolor.g;"
              ]).result;
              break;
            default:
              a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Impl", [
                "  vec4 tcolor = texture2D(texture1, tcoordVCVSOutput);",
                "  ambientColor = ambientColor*tcolor.rgb;",
                "  diffuseColor = diffuseColor*tcolor.rgb;",
                "  opacity = opacity * tcolor.a;"
              ]).result;
          }
      } else
        switch (n3 = vtkShaderProgram$1.substitute(n3, "//VTK::TCoord::Dec", "attribute vec3 tcoordMC; varying vec3 tcoordVCVSOutput;").result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::TCoord::Dec", ["in vec3 tcoordVCVSOutput[];", "out vec3 tcoordVCGSOutput;"]).result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::TCoord::Impl", "tcoordVCGSOutput = tcoordVCVSOutput[i];").result, a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Dec", ["varying vec3 tcoordVCVSOutput;", "uniform samplerCube texture1;"]).result, s) {
          case 1:
            a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Impl", [
              "  vec4 tcolor = textureCube(texture1, tcoordVCVSOutput);",
              "  ambientColor = ambientColor*tcolor.r;",
              "  diffuseColor = diffuseColor*tcolor.r;"
            ]).result;
            break;
          case 2:
            a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Impl", [
              "  vec4 tcolor = textureCube(texture1, tcoordVCVSOutput);",
              "  ambientColor = ambientColor*tcolor.r;",
              "  diffuseColor = diffuseColor*tcolor.r;",
              "  opacity = opacity * tcolor.g;"
            ]).result;
            break;
          default:
            a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Impl", [
              "  vec4 tcolor = textureCube(texture1, tcoordVCVSOutput);",
              "  ambientColor = ambientColor*tcolor.rgb;",
              "  diffuseColor = diffuseColor*tcolor.rgb;",
              "  opacity = opacity * tcolor.a;"
            ]).result;
        }
      e13.Vertex = n3, e13.Geometry = r2, e13.Fragment = a;
    }
  }, e12.replaceShaderClip = (e13, n2, r) => {
    let a = e13.Vertex, o = e13.Fragment;
    if (t.renderable.getNumberOfClippingPlanes()) {
      let e14 = t.renderable.getNumberOfClippingPlanes();
      a = vtkShaderProgram$1.substitute(a, "//VTK::Clip::Dec", [
        "uniform int numClipPlanes;",
        `uniform vec4 clipPlanes[${e14}];`,
        `varying float clipDistancesVSOutput[${e14}];`
      ]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::Clip::Impl", [
        `for (int planeNum = 0; planeNum < ${e14}; planeNum++)`,
        "    {",
        "    if (planeNum >= numClipPlanes)",
        "        {",
        "        break;",
        "        }",
        "    clipDistancesVSOutput[planeNum] = dot(clipPlanes[planeNum], vertexMC);",
        "    }"
      ]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", `varying float clipDistancesVSOutput[${e14}];`]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Clip::Impl", [
        `for (int planeNum = 0; planeNum < ${e14}; planeNum++)`,
        "    {",
        "    if (planeNum >= numClipPlanes)",
        "        {",
        "        break;",
        "        }",
        "    if (clipDistancesVSOutput[planeNum] < 0.0) discard;",
        "    }"
      ]).result;
    }
    e13.Vertex = a, e13.Fragment = o;
  }, e12.getCoincidentParameters = (e13, n2) => {
    let r = {
      factor: 0,
      offset: 0
    }, a = n2.getProperty();
    if (t.renderable.getResolveCoincidentTopology() == Resolve.PolygonOffset || a.getEdgeVisibility() && a.getRepresentation() === Representation$3.SURFACE) {
      let e14 = t.lastBoundBO.getPrimitiveType();
      e14 === primTypes$2.Points || a.getRepresentation() === Representation$3.POINTS ? r = t.renderable.getCoincidentTopologyPointOffsetParameter() : e14 === primTypes$2.Lines || a.getRepresentation() === Representation$3.WIREFRAME ? r = t.renderable.getCoincidentTopologyLineOffsetParameters() : (e14 === primTypes$2.Tris || e14 === primTypes$2.TriStrips) && (r = t.renderable.getCoincidentTopologyPolygonOffsetParameters()), (e14 === primTypes$2.TrisEdges || e14 === primTypes$2.TriStripsEdges) && (r = t.renderable.getCoincidentTopologyPolygonOffsetParameters(), r.factor /= 2, r.offset /= 2);
    }
    let o = t._openGLRenderer.getSelector();
    return o && o.getFieldAssociation() === FieldAssociations.FIELD_ASSOCIATION_POINTS && (r.offset -= 2), r;
  }, e12.replaceShaderPicking = (e13, n2, r) => {
    let a = e13.Fragment, o = e13.Vertex;
    if (a = vtkShaderProgram$1.substitute(a, "//VTK::Picking::Dec", ["uniform int picking;", "//VTK::Picking::Dec"]).result, t._openGLRenderer.getSelector()) {
      switch ((t.lastSelectionState === PassTypes$1.ID_LOW24 || t.lastSelectionState === PassTypes$1.ID_HIGH24) && (o = vtkShaderProgram$1.substitute(o, "//VTK::Picking::Dec", ["flat out int vertexIDVSOutput;\n", "uniform int VertexIDOffset;\n"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Picking::Impl", "  vertexIDVSOutput = gl_VertexID + VertexIDOffset;\n").result, a = vtkShaderProgram$1.substitute(a, "//VTK::Picking::Dec", "flat in int vertexIDVSOutput;\n").result, a = vtkShaderProgram$1.substitute(a, "//VTK::Picking::Impl", ["  int idx = vertexIDVSOutput;", "//VTK::Picking::Impl"]).result), t.lastSelectionState) {
        case PassTypes$1.ID_LOW24:
          a = vtkShaderProgram$1.substitute(a, "//VTK::Picking::Impl", "  gl_FragData[0] = vec4(float(idx%256)/255.0, float((idx/256)%256)/255.0, float((idx/65536)%256)/255.0, 1.0);").result;
          break;
        case PassTypes$1.ID_HIGH24:
          a = vtkShaderProgram$1.substitute(a, "//VTK::Picking::Impl", "  gl_FragData[0] = vec4(float((idx/16777216)%256)/255.0, 0.0, 0.0, 1.0);").result;
          break;
        default:
          a = vtkShaderProgram$1.substitute(a, "//VTK::Picking::Dec", "uniform vec3 mapperIndex;").result, a = vtkShaderProgram$1.substitute(a, "//VTK::Picking::Impl", "  gl_FragData[0] = picking != 0 ? vec4(mapperIndex,1.0) : gl_FragData[0];").result;
      }
      e13.Fragment = a, e13.Vertex = o;
    }
  }, e12.replaceShaderValues = (n2, r, a) => {
    if (e12.replaceShaderColor(n2, r, a), e12.replaceShaderNormal(n2, r, a), e12.replaceShaderLight(n2, r, a), e12.replaceShaderTCoord(n2, r, a), e12.replaceShaderPicking(n2, r, a), e12.replaceShaderClip(n2, r, a), e12.replaceShaderCoincidentOffset(n2, r, a), e12.replaceShaderPositionVC(n2, r, a), t.haveSeenDepthRequest) {
      let e13 = n2.Fragment;
      e13 = vtkShaderProgram$1.substitute(e13, "//VTK::ZBuffer::Dec", "uniform int depthRequest;").result, e13 = vtkShaderProgram$1.substitute(e13, "//VTK::ZBuffer::Impl", [
        "if (depthRequest == 1) {",
        "float iz = floor(gl_FragCoord.z*65535.0 + 0.1);",
        "float rf = floor(iz/256.0)/255.0;",
        "float gf = mod(iz,256.0)/255.0;",
        "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"
      ]).result, n2.Fragment = e13;
    }
  }, e12.getNeedToRebuildShaders = (e13, n2, r) => {
    let a = 0, o = 0, s = e13.getPrimitiveType(), c = t.currentInput, l = false, u = c.getPointData().getNormals(), d = c.getCellData().getNormals(), f = r.getProperty().getInterpolation() === Shading.FLAT, p = r.getProperty().getRepresentation(), m = e13.getOpenGLMode(p, s);
    if ((m === t.context.TRIANGLES || d && !u || !f && u || !f && m === t.context.LINES) && (l = true), r.getProperty().getLighting() && l) {
      a = 0;
      let e14 = n2.getLightsByReference();
      for (let t2 = 0; t2 < e14.length; ++t2) {
        let n3 = e14[t2];
        n3.getSwitch() > 0 && (o++, a === 0 && (a = 1)), a === 1 && (o > 1 || n3.getIntensity() !== 1 || !n3.lightTypeIsHeadLight()) && (a = 2), a < 3 && n3.getPositional() && (a = 3);
      }
    }
    let h = false, g = t.lastBoundBO.getReferenceByName("lastLightComplexity"), _ = t.lastBoundBO.getReferenceByName("lastLightCount");
    return (g !== a || _ !== o) && (t.lastBoundBO.set({ lastLightComplexity: a }, true), t.lastBoundBO.set({ lastLightCount: o }, true), h = true), (!t.currentRenderPass && t.lastRenderPassShaderReplacement || t.currentRenderPass && t.currentRenderPass.getShaderReplacement() !== t.lastRenderPassShaderReplacement) && (h = true), t.lastHaveSeenDepthRequest !== t.haveSeenDepthRequest || e13.getShaderSourceTime().getMTime() < t.renderable.getMTime() || e13.getShaderSourceTime().getMTime() < t.currentInput.getMTime() || e13.getShaderSourceTime().getMTime() < t.selectionStateChanged.getMTime() || h ? (t.lastHaveSeenDepthRequest = t.haveSeenDepthRequest, true) : false;
  }, e12.invokeShaderCallbacks = (e13, n2, r) => {
    let a = t.renderable.getViewSpecificProperties().ShadersCallbacks;
    a && a.forEach((t2) => {
      t2.callback(t2.userData, e13, n2, r);
    });
  }, e12.setMapperShaderParameters = (n2, r, a) => {
    if (n2.getProgram().isUniformUsed("PrimitiveIDOffset") && n2.getProgram().setUniformi("PrimitiveIDOffset", t.primitiveIDOffset), n2.getProgram().isUniformUsed("VertexIDOffset") && n2.getProgram().setUniformi("VertexIDOffset", t.vertexIDOffset), n2.getCABO().getElementCount() && (t.VBOBuildTime.getMTime() > n2.getAttributeUpdateTime().getMTime() || n2.getShaderSourceTime().getMTime() > n2.getAttributeUpdateTime().getMTime())) {
      let e13 = t.lastBoundBO.getReferenceByName("lastLightComplexity");
      n2.getProgram().isAttributeUsed("vertexMC") && (n2.getVAO().addAttributeArray(n2.getProgram(), n2.getCABO(), "vertexMC", n2.getCABO().getVertexOffset(), n2.getCABO().getStride(), t.context.FLOAT, 3, false) || vtkErrorMacro$13("Error setting vertexMC in shader VAO.")), n2.getProgram().isAttributeUsed("normalMC") && n2.getCABO().getNormalOffset() && e13 > 0 ? n2.getVAO().addAttributeArray(n2.getProgram(), n2.getCABO(), "normalMC", n2.getCABO().getNormalOffset(), n2.getCABO().getStride(), t.context.FLOAT, 3, false) || vtkErrorMacro$13("Error setting normalMC in shader VAO.") : n2.getVAO().removeAttributeArray("normalMC"), t.renderable.getCustomShaderAttributes().forEach((e14, r2) => {
        n2.getProgram().isAttributeUsed(`${e14}MC`) && (n2.getVAO().addAttributeArray(n2.getProgram(), n2.getCABO(), `${e14}MC`, n2.getCABO().getCustomData()[r2].offset, n2.getCABO().getStride(), t.context.FLOAT, n2.getCABO().getCustomData()[r2].components, false) || vtkErrorMacro$13(`Error setting ${e14}MC in shader VAO.`));
      }), n2.getProgram().isAttributeUsed("tcoordMC") && n2.getCABO().getTCoordOffset() ? n2.getVAO().addAttributeArray(n2.getProgram(), n2.getCABO(), "tcoordMC", n2.getCABO().getTCoordOffset(), n2.getCABO().getStride(), t.context.FLOAT, n2.getCABO().getTCoordComponents(), false) || vtkErrorMacro$13("Error setting tcoordMC in shader VAO.") : n2.getVAO().removeAttributeArray("tcoordMC"), n2.getProgram().isAttributeUsed("scalarColor") && n2.getCABO().getColorComponents() ? n2.getVAO().addAttributeArray(n2.getProgram(), n2.getCABO().getColorBO(), "scalarColor", n2.getCABO().getColorOffset(), n2.getCABO().getColorBOStride(), t.context.UNSIGNED_BYTE, 4, true) || vtkErrorMacro$13("Error setting scalarColor in shader VAO.") : n2.getVAO().removeAttributeArray("scalarColor"), n2.getAttributeUpdateTime().modified();
    }
    if (t.renderable.getNumberOfClippingPlanes()) {
      let e13 = t.renderable.getNumberOfClippingPlanes(), r2 = [], o2 = n2.getCABO().getCoordShiftAndScaleEnabled() ? n2.getCABO().getInverseShiftAndScaleMatrix() : null, s2 = o2 ? copy$4(t.tmpMat4, a.getMatrix()) : a.getMatrix();
      o2 && (transpose(s2, s2), multiply$2(s2, s2, o2), transpose(s2, s2));
      for (let n3 = 0; n3 < e13; n3++) {
        let e14 = [];
        t.renderable.getClippingPlaneInDataCoords(s2, n3, e14);
        for (let t2 = 0; t2 < 4; t2++)
          r2.push(e14[t2]);
      }
      n2.getProgram().setUniformi("numClipPlanes", e13), n2.getProgram().setUniform4fv("clipPlanes", r2);
    }
    t.internalColorTexture && n2.getProgram().isUniformUsed("texture1") && n2.getProgram().setUniformi("texture1", t.internalColorTexture.getTextureUnit());
    let o = t.openGLActor.getActiveTextures();
    if (o)
      for (let e13 = 0; e13 < o.length; ++e13) {
        let t2 = o[e13].getTextureUnit(), r2 = `texture${t2 + 1}`;
        n2.getProgram().isUniformUsed(r2) && n2.getProgram().setUniformi(r2, t2);
      }
    if (t.haveSeenDepthRequest && n2.getProgram().setUniformi("depthRequest", t.renderDepth ? 1 : 0), n2.getProgram().isUniformUsed("coffset")) {
      let t2 = e12.getCoincidentParameters(r, a);
      n2.getProgram().setUniformf("coffset", t2.offset), n2.getProgram().isUniformUsed("cfactor") && n2.getProgram().setUniformf("cfactor", t2.factor);
    }
    n2.setMapperShaderParameters(r, a, t._openGLRenderer.getTiledSizeAndOrigin());
    let s = t._openGLRenderer.getSelector();
    n2.getProgram().setUniform3fArray("mapperIndex", s ? s.getPropColorValue() : [
      0,
      0,
      0
    ]), n2.getProgram().setUniformi("picking", s ? s.getCurrentPass() + 1 : 0);
  }, e12.setLightingShaderParameters = (e13, n2, r) => {
    let a = t.lastBoundBO.getReferenceByName("lastLightComplexity");
    if (a < 2)
      return;
    let o = e13.getProgram(), s = 0, c = n2.getLightsByReference();
    for (let e14 = 0; e14 < c.length; ++e14) {
      let r2 = c[e14];
      if (r2.getSwitch() > 0) {
        let e15 = r2.getColorByReference(), a2 = r2.getIntensity();
        t.lightColor[0] = e15[0] * a2, t.lightColor[1] = e15[1] * a2, t.lightColor[2] = e15[2] * a2;
        let c2 = r2.getDirection(), l2 = n2.getActiveCamera().getViewMatrix(), u = [...c2];
        r2.lightTypeIsSceneLight() && (u[0] = l2[0] * c2[0] + l2[1] * c2[1] + l2[2] * c2[2], u[1] = l2[4] * c2[0] + l2[5] * c2[1] + l2[6] * c2[2], u[2] = l2[8] * c2[0] + l2[9] * c2[1] + l2[10] * c2[2], normalize$1(u)), t.lightDirection[0] = u[0], t.lightDirection[1] = u[1], t.lightDirection[2] = u[2], normalize$1(t.lightDirection), o.setUniform3fArray(`lightColor${s}`, t.lightColor), o.setUniform3fArray(`lightDirectionVC${s}`, t.lightDirection), s++;
      }
    }
    if (a < 3)
      return;
    let l = n2.getActiveCamera().getViewMatrix();
    transpose(l, l), s = 0;
    for (let e14 = 0; e14 < c.length; ++e14) {
      let t2 = c[e14];
      if (t2.getSwitch() > 0) {
        let e15 = t2.getTransformedPosition(), n3 = new Float64Array(3);
        transformMat4$1(n3, e15, l), o.setUniform3fArray(`lightAttenuation${s}`, t2.getAttenuationValuesByReference()), o.setUniformi(`lightPositional${s}`, t2.getPositional()), o.setUniformf(`lightExponent${s}`, t2.getExponent()), o.setUniformf(`lightConeAngle${s}`, t2.getConeAngle()), o.setUniform3fArray(`lightPositionVC${s}`, [
          n3[0],
          n3[1],
          n3[2]
        ]), s++;
      }
    }
  };
  function n(e13, t2, n2) {
    return t2.identity(n2), e13.reduce((e14, n3, r) => r === 0 ? n3 ? t2.copy(e14, n3) : t2.identity(e14) : n3 ? t2.multiply(e14, e14, n3) : e14, n2);
  }
  e12.setCameraShaderParameters = (e13, r, a) => {
    let o = e13.getProgram(), s = t.openGLCamera.getKeyMatrices(r), c = r.getActiveCamera(), l = t.openGLCamera.getKeyMatrixTime().getMTime(), u = o.getLastCameraMTime(), d = e13.getCABO().getCoordShiftAndScaleEnabled() ? e13.getCABO().getInverseShiftAndScaleMatrix() : null, f = a.getIsIdentity(), p = f ? {
      mcwc: null,
      normalMatrix: null
    } : t.openGLActor.getKeyMatrices();
    if (a.getCoordinateSystem() === CoordinateSystem$3.DISPLAY) {
      let e14 = t._openGLRenderer.getTiledSizeAndOrigin();
      identity$2(t.tmpMat4), t.tmpMat4[0] = 2 / e14.usize, t.tmpMat4[12] = -1, t.tmpMat4[5] = 2 / e14.vsize, t.tmpMat4[13] = -1, multiply$2(t.tmpMat4, t.tmpMat4, d), o.setUniformMatrix("MCPCMatrix", t.tmpMat4);
    } else
      o.setUniformMatrix("MCPCMatrix", n([
        s.wcpc,
        p.mcwc,
        d
      ], mat4_exports, t.tmpMat4));
    o.isUniformUsed("MCVCMatrix") && o.setUniformMatrix("MCVCMatrix", n([
      s.wcvc,
      p.mcwc,
      d
    ], mat4_exports, t.tmpMat4)), o.isUniformUsed("normalMatrix") && o.setUniformMatrix3x3("normalMatrix", n([s.normalMatrix, p.normalMatrix], mat3_exports, t.tmpMat3)), u !== l && (o.isUniformUsed("cameraParallel") && o.setUniformi("cameraParallel", c.getParallelProjection()), o.setLastCameraMTime(l)), f || o.setLastCameraMTime(0);
  }, e12.setPropertyShaderParameters = (e13, n2, r) => {
    let a = e13.getProgram(), o = r.getProperty(), s = o.getOpacity(), c = t.drawingEdges ? o.getEdgeColorByReference() : o.getAmbientColorByReference(), l = t.drawingEdges ? o.getEdgeColorByReference() : o.getDiffuseColorByReference(), u = t.drawingEdges ? 1 : o.getAmbient(), d = t.drawingEdges ? 0 : o.getDiffuse(), f = t.drawingEdges ? 0 : o.getSpecular(), p = o.getSpecularPower();
    a.setUniformf("opacityUniform", s), a.setUniform3fArray("ambientColorUniform", c), a.setUniform3fArray("diffuseColorUniform", l), a.setUniformf("ambient", u), a.setUniformf("diffuse", d);
    let m = t.lastBoundBO.getReferenceByName("lastLightComplexity");
    if (m < 1)
      return;
    let h = o.getSpecularColorByReference();
    if (a.setUniform3fArray("specularColorUniform", h), a.setUniformf("specularPowerUniform", p), a.setUniformf("specular", f), a.isUniformUsed("ambientIntensityBF")) {
      if (o = r.getBackfaceProperty(), s = o.getOpacity(), c = o.getAmbientColor(), u = o.getAmbient(), l = o.getDiffuseColor(), d = o.getDiffuse(), h = o.getSpecularColor(), f = o.getSpecular(), a.setUniformf("ambientIntensityBF", u), a.setUniformf("diffuseIntensityBF", d), a.setUniformf("opacityUniformBF", s), a.setUniform3fArray("ambientColorUniformBF", c), a.setUniform3fArray("diffuseColorUniformBF", l), m < 1)
        return;
      a.setUniformf("specularIntensityBF", f), a.setUniform3fArray("specularColorUniformBF", h), a.setUniformf("specularPowerUniformBF", p);
    }
  }, e12.updateMaximumPointCellIds = (e13, n2) => {
    let r = t._openGLRenderer.getSelector();
    if (r) {
      if (t.selectionWebGLIdsToVTKIds?.points?.length) {
        let e14 = t.selectionWebGLIdsToVTKIds.points.length;
        r.setMaximumPointId(e14 - 1);
      }
      if (t.selectionWebGLIdsToVTKIds?.cells?.length) {
        let e14 = t.selectionWebGLIdsToVTKIds.cells.length;
        r.setMaximumCellId(e14 - 1);
      }
      r.getFieldAssociation() === FieldAssociations.FIELD_ASSOCIATION_POINTS && (t.pointPicking = true);
    }
  }, e12.renderPieceStart = (n2, r) => {
    t.primitiveIDOffset = 0, t.vertexIDOffset = 0;
    let a = getPickState(t._openGLRenderer);
    if (t.lastSelectionState !== a && (t.selectionStateChanged.modified(), t.lastSelectionState = a), t._openGLRenderer.getSelector())
      switch (a) {
        default:
          t._openGLRenderer.getSelector().renderProp(r);
      }
    e12.updateBufferObjects(n2, r), t.renderable.getColorTextureMap() && t.internalColorTexture.activate(), t.lastBoundBO = null;
  }, e12.renderPieceDraw = (n2, r) => {
    let a = r.getProperty().getRepresentation(), o = r.getProperty().getEdgeVisibility() && a === Representation$3.SURFACE, s = t._openGLRenderer.getSelector(), c = s && s.getFieldAssociation() === FieldAssociations.FIELD_ASSOCIATION_POINTS && (t.lastSelectionState === PassTypes$1.ID_LOW24 || t.lastSelectionState === PassTypes$1.ID_HIGH24);
    for (let s2 = primTypes$2.Start; s2 < primTypes$2.End; s2++)
      t.primitives[s2].setPointPicking(c), t.primitives[s2].getCABO().getElementCount() && (t.drawingEdges = o && (s2 === primTypes$2.TrisEdges || s2 === primTypes$2.TriStripsEdges), (!t.drawingEdges || !(t.renderDepth || t.lastSelectionState >= 0)) && (t.lastBoundBO = t.primitives[s2], t.primitiveIDOffset += t.primitives[s2].drawArrays(n2, r, a, e12), t.vertexIDOffset += t.primitives[s2].getCABO().getElementCount()));
  }, e12.renderPieceFinish = (e13, n2) => {
    t.LastBoundBO && t.LastBoundBO.getVAO().release(), t.renderable.getColorTextureMap() && t.internalColorTexture.deactivate();
  }, e12.renderPiece = (n2, r) => {
    if (e12.invokeEvent(StartEvent$2), t.renderable.getStatic() || t.renderable.update(), t.currentInput = t.renderable.getInputData(), e12.invokeEvent(EndEvent$2), !t.currentInput) {
      vtkErrorMacro$13("No input!");
      return;
    }
    if (!t.currentInput.getPoints || !t.currentInput.getPoints().getNumberOfValues())
      return;
    let a = t.context, o = r.getProperty().getBackfaceCulling(), s = r.getProperty().getFrontfaceCulling();
    !o && !s ? t._openGLRenderWindow.disableCullFace() : s ? (t._openGLRenderWindow.enableCullFace(), a.cullFace(a.FRONT)) : (t._openGLRenderWindow.enableCullFace(), a.cullFace(a.BACK)), e12.renderPieceStart(n2, r), e12.renderPieceDraw(n2, r), e12.renderPieceFinish(n2, r);
  }, e12.updateBufferObjects = (t2, n2) => {
    e12.getNeedToRebuildBufferObjects(t2, n2) && e12.buildBufferObjects(t2, n2), e12.updateMaximumPointCellIds();
  }, e12.getNeedToRebuildBufferObjects = (n2, r) => {
    let a = t.VBOBuildTime.getMTime();
    return a < e12.getMTime() || a < t.renderable.getMTime() || a < r.getMTime() || a < t.currentInput.getMTime();
  }, e12.buildBufferObjects = (e13, n2) => {
    let r = t.currentInput;
    if (r === null)
      return;
    t.renderable.mapScalars(r, 1);
    let a = t.renderable.getColorMapColors();
    t.haveCellScalars = false;
    let o = t.renderable.getScalarMode();
    t.renderable.getScalarVisibility() && (o === ScalarMode$1.USE_CELL_DATA || o === ScalarMode$1.USE_CELL_FIELD_DATA || o === ScalarMode$1.USE_FIELD_DATA || !r.getPointData().getScalars()) && o !== ScalarMode$1.USE_POINT_FIELD_DATA && a && (t.haveCellScalars = true);
    let s = n2.getProperty().getInterpolation() === Shading.FLAT ? null : r.getPointData().getNormals();
    s === null && r.getCellData().getNormals() && (t.haveCellNormals = true, s = r.getCellData().getNormals());
    let c = n2.getProperty().getRepresentation(), l = r.getPointData().getTCoords();
    t.openGLActor.getActiveTextures() || (l = null);
    let u = false;
    if (t.renderable.getColorCoordinates()) {
      l = t.renderable.getColorCoordinates(), u = t.renderable.getAreScalarsMappedFromCells(), t.internalColorTexture ||= vtkOpenGLTexture$1.newInstance({ resizable: true });
      let e14 = t.internalColorTexture;
      e14.setMinificationFilter(Filter$2.NEAREST), e14.setMagnificationFilter(Filter$2.NEAREST), e14.setWrapS(Wrap$1.CLAMP_TO_EDGE), e14.setWrapT(Wrap$1.CLAMP_TO_EDGE), e14.setOpenGLRenderWindow(t._openGLRenderWindow);
      let n3 = t.renderable.getColorTextureMap(), r2 = n3.getExtent(), a2 = n3.getPointData().getScalars();
      e14.create2DFromRaw({
        width: r2[1] - r2[0] + 1,
        height: r2[3] - r2[2] + 1,
        numComps: a2.getNumberOfComponents(),
        dataType: a2.getDataType(),
        data: a2.getData()
      }), e14.activate(), e14.sendParameters(), e14.deactivate();
    }
    let d = `${r.getMTime()}A${c}B${r.getMTime()}C${s ? s.getMTime() : 1}D${a ? a.getMTime() : 1}E${n2.getProperty().getEdgeVisibility()}F${l ? l.getMTime() : 1}`;
    if (t.VBOBuildString !== d) {
      let e14 = {
        points: r.getPoints(),
        normals: s,
        tcoords: l,
        colors: a,
        cellOffset: 0,
        vertexOffset: 0,
        useTCoordsPerCell: u,
        haveCellScalars: t.haveCellScalars,
        haveCellNormals: t.haveCellNormals,
        customAttributes: t.renderable.getCustomShaderAttributes().map((e15) => r.getPointData().getArrayByName(e15))
      };
      t.renderable.getPopulateSelectionSettings() && (t.selectionWebGLIdsToVTKIds = {
        points: null,
        cells: null
      });
      let o2 = [
        {
          inRep: "verts",
          cells: r.getVerts()
        },
        {
          inRep: "lines",
          cells: r.getLines()
        },
        {
          inRep: "polys",
          cells: r.getPolys()
        },
        {
          inRep: "strips",
          cells: r.getStrips()
        },
        {
          inRep: "polys",
          cells: r.getPolys()
        },
        {
          inRep: "strips",
          cells: r.getStrips()
        }
      ], f = n2.getProperty().getEdgeVisibility() && c === Representation$3.SURFACE;
      for (let n3 = primTypes$2.Start; n3 < primTypes$2.End; n3++)
        n3 !== primTypes$2.TrisEdges && n3 !== primTypes$2.TriStripsEdges ? (e14.cellOffset += t.primitives[n3].getCABO().createVBO(o2[n3].cells, o2[n3].inRep, c, e14, t.selectionWebGLIdsToVTKIds), e14.vertexOffset += t.primitives[n3].getCABO().getElementCount()) : f ? t.primitives[n3].getCABO().createVBO(o2[n3].cells, o2[n3].inRep, Representation$3.WIREFRAME, {
          ...e14,
          tcoords: null,
          colors: null,
          haveCellScalars: false,
          haveCellNormals: false
        }) : t.primitives[n3].releaseGraphicsResources();
      t.renderable.getPopulateSelectionSettings() && t.renderable.setSelectionWebGLIdsToVTKIds(t.selectionWebGLIdsToVTKIds), t.VBOBuildString = d;
    }
    t.VBOBuildTime.modified();
  }, e12.getAllocatedGPUMemoryInBytes = () => {
    let e13 = 0;
    return t.primitives.forEach((t2) => {
      e13 += t2.getAllocatedGPUMemoryInBytes();
    }), e13;
  };
}
var DEFAULT_VALUES$41 = {
  context: null,
  VBOBuildTime: 0,
  VBOBuildString: null,
  primitives: null,
  primTypes: null,
  shaderRebuildString: null,
  tmpMat4: null,
  ambientColor: [],
  diffuseColor: [],
  specularColor: [],
  lightColor: [],
  lightDirection: [],
  lastHaveSeenDepthRequest: false,
  haveSeenDepthRequest: false,
  lastSelectionState: PassTypes$1.MIN_KNOWN_PASS - 1,
  selectionStateChanged: null,
  selectionWebGLIdsToVTKIds: null,
  pointPicking: false
};
function extend$49(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$41, n), vtkViewNode$1.extend(e12, t, n), vtkReplacementShaderMapper.implementReplaceShaderCoincidentOffset(e12, t, n), vtkReplacementShaderMapper.implementBuildShadersWithReplacements(e12, t, n), t.primitives = [], t.primTypes = primTypes$2, t.tmpMat3 = identity$3(new Float64Array(9)), t.tmpMat4 = identity$2(new Float64Array(16));
  for (let e13 = primTypes$2.Start; e13 < primTypes$2.End; e13++)
    t.primitives[e13] = vtkHelper.newInstance(), t.primitives[e13].setPrimitiveType(e13), t.primitives[e13].set({
      lastLightComplexity: 0,
      lastLightCount: 0,
      lastSelectionPass: false
    }, true);
  setGet(e12, t, ["context"]), t.VBOBuildTime = {}, obj(t.VBOBuildTime, { mtime: 0 }), t.selectionStateChanged = {}, obj(t.selectionStateChanged, { mtime: 0 }), vtkOpenGLPolyDataMapper(e12, t);
}
var newInstance$47 = newInstance(extend$49, "vtkOpenGLPolyDataMapper"), vtkOpenGLPolyDataMapper$1 = {
  newInstance: newInstance$47,
  extend: extend$49
};
registerOverride$1("vtkMapper", newInstance$47);
var { vtkErrorMacro: vtkErrorMacro$12 } = macro$1, { Representation: Representation$2 } = vtkProperty$1, { ObjectType: ObjectType$1 } = vtkBufferObject, { PassTypes } = vtkHardwareSelector, StartEvent$1 = { type: "StartEvent" }, EndEvent$1 = { type: "EndEvent" }, MAT4_BYTE_SIZE = 64, MAT4_ELEMENT_COUNT = 16;
function applyShiftScaleToMat(e12, t, n) {
  e12[12] = (e12[12] - t[0]) * n[0], e12[13] = (e12[13] - t[1]) * n[1], e12[14] = (e12[14] - t[2]) * n[2], e12[0] *= n[0], e12[5] *= n[1], e12[10] *= n[2];
}
function vtkOpenGLGlyph3DMapper(e12, t) {
  t.classHierarchy.push("vtkOpenGLGlyph3DMapper");
  let n = { ...e12 };
  e12.renderPiece = (n2, r) => {
    if (e12.invokeEvent(StartEvent$1), t.renderable.getStatic() || t.renderable.update(), t.currentInput = t.renderable.getInputData(1), e12.invokeEvent(EndEvent$1), !t.currentInput) {
      vtkErrorMacro$12("No input!");
      return;
    }
    if (!t.currentInput.getPoints || !t.currentInput.getPoints().getNumberOfValues())
      return;
    let a = t.context;
    t._openGLRenderWindow.getWebgl2() ? (t.hardwareSupport = true, t.extension = null) : t.extension || (t.extension = t.context.getExtension("ANGLE_instanced_arrays"), t.hardwareSupport = !!t.extension);
    let o = r.getProperty().getBackfaceCulling(), s = r.getProperty().getFrontfaceCulling();
    !o && !s ? t._openGLRenderWindow.disableCullFace() : s ? (t._openGLRenderWindow.enableCullFace(), a.cullFace(a.FRONT)) : (t._openGLRenderWindow.enableCullFace(), a.cullFace(a.BACK)), e12.renderPieceStart(n2, r), e12.renderPieceDraw(n2, r), e12.renderPieceFinish(n2, r);
  }, e12.multiply4x4WithOffset = (e13, t2, n2, r) => {
    let a = t2[0], o = t2[1], s = t2[2], c = t2[3], l = t2[4], u = t2[5], d = t2[6], f = t2[7], p = t2[8], m = t2[9], h = t2[10], g = t2[11], _ = t2[12], v = t2[13], y = t2[14], b = t2[15], S = n2[r], C = n2[r + 1], w = n2[r + 2], T = n2[r + 3];
    e13[0] = S * a + C * l + w * p + T * _, e13[1] = S * o + C * u + w * m + T * v, e13[2] = S * s + C * d + w * h + T * y, e13[3] = S * c + C * f + w * g + T * b, S = n2[r + 4], C = n2[r + 5], w = n2[r + 6], T = n2[r + 7], e13[4] = S * a + C * l + w * p + T * _, e13[5] = S * o + C * u + w * m + T * v, e13[6] = S * s + C * d + w * h + T * y, e13[7] = S * c + C * f + w * g + T * b, S = n2[r + 8], C = n2[r + 9], w = n2[r + 10], T = n2[r + 11], e13[8] = S * a + C * l + w * p + T * _, e13[9] = S * o + C * u + w * m + T * v, e13[10] = S * s + C * d + w * h + T * y, e13[11] = S * c + C * f + w * g + T * b, S = n2[r + 12], C = n2[r + 13], w = n2[r + 14], T = n2[r + 15], e13[12] = S * a + C * l + w * p + T * _, e13[13] = S * o + C * u + w * m + T * v, e13[14] = S * s + C * d + w * h + T * y, e13[15] = S * c + C * f + w * g + T * b;
  }, e12.replaceShaderNormal = (e13, r, a) => {
    if (t.hardwareSupport && t.lastBoundBO.getReferenceByName("lastLightComplexity") > 0) {
      let n2 = e13.Vertex;
      t.lastBoundBO.getCABO().getNormalOffset() && (n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Normal::Dec", [
        "attribute vec3 normalMC;",
        "attribute mat3 gNormal;",
        "uniform mat3 normalMatrix;",
        "varying vec3 normalVCVSOutput;"
      ]).result, n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Normal::Impl", ["normalVCVSOutput = normalMatrix * gNormal * normalMC;"]).result), e13.Vertex = n2;
    }
    n.replaceShaderNormal(e13, r, a);
  }, e12.replaceShaderClip = (e13, r, a) => {
    if (t.hardwareSupport) {
      let n2 = e13.Vertex, r2 = e13.Fragment;
      if (t.renderable.getNumberOfClippingPlanes()) {
        let e14 = t.renderable.getNumberOfClippingPlanes();
        n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Clip::Dec", [
          "uniform int numClipPlanes;",
          `uniform vec4 clipPlanes[${e14}];`,
          `varying float clipDistancesVSOutput[${e14}];`
        ]).result, n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Clip::Impl", [
          `for (int planeNum = 0; planeNum < ${e14}; planeNum++)`,
          "    {",
          "    if (planeNum >= numClipPlanes)",
          "        {",
          "        break;",
          "        }",
          "    vec4 gVertex = gMatrix * vertexMC;",
          "    clipDistancesVSOutput[planeNum] = dot(clipPlanes[planeNum], gVertex);",
          "    }"
        ]).result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::Clip::Dec", ["uniform int numClipPlanes;", `varying float clipDistancesVSOutput[${e14}];`]).result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::Clip::Impl", [
          `for (int planeNum = 0; planeNum < ${e14}; planeNum++)`,
          "    {",
          "    if (planeNum >= numClipPlanes)",
          "        {",
          "        break;",
          "        }",
          "    if (clipDistancesVSOutput[planeNum] < 0.0) discard;",
          "    }"
        ]).result;
      }
      e13.Vertex = n2, e13.Fragment = r2;
    }
    n.replaceShaderClip(e13, r, a);
  }, e12.replaceShaderColor = (e13, r, a) => {
    if (t.hardwareSupport && t.renderable.getColorArray()) {
      let n2 = e13.Vertex, r2 = e13.Geometry, a2 = e13.Fragment, o = t.lastBoundBO.getReferenceByName("lastLightComplexity"), s = [
        "uniform float ambient;",
        "uniform float diffuse;",
        "uniform float specular;",
        "uniform float opacityUniform; // the fragment opacity"
      ];
      o && (s = s.concat(["uniform vec3 specularColorUniform;", "uniform float specularPowerUniform;"]));
      let c = [
        "vec3 ambientColor;",
        "  vec3 diffuseColor;",
        "  float opacity;"
      ];
      o && (c = c.concat(["  vec3 specularColor;", "  float specularPower;"])), c = c.concat(["  opacity = opacityUniform;"]), o && (c = c.concat(["  specularColor = specularColorUniform;", "  specularPower = specularPowerUniform;"])), t.drawingEdges || (s = s.concat(["varying vec4 vertexColorVSOutput;"]), n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Color::Dec", ["attribute vec4 gColor;", "varying vec4 vertexColorVSOutput;"]).result, n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Color::Impl", ["vertexColorVSOutput = gColor;"]).result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::Color::Dec", ["in vec4 vertexColorVSOutput[];", "out vec4 vertexColorGSOutput;"]).result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::Color::Impl", ["vertexColorGSOutput = vertexColorVSOutput[i];"]).result, c = c.concat([
        "  diffuseColor = vertexColorVSOutput.rgb;",
        "  ambientColor = vertexColorVSOutput.rgb;",
        "  opacity = opacity*vertexColorVSOutput.a;"
      ])), a2 = vtkShaderProgram$1.substitute(a2, "//VTK::Color::Impl", c).result, a2 = vtkShaderProgram$1.substitute(a2, "//VTK::Color::Dec", s).result, e13.Vertex = n2, e13.Geometry = r2, e13.Fragment = a2;
    }
    n.replaceShaderColor(e13, r, a);
  }, e12.replaceShaderPositionVC = (e13, r, a) => {
    if (t.hardwareSupport) {
      let n2 = e13.Vertex;
      t.lastBoundBO.getReferenceByName("lastLightComplexity") > 0 ? (n2 = vtkShaderProgram$1.substitute(n2, "//VTK::PositionVC::Impl", [
        "vec4 gVertexMC = gMatrix * vertexMC;",
        "vertexVCVSOutput = MCVCMatrix * gVertexMC;",
        "  gl_Position = MCPCMatrix * gVertexMC;"
      ]).result, n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Camera::Dec", [
        "attribute mat4 gMatrix;",
        "uniform mat4 MCPCMatrix;",
        "uniform mat4 MCVCMatrix;"
      ]).result) : (n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Camera::Dec", ["attribute mat4 gMatrix;", "uniform mat4 MCPCMatrix;"]).result, n2 = vtkShaderProgram$1.substitute(n2, "//VTK::PositionVC::Impl", ["vec4 gVertexMC = gMatrix * vertexMC;", "  gl_Position = MCPCMatrix * gVertexMC;"]).result), e13.Vertex = n2;
    }
    n.replaceShaderPositionVC(e13, r, a);
  }, e12.replaceShaderPicking = (e13, r, a) => {
    if (t.hardwareSupport) {
      let t2 = e13.Fragment, n2 = e13.Vertex;
      n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Picking::Dec", ["attribute vec3 mapperIndexVS;", "varying vec3 mapperIndexVSOutput;"]).result, n2 = vtkShaderProgram$1.substitute(n2, "//VTK::Picking::Impl", "  mapperIndexVSOutput = mapperIndexVS;").result, e13.Vertex = n2, t2 = vtkShaderProgram$1.substitute(t2, "//VTK::Picking::Dec", [
        "varying vec3 mapperIndexVSOutput;",
        "uniform vec3 mapperIndex;",
        "uniform int picking;"
      ]).result, t2 = vtkShaderProgram$1.substitute(t2, "//VTK::Picking::Impl", ["  vec4 pickColor = picking == 2 ? vec4(mapperIndexVSOutput,1.0) : vec4(mapperIndex,1.0);", "  gl_FragData[0] = picking != 0 ? pickColor : gl_FragData[0];"]).result, e13.Fragment = t2;
    } else
      n.replaceShaderPicking(e13, r, a);
  }, e12.updateGlyphShaderParameters = (n2, r, a, o, s, c, l, u) => {
    let d = a.getProgram();
    if (n2) {
      let e13 = t.normalMatrix, n3 = c, r2 = l * 9, a2 = t.tmpMat3, o2 = e13[0], s2 = e13[1], u2 = e13[2], f = e13[3], p = e13[4], m = e13[5], h = e13[6], g = e13[7], _ = e13[8], v = n3[r2], y = n3[r2 + 1], b = n3[r2 + 2], S = n3[r2 + 3], C = n3[r2 + 4], w = n3[r2 + 5], T = n3[r2 + 6], E = n3[r2 + 7], D = n3[r2 + 8];
      a2[0] = v * o2 + y * f + b * h, a2[1] = v * s2 + y * p + b * g, a2[2] = v * u2 + y * m + b * _, a2[3] = S * o2 + C * f + w * h, a2[4] = S * s2 + C * p + w * g, a2[5] = S * u2 + C * m + w * _, a2[6] = T * o2 + E * f + D * h, a2[7] = T * s2 + E * p + D * g, a2[8] = T * u2 + E * m + D * _, d.setUniformMatrix3x3("normalMatrix", t.tmpMat3);
    }
    if (e12.multiply4x4WithOffset(t.tmpMat4, t.mcpcMatrix, s, l * 16), d.setUniformMatrix("MCPCMatrix", t.tmpMat4), r && (e12.multiply4x4WithOffset(t.tmpMat4, t.mcvcMatrix, s, l * 16), d.setUniformMatrix("MCVCMatrix", t.tmpMat4)), o) {
      let e13 = o.getData();
      t.tmpColor[0] = e13[l * 4] / 255, t.tmpColor[1] = e13[l * 4 + 1] / 255, t.tmpColor[2] = e13[l * 4 + 2] / 255, d.setUniform3fArray("ambientColorUniform", t.tmpColor), d.setUniform3fArray("diffuseColorUniform", t.tmpColor);
    }
    u && d.setUniform3fArray("mapperIndex", u.getPropColorValue());
  }, e12.renderPieceDraw = (n2, r) => {
    let a = r.getProperty().getRepresentation(), o = t.context, s = r.getProperty().getEdgeVisibility() && a === Representation$2.SURFACE, c = t.openGLCamera.getKeyMatrices(n2), l = t.openGLActor.getKeyMatrices();
    multiply$3(t.normalMatrix, c.normalMatrix, l.normalMatrix), multiply$2(t.mcpcMatrix, c.wcpc, l.mcwc), multiply$2(t.mcvcMatrix, c.wcvc, l.mcwc);
    let u = t.renderable.getMatrixArray(), d = t.renderable.getNormalArray(), f = t.renderable.getColorArray(), p = u.length / 16, m = false;
    t._openGLRenderer.getSelector() && t._openGLRenderer.getSelector().getCurrentPass() === PassTypes.COMPOSITE_INDEX_PASS && (m = true);
    for (let c2 = t.primTypes.Start; c2 < t.primTypes.End; c2++) {
      let l2 = t.primitives[c2].getCABO();
      if (l2.getElementCount()) {
        t.drawingEdges = s && (c2 === t.primTypes.TrisEdges || c2 === t.primTypes.TriStripsEdges), t.lastBoundBO = t.primitives[c2], t.primitives[c2].updateShaders(n2, r, e12);
        let h = t.primitives[c2].getProgram(), g = t.primitives[c2].getOpenGLMode(a), _ = h.isUniformUsed("normalMatrix"), v = h.isUniformUsed("MCVCMatrix");
        if (t.hardwareSupport)
          t.extension ? t.extension.drawArraysInstancedANGLE(g, 0, l2.getElementCount(), p) : o.drawArraysInstanced(g, 0, l2.getElementCount(), p);
        else
          for (let n3 = 0; n3 < p; ++n3)
            m && t._openGLRenderer.getSelector().renderCompositeIndex(n3), e12.updateGlyphShaderParameters(_, v, t.primitives[c2], f, u, d, n3, m ? t._openGLRenderer.getSelector() : null), o.drawArrays(g, 0, l2.getElementCount());
      }
    }
  }, e12.setMapperShaderParameters = (e13, r, a) => {
    if (e13.getCABO().getElementCount() && (t.glyphBOBuildTime.getMTime() > e13.getAttributeUpdateTime().getMTime() || e13.getShaderSourceTime().getMTime() > e13.getAttributeUpdateTime().getMTime())) {
      e13.getProgram().isAttributeUsed("gMatrix") ? e13.getVAO().addAttributeMatrixWithDivisor(e13.getProgram(), t.matrixBuffer, "gMatrix", 0, 64, t.context.FLOAT, 4, false, 1) || vtkErrorMacro$12("Error setting gMatrix in shader VAO.") : e13.getVAO().removeAttributeArray("gMatrix"), e13.getProgram().isAttributeUsed("gNormal") ? e13.getVAO().addAttributeMatrixWithDivisor(e13.getProgram(), t.normalBuffer, "gNormal", 0, 36, t.context.FLOAT, 3, false, 1) || vtkErrorMacro$12("Error setting gNormal in shader VAO.") : e13.getVAO().removeAttributeArray("gNormal"), e13.getProgram().isAttributeUsed("gColor") ? e13.getVAO().addAttributeArrayWithDivisor(e13.getProgram(), t.colorBuffer, "gColor", 0, 4, t.context.UNSIGNED_BYTE, 4, true, 1, false) || vtkErrorMacro$12("Error setting gColor in shader VAO.") : e13.getVAO().removeAttributeArray("gColor"), e13.getProgram().isAttributeUsed("mapperIndexVS") ? e13.getVAO().addAttributeArrayWithDivisor(e13.getProgram(), t.pickBuffer, "mapperIndexVS", 0, 4, t.context.UNSIGNED_BYTE, 4, true, 1, false) || vtkErrorMacro$12("Error setting mapperIndexVS in shader VAO.") : e13.getVAO().removeAttributeArray("mapperIndexVS"), n.setMapperShaderParameters(e13, r, a), e13.getAttributeUpdateTime().modified();
      return;
    }
    n.setMapperShaderParameters(e13, r, a);
  }, e12.getNeedToRebuildBufferObjects = (e13, r) => (t.renderable.buildArrays(), t.VBOBuildTime.getMTime() < t.renderable.getBuildTime().getMTime() ? true : n.getNeedToRebuildBufferObjects(e13, r)), e12.getNeedToRebuildShaders = (e13, r, a) => !!(n.getNeedToRebuildShaders(e13, r, a) || e13.getShaderSourceTime().getMTime() < t.renderable.getMTime() || e13.getShaderSourceTime().getMTime() < t.currentInput.getMTime()), e12.buildBufferObjects = (e13, r) => {
    let a = t.renderable.getMatrixArray(), { useShiftAndScale: o, coordShift: s, coordScale: c } = computeCoordShiftAndScale(t.renderable.getInputData(0).getPoints());
    if (t.hardwareSupport) {
      let e14 = t.renderable.getNormalArray(), n2 = t.renderable.getColorArray();
      if (t.matrixBuffer || (t.matrixBuffer = vtkBufferObject.newInstance(), t.matrixBuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.normalBuffer = vtkBufferObject.newInstance(), t.normalBuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.colorBuffer = vtkBufferObject.newInstance(), t.colorBuffer.setOpenGLRenderWindow(t._openGLRenderWindow), t.pickBuffer = vtkBufferObject.newInstance(), t.pickBuffer.setOpenGLRenderWindow(t._openGLRenderWindow)), o) {
        let e15 = a.buffer;
        for (let t2 = 0; t2 < a.byteLength; t2 += MAT4_BYTE_SIZE)
          applyShiftScaleToMat(new Float32Array(e15, t2, MAT4_ELEMENT_COUNT), s, c);
      }
      if (t.renderable.getBuildTime().getMTime() > t.glyphBOBuildTime.getMTime()) {
        t.matrixBuffer.upload(a, ObjectType$1.ARRAY_BUFFER), t.normalBuffer.upload(e14, ObjectType$1.ARRAY_BUFFER), n2 ? t.colorBuffer.upload(n2.getData(), ObjectType$1.ARRAY_BUFFER) : t.colorBuffer.releaseGraphicsResources();
        let r2 = a.length / 16, o2 = new Uint8Array(4 * r2);
        for (let e15 = 0; e15 < r2; ++e15) {
          let t2 = e15 + 1, n3 = e15 * 4;
          o2[n3] = t2 % 256, t2 -= o2[n3], t2 /= 256, o2[n3 + 1] = t2 % 256, t2 -= o2[n3 + 1], t2 /= 256, o2[n3 + 2] = t2 % 256, o2[n3 + 3] = 255;
        }
        t.pickBuffer.upload(o2, ObjectType$1.ARRAY_BUFFER), t.glyphBOBuildTime.modified();
      }
    }
    if (n.buildBufferObjects(e13, r), o)
      for (let e14 = primTypes$1.Start; e14 < primTypes$1.End; e14++)
        t.primitives[e14].getCABO().setCoordShiftAndScale(s, c);
  };
}
var DEFAULT_VALUES$40 = {
  normalMatrix: null,
  mcpcMatrix: null,
  mcwcMatrix: null
};
function extend$48(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$40, n), vtkOpenGLPolyDataMapper$1.extend(e12, t, n), t.tmpMat3 = identity$3(new Float64Array(9)), t.normalMatrix = identity$3(new Float64Array(9)), t.mcpcMatrix = identity$2(new Float64Array(16)), t.mcvcMatrix = identity$2(new Float64Array(16)), t.tmpColor = [], t.glyphBOBuildTime = {}, obj(t.glyphBOBuildTime, { mtime: 0 }), vtkOpenGLGlyph3DMapper(e12, t);
}
var newInstance$46 = newInstance(extend$48, "vtkOpenGLGlyph3DMapper"), vtkGlyph3DMapper = {
  newInstance: newInstance$46,
  extend: extend$48
};
registerOverride$1("vtkGlyph3DMapper", newInstance$46);
var { vtkErrorMacro: vtkErrorMacro$11 } = macro$1;
function vtkOpenGLSkybox(e12, t) {
  t.classHierarchy.push("vtkOpenGLSkybox"), e12.buildPass = (n) => {
    if (n) {
      t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.context = t._openGLRenderWindow.getContext(), t.tris.setOpenGLRenderWindow(t._openGLRenderWindow), t.openGLTexture.setOpenGLRenderWindow(t._openGLRenderWindow);
      let n2 = t._openGLRenderer.getRenderable();
      t.openGLCamera = t._openGLRenderer.getViewNodeFor(n2.getActiveCamera());
    }
  }, e12.queryPass = (e13, n) => {
    if (e13) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      n.incrementOpaqueActorCount();
    }
  }, e12.opaquePass = (n, r) => {
    if (n && !t._openGLRenderer.getSelector()) {
      e12.updateBufferObjects(), t.context.depthMask(true), t._openGLRenderWindow.getShaderCache().readyShaderProgram(t.tris.getProgram()), t.openGLTexture.render(t._openGLRenderWindow);
      let n2 = t.openGLTexture.getTextureUnit();
      t.tris.getProgram().setUniformi("sbtexture", n2);
      let r2 = t._openGLRenderer.getRenderable(), a = t.openGLCamera.getKeyMatrices(r2), o = new Float64Array(16);
      if (invert(o, a.wcpc), t.tris.getProgram().setUniformMatrix("IMCPCMatrix", o), t.lastFormat === "box") {
        let e13 = r2.getActiveCamera().getPosition();
        t.tris.getProgram().setUniform3f("camPos", e13[0], e13[1], e13[2]);
      }
      t.tris.getVAO().bind(), t.context.drawArrays(t.context.TRIANGLES, 0, t.tris.getCABO().getElementCount()), t.tris.getVAO().release(), t.openGLTexture.deactivate();
    }
  }, e12.updateBufferObjects = () => {
    if (!t.tris.getCABO().getElementCount()) {
      let e14 = new Float32Array(12);
      for (let t2 = 0; t2 < 4; t2++)
        e14[t2 * 3] = t2 % 2 * 2 - 1, e14[t2 * 3 + 1] = t2 > 1 ? 1 : -1, e14[t2 * 3 + 2] = 1;
      let n = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        values: e14
      });
      n.setName("points");
      let r = new Uint16Array(8);
      r[0] = 3, r[1] = 0, r[2] = 1, r[3] = 3, r[4] = 3, r[5] = 0, r[6] = 3, r[7] = 2;
      let a = vtkDataArray$1.newInstance({
        numberOfComponents: 1,
        values: r
      });
      t.tris.getCABO().createVBO(a, "polys", Representation$1.SURFACE, {
        points: n,
        cellOffset: 0
      });
    }
    t.renderable.getFormat() !== t.lastFormat && (t.lastFormat = t.renderable.getFormat(), t.lastFormat === "box" && t.tris.setProgram(t._openGLRenderWindow.getShaderCache().readyShaderProgramArray("//VTK::System::Dec\n             attribute vec3 vertexMC;\n             uniform mat4 IMCPCMatrix;\n             varying vec3 TexCoords;\n             void main () {\n              gl_Position = vec4(vertexMC.xyz, 1.0);\n              vec4 wpos = IMCPCMatrix * gl_Position;\n              TexCoords = wpos.xyz/wpos.w;\n             }", "//VTK::System::Dec\n             //VTK::Output::Dec\n             varying vec3 TexCoords;\n             uniform samplerCube sbtexture;\n             uniform vec3 camPos;\n             void main () {\n               // skybox looks from inside out\n               // which means we have to adjust\n               // our tcoords. Otherwise text would\n               // be flipped\n               vec3 tc = normalize(TexCoords - camPos);\n               if (abs(tc.z) < max(abs(tc.x),abs(tc.y)))\n               {\n                 tc = vec3(1.0, 1.0, -1.0) * tc;\n               }\n               else\n               {\n                 tc = vec3(-1.0, 1.0, 1.0) * tc;\n               }\n               gl_FragData[0] = textureCube(sbtexture, tc);\n             }", "")), t.lastFormat === "background" && t.tris.setProgram(t._openGLRenderWindow.getShaderCache().readyShaderProgramArray("//VTK::System::Dec\n             attribute vec3 vertexMC;\n             uniform mat4 IMCPCMatrix;\n             varying vec2 TexCoords;\n             void main () {\n              gl_Position = vec4(vertexMC.xyz, 1.0);\n              vec4 wpos = IMCPCMatrix * gl_Position;\n              TexCoords = vec2(vertexMC.x, vertexMC.y)*0.5 + 0.5;\n             }", "//VTK::System::Dec\n             //VTK::Output::Dec\n             varying vec2 TexCoords;\n             uniform sampler2D sbtexture;\n             void main () {\n               gl_FragData[0] = texture2D(sbtexture, TexCoords);\n             }", "")), t.tris.getShaderSourceTime().modified(), t.tris.getVAO().bind(), t.tris.getVAO().addAttributeArray(t.tris.getProgram(), t.tris.getCABO(), "vertexMC", t.tris.getCABO().getVertexOffset(), t.tris.getCABO().getStride(), t.context.FLOAT, 3, t.context.FALSE) || vtkErrorMacro$11("Error setting vertexMC in shader VAO."));
    let e13 = t.renderable.getTextures();
    e13.length || vtkErrorMacro$11("vtkSkybox requires a texture map"), t.openGLTexture.getRenderable() !== e13[0] && (t.openGLTexture.releaseGraphicsResources(t._openGLRenderWindow), t.openGLTexture.setRenderable(e13[0]));
  };
}
var DEFAULT_VALUES$39 = { context: null };
function extend$47(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$39, n), vtkViewNode$1.extend(e12, t, n), t.openGLTexture = vtkOpenGLTexture$1.newInstance(), t.tris = vtkHelper.newInstance(), t.keyMatrixTime = {}, obj(t.keyMatrixTime, { mtime: 0 }), t.keyMatrices = {
    normalMatrix: identity$3(new Float64Array(9)),
    mcwc: identity$2(new Float64Array(16))
  }, setGet(e12, t, ["context"]), get(e12, t, ["activeTextures"]), vtkOpenGLSkybox(e12, t);
}
var newInstance$45 = newInstance(extend$47), vtkSkybox = {
  newInstance: newInstance$45,
  extend: extend$47
};
registerOverride$1("vtkSkybox", newInstance$45);
var vtkSphereMapperVS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkSphereMapperVS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n// this shader implements imposters in OpenGL for Spheres\n\nattribute vec4 vertexMC;\nattribute vec2 offsetMC;\n\n// optional normal declaration\n//VTK::Normal::Dec\n\n//VTK::Picking::Dec\n\n// Texture coordinates\n//VTK::TCoord::Dec\n\nuniform mat3 normalMatrix; // transform model coordinate directions to view coordinates\n\n// material property values\n//VTK::Color::Dec\n\n// clipping plane vars\n//VTK::Clip::Dec\n\n// camera and actor matrix values\n//VTK::Camera::Dec\n\nvarying vec4 vertexVCVSOutput;\nvarying float radiusVCVSOutput;\nvarying vec3 centerVCVSOutput;\n\nuniform int cameraParallel;\nuniform float scaleFactor;\n\nvoid main()\n{\n  //VTK::Picking::Impl\n\n  //VTK::Color::Impl\n\n  //VTK::Normal::Impl\n\n  //VTK::TCoord::Impl\n\n  //VTK::Clip::Impl\n\n  // compute the projected vertex position\n  vec2 scaledOffsetMC = scaleFactor * offsetMC;\n  vertexVCVSOutput = MCVCMatrix * vertexMC;\n  centerVCVSOutput = vertexVCVSOutput.xyz;\n  radiusVCVSOutput = length(scaledOffsetMC)*0.5;\n\n  // make the triangle face the camera\n  if (cameraParallel == 0)\n    {\n    vec3 dir = normalize(-vertexVCVSOutput.xyz);\n    vec3 base2 = normalize(cross(dir,vec3(1.0,0.0,0.0)));\n    vec3 base1 = cross(base2,dir);\n    vertexVCVSOutput.xyz = vertexVCVSOutput.xyz + scaledOffsetMC.x*base1 + scaledOffsetMC.y*base2;\n    }\n  else\n    {\n    // add in the offset\n    vertexVCVSOutput.xy = vertexVCVSOutput.xy + scaledOffsetMC;\n    }\n\n  gl_Position = VCPCMatrix * vertexVCVSOutput;\n}\n", { vtkErrorMacro: vtkErrorMacro$10 } = macro$1;
function vtkOpenGLSphereMapper(e12, t) {
  t.classHierarchy.push("vtkOpenGLSphereMapper");
  let n = { ...e12 };
  e12.getShaderTemplate = (e13, t2, n2) => {
    e13.Vertex = vtkSphereMapperVS, e13.Fragment = vtkPolyDataFS, e13.Geometry = "";
  }, e12.replaceShaderValues = (e13, r, a) => {
    let o = e13.Vertex, s = e13.Fragment;
    o = vtkShaderProgram$1.substitute(o, "//VTK::Camera::Dec", ["uniform mat4 VCPCMatrix;\n", "uniform mat4 MCVCMatrix;"]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::PositionVC::Dec", ["varying vec4 vertexVCVSOutput;"]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::PositionVC::Impl", ["vec4 vertexVC = vertexVCVSOutput;\n"]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::Normal::Dec", [
      "uniform float invertedDepth;\n",
      "uniform int cameraParallel;\n",
      "varying float radiusVCVSOutput;\n",
      "varying vec3 centerVCVSOutput;\n",
      "uniform mat4 VCPCMatrix;\n"
    ]).result;
    let c = "";
    t.context.getExtension("EXT_frag_depth") && (c = "gl_FragDepthEXT = (pos.z / pos.w + 1.0) / 2.0;\n"), t._openGLRenderWindow.getWebgl2() && (c = "gl_FragDepth = (pos.z / pos.w + 1.0) / 2.0;\n"), s = vtkShaderProgram$1.substitute(s, "//VTK::Depth::Impl", [
      "  vec3 EyePos;\n",
      "  vec3 EyeDir;\n",
      "  if (cameraParallel != 0) {\n",
      "    EyePos = vec3(vertexVC.x, vertexVC.y, vertexVC.z + 3.0*radiusVCVSOutput);\n",
      "    EyeDir = vec3(0.0,0.0,-1.0); }\n",
      "  else {\n",
      "    EyeDir = vertexVC.xyz;\n",
      "    EyePos = vec3(0.0,0.0,0.0);\n",
      "    float lengthED = length(EyeDir);\n",
      "    EyeDir = normalize(EyeDir);\n",
      "    if (lengthED > radiusVCVSOutput*3.0) {\n",
      "      EyePos = vertexVC.xyz - EyeDir*3.0*radiusVCVSOutput; }\n",
      "    }\n",
      "  EyePos = EyePos - centerVCVSOutput;\n",
      "  EyePos = EyePos/radiusVCVSOutput;\n",
      "  float b = 2.0*dot(EyePos,EyeDir);\n",
      "  float c = dot(EyePos,EyePos) - 1.0;\n",
      "  float d = b*b - 4.0*c;\n",
      "  vec3 normalVCVSOutput = vec3(0.0,0.0,1.0);\n",
      "  if (d < 0.0) { discard; }\n",
      "  else {\n",
      "    float t = (-b - invertedDepth*sqrt(d))*0.5;\n",
      "    normalVCVSOutput = invertedDepth*normalize(EyePos + t*EyeDir);\n",
      "    vertexVC.xyz = normalVCVSOutput*radiusVCVSOutput + centerVCVSOutput;\n",
      "    }\n",
      "  vec4 pos = VCPCMatrix * vertexVC;\n",
      c
    ]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::Normal::Impl", "").result, t.haveSeenDepthRequest && (s = vtkShaderProgram$1.substitute(s, "//VTK::ZBuffer::Impl", [
      "if (depthRequest == 1) {",
      "float computedZ = (pos.z / pos.w + 1.0) / 2.0;",
      "float iz = floor(computedZ * 65535.0 + 0.1);",
      "float rf = floor(iz/256.0)/255.0;",
      "float gf = mod(iz,256.0)/255.0;",
      "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"
    ]).result), e13.Vertex = o, e13.Fragment = s, n.replaceShaderValues(e13, r, a);
  }, e12.setMapperShaderParameters = (e13, r, a) => {
    if (e13.getCABO().getElementCount() && (t.VBOBuildTime > e13.getAttributeUpdateTime().getMTime() || e13.getShaderSourceTime().getMTime() > e13.getAttributeUpdateTime().getMTime()) && e13.getProgram().isAttributeUsed("offsetMC") && (e13.getVAO().addAttributeArray(e13.getProgram(), e13.getCABO(), "offsetMC", 12, e13.getCABO().getStride(), t.context.FLOAT, 2, false) || vtkErrorMacro$10("Error setting 'offsetMC' in shader VAO.")), e13.getProgram().isUniformUsed("invertedDepth") && e13.getProgram().setUniformf("invertedDepth", t.invert ? -1 : 1), e13.getProgram().isUniformUsed("scaleFactor")) {
      let n2 = t.currentInput.getPointData();
      t.renderable.getScaleArray() != null && n2.hasArray(t.renderable.getScaleArray()) ? e13.getProgram().setUniformf("scaleFactor", t.renderable.getScaleFactor()) : e13.getProgram().setUniformf("scaleFactor", 1);
    }
    n.setMapperShaderParameters(e13, r, a);
  }, e12.setCameraShaderParameters = (e13, n2, r) => {
    let a = e13.getProgram(), o = n2.getActiveCamera(), s = t.openGLCamera.getKeyMatrices(n2);
    a.isUniformUsed("VCPCMatrix") && a.setUniformMatrix("VCPCMatrix", s.vcpc);
    let c = new Float64Array(16);
    if (a.isUniformUsed("MCVCMatrix"))
      if (r.getIsIdentity())
        copy$4(c, s.wcvc), e13.getCABO().getCoordShiftAndScaleEnabled() && multiply$2(c, c, e13.getCABO().getInverseShiftAndScaleMatrix()), a.setUniformMatrix("MCVCMatrix", c);
      else {
        let n3 = t.openGLActor.getKeyMatrices();
        multiply$2(c, s.wcvc, n3.mcwc), e13.getCABO().getCoordShiftAndScaleEnabled() && multiply$2(c, c, e13.getCABO().getInverseShiftAndScaleMatrix()), a.setUniformMatrix("MCVCMatrix", c);
      }
    a.isUniformUsed("cameraParallel") && e13.getProgram().setUniformi("cameraParallel", o.getParallelProjection());
  }, e12.getOpenGLMode = (e13, n2) => t.context.TRIANGLES, e12.buildBufferObjects = (e13, n2) => {
    let r = t.currentInput;
    if (r === null)
      return;
    t.renderable.mapScalars(r, 1);
    let a = t.renderable.getColorMapColors(), o = t.primitives[t.primTypes.Tris].getCABO(), s = r.getPointData(), c = r.getPoints(), l = c.getNumberOfPoints(), u = c.getData(), d = null;
    t.renderable.getScaleArray() != null && s.hasArray(t.renderable.getScaleArray()) && (d = s.getArray(t.renderable.getScaleArray()).getData());
    let f = null, p = 0, m = null;
    a ? (p = a.getNumberOfComponents(), o.setColorOffset(0), o.setColorBOStride(4), f = a.getData(), m = new Uint8Array(3 * l * 4), o.getColorBO() || o.setColorBO(vtkBufferObject.newInstance()), o.getColorBO().setOpenGLRenderWindow(t._openGLRenderWindow)) : o.getColorBO() && o.setColorBO(null), o.setColorComponents(p);
    let h = new Float32Array(5 * l * 3);
    o.setStride(20);
    let g = Math.cos(radiansFromDegrees(30)), _ = 0, v = 0, { useShiftAndScale: y, coordShift: b, coordScale: S } = computeCoordShiftAndScale(c);
    y && o.setCoordShiftAndScale(b, S);
    let C = 0, w = 0;
    for (let e14 = 0; e14 < l; ++e14) {
      let n3 = t.renderable.getRadius();
      d && (n3 = d[e14]), _ = e14 * 3;
      let r2 = (u[_++] - b[0]) * S[0], a2 = (u[_++] - b[1]) * S[1], o2 = (u[_++] - b[2]) * S[2];
      h[C++] = r2, h[C++] = a2, h[C++] = o2, h[C++] = -2 * n3 * g, h[C++] = -n3, f && (v = e14 * p, m[w++] = f[v], m[w++] = f[v + 1], m[w++] = f[v + 2], m[w++] = f[v + 3]), h[C++] = r2, h[C++] = a2, h[C++] = o2, h[C++] = 2 * n3 * g, h[C++] = -n3, f && (m[w++] = f[v], m[w++] = f[v + 1], m[w++] = f[v + 2], m[w++] = f[v + 3]), h[C++] = r2, h[C++] = a2, h[C++] = o2, h[C++] = 0, h[C++] = 2 * n3, f && (m[w++] = f[v], m[w++] = f[v + 1], m[w++] = f[v + 2], m[w++] = f[v + 3]);
    }
    o.setElementCount(C / 5), o.upload(h, ObjectType.ARRAY_BUFFER), a && o.getColorBO().upload(m, ObjectType.ARRAY_BUFFER), t.VBOBuildTime.modified();
  };
}
var DEFAULT_VALUES$38 = {};
function extend$46(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$38, n), vtkOpenGLPolyDataMapper$1.extend(e12, t, n), vtkOpenGLSphereMapper(e12, t);
}
var newInstance$44 = newInstance(extend$46, "vtkOpenGLSphereMapper"), vtkSphereMapper = {
  newInstance: newInstance$44,
  extend: extend$46
};
registerOverride$1("vtkSphereMapper", newInstance$44);
var vtkStickMapperVS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkStickMapperVS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n// this shader implements imposters in OpenGL for Sticks\n\nattribute vec4 vertexMC;\nattribute vec3 orientMC;\nattribute vec4 offsetMC;\nattribute float radiusMC;\n\n// optional normal declaration\n//VTK::Normal::Dec\n\n//VTK::Picking::Dec\n\n// Texture coordinates\n//VTK::TCoord::Dec\n\nuniform mat3 normalMatrix; // transform model coordinate directions to view coordinates\n\n// material property values\n//VTK::Color::Dec\n\n// clipping plane vars\n//VTK::Clip::Dec\n\n// camera and actor matrix values\n//VTK::Camera::Dec\n\nvarying vec4 vertexVCVSOutput;\nvarying float radiusVCVSOutput;\nvarying float lengthVCVSOutput;\nvarying vec3 centerVCVSOutput;\nvarying vec3 orientVCVSOutput;\n\nuniform int cameraParallel;\n\nvoid main()\n{\n  //VTK::Picking::Impl\n\n  //VTK::Color::Impl\n\n  //VTK::Normal::Impl\n\n  //VTK::TCoord::Impl\n\n  //VTK::Clip::Impl\n\n  vertexVCVSOutput = MCVCMatrix * vertexMC;\n  centerVCVSOutput = vertexVCVSOutput.xyz;\n  radiusVCVSOutput = radiusMC;\n  lengthVCVSOutput = length(orientMC);\n  orientVCVSOutput = normalMatrix * normalize(orientMC);\n\n  // make sure it is pointing out of the screen\n  if (orientVCVSOutput.z < 0.0)\n    {\n    orientVCVSOutput = -orientVCVSOutput;\n    }\n\n  // make the basis\n  vec3 xbase;\n  vec3 ybase;\n  vec3 dir = vec3(0.0,0.0,1.0);\n  if (cameraParallel == 0)\n    {\n    dir = normalize(-vertexVCVSOutput.xyz);\n    }\n  if (abs(dot(dir,orientVCVSOutput)) == 1.0)\n    {\n    xbase = normalize(cross(vec3(0.0,1.0,0.0),orientVCVSOutput));\n    ybase = cross(xbase,orientVCVSOutput);\n    }\n  else\n    {\n    xbase = normalize(cross(orientVCVSOutput,dir));\n    ybase = cross(orientVCVSOutput,xbase);\n    }\n\n  vec3 offsets = offsetMC.xyz*2.0-1.0;\n  vertexVCVSOutput.xyz = vertexVCVSOutput.xyz +\n    radiusVCVSOutput*offsets.x*xbase +\n    radiusVCVSOutput*offsets.y*ybase +\n    0.5*lengthVCVSOutput*offsets.z*orientVCVSOutput;\n\n  gl_Position = VCPCMatrix * vertexVCVSOutput;\n}\n", { vtkErrorMacro: vtkErrorMacro$9 } = macro$1;
function vtkOpenGLStickMapper(e12, t) {
  t.classHierarchy.push("vtkOpenGLStickMapper");
  let n = { ...e12 };
  e12.getShaderTemplate = (e13, t2, n2) => {
    e13.Vertex = vtkStickMapperVS, e13.Fragment = vtkPolyDataFS, e13.Geometry = "";
  }, e12.replaceShaderValues = (e13, r, a) => {
    let o = e13.Vertex, s = e13.Fragment;
    o = vtkShaderProgram$1.substitute(o, "//VTK::Camera::Dec", ["uniform mat4 VCPCMatrix;\n", "uniform mat4 MCVCMatrix;"]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::PositionVC::Dec", "varying vec4 vertexVCVSOutput;").result, s = vtkShaderProgram$1.substitute(s, "//VTK::PositionVC::Impl", "  vec4 vertexVC = vertexVCVSOutput;\n").result, s = vtkShaderProgram$1.substitute(s, "//VTK::Normal::Dec", [
      "uniform int cameraParallel;\n",
      "varying float radiusVCVSOutput;\n",
      "varying vec3 orientVCVSOutput;\n",
      "varying float lengthVCVSOutput;\n",
      "varying vec3 centerVCVSOutput;\n",
      "uniform mat4 VCPCMatrix;\n"
    ]).result;
    let c = "";
    t.context.getExtension("EXT_frag_depth") && (c = "  gl_FragDepthEXT = (pos.z / pos.w + 1.0) / 2.0;\n"), t._openGLRenderWindow.getWebgl2() && (c = "gl_FragDepth = (pos.z / pos.w + 1.0) / 2.0;\n"), s = vtkShaderProgram$1.substitute(s, "//VTK::Depth::Impl", [
      "  vec3 EyePos;\n",
      "  vec3 EyeDir;\n",
      "  if (cameraParallel != 0) {\n",
      "    EyePos = vec3(vertexVC.x, vertexVC.y, vertexVC.z + 3.0*radiusVCVSOutput);\n",
      "    EyeDir = vec3(0.0,0.0,-1.0); }\n",
      "  else {\n",
      "    EyeDir = vertexVC.xyz;\n",
      "    EyePos = vec3(0.0,0.0,0.0);\n",
      "    float lengthED = length(EyeDir);\n",
      "    EyeDir = normalize(EyeDir);\n",
      "    if (lengthED > radiusVCVSOutput*3.0) {\n",
      "      EyePos = vertexVC.xyz - EyeDir*3.0*radiusVCVSOutput; }\n",
      "    }\n",
      "  EyePos = EyePos - centerVCVSOutput;\n",
      "  vec3 base1;\n",
      "  if (abs(orientVCVSOutput.z) < 0.99) {\n",
      "    base1 = normalize(cross(orientVCVSOutput,vec3(0.0,0.0,1.0))); }\n",
      "  else {\n",
      "    base1 = normalize(cross(orientVCVSOutput,vec3(0.0,1.0,0.0))); }\n",
      "  vec3 base2 = cross(orientVCVSOutput,base1);\n",
      "  EyePos = vec3(dot(EyePos,base1),dot(EyePos,base2),dot(EyePos,orientVCVSOutput));\n",
      "  EyeDir = vec3(dot(EyeDir,base1),dot(EyeDir,base2),dot(EyeDir,orientVCVSOutput));\n",
      "  EyePos = EyePos/radiusVCVSOutput;\n",
      "  float a = EyeDir.x*EyeDir.x + EyeDir.y*EyeDir.y;\n",
      "  float b = 2.0*(EyePos.x*EyeDir.x + EyePos.y*EyeDir.y);\n",
      "  float c = EyePos.x*EyePos.x + EyePos.y*EyePos.y - 1.0;\n",
      "  float d = b*b - 4.0*a*c;\n",
      "  vec3 normalVCVSOutput = vec3(0.0,0.0,1.0);\n",
      "  if (d < 0.0) { discard; }\n",
      "  else {\n",
      "    float t =  (-b - sqrt(d))/(2.0*a);\n",
      "    float tz = EyePos.z + t*EyeDir.z;\n",
      "    vec3 iPoint = EyePos + t*EyeDir;\n",
      "    if (abs(iPoint.z)*radiusVCVSOutput > lengthVCVSOutput*0.5) {\n",
      "      float t2 = (-b + sqrt(d))/(2.0*a);\n",
      "      float tz2 = EyePos.z + t2*EyeDir.z;\n",
      "      if (tz2*radiusVCVSOutput > lengthVCVSOutput*0.5 || tz*radiusVCVSOutput < -0.5*lengthVCVSOutput) { discard; }\n",
      "      else {\n",
      "        normalVCVSOutput = orientVCVSOutput;\n",
      "        float t3 = (lengthVCVSOutput*0.5/radiusVCVSOutput - EyePos.z)/EyeDir.z;\n",
      "        iPoint = EyePos + t3*EyeDir;\n",
      "        vertexVC.xyz = radiusVCVSOutput*(iPoint.x*base1 + iPoint.y*base2 + iPoint.z*orientVCVSOutput) + centerVCVSOutput;\n",
      "        }\n",
      "      }\n",
      "    else {\n",
      "      normalVCVSOutput = iPoint.x*base1 + iPoint.y*base2;\n",
      "      vertexVC.xyz = radiusVCVSOutput*(normalVCVSOutput + iPoint.z*orientVCVSOutput) + centerVCVSOutput;\n",
      "      }\n",
      "    }\n",
      "  vec4 pos = VCPCMatrix * vertexVC;\n",
      c
    ]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::Normal::Impl", "").result, t.haveSeenDepthRequest && (s = vtkShaderProgram$1.substitute(s, "//VTK::ZBuffer::Impl", [
      "if (depthRequest == 1) {",
      "float computedZ = (pos.z / pos.w + 1.0) / 2.0;",
      "float iz = floor(computedZ * 65535.0 + 0.1);",
      "float rf = floor(iz/256.0)/255.0;",
      "float gf = mod(iz,256.0)/255.0;",
      "gl_FragData[0] = vec4(rf, gf, 0.0, 1.0); }"
    ]).result), e13.Vertex = o, e13.Fragment = s, n.replaceShaderValues(e13, r, a);
  }, e12.setMapperShaderParameters = (e13, r, a) => {
    e13.getCABO().getElementCount() && (t.VBOBuildTime > e13.getAttributeUpdateTime().getMTime() || e13.getShaderSourceTime().getMTime() > e13.getAttributeUpdateTime().getMTime()) && (e13.getProgram().isAttributeUsed("orientMC") && (e13.getVAO().addAttributeArray(e13.getProgram(), e13.getCABO(), "orientMC", 12, e13.getCABO().getStride(), t.context.FLOAT, 3, false) || vtkErrorMacro$9("Error setting 'orientMC' in shader VAO.")), e13.getProgram().isAttributeUsed("offsetMC") && (e13.getVAO().addAttributeArray(e13.getProgram(), e13.getCABO().getColorBO(), "offsetMC", 0, e13.getCABO().getColorBOStride(), t.context.UNSIGNED_BYTE, 3, true) || vtkErrorMacro$9("Error setting 'offsetMC' in shader VAO.")), e13.getProgram().isAttributeUsed("radiusMC") && (e13.getVAO().addAttributeArray(e13.getProgram(), e13.getCABO(), "radiusMC", 24, e13.getCABO().getStride(), t.context.FLOAT, 1, false) || vtkErrorMacro$9("Error setting 'radiusMC' in shader VAO."))), n.setMapperShaderParameters(e13, r, a);
  }, e12.setCameraShaderParameters = (e13, n2, r) => {
    let a = e13.getProgram(), o = n2.getActiveCamera(), s = t.openGLCamera.getKeyMatrices(n2);
    if (a.isUniformUsed("VCPCMatrix") && a.setUniformMatrix("VCPCMatrix", s.vcpc), r.getIsIdentity())
      a.isUniformUsed("MCVCMatrix") && a.setUniformMatrix("MCVCMatrix", s.wcvc), a.isUniformUsed("normalMatrix") && a.setUniformMatrix3x3("normalMatrix", s.normalMatrix);
    else {
      let e14 = t.openGLActor.getKeyMatrices();
      if (a.isUniformUsed("MCVCMatrix")) {
        let t2 = new Float64Array(16);
        multiply$2(t2, s.wcvc, e14.mcwc), a.setUniformMatrix("MCVCMatrix", t2);
      }
      if (a.isUniformUsed("normalMatrix")) {
        let t2 = new Float64Array(9);
        multiply$3(t2, s.normalMatrix, e14.normalMatrix), a.setUniformMatrix3x3("normalMatrix", t2);
      }
    }
    a.isUniformUsed("cameraParallel") && e13.getProgram().setUniformi("cameraParallel", o.getParallelProjection());
  }, e12.getOpenGLMode = (e13, n2) => t.context.TRIANGLES, e12.buildBufferObjects = (e13, n2) => {
    let r = t.currentInput;
    if (r === null)
      return;
    t.renderable.mapScalars(r, 1);
    let a = t.renderable.getColorMapColors(), o = t.primitives[t.primTypes.Tris].getCABO(), s = r.getPointData(), c = r.getPoints(), l = c.getNumberOfPoints(), u = c.getData(), d = 3;
    d += 4;
    let f = null, p = 0;
    o.setColorBOStride(4), o.getColorBO() || o.setColorBO(vtkBufferObject.newInstance()), o.getColorBO().setOpenGLRenderWindow(t._openGLRenderWindow), a && (p = a.getNumberOfComponents(), o.setColorOffset(4), f = a.getData(), o.setColorBOStride(8)), o.setColorComponents(p), o.setStride(d * 4);
    let m = new Float32Array(d * l * 12), h = new Uint8Array(12 * l * (f ? 8 : 4)), g = null, _ = null;
    t.renderable.getScaleArray() != null && s.hasArray(t.renderable.getScaleArray()) && (g = s.getArray(t.renderable.getScaleArray()).getData()), t.renderable.getOrientationArray() != null && s.hasArray(t.renderable.getOrientationArray()) ? _ = s.getArray(t.renderable.getOrientationArray()).getData() : vtkErrorMacro$9(["Error setting orientationArray.\n", "You have to specify the stick orientation"]);
    let v = [
      0,
      1,
      3,
      0,
      3,
      2,
      2,
      3,
      5,
      2,
      5,
      4
    ], y = 0, b = 0, S = 0, C = 0;
    for (let e14 = 0; e14 < l; ++e14) {
      let n3 = t.renderable.getLength(), r2 = t.renderable.getRadius();
      g && (n3 = g[e14 * 2], r2 = g[e14 * 2 + 1]);
      for (let t2 = 0; t2 < v.length; ++t2)
        y = e14 * 3, m[S++] = u[y++], m[S++] = u[y++], m[S++] = u[y++], y = e14 * 3, m[S++] = _[y++] * n3, m[S++] = _[y++] * n3, m[S++] = _[y++] * n3, m[S++] = r2, h[C++] = 255 * (v[t2] % 2), h[C++] = v[t2] >= 4 ? 255 : 0, h[C++] = v[t2] >= 2 ? 255 : 0, h[C++] = 255, b = e14 * p, f && (h[C++] = f[b], h[C++] = f[b + 1], h[C++] = f[b + 2], h[C++] = f[b + 3]);
    }
    o.setElementCount(S / d), o.upload(m, ObjectType.ARRAY_BUFFER), o.getColorBO().upload(h, ObjectType.ARRAY_BUFFER), t.VBOBuildTime.modified();
  };
}
var DEFAULT_VALUES$37 = {};
function extend$45(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$37, n), vtkOpenGLPolyDataMapper$1.extend(e12, t, n), vtkOpenGLStickMapper(e12, t);
}
var newInstance$43 = newInstance(extend$45, "vtkOpenGLStickMapper"), vtkStickMapper = {
  newInstance: newInstance$43,
  extend: extend$45
};
registerOverride$1("vtkStickMapper", newInstance$43);
function vtkStreamingOpenGLVolumeMapper(e12, t) {
  t.classHierarchy.push("vtkStreamingOpenGLVolumeMapper");
  let n = /* @__PURE__ */ new Map();
  function r(t2, r2) {
    if (!r2)
      return;
    let a2 = (n.get(r2) ?? 0) - 1;
    a2 <= 0 ? (t2.unregisterGraphicsResourceUser(r2, e12), n.delete(r2)) : n.set(r2, a2);
  }
  function a(t2, r2) {
    if (!r2)
      return;
    let a2 = n.get(r2) ?? 0, o2 = a2 + 1;
    n.set(r2, o2), a2 <= 0 && t2.registerGraphicsResourceUser(r2, e12);
  }
  function o(e13, t2, n2) {
    t2 !== n2 && (r(e13, t2), a(e13, n2));
  }
  e12.renderPiece = (n2, r2) => {
    e12.invokeEvent({ type: "StartEvent" }), t.renderable.update();
    let a2 = t.renderable.getNumberOfInputPorts();
    t.currentValidInputs = [];
    for (let e13 = 0; e13 < a2; ++e13) {
      let n3 = t.renderable.getInputData(e13);
      n3 && !n3.isDeleted() && t.currentValidInputs.push({
        imageData: n3,
        inputIndex: e13
      });
    }
    let o2 = 0;
    if (t.currentValidInputs.length > 0) {
      let e13 = r2.getProperties(), a3 = t.currentValidInputs[0], s2 = a3.imageData, c = e13[a3.inputIndex];
      c.getShade() && t.renderable.getBlendMode() === BlendMode$1.COMPOSITE_BLEND && n2.getLights().forEach((e14) => {
        e14.getSwitch() > 0 && o2++;
      });
      let l = t.currentValidInputs.length, u = l > 1, { numberOfComponents: d } = s2.get("numberOfComponents");
      t.numberOfComponents = u ? l : d, t.numberOfComponents > 1 ? t.useIndependentComponents = c.getIndependentComponents() : t.useIndependentComponents = false;
    }
    o2 !== t.numberOfLights && (t.numberOfLights = o2, e12.modified()), e12.invokeEvent({ type: "EndEvent" }), t.currentValidInputs.length !== 0 && (e12.renderPieceStart(n2, r2), e12.renderPieceDraw(n2, r2), e12.renderPieceFinish(n2, r2));
  };
  let s = e12.renderPieceStart;
  e12.renderPieceStart = (e13, n2) => {
    s(e13, n2), t._openGLRenderWindow?.getWebgl2?.() && t.context?.getExtension?.("OES_texture_float_linear") === null && t.scalarTextures?.length && t.scalarTextures.forEach((e14) => {
      e14?.setMinificationFilter?.(Filter$1.NEAREST), e14?.setMagnificationFilter?.(Filter$1.NEAREST);
    });
  }, e12.buildBufferObjects = (n2, r2) => {
    if (!t.jitterTexture.getHandle()) {
      let e13 = new Float32Array(1024);
      for (let t2 = 0; t2 < 1024; ++t2)
        e13[t2] = Math.random();
      t.jitterTexture.setMinificationFilter(Filter$1.NEAREST), t.jitterTexture.setMagnificationFilter(Filter$1.NEAREST), t.jitterTexture.create2DFromRaw({
        width: 32,
        height: 32,
        numComps: 1,
        dataType: VtkDataTypes.FLOAT,
        data: e13
      });
    }
    getConfiguration().rendering?.preferSizeOverAccuracy;
    let a2 = r2.getProperties(), s2 = t.currentValidInputs[0], c = s2.imageData, l = a2[s2.inputIndex], u = c?.get?.("numberOfComponents")?.numberOfComponents ?? 1, d = t.numberOfComponents ?? u, f = !!t.useIndependentComponents, p = f ? d : 1, m = [];
    for (let e13 = 0; e13 < p; ++e13)
      m.push(l.getScalarOpacity(e13));
    let h = getTransferFunctionsHash(m, f, p), g = l.getScalarOpacity(), _ = t._openGLRenderWindow.getGraphicsResourceForObject(g);
    if (!_?.oglObject?.getHandle() || _.hash !== h) {
      let r3 = vtkOpenGLTexture$1.newInstance();
      r3.setOpenGLRenderWindow(t._openGLRenderWindow);
      let a3 = t.renderable.getOpacityTextureWidth();
      a3 <= 0 && (a3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let o2 = a3 * 2 * p, s3 = new Float32Array(o2), c2 = new Float32Array(a3);
      for (let t2 = 0; t2 < p; ++t2) {
        let r4 = l.getScalarOpacity(t2), o3 = e12.getCurrentSampleDistance(n2) / l.getScalarOpacityUnitDistance(t2), u3 = r4.getRange();
        r4.getTable(u3[0], u3[1], a3, c2, 1);
        for (let e13 = 0; e13 < a3; ++e13)
          s3[t2 * a3 * 2 + e13] = 1 - (1 - c2[e13]) ** o3, s3[t2 * a3 * 2 + e13 + a3] = s3[t2 * a3 * 2 + e13];
      }
      r3.resetFormatAndType();
      let u2 = t.context.getExtension("OES_texture_float_linear") === null ? Filter$1.NEAREST : Filter$1.LINEAR;
      r3.setMinificationFilter(u2), r3.setMagnificationFilter(u2), r3.create2DFromRaw({
        width: a3,
        height: 2 * p,
        numComps: 1,
        dataType: VtkDataTypes.FLOAT,
        data: s3
      }), g && t._openGLRenderWindow.setGraphicsResourceForObject(g, r3, h), t.opacityTexture = r3;
    } else
      t.opacityTexture = _.oglObject;
    o(t._openGLRenderWindow, t._opacityTextureCore, g), t._opacityTextureCore = g;
    let v = [];
    for (let e13 = 0; e13 < p; ++e13)
      v.push(l.getRGBTransferFunction(e13));
    let y = getTransferFunctionsHash(v, f, p), b = l.getRGBTransferFunction(), S = t._openGLRenderWindow.getGraphicsResourceForObject(b);
    if (!S?.oglObject?.getHandle() || S?.hash !== y) {
      let e13 = vtkOpenGLTexture$1.newInstance();
      e13.setOpenGLRenderWindow(t._openGLRenderWindow);
      let n3 = t.renderable.getColorTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let r3 = n3 * 2 * p * 3, a3 = new Uint8ClampedArray(r3), o2 = new Float32Array(n3 * 3);
      for (let e14 = 0; e14 < p; ++e14) {
        let t2 = l.getRGBTransferFunction(e14), r4 = t2.getRange();
        t2.getTable(r4[0], r4[1], n3, o2, 1);
        for (let t3 = 0; t3 < n3 * 3; ++t3)
          a3[e14 * n3 * 6 + t3] = 255 * o2[t3], a3[e14 * n3 * 6 + t3 + n3 * 3] = 255 * o2[t3];
      }
      e13.resetFormatAndType(), e13.setMinificationFilter(Filter$1.LINEAR), e13.setMagnificationFilter(Filter$1.LINEAR), e13.create2DFromRaw({
        width: n3,
        height: 2 * p,
        numComps: 3,
        dataType: VtkDataTypes.UNSIGNED_CHAR,
        data: a3
      }), t._openGLRenderWindow.setGraphicsResourceForObject(b, e13, y), t.colorTexture = e13;
    } else
      t.colorTexture = S.oglObject;
    o(t._openGLRenderWindow, t._colorTextureCore, b), t._colorTextureCore = b, t.currentValidInputs.forEach(({ imageData: e13, inputIndex: n3 }, r3) => {
      if (t.scalarTextures ||= [], !t.scalarTextures[r3]) {
        console.warn(`ScalarTexture for component ${r3} not initialized, skipping.`);
        return;
      }
      let a3 = t.scalarTextures[r3], o2 = `${e13.getMTime()}-${a3.getMTime()}`;
      if (t.scalarTextureStrings ||= [], t.scalarTextureStrings[r3] !== o2) {
        let n4 = e13.getDimensions();
        a3.setOpenGLRenderWindow(t._openGLRenderWindow), a3.enableUseHalfFloat(true);
        let s3 = a3.getTextureParameters(), c2 = e13.get("dataType").dataType, l2 = true;
        if (s3?.dataType === c2 && s3?.width === n4[0] && s3?.height === n4[1] && s3?.depth === n4[2] && (l2 = false), l2) {
          let e14 = t.context.getExtension("EXT_texture_norm16");
          a3.setOglNorm16Ext(getCanUseNorm16Texture() ? e14 : null), a3.resetFormatAndType(), a3.setTextureParameters({
            width: n4[0],
            height: n4[1],
            depth: n4[2],
            numberOfComponents: p,
            dataType: c2
          }), a3.create3DFromRaw({
            width: n4[0],
            height: n4[1],
            depth: n4[2],
            numComps: p,
            dataType: c2,
            data: null
          }), a3.update3DFromRaw();
        } else
          a3.deactivate(), a3.update3DFromRaw();
        t.scalarTextureStrings[r3] = o2;
      }
      t._scalarTexturesCore ||= [];
    });
    let C = l.getLabelOutlineThickness(), w = t._openGLRenderWindow.getGraphicsResourceForObject(C), T = C.join("-");
    if (!w?.oglObject?.getHandle() || w?.hash !== T) {
      let e13 = vtkOpenGLTexture$1.newInstance();
      e13.setOpenGLRenderWindow(t._openGLRenderWindow);
      let n3 = t.renderable.getLabelOutlineTextureWidth();
      n3 <= 0 && (n3 = t.context.getParameter(t.context.MAX_TEXTURE_SIZE));
      let r3 = n3 * 1, a3 = new Uint8Array(r3);
      for (let e14 = 0; e14 < n3; ++e14)
        a3[e14] = C[e14] === void 0 ? C[0] : C[e14];
      e13.resetFormatAndType(), e13.setMinificationFilter(Filter$1.NEAREST), e13.setMagnificationFilter(Filter$1.NEAREST), e13.create2DFromRaw({
        width: n3,
        height: 1,
        numComps: 1,
        dataType: VtkDataTypes.UNSIGNED_CHAR,
        data: a3
      }), C && t._openGLRenderWindow.setGraphicsResourceForObject(C, e13, T), t.labelOutlineThicknessTexture = e13;
    } else
      t.labelOutlineThicknessTexture = w.oglObject;
    if (o(t._openGLRenderWindow, t._labelOutlineThicknessTextureCore, C), t._labelOutlineThicknessTextureCore = C, !t.tris.getCABO().getElementCount()) {
      let e13 = new Float32Array(12);
      for (let t2 = 0; t2 < 4; t2++)
        e13[t2 * 3] = t2 % 2 * 2 - 1, e13[t2 * 3 + 1] = t2 > 1 ? 1 : -1, e13[t2 * 3 + 2] = -1;
      let n3 = new Uint16Array(8);
      n3[0] = 3, n3[1] = 0, n3[2] = 1, n3[3] = 3, n3[4] = 3, n3[5] = 0, n3[6] = 3, n3[7] = 2;
      let r3 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        values: e13
      });
      r3.setName("points");
      let a3 = vtkDataArray$1.newInstance({
        numberOfComponents: 1,
        values: n3
      });
      t.tris.getCABO().createVBO(a3, "polys", Representation$1.SURFACE, {
        points: r3,
        cellOffset: 0
      });
    }
    t.VBOBuildTime.modified();
  }, e12.getNeedToRebuildBufferObjects = (n2, r2) => {
    if (t.VBOBuildTime.getMTime() < e12.getMTime() || t.VBOBuildTime.getMTime() < r2.getMTime() || t.VBOBuildTime.getMTime() < t.renderable.getMTime() || t.VBOBuildTime.getMTime() < r2.getProperty().getMTime() || t.VBOBuildTime.getMTime() < t.colorTexture?.getMTime() || t.VBOBuildTime.getMTime() < t.labelOutlineThicknessTexture?.getMTime() || !t.colorTexture?.getHandle() || !t.labelOutlineThicknessTexture?.getHandle())
      return true;
    if (t.scalarTextures && t.scalarTextures.length > 0)
      for (let e13 = 0; e13 < t.scalarTextures.length; e13++) {
        let n3 = t.scalarTextures[e13];
        if (n3 && (t.VBOBuildTime.getMTime() < n3.getMTime() || !n3.getHandle()))
          return true;
      }
    if (t.currentValidInputs && t.currentValidInputs.length > 0)
      for (let e13 = 0; e13 < t.currentValidInputs.length; e13++) {
        let n3 = t.currentValidInputs[e13];
        if (n3 && n3.imageData && t.VBOBuildTime.getMTime() < n3.imageData.getMTime())
          return true;
      }
    return false;
  };
}
var DEFAULT_VALUES$36 = {};
function extend$44(e12, t, n = {}) {
  Object.assign(t, DEFAULT_VALUES$36, n), vtkVolumeMapper$2.extend(e12, t, n), n.scalarTexture ? t.scalarTextures = [n.scalarTexture] : t.scalarTextures = [], t.scalarTextureStrings = [], t._scalarTexturesCore = [], t.previousState = {}, vtkStreamingOpenGLVolumeMapper(e12, t);
}
var vtkStreamingOpenGLVolumeMapper_default = {
  newInstance: macro.newInstance(extend$44, "vtkStreamingOpenGLVolumeMapper"),
  extend: extend$44
}, CLASS_MAPPING = /* @__PURE__ */ Object.create(null);
function registerOverride$2(e12, t) {
  CLASS_MAPPING[e12] = t;
}
function vtkStreamingOpenGLViewNodeFactory(e12, t) {
  t.classHierarchy.push("vtkStreamingOpenGLViewNodeFactory"), e12.createNode = (n) => {
    if (n.isDeleted())
      return null;
    let r = 0, a = n.getClassName(r++), o = false, s = Object.keys(t.overrides);
    for (; a && !o; )
      s.includes(a) ? o = true : a = n.getClassName(r++);
    if (!o)
      return null;
    let c = t.getModelInitialValues(n), l = t.overrides[a](c);
    return l.setMyFactory(e12), l;
  }, t.overrides = CLASS_MAPPING, t.getModelInitialValues = (e13) => {
    let t2 = {};
    return e13.getClassName() === "vtkSharedVolumeMapper" && (t2.scalarTexture = e13.getScalarTexture()), t2;
  };
}
var DEFAULT_VALUES$35 = {};
function extend$43(e12, t, n = {}) {
  Object.assign(t, DEFAULT_VALUES$35, n), vtkViewNodeFactory$1.extend(e12, t, n), vtkStreamingOpenGLViewNodeFactory(e12, t), registerOverride$2("vtkActor", vtkActor$2.newInstance), registerOverride$2("vtkActor2D", vtkActor2D.newInstance), registerOverride$2("vtkCamera", vtkCamera$2.newInstance), registerOverride$2("vtkGlyph3DMapper", vtkGlyph3DMapper.newInstance), registerOverride$2("vtkImageMapper", vtkImageMapper$2.newInstance), registerOverride$2("vtkImageCPRMapper", index.newInstance), registerOverride$2("vtkImageSlice", vtkImageSlice$2.newInstance), registerOverride$2("vtkMapper", vtkOpenGLPolyDataMapper$1.newInstance), registerOverride$2("vtkPixelSpaceCallbackMapper", vtkPixelSpaceCallbackMapper.newInstance), registerOverride$2("vtkRenderer", vtkRenderer$2.newInstance), registerOverride$2("vtkSkybox", vtkSkybox.newInstance), registerOverride$2("vtkSphereMapper", vtkSphereMapper.newInstance), registerOverride$2("vtkStickMapper", vtkStickMapper.newInstance), registerOverride$2("vtkTexture", vtkOpenGLTexture$1.newInstance), registerOverride$2("vtkVolume", vtkVolume.newInstance), registerOverride$2("vtkVolumeMapper", vtkVolumeMapper$2.newInstance), registerOverride$2("vtkSharedVolumeMapper", vtkStreamingOpenGLVolumeMapper_default.newInstance);
}
var vtkStreamingOpenGLViewNodeFactory_default = {
  newInstance: macro.newInstance(extend$43, "vtkStreamingOpenGLViewNodeFactory"),
  extend: extend$43
};
function vtkStreamingOpenGLRenderWindow(e12, t) {
  t.classHierarchy.push("vtkStreamingOpenGLRenderWindow");
}
function extend$42(e12, t, n = {}) {
  Object.assign(t, n), vtkRenderWindow.extend(e12, t, n), t.myFactory = vtkStreamingOpenGLViewNodeFactory_default.newInstance(), registerOverride$2("vtkRenderWindow", newInstance$40), vtkStreamingOpenGLRenderWindow(e12, t);
}
const newInstance$40 = macro.newInstance(extend$42, "vtkStreamingOpenGLRenderWindow");
var vtkStreamingOpenGLRenderWindow_default = {
  newInstance: newInstance$40,
  extend: extend$42
}, { vtkDebugMacro: vtkDebugMacro$2 } = macro;
function vtkCamera(e12, t) {
  t.classHierarchy.push("vtkCamera");
  let n = new Float64Array(3), r = new Float64Array([
    0,
    0,
    -1
  ]), a = new Float64Array([
    0,
    1,
    0
  ]), o = identity$2(new Float64Array(16)), s = identity$2(new Float64Array(16)), c = new Float64Array(3), l = new Float64Array(3), u = new Float64Array(3), d = identity$2(new Float64Array(16)), f = identity$2(new Float64Array(16)), p = new Float64Array(3), m = new Float64Array(3);
  function h() {
    t.viewPlaneNormal[0] = -t.directionOfProjection[0], t.viewPlaneNormal[1] = -t.directionOfProjection[1], t.viewPlaneNormal[2] = -t.directionOfProjection[2];
  }
  e12.orthogonalizeViewUp = () => {
    let n2 = e12.getViewMatrix();
    t.viewUp[0] = n2[4], t.viewUp[1] = n2[5], t.viewUp[2] = n2[6], e12.modified();
  }, e12.setPosition = (n2, r2, a2) => {
    n2 === t.position[0] && r2 === t.position[1] && a2 === t.position[2] || (t.position[0] = n2, t.position[1] = r2, t.position[2] = a2, e12.computeDistance(), e12.modified());
  }, e12.setFocalPoint = (n2, r2, a2) => {
    n2 === t.focalPoint[0] && r2 === t.focalPoint[1] && a2 === t.focalPoint[2] || (t.focalPoint[0] = n2, t.focalPoint[1] = r2, t.focalPoint[2] = a2, e12.computeDistance(), e12.modified());
  }, e12.setDistance = (n2) => {
    if (t.distance === n2)
      return;
    t.distance = n2, t.distance < 1e-20 && (t.distance = 1e-20, vtkDebugMacro$2("Distance is set to minimum."));
    let r2 = t.directionOfProjection;
    t.focalPoint[0] = t.position[0] + r2[0] * t.distance, t.focalPoint[1] = t.position[1] + r2[1] * t.distance, t.focalPoint[2] = t.position[2] + r2[2] * t.distance, e12.modified();
  }, e12.computeDistance = () => {
    let e13 = t.focalPoint[0] - t.position[0], n2 = t.focalPoint[1] - t.position[1], r2 = t.focalPoint[2] - t.position[2];
    if (t.distance = Math.sqrt(e13 * e13 + n2 * n2 + r2 * r2), t.distance < 1e-20) {
      t.distance = 1e-20, vtkDebugMacro$2("Distance is set to minimum.");
      let e14 = t.directionOfProjection;
      t.focalPoint[0] = t.position[0] + e14[0] * t.distance, t.focalPoint[1] = t.position[1] + e14[1] * t.distance, t.focalPoint[2] = t.position[2] + e14[2] * t.distance;
    }
    t.directionOfProjection[0] = e13 / t.distance, t.directionOfProjection[1] = n2 / t.distance, t.directionOfProjection[2] = r2 / t.distance, h();
  }, e12.dolly = (n2) => {
    if (n2 <= 0)
      return;
    let r2 = t.distance / n2;
    e12.setPosition(t.focalPoint[0] - r2 * t.directionOfProjection[0], t.focalPoint[1] - r2 * t.directionOfProjection[1], t.focalPoint[2] - r2 * t.directionOfProjection[2]);
  }, e12.roll = (n2) => {
    let r2 = t.position, a2 = t.focalPoint, o2 = t.viewUp, s2 = new Float64Array([
      o2[0],
      o2[1],
      o2[2],
      0
    ]);
    identity$2(d);
    let c2 = new Float64Array([
      a2[0] - r2[0],
      a2[1] - r2[1],
      a2[2] - r2[2]
    ]);
    rotate(d, d, radiansFromDegrees(n2), c2), transformMat4(s2, s2, d), t.viewUp[0] = s2[0], t.viewUp[1] = s2[1], t.viewUp[2] = s2[2], e12.modified();
  }, e12.azimuth = (n2) => {
    let r2 = t.focalPoint;
    identity$2(f), translate(f, f, r2), rotate(f, f, radiansFromDegrees(n2), t.viewUp), translate(f, f, [
      -r2[0],
      -r2[1],
      -r2[2]
    ]), transformMat4$1(p, t.position, f), e12.setPosition(p[0], p[1], p[2]);
  }, e12.yaw = (n2) => {
    let r2 = t.position;
    identity$2(f), translate(f, f, r2), rotate(f, f, radiansFromDegrees(n2), t.viewUp), translate(f, f, [
      -r2[0],
      -r2[1],
      -r2[2]
    ]), transformMat4$1(m, t.focalPoint, f), e12.setFocalPoint(m[0], m[1], m[2]);
  }, e12.elevation = (n2) => {
    let r2 = t.focalPoint, a2 = e12.getViewMatrix(), o2 = [
      -a2[0],
      -a2[1],
      -a2[2]
    ];
    identity$2(f), translate(f, f, r2), rotate(f, f, radiansFromDegrees(n2), o2), translate(f, f, [
      -r2[0],
      -r2[1],
      -r2[2]
    ]), transformMat4$1(p, t.position, f), e12.setPosition(p[0], p[1], p[2]);
  }, e12.pitch = (n2) => {
    let r2 = t.position, a2 = e12.getViewMatrix(), o2 = [
      a2[0],
      a2[1],
      a2[2]
    ];
    identity$2(f), translate(f, f, r2), rotate(f, f, radiansFromDegrees(n2), o2), translate(f, f, [
      -r2[0],
      -r2[1],
      -r2[2]
    ]), transformMat4$1(m, t.focalPoint, f), e12.setFocalPoint(...m);
  }, e12.zoom = (n2) => {
    n2 <= 0 || (t.parallelProjection ? t.parallelScale /= n2 : t.viewAngle /= n2, e12.modified());
  }, e12.translate = (n2, r2, a2) => {
    let o2 = [
      n2,
      r2,
      a2
    ];
    add(t.position, o2, t.position), add(t.focalPoint, o2, t.focalPoint), e12.computeDistance(), e12.modified();
  }, e12.applyTransform = (n2) => {
    let r2 = [...t.viewUp, 1], a2 = [], o2 = [], s2 = [];
    r2[0] += t.position[0], r2[1] += t.position[1], r2[2] += t.position[2], transformMat4(a2, [...t.position, 1], n2), transformMat4(o2, [...t.focalPoint, 1], n2), transformMat4(s2, r2, n2), s2[0] -= a2[0], s2[1] -= a2[1], s2[2] -= a2[2], e12.setPosition(...a2.slice(0, 3)), e12.setFocalPoint(...o2.slice(0, 3)), e12.setViewUp(...s2.slice(0, 3));
  }, e12.getThickness = () => t.clippingRange[1] - t.clippingRange[0], e12.setThickness = (n2) => {
    let r2 = n2;
    r2 < 1e-20 && (r2 = 1e-20, vtkDebugMacro$2("Thickness is set to minimum.")), e12.setClippingRange(t.clippingRange[0], t.clippingRange[0] + r2);
  }, e12.setThicknessFromFocalPoint = (n2) => {
    let r2 = n2;
    r2 < 1e-20 && (r2 = 1e-20, vtkDebugMacro$2("Thickness is set to minimum.")), e12.setClippingRange(t.distance - r2 / 2, t.distance + r2 / 2);
  }, e12.setRoll = (e13) => {
  }, e12.getRoll = () => {
  }, e12.setObliqueAngles = (e13, t2) => {
  }, e12.getOrientation = () => {
  }, e12.getOrientationWXYZ = () => {
  }, e12.getFrustumPlanes = function() {
    let t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Float64Array(24), r2 = [
      [
        1,
        0,
        0,
        1
      ],
      [
        -1,
        0,
        0,
        1
      ],
      [
        0,
        1,
        0,
        1
      ],
      [
        0,
        -1,
        0,
        1
      ],
      [
        0,
        0,
        1,
        1
      ],
      [
        0,
        0,
        -1,
        1
      ]
    ], a2 = e12.getCompositeProjectionMatrix(t2, -1, 1);
    for (let e13 = 0; e13 < 6; e13++)
      transformMat4(r2[e13], r2[e13], a2), normalize4D(r2[e13]), n2[4 * e13 + 0] = r2[e13][0], n2[4 * e13 + 1] = r2[e13][1], n2[4 * e13 + 2] = r2[e13][2], n2[4 * e13 + 3] = r2[e13][3];
    return n2;
  }, e12.getCameraLightTransformMatrix = (e13) => (copy$4(e13, t.cameraLightTransform), e13), e12.computeCameraLightTransform = () => {
    copy$4(o, e12.getViewMatrix()), invert(o, o), fromScaling(s, [
      t.distance,
      t.distance,
      t.distance
    ]), multiply$2(o, o, s), identity$2(t.cameraLightTransform), translate(t.cameraLightTransform, o, [
      0,
      0,
      -1
    ]);
  }, e12.deepCopy = (e13) => {
  }, e12.physicalOrientationToWorldDirection = (e13) => {
    let t2 = fromValues$1(e13[0], e13[1], e13[2], e13[3]), n2 = create$2(), r2 = fromValues$1(0, 0, 1, 0);
    return conjugate(n2, t2), multiply(r2, t2, r2), multiply(r2, r2, n2), [
      r2[0],
      r2[1],
      r2[2]
    ];
  }, e12.getPhysicalToWorldMatrix = (t2) => {
    e12.getWorldToPhysicalMatrix(t2), invert(t2, t2);
  }, e12.getWorldToPhysicalMatrix = (e13) => {
    identity$2(e13);
    let n2 = [3];
    cross(t.physicalViewNorth, t.physicalViewUp, n2), e13[0] = n2[0], e13[1] = n2[1], e13[2] = n2[2], e13[4] = t.physicalViewUp[0], e13[5] = t.physicalViewUp[1], e13[6] = t.physicalViewUp[2], e13[8] = -t.physicalViewNorth[0], e13[9] = -t.physicalViewNorth[1], e13[10] = -t.physicalViewNorth[2], transpose(e13, e13), set$4(c, 1 / t.physicalScale, 1 / t.physicalScale, 1 / t.physicalScale), scale$4(e13, e13, c), translate(e13, e13, t.physicalTranslation);
  }, e12.computeViewParametersFromViewMatrix = (s2) => {
    invert(o, s2), transformMat4$1(c, n, o), e12.computeDistance();
    let d2 = t.distance;
    e12.setPosition(c[0], c[1], c[2]), transformMat4$1(l, r, o), subtract$3(l, l, c), normalize$4(l, l), e12.setDirectionOfProjection(l[0], l[1], l[2]), transformMat4$1(u, a, o), subtract$3(u, u, c), normalize$4(u, u), e12.setViewUp(u[0], u[1], u[2]), e12.setDistance(d2);
  }, e12.computeViewParametersFromPhysicalMatrix = (t2) => {
    e12.getWorldToPhysicalMatrix(o), multiply$2(o, t2, o), e12.computeViewParametersFromViewMatrix(o);
  }, e12.setModelTransformMatrix = (e13) => {
    t.modelTransformMatrix = e13;
  }, e12.getModelTransformMatrix = () => t.modelTransformMatrix, e12.setViewMatrix = (n2) => {
    t.viewMatrix = n2, t.viewMatrix && (copy$4(o, t.viewMatrix), e12.computeViewParametersFromViewMatrix(o), transpose(t.viewMatrix, t.viewMatrix));
  }, e12.getViewMatrix = () => {
    if (t.viewMatrix)
      return t.modelTransformMatrix ? (multiply$2(o, t.viewMatrix, t.modelTransformMatrix), o) : t.viewMatrix;
    lookAt(o, t.position, t.focalPoint, t.viewUp), transpose(o, o);
    let e13 = new Float64Array(16);
    return t.modelTransformMatrix ? multiply$2(e13, o, t.modelTransformMatrix) : copy$4(e13, o), e13;
  }, e12.setProjectionMatrix = (e13) => {
    t.projectionMatrix = e13;
  }, e12.getProjectionMatrix = (e13, n2, r2) => {
    let a2 = new Float64Array(16);
    if (identity$2(a2), t.projectionMatrix) {
      let e14 = 1 / t.physicalScale;
      return set$4(c, e14, e14, e14), copy$4(a2, t.projectionMatrix), scale$4(a2, a2, c), transpose(a2, a2), a2;
    }
    identity$2(o);
    let s2 = t.clippingRange[1] - t.clippingRange[0], l2 = [t.clippingRange[0] + (n2 + 1) * s2 / 2, t.clippingRange[0] + (r2 + 1) * s2 / 2];
    if (t.parallelProjection) {
      let n3 = t.parallelScale * e13, r3 = t.parallelScale;
      ortho(o, (t.windowCenter[0] - 1) * n3, (t.windowCenter[0] + 1) * n3, (t.windowCenter[1] - 1) * r3, (t.windowCenter[1] + 1) * r3, l2[0], l2[1]), transpose(o, o);
    } else if (t.useOffAxisProjection)
      throw Error("Off-Axis projection is not supported at this time");
    else {
      let n3 = Math.tan(radiansFromDegrees(t.viewAngle) / 2), r3, a3;
      t.useHorizontalViewAngle === true ? (r3 = t.clippingRange[0] * n3, a3 = t.clippingRange[0] * n3 / e13) : (r3 = t.clippingRange[0] * n3 * e13, a3 = t.clippingRange[0] * n3);
      let s3 = (t.windowCenter[0] - 1) * r3, c2 = (t.windowCenter[0] + 1) * r3, u2 = (t.windowCenter[1] - 1) * a3, d2 = (t.windowCenter[1] + 1) * a3, f2 = l2[0], p2 = l2[1];
      o[0] = 2 * f2 / (c2 - s3), o[5] = 2 * f2 / (d2 - u2), o[2] = (s3 + c2) / (c2 - s3), o[6] = (u2 + d2) / (d2 - u2), o[10] = -(f2 + p2) / (p2 - f2), o[14] = -1, o[11] = -2 * f2 * p2 / (p2 - f2), o[15] = 0;
    }
    return copy$4(a2, o), a2;
  }, e12.getCompositeProjectionMatrix = (t2, n2, r2) => {
    let a2 = e12.getViewMatrix(), o2 = e12.getProjectionMatrix(t2, n2, r2);
    return multiply$2(o2, a2, o2), o2;
  }, e12.setDirectionOfProjection = (e13, n2, r2) => {
    if (t.directionOfProjection[0] === e13 && t.directionOfProjection[1] === n2 && t.directionOfProjection[2] === r2)
      return;
    t.directionOfProjection[0] = e13, t.directionOfProjection[1] = n2, t.directionOfProjection[2] = r2;
    let a2 = t.directionOfProjection;
    t.focalPoint[0] = t.position[0] + a2[0] * t.distance, t.focalPoint[1] = t.position[1] + a2[1] * t.distance, t.focalPoint[2] = t.position[2] + a2[2] * t.distance, h();
  }, e12.setDeviceAngles = (n2, r2, a2, o2) => {
    let s2 = [3];
    cross(t.physicalViewNorth, t.physicalViewUp, s2);
    let c2 = identity$2(new Float64Array(16));
    rotate(c2, c2, radiansFromDegrees(n2), t.physicalViewUp), rotate(c2, c2, radiansFromDegrees(r2), s2), rotate(c2, c2, radiansFromDegrees(a2), t.physicalViewNorth), rotate(c2, c2, radiansFromDegrees(-o2), t.physicalViewUp);
    let l2 = new Float64Array([
      -t.physicalViewUp[0],
      -t.physicalViewUp[1],
      -t.physicalViewUp[2]
    ]), u2 = new Float64Array(t.physicalViewNorth);
    transformMat4$1(l2, l2, c2), transformMat4$1(u2, u2, c2), e12.setDirectionOfProjection(l2[0], l2[1], l2[2]), e12.setViewUp(u2[0], u2[1], u2[2]), e12.modified();
  }, e12.setOrientationWXYZ = (t2, n2, r2, a2) => {
    let o2 = identity$2(new Float64Array(16));
    if (t2 !== 0 && (n2 !== 0 || r2 !== 0 || a2 !== 0)) {
      let e13 = radiansFromDegrees(t2), s3 = create$2();
      setAxisAngle(s3, [
        n2,
        r2,
        a2
      ], e13), fromQuat(o2, s3);
    }
    let s2 = new Float64Array(3);
    transformMat4$1(s2, [
      0,
      0,
      -1
    ], o2);
    let c2 = new Float64Array(3);
    transformMat4$1(c2, [
      0,
      1,
      0
    ], o2), e12.setDirectionOfProjection(...s2), e12.setViewUp(...c2), e12.modified();
  }, e12.computeClippingRange = (e13) => {
    let n2 = null, r2 = null;
    n2 = t.viewPlaneNormal, r2 = t.position;
    let a2 = -n2[0], o2 = -n2[1], s2 = -n2[2], c2 = -(a2 * r2[0] + o2 * r2[1] + s2 * r2[2]), l2 = [a2 * e13[0] + o2 * e13[2] + s2 * e13[4] + c2, 1e-18];
    for (let t2 = 0; t2 < 2; t2++)
      for (let n3 = 0; n3 < 2; n3++)
        for (let r3 = 0; r3 < 2; r3++) {
          let u2 = a2 * e13[r3] + o2 * e13[2 + n3] + s2 * e13[4 + t2] + c2;
          l2[0] = u2 < l2[0] ? u2 : l2[0], l2[1] = u2 > l2[1] ? u2 : l2[1];
        }
    return l2;
  };
}
var DEFAULT_VALUES$34 = {
  position: [
    0,
    0,
    1
  ],
  focalPoint: [
    0,
    0,
    0
  ],
  viewUp: [
    0,
    1,
    0
  ],
  directionOfProjection: [
    0,
    0,
    -1
  ],
  parallelProjection: false,
  useHorizontalViewAngle: false,
  viewAngle: 30,
  parallelScale: 1,
  clippingRange: [0.01, 1000.01],
  windowCenter: [0, 0],
  viewPlaneNormal: [
    0,
    0,
    1
  ],
  useOffAxisProjection: false,
  screenBottomLeft: [
    -0.5,
    -0.5,
    -0.5
  ],
  screenBottomRight: [
    0.5,
    -0.5,
    -0.5
  ],
  screenTopRight: [
    0.5,
    0.5,
    -0.5
  ],
  freezeFocalPoint: false,
  projectionMatrix: null,
  viewMatrix: null,
  modelTransformMatrix: null,
  cameraLightTransform: create$5(),
  physicalTranslation: [
    0,
    0,
    0
  ],
  physicalScale: 1,
  physicalViewUp: [
    0,
    1,
    0
  ],
  physicalViewNorth: [
    0,
    0,
    -1
  ]
};
function extend$41(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$34, n), macro.obj(e12, t), macro.get(e12, t, ["distance"]), macro.setGet(e12, t, [
    "parallelProjection",
    "useHorizontalViewAngle",
    "viewAngle",
    "parallelScale",
    "useOffAxisProjection",
    "freezeFocalPoint",
    "physicalScale"
  ]), macro.getArray(e12, t, [
    "directionOfProjection",
    "viewPlaneNormal",
    "position",
    "focalPoint"
  ]), macro.setGetArray(e12, t, ["clippingRange", "windowCenter"], 2), macro.setGetArray(e12, t, [
    "viewUp",
    "screenBottomLeft",
    "screenBottomRight",
    "screenTopRight",
    "physicalTranslation",
    "physicalViewUp",
    "physicalViewNorth"
  ], 3), vtkCamera(e12, t);
}
var vtkCamera$1 = {
  newInstance: macro.newInstance(extend$41, "vtkCamera"),
  extend: extend$41
}, LIGHT_TYPES = [
  "HeadLight",
  "CameraLight",
  "SceneLight"
];
function vtkLight(e12, t) {
  t.classHierarchy.push("vtkLight");
  let n = new Float64Array(3);
  e12.getTransformedPosition = () => (t.transformMatrix ? transformMat4$1(n, t.position, t.transformMatrix) : set$4(n, t.position[0], t.position[1], t.position[2]), n), e12.getTransformedFocalPoint = () => (t.transformMatrix ? transformMat4$1(n, t.focalPoint, t.transformMatrix) : set$4(n, t.focalPoint[0], t.focalPoint[1], t.focalPoint[2]), n), e12.getDirection = () => (t.directionMTime < t.mtime && (sub$1(t.direction, t.focalPoint, t.position), normalize$1(t.direction), t.directionMTime = t.mtime), t.direction), e12.setDirection = (e13) => {
    let n2 = new Float64Array(3);
    sub$1(n2, t.position, e13), t.focalPoint = n2;
  }, e12.setDirectionAngle = (t2, n2) => {
    let r = radiansFromDegrees(t2), a = radiansFromDegrees(n2);
    e12.setPosition(Math.cos(r) * Math.sin(a), Math.sin(r), Math.cos(r) * Math.cos(a)), e12.setFocalPoint(0, 0, 0), e12.setPositional(0);
  }, e12.setLightTypeToHeadLight = () => {
    e12.setLightType("HeadLight");
  }, e12.setLightTypeToCameraLight = () => {
    e12.setLightType("CameraLight");
  }, e12.setLightTypeToSceneLight = () => {
    e12.setTransformMatrix(null), e12.setLightType("SceneLight");
  }, e12.lightTypeIsHeadLight = () => t.lightType === "HeadLight", e12.lightTypeIsSceneLight = () => t.lightType === "SceneLight", e12.lightTypeIsCameraLight = () => t.lightType === "CameraLight";
}
var DEFAULT_VALUES$33 = {
  switch: true,
  intensity: 1,
  color: [
    1,
    1,
    1
  ],
  position: [
    0,
    0,
    1
  ],
  focalPoint: [
    0,
    0,
    0
  ],
  positional: false,
  exponent: 1,
  coneAngle: 30,
  coneFalloff: 5,
  attenuationValues: [
    1,
    0,
    0
  ],
  transformMatrix: null,
  lightType: "SceneLight",
  shadowAttenuation: 1,
  direction: [
    0,
    0,
    0
  ],
  directionMTime: 0
};
function extend$40(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$33, n), macro.obj(e12, t), macro.setGet(e12, t, [
    "intensity",
    "switch",
    "positional",
    "exponent",
    "coneAngle",
    "coneFalloff",
    "transformMatrix",
    "lightType",
    "shadowAttenuation",
    "attenuationValues"
  ]), macro.setGetArray(e12, t, [
    "color",
    "position",
    "focalPoint",
    "attenuationValues"
  ], 3), vtkLight(e12, t);
}
var vtkLight$1 = {
  newInstance: macro.newInstance(extend$40, "vtkLight"),
  extend: extend$40,
  LIGHT_TYPES
}, { vtkErrorMacro: vtkErrorMacro$8 } = macro;
function notImplemented$1(e12) {
  return () => vtkErrorMacro$8(`vtkViewport::${e12} - NOT IMPLEMENTED`);
}
function vtkViewport(e12, t) {
  t.classHierarchy.push("vtkViewport"), e12.getViewProps = () => t.props, e12.hasViewProp = (e13) => t.props.includes(e13), e12.addViewProp = (n2) => {
    n2 && !e12.hasViewProp(n2) && t.props.push(n2);
  }, e12.removeViewProp = (e13) => {
    let n2 = t.props.filter((t2) => t2 !== e13);
    t.props.length !== n2.length && (t.props = n2);
  }, e12.removeAllViewProps = () => {
    t.props = [];
  };
  function n(e13) {
    let t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    t2.push(e13);
    let r = e13.getNestedProps();
    if (r && r.length)
      for (let e14 = 0; e14 < r.length; e14++)
        n(r[e14], t2);
    return t2;
  }
  e12.getViewPropsWithNestedProps = () => {
    let r = [], a = e12.getActors2D();
    a.sort((e13, t2) => e13.getLayerNumber() - t2.getLayerNumber());
    let o = t.props.filter((e13) => !a.includes(e13));
    for (let e13 = 0; e13 < o.length; e13++)
      n(o[e13], r);
    return r = r.concat(a), r;
  }, e12.addActor2D = e12.addViewProp, e12.removeActor2D = (t2) => {
    e12.removeViewProp(t2);
  }, e12.getActors2D = () => (t.actors2D = [], t.props.forEach((e13) => {
    t.actors2D = t.actors2D.concat(e13.getActors2D());
  }), t.actors2D), e12.displayToView = () => vtkErrorMacro$8("call displayToView on your view instead"), e12.viewToDisplay = () => vtkErrorMacro$8("callviewtodisplay on your view instead"), e12.getSize = () => vtkErrorMacro$8("call getSize on your View instead"), e12.normalizedDisplayToProjection = (t2, n2, r) => {
    let a = e12.normalizedDisplayToNormalizedViewport(t2, n2, r);
    return e12.normalizedViewportToProjection(a[0], a[1], a[2]);
  }, e12.normalizedDisplayToNormalizedViewport = (e13, n2, r) => {
    let a = [t.viewport[2] - t.viewport[0], t.viewport[3] - t.viewport[1]];
    return [
      (e13 - t.viewport[0]) / a[0],
      (n2 - t.viewport[1]) / a[1],
      r
    ];
  }, e12.normalizedViewportToProjection = (e13, t2, n2) => [
    e13 * 2 - 1,
    t2 * 2 - 1,
    n2 * 2 - 1
  ], e12.projectionToNormalizedDisplay = (t2, n2, r) => {
    let a = e12.projectionToNormalizedViewport(t2, n2, r);
    return e12.normalizedViewportToNormalizedDisplay(a[0], a[1], a[2]);
  }, e12.normalizedViewportToNormalizedDisplay = (e13, n2, r) => {
    let a = [t.viewport[2] - t.viewport[0], t.viewport[3] - t.viewport[1]];
    return [
      e13 * a[0] + t.viewport[0],
      n2 * a[1] + t.viewport[1],
      r
    ];
  }, e12.projectionToNormalizedViewport = (e13, t2, n2) => [
    (e13 + 1) * 0.5,
    (t2 + 1) * 0.5,
    (n2 + 1) * 0.5
  ], e12.PickPropFrom = notImplemented$1("PickPropFrom");
}
var DEFAULT_VALUES$32 = {
  background: [
    0,
    0,
    0
  ],
  background2: [
    0.2,
    0.2,
    0.2
  ],
  gradientBackground: false,
  viewport: [
    0,
    0,
    1,
    1
  ],
  aspect: [1, 1],
  pixelAspect: [1, 1],
  props: [],
  actors2D: []
};
function extend$39(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$32, n), macro.obj(e12, t), macro.event(e12, t, "event"), macro.setGetArray(e12, t, ["viewport"], 4), macro.setGetArray(e12, t, ["background", "background2"], 3), vtkViewport(e12, t);
}
var vtkViewport$1 = {
  newInstance: macro.newInstance(extend$39, "vtkViewport"),
  extend: extend$39
}, { vtkDebugMacro: vtkDebugMacro$1, vtkErrorMacro: vtkErrorMacro$7, vtkWarningMacro: vtkWarningMacro$1 } = macro$1;
function notImplemented(e12) {
  return () => vtkErrorMacro$7(`vtkRenderer::${e12} - NOT IMPLEMENTED`);
}
function vtkRenderer(e12, t) {
  t.classHierarchy.push("vtkRenderer");
  let n = {
    type: "ComputeVisiblePropBoundsEvent",
    renderer: e12
  }, r = {
    type: "ResetCameraClippingRangeEvent",
    renderer: e12
  }, a = {
    type: "ResetCameraEvent",
    renderer: e12
  };
  e12.updateCamera = () => (t.activeCamera || (vtkDebugMacro$1("No cameras are on, creating one."), e12.getActiveCameraAndResetIfCreated()), t.activeCamera.render(e12), true), e12.updateLightsGeometryToFollowCamera = () => {
    let n2 = e12.getActiveCameraAndResetIfCreated();
    t.lights.forEach((e13) => {
      e13.lightTypeIsSceneLight() || (e13.lightTypeIsHeadLight() ? (e13.setPositionFrom(n2.getPositionByReference()), e13.setFocalPointFrom(n2.getFocalPointByReference()), e13.modified(n2.getMTime())) : e13.lightTypeIsCameraLight() ? e13.setTransformMatrix(n2.getCameraLightTransformMatrix(create$5())) : vtkErrorMacro$7("light has unknown light type", e13.get()));
    });
  }, e12.updateLightGeometry = () => t.lightFollowCamera ? e12.updateLightsGeometryToFollowCamera() : true, e12.allocateTime = notImplemented("allocateTime"), e12.updateGeometry = notImplemented("updateGeometry"), e12.getVTKWindow = () => t._renderWindow, e12.setLayer = (n2) => {
    vtkDebugMacro$1(e12.getClassName(), e12, "setting Layer to ", n2), t.layer !== n2 && (t.layer = n2, e12.modified()), e12.setPreserveColorBuffer(!!n2);
  }, e12.setActiveCamera = (n2) => t.activeCamera === n2 ? false : (t.activeCamera = n2, e12.modified(), e12.invokeEvent({
    type: "ActiveCameraEvent",
    camera: n2
  }), true), e12.makeCamera = () => {
    let t2 = vtkCamera$1.newInstance();
    return e12.invokeEvent({
      type: "CreateCameraEvent",
      camera: t2
    }), t2;
  }, e12.getActiveCamera = () => (t.activeCamera ||= e12.makeCamera(), t.activeCamera), e12.getActiveCameraAndResetIfCreated = () => (t.activeCamera || (e12.getActiveCamera(), e12.resetCamera()), t.activeCamera), e12.getActors = () => (t.actors = [], t.props.forEach((e13) => {
    t.actors = t.actors.concat(e13.getActors());
  }), t.actors), e12.addActor = e12.addViewProp, e12.removeActor = (n2) => {
    t.actors = t.actors.filter((e13) => e13 !== n2), e12.removeViewProp(n2), e12.modified();
  }, e12.removeAllActors = () => {
    e12.getActors().forEach((t2) => {
      e12.removeViewProp(t2);
    }), t.actors = [], e12.modified();
  }, e12.getVolumes = () => (t.volumes = [], t.props.forEach((e13) => {
    t.volumes = t.volumes.concat(e13.getVolumes());
  }), t.volumes), e12.addVolume = e12.addViewProp, e12.removeVolume = (n2) => {
    t.volumes = t.volumes.filter((e13) => e13 !== n2), e12.removeViewProp(n2), e12.modified();
  }, e12.removeAllVolumes = () => {
    e12.getVolumes().forEach((t2) => {
      e12.removeViewProp(t2);
    }), t.volumes = [], e12.modified();
  }, e12.hasLight = (e13) => t.lights.includes(e13), e12.addLight = (n2) => {
    n2 && !e12.hasLight(n2) && (t.lights.push(n2), e12.modified());
  }, e12.removeLight = (n2) => {
    t.lights = t.lights.filter((e13) => e13 !== n2), e12.modified();
  }, e12.removeAllLights = () => {
    t.lights = [], e12.modified();
  }, e12.setLightCollection = (n2) => {
    t.lights = n2, e12.modified();
  }, e12.makeLight = vtkLight$1.newInstance, e12.createLight = () => {
    t.automaticLightCreation && (t._createdLight &&= (e12.removeLight(t._createdLight), t._createdLight.delete(), null), t._createdLight = e12.makeLight(), e12.addLight(t._createdLight), t._createdLight.setLightTypeToHeadLight(), t._createdLight.setPosition(e12.getActiveCamera().getPosition()), t._createdLight.setFocalPoint(e12.getActiveCamera().getFocalPoint()));
  }, e12.normalizedDisplayToWorld = (t2, n2, r2, a2) => {
    let o = e12.normalizedDisplayToProjection(t2, n2, r2);
    return o = e12.projectionToView(o[0], o[1], o[2], a2), e12.viewToWorld(o[0], o[1], o[2]);
  }, e12.worldToNormalizedDisplay = (t2, n2, r2, a2) => {
    let o = e12.worldToView(t2, n2, r2);
    return o = e12.viewToProjection(o[0], o[1], o[2], a2), e12.projectionToNormalizedDisplay(o[0], o[1], o[2]);
  }, e12.viewToWorld = (e13, n2, r2) => {
    if (t.activeCamera === null)
      return vtkErrorMacro$7("ViewToWorld: no active camera, cannot compute view to world, returning 0,0,0"), [
        0,
        0,
        0
      ];
    let a2 = t.activeCamera.getViewMatrix();
    invert(a2, a2), transpose(a2, a2);
    let o = new Float64Array([
      e13,
      n2,
      r2
    ]);
    return transformMat4$1(o, o, a2), o;
  }, e12.projectionToView = (e13, n2, r2, a2) => {
    if (t.activeCamera === null)
      return vtkErrorMacro$7("ProjectionToView: no active camera, cannot compute projection to view, returning 0,0,0"), [
        0,
        0,
        0
      ];
    let o = t.activeCamera.getProjectionMatrix(a2, -1, 1);
    invert(o, o), transpose(o, o);
    let s = new Float64Array([
      e13,
      n2,
      r2
    ]);
    return transformMat4$1(s, s, o), s;
  }, e12.worldToView = (e13, n2, r2) => {
    if (t.activeCamera === null)
      return vtkErrorMacro$7("WorldToView: no active camera, cannot compute view to world, returning 0,0,0"), [
        0,
        0,
        0
      ];
    let a2 = t.activeCamera.getViewMatrix();
    transpose(a2, a2);
    let o = new Float64Array([
      e13,
      n2,
      r2
    ]);
    return transformMat4$1(o, o, a2), o;
  }, e12.viewToProjection = (e13, n2, r2, a2) => {
    if (t.activeCamera === null)
      return vtkErrorMacro$7("ViewToProjection: no active camera, cannot compute view to projection, returning 0,0,0"), [
        0,
        0,
        0
      ];
    let o = t.activeCamera.getProjectionMatrix(a2, -1, 1);
    transpose(o, o);
    let s = new Float64Array([
      e13,
      n2,
      r2
    ]);
    return transformMat4$1(s, s, o), s;
  }, e12.computeVisiblePropBounds = () => {
    t.allBounds[0] = vtkBoundingBox.INIT_BOUNDS[0], t.allBounds[1] = vtkBoundingBox.INIT_BOUNDS[1], t.allBounds[2] = vtkBoundingBox.INIT_BOUNDS[2], t.allBounds[3] = vtkBoundingBox.INIT_BOUNDS[3], t.allBounds[4] = vtkBoundingBox.INIT_BOUNDS[4], t.allBounds[5] = vtkBoundingBox.INIT_BOUNDS[5];
    let r2 = true;
    e12.invokeEvent(n);
    for (let e13 = 0; e13 < t.props.length; ++e13) {
      let n2 = t.props[e13];
      if (n2.getVisibility() && n2.getUseBounds()) {
        let e14 = n2.getBounds();
        e14 && areBoundsInitialized(e14) && (r2 = false, e14[0] < t.allBounds[0] && (t.allBounds[0] = e14[0]), e14[1] > t.allBounds[1] && (t.allBounds[1] = e14[1]), e14[2] < t.allBounds[2] && (t.allBounds[2] = e14[2]), e14[3] > t.allBounds[3] && (t.allBounds[3] = e14[3]), e14[4] < t.allBounds[4] && (t.allBounds[4] = e14[4]), e14[5] > t.allBounds[5] && (t.allBounds[5] = e14[5]));
      }
    }
    return r2 && (uninitializeBounds(t.allBounds), vtkDebugMacro$1("Can't compute bounds, no 3D props are visible")), t.allBounds;
  }, e12.resetCamera = function() {
    let n2 = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null) || e12.computeVisiblePropBounds(), r2 = [
      0,
      0,
      0
    ];
    if (!areBoundsInitialized(n2))
      return vtkDebugMacro$1("Cannot reset camera!"), false;
    let o = null;
    if (e12.getActiveCamera())
      o = t.activeCamera.getViewPlaneNormal();
    else
      return vtkErrorMacro$7("Trying to reset non-existent camera"), false;
    t.activeCamera.setViewAngle(30), r2[0] = (n2[0] + n2[1]) / 2, r2[1] = (n2[2] + n2[3]) / 2, r2[2] = (n2[4] + n2[5]) / 2;
    let s = n2[1] - n2[0], c = n2[3] - n2[2], l = n2[5] - n2[4];
    s *= s, c *= c, l *= l;
    let u = s + c + l;
    u = u === 0 ? 1 : u, u = Math.sqrt(u) * 0.5;
    let d = radiansFromDegrees(t.activeCamera.getViewAngle()), f = u, p = u / Math.sin(d * 0.5), m = t.activeCamera.getViewUp();
    return Math.abs(dot(m, o)) > 0.999 && (vtkWarningMacro$1("Resetting view-up since view plane normal is parallel"), t.activeCamera.setViewUp(-m[2], m[0], m[1])), t.activeCamera.setFocalPoint(r2[0], r2[1], r2[2]), t.activeCamera.setPosition(r2[0] + p * o[0], r2[1] + p * o[1], r2[2] + p * o[2]), e12.resetCameraClippingRange(n2), t.activeCamera.setParallelScale(f), t.activeCamera.setPhysicalScale(u), t.activeCamera.setPhysicalTranslation(-r2[0], -r2[1], -r2[2]), e12.invokeEvent(a), true;
  }, e12.resetCameraClippingRange = function() {
    let n2 = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null) || e12.computeVisiblePropBounds();
    if (!areBoundsInitialized(n2))
      return vtkDebugMacro$1("Cannot reset camera clipping range!"), false;
    if (e12.getActiveCameraAndResetIfCreated(), !t.activeCamera)
      return vtkErrorMacro$7("Trying to reset clipping range of non-existent camera"), false;
    let a2 = t.activeCamera.computeClippingRange(n2), o = 0;
    if (t.activeCamera.getParallelProjection())
      o = 0.2 * t.activeCamera.getParallelScale();
    else {
      let e13 = radiansFromDegrees(t.activeCamera.getViewAngle());
      o = 0.2 * Math.tan(e13 / 2) * a2[1];
    }
    return a2[1] - a2[0] < o && (o = o - a2[1] + a2[0], a2[1] += o / 2, a2[0] -= o / 2), a2[0] < 0 && (a2[0] = 0), a2[0] = 0.99 * a2[0] - (a2[1] - a2[0]) * t.clippingRangeExpansion, a2[1] = 1.01 * a2[1] + (a2[1] - a2[0]) * t.clippingRangeExpansion, a2[0] = a2[0] >= a2[1] ? 0.01 * a2[1] : a2[0], t.nearClippingPlaneTolerance ||= 0.01, a2[0] < t.nearClippingPlaneTolerance * a2[1] && (a2[0] = t.nearClippingPlaneTolerance * a2[1]), t.activeCamera.setClippingRange(a2[0], a2[1]), e12.invokeEvent(r), false;
  }, e12.setRenderWindow = (e13) => {
    e13 !== t._renderWindow && (t._vtkWindow = e13, t._renderWindow = e13);
  }, e12.visibleActorCount = () => t.props.filter((e13) => e13.getVisibility()).length, e12.visibleVolumeCount = e12.visibleActorCount, e12.getMTime = () => {
    let e13 = t.mtime, n2 = t.activeCamera ? t.activeCamera.getMTime() : 0;
    n2 > e13 && (e13 = n2);
    let r2 = t._createdLight ? t._createdLight.getMTime() : 0;
    return r2 > e13 && (e13 = r2), e13;
  }, e12.getTransparent = () => !!t.preserveColorBuffer, e12.isActiveCameraCreated = () => !!t.activeCamera;
}
var DEFAULT_VALUES$31 = {
  pickedProp: null,
  activeCamera: null,
  allBounds: [],
  ambient: [
    1,
    1,
    1
  ],
  allocatedRenderTime: 100,
  timeFactor: 1,
  automaticLightCreation: true,
  twoSidedLighting: true,
  lastRenderTimeInSeconds: -1,
  renderWindow: null,
  lights: [],
  actors: [],
  volumes: [],
  lightFollowCamera: true,
  numberOfPropsRendered: 0,
  propArray: null,
  pathArray: null,
  layer: 0,
  preserveColorBuffer: false,
  preserveDepthBuffer: false,
  computeVisiblePropBounds: createUninitializedBounds(),
  interactive: true,
  nearClippingPlaneTolerance: 0,
  clippingRangeExpansion: 0.05,
  erase: true,
  draw: true,
  useShadows: false,
  useDepthPeeling: false,
  occlusionRatio: 0,
  maximumNumberOfPeels: 4,
  selector: null,
  delegate: null,
  texturedBackground: false,
  backgroundTexture: null,
  environmentTexture: null,
  environmentTextureDiffuseStrength: 1,
  environmentTextureSpecularStrength: 1,
  useEnvironmentTextureAsBackground: false,
  pass: 0
};
function extend$38(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  for (Object.assign(t, DEFAULT_VALUES$31, n), vtkViewport$1.extend(e12, t, n), t.background ||= [
    0,
    0,
    0,
    1
  ]; t.background.length < 3; )
    t.background.push(0);
  t.background.length === 3 && t.background.push(1), get(e12, t, [
    "_renderWindow",
    "allocatedRenderTime",
    "timeFactor",
    "lastRenderTimeInSeconds",
    "numberOfPropsRendered",
    "lastRenderingUsedDepthPeeling",
    "selector"
  ]), setGet(e12, t, [
    "twoSidedLighting",
    "lightFollowCamera",
    "automaticLightCreation",
    "erase",
    "draw",
    "nearClippingPlaneTolerance",
    "clippingRangeExpansion",
    "backingStore",
    "interactive",
    "layer",
    "preserveColorBuffer",
    "preserveDepthBuffer",
    "useDepthPeeling",
    "occlusionRatio",
    "maximumNumberOfPeels",
    "delegate",
    "backgroundTexture",
    "texturedBackground",
    "environmentTexture",
    "environmentTextureDiffuseStrength",
    "environmentTextureSpecularStrength",
    "useEnvironmentTextureAsBackground",
    "useShadows",
    "pass"
  ]), getArray(e12, t, [
    "actors",
    "volumes",
    "lights"
  ]), setGetArray(e12, t, ["background"], 4, 1), moveToProtected(e12, t, ["renderWindow"]), vtkRenderer(e12, t);
}
var vtkRenderer$1 = {
  newInstance: newInstance(extend$38, "vtkRenderer"),
  extend: extend$38
}, Constants$5 = {
  Device: {
    Unknown: 0,
    LeftController: 1,
    RightController: 2
  },
  Input: {
    Unknown: 0,
    Trigger: 1,
    TrackPad: 2,
    Grip: 3,
    Thumbstick: 4,
    A: 5,
    B: 6,
    ApplicationMenu: 7
  },
  Axis: {
    Unknown: 0,
    TouchpadX: 1,
    TouchpadY: 2,
    ThumbstickX: 3,
    ThumbstickY: 4
  },
  MouseButton: {
    LeftButton: 1,
    MiddleButton: 2,
    RightButton: 3
  }
}, { Device, Input } = Constants$5, { vtkWarningMacro, vtkErrorMacro: vtkErrorMacro$6, normalizeWheel, vtkOnceErrorMacro } = macro, EMPTY_MOUSE_EVENT = {
  ctrlKey: false,
  altKey: false,
  shiftKey: false
}, deviceInputMap = { "xr-standard": [
  Input.Trigger,
  Input.Grip,
  Input.TrackPad,
  Input.Thumbstick,
  Input.A,
  Input.B
] }, handledEvents = /* @__PURE__ */ "StartAnimation.Animation.EndAnimation.PointerEnter.PointerLeave.MouseEnter.MouseLeave.StartMouseMove.MouseMove.EndMouseMove.LeftButtonPress.LeftButtonRelease.MiddleButtonPress.MiddleButtonRelease.RightButtonPress.RightButtonRelease.KeyPress.KeyDown.KeyUp.StartMouseWheel.MouseWheel.EndMouseWheel.StartPinch.Pinch.EndPinch.StartPan.Pan.EndPan.StartRotate.Rotate.EndRotate.Button3D.Move3D.StartPointerLock.EndPointerLock.StartInteraction.Interaction.EndInteraction.AnimationFrameRateUpdate".split(".");
function preventDefault(e12) {
  e12.cancelable && e12.preventDefault();
}
function pointerCacheToPositions(e12) {
  let t = /* @__PURE__ */ Object.create(null);
  return e12.forEach((e13) => {
    let { pointerId: n, position: r } = e13;
    t[n] = r;
  }), t;
}
function vtkRenderWindowInteractor(e12, t) {
  t.classHierarchy.push("vtkRenderWindowInteractor");
  let n = { ...e12 }, r = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Map(), o = 1;
  e12.start = () => {
    !t.initialized && (e12.initialize(), !t.initialized) || e12.startEventLoop();
  }, e12.setRenderWindow = (e13) => {
    vtkErrorMacro$6("you want to call setView(view) instead of setRenderWindow on a vtk.js interactor");
  }, e12.setInteractorStyle = (n2) => {
    t.interactorStyle !== n2 && (t.interactorStyle != null && t.interactorStyle.setInteractor(null), t.interactorStyle = n2, t.interactorStyle != null && t.interactorStyle.getInteractor() !== e12 && t.interactorStyle.setInteractor(e12));
  }, e12.initialize = () => {
    t.initialized = true, e12.enable(), e12.render();
  }, e12.enable = () => e12.setEnabled(true), e12.disable = () => e12.setEnabled(false), e12.startEventLoop = () => vtkWarningMacro("empty event loop");
  function s(n2, r2) {
    t._forcedRenderer || (t.currentRenderer = e12.findPokedRenderer(n2, r2));
  }
  e12.getCurrentRenderer = () => (t.currentRenderer || s(0, 0), t.currentRenderer);
  function c(e13) {
    let n2 = t._view.getCanvas(), r2 = n2.getBoundingClientRect(), o2 = n2.width / r2.width, c2 = n2.height / r2.height, l2 = {
      x: o2 * (e13.clientX - r2.left),
      y: c2 * (r2.height - e13.clientY + r2.top),
      z: 0,
      movementX: o2 * e13.movementX,
      movementY: c2 * e13.movementY
    };
    return (a.size <= 1 || !t.currentRenderer) && s(l2.x, l2.y), l2;
  }
  let l = t._getScreenEventPositionFor || c;
  function u(e13) {
    return {
      controlKey: e13.ctrlKey,
      altKey: e13.altKey,
      shiftKey: e13.shiftKey
    };
  }
  function d(e13) {
    let t2 = u(e13);
    return {
      key: e13.key,
      keyCode: e13.charCode,
      ...t2
    };
  }
  function f(e13) {
    return e13.pointerType || "";
  }
  let p = () => {
    if (t.container === null)
      return;
    let { container: n2 } = t;
    n2.addEventListener("contextmenu", preventDefault), n2.addEventListener("wheel", e12.handleWheel), n2.addEventListener("DOMMouseScroll", e12.handleWheel), n2.addEventListener("pointerenter", e12.handlePointerEnter), n2.addEventListener("pointerleave", e12.handlePointerLeave), n2.addEventListener("pointermove", e12.handlePointerMove, { passive: false }), n2.addEventListener("pointerdown", e12.handlePointerDown, { passive: false }), n2.addEventListener("pointerup", e12.handlePointerUp), n2.addEventListener("pointercancel", e12.handlePointerCancel), n2.addEventListener("keypress", e12.handleKeyPress), n2.addEventListener("keydown", e12.handleKeyDown), document.addEventListener("keyup", e12.handleKeyUp), document.addEventListener("pointerlockchange", e12.handlePointerLockChange), n2.tabIndex = 0, n2.style.touchAction = "none", n2.style.userSelect = "none", n2.style.webkitTapHighlightColor = "rgba(0,0,0,0)";
  };
  e12.bindEvents = (e13) => {
    e13 !== null && n.setContainer(e13) && p();
  };
  let m = () => {
    clearTimeout(t.moveTimeoutID), clearTimeout(t.wheelTimeoutID), t.moveTimeoutID = 0, t.wheelTimeoutID = 0, o = 1;
    let { container: n2 } = t;
    n2 && (n2.removeEventListener("contextmenu", preventDefault), n2.removeEventListener("wheel", e12.handleWheel), n2.removeEventListener("DOMMouseScroll", e12.handleWheel), n2.removeEventListener("pointerenter", e12.handlePointerEnter), n2.removeEventListener("pointerleave", e12.handlePointerLeave), n2.removeEventListener("pointermove", e12.handlePointerMove, { passive: false }), n2.removeEventListener("pointerdown", e12.handlePointerDown, { passive: false }), n2.removeEventListener("pointerup", e12.handlePointerUp), n2.removeEventListener("pointercancel", e12.handlePointerCancel), n2.removeEventListener("keypress", e12.handleKeyPress), n2.removeEventListener("keydown", e12.handleKeyDown)), document.removeEventListener("keyup", e12.handleKeyUp), document.removeEventListener("pointerlockchange", e12.handlePointerLockChange), a.clear();
  };
  e12.unbindEvents = () => {
    m(), n.setContainer(null);
  }, e12.handleKeyPress = (t2) => {
    let n2 = d(t2);
    e12.keyPressEvent(n2);
  }, e12.handleKeyDown = (t2) => {
    let n2 = d(t2);
    e12.keyDownEvent(n2);
  }, e12.handleKeyUp = (t2) => {
    let n2 = d(t2);
    e12.keyUpEvent(n2);
  }, e12.handlePointerEnter = (t2) => {
    let n2 = {
      ...u(t2),
      position: l(t2),
      deviceType: f(t2)
    };
    e12.pointerEnterEvent(n2), n2.deviceType === "mouse" && e12.mouseEnterEvent(n2);
  }, e12.handlePointerLeave = (t2) => {
    let n2 = {
      ...u(t2),
      position: l(t2),
      deviceType: f(t2)
    };
    e12.pointerLeaveEvent(n2), n2.deviceType === "mouse" && e12.mouseLeaveEvent(n2);
  }, e12.handlePointerDown = (n2) => {
    if (!(n2.button > 2 || e12.isPointerLocked()))
      switch (t.preventDefaultOnPointerDown && preventDefault(n2), n2.target.hasPointerCapture(n2.pointerId) && n2.target.releasePointerCapture(n2.pointerId), t.container.setPointerCapture(n2.pointerId), a.has(n2.pointerId) && vtkWarningMacro("[RenderWindowInteractor] duplicate pointerId detected"), a.set(n2.pointerId, {
        pointerId: n2.pointerId,
        position: l(n2)
      }), n2.pointerType) {
        case "pen":
        case "touch":
          e12.handleTouchStart(n2);
          break;
        case "mouse":
        default:
          e12.handleMouseDown(n2);
          break;
      }
  }, e12.handlePointerUp = (n2) => {
    if (a.has(n2.pointerId))
      switch (t.preventDefaultOnPointerUp && preventDefault(n2), a.delete(n2.pointerId), t.container.releasePointerCapture(n2.pointerId), n2.pointerType) {
        case "pen":
        case "touch":
          e12.handleTouchEnd(n2);
          break;
        case "mouse":
        default:
          e12.handleMouseUp(n2);
          break;
      }
  }, e12.handlePointerCancel = (t2) => {
    if (a.has(t2.pointerId))
      switch (a.delete(t2.pointerId), t2.pointerType) {
        case "pen":
        case "touch":
          e12.handleTouchEnd(t2);
          break;
        case "mouse":
        default:
          e12.handleMouseUp(t2);
          break;
      }
  }, e12.handlePointerMove = (t2) => {
    if (a.has(t2.pointerId)) {
      let e13 = a.get(t2.pointerId);
      e13.position = l(t2);
    }
    switch (t2.pointerType) {
      case "pen":
      case "touch":
        e12.handleTouchMove(t2);
        break;
      case "mouse":
      default:
        e12.handleMouseMove(t2);
        break;
    }
  }, e12.handleMouseDown = (t2) => {
    let n2 = {
      ...u(t2),
      position: l(t2),
      deviceType: f(t2)
    };
    switch (t2.button) {
      case 0:
        e12.leftButtonPressEvent(n2);
        break;
      case 1:
        e12.middleButtonPressEvent(n2);
        break;
      case 2:
        e12.rightButtonPressEvent(n2);
        break;
      default:
        vtkErrorMacro$6(`Unknown mouse button pressed: ${t2.button}`);
        break;
    }
  }, e12.requestPointerLock = () => {
    t.container && t.container.requestPointerLock();
  }, e12.exitPointerLock = () => document.exitPointerLock?.(), e12.isPointerLocked = () => !!t.container && document.pointerLockElement === t.container, e12.handlePointerLockChange = () => {
    e12.isPointerLocked() ? e12.startPointerLockEvent() : e12.endPointerLockEvent();
  };
  function h() {
    t._view && t.enabled && t.enableRender && (t.inRender = true, t._view.traverseAllPasses(), t.inRender = false), e12.invokeRenderEvent();
  }
  e12.requestAnimation = (n2) => {
    if (n2 === void 0) {
      vtkErrorMacro$6("undefined requester, can not start animating");
      return;
    }
    if (r.has(n2)) {
      vtkWarningMacro("requester is already registered for animating");
      return;
    }
    r.add(n2), !t.animationRequest && r.size === 1 && !t.xrAnimation && (t._animationStartTime = Date.now(), t._animationFrameCount = 0, t.animationRequest = requestAnimationFrame(e12.handleAnimation), e12.startAnimationEvent());
  }, e12.extendAnimation = (n2) => {
    let a2 = Date.now() + n2;
    t._animationExtendedEnd = Math.max(t._animationExtendedEnd, a2), !t.animationRequest && r.size === 0 && !t.xrAnimation && (t._animationStartTime = Date.now(), t._animationFrameCount = 0, t.animationRequest = requestAnimationFrame(e12.handleAnimation), e12.startAnimationEvent());
  }, e12.isAnimating = () => t.xrAnimation || t.animationRequest !== null, e12.cancelAnimation = function(n2) {
    let a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!r.has(n2)) {
      a2 || vtkWarningMacro(`${n2 && n2.getClassName ? n2.getClassName() : n2} did not request an animation`);
      return;
    }
    r.delete(n2), t.animationRequest && r.size === 0 && Date.now() > t._animationExtendedEnd && (cancelAnimationFrame(t.animationRequest), t.animationRequest = null, e12.endAnimationEvent(), e12.render());
  }, e12.switchToXRAnimation = () => {
    t.animationRequest &&= (cancelAnimationFrame(t.animationRequest), null), t.xrAnimation = true;
  }, e12.returnFromXRAnimation = () => {
    t.xrAnimation = false, r.size !== 0 && (t.recentAnimationFrameRate = 10, t.animationRequest = requestAnimationFrame(e12.handleAnimation));
  }, e12.updateXRGamepads = (n2, r2, a2) => {
    n2.inputSources.forEach((n3) => {
      let o2 = n3.gripSpace == null ? null : r2.getPose(n3.gripSpace, a2), s2 = n3.gripSpace == null ? null : r2.getPose(n3.targetRaySpace, a2), c2 = n3.gamepad, l2 = n3.handedness;
      if (c2) {
        c2.index in t.lastGamepadValues || (t.lastGamepadValues[c2.index] = {
          left: { buttons: {} },
          right: { buttons: {} },
          none: { buttons: {} }
        });
        for (let r3 = 0; r3 < c2.buttons.length; ++r3)
          r3 in t.lastGamepadValues[c2.index][l2].buttons || (t.lastGamepadValues[c2.index][l2].buttons[r3] = false), t.lastGamepadValues[c2.index][l2].buttons[r3] !== c2.buttons[r3].pressed && o2 != null && (e12.button3DEvent({
            gamepad: c2,
            position: o2.transform.position,
            orientation: o2.transform.orientation,
            targetPosition: s2.transform.position,
            targetOrientation: s2.transform.orientation,
            pressed: c2.buttons[r3].pressed,
            device: n3.handedness === "left" ? Device.LeftController : Device.RightController,
            input: deviceInputMap[c2.mapping] && deviceInputMap[c2.mapping][r3] ? deviceInputMap[c2.mapping][r3] : Input.Trigger
          }), t.lastGamepadValues[c2.index][l2].buttons[r3] = c2.buttons[r3].pressed), t.lastGamepadValues[c2.index][l2].buttons[r3] && o2 != null && e12.move3DEvent({
            gamepad: c2,
            position: o2.transform.position,
            orientation: o2.transform.orientation,
            targetPosition: s2.transform.position,
            targetOrientation: s2.transform.orientation,
            device: n3.handedness === "left" ? Device.LeftController : Device.RightController
          });
      }
    });
  }, e12.handleMouseMove = (n2) => {
    let r2 = {
      ...u(n2),
      position: l(n2),
      deviceType: f(n2)
    };
    t.moveTimeoutID === 0 ? e12.startMouseMoveEvent(r2) : (e12.mouseMoveEvent(r2), clearTimeout(t.moveTimeoutID)), t.moveTimeoutID = setTimeout(() => {
      e12.endMouseMoveEvent(), t.moveTimeoutID = 0;
    }, 200);
  }, e12.handleAnimation = () => {
    let n2 = Date.now();
    t._animationFrameCount++, n2 - t._animationStartTime > 1e3 && t._animationFrameCount > 1 && (t.recentAnimationFrameRate = 1e3 * (t._animationFrameCount - 1) / (n2 - t._animationStartTime), t.lastFrameTime = 1 / t.recentAnimationFrameRate, e12.animationFrameRateUpdateEvent(), t._animationStartTime = n2, t._animationFrameCount = 1), e12.animationEvent(), h(), r.size > 0 || Date.now() < t._animationExtendedEnd ? t.animationRequest = requestAnimationFrame(e12.handleAnimation) : (cancelAnimationFrame(t.animationRequest), t.animationRequest = null, e12.endAnimationEvent(), e12.render());
  }, e12.handleWheel = (n2) => {
    preventDefault(n2);
    let r2 = {
      ...normalizeWheel(n2),
      ...u(n2),
      position: l(n2),
      deviceType: f(n2)
    };
    t.wheelTimeoutID === 0 && (o = Math.abs(r2.spinY) >= 0.3 ? Math.abs(r2.spinY) : 1), r2.spinY /= o, t.wheelTimeoutID === 0 ? (e12.startMouseWheelEvent(r2), e12.mouseWheelEvent(r2)) : (e12.mouseWheelEvent(r2), clearTimeout(t.wheelTimeoutID)), t.mouseScrollDebounceByPass ? (e12.extendAnimation(600), e12.endMouseWheelEvent(), t.wheelTimeoutID = 0) : t.wheelTimeoutID = setTimeout(() => {
      e12.extendAnimation(600), e12.endMouseWheelEvent(), t.wheelTimeoutID = 0;
    }, 200);
  }, e12.handleMouseUp = (t2) => {
    let n2 = {
      ...u(t2),
      position: l(t2),
      deviceType: f(t2)
    };
    switch (t2.button) {
      case 0:
        e12.leftButtonReleaseEvent(n2);
        break;
      case 1:
        e12.middleButtonReleaseEvent(n2);
        break;
      case 2:
        e12.rightButtonReleaseEvent(n2);
        break;
      default:
        vtkErrorMacro$6(`Unknown mouse button released: ${t2.button}`);
        break;
    }
  }, e12.handleTouchStart = (n2) => {
    let r2 = [...a.values()];
    if (t.recognizeGestures && r2.length > 1) {
      let t2 = pointerCacheToPositions(a);
      if (r2.length === 2) {
        let t3 = {
          ...u(EMPTY_MOUSE_EVENT),
          position: r2[0].position,
          deviceType: f(n2)
        };
        e12.leftButtonReleaseEvent(t3);
      }
      e12.recognizeGesture("TouchStart", t2);
    } else if (r2.length === 1) {
      let t2 = {
        ...u(EMPTY_MOUSE_EVENT),
        position: l(n2),
        deviceType: f(n2)
      };
      e12.leftButtonPressEvent(t2);
    }
  }, e12.handleTouchMove = (n2) => {
    let r2 = [...a.values()];
    if (t.recognizeGestures && r2.length > 1) {
      let t2 = pointerCacheToPositions(a);
      e12.recognizeGesture("TouchMove", t2);
    } else if (r2.length === 1) {
      let t2 = {
        ...u(EMPTY_MOUSE_EVENT),
        position: r2[0].position,
        deviceType: f(n2)
      };
      e12.mouseMoveEvent(t2);
    }
  }, e12.handleTouchEnd = (n2) => {
    let r2 = [...a.values()];
    if (t.recognizeGestures)
      if (r2.length === 0) {
        let t2 = {
          ...u(EMPTY_MOUSE_EVENT),
          position: l(n2),
          deviceType: f(n2)
        };
        e12.leftButtonReleaseEvent(t2);
      } else if (r2.length === 1) {
        let t2 = pointerCacheToPositions(a);
        e12.recognizeGesture("TouchEnd", t2);
        let o2 = {
          ...u(EMPTY_MOUSE_EVENT),
          position: r2[0].position,
          deviceType: f(n2)
        };
        e12.leftButtonPressEvent(o2);
      } else {
        let t2 = pointerCacheToPositions(a);
        e12.recognizeGesture("TouchMove", t2);
      }
    else if (r2.length === 1) {
      let t2 = {
        ...u(EMPTY_MOUSE_EVENT),
        position: r2[0].position,
        deviceType: f(n2)
      };
      e12.leftButtonReleaseEvent(t2);
    }
  }, e12.setView = (n2) => {
    t._view !== n2 && (t._view = n2, t._view.getRenderable().setInteractor(e12), e12.modified());
  }, e12.getFirstRenderer = () => t._view?.getRenderable()?.getRenderersByReference()?.[0], e12.findPokedRenderer = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!t._view)
      return null;
    let r2 = t._view?.getRenderable()?.getRenderers();
    if (!r2 || r2.length === 0)
      return null;
    r2.sort((e14, t2) => e14.getLayer() - t2.getLayer());
    let a2 = null, o2 = null, s2 = null, c2 = r2.length;
    for (; c2--; ) {
      let l2 = r2[c2];
      if (t._view.isInViewport(e13, n2, l2) && l2.getInteractive()) {
        s2 = l2;
        break;
      }
      a2 === null && l2.getInteractive() && (a2 = l2), o2 === null && t._view.isInViewport(e13, n2, l2) && (o2 = l2);
    }
    return s2 === null && (s2 = a2), s2 === null && (s2 = o2), s2 ??= r2[0], s2;
  }, e12.render = () => {
    !e12.isAnimating() && !t.inRender && h();
  }, handledEvents.forEach((n2) => {
    let r2 = n2.charAt(0).toLowerCase() + n2.slice(1);
    e12[`${r2}Event`] = (r3) => {
      if (!t.enabled)
        return;
      if (!e12.getCurrentRenderer()) {
        vtkOnceErrorMacro("\n          Can not forward events without a current renderer on the interactor.\n        ");
        return;
      }
      let a2 = {
        type: n2,
        pokedRenderer: t.currentRenderer,
        firstRenderer: e12.getFirstRenderer(),
        ...r3
      };
      e12[`invoke${n2}`](a2);
    };
  }), e12.recognizeGesture = (n2, r2) => {
    if (Object.keys(r2).length > 2)
      return;
    if (t.startingEventPositions ||= {}, n2 === "TouchStart") {
      Object.keys(r2).forEach((e13) => {
        t.startingEventPositions[e13] = r2[e13];
      }), t.currentGesture = "Start";
      return;
    }
    if (n2 === "TouchEnd") {
      t.currentGesture === "Pinch" && (e12.render(), e12.endPinchEvent()), t.currentGesture === "Rotate" && (e12.render(), e12.endRotateEvent()), t.currentGesture === "Pan" && (e12.render(), e12.endPanEvent()), t.currentGesture = "Start", t.startingEventPositions = {};
      return;
    }
    let a2 = 0, o2 = [], s2 = [];
    Object.keys(r2).forEach((e13) => {
      o2[a2] = r2[e13], s2[a2] = t.startingEventPositions[e13], a2++;
    });
    let c2 = Math.sqrt((s2[0].x - s2[1].x) * (s2[0].x - s2[1].x) + (s2[0].y - s2[1].y) * (s2[0].y - s2[1].y)), l2 = Math.sqrt((o2[0].x - o2[1].x) * (o2[0].x - o2[1].x) + (o2[0].y - o2[1].y) * (o2[0].y - o2[1].y)), u2 = degreesFromRadians(Math.atan2(s2[1].y - s2[0].y, s2[1].x - s2[0].x)), d2 = degreesFromRadians(Math.atan2(o2[1].y - o2[0].y, o2[1].x - o2[0].x)), f2 = d2 - u2;
    d2 = d2 + 180 >= 360 ? d2 - 180 : d2 + 180, u2 = u2 + 180 >= 360 ? u2 - 180 : u2 + 180, Math.abs(d2 - u2) < Math.abs(f2) && (f2 = d2 - u2);
    let p2 = [];
    if (p2[0] = (o2[0].x - s2[0].x + o2[1].x - s2[1].x) / 2, p2[1] = (o2[0].y - s2[0].y + o2[1].y - s2[1].y) / 2, n2 === "TouchMove")
      if (t.currentGesture === "Start") {
        let n3 = 0.01 * Math.sqrt(t.container.clientWidth * t.container.clientWidth + t.container.clientHeight * t.container.clientHeight);
        n3 < 15 && (n3 = 15);
        let a3 = Math.abs(l2 - c2), o3 = l2 * 3.1415926 * Math.abs(f2) / 360, s3 = Math.sqrt(p2[0] * p2[0] + p2[1] * p2[1]);
        if (a3 > n3 && a3 > o3 && a3 > s3) {
          t.currentGesture = "Pinch";
          let n4 = {
            scale: 1,
            touches: r2
          };
          e12.startPinchEvent(n4);
        } else if (o3 > n3 && o3 > s3) {
          t.currentGesture = "Rotate";
          let n4 = {
            rotation: 0,
            touches: r2
          };
          e12.startRotateEvent(n4);
        } else if (s3 > n3) {
          t.currentGesture = "Pan";
          let n4 = {
            translation: [0, 0],
            touches: r2
          };
          e12.startPanEvent(n4);
        }
      } else {
        if (t.currentGesture === "Rotate") {
          let t2 = {
            rotation: f2,
            touches: r2
          };
          e12.rotateEvent(t2);
        }
        if (t.currentGesture === "Pinch") {
          let t2 = {
            scale: l2 / c2,
            touches: r2
          };
          e12.pinchEvent(t2);
        }
        if (t.currentGesture === "Pan") {
          let t2 = {
            translation: p2,
            touches: r2
          };
          e12.panEvent(t2);
        }
      }
  }, e12.handleVisibilityChange = () => {
    t._animationStartTime = Date.now(), t._animationFrameCount = 0;
  }, e12.setCurrentRenderer = (e13) => {
    t._forcedRenderer = !!e13, t.currentRenderer = e13;
  }, e12.setContainer = (e13) => {
    m();
    let t2 = n.setContainer(e13 ?? null);
    return t2 && p(), t2;
  }, e12.delete = () => {
    for (; r.size; )
      e12.cancelAnimation(r.values().next().value);
    document.hidden !== void 0 && document.removeEventListener("visibilitychange", e12.handleVisibilityChange), t.container && e12.setContainer(null), n.delete();
  }, document.hidden !== void 0 && document.addEventListener("visibilitychange", e12.handleVisibilityChange, false);
}
var DEFAULT_VALUES$30 = {
  renderWindow: null,
  interactorStyle: null,
  picker: null,
  pickingManager: null,
  initialized: false,
  enabled: false,
  enableRender: true,
  currentRenderer: null,
  lightFollowCamera: true,
  desiredUpdateRate: 30,
  stillUpdateRate: 2,
  container: null,
  recognizeGestures: true,
  currentGesture: "Start",
  animationRequest: null,
  lastFrameTime: 0.1,
  recentAnimationFrameRate: 10,
  wheelTimeoutID: 0,
  moveTimeoutID: 0,
  lastGamepadValues: {},
  preventDefaultOnPointerDown: false,
  preventDefaultOnPointerUp: false,
  mouseScrollDebounceByPass: false
};
function extend$37(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$30, n), macro.obj(e12, t), t._animationExtendedEnd = 0, macro.event(e12, t, "RenderEvent"), handledEvents.forEach((n2) => macro.event(e12, t, n2)), macro.get(e12, t, [
    "initialized",
    "interactorStyle",
    "lastFrameTime",
    "recentAnimationFrameRate",
    "_view"
  ]), macro.setGet(e12, t, [
    "container",
    "lightFollowCamera",
    "enabled",
    "enableRender",
    "recognizeGestures",
    "desiredUpdateRate",
    "stillUpdateRate",
    "picker",
    "preventDefaultOnPointerDown",
    "preventDefaultOnPointerUp",
    "mouseScrollDebounceByPass"
  ]), macro.moveToProtected(e12, t, ["view"]), vtkRenderWindowInteractor(e12, t);
}
var vtkRenderWindowInteractor$1 = {
  newInstance: macro.newInstance(extend$37, "vtkRenderWindowInteractor"),
  extend: extend$37,
  handledEvents,
  ...Constants$5
};
function vtkActor(e12, t) {
  t.classHierarchy.push("vtkActor");
  let n = { ...e12 };
  e12.getActors = () => [e12], e12.getIsOpaque = () => {
    if (t.forceOpaque)
      return true;
    if (t.forceTranslucent)
      return false;
    t.properties[0] || e12.getProperty();
    let n2 = t.properties[0].getOpacity() >= 1;
    return n2 &&= !t.texture || !t.texture.isTranslucent(), n2 &&= !t.mapper || t.mapper.getIsOpaque(), n2;
  }, e12.hasTranslucentPolygonalGeometry = () => t.mapper === null ? false : (t.properties[0] || e12.getProperty(), !e12.getIsOpaque()), e12.makeProperty = vtkProperty$1.newInstance, e12.getMTime = () => {
    let e13 = n.getMTime();
    if (t.backfaceProperty !== null) {
      let n2 = t.backfaceProperty.getMTime();
      e13 = n2 > e13 ? n2 : e13;
    }
    return e13;
  }, e12.getRedrawMTime = () => {
    let e13 = t.mtime;
    if (t.mapper !== null) {
      let n2 = t.mapper.getMTime();
      e13 = n2 > e13 ? n2 : e13, t.mapper.getInput() !== null && (t.mapper.getInputAlgorithm().update(), n2 = t.mapper.getInput().getMTime(), e13 = n2 > e13 ? n2 : e13);
    }
    return e13;
  }, e12.getSupportsSelection = () => t.mapper ? t.mapper.getSupportsSelection() : false, e12.processSelectorPixelBuffers = (e13, n2) => {
    t.mapper && t.mapper.processSelectorPixelBuffers && t.mapper.processSelectorPixelBuffers(e13, n2);
  };
}
var DEFAULT_VALUES$29 = {
  mapper: null,
  backfaceProperty: null,
  forceOpaque: false,
  forceTranslucent: false
};
function extend$36(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$29, n), vtkProp3D$1.extend(e12, t, n), t.boundsMTime = {}, macro.obj(t.boundsMTime), macro.setGet(e12, t, [
    "backfaceProperty",
    "forceOpaque",
    "forceTranslucent",
    "mapper"
  ]), vtkActor(e12, t);
}
var vtkActor$1 = {
  newInstance: macro.newInstance(extend$36, "vtkActor"),
  extend: extend$36
};
function vtkOffscreenMultiRenderWindow(e12, t) {
  let n = e12.invokeResize;
  delete e12.invokeResize, t.renderWindow = vtkRenderWindow$1.newInstance(), t.rendererMap = {}, t.openGLRenderWindow = vtkStreamingOpenGLRenderWindow_default.newInstance(), t.renderWindow.addView(t.openGLRenderWindow), t.interactor = vtkRenderWindowInteractor$1.newInstance(), t.interactor.setView(t.openGLRenderWindow), t.interactor.initialize(), e12.addRenderer = ({ viewport: e13, id: n2, background: r }) => {
    let a = vtkRenderer$1.newInstance({
      viewport: e13,
      background: r || t.background
    });
    t.renderWindow.addRenderer(a), t.rendererMap[n2] = a;
  }, e12.destroy = () => {
    t.renderWindow.getInteractor().delete();
  }, e12.removeRenderer = (n2) => {
    let r = e12.getRenderer(n2);
    t.renderWindow.removeRenderer(r), r.delete(), delete t.rendererMap[n2];
  }, e12.getRenderer = (e13) => t.rendererMap[e13], e12.getRenderers = () => {
    let { rendererMap: e13 } = t;
    return Object.keys(e13).map((t2) => ({
      id: t2,
      renderer: e13[t2]
    }));
  }, e12.resize = () => {
    if (t.container) {
      let { width: e13, height: r } = t.container;
      t.openGLRenderWindow.setSize(Math.floor(e13), Math.floor(r)), n(), t.renderWindow.render();
    }
  }, e12.setContainer = (e13) => {
    t.container = e13, t.openGLRenderWindow.setContainer(t.container);
  }, e12.delete = macro.chain(e12.setContainer, e12.destroy, t.openGLRenderWindow.delete, e12.delete), e12.resize();
}
var DEFAULT_VALUES$28 = {
  background: [
    0,
    0,
    0
  ],
  container: null
};
function extend$35(e12, t, n = {}) {
  Object.assign(t, DEFAULT_VALUES$28, n), macro.obj(e12, t), macro.get(e12, t, [
    "renderWindow",
    "openGLRenderWindow",
    "interactor",
    "container"
  ]), macro.event(e12, t, "resize"), vtkOffscreenMultiRenderWindow(e12, t);
}
var vtkOffscreenMultiRenderWindow_default = {
  newInstance: macro.newInstance(extend$35),
  extend: extend$35
}, { BlendMode } = Constants$4;
function createRadonTransferFunction(e12, t, n, r, a) {
  let o = null;
  return a ? (o = a, o.removeAllPoints()) : o = vtkPiecewiseFunction$1.newInstance(), o.addPointLong(-1024, 0, 1, 1), o.addPoint(e12, t), o.addPoint(n, r), o;
}
var methodNamesMovedToVolumeProperties = /* @__PURE__ */ "getAnisotropy.getComputeNormalFromOpacity.getFilterMode.getFilterModeAsString.getGlobalIlluminationReach.getIpScalarRange.getIpScalarRangeByReference.getLAOKernelRadius.getLAOKernelSize.getLocalAmbientOcclusion.getPreferSizeOverAccuracy.getVolumetricScatteringBlending.setAnisotropy.setAverageIPScalarRange.setComputeNormalFromOpacity.setFilterMode.setFilterModeToNormalized.setFilterModeToOff.setFilterModeToRaw.setGlobalIlluminationReach.setIpScalarRange.setIpScalarRangeFrom.setLAOKernelRadius.setLAOKernelSize.setLocalAmbientOcclusion.setPreferSizeOverAccuracy.setVolumetricScatteringBlending".split("."), STATIC$2 = { createRadonTransferFunction };
function vtkVolumeMapper(e12, t) {
  t.classHierarchy.push("vtkVolumeMapper");
  let n = { ...e12 };
  e12.getBounds = () => (t.static || e12.update(), t.bounds = [...e12.getInputData().getBounds()], t.bounds), e12.setBlendModeToComposite = () => {
    e12.setBlendMode(BlendMode.COMPOSITE_BLEND);
  }, e12.setBlendModeToMaximumIntensity = () => {
    e12.setBlendMode(BlendMode.MAXIMUM_INTENSITY_BLEND);
  }, e12.setBlendModeToMinimumIntensity = () => {
    e12.setBlendMode(BlendMode.MINIMUM_INTENSITY_BLEND);
  }, e12.setBlendModeToAverageIntensity = () => {
    e12.setBlendMode(BlendMode.AVERAGE_INTENSITY_BLEND);
  }, e12.setBlendModeToAdditiveIntensity = () => {
    e12.setBlendMode(BlendMode.ADDITIVE_INTENSITY_BLEND);
  }, e12.setBlendModeToRadonTransform = () => {
    e12.setBlendMode(BlendMode.RADON_TRANSFORM_BLEND);
  }, e12.getBlendModeAsString = () => macro.enumToString(BlendMode, t.blendMode), e12.setVolumeShadowSamplingDistFactor = (e13) => n.setVolumeShadowSamplingDistFactor(e13 >= 1 ? e13 : 1), methodNamesMovedToVolumeProperties.forEach((t2) => {
    e12[t2] = () => {
      throw Error(`The method "volumeMapper.${t2}()" doesn't exist anymore. It is a rendering property that has been moved to the volume property. Replace your code with:
volumeActor.getProperty().${t2}()
`);
    };
  });
}
var defaultValues$5 = (e12) => ({
  bounds: [...vtkBoundingBox.INIT_BOUNDS],
  sampleDistance: 1,
  imageSampleDistance: 1,
  maximumSamplesPerRay: 1e3,
  autoAdjustSampleDistances: true,
  initialInteractionScale: 1,
  interactionSampleDistanceFactor: 1,
  blendMode: BlendMode.COMPOSITE_BLEND,
  volumeShadowSamplingDistFactor: 5,
  colorTextureWidth: 1024,
  opacityTextureWidth: 1024,
  labelOutlineTextureWidth: 1024,
  ...e12
});
function extend$34(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, defaultValues$5(n)), vtkAbstractMapper3D$1.extend(e12, t, n), macro.setGet(e12, t, [
    "sampleDistance",
    "imageSampleDistance",
    "maximumSamplesPerRay",
    "autoAdjustSampleDistances",
    "initialInteractionScale",
    "interactionSampleDistanceFactor",
    "blendMode",
    "volumeShadowSamplingDistFactor",
    "colorTextureWidth",
    "opacityTextureWidth",
    "labelOutlineTextureWidth"
  ]), macro.event(e12, t, "lightingActivated"), vtkVolumeMapper(e12, t);
}
var vtkVolumeMapper$1 = {
  newInstance: macro.newInstance(extend$34, "vtkVolumeMapper"),
  extend: extend$34,
  ...STATIC$2
};
function vtkSharedVolumeMapper(e12, t) {
  t.classHierarchy.push("vtkSharedVolumeMapper");
  let n = e12.delete;
  e12.delete = () => {
    t.scalarTexture = null, n();
  };
}
var DEFAULT_VALUES$27 = { scalarTexture: null };
function extend$33(e12, t, n = {}) {
  Object.assign(t, DEFAULT_VALUES$27, n), vtkVolumeMapper$1.extend(e12, t, n), macro.setGet(e12, t, ["scalarTexture"]), vtkSharedVolumeMapper(e12, t);
}
var vtkSharedVolumeMapper_default = {
  newInstance: macro.newInstance(extend$33, "vtkSharedVolumeMapper"),
  extend: extend$33
};
function getConstructorFromType(e12, t) {
  switch (e12) {
    case "Float32Array":
      return Float32Array;
    case "Uint8Array":
      return Uint8Array;
    case "Uint32Array":
      return Uint32Array;
    case "Uint16Array":
    case "Int16Array":
      return t ? (console.debug(`${e12} is not supported for volume rendering, switching back to Float32Array`), Float32Array) : e12 === "Uint16Array" ? Uint16Array : Int16Array;
    default:
      if (e12)
        throw Error("TargetBuffer should be Float32Array, Uint8Array, Uint16Array, Int16Array, or Uint32Array");
      return Float32Array;
  }
}
function getBufferConfiguration(e12, t, n = {}) {
  let { isVolumeBuffer: r = false } = n, a = getConstructorFromType(e12, r);
  return {
    numBytes: t * a.BYTES_PER_ELEMENT,
    TypedArrayConstructor: a
  };
}
function convertDataType(e12, t) {
  let n = new (getConstructorFromType(t))(e12.length);
  return n.set(e12), n;
}
function vtkStreamingOpenGLTexture(e12, t) {
  t.classHierarchy.push("vtkStreamingOpenGLTexture"), t.updatedFrames = [], t.volumeId = null;
  let n = e12.create3DFilterableFromRaw;
  e12.create3DFilterableFromRaw = ({ width: r2, height: a2, depth: o2, numberOfComponents: s2, numComps: c, dataType: l, data: u, preferSizeOverAccuracy: d, updatedExtents: f }) => {
    let p = s2 ?? c;
    if (t.inputDataType = l, t.inputNumComps = p, u === null) {
      e12.getOpenGLDataType(l);
      let n2 = !!d, s3 = false;
      if (t._openGLRenderWindow.getWebgl2())
        s3 = t.openGLDataType === t.context.FLOAT && t.context.getExtension("OES_texture_float_linear") === null && n2 || t.openGLDataType === t.context.HALF_FLOAT;
      else {
        let e13 = t.context.getExtension("OES_texture_half_float");
        s3 = !!e13 && t.openGLDataType === e13.HALF_FLOAT_OES;
      }
      t.canUseHalfFloat = s3 && n2, e12.create3DFromRaw({
        width: r2,
        height: a2,
        depth: o2,
        numComps: p,
        dataType: l,
        data: null,
        updatedExtents: f
      });
      return;
    }
    n({
      width: r2,
      height: a2,
      depth: o2,
      numComps: p,
      dataType: l,
      data: u,
      preferSizeOverAccuracy: d
    });
  };
  let r = e12.updateVolumeInfoForGL;
  e12.updateVolumeInfoForGL = (e13, n2) => {
    let a2 = r(e13, n2), o2 = (t.volumeId ? cache_default.getVolume(t.volumeId) : null)?.voxelManager?.getRange?.(), s2 = Array.isArray(o2) ? o2[0] : 0, c = Array.isArray(o2) ? o2[1] : 0, l = Number.isFinite(c) && Number.isFinite(s2) && c - s2 || 1, u = Number.isFinite(s2) ? s2 : 0, d = Math.max(1, Math.min(n2 ?? 1, 4));
    return t.volumeInfo.dataComputedScale = Array(d).fill(l), t.volumeInfo.dataComputedOffset = Array(d).fill(u), a2;
  }, e12.update3DFromRaw = () => {
    let { volumeId: n2 } = t;
    if (!n2)
      return;
    let r2 = cache_default.getVolume(n2);
    if (r2) {
      if (t._openGLRenderWindow.activateTexture(e12), e12.createTexture(), e12.bind(), r2.isDynamicVolume()) {
        s();
        return;
      }
      return e12.hasUpdatedFrames() && o();
    }
  };
  let a = e12.modified;
  e12.setUpdatedFrame = (e13) => {
    t.updatedFrames[e13] = true, a();
  }, e12.modified = () => {
    a();
    let e13 = cache_default.getVolume(t.volumeId);
    if (!e13)
      return;
    let n2 = e13.imageIds;
    for (let e14 = 0; e14 < n2.length; e14++)
      t.updatedFrames[e14] = true;
  };
  function o() {
    let n2 = cache_default.getVolume(t.volumeId), r2 = n2.imageIds;
    for (let a2 = 0; a2 < t.updatedFrames.length; a2++)
      if (t.updatedFrames[a2]) {
        let o2 = cache_default.getImage(r2[a2]);
        if (!o2)
          continue;
        let s2 = o2.voxelManager.getScalarData(), c = t.context;
        n2.dataType !== s2.constructor.name && (s2 = convertDataType(s2, n2.dataType));
        let [l] = e12.updateArrayDataTypeForGL(n2.dataType, [s2]);
        e12.bind();
        let u = a2;
        c.texSubImage3D(t.target, 0, 0, 0, u, t.width, t.height, 1, t.format, t.openGLDataType, l), e12.deactivate(), t.updatedFrames[a2] = null;
      }
    return t.generateMipmap && t.context.generateMipmap(t.target), e12.deactivate(), true;
  }
  function s() {
    let n2 = cache_default.getVolume(t.volumeId), r2 = n2.getCurrentDimensionGroupImageIds();
    if (!r2.length)
      return false;
    let a2;
    for (let o2 = 0; o2 < r2.length; o2++) {
      let s2 = r2[o2], c = cache_default.getImage(s2), l;
      c ? (l = c.voxelManager.getScalarData(), a2 = l.constructor) : (a2 = getConstructorFromType(n2.dataType, true), l = new a2(t.width * t.height));
      let u = t.context;
      n2.dataType !== l.constructor.name && (l = convertDataType(l, n2.dataType));
      let [d] = e12.updateArrayDataTypeForGL(n2.dataType, [l]);
      e12.bind();
      let f = o2;
      u.texSubImage3D(t.target, 0, 0, 0, f, t.width, t.height, 1, t.format, t.openGLDataType, d), e12.deactivate();
    }
    return t.generateMipmap && t.context.generateMipmap(t.target), e12.deactivate(), true;
  }
  e12.hasUpdatedFrames = () => !t.updatedFrames.length || t.updatedFrames.some((e13) => e13), e12.getUpdatedFrames = () => t.updatedFrames, e12.setVolumeId = (e13) => {
    t.volumeId = e13;
  }, e12.getVolumeId = () => t.volumeId, e12.setTextureParameters = ({ width: e13, height: n2, depth: r2, numberOfComponents: a2, dataType: o2 }) => {
    t.width ??= e13, t.height ??= n2, t.depth ??= r2, t.inputNumComps ??= a2, t.inputDataType ??= o2;
  }, e12.getTextureParameters = () => ({
    width: t.width,
    height: t.height,
    depth: t.depth,
    numberOfComponents: t.inputNumComps,
    dataType: t.inputDataType
  });
}
var DEFAULT_VALUES$26 = { updatedFrames: [] };
function extend$32(e12, t, n = {}) {
  Object.assign(t, DEFAULT_VALUES$26, n), vtkOpenGLTexture$1.extend(e12, t, n), vtkStreamingOpenGLTexture(e12, t);
}
var vtkStreamingOpenGLTexture_default = {
  newInstance: macro.newInstance(extend$32, "vtkStreamingOpenGLTexture"),
  extend: extend$32
};
function getProjectionScaleMatrix(e12) {
  let [t, n] = e12;
  return fromScaling(create$5(), [
    t,
    n,
    1
  ]);
}
var EPSILON$1 = 1e10;
const getNormalizedAspectRatio = (e12) => {
  let [t, n] = e12;
  if (isEqual_default(t, n))
    return [1, 1];
  let r = Math.min(t, n);
  return [Math.round(t / r * EPSILON$1) / EPSILON$1, Math.round(n / r * EPSILON$1) / EPSILON$1];
};
function extendedVtkCamera(e12, t) {
  t.classHierarchy.push("extendedVtkCamera");
  let n = e12.getProjectionMatrix;
  e12.getProjectionMatrix = (e13, r, a) => {
    let o = n(e13, r, a), [s, c] = getNormalizedAspectRatio(t.aspectRatio);
    return (s !== 1 || c !== 1) && multiply$2(o, getProjectionScaleMatrix([s, c]), o), o;
  }, e12.getAspectRatio = () => t.aspectRatio, e12.setAspectRatio = (e13) => {
    t.aspectRatio = e13;
  };
}
var DEFAULT_VALUES$25 = { aspectRatio: [1, 1] };
function extend$31(e12, t, n = {}) {
  Object.assign(t, DEFAULT_VALUES$25, n), vtkCamera$1.extend(e12, t, n), macro.setGet(e12, t, ["aspectRatio"]), extendedVtkCamera(e12, t);
}
var extendedVtkCamera_default = {
  newInstance: macro.newInstance(extend$31, "extendedVtkCamera"),
  extend: extend$31
};
require_seedrandom();
var DEFAULT_VALUES$24 = { isPerformingCoordinateTransformation: false };
function extend$30(e12, t, n = {}) {
  Object.assign(t, DEFAULT_VALUES$24, n), extendedVtkCamera_default.extend(e12, t, n), macro.setGet(e12, t, ["isPerformingCoordinateTransformation"]), vtkSlabCamera(e12, t);
}
var newInstance$28 = macro.newInstance(extend$30, "vtkSlabCamera");
function vtkSlabCamera(e12, t) {
  t.classHierarchy.push("vtkSlabCamera");
  let n = identity$2(new Float64Array(16)), r = new Float64Array(3);
  e12.getProjectionMatrix = (e13, a, o) => {
    let s = create$5();
    if (t.projectionMatrix) {
      let e14 = 1 / t.physicalScale;
      return set$4(r, e14, e14, e14), copy$4(s, t.projectionMatrix), scale$4(s, s, r), transpose(s, s), s;
    }
    identity$2(n);
    let c = t.clippingRange[0], l = t.clippingRange[1];
    t.isPerformingCoordinateTransformation && (c = t.distance, l = t.distance + 0.1);
    let u = l - c, d = [c + (a + 1) * u / 2, c + (o + 1) * u / 2];
    if (t.parallelProjection) {
      let r2 = t.parallelScale * e13, a2 = t.parallelScale;
      ortho(n, (t.windowCenter[0] - 1) * r2, (t.windowCenter[0] + 1) * r2, (t.windowCenter[1] - 1) * a2, (t.windowCenter[1] + 1) * a2, d[0], d[1]), transpose(n, n);
    } else if (t.useOffAxisProjection)
      throw Error("Off-Axis projection is not supported at this time");
    else {
      let r2 = Math.tan(vtkMath.radiansFromDegrees(t.viewAngle) / 2), a2, o2;
      t.useHorizontalViewAngle === true ? (a2 = c * r2, o2 = c * r2 / e13) : (a2 = c * r2 * e13, o2 = c * r2);
      let s2 = (t.windowCenter[0] - 1) * a2, l2 = (t.windowCenter[0] + 1) * a2, u2 = (t.windowCenter[1] - 1) * o2, f2 = (t.windowCenter[1] + 1) * o2, p2 = d[0], m = d[1];
      n[0] = 2 * p2 / (l2 - s2), n[5] = 2 * p2 / (f2 - u2), n[2] = (s2 + l2) / (l2 - s2), n[6] = (u2 + f2) / (f2 - u2), n[10] = -(p2 + m) / (m - p2), n[14] = -1, n[11] = -2 * p2 * m / (m - p2), n[15] = 0;
    }
    let [f, p] = getNormalizedAspectRatio(t.aspectRatio);
    return (f !== 1 || p !== 1) && multiply$2(n, getProjectionScaleMatrix([f, p]), n), copy$4(s, n), s;
  };
}
var vtkSlabCamera_default = {
  newInstance: newInstance$28,
  extend: extend$30
}, ImageVolume = class {
  get numTimePoints() {
    return typeof this.numDimensionGroups == "number" ? this.numDimensionGroups : 1;
  }
  constructor(e12) {
    this._imageIdsIndexMap = /* @__PURE__ */ new Map(), this._imageURIsIndexMap = /* @__PURE__ */ new Map(), this.cornerstoneImageMetaData = null, this.isPreScaled = false, this.numFrames = null;
    let { imageIds: t, scaling: n, dimensions: r, spacing: a, origin: o, direction: s, dataType: c, volumeId: l, referencedVolumeId: u, metadata: d, referencedImageIds: f, additionalDetails: p, voxelManager: m, numberOfComponents: h } = e12;
    if (!c)
      throw Error('Data type is required, please provide a data type as string such as "Uint8Array", "Float32Array", etc.');
    let { imageData: g } = e12;
    this.suppressWarnings = true, this.imageIds = t, this.volumeId = l, this.metadata = d, this.dimensions = r, this.spacing = a, this.origin = o, this.direction = s, this.dataType = c, this.vtkOpenGLTexture = vtkStreamingOpenGLTexture_default.newInstance(), this.vtkOpenGLTexture.setVolumeId(l), this.voxelManager = m ?? VoxelManager.createImageVolumeVoxelManager({
      dimensions: r,
      imageIds: t,
      numberOfComponents: h,
      id: l
    }), this.numVoxels = this.dimensions[0] * this.dimensions[1] * this.dimensions[2], g || (g = vtkImageData$1.newInstance(), g.setDimensions(r), g.setSpacing(a), g.setDirection(s), g.setOrigin(o)), g.set({
      dataType: c,
      voxelManager: this.voxelManager,
      id: l,
      numberOfComponents: h || 1
    }, this.suppressWarnings), g.set({ hasScalarVolume: false }, this.suppressWarnings), this.imageData = g, this.numFrames = this._getNumFrames(), this._reprocessImageIds(), n && (this.scaling = n), u && (this.referencedVolumeId = u), f && (this.referencedImageIds = f), p && (this.additionalDetails = p);
  }
  get sizeInBytes() {
    return this.voxelManager.sizeInBytes;
  }
  get imageIds() {
    return this._imageIds;
  }
  set imageIds(e12) {
    this._imageIds = e12, this._reprocessImageIds();
  }
  _reprocessImageIds() {
    this._imageIdsIndexMap.clear(), this._imageURIsIndexMap.clear(), this._imageIds.forEach((e12, t) => {
      let n = imageIdToURI(e12);
      this._imageIdsIndexMap.set(e12, t), this._imageURIsIndexMap.set(n, t);
    });
  }
  isDynamicVolume() {
    return this.numTimePoints ? this.numTimePoints > 1 : false;
  }
  getImageIdIndex(e12) {
    return this._imageIdsIndexMap.get(e12);
  }
  getImageIdByIndex(e12) {
    return this._imageIds[e12];
  }
  getImageURIIndex(e12) {
    return this._imageURIsIndexMap.get(e12);
  }
  load(e12) {
  }
  destroy() {
    this.imageData.delete(), this.imageData = null, this.voxelManager.clear(), this.vtkOpenGLTexture.releaseGraphicsResources(), this.vtkOpenGLTexture.delete();
  }
  invalidate() {
    for (let e12 = 0; e12 < this.imageIds.length; e12++)
      this.vtkOpenGLTexture.setUpdatedFrame(e12);
    this.imageData.modified();
  }
  modified() {
    this.imageData.modified(), this.vtkOpenGLTexture.modified(), this.numFrames = this._getNumFrames();
  }
  removeFromCache() {
    cache_default.removeVolumeLoadObject(this.volumeId);
  }
  getScalarDataLength() {
    return this.voxelManager.getScalarDataLength();
  }
  _getNumFrames() {
    return this.isDynamicVolume() ? this.numTimePoints : this.imageIds.length;
  }
  imageIdIndexToFrameIndex(e12) {
    return e12 % this.numFrames;
  }
  getCornerstoneImages() {
    let { imageIds: e12 } = this;
    return e12.map((e13) => cache_default.getImage(e13));
  }
}, ImageVolume_default = ImageVolume, metaData_exports = /* @__PURE__ */ __export({
  addProvider: () => addProvider,
  get: () => getMetaData,
  getNormalized: () => getNormalized,
  removeAllProviders: () => removeAllProviders,
  removeProvider: () => removeProvider,
  toLowerCamelTag: () => toLowerCamelTag,
  toUpperCamelTag: () => toUpperCamelTag
}), providers = [];
function addProvider(e12, t = 0) {
  let n;
  for (n = 0; n < providers.length && !(providers[n].priority <= t); n++)
    ;
  providers.splice(n, 0, {
    priority: t,
    provider: e12
  });
}
function removeProvider(e12) {
  for (let t = 0; t < providers.length; t++)
    if (providers[t].provider === e12) {
      providers.splice(t, 1);
      break;
    }
}
function removeAllProviders() {
  for (; providers.length > 0; )
    providers.pop();
}
function getMetaData(e12, ...t) {
  for (let n = 0; n < providers.length; n++) {
    let r = providers[n].provider(e12, ...t);
    if (r !== void 0)
      return r;
  }
}
function getNormalized(e12, t, n = getMetaData) {
  let r = {};
  for (let a of t)
    try {
      let t2 = n(a, e12);
      if (t2) {
        let e13 = {};
        for (let n2 in t2)
          if (n2 in t2) {
            let r2 = toUpperCamelTag(n2);
            e13[r2] = t2[n2];
          }
        Object.assign(r, e13);
      }
    } catch (e13) {
      console.error(`Error retrieving ${a} data:`, e13);
    }
  return r;
}
const toUpperCamelTag = (e12) => e12.startsWith("sop") ? `SOP${e12.substring(3)}` : (e12.endsWith("Id") && (e12 = `${e12.substring(0, e12.length - 2)}ID`), e12.charAt(0).toUpperCase() + e12.slice(1)), toLowerCamelTag = (e12) => e12.startsWith("SOP") ? `sop${e12.substring(3)}` : (e12.endsWith("ID") && (e12 = `${e12.substring(0, e12.length - 2)}Id`), e12.charAt(0).toLowerCase() + e12.slice(1));
var state$4 = {}, metadataProvider$1 = {
  add: (e12, t) => {
    metadataProvider$1.addRaw(e12, {
      ...t,
      metadata: structuredClone(t.metadata)
    });
  },
  addRaw: (e12, t) => {
    let n = t.type;
    state$4[e12] || (state$4[e12] = {}), state$4[e12][n] = t.metadata;
  },
  get: (e12, t) => state$4[t]?.[e12],
  clear: () => {
    state$4 = {};
  }
};
addProvider(metadataProvider$1.get);
var genericMetadataProvider_default = metadataProvider$1, imageLoadPoolManager = new RequestPoolManager("imageLoadPool");
imageLoadPoolManager.grabDelay = 0, imageLoadPoolManager.setMaxSimultaneousRequests(RequestType_default.Interaction, 1e3), imageLoadPoolManager.setMaxSimultaneousRequests(RequestType_default.Thumbnail, 1e3), imageLoadPoolManager.setMaxSimultaneousRequests(RequestType_default.Prefetch, 1e3);
var imageLoadPoolManager_default = imageLoadPoolManager, imageLoaders = {}, unknownImageLoader;
function loadImageFromImageLoader(e12, t) {
  let n = cache_default.getImageLoadObject(e12);
  if (n)
    return handleImageLoadPromise(n.promise, e12), n;
  let r = e12.split(":")[0], a = imageLoaders[r] || unknownImageLoader;
  if (!a)
    throw Error(`loadImageFromImageLoader: No image loader found for scheme '${r}'`);
  let o = a(e12, t);
  return handleImageLoadPromise(o.promise, e12), o;
}
function handleImageLoadPromise(e12, t) {
  Promise.resolve(e12).then((e13) => {
    ensureVoxelManager(e13), triggerEvent(eventTarget_default, Events_default.IMAGE_LOADED, { image: e13 });
  }).catch((e13) => {
    let n = {
      imageId: t,
      error: e13
    };
    triggerEvent(eventTarget_default, Events_default.IMAGE_LOAD_FAILED, n);
  });
}
function ensureVoxelManager(e12) {
  if (!e12.voxelManager) {
    let { width: t, height: n, numberOfComponents: r } = e12, a = VoxelManager.createImageVoxelManager({
      scalarData: e12.getPixelData(),
      width: t,
      height: n,
      numberOfComponents: r
    });
    e12.voxelManager = a, e12.getPixelData = () => a.getScalarData(), delete e12.imageFrame.pixelData;
  }
}
function loadImage(e12, t = {
  priority: 0,
  requestType: "prefetch"
}) {
  if (e12 === void 0)
    throw Error("loadImage: parameter imageId must not be undefined");
  return loadImageFromImageLoader(e12, t).promise;
}
function loadAndCacheImage(e12, t = {
  priority: 0,
  requestType: "prefetch"
}) {
  if (e12 === void 0)
    throw Error("loadAndCacheImage: parameter imageId must not be undefined");
  let n = loadImageFromImageLoader(e12, t);
  return cache_default.getImageLoadObject(e12) || cache_default.putImageLoadObject(e12, n), n.promise;
}
function loadAndCacheImages(e12, t = {
  priority: 0,
  requestType: "prefetch"
}) {
  if (!e12 || e12.length === 0)
    throw Error("loadAndCacheImages: parameter imageIds must be list of image Ids");
  return e12.map((e13) => loadAndCacheImage(e13, t));
}
function createAndCacheDerivedImage(e12, t = {}) {
  if (e12 === void 0)
    throw Error("createAndCacheDerivedImage: parameter imageId must not be undefined");
  t.imageId === void 0 && (t.imageId = `derived:${uuidv4()}`);
  let { imageId: n, skipCreateBuffer: r, onCacheAdd: a, voxelRepresentation: o } = t, s = getMetaData("imagePlaneModule", e12), c = s.rows * s.columns, { TypedArrayConstructor: l } = getBufferConfiguration(t.targetBuffer?.type, c), u = new l(r ? 1 : c), d = n, f = getMetaData("imagePlaneModule", e12);
  genericMetadataProvider_default.add(d, {
    type: "imagePlaneModule",
    metadata: f
  });
  let p = getMetaData("generalSeriesModule", e12);
  genericMetadataProvider_default.add(d, {
    type: "generalSeriesModule",
    metadata: p
  }), genericMetadataProvider_default.add(d, {
    type: "generalImageModule",
    metadata: { instanceNumber: t.instanceNumber }
  });
  let m = getMetaData("imagePixelModule", e12);
  genericMetadataProvider_default.add(d, {
    type: "imagePixelModule",
    metadata: {
      ...m,
      bitsAllocated: 8,
      bitsStored: 8,
      highBit: 7,
      samplesPerPixel: 1,
      pixelRepresentation: 0
    }
  });
  let h = createAndCacheLocalImage(n, {
    scalarData: u,
    onCacheAdd: a,
    skipCreateBuffer: r,
    targetBuffer: { type: u.constructor.name },
    voxelRepresentation: o,
    dimensions: [s.columns, s.rows],
    spacing: [s.columnPixelSpacing, s.rowPixelSpacing],
    origin: s.imagePositionPatient,
    direction: s.imageOrientationPatient,
    frameOfReferenceUID: s.frameOfReferenceUID,
    referencedImageId: e12
  });
  return h.referencedImageId = e12, cache_default.getImageLoadObject(n) || cache_default.putImageSync(n, h), h;
}
function createAndCacheDerivedImages(e12, t = {}) {
  if (e12.length === 0)
    throw Error("createAndCacheDerivedImages: parameter imageIds must be list of image Ids");
  let n = [];
  return e12.map((e13, r) => {
    let a = {
      imageId: t?.getDerivedImageId?.(e13) || `derived:${uuidv4()}`,
      ...t
    };
    return n.push(a.imageId), createAndCacheDerivedImage(e13, {
      ...a,
      instanceNumber: r + 1
    });
  });
}
function createAndCacheLocalImage(e12, t) {
  let { scalarData: n, origin: r, direction: a, targetBuffer: o, skipCreateBuffer: s, onCacheAdd: c, frameOfReferenceUID: l, voxelRepresentation: u, referencedImageId: d } = t, f = t.dimensions, p = t.spacing;
  if (!f || !p)
    throw Error("createAndCacheLocalImage: dimensions and spacing are required");
  let m = f[0], h = f[1], g = p[0], _ = p[1], v = {
    frameOfReferenceUID: l,
    rows: h,
    columns: m,
    imageOrientationPatient: a ?? [
      1,
      0,
      0,
      0,
      1,
      0
    ],
    rowCosines: a ? a.slice(0, 3) : [
      1,
      0,
      0
    ],
    columnCosines: a ? a.slice(3, 6) : [
      0,
      1,
      0
    ],
    imagePositionPatient: r ?? [
      0,
      0,
      0
    ],
    pixelSpacing: [_, g],
    rowPixelSpacing: _,
    columnPixelSpacing: g
  }, y = m * h, b = n.length / y, S;
  if (n) {
    if (!(n instanceof Uint8Array || n instanceof Float32Array || n instanceof Uint16Array || n instanceof Int16Array))
      throw Error("createAndCacheLocalImage: scalarData must be of type Uint8Array, Uint16Array, Int16Array or Float32Array");
    S = n;
  } else if (!s) {
    let { TypedArrayConstructor: e13 } = getBufferConfiguration(o?.type, y);
    S = new e13(y);
  }
  let C, w, T;
  if (S instanceof Uint8Array)
    C = 8, w = 8, T = 7;
  else if (S instanceof Uint16Array)
    C = 16, w = 16, T = 15;
  else if (S instanceof Int16Array)
    C = 16, w = 16, T = 15;
  else if (S instanceof Float32Array)
    C = 32, w = 32, T = 31;
  else
    throw Error("Unsupported scalarData type");
  let E = {
    samplesPerPixel: 1,
    photometricInterpretation: S.length > f[0] * f[1] ? "RGB" : "MONOCHROME2",
    rows: h,
    columns: m,
    bitsAllocated: C,
    bitsStored: w,
    highBit: T
  }, D = {
    imagePlaneModule: v,
    imagePixelModule: E
  };
  ["imagePlaneModule", "imagePixelModule"].forEach((t2) => {
    genericMetadataProvider_default.add(e12, {
      type: t2,
      metadata: D[t2] || {}
    });
  });
  let O = e12, k = u === VoxelManagerEnum_default.RLE && VoxelManager.createRLEImageVoxelManager({
    dimensions: f,
    id: O
  }) || VoxelManager.createImageVoxelManager({
    height: h,
    width: m,
    numberOfComponents: b,
    scalarData: S,
    id: O
  }), A = S[0], j = S[0];
  for (let e13 = 1; e13 < S.length; e13++)
    S[e13] < A && (A = S[e13]), S[e13] > j && (j = S[e13]);
  let M = {
    imageId: e12,
    intercept: 0,
    windowCenter: 0,
    windowWidth: 0,
    color: E.photometricInterpretation === "RGB",
    numberOfComponents: E.samplesPerPixel,
    dataType: o?.type,
    slope: 1,
    minPixelValue: A,
    maxPixelValue: j,
    rows: E.rows,
    columns: E.columns,
    getCanvas: void 0,
    height: E.rows,
    width: E.columns,
    rgba: void 0,
    columnPixelSpacing: v.columnPixelSpacing,
    rowPixelSpacing: v.rowPixelSpacing,
    FrameOfReferenceUID: v.frameOfReferenceUID,
    invert: false,
    getPixelData: () => k.getScalarData(),
    voxelManager: k,
    sizeInBytes: n.byteLength,
    referencedImageId: d
  };
  return c?.(M), cache_default.putImageSync(M.imageId, M), M;
}
function registerImageLoader(e12, t) {
  imageLoaders[e12] = t;
}
function createAndCacheDerivedLabelmapImages(e12, t = {}) {
  return createAndCacheDerivedImages(e12, {
    ...t,
    targetBuffer: { type: "Uint8Array" }
  });
}
function makeVolumeMetadata(e12) {
  let t = e12[0], { pixelRepresentation: n, bitsAllocated: r, bitsStored: a, highBit: o, photometricInterpretation: s, samplesPerPixel: c } = getMetaData("imagePixelModule", t), l = [], u = getMetaData("voiLutModule", t), d;
  if (u) {
    let { windowWidth: e13, windowCenter: t2 } = u;
    if (d = u?.voiLUTFunction, Array.isArray(e13))
      for (let n2 = 0; n2 < e13.length; n2++)
        l.push({
          windowWidth: e13[n2],
          windowCenter: t2[n2]
        });
    else
      l.push({
        windowWidth: e13,
        windowCenter: t2
      });
  } else
    l.push({
      windowWidth: void 0,
      windowCenter: void 0
    });
  let { modality: f, seriesInstanceUID: p } = getMetaData("generalSeriesModule", t), { imageOrientationPatient: m, pixelSpacing: h, frameOfReferenceUID: g, columns: _, rows: v } = getMetaData("imagePlaneModule", t);
  return {
    BitsAllocated: r,
    BitsStored: a,
    SamplesPerPixel: c,
    HighBit: o,
    PhotometricInterpretation: s,
    PixelRepresentation: n,
    Modality: f,
    ImageOrientationPatient: m,
    PixelSpacing: h,
    FrameOfReferenceUID: g,
    Columns: _,
    Rows: v,
    voiLut: l,
    VOILUTFunction: d,
    SeriesInstanceUID: p
  };
}
var DEFAULT_THICKNESS_SINGLE_SLICE = 1;
function getPixelSpacingForCubicVoxel(e12) {
  if (e12.columnPixelSpacing !== void 0)
    return e12.columnPixelSpacing;
  if (e12.rowPixelSpacing !== void 0)
    return e12.rowPixelSpacing;
  if (e12.pixelSpacing?.[1] !== void 0)
    return e12.pixelSpacing[1];
  if (e12.pixelSpacing?.[0] !== void 0)
    return e12.pixelSpacing[0];
}
function calculateSpacingBetweenImageIds(e12) {
  let { imagePositionPatient: t, imageOrientationPatient: n } = getMetaData("imagePlaneModule", e12[0]);
  if (e12.length === 1) {
    let { sliceThickness: t2, spacingBetweenSlices: n2, columnPixelSpacing: r2, rowPixelSpacing: a2, pixelSpacing: o2 } = getMetaData("imagePlaneModule", e12[0]);
    if (t2)
      return t2;
    if (n2)
      return n2;
    let s2 = getPixelSpacingForCubicVoxel({
      columnPixelSpacing: r2,
      rowPixelSpacing: a2,
      pixelSpacing: o2
    });
    return s2 === void 0 ? DEFAULT_THICKNESS_SINGLE_SLICE : s2;
  }
  let r = fromValues$3(n[0], n[1], n[2]), a = fromValues$3(n[3], n[4], n[5]), o = create$4();
  cross$1(o, r, a);
  let s = fromValues$3(t[0], t[1], t[2]), c = e12[0].split(":")[0] === "wadouri", l;
  function u(e13) {
    let { imagePositionPatient: t2 } = getMetaData("imagePlaneModule", e13), n2 = create$4();
    return sub$1(n2, s, fromValues$3(t2[0], t2[1], t2[2])), dot$3(n2, o);
  }
  if (c) {
    let t2 = getMetaData("imagePlaneModule", [e12[0], e12[Math.floor(e12.length / 2)]][1]);
    if (!t2)
      throw Error("Incomplete metadata required for volume construction.");
    let n2 = create$4();
    sub$1(n2, s, fromValues$3(t2.imagePositionPatient[0], t2.imagePositionPatient[1], t2.imagePositionPatient[2]));
    let r2 = dot$3(n2, o);
    l = Math.abs(r2) / Math.floor(e12.length / 2);
  } else {
    let t2 = e12.map((e13) => ({
      distance: u(e13),
      imageId: e13
    }));
    t2.sort((e13, t3) => t3.distance - e13.distance);
    let n2 = t2.length;
    l = Math.abs(t2[n2 - 1].distance - t2[0].distance) / (n2 - 1);
  }
  let { sliceThickness: d, spacingBetweenSlices: f, columnPixelSpacing: p, rowPixelSpacing: m, pixelSpacing: h } = getMetaData("imagePlaneModule", e12[0]), { strictZSpacingForVolumeViewport: g } = getConfiguration().rendering;
  if ((l === 0 || isNaN(l)) && !g)
    if (f)
      console.debug("Could not calculate spacing. Using spacingBetweenSlices"), l = f;
    else if (d)
      console.debug("Could not calculate spacing and no spacingBetweenSlices. Using sliceThickness"), l = d;
    else {
      let e13 = getPixelSpacingForCubicVoxel({
        columnPixelSpacing: p,
        rowPixelSpacing: m,
        pixelSpacing: h
      });
      e13 ? l = e13 : (console.debug(`Could not calculate spacing and no pixel spacing found. Using default thickness (${DEFAULT_THICKNESS_SINGLE_SLICE} mm)`), l = DEFAULT_THICKNESS_SINGLE_SLICE);
    }
  return l;
}
function sortImageIdsAndGetSpacing(e12, t) {
  let { imagePositionPatient: n, imageOrientationPatient: r } = getMetaData("imagePlaneModule", e12[0]);
  if (!t) {
    let e13 = fromValues$3(r[0], r[1], r[2]), n2 = fromValues$3(r[3], r[4], r[5]);
    t = create$4(), cross$1(t, e13, n2);
  }
  let a = e12[0].split(":")[0] === "wadouri", o = calculateSpacingBetweenImageIds(e12), s;
  function c(e13) {
    let { imagePositionPatient: r2 } = getMetaData("imagePlaneModule", e13), a2 = create$4();
    return sub$1(a2, n, r2), dot$3(a2, t);
  }
  if (a) {
    let t2 = [e12[0], e12[Math.floor(e12.length / 2)]];
    s = e12, c(t2[0]) - c(t2[1]) < 0 && s.reverse();
  } else {
    let t2 = e12.map((e13) => ({
      distance: c(e13),
      imageId: e13
    }));
    t2.sort((e13, t3) => t3.distance - e13.distance), s = t2.map((e13) => e13.imageId);
  }
  let { imagePositionPatient: l } = getMetaData("imagePlaneModule", s[0]);
  return {
    zSpacing: o,
    origin: l,
    sortedImageIds: s
  };
}
function getScalingParameters(e12) {
  let t = getMetaData("modalityLutModule", e12) || {}, { modality: n } = getMetaData("generalSeriesModule", e12) || {}, r = {
    rescaleSlope: t.rescaleSlope || 1,
    rescaleIntercept: t.rescaleIntercept ?? 0,
    modality: n
  }, a = getMetaData("scalingModule", e12) || {};
  return {
    ...r,
    ...n === "PT" && {
      suvbw: a.suvbw,
      suvbsa: a.suvbsa,
      suvlbm: a.suvlbm
    },
    ...n === "RTDOSE" && {
      doseGridScaling: a.DoseGridScaling,
      doseSummation: a.DoseSummation,
      doseType: a.DoseType,
      doseUnit: a.DoseUnit
    }
  };
}
const hasFloatScalingParameters = (e12) => Object.values(e12).some((e13) => typeof e13 == "number" && !Number.isInteger(e13));
var constructorToTypedArray = {
  Uint8Array: "Uint8Array",
  Int16Array: "Int16Array",
  Uint16Array: "Uint16Array",
  Float32Array: "Float32Array"
};
function generateVolumePropsFromImageIds(e12, t) {
  let n = makeVolumeMetadata(e12), { ImageOrientationPatient: r, PixelSpacing: a, Columns: o, Rows: s } = n, c = fromValues$3(r[0], r[1], r[2]), l = fromValues$3(r[3], r[4], r[5]), u = create$4();
  cross$1(u, c, l);
  let { zSpacing: d, origin: f, sortedImageIds: p } = sortImageIdsAndGetSpacing(e12, u), m = e12.length, h = [
    a[1],
    a[0],
    d
  ], g = [
    o,
    s,
    m
  ].map((e13) => Math.floor(e13)), _ = [
    ...c,
    ...l,
    ...u
  ];
  return {
    dimensions: g,
    spacing: h,
    origin: f,
    dataType: _determineDataType(p, n),
    direction: _,
    metadata: n,
    imageIds: p,
    volumeId: t,
    voxelManager: null,
    numberOfComponents: n.PhotometricInterpretation === "RGB" ? 3 : 1
  };
}
function _determineDataType(e12, t) {
  let { BitsAllocated: n, PixelRepresentation: r } = t, a = r === 1, o = _getDataTypeFromCache(e12);
  if (o)
    return o;
  let [s, c, l] = [
    0,
    Math.floor(e12.length / 2),
    e12.length - 1
  ], u = [
    s,
    c,
    l
  ].map((t2) => getScalingParameters(e12[t2])), d = u.some((e13) => e13.rescaleIntercept < 0 || e13.rescaleSlope < 0), f = u.some((e13) => hasFloatScalingParameters(e13)), p = canRenderFloatTextures();
  switch (n) {
    case 8:
      return "Uint8Array";
    case 16:
      return p && f ? "Float32Array" : a || d ? "Int16Array" : !a && !d ? "Uint16Array" : "Float32Array";
    case 24:
      return "Uint8Array";
    case 32:
      return "Float32Array";
    case 64:
      return "Float64Array";
    default:
      throw Error(`Bits allocated of ${n} is not defined to generate scalarData for the volume.`);
  }
}
function _getDataTypeFromCache(e12) {
  let t = [
    0,
    Math.floor(e12.length / 2),
    e12.length - 1
  ].map((t2) => cache_default.getImage(e12[t2]));
  if (!t.every(Boolean))
    return null;
  let n = t[0].getPixelData().constructor.name;
  return t.every((e13) => e13.getPixelData().constructor.name === n) && n in constructorToTypedArray ? constructorToTypedArray[n] : null;
}
var ProgressiveIterator = class e3 {
  constructor(e12) {
    this.name = e12 || "unknown";
  }
  static as(t) {
    if (t.iterator)
      return t.iterator;
    let n = new e3("as iterator");
    return t.then((e12) => {
      try {
        n.add(e12, true);
      } catch (e13) {
        n.reject(e13);
      }
    }, (e12) => {
      n.reject(e12);
    }), n;
  }
  add(e12, t = false) {
    this.nextValue = e12, this.done ||= t, this.waiting &&= (this.waiting.resolve(e12), void 0);
  }
  resolve() {
    this.done = true, this.waiting &&= (this.waiting.resolve(this.nextValue), void 0);
  }
  reject(e12) {
    this.rejectReason = e12, this.waiting?.reject(e12);
  }
  getRecent() {
    if (this.rejectReason)
      throw this.rejectReason;
    return this.nextValue;
  }
  async *[Symbol.asyncIterator]() {
    for (; !this.done; ) {
      if (this.rejectReason)
        throw this.rejectReason;
      if (this.nextValue !== void 0 && (yield this.nextValue, this.done))
        break;
      this.waiting || (this.waiting = {}, this.waiting.promise = new Promise((e12, t) => {
        this.waiting.resolve = e12, this.waiting.reject = t;
      })), await this.waiting.promise;
    }
    yield this.nextValue;
  }
  async forEach(e12, t) {
    let n = 0;
    try {
      for await (let r of this) {
        let { done: a } = this;
        try {
          await e12(r, a, n), n++;
        } catch (e13) {
          if (!a) {
            console.warn("Caught exception in intermediate value", e13);
            continue;
          }
          if (t)
            t(e13, a);
          else
            throw e13;
        }
      }
    } catch (e13) {
      if (t)
        t(e13, true);
      else
        throw e13;
    }
  }
  generate(e12, t) {
    return e12(this, this.reject.bind(this)).then(() => {
      this.done || this.resolve();
    }, (e13) => {
      this.reject(e13), t ? t(e13) : console.warn("Couldn't process because", e13);
    });
  }
  async nextPromise() {
    for await (let e12 of this)
      if (e12)
        return e12;
    return this.nextValue;
  }
  async donePromise() {
    for await (let e12 of this)
      ;
    return this.nextValue;
  }
  getNextPromise() {
    let e12 = this.nextPromise();
    return e12.iterator = this, e12;
  }
  getDonePromise() {
    let e12 = this.donePromise();
    return e12.iterator = this, e12;
  }
}, retrieveConfigurationState = /* @__PURE__ */ new Map(), IMAGE_RETRIEVE_CONFIGURATION = "imageRetrieveConfiguration", imageRetrieveMetadataProvider = {
  IMAGE_RETRIEVE_CONFIGURATION,
  clear: () => {
    retrieveConfigurationState.clear();
  },
  add: (e12, t) => {
    retrieveConfigurationState.set(e12, t);
  },
  clone: () => new Map(retrieveConfigurationState),
  restore: (e12) => {
    retrieveConfigurationState.clear(), e12.forEach((e13, t) => {
      retrieveConfigurationState.set(t, e13);
    });
  },
  get: (e12, ...t) => {
    if (e12 === IMAGE_RETRIEVE_CONFIGURATION)
      return t.map((e13) => retrieveConfigurationState.get(e13)).find((e13) => e13 !== void 0);
  }
};
addProvider(imageRetrieveMetadataProvider.get.bind(imageRetrieveMetadataProvider));
var imageRetrieveMetadataProvider_default = imageRetrieveMetadataProvider;
function getViewportsWithVolumeId(e12) {
  let t = getRenderingEngines(), n = [];
  return t.forEach((t2) => {
    let r = t2.getVolumeViewports().filter((t3) => t3.hasVolumeId(e12));
    n.push(...r);
  }), n;
}
var getViewportsWithVolumeId_default = getViewportsWithVolumeId, autoLoad = (e12) => {
  let t = getRenderingEngineAndViewportsContainingVolume(e12);
  t?.length && t.forEach(({ renderingEngine: e13, viewportIds: t2 }) => {
    e13.hasBeenDestroyed || e13.renderViewports(t2);
  });
};
function getRenderingEngineAndViewportsContainingVolume(e12) {
  let t = getRenderingEngines(), n = [];
  return t.forEach((t2) => {
    let r = getViewportsWithVolumeId_default(e12);
    r.length && n.push({
      renderingEngine: t2,
      viewportIds: r.map((e13) => e13.id)
    });
  }), n;
}
var autoLoad_default = autoLoad, singleRetrieve_default = [{
  id: "initialImages",
  retrieveType: "single"
}], sequentialRetrieve_default = [{
  id: "lossySequential",
  retrieveType: "singleFast"
}, {
  id: "finalSequential",
  retrieveType: "singleFinal"
}], nearbyFrames = [
  {
    offset: -1,
    imageQualityStatus: ImageQualityStatus_default.ADJACENT_REPLICATE
  },
  {
    offset: 1,
    imageQualityStatus: ImageQualityStatus_default.ADJACENT_REPLICATE
  },
  {
    offset: 2,
    imageQualityStatus: ImageQualityStatus_default.FAR_REPLICATE
  }
], interleavedRetrieve_default = [
  {
    id: "initialImages",
    positions: [
      0.5,
      0,
      -1
    ],
    retrieveType: "default",
    requestType: RequestType_default.Thumbnail,
    priority: 5,
    nearbyFrames
  },
  {
    id: "quarterThumb",
    decimate: 4,
    offset: 3,
    requestType: RequestType_default.Thumbnail,
    retrieveType: "multipleFast",
    priority: 6,
    nearbyFrames
  },
  {
    id: "halfThumb",
    decimate: 4,
    offset: 1,
    priority: 7,
    requestType: RequestType_default.Thumbnail,
    retrieveType: "multipleFast",
    nearbyFrames
  },
  {
    id: "quarterFull",
    decimate: 4,
    offset: 2,
    priority: 8,
    requestType: RequestType_default.Thumbnail,
    retrieveType: "multipleFinal"
  },
  {
    id: "halfFull",
    decimate: 4,
    offset: 0,
    priority: 9,
    requestType: RequestType_default.Thumbnail,
    retrieveType: "multipleFinal"
  },
  {
    id: "threeQuarterFull",
    decimate: 4,
    offset: 1,
    priority: 10,
    requestType: RequestType_default.Thumbnail,
    retrieveType: "multipleFinal"
  },
  {
    id: "finalFull",
    decimate: 4,
    offset: 3,
    priority: 11,
    requestType: RequestType_default.Thumbnail,
    retrieveType: "multipleFinal"
  },
  { id: "errorRetrieve" }
];
function decimate(e12, t, n = 0) {
  let r = [];
  for (let a = n; a < e12.length; a += t)
    r.push(a);
  return r;
}
function fillNearbyFrames(e12, t, n) {
  if (t?.nearbyRequests?.length)
    for (let r of t.nearbyRequests)
      try {
        let { itemId: t2, imageQualityStatus: a } = r, o = cache_default.getImageQuality(t2);
        if (o !== void 0 && o >= a)
          continue;
        let s = {
          ...n,
          imageId: t2,
          imageQualityStatus: a
        };
        cache_default.setPartialImage(t2, s), e12.successCallback(t2, s);
      } catch (e13) {
        console.warn("Couldn't fill nearby item ", r.itemId, e13);
      }
}
var ProgressiveRetrieveImages = class {
  static {
    this.createProgressive = createProgressive;
  }
  static {
    this.interleavedRetrieveStages = { stages: interleavedRetrieve_default };
  }
  static {
    this.singleRetrieveStages = { stages: singleRetrieve_default };
  }
  static {
    this.sequentialRetrieveStages = { stages: sequentialRetrieve_default };
  }
  constructor(e12) {
    this.stages = e12.stages || singleRetrieve_default, this.retrieveOptions = e12.retrieveOptions || {};
  }
  loadImages(e12, t) {
    return new ProgressiveRetrieveImagesInstance(this, e12, t).loadImages();
  }
}, ProgressiveRetrieveImagesInstance = class {
  constructor(e12, t, n) {
    this.outstandingRequests = 0, this.stageStatusMap = /* @__PURE__ */ new Map(), this.displayedIterator = new ProgressiveIterator("displayed"), this.stages = e12.stages, this.retrieveOptions = e12.retrieveOptions, this.imageIds = t, this.listener = n;
  }
  async loadImages() {
    let e12 = this.createStageRequests();
    this.outstandingRequests = e12.length;
    for (let t of e12)
      this.addRequest(t);
    return this.outstandingRequests === 0 ? Promise.resolve(null) : this.displayedIterator.getDonePromise();
  }
  sendRequest(e12, t) {
    let { imageId: n, next: r } = e12, a = (t2, a2) => {
      this.listener.errorCallback(n, c || !r, t2), a2 && this.updateStageStatus(e12.stage, t2);
    }, o = (t.loader || loadAndCacheImage)(n, t), s = ProgressiveIterator.as(o), c = false;
    return s.forEach(async (t2, r2) => {
      let a2 = cache_default.getImageQuality(n);
      if (!t2) {
        console.warn("No image retrieved", n);
        return;
      }
      let { imageQualityStatus: o2 } = t2;
      if (c ||= o2 === ImageQualityStatus_default.FULL_RESOLUTION, a2 !== void 0 && a2 > o2) {
        this.updateStageStatus(e12.stage, null, true);
        return;
      }
      this.listener.successCallback(n, t2), this.displayedIterator.add(t2), r2 && this.updateStageStatus(e12.stage), fillNearbyFrames(this.listener, e12, t2);
    }, a).finally(() => {
      if (!c && r)
        cache_default.setPartialImage(n), this.addRequest(r, t.streamingData);
      else {
        c || this.listener.errorCallback(n, true, "Couldn't decode"), this.outstandingRequests--;
        for (let e13 = r; e13; e13 = e13.next)
          this.updateStageStatus(e13.stage, null, true);
      }
      this.outstandingRequests <= 0 && this.displayedIterator.resolve();
    }), s.getDonePromise().catch((e13) => null);
  }
  addRequest(e12, t = {}) {
    let { imageId: n, stage: r } = e12, a = this.listener.getLoaderImageOptions(n);
    if (!a)
      return;
    let { retrieveType: o = "default" } = r, { retrieveOptions: c } = this, l = c[o] || c.default, u = {
      ...a,
      retrieveType: o,
      retrieveOptions: l,
      streamingData: t
    }, d = r.priority ?? -5, f = r.requestType || RequestType_default.Interaction, p = { imageId: n };
    imageLoadPoolManager_default.addRequest(this.sendRequest.bind(this, e12, u), f, p, d);
  }
  updateStageStatus(e12, t, n = false) {
    let { id: r } = e12, o = this.stageStatusMap.get(r);
    if (o && (o.imageLoadPendingCount--, t ? o.imageLoadFailedCount++ : n || o.totalImageCount++, !n && !o.stageStartTime && (o.stageStartTime = Date.now()), !o.imageLoadPendingCount)) {
      let { imageLoadFailedCount: e13, totalImageCount: t2, stageStartTime: n2 = Date.now(), startTime: s } = o, c = {
        stageId: r,
        numberOfFailures: e13,
        numberOfImages: t2,
        stageDurationInMS: n2 ? Date.now() - n2 : null,
        startDurationInMS: Date.now() - s
      };
      triggerEvent(eventTarget_default, Events_default.IMAGE_RETRIEVAL_STAGE, c), this.stageStatusMap.delete(r);
    }
  }
  createStageRequests() {
    let e12 = [], t = /* @__PURE__ */ new Map(), n = (n2, r) => {
      let a = r < 0 ? this.imageIds.length + r : r < 1 ? Math.floor((this.imageIds.length - 1) * r) : r, o = this.imageIds[a];
      if (!o)
        throw Error(`No value found to add to requests at ${r}`);
      let s = {
        imageId: o,
        stage: n2,
        index: a,
        nearbyRequests: this.findNearbyRequests(a, n2)
      };
      this.addStageStatus(n2);
      let c = t.get(o);
      c ? c.next = s : e12.push(s), t.set(o, s);
    };
    for (let e13 of this.stages)
      (e13.positions || decimate(this.imageIds, e13.decimate || 1, e13.offset ?? 0)).forEach((t2) => {
        n(e13, t2);
      });
    return e12;
  }
  findNearbyRequests(e12, t) {
    let n = [];
    if (!t.nearbyFrames)
      return n;
    for (let r of t.nearbyFrames) {
      let t2 = e12 + r.offset;
      t2 < 0 || t2 >= this.imageIds.length || n.push({
        itemId: this.imageIds[t2],
        imageQualityStatus: r.imageQualityStatus,
        index: t2
      });
    }
    return n;
  }
  addStageStatus(e12) {
    let { id: t } = e12, n = this.stageStatusMap.get(t) || {
      stageId: t,
      startTime: Date.now(),
      stageStartTime: null,
      totalImageCount: 0,
      imageLoadFailedCount: 0,
      imageLoadPendingCount: 0
    };
    return n.imageLoadPendingCount++, this.stageStatusMap.set(t, n), n;
  }
};
function createProgressive(e12) {
  return new ProgressiveRetrieveImages(e12);
}
var ProgressiveRetrieveImages_default = ProgressiveRetrieveImages, requestTypeDefault = RequestType_default.Prefetch, BaseStreamingImageVolume_default = class extends ImageVolume_default {
  constructor(e12, t) {
    super(e12), this.framesLoaded = 0, this.framesProcessed = 0, this.framesUpdated = 0, this.autoRenderOnLoad = true, this.cachedFrames = [], this.reRenderTarget = 0, this.reRenderFraction = 2, this.imagesLoader = this, this.cancelLoading = () => {
      let { loadStatus: e13 } = this;
      !e13 || !e13.loading || (e13.loading = false, e13.cancelled = true, this.clearLoadCallbacks(), imageLoadPoolManager_default.filterRequests(({ additionalDetails: e14 }) => e14.volumeId !== this.volumeId));
    }, this.loadStatus = t.loadStatus;
  }
  invalidateVolume(e12) {
    let { vtkOpenGLTexture: t } = this, { numFrames: n } = this;
    for (let e13 = 0; e13 < n; e13++)
      t.setUpdatedFrame(e13);
    this.modified(), e12 && autoLoad_default(this.volumeId);
  }
  clearLoadCallbacks() {
    this.loadStatus.callbacks = [];
  }
  callLoadStatusCallback(e12) {
    let { framesUpdated: t, framesProcessed: n, totalNumFrames: r } = e12, { volumeId: o, reRenderFraction: s, loadStatus: c, metadata: l } = this, { FrameOfReferenceUID: u } = l;
    if (this.autoRenderOnLoad && (t > this.reRenderTarget || n === r) && (this.reRenderTarget += s, autoLoad_default(o)), n === r) {
      c.callbacks.forEach((t3) => t3(e12));
      let t2 = {
        FrameOfReferenceUID: u,
        volumeId: o
      };
      triggerEvent(eventTarget_default, Events_default.IMAGE_VOLUME_LOADING_COMPLETED, t2);
    }
  }
  updateTextureAndTriggerEvents(e12, t, n = ImageQualityStatus_default.FULL_RESOLUTION) {
    let r = this.imageIdIndexToFrameIndex(e12), { cachedFrames: o, numFrames: s, totalNumFrames: c } = this, { FrameOfReferenceUID: l } = this.metadata;
    if (o[r] > n || o[r] === ImageQualityStatus_default.FULL_RESOLUTION)
      return;
    let u = n === ImageQualityStatus_default.FULL_RESOLUTION;
    o[e12] = n, this.framesUpdated++, u && (this.framesLoaded++, this.framesProcessed++);
    let d = {
      FrameOfReferenceUID: l,
      volumeId: this.volumeId,
      numberOfFrames: s,
      framesProcessed: this.framesProcessed
    };
    triggerEvent(eventTarget_default, Events_default.IMAGE_VOLUME_MODIFIED, d), u && this.framesProcessed === this.totalNumFrames && (this.loadStatus.loaded = true, this.loadStatus.loading = false), this.callLoadStatusCallback({
      success: true,
      imageIdIndex: e12,
      imageId: t,
      framesLoaded: this.framesLoaded,
      framesProcessed: this.framesProcessed,
      framesUpdated: this.framesUpdated,
      numFrames: s,
      totalNumFrames: c,
      complete: u,
      imageQualityStatus: n
    }), this.vtkOpenGLTexture.setUpdatedFrame(r), this.loadStatus.loaded && (this.loadStatus.callbacks = []);
  }
  successCallback(e12, t) {
    let n = this.getImageIdIndex(e12), { imageQualityStatus: r } = t;
    if (this.loadStatus.cancelled) {
      console.warn("volume load cancelled, returning for imageIdIndex: ", n);
      return;
    }
    this.updateTextureAndTriggerEvents(n, e12, r), this.isDynamicVolume() && this.checkDimensionGroupCompletion(n);
  }
  errorCallback(e12, t, n) {
    if (!t)
      return;
    let { totalNumFrames: r, numFrames: o } = this, s = this.getImageIdIndex(e12);
    this.framesProcessed++, this.framesProcessed === r && (this.loadStatus.loaded = true, this.loadStatus.loading = false), this.callLoadStatusCallback({
      success: false,
      imageId: e12,
      imageIdIndex: s,
      error: n,
      framesLoaded: this.framesLoaded,
      framesProcessed: this.framesProcessed,
      framesUpdated: this.framesUpdated,
      numFrames: o,
      totalNumFrames: r
    }), this.loadStatus.loaded && (this.loadStatus.callbacks = []);
    let c = {
      error: n,
      imageIdIndex: s,
      imageId: e12
    };
    triggerEvent(eventTarget_default, Events_default.IMAGE_LOAD_ERROR, c);
  }
  load(e12) {
    let { imageIds: t, loadStatus: n, numFrames: r } = this, { transferSyntaxUID: a } = getMetaData("transferSyntax", t[0]) || {}, o = getMetaData(imageRetrieveMetadataProvider_default.IMAGE_RETRIEVE_CONFIGURATION, this.volumeId, a, "volume");
    if (this.imagesLoader = this.isDynamicVolume() ? this : o ? (o.create || ProgressiveRetrieveImages_default.createProgressive)(o) : this, n.loading === true)
      return;
    let { loaded: s } = this.loadStatus, c = t.length;
    if (s) {
      e12 && e12({
        success: true,
        framesLoaded: c,
        framesProcessed: c,
        numFrames: r,
        totalNumFrames: c
      });
      return;
    }
    e12 && this.loadStatus.callbacks.push(e12), this._prefetchImageIds();
  }
  getLoaderImageOptions(e12) {
    let { transferSyntaxUID: t } = getMetaData("transferSyntax", e12) || {}, n = this.dimensions[1], r = this.dimensions[0], a = this.getImageIdIndex(e12), o = getMetaData("modalityLutModule", e12) || {}, s = getMetaData("generalSeriesModule", e12) || {}, c = {
      rescaleSlope: o.rescaleSlope,
      rescaleIntercept: o.rescaleIntercept,
      modality: s.modality
    }, l = c.modality;
    if (l === "PT" || l === "RTDOSE") {
      let t2 = getMetaData("scalingModule", e12);
      t2 && (this._addScalingToVolume(t2), Object.assign(c, t2));
    }
    let u = hasFloatScalingParameters(c), d = canRenderFloatTextures();
    if (this.isPreScaled = true, c && c.rescaleSlope !== void 0 && c.rescaleIntercept !== void 0) {
      let { rescaleSlope: e13, rescaleIntercept: t2 } = c;
      this.isPreScaled = typeof e13 == "number" && typeof t2 == "number";
    }
    return !d && u && (this.isPreScaled = false), {
      targetBuffer: {
        type: this.dataType,
        rows: n,
        columns: r
      },
      allowFloatRendering: d,
      preScale: {
        enabled: this.isPreScaled,
        scalingParameters: c
      },
      transferPixelData: true,
      requestType: requestTypeDefault,
      transferSyntaxUID: t,
      additionalDetails: {
        imageId: e12,
        imageIdIndex: a,
        volumeId: this.volumeId
      },
      retrieveOptions: void 0
    };
  }
  callLoadImage(e12, t, n) {
    let { cachedFrames: r } = this;
    if (r[t] === ImageQualityStatus_default.FULL_RESOLUTION)
      return;
    let o = (n2) => {
      let { image: r2 } = n2.detail;
      r2.imageId === e12 && (this.vtkOpenGLTexture.setUpdatedFrame(t), eventTarget_default.removeEventListener(Events_default.IMAGE_CACHE_IMAGE_ADDED, o));
    };
    return eventTarget_default.addEventListener(Events_default.IMAGE_CACHE_IMAGE_ADDED, o), ProgressiveIterator.as(loadAndCacheImage(e12, n)).forEach((t2) => {
      this.successCallback(e12, t2);
    }, this.errorCallback.bind(this, t, e12));
  }
  getImageIdsRequests(e12, t) {
    return this.totalNumFrames = this.imageIds.length, this.autoRenderOnLoad && (this.reRenderFraction = this.totalNumFrames * (2 / 100), this.reRenderTarget = this.reRenderFraction), e12.map((e13) => {
      let n = this.getImageIdIndex(e13), r = requestTypeDefault, a = t, o = this.getLoaderImageOptions(e13), { retrieveOptions: s = {} } = getMetaData(imageRetrieveMetadataProvider_default.IMAGE_RETRIEVE_CONFIGURATION, e13, "volume") || {};
      return o.retrieveOptions = {
        ...o.retrieveOptions,
        ...s.default || Object.values(s)?.[0] || {}
      }, {
        callLoadImage: this.callLoadImage.bind(this),
        imageId: e13,
        imageIdIndex: n,
        options: o,
        priority: a,
        requestType: r,
        additionalDetails: { volumeId: this.volumeId }
      };
    });
  }
  getImageLoadRequests(e12) {
    throw Error("Abstract method");
  }
  getImageIdsToLoad() {
    throw Error("Abstract method");
  }
  loadImages() {
    return this.loadStatus.loading = true, this.getImageLoadRequests(5).reverse().forEach((e12) => {
      if (!e12)
        return;
      let { callLoadImage: t, imageId: n, imageIdIndex: r, options: a, priority: o, requestType: s, additionalDetails: c } = e12;
      imageLoadPoolManager_default.addRequest(t.bind(this, n, r, a), s, c, o);
    }), Promise.resolve(true);
  }
  _prefetchImageIds() {
    this.loadStatus.loading = true;
    let e12 = [...this.getImageIdsToLoad()];
    return this.totalNumFrames = this.imageIds.length, this.autoRenderOnLoad && (this.reRenderFraction = this.totalNumFrames * (2 / 100), this.reRenderTarget = this.reRenderFraction), this.imagesLoader.loadImages(e12, this).catch((e13) => {
      console.debug("progressive loading failed to complete", e13);
    });
  }
  _addScalingToVolume(e12) {
    if (this.scaling)
      return;
    let { suvbw: t, suvlbm: n, suvbsa: r } = e12, a = {};
    n && (a.suvbwToSuvlbm = n / t), r && (a.suvbwToSuvbsa = r / t), t && (a.suvbw = t), this.scaling = { PT: a };
  }
  checkDimensionGroupCompletion(e12) {
  }
}, StreamingImageVolume = class extends BaseStreamingImageVolume_default {
  constructor(e12, t) {
    e12.imageIds ||= t.imageIds, super(e12, t), this.getImageIdsToLoad = () => {
      let { imageIds: e13 } = this;
      return this.numFrames = e13.length, e13;
    };
  }
  getScalarData() {
    return this.voxelManager.getScalarData();
  }
  getImageLoadRequests(e12) {
    let { imageIds: t } = this;
    return this.getImageIdsRequests(t, e12);
  }
};
function cornerstoneStreamingImageVolumeLoader(e12, t) {
  if (!t || !t.imageIds || !t.imageIds.length)
    throw Error("ImageIds must be provided to create a streaming image volume");
  async function n() {
    if (t.imageIds[0].split(":")[0] === "wadouri") {
      let [n3, r3] = [Math.floor(t.imageIds.length / 2), t.imageIds.length - 1], a2 = [
        0,
        n3,
        r3
      ];
      await Promise.all(a2.map((n4) => cache_default.isLoaded(t.imageIds[n4]) ? Promise.resolve(true) : new Promise((r4, a3) => {
        let o2 = t.imageIds[n4];
        imageLoadPoolManager_default.addRequest(async () => {
          loadImage(o2).then(() => {
            console.log(`Prefetched imageId: ${o2}`), r4(true);
          }).catch((e13) => {
            a3(e13);
          });
        }, RequestType_default.Prefetch, { volumeId: e12 }, 1);
      }))).catch(console.error);
    }
    let { dimensions: n2, spacing: r2, origin: a, direction: o, metadata: c, imageIds: l, dataType: u, numberOfComponents: d } = generateVolumePropsFromImageIds(t.imageIds, e12);
    return new StreamingImageVolume({
      volumeId: e12,
      metadata: c,
      dimensions: n2,
      spacing: r2,
      origin: a,
      direction: o,
      imageIds: l,
      dataType: u,
      numberOfComponents: d
    }, {
      imageIds: l,
      loadStatus: {
        loaded: false,
        loading: false,
        cancelled: false,
        cachedFrames: [],
        callbacks: []
      }
    });
  }
  let r = n();
  return {
    promise: r,
    decache: () => {
      r.then((e13) => {
        e13.destroy(), e13 = null;
      });
    },
    cancel: () => {
      r.then((e13) => {
        e13.cancelLoading();
      });
    }
  };
}
var volumeLoader_exports = /* @__PURE__ */ __export({
  createAndCacheDerivedLabelmapVolume: () => createAndCacheDerivedLabelmapVolume,
  createAndCacheDerivedVolume: () => createAndCacheDerivedVolume,
  createAndCacheVolume: () => createAndCacheVolume,
  createAndCacheVolumeFromImages: () => createAndCacheVolumeFromImages,
  createAndCacheVolumeFromImagesSync: () => createAndCacheVolumeFromImagesSync,
  createLocalLabelmapVolume: () => createLocalLabelmapVolume,
  createLocalVolume: () => createLocalVolume,
  getUnknownVolumeLoaderSchema: () => getUnknownVolumeLoaderSchema,
  getVolumeLoaderSchemes: () => getVolumeLoaderSchemes,
  loadVolume: () => loadVolume,
  registerUnknownVolumeLoader: () => registerUnknownVolumeLoader,
  registerVolumeLoader: () => registerVolumeLoader
}), volumeLoaders = {}, unknownVolumeLoader = cornerstoneStreamingImageVolumeLoader;
function loadVolumeFromVolumeLoader(e12, t) {
  let n = e12.indexOf(":"), r = e12.substring(0, n), o = volumeLoaders[r];
  if (o == null) {
    if (unknownVolumeLoader == null || typeof unknownVolumeLoader != "function")
      throw Error(`No volume loader for scheme ${r} has been registered`);
    o = unknownVolumeLoader;
  }
  let s = o(e12, t);
  return s.promise.then(function(e13) {
    triggerEvent(eventTarget_default, Events_default.VOLUME_LOADED, { volume: e13 });
  }, function(t2) {
    let n2 = {
      volumeId: e12,
      error: t2
    };
    triggerEvent(eventTarget_default, Events_default.VOLUME_LOADED_FAILED, n2);
  }), s;
}
function loadVolume(e12, t = { imageIds: [] }) {
  if (e12 === void 0)
    throw Error("loadVolume: parameter volumeId must not be undefined");
  let n = cache_default.getVolumeLoadObject(e12);
  return n === void 0 ? (n = loadVolumeFromVolumeLoader(e12, t), n.promise.then((e13) => e13)) : n.promise;
}
async function createAndCacheVolume(e12, t) {
  if (e12 === void 0)
    throw Error("createAndCacheVolume: parameter volumeId must not be undefined");
  let n = cache_default.getVolumeLoadObject(e12);
  return n === void 0 ? (n = loadVolumeFromVolumeLoader(e12, t), cache_default.putVolumeLoadObject(e12, n), n.promise) : n.promise;
}
function createAndCacheDerivedVolume(e12, t) {
  let n = cache_default.getVolume(e12);
  if (!n)
    throw Error(`Cannot created derived volume: Referenced volume with id ${e12} does not exist.`);
  let { volumeId: r } = t, { voxelRepresentation: a } = t;
  r === void 0 && (r = uuidv4());
  let { metadata: o, dimensions: s, spacing: c, origin: l, direction: u } = n, d = createAndCacheDerivedImages(n.isDynamicVolume() ? n.getCurrentDimensionGroupImageIds() : n.imageIds ?? [], {
    targetBuffer: t.targetBuffer,
    voxelRepresentation: a
  }), f = d[0].dataType, p = d.map((e13) => e13.imageId), m = new ImageVolume({
    volumeId: r,
    dataType: f,
    metadata: structuredClone(o),
    dimensions: [
      s[0],
      s[1],
      s[2]
    ],
    spacing: c,
    origin: l,
    direction: u,
    referencedVolumeId: e12,
    imageIds: p,
    referencedImageIds: n.imageIds ?? []
  });
  return cache_default.putVolumeSync(r, m), m;
}
async function createAndCacheVolumeFromImages(e12, t) {
  if (t === void 0)
    throw Error("createAndCacheVolumeFromImages: parameter imageIds must not be undefined");
  if (e12 === void 0)
    throw Error("createAndCacheVolumeFromImages: parameter volumeId must not be undefined");
  return cache_default.getVolume(e12) || (t.filter((e13) => !cache_default.getImage(e13)).length === 0 ? createAndCacheVolumeFromImagesSync(e12, t) : await createAndCacheVolume(e12, { imageIds: t }));
}
function createAndCacheVolumeFromImagesSync(e12, t) {
  if (t === void 0)
    throw Error("createAndCacheVolumeFromImagesSync: parameter imageIds must not be undefined");
  if (e12 === void 0)
    throw Error("createAndCacheVolumeFromImagesSync: parameter volumeId must not be undefined");
  let n = cache_default.getVolume(e12);
  if (n)
    return n;
  let r = generateVolumePropsFromImageIds(t, e12), a = new ImageVolume({
    volumeId: e12,
    dataType: r.dataType,
    metadata: structuredClone(r.metadata),
    dimensions: r.dimensions,
    spacing: r.spacing,
    origin: r.origin,
    direction: r.direction,
    referencedVolumeId: r.referencedVolumeId,
    imageIds: r.imageIds,
    referencedImageIds: r.referencedImageIds
  });
  return cache_default.putVolumeSync(e12, a), a;
}
function createLocalVolume(e12, t = {}) {
  let { metadata: n, dimensions: r, spacing: a, origin: o, direction: s, scalarData: c, targetBuffer: l, preventCache: u = false } = t, d = cache_default.getVolume(e12);
  if (d)
    return d;
  let f = r[0] * r[1], p = c ? c.constructor.name : l?.type ?? "Float32Array", m = f * r[2], h;
  switch (p) {
    case "Uint8Array":
    case "Int8Array":
      h = m;
      break;
    case "Uint16Array":
    case "Int16Array":
      h = m * 2;
      break;
    case "Float32Array":
      h = m * 4;
      break;
  }
  if (!cache_default.isCacheable(h))
    throw Error(`Cannot created derived volume: Volume with id ${e12} is not cacheable.`);
  let g = [], _ = [];
  for (let t2 = 0; t2 < r[2]; t2++) {
    let n2 = `${e12}_slice_${t2}`;
    g.push(n2);
    let l2 = createAndCacheLocalImage(n2, {
      scalarData: c.subarray(t2 * f, (t2 + 1) * f),
      dimensions: [r[0], r[1]],
      spacing: [a[0], a[1]],
      origin: o,
      direction: s,
      targetBuffer: { type: p }
    });
    _.push(l2);
  }
  let v = new ImageVolume({
    volumeId: e12,
    metadata: structuredClone(n),
    dimensions: [
      r[0],
      r[1],
      r[2]
    ],
    spacing: a,
    origin: o,
    direction: s,
    imageIds: g,
    dataType: p
  });
  return v.voxelManager = VoxelManager.createImageVolumeVoxelManager({
    imageIds: g,
    dimensions: r,
    numberOfComponents: 1,
    id: e12
  }), u || cache_default.putVolumeSync(e12, v), v;
}
function registerVolumeLoader(e12, t) {
  volumeLoaders[e12] = t;
}
function getVolumeLoaderSchemes() {
  return Object.keys(volumeLoaders);
}
function registerUnknownVolumeLoader(e12) {
  let t = unknownVolumeLoader;
  return unknownVolumeLoader = e12, t;
}
function getUnknownVolumeLoaderSchema() {
  return unknownVolumeLoader.name;
}
function createAndCacheDerivedLabelmapVolume(e12, t = {}) {
  return createAndCacheDerivedVolume(e12, {
    ...t,
    targetBuffer: {
      type: "Uint8Array",
      ...t?.targetBuffer
    }
  });
}
function createLocalLabelmapVolume(e12, t, n = false) {
  return e12.scalarData ||= new Uint8Array(e12.dimensions[0] * e12.dimensions[1] * e12.dimensions[2]), createLocalVolume(t, {
    ...e12,
    preventCache: n
  });
}
function createVolumeMapper(e12, t) {
  let n = vtkSharedVolumeMapper_default.newInstance();
  n.setInputData(e12);
  let r = e12.getSpacing(), a = (getConfiguration().rendering?.volumeRendering?.sampleDistanceMultiplier || 1) * (r[0] + r[1] + r[2]) / 6;
  return n.setMaximumSamplesPerRay(4e3), n.setSampleDistance(a), n.setScalarTexture(t), n;
}
function convertMapperToNotSharedMapper(e12) {
  let t = vtkVolumeMapper$1.newInstance();
  t.setBlendMode(e12.getBlendMode());
  let n = e12.getInputData(), { voxelManager: r } = n.get("voxelManager"), a = r.getCompleteScalarDataArray(), o = vtkDataArray$1.newInstance({
    name: "Pixels",
    values: a
  });
  return n.getPointData().setScalars(o), t.setInputData(n), t.setMaximumSamplesPerRay(e12.getMaximumSamplesPerRay()), t.setSampleDistance(e12.getSampleDistance()), t;
}
var PRIORITY = 0, REQUEST_TYPE = RequestType_default.Prefetch;
async function setDefaultVolumeVOI(e12, t) {
  let n = getVOIFromMetadata(t);
  if (!n && t.imageIds.length && (n = await getVOIFromMiddleSliceMinMax(t), n = handlePreScaledVolume(t, n)), !n || n.lower === void 0 || n.upper === void 0)
    return;
  let r = n.lower, a = n.lower === n.upper ? n.upper + 1 : n.upper;
  e12.getProperty().getRGBTransferFunction(0).setMappingRange(r, a);
}
function handlePreScaledVolume(e12, t) {
  let n = e12.imageIds, r = n[Math.floor(n.length / 2)];
  return _isCurrentImagePTPrescaled((getMetaData("generalSeriesModule", r) || {}).modality, e12) ? {
    lower: 0,
    upper: 5
  } : t;
}
function getVOIFromMetadata(e12) {
  let { imageIds: t, metadata: n } = e12, r;
  if (t?.length) {
    let e13 = t[Math.floor(t.length / 2)], n2 = getMetaData("voiLutModule", e13);
    if (n2 && n2.windowWidth !== void 0 && n2.windowCenter !== void 0) {
      n2?.voiLUTFunction && (r = {}, r.voiLUTFunction = n2?.voiLUTFunction);
      let { windowWidth: e14, windowCenter: t2 } = n2, a = Array.isArray(e14) ? e14[0] : e14, o = Array.isArray(t2) ? t2[0] : t2;
      a !== 0 && (r = {
        windowWidth: a,
        windowCenter: o
      });
    }
  } else
    r = n.voiLut[0];
  if (r && r.windowWidth !== void 0 && r.windowWidth !== 0 && r.windowCenter !== void 0) {
    let { lower: e13, upper: t2 } = toLowHighRange(Number(r.windowWidth), Number(r.windowCenter), r.voiLUTFunction);
    return isNaN(e13) || isNaN(t2) ? void 0 : {
      lower: e13,
      upper: t2
    };
  }
}
async function getVOIFromMiddleSliceMinMax(e12) {
  let { imageIds: t } = e12, n = Math.floor(t.length / 2), r = e12.imageIds[n], { modality: a } = getMetaData("generalSeriesModule", r) || {}, o = getMetaData("modalityLutModule", r) || {}, s = {
    rescaleSlope: o.rescaleSlope,
    rescaleIntercept: o.rescaleIntercept,
    modality: a
  }, c;
  if (a === "PT") {
    let e13 = getMetaData("scalingModule", r);
    e13 && (c = {
      ...s,
      suvbw: e13.suvbw
    });
  }
  let l = {
    priority: PRIORITY,
    requestType: REQUEST_TYPE,
    preScale: { scalingParameters: c }
  }, u = cache_default.getImage(r);
  e12.referencedImageIds?.length || (u = await loadAndCacheImage(r, {
    ...l,
    ignoreCache: true
  }));
  let { min: d, max: f } = u.voxelManager.getMinMax();
  return d?.length > 1 && (d = Math.min(...d), f = Math.max(...f)), {
    lower: d,
    upper: f
  };
}
function _isCurrentImagePTPrescaled(e12, t) {
  return !(e12 !== "PT" || !t.isPreScaled || !t.scaling?.PT.suvbw);
}
var setDefaultVolumeVOI_default = setDefaultVolumeVOI;
async function createVolumeActor(e12, t, n, r = false) {
  let { volumeId: a, callback: o, blendMode: s } = e12, c = await loadVolume(a);
  if (!c)
    throw Error(`imageVolume with id: ${c.volumeId} does not exist`);
  let { imageData: l, vtkOpenGLTexture: u } = c, d = createVolumeMapper(l, u);
  s && d.setBlendMode(s);
  let f = vtkVolume$1.newInstance();
  f.setMapper(d);
  let { numberOfComponents: p } = l.get("numberOfComponents"), m = f.getProperty();
  return m.set({ viewportId: n }, true), getConfiguration().rendering.preferSizeOverAccuracy && m.setPreferSizeOverAccuracy(true), p === 3 && f.getProperty().setIndependentComponents(false), await setDefaultVolumeVOI_default(f, c), o && o({
    volumeActor: f,
    volumeId: a
  }), r || triggerVOIModified(t, n, f, a), f;
}
function triggerVOIModified(e12, t, n, r) {
  let o = n.getProperty().getRGBTransferFunction(0).getRange(), s = {
    viewportId: t,
    range: {
      lower: o[0],
      upper: o[1]
    },
    volumeId: r
  };
  triggerEvent(e12, Events_default.VOI_MODIFIED, s);
}
var createVolumeActor_default = createVolumeActor;
function getVolumeActorCorners(e12) {
  let t = e12.getMapper().getInputData(), n = t.extentToBounds(t.getExtent());
  return [
    [
      n[0],
      n[2],
      n[4]
    ],
    [
      n[0],
      n[2],
      n[5]
    ],
    [
      n[0],
      n[3],
      n[4]
    ],
    [
      n[0],
      n[3],
      n[5]
    ],
    [
      n[1],
      n[2],
      n[4]
    ],
    [
      n[1],
      n[2],
      n[5]
    ],
    [
      n[1],
      n[3],
      n[4]
    ],
    [
      n[1],
      n[3],
      n[5]
    ]
  ];
}
var SMALL_EPSILON = epsilon_default * epsilon_default, isOne = (e12) => Math.abs(Math.abs(e12) - 1) < SMALL_EPSILON, isUnit = (e12, t) => isOne(e12[t]) || isOne(e12[t + 1]) || isOne(e12[t + 2]), isOrthonormal = (e12) => isUnit(e12, 0) && isUnit(e12, 3) && isUnit(e12, 6);
function getSliceRange(e12, t, n) {
  let r = e12.getMapper().getInputData(), a;
  if (isOrthonormal(r.getDirection()))
    a = getVolumeActorCorners(e12);
  else {
    let [e13, t2, n2] = r.getDimensions();
    a = [
      [
        0,
        0,
        0
      ],
      [
        e13 - 1,
        0,
        0
      ],
      [
        0,
        t2 - 1,
        0
      ],
      [
        e13 - 1,
        t2 - 1,
        0
      ],
      [
        0,
        0,
        n2 - 1
      ],
      [
        e13 - 1,
        0,
        n2 - 1
      ],
      [
        0,
        t2 - 1,
        n2 - 1
      ],
      [
        e13 - 1,
        t2 - 1,
        n2 - 1
      ]
    ].map((e14) => r.indexToWorld(e14));
  }
  let o = vtkMatrixBuilder.buildFromDegree().identity().rotateFromDirections(t, [
    1,
    0,
    0
  ]);
  a.forEach((e13) => o.apply(e13));
  let s = [...n];
  o.apply(s);
  let c = s[0], l = Infinity, u = -Infinity;
  for (let e13 = 0; e13 < 8; e13++) {
    let t2 = a[e13][0];
    t2 > u && (u = t2), t2 < l && (l = t2);
  }
  return {
    min: l,
    max: u,
    current: c,
    actor: e12,
    viewPlaneNormal: t,
    focalPoint: n
  };
}
function getSpacingInNormalDirection(e12, t) {
  let { direction: n, spacing: r } = e12, a = n.slice(0, 3), o = n.slice(3, 6), s = n.slice(6, 9), c = [
    dot$3(a, t),
    dot$3(o, t),
    dot$3(s, t)
  ], l = create$4();
  return set$4(l, c[0] * r[0], c[1] * r[1], c[2] * r[2]), length$2(l);
}
const getVolumeId = (e12) => {
  let t = e12.includes("volumeId:") ? e12.substring(9) : e12, n = t.indexOf("sliceIndex=");
  return n === -1 ? t : t.substring(0, n - 1);
};
var EPSILON_PART = 1 + epsilon_default, startsWith = (e12, t) => t === e12.substring(0, Math.min(e12.length, t.length)), isPrimaryVolume = (e12) => !!getVolumeLoaderSchemes().find((t) => startsWith(e12.volumeId, t));
function getTargetVolumeAndSpacingInNormalDir(e12, t, n, r = false) {
  let { viewPlaneNormal: a } = t, o = e12.getActors();
  if (!o.length)
    return {
      spacingInNormalDirection: null,
      imageVolume: null,
      actorUID: null
    };
  let s = o.map((e13) => {
    let t2 = e13.referencedId ?? e13.uid;
    return cache_default.getVolume(t2);
  }).filter((e13) => !!e13);
  if (n) {
    let t2 = getVolumeId(n), c2 = s.findIndex((e13) => t2.includes(e13.volumeId)), l2 = s[c2], { uid: u } = o[c2];
    return {
      imageVolume: l2,
      spacingInNormalDirection: getSpacingInNormal(l2, a, e12, r),
      actorUID: u
    };
  }
  if (!s.length)
    return {
      spacingInNormalDirection: null,
      imageVolume: null,
      actorUID: null
    };
  let c = {
    spacingInNormalDirection: Infinity,
    imageVolume: null,
    actorUID: null
  }, l = s.find(isPrimaryVolume);
  for (let t2 = 0; t2 < s.length; t2++) {
    let n2 = s[t2];
    if (l && !isPrimaryVolume(n2))
      continue;
    let r2 = getSpacingInNormal(n2, a, e12);
    r2 * EPSILON_PART < c.spacingInNormalDirection && (c.spacingInNormalDirection = r2, c.imageVolume = n2, c.actorUID = o[t2].uid);
  }
  return c;
}
function getSpacingInNormal(e12, t, n, r = false) {
  let { slabThickness: a } = n.getProperties(), o = a;
  return (!a || !r) && (o = getSpacingInNormalDirection(e12, t)), o;
}
function getImageSliceDataForVolumeViewport(e12) {
  let t = e12.getCamera(), { spacingInNormalDirection: n, imageVolume: r } = getTargetVolumeAndSpacingInNormalDir(e12, t);
  if (!r)
    return;
  let { viewPlaneNormal: a, focalPoint: o } = t, s = e12.getActors().find((e13) => e13.referencedId === r.volumeId || e13.uid === r.volumeId);
  s || console.warn("No actor found for with actorUID of", r.volumeId);
  let c = s.actor, { min: l, max: u, current: d } = getSliceRange(c, a, o), f = Math.round((u - l) / n) + 1, p = (d - l) / (u - l) * f;
  return p = Math.floor(p), p > f - 1 ? p = f - 1 : p < 0 && (p = 0), {
    numberOfSlices: f,
    imageIndex: p
  };
}
var getImageSliceDataForVolumeViewport_default = getImageSliceDataForVolumeViewport, state$3 = {};
function resetVolumeNewImageState(e12) {
  state$3[e12] !== void 0 && delete state$3[e12];
}
function volumeNewImageEventDispatcher(e12) {
  let { renderingEngineId: t, viewportId: n } = e12.detail, r = getRenderingEngine(t).getViewport(n);
  if (!("setVolumes" in r))
    throw Error("volumeNewImageEventDispatcher: viewport does not have setVolumes method");
  state$3[r.id] === void 0 && (state$3[r.id] = 0);
  let o = getImageSliceDataForVolumeViewport_default(r);
  if (!o) {
    console.warn(`volumeNewImageEventDispatcher: sliceData is undefined for viewport ${r.id}`);
    return;
  }
  let { numberOfSlices: s, imageIndex: c } = o;
  if (state$3[r.id] === c)
    return;
  state$3[r.id] = c;
  let l = {
    imageIndex: c,
    viewportId: n,
    renderingEngineId: t,
    numberOfSlices: s
  };
  triggerEvent(r.element, Events_default.VOLUME_NEW_IMAGE, l);
}
var volumeNewImageEventDispatcher_default = volumeNewImageEventDispatcher, planar_exports = /* @__PURE__ */ __export({
  isPointOnPlane: () => isPointOnPlane,
  linePlaneIntersection: () => linePlaneIntersection,
  planeDistanceToPoint: () => planeDistanceToPoint,
  planeEquation: () => planeEquation,
  threePlaneIntersection: () => threePlaneIntersection
});
function linePlaneIntersection(e12, t, n) {
  let [r, a, o] = e12, [s, c, l] = t, [u, d, f, p] = n, m = s - r, h = c - a, g = l - o, _ = -1 * (u * r + d * a + f * o - p) / (u * m + d * h + f * g);
  return [
    m * _ + r,
    h * _ + a,
    g * _ + o
  ];
}
function planeEquation(e12, t, n = false) {
  let [r, a, o] = e12, s = r * t[0] + a * t[1] + o * t[2];
  if (n) {
    let e13 = Math.sqrt(r * r + a * a + o * o);
    return [
      r / e13,
      a / e13,
      o / e13,
      s / e13
    ];
  }
  return [
    r,
    a,
    o,
    s
  ];
}
function threePlaneIntersection(e12, t, n) {
  let [r, a, o, s] = e12, [c, l, u, d] = t, [f, p, m, h] = n, g = fromValues$5(r, c, f, a, l, p, o, u, m), _ = fromValues$5(s, d, h, a, l, p, o, u, m), v = fromValues$5(r, c, f, s, d, h, o, u, m), y = fromValues$5(r, c, f, a, l, p, s, d, h);
  return [
    determinant$1(_) / determinant$1(g),
    determinant$1(v) / determinant$1(g),
    determinant$1(y) / determinant$1(g)
  ];
}
function planeDistanceToPoint(e12, t, n = false) {
  let [r, a, o, s] = e12, [c, l, u] = t, d = r * c + a * l + o * u - s, f = Math.abs(d) / Math.sqrt(r * r + a * a + o * o);
  return (n ? Math.sign(d) : 1) * f;
}
function isPointOnPlane(e12, t, n = epsilon_default) {
  return planeDistanceToPoint(t, e12) < n;
}
function hasNaNValues(e12) {
  return Array.isArray(e12) ? e12.some((e13) => Number.isNaN(e13)) : Number.isNaN(e12);
}
function deepClone(e12) {
  if (typeof e12 != "object" || !e12 || typeof e12 == "function" || typeof structuredClone == "function")
    return e12;
  if (Array.isArray(e12))
    return e12.map(deepClone);
  {
    let t = {};
    for (let n in e12)
      Object.prototype.hasOwnProperty.call(e12, n) && (t[n] = deepClone(e12[n]));
    return t;
  }
}
var ORTHOGONAL_TEST_VALUE = 0.95;
function updatePlaneRestriction(e12, t) {
  if (!e12?.length || !t.FrameOfReferenceUID)
    return;
  t.planeRestriction ||= {
    FrameOfReferenceUID: t.FrameOfReferenceUID,
    point: e12[0],
    inPlaneVector1: null,
    inPlaneVector2: null
  };
  let { planeRestriction: n } = t;
  if (e12.length === 1)
    return n.inPlaneVector1 = null, n.inPlaneVector2 = null, n;
  let r = sub$1(create$4(), e12[0], e12[Math.floor(e12.length / 2)]);
  normalize$4(r, r), n.inPlaneVector1 = r, n.inPlaneVector2 = null;
  let a = e12.length;
  if (a > 2)
    for (let t2 = Math.floor(a / 3); t2 < a; t2++) {
      let r2 = sub$1(create$4(), e12[t2], e12[0]), a2 = length$2(r2);
      if (!isEqual(a2, 0) && dot$3(r2, n.inPlaneVector1) < a2 * ORTHOGONAL_TEST_VALUE)
        return normalize$4(r2, r2), n.inPlaneVector2 = r2, n;
    }
  return n;
}
function rotateToViewCoordinates(e12, t, n) {
  let r = cross$1(create$4(), t, n);
  normalize$4(r, r);
  let a = e12.getExtent(), o = a[0], s = a[1] + 1, c = a[2], l = a[3] + 1, u = a[4], d = a[5] + 1;
  return [
    [
      o,
      c,
      u
    ],
    [
      s,
      c,
      u
    ],
    [
      o,
      l,
      u
    ],
    [
      s,
      l,
      u
    ],
    [
      o,
      c,
      d
    ],
    [
      s,
      c,
      d
    ],
    [
      o,
      l,
      d
    ],
    [
      s,
      l,
      d
    ]
  ].map((a2) => {
    let o2 = [
      0,
      0,
      0
    ];
    return e12.indexToWorld(a2, o2), [
      dot$3(o2, r),
      dot$3(o2, n),
      dot$3(o2, t)
    ];
  });
}
function findMinCornerIndex(e12, t) {
  let n = 0, r = e12[0][t];
  for (let a = 1; a < e12.length; a++)
    e12[a][t] < r && (r = e12[a][t], n = a);
  return n;
}
function calculateSize(e12, t) {
  let n = findMinCornerIndex(e12, t);
  return e12[n ^ 7][t] - e12[n][t];
}
function getCubeSizeInView(e12, t, n) {
  let r = rotateToViewCoordinates(e12, t, n);
  return {
    widthWorld: calculateSize(r, 0),
    heightWorld: calculateSize(r, 1),
    depthWorld: calculateSize(r, 2)
  };
}
var getDisplayCanvasSize = (e12) => {
  let t = window?.devicePixelRatio || 1, n = e12.canvas?.clientWidth, r = e12.canvas?.clientHeight;
  return [n || e12.sWidth / t, r || e12.sHeight / t];
}, Viewport_default = class e4 {
  static {
    this.CameraViewPresentation = {
      rotation: true,
      pan: true,
      zoom: true,
      aspectRatio: true,
      displayArea: true
    };
  }
  static {
    this.TransferViewPresentation = {
      windowLevel: true,
      paletteLut: true
    };
  }
  constructor(e12) {
    this.insetImageMultiplier = getConfiguration().rendering?.useLegacyCameraFOV ? 1.1 : 1, this.flipHorizontal = false, this.flipVertical = false, this.viewportStatus = ViewportStatus_default.NO_DATA, this._suppressCameraModifiedEvents = false, this.hasPixelSpacing = true, this.getProperties = () => ({}), this.setRotation = (e13) => {
    }, this.viewportWidgets = /* @__PURE__ */ new Map(), this.addWidget = (e13, t) => {
      this.viewportWidgets.set(e13, t);
    }, this.getWidget = (e13) => this.viewportWidgets.get(e13), this.getWidgets = () => Array.from(this.viewportWidgets.values()), this.getRenderPasses = () => null, this.removeWidgets = () => {
      this.getWidgets().forEach((e13) => {
        if (e13.getEnabled() && e13.setEnabled(false), e13.getActor && e13.getRenderer) {
          let t = e13.getActor(), n = e13.getRenderer();
          n && t && n.removeActor(t);
        }
      });
    }, this.id = e12.id, this.renderingEngineId = e12.renderingEngineId, this.type = e12.type, this.element = e12.element, this.canvas = e12.canvas, this.sx = e12.sx, this.sy = e12.sy, this.sWidth = e12.sWidth, this.sHeight = e12.sHeight, this._actors = /* @__PURE__ */ new Map(), this.element.setAttribute("data-viewport-uid", this.id), this.element.setAttribute("data-rendering-engine-uid", this.renderingEngineId), this.defaultOptions = deepClone(e12.defaultOptions), this.suppressEvents = e12.defaultOptions.suppressEvents ? e12.defaultOptions.suppressEvents : false, this.options = deepClone(e12.defaultOptions), this.isDisabled = false;
  }
  static get useCustomRenderingPipeline() {
    return false;
  }
  isOrientationChangeable() {
    return false;
  }
  setRendered() {
    this.viewportStatus === ViewportStatus_default.NO_DATA || this.viewportStatus === ViewportStatus_default.LOADING || (this.viewportStatus = ViewportStatus_default.RENDERED);
  }
  setNeedsRender() {
    this.viewportStatus = ViewportStatus_default.NEEDS_RENDER;
  }
  setColorTransform(e12, t) {
    let n = null;
    if (!e12 && !t)
      return;
    let r = t || [
      255,
      255,
      255
    ], a = Math.max(...r), o = r.map((e13) => a / e13), { lower: s = 0, upper: c = 255 } = e12 || {}, l = (c - s + 1) / 255, u = s / 255;
    return n = `url('data:image/svg+xml,      <svg xmlns="http://www.w3.org/2000/svg">        <filter id="colour" color-interpolation-filters="linearRGB">        <feColorMatrix type="matrix"         values="          ${o[0] * l} 0 0 0 ${u}           0 ${o[1] * l} 0 0 ${u}           0 0 ${o[2] * l} 0 ${u}           0 0 0 1 0" />        </filter>      </svg>#colour')`, n;
  }
  getRenderingEngine() {
    return renderingEngineCache_default.get(this.renderingEngineId);
  }
  getRenderer() {
    let e12 = this.getRenderingEngine();
    if (!e12 || e12.hasBeenDestroyed)
      throw Error("Rendering engine has been destroyed");
    return e12.offscreenMultiRenderWindow?.getRenderer(this.id);
  }
  render() {
    this.getRenderingEngine().renderViewport(this.id);
  }
  setOptions(e12, t = false) {
    this.options = structuredClone(e12), this.options?.displayArea && this.setDisplayArea(this.options?.displayArea), t && this.render();
  }
  reset(e12 = false) {
    this.options = structuredClone(this.defaultOptions), e12 && this.render();
  }
  getSliceViewInfo() {
    throw Error("Method not implemented.");
  }
  flip({ flipHorizontal: e12, flipVertical: t }) {
    let n = this.getDefaultImageData();
    if (!n)
      return;
    let r = this.getCamera(), { viewPlaneNormal: a, viewUp: o, focalPoint: s, position: c } = r, l = cross$1(create$4(), a, o), u = copy$3(create$4(), o), d = negate(create$4(), a), f = distance(c, s), p = n.getDimensions().map((e13) => Math.floor(e13 / 2)), m = [
      p[0],
      p[1],
      p[2]
    ], h = n.indexToWorld(m, create$4()), g = this._getFocalPointForResetCamera(h, r, {
      resetPan: true,
      resetToCenter: false
    }), _ = subtract$3(create$4(), s, g), v = length$2(_), y = (e13) => {
      let t2 = scale$3(create$4(), e13, 2 * dot$3(_, e13));
      return subtract$3(t2, t2, _), normalize$4(t2, t2), t2;
    };
    if (e12) {
      let e13 = y(u), t2 = scaleAndAdd(create$4(), g, e13, v), n2 = scaleAndAdd(create$4(), t2, d, f);
      this.setCamera({
        viewPlaneNormal: d,
        position: n2,
        focalPoint: t2
      }), this.flipHorizontal = !this.flipHorizontal;
    }
    if (t) {
      u = negate(u, o);
      let e13 = y(l), t2 = scaleAndAdd(create$4(), g, e13, v), n2 = scaleAndAdd(create$4(), t2, d, f);
      this.setCamera({
        focalPoint: t2,
        viewPlaneNormal: d,
        viewUp: u,
        position: n2
      }), this.flipVertical = !this.flipVertical;
    }
    this.render();
  }
  getDefaultImageData() {
    let e12 = this.getDefaultActor();
    if (e12 && isImageActor(e12))
      return e12.actor.getMapper().getInputData();
  }
  getDefaultActor() {
    return this.getActors()[0];
  }
  getActors() {
    return Array.from(this._actors.values());
  }
  getActorUIDs() {
    return Array.from(this._actors.keys());
  }
  getActor(e12) {
    return this._actors.get(e12);
  }
  getImageActor(e12) {
    let t = this.getActors(), n = t[0];
    return e12 && (n = t.find((t2) => t2.referencedId === e12)), !n || !isImageActor(n) ? null : n.actor;
  }
  getActorUIDByIndex(e12) {
    let t = this.getActors()[e12];
    if (t)
      return t.uid;
  }
  getActorByIndex(e12) {
    return this.getActors()[e12];
  }
  setActors(e12) {
    let t = this.getActors();
    this.removeAllActors(), this.addActors(e12, { resetCamera: true }), triggerEvent(this.element, Events_default.ACTORS_CHANGED, {
      viewportId: this.id,
      removedActors: t,
      addedActors: e12,
      currentActors: e12
    });
  }
  _removeActor(e12) {
    let t = this.getActor(e12);
    if (!t) {
      console.warn(`Actor ${e12} does not exist in ${this.id}, can't remove`);
      return;
    }
    return this.getRenderer().removeActor(t.actor), this._actors.delete(e12), t;
  }
  removeActors(e12) {
    let t = [];
    e12.forEach((e13) => {
      let n2 = this._removeActor(e13);
      n2 && t.push(n2);
    });
    let n = this.getActors();
    triggerEvent(this.element, Events_default.ACTORS_CHANGED, {
      viewportId: this.id,
      removedActors: t,
      addedActors: [],
      currentActors: n
    });
  }
  addActors(e12, t = {}) {
    let { resetCamera: n = false } = t, r = this.getRenderingEngine();
    if (!r || r.hasBeenDestroyed) {
      console.warn("Viewport::addActors::Rendering engine has not been initialized or has been destroyed");
      return;
    }
    if (e12.forEach((e13) => {
      this.addActor(e13);
    }), n)
      this.resetCamera();
    else {
      let e13 = this.getViewPresentation(), t2 = this.getViewReference();
      this.resetCamera(), this.setViewReference(t2), this.setViewPresentation(e13);
    }
    triggerEvent(this.element, Events_default.ACTORS_CHANGED, {
      viewportId: this.id,
      removedActors: [],
      addedActors: e12,
      currentActors: this.getActors()
    });
  }
  addActor(e12) {
    let { uid: t, actor: n } = e12, r = this.getRenderingEngine();
    if (!r || r.hasBeenDestroyed) {
      console.warn(`Cannot add actor UID of ${t} Rendering Engine has been destroyed`);
      return;
    }
    if (!t || !n)
      throw Error("Actors should have uid and vtk Actor properties");
    if (this.getActor(t)) {
      console.warn(`Actor ${t} already exists for this viewport`);
      return;
    }
    this.getRenderer()?.addActor(n), this._actors.set(t, Object.assign({}, e12)), this.updateCameraClippingPlanesAndRange(), triggerEvent(this.element, Events_default.ACTORS_CHANGED, {
      viewportId: this.id,
      removedActors: [],
      addedActors: [e12],
      currentActors: this.getActors()
    });
  }
  removeAllActors() {
    let e12 = this.getActors();
    this.getRenderer()?.removeAllViewProps(), this._actors = /* @__PURE__ */ new Map(), triggerEvent(this.element, Events_default.ACTORS_CHANGED, {
      viewportId: this.id,
      removedActors: e12,
      addedActors: [],
      currentActors: []
    });
  }
  resetCameraNoEvent() {
    let e12 = this._suppressCameraModifiedEvents;
    this._suppressCameraModifiedEvents = true, this.resetCamera(), this._suppressCameraModifiedEvents = e12;
  }
  setCameraNoEvent(e12) {
    let t = this._suppressCameraModifiedEvents;
    this._suppressCameraModifiedEvents = true, this.setCamera(e12), this._suppressCameraModifiedEvents = t;
  }
  _getViewImageDataIntersections(e12, t, n) {
    let r = n[0], a = n[1], o = n[2], s = r * t[0] + a * t[1] + o * t[2], c = e12.getBounds(), l = this._getEdges(c), u = [];
    for (let e13 of l) {
      let [[t2, n2, l2], [d, f, p]] = e13;
      if (r * (d - t2) + a * (f - n2) + o * (p - l2) === 0)
        continue;
      let m = linePlaneIntersection([
        t2,
        n2,
        l2
      ], [
        d,
        f,
        p
      ], [
        r,
        a,
        o,
        s
      ]);
      this._isInBounds(m, c) && u.push(m);
    }
    return u;
  }
  setInterpolationType(e12, t) {
  }
  setDisplayArea(e12, t = false) {
    if (!e12)
      return;
    let { storeAsInitialCamera: n, type: r } = e12;
    n && (this.options.displayArea = e12);
    let { _suppressCameraModifiedEvents: o } = this;
    if (this._suppressCameraModifiedEvents = true, this.setCamera(this.fitToCanvasCamera), r === "SCALE" ? this.setDisplayAreaScale(e12) : (this.setInterpolationType(this.getProperties()?.interpolationType ?? InterpolationType_default.LINEAR), this.setDisplayAreaFit(e12)), n && (this.initialCamera = this.getCamera()), this._suppressCameraModifiedEvents = o, !t && !o) {
      let t2 = {
        viewportId: this.id,
        displayArea: e12,
        storeAsInitialCamera: n
      };
      triggerEvent(this.element, Events_default.DISPLAY_AREA_MODIFIED, t2), this.setCamera(this.getCamera());
    }
  }
  setDisplayAreaScale(e12) {
    let { scale: t = 1 } = e12, n = this.canvas, r = n.height, a = n.width;
    if (r < 8 || a < 8)
      return;
    let o = this.getDefaultImageData().getSpacing()[1];
    this.setInterpolationType(InterpolationType_default.NEAREST), this.setCamera({ parallelScale: r * o / (2 * t) }), delete e12.imageArea, this.setDisplayAreaFit(e12);
    let { focalPoint: s, position: c, viewUp: l, viewPlaneNormal: u } = this.getCamera(), f = create$4();
    n.height % 2 && scaleAndAdd(f, f, l, t * 0.5 * o), n.width % 2 && scaleAndAdd(f, f, cross$1(create$4(), l, u), t * 0.5 * o), !(!f[0] && !f[1] && !f[2]) && this.setCamera({
      focalPoint: add$4(create$4(), s, f),
      position: add$4(create$4(), c, f)
    });
  }
  setDisplayAreaFit(e12) {
    let { imageArea: t, imageCanvasPoint: n } = e12, r = this.getDefaultImageData();
    if (!r)
      return;
    let [a, o] = getDisplayCanvasSize(this), s = r.getDimensions(), c = this.worldToCanvas(r.indexToWorld([
      0,
      0,
      0
    ])), l = this.worldToCanvas(r.indexToWorld([
      s[0],
      s[1],
      s[2]
    ])), [u, d] = [Math.abs(l[0] - c[0]), Math.abs(l[1] - c[1])], f = this.getZoom() / this.insetImageMultiplier;
    if (t) {
      let [e13, n2] = t, r2 = Math.max(Math.abs(u / a), Math.abs(d / o)), s2 = Math.abs(e13 * u / a), c2 = Math.abs(n2 * d / o), l2 = this.getZoom(), p = this.getZoom(this.fitToCanvasCamera);
      f = (s2 > c2 ? r2 / s2 : r2 / c2) * l2 / p, this.setZoom(this.insetImageMultiplier * f, false);
    }
    if (n) {
      let { imagePoint: e13, canvasPoint: t2 = e13 || [0.5, 0.5] } = n, [r2, s2] = t2, c2 = a * (r2 - 0.5), l2 = o * (s2 - 0.5), [p, m] = e13 || t2, h = f, g = this.insetImageMultiplier * h * u * (0.5 - p), _ = this.insetImageMultiplier * h * d * (0.5 - m), v = [g + c2, _ + l2];
      add$1(v, v, this.getPan()), this.setPan(v, false);
    }
  }
  getDisplayArea() {
    return this.options?.displayArea;
  }
  resetCamera(t) {
    let { resetPan: n = true, resetZoom: r = true, resetToCenter: a = true, storeAsInitialCamera: o = true, resetAspectRatio: s = true } = t || {}, c = this.getRenderer();
    this.setCameraNoEvent({
      flipHorizontal: false,
      flipVertical: false
    });
    let u = this.getCamera(), d, f = this.getDefaultActor();
    d = f && isImageActor(f) ? f.actor.getMapper().getInputData().getBounds() : c.computeVisiblePropBounds();
    let p = [
      0,
      0,
      0
    ], m = this.getDefaultImageData(), h = this.getVtkActiveCamera(), g = h.getViewPlaneNormal(), _ = h.getViewUp();
    if (p[0] = (d[0] + d[1]) / 2, p[1] = (d[2] + d[3]) / 2, p[2] = (d[4] + d[5]) / 2, m) {
      let e12 = m.getDimensions().map((e13) => Math.floor(e13 / 2)), t2 = [
        e12[0],
        e12[1],
        e12[2]
      ];
      m.indexToWorld(t2, p);
    }
    let { widthWorld: v, heightWorld: y } = m ? getCubeSizeInView(m, g, _) : this._getWorldDistanceViewUpAndViewRight(d, _, g);
    if (m) {
      let e12 = m.getSpacing();
      v = Math.max(e12[0], v - e12[0]), y = Math.max(e12[1], y - e12[1]);
    }
    let b = window?.devicePixelRatio || 1, [S, C] = getDisplayCanvasSize(this), w = [S * b, C * b], T = v / y / (w[0] / w[1]), E = T < 1 ? this.insetImageMultiplier * y / 2 : this.insetImageMultiplier * y * T / 2, D = e4.boundsRadius(d) * (this.type === ViewportType_default.VOLUME_3D ? 10 : 1), O = this.insetImageMultiplier * D, k = Math.abs(vtkMath.dot(_, g)) > 0.999 ? [
      -_[2],
      _[0],
      _[1]
    ] : _, A = this._getFocalPointForResetCamera(p, u, {
      resetPan: n,
      resetToCenter: a
    }), j = [
      A[0] + O * g[0],
      A[1] + O * g[1],
      A[2] + O * g[2]
    ];
    c.resetCameraClippingRange(d);
    let M = [-rendering_default.MAXIMUM_RAY_DISTANCE, rendering_default.MAXIMUM_RAY_DISTANCE];
    h.setPhysicalScale(D), h.setPhysicalTranslation(-A[0], -A[1], -A[2]);
    let N = s ? this.options?.aspectRatio || [1, 1] : this.getAspectRatio();
    this.setCamera({
      parallelScale: r ? E : u.parallelScale,
      focalPoint: A,
      position: j,
      viewAngle: 90,
      viewUp: k,
      clippingRange: M,
      aspectRatio: N,
      isFitViewportAfterStretch: false
    });
    let P = this.getCamera();
    this.setFitToCanvasCamera(this.getCamera()), o && this.setInitialCamera(P), r && this.setZoom(1, o);
    let F = {
      type: "ResetCameraEvent",
      renderer: c
    };
    return c.invokeEvent(F), this.triggerCameraModifiedEventIfNecessary(u, P), m && this.options.displayArea && r && n && a && this.setDisplayArea(this.options.displayArea), true;
  }
  setInitialCamera(e12) {
    this.initialCamera = e12;
  }
  setFitToCanvasCamera(e12) {
    this.fitToCanvasCamera = e12;
  }
  getPan(e12 = this.initialCamera) {
    if (!e12)
      return [0, 0];
    let t = this.getVtkActiveCamera().getFocalPoint(), n = this.canvasToWorld([0, 0]);
    return subtract$1([0, 0], this.worldToCanvas(subtract$3([
      0,
      0,
      0
    ], e12.focalPoint, n)), this.worldToCanvas(subtract$3([
      0,
      0,
      0
    ], t, n)));
  }
  getCurrentImageIdIndex() {
    throw Error("Not implemented");
  }
  getSliceIndex() {
    throw Error("Not implemented");
  }
  getImageData() {
    throw Error("Not implemented");
  }
  getViewReferenceId(e12) {
    return null;
  }
  setPan(e12, t = false) {
    let n = this.getCamera(), { focalPoint: r, position: a } = n, o = this.canvasToWorld([0, 0]), s = subtract$1([0, 0], e12, this.getPan());
    if (Math.abs(s[0]) < 1 && Math.abs(s[1]) < 1 && !t)
      return;
    let c = subtract$3(create$4(), this.canvasToWorld(s), o), l = subtract$3(create$4(), r, c), u = subtract$3(create$4(), a, c);
    this.setCamera({
      ...n,
      focalPoint: l,
      position: u
    }, t);
  }
  getZoom(e12 = this.initialCamera) {
    if (!e12)
      return 1;
    let t = this.getVtkActiveCamera(), { parallelScale: n } = e12;
    return n / t.getParallelScale();
  }
  setZoom(e12, t = false) {
    let n = this.getCamera(), { parallelScale: r } = this.initialCamera, a = r / e12;
    n.parallelScale === a && !t || this.setCamera({
      ...n,
      parallelScale: a
    }, t);
  }
  getAspectRatio() {
    let { aspectRatio: e12 } = this.getCamera();
    return e12 ?? this.options?.aspectRatio ?? [1, 1];
  }
  setAspectRatio(e12, t = true, n = false) {
    let r = this.getCamera();
    n && (this.options.aspectRatio = e12), this.setCamera({
      ...r,
      aspectRatio: e12,
      isFitViewportAfterStretch: t
    }, n);
  }
  _getFocalPointForViewPlaneReset(e12) {
    let { focalPoint: t, viewPlaneNormal: n } = this.getCamera(), r = this._getViewImageDataIntersections(e12, t, n), a = 0, o = 0, s = 0;
    return r.forEach(([e13, t2, n2]) => {
      a += e13, o += t2, s += n2;
    }), [
      a / r.length,
      o / r.length,
      s / r.length
    ];
  }
  getCanvas() {
    return this.canvas;
  }
  getVtkActiveCamera() {
    let e12 = this.getRenderer();
    return e12 ? e12.getActiveCamera() : (console.warn("No renderer found for the viewport"), null);
  }
  getCameraNoRotation() {
    let e12 = this.getVtkActiveCamera(), t = (e13, t2) => e13.some((e14) => isNaN(e14)) ? t2 : e13;
    return {
      viewUp: t([...e12.getViewUp()], [
        0,
        1,
        0
      ]),
      viewPlaneNormal: t([...e12.getViewPlaneNormal()], [
        0,
        0,
        -1
      ]),
      position: t([...e12.getPosition()], [
        0,
        0,
        1
      ]),
      focalPoint: t([...e12.getFocalPoint()], [
        0,
        0,
        0
      ]),
      parallelProjection: e12.getParallelProjection(),
      parallelScale: e12.getParallelScale(),
      viewAngle: e12.getViewAngle(),
      flipHorizontal: this.flipHorizontal,
      flipVertical: this.flipVertical,
      aspectRatio: e12.getAspectRatio()
    };
  }
  getCamera() {
    return {
      ...this.getCameraNoRotation(),
      rotation: this.getRotation()
    };
  }
  setAspectRatioForVTKCamera(e12, t = true) {
    let n = this.getVtkActiveCamera();
    if (!t) {
      n.setAspectRatio(e12);
      return;
    }
    let r = n.getAspectRatio() || [1, 1];
    if (r[0] === e12[0] && r[1] === e12[1])
      return;
    let a = ([e13, t2]) => e13 / t2, o = a(r), s = a(e12);
    n.setAspectRatio(e12);
    let c = this.getDefaultImageData();
    if (!c)
      return;
    let l = (e13) => {
      let { widthWorld: t2, heightWorld: r2 } = getCubeSizeInView(c, n.getViewPlaneNormal(), n.getViewUp()), a2 = this.sWidth / this.sHeight, o2 = t2 * e13, s2 = o2 / r2 > a2 ? o2 / (2 * a2) : r2 / 2;
      return e13 < 1 && (s2 /= e13), s2;
    }, u = l(s) / l(o);
    n.setParallelScale(n.getParallelScale() * u), this.initialCamera?.parallelScale && (this.initialCamera = {
      ...this.initialCamera,
      parallelScale: this.initialCamera.parallelScale * u
    }), this.fitToCanvasCamera?.parallelScale && (this.fitToCanvasCamera = {
      ...this.fitToCanvasCamera,
      parallelScale: this.fitToCanvasCamera.parallelScale * u
    });
  }
  setCamera(e12, t = false) {
    let n = this.getVtkActiveCamera(), r = this.getCamera(), a = Object.assign({}, r, e12), { viewUp: o, viewPlaneNormal: s, position: c, focalPoint: u, parallelScale: d, viewAngle: f, flipHorizontal: p, flipVertical: m, clippingRange: h, aspectRatio: g, isFitViewportAfterStretch: _ } = e12;
    if (p !== void 0) {
      let e13 = p && !this.flipHorizontal || !p && this.flipHorizontal;
      e13 && this.flip({ flipHorizontal: e13 });
    }
    if (m !== void 0) {
      let e13 = m && !this.flipVertical || !m && this.flipVertical;
      e13 && this.flip({ flipVertical: e13 });
    }
    o !== void 0 && n.setViewUp(o), s !== void 0 && n.setDirectionOfProjection(-s[0], -s[1], -s[2]), c !== void 0 && n.setPosition(...c), u !== void 0 && n.setFocalPoint(...u), d !== void 0 && n.setParallelScale(d), f !== void 0 && n.setViewAngle(f), h !== void 0 && n.setClippingRange(h), g && this.setAspectRatioForVTKCamera(g, _);
    let v = r.focalPoint, y = r.viewUp;
    if (v && u || y && o) {
      let e13 = n.getViewPlaneNormal(), t2 = n.getViewUp(), r2 = false, s2 = false;
      if (u) {
        let t3 = [
          u[0] - v[0],
          u[1] - v[1],
          u[2] - v[2]
        ];
        r2 = Math.abs(vtkMath.dot(t3, e13)) > 0;
      }
      if (o && (s2 = !isEqual_default(t2, y)), r2 || s2) {
        let e14 = this.getDefaultActor();
        if (!e14?.actor)
          return;
        actorIsA(e14, "vtkActor") || this.updateClippingPlanesForActors(a), (actorIsA(e14, "vtkImageSlice") || this.type === ViewportType_default.VOLUME_3D) && this.getRenderer().resetCameraClippingRange();
      }
    }
    t && this.setInitialCamera(a), this.triggerCameraModifiedEventIfNecessary(r, this.getCamera());
  }
  triggerCameraModifiedEventIfNecessary(e12, t) {
    if (!this._suppressCameraModifiedEvents && !this.suppressEvents) {
      let n = {
        previousCamera: e12,
        camera: t,
        element: this.element,
        viewportId: this.id,
        renderingEngineId: this.renderingEngineId
      };
      triggerEvent(this.element, Events_default.CAMERA_MODIFIED, n);
    }
  }
  updateCameraClippingPlanesAndRange() {
    let e12 = this.getCamera();
    this.updateClippingPlanesForActors(e12), this.getRenderer().resetCameraClippingRange();
  }
  async updateClippingPlanesForActors(e12) {
    this.getActors().map((t) => {
      if (!t.actor)
        return;
      let n = t.actor.getMapper(), r = t?.clippingFilter ? t?.clippingFilter.getClippingPlanes() : n.getClippingPlanes();
      r.length === 0 && t?.clippingFilter && (r = [vtkPlane$1.newInstance(), vtkPlane$1.newInstance()]);
      let o = rendering_default.MINIMUM_SLAB_THICKNESS;
      t.slabThickness && (o = t.slabThickness);
      let { viewPlaneNormal: s, focalPoint: c } = e12;
      this.setOrientationOfClippingPlanes(r, o, s, c), triggerEvent(this.element, Events_default.CLIPPING_PLANES_UPDATED, {
        actorEntry: t,
        focalPoint: c,
        vtkPlanes: r,
        viewport: this
      });
    });
  }
  setOrientationOfClippingPlanes(e12, t, n, r) {
    if (e12.length < 2)
      return;
    let a = [
      n[0],
      n[1],
      n[2]
    ];
    vtkMath.multiplyScalar(a, t), e12[0].setNormal(n);
    let o = [
      0,
      0,
      0
    ];
    vtkMath.subtract(r, a, o), e12[0].setOrigin(o), e12[1].setNormal(-n[0], -n[1], -n[2]);
    let s = [
      0,
      0,
      0
    ];
    vtkMath.add(r, a, s), e12[1].setOrigin(s);
  }
  getClippingPlanesForActor(e12) {
    if (e12 ||= this.getDefaultActor(), !e12.actor)
      throw Error("Invalid actor entry: Actor is undefined");
    let t = e12.actor.getMapper(), n = e12?.clippingFilter ? e12?.clippingFilter.getClippingPlanes() : t.getClippingPlanes();
    return n.length === 0 && e12?.clippingFilter && (n = [vtkPlane$1.newInstance(), vtkPlane$1.newInstance()]), n;
  }
  _getWorldDistanceViewUpAndViewRight(e12, t, n) {
    let r = this._getCorners(e12), a = this._getCorners(e12), o = cross$1(create$4(), t, n), s = vtkMatrixBuilder.buildFromDegree().identity().rotateFromDirections(t, [
      1,
      0,
      0
    ]);
    r.forEach((e13) => s.apply(e13));
    let c = Infinity, l = -Infinity;
    for (let e13 = 0; e13 < 8; e13++) {
      let t2 = r[e13][0];
      t2 > l && (l = t2), t2 < c && (c = t2);
    }
    s = vtkMatrixBuilder.buildFromDegree().identity().rotateFromDirections([
      o[0],
      o[1],
      o[2]
    ], [
      1,
      0,
      0
    ]), a.forEach((e13) => s.apply(e13));
    let u = Infinity, d = -Infinity;
    for (let e13 = 0; e13 < 8; e13++) {
      let t2 = a[e13][0];
      t2 > d && (d = t2), t2 < u && (u = t2);
    }
    return {
      widthWorld: d - u,
      heightWorld: l - c
    };
  }
  getViewReference(e12) {
    let { focalPoint: t, viewPlaneNormal: n, viewUp: r } = this.getCamera(), a = this.getFrameOfReferenceUID(), o = {
      FrameOfReferenceUID: a,
      cameraFocalPoint: t,
      viewPlaneNormal: n,
      viewUp: r,
      sliceIndex: e12?.sliceIndex ?? this.getSliceIndex(),
      planeRestriction: {
        FrameOfReferenceUID: a,
        point: e12?.points?.[0] || t,
        inPlaneVector1: r,
        inPlaneVector2: cross$1(create$4(), r, n)
      }
    };
    return e12?.points && updatePlaneRestriction(e12.points, o.planeRestriction), o;
  }
  isPlaneViewable(e12, t) {
    if (e12.FrameOfReferenceUID !== this.getFrameOfReferenceUID())
      return false;
    let { focalPoint: n, viewPlaneNormal: r } = this.getCamera(), { point: a, inPlaneVector1: o, inPlaneVector2: s } = e12;
    return t?.withOrientation ? true : o && !isEqual_default(0, dot$3(r, o)) || s && !isEqual_default(0, dot$3(r, s)) ? false : t?.withNavigation ? true : isEqual_default(0, dot$3(sub$1(create$4(), a, n), r));
  }
  isReferenceViewable(e12, t) {
    if (e12.planeRestriction)
      return this.isPlaneViewable(e12.planeRestriction, t);
    if (e12.FrameOfReferenceUID && e12.FrameOfReferenceUID !== this.getFrameOfReferenceUID())
      return false;
    let { viewPlaneNormal: n } = e12, r = this.getCamera();
    return n && !isEqual_default(n, r.viewPlaneNormal) && !isEqual_default(negate(r.viewPlaneNormal, r.viewPlaneNormal), n) ? t?.withOrientation : true;
  }
  getViewPresentation(e12 = {
    rotation: true,
    displayArea: true,
    zoom: true,
    pan: true,
    aspectRatio: true,
    flipHorizontal: true,
    flipVertical: true
  }) {
    let t = {}, { rotation: n, displayArea: r, zoom: a, pan: o, flipHorizontal: s, flipVertical: c } = e12;
    n && (t.rotation = this.getRotation()), r && (t.displayArea = this.getDisplayArea());
    let l = this.getZoom();
    a && (t.zoom = l);
    let u = this.getAspectRatio();
    if (t.aspectRatio = u, o) {
      let e13 = this.getPan(), [n2, r2] = u;
      t.pan = [e13[0] / (l * n2), e13[1] / (l * r2)];
    }
    return s && (t.flipHorizontal = this.flipHorizontal), c && (t.flipVertical = this.flipVertical), t;
  }
  setViewReference(e12) {
  }
  setViewPresentation(e12) {
    if (!e12)
      return;
    let { displayArea: t, zoom: n = this.getZoom(), pan: r, aspectRatio: a = this.getAspectRatio(), rotation: o, flipHorizontal: s = this.flipHorizontal, flipVertical: c = this.flipVertical } = e12;
    if (t !== this.getDisplayArea() && this.setDisplayArea(t), this.setZoom(n), this.setAspectRatio(a), r) {
      let [e13, t2] = a;
      this.setPan([r[0] * n * e13, r[1] * n * t2]);
    }
    s !== void 0 && s !== this.flipHorizontal && this.flip({ flipHorizontal: s }), c !== void 0 && c !== this.flipVertical && this.flip({ flipVertical: c }), o >= 0 && this.setRotation(o);
  }
  _getCorners(e12) {
    return [
      [
        e12[0],
        e12[2],
        e12[4]
      ],
      [
        e12[0],
        e12[2],
        e12[5]
      ],
      [
        e12[0],
        e12[3],
        e12[4]
      ],
      [
        e12[0],
        e12[3],
        e12[5]
      ],
      [
        e12[1],
        e12[2],
        e12[4]
      ],
      [
        e12[1],
        e12[2],
        e12[5]
      ],
      [
        e12[1],
        e12[3],
        e12[4]
      ],
      [
        e12[1],
        e12[3],
        e12[5]
      ]
    ];
  }
  _getFocalPointForResetCamera(e12, t, { resetPan: n = true, resetToCenter: r = true }) {
    if (r && n)
      return e12;
    if (r && !n)
      return hasNaNValues(t.focalPoint) ? e12 : t.focalPoint;
    if (!r && n) {
      let n2 = t, r2 = n2.focalPoint, a = n2.viewPlaneNormal, o = dot$3(subtract$3(create$4(), e12, r2), a), s = scaleAndAdd(create$4(), e12, a, -1 * o);
      return [
        s[0],
        s[1],
        s[2]
      ];
    }
    if (!n && !r)
      return hasNaNValues(t.focalPoint) ? e12 : t.focalPoint;
  }
  _isInBounds(e12, t) {
    let [n, r, a, o, s, c] = t, [l, u, d] = e12;
    return !(l < n || l > r || u < a || u > o || d < s || d > c);
  }
  _getEdges(e12) {
    let [t, n, r, a, o, s, c, l] = this._getCorners(e12);
    return [
      [t, n],
      [t, o],
      [t, r],
      [n, a],
      [n, s],
      [r, a],
      [r, c],
      [a, l],
      [o, c],
      [o, s],
      [s, l],
      [c, l]
    ];
  }
  static boundsRadius(e12) {
    let t = (e12[1] - e12[0]) ** 2, n = (e12[3] - e12[2]) ** 2, r = (e12[5] - e12[4]) ** 2;
    return Math.sqrt(t + n + r || 1) * 0.5;
  }
  setDataIds(e12, t) {
    throw Error("Unsupported operatoin setDataIds");
  }
};
function getVolumeSliceRangeInfo(e12, t, n = false) {
  let r = e12.getCamera(), { focalPoint: a, viewPlaneNormal: o } = r, { spacingInNormalDirection: s, actorUID: c } = getTargetVolumeAndSpacingInNormalDir(e12, r, t, n);
  if (!c)
    throw Error(`Could not find image volume with id ${t} in the viewport`);
  let l = e12.getActor(c);
  if (!l)
    return console.warn("No actor found for with actorUID of", c), null;
  let u = l.actor;
  return {
    sliceRange: getSliceRange(u, o, a),
    spacingInNormalDirection: s,
    camera: r
  };
}
var getVolumeSliceRangeInfo_default = getVolumeSliceRangeInfo;
function getVolumeViewportScrollInfo(e12, t, n = false) {
  let { sliceRange: r, spacingInNormalDirection: a, camera: o } = getVolumeSliceRangeInfo_default(e12, t, n), { min: s, max: c, current: l } = r, u = Math.round((c - s) / a), d = (l - s) / (c - s) * u;
  return {
    numScrollSteps: u,
    currentStepIndex: Math.round(d),
    sliceRangeInfo: {
      sliceRange: r,
      spacingInNormalDirection: a,
      camera: o
    }
  };
}
var getVolumeViewportScrollInfo_default = getVolumeViewportScrollInfo;
function snapFocalPointToSlice(e12, t, n, r, a, o) {
  let { min: s, max: c, current: l } = n, u = create$4();
  sub$1(u, t, e12);
  let d = Math.round((c - s) / a), f = (l - s) / (c - s) * d, p = Math.round(f), m = [
    e12[0] - r[0] * f * a,
    e12[1] - r[1] * f * a,
    e12[2] - r[2] * f * a
  ];
  p += o, p > d ? p = d : p < 0 && (p = 0);
  let h = p * a;
  m = [
    m[0] + r[0] * h,
    m[1] + r[1] * h,
    m[2] + r[2] * h
  ];
  let g = [
    m[0] + u[0],
    m[1] + u[1],
    m[2] + u[2]
  ];
  return {
    newFocalPoint: m,
    newPosition: g
  };
}
function getVoiFromSigmoidRGBTransferFunction(e12) {
  let t = [], [n, r] = e12.getRange();
  e12.getTable(n, r, 1024, t), t = t.filter((e13, t2) => t2 % 3 == 0);
  let a = [...Array(1024).keys()].map((e13, t2) => n + (r - n) / 1023 * t2), o = t[256], s = Math.log((1 - o) / o), c = a[256], l = t[256 * 3], u = Math.log((1 - l) / l), d = a[256 * 3], f = Math.round(4 * (d - c) / (s - u)), p = Math.round(c + f * s / 4);
  return [Math.round(p - f / 2), Math.round(p + f / 2)];
}
function applyPreset(e12, t) {
  let n = t.colorTransfer.split(" ").splice(1).map(parseFloat), { shiftRange: r } = getShiftRange(n), a = r[0], o = r[1] - r[0], s = vtkColorTransferFunction$1.newInstance(), c = [];
  for (let e13 = 0; e13 < n.length; e13 += 4) {
    let t2 = n[e13], r2 = n[e13 + 1], s2 = n[e13 + 2], l2 = n[e13 + 3];
    t2 = (t2 - a) / o, c.push([
      t2,
      r2,
      s2,
      l2
    ]);
  }
  applyPointsToRGBFunction(c, r, s), e12.getProperty().setRGBTransferFunction(0, s);
  let l = t.scalarOpacity.split(" ").splice(1).map(parseFloat), u = vtkPiecewiseFunction$1.newInstance(), d = [];
  for (let e13 = 0; e13 < l.length; e13 += 2) {
    let t2 = l[e13], n2 = l[e13 + 1];
    t2 = (t2 - a) / o, d.push([t2, n2]);
  }
  applyPointsToPiecewiseFunction(d, r, u);
  let f = e12.getProperty();
  f.setScalarOpacity(0, u);
  let [p, m, h, g] = t.gradientOpacity.split(" ").splice(1).map(parseFloat);
  f.setUseGradientOpacity(0, true), f.setGradientOpacityMinimumValue(0, p), f.setGradientOpacityMinimumOpacity(0, m), f.setGradientOpacityMaximumValue(0, h), f.setGradientOpacityMaximumOpacity(0, g), t.interpolation === "1" && f.setInterpolationTypeToFastLinear(), f.setShade(t.shade === "1");
  let _ = parseFloat(t.ambient), v = parseFloat(t.diffuse), y = parseFloat(t.specular), b = parseFloat(t.specularPower);
  f.setAmbient(_), f.setDiffuse(v), f.setSpecular(y), f.setSpecularPower(b);
}
function getShiftRange(e12) {
  let t = Infinity, n = -Infinity;
  for (let r2 = 0; r2 < e12.length; r2 += 4)
    t = Math.min(t, e12[r2]), n = Math.max(n, e12[r2]);
  let r = (n - t) / 2;
  return {
    shiftRange: [-r, r],
    min: t,
    max: n
  };
}
function applyPointsToRGBFunction(e12, t, n) {
  let r = t[1] - t[0], a = e12.map(([e13, n2, a2, o]) => [
    e13 * r + t[0],
    n2,
    a2,
    o
  ]);
  return n.removeAllPoints(), a.forEach(([e13, t2, r2, a2]) => n.addRGBPoint(e13, t2, r2, a2)), a;
}
function applyPointsToPiecewiseFunction(e12, t, n) {
  let r = t[1] - t[0], a = e12.map(([e13, n2]) => [e13 * r + t[0], n2]);
  return n.removeAllPoints(), a.forEach(([e13, t2]) => n.addPoint(e13, t2)), a;
}
var { MPR_CAMERA_VALUES } = constants_exports, { OrientationAxis } = enums_exports;
function calculateCameraPosition(e12, t, n, r) {
  let a;
  switch (r) {
    case OrientationAxis.AXIAL:
    case OrientationAxis.AXIAL_REFORMAT:
      a = MPR_CAMERA_VALUES.axial;
      break;
    case OrientationAxis.SAGITTAL:
    case OrientationAxis.SAGITTAL_REFORMAT:
      a = MPR_CAMERA_VALUES.sagittal;
      break;
    case OrientationAxis.CORONAL:
    case OrientationAxis.CORONAL_REFORMAT:
      a = MPR_CAMERA_VALUES.coronal;
      break;
    case OrientationAxis.REFORMAT:
      switch (getOrientationFromScanAxisNormal(n)) {
        case OrientationAxis.AXIAL:
          a = MPR_CAMERA_VALUES.axial;
          break;
        case OrientationAxis.SAGITTAL:
          a = MPR_CAMERA_VALUES.sagittal;
          break;
        case OrientationAxis.CORONAL:
          a = MPR_CAMERA_VALUES.coronal;
          break;
        default:
          a = MPR_CAMERA_VALUES.axial;
      }
      break;
    default:
      a = MPR_CAMERA_VALUES.axial;
      break;
  }
  let o = [
    normalize$4(create$4(), e12),
    normalize$4(create$4(), t),
    normalize$4(create$4(), n)
  ], s = [
    fromValues$3(a.viewRight[0], a.viewRight[1], a.viewRight[2]),
    fromValues$3(a.viewUp[0], a.viewUp[1], a.viewUp[2]),
    fromValues$3(a.viewPlaneNormal[0], a.viewPlaneNormal[1], a.viewPlaneNormal[2])
  ], c = /* @__PURE__ */ new Set(), l = (e13) => {
    let t2 = 0, n2 = -2, r2 = false;
    o.forEach((a3, o2) => {
      if (c.has(o2))
        return;
      let s2 = dot$3(e13, a3), l2 = Math.abs(s2);
      l2 > n2 && (n2 = l2, t2 = o2, r2 = s2 < 0);
    }), c.add(t2);
    let a2 = clone$2(o[t2]);
    return r2 && negate(a2, a2), a2;
  }, u = l(s[0]), d = l(s[1]), f = l(s[2]);
  return {
    viewPlaneNormal: [
      f[0],
      f[1],
      f[2]
    ],
    viewUp: [
      d[0],
      d[1],
      d[2]
    ],
    viewRight: [
      u[0],
      u[1],
      u[2]
    ]
  };
}
function getCameraVectors(e12, t) {
  if (!e12.getActors()?.length)
    return;
  e12.type !== ViewportType_default.ORTHOGRAPHIC && console.warn("Viewport should be a volume viewport");
  let n = e12.getCurrentImageId();
  if (n ||= e12.getImageIds()?.[0], !n)
    return;
  let { imageOrientationPatient: r } = getMetaData("imagePlaneModule", n), a = fromValues$3(r[0], r[1], r[2]), o = fromValues$3(r[3], r[4], r[5]), s = cross$1(create$4(), a, o), { orientation: c } = t || {}, { useViewportNormal: u } = t || {}, d = s;
  return u && (d = e12.getCamera().viewPlaneNormal), (!c || c === OrientationAxis.REFORMAT) && (c = getOrientationFromScanAxisNormal(d)), calculateCameraPosition(a, o, s, c);
}
function getOrientationFromScanAxisNormal(e12) {
  let t = normalize$4(create$4(), e12), n = fromValues$3(MPR_CAMERA_VALUES.axial.viewPlaneNormal[0], MPR_CAMERA_VALUES.axial.viewPlaneNormal[1], MPR_CAMERA_VALUES.axial.viewPlaneNormal[2]), r = fromValues$3(MPR_CAMERA_VALUES.sagittal.viewPlaneNormal[0], MPR_CAMERA_VALUES.sagittal.viewPlaneNormal[1], MPR_CAMERA_VALUES.sagittal.viewPlaneNormal[2]), a = fromValues$3(MPR_CAMERA_VALUES.coronal.viewPlaneNormal[0], MPR_CAMERA_VALUES.coronal.viewPlaneNormal[1], MPR_CAMERA_VALUES.coronal.viewPlaneNormal[2]), o = Math.abs(dot$3(t, n)), s = Math.abs(dot$3(t, r)), c = Math.abs(dot$3(t, a));
  return o >= s && o >= c ? OrientationAxis.AXIAL : s >= c ? OrientationAxis.SAGITTAL : OrientationAxis.CORONAL;
}
function isContextPoolRenderingEngine() {
  return getConfiguration()?.rendering?.renderingEngineMode === RenderingEngineModeEnum_default.ContextPool;
}
const isInvalidNumber = (e12) => !(typeof e12 == "number" && Number.isFinite(e12));
var { vtkErrorMacro: vtkErrorMacro$5 } = macro;
function vtkConvolution2DPass(e12, t) {
  t.classHierarchy.push("vtkConvolution2DPass"), e12.computeKernelWeight = function(e13) {
    let t2 = e13.reduce((e14, t3) => e14 + t3);
    return t2 <= 0 ? 1 : t2;
  }, e12.traverse = function(n) {
    if (t.deleted)
      return;
    if (t.kernelDimension % 2 != 1) {
      vtkErrorMacro$5("Invalid kernel dimension! Kernel dimension must be odd (e.g. 3, 5, 7, ...).");
      return;
    }
    t.kernel === null && (t.kernel = new Float32Array(t.kernelDimension), t.kernel[Math.floor(t.kernelDimension / 2)] = 1);
    let r = t.kernelDimension * t.kernelDimension;
    if (t.kernel.length !== r) {
      vtkErrorMacro$5(`The given kernel is invalid. 2D convolution kernels have to be 1D arrays with ${r} components representing the ${t.kernelDimension}x${t.kernelDimension} kernel in row-major form.`);
      return;
    }
    t.framebuffer === null && (t.framebuffer = vtkOpenGLFramebuffer.newInstance());
    let a = n.getSize(), o = n.getContext();
    if (o === null) {
      t.delegates.forEach((t2) => {
        t2.traverse(n, e12);
      });
      return;
    }
    t.VBOBuildTime.getMTime() < e12.getMTime() && (t.tris.setOpenGLRenderWindow(n), e12.buildVertexBuffer()), t.framebuffer.setOpenGLRenderWindow(n), t.framebuffer.saveCurrentBindingsAndBuffers();
    let s = t.framebuffer.getSize();
    if ((s === null || s[0] !== a[0] || s[1] !== a[1]) && (t.framebuffer.create(a[0], a[1]), t.framebuffer.populateFramebuffer()), t.framebuffer.bind(), t.delegates.forEach((t2) => {
      t2.traverse(n, e12);
    }), t.framebuffer.restorePreviousBindingsAndBuffers(), t.convolutionShader !== null && t.oldKernelDimension !== t.kernelDimension && (t.convolutionShader = null, t.oldKernelDimension = t.kernelDimension), t.convolutionShader === null) {
      t.convolutionShader = n.getShaderCache().readyShaderProgramArray([
        "//VTK::System::Dec",
        "attribute vec4 vertexDC;",
        "attribute vec2 tcoordTC;",
        "varying vec2 tcoord;",
        "void main() { tcoord = tcoordTC; gl_Position = vertexDC; }"
      ].join("\n"), e12.getFragmentShaderCode(t.kernelDimension), "");
      let r2 = t.convolutionShader;
      t.copyVAO = vtkVertexArrayObject.newInstance(), t.copyVAO.setOpenGLRenderWindow(n), t.tris.getCABO().bind(), t.copyVAO.addAttributeArray(r2, t.tris.getCABO(), "vertexDC", t.tris.getCABO().getVertexOffset(), t.tris.getCABO().getStride(), o.FLOAT, 3, o.FALSE) || vtkErrorMacro$5("Error setting vertexDC in copy shader VAO."), t.copyVAO.addAttributeArray(r2, t.tris.getCABO(), "tcoordTC", t.tris.getCABO().getTCoordOffset(), t.tris.getCABO().getStride(), o.FLOAT, 2, o.FALSE) || vtkErrorMacro$5("Error setting vertexDC in copy shader VAO.");
    } else
      n.getShaderCache().readyShaderProgram(t.convolutionShader);
    o.viewport(0, 0, a[0], a[1]), o.scissor(0, 0, a[0], a[1]);
    let c = t.framebuffer.getColorTexture();
    c.activate(), t.convolutionShader.setUniformi("u_image", c.getTextureUnit()), t.convolutionShader.setUniform2f("u_textureSize", c.getWidth(), c.getHeight()), t.convolutionShader.setUniformfv("u_kernel", t.kernel), t.convolutionShader.setUniformf("u_kernelWeight", e12.computeKernelWeight(t.kernel)), o.drawArrays(o.TRIANGLES, 0, t.tris.getCABO().getElementCount()), c.deactivate();
  }, e12.getFragmentShaderCode = (e13) => {
    let t2 = e13 * e13, n = [
      "//VTK::System::Dec",
      "//VTK::Output::Dec",
      "uniform sampler2D u_image;",
      "uniform vec2 u_textureSize;",
      `uniform float u_kernel[${t2}];`,
      "uniform float u_kernelWeight;",
      "varying vec2 tcoord;",
      "void main(){",
      "    vec2 onePixel = vec2(1.0, 1.0) / u_textureSize;",
      "    vec4 colorSum =\n"
    ].join("\n"), r = Math.floor(e13 / 2), a = 0;
    for (let e14 = -r; e14 <= r; ++e14)
      for (let o = -r; o <= r; ++o)
        n += `        texture2D(u_image, tcoord + onePixel * vec2(${o}, ${e14})) * u_kernel[${a}]`, ++a, a !== t2 && (n += " +\n");
    return n += [
      ";",
      "    gl_FragData[0] = vec4((colorSum / u_kernelWeight).rgb, texture2D(u_image, tcoord).a);",
      "}"
    ].join("\n"), n;
  }, e12.buildVertexBuffer = () => {
    let e13 = new Float32Array([
      -1,
      -1,
      -1,
      1,
      -1,
      -1,
      -1,
      1,
      -1,
      1,
      1,
      -1
    ]), n = new Float32Array([
      0,
      0,
      1,
      0,
      0,
      1,
      1,
      1
    ]), r = new Uint16Array([
      4,
      0,
      1,
      3,
      2
    ]), a = vtkDataArray$1.newInstance({
      numberOfComponents: 3,
      values: e13
    });
    a.setName("points");
    let o = vtkDataArray$1.newInstance({
      numberOfComponents: 2,
      values: n
    });
    o.setName("tcoords");
    let s = vtkDataArray$1.newInstance({
      numberOfComponents: 1,
      values: r
    });
    t.tris.getCABO().createVBO(s, "polys", Representation$1.SURFACE, {
      points: a,
      tcoords: o,
      cellOffset: 0
    }), t.VBOBuildTime.modified();
  };
}
var DEFAULT_VALUES$23 = {
  framebuffer: null,
  convolutionShader: null,
  tris: null,
  kernel: [
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0
  ],
  oldKernelDimension: 3,
  kernelDimension: 3
};
function extend$29(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$23, n), vtkRenderPass$1.extend(e12, t, n), t.VBOBuildTime = {}, macro.obj(t.VBOBuildTime, { mtime: 0 }), t.tris = vtkHelper.newInstance(), macro.setGet(e12, t, ["kernel", "kernelDimension"]), macro.get(e12, t, ["framebuffer"]), vtkConvolution2DPass(e12, t);
}
var vtkConvolution2DPass$1 = {
  newInstance: macro.newInstance(extend$29, "vtkConvolution2DPass"),
  extend: extend$29
};
function createSharpeningRenderPass(e12) {
  let t = vtkForwardPass$1.newInstance();
  if (e12 > 0) {
    let n = vtkConvolution2DPass$1.newInstance();
    n.setDelegates([t]);
    let r = Math.max(0, e12);
    n.setKernelDimension(3), n.setKernel([
      -r,
      -r,
      -r,
      -r,
      1 + 8 * r,
      -r,
      -r,
      -r,
      -r
    ]), t = n;
  }
  return t;
}
function createSmoothingRenderPass(e12) {
  let t = vtkForwardPass$1.newInstance();
  if (e12 > 0) {
    let n = vtkConvolution2DPass$1.newInstance();
    n.setDelegates([t]);
    let r = Math.min(e12, 1e3), a = createGaussianKernel(15, 5), o = Array(225).fill(0);
    o[112] = 1;
    let s = Math.min(r / 10, 1), c = a.map((e13, t2) => (1 - s) * o[t2] + s * e13);
    n.setKernelDimension(15), n.setKernel(c), t = n;
  }
  return t;
}
function createGaussianKernel(e12, t) {
  let n = [], r = (e12 - 1) / 2, a = 0;
  for (let o = 0; o < e12; o++)
    for (let s = 0; s < e12; s++) {
      let e13 = s - r, c = o - r, l = Math.exp(-(e13 * e13 + c * c) / (2 * t ** 2));
      n.push(l), a += l;
    }
  return n.map((e13) => e13 / a);
}
var BaseVolumeViewport = class extends Viewport_default {
  constructor(e12) {
    if (super(e12), this.useCPURendering = false, this.sharpening = 0, this.smoothing = 0, this.perVolumeIdDefaultProperties = /* @__PURE__ */ new Map(), this.viewportProperties = {}, this.volumeIds = /* @__PURE__ */ new Set(), this.setRotation = (e13) => {
      let t2 = this.getPan(this.fitToCanvasCamera), n2 = this.getPan(), r = this.getCamera(), o = sub([0, 0], t2, n2);
      this.setPan(o, false);
      let { flipVertical: s } = this.getCamera(), c = s ? negate([
        0,
        0,
        0
      ], this.initialViewUp) : this.initialViewUp;
      this.setCameraNoEvent({ viewUp: c }), this.rotateCamera(e13);
      let l = add$1([0, 0], t2, sub([0, 0], this.getPan(), this.getPan(this.fitToCanvasCamera)));
      if (this.setPan(l, false), this._suppressCameraModifiedEvents)
        return;
      let u = {
        previousCamera: r,
        camera: this.getCamera(),
        element: this.element,
        viewportId: this.id,
        renderingEngineId: this.renderingEngineId
      };
      triggerEvent(this.element, Events_default.CAMERA_MODIFIED, u);
    }, this.setSharpening = (e13) => {
      this.sharpening = e13, this.render();
    }, this.setSmoothing = (e13) => {
      this.smoothing = e13, this.render();
    }, this.getRenderPasses = () => {
      if (!this.shouldUseCustomRenderPass())
        return null;
      let e13 = [];
      try {
        return this.smoothing > 0 && e13.push(createSmoothingRenderPass(this.smoothing)), this.sharpening > 0 && e13.push(createSharpeningRenderPass(this.sharpening)), e13.length ? e13 : null;
      } catch (e14) {
        return console.warn("Failed to create custom render passes:", e14), null;
      }
    }, this.getDefaultProperties = (e13) => {
      let t2;
      return e13 !== void 0 && (t2 = this.perVolumeIdDefaultProperties.get(e13)), t2 === void 0 ? { ...this.globalDefaultProperties } : t2;
    }, this.getProperties = (e13) => {
      if (!this._getApplicableVolumeActor(e13))
        return;
      let { colormap: t2, VOILUTFunction: n2, interpolationType: r, invert: a, slabThickness: o, preset: s } = this.viewportProperties;
      if (e13 ||= this.getVolumeId(), !cache_default.getVolume(e13))
        return null;
      let c = this.getActors().find((t3) => t3.referencedId === e13);
      if (!c)
        return;
      let l = c.actor.getProperty().getRGBTransferFunction(0), [u, d] = this.viewportProperties?.VOILUTFunction === "SIGMOID" ? getVoiFromSigmoidRGBTransferFunction(l) : l.getRange(), f = {
        lower: u,
        upper: d
      }, p = this.getColormap(e13);
      return {
        colormap: e13 && p ? p : t2,
        voiRange: f,
        VOILUTFunction: n2,
        interpolationType: r,
        invert: a,
        slabThickness: o,
        preset: s,
        sharpening: this.sharpening,
        smoothing: this.smoothing
      };
    }, this.getColormap = (e13) => {
      let t2 = this._getApplicableVolumeActor(e13);
      if (!t2)
        return;
      let { volumeActor: n2 } = t2, { nodes: r } = this._getOrCreateColorTransferFunction(e13).getState(), a = findMatchingColormap(r.reduce((e14, t3) => (e14.push(t3.x, t3.r, t3.g, t3.b), e14), []), n2) || {}, o = getThresholdValue(n2), s = getMaxOpacity(n2);
      return a.threshold = o, a.opacity = s, a;
    }, this.getRotation = () => {
      let { viewUp: e13, viewPlaneNormal: t2, flipVertical: n2 } = this.getCameraNoRotation(), r = n2 ? negate([
        0,
        0,
        0
      ], this.initialViewUp) : this.initialViewUp;
      if (!r)
        return 0;
      let a = angle(r, e13) * 180 / Math.PI;
      return dot$3(cross$1([
        0,
        0,
        0
      ], r, e13), t2) >= 0 ? a : (360 - a) % 360;
    }, this.getFrameOfReferenceUID = () => this._FrameOfReferenceUID, this.canvasToWorldTiled = (e13) => {
      let t2 = this.getVtkActiveCamera();
      t2.setIsPerformingCoordinateTransformation?.(true);
      let n2 = this.getRenderer(), r = this.getVtkDisplayCoordsTiled(e13), a = this.getRenderingEngine().offscreenMultiRenderWindow.getOpenGLRenderWindow().displayToWorld(r[0], r[1], r[2], n2);
      return t2.setIsPerformingCoordinateTransformation?.(false), [
        a[0],
        a[1],
        a[2]
      ];
    }, this.canvasToWorldContextPool = (e13) => {
      let t2 = this.getVtkActiveCamera();
      t2.setIsPerformingCoordinateTransformation?.(true);
      let n2 = this.getRenderer(), r = window.devicePixelRatio || 1, { width: a, height: o } = this.canvas, s = a / o, [c, l, u, d] = n2.getViewport(), f = u - c, p = d - l, m = [e13[0] * r, e13[1] * r], h = [
        c + m[0] / a * f,
        l + (1 - m[1] / o) * p,
        0
      ], g = n2.normalizedDisplayToProjection(h[0], h[1], h[2]), _ = n2.projectionToView(g[0], g[1], g[2], s), v = n2.viewToWorld(_[0], _[1], _[2]);
      return t2.setIsPerformingCoordinateTransformation?.(false), [
        v[0],
        v[1],
        v[2]
      ];
    }, this.getVtkDisplayCoordsTiled = (e13) => {
      let t2 = window.devicePixelRatio || 1, n2 = [e13[0] * t2, e13[1] * t2], r = this.getRenderingEngine().offscreenMultiRenderWindow.getOpenGLRenderWindow().getSize(), a = [n2[0] + this.sx, n2[1] + this.sy];
      return a[1] = r[1] - a[1], [
        a[0],
        a[1],
        0
      ];
    }, this.getVtkDisplayCoordsContextPool = (e13) => {
      let t2 = window.devicePixelRatio || 1, n2 = [e13[0] * t2, e13[1] * t2], r = this.getRenderer(), { width: a, height: o } = this.canvas, [s, c, l, u] = r.getViewport(), d = l - s, f = u - c, p = n2[0] / a * d * a, m = n2[1] / o * f * o, h = [p, f * o - m];
      return [
        h[0],
        h[1],
        0
      ];
    }, this.worldToCanvasTiled = (e13) => {
      let t2 = this.getVtkActiveCamera();
      t2.setIsPerformingCoordinateTransformation?.(true);
      let n2 = this.getRenderer(), r = this.getRenderingEngine().offscreenMultiRenderWindow.getOpenGLRenderWindow(), a = r.getSize(), o = r.worldToDisplay(...e13, n2);
      o[1] = a[1] - o[1];
      let s = [o[0] - this.sx, o[1] - this.sy], c = window.devicePixelRatio || 1, l = [s[0] / c, s[1] / c];
      return t2.setIsPerformingCoordinateTransformation(false), l;
    }, this.worldToCanvasContextPool = (e13) => {
      let t2 = this.getVtkActiveCamera();
      t2.setIsPerformingCoordinateTransformation?.(true);
      let n2 = this.getRenderer(), { width: r, height: a } = this.canvas, o = r / a, [s, c, l, u] = n2.getViewport(), d = l - s, f = u - c, p = n2.worldToView(e13[0], e13[1], e13[2]), m = n2.viewToProjection(p[0], p[1], p[2], o), h = n2.projectionToNormalizedDisplay(m[0], m[1], m[2]), g = (h[0] - s) / d, _ = (h[1] - c) / f, v = g * r, y = (1 - _) * a, b = window.devicePixelRatio || 1, S = [v / b, y / b];
      return t2.setIsPerformingCoordinateTransformation(false), S;
    }, this.hasImageURI = (e13) => this.getActors().filter((e14) => actorIsA(e14, "vtkVolume")).some(({ uid: t2, referencedId: n2 }) => {
      let r = cache_default.getVolume(n2 || t2);
      return r?.getImageIdIndex ? r.getImageIdIndex(e13) !== void 0 || r.getImageURIIndex(e13) !== void 0 : false;
    }), this.getImageIds = (e13) => {
      let t2 = this._getApplicableVolumeActor(e13);
      if (!t2)
        throw Error(`No actor found for the given volumeId: ${e13}`);
      let n2 = t2.volumeId, r = cache_default.getVolume(n2);
      if (!r)
        throw Error(`imageVolume with id: ${n2} does not exist in cache`);
      return r.imageIds;
    }, this.renderingPipelineFunctions = {
      worldToCanvas: {
        tiled: this.worldToCanvasTiled,
        contextPool: this.worldToCanvasContextPool
      },
      canvasToWorld: {
        tiled: this.canvasToWorldTiled,
        contextPool: this.canvasToWorldContextPool
      },
      getVtkDisplayCoords: {
        tiled: this.getVtkDisplayCoordsTiled,
        contextPool: this.getVtkDisplayCoordsContextPool
      },
      getRenderer: {
        tiled: this.getRendererTiled,
        contextPool: this.getRendererContextPool
      }
    }, this.useCPURendering = getShouldUseCPURendering(), this.useCPURendering)
      throw Error("VolumeViewports cannot be used whilst CPU Fallback Rendering is enabled.");
    this._configureRenderingPipeline();
    let t = this.getRenderer(), n = vtkSlabCamera_default.newInstance();
    switch (t.setActiveCamera(n), this.type) {
      case ViewportType_default.ORTHOGRAPHIC:
        n.setParallelProjection(true);
        break;
      case ViewportType_default.VOLUME_3D:
        n.setParallelProjection(true);
        break;
      case ViewportType_default.PERSPECTIVE:
        n.setParallelProjection(false);
        break;
      default:
        throw Error(`Unrecognized viewport type: ${this.type}`);
    }
    this.initializeVolumeNewImageEventDispatcher();
  }
  static get useCustomRenderingPipeline() {
    return false;
  }
  isOrientationChangeable() {
    return true;
  }
  getSliceViewInfo() {
    throw Error("Method not implemented.");
  }
  applyViewOrientation(e12, t = true, n = false) {
    let { viewPlaneNormal: r, viewUp: a } = this._getOrientationVectors(e12) || {};
    if (!r || !a)
      return;
    let o = this.getVtkActiveCamera();
    o.setDirectionOfProjection(-r[0], -r[1], -r[2]), o.setViewUpFrom(a), this.initialViewUp = a, t && this.resetCamera({
      resetOrientation: false,
      resetRotation: false,
      suppressEvents: n
    });
  }
  initializeVolumeNewImageEventDispatcher() {
    let e12 = n.bind(this), t = r.bind(this);
    function n(e13) {
      let t2 = e13, { viewportId: n2 } = t2.detail;
      n2 !== this.id || this.isDisabled || this.getImageData() && volumeNewImageEventDispatcher_default(t2);
    }
    function r(n2) {
      let { viewportId: r2 } = n2.detail;
      r2 === this.id && (this.element.removeEventListener(Events_default.CAMERA_MODIFIED, e12), eventTarget_default.removeEventListener(Events_default.ELEMENT_DISABLED, t), resetVolumeNewImageState(r2));
    }
    this.element.removeEventListener(Events_default.CAMERA_MODIFIED, e12), this.element.addEventListener(Events_default.CAMERA_MODIFIED, e12), eventTarget_default.addEventListener(Events_default.ELEMENT_DISABLED, t);
  }
  setVOILUTFunction(e12, t, n) {
    Object.values(VOILUTFunctionType_default).includes(e12) || (e12 = VOILUTFunctionType_default.LINEAR);
    let { voiRange: r } = this.getProperties();
    this.setVOI(r, t, n), this.viewportProperties.VOILUTFunction = e12;
  }
  setColormap(e12, t, n) {
    let r = this._getApplicableVolumeActor(t);
    if (!r)
      return;
    let { volumeActor: o } = r, s = vtkColorTransferFunction$1.newInstance(), c = getColormap$1(e12.name), { name: l } = e12;
    if (c ||= vtkColorMaps.getPresetByName(l), !c)
      throw Error(`Colormap ${e12} not found`);
    let u = o.getProperty().getRGBTransferFunction(0).getRange();
    if (s.applyColorMap(c), s.setMappingRange(u[0], u[1]), o.getProperty().setRGBTransferFunction(0, s), this.viewportProperties.colormap = e12, !n) {
      let e13 = this.getColormap(t), n2 = {
        viewportId: this.id,
        colormap: e13,
        volumeId: t
      };
      triggerEvent(this.element, Events_default.VOI_MODIFIED, n2), triggerEvent(this.element, Events_default.COLORMAP_MODIFIED, n2);
    }
  }
  setOpacity(e12, t) {
    let n = this._getApplicableVolumeActor(t);
    if (!n)
      return;
    let { volumeActor: r } = n, o = vtkPiecewiseFunction$1.newInstance();
    typeof e12.opacity == "number" ? updateOpacity(r, e12.opacity) : (e12.opacity.forEach(({ opacity: e13, value: t2 }) => {
      o.addPoint(t2, e13);
    }), r.getProperty().setScalarOpacity(0, o)), this.viewportProperties.colormap || (this.viewportProperties.colormap = {}), this.viewportProperties.colormap.opacity = e12.opacity;
    let s = this.getColormap(t), c = {
      viewportId: this.id,
      colormap: s,
      volumeId: t
    };
    triggerEvent(this.element, Events_default.COLORMAP_MODIFIED, c);
  }
  setInvert(e12, t, n) {
    let r = this._getApplicableVolumeActor(t);
    if (!r)
      return;
    let o = r.volumeId;
    if (invertRgbTransferFunction(this._getOrCreateColorTransferFunction(o)), this.viewportProperties.invert = e12, !n) {
      let e13 = {
        ...this.getVOIModifiedEventDetail(o),
        invertStateChanged: true
      };
      triggerEvent(this.element, Events_default.VOI_MODIFIED, e13);
    }
  }
  getVOIModifiedEventDetail(e12) {
    let t = this._getApplicableVolumeActor(e12);
    if (!t)
      throw Error(`No actor found for the given volumeId: ${e12}`);
    let n = t.volumeActor.getProperty().getRGBTransferFunction(0).getMappingRange(), r = this.getColormap(e12), { VOILUTFunction: a, invert: o } = this.getProperties(e12);
    return {
      viewportId: this.id,
      range: {
        lower: n[0],
        upper: n[1]
      },
      volumeId: t.volumeId,
      VOILUTFunction: a,
      colormap: r,
      invert: o
    };
  }
  _getOrCreateColorTransferFunction(e12) {
    let t = this._getApplicableVolumeActor(e12);
    if (!t)
      return null;
    let { volumeActor: n } = t, r = n.getProperty().getRGBTransferFunction(0);
    if (r)
      return r;
    let a = vtkColorTransferFunction$1.newInstance();
    return n.getProperty().setRGBTransferFunction(0, a), a;
  }
  setInterpolationType(e12, t) {
    let n = this._getApplicableVolumeActor(t);
    if (!n)
      return;
    let { volumeActor: r } = n;
    r.getProperty().setInterpolationType(e12), this.viewportProperties.interpolationType = e12;
  }
  setVOI(e12, t, n = false) {
    let r = this._getApplicableVolumeActor(t);
    if (!r)
      return;
    let { volumeActor: o } = r, s = r.volumeId, c = e12;
    if (c === void 0)
      throw Error("voiRangeToUse is undefined, need to implement this in the new volume model");
    if ([c.lower, c.upper].some(isInvalidNumber)) {
      console.warn("VOI range contains invalid values, ignoring setVOI request", c);
      return;
    }
    let { VOILUTFunction: l } = this.getProperties(s);
    if (l === VOILUTFunctionType_default.SAMPLED_SIGMOID) {
      let e13 = createSigmoidRGBTransferFunction(c);
      o.getProperty().setRGBTransferFunction(0, e13);
    } else {
      let { lower: e13, upper: t2 } = c;
      o.getProperty().getRGBTransferFunction(0).setRange(e13, t2);
    }
    if (!n) {
      let e13 = { ...this.getVOIModifiedEventDetail(s) };
      triggerEvent(this.element, Events_default.VOI_MODIFIED, e13);
    }
    this.viewportProperties.voiRange = c;
  }
  rotateCamera(e12) {
    let t = e12 - this.getRotation();
    this.getVtkActiveCamera().roll(-t);
  }
  setDefaultProperties(e12, t) {
    t == null ? this.globalDefaultProperties = e12 : this.perVolumeIdDefaultProperties.set(t, e12);
  }
  clearDefaultProperties(e12) {
    e12 == null ? (this.globalDefaultProperties = {}, this.resetProperties()) : (this.perVolumeIdDefaultProperties.delete(e12), this.resetToDefaultProperties(e12));
  }
  getViewReference(e12 = {}) {
    let t = super.getViewReference(e12), n = this.getVolumeId(e12);
    if (e12?.forFrameOfReference !== false && (t.volumeId = n), typeof e12?.sliceIndex != "number")
      return t;
    let { viewPlaneNormal: r } = t, a = e12?.sliceIndex - this.getSliceIndex(), { sliceRangeInfo: o } = getVolumeViewportScrollInfo_default(this, n, true), { sliceRange: s, spacingInNormalDirection: c, camera: l } = o, { focalPoint: u, position: d } = l, { newFocalPoint: f } = snapFocalPointToSlice(u, d, s, r, c, a);
    return t.cameraFocalPoint = f, t;
  }
  isReferenceViewable(e12, t) {
    if (!e12.FrameOfReferenceUID || !super.isReferenceViewable(e12, t))
      return false;
    if (t?.withNavigation) {
      let { referencedImageId: t2 } = e12;
      return !t2 || this.hasImageURI(t2);
    }
    let n = this.getSliceIndex(), { sliceIndex: r } = e12;
    return Array.isArray(r) ? r[0] <= n && n <= r[1] : r === void 0 || r === n;
  }
  scroll(e12 = 1) {
    let t = this.getVolumeId(), { sliceRangeInfo: n } = getVolumeViewportScrollInfo_default(this, t, true);
    if (!n)
      return;
    let { sliceRange: r, spacingInNormalDirection: a, camera: o } = n, { focalPoint: s, viewPlaneNormal: c, position: l } = o, { newFocalPoint: u, newPosition: d } = snapFocalPointToSlice(s, l, r, c, a, e12);
    this.setCamera({
      focalPoint: u,
      position: d
    }), this.render();
  }
  setBestOrentation(e12, t) {
    if (!e12 && !t)
      return;
    let { viewPlaneNormal: n } = this.getCamera();
    if (isCompatible(n, t) && isCompatible(n, e12))
      return;
    let r = this._getAcquisitionPlaneOrientation();
    if (isCompatible(r.viewPlaneNormal, t) && isCompatible(r.viewPlaneNormal, e12)) {
      this.setOrientation(r);
      return;
    }
    for (let n2 of Object.values(mprCameraValues_default))
      if (isCompatible(n2.viewPlaneNormal, t) && isCompatible(n2.viewPlaneNormal, e12)) {
        this.setOrientation(n2);
        return;
      }
    let a = cross$1(create$4(), t || r.viewPlaneNormal, e12);
    normalize$4(a, a), this.setOrientation({ viewPlaneNormal: a });
  }
  setViewPlane(e12) {
    let { point: t, inPlaneVector1: n, inPlaneVector2: r, FrameOfReferenceUID: a } = e12;
    this.setBestOrentation(n, r);
    let { focalPoint: o, viewPlaneNormal: s } = this.getCamera(), c = dot$3(subtract$3(create$4(), t, o), s), l = scaleAndAdd(create$4(), o, s, c);
    this.setViewReference({
      FrameOfReferenceUID: a,
      cameraFocalPoint: l,
      viewPlaneNormal: s
    });
  }
  setViewReference(e12) {
    if (!e12)
      return;
    let t = this.getVolumeId(), { FrameOfReferenceUID: n, cameraFocalPoint: r, referencedImageId: a, planeRestriction: o, viewPlaneNormal: s, viewUp: c } = e12, { sliceIndex: l } = e12;
    if (o && !s)
      return this.setViewPlane(o);
    let { focalPoint: u, viewPlaneNormal: d, position: f } = this.getCamera(), p = isEqualNegative(d, s), m = isEqual_default(d, s);
    if (typeof l == "number" && t !== void 0 && e12.volumeId === t && (p || m)) {
      let { currentStepIndex: e13, sliceRangeInfo: n2, numScrollSteps: r2 } = getVolumeViewportScrollInfo_default(this, t, true), { sliceRange: a2, spacingInNormalDirection: o2 } = n2;
      p && (l = r2 - l - 1);
      let { newFocalPoint: s2, newPosition: c2 } = snapFocalPointToSlice(u, f, a2, d, o2, l - e13);
      this.setCamera({
        focalPoint: s2,
        position: c2
      });
    } else if (n === this.getFrameOfReferenceUID()) {
      if (s && !p && !m) {
        this.setOrientation({
          viewPlaneNormal: s,
          viewUp: c
        }, true, true), this.setViewReference(e12);
        return;
      }
      if (a && this.isInAcquisitionPlane()) {
        let { imagePositionPatient: e13 } = getMetaData(MetadataModules_default.IMAGE_PLANE, a), { focalPoint: t2 } = this.getCamera(), n2 = dot$3(subtract$3(create$4(), t2, e13), d), r2 = scaleAndAdd(create$4(), t2, [
          -d[0],
          -d[1],
          -d[2]
        ], n2), o2 = subtract$3(create$4(), r2, t2), s2 = add$4(create$4(), f, o2);
        this.setCamera({
          focalPoint: r2,
          position: s2
        }), this.render();
        return;
      }
      if (r) {
        let e13 = subtract$3([
          0,
          0,
          0
        ], r, u), t2 = s ?? d, n2 = dot$3(e13, t2);
        isEqual_default(n2, 0) || scale$3(e13, t2, n2);
        let a2 = add$4([
          0,
          0,
          0
        ], u, e13), o2 = add$4([
          0,
          0,
          0
        ], f, e13);
        this.setCamera({
          focalPoint: a2,
          position: o2
        });
      }
    } else
      throw Error(`Incompatible view refs: ${n}!==${this.getFrameOfReferenceUID()}`);
  }
  setThreshold(e12, t) {
    let n = this._getApplicableVolumeActor(t);
    if (!n)
      return;
    let { volumeActor: r } = n;
    updateThreshold(r, e12.threshold), this.viewportProperties.colormap || (this.viewportProperties.colormap = {}), this.viewportProperties.colormap.threshold = e12.threshold;
    let o = this.getColormap(t), s = {
      viewportId: this.id,
      colormap: o,
      volumeId: t
    };
    triggerEvent(this.element, Events_default.COLORMAP_MODIFIED, s);
  }
  setProperties({ voiRange: e12, VOILUTFunction: t, invert: n, colormap: r, preset: a, interpolationType: o, slabThickness: s, sampleDistanceMultiplier: c, sharpening: l, smoothing: u } = {}, d, f = false) {
    this.globalDefaultProperties ?? this.setDefaultProperties({
      voiRange: e12,
      VOILUTFunction: t,
      invert: n,
      colormap: r,
      preset: a,
      slabThickness: s,
      sampleDistanceMultiplier: c
    }), n !== void 0 && this.viewportProperties.invert !== n && this.setInvert(n, d, f), r?.name && this.setColormap(r, d, f), r?.opacity != null && this.setOpacity(r, d), r?.threshold != null && this.setThreshold(r, d), e12 !== void 0 && this.setVOI(e12, d, f), o !== void 0 && this.setInterpolationType(o), t !== void 0 && this.setVOILUTFunction(t, d, f), a !== void 0 && this.setPreset(a, d, f), s !== void 0 && this.setSlabThickness(s), c !== void 0 && this.setSampleDistanceMultiplier(c), l !== void 0 && this.setSharpening(l), u !== void 0 && this.setSmoothing(u);
  }
  shouldUseCustomRenderPass() {
    return !this.useCPURendering;
  }
  _restoreVolumeRenderingDefaults(e12, t) {
    if (!isImageActor(e12))
      return;
    let n = this.getDefaultProperties(t);
    n?.preset || n?.colormap ? this.setProperties(n, t, true) : setTransferFunctionNodes(e12.actor.getProperty().getRGBTransferFunction(0), this.initialTransferFunctionNodes);
  }
  resetToDefaultProperties(e12) {
    let t = this.globalDefaultProperties;
    t.colormap?.name && this.setColormap(t.colormap, e12), t.colormap?.opacity != null && this.setOpacity(t.colormap, e12), t.voiRange !== void 0 && this.setVOI(t.voiRange, e12), t.VOILUTFunction !== void 0 && this.setVOILUTFunction(t.VOILUTFunction, e12), t.invert !== void 0 && this.setInvert(t.invert, e12), t.slabThickness !== void 0 && (this.setSlabThickness(t.slabThickness), this.viewportProperties.slabThickness = t.slabThickness), t.sampleDistanceMultiplier !== void 0 && this.setSampleDistanceMultiplier(t.sampleDistanceMultiplier), t.preset !== void 0 && this.setPreset(t.preset, e12, false), this.render();
  }
  setPreset(e12, t, n) {
    let r = this._getApplicableVolumeActor(t);
    if (!r)
      return;
    let { volumeActor: o } = r, s = typeof e12 == "string" ? viewportPresets_default.find((t2) => t2.name === e12) : e12;
    s && (applyPreset(o, s), this.viewportProperties.preset = s.name, this.render(), n || triggerEvent(this.element, Events_default.PRESET_MODIFIED, {
      viewportId: this.id,
      volumeId: r.volumeId,
      actor: o,
      presetName: s.name
    }));
  }
  setSampleDistanceMultiplier(e12) {
  }
  async setVolumes(e12, t = false, n = false) {
    let r = e12[0].volumeId, o = cache_default.getVolume(r);
    if (!o)
      throw Error(`imageVolume with id: ${r} does not exist, you need to create/allocate the volume first`);
    let s = o.metadata.FrameOfReferenceUID;
    this._isValidVolumeInputArray(e12, s), this._FrameOfReferenceUID = s, e12.forEach((e13) => {
      this._addVolumeId(e13.volumeId);
    });
    let c = [];
    for (let t2 = 0; t2 < e12.length; t2++) {
      let { volumeId: r2, actorUID: a, slabThickness: o2, ...s2 } = e12[t2], l = await createVolumeActor_default(e12[t2], this.element, this.id, n), u = a || uuidv4();
      c.push({
        uid: u,
        actor: l,
        slabThickness: o2,
        referencedId: r2,
        ...s2
      });
    }
    this._setVolumeActors(c), this.viewportStatus = ViewportStatus_default.PRE_RENDER, this.initializeColorTransferFunction(e12), triggerEvent(this.element, Events_default.VOLUME_VIEWPORT_NEW_VOLUME, {
      viewportId: this.id,
      volumeActors: c
    }), t && this.render();
  }
  async addVolumes(e12, t = false, n = false) {
    let r = cache_default.getVolume(e12[0].volumeId);
    if (!r)
      throw Error(`imageVolume with id: ${r.volumeId} does not exist`);
    let a = [];
    this._isValidVolumeInputArray(e12, this._FrameOfReferenceUID), e12.forEach((e13) => {
      this._addVolumeId(e13.volumeId);
    });
    for (let t2 = 0; t2 < e12.length; t2++) {
      let { volumeId: r2, visibility: o, actorUID: s, slabThickness: c, ...l } = e12[t2], u = await createVolumeActor_default(e12[t2], this.element, this.id, n);
      o || u.setVisibility(false);
      let d = s || uuidv4();
      a.push({
        uid: d,
        actor: u,
        slabThickness: c,
        referencedId: r2,
        ...l
      });
    }
    this.addActors(a), this.initializeColorTransferFunction(e12), t && this.render();
  }
  removeVolumeActors(e12, t = false) {
    this.removeActors(e12), t && this.render();
  }
  setOrientation(e12, t = true, n = false) {
    console.warn('Method "setOrientation" needs implementation');
  }
  initializeColorTransferFunction(e12) {
    let t = e12[0].volumeId, n = this._getOrCreateColorTransferFunction(t);
    !this.initialTransferFunctionNodes && n && (this.initialTransferFunctionNodes = getTransferFunctionNodes(n));
  }
  _getApplicableVolumeActor(e12) {
    let t = this.getActors();
    if (!t?.length)
      return;
    if (e12) {
      let n2 = t.find((t2) => t2.referencedId === e12);
      return n2 ? {
        volumeActor: n2.actor,
        volumeId: e12,
        actorUID: n2.uid
      } : void 0;
    }
    let n = t[0];
    return {
      volumeActor: n.actor,
      volumeId: n.referencedId,
      actorUID: n.uid
    };
  }
  async _isValidVolumeInputArray(e12, t) {
    let n = e12.length;
    for (let r = 1; r < n; r++)
      if (t !== cache_default.getVolume(e12[r].volumeId).metadata.FrameOfReferenceUID)
        throw Error(`Volumes being added to viewport ${this.id} do not share the same FrameOfReferenceUID. This is not yet supported`);
    return true;
  }
  getBounds() {
    return this.getRenderer().computeVisiblePropBounds();
  }
  flip(e12) {
    super.flip(e12);
  }
  hasVolumeId(e12) {
    return this.volumeIds.has(e12);
  }
  hasVolumeURI(e12) {
    for (let t of this.volumeIds)
      if (t.includes(e12))
        return true;
    return false;
  }
  getImageData(e12) {
    if (!this.getDefaultActor())
      return;
    e12 ||= this.getVolumeId();
    let t = this.getActors()?.find((t2) => t2.referencedId === e12);
    if (!t || !actorIsA(t, "vtkVolume"))
      return;
    let n = t.actor, r = cache_default.getVolume(e12), a = n.getMapper().getInputData();
    return {
      dimensions: a.getDimensions(),
      spacing: a.getSpacing(),
      origin: a.getOrigin(),
      direction: a.getDirection(),
      imageData: n.getMapper().getInputData(),
      metadata: {
        Modality: r?.metadata?.Modality,
        FrameOfReferenceUID: r?.metadata?.FrameOfReferenceUID
      },
      get scalarData() {
        return r?.voxelManager?.getScalarData();
      },
      scaling: r?.scaling,
      hasPixelSpacing: true,
      voxelManager: r?.voxelManager
    };
  }
  setCameraClippingRange() {
    throw Error("Method not implemented.");
  }
  getSliceIndex() {
    throw Error("Method not implemented.");
  }
  setCamera(e12, t) {
    super.setCamera(e12, t), this.setCameraClippingRange();
  }
  _setVolumeActors(e12) {
    for (let t = 0; t < e12.length; t++)
      this.viewportProperties.invert = false;
    this.setActors(e12);
  }
  getRendererContextPool() {
    return this.getRenderingEngine().getRenderer(this.id);
  }
  getRendererTiled() {
    let e12 = this.getRenderingEngine();
    if (!e12 || e12.hasBeenDestroyed)
      throw Error("Rendering engine has been destroyed");
    return e12.offscreenMultiRenderWindow?.getRenderer(this.id);
  }
  _getViewUp(e12) {
    let { viewUp: t } = this.getCamera(), n = dot$3(t, e12);
    if (isEqual_default(n, 0))
      return t;
    if (isEqualAbs(e12[0], 1) || isEqualAbs(e12[1], 1))
      return [
        0,
        0,
        1
      ];
    if (isEqualAbs(e12[2], 1))
      return [
        0,
        -1,
        0
      ];
    let r = scaleAndAdd(create$4(), t, e12, -n);
    return normalize$4(r, r), r;
  }
  _getOrientationVectors(e12) {
    if (typeof e12 == "object") {
      if (e12.viewPlaneNormal)
        return {
          ...e12,
          viewUp: e12.viewUp || this._getViewUp(e12.viewPlaneNormal)
        };
      throw Error("Invalid orientation object. It must contain viewPlaneNormal");
    } else if (typeof e12 == "string") {
      if (e12 === OrientationAxis_default.ACQUISITION)
        return this._getAcquisitionPlaneOrientation();
      if (e12 === OrientationAxis_default.REFORMAT)
        return getCameraVectors(this, { useViewportNormal: true });
      if (e12 === OrientationAxis_default.AXIAL_REFORMAT || e12 === OrientationAxis_default.SAGITTAL_REFORMAT || e12 === OrientationAxis_default.CORONAL_REFORMAT) {
        let t;
        return t = e12 === OrientationAxis_default.AXIAL_REFORMAT ? OrientationAxis_default.AXIAL : e12 === OrientationAxis_default.SAGITTAL_REFORMAT ? OrientationAxis_default.SAGITTAL : OrientationAxis_default.CORONAL, getCameraVectors(this, {
          useViewportNormal: true,
          orientation: t
        });
      } else if (mprCameraValues_default[e12])
        return this.viewportProperties.orientation = e12, mprCameraValues_default[e12];
    }
    throw Error(`Invalid orientation: ${e12}. Valid orientations are: ${Object.keys(mprCameraValues_default).join(", ")}, ${OrientationAxis_default.ACQUISITION}, ${OrientationAxis_default.REFORMAT}, ${OrientationAxis_default.AXIAL_REFORMAT}, ${OrientationAxis_default.SAGITTAL_REFORMAT}, ${OrientationAxis_default.CORONAL_REFORMAT}`);
  }
  _getAcquisitionPlaneOrientation() {
    if (!this.getDefaultActor())
      return;
    let e12 = this.getVolumeId(), t = cache_default.getVolume(e12);
    if (!t)
      throw Error(`imageVolume with id: ${e12} does not exist in cache`);
    let { direction: n } = t;
    return {
      viewPlaneNormal: n.slice(6, 9).map((e13) => -e13),
      viewUp: n.slice(3, 6).map((e13) => -e13)
    };
  }
  getSlabThickness() {
    let e12 = this.getActors(), t = rendering_default.MINIMUM_SLAB_THICKNESS;
    return e12.forEach((e13) => {
      e13.slabThickness > t && (t = e13.slabThickness);
    }), t;
  }
  getIntensityFromWorld(e12) {
    let t = this.getDefaultActor();
    if (!actorIsA(t, "vtkVolume"))
      return;
    let { actor: n } = t, r = n.getMapper().getInputData(), a = cache_default.getVolume(this.getVolumeId()), o = transformWorldToIndex(r, e12);
    return a.voxelManager.getAtIJKPoint(o);
  }
  getVolumeId(e12) {
    let t = this.getActors();
    if (!t)
      return;
    if (!e12?.volumeId) {
      let e13 = t.find((e14) => e14.actor.getClassName() === "vtkVolume");
      return e13?.referencedId || e13?.uid;
    }
    let n = t.find((t2) => t2.actor.getClassName() === "vtkVolume" && t2.referencedId === e12?.volumeId);
    return n?.referencedId || n?.uid;
  }
  getViewReferenceId(e12 = {}) {
    let { volumeId: t, sliceIndex: n } = e12;
    if (!t) {
      let e13 = this.getActors();
      if (!e13 || (t = e13.find((e14) => e14.actor.getClassName() === "vtkVolume")?.referencedId, !t))
        return;
    }
    let r = this.getSliceIndex();
    n ??= r;
    let { viewPlaneNormal: a, focalPoint: o } = this.getCamera(), s = t.includes("?") ? "&" : "?", c = a.map((e13) => e13.toFixed(3)).join(",");
    return `volumeId:${t}${s}sliceIndex=${n}&viewPlaneNormal=${c}`;
  }
  _addVolumeId(e12) {
    this.volumeIds.add(e12);
  }
  getAllVolumeIds() {
    return Array.from(this.volumeIds);
  }
  _configureRenderingPipeline() {
    let e12 = isContextPoolRenderingEngine();
    for (let t in this.renderingPipelineFunctions)
      if (Object.prototype.hasOwnProperty.call(this.renderingPipelineFunctions, t)) {
        let n = this.renderingPipelineFunctions[t];
        this[t] = e12 ? n.contextPool : n.tiled;
      }
  }
};
function isCompatible(e12, t) {
  return !t || isEqual_default(dot$3(e12, t), 0);
}
var BaseVolumeViewport_default = BaseVolumeViewport;
function vtkAbstractImageMapper(e12, t) {
  t.classHierarchy.push("vtkAbstractImageMapper"), e12.getIsOpaque = () => true, e12.getCurrentImage = () => null, e12.getBoundsForSlice = () => (macro.vtkErrorMacro("vtkAbstractImageMapper.getBoundsForSlice - NOT IMPLEMENTED"), createUninitializedBounds());
}
var DEFAULT_VALUES$22 = {
  slice: 0,
  customDisplayExtent: [
    0,
    0,
    0,
    0,
    0,
    0
  ],
  useCustomExtents: false,
  backgroundColor: [
    0,
    0,
    0,
    1
  ],
  colorTextureWidth: 1024,
  opacityTextureWidth: 1024,
  labelOutlineTextureWidth: 1024
};
function extend$28(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$22, n), vtkAbstractMapper3D$1.extend(e12, t, n), macro.setGet(e12, t, [
    "slice",
    "useCustomExtents",
    "colorTextureWidth",
    "opacityTextureWidth",
    "labelOutlineTextureWidth"
  ]), macro.setGetArray(e12, t, ["customDisplayExtent"], 6), macro.setGetArray(e12, t, ["backgroundColor"], 4), vtkAbstractImageMapper(e12, t);
}
var vtkAbstractImageMapper$1 = { extend: extend$28 };
function doPicking(e12, t, n) {
  let r = n.getCurrentImage(), a = r.getExtent(), o = [
    a[0],
    a[2],
    a[4]
  ], { ijkMode: s } = n.getClosestIJKAxis(), c = n.isA("vtkImageArrayMapper") ? n.getSubSlice() : n.getSlice();
  s !== n.getSlicingMode() && (c = n.getSliceAtPosition(c)), o[s] += c;
  let l = [
    0,
    0,
    0
  ];
  r.indexToWorld(o, l), o[s] += 1;
  let u = [
    0,
    0,
    0
  ];
  r.indexToWorld(o, u), u[0] -= l[0], u[1] -= l[1], u[2] -= l[2], normalize$4(u, u);
  let d = vtkPlane$1.intersectWithLine(e12, t, l, u);
  if (d.intersection) {
    let e13 = d.x, t2 = [
      0,
      0,
      0
    ];
    return r.worldToIndex(e13, t2), {
      t: d.t,
      absoluteIJK: t2
    };
  }
  return null;
}
function intersectWithLineForPointPicking(e12, t, n) {
  let r = doPicking(e12, t, n);
  if (r) {
    let e13 = n.getCurrentImage().getExtent(), t2 = [
      Math.round(r.absoluteIJK[0]),
      Math.round(r.absoluteIJK[1]),
      Math.round(r.absoluteIJK[2])
    ];
    return t2[0] < e13[0] || t2[0] > e13[1] || t2[1] < e13[2] || t2[1] > e13[3] || t2[2] < e13[4] || t2[2] > e13[5] ? null : {
      t: r.t,
      ijk: t2
    };
  }
  return null;
}
function intersectWithLineForCellPicking(e12, t, n) {
  let r = doPicking(e12, t, n);
  if (r) {
    let e13 = n.getCurrentImage().getExtent(), t2 = r.absoluteIJK, a = [
      Math.floor(t2[0]),
      Math.floor(t2[1]),
      Math.floor(t2[2])
    ];
    if (a[0] < e13[0] || a[0] > e13[1] - 1 || a[1] < e13[2] || a[1] > e13[3] - 1 || a[2] < e13[4] || a[2] > (e13[5] ? e13[5] - 1 : e13[5]))
      return null;
    let o = [
      t2[0] - a[0],
      t2[1] - a[1],
      t2[2] - a[2]
    ];
    return {
      t: r.t,
      ijk: a,
      pCoords: o
    };
  }
  return null;
}
var { staticOffsetAPI, otherStaticMethods } = CoincidentTopologyHelper, { SlicingMode } = Constants$3;
function vtkImageMapper(e12, t) {
  t.classHierarchy.push("vtkImageMapper"), e12.getSliceAtPosition = (n2) => {
    let r = e12.getCurrentImage(), a;
    if (n2.length === 3)
      a = n2;
    else if (Number.isFinite(n2)) {
      let e13 = r.getBounds();
      switch (t.slicingMode) {
        case SlicingMode.X:
          a = [
            n2,
            (e13[3] + e13[2]) / 2,
            (e13[5] + e13[4]) / 2
          ];
          break;
        case SlicingMode.Y:
          a = [
            (e13[1] + e13[0]) / 2,
            n2,
            (e13[5] + e13[4]) / 2
          ];
          break;
        case SlicingMode.Z:
          a = [
            (e13[1] + e13[0]) / 2,
            (e13[3] + e13[2]) / 2,
            n2
          ];
          break;
      }
    }
    let o = [
      0,
      0,
      0
    ];
    r.worldToIndex(a, o);
    let s = r.getExtent(), { ijkMode: c } = e12.getClosestIJKAxis(), l = 0;
    switch (c) {
      case SlicingMode.I:
        l = clampValue(o[0], s[0], s[1]);
        break;
      case SlicingMode.J:
        l = clampValue(o[1], s[2], s[3]);
        break;
      case SlicingMode.K:
        l = clampValue(o[2], s[4], s[5]);
        break;
      default:
        return 0;
    }
    return l;
  }, e12.setSliceFromCamera = (n2) => {
    let r = n2.getFocalPoint();
    switch (t.slicingMode) {
      case SlicingMode.I:
      case SlicingMode.J:
      case SlicingMode.K:
        {
          let t2 = e12.getSliceAtPosition(r);
          e12.setSlice(t2);
        }
        break;
      case SlicingMode.X:
        e12.setSlice(r[0]);
        break;
      case SlicingMode.Y:
        e12.setSlice(r[1]);
        break;
      case SlicingMode.Z:
        e12.setSlice(r[2]);
        break;
    }
  }, e12.setXSlice = (t2) => {
    e12.setSlicingMode(SlicingMode.X), e12.setSlice(t2);
  }, e12.setYSlice = (t2) => {
    e12.setSlicingMode(SlicingMode.Y), e12.setSlice(t2);
  }, e12.setZSlice = (t2) => {
    e12.setSlicingMode(SlicingMode.Z), e12.setSlice(t2);
  }, e12.setISlice = (t2) => {
    e12.setSlicingMode(SlicingMode.I), e12.setSlice(t2);
  }, e12.setJSlice = (t2) => {
    e12.setSlicingMode(SlicingMode.J), e12.setSlice(t2);
  }, e12.setKSlice = (t2) => {
    e12.setSlicingMode(SlicingMode.K), e12.setSlice(t2);
  }, e12.getSlicingModeNormal = () => {
    let n2 = [
      0,
      0,
      0
    ], r = e12.getCurrentImage().getDirection();
    switch (t.slicingMode) {
      case SlicingMode.X:
        n2[0] = 1;
        break;
      case SlicingMode.Y:
        n2[1] = 1;
        break;
      case SlicingMode.Z:
        n2[2] = 1;
        break;
      case SlicingMode.I:
        multiply3x3_vect3(r, [
          1,
          0,
          0
        ], n2);
        break;
      case SlicingMode.J:
        multiply3x3_vect3(r, [
          0,
          1,
          0
        ], n2);
        break;
      case SlicingMode.K:
        multiply3x3_vect3(r, [
          0,
          0,
          1
        ], n2);
        break;
    }
    return n2;
  };
  function n() {
    let n2;
    switch (t.slicingMode) {
      case SlicingMode.X:
        n2 = 0;
        break;
      case SlicingMode.Y:
        n2 = 1;
        break;
      case SlicingMode.Z:
        n2 = 2;
        break;
      default:
        t.closestIJKAxis = {
          ijkMode: t.slicingMode,
          flip: false
        };
        return;
    }
    let r = getSparseOrthogonalMatrix(e12.getCurrentImage().getDirection()), a = 0;
    for (; a < 3 && r[n2 + 3 * a] === 0; ++a)
      ;
    let o = r[n2 + 3 * a] < 0;
    t.closestIJKAxis = {
      ijkMode: a,
      flip: o
    };
  }
  e12.setSlicingMode = (r) => {
    t.slicingMode !== r && (t.slicingMode = r, e12.getCurrentImage() && n(), e12.modified());
  }, e12.getClosestIJKAxis = () => ((t.closestIJKAxis === void 0 || t.closestIJKAxis.ijkMode === SlicingMode.NONE) && e12.getCurrentImage() && n(), t.closestIJKAxis), e12.getBounds = () => {
    let n2 = e12.getCurrentImage();
    if (!n2)
      return createUninitializedBounds();
    if (!t.useCustomExtents)
      return n2.getBounds();
    let r = t.customDisplayExtent.slice(), { ijkMode: a } = e12.getClosestIJKAxis(), o = t.slice;
    switch (a !== t.slicingMode && (o = e12.getSliceAtPosition(t.slice)), a) {
      case SlicingMode.I:
        r[0] = o, r[1] = o;
        break;
      case SlicingMode.J:
        r[2] = o, r[3] = o;
        break;
      case SlicingMode.K:
        r[4] = o, r[5] = o;
        break;
    }
    return n2.extentToBounds(r);
  }, e12.getBoundsForSlice = function() {
    let n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : t.slice, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = e12.getCurrentImage();
    if (!a)
      return createUninitializedBounds();
    let o = a.getSpatialExtent(), { ijkMode: s } = e12.getClosestIJKAxis(), c = n2;
    switch (s !== t.slicingMode && (c = e12.getSliceAtPosition(n2)), s) {
      case SlicingMode.I:
        o[0] = c - r, o[1] = c + r;
        break;
      case SlicingMode.J:
        o[2] = c - r, o[3] = c + r;
        break;
      case SlicingMode.K:
        o[4] = c - r, o[5] = c + r;
        break;
    }
    return a.extentToBounds(o);
  }, e12.intersectWithLineForPointPicking = (t2, n2) => intersectWithLineForPointPicking(t2, n2, e12), e12.intersectWithLineForCellPicking = (t2, n2) => intersectWithLineForCellPicking(t2, n2, e12), e12.getCurrentImage = () => e12.getInputData();
}
var DEFAULT_VALUES$21 = {
  slicingMode: SlicingMode.NONE,
  closestIJKAxis: {
    ijkMode: SlicingMode.NONE,
    flip: false
  },
  renderToRectangle: false,
  sliceAtFocalPoint: false,
  preferSizeOverAccuracy: false
};
function extend$27(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$21, n), vtkAbstractImageMapper$1.extend(e12, t, n), macro.get(e12, t, ["slicingMode"]), macro.setGet(e12, t, [
    "closestIJKAxis",
    "renderToRectangle",
    "sliceAtFocalPoint",
    "preferSizeOverAccuracy"
  ]), CoincidentTopologyHelper.implementCoincidentTopologyMethods(e12, t), vtkImageMapper(e12, t);
}
var vtkImageMapper$1 = {
  newInstance: macro.newInstance(extend$27, "vtkImageMapper"),
  extend: extend$27,
  ...staticOffsetAPI,
  ...otherStaticMethods,
  ...Constants$3
}, { InterpolationType } = Constants$2, { vtkErrorMacro: vtkErrorMacro$4 } = macro, VTK_MAX_VRCOMP = 4;
function vtkImageProperty(e12, t) {
  t.classHierarchy.push("vtkImageProperty"), e12.getMTime = () => {
    let e13 = t.mtime, n;
    for (let r = 0; r < VTK_MAX_VRCOMP; r++)
      t.componentData[r].rGBTransferFunction && (n = t.componentData[r].rGBTransferFunction.getMTime(), e13 = e13 > n ? e13 : n), t.componentData[r].piecewiseFunction && (n = t.componentData[r].piecewiseFunction.getMTime(), e13 = e13 > n ? e13 : n);
    return e13;
  }, e12.setRGBTransferFunction = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = n, o = r;
    return Number.isInteger(n) || (o = n, a = 0), t.componentData[a].rGBTransferFunction === o ? false : (t.componentData[a].rGBTransferFunction = o, e12.modified(), true);
  }, e12.getRGBTransferFunction = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[e13].rGBTransferFunction;
  }, e12.setPiecewiseFunction = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = n, o = r;
    return Number.isInteger(n) || (o = n, a = 0), t.componentData[a].piecewiseFunction === o ? false : (t.componentData[a].piecewiseFunction = o, e12.modified(), true);
  }, e12.getPiecewiseFunction = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return t.componentData[e13].piecewiseFunction;
  }, e12.setScalarOpacity = function() {
    let t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, r = t2, a = n;
    return Number.isInteger(t2) || (a = t2, r = 0), e12.setPiecewiseFunction(r, a);
  }, e12.getScalarOpacity = function() {
    let t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return e12.getPiecewiseFunction(t2);
  }, e12.setComponentWeight = function() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (n < 0 || n >= VTK_MAX_VRCOMP)
      return vtkErrorMacro$4("Invalid index"), false;
    let a = Math.min(1, Math.max(0, r));
    return t.componentData[n].componentWeight === a ? false : (t.componentData[n].componentWeight = a, e12.modified(), true);
  }, e12.getComponentWeight = function() {
    let e13 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return e13 < 0 || e13 >= VTK_MAX_VRCOMP ? (vtkErrorMacro$4("Invalid index"), 0) : t.componentData[e13].componentWeight;
  }, e12.setInterpolationTypeToNearest = () => e12.setInterpolationType(InterpolationType.NEAREST), e12.setInterpolationTypeToLinear = () => e12.setInterpolationType(InterpolationType.LINEAR), e12.getInterpolationTypeAsString = () => macro.enumToString(InterpolationType, t.interpolationType);
}
var defaultValues$4 = (e12) => ({
  independentComponents: false,
  interpolationType: InterpolationType.LINEAR,
  colorWindow: 255,
  colorLevel: 127.5,
  ambient: 1,
  diffuse: 0,
  opacity: 1,
  useLookupTableScalarRange: false,
  useLabelOutline: false,
  labelOutlineThickness: [1],
  labelOutlineOpacity: 1,
  updatedExtents: [],
  ...e12
});
function extend$26(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (Object.assign(t, defaultValues$4(n)), macro.obj(e12, t), !t.componentData) {
    t.componentData = [];
    for (let e13 = 0; e13 < VTK_MAX_VRCOMP; e13++)
      t.componentData.push({
        rGBTransferFunction: null,
        piecewiseFunction: null,
        componentWeight: 1
      });
  }
  macro.setGet(e12, t, [
    "independentComponents",
    "interpolationType",
    "colorWindow",
    "colorLevel",
    "ambient",
    "diffuse",
    "opacity",
    "useLookupTableScalarRange",
    "useLabelOutline",
    "labelOutlineOpacity",
    "updatedExtents"
  ]), macro.setGetArray(e12, t, ["labelOutlineThickness"]), vtkImageProperty(e12, t);
}
var vtkImageProperty$1 = {
  newInstance: macro.newInstance(extend$26, "vtkImageProperty"),
  extend: extend$26
};
function vtkImageSlice(e12, t) {
  t.classHierarchy.push("vtkImageSlice"), e12.getActors = () => e12, e12.getImages = () => e12, e12.getIsOpaque = () => {
    if (t.forceOpaque)
      return true;
    if (t.forceTranslucent)
      return false;
    t.properties[0] || e12.getProperty();
    let n = t.properties[0].getOpacity() >= 1;
    return n &&= !t.mapper || t.mapper.getIsOpaque(), n;
  }, e12.hasTranslucentPolygonalGeometry = () => false, e12.makeProperty = vtkImageProperty$1.newInstance, e12.getBoundsForSlice = (n, r) => {
    let a = t.mapper.getBoundsForSlice(n, r);
    if (!vtkBoundingBox.isValid(a))
      return a;
    e12.computeMatrix();
    let o = new Float64Array(16);
    return transpose(o, t.matrix), vtkBoundingBox.transformBounds(a, o);
  }, e12.getMinXBound = () => e12.getBounds()[0], e12.getMaxXBound = () => e12.getBounds()[1], e12.getMinYBound = () => e12.getBounds()[2], e12.getMaxYBound = () => e12.getBounds()[3], e12.getMinZBound = () => e12.getBounds()[4], e12.getMaxZBound = () => e12.getBounds()[5], e12.getRedrawMTime = () => {
    let e13 = t.mtime;
    if (t.mapper !== null) {
      let n = t.mapper.getMTime();
      e13 = n > e13 ? n : e13, t.mapper.getInput() !== null && (t.mapper.getInputAlgorithm().update(), n = t.mapper.getInput().getMTime(), e13 = n > e13 ? n : e13);
    }
    return t.properties.forEach((t2) => {
      e13 = Math.max(e13, t2.getMTime());
      let n = t2.getRGBTransferFunction();
      n !== null && (e13 = Math.max(e13, n.getMTime()));
    }), e13;
  }, e12.getSupportsSelection = () => t.mapper ? t.mapper.getSupportsSelection() : false;
}
var DEFAULT_VALUES$20 = {
  mapper: null,
  forceOpaque: false,
  forceTranslucent: false
};
function extend$25(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$20, n), vtkProp3D$1.extend(e12, t, n), t.boundsMTime = {}, macro.obj(t.boundsMTime), macro.setGet(e12, t, [
    "mapper",
    "forceOpaque",
    "forceTranslucent"
  ]), vtkImageSlice(e12, t);
}
var vtkImageSlice$1 = {
  newInstance: macro.newInstance(extend$25, "vtkImageSlice"),
  extend: extend$25
};
function getValidVOILUTFunction(e12) {
  return Object.values(VOILUTFunctionType_default).includes(e12) ? e12 : VOILUTFunctionType_default.LINEAR;
}
function getImagePlaneModule(e12) {
  let t = { ...getMetaData(MetadataModules_default.IMAGE_PLANE, e12) };
  return t.columnPixelSpacing ||= 1, t.rowPixelSpacing ||= 1, t.columnCosines ||= [
    0,
    1,
    0
  ], t.rowCosines ||= [
    1,
    0,
    0
  ], t.imagePositionPatient ||= [
    0,
    0,
    0
  ], t.imageOrientationPatient ||= new Float32Array([
    1,
    0,
    0,
    0,
    1,
    0
  ]), t;
}
function buildMetadata(e12) {
  let t = e12.imageId, { pixelRepresentation: n, bitsAllocated: r, bitsStored: a, highBit: o, photometricInterpretation: s, samplesPerPixel: c } = getMetaData("imagePixelModule", t), { windowWidth: l, windowCenter: u, voiLUTFunction: d } = e12, { modality: f } = getMetaData("generalSeriesModule", t), p = getMetaData("scalingModule", t), m = getMetaData(MetadataModules_default.CALIBRATION, t), h = getValidVOILUTFunction(d);
  return {
    calibration: m,
    scalingFactor: p,
    voiLUTFunction: h,
    modality: f,
    imagePlaneModule: getImagePlaneModule(t),
    imagePixelModule: {
      bitsAllocated: r,
      bitsStored: a,
      samplesPerPixel: c,
      highBit: o,
      photometricInterpretation: s,
      pixelRepresentation: n,
      windowWidth: l,
      windowCenter: u,
      modality: f,
      voiLUTFunction: h
    }
  };
}
function getImageDataMetadata(e12) {
  let { imagePlaneModule: t, imagePixelModule: n, voiLUTFunction: r, modality: a, scalingFactor: o, calibration: s } = buildMetadata(e12), { rowCosines: c, columnCosines: l } = t;
  (c == null || l == null) && (c = [
    1,
    0,
    0
  ], l = [
    0,
    1,
    0
  ]);
  let u = fromValues$3(c[0], c[1], c[2]), d = fromValues$3(l[0], l[1], l[2]), f = create$4();
  cross$1(f, u, d);
  let p = t.imagePositionPatient;
  p ??= [
    0,
    0,
    0
  ];
  let m = t.columnPixelSpacing || e12.columnPixelSpacing, h = t.rowPixelSpacing || e12.rowPixelSpacing, g = e12.columns, _ = e12.rows, v = epsilon_default;
  return !n.photometricInterpretation && e12.sizeInBytes === 3 * e12.width * e12.height && (e12.numberOfComponents = 3), {
    numberOfComponents: e12.numberOfComponents || _getNumCompsFromPhotometricInterpretation(n.photometricInterpretation),
    origin: p,
    direction: [
      ...u,
      ...d,
      ...f
    ],
    dimensions: [
      g,
      _,
      1
    ],
    spacing: [
      m,
      h,
      v
    ],
    numVoxels: g * _ * 1,
    imagePlaneModule: t,
    imagePixelModule: n,
    bitsAllocated: n.bitsAllocated,
    voiLUTFunction: r,
    modality: a,
    scalingFactor: o,
    calibration: s,
    scanAxisNormal: f
  };
}
function _getNumCompsFromPhotometricInterpretation(e12) {
  let t = 1;
  return (e12 === "RGB" || e12?.includes("YBR") || e12 === "PALETTE COLOR") && (t = 3), t;
}
var require_loglevel = /* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(e13, n) {
    typeof define == "function" && define.amd ? define(n) : typeof t == "object" && t.exports ? t.exports = n() : e13.log = n();
  })(e12, function() {
    var e13 = function() {
    }, t2 = "undefined", n = typeof window !== t2 && typeof window.navigator !== t2 && /Trident\/|MSIE /.test(window.navigator.userAgent), r = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ], a = {}, o = null;
    function s(e14, t3) {
      var n2 = e14[t3];
      if (typeof n2.bind == "function")
        return n2.bind(e14);
      try {
        return Function.prototype.bind.call(n2, e14);
      } catch {
        return function() {
          return Function.prototype.apply.apply(n2, [e14, arguments]);
        };
      }
    }
    function c() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function l(r2) {
      return r2 === "debug" && (r2 = "log"), typeof console === t2 ? false : r2 === "trace" && n ? c : console[r2] === void 0 ? console.log === void 0 ? e13 : s(console, "log") : s(console, r2);
    }
    function u() {
      for (var n2 = this.getLevel(), a2 = 0; a2 < r.length; a2++) {
        var o2 = r[a2];
        this[o2] = a2 < n2 ? e13 : this.methodFactory(o2, n2, this.name);
      }
      if (this.log = this.debug, typeof console === t2 && n2 < this.levels.SILENT)
        return "No console available for logging";
    }
    function d(e14) {
      return function() {
        typeof console !== t2 && (u.call(this), this[e14].apply(this, arguments));
      };
    }
    function f(e14, t3, n2) {
      return l(e14) || d.apply(this, arguments);
    }
    function p(e14, n2) {
      var s2 = this, c2, l2, d2, p2 = "loglevel";
      typeof e14 == "string" ? p2 += ":" + e14 : typeof e14 == "symbol" && (p2 = void 0);
      function m2(e15) {
        var n3 = (r[e15] || "silent").toUpperCase();
        if (!(typeof window === t2 || !p2)) {
          try {
            window.localStorage[p2] = n3;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(p2) + "=" + n3 + ";";
          } catch {
          }
        }
      }
      function h() {
        var e15;
        if (!(typeof window === t2 || !p2)) {
          try {
            e15 = window.localStorage[p2];
          } catch {
          }
          if (typeof e15 === t2)
            try {
              var n3 = window.document.cookie, r2 = encodeURIComponent(p2), a2 = n3.indexOf(r2 + "=");
              a2 !== -1 && (e15 = /^([^;]+)/.exec(n3.slice(a2 + r2.length + 1))[1]);
            } catch {
            }
          return s2.levels[e15] === void 0 && (e15 = void 0), e15;
        }
      }
      function g() {
        if (!(typeof window === t2 || !p2)) {
          try {
            window.localStorage.removeItem(p2);
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(p2) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      function _(e15) {
        var t3 = e15;
        if (typeof t3 == "string" && s2.levels[t3.toUpperCase()] !== void 0 && (t3 = s2.levels[t3.toUpperCase()]), typeof t3 == "number" && t3 >= 0 && t3 <= s2.levels.SILENT)
          return t3;
        throw TypeError("log.setLevel() called with invalid level: " + e15);
      }
      s2.name = e14, s2.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, s2.methodFactory = n2 || f, s2.getLevel = function() {
        return d2 ?? l2 ?? c2;
      }, s2.setLevel = function(e15, t3) {
        return d2 = _(e15), t3 !== false && m2(d2), u.call(s2);
      }, s2.setDefaultLevel = function(e15) {
        l2 = _(e15), h() || s2.setLevel(e15, false);
      }, s2.resetLevel = function() {
        d2 = null, g(), u.call(s2);
      }, s2.enableAll = function(e15) {
        s2.setLevel(s2.levels.TRACE, e15);
      }, s2.disableAll = function(e15) {
        s2.setLevel(s2.levels.SILENT, e15);
      }, s2.rebuild = function() {
        if (o !== s2 && (c2 = _(o.getLevel())), u.call(s2), o === s2)
          for (var e15 in a)
            a[e15].rebuild();
      }, c2 = _(o ? o.getLevel() : "WARN");
      var v = h();
      v != null && (d2 = _(v)), u.call(s2);
    }
    o = new p(), o.getLogger = function(e14) {
      if (typeof e14 != "symbol" && typeof e14 != "string" || e14 === "")
        throw TypeError("You must supply a name when creating a logger.");
      var t3 = a[e14];
      return t3 ||= a[e14] = new p(e14, o.methodFactory), t3;
    };
    var m = typeof window === t2 ? void 0 : window.log;
    return o.noConflict = function() {
      return typeof window !== t2 && window.log === o && (window.log = m), o;
    }, o.getLoggers = function() {
      return a;
    }, o.default = o, o;
  });
}), logger_exports = /* @__PURE__ */ __export({
  aiLog: () => aiLog,
  coreLog: () => coreLog,
  cs3dLog: () => cs3dLog,
  dicomConsistencyLog: () => dicomConsistencyLog,
  examplesLog: () => examplesLog,
  getLogger: () => getLogger,
  getRootLogger: () => getRootLogger,
  imageConsistencyLog: () => imageConsistencyLog,
  loaderLog: () => loaderLog,
  toolsLog: () => toolsLog
}), loglevel = (/* @__PURE__ */ __toESM(require_loglevel())).default.noConflict();
typeof window < "u" && (window.log = loglevel);
function getRootLogger(e12) {
  let t = loglevel.getLogger(e12[0]);
  return t.getLogger = (...t2) => getRootLogger(`${e12}.${t2.join(".")}`), t;
}
function getLogger(...e12) {
  return getRootLogger(e12.join("."));
}
const cs3dLog = getRootLogger("cs3d"), coreLog = cs3dLog.getLogger("core"), toolsLog = cs3dLog.getLogger("tools"), loaderLog = cs3dLog.getLogger("dicomImageLoader"), aiLog = cs3dLog.getLogger("ai"), examplesLog = cs3dLog.getLogger("examples"), dicomConsistencyLog = getLogger("consistency", "dicom"), imageConsistencyLog = getLogger("consistency", "image");
function createLinearRGBTransferFunction(e12) {
  let t = vtkColorTransferFunction$1.newInstance(), n = 0, r = 1024;
  return e12.lower !== void 0 && e12.upper !== void 0 && (n = e12.lower, r = e12.upper), t.addRGBPoint(n, 0, 0, 0), t.addRGBPoint(r, 1, 1, 1), t;
}
function updateVTKImageDataWithCornerstoneImage(e12, t) {
  let n = t.voxelManager.getScalarData();
  if (!e12.getPointData)
    return;
  let r = e12.getPointData().getScalars().getData();
  if (t.color && t.rgba) {
    let e13 = new Uint8Array(t.columns * t.rows * 3);
    for (let r2 = 0; r2 < t.columns * t.rows; r2++)
      e13[r2 * 3] = n[r2 * 4], e13[r2 * 3 + 1] = n[r2 * 4 + 1], e13[r2 * 3 + 2] = n[r2 * 4 + 2];
    t.rgba = false, t.getPixelData = () => e13, r.set(e13);
  } else
    r.set(n);
  e12.modified();
}
function now_default() {
  return window.performance ? performance.now() : Date.now();
}
function generateLinearVOILUT(e12, t) {
  return function(n) {
    let r = ((n - (t - 0.5)) / (e12 - 1) + 0.5) * 255;
    return Math.min(Math.max(r, 0), 255);
  };
}
function generateNonLinearVOILUT(e12) {
  let t = Math.max(...e12.lut).toString(2).length - 8, n = e12.lut[0] >> t, r = e12.lut[e12.lut.length - 1] >> t, a = e12.firstValueMapped + e12.lut.length - 1;
  return function(o) {
    return o < e12.firstValueMapped ? n : o >= a ? r : e12.lut[o - e12.firstValueMapped] >> t;
  };
}
function getVOILut_default(e12, t, n) {
  return n ? generateNonLinearVOILUT(n) : generateLinearVOILUT(e12, t);
}
function generateColorLUT(e12, t, n, r, a) {
  let o = e12.maxPixelValue, s = e12.minPixelValue, c = Math.min(s, 0);
  if (e12.cachedLut === void 0) {
    let t2 = o - c + 1;
    e12.cachedLut = {}, e12.cachedLut.lutArray = new Uint8ClampedArray(t2);
  }
  let l = e12.cachedLut.lutArray, u = getVOILut_default(Array.isArray(t) ? t[0] : t, Array.isArray(n) ? n[0] : n, a);
  if (r)
    for (let e13 = s; e13 <= o; e13++)
      l[e13 + -c] = 255 - u(e13);
  else
    for (let e13 = s; e13 <= o; e13++)
      l[e13 + -c] = u(e13);
  return l;
}
function storedColorPixelDataToCanvasImageData_default(e12, t, n) {
  let r = now_default(), a = e12.voxelManager.getScalarData();
  e12.stats.lastGetPixelDataTime = now_default() - r;
  let o = e12.minPixelValue, s = 0, c = 0, l = a.length;
  if (r = now_default(), o < 0)
    for (; c < l; )
      n[s++] = t[a[c++] + -o], n[s++] = t[a[c++] + -o], n[s++] = t[a[c++] + -o], n[s++] = 255;
  else
    for (; c < l; )
      n[s++] = t[a[c++]], n[s++] = t[a[c++]], n[s++] = t[a[c++]], n[s++] = 255;
  e12.stats.lastStoredPixelDataToCanvasImageDataTime = now_default() - r;
}
function storedRGBAPixelDataToCanvasImageData_default(e12, t, n) {
  let r = now_default(), a = e12.getPixelData();
  e12.stats.lastGetPixelDataTime = now_default() - r;
  let o = e12.minPixelValue, s = 0, c = 0, l = a.length;
  if (r = now_default(), o < 0)
    for (; c < l; )
      n[s++] = t[a[c++] + -o], n[s++] = t[a[c++] + -o], n[s++] = t[a[c++] + -o], n[s++] = a[c++];
  else
    for (; c < l; )
      n[s++] = t[a[c++]], n[s++] = t[a[c++]], n[s++] = t[a[c++]], n[s++] = a[c++];
  e12.stats.lastStoredPixelDataToCanvasImageDataTime = now_default() - r;
}
var Transform = class e5 {
  constructor() {
    this.reset();
  }
  getMatrix() {
    return this.m;
  }
  reset() {
    this.m = [
      1,
      0,
      0,
      1,
      0,
      0
    ];
  }
  clone() {
    let t = new e5();
    return t.m[0] = this.m[0], t.m[1] = this.m[1], t.m[2] = this.m[2], t.m[3] = this.m[3], t.m[4] = this.m[4], t.m[5] = this.m[5], t;
  }
  multiply(e12) {
    let t = this.m[0] * e12[0] + this.m[2] * e12[1], n = this.m[1] * e12[0] + this.m[3] * e12[1], r = this.m[0] * e12[2] + this.m[2] * e12[3], a = this.m[1] * e12[2] + this.m[3] * e12[3], o = this.m[0] * e12[4] + this.m[2] * e12[5] + this.m[4], s = this.m[1] * e12[4] + this.m[3] * e12[5] + this.m[5];
    this.m[0] = t, this.m[1] = n, this.m[2] = r, this.m[3] = a, this.m[4] = o, this.m[5] = s;
  }
  invert() {
    let e12 = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), t = this.m[3] * e12, n = -this.m[1] * e12, r = -this.m[2] * e12, a = this.m[0] * e12, o = e12 * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), s = e12 * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
    this.m[0] = t, this.m[1] = n, this.m[2] = r, this.m[3] = a, this.m[4] = o, this.m[5] = s;
  }
  rotate(e12) {
    let t = Math.cos(e12), n = Math.sin(e12), r = this.m[0] * t + this.m[2] * n, a = this.m[1] * t + this.m[3] * n, o = this.m[0] * -n + this.m[2] * t, s = this.m[1] * -n + this.m[3] * t;
    this.m[0] = r, this.m[1] = a, this.m[2] = o, this.m[3] = s;
  }
  translate(e12, t) {
    this.m[4] += this.m[0] * e12 + this.m[2] * t, this.m[5] += this.m[1] * e12 + this.m[3] * t;
  }
  scale(e12, t) {
    this.m[0] *= e12, this.m[1] *= e12, this.m[2] *= t, this.m[3] *= t;
  }
  transformPoint(e12) {
    let t = e12[0], n = e12[1];
    return [t * this.m[0] + n * this.m[2] + this.m[4], t * this.m[1] + n * this.m[3] + this.m[5]];
  }
};
function calculateTransform_default(e12, t) {
  let n = new Transform(), r = e12.viewport.aspectRatio;
  if (!e12.viewport.displayedArea)
    return n;
  n.translate(e12.canvas.width / 2, e12.canvas.height / 2);
  let a = e12.viewport.rotation;
  a !== 0 && n.rotate(a * Math.PI / 180);
  let o = e12.viewport.scale, s = e12.viewport.scale, c = e12.viewport.displayedArea.brhc.x - (e12.viewport.displayedArea.tlhc.x - 1), l = e12.viewport.displayedArea.brhc.y - (e12.viewport.displayedArea.tlhc.y - 1);
  if (e12.viewport.displayedArea.presentationSizeMode === "NONE")
    e12.image.rowPixelSpacing < e12.image.columnPixelSpacing ? o *= e12.image.columnPixelSpacing / e12.image.rowPixelSpacing : e12.image.columnPixelSpacing < e12.image.rowPixelSpacing && (s *= e12.image.rowPixelSpacing / e12.image.columnPixelSpacing);
  else if (o = e12.viewport.displayedArea.columnPixelSpacing, s = e12.viewport.displayedArea.rowPixelSpacing, e12.viewport.displayedArea.presentationSizeMode === "SCALE TO FIT") {
    let t2 = e12.canvas.height / (l * s), n2 = e12.canvas.width / (c * o);
    o = s = Math.min(n2, t2), e12.viewport.displayedArea.rowPixelSpacing < e12.viewport.displayedArea.columnPixelSpacing ? o *= e12.viewport.displayedArea.columnPixelSpacing / e12.viewport.displayedArea.rowPixelSpacing : e12.viewport.displayedArea.columnPixelSpacing < e12.viewport.displayedArea.rowPixelSpacing && (s *= e12.viewport.displayedArea.rowPixelSpacing / e12.viewport.displayedArea.columnPixelSpacing);
  }
  if (n.scale(o, s), a !== 0 && n.rotate(-a * Math.PI / 180), n.translate(e12.viewport.translation.x, e12.viewport.translation.y), a !== 0 && n.rotate(a * Math.PI / 180), t !== void 0 && r === void 0 && n.scale(t, t), r !== void 0 && t === void 0) {
    let [e13, t2] = r;
    n.scale(e13, t2);
  }
  return e12.viewport.hflip && n.scale(-1, 1), e12.viewport.vflip && n.scale(1, -1), n.translate(-c / 2, -l / 2), n;
}
function setToPixelCoordinateSystem_default(e12, t, n) {
  if (e12 === void 0)
    throw Error("setToPixelCoordinateSystem: parameter enabledElement must not be undefined");
  if (t === void 0)
    throw Error("setToPixelCoordinateSystem: parameter context must not be undefined");
  let r = calculateTransform_default(e12, n).getMatrix();
  t.setTransform(r[0], r[1], r[2], r[3], r[4], r[5]);
}
function doesImageNeedToBeRendered(e12, t) {
  let n = e12.renderingTools.lastRenderedImageId, r = e12.renderingTools.lastRenderedViewport;
  return t.imageId !== n || !r || r.windowCenter !== e12.viewport.voi.windowCenter || r.windowWidth !== e12.viewport.voi.windowWidth || r.invert !== e12.viewport.invert || r.rotation !== e12.viewport.rotation || r.hflip !== e12.viewport.hflip || r.vflip !== e12.viewport.vflip || r.modalityLUT !== e12.viewport.modalityLUT || r.voiLUT !== e12.viewport.voiLUT || r.colormap !== e12.viewport.colormap;
}
function initializeRenderCanvas_default(e12, t) {
  let n = e12.renderingTools.renderCanvas;
  n.width = t.width, n.height = t.height;
  let r = n.getContext("2d");
  r.fillStyle = "white", r.fillRect(0, 0, n.width, n.height);
  let a = r.getImageData(0, 0, t.width, t.height);
  e12.renderingTools.renderCanvasContext = r, e12.renderingTools.renderCanvasData = a;
}
function saveLastRendered_default(e12) {
  let t = e12.image.imageId, n = e12.viewport, r = e12.image.color;
  return e12.renderingTools.lastRenderedImageId = t, e12.renderingTools.lastRenderedIsColor = r, e12.renderingTools.lastRenderedViewport = {
    windowCenter: n.voi.windowCenter,
    windowWidth: n.voi.windowWidth,
    invert: n.invert,
    rotation: n.rotation,
    hflip: n.hflip,
    vflip: n.vflip,
    modalityLUT: n.modalityLUT,
    voiLUT: n.voiLUT,
    colormap: n.colormap
  }, e12.renderingTools;
}
var VIEWPORT_ELEMENT = "viewport-element", CANVAS_CSS_CLASS = "cornerstone-canvas";
const EPSILON = 1e-4;
var canvasCreator;
function normalizeRenderScale(e12 = 1) {
  return Number.isFinite(e12) && e12 > 0 && e12 <= 1 ? e12 : 1;
}
function createCanvas(e12, t = 512, n = 512) {
  let r = canvasCreator ? canvasCreator(t, n) : document.createElement("canvas");
  return e12 ? (r.style.position = "absolute", r.style.width = "100%", r.style.height = "100%", r.style.imageRendering = "pixelated", r.classList.add(CANVAS_CSS_CLASS), e12.appendChild(r), r) : r;
}
function createViewportElement(e12) {
  let t = document.createElement("div");
  return t.style.position = "relative", t.style.width = "100%", t.style.height = "100%", t.style.overflow = "hidden", t.classList.add(VIEWPORT_ELEMENT), e12.appendChild(t), t;
}
function updateCanvasSizeAndAspectRatio(e12, t, n = 1) {
  let r = normalizeRenderScale(n);
  if (t === void 0) {
    let t2 = window.devicePixelRatio || 1, n2 = e12.getBoundingClientRect(), a2 = Math.round(n2.width * t2 * r), o2 = Math.round(n2.height * t2 * r);
    a2 > 0 && o2 > 0 && (e12.width = a2, e12.height = o2, e12.style.aspectRatio = `${a2} / ${o2}`);
    return;
  }
  let { width: a, height: o } = t;
  return a < 1 || o < 1 ? false : e12.width !== a || e12.height !== o ? (e12.width = a, e12.height = o, e12.style.aspectRatio = `${a} / ${o}`, true) : false;
}
function getOrCreateCanvas(e12, t = 1) {
  let n = `canvas.${CANVAS_CSS_CLASS}`, r = `div.${VIEWPORT_ELEMENT}`, a = e12.querySelector(r) || createViewportElement(e12), o = a.querySelector(n);
  if (o)
    return o;
  let s = createCanvas(a), c = a.getBoundingClientRect(), l = window.devicePixelRatio || 1, u = normalizeRenderScale(t), d = Math.ceil(c.width * l * u), f = Math.ceil(c.height * l * u);
  return d > 0 && f > 0 && (s.width = d, s.height = f, s.style.aspectRatio = `${d} / ${f}`), s;
}
var getOrCreateCanvas_default = getOrCreateCanvas;
function getLut(e12, t) {
  return e12.cachedLut !== void 0 && e12.cachedLut.windowCenter === t.voi.windowCenter && e12.cachedLut.windowWidth === t.voi.windowWidth && e12.cachedLut.invert === t.invert ? e12.cachedLut.lutArray : (generateColorLUT(e12, t.voi.windowWidth, t.voi.windowCenter, t.invert), e12.cachedLut.windowWidth = t.voi.windowWidth, e12.cachedLut.windowCenter = t.voi.windowCenter, e12.cachedLut.invert = t.invert, e12.cachedLut.lutArray);
}
function getRenderCanvas$2(e12, t, n) {
  let r = e12.renderingTools.lastRenderedIsColor;
  (!e12.renderingTools.renderCanvas || !r) && (e12.renderingTools.renderCanvas = createCanvas(null, t.width, t.height));
  let a = e12.renderingTools.renderCanvas, { windowWidth: o, windowCenter: s } = e12.viewport.voi;
  if ((o === 256 || o === 255) && (s === 128 || s === 127) && !e12.viewport.invert && t.getCanvas && t.getCanvas())
    return t.getCanvas();
  if (!doesImageNeedToBeRendered(e12, t) && !n)
    return a;
  (!e12.renderingTools.renderCanvasContext || a.width !== t.width || a.height !== t.height) && initializeRenderCanvas_default(e12, t);
  let c = now_default(), l = getLut(t, e12.viewport);
  t.stats = t.stats || {}, t.stats.lastLutGenerateTime = now_default() - c;
  let u = e12.renderingTools.renderCanvasData, d = e12.renderingTools.renderCanvasContext;
  return t.rgba ? storedRGBAPixelDataToCanvasImageData_default(t, l, u.data) : storedColorPixelDataToCanvasImageData_default(t, l, u.data), c = now_default(), d.putImageData(u, 0, 0), t.stats.lastPutImageDataTime = now_default() - c, a;
}
function renderColorImage(e12, t) {
  if (e12 === void 0)
    throw Error("renderColorImage: enabledElement parameter must not be undefined");
  let n = e12.image;
  if (n === void 0)
    throw Error("renderColorImage: image must be loaded before it can be drawn");
  let r = e12.canvas.getContext("2d");
  r.setTransform(1, 0, 0, 1, 0, 0), r.fillStyle = "black", r.fillRect(0, 0, e12.canvas.width, e12.canvas.height), r.imageSmoothingEnabled = !e12.viewport.pixelReplication, setToPixelCoordinateSystem_default(e12, r);
  let a = getRenderCanvas$2(e12, n, t), o = e12.viewport.displayedArea.tlhc.x - 1, s = e12.viewport.displayedArea.tlhc.y - 1, c = e12.viewport.displayedArea.brhc.x - o, l = e12.viewport.displayedArea.brhc.y - s;
  r.drawImage(a, o, s, c, l, 0, 0, c, l), e12.renderingTools = saveLastRendered_default(e12);
}
function storedPixelDataToCanvasImageData_default(e12, t, n) {
  let r = now_default(), a = e12.voxelManager.getScalarData();
  e12.stats.lastGetPixelDataTime = now_default() - r;
  let o = a.length, s = e12.minPixelValue, c = 3, l = 0;
  if (r = now_default(), a instanceof Int16Array)
    if (s < 0)
      for (; l < o; )
        n[c] = t[a[l++] + -s], c += 4;
    else
      for (; l < o; )
        n[c] = t[a[l++]], c += 4;
  else if (a instanceof Uint16Array)
    for (; l < o; )
      n[c] = t[a[l++]], c += 4;
  else if (s < 0)
    for (; l < o; )
      n[c] = t[a[l++] + -s], c += 4;
  else
    for (; l < o; )
      n[c] = t[a[l++]], c += 4;
  e12.stats.lastStoredPixelDataToCanvasImageDataTime = now_default() - r;
}
function storedPixelDataToCanvasImageDataPET_default(e12, t, n) {
  let r = now_default(), a = e12.voxelManager.getScalarData();
  e12.stats.lastGetPixelDataTime = now_default() - r;
  let o = a.length, s = 3, c = 0;
  for (r = now_default(); c < o; )
    n[s] = t(a[c++]), s += 4;
  e12.stats.lastStoredPixelDataToCanvasImageDataTime = now_default() - r;
}
function storedPixelDataToCanvasImageDataRGBA_default(e12, t, n) {
  let r = now_default(), a = e12.voxelManager.getScalarData();
  e12.stats.lastGetPixelDataTime = now_default() - r;
  let o = a.length, s = e12.minPixelValue, c = 0, l = 0, u;
  if (r = now_default(), a instanceof Int16Array)
    if (s < 0)
      for (; l < o; )
        u = t[a[l++] + -s], n[c++] = u, n[c++] = u, n[c++] = u, n[c++] = 255;
    else
      for (; l < o; )
        u = t[a[l++]], n[c++] = u, n[c++] = u, n[c++] = u, n[c++] = 255;
  else if (a instanceof Uint16Array)
    for (; l < o; )
      u = t[a[l++]], n[c++] = u, n[c++] = u, n[c++] = u, n[c++] = 255;
  else if (s < 0)
    for (; l < o; )
      u = t[a[l++] + -s], n[c++] = u, n[c++] = u, n[c++] = u, n[c++] = 255;
  else
    for (; l < o; )
      u = t[a[l++]], n[c++] = u, n[c++] = u, n[c++] = u, n[c++] = 255;
  e12.stats.lastStoredPixelDataToCanvasImageDataTime = now_default() - r;
}
function computeAutoVoi(e12, t) {
  if (hasVoi(e12))
    return;
  let n = t.maxPixelValue * t.slope + t.intercept, r = t.minPixelValue * t.slope + t.intercept, a = n - r, o = (n + r) / 2;
  e12.voi === void 0 ? e12.voi = {
    windowWidth: a,
    windowCenter: o,
    voiLUTFunction: t.voiLUTFunction
  } : (e12.voi.windowWidth = a, e12.voi.windowCenter = o);
}
function hasVoi(e12) {
  return e12.voiLUT && e12.voiLUT.lut && e12.voiLUT.lut.length > 0 || e12.voi.windowWidth !== void 0 && e12.voi.windowCenter !== void 0;
}
function lutMatches(e12, t) {
  return !e12 && !t ? true : !e12 || !t ? false : e12.id === t.id;
}
function generateLinearModalityLUT(e12, t) {
  return (n) => n * e12 + t;
}
function generateNonLinearModalityLUT(e12) {
  let t = e12.lut[0], n = e12.lut[e12.lut.length - 1], r = e12.firstValueMapped + e12.lut.length;
  return (a) => a < e12.firstValueMapped ? t : a >= r ? n : e12.lut[a];
}
function getModalityLut_default(e12, t, n) {
  return n ? generateNonLinearModalityLUT(n) : generateLinearModalityLUT(e12, t);
}
function generateLut_default(e12, t, n, r, a, o) {
  let s = e12.maxPixelValue, c = e12.minPixelValue, l = Math.min(c, 0);
  if (e12.cachedLut === void 0) {
    let t2 = s - l + 1;
    e12.cachedLut = {}, e12.cachedLut.lutArray = new Uint8ClampedArray(t2);
  }
  let u = e12.cachedLut.lutArray, d = getModalityLut_default(e12.slope, e12.intercept, a), f = getVOILut_default(t, n, o);
  if (e12.isPreScaled)
    if (r)
      for (let e13 = c; e13 <= s; e13++)
        u[e13 + -l] = 255 - f(e13);
    else
      for (let e13 = c; e13 <= s; e13++)
        u[e13 + -l] = f(e13);
  else if (r)
    for (let e13 = c; e13 <= s; e13++)
      u[e13 + -l] = 255 - f(d(e13));
  else
    for (let e13 = c; e13 <= s; e13++)
      u[e13 + -l] = f(d(e13));
  return u;
}
function getLut_default(e12, t, n) {
  return e12.cachedLut !== void 0 && e12.cachedLut.windowCenter === t.voi.windowCenter && e12.cachedLut.windowWidth === t.voi.windowWidth && lutMatches(e12.cachedLut.modalityLUT, t.modalityLUT) && lutMatches(e12.cachedLut.voiLUT, t.voiLUT) && e12.cachedLut.invert === t.invert && !n ? e12.cachedLut.lutArray : (computeAutoVoi(t, e12), generateLut_default(e12, t.voi.windowWidth, t.voi.windowCenter, t.invert, t.modalityLUT, t.voiLUT), e12.cachedLut.windowWidth = t.voi.windowWidth, e12.cachedLut.windowCenter = t.voi.windowCenter, e12.cachedLut.invert = t.invert, e12.cachedLut.voiLUT = t.voiLUT, e12.cachedLut.modalityLUT = t.modalityLUT, e12.cachedLut.lutArray);
}
function getRenderCanvas$1(e12, t, n, r = true) {
  let a = e12.renderingTools.lastRenderedIsColor;
  (!e12.renderingTools.renderCanvas || a) && (e12.renderingTools.renderCanvas = createCanvas(null, t.width, t.height), initializeRenderCanvas_default(e12, t));
  let o = e12.renderingTools.renderCanvas;
  if (!doesImageNeedToBeRendered(e12, t) && !n)
    return o;
  (o.width !== t.width || o.height !== t.height) && initializeRenderCanvas_default(e12, t), t.stats = t.stats || {};
  let s = e12.renderingTools.renderCanvasData, c = e12.renderingTools.renderCanvasContext, l = now_default();
  t.stats.lastLutGenerateTime = now_default() - l;
  let { viewport: u } = e12;
  if (u.modality === "PT" && t.isPreScaled) {
    let { windowWidth: e13, windowCenter: n2 } = u.voi, r2 = n2 - e13 / 2, a2 = 255 / (n2 + e13 / 2 - r2), o2;
    o2 = u.invert ? (e14) => 255 - (e14 - r2) * a2 : (e14) => (e14 - r2) * a2, storedPixelDataToCanvasImageDataPET_default(t, o2, s.data);
  } else {
    let e13 = getLut_default(t, u, n);
    r ? storedPixelDataToCanvasImageData_default(t, e13, s.data) : storedPixelDataToCanvasImageDataRGBA_default(t, e13, s.data);
  }
  return l = now_default(), c.putImageData(s, 0, 0), t.stats.lastPutImageDataTime = now_default() - l, o;
}
function renderGrayscaleImage(e12, t) {
  if (e12 === void 0)
    throw Error("drawImage: enabledElement parameter must not be undefined");
  let n = e12.image;
  if (n === void 0)
    throw Error("drawImage: image must be loaded before it can be drawn");
  let r = e12.canvas.getContext("2d");
  r.setTransform(1, 0, 0, 1, 0, 0), r.fillStyle = "black", r.fillRect(0, 0, e12.canvas.width, e12.canvas.height), r.imageSmoothingEnabled = !e12.viewport.pixelReplication, setToPixelCoordinateSystem_default(e12, r);
  let a = getRenderCanvas$1(e12, n, t), o = e12.viewport.displayedArea.tlhc.x - 1, s = e12.viewport.displayedArea.tlhc.y - 1, c = e12.viewport.displayedArea.brhc.x - o, l = e12.viewport.displayedArea.brhc.y - s;
  r.drawImage(a, o, s, c, l, 0, 0, c, l), e12.renderingTools = saveLastRendered_default(e12);
}
var BELOW_RANGE_COLOR_INDEX = 0, ABOVE_RANGE_COLOR_INDEX = 1, NAN_COLOR_INDEX = 2;
function HSVToRGB(e12, t, n) {
  if (e12 > 1)
    throw Error("HSVToRGB expects hue < 1");
  let r = [];
  if (t === 0)
    return r[0] = n, r[1] = n, r[2] = n, r;
  let a = Math.floor(e12 * 6), o = 6 * e12 - a, s = n * (1 - t), c = n * (1 - t * o), l = n * (1 - t * (1 - o));
  switch (a) {
    case 0:
    case 6:
      r[0] = n, r[1] = l, r[2] = s;
      break;
    case 1:
      r[0] = c, r[1] = n, r[2] = s;
      break;
    case 2:
      r[0] = s, r[1] = n, r[2] = l;
      break;
    case 3:
      r[0] = s, r[1] = c, r[2] = n;
      break;
    case 4:
      r[0] = l, r[1] = s, r[2] = n;
      break;
    case 5:
      r[0] = n, r[1] = s, r[2] = c;
      break;
  }
  return r;
}
function linearIndexLookupMain(e12, t) {
  let n;
  return n = e12 < t.Range[0] ? t.MaxIndex + BELOW_RANGE_COLOR_INDEX + 1.5 : e12 > t.Range[1] ? t.MaxIndex + ABOVE_RANGE_COLOR_INDEX + 1.5 : (e12 + t.Shift) * t.Scale, Math.floor(n);
}
var lookupTable_default = class {
  constructor() {
    this.NumberOfColors = 256, this.Ramp = "linear", this.TableRange = [0, 255], this.HueRange = [0, 0.66667], this.SaturationRange = [1, 1], this.ValueRange = [1, 1], this.AlphaRange = [1, 1], this.NaNColor = [
      128,
      0,
      0,
      255
    ], this.BelowRangeColor = [
      0,
      0,
      0,
      255
    ], this.UseBelowRangeColor = true, this.AboveRangeColor = [
      255,
      255,
      255,
      255
    ], this.UseAboveRangeColor = true, this.InputRange = [0, 255], this.Table = [];
  }
  setNumberOfTableValues(e12) {
    this.NumberOfColors = e12;
  }
  setRamp(e12) {
    this.Ramp = e12;
  }
  setTableRange(e12, t) {
    this.TableRange[0] = e12, this.TableRange[1] = t;
  }
  setHueRange(e12, t) {
    this.HueRange[0] = e12, this.HueRange[1] = t;
  }
  setSaturationRange(e12, t) {
    this.SaturationRange[0] = e12, this.SaturationRange[1] = t;
  }
  setValueRange(e12, t) {
    this.ValueRange[0] = e12, this.ValueRange[1] = t;
  }
  setRange(e12, t) {
    this.InputRange[0] = e12, this.InputRange[1] = t;
  }
  setAlphaRange(e12, t) {
    this.AlphaRange[0] = e12, this.AlphaRange[1] = t;
  }
  getColor(e12) {
    return this.mapValue(e12);
  }
  build(e12) {
    if (this.Table.length > 1 && !e12)
      return;
    this.Table = [];
    let t = this.NumberOfColors - 1, n, r, a, o;
    t ? (n = (this.HueRange[1] - this.HueRange[0]) / t, r = (this.SaturationRange[1] - this.SaturationRange[0]) / t, a = (this.ValueRange[1] - this.ValueRange[0]) / t, o = (this.AlphaRange[1] - this.AlphaRange[0]) / t) : n = r = a = o = 0;
    for (let e13 = 0; e13 <= t; e13++) {
      let t2 = this.HueRange[0] + e13 * n, s = this.SaturationRange[0] + e13 * r, c = this.ValueRange[0] + e13 * a, l = this.AlphaRange[0] + e13 * o, u = HSVToRGB(t2, s, c), d = [
        0,
        0,
        0,
        0
      ];
      switch (this.Ramp) {
        case "scurve":
          d[0] = Math.floor(127.5 * (1 + Math.cos((1 - u[0]) * Math.PI))), d[1] = Math.floor(127.5 * (1 + Math.cos((1 - u[1]) * Math.PI))), d[2] = Math.floor(127.5 * (1 + Math.cos((1 - u[2]) * Math.PI))), d[3] = Math.floor(l * 255);
          break;
        case "linear":
          d[0] = Math.floor(u[0] * 255 + 0.5), d[1] = Math.floor(u[1] * 255 + 0.5), d[2] = Math.floor(u[2] * 255 + 0.5), d[3] = Math.floor(l * 255 + 0.5);
          break;
        case "sqrt":
          d[0] = Math.floor(Math.sqrt(u[0]) * 255 + 0.5), d[1] = Math.floor(Math.sqrt(u[1]) * 255 + 0.5), d[2] = Math.floor(Math.sqrt(u[2]) * 255 + 0.5), d[3] = Math.floor(Math.sqrt(l) * 255 + 0.5);
          break;
        default:
          throw Error(`Invalid Ramp value (${this.Ramp})`);
      }
      this.Table.push(d);
    }
    this.buildSpecialColors();
  }
  buildSpecialColors() {
    let e12 = this.NumberOfColors, t = e12 + BELOW_RANGE_COLOR_INDEX, n = e12 + ABOVE_RANGE_COLOR_INDEX, r = e12 + NAN_COLOR_INDEX;
    this.UseBelowRangeColor || e12 === 0 ? this.Table[t] = this.BelowRangeColor : this.Table[t] = this.Table[0], this.UseAboveRangeColor || e12 === 0 ? this.Table[n] = this.AboveRangeColor : this.Table[n] = this.Table[e12 - 1], this.Table[r] = this.NaNColor;
  }
  mapValue(e12) {
    let t = this.getIndex(e12);
    if (t < 0)
      return this.NaNColor;
    if (t === 0) {
      if (this.UseBelowRangeColor && e12 < this.TableRange[0])
        return this.BelowRangeColor;
    } else if (t === this.NumberOfColors - 1 && this.UseAboveRangeColor && e12 > this.TableRange[1])
      return this.AboveRangeColor;
    return this.Table[t];
  }
  getIndex(e12) {
    let t = {
      Range: [],
      MaxIndex: this.NumberOfColors - 1,
      Shift: -this.TableRange[0],
      Scale: 1
    };
    if (this.TableRange[1] <= this.TableRange[0] ? t.Scale = Number.MAX_VALUE : t.Scale = t.MaxIndex / (this.TableRange[1] - this.TableRange[0]), t.Range[0] = this.TableRange[0], t.Range[1] = this.TableRange[1], isNaN(e12))
      return -1;
    let n = linearIndexLookupMain(e12, t);
    return n === this.NumberOfColors + BELOW_RANGE_COLOR_INDEX ? n = 0 : n === this.NumberOfColors + ABOVE_RANGE_COLOR_INDEX && (n = this.NumberOfColors - 1), n;
  }
  setTableValue(e12, t, n, r, a) {
    let o;
    if (typeof t == "number" && n !== void 0 && r !== void 0 && a !== void 0)
      o = [
        t,
        n,
        r,
        a
      ];
    else if (Array.isArray(t))
      o = t;
    else
      throw Error("Invalid arguments for setTableValue");
    if (e12 < 0)
      throw Error(`Can't set the table value for negative index (${e12})`);
    if (e12 >= this.NumberOfColors)
      throw Error(`Index ${e12} is greater than the number of colors ${this.NumberOfColors}`);
    this.Table[e12] = o, (e12 === 0 || e12 === this.NumberOfColors - 1) && this.buildSpecialColors();
  }
}, COLOR_TRANSPARENT = [
  0,
  0,
  0,
  0
];
function linspace(e12, t, n) {
  n = n === null ? 100 : n;
  let r = (t - e12) / (n - 1), a = [];
  for (; n-- > 0; )
    a.push(e12), e12 += r;
  return a[a.length - 1] = t, a;
}
function getRank(e12, t) {
  let n = 0, r = e12.length - 1;
  for (; n <= r; ) {
    let a = n + Math.floor((r - n) / 2), o = e12[a];
    if (o === t)
      return a;
    t < o ? r = a - 1 : n = a + 1;
  }
  return n;
}
function searchSorted(e12, t) {
  let n, r = [], a = t.length;
  for (e12.sort(function(e13, t2) {
    return e13 - t2;
  }), n = 0; n < a; n++)
    r[n] = getRank(e12, t[n]);
  return r;
}
function makeMappingArray(e12, t, n) {
  let r, a = [], o = [], s = [], c = [];
  for (n = n === null ? 1 : n, r = 0; r < t.length; r++) {
    let n2 = t[r];
    a.push((e12 - 1) * n2[0]), o.push(n2[1]), s.push(n2[1]);
  }
  let l = linspace(0, 1, e12);
  for (r = 0; r < e12; r++)
    l[r] = (e12 - 1) * l[r] ** +n;
  let u = searchSorted(a, l);
  for (r = 1; r < e12 - 1; r++) {
    let e13 = u[r];
    c[r] = (l[r] - a[e13 - 1]) / (a[e13] - a[e13 - 1]) * (o[e13] - s[e13 - 1]) + s[e13 - 1];
  }
  return c[0] = s[0], c[e12 - 1] = o[t.length - 1], c;
}
function createLinearSegmentedColormap(e12, t, n) {
  let r, a = [];
  t = t === null ? 256 : t, n = n === null ? 1 : n;
  let o = makeMappingArray(t, e12.red, n), s = makeMappingArray(t, e12.green, n), c = makeMappingArray(t, e12.blue, n);
  for (r = 0; r < t; r++) {
    let e13 = [
      Math.round(o[r] * 255),
      Math.round(s[r] * 255),
      Math.round(c[r] * 255),
      255
    ];
    a.push(e13);
  }
  return a;
}
function getColormap(e12, t) {
  let n = cpuColormaps_default[e12];
  return n ||= cpuColormaps_default[e12] = t || {
    name: "",
    colors: []
  }, !n.colors && n.segmentedData && (n.colors = createLinearSegmentedColormap(n.segmentedData, n.numColors, n.gamma)), {
    getId() {
      return e12;
    },
    getColorSchemeName() {
      return n.name;
    },
    setColorSchemeName(e13) {
      n.name = e13;
    },
    getNumberOfColors() {
      return n.colors.length;
    },
    setNumberOfColors(e13) {
      for (; n.colors.length < e13; )
        n.colors.push(COLOR_TRANSPARENT);
      n.colors.length = e13;
    },
    getColor(e13) {
      return this.isValidIndex(e13) ? n.colors[e13] : COLOR_TRANSPARENT;
    },
    getColorRepeating(e13) {
      let t2 = n.colors.length;
      return e13 = t2 ? e13 % t2 : 0, this.getColor(e13);
    },
    setColor(e13, t2) {
      this.isValidIndex(e13) && (n.colors[e13] = t2);
    },
    addColor(e13) {
      n.colors.push(e13);
    },
    insertColor(e13, t2) {
      this.isValidIndex(e13) && n.colors.splice(e13, 1, t2);
    },
    removeColor(e13) {
      this.isValidIndex(e13) && n.colors.splice(e13, 1);
    },
    clearColors() {
      n.colors = [];
    },
    buildLookupTable(e13) {
      if (!e13)
        return;
      let t2 = n.colors.length;
      e13.setNumberOfTableValues(t2);
      for (let r = 0; r < t2; r++)
        e13.setTableValue(r, n.colors[r]);
    },
    createLookupTable() {
      let e13 = new lookupTable_default();
      return this.buildLookupTable(e13), e13;
    },
    isValidIndex(e13) {
      return e13 >= 0 && e13 < n.colors.length;
    }
  };
}
function storedPixelDataToCanvasImageDataPseudocolorLUT(e12, t, n, r) {
  let a = now_default(), o = e12.voxelManager.getScalarData();
  e12.stats.lastGetPixelDataTime = now_default() - a;
  let s = o.length, c = e12.minPixelValue, l = 0, u = 0, d, f, p;
  if (a = now_default(), p = n instanceof lookupTable_default ? n.Table : n, c < 0)
    for (; u < s; )
      d = t[o[u++] + -c], f = p[d], r[l++] = f[0], r[l++] = f[1], r[l++] = f[2], r[l++] = f[3];
  else
    for (; u < s; )
      d = t[o[u++]], f = p[d], r[l++] = f[0], r[l++] = f[1], r[l++] = f[2], r[l++] = f[3];
  e12.stats.lastStoredPixelDataToCanvasImageDataTime = now_default() - a;
}
var storedPixelDataToCanvasImageDataPseudocolorLUT_default = storedPixelDataToCanvasImageDataPseudocolorLUT;
function storedPixelDataToCanvasImageDataPseudocolorLUTPET(e12, t, n, r) {
  let a = now_default(), o = e12.voxelManager.getScalarData();
  e12.stats.lastGetPixelDataTime = now_default() - a;
  let s = o.length, c = e12.minPixelValue, l = 0, u = 0, d, f, p;
  if (a = now_default(), p = n instanceof lookupTable_default ? n.Table : n, c < 0)
    for (; u < s; )
      d = t(o[u++] + -c), f = p[d], r[l++] = f[0], r[l++] = f[1], r[l++] = f[2], r[l++] = f[3];
  else
    for (; u < s; )
      d = t(o[u++]), f = p[d], r[l++] = f[0], r[l++] = f[1], r[l++] = f[2], r[l++] = f[3];
  e12.stats.lastStoredPixelDataToCanvasImageDataTime = now_default() - a;
}
var storedPixelDataToCanvasImageDataPseudocolorLUTPET_default = storedPixelDataToCanvasImageDataPseudocolorLUTPET;
function clamp(e12, t, n) {
  return Math.max(t, Math.min(n, e12));
}
function getRenderCanvas(e12, t, n) {
  e12.renderingTools.renderCanvas || (e12.renderingTools.renderCanvas = createCanvas(null, t.width, t.height));
  let r = e12.renderingTools.renderCanvas, a = e12.viewport.colormap || e12.options.colormap;
  if (e12.options && e12.options.colormap && console.warn("enabledElement.options.colormap is deprecated. Use enabledElement.viewport.colormap instead"), a && typeof a == "string" && (a = getColormap(a)), !a)
    throw Error("renderPseudoColorImage: colormap not found.");
  let o = a.getId();
  if (!doesImageNeedToBeRendered(e12, t) && !n && e12.renderingTools.colormapId === o)
    return r;
  (!e12.renderingTools.renderCanvasContext || r.width !== t.width || r.height !== t.height) && initializeRenderCanvas_default(e12, t);
  let s = now_default();
  (!e12.renderingTools.colorLUT || n || e12.renderingTools.colormapId !== o) && (a.setNumberOfColors(256), e12.renderingTools.colorLUT = a.createLookupTable(), e12.renderingTools.colormapId = o);
  let c = e12.renderingTools.renderCanvasData, l = e12.renderingTools.renderCanvasContext, { viewport: u } = e12, d = e12.renderingTools.colorLUT;
  if (u.modality === "PT") {
    let { windowWidth: e13, windowCenter: n2 } = u.voi, r2 = n2 - e13 / 2, a2 = 255 / (n2 + e13 / 2 - r2), o2;
    o2 = u.invert ? (e14) => clamp(Math.floor(255 - (e14 - r2) * a2), 0, 255) : (e14) => clamp(Math.floor((e14 - r2) * a2), 0, 255), storedPixelDataToCanvasImageDataPseudocolorLUTPET_default(t, o2, d, c.data);
  } else {
    let r2 = getLut_default(t, e12.viewport, n);
    t.stats = t.stats || {}, t.stats.lastLutGenerateTime = now_default() - s, storedPixelDataToCanvasImageDataPseudocolorLUT_default(t, r2, d, c.data);
  }
  return s = now_default(), l.putImageData(c, 0, 0), t.stats.lastPutImageDataTime = now_default() - s, r;
}
function renderPseudoColorImage(e12, t) {
  if (e12 === void 0)
    throw Error("drawImage: enabledElement parameter must not be undefined");
  let n = e12.image;
  if (n === void 0)
    throw Error("drawImage: image must be loaded before it can be drawn");
  let r = e12.canvas.getContext("2d");
  r.setTransform(1, 0, 0, 1, 0, 0), r.fillStyle = "black", r.fillRect(0, 0, e12.canvas.width, e12.canvas.height), r.imageSmoothingEnabled = !e12.viewport.pixelReplication, setToPixelCoordinateSystem_default(e12, r);
  let a = getRenderCanvas(e12, n, t), o = e12.viewport.displayedArea.tlhc.x - 1, s = e12.viewport.displayedArea.tlhc.y - 1, c = e12.viewport.displayedArea.brhc.x - o, l = e12.viewport.displayedArea.brhc.y - s;
  r.drawImage(a, o, s, c, l, 0, 0, c, l), e12.renderingTools = saveLastRendered_default(e12);
}
function drawImageSync_default(e12, t) {
  let n = e12.image;
  if (!e12.canvas || !e12.image)
    return;
  let r = now_default();
  if (n.stats = {
    lastGetPixelDataTime: -1,
    lastStoredPixelDataToCanvasImageDataTime: -1,
    lastPutImageDataTime: -1,
    lastRenderTime: -1,
    lastLutGenerateTime: -1
  }, n) {
    let r2 = n.render;
    r2 ||= e12.viewport.colormap ? renderPseudoColorImage : n.color ? renderColorImage : renderGrayscaleImage, r2(e12, t);
  }
  let a = now_default() - r;
  n.stats.lastRenderTime = a, e12.invalid = false, e12.needsRedraw = false;
}
function getTransform_default(e12) {
  return calculateTransform_default(e12);
}
function canvasToPixel_default(e12, t) {
  let n = getTransform_default(e12);
  return n.invert(), n.transformPoint(t);
}
var state$2 = { viewport: {} };
function createDefaultDisplayedArea() {
  return {
    tlhc: {
      x: 1,
      y: 1
    },
    brhc: {
      x: 1,
      y: 1
    },
    rowPixelSpacing: 1,
    columnPixelSpacing: 1,
    presentationSizeMode: "NONE"
  };
}
function createViewport() {
  let e12 = createDefaultDisplayedArea(), t = {
    scale: 1,
    translation: {
      x: 0,
      y: 0
    },
    voi: {
      windowWidth: void 0,
      windowCenter: void 0,
      voiLUTFunction: VOILUTFunctionType_default.LINEAR
    },
    invert: false,
    pixelReplication: false,
    rotation: 0,
    hflip: false,
    vflip: false,
    modalityLUT: void 0,
    voiLUT: void 0,
    colormap: void 0,
    labelmap: false,
    displayedArea: e12
  };
  return Object.assign({}, t, state$2.viewport);
}
function validateParameterUndefinedOrNull(e12, t) {
  if (e12 == null)
    throw Error(t);
}
function isRotated(e12) {
  return !(e12 == null || e12 === 0 || e12 === 180);
}
function getImageSize_default(e12, t = null) {
  return validateParameterUndefinedOrNull(e12, "getImageSize: parameter image must not be undefined"), validateParameterUndefinedOrNull(e12.width, "getImageSize: parameter image must have width"), validateParameterUndefinedOrNull(e12.height, "getImageSize: parameter image must have height"), isRotated(t) ? {
    height: e12.width,
    width: e12.height
  } : {
    width: e12.width,
    height: e12.height
  };
}
function getImageFitScale_default(e12, t, n = null) {
  validateParameterUndefinedOrNull(e12, "getImageScale: parameter canvas must not be undefined"), validateParameterUndefinedOrNull(t, "getImageScale: parameter image must not be undefined");
  let r = getImageSize_default(t, n), a = t.rowPixelSpacing || 1, o = t.columnPixelSpacing || 1, s = 1, c = 1;
  a < o ? c = o / a : s = a / o;
  let l = e12.height / r.height / s, u = e12.width / r.width / c;
  return {
    verticalScale: l,
    horizontalScale: u,
    scaleFactor: Math.min(u, l)
  };
}
function getDefaultViewport_default(e12, t, n, r) {
  if (e12 === void 0)
    throw Error("getDefaultViewport: parameter canvas must not be undefined");
  if (t === void 0)
    return createViewport();
  let a = getImageFitScale_default(e12, t, 0).scaleFactor, o;
  return n === "PT" && t.isPreScaled ? o = {
    windowWidth: 5,
    windowCenter: 2.5
  } : t.windowWidth !== void 0 && t.windowCenter !== void 0 && (o = {
    windowWidth: Array.isArray(t.windowWidth) ? t.windowWidth[0] : t.windowWidth,
    windowCenter: Array.isArray(t.windowCenter) ? t.windowCenter[0] : t.windowCenter
  }), {
    scale: a,
    translation: {
      x: 0,
      y: 0
    },
    voi: o,
    invert: t.invert,
    pixelReplication: false,
    rotation: 0,
    hflip: false,
    vflip: false,
    modalityLUT: t.modalityLUT,
    modality: n,
    voiLUT: t.voiLUT,
    colormap: r === void 0 ? t.colormap : r,
    displayedArea: {
      tlhc: {
        x: 1,
        y: 1
      },
      brhc: {
        x: t.columns,
        y: t.rows
      },
      rowPixelSpacing: t.rowPixelSpacing === void 0 ? 1 : t.rowPixelSpacing,
      columnPixelSpacing: t.columnPixelSpacing === void 0 ? 1 : t.columnPixelSpacing,
      presentationSizeMode: "NONE"
    }
  };
}
function pixelToCanvas_default(e12, t) {
  return getTransform_default(e12).transformPoint(t);
}
function fitToWindow_default(e12) {
  let { image: t } = e12;
  e12.viewport.scale = getImageFitScale_default(e12.canvas, t, e12.viewport.rotation).scaleFactor, e12.viewport.translation.x = 0, e12.viewport.translation.y = 0;
}
function setCanvasSize(e12) {
  let { canvas: t } = e12, { clientWidth: n, clientHeight: r } = t;
  (t.width !== n || t.height !== r) && (t.width = n, t.height = r);
}
function wasFitToWindow(e12, t, n) {
  let r = e12.viewport.scale, a = getImageSize_default(e12.image, e12.viewport.rotation), o = Math.round(a.width * r), s = Math.round(a.height * r), c = e12.viewport.translation.x, l = e12.viewport.translation.y;
  return o === t && s <= n || o <= t && s === n && c === 0 && l === 0;
}
function relativeRescale(e12, t, n) {
  let r = e12.viewport.scale, a = e12.canvas.width, o = e12.canvas.height, s = a / t, c = o / n, l = Math.sqrt(s * c);
  e12.viewport.scale = l * r;
}
function resize_default(e12, t = false) {
  let n = e12.canvas.width, r = e12.canvas.height;
  setCanvasSize(e12), e12.image !== void 0 && (t || wasFitToWindow(e12, n, r) ? fitToWindow_default(e12) : relativeRescale(e12, n, r));
}
function correctShift_default(e12, t) {
  let { hflip: n, vflip: r, rotation: a } = t;
  if (e12.x *= n ? -1 : 1, e12.y *= r ? -1 : 1, a !== 0) {
    let t2 = a * Math.PI / 180, n2 = Math.cos(t2), r2 = Math.sin(t2), o = e12.x * n2 - e12.y * r2, s = e12.x * r2 + e12.y * n2;
    e12.x = o, e12.y = s;
  }
  return e12;
}
function resetCamera_default(e12, t = true, n = true) {
  let { canvas: r, image: a, viewport: o } = e12, s = getImageFitScale_default(r, a, 0).scaleFactor;
  o.vflip = false, o.hflip = false, t && (o.translation.x = 0, o.translation.y = 0), n && (o.displayedArea.tlhc.x = 1, o.displayedArea.tlhc.y = 1, o.displayedArea.brhc.x = a.columns, o.displayedArea.brhc.y = a.rows, o.scale = s);
}
var log$1 = coreLog.getLogger("utilities", "getClosestImageId");
function getClosestImageId(e12, t, n, r) {
  let { direction: a, spacing: o, imageIds: s } = e12, { ignoreSpacing: c = false } = r || {};
  if (!s?.length)
    return;
  let l = dot$3(a.slice(6, 9), n);
  if (Math.abs(l) < 0.999)
    return;
  let u;
  c || (u = getSpacingInNormalDirection({
    direction: a,
    spacing: o
  }, n) / 2);
  let d, f = Infinity;
  for (let e13 = 0; e13 < s.length; e13++) {
    let r2 = s[e13], a2 = getMetaData("imagePlaneModule", r2);
    if (!a2?.imagePositionPatient) {
      log$1.warn(`Missing imagePositionPatient for imageId: ${r2}`);
      continue;
    }
    let { imagePositionPatient: o2 } = a2, l2 = create$4();
    sub$1(l2, t, o2);
    let p = Math.abs(dot$3(l2, n));
    c ? p < f && (f = p, d = r2) : p < u && p < f && (f = p, d = r2);
  }
  return d === void 0 && log$1.warn("No imageId found within the specified criteria (half spacing or absolute closest)."), d;
}
function reflectVector(e12, t) {
  let n = dot$3(e12, t), r = scale$3(create$4(), t, 2 * n);
  return sub$1(create$4(), e12, r);
}
function adjustInitialViewUp(e12, t, n, r) {
  let a = clone$2(e12);
  if (n && negate(a, a), t) {
    let e13 = cross$1(create$4(), r, a);
    normalize$4(e13, e13), a = reflectVector(a, e13);
  }
  return a;
}
var log = coreLog.getLogger("RenderingEngine", "StackViewport"), StackViewport_default = class extends Viewport_default {
  constructor(e12) {
    super(e12), this.imageIds = [], this.imageKeyToIndexMap = /* @__PURE__ */ new Map(), this.currentImageIdIndex = 0, this.targetImageIdIndex = 0, this.imagesLoader = this, this.globalDefaultProperties = {}, this.perImageIdDefaultProperties = /* @__PURE__ */ new Map(), this.voiUpdatedWithSetProperties = false, this.sharpening = 0, this.smoothing = 0, this.invert = false, this.initialInvert = false, this.initialTransferFunctionNodes = null, this.stackInvalidated = false, this._publishCalibratedEvent = false, this.updateRenderingPipeline = () => {
      this._configureRenderingPipeline();
    }, this.setSharpening = (e13) => {
      this.sharpening = e13, this.render();
    }, this.setSmoothing = (e13) => {
      this.smoothing = e13, this.render();
    }, this.getRenderPasses = () => {
      if (!this.shouldUseCustomRenderPass())
        return null;
      let e13 = [];
      try {
        return this.smoothing > 0 && e13.push(createSmoothingRenderPass(this.smoothing)), this.sharpening > 0 && e13.push(createSharpeningRenderPass(this.sharpening)), e13.length ? e13 : null;
      } catch (e14) {
        return console.warn("Failed to create custom render passes:", e14), null;
      }
    }, this.resize = () => {
      this.useCPURendering && this._resizeCPU();
    }, this._resizeCPU = () => {
      this._cpuFallbackEnabledElement.viewport && resize_default(this._cpuFallbackEnabledElement);
    }, this.getFrameOfReferenceUID = (e13) => this.getImagePlaneReferenceData(e13)?.FrameOfReferenceUID, this.getCornerstoneImage = () => this.csImage, this.createActorMapper = (e13) => {
      let t = vtkImageMapper$1.newInstance();
      t.setInputData(e13);
      let n = vtkImageSlice$1.newInstance();
      return n.setMapper(t), e13.getPointData().getScalars().getNumberOfComponents() > 1 && n.getProperty().setIndependentComponents(false), n;
    }, this.getNumberOfSlices = () => this.imageIds.length, this.getDefaultProperties = (e13) => {
      let t;
      return e13 !== void 0 && (t = this.perImageIdDefaultProperties.get(e13)), t === void 0 ? { ...this.globalDefaultProperties } : t;
    }, this.getProperties = () => {
      let { colormap: e13, voiRange: t, VOILUTFunction: n, interpolationType: r, invert: a, voiUpdatedWithSetProperties: o } = this;
      return {
        colormap: e13,
        voiRange: t,
        VOILUTFunction: n,
        interpolationType: r,
        invert: a,
        isComputedVOI: !o,
        sharpening: this.sharpening,
        smoothing: this.smoothing
      };
    }, this.resetCameraForResize = () => this.resetCamera({
      resetPan: true,
      resetZoom: true,
      resetToCenter: true,
      resetAspectRatio: true,
      suppressEvents: true
    }), this.getRotationCPU = () => {
      let { viewport: e13 } = this._cpuFallbackEnabledElement;
      return e13.rotation;
    }, this.getRotationGPU = () => {
      let { viewUp: e13, viewPlaneNormal: t, flipVertical: n, flipHorizontal: r } = this.getCameraNoRotation(), a = adjustInitialViewUp(this.initialViewUp, r, n, t), o = angle(a, e13) * 180 / Math.PI;
      return dot$3(cross$1(create$4(), a, e13), t) >= 0 ? o : (360 - o) % 360;
    }, this.setRotation = (e13) => {
      let t = this.getCamera();
      if (this.useCPURendering ? this.setRotationCPU(e13) : this.setRotationGPU(e13), this._suppressCameraModifiedEvents)
        return;
      let n = {
        previousCamera: t,
        camera: this.getCamera(),
        element: this.element,
        viewportId: this.id,
        renderingEngineId: this.renderingEngineId
      };
      triggerEvent(this.element, Events_default.CAMERA_MODIFIED, n);
    }, this.renderImageObject = (e13) => {
      this._setCSImage(e13), (this.useCPURendering ? this._updateToDisplayImageCPU : this._updateActorToDisplayImageId).call(this, e13);
    }, this._setCSImage = (e13) => {
      e13.isPreScaled = e13.preScale?.scaled, this.csImage = e13;
    }, this.canvasToWorldCPU = (e13, t = [
      0,
      0,
      0
    ]) => {
      if (!this._cpuFallbackEnabledElement.image)
        return;
      let [n, r] = canvasToPixel_default(this._cpuFallbackEnabledElement, e13), { origin: a, spacing: o, direction: s } = this.getImageData(), c = s.slice(0, 3), l = s.slice(3, 6);
      return scaleAndAdd(t, a, c, n * o[0]), scaleAndAdd(t, t, l, r * o[1]), t;
    }, this.worldToCanvasCPU = (e13) => {
      let { spacing: t, direction: n, origin: r } = this.getImageData(), a = n.slice(0, 3), o = n.slice(3, 6), s = subtract$3(create$4(), e13, r), c = [dot$3(s, a) / t[0], dot$3(s, o) / t[1]];
      return pixelToCanvas_default(this._cpuFallbackEnabledElement, c);
    }, this.canvasToWorldGPUContextPool = (e13) => {
      let t = this.getRenderer(), n = this.getVtkActiveCamera(), r = n.getClippingRange(), a = n.getDistance();
      n.setClippingRange(a, a + 0.1);
      let o = window.devicePixelRatio || 1, { width: s, height: c } = this.canvas, l = s / c, u = [e13[0] * o, e13[1] * o], [d, f, p, m] = t.getViewport(), h = p - d, g = m - f, _ = [
        d + u[0] / s * h,
        f + (1 - u[1] / c) * g,
        0
      ], v = t.normalizedDisplayToProjection(_[0], _[1], _[2]), y = t.projectionToView(v[0], v[1], v[2], l), b = t.viewToWorld(y[0], y[1], y[2]);
      return n.setClippingRange(r[0], r[1]), [
        b[0],
        b[1],
        b[2]
      ];
    }, this.canvasToWorldGPUTiled = (e13) => {
      let t = this.getRenderer(), n = this.getVtkActiveCamera(), r = n.getClippingRange(), a = n.getDistance();
      n.setClippingRange(a, a + 0.1);
      let o = this.getRenderingEngine().offscreenMultiRenderWindow.getOpenGLRenderWindow(), s = o.getSize(), c = window.devicePixelRatio || 1, l = [e13[0] * c, e13[1] * c], u = [l[0] + this.sx, l[1] + this.sy];
      u[1] = s[1] - u[1];
      let d = o.displayToWorld(u[0], u[1], 0, t);
      return n.setClippingRange(r[0], r[1]), [
        d[0],
        d[1],
        d[2]
      ];
    }, this.worldToCanvasGPUContextPool = (e13) => {
      let t = this.getRenderer(), n = this.getVtkActiveCamera(), r = n.getClippingRange(), a = n.getDistance();
      n.setClippingRange(a, a + 0.1);
      let o = window.devicePixelRatio || 1, { width: s, height: c } = this.canvas, l = s / c, u = t.worldToView(e13[0], e13[1], e13[2]), d = t.viewToProjection(u[0], u[1], u[2], l), f = t.projectionToNormalizedDisplay(d[0], d[1], d[2]), [p, m, h, g] = t.getViewport(), _ = h - p, v = g - m, y = (f[0] - p) / _ * s, b = (1 - (f[1] - m) / v) * c;
      return n.setClippingRange(r[0], r[1]), [y / o, b / o];
    }, this.worldToCanvasGPUTiled = (e13) => {
      let t = this.getRenderer(), n = this.getVtkActiveCamera(), r = n.getClippingRange(), a = n.getDistance();
      n.setClippingRange(a, a + 0.1);
      let o = this.getRenderingEngine().offscreenMultiRenderWindow.getOpenGLRenderWindow(), s = o.getSize(), c = o.worldToDisplay(...e13, t);
      c[1] = s[1] - c[1];
      let l = [c[0] - this.sx, c[1] - this.sy];
      n.setClippingRange(r[0], r[1]);
      let u = window.devicePixelRatio || 1;
      return [l[0] / u, l[1] / u];
    }, this.getCurrentImageIdIndex = () => this.currentImageIdIndex, this.getSliceIndex = () => this.currentImageIdIndex, this.getTargetImageIdIndex = () => this.targetImageIdIndex, this.getImageIds = () => this.imageIds, this.getCurrentImageId = (e13 = this.getCurrentImageIdIndex()) => this.imageIds[e13], this.hasImageId = (e13) => this.imageKeyToIndexMap.has(e13), this.hasImageURI = (e13) => this.imageKeyToIndexMap.has(e13), this.customRenderViewportToCanvas = () => {
      if (!this.useCPURendering)
        throw Error("Custom cpu rendering pipeline should only be hit in CPU rendering mode");
      return this._cpuFallbackEnabledElement.image ? (drawImageSync_default(this._cpuFallbackEnabledElement, this.cpuRenderingInvalidated), this.cpuRenderingInvalidated = false) : this.fillWithBackgroundColor(), {
        canvas: this.canvas,
        element: this.element,
        viewportId: this.id,
        renderingEngineId: this.renderingEngineId,
        viewportStatus: this.viewportStatus
      };
    }, this.renderingPipelineFunctions = {
      getImageData: {
        cpu: this.getImageDataCPU,
        gpu: this.getImageDataGPU
      },
      setColormap: {
        cpu: this.setColormapCPU,
        gpu: this.setColormapGPU
      },
      getCamera: {
        cpu: this.getCameraCPU,
        gpu: super.getCamera
      },
      setCamera: {
        cpu: this.setCameraCPU,
        gpu: super.setCamera
      },
      getPan: {
        cpu: this.getPanCPU,
        gpu: super.getPan
      },
      setPan: {
        cpu: this.setPanCPU,
        gpu: super.setPan
      },
      getZoom: {
        cpu: this.getZoomCPU,
        gpu: super.getZoom
      },
      setZoom: {
        cpu: this.setZoomCPU,
        gpu: super.setZoom
      },
      getAspectRatio: {
        cpu: this.getAspectRatioCPU,
        gpu: super.getAspectRatio
      },
      setAspectRatio: {
        cpu: this.setAspectRatioCPU,
        gpu: super.setAspectRatio
      },
      setVOI: {
        cpu: this.setVOICPU,
        gpu: this.setVOIGPU
      },
      getRotation: {
        cpu: this.getRotationCPU,
        gpu: this.getRotationGPU
      },
      setInterpolationType: {
        cpu: this.setInterpolationTypeCPU,
        gpu: this.setInterpolationTypeGPU
      },
      setInvertColor: {
        cpu: this.setInvertColorCPU,
        gpu: this.setInvertColorGPU
      },
      resetCamera: {
        cpu: (e13 = {}) => {
          let { resetPan: t = true, resetZoom: n = true } = e13;
          return this.resetCameraCPU({
            resetPan: t,
            resetZoom: n
          }), true;
        },
        gpu: (e13 = {}) => {
          let { resetPan: t = true, resetZoom: n = true, resetAspectRatio: r = true } = e13;
          return this.resetCameraGPU({
            resetPan: t,
            resetZoom: n,
            resetAspectRatio: r
          }), true;
        }
      },
      canvasToWorld: {
        cpu: this.canvasToWorldCPU,
        gpu: {
          tiled: this.canvasToWorldGPUTiled,
          contextPool: this.canvasToWorldGPUContextPool
        }
      },
      worldToCanvas: {
        cpu: this.worldToCanvasCPU,
        gpu: {
          tiled: this.worldToCanvasGPUTiled,
          contextPool: this.worldToCanvasGPUContextPool
        }
      },
      getRenderer: {
        cpu: () => this.getCPUFallbackError("getRenderer"),
        gpu: {
          tiled: this.getRendererTiled,
          contextPool: this.getRendererContextPool
        }
      },
      getDefaultActor: {
        cpu: () => this.getCPUFallbackError("getDefaultActor"),
        gpu: super.getDefaultActor
      },
      getActors: {
        cpu: () => this.getCPUFallbackError("getActors"),
        gpu: super.getActors
      },
      getActor: {
        cpu: () => this.getCPUFallbackError("getActor"),
        gpu: super.getActor
      },
      setActors: {
        cpu: () => this.getCPUFallbackError("setActors"),
        gpu: super.setActors
      },
      addActors: {
        cpu: () => this.getCPUFallbackError("addActors"),
        gpu: super.addActors
      },
      addActor: {
        cpu: () => this.getCPUFallbackError("addActor"),
        gpu: super.addActor
      },
      removeAllActors: {
        cpu: () => this.getCPUFallbackError("removeAllActors"),
        gpu: super.removeAllActors
      },
      unsetColormap: {
        cpu: this.unsetColormapCPU,
        gpu: this.unsetColormapGPU
      }
    }, this.scaling = {}, this.modality = null, this.useCPURendering = getShouldUseCPURendering(), this._configureRenderingPipeline(), this.useCPURendering ? this._resetCPUFallbackElement() : this._resetGPUViewport(), this.currentImageIdIndex = 0, this.targetImageIdIndex = 0, this.resetCamera(), this.initializeElementDisabledHandler();
  }
  setUseCPURendering(e12) {
    this.useCPURendering = e12, this._configureRenderingPipeline(e12);
  }
  static get useCustomRenderingPipeline() {
    return getShouldUseCPURendering();
  }
  _configureRenderingPipeline(e12) {
    let t = isContextPoolRenderingEngine();
    for (let n in this.useCPURendering = e12 ?? getShouldUseCPURendering(), this.renderingPipelineFunctions)
      if (Object.prototype.hasOwnProperty.call(this.renderingPipelineFunctions, n)) {
        let e13 = this.renderingPipelineFunctions[n];
        this.useCPURendering ? this[n] = e13.cpu : typeof e13.gpu == "object" && e13.gpu.tiled && e13.gpu.contextPool ? this[n] = t ? e13.gpu.contextPool : e13.gpu.tiled : this[n] = e13.gpu;
      }
    this.useCPURendering ? this._resetCPUFallbackElement() : this._resetGPUViewport();
  }
  _resetCPUFallbackElement() {
    this._cpuFallbackEnabledElement = {
      canvas: this.canvas,
      renderingTools: {},
      transform: new Transform(),
      viewport: {
        rotation: 0,
        aspectRatio: [1, 1]
      }
    };
  }
  _resetGPUViewport() {
    let e12 = this.getRenderer(), t = extendedVtkCamera_default.newInstance();
    e12.setActiveCamera(t);
    let n = [
      0,
      0,
      -1
    ];
    this.initialViewUp = [
      0,
      -1,
      0
    ], t.setDirectionOfProjection(-n[0], -n[1], -n[2]), t.setViewUp(...this.initialViewUp), t.setParallelProjection(true), t.setThicknessFromFocalPoint(0.1), t.setFreezeFocalPoint(true);
  }
  shouldUseCustomRenderPass() {
    return !this.useCPURendering;
  }
  initializeElementDisabledHandler() {
    eventTarget_default.addEventListener(Events_default.ELEMENT_DISABLED, function e12() {
      clearTimeout(this.debouncedTimeout), eventTarget_default.removeEventListener(Events_default.ELEMENT_DISABLED, e12);
    });
  }
  getImageDataGPU() {
    let e12 = this.getDefaultActor();
    if (!e12 || !isImageActor(e12))
      return;
    let { actor: t } = e12, n = t.getMapper().getInputData(), r = this.csImage;
    return {
      dimensions: n.getDimensions(),
      spacing: n.getSpacing(),
      origin: n.getOrigin(),
      direction: n.getDirection(),
      get scalarData() {
        return r?.voxelManager.getScalarData();
      },
      imageData: t.getMapper().getInputData(),
      metadata: {
        Modality: this.modality,
        FrameOfReferenceUID: this.getFrameOfReferenceUID()
      },
      scaling: this.scaling,
      hasPixelSpacing: this.hasPixelSpacing,
      calibration: {
        ...r?.calibration,
        ...this.calibration
      },
      preScale: { ...r?.preScale },
      voxelManager: r?.voxelManager
    };
  }
  getImageDataCPU() {
    let { metadata: e12 } = this._cpuFallbackEnabledElement;
    if (!e12)
      return;
    let t = e12.spacing, n = this.csImage;
    return {
      dimensions: e12.dimensions,
      spacing: t,
      origin: e12.origin,
      direction: e12.direction,
      metadata: {
        Modality: this.modality,
        FrameOfReferenceUID: this.getFrameOfReferenceUID()
      },
      scaling: this.scaling,
      imageData: {
        getDirection: () => e12.direction,
        getDimensions: () => e12.dimensions,
        getScalarData: () => this.cpuImagePixelData,
        getSpacing: () => t,
        worldToIndex: (e13) => {
          let t2 = this.worldToCanvasCPU(e13), n2 = canvasToPixel_default(this._cpuFallbackEnabledElement, t2);
          return [
            n2[0],
            n2[1],
            0
          ];
        },
        indexToWorld: (e13, t2) => {
          let n2 = pixelToCanvas_default(this._cpuFallbackEnabledElement, [e13[0], e13[1]]);
          return this.canvasToWorldCPU(n2, t2);
        }
      },
      scalarData: this.cpuImagePixelData,
      hasPixelSpacing: this.hasPixelSpacing,
      calibration: {
        ...n?.calibration,
        ...this.calibration
      },
      preScale: { ...n?.preScale },
      voxelManager: n?.voxelManager
    };
  }
  calibrateIfNecessary(e12, t) {
    let n = getMetaData("calibratedPixelSpacing", e12), r = this.calibration !== n, a = n?.scale;
    return this.hasPixelSpacing = a > 0 || !t.usingDefaultValues && t.rowPixelSpacing > 0, t.calibration = n, r ? (this.calibration = n, this._publishCalibratedEvent = true, this._calibrationEvent = {
      scale: a,
      calibration: n
    }, t) : t;
  }
  setDefaultProperties(e12, t) {
    t == null ? this.globalDefaultProperties = e12 : (this.perImageIdDefaultProperties.set(t, e12), this.getCurrentImageId() === t && this.setProperties(e12));
  }
  clearDefaultProperties(e12) {
    e12 == null ? (this.globalDefaultProperties = {}, this.resetProperties()) : (this.perImageIdDefaultProperties.delete(e12), this.resetToDefaultProperties());
  }
  setProperties({ colormap: e12, voiRange: t, VOILUTFunction: n, invert: r, interpolationType: a, sharpening: o, smoothing: s } = {}, c = false) {
    this.viewportStatus = this.csImage ? ViewportStatus_default.PRE_RENDER : ViewportStatus_default.LOADING, this.globalDefaultProperties = {
      colormap: this.globalDefaultProperties.colormap ?? e12,
      voiRange: this.globalDefaultProperties.voiRange ?? t,
      VOILUTFunction: this.globalDefaultProperties.VOILUTFunction ?? n,
      invert: this.globalDefaultProperties.invert ?? r,
      interpolationType: this.globalDefaultProperties.interpolationType ?? a,
      sharpening: this.globalDefaultProperties.sharpening ?? o,
      smoothing: this.globalDefaultProperties.smoothing ?? s
    }, e12 !== void 0 && this.setColormap(e12), t !== void 0 && this.setVOI(t, {
      suppressEvents: c,
      voiUpdatedWithSetProperties: true
    }), n !== void 0 && this.setVOILUTFunction(n, c), r !== void 0 && this.setInvertColor(r), a !== void 0 && this.setInterpolationType(a), o !== void 0 && this.setSharpening(o), s !== void 0 && this.setSmoothing(s);
  }
  resetProperties() {
    this.cpuRenderingInvalidated = true, this.voiUpdatedWithSetProperties = false, this.viewportStatus = ViewportStatus_default.PRE_RENDER, this.fillWithBackgroundColor(), this.useCPURendering && (this._cpuFallbackEnabledElement.renderingTools = {}), this._resetProperties(), this.render();
  }
  _resetProperties() {
    let e12;
    if (e12 = this._isCurrentImagePTPrescaled() ? this._getDefaultPTPrescaledVOIRange() : this._getVOIRangeForCurrentImage(), this.setVOI(e12), this.setInvertColor(this.initialInvert), this.setInterpolationType(InterpolationType_default.LINEAR), !this.useCPURendering) {
      let e13 = this.getTransferFunction();
      setTransferFunctionNodes(e13, this.initialTransferFunctionNodes);
      let t = findMatchingColormap(getTransferFunctionNodes(e13).reduce((e14, t2) => (e14.push(t2[0], t2[1], t2[2], t2[3]), e14), []), this.getDefaultActor().actor);
      this.setColormap(t);
    }
  }
  resetToDefaultProperties() {
    this.cpuRenderingInvalidated = true, this.viewportStatus = ViewportStatus_default.PRE_RENDER, this.fillWithBackgroundColor(), this.useCPURendering && (this._cpuFallbackEnabledElement.renderingTools = {});
    let e12 = this.getCurrentImageId(), t = this.perImageIdDefaultProperties.get(e12) || this.globalDefaultProperties;
    t.colormap?.name && this.setColormap(t.colormap);
    let n;
    n = t.voiRange == null ? this._getVOIRangeForCurrentImage() : t.voiRange, this.setVOI(n), this.setInterpolationType(InterpolationType_default.LINEAR), this.setInvertColor(false), this.render();
  }
  _getVOIFromCache() {
    let e12;
    return e12 = this.voiUpdatedWithSetProperties ? this.voiRange : this._isCurrentImagePTPrescaled() ? this._getDefaultPTPrescaledVOIRange() : this._getVOIRangeForCurrentImage() ?? this.voiRange, e12;
  }
  _setPropertiesFromCache() {
    let e12 = this._getVOIFromCache(), { interpolationType: t, invert: n } = this;
    this.setVOI(e12), this.setInterpolationType(t), this.setInvertColor(n);
  }
  getCameraCPU() {
    let { metadata: e12, viewport: t } = this._cpuFallbackEnabledElement;
    if (!e12)
      return {};
    let { direction: n } = e12, r = n.slice(6, 9).map((e13) => -e13), a = n.slice(3, 6).map((e13) => -e13);
    if (t.rotation) {
      let e13 = fromRotation(create$5(), t.rotation * Math.PI / 180, r);
      a = transformMat4$1(create$4(), a, e13);
    }
    let o = [this.element.clientWidth / 2, this.element.clientHeight / 2];
    return {
      parallelProjection: true,
      focalPoint: this.canvasToWorld(o),
      position: [
        0,
        0,
        0
      ],
      parallelScale: distance(this.canvasToWorld([0, 0]), this.canvasToWorld([0, this.element.clientHeight])) / 2,
      scale: t.scale,
      viewPlaneNormal: [
        r[0],
        r[1],
        r[2]
      ],
      aspectRatio: t.aspectRatio ?? [1, 1],
      viewUp: [
        a[0],
        a[1],
        a[2]
      ],
      flipHorizontal: this.flipHorizontal,
      flipVertical: this.flipVertical
    };
  }
  setAspectRatioForViewport(e12, t = true) {
    let { viewport: n, image: r } = this._cpuFallbackEnabledElement;
    if (!t) {
      n.aspectRatio = e12;
      return;
    }
    let { clientWidth: a, clientHeight: o } = this.element, { rowPixelSpacing: s, columnPixelSpacing: c, width: l, height: u } = r, d = ([e13, t2]) => e13 / t2, f = d(n.aspectRatio || [1, 1]), p = d(e12), m = a / o, h = o * s * 0.5, g = (e13) => {
      let t2 = l * c * e13, n2 = u * s;
      if (t2 / n2 > m)
        return h / (a / t2);
      let r2 = n2 * 0.5;
      return e13 < 1 ? r2 / e13 : r2;
    }, _ = g(p) / g(f);
    n.aspectRatio = e12, n.parallelScale && (n.parallelScale *= _, n.scale = h / n.parallelScale);
  }
  setCameraCPU(e12) {
    let { viewport: t, image: n } = this._cpuFallbackEnabledElement, r = this.getCameraCPU(), { focalPoint: o, parallelScale: s, scale: c, flipHorizontal: l, flipVertical: u, aspectRatio: d, isFitViewportAfterStretch: f } = e12, { clientHeight: p } = this.element;
    if (o) {
      let e13 = this.worldToCanvasCPU(o), n2 = canvasToPixel_default(this._cpuFallbackEnabledElement, e13), a = this.worldToCanvasCPU(r.focalPoint), s2 = canvasToPixel_default(this._cpuFallbackEnabledElement, a), c2 = create$1();
      subtract$1(c2, fromValues(n2[0], n2[1]), fromValues(s2[0], s2[1]));
      let l2 = correctShift_default({
        x: c2[0],
        y: c2[1]
      }, t);
      t.translation.x -= l2.x, t.translation.y -= l2.y;
    }
    if (s) {
      let { rowPixelSpacing: e13 } = n;
      t.scale = p * e13 * 0.5 / s, t.parallelScale = s;
    }
    if (c) {
      let { rowPixelSpacing: e13 } = n;
      t.scale = c, t.parallelScale = p * e13 * 0.5 / c;
    }
    d && this.setAspectRatioForViewport(d, f), (l !== void 0 || u !== void 0) && this.setFlipCPU({
      flipHorizontal: l,
      flipVertical: u
    }), this._cpuFallbackEnabledElement.transform = calculateTransform_default(this._cpuFallbackEnabledElement);
    let m = {
      previousCamera: r,
      camera: this.getCamera(),
      element: this.element,
      viewportId: this.id,
      renderingEngineId: this.renderingEngineId
    };
    triggerEvent(this.element, Events_default.CAMERA_MODIFIED, m);
  }
  getPanCPU() {
    let { viewport: e12 } = this._cpuFallbackEnabledElement;
    return [e12.translation?.x ?? 0, e12.translation?.y ?? 0];
  }
  setPanCPU(e12) {
    let t = this.getCameraCPU();
    this.setCameraCPU({
      ...t,
      focalPoint: [...e12.map((e13) => -e13), 0]
    });
  }
  getZoomCPU() {
    let { viewport: e12 } = this._cpuFallbackEnabledElement;
    return e12.scale;
  }
  setZoomCPU(e12) {
    let t = this.getCameraCPU();
    this.setCameraCPU({
      ...t,
      scale: e12
    });
  }
  getAspectRatioCPU() {
    let { aspectRatio: e12 } = this.getCameraCPU();
    return e12 ?? this.options?.aspectRatio ?? [1, 1];
  }
  setAspectRatioCPU(e12, t = true, n = false) {
    let r = this.getCameraCPU();
    n && (this.options.aspectRatio = e12), this.setCameraCPU({
      ...r,
      aspectRatio: e12,
      isFitViewportAfterStretch: t
    });
  }
  setFlipCPU({ flipHorizontal: e12, flipVertical: t }) {
    let { viewport: n } = this._cpuFallbackEnabledElement;
    e12 !== void 0 && (n.hflip = e12, this.flipHorizontal = n.hflip), t !== void 0 && (n.vflip = t, this.flipVertical = n.vflip);
  }
  setVOILUTFunction(e12, t) {
    if (this.useCPURendering)
      throw Error("VOI LUT function is not supported in CPU rendering");
    let n = this._getValidVOILUTFunction(e12), r = false;
    this.VOILUTFunction !== n && (r = true), this.VOILUTFunction = n;
    let { voiRange: a } = this.getProperties();
    this.setVOI(a, {
      suppressEvents: t,
      forceRecreateLUTFunction: r
    });
  }
  setRotationCPU(e12) {
    let { viewport: t } = this._cpuFallbackEnabledElement;
    t.rotation = e12;
  }
  setRotationGPU(e12) {
    let t = this.getPan(this.fitToCanvasCamera), n = sub([0, 0], t, this.getPan());
    this.setPan(n, false);
    let { flipVertical: r, flipHorizontal: a, viewPlaneNormal: o } = this.getCamera(), s = adjustInitialViewUp(this.initialViewUp, a, r, o);
    this.setCameraNoEvent({ viewUp: s }), this.getVtkActiveCamera().roll(-e12);
    let c = add$1([0, 0], t, sub([0, 0], this.getPan(), this.getPan(this.fitToCanvasCamera)));
    this.setPan(c, false);
  }
  setInterpolationTypeGPU(e12) {
    let t = this.getDefaultActor();
    if (!t || !isImageActor(t))
      return;
    let { actor: n } = t;
    n.getProperty().setInterpolationType(e12), this.interpolationType = e12;
  }
  setInterpolationTypeCPU(e12) {
    let { viewport: t } = this._cpuFallbackEnabledElement;
    t.pixelReplication = e12 !== InterpolationType_default.LINEAR, this.interpolationType = e12;
  }
  setInvertColorCPU(e12) {
    let { viewport: t } = this._cpuFallbackEnabledElement;
    t && (t.invert = e12, this.invert = e12);
  }
  setInvertColorGPU(e12) {
    let t = this.getDefaultActor();
    if (t && isImageActor(t)) {
      if (actorIsA(t, "vtkVolume")) {
        let n = t.actor.getProperty().getRGBTransferFunction(0);
        (!this.invert && e12 || this.invert && !e12) && invertRgbTransferFunction(n), this.invert = e12;
      } else if (actorIsA(t, "vtkImageSlice")) {
        let n = t.actor.getProperty().getRGBTransferFunction(0);
        (!this.invert && e12 || this.invert && !e12) && invertRgbTransferFunction(n), this.invert = e12;
      }
    }
  }
  setVOICPU(e12, t = {}) {
    let { suppressEvents: n = false } = t, { viewport: r, image: o } = this._cpuFallbackEnabledElement;
    if (!r || !o)
      return;
    if (e12 === void 0) {
      let { windowWidth: t2, windowCenter: n2 } = o, a = Array.isArray(t2) ? t2[0] : t2, s2 = Array.isArray(n2) ? n2[0] : n2;
      r.voi = {
        windowWidth: a,
        windowCenter: s2,
        voiLUTFunction: o.voiLUTFunction
      };
      let { lower: c, upper: l } = toLowHighRange(a, s2, o.voiLUTFunction);
      e12 = {
        lower: c,
        upper: l
      };
    } else {
      let { lower: t2, upper: n2 } = e12, { windowCenter: a, windowWidth: s2 } = toWindowLevel(t2, n2);
      r.voi ||= {
        windowWidth: 0,
        windowCenter: 0,
        voiLUTFunction: o.voiLUTFunction
      }, r.voi.windowWidth = s2, r.voi.windowCenter = a;
    }
    this.voiRange = e12;
    let s = {
      viewportId: this.id,
      range: e12
    };
    n || triggerEvent(this.element, Events_default.VOI_MODIFIED, s);
  }
  getTransferFunction() {
    let e12 = this.getDefaultActor();
    if (e12 && isImageActor(e12))
      return e12.actor.getProperty().getRGBTransferFunction(0);
  }
  setVOIGPU(e12, t = {}) {
    let { suppressEvents: n = false, forceRecreateLUTFunction: r = false, voiUpdatedWithSetProperties: o = false } = t;
    if (e12 && this.voiRange && this.voiRange.lower === e12.lower && this.voiRange.upper === e12.upper && !r && !this.stackInvalidated)
      return;
    let s = this.getDefaultActor();
    if (!s || !isImageActor(s))
      return;
    let c = s.actor, l = e12;
    if (l === void 0) {
      let e13 = c.getMapper().getInputData().getPointData().getScalars().getRange();
      l = {
        lower: e13[0],
        upper: e13[1]
      };
    }
    c.getProperty().setUseLookupTableScalarRange(true);
    let u = c.getProperty().getRGBTransferFunction(0), d = this.VOILUTFunction === VOILUTFunctionType_default.SAMPLED_SIGMOID;
    if ((d || !u || r) && (u = (d ? createSigmoidRGBTransferFunction : createLinearRGBTransferFunction)(l), this.invert && invertRgbTransferFunction(u), c.getProperty().setRGBTransferFunction(0, u), this.initialTransferFunctionNodes = getTransferFunctionNodes(u)), d || u.setRange(l.lower, l.upper), this.voiRange = l, this.voiUpdatedWithSetProperties ||= o, n)
      return;
    let f = {
      viewportId: this.id,
      range: l,
      VOILUTFunction: this.VOILUTFunction
    };
    triggerEvent(this.element, Events_default.VOI_MODIFIED, f);
  }
  _addScalingToViewport(e12) {
    if (this.scaling.PT)
      return;
    let { suvbw: t, suvlbm: n, suvbsa: r } = e12, a = {};
    n && (a.suvbwToSuvlbm = n / t), r && (a.suvbwToSuvbsa = r / t), this.scaling.PT = a;
  }
  getImageDataMetadata(e12) {
    let t = e12.imageId, { numberOfComponents: n, origin: r, direction: a, dimensions: o, spacing: s, numVoxels: c, imagePixelModule: l, voiLUTFunction: u, modality: d, scalingFactor: f, calibration: p } = getImageDataMetadata(e12);
    d === "PT" && f && this._addScalingToViewport(f), this.modality = d, this.VOILUTFunction = this._getValidVOILUTFunction(u), this.calibration = p;
    let m = this._getImagePlaneModule(t);
    return this.useCPURendering || (m = this.calibrateIfNecessary(t, m)), {
      bitsAllocated: l.bitsAllocated,
      numberOfComponents: n,
      origin: r,
      direction: a,
      dimensions: o,
      spacing: s,
      numVoxels: c,
      imagePlaneModule: m,
      imagePixelModule: l
    };
  }
  matchImagesForOverlay(e12, t) {
    return ((e13) => {
      let n = getMetaData(MetadataModules_default.IMAGE_PLANE, t), r = getMetaData(MetadataModules_default.IMAGE_PLANE, e13), a = n.imageOrientationPatient, o = r.imageOrientationPatient;
      if (a && o) {
        if (isEqual(n.imageOrientationPatient, r.imageOrientationPatient)) {
          let t2 = n.imagePositionPatient, a2 = r.imagePositionPatient;
          if (t2 && a2 && isEqual(t2, a2)) {
            let t3 = n.rows, a3 = n.columns, o2 = r.rows, s = r.columns;
            if (t3 === o2 && a3 === s)
              return e13;
          }
        }
      } else {
        let t2 = n.rows, a2 = n.columns, o2 = r.rows, s = r.columns;
        if (t2 === o2 && a2 === s)
          return e13;
      }
    })(e12);
  }
  getImagePlaneReferenceData(e12 = this.getCurrentImageIdIndex()) {
    let t = this.imageIds[e12];
    if (!t)
      return;
    let n = getMetaData(MetadataModules_default.IMAGE_PLANE, t);
    if (!n)
      return;
    let { imagePositionPatient: r, frameOfReferenceUID: a } = n, { rowCosines: o, columnCosines: s } = n;
    return o ||= [
      1,
      0,
      0
    ], s ||= [
      0,
      1,
      0
    ], {
      FrameOfReferenceUID: a,
      viewPlaneNormal: cross$1([
        0,
        0,
        0
      ], s, o),
      cameraFocalPoint: r,
      referencedImageId: t,
      sliceIndex: e12
    };
  }
  _getCameraOrientation(e12) {
    let t = e12.slice(6, 9).map((e13) => -e13), n = e12.slice(3, 6).map((e13) => -e13);
    return {
      viewPlaneNormal: [
        t[0],
        t[1],
        t[2]
      ],
      viewUp: [
        n[0],
        n[1],
        n[2]
      ]
    };
  }
  createVTKImageData({ origin: e12, direction: t, dimensions: n, spacing: r, numberOfComponents: a, pixelArray: o }) {
    let s = new o.constructor(o.length), c = vtkDataArray$1.newInstance({
      name: "Pixels",
      numberOfComponents: a,
      values: s
    }), l = vtkImageData$1.newInstance();
    return l.setDimensions(n), l.setSpacing(r), l.setDirection(t), l.setOrigin(e12), l.getPointData().setScalars(c), l;
  }
  _createVTKImageData({ origin: e12, direction: t, dimensions: n, spacing: r, numberOfComponents: a, pixelArray: o }) {
    try {
      this._imageData = this.createVTKImageData({
        origin: e12,
        direction: t,
        dimensions: n,
        spacing: r,
        numberOfComponents: a,
        pixelArray: o
      });
    } catch (e13) {
      log.error(e13);
    }
  }
  async setStack(e12, t = 0) {
    if (this._throwIfDestroyed(), this.imageIds = e12, t > e12.length)
      throw Error("Current image index is greater than the number of images in the stack");
    this.imageKeyToIndexMap.clear(), e12.forEach((e13, t2) => {
      this.imageKeyToIndexMap.set(e13, t2), this.imageKeyToIndexMap.set(imageIdToURI(e13), t2);
    }), this.currentImageIdIndex = t, this.targetImageIdIndex = t;
    let n = getMetaData(imageRetrieveMetadataProvider_default.IMAGE_RETRIEVE_CONFIGURATION, e12[t], "stack");
    this.imagesLoader = n ? (n.create || createProgressive)(n) : this, this.stackInvalidated = true, this.flipVertical = false, this.flipHorizontal = false, this.voiRange = null, this.interpolationType = InterpolationType_default.LINEAR, this.invert = false, this.viewportStatus = ViewportStatus_default.LOADING, this.fillWithBackgroundColor(), this.useCPURendering && (this._cpuFallbackEnabledElement.renderingTools = {}, delete this._cpuFallbackEnabledElement.viewport.colormap);
    let r = await this._setImageIdIndex(t), o = {
      imageIds: e12,
      viewportId: this.id,
      element: this.element,
      currentImageIdIndex: t
    };
    return triggerEvent(this.element, Events_default.VIEWPORT_NEW_IMAGE_SET, o), r;
  }
  _throwIfDestroyed() {
    if (this.isDisabled)
      throw Error("The stack viewport has been destroyed and is no longer usable. Renderings will not be performed. If you are using the same viewportId and have re-enabled the viewport, you need to grab the new viewport instance using renderingEngine.getViewport(viewportId), instead of using your lexical scoped reference to the viewport instance.");
  }
  _checkVTKImageDataMatchesCornerstoneImage(e12, t) {
    if (!t)
      return false;
    let [n, r] = t.getSpacing(), [a, o] = t.getDimensions(), s = this._getImagePlaneModule(e12.imageId), c = t.getDirection(), l = c.slice(0, 3), u = c.slice(3, 6), d = t.getPointData().getScalars().getDataType(), f = isEqual(n, e12.columnPixelSpacing), p = isEqual(r, e12.rowPixelSpacing), m = f || e12.columnPixelSpacing === null && n === 1, h = p || e12.rowPixelSpacing === null && r === 1, g = a === e12.columns, _ = o === e12.rows, v = isEqual(s.rowCosines, l), y = isEqual(s.columnCosines, u), b = d === e12.voxelManager.getScalarData().constructor.name;
    return m && h && g && _ && v && y && b;
  }
  _updateVTKImageDataFromCornerstoneImage(e12) {
    let t = this._getImagePlaneModule(e12.imageId).imagePositionPatient;
    t ??= [
      0,
      0,
      0
    ], this._imageData.setOrigin(t);
    let n = this.getActor(this.id);
    n && (n.referencedId = e12.imageId), updateVTKImageDataWithCornerstoneImage(this._imageData, e12);
  }
  _loadAndDisplayImage(e12, t) {
    return this.useCPURendering ? this._loadAndDisplayImageCPU(e12, t) : this._loadAndDisplayImageGPU(e12, t);
  }
  _loadAndDisplayImageCPU(e12, t) {
    return new Promise((n, r) => {
      function o(e13, t2, r2) {
        if (this.currentImageIdIndex !== t2)
          return;
        let o2 = e13.voxelManager.getScalarData(), s = e13.preScale, c2 = s?.scalingParameters, l2 = s?.scaled && c2?.rescaleIntercept % 1 != 0 || c2?.rescaleSlope % 1 != 0;
        if (o2 instanceof Float32Array && l2) {
          let t3 = {
            min: e13.minPixelValue,
            max: e13.maxPixelValue
          }, n2 = Math.abs(t3.max - t3.min) / 65535, r3 = t3.min, a = o2.length, s2 = new Uint16Array(a), c3 = 65535, l3 = 0;
          for (let e14 = 0; e14 < a; e14++) {
            let t4 = Math.floor((o2[e14] - r3) / n2);
            s2[e14] = t4, c3 = Math.min(c3, t4), l3 = Math.max(l3, t4);
          }
          e13.minPixelValue = c3, e13.maxPixelValue = l3, e13.slope = n2, e13.intercept = r3, e13.voxelManager ? e13.voxelManager.getScalarData = () => s2 : e13.getPixelData = () => s2, e13.preScale = {
            ...e13.preScale,
            scaled: false
          };
        }
        this._setCSImage(e13), this.viewportStatus = ViewportStatus_default.PRE_RENDER;
        let u2 = {
          image: e13,
          imageId: r2,
          imageIdIndex: t2,
          viewportId: this.id,
          renderingEngineId: this.renderingEngineId
        };
        triggerEvent(this.element, Events_default.STACK_NEW_IMAGE, u2), this._updateToDisplayImageCPU(e13), this.render(), this.currentImageIdIndex = t2, n(r2);
      }
      function c(e13, t2, n2) {
        let o2 = {
          error: e13,
          imageIdIndex: t2,
          imageId: n2
        };
        this.suppressEvents || triggerEvent(eventTarget_default, Events_default.IMAGE_LOAD_ERROR, o2), r(e13);
      }
      function l(e13, t2, n2) {
        return loadAndCacheImage(e13, n2).then((n3) => {
          o.call(this, n3, t2, e13);
        }, (n3) => {
          c.call(this, n3, t2, e13);
        });
      }
      let u = RequestType_default.Interaction, d = {
        imageId: e12,
        imageIdIndex: t
      }, f = {
        useRGBA: true,
        requestType: u
      }, p = {
        imageId: e12,
        imageIdIndex: t,
        viewportId: this.id,
        renderingEngineId: this.renderingEngineId
      };
      triggerEvent(this.element, Events_default.PRE_STACK_NEW_IMAGE, p), imageLoadPoolManager_default.addRequest(l.bind(this, e12, t, f), u, d, -5);
    });
  }
  successCallback(e12, t) {
    let n = this.imageIds.indexOf(e12);
    if (this.currentImageIdIndex !== n)
      return;
    let r = this.csImage?.imageFrame, o = t?.imageFrame;
    (r?.photometricInterpretation || this.csImage?.photometricInterpretation) !== (o?.photometricInterpretation || t?.photometricInterpretation) && (this.stackInvalidated = true), this._setCSImage(t);
    let s = {
      image: t,
      imageId: e12,
      imageIdIndex: n,
      viewportId: this.id,
      renderingEngineId: this.renderingEngineId
    };
    this._updateActorToDisplayImageId(t), triggerEvent(this.element, Events_default.STACK_NEW_IMAGE, s), this.render(), this.currentImageIdIndex = n;
  }
  errorCallback(e12, t, n) {
    if (!t)
      return;
    let r = {
      error: n,
      imageIdIndex: this.imageIds.indexOf(e12),
      imageId: e12
    };
    triggerEvent(eventTarget_default, Events_default.IMAGE_LOAD_ERROR, r);
  }
  getLoaderImageOptions(e12) {
    let t = this.imageIds.indexOf(e12), { transferSyntaxUID: n } = getMetaData("transferSyntax", e12) || {};
    return {
      useRGBA: false,
      transferSyntaxUID: n,
      priority: 5,
      requestType: RequestType_default.Interaction,
      additionalDetails: {
        imageId: e12,
        imageIdIndex: t
      }
    };
  }
  async loadImages(e12, t) {
    let n = await Promise.allSettled(e12.map((e13) => loadAndCacheImage(e13, this.getLoaderImageOptions(e13)).then((n2) => (t.successCallback(e13, n2), e13), (n2) => (t.errorCallback(e13, true, n2), e13)))), r = n.filter((e13) => e13.status === "rejected");
    if (r && r.length) {
      let e13 = new CustomEvent(Events_default.IMAGE_LOAD_ERROR, {
        detail: r,
        cancelable: true
      });
      eventTarget_default.dispatchEvent(e13);
    }
    return n;
  }
  _loadAndDisplayImageGPU(e12, t) {
    if (!e12) {
      console.warn("No image id set yet to load");
      return;
    }
    let n = {
      imageId: e12,
      imageIdIndex: t,
      viewportId: this.id,
      renderingEngineId: this.renderingEngineId
    };
    return triggerEvent(this.element, Events_default.PRE_STACK_NEW_IMAGE, n), this.imagesLoader.loadImages([e12], this).then(() => e12);
  }
  _updateToDisplayImageCPU(e12) {
    let t = this.getImageDataMetadata(e12), n = getDefaultViewport_default(this.canvas, e12, this.modality, this._cpuFallbackEnabledElement.viewport.colormap), { windowCenter: r, windowWidth: a, voiLUTFunction: o } = n.voi;
    this.voiRange = toLowHighRange(a, r, o), this._cpuFallbackEnabledElement.image = e12, this._cpuFallbackEnabledElement.metadata = { ...t }, this.cpuImagePixelData = e12.voxelManager.getScalarData();
    let s = Object.assign({}, n, this._cpuFallbackEnabledElement.viewport);
    this._cpuFallbackEnabledElement.viewport = this.stackInvalidated ? n : s, this.stackInvalidated = false, this.cpuRenderingInvalidated = true, this._cpuFallbackEnabledElement.transform = calculateTransform_default(this._cpuFallbackEnabledElement);
  }
  getSliceViewInfo() {
    throw Error("Method not implemented.");
  }
  addImages(e12) {
    let t = [];
    e12.forEach((e13) => {
      let { imageId: n, ...r } = e13, a = cache_default.getImage(n), { origin: o, dimensions: s, direction: c, spacing: l, numberOfComponents: u } = this.getImageDataMetadata(a), d = this.createVTKImageData({
        origin: o,
        dimensions: s,
        direction: c,
        spacing: l,
        numberOfComponents: u,
        pixelArray: a.voxelManager.getScalarData()
      }), f = this.createActorMapper(d);
      f && (t.push({
        uid: e13.actorUID ?? uuidv4(),
        actor: f,
        referencedId: n,
        ...r
      }), e13.callback && e13.callback({
        imageActor: f,
        imageId: e13.imageId
      }));
    }), this.addActors(t);
  }
  _updateActorToDisplayImageId(e12) {
    let t = this._checkVTKImageDataMatchesCornerstoneImage(e12, this._imageData), n = this.getViewPresentation();
    if (t && !this.stackInvalidated) {
      this._updateVTKImageDataFromCornerstoneImage(e12), this.resetCameraNoEvent(), this.setViewPresentation(n), this._setPropertiesFromCache(), this.stackActorReInitialized = false;
      return;
    }
    let { origin: r, direction: a, dimensions: o, spacing: s, numberOfComponents: c, imagePixelModule: l } = this.getImageDataMetadata(e12), u = e12.voxelManager.getScalarData();
    this._createVTKImageData({
      origin: r,
      direction: a,
      dimensions: o,
      spacing: s,
      numberOfComponents: c,
      pixelArray: u
    }), this._updateVTKImageDataFromCornerstoneImage(e12);
    let d = this.createActorMapper(this._imageData), f = this.getActors();
    f.length && f[0].uid === this.id ? f[0].actor = d : f.unshift({
      uid: this.id,
      actor: d,
      referencedId: e12.imageId
    }), this.setActors(f);
    let { viewPlaneNormal: p, viewUp: m } = this._getCameraOrientation(a), h = this.getCamera();
    this.setCameraNoEvent({
      viewUp: m,
      viewPlaneNormal: p
    }), this.initialViewUp = m, this.resetCameraNoEvent(), this.setViewPresentation(n), this.triggerCameraEvent(this.getCamera(), h);
    let g = l.photometricInterpretation === "MONOCHROME1";
    this.stackInvalidated = true;
    let _ = this._getInitialVOIRange(e12);
    this.setVOI(_, { forceRecreateLUTFunction: !!g }), this.initialInvert = !!g, this.setInvertColor(this.invert || this.initialInvert), this.stackInvalidated = false, this.stackActorReInitialized = true, this._publishCalibratedEvent && this.triggerCalibrationEvent();
  }
  _getInitialVOIRange(e12) {
    if (this.voiRange && this.voiUpdatedWithSetProperties)
      return this.voiRange;
    let { windowCenter: t, windowWidth: n, voiLUTFunction: r } = e12, a = this._getVOIRangeFromWindowLevel(n, t, r);
    return a = this._getPTPreScaledRange() || a, a;
  }
  _getPTPreScaledRange() {
    if (this._isCurrentImagePTPrescaled())
      return this._getDefaultPTPrescaledVOIRange();
  }
  _isCurrentImagePTPrescaled() {
    return !(this.modality !== "PT" || !this.csImage.isPreScaled || !this.csImage.preScale?.scalingParameters.suvbw);
  }
  _getDefaultPTPrescaledVOIRange() {
    return {
      lower: 0,
      upper: 5
    };
  }
  _getVOIRangeFromWindowLevel(e12, t, n = VOILUTFunctionType_default.LINEAR) {
    let r, a;
    if (typeof t == "number" && typeof e12 == "number" ? (r = t, a = e12) : Array.isArray(t) && Array.isArray(e12) && (r = t[0], a = e12[0]), r !== void 0 && a !== void 0)
      return toLowHighRange(a, r, n);
  }
  async _setImageIdIndex(e12) {
    if (e12 >= this.imageIds.length)
      throw Error(`ImageIdIndex provided ${e12} is invalid, the stack only has ${this.imageIds.length} elements`);
    this.currentImageIdIndex = e12, this.hasPixelSpacing = true, this.viewportStatus = ViewportStatus_default.PRE_RENDER;
    let t = await this._loadAndDisplayImage(this.imageIds[e12], e12);
    if (this.perImageIdDefaultProperties.size >= 1) {
      let e13 = this.perImageIdDefaultProperties.get(t);
      e13 === void 0 ? this.globalDefaultProperties !== void 0 && this.setProperties(this.globalDefaultProperties) : this.setProperties(e13);
    }
    return t;
  }
  resetCameraCPU({ resetPan: e12 = true, resetZoom: t = true }) {
    let { image: n } = this._cpuFallbackEnabledElement;
    if (!n)
      return;
    resetCamera_default(this._cpuFallbackEnabledElement, e12, t);
    let { scale: r } = this._cpuFallbackEnabledElement.viewport, { clientWidth: a, clientHeight: o } = this.element, s = [a / 2, o / 2], c = this.canvasToWorldCPU(s);
    this.setCameraCPU({
      focalPoint: c,
      scale: r
    });
  }
  resetCameraGPU(e12) {
    return this.setCamera({
      flipHorizontal: false,
      flipVertical: false,
      viewUp: this.initialViewUp
    }), super.resetCamera({
      resetToCenter: true,
      ...e12
    });
  }
  scroll(e12, t = true, n = false) {
    let r = this.imageIds;
    if (isNaN(this.targetImageIdIndex))
      return;
    let o = this.targetImageIdIndex, s = r.length, c = o + e12;
    c = n ? (c + s) % s : Math.max(0, Math.min(s - 1, c)), this.targetImageIdIndex = c;
    let l = r[c];
    cache_default.isLoaded(l) || !t ? this.setImageIdIndex(c) : (clearTimeout(this.debouncedTimeout), this.debouncedTimeout = window.setTimeout(() => {
      this.setImageIdIndex(c);
    }, 40));
    let u = {
      newImageIdIndex: c,
      imageId: l,
      direction: e12
    };
    c !== o && triggerEvent(this.element, Events_default.STACK_VIEWPORT_SCROLL, u);
  }
  setImageIdIndex(e12) {
    if (this._throwIfDestroyed(), this.currentImageIdIndex === e12)
      return Promise.resolve(this.getCurrentImageId());
    let t = this._setImageIdIndex(e12);
    return this.targetImageIdIndex = e12, t;
  }
  calibrateSpacing(e12) {
    let t = this.getImageIds().indexOf(e12);
    this.stackInvalidated = true, this._loadAndDisplayImage(e12, t);
  }
  triggerCameraEvent(e12, t) {
    let n = {
      previousCamera: t,
      camera: e12,
      element: this.element,
      viewportId: this.id,
      renderingEngineId: this.renderingEngineId
    };
    this.suppressEvents || triggerEvent(this.element, Events_default.CAMERA_MODIFIED, n);
  }
  triggerCalibrationEvent() {
    let { imageData: e12 } = this.getImageData(), t = {
      element: this.element,
      viewportId: this.id,
      renderingEngineId: this.renderingEngineId,
      imageId: this.getCurrentImageId(),
      imageData: e12,
      worldToIndex: e12.getWorldToIndex(),
      ...this._calibrationEvent
    };
    this.suppressEvents || triggerEvent(this.element, Events_default.IMAGE_SPACING_CALIBRATED, t), this._publishCalibratedEvent = false;
  }
  jumpToWorld(e12) {
    let t = this.getImageIds(), { direction: n, spacing: r } = this.getImageData(), a = getClosestImageId({
      direction: n,
      spacing: r,
      imageIds: t
    }, e12, this.getCamera().viewPlaneNormal, { ignoreSpacing: true }), o = t.indexOf(a);
    return o === -1 ? false : (this.setImageIdIndex(o), this.render(), true);
  }
  getRendererContextPool() {
    return this.getRenderingEngine().getRenderer(this.id);
  }
  getRendererTiled() {
    let e12 = this.getRenderingEngine();
    if (!e12 || e12.hasBeenDestroyed)
      throw Error("Rendering engine has been destroyed");
    return e12.offscreenMultiRenderWindow?.getRenderer(this.id);
  }
  _getVOIRangeForCurrentImage() {
    let { windowCenter: e12, windowWidth: t, voiLUTFunction: n } = this.csImage;
    return this._getVOIRangeFromWindowLevel(t, e12, n);
  }
  _getValidVOILUTFunction(e12) {
    return Object.values(VOILUTFunctionType_default).includes(e12) ? e12 : VOILUTFunctionType_default.LINEAR;
  }
  getSliceInfo() {
    let e12 = this.getSliceIndex(), { dimensions: t } = this.getImageData();
    return {
      width: t[0],
      height: t[1],
      sliceIndex: e12,
      slicePlane: 2
    };
  }
  isReferenceViewable(e12, t = {}) {
    let n = this.getCurrentImageIdIndex(), r = this.imageIds[n];
    if (!r || !e12)
      return false;
    let { referencedImageId: a, multiSliceReference: o } = e12;
    if (a) {
      if (a === r)
        return true;
      e12.referencedImageURI ||= imageIdToURI(a);
      let { referencedImageURI: s2 } = e12, c = this.imageKeyToIndexMap.get(s2);
      return t.asOverlay && this.matchImagesForOverlay(r, a) ? true : c === void 0 ? false : t.withNavigation ? true : n <= (o && this.imageKeyToIndexMap.get(o.referencedImageId)) && n >= c;
    }
    if (!super.isReferenceViewable(e12, {
      ...t,
      withOrientation: t?.asVolume
    }))
      return false;
    if (e12.volumeId || e12.FrameOfReferenceUID)
      return t.asVolume;
    let { cameraFocalPoint: s } = e12;
    if (t.asNearbyProjection && s) {
      let { spacing: e13, direction: t2, origin: n2 } = this.getImageData(), r2 = t2.slice(6, 9), a2 = getSpacingInNormalDirection({
        direction: t2,
        spacing: e13
      }, r2), o2 = dot$3(subtract$3(create$4(), s, n2), r2), c = a2 / 2;
      if (Math.abs(o2) <= c)
        return true;
    }
    return false;
  }
  getViewReference(e12 = {}) {
    let { sliceIndex: t = this.getCurrentImageIdIndex() } = e12, n = super.getViewReference(e12), r = this.getCurrentImageId(t);
    if (r) {
      if (n.referencedImageId = r, this.getCurrentImageIdIndex() !== t) {
        let e13 = this.getImagePlaneReferenceData(t);
        if (!e13)
          return;
        Object.assign(n, e13);
      }
      return n;
    }
  }
  setViewReference(e12) {
    if (!e12?.referencedImageId) {
      e12?.sliceIndex !== void 0 && this.scroll(e12.sliceIndex - this.targetImageIdIndex);
      return;
    }
    let { referencedImageId: t } = e12;
    e12.referencedImageURI ||= imageIdToURI(t);
    let { referencedImageURI: n } = e12, r = this.imageKeyToIndexMap.get(n);
    if (r === void 0) {
      log.error(`No image URI found for ${n}`);
      return;
    }
    this.scroll(r - this.targetImageIdIndex);
  }
  getViewReferenceId(e12 = {}) {
    let { sliceIndex: t = this.currentImageIdIndex } = e12;
    return `imageId:${this.imageIds[t]}`;
  }
  getSliceIndexForImage(e12) {
    if (e12) {
      if (typeof e12 == "string")
        return this.imageKeyToIndexMap.get(e12);
      if (e12.referencedImageId)
        return this.imageKeyToIndexMap.get(e12.referencedImageId);
    }
  }
  getCPUFallbackError(e12) {
    return /* @__PURE__ */ Error(`method ${e12} cannot be used during CPU Fallback mode`);
  }
  fillWithBackgroundColor() {
    let e12 = this.getRenderingEngine();
    e12 && e12.fillCanvasWithBackgroundColor(this.canvas, this.options.background);
  }
  unsetColormapCPU() {
    delete this._cpuFallbackEnabledElement.viewport.colormap, this._cpuFallbackEnabledElement.renderingTools = {}, this.cpuRenderingInvalidated = true, this.fillWithBackgroundColor(), this.render();
  }
  setColormapCPU(e12) {
    this.colormap = e12;
    let t = getColormap$1(e12.name);
    this._cpuFallbackEnabledElement.viewport.colormap = t, this._cpuFallbackEnabledElement.renderingTools = {}, this.fillWithBackgroundColor(), this.cpuRenderingInvalidated = true, this.render();
    let n = {
      viewportId: this.id,
      colormap: e12
    };
    triggerEvent(this.element, Events_default.COLORMAP_MODIFIED, n);
  }
  setColormapGPU(e12) {
    let t = this.getDefaultActor().actor.getProperty(), n = t.getRGBTransferFunction(), r = getColormap$1(e12.name) || vtkColorMaps.getPresetByName(e12.name);
    if (n)
      n.applyColorMap(r), n.setMappingRange(this.voiRange.lower, this.voiRange.upper), t.setRGBTransferFunction(0, n);
    else {
      let e13 = vtkColorTransferFunction$1.newInstance();
      e13.applyColorMap(r), e13.setMappingRange(this.voiRange.lower, this.voiRange.upper), t.setRGBTransferFunction(0, e13);
    }
    this.colormap = e12, this.render();
    let o = {
      viewportId: this.id,
      colormap: e12
    };
    triggerEvent(this.element, Events_default.COLORMAP_MODIFIED, o);
  }
  unsetColormapGPU() {
    throw Error("unsetColormapGPU not implemented.");
  }
  _getImagePlaneModule(e12) {
    let t = getImagePlaneModule(e12);
    return this.hasPixelSpacing = !t.usingDefaultValues || this.calibration?.scale > 0 || this.calibration?.rowPixelSpacing > 0, this.calibration ||= t.calibration, t;
  }
  isInAcquisitionPlane() {
    return true;
  }
};
function transformCanvasToIJK(e12, t) {
  let { imageData: n } = e12.getImageData();
  return transformWorldToIndex(n, e12.canvasToWorld(t));
}
function transformIndexToWorld(e12, t) {
  return e12.indexToWorld(t);
}
function transformIJKToCanvas(e12, t) {
  let { imageData: n } = e12.getImageData(), r = transformIndexToWorld(n, t);
  return e12.worldToCanvas(r);
}
var VolumeViewport_default = class extends BaseVolumeViewport_default {
  constructor(e12) {
    super(e12), this._useAcquisitionPlaneForViewPlane = false, this.getNumberOfSlices = () => {
      let { numberOfSlices: e13 } = getImageSliceDataForVolumeViewport_default(this) || {};
      return e13;
    }, this.resetCameraForResize = () => this.resetCamera({
      resetPan: true,
      resetZoom: true,
      resetToCenter: true,
      resetRotation: false,
      suppressEvents: true
    }), this.getCurrentImageIdIndex = (e13 = this.getVolumeId(), t2 = true) => {
      if (!e13)
        return 0;
      let { currentStepIndex: n } = getVolumeViewportScrollInfo_default(this, e13, t2);
      return n;
    }, this.getSliceIndex = () => {
      let { imageIndex: e13 } = getImageSliceDataForVolumeViewport_default(this) || {};
      return e13;
    }, this.getCurrentImageId = () => {
      let e13 = this.getDefaultActor();
      if (!e13 || !actorIsA(e13, "vtkVolume"))
        return;
      let t2 = cache_default.getVolume(this.getVolumeId());
      if (!t2)
        return;
      let { viewPlaneNormal: n, focalPoint: r } = this.getCamera();
      return getClosestImageId(t2, r, n);
    }, this.getSlicePlaneCoordinates = () => {
      let e13 = this.getDefaultActor();
      if (!e13?.actor)
        return console.warn("No image data found for calculating vtkPlanes."), [];
      let t2 = this.getVolumeId(), n = cache_default.getVolume(t2), { focalPoint: r, position: a, viewPlaneNormal: o } = this.getCamera(), s = getSpacingInNormalDirection(n, o), c = getSliceRange(e13.actor, o, r), l = Math.round((c.current - c.min) / s), u = Math.round((c.max - c.current) / s), d = this.getSliceIndex(), f = [];
      for (let e14 = -l; e14 <= u; e14++) {
        let { newFocalPoint: t3 } = snapFocalPointToSlice(r, a, c, o, s, e14);
        f.push({
          sliceIndex: d + e14,
          point: t3
        });
      }
      return f;
    };
    let { orientation: t } = this.options;
    if (t && t !== OrientationAxis_default.ACQUISITION) {
      this.applyViewOrientation(t);
      return;
    }
    this._useAcquisitionPlaneForViewPlane = true;
  }
  async setVolumes(e12, t = false, n = false) {
    let r = e12[0].volumeId, a = cache_default.getVolume(r);
    if (!a)
      throw Error(`imageVolume with id: ${r} does not exist`);
    return this._useAcquisitionPlaneForViewPlane ? (this._setViewPlaneToAcquisitionPlane(a), this._useAcquisitionPlaneForViewPlane = false) : this.options.orientation && typeof this.options.orientation == "string" && this.options.orientation.includes("_reformat") && this._setViewPlaneToReformatOrientation(this.options.orientation, a), super.setVolumes(e12, t, n);
  }
  async addVolumes(e12, t = false, n = false) {
    let r = cache_default.getVolume(e12[0].volumeId);
    if (!r)
      throw Error(`imageVolume with id: ${r.volumeId} does not exist`);
    return this._useAcquisitionPlaneForViewPlane ? (this._setViewPlaneToAcquisitionPlane(r), this._useAcquisitionPlaneForViewPlane = false) : this.options.orientation && typeof this.options.orientation == "string" && this.options.orientation.includes("_reformat") && this._setViewPlaneToReformatOrientation(this.options.orientation, r), super.addVolumes(e12, t, n);
  }
  jumpToWorld(e12) {
    let t = e12, n = this.getImageData();
    if (n?.imageData) {
      let r2 = n.imageData.getBounds();
      t = [
        Math.max(r2[0], Math.min(r2[1], e12[0])),
        Math.max(r2[2], Math.min(r2[3], e12[1])),
        Math.max(r2[4], Math.min(r2[5], e12[2]))
      ];
    }
    let { focalPoint: r } = this.getCamera(), a = [
      0,
      0,
      0
    ];
    sub$1(a, t, r);
    let o = this.getCamera(), s = o.viewPlaneNormal, c = dot$3(a, s), l = fromValues$3(s[0], s[1], s[2]);
    if (scale$3(l, l, c), Math.abs(l[0]) > 1e-3 || Math.abs(l[1]) > 1e-3 || Math.abs(l[2]) > 1e-3) {
      let e13 = [
        0,
        0,
        0
      ], t2 = [
        0,
        0,
        0
      ];
      add$4(e13, o.focalPoint, l), add$4(t2, o.position, l), this.setCamera({
        focalPoint: e13,
        position: t2
      }), this.render();
    }
    return true;
  }
  setOrientation(e12, t = true, n = false) {
    let r, a;
    if (typeof e12 == "string") {
      if (e12 === OrientationAxis_default.ACQUISITION)
        ({ viewPlaneNormal: r, viewUp: a } = super._getAcquisitionPlaneOrientation());
      else if (e12 === OrientationAxis_default.REFORMAT)
        ({ viewPlaneNormal: r, viewUp: a } = getCameraVectors(this, { useViewportNormal: true }));
      else if (e12 === OrientationAxis_default.AXIAL_REFORMAT || e12 === OrientationAxis_default.SAGITTAL_REFORMAT || e12 === OrientationAxis_default.CORONAL_REFORMAT) {
        let t2;
        t2 = e12 === OrientationAxis_default.AXIAL_REFORMAT ? OrientationAxis_default.AXIAL : e12 === OrientationAxis_default.SAGITTAL_REFORMAT ? OrientationAxis_default.SAGITTAL : OrientationAxis_default.CORONAL, { viewPlaneNormal: r, viewUp: a } = getCameraVectors(this, {
          useViewportNormal: true,
          orientation: t2
        });
      } else if (mprCameraValues_default[e12])
        ({ viewPlaneNormal: r, viewUp: a } = mprCameraValues_default[e12]);
      else
        throw Error(`Invalid orientation: ${e12}. Use Enums.OrientationAxis instead.`);
      this.setCamera({
        viewPlaneNormal: r,
        viewUp: a
      }), this.viewportProperties.orientation = e12, this.resetCamera({ suppressEvents: true });
    } else
      ({ viewPlaneNormal: r, viewUp: a } = e12), this.applyViewOrientation(e12, true, n);
    t && this.render();
  }
  setCameraClippingRange() {
    let e12 = this.getVtkActiveCamera();
    if (!e12) {
      console.warn("No active camera found");
      return;
    }
    e12.getParallelProjection() ? e12.setClippingRange(-rendering_default.MAXIMUM_RAY_DISTANCE, rendering_default.MAXIMUM_RAY_DISTANCE) : e12.setClippingRange(rendering_default.MINIMUM_SLAB_THICKNESS, rendering_default.MAXIMUM_RAY_DISTANCE);
  }
  _setViewPlaneToReformatOrientation(e12, t) {
    let n, r;
    if (t) {
      let { direction: a } = t;
      ({ viewPlaneNormal: n, viewUp: r } = calculateCameraPosition(a.slice(0, 3), a.slice(3, 6), a.slice(6, 9), e12));
    } else
      ({ viewPlaneNormal: n, viewUp: r } = this._getAcquisitionPlaneOrientation());
    this.setCamera({
      viewPlaneNormal: n,
      viewUp: r
    }), this.initialViewUp = r, this.resetCamera();
  }
  _setViewPlaneToAcquisitionPlane(e12) {
    let t, n;
    if (e12) {
      let { direction: r } = e12;
      t = r.slice(6, 9).map((e13) => -e13), n = r.slice(3, 6).map((e13) => -e13);
    } else
      ({ viewPlaneNormal: t, viewUp: n } = this._getAcquisitionPlaneOrientation());
    this.setCamera({
      viewPlaneNormal: t,
      viewUp: n
    }), this.initialViewUp = n, this.resetCamera();
  }
  getBlendMode(e12) {
    let t = this.getActors(), n = e12?.length > 0 ? t.find((t2) => e12.includes(t2.uid)) : t[0];
    return n?.blendMode || n?.actor.getMapper().getBlendMode();
  }
  setBlendMode(e12, t = [], n = false) {
    let r = this.getActors();
    t?.length > 0 && (r = r.filter((e13) => t.includes(e13.uid))), r.forEach((t2) => {
      let { actor: n2 } = t2;
      n2.getMapper().setBlendMode?.(e12), t2.blendMode = e12;
    }), n && this.render();
  }
  resetCamera(e12) {
    let { resetPan: t = true, resetZoom: n = true, resetRotation: r = true, resetToCenter: o = true, suppressEvents: s = false, resetOrientation: c = true, resetAspectRatio: l = true } = e12 || {}, { orientation: u } = this.viewportProperties;
    u && c && this.applyViewOrientation(u, false), super.resetCamera({
      resetPan: t,
      resetZoom: n,
      resetToCenter: o,
      resetAspectRatio: l
    });
    let d = this.getVtkActiveCamera(), f = d.getViewPlaneNormal(), p = d.getFocalPoint();
    if (this.getActors().forEach((e13) => {
      if (!e13.actor)
        return;
      let t2 = e13.actor.getMapper();
      if (t2.getClippingPlanes().length === 0 && !e13?.clippingFilter) {
        let n2 = vtkPlane$1.newInstance(), r2 = vtkPlane$1.newInstance(), a = [n2, r2], o2 = rendering_default.MINIMUM_SLAB_THICKNESS;
        e13.slabThickness && (o2 = e13.slabThickness), this.setOrientationOfClippingPlanes(a, o2, f, p), t2.addClippingPlane(n2), t2.addClippingPlane(r2);
      }
    }), r && mprCameraValues_default[this.viewportProperties.orientation] !== void 0) {
      let e13 = mprCameraValues_default[this.viewportProperties.orientation];
      this.setCameraNoEvent({
        viewUp: e13.viewUp,
        viewPlaneNormal: e13.viewPlaneNormal
      });
    }
    if (!s) {
      let e13 = {
        viewportId: this.id,
        camera: this.getCamera(),
        renderingEngineId: this.renderingEngineId,
        element: this.element
      };
      triggerEvent(this.element, Events_default.CAMERA_RESET, e13);
    }
    return true;
  }
  setSlabThickness(e12, t = []) {
    e12 < 0.1 && (e12 = 0.1);
    let n = this.getActors();
    t?.length > 0 && (n = n.filter((e13) => t.includes(e13.uid))), n.forEach((t2) => {
      actorIsA(t2, "vtkVolume") && (t2.slabThickness = e12);
    });
    let r = this.getCamera();
    this.updateClippingPlanesForActors(r), this.triggerCameraModifiedEventIfNecessary(r, r), this.viewportProperties.slabThickness = e12;
  }
  resetSlabThickness() {
    this.getActors().forEach((e13) => {
      actorIsA(e13, "vtkVolume") && (e13.slabThickness = rendering_default.MINIMUM_SLAB_THICKNESS);
    });
    let e12 = this.getCamera();
    this.updateClippingPlanesForActors(e12), this.triggerCameraModifiedEventIfNecessary(e12, e12), this.viewportProperties.slabThickness = void 0;
  }
  isInAcquisitionPlane() {
    let e12 = this.getImageData();
    if (!e12)
      return false;
    let { direction: t } = e12, { viewPlaneNormal: n } = this.getCamera(), r = [
      t[6],
      t[7],
      t[8]
    ];
    return Math.abs(dot$3(n, r)) > 0.99;
  }
  getSliceViewInfo() {
    let { width: e12, height: t } = this.getCanvas(), n = transformCanvasToIJK(this, [0, 0]), r = transformCanvasToIJK(this, [e12 - 1, 0]), a = transformCanvasToIJK(this, [0, t - 1]), o = sub$1(create$4(), r, n), s = sub$1(create$4(), a, n), c = cross$1(create$4(), o, s);
    normalize$4(o, o), normalize$4(s, s), normalize$4(c, c);
    let { dimensions: l } = this.getImageData(), [u, d, f] = l, p = [
      [
        0,
        0,
        0
      ],
      [
        u - 1,
        0,
        0
      ],
      [
        0,
        d - 1,
        0
      ],
      [
        u - 1,
        d - 1,
        0
      ],
      [
        0,
        0,
        f - 1
      ],
      [
        u - 1,
        0,
        f - 1
      ],
      [
        0,
        d - 1,
        f - 1
      ],
      [
        u - 1,
        d - 1,
        f - 1
      ]
    ].map((e13) => transformIJKToCanvas(this, e13)).reduce((e13, t2) => (e13.minX = Math.min(e13.minX, t2[0]), e13.minY = Math.min(e13.minY, t2[1]), e13.maxX = Math.max(e13.maxX, t2[0]), e13.maxY = Math.max(e13.maxY, t2[1]), e13), {
      minX: Infinity,
      minY: Infinity,
      maxX: -Infinity,
      maxY: -Infinity
    }), m = transformCanvasToIJK(this, [p.minX, p.minY]), h = fromValues$4(o[0], o[1], o[2], 0, s[0], s[1], s[2], 0, c[0], c[1], c[2], 0, m[0], m[1], m[2], 1), g = transformCanvasToIJK(this, [p.maxX, p.maxY]), _ = sub$1(create$4(), g, m), v = invert(create$5(), h), { viewPlaneNormal: y } = this.getCamera();
    if (y.filter((e13) => Math.abs(e13) > 1e-3).length > 1)
      throw Error("getSliceInfo is not supported for oblique views");
    let b = y.findIndex((e13) => Math.abs(e13) > 1 - epsilon_default);
    if (b === -1)
      throw Error("Unable to determine slice axis");
    let S = dot$3(o, _) + 1, C = dot$3(s, _) + 1;
    return {
      sliceIndex: this.getSliceIndex(),
      width: S,
      height: C,
      slicePlane: b,
      sliceToIndexMatrix: h,
      indexToSliceMatrix: v
    };
  }
  getCurrentSlicePixelData() {
    let { voxelManager: e12 } = this.getImageData();
    return e12.getSliceData(this.getSliceViewInfo());
  }
  getViewReference(e12 = {}) {
    let t = super.getViewReference(e12);
    if (t?.volumeId)
      return t.referencedImageId = getClosestImageId(cache_default.getVolume(t.volumeId), t.cameraFocalPoint, t.viewPlaneNormal), t;
  }
  resetProperties(e12) {
    this._resetProperties(e12);
  }
  _resetProperties(e12) {
    let t = e12 ? this.getActor(e12) : this.getDefaultActor();
    if (!t)
      throw Error(`No actor found for the given volumeId: ${e12}`);
    t.slabThickness && (t.slabThickness = rendering_default.MINIMUM_SLAB_THICKNESS, this.viewportProperties.slabThickness = void 0, this.updateClippingPlanesForActors(this.getCamera())), e12 ||= this.getVolumeId();
    let n = cache_default.getVolume(e12);
    if (!n)
      throw Error(`imageVolume with id: ${e12} does not exist in cache`);
    setDefaultVolumeVOI_default(t.actor, n), this._restoreVolumeRenderingDefaults(t, e12);
    let r = { ...super.getVOIModifiedEventDetail(e12) };
    this.resetCamera({
      resetPan: true,
      resetZoom: true,
      resetToCenter: true,
      resetCameraRotation: true,
      resetAspectRatio: true
    }), triggerEvent(this.element, Events_default.VOI_MODIFIED, r);
  }
  getSlicesClippingPlanes() {
    let e12 = this.getSlicePlaneCoordinates(), { viewPlaneNormal: t } = this.getCamera(), n = rendering_default.MINIMUM_SLAB_THICKNESS;
    return e12.map(({ point: e13, sliceIndex: r }) => {
      let a = [vtkPlane$1.newInstance(), vtkPlane$1.newInstance()];
      return this.setOrientationOfClippingPlanes(a, n, t, e13), {
        sliceIndex: r,
        planes: a.map((e14) => ({
          normal: e14.getNormal(),
          origin: e14.getOrigin()
        }))
      };
    });
  }
}, VolumeViewport3D_default = class extends BaseVolumeViewport_default {
  constructor(e12) {
    super(e12), this.setSampleDistanceMultiplier = (e13) => {
      this.getActors().forEach((t2) => {
        if (actorIsA(t2, "vtkVolume")) {
          let n2 = t2.actor.getMapper();
          if (n2 && n2.getInputData) {
            let t3 = n2.getInputData();
            if (t3) {
              let r2 = t3.getSpacing(), a = (r2[0] + r2[1] + r2[2]) / 6 * (e13 || 1);
              a !== void 0 && n2.setSampleDistance && (n2.getSampleDistance(), n2.setSampleDistance(a));
            }
          }
        }
      }), this.render();
    }, this.getNumberOfSlices = () => 1, this.getRotation = () => 0, this.getCurrentImageIdIndex = () => 0, this.getCurrentImageId = () => null, this.resetCameraForResize = () => this.resetCamera({
      resetPan: true,
      resetZoom: true,
      resetToCenter: true
    });
    let { parallelProjection: t, orientation: n } = this.options, r = this.getVtkActiveCamera();
    t != null && r.setParallelProjection(t), n && n !== OrientationAxis_default.ACQUISITION && this.applyViewOrientation(n);
  }
  isInAcquisitionPlane() {
    return false;
  }
  resetCamera({ resetPan: e12 = true, resetZoom: t = true, resetToCenter: n = true } = {}) {
    super.resetCamera({
      resetPan: e12,
      resetZoom: t,
      resetToCenter: n
    });
    let r = this.getVtkActiveCamera();
    return r.getParallelProjection() ? r.setClippingRange(-rendering_default.MAXIMUM_RAY_DISTANCE, rendering_default.MAXIMUM_RAY_DISTANCE) : r.setClippingRange(rendering_default.MINIMUM_SLAB_THICKNESS, rendering_default.MAXIMUM_RAY_DISTANCE), this.getRenderer().resetCameraClippingRange(), true;
  }
  setSlabThickness(e12, t) {
    return null;
  }
  setBlendMode(e12, t, n) {
    return null;
  }
  resetProperties(e12) {
    let t = e12 ? this.getActor(e12) : this.getDefaultActor();
    if (!t)
      throw Error(`No actor found for the given volumeId: ${e12}`);
    t.slabThickness && (t.slabThickness = rendering_default.MINIMUM_SLAB_THICKNESS, this.viewportProperties.slabThickness = void 0, this.updateClippingPlanesForActors(this.getCamera())), e12 ||= this.getVolumeId();
    let n = cache_default.getVolume(e12);
    if (!n)
      throw Error(`imageVolume with id: ${e12} does not exist in cache`);
    setDefaultVolumeVOI_default(t.actor, n), this._restoreVolumeRenderingDefaults(t, e12), this.setCamera(this.initialCamera), triggerEvent(this.element, Events_default.VOI_MODIFIED, super.getVOIModifiedEventDetail(e12));
  }
  getSliceIndex() {
    return null;
  }
  setCamera(e12) {
    super.setCamera(e12), this.getRenderer().resetCameraClippingRange(), this.render();
  }
  setCameraClippingRange() {
    let e12 = this.getVtkActiveCamera();
    e12.getParallelProjection() ? e12.setClippingRange(-rendering_default.MAXIMUM_RAY_DISTANCE, rendering_default.MAXIMUM_RAY_DISTANCE) : e12.setClippingRange(rendering_default.MINIMUM_SLAB_THICKNESS, rendering_default.MAXIMUM_RAY_DISTANCE);
  }
  resetSlabThickness() {
    return null;
  }
};
async function setVolumesForViewports(e12, t, n, r = false, a = false) {
  n.forEach((t2) => {
    let n2 = e12.getViewport(t2);
    if (!n2)
      throw Error(`Viewport with Id ${t2} does not exist`);
    if (!(n2 instanceof BaseVolumeViewport_default))
      throw Error("setVolumesForViewports only supports VolumeViewport and VolumeViewport3D");
  });
  let o = n.map(async (n2) => {
    await e12.getViewport(n2).setVolumes(t, r, a);
  });
  await Promise.all(o);
}
var setVolumesForViewports_default = setVolumesForViewports;
async function addVolumesToViewports(e12, t, n, r = false, a = false) {
  for (let t2 of n) {
    let n2 = e12.getViewport(t2);
    if (!n2)
      throw Error(`Viewport with Id ${t2} does not exist`);
    if (!(n2 instanceof BaseVolumeViewport_default)) {
      console.warn(`Viewport with Id ${t2} is not a BaseVolumeViewport. Cannot add volume to this viewport.`);
      return;
    }
  }
  let o = n.map(async (n2) => {
    await e12.getViewport(n2).addVolumes(t, r, a);
  });
  await Promise.all(o);
}
var addVolumesToViewports_default = addVolumesToViewports;
function addImageSlicesToViewports(e12, t, n) {
  for (let t2 of n) {
    let n2 = e12.getViewport(t2);
    if (!n2)
      throw Error(`Viewport with Id ${t2} does not exist`);
    if (!n2.addImages) {
      console.warn(`Viewport with Id ${t2} does not have addImages. Cannot add image segmentation to this viewport.`);
      return;
    }
  }
  n.forEach((n2) => {
    e12.getViewport(n2).addImages(t);
  });
}
var addImageSlicesToViewports_default = addImageSlicesToViewports, CanvasProperties = class {
  constructor(e12) {
    this.opacity = 0.4, this.outlineOpacity = 0.4, this.transferFunction = [], this.actor = e12;
  }
  setRGBTransferFunction(e12, t) {
    this.transferFunction[e12] = t;
  }
  setScalarOpacity(e12) {
  }
  setInterpolationTypeToNearest() {
  }
  setUseLabelOutline() {
  }
  setLabelOutlineOpacity(e12) {
    this.outlineOpacity = e12;
  }
  setLabelOutlineThickness() {
  }
  getColor(e12) {
    let t = this.transferFunction[0];
    return [
      t.getRedValue(e12),
      t.getGreenValue(e12),
      t.getBlueValue(e12),
      this.opacity
    ];
  }
}, CanvasMapper = class {
  constructor(e12) {
    this.actor = e12;
  }
  getInputData() {
    return this.actor.getImage();
  }
}, CanvasActor = class {
  constructor(e12, t) {
    this.canvasProperties = new CanvasProperties(this), this.visibility = false, this.mapper = new CanvasMapper(this), this.className = "CanvasActor", this.derivedImage = t, this.viewport = e12;
  }
  renderRLE(e12, t, n) {
    let { width: r, height: a } = this.image, { canvas: o } = this;
    (!o || o.width !== r || o.height !== a) && (this.canvas = o = new window.OffscreenCanvas(r, a));
    let s = o.getContext("2d"), c = s.createImageData(r, a), { data: l } = c;
    l.fill(0);
    let { map: u } = n, d = Infinity, f = Infinity, p = -Infinity, m = -Infinity;
    for (let e13 = 0; e13 < a; e13++) {
      let t2 = u.getRun(e13, 0);
      if (!t2)
        continue;
      f = Math.min(f, e13), m = Math.max(m, e13);
      let n2 = e13 * r << 2, a2;
      for (let e14 of t2) {
        let { start: r2, end: o2, value: s2 } = e14;
        if (s2 === 0) {
          a2 ||= [], a2.push(t2.indexOf(e14));
          continue;
        }
        d = Math.min(d, r2), p = Math.max(p, o2);
        let c2 = this.canvasProperties.getColor(s2).map((e15) => e15 * 255), u2 = n2 + (r2 << 2);
        for (let e15 = r2; e15 < o2; e15++)
          l[u2++] = c2[0], l[u2++] = c2[1], l[u2++] = c2[2], l[u2++] = c2[3];
      }
    }
    if (d > r)
      return;
    let h = p - d, g = m - f;
    s.putImageData(c, 0, 0, d - 1, f - 1, h + 2, g + 2), t.drawImage(o, d, f, h, g, d, f, h, g);
  }
  setMapper(e12) {
    this.mapper = e12;
  }
  render(e12, t) {
    if (!this.visibility)
      return;
    let n = this.image || this.getImage(), { width: r, height: a } = n, o = n.getScalarData();
    if (!o)
      return;
    let { voxelManager: s } = n;
    if (s && s.map.getRun) {
      this.renderRLE(e12, t, s);
      return;
    }
    let { canvas: c } = this;
    (!c || c.width !== r || c.height !== a) && (this.canvas = c = new window.OffscreenCanvas(r, a));
    let l = c.getContext("2d"), u = l.createImageData(r, a), { data: d } = u, f = 0, p = 0, m = Infinity, h = Infinity, g = -Infinity, _ = -Infinity;
    for (let e13 = 0; e13 < a; e13++)
      for (let t2 = 0; t2 < r; t2++) {
        let n2 = o[f++];
        if (n2) {
          m = Math.min(t2, m), h = Math.min(e13, h), g = Math.max(t2, g), _ = Math.max(e13, _);
          let r2 = this.canvasProperties.getColor(n2);
          d[p] = r2[0] * 255, d[p + 1] = r2[1] * 255, d[p + 2] = r2[2] * 255, d[p + 3] = 127;
        }
        p += 4;
      }
    if (m > r)
      return;
    let v = g - m + 1, y = _ - h + 1;
    l.putImageData(u, 0, 0, m, h, v, y), t.drawImage(c, m, h, v, y, m, h, v, y);
  }
  getClassName() {
    return this.className;
  }
  getProperty() {
    return this.canvasProperties;
  }
  setVisibility(e12) {
    this.visibility = e12;
  }
  getMapper() {
    return this.mapper;
  }
  isA(e12) {
    return e12 === this.className;
  }
  getImage() {
    if (this.image)
      return this.image;
    this.image = { ...this.derivedImage };
    let e12 = this.viewport.getImageData();
    return Object.assign(this.image, {
      worldToIndex: (t) => e12.imageData.worldToIndex(t),
      indexToWorld: (t, n) => e12.imageData.indexToWorld(t, n),
      getDimensions: () => e12.dimensions,
      getScalarData: () => this.derivedImage?.getPixelData(),
      getDirection: () => e12.direction,
      getSpacing: () => e12.spacing,
      setOrigin: () => null,
      setDerivedImage: (e13) => {
        this.derivedImage = e13, this.image = null;
      },
      modified: () => null
    }), this.image;
  }
}, FrameRange = class {
  static {
    this.frameRangeExtractor = /(\/frames\/|[&?]frameNumber=)([^/&?]*)/i;
  }
  static imageIdToFrames(e12) {
    let t = e12.match(this.frameRangeExtractor);
    if (!t || !t[2])
      return null;
    let n = t[2].split("-").map((e13) => Number(e13));
    return n.length === 1 ? n[0] : n;
  }
  static imageIdToFrameEnd(e12) {
    let t = this.imageIdToFrames(e12);
    return Array.isArray(t) ? t[1] : t;
  }
  static imageIdToFrameStart(e12) {
    let t = this.imageIdToFrames(e12);
    return Array.isArray(t) ? t[0] : t;
  }
  static framesToString(e12) {
    return Array.isArray(e12) ? `${e12[0]}-${e12[1]}` : String(e12);
  }
  static framesToImageId(e12, t) {
    let n = e12.match(this.frameRangeExtractor);
    if (!n || !n[2])
      return null;
    let r = this.framesToString(t);
    return e12.replace(this.frameRangeExtractor, `${n[1]}${r}`);
  }
}, VideoViewport_default = class e6 extends Viewport_default {
  static {
    this.frameRangeExtractor = /(\/frames\/|[&?]frameNumber=)([^/&?]*)/i;
  }
  constructor(e12) {
    super({
      ...e12,
      canvas: e12.canvas || getOrCreateCanvas(e12.element)
    }), this.videoWidth = 0, this.videoHeight = 0, this.loop = true, this.mute = true, this.isPlaying = false, this.scrollSpeed = 1, this.playbackRate = 1, this.frameRange = [0, 0], this.fps = 30, this.videoCamera = {
      panWorld: [0, 0],
      parallelScale: 1
    }, this.voiRange = {
      lower: 0,
      upper: 255
    }, this.getProperties = () => ({
      loop: this.videoElement.loop,
      muted: this.videoElement.muted,
      playbackRate: this.playbackRate,
      scrollSpeed: this.scrollSpeed,
      voiRange: { ...this.voiRange }
    }), this.getMiddleSliceData = () => {
      throw Error("Method not implemented.");
    }, this.useCustomRenderingPipeline = true, this.resetCamera = () => (this.refreshRenderValues(), this.canvasContext.fillRect(0, 0, this.canvas.width, this.canvas.height), this.isPlaying || this.renderFrame(), true), this.getNumberOfSlices = () => {
      let e13 = Math.round(this.videoElement.duration * this.fps / this.scrollSpeed);
      return isNaN(e13) ? this.numberOfFrames : e13;
    }, this.getFrameOfReferenceUID = () => this.videoElement.src, this.resize = () => {
      let e13 = this.canvas, { clientWidth: t, clientHeight: n } = e13;
      (e13.width !== t || e13.height !== n) && (e13.width = t, e13.height = n), this.refreshRenderValues(), this.isPlaying || this.renderFrame();
    }, this.canvasToWorld = (e13, t = [
      0,
      0,
      0
    ]) => {
      let n = this.videoCamera.panWorld, r = this.getWorldToCanvasRatio(), a = [n[0] * r, n[1] * r], o = [e13[0] - a[0], e13[1] - a[1]];
      return t.splice(0, 2, o[0] / r, o[1] / r), t;
    }, this.worldToCanvas = (e13) => {
      let t = this.videoCamera.panWorld, n = this.getWorldToCanvasRatio();
      return [(e13[0] + t[0]) * n, (e13[1] + t[1]) * n];
    }, this.getRotation = () => 0, this.canvasToIndex = (e13) => {
      let t = this.getTransform();
      return t.invert(), t.transformPoint(e13.map((e14) => e14 * devicePixelRatio));
    }, this.indexToCanvas = (e13) => this.getTransform().transformPoint(e13).map((e14) => e14 / devicePixelRatio), this.customRenderViewportToCanvas = () => {
      this.renderFrame();
    }, this.renderFrame = () => {
      let e13 = window.devicePixelRatio || 1, t = this.getTransform().getMatrix(), n = this.canvasContext;
      n.resetTransform(), n.clearRect(0, 0, this.canvas.width, this.canvas.height), n.transform(t[0] / e13, t[1] / e13, t[2] / e13, t[3] / e13, t[4] / e13, t[5] / e13), n.drawImage(this.videoElement, 0, 0, this.videoWidth, this.videoHeight);
      for (let e14 of this.getActors())
        e14.actor.render(this, this.canvasContext);
      this.canvasContext.resetTransform(), this.setRendered(), triggerEvent(this.element, Events_default.STACK_NEW_IMAGE, {
        element: this.element,
        viewportId: this.id,
        viewport: this,
        renderingEngineId: this.renderingEngineId,
        time: this.videoElement.currentTime,
        duration: this.videoElement.duration
      }), triggerEvent(this.element, Events_default.IMAGE_RENDERED, {
        element: this.element,
        viewportId: this.id,
        viewport: this,
        imageIndex: this.getCurrentImageIdIndex(),
        numberOfSlices: this.numberOfFrames,
        renderingEngineId: this.renderingEngineId,
        time: this.videoElement.currentTime,
        duration: this.videoElement.duration
      }), this.initialRender?.();
      let r = this.getFrameNumber();
      this.isPlaying && (r < this.frameRange[0] ? this.setFrameNumber(this.frameRange[0]) : r > this.frameRange[1] && (this.loop ? this.setFrameNumber(this.frameRange[0]) : this.pause()));
    }, this.renderWhilstPlaying = () => {
      this.renderFrame(), this.isPlaying && requestAnimationFrame(this.renderWhilstPlaying);
    }, this.canvasContext = this.canvas.getContext("2d"), this.renderingEngineId = e12.renderingEngineId, this.element.setAttribute("data-viewport-uid", this.id), this.element.setAttribute("data-rendering-engine-uid", this.renderingEngineId), this.videoElement = document.createElement("video"), this.videoElement.muted = this.mute, this.videoElement.loop = this.loop, this.videoElement.autoplay = true, this.videoElement.crossOrigin = "anonymous", this.addEventListeners(), this.resize();
  }
  static get useCustomRenderingPipeline() {
    return true;
  }
  addEventListeners() {
    this.canvas.addEventListener(Events_default.ELEMENT_DISABLED, this.elementDisabledHandler);
  }
  removeEventListeners() {
    this.canvas.removeEventListener(Events_default.ELEMENT_DISABLED, this.elementDisabledHandler);
  }
  elementDisabledHandler() {
    this.removeEventListeners(), this.videoElement.remove();
  }
  getImageDataMetadata(e12) {
    let t = typeof e12 == "string" ? e12 : e12.imageId, n = getMetaData(MetadataModules_default.IMAGE_PLANE, t), r = n.rowCosines, a = n.columnCosines;
    (n.usingDefaultValues || r == null || a == null) && (r = [
      1,
      0,
      0
    ], a = [
      0,
      1,
      0
    ]);
    let o = fromValues$3(r[0], r[1], r[2]), s = fromValues$3(a[0], a[1], a[2]), { rows: c, columns: l } = n, u = create$4();
    cross$1(u, o, s);
    let d = n.imagePositionPatient;
    d ??= [
      0,
      0,
      0
    ];
    let f = n.columnPixelSpacing || 1, p = n.rowPixelSpacing || 1, m = n.columns, h = n.rows;
    return this.hasPixelSpacing = !!n.columnPixelSpacing, {
      bitsAllocated: 8,
      numberOfComponents: 3,
      origin: d,
      rows: c,
      columns: l,
      direction: [
        ...o,
        ...s,
        ...u
      ],
      dimensions: [
        m,
        h,
        1
      ],
      spacing: [
        f,
        p,
        1
      ],
      hasPixelSpacing: this.hasPixelSpacing,
      numVoxels: m * h * 1,
      imagePlaneModule: n
    };
  }
  setDataIds(e12, t) {
    this.setVideo(e12[0], (t.viewReference?.sliceIndex || 0) + 1);
  }
  setVideo(e12, t) {
    this.imageId = Array.isArray(e12) ? e12[0] : e12;
    let n = getMetaData(MetadataModules_default.IMAGE_URL, e12);
    if (!n?.rendered)
      throw Error(`Video Image ID ${e12} does not have a rendered video view`);
    let { rendered: r } = n;
    this.modality = getMetaData(MetadataModules_default.GENERAL_SERIES, e12)?.Modality, this.metadata = this.getImageDataMetadata(e12);
    let { cineRate: a, numberOfFrames: o } = getMetaData(MetadataModules_default.CINE, e12);
    return this.numberOfFrames = o, this.setVideoURL(r).then(() => ((!o || o === 1) && (o = Math.round(this.videoElement.duration * (a || 30))), a ||= Math.round(o / this.videoElement.duration), this.fps = a, this.numberOfFrames = o, this.setFrameRange([1, o]), this.initialRender = () => {
      this.initialRender = null, this.pause(), this.setFrameNumber(t || 1);
    }, new Promise((e13) => {
      window.setTimeout(() => {
        this.setFrameNumber(t || 1), e13(this);
      }, 25);
    })));
  }
  async setVideoURL(e12) {
    return new Promise((t) => {
      this.videoElement.src = e12, this.videoElement.preload = "auto";
      let n = () => {
        this.videoWidth = this.videoElement.videoWidth, this.videoHeight = this.videoElement.videoHeight, this.videoElement.removeEventListener("loadedmetadata", n), this.refreshRenderValues(), t(true);
      };
      this.videoElement.addEventListener("loadedmetadata", n);
    });
  }
  getImageIds() {
    let e12 = Array(this.numberOfFrames), t = this.imageId.replace(/[0-9]+$/, "");
    for (let n = 0; n < this.numberOfFrames; n++)
      e12[n] = `${t}${n + 1}`;
    return e12;
  }
  togglePlayPause() {
    return this.isPlaying ? (this.pause(), false) : (this.play(), true);
  }
  async play() {
    try {
      this.isPlaying || (this.isPlaying = true, await this.videoElement.play(), this.renderWhilstPlaying());
    } catch {
    }
  }
  pause() {
    try {
      this.isPlaying = false, this.videoElement.pause();
    } catch {
    }
  }
  async scroll(e12 = 1) {
    await this.pause();
    let t = this.videoElement, n = this.renderFrame;
    t.currentTime += e12 * this.scrollSpeed / this.fps;
    let r = (e13) => {
      n(), t.removeEventListener("seeked", r);
    };
    t.addEventListener("seeked", r);
  }
  async start() {
    let e12 = this.videoElement, t = this.renderFrame;
    if (e12.currentTime = 0, e12.paused) {
      let n = (r) => {
        t(), e12.removeEventListener("seeked", n);
      };
      e12.addEventListener("seeked", n);
    }
  }
  async end() {
    let e12 = this.videoElement, t = this.renderFrame;
    if (e12.currentTime = e12.duration, e12.paused) {
      let n = (r) => {
        t(), e12.removeEventListener("seeked", n);
      };
      e12.addEventListener("seeked", n);
    }
  }
  async setTime(e12) {
    let t = this.videoElement, n = this.renderFrame;
    if (t.currentTime = e12, t.paused) {
      let e13 = (r) => {
        n(), t.removeEventListener("seeked", e13);
      };
      t.addEventListener("seeked", e13);
    }
  }
  getSliceViewInfo() {
    throw Error("Method not implemented.");
  }
  async setFrameNumber(e12) {
    this.setTime((e12 - 1) / this.fps);
  }
  setFrameRange(e12) {
    if (!e12) {
      this.frameRange = [1, this.numberOfFrames];
      return;
    }
    e12.length !== 2 || e12[0] === e12[1] || (this.frameRange = [e12[0], e12[1]]);
  }
  getSliceIndexForImage(e12) {
    if (e12) {
      if (typeof e12 == "string")
        return FrameRange.imageIdToFrameStart(e12);
      if (e12.referencedImageId)
        return FrameRange.imageIdToFrameStart(e12.referencedImageId);
    }
  }
  getFrameRange() {
    return this.frameRange;
  }
  setProperties(e12) {
    e12.loop !== void 0 && (this.videoElement.loop = e12.loop), e12.muted !== void 0 && (this.videoElement.muted = e12.muted), e12.playbackRate !== void 0 && this.setPlaybackRate(e12.playbackRate), e12.scrollSpeed !== void 0 && this.setScrollSpeed(e12.scrollSpeed), e12.voiRange && this.setVOI(e12.voiRange);
  }
  setPlaybackRate(e12 = 1) {
    if (this.playbackRate = e12, e12 < 0.0625) {
      this.pause();
      return;
    }
    this.videoElement && (this.videoElement.playbackRate = e12, this.play());
  }
  setScrollSpeed(e12 = 1, t = SpeedUnit.FRAME) {
    this.scrollSpeed = t === SpeedUnit.SECOND ? e12 * this.fps : e12;
  }
  resetProperties() {
    this.setProperties({
      loop: false,
      muted: true,
      voiRange: {
        lower: 0,
        upper: 255
      }
    });
  }
  getScalarData() {
    if (this.scalarData?.frameNumber === this.getFrameNumber())
      return this.scalarData;
    if (!this.videoElement || !this.videoElement.videoWidth || !this.videoElement.videoHeight) {
      console.debug("Video not ready yet, returning empty scalar data");
      let e13 = new Uint8ClampedArray();
      return e13.getRange = () => [0, 255], e13.frameNumber = -1, e13;
    }
    let e12 = document.createElement("canvas");
    e12.width = this.videoElement.videoWidth, e12.height = this.videoElement.videoHeight;
    let t = e12.getContext("2d");
    t.drawImage(this.videoElement, 0, 0);
    let n = t.getImageData(0, 0, e12.width, e12.height).data;
    return n.getRange = () => [0, 255], n.frameNumber = this.getFrameNumber(), this.scalarData = n, n;
  }
  getImageData() {
    let { metadata: e12 } = this, t = e12.spacing, n = {
      getDirection: () => e12.direction,
      getDimensions: () => e12.dimensions,
      getRange: () => [0, 255],
      getScalarData: () => this.getScalarData(),
      getSpacing: () => e12.spacing,
      worldToIndex: (e13) => {
        let t2 = this.worldToCanvas(e13), n2 = this.canvasToIndex(t2);
        return [
          n2[0],
          n2[1],
          0
        ];
      },
      indexToWorld: (e13, t2) => {
        let n2 = this.indexToCanvas([e13[0], e13[1]]);
        return this.canvasToWorld(n2, t2);
      }
    }, r = {
      dimensions: e12.dimensions,
      spacing: t,
      origin: e12.origin,
      direction: e12.direction,
      metadata: {
        Modality: this.modality,
        FrameOfReferenceUID: e12.FrameOfReferenceUID
      },
      getScalarData: () => this.getScalarData(),
      scalarData: this.getScalarData(),
      imageData: n,
      voxelManager: { forEach: (e13, t2) => pointInShapeCallback(t2.imageData, {
        pointInShapeFn: t2.isInObject ?? (() => true),
        callback: e13,
        boundsIJK: t2.boundsIJK,
        returnPoints: t2.returnPoints ?? false
      }) },
      hasPixelSpacing: this.hasPixelSpacing,
      calibration: this.calibration,
      preScale: { scaled: false }
    };
    return Object.defineProperty(n, "scalarData", {
      get: () => this.getScalarData(),
      enumerable: true
    }), r;
  }
  hasImageURI(t) {
    let n = t.match(e6.frameRangeExtractor), r = n ? t.substring(0, n.index) : t;
    return this.imageId.includes(r);
  }
  setVOI(e12) {
    this.voiRange = e12;
    let t = this.setColorTransform(e12, this.averageWhite);
    this.canvas.style.filter = t;
  }
  setWindowLevel(e12 = 256, t = 128) {
    let n = t - e12 / 2, r = t + e12 / 2 - 1;
    this.setVOI({
      lower: n,
      upper: r
    }), this.setColorTransform({
      lower: n,
      upper: r
    }, this.averageWhite);
  }
  setAverageWhite(e12) {
    this.averageWhite = e12, this.setColorTransform(this.voiRange, e12);
  }
  setCamera(e12) {
    let { parallelScale: t, focalPoint: n } = e12;
    if (t && (this.videoCamera.parallelScale = this.element.clientHeight / 2 / t), n !== void 0) {
      let e13 = this.worldToCanvas(n), t2 = [this.element.clientWidth / 2, this.element.clientHeight / 2], r = [(e13[0] - t2[0]) / this.videoCamera.parallelScale, (e13[1] - t2[1]) / this.videoCamera.parallelScale];
      this.videoCamera.panWorld = [this.videoCamera.panWorld[0] - r[0], this.videoCamera.panWorld[1] - r[1]];
    }
    this.canvasContext.fillStyle = "rgba(0,0,0,1)", this.canvasContext.fillRect(0, 0, this.canvas.width, this.canvas.height), this.isPlaying || this.renderFrame();
  }
  getCurrentImageId(e12 = this.getCurrentImageIdIndex()) {
    return this.imageId?.replace("/frames/1", `/frames/${e12 + 1}`);
  }
  getViewReferenceId(e12 = {}) {
    let { sliceIndex: t } = e12;
    return t === void 0 ? `videoId:${this.getCurrentImageId()}` : Array.isArray(t) ? `videoId:${this.imageId.substring(0, this.imageId.length - 1)}${t[0] + 1}-${t[1] + 1}` : `videoId:${this.imageId.replace("/frames/1", `/frames/${1 + t}`)}`;
  }
  isReferenceViewable(t, n = {}) {
    let { imageURI: r } = n, { referencedImageId: a, sliceIndex: o, multiSliceReference: s } = t;
    if (!super.isReferenceViewable(t))
      return false;
    let c = this.getCurrentImageId();
    if (!r) {
      let e12 = c.indexOf(":");
      r = c.substring(e12 + 1, c.length - 1);
    }
    if (n.withNavigation)
      return true;
    let l = this.getSliceIndex();
    if (s) {
      let e12 = FrameRange.imageIdToFrameEnd(s.referencedImageId);
      return l >= o && l <= e12;
    }
    if (o !== void 0)
      return l === o;
    if (!a)
      return false;
    let u = a.match(e6.frameRangeExtractor);
    if (!u || !u[2])
      return true;
    let d = u[2].split("-").map((e12) => Number(e12)), f = l + 1;
    return d[0] <= f && f <= (d[1] ?? d[0]);
  }
  setViewReference(e12) {
    typeof e12.sliceIndex == "number" ? this.setFrameNumber(e12.sliceIndex + 1) : Array.isArray(e12.sliceIndex) && this.setFrameRange(e12.sliceIndex);
  }
  getViewReference(e12) {
    let t = e12?.sliceIndex ?? (this.isPlaying ? this.frameRange[0] : this.getCurrentImageIdIndex()), n = e12?.rangeEndSliceIndex ?? (this.isPlaying ? this.frameRange[1] - 1 : void 0), r = n > t ? {
      sliceIndex: n,
      referencedImageId: this.getCurrentImageId(n)
    } : void 0;
    return {
      ...super.getViewReference(e12),
      referencedImageId: this.getViewReferenceId(e12),
      sliceIndex: t,
      multiSliceReference: r
    };
  }
  getFrameNumber() {
    return 1 + this.getCurrentImageIdIndex();
  }
  getCurrentImageIdIndex() {
    return Math.round(this.videoElement.currentTime * this.fps);
  }
  getSliceIndex() {
    return this.getCurrentImageIdIndex() / this.scrollSpeed;
  }
  getCamera() {
    let { parallelScale: e12 } = this.videoCamera, t = [this.element.clientWidth / 2, this.element.clientHeight / 2];
    return {
      parallelProjection: true,
      focalPoint: this.canvasToWorld(t),
      position: [
        0,
        0,
        0
      ],
      viewUp: [
        0,
        -1,
        0
      ],
      parallelScale: this.element.clientHeight / 2 / e12,
      viewPlaneNormal: [
        0,
        0,
        1
      ]
    };
  }
  getFrameRate() {
    return this.fps;
  }
  getPan() {
    let e12 = this.videoCamera.panWorld;
    return [e12[0], e12[1]];
  }
  refreshRenderValues() {
    let e12 = this.canvas.offsetWidth / this.videoWidth;
    this.videoHeight * e12 > this.canvas.height && (e12 = this.canvas.offsetHeight / this.videoHeight);
    let t = Math.floor(this.videoWidth * e12), n = Math.floor(this.videoHeight * e12), r = (this.canvas.offsetWidth - t) / 2, a = (this.canvas.offsetHeight - n) / 2, o = r / e12, s = a / e12;
    this.videoCamera.panWorld = [o, s], this.videoCamera.parallelScale = e12;
  }
  getWorldToCanvasRatio() {
    return this.videoCamera.parallelScale;
  }
  getCanvasToWorldRatio() {
    return 1 / this.videoCamera.parallelScale;
  }
  getTransform() {
    let e12 = this.videoCamera.panWorld, t = window.devicePixelRatio || 1, n = this.getWorldToCanvasRatio(), r = this.getCanvasToWorldRatio(), a = [this.canvas.offsetWidth / 2, this.canvas.offsetHeight / 2], o = [a[0] * r, a[1] * r], s = new Transform();
    return s.scale(t, t), s.translate(a[0], a[1]), s.scale(n, n), s.translate(e12[0], e12[1]), s.translate(-o[0], -o[1]), s;
  }
  updateCameraClippingPlanesAndRange() {
  }
  addImages(e12) {
    let t = this.getActors();
    e12.forEach((e13) => {
      let { imageId: n, ...r } = e13, a = cache_default.getImage(n), o = this.createActorMapper(a), s = e13.actorUID ?? uuidv4();
      o && (t.push({
        uid: s,
        actor: o,
        referencedId: n,
        ...r
      }), e13.callback && e13.callback({
        imageActor: o,
        imageId: n
      }));
    }), this.setActors(t);
  }
  createActorMapper(e12) {
    return new CanvasActor(this, e12);
  }
}, microscopyViewportCss_default = "\n.DicomMicroscopyViewer {\n  --ol-partial-background-color: rgba(127, 127, 127, 0.7);\n  --ol-foreground-color: #000000;\n  --ol-subtle-foreground-color: #000;\n  --ol-subtle-background-color: rgba(78, 78, 78, 0.5);\n}\n\n.DicomMicroscopyViewer .ol-box {\n  box-sizing: border-box;\n  border-radius: 2px;\n  border: 1.5px solid var(--ol-background-color);\n  background-color: var(--ol-partial-background-color);\n}\n\n.DicomMicroscopyViewer .ol-mouse-position {\n  top: 8px;\n  right: 8px;\n  position: absolute;\n}\n\n.DicomMicroscopyViewer .ol-scale-line {\n  background: var(--ol-partial-background-color);\n  border-radius: 4px;\n  bottom: 8px;\n  left: 8px;\n  padding: 2px;\n  position: absolute;\n}\n\n.DicomMicroscopyViewer .ol-scale-line-inner {\n  border: 1px solid var(--ol-subtle-foreground-color);\n  border-top: none;\n  color: var(--ol-foreground-color);\n  font-size: 10px;\n  text-align: center;\n  margin: 1px;\n  will-change: contents, width;\n  transition: all 0.25s;\n}\n\n.DicomMicroscopyViewer .ol-scale-bar {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n}\n\n.DicomMicroscopyViewer .ol-scale-bar-inner {\n  display: flex;\n}\n\n.DicomMicroscopyViewer .ol-scale-step-marker {\n  width: 1px;\n  height: 15px;\n  background-color: var(--ol-foreground-color);\n  float: right;\n  z-index: 10;\n}\n\n.DicomMicroscopyViewer .ol-scale-step-text {\n  position: absolute;\n  bottom: -5px;\n  font-size: 10px;\n  z-index: 11;\n  color: var(--ol-foreground-color);\n  text-shadow:\n    -1.5px 0 var(--ol-partial-background-color),\n    0 1.5px var(--ol-partial-background-color),\n    1.5px 0 var(--ol-partial-background-color),\n    0 -1.5px var(--ol-partial-background-color);\n}\n\n.DicomMicroscopyViewer .ol-scale-text {\n  position: absolute;\n  font-size: 12px;\n  text-align: center;\n  bottom: 25px;\n  color: var(--ol-foreground-color);\n  text-shadow:\n    -1.5px 0 var(--ol-partial-background-color),\n    0 1.5px var(--ol-partial-background-color),\n    1.5px 0 var(--ol-partial-background-color),\n    0 -1.5px var(--ol-partial-background-color);\n}\n\n.DicomMicroscopyViewer .ol-scale-singlebar {\n  position: relative;\n  height: 10px;\n  z-index: 9;\n  box-sizing: border-box;\n  border: 1px solid var(--ol-foreground-color);\n}\n\n.DicomMicroscopyViewer .ol-scale-singlebar-even {\n  background-color: var(--ol-subtle-foreground-color);\n}\n\n.DicomMicroscopyViewer .ol-scale-singlebar-odd {\n  background-color: var(--ol-background-color);\n}\n\n.DicomMicroscopyViewer .ol-unsupported {\n  display: none;\n}\n\n.DicomMicroscopyViewer .ol-viewport,\n.DicomMicroscopyViewer .ol-unselectable {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.DicomMicroscopyViewer .ol-viewport canvas {\n  all: unset;\n}\n\n.DicomMicroscopyViewer .ol-selectable {\n  -webkit-touch-callout: default;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  user-select: text;\n}\n\n.DicomMicroscopyViewer .ol-grabbing {\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n  cursor: grabbing;\n}\n\n.DicomMicroscopyViewer .ol-grab {\n  cursor: move;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n  cursor: grab;\n}\n\n.DicomMicroscopyViewer .ol-control {\n  position: absolute;\n  background-color: var(--ol-subtle-background-color);\n  border-radius: 4px;\n}\n\n.DicomMicroscopyViewer .ol-zoom {\n  top: 0.5em;\n  left: 0.5em;\n}\n\n.DicomMicroscopyViewer .ol-rotate {\n  top: 0.5em;\n  right: 0.5em;\n  transition:\n    opacity 0.25s linear,\n    visibility 0s linear;\n}\n\n.DicomMicroscopyViewer .ol-rotate.ol-hidden {\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity 0.25s linear,\n    visibility 0s linear 0.25s;\n}\n\n.DicomMicroscopyViewer .ol-zoom-extent {\n  top: 4.643em;\n  left: 0.5em;\n}\n\n.DicomMicroscopyViewer .ol-full-screen {\n  right: 0.5em;\n  top: 0.5em;\n}\n\n.DicomMicroscopyViewer .ol-control button {\n  display: block;\n  margin: 1px;\n  padding: 0;\n  color: var(--ol-subtle-foreground-color);\n  font-weight: bold;\n  text-decoration: none;\n  font-size: inherit;\n  text-align: center;\n  height: 1.375em;\n  width: 1.375em;\n  line-height: 0.4em;\n  background-color: var(--ol-background-color);\n  border: none;\n  border-radius: 2px;\n}\n\n.DicomMicroscopyViewer .ol-control button::-moz-focus-inner {\n  border: none;\n  padding: 0;\n}\n\n.DicomMicroscopyViewer .ol-zoom-extent button {\n  line-height: 1.4em;\n}\n\n.DicomMicroscopyViewer .ol-compass {\n  display: block;\n  font-weight: normal;\n  will-change: transform;\n}\n\n.DicomMicroscopyViewer .ol-touch .ol-control button {\n  font-size: 1.5em;\n}\n\n.DicomMicroscopyViewer .ol-touch .ol-zoom-extent {\n  top: 5.5em;\n}\n\n.DicomMicroscopyViewer .ol-control button:hover,\n.DicomMicroscopyViewer .ol-control button:focus {\n  text-decoration: none;\n  outline: 1px solid var(--ol-subtle-foreground-color);\n  color: var(--ol-foreground-color);\n}\n\n.DicomMicroscopyViewer .ol-zoom .ol-zoom-in {\n  border-radius: 2px 2px 0 0;\n}\n\n.DicomMicroscopyViewer .ol-zoom .ol-zoom-out {\n  border-radius: 0 0 2px 2px;\n}\n\n.DicomMicroscopyViewer .ol-attribution {\n  text-align: right;\n  bottom: 0.5em;\n  right: 0.5em;\n  max-width: calc(100% - 1.3em);\n  display: flex;\n  flex-flow: row-reverse;\n  align-items: center;\n}\n\n.DicomMicroscopyViewer .ol-attribution a {\n  color: var(--ol-subtle-foreground-color);\n  text-decoration: none;\n}\n\n.DicomMicroscopyViewer .ol-attribution ul {\n  margin: 0;\n  padding: 1px 0.5em;\n  color: var(--ol-foreground-color);\n  text-shadow: 0 0 2px var(--ol-background-color);\n  font-size: 12px;\n}\n\n.DicomMicroscopyViewer .ol-attribution li {\n  display: inline;\n  list-style: none;\n}\n\n.DicomMicroscopyViewer .ol-attribution li:not(:last-child):after {\n  content: ' ';\n}\n\n.DicomMicroscopyViewer .ol-attribution img {\n  max-height: 2em;\n  max-width: inherit;\n  vertical-align: middle;\n}\n\n.DicomMicroscopyViewer .ol-attribution button {\n  flex-shrink: 0;\n}\n\n.DicomMicroscopyViewer .ol-attribution.ol-collapsed ul {\n  display: none;\n}\n\n.DicomMicroscopyViewer .ol-attribution:not(.ol-collapsed) {\n  background: var(--ol-partial-background-color);\n}\n\n.DicomMicroscopyViewer .ol-attribution.ol-uncollapsible {\n  bottom: 0;\n  right: 0;\n  border-radius: 4px 0 0;\n}\n\n.DicomMicroscopyViewer .ol-attribution.ol-uncollapsible img {\n  margin-top: -0.2em;\n  max-height: 1.6em;\n}\n\n.DicomMicroscopyViewer .ol-attribution.ol-uncollapsible button {\n  display: none;\n}\n\n.DicomMicroscopyViewer .ol-zoomslider {\n  top: 4.5em;\n  left: 0.5em;\n  height: 200px;\n}\n\n.DicomMicroscopyViewer .ol-zoomslider button {\n  position: relative;\n  height: 10px;\n}\n\n.DicomMicroscopyViewer .ol-touch .ol-zoomslider {\n  top: 5.5em;\n}\n\n.DicomMicroscopyViewer .ol-overviewmap {\n  left: 0.5em;\n  bottom: 0.5em;\n}\n\n.DicomMicroscopyViewer .ol-overviewmap.ol-uncollapsible {\n  bottom: 0;\n  left: 0;\n  border-radius: 0 4px 0 0;\n}\n\n.DicomMicroscopyViewer .ol-overviewmap .ol-overviewmap-map,\n.DicomMicroscopyViewer .ol-overviewmap button {\n  display: block;\n}\n\n.DicomMicroscopyViewer .ol-overviewmap .ol-overviewmap-map {\n  border: 1px solid var(--ol-subtle-foreground-color);\n  height: 150px;\n  width: 150px;\n}\n\n.DicomMicroscopyViewer .ol-overviewmap:not(.ol-collapsed) button {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n}\n\n.DicomMicroscopyViewer .ol-overviewmap.ol-collapsed .ol-overviewmap-map,\n.DicomMicroscopyViewer .ol-overviewmap.ol-uncollapsible button {\n  display: none;\n}\n\n.DicomMicroscopyViewer .ol-overviewmap:not(.ol-collapsed) {\n  background: var(--ol-subtle-background-color);\n}\n\n.DicomMicroscopyViewer .ol-overviewmap-box {\n  border: 0.5px dotted var(--ol-subtle-foreground-color);\n}\n\n.DicomMicroscopyViewer .ol-overviewmap .ol-overviewmap-box:hover {\n  cursor: move;\n}\n\n@layout-header-background: #007ea3;\n@primary-color: #007ea3;\n@processing-color: #8cb8c6;\n@success-color: #3f9c35;\n@warning-color: #eeaf30;\n@error-color: #96172e;\n@font-size-base: 14px;\n\n.DicomMicroscopyViewer .ol-tooltip {\n  font-size: 16px !important;\n}\n", WSIUtilFunctions = null, EVENT_POSTRENDER = "postrender", ANNOTATION_REMOVED = "CORNERSTONE_TOOLS_ANNOTATION_REMOVED", WSIViewport_default = class e7 extends Viewport_default {
  constructor(e12) {
    super({
      ...e12,
      canvas: e12.canvas || getOrCreateCanvas(e12.element)
    }), this.imageURISet = /* @__PURE__ */ new Set(), this.internalCamera = {
      rotation: 0,
      centerIndex: [0, 0],
      extent: [
        0,
        -2,
        1,
        -1
      ],
      xSpacing: 1,
      ySpacing: 1,
      resolution: 1,
      zoom: 1
    }, this.annotationRemovedListener = (e13) => {
      let { detail: t2 } = e13, n = t2?.annotation?.metadata;
      if (!n) {
        this.postrender();
        return;
      }
      let r = n.referencedImageURI ?? (n.referencedImageId ? imageIdToURI(n.referencedImageId) : null);
      if (r && !this.hasImageURI(r))
        return;
      let a = n.FrameOfReferenceUID ?? null;
      a && a !== this.frameOfReferenceUID || this.postrender();
    }, this.voiRange = {
      lower: 0,
      upper: 255
    }, this.getProperties = () => ({ voiRange: { ...this.voiRange } }), this.resetCamera = () => true, this.getNumberOfSlices = () => 1, this.getFrameOfReferenceUID = () => this.frameOfReferenceUID, this.resize = () => {
      let e13 = this.canvas, { clientWidth: t2, clientHeight: n } = e13;
      (e13.width !== t2 || e13.height !== n) && (e13.width = t2, e13.height = n), this.refreshRenderValues();
    }, this.canvasToWorld = (e13) => {
      if (!this.metadata)
        return;
      let t2 = this.canvasToIndex(e13);
      return t2[1] = -t2[1], this.indexToWorld(t2);
    }, this.worldToCanvas = (e13) => {
      if (!this.metadata)
        return;
      let t2 = this.worldToIndex(e13);
      return t2[1] = -t2[1], this.indexToCanvas([
        t2[0],
        t2[1],
        0
      ]);
    }, this.postrender = () => {
      this.refreshRenderValues(), triggerEvent(this.element, Events_default.IMAGE_RENDERED, {
        element: this.element,
        viewportId: this.id,
        viewport: this,
        renderingEngineId: this.renderingEngineId
      });
    }, this.getRotation = () => 0, this.canvasToIndex = (e13) => {
      let t2 = this.getTransform();
      t2.invert();
      let n = t2.transformPoint(e13.map((e14) => e14 * devicePixelRatio));
      return [
        n[0],
        n[1],
        0
      ];
    }, this.indexToCanvas = (e13) => this.getTransform().transformPoint([e13[0], e13[1]]).map((e14) => e14 / devicePixelRatio), this.customRenderViewportToCanvas = () => {
    }, this.getImageIds = () => [this.imageIds[0]], this.renderingEngineId = e12.renderingEngineId, this.element.setAttribute("data-viewport-uid", this.id), this.element.setAttribute("data-rendering-engine-uid", this.renderingEngineId), this.element.style.position = "relative", this.microscopyElement = document.createElement("div"), this.microscopyElement.setAttribute("class", "DicomMicroscopyViewer"), this.microscopyElement.id = uuidv4(), this.microscopyElement.innerText = "Initial", this.microscopyElement.style.background = "grey", this.microscopyElement.style.width = "100%", this.microscopyElement.style.height = "100%", this.microscopyElement.style.position = "absolute", this.microscopyElement.style.left = "0", this.microscopyElement.style.top = "0";
    let t = this.element.firstElementChild;
    t.insertBefore(this.microscopyElement, t.childNodes[1]), this.addEventListeners(), this.addWidget("DicomMicroscopyViewer", {
      getEnabled: () => !!this.viewer,
      setEnabled: () => {
        this.elementDisabledHandler();
      }
    }), this.resize();
  }
  static get useCustomRenderingPipeline() {
    return true;
  }
  addEventListeners() {
    this.canvas.addEventListener(Events_default.ELEMENT_DISABLED, this.elementDisabledHandler), eventTarget_default.addEventListener(ANNOTATION_REMOVED, this.annotationRemovedListener);
  }
  removeEventListeners() {
    this.canvas.removeEventListener(Events_default.ELEMENT_DISABLED, this.elementDisabledHandler), eventTarget_default.removeEventListener(ANNOTATION_REMOVED, this.annotationRemovedListener);
  }
  elementDisabledHandler() {
    this.removeEventListeners(), this.viewer?.cleanup(), this.viewer = null, this.element.firstElementChild.removeChild(this.microscopyElement), this.microscopyElement = null, this.imageURISet.clear();
  }
  getImageDataMetadata(e12 = 0) {
    let t = this.metadataDicomweb.reduce((e13, t2) => e13?.NumberOfFrames < t2.NumberOfFrames ? t2 : e13), { TotalPixelMatrixColumns: n, TotalPixelMatrixRows: r, ImageOrientationSlide: a, ImagedVolumeWidth: o, ImagedVolumeHeight: s, ImagedVolumeDepth: c } = t, l = getMetaData(MetadataModules_default.IMAGE_PLANE, this.imageIds[e12]), u = a.slice(0, 3), d = a.slice(3, 6);
    (u == null || d == null) && (u = [
      1,
      0,
      0
    ], d = [
      0,
      1,
      0
    ]);
    let f = fromValues$3(u[0], u[1], u[2]), p = fromValues$3(d[0], d[1], d[2]), m = create$4();
    cross$1(m, f, p);
    let { XOffsetInSlideCoordinateSystem: h = 0, YOffsetInSlideCoordinateSystem: g = 0, ZOffsetInSlideCoordinateSystem: _ = 0 } = t.TotalPixelMatrixOriginSequence?.[0] || {}, v = [
      h,
      g,
      _
    ], y = o / n, b = s / r, S = n, C = r, w = c;
    return this.hasPixelSpacing = !!(o && s), {
      bitsAllocated: 8,
      numberOfComponents: 3,
      origin: v,
      direction: [
        ...f,
        ...p,
        ...m
      ],
      dimensions: [
        S,
        C,
        1
      ],
      spacing: [
        y,
        b,
        w
      ],
      hasPixelSpacing: this.hasPixelSpacing,
      numVoxels: S * C * 1,
      imagePlaneModule: l
    };
  }
  async setFrameNumber(e12) {
  }
  setProperties(e12) {
    e12.voiRange && this.setVOI(e12.voiRange);
  }
  resetProperties() {
    this.setProperties({ voiRange: {
      lower: 0,
      upper: 255
    } });
  }
  setVOI(e12) {
    this.voiRange = e12;
    let t = this.setColorTransform(e12, this.averageWhite);
    this.map.getViewport().querySelectorAll(".ol-layers canvas").forEach((e13) => {
      e13.style.filter = t;
    });
  }
  setAverageWhite(e12) {
    this.averageWhite = e12, this.setColorTransform(this.voiRange, e12);
  }
  getScalarData() {
    return null;
  }
  computeTransforms() {
    let e12 = create$5(), t = create$5();
    return fromTranslation(e12, this.metadata.origin), e12[0] = this.metadata.direction[0], e12[1] = this.metadata.direction[1], e12[2] = this.metadata.direction[2], e12[4] = this.metadata.direction[3], e12[5] = this.metadata.direction[4], e12[6] = this.metadata.direction[5], e12[8] = this.metadata.direction[6], e12[9] = this.metadata.direction[7], e12[10] = this.metadata.direction[8], scale$4(e12, e12, this.metadata.spacing), invert(t, e12), {
      indexToWorld: e12,
      worldToIndex: t
    };
  }
  getImageData() {
    let { metadata: e12 } = this;
    if (!e12)
      return null;
    let { spacing: t } = e12;
    return {
      dimensions: e12.dimensions,
      spacing: t,
      numberOfComponents: 3,
      origin: e12.origin,
      direction: e12.direction,
      metadata: {
        Modality: this.modality,
        FrameOfReferenceUID: this.frameOfReferenceUID
      },
      hasPixelSpacing: this.hasPixelSpacing,
      calibration: this.calibration,
      preScale: { scaled: false },
      scalarData: this.getScalarData(),
      imageData: {
        getDirection: () => e12.direction,
        getDimensions: () => e12.dimensions,
        getRange: () => [0, 255],
        getScalarData: () => this.getScalarData(),
        getSpacing: () => e12.spacing,
        worldToIndex: (e13) => this.worldToIndex(e13),
        indexToWorld: (e13) => this.indexToWorld(e13)
      }
    };
  }
  hasImageURI(e12) {
    return e12 ? this.imageURISet.has(e12) : false;
  }
  setCamera(e12) {
    let t = this.getCamera(), { parallelScale: n, focalPoint: r } = e12, a = this.getView(), { xSpacing: o } = this.internalCamera;
    if (n) {
      let e13 = this.element.clientHeight / n, t2 = 1 / o / e13;
      a.setResolution(t2);
    }
    if (r) {
      let e13 = this.worldToCanvas(r), t2 = this.canvasToIndex(e13);
      a.setCenter(t2);
    }
    let s = this.getCamera();
    this.triggerCameraModifiedEventIfNecessary(t, s);
  }
  getCurrentImageId() {
    return this.imageIds[0];
  }
  getFrameNumber() {
    return 1;
  }
  getCamera() {
    this.refreshRenderValues();
    let { resolution: e12, xSpacing: t, centerIndex: n } = this.internalCamera, r = e12 * t, a = this.indexToCanvas([
      n[0],
      n[1],
      0
    ]), o = this.canvasToWorld(a);
    return {
      parallelProjection: true,
      focalPoint: o,
      position: o,
      viewUp: [
        0,
        -1,
        0
      ],
      parallelScale: this.element.clientHeight * r,
      viewPlaneNormal: [
        0,
        0,
        1
      ]
    };
  }
  static {
    this.getDicomMicroscopyViewer = async () => peerImport("dicom-microscopy-viewer");
  }
  worldToIndexWSI(e12) {
    if (!WSIUtilFunctions)
      return;
    let t = this.viewer.getAffine(), n = WSIUtilFunctions.applyInverseTransform({
      coordinate: [e12[0], e12[1]],
      affine: t
    });
    return [n[0], n[1]];
  }
  indexToWorldWSI(e12) {
    if (!WSIUtilFunctions)
      return;
    let t = WSIUtilFunctions.applyTransform({
      coordinate: [e12[0], e12[1]],
      affine: this.viewer.getAffine()
    });
    return [
      t[0],
      t[1],
      0
    ];
  }
  worldToIndex(e12) {
    let { worldToIndex: t } = this.computeTransforms(), n = create$4();
    return transformMat4$1(n, e12, t), n;
  }
  indexToWorld(e12) {
    let { indexToWorld: t } = this.computeTransforms(), n = create$4();
    return transformMat4$1(n, fromValues$3(...e12), t), [
      n[0],
      n[1],
      n[2]
    ];
  }
  setDataIds(t, n) {
    n?.miniNavigationOverlay !== false && e7.addMiniNavigationOverlayCss();
    let r = n?.webClient || getMetaData(MetadataModules_default.WADO_WEB_CLIENT, t[0]);
    if (!r)
      throw Error(`To use setDataIds on WSI data, you must provide metaData.webClient for ${t[0]}.`);
    return this.setWSI(t, r);
  }
  async setWSI(t, n) {
    this.microscopyElement.style.background = "black", this.microscopyElement.innerText = "Loading", this.imageIds = t, this.imageURISet = new Set(t.map((e12) => imageIdToURI(e12)));
    let r = await e7.getDicomMicroscopyViewer();
    WSIUtilFunctions ||= r.utils, this.frameOfReferenceUID = null;
    let a = this.imageIds.map((e12) => {
      let t2 = n.getDICOMwebMetadata(e12);
      Object.defineProperty(t2, "isMultiframe", {
        value: t2.isMultiframe,
        enumerable: false
      }), Object.defineProperty(t2, "frameNumber", {
        value: void 0,
        enumerable: false
      });
      let r2 = t2["00080008"]?.Value;
      r2?.length === 1 && (t2["00080008"].Value = r2[0].split("\\"));
      let a2 = t2["00200052"]?.Value?.[0];
      return this.frameOfReferenceUID ? a2 !== this.frameOfReferenceUID && (t2["00200052"].Value = [this.frameOfReferenceUID]) : this.frameOfReferenceUID = a2, t2;
    }), o = [];
    a.forEach((e12) => {
      let t2 = new r.metadata.VLWholeSlideMicroscopyImage({ metadata: e12 }), n2 = t2.ImageType[2];
      n2 === "VOLUME" || n2 === "THUMBNAIL" ? o.push(t2) : console.log("Unknown image type", t2.ImageType);
    }), this.metadataDicomweb = o;
    let s = new r.viewer.VolumeImageViewer({
      client: n,
      metadata: o,
      controls: ["overview", "position"],
      retrieveRendered: false,
      bindings: {}
    });
    s.render({ container: this.microscopyElement }), this.metadata = this.getImageDataMetadata(), s.deactivateDragPanInteraction(), this.viewer = s, this.map = s.getMap(), this.map.on(EVENT_POSTRENDER, this.postrender), this.resize(), this.microscopyElement.innerText = "", Object.assign(this.microscopyElement.style, {
      "--ol-partial-background-color": "rgba(127, 127, 127, 0.7)",
      "--ol-foreground-color": "#000000",
      "--ol-subtle-foreground-color": "#000",
      "--ol-subtle-background-color": "rgba(78, 78, 78, 0.5)",
      background: "none"
    });
  }
  scroll(e12) {
    let t = this.getCamera();
    this.setCamera({ parallelScale: t.parallelScale * (1 + 0.1 * e12) });
  }
  getSliceIndex() {
    return 0;
  }
  getView() {
    if (!this.viewer)
      return;
    let e12 = this.viewer.getMap(), t = window;
    return t.map = e12, t.viewer = this.viewer, t.view = e12?.getView(), t.wsi = this, e12?.getView();
  }
  refreshRenderValues() {
    let e12 = this.getView();
    if (!e12)
      return;
    let t = e12.getResolution();
    if (!t || t < 1e-3)
      return;
    let n = e12.getCenter(), r = e12.getProjection().getExtent(), a = e12.getRotation(), o = e12.getZoom(), { metadata: { spacing: [s, c] } } = this, l = 1 / t / s;
    Object.assign(this.internalCamera, {
      extent: r,
      centerIndex: n,
      worldToCanvasRatio: l,
      xSpacing: s,
      ySpacing: c,
      resolution: t,
      rotation: a,
      zoom: o
    });
  }
  getZoom() {
    return this.getView()?.getZoom();
  }
  setZoom(e12) {
    this.getView()?.setZoom(e12);
  }
  getTransform() {
    this.refreshRenderValues();
    let { centerIndex: e12, resolution: t, rotation: n } = this.internalCamera, r = [this.canvas.width / 2, this.canvas.height / 2], a = new Transform();
    return a.translate(r[0], r[1]), a.rotate(n), a.scale(1 / t, -1 / t), a.translate(-e12[0], -e12[1]), a;
  }
  getViewReferenceId() {
    return `imageId:${this.getCurrentImageId()}`;
  }
  getCurrentImageIdIndex() {
    return 0;
  }
  static {
    this.overlayCssId = "overlayCss";
  }
  static addMiniNavigationOverlayCss() {
    if (document.getElementById(this.overlayCssId))
      return;
    let e12 = document.createElement("style");
    e12.innerText = microscopyViewportCss_default, e12.setAttribute("id", this.overlayCssId), document.getElementsByTagName("head")[0].append(e12);
  }
}, SECONDS_WIDTH = 150, CHANNEL_SPACING = 5, ECG_AMPLITUDE_INDEX_SIZE = 65536, COLOR_GRID_MAJOR = "#7f0000", COLOR_GRID_MINOR = "#3f0000", COLOR_BASELINE = "#7F4C00", COLOR_TRACE = "#ffffff", COLOR_LABEL = "#ffff00", COLOR_BACKGROUND = "#000000";
function computeMinMax(e12) {
  let t = 0, n = 0;
  for (let r = 0; r < e12.length; r++)
    e12[r] < t && (t = e12[r]), e12[r] > n && (n = e12[r]);
  return {
    min: t,
    max: n
  };
}
var ECGViewport_default = class extends Viewport_default {
  constructor(e12) {
    super({
      ...e12,
      canvas: e12.canvas || getOrCreateCanvas(e12.element)
    }), this.imageId = null, this.channels = [], this.waveformData = null, this.ecgWidth = 0, this.ecgHeight = 0, this.channelScale = 0, this.ecgCamera = {
      panWorld: [0, 0],
      parallelScale: 1
    }, this.getProperties = () => ({ visibleChannels: this.channels.map((e13, t) => e13.visible ? t : -1).filter((e13) => e13 >= 0) }), this.resetCamera = () => (this.refreshRenderValues(), this.canvasContext.fillRect(0, 0, this.canvas.width, this.canvas.height), this.renderFrame(), true), this.getFrameOfReferenceUID = () => `ecg-viewport-${this.id}`, this.resize = () => {
      let e13 = this.canvas, { clientWidth: t, clientHeight: n } = e13;
      (e13.width !== t || e13.height !== n) && (e13.width = t, e13.height = n), this.waveformData && (this.computeChannelScale(), this.recalculateHeight()), this.refreshRenderValues(), this.renderFrame();
    }, this.canvasToWorld = (e13, t = [
      0,
      0,
      0
    ]) => {
      if (!this.waveformData)
        return t[0] = 0, t[1] = 0, t[2] = 0, t;
      let n = this.getWorldToCanvasRatio(), r = this.ecgCamera.panWorld, a = this.computeChannelLayouts(), o = [e13[0] / n - r[0], e13[1] / n - r[1]], s = 0;
      for (let e14 = 0; e14 < a.length; e14++) {
        let t2 = a[e14];
        if (o[1] <= t2.yOffset) {
          s = e14;
          break;
        }
        e14 === a.length - 1 && (s = e14);
      }
      let c = Math.max(0, Math.min(this.waveformData.numberOfSamples - 1, o[0] * this.waveformData.numberOfSamples / this.ecgWidth)), l = (a[s].baseline - o[1]) / this.channelScale;
      return t[0] = c, t[1] = l, t[2] = s, t;
    }, this.worldToCanvas = (e13) => {
      if (!this.waveformData)
        return [0, 0];
      let t = this.getWorldToCanvasRatio(), n = this.ecgCamera.panWorld, r = this.computeChannelLayouts(), a = Math.round(e13[2]);
      if (a < 0 || a >= r.length)
        return [0, 0];
      let o = r[a];
      return [e13[0] / this.waveformData.numberOfSamples * this.ecgWidth * t + n[0] * t, (o.baseline - e13[1] * this.channelScale) * t + n[1] * t];
    }, this.getRotation = () => 0, this.getNumberOfSlices = () => 1, this.getCurrentImageIdIndex = () => 0, this.getCurrentImageId = () => this.imageId, this.getSliceIndex = () => 0, this.getImageIds = () => this.imageId ? [this.imageId] : [], this.scroll = () => {
    }, this.customRenderViewportToCanvas = () => {
      this.renderFrame();
    }, this.renderFrame = () => {
      if (!this.waveformData)
        return;
      let e13 = window.devicePixelRatio || 1, t = this.getTransform().getMatrix(), n = this.canvasContext;
      n.resetTransform(), n.fillStyle = COLOR_BACKGROUND, n.fillRect(0, 0, this.canvas.width, this.canvas.height), n.setTransform(t[0] / e13, t[1] / e13, t[2] / e13, t[3] / e13, t[4] / e13, t[5] / e13);
      let r = this.computeChannelLayouts();
      this.drawGrid(n), this.drawTraces(n, r), this.drawLabels(n, r), n.resetTransform(), this.setRendered(), triggerEvent(this.element, Events_default.IMAGE_RENDERED, {
        element: this.element,
        viewportId: this.id,
        viewport: this,
        renderingEngineId: this.renderingEngineId
      });
    }, this.getMiddleSliceData = () => {
      throw Error("Method not implemented for ECG viewport.");
    }, this.canvasContext = this.canvas.getContext("2d"), this.renderingEngineId = e12.renderingEngineId, this.element.setAttribute("data-viewport-uid", this.id), this.element.setAttribute("data-rendering-engine-uid", this.renderingEngineId), this.addEventListeners(), this.resize();
  }
  static get useCustomRenderingPipeline() {
    return true;
  }
  addEventListeners() {
    this.canvas.addEventListener(Events_default.ELEMENT_DISABLED, this.elementDisabledHandler);
  }
  removeEventListeners() {
    this.canvas.removeEventListener(Events_default.ELEMENT_DISABLED, this.elementDisabledHandler);
  }
  elementDisabledHandler() {
    this.removeEventListeners();
  }
  async setEcg(e12) {
    this.imageId = e12;
    let t = getMetaData(MetadataModules_default.ECG, e12);
    if (!t?.waveformData?.retrieveBulkData)
      throw Error(`[ECGViewport] No ECG waveform data for imageId: ${e12}`);
    let { numberOfWaveformChannels: n, numberOfWaveformSamples: r, samplingFrequency: a, waveformBitsAllocated: o = 16, waveformSampleInterpretation: s = "SS", multiplexGroupLabel: c, channelDefinitionSequence: l = [] } = t, u = await t.waveformData.retrieveBulkData();
    this.channels = [];
    for (let e13 = 0; e13 < n; e13++) {
      let t2 = l[e13] || {}, n2 = t2.channelSourceSequence?.codeMeaning || t2.ChannelSourceSequence?.CodeMeaning || `Channel ${e13 + 1}`, r2 = u[e13] || new Int16Array(), { min: a2, max: o2 } = computeMinMax(r2);
      this.channels.push({
        name: n2,
        data: r2,
        visible: true,
        min: a2,
        max: o2
      });
    }
    this.waveformData = {
      channels: this.channels,
      numberOfChannels: n,
      numberOfSamples: r,
      samplingFrequency: a,
      bitsAllocated: o,
      sampleInterpretation: s,
      multiplexGroupLabel: c
    }, this.calibration = getMetaData(MetadataModules_default.CALIBRATION, e12), this.ecgWidth = Math.ceil(r * SECONDS_WIDTH / a), this.computeChannelScale(), this.recalculateHeight(), this.refreshRenderValues(), this.renderFrame();
  }
  setChannelVisibility(e12, t) {
    e12 >= 0 && e12 < this.channels.length && (this.channels[e12].visible = t, this.computeChannelScale(), this.recalculateHeight(), this.refreshRenderValues(), this.renderFrame());
  }
  getVisibleChannels() {
    return this.channels.map((e12) => ({
      name: e12.name,
      visible: e12.visible
    }));
  }
  getWaveformData() {
    return this.waveformData;
  }
  getContentDimensions() {
    return {
      width: this.ecgWidth,
      height: this.ecgHeight
    };
  }
  computeChannelScale() {
    let e12 = this.channels.filter((e13) => e13.visible && e13.data.length > 0);
    if (e12.length === 0 || this.ecgWidth === 0) {
      this.channelScale = 0;
      return;
    }
    let t = 1;
    for (let n2 of e12) {
      let e13 = n2.max - n2.min;
      t = Math.max(t, e13);
    }
    let n = this.canvas.offsetHeight && this.canvas.offsetWidth ? this.canvas.offsetHeight / this.canvas.offsetWidth : 2 / 3;
    this.channelScale = (this.ecgWidth * n - CHANNEL_SPACING * e12.length) / e12.length / (t * 1.25);
  }
  recalculateHeight() {
    let e12 = this.channelScale, t = 0;
    for (let n of this.channels) {
      if (!n.visible || n.data.length === 0)
        continue;
      let r = (n.max - n.min) * e12 * 1.25;
      t += r + CHANNEL_SPACING;
    }
    this.ecgHeight = t;
  }
  computeChannelLayouts() {
    let e12 = this.channelScale, t = [], n = 0;
    for (let r of this.channels) {
      if (!r.visible || r.data.length === 0)
        continue;
      let a = (r.max - r.min) * e12 * 1.25;
      n += a + CHANNEL_SPACING;
      let o = n + r.min * e12;
      t.push({
        channel: r,
        itemHeight: a,
        yOffset: n,
        baseline: o
      });
    }
    return t;
  }
  setProperties(e12) {
    if (e12.visibleChannels !== void 0) {
      for (let t = 0; t < this.channels.length; t++)
        this.channels[t].visible = e12.visibleChannels.includes(t);
      this.computeChannelScale(), this.recalculateHeight(), this.refreshRenderValues(), this.renderFrame();
    }
  }
  resetProperties() {
    for (let e12 of this.channels)
      e12.visible = true;
    this.computeChannelScale(), this.recalculateHeight(), this.refreshRenderValues(), this.renderFrame();
  }
  setCamera(e12) {
    let { parallelScale: t, focalPoint: n } = e12;
    if (t && (this.ecgCamera.parallelScale = this.element.clientHeight / 2 / t), n !== void 0) {
      let e13 = this.worldToCanvas(n), t2 = [this.element.clientWidth / 2, this.element.clientHeight / 2], r = [(e13[0] - t2[0]) / this.ecgCamera.parallelScale, (e13[1] - t2[1]) / this.ecgCamera.parallelScale];
      this.ecgCamera.panWorld = [this.ecgCamera.panWorld[0] - r[0], this.ecgCamera.panWorld[1] - r[1]];
    }
    this.canvasContext.fillStyle = COLOR_BACKGROUND, this.canvasContext.fillRect(0, 0, this.canvas.width, this.canvas.height), this.renderFrame();
  }
  getCamera() {
    let { parallelScale: e12 } = this.ecgCamera, t = [this.element.clientWidth / 2, this.element.clientHeight / 2];
    return {
      parallelProjection: true,
      focalPoint: this.canvasToWorld(t),
      position: [
        0,
        0,
        0
      ],
      viewUp: [
        0,
        -1,
        0
      ],
      parallelScale: this.element.clientHeight / 2 / e12,
      viewPlaneNormal: [
        0,
        0,
        1
      ]
    };
  }
  getPan() {
    let e12 = this.ecgCamera.panWorld;
    return [e12[0], e12[1]];
  }
  getViewReferenceId(e12) {
    return `imageId:${this.imageId}`;
  }
  hasImageURI(e12) {
    return this.imageId?.includes(e12) ?? false;
  }
  isReferenceViewable(e12) {
    return !(e12.FrameOfReferenceUID && e12.FrameOfReferenceUID !== this.getFrameOfReferenceUID());
  }
  updateCameraClippingPlanesAndRange() {
  }
  refreshRenderValues() {
    if (!this.ecgWidth || !this.ecgHeight)
      return;
    let e12 = this.canvas.offsetWidth / this.ecgWidth;
    this.ecgHeight * e12 > this.canvas.offsetHeight && (e12 = this.canvas.offsetHeight / this.ecgHeight);
    let t = Math.floor(this.ecgWidth * e12), n = Math.floor(this.ecgHeight * e12), r = (this.canvas.offsetWidth - t) / 2, a = (this.canvas.offsetHeight - n) / 2, o = r / e12, s = a / e12;
    this.ecgCamera.panWorld = [o, s], this.ecgCamera.parallelScale = e12;
  }
  getWorldToCanvasRatio() {
    return this.ecgCamera.parallelScale;
  }
  getTransform() {
    let e12 = this.ecgCamera.panWorld, t = window.devicePixelRatio || 1, n = this.getWorldToCanvasRatio(), r = 1 / n, a = [this.canvas.offsetWidth / 2, this.canvas.offsetHeight / 2], o = [a[0] * r, a[1] * r], s = new Transform();
    return s.scale(t, t), s.translate(a[0], a[1]), s.scale(n, n), s.translate(e12[0], e12[1]), s.translate(-o[0], -o[1]), s;
  }
  drawGrid(e12) {
    let t = this.channelScale, n = this.ecgWidth, r = this.ecgHeight;
    if (t <= 0)
      return;
    let a = 100;
    for (; a * t < 8; )
      a *= 2;
    let o = a * t, s = o * 5, c = SECONDS_WIDTH / 25, l = SECONDS_WIDTH / 5;
    e12.strokeStyle = COLOR_GRID_MINOR, e12.lineWidth = 0.5, e12.beginPath();
    let u = Math.floor(r / o);
    for (let t2 = 1; t2 <= u; t2++)
      if (t2 % 5 != 0) {
        let r2 = t2 * o;
        e12.moveTo(0, r2), e12.lineTo(n, r2);
      }
    let d = Math.floor(n / c);
    for (let t2 = 1; t2 <= d; t2++)
      if (t2 % 5 != 0) {
        let n2 = t2 * c;
        e12.moveTo(n2, 0), e12.lineTo(n2, r);
      }
    e12.stroke(), e12.strokeStyle = COLOR_GRID_MAJOR, e12.lineWidth = 1, e12.beginPath();
    let f = Math.floor(r / s);
    for (let t2 = 1; t2 <= f; t2++) {
      let r2 = t2 * s;
      e12.moveTo(0, r2), e12.lineTo(n, r2);
    }
    let p = Math.floor(n / l);
    for (let t2 = 1; t2 <= p; t2++) {
      let n2 = t2 * l;
      e12.moveTo(n2, 0), e12.lineTo(n2, r);
    }
    e12.stroke();
  }
  drawTraces(e12, t) {
    let n = this.channelScale, r = this.ecgWidth;
    for (let { channel: a, baseline: o } of t) {
      e12.strokeStyle = COLOR_BASELINE, e12.lineWidth = 2, e12.beginPath(), e12.moveTo(0, o), e12.lineTo(r, o), e12.stroke(), e12.strokeStyle = COLOR_TRACE, e12.lineWidth = 1, e12.beginPath();
      for (let t2 = 0; t2 < a.data.length; t2++) {
        let s = t2 * r / a.data.length, c = o - a.data[t2] * n;
        t2 === 0 ? e12.moveTo(s, c) : e12.lineTo(s, c);
      }
      e12.stroke();
    }
  }
  drawLabels(e12, t) {
    let n = 14 / this.getWorldToCanvasRatio();
    for (let { channel: r, itemHeight: a, yOffset: o } of t) {
      let t2 = o - a + n;
      e12.font = `${n}px monospace`;
      let s = e12.measureText(r.name).width;
      e12.fillStyle = COLOR_BACKGROUND, e12.fillRect(5, t2 - n, s + 4, n + 4), e12.fillStyle = COLOR_LABEL, e12.fillText(r.name, 5, t2);
    }
  }
  getImageData() {
    if (!this.waveformData)
      return null;
    let e12 = [
      this.waveformData.numberOfSamples,
      ECG_AMPLITUDE_INDEX_SIZE,
      this.waveformData.numberOfChannels
    ], t = [
      1,
      1,
      1
    ], n = [
      0,
      0,
      0
    ], r = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], a = ECG_AMPLITUDE_INDEX_SIZE / 2;
    return {
      dimensions: e12,
      spacing: t,
      origin: n,
      direction: r,
      imageData: {
        getDirection: () => r,
        getDimensions: () => e12,
        getRange: () => [0, 1],
        getSpacing: () => t,
        worldToIndex: (e13) => [
          e13[0],
          e13[1] + a,
          e13[2]
        ],
        indexToWorld: (e13) => [
          e13[0],
          e13[1] - a,
          e13[2]
        ]
      },
      hasPixelSpacing: false,
      calibration: this.calibration,
      preScale: { scaled: false },
      metadata: { Modality: "ECG" }
    };
  }
  getSliceViewInfo() {
    throw Error("Method not implemented for ECG viewport.");
  }
}, viewportTypeToViewportClass_default = {
  [ViewportType_default.ORTHOGRAPHIC]: VolumeViewport_default,
  [ViewportType_default.PERSPECTIVE]: VolumeViewport_default,
  [ViewportType_default.STACK]: StackViewport_default,
  [ViewportType_default.VOLUME_3D]: VolumeViewport3D_default,
  [ViewportType_default.VIDEO]: VideoViewport_default,
  [ViewportType_default.WHOLE_SLIDE]: WSIViewport_default,
  [ViewportType_default.ECG]: ECGViewport_default
};
function viewportTypeUsesCustomRenderingPipeline(e12) {
  return viewportTypeToViewportClass_default[e12].useCustomRenderingPipeline;
}
var PANEL_CONFIG = {
  WIDTH: 160,
  HEIGHT: 96,
  TEXT_PADDING: 3,
  TEXT_Y_OFFSET: 2,
  GRAPH_Y_OFFSET: 15,
  GRAPH_WIDTH: 150,
  GRAPH_HEIGHT: 70,
  FONT_SIZE: 9,
  FONT_FAMILY: "Helvetica,Arial,sans-serif",
  GRAPH_ALPHA: 0.9
}, STATS_CONFIG = {
  UPDATE_INTERVAL: 1e3,
  MAX_MS_VALUE: 200,
  MAX_FPS_VALUE: 300,
  OVERLAY_STYLES: {
    position: "fixed",
    top: "0px",
    right: "0px",
    left: "auto",
    zIndex: "9999",
    cursor: "pointer",
    opacity: "0.9"
  }
}, CONVERSION = {
  BYTES_TO_MB: 1048576,
  MS_PER_SECOND: 1e3
}, PANEL_CONFIGS = [
  {
    name: "FPS",
    foregroundColor: "#0ff",
    backgroundColor: "#002"
  },
  {
    name: "MS",
    foregroundColor: "#0f0",
    backgroundColor: "#020"
  },
  {
    name: "MB",
    foregroundColor: "#f08",
    backgroundColor: "#201"
  }
], StatsPanel = class {
  constructor(e12, t, n) {
    this.minValue = Infinity, this.maxValue = 0, this.name = e12, this.foregroundColor = t, this.backgroundColor = n, this.devicePixelRatio = Math.round(window.devicePixelRatio || 1), this.dimensions = this.calculateDimensions(), this.dom = this.createCanvas(), this.context = this.initializeContext(), this.drawInitialPanel();
  }
  update(e12, t) {
    this.updateMinMax(e12), this.clearTextArea(), this.drawText(e12), this.scrollGraph(), this.drawNewValue(e12, t);
  }
  calculateDimensions() {
    let e12 = this.devicePixelRatio;
    return {
      width: PANEL_CONFIG.WIDTH * e12,
      height: PANEL_CONFIG.HEIGHT * e12,
      textX: PANEL_CONFIG.TEXT_PADDING * e12,
      textY: PANEL_CONFIG.TEXT_Y_OFFSET * e12,
      graphX: PANEL_CONFIG.TEXT_PADDING * e12,
      graphY: PANEL_CONFIG.GRAPH_Y_OFFSET * e12,
      graphWidth: PANEL_CONFIG.GRAPH_WIDTH * e12,
      graphHeight: PANEL_CONFIG.GRAPH_HEIGHT * e12
    };
  }
  createCanvas() {
    let e12 = document.createElement("canvas");
    return e12.width = this.dimensions.width, e12.height = this.dimensions.height, e12.style.cssText = `width:${PANEL_CONFIG.WIDTH}px;height:${PANEL_CONFIG.HEIGHT}px`, e12;
  }
  initializeContext() {
    let e12 = this.dom.getContext("2d");
    if (!e12)
      throw Error("Failed to get 2D context");
    return e12.font = `bold ${PANEL_CONFIG.FONT_SIZE * this.devicePixelRatio}px ${PANEL_CONFIG.FONT_FAMILY}`, e12.textBaseline = "top", e12;
  }
  drawInitialPanel() {
    let { width: e12, height: t, textX: n, textY: r, graphX: a, graphY: o, graphWidth: s, graphHeight: c } = this.dimensions;
    this.context.fillStyle = this.backgroundColor, this.context.fillRect(0, 0, e12, t), this.context.fillStyle = this.foregroundColor, this.context.fillText(this.name, n, r), this.context.fillRect(a, o, s, c), this.context.fillStyle = this.backgroundColor, this.context.globalAlpha = PANEL_CONFIG.GRAPH_ALPHA, this.context.fillRect(a, o, s, c), this.context.globalAlpha = 1;
  }
  updateMinMax(e12) {
    this.minValue = Math.min(this.minValue, e12), this.maxValue = Math.max(this.maxValue, e12);
  }
  clearTextArea() {
    let { width: e12, graphY: t } = this.dimensions;
    this.context.fillStyle = this.backgroundColor, this.context.fillRect(0, 0, e12, t);
  }
  drawText(e12) {
    let { textX: t, textY: n } = this.dimensions, r = this.formatText(e12);
    this.context.fillStyle = this.foregroundColor, this.context.fillText(r, t, n);
  }
  formatText(e12) {
    let t = Math.round(e12), n = Math.round(this.minValue), r = Math.round(this.maxValue);
    return `${t} ${this.name} (${n}-${r})`;
  }
  scrollGraph() {
    let { graphX: e12, graphY: t, graphWidth: n, graphHeight: r } = this.dimensions, a = this.devicePixelRatio;
    this.context.drawImage(this.dom, e12 + a, t, n - a, r, e12, t, n - a, r);
  }
  drawNewValue(e12, t) {
    let { graphX: n, graphY: r, graphWidth: a, graphHeight: o } = this.dimensions, s = this.devicePixelRatio, c = n + a - s;
    this.context.fillStyle = this.foregroundColor, this.context.fillRect(c, r, s, o);
    let l = Math.round((1 - e12 / t) * o);
    this.context.fillStyle = this.backgroundColor, this.context.globalAlpha = PANEL_CONFIG.GRAPH_ALPHA, this.context.fillRect(c, r, s, l), this.context.globalAlpha = 1;
  }
}, PanelType;
(function(e12) {
  e12[e12.FPS = 0] = "FPS", e12[e12.MS = 1] = "MS", e12[e12.MEMORY = 2] = "MEMORY";
})(PanelType ||= {});
const StatsOverlay = class e8 {
  static {
    this.instance = null;
  }
  constructor() {
    this.dom = null, this.currentMode = 0, this.startTime = 0, this.lastUpdateTime = 0, this.frameCount = 0, this.panels = /* @__PURE__ */ new Map(), this.animationFrameId = null, this.isSetup = false;
  }
  static getInstance() {
    return e8.instance ||= new e8(), e8.instance;
  }
  setup() {
    if (!this.isSetup)
      try {
        this.dom = this.createOverlayElement(), this.startTime = performance.now(), this.lastUpdateTime = this.startTime, this.initializePanels(), this.showPanel(PanelType.FPS), this.applyOverlayStyles(), document.body.appendChild(this.dom), this.startLoop(), this.isSetup = true;
      } catch (e12) {
        console.warn("Failed to setup stats overlay:", e12);
      }
  }
  cleanup() {
    this.stopLoop(), this.dom && this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.dom = null, this.panels.clear(), this.isSetup = false;
  }
  showPanel(e12) {
    Array.from(this.dom.children).forEach((t, n) => {
      t.style.display = n === e12 ? "block" : "none";
    }), this.currentMode = e12;
  }
  update() {
    this.startTime = this.updateStats();
  }
  createOverlayElement() {
    let e12 = document.createElement("div");
    return e12.addEventListener("click", this.handleClick.bind(this), false), e12;
  }
  applyOverlayStyles() {
    Object.assign(this.dom.style, STATS_CONFIG.OVERLAY_STYLES);
  }
  handleClick(e12) {
    e12.preventDefault();
    let t = this.dom.children.length;
    this.showPanel((this.currentMode + 1) % t);
  }
  initializePanels() {
    let e12 = new StatsPanel(PANEL_CONFIGS[PanelType.FPS].name, PANEL_CONFIGS[PanelType.FPS].foregroundColor, PANEL_CONFIGS[PanelType.FPS].backgroundColor);
    this.addPanel(PanelType.FPS, e12);
    let t = new StatsPanel(PANEL_CONFIGS[PanelType.MS].name, PANEL_CONFIGS[PanelType.MS].foregroundColor, PANEL_CONFIGS[PanelType.MS].backgroundColor);
    if (this.addPanel(PanelType.MS, t), this.isMemoryAvailable()) {
      let e13 = new StatsPanel(PANEL_CONFIGS[PanelType.MEMORY].name, PANEL_CONFIGS[PanelType.MEMORY].foregroundColor, PANEL_CONFIGS[PanelType.MEMORY].backgroundColor);
      this.addPanel(PanelType.MEMORY, e13);
    }
  }
  isMemoryAvailable() {
    return performance.memory !== void 0;
  }
  addPanel(e12, t) {
    this.dom.appendChild(t.dom), this.panels.set(e12, t);
  }
  startLoop() {
    let e12 = () => {
      this.update(), this.animationFrameId = requestAnimationFrame(e12);
    };
    this.animationFrameId = requestAnimationFrame(e12);
  }
  stopLoop() {
    this.animationFrameId !== null && (cancelAnimationFrame(this.animationFrameId), this.animationFrameId = null);
  }
  updateStats() {
    this.frameCount++;
    let e12 = performance.now(), t = e12 - this.startTime, n = this.panels.get(PanelType.MS);
    if (n && n.update(t, STATS_CONFIG.MAX_MS_VALUE), e12 >= this.lastUpdateTime + STATS_CONFIG.UPDATE_INTERVAL) {
      let t2 = this.frameCount * CONVERSION.MS_PER_SECOND / (e12 - this.lastUpdateTime), n2 = this.panels.get(PanelType.FPS);
      n2 && n2.update(t2, STATS_CONFIG.MAX_FPS_VALUE), this.lastUpdateTime = e12, this.frameCount = 0, this.updateMemoryPanel();
    }
    return e12;
  }
  updateMemoryPanel() {
    let e12 = this.panels.get(PanelType.MEMORY);
    if (!e12)
      return;
    let t = performance;
    if (t.memory) {
      let n = t.memory.usedJSHeapSize / CONVERSION.BYTES_TO_MB, r = t.memory.jsHeapSizeLimit / CONVERSION.BYTES_TO_MB;
      e12.update(n, r);
    }
  }
}.getInstance();
function convertColorArrayToRgbString(e12) {
  return Array.isArray(e12) ? `rgb(${e12.map((e13) => Math.round(e13 * 255)).join(",")})` : e12;
}
var BaseRenderingEngine_default = class {
  constructor(e12) {
    if (this._needsRender = /* @__PURE__ */ new Set(), this._animationFrameSet = false, this._animationFrameHandle = null, this.renderFrameOfReference = (e13) => {
      let t = this._getViewportsAsArray().map((t2) => {
        if (t2.getFrameOfReferenceUID() === e13)
          return t2.id;
      });
      this.renderViewports(t);
    }, this.id = e12 || uuidv4(), this.useCPURendering = getShouldUseCPURendering(), renderingEngineCache_default.set(this), !isCornerstoneInitialized())
      throw Error("@cornerstonejs/core is not initialized, run init() first");
    this._viewports = /* @__PURE__ */ new Map(), this.hasBeenDestroyed = false, getConfiguration()?.debug?.statsOverlay && StatsOverlay.setup();
  }
  enableElement(e12) {
    let t = this._normalizeViewportInputEntry(e12);
    this._throwIfDestroyed();
    let { element: n, viewportId: r } = t;
    if (!n)
      throw Error("No element provided");
    this.getViewport(r) && this.disableElement(r);
    let { type: a } = t, o = viewportTypeUsesCustomRenderingPipeline(a);
    !this.useCPURendering && !o ? this.enableVTKjsDrivenViewport(t) : this.addCustomViewport(t);
    let s = getOrCreateCanvas_default(n), { background: c } = t.defaultOptions;
    this.fillCanvasWithBackgroundColor(s, c);
  }
  disableElement(e12) {
    this._throwIfDestroyed();
    let t = this.getViewport(e12);
    if (!t) {
      console.warn(`viewport ${e12} does not exist`);
      return;
    }
    this._resetViewport(t), !viewportTypeUsesCustomRenderingPipeline(t.type) && !this.useCPURendering && this.offscreenMultiRenderWindow && this.offscreenMultiRenderWindow.removeRenderer(e12), this._removeViewport(e12), t.isDisabled = true, this._needsRender.delete(e12), this.getViewports().length || this._clearAnimationFrame();
  }
  setViewports(e12) {
    let t = this._normalizeViewportInputEntries(e12);
    this._throwIfDestroyed(), this._reset();
    let n = [], r = [];
    t.forEach((e13) => {
      !this.useCPURendering && !viewportTypeUsesCustomRenderingPipeline(e13.type) ? n.push(e13) : r.push(e13);
    }), this.setVtkjsDrivenViewports(n), this.setCustomViewports(r), t.forEach((e13) => {
      let t2 = getOrCreateCanvas_default(e13.element), { background: n2 } = e13.defaultOptions;
      this.fillCanvasWithBackgroundColor(t2, n2);
    });
  }
  resize(e12 = true, t = true) {
    this._throwIfDestroyed();
    let n = this._getViewportsAsArray(), r = [], a = [];
    n.forEach((e13) => {
      viewportTypeUsesCustomRenderingPipeline(e13.type) ? a.push(e13) : r.push(e13);
    }), r.length && this._resizeVTKViewports(r, t, e12), a.length && this._resizeUsingCustomResizeHandler(a, t, e12);
  }
  getViewport(e12) {
    return this._viewports?.get(e12);
  }
  getViewports() {
    return this._throwIfDestroyed(), this._getViewportsAsArray();
  }
  getStackViewport(e12) {
    this._throwIfDestroyed();
    let t = this.getViewport(e12);
    if (!t)
      throw Error(`Viewport with Id ${e12} does not exist`);
    if (!(t instanceof StackViewport_default))
      throw Error(`Viewport with Id ${e12} is not a StackViewport.`);
    return t;
  }
  getStackViewports() {
    return this._throwIfDestroyed(), this.getViewports().filter((e12) => e12 instanceof StackViewport_default);
  }
  getVolumeViewports() {
    return this._throwIfDestroyed(), this.getViewports().filter((e12) => e12 instanceof BaseVolumeViewport_default);
  }
  render() {
    let e12 = this.getViewports().map((e13) => e13.id);
    this._setViewportsToBeRenderedNextFrame(e12);
  }
  renderViewports(e12) {
    this._setViewportsToBeRenderedNextFrame(e12);
  }
  renderViewport(e12) {
    this._setViewportsToBeRenderedNextFrame([e12]);
  }
  destroy() {
    this.hasBeenDestroyed ||= (StatsOverlay.cleanup(), this.useCPURendering || (this._getViewportsAsArray().forEach((e12) => {
      this.offscreenMultiRenderWindow && this.offscreenMultiRenderWindow.removeRenderer(e12.id);
    }), this.offscreenMultiRenderWindow && this.offscreenMultiRenderWindow.delete(), delete this.offscreenMultiRenderWindow), this._reset(), renderingEngineCache_default.delete(this.id), true);
  }
  fillCanvasWithBackgroundColor(e12, t) {
    let n = e12.getContext("2d");
    n.fillStyle = t ? convertColorArrayToRgbString(t) : "black", n.fillRect(0, 0, e12.width, e12.height);
  }
  _normalizeViewportInputEntry(e12) {
    let { type: t, defaultOptions: n } = e12, r = n;
    return (!r || Object.keys(r).length === 0) && (r = {
      background: [
        0,
        0,
        0
      ],
      orientation: null,
      displayArea: null
    }, t === ViewportType_default.ORTHOGRAPHIC && (r = {
      ...r,
      orientation: OrientationAxis_default.AXIAL
    })), {
      ...e12,
      defaultOptions: r
    };
  }
  _normalizeViewportInputEntries(e12) {
    let t = [];
    return e12.forEach((e13) => {
      t.push(this._normalizeViewportInputEntry(e13));
    }), t;
  }
  _resizeUsingCustomResizeHandler(e12, t = true, n = true) {
    e12.forEach((e13) => {
      typeof e13.resize == "function" && e13.resize();
    }), e12.forEach((e13) => {
      let n2 = e13.getCamera();
      e13.resetCamera(), t && e13.setCamera(n2);
    }), n && this.render();
  }
  _removeViewport(e12) {
    if (!this.getViewport(e12)) {
      console.warn(`viewport ${e12} does not exist`);
      return;
    }
    this._viewports.delete(e12);
  }
  addCustomViewport(e12) {
    let { element: t, viewportId: n, type: r, defaultOptions: o } = e12;
    t.tabIndex = -1;
    let s = getOrCreateCanvas_default(t), { clientWidth: c, clientHeight: l } = s;
    (s.width !== c || s.height !== l) && (s.width = c, s.height = l);
    let u = {
      id: n,
      renderingEngineId: this.id,
      element: t,
      type: r,
      canvas: s,
      sx: 0,
      sy: 0,
      sWidth: c,
      sHeight: l,
      defaultOptions: o || {}
    }, d = viewportTypeToViewportClass_default[r], f = new d(u);
    this._viewports.set(n, f);
    let p = {
      element: t,
      viewportId: n,
      renderingEngineId: this.id
    };
    triggerEvent(eventTarget_default, Events_default.ELEMENT_ENABLED, p);
  }
  getRenderer(e12) {
    return this.offscreenMultiRenderWindow.getRenderer(e12);
  }
  getOffscreenMultiRenderWindow(e12) {
    if (this.useCPURendering)
      throw Error("Offscreen multi render window is not available when using CPU rendering.");
    return this.offscreenMultiRenderWindow;
  }
  setCustomViewports(e12) {
    e12.forEach((e13) => {
      this.addCustomViewport(e13);
    });
  }
  _getViewportsAsArray() {
    return Array.from(this._viewports.values());
  }
  _setViewportsToBeRenderedNextFrame(e12) {
    e12.forEach((e13) => {
      this._needsRender.add(e13);
      let t = this._viewports.get(e13);
      t && (t.viewportStatus = ViewportStatus_default.NEEDS_RENDER);
    }), this._render();
  }
  _render() {
    this._needsRender.size > 0 && !this._animationFrameSet && (this._animationFrameHandle = window.requestAnimationFrame(this._renderFlaggedViewports), this._animationFrameSet = true);
  }
  _resetViewport(e12) {
    let t = this.id, { element: n, canvas: r, id: o } = e12, s = {
      element: n,
      viewportId: o,
      renderingEngineId: t
    };
    e12.removeWidgets(), triggerEvent(eventTarget_default, Events_default.ELEMENT_DISABLED, s), n.removeAttribute("data-viewport-uid"), n.removeAttribute("data-rendering-engine-uid"), r.getContext("2d").clearRect(0, 0, r.width, r.height);
  }
  _clearAnimationFrame() {
    window.cancelAnimationFrame(this._animationFrameHandle), this._needsRender.clear(), this._animationFrameSet = false, this._animationFrameHandle = null;
  }
  _reset() {
    this._getViewportsAsArray().forEach((e12) => {
      this._resetViewport(e12);
    }), this._clearAnimationFrame(), this._viewports = /* @__PURE__ */ new Map();
  }
  _throwIfDestroyed() {
    if (this.hasBeenDestroyed)
      throw Error("this.destroy() has been manually called to free up memory, can not longer use this instance. Instead make a new one.");
  }
}, TiledRenderingEngine_default = class extends BaseRenderingEngine_default {
  constructor(e12) {
    super(e12), this._renderFlaggedViewports = () => {
      this._throwIfDestroyed(), this.useCPURendering || this.performVtkDrawCall();
      let e13 = this._getViewportsAsArray(), t = [];
      for (let n = 0; n < e13.length; n++) {
        let r = e13[n];
        if (this._needsRender.has(r.id)) {
          let e14 = this.renderViewportUsingCustomOrVtkPipeline(r);
          if (t.push(e14), r.setRendered(), this._needsRender.delete(r.id), this._needsRender.size === 0)
            break;
        }
      }
      this._animationFrameSet = false, this._animationFrameHandle = null, t.forEach((e14) => {
        e14?.element && triggerEvent(e14.element, Events_default.IMAGE_RENDERED, e14);
      });
    }, this.useCPURendering || (this.offscreenMultiRenderWindow = vtkOffscreenMultiRenderWindow_default.newInstance(), this.offScreenCanvasContainer = document.createElement("div"), this.offscreenMultiRenderWindow.setContainer(this.offScreenCanvasContainer));
  }
  enableVTKjsDrivenViewport(e12) {
    let t = this._getViewportsAsArray().filter((e13) => viewportTypeUsesCustomRenderingPipeline(e13.type) === false), n = t.map((e13) => e13.canvas), r = getOrCreateCanvas_default(e12.element);
    n.push(r);
    let { offScreenCanvasWidth: a, offScreenCanvasHeight: o } = this._resizeOffScreenCanvas(n), s = this._resize(t, a, o), c = {
      ...e12,
      canvas: r
    };
    this.addVtkjsDrivenViewport(c, {
      offScreenCanvasWidth: a,
      offScreenCanvasHeight: o,
      xOffset: s
    });
  }
  addVtkjsDrivenViewport(e12, t) {
    let { element: n, canvas: r, viewportId: o, type: s, defaultOptions: c } = e12;
    n.tabIndex = -1;
    let { offScreenCanvasWidth: u, offScreenCanvasHeight: d, xOffset: f } = t, { sxStartDisplayCoords: p, syStartDisplayCoords: m, sxEndDisplayCoords: h, syEndDisplayCoords: g, sx: _, sy: v, sWidth: y, sHeight: b } = this._getViewportCoordsOnOffScreenCanvas(e12, u, d, f);
    this.offscreenMultiRenderWindow.addRenderer({
      viewport: [
        p,
        m,
        h,
        g
      ],
      id: o,
      background: c.background ? c.background : [
        0,
        0,
        0
      ]
    });
    let S = {
      id: o,
      element: n,
      renderingEngineId: this.id,
      type: s,
      canvas: r,
      sx: _,
      sy: v,
      sWidth: y,
      sHeight: b,
      defaultOptions: c || {}
    }, C;
    if (s === ViewportType_default.STACK)
      C = new StackViewport_default(S);
    else if (s === ViewportType_default.ORTHOGRAPHIC || s === ViewportType_default.PERSPECTIVE)
      C = new VolumeViewport_default(S);
    else if (s === ViewportType_default.VOLUME_3D)
      C = new VolumeViewport3D_default(S);
    else
      throw Error(`Viewport Type ${s} is not supported`);
    this._viewports.set(o, C);
    let w = {
      element: n,
      viewportId: o,
      renderingEngineId: this.id
    };
    C.suppressEvents || triggerEvent(eventTarget_default, Events_default.ELEMENT_ENABLED, w);
  }
  setVtkjsDrivenViewports(e12) {
    if (e12.length) {
      let t = e12.map((e13) => getOrCreateCanvas_default(e13.element));
      t.forEach((e13) => {
        let t2 = window.devicePixelRatio || 1, n2 = e13.getBoundingClientRect();
        e13.width = n2.width * t2, e13.height = n2.height * t2;
      });
      let { offScreenCanvasWidth: n, offScreenCanvasHeight: r } = this._resizeOffScreenCanvas(t), a = 0;
      for (let o = 0; o < e12.length; o++) {
        let s = e12[o], c = t[o], l = {
          ...s,
          canvas: c
        };
        this.addVtkjsDrivenViewport(l, {
          offScreenCanvasWidth: n,
          offScreenCanvasHeight: r,
          xOffset: a
        }), a += c.width;
      }
    }
  }
  _resizeVTKViewports(e12, t = true, n = true) {
    let r = e12.map((e13) => getOrCreateCanvas_default(e13.element));
    if (r.forEach((e13) => {
      let t2 = window.devicePixelRatio || 1;
      e13.width = e13.clientWidth * t2, e13.height = e13.clientHeight * t2;
    }), r.length) {
      let { offScreenCanvasWidth: t2, offScreenCanvasHeight: n2 } = this._resizeOffScreenCanvas(r);
      this._resize(e12, t2, n2);
    }
    e12.forEach((e13) => {
      let n2 = e13.getCamera(), r2 = e13.getRotation(), { flipHorizontal: a } = n2;
      e13.resetCameraForResize();
      let o = e13.getDisplayArea();
      t && (o ? (a && e13.setCamera({ flipHorizontal: a }), r2 && e13.setViewPresentation({ rotation: r2 })) : e13.setCamera(n2));
    }), n && this.render();
  }
  performVtkDrawCall() {
    let { offscreenMultiRenderWindow: e12 } = this, t = e12.getRenderWindow(), n = e12.getRenderers();
    if (n.length) {
      for (let e13 = 0; e13 < n.length; e13++) {
        let { renderer: t2, id: r } = n[e13];
        this._needsRender.has(r) ? t2.setDraw(true) : t2.setDraw(false);
      }
      t.render();
      for (let e13 = 0; e13 < n.length; e13++)
        n[e13].renderer.setDraw(false);
    }
  }
  renderViewportUsingCustomOrVtkPipeline(e12) {
    let t;
    if (e12.sWidth < 2 || e12.sHeight < 2) {
      console.warn("Viewport is too small", e12.sWidth, e12.sHeight);
      return;
    }
    if (viewportTypeUsesCustomRenderingPipeline(e12.type) === true)
      t = e12.customRenderViewportToCanvas();
    else {
      if (this.useCPURendering)
        throw Error("GPU not available, and using a viewport with no custom render pipeline.");
      let { offscreenMultiRenderWindow: n } = this, r = n.getOpenGLRenderWindow().get3DContext().canvas;
      t = this._renderViewportFromVtkCanvasToOnscreenCanvas(e12, r);
    }
    return t;
  }
  _renderViewportFromVtkCanvasToOnscreenCanvas(e12, t) {
    let { element: n, canvas: r, sx: a, sy: o, sWidth: s, sHeight: c, id: l, renderingEngineId: u, suppressEvents: d } = e12, { width: f, height: p } = r;
    return r.getContext("2d").drawImage(t, a, o, s, c, 0, 0, f, p), {
      element: n,
      suppressEvents: d,
      viewportId: l,
      renderingEngineId: u,
      viewportStatus: e12.viewportStatus
    };
  }
  _resizeOffScreenCanvas(e12) {
    let { offScreenCanvasContainer: t, offscreenMultiRenderWindow: n } = this, r = Math.max(...e12.map((e13) => e13.height)), a = 0;
    return e12.forEach((e13) => {
      a += e13.width;
    }), t.width = a, t.height = r, n.resize(), {
      offScreenCanvasWidth: a,
      offScreenCanvasHeight: r
    };
  }
  _resize(e12, t, n) {
    let r = 0;
    for (let a = 0; a < e12.length; a++) {
      let o = e12[a], { sxStartDisplayCoords: s, syStartDisplayCoords: c, sxEndDisplayCoords: l, syEndDisplayCoords: u, sx: d, sy: f, sWidth: p, sHeight: m } = this._getViewportCoordsOnOffScreenCanvas(o, t, n, r);
      r += o.canvas.width, o.sx = d, o.sy = f, o.sWidth = p, o.sHeight = m, this.offscreenMultiRenderWindow.getRenderer(o.id).setViewport(s, c, l, u);
    }
    return r;
  }
  _getViewportCoordsOnOffScreenCanvas(e12, t, n, r) {
    let { canvas: a } = e12, { width: o, height: s } = a, c = r, l = c / t, u = 0 + (n - s) / n, d = o / t, f = s / n;
    return {
      sxStartDisplayCoords: l,
      syStartDisplayCoords: u,
      sxEndDisplayCoords: l + d,
      syEndDisplayCoords: u + f,
      sx: c,
      sy: 0,
      sWidth: o,
      sHeight: s
    };
  }
}, WebGLContextPool_default = class {
  constructor(e12) {
    this.contexts = [], this.offScreenCanvasContainers = [], this.viewportToContext = /* @__PURE__ */ new Map(), this.viewportSizes = /* @__PURE__ */ new Map(), this.contextMaxSizes = /* @__PURE__ */ new Map();
    for (let t = 0; t < e12; t++) {
      let e13 = vtkOffscreenMultiRenderWindow_default.newInstance(), t2 = document.createElement("div");
      e13.setContainer(t2), this.contexts.push(e13), this.offScreenCanvasContainers.push(t2);
    }
  }
  getContextByIndex(e12) {
    return e12 >= 0 && e12 < this.contexts.length ? {
      context: this.contexts[e12],
      container: this.offScreenCanvasContainers[e12]
    } : null;
  }
  assignViewportToContext(e12, t) {
    this.viewportToContext.set(e12, t);
  }
  getContextIndexForViewport(e12) {
    return this.viewportToContext.get(e12);
  }
  getAllContexts() {
    return this.contexts;
  }
  getContextCount() {
    return this.contexts.length;
  }
  updateViewportSize(e12, t, n) {
    let r = this.viewportToContext.get(e12);
    if (r === void 0)
      return false;
    this.viewportSizes.set(e12, {
      width: t,
      height: n
    });
    let a = this.contextMaxSizes.get(r), o = this.calculateMaxSizeForContext(r);
    return this.contextMaxSizes.set(r, o), !a || a.width !== o.width || a.height !== o.height;
  }
  getMaxSizeForContext(e12) {
    return this.contextMaxSizes.get(e12);
  }
  calculateMaxSizeForContext(e12) {
    let t = 0, n = 0;
    return this.viewportToContext.forEach((r, a) => {
      if (r === e12) {
        let e13 = this.viewportSizes.get(a);
        e13 && (t = Math.max(t, e13.width), n = Math.max(n, e13.height));
      }
    }), {
      width: t,
      height: n
    };
  }
  removeViewport(e12) {
    let t = this.viewportToContext.get(e12);
    if (this.viewportToContext.delete(e12), this.viewportSizes.delete(e12), t !== void 0) {
      let e13 = this.calculateMaxSizeForContext(t);
      this.contextMaxSizes.set(t, e13);
    }
  }
  destroy() {
    this.contexts.forEach((e12) => {
      e12.delete();
    }), this.contexts = [], this.offScreenCanvasContainers = [], this.viewportToContext.clear(), this.viewportSizes.clear(), this.contextMaxSizes.clear();
  }
}, getViewportRenderScale = (e12) => {
  let t = e12?.options?.renderScale ?? e12?.defaultOptions?.renderScale;
  return Number.isFinite(t) && t > 0 && t <= 1 ? t : 1;
}, ContextPoolRenderingEngine_default = class extends BaseRenderingEngine_default {
  constructor(e12) {
    super(e12), this._renderFlaggedViewports = () => {
      this._throwIfDestroyed();
      let e13 = this._getViewportsAsArray().filter((e14) => this._needsRender.has(e14.id));
      if (e13.length === 0) {
        this._animationFrameSet = false, this._animationFrameHandle = null;
        return;
      }
      let t2 = e13.map((e14) => {
        let t3 = this.renderViewportUsingCustomOrVtkPipeline(e14);
        return e14.setRendered(), this._needsRender.delete(e14.id), t3;
      });
      this._animationFrameSet = false, this._animationFrameHandle = null, t2.forEach((e14) => {
        e14?.element && triggerEvent(e14.element, Events_default.IMAGE_RENDERED, e14);
      });
    };
    let { rendering: t } = getConfiguration(), { webGlContextCount: n } = t;
    this.useCPURendering || (this.contextPool = new WebGLContextPool_default(n));
  }
  enableVTKjsDrivenViewport(e12) {
    let t = this._getViewportsAsArray().filter((e13) => viewportTypeUsesCustomRenderingPipeline(e13.type) === false).map((e13) => e13.canvas), n = getViewportRenderScale({ defaultOptions: e12.defaultOptions }), r = getOrCreateCanvas_default(e12.element, n);
    updateCanvasSizeAndAspectRatio(r, void 0, n), t.push(r);
    let a = {
      ...e12,
      canvas: r
    };
    this.addVtkjsDrivenViewport(a);
  }
  addVtkjsDrivenViewport(e12) {
    let { element: t, canvas: n, viewportId: r, type: o, defaultOptions: s } = e12;
    t.tabIndex = -1;
    let c = 0;
    if (o === ViewportType_default.STACK) {
      let e13 = this.contextPool.getAllContexts();
      c = this._viewports.size % e13.length;
    }
    this.contextPool.assignViewportToContext(r, c), this.contextPool.updateViewportSize(r, n.width, n.height);
    let { context: u, container: d } = this.contextPool.getContextByIndex(c), f = this.contextPool.getMaxSizeForContext(c);
    d.width = f.width, d.height = f.height, u.resize(), u.addRenderer({
      viewport: [
        0,
        0,
        1,
        1
      ],
      id: r,
      background: s.background ? s.background : [
        0,
        0,
        0
      ]
    });
    let p = {
      id: r,
      element: t,
      renderingEngineId: this.id,
      type: o,
      canvas: n,
      sx: 0,
      sy: 0,
      sWidth: n.width,
      sHeight: n.height,
      defaultOptions: s || {}
    }, m;
    if (o === ViewportType_default.STACK)
      m = new StackViewport_default(p);
    else if (o === ViewportType_default.ORTHOGRAPHIC || o === ViewportType_default.PERSPECTIVE)
      m = new VolumeViewport_default(p);
    else if (o === ViewportType_default.VOLUME_3D)
      m = new VolumeViewport3D_default(p);
    else
      throw Error(`Viewport Type ${o} is not supported`);
    this._viewports.set(r, m);
    let h = {
      element: t,
      viewportId: r,
      renderingEngineId: this.id
    };
    m.suppressEvents || triggerEvent(eventTarget_default, Events_default.ELEMENT_ENABLED, h);
  }
  setVtkjsDrivenViewports(e12) {
    if (e12.length) {
      let t = e12.map((e13) => {
        let t2 = getViewportRenderScale({ defaultOptions: e13.defaultOptions });
        return getOrCreateCanvas_default(e13.element, t2);
      });
      t.forEach((t2, n) => {
        updateCanvasSizeAndAspectRatio(t2, void 0, getViewportRenderScale({ defaultOptions: e12[n].defaultOptions }));
      });
      for (let n = 0; n < e12.length; n++) {
        let r = e12[n], a = t[n], o = {
          ...r,
          canvas: a
        };
        this.addVtkjsDrivenViewport(o);
      }
    }
  }
  _resizeVTKViewports(e12, t = true, n = true) {
    let r = window.devicePixelRatio || 1, a = [];
    for (let t2 of e12) {
      let e13 = getViewportRenderScale(t2), n2 = getOrCreateCanvas_default(t2.element, e13), o = Math.round(n2.clientWidth * r * e13), s = Math.round(n2.clientHeight * r * e13);
      if (o === 0 || s === 0)
        continue;
      let c = n2.width, l = n2.height;
      o === c && s === l || a.push(t2);
    }
    if (a.length !== 0) {
      for (let e13 of a) {
        let t2 = getViewportRenderScale(e13), n2 = getOrCreateCanvas_default(e13.element, t2), a2 = Math.round(n2.clientWidth * r * t2), o = Math.round(n2.clientHeight * r * t2), s = Math.max(2, a2), c = Math.max(2, o);
        e13.sWidth = s, e13.sHeight = c;
      }
      this._animationFrameSet || (e12.length && this._resize(e12), e12.forEach((e13) => {
        let n2 = e13.getCamera(), r2 = e13.getRotation(), { flipHorizontal: a2 } = n2;
        e13.resetCameraForResize();
        let o = e13.getDisplayArea();
        t && (o ? (a2 && e13.setCamera({ flipHorizontal: a2 }), r2 && e13.setViewPresentation({ rotation: r2 })) : e13.setCamera(n2));
      }), n && this.render());
    }
  }
  renderViewportUsingCustomOrVtkPipeline(e12) {
    if (viewportTypeUsesCustomRenderingPipeline(e12.type))
      return e12.customRenderViewportToCanvas();
    if (this.useCPURendering)
      throw Error("GPU not available, and using a viewport with no custom render pipeline.");
    let t = this.contextPool.getContextIndexForViewport(e12.id), { context: n, container: r } = this.contextPool.getContextByIndex(t);
    return this._renderViewportWithContext(e12, n, r);
  }
  _renderViewportWithContext(e12, t, n) {
    if (e12.canvas.clientWidth === 0 || e12.canvas.clientHeight === 0)
      return;
    if (e12.sWidth < 2 || e12.sHeight < 2) {
      console.warn("Viewport is too small", e12.sWidth, e12.sHeight);
      return;
    }
    if (viewportTypeUsesCustomRenderingPipeline(e12.type))
      return e12.customRenderViewportToCanvas();
    if (this.useCPURendering)
      throw Error("GPU not available, and using a viewport with no custom render pipeline.");
    t.getRenderer(e12.id) || t.addRenderer({
      viewport: [
        0,
        0,
        1,
        1
      ],
      id: e12.id,
      background: e12.defaultOptions?.background || [
        0,
        0,
        0
      ]
    });
    let r = t.getRenderWindow(), a = r.getViews()[0], o = a.getRenderPasses(), s = this.getViewportRenderPasses(e12.id);
    s && a.setRenderPasses(s), this._resizeOffScreenCanvasForViewport(e12, n, t);
    let c = t.getRenderer(e12.id), l = this.contextPool.getContextIndexForViewport(e12.id), u = this.contextPool.getMaxSizeForContext(l), d = e12.sWidth, f = e12.sHeight, p = Math.min(1, d / u.width), m = Math.min(1, f / u.height);
    c.setViewport(0, 0, p, m);
    let h = t.getRenderers();
    h.forEach(({ renderer: t2, id: n2 }) => {
      t2.setDraw(n2 === e12.id);
    });
    let g = this.getWidgetRenderers();
    g.forEach((t2, n2) => {
      n2.setDraw(t2 === e12.id);
    }), r.render(), h.forEach(({ renderer: e13 }) => e13.setDraw(false)), g.forEach((e13, t2) => {
      t2.setDraw(false);
    }), o && a.setRenderPasses(o);
    let _ = t.getOpenGLRenderWindow().get3DContext().canvas;
    return this._copyToOnscreenCanvas(e12, _);
  }
  _renderViewportFromVtkCanvasToOnscreenCanvas(e12, t) {
    return this._copyToOnscreenCanvas(e12, t);
  }
  _resizeOffScreenCanvasForViewport(e12, t, n) {
    let r = this.contextPool.getContextIndexForViewport(e12.id);
    if (r === void 0 || !this.contextPool.updateViewportSize(e12.id, e12.sWidth, e12.sHeight))
      return;
    let a = this.contextPool.getMaxSizeForContext(r);
    t.width === a.width && t.height === a.height || (t.width = a.width, t.height = a.height, n.resize());
  }
  _copyToOnscreenCanvas(e12, t) {
    let { element: n, canvas: r, id: a, renderingEngineId: o, suppressEvents: s } = e12, c = e12.sWidth, l = e12.sHeight;
    updateCanvasSizeAndAspectRatio(r, {
      width: c,
      height: l
    });
    let u = r.getContext("2d"), d = this.contextPool.getContextIndexForViewport(a), f = this.contextPool.getMaxSizeForContext(d).height - l;
    return u.drawImage(t, 0, f, c, l, 0, 0, c, l), {
      element: n,
      suppressEvents: s,
      viewportId: a,
      renderingEngineId: o,
      viewportStatus: e12.viewportStatus
    };
  }
  _resize(e12) {
    let t = /* @__PURE__ */ new Set();
    for (let n of e12) {
      n.sx = 0, n.sy = 0;
      let e13 = this.contextPool.getContextIndexForViewport(n.id);
      this.contextPool.updateViewportSize(n.id, n.sWidth, n.sHeight) && t.add(e13);
      let { context: r } = this.contextPool.getContextByIndex(e13), a = r.getRenderer(n.id), o = this.contextPool.getMaxSizeForContext(e13), s = Math.min(1, n.sWidth / o.width), c = Math.min(1, n.sHeight / o.height);
      a.setViewport(0, 0, s, c);
    }
    t.forEach((e13) => {
      let t2 = this.contextPool.getContextByIndex(e13);
      if (t2) {
        let { context: n, container: r } = t2, a = this.contextPool.getMaxSizeForContext(e13);
        r.width = a.width, r.height = a.height, n.resize();
      }
    });
  }
  getWidgetRenderers() {
    let e12 = this._getViewportsAsArray(), t = /* @__PURE__ */ new Map();
    return e12.forEach((e13) => {
      (e13.getWidgets ? e13.getWidgets() : []).forEach((n) => {
        let r = n.getRenderer ? n.getRenderer() : null;
        r && t.set(r, e13.id);
      });
    }), t;
  }
  getViewportRenderPasses(e12) {
    let t = this.getViewport(e12);
    return t?.getRenderPasses ? t.getRenderPasses() : null;
  }
  getRenderer(e12) {
    let t = this.contextPool?.getContextIndexForViewport(e12), { context: n } = this.contextPool.getContextByIndex(t);
    return n.getRenderer(e12);
  }
  disableElement(e12) {
    let t = this.getViewport(e12);
    if (t && (super.disableElement(e12), !viewportTypeUsesCustomRenderingPipeline(t.type) && !this.useCPURendering)) {
      let t2 = this.contextPool.getContextIndexForViewport(e12);
      if (t2 !== void 0) {
        let n = this.contextPool.getContextByIndex(t2);
        if (n) {
          let { context: t3 } = n;
          t3.removeRenderer(e12);
        }
      }
      this.contextPool.removeViewport(e12);
    }
  }
  destroy() {
    this.contextPool && this.contextPool.destroy(), super.destroy();
  }
  getOffscreenMultiRenderWindow(e12) {
    if (this.useCPURendering)
      throw Error("Offscreen multi render window is not available when using CPU rendering.");
    let t = this.contextPool.getContextIndexForViewport(e12);
    return this.contextPool.getContextByIndex(t).context;
  }
}, RenderingEngine_default = class {
  constructor(e12) {
    let t = getConfiguration()?.rendering?.renderingEngineMode;
    switch (t) {
      case RenderingEngineModeEnum_default.Tiled:
        this._implementation = new TiledRenderingEngine_default(e12);
        break;
      case RenderingEngineModeEnum_default.ContextPool:
        this._implementation = new ContextPoolRenderingEngine_default(e12);
        break;
      default:
        console.warn(`RenderingEngine: Unknown rendering engine mode "${t}". Defaulting to Next rendering engine.`), this._implementation = new ContextPoolRenderingEngine_default(e12);
        break;
    }
  }
  get id() {
    return this._implementation.id;
  }
  enableElement(e12) {
    return this._implementation.enableElement(e12);
  }
  disableElement(e12) {
    return this._implementation.disableElement(e12);
  }
  setViewports(e12) {
    return this._implementation.setViewports(e12);
  }
  resize(e12 = true, t = true) {
    return this._implementation.resize(e12, t);
  }
  getViewport(e12) {
    return this._implementation.getViewport(e12);
  }
  getViewports() {
    return this._implementation.getViewports();
  }
  getStackViewport(e12) {
    return this._implementation.getStackViewport(e12);
  }
  getStackViewports() {
    return this._implementation.getStackViewports();
  }
  getVolumeViewports() {
    return this._implementation.getVolumeViewports();
  }
  getRenderer(e12) {
    return this._implementation.getRenderer(e12);
  }
  fillCanvasWithBackgroundColor(e12, t) {
    return this._implementation.fillCanvasWithBackgroundColor(e12, t);
  }
  render() {
    return this._implementation.render();
  }
  renderViewports(e12) {
    return this._implementation.renderViewports(e12);
  }
  renderViewport(e12) {
    return this._implementation.renderViewport(e12);
  }
  destroy() {
    return this._implementation.destroy();
  }
  getOffscreenMultiRenderWindow(e12) {
    return this._implementation.getOffscreenMultiRenderWindow(e12);
  }
}, Surface = class {
  constructor(e12) {
    this._color = [
      200,
      0,
      0
    ], this.id = e12.id, this._points = e12.points, this._polys = e12.polys, this._color = e12.color ?? this._color, this.frameOfReferenceUID = e12.frameOfReferenceUID, this._segmentIndex = e12.segmentIndex, this.sizeInBytes = this._getSizeInBytes(), this._updateCentroid(), this._visible = true;
  }
  _getSizeInBytes() {
    return this._points.length * 4 + this._polys.length * 4;
  }
  _updateCentroid() {
    let e12 = this._points.length / 3, t = 0, n = 0, r = 0;
    for (let e13 = 0; e13 < this._points.length; e13 += 3)
      t += this._points[e13], n += this._points[e13 + 1], r += this._points[e13 + 2];
    this._centroid = [
      t / e12,
      n / e12,
      r / e12
    ];
  }
  get color() {
    return this._color;
  }
  set color(e12) {
    this._color = e12;
  }
  get points() {
    return this._points;
  }
  set points(e12) {
    this._points = e12, this._updateCentroid();
  }
  get polys() {
    return this._polys;
  }
  set polys(e12) {
    this._polys = e12;
  }
  get segmentIndex() {
    return this._segmentIndex;
  }
  get visible() {
    return this._visible;
  }
  set visible(e12) {
    this._visible = e12;
  }
  get centroid() {
    return this._centroid;
  }
  get flatPointsArray() {
    return this._points;
  }
  get totalNumberOfPoints() {
    return this._points.length / 3;
  }
};
function arrayBufferToString(e12) {
  return new TextDecoder("latin1").decode(e12);
}
function extractBinary(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arrayBufferToString(e12), a = t.exec(r);
  if (!a)
    return { text: r };
  let o = a.index + a[0].length, s = r.substring(0, o), c = null, l = n ? n.exec(r) : null;
  return c = l ? {
    text: s + r.substr(l.index),
    binaryBuffer: e12.slice(o, l.index)
  } : {
    text: s,
    binaryBuffer: e12.slice(o)
  }, c;
}
var BinaryHelper = {
  arrayBufferToString,
  extractBinary
}, TYPE_MAPPING = {};
function has(e12) {
  return !!TYPE_MAPPING[e12];
}
function get$2() {
  let e12 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "http", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return TYPE_MAPPING[e12](t);
}
function registerType(e12, t) {
  TYPE_MAPPING[e12] = t;
}
var DataAccessHelper = {
  get: get$2,
  has,
  registerType
};
function getEndianness() {
  let e12 = /* @__PURE__ */ new ArrayBuffer(4), t = new Uint8Array(e12), n = new Uint32Array(e12);
  return t[0] = 161, t[1] = 178, t[2] = 195, t[3] = 212, n[0] === 3569595041 ? "LittleEndian" : n[0] === 2712847316 ? "BigEndian" : null;
}
var ENDIANNESS = getEndianness();
function swapBytes(e12, t) {
  if (t < 2)
    return;
  let n = new Int8Array(e12), r = n.length, a = [];
  for (let e13 = 0; e13 < r; e13 += t) {
    for (let r2 = 0; r2 < t; r2++)
      a.push(n[e13 + r2]);
    for (let r2 = 0; r2 < t; r2++)
      n[e13 + r2] = a.pop();
  }
}
var Endian = {
  ENDIANNESS,
  getEndianness,
  swapBytes
}, { vtkErrorMacro: vtkErrorMacro$3, vtkDebugMacro } = macro, REJECT_COMPRESSION = () => (vtkErrorMacro$3("LiteHttpDataAccessHelper does not support compression. Need to register HttpDataAccessHelper instead."), Promise.reject(/* @__PURE__ */ Error("LiteHttpDataAccessHelper does not support compression. Need to register HttpDataAccessHelper instead."))), requestCount = 0;
function openAsyncXHR(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = new XMLHttpRequest();
  return r.open(e12, t, true), n.headers && Object.entries(n.headers).forEach((e13) => {
    let [t2, n2] = e13;
    return r.setRequestHeader(t2, n2);
  }), n.progressCallback && r.addEventListener("progress", n.progressCallback), r;
}
function fetchBinary(e12) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise((n, r) => {
    let a = openAsyncXHR("GET", e12, t);
    a.onreadystatechange = (e13) => {
      a.readyState === 4 && (a.status === 200 || a.status === 0 ? n(a.response) : r({
        xhr: a,
        e: e13
      }));
    }, a.responseType = "arraybuffer", a.send();
  });
}
function fetchArray(e12, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  return r && r.compression ? REJECT_COMPRESSION() : n.ref && !n.ref.pending ? new Promise((a, o) => {
    let s = openAsyncXHR("GET", [
      t,
      n.ref.basepath,
      n.ref.id
    ].join("/"), r);
    s.onreadystatechange = (t2) => {
      s.readyState === 1 && (n.ref.pending = true, ++requestCount === 1 && e12?.invokeBusy && e12.invokeBusy(true)), s.readyState === 4 && (n.ref.pending = false, s.status === 200 || s.status === 0 ? (n.buffer = s.response, n.ref.encode === "JSON" ? n.values = JSON.parse(n.buffer) : (Endian.ENDIANNESS !== n.ref.encode && Endian.ENDIANNESS && (vtkDebugMacro(`Swap bytes of ${n.name}`), Endian.swapBytes(n.buffer, DataTypeByteSize[n.dataType])), n.values = macro.newTypedArray(n.dataType, n.buffer)), n.values.length !== n.size && vtkErrorMacro$3(`Error in FetchArray: ${n.name}, does not have the proper array size. Got ${n.values.length}, instead of ${n.size}`), delete n.ref, --requestCount === 0 && e12?.invokeBusy && e12.invokeBusy(false), e12?.modified && e12.modified(), a(n)) : o({
        xhr: s,
        e: t2
      }));
    }, s.responseType = n.dataType === "string" ? "text" : "arraybuffer", s.send();
  }) : Promise.resolve(n);
}
function fetchJSON(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return n && n.compression ? REJECT_COMPRESSION() : new Promise((r, a) => {
    let o = openAsyncXHR("GET", t, n);
    o.onreadystatechange = (t2) => {
      o.readyState === 1 && ++requestCount === 1 && e12?.invokeBusy && e12.invokeBusy(true), o.readyState === 4 && (--requestCount === 0 && e12?.invokeBusy && e12.invokeBusy(false), o.status === 200 || o.status === 0 ? r(JSON.parse(o.responseText)) : a({
        xhr: o,
        e: t2
      }));
    }, o.responseType = "text", o.send();
  });
}
function fetchText(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return n && n.compression ? REJECT_COMPRESSION() : new Promise((r, a) => {
    let o = openAsyncXHR("GET", t, n);
    o.onreadystatechange = (t2) => {
      o.readyState === 1 && ++requestCount === 1 && e12?.invokeBusy && e12.invokeBusy(true), o.readyState === 4 && (--requestCount === 0 && e12?.invokeBusy && e12.invokeBusy(false), o.status === 200 || o.status === 0 ? r(o.responseText) : a({
        xhr: o,
        e: t2
      }));
    }, o.responseType = "text", o.send();
  });
}
function fetchImage(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return new Promise((e13, r) => {
    let a = new Image();
    n.crossOrigin && (a.crossOrigin = n.crossOrigin), a.onload = () => e13(a), a.onerror = r, a.src = t;
  });
}
var LiteHttpDataAccessHelper = {
  fetchArray,
  fetchJSON,
  fetchText,
  fetchBinary,
  fetchImage
};
has("http") || registerType("http", (e12) => LiteHttpDataAccessHelper);
var PLYFormats = {
  ASCII: "ascii",
  BINARY_BIG_ENDIAN: "binary_big_endian",
  BINARY_LITTLE_ENDIAN: "binary_little_endian"
}, mapping = {
  diffuse_red: "red",
  diffuse_green: "green",
  diffuse_blue: "blue"
}, patterns = {
  patternHeader: /ply([\s\S]*)end_header\r?\n/,
  patternBody: /end_header\s([\s\S]*)$/
};
function parseHeader$1(e12) {
  let t = "", n = 0, r = patterns.patternHeader.exec(e12);
  r !== null && (t = r[1], n = r[0].length);
  let a = {
    comments: [],
    elements: [],
    headerLength: n
  }, o = t.split("\n"), s, c, l;
  for (let e13 = 0; e13 < o.length; e13++) {
    let t2 = o[e13];
    if (t2 = t2.trim(), t2 !== "") {
      let e14;
      switch (l = t2.split(/\s+/), c = l.shift(), t2 = l.join(" "), c) {
        case "format":
          a.format = l[0], a.version = l[1];
          break;
        case "comment":
          a.comments.push(t2);
          break;
        case "element":
          s !== void 0 && a.elements.push(s), s = {}, s.name = l[0], s.count = parseInt(l[1], 10), s.properties = [];
          break;
        case "property":
          e14 = { type: l[0] }, e14.type === "list" ? (e14.name = l[3], e14.countType = l[1], e14.itemType = l[2]) : e14.name = l[1], e14.name in mapping && (e14.name = mapping[e14.name]), s.properties.push(e14);
          break;
        case "obj_info":
          a.objInfo = t2;
          break;
        default:
          console.warn("unhandled", c, l);
          break;
      }
    }
  }
  return s !== void 0 && a.elements.push(s), a;
}
function postProcess(e12, t, n, r) {
  let a = t.find((e13) => e13.name === "vertex"), o = t.find((e13) => e13.name === "face"), s = 0, c = 0;
  a && (s = a.count), o && (c = o.count);
  let l = new Float32Array(s * 3), u = new Uint8Array(s * 3), d = new Float32Array(s * 2), f = new Float32Array(s * 3), p = e12.colors.length > 0, m = e12.uvs.length > 0, h = e12.normals.length > 0, g = e12.faceVertexUvs.length > 0, _ = /* @__PURE__ */ new Map(), v = s;
  for (let t2 = 0; t2 < s; t2++) {
    let n2 = t2 * 3 + 0, r2 = t2 * 3 + 1, a2 = t2 * 3 + 2;
    l[n2] = e12.vertices[n2], l[r2] = e12.vertices[r2], l[a2] = e12.vertices[a2], p && (u[n2] = e12.colors[n2], u[r2] = e12.colors[r2], u[a2] = e12.colors[a2]), m ? (n2 = t2 * 2 + 0, r2 = t2 * 2 + 1, d[n2] = e12.uvs[n2], d[r2] = e12.uvs[r2]) : (d[t2 * 2] = -1, d[t2 * 2 + 1] = -1), h && (f[n2] = e12.normals[n2], f[r2] = e12.normals[r2], f[a2] = e12.normals[a2]);
  }
  if (g && !m && c > 0) {
    let t2 = 0, a2 = 0;
    if (r) {
      let r2 = [], o2 = [], m2 = [], g2 = [];
      for (let s2 = 0; s2 < c; ++s2) {
        let s3 = e12.indices[t2++], c2 = e12.faceVertexUvs[a2++];
        if (c2 && s3 * 2 === c2.length)
          for (let a3 = 0; a3 < s3; ++a3) {
            let s4 = e12.indices[t2 + a3], y2 = [c2[a3 * 2], c2[a3 * 2 + 1]], b = [d[s4 * 2], d[s4 * 2 + 1]];
            if (b[0] === -1) {
              d[s4 * 2] = y2[0], d[s4 * 2 + 1] = y2[1];
              let e13 = `${y2[0]},${y2[1]}`;
              _.has(e13) || _.set(e13, []), _.get(e13).push(s4);
            } else if (Math.abs(b[0] - y2[0]) > n || Math.abs(b[1] - y2[1]) > n) {
              let c3 = `${y2[0]},${y2[1]}`, d2 = -1;
              if (_.has(c3)) {
                let e13 = _.get(c3);
                for (let t3 = 0, r3 = e13.length; t3 < r3; t3++) {
                  let r4 = e13[t3];
                  if (Math.abs(l[r4 * 3] - l[s4 * 3]) <= n && Math.abs(l[r4 * 3 + 1] - l[s4 * 3 + 1]) <= n && Math.abs(l[r4 * 3 + 2] - l[s4 * 3 + 2]) <= n) {
                    d2 = r4;
                    break;
                  }
                }
              }
              d2 === -1 ? (r2.push(l[s4 * 3], l[s4 * 3 + 1], l[s4 * 3 + 2]), p && o2.push(u[s4 * 3], u[s4 * 3 + 1], u[s4 * 3 + 2]), h && m2.push(f[s4 * 3], f[s4 * 3 + 1], f[s4 * 3 + 2]), g2.push(y2[0], y2[1]), _.has(c3) || _.set(c3, []), _.get(c3).push(v), e12.indices[t2 + a3] = v, v++) : e12.indices[t2 + a3] = d2;
            }
          }
        t2 += s3;
      }
      if (r2.length > 0) {
        let e13 = s + r2.length / 3, t3 = new Float32Array(e13 * 3), n2 = new Float32Array(e13 * 2), a3 = p ? new Uint8Array(e13 * 3) : null, c2 = h ? new Float32Array(e13 * 3) : null;
        t3.set(l), n2.set(d), p && a3 && a3.set(u), h && c2 && c2.set(f), t3.set(r2, s * 3), n2.set(g2, s * 2), p && a3 && a3.set(o2, s * 3), h && c2 && c2.set(m2, s * 3), l = t3, d = n2, p && (u = a3), h && (f = c2);
      }
    } else
      for (let n2 = 0; n2 < c; ++n2) {
        let n3 = e12.indices[t2++], r2 = e12.faceVertexUvs[a2++];
        if (r2 && n3 * 2 === r2.length)
          for (let a3 = 0; a3 < n3; ++a3) {
            let n4 = e12.indices[t2++];
            d[n4 * 2] = r2[a3 * 2], d[n4 * 2 + 1] = r2[a3 * 2 + 1];
          }
        else
          t2 += n3;
      }
  }
  let y = vtkPolyData$1.newInstance();
  if (y.getPoints().setData(l, 3), c > 0)
    y.getPolys().setData(Uint32Array.from(e12.indices));
  else {
    let e13 = new Uint32Array(s * 2);
    for (let t2 = 0; t2 < s; t2++)
      e13[t2 * 2] = 1, e13[t2 * 2 + 1] = t2;
    y.getVerts().setData(e13);
  }
  if (p && y.getPointData().setScalars(vtkDataArray$1.newInstance({
    numberOfComponents: 3,
    values: u,
    name: "RGB"
  })), m || g) {
    let e13 = vtkDataArray$1.newInstance({
      numberOfComponents: 2,
      values: d,
      name: "TextureCoordinates"
    }), t2 = y.getPointData();
    t2.addArray(e13), t2.setActiveTCoords(e13.getName());
  }
  return h && y.getPointData().setNormals(vtkDataArray$1.newInstance({
    numberOfComponents: 3,
    name: "Normals",
    values: f
  })), y;
}
function parseNumber(e12, t) {
  let n;
  switch (t) {
    case "char":
    case "uchar":
    case "short":
    case "ushort":
    case "int":
    case "uint":
    case "int8":
    case "uint8":
    case "int16":
    case "uint16":
    case "int32":
    case "uint32":
      n = parseInt(e12, 10);
      break;
    case "float":
    case "double":
    case "float32":
    case "float64":
      n = parseFloat(e12);
      break;
    default:
      console.log("Unsupported type");
      break;
  }
  return n;
}
function parseElement(e12, t) {
  let n = t.split(/\s+/), r = {};
  for (let t2 = 0; t2 < e12.length; t2++)
    if (e12[t2].type === "list") {
      let a = [], o = parseNumber(n.shift(), e12[t2].countType);
      for (let r2 = 0; r2 < o; r2++)
        a.push(parseNumber(n.shift(), e12[t2].itemType));
      r[e12[t2].name] = a;
    } else
      r[e12[t2].name] = parseNumber(n.shift(), e12[t2].type);
  return r;
}
function handleElement(e12, t, n) {
  if (t === "vertex")
    e12.vertices.push(n.x, n.y, n.z), "nx" in n && "ny" in n && "nz" in n && e12.normals.push(n.nx, n.ny, n.nz), "s" in n && "t" in n ? e12.uvs.push(n.s, n.t) : "u" in n && "v" in n ? e12.uvs.push(n.u, n.v) : "texture_u" in n && "texture_v" in n && e12.uvs.push(n.texture_u, n.texture_v), "red" in n && "green" in n && "blue" in n && e12.colors.push(n.red, n.green, n.blue);
  else if (t === "face") {
    let t2 = n.vertex_indices || n.vertex_index, r = n.texcoord;
    t2 && t2.length > 0 && (e12.indices.push(t2.length), t2.forEach((t3, n2) => {
      e12.indices.push(t3);
    })), e12.faceVertexUvs.push(r);
  }
}
function binaryRead(e12, t, n, r) {
  let a;
  switch (n) {
    case "int8":
    case "char":
      a = [e12.getInt8(t), 1];
      break;
    case "uint8":
    case "uchar":
      a = [e12.getUint8(t), 1];
      break;
    case "int16":
    case "short":
      a = [e12.getInt16(t, r), 2];
      break;
    case "uint16":
    case "ushort":
      a = [e12.getUint16(t, r), 2];
      break;
    case "int32":
    case "int":
      a = [e12.getInt32(t, r), 4];
      break;
    case "uint32":
    case "uint":
      a = [e12.getUint32(t, r), 4];
      break;
    case "float32":
    case "float":
      a = [e12.getFloat32(t, r), 4];
      break;
    case "float64":
    case "double":
      a = [e12.getFloat64(t, r), 8];
      break;
    default:
      console.log("Unsupported type");
      break;
  }
  return a;
}
function binaryReadElement(e12, t, n, r) {
  let a = {}, o, s = 0;
  for (let c = 0; c < n.length; c++)
    if (n[c].type === "list") {
      let l = [];
      o = binaryRead(e12, t + s, n[c].countType, r);
      let u = o[0];
      s += o[1];
      for (let a2 = 0; a2 < u; a2++)
        o = binaryRead(e12, t + s, n[c].itemType, r), l.push(o[0]), s += o[1];
      a[n[c].name] = l;
    } else
      o = binaryRead(e12, t + s, n[c].type, r), a[n[c].name] = o[0], s += o[1];
  return [a, s];
}
function vtkPLYReader(e12, t) {
  t.classHierarchy.push("vtkPLYReader"), t.dataAccessHelper ||= DataAccessHelper.get("http");
  function n(n2) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { compression: a, progressCallback: o } = t;
    return r.binary ? t.dataAccessHelper.fetchBinary(n2, {
      compression: a,
      progressCallback: o
    }) : t.dataAccessHelper.fetchText(e12, n2, {
      compression: a,
      progressCallback: o
    });
  }
  e12.setUrl = function(n2) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { binary: true };
    t.url = n2;
    let a = n2.split("/");
    return a.pop(), t.baseURL = a.join("/"), t.compression = r.compression, e12.loadData({
      progressCallback: r.progressCallback,
      binary: !!r.binary
    });
  }, e12.loadData = function() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = n(t.url, r);
    return a.then(e12.parse), a;
  }, e12.parse = (t2) => {
    typeof t2 == "string" ? e12.parseAsText(t2) : e12.parseAsArrayBuffer(t2);
  }, e12.parseAsArrayBuffer = (n2) => {
    if (!n2)
      return;
    if (n2 !== t.parseData)
      e12.modified();
    else
      return;
    let r = n2;
    n2 instanceof ArrayBuffer && (r = BinaryHelper.arrayBufferToString(n2));
    let a = parseHeader$1(r);
    if (a.format === PLYFormats.ASCII) {
      e12.parseAsText(r);
      return;
    }
    t.parseData = n2;
    let o = {
      indices: [],
      vertices: [],
      normals: [],
      uvs: [],
      faceVertexUvs: [],
      colors: []
    }, s = a.format === PLYFormats.BINARY_LITTLE_ENDIAN, c = n2 instanceof ArrayBuffer ? n2 : n2.buffer, l = new DataView(c, a.headerLength), u, d = 0;
    for (let e13 = 0; e13 < a.elements.length; e13++)
      for (let t2 = 0; t2 < a.elements[e13].count; t2++) {
        u = binaryReadElement(l, d, a.elements[e13].properties, s), d += u[1];
        let t3 = u[0];
        handleElement(o, a.elements[e13].name, t3);
      }
    let f = postProcess(o, a.elements, t.faceTextureTolerance, t.duplicatePointsForFaceTexture);
    t.output[0] = f;
  }, e12.parseAsText = (n2) => {
    if (!n2)
      return;
    if (n2 !== t.parseData)
      e12.modified();
    else
      return;
    t.parseData = n2;
    let r = n2;
    n2 instanceof ArrayBuffer && (r = BinaryHelper.arrayBufferToString(n2));
    let a = parseHeader$1(r);
    if (a.format !== PLYFormats.ASCII) {
      e12.parseAsArrayBuffer(n2);
      return;
    }
    let o = {
      indices: [],
      vertices: [],
      normals: [],
      uvs: [],
      faceVertexUvs: [],
      colors: []
    }, s = patterns.patternBody.exec(r), c = "";
    s !== null && (c = s[1]);
    let l = c.split("\n"), u = 0, d = 0;
    for (let e13 = 0; e13 < l.length; e13++) {
      let t2 = l[e13];
      if (t2 = t2.trim(), t2 !== "") {
        d >= a.elements[u].count && (u++, d = 0);
        let e14 = parseElement(a.elements[u].properties, t2);
        handleElement(o, a.elements[u].name, e14), d++;
      }
    }
    let f = postProcess(o, a.elements, t.faceTextureTolerance, t.duplicatePointsForFaceTexture);
    t.output[0] = f;
  }, e12.requestData = (n2, r) => {
    e12.parse(t.parseData);
  };
}
var DEFAULT_VALUES$19 = {
  faceTextureTolerance: 1e-6,
  duplicatePointsForFaceTexture: true
};
function extend$24(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$19, n), macro.obj(e12, t), macro.get(e12, t, [
    "url",
    "baseURL",
    "duplicatePointsForFaceTexture",
    "faceTextureTolerance"
  ]), macro.setGet(e12, t, ["dataAccessHelper"]), macro.algo(e12, t, 0, 1), vtkPLYReader(e12, t), t.compression ||= null, t.progressCallback ||= null;
}
var vtkPLYReader$1 = {
  extend: extend$24,
  newInstance: macro.newInstance(extend$24, "vtkPLYReader")
}, { vtkErrorMacro: vtkErrorMacro$2 } = macro;
function parseHeader(e12) {
  let t = e12.split(" ").filter((e13) => e13.indexOf("=") > -1), n = {};
  for (let e13 = 0; e13 < t.length; ++e13) {
    let r = t[e13].split("=");
    r.length === 2 && (n[r[0]] = r[1]);
  }
  return n;
}
function addValuesToArray(e12, t) {
  for (let n = 0; n < e12.length; n++)
    t.push(e12[n]);
}
function readTriangle(e12, t, n, r, a) {
  let o = e12[t];
  if (o === void 0)
    return -1;
  if (o.indexOf("endfacet") !== -1 || o.indexOf("facet") === -1)
    return t + 1;
  let s = 0, c = 2, l = n.length / 3;
  for (addValuesToArray(o.split(/[ \t]+/).filter((e13) => e13).slice(-3).map(Number), a); e12[t + c].indexOf("vertex") !== -1; )
    addValuesToArray(e12[t + c].split(/[ \t]+/).filter((e13) => e13).slice(-3).map(Number), n), s++, c++;
  r.push(s);
  for (let e13 = 0; e13 < s; e13++)
    r.push(l + e13);
  for (; e12[t + c] && e12[t + c].indexOf("endfacet") !== -1; )
    c++;
  return t + c + 2;
}
function vtkSTLReader(e12, t) {
  t.classHierarchy.push("vtkSTLReader"), t.dataAccessHelper ||= DataAccessHelper.get("http");
  function n(n2) {
    let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r2.compression === void 0 ? t.compression : r2.compression, o = r2.progressCallback === void 0 ? t.progressCallback : r2.progressCallback;
    return r2.binary ? t.dataAccessHelper.fetchBinary(n2, {
      compression: a,
      progressCallback: o
    }) : t.dataAccessHelper.fetchText(e12, n2, {
      compression: a,
      progressCallback: o
    });
  }
  function r(e13) {
    let n2 = t.output[0], r2 = n2.getPoints().getData(), a = n2.getPolys().getData();
    if (!r2 || !a) {
      console.warn("No valid polydata.");
      return;
    }
    let o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), c = 0, l = false;
    for (let t2 = 0; t2 < r2.length; t2 += 3) {
      let n3 = `${(r2[t2] * 10 ** e13).toFixed(0)},${(r2[t2 + 1] * 10 ** e13).toFixed(0)},${(r2[t2 + 2] * 10 ** e13).toFixed(0)}`;
      o.get(n3) === void 0 ? (s.set(t2 / 3, c), o.set(n3, c), c++) : (s.set(t2 / 3, o.get(n3)), l = true);
    }
    if (l) {
      let t2 = new Float32Array(o.size * 3), r3 = Array.from(o.keys());
      for (let n3 = 0; n3 < r3.length; n3++) {
        let a2 = r3[n3], s2 = o.get(a2) * 3, c3 = a2.split(",").map((t3) => t3 * 10 ** -e13);
        t2[s2] = c3[0], t2[s2 + 1] = c3[1], t2[s2 + 2] = c3[2];
      }
      let c2 = new Int32Array(a.length);
      for (let e14 = 0; e14 < a.length; e14 += 4)
        c2[e14] = 3, c2[e14 + 1] = s.get(a[e14 + 1]), c2[e14 + 2] = s.get(a[e14 + 2]), c2[e14 + 3] = s.get(a[e14 + 3]);
      n2.getPoints().setData(t2), n2.getPolys().setData(c2), n2.modified();
    }
  }
  e12.setUrl = function(n2) {
    let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { binary: true };
    t.url = n2;
    let a = n2.split("/");
    return a.pop(), t.baseURL = a.join("/"), e12.loadData(r2);
  }, e12.loadData = function() {
    let r2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = n(t.url, r2);
    return a.then(e12.parse), a;
  }, e12.parse = (t2) => {
    typeof t2 == "string" ? e12.parseAsText(t2) : e12.parseAsArrayBuffer(t2);
  }, e12.parseAsArrayBuffer = (n2) => {
    if (!n2)
      return;
    if (n2 !== t.parseData)
      e12.modified();
    else
      return;
    t.parseData = n2;
    let a = false;
    if (a = 84 + new DataView(n2, 0, 84).getUint32(80, true) * 50 === n2.byteLength, !a) {
      e12.parseAsText(BinaryHelper.arrayBufferToString(n2));
      return;
    }
    let o = n2.slice(0, 80), s = parseHeader(BinaryHelper.arrayBufferToString(o)), c = new DataView(n2, 84), l = (n2.byteLength - 84) / 50, u = new Float32Array(l * 9), d = new Float32Array(l * 3), f = new Uint32Array(l * 4), p = new Uint16Array(l), m = 0;
    for (let e13 = 0; e13 < l; e13++) {
      let t2 = e13 * 50;
      d[e13 * 3 + 0] = c.getFloat32(t2 + 0, true), d[e13 * 3 + 1] = c.getFloat32(t2 + 4, true), d[e13 * 3 + 2] = c.getFloat32(t2 + 8, true), u[e13 * 9 + 0] = c.getFloat32(t2 + 12, true), u[e13 * 9 + 1] = c.getFloat32(t2 + 16, true), u[e13 * 9 + 2] = c.getFloat32(t2 + 20, true), u[e13 * 9 + 3] = c.getFloat32(t2 + 24, true), u[e13 * 9 + 4] = c.getFloat32(t2 + 28, true), u[e13 * 9 + 5] = c.getFloat32(t2 + 32, true), u[e13 * 9 + 6] = c.getFloat32(t2 + 36, true), u[e13 * 9 + 7] = c.getFloat32(t2 + 40, true), u[e13 * 9 + 8] = c.getFloat32(t2 + 44, true), f[m++] = 3, f[m++] = e13 * 3 + 0, f[m++] = e13 * 3 + 1, f[m++] = e13 * 3 + 2, p[e13] = c.getUint16(t2 + 48, true);
    }
    let h = "SPACE";
    if (h in s && s[h] !== "LPS") {
      let e13 = s[h], t2 = new Float32Array(16);
      switch (t2[15] = 1, e13[0]) {
        case "L":
          t2[0] = 1;
          break;
        case "R":
          t2[0] = -1;
          break;
        default:
          vtkErrorMacro$2(`Can not convert STL file from ${e13} to LPS space: permutations not supported. Use itk.js STL reader instead.`);
          return;
      }
      switch (e13[1]) {
        case "P":
          t2[5] = 1;
          break;
        case "A":
          t2[5] = -1;
          break;
        default:
          vtkErrorMacro$2(`Can not convert STL file from ${e13} to LPS space: permutations not supported. Use itk.js STL reader instead.`);
          return;
      }
      switch (e13[2]) {
        case "S":
          t2[10] = 1;
          break;
        case "I":
          t2[10] = -1;
          break;
        default:
          vtkErrorMacro$2(`Can not convert STL file from ${e13} to LPS space: permutations not supported. Use itk.js STL reader instead.`);
          return;
      }
      vtkMatrixBuilder.buildFromDegree().setMatrix(t2).apply(u).apply(d);
    }
    let g = vtkPolyData$1.newInstance();
    g.getPoints().setData(u, 3), g.getPolys().setData(f), g.getCellData().setScalars(vtkDataArray$1.newInstance({
      name: "Attribute",
      values: p
    })), g.getCellData().setNormals(vtkDataArray$1.newInstance({
      name: "Normals",
      values: d,
      numberOfComponents: 3
    })), t.output[0] = g, t.removeDuplicateVertices >= 0 && r(t.removeDuplicateVertices);
  }, e12.parseAsText = (n2) => {
    if (!n2)
      return;
    if (n2 !== t.parseData)
      e12.modified();
    else
      return;
    t.parseData = n2;
    let a = n2.split("\n"), o = 1, s = [], c = [], l = [];
    for (; o !== -1; )
      o = readTriangle(a, o, s, c, l);
    let u = vtkPolyData$1.newInstance();
    u.getPoints().setData(Float32Array.from(s), 3), u.getPolys().setData(Uint32Array.from(c)), u.getCellData().setNormals(vtkDataArray$1.newInstance({
      name: "Normals",
      values: Float32Array.from(l),
      numberOfComponents: 3
    })), t.output[0] = u, t.removeDuplicateVertices >= 0 && r(t.removeDuplicateVertices);
  }, e12.requestData = (n2, r2) => {
    e12.parse(t.parseData);
  };
}
var DEFAULT_VALUES$18 = { removeDuplicateVertices: -1 };
function extend$23(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$18, n), macro.obj(e12, t), macro.get(e12, t, ["url", "baseURL"]), macro.setGet(e12, t, ["dataAccessHelper", "removeDuplicateVertices"]), macro.algo(e12, t, 0, 1), vtkSTLReader(e12, t), t.compression ||= null, t.progressCallback ||= null;
}
var vtkSTLReader$1 = {
  extend: extend$23,
  newInstance: macro.newInstance(extend$23, "vtkSTLReader")
}, require_xmlbuilder2_min = /* @__PURE__ */ __commonJSMin((e12, t) => {
  (function(n, r) {
    typeof e12 == "object" && typeof t == "object" ? t.exports = r() : typeof define == "function" && define.amd ? define([], r) : typeof e12 == "object" ? e12.xmlbuilder2 = r() : n.xmlbuilder2 = r();
  })(e12, function() {
    return function(e13) {
      var t2 = {};
      function n(r) {
        if (t2[r])
          return t2[r].exports;
        var a = t2[r] = {
          i: r,
          l: false,
          exports: {}
        };
        return e13[r].call(a.exports, a, a.exports, n), a.l = true, a.exports;
      }
      return n.m = e13, n.c = t2, n.d = function(e14, t3, r) {
        n.o(e14, t3) || Object.defineProperty(e14, t3, {
          enumerable: true,
          get: r
        });
      }, n.r = function(e14) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(e14, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e14, "__esModule", { value: true });
      }, n.t = function(e14, t3) {
        if (1 & t3 && (e14 = n(e14)), 8 & t3 || 4 & t3 && typeof e14 == "object" && e14 && e14.__esModule)
          return e14;
        var r = /* @__PURE__ */ Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: true,
          value: e14
        }), 2 & t3 && typeof e14 != "string")
          for (var a in e14)
            n.d(r, a, function(t4) {
              return e14[t4];
            }.bind(null, a));
        return r;
      }, n.n = function(e14) {
        var t3 = e14 && e14.__esModule ? function() {
          return e14.default;
        } : function() {
          return e14;
        };
        return n.d(t3, "a", t3), t3;
      }, n.o = function(e14, t3) {
        return Object.prototype.hasOwnProperty.call(e14, t3);
      }, n.p = "", n(n.s = 184);
    }([
      function(e13, t2, n) {
        function r(e14) {
          for (var n2 in e14)
            t2.hasOwnProperty(n2) || (t2[n2] = e14[n2]);
        }
        Object.defineProperty(t2, "__esModule", { value: true }), r(n(240)), r(n(251)), r(n(175)), r(n(107)), r(n(29)), r(n(73)), r(n(106)), r(n(30)), r(n(252)), r(n(52)), r(n(97)), r(n(253)), r(n(37)), r(n(51)), r(n(173)), r(n(176)), r(n(172)), r(n(108)), r(n(254)), r(n(255)), r(n(256)), r(n(72)), r(n(177)), r(n(105)), r(n(17)), r(n(257)), r(n(12)), r(n(174));
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true }), t2.FixedSizeSet = n(212).FixedSizeSet, t2.ObjectCache = n(213).ObjectCache, t2.CompareCache = n(214).CompareCache, t2.Lazy = n(215).Lazy;
        var a = n(216);
        function o(e14, t3, n2) {
          if (f(e14))
            e14.forEach(function(e15, r3) {
              return t3.call(n2, r3, e15);
            });
          else
            for (var r2 in e14)
              e14.hasOwnProperty(r2) && t3.call(n2, r2, e14[r2]);
        }
        function s(e14) {
          var t3, n2;
          if (c(e14))
            return e14;
          if (u(e14)) {
            var a2 = [];
            try {
              for (var o2 = r(e14), d2 = o2.next(); !d2.done; d2 = o2.next()) {
                var f2 = d2.value;
                a2.push(s(f2));
              }
            } catch (e15) {
              t3 = { error: e15 };
            } finally {
              try {
                d2 && !d2.done && (n2 = o2.return) && n2.call(o2);
              } finally {
                if (t3)
                  throw t3.error;
              }
            }
            return a2;
          }
          if (l(e14)) {
            for (var p2 in a2 = {}, e14)
              if (e14.hasOwnProperty(p2)) {
                var m = e14[p2];
                a2[p2] = s(m);
              }
            return a2;
          }
          return e14;
        }
        function c(e14) {
          return !!e14 && Object.prototype.toString.call(e14) === "[object Function]";
        }
        function l(e14) {
          var t3 = typeof e14;
          return !!e14 && (t3 === "function" || t3 === "object");
        }
        function u(e14) {
          return Array.isArray(e14);
        }
        function d(e14) {
          return e14 instanceof Set;
        }
        function f(e14) {
          return e14 instanceof Map;
        }
        function p(e14) {
          if (l(e14)) {
            var t3 = Object.getPrototypeOf(e14), n2 = t3.constructor;
            return t3 && n2 && typeof n2 == "function" && n2 instanceof n2 && Function.prototype.toString.call(n2) === Function.prototype.toString.call(Object);
          }
          return false;
        }
        t2.StringWalker = a.StringWalker, t2.applyMixin = function(e14, t3) {
          var n2 = [...arguments].slice(2);
          Object.getOwnPropertyNames(t3.prototype).forEach(function(r2) {
            if (r2 !== "constructor") {
              if (n2.indexOf(r2) !== -1) {
                var a2 = Object.getOwnPropertyDescriptor(e14.prototype, r2);
                a2 && Object.defineProperty(e14.prototype, "_" + r2, a2);
              }
              var o2 = Object.getOwnPropertyDescriptor(t3.prototype, r2);
              o2 && Object.defineProperty(e14.prototype, r2, o2);
            }
          });
        }, t2.applyDefaults = function e14(t3, n2, r2) {
          r2 === void 0 && (r2 = false);
          var a2 = s(t3 || {});
          return o(n2, function(t4, n3) {
            p(n3) ? a2[t4] = e14(a2[t4], n3, r2) : (r2 || a2[t4] === void 0) && (a2[t4] = n3);
          }), a2;
        }, t2.forEachArray = function(e14, t3, n2) {
          e14.forEach(t3, n2);
        }, t2.forEachObject = o, t2.arrayLength = function(e14) {
          return d(e14) ? e14.size : e14.length;
        }, t2.objectLength = function(e14) {
          return f(e14) ? e14.size : Object.keys(e14).length;
        }, t2.getObjectValue = function(e14, t3) {
          return f(e14) ? e14.get(t3) : e14[t3];
        }, t2.removeObjectValue = function(e14, t3) {
          f(e14) ? e14.delete(t3) : delete e14[t3];
        }, t2.clone = s, t2.isBoolean = function(e14) {
          return typeof e14 == "boolean";
        }, t2.isNumber = function(e14) {
          return typeof e14 == "number";
        }, t2.isString = function(e14) {
          return typeof e14 == "string";
        }, t2.isFunction = c, t2.isObject = l, t2.isArray = u, t2.isSet = d, t2.isMap = f, t2.isEmpty = function(e14) {
          if (u(e14))
            return !e14.length;
          if (d(e14) || f(e14))
            return !e14.size;
          if (l(e14)) {
            for (var t3 in e14)
              if (e14.hasOwnProperty(t3))
                return false;
            return true;
          }
          return false;
        }, t2.isPlainObject = p, t2.isIterable = function(e14) {
          return e14 && typeof e14[Symbol.iterator] == "function";
        }, t2.getValue = function(e14) {
          return c(e14.valueOf) ? e14.valueOf() : e14;
        }, t2.utf8Encode = function(e14) {
          for (var t3 = new Uint8Array(4 * e14.length), n2 = 0, r2 = 0; r2 < e14.length; r2++) {
            var a2 = e14.charCodeAt(r2);
            if (a2 < 128)
              t3[n2++] = a2;
            else {
              if (a2 < 2048)
                t3[n2++] = a2 >> 6 | 192;
              else {
                if (a2 > 55295 && a2 < 56320) {
                  if (++r2 >= e14.length)
                    throw Error("Incomplete surrogate pair.");
                  var o2 = e14.charCodeAt(r2);
                  if (o2 < 56320 || o2 > 57343)
                    throw Error("Invalid surrogate character.");
                  a2 = 65536 + ((1023 & a2) << 10) + (1023 & o2), t3[n2++] = a2 >> 18 | 240, t3[n2++] = a2 >> 12 & 63 | 128;
                } else
                  t3[n2++] = a2 >> 12 | 224;
                t3[n2++] = a2 >> 6 & 63 | 128;
              }
              t3[n2++] = 63 & a2 | 128;
            }
          }
          return t3.subarray(0, n2);
        }, t2.utf8Decode = function(e14) {
          for (var t3 = "", n2 = 0; n2 < e14.length; ) {
            var r2 = e14[n2++];
            if (r2 > 127)
              if (r2 > 191 && r2 < 224) {
                if (n2 >= e14.length)
                  throw Error("Incomplete 2-byte sequence.");
                r2 = (31 & r2) << 6 | 63 & e14[n2++];
              } else if (r2 > 223 && r2 < 240) {
                if (n2 + 1 >= e14.length)
                  throw Error("Incomplete 3-byte sequence.");
                r2 = (15 & r2) << 12 | (63 & e14[n2++]) << 6 | 63 & e14[n2++];
              } else {
                if (!(r2 > 239 && r2 < 248))
                  throw Error("Unknown multi-byte start.");
                if (n2 + 2 >= e14.length)
                  throw Error("Incomplete 4-byte sequence.");
                r2 = (7 & r2) << 18 | (63 & e14[n2++]) << 12 | (63 & e14[n2++]) << 6 | 63 & e14[n2++];
              }
            if (r2 <= 65535)
              t3 += String.fromCharCode(r2);
            else {
              if (!(r2 <= 1114111))
                throw Error("Code point exceeds UTF-16 limit.");
              r2 -= 65536, t3 += String.fromCharCode(r2 >> 10 | 55296), t3 += String.fromCharCode(1023 & r2 | 56320);
            }
          }
          return t3;
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), function(e14) {
          e14[e14.Before = 0] = "Before", e14[e14.Equal = 1] = "Equal", e14[e14.After = 2] = "After";
        }(t2.BoundaryPosition ||= {}), function(e14) {
          e14[e14.None = 0] = "None", e14[e14.Capturing = 1] = "Capturing", e14[e14.AtTarget = 2] = "AtTarget", e14[e14.Bubbling = 3] = "Bubbling";
        }(t2.EventPhase ||= {}), function(e14) {
          e14[e14.Element = 1] = "Element", e14[e14.Attribute = 2] = "Attribute", e14[e14.Text = 3] = "Text", e14[e14.CData = 4] = "CData", e14[e14.EntityReference = 5] = "EntityReference", e14[e14.Entity = 6] = "Entity", e14[e14.ProcessingInstruction = 7] = "ProcessingInstruction", e14[e14.Comment = 8] = "Comment", e14[e14.Document = 9] = "Document", e14[e14.DocumentType = 10] = "DocumentType", e14[e14.DocumentFragment = 11] = "DocumentFragment", e14[e14.Notation = 12] = "Notation";
        }(t2.NodeType ||= {}), function(e14) {
          e14[e14.Disconnected = 1] = "Disconnected", e14[e14.Preceding = 2] = "Preceding", e14[e14.Following = 4] = "Following", e14[e14.Contains = 8] = "Contains", e14[e14.ContainedBy = 16] = "ContainedBy", e14[e14.ImplementationSpecific = 32] = "ImplementationSpecific";
        }(t2.Position ||= {}), function(e14) {
          e14[e14.Accept = 1] = "Accept", e14[e14.Reject = 2] = "Reject", e14[e14.Skip = 3] = "Skip";
        }(t2.FilterResult ||= {}), function(e14) {
          e14[e14.All = 4294967295] = "All", e14[e14.Element = 1] = "Element", e14[e14.Attribute = 2] = "Attribute", e14[e14.Text = 4] = "Text", e14[e14.CDataSection = 8] = "CDataSection", e14[e14.EntityReference = 16] = "EntityReference", e14[e14.Entity = 32] = "Entity", e14[e14.ProcessingInstruction = 64] = "ProcessingInstruction", e14[e14.Comment = 128] = "Comment", e14[e14.Document = 256] = "Document", e14[e14.DocumentType = 512] = "DocumentType", e14[e14.DocumentFragment = 1024] = "DocumentFragment", e14[e14.Notation = 2048] = "Notation";
        }(t2.WhatToShow ||= {}), function(e14) {
          e14[e14.StartToStart = 0] = "StartToStart", e14[e14.StartToEnd = 1] = "StartToEnd", e14[e14.EndToEnd = 2] = "EndToEnd", e14[e14.EndToStart = 3] = "EndToStart";
        }(t2.HowToCompare ||= {});
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.Cast = n(241).Cast, t2.Guard = n(150).Guard, t2.EmptySet = n(242).EmptySet;
      },
      function(e13, t2, n) {
        var r = n(11), a = n(55).f, o = n(21), s = n(25), c = n(80), l = n(119), u = n(123);
        e13.exports = function(e14, t3) {
          var n2, d, f, p, m, h = e14.target, g = e14.global, _ = e14.stat;
          if (n2 = g ? r : _ ? r[h] || c(h, {}) : (r[h] || {}).prototype)
            for (d in t3) {
              if (p = t3[d], f = e14.noTargetGet ? (m = a(n2, d)) && m.value : n2[d], !u(g ? d : h + (_ ? "." : "#") + d, e14.forced) && f !== void 0) {
                if (typeof p == typeof f)
                  continue;
                l(p, f);
              }
              (e14.sham || f && f.sham) && o(p, "sham", true), s(n2, d, p, e14);
            }
        };
      },
      function(e13, t2, n) {
        var r = n(11), a = n(81), o = n(14), s = n(58), c = n(86), l = n(124), u = a("wks"), d = r.Symbol, f = l ? d : d && d.withoutSetter || s;
        e13.exports = function(e14) {
          return o(u, e14) || (c && o(d, e14) ? u[e14] = d[e14] : u[e14] = f("Symbol." + e14)), u[e14];
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(1), a = n(29);
        t2.dom = function() {
          function e14() {
            this._features = {
              mutationObservers: true,
              customElements: true,
              slots: true,
              steps: true
            }, this._window = null, this._compareCache = new r.CompareCache(), this._rangeList = new r.FixedSizeSet();
          }
          return e14.prototype.setFeatures = function(e15) {
            if (e15 === void 0 && (e15 = true), r.isObject(e15))
              for (var t3 in e15)
                this._features[t3] = e15[t3] || false;
            else
              for (var t3 in this._features)
                this._features[t3] = e15;
          }, Object.defineProperty(e14.prototype, "features", {
            get: function() {
              return this._features;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "window", {
            get: function() {
              return this._window === null && (this._window = a.create_window()), this._window;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "compareCache", {
            get: function() {
              return this._compareCache;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "rangeList", {
            get: function() {
              return this._rangeList;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14, "instance", {
            get: function() {
              return e14._instance ||= new e14(), e14._instance;
            },
            enumerable: true,
            configurable: true
          }), e14;
        }().instance;
      },
      function(e13, t2, n) {
        var r = this && this.__importStar || function(e14) {
          if (e14 && e14.__esModule)
            return e14;
          var t3 = {};
          if (e14 != null)
            for (var n2 in e14)
              Object.hasOwnProperty.call(e14, n2) && (t3[n2] = e14[n2]);
          return t3.default = e14, t3;
        };
        Object.defineProperty(t2, "__esModule", { value: true }), t2.base64 = r(n(228)), t2.byte = r(n(146)), t2.byteSequence = r(n(147)), t2.codePoint = r(n(96)), t2.json = r(n(232)), t2.list = r(n(233)), t2.map = r(n(234)), t2.namespace = r(n(235)), t2.queue = r(n(236)), t2.set = r(n(237)), t2.stack = r(n(238)), t2.string = r(n(239));
      },
      function(e13, t2) {
        e13.exports = function(e14) {
          try {
            return !!e14();
          } catch {
            return true;
          }
        };
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = function(e14) {
          function t3(t4, n2) {
            n2 === void 0 && (n2 = "");
            var r2 = e14.call(this, n2) || this;
            return r2.name = t4, r2;
          }
          return a(t3, e14), t3;
        }(Error);
        t2.DOMException = o, t2.DOMStringSizeError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "DOMStringSizeError", t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.WrongDocumentError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "WrongDocumentError", "The object is in the wrong document. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.NoDataAllowedError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "NoDataAllowedError", t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.NoModificationAllowedError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "NoModificationAllowedError", "The object can not be modified. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.NotSupportedError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "NotSupportedError", "The operation is not supported. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.InUseAttributeError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "InUseAttributeError", t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.InvalidStateError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "InvalidStateError", "The object is in an invalid state. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.InvalidModificationError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "InvalidModificationError", "The object can not be modified in this way. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.NamespaceError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "NamespaceError", "The operation is not allowed by Namespaces in XML. [XMLNS] " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.InvalidAccessError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "InvalidAccessError", "The object does not support the operation or argument. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.ValidationError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "ValidationError", t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.TypeMismatchError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "TypeMismatchError", t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.SecurityError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "SecurityError", "The operation is insecure. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.NetworkError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "NetworkError", "A network error occurred. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.AbortError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "AbortError", "The operation was aborted. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.URLMismatchError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "URLMismatchError", "The given URL does not match another URL. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.QuotaExceededError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "QuotaExceededError", "The quota has been exceeded. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.TimeoutError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "TimeoutError", "The operation timed out. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.InvalidNodeTypeError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "InvalidNodeTypeError", "The supplied node is incorrect or has an incorrect ancestor for this operation. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.DataCloneError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "DataCloneError", "The object can not be cloned. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.NotImplementedError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "NotImplementedError", "The DOM method is not implemented by this module. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.HierarchyRequestError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "HierarchyRequestError", "The operation would yield an incorrect node tree. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.NotFoundError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "NotFoundError", "The object can not be found here. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.IndexSizeError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "IndexSizeError", "The index is not in the allowed range. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.SyntaxError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "SyntaxError", "The string did not match the expected pattern. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o), t2.InvalidCharacterError = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, "InvalidCharacterError", "The string contains invalid characters. " + t4) || this;
          }
          return a(t3, e14), t3;
        }(o);
      },
      function(e13, t2, n) {
        var r = n(53), a = [
          "kind",
          "resolve",
          "construct",
          "instanceOf",
          "predicate",
          "represent",
          "defaultStyle",
          "styleAliases"
        ], o = [
          "scalar",
          "sequence",
          "mapping"
        ];
        e13.exports = function(e14, t3) {
          var n2, s;
          if (t3 ||= {}, Object.keys(t3).forEach(function(t4) {
            if (a.indexOf(t4) === -1)
              throw new r('Unknown option "' + t4 + '" is met in definition of "' + e14 + '" YAML type.');
          }), this.tag = e14, this.kind = t3.kind || null, this.resolve = t3.resolve || function() {
            return true;
          }, this.construct = t3.construct || function(e15) {
            return e15;
          }, this.instanceOf = t3.instanceOf || null, this.predicate = t3.predicate || null, this.represent = t3.represent || null, this.defaultStyle = t3.defaultStyle || null, this.styleAliases = (n2 = t3.styleAliases || null, s = {}, n2 !== null && Object.keys(n2).forEach(function(e15) {
            n2[e15].forEach(function(t4) {
              s[String(t4)] = e15;
            });
          }), s), o.indexOf(this.kind) === -1)
            throw new r('Unknown kind "' + this.kind + '" is specified for "' + e14 + '" YAML type.');
        };
      },
      function(e13, t2, n) {
        (function(t3) {
          var n2 = function(e14) {
            return e14 && e14.Math == Math && e14;
          };
          e13.exports = n2(typeof globalThis == "object" && globalThis) || n2(typeof window == "object" && window) || n2(typeof self == "object" && self) || n2(typeof t3 == "object" && t3) || Function("return this")();
        }).call(this, n(78));
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.idl_defineConst = function(e14, t3, n2) {
          Object.defineProperty(e14, t3, {
            writable: false,
            enumerable: true,
            configurable: false,
            value: n2
          });
        };
      },
      function(e13, t2) {
        e13.exports = function(e14) {
          return typeof e14 == "object" ? e14 !== null : typeof e14 == "function";
        };
      },
      function(e13, t2) {
        var n = {}.hasOwnProperty;
        e13.exports = function(e14, t3) {
          return n.call(e14, t3);
        };
      },
      function(e13, t2, n) {
        var r = n(16), a = n(115), o = n(18), s = n(56), c = Object.defineProperty;
        t2.f = r ? c : function(e14, t3, n2) {
          if (o(e14), t3 = s(t3, true), o(n2), a)
            try {
              return c(e14, t3, n2);
            } catch {
            }
          if ("get" in n2 || "set" in n2)
            throw TypeError("Accessors not supported");
          return "value" in n2 && (e14[t3] = n2.value), e14;
        };
      },
      function(e13, t2, n) {
        e13.exports = !n(8)(function() {
          return Object.defineProperty({}, 1, { get: function() {
            return 7;
          } })[1] != 7;
        });
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(3), o = n(2);
        function s(e14, t3, n2) {
          if (n2 === void 0 && (n2 = false), n2 && a.Guard.isElementNode(t3) && a.Guard.isShadowRoot(t3.shadowRoot) && t3.shadowRoot._firstChild)
            return t3.shadowRoot._firstChild;
          if (t3._firstChild)
            return t3._firstChild;
          if (t3 === e14)
            return null;
          if (t3._nextSibling)
            return t3._nextSibling;
          for (var r2 = t3._parent; r2 && r2 !== e14; ) {
            if (r2._nextSibling)
              return r2._nextSibling;
            r2 = r2._parent;
          }
          return null;
        }
        function c() {
          var e14;
          return (e14 = {})[Symbol.iterator] = function() {
            return { next: function() {
              return {
                done: true,
                value: null
              };
            } };
          }, e14;
        }
        function l(e14, t3, n2, r2) {
          t3 === void 0 && (t3 = false), n2 === void 0 && (n2 = false);
          for (var a2 = t3 ? e14 : s(e14, e14, n2); a2 && r2 && !r2(a2); )
            a2 = s(e14, a2, n2);
          return a2;
        }
        function u(e14, t3, n2, r2, a2) {
          n2 === void 0 && (n2 = false), r2 === void 0 && (r2 = false);
          for (var o2 = s(e14, t3, r2); o2 && a2 && !a2(o2); )
            o2 = s(e14, o2, r2);
          return o2;
        }
        function d(e14, t3, n2, r2) {
          var a2;
          return t3 === void 0 && (t3 = false), n2 === void 0 && (n2 = false), t3 || e14._children.size !== 0 ? ((a2 = {})[Symbol.iterator] = function() {
            var a3 = t3 ? e14 : s(e14, e14, n2);
            return { next: function() {
              for (; a3 && r2 && !r2(a3); )
                a3 = s(e14, a3, n2);
              if (a3 === null)
                return {
                  done: true,
                  value: null
                };
              var t4 = {
                done: false,
                value: a3
              };
              return a3 = s(e14, a3, n2), t4;
            } };
          }, a2) : c();
        }
        function f(e14, t3, n2) {
          t3 === void 0 && (t3 = false);
          for (var r2 = t3 ? e14 : e14._parent; r2 && n2 && !n2(r2); )
            r2 = r2._parent;
          return r2;
        }
        function p(e14, t3, n2, r2) {
          n2 === void 0 && (n2 = false);
          for (var a2 = t3._parent; a2 && r2 && !r2(a2); )
            a2 = a2._parent;
          return a2;
        }
        function m(e14) {
          return a.Guard.isDocumentTypeNode(e14) ? 0 : a.Guard.isCharacterDataNode(e14) ? e14._data.length : e14._children.size;
        }
        function h(e14, t3) {
          if (t3 === void 0 && (t3 = false), t3) {
            var n2 = h(e14, false);
            return a.Guard.isShadowRoot(n2) ? h(n2._host, true) : n2;
          }
          return e14._parent ? h(e14._parent) : e14;
        }
        function g(e14, t3, n2, r2) {
          n2 === void 0 && (n2 = false), r2 === void 0 && (r2 = false);
          for (var o2 = n2 ? e14 : r2 && a.Guard.isShadowRoot(e14) ? e14._host : e14._parent; o2 !== null; ) {
            if (o2 === t3)
              return true;
            o2 = r2 && a.Guard.isShadowRoot(o2) ? o2._host : o2._parent;
          }
          return false;
        }
        function _(e14) {
          for (var t3 = h(e14), n2 = 0, r2 = l(t3); r2 !== null; ) {
            if (n2++, r2 === e14)
              return n2;
            r2 = u(t3, r2);
          }
          return -1;
        }
        t2.tree_getFirstDescendantNode = l, t2.tree_getNextDescendantNode = u, t2.tree_getDescendantNodes = d, t2.tree_getDescendantElements = function(e14, t3, n2, r2) {
          var o2;
          return t3 === void 0 && (t3 = false), n2 === void 0 && (n2 = false), t3 || e14._children.size !== 0 ? ((o2 = {})[Symbol.iterator] = function() {
            var o3 = d(e14, t3, n2, function(e15) {
              return a.Guard.isElementNode(e15);
            })[Symbol.iterator](), s2 = o3.next().value;
            return { next: function() {
              for (; s2 && r2 && !r2(s2); )
                s2 = o3.next().value;
              if (s2 === null)
                return {
                  done: true,
                  value: null
                };
              var e15 = {
                done: false,
                value: s2
              };
              return s2 = o3.next().value, e15;
            } };
          }, o2) : c();
        }, t2.tree_getSiblingNodes = function(e14, t3, n2) {
          var r2;
          return t3 === void 0 && (t3 = false), e14._parent && e14._parent._children.size !== 0 ? ((r2 = {})[Symbol.iterator] = function() {
            var r3 = e14._parent ? e14._parent._firstChild : null;
            return { next: function() {
              for (; r3 && (n2 && !n2(r3) || !t3 && r3 === e14); )
                r3 = r3._nextSibling;
              if (r3 === null)
                return {
                  done: true,
                  value: null
                };
              var a2 = {
                done: false,
                value: r3
              };
              return r3 = r3._nextSibling, a2;
            } };
          }, r2) : c();
        }, t2.tree_getFirstAncestorNode = f, t2.tree_getNextAncestorNode = p, t2.tree_getAncestorNodes = function(e14, t3, n2) {
          var r2;
          return t3 === void 0 && (t3 = false), t3 || e14._parent ? ((r2 = {})[Symbol.iterator] = function() {
            var r3 = f(e14, t3, n2);
            return { next: function() {
              if (r3 === null)
                return {
                  done: true,
                  value: null
                };
              var e15 = {
                done: false,
                value: r3
              };
              return r3 = p(0, r3, t3, n2), e15;
            } };
          }, r2) : c();
        }, t2.tree_getCommonAncestor = function(e14, t3) {
          if (e14 === t3)
            return e14._parent;
          for (var n2 = [], r2 = [], a2 = f(e14, true); a2 !== null; )
            n2.push(a2), a2 = p(0, a2, true);
          for (var o2 = f(t3, true); o2 !== null; )
            r2.push(o2), o2 = p(0, o2, true);
          for (var s2 = n2.length, c2 = r2.length, l2 = null, u2 = Math.min(s2, c2); u2 > 0; u2--) {
            var d2 = n2[--s2];
            if (d2 !== r2[--c2])
              break;
            l2 = d2;
          }
          return l2;
        }, t2.tree_getFollowingNode = function(e14, t3) {
          if (t3._firstChild)
            return t3._firstChild;
          if (t3._nextSibling)
            return t3._nextSibling;
          for (; ; ) {
            var n2 = t3._parent;
            if (n2 === null || n2 === e14)
              return null;
            if (n2._nextSibling)
              return n2._nextSibling;
            t3 = n2;
          }
        }, t2.tree_getPrecedingNode = function(e14, t3) {
          return t3 === e14 ? null : t3._previousSibling ? (t3 = t3._previousSibling)._lastChild ? t3._lastChild : t3 : t3._parent;
        }, t2.tree_isConstrained = function e14(t3) {
          var n2, a2, s2, c2, l2, u2;
          switch (t3._nodeType) {
            case o.NodeType.Document:
              var d2 = false, f2 = false;
              try {
                for (var p2 = r(t3._children), m2 = p2.next(); !m2.done; m2 = p2.next())
                  switch (m2.value._nodeType) {
                    case o.NodeType.ProcessingInstruction:
                    case o.NodeType.Comment:
                      break;
                    case o.NodeType.DocumentType:
                      if (d2 || f2)
                        return false;
                      d2 = true;
                      break;
                    case o.NodeType.Element:
                      if (f2)
                        return false;
                      f2 = true;
                      break;
                    default:
                      return false;
                  }
              } catch (e15) {
                n2 = { error: e15 };
              } finally {
                try {
                  m2 && !m2.done && (a2 = p2.return) && a2.call(p2);
                } finally {
                  if (n2)
                    throw n2.error;
                }
              }
              break;
            case o.NodeType.DocumentFragment:
            case o.NodeType.Element:
              try {
                for (var h2 = r(t3._children), g2 = h2.next(); !g2.done; g2 = h2.next())
                  switch (g2.value._nodeType) {
                    case o.NodeType.Element:
                    case o.NodeType.Text:
                    case o.NodeType.ProcessingInstruction:
                    case o.NodeType.CData:
                    case o.NodeType.Comment:
                      break;
                    default:
                      return false;
                  }
              } catch (e15) {
                s2 = { error: e15 };
              } finally {
                try {
                  g2 && !g2.done && (c2 = h2.return) && c2.call(h2);
                } finally {
                  if (s2)
                    throw s2.error;
                }
              }
              break;
            case o.NodeType.DocumentType:
            case o.NodeType.Text:
            case o.NodeType.ProcessingInstruction:
            case o.NodeType.CData:
            case o.NodeType.Comment:
              return !t3.hasChildNodes();
          }
          try {
            for (var _2 = r(t3._children), v = _2.next(); !v.done; v = _2.next())
              if (!e14(v.value))
                return false;
          } catch (e15) {
            l2 = { error: e15 };
          } finally {
            try {
              v && !v.done && (u2 = _2.return) && u2.call(_2);
            } finally {
              if (l2)
                throw l2.error;
            }
          }
          return true;
        }, t2.tree_nodeLength = m, t2.tree_isEmpty = function(e14) {
          return m(e14) === 0;
        }, t2.tree_rootNode = h, t2.tree_isDescendantOf = function(e14, t3, n2, r2) {
          n2 === void 0 && (n2 = false), r2 === void 0 && (r2 = false);
          for (var a2 = l(e14, n2, r2); a2 !== null; ) {
            if (a2 === t3)
              return true;
            a2 = u(e14, a2, n2, r2);
          }
          return false;
        }, t2.tree_isAncestorOf = g, t2.tree_isHostIncludingAncestorOf = function e14(t3, n2, r2) {
          if (r2 === void 0 && (r2 = false), g(t3, n2, r2))
            return true;
          var o2 = h(t3);
          return !(!a.Guard.isDocumentFragmentNode(o2) || o2._host === null || !e14(o2._host, n2, r2));
        }, t2.tree_isSiblingOf = function(e14, t3, n2) {
          return n2 === void 0 && (n2 = false), e14 === t3 ? !!n2 : e14._parent !== null && e14._parent === t3._parent;
        }, t2.tree_isPreceding = function(e14, t3) {
          var n2 = _(e14), r2 = _(t3);
          return n2 !== -1 && r2 !== -1 && h(e14) === h(t3) && r2 < n2;
        }, t2.tree_isFollowing = function(e14, t3) {
          var n2 = _(e14), r2 = _(t3);
          return n2 !== -1 && r2 !== -1 && h(e14) === h(t3) && r2 > n2;
        }, t2.tree_isParentOf = function(e14, t3) {
          return e14._parent === t3;
        }, t2.tree_isChildOf = function(e14, t3) {
          return t3._parent === e14;
        }, t2.tree_previousSibling = function(e14) {
          return e14._previousSibling;
        }, t2.tree_nextSibling = function(e14) {
          return e14._nextSibling;
        }, t2.tree_firstChild = function(e14) {
          return e14._firstChild;
        }, t2.tree_lastChild = function(e14) {
          return e14._lastChild;
        }, t2.tree_treePosition = _, t2.tree_index = function(e14) {
          for (var t3 = 0; e14._previousSibling !== null; )
            t3++, e14 = e14._previousSibling;
          return t3;
        }, t2.tree_retarget = function(e14, t3) {
          for (; ; ) {
            if (!e14 || !a.Guard.isNode(e14))
              return e14;
            var n2 = h(e14);
            if (!a.Guard.isShadowRoot(n2) || t3 && a.Guard.isNode(t3) && g(n2, t3, true, true))
              return e14;
            e14 = n2.host;
          }
        };
      },
      function(e13, t2, n) {
        var r = n(13);
        e13.exports = function(e14) {
          if (!r(e14))
            throw TypeError(String(e14) + " is not an object");
          return e14;
        };
      },
      function(e13, t2, n) {
        var r = n(24), a = n(130), o = n(49), s = n(43), c = n(88), l = s.set, u = s.getterFor("Array Iterator");
        e13.exports = c(Array, "Array", function(e14, t3) {
          l(this, {
            type: "Array Iterator",
            target: r(e14),
            index: 0,
            kind: t3
          });
        }, function() {
          var e14 = u(this), t3 = e14.target, n2 = e14.kind, r2 = e14.index++;
          return !t3 || r2 >= t3.length ? (e14.target = void 0, {
            value: void 0,
            done: true
          }) : n2 == "keys" ? {
            value: r2,
            done: false
          } : n2 == "values" ? {
            value: t3[r2],
            done: false
          } : {
            value: [r2, t3[r2]],
            done: false
          };
        }, "values"), o.Arguments = o.Array, a("keys"), a("values"), a("entries");
      },
      function(e13, t2, n) {
        var r = n(90), a = n(25), o = n(202);
        r || a(Object.prototype, "toString", o, { unsafe: true });
      },
      function(e13, t2, n) {
        var r = n(16), a = n(15), o = n(40);
        e13.exports = r ? function(e14, t3, n2) {
          return a.f(e14, t3, o(1, n2));
        } : function(e14, t3, n2) {
          return e14[t3] = n2, e14;
        };
      },
      function(e13, t2, n) {
        var r = n(137).charAt, a = n(43), o = n(88), s = a.set, c = a.getterFor("String Iterator");
        o(String, "String", function(e14) {
          s(this, {
            type: "String Iterator",
            string: String(e14),
            index: 0
          });
        }, function() {
          var e14, t3 = c(this), n2 = t3.string, a2 = t3.index;
          return a2 >= n2.length ? {
            value: void 0,
            done: true
          } : (e14 = r(n2, a2), t3.index += e14.length, {
            value: e14,
            done: false
          });
        });
      },
      function(e13, t2, n) {
        var r = n(11), a = n(203), o = n(19), s = n(21), c = n(5), l = c("iterator"), u = c("toStringTag"), d = o.values;
        for (var f in a) {
          var p = r[f], m = p && p.prototype;
          if (m) {
            if (m[l] !== d)
              try {
                s(m, l, d);
              } catch {
                m[l] = d;
              }
            if (m[u] || s(m, u, f), a[f]) {
              for (var h in o)
                if (m[h] !== o[h])
                  try {
                    s(m, h, o[h]);
                  } catch {
                    m[h] = o[h];
                  }
            }
          }
        }
      },
      function(e13, t2, n) {
        var r = n(41), a = n(35);
        e13.exports = function(e14) {
          return r(a(e14));
        };
      },
      function(e13, t2, n) {
        var r = n(11), a = n(21), o = n(14), s = n(80), c = n(117), l = n(43), u = l.get, d = l.enforce, f = String(String).split("String");
        (e13.exports = function(e14, t3, n2, c2) {
          var l2 = !!c2 && !!c2.unsafe, u2 = !!c2 && !!c2.enumerable, p = !!c2 && !!c2.noTargetGet;
          typeof n2 == "function" && (typeof t3 != "string" || o(n2, "name") || a(n2, "name", t3), d(n2).source = f.join(typeof t3 == "string" ? t3 : "")), e14 === r ? u2 ? e14[t3] = n2 : s(t3, n2) : (l2 ? !p && e14[t3] && (u2 = true) : delete e14[t3], u2 ? e14[t3] = n2 : a(e14, t3, n2));
        })(Function.prototype, "toString", function() {
          return typeof this == "function" && u(this).source || c(this);
        });
      },
      function(e13, t2, n) {
        var r = n(47), a = Math.min;
        e13.exports = function(e14) {
          return e14 > 0 ? a(r(e14), 9007199254740991) : 0;
        };
      },
      function(e13, t2, n) {
        var r = n(35);
        e13.exports = function(e14) {
          return Object(r(e14));
        };
      },
      function(e13, t2, n) {
        var r = n(16), a = n(8), o = n(14), s = Object.defineProperty, c = {}, l = function(e14) {
          throw e14;
        };
        e13.exports = function(e14, t3) {
          if (o(c, e14))
            return c[e14];
          t3 ||= {};
          var n2 = [][e14], u = !!o(t3, "ACCESSORS") && t3.ACCESSORS, d = o(t3, 0) ? t3[0] : l, f = o(t3, 1) ? t3[1] : void 0;
          return c[e14] = !!n2 && !a(function() {
            if (u && !r)
              return true;
            var e15 = { length: -1 };
            u ? s(e15, 1, {
              enumerable: true,
              get: l
            }) : e15[1] = 1, n2.call(e15, d, f);
          });
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(148), a = n(149), o = n(151), s = n(98), c = n(153), l = n(154), u = n(155), d = n(99), f = n(100), p = n(156), m = n(157), h = n(101), g = n(158), _ = n(159), v = n(160), y = n(161), b = n(162), S = n(163), C = n(164), w = n(165), T = n(166), E = n(167), D = n(168), O = n(169), k = n(170);
        t2.create_domImplementation = function(e14) {
          return r.DOMImplementationImpl._create(e14);
        }, t2.create_window = function() {
          return a.WindowImpl._create();
        }, t2.create_xmlDocument = function() {
          return new o.XMLDocumentImpl();
        }, t2.create_document = function() {
          return new s.DocumentImpl();
        }, t2.create_abortController = function() {
          return new c.AbortControllerImpl();
        }, t2.create_abortSignal = function() {
          return l.AbortSignalImpl._create();
        }, t2.create_documentType = function(e14, t3, n2, r2) {
          return u.DocumentTypeImpl._create(e14, t3, n2, r2);
        }, t2.create_element = function(e14, t3, n2, r2) {
          return d.ElementImpl._create(e14, t3, n2, r2);
        }, t2.create_htmlElement = function(e14, t3, n2, r2) {
          return d.ElementImpl._create(e14, t3, n2, r2);
        }, t2.create_htmlUnknownElement = function(e14, t3, n2, r2) {
          return d.ElementImpl._create(e14, t3, n2, r2);
        }, t2.create_documentFragment = function(e14) {
          return f.DocumentFragmentImpl._create(e14);
        }, t2.create_shadowRoot = function(e14, t3) {
          return p.ShadowRootImpl._create(e14, t3);
        }, t2.create_attr = function(e14, t3) {
          return m.AttrImpl._create(e14, t3);
        }, t2.create_text = function(e14, t3) {
          return h.TextImpl._create(e14, t3);
        }, t2.create_cdataSection = function(e14, t3) {
          return g.CDATASectionImpl._create(e14, t3);
        }, t2.create_comment = function(e14, t3) {
          return _.CommentImpl._create(e14, t3);
        }, t2.create_processingInstruction = function(e14, t3, n2) {
          return v.ProcessingInstructionImpl._create(e14, t3, n2);
        }, t2.create_htmlCollection = function(e14, t3) {
          return t3 === void 0 && (t3 = function() {
            return true;
          }), y.HTMLCollectionImpl._create(e14, t3);
        }, t2.create_nodeList = function(e14) {
          return b.NodeListImpl._create(e14);
        }, t2.create_nodeListStatic = function(e14, t3) {
          return S.NodeListStaticImpl._create(e14, t3);
        }, t2.create_namedNodeMap = function(e14) {
          return C.NamedNodeMapImpl._create(e14);
        }, t2.create_range = function(e14, t3) {
          return w.RangeImpl._create(e14, t3);
        }, t2.create_nodeIterator = function(e14, t3, n2) {
          return T.NodeIteratorImpl._create(e14, t3, n2);
        }, t2.create_treeWalker = function(e14, t3) {
          return E.TreeWalkerImpl._create(e14, t3);
        }, t2.create_nodeFilter = function() {
          return D.NodeFilterImpl._create();
        }, t2.create_mutationRecord = function(e14, t3, n2, r2, a2, o2, s2, c2, l2) {
          return O.MutationRecordImpl._create(e14, t3, n2, r2, a2, o2, s2, c2, l2);
        }, t2.create_domTokenList = function(e14, t3) {
          return k.DOMTokenListImpl._create(e14, t3);
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(6), o = n(17), s = n(3), c = n(72), l = /* @__PURE__ */ new Map();
        function u(e14, t3) {
          if (t3 !== e14._root && o.tree_isAncestorOf(e14._reference, t3, true)) {
            if (e14._pointerBeforeReference)
              for (; ; ) {
                var n2 = o.tree_getFollowingNode(e14._root, t3);
                if (n2 !== null && o.tree_isDescendantOf(e14._root, n2, true) && !o.tree_isDescendantOf(t3, n2, true))
                  return void (e14._reference = n2);
                if (n2 === null)
                  return void (e14._pointerBeforeReference = false);
              }
            if (t3._previousSibling === null)
              t3._parent !== null && (e14._reference = t3._parent);
            else {
              for (var r2 = t3._previousSibling, a2 = o.tree_getFirstDescendantNode(t3._previousSibling, true, false); a2 !== null; )
                a2 !== null && (r2 = a2), a2 = o.tree_getNextDescendantNode(t3._previousSibling, a2, true, false);
              e14._reference = r2;
            }
          }
        }
        function d(e14, t3, n2, r2, a2) {
          if (s.Guard.isSlot(e14) && t3 === "name" && a2 === null) {
            if (r2 === n2 || r2 === null && n2 === "" || r2 === "" && n2 === null)
              return;
            e14._name = r2 === null || r2 === "" ? "" : r2, c.shadowTree_assignSlotablesForATree(o.tree_rootNode(e14));
          }
        }
        function f(e14, t3, n2, r2, a2) {
          if (s.Guard.isSlotable(e14) && t3 === "slot" && a2 === null) {
            if (r2 === n2 || r2 === null && n2 === "" || r2 === "" && n2 === null)
              return;
            e14._name = r2 === null || r2 === "" ? "" : r2, c.shadowTree_isAssigned(e14) && c.shadowTree_assignSlotables(e14._assignedSlot), c.shadowTree_assignASlot(e14);
          }
        }
        function p(e14, t3, n2, r2) {
          t3 === "id" && r2 === null && (e14._uniqueIdentifier = n2 || void 0);
        }
        t2.dom_runRemovingSteps = function(e14, t3) {
        }, t2.dom_runCloningSteps = function(e14, t3, n2, r2) {
        }, t2.dom_runAdoptingSteps = function(e14, t3) {
        }, t2.dom_runAttributeChangeSteps = function(e14, t3, n2, o2, s2) {
          var c2, l2;
          a.dom.features.slots && (f.call(e14, e14, t3, n2, o2, s2), d.call(e14, e14, t3, n2, o2, s2)), p.call(e14, e14, t3, o2, s2);
          try {
            for (var u2 = r(e14._attributeChangeSteps), m = u2.next(); !m.done; m = u2.next())
              m.value.call(e14, e14, t3, n2, o2, s2);
          } catch (e15) {
            c2 = { error: e15 };
          } finally {
            try {
              m && !m.done && (l2 = u2.return) && l2.call(u2);
            } finally {
              if (c2)
                throw c2.error;
            }
          }
        }, t2.dom_runInsertionSteps = function(e14) {
        }, t2.dom_runNodeIteratorPreRemovingSteps = function(e14, t3) {
          u.call(e14, e14, t3);
        }, t2.dom_hasSupportedTokens = function(e14) {
          return l.has(e14);
        }, t2.dom_getSupportedTokens = function(e14) {
          return l.get(e14) || /* @__PURE__ */ new Set();
        }, t2.dom_runEventConstructingSteps = function(e14) {
        }, t2.dom_runChildTextContentChangeSteps = function(e14) {
        };
      },
      function(e13, t2, n) {
        var r = n(4), a = n(11), o = n(46), s = n(44), c = n(16), l = n(86), u = n(124), d = n(8), f = n(14), p = n(59), m = n(13), h = n(18), g = n(27), _ = n(24), v = n(56), y = n(40), b = n(60), S = n(61), C = n(82), w = n(190), T = n(85), E = n(55), D = n(15), O = n(79), k = n(21), A = n(25), j = n(81), M = n(57), N = n(45), P = n(58), F = n(5), I = n(125), L = n(126), R = n(62), z = n(43), B = n(36).forEach, V = M("hidden"), H = F("toPrimitive"), U = z.set, W = z.getterFor("Symbol"), G = Object.prototype, K = a.Symbol, q = o("JSON", "stringify"), J = E.f, Y = D.f, hV = w.f, X = O.f, Z = j("symbols"), Q = j("op-symbols"), $ = j("string-to-symbol-registry"), gV = j("symbol-to-string-registry"), _V = j("wks"), vV = a.QObject, yV = !vV || !vV.prototype || !vV.prototype.findChild, bV = c && d(function() {
          return b(Y({}, "a", { get: function() {
            return Y(this, "a", { value: 7 }).a;
          } })).a != 7;
        }) ? function(e14, t3, n2) {
          var r2 = J(G, t3);
          r2 && delete G[t3], Y(e14, t3, n2), r2 && e14 !== G && Y(G, t3, r2);
        } : Y, xV = function(e14, t3) {
          var n2 = Z[e14] = b(K.prototype);
          return U(n2, {
            type: "Symbol",
            tag: e14,
            description: t3
          }), c || (n2.description = t3), n2;
        }, SV = u ? function(e14) {
          return typeof e14 == "symbol";
        } : function(e14) {
          return Object(e14) instanceof K;
        }, CV = function(e14, t3, n2) {
          e14 === G && CV(Q, t3, n2), h(e14);
          var r2 = v(t3, true);
          return h(n2), f(Z, r2) ? (n2.enumerable ? (f(e14, V) && e14[V][r2] && (e14[V][r2] = false), n2 = b(n2, { enumerable: y(0, false) })) : (f(e14, V) || Y(e14, V, y(1, {})), e14[V][r2] = true), bV(e14, r2, n2)) : Y(e14, r2, n2);
        }, wV = function(e14, t3) {
          h(e14);
          var n2 = _(t3);
          return B(S(n2).concat(OV(n2)), function(t4) {
            c && !TV.call(n2, t4) || CV(e14, t4, n2[t4]);
          }), e14;
        }, TV = function(e14) {
          var t3 = v(e14, true), n2 = X.call(this, t3);
          return !(this === G && f(Z, t3) && !f(Q, t3)) && (!(n2 || !f(this, t3) || !f(Z, t3) || f(this, V) && this[V][t3]) || n2);
        }, EV = function(e14, t3) {
          var n2 = _(e14), r2 = v(t3, true);
          if (n2 !== G || !f(Z, r2) || f(Q, r2)) {
            var a2 = J(n2, r2);
            return !a2 || !f(Z, r2) || f(n2, V) && n2[V][r2] || (a2.enumerable = true), a2;
          }
        }, DV = function(e14) {
          var t3 = hV(_(e14)), n2 = [];
          return B(t3, function(e15) {
            f(Z, e15) || f(N, e15) || n2.push(e15);
          }), n2;
        }, OV = function(e14) {
          var t3 = e14 === G, n2 = hV(t3 ? Q : _(e14)), r2 = [];
          return B(n2, function(e15) {
            !f(Z, e15) || t3 && !f(G, e15) || r2.push(Z[e15]);
          }), r2;
        };
        (l || (A((K = function() {
          if (this instanceof K)
            throw TypeError("Symbol is not a constructor");
          var e14 = arguments.length && arguments[0] !== void 0 ? String(arguments[0]) : void 0, t3 = P(e14), n2 = function(e15) {
            this === G && n2.call(Q, e15), f(this, V) && f(this[V], t3) && (this[V][t3] = false), bV(this, t3, y(1, e15));
          };
          return c && yV && bV(G, t3, {
            configurable: true,
            set: n2
          }), xV(t3, e14);
        }).prototype, "toString", function() {
          return W(this).tag;
        }), A(K, "withoutSetter", function(e14) {
          return xV(P(e14), e14);
        }), O.f = TV, D.f = CV, E.f = EV, C.f = w.f = DV, T.f = OV, I.f = function(e14) {
          return xV(F(e14), e14);
        }, c && (Y(K.prototype, "description", {
          configurable: true,
          get: function() {
            return W(this).description;
          }
        }), s || A(G, "propertyIsEnumerable", TV, { unsafe: true }))), r({
          global: true,
          wrap: true,
          forced: !l,
          sham: !l
        }, { Symbol: K }), B(S(_V), function(e14) {
          L(e14);
        }), r({
          target: "Symbol",
          stat: true,
          forced: !l
        }, {
          for: function(e14) {
            var t3 = String(e14);
            if (f($, t3))
              return $[t3];
            var n2 = K(t3);
            return $[t3] = n2, gV[n2] = t3, n2;
          },
          keyFor: function(e14) {
            if (!SV(e14))
              throw TypeError(e14 + " is not a symbol");
            if (f(gV, e14))
              return gV[e14];
          },
          useSetter: function() {
            yV = true;
          },
          useSimple: function() {
            yV = false;
          }
        }), r({
          target: "Object",
          stat: true,
          forced: !l,
          sham: !c
        }, {
          create: function(e14, t3) {
            return t3 === void 0 ? b(e14) : wV(b(e14), t3);
          },
          defineProperty: CV,
          defineProperties: wV,
          getOwnPropertyDescriptor: EV
        }), r({
          target: "Object",
          stat: true,
          forced: !l
        }, {
          getOwnPropertyNames: DV,
          getOwnPropertySymbols: OV
        }), r({
          target: "Object",
          stat: true,
          forced: d(function() {
            T.f(1);
          })
        }, { getOwnPropertySymbols: function(e14) {
          return T.f(g(e14));
        } }), q) && r({
          target: "JSON",
          stat: true,
          forced: !l || d(function() {
            var e14 = K();
            return q([e14]) != "[null]" || q({ a: e14 }) != "{}" || q(Object(e14)) != "{}";
          })
        }, { stringify: function(e14, t3, n2) {
          for (var r2, a2 = [e14], o2 = 1; arguments.length > o2; )
            a2.push(arguments[o2++]);
          if (r2 = t3, (m(t3) || e14 !== void 0) && !SV(e14))
            return p(t3) || (t3 = function(e15, t4) {
              if (typeof r2 == "function" && (t4 = r2.call(this, e15, t4)), !SV(t4))
                return t4;
            }), a2[1] = t3, q.apply(null, a2);
        } }), K.prototype[H] || k(K.prototype, H, K.prototype.valueOf), R(K, "Symbol"), N[V] = true;
      },
      function(e13, t2, n) {
        var r = n(4), a = n(16), o = n(11), s = n(14), c = n(13), l = n(15).f, u = n(119), d = o.Symbol;
        if (a && typeof d == "function" && (!("description" in d.prototype) || d().description !== void 0)) {
          var f = {}, p = function() {
            var e14 = arguments.length < 1 || arguments[0] === void 0 ? void 0 : String(arguments[0]), t3 = this instanceof p ? new d(e14) : e14 === void 0 ? d() : d(e14);
            return e14 === "" && (f[t3] = true), t3;
          };
          u(p, d);
          var m = p.prototype = d.prototype;
          m.constructor = p;
          var h = m.toString, g = String(d("test")) == "Symbol(test)", _ = /^Symbol\((.*)\)[^)]+$/;
          l(m, "description", {
            configurable: true,
            get: function() {
              var e14 = c(this) ? this.valueOf() : this, t3 = h.call(e14);
              if (s(f, e14))
                return "";
              var n2 = g ? t3.slice(7, -1) : t3.replace(_, "$1");
              return n2 === "" ? void 0 : n2;
            }
          }), r({
            global: true,
            forced: true
          }, { Symbol: p });
        }
      },
      function(e13, t2, n) {
        n(126)("iterator");
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(6), c = n(2), l = n(70), u = n(3), d = n(9), f = n(0), p = n(152), m = n(12), h = function(e14) {
          function t3() {
            var t4 = e14.call(this) || this;
            return t4._parent = null, t4._firstChild = null, t4._lastChild = null, t4._previousSibling = null, t4._nextSibling = null, t4;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "_childNodes", {
            get: function() {
              return this.__childNodes ||= f.create_nodeList(this);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "_nodeDocument", {
            get: function() {
              return this._nodeDocumentOverride || s.dom.window._associatedDocument;
            },
            set: function(e15) {
              this._nodeDocumentOverride = e15;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "_registeredObserverList", {
            get: function() {
              return this.__registeredObserverList ||= [];
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "nodeType", {
            get: function() {
              return this._nodeType;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "nodeName", {
            get: function() {
              return u.Guard.isElementNode(this) ? this._htmlUppercasedQualifiedName : u.Guard.isAttrNode(this) ? this._qualifiedName : u.Guard.isExclusiveTextNode(this) ? "#text" : u.Guard.isCDATASectionNode(this) ? "#cdata-section" : u.Guard.isProcessingInstructionNode(this) ? this._target : u.Guard.isCommentNode(this) ? "#comment" : u.Guard.isDocumentNode(this) ? "#document" : u.Guard.isDocumentTypeNode(this) ? this._name : u.Guard.isDocumentFragmentNode(this) ? "#document-fragment" : "";
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "baseURI", {
            get: function() {
              return p.urlSerializer(this._nodeDocument._URL);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "isConnected", {
            get: function() {
              return u.Guard.isElementNode(this) && f.shadowTree_isConnected(this);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "ownerDocument", {
            get: function() {
              return this._nodeType === c.NodeType.Document ? null : this._nodeDocument;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.getRootNode = function(e15) {
            return f.tree_rootNode(this, !!e15 && e15.composed);
          }, Object.defineProperty(t3.prototype, "parentNode", {
            get: function() {
              return this._nodeType === c.NodeType.Attribute ? null : this._parent;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "parentElement", {
            get: function() {
              return this._parent && u.Guard.isElementNode(this._parent) ? this._parent : null;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.hasChildNodes = function() {
            return this._firstChild !== null;
          }, Object.defineProperty(t3.prototype, "childNodes", {
            get: function() {
              return this._childNodes;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "firstChild", {
            get: function() {
              return this._firstChild;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "lastChild", {
            get: function() {
              return this._lastChild;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "previousSibling", {
            get: function() {
              return this._previousSibling;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "nextSibling", {
            get: function() {
              return this._nextSibling;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "nodeValue", {
            get: function() {
              return u.Guard.isAttrNode(this) ? this._value : u.Guard.isCharacterDataNode(this) ? this._data : null;
            },
            set: function(e15) {
              e15 === null && (e15 = ""), u.Guard.isAttrNode(this) ? f.attr_setAnExistingAttributeValue(this, e15) : u.Guard.isCharacterDataNode(this) && f.characterData_replaceData(this, 0, this._data.length, e15);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "textContent", {
            get: function() {
              return u.Guard.isDocumentFragmentNode(this) || u.Guard.isElementNode(this) ? f.text_descendantTextContent(this) : u.Guard.isAttrNode(this) ? this._value : u.Guard.isCharacterDataNode(this) ? this._data : null;
            },
            set: function(e15) {
              e15 === null && (e15 = ""), u.Guard.isDocumentFragmentNode(this) || u.Guard.isElementNode(this) ? f.node_stringReplaceAll(e15, this) : u.Guard.isAttrNode(this) ? f.attr_setAnExistingAttributeValue(this, e15) : u.Guard.isCharacterDataNode(this) && f.characterData_replaceData(this, 0, f.tree_nodeLength(this), e15);
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.normalize = function() {
            for (var e15, t4, n2, r2, a2 = [], c2 = f.tree_getFirstDescendantNode(this, false, false, function(e16) {
              return u.Guard.isExclusiveTextNode(e16);
            }); c2 !== null; )
              a2.push(c2), c2 = f.tree_getNextDescendantNode(this, c2, false, false, function(e16) {
                return u.Guard.isExclusiveTextNode(e16);
              });
            for (var l2 = 0; l2 < a2.length; l2++) {
              var d2 = a2[l2];
              if (d2._parent !== null) {
                var p2 = f.tree_nodeLength(d2);
                if (p2 !== 0) {
                  var m2 = [], h2 = "";
                  try {
                    for (var g = (e15 = void 0, o(f.text_contiguousExclusiveTextNodes(d2))), _ = g.next(); !_.done; _ = g.next()) {
                      var v = _.value;
                      m2.push(v), h2 += v._data;
                    }
                  } catch (t5) {
                    e15 = { error: t5 };
                  } finally {
                    try {
                      _ && !_.done && (t4 = g.return) && t4.call(g);
                    } finally {
                      if (e15)
                        throw e15.error;
                    }
                  }
                  if (f.characterData_replaceData(d2, p2, 0, h2), s.dom.rangeList.size !== 0)
                    for (var y = d2._nextSibling; y !== null && u.Guard.isExclusiveTextNode(y); ) {
                      var b = y, S = f.tree_index(b);
                      try {
                        for (var C = (n2 = void 0, o(s.dom.rangeList)), w = C.next(); !w.done; w = C.next()) {
                          var T = w.value;
                          T._start[0] === b && (T._start[0] = d2, T._start[1] += p2), T._end[0] === b && (T._end[0] = d2, T._end[1] += p2), T._start[0] === b._parent && T._start[1] === S && (T._start[0] = d2, T._start[1] = p2), T._end[0] === b._parent && T._end[1] === S && (T._end[0] = d2, T._end[1] = p2);
                        }
                      } catch (e16) {
                        n2 = { error: e16 };
                      } finally {
                        try {
                          w && !w.done && (r2 = C.return) && r2.call(C);
                        } finally {
                          if (n2)
                            throw n2.error;
                        }
                      }
                      p2 += f.tree_nodeLength(y), y = y._nextSibling;
                    }
                  for (var E = 0; E < m2.length; E++)
                    (v = m2[E])._parent !== null && f.mutation_remove(v, v._parent);
                } else
                  f.mutation_remove(d2, d2._parent);
              }
            }
          }, t3.prototype.cloneNode = function(e15) {
            if (e15 === void 0 && (e15 = false), u.Guard.isShadowRoot(this))
              throw new d.NotSupportedError();
            return f.node_clone(this, null, e15);
          }, t3.prototype.isEqualNode = function(e15) {
            return e15 === void 0 && (e15 = null), e15 !== null && f.node_equals(this, e15);
          }, t3.prototype.isSameNode = function(e15) {
            return e15 === void 0 && (e15 = null), this === e15;
          }, t3.prototype.compareDocumentPosition = function(e15) {
            if (e15 === this)
              return 0;
            var t4 = e15, n2 = this, r2 = null, a2 = null;
            if (u.Guard.isAttrNode(t4) && (t4 = (r2 = t4)._element), u.Guard.isAttrNode(n2) && (n2 = (a2 = n2)._element, r2 && t4 && t4 === n2))
              for (var o2 = 0; o2 < n2._attributeList.length; o2++) {
                var l2 = n2._attributeList[o2];
                if (f.node_equals(l2, r2))
                  return c.Position.ImplementationSpecific | c.Position.Preceding;
                if (f.node_equals(l2, a2))
                  return c.Position.ImplementationSpecific | c.Position.Following;
              }
            return t4 === null || n2 === null || f.tree_rootNode(t4) !== f.tree_rootNode(n2) ? c.Position.Disconnected | c.Position.ImplementationSpecific | (s.dom.compareCache.check(this, e15) ? c.Position.Preceding : c.Position.Following) : !r2 && f.tree_isAncestorOf(n2, t4) || a2 && t4 === n2 ? c.Position.Contains | c.Position.Preceding : !a2 && f.tree_isDescendantOf(n2, t4) || r2 && t4 === n2 ? c.Position.ContainedBy | c.Position.Following : f.tree_isPreceding(n2, t4) ? c.Position.Preceding : c.Position.Following;
          }, t3.prototype.contains = function(e15) {
            return e15 !== null && f.tree_isDescendantOf(this, e15, true);
          }, t3.prototype.lookupPrefix = function(e15) {
            return e15 ? u.Guard.isElementNode(this) ? f.node_locateANamespacePrefix(this, e15) : u.Guard.isDocumentNode(this) ? this.documentElement === null ? null : f.node_locateANamespacePrefix(this.documentElement, e15) : u.Guard.isDocumentTypeNode(this) || u.Guard.isDocumentFragmentNode(this) ? null : u.Guard.isAttrNode(this) ? this._element === null ? null : f.node_locateANamespacePrefix(this._element, e15) : this._parent !== null && u.Guard.isElementNode(this._parent) ? f.node_locateANamespacePrefix(this._parent, e15) : null : null;
          }, t3.prototype.lookupNamespaceURI = function(e15) {
            return f.node_locateANamespace(this, e15 || null);
          }, t3.prototype.isDefaultNamespace = function(e15) {
            return e15 ||= null, f.node_locateANamespace(this, null) === e15;
          }, t3.prototype.insertBefore = function(e15, t4) {
            return f.mutation_preInsert(e15, this, t4);
          }, t3.prototype.appendChild = function(e15) {
            return f.mutation_append(e15, this);
          }, t3.prototype.replaceChild = function(e15, t4) {
            return f.mutation_replace(t4, e15, this);
          }, t3.prototype.removeChild = function(e15) {
            return f.mutation_preRemove(e15, this);
          }, t3.prototype._getTheParent = function(e15) {
            return u.Guard.isSlotable(this) && f.shadowTree_isAssigned(this) ? this._assignedSlot : this._parent;
          }, t3.ELEMENT_NODE = 1, t3.ATTRIBUTE_NODE = 2, t3.TEXT_NODE = 3, t3.CDATA_SECTION_NODE = 4, t3.ENTITY_REFERENCE_NODE = 5, t3.ENTITY_NODE = 6, t3.PROCESSING_INSTRUCTION_NODE = 7, t3.COMMENT_NODE = 8, t3.DOCUMENT_NODE = 9, t3.DOCUMENT_TYPE_NODE = 10, t3.DOCUMENT_FRAGMENT_NODE = 11, t3.NOTATION_NODE = 12, t3.DOCUMENT_POSITION_DISCONNECTED = 1, t3.DOCUMENT_POSITION_PRECEDING = 2, t3.DOCUMENT_POSITION_FOLLOWING = 4, t3.DOCUMENT_POSITION_CONTAINS = 8, t3.DOCUMENT_POSITION_CONTAINED_BY = 16, t3.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC = 32, t3;
        }(l.EventTargetImpl);
        t2.NodeImpl = h, h.prototype._children = new u.EmptySet(), m.idl_defineConst(h.prototype, "ELEMENT_NODE", 1), m.idl_defineConst(h.prototype, "ATTRIBUTE_NODE", 2), m.idl_defineConst(h.prototype, "TEXT_NODE", 3), m.idl_defineConst(h.prototype, "CDATA_SECTION_NODE", 4), m.idl_defineConst(h.prototype, "ENTITY_REFERENCE_NODE", 5), m.idl_defineConst(h.prototype, "ENTITY_NODE", 6), m.idl_defineConst(h.prototype, "PROCESSING_INSTRUCTION_NODE", 7), m.idl_defineConst(h.prototype, "COMMENT_NODE", 8), m.idl_defineConst(h.prototype, "DOCUMENT_NODE", 9), m.idl_defineConst(h.prototype, "DOCUMENT_TYPE_NODE", 10), m.idl_defineConst(h.prototype, "DOCUMENT_FRAGMENT_NODE", 11), m.idl_defineConst(h.prototype, "NOTATION_NODE", 12), m.idl_defineConst(h.prototype, "DOCUMENT_POSITION_DISCONNECTED", 1), m.idl_defineConst(h.prototype, "DOCUMENT_POSITION_PRECEDING", 2), m.idl_defineConst(h.prototype, "DOCUMENT_POSITION_FOLLOWING", 4), m.idl_defineConst(h.prototype, "DOCUMENT_POSITION_CONTAINS", 8), m.idl_defineConst(h.prototype, "DOCUMENT_POSITION_CONTAINED_BY", 16), m.idl_defineConst(h.prototype, "DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC", 32);
      },
      function(e13, t2) {
        e13.exports = function(e14) {
          if (e14 == null)
            throw TypeError("Can't call method on " + e14);
          return e14;
        };
      },
      function(e13, t2, n) {
        var r = n(87), a = n(41), o = n(27), s = n(26), c = n(128), l = [].push, u = function(e14) {
          var t3 = e14 == 1, n2 = e14 == 2, u2 = e14 == 3, d = e14 == 4, f = e14 == 6, p = e14 == 5 || f;
          return function(m, h, g, _) {
            for (var v, y, b = o(m), S = a(b), C = r(h, g, 3), w = s(S.length), T = 0, E = _ || c, D = t3 ? E(m, w) : n2 ? E(m, 0) : void 0; w > T; T++)
              if ((p || T in S) && (y = C(v = S[T], T, b), e14)) {
                if (t3)
                  D[T] = y;
                else if (y)
                  switch (e14) {
                    case 3:
                      return true;
                    case 5:
                      return v;
                    case 6:
                      return T;
                    case 2:
                      l.call(D, v);
                  }
                else if (d)
                  return false;
              }
            return f ? -1 : u2 || d ? d : D;
          };
        };
        e13.exports = {
          forEach: u(0),
          map: u(1),
          filter: u(2),
          some: u(3),
          every: u(4),
          find: u(5),
          findIndex: u(6)
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, a = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, o = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(a(arguments[t3]));
          return e14;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(6), c = n(9), l = n(2), u = n(3), d = n(1), f = n(7), p = n(73), m = n(17), h = n(172), g = n(72), _ = n(51), v = n(30), y = n(106);
        function b(e14, t3, n2) {
          var a2, o2, s2, u2, d2, f2, p2, h2, g2 = t3._nodeType, _2 = e14._nodeType, v2 = n2 ? n2._nodeType : null;
          if (g2 !== l.NodeType.Document && g2 !== l.NodeType.DocumentFragment && g2 !== l.NodeType.Element)
            throw new c.HierarchyRequestError("Only document, document fragment and element nodes can contain child nodes. Parent node is " + t3.nodeName + ".");
          if (m.tree_isHostIncludingAncestorOf(t3, e14, true))
            throw new c.HierarchyRequestError("The node to be inserted cannot be an inclusive ancestor of parent node. Node is " + e14.nodeName + ", parent node is " + t3.nodeName + ".");
          if (n2 !== null && n2._parent !== t3)
            throw new c.NotFoundError("The reference child node cannot be found under parent node. Child node is " + n2.nodeName + ", parent node is " + t3.nodeName + ".");
          if (_2 !== l.NodeType.DocumentFragment && _2 !== l.NodeType.DocumentType && _2 !== l.NodeType.Element && _2 !== l.NodeType.Text && _2 !== l.NodeType.ProcessingInstruction && _2 !== l.NodeType.CData && _2 !== l.NodeType.Comment)
            throw new c.HierarchyRequestError("Only document fragment, document type, element, text, processing instruction, cdata section or comment nodes can be inserted. Node is " + e14.nodeName + ".");
          if (_2 === l.NodeType.Text && g2 === l.NodeType.Document)
            throw new c.HierarchyRequestError("Cannot insert a text node as a child of a document node. Node is " + e14.nodeName + ".");
          if (_2 === l.NodeType.DocumentType && g2 !== l.NodeType.Document)
            throw new c.HierarchyRequestError("A document type node can only be inserted under a document node. Parent node is " + t3.nodeName + ".");
          if (g2 === l.NodeType.Document) {
            if (_2 === l.NodeType.DocumentFragment) {
              var y2 = 0;
              try {
                for (var b2 = r(e14._children), S2 = b2.next(); !S2.done; S2 = b2.next()) {
                  var C2 = S2.value;
                  if (C2._nodeType === l.NodeType.Element)
                    y2++;
                  else if (C2._nodeType === l.NodeType.Text)
                    throw new c.HierarchyRequestError("Cannot insert text a node as a child of a document node. Node is " + C2.nodeName + ".");
                }
              } catch (e15) {
                a2 = { error: e15 };
              } finally {
                try {
                  S2 && !S2.done && (o2 = b2.return) && o2.call(b2);
                } finally {
                  if (a2)
                    throw a2.error;
                }
              }
              if (y2 > 1)
                throw new c.HierarchyRequestError("A document node can only have one document element node. Document fragment to be inserted has " + y2 + " element nodes.");
              if (y2 === 1) {
                try {
                  for (var w2 = r(t3._children), T = w2.next(); !T.done; T = w2.next())
                    if (T.value._nodeType === l.NodeType.Element)
                      throw new c.HierarchyRequestError("The document node already has a document element node.");
                } catch (e15) {
                  s2 = { error: e15 };
                } finally {
                  try {
                    T && !T.done && (u2 = w2.return) && u2.call(w2);
                  } finally {
                    if (s2)
                      throw s2.error;
                  }
                }
                if (n2) {
                  if (v2 === l.NodeType.DocumentType)
                    throw new c.HierarchyRequestError("Cannot insert an element node before a document type node.");
                  for (var E = n2._nextSibling; E; ) {
                    if (E._nodeType === l.NodeType.DocumentType)
                      throw new c.HierarchyRequestError("Cannot insert an element node before a document type node.");
                    E = E._nextSibling;
                  }
                }
              }
            } else if (_2 === l.NodeType.Element) {
              try {
                for (var D = r(t3._children), O = D.next(); !O.done; O = D.next())
                  if (O.value._nodeType === l.NodeType.Element)
                    throw new c.HierarchyRequestError("Document already has a document element node. Node is " + e14.nodeName + ".");
              } catch (e15) {
                d2 = { error: e15 };
              } finally {
                try {
                  O && !O.done && (f2 = D.return) && f2.call(D);
                } finally {
                  if (d2)
                    throw d2.error;
                }
              }
              if (n2) {
                if (v2 === l.NodeType.DocumentType)
                  throw new c.HierarchyRequestError("Cannot insert an element node before a document type node. Node is " + e14.nodeName + ".");
                for (E = n2._nextSibling; E; ) {
                  if (E._nodeType === l.NodeType.DocumentType)
                    throw new c.HierarchyRequestError("Cannot insert an element node before a document type node. Node is " + e14.nodeName + ".");
                  E = E._nextSibling;
                }
              }
            } else if (_2 === l.NodeType.DocumentType) {
              try {
                for (var k = r(t3._children), A = k.next(); !A.done; A = k.next())
                  if (A.value._nodeType === l.NodeType.DocumentType)
                    throw new c.HierarchyRequestError("Document already has a document type node. Node is " + e14.nodeName + ".");
              } catch (e15) {
                p2 = { error: e15 };
              } finally {
                try {
                  A && !A.done && (h2 = k.return) && h2.call(k);
                } finally {
                  if (p2)
                    throw p2.error;
                }
              }
              if (n2)
                for (var j = n2._previousSibling; j; ) {
                  if (j._nodeType === l.NodeType.Element)
                    throw new c.HierarchyRequestError("Cannot insert a document type node before an element node. Node is " + e14.nodeName + ".");
                  j = j._previousSibling;
                }
              else
                for (j = t3._firstChild; j; ) {
                  if (j._nodeType === l.NodeType.Element)
                    throw new c.HierarchyRequestError("Cannot insert a document type node before an element node. Node is " + e14.nodeName + ".");
                  j = j._nextSibling;
                }
            }
          }
        }
        function S(e14, t3, n2) {
          b(e14, t3, n2);
          var r2 = n2;
          return r2 === e14 && (r2 = e14._nextSibling), y.document_adopt(e14, t3._nodeDocument), C(e14, t3, r2), e14;
        }
        function C(e14, t3, n2, a2) {
          var c2, h2;
          if (n2 !== null || e14._nodeType === l.NodeType.DocumentFragment) {
            var y2 = e14._nodeType === l.NodeType.DocumentFragment ? e14._children.size : 1;
            if (n2 !== null && s.dom.rangeList.size !== 0) {
              var b2 = m.tree_index(n2);
              try {
                for (var S2 = r(s.dom.rangeList), C2 = S2.next(); !C2.done; C2 = S2.next()) {
                  var T = C2.value;
                  T._start[0] === t3 && T._start[1] > b2 && (T._start[1] += y2), T._end[0] === t3 && T._end[1] > b2 && (T._end[1] += y2);
                }
              } catch (e15) {
                c2 = { error: e15 };
              } finally {
                try {
                  C2 && !C2.done && (h2 = S2.return) && h2.call(S2);
                } finally {
                  if (c2)
                    throw c2.error;
                }
              }
            }
            var E = e14._nodeType === l.NodeType.DocumentFragment ? new (Array.bind.apply(Array, o([void 0], e14._children)))() : [e14];
            if (e14._nodeType === l.NodeType.DocumentFragment)
              for (; e14._firstChild; )
                w(e14._firstChild, e14, true);
            s.dom.features.mutationObservers && e14._nodeType === l.NodeType.DocumentFragment && _.observer_queueTreeMutationRecord(e14, [], E, null, null);
            for (var D = n2 ? n2._previousSibling : t3._lastChild, O = n2 === null ? -1 : m.tree_index(n2), k = 0; k < E.length; k++) {
              var A = E[k];
              if (u.Guard.isElementNode(A) && (u.Guard.isDocumentNode(t3) && (t3._documentElement = A), A._nodeDocument._hasNamespaces || A._namespace === null && A._namespacePrefix === null || (A._nodeDocument._hasNamespaces = true)), A._parent = t3, n2 === null ? f.set.append(t3._children, A) : (f.set.insert(t3._children, A, O), O++), t3._firstChild === null)
                A._previousSibling = null, A._nextSibling = null, t3._firstChild = A, t3._lastChild = A;
              else {
                var j = n2 ? n2._previousSibling : t3._lastChild, M = n2 || null;
                A._previousSibling = j, A._nextSibling = M, j && (j._nextSibling = A), M && (M._previousSibling = A), j || (t3._firstChild = A), M || (t3._lastChild = A);
              }
              s.dom.features.slots && t3._shadowRoot !== null && u.Guard.isSlotable(A) && g.shadowTree_assignASlot(A), s.dom.features.steps && u.Guard.isTextNode(A) && v.dom_runChildTextContentChangeSteps(t3), s.dom.features.slots && u.Guard.isShadowRoot(m.tree_rootNode(t3)) && u.Guard.isSlot(t3) && d.isEmpty(t3._assignedNodes) && g.shadowTree_signalASlotChange(t3), s.dom.features.slots && g.shadowTree_assignSlotablesForATree(m.tree_rootNode(A));
              for (var N = m.tree_getFirstDescendantNode(A, true, true); N !== null; )
                s.dom.features.steps && v.dom_runInsertionSteps(N), s.dom.features.customElements && u.Guard.isElementNode(N) && g.shadowTree_isConnected(N) && (u.Guard.isCustomElementNode(N) ? p.customElement_enqueueACustomElementCallbackReaction(N, "connectedCallback", []) : p.customElement_tryToUpgrade(N)), N = m.tree_getNextDescendantNode(A, N, true, true);
            }
            s.dom.features.mutationObservers && (a2 || _.observer_queueTreeMutationRecord(t3, E, [], D, n2));
          } else
            (function(e15, t4, n3) {
              var r2 = t4._lastChild;
              if (u.Guard.isElementNode(e15) && (u.Guard.isDocumentNode(t4) && (t4._documentElement = e15), e15._nodeDocument._hasNamespaces || e15._namespace === null && e15._namespacePrefix === null || (e15._nodeDocument._hasNamespaces = true)), e15._parent = t4, t4._children.add(e15), t4._firstChild === null)
                e15._previousSibling = null, e15._nextSibling = null, t4._firstChild = e15, t4._lastChild = e15;
              else {
                var a3 = t4._lastChild;
                e15._previousSibling = a3, e15._nextSibling = null, a3 && (a3._nextSibling = e15), a3 || (t4._firstChild = e15), t4._lastChild = e15;
              }
              s.dom.features.slots && t4._shadowRoot !== null && u.Guard.isSlotable(e15) && g.shadowTree_assignASlot(e15), s.dom.features.steps && u.Guard.isTextNode(e15) && v.dom_runChildTextContentChangeSteps(t4), s.dom.features.slots && u.Guard.isShadowRoot(m.tree_rootNode(t4)) && u.Guard.isSlot(t4) && d.isEmpty(t4._assignedNodes) && g.shadowTree_signalASlotChange(t4), s.dom.features.slots && g.shadowTree_assignSlotablesForATree(m.tree_rootNode(e15)), s.dom.features.steps && v.dom_runInsertionSteps(e15), s.dom.features.customElements && u.Guard.isElementNode(e15) && g.shadowTree_isConnected(e15) && (u.Guard.isCustomElementNode(e15) ? p.customElement_enqueueACustomElementCallbackReaction(e15, "connectedCallback", []) : p.customElement_tryToUpgrade(e15)), s.dom.features.mutationObservers && (n3 || _.observer_queueTreeMutationRecord(t4, [e15], [], r2, null));
            })(e14, t3, a2);
        }
        function w(e14, t3, n2) {
          var a2, o2, c2, l2, f2, y2, b2, S2;
          if (s.dom.rangeList.size !== 0) {
            var C2 = m.tree_index(e14);
            try {
              for (var w2 = r(s.dom.rangeList), T = w2.next(); !T.done; T = w2.next()) {
                var E = T.value;
                m.tree_isDescendantOf(e14, E._start[0], true) && (E._start = [t3, C2]), m.tree_isDescendantOf(e14, E._end[0], true) && (E._end = [t3, C2]), E._start[0] === t3 && E._start[1] > C2 && E._start[1]--, E._end[0] === t3 && E._end[1] > C2 && E._end[1]--;
              }
            } catch (e15) {
              a2 = { error: e15 };
            } finally {
              try {
                T && !T.done && (o2 = w2.return) && o2.call(w2);
              } finally {
                if (a2)
                  throw a2.error;
              }
            }
            try {
              for (var D = r(s.dom.rangeList), O = D.next(); !O.done; O = D.next())
                (E = O.value)._start[0] === t3 && E._start[1] > C2 && --E._start[1], E._end[0] === t3 && E._end[1] > C2 && --E._end[1];
            } catch (e15) {
              c2 = { error: e15 };
            } finally {
              try {
                O && !O.done && (l2 = D.return) && l2.call(D);
              } finally {
                if (c2)
                  throw c2.error;
              }
            }
          }
          if (s.dom.features.steps)
            try {
              for (var k = r(h.nodeIterator_iteratorList()), A = k.next(); !A.done; A = k.next()) {
                var j = A.value;
                j._root._nodeDocument === e14._nodeDocument && v.dom_runNodeIteratorPreRemovingSteps(j, e14);
              }
            } catch (e15) {
              f2 = { error: e15 };
            } finally {
              try {
                A && !A.done && (y2 = k.return) && y2.call(k);
              } finally {
                if (f2)
                  throw f2.error;
              }
            }
          var M = e14._previousSibling, N = e14._nextSibling;
          u.Guard.isDocumentNode(t3) && u.Guard.isElementNode(e14) && (t3._documentElement = null), e14._parent = null, t3._children.delete(e14);
          var P = e14._previousSibling, F = e14._nextSibling;
          (e14._previousSibling = null, e14._nextSibling = null, P && (P._nextSibling = F), F && (F._previousSibling = P), P || (t3._firstChild = F), F || (t3._lastChild = P), s.dom.features.slots && u.Guard.isSlotable(e14) && e14._assignedSlot !== null && g.shadowTree_isAssigned(e14) && g.shadowTree_assignSlotables(e14._assignedSlot), s.dom.features.slots && u.Guard.isShadowRoot(m.tree_rootNode(t3)) && u.Guard.isSlot(t3) && d.isEmpty(t3._assignedNodes) && g.shadowTree_signalASlotChange(t3), s.dom.features.slots) && m.tree_getFirstDescendantNode(e14, true, false, function(e15) {
            return u.Guard.isSlot(e15);
          }) !== null && (g.shadowTree_assignSlotablesForATree(m.tree_rootNode(t3)), g.shadowTree_assignSlotablesForATree(e14)), s.dom.features.steps && v.dom_runRemovingSteps(e14, t3), s.dom.features.customElements && u.Guard.isCustomElementNode(e14) && p.customElement_enqueueACustomElementCallbackReaction(e14, "disconnectedCallback", []);
          for (var I = m.tree_getFirstDescendantNode(e14, false, true); I !== null; )
            s.dom.features.steps && v.dom_runRemovingSteps(I, e14), s.dom.features.customElements && u.Guard.isCustomElementNode(I) && p.customElement_enqueueACustomElementCallbackReaction(I, "disconnectedCallback", []), I = m.tree_getNextDescendantNode(e14, I, false, true);
          if (s.dom.features.mutationObservers)
            for (var L = m.tree_getFirstAncestorNode(t3, true); L !== null; ) {
              try {
                for (var R = (b2 = void 0, r(L._registeredObserverList)), z = R.next(); !z.done; z = R.next()) {
                  var B = z.value;
                  B.options.subtree && e14._registeredObserverList.push({
                    observer: B.observer,
                    options: B.options,
                    source: B
                  });
                }
              } catch (e15) {
                b2 = { error: e15 };
              } finally {
                try {
                  z && !z.done && (S2 = R.return) && S2.call(R);
                } finally {
                  if (b2)
                    throw b2.error;
                }
              }
              L = m.tree_getNextAncestorNode(t3, L, true);
            }
          s.dom.features.mutationObservers && (n2 || _.observer_queueTreeMutationRecord(t3, [], [e14], M, N)), s.dom.features.steps && u.Guard.isTextNode(e14) && v.dom_runChildTextContentChangeSteps(t3);
        }
        t2.mutation_ensurePreInsertionValidity = b, t2.mutation_preInsert = S, t2.mutation_insert = C, t2.mutation_append = function(e14, t3) {
          return S(e14, t3, null);
        }, t2.mutation_replace = function(e14, t3, n2) {
          var a2, o2, u2, d2, f2, p2, h2, g2;
          if (n2._nodeType !== l.NodeType.Document && n2._nodeType !== l.NodeType.DocumentFragment && n2._nodeType !== l.NodeType.Element)
            throw new c.HierarchyRequestError("Only document, document fragment and element nodes can contain child nodes. Parent node is " + n2.nodeName + ".");
          if (m.tree_isHostIncludingAncestorOf(n2, t3, true))
            throw new c.HierarchyRequestError("The node to be inserted cannot be an ancestor of parent node. Node is " + t3.nodeName + ", parent node is " + n2.nodeName + ".");
          if (e14._parent !== n2)
            throw new c.NotFoundError("The reference child node cannot be found under parent node. Child node is " + e14.nodeName + ", parent node is " + n2.nodeName + ".");
          if (t3._nodeType !== l.NodeType.DocumentFragment && t3._nodeType !== l.NodeType.DocumentType && t3._nodeType !== l.NodeType.Element && t3._nodeType !== l.NodeType.Text && t3._nodeType !== l.NodeType.ProcessingInstruction && t3._nodeType !== l.NodeType.CData && t3._nodeType !== l.NodeType.Comment)
            throw new c.HierarchyRequestError("Only document fragment, document type, element, text, processing instruction, cdata section or comment nodes can be inserted. Node is " + t3.nodeName + ".");
          if (t3._nodeType === l.NodeType.Text && n2._nodeType === l.NodeType.Document)
            throw new c.HierarchyRequestError("Cannot insert a text node as a child of a document node. Node is " + t3.nodeName + ".");
          if (t3._nodeType === l.NodeType.DocumentType && n2._nodeType !== l.NodeType.Document)
            throw new c.HierarchyRequestError("A document type node can only be inserted under a document node. Parent node is " + n2.nodeName + ".");
          if (n2._nodeType === l.NodeType.Document) {
            if (t3._nodeType === l.NodeType.DocumentFragment) {
              var v2 = 0;
              try {
                for (var b2 = r(t3._children), S2 = b2.next(); !S2.done; S2 = b2.next()) {
                  var T = S2.value;
                  if (T._nodeType === l.NodeType.Element)
                    v2++;
                  else if (T._nodeType === l.NodeType.Text)
                    throw new c.HierarchyRequestError("Cannot insert text a node as a child of a document node. Node is " + T.nodeName + ".");
                }
              } catch (e15) {
                a2 = { error: e15 };
              } finally {
                try {
                  S2 && !S2.done && (o2 = b2.return) && o2.call(b2);
                } finally {
                  if (a2)
                    throw a2.error;
                }
              }
              if (v2 > 1)
                throw new c.HierarchyRequestError("A document node can only have one document element node. Document fragment to be inserted has " + v2 + " element nodes.");
              if (v2 === 1) {
                try {
                  for (var E = r(n2._children), D = E.next(); !D.done; D = E.next())
                    if ((N = D.value)._nodeType === l.NodeType.Element && N !== e14)
                      throw new c.HierarchyRequestError("The document node already has a document element node.");
                } catch (e15) {
                  u2 = { error: e15 };
                } finally {
                  try {
                    D && !D.done && (d2 = E.return) && d2.call(E);
                  } finally {
                    if (u2)
                      throw u2.error;
                  }
                }
                for (var O = e14._nextSibling; O; ) {
                  if (O._nodeType === l.NodeType.DocumentType)
                    throw new c.HierarchyRequestError("Cannot insert an element node before a document type node.");
                  O = O._nextSibling;
                }
              }
            } else if (t3._nodeType === l.NodeType.Element) {
              try {
                for (var k = r(n2._children), A = k.next(); !A.done; A = k.next())
                  if ((N = A.value)._nodeType === l.NodeType.Element && N !== e14)
                    throw new c.HierarchyRequestError("Document already has a document element node. Node is " + t3.nodeName + ".");
              } catch (e15) {
                f2 = { error: e15 };
              } finally {
                try {
                  A && !A.done && (p2 = k.return) && p2.call(k);
                } finally {
                  if (f2)
                    throw f2.error;
                }
              }
              for (O = e14._nextSibling; O; ) {
                if (O._nodeType === l.NodeType.DocumentType)
                  throw new c.HierarchyRequestError("Cannot insert an element node before a document type node. Node is " + t3.nodeName + ".");
                O = O._nextSibling;
              }
            } else if (t3._nodeType === l.NodeType.DocumentType) {
              try {
                for (var j = r(n2._children), M = j.next(); !M.done; M = j.next()) {
                  var N;
                  if ((N = M.value)._nodeType === l.NodeType.DocumentType && N !== e14)
                    throw new c.HierarchyRequestError("Document already has a document type node. Node is " + t3.nodeName + ".");
                }
              } catch (e15) {
                h2 = { error: e15 };
              } finally {
                try {
                  M && !M.done && (g2 = j.return) && g2.call(j);
                } finally {
                  if (h2)
                    throw h2.error;
                }
              }
              for (var P = e14._previousSibling; P; ) {
                if (P._nodeType === l.NodeType.Element)
                  throw new c.HierarchyRequestError("Cannot insert a document type node before an element node. Node is " + t3.nodeName + ".");
                P = P._previousSibling;
              }
            }
          }
          var F = e14._nextSibling;
          F === t3 && (F = t3._nextSibling);
          var I = e14._previousSibling;
          y.document_adopt(t3, n2._nodeDocument);
          var L = [];
          e14._parent !== null && (L.push(e14), w(e14, e14._parent, true));
          var R = [];
          return t3._nodeType === l.NodeType.DocumentFragment ? R = Array.from(t3._children) : R.push(t3), C(t3, n2, F, true), s.dom.features.mutationObservers && _.observer_queueTreeMutationRecord(n2, R, L, I, F), e14;
        }, t2.mutation_replaceAll = function(e14, t3) {
          var n2, a2;
          e14 !== null && y.document_adopt(e14, t3._nodeDocument);
          var o2 = Array.from(t3._children), c2 = [];
          e14 && e14._nodeType === l.NodeType.DocumentFragment ? c2 = Array.from(e14._children) : e14 !== null && c2.push(e14);
          try {
            for (var u2 = r(o2), d2 = u2.next(); !d2.done; d2 = u2.next())
              w(d2.value, t3, true);
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              d2 && !d2.done && (a2 = u2.return) && a2.call(u2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          e14 !== null && C(e14, t3, null, true), s.dom.features.mutationObservers && _.observer_queueTreeMutationRecord(t3, c2, o2, null, null);
        }, t2.mutation_preRemove = function(e14, t3) {
          if (e14._parent !== t3)
            throw new c.NotFoundError("The child node cannot be found under parent node. Child node is " + e14.nodeName + ", parent node is " + t3.nodeName + ".");
          return w(e14, t3), e14;
        }, t2.mutation_remove = w;
      },
      function(e13, t2, n) {
        function r(e14) {
          return e14 == null;
        }
        e13.exports.isNothing = r, e13.exports.isObject = function(e14) {
          return typeof e14 == "object" && !!e14;
        }, e13.exports.toArray = function(e14) {
          return Array.isArray(e14) ? e14 : r(e14) ? [] : [e14];
        }, e13.exports.repeat = function(e14, t3) {
          var n2, r2 = "";
          for (n2 = 0; n2 < t3; n2 += 1)
            r2 += e14;
          return r2;
        }, e13.exports.isNegativeZero = function(e14) {
          return e14 === 0 && 1 / e14 == -Infinity;
        }, e13.exports.extend = function(e14, t3) {
          var n2, r2, a, o;
          if (t3)
            for (n2 = 0, r2 = (o = Object.keys(t3)).length; n2 < r2; n2 += 1)
              e14[a = o[n2]] = t3[a];
          return e14;
        };
      },
      function(e13, t2, n) {
        var r = n(38), a = n(53), o = n(10);
        function s(e14, t3, n2) {
          var r2 = [];
          return e14.include.forEach(function(e15) {
            n2 = s(e15, t3, n2);
          }), e14[t3].forEach(function(e15) {
            n2.forEach(function(t4, n3) {
              t4.tag === e15.tag && t4.kind === e15.kind && r2.push(n3);
            }), n2.push(e15);
          }), n2.filter(function(e15, t4) {
            return r2.indexOf(t4) === -1;
          });
        }
        function c(e14) {
          this.include = e14.include || [], this.implicit = e14.implicit || [], this.explicit = e14.explicit || [], this.implicit.forEach(function(e15) {
            if (e15.loadKind && e15.loadKind !== "scalar")
              throw new a("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
          }), this.compiledImplicit = s(this, "implicit", []), this.compiledExplicit = s(this, "explicit", []), this.compiledTypeMap = function() {
            var e15, t3, n2 = {
              scalar: {},
              sequence: {},
              mapping: {},
              fallback: {}
            };
            function r2(e16) {
              n2[e16.kind][e16.tag] = n2.fallback[e16.tag] = e16;
            }
            for (e15 = 0, t3 = arguments.length; e15 < t3; e15 += 1)
              arguments[e15].forEach(r2);
            return n2;
          }(this.compiledImplicit, this.compiledExplicit);
        }
        c.DEFAULT = null, c.create = function() {
          var e14, t3;
          switch (arguments.length) {
            case 1:
              e14 = c.DEFAULT, t3 = arguments[0];
              break;
            case 2:
              e14 = arguments[0], t3 = arguments[1];
              break;
            default:
              throw new a("Wrong number of arguments for Schema.create function");
          }
          if (e14 = r.toArray(e14), t3 = r.toArray(t3), !e14.every(function(e15) {
            return e15 instanceof c;
          }))
            throw new a("Specified list of super schemas (or a single Schema object) contains a non-Schema object.");
          if (!t3.every(function(e15) {
            return e15 instanceof o;
          }))
            throw new a("Specified list of YAML types (or a single Type object) contains a non-Type object.");
          return new c({
            include: e14,
            explicit: t3
          });
        }, e13.exports = c;
      },
      function(e13, t2) {
        e13.exports = function(e14, t3) {
          return {
            enumerable: !(1 & e14),
            configurable: !(2 & e14),
            writable: !(4 & e14),
            value: t3
          };
        };
      },
      function(e13, t2, n) {
        var r = n(8), a = n(42), o = "".split;
        e13.exports = r(function() {
          return !Object("z").propertyIsEnumerable(0);
        }) ? function(e14) {
          return a(e14) == "String" ? o.call(e14, "") : Object(e14);
        } : Object;
      },
      function(e13, t2) {
        var n = {}.toString;
        e13.exports = function(e14) {
          return n.call(e14).slice(8, -1);
        };
      },
      function(e13, t2, n) {
        var r, a, o, s = n(186), c = n(11), l = n(13), u = n(21), d = n(14), f = n(57), p = n(45), m = c.WeakMap;
        if (s) {
          var h = new m(), g = h.get, _ = h.has, v = h.set;
          r = function(e14, t3) {
            return v.call(h, e14, t3), t3;
          }, a = function(e14) {
            return g.call(h, e14) || {};
          }, o = function(e14) {
            return _.call(h, e14);
          };
        } else {
          var y = f("state");
          p[y] = true, r = function(e14, t3) {
            return u(e14, y, t3), t3;
          }, a = function(e14) {
            return d(e14, y) ? e14[y] : {};
          }, o = function(e14) {
            return d(e14, y);
          };
        }
        e13.exports = {
          set: r,
          get: a,
          has: o,
          enforce: function(e14) {
            return o(e14) ? a(e14) : r(e14, {});
          },
          getterFor: function(e14) {
            return function(t3) {
              var n2;
              if (!l(t3) || (n2 = a(t3)).type !== e14)
                throw TypeError("Incompatible receiver, " + e14 + " required");
              return n2;
            };
          }
        };
      },
      function(e13, t2) {
        e13.exports = false;
      },
      function(e13, t2) {
        e13.exports = {};
      },
      function(e13, t2, n) {
        var r = n(120), a = n(11), o = function(e14) {
          return typeof e14 == "function" ? e14 : void 0;
        };
        e13.exports = function(e14, t3) {
          return arguments.length < 2 ? o(r[e14]) || o(a[e14]) : r[e14] && r[e14][t3] || a[e14] && a[e14][t3];
        };
      },
      function(e13, t2) {
        var n = Math.ceil, r = Math.floor;
        e13.exports = function(e14) {
          return isNaN(e14 = +e14) ? 0 : (e14 > 0 ? r : n)(e14);
        };
      },
      function(e13, t2, n) {
        var r = n(8);
        e13.exports = function(e14, t3) {
          var n2 = [][e14];
          return !!n2 && r(function() {
            n2.call(null, t3 || function() {
              throw 1;
            }, 1);
          });
        };
      },
      function(e13, t2) {
        e13.exports = {};
      },
      function(e13, t2, n) {
        n(31), n(32), n(33), n(220), n(64), n(19), n(65), n(20), n(68), n(66), n(92), n(144), n(22), n(94), n(23);
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, a = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, o = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(a(arguments[t3]));
          return e14;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(2), c = n(69), l = n(95), u = n(7), d = n(0);
        t2.BaseWriter = function() {
          function e14(e15) {
            this.level = 0, this._builderOptions = e15;
          }
          return e14.prototype.declaration = function(e15, t3, n2) {
          }, e14.prototype.docType = function(e15, t3, n2) {
          }, e14.prototype.comment = function(e15) {
          }, e14.prototype.text = function(e15) {
          }, e14.prototype.instruction = function(e15, t3) {
          }, e14.prototype.cdata = function(e15) {
          }, e14.prototype.openTagBegin = function(e15) {
          }, e14.prototype.openTagEnd = function(e15, t3, n2) {
          }, e14.prototype.closeTag = function(e15) {
          }, e14.prototype.attributes = function(e15) {
            var t3, n2;
            try {
              for (var a2 = r(e15), o2 = a2.next(); !o2.done; o2 = a2.next()) {
                var s2 = o2.value;
                this.attribute(s2[1] === null ? s2[2] : s2[1] + ":" + s2[2], s2[3]);
              }
            } catch (e16) {
              t3 = { error: e16 };
            } finally {
              try {
                o2 && !o2.done && (n2 = a2.return) && n2.call(a2);
              } finally {
                if (t3)
                  throw t3.error;
              }
            }
          }, e14.prototype.attribute = function(e15, t3) {
          }, e14.prototype.beginElement = function(e15) {
          }, e14.prototype.endElement = function(e15) {
          }, e14.prototype.serializeNode = function(e15, t3) {
            var n2 = e15._nodeDocument !== void 0 && e15._nodeDocument._hasNamespaces;
            if (this.level = 0, this.currentNode = e15, n2) {
              var r2 = new l.NamespacePrefixMap();
              r2.set("xml", u.namespace.XML), this._serializeNodeNS(e15, null, r2, { value: 1 }, t3);
            } else
              this._serializeNode(e15, t3);
          }, e14.prototype._serializeNodeNS = function(e15, t3, n2, r2, a2) {
            switch (this.currentNode = e15, e15.nodeType) {
              case s.NodeType.Element:
                this._serializeElementNS(e15, t3, n2, r2, a2);
                break;
              case s.NodeType.Document:
                this._serializeDocumentNS(e15, t3, n2, r2, a2);
                break;
              case s.NodeType.Comment:
                this._serializeComment(e15, a2);
                break;
              case s.NodeType.Text:
                this._serializeText(e15, a2);
                break;
              case s.NodeType.DocumentFragment:
                this._serializeDocumentFragmentNS(e15, t3, n2, r2, a2);
                break;
              case s.NodeType.DocumentType:
                this._serializeDocumentType(e15, a2);
                break;
              case s.NodeType.ProcessingInstruction:
                this._serializeProcessingInstruction(e15, a2);
                break;
              case s.NodeType.CData:
                this._serializeCData(e15, a2);
                break;
              default:
                throw Error("Unknown node type: " + e15.nodeType);
            }
          }, e14.prototype._serializeNode = function(e15, t3) {
            switch (this.currentNode = e15, e15.nodeType) {
              case s.NodeType.Element:
                this._serializeElement(e15, t3);
                break;
              case s.NodeType.Document:
                this._serializeDocument(e15, t3);
                break;
              case s.NodeType.Comment:
                this._serializeComment(e15, t3);
                break;
              case s.NodeType.Text:
                this._serializeText(e15, t3);
                break;
              case s.NodeType.DocumentFragment:
                this._serializeDocumentFragment(e15, t3);
                break;
              case s.NodeType.DocumentType:
                this._serializeDocumentType(e15, t3);
                break;
              case s.NodeType.ProcessingInstruction:
                this._serializeProcessingInstruction(e15, t3);
                break;
              case s.NodeType.CData:
                this._serializeCData(e15, t3);
                break;
              default:
                throw Error("Unknown node type: " + e15.nodeType);
            }
          }, e14.prototype._serializeElementNS = function(t3, n2, a2, s2, c2) {
            var l2, f, p = [];
            if (c2 && (t3.localName.indexOf(":") !== -1 || !d.xml_isName(t3.localName)))
              throw Error("Node local name contains invalid characters (well-formed required).");
            var m = "", h = false, g = false, _ = a2.copy(), v = {}, y = this._recordNamespaceInformation(t3, _, v), b = n2, S = t3.namespaceURI;
            if (b === S)
              y !== null && (g = true), m = S === u.namespace.XML ? "xml:" + t3.localName : t3.localName, this.beginElement(m), this.openTagBegin(m);
            else {
              var C = t3.prefix, w = null;
              if (C === null && S === y || (w = _.get(C, S)), C === "xmlns") {
                if (c2)
                  throw Error("An element cannot have the 'xmlns' prefix (well-formed required).");
                w = C;
              }
              w === null ? C === null ? y === null || y !== null && y !== S ? (g = true, m += t3.localName, b = S, this.beginElement(m), this.openTagBegin(m), p.push([
                null,
                null,
                "xmlns",
                this._serializeAttributeValue(S, c2)
              ])) : (m += t3.localName, b = S, this.beginElement(m), this.openTagBegin(m)) : (C in v && (C = this._generatePrefix(S, _, s2)), _.set(C, S), m += C + ":" + t3.localName, this.beginElement(m), this.openTagBegin(m), p.push([
                null,
                "xmlns",
                C,
                this._serializeAttributeValue(S, c2)
              ]), y !== null && (b = y || null)) : (m = w + ":" + t3.localName, y !== null && y !== u.namespace.XML && (b = y || null), this.beginElement(m), this.openTagBegin(m));
            }
            p.push.apply(p, o(this._serializeAttributesNS(t3, _, s2, v, g, c2))), this.attributes(p);
            var T = S === u.namespace.HTML;
            if (T && t3.childNodes.length === 0 && e14._VoidElementNames.has(t3.localName) ? (this.openTagEnd(m, true, true), this.endElement(m), h = true) : T || t3.childNodes.length !== 0 ? this.openTagEnd(m, false, false) : (this.openTagEnd(m, true, false), this.endElement(m), h = true), !h) {
              if (!(T && t3.localName === "template"))
                try {
                  for (var E = r(t3.childNodes), D = E.next(); !D.done; D = E.next()) {
                    var O = D.value;
                    this.level++, this._serializeNodeNS(O, b, _, s2, c2), this.level--;
                  }
                } catch (e15) {
                  l2 = { error: e15 };
                } finally {
                  try {
                    D && !D.done && (f = E.return) && f.call(E);
                  } finally {
                    if (l2)
                      throw l2.error;
                  }
                }
              this.closeTag(m), this.endElement(m);
            }
          }, e14.prototype._serializeElement = function(e15, t3) {
            var n2, a2;
            if (t3 && (e15.localName.indexOf(":") !== -1 || !d.xml_isName(e15.localName)))
              throw Error("Node local name contains invalid characters (well-formed required).");
            var o2 = false, s2 = e15.localName;
            this.beginElement(s2), this.openTagBegin(s2);
            var c2 = this._serializeAttributes(e15, t3);
            if (this.attributes(c2), e15.hasChildNodes() ? this.openTagEnd(s2, false, false) : (this.openTagEnd(s2, true, false), this.endElement(s2), o2 = true), !o2) {
              try {
                for (var l2 = r(e15._children), u2 = l2.next(); !u2.done; u2 = l2.next()) {
                  var f = u2.value;
                  this.level++, this._serializeNode(f, t3), this.level--;
                }
              } catch (e16) {
                n2 = { error: e16 };
              } finally {
                try {
                  u2 && !u2.done && (a2 = l2.return) && a2.call(l2);
                } finally {
                  if (n2)
                    throw n2.error;
                }
              }
              this.closeTag(s2), this.endElement(s2);
            }
          }, e14.prototype._serializeDocumentNS = function(e15, t3, n2, a2, o2) {
            var s2, c2;
            if (o2 && e15.documentElement === null)
              throw Error("Missing document element (well-formed required).");
            try {
              for (var l2 = r(e15.childNodes), u2 = l2.next(); !u2.done; u2 = l2.next()) {
                var d2 = u2.value;
                this._serializeNodeNS(d2, t3, n2, a2, o2);
              }
            } catch (e16) {
              s2 = { error: e16 };
            } finally {
              try {
                u2 && !u2.done && (c2 = l2.return) && c2.call(l2);
              } finally {
                if (s2)
                  throw s2.error;
              }
            }
          }, e14.prototype._serializeDocument = function(e15, t3) {
            var n2, a2;
            if (t3 && e15.documentElement === null)
              throw Error("Missing document element (well-formed required).");
            try {
              for (var o2 = r(e15._children), s2 = o2.next(); !s2.done; s2 = o2.next()) {
                var c2 = s2.value;
                this._serializeNode(c2, t3);
              }
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                s2 && !s2.done && (a2 = o2.return) && a2.call(o2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          }, e14.prototype._serializeComment = function(e15, t3) {
            if (t3 && (!d.xml_isLegalChar(e15.data) || e15.data.indexOf("--") !== -1 || e15.data.endsWith("-")))
              throw Error("Comment data contains invalid characters (well-formed required).");
            this.comment(e15.data);
          }, e14.prototype._serializeText = function(e15, t3) {
            if (t3 && !d.xml_isLegalChar(e15.data))
              throw Error("Text data contains invalid characters (well-formed required).");
            var n2 = e15.data.replace(/(?!&([^&;]*);)&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            this.text(n2);
          }, e14.prototype._serializeDocumentFragmentNS = function(e15, t3, n2, a2, o2) {
            var s2, c2;
            try {
              for (var l2 = r(e15.childNodes), u2 = l2.next(); !u2.done; u2 = l2.next()) {
                var d2 = u2.value;
                this._serializeNodeNS(d2, t3, n2, a2, o2);
              }
            } catch (e16) {
              s2 = { error: e16 };
            } finally {
              try {
                u2 && !u2.done && (c2 = l2.return) && c2.call(l2);
              } finally {
                if (s2)
                  throw s2.error;
              }
            }
          }, e14.prototype._serializeDocumentFragment = function(e15, t3) {
            var n2, a2;
            try {
              for (var o2 = r(e15._children), s2 = o2.next(); !s2.done; s2 = o2.next()) {
                var c2 = s2.value;
                this._serializeNode(c2, t3);
              }
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                s2 && !s2.done && (a2 = o2.return) && a2.call(o2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          }, e14.prototype._serializeDocumentType = function(e15, t3) {
            if (t3 && !d.xml_isPubidChar(e15.publicId))
              throw Error("DocType public identifier does not match PubidChar construct (well-formed required).");
            if (t3 && (!d.xml_isLegalChar(e15.systemId) || e15.systemId.indexOf('"') !== -1 && e15.systemId.indexOf("'") !== -1))
              throw Error("DocType system identifier contains invalid characters (well-formed required).");
            this.docType(e15.name, e15.publicId, e15.systemId);
          }, e14.prototype._serializeProcessingInstruction = function(e15, t3) {
            if (t3 && (e15.target.indexOf(":") !== -1 || /^xml$/i.test(e15.target)))
              throw Error("Processing instruction target contains invalid characters (well-formed required).");
            if (t3 && (!d.xml_isLegalChar(e15.data) || e15.data.indexOf("?>") !== -1))
              throw Error("Processing instruction data contains invalid characters (well-formed required).");
            this.instruction(e15.target, e15.data);
          }, e14.prototype._serializeCData = function(e15, t3) {
            if (t3 && e15.data.indexOf("]]>") !== -1)
              throw Error("CDATA contains invalid characters (well-formed required).");
            this.cdata(e15.data);
          }, e14.prototype._serializeAttributesNS = function(e15, t3, n2, a2, o2, s2) {
            var l2, f, p = [], m = s2 ? new c.LocalNameSet() : void 0;
            try {
              for (var h = r(e15.attributes), g = h.next(); !g.done; g = h.next()) {
                var _ = g.value;
                if (s2 || o2 || _.namespaceURI !== null) {
                  if (s2 && m && m.has(_.namespaceURI, _.localName))
                    throw Error("Element contains duplicate attributes (well-formed required).");
                  s2 && m && m.set(_.namespaceURI, _.localName);
                  var v = _.namespaceURI, y = null;
                  if (v !== null)
                    if (y = t3.get(_.prefix, v), v === u.namespace.XMLNS) {
                      if (_.value === u.namespace.XML || _.prefix === null && o2 || _.prefix !== null && (!(_.localName in a2) || a2[_.localName] !== _.value) && t3.has(_.localName, _.value))
                        continue;
                      if (s2 && _.value === u.namespace.XMLNS)
                        throw Error("XMLNS namespace is reserved (well-formed required).");
                      if (s2 && _.value === "")
                        throw Error("Namespace prefix declarations cannot be used to undeclare a namespace (well-formed required).");
                      _.prefix === "xmlns" && (y = "xmlns");
                    } else
                      y === null && (y = _.prefix === null || t3.hasPrefix(_.prefix) && !t3.has(_.prefix, v) ? this._generatePrefix(v, t3, n2) : _.prefix, p.push([
                        null,
                        "xmlns",
                        y,
                        this._serializeAttributeValue(v, s2)
                      ]));
                  if (s2 && (_.localName.indexOf(":") !== -1 || !d.xml_isName(_.localName) || _.localName === "xmlns" && v === null))
                    throw Error("Attribute local name contains invalid characters (well-formed required).");
                  p.push([
                    v,
                    y,
                    _.localName,
                    this._serializeAttributeValue(_.value, s2)
                  ]);
                } else
                  p.push([
                    null,
                    null,
                    _.localName,
                    this._serializeAttributeValue(_.value, s2)
                  ]);
              }
            } catch (e16) {
              l2 = { error: e16 };
            } finally {
              try {
                g && !g.done && (f = h.return) && f.call(h);
              } finally {
                if (l2)
                  throw l2.error;
              }
            }
            return p;
          }, e14.prototype._serializeAttributes = function(e15, t3) {
            var n2, a2, o2 = [], s2 = t3 ? {} : void 0;
            try {
              for (var c2 = r(e15.attributes), l2 = c2.next(); !l2.done; l2 = c2.next()) {
                var u2 = l2.value;
                if (t3) {
                  if (t3 && s2 && u2.localName in s2)
                    throw Error("Element contains duplicate attributes (well-formed required).");
                  if (t3 && s2 && (s2[u2.localName] = true), t3 && (u2.localName.indexOf(":") !== -1 || !d.xml_isName(u2.localName)))
                    throw Error("Attribute local name contains invalid characters (well-formed required).");
                  o2.push([
                    null,
                    null,
                    u2.localName,
                    this._serializeAttributeValue(u2.value, t3)
                  ]);
                } else
                  o2.push([
                    null,
                    null,
                    u2.localName,
                    this._serializeAttributeValue(u2.value, t3)
                  ]);
              }
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                l2 && !l2.done && (a2 = c2.return) && a2.call(c2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
            return o2;
          }, e14.prototype._recordNamespaceInformation = function(e15, t3, n2) {
            var a2, o2, s2 = null;
            try {
              for (var c2 = r(e15.attributes), l2 = c2.next(); !l2.done; l2 = c2.next()) {
                var d2 = l2.value, f = d2.namespaceURI, p = d2.prefix;
                if (f === u.namespace.XMLNS) {
                  if (p === null) {
                    s2 = d2.value;
                    continue;
                  }
                  var m = d2.localName, h = d2.value;
                  if (h === u.namespace.XML || (h === "" && (h = null), t3.has(m, h)))
                    continue;
                  t3.set(m, h), n2[m] = h || "";
                }
              }
            } catch (e16) {
              a2 = { error: e16 };
            } finally {
              try {
                l2 && !l2.done && (o2 = c2.return) && o2.call(c2);
              } finally {
                if (a2)
                  throw a2.error;
              }
            }
            return s2;
          }, e14.prototype._generatePrefix = function(e15, t3, n2) {
            var r2 = "ns" + n2.value.toString();
            return n2.value++, t3.set(r2, e15), r2;
          }, e14.prototype._serializeAttributeValue = function(e15, t3) {
            if (t3 && e15 !== null && !d.xml_isLegalChar(e15))
              throw Error("Invalid characters in attribute value.");
            return e15 === null ? "" : e15.replace(/(?!&([^&;]*);)&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
          }, e14._VoidElementNames = /* @__PURE__ */ new Set([
            "area",
            "base",
            "basefont",
            "bgsound",
            "br",
            "col",
            "embed",
            "frame",
            "hr",
            "img",
            "input",
            "keygen",
            "link",
            "menuitem",
            "meta",
            "param",
            "source",
            "track",
            "wbr"
          ]), e14;
        }();
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, a = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(6), s = n(3), c = n(7), l = n(29), u = n(17), d = n(97);
        function f() {
          var e14 = o.dom.window;
          e14._mutationObserverMicrotaskQueued || (e14._mutationObserverMicrotaskQueued = true, Promise.resolve().then(function() {
            p();
          }));
        }
        function p() {
          var e14, t3, n2, a2, l2 = o.dom.window;
          l2._mutationObserverMicrotaskQueued = false;
          var u2 = c.set.clone(l2._mutationObservers), f2 = c.set.clone(l2._signalSlots);
          c.set.empty(l2._signalSlots);
          var p2 = function(e15) {
            var t4 = c.list.clone(e15._recordQueue);
            c.list.empty(e15._recordQueue);
            for (var n3 = 0; n3 < e15._nodeList.length; n3++) {
              var r2 = e15._nodeList[n3];
              c.list.remove(r2._registeredObserverList, function(t5) {
                return s.Guard.isTransientRegisteredObserver(t5) && t5.observer === e15;
              });
            }
            if (!c.list.isEmpty(t4))
              try {
                e15._callback.call(e15, t4, e15);
              } catch {
              }
          };
          try {
            for (var m2 = r(u2), h = m2.next(); !h.done; h = m2.next())
              p2(h.value);
          } catch (t4) {
            e14 = { error: t4 };
          } finally {
            try {
              h && !h.done && (t3 = m2.return) && t3.call(m2);
            } finally {
              if (e14)
                throw e14.error;
            }
          }
          if (o.dom.features.slots)
            try {
              for (var g = r(f2), _ = g.next(); !_.done; _ = g.next()) {
                var v = _.value;
                d.event_fireAnEvent("slotchange", v, void 0, { bubbles: true });
              }
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                _ && !_.done && (a2 = g.return) && a2.call(g);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
        }
        function m(e14, t3, n2, o2, s2, c2, d2, p2, m2) {
          for (var h, g, _ = /* @__PURE__ */ new Map(), v = u.tree_getFirstAncestorNode(t3, true); v !== null; ) {
            for (var y = 0; y < v._registeredObserverList.length; y++) {
              var b = v._registeredObserverList[y], S = b.options;
              if ((v === t3 || S.subtree) && (e14 !== "attributes" || S.attributes) && (e14 !== "attributes" || !S.attributeFilter || S.attributeFilter.indexOf(n2 || "") && o2 === null) && (e14 !== "characterData" || S.characterData) && (e14 !== "childList" || S.childList)) {
                var C = b.observer;
                _.has(C) || _.set(C, null), (e14 === "attributes" && S.attributeOldValue || e14 === "characterData" && S.characterDataOldValue) && _.set(C, s2);
              }
            }
            v = u.tree_getNextAncestorNode(t3, v, true);
          }
          try {
            for (var w = r(_), T = w.next(); !T.done; T = w.next()) {
              var E = a(T.value, 2), D = E[0], O = E[1], k = l.create_mutationRecord(e14, t3, l.create_nodeListStatic(t3, c2), l.create_nodeListStatic(t3, d2), p2, m2, n2, o2, O);
              D._recordQueue.push(k);
            }
          } catch (e15) {
            h = { error: e15 };
          } finally {
            try {
              T && !T.done && (g = w.return) && g.call(w);
            } finally {
              if (h)
                throw h.error;
            }
          }
          f();
        }
        t2.observer_queueAMutationObserverMicrotask = f, t2.observer_notifyMutationObservers = p, t2.observer_queueMutationRecord = m, t2.observer_queueTreeMutationRecord = function(e14, t3, n2, r2, a2) {
          m("childList", e14, null, null, null, t3, n2, r2, a2);
        }, t2.observer_queueAttributeMutationRecord = function(e14, t3, n2, r2) {
          m("attributes", e14, t3, n2, r2, [], [], null, null);
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(6), a = n(7), o = n(3), s = n(9), c = n(29), l = n(73), u = n(51), d = n(30), f = n(37), p = n(106);
        function m(e14, t3, n2) {
          r.dom.features.mutationObservers && u.observer_queueAttributeMutationRecord(t3, e14._localName, e14._namespace, e14._value), r.dom.features.customElements && o.Guard.isCustomElementNode(t3) && l.customElement_enqueueACustomElementCallbackReaction(t3, "attributeChangedCallback", [
            e14._localName,
            e14._value,
            n2,
            e14._namespace
          ]), r.dom.features.steps && d.dom_runAttributeChangeSteps(t3, e14._localName, e14._value, n2, e14._namespace), e14._value = n2;
        }
        function h(e14, t3) {
          r.dom.features.mutationObservers && u.observer_queueAttributeMutationRecord(t3, e14._localName, e14._namespace, null), r.dom.features.customElements && o.Guard.isCustomElementNode(t3) && l.customElement_enqueueACustomElementCallbackReaction(t3, "attributeChangedCallback", [
            e14._localName,
            null,
            e14._value,
            e14._namespace
          ]), r.dom.features.steps && d.dom_runAttributeChangeSteps(t3, e14._localName, null, e14._value, e14._namespace), t3._attributeList._asArray().push(e14), e14._element = t3, t3._nodeDocument._hasNamespaces || e14._namespace === null && e14._namespacePrefix === null && e14._localName !== "xmlns" || (t3._nodeDocument._hasNamespaces = true);
        }
        function g(e14, t3) {
          r.dom.features.mutationObservers && u.observer_queueAttributeMutationRecord(t3, e14._localName, e14._namespace, e14._value), r.dom.features.customElements && o.Guard.isCustomElementNode(t3) && l.customElement_enqueueACustomElementCallbackReaction(t3, "attributeChangedCallback", [
            e14._localName,
            e14._value,
            null,
            e14._namespace
          ]), r.dom.features.steps && d.dom_runAttributeChangeSteps(t3, e14._localName, e14._value, null, e14._namespace);
          var n2 = t3._attributeList._asArray().indexOf(e14);
          t3._attributeList._asArray().splice(n2, 1), e14._element = null;
        }
        function _(e14, t3, n2) {
          r.dom.features.mutationObservers && u.observer_queueAttributeMutationRecord(n2, e14._localName, e14._namespace, e14._value), r.dom.features.customElements && o.Guard.isCustomElementNode(n2) && l.customElement_enqueueACustomElementCallbackReaction(n2, "attributeChangedCallback", [
            e14._localName,
            e14._value,
            t3._value,
            e14._namespace
          ]), r.dom.features.steps && d.dom_runAttributeChangeSteps(n2, e14._localName, e14._value, t3._value, e14._namespace);
          var a2 = n2._attributeList._asArray().indexOf(e14);
          a2 !== -1 && (n2._attributeList._asArray()[a2] = t3), e14._element = null, t3._element = n2, n2._nodeDocument._hasNamespaces || t3._namespace === null && t3._namespacePrefix === null && t3._localName !== "xmlns" || (n2._nodeDocument._hasNamespaces = true);
        }
        function v(e14, t3) {
          return t3._namespace === a.namespace.HTML && t3._nodeDocument._type === "html" && (e14 = e14.toLowerCase()), t3._attributeList._asArray().find(function(t4) {
            return t4._qualifiedName === e14;
          }) || null;
        }
        function y(e14, t3, n2) {
          var r2 = e14 || null;
          return n2._attributeList._asArray().find(function(e15) {
            return e15._namespace === r2 && e15._localName === t3;
          }) || null;
        }
        t2.element_has = function(e14, t3) {
          return t3._attributeList._asArray().indexOf(e14) !== -1;
        }, t2.element_change = m, t2.element_append = h, t2.element_remove = g, t2.element_replace = _, t2.element_getAnAttributeByName = v, t2.element_getAnAttributeByNamespaceAndLocalName = y, t2.element_getAnAttributeValue = function(e14, t3, n2) {
          n2 === void 0 && (n2 = "");
          var r2 = y(n2, t3, e14);
          return r2 === null ? "" : r2._value;
        }, t2.element_setAnAttribute = function(e14, t3) {
          if (e14._element !== null && e14._element !== t3)
            throw new s.InUseAttributeError("This attribute already exists in the document: " + e14._qualifiedName + " as a child of " + e14._element._qualifiedName + ".");
          var n2 = y(e14._namespace || "", e14._localName, t3);
          return n2 === e14 ? e14 : (n2 === null ? h(e14, t3) : _(n2, e14, t3), n2);
        }, t2.element_setAnAttributeValue = function(e14, t3, n2, r2, a2) {
          r2 === void 0 && (r2 = null), a2 === void 0 && (a2 = null);
          var o2 = y(a2 || "", t3, e14);
          if (o2 === null) {
            var s2 = c.create_attr(e14._nodeDocument, t3);
            s2._namespace = a2, s2._namespacePrefix = r2, s2._value = n2, h(s2, e14);
            return;
          }
          m(o2, e14, n2);
        }, t2.element_removeAnAttributeByName = function(e14, t3) {
          var n2 = v(e14, t3);
          return n2 !== null && g(n2, t3), n2;
        }, t2.element_removeAnAttributeByNamespaceAndLocalName = function(e14, t3, n2) {
          var r2 = y(e14, t3, n2);
          return r2 !== null && g(r2, n2), r2;
        }, t2.element_createAnElement = function(e14, t3, n2, o2, u2, d2) {
          o2 === void 0 && (o2 = null), u2 === void 0 && (u2 = null), d2 === void 0 && (d2 = false);
          var f2 = null;
          if (!r.dom.features.customElements)
            return (f2 = c.create_element(e14, t3, n2, o2))._customElementState = "uncustomized", f2._customElementDefinition = null, f2._is = u2, f2;
          var m2 = l.customElement_lookUpACustomElementDefinition(e14, n2, t3, u2);
          if (m2 !== null && m2.name !== m2.localName)
            (f2 = new (p.document_elementInterface(t3, a.namespace.HTML))())._localName = t3, f2._namespace = a.namespace.HTML, f2._namespacePrefix = o2, f2._customElementState = "undefined", f2._customElementDefinition = null, f2._is = u2, f2._nodeDocument = e14, d2 ? l.customElement_upgrade(m2, f2) : l.customElement_enqueueACustomElementUpgradeReaction(f2, m2);
          else if (m2 !== null)
            if (d2)
              try {
                var h2 = new m2.constructor();
                if (console.assert(h2._customElementState !== void 0), console.assert(h2._customElementDefinition !== void 0), console.assert(h2._namespace === a.namespace.HTML), h2._attributeList.length !== 0)
                  throw new s.NotSupportedError("Custom element already has attributes.");
                if (h2._children.size !== 0)
                  throw new s.NotSupportedError("Custom element already has child nodes.");
                if (h2._parent !== null)
                  throw new s.NotSupportedError("Custom element already has a parent node.");
                if (h2._nodeDocument !== e14)
                  throw new s.NotSupportedError("Custom element is already in a document.");
                if (h2._localName !== t3)
                  throw new s.NotSupportedError("Custom element has a different local name.");
                h2._namespacePrefix = o2, h2._is = null;
              } catch {
                (f2 = c.create_htmlUnknownElement(e14, t3, a.namespace.HTML, o2))._customElementState = "failed", f2._customElementDefinition = null, f2._is = null;
              }
            else
              (f2 = c.create_htmlElement(e14, t3, a.namespace.HTML, o2))._customElementState = "undefined", f2._customElementDefinition = null, f2._is = null, l.customElement_enqueueACustomElementUpgradeReaction(f2, m2);
          else
            (f2 = new (p.document_elementInterface(t3, n2))())._localName = t3, f2._namespace = n2, f2._namespacePrefix = o2, f2._customElementState = "uncustomized", f2._customElementDefinition = null, f2._is = u2, f2._nodeDocument = e14, n2 !== a.namespace.HTML || u2 === null && !l.customElement_isValidCustomElementName(t3) || (f2._customElementState = "undefined");
          if (f2 === null)
            throw Error("Unable to create element.");
          return f2;
        }, t2.element_insertAdjacent = function(e14, t3, n2) {
          switch (t3.toLowerCase()) {
            case "beforebegin":
              return e14._parent === null ? null : f.mutation_preInsert(n2, e14._parent, e14);
            case "afterbegin":
              return f.mutation_preInsert(n2, e14, e14._firstChild);
            case "beforeend":
              return f.mutation_preInsert(n2, e14, null);
            case "afterend":
              return e14._parent === null ? null : f.mutation_preInsert(n2, e14._parent, e14._nextSibling);
            default:
              throw new s.SyntaxError(`Invalid 'where' argument. "beforebegin", "afterbegin", "beforeend" or "afterend" expected`);
          }
        };
      },
      function(e13, t2, n) {
        function r(e14, t3) {
          Error.call(this), this.name = "YAMLException", this.reason = e14, this.mark = t3, this.message = (this.reason || "(unknown reason)") + (this.mark ? " " + this.mark.toString() : ""), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = (/* @__PURE__ */ Error()).stack || "";
        }
        r.prototype = Object.create(Error.prototype), r.prototype.constructor = r, r.prototype.toString = function(e14) {
          var t3 = this.name + ": ";
          return t3 += this.reason || "(unknown reason)", !e14 && this.mark && (t3 += " " + this.mark.toString()), t3;
        }, e13.exports = r;
      },
      function(e13, t2, n) {
        e13.exports = new (n(39))({
          include: [n(181)],
          implicit: [n(293), n(294)],
          explicit: [
            n(295),
            n(296),
            n(297),
            n(298)
          ]
        });
      },
      function(e13, t2, n) {
        var r = n(16), a = n(79), o = n(40), s = n(24), c = n(56), l = n(14), u = n(115), d = Object.getOwnPropertyDescriptor;
        t2.f = r ? d : function(e14, t3) {
          if (e14 = s(e14), t3 = c(t3, true), u)
            try {
              return d(e14, t3);
            } catch {
            }
          if (l(e14, t3))
            return o(!a.f.call(e14, t3), e14[t3]);
        };
      },
      function(e13, t2, n) {
        var r = n(13);
        e13.exports = function(e14, t3) {
          if (!r(e14))
            return e14;
          var n2, a;
          if (t3 && typeof (n2 = e14.toString) == "function" && !r(a = n2.call(e14)) || typeof (n2 = e14.valueOf) == "function" && !r(a = n2.call(e14)) || !t3 && typeof (n2 = e14.toString) == "function" && !r(a = n2.call(e14)))
            return a;
          throw TypeError("Can't convert object to primitive value");
        };
      },
      function(e13, t2, n) {
        var r = n(81), a = n(58), o = r("keys");
        e13.exports = function(e14) {
          return o[e14] || (o[e14] = a(e14));
        };
      },
      function(e13, t2) {
        var n = 0, r = Math.random();
        e13.exports = function(e14) {
          return "Symbol(" + String(e14 === void 0 ? "" : e14) + ")_" + (++n + r).toString(36);
        };
      },
      function(e13, t2, n) {
        var r = n(42);
        e13.exports = Array.isArray || function(e14) {
          return r(e14) == "Array";
        };
      },
      function(e13, t2, n) {
        var r, a = n(18), o = n(188), s = n(84), c = n(45), l = n(189), u = n(116), d = n(57)("IE_PROTO"), f = function() {
        }, p = function(e14) {
          return "<script>" + e14 + "<\/script>";
        }, m = function() {
          try {
            r = document.domain && new ActiveXObject("htmlfile");
          } catch {
          }
          var e14, t3;
          m = r ? function(e15) {
            e15.write(p("")), e15.close();
            var t4 = e15.parentWindow.Object;
            return e15 = null, t4;
          }(r) : ((t3 = u("iframe")).style.display = "none", l.appendChild(t3), t3.src = "javascript:", (e14 = t3.contentWindow.document).open(), e14.write(p("document.F=Object")), e14.close(), e14.F);
          for (var n2 = s.length; n2--; )
            delete m.prototype[s[n2]];
          return m();
        };
        c[d] = true, e13.exports = Object.create || function(e14, t3) {
          var n2;
          return e14 === null ? n2 = m() : (f.prototype = a(e14), n2 = new f(), f.prototype = null, n2[d] = e14), t3 === void 0 ? n2 : o(n2, t3);
        };
      },
      function(e13, t2, n) {
        var r = n(121), a = n(84);
        e13.exports = Object.keys || function(e14) {
          return r(e14, a);
        };
      },
      function(e13, t2, n) {
        var r = n(15).f, a = n(14), o = n(5)("toStringTag");
        e13.exports = function(e14, t3, n2) {
          e14 && !a(e14 = n2 ? e14 : e14.prototype, o) && r(e14, o, {
            configurable: true,
            value: t3
          });
        };
      },
      function(e13, t2, n) {
        var r = n(8), a = n(5), o = n(129), s = a("species");
        e13.exports = function(e14) {
          return o >= 51 || !r(function() {
            var t3 = [];
            return (t3.constructor = {})[s] = function() {
              return { foo: 1 };
            }, t3[e14](Boolean).foo !== 1;
          });
        };
      },
      function(e13, t2, n) {
        var r = n(4), a = n(122).indexOf, o = n(48), s = n(28), c = [].indexOf, l = !!c && 1 / [1].indexOf(1, -0) < 0, u = o("indexOf"), d = s("indexOf", {
          ACCESSORS: true,
          1: 0
        });
        r({
          target: "Array",
          proto: true,
          forced: l || !u || !d
        }, { indexOf: function(e14) {
          return l ? c.apply(this, arguments) || 0 : a(this, e14, arguments.length > 1 ? arguments[1] : void 0);
        } });
      },
      function(e13, t2, n) {
        var r = n(16), a = n(15).f, o = Function.prototype, s = o.toString, c = /^\s*function ([^ (]*)/;
        r && !("name" in o) && a(o, "name", {
          configurable: true,
          get: function() {
            try {
              return s.call(this).match(c)[1];
            } catch {
              return "";
            }
          }
        });
      },
      function(e13, t2, n) {
        var r = n(25), a = n(18), o = n(8), s = n(136), c = RegExp.prototype, l = c.toString, u = o(function() {
          return l.call({
            source: "a",
            flags: "b"
          }) != "/a/b";
        }), d = l.name != "toString";
        (u || d) && r(RegExp.prototype, "toString", function() {
          var e14 = a(this), t3 = String(e14.source), n2 = e14.flags;
          return "/" + t3 + "/" + String(n2 === void 0 && e14 instanceof RegExp && !("flags" in c) ? s.call(e14) : n2);
        }, { unsafe: true });
      },
      function(e13, t2, n) {
        n(31), n(32), n(33), n(19), n(138), n(20), n(66), n(22), n(23);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(1), c = n(2);
        t2.ObjectWriter = function(e14) {
          function t3(t4, n2) {
            var r2 = e14.call(this, t4) || this;
            return r2._writerOptions = s.applyDefaults(n2, {
              format: "object",
              wellFormed: false,
              group: false,
              verbose: false
            }), r2;
          }
          return a(t3, e14), t3.prototype.serialize = function(e15) {
            return this._currentList = [], this._currentIndex = 0, this._listRegister = [this._currentList], this.serializeNode(e15, this._writerOptions.wellFormed), this._process(this._currentList, this._writerOptions);
          }, t3.prototype._process = function(e15, t4) {
            var n2, r2, a2, o2, l, u, d;
            if (e15.length === 0)
              return {};
            for (var f = {}, p = false, m = 0, h = 0, g = 0, _ = 0, v = 0; v < e15.length; v++) {
              var y = e15[v];
              switch (I = Object.keys(y)[0]) {
                case "@":
                  continue;
                case "#":
                  m++;
                  break;
                case "!":
                  h++;
                  break;
                case "?":
                  g++;
                  break;
                case "$":
                  _++;
                  break;
                default:
                  f[I] ? p = true : f[I] = true;
              }
            }
            var b = this._getAttrKey(), S = this._getNodeKey(c.NodeType.Text), C = this._getNodeKey(c.NodeType.Comment), w = this._getNodeKey(c.NodeType.ProcessingInstruction), T = this._getNodeKey(c.NodeType.CData);
            if (m === 1 && e15.length === 1 && s.isString(e15[0]["#"]))
              return e15[0]["#"];
            if (p) {
              var E = {};
              for (v = 0; v < e15.length; v++)
                if (y = e15[v], (I = Object.keys(y)[0]) === "@") {
                  var D = y["@"];
                  (L = Object.keys(D)).length === 1 ? E[b + L[0]] = D[L[0]] : E[b] = y["@"];
                }
              var O = [];
              for (v = 0; v < e15.length; v++)
                switch (y = e15[v], I = Object.keys(y)[0]) {
                  case "@":
                    break;
                  case "#":
                    O.push(((n2 = {})[S] = y["#"], n2));
                    break;
                  case "!":
                    O.push(((r2 = {})[C] = y["!"], r2));
                    break;
                  case "?":
                    O.push(((a2 = {})[w] = y["?"], a2));
                    break;
                  case "$":
                    O.push(((o2 = {})[T] = y.$, o2));
                    break;
                  default:
                    if ((z = y)[I].length !== 0 && s.isArray(z[I][0])) {
                      for (var k = [], A = z[I], j = 0; j < A.length; j++)
                        k.push(this._process(A[j], t4));
                      O.push(((l = {})[I] = k, l));
                    } else
                      t4.verbose ? O.push(((u = {})[I] = [this._process(z[I], t4)], u)) : O.push(((d = {})[I] = this._process(z[I], t4), d));
                }
              return E[S] = O, E;
            }
            var M = 1, N = 1, P = 1, F = 1;
            for (E = {}, v = 0; v < e15.length; v++) {
              var I;
              switch (y = e15[v], I = Object.keys(y)[0]) {
                case "@":
                  D = y["@"];
                  var L = Object.keys(D);
                  if (t4.group && L.length !== 1)
                    E[b] = D;
                  else
                    for (var R in D)
                      E[b + R] = D[R];
                  break;
                case "#":
                  M = this._processSpecItem(y["#"], E, t4.group, S, m, M);
                  break;
                case "!":
                  N = this._processSpecItem(y["!"], E, t4.group, C, h, N);
                  break;
                case "?":
                  P = this._processSpecItem(y["?"], E, t4.group, w, g, P);
                  break;
                case "$":
                  F = this._processSpecItem(y.$, E, t4.group, T, _, F);
                  break;
                default:
                  var z;
                  if ((z = y)[I].length !== 0 && s.isArray(z[I][0])) {
                    k = [], A = z[I];
                    for (var B = 0; B < A.length; B++)
                      k.push(this._process(A[B], t4));
                    E[I] = k;
                  } else
                    t4.verbose ? E[I] = [this._process(z[I], t4)] : E[I] = this._process(z[I], t4);
              }
            }
            return E;
          }, t3.prototype._processSpecItem = function(e15, t4, n2, r2, a2, c2) {
            var l, u;
            if (!n2 && s.isArray(e15) && a2 + e15.length > 2)
              try {
                for (var d = o(e15), f = d.next(); !f.done; f = d.next()) {
                  var p = f.value;
                  t4[r2 + (c2++).toString()] = p;
                }
              } catch (e16) {
                l = { error: e16 };
              } finally {
                try {
                  f && !f.done && (u = d.return) && u.call(d);
                } finally {
                  if (l)
                    throw l.error;
                }
              }
            else
              t4[a2 > 1 ? r2 + (c2++).toString() : r2] = e15;
            return c2;
          }, t3.prototype.beginElement = function(e15) {
            var t4, n2, r2 = [];
            if (this._currentList.length === 0)
              this._currentList.push(((t4 = {})[e15] = r2, t4));
            else {
              var a2 = this._currentList[this._currentList.length - 1];
              this._isElementNode(a2, e15) ? a2[e15].length !== 0 && s.isArray(a2[e15][0]) ? a2[e15].push(r2) : a2[e15] = [a2[e15], r2] : this._currentList.push(((n2 = {})[e15] = r2, n2));
            }
            this._currentIndex++, this._listRegister.length > this._currentIndex ? this._listRegister[this._currentIndex] = r2 : this._listRegister.push(r2), this._currentList = r2;
          }, t3.prototype.endElement = function() {
            this._currentList = this._listRegister[--this._currentIndex];
          }, t3.prototype.attribute = function(e15, t4) {
            var n2, r2;
            if (this._currentList.length === 0)
              this._currentList.push({ "@": (n2 = {}, n2[e15] = t4, n2) });
            else {
              var a2 = this._currentList[this._currentList.length - 1];
              this._isAttrNode(a2) ? a2["@"][e15] = t4 : this._currentList.push({ "@": (r2 = {}, r2[e15] = t4, r2) });
            }
          }, t3.prototype.comment = function(e15) {
            if (this._currentList.length === 0)
              this._currentList.push({ "!": e15 });
            else {
              var t4 = this._currentList[this._currentList.length - 1];
              this._isCommentNode(t4) ? s.isArray(t4["!"]) ? t4["!"].push(e15) : t4["!"] = [t4["!"], e15] : this._currentList.push({ "!": e15 });
            }
          }, t3.prototype.text = function(e15) {
            if (this._currentList.length === 0)
              this._currentList.push({ "#": e15 });
            else {
              var t4 = this._currentList[this._currentList.length - 1];
              this._isTextNode(t4) ? s.isArray(t4["#"]) ? t4["#"].push(e15) : t4["#"] = [t4["#"], e15] : this._currentList.push({ "#": e15 });
            }
          }, t3.prototype.instruction = function(e15, t4) {
            var n2 = t4 === "" ? e15 : e15 + " " + t4;
            if (this._currentList.length === 0)
              this._currentList.push({ "?": n2 });
            else {
              var r2 = this._currentList[this._currentList.length - 1];
              this._isInstructionNode(r2) ? s.isArray(r2["?"]) ? r2["?"].push(n2) : r2["?"] = [r2["?"], n2] : this._currentList.push({ "?": n2 });
            }
          }, t3.prototype.cdata = function(e15) {
            if (this._currentList.length === 0)
              this._currentList.push({ $: e15 });
            else {
              var t4 = this._currentList[this._currentList.length - 1];
              this._isCDATANode(t4) ? s.isArray(t4.$) ? t4.$.push(e15) : t4.$ = [t4.$, e15] : this._currentList.push({ $: e15 });
            }
          }, t3.prototype._isAttrNode = function(e15) {
            return "@" in e15;
          }, t3.prototype._isTextNode = function(e15) {
            return "#" in e15;
          }, t3.prototype._isCommentNode = function(e15) {
            return "!" in e15;
          }, t3.prototype._isInstructionNode = function(e15) {
            return "?" in e15;
          }, t3.prototype._isCDATANode = function(e15) {
            return "$" in e15;
          }, t3.prototype._isElementNode = function(e15, t4) {
            return t4 in e15;
          }, t3.prototype._getAttrKey = function() {
            return this._builderOptions.convert.att;
          }, t3.prototype._getNodeKey = function(e15) {
            switch (e15) {
              case c.NodeType.Comment:
                return this._builderOptions.convert.comment;
              case c.NodeType.Text:
                return this._builderOptions.convert.text;
              case c.NodeType.ProcessingInstruction:
                return this._builderOptions.convert.ins;
              case c.NodeType.CData:
                return this._builderOptions.convert.cdata;
              default:
                throw Error("Invalid node type.");
            }
          }, t3;
        }(n(50).BaseWriter);
      },
      function(e13, t2, n) {
        var r = n(4), a = n(93);
        r({
          target: "RegExp",
          proto: true,
          forced: /./.exec !== a
        }, { exec: a });
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.LocalNameSet = function() {
          function e14() {
            this._items = {}, this._nullItems = {};
          }
          return e14.prototype.set = function(e15, t3) {
            e15 === null ? this._nullItems[t3] = true : (this._items[e15] || (this._items[e15] = {}), this._items[e15][t3] = true);
          }, e14.prototype.has = function(e15, t3) {
            return e15 === null ? true === this._nullItems[t3] : !!this._items[e15] && true === this._items[e15][t3];
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(9), o = n(3), s = n(0);
        t2.EventTargetImpl = function() {
          function e14() {
          }
          return Object.defineProperty(e14.prototype, "_eventListenerList", {
            get: function() {
              return this.__eventListenerList ||= [];
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "_eventHandlerMap", {
            get: function() {
              return this.__eventHandlerMap ||= {};
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.addEventListener = function(e15, t3, n2) {
            n2 === void 0 && (n2 = {
              passive: false,
              once: false,
              capture: false
            });
            var a2, c = r(s.eventTarget_flattenMore(n2), 3), l = c[0], u = c[1], d = c[2];
            t3 && (a2 = o.Guard.isEventListener(t3) ? t3 : { handleEvent: t3 }, s.eventTarget_addEventListener(this, {
              type: e15,
              callback: a2,
              capture: l,
              passive: u,
              once: d,
              removed: false
            }));
          }, e14.prototype.removeEventListener = function(e15, t3, n2) {
            n2 === void 0 && (n2 = { capture: false });
            var r2 = s.eventTarget_flatten(n2);
            if (t3)
              for (var a2 = 0; a2 < this._eventListenerList.length; a2++) {
                var c = this._eventListenerList[a2];
                if (c.type === e15 && c.capture === r2) {
                  if (o.Guard.isEventListener(t3) && c.callback === t3) {
                    s.eventTarget_removeEventListener(this, c, a2);
                    break;
                  }
                  if (t3 && c.callback.handleEvent === t3) {
                    s.eventTarget_removeEventListener(this, c, a2);
                    break;
                  }
                }
              }
          }, e14.prototype.dispatchEvent = function(e15) {
            if (e15._dispatchFlag || !e15._initializedFlag)
              throw new a.InvalidStateError();
            return e15._isTrusted = false, s.event_dispatch(e15, this);
          }, e14.prototype._getTheParent = function(e15) {
            return null;
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(34), s = n(0);
        t2.CharacterDataImpl = function(e14) {
          function t3(t4) {
            var n2 = e14.call(this) || this;
            return n2._data = t4, n2;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "data", {
            get: function() {
              return this._data;
            },
            set: function(e15) {
              s.characterData_replaceData(this, 0, this._data.length, e15);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "length", {
            get: function() {
              return this._data.length;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.substringData = function(e15, t4) {
            return s.characterData_substringData(this, e15, t4);
          }, t3.prototype.appendData = function(e15) {
            return s.characterData_replaceData(this, this._data.length, 0, e15);
          }, t3.prototype.insertData = function(e15, t4) {
            s.characterData_replaceData(this, e15, 0, t4);
          }, t3.prototype.deleteData = function(e15, t4) {
            s.characterData_replaceData(this, e15, t4, "");
          }, t3.prototype.replaceData = function(e15, t4, n2) {
            s.characterData_replaceData(this, e15, t4, n2);
          }, Object.defineProperty(t3.prototype, "previousElementSibling", {
            get: function() {
              throw Error("Mixin: NonDocumentTypeChildNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "nextElementSibling", {
            get: function() {
              throw Error("Mixin: NonDocumentTypeChildNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.before = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3.prototype.after = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3.prototype.replaceWith = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3.prototype.remove = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3;
        }(o.NodeImpl);
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, a = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, o = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(a(arguments[t3]));
          return e14;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(6), c = n(3), l = n(1), u = n(17), d = n(51);
        function f(e14) {
          s.dom.window._signalSlots.add(e14), d.observer_queueAMutationObserverMicrotask();
        }
        function p(e14, t3) {
          t3 === void 0 && (t3 = false);
          var n2 = c.Cast.asNode(e14)._parent;
          if (n2 === null)
            return null;
          var r2 = n2._shadowRoot || null;
          if (r2 === null || t3 && r2._mode !== "open")
            return null;
          for (var a2 = u.tree_getFirstDescendantNode(r2, false, true, function(e15) {
            return c.Guard.isSlot(e15);
          }); a2 !== null; ) {
            if (a2._name === e14._name)
              return a2;
            a2 = u.tree_getNextDescendantNode(r2, a2, false, true, function(e15) {
              return c.Guard.isSlot(e15);
            });
          }
          return null;
        }
        function m(e14) {
          var t3, n2, a2 = [], o2 = u.tree_rootNode(e14);
          if (!c.Guard.isShadowRoot(o2))
            return a2;
          var s2 = o2._host;
          try {
            for (var l2 = r(s2._children), d2 = l2.next(); !d2.done; d2 = l2.next()) {
              var f2 = d2.value;
              c.Guard.isSlotable(f2) && p(f2) === e14 && a2.push(f2);
            }
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              d2 && !d2.done && (n2 = l2.return) && n2.call(l2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          return a2;
        }
        function h(e14) {
          var t3, n2, a2 = m(e14);
          if (a2.length === e14._assignedNodes.length) {
            for (var o2 = true, s2 = 0; s2 < a2.length; s2++)
              if (a2[s2] !== e14._assignedNodes[s2]) {
                o2 = false;
                break;
              }
            o2 || f(e14);
          }
          e14._assignedNodes = a2;
          try {
            for (var c2 = r(a2), l2 = c2.next(); !l2.done; l2 = c2.next())
              l2.value._assignedSlot = e14;
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              l2 && !l2.done && (n2 = c2.return) && n2.call(c2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
        }
        t2.shadowTree_signalASlotChange = f, t2.shadowTree_isConnected = function(e14) {
          return c.Guard.isDocumentNode(u.tree_rootNode(e14, true));
        }, t2.shadowTree_isAssigned = function(e14) {
          return e14._assignedSlot !== null;
        }, t2.shadowTree_findASlot = p, t2.shadowTree_findSlotables = m, t2.shadowTree_findFlattenedSlotables = function e14(t3) {
          var n2, a2, s2, d2, f2 = [], p2 = u.tree_rootNode(t3);
          if (!c.Guard.isShadowRoot(p2))
            return f2;
          var h2 = m(t3);
          if (l.isEmpty(h2))
            try {
              for (var g = r(t3._children), _ = g.next(); !_.done; _ = g.next()) {
                var v = _.value;
                c.Guard.isSlotable(v) && h2.push(v);
              }
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                _ && !_.done && (a2 = g.return) && a2.call(g);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          try {
            for (var y = r(h2), b = y.next(); !b.done; b = y.next()) {
              var S = b.value;
              if (c.Guard.isSlot(S) && c.Guard.isShadowRoot(u.tree_rootNode(S))) {
                var C = e14(S);
                f2.push.apply(f2, o(C));
              } else
                f2.push(S);
            }
          } catch (e15) {
            s2 = { error: e15 };
          } finally {
            try {
              b && !b.done && (d2 = y.return) && d2.call(y);
            } finally {
              if (s2)
                throw s2.error;
            }
          }
          return f2;
        }, t2.shadowTree_assignSlotables = h, t2.shadowTree_assignSlotablesForATree = function(e14) {
          for (var t3 = u.tree_getFirstDescendantNode(e14, true, false, function(e15) {
            return c.Guard.isSlot(e15);
          }); t3 !== null; )
            h(t3), t3 = u.tree_getNextDescendantNode(e14, t3, true, false, function(e15) {
              return c.Guard.isSlot(e15);
            });
        }, t2.shadowTree_assignASlot = function(e14) {
          var t3 = p(e14);
          t3 !== null && h(t3);
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = /[a-z]([\0-\t\x2D\._a-z\xB7\xC0-\xD6\xD8-\xF6\xF8-\u037D\u037F-\u1FFF\u200C\u200D\u203F\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])*-([\0-\t\x2D\._a-z\xB7\xC0-\xD6\xD8-\xF6\xF8-\u037D\u037F-\u1FFF\u200C\u200D\u203F\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])*/, a = /* @__PURE__ */ new Set([
          "annotation-xml",
          "color-profile",
          "font-face",
          "font-face-src",
          "font-face-uri",
          "font-face-format",
          "font-face-name",
          "missing-glyph"
        ]), o = /* @__PURE__ */ new Set([
          "article",
          "aside",
          "blockquote",
          "body",
          "div",
          "footer",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "header",
          "main",
          "nav",
          "p",
          "section",
          "span"
        ]), s = /* @__PURE__ */ new Set([
          "area",
          "base",
          "basefont",
          "bgsound",
          "br",
          "col",
          "embed",
          "frame",
          "hr",
          "img",
          "input",
          "keygen",
          "link",
          "menuitem",
          "meta",
          "param",
          "source",
          "track",
          "wbr"
        ]), c = /* @__PURE__ */ new Set([
          "article",
          "aside",
          "blockquote",
          "body",
          "div",
          "footer",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "header",
          "main",
          "nav",
          "p",
          "section",
          "span"
        ]);
        t2.customElement_isValidCustomElementName = function(e14) {
          return !!r.test(e14) && !a.has(e14);
        }, t2.customElement_isValidElementName = function(e14) {
          return o.has(e14);
        }, t2.customElement_isVoidElementName = function(e14) {
          return s.has(e14);
        }, t2.customElement_isValidShadowHostName = function(e14) {
          return c.has(e14);
        }, t2.customElement_enqueueACustomElementUpgradeReaction = function(e14, t3) {
        }, t2.customElement_enqueueACustomElementCallbackReaction = function(e14, t3, n2) {
        }, t2.customElement_upgrade = function(e14, t3) {
        }, t2.customElement_tryToUpgrade = function(e14) {
        }, t2.customElement_lookUpACustomElementDefinition = function(e14, t3, n2, r2) {
          return null;
        };
      },
      function(e13, t2, n) {
        n(4)({
          target: "String",
          proto: true
        }, { repeat: n(259) });
      },
      function(e13, t2, n) {
        n(278), n(68), n(179), n(94), Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(109);
        t2.BaseReader = function() {
          function e14(e15) {
            this._builderOptions = e15, e15.parser && Object.assign(this, e15.parser);
          }
          return e14.prototype._docType = function(e15, t3, n2, r2) {
            return e15.dtd({
              name: t3,
              pubID: n2,
              sysID: r2
            });
          }, e14.prototype._comment = function(e15, t3) {
            return e15.com(t3);
          }, e14.prototype._text = function(e15, t3) {
            return e15.txt(t3);
          }, e14.prototype._instruction = function(e15, t3, n2) {
            return e15.ins(t3, n2);
          }, e14.prototype._cdata = function(e15, t3) {
            return e15.dat(t3);
          }, e14.prototype._element = function(e15, t3, n2) {
            return t3 === void 0 ? e15.ele(n2) : e15.ele(t3, n2);
          }, e14.prototype._attribute = function(e15, t3, n2, r2) {
            return t3 === void 0 ? e15.att(n2, r2) : e15.att(t3, n2, r2);
          }, e14.prototype._sanitize = function(e15) {
            return r.sanitizeInput(e15, this._builderOptions.invalidCharReplacement);
          }, e14.prototype._decodeText = function(t3) {
            return t3 == null ? t3 : t3.replace(/&(quot|amp|apos|lt|gt);/g, function(t4, n2) {
              return e14._entityTable[n2];
            }).replace(/&#(?:x([a-fA-F0-9]+)|([0-9]+));/g, function(e15, t4, n2) {
              return String.fromCodePoint(parseInt(t4 || n2, t4 ? 16 : 10));
            });
          }, e14.prototype._decodeAttributeValue = function(e15) {
            return this._decodeText(e15);
          }, e14.prototype.parse = function(e15, t3) {
            return this._parse(e15, t3);
          }, e14.prototype.docType = function(e15, t3, n2, r2) {
            return this._docType(e15, t3, n2, r2);
          }, e14.prototype.comment = function(e15, t3) {
            return this._comment(e15, t3);
          }, e14.prototype.text = function(e15, t3) {
            return this._text(e15, t3);
          }, e14.prototype.instruction = function(e15, t3, n2) {
            return this._instruction(e15, t3, n2);
          }, e14.prototype.cdata = function(e15, t3) {
            return this._cdata(e15, t3);
          }, e14.prototype.element = function(e15, t3, n2) {
            return this._element(e15, t3, n2);
          }, e14.prototype.attribute = function(e15, t3, n2, r2) {
            return this._attribute(e15, t3, n2, r2);
          }, e14.prototype.sanitize = function(e15) {
            return this._sanitize(e15);
          }, e14._entityTable = {
            lt: "<",
            gt: ">",
            amp: "&",
            quot: '"',
            apos: "'"
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r = n(39);
        e13.exports = r.DEFAULT = new r({
          include: [n(54)],
          explicit: [
            n(299),
            n(300),
            n(301)
          ]
        });
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.XMLBuilderImpl = n(185).XMLBuilderImpl, t2.XMLBuilderCBImpl = n(304).XMLBuilderCBImpl;
        var r = n(183);
        t2.builder = r.builder, t2.create = r.create, t2.fragment = r.fragment, t2.convert = r.convert;
        var a = n(309);
        t2.createCB = a.createCB, t2.fragmentCB = a.fragmentCB;
      },
      function(e13, t2) {
        var n = function() {
          return this;
        }();
        try {
          n ||= Function("return this")();
        } catch {
          typeof window == "object" && (n = window);
        }
        e13.exports = n;
      },
      function(e13, t2, n) {
        var r = {}.propertyIsEnumerable, a = Object.getOwnPropertyDescriptor;
        t2.f = a && !r.call({ 1: 2 }, 1) ? function(e14) {
          var t3 = a(this, e14);
          return !!t3 && t3.enumerable;
        } : r;
      },
      function(e13, t2, n) {
        var r = n(11), a = n(21);
        e13.exports = function(e14, t3) {
          try {
            a(r, e14, t3);
          } catch {
            r[e14] = t3;
          }
          return t3;
        };
      },
      function(e13, t2, n) {
        var r = n(44), a = n(118);
        (e13.exports = function(e14, t3) {
          return a[e14] || (a[e14] = t3 === void 0 ? {} : t3);
        })("versions", []).push({
          version: "3.6.5",
          mode: r ? "pure" : "global",
          copyright: "\xA9 2020 Denis Pushkarev (zloirock.ru)"
        });
      },
      function(e13, t2, n) {
        var r = n(121), a = n(84).concat("length", "prototype");
        t2.f = Object.getOwnPropertyNames || function(e14) {
          return r(e14, a);
        };
      },
      function(e13, t2, n) {
        var r = n(47), a = Math.max, o = Math.min;
        e13.exports = function(e14, t3) {
          var n2 = r(e14);
          return n2 < 0 ? a(n2 + t3, 0) : o(n2, t3);
        };
      },
      function(e13, t2) {
        e13.exports = [
          "constructor",
          "hasOwnProperty",
          "isPrototypeOf",
          "propertyIsEnumerable",
          "toLocaleString",
          "toString",
          "valueOf"
        ];
      },
      function(e13, t2) {
        t2.f = Object.getOwnPropertySymbols;
      },
      function(e13, t2, n) {
        var r = n(8);
        e13.exports = !!Object.getOwnPropertySymbols && !r(function() {
          return !String(Symbol());
        });
      },
      function(e13, t2, n) {
        var r = n(127);
        e13.exports = function(e14, t3, n2) {
          if (r(e14), t3 === void 0)
            return e14;
          switch (n2) {
            case 0:
              return function() {
                return e14.call(t3);
              };
            case 1:
              return function(n3) {
                return e14.call(t3, n3);
              };
            case 2:
              return function(n3, r2) {
                return e14.call(t3, n3, r2);
              };
            case 3:
              return function(n3, r2, a) {
                return e14.call(t3, n3, r2, a);
              };
          }
          return function() {
            return e14.apply(t3, arguments);
          };
        };
      },
      function(e13, t2, n) {
        var r = n(4), a = n(195), o = n(132), s = n(133), c = n(62), l = n(21), u = n(25), d = n(5), f = n(44), p = n(49), m = n(131), h = m.IteratorPrototype, g = m.BUGGY_SAFARI_ITERATORS, _ = d("iterator"), v = function() {
          return this;
        };
        e13.exports = function(e14, t3, n2, d2, m2, y, b) {
          a(n2, t3, d2);
          var S, C, w, T = function(e15) {
            if (e15 === m2 && A)
              return A;
            if (!g && e15 in O)
              return O[e15];
            switch (e15) {
              case "keys":
              case "values":
              case "entries":
                return function() {
                  return new n2(this, e15);
                };
            }
            return function() {
              return new n2(this);
            };
          }, E = t3 + " Iterator", D = false, O = e14.prototype, k = O[_] || O["@@iterator"] || m2 && O[m2], A = !g && k || T(m2), j = t3 == "Array" && O.entries || k;
          if (j && (S = o(j.call(new e14())), h !== Object.prototype && S.next && (f || o(S) === h || (s ? s(S, h) : typeof S[_] != "function" && l(S, _, v)), c(S, E, true, true), f && (p[E] = v))), m2 == "values" && k && k.name !== "values" && (D = true, A = function() {
            return k.call(this);
          }), f && !b || O[_] === A || l(O, _, A), p[t3] = A, m2)
            if (C = {
              values: T("values"),
              keys: y ? A : T("keys"),
              entries: T("entries")
            }, b)
              for (w in C)
                (g || D || !(w in O)) && u(O, w, C[w]);
            else
              r({
                target: t3,
                proto: true,
                forced: g || D
              }, C);
          return C;
        };
      },
      function(e13, t2, n) {
        var r = n(4), a = n(13), o = n(59), s = n(83), c = n(26), l = n(24), u = n(134), d = n(5), f = n(63), p = n(28), m = f("slice"), h = p("slice", {
          ACCESSORS: true,
          0: 0,
          1: 2
        }), g = d("species"), _ = [].slice, v = Math.max;
        r({
          target: "Array",
          proto: true,
          forced: !m || !h
        }, { slice: function(e14, t3) {
          var n2, r2, d2, f2 = l(this), p2 = c(f2.length), m2 = s(e14, p2), h2 = s(t3 === void 0 ? p2 : t3, p2);
          if (o(f2) && (typeof (n2 = f2.constructor) != "function" || n2 !== Array && !o(n2.prototype) ? a(n2) && (n2 = n2[g]) === null && (n2 = void 0) : n2 = void 0, n2 === Array || n2 === void 0))
            return _.call(f2, m2, h2);
          for (r2 = new (n2 === void 0 ? Array : n2)(v(h2 - m2, 0)), d2 = 0; m2 < h2; m2++, d2++)
            m2 in f2 && u(r2, d2, f2[m2]);
          return r2.length = d2, r2;
        } });
      },
      function(e13, t2, n) {
        var r = {};
        r[n(5)("toStringTag")] = "z", e13.exports = String(r) === "[object z]";
      },
      function(e13, t2, n) {
        n(19), n(138), n(20), n(92), n(22), n(23), Object.defineProperty(t2, "__esModule", { value: true }), t2.DefaultBuilderOptions = {
          version: "1.0",
          encoding: void 0,
          standalone: void 0,
          keepNullNodes: false,
          keepNullAttributes: false,
          ignoreConverters: false,
          convert: {
            att: "@",
            ins: "?",
            text: "#",
            cdata: "$",
            comment: "!"
          },
          defaultNamespace: {
            ele: void 0,
            att: void 0
          },
          namespaceAlias: {
            html: "http://www.w3.org/1999/xhtml",
            xml: "http://www.w3.org/XML/1998/namespace",
            xmlns: "http://www.w3.org/2000/xmlns/",
            mathml: "http://www.w3.org/1998/Math/MathML",
            svg: "http://www.w3.org/2000/svg",
            xlink: "http://www.w3.org/1999/xlink"
          },
          invalidCharReplacement: void 0,
          parser: void 0
        }, t2.XMLBuilderOptionKeys = new Set(Object.keys(t2.DefaultBuilderOptions)), t2.DefaultXMLBuilderCBOptions = {
          format: "xml",
          wellFormed: false,
          prettyPrint: false,
          indent: "  ",
          newline: "\n",
          offset: 0,
          width: 0,
          allowEmptyTags: false,
          spaceBeforeSlash: false,
          keepNullNodes: false,
          keepNullAttributes: false,
          ignoreConverters: false,
          convert: {
            att: "@",
            ins: "?",
            text: "#",
            cdata: "$",
            comment: "!"
          },
          defaultNamespace: {
            ele: void 0,
            att: void 0
          },
          namespaceAlias: {
            html: "http://www.w3.org/1999/xhtml",
            xml: "http://www.w3.org/XML/1998/namespace",
            xmlns: "http://www.w3.org/2000/xmlns/",
            mathml: "http://www.w3.org/1998/Math/MathML",
            svg: "http://www.w3.org/2000/svg",
            xlink: "http://www.w3.org/1999/xlink"
          }
        };
      },
      function(e13, t2, n) {
        e13.exports = n(139)("Set", function(e14) {
          return function() {
            return e14(this, arguments.length ? arguments[0] : void 0);
          };
        }, n(143));
      },
      function(e13, t2, n) {
        var r, a, o = n(136), s = n(221), c = RegExp.prototype.exec, l = String.prototype.replace, u = c, d = (r = /a/, a = /b*/g, c.call(r, "a"), c.call(a, "a"), r.lastIndex !== 0 || a.lastIndex !== 0), f = s.UNSUPPORTED_Y || s.BROKEN_CARET, p = /()??/.exec("")[1] !== void 0;
        (d || p || f) && (u = function(e14) {
          var t3, n2, r2, a2, s2 = this, u2 = f && s2.sticky, m = o.call(s2), h = s2.source, g = 0, _ = e14;
          return u2 && ((m = m.replace("y", "")).indexOf("g") === -1 && (m += "g"), _ = String(e14).slice(s2.lastIndex), s2.lastIndex > 0 && (!s2.multiline || s2.multiline && e14[s2.lastIndex - 1] !== "\n") && (h = "(?: " + h + ")", _ = " " + _, g++), n2 = RegExp("^(?:" + h + ")", m)), p && (n2 = RegExp("^" + h + "$(?!\\s)", m)), d && (t3 = s2.lastIndex), r2 = c.call(u2 ? n2 : s2, _), u2 ? r2 ? (r2.input = r2.input.slice(g), r2[0] = r2[0].slice(g), r2.index = s2.lastIndex, s2.lastIndex += r2[0].length) : s2.lastIndex = 0 : d && r2 && (s2.lastIndex = s2.global ? r2.index + r2[0].length : t3), p && r2 && r2.length > 1 && l.call(r2[0], n2, function() {
            for (a2 = 1; a2 < arguments.length - 2; a2++)
              arguments[a2] === void 0 && (r2[a2] = void 0);
          }), r2;
        }), e13.exports = u;
      },
      function(e13, t2, n) {
        var r = n(225), a = n(18), o = n(27), s = n(26), c = n(47), l = n(35), u = n(226), d = n(227), f = Math.max, p = Math.min, m = Math.floor, h = /\$([$&'`]|\d\d?|<[^>]*>)/g, g = /\$([$&'`]|\d\d?)/g;
        r("replace", 2, function(e14, t3, n2, r2) {
          var _ = r2.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE, v = r2.REPLACE_KEEPS_$0, y = _ ? "$" : "$0";
          return [function(n3, r3) {
            var a2 = l(this), o2 = n3?.[e14];
            return o2 === void 0 ? t3.call(String(a2), n3, r3) : o2.call(n3, a2, r3);
          }, function(e15, r3) {
            if (!_ && v || typeof r3 == "string" && r3.indexOf(y) === -1) {
              var o2 = n2(t3, e15, this, r3);
              if (o2.done)
                return o2.value;
            }
            var l2 = a(e15), m2 = String(this), h2 = typeof r3 == "function";
            h2 || (r3 = String(r3));
            var g2 = l2.global;
            if (g2) {
              var S = l2.unicode;
              l2.lastIndex = 0;
            }
            for (var C = []; ; ) {
              var w = d(l2, m2);
              if (w === null || (C.push(w), !g2))
                break;
              String(w[0]) === "" && (l2.lastIndex = u(m2, s(l2.lastIndex), S));
            }
            for (var T, E = "", D = 0, O = 0; O < C.length; O++) {
              w = C[O];
              for (var k = String(w[0]), A = f(p(c(w.index), m2.length), 0), j = [], M = 1; M < w.length; M++)
                j.push((T = w[M]) === void 0 ? T : String(T));
              var N = w.groups;
              if (h2) {
                var P = [k].concat(j, A, m2);
                N !== void 0 && P.push(N);
                var F = String(r3.apply(void 0, P));
              } else
                F = b(k, m2, A, j, N, r3);
              A >= D && (E += m2.slice(D, A) + F, D = A + k.length);
            }
            return E + m2.slice(D);
          }];
          function b(e15, n3, r3, a2, s2, c2) {
            var l2 = r3 + e15.length, u2 = a2.length, d2 = g;
            return s2 !== void 0 && (s2 = o(s2), d2 = h), t3.call(c2, d2, function(t4, o2) {
              var c3;
              switch (o2.charAt(0)) {
                case "$":
                  return "$";
                case "&":
                  return e15;
                case "`":
                  return n3.slice(0, r3);
                case "'":
                  return n3.slice(l2);
                case "<":
                  c3 = s2[o2.slice(1, -1)];
                  break;
                default:
                  var d3 = +o2;
                  if (d3 === 0)
                    return t4;
                  if (d3 > u2) {
                    var f2 = m(d3 / 10);
                    return f2 === 0 ? t4 : f2 <= u2 ? a2[f2 - 1] === void 0 ? o2.charAt(1) : a2[f2 - 1] + o2.charAt(1) : t4;
                  }
                  c3 = a2[d3 - 1];
              }
              return c3 === void 0 ? "" : c3;
            });
          }
        });
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.NamespacePrefixMap = function() {
          function e14() {
            this._items = {}, this._nullItems = [];
          }
          return e14.prototype.copy = function() {
            var t3 = new e14();
            for (var n2 in this._items)
              t3._items[n2] = this._items[n2].slice(0);
            return t3._nullItems = this._nullItems.slice(0), t3;
          }, e14.prototype.get = function(e15, t3) {
            var n2 = t3 === null ? this._nullItems : this._items[t3] || null;
            if (n2 === null)
              return null;
            for (var r = null, a = 0; a < n2.length; a++)
              if ((r = n2[a]) === e15)
                return r;
            return r;
          }, e14.prototype.has = function(e15, t3) {
            var n2 = t3 === null ? this._nullItems : this._items[t3] || null;
            return n2 !== null && n2.indexOf(e15) !== -1;
          }, e14.prototype.hasPrefix = function(e15) {
            if (this._nullItems.indexOf(e15) !== -1)
              return true;
            for (var t3 in this._items)
              if (this._items[t3].indexOf(e15) !== -1)
                return true;
            return false;
          }, e14.prototype.set = function(e15, t3) {
            var n2 = t3 === null ? this._nullItems : this._items[t3] || null;
            t3 !== null && n2 === null ? this._items[t3] = [e15] : n2.push(e15);
          }, e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.Surrogate = /[\uD800-\uDFFF]/, t2.ScalarValue = /[\uD800-\uDFFF]/, t2.NonCharacter = /[\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]/, t2.ASCIICodePoint = /[\u0000-\u007F]/, t2.ASCIITabOrNewLine = /[\t\n\r]/, t2.ASCIIWhiteSpace = /[\t\n\f\r ]/, t2.C0Control = /[\u0000-\u001F]/, t2.C0ControlOrSpace = /[\u0000-\u001F ]/, t2.Control = /[\u0000-\u001F\u007F-\u009F]/, t2.ASCIIDigit = /[0-9]/, t2.ASCIIUpperHexDigit = /[0-9A-F]/, t2.ASCIILowerHexDigit = /[0-9a-f]/, t2.ASCIIHexDigit = /[0-9A-Fa-f]/, t2.ASCIIUpperAlpha = /[A-Z]/, t2.ASCIILowerAlpha = /[a-z]/, t2.ASCIIAlpha = /[A-Za-z]/, t2.ASCIIAlphanumeric = /[0-9A-Za-z]/;
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, a = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, o = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(a(arguments[t3]));
          return e14;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(6), c = n(2), l = n(3), u = n(171), d = n(104), f = n(9), p = n(17), m = n(72), h = n(30);
        function g(e14, t3) {
          t3 === void 0 && (t3 = void 0), t3 === void 0 && (t3 = null);
          var n2 = _(e14, t3, /* @__PURE__ */ new Date(), {});
          return n2._isTrusted = true, n2;
        }
        function _(e14, t3, n2, r2) {
          var a2 = new e14("");
          return a2._initializedFlag = true, a2._timeStamp = n2.getTime(), Object.assign(a2, r2), s.dom.features.steps && h.dom_runEventConstructingSteps(a2), a2;
        }
        function v(e14, t3, n2, a2) {
          var o2, s2, u2, d2;
          n2 === void 0 && (n2 = false), a2 === void 0 && (a2 = { value: false });
          var f2 = false;
          e14._dispatchFlag = true;
          var h2 = t3;
          if (n2) {
            var g2 = t3._associatedDocument;
            l.Guard.isDocumentNode(g2) && (h2 = g2);
          }
          var _2 = null, v2 = p.tree_retarget(e14._relatedTarget, t3);
          if (t3 !== v2 || t3 === e14._relatedTarget) {
            var S2 = [];
            try {
              for (var C2 = r(e14._touchTargetList), w2 = C2.next(); !w2.done; w2 = C2.next()) {
                var T2 = w2.value;
                S2.push(p.tree_retarget(T2, t3));
              }
            } catch (e15) {
              o2 = { error: e15 };
            } finally {
              try {
                w2 && !w2.done && (s2 = C2.return) && s2.call(C2);
              } finally {
                if (o2)
                  throw o2.error;
              }
            }
            y(e14, t3, h2, v2, S2, false);
            var E2 = l.Guard.isMouseEvent(e14) && e14._type === "click";
            E2 && t3._activationBehavior !== void 0 && (_2 = t3);
            for (var D = l.Guard.isSlotable(t3) && m.shadowTree_isAssigned(t3) ? t3 : null, O = false, k = t3._getTheParent(e14); k !== null && l.Guard.isNode(k); ) {
              if (D !== null) {
                if (!l.Guard.isSlot(k))
                  throw Error("Parent node of a slotable should be a slot.");
                D = null;
                var A = p.tree_rootNode(k, true);
                l.Guard.isShadowRoot(A) && A._mode === "closed" && (O = true);
              }
              l.Guard.isSlotable(k) && m.shadowTree_isAssigned(k) && (D = k), v2 = p.tree_retarget(e14._relatedTarget, k), S2 = [];
              try {
                for (var j = (u2 = void 0, r(e14._touchTargetList)), M = j.next(); !M.done; M = j.next())
                  T2 = M.value, S2.push(p.tree_retarget(T2, k));
              } catch (e15) {
                u2 = { error: e15 };
              } finally {
                try {
                  M && !M.done && (d2 = j.return) && d2.call(j);
                } finally {
                  if (u2)
                    throw u2.error;
                }
              }
              l.Guard.isWindow(k) || l.Guard.isNode(k) && l.Guard.isNode(t3) && p.tree_isAncestorOf(p.tree_rootNode(t3, true), k, true, true) ? (E2 && e14._bubbles && _2 === null && k._activationBehavior && (_2 = k), y(e14, k, null, v2, S2, O)) : k === v2 ? k = null : (t3 = k, E2 && _2 === null && t3._activationBehavior && (_2 = t3), y(e14, k, t3, v2, S2, O)), k !== null && (k = k._getTheParent(e14)), O = false;
            }
            for (var N = null, P = e14._path, F = P.length - 1; F >= 0; F--)
              if ((L = P[F]).shadowAdjustedTarget !== null) {
                N = L;
                break;
              }
            if (N !== null)
              if (l.Guard.isNode(N.shadowAdjustedTarget) && l.Guard.isShadowRoot(p.tree_rootNode(N.shadowAdjustedTarget, true)))
                f2 = true;
              else if (l.Guard.isNode(N.relatedTarget) && l.Guard.isShadowRoot(p.tree_rootNode(N.relatedTarget, true)))
                f2 = true;
              else
                for (var I = 0; I < N.touchTargetList.length; I++) {
                  var L = N.touchTargetList[I];
                  if (l.Guard.isNode(L) && l.Guard.isShadowRoot(p.tree_rootNode(L, true))) {
                    f2 = true;
                    break;
                  }
                }
            for (_2 !== null && _2._legacyPreActivationBehavior !== void 0 && _2._legacyPreActivationBehavior(e14), F = P.length - 1; F >= 0; F--)
              (L = P[F]).shadowAdjustedTarget === null ? e14._eventPhase = c.EventPhase.Capturing : e14._eventPhase = c.EventPhase.AtTarget, b(L, e14, "capturing", a2);
            for (F = 0; F < P.length; F++) {
              if ((L = P[F]).shadowAdjustedTarget !== null)
                e14._eventPhase = c.EventPhase.AtTarget;
              else {
                if (!e14._bubbles)
                  continue;
                e14._eventPhase = c.EventPhase.Bubbling;
              }
              b(L, e14, "bubbling", a2);
            }
          }
          return e14._eventPhase = c.EventPhase.None, e14._currentTarget = null, e14._path = [], e14._dispatchFlag = false, e14._stopPropagationFlag = false, e14._stopImmediatePropagationFlag = false, f2 && (e14._target = null, e14._relatedTarget = null, e14._touchTargetList = []), _2 !== null && (e14._canceledFlag || _2._activationBehavior === void 0 ? _2._legacyCanceledActivationBehavior !== void 0 && _2._legacyCanceledActivationBehavior(e14) : _2._activationBehavior(e14)), !e14._canceledFlag;
        }
        function y(e14, t3, n2, r2, a2, o2) {
          var s2 = false;
          l.Guard.isNode(t3) && l.Guard.isShadowRoot(p.tree_rootNode(t3)) && (s2 = true);
          var c2 = false;
          l.Guard.isShadowRoot(t3) && t3._mode === "closed" && (c2 = true), e14._path.push({
            invocationTarget: t3,
            invocationTargetInShadowTree: s2,
            shadowAdjustedTarget: n2,
            relatedTarget: r2,
            touchTargetList: a2,
            rootOfClosedTree: c2,
            slotInClosedTree: o2
          });
        }
        function b(e14, t3, n2, r2) {
          r2 === void 0 && (r2 = { value: false });
          for (var a2 = t3._path, s2 = -1, c2 = 0; c2 < a2.length; c2++)
            if (a2[c2] === e14) {
              s2 = c2;
              break;
            }
          if (s2 !== -1) {
            var l2 = a2[s2];
            (l2.shadowAdjustedTarget !== null || s2 > 0 && (l2 = a2[s2 - 1]).shadowAdjustedTarget !== null) && (t3._target = l2.shadowAdjustedTarget);
          }
          if (t3._relatedTarget = e14.relatedTarget, t3._touchTargetList = e14.touchTargetList, !t3._stopPropagationFlag) {
            t3._currentTarget = e14.invocationTarget;
            var u2 = t3._currentTarget._eventListenerList, d2 = new (Array.bind.apply(Array, o([void 0], u2)))();
            if (!S(t3, d2, n2, e14, r2) && t3._isTrusted) {
              var f2 = t3._type;
              f2 === "animationend" ? t3._type = "webkitAnimationEnd" : f2 === "animationiteration" ? t3._type = "webkitAnimationIteration" : f2 === "animationstart" ? t3._type = "webkitAnimationStart" : f2 === "transitionend" && (t3._type = "webkitTransitionEnd"), S(t3, d2, n2, e14, r2), t3._type = f2;
            }
          }
        }
        function S(e14, t3, n2, r2, a2) {
          a2 === void 0 && (a2 = { value: false });
          for (var o2 = false, s2 = 0; s2 < t3.length; s2++) {
            var c2 = t3[s2];
            if (!c2.removed) {
              if (e14._type !== c2.type || (o2 = true, n2 === "capturing" && !c2.capture) || n2 === "bubbling" && c2.capture)
                continue;
              if (c2.once && e14._currentTarget !== null) {
                for (var u2 = e14._currentTarget, d2 = -1, f2 = 0; f2 < u2._eventListenerList.length; f2++)
                  if (u2._eventListenerList[f2] === c2) {
                    d2 = f2;
                    break;
                  }
                d2 !== -1 && u2._eventListenerList.splice(d2, 1);
              }
              var p2 = void 0, m2 = void 0;
              l.Guard.isWindow(p2) && (m2 = p2._currentEvent, false === r2.invocationTargetInShadowTree && (p2._currentEvent = e14)), c2.passive && (e14._inPassiveListenerFlag = true);
              try {
                c2.callback.handleEvent.call(e14._currentTarget, e14);
              } catch {
                a2.value = true;
              }
              if (c2.passive && (e14._inPassiveListenerFlag = false), l.Guard.isWindow(p2) && (p2._currentEvent = m2), e14._stopImmediatePropagationFlag)
                return o2;
            }
          }
          return o2;
        }
        function C(e14, t3) {
          return null;
        }
        function w(e14, t3) {
          return null;
        }
        function T(e14, t3) {
        }
        function E(e14, t3) {
        }
        t2.event_setTheCanceledFlag = function(e14) {
          e14._cancelable && !e14._inPassiveListenerFlag && (e14._canceledFlag = true);
        }, t2.event_initialize = function(e14, t3, n2, r2) {
          e14._initializedFlag = true, e14._stopPropagationFlag = false, e14._stopImmediatePropagationFlag = false, e14._canceledFlag = false, e14._isTrusted = false, e14._target = null, e14._type = t3, e14._bubbles = n2, e14._cancelable = r2;
        }, t2.event_createAnEvent = g, t2.event_innerEventCreationSteps = _, t2.event_dispatch = v, t2.event_appendToAnEventPath = y, t2.event_invoke = b, t2.event_innerInvoke = S, t2.event_fireAnEvent = function(e14, t3, n2, r2, a2) {
          n2 === void 0 && (n2 = d.EventImpl);
          var o2 = g(n2);
          if (o2._type = e14, r2)
            for (var s2 in r2)
              o2[s2] = r2[s2];
          return v(o2, t3, a2);
        }, t2.event_createLegacyEvent = function(e14) {
          var t3 = null;
          switch (e14.toLowerCase()) {
            case "beforeunloadevent":
            case "compositionevent":
              break;
            case "customevent":
              t3 = u.CustomEventImpl;
              break;
            case "devicemotionevent":
            case "deviceorientationevent":
            case "dragevent":
              break;
            case "event":
            case "events":
              t3 = d.EventImpl;
          }
          if (t3 === null)
            throw new f.NotSupportedError("Event constructor not found for interface " + e14 + ".");
          var n2 = new t3("");
          return n2._type = "", n2._timeStamp = (/* @__PURE__ */ new Date()).getTime(), n2._isTrusted = false, n2._initializedFlag = false, n2;
        }, t2.event_getterEventHandlerIDLAttribute = function(e14, t3) {
          return null;
        }, t2.event_setterEventHandlerIDLAttribute = function(e14, t3, n2) {
        }, t2.event_determineTheTargetOfAnEventHandler = C, t2.event_getTheCurrentValueOfAnEventHandler = w, t2.event_activateAnEventHandler = T, t2.event_deactivateAnEventHandler = E;
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, s = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var c = n(6), l = n(2), u = n(9), d = n(34), f = n(3), p = n(1), m = n(7), h = n(152), g = n(0), _ = n(12), v = function(e14) {
          function t3() {
            var t4 = e14.call(this) || this;
            return t4._children = /* @__PURE__ */ new Set(), t4._encoding = {
              name: "UTF-8",
              labels: [
                "unicode-1-1-utf-8",
                "utf-8",
                "utf8"
              ]
            }, t4._contentType = "application/xml", t4._URL = {
              scheme: "about",
              username: "",
              password: "",
              host: null,
              port: null,
              path: ["blank"],
              query: null,
              fragment: null,
              _cannotBeABaseURLFlag: true,
              _blobURLEntry: null
            }, t4._origin = null, t4._type = "xml", t4._mode = "no-quirks", t4._documentElement = null, t4._hasNamespaces = false, t4._nodeDocumentOverwrite = null, t4;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "_nodeDocument", {
            get: function() {
              return this._nodeDocumentOverwrite || this;
            },
            set: function(e15) {
              this._nodeDocumentOverwrite = e15;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "implementation", {
            get: function() {
              return this._implementation ||= g.create_domImplementation(this);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "URL", {
            get: function() {
              return h.urlSerializer(this._URL);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "documentURI", {
            get: function() {
              return this.URL;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "origin", {
            get: function() {
              return "null";
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "compatMode", {
            get: function() {
              return this._mode === "quirks" ? "BackCompat" : "CSS1Compat";
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "characterSet", {
            get: function() {
              return this._encoding.name;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "charset", {
            get: function() {
              return this._encoding.name;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "inputEncoding", {
            get: function() {
              return this._encoding.name;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "contentType", {
            get: function() {
              return this._contentType;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "doctype", {
            get: function() {
              var e15, t4;
              try {
                for (var n2 = o(this._children), r2 = n2.next(); !r2.done; r2 = n2.next()) {
                  var a2 = r2.value;
                  if (f.Guard.isDocumentTypeNode(a2))
                    return a2;
                }
              } catch (t5) {
                e15 = { error: t5 };
              } finally {
                try {
                  r2 && !r2.done && (t4 = n2.return) && t4.call(n2);
                } finally {
                  if (e15)
                    throw e15.error;
                }
              }
              return null;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "documentElement", {
            get: function() {
              return this._documentElement;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.getElementsByTagName = function(e15) {
            return g.node_listOfElementsWithQualifiedName(e15, this);
          }, t3.prototype.getElementsByTagNameNS = function(e15, t4) {
            return g.node_listOfElementsWithNamespace(e15, t4, this);
          }, t3.prototype.getElementsByClassName = function(e15) {
            return g.node_listOfElementsWithClassNames(e15, this);
          }, t3.prototype.createElement = function(e15, t4) {
            if (!g.xml_isName(e15))
              throw new u.InvalidCharacterError();
            this._type === "html" && (e15 = e15.toLowerCase());
            var n2 = null;
            t4 !== void 0 && (n2 = p.isString(t4) ? t4 : t4.is);
            var r2 = this._type === "html" || this._contentType === "application/xhtml+xml" ? m.namespace.HTML : null;
            return g.element_createAnElement(this, e15, r2, null, n2, true);
          }, t3.prototype.createElementNS = function(e15, t4, n2) {
            return g.document_internalCreateElementNS(this, e15, t4, n2);
          }, t3.prototype.createDocumentFragment = function() {
            return g.create_documentFragment(this);
          }, t3.prototype.createTextNode = function(e15) {
            return g.create_text(this, e15);
          }, t3.prototype.createCDATASection = function(e15) {
            if (this._type === "html")
              throw new u.NotSupportedError();
            if (e15.indexOf("]]>") !== -1)
              throw new u.InvalidCharacterError();
            return g.create_cdataSection(this, e15);
          }, t3.prototype.createComment = function(e15) {
            return g.create_comment(this, e15);
          }, t3.prototype.createProcessingInstruction = function(e15, t4) {
            if (!g.xml_isName(e15) || t4.indexOf("?>") !== -1)
              throw new u.InvalidCharacterError();
            return g.create_processingInstruction(this, e15, t4);
          }, t3.prototype.importNode = function(e15, t4) {
            if (t4 === void 0 && (t4 = false), f.Guard.isDocumentNode(e15) || f.Guard.isShadowRoot(e15))
              throw new u.NotSupportedError();
            return g.node_clone(e15, this, t4);
          }, t3.prototype.adoptNode = function(e15) {
            if (f.Guard.isDocumentNode(e15))
              throw new u.NotSupportedError();
            if (f.Guard.isShadowRoot(e15))
              throw new u.HierarchyRequestError();
            return g.document_adopt(e15, this), e15;
          }, t3.prototype.createAttribute = function(e15) {
            if (!g.xml_isName(e15))
              throw new u.InvalidCharacterError();
            return this._type === "html" && (e15 = e15.toLowerCase()), g.create_attr(this, e15);
          }, t3.prototype.createAttributeNS = function(e15, t4) {
            var n2 = s(g.namespace_validateAndExtract(e15, t4), 3), r2 = n2[0], a2 = n2[1], o2 = n2[2], c2 = g.create_attr(this, o2);
            return c2._namespace = r2, c2._namespacePrefix = a2, c2;
          }, t3.prototype.createEvent = function(e15) {
            return g.event_createLegacyEvent(e15);
          }, t3.prototype.createRange = function() {
            var e15 = g.create_range();
            return e15._start = [this, 0], e15._end = [this, 0], e15;
          }, t3.prototype.createNodeIterator = function(e15, t4, n2) {
            t4 === void 0 && (t4 = l.WhatToShow.All), n2 === void 0 && (n2 = null);
            var r2 = g.create_nodeIterator(e15, e15, true);
            return r2._whatToShow = t4, r2._iteratorCollection = g.create_nodeList(e15), p.isFunction(n2) ? (r2._filter = g.create_nodeFilter(), r2._filter.acceptNode = n2) : r2._filter = n2, r2;
          }, t3.prototype.createTreeWalker = function(e15, t4, n2) {
            t4 === void 0 && (t4 = l.WhatToShow.All), n2 === void 0 && (n2 = null);
            var r2 = g.create_treeWalker(e15, e15);
            return r2._whatToShow = t4, p.isFunction(n2) ? (r2._filter = g.create_nodeFilter(), r2._filter.acceptNode = n2) : r2._filter = n2, r2;
          }, t3.prototype._getTheParent = function(e15) {
            return e15._type === "load" ? null : c.dom.window;
          }, t3.prototype.getElementById = function(e15) {
            throw Error("Mixin: NonElementParentNode not implemented.");
          }, Object.defineProperty(t3.prototype, "children", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "firstElementChild", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "lastElementChild", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "childElementCount", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.prepend = function() {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3.prototype.append = function() {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3.prototype.querySelector = function(e15) {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3.prototype.querySelectorAll = function(e15) {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3;
        }(d.NodeImpl);
        t2.DocumentImpl = v, _.idl_defineConst(v.prototype, "_nodeType", l.NodeType.Document);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, s = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var c = n(2), l = n(34), u = n(9), d = n(7), f = n(0), p = n(12), m = function(e14) {
          function t3() {
            var t4 = e14.call(this) || this;
            return t4._children = /* @__PURE__ */ new Set(), t4._namespace = null, t4._namespacePrefix = null, t4._localName = "", t4._customElementState = "undefined", t4._customElementDefinition = null, t4._is = null, t4._shadowRoot = null, t4._attributeList = f.create_namedNodeMap(t4), t4._attributeChangeSteps = [], t4._name = "", t4._assignedSlot = null, t4;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "namespaceURI", {
            get: function() {
              return this._namespace;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "prefix", {
            get: function() {
              return this._namespacePrefix;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "localName", {
            get: function() {
              return this._localName;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "tagName", {
            get: function() {
              return this._htmlUppercasedQualifiedName;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "id", {
            get: function() {
              return f.element_getAnAttributeValue(this, "id");
            },
            set: function(e15) {
              f.element_setAnAttributeValue(this, "id", e15);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "className", {
            get: function() {
              return f.element_getAnAttributeValue(this, "class");
            },
            set: function(e15) {
              f.element_setAnAttributeValue(this, "class", e15);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "classList", {
            get: function() {
              var e15 = f.element_getAnAttributeByName("class", this);
              return e15 === null && (e15 = f.create_attr(this._nodeDocument, "class")), f.create_domTokenList(this, e15);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "slot", {
            get: function() {
              return f.element_getAnAttributeValue(this, "slot");
            },
            set: function(e15) {
              f.element_setAnAttributeValue(this, "slot", e15);
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.hasAttributes = function() {
            return this._attributeList.length !== 0;
          }, Object.defineProperty(t3.prototype, "attributes", {
            get: function() {
              return this._attributeList;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.getAttributeNames = function() {
            var e15, t4, n2 = [];
            try {
              for (var r2 = o(this._attributeList), a2 = r2.next(); !a2.done; a2 = r2.next()) {
                var s2 = a2.value;
                n2.push(s2._qualifiedName);
              }
            } catch (t5) {
              e15 = { error: t5 };
            } finally {
              try {
                a2 && !a2.done && (t4 = r2.return) && t4.call(r2);
              } finally {
                if (e15)
                  throw e15.error;
              }
            }
            return n2;
          }, t3.prototype.getAttribute = function(e15) {
            var t4 = f.element_getAnAttributeByName(e15, this);
            return t4 ? t4._value : null;
          }, t3.prototype.getAttributeNS = function(e15, t4) {
            var n2 = f.element_getAnAttributeByNamespaceAndLocalName(e15, t4, this);
            return n2 ? n2._value : null;
          }, t3.prototype.setAttribute = function(e15, t4) {
            if (!f.xml_isName(e15))
              throw new u.InvalidCharacterError();
            this._namespace === d.namespace.HTML && this._nodeDocument._type === "html" && (e15 = e15.toLowerCase());
            for (var n2 = null, r2 = 0; r2 < this._attributeList.length; r2++) {
              var a2 = this._attributeList[r2];
              if (a2._qualifiedName === e15) {
                n2 = a2;
                break;
              }
            }
            if (n2 === null)
              return (n2 = f.create_attr(this._nodeDocument, e15))._value = t4, void f.element_append(n2, this);
            f.element_change(n2, this, t4);
          }, t3.prototype.setAttributeNS = function(e15, t4, n2) {
            var r2 = s(f.namespace_validateAndExtract(e15, t4), 3), a2 = r2[0], o2 = r2[1], c2 = r2[2];
            f.element_setAnAttributeValue(this, c2, n2, o2, a2);
          }, t3.prototype.removeAttribute = function(e15) {
            f.element_removeAnAttributeByName(e15, this);
          }, t3.prototype.removeAttributeNS = function(e15, t4) {
            f.element_removeAnAttributeByNamespaceAndLocalName(e15, t4, this);
          }, t3.prototype.hasAttribute = function(e15) {
            this._namespace === d.namespace.HTML && this._nodeDocument._type === "html" && (e15 = e15.toLowerCase());
            for (var t4 = 0; t4 < this._attributeList.length; t4++)
              if (this._attributeList[t4]._qualifiedName === e15)
                return true;
            return false;
          }, t3.prototype.toggleAttribute = function(e15, t4) {
            if (!f.xml_isName(e15))
              throw new u.InvalidCharacterError();
            this._namespace === d.namespace.HTML && this._nodeDocument._type === "html" && (e15 = e15.toLowerCase());
            for (var n2 = null, r2 = 0; r2 < this._attributeList.length; r2++) {
              var a2 = this._attributeList[r2];
              if (a2._qualifiedName === e15) {
                n2 = a2;
                break;
              }
            }
            return n2 === null ? (t4 === void 0 || true === t4) && ((n2 = f.create_attr(this._nodeDocument, e15))._value = "", f.element_append(n2, this), true) : t4 !== void 0 && false !== t4 || (f.element_removeAnAttributeByName(e15, this), false);
          }, t3.prototype.hasAttributeNS = function(e15, t4) {
            for (var n2 = e15 || null, r2 = 0; r2 < this._attributeList.length; r2++) {
              var a2 = this._attributeList[r2];
              if (a2._namespace === n2 && a2._localName === t4)
                return true;
            }
            return false;
          }, t3.prototype.getAttributeNode = function(e15) {
            return f.element_getAnAttributeByName(e15, this);
          }, t3.prototype.getAttributeNodeNS = function(e15, t4) {
            return f.element_getAnAttributeByNamespaceAndLocalName(e15, t4, this);
          }, t3.prototype.setAttributeNode = function(e15) {
            return f.element_setAnAttribute(e15, this);
          }, t3.prototype.setAttributeNodeNS = function(e15) {
            return f.element_setAnAttribute(e15, this);
          }, t3.prototype.removeAttributeNode = function(e15) {
            for (var t4 = false, n2 = 0; n2 < this._attributeList.length; n2++)
              if (this._attributeList[n2] === e15) {
                t4 = true;
                break;
              }
            if (!t4)
              throw new u.NotFoundError();
            return f.element_remove(e15, this), e15;
          }, t3.prototype.attachShadow = function(e15) {
            if (this._namespace !== d.namespace.HTML || !f.customElement_isValidCustomElementName(this._localName) && !f.customElement_isValidShadowHostName(this._localName))
              throw new u.NotSupportedError();
            if (f.customElement_isValidCustomElementName(this._localName) || this._is !== null) {
              var t4 = f.customElement_lookUpACustomElementDefinition(this._nodeDocument, this._namespace, this._localName, this._is);
              if (t4 !== null && true === t4.disableShadow)
                throw new u.NotSupportedError();
            }
            if (this._shadowRoot !== null)
              throw new u.NotSupportedError();
            var n2 = f.create_shadowRoot(this._nodeDocument, this);
            return n2._mode = e15.mode, this._shadowRoot = n2, n2;
          }, Object.defineProperty(t3.prototype, "shadowRoot", {
            get: function() {
              var e15 = this._shadowRoot;
              return e15 === null || e15.mode === "closed" ? null : e15;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.closest = function(e15) {
            throw new u.NotImplementedError();
          }, t3.prototype.matches = function(e15) {
            throw new u.NotImplementedError();
          }, t3.prototype.webkitMatchesSelector = function(e15) {
            return this.matches(e15);
          }, t3.prototype.getElementsByTagName = function(e15) {
            return f.node_listOfElementsWithQualifiedName(e15, this);
          }, t3.prototype.getElementsByTagNameNS = function(e15, t4) {
            return f.node_listOfElementsWithNamespace(e15, t4, this);
          }, t3.prototype.getElementsByClassName = function(e15) {
            return f.node_listOfElementsWithClassNames(e15, this);
          }, t3.prototype.insertAdjacentElement = function(e15, t4) {
            return f.element_insertAdjacent(this, e15, t4);
          }, t3.prototype.insertAdjacentText = function(e15, t4) {
            var n2 = f.create_text(this._nodeDocument, t4);
            f.element_insertAdjacent(this, e15, n2);
          }, Object.defineProperty(t3.prototype, "_qualifiedName", {
            get: function() {
              return this._namespacePrefix ? this._namespacePrefix + ":" + this._localName : this._localName;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "_htmlUppercasedQualifiedName", {
            get: function() {
              var e15 = this._qualifiedName;
              return this._namespace === d.namespace.HTML && this._nodeDocument._type === "html" && (e15 = e15.toUpperCase()), e15;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "children", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "firstElementChild", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "lastElementChild", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "childElementCount", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.prepend = function() {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3.prototype.append = function() {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3.prototype.querySelector = function(e15) {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3.prototype.querySelectorAll = function(e15) {
            throw Error("Mixin: ParentNode not implemented.");
          }, Object.defineProperty(t3.prototype, "previousElementSibling", {
            get: function() {
              throw Error("Mixin: NonDocumentTypeChildNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "nextElementSibling", {
            get: function() {
              throw Error("Mixin: NonDocumentTypeChildNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.before = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3.prototype.after = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3.prototype.replaceWith = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3.prototype.remove = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, Object.defineProperty(t3.prototype, "assignedSlot", {
            get: function() {
              throw Error("Mixin: Slotable not implemented.");
            },
            enumerable: true,
            configurable: true
          }), t3._create = function(e15, n2, r2, a2) {
            r2 === void 0 && (r2 = null), a2 === void 0 && (a2 = null);
            var o2 = new t3();
            return o2._localName = n2, o2._namespace = r2, o2._namespacePrefix = a2, o2._nodeDocument = e15, o2;
          }, t3;
        }(l.NodeImpl);
        t2.ElementImpl = m, p.idl_defineConst(m.prototype, "_nodeType", c.NodeType.Element);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(2), s = n(34), c = n(12), l = function(e14) {
          function t3(t4) {
            t4 === void 0 && (t4 = null);
            var n2 = e14.call(this) || this;
            return n2._children = /* @__PURE__ */ new Set(), n2._host = t4, n2;
          }
          return a(t3, e14), t3.prototype.getElementById = function(e15) {
            throw Error("Mixin: NonElementParentNode not implemented.");
          }, Object.defineProperty(t3.prototype, "children", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "firstElementChild", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "lastElementChild", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "childElementCount", {
            get: function() {
              throw Error("Mixin: ParentNode not implemented.");
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.prepend = function() {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3.prototype.append = function() {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3.prototype.querySelector = function(e15) {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3.prototype.querySelectorAll = function(e15) {
            throw Error("Mixin: ParentNode not implemented.");
          }, t3._create = function(e15, n2) {
            n2 === void 0 && (n2 = null);
            var r2 = new t3(n2);
            return r2._nodeDocument = e15, r2;
          }, t3;
        }(s.NodeImpl);
        t2.DocumentFragmentImpl = l, c.idl_defineConst(l.prototype, "_nodeType", o.NodeType.DocumentFragment);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(2), c = n(71), l = n(0), u = n(12), d = function(e14) {
          function t3(t4) {
            t4 === void 0 && (t4 = "");
            var n2 = e14.call(this, t4) || this;
            return n2._name = "", n2._assignedSlot = null, n2;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "wholeText", {
            get: function() {
              var e15, t4, n2 = "";
              try {
                for (var r2 = o(l.text_contiguousTextNodes(this, true)), a2 = r2.next(); !a2.done; a2 = r2.next())
                  n2 += a2.value._data;
              } catch (t5) {
                e15 = { error: t5 };
              } finally {
                try {
                  a2 && !a2.done && (t4 = r2.return) && t4.call(r2);
                } finally {
                  if (e15)
                    throw e15.error;
                }
              }
              return n2;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.splitText = function(e15) {
            return l.text_split(this, e15);
          }, Object.defineProperty(t3.prototype, "assignedSlot", {
            get: function() {
              throw Error("Mixin: Slotable not implemented.");
            },
            enumerable: true,
            configurable: true
          }), t3._create = function(e15, n2) {
            n2 === void 0 && (n2 = "");
            var r2 = new t3(n2);
            return r2._nodeDocument = e15, r2;
          }, t3;
        }(c.CharacterDataImpl);
        t2.TextImpl = d, u.idl_defineConst(d.prototype, "_nodeType", s.NodeType.Text);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.AbstractRangeImpl = function() {
          function e14() {
          }
          return Object.defineProperty(e14.prototype, "_startNode", {
            get: function() {
              return this._start[0];
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "_startOffset", {
            get: function() {
              return this._start[1];
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "_endNode", {
            get: function() {
              return this._end[0];
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "_endOffset", {
            get: function() {
              return this._end[1];
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "_collapsed", {
            get: function() {
              return this._start[0] === this._end[0] && this._start[1] === this._end[1];
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "startContainer", {
            get: function() {
              return this._startNode;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "startOffset", {
            get: function() {
              return this._startOffset;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "endContainer", {
            get: function() {
              return this._endNode;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "endOffset", {
            get: function() {
              return this._endOffset;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "collapsed", {
            get: function() {
              return this._collapsed;
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(2);
        t2.TraverserImpl = function() {
          function e14(e15) {
            this._activeFlag = false, this._root = e15, this._whatToShow = r.WhatToShow.All, this._filter = null;
          }
          return Object.defineProperty(e14.prototype, "root", {
            get: function() {
              return this._root;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "whatToShow", {
            get: function() {
              return this._whatToShow;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "filter", {
            get: function() {
              return this._filter;
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(2), a = n(0), o = n(12), s = function() {
          function e14(e15, t3) {
            this._target = null, this._relatedTarget = null, this._touchTargetList = [], this._path = [], this._currentTarget = null, this._eventPhase = r.EventPhase.None, this._stopPropagationFlag = false, this._stopImmediatePropagationFlag = false, this._canceledFlag = false, this._inPassiveListenerFlag = false, this._composedFlag = false, this._initializedFlag = false, this._dispatchFlag = false, this._isTrusted = false, this._bubbles = false, this._cancelable = false, this._type = e15, t3 && (this._bubbles = t3.bubbles || false, this._cancelable = t3.cancelable || false, this._composedFlag = t3.composed || false), this._initializedFlag = true, this._timeStamp = (/* @__PURE__ */ new Date()).getTime();
          }
          return Object.defineProperty(e14.prototype, "type", {
            get: function() {
              return this._type;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "target", {
            get: function() {
              return this._target;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "srcElement", {
            get: function() {
              return this._target;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "currentTarget", {
            get: function() {
              return this._currentTarget;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.composedPath = function() {
            var e15 = [], t3 = this._path;
            if (t3.length === 0)
              return e15;
            var n2 = this._currentTarget;
            if (n2 === null)
              throw Error("Event currentTarget is null.");
            e15.push(n2);
            for (var r2 = 0, a2 = 0, o2 = t3.length - 1; o2 >= 0; ) {
              if (t3[o2].rootOfClosedTree && a2++, t3[o2].invocationTarget === n2) {
                r2 = o2;
                break;
              }
              t3[o2].slotInClosedTree && a2--, o2--;
            }
            var s2 = a2, c = a2;
            for (o2 = r2 - 1; o2 >= 0; )
              t3[o2].rootOfClosedTree && s2++, s2 <= c && e15.unshift(t3[o2].invocationTarget), t3[o2].slotInClosedTree && --s2 < c && (c = s2), o2--;
            for (s2 = a2, c = a2, o2 = r2 + 1; o2 < t3.length; )
              t3[o2].slotInClosedTree && s2++, s2 <= c && e15.push(t3[o2].invocationTarget), t3[o2].rootOfClosedTree && --s2 < c && (c = s2), o2++;
            return e15;
          }, Object.defineProperty(e14.prototype, "eventPhase", {
            get: function() {
              return this._eventPhase;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.stopPropagation = function() {
            this._stopPropagationFlag = true;
          }, Object.defineProperty(e14.prototype, "cancelBubble", {
            get: function() {
              return this._stopPropagationFlag;
            },
            set: function(e15) {
              e15 && this.stopPropagation();
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.stopImmediatePropagation = function() {
            this._stopPropagationFlag = true, this._stopImmediatePropagationFlag = true;
          }, Object.defineProperty(e14.prototype, "bubbles", {
            get: function() {
              return this._bubbles;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "cancelable", {
            get: function() {
              return this._cancelable;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "returnValue", {
            get: function() {
              return !this._canceledFlag;
            },
            set: function(e15) {
              e15 || a.event_setTheCanceledFlag(this);
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.preventDefault = function() {
            a.event_setTheCanceledFlag(this);
          }, Object.defineProperty(e14.prototype, "defaultPrevented", {
            get: function() {
              return this._canceledFlag;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "composed", {
            get: function() {
              return this._composedFlag;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "isTrusted", {
            get: function() {
              return this._isTrusted;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "timeStamp", {
            get: function() {
              return this._timeStamp;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.initEvent = function(e15, t3, n2) {
            t3 === void 0 && (t3 = false), n2 === void 0 && (n2 = false), this._dispatchFlag || a.event_initialize(this, e15, t3, n2);
          }, e14.NONE = 0, e14.CAPTURING_PHASE = 1, e14.AT_TARGET = 2, e14.BUBBLING_PHASE = 3, e14;
        }();
        t2.EventImpl = s, o.idl_defineConst(s.prototype, "NONE", 0), o.idl_defineConst(s.prototype, "CAPTURING_PHASE", 1), o.idl_defineConst(s.prototype, "AT_TARGET", 2), o.idl_defineConst(s.prototype, "BUBBLING_PHASE", 3);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(2), a = n(9);
        t2.traversal_filter = function(e14, t3) {
          if (e14._activeFlag)
            throw new a.InvalidStateError();
          var n2 = 1 << t3._nodeType - 1;
          if ((e14.whatToShow & n2) == 0)
            return r.FilterResult.Skip;
          if (!e14.filter)
            return r.FilterResult.Accept;
          e14._activeFlag = true;
          var o = r.FilterResult.Reject;
          try {
            o = e14.filter.acceptNode(t3);
          } catch (t4) {
            throw e14._activeFlag = false, t4;
          }
          return e14._activeFlag = false, o;
        };
      },
      function(e13, t2, n) {
        var r = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, a = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(6), s = n(3), c = n(1), l = n(99), u = n(73), d = n(17), f = n(173), p = n(30), m = n(52), h = n(37);
        t2.document_elementInterface = function(e14, t3) {
          return l.ElementImpl;
        }, t2.document_internalCreateElementNS = function(e14, t3, n2, a2) {
          var o2 = r(f.namespace_validateAndExtract(t3, n2), 3), s2 = o2[0], l2 = o2[1], u2 = o2[2], d2 = null;
          return a2 !== void 0 && (d2 = c.isString(a2) ? a2 : a2.is), m.element_createAnElement(e14, u2, s2, l2, d2, true);
        }, t2.document_adopt = function(e14, t3) {
          var n2, r2;
          if (e14._nodeDocument !== t3 || e14._parent !== null) {
            var c2 = e14._nodeDocument;
            if (e14._parent && h.mutation_remove(e14, e14._parent), t3 !== c2)
              for (var l2 = d.tree_getFirstDescendantNode(e14, true, true); l2 !== null; ) {
                if (l2._nodeDocument = t3, s.Guard.isElementNode(l2))
                  try {
                    for (var f2 = (n2 = void 0, a(l2._attributeList._asArray())), m2 = f2.next(); !m2.done; m2 = f2.next())
                      m2.value._nodeDocument = t3;
                  } catch (e15) {
                    n2 = { error: e15 };
                  } finally {
                    try {
                      m2 && !m2.done && (r2 = f2.return) && r2.call(f2);
                    } finally {
                      if (n2)
                        throw n2.error;
                    }
                  }
                o.dom.features.customElements && s.Guard.isElementNode(l2) && l2._customElementState === "custom" && u.customElement_enqueueACustomElementCallbackReaction(l2, "adoptedCallback", [c2, t3]), o.dom.features.steps && p.dom_runAdoptingSteps(l2, c2), l2 = d.tree_getNextDescendantNode(e14, l2, true, true);
              }
          }
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(6), o = n(3), s = n(9), c = n(17), l = n(51), u = n(30);
        t2.characterData_replaceData = function(e14, t3, n2, d) {
          var f, p, m = c.tree_nodeLength(e14);
          if (t3 > m)
            throw new s.IndexSizeError("Offset exceeds character data length. Offset: " + t3 + ", Length: " + m + ", Node is " + e14.nodeName + ".");
          t3 + n2 > m && (n2 = m - t3), a.dom.features.mutationObservers && l.observer_queueMutationRecord("characterData", e14, null, null, e14._data, [], [], null, null), e14._data = e14._data.substring(0, t3) + d + e14._data.substring(t3 + n2);
          try {
            for (var h = r(a.dom.rangeList), g = h.next(); !g.done; g = h.next()) {
              var _ = g.value;
              _._start[0] === e14 && _._start[1] > t3 && _._start[1] <= t3 + n2 && (_._start[1] = t3), _._end[0] === e14 && _._end[1] > t3 && _._end[1] <= t3 + n2 && (_._end[1] = t3), _._start[0] === e14 && _._start[1] > t3 + n2 && (_._start[1] += d.length - n2), _._end[0] === e14 && _._end[1] > t3 + n2 && (_._end[1] += d.length - n2);
            }
          } catch (e15) {
            f = { error: e15 };
          } finally {
            try {
              g && !g.done && (p = h.return) && p.call(h);
            } finally {
              if (f)
                throw f.error;
            }
          }
          a.dom.features.steps && o.Guard.isTextNode(e14) && e14._parent !== null && u.dom_runChildTextContentChangeSteps(e14._parent);
        }, t2.characterData_substringData = function(e14, t3, n2) {
          var r2 = c.tree_nodeLength(e14);
          if (t3 > r2)
            throw new s.IndexSizeError("Offset exceeds character data length. Offset: " + t3 + ", Length: " + r2 + ", Node is " + e14.nodeName + ".");
          return t3 + n2 > r2 ? e14._data.substr(t3) : e14._data.substr(t3, n2);
        };
      },
      function(e13, t2, n) {
        var r = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, a = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(r(arguments[t3]));
          return e14;
        }, o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(7);
        function c(e14) {
          var t3 = s.string.splitAStringOnASCIIWhitespace(e14);
          return new Set(t3);
        }
        function l(e14) {
          return a(e14).join(" ");
        }
        t2.orderedSet_parse = c, t2.orderedSet_serialize = l, t2.orderedSet_sanitize = function(e14) {
          return l(c(e14));
        }, t2.orderedSet_contains = function(e14, t3, n2) {
          var r2, a2, s2, c2;
          try {
            for (var l2 = o(t3), u = l2.next(); !u.done; u = l2.next()) {
              var d = u.value, f = false;
              try {
                for (var p = (s2 = void 0, o(e14)), m = p.next(); !m.done; m = p.next()) {
                  var h = m.value;
                  if (n2) {
                    if (h === d) {
                      f = true;
                      break;
                    }
                  } else if (h.toUpperCase() === d.toUpperCase()) {
                    f = true;
                    break;
                  }
                }
              } catch (e15) {
                s2 = { error: e15 };
              } finally {
                try {
                  m && !m.done && (c2 = p.return) && c2.call(p);
                } finally {
                  if (s2)
                    throw s2.error;
                }
              }
              if (!f)
                return false;
            }
          } catch (e15) {
            r2 = { error: e15 };
          } finally {
            try {
              u && !u.done && (a2 = l2.return) && a2.call(l2);
            } finally {
              if (r2)
                throw r2.error;
            }
          }
          return true;
        };
      },
      function(e13, t2, n) {
        n(179), Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(262), a = n(110), o = n(1);
        a.dom.setFeatures(false), t2.createDocument = function() {
          var e14 = new r.DOMImplementation().createDocument(null, "root", null);
          return e14.documentElement && e14.removeChild(e14.documentElement), e14;
        }, t2.sanitizeInput = function(e14, t3) {
          if (e14 == null)
            return e14;
          if (t3 === void 0)
            return e14 + "";
          var n2 = "";
          e14 += "";
          for (var r2 = 0; r2 < e14.length; r2++) {
            var a2 = e14.charCodeAt(r2);
            if (a2 === 9 || a2 === 10 || a2 === 13 || a2 >= 32 && a2 <= 55295 || a2 >= 57344 && a2 <= 65533)
              n2 += e14.charAt(r2);
            else if (a2 >= 55296 && a2 <= 56319 && r2 < e14.length - 1) {
              var s = e14.charCodeAt(r2 + 1);
              s >= 56320 && s <= 57343 ? (a2 = 1024 * (a2 - 55296) + s - 56320 + 65536, n2 += String.fromCodePoint(a2), r2++) : n2 += o.isString(t3) ? t3 : t3(e14.charAt(r2), r2, e14);
            } else
              n2 += o.isString(t3) ? t3 : t3(e14.charAt(r2), r2, e14);
          }
          return n2;
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(1);
        t2.AbortController = n(153).AbortControllerImpl, t2.AbortSignal = n(154).AbortSignalImpl, t2.AbstractRange = n(102).AbstractRangeImpl, t2.Attr = n(157).AttrImpl, t2.CDATASection = n(158).CDATASectionImpl;
        var a = n(71);
        t2.CharacterData = a.CharacterDataImpl;
        var o = n(263);
        t2.Comment = n(159).CommentImpl, t2.CustomEvent = n(171).CustomEventImpl;
        var s = n(100);
        t2.DocumentFragment = s.DocumentFragmentImpl;
        var c = n(98);
        t2.Document = c.DocumentImpl;
        var l = n(264), u = n(155);
        t2.DocumentType = u.DocumentTypeImpl, t2.dom = n(6).dom, t2.DOMImplementation = n(148).DOMImplementationImpl, t2.DOMTokenList = n(170).DOMTokenListImpl;
        var d = n(99);
        t2.Element = d.ElementImpl, t2.Event = n(104).EventImpl, t2.EventTarget = n(70).EventTargetImpl, t2.HTMLCollection = n(161).HTMLCollectionImpl, t2.MutationObserver = n(265).MutationObserverImpl, t2.MutationRecord = n(169).MutationRecordImpl, t2.NamedNodeMap = n(164).NamedNodeMapImpl, t2.NodeFilter = n(168).NodeFilterImpl, t2.Node = n(34).NodeImpl, t2.NodeIterator = n(166).NodeIteratorImpl, t2.NodeList = n(162).NodeListImpl, t2.NodeListStatic = n(163).NodeListStaticImpl;
        var f = n(266), p = n(267), m = n(268);
        t2.ProcessingInstruction = n(160).ProcessingInstructionImpl, t2.Range = n(165).RangeImpl;
        var h = n(156);
        t2.ShadowRoot = h.ShadowRootImpl;
        var g = n(269);
        t2.StaticRange = n(270).StaticRangeImpl;
        var _ = n(101);
        t2.Text = _.TextImpl, t2.Traverser = n(103).TraverserImpl, t2.TreeWalker = n(167).TreeWalkerImpl, t2.Window = n(149).WindowImpl, t2.XMLDocument = n(151).XMLDocumentImpl, r.applyMixin(d.ElementImpl, o.ChildNodeImpl), r.applyMixin(a.CharacterDataImpl, o.ChildNodeImpl), r.applyMixin(u.DocumentTypeImpl, o.ChildNodeImpl), r.applyMixin(c.DocumentImpl, l.DocumentOrShadowRootImpl), r.applyMixin(h.ShadowRootImpl, l.DocumentOrShadowRootImpl), r.applyMixin(d.ElementImpl, f.NonDocumentTypeChildNodeImpl), r.applyMixin(a.CharacterDataImpl, f.NonDocumentTypeChildNodeImpl), r.applyMixin(c.DocumentImpl, p.NonElementParentNodeImpl), r.applyMixin(s.DocumentFragmentImpl, p.NonElementParentNodeImpl), r.applyMixin(c.DocumentImpl, m.ParentNodeImpl), r.applyMixin(s.DocumentFragmentImpl, m.ParentNodeImpl), r.applyMixin(d.ElementImpl, m.ParentNodeImpl), r.applyMixin(_.TextImpl, g.SlotableImpl), r.applyMixin(d.ElementImpl, g.SlotableImpl);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), function(e14) {
          e14[e14.EOF = 0] = "EOF", e14[e14.Declaration = 1] = "Declaration", e14[e14.DocType = 2] = "DocType", e14[e14.Element = 3] = "Element", e14[e14.Text = 4] = "Text", e14[e14.CDATA = 5] = "CDATA", e14[e14.PI = 6] = "PI", e14[e14.Comment = 7] = "Comment", e14[e14.ClosingTag = 8] = "ClosingTag";
        }(t2.TokenType ||= {});
      },
      function(e13, t2, n) {
        n(64), n(20), n(66);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(1);
        t2.ObjectReader = function(e14) {
          function t3() {
            return e14 !== null && e14.apply(this, arguments) || this;
          }
          return a(t3, e14), t3.prototype._parse = function(e15, t4) {
            var n2 = this, r2 = this._builderOptions, a2 = null;
            return o.isFunction(t4) ? a2 = this.parse(e15, t4.apply(this)) : o.isArray(t4) || o.isSet(t4) ? o.forEachArray(t4, function(t5) {
              return a2 = n2.parse(e15, t5);
            }, this) : o.isMap(t4) || o.isObject(t4) ? o.forEachObject(t4, function(t5, s) {
              if (o.isFunction(s) && (s = s.apply(n2)), r2.ignoreConverters || t5.indexOf(r2.convert.att) !== 0)
                if (r2.ignoreConverters || t5.indexOf(r2.convert.text) !== 0)
                  if (r2.ignoreConverters || t5.indexOf(r2.convert.cdata) !== 0)
                    if (r2.ignoreConverters || t5.indexOf(r2.convert.comment) !== 0)
                      if (r2.ignoreConverters || t5.indexOf(r2.convert.ins) !== 0) {
                        if (!((o.isArray(s) || o.isSet(s)) && o.isEmpty(s))) {
                          if ((o.isMap(s) || o.isObject(s)) && o.isEmpty(s))
                            a2 = n2.element(e15, void 0, n2.sanitize(t5)) || a2;
                          else if (r2.keepNullNodes || s != null)
                            if (o.isArray(s) || o.isSet(s))
                              o.forEachArray(s, function(r3) {
                                var o2 = {};
                                o2[t5] = r3, a2 = n2.parse(e15, o2);
                              }, n2);
                            else if (o.isMap(s) || o.isObject(s))
                              (c = n2.element(e15, void 0, n2.sanitize(t5))) && (a2 = c, n2.parse(c, s));
                            else if (s != null && s !== "") {
                              var c;
                              (c = n2.element(e15, void 0, n2.sanitize(t5))) && (a2 = c, n2.text(c, n2._decodeText(n2.sanitize(s))));
                            } else
                              a2 = n2.element(e15, void 0, n2.sanitize(t5)) || a2;
                        }
                      } else if (o.isString(s)) {
                        var l = s.indexOf(" "), u = l === -1 ? s : s.substr(0, l), d = l === -1 ? "" : s.substr(l + 1);
                        a2 = n2.instruction(e15, n2.sanitize(u), n2.sanitize(d)) || a2;
                      } else
                        o.isArray(s) || o.isSet(s) ? o.forEachArray(s, function(t6) {
                          var r3 = t6.indexOf(" "), o2 = r3 === -1 ? t6 : t6.substr(0, r3), s2 = r3 === -1 ? "" : t6.substr(r3 + 1);
                          a2 = n2.instruction(e15, n2.sanitize(o2), n2.sanitize(s2)) || a2;
                        }, n2) : o.forEachObject(s, function(t6, r3) {
                          return a2 = n2.instruction(e15, n2.sanitize(t6), n2.sanitize(r3)) || a2;
                        }, n2);
                    else
                      o.isArray(s) || o.isSet(s) ? o.forEachArray(s, function(t6) {
                        return a2 = n2.comment(e15, n2.sanitize(t6)) || a2;
                      }, n2) : a2 = n2.comment(e15, n2.sanitize(s)) || a2;
                  else
                    o.isArray(s) || o.isSet(s) ? o.forEachArray(s, function(t6) {
                      return a2 = n2.cdata(e15, n2.sanitize(t6)) || a2;
                    }, n2) : a2 = n2.cdata(e15, n2.sanitize(s)) || a2;
                else
                  a2 = o.isMap(s) || o.isObject(s) ? n2.parse(e15, s) : n2.text(e15, n2._decodeText(n2.sanitize(s))) || a2;
              else if (t5 === r2.convert.att) {
                if (o.isArray(s) || o.isSet(s))
                  throw Error("Invalid attribute: " + s.toString() + ". " + e15._debugInfo());
                o.forEachObject(s, function(t6, r3) {
                  a2 = n2.attribute(e15, void 0, n2.sanitize(t6), n2._decodeAttributeValue(n2.sanitize(r3))) || a2;
                });
              } else
                a2 = n2.attribute(e15, void 0, n2.sanitize(t5.substr(r2.convert.att.length)), n2._decodeAttributeValue(n2.sanitize(s))) || a2;
            }, this) : (r2.keepNullNodes || t4 != null) && (a2 = this.text(e15, this._decodeText(this.sanitize(t4))) || a2), a2 || e15;
          }, t3;
        }(n(75).BaseReader);
      },
      function(e13, t2, n) {
        e13.exports = new (n(39))({ explicit: [
          n(286),
          n(287),
          n(288)
        ] });
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.BaseCBWriter = function(e14) {
          this.level = 0, this._builderOptions = e14, this._writerOptions = e14;
        };
      },
      function(e13, t2, n) {
        var r = n(16), a = n(8), o = n(116);
        e13.exports = !r && !a(function() {
          return Object.defineProperty(o("div"), "a", { get: function() {
            return 7;
          } }).a != 7;
        });
      },
      function(e13, t2, n) {
        var r = n(11), a = n(13), o = r.document, s = a(o) && a(o.createElement);
        e13.exports = function(e14) {
          return s ? o.createElement(e14) : {};
        };
      },
      function(e13, t2, n) {
        var r = n(118), a = Function.toString;
        typeof r.inspectSource != "function" && (r.inspectSource = function(e14) {
          return a.call(e14);
        }), e13.exports = r.inspectSource;
      },
      function(e13, t2, n) {
        var r = n(11), a = n(80);
        e13.exports = r["__core-js_shared__"] || a("__core-js_shared__", {});
      },
      function(e13, t2, n) {
        var r = n(14), a = n(187), o = n(55), s = n(15);
        e13.exports = function(e14, t3) {
          for (var n2 = a(t3), c = s.f, l = o.f, u = 0; u < n2.length; u++) {
            var d = n2[u];
            r(e14, d) || c(e14, d, l(t3, d));
          }
        };
      },
      function(e13, t2, n) {
        e13.exports = n(11);
      },
      function(e13, t2, n) {
        var r = n(14), a = n(24), o = n(122).indexOf, s = n(45);
        e13.exports = function(e14, t3) {
          var n2, c = a(e14), l = 0, u = [];
          for (n2 in c)
            !r(s, n2) && r(c, n2) && u.push(n2);
          for (; t3.length > l; )
            r(c, n2 = t3[l++]) && (~o(u, n2) || u.push(n2));
          return u;
        };
      },
      function(e13, t2, n) {
        var r = n(24), a = n(26), o = n(83), s = function(e14) {
          return function(t3, n2, s2) {
            var c, l = r(t3), u = a(l.length), d = o(s2, u);
            if (e14 && n2 != n2) {
              for (; u > d; )
                if ((c = l[d++]) != c)
                  return true;
            } else
              for (; u > d; d++)
                if ((e14 || d in l) && l[d] === n2)
                  return e14 || d || 0;
            return !e14 && -1;
          };
        };
        e13.exports = {
          includes: s(true),
          indexOf: s(false)
        };
      },
      function(e13, t2, n) {
        var r = n(8), a = /#|\.prototype\./, o = function(e14, t3) {
          var n2 = c[s(e14)];
          return n2 == u || n2 != l && (typeof t3 == "function" ? r(t3) : !!t3);
        }, s = o.normalize = function(e14) {
          return String(e14).replace(a, ".").toLowerCase();
        }, c = o.data = {}, l = o.NATIVE = "N", u = o.POLYFILL = "P";
        e13.exports = o;
      },
      function(e13, t2, n) {
        e13.exports = n(86) && !Symbol.sham && typeof Symbol.iterator == "symbol";
      },
      function(e13, t2, n) {
        t2.f = n(5);
      },
      function(e13, t2, n) {
        var r = n(120), a = n(14), o = n(125), s = n(15).f;
        e13.exports = function(e14) {
          var t3 = r.Symbol ||= {};
          a(t3, e14) || s(t3, e14, { value: o.f(e14) });
        };
      },
      function(e13, t2) {
        e13.exports = function(e14) {
          if (typeof e14 != "function")
            throw TypeError(String(e14) + " is not a function");
          return e14;
        };
      },
      function(e13, t2, n) {
        var r = n(13), a = n(59), o = n(5)("species");
        e13.exports = function(e14, t3) {
          var n2;
          return a(e14) && (typeof (n2 = e14.constructor) != "function" || n2 !== Array && !a(n2.prototype) ? r(n2) && (n2 = n2[o]) === null && (n2 = void 0) : n2 = void 0), new (n2 === void 0 ? Array : n2)(t3 === 0 ? 0 : t3);
        };
      },
      function(e13, t2, n) {
        var r, a, o = n(11), s = n(193), c = o.process, l = c && c.versions, u = l && l.v8;
        u ? a = (r = u.split("."))[0] + r[1] : s && (!(r = s.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = s.match(/Chrome\/(\d+)/)) && (a = r[1]), e13.exports = a && +a;
      },
      function(e13, t2, n) {
        var r = n(5), a = n(60), o = n(15), s = r("unscopables"), c = Array.prototype;
        c[s] ?? o.f(c, s, {
          configurable: true,
          value: a(null)
        }), e13.exports = function(e14) {
          c[s][e14] = true;
        };
      },
      function(e13, t2, n) {
        var r, a, o, s = n(132), c = n(21), l = n(14), u = n(5), d = n(44), f = u("iterator"), p = false;
        [].keys && ("next" in (o = [].keys()) ? (a = s(s(o))) !== Object.prototype && (r = a) : p = true), r ??= {}, d || l(r, f) || c(r, f, function() {
          return this;
        }), e13.exports = {
          IteratorPrototype: r,
          BUGGY_SAFARI_ITERATORS: p
        };
      },
      function(e13, t2, n) {
        var r = n(14), a = n(27), o = n(57), s = n(196), c = o("IE_PROTO"), l = Object.prototype;
        e13.exports = s ? Object.getPrototypeOf : function(e14) {
          return e14 = a(e14), r(e14, c) ? e14[c] : typeof e14.constructor == "function" && e14 instanceof e14.constructor ? e14.constructor.prototype : e14 instanceof Object ? l : null;
        };
      },
      function(e13, t2, n) {
        var r = n(18), a = n(197);
        e13.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
          var e14, t3 = false, n2 = {};
          try {
            (e14 = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(n2, []), t3 = n2 instanceof Array;
          } catch {
          }
          return function(n3, o) {
            return r(n3), a(o), t3 ? e14.call(n3, o) : n3.__proto__ = o, n3;
          };
        }() : void 0);
      },
      function(e13, t2, n) {
        var r = n(56), a = n(15), o = n(40);
        e13.exports = function(e14, t3, n2) {
          var s = r(t3);
          s in e14 ? a.f(e14, s, o(0, n2)) : e14[s] = n2;
        };
      },
      function(e13, t2, n) {
        var r = n(90), a = n(42), o = n(5)("toStringTag"), s = a(function() {
          return arguments;
        }()) == "Arguments";
        e13.exports = r ? a : function(e14) {
          var t3, n2, r2;
          return e14 === void 0 ? "Undefined" : e14 === null ? "Null" : typeof (n2 = function(e15, t4) {
            try {
              return e15[t4];
            } catch {
            }
          }(t3 = Object(e14), o)) == "string" ? n2 : s ? a(t3) : (r2 = a(t3)) == "Object" && typeof t3.callee == "function" ? "Arguments" : r2;
        };
      },
      function(e13, t2, n) {
        var r = n(18);
        e13.exports = function() {
          var e14 = r(this), t3 = "";
          return e14.global && (t3 += "g"), e14.ignoreCase && (t3 += "i"), e14.multiline && (t3 += "m"), e14.dotAll && (t3 += "s"), e14.unicode && (t3 += "u"), e14.sticky && (t3 += "y"), t3;
        };
      },
      function(e13, t2, n) {
        var r = n(47), a = n(35), o = function(e14) {
          return function(t3, n2) {
            var o2, s, c = String(a(t3)), l = r(n2), u = c.length;
            return l < 0 || l >= u ? e14 ? "" : void 0 : (o2 = c.charCodeAt(l)) < 55296 || o2 > 56319 || l + 1 === u || (s = c.charCodeAt(l + 1)) < 56320 || s > 57343 ? e14 ? c.charAt(l) : o2 : e14 ? c.slice(l, l + 2) : s - 56320 + (o2 - 55296 << 10) + 65536;
          };
        };
        e13.exports = {
          codeAt: o(false),
          charAt: o(true)
        };
      },
      function(e13, t2, n) {
        var r = n(4), a = n(27), o = n(61);
        r({
          target: "Object",
          stat: true,
          forced: n(8)(function() {
            o(1);
          })
        }, { keys: function(e14) {
          return o(a(e14));
        } });
      },
      function(e13, t2, n) {
        var r = n(4), a = n(11), o = n(123), s = n(25), c = n(140), l = n(141), u = n(142), d = n(13), f = n(8), p = n(208), m = n(62), h = n(209);
        e13.exports = function(e14, t3, n2) {
          var g = e14.indexOf("Map") !== -1, _ = e14.indexOf("Weak") !== -1, v = g ? "set" : "add", y = a[e14], b = y && y.prototype, S = y, C = {}, w = function(e15) {
            var t4 = b[e15];
            s(b, e15, e15 == "add" ? function(e16) {
              return t4.call(this, e16 === 0 ? 0 : e16), this;
            } : e15 == "delete" ? function(e16) {
              return !(_ && !d(e16)) && t4.call(this, e16 === 0 ? 0 : e16);
            } : e15 == "get" ? function(e16) {
              return _ && !d(e16) ? void 0 : t4.call(this, e16 === 0 ? 0 : e16);
            } : e15 == "has" ? function(e16) {
              return !(_ && !d(e16)) && t4.call(this, e16 === 0 ? 0 : e16);
            } : function(e16, n3) {
              return t4.call(this, e16 === 0 ? 0 : e16, n3), this;
            });
          };
          if (o(e14, typeof y != "function" || !(_ || b.forEach && !f(function() {
            new y().entries().next();
          }))))
            S = n2.getConstructor(t3, e14, g, v), c.REQUIRED = true;
          else if (o(e14, true)) {
            var T = new S(), E = T[v](_ ? {} : -0, 1) != T, D = f(function() {
              T.has(1);
            }), O = p(function(e15) {
              new y(e15);
            }), k = !_ && f(function() {
              for (var e15 = new y(), t4 = 5; t4--; )
                e15[v](t4, t4);
              return !e15.has(-0);
            });
            O || ((S = t3(function(t4, n3) {
              u(t4, S, e14);
              var r2 = h(new y(), t4, S);
              return n3 != null && l(n3, r2[v], r2, g), r2;
            })).prototype = b, b.constructor = S), (D || k) && (w("delete"), w("has"), g && w("get")), (k || E) && w(v), _ && b.clear && delete b.clear;
          }
          return C[e14] = S, r({
            global: true,
            forced: S != y
          }, C), m(S, e14), _ || n2.setStrong(S, e14, g), S;
        };
      },
      function(e13, t2, n) {
        var r = n(45), a = n(13), o = n(14), s = n(15).f, c = n(58), l = n(204), u = c("meta"), d = 0, f = Object.isExtensible || function() {
          return true;
        }, p = function(e14) {
          s(e14, u, { value: {
            objectID: "O" + ++d,
            weakData: {}
          } });
        }, m = e13.exports = {
          REQUIRED: false,
          fastKey: function(e14, t3) {
            if (!a(e14))
              return typeof e14 == "symbol" ? e14 : (typeof e14 == "string" ? "S" : "P") + e14;
            if (!o(e14, u)) {
              if (!f(e14))
                return "F";
              if (!t3)
                return "E";
              p(e14);
            }
            return e14[u].objectID;
          },
          getWeakData: function(e14, t3) {
            if (!o(e14, u)) {
              if (!f(e14))
                return true;
              if (!t3)
                return false;
              p(e14);
            }
            return e14[u].weakData;
          },
          onFreeze: function(e14) {
            return l && m.REQUIRED && f(e14) && !o(e14, u) && p(e14), e14;
          }
        };
        r[u] = true;
      },
      function(e13, t2, n) {
        var r = n(18), a = n(205), o = n(26), s = n(87), c = n(206), l = n(207), u = function(e14, t3) {
          this.stopped = e14, this.result = t3;
        };
        (e13.exports = function(e14, t3, n2, d, f) {
          var p, m, h, g, _, v, y, b = s(t3, n2, d ? 2 : 1);
          if (f)
            p = e14;
          else {
            if (typeof (m = c(e14)) != "function")
              throw TypeError("Target is not iterable");
            if (a(m)) {
              for (h = 0, g = o(e14.length); g > h; h++)
                if ((_ = d ? b(r(y = e14[h])[0], y[1]) : b(e14[h])) && _ instanceof u)
                  return _;
              return new u(false);
            }
            p = m.call(e14);
          }
          for (v = p.next; !(y = v.call(p)).done; )
            if (typeof (_ = l(p, b, y.value, d)) == "object" && _ && _ instanceof u)
              return _;
          return new u(false);
        }).stop = function(e14) {
          return new u(true, e14);
        };
      },
      function(e13, t2) {
        e13.exports = function(e14, t3, n) {
          if (!(e14 instanceof t3))
            throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
          return e14;
        };
      },
      function(e13, t2, n) {
        var r = n(15).f, a = n(60), o = n(210), s = n(87), c = n(142), l = n(141), u = n(88), d = n(211), f = n(16), p = n(140).fastKey, m = n(43), h = m.set, g = m.getterFor;
        e13.exports = {
          getConstructor: function(e14, t3, n2, u2) {
            var d2 = e14(function(e15, r2) {
              c(e15, d2, t3), h(e15, {
                type: t3,
                index: a(null),
                first: void 0,
                last: void 0,
                size: 0
              }), f || (e15.size = 0), r2 != null && l(r2, e15[u2], e15, n2);
            }), m2 = g(t3), _ = function(e15, t4, n3) {
              var r2, a2, o2 = m2(e15), s2 = v(e15, t4);
              return s2 ? s2.value = n3 : (o2.last = s2 = {
                index: a2 = p(t4, true),
                key: t4,
                value: n3,
                previous: r2 = o2.last,
                next: void 0,
                removed: false
              }, o2.first ||= s2, r2 && (r2.next = s2), f ? o2.size++ : e15.size++, a2 !== "F" && (o2.index[a2] = s2)), e15;
            }, v = function(e15, t4) {
              var n3, r2 = m2(e15), a2 = p(t4);
              if (a2 !== "F")
                return r2.index[a2];
              for (n3 = r2.first; n3; n3 = n3.next)
                if (n3.key == t4)
                  return n3;
            };
            return o(d2.prototype, {
              clear: function() {
                for (var e15 = m2(this), t4 = e15.index, n3 = e15.first; n3; )
                  n3.removed = true, n3.previous &&= n3.previous.next = void 0, delete t4[n3.index], n3 = n3.next;
                e15.first = e15.last = void 0, f ? e15.size = 0 : this.size = 0;
              },
              delete: function(e15) {
                var t4 = m2(this), n3 = v(this, e15);
                if (n3) {
                  var r2 = n3.next, a2 = n3.previous;
                  delete t4.index[n3.index], n3.removed = true, a2 && (a2.next = r2), r2 && (r2.previous = a2), t4.first == n3 && (t4.first = r2), t4.last == n3 && (t4.last = a2), f ? t4.size-- : this.size--;
                }
                return !!n3;
              },
              forEach: function(e15) {
                for (var t4, n3 = m2(this), r2 = s(e15, arguments.length > 1 ? arguments[1] : void 0, 3); t4 = t4 ? t4.next : n3.first; )
                  for (r2(t4.value, t4.key, this); t4 && t4.removed; )
                    t4 = t4.previous;
              },
              has: function(e15) {
                return !!v(this, e15);
              }
            }), o(d2.prototype, n2 ? {
              get: function(e15) {
                var t4 = v(this, e15);
                return t4 && t4.value;
              },
              set: function(e15, t4) {
                return _(this, e15 === 0 ? 0 : e15, t4);
              }
            } : { add: function(e15) {
              return _(this, e15 = e15 === 0 ? 0 : e15, e15);
            } }), f && r(d2.prototype, "size", { get: function() {
              return m2(this).size;
            } }), d2;
          },
          setStrong: function(e14, t3, n2) {
            var r2 = t3 + " Iterator", a2 = g(t3), o2 = g(r2);
            u(e14, t3, function(e15, t4) {
              h(this, {
                type: r2,
                target: e15,
                state: a2(e15),
                kind: t4,
                last: void 0
              });
            }, function() {
              for (var e15 = o2(this), t4 = e15.kind, n3 = e15.last; n3 && n3.removed; )
                n3 = n3.previous;
              return e15.target && (e15.last = n3 = n3 ? n3.next : e15.state.first) ? t4 == "keys" ? {
                value: n3.key,
                done: false
              } : t4 == "values" ? {
                value: n3.value,
                done: false
              } : {
                value: [n3.key, n3.value],
                done: false
              } : (e15.target = void 0, {
                value: void 0,
                done: true
              });
            }, n2 ? "entries" : "values", !n2, true), d(t3);
          }
        };
      },
      function(e13, t2, n) {
        var r, a = n(4), o = n(55).f, s = n(26), c = n(222), l = n(35), u = n(224), d = n(44), f = "".endsWith, p = Math.min, m = u("endsWith");
        a({
          target: "String",
          proto: true,
          forced: !!(d || m || (r = o(String.prototype, "endsWith"), !r || r.writable)) && !m
        }, { endsWith: function(e14) {
          var t3 = String(l(this));
          c(e14);
          var n2 = arguments.length > 1 ? arguments[1] : void 0, r2 = s(t3.length), a2 = n2 === void 0 ? r2 : p(s(n2), r2), o2 = String(e14);
          return f ? f.call(t3, o2, a2) : t3.slice(a2 - o2.length, a2) === o2;
        } });
      },
      function(e13, t2, n) {
        (function(e14) {
          var r = n(229), a = n(230), o = n(231);
          function s() {
            return l.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
          }
          function c(e15, t3) {
            if (s() < t3)
              throw RangeError("Invalid typed array length");
            return l.TYPED_ARRAY_SUPPORT ? (e15 = new Uint8Array(t3)).__proto__ = l.prototype : (e15 === null && (e15 = new l(t3)), e15.length = t3), e15;
          }
          function l(e15, t3, n2) {
            if (!(l.TYPED_ARRAY_SUPPORT || this instanceof l))
              return new l(e15, t3, n2);
            if (typeof e15 == "number") {
              if (typeof t3 == "string")
                throw Error("If encoding is specified then the first argument must be a string");
              return f(this, e15);
            }
            return u(this, e15, t3, n2);
          }
          function u(e15, t3, n2, r2) {
            if (typeof t3 == "number")
              throw TypeError('"value" argument must not be a number');
            return typeof ArrayBuffer < "u" && t3 instanceof ArrayBuffer ? function(e16, t4, n3, r3) {
              if (t4.byteLength, n3 < 0 || t4.byteLength < n3)
                throw RangeError("'offset' is out of bounds");
              if (t4.byteLength < n3 + (r3 || 0))
                throw RangeError("'length' is out of bounds");
              return t4 = n3 === void 0 && r3 === void 0 ? new Uint8Array(t4) : r3 === void 0 ? new Uint8Array(t4, n3) : new Uint8Array(t4, n3, r3), l.TYPED_ARRAY_SUPPORT ? (e16 = t4).__proto__ = l.prototype : e16 = p(e16, t4), e16;
            }(e15, t3, n2, r2) : typeof t3 == "string" ? function(e16, t4, n3) {
              if (typeof n3 == "string" && n3 !== "" || (n3 = "utf8"), !l.isEncoding(n3))
                throw TypeError('"encoding" must be a valid string encoding');
              var r3 = 0 | h(t4, n3), a2 = (e16 = c(e16, r3)).write(t4, n3);
              return a2 !== r3 && (e16 = e16.slice(0, a2)), e16;
            }(e15, t3, n2) : function(e16, t4) {
              if (l.isBuffer(t4)) {
                var n3 = 0 | m(t4.length);
                return (e16 = c(e16, n3)).length === 0 || t4.copy(e16, 0, 0, n3), e16;
              }
              if (t4) {
                if (typeof ArrayBuffer < "u" && t4.buffer instanceof ArrayBuffer || "length" in t4)
                  return typeof t4.length != "number" || (r3 = t4.length) != r3 ? c(e16, 0) : p(e16, t4);
                if (t4.type === "Buffer" && o(t4.data))
                  return p(e16, t4.data);
              }
              var r3;
              throw TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
            }(e15, t3);
          }
          function d(e15) {
            if (typeof e15 != "number")
              throw TypeError('"size" argument must be a number');
            if (e15 < 0)
              throw RangeError('"size" argument must not be negative');
          }
          function f(e15, t3) {
            if (d(t3), e15 = c(e15, t3 < 0 ? 0 : 0 | m(t3)), !l.TYPED_ARRAY_SUPPORT)
              for (var n2 = 0; n2 < t3; ++n2)
                e15[n2] = 0;
            return e15;
          }
          function p(e15, t3) {
            var n2 = t3.length < 0 ? 0 : 0 | m(t3.length);
            e15 = c(e15, n2);
            for (var r2 = 0; r2 < n2; r2 += 1)
              e15[r2] = 255 & t3[r2];
            return e15;
          }
          function m(e15) {
            if (e15 >= s())
              throw RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
            return 0 | e15;
          }
          function h(e15, t3) {
            if (l.isBuffer(e15))
              return e15.length;
            if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e15) || e15 instanceof ArrayBuffer))
              return e15.byteLength;
            typeof e15 != "string" && (e15 = "" + e15);
            var n2 = e15.length;
            if (n2 === 0)
              return 0;
            for (var r2 = false; ; )
              switch (t3) {
                case "ascii":
                case "latin1":
                case "binary":
                  return n2;
                case "utf8":
                case "utf-8":
                case void 0:
                  return H(e15).length;
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return 2 * n2;
                case "hex":
                  return n2 >>> 1;
                case "base64":
                  return U(e15).length;
                default:
                  if (r2)
                    return H(e15).length;
                  t3 = ("" + t3).toLowerCase(), r2 = true;
              }
          }
          function g(e15, t3, n2) {
            var r2 = false;
            if ((t3 === void 0 || t3 < 0) && (t3 = 0), t3 > this.length || ((n2 === void 0 || n2 > this.length) && (n2 = this.length), n2 <= 0) || (n2 >>>= 0) <= (t3 >>>= 0))
              return "";
            for (e15 ||= "utf8"; ; )
              switch (e15) {
                case "hex":
                  return j(this, t3, n2);
                case "utf8":
                case "utf-8":
                  return O(this, t3, n2);
                case "ascii":
                  return k(this, t3, n2);
                case "latin1":
                case "binary":
                  return A(this, t3, n2);
                case "base64":
                  return D(this, t3, n2);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return M(this, t3, n2);
                default:
                  if (r2)
                    throw TypeError("Unknown encoding: " + e15);
                  e15 = (e15 + "").toLowerCase(), r2 = true;
              }
          }
          function _(e15, t3, n2) {
            var r2 = e15[t3];
            e15[t3] = e15[n2], e15[n2] = r2;
          }
          function v(e15, t3, n2, r2, a2) {
            if (e15.length === 0)
              return -1;
            if (typeof n2 == "string" ? (r2 = n2, n2 = 0) : n2 > 2147483647 ? n2 = 2147483647 : n2 < -2147483648 && (n2 = -2147483648), n2 = +n2, isNaN(n2) && (n2 = a2 ? 0 : e15.length - 1), n2 < 0 && (n2 = e15.length + n2), n2 >= e15.length) {
              if (a2)
                return -1;
              n2 = e15.length - 1;
            } else if (n2 < 0) {
              if (!a2)
                return -1;
              n2 = 0;
            }
            if (typeof t3 == "string" && (t3 = l.from(t3, r2)), l.isBuffer(t3))
              return t3.length === 0 ? -1 : y(e15, t3, n2, r2, a2);
            if (typeof t3 == "number")
              return t3 &= 255, l.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? a2 ? Uint8Array.prototype.indexOf.call(e15, t3, n2) : Uint8Array.prototype.lastIndexOf.call(e15, t3, n2) : y(e15, [t3], n2, r2, a2);
            throw TypeError("val must be string, number or Buffer");
          }
          function y(e15, t3, n2, r2, a2) {
            var o2, s2 = 1, c2 = e15.length, l2 = t3.length;
            if (r2 !== void 0 && ((r2 = String(r2).toLowerCase()) === "ucs2" || r2 === "ucs-2" || r2 === "utf16le" || r2 === "utf-16le")) {
              if (e15.length < 2 || t3.length < 2)
                return -1;
              s2 = 2, c2 /= 2, l2 /= 2, n2 /= 2;
            }
            function u2(e16, t4) {
              return s2 === 1 ? e16[t4] : e16.readUInt16BE(t4 * s2);
            }
            if (a2) {
              var d2 = -1;
              for (o2 = n2; o2 < c2; o2++)
                if (u2(e15, o2) === u2(t3, d2 === -1 ? 0 : o2 - d2)) {
                  if (d2 === -1 && (d2 = o2), o2 - d2 + 1 === l2)
                    return d2 * s2;
                } else
                  d2 !== -1 && (o2 -= o2 - d2), d2 = -1;
            } else
              for (n2 + l2 > c2 && (n2 = c2 - l2), o2 = n2; o2 >= 0; o2--) {
                for (var f2 = true, p2 = 0; p2 < l2; p2++)
                  if (u2(e15, o2 + p2) !== u2(t3, p2)) {
                    f2 = false;
                    break;
                  }
                if (f2)
                  return o2;
              }
            return -1;
          }
          function b(e15, t3, n2, r2) {
            n2 = Number(n2) || 0;
            var a2 = e15.length - n2;
            r2 ? (r2 = Number(r2)) > a2 && (r2 = a2) : r2 = a2;
            var o2 = t3.length;
            if (o2 % 2 != 0)
              throw TypeError("Invalid hex string");
            r2 > o2 / 2 && (r2 = o2 / 2);
            for (var s2 = 0; s2 < r2; ++s2) {
              var c2 = parseInt(t3.substr(2 * s2, 2), 16);
              if (isNaN(c2))
                return s2;
              e15[n2 + s2] = c2;
            }
            return s2;
          }
          function S(e15, t3, n2, r2) {
            return W(H(t3, e15.length - n2), e15, n2, r2);
          }
          function C(e15, t3, n2, r2) {
            return W(function(e16) {
              for (var t4 = [], n3 = 0; n3 < e16.length; ++n3)
                t4.push(255 & e16.charCodeAt(n3));
              return t4;
            }(t3), e15, n2, r2);
          }
          function w(e15, t3, n2, r2) {
            return C(e15, t3, n2, r2);
          }
          function T(e15, t3, n2, r2) {
            return W(U(t3), e15, n2, r2);
          }
          function E(e15, t3, n2, r2) {
            return W(function(e16, t4) {
              for (var n3, r3, a2, o2 = [], s2 = 0; s2 < e16.length && !((t4 -= 2) < 0); ++s2)
                n3 = e16.charCodeAt(s2), r3 = n3 >> 8, a2 = n3 % 256, o2.push(a2), o2.push(r3);
              return o2;
            }(t3, e15.length - n2), e15, n2, r2);
          }
          function D(e15, t3, n2) {
            return t3 === 0 && n2 === e15.length ? r.fromByteArray(e15) : r.fromByteArray(e15.slice(t3, n2));
          }
          function O(e15, t3, n2) {
            n2 = Math.min(e15.length, n2);
            for (var r2 = [], a2 = t3; a2 < n2; ) {
              var o2, s2, c2, l2, u2 = e15[a2], d2 = null, f2 = u2 > 239 ? 4 : u2 > 223 ? 3 : u2 > 191 ? 2 : 1;
              if (a2 + f2 <= n2)
                switch (f2) {
                  case 1:
                    u2 < 128 && (d2 = u2);
                    break;
                  case 2:
                    (192 & (o2 = e15[a2 + 1])) == 128 && (l2 = (31 & u2) << 6 | 63 & o2) > 127 && (d2 = l2);
                    break;
                  case 3:
                    o2 = e15[a2 + 1], s2 = e15[a2 + 2], (192 & o2) == 128 && (192 & s2) == 128 && (l2 = (15 & u2) << 12 | (63 & o2) << 6 | 63 & s2) > 2047 && (l2 < 55296 || l2 > 57343) && (d2 = l2);
                    break;
                  case 4:
                    o2 = e15[a2 + 1], s2 = e15[a2 + 2], c2 = e15[a2 + 3], (192 & o2) == 128 && (192 & s2) == 128 && (192 & c2) == 128 && (l2 = (15 & u2) << 18 | (63 & o2) << 12 | (63 & s2) << 6 | 63 & c2) > 65535 && l2 < 1114112 && (d2 = l2);
                }
              d2 === null ? (d2 = 65533, f2 = 1) : d2 > 65535 && (d2 -= 65536, r2.push(d2 >>> 10 & 1023 | 55296), d2 = 56320 | 1023 & d2), r2.push(d2), a2 += f2;
            }
            return function(e16) {
              var t4 = e16.length;
              if (t4 <= 4096)
                return String.fromCharCode.apply(String, e16);
              for (var n3 = "", r3 = 0; r3 < t4; )
                n3 += String.fromCharCode.apply(String, e16.slice(r3, r3 += 4096));
              return n3;
            }(r2);
          }
          t2.Buffer = l, t2.SlowBuffer = function(e15) {
            return +e15 != e15 && (e15 = 0), l.alloc(+e15);
          }, t2.INSPECT_MAX_BYTES = 50, l.TYPED_ARRAY_SUPPORT = e14.TYPED_ARRAY_SUPPORT === void 0 ? function() {
            try {
              var e15 = new Uint8Array(1);
              return e15.__proto__ = {
                __proto__: Uint8Array.prototype,
                foo: function() {
                  return 42;
                }
              }, e15.foo() === 42 && typeof e15.subarray == "function" && e15.subarray(1, 1).byteLength === 0;
            } catch {
              return false;
            }
          }() : e14.TYPED_ARRAY_SUPPORT, t2.kMaxLength = s(), l.poolSize = 8192, l._augment = function(e15) {
            return e15.__proto__ = l.prototype, e15;
          }, l.from = function(e15, t3, n2) {
            return u(null, e15, t3, n2);
          }, l.TYPED_ARRAY_SUPPORT && (l.prototype.__proto__ = Uint8Array.prototype, l.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && l[Symbol.species] === l && Object.defineProperty(l, Symbol.species, {
            value: null,
            configurable: true
          })), l.alloc = function(e15, t3, n2) {
            return function(e16, t4, n3, r2) {
              return d(t4), t4 <= 0 || n3 === void 0 ? c(e16, t4) : typeof r2 == "string" ? c(e16, t4).fill(n3, r2) : c(e16, t4).fill(n3);
            }(null, e15, t3, n2);
          }, l.allocUnsafe = function(e15) {
            return f(null, e15);
          }, l.allocUnsafeSlow = function(e15) {
            return f(null, e15);
          }, l.isBuffer = function(e15) {
            return !(e15 == null || !e15._isBuffer);
          }, l.compare = function(e15, t3) {
            if (!l.isBuffer(e15) || !l.isBuffer(t3))
              throw TypeError("Arguments must be Buffers");
            if (e15 === t3)
              return 0;
            for (var n2 = e15.length, r2 = t3.length, a2 = 0, o2 = Math.min(n2, r2); a2 < o2; ++a2)
              if (e15[a2] !== t3[a2]) {
                n2 = e15[a2], r2 = t3[a2];
                break;
              }
            return n2 < r2 ? -1 : r2 < n2 ? 1 : 0;
          }, l.isEncoding = function(e15) {
            switch (String(e15).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return true;
              default:
                return false;
            }
          }, l.concat = function(e15, t3) {
            if (!o(e15))
              throw TypeError('"list" argument must be an Array of Buffers');
            if (e15.length === 0)
              return l.alloc(0);
            var n2;
            if (t3 === void 0)
              for (t3 = 0, n2 = 0; n2 < e15.length; ++n2)
                t3 += e15[n2].length;
            var r2 = l.allocUnsafe(t3), a2 = 0;
            for (n2 = 0; n2 < e15.length; ++n2) {
              var s2 = e15[n2];
              if (!l.isBuffer(s2))
                throw TypeError('"list" argument must be an Array of Buffers');
              s2.copy(r2, a2), a2 += s2.length;
            }
            return r2;
          }, l.byteLength = h, l.prototype._isBuffer = true, l.prototype.swap16 = function() {
            var e15 = this.length;
            if (e15 % 2 != 0)
              throw RangeError("Buffer size must be a multiple of 16-bits");
            for (var t3 = 0; t3 < e15; t3 += 2)
              _(this, t3, t3 + 1);
            return this;
          }, l.prototype.swap32 = function() {
            var e15 = this.length;
            if (e15 % 4 != 0)
              throw RangeError("Buffer size must be a multiple of 32-bits");
            for (var t3 = 0; t3 < e15; t3 += 4)
              _(this, t3, t3 + 3), _(this, t3 + 1, t3 + 2);
            return this;
          }, l.prototype.swap64 = function() {
            var e15 = this.length;
            if (e15 % 8 != 0)
              throw RangeError("Buffer size must be a multiple of 64-bits");
            for (var t3 = 0; t3 < e15; t3 += 8)
              _(this, t3, t3 + 7), _(this, t3 + 1, t3 + 6), _(this, t3 + 2, t3 + 5), _(this, t3 + 3, t3 + 4);
            return this;
          }, l.prototype.toString = function() {
            var e15 = 0 | this.length;
            return e15 === 0 ? "" : arguments.length === 0 ? O(this, 0, e15) : g.apply(this, arguments);
          }, l.prototype.equals = function(e15) {
            if (!l.isBuffer(e15))
              throw TypeError("Argument must be a Buffer");
            return this === e15 || l.compare(this, e15) === 0;
          }, l.prototype.inspect = function() {
            var e15 = "", n2 = t2.INSPECT_MAX_BYTES;
            return this.length > 0 && (e15 = this.toString("hex", 0, n2).match(/.{2}/g).join(" "), this.length > n2 && (e15 += " ... ")), "<Buffer " + e15 + ">";
          }, l.prototype.compare = function(e15, t3, n2, r2, a2) {
            if (!l.isBuffer(e15))
              throw TypeError("Argument must be a Buffer");
            if (t3 === void 0 && (t3 = 0), n2 === void 0 && (n2 = e15 ? e15.length : 0), r2 === void 0 && (r2 = 0), a2 === void 0 && (a2 = this.length), t3 < 0 || n2 > e15.length || r2 < 0 || a2 > this.length)
              throw RangeError("out of range index");
            if (r2 >= a2 && t3 >= n2)
              return 0;
            if (r2 >= a2)
              return -1;
            if (t3 >= n2)
              return 1;
            if (this === e15)
              return 0;
            for (var o2 = (a2 >>>= 0) - (r2 >>>= 0), s2 = (n2 >>>= 0) - (t3 >>>= 0), c2 = Math.min(o2, s2), u2 = this.slice(r2, a2), d2 = e15.slice(t3, n2), f2 = 0; f2 < c2; ++f2)
              if (u2[f2] !== d2[f2]) {
                o2 = u2[f2], s2 = d2[f2];
                break;
              }
            return o2 < s2 ? -1 : s2 < o2 ? 1 : 0;
          }, l.prototype.includes = function(e15, t3, n2) {
            return this.indexOf(e15, t3, n2) !== -1;
          }, l.prototype.indexOf = function(e15, t3, n2) {
            return v(this, e15, t3, n2, true);
          }, l.prototype.lastIndexOf = function(e15, t3, n2) {
            return v(this, e15, t3, n2, false);
          }, l.prototype.write = function(e15, t3, n2, r2) {
            if (t3 === void 0)
              r2 = "utf8", n2 = this.length, t3 = 0;
            else if (n2 === void 0 && typeof t3 == "string")
              r2 = t3, n2 = this.length, t3 = 0;
            else {
              if (!isFinite(t3))
                throw Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              t3 |= 0, isFinite(n2) ? (n2 |= 0, r2 === void 0 && (r2 = "utf8")) : (r2 = n2, n2 = void 0);
            }
            var a2 = this.length - t3;
            if ((n2 === void 0 || n2 > a2) && (n2 = a2), e15.length > 0 && (n2 < 0 || t3 < 0) || t3 > this.length)
              throw RangeError("Attempt to write outside buffer bounds");
            r2 ||= "utf8";
            for (var o2 = false; ; )
              switch (r2) {
                case "hex":
                  return b(this, e15, t3, n2);
                case "utf8":
                case "utf-8":
                  return S(this, e15, t3, n2);
                case "ascii":
                  return C(this, e15, t3, n2);
                case "latin1":
                case "binary":
                  return w(this, e15, t3, n2);
                case "base64":
                  return T(this, e15, t3, n2);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return E(this, e15, t3, n2);
                default:
                  if (o2)
                    throw TypeError("Unknown encoding: " + r2);
                  r2 = ("" + r2).toLowerCase(), o2 = true;
              }
          }, l.prototype.toJSON = function() {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };
          function k(e15, t3, n2) {
            var r2 = "";
            n2 = Math.min(e15.length, n2);
            for (var a2 = t3; a2 < n2; ++a2)
              r2 += String.fromCharCode(127 & e15[a2]);
            return r2;
          }
          function A(e15, t3, n2) {
            var r2 = "";
            n2 = Math.min(e15.length, n2);
            for (var a2 = t3; a2 < n2; ++a2)
              r2 += String.fromCharCode(e15[a2]);
            return r2;
          }
          function j(e15, t3, n2) {
            var r2 = e15.length;
            (!t3 || t3 < 0) && (t3 = 0), (!n2 || n2 < 0 || n2 > r2) && (n2 = r2);
            for (var a2 = "", o2 = t3; o2 < n2; ++o2)
              a2 += V(e15[o2]);
            return a2;
          }
          function M(e15, t3, n2) {
            for (var r2 = e15.slice(t3, n2), a2 = "", o2 = 0; o2 < r2.length; o2 += 2)
              a2 += String.fromCharCode(r2[o2] + 256 * r2[o2 + 1]);
            return a2;
          }
          function N(e15, t3, n2) {
            if (e15 % 1 != 0 || e15 < 0)
              throw RangeError("offset is not uint");
            if (e15 + t3 > n2)
              throw RangeError("Trying to access beyond buffer length");
          }
          function P(e15, t3, n2, r2, a2, o2) {
            if (!l.isBuffer(e15))
              throw TypeError('"buffer" argument must be a Buffer instance');
            if (t3 > a2 || t3 < o2)
              throw RangeError('"value" argument is out of bounds');
            if (n2 + r2 > e15.length)
              throw RangeError("Index out of range");
          }
          function F(e15, t3, n2, r2) {
            t3 < 0 && (t3 = 65535 + t3 + 1);
            for (var a2 = 0, o2 = Math.min(e15.length - n2, 2); a2 < o2; ++a2)
              e15[n2 + a2] = (t3 & 255 << 8 * (r2 ? a2 : 1 - a2)) >>> 8 * (r2 ? a2 : 1 - a2);
          }
          function I(e15, t3, n2, r2) {
            t3 < 0 && (t3 = 4294967295 + t3 + 1);
            for (var a2 = 0, o2 = Math.min(e15.length - n2, 4); a2 < o2; ++a2)
              e15[n2 + a2] = t3 >>> 8 * (r2 ? a2 : 3 - a2) & 255;
          }
          function L(e15, t3, n2, r2, a2, o2) {
            if (n2 + r2 > e15.length || n2 < 0)
              throw RangeError("Index out of range");
          }
          function R(e15, t3, n2, r2, o2) {
            return o2 || L(e15, 0, n2, 4), a.write(e15, t3, n2, r2, 23, 4), n2 + 4;
          }
          function z(e15, t3, n2, r2, o2) {
            return o2 || L(e15, 0, n2, 8), a.write(e15, t3, n2, r2, 52, 8), n2 + 8;
          }
          l.prototype.slice = function(e15, t3) {
            var n2, r2 = this.length;
            if ((e15 = ~~e15) < 0 ? (e15 += r2) < 0 && (e15 = 0) : e15 > r2 && (e15 = r2), (t3 = t3 === void 0 ? r2 : ~~t3) < 0 ? (t3 += r2) < 0 && (t3 = 0) : t3 > r2 && (t3 = r2), t3 < e15 && (t3 = e15), l.TYPED_ARRAY_SUPPORT)
              (n2 = this.subarray(e15, t3)).__proto__ = l.prototype;
            else {
              var a2 = t3 - e15;
              n2 = new l(a2, void 0);
              for (var o2 = 0; o2 < a2; ++o2)
                n2[o2] = this[o2 + e15];
            }
            return n2;
          }, l.prototype.readUIntLE = function(e15, t3, n2) {
            e15 |= 0, t3 |= 0, n2 || N(e15, t3, this.length);
            for (var r2 = this[e15], a2 = 1, o2 = 0; ++o2 < t3 && (a2 *= 256); )
              r2 += this[e15 + o2] * a2;
            return r2;
          }, l.prototype.readUIntBE = function(e15, t3, n2) {
            e15 |= 0, t3 |= 0, n2 || N(e15, t3, this.length);
            for (var r2 = this[e15 + --t3], a2 = 1; t3 > 0 && (a2 *= 256); )
              r2 += this[e15 + --t3] * a2;
            return r2;
          }, l.prototype.readUInt8 = function(e15, t3) {
            return t3 || N(e15, 1, this.length), this[e15];
          }, l.prototype.readUInt16LE = function(e15, t3) {
            return t3 || N(e15, 2, this.length), this[e15] | this[e15 + 1] << 8;
          }, l.prototype.readUInt16BE = function(e15, t3) {
            return t3 || N(e15, 2, this.length), this[e15] << 8 | this[e15 + 1];
          }, l.prototype.readUInt32LE = function(e15, t3) {
            return t3 || N(e15, 4, this.length), (this[e15] | this[e15 + 1] << 8 | this[e15 + 2] << 16) + 16777216 * this[e15 + 3];
          }, l.prototype.readUInt32BE = function(e15, t3) {
            return t3 || N(e15, 4, this.length), 16777216 * this[e15] + (this[e15 + 1] << 16 | this[e15 + 2] << 8 | this[e15 + 3]);
          }, l.prototype.readIntLE = function(e15, t3, n2) {
            e15 |= 0, t3 |= 0, n2 || N(e15, t3, this.length);
            for (var r2 = this[e15], a2 = 1, o2 = 0; ++o2 < t3 && (a2 *= 256); )
              r2 += this[e15 + o2] * a2;
            return r2 >= (a2 *= 128) && (r2 -= 2 ** (8 * t3)), r2;
          }, l.prototype.readIntBE = function(e15, t3, n2) {
            e15 |= 0, t3 |= 0, n2 || N(e15, t3, this.length);
            for (var r2 = t3, a2 = 1, o2 = this[e15 + --r2]; r2 > 0 && (a2 *= 256); )
              o2 += this[e15 + --r2] * a2;
            return o2 >= (a2 *= 128) && (o2 -= 2 ** (8 * t3)), o2;
          }, l.prototype.readInt8 = function(e15, t3) {
            return t3 || N(e15, 1, this.length), 128 & this[e15] ? -1 * (255 - this[e15] + 1) : this[e15];
          }, l.prototype.readInt16LE = function(e15, t3) {
            t3 || N(e15, 2, this.length);
            var n2 = this[e15] | this[e15 + 1] << 8;
            return 32768 & n2 ? 4294901760 | n2 : n2;
          }, l.prototype.readInt16BE = function(e15, t3) {
            t3 || N(e15, 2, this.length);
            var n2 = this[e15 + 1] | this[e15] << 8;
            return 32768 & n2 ? 4294901760 | n2 : n2;
          }, l.prototype.readInt32LE = function(e15, t3) {
            return t3 || N(e15, 4, this.length), this[e15] | this[e15 + 1] << 8 | this[e15 + 2] << 16 | this[e15 + 3] << 24;
          }, l.prototype.readInt32BE = function(e15, t3) {
            return t3 || N(e15, 4, this.length), this[e15] << 24 | this[e15 + 1] << 16 | this[e15 + 2] << 8 | this[e15 + 3];
          }, l.prototype.readFloatLE = function(e15, t3) {
            return t3 || N(e15, 4, this.length), a.read(this, e15, true, 23, 4);
          }, l.prototype.readFloatBE = function(e15, t3) {
            return t3 || N(e15, 4, this.length), a.read(this, e15, false, 23, 4);
          }, l.prototype.readDoubleLE = function(e15, t3) {
            return t3 || N(e15, 8, this.length), a.read(this, e15, true, 52, 8);
          }, l.prototype.readDoubleBE = function(e15, t3) {
            return t3 || N(e15, 8, this.length), a.read(this, e15, false, 52, 8);
          }, l.prototype.writeUIntLE = function(e15, t3, n2, r2) {
            (e15 = +e15, t3 |= 0, n2 |= 0, r2) || P(this, e15, t3, n2, 2 ** (8 * n2) - 1, 0);
            var a2 = 1, o2 = 0;
            for (this[t3] = 255 & e15; ++o2 < n2 && (a2 *= 256); )
              this[t3 + o2] = e15 / a2 & 255;
            return t3 + n2;
          }, l.prototype.writeUIntBE = function(e15, t3, n2, r2) {
            (e15 = +e15, t3 |= 0, n2 |= 0, r2) || P(this, e15, t3, n2, 2 ** (8 * n2) - 1, 0);
            var a2 = n2 - 1, o2 = 1;
            for (this[t3 + a2] = 255 & e15; --a2 >= 0 && (o2 *= 256); )
              this[t3 + a2] = e15 / o2 & 255;
            return t3 + n2;
          }, l.prototype.writeUInt8 = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 1, 255, 0), l.TYPED_ARRAY_SUPPORT || (e15 = Math.floor(e15)), this[t3] = 255 & e15, t3 + 1;
          }, l.prototype.writeUInt16LE = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[t3] = 255 & e15, this[t3 + 1] = e15 >>> 8) : F(this, e15, t3, true), t3 + 2;
          }, l.prototype.writeUInt16BE = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[t3] = e15 >>> 8, this[t3 + 1] = 255 & e15) : F(this, e15, t3, false), t3 + 2;
          }, l.prototype.writeUInt32LE = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[t3 + 3] = e15 >>> 24, this[t3 + 2] = e15 >>> 16, this[t3 + 1] = e15 >>> 8, this[t3] = 255 & e15) : I(this, e15, t3, true), t3 + 4;
          }, l.prototype.writeUInt32BE = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[t3] = e15 >>> 24, this[t3 + 1] = e15 >>> 16, this[t3 + 2] = e15 >>> 8, this[t3 + 3] = 255 & e15) : I(this, e15, t3, false), t3 + 4;
          }, l.prototype.writeIntLE = function(e15, t3, n2, r2) {
            if (e15 = +e15, t3 |= 0, !r2) {
              var a2 = 2 ** (8 * n2 - 1);
              P(this, e15, t3, n2, a2 - 1, -a2);
            }
            var o2 = 0, s2 = 1, c2 = 0;
            for (this[t3] = 255 & e15; ++o2 < n2 && (s2 *= 256); )
              e15 < 0 && c2 === 0 && this[t3 + o2 - 1] !== 0 && (c2 = 1), this[t3 + o2] = (e15 / s2 >> 0) - c2 & 255;
            return t3 + n2;
          }, l.prototype.writeIntBE = function(e15, t3, n2, r2) {
            if (e15 = +e15, t3 |= 0, !r2) {
              var a2 = 2 ** (8 * n2 - 1);
              P(this, e15, t3, n2, a2 - 1, -a2);
            }
            var o2 = n2 - 1, s2 = 1, c2 = 0;
            for (this[t3 + o2] = 255 & e15; --o2 >= 0 && (s2 *= 256); )
              e15 < 0 && c2 === 0 && this[t3 + o2 + 1] !== 0 && (c2 = 1), this[t3 + o2] = (e15 / s2 >> 0) - c2 & 255;
            return t3 + n2;
          }, l.prototype.writeInt8 = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 1, 127, -128), l.TYPED_ARRAY_SUPPORT || (e15 = Math.floor(e15)), e15 < 0 && (e15 = 255 + e15 + 1), this[t3] = 255 & e15, t3 + 1;
          }, l.prototype.writeInt16LE = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[t3] = 255 & e15, this[t3 + 1] = e15 >>> 8) : F(this, e15, t3, true), t3 + 2;
          }, l.prototype.writeInt16BE = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[t3] = e15 >>> 8, this[t3 + 1] = 255 & e15) : F(this, e15, t3, false), t3 + 2;
          }, l.prototype.writeInt32LE = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 4, 2147483647, -2147483648), l.TYPED_ARRAY_SUPPORT ? (this[t3] = 255 & e15, this[t3 + 1] = e15 >>> 8, this[t3 + 2] = e15 >>> 16, this[t3 + 3] = e15 >>> 24) : I(this, e15, t3, true), t3 + 4;
          }, l.prototype.writeInt32BE = function(e15, t3, n2) {
            return e15 = +e15, t3 |= 0, n2 || P(this, e15, t3, 4, 2147483647, -2147483648), e15 < 0 && (e15 = 4294967295 + e15 + 1), l.TYPED_ARRAY_SUPPORT ? (this[t3] = e15 >>> 24, this[t3 + 1] = e15 >>> 16, this[t3 + 2] = e15 >>> 8, this[t3 + 3] = 255 & e15) : I(this, e15, t3, false), t3 + 4;
          }, l.prototype.writeFloatLE = function(e15, t3, n2) {
            return R(this, e15, t3, true, n2);
          }, l.prototype.writeFloatBE = function(e15, t3, n2) {
            return R(this, e15, t3, false, n2);
          }, l.prototype.writeDoubleLE = function(e15, t3, n2) {
            return z(this, e15, t3, true, n2);
          }, l.prototype.writeDoubleBE = function(e15, t3, n2) {
            return z(this, e15, t3, false, n2);
          }, l.prototype.copy = function(e15, t3, n2, r2) {
            if (n2 ||= 0, r2 || r2 === 0 || (r2 = this.length), t3 >= e15.length && (t3 = e15.length), t3 ||= 0, r2 > 0 && r2 < n2 && (r2 = n2), r2 === n2 || e15.length === 0 || this.length === 0)
              return 0;
            if (t3 < 0)
              throw RangeError("targetStart out of bounds");
            if (n2 < 0 || n2 >= this.length)
              throw RangeError("sourceStart out of bounds");
            if (r2 < 0)
              throw RangeError("sourceEnd out of bounds");
            r2 > this.length && (r2 = this.length), e15.length - t3 < r2 - n2 && (r2 = e15.length - t3 + n2);
            var a2, o2 = r2 - n2;
            if (this === e15 && n2 < t3 && t3 < r2)
              for (a2 = o2 - 1; a2 >= 0; --a2)
                e15[a2 + t3] = this[a2 + n2];
            else if (o2 < 1e3 || !l.TYPED_ARRAY_SUPPORT)
              for (a2 = 0; a2 < o2; ++a2)
                e15[a2 + t3] = this[a2 + n2];
            else
              Uint8Array.prototype.set.call(e15, this.subarray(n2, n2 + o2), t3);
            return o2;
          }, l.prototype.fill = function(e15, t3, n2, r2) {
            if (typeof e15 == "string") {
              if (typeof t3 == "string" ? (r2 = t3, t3 = 0, n2 = this.length) : typeof n2 == "string" && (r2 = n2, n2 = this.length), e15.length === 1) {
                var a2 = e15.charCodeAt(0);
                a2 < 256 && (e15 = a2);
              }
              if (r2 !== void 0 && typeof r2 != "string")
                throw TypeError("encoding must be a string");
              if (typeof r2 == "string" && !l.isEncoding(r2))
                throw TypeError("Unknown encoding: " + r2);
            } else
              typeof e15 == "number" && (e15 &= 255);
            if (t3 < 0 || this.length < t3 || this.length < n2)
              throw RangeError("Out of range index");
            if (n2 <= t3)
              return this;
            var o2;
            if (t3 >>>= 0, n2 = n2 === void 0 ? this.length : n2 >>> 0, e15 ||= 0, typeof e15 == "number")
              for (o2 = t3; o2 < n2; ++o2)
                this[o2] = e15;
            else {
              var s2 = l.isBuffer(e15) ? e15 : H(new l(e15, r2).toString()), c2 = s2.length;
              for (o2 = 0; o2 < n2 - t3; ++o2)
                this[o2 + t3] = s2[o2 % c2];
            }
            return this;
          };
          var B = /[^+\/0-9A-Za-z-_]/g;
          function V(e15) {
            return e15 < 16 ? "0" + e15.toString(16) : e15.toString(16);
          }
          function H(e15, t3) {
            var n2;
            t3 ||= Infinity;
            for (var r2 = e15.length, a2 = null, o2 = [], s2 = 0; s2 < r2; ++s2) {
              if ((n2 = e15.charCodeAt(s2)) > 55295 && n2 < 57344) {
                if (!a2) {
                  if (n2 > 56319) {
                    (t3 -= 3) > -1 && o2.push(239, 191, 189);
                    continue;
                  }
                  if (s2 + 1 === r2) {
                    (t3 -= 3) > -1 && o2.push(239, 191, 189);
                    continue;
                  }
                  a2 = n2;
                  continue;
                }
                if (n2 < 56320) {
                  (t3 -= 3) > -1 && o2.push(239, 191, 189), a2 = n2;
                  continue;
                }
                n2 = 65536 + (a2 - 55296 << 10 | n2 - 56320);
              } else
                a2 && (t3 -= 3) > -1 && o2.push(239, 191, 189);
              if (a2 = null, n2 < 128) {
                if (--t3 < 0)
                  break;
                o2.push(n2);
              } else if (n2 < 2048) {
                if ((t3 -= 2) < 0)
                  break;
                o2.push(n2 >> 6 | 192, 63 & n2 | 128);
              } else if (n2 < 65536) {
                if ((t3 -= 3) < 0)
                  break;
                o2.push(n2 >> 12 | 224, n2 >> 6 & 63 | 128, 63 & n2 | 128);
              } else {
                if (!(n2 < 1114112))
                  throw Error("Invalid code point");
                if ((t3 -= 4) < 0)
                  break;
                o2.push(n2 >> 18 | 240, n2 >> 12 & 63 | 128, n2 >> 6 & 63 | 128, 63 & n2 | 128);
              }
            }
            return o2;
          }
          function U(e15) {
            return r.toByteArray(function(e16) {
              if ((e16 = function(e17) {
                return e17.trim ? e17.trim() : e17.replace(/^\s+|\s+$/g, "");
              }(e16).replace(B, "")).length < 2)
                return "";
              for (; e16.length % 4 != 0; )
                e16 += "=";
              return e16;
            }(e15));
          }
          function W(e15, t3, n2, r2) {
            for (var a2 = 0; a2 < r2 && !(a2 + n2 >= t3.length || a2 >= e15.length); ++a2)
              t3[a2 + n2] = e15[a2];
            return a2;
          }
        }).call(this, n(78));
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.isASCIIByte = function(e14) {
          return e14 >= 0 && e14 <= 127;
        };
      },
      function(e13, t2, n) {
        var r = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o = n2.call(e14), s = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o.next()).done; )
              s.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o.return) && n2.call(o);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s;
        }, a = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(r(arguments[t3]));
          return e14;
        };
        Object.defineProperty(t2, "__esModule", { value: true }), t2.length = function(e14) {
          return e14.length;
        }, t2.byteLowercase = function(e14) {
          for (var t3 = 0; t3 < e14.length; t3++) {
            var n2 = e14[t3];
            n2 >= 65 && n2 <= 90 && (e14[t3] = n2 + 32);
          }
        }, t2.byteUppercase = function(e14) {
          for (var t3 = 0; t3 < e14.length; t3++) {
            var n2 = e14[t3];
            n2 >= 97 && n2 <= 122 && (e14[t3] = n2 - 32);
          }
        }, t2.byteCaseInsensitiveMatch = function(e14, t3) {
          if (e14.length !== t3.length)
            return false;
          for (var n2 = 0; n2 < e14.length; n2++) {
            var r2 = e14[n2], a2 = t3[n2];
            if (r2 >= 65 && r2 <= 90 && (r2 += 32), a2 >= 65 && a2 <= 90 && (a2 += 32), r2 !== a2)
              return false;
          }
          return true;
        }, t2.startsWith = function(e14, t3) {
          for (var n2 = 0; ; ) {
            if (n2 >= e14.length)
              return false;
            if (n2 >= t3.length)
              return true;
            if (e14[n2] !== t3[n2])
              return false;
            n2++;
          }
        }, t2.byteLessThan = function(e14, t3) {
          for (var n2 = 0; ; ) {
            if (n2 >= e14.length)
              return false;
            if (n2 >= t3.length)
              return true;
            var r2 = e14[n2], a2 = t3[n2];
            if (r2 < a2)
              return true;
            if (r2 > a2)
              return false;
            n2++;
          }
        }, t2.isomorphicDecode = function(e14) {
          return String.fromCodePoint.apply(String, a(e14));
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(6), a = n(7), o = n(0), s = n(12), c = function() {
          function e14(e15) {
            this._associatedDocument = e15 || r.dom.window.document;
          }
          return e14.prototype.createDocumentType = function(e15, t3, n2) {
            return o.namespace_validate(e15), o.create_documentType(this._associatedDocument, e15, t3, n2);
          }, e14.prototype.createDocument = function(e15, t3, n2) {
            n2 === void 0 && (n2 = null);
            var r2 = o.create_xmlDocument(), s2 = null;
            return t3 && (s2 = o.document_internalCreateElementNS(r2, e15, t3)), n2 && r2.appendChild(n2), s2 && r2.appendChild(s2), r2._origin = this._associatedDocument._origin, e15 === a.namespace.HTML ? r2._contentType = "application/xhtml+xml" : e15 === a.namespace.SVG ? r2._contentType = "image/svg+xml" : r2._contentType = "application/xml", r2;
          }, e14.prototype.createHTMLDocument = function(e15) {
            var t3 = o.create_document();
            t3._type = "html", t3._contentType = "text/html", t3.appendChild(o.create_documentType(t3, "html", "", ""));
            var n2 = o.element_createAnElement(t3, "html", a.namespace.HTML);
            t3.appendChild(n2);
            var r2 = o.element_createAnElement(t3, "head", a.namespace.HTML);
            if (n2.appendChild(r2), e15 !== void 0) {
              var s2 = o.element_createAnElement(t3, "title", a.namespace.HTML);
              r2.appendChild(s2);
              var c2 = o.create_text(t3, e15);
              s2.appendChild(c2);
            }
            var l = o.element_createAnElement(t3, "body", a.namespace.HTML);
            return n2.appendChild(l), t3._origin = this._associatedDocument._origin, t3;
          }, e14.prototype.hasFeature = function() {
            return true;
          }, e14._create = function(t3) {
            return new e14(t3);
          }, e14;
        }();
        t2.DOMImplementationImpl = c, s.idl_defineConst(c.prototype, "_ID", "@oozcitak/dom");
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(70), s = n(1), c = n(0);
        t2.WindowImpl = function(e14) {
          function t3() {
            var t4 = e14.call(this) || this;
            return t4._signalSlots = /* @__PURE__ */ new Set(), t4._mutationObserverMicrotaskQueued = false, t4._mutationObservers = /* @__PURE__ */ new Set(), t4._iteratorList = new s.FixedSizeSet(), t4._associatedDocument = c.create_document(), t4;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "document", {
            get: function() {
              return this._associatedDocument;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "event", {
            get: function() {
              return this._currentEvent;
            },
            enumerable: true,
            configurable: true
          }), t3._create = function() {
            return new t3();
          }, t3;
        }(o.EventTargetImpl);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(2);
        t2.Guard = function() {
          function e14() {
          }
          return e14.isNode = function(e15) {
            return !!e15 && e15._nodeType !== void 0;
          }, e14.isDocumentNode = function(t3) {
            return e14.isNode(t3) && t3._nodeType === r.NodeType.Document;
          }, e14.isDocumentTypeNode = function(t3) {
            return e14.isNode(t3) && t3._nodeType === r.NodeType.DocumentType;
          }, e14.isDocumentFragmentNode = function(t3) {
            return e14.isNode(t3) && t3._nodeType === r.NodeType.DocumentFragment;
          }, e14.isAttrNode = function(t3) {
            return e14.isNode(t3) && t3._nodeType === r.NodeType.Attribute;
          }, e14.isCharacterDataNode = function(t3) {
            if (!e14.isNode(t3))
              return false;
            var n2 = t3._nodeType;
            return n2 === r.NodeType.Text || n2 === r.NodeType.ProcessingInstruction || n2 === r.NodeType.Comment || n2 === r.NodeType.CData;
          }, e14.isTextNode = function(t3) {
            return e14.isNode(t3) && (t3._nodeType === r.NodeType.Text || t3._nodeType === r.NodeType.CData);
          }, e14.isExclusiveTextNode = function(t3) {
            return e14.isNode(t3) && t3._nodeType === r.NodeType.Text;
          }, e14.isCDATASectionNode = function(t3) {
            return e14.isNode(t3) && t3._nodeType === r.NodeType.CData;
          }, e14.isCommentNode = function(t3) {
            return e14.isNode(t3) && t3._nodeType === r.NodeType.Comment;
          }, e14.isProcessingInstructionNode = function(t3) {
            return e14.isNode(t3) && t3._nodeType === r.NodeType.ProcessingInstruction;
          }, e14.isElementNode = function(t3) {
            return e14.isNode(t3) && t3._nodeType === r.NodeType.Element;
          }, e14.isCustomElementNode = function(t3) {
            return e14.isElementNode(t3) && t3._customElementState === "custom";
          }, e14.isShadowRoot = function(e15) {
            return !!e15 && e15.host !== void 0;
          }, e14.isMouseEvent = function(e15) {
            return !!e15 && e15.screenX !== void 0 && e15.screenY != null;
          }, e14.isSlotable = function(t3) {
            return !!t3 && t3._name !== void 0 && t3._assignedSlot !== void 0 && (e14.isTextNode(t3) || e14.isElementNode(t3));
          }, e14.isSlot = function(t3) {
            return !!t3 && t3._name !== void 0 && t3._assignedNodes !== void 0 && e14.isElementNode(t3);
          }, e14.isWindow = function(e15) {
            return !!e15 && e15.navigator !== void 0;
          }, e14.isEventListener = function(e15) {
            return !!e15 && e15.handleEvent !== void 0;
          }, e14.isRegisteredObserver = function(e15) {
            return !!e15 && e15.observer !== void 0 && e15.options !== void 0;
          }, e14.isTransientRegisteredObserver = function(t3) {
            return !!t3 && t3.source !== void 0 && e14.isRegisteredObserver(t3);
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true }), t2.XMLDocumentImpl = function(e14) {
          function t3() {
            return e14.call(this) || this;
          }
          return a(t3, e14), t3;
        }(n(98).DocumentImpl);
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, a = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var o, s = n(1), c = n(243), l = n(7), u = n(244), d = {
          ftp: 21,
          file: null,
          http: 80,
          https: 443,
          ws: 80,
          wss: 443
        }, f = /[\0-\x1F\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, p = /[ "<>`]|[\0-\x1F\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, m = /[ "<>`#?{}]|[\0-\x1F\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, h = /[ "<>`#?{}/:;=@\[\]\\\^\|]|[\0-\x1F\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, g = /[0-9A-Za-z!\$&-\/:;=\?@_~\xA0-\uD7FF\uE000-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uD83E\uD840-\uD87E\uD880-\uD8BE\uD8C0-\uD8FE\uD900-\uD93E\uD940-\uD97E\uD980-\uD9BE\uD9C0-\uD9FE\uDA00-\uDA3E\uDA40-\uDA7E\uDA80-\uDABE\uDAC0-\uDAFE\uDB00-\uDB3E\uDB40-\uDB7E\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDC00-\uDFFD]/, _ = /[\0\t\f\r #%/:?@\[\\\]]/;
        function v(e14) {
          o !== void 0 && o.call(null, "Validation Error: " + e14);
        }
        function y() {
          return {
            scheme: "",
            username: "",
            password: "",
            host: null,
            port: null,
            path: [],
            query: null,
            fragment: null,
            _cannotBeABaseURLFlag: false,
            _blobURLEntry: null
          };
        }
        function b(e14) {
          return e14 in d;
        }
        function S(e14) {
          return b(e14.scheme);
        }
        function C(e14) {
          return d[e14] || null;
        }
        function w(e14) {
          return e14.username !== "" || e14.password !== "";
        }
        function T(e14, t3) {
          var n2, a2;
          t3 === void 0 && (t3 = false);
          var o2 = e14.scheme + ":";
          if (e14.host === null ? e14.host === null && e14.scheme === "file" && (o2 += "//") : (o2 += "//", w(e14) && (o2 += e14.username, e14.password !== "" && (o2 += ":" + e14.password), o2 += "@"), o2 += E(e14.host), e14.port !== null && (o2 += ":" + e14.port)), e14._cannotBeABaseURLFlag)
            o2 += e14.path[0];
          else
            try {
              for (var s2 = r(e14.path), c2 = s2.next(); !c2.done; c2 = s2.next())
                o2 += "/" + c2.value;
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                c2 && !c2.done && (a2 = s2.return) && a2.call(s2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          return e14.query !== null && (o2 += "?" + e14.query), t3 || e14.fragment === null || (o2 += "#" + e14.fragment), o2;
        }
        function E(e14) {
          return s.isNumber(e14) ? D(e14) : s.isArray(e14) ? "[" + O(e14) + "]" : e14;
        }
        function D(e14) {
          for (var t3 = "", n2 = e14, r2 = 1; r2 <= 4; r2++)
            t3 = (n2 % 256).toString() + t3, r2 !== 4 && (t3 = "." + t3), n2 = Math.floor(n2 / 256);
          return t3;
        }
        function O(e14) {
          for (var t3 = "", n2 = null, r2 = -1, a2 = 0, o2 = 0, s2 = 0; s2 < 8; s2++)
            if (e14[s2] === 0) {
              a2 = 1;
              for (var c2 = s2 + 1; c2 < 8 && e14[c2] === 0; c2++)
                a2++;
              a2 > o2 && (o2 = a2, r2 = s2);
            }
          o2 > 1 && (n2 = r2);
          for (var l2 = false, u2 = 0; u2 < 8; u2++)
            l2 && e14[u2] === 0 || (l2 &&= false, n2 === u2 ? (t3 += u2 === 0 ? "::" : ":", l2 = true) : (t3 += e14[u2].toString(16), u2 !== 7 && (t3 += ":")));
          return t3;
        }
        function k(e14, t3, n2, a2, o2) {
          var u2, d2, _2, y2;
          if (a2 === void 0) {
            a2 = {
              scheme: "",
              username: "",
              password: "",
              host: null,
              port: null,
              path: [],
              query: null,
              fragment: null,
              _cannotBeABaseURLFlag: false,
              _blobURLEntry: null
            };
            var T2 = /^[\u0000-\u001F\u0020]+/, E2 = /[\u0000-\u001F\u0020]+$/;
            (T2.test(e14) || E2.test(e14)) && v("Input string contains leading or trailing control characters or space."), e14 = (e14 = e14.replace(T2, "")).replace(E2, "");
          }
          var D2 = /[\u0009\u000A\u000D]/g;
          D2.test(e14) && v("Input string contains tab or newline characters."), e14 = e14.replace(D2, "");
          var O2 = o2 === void 0 ? c.ParserState.SchemeStart : o2;
          t3 === void 0 && (t3 = null);
          for (var k2 = n2 === void 0 || n2 === "replacement" || n2 === "UTF-16BE" || n2 === "UTF-16LE" ? "UTF-8" : n2, L2 = "", R2 = false, z2 = false, B2 = false, V2 = new s.StringWalker(e14); ; ) {
            switch (O2) {
              case c.ParserState.SchemeStart:
                if (l.codePoint.ASCIIAlpha.test(V2.c()))
                  L2 += V2.c().toLowerCase(), O2 = c.ParserState.Scheme;
                else {
                  if (o2 !== void 0)
                    return v("Invalid scheme start character."), null;
                  O2 = c.ParserState.NoScheme, V2.pointer--;
                }
                break;
              case c.ParserState.Scheme:
                if (l.codePoint.ASCIIAlphanumeric.test(V2.c()) || V2.c() === "+" || V2.c() === "-" || V2.c() === ".")
                  L2 += V2.c().toLowerCase();
                else {
                  if (V2.c() !== ":") {
                    if (o2 === void 0) {
                      L2 = "", O2 = c.ParserState.NoScheme, V2.pointer = 0;
                      continue;
                    }
                    return v("Invalid input string."), null;
                  }
                  if (o2 !== void 0 && (b(a2.scheme) && !b(L2) || !b(a2.scheme) && b(L2) || (w(a2) || a2.port !== null) && L2 === "file" || a2.scheme === "file" && (a2.host === "" || a2.host === null)))
                    return a2;
                  if (a2.scheme = L2, o2 !== void 0)
                    return a2.port === C(a2.scheme) && (a2.port = null), a2;
                  L2 = "", a2.scheme === "file" ? (V2.remaining().startsWith("//") || v("Invalid file URL scheme, '//' expected."), O2 = c.ParserState.File) : S(a2) && t3 !== null && t3.scheme === a2.scheme ? O2 = c.ParserState.SpecialRelativeOrAuthority : S(a2) ? O2 = c.ParserState.SpecialAuthoritySlashes : V2.remaining().startsWith("/") ? (O2 = c.ParserState.PathOrAuthority, V2.pointer++) : (a2._cannotBeABaseURLFlag = true, a2.path.push(""), O2 = c.ParserState.CannotBeABaseURLPath);
                }
                break;
              case c.ParserState.NoScheme:
                if (t3 === null || t3._cannotBeABaseURLFlag && V2.c() !== "#")
                  return v("Invalid input string."), null;
                t3._cannotBeABaseURLFlag && V2.c() === "#" ? (a2.scheme = t3.scheme, a2.path = l.list.clone(t3.path), a2.query = t3.query, a2.fragment = "", a2._cannotBeABaseURLFlag = true, O2 = c.ParserState.Fragment) : t3.scheme === "file" ? (O2 = c.ParserState.File, V2.pointer--) : (O2 = c.ParserState.Relative, V2.pointer--);
                break;
              case c.ParserState.SpecialRelativeOrAuthority:
                V2.c() === "/" && V2.remaining().startsWith("/") ? (O2 = c.ParserState.SpecialAuthorityIgnoreSlashes, V2.pointer++) : (v("Invalid input string."), O2 = c.ParserState.Relative, V2.pointer--);
                break;
              case c.ParserState.PathOrAuthority:
                V2.c() === "/" ? O2 = c.ParserState.Authority : (O2 = c.ParserState.Path, V2.pointer--);
                break;
              case c.ParserState.Relative:
                if (t3 === null)
                  throw Error("Invalid parser state. Base URL is null.");
                switch (a2.scheme = t3.scheme, V2.c()) {
                  case "":
                    a2.username = t3.username, a2.password = t3.password, a2.host = t3.host, a2.port = t3.port, a2.path = l.list.clone(t3.path), a2.query = t3.query;
                    break;
                  case "/":
                    O2 = c.ParserState.RelativeSlash;
                    break;
                  case "?":
                    a2.username = t3.username, a2.password = t3.password, a2.host = t3.host, a2.port = t3.port, a2.path = l.list.clone(t3.path), a2.query = "", O2 = c.ParserState.Query;
                    break;
                  case "#":
                    a2.username = t3.username, a2.password = t3.password, a2.host = t3.host, a2.port = t3.port, a2.path = l.list.clone(t3.path), a2.query = t3.query, a2.fragment = "", O2 = c.ParserState.Fragment;
                    break;
                  default:
                    S(a2) && V2.c() === "\\" ? (v("Invalid input string."), O2 = c.ParserState.RelativeSlash) : (a2.username = t3.username, a2.password = t3.password, a2.host = t3.host, a2.port = t3.port, a2.path = l.list.clone(t3.path), a2.path.length !== 0 && a2.path.splice(a2.path.length - 1, 1), O2 = c.ParserState.Path, V2.pointer--);
                }
                break;
              case c.ParserState.RelativeSlash:
                if (!S(a2) || V2.c() !== "/" && V2.c() !== "\\")
                  if (V2.c() === "/")
                    O2 = c.ParserState.Authority;
                  else {
                    if (t3 === null)
                      throw Error("Invalid parser state. Base URL is null.");
                    a2.username = t3.username, a2.password = t3.password, a2.host = t3.host, a2.port = t3.port, O2 = c.ParserState.Path, V2.pointer--;
                  }
                else
                  V2.c() === "\\" && v("Invalid input string."), O2 = c.ParserState.SpecialAuthorityIgnoreSlashes;
                break;
              case c.ParserState.SpecialAuthoritySlashes:
                V2.c() === "/" && V2.remaining().startsWith("/") ? (O2 = c.ParserState.SpecialAuthorityIgnoreSlashes, V2.pointer++) : (v("Expected '//'."), O2 = c.ParserState.SpecialAuthorityIgnoreSlashes, V2.pointer--);
                break;
              case c.ParserState.SpecialAuthorityIgnoreSlashes:
                V2.c() !== "/" && V2.c() !== "\\" ? (O2 = c.ParserState.Authority, V2.pointer--) : v("Unexpected '/' or '\\'.");
                break;
              case c.ParserState.Authority:
                if (V2.c() === "@") {
                  v("Unexpected '@'."), R2 && (L2 = "%40" + L2), R2 = true;
                  try {
                    for (var U2 = (u2 = void 0, r(L2)), W2 = U2.next(); !W2.done; W2 = U2.next()) {
                      var K2 = W2.value;
                      if (K2 !== ":" || B2) {
                        var q2 = G(K2, h);
                        B2 ? a2.password += q2 : a2.username += q2;
                      } else
                        B2 = true;
                    }
                  } catch (e15) {
                    u2 = { error: e15 };
                  } finally {
                    try {
                      W2 && !W2.done && (d2 = U2.return) && d2.call(U2);
                    } finally {
                      if (u2)
                        throw u2.error;
                    }
                  }
                  L2 = "";
                } else if (V2.c() === "" || V2.c() === "/" || V2.c() === "?" || V2.c() === "#" || S(a2) && V2.c() === "\\") {
                  if (R2 && L2 === "")
                    return v("Invalid input string."), null;
                  V2.pointer -= L2.length + 1, L2 = "", O2 = c.ParserState.Host;
                } else
                  L2 += V2.c();
                break;
              case c.ParserState.Host:
              case c.ParserState.Hostname:
                if (o2 !== void 0 && a2.scheme === "file")
                  V2.pointer--, O2 = c.ParserState.FileHost;
                else if (V2.c() !== ":" || z2)
                  if (V2.c() === "" || V2.c() === "/" || V2.c() === "?" || V2.c() === "#" || S(a2) && V2.c() === "\\") {
                    if (V2.pointer--, S(a2) && L2 === "")
                      return v("Invalid input string."), null;
                    if (o2 !== void 0 && L2 === "" && (w(a2) || a2.port !== null))
                      return v("Invalid input string."), a2;
                    if ((Y = I(L2, !S(a2))) === null)
                      return null;
                    if (a2.host = Y, L2 = "", O2 = c.ParserState.PathStart, o2 !== void 0)
                      return a2;
                  } else
                    V2.c() === "[" && (z2 = true), V2.c() === "]" && (z2 = false), L2 += V2.c();
                else {
                  if (L2 === "")
                    return v("Invalid input string."), null;
                  if ((Y = I(L2, !S(a2))) === null)
                    return null;
                  if (a2.host = Y, L2 = "", O2 = c.ParserState.Port, o2 === c.ParserState.Hostname)
                    return a2;
                }
                break;
              case c.ParserState.Port:
                if (l.codePoint.ASCIIDigit.test(V2.c()))
                  L2 += V2.c();
                else {
                  if (!(V2.c() === "" || V2.c() === "/" || V2.c() === "?" || V2.c() === "#" || S(a2) && V2.c() === "\\" || o2))
                    return v("Invalid input string."), null;
                  if (L2 !== "" && L2 !== "") {
                    var J2 = parseInt(L2, 10);
                    if (J2 > 2 ** 16 - 1)
                      return v("Invalid port number."), null;
                    a2.port = J2 === C(a2.scheme) ? null : J2, L2 = "";
                  }
                  if (o2 !== void 0)
                    return a2;
                  O2 = c.ParserState.PathStart, V2.pointer--;
                }
                break;
              case c.ParserState.File:
                if (a2.scheme = "file", V2.c() === "/" || V2.c() === "\\")
                  V2.c() === "\\" && v("Invalid input string."), O2 = c.ParserState.FileSlash;
                else if (t3 !== null && t3.scheme === "file")
                  switch (V2.c()) {
                    case "":
                      a2.host = t3.host, a2.path = l.list.clone(t3.path), a2.query = t3.query;
                      break;
                    case "?":
                      a2.host = t3.host, a2.path = l.list.clone(t3.path), a2.query = "", O2 = c.ParserState.Query;
                      break;
                    case "#":
                      a2.host = t3.host, a2.path = l.list.clone(t3.path), a2.query = t3.query, a2.fragment = "", O2 = c.ParserState.Fragment;
                      break;
                    default:
                      F(V2.substring()) ? v("Unexpected windows drive letter in input string.") : (a2.host = t3.host, a2.path = l.list.clone(t3.path), M(a2)), O2 = c.ParserState.Path, V2.pointer--;
                  }
                else
                  O2 = c.ParserState.Path, V2.pointer--;
                break;
              case c.ParserState.FileSlash:
                V2.c() === "/" || V2.c() === "\\" ? (V2.c() === "\\" && v("Invalid input string."), O2 = c.ParserState.FileHost) : (t3 === null || t3.scheme !== "file" || F(V2.substring()) || (N(t3.path[0]) ? a2.path.push(t3.path[0]) : a2.host = t3.host), O2 = c.ParserState.Path, V2.pointer--);
                break;
              case c.ParserState.FileHost:
                if (V2.c() === "" || V2.c() === "/" || V2.c() === "\\" || V2.c() === "?" || V2.c() === "#")
                  if (V2.pointer--, o2 === void 0 && P(L2))
                    v("Unexpected windows drive letter in input string."), O2 = c.ParserState.Path;
                  else if (L2 === "") {
                    if (a2.host = "", o2 !== void 0)
                      return a2;
                    O2 = c.ParserState.PathStart;
                  } else {
                    var Y;
                    if ((Y = I(L2, !S(a2))) === null)
                      return null;
                    if (Y === "localhost" && (Y = ""), a2.host = Y, o2 !== void 0)
                      return a2;
                    L2 = "", O2 = c.ParserState.PathStart;
                  }
                else
                  L2 += V2.c();
                break;
              case c.ParserState.PathStart:
                S(a2) ? (V2.c() === "\\" && v("Invalid input string."), O2 = c.ParserState.Path, V2.c() !== "/" && V2.c() !== "\\" && V2.pointer--) : o2 === void 0 && V2.c() === "?" ? (a2.query = "", O2 = c.ParserState.Query) : o2 === void 0 && V2.c() === "#" ? (a2.fragment = "", O2 = c.ParserState.Fragment) : V2.c() !== "" && (O2 = c.ParserState.Path, V2.c() !== "/" && V2.pointer--);
                break;
              case c.ParserState.Path:
                if (V2.c() === "" || V2.c() === "/" || S(a2) && V2.c() === "\\" || o2 === void 0 && (V2.c() === "?" || V2.c() === "#")) {
                  if (S(a2) && V2.c() === "\\" && v("Invalid input string."), j(L2))
                    M(a2), V2.c() === "/" || S(a2) && V2.c() === "\\" || a2.path.push("");
                  else if (!A(L2) || V2.c() === "/" || S(a2) && V2.c() === "\\") {
                    if (!A(L2)) {
                      if (a2.scheme === "file" && a2.path.length === 0 && P(L2)) {
                        a2.host !== null && a2.host !== "" && (v("Invalid input string."), a2.host = "");
                        var hV = Array.from(L2);
                        L2 = hV.slice(0, 1) + ":" + hV.slice(2);
                      }
                      a2.path.push(L2);
                    }
                  } else
                    a2.path.push("");
                  if (L2 = "", a2.scheme === "file" && (V2.c() === "" || V2.c() === "?" || V2.c() === "#"))
                    for (; a2.path.length > 1 && a2.path[0] === ""; )
                      v("Invalid input string."), a2.path.splice(0, 1);
                  V2.c() === "?" && (a2.query = "", O2 = c.ParserState.Query), V2.c() === "#" && (a2.fragment = "", O2 = c.ParserState.Fragment);
                } else
                  g.test(V2.c()) || V2.c() === "%" || v("Character is not a URL code point or a percent encoded character."), V2.c() !== "%" || /^[0-9a-fA-F][0-9a-fA-F]/.test(V2.remaining()) || v("Percent encoded character must be followed by two hex digits."), L2 += G(V2.c(), m);
                break;
              case c.ParserState.CannotBeABaseURLPath:
                V2.c() === "?" ? (a2.query = "", O2 = c.ParserState.Query) : V2.c() === "#" ? (a2.fragment = "", O2 = c.ParserState.Fragment) : (V2.c() === "" || g.test(V2.c()) || V2.c() === "%" || v("Character is not a URL code point or a percent encoded character."), V2.c() !== "%" || /^[0-9a-fA-F][0-9a-fA-F]/.test(V2.remaining()) || v("Percent encoded character must be followed by two hex digits."), V2.c() !== "" && (a2.path[0] += G(V2.c(), f)));
                break;
              case c.ParserState.Query:
                if (k2 === "UTF-8" || S(a2) && a2.scheme !== "ws" && a2.scheme !== "wss" || (k2 = "UTF-8"), o2 === void 0 && V2.c() === "#")
                  a2.fragment = "", O2 = c.ParserState.Fragment;
                else if (V2.c() !== "") {
                  if (g.test(V2.c()) || V2.c() === "%" || v("Character is not a URL code point or a percent encoded character."), V2.c() !== "%" || /^[0-9a-fA-F][0-9a-fA-F]/.test(V2.remaining()) || v("Percent encoded character must be followed by two hex digits."), k2.toUpperCase() !== "UTF-8")
                    throw Error("Only UTF-8 encoding is supported.");
                  var X = s.utf8Encode(V2.c());
                  if (X.length >= 3 && X[0] === 38 && X[1] === 35 && X[X.length - 1] === 59)
                    X = X.subarray(2, X.length - 1), a2.query += "%26%23" + l.byteSequence.isomorphicDecode(X) + "%3B";
                  else
                    try {
                      for (var Z = (_2 = void 0, r(X)), Q = Z.next(); !Q.done; Q = Z.next()) {
                        var $ = Q.value;
                        $ < 33 || $ > 126 || $ === 34 || $ === 35 || $ === 60 || $ === 62 || $ === 39 && S(a2) ? a2.query += H($) : a2.query += String.fromCharCode($);
                      }
                    } catch (e15) {
                      _2 = { error: e15 };
                    } finally {
                      try {
                        Q && !Q.done && (y2 = Z.return) && y2.call(Z);
                      } finally {
                        if (_2)
                          throw _2.error;
                      }
                    }
                }
                break;
              case c.ParserState.Fragment:
                V2.c() === "" || (V2.c() === "\0" ? v("NULL character in input string.") : (g.test(V2.c()) || V2.c() === "%" || v("Unexpected character in fragment string."), V2.c() !== "%" || /^[A-Za-z0-9][A-Za-z0-9]/.test(V2.remaining()) || v("Unexpected character in fragment string."), a2.fragment += G(V2.c(), p)));
            }
            if (V2.eof)
              break;
            V2.pointer++;
          }
          return a2;
        }
        function A(e14) {
          return e14 === "." || e14.toLowerCase() === "%2e";
        }
        function j(e14) {
          var t3 = e14.toLowerCase();
          return t3 === ".." || t3 === ".%2e" || t3 === "%2e." || t3 === "%2e%2e";
        }
        function M(e14) {
          var t3 = e14.path;
          t3.length !== 0 && (e14.scheme === "file" && t3.length === 1 && N(t3[0]) || e14.path.splice(e14.path.length - 1, 1));
        }
        function N(e14) {
          return e14.length >= 2 && l.codePoint.ASCIIAlpha.test(e14[0]) && e14[1] === ":";
        }
        function P(e14) {
          return e14.length >= 2 && l.codePoint.ASCIIAlpha.test(e14[0]) && (e14[1] === ":" || e14[1] === "|");
        }
        function F(e14) {
          return e14.length >= 2 && P(e14) && (e14.length === 2 || e14[2] === "/" || e14[2] === "\\" || e14[2] === "?" || e14[2] === "#");
        }
        function I(e14, t3) {
          if (t3 === void 0 && (t3 = false), e14.startsWith("["))
            return e14.endsWith("]") ? z(e14.substring(1, e14.length - 1)) : (v("Expected ']' after '['."), null);
          if (t3)
            return B(e14);
          var n2 = J(s.utf8Decode(W(e14)));
          if (n2 === null || _.test(n2))
            return v("Invalid domain."), null;
          var r2 = R(n2);
          return r2 === null || s.isNumber(r2) ? r2 : n2;
        }
        function L(e14, t3) {
          t3 === void 0 && (t3 = { value: false });
          var n2 = 10;
          return e14.startsWith("0x") || e14.startsWith("0X") ? (t3.value = true, e14 = e14.substr(2), n2 = 16) : e14.length >= 2 && e14[0] === "0" && (t3.value = true, e14 = e14.substr(1), n2 = 8), e14 === "" ? 0 : (n2 === 10 ? /^[0-9]+$/ : n2 === 16 ? /^[0-9A-Fa-f]+$/ : /^[0-7]+$/).test(e14) ? parseInt(e14, n2) : null;
        }
        function R(e14) {
          var t3, n2, a2, o2, s2 = { value: false }, c2 = e14.split(".");
          if (c2[c2.length - 1] === "" && (s2.value = true, c2.length > 1 && c2.pop()), c2.length > 4)
            return e14;
          var l2 = [];
          try {
            for (var u2 = r(c2), d2 = u2.next(); !d2.done; d2 = u2.next()) {
              var f2 = d2.value;
              if (f2 === "" || (y2 = L(f2, s2)) === null)
                return e14;
              l2.push(y2);
            }
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              d2 && !d2.done && (n2 = u2.return) && n2.call(u2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          s2.value && v("Invalid IP v4 address.");
          for (var p2 = 0; p2 < l2.length; p2++)
            if (l2[p2] > 255 && (v("Invalid IP v4 address."), p2 < l2.length - 1))
              return null;
          if (l2[l2.length - 1] >= 256 ** (5 - l2.length))
            return v("Invalid IP v4 address."), null;
          var m2 = l2[l2.length - 1];
          l2.pop();
          var h2 = 0;
          try {
            for (var g2 = r(l2), _2 = g2.next(); !_2.done; _2 = g2.next()) {
              var y2;
              m2 += (y2 = _2.value) * 256 ** (3 - h2), h2++;
            }
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              _2 && !_2.done && (o2 = g2.return) && o2.call(g2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return m2;
        }
        function z(e14) {
          var t3, n2 = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ], r2 = 0, o2 = null, c2 = new s.StringWalker(e14);
          if (c2.c() === ":") {
            if (!c2.remaining().startsWith(":"))
              return v("Invalid IP v6 address."), null;
            c2.pointer += 2, o2 = r2 += 1;
          }
          for (; c2.c() !== ""; ) {
            if (r2 === 8)
              return v("Invalid IP v6 address."), null;
            if (c2.c() !== ":") {
              for (var u2 = 0, d2 = 0; d2 < 4 && l.codePoint.ASCIIHexDigit.test(c2.c()); )
                u2 = 16 * u2 + parseInt(c2.c(), 16), c2.pointer++, d2++;
              if (c2.c() === ".") {
                if (d2 === 0 || (c2.pointer -= d2, r2 > 6))
                  return v("Invalid IP v6 address."), null;
                for (var f2 = 0; c2.c() !== ""; ) {
                  var p2 = null;
                  if (f2 > 0) {
                    if (!(c2.c() === "." && f2 < 4))
                      return v("Invalid IP v6 address."), null;
                    c2.pointer++;
                  }
                  if (!l.codePoint.ASCIIDigit.test(c2.c()))
                    return v("Invalid IP v6 address."), null;
                  for (; l.codePoint.ASCIIDigit.test(c2.c()); ) {
                    var m2 = parseInt(c2.c(), 10);
                    if (p2 === null)
                      p2 = m2;
                    else {
                      if (p2 === 0)
                        return v("Invalid IP v6 address."), null;
                      p2 = 10 * p2 + m2;
                    }
                    if (p2 > 255)
                      return v("Invalid IP v6 address."), null;
                    c2.pointer++;
                  }
                  if (p2 === null)
                    return v("Invalid IP v6 address."), null;
                  n2[r2] = 256 * n2[r2] + p2, ++f2 !== 2 && f2 !== 4 || r2++;
                }
                if (f2 !== 4)
                  return v("Invalid IP v6 address."), null;
                break;
              }
              if (c2.c() === ":") {
                if (c2.pointer++, c2.c() === "")
                  return v("Invalid IP v6 address."), null;
              } else if (c2.c() !== "")
                return v("Invalid IP v6 address."), null;
              n2[r2] = u2, r2++;
            } else {
              if (o2 !== null)
                return v("Invalid IP v6 address."), null;
              c2.pointer++, o2 = ++r2;
            }
          }
          if (o2 !== null) {
            var h2 = r2 - o2;
            for (r2 = 7; r2 !== 0 && h2 > 0; )
              t3 = a([n2[o2 + h2 - 1], n2[r2]], 2), n2[r2] = t3[0], n2[o2 + h2 - 1] = t3[1], r2--, h2--;
          } else if (o2 === null && r2 !== 8)
            return v("Invalid IP v6 address."), null;
          return n2;
        }
        function B(e14) {
          var t3, n2;
          if (/[\x00\t\f\r #/:?@\[\\\]]/.test(e14))
            return v("Invalid host string."), null;
          var a2 = "";
          try {
            for (var o2 = r(e14), s2 = o2.next(); !s2.done; s2 = o2.next())
              a2 += G(s2.value, f);
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              s2 && !s2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          return a2;
        }
        function V(e14) {
          return null;
        }
        function H(e14) {
          return "%" + ("00" + e14.toString(16).toUpperCase()).slice(-2);
        }
        function U(e14) {
          for (var t3 = function(e15) {
            return e15 >= 48 && e15 <= 57 || e15 >= 65 && e15 <= 70 || e15 >= 97 && e15 <= 102;
          }, n2 = new Uint8Array(e14.length), r2 = 0, a2 = 0; a2 < e14.length; a2++) {
            var o2 = e14[a2];
            o2 === 37 ? o2 === 37 && a2 >= e14.length - 2 ? (n2[r2] = o2, r2++) : o2 !== 37 || t3(e14[a2 + 1]) && t3(e14[a2 + 2]) ? (n2[r2] = parseInt(s.utf8Decode(Uint8Array.of(e14[a2 + 1], e14[a2 + 2])), 16), r2++, a2 += 2) : (n2[r2] = o2, r2++) : (n2[r2] = o2, r2++);
          }
          return n2.subarray(0, r2);
        }
        function W(e14) {
          return U(s.utf8Encode(e14));
        }
        function G(e14, t3) {
          var n2, a2;
          if (!t3.test(e14))
            return e14;
          var o2 = s.utf8Encode(e14), c2 = "";
          try {
            for (var l2 = r(o2), u2 = l2.next(); !u2.done; u2 = l2.next())
              c2 += H(u2.value);
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              u2 && !u2.done && (a2 = l2.return) && a2.call(l2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          return c2;
        }
        function K(e14) {
          var t3, n2, a2, o2, c2 = [], l2 = [];
          try {
            for (var u2 = r(e14), d2 = u2.next(); !d2.done; d2 = u2.next()) {
              var f2 = d2.value;
              f2 === 38 ? (c2.push(Uint8Array.from(l2)), l2 = []) : l2.push(f2);
            }
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              d2 && !d2.done && (n2 = u2.return) && n2.call(u2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          l2.length !== 0 && c2.push(Uint8Array.from(l2));
          var p2 = [];
          try {
            for (var m2 = r(c2), h2 = m2.next(); !h2.done; h2 = m2.next()) {
              var g2 = h2.value;
              if (g2.length !== 0) {
                for (var _2 = g2.indexOf(61), v2 = _2 === -1 ? g2 : g2.slice(0, _2), y2 = _2 === -1 ? new Uint8Array() : g2.slice(_2 + 1), b2 = 0; b2 < v2.length; b2++)
                  v2[b2] === 43 && (v2[b2] = 32);
                for (b2 = 0; b2 < y2.length; b2++)
                  y2[b2] === 43 && (y2[b2] = 32);
                var S2 = s.utf8Decode(v2), C2 = s.utf8Decode(y2);
                p2.push([S2, C2]);
              }
            }
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              h2 && !h2.done && (o2 = m2.return) && o2.call(m2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return p2;
        }
        function q(e14) {
          var t3, n2, a2 = "";
          try {
            for (var o2 = r(e14), s2 = o2.next(); !s2.done; s2 = o2.next()) {
              var c2 = s2.value;
              a2 += c2 === 32 ? "+" : c2 === 42 || c2 === 45 || c2 === 46 || c2 >= 48 && c2 <= 57 || c2 >= 65 && c2 <= 90 || c2 === 95 || c2 >= 97 && c2 <= 122 ? String.fromCodePoint(c2) : H(c2);
            }
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              s2 && !s2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          return a2;
        }
        function J(e14, t3) {
          t3 === void 0 && (t3 = false);
          var n2 = u.domainToASCII(e14);
          return n2 === "" ? (v("Invalid domain name."), null) : n2;
        }
        t2.setValidationErrorCallback = function(e14) {
          o = e14;
        }, t2.newURL = y, t2.isSpecialScheme = b, t2.isSpecial = S, t2.defaultPort = C, t2.includesCredentials = w, t2.cannotHaveAUsernamePasswordPort = function(e14) {
          return e14.host === null || e14.host === "" || e14._cannotBeABaseURLFlag || e14.scheme === "file";
        }, t2.urlSerializer = T, t2.hostSerializer = E, t2.iPv4Serializer = D, t2.iPv6Serializer = O, t2.urlParser = function(e14, t3, n2) {
          var r2 = k(e14, t3, n2);
          return r2 === null ? null : (r2.scheme !== "blob" || (r2._blobURLEntry = null), r2);
        }, t2.basicURLParser = k, t2.setTheUsername = function(e14, t3) {
          var n2, a2, o2 = "";
          try {
            for (var s2 = r(t3), c2 = s2.next(); !c2.done; c2 = s2.next())
              o2 += G(c2.value, h);
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              c2 && !c2.done && (a2 = s2.return) && a2.call(s2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          e14.username = o2;
        }, t2.setThePassword = function(e14, t3) {
          var n2, a2, o2 = "";
          try {
            for (var s2 = r(t3), c2 = s2.next(); !c2.done; c2 = s2.next())
              o2 += G(c2.value, h);
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              c2 && !c2.done && (a2 = s2.return) && a2.call(s2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          e14.password = o2;
        }, t2.isSingleDotPathSegment = A, t2.isDoubleDotPathSegment = j, t2.shorten = M, t2.isNormalizedWindowsDriveLetter = N, t2.isWindowsDriveLetter = P, t2.startsWithAWindowsDriveLetter = F, t2.hostParser = I, t2.iPv4NumberParser = L, t2.iPv4Parser = R, t2.iPv6Parser = z, t2.opaqueHostParser = B, t2.resolveABlobURL = V, t2.percentEncode = H, t2.percentDecode = U, t2.stringPercentDecode = W, t2.utf8PercentEncode = G, t2.hostEquals = function(e14, t3) {
          return e14 === t3;
        }, t2.urlEquals = function(e14, t3, n2) {
          return n2 === void 0 && (n2 = false), T(e14, n2) === T(t3, n2);
        }, t2.urlEncodedStringParser = function(e14) {
          return K(s.utf8Encode(e14));
        }, t2.urlEncodedParser = K, t2.urlEncodedByteSerializer = q, t2.urlEncodedSerializer = function(e14, t3) {
          var n2, a2;
          if ((t3 === void 0 || t3 === "replacement" || t3 === "UTF-16BE" || t3 === "UTF-16LE" ? "UTF-8" : t3).toUpperCase() !== "UTF-8")
            throw Error("Only UTF-8 encoding is supported.");
          var o2 = "";
          try {
            for (var c2 = r(e14), l2 = c2.next(); !l2.done; l2 = c2.next()) {
              var u2 = l2.value, d2 = q(s.utf8Encode(u2[0])), f2 = u2[1];
              f2 = q(s.utf8Encode(f2)), o2 !== "" && (o2 += "&"), o2 += d2 + "=" + f2;
            }
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              l2 && !l2.done && (a2 = c2.return) && a2.call(c2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          return o2;
        }, t2.origin = function e14(t3) {
          switch (t3.scheme) {
            case "blob":
              t3._blobURLEntry;
              var n2 = k(t3.path[0]);
              return n2 === null ? c.OpaqueOrigin : e14(n2);
            case "ftp":
            case "http":
            case "https":
            case "ws":
            case "wss":
              return [
                t3.scheme,
                t3.host === null ? "" : t3.host,
                t3.port,
                null
              ];
            case "file":
            default:
              return c.OpaqueOrigin;
          }
        }, t2.domainToASCII = J, t2.domainToUnicode = function(e14, t3) {
          t3 === void 0 && (t3 = false);
          var n2 = u.domainToUnicode(e14);
          return n2 === "" && v("Invalid domain name."), n2;
        }, t2.asciiSerializationOfAnOrigin = function(e14) {
          if (e14[0] === "" && e14[1] === "" && e14[2] === null && e14[3] === null)
            return "null";
          var t3 = e14[0] + "://" + E(e14[1]);
          return e14[2] !== null && (t3 += ":" + e14[2].toString()), t3;
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(0);
        t2.AbortControllerImpl = function() {
          function e14() {
            this._signal = r.create_abortSignal();
          }
          return Object.defineProperty(e14.prototype, "signal", {
            get: function() {
              return this._signal;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.abort = function() {
            r.abort_signalAbort(this._signal);
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(70), s = n(0);
        t2.AbortSignalImpl = function(e14) {
          function t3() {
            var t4 = e14.call(this) || this;
            return t4._abortedFlag = false, t4._abortAlgorithms = /* @__PURE__ */ new Set(), t4;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "aborted", {
            get: function() {
              return this._abortedFlag;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "onabort", {
            get: function() {
              return s.event_getterEventHandlerIDLAttribute(this, "onabort");
            },
            set: function(e15) {
              s.event_setterEventHandlerIDLAttribute(this, "onabort", e15);
            },
            enumerable: true,
            configurable: true
          }), t3._create = function() {
            return new t3();
          }, t3;
        }(o.EventTargetImpl);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(2), s = n(34), c = n(12), l = function(e14) {
          function t3(t4, n2, r2) {
            var a2 = e14.call(this) || this;
            return a2._name = "", a2._publicId = "", a2._systemId = "", a2._name = t4, a2._publicId = n2, a2._systemId = r2, a2;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "name", {
            get: function() {
              return this._name;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "publicId", {
            get: function() {
              return this._publicId;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "systemId", {
            get: function() {
              return this._systemId;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.before = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3.prototype.after = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3.prototype.replaceWith = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3.prototype.remove = function() {
            throw Error("Mixin: ChildNode not implemented.");
          }, t3._create = function(e15, n2, r2, a2) {
            r2 === void 0 && (r2 = ""), a2 === void 0 && (a2 = "");
            var o2 = new t3(n2, r2, a2);
            return o2._nodeDocument = e15, o2;
          }, t3;
        }(s.NodeImpl);
        t2.DocumentTypeImpl = l, c.idl_defineConst(l.prototype, "_nodeType", o.NodeType.DocumentType);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(100), s = n(1), c = n(0);
        t2.ShadowRootImpl = function(e14) {
          function t3(t4, n2) {
            var r2 = e14.call(this) || this;
            return r2._host = t4, r2._mode = n2, r2;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "mode", {
            get: function() {
              return this._mode;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "host", {
            get: function() {
              return this._host;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype._getTheParent = function(e15) {
            return e15._composedFlag || s.isEmpty(e15._path) || c.tree_rootNode(e15._path[0].invocationTarget) !== this ? this._host : null;
          }, t3._create = function(e15, n2) {
            return new t3(n2, "closed");
          }, t3;
        }(o.DocumentFragmentImpl);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(2), s = n(34), c = n(0), l = n(12), u = function(e14) {
          function t3(t4) {
            var n2 = e14.call(this) || this;
            return n2._namespace = null, n2._namespacePrefix = null, n2._element = null, n2._value = "", n2._localName = t4, n2;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "ownerElement", {
            get: function() {
              return this._element;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "namespaceURI", {
            get: function() {
              return this._namespace;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "prefix", {
            get: function() {
              return this._namespacePrefix;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "localName", {
            get: function() {
              return this._localName;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "name", {
            get: function() {
              return this._qualifiedName;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "value", {
            get: function() {
              return this._value;
            },
            set: function(e15) {
              c.attr_setAnExistingAttributeValue(this, e15);
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "_qualifiedName", {
            get: function() {
              return this._namespacePrefix === null ? this._localName : this._namespacePrefix + ":" + this._localName;
            },
            enumerable: true,
            configurable: true
          }), t3._create = function(e15, n2) {
            var r2 = new t3(n2);
            return r2._nodeDocument = e15, r2;
          }, t3;
        }(s.NodeImpl);
        t2.AttrImpl = u, l.idl_defineConst(u.prototype, "_nodeType", o.NodeType.Attribute), l.idl_defineConst(u.prototype, "specified", true);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(101), s = n(2), c = n(12), l = function(e14) {
          function t3(t4) {
            return e14.call(this, t4) || this;
          }
          return a(t3, e14), t3._create = function(e15, n2) {
            n2 === void 0 && (n2 = "");
            var r2 = new t3(n2);
            return r2._nodeDocument = e15, r2;
          }, t3;
        }(o.TextImpl);
        t2.CDATASectionImpl = l, c.idl_defineConst(l.prototype, "_nodeType", s.NodeType.CData);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(2), s = n(71), c = n(12), l = function(e14) {
          function t3(t4) {
            return t4 === void 0 && (t4 = ""), e14.call(this, t4) || this;
          }
          return a(t3, e14), t3._create = function(e15, n2) {
            n2 === void 0 && (n2 = "");
            var r2 = new t3(n2);
            return r2._nodeDocument = e15, r2;
          }, t3;
        }(s.CharacterDataImpl);
        t2.CommentImpl = l, c.idl_defineConst(l.prototype, "_nodeType", o.NodeType.Comment);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(2), s = n(71), c = n(12), l = function(e14) {
          function t3(t4, n2) {
            var r2 = e14.call(this, n2) || this;
            return r2._target = t4, r2;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "target", {
            get: function() {
              return this._target;
            },
            enumerable: true,
            configurable: true
          }), t3._create = function(e15, n2, r2) {
            var a2 = new t3(n2, r2);
            return a2._nodeDocument = e15, a2;
          }, t3;
        }(s.CharacterDataImpl);
        t2.ProcessingInstructionImpl = l, c.idl_defineConst(l.prototype, "_nodeType", o.NodeType.ProcessingInstruction);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(7), a = n(0), o = n(3), s = n(1);
        t2.HTMLCollectionImpl = function() {
          function e14(e15, t3) {
            return this._live = true, this._root = e15, this._filter = t3, new Proxy(this, this);
          }
          return Object.defineProperty(e14.prototype, "length", {
            get: function() {
              for (var e15 = this, t3 = 0, n2 = a.tree_getFirstDescendantNode(this._root, false, false, function(t4) {
                return o.Guard.isElementNode(t4) && e15._filter(t4);
              }); n2 !== null; )
                t3++, n2 = a.tree_getNextDescendantNode(this._root, n2, false, false, function(t4) {
                  return o.Guard.isElementNode(t4) && e15._filter(t4);
                });
              return t3;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.item = function(e15) {
            for (var t3 = this, n2 = 0, r2 = a.tree_getFirstDescendantNode(this._root, false, false, function(e16) {
              return o.Guard.isElementNode(e16) && t3._filter(e16);
            }); r2 !== null; ) {
              if (n2 === e15)
                return r2;
              n2++, r2 = a.tree_getNextDescendantNode(this._root, r2, false, false, function(e16) {
                return o.Guard.isElementNode(e16) && t3._filter(e16);
              });
            }
            return null;
          }, e14.prototype.namedItem = function(e15) {
            var t3 = this;
            if (e15 === "")
              return null;
            for (var n2 = a.tree_getFirstDescendantNode(this._root, false, false, function(e16) {
              return o.Guard.isElementNode(e16) && t3._filter(e16);
            }); n2 != null; ) {
              if (n2._uniqueIdentifier === e15)
                return n2;
              if (n2._namespace === r.namespace.HTML)
                for (var s2 = 0; s2 < n2._attributeList.length; s2++) {
                  var c = n2._attributeList[s2];
                  if (c._localName === "name" && c._namespace === null && c._namespacePrefix === null && c._value === e15)
                    return n2;
                }
              n2 = a.tree_getNextDescendantNode(this._root, n2, false, false, function(e16) {
                return o.Guard.isElementNode(e16) && t3._filter(e16);
              });
            }
            return null;
          }, e14.prototype[Symbol.iterator] = function() {
            var e15 = this._root, t3 = this._filter, n2 = a.tree_getFirstDescendantNode(e15, false, false, function(e16) {
              return o.Guard.isElementNode(e16) && t3(e16);
            });
            return { next: function() {
              if (n2 === null)
                return {
                  done: true,
                  value: null
                };
              var r2 = {
                done: false,
                value: n2
              };
              return n2 = a.tree_getNextDescendantNode(e15, n2, false, false, function(e16) {
                return o.Guard.isElementNode(e16) && t3(e16);
              }), r2;
            } };
          }, e14.prototype.get = function(t3, n2, r2) {
            if (!s.isString(n2) || e14.reservedNames.indexOf(n2) !== -1)
              return Reflect.get(t3, n2, r2);
            var a2 = Number(n2);
            return isNaN(a2) ? t3.namedItem(n2) || void 0 : t3.item(a2) || void 0;
          }, e14.prototype.set = function(t3, n2, r2, o2) {
            if (!s.isString(n2) || e14.reservedNames.indexOf(n2) !== -1)
              return Reflect.set(t3, n2, r2, o2);
            var c = Number(n2), l = isNaN(c) ? t3.namedItem(n2) || void 0 : t3.item(c) || void 0;
            return !(!l || !l._parent) && (a.mutation_replace(l, r2, l._parent), true);
          }, e14._create = function(t3, n2) {
            return n2 === void 0 && (n2 = function() {
              return true;
            }), new e14(t3, n2);
          }, e14.reservedNames = [
            "_root",
            "_live",
            "_filter",
            "length",
            "item",
            "namedItem",
            "get",
            "set"
          ], e14;
        }();
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(6), o = n(1), s = n(0);
        t2.NodeListImpl = function() {
          function e14(e15) {
            return this._live = true, this._filter = null, this._length = 0, this._root = e15, new Proxy(this, this);
          }
          return Object.defineProperty(e14.prototype, "length", {
            get: function() {
              return this._root._children.size;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.item = function(e15) {
            if (e15 < 0 || e15 > this.length - 1)
              return null;
            if (e15 < this.length / 2) {
              for (var t3 = 0, n2 = this._root._firstChild; n2 !== null && t3 !== e15; )
                n2 = n2._nextSibling, t3++;
              return n2;
            }
            for (t3 = this.length - 1, n2 = this._root._lastChild; n2 !== null && t3 !== e15; )
              n2 = n2._previousSibling, t3--;
            return n2;
          }, e14.prototype.keys = function() {
            var e15;
            return (e15 = {})[Symbol.iterator] = function() {
              var e16 = 0;
              return { next: function() {
                return e16 === this.length ? {
                  done: true,
                  value: null
                } : {
                  done: false,
                  value: e16++
                };
              }.bind(this) };
            }.bind(this), e15;
          }, e14.prototype.values = function() {
            var e15;
            return (e15 = {})[Symbol.iterator] = function() {
              var e16 = this[Symbol.iterator]();
              return { next: function() {
                return e16.next();
              } };
            }.bind(this), e15;
          }, e14.prototype.entries = function() {
            var e15;
            return (e15 = {})[Symbol.iterator] = function() {
              var e16 = this[Symbol.iterator](), t3 = 0;
              return { next: function() {
                var n2 = e16.next();
                return n2.done ? {
                  done: true,
                  value: null
                } : {
                  done: false,
                  value: [t3++, n2.value]
                };
              } };
            }.bind(this), e15;
          }, e14.prototype[Symbol.iterator] = function() {
            return this._root._children[Symbol.iterator]();
          }, e14.prototype.forEach = function(e15, t3) {
            var n2, o2;
            t3 === void 0 && (t3 = a.dom.window);
            var s2 = 0;
            try {
              for (var c = r(this._root._children), l = c.next(); !l.done; l = c.next()) {
                var u = l.value;
                e15.call(t3, u, s2++, this);
              }
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                l && !l.done && (o2 = c.return) && o2.call(c);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          }, e14.prototype.get = function(e15, t3, n2) {
            if (!o.isString(t3))
              return Reflect.get(e15, t3, n2);
            var r2 = Number(t3);
            return isNaN(r2) ? Reflect.get(e15, t3, n2) : e15.item(r2) || void 0;
          }, e14.prototype.set = function(e15, t3, n2, r2) {
            if (!o.isString(t3))
              return Reflect.set(e15, t3, n2, r2);
            var a2 = Number(t3);
            if (isNaN(a2))
              return Reflect.set(e15, t3, n2, r2);
            var c = e15.item(a2) || void 0;
            return !!c && !!c._parent && (s.mutation_replace(c, n2, c._parent), true);
          }, e14._create = function(t3) {
            return new e14(t3);
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(6), o = n(1);
        t2.NodeListStaticImpl = function() {
          function e14(e15) {
            return this._live = false, this._items = [], this._length = 0, this._root = e15, this._items = [], this._filter = function(e16) {
              return true;
            }, new Proxy(this, this);
          }
          return Object.defineProperty(e14.prototype, "length", {
            get: function() {
              return this._items.length;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.item = function(e15) {
            return e15 < 0 || e15 > this.length - 1 ? null : this._items[e15];
          }, e14.prototype.keys = function() {
            var e15;
            return (e15 = {})[Symbol.iterator] = function() {
              var e16 = 0;
              return { next: function() {
                return e16 === this.length ? {
                  done: true,
                  value: null
                } : {
                  done: false,
                  value: e16++
                };
              }.bind(this) };
            }.bind(this), e15;
          }, e14.prototype.values = function() {
            var e15;
            return (e15 = {})[Symbol.iterator] = function() {
              var e16 = this[Symbol.iterator]();
              return { next: function() {
                return e16.next();
              } };
            }.bind(this), e15;
          }, e14.prototype.entries = function() {
            var e15;
            return (e15 = {})[Symbol.iterator] = function() {
              var e16 = this[Symbol.iterator](), t3 = 0;
              return { next: function() {
                var n2 = e16.next();
                return n2.done ? {
                  done: true,
                  value: null
                } : {
                  done: false,
                  value: [t3++, n2.value]
                };
              } };
            }.bind(this), e15;
          }, e14.prototype[Symbol.iterator] = function() {
            var e15 = this._items[Symbol.iterator]();
            return { next: function() {
              return e15.next();
            } };
          }, e14.prototype.forEach = function(e15, t3) {
            var n2, o2;
            t3 === void 0 && (t3 = a.dom.window);
            var s = 0;
            try {
              for (var c = r(this._items), l = c.next(); !l.done; l = c.next()) {
                var u = l.value;
                e15.call(t3, u, s++, this);
              }
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                l && !l.done && (o2 = c.return) && o2.call(c);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          }, e14.prototype.get = function(e15, t3, n2) {
            if (!o.isString(t3))
              return Reflect.get(e15, t3, n2);
            var r2 = Number(t3);
            return isNaN(r2) ? Reflect.get(e15, t3, n2) : e15._items[r2] || void 0;
          }, e14.prototype.set = function(e15, t3, n2, r2) {
            if (!o.isString(t3))
              return Reflect.set(e15, t3, n2, r2);
            var a2 = Number(t3);
            return isNaN(a2) ? Reflect.set(e15, t3, n2, r2) : a2 >= 0 && a2 < e15._items.length && (e15._items[a2] = n2, true);
          }, e14._create = function(t3, n2) {
            var r2 = new e14(t3);
            return r2._items = n2, r2;
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(9), s = n(0);
        t2.NamedNodeMapImpl = function(e14) {
          function t3(n2) {
            var r2 = e14.call(this) || this;
            return r2._element = n2, Object.setPrototypeOf(r2, t3.prototype), r2;
          }
          return a(t3, e14), t3.prototype._asArray = function() {
            return this;
          }, t3.prototype.item = function(e15) {
            return this[e15] || null;
          }, t3.prototype.getNamedItem = function(e15) {
            return s.element_getAnAttributeByName(e15, this._element);
          }, t3.prototype.getNamedItemNS = function(e15, t4) {
            return s.element_getAnAttributeByNamespaceAndLocalName(e15 || "", t4, this._element);
          }, t3.prototype.setNamedItem = function(e15) {
            return s.element_setAnAttribute(e15, this._element);
          }, t3.prototype.setNamedItemNS = function(e15) {
            return s.element_setAnAttribute(e15, this._element);
          }, t3.prototype.removeNamedItem = function(e15) {
            var t4 = s.element_removeAnAttributeByName(e15, this._element);
            if (t4 === null)
              throw new o.NotFoundError();
            return t4;
          }, t3.prototype.removeNamedItemNS = function(e15, t4) {
            var n2 = s.element_removeAnAttributeByNamespaceAndLocalName(e15 || "", t4, this._element);
            if (n2 === null)
              throw new o.NotFoundError();
            return n2;
          }, t3._create = function(e15) {
            return new t3(e15);
          }, t3;
        }(Array);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(6), c = n(2), l = n(102), u = n(9), d = n(0), f = n(12), p = n(3), m = function(e14) {
          function t3() {
            var t4 = e14.call(this) || this, n2 = s.dom.window._associatedDocument;
            return t4._start = [n2, 0], t4._end = [n2, 0], s.dom.rangeList.add(t4), t4;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "commonAncestorContainer", {
            get: function() {
              for (var e15 = this._start[0]; !d.tree_isAncestorOf(this._end[0], e15, true); ) {
                if (e15._parent === null)
                  throw Error("Parent node  is null.");
                e15 = e15._parent;
              }
              return e15;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.setStart = function(e15, t4) {
            d.range_setTheStart(this, e15, t4);
          }, t3.prototype.setEnd = function(e15, t4) {
            d.range_setTheEnd(this, e15, t4);
          }, t3.prototype.setStartBefore = function(e15) {
            var t4 = e15._parent;
            if (t4 === null)
              throw new u.InvalidNodeTypeError();
            d.range_setTheStart(this, t4, d.tree_index(e15));
          }, t3.prototype.setStartAfter = function(e15) {
            var t4 = e15._parent;
            if (t4 === null)
              throw new u.InvalidNodeTypeError();
            d.range_setTheStart(this, t4, d.tree_index(e15) + 1);
          }, t3.prototype.setEndBefore = function(e15) {
            var t4 = e15._parent;
            if (t4 === null)
              throw new u.InvalidNodeTypeError();
            d.range_setTheEnd(this, t4, d.tree_index(e15));
          }, t3.prototype.setEndAfter = function(e15) {
            var t4 = e15._parent;
            if (t4 === null)
              throw new u.InvalidNodeTypeError();
            d.range_setTheEnd(this, t4, d.tree_index(e15) + 1);
          }, t3.prototype.collapse = function(e15) {
            e15 ? this._end = this._start : this._start = this._end;
          }, t3.prototype.selectNode = function(e15) {
            d.range_select(e15, this);
          }, t3.prototype.selectNodeContents = function(e15) {
            if (p.Guard.isDocumentTypeNode(e15))
              throw new u.InvalidNodeTypeError();
            var t4 = d.tree_nodeLength(e15);
            this._start = [e15, 0], this._end = [e15, t4];
          }, t3.prototype.compareBoundaryPoints = function(e15, t4) {
            if (e15 !== c.HowToCompare.StartToStart && e15 !== c.HowToCompare.StartToEnd && e15 !== c.HowToCompare.EndToEnd && e15 !== c.HowToCompare.EndToStart)
              throw new u.NotSupportedError();
            if (d.range_root(this) !== d.range_root(t4))
              throw new u.WrongDocumentError();
            var n2, r2;
            switch (e15) {
              case c.HowToCompare.StartToStart:
                n2 = this._start, r2 = t4._start;
                break;
              case c.HowToCompare.StartToEnd:
                n2 = this._end, r2 = t4._start;
                break;
              case c.HowToCompare.EndToEnd:
                n2 = this._end, r2 = t4._end;
                break;
              case c.HowToCompare.EndToStart:
                n2 = this._start, r2 = t4._end;
                break;
              default:
                throw new u.NotSupportedError();
            }
            var a2 = d.boundaryPoint_position(n2, r2);
            return a2 === c.BoundaryPosition.Before ? -1 : a2 === c.BoundaryPosition.After ? 1 : 0;
          }, t3.prototype.deleteContents = function() {
            var e15, t4, n2, r2;
            if (!d.range_collapsed(this)) {
              var a2 = this._startNode, s2 = this._startOffset, c2 = this._endNode, l2 = this._endOffset;
              if (a2 === c2 && p.Guard.isCharacterDataNode(a2))
                d.characterData_replaceData(a2, s2, l2 - s2, "");
              else {
                var u2, f2, m2 = [];
                try {
                  for (var h = o(d.range_getContainedNodes(this)), g = h.next(); !g.done; g = h.next()) {
                    var _ = (S = g.value)._parent;
                    _ !== null && d.range_isContained(_, this) || m2.push(S);
                  }
                } catch (t5) {
                  e15 = { error: t5 };
                } finally {
                  try {
                    g && !g.done && (t4 = h.return) && t4.call(h);
                  } finally {
                    if (e15)
                      throw e15.error;
                  }
                }
                if (d.tree_isAncestorOf(c2, a2, true))
                  u2 = a2, f2 = s2;
                else {
                  for (var v = a2; v._parent !== null && !d.tree_isAncestorOf(c2, v._parent, true); )
                    v = v._parent;
                  if (v._parent === null)
                    throw Error("Parent node is null.");
                  u2 = v._parent, f2 = d.tree_index(v) + 1;
                }
                p.Guard.isCharacterDataNode(a2) && d.characterData_replaceData(a2, s2, d.tree_nodeLength(a2) - s2, "");
                try {
                  for (var y = o(m2), b = y.next(); !b.done; b = y.next()) {
                    var S;
                    (S = b.value)._parent && d.mutation_remove(S, S._parent);
                  }
                } catch (e16) {
                  n2 = { error: e16 };
                } finally {
                  try {
                    b && !b.done && (r2 = y.return) && r2.call(y);
                  } finally {
                    if (n2)
                      throw n2.error;
                  }
                }
                p.Guard.isCharacterDataNode(c2) && d.characterData_replaceData(c2, 0, l2, ""), this._start = [u2, f2], this._end = [u2, f2];
              }
            }
          }, t3.prototype.extractContents = function() {
            return d.range_extract(this);
          }, t3.prototype.cloneContents = function() {
            return d.range_cloneTheContents(this);
          }, t3.prototype.insertNode = function(e15) {
            return d.range_insert(e15, this);
          }, t3.prototype.surroundContents = function(e15) {
            var t4, n2;
            try {
              for (var r2 = o(d.range_getPartiallyContainedNodes(this)), a2 = r2.next(); !a2.done; a2 = r2.next()) {
                var s2 = a2.value;
                if (!p.Guard.isTextNode(s2))
                  throw new u.InvalidStateError();
              }
            } catch (e16) {
              t4 = { error: e16 };
            } finally {
              try {
                a2 && !a2.done && (n2 = r2.return) && n2.call(r2);
              } finally {
                if (t4)
                  throw t4.error;
              }
            }
            if (p.Guard.isDocumentNode(e15) || p.Guard.isDocumentTypeNode(e15) || p.Guard.isDocumentFragmentNode(e15))
              throw new u.InvalidNodeTypeError();
            var c2 = d.range_extract(this);
            e15._children.size !== 0 && d.mutation_replaceAll(null, e15), d.range_insert(e15, this), d.mutation_append(c2, e15), d.range_select(e15, this);
          }, t3.prototype.cloneRange = function() {
            return d.create_range(this._start, this._end);
          }, t3.prototype.detach = function() {
            s.dom.rangeList.delete(this);
          }, t3.prototype.isPointInRange = function(e15, t4) {
            if (d.tree_rootNode(e15) !== d.range_root(this))
              return false;
            if (p.Guard.isDocumentTypeNode(e15))
              throw new u.InvalidNodeTypeError();
            if (t4 > d.tree_nodeLength(e15))
              throw new u.IndexSizeError();
            var n2 = [e15, t4];
            return d.boundaryPoint_position(n2, this._start) !== c.BoundaryPosition.Before && d.boundaryPoint_position(n2, this._end) !== c.BoundaryPosition.After;
          }, t3.prototype.comparePoint = function(e15, t4) {
            if (d.tree_rootNode(e15) !== d.range_root(this))
              throw new u.WrongDocumentError();
            if (p.Guard.isDocumentTypeNode(e15))
              throw new u.InvalidNodeTypeError();
            if (t4 > d.tree_nodeLength(e15))
              throw new u.IndexSizeError();
            var n2 = [e15, t4];
            return d.boundaryPoint_position(n2, this._start) === c.BoundaryPosition.Before ? -1 : d.boundaryPoint_position(n2, this._end) === c.BoundaryPosition.After ? 1 : 0;
          }, t3.prototype.intersectsNode = function(e15) {
            if (d.tree_rootNode(e15) !== d.range_root(this))
              return false;
            var t4 = e15._parent;
            if (t4 === null)
              return true;
            var n2 = d.tree_index(e15);
            return d.boundaryPoint_position([t4, n2], this._end) === c.BoundaryPosition.Before && d.boundaryPoint_position([t4, n2 + 1], this._start) === c.BoundaryPosition.After;
          }, t3.prototype.toString = function() {
            var e15, t4, n2 = "";
            if (this._startNode === this._endNode && p.Guard.isTextNode(this._startNode))
              return this._startNode._data.substring(this._startOffset, this._endOffset);
            p.Guard.isTextNode(this._startNode) && (n2 += this._startNode._data.substring(this._startOffset));
            try {
              for (var r2 = o(d.range_getContainedNodes(this)), a2 = r2.next(); !a2.done; a2 = r2.next()) {
                var s2 = a2.value;
                p.Guard.isTextNode(s2) && (n2 += s2._data);
              }
            } catch (t5) {
              e15 = { error: t5 };
            } finally {
              try {
                a2 && !a2.done && (t4 = r2.return) && t4.call(r2);
              } finally {
                if (e15)
                  throw e15.error;
              }
            }
            return p.Guard.isTextNode(this._endNode) && (n2 += this._endNode._data.substring(0, this._endOffset)), n2;
          }, t3._create = function(e15, n2) {
            var r2 = new t3();
            return e15 && (r2._start = e15), n2 && (r2._end = n2), r2;
          }, t3.START_TO_START = 0, t3.START_TO_END = 1, t3.END_TO_END = 2, t3.END_TO_START = 3, t3;
        }(l.AbstractRangeImpl);
        t2.RangeImpl = m, f.idl_defineConst(m.prototype, "START_TO_START", 0), f.idl_defineConst(m.prototype, "START_TO_END", 1), f.idl_defineConst(m.prototype, "END_TO_END", 2), f.idl_defineConst(m.prototype, "END_TO_START", 3);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(103), s = n(0);
        t2.NodeIteratorImpl = function(e14) {
          function t3(t4, n2, r2) {
            var a2 = e14.call(this, t4) || this;
            return a2._iteratorCollection = void 0, a2._reference = n2, a2._pointerBeforeReference = r2, s.nodeIterator_iteratorList().add(a2), a2;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "referenceNode", {
            get: function() {
              return this._reference;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(t3.prototype, "pointerBeforeReferenceNode", {
            get: function() {
              return this._pointerBeforeReference;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.nextNode = function() {
            return s.nodeIterator_traverse(this, true);
          }, t3.prototype.previousNode = function() {
            return s.nodeIterator_traverse(this, false);
          }, t3.prototype.detach = function() {
            s.nodeIterator_iteratorList().delete(this);
          }, t3._create = function(e15, n2, r2) {
            return new t3(e15, n2, r2);
          }, t3;
        }(o.TraverserImpl);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(2), s = n(103), c = n(0);
        t2.TreeWalkerImpl = function(e14) {
          function t3(t4, n2) {
            var r2 = e14.call(this, t4) || this;
            return r2._current = n2, r2;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "currentNode", {
            get: function() {
              return this._current;
            },
            set: function(e15) {
              this._current = e15;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.parentNode = function() {
            for (var e15 = this._current; e15 !== null && e15 !== this._root; )
              if ((e15 = e15._parent) !== null && c.traversal_filter(this, e15) === o.FilterResult.Accept)
                return this._current = e15, e15;
            return null;
          }, t3.prototype.firstChild = function() {
            return c.treeWalker_traverseChildren(this, true);
          }, t3.prototype.lastChild = function() {
            return c.treeWalker_traverseChildren(this, false);
          }, t3.prototype.nextSibling = function() {
            return c.treeWalker_traverseSiblings(this, true);
          }, t3.prototype.previousNode = function() {
            for (var e15 = this._current; e15 !== this._root; ) {
              for (var t4 = e15._previousSibling; t4; ) {
                e15 = t4;
                for (var n2 = c.traversal_filter(this, e15); n2 !== o.FilterResult.Reject && e15._lastChild; )
                  e15 = e15._lastChild, n2 = c.traversal_filter(this, e15);
                if (n2 === o.FilterResult.Accept)
                  return this._current = e15, e15;
                t4 = e15._previousSibling;
              }
              if (e15 === this._root || e15._parent === null)
                return null;
              if (e15 = e15._parent, c.traversal_filter(this, e15) === o.FilterResult.Accept)
                return this._current = e15, e15;
            }
            return null;
          }, t3.prototype.previousSibling = function() {
            return c.treeWalker_traverseSiblings(this, false);
          }, t3.prototype.nextNode = function() {
            for (var e15 = this._current, t4 = o.FilterResult.Accept; ; ) {
              for (; t4 !== o.FilterResult.Reject && e15._firstChild; )
                if (e15 = e15._firstChild, (t4 = c.traversal_filter(this, e15)) === o.FilterResult.Accept)
                  return this._current = e15, e15;
              for (var n2 = null, r2 = e15; r2 !== null; ) {
                if (r2 === this._root)
                  return null;
                if ((n2 = r2._nextSibling) !== null) {
                  e15 = n2;
                  break;
                }
                r2 = r2._parent;
              }
              if ((t4 = c.traversal_filter(this, e15)) === o.FilterResult.Accept)
                return this._current = e15, e15;
            }
          }, t3._create = function(e15, n2) {
            return new t3(e15, n2);
          }, t3;
        }(s.TraverserImpl);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(2), a = n(12), o = function() {
          function e14() {
          }
          return e14.prototype.acceptNode = function(e15) {
            return r.FilterResult.Accept;
          }, e14._create = function() {
            return new e14();
          }, e14.FILTER_ACCEPT = 1, e14.FILTER_REJECT = 2, e14.FILTER_SKIP = 3, e14.SHOW_ALL = 4294967295, e14.SHOW_ELEMENT = 1, e14.SHOW_ATTRIBUTE = 2, e14.SHOW_TEXT = 4, e14.SHOW_CDATA_SECTION = 8, e14.SHOW_ENTITY_REFERENCE = 16, e14.SHOW_ENTITY = 32, e14.SHOW_PROCESSING_INSTRUCTION = 64, e14.SHOW_COMMENT = 128, e14.SHOW_DOCUMENT = 256, e14.SHOW_DOCUMENT_TYPE = 512, e14.SHOW_DOCUMENT_FRAGMENT = 1024, e14.SHOW_NOTATION = 2048, e14;
        }();
        t2.NodeFilterImpl = o, a.idl_defineConst(o.prototype, "FILTER_ACCEPT", 1), a.idl_defineConst(o.prototype, "FILTER_REJECT", 2), a.idl_defineConst(o.prototype, "FILTER_SKIP", 3), a.idl_defineConst(o.prototype, "SHOW_ALL", 4294967295), a.idl_defineConst(o.prototype, "SHOW_ELEMENT", 1), a.idl_defineConst(o.prototype, "SHOW_ATTRIBUTE", 2), a.idl_defineConst(o.prototype, "SHOW_TEXT", 4), a.idl_defineConst(o.prototype, "SHOW_CDATA_SECTION", 8), a.idl_defineConst(o.prototype, "SHOW_ENTITY_REFERENCE", 16), a.idl_defineConst(o.prototype, "SHOW_ENTITY", 32), a.idl_defineConst(o.prototype, "SHOW_PROCESSING_INSTRUCTION", 64), a.idl_defineConst(o.prototype, "SHOW_COMMENT", 128), a.idl_defineConst(o.prototype, "SHOW_DOCUMENT", 256), a.idl_defineConst(o.prototype, "SHOW_DOCUMENT_TYPE", 512), a.idl_defineConst(o.prototype, "SHOW_DOCUMENT_FRAGMENT", 1024), a.idl_defineConst(o.prototype, "SHOW_NOTATION", 2048);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.MutationRecordImpl = function() {
          function e14(e15, t3, n2, r, a, o, s, c, l) {
            this._type = e15, this._target = t3, this._addedNodes = n2, this._removedNodes = r, this._previousSibling = a, this._nextSibling = o, this._attributeName = s, this._attributeNamespace = c, this._oldValue = l;
          }
          return Object.defineProperty(e14.prototype, "type", {
            get: function() {
              return this._type;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "target", {
            get: function() {
              return this._target;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "addedNodes", {
            get: function() {
              return this._addedNodes;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "removedNodes", {
            get: function() {
              return this._removedNodes;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "previousSibling", {
            get: function() {
              return this._previousSibling;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "nextSibling", {
            get: function() {
              return this._nextSibling;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "attributeName", {
            get: function() {
              return this._attributeName;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "attributeNamespace", {
            get: function() {
              return this._attributeNamespace;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "oldValue", {
            get: function() {
              return this._oldValue;
            },
            enumerable: true,
            configurable: true
          }), e14._create = function(t3, n2, r, a, o, s, c, l, u) {
            return new e14(t3, n2, r, a, o, s, c, l, u);
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(6), o = n(9), s = n(7), c = n(0);
        t2.DOMTokenListImpl = function() {
          function e14(e15, t3) {
            this._element = e15, this._attribute = t3, this._tokenSet = /* @__PURE__ */ new Set();
            var n2 = t3._localName, r2 = c.element_getAnAttributeValue(e15, n2), o2 = this;
            this._element._attributeChangeSteps.push(function(e16, t4, n3, r3, a2) {
              t4 === o2._attribute._localName && a2 === null && (r3 ? o2._tokenSet = c.orderedSet_parse(r3) : o2._tokenSet.clear());
            }), a.dom.features.steps && c.dom_runAttributeChangeSteps(e15, n2, r2, r2, null);
          }
          return Object.defineProperty(e14.prototype, "length", {
            get: function() {
              return this._tokenSet.size;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.item = function(e15) {
            var t3, n2, a2 = 0;
            try {
              for (var o2 = r(this._tokenSet), s2 = o2.next(); !s2.done; s2 = o2.next()) {
                var c2 = s2.value;
                if (a2 === e15)
                  return c2;
                a2++;
              }
            } catch (e16) {
              t3 = { error: e16 };
            } finally {
              try {
                s2 && !s2.done && (n2 = o2.return) && n2.call(o2);
              } finally {
                if (t3)
                  throw t3.error;
              }
            }
            return null;
          }, e14.prototype.contains = function(e15) {
            return this._tokenSet.has(e15);
          }, e14.prototype.add = function() {
            for (var e15, t3, n2 = [], a2 = 0; a2 < arguments.length; a2++)
              n2[a2] = arguments[a2];
            try {
              for (var l = r(n2), u = l.next(); !u.done; u = l.next()) {
                var d = u.value;
                if (d === "")
                  throw new o.SyntaxError("Cannot add an empty token.");
                if (s.codePoint.ASCIIWhiteSpace.test(d))
                  throw new o.InvalidCharacterError("Token cannot contain whitespace.");
                this._tokenSet.add(d);
              }
            } catch (t4) {
              e15 = { error: t4 };
            } finally {
              try {
                u && !u.done && (t3 = l.return) && t3.call(l);
              } finally {
                if (e15)
                  throw e15.error;
              }
            }
            c.tokenList_updateSteps(this);
          }, e14.prototype.remove = function() {
            for (var e15, t3, n2 = [], a2 = 0; a2 < arguments.length; a2++)
              n2[a2] = arguments[a2];
            try {
              for (var l = r(n2), u = l.next(); !u.done; u = l.next()) {
                var d = u.value;
                if (d === "")
                  throw new o.SyntaxError("Cannot remove an empty token.");
                if (s.codePoint.ASCIIWhiteSpace.test(d))
                  throw new o.InvalidCharacterError("Token cannot contain whitespace.");
                this._tokenSet.delete(d);
              }
            } catch (t4) {
              e15 = { error: t4 };
            } finally {
              try {
                u && !u.done && (t3 = l.return) && t3.call(l);
              } finally {
                if (e15)
                  throw e15.error;
              }
            }
            c.tokenList_updateSteps(this);
          }, e14.prototype.toggle = function(e15, t3) {
            if (t3 === void 0 && (t3 = void 0), e15 === "")
              throw new o.SyntaxError("Cannot toggle an empty token.");
            if (s.codePoint.ASCIIWhiteSpace.test(e15))
              throw new o.InvalidCharacterError("Token cannot contain whitespace.");
            return this._tokenSet.has(e15) ? t3 !== void 0 && false !== t3 || (this._tokenSet.delete(e15), c.tokenList_updateSteps(this), false) : (t3 === void 0 || true === t3) && (this._tokenSet.add(e15), c.tokenList_updateSteps(this), true);
          }, e14.prototype.replace = function(e15, t3) {
            if (e15 === "" || t3 === "")
              throw new o.SyntaxError("Cannot replace an empty token.");
            if (s.codePoint.ASCIIWhiteSpace.test(e15) || s.codePoint.ASCIIWhiteSpace.test(t3))
              throw new o.InvalidCharacterError("Token cannot contain whitespace.");
            return !!this._tokenSet.has(e15) && (s.set.replace(this._tokenSet, e15, t3), c.tokenList_updateSteps(this), true);
          }, e14.prototype.supports = function(e15) {
            return c.tokenList_validationSteps(this, e15);
          }, Object.defineProperty(e14.prototype, "value", {
            get: function() {
              return c.tokenList_serializeSteps(this);
            },
            set: function(e15) {
              c.element_setAnAttributeValue(this._element, this._attribute._localName, e15);
            },
            enumerable: true,
            configurable: true
          }), e14.prototype[Symbol.iterator] = function() {
            var e15 = this._tokenSet[Symbol.iterator]();
            return { next: function() {
              return e15.next();
            } };
          }, e14._create = function(t3, n2) {
            return new e14(t3, n2);
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(104), s = n(0);
        t2.CustomEventImpl = function(e14) {
          function t3(t4, n2) {
            var r2 = e14.call(this, t4, n2) || this;
            return r2._detail = null, r2._detail = n2 && n2.detail || null, r2;
          }
          return a(t3, e14), Object.defineProperty(t3.prototype, "detail", {
            get: function() {
              return this._detail;
            },
            enumerable: true,
            configurable: true
          }), t3.prototype.initCustomEvent = function(e15, t4, n2, r2) {
            t4 === void 0 && (t4 = false), n2 === void 0 && (n2 = false), r2 === void 0 && (r2 = null), this._dispatchFlag || (s.event_initialize(this, e15, t4, n2), this._detail = r2);
          }, t3;
        }(o.EventImpl);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(6), a = n(2), o = n(105), s = n(17);
        t2.nodeIterator_traverse = function(e14, t3) {
          for (var n2 = e14._reference, r2 = e14._pointerBeforeReference; ; ) {
            if (t3)
              if (r2)
                r2 = false;
              else {
                var c = s.tree_getFollowingNode(e14._root, n2);
                if (!c)
                  return null;
                n2 = c;
              }
            else if (r2) {
              var l = s.tree_getPrecedingNode(e14.root, n2);
              if (!l)
                return null;
              n2 = l;
            } else
              r2 = true;
            if (o.traversal_filter(e14, n2) === a.FilterResult.Accept)
              break;
          }
          return e14._reference = n2, e14._pointerBeforeReference = r2, n2;
        }, t2.nodeIterator_iteratorList = function() {
          return r.dom.window._iteratorList;
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(9), a = n(7), o = n(174);
        function s(e14) {
          if (!o.xml_isName(e14))
            throw new r.InvalidCharacterError("Invalid XML name: " + e14);
          if (!o.xml_isQName(e14))
            throw new r.InvalidCharacterError("Invalid XML qualified name: " + e14 + ".");
        }
        t2.namespace_validate = s, t2.namespace_validateAndExtract = function(e14, t3) {
          e14 ||= null, s(t3);
          var n2 = t3.split(":"), o2 = n2.length === 2 ? n2[0] : null, c = n2.length === 2 ? n2[1] : t3;
          if (o2 && e14 === null)
            throw new r.NamespaceError("Qualified name includes a prefix but the namespace is null.");
          if (o2 === "xml" && e14 !== a.namespace.XML)
            throw new r.NamespaceError('Qualified name includes the "xml" prefix but the namespace is not the XML namespace.');
          if (e14 !== a.namespace.XMLNS && (o2 === "xmlns" || t3 === "xmlns"))
            throw new r.NamespaceError('Qualified name includes the "xmlns" prefix but the namespace is not the XMLNS namespace.');
          if (e14 === a.namespace.XMLNS && o2 !== "xmlns" && t3 !== "xmlns")
            throw new r.NamespaceError('Qualified name does not include the "xmlns" prefix but the namespace is the XMLNS namespace.');
          return [
            e14,
            o2,
            c
          ];
        }, t2.namespace_extractQName = function(e14) {
          s(e14);
          var t3 = e14.split(":");
          return [t3.length === 2 ? t3[0] : null, t3.length === 2 ? t3[1] : e14];
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.xml_isName = function(e14) {
          for (var t3 = 0; t3 < e14.length; t3++) {
            var n2 = e14.charCodeAt(t3);
            if (!(n2 >= 97 && n2 <= 122 || n2 >= 65 && n2 <= 90 || n2 === 58 || n2 === 95 || n2 >= 192 && n2 <= 214 || n2 >= 216 && n2 <= 246 || n2 >= 248 && n2 <= 767 || n2 >= 880 && n2 <= 893 || n2 >= 895 && n2 <= 8191 || n2 >= 8204 && n2 <= 8205 || n2 >= 8304 && n2 <= 8591 || n2 >= 11264 && n2 <= 12271 || n2 >= 12289 && n2 <= 55295 || n2 >= 63744 && n2 <= 64975 || n2 >= 65008 && n2 <= 65533) && (t3 === 0 || !(n2 === 45 || n2 === 46 || n2 >= 48 && n2 <= 57 || n2 === 183 || n2 >= 768 && n2 <= 879 || n2 >= 8255 && n2 <= 8256))) {
              if (n2 >= 55296 && n2 <= 56319 && t3 < e14.length - 1) {
                var r = e14.charCodeAt(t3 + 1);
                if (r >= 56320 && r <= 57343 && (t3++, (n2 = 1024 * (n2 - 55296) + r - 56320 + 65536) >= 65536 && n2 <= 983039))
                  continue;
              }
              return false;
            }
          }
          return true;
        }, t2.xml_isQName = function(e14) {
          for (var t3 = false, n2 = 0; n2 < e14.length; n2++) {
            var r = e14.charCodeAt(n2);
            if (!(r >= 97 && r <= 122 || r >= 65 && r <= 90 || r === 95 || r >= 192 && r <= 214 || r >= 216 && r <= 246 || r >= 248 && r <= 767 || r >= 880 && r <= 893 || r >= 895 && r <= 8191 || r >= 8204 && r <= 8205 || r >= 8304 && r <= 8591 || r >= 11264 && r <= 12271 || r >= 12289 && r <= 55295 || r >= 63744 && r <= 64975 || r >= 65008 && r <= 65533) && (n2 === 0 || !(r === 45 || r === 46 || r >= 48 && r <= 57 || r === 183 || r >= 768 && r <= 879 || r >= 8255 && r <= 8256))) {
              if (n2 === 0 || r !== 58) {
                if (r >= 55296 && r <= 56319 && n2 < e14.length - 1) {
                  var a = e14.charCodeAt(n2 + 1);
                  if (a >= 56320 && a <= 57343 && (n2++, (r = 1024 * (r - 55296) + a - 56320 + 65536) >= 65536 && r <= 983039))
                    continue;
                }
                return false;
              }
              if (t3 || n2 === e14.length - 1)
                return false;
              t3 = true;
            }
          }
          return true;
        }, t2.xml_isLegalChar = function(e14) {
          for (var t3 = 0; t3 < e14.length; t3++) {
            var n2 = e14.charCodeAt(t3);
            if (!(n2 === 9 || n2 === 10 || n2 === 13 || n2 >= 32 && n2 <= 55295 || n2 >= 57344 && n2 <= 65533)) {
              if (n2 >= 55296 && n2 <= 56319 && t3 < e14.length - 1) {
                var r = e14.charCodeAt(t3 + 1);
                if (r >= 56320 && r <= 57343 && (t3++, (n2 = 1024 * (n2 - 55296) + r - 56320 + 65536) >= 65536 && n2 <= 1114111))
                  continue;
              }
              return false;
            }
          }
          return true;
        }, t2.xml_isPubidChar = function(e14) {
          for (var t3 = 0; t3 < e14.length; t3++) {
            var n2 = e14.charCodeAt(t3);
            if (!(n2 >= 97 && n2 <= 122 || n2 >= 65 && n2 <= 90 || n2 >= 39 && n2 <= 59 || n2 === 32 || n2 === 13 || n2 === 10 || n2 >= 35 && n2 <= 37 || n2 === 33 || n2 === 61 || n2 === 63 || n2 === 64 || n2 === 95))
              return false;
          }
          return true;
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(2), a = n(17);
        t2.boundaryPoint_position = function e14(t3, n2) {
          var o = t3[0], s = t3[1], c = n2[0], l = n2[1];
          if (console.assert(a.tree_rootNode(o) === a.tree_rootNode(c), "Boundary points must share the same root node."), o === c)
            return s === l ? r.BoundaryPosition.Equal : s < l ? r.BoundaryPosition.Before : r.BoundaryPosition.After;
          if (a.tree_isFollowing(c, o)) {
            var u = e14([c, l], [o, s]);
            if (u === r.BoundaryPosition.Before)
              return r.BoundaryPosition.After;
            if (u === r.BoundaryPosition.After)
              return r.BoundaryPosition.Before;
          }
          if (a.tree_isAncestorOf(c, o)) {
            for (var d = c; !a.tree_isChildOf(o, d); )
              d._parent !== null && (d = d._parent);
            if (a.tree_index(d) < s)
              return r.BoundaryPosition.After;
          }
          return r.BoundaryPosition.Before;
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(6), o = n(3), s = n(7), c = n(29), l = n(108), u = n(30), d = n(37), f = n(52);
        t2.node_stringReplaceAll = function(e14, t3) {
          var n2 = null;
          e14 !== "" && (n2 = c.create_text(t3._nodeDocument, e14)), d.mutation_replaceAll(n2, t3);
        }, t2.node_clone = function e14(t3, n2, s2) {
          var l2, p, m, h, g;
          if (n2 === void 0 && (n2 = null), s2 === void 0 && (s2 = false), n2 === null && (n2 = t3._nodeDocument), o.Guard.isElementNode(t3)) {
            g = f.element_createAnElement(n2, t3._localName, t3._namespace, t3._namespacePrefix, t3._is, false);
            try {
              for (var _ = r(t3._attributeList), v = _.next(); !v.done; v = _.next()) {
                var y = e14(v.value, n2);
                f.element_append(y, g);
              }
            } catch (e15) {
              l2 = { error: e15 };
            } finally {
              try {
                v && !v.done && (p = _.return) && p.call(_);
              } finally {
                if (l2)
                  throw l2.error;
              }
            }
          } else if (o.Guard.isDocumentNode(t3)) {
            var b = c.create_document();
            b._encoding = t3._encoding, b._contentType = t3._contentType, b._URL = t3._URL, b._origin = t3._origin, b._type = t3._type, b._mode = t3._mode, g = b;
          } else if (o.Guard.isDocumentTypeNode(t3))
            g = c.create_documentType(n2, t3._name, t3._publicId, t3._systemId);
          else if (o.Guard.isAttrNode(t3)) {
            var S = c.create_attr(n2, t3.localName);
            S._namespace = t3._namespace, S._namespacePrefix = t3._namespacePrefix, S._value = t3._value, g = S;
          } else
            g = o.Guard.isExclusiveTextNode(t3) ? c.create_text(n2, t3._data) : o.Guard.isCDATASectionNode(t3) ? c.create_cdataSection(n2, t3._data) : o.Guard.isCommentNode(t3) ? c.create_comment(n2, t3._data) : o.Guard.isProcessingInstructionNode(t3) ? c.create_processingInstruction(n2, t3._target, t3._data) : o.Guard.isDocumentFragmentNode(t3) ? c.create_documentFragment(n2) : Object.create(t3);
          if (o.Guard.isDocumentNode(g) ? (g._nodeDocument = g, n2 = g) : g._nodeDocument = n2, a.dom.features.steps && u.dom_runCloningSteps(g, t3, n2, s2), s2)
            try {
              for (var C = r(t3._children), w = C.next(); !w.done; w = C.next()) {
                var T = e14(w.value, n2, true);
                d.mutation_append(T, g);
              }
            } catch (e15) {
              m = { error: e15 };
            } finally {
              try {
                w && !w.done && (h = C.return) && h.call(C);
              } finally {
                if (m)
                  throw m.error;
              }
            }
          return g;
        }, t2.node_equals = function e14(t3, n2) {
          var a2, s2, c2, l2;
          if (t3._nodeType !== n2._nodeType)
            return false;
          if (o.Guard.isDocumentTypeNode(t3) && o.Guard.isDocumentTypeNode(n2)) {
            if (t3._name !== n2._name || t3._publicId !== n2._publicId || t3._systemId !== n2._systemId)
              return false;
          } else if (o.Guard.isElementNode(t3) && o.Guard.isElementNode(n2)) {
            if (t3._namespace !== n2._namespace || t3._namespacePrefix !== n2._namespacePrefix || t3._localName !== n2._localName || t3._attributeList.length !== n2._attributeList.length)
              return false;
          } else if (o.Guard.isAttrNode(t3) && o.Guard.isAttrNode(n2)) {
            if (t3._namespace !== n2._namespace || t3._localName !== n2._localName || t3._value !== n2._value)
              return false;
          } else if (o.Guard.isProcessingInstructionNode(t3) && o.Guard.isProcessingInstructionNode(n2)) {
            if (t3._target !== n2._target || t3._data !== n2._data)
              return false;
          } else if (o.Guard.isCharacterDataNode(t3) && o.Guard.isCharacterDataNode(n2) && t3._data !== n2._data)
            return false;
          if (o.Guard.isElementNode(t3) && o.Guard.isElementNode(n2)) {
            var u2 = {};
            try {
              for (var d2 = r(t3._attributeList), f2 = d2.next(); !f2.done; f2 = d2.next())
                u2[(h = f2.value)._localName] = h;
            } catch (e15) {
              a2 = { error: e15 };
            } finally {
              try {
                f2 && !f2.done && (s2 = d2.return) && s2.call(d2);
              } finally {
                if (a2)
                  throw a2.error;
              }
            }
            try {
              for (var p = r(n2._attributeList), m = p.next(); !m.done; m = p.next()) {
                var h, g = m.value;
                if (!(h = u2[g._localName]) || !e14(h, g))
                  return false;
              }
            } catch (e15) {
              c2 = { error: e15 };
            } finally {
              try {
                m && !m.done && (l2 = p.return) && l2.call(p);
              } finally {
                if (c2)
                  throw c2.error;
              }
            }
          }
          if (t3._children.size !== n2._children.size)
            return false;
          for (var _ = t3._children[Symbol.iterator](), v = n2._children[Symbol.iterator](), y = _.next(), b = v.next(); !y.done && !b.done; ) {
            if (!e14(y.value, b.value))
              return false;
            y = _.next(), b = v.next();
          }
          return true;
        }, t2.node_listOfElementsWithQualifiedName = function(e14, t3) {
          return e14 === "*" ? c.create_htmlCollection(t3) : t3._nodeDocument._type === "html" ? c.create_htmlCollection(t3, function(t4) {
            return t4._namespace === s.namespace.HTML && t4._qualifiedName === e14.toLowerCase() || t4._namespace !== s.namespace.HTML && t4._qualifiedName === e14;
          }) : c.create_htmlCollection(t3, function(t4) {
            return t4._qualifiedName === e14;
          });
        }, t2.node_listOfElementsWithNamespace = function(e14, t3, n2) {
          return e14 === "" && (e14 = null), e14 === "*" && t3 === "*" ? c.create_htmlCollection(n2) : e14 === "*" ? c.create_htmlCollection(n2, function(e15) {
            return e15._localName === t3;
          }) : t3 === "*" ? c.create_htmlCollection(n2, function(t4) {
            return t4._namespace === e14;
          }) : c.create_htmlCollection(n2, function(n3) {
            return n3._localName === t3 && n3._namespace === e14;
          });
        }, t2.node_listOfElementsWithClassNames = function(e14, t3) {
          var n2 = l.orderedSet_parse(e14);
          if (n2.size === 0)
            return c.create_htmlCollection(t3, function() {
              return false;
            });
          var r2 = t3._nodeDocument._mode !== "quirks";
          return c.create_htmlCollection(t3, function(e15) {
            var t4 = e15.classList;
            return l.orderedSet_contains(t4._tokenSet, n2, r2);
          });
        }, t2.node_locateANamespacePrefix = function e14(t3, n2) {
          if (t3._namespace === n2 && t3._namespacePrefix !== null)
            return t3._namespacePrefix;
          for (var r2 = 0; r2 < t3._attributeList.length; r2++) {
            var a2 = t3._attributeList[r2];
            if (a2._namespacePrefix === "xmlns" && a2._value === n2)
              return a2._localName;
          }
          return t3._parent && o.Guard.isElementNode(t3._parent) ? e14(t3._parent, n2) : null;
        }, t2.node_locateANamespace = function e14(t3, n2) {
          if (o.Guard.isElementNode(t3)) {
            if (t3._namespace !== null && t3._namespacePrefix === n2)
              return t3._namespace;
            for (var r2 = 0; r2 < t3._attributeList.length; r2++) {
              var a2 = t3._attributeList[r2];
              if (a2._namespace === s.namespace.XMLNS && a2._namespacePrefix === "xmlns" && a2._localName === n2 || n2 === null && a2._namespace === s.namespace.XMLNS && a2._namespacePrefix === null && a2._localName === "xmlns")
                return a2._value || null;
            }
            return t3.parentElement === null ? null : e14(t3.parentElement, n2);
          }
          return o.Guard.isDocumentNode(t3) ? t3.documentElement === null ? null : e14(t3.documentElement, n2) : o.Guard.isDocumentTypeNode(t3) || o.Guard.isDocumentFragmentNode(t3) ? null : o.Guard.isAttrNode(t3) ? t3._element === null ? null : e14(t3._element, n2) : t3._parent && o.Guard.isElementNode(t3._parent) ? e14(t3._parent, n2) : null;
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(6), o = n(3), s = n(9), c = n(29), l = n(17), u = n(107), d = n(37);
        t2.text_contiguousTextNodes = function(e14, t3) {
          var n2;
          return t3 === void 0 && (t3 = false), (n2 = {})[Symbol.iterator] = function() {
            for (var n3 = e14; n3 && o.Guard.isTextNode(n3._previousSibling); )
              n3 = n3._previousSibling;
            return { next: function() {
              if (n3 && !t3 && n3 === e14 && (n3 = o.Guard.isTextNode(n3._nextSibling) ? n3._nextSibling : null), n3 === null)
                return {
                  done: true,
                  value: null
                };
              var r2 = {
                done: false,
                value: n3
              };
              return n3 = o.Guard.isTextNode(n3._nextSibling) ? n3._nextSibling : null, r2;
            } };
          }, n2;
        }, t2.text_contiguousExclusiveTextNodes = function(e14, t3) {
          var n2;
          return t3 === void 0 && (t3 = false), (n2 = {})[Symbol.iterator] = function() {
            for (var n3 = e14; n3 && o.Guard.isExclusiveTextNode(n3._previousSibling); )
              n3 = n3._previousSibling;
            return { next: function() {
              if (n3 && !t3 && n3 === e14 && (n3 = o.Guard.isExclusiveTextNode(n3._nextSibling) ? n3._nextSibling : null), n3 === null)
                return {
                  done: true,
                  value: null
                };
              var r2 = {
                done: false,
                value: n3
              };
              return n3 = o.Guard.isExclusiveTextNode(n3._nextSibling) ? n3._nextSibling : null, r2;
            } };
          }, n2;
        }, t2.text_descendantTextContent = function(e14) {
          for (var t3 = "", n2 = l.tree_getFirstDescendantNode(e14, false, false, function(e15) {
            return o.Guard.isTextNode(e15);
          }); n2 !== null; )
            t3 += n2._data, n2 = l.tree_getNextDescendantNode(e14, n2, false, false, function(e15) {
              return o.Guard.isTextNode(e15);
            });
          return t3;
        }, t2.text_split = function(e14, t3) {
          var n2, o2, f = e14._data.length;
          if (t3 > f)
            throw new s.IndexSizeError();
          var p = f - t3, m = u.characterData_substringData(e14, t3, p), h = c.create_text(e14._nodeDocument, m), g = e14._parent;
          if (g !== null) {
            d.mutation_insert(h, g, e14._nextSibling);
            try {
              for (var _ = r(a.dom.rangeList), v = _.next(); !v.done; v = _.next()) {
                var y = v.value;
                y._start[0] === e14 && y._start[1] > t3 && (y._start[0] = h, y._start[1] -= t3), y._end[0] === e14 && y._end[1] > t3 && (y._end[0] = h, y._end[1] -= t3);
                var b = l.tree_index(e14);
                y._start[0] === g && y._start[1] === b + 1 && y._start[1]++, y._end[0] === g && y._end[1] === b + 1 && y._end[1]++;
              }
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                v && !v.done && (o2 = _.return) && o2.call(_);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          }
          return u.characterData_replaceData(e14, t3, p, ""), h;
        };
      },
      function(e13, t2, n) {
        var r = n(4), a = n(41), o = n(24), s = n(48), c = [].join, l = a != Object, u = s("join", ",");
        r({
          target: "Array",
          proto: true,
          forced: l || !u
        }, { join: function(e14) {
          return c.call(o(this), e14 === void 0 ? "," : e14);
        } });
      },
      function(e13, t2, n) {
        var r = n(4), a = n(83), o = String.fromCharCode, s = String.fromCodePoint;
        r({
          target: "String",
          stat: true,
          forced: !!s && s.length != 1
        }, { fromCodePoint: function(e14) {
          for (var t3, n2 = [], r2 = arguments.length, s2 = 0; r2 > s2; ) {
            if (t3 = +arguments[s2++], a(t3, 1114111) !== t3)
              throw RangeError(t3 + " is not a valid code point");
            n2.push(t3 < 65536 ? o(t3) : o(55296 + ((t3 -= 65536) >> 10), t3 % 1024 + 56320));
          }
          return n2.join("");
        } });
      },
      function(e13, t2, n) {
        var r = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o = n2.call(e14), s = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o.next()).done; )
              s.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o.return) && n2.call(o);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(111);
        t2.XMLStringLexer = function() {
          function e14(e15, t3) {
            this._options = { skipWhitespaceOnlyText: false }, this.err = {
              line: -1,
              col: -1,
              index: -1,
              str: ""
            }, this._str = e15, this._index = 0, this._length = e15.length, t3 && (this._options.skipWhitespaceOnlyText = t3.skipWhitespaceOnlyText || false);
          }
          return e14.prototype.nextToken = function() {
            if (this.eof())
              return { type: a.TokenType.EOF };
            var t3 = this.skipIfStartsWith("<") ? this.openBracket() : this.text();
            return this._options.skipWhitespaceOnlyText && t3.type === a.TokenType.Text && e14.isWhiteSpaceToken(t3) && (t3 = this.nextToken()), t3;
          }, e14.prototype.openBracket = function() {
            return this.skipIfStartsWith("?") ? this.skipIfStartsWith("xml") ? e14.isSpace(this._str[this._index]) ? this.declaration() : (this.seek(-3), this.pi()) : this.pi() : this.skipIfStartsWith("!") ? this.skipIfStartsWith("--") ? this.comment() : this.skipIfStartsWith("[CDATA[") ? this.cdata() : this.skipIfStartsWith("DOCTYPE") ? this.doctype() : void this.throwError("Invalid '!' in opening tag.") : this.skipIfStartsWith("/") ? this.closeTag() : this.openTag();
          }, e14.prototype.declaration = function() {
            for (var e15 = "", t3 = "", n2 = ""; !this.eof(); ) {
              if (this.skipSpace(), this.skipIfStartsWith("?>"))
                return {
                  type: a.TokenType.Declaration,
                  version: e15,
                  encoding: t3,
                  standalone: n2
                };
              var o = r(this.attribute(), 2), s = o[0], c = o[1];
              s === "version" ? e15 = c : s === "encoding" ? t3 = c : s === "standalone" ? n2 = c : this.throwError("Invalid attribute name: " + s);
            }
            this.throwError("Missing declaration end symbol `?>`");
          }, e14.prototype.doctype = function() {
            var e15 = "", t3 = "";
            this.skipSpace();
            var n2 = this.takeUntil2("[", ">", true);
            return this.skipSpace(), this.skipIfStartsWith("PUBLIC") ? (e15 = this.quotedString(), t3 = this.quotedString()) : this.skipIfStartsWith("SYSTEM") && (t3 = this.quotedString()), this.skipSpace(), this.skipIfStartsWith("[") && (this.skipUntil("]"), this.skipIfStartsWith("]") || this.throwError("Missing end bracket of DTD internal subset")), this.skipSpace(), this.skipIfStartsWith(">") || this.throwError("Missing doctype end symbol `>`"), {
              type: a.TokenType.DocType,
              name: n2,
              pubId: e15,
              sysId: t3
            };
          }, e14.prototype.pi = function() {
            var e15 = this.takeUntilStartsWith("?>", true);
            if (this.eof() && this.throwError("Missing processing instruction end symbol `?>`"), this.skipSpace(), this.skipIfStartsWith("?>"))
              return {
                type: a.TokenType.PI,
                target: e15,
                data: ""
              };
            var t3 = this.takeUntilStartsWith("?>");
            return this.eof() && this.throwError("Missing processing instruction end symbol `?>`"), this.seek(2), {
              type: a.TokenType.PI,
              target: e15,
              data: t3
            };
          }, e14.prototype.text = function() {
            var e15 = this.takeUntil("<");
            return {
              type: a.TokenType.Text,
              data: e15
            };
          }, e14.prototype.comment = function() {
            var e15 = this.takeUntilStartsWith("-->");
            return this.eof() && this.throwError("Missing comment end symbol `-->`"), this.seek(3), {
              type: a.TokenType.Comment,
              data: e15
            };
          }, e14.prototype.cdata = function() {
            var e15 = this.takeUntilStartsWith("]]>");
            return this.eof() && this.throwError("Missing CDATA end symbol `]>`"), this.seek(3), {
              type: a.TokenType.CDATA,
              data: e15
            };
          }, e14.prototype.openTag = function() {
            this.skipSpace();
            var e15 = this.takeUntil2(">", "/", true);
            if (this.skipSpace(), this.skipIfStartsWith(">"))
              return {
                type: a.TokenType.Element,
                name: e15,
                attributes: [],
                selfClosing: false
              };
            if (this.skipIfStartsWith("/>"))
              return {
                type: a.TokenType.Element,
                name: e15,
                attributes: [],
                selfClosing: true
              };
            for (var t3 = []; !this.eof(); ) {
              if (this.skipSpace(), this.skipIfStartsWith(">"))
                return {
                  type: a.TokenType.Element,
                  name: e15,
                  attributes: t3,
                  selfClosing: false
                };
              if (this.skipIfStartsWith("/>"))
                return {
                  type: a.TokenType.Element,
                  name: e15,
                  attributes: t3,
                  selfClosing: true
                };
              var n2 = this.attribute();
              t3.push(n2);
            }
            this.throwError("Missing opening element tag end symbol `>`");
          }, e14.prototype.closeTag = function() {
            this.skipSpace();
            var e15 = this.takeUntil(">", true);
            return this.skipSpace(), this.skipIfStartsWith(">") || this.throwError("Missing closing element tag end symbol `>`"), {
              type: a.TokenType.ClosingTag,
              name: e15
            };
          }, e14.prototype.attribute = function() {
            this.skipSpace();
            var e15 = this.takeUntil("=", true);
            return this.skipSpace(), this.skipIfStartsWith("=") || this.throwError("Missing equals sign before attribute value"), [e15, this.quotedString()];
          }, e14.prototype.quotedString = function() {
            this.skipSpace();
            var t3 = this.take(1);
            e14.isQuote(t3) || this.throwError("Missing start quote character before quoted value");
            var n2 = this.takeUntil(t3);
            return this.skipIfStartsWith(t3) || this.throwError("Missing end quote character after quoted value"), n2;
          }, e14.prototype.eof = function() {
            return this._index >= this._length;
          }, e14.prototype.skipIfStartsWith = function(e15) {
            var t3 = e15.length;
            if (t3 === 1)
              return this._str[this._index] === e15 && (this._index++, true);
            for (var n2 = 0; n2 < t3; n2++)
              if (this._str[this._index + n2] !== e15[n2])
                return false;
            return this._index += t3, true;
          }, e14.prototype.seek = function(e15) {
            this._index += e15, this._index < 0 && (this._index = 0), this._index > this._length && (this._index = this._length);
          }, e14.prototype.skipSpace = function() {
            for (; !this.eof() && e14.isSpace(this._str[this._index]); )
              this._index++;
          }, e14.prototype.take = function(e15) {
            if (e15 === 1)
              return this._str[this._index++];
            var t3 = this._index;
            return this.seek(e15), this._str.slice(t3, this._index);
          }, e14.prototype.takeUntil = function(t3, n2) {
            n2 === void 0 && (n2 = false);
            for (var r2 = this._index; this._index < this._length; ) {
              var a2 = this._str[this._index];
              if (a2 === t3 || n2 && e14.isSpace(a2))
                break;
              this._index++;
            }
            return this._str.slice(r2, this._index);
          }, e14.prototype.takeUntil2 = function(t3, n2, r2) {
            r2 === void 0 && (r2 = false);
            for (var a2 = this._index; this._index < this._length; ) {
              var o = this._str[this._index];
              if (o === t3 || o === n2 || r2 && e14.isSpace(o))
                break;
              this._index++;
            }
            return this._str.slice(a2, this._index);
          }, e14.prototype.takeUntilStartsWith = function(t3, n2) {
            n2 === void 0 && (n2 = false);
            for (var r2 = this._index, a2 = t3.length; this._index < this._length; ) {
              for (var o = true, s = 0; s < a2; s++) {
                var c = this._str[this._index + s], l = t3[s];
                if (n2 && e14.isSpace(c))
                  return this._str.slice(r2, this._index);
                if (c !== l) {
                  this._index++, o = false;
                  break;
                }
              }
              if (o)
                return this._str.slice(r2, this._index);
            }
            return this._index = this._length, this._str.slice(r2);
          }, e14.prototype.skipUntil = function(e15) {
            for (; this._index < this._length && this._str[this._index] !== e15; )
              this._index++;
          }, e14.isWhiteSpaceToken = function(e15) {
            for (var t3 = e15.data, n2 = 0; n2 < t3.length; n2++) {
              var r2 = t3[n2];
              if (r2 !== " " && r2 !== "\n" && r2 !== "\r" && r2 !== "	" && r2 !== "\f")
                return false;
            }
            return true;
          }, e14.isSpace = function(e15) {
            return e15 === " " || e15 === "\n" || e15 === "\r" || e15 === "	";
          }, e14.isQuote = function(e15) {
            return e15 === '"' || e15 === "'";
          }, e14.prototype.throwError = function(e15) {
            for (var t3 = /\r\n|\r|\n/g, n2 = null, r2 = 0, a2 = 0, o = this._str.length; (n2 = t3.exec(this._str)) !== null && n2 !== null; )
              if (r2++, n2.index < this._index && (a2 = t3.lastIndex), n2.index > this._index) {
                o = n2.index;
                break;
              }
            throw this.err = {
              line: r2,
              col: this._index - a2,
              index: this._index,
              str: this._str.substring(a2, o)
            }, /* @__PURE__ */ Error(e15 + "\nIndex: " + this.err.index + "\nLn: " + this.err.line + ", Col: " + this.err.col + "\nInput: " + this.err.str);
          }, e14.prototype[Symbol.iterator] = function() {
            return this._index = 0, { next: function() {
              var e15 = this.nextToken();
              return e15.type === a.TokenType.EOF ? {
                done: true,
                value: null
              } : {
                done: false,
                value: e15
              };
            }.bind(this) };
          }, e14;
        }();
      },
      function(e13, t2, n) {
        e13.exports = new (n(39))({ include: [n(182)] });
      },
      function(e13, t2, n) {
        e13.exports = new (n(39))({
          include: [n(113)],
          implicit: [
            n(289),
            n(290),
            n(291),
            n(292)
          ]
        });
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(91), a = n(1), o = n(3), s = n(77), c = n(109);
        function l(e14, t3) {
          var n2 = d(e14 === void 0 || u(e14) ? e14 : r.DefaultBuilderOptions), a2 = u(e14) ? t3 : e14, o2 = c.createDocument();
          f(o2, n2);
          var l2 = new s.XMLBuilderImpl(o2);
          return a2 !== void 0 && l2.ele(a2), l2;
        }
        function u(e14) {
          if (!a.isPlainObject(e14))
            return false;
          for (var t3 in e14)
            if (e14.hasOwnProperty(t3) && !r.XMLBuilderOptionKeys.has(t3))
              return false;
          return true;
        }
        function d(e14) {
          e14 === void 0 && (e14 = {});
          var t3 = a.applyDefaults(e14, r.DefaultBuilderOptions);
          if (t3.convert.att.length === 0 || t3.convert.ins.length === 0 || t3.convert.text.length === 0 || t3.convert.cdata.length === 0 || t3.convert.comment.length === 0)
            throw Error("JS object converter strings cannot be zero length.");
          return t3;
        }
        function f(e14, t3, n2) {
          var r2 = e14;
          r2._xmlBuilderOptions = t3, r2._isFragment = n2;
        }
        t2.builder = function(e14, t3) {
          var n2 = d(u(e14) ? e14 : r.DefaultBuilderOptions), c2 = o.Guard.isNode(e14) || a.isArray(e14) ? e14 : t3;
          if (c2 === void 0)
            throw Error("Invalid arguments.");
          if (a.isArray(c2)) {
            for (var l2 = [], f2 = 0; f2 < c2.length; f2++) {
              var p = new s.XMLBuilderImpl(c2[f2]);
              p.set(n2), l2.push(p);
            }
            return l2;
          }
          var m = new s.XMLBuilderImpl(c2);
          return m.set(n2), m;
        }, t2.create = l, t2.fragment = function(e14, t3) {
          var n2 = d(e14 === void 0 || u(e14) ? e14 : r.DefaultBuilderOptions), a2 = u(e14) ? t3 : e14, o2 = c.createDocument();
          f(o2, n2, true);
          var l2 = new s.XMLBuilderImpl(o2.createDocumentFragment());
          return a2 !== void 0 && l2.ele(a2), l2;
        }, t2.convert = function(e14, t3, n2) {
          var a2, o2, s2;
          return u(e14) && t3 !== void 0 ? (a2 = e14, o2 = t3, s2 = n2) : (a2 = r.DefaultBuilderOptions, o2 = e14, s2 = t3 || void 0), l(a2, o2).end(s2);
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(77);
        t2.builder = r.builder, t2.create = r.create, t2.fragment = r.fragment, t2.convert = r.convert, t2.createCB = r.createCB, t2.fragmentCB = r.fragmentCB;
      },
      function(e13, t2, n) {
        n(31), n(32), n(33), n(191), n(192), n(194), n(64), n(19), n(198), n(199), n(89), n(201), n(65), n(20), n(66), n(22), n(23);
        var r = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, a = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(91), s = n(1), c = n(217), l = n(2), u = n(3), d = n(0), f = n(109), p = n(7), m = n(276);
        t2.XMLBuilderImpl = function() {
          function e14(e15) {
            this._domNode = e15;
          }
          return Object.defineProperty(e14.prototype, "node", {
            get: function() {
              return this._domNode;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "options", {
            get: function() {
              return this._options;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.set = function(e15) {
            return this._options = s.applyDefaults(s.applyDefaults(this._options, e15, true), o.DefaultBuilderOptions), this;
          }, e14.prototype.ele = function(t3, n2, a2) {
            var o2, c2, l2, u2, p2, h;
            if (s.isObject(t3))
              return new m.ObjectReader(this._options).parse(this, t3);
            if (t3 !== null && /^\s*</.test(t3))
              return new m.XMLReader(this._options).parse(this, t3);
            if (t3 !== null && /^\s*[\{\[]/.test(t3))
              return new m.JSONReader(this._options).parse(this, t3);
            if (t3 !== null && /^(\s*|(#.*)|(%.*))*---/.test(t3))
              return new m.YAMLReader(this._options).parse(this, t3);
            if ((t3 === null || s.isString(t3)) && s.isString(n2))
              u2 = (o2 = r([
                t3,
                n2,
                a2
              ], 3))[0], p2 = o2[1], h = o2[2];
            else {
              if (t3 === null)
                throw Error("Element name cannot be null. " + this._debugInfo());
              u2 = (c2 = r([
                void 0,
                t3,
                s.isObject(n2) ? n2 : void 0
              ], 3))[0], p2 = c2[1], h = c2[2];
            }
            if (h &&= s.getValue(h), u2 = (l2 = r(this._extractNamespace(f.sanitizeInput(u2, this._options.invalidCharReplacement), f.sanitizeInput(p2, this._options.invalidCharReplacement), true), 2))[0], p2 = l2[1], u2 === void 0) {
              var g = r(d.namespace_extractQName(p2), 1)[0];
              u2 = this.node.lookupNamespaceURI(g);
            }
            var _ = u2 == null ? this._doc.createElement(p2) : this._doc.createElementNS(u2, p2);
            this.node.appendChild(_);
            var v = new e14(_), y = this._doc.doctype;
            if (_ === this._doc.documentElement && y !== null) {
              var b = this._doc.implementation.createDocumentType(this._doc.documentElement.tagName, y.publicId, y.systemId);
              this._doc.replaceChild(b, y);
            }
            return h && !s.isEmpty(h) && v.att(h), v;
          }, e14.prototype.remove = function() {
            var e15 = this.up();
            return e15.node.removeChild(this.node), e15;
          }, e14.prototype.att = function(e15, t3, n2) {
            var a2, o2, c2, l2, m2, h, g = this;
            if (s.isMap(e15) || s.isObject(e15))
              return s.forEachObject(e15, function(e16, t4) {
                return g.att(e16, t4);
              }, this), this;
            if (e15 != null && (e15 = s.getValue(e15 + "")), t3 != null && (t3 = s.getValue(t3 + "")), n2 != null && (n2 = s.getValue(n2 + "")), e15 !== null && !s.isString(e15) || !s.isString(t3) || n2 !== null && !s.isString(n2)) {
              if (!s.isString(e15) || t3 != null && !s.isString(t3))
                throw Error("Attribute name and value not specified. " + this._debugInfo());
              l2 = (o2 = r([
                void 0,
                e15,
                t3
              ], 3))[0], m2 = o2[1], h = o2[2];
            } else
              l2 = (a2 = r([
                e15,
                t3,
                n2
              ], 3))[0], m2 = a2[1], h = a2[2];
            if (this._options.keepNullAttributes && h == null)
              h = "";
            else if (h == null)
              return this;
            if (!u.Guard.isElementNode(this.node))
              throw Error("An attribute can only be assigned to an element node.");
            var _ = this.node;
            l2 = (c2 = r(this._extractNamespace(l2, m2, false), 2))[0], m2 = c2[1], m2 = f.sanitizeInput(m2, this._options.invalidCharReplacement), l2 = f.sanitizeInput(l2, this._options.invalidCharReplacement), h = f.sanitizeInput(h, this._options.invalidCharReplacement);
            var v = r(d.namespace_extractQName(m2), 2), y = v[0], b = v[1], S = r(d.namespace_extractQName(_.prefix ? _.prefix + ":" + _.localName : _.localName), 1)[0], C = null;
            return y === "xmlns" ? (l2 = p.namespace.XMLNS, _.namespaceURI === null && S === b && (C = h)) : y === null && b === "xmlns" && S === null && (l2 = p.namespace.XMLNS, C = h), C !== null && (this._updateNamespace(C), _ = this.node), l2 === void 0 ? _.setAttribute(m2, h) : _.setAttributeNS(l2, m2, h), this;
          }, e14.prototype.removeAtt = function(e15, t3) {
            var n2, r2, a2 = this;
            if (!u.Guard.isElementNode(this.node))
              throw Error("An attribute can only be removed from an element node.");
            if (e15 = s.getValue(e15), t3 !== void 0 && (t3 = s.getValue(t3)), e15 !== null && t3 === void 0)
              r2 = e15;
            else {
              if (e15 !== null && !s.isString(e15) || t3 === void 0)
                throw Error("Attribute namespace must be a string. " + this._debugInfo());
              n2 = e15, r2 = t3;
            }
            return s.isArray(r2) || s.isSet(r2) ? s.forEachArray(r2, function(e16) {
              return n2 === void 0 ? a2.removeAtt(e16) : a2.removeAtt(n2, e16);
            }, this) : n2 === void 0 ? (r2 = f.sanitizeInput(r2, this._options.invalidCharReplacement), this.node.removeAttribute(r2)) : (r2 = f.sanitizeInput(r2, this._options.invalidCharReplacement), n2 = f.sanitizeInput(n2, this._options.invalidCharReplacement), this.node.removeAttributeNS(n2, r2)), this;
          }, e14.prototype.txt = function(e15) {
            if (e15 == null) {
              if (!this._options.keepNullNodes)
                return this;
              e15 = "";
            }
            var t3 = this._doc.createTextNode(f.sanitizeInput(e15, this._options.invalidCharReplacement));
            return this.node.appendChild(t3), this;
          }, e14.prototype.com = function(e15) {
            if (e15 == null) {
              if (!this._options.keepNullNodes)
                return this;
              e15 = "";
            }
            var t3 = this._doc.createComment(f.sanitizeInput(e15, this._options.invalidCharReplacement));
            return this.node.appendChild(t3), this;
          }, e14.prototype.dat = function(e15) {
            if (e15 == null) {
              if (!this._options.keepNullNodes)
                return this;
              e15 = "";
            }
            var t3 = this._doc.createCDATASection(f.sanitizeInput(e15, this._options.invalidCharReplacement));
            return this.node.appendChild(t3), this;
          }, e14.prototype.ins = function(e15, t3) {
            var n2 = this;
            if (t3 === void 0 && (t3 = ""), t3 == null) {
              if (!this._options.keepNullNodes)
                return this;
              t3 = "";
            }
            if (s.isArray(e15) || s.isSet(e15))
              s.forEachArray(e15, function(e16) {
                var t4 = (e16 += "").indexOf(" "), r3 = t4 === -1 ? e16 : e16.substr(0, t4), a2 = t4 === -1 ? "" : e16.substr(t4 + 1);
                n2.ins(r3, a2);
              }, this);
            else if (s.isMap(e15) || s.isObject(e15))
              s.forEachObject(e15, function(e16, t4) {
                return n2.ins(e16, t4);
              }, this);
            else {
              var r2 = this._doc.createProcessingInstruction(f.sanitizeInput(e15, this._options.invalidCharReplacement), f.sanitizeInput(t3, this._options.invalidCharReplacement));
              this.node.appendChild(r2);
            }
            return this;
          }, e14.prototype.dec = function(e15) {
            return this._options.version = e15.version || "1.0", this._options.encoding = e15.encoding, this._options.standalone = e15.standalone, this;
          }, e14.prototype.dtd = function(e15) {
            var t3 = f.sanitizeInput(e15 && e15.name || (this._doc.documentElement ? this._doc.documentElement.tagName : "ROOT"), this._options.invalidCharReplacement), n2 = f.sanitizeInput(e15 && e15.pubID || "", this._options.invalidCharReplacement), r2 = f.sanitizeInput(e15 && e15.sysID || "", this._options.invalidCharReplacement);
            if (this._doc.documentElement !== null && t3 !== this._doc.documentElement.tagName)
              throw Error("DocType name does not match document element name.");
            var a2 = this._doc.implementation.createDocumentType(t3, n2, r2);
            return this._doc.doctype === null ? this._doc.insertBefore(a2, this._doc.documentElement) : this._doc.replaceChild(a2, this._doc.doctype), this;
          }, e14.prototype.import = function(t3) {
            var n2, o2, s2 = this._domNode, c2 = this._doc, l2 = t3.node;
            if (u.Guard.isDocumentNode(l2)) {
              var f2 = l2.documentElement;
              if (f2 === null)
                throw Error("Imported document has no document element node. " + this._debugInfo());
              var p2 = c2.importNode(f2, true);
              s2.appendChild(p2);
              var m2 = r(d.namespace_extractQName(p2.prefix ? p2.prefix + ":" + p2.localName : p2.localName), 1)[0], h = s2.lookupNamespaceURI(m2);
              new e14(p2)._updateNamespace(h);
            } else if (u.Guard.isDocumentFragmentNode(l2))
              try {
                for (var g = a(l2.childNodes), _ = g.next(); !_.done; _ = g.next()) {
                  var v = _.value;
                  p2 = c2.importNode(v, true), s2.appendChild(p2), u.Guard.isElementNode(p2) && (m2 = r(d.namespace_extractQName(p2.prefix ? p2.prefix + ":" + p2.localName : p2.localName), 1)[0], h = s2.lookupNamespaceURI(m2), new e14(p2)._updateNamespace(h));
                }
              } catch (e15) {
                n2 = { error: e15 };
              } finally {
                try {
                  _ && !_.done && (o2 = g.return) && o2.call(g);
                } finally {
                  if (n2)
                    throw n2.error;
                }
              }
            else
              p2 = c2.importNode(l2, true), s2.appendChild(p2), u.Guard.isElementNode(p2) && (m2 = r(d.namespace_extractQName(p2.prefix ? p2.prefix + ":" + p2.localName : p2.localName), 1)[0], h = s2.lookupNamespaceURI(m2), new e14(p2)._updateNamespace(h));
            return this;
          }, e14.prototype.doc = function() {
            if (this._doc._isFragment) {
              for (var t3 = this.node; t3 && t3.nodeType !== l.NodeType.DocumentFragment; )
                t3 = t3.parentNode;
              if (t3 === null)
                throw Error("Node has no parent node while searching for document fragment ancestor. " + this._debugInfo());
              return new e14(t3);
            }
            return new e14(this._doc);
          }, e14.prototype.root = function() {
            var t3 = this._doc.documentElement;
            if (!t3)
              throw Error("Document root element is null. " + this._debugInfo());
            return new e14(t3);
          }, e14.prototype.up = function() {
            var t3 = this._domNode.parentNode;
            if (!t3)
              throw Error("Parent node is null. " + this._debugInfo());
            return new e14(t3);
          }, e14.prototype.prev = function() {
            var t3 = this._domNode.previousSibling;
            if (!t3)
              throw Error("Previous sibling node is null. " + this._debugInfo());
            return new e14(t3);
          }, e14.prototype.next = function() {
            var t3 = this._domNode.nextSibling;
            if (!t3)
              throw Error("Next sibling node is null. " + this._debugInfo());
            return new e14(t3);
          }, e14.prototype.first = function() {
            var t3 = this._domNode.firstChild;
            if (!t3)
              throw Error("First child node is null. " + this._debugInfo());
            return new e14(t3);
          }, e14.prototype.last = function() {
            var t3 = this._domNode.lastChild;
            if (!t3)
              throw Error("Last child node is null. " + this._debugInfo());
            return new e14(t3);
          }, e14.prototype.each = function(t3, n2, r2, a2) {
            n2 === void 0 && (n2 = false), r2 === void 0 && (r2 = false);
            for (var o2 = this._getFirstDescendantNode(this._domNode, n2, r2); o2[0]; ) {
              var s2 = this._getNextDescendantNode(this._domNode, o2[0], r2, o2[1], o2[2]);
              t3.call(a2, new e14(o2[0]), o2[1], o2[2]), o2 = s2;
            }
            return this;
          }, e14.prototype.map = function(e15, t3, n2, r2) {
            t3 === void 0 && (t3 = false), n2 === void 0 && (n2 = false);
            var a2 = [];
            return this.each(function(t4, n3, o2) {
              return a2.push(e15.call(r2, t4, n3, o2));
            }, t3, n2), a2;
          }, e14.prototype.reduce = function(e15, t3, n2, r2, a2) {
            n2 === void 0 && (n2 = false), r2 === void 0 && (r2 = false);
            var o2 = t3;
            return this.each(function(t4, n3, r3) {
              return o2 = e15.call(a2, o2, t4, n3, r3);
            }, n2, r2), o2;
          }, e14.prototype.find = function(t3, n2, r2, a2) {
            n2 === void 0 && (n2 = false), r2 === void 0 && (r2 = false);
            for (var o2 = this._getFirstDescendantNode(this._domNode, n2, r2); o2[0]; ) {
              var s2 = new e14(o2[0]);
              if (t3.call(a2, s2, o2[1], o2[2]))
                return s2;
              o2 = this._getNextDescendantNode(this._domNode, o2[0], r2, o2[1], o2[2]);
            }
          }, e14.prototype.filter = function(e15, t3, n2, r2) {
            t3 === void 0 && (t3 = false), n2 === void 0 && (n2 = false);
            var a2 = [];
            return this.each(function(t4, n3, o2) {
              e15.call(r2, t4, n3, o2) && a2.push(t4);
            }, t3, n2), a2;
          }, e14.prototype.every = function(t3, n2, r2, a2) {
            n2 === void 0 && (n2 = false), r2 === void 0 && (r2 = false);
            for (var o2 = this._getFirstDescendantNode(this._domNode, n2, r2); o2[0]; ) {
              var s2 = new e14(o2[0]);
              if (!t3.call(a2, s2, o2[1], o2[2]))
                return false;
              o2 = this._getNextDescendantNode(this._domNode, o2[0], r2, o2[1], o2[2]);
            }
            return true;
          }, e14.prototype.some = function(t3, n2, r2, a2) {
            n2 === void 0 && (n2 = false), r2 === void 0 && (r2 = false);
            for (var o2 = this._getFirstDescendantNode(this._domNode, n2, r2); o2[0]; ) {
              var s2 = new e14(o2[0]);
              if (t3.call(a2, s2, o2[1], o2[2]))
                return true;
              o2 = this._getNextDescendantNode(this._domNode, o2[0], r2, o2[1], o2[2]);
            }
            return false;
          }, e14.prototype.toArray = function(e15, t3) {
            e15 === void 0 && (e15 = false), t3 === void 0 && (t3 = false);
            var n2 = [];
            return this.each(function(e16) {
              return n2.push(e16);
            }, e15, t3), n2;
          }, e14.prototype.toString = function(e15) {
            return (e15 ||= {}).format === void 0 && (e15.format = "xml"), this._serialize(e15);
          }, e14.prototype.toObject = function(e15) {
            return (e15 ||= {}).format === void 0 && (e15.format = "object"), this._serialize(e15);
          }, e14.prototype.end = function(e15) {
            return (e15 ||= {}).format === void 0 && (e15.format = "xml"), this.doc()._serialize(e15);
          }, e14.prototype._getFirstDescendantNode = function(e15, t3, n2) {
            return t3 ? [
              this._domNode,
              0,
              0
            ] : n2 ? this._getNextDescendantNode(e15, e15, n2, 0, 0) : [
              this._domNode.firstChild,
              0,
              1
            ];
          }, e14.prototype._getNextDescendantNode = function(e15, t3, n2, r2, a2) {
            if (!n2)
              return e15 === t3 ? [
                t3.firstChild,
                0,
                a2 + 1
              ] : [
                t3.nextSibling,
                r2 + 1,
                a2
              ];
            if (t3.firstChild)
              return [
                t3.firstChild,
                0,
                a2 + 1
              ];
            if (t3 === e15)
              return [
                null,
                -1,
                -1
              ];
            if (t3.nextSibling)
              return [
                t3.nextSibling,
                r2 + 1,
                a2
              ];
            for (var o2 = t3.parentNode; o2 && o2 !== e15; ) {
              if (o2.nextSibling)
                return [
                  o2.nextSibling,
                  d.tree_index(o2.nextSibling),
                  a2 - 1
                ];
              o2 = o2.parentNode, a2--;
            }
            return [
              null,
              -1,
              -1
            ];
          }, e14.prototype._serialize = function(e15) {
            if (e15.format === "xml")
              return new c.XMLWriter(this._options, e15).serialize(this.node);
            if (e15.format === "map")
              return new c.MapWriter(this._options, e15).serialize(this.node);
            if (e15.format === "object")
              return new c.ObjectWriter(this._options, e15).serialize(this.node);
            if (e15.format === "json")
              return new c.JSONWriter(this._options, e15).serialize(this.node);
            if (e15.format === "yaml")
              return new c.YAMLWriter(this._options, e15).serialize(this.node);
            throw Error("Invalid writer format: " + e15.format + ". " + this._debugInfo());
          }, e14.prototype._extractNamespace = function(e15, t3, n2) {
            var r2 = t3.indexOf("@");
            if (r2 > 0 && (e15 === void 0 && (e15 = t3.slice(r2 + 1)), t3 = t3.slice(0, r2)), e15 === void 0)
              e15 = n2 ? this._options.defaultNamespace.ele : this._options.defaultNamespace.att;
            else if (e15 !== null && e15[0] === "@") {
              var a2 = e15.slice(1);
              if ((e15 = this._options.namespaceAlias[a2]) === void 0)
                throw Error("Namespace alias `" + a2 + "` is not defined. " + this._debugInfo());
            }
            return [e15, t3];
          }, e14.prototype._updateNamespace = function(t3) {
            var n2, o2, s2, c2, l2 = this._domNode;
            if (u.Guard.isElementNode(l2) && t3 !== null && l2.namespaceURI !== t3) {
              var f2 = r(d.namespace_extractQName(l2.prefix ? l2.prefix + ":" + l2.localName : l2.localName), 2), p2 = f2[0], m2 = f2[1], h = d.create_element(this._doc, m2, t3, p2);
              try {
                for (var g = a(l2.attributes), _ = g.next(); !_.done; _ = g.next()) {
                  var v = _.value, y = v.prefix ? v.prefix + ":" + v.localName : v.localName, b = r(d.namespace_extractQName(y), 1)[0], S = v.namespaceURI;
                  S === null && b !== null && (S = l2.lookupNamespaceURI(b)), S === null ? h.setAttribute(y, v.value) : h.setAttributeNS(S, y, v.value);
                }
              } catch (e15) {
                n2 = { error: e15 };
              } finally {
                try {
                  _ && !_.done && (o2 = g.return) && o2.call(g);
                } finally {
                  if (n2)
                    throw n2.error;
                }
              }
              var C = l2.parentNode;
              if (C === null)
                throw Error("Parent node is null." + this._debugInfo());
              C.replaceChild(h, l2), this._domNode = h;
              try {
                for (var w = a(l2.childNodes), T = w.next(); !T.done; T = w.next()) {
                  var E = T.value.cloneNode(true);
                  if (h.appendChild(E), u.Guard.isElementNode(E)) {
                    var D = r(d.namespace_extractQName(E.prefix ? E.prefix + ":" + E.localName : E.localName), 1)[0], O = h.lookupNamespaceURI(D);
                    new e14(E)._updateNamespace(O);
                  }
                }
              } catch (e15) {
                s2 = { error: e15 };
              } finally {
                try {
                  T && !T.done && (c2 = w.return) && c2.call(w);
                } finally {
                  if (s2)
                    throw s2.error;
                }
              }
            }
          }, Object.defineProperty(e14.prototype, "_doc", {
            get: function() {
              var e15 = this.node;
              if (u.Guard.isDocumentNode(e15))
                return e15;
              var t3 = e15.ownerDocument;
              if (!t3)
                throw Error("Owner document is null. " + this._debugInfo());
              return t3;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype._debugInfo = function(e15) {
            var t3 = this.node, n2 = t3.parentNode;
            e15 ||= t3.nodeName;
            var r2 = n2 ? n2.nodeName : "";
            return r2 ? "node: <" + e15 + ">, parent: <" + r2 + ">" : "node: <" + e15 + ">";
          }, Object.defineProperty(e14.prototype, "_options", {
            get: function() {
              var e15 = this._doc;
              if (e15._xmlBuilderOptions === void 0)
                throw Error("Builder options is not set.");
              return e15._xmlBuilderOptions;
            },
            set: function(e15) {
              this._doc._xmlBuilderOptions = e15;
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
      },
      function(e13, t2, n) {
        var r = n(11), a = n(117), o = r.WeakMap;
        e13.exports = typeof o == "function" && /native code/.test(a(o));
      },
      function(e13, t2, n) {
        var r = n(46), a = n(82), o = n(85), s = n(18);
        e13.exports = r("Reflect", "ownKeys") || function(e14) {
          var t3 = a.f(s(e14)), n2 = o.f;
          return n2 ? t3.concat(n2(e14)) : t3;
        };
      },
      function(e13, t2, n) {
        var r = n(16), a = n(15), o = n(18), s = n(61);
        e13.exports = r ? Object.defineProperties : function(e14, t3) {
          o(e14);
          for (var n2, r2 = s(t3), c = r2.length, l = 0; c > l; )
            a.f(e14, n2 = r2[l++], t3[n2]);
          return e14;
        };
      },
      function(e13, t2, n) {
        e13.exports = n(46)("document", "documentElement");
      },
      function(e13, t2, n) {
        var r = n(24), a = n(82).f, o = {}.toString, s = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
        e13.exports.f = function(e14) {
          return s && o.call(e14) == "[object Window]" ? function(e15) {
            try {
              return a(e15);
            } catch {
              return s.slice();
            }
          }(e14) : a(r(e14));
        };
      },
      function(e13, t2, n) {
        var r = n(4), a = n(36).every, o = n(48), s = n(28), c = o("every"), l = s("every");
        r({
          target: "Array",
          proto: true,
          forced: !c || !l
        }, { every: function(e14) {
          return a(this, e14, arguments.length > 1 ? arguments[1] : void 0);
        } });
      },
      function(e13, t2, n) {
        var r = n(4), a = n(36).filter, o = n(63), s = n(28), c = o("filter"), l = s("filter");
        r({
          target: "Array",
          proto: true,
          forced: !c || !l
        }, { filter: function(e14) {
          return a(this, e14, arguments.length > 1 ? arguments[1] : void 0);
        } });
      },
      function(e13, t2, n) {
        e13.exports = n(46)("navigator", "userAgent") || "";
      },
      function(e13, t2, n) {
        var r = n(4), a = n(36).find, o = n(130), s = n(28), c = true, l = s("find");
        "find" in [] && [,].find(function() {
          c = false;
        }), r({
          target: "Array",
          proto: true,
          forced: c || !l
        }, { find: function(e14) {
          return a(this, e14, arguments.length > 1 ? arguments[1] : void 0);
        } }), o("find");
      },
      function(e13, t2, n) {
        var r = n(131).IteratorPrototype, a = n(60), o = n(40), s = n(62), c = n(49), l = function() {
          return this;
        };
        e13.exports = function(e14, t3, n2) {
          var u = t3 + " Iterator";
          return e14.prototype = a(r, { next: o(1, n2) }), s(e14, u, false, true), c[u] = l, e14;
        };
      },
      function(e13, t2, n) {
        e13.exports = !n(8)(function() {
          function e14() {
          }
          return e14.prototype.constructor = null, Object.getPrototypeOf(new e14()) !== e14.prototype;
        });
      },
      function(e13, t2, n) {
        var r = n(13);
        e13.exports = function(e14) {
          if (!r(e14) && e14 !== null)
            throw TypeError("Can't set " + String(e14) + " as a prototype");
          return e14;
        };
      },
      function(e13, t2, n) {
        var r = n(4), a = n(36).map, o = n(63), s = n(28), c = o("map"), l = s("map");
        r({
          target: "Array",
          proto: true,
          forced: !c || !l
        }, { map: function(e14) {
          return a(this, e14, arguments.length > 1 ? arguments[1] : void 0);
        } });
      },
      function(e13, t2, n) {
        var r = n(4), a = n(200).left, o = n(48), s = n(28), c = o("reduce"), l = s("reduce", { 1: 0 });
        r({
          target: "Array",
          proto: true,
          forced: !c || !l
        }, { reduce: function(e14) {
          return a(this, e14, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
        } });
      },
      function(e13, t2, n) {
        var r = n(127), a = n(27), o = n(41), s = n(26), c = function(e14) {
          return function(t3, n2, c2, l) {
            r(n2);
            var u = a(t3), d = o(u), f = s(u.length), p = e14 ? f - 1 : 0, m = e14 ? -1 : 1;
            if (c2 < 2)
              for (; ; ) {
                if (p in d) {
                  l = d[p], p += m;
                  break;
                }
                if (p += m, e14 ? p < 0 : f <= p)
                  throw TypeError("Reduce of empty array with no initial value");
              }
            for (; e14 ? p >= 0 : f > p; p += m)
              p in d && (l = n2(l, d[p], p, u));
            return l;
          };
        };
        e13.exports = {
          left: c(false),
          right: c(true)
        };
      },
      function(e13, t2, n) {
        var r = n(4), a = n(36).some, o = n(48), s = n(28), c = o("some"), l = s("some");
        r({
          target: "Array",
          proto: true,
          forced: !c || !l
        }, { some: function(e14) {
          return a(this, e14, arguments.length > 1 ? arguments[1] : void 0);
        } });
      },
      function(e13, t2, n) {
        var r = n(90), a = n(135);
        e13.exports = r ? {}.toString : function() {
          return "[object " + a(this) + "]";
        };
      },
      function(e13, t2) {
        e13.exports = {
          CSSRuleList: 0,
          CSSStyleDeclaration: 0,
          CSSValueList: 0,
          ClientRectList: 0,
          DOMRectList: 0,
          DOMStringList: 0,
          DOMTokenList: 1,
          DataTransferItemList: 0,
          FileList: 0,
          HTMLAllCollection: 0,
          HTMLCollection: 0,
          HTMLFormElement: 0,
          HTMLSelectElement: 0,
          MediaList: 0,
          MimeTypeArray: 0,
          NamedNodeMap: 0,
          NodeList: 1,
          PaintRequestList: 0,
          Plugin: 0,
          PluginArray: 0,
          SVGLengthList: 0,
          SVGNumberList: 0,
          SVGPathSegList: 0,
          SVGPointList: 0,
          SVGStringList: 0,
          SVGTransformList: 0,
          SourceBufferList: 0,
          StyleSheetList: 0,
          TextTrackCueList: 0,
          TextTrackList: 0,
          TouchList: 0
        };
      },
      function(e13, t2, n) {
        e13.exports = !n(8)(function() {
          return Object.isExtensible(Object.preventExtensions({}));
        });
      },
      function(e13, t2, n) {
        var r = n(5), a = n(49), o = r("iterator"), s = Array.prototype;
        e13.exports = function(e14) {
          return e14 !== void 0 && (a.Array === e14 || s[o] === e14);
        };
      },
      function(e13, t2, n) {
        var r = n(135), a = n(49), o = n(5)("iterator");
        e13.exports = function(e14) {
          if (e14 != null)
            return e14[o] || e14["@@iterator"] || a[r(e14)];
        };
      },
      function(e13, t2, n) {
        var r = n(18);
        e13.exports = function(e14, t3, n2, a) {
          try {
            return a ? t3(r(n2)[0], n2[1]) : t3(n2);
          } catch (t4) {
            var o = e14.return;
            throw o !== void 0 && r(o.call(e14)), t4;
          }
        };
      },
      function(e13, t2, n) {
        var r = n(5)("iterator"), a = false;
        try {
          var o = 0, s = {
            next: function() {
              return { done: !!o++ };
            },
            return: function() {
              a = true;
            }
          };
          s[r] = function() {
            return this;
          }, Array.from(s, function() {
            throw 2;
          });
        } catch {
        }
        e13.exports = function(e14, t3) {
          if (!t3 && !a)
            return false;
          var n2 = false;
          try {
            var o2 = {};
            o2[r] = function() {
              return { next: function() {
                return { done: n2 = true };
              } };
            }, e14(o2);
          } catch {
          }
          return n2;
        };
      },
      function(e13, t2, n) {
        var r = n(13), a = n(133);
        e13.exports = function(e14, t3, n2) {
          var o, s;
          return a && typeof (o = t3.constructor) == "function" && o !== n2 && r(s = o.prototype) && s !== n2.prototype && a(e14, s), e14;
        };
      },
      function(e13, t2, n) {
        var r = n(25);
        e13.exports = function(e14, t3, n2) {
          for (var a in t3)
            r(e14, a, t3[a], n2);
          return e14;
        };
      },
      function(e13, t2, n) {
        var r = n(46), a = n(15), o = n(5), s = n(16), c = o("species");
        e13.exports = function(e14) {
          var t3 = r(e14), n2 = a.f;
          s && t3 && !t3[c] && n2(t3, c, {
            configurable: true,
            get: function() {
              return this;
            }
          });
        };
      },
      function(e13, t2, n) {
        var r = this && this.__generator || function(e14, t3) {
          var n2, r2, a2, o, s = {
            label: 0,
            sent: function() {
              if (1 & a2[0])
                throw a2[1];
              return a2[1];
            },
            trys: [],
            ops: []
          };
          return o = {
            next: c(0),
            throw: c(1),
            return: c(2)
          }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
            return this;
          }), o;
          function c(o2) {
            return function(c2) {
              return function(o3) {
                if (n2)
                  throw TypeError("Generator is already executing.");
                for (; s; )
                  try {
                    if (n2 = 1, r2 && (a2 = 2 & o3[0] ? r2.return : o3[0] ? r2.throw || ((a2 = r2.return) && a2.call(r2), 0) : r2.next) && !(a2 = a2.call(r2, o3[1])).done)
                      return a2;
                    switch (r2 = 0, a2 && (o3 = [2 & o3[0], a2.value]), o3[0]) {
                      case 0:
                      case 1:
                        a2 = o3;
                        break;
                      case 4:
                        return s.label++, {
                          value: o3[1],
                          done: false
                        };
                      case 5:
                        s.label++, r2 = o3[1], o3 = [0];
                        continue;
                      case 7:
                        o3 = s.ops.pop(), s.trys.pop();
                        continue;
                      default:
                        if (a2 = s.trys, !((a2 = a2.length > 0 && a2[a2.length - 1]) || o3[0] !== 6 && o3[0] !== 2)) {
                          s = 0;
                          continue;
                        }
                        if (o3[0] === 3 && (!a2 || o3[1] > a2[0] && o3[1] < a2[3])) {
                          s.label = o3[1];
                          break;
                        }
                        if (o3[0] === 6 && s.label < a2[1]) {
                          s.label = a2[1], a2 = o3;
                          break;
                        }
                        if (a2 && s.label < a2[2]) {
                          s.label = a2[2], s.ops.push(o3);
                          break;
                        }
                        a2[2] && s.ops.pop(), s.trys.pop();
                        continue;
                    }
                    o3 = t3.call(e14, s);
                  } catch (e15) {
                    o3 = [6, e15], r2 = 0;
                  } finally {
                    n2 = a2 = 0;
                  }
                if (5 & o3[0])
                  throw o3[1];
                return {
                  value: o3[0] ? o3[1] : void 0,
                  done: true
                };
              }([o2, c2]);
            };
          }
        }, a = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true }), t2.FixedSizeSet = function() {
          function e14(e15) {
            e15 === void 0 && (e15 = 1e3), this._items = /* @__PURE__ */ new Set(), this._limit = e15;
          }
          return e14.prototype.add = function(e15) {
            if (this._items.add(e15), this._items.size > this._limit) {
              var t3 = this._items.values().next();
              t3.done || this._items.delete(t3.value);
            }
            return this;
          }, e14.prototype.delete = function(e15) {
            return this._items.delete(e15);
          }, e14.prototype.has = function(e15) {
            return this._items.has(e15);
          }, e14.prototype.clear = function() {
            this._items.clear();
          }, Object.defineProperty(e14.prototype, "size", {
            get: function() {
              return this._items.size;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.forEach = function(e15, t3) {
            var n2 = this;
            this._items.forEach(function(r2) {
              return e15.call(t3, r2, r2, n2);
            });
          }, e14.prototype.keys = function() {
            return r(this, function(e15) {
              switch (e15.label) {
                case 0:
                  return [5, a(this._items.keys())];
                case 1:
                  return e15.sent(), [2];
              }
            });
          }, e14.prototype.values = function() {
            return r(this, function(e15) {
              switch (e15.label) {
                case 0:
                  return [5, a(this._items.values())];
                case 1:
                  return e15.sent(), [2];
              }
            });
          }, e14.prototype.entries = function() {
            return r(this, function(e15) {
              switch (e15.label) {
                case 0:
                  return [5, a(this._items.entries())];
                case 1:
                  return e15.sent(), [2];
              }
            });
          }, e14.prototype[Symbol.iterator] = function() {
            return r(this, function(e15) {
              switch (e15.label) {
                case 0:
                  return [5, a(this._items)];
                case 1:
                  return e15.sent(), [2];
              }
            });
          }, Object.defineProperty(e14.prototype, Symbol.toStringTag, {
            get: function() {
              return "FixedSizeSet";
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
      },
      function(e13, t2, n) {
        var r = this && this.__generator || function(e14, t3) {
          var n2, r2, a2, o, s = {
            label: 0,
            sent: function() {
              if (1 & a2[0])
                throw a2[1];
              return a2[1];
            },
            trys: [],
            ops: []
          };
          return o = {
            next: c(0),
            throw: c(1),
            return: c(2)
          }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
            return this;
          }), o;
          function c(o2) {
            return function(c2) {
              return function(o3) {
                if (n2)
                  throw TypeError("Generator is already executing.");
                for (; s; )
                  try {
                    if (n2 = 1, r2 && (a2 = 2 & o3[0] ? r2.return : o3[0] ? r2.throw || ((a2 = r2.return) && a2.call(r2), 0) : r2.next) && !(a2 = a2.call(r2, o3[1])).done)
                      return a2;
                    switch (r2 = 0, a2 && (o3 = [2 & o3[0], a2.value]), o3[0]) {
                      case 0:
                      case 1:
                        a2 = o3;
                        break;
                      case 4:
                        return s.label++, {
                          value: o3[1],
                          done: false
                        };
                      case 5:
                        s.label++, r2 = o3[1], o3 = [0];
                        continue;
                      case 7:
                        o3 = s.ops.pop(), s.trys.pop();
                        continue;
                      default:
                        if (a2 = s.trys, !((a2 = a2.length > 0 && a2[a2.length - 1]) || o3[0] !== 6 && o3[0] !== 2)) {
                          s = 0;
                          continue;
                        }
                        if (o3[0] === 3 && (!a2 || o3[1] > a2[0] && o3[1] < a2[3])) {
                          s.label = o3[1];
                          break;
                        }
                        if (o3[0] === 6 && s.label < a2[1]) {
                          s.label = a2[1], a2 = o3;
                          break;
                        }
                        if (a2 && s.label < a2[2]) {
                          s.label = a2[2], s.ops.push(o3);
                          break;
                        }
                        a2[2] && s.ops.pop(), s.trys.pop();
                        continue;
                    }
                    o3 = t3.call(e14, s);
                  } catch (e15) {
                    o3 = [6, e15], r2 = 0;
                  } finally {
                    n2 = a2 = 0;
                  }
                if (5 & o3[0])
                  throw o3[1];
                return {
                  value: o3[0] ? o3[1] : void 0,
                  done: true
                };
              }([o2, c2]);
            };
          }
        }, a = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true }), t2.ObjectCache = function() {
          function e14(e15) {
            e15 === void 0 && (e15 = 1e3), this._items = /* @__PURE__ */ new Map(), this._limit = e15;
          }
          return e14.prototype.get = function(e15) {
            return this._items.get(e15);
          }, e14.prototype.set = function(e15, t3) {
            if (this._items.set(e15, t3), this._items.size > this._limit) {
              var n2 = this._items.keys().next();
              n2.done || this._items.delete(n2.value);
            }
          }, e14.prototype.delete = function(e15) {
            return this._items.delete(e15);
          }, e14.prototype.has = function(e15) {
            return this._items.has(e15);
          }, e14.prototype.clear = function() {
            this._items.clear();
          }, Object.defineProperty(e14.prototype, "size", {
            get: function() {
              return this._items.size;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.forEach = function(e15, t3) {
            this._items.forEach(function(n2, r2) {
              return e15.call(t3, r2, n2);
            });
          }, e14.prototype.keys = function() {
            return r(this, function(e15) {
              switch (e15.label) {
                case 0:
                  return [5, a(this._items.keys())];
                case 1:
                  return e15.sent(), [2];
              }
            });
          }, e14.prototype.values = function() {
            return r(this, function(e15) {
              switch (e15.label) {
                case 0:
                  return [5, a(this._items.values())];
                case 1:
                  return e15.sent(), [2];
              }
            });
          }, e14.prototype.entries = function() {
            return r(this, function(e15) {
              switch (e15.label) {
                case 0:
                  return [5, a(this._items.entries())];
                case 1:
                  return e15.sent(), [2];
              }
            });
          }, e14.prototype[Symbol.iterator] = function() {
            return r(this, function(e15) {
              switch (e15.label) {
                case 0:
                  return [5, a(this._items)];
                case 1:
                  return e15.sent(), [2];
              }
            });
          }, Object.defineProperty(e14.prototype, Symbol.toStringTag, {
            get: function() {
              return "ObjectCache";
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.CompareCache = function() {
          function e14(e15) {
            e15 === void 0 && (e15 = 1e3), this._items = /* @__PURE__ */ new Map(), this._limit = e15;
          }
          return e14.prototype.check = function(e15, t3) {
            if (this._items.get(e15) === t3)
              return true;
            if (this._items.get(t3) === e15)
              return false;
            var n2 = Math.random() < 0.5;
            if (n2 ? this._items.set(e15, t3) : this._items.set(t3, e15), this._items.size > this._limit) {
              var r = this._items.keys().next();
              r.done || this._items.delete(r.value);
            }
            return n2;
          }, e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.Lazy = function() {
          function e14(e15) {
            this._initialized = false, this._value = void 0, this._initFunc = e15;
          }
          return Object.defineProperty(e14.prototype, "value", {
            get: function() {
              return this._initialized ||= (this._value = this._initFunc(), true), this._value;
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.StringWalker = function() {
          function e14(e15) {
            this._pointer = 0, this._chars = Array.from(e15), this._length = this._chars.length;
          }
          return Object.defineProperty(e14.prototype, "eof", {
            get: function() {
              return this._pointer >= this._length;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "length", {
            get: function() {
              return this._length;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.codePoint = function() {
            if (this._codePoint === void 0)
              if (this.eof)
                this._codePoint = -1;
              else {
                var e15 = this._chars[this._pointer].codePointAt(0);
                this._codePoint = e15 === void 0 ? -1 : e15;
              }
            return this._codePoint;
          }, e14.prototype.c = function() {
            return this._c === void 0 && (this._c = this.eof ? "" : this._chars[this._pointer]), this._c;
          }, e14.prototype.remaining = function() {
            return this._remaining === void 0 && (this._remaining = this.eof ? "" : this._chars.slice(this._pointer + 1).join("")), this._remaining;
          }, e14.prototype.substring = function() {
            return this._substring === void 0 && (this._substring = this.eof ? "" : this._chars.slice(this._pointer).join("")), this._substring;
          }, Object.defineProperty(e14.prototype, "pointer", {
            get: function() {
              return this._pointer;
            },
            set: function(e15) {
              e15 !== this._pointer && (this._pointer = e15, this._codePoint = void 0, this._c = void 0, this._remaining = void 0, this._substring = void 0);
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.MapWriter = n(218).MapWriter, t2.XMLWriter = n(258).XMLWriter, t2.ObjectWriter = n(67).ObjectWriter, t2.JSONWriter = n(260).JSONWriter, t2.YAMLWriter = n(261).YAMLWriter;
      },
      function(e13, t2, n) {
        n(19), n(219), n(20), n(22), n(23);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(1), s = n(67);
        t2.MapWriter = function(e14) {
          function t3(t4, n2) {
            var r2 = e14.call(this, t4) || this;
            return r2._writerOptions = o.applyDefaults(n2, {
              format: "map",
              wellFormed: false,
              group: false,
              verbose: false
            }), r2;
          }
          return a(t3, e14), t3.prototype.serialize = function(e15) {
            var t4 = o.applyDefaults(this._writerOptions, {
              format: "object",
              wellFormed: false,
              verbose: false
            }), n2 = new s.ObjectWriter(this._builderOptions, t4).serialize(e15);
            return this._convertObject(n2);
          }, t3.prototype._convertObject = function(e15) {
            if (o.isArray(e15)) {
              for (var t4 = 0; t4 < e15.length; t4++)
                e15[t4] = this._convertObject(e15[t4]);
              return e15;
            }
            if (o.isObject(e15)) {
              var n2 = /* @__PURE__ */ new Map();
              for (var r2 in e15)
                n2.set(r2, this._convertObject(e15[r2]));
              return n2;
            }
            return e15;
          }, t3;
        }(n(50).BaseWriter);
      },
      function(e13, t2, n) {
        e13.exports = n(139)("Map", function(e14) {
          return function() {
            return e14(this, arguments.length ? arguments[0] : void 0);
          };
        }, n(143));
      },
      function(e13, t2, n) {
        var r = n(4), a = n(8), o = n(59), s = n(13), c = n(27), l = n(26), u = n(134), d = n(128), f = n(63), p = n(5), m = n(129), h = p("isConcatSpreadable"), g = m >= 51 || !a(function() {
          var e14 = [];
          return e14[h] = false, e14.concat()[0] !== e14;
        }), _ = f("concat"), v = function(e14) {
          if (!s(e14))
            return false;
          var t3 = e14[h];
          return t3 === void 0 ? o(e14) : !!t3;
        };
        r({
          target: "Array",
          proto: true,
          forced: !g || !_
        }, { concat: function(e14) {
          var t3, n2, r2, a2, o2, s2 = c(this), f2 = d(s2, 0), p2 = 0;
          for (t3 = -1, r2 = arguments.length; t3 < r2; t3++)
            if (v(o2 = t3 === -1 ? s2 : arguments[t3])) {
              if (p2 + (a2 = l(o2.length)) > 9007199254740991)
                throw TypeError("Maximum allowed index exceeded");
              for (n2 = 0; n2 < a2; n2++, p2++)
                n2 in o2 && u(f2, p2, o2[n2]);
            } else {
              if (p2 >= 9007199254740991)
                throw TypeError("Maximum allowed index exceeded");
              u(f2, p2++, o2);
            }
          return f2.length = p2, f2;
        } });
      },
      function(e13, t2, n) {
        var r = n(8);
        function a(e14, t3) {
          return RegExp(e14, t3);
        }
        t2.UNSUPPORTED_Y = r(function() {
          var e14 = a("a", "y");
          return e14.lastIndex = 2, e14.exec("abcd") != null;
        }), t2.BROKEN_CARET = r(function() {
          var e14 = a("^r", "gy");
          return e14.lastIndex = 2, e14.exec("str") != null;
        });
      },
      function(e13, t2, n) {
        var r = n(223);
        e13.exports = function(e14) {
          if (r(e14))
            throw TypeError("The method doesn't accept regular expressions");
          return e14;
        };
      },
      function(e13, t2, n) {
        var r = n(13), a = n(42), o = n(5)("match");
        e13.exports = function(e14) {
          var t3;
          return r(e14) && ((t3 = e14[o]) === void 0 ? a(e14) == "RegExp" : !!t3);
        };
      },
      function(e13, t2, n) {
        var r = n(5)("match");
        e13.exports = function(e14) {
          var t3 = /./;
          try {
            "/./"[e14](t3);
          } catch {
            try {
              return t3[r] = false, "/./"[e14](t3);
            } catch {
            }
          }
          return false;
        };
      },
      function(e13, t2, n) {
        n(68);
        var r = n(25), a = n(8), o = n(5), s = n(93), c = n(21), l = o("species"), u = !a(function() {
          var e14 = /./;
          return e14.exec = function() {
            var e15 = [];
            return e15.groups = { a: "7" }, e15;
          }, "".replace(e14, "$<a>") !== "7";
        }), d = "a".replace(/./, "$0") === "$0", f = o("replace"), p = !!/./[f] && /./[f]("a", "$0") === "", m = !a(function() {
          var e14 = /(?:)/, t3 = e14.exec;
          e14.exec = function() {
            return t3.apply(this, arguments);
          };
          var n2 = "ab".split(e14);
          return n2.length !== 2 || n2[0] !== "a" || n2[1] !== "b";
        });
        e13.exports = function(e14, t3, n2, f2) {
          var h = o(e14), g = !a(function() {
            var t4 = {};
            return t4[h] = function() {
              return 7;
            }, ""[e14](t4) != 7;
          }), _ = g && !a(function() {
            var t4 = false, n3 = /a/;
            return e14 === "split" && ((n3 = {}).constructor = {}, n3.constructor[l] = function() {
              return n3;
            }, n3.flags = "", n3[h] = /./[h]), n3.exec = function() {
              return t4 = true, null;
            }, n3[h](""), !t4;
          });
          if (!g || !_ || e14 === "replace" && (!u || !d || p) || e14 === "split" && !m) {
            var v = /./[h], y = n2(h, ""[e14], function(e15, t4, n3, r2, a2) {
              return t4.exec === s ? g && !a2 ? {
                done: true,
                value: v.call(t4, n3, r2)
              } : {
                done: true,
                value: e15.call(n3, t4, r2)
              } : { done: false };
            }, {
              REPLACE_KEEPS_$0: d,
              REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: p
            }), b = y[0], S = y[1];
            r(String.prototype, e14, b), r(RegExp.prototype, h, t3 == 2 ? function(e15, t4) {
              return S.call(e15, this, t4);
            } : function(e15) {
              return S.call(e15, this);
            });
          }
          f2 && c(RegExp.prototype[h], "sham", true);
        };
      },
      function(e13, t2, n) {
        var r = n(137).charAt;
        e13.exports = function(e14, t3, n2) {
          return t3 + (n2 ? r(e14, t3).length : 1);
        };
      },
      function(e13, t2, n) {
        var r = n(42), a = n(93);
        e13.exports = function(e14, t3) {
          var n2 = e14.exec;
          if (typeof n2 == "function") {
            var o = n2.call(e14, t3);
            if (typeof o != "object")
              throw TypeError("RegExp exec method returned something other than an Object or null");
            return o;
          }
          if (r(e14) !== "RegExp")
            throw TypeError("RegExp#exec called on incompatible receiver");
          return a.call(e14, t3);
        };
      },
      function(e13, t2, n) {
        (function(e14) {
          Object.defineProperty(t2, "__esModule", { value: true });
          var r = n(96);
          t2.forgivingBase64Encode = function(t3) {
            return e14.from(t3).toString("base64");
          }, t2.forgivingBase64Decode = function(t3) {
            return t3 === "" ? "" : ((t3 = t3.replace(r.ASCIIWhiteSpace, "")).length % 4 == 0 && (t3.endsWith("==") ? t3 = t3.substr(0, t3.length - 2) : t3.endsWith("=") && (t3 = t3.substr(0, t3.length - 1))), t3.length % 4 == 1 ? null : /[0-9A-Za-z+/]/.test(t3) ? e14.from(t3, "base64").toString("utf8") : null);
          };
        }).call(this, n(145).Buffer);
      },
      function(e13, t2, n) {
        t2.byteLength = function(e14) {
          var t3 = u(e14), n2 = t3[0], r2 = t3[1];
          return 3 * (n2 + r2) / 4 - r2;
        }, t2.toByteArray = function(e14) {
          var t3, n2, r2 = u(e14), s2 = r2[0], c2 = r2[1], l2 = new o(function(e15, t4, n3) {
            return 3 * (t4 + n3) / 4 - n3;
          }(0, s2, c2)), d2 = 0, f = c2 > 0 ? s2 - 4 : s2;
          for (n2 = 0; n2 < f; n2 += 4)
            t3 = a[e14.charCodeAt(n2)] << 18 | a[e14.charCodeAt(n2 + 1)] << 12 | a[e14.charCodeAt(n2 + 2)] << 6 | a[e14.charCodeAt(n2 + 3)], l2[d2++] = t3 >> 16 & 255, l2[d2++] = t3 >> 8 & 255, l2[d2++] = 255 & t3;
          return c2 === 2 && (t3 = a[e14.charCodeAt(n2)] << 2 | a[e14.charCodeAt(n2 + 1)] >> 4, l2[d2++] = 255 & t3), c2 === 1 && (t3 = a[e14.charCodeAt(n2)] << 10 | a[e14.charCodeAt(n2 + 1)] << 4 | a[e14.charCodeAt(n2 + 2)] >> 2, l2[d2++] = t3 >> 8 & 255, l2[d2++] = 255 & t3), l2;
        }, t2.fromByteArray = function(e14) {
          for (var t3, n2 = e14.length, a2 = n2 % 3, o2 = [], s2 = 0, c2 = n2 - a2; s2 < c2; s2 += 16383)
            o2.push(d(e14, s2, s2 + 16383 > c2 ? c2 : s2 + 16383));
          return a2 === 1 ? (t3 = e14[n2 - 1], o2.push(r[t3 >> 2] + r[t3 << 4 & 63] + "==")) : a2 === 2 && (t3 = (e14[n2 - 2] << 8) + e14[n2 - 1], o2.push(r[t3 >> 10] + r[t3 >> 4 & 63] + r[t3 << 2 & 63] + "=")), o2.join("");
        };
        for (var r = [], a = [], o = typeof Uint8Array < "u" ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = 0, l = s.length; c < l; ++c)
          r[c] = s[c], a[s.charCodeAt(c)] = c;
        function u(e14) {
          var t3 = e14.length;
          if (t3 % 4 > 0)
            throw Error("Invalid string. Length must be a multiple of 4");
          var n2 = e14.indexOf("=");
          return n2 === -1 && (n2 = t3), [n2, n2 === t3 ? 0 : 4 - n2 % 4];
        }
        function d(e14, t3, n2) {
          for (var a2, o2, s2 = [], c2 = t3; c2 < n2; c2 += 3)
            a2 = (e14[c2] << 16 & 16711680) + (e14[c2 + 1] << 8 & 65280) + (255 & e14[c2 + 2]), s2.push(r[(o2 = a2) >> 18 & 63] + r[o2 >> 12 & 63] + r[o2 >> 6 & 63] + r[63 & o2]);
          return s2.join("");
        }
        a[45] = 62, a[95] = 63;
      },
      function(e13, t2) {
        t2.read = function(e14, t3, n, r, a) {
          var o, s, c = 8 * a - r - 1, l = (1 << c) - 1, u = l >> 1, d = -7, f = n ? a - 1 : 0, p = n ? -1 : 1, m = e14[t3 + f];
          for (f += p, o = m & (1 << -d) - 1, m >>= -d, d += c; d > 0; o = 256 * o + e14[t3 + f], f += p, d -= 8)
            ;
          for (s = o & (1 << -d) - 1, o >>= -d, d += r; d > 0; s = 256 * s + e14[t3 + f], f += p, d -= 8)
            ;
          if (o === 0)
            o = 1 - u;
          else {
            if (o === l)
              return s ? NaN : Infinity * (m ? -1 : 1);
            s += 2 ** r, o -= u;
          }
          return (m ? -1 : 1) * s * 2 ** (o - r);
        }, t2.write = function(e14, t3, n, r, a, o) {
          var s, c, l, u = 8 * o - a - 1, d = (1 << u) - 1, f = d >> 1, p = a === 23 ? 2 ** -24 - 2 ** -77 : 0, m = r ? 0 : o - 1, h = r ? 1 : -1, g = t3 < 0 || t3 === 0 && 1 / t3 < 0 ? 1 : 0;
          for (t3 = Math.abs(t3), isNaN(t3) || t3 === Infinity ? (c = isNaN(t3) ? 1 : 0, s = d) : (s = Math.floor(Math.log(t3) / Math.LN2), t3 * (l = 2 ** -s) < 1 && (s--, l *= 2), (t3 += s + f >= 1 ? p / l : p * 2 ** (1 - f)) * l >= 2 && (s++, l /= 2), s + f >= d ? (c = 0, s = d) : s + f >= 1 ? (c = (t3 * l - 1) * 2 ** a, s += f) : (c = t3 * 2 ** (f - 1) * 2 ** a, s = 0)); a >= 8; e14[n + m] = 255 & c, m += h, c /= 256, a -= 8)
            ;
          for (s = s << a | c, u += a; u > 0; e14[n + m] = 255 & s, m += h, s /= 256, u -= 8)
            ;
          e14[n + m - h] |= 128 * g;
        };
      },
      function(e13, t2) {
        var n = {}.toString;
        e13.exports = Array.isArray || function(e14) {
          return n.call(e14) == "[object Array]";
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(1);
        function o(e14) {
          var t3, n2;
          if (e14 === null || a.isString(e14) || a.isNumber(e14))
            return e14;
          if (a.isArray(e14)) {
            var s = [];
            try {
              for (var c = r(e14), l = c.next(); !l.done; l = c.next()) {
                var u = l.value;
                s.push(o(u));
              }
            } catch (e15) {
              t3 = { error: e15 };
            } finally {
              try {
                l && !l.done && (n2 = c.return) && n2.call(c);
              } finally {
                if (t3)
                  throw t3.error;
              }
            }
            return s;
          }
          if (a.isObject(e14)) {
            for (var d in s = /* @__PURE__ */ new Map(), e14)
              if (e14.hasOwnProperty(d)) {
                var f = e14[d];
                s.set(d, o(f));
              }
            return s;
          }
          return e14;
        }
        t2.parseJSONFromBytes = function(e14) {
          var t3 = a.utf8Decode(e14);
          return JSON.parse.call(void 0, t3);
        }, t2.serializeJSONToBytes = function(e14) {
          var t3 = JSON.stringify.call(void 0, e14);
          return a.utf8Encode(t3);
        }, t2.parseJSONIntoInfraValues = function(e14) {
          return o(JSON.parse.call(void 0, e14));
        }, t2.convertAJSONDerivedJavaScriptValueToAnInfraValue = o;
      },
      function(e13, t2, n) {
        var r = this && this.__generator || function(e14, t3) {
          var n2, r2, a2, o2, s2 = {
            label: 0,
            sent: function() {
              if (1 & a2[0])
                throw a2[1];
              return a2[1];
            },
            trys: [],
            ops: []
          };
          return o2 = {
            next: c2(0),
            throw: c2(1),
            return: c2(2)
          }, typeof Symbol == "function" && (o2[Symbol.iterator] = function() {
            return this;
          }), o2;
          function c2(o3) {
            return function(c3) {
              return function(o4) {
                if (n2)
                  throw TypeError("Generator is already executing.");
                for (; s2; )
                  try {
                    if (n2 = 1, r2 && (a2 = 2 & o4[0] ? r2.return : o4[0] ? r2.throw || ((a2 = r2.return) && a2.call(r2), 0) : r2.next) && !(a2 = a2.call(r2, o4[1])).done)
                      return a2;
                    switch (r2 = 0, a2 && (o4 = [2 & o4[0], a2.value]), o4[0]) {
                      case 0:
                      case 1:
                        a2 = o4;
                        break;
                      case 4:
                        return s2.label++, {
                          value: o4[1],
                          done: false
                        };
                      case 5:
                        s2.label++, r2 = o4[1], o4 = [0];
                        continue;
                      case 7:
                        o4 = s2.ops.pop(), s2.trys.pop();
                        continue;
                      default:
                        if (a2 = s2.trys, !((a2 = a2.length > 0 && a2[a2.length - 1]) || o4[0] !== 6 && o4[0] !== 2)) {
                          s2 = 0;
                          continue;
                        }
                        if (o4[0] === 3 && (!a2 || o4[1] > a2[0] && o4[1] < a2[3])) {
                          s2.label = o4[1];
                          break;
                        }
                        if (o4[0] === 6 && s2.label < a2[1]) {
                          s2.label = a2[1], a2 = o4;
                          break;
                        }
                        if (a2 && s2.label < a2[2]) {
                          s2.label = a2[2], s2.ops.push(o4);
                          break;
                        }
                        a2[2] && s2.ops.pop(), s2.trys.pop();
                        continue;
                    }
                    o4 = t3.call(e14, s2);
                  } catch (e15) {
                    o4 = [6, e15], r2 = 0;
                  } finally {
                    n2 = a2 = 0;
                  }
                if (5 & o4[0])
                  throw o4[1];
                return {
                  value: o4[0] ? o4[1] : void 0,
                  done: true
                };
              }([o3, c3]);
            };
          }
        }, a = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, o = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(a(arguments[t3]));
          return e14;
        }, s = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var c = n(1);
        t2.append = function(e14, t3) {
          e14.push(t3);
        }, t2.extend = function(e14, t3) {
          e14.push.apply(e14, o(t3));
        }, t2.prepend = function(e14, t3) {
          e14.unshift(t3);
        }, t2.replace = function(e14, t3, n2) {
          var r2, a2, o2 = 0;
          try {
            for (var l = s(e14), u = l.next(); !u.done; u = l.next()) {
              var d = u.value;
              if (c.isFunction(t3))
                t3.call(null, d) && (e14[o2] = n2);
              else if (d === t3)
                return void (e14[o2] = n2);
              o2++;
            }
          } catch (e15) {
            r2 = { error: e15 };
          } finally {
            try {
              u && !u.done && (a2 = l.return) && a2.call(l);
            } finally {
              if (r2)
                throw r2.error;
            }
          }
        }, t2.insert = function(e14, t3, n2) {
          e14.splice(n2, 0, t3);
        }, t2.remove = function(e14, t3) {
          for (var n2 = e14.length; n2--; ) {
            var r2 = e14[n2];
            if (c.isFunction(t3))
              t3.call(null, r2) && e14.splice(n2, 1);
            else if (r2 === t3)
              return void e14.splice(n2, 1);
          }
        }, t2.empty = function(e14) {
          e14.length = 0;
        }, t2.contains = function(e14, t3) {
          var n2, r2;
          try {
            for (var a2 = s(e14), o2 = a2.next(); !o2.done; o2 = a2.next()) {
              var l = o2.value;
              if (c.isFunction(t3)) {
                if (t3.call(null, l))
                  return true;
              } else if (l === t3)
                return true;
            }
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              o2 && !o2.done && (r2 = a2.return) && r2.call(a2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          return false;
        }, t2.size = function(e14, t3) {
          var n2, r2;
          if (t3 === void 0)
            return e14.length;
          var a2 = 0;
          try {
            for (var o2 = s(e14), c2 = o2.next(); !c2.done; c2 = o2.next()) {
              var l = c2.value;
              t3.call(null, l) && a2++;
            }
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              c2 && !c2.done && (r2 = o2.return) && r2.call(o2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          return a2;
        }, t2.isEmpty = function(e14) {
          return e14.length === 0;
        }, t2.forEach = function(e14, t3) {
          var n2, a2, o2, c2, l, u;
          return r(this, function(r2) {
            switch (r2.label) {
              case 0:
                return t3 === void 0 ? [5, s(e14)] : [3, 2];
              case 1:
                return r2.sent(), [3, 9];
              case 2:
                r2.trys.push([
                  2,
                  7,
                  8,
                  9
                ]), n2 = s(e14), a2 = n2.next(), r2.label = 3;
              case 3:
                return a2.done ? [3, 6] : (o2 = a2.value, t3.call(null, o2) ? [4, o2] : [3, 5]);
              case 4:
                r2.sent(), r2.label = 5;
              case 5:
                return a2 = n2.next(), [3, 3];
              case 6:
                return [3, 9];
              case 7:
                return c2 = r2.sent(), l = { error: c2 }, [3, 9];
              case 8:
                try {
                  a2 && !a2.done && (u = n2.return) && u.call(n2);
                } finally {
                  if (l)
                    throw l.error;
                }
                return [7];
              case 9:
                return [2];
            }
          });
        }, t2.clone = function(e14) {
          return new (Array.bind.apply(Array, o([void 0], e14)))();
        }, t2.sortInAscendingOrder = function(e14, t3) {
          return e14.sort(function(e15, n2) {
            return t3.call(null, e15, n2) ? -1 : 1;
          });
        }, t2.sortInDescendingOrder = function(e14, t3) {
          return e14.sort(function(e15, n2) {
            return t3.call(null, e15, n2) ? 1 : -1;
          });
        };
      },
      function(e13, t2, n) {
        var r = this && this.__generator || function(e14, t3) {
          var n2, r2, a2, o2, s2 = {
            label: 0,
            sent: function() {
              if (1 & a2[0])
                throw a2[1];
              return a2[1];
            },
            trys: [],
            ops: []
          };
          return o2 = {
            next: c2(0),
            throw: c2(1),
            return: c2(2)
          }, typeof Symbol == "function" && (o2[Symbol.iterator] = function() {
            return this;
          }), o2;
          function c2(o3) {
            return function(c3) {
              return function(o4) {
                if (n2)
                  throw TypeError("Generator is already executing.");
                for (; s2; )
                  try {
                    if (n2 = 1, r2 && (a2 = 2 & o4[0] ? r2.return : o4[0] ? r2.throw || ((a2 = r2.return) && a2.call(r2), 0) : r2.next) && !(a2 = a2.call(r2, o4[1])).done)
                      return a2;
                    switch (r2 = 0, a2 && (o4 = [2 & o4[0], a2.value]), o4[0]) {
                      case 0:
                      case 1:
                        a2 = o4;
                        break;
                      case 4:
                        return s2.label++, {
                          value: o4[1],
                          done: false
                        };
                      case 5:
                        s2.label++, r2 = o4[1], o4 = [0];
                        continue;
                      case 7:
                        o4 = s2.ops.pop(), s2.trys.pop();
                        continue;
                      default:
                        if (a2 = s2.trys, !((a2 = a2.length > 0 && a2[a2.length - 1]) || o4[0] !== 6 && o4[0] !== 2)) {
                          s2 = 0;
                          continue;
                        }
                        if (o4[0] === 3 && (!a2 || o4[1] > a2[0] && o4[1] < a2[3])) {
                          s2.label = o4[1];
                          break;
                        }
                        if (o4[0] === 6 && s2.label < a2[1]) {
                          s2.label = a2[1], a2 = o4;
                          break;
                        }
                        if (a2 && s2.label < a2[2]) {
                          s2.label = a2[2], s2.ops.push(o4);
                          break;
                        }
                        a2[2] && s2.ops.pop(), s2.trys.pop();
                        continue;
                    }
                    o4 = t3.call(e14, s2);
                  } catch (e15) {
                    o4 = [6, e15], r2 = 0;
                  } finally {
                    n2 = a2 = 0;
                  }
                if (5 & o4[0])
                  throw o4[1];
                return {
                  value: o4[0] ? o4[1] : void 0,
                  done: true
                };
              }([o3, c3]);
            };
          }
        }, a = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, o = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, s = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(o(arguments[t3]));
          return e14;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var c = n(1);
        t2.get = function(e14, t3) {
          return e14.get(t3);
        }, t2.set = function(e14, t3, n2) {
          e14.set(t3, n2);
        }, t2.remove = function(e14, t3) {
          var n2, r2, o2, s2;
          if (c.isFunction(t3)) {
            var l = [];
            try {
              for (var u = a(e14), d = u.next(); !d.done; d = u.next()) {
                var f = d.value;
                t3.call(null, f) && l.push(f[0]);
              }
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                d && !d.done && (r2 = u.return) && r2.call(u);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
            try {
              for (var p = a(l), m = p.next(); !m.done; m = p.next()) {
                var h = m.value;
                e14.delete(h);
              }
            } catch (e15) {
              o2 = { error: e15 };
            } finally {
              try {
                m && !m.done && (s2 = p.return) && s2.call(p);
              } finally {
                if (o2)
                  throw o2.error;
              }
            }
          } else
            e14.delete(t3);
        }, t2.contains = function(e14, t3) {
          var n2, r2;
          if (c.isFunction(t3)) {
            try {
              for (var o2 = a(e14), s2 = o2.next(); !s2.done; s2 = o2.next()) {
                var l = s2.value;
                if (t3.call(null, l))
                  return true;
              }
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                s2 && !s2.done && (r2 = o2.return) && r2.call(o2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
            return false;
          }
          return e14.has(t3);
        }, t2.keys = function(e14) {
          return new Set(e14.keys());
        }, t2.values = function(e14) {
          return s(e14.values());
        }, t2.size = function(e14, t3) {
          var n2, r2;
          if (t3 === void 0)
            return e14.size;
          var o2 = 0;
          try {
            for (var s2 = a(e14), c2 = s2.next(); !c2.done; c2 = s2.next()) {
              var l = c2.value;
              t3.call(null, l) && o2++;
            }
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              c2 && !c2.done && (r2 = s2.return) && r2.call(s2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          return o2;
        }, t2.isEmpty = function(e14) {
          return e14.size === 0;
        }, t2.forEach = function(e14, t3) {
          var n2, o2, s2, c2, l, u;
          return r(this, function(r2) {
            switch (r2.label) {
              case 0:
                return t3 === void 0 ? [5, a(e14)] : [3, 2];
              case 1:
                return r2.sent(), [3, 9];
              case 2:
                r2.trys.push([
                  2,
                  7,
                  8,
                  9
                ]), n2 = a(e14), o2 = n2.next(), r2.label = 3;
              case 3:
                return o2.done ? [3, 6] : (s2 = o2.value, t3.call(null, s2) ? [4, s2] : [3, 5]);
              case 4:
                r2.sent(), r2.label = 5;
              case 5:
                return o2 = n2.next(), [3, 3];
              case 6:
                return [3, 9];
              case 7:
                return c2 = r2.sent(), l = { error: c2 }, [3, 9];
              case 8:
                try {
                  o2 && !o2.done && (u = n2.return) && u.call(n2);
                } finally {
                  if (l)
                    throw l.error;
                }
                return [7];
              case 9:
                return [2];
            }
          });
        }, t2.clone = function(e14) {
          return new Map(e14);
        }, t2.sortInAscendingOrder = function(e14, t3) {
          var n2 = new (Array.bind.apply(Array, s([void 0], e14)))();
          return n2.sort(function(e15, n3) {
            return t3.call(null, e15, n3) ? -1 : 1;
          }), new Map(n2);
        }, t2.sortInDescendingOrder = function(e14, t3) {
          var n2 = new (Array.bind.apply(Array, s([void 0], e14)))();
          return n2.sort(function(e15, n3) {
            return t3.call(null, e15, n3) ? 1 : -1;
          }), new Map(n2);
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.HTML = "http://www.w3.org/1999/xhtml", t2.XML = "http://www.w3.org/XML/1998/namespace", t2.XMLNS = "http://www.w3.org/2000/xmlns/", t2.MathML = "http://www.w3.org/1998/Math/MathML", t2.SVG = "http://www.w3.org/2000/svg", t2.XLink = "http://www.w3.org/1999/xlink";
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.enqueue = function(e14, t3) {
          e14.push(t3);
        }, t2.dequeue = function(e14) {
          return e14.shift() || null;
        };
      },
      function(e13, t2, n) {
        var r = this && this.__generator || function(e14, t3) {
          var n2, r2, a2, o2, s2 = {
            label: 0,
            sent: function() {
              if (1 & a2[0])
                throw a2[1];
              return a2[1];
            },
            trys: [],
            ops: []
          };
          return o2 = {
            next: c2(0),
            throw: c2(1),
            return: c2(2)
          }, typeof Symbol == "function" && (o2[Symbol.iterator] = function() {
            return this;
          }), o2;
          function c2(o3) {
            return function(c3) {
              return function(o4) {
                if (n2)
                  throw TypeError("Generator is already executing.");
                for (; s2; )
                  try {
                    if (n2 = 1, r2 && (a2 = 2 & o4[0] ? r2.return : o4[0] ? r2.throw || ((a2 = r2.return) && a2.call(r2), 0) : r2.next) && !(a2 = a2.call(r2, o4[1])).done)
                      return a2;
                    switch (r2 = 0, a2 && (o4 = [2 & o4[0], a2.value]), o4[0]) {
                      case 0:
                      case 1:
                        a2 = o4;
                        break;
                      case 4:
                        return s2.label++, {
                          value: o4[1],
                          done: false
                        };
                      case 5:
                        s2.label++, r2 = o4[1], o4 = [0];
                        continue;
                      case 7:
                        o4 = s2.ops.pop(), s2.trys.pop();
                        continue;
                      default:
                        if (a2 = s2.trys, !((a2 = a2.length > 0 && a2[a2.length - 1]) || o4[0] !== 6 && o4[0] !== 2)) {
                          s2 = 0;
                          continue;
                        }
                        if (o4[0] === 3 && (!a2 || o4[1] > a2[0] && o4[1] < a2[3])) {
                          s2.label = o4[1];
                          break;
                        }
                        if (o4[0] === 6 && s2.label < a2[1]) {
                          s2.label = a2[1], a2 = o4;
                          break;
                        }
                        if (a2 && s2.label < a2[2]) {
                          s2.label = a2[2], s2.ops.push(o4);
                          break;
                        }
                        a2[2] && s2.ops.pop(), s2.trys.pop();
                        continue;
                    }
                    o4 = t3.call(e14, s2);
                  } catch (e15) {
                    o4 = [6, e15], r2 = 0;
                  } finally {
                    n2 = a2 = 0;
                  }
                if (5 & o4[0])
                  throw o4[1];
                return {
                  value: o4[0] ? o4[1] : void 0,
                  done: true
                };
              }([o3, c3]);
            };
          }
        }, a = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, o = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, s = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(o(arguments[t3]));
          return e14;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var c = n(1);
        function l(e14, t3) {
          var n2, r2;
          try {
            for (var o2 = a(e14), s2 = o2.next(); !s2.done; s2 = o2.next()) {
              var c2 = s2.value;
              if (!t3.has(c2))
                return false;
            }
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              s2 && !s2.done && (r2 = o2.return) && r2.call(o2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          return true;
        }
        t2.append = function(e14, t3) {
          e14.add(t3);
        }, t2.extend = function(e14, t3) {
          t3.forEach(e14.add, e14);
        }, t2.prepend = function(e14, t3) {
          var n2 = new Set(e14);
          e14.clear(), e14.add(t3), n2.forEach(e14.add, e14);
        }, t2.replace = function(e14, t3, n2) {
          var r2, o2, s2 = /* @__PURE__ */ new Set();
          try {
            for (var l2 = a(e14), u = l2.next(); !u.done; u = l2.next()) {
              var d = u.value;
              c.isFunction(t3) ? t3.call(null, d) ? s2.add(n2) : s2.add(d) : d === t3 ? s2.add(n2) : s2.add(d);
            }
          } catch (e15) {
            r2 = { error: e15 };
          } finally {
            try {
              u && !u.done && (o2 = l2.return) && o2.call(l2);
            } finally {
              if (r2)
                throw r2.error;
            }
          }
          e14.clear(), s2.forEach(e14.add, e14);
        }, t2.insert = function(e14, t3, n2) {
          var r2, o2, s2 = /* @__PURE__ */ new Set(), c2 = 0;
          try {
            for (var l2 = a(e14), u = l2.next(); !u.done; u = l2.next()) {
              var d = u.value;
              c2 === n2 && s2.add(t3), s2.add(d), c2++;
            }
          } catch (e15) {
            r2 = { error: e15 };
          } finally {
            try {
              u && !u.done && (o2 = l2.return) && o2.call(l2);
            } finally {
              if (r2)
                throw r2.error;
            }
          }
          e14.clear(), s2.forEach(e14.add, e14);
        }, t2.remove = function(e14, t3) {
          var n2, r2, o2, s2;
          if (c.isFunction(t3)) {
            var l2 = [];
            try {
              for (var u = a(e14), d = u.next(); !d.done; d = u.next()) {
                var f = d.value;
                t3.call(null, f) && l2.push(f);
              }
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                d && !d.done && (r2 = u.return) && r2.call(u);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
            try {
              for (var p = a(l2), m = p.next(); !m.done; m = p.next()) {
                var h = m.value;
                e14.delete(h);
              }
            } catch (e15) {
              o2 = { error: e15 };
            } finally {
              try {
                m && !m.done && (s2 = p.return) && s2.call(p);
              } finally {
                if (o2)
                  throw o2.error;
              }
            }
          } else
            e14.delete(t3);
        }, t2.empty = function(e14) {
          e14.clear();
        }, t2.contains = function(e14, t3) {
          var n2, r2;
          if (!c.isFunction(t3))
            return e14.has(t3);
          try {
            for (var o2 = a(e14), s2 = o2.next(); !s2.done; s2 = o2.next()) {
              var l2 = s2.value;
              if (t3.call(null, l2))
                return true;
            }
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              s2 && !s2.done && (r2 = o2.return) && r2.call(o2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          return false;
        }, t2.size = function(e14, t3) {
          var n2, r2;
          if (t3 === void 0)
            return e14.size;
          var o2 = 0;
          try {
            for (var s2 = a(e14), c2 = s2.next(); !c2.done; c2 = s2.next()) {
              var l2 = c2.value;
              t3.call(null, l2) && o2++;
            }
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              c2 && !c2.done && (r2 = s2.return) && r2.call(s2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          return o2;
        }, t2.isEmpty = function(e14) {
          return e14.size === 0;
        }, t2.forEach = function(e14, t3) {
          var n2, o2, s2, c2, l2, u;
          return r(this, function(r2) {
            switch (r2.label) {
              case 0:
                return t3 === void 0 ? [5, a(e14)] : [3, 2];
              case 1:
                return r2.sent(), [3, 9];
              case 2:
                r2.trys.push([
                  2,
                  7,
                  8,
                  9
                ]), n2 = a(e14), o2 = n2.next(), r2.label = 3;
              case 3:
                return o2.done ? [3, 6] : (s2 = o2.value, t3.call(null, s2) ? [4, s2] : [3, 5]);
              case 4:
                r2.sent(), r2.label = 5;
              case 5:
                return o2 = n2.next(), [3, 3];
              case 6:
                return [3, 9];
              case 7:
                return c2 = r2.sent(), l2 = { error: c2 }, [3, 9];
              case 8:
                try {
                  o2 && !o2.done && (u = n2.return) && u.call(n2);
                } finally {
                  if (l2)
                    throw l2.error;
                }
                return [7];
              case 9:
                return [2];
            }
          });
        }, t2.clone = function(e14) {
          return new Set(e14);
        }, t2.sortInAscendingOrder = function(e14, t3) {
          var n2 = new (Array.bind.apply(Array, s([void 0], e14)))();
          return n2.sort(function(e15, n3) {
            return t3.call(null, e15, n3) ? -1 : 1;
          }), new Set(n2);
        }, t2.sortInDescendingOrder = function(e14, t3) {
          var n2 = new (Array.bind.apply(Array, s([void 0], e14)))();
          return n2.sort(function(e15, n3) {
            return t3.call(null, e15, n3) ? 1 : -1;
          }), new Set(n2);
        }, t2.isSubsetOf = l, t2.isSupersetOf = function(e14, t3) {
          return l(t3, e14);
        }, t2.intersection = function(e14, t3) {
          var n2, r2, o2 = /* @__PURE__ */ new Set();
          try {
            for (var s2 = a(e14), c2 = s2.next(); !c2.done; c2 = s2.next()) {
              var l2 = c2.value;
              t3.has(l2) && o2.add(l2);
            }
          } catch (e15) {
            n2 = { error: e15 };
          } finally {
            try {
              c2 && !c2.done && (r2 = s2.return) && r2.call(s2);
            } finally {
              if (n2)
                throw n2.error;
            }
          }
          return o2;
        }, t2.union = function(e14, t3) {
          var n2 = new Set(e14);
          return t3.forEach(n2.add, n2), n2;
        }, t2.range = function(e14, t3) {
          for (var n2 = /* @__PURE__ */ new Set(), r2 = e14; r2 <= t3; r2++)
            n2.add(r2);
          return n2;
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.push = function(e14, t3) {
          e14.push(t3);
        }, t2.pop = function(e14) {
          return e14.pop() || null;
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(96), o = n(147), s = n(146), c = n(1);
        function l(e14, t3) {
          for (var n2 = 0; ; ) {
            var r2 = n2 < e14.length ? e14.charCodeAt(n2) : null, a2 = n2 < t3.length ? t3.charCodeAt(n2) : null;
            if (r2 === null)
              return true;
            if (r2 !== a2)
              return false;
            n2++;
          }
        }
        function u(e14) {
          var t3, n2, a2 = Array.from(e14), o2 = new Uint8Array(a2.length), s2 = 0;
          try {
            for (var c2 = r(e14), l2 = c2.next(); !l2.done; l2 = c2.next()) {
              var u2 = l2.value.codePointAt(0);
              console.assert(u2 !== void 0 && u2 <= 255, "isomorphicEncode requires string bytes to be less than or equal to 0x00FF."), u2 !== void 0 && u2 <= 255 && (o2[s2++] = u2);
            }
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              l2 && !l2.done && (n2 = c2.return) && n2.call(c2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          return o2;
        }
        function d(e14) {
          return /^[\u0000-\u007F]*$/.test(e14);
        }
        function f(e14) {
          var t3, n2, a2 = "";
          try {
            for (var o2 = r(e14), s2 = o2.next(); !s2.done; s2 = o2.next()) {
              var c2 = s2.value, l2 = c2.codePointAt(0);
              a2 += l2 !== void 0 && l2 >= 65 && l2 <= 90 ? String.fromCodePoint(l2 + 32) : c2;
            }
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              s2 && !s2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          return a2;
        }
        function p(e14) {
          return e14.replace(/^[\t\n\f\r ]+/, "").replace(/[\t\n\f\r ]+$/, "");
        }
        function m(e14, t3, n2) {
          if (!c.isArray(t3))
            return m(e14, Array.from(t3), n2);
          for (var r2 = ""; n2.position < t3.length && e14.call(null, t3[n2.position]); )
            r2 += t3[n2.position], n2.position++;
          return r2;
        }
        function h(e14, t3) {
          m(function(e15) {
            return a.ASCIIWhiteSpace.test(e15);
          }, e14, t3);
        }
        t2.isCodeUnitPrefix = l, t2.isCodeUnitLessThan = function(e14, t3) {
          if (l(t3, e14))
            return false;
          if (l(e14, t3))
            return true;
          for (var n2 = 0; n2 < Math.min(e14.length, t3.length); n2++) {
            var r2 = e14.charCodeAt(n2), a2 = t3.charCodeAt(n2);
            if (r2 !== a2)
              return r2 < a2;
          }
          return false;
        }, t2.isomorphicEncode = u, t2.isASCIIString = d, t2.asciiLowercase = f, t2.asciiUppercase = function(e14) {
          var t3, n2, a2 = "";
          try {
            for (var o2 = r(e14), s2 = o2.next(); !s2.done; s2 = o2.next()) {
              var c2 = s2.value, l2 = c2.codePointAt(0);
              a2 += l2 !== void 0 && l2 >= 97 && l2 <= 122 ? String.fromCodePoint(l2 - 32) : c2;
            }
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              s2 && !s2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          return a2;
        }, t2.asciiCaseInsensitiveMatch = function(e14, t3) {
          return f(e14) === f(t3);
        }, t2.asciiEncode = function(e14) {
          return console.assert(d(e14), "asciiEncode requires an ASCII string."), u(e14);
        }, t2.asciiDecode = function(e14) {
          var t3, n2;
          try {
            for (var a2 = r(e14), c2 = a2.next(); !c2.done; c2 = a2.next()) {
              var l2 = c2.value;
              console.assert(s.isASCIIByte(l2), "asciiDecode requires an ASCII byte sequence.");
            }
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              c2 && !c2.done && (n2 = a2.return) && n2.call(a2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          return o.isomorphicDecode(e14);
        }, t2.stripNewlines = function(e14) {
          return e14.replace(/[\n\r]/g, "");
        }, t2.normalizeNewlines = function(e14) {
          return e14.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        }, t2.stripLeadingAndTrailingASCIIWhitespace = p, t2.stripAndCollapseASCIIWhitespace = function(e14) {
          return p(e14.replace(/[\t\n\f\r ]{2,}/g, " "));
        }, t2.collectASequenceOfCodePoints = m, t2.skipASCIIWhitespace = h, t2.strictlySplit = function e14(t3, n2) {
          if (!c.isArray(t3))
            return e14(Array.from(t3), n2);
          var r2 = { position: 0 }, a2 = [], o2 = m(function(e15) {
            return n2 !== e15;
          }, t3, r2);
          for (a2.push(o2); r2.position < t3.length; )
            console.assert(t3[r2.position] === n2, "strictlySplit found no delimiter in input string."), r2.position++, o2 = m(function(e15) {
              return n2 !== e15;
            }, t3, r2), a2.push(o2);
          return a2;
        }, t2.splitAStringOnASCIIWhitespace = function e14(t3) {
          if (!c.isArray(t3))
            return e14(Array.from(t3));
          var n2 = { position: 0 }, r2 = [];
          for (h(t3, n2); n2.position < t3.length; ) {
            var o2 = m(function(e15) {
              return !a.ASCIIWhiteSpace.test(e15);
            }, t3, n2);
            r2.push(o2), h(t3, n2);
          }
          return r2;
        }, t2.splitAStringOnCommas = function e14(t3) {
          if (!c.isArray(t3))
            return e14(Array.from(t3));
          for (var n2 = { position: 0 }, r2 = []; n2.position < t3.length; ) {
            var a2 = m(function(e15) {
              return e15 !== ",";
            }, t3, n2);
            r2.push(p(a2)), n2.position < t3.length && (console.assert(t3[n2.position] === ",", "splitAStringOnCommas found no delimiter in input string."), n2.position++);
          }
          return r2;
        }, t2.concatenate = function(e14, t3) {
          return t3 === void 0 && (t3 = ""), e14.length === 0 ? "" : e14.join(t3);
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(97);
        t2.abort_add = function(e14, t3) {
          t3._abortedFlag || t3._abortAlgorithms.add(e14);
        }, t2.abort_remove = function(e14, t3) {
          t3._abortAlgorithms.delete(e14);
        }, t2.abort_signalAbort = function(e14) {
          var t3, n2;
          if (!e14._abortedFlag) {
            e14._abortedFlag = true;
            try {
              for (var o = r(e14._abortAlgorithms), s = o.next(); !s.done; s = o.next())
                s.value.call(e14);
            } catch (e15) {
              t3 = { error: e15 };
            } finally {
              try {
                s && !s.done && (n2 = o.return) && n2.call(o);
              } finally {
                if (t3)
                  throw t3.error;
              }
            }
            e14._abortAlgorithms.clear(), a.event_fireAnEvent("abort", e14);
          }
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(150);
        t2.Cast = function() {
          function e14() {
          }
          return e14.asNode = function(e15) {
            if (r.Guard.isNode(e15))
              return e15;
            throw Error("Invalid object. Node expected.");
          }, e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.EmptySet = function() {
          function e14() {
          }
          return Object.defineProperty(e14.prototype, "size", {
            get: function() {
              return 0;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.add = function(e15) {
            throw Error("Cannot add to an empty set.");
          }, e14.prototype.clear = function() {
          }, e14.prototype.delete = function(e15) {
            return false;
          }, e14.prototype.forEach = function(e15, t3) {
          }, e14.prototype.has = function(e15) {
            return false;
          }, e14.prototype[Symbol.iterator] = function() {
            return new r();
          }, e14.prototype.entries = function() {
            return new r();
          }, e14.prototype.keys = function() {
            return new r();
          }, e14.prototype.values = function() {
            return new r();
          }, Object.defineProperty(e14.prototype, Symbol.toStringTag, {
            get: function() {
              return "EmptySet";
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
        var r = function() {
          function e14() {
          }
          return e14.prototype[Symbol.iterator] = function() {
            return this;
          }, e14.prototype.next = function() {
            return {
              done: true,
              value: null
            };
          }, e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), function(e14) {
          e14[e14.SchemeStart = 0] = "SchemeStart", e14[e14.Scheme = 1] = "Scheme", e14[e14.NoScheme = 2] = "NoScheme", e14[e14.SpecialRelativeOrAuthority = 3] = "SpecialRelativeOrAuthority", e14[e14.PathOrAuthority = 4] = "PathOrAuthority", e14[e14.Relative = 5] = "Relative", e14[e14.RelativeSlash = 6] = "RelativeSlash", e14[e14.SpecialAuthoritySlashes = 7] = "SpecialAuthoritySlashes", e14[e14.SpecialAuthorityIgnoreSlashes = 8] = "SpecialAuthorityIgnoreSlashes", e14[e14.Authority = 9] = "Authority", e14[e14.Host = 10] = "Host", e14[e14.Hostname = 11] = "Hostname", e14[e14.Port = 12] = "Port", e14[e14.File = 13] = "File", e14[e14.FileSlash = 14] = "FileSlash", e14[e14.FileHost = 15] = "FileHost", e14[e14.PathStart = 16] = "PathStart", e14[e14.Path = 17] = "Path", e14[e14.CannotBeABaseURLPath = 18] = "CannotBeABaseURLPath", e14[e14.Query = 19] = "Query", e14[e14.Fragment = 20] = "Fragment";
        }(t2.ParserState ||= {}), t2.OpaqueOrigin = [
          "",
          "",
          null,
          null
        ];
      },
      function(e13, t2, n) {
        var r = n(245), a = n(247);
        function o() {
          this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
        }
        t2.parse = y, t2.resolve = function(e14, t3) {
          return y(e14, false, true).resolve(t3);
        }, t2.resolveObject = function(e14, t3) {
          return e14 ? y(e14, false, true).resolveObject(t3) : t3;
        }, t2.format = function(e14) {
          return a.isString(e14) && (e14 = y(e14)), e14 instanceof o ? e14.format() : o.prototype.format.call(e14);
        }, t2.Url = o;
        var s = /^([a-z0-9.+-]+:)/i, c = /:[0-9]*$/, l = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, u = [
          "'",
          "{",
          "}",
          "|",
          "\\",
          "^",
          "`",
          "<",
          ">",
          '"',
          "`",
          " ",
          "\r",
          "\n",
          "	"
        ], d = [
          "%",
          "/",
          "?",
          ";",
          "#"
        ].concat(u), f = [
          "/",
          "?",
          "#"
        ], p = /^[+a-z0-9A-Z_-]{0,63}$/, m = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, h = {
          javascript: true,
          "javascript:": true
        }, g = {
          javascript: true,
          "javascript:": true
        }, _ = {
          http: true,
          https: true,
          ftp: true,
          gopher: true,
          file: true,
          "http:": true,
          "https:": true,
          "ftp:": true,
          "gopher:": true,
          "file:": true
        }, v = n(248);
        function y(e14, t3, n2) {
          if (e14 && a.isObject(e14) && e14 instanceof o)
            return e14;
          var r2 = new o();
          return r2.parse(e14, t3, n2), r2;
        }
        o.prototype.parse = function(e14, t3, n2) {
          if (!a.isString(e14))
            throw TypeError("Parameter 'url' must be a string, not " + typeof e14);
          var o2 = e14.indexOf("?"), c2 = o2 !== -1 && o2 < e14.indexOf("#") ? "?" : "#", y2 = e14.split(c2);
          y2[0] = y2[0].replace(/\\/g, "/");
          var b = e14 = y2.join(c2);
          if (b = b.trim(), !n2 && e14.split("#").length === 1) {
            var S = l.exec(b);
            if (S)
              return this.path = b, this.href = b, this.pathname = S[1], S[2] ? (this.search = S[2], this.query = t3 ? v.parse(this.search.substr(1)) : this.search.substr(1)) : t3 && (this.search = "", this.query = {}), this;
          }
          var C = s.exec(b);
          if (C) {
            var w = (C = C[0]).toLowerCase();
            this.protocol = w, b = b.substr(C.length);
          }
          if (n2 || C || b.match(/^\/\/[^@\/]+@[^@\/]+/)) {
            var T = b.substr(0, 2) === "//";
            !T || C && g[C] || (b = b.substr(2), this.slashes = true);
          }
          if (!g[C] && (T || C && !_[C])) {
            for (var E, D, O = -1, k = 0; k < f.length; k++)
              (A = b.indexOf(f[k])) !== -1 && (O === -1 || A < O) && (O = A);
            for ((D = O === -1 ? b.lastIndexOf("@") : b.lastIndexOf("@", O)) !== -1 && (E = b.slice(0, D), b = b.slice(D + 1), this.auth = decodeURIComponent(E)), O = -1, k = 0; k < d.length; k++) {
              var A;
              (A = b.indexOf(d[k])) !== -1 && (O === -1 || A < O) && (O = A);
            }
            O === -1 && (O = b.length), this.host = b.slice(0, O), b = b.slice(O), this.parseHost(), this.hostname = this.hostname || "";
            var j = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
            if (!j)
              for (var M = this.hostname.split(/\./), N = (k = 0, M.length); k < N; k++) {
                var P = M[k];
                if (P && !P.match(p)) {
                  for (var F = "", I = 0, L = P.length; I < L; I++)
                    P.charCodeAt(I) > 127 ? F += "x" : F += P[I];
                  if (!F.match(p)) {
                    var R = M.slice(0, k), z = M.slice(k + 1), B = P.match(m);
                    B && (R.push(B[1]), z.unshift(B[2])), z.length && (b = "/" + z.join(".") + b), this.hostname = R.join(".");
                    break;
                  }
                }
              }
            this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), j || (this.hostname = r.toASCII(this.hostname));
            var V = this.port ? ":" + this.port : "";
            this.host = (this.hostname || "") + V, this.href += this.host, j && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), b[0] !== "/" && (b = "/" + b));
          }
          if (!h[w])
            for (k = 0, N = u.length; k < N; k++) {
              var H = u[k];
              if (b.indexOf(H) !== -1) {
                var U = encodeURIComponent(H);
                U === H && (U = escape(H)), b = b.split(H).join(U);
              }
            }
          var W = b.indexOf("#");
          W !== -1 && (this.hash = b.substr(W), b = b.slice(0, W));
          var G = b.indexOf("?");
          if (G === -1 ? t3 && (this.search = "", this.query = {}) : (this.search = b.substr(G), this.query = b.substr(G + 1), t3 && (this.query = v.parse(this.query)), b = b.slice(0, G)), b && (this.pathname = b), _[w] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
            V = this.pathname || "";
            var K = this.search || "";
            this.path = V + K;
          }
          return this.href = this.format(), this;
        }, o.prototype.format = function() {
          var e14 = this.auth || "";
          e14 && (e14 = (e14 = encodeURIComponent(e14)).replace(/%3A/i, ":"), e14 += "@");
          var t3 = this.protocol || "", n2 = this.pathname || "", r2 = this.hash || "", o2 = false, s2 = "";
          this.host ? o2 = e14 + this.host : this.hostname && (o2 = e14 + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (o2 += ":" + this.port)), this.query && a.isObject(this.query) && Object.keys(this.query).length && (s2 = v.stringify(this.query));
          var c2 = this.search || s2 && "?" + s2 || "";
          return t3 && t3.substr(-1) !== ":" && (t3 += ":"), this.slashes || (!t3 || _[t3]) && false !== o2 ? (o2 = "//" + (o2 || ""), n2 && n2.charAt(0) !== "/" && (n2 = "/" + n2)) : o2 ||= "", r2 && r2.charAt(0) !== "#" && (r2 = "#" + r2), c2 && c2.charAt(0) !== "?" && (c2 = "?" + c2), t3 + o2 + (n2 = n2.replace(/[?#]/g, function(e15) {
            return encodeURIComponent(e15);
          })) + (c2 = c2.replace("#", "%23")) + r2;
        }, o.prototype.resolve = function(e14) {
          return this.resolveObject(y(e14, false, true)).format();
        }, o.prototype.resolveObject = function(e14) {
          if (a.isString(e14)) {
            var t3 = new o();
            t3.parse(e14, false, true), e14 = t3;
          }
          for (var n2 = new o(), r2 = Object.keys(this), s2 = 0; s2 < r2.length; s2++) {
            var c2 = r2[s2];
            n2[c2] = this[c2];
          }
          if (n2.hash = e14.hash, e14.href === "")
            return n2.href = n2.format(), n2;
          if (e14.slashes && !e14.protocol) {
            for (var l2 = Object.keys(e14), u2 = 0; u2 < l2.length; u2++) {
              var d2 = l2[u2];
              d2 !== "protocol" && (n2[d2] = e14[d2]);
            }
            return _[n2.protocol] && n2.hostname && !n2.pathname && (n2.path = n2.pathname = "/"), n2.href = n2.format(), n2;
          }
          if (e14.protocol && e14.protocol !== n2.protocol) {
            if (!_[e14.protocol]) {
              for (var f2 = Object.keys(e14), p2 = 0; p2 < f2.length; p2++) {
                var m2 = f2[p2];
                n2[m2] = e14[m2];
              }
              return n2.href = n2.format(), n2;
            }
            if (n2.protocol = e14.protocol, e14.host || g[e14.protocol])
              n2.pathname = e14.pathname;
            else {
              for (var h2 = (e14.pathname || "").split("/"); h2.length && !(e14.host = h2.shift()); )
                ;
              e14.host ||= "", e14.hostname ||= "", h2[0] !== "" && h2.unshift(""), h2.length < 2 && h2.unshift(""), n2.pathname = h2.join("/");
            }
            return n2.search = e14.search, n2.query = e14.query, n2.host = e14.host || "", n2.auth = e14.auth, n2.hostname = e14.hostname || e14.host, n2.port = e14.port, (n2.pathname || n2.search) && (n2.path = (n2.pathname || "") + (n2.search || "")), n2.slashes = n2.slashes || e14.slashes, n2.href = n2.format(), n2;
          }
          var v2 = n2.pathname && n2.pathname.charAt(0) === "/", y2 = e14.host || e14.pathname && e14.pathname.charAt(0) === "/", b = y2 || v2 || n2.host && e14.pathname, S = b, C = n2.pathname && n2.pathname.split("/") || [], w = (h2 = e14.pathname && e14.pathname.split("/") || [], n2.protocol && !_[n2.protocol]);
          if (w && (n2.hostname = "", n2.port = null, n2.host && (C[0] === "" ? C[0] = n2.host : C.unshift(n2.host)), n2.host = "", e14.protocol && (e14.hostname = null, e14.port = null, e14.host && (h2[0] === "" ? h2[0] = e14.host : h2.unshift(e14.host)), e14.host = null), b &&= h2[0] === "" || C[0] === ""), y2)
            n2.host = e14.host || e14.host === "" ? e14.host : n2.host, n2.hostname = e14.hostname || e14.hostname === "" ? e14.hostname : n2.hostname, n2.search = e14.search, n2.query = e14.query, C = h2;
          else if (h2.length)
            C ||= [], C.pop(), C = C.concat(h2), n2.search = e14.search, n2.query = e14.query;
          else if (!a.isNullOrUndefined(e14.search))
            return w && (n2.hostname = n2.host = C.shift(), (k = !!(n2.host && n2.host.indexOf("@") > 0) && n2.host.split("@")) && (n2.auth = k.shift(), n2.host = n2.hostname = k.shift())), n2.search = e14.search, n2.query = e14.query, a.isNull(n2.pathname) && a.isNull(n2.search) || (n2.path = (n2.pathname ? n2.pathname : "") + (n2.search ? n2.search : "")), n2.href = n2.format(), n2;
          if (!C.length)
            return n2.pathname = null, n2.search ? n2.path = "/" + n2.search : n2.path = null, n2.href = n2.format(), n2;
          for (var T = C.slice(-1)[0], E = (n2.host || e14.host || C.length > 1) && (T === "." || T === "..") || T === "", D = 0, O = C.length; O >= 0; O--)
            (T = C[O]) === "." ? C.splice(O, 1) : T === ".." ? (C.splice(O, 1), D++) : D && (C.splice(O, 1), D--);
          if (!b && !S)
            for (; D--; )
              C.unshift("..");
          !b || C[0] === "" || C[0] && C[0].charAt(0) === "/" || C.unshift(""), E && C.join("/").substr(-1) !== "/" && C.push("");
          var k, A = C[0] === "" || C[0] && C[0].charAt(0) === "/";
          return w && (n2.hostname = n2.host = A ? "" : C.length ? C.shift() : "", (k = !!(n2.host && n2.host.indexOf("@") > 0) && n2.host.split("@")) && (n2.auth = k.shift(), n2.host = n2.hostname = k.shift())), (b ||= n2.host && C.length) && !A && C.unshift(""), C.length ? n2.pathname = C.join("/") : (n2.pathname = null, n2.path = null), a.isNull(n2.pathname) && a.isNull(n2.search) || (n2.path = (n2.pathname ? n2.pathname : "") + (n2.search ? n2.search : "")), n2.auth = e14.auth || n2.auth, n2.slashes = n2.slashes || e14.slashes, n2.href = n2.format(), n2;
        }, o.prototype.parseHost = function() {
          var e14 = this.host, t3 = c.exec(e14);
          t3 && ((t3 = t3[0]) !== ":" && (this.port = t3.substr(1)), e14 = e14.substr(0, e14.length - t3.length)), e14 && (this.hostname = e14);
        };
      },
      function(e13, t2, n) {
        (function(e14, r) {
          var a;
          (function(o) {
            t2 && t2.nodeType, e14 && e14.nodeType;
            var s = typeof r == "object" && r;
            s.global !== s && s.window !== s && s.self;
            var c, l = 2147483647, u = /^xn--/, d = /[^\x20-\x7E]/, f = /[\x2E\u3002\uFF0E\uFF61]/g, p = {
              overflow: "Overflow: input needs wider integers to process",
              "not-basic": "Illegal input >= 0x80 (not a basic code point)",
              "invalid-input": "Invalid input"
            }, m = Math.floor, h = String.fromCharCode;
            function g(e15) {
              throw RangeError(p[e15]);
            }
            function _(e15, t3) {
              for (var n2 = e15.length, r2 = []; n2--; )
                r2[n2] = t3(e15[n2]);
              return r2;
            }
            function v(e15, t3) {
              var n2 = e15.split("@"), r2 = "";
              return n2.length > 1 && (r2 = n2[0] + "@", e15 = n2[1]), r2 + _((e15 = e15.replace(f, ".")).split("."), t3).join(".");
            }
            function y(e15) {
              for (var t3, n2, r2 = [], a2 = 0, o2 = e15.length; a2 < o2; )
                (t3 = e15.charCodeAt(a2++)) >= 55296 && t3 <= 56319 && a2 < o2 ? (64512 & (n2 = e15.charCodeAt(a2++))) == 56320 ? r2.push(((1023 & t3) << 10) + (1023 & n2) + 65536) : (r2.push(t3), a2--) : r2.push(t3);
              return r2;
            }
            function b(e15) {
              return _(e15, function(e16) {
                var t3 = "";
                return e16 > 65535 && (t3 += h((e16 -= 65536) >>> 10 & 1023 | 55296), e16 = 56320 | 1023 & e16), t3 += h(e16);
              }).join("");
            }
            function S(e15, t3) {
              return e15 + 22 + 75 * (e15 < 26) - ((t3 != 0) << 5);
            }
            function C(e15, t3, n2) {
              var r2 = 0;
              for (e15 = n2 ? m(e15 / 700) : e15 >> 1, e15 += m(e15 / t3); e15 > 455; r2 += 36)
                e15 = m(e15 / 35);
              return m(r2 + 36 * e15 / (e15 + 38));
            }
            function w(e15) {
              var t3, n2, r2, a2, o2, s2, c2, u2, d2, f2, p2, h2 = [], _2 = e15.length, v2 = 0, y2 = 128, S2 = 72;
              for ((n2 = e15.lastIndexOf("-")) < 0 && (n2 = 0), r2 = 0; r2 < n2; ++r2)
                e15.charCodeAt(r2) >= 128 && g("not-basic"), h2.push(e15.charCodeAt(r2));
              for (a2 = n2 > 0 ? n2 + 1 : 0; a2 < _2; ) {
                for (o2 = v2, s2 = 1, c2 = 36; a2 >= _2 && g("invalid-input"), ((u2 = (p2 = e15.charCodeAt(a2++)) - 48 < 10 ? p2 - 22 : p2 - 65 < 26 ? p2 - 65 : p2 - 97 < 26 ? p2 - 97 : 36) >= 36 || u2 > m((l - v2) / s2)) && g("overflow"), v2 += u2 * s2, !(u2 < (d2 = c2 <= S2 ? 1 : c2 >= S2 + 26 ? 26 : c2 - S2)); c2 += 36)
                  s2 > m(l / (f2 = 36 - d2)) && g("overflow"), s2 *= f2;
                S2 = C(v2 - o2, t3 = h2.length + 1, o2 == 0), m(v2 / t3) > l - y2 && g("overflow"), y2 += m(v2 / t3), v2 %= t3, h2.splice(v2++, 0, y2);
              }
              return b(h2);
            }
            function T(e15) {
              var t3, n2, r2, a2, o2, s2, c2, u2, d2, f2, p2, _2, v2, b2, w2, T2 = [];
              for (_2 = (e15 = y(e15)).length, t3 = 128, n2 = 0, o2 = 72, s2 = 0; s2 < _2; ++s2)
                (p2 = e15[s2]) < 128 && T2.push(h(p2));
              for (r2 = a2 = T2.length, a2 && T2.push("-"); r2 < _2; ) {
                for (c2 = l, s2 = 0; s2 < _2; ++s2)
                  (p2 = e15[s2]) >= t3 && p2 < c2 && (c2 = p2);
                for (c2 - t3 > m((l - n2) / (v2 = r2 + 1)) && g("overflow"), n2 += (c2 - t3) * v2, t3 = c2, s2 = 0; s2 < _2; ++s2)
                  if ((p2 = e15[s2]) < t3 && ++n2 > l && g("overflow"), p2 == t3) {
                    for (u2 = n2, d2 = 36; !(u2 < (f2 = d2 <= o2 ? 1 : d2 >= o2 + 26 ? 26 : d2 - o2)); d2 += 36)
                      w2 = u2 - f2, b2 = 36 - f2, T2.push(h(S(f2 + w2 % b2, 0))), u2 = m(w2 / b2);
                    T2.push(h(S(u2, 0))), o2 = C(n2, v2, r2 == a2), n2 = 0, ++r2;
                  }
                ++n2, ++t3;
              }
              return T2.join("");
            }
            c = {
              version: "1.4.1",
              ucs2: {
                decode: y,
                encode: b
              },
              decode: w,
              encode: T,
              toASCII: function(e15) {
                return v(e15, function(e16) {
                  return d.test(e16) ? "xn--" + T(e16) : e16;
                });
              },
              toUnicode: function(e15) {
                return v(e15, function(e16) {
                  return u.test(e16) ? w(e16.slice(4).toLowerCase()) : e16;
                });
              }
            }, (a = function() {
              return c;
            }.call(t2, n, t2, e14)) === void 0 || (e14.exports = a);
          })();
        }).call(this, n(246)(e13), n(78));
      },
      function(e13, t2) {
        e13.exports = function(e14) {
          return e14.webpackPolyfill ||= (e14.deprecate = function() {
          }, e14.paths = [], e14.children ||= [], Object.defineProperty(e14, "loaded", {
            enumerable: true,
            get: function() {
              return e14.l;
            }
          }), Object.defineProperty(e14, "id", {
            enumerable: true,
            get: function() {
              return e14.i;
            }
          }), 1), e14;
        };
      },
      function(e13, t2, n) {
        e13.exports = {
          isString: function(e14) {
            return typeof e14 == "string";
          },
          isObject: function(e14) {
            return typeof e14 == "object" && !!e14;
          },
          isNull: function(e14) {
            return e14 === null;
          },
          isNullOrUndefined: function(e14) {
            return e14 == null;
          }
        };
      },
      function(e13, t2, n) {
        t2.decode = t2.parse = n(249), t2.encode = t2.stringify = n(250);
      },
      function(e13, t2, n) {
        function r(e14, t3) {
          return Object.prototype.hasOwnProperty.call(e14, t3);
        }
        e13.exports = function(e14, t3, n2, o) {
          t3 ||= "&", n2 ||= "=";
          var s = {};
          if (typeof e14 != "string" || e14.length === 0)
            return s;
          var c = /\+/g;
          e14 = e14.split(t3);
          var l = 1e3;
          o && typeof o.maxKeys == "number" && (l = o.maxKeys);
          var u = e14.length;
          l > 0 && u > l && (u = l);
          for (var d = 0; d < u; ++d) {
            var f, p, m, h, g = e14[d].replace(c, "%20"), _ = g.indexOf(n2);
            _ >= 0 ? (f = g.substr(0, _), p = g.substr(_ + 1)) : (f = g, p = ""), m = decodeURIComponent(f), h = decodeURIComponent(p), r(s, m) ? a(s[m]) ? s[m].push(h) : s[m] = [s[m], h] : s[m] = h;
          }
          return s;
        };
        var a = Array.isArray || function(e14) {
          return Object.prototype.toString.call(e14) === "[object Array]";
        };
      },
      function(e13, t2, n) {
        var r = function(e14) {
          switch (typeof e14) {
            case "string":
              return e14;
            case "boolean":
              return e14 ? "true" : "false";
            case "number":
              return isFinite(e14) ? e14 : "";
            default:
              return "";
          }
        };
        e13.exports = function(e14, t3, n2, c) {
          return t3 ||= "&", n2 ||= "=", e14 === null && (e14 = void 0), typeof e14 == "object" ? o(s(e14), function(s2) {
            var c2 = encodeURIComponent(r(s2)) + n2;
            return a(e14[s2]) ? o(e14[s2], function(e15) {
              return c2 + encodeURIComponent(r(e15));
            }).join(t3) : c2 + encodeURIComponent(r(e14[s2]));
          }).join(t3) : c ? encodeURIComponent(r(c)) + n2 + encodeURIComponent(r(e14)) : "";
        };
        var a = Array.isArray || function(e14) {
          return Object.prototype.toString.call(e14) === "[object Array]";
        };
        function o(e14, t3) {
          if (e14.map)
            return e14.map(t3);
          for (var n2 = [], r2 = 0; r2 < e14.length; r2++)
            n2.push(t3(e14[r2], r2));
          return n2;
        }
        var s = Object.keys || function(e14) {
          var t3 = [];
          for (var n2 in e14)
            Object.prototype.hasOwnProperty.call(e14, n2) && t3.push(n2);
          return t3;
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(52);
        t2.attr_setAnExistingAttributeValue = function(e14, t3) {
          e14._element === null ? e14._value = t3 : r.element_change(e14, e14._element, t3);
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(108), a = n(30), o = n(52);
        t2.tokenList_validationSteps = function(e14, t3) {
          if (!a.dom_hasSupportedTokens(e14._attribute._localName))
            throw TypeError("There are no supported tokens defined for attribute name: '" + e14._attribute._localName + "'.");
          return a.dom_getSupportedTokens(e14._attribute._localName).has(t3.toLowerCase());
        }, t2.tokenList_updateSteps = function(e14) {
          (e14._element.hasAttribute(e14._attribute._localName) || e14._tokenSet.size !== 0) && o.element_setAnAttributeValue(e14._element, e14._attribute._localName, r.orderedSet_serialize(e14._tokenSet));
        }, t2.tokenList_serializeSteps = function(e14) {
          return o.element_getAnAttributeValue(e14._element, e14._attribute._localName);
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(1);
        function o(e14) {
          return a.isBoolean(e14) ? e14 : e14.capture || false;
        }
        t2.eventTarget_flatten = o, t2.eventTarget_flattenMore = function(e14) {
          var t3 = o(e14), n2 = false, r2 = false;
          return a.isBoolean(e14) || (n2 = e14.once || false, r2 = e14.passive || false), [
            t3,
            r2,
            n2
          ];
        }, t2.eventTarget_addEventListener = function(e14, t3) {
          if (t3.callback !== null) {
            for (var n2 = 0; n2 < e14._eventListenerList.length; n2++) {
              var r2 = e14._eventListenerList[n2];
              if (r2.type === t3.type && r2.callback.handleEvent === t3.callback.handleEvent && r2.capture === t3.capture)
                return;
            }
            e14._eventListenerList.push(t3);
          }
        }, t2.eventTarget_removeEventListener = function(e14, t3, n2) {
          t3.removed = true, e14._eventListenerList.splice(n2, 1);
        }, t2.eventTarget_removeAllEventListeners = function(e14) {
          var t3, n2;
          try {
            for (var a2 = r(e14._eventListenerList), o2 = a2.next(); !o2.done; o2 = a2.next())
              o2.value.removed = true;
          } catch (e15) {
            t3 = { error: e15 };
          } finally {
            try {
              o2 && !o2.done && (n2 = a2.return) && n2.call(a2);
            } finally {
              if (t3)
                throw t3.error;
            }
          }
          e14._eventListenerList.length = 0;
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(1), o = n(29);
        t2.parentNode_convertNodesIntoANode = function(e14, t3) {
          for (var n2, s, c = null, l = 0; l < e14.length; l++) {
            var u = e14[l];
            a.isString(u) && (e14[l] = o.create_text(t3, u));
          }
          if (e14.length === 1)
            c = e14[0];
          else {
            var d = c = o.create_documentFragment(t3);
            try {
              for (var f = r(e14), p = f.next(); !p.done; p = f.next())
                u = p.value, d.appendChild(u);
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                p && !p.done && (s = f.return) && s.call(f);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          }
          return c;
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, a = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, o = this && this.__spread || function() {
          for (var e14 = [], t3 = 0; t3 < arguments.length; t3++)
            e14 = e14.concat(a(arguments[t3]));
          return e14;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(2), c = n(9), l = n(3), u = n(29), d = n(17), f = n(175), p = n(107), m = n(176), h = n(37), g = n(177);
        function _(e14) {
          return e14._startNode === e14._endNode && e14._startOffset === e14._endOffset;
        }
        function v(e14) {
          return d.tree_rootNode(e14._startNode);
        }
        function y(e14, t3) {
          return d.tree_rootNode(e14) === v(t3) && f.boundaryPoint_position([e14, 0], t3._start) === s.BoundaryPosition.After && f.boundaryPoint_position([e14, d.tree_nodeLength(e14)], t3._end) === s.BoundaryPosition.Before;
        }
        function b(e14, t3) {
          var n2 = d.tree_isAncestorOf(t3._startNode, e14, true), r2 = d.tree_isAncestorOf(t3._endNode, e14, true);
          return n2 && !r2 || !n2 && r2;
        }
        function S(e14) {
          var t3, n2, a2, s2, f2, g2, v2 = u.create_documentFragment(e14._startNode._nodeDocument);
          if (_(e14))
            return v2;
          var C = e14._startNode, w = e14._startOffset, T = e14._endNode, E = e14._endOffset;
          if (C === T && l.Guard.isCharacterDataNode(C))
            return (V = m.node_clone(C))._data = p.characterData_substringData(C, w, E - w), h.mutation_append(V, v2), p.characterData_replaceData(C, w, E - w, ""), v2;
          for (var D = C; !d.tree_isAncestorOf(T, D, true); ) {
            if (D._parent === null)
              throw Error("Parent node  is null.");
            D = D._parent;
          }
          var O = null;
          if (!d.tree_isAncestorOf(T, C, true))
            try {
              for (var k = r(D._children), A = k.next(); !A.done; A = k.next())
                if (b(P = A.value, e14)) {
                  O = P;
                  break;
                }
            } catch (e15) {
              t3 = { error: e15 };
            } finally {
              try {
                A && !A.done && (n2 = k.return) && n2.call(k);
              } finally {
                if (t3)
                  throw t3.error;
              }
            }
          var j = null;
          if (!d.tree_isAncestorOf(C, T, true))
            for (var M = o(D._children), N = M.length - 1; N > 0; N--) {
              var P;
              if (b(P = M[N], e14)) {
                j = P;
                break;
              }
            }
          var F, I, L = [];
          try {
            for (var R = r(D._children), z = R.next(); !z.done; z = R.next())
              if (y(G = z.value, e14)) {
                if (l.Guard.isDocumentTypeNode(G))
                  throw new c.HierarchyRequestError();
                L.push(G);
              }
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              z && !z.done && (s2 = R.return) && s2.call(R);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          if (d.tree_isAncestorOf(T, C, true))
            F = C, I = w;
          else {
            for (var B = C; B._parent !== null && !d.tree_isAncestorOf(T, B._parent); )
              B = B._parent;
            if (B._parent === null)
              throw Error("Parent node is null.");
            F = B._parent, I = 1 + d.tree_index(B);
          }
          if (l.Guard.isCharacterDataNode(O))
            (V = m.node_clone(C))._data = p.characterData_substringData(C, w, d.tree_nodeLength(C) - w), h.mutation_append(V, v2), p.characterData_replaceData(C, w, d.tree_nodeLength(C) - w, "");
          else if (O !== null) {
            var V = m.node_clone(O);
            h.mutation_append(V, v2);
            var H = S(u.create_range([C, w], [O, d.tree_nodeLength(O)]));
            h.mutation_append(H, V);
          }
          try {
            for (var U = r(L), W = U.next(); !W.done; W = U.next()) {
              var G = W.value;
              h.mutation_append(G, v2);
            }
          } catch (e15) {
            f2 = { error: e15 };
          } finally {
            try {
              W && !W.done && (g2 = U.return) && g2.call(U);
            } finally {
              if (f2)
                throw f2.error;
            }
          }
          return l.Guard.isCharacterDataNode(j) ? ((V = m.node_clone(T))._data = p.characterData_substringData(T, 0, E), h.mutation_append(V, v2), p.characterData_replaceData(T, 0, E, "")) : j !== null && (V = m.node_clone(j), h.mutation_append(V, v2), H = S(u.create_range([j, 0], [T, E])), h.mutation_append(H, V)), e14._start = [F, I], e14._end = [F, I], v2;
        }
        t2.range_collapsed = _, t2.range_root = v, t2.range_isContained = y, t2.range_isPartiallyContained = b, t2.range_setTheStart = function(e14, t3, n2) {
          if (l.Guard.isDocumentTypeNode(t3))
            throw new c.InvalidNodeTypeError();
          if (n2 > d.tree_nodeLength(t3))
            throw new c.IndexSizeError();
          var r2 = [t3, n2];
          v(e14) === d.tree_rootNode(t3) && f.boundaryPoint_position(r2, e14._end) !== s.BoundaryPosition.After || (e14._end = r2), e14._start = r2;
        }, t2.range_setTheEnd = function(e14, t3, n2) {
          if (l.Guard.isDocumentTypeNode(t3))
            throw new c.InvalidNodeTypeError();
          if (n2 > d.tree_nodeLength(t3))
            throw new c.IndexSizeError();
          var r2 = [t3, n2];
          v(e14) === d.tree_rootNode(t3) && f.boundaryPoint_position(r2, e14._start) !== s.BoundaryPosition.Before || (e14._start = r2), e14._end = r2;
        }, t2.range_select = function(e14, t3) {
          var n2 = e14._parent;
          if (n2 === null)
            throw new c.InvalidNodeTypeError();
          var r2 = d.tree_index(e14);
          t3._start = [n2, r2], t3._end = [n2, r2 + 1];
        }, t2.range_extract = S, t2.range_cloneTheContents = function e14(t3) {
          var n2, a2, s2, f2, g2, v2, C = u.create_documentFragment(t3._startNode._nodeDocument);
          if (_(t3))
            return C;
          var w = t3._startNode, T = t3._startOffset, E = t3._endNode, D = t3._endOffset;
          w === E && l.Guard.isCharacterDataNode(w) && ((z = m.node_clone(w))._data = p.characterData_substringData(w, T, D - T), h.mutation_append(z, C));
          for (var O = w; !d.tree_isAncestorOf(E, O, true); ) {
            if (O._parent === null)
              throw Error("Parent node  is null.");
            O = O._parent;
          }
          var k = null;
          if (!d.tree_isAncestorOf(E, w, true))
            try {
              for (var A = r(O._children), j = A.next(); !j.done; j = A.next())
                if (b(F = j.value, t3)) {
                  k = F;
                  break;
                }
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                j && !j.done && (a2 = A.return) && a2.call(A);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          var M = null;
          if (!d.tree_isAncestorOf(w, E, true))
            for (var N = o(O._children), P = N.length - 1; P > 0; P--) {
              var F;
              if (b(F = N[P], t3)) {
                M = F;
                break;
              }
            }
          var I = [];
          try {
            for (var L = r(O._children), R = L.next(); !R.done; R = L.next())
              if (y(U = R.value, t3)) {
                if (l.Guard.isDocumentTypeNode(U))
                  throw new c.HierarchyRequestError();
                I.push(U);
              }
          } catch (e15) {
            s2 = { error: e15 };
          } finally {
            try {
              R && !R.done && (f2 = L.return) && f2.call(L);
            } finally {
              if (s2)
                throw s2.error;
            }
          }
          if (l.Guard.isCharacterDataNode(k))
            (z = m.node_clone(w))._data = p.characterData_substringData(w, T, d.tree_nodeLength(w) - T), h.mutation_append(z, C);
          else if (k !== null) {
            var z = m.node_clone(k);
            h.mutation_append(z, C);
            var B = e14(u.create_range([w, T], [k, d.tree_nodeLength(k)]));
            h.mutation_append(B, z);
          }
          try {
            for (var V = r(I), H = V.next(); !H.done; H = V.next()) {
              var U = H.value, z = m.node_clone(U);
              h.mutation_append(z, C);
            }
          } catch (e15) {
            g2 = { error: e15 };
          } finally {
            try {
              H && !H.done && (v2 = V.return) && v2.call(V);
            } finally {
              if (g2)
                throw g2.error;
            }
          }
          return l.Guard.isCharacterDataNode(M) ? ((z = m.node_clone(E))._data = p.characterData_substringData(E, 0, D), h.mutation_append(z, C)) : M !== null && (z = m.node_clone(M), C.append(z), B = S(u.create_range([M, 0], [E, D])), h.mutation_append(B, z)), C;
        }, t2.range_insert = function(e14, t3) {
          var n2, a2;
          if (l.Guard.isProcessingInstructionNode(t3._startNode) || l.Guard.isCommentNode(t3._startNode) || l.Guard.isTextNode(t3._startNode) && t3._startNode._parent === null || t3._startNode === e14)
            throw new c.HierarchyRequestError();
          var o2, s2 = null;
          if (l.Guard.isTextNode(t3._startNode))
            s2 = t3._startNode;
          else {
            var u2 = 0;
            try {
              for (var f2 = r(t3._startNode._children), p2 = f2.next(); !p2.done; p2 = f2.next()) {
                var m2 = p2.value;
                if (u2 === t3._startOffset) {
                  s2 = m2;
                  break;
                }
                u2++;
              }
            } catch (e15) {
              n2 = { error: e15 };
            } finally {
              try {
                p2 && !p2.done && (a2 = f2.return) && a2.call(f2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
          }
          if (s2 === null)
            o2 = t3._startNode;
          else {
            if (s2._parent === null)
              throw Error("Parent node is null.");
            o2 = s2._parent;
          }
          h.mutation_ensurePreInsertionValidity(e14, o2, s2), l.Guard.isTextNode(t3._startNode) && (s2 = g.text_split(t3._startNode, t3._startOffset)), e14 === s2 && (s2 = e14._nextSibling), e14._parent !== null && h.mutation_remove(e14, e14._parent);
          var v2 = s2 === null ? d.tree_nodeLength(o2) : d.tree_index(s2);
          l.Guard.isDocumentFragmentNode(e14) ? v2 += d.tree_nodeLength(e14) : v2++, h.mutation_preInsert(e14, o2, s2), _(t3) && (t3._end = [o2, v2]);
        }, t2.range_getContainedNodes = function(e14) {
          var t3;
          return (t3 = {})[Symbol.iterator] = function() {
            var t4 = e14.commonAncestorContainer, n2 = d.tree_getFirstDescendantNode(t4);
            return { next: function() {
              for (; n2 && !y(n2, e14); )
                n2 = d.tree_getNextDescendantNode(t4, n2);
              if (n2 === null)
                return {
                  done: true,
                  value: null
                };
              var r2 = {
                done: false,
                value: n2
              };
              return n2 = d.tree_getNextDescendantNode(t4, n2), r2;
            } };
          }, t3;
        }, t2.range_getPartiallyContainedNodes = function(e14) {
          var t3;
          return (t3 = {})[Symbol.iterator] = function() {
            var t4 = e14.commonAncestorContainer, n2 = d.tree_getFirstDescendantNode(t4);
            return { next: function() {
              for (; n2 && !b(n2, e14); )
                n2 = d.tree_getNextDescendantNode(t4, n2);
              if (n2 === null)
                return {
                  done: true,
                  value: null
                };
              var r2 = {
                done: false,
                value: n2
              };
              return n2 = d.tree_getNextDescendantNode(t4, n2), r2;
            } };
          }, t3;
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(9);
        t2.selectors_scopeMatchASelectorsString = function(e14, t3) {
          throw new r.NotSupportedError();
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(2), a = n(105);
        t2.treeWalker_traverseChildren = function(e14, t3) {
          for (var n2 = t3 ? e14._current._firstChild : e14._current._lastChild; n2 !== null; ) {
            var o = a.traversal_filter(e14, n2);
            if (o === r.FilterResult.Accept)
              return e14._current = n2, n2;
            if (o === r.FilterResult.Skip) {
              var s = t3 ? n2._firstChild : n2._lastChild;
              if (s !== null) {
                n2 = s;
                continue;
              }
            }
            for (; n2 !== null; ) {
              var c = t3 ? n2._nextSibling : n2._previousSibling;
              if (c !== null) {
                n2 = c;
                break;
              }
              var l = n2._parent;
              if (l === null || l === e14._root || l === e14._current)
                return null;
              n2 = l;
            }
          }
          return null;
        }, t2.treeWalker_traverseSiblings = function(e14, t3) {
          var n2 = e14._current;
          if (n2 === e14._root)
            return null;
          for (; ; ) {
            for (var o = t3 ? n2._nextSibling : n2._previousSibling; o !== null; ) {
              n2 = o;
              var s = a.traversal_filter(e14, n2);
              if (s === r.FilterResult.Accept)
                return e14._current = n2, n2;
              o = t3 ? n2._firstChild : n2._lastChild, s !== r.FilterResult.Reject && o !== null || (o = t3 ? n2._nextSibling : n2._previousSibling);
            }
            if ((n2 = n2._parent) === null || n2 === e14._root || a.traversal_filter(e14, n2) === r.FilterResult.Accept)
              return null;
          }
        };
      },
      function(e13, t2, n) {
        n(89), n(74);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(1), s = n(2), c = n(50), l = n(3);
        t2.XMLWriter = function(e14) {
          function t3(t4, n2) {
            var r2 = e14.call(this, t4) || this;
            return r2._indentation = {}, r2._lengthToLastNewline = 0, r2._writerOptions = o.applyDefaults(n2, {
              wellFormed: false,
              headless: false,
              prettyPrint: false,
              indent: "  ",
              newline: "\n",
              offset: 0,
              width: 0,
              allowEmptyTags: false,
              indentTextOnlyNodes: false,
              spaceBeforeSlash: false
            }), r2;
          }
          return a(t3, e14), t3.prototype.serialize = function(e15) {
            return this._refs = {
              suppressPretty: false,
              emptyNode: false,
              markup: ""
            }, e15.nodeType !== s.NodeType.Document || this._writerOptions.headless || this.declaration(this._builderOptions.version, this._builderOptions.encoding, this._builderOptions.standalone), this.serializeNode(e15, this._writerOptions.wellFormed), this._writerOptions.prettyPrint && this._refs.markup.slice(-this._writerOptions.newline.length) === this._writerOptions.newline && (this._refs.markup = this._refs.markup.slice(0, -this._writerOptions.newline.length)), this._refs.markup;
          }, t3.prototype.declaration = function(e15, t4, n2) {
            this._beginLine(), this._refs.markup += '<?xml version="' + e15 + '"', t4 !== void 0 && (this._refs.markup += ' encoding="' + t4 + '"'), n2 !== void 0 && (this._refs.markup += ' standalone="' + (n2 ? "yes" : "no") + '"'), this._refs.markup += "?>", this._endLine();
          }, t3.prototype.docType = function(e15, t4, n2) {
            this._beginLine(), this._refs.markup += t4 && n2 ? "<!DOCTYPE " + e15 + ' PUBLIC "' + t4 + '" "' + n2 + '">' : t4 ? "<!DOCTYPE " + e15 + ' PUBLIC "' + t4 + '">' : n2 ? "<!DOCTYPE " + e15 + ' SYSTEM "' + n2 + '">' : "<!DOCTYPE " + e15 + ">", this._endLine();
          }, t3.prototype.openTagBegin = function(e15) {
            this._beginLine(), this._refs.markup += "<" + e15;
          }, t3.prototype.openTagEnd = function(e15, t4, n2) {
            if (this._refs.suppressPretty = false, this._refs.emptyNode = false, this._writerOptions.prettyPrint && !t4 && !n2) {
              for (var r2 = true, a2 = true, o2 = this.currentNode.firstChild, s2 = 0, c2 = 0; o2; ) {
                if (l.Guard.isExclusiveTextNode(o2))
                  c2++;
                else {
                  if (!l.Guard.isCDATASectionNode(o2)) {
                    r2 = false, a2 = false;
                    break;
                  }
                  s2++;
                }
                o2.data !== "" && (a2 = false), o2 = o2.nextSibling;
              }
              this._refs.suppressPretty = !this._writerOptions.indentTextOnlyNodes && r2 && (s2 <= 1 && c2 === 0 || s2 === 0), this._refs.emptyNode = a2;
            }
            (n2 || t4 || this._refs.emptyNode) && this._writerOptions.allowEmptyTags ? this._refs.markup += "></" + e15 + ">" : this._refs.markup += n2 ? " />" : t4 || this._refs.emptyNode ? this._writerOptions.spaceBeforeSlash ? " />" : "/>" : ">", this._endLine();
          }, t3.prototype.closeTag = function(e15) {
            this._refs.emptyNode || (this._beginLine(), this._refs.markup += "</" + e15 + ">"), this._refs.suppressPretty = false, this._refs.emptyNode = false, this._endLine();
          }, t3.prototype.attribute = function(e15, t4) {
            var n2 = e15 + '="' + t4 + '"';
            this._writerOptions.prettyPrint && this._writerOptions.width > 0 && this._refs.markup.length - this._lengthToLastNewline + 1 + n2.length > this._writerOptions.width ? (this._endLine(), this._beginLine(), this._refs.markup += this._indent(1) + n2) : this._refs.markup += " " + n2;
          }, t3.prototype.text = function(e15) {
            e15 !== "" && (this._beginLine(), this._refs.markup += e15, this._endLine());
          }, t3.prototype.cdata = function(e15) {
            e15 !== "" && (this._beginLine(), this._refs.markup += "<![CDATA[" + e15 + "]]>", this._endLine());
          }, t3.prototype.comment = function(e15) {
            this._beginLine(), this._refs.markup += "<!--" + e15 + "-->", this._endLine();
          }, t3.prototype.instruction = function(e15, t4) {
            this._beginLine(), this._refs.markup += "<?" + (t4 === "" ? e15 : e15 + " " + t4) + "?>", this._endLine();
          }, t3.prototype._beginLine = function() {
            this._writerOptions.prettyPrint && !this._refs.suppressPretty && (this._refs.markup += this._indent(this._writerOptions.offset + this.level));
          }, t3.prototype._endLine = function() {
            this._writerOptions.prettyPrint && !this._refs.suppressPretty && (this._refs.markup += this._writerOptions.newline, this._lengthToLastNewline = this._refs.markup.length);
          }, t3.prototype._indent = function(e15) {
            if (e15 <= 0)
              return "";
            if (this._indentation[e15] !== void 0)
              return this._indentation[e15];
            var t4 = this._writerOptions.indent.repeat(e15);
            return this._indentation[e15] = t4, t4;
          }, t3;
        }(c.BaseWriter);
      },
      function(e13, t2, n) {
        var r = n(47), a = n(35);
        e13.exports = "".repeat || function(e14) {
          var t3 = String(a(this)), n2 = "", o = r(e14);
          if (o < 0 || o == Infinity)
            throw RangeError("Wrong number of repetitions");
          for (; o > 0; (o >>>= 1) && (t3 += t3))
            1 & o && (n2 += t3);
          return n2;
        };
      },
      function(e13, t2, n) {
        n(31), n(32), n(33), n(19), n(178), n(20), n(22), n(23);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(67), c = n(1);
        t2.JSONWriter = function(e14) {
          function t3(t4, n2) {
            var r2 = e14.call(this, t4) || this;
            return r2._writerOptions = c.applyDefaults(n2, {
              wellFormed: false,
              prettyPrint: false,
              indent: "  ",
              newline: "\n",
              offset: 0,
              group: false,
              verbose: false
            }), r2;
          }
          return a(t3, e14), t3.prototype.serialize = function(e15) {
            var t4 = c.applyDefaults(this._writerOptions, {
              format: "object",
              wellFormed: false
            }), n2 = new s.ObjectWriter(this._builderOptions, t4).serialize(e15);
            return this._beginLine(this._writerOptions, 0) + this._convertObject(n2, this._writerOptions);
          }, t3.prototype._convertObject = function(e15, t4, n2) {
            var r2, a2, s2 = this;
            n2 === void 0 && (n2 = 0);
            var l = "", u = this._isLeafNode(e15);
            if (c.isArray(e15)) {
              l += "[";
              var d = e15.length, f = 0;
              try {
                for (var p = o(e15), m = p.next(); !m.done; m = p.next()) {
                  var h = m.value;
                  l += this._endLine(t4, n2 + 1) + this._beginLine(t4, n2 + 1) + this._convertObject(h, t4, n2 + 1), f < d - 1 && (l += ","), f++;
                }
              } catch (e16) {
                r2 = { error: e16 };
              } finally {
                try {
                  m && !m.done && (a2 = p.return) && a2.call(p);
                } finally {
                  if (r2)
                    throw r2.error;
                }
              }
              l += this._endLine(t4, n2) + this._beginLine(t4, n2), l += "]";
            } else if (c.isObject(e15)) {
              l += "{";
              var g = c.objectLength(e15), _ = 0;
              c.forEachObject(e15, function(e16, r3) {
                u && t4.prettyPrint ? l += " " : l += s2._endLine(t4, n2 + 1) + s2._beginLine(t4, n2 + 1), l += s2._key(e16), t4.prettyPrint && (l += " "), l += s2._convertObject(r3, t4, n2 + 1), _ < g - 1 && (l += ","), _++;
              }, this), u && t4.prettyPrint ? l += " " : l += this._endLine(t4, n2) + this._beginLine(t4, n2), l += "}";
            } else
              l += this._val(e15);
            return l;
          }, t3.prototype._beginLine = function(e15, t4) {
            if (!e15.prettyPrint)
              return "";
            var n2 = e15.offset + t4 + 1;
            return n2 > 0 ? Array(n2).join(e15.indent) : "";
          }, t3.prototype._endLine = function(e15, t4) {
            return e15.prettyPrint ? e15.newline : "";
          }, t3.prototype._key = function(e15) {
            return '"' + e15 + '":';
          }, t3.prototype._val = function(e15) {
            return JSON.stringify(e15);
          }, t3.prototype._isLeafNode = function(e15) {
            return this._descendantCount(e15) <= 1;
          }, t3.prototype._descendantCount = function(e15, t4) {
            var n2 = this;
            return t4 === void 0 && (t4 = 0), c.isArray(e15) ? c.forEachArray(e15, function(e16) {
              return t4 += n2._descendantCount(e16, t4);
            }, this) : c.isObject(e15) ? c.forEachObject(e15, function(e16, r2) {
              return t4 += n2._descendantCount(r2, t4);
            }, this) : t4++, t4;
          }, t3;
        }(n(50).BaseWriter);
      },
      function(e13, t2, n) {
        n(31), n(32), n(33), n(19), n(178), n(89), n(20), n(22), n(23);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var s = n(67), c = n(1);
        t2.YAMLWriter = function(e14) {
          function t3(t4, n2) {
            var r2 = e14.call(this, t4) || this;
            if (r2._writerOptions = c.applyDefaults(n2, {
              wellFormed: false,
              indent: "  ",
              newline: "\n",
              offset: 0,
              group: false,
              verbose: false
            }), r2._writerOptions.indent.length < 2)
              throw Error("YAML indententation string must be at least two characters long.");
            if (r2._writerOptions.offset < 0)
              throw Error("YAML offset should be zero or a positive number.");
            return r2;
          }
          return a(t3, e14), t3.prototype.serialize = function(e15) {
            var t4 = c.applyDefaults(this._writerOptions, {
              format: "object",
              wellFormed: false
            }), n2 = new s.ObjectWriter(this._builderOptions, t4).serialize(e15), r2 = this._beginLine(this._writerOptions, 0) + "---" + this._endLine(this._writerOptions) + this._convertObject(n2, this._writerOptions, 0);
            return r2.slice(-this._writerOptions.newline.length) === this._writerOptions.newline && (r2 = r2.slice(0, -this._writerOptions.newline.length)), r2;
          }, t3.prototype._convertObject = function(e15, t4, n2, r2) {
            var a2, s2, l = this;
            r2 === void 0 && (r2 = false);
            var u = "";
            if (c.isArray(e15))
              try {
                for (var d = o(e15), f = d.next(); !f.done; f = d.next()) {
                  var p = f.value;
                  u += this._beginLine(t4, n2, true), c.isObject(p) ? c.isEmpty(p) ? u += '""' + this._endLine(t4) : u += this._convertObject(p, t4, n2, true) : u += this._val(p) + this._endLine(t4);
                }
              } catch (e16) {
                a2 = { error: e16 };
              } finally {
                try {
                  f && !f.done && (s2 = d.return) && s2.call(d);
                } finally {
                  if (a2)
                    throw a2.error;
                }
              }
            else
              c.forEachObject(e15, function(e16, a3) {
                r2 ? (u += l._key(e16), r2 = false) : u += l._beginLine(t4, n2) + l._key(e16), c.isObject(a3) ? c.isEmpty(a3) ? u += ' ""' + l._endLine(t4) : u += l._endLine(t4) + l._convertObject(a3, t4, n2 + 1) : u += " " + l._val(a3) + l._endLine(t4);
              }, this);
            return u;
          }, t3.prototype._beginLine = function(e15, t4, n2) {
            n2 === void 0 && (n2 = false);
            var r2 = e15.offset + t4 + 1, a2 = Array(r2).join(e15.indent);
            return n2 ? a2.substr(0, a2.length - 2) + "-" + a2.substr(-1, 1) : a2;
          }, t3.prototype._endLine = function(e15) {
            return e15.newline;
          }, t3.prototype._key = function(e15) {
            return '"' + e15 + '":';
          }, t3.prototype._val = function(e15) {
            return JSON.stringify(e15);
          }, t3;
        }(n(50).BaseWriter);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), n(110).dom.setFeatures(true), t2.DOMImplementation = n(110).DOMImplementation, t2.DOMParser = n(271).DOMParser, t2.XMLSerializer = n(274).XMLSerializer;
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(3), a = n(0);
        t2.ChildNodeImpl = function() {
          function e14() {
          }
          return e14.prototype.before = function() {
            var e15 = [...arguments], t3 = r.Cast.asNode(this), n2 = t3._parent;
            if (n2 !== null) {
              for (var o = t3._previousSibling, s = true; s && o; ) {
                s = false;
                for (var c = 0; c < e15.length; c++)
                  if (e15[c] === o) {
                    o = o._previousSibling, s = true;
                    break;
                  }
              }
              var l = a.parentNode_convertNodesIntoANode(e15, t3._nodeDocument);
              o = o === null ? n2._firstChild : o._nextSibling, a.mutation_preInsert(l, n2, o);
            }
          }, e14.prototype.after = function() {
            var e15 = [...arguments], t3 = r.Cast.asNode(this), n2 = t3._parent;
            if (n2) {
              for (var o = t3._nextSibling, s = true; s && o; ) {
                s = false;
                for (var c = 0; c < e15.length; c++)
                  if (e15[c] === o) {
                    o = o._nextSibling, s = true;
                    break;
                  }
              }
              var l = a.parentNode_convertNodesIntoANode(e15, t3._nodeDocument);
              a.mutation_preInsert(l, n2, o);
            }
          }, e14.prototype.replaceWith = function() {
            var e15 = [...arguments], t3 = r.Cast.asNode(this), n2 = t3._parent;
            if (n2) {
              for (var o = t3._nextSibling, s = true; s && o; ) {
                s = false;
                for (var c = 0; c < e15.length; c++)
                  if (e15[c] === o) {
                    o = o._nextSibling, s = true;
                    break;
                  }
              }
              var l = a.parentNode_convertNodesIntoANode(e15, t3._nodeDocument);
              t3._parent === n2 ? a.mutation_replace(t3, l, n2) : a.mutation_preInsert(l, n2, o);
            }
          }, e14.prototype.remove = function() {
            var e15 = r.Cast.asNode(this), t3 = e15._parent;
            t3 && a.mutation_remove(e15, t3);
          }, e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.DocumentOrShadowRootImpl = function() {
        };
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(6), o = n(3), s = n(7);
        t2.MutationObserverImpl = function() {
          function e14(e15) {
            this._nodeList = [], this._recordQueue = [], this._callback = e15;
            var t3 = a.dom.window;
            s.set.append(t3._mutationObservers, this);
          }
          return e14.prototype.observe = function(e15, t3) {
            var n2, a2;
            if ((t3 ||= {
              childList: false,
              subtree: false
            }).attributeOldValue === void 0 && t3.attributeFilter === void 0 || t3.attributes !== void 0 || (t3.attributes = true), t3.characterDataOldValue !== void 0 && t3.characterData === void 0 && (t3.characterData = true), !t3.childList && !t3.attributes && !t3.characterData || t3.attributeOldValue && !t3.attributes || t3.attributeFilter !== void 0 && !t3.attributes || t3.characterDataOldValue && !t3.characterData)
              throw TypeError();
            var c = false, l = t3, u = function(e16) {
              var t4, n3;
              if (e16.observer === d) {
                c = true;
                try {
                  for (var a3 = (t4 = void 0, r(d._nodeList)), u2 = a3.next(); !u2.done; u2 = a3.next()) {
                    var f2 = u2.value;
                    s.list.remove(f2._registeredObserverList, function(t5) {
                      return o.Guard.isTransientRegisteredObserver(t5) && t5.source === e16;
                    });
                  }
                } catch (e17) {
                  t4 = { error: e17 };
                } finally {
                  try {
                    u2 && !u2.done && (n3 = a3.return) && n3.call(a3);
                  } finally {
                    if (t4)
                      throw t4.error;
                  }
                }
                e16.options = l;
              }
            }, d = this;
            try {
              for (var f = r(e15._registeredObserverList), p = f.next(); !p.done; p = f.next())
                u(p.value);
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                p && !p.done && (a2 = f.return) && a2.call(f);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
            c || (e15._registeredObserverList.push({
              observer: this,
              options: t3
            }), this._nodeList.push(e15));
          }, e14.prototype.disconnect = function() {
            var e15, t3, n2 = this;
            try {
              for (var a2 = r(this._nodeList), o2 = a2.next(); !o2.done; o2 = a2.next()) {
                var c = o2.value;
                s.list.remove(c._registeredObserverList, function(e16) {
                  return e16.observer === n2;
                });
              }
            } catch (t4) {
              e15 = { error: t4 };
            } finally {
              try {
                o2 && !o2.done && (t3 = a2.return) && t3.call(a2);
              } finally {
                if (e15)
                  throw e15.error;
              }
            }
            this._recordQueue = [];
          }, e14.prototype.takeRecords = function() {
            var e15 = this._recordQueue;
            return this._recordQueue = [], e15;
          }, e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(3);
        t2.NonDocumentTypeChildNodeImpl = function() {
          function e14() {
          }
          return Object.defineProperty(e14.prototype, "previousElementSibling", {
            get: function() {
              for (var e15 = r.Cast.asNode(this)._previousSibling; e15; ) {
                if (r.Guard.isElementNode(e15))
                  return e15;
                e15 = e15._previousSibling;
              }
              return null;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "nextElementSibling", {
            get: function() {
              for (var e15 = r.Cast.asNode(this)._nextSibling; e15; ) {
                if (r.Guard.isElementNode(e15))
                  return e15;
                e15 = e15._nextSibling;
              }
              return null;
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(3), a = n(0);
        t2.NonElementParentNodeImpl = function() {
          function e14() {
          }
          return e14.prototype.getElementById = function(e15) {
            for (var t3 = a.tree_getFirstDescendantNode(r.Cast.asNode(this), false, false, function(e16) {
              return r.Guard.isElementNode(e16);
            }); t3 !== null; ) {
              if (t3._uniqueIdentifier === e15)
                return t3;
              t3 = a.tree_getNextDescendantNode(r.Cast.asNode(this), t3, false, false, function(e16) {
                return r.Guard.isElementNode(e16);
              });
            }
            return null;
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(3), o = n(0);
        t2.ParentNodeImpl = function() {
          function e14() {
          }
          return Object.defineProperty(e14.prototype, "children", {
            get: function() {
              return o.create_htmlCollection(a.Cast.asNode(this));
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "firstElementChild", {
            get: function() {
              for (var e15 = a.Cast.asNode(this)._firstChild; e15; ) {
                if (a.Guard.isElementNode(e15))
                  return e15;
                e15 = e15._nextSibling;
              }
              return null;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "lastElementChild", {
            get: function() {
              for (var e15 = a.Cast.asNode(this)._lastChild; e15; ) {
                if (a.Guard.isElementNode(e15))
                  return e15;
                e15 = e15._previousSibling;
              }
              return null;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "childElementCount", {
            get: function() {
              var e15, t3, n2 = 0;
              try {
                for (var o2 = r(a.Cast.asNode(this)._children), s = o2.next(); !s.done; s = o2.next()) {
                  var c = s.value;
                  a.Guard.isElementNode(c) && n2++;
                }
              } catch (t4) {
                e15 = { error: t4 };
              } finally {
                try {
                  s && !s.done && (t3 = o2.return) && t3.call(o2);
                } finally {
                  if (e15)
                    throw e15.error;
                }
              }
              return n2;
            },
            enumerable: true,
            configurable: true
          }), e14.prototype.prepend = function() {
            var e15 = [...arguments], t3 = a.Cast.asNode(this), n2 = o.parentNode_convertNodesIntoANode(e15, t3._nodeDocument);
            o.mutation_preInsert(n2, t3, t3._firstChild);
          }, e14.prototype.append = function() {
            var e15 = [...arguments], t3 = a.Cast.asNode(this), n2 = o.parentNode_convertNodesIntoANode(e15, t3._nodeDocument);
            o.mutation_append(n2, t3);
          }, e14.prototype.querySelector = function(e15) {
            var t3 = a.Cast.asNode(this), n2 = o.selectors_scopeMatchASelectorsString(e15, t3);
            return n2.length === 0 ? null : n2[0];
          }, e14.prototype.querySelectorAll = function(e15) {
            var t3 = a.Cast.asNode(this), n2 = o.selectors_scopeMatchASelectorsString(e15, t3);
            return o.create_nodeListStatic(t3, n2);
          }, e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(0);
        t2.SlotableImpl = function() {
          function e14() {
          }
          return Object.defineProperty(e14.prototype, "_name", {
            get: function() {
              return this.__name || "";
            },
            set: function(e15) {
              this.__name = e15;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "_assignedSlot", {
            get: function() {
              return this.__assignedSlot || null;
            },
            set: function(e15) {
              this.__assignedSlot = e15;
            },
            enumerable: true,
            configurable: true
          }), Object.defineProperty(e14.prototype, "assignedSlot", {
            get: function() {
              return r.shadowTree_findASlot(this, true);
            },
            enumerable: true,
            configurable: true
          }), e14;
        }();
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(102), s = n(9), c = n(3);
        t2.StaticRangeImpl = function(e14) {
          function t3(t4) {
            var n2 = e14.call(this) || this;
            if (c.Guard.isDocumentTypeNode(t4.startContainer) || c.Guard.isAttrNode(t4.startContainer) || c.Guard.isDocumentTypeNode(t4.endContainer) || c.Guard.isAttrNode(t4.endContainer))
              throw new s.InvalidNodeTypeError();
            return n2._start = [t4.startContainer, t4.startOffset], n2._end = [t4.endContainer, t4.endOffset], n2;
          }
          return a(t3, e14), t3;
        }(o.AbstractRangeImpl);
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.DOMParser = n(272).DOMParserImpl;
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(0), a = n(273);
        t2.DOMParserImpl = function() {
          function e14() {
          }
          return e14.prototype.parseFromString = function(e15, t3) {
            if (t3 === "text/html")
              throw Error("HTML parser not implemented.");
            try {
              return (n2 = new a.XMLParserImpl().parse(e15))._contentType = t3, n2;
            } catch (e16) {
              var n2, o = "http://www.mozilla.org/newlayout/xml/parsererror.xml", s = (n2 = r.create_xmlDocument()).createElementNS(o, "parsererror"), c = n2.createElementNS(o, "error");
              return c.setAttribute("message", e16.message), s.appendChild(c), n2.appendChild(s), n2;
            }
          }, e14;
        }();
      },
      function(e13, t2, n) {
        var r = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, a = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(180), s = n(111), c = n(7), l = n(0), u = n(69);
        t2.XMLParserImpl = function() {
          function e14() {
          }
          return e14.prototype.parse = function(e15) {
            for (var t3, n2, d, f, p = new o.XMLStringLexer(e15, { skipWhitespaceOnlyText: true }), m = l.create_document(), h = m, g = p.nextToken(); g.type !== s.TokenType.EOF; ) {
              switch (g.type) {
                case s.TokenType.Declaration:
                  var _ = g;
                  if (_.version !== "1.0")
                    throw Error("Invalid xml version: " + _.version);
                  break;
                case s.TokenType.DocType:
                  var v = g;
                  if (!l.xml_isPubidChar(v.pubId))
                    throw Error("DocType public identifier does not match PubidChar construct.");
                  if (!l.xml_isLegalChar(v.sysId) || v.sysId.indexOf('"') !== -1 && v.sysId.indexOf("'") !== -1)
                    throw Error("DocType system identifier contains invalid characters.");
                  h.appendChild(m.implementation.createDocumentType(v.name, v.pubId, v.sysId));
                  break;
                case s.TokenType.CDATA:
                  var y = g;
                  if (!l.xml_isLegalChar(y.data) || y.data.indexOf("]]>") !== -1)
                    throw Error("CDATA contains invalid characters.");
                  h.appendChild(m.createCDATASection(y.data));
                  break;
                case s.TokenType.Comment:
                  var b = g;
                  if (!l.xml_isLegalChar(b.data) || b.data.indexOf("--") !== -1 || b.data.endsWith("-"))
                    throw Error("Comment data contains invalid characters.");
                  h.appendChild(m.createComment(b.data));
                  break;
                case s.TokenType.PI:
                  var S = g;
                  if (S.target.indexOf(":") !== -1 || /^xml$/i.test(S.target))
                    throw Error("Processing instruction target contains invalid characters.");
                  if (!l.xml_isLegalChar(S.data) || S.data.indexOf("?>") !== -1)
                    throw Error("Processing instruction data contains invalid characters.");
                  h.appendChild(m.createProcessingInstruction(S.target, S.data));
                  break;
                case s.TokenType.Text:
                  var C = g;
                  if (!l.xml_isLegalChar(C.data))
                    throw Error("Text data contains invalid characters.");
                  h.appendChild(m.createTextNode(this._decodeText(C.data)));
                  break;
                case s.TokenType.Element:
                  var w = g, T = r(l.namespace_extractQName(w.name), 2), E = T[0], D = T[1];
                  if (D.indexOf(":") !== -1 || !l.xml_isName(D))
                    throw Error("Node local name contains invalid characters.");
                  if (E === "xmlns")
                    throw Error("An element cannot have the 'xmlns' prefix.");
                  var O = h.lookupNamespaceURI(E), k = {};
                  try {
                    for (var A = (t3 = void 0, a(w.attributes)), j = A.next(); !j.done; j = A.next()) {
                      var M = r(j.value, 2), N = M[0], P = M[1];
                      if (N === "xmlns")
                        O = P;
                      else {
                        var F = r(l.namespace_extractQName(N), 2), I = F[0], L = F[1];
                        I === "xmlns" && (L === E && (O = P), k[L] = P);
                      }
                    }
                  } catch (e16) {
                    t3 = { error: e16 };
                  } finally {
                    try {
                      j && !j.done && (n2 = A.return) && n2.call(A);
                    } finally {
                      if (t3)
                        throw t3.error;
                    }
                  }
                  var R = O === null ? m.createElement(w.name) : m.createElementNS(O, w.name);
                  h.appendChild(R);
                  var z = new u.LocalNameSet();
                  try {
                    for (var B = (d = void 0, a(w.attributes)), V = B.next(); !V.done; V = B.next()) {
                      var H = r(V.value, 2), U = (N = H[0], P = H[1], r(l.namespace_extractQName(N), 2)), W = (I = U[0], L = U[1], null);
                      if (I === "xmlns" || I === null && L === "xmlns" ? W = c.namespace.XMLNS : (W = R.lookupNamespaceURI(I)) !== null && R.isDefaultNamespace(W) ? W = null : W === null && I !== null && (W = k[I] || null), z.has(W, L))
                        throw Error("Element contains duplicate attributes.");
                      if (z.set(W, L), W === c.namespace.XMLNS && P === c.namespace.XMLNS)
                        throw Error("XMLNS namespace is reserved.");
                      if (L.indexOf(":") !== -1 || !l.xml_isName(L))
                        throw Error("Attribute local name contains invalid characters.");
                      if (I === "xmlns" && P === "")
                        throw Error("Empty XML namespace is not allowed.");
                      W === null ? R.setAttribute(N, this._decodeAttributeValue(P)) : R.setAttributeNS(W, N, this._decodeAttributeValue(P));
                    }
                  } catch (e16) {
                    d = { error: e16 };
                  } finally {
                    try {
                      V && !V.done && (f = B.return) && f.call(B);
                    } finally {
                      if (d)
                        throw d.error;
                    }
                  }
                  w.selfClosing || (h = R);
                  break;
                case s.TokenType.ClosingTag:
                  if (g.name !== h.nodeName)
                    throw Error("Closing tag name does not match opening tag name.");
                  h._parent && (h = h._parent);
              }
              g = p.nextToken();
            }
            return m;
          }, e14.prototype._decodeText = function(e15) {
            return e15 == null ? e15 : e15.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
          }, e14.prototype._decodeAttributeValue = function(e15) {
            return e15 == null ? e15 : e15.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
          }, e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.XMLSerializer = n(275).XMLSerializerImpl;
      },
      function(e13, t2, n) {
        var r = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var a = n(2), o = n(69), s = n(95), c = n(9), l = n(7), u = n(0);
        t2.XMLSerializerImpl = function() {
          function e14() {
          }
          return e14.prototype.serializeToString = function(e15) {
            return this._xmlSerialization(e15, false);
          }, e14.prototype._xmlSerialization = function(e15, t3) {
            if (e15._nodeDocument === void 0 || e15._nodeDocument._hasNamespaces) {
              var n2 = new s.NamespacePrefixMap();
              n2.set("xml", l.namespace.XML);
              try {
                return this._serializeNodeNS(e15, null, n2, { value: 1 }, t3);
              } catch {
                throw new c.InvalidStateError();
              }
            } else
              try {
                return this._serializeNode(e15, t3);
              } catch {
                throw new c.InvalidStateError();
              }
          }, e14.prototype._serializeNodeNS = function(e15, t3, n2, r2, o2) {
            switch (e15.nodeType) {
              case a.NodeType.Element:
                return this._serializeElementNS(e15, t3, n2, r2, o2);
              case a.NodeType.Document:
                return this._serializeDocumentNS(e15, t3, n2, r2, o2);
              case a.NodeType.Comment:
                return this._serializeComment(e15, o2);
              case a.NodeType.Text:
                return this._serializeText(e15, o2);
              case a.NodeType.DocumentFragment:
                return this._serializeDocumentFragmentNS(e15, t3, n2, r2, o2);
              case a.NodeType.DocumentType:
                return this._serializeDocumentType(e15, o2);
              case a.NodeType.ProcessingInstruction:
                return this._serializeProcessingInstruction(e15, o2);
              case a.NodeType.CData:
                return this._serializeCData(e15, o2);
              default:
                throw Error("Unknown node type: " + e15.nodeType);
            }
          }, e14.prototype._serializeNode = function(e15, t3) {
            switch (e15.nodeType) {
              case a.NodeType.Element:
                return this._serializeElement(e15, t3);
              case a.NodeType.Document:
                return this._serializeDocument(e15, t3);
              case a.NodeType.Comment:
                return this._serializeComment(e15, t3);
              case a.NodeType.Text:
                return this._serializeText(e15, t3);
              case a.NodeType.DocumentFragment:
                return this._serializeDocumentFragment(e15, t3);
              case a.NodeType.DocumentType:
                return this._serializeDocumentType(e15, t3);
              case a.NodeType.ProcessingInstruction:
                return this._serializeProcessingInstruction(e15, t3);
              case a.NodeType.CData:
                return this._serializeCData(e15, t3);
              default:
                throw Error("Unknown node type: " + e15.nodeType);
            }
          }, e14.prototype._serializeElementNS = function(t3, n2, a2, o2, s2) {
            var c2, d;
            if (s2 && (t3.localName.indexOf(":") !== -1 || !u.xml_isName(t3.localName)))
              throw Error("Node local name contains invalid characters (well-formed required).");
            var f = "<", p = "", m = false, h = false, g = a2.copy(), _ = {}, v = this._recordNamespaceInformation(t3, g, _), y = n2, b = t3.namespaceURI;
            if (y === b)
              v !== null && (h = true), f += p = b === l.namespace.XML ? "xml:" + t3.localName : t3.localName;
            else {
              var S = t3.prefix, C = null;
              if (S === null && b === v || (C = g.get(S, b)), S === "xmlns") {
                if (s2)
                  throw Error("An element cannot have the 'xmlns' prefix (well-formed required).");
                C = S;
              }
              C === null ? S === null ? v === null || v !== null && v !== b ? (h = true, y = b, f += p += t3.localName, f += ' xmlns="' + this._serializeAttributeValue(b, s2) + '"') : (y = b, f += p += t3.localName) : (S in _ && (S = this._generatePrefix(b, g, o2)), g.set(S, b), f += p += S + ":" + t3.localName, f += " xmlns:" + S + '="' + this._serializeAttributeValue(b, s2) + '"', v !== null && (y = v || null)) : (p = C + ":" + t3.localName, v !== null && v !== l.namespace.XML && (y = v || null), f += p);
            }
            f += this._serializeAttributesNS(t3, g, o2, _, h, s2);
            var w = b === l.namespace.HTML;
            if (w && t3.childNodes.length === 0 && e14._VoidElementNames.has(t3.localName) ? (f += " /", m = true) : w || t3.childNodes.length !== 0 || (f += "/", m = true), f += ">", m)
              return f;
            if (!(w && t3.localName === "template"))
              try {
                for (var T = r(t3._children || t3.childNodes), E = T.next(); !E.done; E = T.next()) {
                  var D = E.value;
                  f += this._serializeNodeNS(D, y, g, o2, s2);
                }
              } catch (e15) {
                c2 = { error: e15 };
              } finally {
                try {
                  E && !E.done && (d = T.return) && d.call(T);
                } finally {
                  if (c2)
                    throw c2.error;
                }
              }
            return f += "</" + p + ">";
          }, e14.prototype._serializeDocumentNS = function(e15, t3, n2, a2, o2) {
            var s2, c2;
            if (o2 && e15.documentElement === null)
              throw Error("Missing document element (well-formed required).");
            var l2 = "";
            try {
              for (var u2 = r(e15._children || e15.childNodes), d = u2.next(); !d.done; d = u2.next()) {
                var f = d.value;
                l2 += this._serializeNodeNS(f, t3, n2, a2, o2);
              }
            } catch (e16) {
              s2 = { error: e16 };
            } finally {
              try {
                d && !d.done && (c2 = u2.return) && c2.call(u2);
              } finally {
                if (s2)
                  throw s2.error;
              }
            }
            return l2;
          }, e14.prototype._serializeComment = function(e15, t3) {
            if (t3 && (!u.xml_isLegalChar(e15.data) || e15.data.indexOf("--") !== -1 || e15.data.endsWith("-")))
              throw Error("Comment data contains invalid characters (well-formed required).");
            return "<!--" + e15.data + "-->";
          }, e14.prototype._serializeText = function(e15, t3) {
            if (t3 && !u.xml_isLegalChar(e15.data))
              throw Error("Text data contains invalid characters (well-formed required).");
            for (var n2 = "", r2 = 0; r2 < e15.data.length; r2++) {
              var a2 = e15.data[r2];
              n2 += a2 === "&" ? "&amp;" : a2 === "<" ? "&lt;" : a2 === ">" ? "&gt;" : a2;
            }
            return n2;
          }, e14.prototype._serializeDocumentFragmentNS = function(e15, t3, n2, a2, o2) {
            var s2, c2, l2 = "";
            try {
              for (var u2 = r(e15._children || e15.childNodes), d = u2.next(); !d.done; d = u2.next()) {
                var f = d.value;
                l2 += this._serializeNodeNS(f, t3, n2, a2, o2);
              }
            } catch (e16) {
              s2 = { error: e16 };
            } finally {
              try {
                d && !d.done && (c2 = u2.return) && c2.call(u2);
              } finally {
                if (s2)
                  throw s2.error;
              }
            }
            return l2;
          }, e14.prototype._serializeDocumentType = function(e15, t3) {
            if (t3 && !u.xml_isPubidChar(e15.publicId))
              throw Error("DocType public identifier does not match PubidChar construct (well-formed required).");
            if (t3 && (!u.xml_isLegalChar(e15.systemId) || e15.systemId.indexOf('"') !== -1 && e15.systemId.indexOf("'") !== -1))
              throw Error("DocType system identifier contains invalid characters (well-formed required).");
            return e15.publicId && e15.systemId ? "<!DOCTYPE " + e15.name + ' PUBLIC "' + e15.publicId + '" "' + e15.systemId + '">' : e15.publicId ? "<!DOCTYPE " + e15.name + ' PUBLIC "' + e15.publicId + '">' : e15.systemId ? "<!DOCTYPE " + e15.name + ' SYSTEM "' + e15.systemId + '">' : "<!DOCTYPE " + e15.name + ">";
          }, e14.prototype._serializeProcessingInstruction = function(e15, t3) {
            if (t3 && (e15.target.indexOf(":") !== -1 || /^xml$/i.test(e15.target)))
              throw Error("Processing instruction target contains invalid characters (well-formed required).");
            if (t3 && (!u.xml_isLegalChar(e15.data) || e15.data.indexOf("?>") !== -1))
              throw Error("Processing instruction data contains invalid characters (well-formed required).");
            return "<?" + (e15.data === "" ? e15.target : e15.target + " " + e15.data) + "?>";
          }, e14.prototype._serializeCData = function(e15, t3) {
            if (t3 && e15.data.indexOf("]]>") !== -1)
              throw Error("CDATA contains invalid characters (well-formed required).");
            return "<![CDATA[" + e15.data + "]]>";
          }, e14.prototype._serializeAttributesNS = function(e15, t3, n2, a2, s2, c2) {
            var d, f, p = "", m = c2 ? new o.LocalNameSet() : void 0;
            try {
              for (var h = r(e15.attributes), g = h.next(); !g.done; g = h.next()) {
                var _ = g.value;
                if (s2 || c2 || _.namespaceURI !== null) {
                  if (c2 && m && m.has(_.namespaceURI, _.localName))
                    throw Error("Element contains duplicate attributes (well-formed required).");
                  c2 && m && m.set(_.namespaceURI, _.localName);
                  var v = _.namespaceURI, y = null;
                  if (v !== null)
                    if (y = t3.get(_.prefix, v), v === l.namespace.XMLNS) {
                      if (_.value === l.namespace.XML || _.prefix === null && s2 || _.prefix !== null && (!(_.localName in a2) || a2[_.localName] !== _.value) && t3.has(_.localName, _.value))
                        continue;
                      if (c2 && _.value === l.namespace.XMLNS)
                        throw Error("XMLNS namespace is reserved (well-formed required).");
                      if (c2 && _.value === "")
                        throw Error("Namespace prefix declarations cannot be used to undeclare a namespace (well-formed required).");
                      _.prefix === "xmlns" && (y = "xmlns");
                    } else
                      y === null && (p += " xmlns:" + (y = _.prefix === null || t3.hasPrefix(_.prefix) && !t3.has(_.prefix, v) ? this._generatePrefix(v, t3, n2) : _.prefix) + '="' + this._serializeAttributeValue(v, c2) + '"');
                  if (p += " ", y !== null && (p += y + ":"), c2 && (_.localName.indexOf(":") !== -1 || !u.xml_isName(_.localName) || _.localName === "xmlns" && v === null))
                    throw Error("Attribute local name contains invalid characters (well-formed required).");
                  p += _.localName + '="' + this._serializeAttributeValue(_.value, c2) + '"';
                } else
                  p += " " + _.localName + '="' + this._serializeAttributeValue(_.value, c2) + '"';
              }
            } catch (e16) {
              d = { error: e16 };
            } finally {
              try {
                g && !g.done && (f = h.return) && f.call(h);
              } finally {
                if (d)
                  throw d.error;
              }
            }
            return p;
          }, e14.prototype._recordNamespaceInformation = function(e15, t3, n2) {
            var a2, o2, s2 = null;
            try {
              for (var c2 = r(e15.attributes), u2 = c2.next(); !u2.done; u2 = c2.next()) {
                var d = u2.value, f = d.namespaceURI, p = d.prefix;
                if (f === l.namespace.XMLNS) {
                  if (p === null) {
                    s2 = d.value;
                    continue;
                  }
                  var m = d.localName, h = d.value;
                  if (h === l.namespace.XML || (h === "" && (h = null), t3.has(m, h)))
                    continue;
                  t3.set(m, h), n2[m] = h || "";
                }
              }
            } catch (e16) {
              a2 = { error: e16 };
            } finally {
              try {
                u2 && !u2.done && (o2 = c2.return) && o2.call(c2);
              } finally {
                if (a2)
                  throw a2.error;
              }
            }
            return s2;
          }, e14.prototype._generatePrefix = function(e15, t3, n2) {
            var r2 = "ns" + n2.value;
            return n2.value++, t3.set(r2, e15), r2;
          }, e14.prototype._serializeAttributeValue = function(e15, t3) {
            if (t3 && e15 !== null && !u.xml_isLegalChar(e15))
              throw Error("Invalid characters in attribute value.");
            if (e15 === null)
              return "";
            for (var n2 = "", r2 = 0; r2 < e15.length; r2++) {
              var a2 = e15[r2];
              n2 += a2 === '"' ? "&quot;" : a2 === "&" ? "&amp;" : a2 === "<" ? "&lt;" : a2 === ">" ? "&gt;" : a2;
            }
            return n2;
          }, e14.prototype._serializeElement = function(e15, t3) {
            var n2, a2;
            if (t3 && (e15.localName.indexOf(":") !== -1 || !u.xml_isName(e15.localName)))
              throw Error("Node local name contains invalid characters (well-formed required).");
            var o2 = false, s2 = e15.localName, c2 = "<" + s2;
            if (c2 += this._serializeAttributes(e15, t3), e15._children.size === 0 && (c2 += "/", o2 = true), c2 += ">", o2)
              return c2;
            try {
              for (var l2 = r(e15._children), d = l2.next(); !d.done; d = l2.next()) {
                var f = d.value;
                c2 += this._serializeNode(f, t3);
              }
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                d && !d.done && (a2 = l2.return) && a2.call(l2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
            return c2 += "</" + s2 + ">";
          }, e14.prototype._serializeDocument = function(e15, t3) {
            var n2, a2;
            if (t3 && e15.documentElement === null)
              throw Error("Missing document element (well-formed required).");
            var o2 = "";
            try {
              for (var s2 = r(e15._children), c2 = s2.next(); !c2.done; c2 = s2.next()) {
                var l2 = c2.value;
                o2 += this._serializeNode(l2, t3);
              }
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                c2 && !c2.done && (a2 = s2.return) && a2.call(s2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
            return o2;
          }, e14.prototype._serializeDocumentFragment = function(e15, t3) {
            var n2, a2, o2 = "";
            try {
              for (var s2 = r(e15._children), c2 = s2.next(); !c2.done; c2 = s2.next()) {
                var l2 = c2.value;
                o2 += this._serializeNode(l2, t3);
              }
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                c2 && !c2.done && (a2 = s2.return) && a2.call(s2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
            return o2;
          }, e14.prototype._serializeAttributes = function(e15, t3) {
            var n2, a2, o2 = "", s2 = t3 ? {} : void 0;
            try {
              for (var c2 = r(e15.attributes), l2 = c2.next(); !l2.done; l2 = c2.next()) {
                var d = l2.value;
                if (t3 && s2 && d.localName in s2)
                  throw Error("Element contains duplicate attributes (well-formed required).");
                if (t3 && s2 && (s2[d.localName] = true), t3 && (d.localName.indexOf(":") !== -1 || !u.xml_isName(d.localName)))
                  throw Error("Attribute local name contains invalid characters (well-formed required).");
                o2 += " " + d.localName + '="' + this._serializeAttributeValue(d.value, t3) + '"';
              }
            } catch (e16) {
              n2 = { error: e16 };
            } finally {
              try {
                l2 && !l2.done && (a2 = c2.return) && a2.call(c2);
              } finally {
                if (n2)
                  throw n2.error;
              }
            }
            return o2;
          }, e14._VoidElementNames = /* @__PURE__ */ new Set([
            "area",
            "base",
            "basefont",
            "bgsound",
            "br",
            "col",
            "embed",
            "frame",
            "hr",
            "img",
            "input",
            "keygen",
            "link",
            "menuitem",
            "meta",
            "param",
            "source",
            "track",
            "wbr"
          ]), e14;
        }();
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true }), t2.XMLReader = n(277).XMLReader, t2.ObjectReader = n(112).ObjectReader, t2.JSONReader = n(280).JSONReader, t2.YAMLReader = n(281).YAMLReader;
      },
      function(e13, t2, n) {
        n(31), n(32), n(33), n(19), n(65), n(20), n(22), n(23);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        }, s = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var c = n(180), l = n(111), u = n(7), d = n(0);
        t2.XMLReader = function(e14) {
          function t3() {
            return e14 !== null && e14.apply(this, arguments) || this;
          }
          return a(t3, e14), t3.prototype._parse = function(e15, t4) {
            for (var n2, r2, a2, f, p = new c.XMLStringLexer(t4, { skipWhitespaceOnlyText: true }), m = e15, h = e15, g = p.nextToken(); g.type !== l.TokenType.EOF; ) {
              switch (g.type) {
                case l.TokenType.Declaration:
                  var _ = g, v = this.sanitize(_.version);
                  if (v !== "1.0")
                    throw Error("Invalid xml version: " + v);
                  var y = { version: v };
                  _.encoding && (y.encoding = this.sanitize(_.encoding)), _.standalone && (y.standalone = this.sanitize(_.standalone) === "yes"), h.set(y);
                  break;
                case l.TokenType.DocType:
                  var b = g;
                  h = this.docType(h, this.sanitize(b.name), this.sanitize(b.pubId), this.sanitize(b.sysId)) || h;
                  break;
                case l.TokenType.CDATA:
                  var S = g;
                  h = this.cdata(h, this.sanitize(S.data)) || h;
                  break;
                case l.TokenType.Comment:
                  var C = g;
                  h = this.comment(h, this.sanitize(C.data)) || h;
                  break;
                case l.TokenType.PI:
                  var w = g;
                  h = this.instruction(h, this.sanitize(w.target), this.sanitize(w.data)) || h;
                  break;
                case l.TokenType.Text:
                  var T = g;
                  h = this.text(h, this._decodeText(this.sanitize(T.data))) || h;
                  break;
                case l.TokenType.Element:
                  var E = g, D = this.sanitize(E.name), O = o(d.namespace_extractQName(D), 1)[0], k = h.node.lookupNamespaceURI(O), A = {};
                  try {
                    for (var j = (n2 = void 0, s(E.attributes)), M = j.next(); !M.done; M = j.next()) {
                      var N = o(M.value, 2), P = N[0], F = N[1];
                      if (P = this.sanitize(P), F = this.sanitize(F), P === "xmlns")
                        k = F;
                      else {
                        var I = o(d.namespace_extractQName(P), 2), L = I[0], R = I[1];
                        L === "xmlns" && (R === O && (k = F), A[R] = F);
                      }
                    }
                  } catch (e16) {
                    n2 = { error: e16 };
                  } finally {
                    try {
                      M && !M.done && (r2 = j.return) && r2.call(j);
                    } finally {
                      if (n2)
                        throw n2.error;
                    }
                  }
                  var z = k === null ? this.element(h, void 0, D) : this.element(h, k, D);
                  if (z === void 0)
                    break;
                  h.node === e15.node && (m = z);
                  try {
                    for (var B = (a2 = void 0, s(E.attributes)), V = B.next(); !V.done; V = B.next()) {
                      var H = o(V.value, 2);
                      P = H[0], F = H[1], P = this.sanitize(P), F = this.sanitize(F);
                      var U = o(d.namespace_extractQName(P), 2), W = (L = U[0], R = U[1], null);
                      L === "xmlns" || L === null && R === "xmlns" ? W = u.namespace.XMLNS : (W = z.node.lookupNamespaceURI(L)) !== null && z.node.isDefaultNamespace(W) ? W = null : W === null && L !== null && (W = A[L] || null), W === null ? this.attribute(z, void 0, P, this._decodeAttributeValue(F)) : this.attribute(z, W, P, this._decodeAttributeValue(F));
                    }
                  } catch (e16) {
                    a2 = { error: e16 };
                  } finally {
                    try {
                      V && !V.done && (f = B.return) && f.call(B);
                    } finally {
                      if (a2)
                        throw a2.error;
                    }
                  }
                  E.selfClosing || (h = z);
                  break;
                case l.TokenType.ClosingTag:
                  h.node.parentNode && (h = h.up());
              }
              g = p.nextToken();
            }
            return m;
          }, t3;
        }(n(75).BaseReader);
      },
      function(e13, t2, n) {
        var r = n(4), a = n(279);
        r({
          target: "Object",
          stat: true,
          forced: Object.assign !== a
        }, { assign: a });
      },
      function(e13, t2, n) {
        var r = n(16), a = n(8), o = n(61), s = n(85), c = n(79), l = n(27), u = n(41), d = Object.assign, f = Object.defineProperty;
        e13.exports = !d || a(function() {
          if (r && d({ b: 1 }, d(f({}, "a", {
            enumerable: true,
            get: function() {
              f(this, "b", {
                value: 3,
                enumerable: false
              });
            }
          }), { b: 2 })).b !== 1)
            return true;
          var e14 = {}, t3 = {}, n2 = Symbol();
          return e14[n2] = 7, "abcdefghijklmnopqrst".split("").forEach(function(e15) {
            t3[e15] = e15;
          }), d({}, e14)[n2] != 7 || o(d({}, t3)).join("") != "abcdefghijklmnopqrst";
        }) ? function(e14, t3) {
          for (var n2 = l(e14), a2 = arguments.length, d2 = 1, f2 = s.f, p = c.f; a2 > d2; )
            for (var m, h = u(arguments[d2++]), g = f2 ? o(h).concat(f2(h)) : o(h), _ = g.length, v = 0; _ > v; )
              m = g[v++], r && !p.call(h, m) || (n2[m] = h[m]);
          return n2;
        } : d;
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(112);
        t2.JSONReader = function(e14) {
          function t3() {
            return e14 !== null && e14.apply(this, arguments) || this;
          }
          return a(t3, e14), t3.prototype._parse = function(e15, t4) {
            return new o.ObjectReader(this._builderOptions).parse(e15, JSON.parse(t4));
          }, t3;
        }(n(75).BaseReader);
      },
      function(e13, t2, n) {
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true });
        var o = n(112), s = n(75), c = n(282);
        t2.YAMLReader = function(e14) {
          function t3() {
            return e14 !== null && e14.apply(this, arguments) || this;
          }
          return a(t3, e14), t3.prototype._parse = function(e15, t4) {
            var n2 = c.safeLoad(t4);
            if (n2 === void 0)
              throw Error("Unable to parse YAML document.");
            return new o.ObjectReader(this._builderOptions).parse(e15, n2);
          }, t3;
        }(s.BaseReader);
      },
      function(e13, t2, n) {
        e13.exports = n(283);
      },
      function(e13, t2, n) {
        var r = n(284), a = n(303);
        function o(e14) {
          return function() {
            throw Error("Function " + e14 + " is deprecated and cannot be used.");
          };
        }
        e13.exports.Type = n(10), e13.exports.Schema = n(39), e13.exports.FAILSAFE_SCHEMA = n(113), e13.exports.JSON_SCHEMA = n(182), e13.exports.CORE_SCHEMA = n(181), e13.exports.DEFAULT_SAFE_SCHEMA = n(54), e13.exports.DEFAULT_FULL_SCHEMA = n(76), e13.exports.load = r.load, e13.exports.loadAll = r.loadAll, e13.exports.safeLoad = r.safeLoad, e13.exports.safeLoadAll = r.safeLoadAll, e13.exports.dump = a.dump, e13.exports.safeDump = a.safeDump, e13.exports.YAMLException = n(53), e13.exports.MINIMAL_SCHEMA = n(113), e13.exports.SAFE_SCHEMA = n(54), e13.exports.DEFAULT_SCHEMA = n(76), e13.exports.scan = o("scan"), e13.exports.parse = o("parse"), e13.exports.compose = o("compose"), e13.exports.addConstructor = o("addConstructor");
      },
      function(e13, t2, n) {
        var r = n(38), a = n(53), o = n(285), s = n(54), c = n(76), l = Object.prototype.hasOwnProperty, u = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, d = /[\x85\u2028\u2029]/, f = /[,\[\]\{\}]/, p = /^(?:!|!!|![a-z\-]+!)$/i, m = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
        function h(e14) {
          return Object.prototype.toString.call(e14);
        }
        function g(e14) {
          return e14 === 10 || e14 === 13;
        }
        function _(e14) {
          return e14 === 9 || e14 === 32;
        }
        function v(e14) {
          return e14 === 9 || e14 === 32 || e14 === 10 || e14 === 13;
        }
        function y(e14) {
          return e14 === 44 || e14 === 91 || e14 === 93 || e14 === 123 || e14 === 125;
        }
        function b(e14) {
          var t3;
          return 48 <= e14 && e14 <= 57 ? e14 - 48 : 97 <= (t3 = 32 | e14) && t3 <= 102 ? t3 - 97 + 10 : -1;
        }
        function S(e14) {
          return e14 === 48 ? "\0" : e14 === 97 ? "\x07" : e14 === 98 ? "\b" : e14 === 116 || e14 === 9 ? "	" : e14 === 110 ? "\n" : e14 === 118 ? "\v" : e14 === 102 ? "\f" : e14 === 114 ? "\r" : e14 === 101 ? "\x1B" : e14 === 32 ? " " : e14 === 34 ? '"' : e14 === 47 ? "/" : e14 === 92 ? "\\" : e14 === 78 ? "\x85" : e14 === 95 ? "\xA0" : e14 === 76 ? "\u2028" : e14 === 80 ? "\u2029" : "";
        }
        function C(e14) {
          return e14 <= 65535 ? String.fromCharCode(e14) : String.fromCharCode(55296 + (e14 - 65536 >> 10), 56320 + (e14 - 65536 & 1023));
        }
        for (var w = Array(256), T = Array(256), E = 0; E < 256; E++)
          w[E] = S(E) ? 1 : 0, T[E] = S(E);
        function D(e14, t3) {
          this.input = e14, this.filename = t3.filename || null, this.schema = t3.schema || c, this.onWarning = t3.onWarning || null, this.legacy = t3.legacy || false, this.json = t3.json || false, this.listener = t3.listener || null, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = e14.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.documents = [];
        }
        function O(e14, t3) {
          return new a(t3, new o(e14.filename, e14.input, e14.position, e14.line, e14.position - e14.lineStart));
        }
        function k(e14, t3) {
          throw O(e14, t3);
        }
        function A(e14, t3) {
          e14.onWarning && e14.onWarning.call(null, O(e14, t3));
        }
        var j = {
          YAML: function(e14, t3, n2) {
            var r2, a2, o2;
            e14.version !== null && k(e14, "duplication of %YAML directive"), n2.length !== 1 && k(e14, "YAML directive accepts exactly one argument"), (r2 = /^([0-9]+)\.([0-9]+)$/.exec(n2[0])) === null && k(e14, "ill-formed argument of the YAML directive"), a2 = parseInt(r2[1], 10), o2 = parseInt(r2[2], 10), a2 !== 1 && k(e14, "unacceptable YAML version of the document"), e14.version = n2[0], e14.checkLineBreaks = o2 < 2, o2 !== 1 && o2 !== 2 && A(e14, "unsupported YAML version of the document");
          },
          TAG: function(e14, t3, n2) {
            var r2, a2;
            n2.length !== 2 && k(e14, "TAG directive accepts exactly two arguments"), r2 = n2[0], a2 = n2[1], p.test(r2) || k(e14, "ill-formed tag handle (first argument) of the TAG directive"), l.call(e14.tagMap, r2) && k(e14, 'there is a previously declared suffix for "' + r2 + '" tag handle'), m.test(a2) || k(e14, "ill-formed tag prefix (second argument) of the TAG directive"), e14.tagMap[r2] = a2;
          }
        };
        function M(e14, t3, n2, r2) {
          var a2, o2, s2, c2;
          if (t3 < n2) {
            if (c2 = e14.input.slice(t3, n2), r2)
              for (a2 = 0, o2 = c2.length; a2 < o2; a2 += 1)
                (s2 = c2.charCodeAt(a2)) === 9 || 32 <= s2 && s2 <= 1114111 || k(e14, "expected valid JSON character");
            else
              u.test(c2) && k(e14, "the stream contains non-printable characters");
            e14.result += c2;
          }
        }
        function N(e14, t3, n2, a2) {
          var o2, s2, c2, u2;
          for (r.isObject(n2) || k(e14, "cannot merge mappings; the provided source object is unacceptable"), c2 = 0, u2 = (o2 = Object.keys(n2)).length; c2 < u2; c2 += 1)
            s2 = o2[c2], l.call(t3, s2) || (t3[s2] = n2[s2], a2[s2] = true);
        }
        function P(e14, t3, n2, r2, a2, o2, s2, c2) {
          var u2, d2;
          if (Array.isArray(a2))
            for (u2 = 0, d2 = (a2 = Array.prototype.slice.call(a2)).length; u2 < d2; u2 += 1)
              Array.isArray(a2[u2]) && k(e14, "nested arrays are not supported inside keys"), typeof a2 == "object" && h(a2[u2]) === "[object Object]" && (a2[u2] = "[object Object]");
          if (typeof a2 == "object" && h(a2) === "[object Object]" && (a2 = "[object Object]"), a2 = String(a2), t3 === null && (t3 = {}), r2 === "tag:yaml.org,2002:merge")
            if (Array.isArray(o2))
              for (u2 = 0, d2 = o2.length; u2 < d2; u2 += 1)
                N(e14, t3, o2[u2], n2);
            else
              N(e14, t3, o2, n2);
          else
            e14.json || l.call(n2, a2) || !l.call(t3, a2) || (e14.line = s2 || e14.line, e14.position = c2 || e14.position, k(e14, "duplicated mapping key")), t3[a2] = o2, delete n2[a2];
          return t3;
        }
        function F(e14) {
          var t3;
          (t3 = e14.input.charCodeAt(e14.position)) === 10 ? e14.position++ : t3 === 13 ? (e14.position++, e14.input.charCodeAt(e14.position) === 10 && e14.position++) : k(e14, "a line break is expected"), e14.line += 1, e14.lineStart = e14.position;
        }
        function I(e14, t3, n2) {
          for (var r2 = 0, a2 = e14.input.charCodeAt(e14.position); a2 !== 0; ) {
            for (; _(a2); )
              a2 = e14.input.charCodeAt(++e14.position);
            if (t3 && a2 === 35)
              do
                a2 = e14.input.charCodeAt(++e14.position);
              while (a2 !== 10 && a2 !== 13 && a2 !== 0);
            if (!g(a2))
              break;
            for (F(e14), a2 = e14.input.charCodeAt(e14.position), r2++, e14.lineIndent = 0; a2 === 32; )
              e14.lineIndent++, a2 = e14.input.charCodeAt(++e14.position);
          }
          return n2 !== -1 && r2 !== 0 && e14.lineIndent < n2 && A(e14, "deficient indentation"), r2;
        }
        function L(e14) {
          var t3, n2 = e14.position;
          return !((t3 = e14.input.charCodeAt(n2)) !== 45 && t3 !== 46 || t3 !== e14.input.charCodeAt(n2 + 1) || t3 !== e14.input.charCodeAt(n2 + 2) || (n2 += 3, (t3 = e14.input.charCodeAt(n2)) !== 0 && !v(t3)));
        }
        function R(e14, t3) {
          t3 === 1 ? e14.result += " " : t3 > 1 && (e14.result += r.repeat("\n", t3 - 1));
        }
        function z(e14, t3) {
          var n2, r2, a2 = e14.tag, o2 = e14.anchor, s2 = [], c2 = false;
          for (e14.anchor !== null && (e14.anchorMap[e14.anchor] = s2), r2 = e14.input.charCodeAt(e14.position); r2 !== 0 && r2 === 45 && v(e14.input.charCodeAt(e14.position + 1)); )
            if (c2 = true, e14.position++, I(e14, true, -1) && e14.lineIndent <= t3)
              s2.push(null), r2 = e14.input.charCodeAt(e14.position);
            else if (n2 = e14.line, H(e14, t3, 3, false, true), s2.push(e14.result), I(e14, true, -1), r2 = e14.input.charCodeAt(e14.position), (e14.line === n2 || e14.lineIndent > t3) && r2 !== 0)
              k(e14, "bad indentation of a sequence entry");
            else if (e14.lineIndent < t3)
              break;
          return !!c2 && (e14.tag = a2, e14.anchor = o2, e14.kind = "sequence", e14.result = s2, true);
        }
        function B(e14) {
          var t3, n2, r2, a2, o2 = false, s2 = false;
          if ((a2 = e14.input.charCodeAt(e14.position)) !== 33)
            return false;
          if (e14.tag !== null && k(e14, "duplication of a tag property"), (a2 = e14.input.charCodeAt(++e14.position)) === 60 ? (o2 = true, a2 = e14.input.charCodeAt(++e14.position)) : a2 === 33 ? (s2 = true, n2 = "!!", a2 = e14.input.charCodeAt(++e14.position)) : n2 = "!", t3 = e14.position, o2) {
            do
              a2 = e14.input.charCodeAt(++e14.position);
            while (a2 !== 0 && a2 !== 62);
            e14.position < e14.length ? (r2 = e14.input.slice(t3, e14.position), a2 = e14.input.charCodeAt(++e14.position)) : k(e14, "unexpected end of the stream within a verbatim tag");
          } else {
            for (; a2 !== 0 && !v(a2); )
              a2 === 33 && (s2 ? k(e14, "tag suffix cannot contain exclamation marks") : (n2 = e14.input.slice(t3 - 1, e14.position + 1), p.test(n2) || k(e14, "named tag handle cannot contain such characters"), s2 = true, t3 = e14.position + 1)), a2 = e14.input.charCodeAt(++e14.position);
            r2 = e14.input.slice(t3, e14.position), f.test(r2) && k(e14, "tag suffix cannot contain flow indicator characters");
          }
          return r2 && !m.test(r2) && k(e14, "tag name cannot contain such characters: " + r2), o2 ? e14.tag = r2 : l.call(e14.tagMap, n2) ? e14.tag = e14.tagMap[n2] + r2 : n2 === "!" ? e14.tag = "!" + r2 : n2 === "!!" ? e14.tag = "tag:yaml.org,2002:" + r2 : k(e14, 'undeclared tag handle "' + n2 + '"'), true;
        }
        function V(e14) {
          var t3, n2;
          if ((n2 = e14.input.charCodeAt(e14.position)) !== 38)
            return false;
          for (e14.anchor !== null && k(e14, "duplication of an anchor property"), n2 = e14.input.charCodeAt(++e14.position), t3 = e14.position; n2 !== 0 && !v(n2) && !y(n2); )
            n2 = e14.input.charCodeAt(++e14.position);
          return e14.position === t3 && k(e14, "name of an anchor node must contain at least one character"), e14.anchor = e14.input.slice(t3, e14.position), true;
        }
        function H(e14, t3, n2, a2, o2) {
          var s2, c2, u2, d2, f2, p2, m2, h2, S2 = 1, E2 = false, D2 = false;
          if (e14.listener !== null && e14.listener("open", e14), e14.tag = null, e14.anchor = null, e14.kind = null, e14.result = null, s2 = c2 = u2 = n2 === 4 || n2 === 3, a2 && I(e14, true, -1) && (E2 = true, e14.lineIndent > t3 ? S2 = 1 : e14.lineIndent === t3 ? S2 = 0 : e14.lineIndent < t3 && (S2 = -1)), S2 === 1)
            for (; B(e14) || V(e14); )
              I(e14, true, -1) ? (E2 = true, u2 = s2, e14.lineIndent > t3 ? S2 = 1 : e14.lineIndent === t3 ? S2 = 0 : e14.lineIndent < t3 && (S2 = -1)) : u2 = false;
          if (u2 &&= E2 || o2, S2 !== 1 && n2 !== 4 || (m2 = n2 === 1 || n2 === 2 ? t3 : t3 + 1, h2 = e14.position - e14.lineStart, S2 === 1 ? u2 && (z(e14, h2) || function(e15, t4, n3) {
            var r2, a3, o3, s3, c3, l2 = e15.tag, u3 = e15.anchor, d3 = {}, f3 = {}, p3 = null, m3 = null, h3 = null, g2 = false, y2 = false;
            for (e15.anchor !== null && (e15.anchorMap[e15.anchor] = d3), c3 = e15.input.charCodeAt(e15.position); c3 !== 0; ) {
              if (r2 = e15.input.charCodeAt(e15.position + 1), o3 = e15.line, s3 = e15.position, c3 !== 63 && c3 !== 58 || !v(r2)) {
                if (!H(e15, n3, 2, false, true))
                  break;
                if (e15.line === o3) {
                  for (c3 = e15.input.charCodeAt(e15.position); _(c3); )
                    c3 = e15.input.charCodeAt(++e15.position);
                  if (c3 === 58)
                    v(c3 = e15.input.charCodeAt(++e15.position)) || k(e15, "a whitespace character is expected after the key-value separator within a block mapping"), g2 && (P(e15, d3, f3, p3, m3, null), p3 = m3 = h3 = null), y2 = true, g2 = false, a3 = false, p3 = e15.tag, m3 = e15.result;
                  else {
                    if (!y2)
                      return e15.tag = l2, e15.anchor = u3, true;
                    k(e15, "can not read an implicit mapping pair; a colon is missed");
                  }
                } else {
                  if (!y2)
                    return e15.tag = l2, e15.anchor = u3, true;
                  k(e15, "can not read a block mapping entry; a multiline key may not be an implicit key");
                }
              } else
                c3 === 63 ? (g2 && (P(e15, d3, f3, p3, m3, null), p3 = m3 = h3 = null), y2 = true, g2 = true, a3 = true) : g2 ? (g2 = false, a3 = true) : k(e15, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"), e15.position += 1, c3 = r2;
              if ((e15.line === o3 || e15.lineIndent > t4) && (H(e15, t4, 4, true, a3) && (g2 ? m3 = e15.result : h3 = e15.result), g2 || (P(e15, d3, f3, p3, m3, h3, o3, s3), p3 = m3 = h3 = null), I(e15, true, -1), c3 = e15.input.charCodeAt(e15.position)), e15.lineIndent > t4 && c3 !== 0)
                k(e15, "bad indentation of a mapping entry");
              else if (e15.lineIndent < t4)
                break;
            }
            return g2 && P(e15, d3, f3, p3, m3, null), y2 && (e15.tag = l2, e15.anchor = u3, e15.kind = "mapping", e15.result = d3), y2;
          }(e14, h2, m2)) || function(e15, t4) {
            var n3, r2, a3, o3, s3, c3, l2, u3, d3, f3, p3 = true, m3 = e15.tag, h3 = e15.anchor, g2 = {};
            if ((f3 = e15.input.charCodeAt(e15.position)) === 91)
              a3 = 93, c3 = false, r2 = [];
            else {
              if (f3 !== 123)
                return false;
              a3 = 125, c3 = true, r2 = {};
            }
            for (e15.anchor !== null && (e15.anchorMap[e15.anchor] = r2), f3 = e15.input.charCodeAt(++e15.position); f3 !== 0; ) {
              if (I(e15, true, t4), (f3 = e15.input.charCodeAt(e15.position)) === a3)
                return e15.position++, e15.tag = m3, e15.anchor = h3, e15.kind = c3 ? "mapping" : "sequence", e15.result = r2, true;
              p3 || k(e15, "missed comma between flow collection entries"), d3 = null, o3 = s3 = false, f3 === 63 && v(e15.input.charCodeAt(e15.position + 1)) && (o3 = s3 = true, e15.position++, I(e15, true, t4)), n3 = e15.line, H(e15, t4, 1, false, true), u3 = e15.tag, l2 = e15.result, I(e15, true, t4), f3 = e15.input.charCodeAt(e15.position), !s3 && e15.line !== n3 || f3 !== 58 || (o3 = true, f3 = e15.input.charCodeAt(++e15.position), I(e15, true, t4), H(e15, t4, 1, false, true), d3 = e15.result), c3 ? P(e15, r2, g2, u3, l2, d3) : o3 ? r2.push(P(e15, null, g2, u3, l2, d3)) : r2.push(l2), I(e15, true, t4), (f3 = e15.input.charCodeAt(e15.position)) === 44 ? (p3 = true, f3 = e15.input.charCodeAt(++e15.position)) : p3 = false;
            }
            k(e15, "unexpected end of the stream within a flow collection");
          }(e14, m2) ? D2 = true : (c2 && function(e15, t4) {
            var n3, a3, o3, s3, c3, l2 = 1, u3 = false, d3 = false, f3 = t4, p3 = 0, m3 = false;
            if ((s3 = e15.input.charCodeAt(e15.position)) === 124)
              a3 = false;
            else {
              if (s3 !== 62)
                return false;
              a3 = true;
            }
            for (e15.kind = "scalar", e15.result = ""; s3 !== 0; )
              if ((s3 = e15.input.charCodeAt(++e15.position)) === 43 || s3 === 45)
                l2 === 1 ? l2 = s3 === 43 ? 3 : 2 : k(e15, "repeat of a chomping mode identifier");
              else {
                if (!((o3 = 48 <= (c3 = s3) && c3 <= 57 ? c3 - 48 : -1) >= 0))
                  break;
                o3 === 0 ? k(e15, "bad explicit indentation width of a block scalar; it cannot be less than one") : d3 ? k(e15, "repeat of an indentation width identifier") : (f3 = t4 + o3 - 1, d3 = true);
              }
            if (_(s3)) {
              do
                s3 = e15.input.charCodeAt(++e15.position);
              while (_(s3));
              if (s3 === 35)
                do
                  s3 = e15.input.charCodeAt(++e15.position);
                while (!g(s3) && s3 !== 0);
            }
            for (; s3 !== 0; ) {
              for (F(e15), e15.lineIndent = 0, s3 = e15.input.charCodeAt(e15.position); (!d3 || e15.lineIndent < f3) && s3 === 32; )
                e15.lineIndent++, s3 = e15.input.charCodeAt(++e15.position);
              if (!d3 && e15.lineIndent > f3 && (f3 = e15.lineIndent), g(s3))
                p3++;
              else {
                if (e15.lineIndent < f3) {
                  l2 === 3 ? e15.result += r.repeat("\n", u3 ? 1 + p3 : p3) : l2 === 1 && u3 && (e15.result += "\n");
                  break;
                }
                for (a3 ? _(s3) ? (m3 = true, e15.result += r.repeat("\n", u3 ? 1 + p3 : p3)) : m3 ? (m3 = false, e15.result += r.repeat("\n", p3 + 1)) : p3 === 0 ? u3 && (e15.result += " ") : e15.result += r.repeat("\n", p3) : e15.result += r.repeat("\n", u3 ? 1 + p3 : p3), u3 = true, d3 = true, p3 = 0, n3 = e15.position; !g(s3) && s3 !== 0; )
                  s3 = e15.input.charCodeAt(++e15.position);
                M(e15, n3, e15.position, false);
              }
            }
            return true;
          }(e14, m2) || function(e15, t4) {
            var n3, r2, a3;
            if ((n3 = e15.input.charCodeAt(e15.position)) !== 39)
              return false;
            for (e15.kind = "scalar", e15.result = "", e15.position++, r2 = a3 = e15.position; (n3 = e15.input.charCodeAt(e15.position)) !== 0; )
              if (n3 === 39) {
                if (M(e15, r2, e15.position, true), (n3 = e15.input.charCodeAt(++e15.position)) !== 39)
                  return true;
                r2 = e15.position, e15.position++, a3 = e15.position;
              } else
                g(n3) ? (M(e15, r2, a3, true), R(e15, I(e15, false, t4)), r2 = a3 = e15.position) : e15.position === e15.lineStart && L(e15) ? k(e15, "unexpected end of the document within a single quoted scalar") : (e15.position++, a3 = e15.position);
            k(e15, "unexpected end of the stream within a single quoted scalar");
          }(e14, m2) || function(e15, t4) {
            var n3, r2, a3, o3, s3, c3, l2;
            if ((c3 = e15.input.charCodeAt(e15.position)) !== 34)
              return false;
            for (e15.kind = "scalar", e15.result = "", e15.position++, n3 = r2 = e15.position; (c3 = e15.input.charCodeAt(e15.position)) !== 0; ) {
              if (c3 === 34)
                return M(e15, n3, e15.position, true), e15.position++, true;
              if (c3 === 92) {
                if (M(e15, n3, e15.position, true), g(c3 = e15.input.charCodeAt(++e15.position)))
                  I(e15, false, t4);
                else if (c3 < 256 && w[c3])
                  e15.result += T[c3], e15.position++;
                else if ((s3 = (l2 = c3) === 120 ? 2 : l2 === 117 ? 4 : l2 === 85 ? 8 : 0) > 0) {
                  for (a3 = s3, o3 = 0; a3 > 0; a3--)
                    (s3 = b(c3 = e15.input.charCodeAt(++e15.position))) >= 0 ? o3 = (o3 << 4) + s3 : k(e15, "expected hexadecimal character");
                  e15.result += C(o3), e15.position++;
                } else
                  k(e15, "unknown escape sequence");
                n3 = r2 = e15.position;
              } else
                g(c3) ? (M(e15, n3, r2, true), R(e15, I(e15, false, t4)), n3 = r2 = e15.position) : e15.position === e15.lineStart && L(e15) ? k(e15, "unexpected end of the document within a double quoted scalar") : (e15.position++, r2 = e15.position);
            }
            k(e15, "unexpected end of the stream within a double quoted scalar");
          }(e14, m2) ? D2 = true : function(e15) {
            var t4, n3, r2;
            if ((r2 = e15.input.charCodeAt(e15.position)) !== 42)
              return false;
            for (r2 = e15.input.charCodeAt(++e15.position), t4 = e15.position; r2 !== 0 && !v(r2) && !y(r2); )
              r2 = e15.input.charCodeAt(++e15.position);
            return e15.position === t4 && k(e15, "name of an alias node must contain at least one character"), n3 = e15.input.slice(t4, e15.position), e15.anchorMap.hasOwnProperty(n3) || k(e15, 'unidentified alias "' + n3 + '"'), e15.result = e15.anchorMap[n3], I(e15, true, -1), true;
          }(e14) ? (D2 = true, e14.tag === null && e14.anchor === null || k(e14, "alias node should not have any properties")) : function(e15, t4, n3) {
            var r2, a3, o3, s3, c3, l2, u3, d3, f3 = e15.kind, p3 = e15.result;
            if (v(d3 = e15.input.charCodeAt(e15.position)) || y(d3) || d3 === 35 || d3 === 38 || d3 === 42 || d3 === 33 || d3 === 124 || d3 === 62 || d3 === 39 || d3 === 34 || d3 === 37 || d3 === 64 || d3 === 96 || (d3 === 63 || d3 === 45) && (v(r2 = e15.input.charCodeAt(e15.position + 1)) || n3 && y(r2)))
              return false;
            for (e15.kind = "scalar", e15.result = "", a3 = o3 = e15.position, s3 = false; d3 !== 0; ) {
              if (d3 === 58) {
                if (v(r2 = e15.input.charCodeAt(e15.position + 1)) || n3 && y(r2))
                  break;
              } else if (d3 === 35) {
                if (v(e15.input.charCodeAt(e15.position - 1)))
                  break;
              } else {
                if (e15.position === e15.lineStart && L(e15) || n3 && y(d3))
                  break;
                if (g(d3)) {
                  if (c3 = e15.line, l2 = e15.lineStart, u3 = e15.lineIndent, I(e15, false, -1), e15.lineIndent >= t4) {
                    s3 = true, d3 = e15.input.charCodeAt(e15.position);
                    continue;
                  }
                  e15.position = o3, e15.line = c3, e15.lineStart = l2, e15.lineIndent = u3;
                  break;
                }
              }
              s3 &&= (M(e15, a3, o3, false), R(e15, e15.line - c3), a3 = o3 = e15.position, false), _(d3) || (o3 = e15.position + 1), d3 = e15.input.charCodeAt(++e15.position);
            }
            return M(e15, a3, o3, false), !!e15.result || (e15.kind = f3, e15.result = p3, false);
          }(e14, m2, n2 === 1) && (D2 = true, e14.tag === null && (e14.tag = "?")), e14.anchor !== null && (e14.anchorMap[e14.anchor] = e14.result)) : S2 === 0 && (D2 = u2 && z(e14, h2))), e14.tag !== null && e14.tag !== "!")
            if (e14.tag === "?") {
              for (e14.result !== null && e14.kind !== "scalar" && k(e14, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + e14.kind + '"'), d2 = 0, f2 = e14.implicitTypes.length; d2 < f2; d2 += 1)
                if ((p2 = e14.implicitTypes[d2]).resolve(e14.result)) {
                  e14.result = p2.construct(e14.result), e14.tag = p2.tag, e14.anchor !== null && (e14.anchorMap[e14.anchor] = e14.result);
                  break;
                }
            } else
              l.call(e14.typeMap[e14.kind || "fallback"], e14.tag) ? (p2 = e14.typeMap[e14.kind || "fallback"][e14.tag], e14.result !== null && p2.kind !== e14.kind && k(e14, "unacceptable node kind for !<" + e14.tag + '> tag; it should be "' + p2.kind + '", not "' + e14.kind + '"'), p2.resolve(e14.result) ? (e14.result = p2.construct(e14.result), e14.anchor !== null && (e14.anchorMap[e14.anchor] = e14.result)) : k(e14, "cannot resolve a node with !<" + e14.tag + "> explicit tag")) : k(e14, "unknown tag !<" + e14.tag + ">");
          return e14.listener !== null && e14.listener("close", e14), e14.tag !== null || e14.anchor !== null || D2;
        }
        function U(e14) {
          var t3, n2, r2, a2, o2 = e14.position, s2 = false;
          for (e14.version = null, e14.checkLineBreaks = e14.legacy, e14.tagMap = {}, e14.anchorMap = {}; (a2 = e14.input.charCodeAt(e14.position)) !== 0 && (I(e14, true, -1), a2 = e14.input.charCodeAt(e14.position), !(e14.lineIndent > 0 || a2 !== 37)); ) {
            for (s2 = true, a2 = e14.input.charCodeAt(++e14.position), t3 = e14.position; a2 !== 0 && !v(a2); )
              a2 = e14.input.charCodeAt(++e14.position);
            for (r2 = [], (n2 = e14.input.slice(t3, e14.position)).length < 1 && k(e14, "directive name must not be less than one character in length"); a2 !== 0; ) {
              for (; _(a2); )
                a2 = e14.input.charCodeAt(++e14.position);
              if (a2 === 35) {
                do
                  a2 = e14.input.charCodeAt(++e14.position);
                while (a2 !== 0 && !g(a2));
                break;
              }
              if (g(a2))
                break;
              for (t3 = e14.position; a2 !== 0 && !v(a2); )
                a2 = e14.input.charCodeAt(++e14.position);
              r2.push(e14.input.slice(t3, e14.position));
            }
            a2 !== 0 && F(e14), l.call(j, n2) ? j[n2](e14, n2, r2) : A(e14, 'unknown document directive "' + n2 + '"');
          }
          I(e14, true, -1), e14.lineIndent === 0 && e14.input.charCodeAt(e14.position) === 45 && e14.input.charCodeAt(e14.position + 1) === 45 && e14.input.charCodeAt(e14.position + 2) === 45 ? (e14.position += 3, I(e14, true, -1)) : s2 && k(e14, "directives end mark is expected"), H(e14, e14.lineIndent - 1, 4, false, true), I(e14, true, -1), e14.checkLineBreaks && d.test(e14.input.slice(o2, e14.position)) && A(e14, "non-ASCII line breaks are interpreted as content"), e14.documents.push(e14.result), e14.position === e14.lineStart && L(e14) ? e14.input.charCodeAt(e14.position) === 46 && (e14.position += 3, I(e14, true, -1)) : e14.position < e14.length - 1 && k(e14, "end of the stream or a document separator is expected");
        }
        function W(e14, t3) {
          t3 ||= {}, (e14 = String(e14)).length !== 0 && (e14.charCodeAt(e14.length - 1) !== 10 && e14.charCodeAt(e14.length - 1) !== 13 && (e14 += "\n"), e14.charCodeAt(0) === 65279 && (e14 = e14.slice(1)));
          var n2 = new D(e14, t3), r2 = e14.indexOf("\0");
          for (r2 !== -1 && (n2.position = r2, k(n2, "null byte is not allowed in input")), n2.input += "\0"; n2.input.charCodeAt(n2.position) === 32; )
            n2.lineIndent += 1, n2.position += 1;
          for (; n2.position < n2.length - 1; )
            U(n2);
          return n2.documents;
        }
        function G(e14, t3, n2) {
          typeof t3 == "object" && t3 && n2 === void 0 && (n2 = t3, t3 = null);
          var r2 = W(e14, n2);
          if (typeof t3 != "function")
            return r2;
          for (var a2 = 0, o2 = r2.length; a2 < o2; a2 += 1)
            t3(r2[a2]);
        }
        function K(e14, t3) {
          var n2 = W(e14, t3);
          if (n2.length !== 0) {
            if (n2.length === 1)
              return n2[0];
            throw new a("expected a single document in the stream, but found more");
          }
        }
        e13.exports.loadAll = G, e13.exports.load = K, e13.exports.safeLoadAll = function(e14, t3, n2) {
          return typeof t3 == "object" && t3 && n2 === void 0 && (n2 = t3, t3 = null), G(e14, t3, r.extend({ schema: s }, n2));
        }, e13.exports.safeLoad = function(e14, t3) {
          return K(e14, r.extend({ schema: s }, t3));
        };
      },
      function(e13, t2, n) {
        var r = n(38);
        function a(e14, t3, n2, r2, a2) {
          this.name = e14, this.buffer = t3, this.position = n2, this.line = r2, this.column = a2;
        }
        a.prototype.getSnippet = function(e14, t3) {
          var n2, a2, o, s, c;
          if (!this.buffer)
            return null;
          for (e14 ||= 4, t3 ||= 75, n2 = "", a2 = this.position; a2 > 0 && "\0\r\n\x85\u2028\u2029".indexOf(this.buffer.charAt(a2 - 1)) === -1; )
            if (--a2, this.position - a2 > t3 / 2 - 1) {
              n2 = " ... ", a2 += 5;
              break;
            }
          for (o = "", s = this.position; s < this.buffer.length && "\0\r\n\x85\u2028\u2029".indexOf(this.buffer.charAt(s)) === -1; )
            if ((s += 1) - this.position > t3 / 2 - 1) {
              o = " ... ", s -= 5;
              break;
            }
          return c = this.buffer.slice(a2, s), r.repeat(" ", e14) + n2 + c + o + "\n" + r.repeat(" ", e14 + this.position - a2 + n2.length) + "^";
        }, a.prototype.toString = function(e14) {
          var t3, n2 = "";
          return this.name && (n2 += 'in "' + this.name + '" '), n2 += "at line " + (this.line + 1) + ", column " + (this.column + 1), e14 || (t3 = this.getSnippet()) && (n2 += ":\n" + t3), n2;
        }, e13.exports = a;
      },
      function(e13, t2, n) {
        e13.exports = new (n(10))("tag:yaml.org,2002:str", {
          kind: "scalar",
          construct: function(e14) {
            return e14 === null ? "" : e14;
          }
        });
      },
      function(e13, t2, n) {
        e13.exports = new (n(10))("tag:yaml.org,2002:seq", {
          kind: "sequence",
          construct: function(e14) {
            return e14 === null ? [] : e14;
          }
        });
      },
      function(e13, t2, n) {
        e13.exports = new (n(10))("tag:yaml.org,2002:map", {
          kind: "mapping",
          construct: function(e14) {
            return e14 === null ? {} : e14;
          }
        });
      },
      function(e13, t2, n) {
        e13.exports = new (n(10))("tag:yaml.org,2002:null", {
          kind: "scalar",
          resolve: function(e14) {
            if (e14 === null)
              return true;
            var t3 = e14.length;
            return t3 === 1 && e14 === "~" || t3 === 4 && (e14 === "null" || e14 === "Null" || e14 === "NULL");
          },
          construct: function() {
            return null;
          },
          predicate: function(e14) {
            return e14 === null;
          },
          represent: {
            canonical: function() {
              return "~";
            },
            lowercase: function() {
              return "null";
            },
            uppercase: function() {
              return "NULL";
            },
            camelcase: function() {
              return "Null";
            }
          },
          defaultStyle: "lowercase"
        });
      },
      function(e13, t2, n) {
        e13.exports = new (n(10))("tag:yaml.org,2002:bool", {
          kind: "scalar",
          resolve: function(e14) {
            if (e14 === null)
              return false;
            var t3 = e14.length;
            return t3 === 4 && (e14 === "true" || e14 === "True" || e14 === "TRUE") || t3 === 5 && (e14 === "false" || e14 === "False" || e14 === "FALSE");
          },
          construct: function(e14) {
            return e14 === "true" || e14 === "True" || e14 === "TRUE";
          },
          predicate: function(e14) {
            return Object.prototype.toString.call(e14) === "[object Boolean]";
          },
          represent: {
            lowercase: function(e14) {
              return e14 ? "true" : "false";
            },
            uppercase: function(e14) {
              return e14 ? "TRUE" : "FALSE";
            },
            camelcase: function(e14) {
              return e14 ? "True" : "False";
            }
          },
          defaultStyle: "lowercase"
        });
      },
      function(e13, t2, n) {
        var r = n(38), a = n(10);
        function o(e14) {
          return 48 <= e14 && e14 <= 55;
        }
        function s(e14) {
          return 48 <= e14 && e14 <= 57;
        }
        e13.exports = new a("tag:yaml.org,2002:int", {
          kind: "scalar",
          resolve: function(e14) {
            if (e14 === null)
              return false;
            var t3, n2, r2 = e14.length, a2 = 0, c = false;
            if (!r2)
              return false;
            if ((t3 = e14[a2]) !== "-" && t3 !== "+" || (t3 = e14[++a2]), t3 === "0") {
              if (a2 + 1 === r2)
                return true;
              if ((t3 = e14[++a2]) === "b") {
                for (a2++; a2 < r2; a2++)
                  if ((t3 = e14[a2]) !== "_") {
                    if (t3 !== "0" && t3 !== "1")
                      return false;
                    c = true;
                  }
                return c && t3 !== "_";
              }
              if (t3 === "x") {
                for (a2++; a2 < r2; a2++)
                  if ((t3 = e14[a2]) !== "_") {
                    if (!(48 <= (n2 = e14.charCodeAt(a2)) && n2 <= 57 || 65 <= n2 && n2 <= 70 || 97 <= n2 && n2 <= 102))
                      return false;
                    c = true;
                  }
                return c && t3 !== "_";
              }
              for (; a2 < r2; a2++)
                if ((t3 = e14[a2]) !== "_") {
                  if (!o(e14.charCodeAt(a2)))
                    return false;
                  c = true;
                }
              return c && t3 !== "_";
            }
            if (t3 === "_")
              return false;
            for (; a2 < r2; a2++)
              if ((t3 = e14[a2]) !== "_") {
                if (t3 === ":")
                  break;
                if (!s(e14.charCodeAt(a2)))
                  return false;
                c = true;
              }
            return !(!c || t3 === "_") && (t3 !== ":" || /^(:[0-5]?[0-9])+$/.test(e14.slice(a2)));
          },
          construct: function(e14) {
            var t3, n2, r2 = e14, a2 = 1, o2 = [];
            return r2.indexOf("_") !== -1 && (r2 = r2.replace(/_/g, "")), (t3 = r2[0]) !== "-" && t3 !== "+" || (t3 === "-" && (a2 = -1), t3 = (r2 = r2.slice(1))[0]), r2 === "0" ? 0 : t3 === "0" ? r2[1] === "b" ? a2 * parseInt(r2.slice(2), 2) : r2[1] === "x" ? a2 * parseInt(r2, 16) : a2 * parseInt(r2, 8) : r2.indexOf(":") === -1 ? a2 * parseInt(r2, 10) : (r2.split(":").forEach(function(e15) {
              o2.unshift(parseInt(e15, 10));
            }), r2 = 0, n2 = 1, o2.forEach(function(e15) {
              r2 += e15 * n2, n2 *= 60;
            }), a2 * r2);
          },
          predicate: function(e14) {
            return Object.prototype.toString.call(e14) === "[object Number]" && e14 % 1 == 0 && !r.isNegativeZero(e14);
          },
          represent: {
            binary: function(e14) {
              return e14 >= 0 ? "0b" + e14.toString(2) : "-0b" + e14.toString(2).slice(1);
            },
            octal: function(e14) {
              return e14 >= 0 ? "0" + e14.toString(8) : "-0" + e14.toString(8).slice(1);
            },
            decimal: function(e14) {
              return e14.toString(10);
            },
            hexadecimal: function(e14) {
              return e14 >= 0 ? "0x" + e14.toString(16).toUpperCase() : "-0x" + e14.toString(16).toUpperCase().slice(1);
            }
          },
          defaultStyle: "decimal",
          styleAliases: {
            binary: [2, "bin"],
            octal: [8, "oct"],
            decimal: [10, "dec"],
            hexadecimal: [16, "hex"]
          }
        });
      },
      function(e13, t2, n) {
        var r = n(38), a = n(10), o = /* @__PURE__ */ RegExp("^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$"), s = /^[-+]?[0-9]+e/;
        e13.exports = new a("tag:yaml.org,2002:float", {
          kind: "scalar",
          resolve: function(e14) {
            return e14 !== null && !(!o.test(e14) || e14[e14.length - 1] === "_");
          },
          construct: function(e14) {
            var t3, n2, r2, a2;
            return n2 = (t3 = e14.replace(/_/g, "").toLowerCase())[0] === "-" ? -1 : 1, a2 = [], "+-".indexOf(t3[0]) >= 0 && (t3 = t3.slice(1)), t3 === ".inf" ? n2 === 1 ? Infinity : -Infinity : t3 === ".nan" ? NaN : t3.indexOf(":") >= 0 ? (t3.split(":").forEach(function(e15) {
              a2.unshift(parseFloat(e15, 10));
            }), t3 = 0, r2 = 1, a2.forEach(function(e15) {
              t3 += e15 * r2, r2 *= 60;
            }), n2 * t3) : n2 * parseFloat(t3, 10);
          },
          predicate: function(e14) {
            return Object.prototype.toString.call(e14) === "[object Number]" && (e14 % 1 != 0 || r.isNegativeZero(e14));
          },
          represent: function(e14, t3) {
            var n2;
            if (isNaN(e14))
              switch (t3) {
                case "lowercase":
                  return ".nan";
                case "uppercase":
                  return ".NAN";
                case "camelcase":
                  return ".NaN";
              }
            else if (e14 === Infinity)
              switch (t3) {
                case "lowercase":
                  return ".inf";
                case "uppercase":
                  return ".INF";
                case "camelcase":
                  return ".Inf";
              }
            else if (e14 === -Infinity)
              switch (t3) {
                case "lowercase":
                  return "-.inf";
                case "uppercase":
                  return "-.INF";
                case "camelcase":
                  return "-.Inf";
              }
            else if (r.isNegativeZero(e14))
              return "-0.0";
            return n2 = e14.toString(10), s.test(n2) ? n2.replace("e", ".e") : n2;
          },
          defaultStyle: "lowercase"
        });
      },
      function(e13, t2, n) {
        var r = n(10), a = /* @__PURE__ */ RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"), o = /* @__PURE__ */ RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$");
        e13.exports = new r("tag:yaml.org,2002:timestamp", {
          kind: "scalar",
          resolve: function(e14) {
            return e14 !== null && (a.exec(e14) !== null || o.exec(e14) !== null);
          },
          construct: function(e14) {
            var t3, n2, r2, s, c, l, u, d, f = 0, p = null;
            if ((t3 = a.exec(e14)) === null && (t3 = o.exec(e14)), t3 === null)
              throw Error("Date resolve error");
            if (n2 = +t3[1], r2 = t3[2] - 1, s = +t3[3], !t3[4])
              return new Date(Date.UTC(n2, r2, s));
            if (c = +t3[4], l = +t3[5], u = +t3[6], t3[7]) {
              for (f = t3[7].slice(0, 3); f.length < 3; )
                f += "0";
              f = +f;
            }
            return t3[9] && (p = 6e4 * (60 * t3[10] + +(t3[11] || 0)), t3[9] === "-" && (p = -p)), d = new Date(Date.UTC(n2, r2, s, c, l, u, f)), p && d.setTime(d.getTime() - p), d;
          },
          instanceOf: Date,
          represent: function(e14) {
            return e14.toISOString();
          }
        });
      },
      function(e13, t2, n) {
        e13.exports = new (n(10))("tag:yaml.org,2002:merge", {
          kind: "scalar",
          resolve: function(e14) {
            return e14 === "<<" || e14 === null;
          }
        });
      },
      function(e13, t2, n) {
        var r;
        try {
          r = n(145).Buffer;
        } catch {
        }
        var a = n(10), o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r";
        e13.exports = new a("tag:yaml.org,2002:binary", {
          kind: "scalar",
          resolve: function(e14) {
            if (e14 === null)
              return false;
            var t3, n2, r2 = 0, a2 = e14.length, s = o;
            for (n2 = 0; n2 < a2; n2++)
              if (!((t3 = s.indexOf(e14.charAt(n2))) > 64)) {
                if (t3 < 0)
                  return false;
                r2 += 6;
              }
            return r2 % 8 == 0;
          },
          construct: function(e14) {
            var t3, n2, a2 = e14.replace(/[\r\n=]/g, ""), s = a2.length, c = o, l = 0, u = [];
            for (t3 = 0; t3 < s; t3++)
              t3 % 4 == 0 && t3 && (u.push(l >> 16 & 255), u.push(l >> 8 & 255), u.push(255 & l)), l = l << 6 | c.indexOf(a2.charAt(t3));
            return (n2 = s % 4 * 6) == 0 ? (u.push(l >> 16 & 255), u.push(l >> 8 & 255), u.push(255 & l)) : n2 === 18 ? (u.push(l >> 10 & 255), u.push(l >> 2 & 255)) : n2 === 12 && u.push(l >> 4 & 255), r ? r.from ? r.from(u) : new r(u) : u;
          },
          predicate: function(e14) {
            return r && r.isBuffer(e14);
          },
          represent: function(e14) {
            var t3, n2, r2 = "", a2 = 0, s = e14.length, c = o;
            for (t3 = 0; t3 < s; t3++)
              t3 % 3 == 0 && t3 && (r2 += c[a2 >> 18 & 63], r2 += c[a2 >> 12 & 63], r2 += c[a2 >> 6 & 63], r2 += c[63 & a2]), a2 = (a2 << 8) + e14[t3];
            return (n2 = s % 3) == 0 ? (r2 += c[a2 >> 18 & 63], r2 += c[a2 >> 12 & 63], r2 += c[a2 >> 6 & 63], r2 += c[63 & a2]) : n2 === 2 ? (r2 += c[a2 >> 10 & 63], r2 += c[a2 >> 4 & 63], r2 += c[a2 << 2 & 63], r2 += c[64]) : n2 === 1 && (r2 += c[a2 >> 2 & 63], r2 += c[a2 << 4 & 63], r2 += c[64], r2 += c[64]), r2;
          }
        });
      },
      function(e13, t2, n) {
        var r = n(10), a = Object.prototype.hasOwnProperty, o = Object.prototype.toString;
        e13.exports = new r("tag:yaml.org,2002:omap", {
          kind: "sequence",
          resolve: function(e14) {
            if (e14 === null)
              return true;
            var t3, n2, r2, s, c, l = [], u = e14;
            for (t3 = 0, n2 = u.length; t3 < n2; t3 += 1) {
              if (r2 = u[t3], c = false, o.call(r2) !== "[object Object]")
                return false;
              for (s in r2)
                if (a.call(r2, s)) {
                  if (c)
                    return false;
                  c = true;
                }
              if (!c || l.indexOf(s) !== -1)
                return false;
              l.push(s);
            }
            return true;
          },
          construct: function(e14) {
            return e14 === null ? [] : e14;
          }
        });
      },
      function(e13, t2, n) {
        var r = n(10), a = Object.prototype.toString;
        e13.exports = new r("tag:yaml.org,2002:pairs", {
          kind: "sequence",
          resolve: function(e14) {
            if (e14 === null)
              return true;
            var t3, n2, r2, o, s, c = e14;
            for (s = Array(c.length), t3 = 0, n2 = c.length; t3 < n2; t3 += 1) {
              if (r2 = c[t3], a.call(r2) !== "[object Object]" || (o = Object.keys(r2)).length !== 1)
                return false;
              s[t3] = [o[0], r2[o[0]]];
            }
            return true;
          },
          construct: function(e14) {
            if (e14 === null)
              return [];
            var t3, n2, r2, a2, o, s = e14;
            for (o = Array(s.length), t3 = 0, n2 = s.length; t3 < n2; t3 += 1)
              r2 = s[t3], a2 = Object.keys(r2), o[t3] = [a2[0], r2[a2[0]]];
            return o;
          }
        });
      },
      function(e13, t2, n) {
        var r = n(10), a = Object.prototype.hasOwnProperty;
        e13.exports = new r("tag:yaml.org,2002:set", {
          kind: "mapping",
          resolve: function(e14) {
            if (e14 === null)
              return true;
            var t3, n2 = e14;
            for (t3 in n2)
              if (a.call(n2, t3) && n2[t3] !== null)
                return false;
            return true;
          },
          construct: function(e14) {
            return e14 === null ? {} : e14;
          }
        });
      },
      function(e13, t2, n) {
        e13.exports = new (n(10))("tag:yaml.org,2002:js/undefined", {
          kind: "scalar",
          resolve: function() {
            return true;
          },
          construct: function() {
          },
          predicate: function(e14) {
            return e14 === void 0;
          },
          represent: function() {
            return "";
          }
        });
      },
      function(e13, t2, n) {
        e13.exports = new (n(10))("tag:yaml.org,2002:js/regexp", {
          kind: "scalar",
          resolve: function(e14) {
            if (e14 === null || e14.length === 0)
              return false;
            var t3 = e14, n2 = /\/([gim]*)$/.exec(e14), r = "";
            return !(t3[0] === "/" && (n2 && (r = n2[1]), r.length > 3 || t3[t3.length - r.length - 1] !== "/"));
          },
          construct: function(e14) {
            var t3 = e14, n2 = /\/([gim]*)$/.exec(e14), r = "";
            return t3[0] === "/" && (n2 && (r = n2[1]), t3 = t3.slice(1, t3.length - r.length - 1)), new RegExp(t3, r);
          },
          predicate: function(e14) {
            return Object.prototype.toString.call(e14) === "[object RegExp]";
          },
          represent: function(e14) {
            var t3 = "/" + e14.source + "/";
            return e14.global && (t3 += "g"), e14.multiline && (t3 += "m"), e14.ignoreCase && (t3 += "i"), t3;
          }
        });
      },
      function(e13, t2, n) {
        var r;
        try {
          r = n(302);
        } catch {
          typeof window < "u" && (r = window.esprima);
        }
        e13.exports = new (n(10))("tag:yaml.org,2002:js/function", {
          kind: "scalar",
          resolve: function(e14) {
            if (e14 === null)
              return false;
            try {
              var t3 = "(" + e14 + ")", n2 = r.parse(t3, { range: true });
              return n2.type === "Program" && n2.body.length === 1 && n2.body[0].type === "ExpressionStatement" && (n2.body[0].expression.type === "ArrowFunctionExpression" || n2.body[0].expression.type === "FunctionExpression");
            } catch {
              return false;
            }
          },
          construct: function(e14) {
            var t3, n2 = "(" + e14 + ")", a = r.parse(n2, { range: true }), o = [];
            if (a.type !== "Program" || a.body.length !== 1 || a.body[0].type !== "ExpressionStatement" || a.body[0].expression.type !== "ArrowFunctionExpression" && a.body[0].expression.type !== "FunctionExpression")
              throw Error("Failed to resolve function");
            return a.body[0].expression.params.forEach(function(e15) {
              o.push(e15.name);
            }), t3 = a.body[0].expression.body.range, a.body[0].expression.body.type === "BlockStatement" ? Function(o, n2.slice(t3[0] + 1, t3[1] - 1)) : Function(o, "return " + n2.slice(t3[0], t3[1]));
          },
          predicate: function(e14) {
            return Object.prototype.toString.call(e14) === "[object Function]";
          },
          represent: function(e14) {
            return e14.toString();
          }
        });
      },
      function(e13, t2, n) {
        e13.exports = function() {
          return function(e14) {
            var t3 = {};
            function n2(r) {
              if (t3[r])
                return t3[r].exports;
              var a = t3[r] = {
                exports: {},
                id: r,
                loaded: false
              };
              return e14[r].call(a.exports, a, a.exports, n2), a.loaded = true, a.exports;
            }
            return n2.m = e14, n2.c = t3, n2.p = "", n2(0);
          }([
            function(e14, t3, n2) {
              Object.defineProperty(t3, "__esModule", { value: true });
              var r = n2(1), a = n2(3), o = n2(8), s = n2(15);
              function c(e15, t4, n3) {
                var s2 = null, c2 = function(e16, t5) {
                  n3 && n3(e16, t5), s2 && s2.visit(e16, t5);
                }, l = typeof n3 == "function" ? c2 : null, u = false;
                if (t4) {
                  u = typeof t4.comment == "boolean" && t4.comment;
                  var d = typeof t4.attachComment == "boolean" && t4.attachComment;
                  (u || d) && ((s2 = new r.CommentHandler()).attach = d, t4.comment = true, l = c2);
                }
                var f, p = false;
                t4 && typeof t4.sourceType == "string" && (p = t4.sourceType === "module"), f = t4 && typeof t4.jsx == "boolean" && t4.jsx ? new a.JSXParser(e15, t4, l) : new o.Parser(e15, t4, l);
                var m = p ? f.parseModule() : f.parseScript();
                return u && s2 && (m.comments = s2.comments), f.config.tokens && (m.tokens = f.tokens), f.config.tolerant && (m.errors = f.errorHandler.errors), m;
              }
              t3.parse = c, t3.parseModule = function(e15, t4, n3) {
                var r2 = t4 || {};
                return r2.sourceType = "module", c(e15, r2, n3);
              }, t3.parseScript = function(e15, t4, n3) {
                var r2 = t4 || {};
                return r2.sourceType = "script", c(e15, r2, n3);
              }, t3.tokenize = function(e15, t4, n3) {
                var r2, a2 = new s.Tokenizer(e15, t4);
                r2 = [];
                try {
                  for (; ; ) {
                    var o2 = a2.getNextToken();
                    if (!o2)
                      break;
                    n3 && (o2 = n3(o2)), r2.push(o2);
                  }
                } catch (e16) {
                  a2.errorHandler.tolerate(e16);
                }
                return a2.errorHandler.tolerant && (r2.errors = a2.errors()), r2;
              }, t3.Syntax = n2(2).Syntax, t3.version = "4.0.1";
            },
            function(e14, t3, n2) {
              Object.defineProperty(t3, "__esModule", { value: true });
              var r = n2(2);
              t3.CommentHandler = function() {
                function e15() {
                  this.attach = false, this.comments = [], this.stack = [], this.leading = [], this.trailing = [];
                }
                return e15.prototype.insertInnerComments = function(e16, t4) {
                  if (e16.type === r.Syntax.BlockStatement && e16.body.length === 0) {
                    for (var n3 = [], a = this.leading.length - 1; a >= 0; --a) {
                      var o = this.leading[a];
                      t4.end.offset >= o.start && (n3.unshift(o.comment), this.leading.splice(a, 1), this.trailing.splice(a, 1));
                    }
                    n3.length && (e16.innerComments = n3);
                  }
                }, e15.prototype.findTrailingComments = function(e16) {
                  var t4 = [];
                  if (this.trailing.length > 0) {
                    for (var n3 = this.trailing.length - 1; n3 >= 0; --n3) {
                      var r2 = this.trailing[n3];
                      r2.start >= e16.end.offset && t4.unshift(r2.comment);
                    }
                    return this.trailing.length = 0, t4;
                  }
                  var a = this.stack[this.stack.length - 1];
                  if (a && a.node.trailingComments) {
                    var o = a.node.trailingComments[0];
                    o && o.range[0] >= e16.end.offset && (t4 = a.node.trailingComments, delete a.node.trailingComments);
                  }
                  return t4;
                }, e15.prototype.findLeadingComments = function(e16) {
                  for (var t4, n3 = []; this.stack.length > 0 && (o = this.stack[this.stack.length - 1]) && o.start >= e16.start.offset; )
                    t4 = o.node, this.stack.pop();
                  if (t4) {
                    for (var r2 = (t4.leadingComments ? t4.leadingComments.length : 0) - 1; r2 >= 0; --r2) {
                      var a = t4.leadingComments[r2];
                      a.range[1] <= e16.start.offset && (n3.unshift(a), t4.leadingComments.splice(r2, 1));
                    }
                    return t4.leadingComments && t4.leadingComments.length === 0 && delete t4.leadingComments, n3;
                  }
                  for (r2 = this.leading.length - 1; r2 >= 0; --r2) {
                    var o;
                    (o = this.leading[r2]).start <= e16.start.offset && (n3.unshift(o.comment), this.leading.splice(r2, 1));
                  }
                  return n3;
                }, e15.prototype.visitNode = function(e16, t4) {
                  if (!(e16.type === r.Syntax.Program && e16.body.length > 0)) {
                    this.insertInnerComments(e16, t4);
                    var n3 = this.findTrailingComments(t4), a = this.findLeadingComments(t4);
                    a.length > 0 && (e16.leadingComments = a), n3.length > 0 && (e16.trailingComments = n3), this.stack.push({
                      node: e16,
                      start: t4.start.offset
                    });
                  }
                }, e15.prototype.visitComment = function(e16, t4) {
                  var n3 = e16.type[0] === "L" ? "Line" : "Block", r2 = {
                    type: n3,
                    value: e16.value
                  };
                  if (e16.range && (r2.range = e16.range), e16.loc && (r2.loc = e16.loc), this.comments.push(r2), this.attach) {
                    var a = {
                      comment: {
                        type: n3,
                        value: e16.value,
                        range: [t4.start.offset, t4.end.offset]
                      },
                      start: t4.start.offset
                    };
                    e16.loc && (a.comment.loc = e16.loc), e16.type = n3, this.leading.push(a), this.trailing.push(a);
                  }
                }, e15.prototype.visit = function(e16, t4) {
                  e16.type === "LineComment" || e16.type === "BlockComment" ? this.visitComment(e16, t4) : this.attach && this.visitNode(e16, t4);
                }, e15;
              }();
            },
            function(e14, t3) {
              Object.defineProperty(t3, "__esModule", { value: true }), t3.Syntax = {
                AssignmentExpression: "AssignmentExpression",
                AssignmentPattern: "AssignmentPattern",
                ArrayExpression: "ArrayExpression",
                ArrayPattern: "ArrayPattern",
                ArrowFunctionExpression: "ArrowFunctionExpression",
                AwaitExpression: "AwaitExpression",
                BlockStatement: "BlockStatement",
                BinaryExpression: "BinaryExpression",
                BreakStatement: "BreakStatement",
                CallExpression: "CallExpression",
                CatchClause: "CatchClause",
                ClassBody: "ClassBody",
                ClassDeclaration: "ClassDeclaration",
                ClassExpression: "ClassExpression",
                ConditionalExpression: "ConditionalExpression",
                ContinueStatement: "ContinueStatement",
                DoWhileStatement: "DoWhileStatement",
                DebuggerStatement: "DebuggerStatement",
                EmptyStatement: "EmptyStatement",
                ExportAllDeclaration: "ExportAllDeclaration",
                ExportDefaultDeclaration: "ExportDefaultDeclaration",
                ExportNamedDeclaration: "ExportNamedDeclaration",
                ExportSpecifier: "ExportSpecifier",
                ExpressionStatement: "ExpressionStatement",
                ForStatement: "ForStatement",
                ForOfStatement: "ForOfStatement",
                ForInStatement: "ForInStatement",
                FunctionDeclaration: "FunctionDeclaration",
                FunctionExpression: "FunctionExpression",
                Identifier: "Identifier",
                IfStatement: "IfStatement",
                ImportDeclaration: "ImportDeclaration",
                ImportDefaultSpecifier: "ImportDefaultSpecifier",
                ImportNamespaceSpecifier: "ImportNamespaceSpecifier",
                ImportSpecifier: "ImportSpecifier",
                Literal: "Literal",
                LabeledStatement: "LabeledStatement",
                LogicalExpression: "LogicalExpression",
                MemberExpression: "MemberExpression",
                MetaProperty: "MetaProperty",
                MethodDefinition: "MethodDefinition",
                NewExpression: "NewExpression",
                ObjectExpression: "ObjectExpression",
                ObjectPattern: "ObjectPattern",
                Program: "Program",
                Property: "Property",
                RestElement: "RestElement",
                ReturnStatement: "ReturnStatement",
                SequenceExpression: "SequenceExpression",
                SpreadElement: "SpreadElement",
                Super: "Super",
                SwitchCase: "SwitchCase",
                SwitchStatement: "SwitchStatement",
                TaggedTemplateExpression: "TaggedTemplateExpression",
                TemplateElement: "TemplateElement",
                TemplateLiteral: "TemplateLiteral",
                ThisExpression: "ThisExpression",
                ThrowStatement: "ThrowStatement",
                TryStatement: "TryStatement",
                UnaryExpression: "UnaryExpression",
                UpdateExpression: "UpdateExpression",
                VariableDeclaration: "VariableDeclaration",
                VariableDeclarator: "VariableDeclarator",
                WhileStatement: "WhileStatement",
                WithStatement: "WithStatement",
                YieldExpression: "YieldExpression"
              };
            },
            function(e14, t3, n2) {
              var r, a = this && this.__extends || (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
                e15.__proto__ = t4;
              } || function(e15, t4) {
                for (var n3 in t4)
                  t4.hasOwnProperty(n3) && (e15[n3] = t4[n3]);
              }, function(e15, t4) {
                function n3() {
                  this.constructor = e15;
                }
                r(e15, t4), e15.prototype = t4 === null ? Object.create(t4) : (n3.prototype = t4.prototype, new n3());
              });
              Object.defineProperty(t3, "__esModule", { value: true });
              var o = n2(4), s = n2(5), c = n2(6), l = n2(7), u = n2(8), d = n2(13), f = n2(14);
              function p(e15) {
                var t4;
                switch (e15.type) {
                  case c.JSXSyntax.JSXIdentifier:
                    t4 = e15.name;
                    break;
                  case c.JSXSyntax.JSXNamespacedName:
                    var n3 = e15;
                    t4 = p(n3.namespace) + ":" + p(n3.name);
                    break;
                  case c.JSXSyntax.JSXMemberExpression:
                    var r2 = e15;
                    t4 = p(r2.object) + "." + p(r2.property);
                }
                return t4;
              }
              d.TokenName[100] = "JSXIdentifier", d.TokenName[101] = "JSXText", t3.JSXParser = function(e15) {
                function t4(t5, n3, r2) {
                  return e15.call(this, t5, n3, r2) || this;
                }
                return a(t4, e15), t4.prototype.parsePrimaryExpression = function() {
                  return this.match("<") ? this.parseJSXRoot() : e15.prototype.parsePrimaryExpression.call(this);
                }, t4.prototype.startJSX = function() {
                  this.scanner.index = this.startMarker.index, this.scanner.lineNumber = this.startMarker.line, this.scanner.lineStart = this.startMarker.index - this.startMarker.column;
                }, t4.prototype.finishJSX = function() {
                  this.nextToken();
                }, t4.prototype.reenterJSX = function() {
                  this.startJSX(), this.expectJSX("}"), this.config.tokens && this.tokens.pop();
                }, t4.prototype.createJSXNode = function() {
                  return this.collectComments(), {
                    index: this.scanner.index,
                    line: this.scanner.lineNumber,
                    column: this.scanner.index - this.scanner.lineStart
                  };
                }, t4.prototype.createJSXChildNode = function() {
                  return {
                    index: this.scanner.index,
                    line: this.scanner.lineNumber,
                    column: this.scanner.index - this.scanner.lineStart
                  };
                }, t4.prototype.scanXHTMLEntity = function(e16) {
                  for (var t5 = "&", n3 = true, r2 = false, a2 = false, s2 = false; !this.scanner.eof() && n3 && !r2; ) {
                    var c2 = this.scanner.source[this.scanner.index];
                    if (c2 === e16)
                      break;
                    if (r2 = c2 === ";", t5 += c2, ++this.scanner.index, !r2)
                      switch (t5.length) {
                        case 2:
                          a2 = c2 === "#";
                          break;
                        case 3:
                          a2 && (n3 = (s2 = c2 === "x") || o.Character.isDecimalDigit(c2.charCodeAt(0)), a2 &&= !s2);
                          break;
                        default:
                          n3 = (n3 &&= !(a2 && !o.Character.isDecimalDigit(c2.charCodeAt(0)))) && !(s2 && !o.Character.isHexDigit(c2.charCodeAt(0)));
                      }
                  }
                  if (n3 && r2 && t5.length > 2) {
                    var l2 = t5.substr(1, t5.length - 2);
                    a2 && l2.length > 1 ? t5 = String.fromCharCode(parseInt(l2.substr(1), 10)) : s2 && l2.length > 2 ? t5 = String.fromCharCode(parseInt("0" + l2.substr(1), 16)) : a2 || s2 || !f.XHTMLEntities[l2] || (t5 = f.XHTMLEntities[l2]);
                  }
                  return t5;
                }, t4.prototype.lexJSX = function() {
                  var e16 = this.scanner.source.charCodeAt(this.scanner.index);
                  if (e16 === 60 || e16 === 62 || e16 === 47 || e16 === 58 || e16 === 61 || e16 === 123 || e16 === 125)
                    return {
                      type: 7,
                      value: c2 = this.scanner.source[this.scanner.index++],
                      lineNumber: this.scanner.lineNumber,
                      lineStart: this.scanner.lineStart,
                      start: this.scanner.index - 1,
                      end: this.scanner.index
                    };
                  if (e16 === 34 || e16 === 39) {
                    for (var t5 = this.scanner.index, n3 = this.scanner.source[this.scanner.index++], r2 = ""; !this.scanner.eof() && (l2 = this.scanner.source[this.scanner.index++]) !== n3; )
                      r2 += l2 === "&" ? this.scanXHTMLEntity(n3) : l2;
                    return {
                      type: 8,
                      value: r2,
                      lineNumber: this.scanner.lineNumber,
                      lineStart: this.scanner.lineStart,
                      start: t5,
                      end: this.scanner.index
                    };
                  }
                  if (e16 === 46) {
                    var a2 = this.scanner.source.charCodeAt(this.scanner.index + 1), s2 = this.scanner.source.charCodeAt(this.scanner.index + 2), c2 = a2 === 46 && s2 === 46 ? "..." : ".";
                    return t5 = this.scanner.index, this.scanner.index += c2.length, {
                      type: 7,
                      value: c2,
                      lineNumber: this.scanner.lineNumber,
                      lineStart: this.scanner.lineStart,
                      start: t5,
                      end: this.scanner.index
                    };
                  }
                  if (e16 === 96)
                    return {
                      type: 10,
                      value: "",
                      lineNumber: this.scanner.lineNumber,
                      lineStart: this.scanner.lineStart,
                      start: this.scanner.index,
                      end: this.scanner.index
                    };
                  if (o.Character.isIdentifierStart(e16) && e16 !== 92) {
                    for (t5 = this.scanner.index, ++this.scanner.index; !this.scanner.eof(); ) {
                      var l2 = this.scanner.source.charCodeAt(this.scanner.index);
                      if (o.Character.isIdentifierPart(l2) && l2 !== 92)
                        ++this.scanner.index;
                      else {
                        if (l2 !== 45)
                          break;
                        ++this.scanner.index;
                      }
                    }
                    return {
                      type: 100,
                      value: this.scanner.source.slice(t5, this.scanner.index),
                      lineNumber: this.scanner.lineNumber,
                      lineStart: this.scanner.lineStart,
                      start: t5,
                      end: this.scanner.index
                    };
                  }
                  return this.scanner.lex();
                }, t4.prototype.nextJSXToken = function() {
                  this.collectComments(), this.startMarker.index = this.scanner.index, this.startMarker.line = this.scanner.lineNumber, this.startMarker.column = this.scanner.index - this.scanner.lineStart;
                  var e16 = this.lexJSX();
                  return this.lastMarker.index = this.scanner.index, this.lastMarker.line = this.scanner.lineNumber, this.lastMarker.column = this.scanner.index - this.scanner.lineStart, this.config.tokens && this.tokens.push(this.convertToken(e16)), e16;
                }, t4.prototype.nextJSXText = function() {
                  this.startMarker.index = this.scanner.index, this.startMarker.line = this.scanner.lineNumber, this.startMarker.column = this.scanner.index - this.scanner.lineStart;
                  for (var e16 = this.scanner.index, t5 = ""; !this.scanner.eof(); ) {
                    var n3 = this.scanner.source[this.scanner.index];
                    if (n3 === "{" || n3 === "<")
                      break;
                    ++this.scanner.index, t5 += n3, o.Character.isLineTerminator(n3.charCodeAt(0)) && (++this.scanner.lineNumber, n3 === "\r" && this.scanner.source[this.scanner.index] === "\n" && ++this.scanner.index, this.scanner.lineStart = this.scanner.index);
                  }
                  this.lastMarker.index = this.scanner.index, this.lastMarker.line = this.scanner.lineNumber, this.lastMarker.column = this.scanner.index - this.scanner.lineStart;
                  var r2 = {
                    type: 101,
                    value: t5,
                    lineNumber: this.scanner.lineNumber,
                    lineStart: this.scanner.lineStart,
                    start: e16,
                    end: this.scanner.index
                  };
                  return t5.length > 0 && this.config.tokens && this.tokens.push(this.convertToken(r2)), r2;
                }, t4.prototype.peekJSXToken = function() {
                  var e16 = this.scanner.saveState();
                  this.scanner.scanComments();
                  var t5 = this.lexJSX();
                  return this.scanner.restoreState(e16), t5;
                }, t4.prototype.expectJSX = function(e16) {
                  var t5 = this.nextJSXToken();
                  t5.type === 7 && t5.value === e16 || this.throwUnexpectedToken(t5);
                }, t4.prototype.matchJSX = function(e16) {
                  var t5 = this.peekJSXToken();
                  return t5.type === 7 && t5.value === e16;
                }, t4.prototype.parseJSXIdentifier = function() {
                  var e16 = this.createJSXNode(), t5 = this.nextJSXToken();
                  return t5.type !== 100 && this.throwUnexpectedToken(t5), this.finalize(e16, new s.JSXIdentifier(t5.value));
                }, t4.prototype.parseJSXElementName = function() {
                  var e16 = this.createJSXNode(), t5 = this.parseJSXIdentifier();
                  if (this.matchJSX(":")) {
                    var n3 = t5;
                    this.expectJSX(":");
                    var r2 = this.parseJSXIdentifier();
                    t5 = this.finalize(e16, new s.JSXNamespacedName(n3, r2));
                  } else if (this.matchJSX("."))
                    for (; this.matchJSX("."); ) {
                      var a2 = t5;
                      this.expectJSX(".");
                      var o2 = this.parseJSXIdentifier();
                      t5 = this.finalize(e16, new s.JSXMemberExpression(a2, o2));
                    }
                  return t5;
                }, t4.prototype.parseJSXAttributeName = function() {
                  var e16, t5 = this.createJSXNode(), n3 = this.parseJSXIdentifier();
                  if (this.matchJSX(":")) {
                    var r2 = n3;
                    this.expectJSX(":");
                    var a2 = this.parseJSXIdentifier();
                    e16 = this.finalize(t5, new s.JSXNamespacedName(r2, a2));
                  } else
                    e16 = n3;
                  return e16;
                }, t4.prototype.parseJSXStringLiteralAttribute = function() {
                  var e16 = this.createJSXNode(), t5 = this.nextJSXToken();
                  t5.type !== 8 && this.throwUnexpectedToken(t5);
                  var n3 = this.getTokenRaw(t5);
                  return this.finalize(e16, new l.Literal(t5.value, n3));
                }, t4.prototype.parseJSXExpressionAttribute = function() {
                  var e16 = this.createJSXNode();
                  this.expectJSX("{"), this.finishJSX(), this.match("}") && this.tolerateError("JSX attributes must only be assigned a non-empty expression");
                  var t5 = this.parseAssignmentExpression();
                  return this.reenterJSX(), this.finalize(e16, new s.JSXExpressionContainer(t5));
                }, t4.prototype.parseJSXAttributeValue = function() {
                  return this.matchJSX("{") ? this.parseJSXExpressionAttribute() : this.matchJSX("<") ? this.parseJSXElement() : this.parseJSXStringLiteralAttribute();
                }, t4.prototype.parseJSXNameValueAttribute = function() {
                  var e16 = this.createJSXNode(), t5 = this.parseJSXAttributeName(), n3 = null;
                  return this.matchJSX("=") && (this.expectJSX("="), n3 = this.parseJSXAttributeValue()), this.finalize(e16, new s.JSXAttribute(t5, n3));
                }, t4.prototype.parseJSXSpreadAttribute = function() {
                  var e16 = this.createJSXNode();
                  this.expectJSX("{"), this.expectJSX("..."), this.finishJSX();
                  var t5 = this.parseAssignmentExpression();
                  return this.reenterJSX(), this.finalize(e16, new s.JSXSpreadAttribute(t5));
                }, t4.prototype.parseJSXAttributes = function() {
                  for (var e16 = []; !this.matchJSX("/") && !this.matchJSX(">"); ) {
                    var t5 = this.matchJSX("{") ? this.parseJSXSpreadAttribute() : this.parseJSXNameValueAttribute();
                    e16.push(t5);
                  }
                  return e16;
                }, t4.prototype.parseJSXOpeningElement = function() {
                  var e16 = this.createJSXNode();
                  this.expectJSX("<");
                  var t5 = this.parseJSXElementName(), n3 = this.parseJSXAttributes(), r2 = this.matchJSX("/");
                  return r2 && this.expectJSX("/"), this.expectJSX(">"), this.finalize(e16, new s.JSXOpeningElement(t5, r2, n3));
                }, t4.prototype.parseJSXBoundaryElement = function() {
                  var e16 = this.createJSXNode();
                  if (this.expectJSX("<"), this.matchJSX("/")) {
                    this.expectJSX("/");
                    var t5 = this.parseJSXElementName();
                    return this.expectJSX(">"), this.finalize(e16, new s.JSXClosingElement(t5));
                  }
                  var n3 = this.parseJSXElementName(), r2 = this.parseJSXAttributes(), a2 = this.matchJSX("/");
                  return a2 && this.expectJSX("/"), this.expectJSX(">"), this.finalize(e16, new s.JSXOpeningElement(n3, a2, r2));
                }, t4.prototype.parseJSXEmptyExpression = function() {
                  var e16 = this.createJSXChildNode();
                  return this.collectComments(), this.lastMarker.index = this.scanner.index, this.lastMarker.line = this.scanner.lineNumber, this.lastMarker.column = this.scanner.index - this.scanner.lineStart, this.finalize(e16, new s.JSXEmptyExpression());
                }, t4.prototype.parseJSXExpressionContainer = function() {
                  var e16, t5 = this.createJSXNode();
                  return this.expectJSX("{"), this.matchJSX("}") ? (e16 = this.parseJSXEmptyExpression(), this.expectJSX("}")) : (this.finishJSX(), e16 = this.parseAssignmentExpression(), this.reenterJSX()), this.finalize(t5, new s.JSXExpressionContainer(e16));
                }, t4.prototype.parseJSXChildren = function() {
                  for (var e16 = []; !this.scanner.eof(); ) {
                    var t5 = this.createJSXChildNode(), n3 = this.nextJSXText();
                    if (n3.start < n3.end) {
                      var r2 = this.getTokenRaw(n3), a2 = this.finalize(t5, new s.JSXText(n3.value, r2));
                      e16.push(a2);
                    }
                    if (this.scanner.source[this.scanner.index] !== "{")
                      break;
                    var o2 = this.parseJSXExpressionContainer();
                    e16.push(o2);
                  }
                  return e16;
                }, t4.prototype.parseComplexJSXElement = function(e16) {
                  for (var t5 = []; !this.scanner.eof(); ) {
                    e16.children = e16.children.concat(this.parseJSXChildren());
                    var n3 = this.createJSXChildNode(), r2 = this.parseJSXBoundaryElement();
                    if (r2.type === c.JSXSyntax.JSXOpeningElement) {
                      var a2 = r2;
                      if (a2.selfClosing) {
                        var o2 = this.finalize(n3, new s.JSXElement(a2, [], null));
                        e16.children.push(o2);
                      } else
                        t5.push(e16), e16 = {
                          node: n3,
                          opening: a2,
                          closing: null,
                          children: []
                        };
                    }
                    if (r2.type === c.JSXSyntax.JSXClosingElement) {
                      e16.closing = r2;
                      var l2 = p(e16.opening.name);
                      if (l2 !== p(e16.closing.name) && this.tolerateError("Expected corresponding JSX closing tag for %0", l2), !(t5.length > 0))
                        break;
                      o2 = this.finalize(e16.node, new s.JSXElement(e16.opening, e16.children, e16.closing)), (e16 = t5[t5.length - 1]).children.push(o2), t5.pop();
                    }
                  }
                  return e16;
                }, t4.prototype.parseJSXElement = function() {
                  var e16 = this.createJSXNode(), t5 = this.parseJSXOpeningElement(), n3 = [], r2 = null;
                  if (!t5.selfClosing) {
                    var a2 = this.parseComplexJSXElement({
                      node: e16,
                      opening: t5,
                      closing: r2,
                      children: n3
                    });
                    n3 = a2.children, r2 = a2.closing;
                  }
                  return this.finalize(e16, new s.JSXElement(t5, n3, r2));
                }, t4.prototype.parseJSXRoot = function() {
                  this.config.tokens && this.tokens.pop(), this.startJSX();
                  var e16 = this.parseJSXElement();
                  return this.finishJSX(), e16;
                }, t4.prototype.isStartOfExpression = function() {
                  return e15.prototype.isStartOfExpression.call(this) || this.match("<");
                }, t4;
              }(u.Parser);
            },
            function(e14, t3) {
              Object.defineProperty(t3, "__esModule", { value: true });
              var n2 = {
                NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
                NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
              };
              t3.Character = {
                fromCodePoint: function(e15) {
                  return e15 < 65536 ? String.fromCharCode(e15) : String.fromCharCode(55296 + (e15 - 65536 >> 10)) + String.fromCharCode(56320 + (e15 - 65536 & 1023));
                },
                isWhiteSpace: function(e15) {
                  return e15 === 32 || e15 === 9 || e15 === 11 || e15 === 12 || e15 === 160 || e15 >= 5760 && [
                    5760,
                    8192,
                    8193,
                    8194,
                    8195,
                    8196,
                    8197,
                    8198,
                    8199,
                    8200,
                    8201,
                    8202,
                    8239,
                    8287,
                    12288,
                    65279
                  ].indexOf(e15) >= 0;
                },
                isLineTerminator: function(e15) {
                  return e15 === 10 || e15 === 13 || e15 === 8232 || e15 === 8233;
                },
                isIdentifierStart: function(e15) {
                  return e15 === 36 || e15 === 95 || e15 >= 65 && e15 <= 90 || e15 >= 97 && e15 <= 122 || e15 === 92 || e15 >= 128 && n2.NonAsciiIdentifierStart.test(t3.Character.fromCodePoint(e15));
                },
                isIdentifierPart: function(e15) {
                  return e15 === 36 || e15 === 95 || e15 >= 65 && e15 <= 90 || e15 >= 97 && e15 <= 122 || e15 >= 48 && e15 <= 57 || e15 === 92 || e15 >= 128 && n2.NonAsciiIdentifierPart.test(t3.Character.fromCodePoint(e15));
                },
                isDecimalDigit: function(e15) {
                  return e15 >= 48 && e15 <= 57;
                },
                isHexDigit: function(e15) {
                  return e15 >= 48 && e15 <= 57 || e15 >= 65 && e15 <= 70 || e15 >= 97 && e15 <= 102;
                },
                isOctalDigit: function(e15) {
                  return e15 >= 48 && e15 <= 55;
                }
              };
            },
            function(e14, t3, n2) {
              Object.defineProperty(t3, "__esModule", { value: true });
              var r = n2(6);
              t3.JSXClosingElement = function(e15) {
                this.type = r.JSXSyntax.JSXClosingElement, this.name = e15;
              }, t3.JSXElement = function(e15, t4, n3) {
                this.type = r.JSXSyntax.JSXElement, this.openingElement = e15, this.children = t4, this.closingElement = n3;
              }, t3.JSXEmptyExpression = function() {
                this.type = r.JSXSyntax.JSXEmptyExpression;
              }, t3.JSXExpressionContainer = function(e15) {
                this.type = r.JSXSyntax.JSXExpressionContainer, this.expression = e15;
              }, t3.JSXIdentifier = function(e15) {
                this.type = r.JSXSyntax.JSXIdentifier, this.name = e15;
              }, t3.JSXMemberExpression = function(e15, t4) {
                this.type = r.JSXSyntax.JSXMemberExpression, this.object = e15, this.property = t4;
              }, t3.JSXAttribute = function(e15, t4) {
                this.type = r.JSXSyntax.JSXAttribute, this.name = e15, this.value = t4;
              }, t3.JSXNamespacedName = function(e15, t4) {
                this.type = r.JSXSyntax.JSXNamespacedName, this.namespace = e15, this.name = t4;
              }, t3.JSXOpeningElement = function(e15, t4, n3) {
                this.type = r.JSXSyntax.JSXOpeningElement, this.name = e15, this.selfClosing = t4, this.attributes = n3;
              }, t3.JSXSpreadAttribute = function(e15) {
                this.type = r.JSXSyntax.JSXSpreadAttribute, this.argument = e15;
              }, t3.JSXText = function(e15, t4) {
                this.type = r.JSXSyntax.JSXText, this.value = e15, this.raw = t4;
              };
            },
            function(e14, t3) {
              Object.defineProperty(t3, "__esModule", { value: true }), t3.JSXSyntax = {
                JSXAttribute: "JSXAttribute",
                JSXClosingElement: "JSXClosingElement",
                JSXElement: "JSXElement",
                JSXEmptyExpression: "JSXEmptyExpression",
                JSXExpressionContainer: "JSXExpressionContainer",
                JSXIdentifier: "JSXIdentifier",
                JSXMemberExpression: "JSXMemberExpression",
                JSXNamespacedName: "JSXNamespacedName",
                JSXOpeningElement: "JSXOpeningElement",
                JSXSpreadAttribute: "JSXSpreadAttribute",
                JSXText: "JSXText"
              };
            },
            function(e14, t3, n2) {
              Object.defineProperty(t3, "__esModule", { value: true });
              var r = n2(2);
              t3.ArrayExpression = function(e15) {
                this.type = r.Syntax.ArrayExpression, this.elements = e15;
              }, t3.ArrayPattern = function(e15) {
                this.type = r.Syntax.ArrayPattern, this.elements = e15;
              }, t3.ArrowFunctionExpression = function(e15, t4, n3) {
                this.type = r.Syntax.ArrowFunctionExpression, this.id = null, this.params = e15, this.body = t4, this.generator = false, this.expression = n3, this.async = false;
              }, t3.AssignmentExpression = function(e15, t4, n3) {
                this.type = r.Syntax.AssignmentExpression, this.operator = e15, this.left = t4, this.right = n3;
              }, t3.AssignmentPattern = function(e15, t4) {
                this.type = r.Syntax.AssignmentPattern, this.left = e15, this.right = t4;
              }, t3.AsyncArrowFunctionExpression = function(e15, t4, n3) {
                this.type = r.Syntax.ArrowFunctionExpression, this.id = null, this.params = e15, this.body = t4, this.generator = false, this.expression = n3, this.async = true;
              }, t3.AsyncFunctionDeclaration = function(e15, t4, n3) {
                this.type = r.Syntax.FunctionDeclaration, this.id = e15, this.params = t4, this.body = n3, this.generator = false, this.expression = false, this.async = true;
              }, t3.AsyncFunctionExpression = function(e15, t4, n3) {
                this.type = r.Syntax.FunctionExpression, this.id = e15, this.params = t4, this.body = n3, this.generator = false, this.expression = false, this.async = true;
              }, t3.AwaitExpression = function(e15) {
                this.type = r.Syntax.AwaitExpression, this.argument = e15;
              }, t3.BinaryExpression = function(e15, t4, n3) {
                this.type = e15 === "||" || e15 === "&&" ? r.Syntax.LogicalExpression : r.Syntax.BinaryExpression, this.operator = e15, this.left = t4, this.right = n3;
              }, t3.BlockStatement = function(e15) {
                this.type = r.Syntax.BlockStatement, this.body = e15;
              }, t3.BreakStatement = function(e15) {
                this.type = r.Syntax.BreakStatement, this.label = e15;
              }, t3.CallExpression = function(e15, t4) {
                this.type = r.Syntax.CallExpression, this.callee = e15, this.arguments = t4;
              }, t3.CatchClause = function(e15, t4) {
                this.type = r.Syntax.CatchClause, this.param = e15, this.body = t4;
              }, t3.ClassBody = function(e15) {
                this.type = r.Syntax.ClassBody, this.body = e15;
              }, t3.ClassDeclaration = function(e15, t4, n3) {
                this.type = r.Syntax.ClassDeclaration, this.id = e15, this.superClass = t4, this.body = n3;
              }, t3.ClassExpression = function(e15, t4, n3) {
                this.type = r.Syntax.ClassExpression, this.id = e15, this.superClass = t4, this.body = n3;
              }, t3.ComputedMemberExpression = function(e15, t4) {
                this.type = r.Syntax.MemberExpression, this.computed = true, this.object = e15, this.property = t4;
              }, t3.ConditionalExpression = function(e15, t4, n3) {
                this.type = r.Syntax.ConditionalExpression, this.test = e15, this.consequent = t4, this.alternate = n3;
              }, t3.ContinueStatement = function(e15) {
                this.type = r.Syntax.ContinueStatement, this.label = e15;
              }, t3.DebuggerStatement = function() {
                this.type = r.Syntax.DebuggerStatement;
              }, t3.Directive = function(e15, t4) {
                this.type = r.Syntax.ExpressionStatement, this.expression = e15, this.directive = t4;
              }, t3.DoWhileStatement = function(e15, t4) {
                this.type = r.Syntax.DoWhileStatement, this.body = e15, this.test = t4;
              }, t3.EmptyStatement = function() {
                this.type = r.Syntax.EmptyStatement;
              }, t3.ExportAllDeclaration = function(e15) {
                this.type = r.Syntax.ExportAllDeclaration, this.source = e15;
              }, t3.ExportDefaultDeclaration = function(e15) {
                this.type = r.Syntax.ExportDefaultDeclaration, this.declaration = e15;
              }, t3.ExportNamedDeclaration = function(e15, t4, n3) {
                this.type = r.Syntax.ExportNamedDeclaration, this.declaration = e15, this.specifiers = t4, this.source = n3;
              }, t3.ExportSpecifier = function(e15, t4) {
                this.type = r.Syntax.ExportSpecifier, this.exported = t4, this.local = e15;
              }, t3.ExpressionStatement = function(e15) {
                this.type = r.Syntax.ExpressionStatement, this.expression = e15;
              }, t3.ForInStatement = function(e15, t4, n3) {
                this.type = r.Syntax.ForInStatement, this.left = e15, this.right = t4, this.body = n3, this.each = false;
              }, t3.ForOfStatement = function(e15, t4, n3) {
                this.type = r.Syntax.ForOfStatement, this.left = e15, this.right = t4, this.body = n3;
              }, t3.ForStatement = function(e15, t4, n3, a) {
                this.type = r.Syntax.ForStatement, this.init = e15, this.test = t4, this.update = n3, this.body = a;
              }, t3.FunctionDeclaration = function(e15, t4, n3, a) {
                this.type = r.Syntax.FunctionDeclaration, this.id = e15, this.params = t4, this.body = n3, this.generator = a, this.expression = false, this.async = false;
              }, t3.FunctionExpression = function(e15, t4, n3, a) {
                this.type = r.Syntax.FunctionExpression, this.id = e15, this.params = t4, this.body = n3, this.generator = a, this.expression = false, this.async = false;
              }, t3.Identifier = function(e15) {
                this.type = r.Syntax.Identifier, this.name = e15;
              }, t3.IfStatement = function(e15, t4, n3) {
                this.type = r.Syntax.IfStatement, this.test = e15, this.consequent = t4, this.alternate = n3;
              }, t3.ImportDeclaration = function(e15, t4) {
                this.type = r.Syntax.ImportDeclaration, this.specifiers = e15, this.source = t4;
              }, t3.ImportDefaultSpecifier = function(e15) {
                this.type = r.Syntax.ImportDefaultSpecifier, this.local = e15;
              }, t3.ImportNamespaceSpecifier = function(e15) {
                this.type = r.Syntax.ImportNamespaceSpecifier, this.local = e15;
              }, t3.ImportSpecifier = function(e15, t4) {
                this.type = r.Syntax.ImportSpecifier, this.local = e15, this.imported = t4;
              }, t3.LabeledStatement = function(e15, t4) {
                this.type = r.Syntax.LabeledStatement, this.label = e15, this.body = t4;
              }, t3.Literal = function(e15, t4) {
                this.type = r.Syntax.Literal, this.value = e15, this.raw = t4;
              }, t3.MetaProperty = function(e15, t4) {
                this.type = r.Syntax.MetaProperty, this.meta = e15, this.property = t4;
              }, t3.MethodDefinition = function(e15, t4, n3, a, o) {
                this.type = r.Syntax.MethodDefinition, this.key = e15, this.computed = t4, this.value = n3, this.kind = a, this.static = o;
              }, t3.Module = function(e15) {
                this.type = r.Syntax.Program, this.body = e15, this.sourceType = "module";
              }, t3.NewExpression = function(e15, t4) {
                this.type = r.Syntax.NewExpression, this.callee = e15, this.arguments = t4;
              }, t3.ObjectExpression = function(e15) {
                this.type = r.Syntax.ObjectExpression, this.properties = e15;
              }, t3.ObjectPattern = function(e15) {
                this.type = r.Syntax.ObjectPattern, this.properties = e15;
              }, t3.Property = function(e15, t4, n3, a, o, s) {
                this.type = r.Syntax.Property, this.key = t4, this.computed = n3, this.value = a, this.kind = e15, this.method = o, this.shorthand = s;
              }, t3.RegexLiteral = function(e15, t4, n3, a) {
                this.type = r.Syntax.Literal, this.value = e15, this.raw = t4, this.regex = {
                  pattern: n3,
                  flags: a
                };
              }, t3.RestElement = function(e15) {
                this.type = r.Syntax.RestElement, this.argument = e15;
              }, t3.ReturnStatement = function(e15) {
                this.type = r.Syntax.ReturnStatement, this.argument = e15;
              }, t3.Script = function(e15) {
                this.type = r.Syntax.Program, this.body = e15, this.sourceType = "script";
              }, t3.SequenceExpression = function(e15) {
                this.type = r.Syntax.SequenceExpression, this.expressions = e15;
              }, t3.SpreadElement = function(e15) {
                this.type = r.Syntax.SpreadElement, this.argument = e15;
              }, t3.StaticMemberExpression = function(e15, t4) {
                this.type = r.Syntax.MemberExpression, this.computed = false, this.object = e15, this.property = t4;
              }, t3.Super = function() {
                this.type = r.Syntax.Super;
              }, t3.SwitchCase = function(e15, t4) {
                this.type = r.Syntax.SwitchCase, this.test = e15, this.consequent = t4;
              }, t3.SwitchStatement = function(e15, t4) {
                this.type = r.Syntax.SwitchStatement, this.discriminant = e15, this.cases = t4;
              }, t3.TaggedTemplateExpression = function(e15, t4) {
                this.type = r.Syntax.TaggedTemplateExpression, this.tag = e15, this.quasi = t4;
              }, t3.TemplateElement = function(e15, t4) {
                this.type = r.Syntax.TemplateElement, this.value = e15, this.tail = t4;
              }, t3.TemplateLiteral = function(e15, t4) {
                this.type = r.Syntax.TemplateLiteral, this.quasis = e15, this.expressions = t4;
              }, t3.ThisExpression = function() {
                this.type = r.Syntax.ThisExpression;
              }, t3.ThrowStatement = function(e15) {
                this.type = r.Syntax.ThrowStatement, this.argument = e15;
              }, t3.TryStatement = function(e15, t4, n3) {
                this.type = r.Syntax.TryStatement, this.block = e15, this.handler = t4, this.finalizer = n3;
              }, t3.UnaryExpression = function(e15, t4) {
                this.type = r.Syntax.UnaryExpression, this.operator = e15, this.argument = t4, this.prefix = true;
              }, t3.UpdateExpression = function(e15, t4, n3) {
                this.type = r.Syntax.UpdateExpression, this.operator = e15, this.argument = t4, this.prefix = n3;
              }, t3.VariableDeclaration = function(e15, t4) {
                this.type = r.Syntax.VariableDeclaration, this.declarations = e15, this.kind = t4;
              }, t3.VariableDeclarator = function(e15, t4) {
                this.type = r.Syntax.VariableDeclarator, this.id = e15, this.init = t4;
              }, t3.WhileStatement = function(e15, t4) {
                this.type = r.Syntax.WhileStatement, this.test = e15, this.body = t4;
              }, t3.WithStatement = function(e15, t4) {
                this.type = r.Syntax.WithStatement, this.object = e15, this.body = t4;
              }, t3.YieldExpression = function(e15, t4) {
                this.type = r.Syntax.YieldExpression, this.argument = e15, this.delegate = t4;
              };
            },
            function(e14, t3, n2) {
              Object.defineProperty(t3, "__esModule", { value: true });
              var r = n2(9), a = n2(10), o = n2(11), s = n2(7), c = n2(12), l = n2(2), u = n2(13);
              t3.Parser = function() {
                function e15(e16, t4, n3) {
                  t4 === void 0 && (t4 = {}), this.config = {
                    range: typeof t4.range == "boolean" && t4.range,
                    loc: typeof t4.loc == "boolean" && t4.loc,
                    source: null,
                    tokens: typeof t4.tokens == "boolean" && t4.tokens,
                    comment: typeof t4.comment == "boolean" && t4.comment,
                    tolerant: typeof t4.tolerant == "boolean" && t4.tolerant
                  }, this.config.loc && t4.source && t4.source !== null && (this.config.source = String(t4.source)), this.delegate = n3, this.errorHandler = new a.ErrorHandler(), this.errorHandler.tolerant = this.config.tolerant, this.scanner = new c.Scanner(e16, this.errorHandler), this.scanner.trackComment = this.config.comment, this.operatorPrecedence = {
                    ")": 0,
                    ";": 0,
                    ",": 0,
                    "=": 0,
                    "]": 0,
                    "||": 1,
                    "&&": 2,
                    "|": 3,
                    "^": 4,
                    "&": 5,
                    "==": 6,
                    "!=": 6,
                    "===": 6,
                    "!==": 6,
                    "<": 7,
                    ">": 7,
                    "<=": 7,
                    ">=": 7,
                    "<<": 8,
                    ">>": 8,
                    ">>>": 8,
                    "+": 9,
                    "-": 9,
                    "*": 11,
                    "/": 11,
                    "%": 11
                  }, this.lookahead = {
                    type: 2,
                    value: "",
                    lineNumber: this.scanner.lineNumber,
                    lineStart: 0,
                    start: 0,
                    end: 0
                  }, this.hasLineTerminator = false, this.context = {
                    isModule: false,
                    await: false,
                    allowIn: true,
                    allowStrictDirective: true,
                    allowYield: true,
                    firstCoverInitializedNameError: null,
                    isAssignmentTarget: false,
                    isBindingElement: false,
                    inFunctionBody: false,
                    inIteration: false,
                    inSwitch: false,
                    labelSet: {},
                    strict: false
                  }, this.tokens = [], this.startMarker = {
                    index: 0,
                    line: this.scanner.lineNumber,
                    column: 0
                  }, this.lastMarker = {
                    index: 0,
                    line: this.scanner.lineNumber,
                    column: 0
                  }, this.nextToken(), this.lastMarker = {
                    index: this.scanner.index,
                    line: this.scanner.lineNumber,
                    column: this.scanner.index - this.scanner.lineStart
                  };
                }
                return e15.prototype.throwError = function(e16) {
                  var t4 = Array.prototype.slice.call(arguments, 1), n3 = e16.replace(/%(\d)/g, function(e17, n4) {
                    return r.assert(n4 < t4.length, "Message reference must be in range"), t4[n4];
                  }), a2 = this.lastMarker.index, o2 = this.lastMarker.line, s2 = this.lastMarker.column + 1;
                  throw this.errorHandler.createError(a2, o2, s2, n3);
                }, e15.prototype.tolerateError = function(e16) {
                  var t4 = Array.prototype.slice.call(arguments, 1), n3 = e16.replace(/%(\d)/g, function(e17, n4) {
                    return r.assert(n4 < t4.length, "Message reference must be in range"), t4[n4];
                  }), a2 = this.lastMarker.index, o2 = this.scanner.lineNumber, s2 = this.lastMarker.column + 1;
                  this.errorHandler.tolerateError(a2, o2, s2, n3);
                }, e15.prototype.unexpectedTokenError = function(e16, t4) {
                  var n3, r2 = t4 || o.Messages.UnexpectedToken;
                  if (e16 ? (t4 || (r2 = e16.type === 2 ? o.Messages.UnexpectedEOS : e16.type === 3 ? o.Messages.UnexpectedIdentifier : e16.type === 6 ? o.Messages.UnexpectedNumber : e16.type === 8 ? o.Messages.UnexpectedString : e16.type === 10 ? o.Messages.UnexpectedTemplate : o.Messages.UnexpectedToken, e16.type === 4 && (this.scanner.isFutureReservedWord(e16.value) ? r2 = o.Messages.UnexpectedReserved : this.context.strict && this.scanner.isStrictModeReservedWord(e16.value) && (r2 = o.Messages.StrictReservedWord))), n3 = e16.value) : n3 = "ILLEGAL", r2 = r2.replace("%0", n3), e16 && typeof e16.lineNumber == "number") {
                    var a2 = e16.start, s2 = e16.lineNumber, c2 = this.lastMarker.index - this.lastMarker.column, l2 = e16.start - c2 + 1;
                    return this.errorHandler.createError(a2, s2, l2, r2);
                  }
                  return a2 = this.lastMarker.index, s2 = this.lastMarker.line, l2 = this.lastMarker.column + 1, this.errorHandler.createError(a2, s2, l2, r2);
                }, e15.prototype.throwUnexpectedToken = function(e16, t4) {
                  throw this.unexpectedTokenError(e16, t4);
                }, e15.prototype.tolerateUnexpectedToken = function(e16, t4) {
                  this.errorHandler.tolerate(this.unexpectedTokenError(e16, t4));
                }, e15.prototype.collectComments = function() {
                  if (this.config.comment) {
                    var e16 = this.scanner.scanComments();
                    if (e16.length > 0 && this.delegate)
                      for (var t4 = 0; t4 < e16.length; ++t4) {
                        var n3 = e16[t4], r2 = void 0;
                        r2 = {
                          type: n3.multiLine ? "BlockComment" : "LineComment",
                          value: this.scanner.source.slice(n3.slice[0], n3.slice[1])
                        }, this.config.range && (r2.range = n3.range), this.config.loc && (r2.loc = n3.loc);
                        var a2 = {
                          start: {
                            line: n3.loc.start.line,
                            column: n3.loc.start.column,
                            offset: n3.range[0]
                          },
                          end: {
                            line: n3.loc.end.line,
                            column: n3.loc.end.column,
                            offset: n3.range[1]
                          }
                        };
                        this.delegate(r2, a2);
                      }
                  } else
                    this.scanner.scanComments();
                }, e15.prototype.getTokenRaw = function(e16) {
                  return this.scanner.source.slice(e16.start, e16.end);
                }, e15.prototype.convertToken = function(e16) {
                  var t4 = {
                    type: u.TokenName[e16.type],
                    value: this.getTokenRaw(e16)
                  };
                  return this.config.range && (t4.range = [e16.start, e16.end]), this.config.loc && (t4.loc = {
                    start: {
                      line: this.startMarker.line,
                      column: this.startMarker.column
                    },
                    end: {
                      line: this.scanner.lineNumber,
                      column: this.scanner.index - this.scanner.lineStart
                    }
                  }), e16.type === 9 && (t4.regex = {
                    pattern: e16.pattern,
                    flags: e16.flags
                  }), t4;
                }, e15.prototype.nextToken = function() {
                  var e16 = this.lookahead;
                  this.lastMarker.index = this.scanner.index, this.lastMarker.line = this.scanner.lineNumber, this.lastMarker.column = this.scanner.index - this.scanner.lineStart, this.collectComments(), this.scanner.index !== this.startMarker.index && (this.startMarker.index = this.scanner.index, this.startMarker.line = this.scanner.lineNumber, this.startMarker.column = this.scanner.index - this.scanner.lineStart);
                  var t4 = this.scanner.lex();
                  return this.hasLineTerminator = e16.lineNumber !== t4.lineNumber, t4 && this.context.strict && t4.type === 3 && this.scanner.isStrictModeReservedWord(t4.value) && (t4.type = 4), this.lookahead = t4, this.config.tokens && t4.type !== 2 && this.tokens.push(this.convertToken(t4)), e16;
                }, e15.prototype.nextRegexToken = function() {
                  this.collectComments();
                  var e16 = this.scanner.scanRegExp();
                  return this.config.tokens && (this.tokens.pop(), this.tokens.push(this.convertToken(e16))), this.lookahead = e16, this.nextToken(), e16;
                }, e15.prototype.createNode = function() {
                  return {
                    index: this.startMarker.index,
                    line: this.startMarker.line,
                    column: this.startMarker.column
                  };
                }, e15.prototype.startNode = function(e16, t4) {
                  t4 === void 0 && (t4 = 0);
                  var n3 = e16.start - e16.lineStart, r2 = e16.lineNumber;
                  return n3 < 0 && (n3 += t4, r2--), {
                    index: e16.start,
                    line: r2,
                    column: n3
                  };
                }, e15.prototype.finalize = function(e16, t4) {
                  if (this.config.range && (t4.range = [e16.index, this.lastMarker.index]), this.config.loc && (t4.loc = {
                    start: {
                      line: e16.line,
                      column: e16.column
                    },
                    end: {
                      line: this.lastMarker.line,
                      column: this.lastMarker.column
                    }
                  }, this.config.source && (t4.loc.source = this.config.source)), this.delegate) {
                    var n3 = {
                      start: {
                        line: e16.line,
                        column: e16.column,
                        offset: e16.index
                      },
                      end: {
                        line: this.lastMarker.line,
                        column: this.lastMarker.column,
                        offset: this.lastMarker.index
                      }
                    };
                    this.delegate(t4, n3);
                  }
                  return t4;
                }, e15.prototype.expect = function(e16) {
                  var t4 = this.nextToken();
                  t4.type === 7 && t4.value === e16 || this.throwUnexpectedToken(t4);
                }, e15.prototype.expectCommaSeparator = function() {
                  if (this.config.tolerant) {
                    var e16 = this.lookahead;
                    e16.type === 7 && e16.value === "," ? this.nextToken() : e16.type === 7 && e16.value === ";" ? (this.nextToken(), this.tolerateUnexpectedToken(e16)) : this.tolerateUnexpectedToken(e16, o.Messages.UnexpectedToken);
                  } else
                    this.expect(",");
                }, e15.prototype.expectKeyword = function(e16) {
                  var t4 = this.nextToken();
                  t4.type === 4 && t4.value === e16 || this.throwUnexpectedToken(t4);
                }, e15.prototype.match = function(e16) {
                  return this.lookahead.type === 7 && this.lookahead.value === e16;
                }, e15.prototype.matchKeyword = function(e16) {
                  return this.lookahead.type === 4 && this.lookahead.value === e16;
                }, e15.prototype.matchContextualKeyword = function(e16) {
                  return this.lookahead.type === 3 && this.lookahead.value === e16;
                }, e15.prototype.matchAssign = function() {
                  if (this.lookahead.type !== 7)
                    return false;
                  var e16 = this.lookahead.value;
                  return e16 === "=" || e16 === "*=" || e16 === "**=" || e16 === "/=" || e16 === "%=" || e16 === "+=" || e16 === "-=" || e16 === "<<=" || e16 === ">>=" || e16 === ">>>=" || e16 === "&=" || e16 === "^=" || e16 === "|=";
                }, e15.prototype.isolateCoverGrammar = function(e16) {
                  var t4 = this.context.isBindingElement, n3 = this.context.isAssignmentTarget, r2 = this.context.firstCoverInitializedNameError;
                  this.context.isBindingElement = true, this.context.isAssignmentTarget = true, this.context.firstCoverInitializedNameError = null;
                  var a2 = e16.call(this);
                  return this.context.firstCoverInitializedNameError !== null && this.throwUnexpectedToken(this.context.firstCoverInitializedNameError), this.context.isBindingElement = t4, this.context.isAssignmentTarget = n3, this.context.firstCoverInitializedNameError = r2, a2;
                }, e15.prototype.inheritCoverGrammar = function(e16) {
                  var t4 = this.context.isBindingElement, n3 = this.context.isAssignmentTarget, r2 = this.context.firstCoverInitializedNameError;
                  this.context.isBindingElement = true, this.context.isAssignmentTarget = true, this.context.firstCoverInitializedNameError = null;
                  var a2 = e16.call(this);
                  return this.context.isBindingElement = this.context.isBindingElement && t4, this.context.isAssignmentTarget = this.context.isAssignmentTarget && n3, this.context.firstCoverInitializedNameError = r2 || this.context.firstCoverInitializedNameError, a2;
                }, e15.prototype.consumeSemicolon = function() {
                  this.match(";") ? this.nextToken() : this.hasLineTerminator || (this.lookahead.type === 2 || this.match("}") || this.throwUnexpectedToken(this.lookahead), this.lastMarker.index = this.startMarker.index, this.lastMarker.line = this.startMarker.line, this.lastMarker.column = this.startMarker.column);
                }, e15.prototype.parsePrimaryExpression = function() {
                  var e16, t4, n3, r2 = this.createNode();
                  switch (this.lookahead.type) {
                    case 3:
                      (this.context.isModule || this.context.await) && this.lookahead.value === "await" && this.tolerateUnexpectedToken(this.lookahead), e16 = this.matchAsyncFunction() ? this.parseFunctionExpression() : this.finalize(r2, new s.Identifier(this.nextToken().value));
                      break;
                    case 6:
                    case 8:
                      this.context.strict && this.lookahead.octal && this.tolerateUnexpectedToken(this.lookahead, o.Messages.StrictOctalLiteral), this.context.isAssignmentTarget = false, this.context.isBindingElement = false, t4 = this.nextToken(), n3 = this.getTokenRaw(t4), e16 = this.finalize(r2, new s.Literal(t4.value, n3));
                      break;
                    case 1:
                      this.context.isAssignmentTarget = false, this.context.isBindingElement = false, t4 = this.nextToken(), n3 = this.getTokenRaw(t4), e16 = this.finalize(r2, new s.Literal(t4.value === "true", n3));
                      break;
                    case 5:
                      this.context.isAssignmentTarget = false, this.context.isBindingElement = false, t4 = this.nextToken(), n3 = this.getTokenRaw(t4), e16 = this.finalize(r2, new s.Literal(null, n3));
                      break;
                    case 10:
                      e16 = this.parseTemplateLiteral();
                      break;
                    case 7:
                      switch (this.lookahead.value) {
                        case "(":
                          this.context.isBindingElement = false, e16 = this.inheritCoverGrammar(this.parseGroupExpression);
                          break;
                        case "[":
                          e16 = this.inheritCoverGrammar(this.parseArrayInitializer);
                          break;
                        case "{":
                          e16 = this.inheritCoverGrammar(this.parseObjectInitializer);
                          break;
                        case "/":
                        case "/=":
                          this.context.isAssignmentTarget = false, this.context.isBindingElement = false, this.scanner.index = this.startMarker.index, t4 = this.nextRegexToken(), n3 = this.getTokenRaw(t4), e16 = this.finalize(r2, new s.RegexLiteral(t4.regex, n3, t4.pattern, t4.flags));
                          break;
                        default:
                          e16 = this.throwUnexpectedToken(this.nextToken());
                      }
                      break;
                    case 4:
                      !this.context.strict && this.context.allowYield && this.matchKeyword("yield") ? e16 = this.parseIdentifierName() : !this.context.strict && this.matchKeyword("let") ? e16 = this.finalize(r2, new s.Identifier(this.nextToken().value)) : (this.context.isAssignmentTarget = false, this.context.isBindingElement = false, this.matchKeyword("function") ? e16 = this.parseFunctionExpression() : this.matchKeyword("this") ? (this.nextToken(), e16 = this.finalize(r2, new s.ThisExpression())) : e16 = this.matchKeyword("class") ? this.parseClassExpression() : this.throwUnexpectedToken(this.nextToken()));
                      break;
                    default:
                      e16 = this.throwUnexpectedToken(this.nextToken());
                  }
                  return e16;
                }, e15.prototype.parseSpreadElement = function() {
                  var e16 = this.createNode();
                  this.expect("...");
                  var t4 = this.inheritCoverGrammar(this.parseAssignmentExpression);
                  return this.finalize(e16, new s.SpreadElement(t4));
                }, e15.prototype.parseArrayInitializer = function() {
                  var e16 = this.createNode(), t4 = [];
                  for (this.expect("["); !this.match("]"); )
                    if (this.match(","))
                      this.nextToken(), t4.push(null);
                    else if (this.match("...")) {
                      var n3 = this.parseSpreadElement();
                      this.match("]") || (this.context.isAssignmentTarget = false, this.context.isBindingElement = false, this.expect(",")), t4.push(n3);
                    } else
                      t4.push(this.inheritCoverGrammar(this.parseAssignmentExpression)), this.match("]") || this.expect(",");
                  return this.expect("]"), this.finalize(e16, new s.ArrayExpression(t4));
                }, e15.prototype.parsePropertyMethod = function(e16) {
                  this.context.isAssignmentTarget = false, this.context.isBindingElement = false;
                  var t4 = this.context.strict, n3 = this.context.allowStrictDirective;
                  this.context.allowStrictDirective = e16.simple;
                  var r2 = this.isolateCoverGrammar(this.parseFunctionSourceElements);
                  return this.context.strict && e16.firstRestricted && this.tolerateUnexpectedToken(e16.firstRestricted, e16.message), this.context.strict && e16.stricted && this.tolerateUnexpectedToken(e16.stricted, e16.message), this.context.strict = t4, this.context.allowStrictDirective = n3, r2;
                }, e15.prototype.parsePropertyMethodFunction = function() {
                  var e16 = this.createNode(), t4 = this.context.allowYield;
                  this.context.allowYield = true;
                  var n3 = this.parseFormalParameters(), r2 = this.parsePropertyMethod(n3);
                  return this.context.allowYield = t4, this.finalize(e16, new s.FunctionExpression(null, n3.params, r2, false));
                }, e15.prototype.parsePropertyMethodAsyncFunction = function() {
                  var e16 = this.createNode(), t4 = this.context.allowYield, n3 = this.context.await;
                  this.context.allowYield = false, this.context.await = true;
                  var r2 = this.parseFormalParameters(), a2 = this.parsePropertyMethod(r2);
                  return this.context.allowYield = t4, this.context.await = n3, this.finalize(e16, new s.AsyncFunctionExpression(null, r2.params, a2));
                }, e15.prototype.parseObjectPropertyKey = function() {
                  var e16, t4 = this.createNode(), n3 = this.nextToken();
                  switch (n3.type) {
                    case 8:
                    case 6:
                      this.context.strict && n3.octal && this.tolerateUnexpectedToken(n3, o.Messages.StrictOctalLiteral);
                      var r2 = this.getTokenRaw(n3);
                      e16 = this.finalize(t4, new s.Literal(n3.value, r2));
                      break;
                    case 3:
                    case 1:
                    case 5:
                    case 4:
                      e16 = this.finalize(t4, new s.Identifier(n3.value));
                      break;
                    case 7:
                      n3.value === "[" ? (e16 = this.isolateCoverGrammar(this.parseAssignmentExpression), this.expect("]")) : e16 = this.throwUnexpectedToken(n3);
                      break;
                    default:
                      e16 = this.throwUnexpectedToken(n3);
                  }
                  return e16;
                }, e15.prototype.isPropertyKey = function(e16, t4) {
                  return e16.type === l.Syntax.Identifier && e16.name === t4 || e16.type === l.Syntax.Literal && e16.value === t4;
                }, e15.prototype.parseObjectProperty = function(e16) {
                  var t4, n3 = this.createNode(), r2 = this.lookahead, a2 = null, c2 = null, l2 = false, u2 = false, d = false, f = false;
                  if (r2.type === 3) {
                    var p = r2.value;
                    this.nextToken(), l2 = this.match("["), a2 = (f = !(this.hasLineTerminator || p !== "async" || this.match(":") || this.match("(") || this.match("*") || this.match(","))) ? this.parseObjectPropertyKey() : this.finalize(n3, new s.Identifier(p));
                  } else
                    this.match("*") ? this.nextToken() : (l2 = this.match("["), a2 = this.parseObjectPropertyKey());
                  var m = this.qualifiedPropertyName(this.lookahead);
                  if (r2.type === 3 && !f && r2.value === "get" && m)
                    t4 = "get", l2 = this.match("["), a2 = this.parseObjectPropertyKey(), this.context.allowYield = false, c2 = this.parseGetterMethod();
                  else if (r2.type === 3 && !f && r2.value === "set" && m)
                    t4 = "set", l2 = this.match("["), a2 = this.parseObjectPropertyKey(), c2 = this.parseSetterMethod();
                  else if (r2.type === 7 && r2.value === "*" && m)
                    t4 = "init", l2 = this.match("["), a2 = this.parseObjectPropertyKey(), c2 = this.parseGeneratorMethod(), u2 = true;
                  else if (a2 || this.throwUnexpectedToken(this.lookahead), t4 = "init", this.match(":") && !f)
                    !l2 && this.isPropertyKey(a2, "__proto__") && (e16.value && this.tolerateError(o.Messages.DuplicateProtoProperty), e16.value = true), this.nextToken(), c2 = this.inheritCoverGrammar(this.parseAssignmentExpression);
                  else if (this.match("("))
                    c2 = f ? this.parsePropertyMethodAsyncFunction() : this.parsePropertyMethodFunction(), u2 = true;
                  else if (r2.type === 3)
                    if (p = this.finalize(n3, new s.Identifier(r2.value)), this.match("=")) {
                      this.context.firstCoverInitializedNameError = this.lookahead, this.nextToken(), d = true;
                      var h = this.isolateCoverGrammar(this.parseAssignmentExpression);
                      c2 = this.finalize(n3, new s.AssignmentPattern(p, h));
                    } else
                      d = true, c2 = p;
                  else
                    this.throwUnexpectedToken(this.nextToken());
                  return this.finalize(n3, new s.Property(t4, a2, l2, c2, u2, d));
                }, e15.prototype.parseObjectInitializer = function() {
                  var e16 = this.createNode();
                  this.expect("{");
                  for (var t4 = [], n3 = { value: false }; !this.match("}"); )
                    t4.push(this.parseObjectProperty(n3)), this.match("}") || this.expectCommaSeparator();
                  return this.expect("}"), this.finalize(e16, new s.ObjectExpression(t4));
                }, e15.prototype.parseTemplateHead = function() {
                  r.assert(this.lookahead.head, "Template literal must start with a template head");
                  var e16 = this.createNode(), t4 = this.nextToken(), n3 = t4.value, a2 = t4.cooked;
                  return this.finalize(e16, new s.TemplateElement({
                    raw: n3,
                    cooked: a2
                  }, t4.tail));
                }, e15.prototype.parseTemplateElement = function() {
                  this.lookahead.type !== 10 && this.throwUnexpectedToken();
                  var e16 = this.createNode(), t4 = this.nextToken(), n3 = t4.value, r2 = t4.cooked;
                  return this.finalize(e16, new s.TemplateElement({
                    raw: n3,
                    cooked: r2
                  }, t4.tail));
                }, e15.prototype.parseTemplateLiteral = function() {
                  var e16 = this.createNode(), t4 = [], n3 = [], r2 = this.parseTemplateHead();
                  for (n3.push(r2); !r2.tail; )
                    t4.push(this.parseExpression()), r2 = this.parseTemplateElement(), n3.push(r2);
                  return this.finalize(e16, new s.TemplateLiteral(n3, t4));
                }, e15.prototype.reinterpretExpressionAsPattern = function(e16) {
                  switch (e16.type) {
                    case l.Syntax.Identifier:
                    case l.Syntax.MemberExpression:
                    case l.Syntax.RestElement:
                    case l.Syntax.AssignmentPattern:
                      break;
                    case l.Syntax.SpreadElement:
                      e16.type = l.Syntax.RestElement, this.reinterpretExpressionAsPattern(e16.argument);
                      break;
                    case l.Syntax.ArrayExpression:
                      e16.type = l.Syntax.ArrayPattern;
                      for (var t4 = 0; t4 < e16.elements.length; t4++)
                        e16.elements[t4] !== null && this.reinterpretExpressionAsPattern(e16.elements[t4]);
                      break;
                    case l.Syntax.ObjectExpression:
                      for (e16.type = l.Syntax.ObjectPattern, t4 = 0; t4 < e16.properties.length; t4++)
                        this.reinterpretExpressionAsPattern(e16.properties[t4].value);
                      break;
                    case l.Syntax.AssignmentExpression:
                      e16.type = l.Syntax.AssignmentPattern, delete e16.operator, this.reinterpretExpressionAsPattern(e16.left);
                  }
                }, e15.prototype.parseGroupExpression = function() {
                  var e16;
                  if (this.expect("("), this.match(")"))
                    this.nextToken(), this.match("=>") || this.expect("=>"), e16 = {
                      type: "ArrowParameterPlaceHolder",
                      params: [],
                      async: false
                    };
                  else {
                    var t4 = this.lookahead, n3 = [];
                    if (this.match("..."))
                      e16 = this.parseRestElement(n3), this.expect(")"), this.match("=>") || this.expect("=>"), e16 = {
                        type: "ArrowParameterPlaceHolder",
                        params: [e16],
                        async: false
                      };
                    else {
                      var r2 = false;
                      if (this.context.isBindingElement = true, e16 = this.inheritCoverGrammar(this.parseAssignmentExpression), this.match(",")) {
                        var a2 = [];
                        for (this.context.isAssignmentTarget = false, a2.push(e16); this.lookahead.type !== 2 && this.match(","); ) {
                          if (this.nextToken(), this.match(")")) {
                            this.nextToken();
                            for (var o2 = 0; o2 < a2.length; o2++)
                              this.reinterpretExpressionAsPattern(a2[o2]);
                            r2 = true, e16 = {
                              type: "ArrowParameterPlaceHolder",
                              params: a2,
                              async: false
                            };
                          } else if (this.match("...")) {
                            for (this.context.isBindingElement || this.throwUnexpectedToken(this.lookahead), a2.push(this.parseRestElement(n3)), this.expect(")"), this.match("=>") || this.expect("=>"), this.context.isBindingElement = false, o2 = 0; o2 < a2.length; o2++)
                              this.reinterpretExpressionAsPattern(a2[o2]);
                            r2 = true, e16 = {
                              type: "ArrowParameterPlaceHolder",
                              params: a2,
                              async: false
                            };
                          } else
                            a2.push(this.inheritCoverGrammar(this.parseAssignmentExpression));
                          if (r2)
                            break;
                        }
                        r2 || (e16 = this.finalize(this.startNode(t4), new s.SequenceExpression(a2)));
                      }
                      if (!r2) {
                        if (this.expect(")"), this.match("=>") && (e16.type === l.Syntax.Identifier && e16.name === "yield" && (r2 = true, e16 = {
                          type: "ArrowParameterPlaceHolder",
                          params: [e16],
                          async: false
                        }), !r2)) {
                          if (this.context.isBindingElement || this.throwUnexpectedToken(this.lookahead), e16.type === l.Syntax.SequenceExpression)
                            for (o2 = 0; o2 < e16.expressions.length; o2++)
                              this.reinterpretExpressionAsPattern(e16.expressions[o2]);
                          else
                            this.reinterpretExpressionAsPattern(e16);
                          e16 = {
                            type: "ArrowParameterPlaceHolder",
                            params: e16.type === l.Syntax.SequenceExpression ? e16.expressions : [e16],
                            async: false
                          };
                        }
                        this.context.isBindingElement = false;
                      }
                    }
                  }
                  return e16;
                }, e15.prototype.parseArguments = function() {
                  this.expect("(");
                  var e16 = [];
                  if (!this.match(")"))
                    for (; ; ) {
                      var t4 = this.match("...") ? this.parseSpreadElement() : this.isolateCoverGrammar(this.parseAssignmentExpression);
                      if (e16.push(t4), this.match(")") || (this.expectCommaSeparator(), this.match(")")))
                        break;
                    }
                  return this.expect(")"), e16;
                }, e15.prototype.isIdentifierName = function(e16) {
                  return e16.type === 3 || e16.type === 4 || e16.type === 1 || e16.type === 5;
                }, e15.prototype.parseIdentifierName = function() {
                  var e16 = this.createNode(), t4 = this.nextToken();
                  return this.isIdentifierName(t4) || this.throwUnexpectedToken(t4), this.finalize(e16, new s.Identifier(t4.value));
                }, e15.prototype.parseNewExpression = function() {
                  var e16, t4 = this.createNode(), n3 = this.parseIdentifierName();
                  if (r.assert(n3.name === "new", "New expression must start with `new`"), this.match("."))
                    if (this.nextToken(), this.lookahead.type === 3 && this.context.inFunctionBody && this.lookahead.value === "target") {
                      var a2 = this.parseIdentifierName();
                      e16 = new s.MetaProperty(n3, a2);
                    } else
                      this.throwUnexpectedToken(this.lookahead);
                  else {
                    var o2 = this.isolateCoverGrammar(this.parseLeftHandSideExpression), c2 = this.match("(") ? this.parseArguments() : [];
                    e16 = new s.NewExpression(o2, c2), this.context.isAssignmentTarget = false, this.context.isBindingElement = false;
                  }
                  return this.finalize(t4, e16);
                }, e15.prototype.parseAsyncArgument = function() {
                  var e16 = this.parseAssignmentExpression();
                  return this.context.firstCoverInitializedNameError = null, e16;
                }, e15.prototype.parseAsyncArguments = function() {
                  this.expect("(");
                  var e16 = [];
                  if (!this.match(")"))
                    for (; ; ) {
                      var t4 = this.match("...") ? this.parseSpreadElement() : this.isolateCoverGrammar(this.parseAsyncArgument);
                      if (e16.push(t4), this.match(")") || (this.expectCommaSeparator(), this.match(")")))
                        break;
                    }
                  return this.expect(")"), e16;
                }, e15.prototype.parseLeftHandSideExpressionAllowCall = function() {
                  var e16, t4 = this.lookahead, n3 = this.matchContextualKeyword("async"), r2 = this.context.allowIn;
                  for (this.context.allowIn = true, this.matchKeyword("super") && this.context.inFunctionBody ? (e16 = this.createNode(), this.nextToken(), e16 = this.finalize(e16, new s.Super()), this.match("(") || this.match(".") || this.match("[") || this.throwUnexpectedToken(this.lookahead)) : e16 = this.inheritCoverGrammar(this.matchKeyword("new") ? this.parseNewExpression : this.parsePrimaryExpression); ; )
                    if (this.match(".")) {
                      this.context.isBindingElement = false, this.context.isAssignmentTarget = true, this.expect(".");
                      var a2 = this.parseIdentifierName();
                      e16 = this.finalize(this.startNode(t4), new s.StaticMemberExpression(e16, a2));
                    } else if (this.match("(")) {
                      var o2 = n3 && t4.lineNumber === this.lookahead.lineNumber;
                      this.context.isBindingElement = false, this.context.isAssignmentTarget = false;
                      var c2 = o2 ? this.parseAsyncArguments() : this.parseArguments();
                      if (e16 = this.finalize(this.startNode(t4), new s.CallExpression(e16, c2)), o2 && this.match("=>")) {
                        for (var l2 = 0; l2 < c2.length; ++l2)
                          this.reinterpretExpressionAsPattern(c2[l2]);
                        e16 = {
                          type: "ArrowParameterPlaceHolder",
                          params: c2,
                          async: true
                        };
                      }
                    } else if (this.match("["))
                      this.context.isBindingElement = false, this.context.isAssignmentTarget = true, this.expect("["), a2 = this.isolateCoverGrammar(this.parseExpression), this.expect("]"), e16 = this.finalize(this.startNode(t4), new s.ComputedMemberExpression(e16, a2));
                    else {
                      if (this.lookahead.type !== 10 || !this.lookahead.head)
                        break;
                      var u2 = this.parseTemplateLiteral();
                      e16 = this.finalize(this.startNode(t4), new s.TaggedTemplateExpression(e16, u2));
                    }
                  return this.context.allowIn = r2, e16;
                }, e15.prototype.parseSuper = function() {
                  var e16 = this.createNode();
                  return this.expectKeyword("super"), this.match("[") || this.match(".") || this.throwUnexpectedToken(this.lookahead), this.finalize(e16, new s.Super());
                }, e15.prototype.parseLeftHandSideExpression = function() {
                  r.assert(this.context.allowIn, "callee of new expression always allow in keyword.");
                  for (var e16 = this.startNode(this.lookahead), t4 = this.matchKeyword("super") && this.context.inFunctionBody ? this.parseSuper() : this.inheritCoverGrammar(this.matchKeyword("new") ? this.parseNewExpression : this.parsePrimaryExpression); ; )
                    if (this.match("[")) {
                      this.context.isBindingElement = false, this.context.isAssignmentTarget = true, this.expect("[");
                      var n3 = this.isolateCoverGrammar(this.parseExpression);
                      this.expect("]"), t4 = this.finalize(e16, new s.ComputedMemberExpression(t4, n3));
                    } else if (this.match("."))
                      this.context.isBindingElement = false, this.context.isAssignmentTarget = true, this.expect("."), n3 = this.parseIdentifierName(), t4 = this.finalize(e16, new s.StaticMemberExpression(t4, n3));
                    else {
                      if (this.lookahead.type !== 10 || !this.lookahead.head)
                        break;
                      var a2 = this.parseTemplateLiteral();
                      t4 = this.finalize(e16, new s.TaggedTemplateExpression(t4, a2));
                    }
                  return t4;
                }, e15.prototype.parseUpdateExpression = function() {
                  var e16, t4 = this.lookahead;
                  if (this.match("++") || this.match("--")) {
                    var n3 = this.startNode(t4), r2 = this.nextToken();
                    e16 = this.inheritCoverGrammar(this.parseUnaryExpression), this.context.strict && e16.type === l.Syntax.Identifier && this.scanner.isRestrictedWord(e16.name) && this.tolerateError(o.Messages.StrictLHSPrefix), this.context.isAssignmentTarget || this.tolerateError(o.Messages.InvalidLHSInAssignment);
                    var a2 = true;
                    e16 = this.finalize(n3, new s.UpdateExpression(r2.value, e16, a2)), this.context.isAssignmentTarget = false, this.context.isBindingElement = false;
                  } else if (e16 = this.inheritCoverGrammar(this.parseLeftHandSideExpressionAllowCall), !this.hasLineTerminator && this.lookahead.type === 7 && (this.match("++") || this.match("--"))) {
                    this.context.strict && e16.type === l.Syntax.Identifier && this.scanner.isRestrictedWord(e16.name) && this.tolerateError(o.Messages.StrictLHSPostfix), this.context.isAssignmentTarget || this.tolerateError(o.Messages.InvalidLHSInAssignment), this.context.isAssignmentTarget = false, this.context.isBindingElement = false;
                    var c2 = this.nextToken().value;
                    a2 = false, e16 = this.finalize(this.startNode(t4), new s.UpdateExpression(c2, e16, a2));
                  }
                  return e16;
                }, e15.prototype.parseAwaitExpression = function() {
                  var e16 = this.createNode();
                  this.nextToken();
                  var t4 = this.parseUnaryExpression();
                  return this.finalize(e16, new s.AwaitExpression(t4));
                }, e15.prototype.parseUnaryExpression = function() {
                  var e16;
                  if (this.match("+") || this.match("-") || this.match("~") || this.match("!") || this.matchKeyword("delete") || this.matchKeyword("void") || this.matchKeyword("typeof")) {
                    var t4 = this.startNode(this.lookahead), n3 = this.nextToken();
                    e16 = this.inheritCoverGrammar(this.parseUnaryExpression), e16 = this.finalize(t4, new s.UnaryExpression(n3.value, e16)), this.context.strict && e16.operator === "delete" && e16.argument.type === l.Syntax.Identifier && this.tolerateError(o.Messages.StrictDelete), this.context.isAssignmentTarget = false, this.context.isBindingElement = false;
                  } else
                    e16 = this.context.await && this.matchContextualKeyword("await") ? this.parseAwaitExpression() : this.parseUpdateExpression();
                  return e16;
                }, e15.prototype.parseExponentiationExpression = function() {
                  var e16 = this.lookahead, t4 = this.inheritCoverGrammar(this.parseUnaryExpression);
                  if (t4.type !== l.Syntax.UnaryExpression && this.match("**")) {
                    this.nextToken(), this.context.isAssignmentTarget = false, this.context.isBindingElement = false;
                    var n3 = t4, r2 = this.isolateCoverGrammar(this.parseExponentiationExpression);
                    t4 = this.finalize(this.startNode(e16), new s.BinaryExpression("**", n3, r2));
                  }
                  return t4;
                }, e15.prototype.binaryPrecedence = function(e16) {
                  var t4 = e16.value;
                  return e16.type === 7 ? this.operatorPrecedence[t4] || 0 : e16.type === 4 && (t4 === "instanceof" || this.context.allowIn && t4 === "in") ? 7 : 0;
                }, e15.prototype.parseBinaryExpression = function() {
                  var e16 = this.lookahead, t4 = this.inheritCoverGrammar(this.parseExponentiationExpression), n3 = this.lookahead, r2 = this.binaryPrecedence(n3);
                  if (r2 > 0) {
                    this.nextToken(), this.context.isAssignmentTarget = false, this.context.isBindingElement = false;
                    for (var a2 = [e16, this.lookahead], o2 = t4, c2 = this.isolateCoverGrammar(this.parseExponentiationExpression), l2 = [
                      o2,
                      n3.value,
                      c2
                    ], u2 = [r2]; !((r2 = this.binaryPrecedence(this.lookahead)) <= 0); ) {
                      for (; l2.length > 2 && r2 <= u2[u2.length - 1]; ) {
                        c2 = l2.pop();
                        var d = l2.pop();
                        u2.pop(), o2 = l2.pop(), a2.pop();
                        var f = this.startNode(a2[a2.length - 1]);
                        l2.push(this.finalize(f, new s.BinaryExpression(d, o2, c2)));
                      }
                      l2.push(this.nextToken().value), u2.push(r2), a2.push(this.lookahead), l2.push(this.isolateCoverGrammar(this.parseExponentiationExpression));
                    }
                    var p = l2.length - 1;
                    t4 = l2[p];
                    for (var m = a2.pop(); p > 1; ) {
                      var h = a2.pop(), g = m && m.lineStart;
                      f = this.startNode(h, g), d = l2[p - 1], t4 = this.finalize(f, new s.BinaryExpression(d, l2[p - 2], t4)), p -= 2, m = h;
                    }
                  }
                  return t4;
                }, e15.prototype.parseConditionalExpression = function() {
                  var e16 = this.lookahead, t4 = this.inheritCoverGrammar(this.parseBinaryExpression);
                  if (this.match("?")) {
                    this.nextToken();
                    var n3 = this.context.allowIn;
                    this.context.allowIn = true;
                    var r2 = this.isolateCoverGrammar(this.parseAssignmentExpression);
                    this.context.allowIn = n3, this.expect(":");
                    var a2 = this.isolateCoverGrammar(this.parseAssignmentExpression);
                    t4 = this.finalize(this.startNode(e16), new s.ConditionalExpression(t4, r2, a2)), this.context.isAssignmentTarget = false, this.context.isBindingElement = false;
                  }
                  return t4;
                }, e15.prototype.checkPatternParam = function(e16, t4) {
                  switch (t4.type) {
                    case l.Syntax.Identifier:
                      this.validateParam(e16, t4, t4.name);
                      break;
                    case l.Syntax.RestElement:
                      this.checkPatternParam(e16, t4.argument);
                      break;
                    case l.Syntax.AssignmentPattern:
                      this.checkPatternParam(e16, t4.left);
                      break;
                    case l.Syntax.ArrayPattern:
                      for (var n3 = 0; n3 < t4.elements.length; n3++)
                        t4.elements[n3] !== null && this.checkPatternParam(e16, t4.elements[n3]);
                      break;
                    case l.Syntax.ObjectPattern:
                      for (n3 = 0; n3 < t4.properties.length; n3++)
                        this.checkPatternParam(e16, t4.properties[n3].value);
                  }
                  e16.simple = e16.simple && t4 instanceof s.Identifier;
                }, e15.prototype.reinterpretAsCoverFormalsList = function(e16) {
                  var t4, n3 = [e16], r2 = false;
                  switch (e16.type) {
                    case l.Syntax.Identifier:
                      break;
                    case "ArrowParameterPlaceHolder":
                      n3 = e16.params, r2 = e16.async;
                      break;
                    default:
                      return null;
                  }
                  t4 = {
                    simple: true,
                    paramSet: {}
                  };
                  for (var a2 = 0; a2 < n3.length; ++a2)
                    (s2 = n3[a2]).type === l.Syntax.AssignmentPattern ? s2.right.type === l.Syntax.YieldExpression && (s2.right.argument && this.throwUnexpectedToken(this.lookahead), s2.right.type = l.Syntax.Identifier, s2.right.name = "yield", delete s2.right.argument, delete s2.right.delegate) : r2 && s2.type === l.Syntax.Identifier && s2.name === "await" && this.throwUnexpectedToken(this.lookahead), this.checkPatternParam(t4, s2), n3[a2] = s2;
                  if (this.context.strict || !this.context.allowYield)
                    for (a2 = 0; a2 < n3.length; ++a2) {
                      var s2;
                      (s2 = n3[a2]).type === l.Syntax.YieldExpression && this.throwUnexpectedToken(this.lookahead);
                    }
                  if (t4.message === o.Messages.StrictParamDupe) {
                    var c2 = this.context.strict ? t4.stricted : t4.firstRestricted;
                    this.throwUnexpectedToken(c2, t4.message);
                  }
                  return {
                    simple: t4.simple,
                    params: n3,
                    stricted: t4.stricted,
                    firstRestricted: t4.firstRestricted,
                    message: t4.message
                  };
                }, e15.prototype.parseAssignmentExpression = function() {
                  var e16;
                  if (!this.context.allowYield && this.matchKeyword("yield"))
                    e16 = this.parseYieldExpression();
                  else {
                    var t4 = this.lookahead, n3 = t4;
                    if (e16 = this.parseConditionalExpression(), n3.type === 3 && n3.lineNumber === this.lookahead.lineNumber && n3.value === "async" && (this.lookahead.type === 3 || this.matchKeyword("yield"))) {
                      var r2 = this.parsePrimaryExpression();
                      this.reinterpretExpressionAsPattern(r2), e16 = {
                        type: "ArrowParameterPlaceHolder",
                        params: [r2],
                        async: true
                      };
                    }
                    if (e16.type === "ArrowParameterPlaceHolder" || this.match("=>")) {
                      this.context.isAssignmentTarget = false, this.context.isBindingElement = false;
                      var a2 = e16.async, c2 = this.reinterpretAsCoverFormalsList(e16);
                      if (c2) {
                        this.hasLineTerminator && this.tolerateUnexpectedToken(this.lookahead), this.context.firstCoverInitializedNameError = null;
                        var u2 = this.context.strict, d = this.context.allowStrictDirective;
                        this.context.allowStrictDirective = c2.simple;
                        var f = this.context.allowYield, p = this.context.await;
                        this.context.allowYield = true, this.context.await = a2;
                        var m = this.startNode(t4);
                        this.expect("=>");
                        var h = void 0;
                        if (this.match("{")) {
                          var g = this.context.allowIn;
                          this.context.allowIn = true, h = this.parseFunctionSourceElements(), this.context.allowIn = g;
                        } else
                          h = this.isolateCoverGrammar(this.parseAssignmentExpression);
                        var _ = h.type !== l.Syntax.BlockStatement;
                        this.context.strict && c2.firstRestricted && this.throwUnexpectedToken(c2.firstRestricted, c2.message), this.context.strict && c2.stricted && this.tolerateUnexpectedToken(c2.stricted, c2.message), e16 = a2 ? this.finalize(m, new s.AsyncArrowFunctionExpression(c2.params, h, _)) : this.finalize(m, new s.ArrowFunctionExpression(c2.params, h, _)), this.context.strict = u2, this.context.allowStrictDirective = d, this.context.allowYield = f, this.context.await = p;
                      }
                    } else if (this.matchAssign()) {
                      if (this.context.isAssignmentTarget || this.tolerateError(o.Messages.InvalidLHSInAssignment), this.context.strict && e16.type === l.Syntax.Identifier) {
                        var v = e16;
                        this.scanner.isRestrictedWord(v.name) && this.tolerateUnexpectedToken(n3, o.Messages.StrictLHSAssignment), this.scanner.isStrictModeReservedWord(v.name) && this.tolerateUnexpectedToken(n3, o.Messages.StrictReservedWord);
                      }
                      this.match("=") ? this.reinterpretExpressionAsPattern(e16) : (this.context.isAssignmentTarget = false, this.context.isBindingElement = false);
                      var y = (n3 = this.nextToken()).value, b = this.isolateCoverGrammar(this.parseAssignmentExpression);
                      e16 = this.finalize(this.startNode(t4), new s.AssignmentExpression(y, e16, b)), this.context.firstCoverInitializedNameError = null;
                    }
                  }
                  return e16;
                }, e15.prototype.parseExpression = function() {
                  var e16 = this.lookahead, t4 = this.isolateCoverGrammar(this.parseAssignmentExpression);
                  if (this.match(",")) {
                    var n3 = [];
                    for (n3.push(t4); this.lookahead.type !== 2 && this.match(","); )
                      this.nextToken(), n3.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
                    t4 = this.finalize(this.startNode(e16), new s.SequenceExpression(n3));
                  }
                  return t4;
                }, e15.prototype.parseStatementListItem = function() {
                  var e16;
                  if (this.context.isAssignmentTarget = true, this.context.isBindingElement = true, this.lookahead.type === 4)
                    switch (this.lookahead.value) {
                      case "export":
                        this.context.isModule || this.tolerateUnexpectedToken(this.lookahead, o.Messages.IllegalExportDeclaration), e16 = this.parseExportDeclaration();
                        break;
                      case "import":
                        this.context.isModule || this.tolerateUnexpectedToken(this.lookahead, o.Messages.IllegalImportDeclaration), e16 = this.parseImportDeclaration();
                        break;
                      case "const":
                        e16 = this.parseLexicalDeclaration({ inFor: false });
                        break;
                      case "function":
                        e16 = this.parseFunctionDeclaration();
                        break;
                      case "class":
                        e16 = this.parseClassDeclaration();
                        break;
                      case "let":
                        e16 = this.isLexicalDeclaration() ? this.parseLexicalDeclaration({ inFor: false }) : this.parseStatement();
                        break;
                      default:
                        e16 = this.parseStatement();
                    }
                  else
                    e16 = this.parseStatement();
                  return e16;
                }, e15.prototype.parseBlock = function() {
                  var e16 = this.createNode();
                  this.expect("{");
                  for (var t4 = []; !this.match("}"); )
                    t4.push(this.parseStatementListItem());
                  return this.expect("}"), this.finalize(e16, new s.BlockStatement(t4));
                }, e15.prototype.parseLexicalBinding = function(e16, t4) {
                  var n3 = this.createNode(), r2 = this.parsePattern([], e16);
                  this.context.strict && r2.type === l.Syntax.Identifier && this.scanner.isRestrictedWord(r2.name) && this.tolerateError(o.Messages.StrictVarName);
                  var a2 = null;
                  return e16 === "const" ? this.matchKeyword("in") || this.matchContextualKeyword("of") || (this.match("=") ? (this.nextToken(), a2 = this.isolateCoverGrammar(this.parseAssignmentExpression)) : this.throwError(o.Messages.DeclarationMissingInitializer, "const")) : (!t4.inFor && r2.type !== l.Syntax.Identifier || this.match("=")) && (this.expect("="), a2 = this.isolateCoverGrammar(this.parseAssignmentExpression)), this.finalize(n3, new s.VariableDeclarator(r2, a2));
                }, e15.prototype.parseBindingList = function(e16, t4) {
                  for (var n3 = [this.parseLexicalBinding(e16, t4)]; this.match(","); )
                    this.nextToken(), n3.push(this.parseLexicalBinding(e16, t4));
                  return n3;
                }, e15.prototype.isLexicalDeclaration = function() {
                  var e16 = this.scanner.saveState();
                  this.scanner.scanComments();
                  var t4 = this.scanner.lex();
                  return this.scanner.restoreState(e16), t4.type === 3 || t4.type === 7 && t4.value === "[" || t4.type === 7 && t4.value === "{" || t4.type === 4 && t4.value === "let" || t4.type === 4 && t4.value === "yield";
                }, e15.prototype.parseLexicalDeclaration = function(e16) {
                  var t4 = this.createNode(), n3 = this.nextToken().value;
                  r.assert(n3 === "let" || n3 === "const", "Lexical declaration must be either let or const");
                  var a2 = this.parseBindingList(n3, e16);
                  return this.consumeSemicolon(), this.finalize(t4, new s.VariableDeclaration(a2, n3));
                }, e15.prototype.parseBindingRestElement = function(e16, t4) {
                  var n3 = this.createNode();
                  this.expect("...");
                  var r2 = this.parsePattern(e16, t4);
                  return this.finalize(n3, new s.RestElement(r2));
                }, e15.prototype.parseArrayPattern = function(e16, t4) {
                  var n3 = this.createNode();
                  this.expect("[");
                  for (var r2 = []; !this.match("]"); )
                    if (this.match(","))
                      this.nextToken(), r2.push(null);
                    else {
                      if (this.match("...")) {
                        r2.push(this.parseBindingRestElement(e16, t4));
                        break;
                      }
                      r2.push(this.parsePatternWithDefault(e16, t4)), this.match("]") || this.expect(",");
                    }
                  return this.expect("]"), this.finalize(n3, new s.ArrayPattern(r2));
                }, e15.prototype.parsePropertyPattern = function(e16, t4) {
                  var n3, r2, a2 = this.createNode(), o2 = false, c2 = false;
                  if (this.lookahead.type === 3) {
                    var l2 = this.lookahead;
                    n3 = this.parseVariableIdentifier();
                    var u2 = this.finalize(a2, new s.Identifier(l2.value));
                    if (this.match("=")) {
                      e16.push(l2), c2 = true, this.nextToken();
                      var d = this.parseAssignmentExpression();
                      r2 = this.finalize(this.startNode(l2), new s.AssignmentPattern(u2, d));
                    } else
                      this.match(":") ? (this.expect(":"), r2 = this.parsePatternWithDefault(e16, t4)) : (e16.push(l2), c2 = true, r2 = u2);
                  } else
                    o2 = this.match("["), n3 = this.parseObjectPropertyKey(), this.expect(":"), r2 = this.parsePatternWithDefault(e16, t4);
                  return this.finalize(a2, new s.Property("init", n3, o2, r2, false, c2));
                }, e15.prototype.parseObjectPattern = function(e16, t4) {
                  var n3 = this.createNode(), r2 = [];
                  for (this.expect("{"); !this.match("}"); )
                    r2.push(this.parsePropertyPattern(e16, t4)), this.match("}") || this.expect(",");
                  return this.expect("}"), this.finalize(n3, new s.ObjectPattern(r2));
                }, e15.prototype.parsePattern = function(e16, t4) {
                  var n3;
                  return this.match("[") ? n3 = this.parseArrayPattern(e16, t4) : this.match("{") ? n3 = this.parseObjectPattern(e16, t4) : (!this.matchKeyword("let") || t4 !== "const" && t4 !== "let" || this.tolerateUnexpectedToken(this.lookahead, o.Messages.LetInLexicalBinding), e16.push(this.lookahead), n3 = this.parseVariableIdentifier(t4)), n3;
                }, e15.prototype.parsePatternWithDefault = function(e16, t4) {
                  var n3 = this.lookahead, r2 = this.parsePattern(e16, t4);
                  if (this.match("=")) {
                    this.nextToken();
                    var a2 = this.context.allowYield;
                    this.context.allowYield = true;
                    var o2 = this.isolateCoverGrammar(this.parseAssignmentExpression);
                    this.context.allowYield = a2, r2 = this.finalize(this.startNode(n3), new s.AssignmentPattern(r2, o2));
                  }
                  return r2;
                }, e15.prototype.parseVariableIdentifier = function(e16) {
                  var t4 = this.createNode(), n3 = this.nextToken();
                  return n3.type === 4 && n3.value === "yield" ? this.context.strict ? this.tolerateUnexpectedToken(n3, o.Messages.StrictReservedWord) : this.context.allowYield || this.throwUnexpectedToken(n3) : n3.type === 3 ? (this.context.isModule || this.context.await) && n3.type === 3 && n3.value === "await" && this.tolerateUnexpectedToken(n3) : this.context.strict && n3.type === 4 && this.scanner.isStrictModeReservedWord(n3.value) ? this.tolerateUnexpectedToken(n3, o.Messages.StrictReservedWord) : (this.context.strict || n3.value !== "let" || e16 !== "var") && this.throwUnexpectedToken(n3), this.finalize(t4, new s.Identifier(n3.value));
                }, e15.prototype.parseVariableDeclaration = function(e16) {
                  var t4 = this.createNode(), n3 = this.parsePattern([], "var");
                  this.context.strict && n3.type === l.Syntax.Identifier && this.scanner.isRestrictedWord(n3.name) && this.tolerateError(o.Messages.StrictVarName);
                  var r2 = null;
                  return this.match("=") ? (this.nextToken(), r2 = this.isolateCoverGrammar(this.parseAssignmentExpression)) : n3.type === l.Syntax.Identifier || e16.inFor || this.expect("="), this.finalize(t4, new s.VariableDeclarator(n3, r2));
                }, e15.prototype.parseVariableDeclarationList = function(e16) {
                  var t4 = { inFor: e16.inFor }, n3 = [];
                  for (n3.push(this.parseVariableDeclaration(t4)); this.match(","); )
                    this.nextToken(), n3.push(this.parseVariableDeclaration(t4));
                  return n3;
                }, e15.prototype.parseVariableStatement = function() {
                  var e16 = this.createNode();
                  this.expectKeyword("var");
                  var t4 = this.parseVariableDeclarationList({ inFor: false });
                  return this.consumeSemicolon(), this.finalize(e16, new s.VariableDeclaration(t4, "var"));
                }, e15.prototype.parseEmptyStatement = function() {
                  var e16 = this.createNode();
                  return this.expect(";"), this.finalize(e16, new s.EmptyStatement());
                }, e15.prototype.parseExpressionStatement = function() {
                  var e16 = this.createNode(), t4 = this.parseExpression();
                  return this.consumeSemicolon(), this.finalize(e16, new s.ExpressionStatement(t4));
                }, e15.prototype.parseIfClause = function() {
                  return this.context.strict && this.matchKeyword("function") && this.tolerateError(o.Messages.StrictFunction), this.parseStatement();
                }, e15.prototype.parseIfStatement = function() {
                  var e16, t4 = this.createNode(), n3 = null;
                  this.expectKeyword("if"), this.expect("(");
                  var r2 = this.parseExpression();
                  return !this.match(")") && this.config.tolerant ? (this.tolerateUnexpectedToken(this.nextToken()), e16 = this.finalize(this.createNode(), new s.EmptyStatement())) : (this.expect(")"), e16 = this.parseIfClause(), this.matchKeyword("else") && (this.nextToken(), n3 = this.parseIfClause())), this.finalize(t4, new s.IfStatement(r2, e16, n3));
                }, e15.prototype.parseDoWhileStatement = function() {
                  var e16 = this.createNode();
                  this.expectKeyword("do");
                  var t4 = this.context.inIteration;
                  this.context.inIteration = true;
                  var n3 = this.parseStatement();
                  this.context.inIteration = t4, this.expectKeyword("while"), this.expect("(");
                  var r2 = this.parseExpression();
                  return !this.match(")") && this.config.tolerant ? this.tolerateUnexpectedToken(this.nextToken()) : (this.expect(")"), this.match(";") && this.nextToken()), this.finalize(e16, new s.DoWhileStatement(n3, r2));
                }, e15.prototype.parseWhileStatement = function() {
                  var e16, t4 = this.createNode();
                  this.expectKeyword("while"), this.expect("(");
                  var n3 = this.parseExpression();
                  if (!this.match(")") && this.config.tolerant)
                    this.tolerateUnexpectedToken(this.nextToken()), e16 = this.finalize(this.createNode(), new s.EmptyStatement());
                  else {
                    this.expect(")");
                    var r2 = this.context.inIteration;
                    this.context.inIteration = true, e16 = this.parseStatement(), this.context.inIteration = r2;
                  }
                  return this.finalize(t4, new s.WhileStatement(n3, e16));
                }, e15.prototype.parseForStatement = function() {
                  var e16, t4, n3, r2 = null, a2 = null, c2 = null, u2 = true, d = this.createNode();
                  if (this.expectKeyword("for"), this.expect("("), this.match(";"))
                    this.nextToken();
                  else if (this.matchKeyword("var")) {
                    r2 = this.createNode(), this.nextToken();
                    var f = this.context.allowIn;
                    this.context.allowIn = false;
                    var p = this.parseVariableDeclarationList({ inFor: true });
                    if (this.context.allowIn = f, p.length === 1 && this.matchKeyword("in")) {
                      var m = p[0];
                      m.init && (m.id.type === l.Syntax.ArrayPattern || m.id.type === l.Syntax.ObjectPattern || this.context.strict) && this.tolerateError(o.Messages.ForInOfLoopInitializer, "for-in"), r2 = this.finalize(r2, new s.VariableDeclaration(p, "var")), this.nextToken(), e16 = r2, t4 = this.parseExpression(), r2 = null;
                    } else
                      p.length === 1 && p[0].init === null && this.matchContextualKeyword("of") ? (r2 = this.finalize(r2, new s.VariableDeclaration(p, "var")), this.nextToken(), e16 = r2, t4 = this.parseAssignmentExpression(), r2 = null, u2 = false) : (r2 = this.finalize(r2, new s.VariableDeclaration(p, "var")), this.expect(";"));
                  } else if (this.matchKeyword("const") || this.matchKeyword("let")) {
                    r2 = this.createNode();
                    var h = this.nextToken().value;
                    this.context.strict || this.lookahead.value !== "in" ? (f = this.context.allowIn, this.context.allowIn = false, p = this.parseBindingList(h, { inFor: true }), this.context.allowIn = f, p.length === 1 && p[0].init === null && this.matchKeyword("in") ? (r2 = this.finalize(r2, new s.VariableDeclaration(p, h)), this.nextToken(), e16 = r2, t4 = this.parseExpression(), r2 = null) : p.length === 1 && p[0].init === null && this.matchContextualKeyword("of") ? (r2 = this.finalize(r2, new s.VariableDeclaration(p, h)), this.nextToken(), e16 = r2, t4 = this.parseAssignmentExpression(), r2 = null, u2 = false) : (this.consumeSemicolon(), r2 = this.finalize(r2, new s.VariableDeclaration(p, h)))) : (r2 = this.finalize(r2, new s.Identifier(h)), this.nextToken(), e16 = r2, t4 = this.parseExpression(), r2 = null);
                  } else {
                    var g = this.lookahead;
                    if (f = this.context.allowIn, this.context.allowIn = false, r2 = this.inheritCoverGrammar(this.parseAssignmentExpression), this.context.allowIn = f, this.matchKeyword("in"))
                      this.context.isAssignmentTarget && r2.type !== l.Syntax.AssignmentExpression || this.tolerateError(o.Messages.InvalidLHSInForIn), this.nextToken(), this.reinterpretExpressionAsPattern(r2), e16 = r2, t4 = this.parseExpression(), r2 = null;
                    else if (this.matchContextualKeyword("of"))
                      this.context.isAssignmentTarget && r2.type !== l.Syntax.AssignmentExpression || this.tolerateError(o.Messages.InvalidLHSInForLoop), this.nextToken(), this.reinterpretExpressionAsPattern(r2), e16 = r2, t4 = this.parseAssignmentExpression(), r2 = null, u2 = false;
                    else {
                      if (this.match(",")) {
                        for (var _ = [r2]; this.match(","); )
                          this.nextToken(), _.push(this.isolateCoverGrammar(this.parseAssignmentExpression));
                        r2 = this.finalize(this.startNode(g), new s.SequenceExpression(_));
                      }
                      this.expect(";");
                    }
                  }
                  if (e16 === void 0 && (this.match(";") || (a2 = this.parseExpression()), this.expect(";"), this.match(")") || (c2 = this.parseExpression())), !this.match(")") && this.config.tolerant)
                    this.tolerateUnexpectedToken(this.nextToken()), n3 = this.finalize(this.createNode(), new s.EmptyStatement());
                  else {
                    this.expect(")");
                    var v = this.context.inIteration;
                    this.context.inIteration = true, n3 = this.isolateCoverGrammar(this.parseStatement), this.context.inIteration = v;
                  }
                  return e16 === void 0 ? this.finalize(d, new s.ForStatement(r2, a2, c2, n3)) : u2 ? this.finalize(d, new s.ForInStatement(e16, t4, n3)) : this.finalize(d, new s.ForOfStatement(e16, t4, n3));
                }, e15.prototype.parseContinueStatement = function() {
                  var e16 = this.createNode();
                  this.expectKeyword("continue");
                  var t4 = null;
                  if (this.lookahead.type === 3 && !this.hasLineTerminator) {
                    var n3 = this.parseVariableIdentifier();
                    t4 = n3;
                    var r2 = "$" + n3.name;
                    Object.prototype.hasOwnProperty.call(this.context.labelSet, r2) || this.throwError(o.Messages.UnknownLabel, n3.name);
                  }
                  return this.consumeSemicolon(), t4 !== null || this.context.inIteration || this.throwError(o.Messages.IllegalContinue), this.finalize(e16, new s.ContinueStatement(t4));
                }, e15.prototype.parseBreakStatement = function() {
                  var e16 = this.createNode();
                  this.expectKeyword("break");
                  var t4 = null;
                  if (this.lookahead.type === 3 && !this.hasLineTerminator) {
                    var n3 = this.parseVariableIdentifier(), r2 = "$" + n3.name;
                    Object.prototype.hasOwnProperty.call(this.context.labelSet, r2) || this.throwError(o.Messages.UnknownLabel, n3.name), t4 = n3;
                  }
                  return this.consumeSemicolon(), t4 !== null || this.context.inIteration || this.context.inSwitch || this.throwError(o.Messages.IllegalBreak), this.finalize(e16, new s.BreakStatement(t4));
                }, e15.prototype.parseReturnStatement = function() {
                  this.context.inFunctionBody || this.tolerateError(o.Messages.IllegalReturn);
                  var e16 = this.createNode();
                  this.expectKeyword("return");
                  var t4 = (this.match(";") || this.match("}") || this.hasLineTerminator || this.lookahead.type === 2) && this.lookahead.type !== 8 && this.lookahead.type !== 10 ? null : this.parseExpression();
                  return this.consumeSemicolon(), this.finalize(e16, new s.ReturnStatement(t4));
                }, e15.prototype.parseWithStatement = function() {
                  this.context.strict && this.tolerateError(o.Messages.StrictModeWith);
                  var e16, t4 = this.createNode();
                  this.expectKeyword("with"), this.expect("(");
                  var n3 = this.parseExpression();
                  return !this.match(")") && this.config.tolerant ? (this.tolerateUnexpectedToken(this.nextToken()), e16 = this.finalize(this.createNode(), new s.EmptyStatement())) : (this.expect(")"), e16 = this.parseStatement()), this.finalize(t4, new s.WithStatement(n3, e16));
                }, e15.prototype.parseSwitchCase = function() {
                  var e16, t4 = this.createNode();
                  this.matchKeyword("default") ? (this.nextToken(), e16 = null) : (this.expectKeyword("case"), e16 = this.parseExpression()), this.expect(":");
                  for (var n3 = []; !(this.match("}") || this.matchKeyword("default") || this.matchKeyword("case")); )
                    n3.push(this.parseStatementListItem());
                  return this.finalize(t4, new s.SwitchCase(e16, n3));
                }, e15.prototype.parseSwitchStatement = function() {
                  var e16 = this.createNode();
                  this.expectKeyword("switch"), this.expect("(");
                  var t4 = this.parseExpression();
                  this.expect(")");
                  var n3 = this.context.inSwitch;
                  this.context.inSwitch = true;
                  var r2 = [], a2 = false;
                  for (this.expect("{"); !this.match("}"); ) {
                    var c2 = this.parseSwitchCase();
                    c2.test === null && (a2 && this.throwError(o.Messages.MultipleDefaultsInSwitch), a2 = true), r2.push(c2);
                  }
                  return this.expect("}"), this.context.inSwitch = n3, this.finalize(e16, new s.SwitchStatement(t4, r2));
                }, e15.prototype.parseLabelledStatement = function() {
                  var e16, t4 = this.createNode(), n3 = this.parseExpression();
                  if (n3.type === l.Syntax.Identifier && this.match(":")) {
                    this.nextToken();
                    var r2 = n3, a2 = "$" + r2.name;
                    Object.prototype.hasOwnProperty.call(this.context.labelSet, a2) && this.throwError(o.Messages.Redeclaration, "Label", r2.name), this.context.labelSet[a2] = true;
                    var c2 = void 0;
                    if (this.matchKeyword("class"))
                      this.tolerateUnexpectedToken(this.lookahead), c2 = this.parseClassDeclaration();
                    else if (this.matchKeyword("function")) {
                      var u2 = this.lookahead, d = this.parseFunctionDeclaration();
                      this.context.strict ? this.tolerateUnexpectedToken(u2, o.Messages.StrictFunction) : d.generator && this.tolerateUnexpectedToken(u2, o.Messages.GeneratorInLegacyContext), c2 = d;
                    } else
                      c2 = this.parseStatement();
                    delete this.context.labelSet[a2], e16 = new s.LabeledStatement(r2, c2);
                  } else
                    this.consumeSemicolon(), e16 = new s.ExpressionStatement(n3);
                  return this.finalize(t4, e16);
                }, e15.prototype.parseThrowStatement = function() {
                  var e16 = this.createNode();
                  this.expectKeyword("throw"), this.hasLineTerminator && this.throwError(o.Messages.NewlineAfterThrow);
                  var t4 = this.parseExpression();
                  return this.consumeSemicolon(), this.finalize(e16, new s.ThrowStatement(t4));
                }, e15.prototype.parseCatchClause = function() {
                  var e16 = this.createNode();
                  this.expectKeyword("catch"), this.expect("("), this.match(")") && this.throwUnexpectedToken(this.lookahead);
                  for (var t4 = [], n3 = this.parsePattern(t4), r2 = {}, a2 = 0; a2 < t4.length; a2++) {
                    var c2 = "$" + t4[a2].value;
                    Object.prototype.hasOwnProperty.call(r2, c2) && this.tolerateError(o.Messages.DuplicateBinding, t4[a2].value), r2[c2] = true;
                  }
                  this.context.strict && n3.type === l.Syntax.Identifier && this.scanner.isRestrictedWord(n3.name) && this.tolerateError(o.Messages.StrictCatchVariable), this.expect(")");
                  var u2 = this.parseBlock();
                  return this.finalize(e16, new s.CatchClause(n3, u2));
                }, e15.prototype.parseFinallyClause = function() {
                  return this.expectKeyword("finally"), this.parseBlock();
                }, e15.prototype.parseTryStatement = function() {
                  var e16 = this.createNode();
                  this.expectKeyword("try");
                  var t4 = this.parseBlock(), n3 = this.matchKeyword("catch") ? this.parseCatchClause() : null, r2 = this.matchKeyword("finally") ? this.parseFinallyClause() : null;
                  return n3 || r2 || this.throwError(o.Messages.NoCatchOrFinally), this.finalize(e16, new s.TryStatement(t4, n3, r2));
                }, e15.prototype.parseDebuggerStatement = function() {
                  var e16 = this.createNode();
                  return this.expectKeyword("debugger"), this.consumeSemicolon(), this.finalize(e16, new s.DebuggerStatement());
                }, e15.prototype.parseStatement = function() {
                  var e16;
                  switch (this.lookahead.type) {
                    case 1:
                    case 5:
                    case 6:
                    case 8:
                    case 10:
                    case 9:
                      e16 = this.parseExpressionStatement();
                      break;
                    case 7:
                      var t4 = this.lookahead.value;
                      e16 = t4 === "{" ? this.parseBlock() : t4 === "(" ? this.parseExpressionStatement() : t4 === ";" ? this.parseEmptyStatement() : this.parseExpressionStatement();
                      break;
                    case 3:
                      e16 = this.matchAsyncFunction() ? this.parseFunctionDeclaration() : this.parseLabelledStatement();
                      break;
                    case 4:
                      switch (this.lookahead.value) {
                        case "break":
                          e16 = this.parseBreakStatement();
                          break;
                        case "continue":
                          e16 = this.parseContinueStatement();
                          break;
                        case "debugger":
                          e16 = this.parseDebuggerStatement();
                          break;
                        case "do":
                          e16 = this.parseDoWhileStatement();
                          break;
                        case "for":
                          e16 = this.parseForStatement();
                          break;
                        case "function":
                          e16 = this.parseFunctionDeclaration();
                          break;
                        case "if":
                          e16 = this.parseIfStatement();
                          break;
                        case "return":
                          e16 = this.parseReturnStatement();
                          break;
                        case "switch":
                          e16 = this.parseSwitchStatement();
                          break;
                        case "throw":
                          e16 = this.parseThrowStatement();
                          break;
                        case "try":
                          e16 = this.parseTryStatement();
                          break;
                        case "var":
                          e16 = this.parseVariableStatement();
                          break;
                        case "while":
                          e16 = this.parseWhileStatement();
                          break;
                        case "with":
                          e16 = this.parseWithStatement();
                          break;
                        default:
                          e16 = this.parseExpressionStatement();
                      }
                      break;
                    default:
                      e16 = this.throwUnexpectedToken(this.lookahead);
                  }
                  return e16;
                }, e15.prototype.parseFunctionSourceElements = function() {
                  var e16 = this.createNode();
                  this.expect("{");
                  var t4 = this.parseDirectivePrologues(), n3 = this.context.labelSet, r2 = this.context.inIteration, a2 = this.context.inSwitch, o2 = this.context.inFunctionBody;
                  for (this.context.labelSet = {}, this.context.inIteration = false, this.context.inSwitch = false, this.context.inFunctionBody = true; this.lookahead.type !== 2 && !this.match("}"); )
                    t4.push(this.parseStatementListItem());
                  return this.expect("}"), this.context.labelSet = n3, this.context.inIteration = r2, this.context.inSwitch = a2, this.context.inFunctionBody = o2, this.finalize(e16, new s.BlockStatement(t4));
                }, e15.prototype.validateParam = function(e16, t4, n3) {
                  var r2 = "$" + n3;
                  this.context.strict ? (this.scanner.isRestrictedWord(n3) && (e16.stricted = t4, e16.message = o.Messages.StrictParamName), Object.prototype.hasOwnProperty.call(e16.paramSet, r2) && (e16.stricted = t4, e16.message = o.Messages.StrictParamDupe)) : e16.firstRestricted || (this.scanner.isRestrictedWord(n3) ? (e16.firstRestricted = t4, e16.message = o.Messages.StrictParamName) : this.scanner.isStrictModeReservedWord(n3) ? (e16.firstRestricted = t4, e16.message = o.Messages.StrictReservedWord) : Object.prototype.hasOwnProperty.call(e16.paramSet, r2) && (e16.stricted = t4, e16.message = o.Messages.StrictParamDupe)), typeof Object.defineProperty == "function" ? Object.defineProperty(e16.paramSet, r2, {
                    value: true,
                    enumerable: true,
                    writable: true,
                    configurable: true
                  }) : e16.paramSet[r2] = true;
                }, e15.prototype.parseRestElement = function(e16) {
                  var t4 = this.createNode();
                  this.expect("...");
                  var n3 = this.parsePattern(e16);
                  return this.match("=") && this.throwError(o.Messages.DefaultRestParameter), this.match(")") || this.throwError(o.Messages.ParameterAfterRestParameter), this.finalize(t4, new s.RestElement(n3));
                }, e15.prototype.parseFormalParameter = function(e16) {
                  for (var t4 = [], n3 = this.match("...") ? this.parseRestElement(t4) : this.parsePatternWithDefault(t4), r2 = 0; r2 < t4.length; r2++)
                    this.validateParam(e16, t4[r2], t4[r2].value);
                  e16.simple = e16.simple && n3 instanceof s.Identifier, e16.params.push(n3);
                }, e15.prototype.parseFormalParameters = function(e16) {
                  var t4;
                  if (t4 = {
                    simple: true,
                    params: [],
                    firstRestricted: e16
                  }, this.expect("("), !this.match(")"))
                    for (t4.paramSet = {}; this.lookahead.type !== 2 && (this.parseFormalParameter(t4), !this.match(")")) && (this.expect(","), !this.match(")")); )
                      ;
                  return this.expect(")"), {
                    simple: t4.simple,
                    params: t4.params,
                    stricted: t4.stricted,
                    firstRestricted: t4.firstRestricted,
                    message: t4.message
                  };
                }, e15.prototype.matchAsyncFunction = function() {
                  var e16 = this.matchContextualKeyword("async");
                  if (e16) {
                    var t4 = this.scanner.saveState();
                    this.scanner.scanComments();
                    var n3 = this.scanner.lex();
                    this.scanner.restoreState(t4), e16 = t4.lineNumber === n3.lineNumber && n3.type === 4 && n3.value === "function";
                  }
                  return e16;
                }, e15.prototype.parseFunctionDeclaration = function(e16) {
                  var t4 = this.createNode(), n3 = this.matchContextualKeyword("async");
                  n3 && this.nextToken(), this.expectKeyword("function");
                  var r2, a2 = !n3 && this.match("*");
                  a2 && this.nextToken();
                  var c2 = null, l2 = null;
                  if (!e16 || !this.match("(")) {
                    var u2 = this.lookahead;
                    c2 = this.parseVariableIdentifier(), this.context.strict ? this.scanner.isRestrictedWord(u2.value) && this.tolerateUnexpectedToken(u2, o.Messages.StrictFunctionName) : this.scanner.isRestrictedWord(u2.value) ? (l2 = u2, r2 = o.Messages.StrictFunctionName) : this.scanner.isStrictModeReservedWord(u2.value) && (l2 = u2, r2 = o.Messages.StrictReservedWord);
                  }
                  var d = this.context.await, f = this.context.allowYield;
                  this.context.await = n3, this.context.allowYield = !a2;
                  var p = this.parseFormalParameters(l2), m = p.params, h = p.stricted;
                  l2 = p.firstRestricted, p.message && (r2 = p.message);
                  var g = this.context.strict, _ = this.context.allowStrictDirective;
                  this.context.allowStrictDirective = p.simple;
                  var v = this.parseFunctionSourceElements();
                  return this.context.strict && l2 && this.throwUnexpectedToken(l2, r2), this.context.strict && h && this.tolerateUnexpectedToken(h, r2), this.context.strict = g, this.context.allowStrictDirective = _, this.context.await = d, this.context.allowYield = f, n3 ? this.finalize(t4, new s.AsyncFunctionDeclaration(c2, m, v)) : this.finalize(t4, new s.FunctionDeclaration(c2, m, v, a2));
                }, e15.prototype.parseFunctionExpression = function() {
                  var e16 = this.createNode(), t4 = this.matchContextualKeyword("async");
                  t4 && this.nextToken(), this.expectKeyword("function");
                  var n3, r2 = !t4 && this.match("*");
                  r2 && this.nextToken();
                  var a2, c2 = null, l2 = this.context.await, u2 = this.context.allowYield;
                  if (this.context.await = t4, this.context.allowYield = !r2, !this.match("(")) {
                    var d = this.lookahead;
                    c2 = this.context.strict || r2 || !this.matchKeyword("yield") ? this.parseVariableIdentifier() : this.parseIdentifierName(), this.context.strict ? this.scanner.isRestrictedWord(d.value) && this.tolerateUnexpectedToken(d, o.Messages.StrictFunctionName) : this.scanner.isRestrictedWord(d.value) ? (a2 = d, n3 = o.Messages.StrictFunctionName) : this.scanner.isStrictModeReservedWord(d.value) && (a2 = d, n3 = o.Messages.StrictReservedWord);
                  }
                  var f = this.parseFormalParameters(a2), p = f.params, m = f.stricted;
                  a2 = f.firstRestricted, f.message && (n3 = f.message);
                  var h = this.context.strict, g = this.context.allowStrictDirective;
                  this.context.allowStrictDirective = f.simple;
                  var _ = this.parseFunctionSourceElements();
                  return this.context.strict && a2 && this.throwUnexpectedToken(a2, n3), this.context.strict && m && this.tolerateUnexpectedToken(m, n3), this.context.strict = h, this.context.allowStrictDirective = g, this.context.await = l2, this.context.allowYield = u2, t4 ? this.finalize(e16, new s.AsyncFunctionExpression(c2, p, _)) : this.finalize(e16, new s.FunctionExpression(c2, p, _, r2));
                }, e15.prototype.parseDirective = function() {
                  var e16 = this.lookahead, t4 = this.createNode(), n3 = this.parseExpression(), r2 = n3.type === l.Syntax.Literal ? this.getTokenRaw(e16).slice(1, -1) : null;
                  return this.consumeSemicolon(), this.finalize(t4, r2 ? new s.Directive(n3, r2) : new s.ExpressionStatement(n3));
                }, e15.prototype.parseDirectivePrologues = function() {
                  for (var e16 = null, t4 = []; ; ) {
                    var n3 = this.lookahead;
                    if (n3.type !== 8)
                      break;
                    var r2 = this.parseDirective();
                    t4.push(r2);
                    var a2 = r2.directive;
                    if (typeof a2 != "string")
                      break;
                    a2 === "use strict" ? (this.context.strict = true, e16 && this.tolerateUnexpectedToken(e16, o.Messages.StrictOctalLiteral), this.context.allowStrictDirective || this.tolerateUnexpectedToken(n3, o.Messages.IllegalLanguageModeDirective)) : !e16 && n3.octal && (e16 = n3);
                  }
                  return t4;
                }, e15.prototype.qualifiedPropertyName = function(e16) {
                  switch (e16.type) {
                    case 3:
                    case 8:
                    case 1:
                    case 5:
                    case 6:
                    case 4:
                      return true;
                    case 7:
                      return e16.value === "[";
                  }
                  return false;
                }, e15.prototype.parseGetterMethod = function() {
                  var e16 = this.createNode(), t4 = this.context.allowYield;
                  this.context.allowYield = true;
                  var n3 = this.parseFormalParameters();
                  n3.params.length > 0 && this.tolerateError(o.Messages.BadGetterArity);
                  var r2 = this.parsePropertyMethod(n3);
                  return this.context.allowYield = t4, this.finalize(e16, new s.FunctionExpression(null, n3.params, r2, false));
                }, e15.prototype.parseSetterMethod = function() {
                  var e16 = this.createNode(), t4 = this.context.allowYield;
                  this.context.allowYield = true;
                  var n3 = this.parseFormalParameters();
                  n3.params.length === 1 ? n3.params[0] instanceof s.RestElement && this.tolerateError(o.Messages.BadSetterRestParameter) : this.tolerateError(o.Messages.BadSetterArity);
                  var r2 = this.parsePropertyMethod(n3);
                  return this.context.allowYield = t4, this.finalize(e16, new s.FunctionExpression(null, n3.params, r2, false));
                }, e15.prototype.parseGeneratorMethod = function() {
                  var e16 = this.createNode(), t4 = this.context.allowYield;
                  this.context.allowYield = true;
                  var n3 = this.parseFormalParameters();
                  this.context.allowYield = false;
                  var r2 = this.parsePropertyMethod(n3);
                  return this.context.allowYield = t4, this.finalize(e16, new s.FunctionExpression(null, n3.params, r2, true));
                }, e15.prototype.isStartOfExpression = function() {
                  var e16 = true, t4 = this.lookahead.value;
                  switch (this.lookahead.type) {
                    case 7:
                      e16 = t4 === "[" || t4 === "(" || t4 === "{" || t4 === "+" || t4 === "-" || t4 === "!" || t4 === "~" || t4 === "++" || t4 === "--" || t4 === "/" || t4 === "/=";
                      break;
                    case 4:
                      e16 = t4 === "class" || t4 === "delete" || t4 === "function" || t4 === "let" || t4 === "new" || t4 === "super" || t4 === "this" || t4 === "typeof" || t4 === "void" || t4 === "yield";
                  }
                  return e16;
                }, e15.prototype.parseYieldExpression = function() {
                  var e16 = this.createNode();
                  this.expectKeyword("yield");
                  var t4 = null, n3 = false;
                  if (!this.hasLineTerminator) {
                    var r2 = this.context.allowYield;
                    this.context.allowYield = false, (n3 = this.match("*")) ? (this.nextToken(), t4 = this.parseAssignmentExpression()) : this.isStartOfExpression() && (t4 = this.parseAssignmentExpression()), this.context.allowYield = r2;
                  }
                  return this.finalize(e16, new s.YieldExpression(t4, n3));
                }, e15.prototype.parseClassElement = function(e16) {
                  var t4 = this.lookahead, n3 = this.createNode(), r2 = "", a2 = null, c2 = null, l2 = false, u2 = false, d = false, f = false;
                  if (this.match("*"))
                    this.nextToken();
                  else if (l2 = this.match("["), (a2 = this.parseObjectPropertyKey()).name === "static" && (this.qualifiedPropertyName(this.lookahead) || this.match("*")) && (t4 = this.lookahead, d = true, l2 = this.match("["), this.match("*") ? this.nextToken() : a2 = this.parseObjectPropertyKey()), t4.type === 3 && !this.hasLineTerminator && t4.value === "async") {
                    var p = this.lookahead.value;
                    p !== ":" && p !== "(" && p !== "*" && (f = true, t4 = this.lookahead, a2 = this.parseObjectPropertyKey(), t4.type === 3 && t4.value === "constructor" && this.tolerateUnexpectedToken(t4, o.Messages.ConstructorIsAsync));
                  }
                  var m = this.qualifiedPropertyName(this.lookahead);
                  return t4.type === 3 ? t4.value === "get" && m ? (r2 = "get", l2 = this.match("["), a2 = this.parseObjectPropertyKey(), this.context.allowYield = false, c2 = this.parseGetterMethod()) : t4.value === "set" && m && (r2 = "set", l2 = this.match("["), a2 = this.parseObjectPropertyKey(), c2 = this.parseSetterMethod()) : t4.type === 7 && t4.value === "*" && m && (r2 = "init", l2 = this.match("["), a2 = this.parseObjectPropertyKey(), c2 = this.parseGeneratorMethod(), u2 = true), !r2 && a2 && this.match("(") && (r2 = "init", c2 = f ? this.parsePropertyMethodAsyncFunction() : this.parsePropertyMethodFunction(), u2 = true), r2 || this.throwUnexpectedToken(this.lookahead), r2 === "init" && (r2 = "method"), l2 || (d && this.isPropertyKey(a2, "prototype") && this.throwUnexpectedToken(t4, o.Messages.StaticPrototype), !d && this.isPropertyKey(a2, "constructor") && ((r2 !== "method" || !u2 || c2 && c2.generator) && this.throwUnexpectedToken(t4, o.Messages.ConstructorSpecialMethod), e16.value ? this.throwUnexpectedToken(t4, o.Messages.DuplicateConstructor) : e16.value = true, r2 = "constructor")), this.finalize(n3, new s.MethodDefinition(a2, l2, c2, r2, d));
                }, e15.prototype.parseClassElementList = function() {
                  var e16 = [], t4 = { value: false };
                  for (this.expect("{"); !this.match("}"); )
                    this.match(";") ? this.nextToken() : e16.push(this.parseClassElement(t4));
                  return this.expect("}"), e16;
                }, e15.prototype.parseClassBody = function() {
                  var e16 = this.createNode(), t4 = this.parseClassElementList();
                  return this.finalize(e16, new s.ClassBody(t4));
                }, e15.prototype.parseClassDeclaration = function(e16) {
                  var t4 = this.createNode(), n3 = this.context.strict;
                  this.context.strict = true, this.expectKeyword("class");
                  var r2 = e16 && this.lookahead.type !== 3 ? null : this.parseVariableIdentifier(), a2 = null;
                  this.matchKeyword("extends") && (this.nextToken(), a2 = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall));
                  var o2 = this.parseClassBody();
                  return this.context.strict = n3, this.finalize(t4, new s.ClassDeclaration(r2, a2, o2));
                }, e15.prototype.parseClassExpression = function() {
                  var e16 = this.createNode(), t4 = this.context.strict;
                  this.context.strict = true, this.expectKeyword("class");
                  var n3 = this.lookahead.type === 3 ? this.parseVariableIdentifier() : null, r2 = null;
                  this.matchKeyword("extends") && (this.nextToken(), r2 = this.isolateCoverGrammar(this.parseLeftHandSideExpressionAllowCall));
                  var a2 = this.parseClassBody();
                  return this.context.strict = t4, this.finalize(e16, new s.ClassExpression(n3, r2, a2));
                }, e15.prototype.parseModule = function() {
                  this.context.strict = true, this.context.isModule = true, this.scanner.isModule = true;
                  for (var e16 = this.createNode(), t4 = this.parseDirectivePrologues(); this.lookahead.type !== 2; )
                    t4.push(this.parseStatementListItem());
                  return this.finalize(e16, new s.Module(t4));
                }, e15.prototype.parseScript = function() {
                  for (var e16 = this.createNode(), t4 = this.parseDirectivePrologues(); this.lookahead.type !== 2; )
                    t4.push(this.parseStatementListItem());
                  return this.finalize(e16, new s.Script(t4));
                }, e15.prototype.parseModuleSpecifier = function() {
                  var e16 = this.createNode();
                  this.lookahead.type !== 8 && this.throwError(o.Messages.InvalidModuleSpecifier);
                  var t4 = this.nextToken(), n3 = this.getTokenRaw(t4);
                  return this.finalize(e16, new s.Literal(t4.value, n3));
                }, e15.prototype.parseImportSpecifier = function() {
                  var e16, t4, n3 = this.createNode();
                  return this.lookahead.type === 3 ? (t4 = e16 = this.parseVariableIdentifier(), this.matchContextualKeyword("as") && (this.nextToken(), t4 = this.parseVariableIdentifier())) : (t4 = e16 = this.parseIdentifierName(), this.matchContextualKeyword("as") ? (this.nextToken(), t4 = this.parseVariableIdentifier()) : this.throwUnexpectedToken(this.nextToken())), this.finalize(n3, new s.ImportSpecifier(t4, e16));
                }, e15.prototype.parseNamedImports = function() {
                  this.expect("{");
                  for (var e16 = []; !this.match("}"); )
                    e16.push(this.parseImportSpecifier()), this.match("}") || this.expect(",");
                  return this.expect("}"), e16;
                }, e15.prototype.parseImportDefaultSpecifier = function() {
                  var e16 = this.createNode(), t4 = this.parseIdentifierName();
                  return this.finalize(e16, new s.ImportDefaultSpecifier(t4));
                }, e15.prototype.parseImportNamespaceSpecifier = function() {
                  var e16 = this.createNode();
                  this.expect("*"), this.matchContextualKeyword("as") || this.throwError(o.Messages.NoAsAfterImportNamespace), this.nextToken();
                  var t4 = this.parseIdentifierName();
                  return this.finalize(e16, new s.ImportNamespaceSpecifier(t4));
                }, e15.prototype.parseImportDeclaration = function() {
                  this.context.inFunctionBody && this.throwError(o.Messages.IllegalImportDeclaration);
                  var e16, t4 = this.createNode();
                  this.expectKeyword("import");
                  var n3 = [];
                  if (this.lookahead.type === 8)
                    e16 = this.parseModuleSpecifier();
                  else {
                    if (this.match("{") ? n3 = n3.concat(this.parseNamedImports()) : this.match("*") ? n3.push(this.parseImportNamespaceSpecifier()) : this.isIdentifierName(this.lookahead) && !this.matchKeyword("default") ? (n3.push(this.parseImportDefaultSpecifier()), this.match(",") && (this.nextToken(), this.match("*") ? n3.push(this.parseImportNamespaceSpecifier()) : this.match("{") ? n3 = n3.concat(this.parseNamedImports()) : this.throwUnexpectedToken(this.lookahead))) : this.throwUnexpectedToken(this.nextToken()), !this.matchContextualKeyword("from")) {
                      var r2 = this.lookahead.value ? o.Messages.UnexpectedToken : o.Messages.MissingFromClause;
                      this.throwError(r2, this.lookahead.value);
                    }
                    this.nextToken(), e16 = this.parseModuleSpecifier();
                  }
                  return this.consumeSemicolon(), this.finalize(t4, new s.ImportDeclaration(n3, e16));
                }, e15.prototype.parseExportSpecifier = function() {
                  var e16 = this.createNode(), t4 = this.parseIdentifierName(), n3 = t4;
                  return this.matchContextualKeyword("as") && (this.nextToken(), n3 = this.parseIdentifierName()), this.finalize(e16, new s.ExportSpecifier(t4, n3));
                }, e15.prototype.parseExportDeclaration = function() {
                  this.context.inFunctionBody && this.throwError(o.Messages.IllegalExportDeclaration);
                  var e16, t4 = this.createNode();
                  if (this.expectKeyword("export"), this.matchKeyword("default"))
                    if (this.nextToken(), this.matchKeyword("function")) {
                      var n3 = this.parseFunctionDeclaration(true);
                      e16 = this.finalize(t4, new s.ExportDefaultDeclaration(n3));
                    } else
                      this.matchKeyword("class") ? (n3 = this.parseClassDeclaration(true), e16 = this.finalize(t4, new s.ExportDefaultDeclaration(n3))) : this.matchContextualKeyword("async") ? (n3 = this.matchAsyncFunction() ? this.parseFunctionDeclaration(true) : this.parseAssignmentExpression(), e16 = this.finalize(t4, new s.ExportDefaultDeclaration(n3))) : (this.matchContextualKeyword("from") && this.throwError(o.Messages.UnexpectedToken, this.lookahead.value), n3 = this.match("{") ? this.parseObjectInitializer() : this.match("[") ? this.parseArrayInitializer() : this.parseAssignmentExpression(), this.consumeSemicolon(), e16 = this.finalize(t4, new s.ExportDefaultDeclaration(n3)));
                  else if (this.match("*")) {
                    if (this.nextToken(), !this.matchContextualKeyword("from")) {
                      var r2 = this.lookahead.value ? o.Messages.UnexpectedToken : o.Messages.MissingFromClause;
                      this.throwError(r2, this.lookahead.value);
                    }
                    this.nextToken();
                    var a2 = this.parseModuleSpecifier();
                    this.consumeSemicolon(), e16 = this.finalize(t4, new s.ExportAllDeclaration(a2));
                  } else if (this.lookahead.type === 4) {
                    switch (n3 = void 0, this.lookahead.value) {
                      case "let":
                      case "const":
                        n3 = this.parseLexicalDeclaration({ inFor: false });
                        break;
                      case "var":
                      case "class":
                      case "function":
                        n3 = this.parseStatementListItem();
                        break;
                      default:
                        this.throwUnexpectedToken(this.lookahead);
                    }
                    e16 = this.finalize(t4, new s.ExportNamedDeclaration(n3, [], null));
                  } else if (this.matchAsyncFunction())
                    n3 = this.parseFunctionDeclaration(), e16 = this.finalize(t4, new s.ExportNamedDeclaration(n3, [], null));
                  else {
                    var c2 = [], l2 = null, u2 = false;
                    for (this.expect("{"); !this.match("}"); )
                      u2 ||= this.matchKeyword("default"), c2.push(this.parseExportSpecifier()), this.match("}") || this.expect(",");
                    this.expect("}"), this.matchContextualKeyword("from") ? (this.nextToken(), l2 = this.parseModuleSpecifier(), this.consumeSemicolon()) : u2 ? (r2 = this.lookahead.value ? o.Messages.UnexpectedToken : o.Messages.MissingFromClause, this.throwError(r2, this.lookahead.value)) : this.consumeSemicolon(), e16 = this.finalize(t4, new s.ExportNamedDeclaration(null, c2, l2));
                  }
                  return e16;
                }, e15;
              }();
            },
            function(e14, t3) {
              Object.defineProperty(t3, "__esModule", { value: true }), t3.assert = function(e15, t4) {
                if (!e15)
                  throw Error("ASSERT: " + t4);
              };
            },
            function(e14, t3) {
              Object.defineProperty(t3, "__esModule", { value: true }), t3.ErrorHandler = function() {
                function e15() {
                  this.errors = [], this.tolerant = false;
                }
                return e15.prototype.recordError = function(e16) {
                  this.errors.push(e16);
                }, e15.prototype.tolerate = function(e16) {
                  if (!this.tolerant)
                    throw e16;
                  this.recordError(e16);
                }, e15.prototype.constructError = function(e16, t4) {
                  var n2 = Error(e16);
                  try {
                    throw n2;
                  } catch (e17) {
                    Object.create && Object.defineProperty && (n2 = Object.create(e17), Object.defineProperty(n2, "column", { value: t4 }));
                  }
                  return n2;
                }, e15.prototype.createError = function(e16, t4, n2, r) {
                  var a = "Line " + t4 + ": " + r, o = this.constructError(a, n2);
                  return o.index = e16, o.lineNumber = t4, o.description = r, o;
                }, e15.prototype.throwError = function(e16, t4, n2, r) {
                  throw this.createError(e16, t4, n2, r);
                }, e15.prototype.tolerateError = function(e16, t4, n2, r) {
                  var a = this.createError(e16, t4, n2, r);
                  if (!this.tolerant)
                    throw a;
                  this.recordError(a);
                }, e15;
              }();
            },
            function(e14, t3) {
              Object.defineProperty(t3, "__esModule", { value: true }), t3.Messages = {
                BadGetterArity: "Getter must not have any formal parameters",
                BadSetterArity: "Setter must have exactly one formal parameter",
                BadSetterRestParameter: "Setter function argument must not be a rest parameter",
                ConstructorIsAsync: "Class constructor may not be an async method",
                ConstructorSpecialMethod: "Class constructor may not be an accessor",
                DeclarationMissingInitializer: "Missing initializer in %0 declaration",
                DefaultRestParameter: "Unexpected token =",
                DuplicateBinding: "Duplicate binding %0",
                DuplicateConstructor: "A class may only have one constructor",
                DuplicateProtoProperty: "Duplicate __proto__ fields are not allowed in object literals",
                ForInOfLoopInitializer: "%0 loop variable declaration may not have an initializer",
                GeneratorInLegacyContext: "Generator declarations are not allowed in legacy contexts",
                IllegalBreak: "Illegal break statement",
                IllegalContinue: "Illegal continue statement",
                IllegalExportDeclaration: "Unexpected token",
                IllegalImportDeclaration: "Unexpected token",
                IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list",
                IllegalReturn: "Illegal return statement",
                InvalidEscapedReservedWord: "Keyword must not contain escaped characters",
                InvalidHexEscapeSequence: "Invalid hexadecimal escape sequence",
                InvalidLHSInAssignment: "Invalid left-hand side in assignment",
                InvalidLHSInForIn: "Invalid left-hand side in for-in",
                InvalidLHSInForLoop: "Invalid left-hand side in for-loop",
                InvalidModuleSpecifier: "Unexpected token",
                InvalidRegExp: "Invalid regular expression",
                LetInLexicalBinding: "let is disallowed as a lexically bound name",
                MissingFromClause: "Unexpected token",
                MultipleDefaultsInSwitch: "More than one default clause in switch statement",
                NewlineAfterThrow: "Illegal newline after throw",
                NoAsAfterImportNamespace: "Unexpected token",
                NoCatchOrFinally: "Missing catch or finally after try",
                ParameterAfterRestParameter: "Rest parameter must be last formal parameter",
                Redeclaration: "%0 '%1' has already been declared",
                StaticPrototype: "Classes may not have static property named prototype",
                StrictCatchVariable: "Catch variable may not be eval or arguments in strict mode",
                StrictDelete: "Delete of an unqualified identifier in strict mode.",
                StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block",
                StrictFunctionName: "Function name may not be eval or arguments in strict mode",
                StrictLHSAssignment: "Assignment to eval or arguments is not allowed in strict mode",
                StrictLHSPostfix: "Postfix increment/decrement may not have eval or arguments operand in strict mode",
                StrictLHSPrefix: "Prefix increment/decrement may not have eval or arguments operand in strict mode",
                StrictModeWith: "Strict mode code may not include a with statement",
                StrictOctalLiteral: "Octal literals are not allowed in strict mode.",
                StrictParamDupe: "Strict mode function may not have duplicate parameter names",
                StrictParamName: "Parameter name eval or arguments is not allowed in strict mode",
                StrictReservedWord: "Use of future reserved word in strict mode",
                StrictVarName: "Variable name may not be eval or arguments in strict mode",
                TemplateOctalLiteral: "Octal literals are not allowed in template strings.",
                UnexpectedEOS: "Unexpected end of input",
                UnexpectedIdentifier: "Unexpected identifier",
                UnexpectedNumber: "Unexpected number",
                UnexpectedReserved: "Unexpected reserved word",
                UnexpectedString: "Unexpected string",
                UnexpectedTemplate: "Unexpected quasi %0",
                UnexpectedToken: "Unexpected token %0",
                UnexpectedTokenIllegal: "Unexpected token ILLEGAL",
                UnknownLabel: "Undefined label '%0'",
                UnterminatedRegExp: "Invalid regular expression: missing /"
              };
            },
            function(e14, t3, n2) {
              Object.defineProperty(t3, "__esModule", { value: true });
              var r = n2(9), a = n2(4), o = n2(11);
              function s(e15) {
                return "0123456789abcdef".indexOf(e15.toLowerCase());
              }
              function c(e15) {
                return "01234567".indexOf(e15);
              }
              t3.Scanner = function() {
                function e15(e16, t4) {
                  this.source = e16, this.errorHandler = t4, this.trackComment = false, this.isModule = false, this.length = e16.length, this.index = 0, this.lineNumber = e16.length > 0 ? 1 : 0, this.lineStart = 0, this.curlyStack = [];
                }
                return e15.prototype.saveState = function() {
                  return {
                    index: this.index,
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart
                  };
                }, e15.prototype.restoreState = function(e16) {
                  this.index = e16.index, this.lineNumber = e16.lineNumber, this.lineStart = e16.lineStart;
                }, e15.prototype.eof = function() {
                  return this.index >= this.length;
                }, e15.prototype.throwUnexpectedToken = function(e16) {
                  return e16 === void 0 && (e16 = o.Messages.UnexpectedTokenIllegal), this.errorHandler.throwError(this.index, this.lineNumber, this.index - this.lineStart + 1, e16);
                }, e15.prototype.tolerateUnexpectedToken = function(e16) {
                  e16 === void 0 && (e16 = o.Messages.UnexpectedTokenIllegal), this.errorHandler.tolerateError(this.index, this.lineNumber, this.index - this.lineStart + 1, e16);
                }, e15.prototype.skipSingleLineComment = function(e16) {
                  var t4, n3, r2 = [];
                  for (this.trackComment && (r2 = [], t4 = this.index - e16, n3 = {
                    start: {
                      line: this.lineNumber,
                      column: this.index - this.lineStart - e16
                    },
                    end: {}
                  }); !this.eof(); ) {
                    var o2 = this.source.charCodeAt(this.index);
                    if (++this.index, a.Character.isLineTerminator(o2)) {
                      if (this.trackComment) {
                        n3.end = {
                          line: this.lineNumber,
                          column: this.index - this.lineStart - 1
                        };
                        var s2 = {
                          multiLine: false,
                          slice: [t4 + e16, this.index - 1],
                          range: [t4, this.index - 1],
                          loc: n3
                        };
                        r2.push(s2);
                      }
                      return o2 === 13 && this.source.charCodeAt(this.index) === 10 && ++this.index, ++this.lineNumber, this.lineStart = this.index, r2;
                    }
                  }
                  return this.trackComment && (n3.end = {
                    line: this.lineNumber,
                    column: this.index - this.lineStart
                  }, s2 = {
                    multiLine: false,
                    slice: [t4 + e16, this.index],
                    range: [t4, this.index],
                    loc: n3
                  }, r2.push(s2)), r2;
                }, e15.prototype.skipMultiLineComment = function() {
                  var e16, t4, n3 = [];
                  for (this.trackComment && (n3 = [], e16 = this.index - 2, t4 = {
                    start: {
                      line: this.lineNumber,
                      column: this.index - this.lineStart - 2
                    },
                    end: {}
                  }); !this.eof(); ) {
                    var r2 = this.source.charCodeAt(this.index);
                    if (a.Character.isLineTerminator(r2))
                      r2 === 13 && this.source.charCodeAt(this.index + 1) === 10 && ++this.index, ++this.lineNumber, ++this.index, this.lineStart = this.index;
                    else if (r2 === 42) {
                      if (this.source.charCodeAt(this.index + 1) === 47) {
                        if (this.index += 2, this.trackComment) {
                          t4.end = {
                            line: this.lineNumber,
                            column: this.index - this.lineStart
                          };
                          var o2 = {
                            multiLine: true,
                            slice: [e16 + 2, this.index - 2],
                            range: [e16, this.index],
                            loc: t4
                          };
                          n3.push(o2);
                        }
                        return n3;
                      }
                      ++this.index;
                    } else
                      ++this.index;
                  }
                  return this.trackComment && (t4.end = {
                    line: this.lineNumber,
                    column: this.index - this.lineStart
                  }, o2 = {
                    multiLine: true,
                    slice: [e16 + 2, this.index],
                    range: [e16, this.index],
                    loc: t4
                  }, n3.push(o2)), this.tolerateUnexpectedToken(), n3;
                }, e15.prototype.scanComments = function() {
                  var e16;
                  this.trackComment && (e16 = []);
                  for (var t4 = this.index === 0; !this.eof(); ) {
                    var n3 = this.source.charCodeAt(this.index);
                    if (a.Character.isWhiteSpace(n3))
                      ++this.index;
                    else if (a.Character.isLineTerminator(n3))
                      ++this.index, n3 === 13 && this.source.charCodeAt(this.index) === 10 && ++this.index, ++this.lineNumber, this.lineStart = this.index, t4 = true;
                    else if (n3 === 47)
                      if ((n3 = this.source.charCodeAt(this.index + 1)) === 47) {
                        this.index += 2;
                        var r2 = this.skipSingleLineComment(2);
                        this.trackComment && (e16 = e16.concat(r2)), t4 = true;
                      } else {
                        if (n3 !== 42)
                          break;
                        this.index += 2, r2 = this.skipMultiLineComment(), this.trackComment && (e16 = e16.concat(r2));
                      }
                    else if (t4 && n3 === 45) {
                      if (this.source.charCodeAt(this.index + 1) !== 45 || this.source.charCodeAt(this.index + 2) !== 62)
                        break;
                      this.index += 3, r2 = this.skipSingleLineComment(3), this.trackComment && (e16 = e16.concat(r2));
                    } else {
                      if (n3 !== 60 || this.isModule || this.source.slice(this.index + 1, this.index + 4) !== "!--")
                        break;
                      this.index += 4, r2 = this.skipSingleLineComment(4), this.trackComment && (e16 = e16.concat(r2));
                    }
                  }
                  return e16;
                }, e15.prototype.isFutureReservedWord = function(e16) {
                  switch (e16) {
                    case "enum":
                    case "export":
                    case "import":
                    case "super":
                      return true;
                    default:
                      return false;
                  }
                }, e15.prototype.isStrictModeReservedWord = function(e16) {
                  switch (e16) {
                    case "implements":
                    case "interface":
                    case "package":
                    case "private":
                    case "protected":
                    case "public":
                    case "static":
                    case "yield":
                    case "let":
                      return true;
                    default:
                      return false;
                  }
                }, e15.prototype.isRestrictedWord = function(e16) {
                  return e16 === "eval" || e16 === "arguments";
                }, e15.prototype.isKeyword = function(e16) {
                  switch (e16.length) {
                    case 2:
                      return e16 === "if" || e16 === "in" || e16 === "do";
                    case 3:
                      return e16 === "var" || e16 === "for" || e16 === "new" || e16 === "try" || e16 === "let";
                    case 4:
                      return e16 === "this" || e16 === "else" || e16 === "case" || e16 === "void" || e16 === "with" || e16 === "enum";
                    case 5:
                      return e16 === "while" || e16 === "break" || e16 === "catch" || e16 === "throw" || e16 === "const" || e16 === "yield" || e16 === "class" || e16 === "super";
                    case 6:
                      return e16 === "return" || e16 === "typeof" || e16 === "delete" || e16 === "switch" || e16 === "export" || e16 === "import";
                    case 7:
                      return e16 === "default" || e16 === "finally" || e16 === "extends";
                    case 8:
                      return e16 === "function" || e16 === "continue" || e16 === "debugger";
                    case 10:
                      return e16 === "instanceof";
                    default:
                      return false;
                  }
                }, e15.prototype.codePointAt = function(e16) {
                  var t4 = this.source.charCodeAt(e16);
                  if (t4 >= 55296 && t4 <= 56319) {
                    var n3 = this.source.charCodeAt(e16 + 1);
                    n3 >= 56320 && n3 <= 57343 && (t4 = 1024 * (t4 - 55296) + n3 - 56320 + 65536);
                  }
                  return t4;
                }, e15.prototype.scanHexEscape = function(e16) {
                  for (var t4 = e16 === "u" ? 4 : 2, n3 = 0, r2 = 0; r2 < t4; ++r2) {
                    if (this.eof() || !a.Character.isHexDigit(this.source.charCodeAt(this.index)))
                      return null;
                    n3 = 16 * n3 + s(this.source[this.index++]);
                  }
                  return String.fromCharCode(n3);
                }, e15.prototype.scanUnicodeCodePointEscape = function() {
                  var e16 = this.source[this.index], t4 = 0;
                  for (e16 === "}" && this.throwUnexpectedToken(); !this.eof() && (e16 = this.source[this.index++], a.Character.isHexDigit(e16.charCodeAt(0))); )
                    t4 = 16 * t4 + s(e16);
                  return (t4 > 1114111 || e16 !== "}") && this.throwUnexpectedToken(), a.Character.fromCodePoint(t4);
                }, e15.prototype.getIdentifier = function() {
                  for (var e16 = this.index++; !this.eof(); ) {
                    var t4 = this.source.charCodeAt(this.index);
                    if (t4 === 92 || t4 >= 55296 && t4 < 57343)
                      return this.index = e16, this.getComplexIdentifier();
                    if (!a.Character.isIdentifierPart(t4))
                      break;
                    ++this.index;
                  }
                  return this.source.slice(e16, this.index);
                }, e15.prototype.getComplexIdentifier = function() {
                  var e16, t4 = this.codePointAt(this.index), n3 = a.Character.fromCodePoint(t4);
                  for (this.index += n3.length, t4 === 92 && (this.source.charCodeAt(this.index) !== 117 && this.throwUnexpectedToken(), ++this.index, this.source[this.index] === "{" ? (++this.index, e16 = this.scanUnicodeCodePointEscape()) : (e16 = this.scanHexEscape("u")) !== null && e16 !== "\\" && a.Character.isIdentifierStart(e16.charCodeAt(0)) || this.throwUnexpectedToken(), n3 = e16); !this.eof() && (t4 = this.codePointAt(this.index), a.Character.isIdentifierPart(t4)); )
                    n3 += e16 = a.Character.fromCodePoint(t4), this.index += e16.length, t4 === 92 && (n3 = n3.substr(0, n3.length - 1), this.source.charCodeAt(this.index) !== 117 && this.throwUnexpectedToken(), ++this.index, this.source[this.index] === "{" ? (++this.index, e16 = this.scanUnicodeCodePointEscape()) : (e16 = this.scanHexEscape("u")) !== null && e16 !== "\\" && a.Character.isIdentifierPart(e16.charCodeAt(0)) || this.throwUnexpectedToken(), n3 += e16);
                  return n3;
                }, e15.prototype.octalToDecimal = function(e16) {
                  var t4 = e16 !== "0", n3 = c(e16);
                  return !this.eof() && a.Character.isOctalDigit(this.source.charCodeAt(this.index)) && (t4 = true, n3 = 8 * n3 + c(this.source[this.index++]), "0123".indexOf(e16) >= 0 && !this.eof() && a.Character.isOctalDigit(this.source.charCodeAt(this.index)) && (n3 = 8 * n3 + c(this.source[this.index++]))), {
                    code: n3,
                    octal: t4
                  };
                }, e15.prototype.scanIdentifier = function() {
                  var e16, t4 = this.index, n3 = this.source.charCodeAt(t4) === 92 ? this.getComplexIdentifier() : this.getIdentifier();
                  if ((e16 = n3.length === 1 ? 3 : this.isKeyword(n3) ? 4 : n3 === "null" ? 5 : n3 === "true" || n3 === "false" ? 1 : 3) != 3 && t4 + n3.length !== this.index) {
                    var r2 = this.index;
                    this.index = t4, this.tolerateUnexpectedToken(o.Messages.InvalidEscapedReservedWord), this.index = r2;
                  }
                  return {
                    type: e16,
                    value: n3,
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart,
                    start: t4,
                    end: this.index
                  };
                }, e15.prototype.scanPunctuator = function() {
                  var e16 = this.index, t4 = this.source[this.index];
                  switch (t4) {
                    case "(":
                    case "{":
                      t4 === "{" && this.curlyStack.push("{"), ++this.index;
                      break;
                    case ".":
                      ++this.index, this.source[this.index] === "." && this.source[this.index + 1] === "." && (this.index += 2, t4 = "...");
                      break;
                    case "}":
                      ++this.index, this.curlyStack.pop();
                      break;
                    case ")":
                    case ";":
                    case ",":
                    case "[":
                    case "]":
                    case ":":
                    case "?":
                    case "~":
                      ++this.index;
                      break;
                    default:
                      (t4 = this.source.substr(this.index, 4)) === ">>>=" ? this.index += 4 : (t4 = t4.substr(0, 3)) === "===" || t4 === "!==" || t4 === ">>>" || t4 === "<<=" || t4 === ">>=" || t4 === "**=" ? this.index += 3 : (t4 = t4.substr(0, 2)) === "&&" || t4 === "||" || t4 === "==" || t4 === "!=" || t4 === "+=" || t4 === "-=" || t4 === "*=" || t4 === "/=" || t4 === "++" || t4 === "--" || t4 === "<<" || t4 === ">>" || t4 === "&=" || t4 === "|=" || t4 === "^=" || t4 === "%=" || t4 === "<=" || t4 === ">=" || t4 === "=>" || t4 === "**" ? this.index += 2 : (t4 = this.source[this.index], "<>=!+-*%&|^/".indexOf(t4) >= 0 && ++this.index);
                  }
                  return this.index === e16 && this.throwUnexpectedToken(), {
                    type: 7,
                    value: t4,
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart,
                    start: e16,
                    end: this.index
                  };
                }, e15.prototype.scanHexLiteral = function(e16) {
                  for (var t4 = ""; !this.eof() && a.Character.isHexDigit(this.source.charCodeAt(this.index)); )
                    t4 += this.source[this.index++];
                  return t4.length === 0 && this.throwUnexpectedToken(), a.Character.isIdentifierStart(this.source.charCodeAt(this.index)) && this.throwUnexpectedToken(), {
                    type: 6,
                    value: parseInt("0x" + t4, 16),
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart,
                    start: e16,
                    end: this.index
                  };
                }, e15.prototype.scanBinaryLiteral = function(e16) {
                  for (var t4, n3 = ""; !this.eof() && ((t4 = this.source[this.index]) === "0" || t4 === "1"); )
                    n3 += this.source[this.index++];
                  return n3.length === 0 && this.throwUnexpectedToken(), this.eof() || (t4 = this.source.charCodeAt(this.index), (a.Character.isIdentifierStart(t4) || a.Character.isDecimalDigit(t4)) && this.throwUnexpectedToken()), {
                    type: 6,
                    value: parseInt(n3, 2),
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart,
                    start: e16,
                    end: this.index
                  };
                }, e15.prototype.scanOctalLiteral = function(e16, t4) {
                  var n3 = "", r2 = false;
                  for (a.Character.isOctalDigit(e16.charCodeAt(0)) ? (r2 = true, n3 = "0" + this.source[this.index++]) : ++this.index; !this.eof() && a.Character.isOctalDigit(this.source.charCodeAt(this.index)); )
                    n3 += this.source[this.index++];
                  return r2 || n3.length !== 0 || this.throwUnexpectedToken(), (a.Character.isIdentifierStart(this.source.charCodeAt(this.index)) || a.Character.isDecimalDigit(this.source.charCodeAt(this.index))) && this.throwUnexpectedToken(), {
                    type: 6,
                    value: parseInt(n3, 8),
                    octal: r2,
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart,
                    start: t4,
                    end: this.index
                  };
                }, e15.prototype.isImplicitOctalLiteral = function() {
                  for (var e16 = this.index + 1; e16 < this.length; ++e16) {
                    var t4 = this.source[e16];
                    if (t4 === "8" || t4 === "9")
                      return false;
                    if (!a.Character.isOctalDigit(t4.charCodeAt(0)))
                      return true;
                  }
                  return true;
                }, e15.prototype.scanNumericLiteral = function() {
                  var e16 = this.index, t4 = this.source[e16];
                  r.assert(a.Character.isDecimalDigit(t4.charCodeAt(0)) || t4 === ".", "Numeric literal must start with a decimal digit or a decimal point");
                  var n3 = "";
                  if (t4 !== ".") {
                    if (n3 = this.source[this.index++], t4 = this.source[this.index], n3 === "0") {
                      if (t4 === "x" || t4 === "X")
                        return ++this.index, this.scanHexLiteral(e16);
                      if (t4 === "b" || t4 === "B")
                        return ++this.index, this.scanBinaryLiteral(e16);
                      if (t4 === "o" || t4 === "O" || t4 && a.Character.isOctalDigit(t4.charCodeAt(0)) && this.isImplicitOctalLiteral())
                        return this.scanOctalLiteral(t4, e16);
                    }
                    for (; a.Character.isDecimalDigit(this.source.charCodeAt(this.index)); )
                      n3 += this.source[this.index++];
                    t4 = this.source[this.index];
                  }
                  if (t4 === ".") {
                    for (n3 += this.source[this.index++]; a.Character.isDecimalDigit(this.source.charCodeAt(this.index)); )
                      n3 += this.source[this.index++];
                    t4 = this.source[this.index];
                  }
                  if (t4 === "e" || t4 === "E")
                    if (n3 += this.source[this.index++], (t4 = this.source[this.index]) !== "+" && t4 !== "-" || (n3 += this.source[this.index++]), a.Character.isDecimalDigit(this.source.charCodeAt(this.index)))
                      for (; a.Character.isDecimalDigit(this.source.charCodeAt(this.index)); )
                        n3 += this.source[this.index++];
                    else
                      this.throwUnexpectedToken();
                  return a.Character.isIdentifierStart(this.source.charCodeAt(this.index)) && this.throwUnexpectedToken(), {
                    type: 6,
                    value: parseFloat(n3),
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart,
                    start: e16,
                    end: this.index
                  };
                }, e15.prototype.scanStringLiteral = function() {
                  var e16 = this.index, t4 = this.source[e16];
                  r.assert(t4 === "'" || t4 === '"', "String literal must starts with a quote"), ++this.index;
                  for (var n3 = false, s2 = ""; !this.eof(); ) {
                    var c2 = this.source[this.index++];
                    if (c2 === t4) {
                      t4 = "";
                      break;
                    }
                    if (c2 === "\\")
                      if ((c2 = this.source[this.index++]) && a.Character.isLineTerminator(c2.charCodeAt(0)))
                        ++this.lineNumber, c2 === "\r" && this.source[this.index] === "\n" && ++this.index, this.lineStart = this.index;
                      else
                        switch (c2) {
                          case "u":
                            if (this.source[this.index] === "{")
                              ++this.index, s2 += this.scanUnicodeCodePointEscape();
                            else {
                              var l = this.scanHexEscape(c2);
                              l === null && this.throwUnexpectedToken(), s2 += l;
                            }
                            break;
                          case "x":
                            var u = this.scanHexEscape(c2);
                            u === null && this.throwUnexpectedToken(o.Messages.InvalidHexEscapeSequence), s2 += u;
                            break;
                          case "n":
                            s2 += "\n";
                            break;
                          case "r":
                            s2 += "\r";
                            break;
                          case "t":
                            s2 += "	";
                            break;
                          case "b":
                            s2 += "\b";
                            break;
                          case "f":
                            s2 += "\f";
                            break;
                          case "v":
                            s2 += "\v";
                            break;
                          case "8":
                          case "9":
                            s2 += c2, this.tolerateUnexpectedToken();
                            break;
                          default:
                            if (c2 && a.Character.isOctalDigit(c2.charCodeAt(0))) {
                              var d = this.octalToDecimal(c2);
                              n3 = d.octal || n3, s2 += String.fromCharCode(d.code);
                            } else
                              s2 += c2;
                        }
                    else {
                      if (a.Character.isLineTerminator(c2.charCodeAt(0)))
                        break;
                      s2 += c2;
                    }
                  }
                  return t4 !== "" && (this.index = e16, this.throwUnexpectedToken()), {
                    type: 8,
                    value: s2,
                    octal: n3,
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart,
                    start: e16,
                    end: this.index
                  };
                }, e15.prototype.scanTemplate = function() {
                  var e16 = "", t4 = false, n3 = this.index, r2 = this.source[n3] === "`", s2 = false, c2 = 2;
                  for (++this.index; !this.eof(); ) {
                    var l = this.source[this.index++];
                    if (l === "`") {
                      c2 = 1, s2 = true, t4 = true;
                      break;
                    }
                    if (l === "$") {
                      if (this.source[this.index] === "{") {
                        this.curlyStack.push("${"), ++this.index, t4 = true;
                        break;
                      }
                      e16 += l;
                    } else if (l === "\\")
                      if (l = this.source[this.index++], a.Character.isLineTerminator(l.charCodeAt(0)))
                        ++this.lineNumber, l === "\r" && this.source[this.index] === "\n" && ++this.index, this.lineStart = this.index;
                      else
                        switch (l) {
                          case "n":
                            e16 += "\n";
                            break;
                          case "r":
                            e16 += "\r";
                            break;
                          case "t":
                            e16 += "	";
                            break;
                          case "u":
                            if (this.source[this.index] === "{")
                              ++this.index, e16 += this.scanUnicodeCodePointEscape();
                            else {
                              var u = this.index, d = this.scanHexEscape(l);
                              d === null ? (this.index = u, e16 += l) : e16 += d;
                            }
                            break;
                          case "x":
                            var f = this.scanHexEscape(l);
                            f === null && this.throwUnexpectedToken(o.Messages.InvalidHexEscapeSequence), e16 += f;
                            break;
                          case "b":
                            e16 += "\b";
                            break;
                          case "f":
                            e16 += "\f";
                            break;
                          case "v":
                            e16 += "\v";
                            break;
                          default:
                            l === "0" ? (a.Character.isDecimalDigit(this.source.charCodeAt(this.index)) && this.throwUnexpectedToken(o.Messages.TemplateOctalLiteral), e16 += "\0") : a.Character.isOctalDigit(l.charCodeAt(0)) ? this.throwUnexpectedToken(o.Messages.TemplateOctalLiteral) : e16 += l;
                        }
                    else
                      a.Character.isLineTerminator(l.charCodeAt(0)) ? (++this.lineNumber, l === "\r" && this.source[this.index] === "\n" && ++this.index, this.lineStart = this.index, e16 += "\n") : e16 += l;
                  }
                  return t4 || this.throwUnexpectedToken(), r2 || this.curlyStack.pop(), {
                    type: 10,
                    value: this.source.slice(n3 + 1, this.index - c2),
                    cooked: e16,
                    head: r2,
                    tail: s2,
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart,
                    start: n3,
                    end: this.index
                  };
                }, e15.prototype.testRegExp = function(e16, t4) {
                  var n3 = e16, r2 = this;
                  t4.indexOf("u") >= 0 && (n3 = n3.replace(/\\u\{([0-9a-fA-F]+)\}|\\u([a-fA-F0-9]{4})/g, function(e17, t5, n4) {
                    var a2 = parseInt(t5 || n4, 16);
                    return a2 > 1114111 && r2.throwUnexpectedToken(o.Messages.InvalidRegExp), a2 <= 65535 ? String.fromCharCode(a2) : "\uFFFF";
                  }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "\uFFFF"));
                  try {
                    return new RegExp(e16, t4);
                  } catch {
                    return null;
                  }
                }, e15.prototype.scanRegExpBody = function() {
                  var e16 = this.source[this.index];
                  r.assert(e16 === "/", "Regular expression literal must start with a slash");
                  for (var t4 = this.source[this.index++], n3 = false, s2 = false; !this.eof(); )
                    if (t4 += e16 = this.source[this.index++], e16 === "\\")
                      e16 = this.source[this.index++], a.Character.isLineTerminator(e16.charCodeAt(0)) && this.throwUnexpectedToken(o.Messages.UnterminatedRegExp), t4 += e16;
                    else if (a.Character.isLineTerminator(e16.charCodeAt(0)))
                      this.throwUnexpectedToken(o.Messages.UnterminatedRegExp);
                    else if (n3)
                      e16 === "]" && (n3 = false);
                    else {
                      if (e16 === "/") {
                        s2 = true;
                        break;
                      }
                      e16 === "[" && (n3 = true);
                    }
                  return s2 || this.throwUnexpectedToken(o.Messages.UnterminatedRegExp), t4.substr(1, t4.length - 2);
                }, e15.prototype.scanRegExpFlags = function() {
                  for (var e16 = ""; !this.eof(); ) {
                    var t4 = this.source[this.index];
                    if (!a.Character.isIdentifierPart(t4.charCodeAt(0)))
                      break;
                    if (++this.index, t4 !== "\\" || this.eof())
                      e16 += t4;
                    else if ((t4 = this.source[this.index]) === "u") {
                      ++this.index;
                      var n3 = this.index, r2 = this.scanHexEscape("u");
                      if (r2 !== null)
                        for (e16 += r2; n3 < this.index; ++n3)
                          this.source[n3];
                      else
                        this.index = n3, e16 += "u";
                      this.tolerateUnexpectedToken();
                    } else
                      this.tolerateUnexpectedToken();
                  }
                  return e16;
                }, e15.prototype.scanRegExp = function() {
                  var e16 = this.index, t4 = this.scanRegExpBody(), n3 = this.scanRegExpFlags();
                  return {
                    type: 9,
                    value: "",
                    pattern: t4,
                    flags: n3,
                    regex: this.testRegExp(t4, n3),
                    lineNumber: this.lineNumber,
                    lineStart: this.lineStart,
                    start: e16,
                    end: this.index
                  };
                }, e15.prototype.lex = function() {
                  if (this.eof())
                    return {
                      type: 2,
                      value: "",
                      lineNumber: this.lineNumber,
                      lineStart: this.lineStart,
                      start: this.index,
                      end: this.index
                    };
                  var e16 = this.source.charCodeAt(this.index);
                  return a.Character.isIdentifierStart(e16) ? this.scanIdentifier() : e16 === 40 || e16 === 41 || e16 === 59 ? this.scanPunctuator() : e16 === 39 || e16 === 34 ? this.scanStringLiteral() : e16 === 46 ? a.Character.isDecimalDigit(this.source.charCodeAt(this.index + 1)) ? this.scanNumericLiteral() : this.scanPunctuator() : a.Character.isDecimalDigit(e16) ? this.scanNumericLiteral() : e16 === 96 || e16 === 125 && this.curlyStack[this.curlyStack.length - 1] === "${" ? this.scanTemplate() : e16 >= 55296 && e16 < 57343 && a.Character.isIdentifierStart(this.codePointAt(this.index)) ? this.scanIdentifier() : this.scanPunctuator();
                }, e15;
              }();
            },
            function(e14, t3) {
              Object.defineProperty(t3, "__esModule", { value: true }), t3.TokenName = {}, t3.TokenName[1] = "Boolean", t3.TokenName[2] = "<end>", t3.TokenName[3] = "Identifier", t3.TokenName[4] = "Keyword", t3.TokenName[5] = "Null", t3.TokenName[6] = "Numeric", t3.TokenName[7] = "Punctuator", t3.TokenName[8] = "String", t3.TokenName[9] = "RegularExpression", t3.TokenName[10] = "Template";
            },
            function(e14, t3) {
              Object.defineProperty(t3, "__esModule", { value: true }), t3.XHTMLEntities = {
                quot: '"',
                amp: "&",
                apos: "'",
                gt: ">",
                nbsp: "\xA0",
                iexcl: "\xA1",
                cent: "\xA2",
                pound: "\xA3",
                curren: "\xA4",
                yen: "\xA5",
                brvbar: "\xA6",
                sect: "\xA7",
                uml: "\xA8",
                copy: "\xA9",
                ordf: "\xAA",
                laquo: "\xAB",
                not: "\xAC",
                shy: "\xAD",
                reg: "\xAE",
                macr: "\xAF",
                deg: "\xB0",
                plusmn: "\xB1",
                sup2: "\xB2",
                sup3: "\xB3",
                acute: "\xB4",
                micro: "\xB5",
                para: "\xB6",
                middot: "\xB7",
                cedil: "\xB8",
                sup1: "\xB9",
                ordm: "\xBA",
                raquo: "\xBB",
                frac14: "\xBC",
                frac12: "\xBD",
                frac34: "\xBE",
                iquest: "\xBF",
                Agrave: "\xC0",
                Aacute: "\xC1",
                Acirc: "\xC2",
                Atilde: "\xC3",
                Auml: "\xC4",
                Aring: "\xC5",
                AElig: "\xC6",
                Ccedil: "\xC7",
                Egrave: "\xC8",
                Eacute: "\xC9",
                Ecirc: "\xCA",
                Euml: "\xCB",
                Igrave: "\xCC",
                Iacute: "\xCD",
                Icirc: "\xCE",
                Iuml: "\xCF",
                ETH: "\xD0",
                Ntilde: "\xD1",
                Ograve: "\xD2",
                Oacute: "\xD3",
                Ocirc: "\xD4",
                Otilde: "\xD5",
                Ouml: "\xD6",
                times: "\xD7",
                Oslash: "\xD8",
                Ugrave: "\xD9",
                Uacute: "\xDA",
                Ucirc: "\xDB",
                Uuml: "\xDC",
                Yacute: "\xDD",
                THORN: "\xDE",
                szlig: "\xDF",
                agrave: "\xE0",
                aacute: "\xE1",
                acirc: "\xE2",
                atilde: "\xE3",
                auml: "\xE4",
                aring: "\xE5",
                aelig: "\xE6",
                ccedil: "\xE7",
                egrave: "\xE8",
                eacute: "\xE9",
                ecirc: "\xEA",
                euml: "\xEB",
                igrave: "\xEC",
                iacute: "\xED",
                icirc: "\xEE",
                iuml: "\xEF",
                eth: "\xF0",
                ntilde: "\xF1",
                ograve: "\xF2",
                oacute: "\xF3",
                ocirc: "\xF4",
                otilde: "\xF5",
                ouml: "\xF6",
                divide: "\xF7",
                oslash: "\xF8",
                ugrave: "\xF9",
                uacute: "\xFA",
                ucirc: "\xFB",
                uuml: "\xFC",
                yacute: "\xFD",
                thorn: "\xFE",
                yuml: "\xFF",
                OElig: "\u0152",
                oelig: "\u0153",
                Scaron: "\u0160",
                scaron: "\u0161",
                Yuml: "\u0178",
                fnof: "\u0192",
                circ: "\u02C6",
                tilde: "\u02DC",
                Alpha: "\u0391",
                Beta: "\u0392",
                Gamma: "\u0393",
                Delta: "\u0394",
                Epsilon: "\u0395",
                Zeta: "\u0396",
                Eta: "\u0397",
                Theta: "\u0398",
                Iota: "\u0399",
                Kappa: "\u039A",
                Lambda: "\u039B",
                Mu: "\u039C",
                Nu: "\u039D",
                Xi: "\u039E",
                Omicron: "\u039F",
                Pi: "\u03A0",
                Rho: "\u03A1",
                Sigma: "\u03A3",
                Tau: "\u03A4",
                Upsilon: "\u03A5",
                Phi: "\u03A6",
                Chi: "\u03A7",
                Psi: "\u03A8",
                Omega: "\u03A9",
                alpha: "\u03B1",
                beta: "\u03B2",
                gamma: "\u03B3",
                delta: "\u03B4",
                epsilon: "\u03B5",
                zeta: "\u03B6",
                eta: "\u03B7",
                theta: "\u03B8",
                iota: "\u03B9",
                kappa: "\u03BA",
                lambda: "\u03BB",
                mu: "\u03BC",
                nu: "\u03BD",
                xi: "\u03BE",
                omicron: "\u03BF",
                pi: "\u03C0",
                rho: "\u03C1",
                sigmaf: "\u03C2",
                sigma: "\u03C3",
                tau: "\u03C4",
                upsilon: "\u03C5",
                phi: "\u03C6",
                chi: "\u03C7",
                psi: "\u03C8",
                omega: "\u03C9",
                thetasym: "\u03D1",
                upsih: "\u03D2",
                piv: "\u03D6",
                ensp: "\u2002",
                emsp: "\u2003",
                thinsp: "\u2009",
                zwnj: "\u200C",
                zwj: "\u200D",
                lrm: "\u200E",
                rlm: "\u200F",
                ndash: "\u2013",
                mdash: "\u2014",
                lsquo: "\u2018",
                rsquo: "\u2019",
                sbquo: "\u201A",
                ldquo: "\u201C",
                rdquo: "\u201D",
                bdquo: "\u201E",
                dagger: "\u2020",
                Dagger: "\u2021",
                bull: "\u2022",
                hellip: "\u2026",
                permil: "\u2030",
                prime: "\u2032",
                Prime: "\u2033",
                lsaquo: "\u2039",
                rsaquo: "\u203A",
                oline: "\u203E",
                frasl: "\u2044",
                euro: "\u20AC",
                image: "\u2111",
                weierp: "\u2118",
                real: "\u211C",
                trade: "\u2122",
                alefsym: "\u2135",
                larr: "\u2190",
                uarr: "\u2191",
                rarr: "\u2192",
                darr: "\u2193",
                harr: "\u2194",
                crarr: "\u21B5",
                lArr: "\u21D0",
                uArr: "\u21D1",
                rArr: "\u21D2",
                dArr: "\u21D3",
                hArr: "\u21D4",
                forall: "\u2200",
                part: "\u2202",
                exist: "\u2203",
                empty: "\u2205",
                nabla: "\u2207",
                isin: "\u2208",
                notin: "\u2209",
                ni: "\u220B",
                prod: "\u220F",
                sum: "\u2211",
                minus: "\u2212",
                lowast: "\u2217",
                radic: "\u221A",
                prop: "\u221D",
                infin: "\u221E",
                ang: "\u2220",
                and: "\u2227",
                or: "\u2228",
                cap: "\u2229",
                cup: "\u222A",
                int: "\u222B",
                there4: "\u2234",
                sim: "\u223C",
                cong: "\u2245",
                asymp: "\u2248",
                ne: "\u2260",
                equiv: "\u2261",
                le: "\u2264",
                ge: "\u2265",
                sub: "\u2282",
                sup: "\u2283",
                nsub: "\u2284",
                sube: "\u2286",
                supe: "\u2287",
                oplus: "\u2295",
                otimes: "\u2297",
                perp: "\u22A5",
                sdot: "\u22C5",
                lceil: "\u2308",
                rceil: "\u2309",
                lfloor: "\u230A",
                rfloor: "\u230B",
                loz: "\u25CA",
                spades: "\u2660",
                clubs: "\u2663",
                hearts: "\u2665",
                diams: "\u2666",
                lang: "\u27E8",
                rang: "\u27E9"
              };
            },
            function(e14, t3, n2) {
              Object.defineProperty(t3, "__esModule", { value: true });
              var r = n2(10), a = n2(12), o = n2(13), s = function() {
                function e15() {
                  this.values = [], this.curly = this.paren = -1;
                }
                return e15.prototype.beforeFunctionExpression = function(e16) {
                  return (/* @__PURE__ */ "(.{.[.in.typeof.instanceof.new.return.case.delete.throw.void.=.+=.-=.*=.**=./=.%=.<<=.>>=.>>>=.&=.|=.^=.,.+.-.*.**./.%.++.--.<<.>>.>>>.&.|.^.!.~.&&.||.?.:.===.==.>=.<=.<.>.!=.!==".split(".")).indexOf(e16) >= 0;
                }, e15.prototype.isRegexStart = function() {
                  var e16 = this.values[this.values.length - 1], t4 = e16 !== null;
                  switch (e16) {
                    case "this":
                    case "]":
                      t4 = false;
                      break;
                    case ")":
                      var n3 = this.values[this.paren - 1];
                      t4 = n3 === "if" || n3 === "while" || n3 === "for" || n3 === "with";
                      break;
                    case "}":
                      if (t4 = false, this.values[this.curly - 3] === "function")
                        t4 = !!(r2 = this.values[this.curly - 4]) && !this.beforeFunctionExpression(r2);
                      else if (this.values[this.curly - 4] === "function") {
                        var r2;
                        t4 = !(r2 = this.values[this.curly - 5]) || !this.beforeFunctionExpression(r2);
                      }
                  }
                  return t4;
                }, e15.prototype.push = function(e16) {
                  e16.type === 7 || e16.type === 4 ? (e16.value === "{" ? this.curly = this.values.length : e16.value === "(" && (this.paren = this.values.length), this.values.push(e16.value)) : this.values.push(null);
                }, e15;
              }();
              t3.Tokenizer = function() {
                function e15(e16, t4) {
                  this.errorHandler = new r.ErrorHandler(), this.errorHandler.tolerant = !!t4 && typeof t4.tolerant == "boolean" && t4.tolerant, this.scanner = new a.Scanner(e16, this.errorHandler), this.scanner.trackComment = !!t4 && typeof t4.comment == "boolean" && t4.comment, this.trackRange = !!t4 && typeof t4.range == "boolean" && t4.range, this.trackLoc = !!t4 && typeof t4.loc == "boolean" && t4.loc, this.buffer = [], this.reader = new s();
                }
                return e15.prototype.errors = function() {
                  return this.errorHandler.errors;
                }, e15.prototype.getNextToken = function() {
                  if (this.buffer.length === 0) {
                    var e16 = this.scanner.scanComments();
                    if (this.scanner.trackComment)
                      for (var t4 = 0; t4 < e16.length; ++t4) {
                        var n3 = e16[t4], r2 = this.scanner.source.slice(n3.slice[0], n3.slice[1]), a2 = {
                          type: n3.multiLine ? "BlockComment" : "LineComment",
                          value: r2
                        };
                        this.trackRange && (a2.range = n3.range), this.trackLoc && (a2.loc = n3.loc), this.buffer.push(a2);
                      }
                    if (!this.scanner.eof()) {
                      var s2 = void 0;
                      this.trackLoc && (s2 = {
                        start: {
                          line: this.scanner.lineNumber,
                          column: this.scanner.index - this.scanner.lineStart
                        },
                        end: {}
                      });
                      var c = this.scanner.source[this.scanner.index] === "/" && this.reader.isRegexStart() ? this.scanner.scanRegExp() : this.scanner.lex();
                      this.reader.push(c);
                      var l = {
                        type: o.TokenName[c.type],
                        value: this.scanner.source.slice(c.start, c.end)
                      };
                      this.trackRange && (l.range = [c.start, c.end]), this.trackLoc && (s2.end = {
                        line: this.scanner.lineNumber,
                        column: this.scanner.index - this.scanner.lineStart
                      }, l.loc = s2), c.type === 9 && (l.regex = {
                        pattern: c.pattern,
                        flags: c.flags
                      }), this.buffer.push(l);
                    }
                  }
                  return this.buffer.shift();
                }, e15;
              }();
            }
          ]);
        }();
      },
      function(e13, t2, n) {
        var r = n(38), a = n(53), o = n(76), s = n(54), c = Object.prototype.toString, l = Object.prototype.hasOwnProperty, u = {
          0: "\\0",
          7: "\\a",
          8: "\\b",
          9: "\\t",
          10: "\\n",
          11: "\\v",
          12: "\\f",
          13: "\\r",
          27: "\\e",
          34: '\\"',
          92: "\\\\",
          133: "\\N",
          160: "\\_",
          8232: "\\L",
          8233: "\\P"
        }, d = [
          "y",
          "Y",
          "yes",
          "Yes",
          "YES",
          "on",
          "On",
          "ON",
          "n",
          "N",
          "no",
          "No",
          "NO",
          "off",
          "Off",
          "OFF"
        ];
        function f(e14) {
          var t3, n2, o2;
          if (t3 = e14.toString(16).toUpperCase(), e14 <= 255)
            n2 = "x", o2 = 2;
          else if (e14 <= 65535)
            n2 = "u", o2 = 4;
          else {
            if (!(e14 <= 4294967295))
              throw new a("code point within a string may not be greater than 0xFFFFFFFF");
            n2 = "U", o2 = 8;
          }
          return "\\" + n2 + r.repeat("0", o2 - t3.length) + t3;
        }
        function p(e14) {
          this.schema = e14.schema || o, this.indent = Math.max(1, e14.indent || 2), this.noArrayIndent = e14.noArrayIndent || false, this.skipInvalid = e14.skipInvalid || false, this.flowLevel = r.isNothing(e14.flowLevel) ? -1 : e14.flowLevel, this.styleMap = function(e15, t3) {
            var n2, r2, a2, o2, s2, c2, u2;
            if (t3 === null)
              return {};
            for (n2 = {}, a2 = 0, o2 = (r2 = Object.keys(t3)).length; a2 < o2; a2 += 1)
              s2 = r2[a2], c2 = String(t3[s2]), s2.slice(0, 2) === "!!" && (s2 = "tag:yaml.org,2002:" + s2.slice(2)), (u2 = e15.compiledTypeMap.fallback[s2]) && l.call(u2.styleAliases, c2) && (c2 = u2.styleAliases[c2]), n2[s2] = c2;
            return n2;
          }(this.schema, e14.styles || null), this.sortKeys = e14.sortKeys || false, this.lineWidth = e14.lineWidth || 80, this.noRefs = e14.noRefs || false, this.noCompatMode = e14.noCompatMode || false, this.condenseFlow = e14.condenseFlow || false, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
        }
        function m(e14, t3) {
          for (var n2, a2 = r.repeat(" ", t3), o2 = 0, s2 = -1, c2 = "", l2 = e14.length; o2 < l2; )
            (s2 = e14.indexOf("\n", o2)) === -1 ? (n2 = e14.slice(o2), o2 = l2) : (n2 = e14.slice(o2, s2 + 1), o2 = s2 + 1), n2.length && n2 !== "\n" && (c2 += a2), c2 += n2;
          return c2;
        }
        function h(e14, t3) {
          return "\n" + r.repeat(" ", e14.indent * t3);
        }
        function g(e14) {
          return e14 === 32 || e14 === 9;
        }
        function _(e14) {
          return 32 <= e14 && e14 <= 126 || 161 <= e14 && e14 <= 55295 && e14 !== 8232 && e14 !== 8233 || 57344 <= e14 && e14 <= 65533 && e14 !== 65279 || 65536 <= e14 && e14 <= 1114111;
        }
        function v(e14, t3) {
          return _(e14) && e14 !== 65279 && e14 !== 44 && e14 !== 91 && e14 !== 93 && e14 !== 123 && e14 !== 125 && e14 !== 58 && (e14 !== 35 || t3 && function(e15) {
            return _(e15) && !g(e15) && e15 !== 65279 && e15 !== 13 && e15 !== 10;
          }(t3));
        }
        function y(e14) {
          return /^\n* /.test(e14);
        }
        function b(e14, t3, n2, r2, a2) {
          var o2, s2, c2, l2, u2 = false, d2 = false, f2 = r2 !== -1, p2 = -1, m2 = _(l2 = e14.charCodeAt(0)) && l2 !== 65279 && !g(l2) && l2 !== 45 && l2 !== 63 && l2 !== 58 && l2 !== 44 && l2 !== 91 && l2 !== 93 && l2 !== 123 && l2 !== 125 && l2 !== 35 && l2 !== 38 && l2 !== 42 && l2 !== 33 && l2 !== 124 && l2 !== 61 && l2 !== 62 && l2 !== 39 && l2 !== 34 && l2 !== 37 && l2 !== 64 && l2 !== 96 && !g(e14.charCodeAt(e14.length - 1));
          if (t3)
            for (o2 = 0; o2 < e14.length; o2++) {
              if (!_(s2 = e14.charCodeAt(o2)))
                return 5;
              c2 = o2 > 0 ? e14.charCodeAt(o2 - 1) : null, m2 &&= v(s2, c2);
            }
          else {
            for (o2 = 0; o2 < e14.length; o2++) {
              if ((s2 = e14.charCodeAt(o2)) === 10)
                u2 = true, f2 && (d2 ||= o2 - p2 - 1 > r2 && e14[p2 + 1] !== " ", p2 = o2);
              else if (!_(s2))
                return 5;
              c2 = o2 > 0 ? e14.charCodeAt(o2 - 1) : null, m2 &&= v(s2, c2);
            }
            d2 ||= f2 && o2 - p2 - 1 > r2 && e14[p2 + 1] !== " ";
          }
          return u2 || d2 ? n2 > 9 && y(e14) ? 5 : d2 ? 4 : 3 : m2 && !a2(e14) ? 1 : 2;
        }
        function S(e14, t3, n2, r2) {
          e14.dump = function() {
            if (t3.length === 0)
              return "''";
            if (!e14.noCompatMode && d.indexOf(t3) !== -1)
              return "'" + t3 + "'";
            var o2 = e14.indent * Math.max(1, n2), s2 = e14.lineWidth === -1 ? -1 : Math.max(Math.min(e14.lineWidth, 40), e14.lineWidth - o2);
            switch (b(t3, r2 || e14.flowLevel > -1 && n2 >= e14.flowLevel, e14.indent, s2, function(t4) {
              return function(e15, t5) {
                var n3, r3;
                for (n3 = 0, r3 = e15.implicitTypes.length; n3 < r3; n3 += 1)
                  if (e15.implicitTypes[n3].resolve(t5))
                    return true;
                return false;
              }(e14, t4);
            })) {
              case 1:
                return t3;
              case 2:
                return "'" + t3.replace(/'/g, "''") + "'";
              case 3:
                return "|" + C(t3, e14.indent) + w(m(t3, o2));
              case 4:
                return ">" + C(t3, e14.indent) + w(m(function(e15, t4) {
                  for (var n3, r3, a2 = /(\n+)([^\n]*)/g, o3 = (c2 = e15.indexOf("\n"), c2 = c2 === -1 ? e15.length : c2, a2.lastIndex = c2, T(e15.slice(0, c2), t4)), s3 = e15[0] === "\n" || e15[0] === " ", c2; r3 = a2.exec(e15); ) {
                    var l2 = r3[1], u2 = r3[2];
                    n3 = u2[0] === " ", o3 += l2 + (s3 || n3 || u2 === "" ? "" : "\n") + T(u2, t4), s3 = n3;
                  }
                  return o3;
                }(t3, s2), o2));
              case 5:
                return '"' + function(e15) {
                  for (var t4, n3, r3, a2 = "", o3 = 0; o3 < e15.length; o3++)
                    (t4 = e15.charCodeAt(o3)) >= 55296 && t4 <= 56319 && (n3 = e15.charCodeAt(o3 + 1)) >= 56320 && n3 <= 57343 ? (a2 += f(1024 * (t4 - 55296) + n3 - 56320 + 65536), o3++) : (r3 = u[t4], a2 += !r3 && _(t4) ? e15[o3] : r3 || f(t4));
                  return a2;
                }(t3) + '"';
              default:
                throw new a("impossible error: invalid scalar style");
            }
          }();
        }
        function C(e14, t3) {
          var n2 = y(e14) ? String(t3) : "", r2 = e14[e14.length - 1] === "\n";
          return n2 + (r2 && (e14[e14.length - 2] === "\n" || e14 === "\n") ? "+" : r2 ? "" : "-") + "\n";
        }
        function w(e14) {
          return e14[e14.length - 1] === "\n" ? e14.slice(0, -1) : e14;
        }
        function T(e14, t3) {
          if (e14 === "" || e14[0] === " ")
            return e14;
          for (var n2, r2, a2 = / [^ ]/g, o2 = 0, s2 = 0, c2 = 0, l2 = ""; n2 = a2.exec(e14); )
            (c2 = n2.index) - o2 > t3 && (r2 = s2 > o2 ? s2 : c2, l2 += "\n" + e14.slice(o2, r2), o2 = r2 + 1), s2 = c2;
          return l2 += "\n", e14.length - o2 > t3 && s2 > o2 ? l2 += e14.slice(o2, s2) + "\n" + e14.slice(s2 + 1) : l2 += e14.slice(o2), l2.slice(1);
        }
        function E(e14, t3, n2) {
          var r2, o2, s2, u2, d2, f2;
          for (s2 = 0, u2 = (o2 = n2 ? e14.explicitTypes : e14.implicitTypes).length; s2 < u2; s2 += 1)
            if (((d2 = o2[s2]).instanceOf || d2.predicate) && (!d2.instanceOf || typeof t3 == "object" && t3 instanceof d2.instanceOf) && (!d2.predicate || d2.predicate(t3))) {
              if (e14.tag = n2 ? d2.tag : "?", d2.represent) {
                if (f2 = e14.styleMap[d2.tag] || d2.defaultStyle, c.call(d2.represent) === "[object Function]")
                  r2 = d2.represent(t3, f2);
                else {
                  if (!l.call(d2.represent, f2))
                    throw new a("!<" + d2.tag + '> tag resolver accepts not "' + f2 + '" style');
                  r2 = d2.represent[f2](t3, f2);
                }
                e14.dump = r2;
              }
              return true;
            }
          return false;
        }
        function D(e14, t3, n2, r2, o2, s2) {
          e14.tag = null, e14.dump = n2, E(e14, n2, false) || E(e14, n2, true);
          var l2 = c.call(e14.dump);
          r2 &&= e14.flowLevel < 0 || e14.flowLevel > t3;
          var u2, d2, f2 = l2 === "[object Object]" || l2 === "[object Array]";
          if (f2 && (d2 = (u2 = e14.duplicates.indexOf(n2)) !== -1), (e14.tag !== null && e14.tag !== "?" || d2 || e14.indent !== 2 && t3 > 0) && (o2 = false), d2 && e14.usedDuplicates[u2])
            e14.dump = "*ref_" + u2;
          else {
            if (f2 && d2 && !e14.usedDuplicates[u2] && (e14.usedDuplicates[u2] = true), l2 === "[object Object]")
              r2 && Object.keys(e14.dump).length !== 0 ? (function(e15, t4, n3, r3) {
                var o3, s3, c2, l3, u3, d3, f3 = "", p3 = e15.tag, m2 = Object.keys(n3);
                if (true === e15.sortKeys)
                  m2.sort();
                else if (typeof e15.sortKeys == "function")
                  m2.sort(e15.sortKeys);
                else if (e15.sortKeys)
                  throw new a("sortKeys must be a boolean or a function");
                for (o3 = 0, s3 = m2.length; o3 < s3; o3 += 1)
                  d3 = "", r3 && o3 === 0 || (d3 += h(e15, t4)), l3 = n3[c2 = m2[o3]], D(e15, t4 + 1, c2, true, true, true) && ((u3 = e15.tag !== null && e15.tag !== "?" || e15.dump && e15.dump.length > 1024) && (e15.dump && e15.dump.charCodeAt(0) === 10 ? d3 += "?" : d3 += "? "), d3 += e15.dump, u3 && (d3 += h(e15, t4)), D(e15, t4 + 1, l3, true, u3) && (e15.dump && e15.dump.charCodeAt(0) === 10 ? d3 += ":" : d3 += ": ", f3 += d3 += e15.dump));
                e15.tag = p3, e15.dump = f3 || "{}";
              }(e14, t3, e14.dump, o2), d2 && (e14.dump = "&ref_" + u2 + e14.dump)) : (function(e15, t4, n3) {
                var r3, a2, o3, s3, c2, l3 = "", u3 = e15.tag, d3 = Object.keys(n3);
                for (r3 = 0, a2 = d3.length; r3 < a2; r3 += 1)
                  c2 = "", r3 !== 0 && (c2 += ", "), e15.condenseFlow && (c2 += '"'), s3 = n3[o3 = d3[r3]], D(e15, t4, o3, false, false) && (e15.dump.length > 1024 && (c2 += "? "), c2 += e15.dump + (e15.condenseFlow ? '"' : "") + ":" + (e15.condenseFlow ? "" : " "), D(e15, t4, s3, false, false) && (l3 += c2 += e15.dump));
                e15.tag = u3, e15.dump = "{" + l3 + "}";
              }(e14, t3, e14.dump), d2 && (e14.dump = "&ref_" + u2 + " " + e14.dump));
            else if (l2 === "[object Array]") {
              var p2 = e14.noArrayIndent && t3 > 0 ? t3 - 1 : t3;
              r2 && e14.dump.length !== 0 ? (function(e15, t4, n3, r3) {
                var a2, o3, s3 = "", c2 = e15.tag;
                for (a2 = 0, o3 = n3.length; a2 < o3; a2 += 1)
                  D(e15, t4 + 1, n3[a2], true, true) && (r3 && a2 === 0 || (s3 += h(e15, t4)), e15.dump && e15.dump.charCodeAt(0) === 10 ? s3 += "-" : s3 += "- ", s3 += e15.dump);
                e15.tag = c2, e15.dump = s3 || "[]";
              }(e14, p2, e14.dump, o2), d2 && (e14.dump = "&ref_" + u2 + e14.dump)) : (function(e15, t4, n3) {
                var r3, a2, o3 = "", s3 = e15.tag;
                for (r3 = 0, a2 = n3.length; r3 < a2; r3 += 1)
                  D(e15, t4, n3[r3], false, false) && (r3 !== 0 && (o3 += "," + (e15.condenseFlow ? "" : " ")), o3 += e15.dump);
                e15.tag = s3, e15.dump = "[" + o3 + "]";
              }(e14, p2, e14.dump), d2 && (e14.dump = "&ref_" + u2 + " " + e14.dump));
            } else {
              if (l2 !== "[object String]") {
                if (e14.skipInvalid)
                  return false;
                throw new a("unacceptable kind of an object to dump " + l2);
              }
              e14.tag !== "?" && S(e14, e14.dump, t3, s2);
            }
            e14.tag !== null && e14.tag !== "?" && (e14.dump = "!<" + e14.tag + "> " + e14.dump);
          }
          return true;
        }
        function O(e14, t3) {
          var n2, r2, a2 = [], o2 = [];
          for (function e15(t4, n3, r3) {
            var a3, o3, s2;
            if (typeof t4 == "object" && t4)
              if ((o3 = n3.indexOf(t4)) !== -1)
                r3.indexOf(o3) === -1 && r3.push(o3);
              else if (n3.push(t4), Array.isArray(t4))
                for (o3 = 0, s2 = t4.length; o3 < s2; o3 += 1)
                  e15(t4[o3], n3, r3);
              else
                for (a3 = Object.keys(t4), o3 = 0, s2 = a3.length; o3 < s2; o3 += 1)
                  e15(t4[a3[o3]], n3, r3);
          }(e14, a2, o2), n2 = 0, r2 = o2.length; n2 < r2; n2 += 1)
            t3.duplicates.push(a2[o2[n2]]);
          t3.usedDuplicates = Array(r2);
        }
        function k(e14, t3) {
          var n2 = new p(t3 ||= {});
          return n2.noRefs || O(e14, n2), D(n2, 0, e14, true, true) ? n2.dump + "\n" : "";
        }
        e13.exports.dump = k, e13.exports.safeDump = function(e14, t3) {
          return k(e14, r.extend({ schema: s }, t3));
        };
      },
      function(e13, t2, n) {
        n(31), n(32), n(33), n(64), n(19), n(65), n(20), n(68), n(92), n(144), n(22), n(94), n(23);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        }), o = this && this.__values || function(e14) {
          var t3 = typeof Symbol == "function" && Symbol.iterator, n2 = t3 && e14[t3], r2 = 0;
          if (n2)
            return n2.call(e14);
          if (e14 && typeof e14.length == "number")
            return { next: function() {
              return e14 && r2 >= e14.length && (e14 = void 0), {
                value: e14 && e14[r2++],
                done: !e14
              };
            } };
          throw TypeError(t3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, s = this && this.__read || function(e14, t3) {
          var n2 = typeof Symbol == "function" && e14[Symbol.iterator];
          if (!n2)
            return e14;
          var r2, a2, o2 = n2.call(e14), s2 = [];
          try {
            for (; (t3 === void 0 || t3-- > 0) && !(r2 = o2.next()).done; )
              s2.push(r2.value);
          } catch (e15) {
            a2 = { error: e15 };
          } finally {
            try {
              r2 && !r2.done && (n2 = o2.return) && n2.call(o2);
            } finally {
              if (a2)
                throw a2.error;
            }
          }
          return s2;
        };
        Object.defineProperty(t2, "__esModule", { value: true });
        var c = n(91), l = n(1), u = n(183), d = n(0), f = n(7), p = n(95), m = n(69), h = n(3), g = n(305), _ = n(306), v = n(307);
        t2.XMLBuilderCBImpl = function(e14) {
          function t3(t4, n2) {
            n2 === void 0 && (n2 = false);
            var r2 = e14.call(this) || this;
            return r2._hasDeclaration = false, r2._docTypeName = "", r2._hasDocumentElement = false, r2._currentElementSerialized = false, r2._openTags = [], r2._ended = false, r2._fragment = n2, r2._options = l.applyDefaults(t4 || {}, c.DefaultXMLBuilderCBOptions), r2._builderOptions = {
              defaultNamespace: r2._options.defaultNamespace,
              namespaceAlias: r2._options.namespaceAlias
            }, r2._options.format === "json" ? r2._writer = new _.JSONCBWriter(r2._options) : r2._options.format === "yaml" ? r2._writer = new v.YAMLCBWriter(r2._options) : r2._writer = new g.XMLCBWriter(r2._options), r2._options.data !== void 0 && r2.on("data", r2._options.data), r2._options.end !== void 0 && r2.on("end", r2._options.end), r2._options.error !== void 0 && r2.on("error", r2._options.error), r2._prefixMap = new p.NamespacePrefixMap(), r2._prefixMap.set("xml", f.namespace.XML), r2._prefixIndex = { value: 1 }, r2._push(r2._writer.frontMatter()), r2;
          }
          return a(t3, e14), t3.prototype.ele = function(e15, t4, n2) {
            var r2, a2;
            if (l.isObject(e15) || l.isString(e15) && (/^\s*</.test(e15) || /^\s*[\{\[]/.test(e15) || /^(\s*|(#.*)|(%.*))*---/.test(e15))) {
              var s2 = u.fragment().set(this._options);
              try {
                s2.ele(e15);
              } catch (e16) {
                return this.emit("error", e16), this;
              }
              try {
                for (var c2 = o(s2.node.childNodes), d2 = c2.next(); !d2.done; d2 = c2.next()) {
                  var f2 = d2.value;
                  this._fromNode(f2);
                }
              } catch (e16) {
                r2 = { error: e16 };
              } finally {
                try {
                  d2 && !d2.done && (a2 = c2.return) && a2.call(c2);
                } finally {
                  if (r2)
                    throw r2.error;
                }
              }
              return this;
            }
            if (this._serializeOpenTag(true), !this._fragment && this._hasDocumentElement && this._writer.level === 0)
              return this.emit("error", /* @__PURE__ */ Error("Document cannot have multiple document element nodes.")), this;
            try {
              this._currentElement = u.fragment(this._builderOptions).ele(e15, t4, n2);
            } catch (e16) {
              return this.emit("error", e16), this;
            }
            return this._fragment || this._hasDocumentElement || this._docTypeName === "" || this._currentElement.node._qualifiedName === this._docTypeName ? (this._currentElementSerialized = false, this._fragment || (this._hasDocumentElement = true), this) : (this.emit("error", /* @__PURE__ */ Error("Document element name does not match DocType declaration name.")), this);
          }, t3.prototype.att = function(e15, t4, n2) {
            if (this._currentElement === void 0)
              return this.emit("error", /* @__PURE__ */ Error("Cannot insert an attribute node as child of a document node.")), this;
            try {
              this._currentElement.att(e15, t4, n2);
            } catch (e16) {
              return this.emit("error", e16), this;
            }
            return this;
          }, t3.prototype.com = function(e15) {
            var t4;
            this._serializeOpenTag(true);
            try {
              t4 = u.fragment(this._builderOptions).com(e15).first().node;
            } catch (e16) {
              return this.emit("error", e16), this;
            }
            return !this._options.wellFormed || d.xml_isLegalChar(t4.data) && t4.data.indexOf("--") === -1 && !t4.data.endsWith("-") ? (this._push(this._writer.comment(t4.data)), this) : (this.emit("error", /* @__PURE__ */ Error("Comment data contains invalid characters (well-formed required).")), this);
          }, t3.prototype.txt = function(e15) {
            if (!this._fragment && this._currentElement === void 0)
              return this.emit("error", /* @__PURE__ */ Error("Cannot insert a text node as child of a document node.")), this;
            var t4;
            this._serializeOpenTag(true);
            try {
              t4 = u.fragment(this._builderOptions).txt(e15).first().node;
            } catch (e16) {
              return this.emit("error", e16), this;
            }
            if (this._options.wellFormed && !d.xml_isLegalChar(t4.data))
              return this.emit("error", /* @__PURE__ */ Error("Text data contains invalid characters (well-formed required).")), this;
            var n2 = t4.data.replace(/(?!&(lt|gt|amp|apos|quot);)&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            return this._push(this._writer.text(n2)), this;
          }, t3.prototype.ins = function(e15, t4) {
            var n2;
            t4 === void 0 && (t4 = ""), this._serializeOpenTag(true);
            try {
              n2 = u.fragment(this._builderOptions).ins(e15, t4).first().node;
            } catch (e16) {
              return this.emit("error", e16), this;
            }
            return this._options.wellFormed && (n2.target.indexOf(":") !== -1 || /^xml$/i.test(n2.target)) ? (this.emit("error", /* @__PURE__ */ Error("Processing instruction target contains invalid characters (well-formed required).")), this) : this._options.wellFormed && !d.xml_isLegalChar(n2.data) ? (this.emit("error", Error("Processing instruction data contains invalid characters (well-formed required).")), this) : (this._push(this._writer.instruction(n2.target, n2.data)), this);
          }, t3.prototype.dat = function(e15) {
            var t4;
            this._serializeOpenTag(true);
            try {
              t4 = u.fragment(this._builderOptions).dat(e15).first().node;
            } catch (e16) {
              return this.emit("error", e16), this;
            }
            return this._push(this._writer.cdata(t4.data)), this;
          }, t3.prototype.dec = function(e15) {
            return e15 === void 0 && (e15 = { version: "1.0" }), this._fragment ? (this.emit("error", Error("Cannot insert an XML declaration into a document fragment.")), this) : this._hasDeclaration ? (this.emit("error", Error("XML declaration is already inserted.")), this) : (this._push(this._writer.declaration(e15.version || "1.0", e15.encoding, e15.standalone)), this._hasDeclaration = true, this);
          }, t3.prototype.dtd = function(e15) {
            if (this._fragment)
              return this.emit("error", Error("Cannot insert a DocType declaration into a document fragment.")), this;
            if (this._docTypeName !== "")
              return this.emit("error", /* @__PURE__ */ Error("DocType declaration is already inserted.")), this;
            if (this._hasDocumentElement)
              return this.emit("error", /* @__PURE__ */ Error("Cannot insert DocType declaration after document element.")), this;
            var t4;
            try {
              t4 = u.create().dtd(e15).first().node;
            } catch (e16) {
              return this.emit("error", e16), this;
            }
            return this._options.wellFormed && !d.xml_isPubidChar(t4.publicId) ? (this.emit("error", /* @__PURE__ */ Error("DocType public identifier does not match PubidChar construct (well-formed required).")), this) : this._options.wellFormed && (!d.xml_isLegalChar(t4.systemId) || t4.systemId.indexOf('"') !== -1 && t4.systemId.indexOf("'") !== -1) ? (this.emit("error", /* @__PURE__ */ Error("DocType system identifier contains invalid characters (well-formed required).")), this) : (this._docTypeName = e15.name, this._push(this._writer.docType(e15.name, t4.publicId, t4.systemId)), this);
          }, t3.prototype.import = function(e15) {
            var t4, n2, r2 = u.fragment().set(this._options);
            try {
              r2.import(e15);
            } catch (e16) {
              return this.emit("error", e16), this;
            }
            try {
              for (var a2 = o(r2.node.childNodes), s2 = a2.next(); !s2.done; s2 = a2.next()) {
                var c2 = s2.value;
                this._fromNode(c2);
              }
            } catch (e16) {
              t4 = { error: e16 };
            } finally {
              try {
                s2 && !s2.done && (n2 = a2.return) && n2.call(a2);
              } finally {
                if (t4)
                  throw t4.error;
              }
            }
            return this;
          }, t3.prototype.up = function() {
            return this._serializeOpenTag(false), this._serializeCloseTag(), this;
          }, t3.prototype.end = function() {
            for (this._serializeOpenTag(false); this._openTags.length > 0; )
              this._serializeCloseTag();
            return this._push(null), this;
          }, t3.prototype._serializeOpenTag = function(e15) {
            if (!this._currentElementSerialized && this._currentElement !== void 0) {
              var n2 = this._currentElement.node;
              if (!this._options.wellFormed || n2.localName.indexOf(":") === -1 && d.xml_isName(n2.localName)) {
                var r2 = "", a2 = false, o2 = this._prefixMap.copy(), s2 = {}, c2 = this._recordNamespaceInformation(n2, o2, s2), l2 = this._openTags.length === 0 ? null : this._openTags[this._openTags.length - 1][1], u2 = n2.namespaceURI;
                if (u2 === null && (u2 = l2), l2 === u2)
                  c2 !== null && (a2 = true), r2 = u2 === f.namespace.XML ? "xml:" + n2.localName : n2.localName, this._writer.beginElement(r2), this._push(this._writer.openTagBegin(r2));
                else {
                  var p2 = n2.prefix, m2 = null;
                  if (p2 === null && u2 === c2 || (m2 = o2.get(p2, u2)), p2 === "xmlns") {
                    if (this._options.wellFormed)
                      return void this.emit("error", /* @__PURE__ */ Error("An element cannot have the 'xmlns' prefix (well-formed required)."));
                    m2 = p2;
                  }
                  m2 === null ? p2 === null ? c2 === null || c2 !== null && c2 !== u2 ? (a2 = true, r2 += n2.localName, l2 = u2, this._writer.beginElement(r2), this._push(this._writer.openTagBegin(r2)), this._push(this._writer.attribute("xmlns", this._serializeAttributeValue(u2, this._options.wellFormed)))) : (r2 += n2.localName, l2 = u2, this._writer.beginElement(r2), this._push(this._writer.openTagBegin(r2))) : (p2 in s2 && (p2 = this._generatePrefix(u2, o2, this._prefixIndex)), o2.set(p2, u2), r2 += p2 + ":" + n2.localName, this._writer.beginElement(r2), this._push(this._writer.openTagBegin(r2)), this._push(this._writer.attribute("xmlns:" + p2, this._serializeAttributeValue(u2, this._options.wellFormed))), c2 !== null && (l2 = c2 || null)) : (r2 = m2 + ":" + n2.localName, c2 !== null && c2 !== f.namespace.XML && (l2 = c2 || null), this._writer.beginElement(r2), this._push(this._writer.openTagBegin(r2)));
                }
                this._serializeAttributes(n2, o2, this._prefixIndex, s2, a2, this._options.wellFormed);
                var h2 = u2 === f.namespace.HTML;
                h2 && !e15 && t3._VoidElementNames.has(n2.localName) ? (this._push(this._writer.openTagEnd(r2, true, true)), this._writer.endElement(r2)) : h2 || e15 ? this._push(this._writer.openTagEnd(r2, false, false)) : (this._push(this._writer.openTagEnd(r2, true, false)), this._writer.endElement(r2)), this._currentElementSerialized = true, this._openTags.push([
                  r2,
                  l2,
                  this._prefixMap,
                  e15
                ]), this._isPrefixMapModified(this._prefixMap, o2) && (this._prefixMap = o2), this._writer.level++;
              } else
                this.emit("error", /* @__PURE__ */ Error("Node local name contains invalid characters (well-formed required)."));
            }
          }, t3.prototype._serializeCloseTag = function() {
            this._writer.level--;
            var e15 = this._openTags.pop();
            if (e15 !== void 0) {
              var t4 = s(e15, 4), n2 = t4[0], r2 = (t4[1], t4[2]), a2 = t4[3];
              this._prefixMap = r2, a2 && (this._push(this._writer.closeTag(n2)), this._writer.endElement(n2));
            } else
              this.emit("error", /* @__PURE__ */ Error("Last element is undefined."));
          }, t3.prototype._push = function(e15) {
            e15 === null ? (this._ended = true, this.emit("end")) : this._ended ? this.emit("error", /* @__PURE__ */ Error("Cannot push to ended stream.")) : e15.length !== 0 && (this._writer.hasData = true, this.emit("data", e15, this._writer.level));
          }, t3.prototype._fromNode = function(e15) {
            var t4, n2, r2, a2;
            if (h.Guard.isElementNode(e15)) {
              var s2 = e15.prefix ? e15.prefix + ":" + e15.localName : e15.localName;
              e15.namespaceURI === null ? this.ele(s2) : this.ele(e15.namespaceURI, s2);
              try {
                for (var c2 = o(e15.attributes), l2 = c2.next(); !l2.done; l2 = c2.next()) {
                  var u2 = l2.value, d2 = u2.prefix ? u2.prefix + ":" + u2.localName : u2.localName;
                  u2.namespaceURI === null ? this.att(d2, u2.value) : this.att(u2.namespaceURI, d2, u2.value);
                }
              } catch (e16) {
                t4 = { error: e16 };
              } finally {
                try {
                  l2 && !l2.done && (n2 = c2.return) && n2.call(c2);
                } finally {
                  if (t4)
                    throw t4.error;
                }
              }
              try {
                for (var f2 = o(e15.childNodes), p2 = f2.next(); !p2.done; p2 = f2.next()) {
                  var m2 = p2.value;
                  this._fromNode(m2);
                }
              } catch (e16) {
                r2 = { error: e16 };
              } finally {
                try {
                  p2 && !p2.done && (a2 = f2.return) && a2.call(f2);
                } finally {
                  if (r2)
                    throw r2.error;
                }
              }
              this.up();
            } else
              h.Guard.isExclusiveTextNode(e15) && e15.data ? this.txt(e15.data) : h.Guard.isCommentNode(e15) ? this.com(e15.data) : h.Guard.isCDATASectionNode(e15) ? this.dat(e15.data) : h.Guard.isProcessingInstructionNode(e15) && this.ins(e15.target, e15.data);
          }, t3.prototype._serializeAttributes = function(e15, t4, n2, r2, a2, s2) {
            var c2, l2, u2 = s2 ? new m.LocalNameSet() : void 0;
            try {
              for (var p2 = o(e15.attributes), h2 = p2.next(); !h2.done; h2 = p2.next()) {
                var g2 = h2.value;
                if (s2 || a2 || g2.namespaceURI !== null) {
                  if (s2 && u2 && u2.has(g2.namespaceURI, g2.localName))
                    return void this.emit("error", /* @__PURE__ */ Error("Element contains duplicate attributes (well-formed required)."));
                  s2 && u2 && u2.set(g2.namespaceURI, g2.localName);
                  var _2 = g2.namespaceURI, v2 = null;
                  if (_2 !== null)
                    if (v2 = t4.get(g2.prefix, _2), _2 === f.namespace.XMLNS) {
                      if (g2.value === f.namespace.XML || g2.prefix === null && a2 || g2.prefix !== null && (!(g2.localName in r2) || r2[g2.localName] !== g2.value) && t4.has(g2.localName, g2.value))
                        continue;
                      if (s2 && g2.value === f.namespace.XMLNS)
                        return void this.emit("error", /* @__PURE__ */ Error("XMLNS namespace is reserved (well-formed required)."));
                      if (s2 && g2.value === "")
                        return void this.emit("error", /* @__PURE__ */ Error("Namespace prefix declarations cannot be used to undeclare a namespace (well-formed required)."));
                      g2.prefix === "xmlns" && (v2 = "xmlns");
                    } else
                      v2 === null && (v2 = g2.prefix === null || t4.hasPrefix(g2.prefix) && !t4.has(g2.prefix, _2) ? this._generatePrefix(_2, t4, n2) : g2.prefix, this._push(this._writer.attribute("xmlns:" + v2, this._serializeAttributeValue(_2, this._options.wellFormed))));
                  if (s2 && (g2.localName.indexOf(":") !== -1 || !d.xml_isName(g2.localName) || g2.localName === "xmlns" && _2 === null))
                    return void this.emit("error", /* @__PURE__ */ Error("Attribute local name contains invalid characters (well-formed required)."));
                  this._push(this._writer.attribute((v2 === null ? "" : v2 + ":") + g2.localName, this._serializeAttributeValue(g2.value, this._options.wellFormed)));
                } else
                  this._push(this._writer.attribute(g2.localName, this._serializeAttributeValue(g2.value, this._options.wellFormed)));
              }
            } catch (e16) {
              c2 = { error: e16 };
            } finally {
              try {
                h2 && !h2.done && (l2 = p2.return) && l2.call(p2);
              } finally {
                if (c2)
                  throw c2.error;
              }
            }
          }, t3.prototype._serializeAttributeValue = function(e15, t4) {
            return t4 && e15 !== null && !d.xml_isLegalChar(e15) ? (this.emit("error", /* @__PURE__ */ Error("Invalid characters in attribute value.")), "") : e15 === null ? "" : e15.replace(/(?!&(lt|gt|amp|apos|quot);)&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
          }, t3.prototype._recordNamespaceInformation = function(e15, t4, n2) {
            var r2, a2, s2 = null;
            try {
              for (var c2 = o(e15.attributes), l2 = c2.next(); !l2.done; l2 = c2.next()) {
                var u2 = l2.value, d2 = u2.namespaceURI, p2 = u2.prefix;
                if (d2 === f.namespace.XMLNS) {
                  if (p2 === null) {
                    s2 = u2.value;
                    continue;
                  }
                  var m2 = u2.localName, h2 = u2.value;
                  if (h2 === f.namespace.XML || (h2 === "" && (h2 = null), t4.has(m2, h2)))
                    continue;
                  t4.set(m2, h2), n2[m2] = h2 || "";
                }
              }
            } catch (e16) {
              r2 = { error: e16 };
            } finally {
              try {
                l2 && !l2.done && (a2 = c2.return) && a2.call(c2);
              } finally {
                if (r2)
                  throw r2.error;
              }
            }
            return s2;
          }, t3.prototype._generatePrefix = function(e15, t4, n2) {
            var r2 = "ns" + n2.value;
            return n2.value++, t4.set(r2, e15), r2;
          }, t3.prototype._isPrefixMapModified = function(e15, t4) {
            var n2 = e15._items, r2 = t4._items, a2 = e15._nullItems, o2 = t4._nullItems;
            for (var s2 in r2) {
              var c2 = n2[s2];
              if (c2 === void 0)
                return true;
              var l2 = r2[s2];
              if (c2.length !== l2.length)
                return true;
              for (var u2 = 0; u2 < c2.length; u2++)
                if (c2[u2] !== l2[u2])
                  return true;
            }
            if (a2.length !== o2.length)
              return true;
            for (u2 = 0; u2 < a2.length; u2++)
              if (a2[u2] !== o2[u2])
                return true;
            return false;
          }, t3._VoidElementNames = /* @__PURE__ */ new Set([
            "area",
            "base",
            "basefont",
            "bgsound",
            "br",
            "col",
            "embed",
            "frame",
            "hr",
            "img",
            "input",
            "keygen",
            "link",
            "menuitem",
            "meta",
            "param",
            "source",
            "track",
            "wbr"
          ]), t3;
        }(n(308).EventEmitter);
      },
      function(e13, t2, n) {
        n(74);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true }), t2.XMLCBWriter = function(e14) {
          function t3(t4) {
            var n2 = e14.call(this, t4) || this;
            return n2._lineLength = 0, n2;
          }
          return a(t3, e14), t3.prototype.frontMatter = function() {
            return "";
          }, t3.prototype.declaration = function(e15, t4, n2) {
            var r2 = this._beginLine() + "<?xml";
            return r2 += ' version="' + e15 + '"', t4 !== void 0 && (r2 += ' encoding="' + t4 + '"'), n2 !== void 0 && (r2 += ' standalone="' + (n2 ? "yes" : "no") + '"'), r2 += "?>";
          }, t3.prototype.docType = function(e15, t4, n2) {
            var r2 = this._beginLine();
            return r2 += t4 && n2 ? "<!DOCTYPE " + e15 + ' PUBLIC "' + t4 + '" "' + n2 + '">' : t4 ? "<!DOCTYPE " + e15 + ' PUBLIC "' + t4 + '">' : n2 ? "<!DOCTYPE " + e15 + ' SYSTEM "' + n2 + '">' : "<!DOCTYPE " + e15 + ">";
          }, t3.prototype.comment = function(e15) {
            return this._beginLine() + "<!--" + e15 + "-->";
          }, t3.prototype.text = function(e15) {
            return this._beginLine() + e15;
          }, t3.prototype.instruction = function(e15, t4) {
            return t4 ? this._beginLine() + "<?" + e15 + " " + t4 + "?>" : this._beginLine() + "<?" + e15 + "?>";
          }, t3.prototype.cdata = function(e15) {
            return this._beginLine() + "<![CDATA[" + e15 + "]]>";
          }, t3.prototype.openTagBegin = function(e15) {
            return this._lineLength += 1 + e15.length, this._beginLine() + "<" + e15;
          }, t3.prototype.openTagEnd = function(e15, t4, n2) {
            return n2 ? " />" : t4 ? this._writerOptions.allowEmptyTags ? "></" + e15 + ">" : this._writerOptions.spaceBeforeSlash ? " />" : "/>" : ">";
          }, t3.prototype.closeTag = function(e15) {
            return this._beginLine() + "</" + e15 + ">";
          }, t3.prototype.attribute = function(e15, t4) {
            var n2 = e15 + '="' + t4 + '"';
            return this._writerOptions.prettyPrint && this._writerOptions.width > 0 && this._lineLength + 1 + n2.length > this._writerOptions.width ? (n2 = this._beginLine() + this._indent(1) + n2, this._lineLength = n2.length, n2) : (this._lineLength += 1 + n2.length, " " + n2);
          }, t3.prototype.beginElement = function(e15) {
          }, t3.prototype.endElement = function(e15) {
          }, t3.prototype._beginLine = function() {
            if (this._writerOptions.prettyPrint) {
              var e15 = (this.hasData ? this._writerOptions.newline : "") + this._indent(this._writerOptions.offset + this.level);
              return this._lineLength = e15.length, e15;
            }
            return "";
          }, t3.prototype._indent = function(e15) {
            return e15 <= 0 ? "" : this._writerOptions.indent.repeat(e15);
          }, t3;
        }(n(114).BaseCBWriter);
      },
      function(e13, t2, n) {
        n(74);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true }), t2.JSONCBWriter = function(e14) {
          function t3(t4) {
            var n2 = e14.call(this, t4) || this;
            return n2._hasChildren = [], n2._additionalLevel = 0, n2;
          }
          return a(t3, e14), t3.prototype.frontMatter = function() {
            return "";
          }, t3.prototype.declaration = function(e15, t4, n2) {
            return "";
          }, t3.prototype.docType = function(e15, t4, n2) {
            return "";
          }, t3.prototype.comment = function(e15) {
            return this._comma() + this._beginLine() + "{" + this._sep() + this._key(this._builderOptions.convert.comment) + this._sep() + this._val(e15) + this._sep() + "}";
          }, t3.prototype.text = function(e15) {
            return this._comma() + this._beginLine() + "{" + this._sep() + this._key(this._builderOptions.convert.text) + this._sep() + this._val(e15) + this._sep() + "}";
          }, t3.prototype.instruction = function(e15, t4) {
            return this._comma() + this._beginLine() + "{" + this._sep() + this._key(this._builderOptions.convert.ins) + this._sep() + this._val(t4 ? e15 + " " + t4 : e15) + this._sep() + "}";
          }, t3.prototype.cdata = function(e15) {
            return this._comma() + this._beginLine() + "{" + this._sep() + this._key(this._builderOptions.convert.cdata) + this._sep() + this._val(e15) + this._sep() + "}";
          }, t3.prototype.attribute = function(e15, t4) {
            return this._comma() + this._beginLine(1) + "{" + this._sep() + this._key(this._builderOptions.convert.att + e15) + this._sep() + this._val(t4) + this._sep() + "}";
          }, t3.prototype.openTagBegin = function(e15) {
            var t4 = this._comma() + this._beginLine() + "{" + this._sep() + this._key(e15) + this._sep() + "{";
            return this._additionalLevel++, this.hasData = true, t4 += this._beginLine() + this._key(this._builderOptions.convert.text) + this._sep() + "[", this._hasChildren.push(false), t4;
          }, t3.prototype.openTagEnd = function(e15, t4, n2) {
            if (t4) {
              var r2 = this._sep() + "]";
              return this._additionalLevel--, r2 += this._beginLine() + "}" + this._sep() + "}";
            }
            return "";
          }, t3.prototype.closeTag = function(e15) {
            var t4 = this._beginLine() + "]";
            return this._additionalLevel--, t4 += this._beginLine() + "}" + this._sep() + "}";
          }, t3.prototype.beginElement = function(e15) {
          }, t3.prototype.endElement = function(e15) {
            this._hasChildren.pop();
          }, t3.prototype._beginLine = function(e15) {
            return e15 === void 0 && (e15 = 0), this._writerOptions.prettyPrint ? (this.hasData ? this._writerOptions.newline : "") + this._indent(this._writerOptions.offset + this.level + e15) : "";
          }, t3.prototype._indent = function(e15) {
            return e15 + this._additionalLevel <= 0 ? "" : this._writerOptions.indent.repeat(e15 + this._additionalLevel);
          }, t3.prototype._comma = function() {
            var e15 = this._hasChildren[this._hasChildren.length - 1] ? "," : "";
            return this._hasChildren.length > 0 && (this._hasChildren[this._hasChildren.length - 1] = true), e15;
          }, t3.prototype._sep = function() {
            return this._writerOptions.prettyPrint ? " " : "";
          }, t3.prototype._key = function(e15) {
            return '"' + e15 + '":';
          }, t3.prototype._val = function(e15) {
            return JSON.stringify(e15);
          }, t3;
        }(n(114).BaseCBWriter);
      },
      function(e13, t2, n) {
        n(74);
        var r, a = this && this.__extends || (r = function(e14, t3) {
          return (r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e15, t4) {
            e15.__proto__ = t4;
          } || function(e15, t4) {
            for (var n2 in t4)
              t4.hasOwnProperty(n2) && (e15[n2] = t4[n2]);
          })(e14, t3);
        }, function(e14, t3) {
          function n2() {
            this.constructor = e14;
          }
          r(e14, t3), e14.prototype = t3 === null ? Object.create(t3) : (n2.prototype = t3.prototype, new n2());
        });
        Object.defineProperty(t2, "__esModule", { value: true }), t2.YAMLCBWriter = function(e14) {
          function t3(t4) {
            var n2 = e14.call(this, t4) || this;
            if (n2._rootWritten = false, n2._additionalLevel = 0, t4.indent.length < 2)
              throw Error("YAML indententation string must be at least two characters long.");
            if (t4.offset < 0)
              throw Error("YAML offset should be zero or a positive number.");
            return n2;
          }
          return a(t3, e14), t3.prototype.frontMatter = function() {
            return this._beginLine() + "---";
          }, t3.prototype.declaration = function(e15, t4, n2) {
            return "";
          }, t3.prototype.docType = function(e15, t4, n2) {
            return "";
          }, t3.prototype.comment = function(e15) {
            return this._beginLine() + this._key(this._builderOptions.convert.comment) + " " + this._val(e15);
          }, t3.prototype.text = function(e15) {
            return this._beginLine() + this._key(this._builderOptions.convert.text) + " " + this._val(e15);
          }, t3.prototype.instruction = function(e15, t4) {
            return this._beginLine() + this._key(this._builderOptions.convert.ins) + " " + this._val(t4 ? e15 + " " + t4 : e15);
          }, t3.prototype.cdata = function(e15) {
            return this._beginLine() + this._key(this._builderOptions.convert.cdata) + " " + this._val(e15);
          }, t3.prototype.attribute = function(e15, t4) {
            this._additionalLevel++;
            var n2 = this._beginLine() + this._key(this._builderOptions.convert.att + e15) + " " + this._val(t4);
            return this._additionalLevel--, n2;
          }, t3.prototype.openTagBegin = function(e15) {
            var t4 = this._beginLine() + this._key(e15);
            return this._rootWritten ||= true, this.hasData = true, this._additionalLevel++, t4 += this._beginLine(true) + this._key(this._builderOptions.convert.text);
          }, t3.prototype.openTagEnd = function(e15, t4, n2) {
            return t4 ? " " + this._val("") : "";
          }, t3.prototype.closeTag = function(e15) {
            return this._additionalLevel--, "";
          }, t3.prototype.beginElement = function(e15) {
          }, t3.prototype.endElement = function(e15) {
          }, t3.prototype._beginLine = function(e15) {
            return e15 === void 0 && (e15 = false), (this.hasData ? this._writerOptions.newline : "") + this._indent(this._writerOptions.offset + this.level, e15);
          }, t3.prototype._indent = function(e15, t4) {
            if (e15 + this._additionalLevel <= 0)
              return "";
            var n2 = this._writerOptions.indent.repeat(e15 + this._additionalLevel);
            return !t4 && this._rootWritten ? n2.substr(0, n2.length - 2) + "-" + n2.substr(-1, 1) : n2;
          }, t3.prototype._key = function(e15) {
            return '"' + e15 + '":';
          }, t3.prototype._val = function(e15) {
            return JSON.stringify(e15);
          }, t3;
        }(n(114).BaseCBWriter);
      },
      function(e13, t2, n) {
        var r, a = typeof Reflect == "object" ? Reflect : null, o = a && typeof a.apply == "function" ? a.apply : function(e14, t3, n2) {
          return Function.prototype.apply.call(e14, t3, n2);
        };
        r = a && typeof a.ownKeys == "function" ? a.ownKeys : Object.getOwnPropertySymbols ? function(e14) {
          return Object.getOwnPropertyNames(e14).concat(Object.getOwnPropertySymbols(e14));
        } : function(e14) {
          return Object.getOwnPropertyNames(e14);
        };
        var s = Number.isNaN || function(e14) {
          return e14 != e14;
        };
        function c() {
          c.init.call(this);
        }
        e13.exports = c, c.EventEmitter = c, c.prototype._events = void 0, c.prototype._eventsCount = 0, c.prototype._maxListeners = void 0;
        var l = 10;
        function u(e14) {
          if (typeof e14 != "function")
            throw TypeError('The "listener" argument must be of type Function. Received type ' + typeof e14);
        }
        function d(e14) {
          return e14._maxListeners === void 0 ? c.defaultMaxListeners : e14._maxListeners;
        }
        function f(e14, t3, n2, r2) {
          var a2, o2, s2, c2;
          if (u(n2), (o2 = e14._events) === void 0 ? (o2 = e14._events = /* @__PURE__ */ Object.create(null), e14._eventsCount = 0) : (o2.newListener !== void 0 && (e14.emit("newListener", t3, n2.listener ? n2.listener : n2), o2 = e14._events), s2 = o2[t3]), s2 === void 0)
            s2 = o2[t3] = n2, ++e14._eventsCount;
          else if (typeof s2 == "function" ? s2 = o2[t3] = r2 ? [n2, s2] : [s2, n2] : r2 ? s2.unshift(n2) : s2.push(n2), (a2 = d(e14)) > 0 && s2.length > a2 && !s2.warned) {
            s2.warned = true;
            var l2 = /* @__PURE__ */ Error("Possible EventEmitter memory leak detected. " + s2.length + " " + String(t3) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            l2.name = "MaxListenersExceededWarning", l2.emitter = e14, l2.type = t3, l2.count = s2.length, c2 = l2, console && console.warn && console.warn(c2);
          }
          return e14;
        }
        function p() {
          if (!this.fired)
            return this.target.removeListener(this.type, this.wrapFn), this.fired = true, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
        }
        function m(e14, t3, n2) {
          var r2 = {
            fired: false,
            wrapFn: void 0,
            target: e14,
            type: t3,
            listener: n2
          }, a2 = p.bind(r2);
          return a2.listener = n2, r2.wrapFn = a2, a2;
        }
        function h(e14, t3, n2) {
          var r2 = e14._events;
          if (r2 === void 0)
            return [];
          var a2 = r2[t3];
          return a2 === void 0 ? [] : typeof a2 == "function" ? n2 ? [a2.listener || a2] : [a2] : n2 ? function(e15) {
            for (var t4 = Array(e15.length), n3 = 0; n3 < t4.length; ++n3)
              t4[n3] = e15[n3].listener || e15[n3];
            return t4;
          }(a2) : _(a2, a2.length);
        }
        function g(e14) {
          var t3 = this._events;
          if (t3 !== void 0) {
            var n2 = t3[e14];
            if (typeof n2 == "function")
              return 1;
            if (n2 !== void 0)
              return n2.length;
          }
          return 0;
        }
        function _(e14, t3) {
          for (var n2 = Array(t3), r2 = 0; r2 < t3; ++r2)
            n2[r2] = e14[r2];
          return n2;
        }
        Object.defineProperty(c, "defaultMaxListeners", {
          enumerable: true,
          get: function() {
            return l;
          },
          set: function(e14) {
            if (typeof e14 != "number" || e14 < 0 || s(e14))
              throw RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e14 + ".");
            l = e14;
          }
        }), c.init = function() {
          this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
        }, c.prototype.setMaxListeners = function(e14) {
          if (typeof e14 != "number" || e14 < 0 || s(e14))
            throw RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e14 + ".");
          return this._maxListeners = e14, this;
        }, c.prototype.getMaxListeners = function() {
          return d(this);
        }, c.prototype.emit = function(e14) {
          for (var t3 = [], n2 = 1; n2 < arguments.length; n2++)
            t3.push(arguments[n2]);
          var r2 = e14 === "error", a2 = this._events;
          if (a2 !== void 0)
            r2 &&= a2.error === void 0;
          else if (!r2)
            return false;
          if (r2) {
            var s2;
            if (t3.length > 0 && (s2 = t3[0]), s2 instanceof Error)
              throw s2;
            var c2 = /* @__PURE__ */ Error("Unhandled error." + (s2 ? " (" + s2.message + ")" : ""));
            throw c2.context = s2, c2;
          }
          var l2 = a2[e14];
          if (l2 === void 0)
            return false;
          if (typeof l2 == "function")
            o(l2, this, t3);
          else {
            var u2 = l2.length, d2 = _(l2, u2);
            for (n2 = 0; n2 < u2; ++n2)
              o(d2[n2], this, t3);
          }
          return true;
        }, c.prototype.addListener = function(e14, t3) {
          return f(this, e14, t3, false);
        }, c.prototype.on = c.prototype.addListener, c.prototype.prependListener = function(e14, t3) {
          return f(this, e14, t3, true);
        }, c.prototype.once = function(e14, t3) {
          return u(t3), this.on(e14, m(this, e14, t3)), this;
        }, c.prototype.prependOnceListener = function(e14, t3) {
          return u(t3), this.prependListener(e14, m(this, e14, t3)), this;
        }, c.prototype.removeListener = function(e14, t3) {
          var n2, r2, a2, o2, s2;
          if (u(t3), (r2 = this._events) === void 0 || (n2 = r2[e14]) === void 0)
            return this;
          if (n2 === t3 || n2.listener === t3)
            --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete r2[e14], r2.removeListener && this.emit("removeListener", e14, n2.listener || t3));
          else if (typeof n2 != "function") {
            for (a2 = -1, o2 = n2.length - 1; o2 >= 0; o2--)
              if (n2[o2] === t3 || n2[o2].listener === t3) {
                s2 = n2[o2].listener, a2 = o2;
                break;
              }
            if (a2 < 0)
              return this;
            a2 === 0 ? n2.shift() : function(e15, t4) {
              for (; t4 + 1 < e15.length; t4++)
                e15[t4] = e15[t4 + 1];
              e15.pop();
            }(n2, a2), n2.length === 1 && (r2[e14] = n2[0]), r2.removeListener !== void 0 && this.emit("removeListener", e14, s2 || t3);
          }
          return this;
        }, c.prototype.off = c.prototype.removeListener, c.prototype.removeAllListeners = function(e14) {
          var t3, n2, r2;
          if ((n2 = this._events) === void 0)
            return this;
          if (n2.removeListener === void 0)
            return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n2[e14] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n2[e14]), this;
          if (arguments.length === 0) {
            var a2, o2 = Object.keys(n2);
            for (r2 = 0; r2 < o2.length; ++r2)
              (a2 = o2[r2]) !== "removeListener" && this.removeAllListeners(a2);
            return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
          }
          if (typeof (t3 = n2[e14]) == "function")
            this.removeListener(e14, t3);
          else if (t3 !== void 0)
            for (r2 = t3.length - 1; r2 >= 0; r2--)
              this.removeListener(e14, t3[r2]);
          return this;
        }, c.prototype.listeners = function(e14) {
          return h(this, e14, true);
        }, c.prototype.rawListeners = function(e14) {
          return h(this, e14, false);
        }, c.listenerCount = function(e14, t3) {
          return typeof e14.listenerCount == "function" ? e14.listenerCount(t3) : g.call(e14, t3);
        }, c.prototype.listenerCount = g, c.prototype.eventNames = function() {
          return this._eventsCount > 0 ? r(this._events) : [];
        };
      },
      function(e13, t2, n) {
        Object.defineProperty(t2, "__esModule", { value: true });
        var r = n(77);
        t2.createCB = function(e14) {
          return new r.XMLBuilderCBImpl(e14);
        }, t2.fragmentCB = function(e14) {
          return new r.XMLBuilderCBImpl(e14, true);
        };
      }
    ]);
  });
}), u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array, fleb = new u8([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  0,
  0,
  0
]), fdeb = new u8([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  0,
  0
]), clim = new u8([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), freb = function(e12, t) {
  for (var n = new u16(31), r = 0; r < 31; ++r)
    n[r] = t += 1 << e12[r - 1];
  for (var a = new u32(n[30]), r = 1; r < 30; ++r)
    for (var o = n[r]; o < n[r + 1]; ++o)
      a[o] = o - n[r] << 5 | r;
  return [n, a];
}, _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0];
_b[1];
for (var rev = new u16(32768), i = 0; i < 32768; ++i) {
  var x = (i & 43690) >>> 1 | (i & 21845) << 1;
  x = (x & 52428) >>> 2 | (x & 13107) << 2, x = (x & 61680) >>> 4 | (x & 3855) << 4, rev[i] = ((x & 65280) >>> 8 | (x & 255) << 8) >>> 1;
}
for (var hMap = function(e12, t, n) {
  for (var r = e12.length, a = 0, o = new u16(t); a < r; ++a)
    e12[a] && ++o[e12[a] - 1];
  var s = new u16(t);
  for (a = 0; a < t; ++a)
    s[a] = s[a - 1] + o[a - 1] << 1;
  var c;
  if (n) {
    c = new u16(1 << t);
    var l = 15 - t;
    for (a = 0; a < r; ++a)
      if (e12[a])
        for (var u = a << 4 | e12[a], d = t - e12[a], f = s[e12[a] - 1]++ << d, p = f | (1 << d) - 1; f <= p; ++f)
          c[rev[f] >>> l] = u;
  } else
    for (c = new u16(r), a = 0; a < r; ++a)
      e12[a] && (c[a] = rev[s[e12[a] - 1]++] >>> 15 - e12[a]);
  return c;
}, flt = new u8(288), i = 0; i < 144; ++i)
  flt[i] = 8;
for (var i = 144; i < 256; ++i)
  flt[i] = 9;
for (var i = 256; i < 280; ++i)
  flt[i] = 7;
for (var i = 280; i < 288; ++i)
  flt[i] = 8;
for (var fdt = new u8(32), i = 0; i < 32; ++i)
  fdt[i] = 5;
var flrm = /* @__PURE__ */ hMap(flt, 9, 1), fdrm = /* @__PURE__ */ hMap(fdt, 5, 1), max = function(e12) {
  for (var t = e12[0], n = 1; n < e12.length; ++n)
    e12[n] > t && (t = e12[n]);
  return t;
}, bits = function(e12, t, n) {
  var r = t / 8 | 0;
  return (e12[r] | e12[r + 1] << 8) >> (t & 7) & n;
}, bits16 = function(e12, t) {
  var n = t / 8 | 0;
  return (e12[n] | e12[n + 1] << 8 | e12[n + 2] << 16) >> (t & 7);
}, shft = function(e12) {
  return (e12 + 7) / 8 | 0;
}, slc = function(e12, t, n) {
  (t == null || t < 0) && (t = 0), (n == null || n > e12.length) && (n = e12.length);
  var r = new (e12.BYTES_PER_ELEMENT == 2 ? u16 : e12.BYTES_PER_ELEMENT == 4 ? u32 : u8)(n - t);
  return r.set(e12.subarray(t, n)), r;
}, ec = [
  "unexpected EOF",
  "invalid block type",
  "invalid length/literal",
  "invalid distance",
  "stream finished",
  "no stream handler",
  ,
  "no callback",
  "invalid UTF-8 data",
  "extra field too long",
  "date not in range 1980-2099",
  "filename too long",
  "stream finishing",
  "invalid zip data"
], err = function(e12, t, n) {
  var r = Error(t || ec[e12]);
  if (r.code = e12, Error.captureStackTrace && Error.captureStackTrace(r, err), !n)
    throw r;
  return r;
}, inflt = function(e12, t, n) {
  var r = e12.length;
  if (!r || n && n.f && !n.l)
    return t || new u8(0);
  var a = !t || n, o = !n || n.i;
  n ||= {}, t ||= new u8(r * 3);
  var s = function(e13) {
    var n2 = t.length;
    if (e13 > n2) {
      var r2 = new u8(Math.max(n2 * 2, e13));
      r2.set(t), t = r2;
    }
  }, c = n.f || 0, l = n.p || 0, u = n.b || 0, d = n.l, f = n.d, p = n.m, m = n.n, h = r * 8;
  do {
    if (!d) {
      c = bits(e12, l, 1);
      var g = bits(e12, l + 1, 3);
      if (l += 3, g)
        if (g == 1)
          d = flrm, f = fdrm, p = 9, m = 5;
        else if (g == 2) {
          var _ = bits(e12, l, 31) + 257, v = bits(e12, l + 10, 15) + 4, y = _ + bits(e12, l + 5, 31) + 1;
          l += 14;
          for (var b = new u8(y), S = new u8(19), C = 0; C < v; ++C)
            S[clim[C]] = bits(e12, l + C * 3, 7);
          l += v * 3;
          for (var w = max(S), T = (1 << w) - 1, E = hMap(S, w, 1), C = 0; C < y; ) {
            var D = E[bits(e12, l, T)];
            l += D & 15;
            var O = D >>> 4;
            if (O < 16)
              b[C++] = O;
            else {
              var k = 0, A = 0;
              for (O == 16 ? (A = 3 + bits(e12, l, 3), l += 2, k = b[C - 1]) : O == 17 ? (A = 3 + bits(e12, l, 7), l += 3) : O == 18 && (A = 11 + bits(e12, l, 127), l += 7); A--; )
                b[C++] = k;
            }
          }
          var j = b.subarray(0, _), M = b.subarray(_);
          p = max(j), m = max(M), d = hMap(j, p, 1), f = hMap(M, m, 1);
        } else
          err(1);
      else {
        var O = shft(l) + 4, N = e12[O - 4] | e12[O - 3] << 8, P = O + N;
        if (P > r) {
          o && err(0);
          break;
        }
        a && s(u + N), t.set(e12.subarray(O, P), u), n.b = u += N, n.p = l = P * 8, n.f = c;
        continue;
      }
      if (l > h) {
        o && err(0);
        break;
      }
    }
    a && s(u + 131072);
    for (var F = (1 << p) - 1, I = (1 << m) - 1, L = l; ; L = l) {
      var k = d[bits16(e12, l) & F], R = k >>> 4;
      if (l += k & 15, l > h) {
        o && err(0);
        break;
      }
      if (k || err(2), R < 256)
        t[u++] = R;
      else if (R == 256) {
        L = l, d = null;
        break;
      } else {
        var z = R - 254;
        if (R > 264) {
          var C = R - 257, B = fleb[C];
          z = bits(e12, l, (1 << B) - 1) + fl[C], l += B;
        }
        var V = f[bits16(e12, l) & I], H = V >>> 4;
        V || err(3), l += V & 15;
        var M = fd[H];
        if (H > 3) {
          var B = fdeb[H];
          M += bits16(e12, l) & (1 << B) - 1, l += B;
        }
        if (l > h) {
          o && err(0);
          break;
        }
        a && s(u + 131072);
        for (var U = u + z; u < U; u += 4)
          t[u] = t[u - M], t[u + 1] = t[u + 1 - M], t[u + 2] = t[u + 2 - M], t[u + 3] = t[u + 3 - M];
        u = U;
      }
    }
    n.l = d, n.p = L, n.b = u, n.f = c, d && (c = 1, n.m = p, n.d = f, n.n = m);
  } while (!c);
  return u == t.length ? t : slc(t, 0, u);
}, et = /* @__PURE__ */ new u8(0), gzs = function(e12) {
  (e12[0] != 31 || e12[1] != 139 || e12[2] != 8) && err(6, "invalid gzip data");
  var t = e12[3], n = 10;
  t & 4 && (n += e12[10] | (e12[11] << 8) + 2);
  for (var r = (t >> 3 & 1) + (t >> 4 & 1); r > 0; r -= !e12[n++])
    ;
  return n + (t & 2);
}, gzl = function(e12) {
  var t = e12.length;
  return (e12[t - 4] | e12[t - 3] << 8 | e12[t - 2] << 16 | e12[t - 1] << 24) >>> 0;
}, zlv = function(e12) {
  ((e12[0] & 15) != 8 || e12[0] >>> 4 > 7 || (e12[0] << 8 | e12[1]) % 31) && err(6, "invalid zlib data"), e12[1] & 32 && err(6, "invalid zlib data: preset dictionaries not supported");
};
function inflateSync(e12, t) {
  return inflt(e12, t);
}
function gunzipSync(e12, t) {
  return inflt(e12.subarray(gzs(e12), -8), t || new u8(gzl(e12)));
}
function unzlibSync(e12, t) {
  return inflt((zlv(e12), e12.subarray(2, -4)), t);
}
function decompressSync(e12, t) {
  return e12[0] == 31 && e12[1] == 139 && e12[2] == 8 ? gunzipSync(e12, t) : (e12[0] & 15) != 8 || e12[0] >> 4 > 7 || (e12[0] << 8 | e12[1]) % 31 ? inflateSync(e12, t) : unzlibSync(e12, t);
}
var td = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder();
try {
  td.decode(et, { stream: true });
} catch {
}
var REVERSE_LOOKUP = [];
REVERSE_LOOKUP[45] = 62, REVERSE_LOOKUP[95] = 63;
var BASE64_CODE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (let e12 = 0; e12 < 64; e12++)
  REVERSE_LOOKUP[BASE64_CODE.charCodeAt(e12)] = e12;
function isValidChar(e12) {
  return REVERSE_LOOKUP[e12.charCodeAt(0)] !== void 0;
}
function extractChunks(e12) {
  let t = e12.length, n = [], r = null;
  for (let a = 0; a < t; a++)
    isValidChar(e12[a]) ? (r ||= {
      start: a,
      count: 0
    }, r.count++, r.end = a) : e12[a] === "=" && r && (n.push(r), r = null);
  return r && n.push(r), n;
}
function writeChunk(e12, t, n, r) {
  let { start: a, count: o } = t, s = o % 4, c = Math.floor(o / 4), l = a, u = null, d = n;
  for (let t2 = 0; t2 < c; t2++) {
    for (; !isValidChar(e12[l]); )
      l++;
    for (u = REVERSE_LOOKUP[e12.charCodeAt(l++)] << 18; !isValidChar(e12[l]); )
      l++;
    for (u |= REVERSE_LOOKUP[e12.charCodeAt(l++)] << 12; !isValidChar(e12[l]); )
      l++;
    for (u |= REVERSE_LOOKUP[e12.charCodeAt(l++)] << 6; !isValidChar(e12[l]); )
      l++;
    u |= REVERSE_LOOKUP[e12.charCodeAt(l++)], r[d++] = u >> 16 & 255, r[d++] = u >> 8 & 255, r[d++] = u & 255;
  }
  switch (s) {
    case 3:
      for (; !isValidChar(e12[l]); )
        l++;
      for (u = REVERSE_LOOKUP[e12.charCodeAt(l++)] << 10; !isValidChar(e12[l]); )
        l++;
      for (u |= REVERSE_LOOKUP[e12.charCodeAt(l++)] << 4; !isValidChar(e12[l]); )
        l++;
      u |= REVERSE_LOOKUP[e12.charCodeAt(l++)] >> 2, r[d++] = u >> 8 & 255, r[d++] = u & 255;
      break;
    case 2:
      for (; !isValidChar(e12[l]); )
        l++;
      for (u = REVERSE_LOOKUP[e12.charCodeAt(l++)] << 2; !isValidChar(e12[l]); )
        l++;
      u |= REVERSE_LOOKUP[e12.charCodeAt(l++)] >> 4, r[d++] = u & 255;
      break;
    case 1:
      throw Error("BASE64: remain 1 should not happen");
  }
  return d;
}
function toArrayBuffer(e12) {
  let t = extractChunks(e12), n = t[t.length - 1].end + 1, r = (4 - n % 4) % 4, a = (n + r) * 3 / 4 - r, o = new ArrayBuffer(a), s = new Uint8Array(o), c = 0;
  for (let n2 = 0; n2 < t.length; n2++)
    c += writeChunk(e12, t[n2], c, s), c += (4 - t[n2].count % 4) % 4;
  return o;
}
function encodeTriplet(e12, t, n) {
  let r = (e12 << 16) + (t << 8) + n;
  return BASE64_CODE[r >> 18] + BASE64_CODE[r >> 12 & 63] + BASE64_CODE[r >> 6 & 63] + BASE64_CODE[r & 63];
}
function fromArrayBuffer(e12) {
  let t = new Uint8Array(e12), n = e12.byteLength % 3, r = e12.byteLength - n, a = Array(r / 3);
  for (let e13 = 0; e13 < a.length; e13++) {
    let n2 = e13 * 3;
    a[e13] = encodeTriplet(t[n2], t[n2 + 1], t[n2 + 2]);
  }
  if (n > 0) {
    let e13 = encodeTriplet(t[r], t[r + 1] || 0, t[r + 2] || 0);
    n === 1 ? a.push(`${e13.substr(0, 2)}==`) : n === 2 && a.push(`${e13.substr(0, 3)}=`);
  }
  return a.join("");
}
var Base64 = {
  toArrayBuffer,
  fromArrayBuffer
};
function vtkStringArray(e12, t) {
  t.classHierarchy.push("vtkStringArray"), e12.getComponent = function(e13) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return t.values[e13 * t.numberOfComponents + n];
  }, e12.setComponent = (n, r, a) => {
    a !== t.values[n * t.numberOfComponents + r] && (t.values[n * t.numberOfComponents + r] = a, e12.modified());
  }, e12.getData = () => t.values, e12.getTuple = function(e13) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = t.numberOfComponents || 1;
    n.length &&= r;
    let a = e13 * r;
    for (let e14 = 0; e14 < r; e14++)
      n[e14] = t.values[a + e14];
    return n;
  }, e12.getTupleLocation = function() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1) * t.numberOfComponents;
  }, e12.getNumberOfComponents = () => t.numberOfComponents, e12.getNumberOfValues = () => t.values.length, e12.getNumberOfTuples = () => t.values.length / t.numberOfComponents, e12.getDataType = () => t.dataType, e12.newClone = () => newInstance$21({
    name: t.name,
    numberOfComponents: t.numberOfComponents,
    empty: true
  }), e12.getName = () => (t.name || e12.setName(`vtkStringArray${e12.getMTime()}`), t.name), e12.setData = (n, r) => {
    t.values = n, t.size = n.length, r && (t.numberOfComponents = r), t.size % t.numberOfComponents !== 0 && (t.numberOfComponents = 1), e12.modified();
  };
}
var DEFAULT_VALUES$17 = {
  name: "",
  numberOfComponents: 1,
  size: 0,
  dataType: "string"
};
function extend$22(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (Object.assign(t, DEFAULT_VALUES$17, n), !t.empty && !t.values && !t.size)
    throw TypeError("Cannot create vtkStringArray object without: size > 0, values");
  t.values ? Array.isArray(t.values) && (t.values = [...t.values]) : t.values = [], t.values && (t.size = t.values.length), macro.obj(e12, t), macro.set(e12, t, ["name"]), vtkStringArray(e12, t);
}
var newInstance$21 = macro.newInstance(extend$22, "vtkStringArray"), vtkStringArray$1 = {
  newInstance: newInstance$21,
  extend: extend$22
}, import_xmlbuilder2_min = require_xmlbuilder2_min();
function findAllTags(e12, t) {
  return [...e12.getElementsByTagName(t)];
}
function findFirstTag(e12, t) {
  return findAllTags(e12, t)[0];
}
function parseXML(e12) {
  return (0, import_xmlbuilder2_min.create)(e12);
}
function extractAppendedData(e12) {
  return BinaryHelper.extractBinary(e12, /^\s*<AppendedData\s+encoding="raw">\s*_/m, /\n\s*<\/AppendedData>/m);
}
var TYPED_ARRAY = {
  Int8: Int8Array,
  UInt8: Uint8Array,
  Int16: Int16Array,
  UInt16: Uint16Array,
  Int32: Int32Array,
  UInt32: Uint32Array,
  Int64: Int32Array,
  UInt64: Uint32Array,
  Float32: Float32Array,
  Float64: Float64Array
}, TYPED_ARRAY_BYTES = {
  Int8: 1,
  UInt8: 1,
  Int16: 2,
  UInt16: 2,
  Int32: 4,
  UInt32: 4,
  Int64: 8,
  UInt64: 8,
  Float32: 4,
  Float64: 8
};
function integer64to32(e12) {
  let t = e12.length - 1;
  return e12.filter((e13, n) => n < t && n % 2 == 0);
}
function readLengthPrefixedData(e12, t, n) {
  if (!["UInt64", "UInt32"].includes(n))
    throw Error(`Cannot handle a header type of ${n}`);
  let r = TYPED_ARRAY[n], a = TYPED_ARRAY[t], o = false;
  n === "UInt64" && (r = TYPED_ARRAY.UInt32), /^U?Int64$/.test(t) && (o = true, a = TYPED_ARRAY[t.replace("64", "32")]);
  let { byteOffset: s } = e12, c = TYPED_ARRAY_BYTES[t], l = TYPED_ARRAY_BYTES[n], u;
  u = s % l === 0 ? new r(e12.buffer, s, 1) : new r(e12.buffer.slice(s, s + l));
  let d = Number(u[0]), f, p = d / c;
  o && (p *= 2);
  let m = s + l;
  return f = m % c === 0 ? new a(e12.buffer, m, p) : new a(e12.buffer.slice(m, m + d)), o && (f = integer64to32(f)), f;
}
function readerHeader(e12, t) {
  if (t === "UInt64") {
    let t2 = new Uint32Array(e12.buffer, 0, 6), n2 = t2[0], r2 = [
      8,
      n2,
      t2[2],
      t2[4]
    ];
    t2 = new Uint32Array(e12.buffer, 24, n2 * 2);
    for (let e13 = 0; e13 < n2; e13++)
      r2.push(t2[e13 * 2]);
    return r2;
  }
  let n = new Uint32Array(e12.buffer, 0, 3), r = n[0], a = [
    4,
    r,
    n[1],
    n[2]
  ];
  n = new Uint32Array(e12.buffer, 12, r);
  for (let e13 = 0; e13 < r; e13++)
    a.push(n[e13]);
  return a;
}
function getHeaderByteLength(e12, t) {
  let [n] = e12;
  return (e12.length - 1) * n;
}
function uncompressBlock(e12, t) {
  let n = decompressSync(e12);
  t.uint8.set(n, t.offset), t.offset += n.length;
}
function decompressZLib(e12, t) {
  let n = readerHeader(e12, t), r = n[1], a = n[2], o = n[3], s = 0;
  r > 0 && (s = o === 0 ? r * a : (r - 1) * a + o);
  let c = new ArrayBuffer(s), l = {
    offset: 0,
    uint8: new Uint8Array(c)
  }, u = getHeaderByteLength(n);
  for (; u < e12.length && e12[u] !== 120; )
    u++;
  for (let t2 = 0; t2 < r; t2++) {
    let r2 = n[4 + t2];
    uncompressBlock(new Uint8Array(e12.buffer, u, r2), l), u += r2;
  }
  return l.uint8;
}
function processDataArray(e12, t, n, r, a, o) {
  let s = t.getAttribute("type"), c = t.getAttribute("Name"), l = t.getAttribute("format"), u = Number(t.getAttribute("NumberOfComponents") || "1"), d = null;
  if (l === "ascii") {
    d = new TYPED_ARRAY[s](e12 * u);
    let n2 = 0;
    t.firstChild.nodeValue.split(/[\\t \\n]+/).forEach((e13) => {
      e13.trim().length && (d[n2++] = Number(e13));
    });
  } else if (l === "binary") {
    let e13 = new Uint8Array(Base64.toArrayBuffer(t.firstChild.nodeValue.trim()));
    if (n === "vtkZLibDataCompressor") {
      let t2 = decompressZLib(e13, a);
      d = new TYPED_ARRAY[s](t2.buffer), /^U?Int64$/.test(s) && (d = integer64to32(d));
    } else
      d = new TYPED_ARRAY[s](e13.buffer, TYPED_ARRAY_BYTES[a]), s.indexOf("Int64") !== -1 && (d = integer64to32(d));
  } else if (l === "appended") {
    let e13 = Number(t.getAttribute("offset"));
    d = readLengthPrefixedData(new Uint8Array(o, e13), s, a);
  } else
    console.error("Format not supported", l);
  return {
    name: c,
    values: d,
    numberOfComponents: u
  };
}
function decodeStringArrayFromBytes(e12) {
  return new TextDecoder().decode(e12).split("\0").slice(0, -1);
}
function processStringArray(e12, t, n, r, a) {
  let o = e12.getAttribute("Name"), s = e12.getAttribute("format"), c = Number(e12.getAttribute("NumberOfComponents") || "1"), l = Number(e12.getAttribute("NumberOfTuples") || "1") * c, u = [];
  if (s === "ascii") {
    let t2 = e12.firstChild.nodeValue.trim().split(/\s+/), n2 = 0, r2 = [];
    for (; u.length < l; ) {
      let e13 = Number(t2[n2++]);
      e13 === 0 ? (u.push(r2.join("")), r2.length = 0) : r2.push(String.fromCharCode(e13));
    }
  } else if (s === "binary") {
    let n2 = new Uint8Array(Base64.toArrayBuffer(e12.firstChild.nodeValue.trim()));
    if (t === "vtkZLibDataCompressor") {
      let e13 = decompressZLib(n2, r);
      u.push(...decodeStringArrayFromBytes(e13));
    } else {
      let e13 = readLengthPrefixedData(n2, "UInt8", r);
      u.push(...decodeStringArrayFromBytes(e13));
    }
  } else if (s === "appended") {
    let t2 = Number(e12.getAttribute("offset")), n2 = readLengthPrefixedData(new Uint8Array(a, t2), "UInt8", r);
    u.push(...decodeStringArrayFromBytes(n2));
  } else
    macro.vtkErrorMacro(`Format not supported: ${s}`);
  return {
    name: o,
    values: u,
    numberOfComponents: c
  };
}
function processCells(e12, t, n, r, a, o) {
  let s = {}, c = t.getElementsByTagName("DataArray");
  for (let e13 = 0; e13 < c.length; e13++) {
    let t2 = c[e13];
    s[t2.getAttribute("Name")] = t2;
  }
  let l = processDataArray(e12, s.offsets, n, r, a, o).values, u = l[l.length - 1], d = processDataArray(u, s.connectivity, n, r, a, o).values, f = new Uint32Array(e12 + u), p = 0, m = 0;
  return l.forEach((e13) => {
    let t2 = e13 - m;
    f[p++] = t2;
    for (let e14 = 0; e14 < t2; e14++)
      f[p++] = d[m + e14];
    m = e13;
  }), f;
}
function processFieldData(e12, t, n, r, a, o, s) {
  if (t) {
    let c = [
      "Scalars",
      "Vectors",
      "Normals",
      "Tensors",
      "TCoords"
    ], l = {};
    c.forEach((e13) => {
      let r2 = t.getAttribute(e13);
      r2 && (l[r2] = n[`set${e13}`]);
    });
    let u = t.getElementsByTagName("DataArray"), d = u.length;
    for (let t2 = 0; t2 < d; t2++) {
      let c2 = u[t2], d2 = vtkDataArray$1.newInstance(processDataArray(e12, c2, r, a, o, s));
      (l[d2.getName()] || n.addArray)(d2);
    }
  }
}
function handleFieldDataArrays(e12, t, n, r, a) {
  let o = [...e12.getElementsByTagName("DataArray")].map((e13) => vtkDataArray$1.newInstance(processDataArray(Number(e13.getAttribute("NumberOfTuples")), e13, t, n, r, a))), s = [...e12.getElementsByTagName("Array")].filter((e13) => e13.getAttribute("type") === "String").map((e13) => vtkStringArray$1.newInstance(processStringArray(e13, t, n, r, a)));
  return [...o, ...s];
}
function vtkXMLReader(e12, t) {
  t.classHierarchy.push("vtkXMLReader"), t.dataAccessHelper ||= DataAccessHelper.get("http");
  function n(e13) {
    let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return t.dataAccessHelper.fetchBinary(e13, n2);
  }
  e12.setUrl = function(n2) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    t.url = n2;
    let a = n2.split("/");
    return a.pop(), t.baseURL = a.join("/"), e12.loadData(r);
  }, e12.loadData = function() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return n(t.url, r).then(e12.parseAsArrayBuffer);
  }, e12.parseAsArrayBuffer = (n2) => {
    if (!n2)
      return false;
    if (n2 !== t.rawDataBuffer)
      e12.modified();
    else
      return true;
    let { text: r, binaryBuffer: a } = extractAppendedData(n2);
    t.rawDataBuffer = n2, t.binaryBuffer = a;
    let o = parseXML(r).root(), s = o.node, c = s.getAttribute("type"), l = s.getAttribute("compressor"), u = s.getAttribute("byte_order"), d = s.getAttribute("header_type") || "UInt32";
    if (l && l !== "vtkZLibDataCompressor")
      return console.error("Invalid compressor", l), false;
    if (u && u !== "LittleEndian")
      return console.error("Only LittleEndian encoding is supported"), false;
    if (c !== t.dataType)
      return console.error("Invalid data type", c, "expecting", t.dataType), false;
    if (findFirstTag(s, "AppendedData")) {
      let e13 = findFirstTag(s, "AppendedData"), n3 = e13.getAttribute("encoding"), r2 = o.filter((e14) => {
        let { node: t2 } = e14;
        return t2.nodeType === Node.ELEMENT_NODE && t2.getAttribute("format") === "appended" && t2.hasAttribute("offset");
      }, false, true).map((e14) => ({
        node: e14.node,
        offset: Number(e14.node.getAttribute("offset"))
      }));
      r2.sort((e14, t2) => e14.offset - t2.offset);
      let a2 = t.binaryBuffer;
      n3 === "base64" && (a2 = e13.textContent.trim().substr(1));
      let c2 = [];
      for (let e14 = 0; e14 < r2.length; ++e14) {
        let t2 = r2[e14].offset, o2 = 0;
        o2 = e14 === r2.length - 1 ? a2.length || a2.byteLength : r2[e14 + 1].offset, n3 === "base64" ? c2.push(new Uint8Array(Base64.toArrayBuffer(a2.substring(t2, o2)))) : c2.push(new Uint8Array(a2.slice(t2, o2)));
      }
      if (l === "vtkZLibDataCompressor")
        for (let e14 = 0; e14 < c2.length; ++e14) {
          let t2 = c2[e14], n4 = decompressZLib(t2, d), r3 = new Uint8Array(n4.length + TYPED_ARRAY_BYTES[d]);
          new TYPED_ARRAY[d](r3.buffer, 0, 1)[0] = n4.length, r3.set(n4, TYPED_ARRAY_BYTES[d]), c2[e14] = r3;
        }
      let u2 = c2.reduce((e14, t2) => e14 + t2.length, 0), f2 = new ArrayBuffer(u2), p = new Uint8Array(f2);
      for (let e14 = 0, t2 = 0; e14 < c2.length; ++e14)
        r2[e14].node.setAttribute("offset", t2), p.set(c2[e14], t2), t2 += c2[e14].length;
      if (t.binaryBuffer = f2, !t.binaryBuffer)
        return console.error("Processing appended data format: requires binaryBuffer to parse"), false;
    }
    e12.parseXML(s, c, l, u, d);
    let f = s.getElementsByTagName(c)[0].getElementsByTagName("FieldData")[0];
    if (f) {
      let e13 = handleFieldDataArrays(f, l, u, d, t.binaryBuffer);
      for (let n3 = 0; n3 < t.output.length; n3++) {
        let r2 = t.output[n3].getFieldData();
        for (let t2 = 0; t2 < e13.length; t2++)
          r2.addArray(e13[t2]);
      }
    }
    return true;
  }, e12.requestData = (n2, r) => {
    e12.parseAsArrayBuffer(t.rawDataBuffer);
  };
}
var DEFAULT_VALUES$16 = {};
function extend$21(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$16, n), macro.obj(e12, t), macro.get(e12, t, ["url", "baseURL"]), macro.setGet(e12, t, ["dataAccessHelper"]), macro.algo(e12, t, 0, 1), vtkXMLReader(e12, t);
}
var vtkXMLReader$1 = {
  extend: extend$21,
  processDataArray,
  processFieldData,
  processCells
};
function handleArray(e12, t, n, r, a, o, s) {
  let c = Number(n.getAttribute(`NumberOf${t}`));
  if (c > 0) {
    let l = n.getElementsByTagName(t)[0].getElementsByTagName("DataArray")[0], { values: u, numberOfComponents: d } = vtkXMLReader$1.processDataArray(c, l, r, a, o, s);
    e12[`get${t}`]().setData(u, d);
  }
  return c;
}
function handleCells(e12, t, n, r, a, o, s) {
  let c = Number(n.getAttribute(`NumberOf${t}`));
  if (c > 0) {
    let l = vtkXMLReader$1.processCells(c, n.getElementsByTagName(t)[0], r, a, o, s);
    e12[`get${t}`]().setData(l);
  }
  return c;
}
function vtkXMLPolyDataReader(e12, t) {
  t.classHierarchy.push("vtkXMLPolyDataReader"), e12.parseXML = (e13, n, r, a, o) => {
    let s = e13.getElementsByTagName(t.dataType)[0].getElementsByTagName("Piece"), c = s.length;
    for (let e14 = 0; e14 < c; e14++) {
      let n2 = vtkPolyData$1.newInstance(), c2 = s[e14], l = handleArray(n2, "Points", c2, r, a, o, t.binaryBuffer), u = 0;
      [
        "Verts",
        "Lines",
        "Strips",
        "Polys"
      ].forEach((e15) => {
        u += handleCells(n2, e15, c2, r, a, o, t.binaryBuffer);
      }), vtkXMLReader$1.processFieldData(l, c2.getElementsByTagName("PointData")[0], n2.getPointData(), r, a, o, t.binaryBuffer), vtkXMLReader$1.processFieldData(u, c2.getElementsByTagName("CellData")[0], n2.getCellData(), r, a, o, t.binaryBuffer), t.output[e14] = n2;
    }
  };
}
var DEFAULT_VALUES$15 = { dataType: "PolyData" };
function extend$20(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$15, n), vtkXMLReader$1.extend(e12, t, n), vtkXMLPolyDataReader(e12, t);
}
var vtkXMLPolyDataReader$1 = {
  newInstance: macro.newInstance(extend$20, "vtkXMLPolyDataReader"),
  extend: extend$20
}, data = {};
function copyVector(e12, t, n, r, a) {
  for (let o = 0; o < a; o++)
    n[r + o] = e12[t + o];
}
function begin(e12) {
  data.splitOn = e12, data.pieces = [], data.v = [], data.vt = [], data.vn = [], data.f = [[]], data.size = 0;
}
function faceMap(e12) {
  let t = e12.split("/").map((e13) => Number(e13)), n = t[0] - 1;
  n = n < 0 ? n + 1 + data.v.length / 3 : n;
  let r = t[1] ? t[1] - 1 : n;
  r = r < 0 ? r + 1 + data.vt.length / 2 : r;
  let a = t[2] ? t[2] - 1 : n;
  return a = a < 0 ? a + 1 + data.vn.length / 3 : a, [
    n,
    r,
    a
  ];
}
function parseLine(e12) {
  if (e12[0] === "#")
    return;
  let t = e12.split(/[ \t]+/);
  if (t[0] === data.splitOn)
    t.shift(), data.pieces.push(t.join(" ").trim()), data.f.push([]), data.size++;
  else if (t[0] === "v")
    data.v.push(Number(t[1])), data.v.push(Number(t[2])), data.v.push(Number(t[3]));
  else if (t[0] === "vt")
    data.vt.push(Number(t[1])), data.vt.push(Number(t[2]));
  else if (t[0] === "vn")
    data.vn.push(Number(t[1])), data.vn.push(Number(t[2])), data.vn.push(Number(t[3]));
  else if (t[0] === "f") {
    data.size === 0 && data.size++;
    let e13 = data.f[data.size - 1];
    t.shift();
    let n = t.filter((e14) => e14.length > 0 && e14 !== "\r"), r = n.length;
    e13.push(r);
    for (let t2 = 0; t2 < r; t2++)
      e13.push(faceMap(n[t2]));
  }
}
function end(e12) {
  let t = !!data.vt.length, n = !!data.vn.length;
  if (e12.splitMode) {
    e12.numberOfOutputs = data.size;
    for (let r = 0; r < data.size; r++) {
      let a = data.f[r], o = a.length, s = data.v.length / 3, c = {}, l;
      if (e12.trackDuplicates) {
        let e13 = [], t2 = 0;
        for (let n3 = 0; n3 < o; ) {
          let r2 = a[n3++];
          for (let o2 = 0; o2 < r2; o2++) {
            let [r3, o3, s2] = a[n3++], l2 = `${r3}/${o3}/${s2}`;
            c[l2] === void 0 && (e13[r3] === void 0 ? e13[r3] = [l2] : (e13[r3].push(l2), ++t2), c[l2] = r3);
          }
        }
        l = new Uint16Array(s + t2);
        let n2 = 0;
        for (let t3 = 0; t3 < e13.length; ++t3) {
          let r2 = e13[t3] ? e13[t3].length : 0;
          l[t3] = r2 > 1 ? s + n2 : t3;
          for (let a2 = 1; a2 < r2; ++a2) {
            let r3 = s + n2++;
            l[r3] = t3, c[e13[t3][a2]] = r3;
          }
        }
      }
      let u = {}, d = vtkPolyData$1.newInstance({ name: data.pieces[r] }), f = [], p = [], m = [], h = [], g = 0;
      for (; g < o; ) {
        let r2 = a[g];
        h.push(r2);
        for (let o2 = 0; o2 < r2; o2++) {
          let [r3, s2, l2] = a[g + o2 + 1], d2 = `${r3}/${s2}/${l2}`;
          if (u[d2] === void 0) {
            let a2 = e12.trackDuplicates ? c[d2] : f.length / 3;
            u[d2] = a2, copyVector(data.v, r3 * 3, f, a2 * 3, 3), t && copyVector(data.vt, s2 * 2, p, a2 * 2, 2), n && copyVector(data.vn, l2 * 3, m, a2 * 3, 3);
          }
          h.push(u[d2]);
        }
        g += r2 + 1;
      }
      if (d.getPoints().setData(Float32Array.from(f), 3), e12.trackDuplicates) {
        let e13 = vtkDataArray$1.newInstance({
          name: "Duplicates",
          values: l
        });
        d.getPointData().addArray(e13);
      }
      if (d.getPolys().setData(Uint32Array.from(h)), t) {
        let e13 = vtkDataArray$1.newInstance({
          numberOfComponents: 2,
          values: Float32Array.from(p),
          name: "TextureCoordinates"
        });
        d.getPointData().setTCoords(e13);
      }
      if (n) {
        let e13 = vtkDataArray$1.newInstance({
          numberOfComponents: 3,
          values: Float32Array.from(m),
          name: "Normals"
        });
        d.getPointData().setNormals(e13);
      }
      e12.output[r] = d;
    }
  } else {
    e12.numberOfOutputs = 1;
    let r = vtkPolyData$1.newInstance();
    if (r.getPoints().setData(Float32Array.from(data.v), 3), t && data.v.length / 3 == data.vt.length / 2) {
      let e13 = vtkDataArray$1.newInstance({
        numberOfComponents: 2,
        values: Float32Array.from(data.vt),
        name: "TextureCoordinates"
      });
      r.getPointData().setTCoords(e13);
    }
    if (n && data.v.length === data.vn.length) {
      let e13 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        values: Float32Array.from(data.vn),
        name: "Normals"
      });
      r.getPointData().setNormals(e13);
    }
    let a = [], o = data.f[0], s = o.length, c = 0;
    for (; c < s; ) {
      let e13 = o[c];
      a.push(e13);
      for (let t2 = 0; t2 < e13; t2++) {
        let [e14] = o[c + t2 + 1];
        a.push(e14);
      }
      c += e13 + 1;
    }
    r.getPolys().setData(Uint32Array.from(a)), e12.output[0] = r;
  }
}
function getPointDuplicateIds(e12, t) {
  let n = [], r = e12.getPointData().getArrayByName("Duplicates");
  if (r == null)
    return n;
  let a = r.getData(), o = Math.min(t, a[t]);
  n.push(o);
  let s = a[o];
  if (s !== o)
    for (; s < a.length && a[s] === o; )
      n.push(s++);
  return n;
}
var STATIC$1 = { getPointDuplicateIds };
function vtkOBJReader(e12, t) {
  t.classHierarchy.push("vtkOBJReader"), t.dataAccessHelper ||= DataAccessHelper.get("http");
  function n(n2) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return t.dataAccessHelper.fetchText(e12, n2, r);
  }
  e12.setUrl = function(n2) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (n2.indexOf(".obj") === -1 && !r.fullpath)
      t.baseURL = n2, t.url = `${n2}/index.obj`;
    else {
      t.url = n2;
      let e13 = n2.split("/");
      e13.pop(), t.baseURL = e13.join("/");
    }
    return e12.loadData(r);
  }, e12.loadData = function() {
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return n(t.url, r).then((t2) => e12.isDeleted() ? false : e12.parseAsText(t2));
  }, e12.parseAsText = (n2) => n2 ? (n2 !== t.parseData && e12.modified(), t.parseData = n2, t.numberOfOutputs = 0, begin(t.splitMode), n2.split("\n").forEach(parseLine), end(t), true) : true, e12.requestData = (n2, r) => {
    e12.parseAsText(t.parseData);
  }, e12.isBusy = () => !!t.requestCount, e12.getNumberOfOutputPorts = () => t.numberOfOutputs;
}
var DEFAULT_VALUES$14 = {
  numberOfOutputs: 1,
  requestCount: 0,
  splitMode: null,
  trackDuplicates: false
};
function extend$19(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$14, n), macro.obj(e12, t), macro.get(e12, t, ["url", "baseURL"]), macro.setGet(e12, t, [
    "dataAccessHelper",
    "splitMode",
    "trackDuplicates"
  ]), macro.algo(e12, t, 0, 1), macro.event(e12, t, "busy"), vtkOBJReader(e12, t);
}
var vtkOBJReader$1 = {
  newInstance: macro.newInstance(extend$19, "vtkOBJReader"),
  extend: extend$19,
  ...STATIC$1
};
function vtkPolyDataNormals(e12, t) {
  t.classHierarchy.push("vtkPolyDataNormals"), e12.vtkPolyDataNormalsExecute = (e13, n, r) => {
    if (!r)
      return null;
    let a = new Float32Array(r.length), o = new Float32Array(3 * e13), s = 0, c = 0, l = n.length, u = [
      0,
      0,
      0
    ], d = [
      0,
      0,
      0
    ];
    for (let e14 = 0; e14 < l; e14 += c + 1)
      if (c = n[e14], !(c < 3)) {
        for (let t2 = 1; t2 <= 3; ++t2)
          u[t2 - 1] = 3 * n[e14 + t2];
        if (vtkTriangle$1.computeNormal(r.slice(u[0], u[0] + 3), r.slice(u[1], u[1] + 3), r.slice(u[2], u[2] + 3), d), o[s++] = d[0], o[s++] = d[1], o[s++] = d[2], t.computePointNormals)
          for (let t2 = 1; t2 <= c; ++t2) {
            let r2 = 3 * n[e14 + t2];
            a[r2] += d[0], a[++r2] += d[1], a[++r2] += d[2];
          }
      }
    if (t.computePointNormals) {
      let e14 = [
        0,
        0,
        0
      ];
      for (let t2 = 0; t2 < r.length; )
        e14[0] = a[t2], e14[1] = a[t2 + 1], e14[2] = a[t2 + 2], vtkMath.normalize(e14), a[t2++] = e14[0], a[t2++] = e14[1], a[t2++] = e14[2];
    }
    return [o, a];
  }, e12.requestData = (n, r) => {
    if (!e12.getNumberOfInputPorts())
      return;
    let a = n[0];
    if (!a)
      return;
    let o = r[0]?.initialize() || vtkPolyData$1.newInstance();
    o.setPoints(a.getPoints()), o.setVerts(a.getVerts()), o.setLines(a.getLines()), o.setPolys(a.getPolys()), o.setStrips(a.getStrips()), o.getPointData().passData(a.getPointData()), o.getCellData().passData(a.getCellData()), o.getFieldData().passData(a.getFieldData());
    let [s, c] = e12.vtkPolyDataNormalsExecute(a.getNumberOfPolys(), a.getPolys().getData(), a.getPoints().getData());
    if (t.computePointNormals) {
      let e13 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        name: "Normals",
        values: c
      });
      o.getPointData().setNormals(e13);
    }
    if (t.computeCellNormals) {
      let e13 = vtkDataArray$1.newInstance({
        numberOfComponents: 3,
        name: "Normals",
        values: s
      });
      o.getCellData().setNormals(e13);
    }
    r[0] = o;
  };
}
function defaultValues$3(e12) {
  return {
    computeCellNormals: false,
    computePointNormals: true,
    ...e12
  };
}
function extend$18(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, defaultValues$3(n)), macro.obj(e12, t), macro.algo(e12, t, 1, 1), macro.setGet(e12, t, ["computeCellNormals", "computePointNormals"]), vtkPolyDataNormals(e12, t);
}
var vtkPolyDataNormals$1 = {
  newInstance: macro.newInstance(extend$18, "vtkPolyDataNormals"),
  extend: extend$18
}, Mesh = class {
  constructor(e12) {
    this._color = [
      255,
      255,
      255
    ], this._actors = [], this.id = e12.id, this._color = e12.color ?? this._color, this._format = e12.format;
    let t = new TextDecoder(), n = vtkPolyDataNormals$1.newInstance(), r = (e13) => {
      let t2 = vtkActor$1.newInstance();
      t2.setMapper(e13);
      let n2 = vtkProperty$1.newInstance();
      return n2.setColor(this._color[0] / 255, this._color[1] / 255, this._color[2] / 255), t2.setProperty(n2), t2;
    };
    if (this._format === MeshType_default.PLY) {
      let t2 = vtkMapper$1.newInstance(), n2 = vtkPLYReader$1.newInstance();
      n2.parseAsArrayBuffer(e12.arrayBuffer), t2.setInputConnection(n2.getOutputPort()), this._actors.push(r(t2));
    } else if (this._format === MeshType_default.STL) {
      let t2 = vtkMapper$1.newInstance(), a = vtkSTLReader$1.newInstance();
      a.parseAsArrayBuffer(e12.arrayBuffer), n.setInputConnection(a.getOutputPort()), t2.setInputConnection(n.getOutputPort()), this._actors.push(r(t2));
    } else if (this._format === MeshType_default.OBJ) {
      let n2 = vtkOBJReader$1.newInstance({ splitMode: e12.materialUrl ? "usemtl" : null });
      n2.parseAsText(t.decode(e12.arrayBuffer));
      let a = n2.getNumberOfOutputPorts();
      for (let e13 = 0; e13 < a; e13++) {
        let t2 = n2.getOutputData(e13), a2 = vtkMapper$1.newInstance();
        a2.setInputData(t2), this._actors.push(r(a2));
      }
    } else if (this._format === MeshType_default.VTP) {
      let t2 = vtkMapper$1.newInstance(), n2 = vtkXMLPolyDataReader$1.newInstance();
      n2.parseAsArrayBuffer(e12.arrayBuffer), t2.setInputConnection(n2.getOutputPort()), this._actors.push(r(t2));
    }
    this.sizeInBytes = this._getSizeInBytes();
  }
  _getSizeInBytes() {
    let e12 = 0;
    for (let t = 0; t < this._actors.length; t++) {
      let n = this._actors[t].getMapper().getInputData(), r = n.getPoints(), a = n.getPolys(), o = r.getData().length, s = a.getData().length;
      e12 += o * 4 + s * 4;
    }
    return e12;
  }
  get defaultActor() {
    return this._actors[0];
  }
  get actors() {
    return this._actors;
  }
  get color() {
    return this._color;
  }
  get format() {
    return this._format;
  }
}, EventListenerPhases;
(function(e12) {
  e12[e12.None = 0] = "None", e12[e12.Capture = 1] = "Capture", e12[e12.Bubble = 2] = "Bubble";
})(EventListenerPhases ||= {});
var TargetEventListeners = class e9 {
  constructor(e12) {
    this._eventListeners = /* @__PURE__ */ new Map(), this._children = /* @__PURE__ */ new Map(), this._target = e12;
  }
  get isEmpty() {
    return this._eventListeners.size === 0 && this._children.size === 0;
  }
  addEventListener(t, n, r) {
    let a = t.indexOf(".");
    if (a !== -1) {
      let o = t.substring(0, a), s = this._children.get(o);
      s || (s = new e9(this._target), this._children.set(o, s)), t = t.substring(a + 1), s.addEventListener(t, n, r);
    } else
      this._addEventListener(t, n, r);
  }
  removeEventListener(e12, t, n) {
    let r = e12.indexOf(".");
    if (r !== -1) {
      let a = e12.substring(0, r), o = this._children.get(a);
      if (!o)
        return;
      e12 = e12.substring(r + 1), o.removeEventListener(e12, t, n), o.isEmpty && this._children.delete(a);
    } else
      this._removeEventListener(e12, t, n);
  }
  reset() {
    Array.from(this._children.entries()).forEach(([e12, t]) => {
      if (t.reset(), t.isEmpty)
        this._children.delete(e12);
      else
        throw Error("Child is not empty and cannot be removed");
    }), this._unregisterAllEvents();
  }
  _addEventListener(e12, t, n) {
    let r = this._eventListeners.get(e12);
    r || (r = /* @__PURE__ */ new Map(), this._eventListeners.set(e12, r));
    let a = n?.capture ?? false ? EventListenerPhases.Capture : EventListenerPhases.Bubble, o = r.get(t) ?? EventListenerPhases.None;
    if (o & a) {
      console.warn("A listener is already registered for this phase");
      return;
    }
    r.set(t, o | a), this._target.addEventListener(e12, t, n);
  }
  _removeEventListener(e12, t, n) {
    let r = n?.capture ?? false ? EventListenerPhases.Capture : EventListenerPhases.Bubble, a = this._eventListeners.get(e12);
    a && ((t ? [t] : Array.from(a.keys())).forEach((t2) => {
      let o = a.get(t2) ?? EventListenerPhases.None;
      if (!(o & r))
        return;
      this._target.removeEventListener(e12, t2, n);
      let s = o ^ r;
      s === EventListenerPhases.None ? a.delete(t2) : a.set(t2, s);
    }), a.size || this._eventListeners.delete(e12));
  }
  _unregisterAllListeners(e12, t) {
    Array.from(t.entries()).forEach(([t2, n]) => {
      let r = EventListenerPhases.Capture;
      for (let a = r; n; a <<= 1) {
        if (!(n & a))
          continue;
        let r2 = a === EventListenerPhases.Capture;
        this.removeEventListener(e12, t2, { capture: r2 }), n ^= a;
      }
    });
  }
  _unregisterAllEvents() {
    Array.from(this._eventListeners.entries()).forEach(([e12, t]) => {
      this._unregisterAllListeners(e12, t);
    });
  }
}, MultiTargetEventListenerManager = class {
  constructor() {
    this._targetsEventListeners = /* @__PURE__ */ new Map();
  }
  addEventListener(e12, t, n, r) {
    let a = this._targetsEventListeners.get(e12);
    a || (a = new TargetEventListeners(e12), this._targetsEventListeners.set(e12, a)), a.addEventListener(t, n, r);
  }
  removeEventListener(e12, t, n, r) {
    let a = this._targetsEventListeners.get(e12);
    a && (a.removeEventListener(t, n, r), a.isEmpty && this._targetsEventListeners.delete(e12));
  }
  reset() {
    Array.from(this._targetsEventListeners.entries()).forEach(([e12, t]) => {
      t.reset(), this._targetsEventListeners.delete(e12);
    });
  }
}, eventListener_exports = /* @__PURE__ */ __export({
  MultiTargetEventListenerManager: () => MultiTargetEventListenerManager,
  TargetEventListeners: () => TargetEventListeners
});
function scaleRGBTransferFunction(e12, t) {
  let n = e12.getSize();
  for (let r = 0; r < n; r++) {
    let n2 = [];
    e12.getNodeValue(r, n2), n2[1] *= t, n2[2] *= t, n2[3] *= t, e12.setNodeValue(r, n2);
  }
}
function getMinMax(e12) {
  let t = e12[0], n = e12[0], r, a = e12.length;
  for (let o = 1; o < a; o++)
    r = e12[o], t = Math.min(t, r), n = Math.max(n, r);
  return {
    min: t,
    max: n
  };
}
var LAST_RUNTIME_ID = Symbol("LastRuntimeId"), GLOBAL_CONTEXT = {}, DEFAULT_MAX = 4294967295, DEFAULT_SEPARATOR = "-";
function getRuntimeId(e12, t, n) {
  return getNextRuntimeId(typeof e12 == "object" && e12 ? e12 : GLOBAL_CONTEXT, LAST_RUNTIME_ID, (typeof n == "number" && n > 0 ? n : DEFAULT_MAX) >>> 0).join(typeof t == "string" ? t : DEFAULT_SEPARATOR);
}
function getNextRuntimeId(e12, t, n) {
  let r = e12[t];
  r instanceof Array || (r = [0], Object.defineProperty(e12, t, { value: r }));
  for (let e13 = true, t2 = 0; e13 && t2 < r.length; ++t2) {
    let a = r[t2] | 0;
    a < n ? (e13 = false, a += 1) : (a = 0, t2 + 1 === r.length && r.push(0)), r[t2] = a;
  }
  return r;
}
var state$1 = {}, calibratedPixelSpacingMetadataProvider_default = {
  add: (e12, t) => {
    let n = imageIdToURI(e12);
    state$1[n] = t;
  },
  get: (e12, t) => {
    if (e12 === "calibratedPixelSpacing")
      return state$1[imageIdToURI(t)];
  }
};
function isOpposite(e12, t, n = 1e-5) {
  return Math.abs(e12[0] + t[0]) < n && Math.abs(e12[1] + t[1]) < n && Math.abs(e12[2] + t[2]) < n;
}
function indexWithinDimensions(e12, t) {
  return !(e12[0] < 0 || e12[0] >= t[0] || e12[1] < 0 || e12[1] >= t[1] || e12[2] < 0 || e12[2] >= t[2]);
}
function getVolumeViewportsContainingSameVolumes(e12, t) {
  let n;
  n = t ? [getRenderingEngine(t)] : getRenderingEngines();
  let r = [];
  return n.forEach((t2) => {
    let n2 = e12.getActors(), a = t2.getVolumeViewports();
    for (let e13 of a) {
      let t3 = e13.getActors();
      t3.length === n2.length && n2.every(({ uid: e14 }) => t3.find((t4) => e14 === t4.uid)) && r.push(e13);
    }
  }), r;
}
var getVolumeViewportsContainingSameVolumes_default = getVolumeViewportsContainingSameVolumes, isPTPrescaledWithSUV_default = (e12) => e12.preScale.scaled && e12.preScale.scalingParameters.suvbw;
function renderToCanvasGPU(e12, t, n = void 0, r = "_thumbnails", o = { displayArea: { imageArea: [1, 1] } }) {
  if (!e12 || !(e12 instanceof HTMLCanvasElement))
    throw Error("canvas element is required");
  let s = !t.imageId, c = !s && t, u = s && t, d = `renderGPUViewport-${c.imageId || u.volumeId}`, f = document.createElement("div"), p = window.devicePixelRatio || 1;
  o.displayArea ||= { imageArea: [1, 1] };
  let m = e12.width, h = e12.height;
  f.style.width = `${m / p + EPSILON}px`, f.style.height = `${h / p + EPSILON}px`, f.style.visibility = "hidden", f.style.position = "absolute", document.body.appendChild(f);
  let g = d.split(":").join("-");
  f.setAttribute("viewport-id-for-remove", g);
  let _ = getOrCreateCanvas_default(f), v = getRenderingEngine(r) || new TiledRenderingEngine_default(r), y = v.getViewport(d);
  if (!y) {
    let e13 = {
      viewportId: d,
      type: s ? ViewportType_default.ORTHOGRAPHIC : ViewportType_default.STACK,
      element: f,
      defaultOptions: {
        ...o,
        suppressEvents: true
      }
    };
    v.enableElement(e13), y = v.getViewport(d);
  }
  return new Promise((r2) => {
    let l = false, { viewReference: m2 } = o, h2 = (t2) => {
      if (l)
        return;
      if (m2) {
        let e13 = m2;
        m2 = null, y.setViewReference(e13), y.render();
        return;
      }
      e12.getContext("2d").drawImage(_, 0, 0, _.width, _.height, 0, 0, e12.width, e12.height);
      let n2 = y.canvasToWorld([0, 0]), o2 = y.canvasToWorld([_.width / p, 0]), s2 = y.canvasToWorld([0, _.height / p]), c2 = sub$1([
        0,
        0,
        0
      ], y.canvasToWorld([1 / p, 0]), n2), u2 = sub$1([
        0,
        0,
        0
      ], y.canvasToWorld([0, 1 / p]), n2);
      l = true, f.removeEventListener(Events_default.IMAGE_RENDERED, h2), setTimeout(() => {
        v.disableElement(d), document.querySelectorAll(`[viewport-id-for-remove="${g}"]`).forEach((e13) => {
          e13.remove();
        });
      }, 0), r2({
        origin: n2,
        bottomLeft: s2,
        topRight: o2,
        thicknessMm: 1,
        rightVector: c2,
        downVector: u2
      });
    };
    f.addEventListener(Events_default.IMAGE_RENDERED, h2), s ? y.setVolumes([u], false, true) : y.renderImageObject(t), y.resetCamera(), n === "PT" && !isPTPrescaledWithSUV_default(c) && y.setProperties({ voiRange: {
      lower: c.minPixelValue,
      upper: c.maxPixelValue
    } }), y.render();
  });
}
function renderToCanvasCPU(e12, t, n, r, a) {
  if (t.volumeId)
    throw Error("Unsupported volume rendering for CPU");
  let o = t, s = {
    canvas: e12,
    viewport: getDefaultViewport_default(e12, o, n),
    image: o,
    renderingTools: {}
  };
  return s.transform = calculateTransform_default(s), new Promise((e13, t2) => {
    drawImageSync_default(s, true), e13(null);
  });
}
function loadImageToCanvas(e12) {
  let { canvas: t, imageId: n, viewReference: r, requestType: a = RequestType_default.Thumbnail, priority: o = -5, renderingEngineId: c = "_thumbnails", useCPURendering: l = false, thumbnail: u = false, imageAspect: d = false, viewportOptions: f } = e12, p = r?.volumeId, m = p && !n, h = r && f ? {
    ...f,
    viewReference: r
  } : f, g = l ? renderToCanvasCPU : renderToCanvasGPU;
  return new Promise((e13, r2) => {
    function s(n2, a2) {
      let { modality: o2 } = getMetaData("generalSeriesModule", a2) || {}, s2 = !m && n2, f3 = m && n2;
      s2 && (s2.isPreScaled = s2.isPreScaled || s2.preScale?.scaled), u && (t.height = 256, t.width = 256), d && s2 && (t.width = s2 && t.height * s2.width / s2.height), t.style.width = `${t.width / devicePixelRatio}px`, t.style.height = `${t.height / devicePixelRatio}px`, f3 && l && r2(/* @__PURE__ */ Error("CPU rendering of volume not supported")), g(t, n2, o2, c, h).then(e13);
    }
    function f2(e14, t2) {
      console.error(e14, t2), r2(e14);
    }
    function _(e14, t2, n2) {
      return loadAndCacheImage(e14, n2).then((t3) => {
        s.call(this, t3, e14);
      }, (t3) => {
        f2.call(this, t3, e14);
      });
    }
    let v = {
      useRGBA: !!l,
      requestType: a
    };
    if (p) {
      let e14 = cache_default.getVolume(p);
      e14 || r2(/* @__PURE__ */ Error(`Volume id ${p} not found in cache`));
      let t2 = e14.imageIds[0];
      s(e14, t2);
    } else
      imageLoadPoolManager_default.addRequest(_.bind(null, n, null, v), a, { imageId: n }, o);
  });
}
function asArray(e12) {
  return Array.isArray(e12) ? e12 : [e12];
}
var historyMemo_exports = /* @__PURE__ */ __export({
  DefaultHistoryMemo: () => DefaultHistoryMemo,
  HistoryMemo: () => HistoryMemo
}), Events = {
  HISTORY_UNDO: "CORNERSTONE_TOOLS_HISTORY_UNDO",
  HISTORY_REDO: "CORNERSTONE_TOOLS_HISTORY_REDO"
}, HistoryMemo = class {
  constructor(e12 = "Tools", t = 50) {
    this.position = -1, this.redoAvailable = 0, this.undoAvailable = 0, this.ring = [], this.isRecordingGrouped = false, this.label = e12, this._size = t;
  }
  get size() {
    return this._size;
  }
  set size(e12) {
    this.ring = Array(e12), this._size = e12, this.position = -1, this.redoAvailable = 0, this.undoAvailable = 0;
  }
  get canUndo() {
    return this.undoAvailable > 0;
  }
  get canRedo() {
    return this.redoAvailable > 0;
  }
  undo(e12 = 1) {
    for (; e12 > 0 && this.undoAvailable > 0; ) {
      let t = this.ring[this.position];
      for (let e13 of asArray(t).reverse())
        e13.restoreMemo(true), this.dispatchHistoryEvent({
          item: e13,
          isUndo: true
        });
      e12--, this.redoAvailable++, this.undoAvailable--, this.position = (this.position - 1 + this.size) % this.size;
    }
  }
  undoIf(e12) {
    return this.undoAvailable > 0 && e12(this.ring[this.position]) ? (this.undo(), true) : false;
  }
  dispatchHistoryEvent({ item: e12, isUndo: t }) {
    e12.id && eventTarget_default.dispatchEvent(new CustomEvent(t ? Events.HISTORY_UNDO : Events.HISTORY_REDO, { detail: {
      isUndo: t,
      id: e12.id,
      operationType: e12.operationType || "annotation",
      memo: e12
    } }));
  }
  redo(e12 = 1) {
    for (; e12 > 0 && this.redoAvailable > 0; ) {
      let t = (this.position + 1) % this.size, n = this.ring[t];
      for (let e13 of asArray(n).reverse())
        e13.restoreMemo(false), this.dispatchHistoryEvent({
          item: e13,
          isUndo: false
        });
      e12--, this.position = t, this.undoAvailable++, this.redoAvailable--;
    }
  }
  initializeGroupItem() {
    this.redoAvailable = 0, this.undoAvailable < this._size && this.undoAvailable++, this.position = (this.position + 1) % this._size, this.ring[this.position] = [];
  }
  startGroupRecording() {
    this.isRecordingGrouped = true, this.initializeGroupItem();
  }
  rollbackUnusedGroupItem() {
    this.ring[this.position] = void 0, this.position = (this.position - 1) % this._size, this.undoAvailable--;
  }
  endGroupRecording() {
    this.isRecordingGrouped = false;
    let e12 = this.ring[this.position];
    Array.isArray(e12) && e12.length === 0 && this.rollbackUnusedGroupItem();
  }
  pushGrouped(e12) {
    let t = this.ring[this.position];
    if (Array.isArray(t))
      return t.push(e12), e12;
    throw Error("Last item should be an array for grouped memos.");
  }
  push(e12) {
    if (!e12)
      return;
    let t = e12.restoreMemo ? e12 : e12.createMemo?.();
    if (t)
      return this.isRecordingGrouped ? this.pushGrouped(t) : (this.redoAvailable = 0, this.undoAvailable < this._size && this.undoAvailable++, this.position = (this.position + 1) % this._size, this.ring[this.position] = t, t);
  }
}, DefaultHistoryMemo = new HistoryMemo();
function worldToImageCoords(e12, t) {
  let n = getMetaData("imagePlaneModule", e12);
  if (!n)
    throw Error(`No imagePlaneModule found for imageId: ${e12}`);
  let { columnCosines: r, rowCosines: a, imagePositionPatient: o } = n, { columnPixelSpacing: s, rowPixelSpacing: c } = n;
  s ||= 1, c ||= 1;
  let l = create$4();
  scaleAndAdd(l, o, r, -s / 2), scaleAndAdd(l, l, a, -c / 2);
  let u = create$4();
  sub$1(u, t, l);
  let d = dot$3(u, a), f = dot$3(u, r);
  return [d / c, f / s];
}
var worldToImageCoords_default = worldToImageCoords;
function imageToWorldCoords(e12, t) {
  let n = getMetaData("imagePlaneModule", e12);
  if (!n)
    throw Error(`No imagePlaneModule found for imageId: ${e12}`);
  let { columnCosines: r, rowCosines: a, imagePositionPatient: o } = n, { columnPixelSpacing: s, rowPixelSpacing: c } = n;
  s ||= 1, c ||= 1;
  let l = create$4();
  return scaleAndAdd(l, o, a, c * (t[0] - 0.5)), scaleAndAdd(l, l, r, s * (t[1] - 0.5)), Array.from(l);
}
function getViewportsWithImageURI(e12) {
  let t = getRenderingEngines(), n = [];
  return t.forEach((t2) => {
    t2.getViewports().forEach((t3) => {
      t3.hasImageURI(e12) && n.push(t3);
    });
  }), n;
}
function getClosestStackImageIndexForPoint(e12, t) {
  let n = calculateMinimalDistanceForStackViewport(e12, t);
  return n ? n.index : null;
}
function calculateMinimalDistanceForStackViewport(e12, t) {
  let n = t.getImageIds(), r = t.getCurrentImageIdIndex();
  if (n.length === 0)
    return null;
  let a = (t2) => {
    let n2 = getPlaneMetadata(t2);
    return n2 ? planeDistanceToPoint(planeEquation(n2.planeNormal, n2.imagePositionPatient), e12) : null;
  }, o = {
    distance: a(n[r]) ?? Infinity,
    index: r
  }, s = n.slice(r + 1);
  for (let e13 = 0; e13 < s.length; e13++) {
    let t2 = s[e13], n2 = a(t2);
    if (n2 !== null)
      if (n2 <= o.distance)
        o.distance = n2, o.index = e13 + r + 1;
      else
        break;
  }
  let c = n.slice(0, r);
  for (let e13 = c.length - 1; e13 >= 0; e13--) {
    let t2 = c[e13], n2 = a(t2);
    if (!(n2 === null || n2 === o.distance))
      if (n2 < o.distance)
        o.distance = n2, o.index = e13;
      else
        break;
  }
  return o.distance === Infinity ? null : o;
}
function getPlaneMetadata(e12) {
  let t = getMetaData("imagePlaneModule", e12);
  if (!t || !(t.rowCosines instanceof Array && t.rowCosines.length === 3) || !(t.columnCosines instanceof Array && t.columnCosines.length === 3) || !(t.imagePositionPatient instanceof Array && t.imagePositionPatient.length === 3))
    return null;
  let { rowCosines: n, columnCosines: r, imagePositionPatient: a } = t, o = set$4(create$4(), ...n), s = set$4(create$4(), ...r);
  return {
    rowCosines: n,
    columnCosines: r,
    imagePositionPatient: a,
    planeNormal: cross$1(create$4(), o, s)
  };
}
function getCurrentVolumeViewportSlice(e12) {
  let { width: t, height: n } = e12.getCanvas(), { sliceToIndexMatrix: r, indexToSliceMatrix: a } = e12.getSliceViewInfo(), o = transformCanvasToIJK(e12, [0, 0]), s = transformCanvasToIJK(e12, [t - 1, 0]), c = transformCanvasToIJK(e12, [0, n - 1]), l = sub$1(create$4(), s, o), u = sub$1(create$4(), c, o), d = cross$1(create$4(), l, u);
  normalize$4(l, l), normalize$4(u, u), normalize$4(d, d);
  let f = Math.max(Math.abs(l[0]), Math.abs(l[1]), Math.abs(l[2])), p = Math.max(Math.abs(u[0]), Math.abs(u[1]), Math.abs(u[2]));
  if (!equals$6(1, f) || !equals$6(1, p))
    throw Error("Livewire is not available for rotate/oblique viewports");
  let { voxelManager: m } = e12.getImageData(), h = e12.getSliceViewInfo(), g = m.getSliceData(h);
  return {
    width: h.width,
    height: h.height,
    scalarData: g,
    sliceToIndexMatrix: r,
    indexToSliceMatrix: a
  };
}
var state = {}, spatialRegistrationMetadataProvider = {
  add: (e12, t) => {
    let [n, r] = e12, a = `${n}_${r}`;
    state[a] || (state[a] = {}), state[a] = t;
  },
  get: (e12, t, n) => {
    if (e12 !== "spatialRegistrationModule")
      return;
    let r = `${t}_${n}`;
    if (state[r])
      return state[r];
    let a = `${n}_${t}`;
    if (state[a])
      return invert(create$5(), state[a]);
  }
};
addProvider(spatialRegistrationMetadataProvider.get.bind(spatialRegistrationMetadataProvider));
var spatialRegistrationMetadataProvider_default = spatialRegistrationMetadataProvider, ALLOWED_DELTA = 0.05;
function calculateViewportsSpatialRegistration(e12, t) {
  let n = e12.getSliceIndex(), r = t.getSliceIndex(), a = getMetaData("imagePlaneModule", n.toString()), o = getMetaData("imagePlaneModule", r.toString());
  if (!a || !o) {
    console.log("Viewport spatial registration requires image plane module");
    return;
  }
  let { imageOrientationPatient: s } = o;
  if (!a.imageOrientationPatient.every((e13, t2) => Math.abs(e13 - s[t2]) < ALLOWED_DELTA)) {
    console.log("Viewport spatial registration only supported for same orientation (hence translation only) for now", a?.imageOrientationPatient, o?.imageOrientationPatient);
    return;
  }
  let c = a.imagePositionPatient, l = o.imagePositionPatient, u = subtract$3(create$4(), c, l), d = fromTranslation(create$5(), u);
  spatialRegistrationMetadataProvider_default.add([e12.id, t.id], d);
}
var calculateViewportsSpatialRegistration_default = calculateViewportsSpatialRegistration;
function getViewportImageCornersInWorld(e12) {
  let { imageData: t, dimensions: n } = e12.getImageData() || {};
  if (!t || !n)
    return [];
  let { canvas: r } = e12, a = window.devicePixelRatio, o = [0, 0], s = [r.width / a, 0], c = [r.width / a, r.height / a], l = [0, r.height / a], u = e12.canvasToWorld(o), d = e12.canvasToWorld(s), f = e12.canvasToWorld(c), p = e12.canvasToWorld(l);
  return _getStackViewportImageCorners({
    dimensions: n,
    imageData: t,
    topLeftImage: t.worldToIndex(u),
    topRightImage: t.worldToIndex(d),
    bottomRightImage: t.worldToIndex(f),
    bottomLeftImage: t.worldToIndex(p),
    topLeftWorld: u,
    topRightWorld: d,
    bottomRightWorld: f,
    bottomLeftWorld: p
  });
}
function _getStackViewportImageCorners({ dimensions: e12, imageData: t, topLeftImage: n, topRightImage: r, bottomRightImage: a, bottomLeftImage: o, topLeftWorld: s, topRightWorld: c, bottomRightWorld: l, bottomLeftWorld: u }) {
  let d = _isInBounds(n, e12) ? s : t.indexToWorld([
    0,
    0,
    0
  ]), f = _isInBounds(r, e12) ? c : t.indexToWorld([
    e12[0] - 1,
    0,
    0
  ]), p = _isInBounds(a, e12) ? l : t.indexToWorld([
    e12[0] - 1,
    e12[1] - 1,
    0
  ]);
  return [
    d,
    f,
    _isInBounds(o, e12) ? u : t.indexToWorld([
      0,
      e12[1] - 1,
      0
    ]),
    p
  ];
}
function _isInBounds(e12, t) {
  return e12[0] > 0 || e12[0] < t[0] - 1 || e12[1] > 0 || e12[1] < t[1] - 1 || e12[2] > 0 || e12[2] < t[2] - 1;
}
function getEnabledElement(e12) {
  if (!e12)
    return;
  let { viewportUid: t, renderingEngineUid: n } = e12.dataset;
  return getEnabledElementByIds(t, n);
}
function getEnabledElementByIds(e12, t) {
  if (!t || !e12)
    return;
  let n = getRenderingEngine_default(t);
  if (!n || n.hasBeenDestroyed)
    return;
  let r = n.getViewport(e12);
  if (r)
    return {
      viewport: r,
      renderingEngine: n,
      viewportId: e12,
      renderingEngineId: t,
      FrameOfReferenceUID: r.getFrameOfReferenceUID()
    };
}
function getEnabledElementByViewportId(e12) {
  let t = getRenderingEngines();
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    if (r.getViewport(e12))
      return getEnabledElementByIds(e12, r.id);
  }
}
function getEnabledElements() {
  let e12 = [];
  return getRenderingEngines().forEach((t) => {
    t.getViewports().forEach(({ element: t2 }) => {
      e12.push(getEnabledElement(t2));
    });
  }), e12;
}
function getImageLegacy(e12) {
  let t = getEnabledElement(e12);
  if (!t)
    return;
  let { viewport: n } = t;
  if (!(n instanceof StackViewport_default))
    throw Error(`An image can only be fetched for a stack viewport and not for a viewport of type: ${n.type}`);
  return n.getCornerstoneImage();
}
var getImageLegacy_default = getImageLegacy;
function isValidVolume(e12) {
  if (!e12.length)
    return false;
  let t = e12[0], { modality: n, seriesInstanceUID: r } = getMetaData("generalSeriesModule", t), { imageOrientationPatient: a, pixelSpacing: o, frameOfReferenceUID: s, columns: c, rows: l, usingDefaultValues: u } = getMetaData("imagePlaneModule", t);
  if (u)
    return false;
  let d = {
    modality: n,
    imageOrientationPatient: a,
    pixelSpacing: o,
    frameOfReferenceUID: s,
    columns: c,
    rows: l,
    seriesInstanceUID: r
  }, f = true;
  for (let t2 = 0; t2 < e12.length; t2++) {
    let n2 = e12[t2], { modality: r2, seriesInstanceUID: a2 } = getMetaData("generalSeriesModule", n2), { imageOrientationPatient: o2, pixelSpacing: s2, columns: c2, rows: l2 } = getMetaData("imagePlaneModule", n2);
    if (a2 !== d.seriesInstanceUID) {
      f = false;
      break;
    }
    if (r2 !== d.modality) {
      f = false;
      break;
    }
    if (c2 !== d.columns) {
      f = false;
      break;
    }
    if (l2 !== d.rows) {
      f = false;
      break;
    }
    if (!isEqual_default(o2, d.imageOrientationPatient)) {
      f = false;
      break;
    }
    if (!isEqual_default(s2, d.pixelSpacing)) {
      f = false;
      break;
    }
  }
  return f;
}
const videoUIDs = /* @__PURE__ */ new Set([
  "1.2.840.10008.1.2.4.100",
  "1.2.840.10008.1.2.4.100.1",
  "1.2.840.10008.1.2.4.101",
  "1.2.840.10008.1.2.4.101.1",
  "1.2.840.10008.1.2.4.102",
  "1.2.840.10008.1.2.4.102.1",
  "1.2.840.10008.1.2.4.103",
  "1.2.840.10008.1.2.4.103.1",
  "1.2.840.10008.1.2.4.104",
  "1.2.840.10008.1.2.4.104.1",
  "1.2.840.10008.1.2.4.105",
  "1.2.840.10008.1.2.4.105.1",
  "1.2.840.10008.1.2.4.106",
  "1.2.840.10008.1.2.4.106.1",
  "1.2.840.10008.1.2.4.107",
  "1.2.840.10008.1.2.4.108"
]);
function isVideoTransferSyntax(e12) {
  return e12 ? (Array.isArray(e12) ? e12 : [e12]).find((e13) => videoUIDs.has(e13)) : false;
}
async function convertStackToVolumeViewport({ viewport: e12, options: t = {} }) {
  let n = e12.getRenderingEngine(), r = t.volumeId || `${uuidv4()}`;
  r.split(":").length === 0 && (r = `${getUnknownVolumeLoaderSchema()}:${r}`);
  let { id: o, element: s } = e12, c = t.viewportId || o, u = e12.getImageIds(), d = e12.getViewPresentation(), f = e12.getViewReference();
  n.enableElement({
    viewportId: c,
    type: ViewportType_default.ORTHOGRAPHIC,
    element: s,
    defaultOptions: {
      background: t.background,
      orientation: t.orientation
    }
  }), (await createAndCacheVolume(r, { imageIds: u })).load();
  let p = n.getViewport(c);
  await setVolumesForViewports_default(n, [{ volumeId: r }], [c]);
  let m = () => {
    p.render(), s.removeEventListener(Events_default.VOLUME_VIEWPORT_NEW_VOLUME, m);
  };
  return s.addEventListener(Events_default.VOLUME_VIEWPORT_NEW_VOLUME, m), p.setViewPresentation(d), p.setViewReference(f), p.render(), p;
}
async function convertVolumeToStackViewport({ viewport: e12, options: t }) {
  let n = e12, { id: r, element: a } = n, o = e12.getRenderingEngine(), { background: s } = t, c = t.viewportId || r, u = cache_default.getVolume(n.getVolumeId());
  if (!(u instanceof ImageVolume))
    throw Error("Currently, you cannot decache a volume that is not an ImageVolume. So, unfortunately, volumes such as nifti  (which are basic Volume, without imageIds) cannot be decached.");
  let d = {
    viewportId: c,
    type: ViewportType_default.STACK,
    element: a,
    defaultOptions: { background: s }
  }, f = n.getViewReference();
  o.enableElement(d);
  let p = o.getViewport(c);
  return await p.setStack(u.imageIds), p.setViewReference(f), p.render(), p;
}
function roundNumber(e12, t = 2) {
  if (Array.isArray(e12))
    return e12.map((e13) => roundNumber(e13, t)).join(", ");
  if (e12 == null || e12 === "")
    return "NaN";
  e12 = Number(e12);
  let n = Math.abs(e12);
  if (n < 1e-4)
    return `${e12}`;
  let r = n >= 100 ? t - 2 : n >= 10 ? t - 1 : n >= 1 ? t : n >= 0.1 ? t + 1 : n >= 0.01 ? t + 2 : n >= 1e-3 ? t + 3 : t + 4;
  return e12.toFixed(r);
}
function roundToPrecision(e12) {
  return Math.round(e12 / epsilon_default) * epsilon_default;
}
var roundNumber_default = roundNumber;
function convertToGrayscale(e12, t, n) {
  let r = e12.length === t * n * 4, a = e12.length === t * n * 3;
  if (r || a) {
    let a2 = new Float32Array(t * n), o = 0, s = 0, c = r ? 4 : 3;
    for (let r2 = 0; r2 < t; r2++)
      for (let t2 = 0; t2 < n; t2++) {
        let t3 = e12[o], n2 = e12[o + 1], r3 = e12[o + 2];
        a2[s] = (t3 + n2 + r3) / 3, o += c, s++;
      }
    return a2;
  } else
    return e12;
}
function getViewportImageIds(e12) {
  if (e12 instanceof VolumeViewport_default)
    return cache_default.getVolume(e12.getVolumeId()).imageIds;
  if (e12.getImageIds)
    return e12.getImageIds();
}
var getViewportImageIds_default = getViewportImageIds;
function getRandomSampleFromArray(e12, t) {
  let n = [...e12];
  return t >= n.length ? (shuffleArray(n), n) : (shuffleArray(n), n.slice(0, t));
}
function shuffleArray(e12) {
  for (let t = e12.length - 1; t > 0; t--) {
    let n = Math.floor(Math.random() * (t + 1));
    [e12[t], e12[n]] = [e12[n], e12[t]];
  }
}
var color_exports = /* @__PURE__ */ __export({
  hexToRgb: () => hexToRgb,
  rgbToHex: () => rgbToHex
});
function componentToHex(e12) {
  let t = e12.toString(16);
  return t.length == 1 ? "0" + t : t;
}
function rgbToHex(e12, t, n) {
  return "#" + componentToHex(e12) + componentToHex(t) + componentToHex(n);
}
function hexToRgb(e12) {
  let t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e12);
  return t ? {
    r: parseInt(t[1], 16),
    g: parseInt(t[2], 16),
    b: parseInt(t[3], 16)
  } : null;
}
function deepEqual(e12, t) {
  if (e12 === t)
    return true;
  if (e12 == null || t == null)
    return false;
  try {
    return JSON.stringify(e12) === JSON.stringify(t);
  } catch (n) {
    return console.debug("Error in JSON.stringify during deep comparison:", n), e12 === t;
  }
}
function _getViewportModality(e12, t, n) {
  if (!n)
    throw Error("getVolume is required, use the utilities export instead ");
  if (e12.modality)
    return e12.modality;
  if (e12.setVolumes)
    return t ??= e12.getVolumeId(), !t || !n ? void 0 : n(t).metadata.Modality;
  throw Error("Invalid viewport type");
}
function toFiniteNumber(e12) {
  return Number.isFinite(e12) ? e12 : void 0;
}
function generateFrameImageId(e12, t) {
  let n = /\/frames\/\d+/;
  if (!n.test(e12))
    throw Error(`generateFrameImageId: baseImageId must contain a "/frames/" pattern followed by a digit. Expected format: e.g., "wadouri:http://example.com/image/frames/1" or "wadors:/path/to/image.dcm/frames/1". Received: ${e12}`);
  return e12.replace(n, `/frames/${t}`);
}
function handleMultiframe4D(e12) {
  if (!e12 || e12.length === 0)
    return null;
  let t = e12[0], n = getMetaData("instance", t);
  if (!n)
    return null;
  let r = n.NumberOfFrames;
  if (!r || r <= 1)
    return null;
  let a = n.TimeSlotVector;
  if (!a || !Array.isArray(a))
    return null;
  let o = n.SliceVector, s = n.NumberOfSlices;
  if (a.length !== r)
    return console.warn("TimeSlotVector length does not match NumberOfFrames:", a.length, "vs", r), null;
  if (o) {
    if (!Array.isArray(o))
      return console.warn("SliceVector exists but is not an array. Expected length:", r), null;
    if (o.length !== r || o.some((e13) => e13 === void 0))
      return console.warn("SliceVector exists but has invalid length or undefined entries. Expected length:", r, "Actual length:", o.length), null;
  }
  let c = /* @__PURE__ */ new Map();
  for (let e13 = 0; e13 < r; e13++) {
    let t2 = a[e13], n2 = o?.[e13] ?? e13;
    c.has(t2) || c.set(t2, []), c.get(t2).push({
      frameIndex: e13,
      sliceIndex: n2
    });
  }
  let l = Array.from(c.keys()).sort((e13, t2) => e13 - t2).map((e13) => {
    let n2 = c.get(e13);
    return n2.sort((e14, t2) => e14.sliceIndex - t2.sliceIndex), n2.map((e14) => generateFrameImageId(t, e14.frameIndex + 1));
  }), u = s || l[0]?.length;
  return l.every((e13) => e13.length === u) || console.warn("Multiframe 4D split resulted in uneven time slot groups. Expected", u, "slices per time slot."), {
    imageIdGroups: l,
    splittingTag: "TimeSlotVector"
  };
}
function handleCardiac4D(e12) {
  if (!e12 || e12.length === 0 || getFiniteValue(e12[0], "CardiacNumberOfImages") === void 0)
    return null;
  let t = /* @__PURE__ */ new Map();
  for (let n2 of e12) {
    let e13 = getMetaData("StackID", n2), r2 = getFiniteValue(n2, "InStackPositionNumber"), a2 = getFiniteValue(n2, "TriggerTime");
    if (e13 === void 0 || r2 === void 0 || a2 === void 0)
      return null;
    let o2 = String(e13);
    t.has(o2) || t.set(o2, /* @__PURE__ */ new Map());
    let s = t.get(o2);
    s.has(r2) || s.set(r2, []), s.get(r2).push({
      imageId: n2,
      triggerTime: a2
    });
  }
  let n = Array.from(t.keys()).sort((e13, t2) => Number(e13) - Number(t2));
  if (n.length === 0)
    return null;
  let r = [], a;
  for (let e13 of n) {
    let n2 = t.get(e13), o2 = Array.from(n2.keys()).sort((e14, t2) => e14 - t2);
    for (let e14 of o2) {
      let t2 = n2.get(e14);
      if (t2.sort((e15, t3) => e15.triggerTime - t3.triggerTime), a === void 0)
        a = t2.length;
      else if (t2.length !== a)
        return null;
    }
    r.push({
      stackId: e13,
      positions: o2,
      framesByPosition: n2
    });
  }
  if (!a)
    return null;
  let o = [];
  for (let e13 = 0; e13 < a; e13++) {
    let t2 = [];
    for (let n2 of r)
      for (let r2 of n2.positions) {
        let a2 = n2.framesByPosition.get(r2);
        t2.push(a2[e13].imageId);
      }
    o.push(t2);
  }
  return {
    imageIdGroups: o,
    splittingTag: "CardiacTriggerTime"
  };
}
var groupBy = (e12, t) => e12.reduce((e13, n) => ((e13[n[t]] = e13[n[t]] || []).push(n), e13), {});
function getIPPGroups(e12) {
  let t = e12.map((e13) => {
    let { imagePositionPatient: t2 } = getMetaData("imagePlaneModule", e13) || {};
    return {
      imageId: e13,
      imagePositionPatient: t2
    };
  });
  if (!t.every((e13) => e13.imagePositionPatient))
    return null;
  let n = groupBy(t, "imagePositionPatient"), r = Object.keys(n), a = n[r[0]].length;
  return a === 1 || !r.every((e13) => n[e13].length === a) ? null : n;
}
function test4DTag(e12, t) {
  let n = {}, r = [], a = Object.keys(e12);
  for (let o = 0; o < a.length; o++) {
    let s = /* @__PURE__ */ new Set(), c = e12[a[o]];
    for (let e13 = 0; e13 < c.length; e13++) {
      let r2 = t(c[e13].imageId) || 0;
      if (n[r2] = n[r2] || [], n[r2].push({ imageId: c[e13].imageId }), s.add(r2), s.size - 1 < e13)
        return;
    }
    if (o == 0)
      r = Array.from(s);
    else if (!setEquals(r, s))
      return;
  }
  return n;
}
function getTagValue(e12, t) {
  let n = getMetaData(t, e12);
  try {
    return parseFloat(n);
  } catch {
    return;
  }
}
function getFiniteValue(e12, t) {
  return toFiniteNumber(getTagValue(e12, t));
}
function getPhilipsPrivateBValue(e12) {
  let t = getMetaData("20011003", e12);
  try {
    let { InlineBinary: e13 } = t;
    if (e13) {
      let t2 = atob(e13), n = new ArrayBuffer(t2.length), r = new DataView(n);
      for (let e14 = 0; e14 < t2.length; e14++)
        r.setUint8(e14, t2.charCodeAt(e14));
      return new Float32Array(n)[0];
    }
    return parseFloat(t);
  } catch {
    return;
  }
}
function getSiemensPrivateBValue(e12) {
  let t = getMetaData("0019100c", e12) || getMetaData("0019100C", e12);
  try {
    let { InlineBinary: e13 } = t;
    return e13 && (t = atob(e13)), parseFloat(t);
  } catch {
    return;
  }
}
function getGEPrivateBValue(e12) {
  let t = getMetaData("00431039", e12);
  try {
    let { InlineBinary: e13 } = t;
    return e13 && (t = atob(e13).split("//")), parseFloat(t[0]) % 1e5;
  } catch {
    return;
  }
}
function setEquals(e12, t) {
  if (e12.length != t.size)
    return false;
  for (let n = 0; n < e12.length; n++)
    if (!t.has(e12[n]))
      return false;
  return true;
}
function getPetFrameReferenceTime(e12) {
  let t = getMetaData("petImageModule", e12);
  return t ? t.frameReferenceTime : 0;
}
function splitImageIdsBy4DTags(e12) {
  let t = handleMultiframe4D(e12);
  if (t)
    return t;
  let n = handleCardiac4D(e12);
  if (n)
    return n;
  let r = getIPPGroups(e12);
  if (!r)
    return {
      imageIdGroups: [e12],
      splittingTag: null
    };
  let a = [
    "TemporalPositionIdentifier",
    "DiffusionBValue",
    "TriggerTime",
    "EchoTime",
    "EchoNumber",
    "PhilipsPrivateBValue",
    "SiemensPrivateBValue",
    "GEPrivateBValue",
    "PetFrameReferenceTime"
  ], o = [
    (e13) => getTagValue(e13, a[0]),
    (e13) => getTagValue(e13, a[1]),
    (e13) => getTagValue(e13, a[2]),
    (e13) => getTagValue(e13, a[3]),
    (e13) => getTagValue(e13, a[4]),
    getPhilipsPrivateBValue,
    getSiemensPrivateBValue,
    getGEPrivateBValue,
    getPetFrameReferenceTime
  ];
  for (let e13 = 0; e13 < o.length; e13++) {
    let t2 = test4DTag(r, o[e13]);
    if (t2)
      return {
        imageIdGroups: Object.keys(t2).map(Number.parseFloat).sort((e14, t3) => e14 - t3).map((e14) => t2[e14].map((e15) => e15.imageId)),
        splittingTag: a[e13]
      };
  }
  return {
    imageIdGroups: [e12],
    splittingTag: null
  };
}
var splitImageIdsBy4DTags_default = splitImageIdsBy4DTags;
function getDynamicVolumeInfo(e12) {
  let { imageIdGroups: t, splittingTag: n } = splitImageIdsBy4DTags_default(e12);
  return {
    isDynamicVolume: t.length > 1,
    timePoints: t,
    splittingTag: n
  };
}
var getDynamicVolumeInfo_default = getDynamicVolumeInfo;
function scaleArray(e12, t) {
  let n = e12.length, { rescaleSlope: r, rescaleIntercept: a, suvbw: o } = t;
  if (t.modality === "PT" && typeof o == "number")
    for (let t2 = 0; t2 < n; t2++)
      e12[t2] = o * (e12[t2] * r + a);
  else
    for (let t2 = 0; t2 < n; t2++)
      e12[t2] = e12[t2] * r + a;
  return e12;
}
function clip(e12, t, n) {
  return Math.min(Math.max(t, e12), n);
}
var clip_default = clip;
function scroll(e12, t) {
  if (!getEnabledElement(e12.element))
    throw Error("Scroll::Viewport is not enabled (it might be disabled)");
  if (e12 instanceof StackViewport_default && e12.getImageIds().length === 0)
    throw Error("Scroll::Stack Viewport has no images");
  let { volumeId: n, delta: r, scrollSlabs: o } = t;
  if (e12 instanceof VolumeViewport_default)
    scrollVolume(e12, n, r, o);
  else {
    let n2 = e12.getCurrentImageIdIndex();
    if (n2 + r > e12.getImageIds().length - 1 || n2 + r < 0) {
      let e13 = {
        imageIdIndex: n2,
        direction: r
      };
      triggerEvent(eventTarget_default, Events_default.STACK_SCROLL_OUT_OF_BOUNDS, e13);
    }
    e12.scroll(r, t.debounceLoading, t.loop);
  }
}
function scrollVolume(e12, t, n, r = false) {
  let { numScrollSteps: o, currentStepIndex: s, sliceRangeInfo: c } = getVolumeViewportScrollInfo_default(e12, t, r);
  if (o === 0 || !c)
    return;
  let { sliceRange: l, spacingInNormalDirection: u, camera: d } = c, { focalPoint: f, viewPlaneNormal: p, position: m } = d, { newFocalPoint: h, newPosition: g } = snapFocalPointToSlice(f, m, l, p, u, n);
  e12.setCamera({
    focalPoint: h,
    position: g
  }), e12.render();
  let _ = s + n, v = {
    volumeId: t,
    viewport: e12,
    delta: n,
    desiredStepIndex: _,
    currentStepIndex: s,
    numScrollSteps: o,
    currentImageId: e12.getCurrentImageId()
  };
  (_ > o || _ < 0) && e12.getCurrentImageId() ? triggerEvent(eventTarget_default, Events_default.VOLUME_VIEWPORT_SCROLL_OUT_OF_BOUNDS, v) : triggerEvent(eventTarget_default, Events_default.VOLUME_VIEWPORT_SCROLL, v);
}
async function jumpToSlice(e12, t = {}) {
  let { imageIndex: n, debounceLoading: r, volumeId: a } = t, o = getEnabledElement(e12);
  if (!o)
    throw Error("Element has been disabled");
  let { viewport: s } = o, { imageIndex: c, numberOfSlices: l } = _getImageSliceData(s, r);
  scroll(s, {
    delta: _getImageIndexToJump(l, n) - c,
    debounceLoading: r,
    volumeId: a
  });
}
function _getImageSliceData(e12, t) {
  return e12 instanceof StackViewport_default ? {
    numberOfSlices: e12.getImageIds().length,
    imageIndex: t ? e12.getTargetImageIdIndex() : e12.getCurrentImageIdIndex()
  } : {
    numberOfSlices: e12.getNumberOfSlices(),
    imageIndex: e12.getSliceIndex()
  };
}
function _getImageIndexToJump(e12, t) {
  return clip_default(t, 0, e12 - 1);
}
function createSubVolume(e12, t, n = {}) {
  let r = cache_default.getVolume(e12);
  if (!r)
    throw Error(`Referenced volume with id ${e12} does not exist.`);
  let { metadata: a, spacing: o, direction: s, dimensions: c } = r, { minX: l, maxX: u, minY: d, maxY: f, minZ: p, maxZ: m } = t, h = [
    Math.min(l, u),
    Math.min(d, f),
    Math.min(p, m)
  ], g = transformIndexToWorld(r.imageData, h), _ = [
    Math.abs(u - l) + 1,
    Math.abs(f - d) + 1,
    Math.abs(m - p) + 1
  ], { targetBuffer: v } = n, y = {
    metadata: a,
    dimensions: _,
    spacing: o,
    origin: g,
    direction: s,
    targetBuffer: v,
    scalarData: v?.type === "Float32Array" ? new Float32Array(_[0] * _[1] * _[2]) : void 0
  }, b = createLocalVolume(uuidv4(), y), S = b.voxelManager.getCompleteScalarDataArray(), C = _[0] * _[1], w = c[0] * c[1], T = r.voxelManager.getCompleteScalarDataArray();
  for (let e13 = 0; e13 < _[2]; e13++)
    for (let t2 = 0; t2 < _[1]; t2++) {
      let n2 = transformIndexToWorld(b.imageData, [
        0,
        t2,
        e13
      ]), a2 = transformWorldToIndex(r.imageData, n2), o2 = a2[2] * w + a2[1] * c[0] + a2[0], s2 = T.slice(o2, o2 + _[0]), l2 = e13 * C + t2 * _[0];
      S.set(s2, l2);
    }
  return b.voxelManager.setCompleteScalarDataArray(S), b;
}
function getVolumeDirectionVectors(e12, t) {
  let { viewUp: n, viewPlaneNormal: r } = t, a = transformWorldToIndexContinuous(e12, [
    0,
    0,
    0
  ]), o = negate(create$4(), n), s = negate(create$4(), r), c = cross$1(create$4(), o, s), l = sub$1(create$4(), transformWorldToIndexContinuous(e12, o), a), u = sub$1(create$4(), transformWorldToIndexContinuous(e12, s), a);
  return normalize$4(l, l), normalize$4(u, u), {
    worldVecRowDir: c,
    worldVecColDir: o,
    worldVecSliceDir: s,
    ijkVecRowDir: cross$1(create$4(), l, u),
    ijkVecColDir: l,
    ijkVecSliceDir: u
  };
}
function calculateNeighborhoodStats(e12, t, n, r) {
  let [a, o, s] = t, c = a * o, l = 0, u = 0, d = 0, [f, p, m] = n.map(Math.round);
  for (let t2 = m - r; t2 <= m + r; t2++)
    if (!(t2 < 0 || t2 >= s)) {
      for (let n2 = p - r; n2 <= p + r; n2++)
        if (!(n2 < 0 || n2 >= o))
          for (let o2 = f - r; o2 <= f + r; o2++) {
            if (o2 < 0 || o2 >= a)
              continue;
            let r2 = e12[t2 * c + n2 * a + o2];
            l += r2, u += r2 * r2, d++;
          }
    }
  if (d === 0) {
    let t2 = m * c + p * a + f;
    return t2 >= 0 && t2 < e12.length ? {
      mean: e12[t2],
      stdDev: 0,
      count: 1
    } : {
      mean: 0,
      stdDev: 0,
      count: 0
    };
  }
  let h = l / d, g = u / d - h * h;
  return {
    mean: h,
    stdDev: Math.sqrt(Math.max(0, g)),
    count: d
  };
}
var projectionRadiographSOPClassUIDs = /* @__PURE__ */ new Set([
  "1.2.840.10008.5.1.4.1.1.1",
  "1.2.840.10008.5.1.4.1.1.1.1",
  "1.2.840.10008.5.1.4.1.1.1.1.1",
  "1.2.840.10008.5.1.4.1.1.1.2",
  "1.2.840.10008.5.1.4.1.1.1.2.1",
  "1.2.840.10008.5.1.4.1.1.1.3",
  "1.2.840.10008.5.1.4.1.1.1.3.1",
  "1.2.840.10008.5.1.4.1.1.12.1",
  "1.2.840.10008.5.1.4.1.1.12.1.1",
  "1.2.840.10008.5.1.4.1.1.12.2",
  "1.2.840.10008.5.1.4.1.1.12.2.1",
  "1.2.840.10008.5.1.4.1.1.12.3"
]);
function getERMF(e12) {
  let { PixelSpacing: t, ImagerPixelSpacing: n, EstimatedRadiographicMagnificationFactor: r, DistanceSourceToDetector: a, DistanceSourceToPatient: o } = e12;
  if (r)
    return r;
  if (o < a)
    return a / o;
  if (n?.[0] > t?.[0])
    return true;
}
function calculateRadiographicPixelSpacing(e12) {
  let { PixelSpacing: t, ImagerPixelSpacing: n, PixelSpacingCalibrationType: r } = e12;
  if (t && r === "GEOMETRY")
    return isEqual(t, n) && console.warn("Calibration type is geometry, but pixel spacing and imager pixel spacing identical", t, n), {
      PixelSpacing: t,
      type: CalibrationTypes_default.ERMF,
      isProjection: true
    };
  if (t && r === "FIDUCIAL")
    return {
      PixelSpacing: t,
      type: CalibrationTypes_default.CALIBRATED,
      isProjection: true
    };
  if (n) {
    let r2 = getERMF(e12);
    return r2 > 1 ? {
      PixelSpacing: n.map((e13) => e13 / r2),
      type: CalibrationTypes_default.ERMF,
      isProjection: true
    } : r2 === true ? {
      PixelSpacing: t,
      type: CalibrationTypes_default.ERMF,
      isProjection: true
    } : (r2 && console.error("Illegal ERMF value:", r2), {
      PixelSpacing: t || n,
      type: CalibrationTypes_default.PROJECTION,
      isProjection: true
    });
  }
  return {
    PixelSpacing: t,
    type: CalibrationTypes_default.UNKNOWN,
    isProjection: true
  };
}
function getPixelSpacingInformation(e12) {
  let { PixelSpacing: t, SOPClassUID: n } = e12;
  return projectionRadiographSOPClassUIDs.has(n) ? calculateRadiographicPixelSpacing(e12) : {
    PixelSpacing: t,
    type: CalibrationTypes_default.NOT_APPLICABLE,
    isProjection: false
  };
}
var utilities_exports = /* @__PURE__ */ __export({
  FrameRange: () => FrameRange,
  HistoryMemo: () => historyMemo_exports,
  PointsManager: () => PointsManager,
  ProgressiveIterator: () => ProgressiveIterator,
  RLEVoxelMap: () => RLEVoxelMap,
  VoxelManager: () => VoxelManager,
  actorIsA: () => actorIsA,
  applyPreset: () => applyPreset,
  asArray: () => asArray,
  autoLoad: () => autoLoad_default,
  buildMetadata: () => buildMetadata,
  calculateNeighborhoodStats: () => calculateNeighborhoodStats,
  calculateRadiographicPixelSpacing: () => calculateRadiographicPixelSpacing,
  calculateSpacingBetweenImageIds: () => calculateSpacingBetweenImageIds,
  calculateViewportsSpatialRegistration: () => calculateViewportsSpatialRegistration_default,
  calibratedPixelSpacingMetadataProvider: () => calibratedPixelSpacingMetadataProvider_default,
  clamp: () => clamp,
  clip: () => clip_default,
  color: () => color_exports,
  colormap: () => colormap_exports,
  convertColorArrayToRgbString: () => convertColorArrayToRgbString,
  convertStackToVolumeViewport: () => convertStackToVolumeViewport,
  convertToGrayscale: () => convertToGrayscale,
  convertVolumeToStackViewport: () => convertVolumeToStackViewport,
  createLinearRGBTransferFunction: () => createLinearRGBTransferFunction,
  createSigmoidRGBTransferFunction: () => createSigmoidRGBTransferFunction,
  createSubVolume: () => createSubVolume,
  decimate: () => decimate,
  deepClone: () => deepClone,
  deepEqual: () => deepEqual,
  deepMerge: () => deepMerge_default,
  eventListener: () => eventListener_exports,
  fnv1aHash: () => fnv1aHash,
  generateFrameImageId: () => generateFrameImageId,
  generateVolumePropsFromImageIds: () => generateVolumePropsFromImageIds,
  genericMetadataProvider: () => genericMetadataProvider_default,
  getBufferConfiguration: () => getBufferConfiguration,
  getClosestImageId: () => getClosestImageId,
  getClosestStackImageIndexForPoint: () => getClosestStackImageIndexForPoint,
  getCubeSizeInView: () => getCubeSizeInView,
  getCurrentVolumeViewportSlice: () => getCurrentVolumeViewportSlice,
  getDynamicVolumeInfo: () => getDynamicVolumeInfo_default,
  getERMF: () => getERMF,
  getImageDataMetadata: () => getImageDataMetadata,
  getImageLegacy: () => getImageLegacy_default,
  getImageSliceDataForVolumeViewport: () => getImageSliceDataForVolumeViewport_default,
  getMinMax: () => getMinMax,
  getNormalizedAspectRatio: () => getNormalizedAspectRatio,
  getPixelSpacingInformation: () => getPixelSpacingInformation,
  getRandomSampleFromArray: () => getRandomSampleFromArray,
  getRuntimeId: () => getRuntimeId,
  getScalingParameters: () => getScalingParameters,
  getSliceRange: () => getSliceRange,
  getSpacingInNormalDirection: () => getSpacingInNormalDirection,
  getTargetVolumeAndSpacingInNormalDir: () => getTargetVolumeAndSpacingInNormalDir,
  getViewportImageCornersInWorld: () => getViewportImageCornersInWorld,
  getViewportImageIds: () => getViewportImageIds_default,
  getViewportModality: () => getViewportModality,
  getViewportsWithImageURI: () => getViewportsWithImageURI,
  getViewportsWithVolumeId: () => getViewportsWithVolumeId_default,
  getVoiFromSigmoidRGBTransferFunction: () => getVoiFromSigmoidRGBTransferFunction,
  getVolumeActorCorners: () => getVolumeActorCorners,
  getVolumeDirectionVectors: () => getVolumeDirectionVectors,
  getVolumeId: () => getVolumeId,
  getVolumeSliceRangeInfo: () => getVolumeSliceRangeInfo_default,
  getVolumeViewportScrollInfo: () => getVolumeViewportScrollInfo_default,
  getVolumeViewportsContainingSameVolumes: () => getVolumeViewportsContainingSameVolumes_default,
  handleMultiframe4D: () => handleMultiframe4D,
  hasFloatScalingParameters: () => hasFloatScalingParameters,
  hasNaNValues: () => hasNaNValues,
  imageIdToURI: () => imageIdToURI,
  imageRetrieveMetadataProvider: () => imageRetrieveMetadataProvider_default,
  imageToWorldCoords: () => imageToWorldCoords,
  indexWithinDimensions: () => indexWithinDimensions,
  invertRgbTransferFunction: () => invertRgbTransferFunction,
  isEqual: () => isEqual,
  isEqualAbs: () => isEqualAbs,
  isEqualNegative: () => isEqualNegative,
  isImageActor: () => isImageActor,
  isNumber: () => isNumber,
  isOpposite: () => isOpposite,
  isPTPrescaledWithSUV: () => isPTPrescaledWithSUV_default,
  isValidVolume: () => isValidVolume,
  isVideoTransferSyntax: () => isVideoTransferSyntax,
  jumpToSlice: () => jumpToSlice,
  loadImageToCanvas: () => loadImageToCanvas,
  logger: () => logger_exports,
  makeVolumeMetadata: () => makeVolumeMetadata,
  planar: () => planar_exports,
  pointInShapeCallback: () => pointInShapeCallback,
  renderToCanvasCPU: () => renderToCanvasCPU,
  renderToCanvasGPU: () => renderToCanvasGPU,
  rotateToViewCoordinates: () => rotateToViewCoordinates,
  roundNumber: () => roundNumber_default,
  roundToPrecision: () => roundToPrecision,
  scaleArray: () => scaleArray,
  scaleRgbTransferFunction: () => scaleRGBTransferFunction,
  scroll: () => scroll,
  snapFocalPointToSlice: () => snapFocalPointToSlice,
  sortImageIdsAndGetSpacing: () => sortImageIdsAndGetSpacing,
  spatialRegistrationMetadataProvider: () => spatialRegistrationMetadataProvider_default,
  splitImageIdsBy4DTags: () => splitImageIdsBy4DTags_default,
  transferFunctionUtils: () => transferFunctionUtils_exports,
  transformIndexToWorld: () => transformIndexToWorld,
  transformWorldToIndex: () => transformWorldToIndex,
  transformWorldToIndexContinuous: () => transformWorldToIndexContinuous,
  triggerEvent: () => triggerEvent,
  updatePlaneRestriction: () => updatePlaneRestriction,
  updateVTKImageDataWithCornerstoneImage: () => updateVTKImageDataWithCornerstoneImage,
  uuidv4: () => uuidv4,
  windowLevel: () => windowLevel_exports,
  worldToImageCoords: () => worldToImageCoords_default
}), getViewportModality = (e12, t) => _getViewportModality(e12, t, cache_default.getVolume), imageRetrievalPoolManager = new RequestPoolManager("imageRetrievalPool");
imageRetrievalPoolManager.setMaxSimultaneousRequests(RequestType_default.Interaction, 200), imageRetrievalPoolManager.setMaxSimultaneousRequests(RequestType_default.Thumbnail, 200), imageRetrievalPoolManager.setMaxSimultaneousRequests(RequestType_default.Prefetch, 200), imageRetrievalPoolManager.grabDelay = 0;
var imageRetrievalPoolManager_default = imageRetrievalPoolManager, DEFAULT_SETTINGS = Symbol("DefaultSettings"), RUNTIME_SETTINGS = Symbol("RuntimeSettings"), OBJECT_SETTINGS_MAP = Symbol("ObjectSettingsMap"), DICTIONARY = Symbol("Dictionary"), Settings = class e10 {
  constructor(t) {
    let n = Object.create(t instanceof e10 && DICTIONARY in t ? t[DICTIONARY] : null);
    Object.seal(Object.defineProperty(this, DICTIONARY, { value: n }));
  }
  set(e12, t) {
    return set(this[DICTIONARY], e12, t, null);
  }
  get(e12) {
    return get$1(this[DICTIONARY], e12);
  }
  unset(e12) {
    return unset(this[DICTIONARY], e12 + "");
  }
  forEach(e12) {
    iterate(this[DICTIONARY], e12);
  }
  extend() {
    return new e10(this);
  }
  import(e12) {
    isPlainObject(e12) && Object.keys(e12).forEach((t) => {
      set(this[DICTIONARY], t, e12[t], null);
    });
  }
  dump() {
    let e12 = {};
    return iterate(this[DICTIONARY], (t, n) => {
      n !== void 0 && deepSet(e12, t, n);
    }), e12;
  }
  static assert(t) {
    return t instanceof e10 ? t : e10.getRuntimeSettings();
  }
  static getDefaultSettings(t = null) {
    let n = e10[DEFAULT_SETTINGS];
    if (n instanceof e10 || (n = new e10(), e10[DEFAULT_SETTINGS] = n), t) {
      let e12 = {};
      return n.forEach((r) => {
        if (r.startsWith(t)) {
          let a = r.split(`${t}.`)[1];
          e12[a] = n.get(r);
        }
      }), e12;
    }
    return n;
  }
  static getRuntimeSettings() {
    let t = e10[RUNTIME_SETTINGS];
    return t instanceof e10 || (t = new e10(e10.getDefaultSettings()), e10[RUNTIME_SETTINGS] = t), t;
  }
  static getObjectSettings(t, n) {
    let r = null;
    if (t instanceof e10)
      r = t;
    else if (typeof t == "object" && t) {
      let a = e10[OBJECT_SETTINGS_MAP];
      a instanceof WeakMap || (a = /* @__PURE__ */ new WeakMap(), e10[OBJECT_SETTINGS_MAP] = a), r = a.get(t), r instanceof e10 || (r = new e10(e10.assert(e10.getObjectSettings(n))), a.set(t, r));
    }
    return r;
  }
  static extendRuntimeSettings() {
    return e10.getRuntimeSettings().extend();
  }
};
function unset(e12, t) {
  if (t.endsWith(".")) {
    let n = 0, r = t, a = r.slice(0, -1), o = a.length === 0;
    for (let t2 in e12)
      Object.prototype.hasOwnProperty.call(e12, t2) && (o || t2.startsWith(r) || t2 === a) && (delete e12[t2], ++n);
    return n > 0;
  }
  return delete e12[t];
}
function iterate(e12, t) {
  for (let n in e12)
    t(n, e12[n]);
}
function setAll(e12, t, n, r) {
  let a;
  if (r.has(n))
    return set(e12, t, null, r);
  for (let o in r.add(n), a = 0, n)
    Object.prototype.hasOwnProperty.call(n, o) && (set(e12, o.length === 0 ? t : `${t}.${o}`, n[o], r) || ++a);
  return r.delete(n), a === 0;
}
function set(e12, t, n, r) {
  return isValidKey(t) ? isPlainObject(n) ? setAll(e12, t, n, r instanceof WeakSet ? r : /* @__PURE__ */ new WeakSet()) : (e12[t] = n, true) : false;
}
function get$1(e12, t) {
  return e12[t];
}
function isValidKey(e12) {
  let t, n, r;
  if (typeof e12 != "string" || (t = e12.length - 1) < 0)
    return false;
  for (r = -1; (n = e12.indexOf(".", r + 1)) >= 0; ) {
    if (n - r < 2 || n === t)
      return false;
    r = n;
  }
  return true;
}
function isPlainObject(e12) {
  if (typeof e12 == "object" && e12) {
    let t = Object.getPrototypeOf(e12);
    if (t === Object.prototype || t === null)
      return true;
  }
  return false;
}
function deepSet(e12, t, n) {
  let r = t.indexOf(".");
  if (r >= 0) {
    let a = t.slice(0, r), o = e12[a];
    if (typeof o != "object" || !o) {
      let t2 = o;
      o = {}, t2 !== void 0 && (o[""] = t2), e12[a] = o;
    }
    deepSet(o, t.slice(r + 1, t.length), n);
  } else
    e12[t] = n;
}
Settings.getDefaultSettings().set("useCursors", true);
function ascending(e12, t) {
  return e12 == null || t == null ? NaN : e12 < t ? -1 : e12 > t ? 1 : e12 >= t ? 0 : NaN;
}
function descending(e12, t) {
  return e12 == null || t == null ? NaN : t < e12 ? -1 : t > e12 ? 1 : t >= e12 ? 0 : NaN;
}
function bisector(e12) {
  let t, n, r;
  e12.length === 2 ? (t = e12 === ascending || e12 === descending ? e12 : zero$1, n = e12, r = e12) : (t = ascending, n = (t2, n2) => ascending(e12(t2), n2), r = (t2, n2) => e12(t2) - n2);
  function a(e13, r2, a2 = 0, o2 = e13.length) {
    if (a2 < o2) {
      if (t(r2, r2) !== 0)
        return o2;
      do {
        let t2 = a2 + o2 >>> 1;
        n(e13[t2], r2) < 0 ? a2 = t2 + 1 : o2 = t2;
      } while (a2 < o2);
    }
    return a2;
  }
  function o(e13, r2, a2 = 0, o2 = e13.length) {
    if (a2 < o2) {
      if (t(r2, r2) !== 0)
        return o2;
      do {
        let t2 = a2 + o2 >>> 1;
        n(e13[t2], r2) <= 0 ? a2 = t2 + 1 : o2 = t2;
      } while (a2 < o2);
    }
    return a2;
  }
  function s(e13, t2, n2 = 0, o2 = e13.length) {
    let s2 = a(e13, t2, n2, o2 - 1);
    return s2 > n2 && r(e13[s2 - 1], t2) > -r(e13[s2], t2) ? s2 - 1 : s2;
  }
  return {
    left: a,
    center: s,
    right: o
  };
}
function zero$1() {
  return 0;
}
function number$1(e12) {
  return e12 === null ? NaN : +e12;
}
var ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
ascendingBisect.left, bisector(number$1).center;
var bisect_default = bisectRight, e102 = Math.sqrt(50), e52 = Math.sqrt(10), e22 = Math.sqrt(2);
function tickSpec(e12, t, n) {
  let r = (t - e12) / Math.max(0, n), a = Math.floor(Math.log10(r)), o = r / 10 ** a, s = o >= e102 ? 10 : o >= e52 ? 5 : o >= e22 ? 2 : 1, c, l, u;
  return a < 0 ? (u = 10 ** -a / s, c = Math.round(e12 * u), l = Math.round(t * u), c / u < e12 && ++c, l / u > t && --l, u = -u) : (u = 10 ** a * s, c = Math.round(e12 / u), l = Math.round(t / u), c * u < e12 && ++c, l * u > t && --l), l < c && 0.5 <= n && n < 2 ? tickSpec(e12, t, n * 2) : [
    c,
    l,
    u
  ];
}
function ticks(e12, t, n) {
  if (t = +t, e12 = +e12, n = +n, !(n > 0))
    return [];
  if (e12 === t)
    return [e12];
  let r = t < e12, [a, o, s] = r ? tickSpec(t, e12, n) : tickSpec(e12, t, n);
  if (!(o >= a))
    return [];
  let c = o - a + 1, l = Array(c);
  if (r)
    if (s < 0)
      for (let e13 = 0; e13 < c; ++e13)
        l[e13] = (o - e13) / -s;
    else
      for (let e13 = 0; e13 < c; ++e13)
        l[e13] = (o - e13) * s;
  else if (s < 0)
    for (let e13 = 0; e13 < c; ++e13)
      l[e13] = (a + e13) / -s;
  else
    for (let e13 = 0; e13 < c; ++e13)
      l[e13] = (a + e13) * s;
  return l;
}
function tickIncrement(e12, t, n) {
  return t = +t, e12 = +e12, n = +n, tickSpec(e12, t, n)[2];
}
function tickStep(e12, t, n) {
  t = +t, e12 = +e12, n = +n;
  let r = t < e12, a = r ? tickIncrement(t, e12, n) : tickIncrement(e12, t, n);
  return (r ? -1 : 1) * (a < 0 ? 1 / -a : a);
}
function initRange(e12, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e12);
      break;
    default:
      this.range(t).domain(e12);
      break;
  }
  return this;
}
function define_default(e12, t, n) {
  e12.prototype = t.prototype = n, n.constructor = e12;
}
function extend$17(e12, t) {
  var n = Object.create(e12.prototype);
  for (var r in t)
    n[r] = t[r];
  return n;
}
function Color() {
}
var darker = 0.7, brighter = 1 / darker, reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = /* @__PURE__ */ RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = /* @__PURE__ */ RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = /* @__PURE__ */ RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = /* @__PURE__ */ RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = /* @__PURE__ */ RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = /* @__PURE__ */ RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`), named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define_default(Color, color, {
  copy(e12) {
    return Object.assign(new this.constructor(), this, e12);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(e12) {
  var t, n;
  return e12 = (e12 + "").trim().toLowerCase(), (t = reHex.exec(e12)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? rgbn(t) : n === 3 ? new Rgb(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? rgba(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? rgba(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = reRgbInteger.exec(e12)) ? new Rgb(t[1], t[2], t[3], 1) : (t = reRgbPercent.exec(e12)) ? new Rgb(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = reRgbaInteger.exec(e12)) ? rgba(t[1], t[2], t[3], t[4]) : (t = reRgbaPercent.exec(e12)) ? rgba(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = reHslPercent.exec(e12)) ? hsla(t[1], t[2] / 100, t[3] / 100, 1) : (t = reHslaPercent.exec(e12)) ? hsla(t[1], t[2] / 100, t[3] / 100, t[4]) : named.hasOwnProperty(e12) ? rgbn(named[e12]) : e12 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(e12) {
  return new Rgb(e12 >> 16 & 255, e12 >> 8 & 255, e12 & 255, 1);
}
function rgba(e12, t, n, r) {
  return r <= 0 && (e12 = t = n = NaN), new Rgb(e12, t, n, r);
}
function rgbConvert(e12) {
  return e12 instanceof Color || (e12 = color(e12)), e12 ? (e12 = e12.rgb(), new Rgb(e12.r, e12.g, e12.b, e12.opacity)) : new Rgb();
}
function rgb(e12, t, n, r) {
  return arguments.length === 1 ? rgbConvert(e12) : new Rgb(e12, t, n, r ?? 1);
}
function Rgb(e12, t, n, r) {
  this.r = +e12, this.g = +t, this.b = +n, this.opacity = +r;
}
define_default(Rgb, rgb, extend$17(Color, {
  brighter(e12) {
    return e12 = e12 == null ? brighter : brighter ** +e12, new Rgb(this.r * e12, this.g * e12, this.b * e12, this.opacity);
  },
  darker(e12) {
    return e12 = e12 == null ? darker : darker ** +e12, new Rgb(this.r * e12, this.g * e12, this.b * e12, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  let e12 = clampa(this.opacity);
  return `${e12 === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${e12 === 1 ? ")" : `, ${e12})`}`;
}
function clampa(e12) {
  return isNaN(e12) ? 1 : Math.max(0, Math.min(1, e12));
}
function clampi(e12) {
  return Math.max(0, Math.min(255, Math.round(e12) || 0));
}
function hex(e12) {
  return e12 = clampi(e12), (e12 < 16 ? "0" : "") + e12.toString(16);
}
function hsla(e12, t, n, r) {
  return r <= 0 ? e12 = t = n = NaN : n <= 0 || n >= 1 ? e12 = t = NaN : t <= 0 && (e12 = NaN), new Hsl(e12, t, n, r);
}
function hslConvert(e12) {
  if (e12 instanceof Hsl)
    return new Hsl(e12.h, e12.s, e12.l, e12.opacity);
  if (e12 instanceof Color || (e12 = color(e12)), !e12)
    return new Hsl();
  if (e12 instanceof Hsl)
    return e12;
  e12 = e12.rgb();
  var t = e12.r / 255, n = e12.g / 255, r = e12.b / 255, a = Math.min(t, n, r), o = Math.max(t, n, r), s = NaN, c = o - a, l = (o + a) / 2;
  return c ? (s = t === o ? (n - r) / c + (n < r) * 6 : n === o ? (r - t) / c + 2 : (t - n) / c + 4, c /= l < 0.5 ? o + a : 2 - o - a, s *= 60) : c = l > 0 && l < 1 ? 0 : s, new Hsl(s, c, l, e12.opacity);
}
function hsl(e12, t, n, r) {
  return arguments.length === 1 ? hslConvert(e12) : new Hsl(e12, t, n, r ?? 1);
}
function Hsl(e12, t, n, r) {
  this.h = +e12, this.s = +t, this.l = +n, this.opacity = +r;
}
define_default(Hsl, hsl, extend$17(Color, {
  brighter(e12) {
    return e12 = e12 == null ? brighter : brighter ** +e12, new Hsl(this.h, this.s, this.l * e12, this.opacity);
  },
  darker(e12) {
    return e12 = e12 == null ? darker : darker ** +e12, new Hsl(this.h, this.s, this.l * e12, this.opacity);
  },
  rgb() {
    var e12 = this.h % 360 + (this.h < 0) * 360, t = isNaN(e12) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, a = 2 * n - r;
    return new Rgb(hsl2rgb(e12 >= 240 ? e12 - 240 : e12 + 120, a, r), hsl2rgb(e12, a, r), hsl2rgb(e12 < 120 ? e12 + 240 : e12 - 120, a, r), this.opacity);
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    let e12 = clampa(this.opacity);
    return `${e12 === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${e12 === 1 ? ")" : `, ${e12})`}`;
  }
}));
function clamph(e12) {
  return e12 = (e12 || 0) % 360, e12 < 0 ? e12 + 360 : e12;
}
function clampt(e12) {
  return Math.max(0, Math.min(1, e12 || 0));
}
function hsl2rgb(e12, t, n) {
  return (e12 < 60 ? t + (n - t) * e12 / 60 : e12 < 180 ? n : e12 < 240 ? t + (n - t) * (240 - e12) / 60 : t) * 255;
}
function basis(e12, t, n, r, a) {
  var o = e12 * e12, s = o * e12;
  return ((1 - 3 * e12 + 3 * o - s) * t + (4 - 6 * o + 3 * s) * n + (1 + 3 * e12 + 3 * o - 3 * s) * r + s * a) / 6;
}
function basis_default(e12) {
  var t = e12.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, t - 1) : Math.floor(n * t), a = e12[r], o = e12[r + 1], s = r > 0 ? e12[r - 1] : 2 * a - o, c = r < t - 1 ? e12[r + 2] : 2 * o - a;
    return basis((n - r / t) * t, s, a, o, c);
  };
}
var constant_default = (e12) => () => e12;
function linear$1(e12, t) {
  return function(n) {
    return e12 + n * t;
  };
}
function exponential(e12, t, n) {
  return e12 **= +n, t = t ** +n - e12, n = 1 / n, function(r) {
    return (e12 + r * t) ** +n;
  };
}
function gamma(e12) {
  return (e12 = +e12) == 1 ? nogamma : function(t, n) {
    return n - t ? exponential(t, n, e12) : constant_default(isNaN(t) ? n : t);
  };
}
function nogamma(e12, t) {
  var n = t - e12;
  return n ? linear$1(e12, n) : constant_default(isNaN(e12) ? t : e12);
}
var rgb_default = function e11(t) {
  var n = gamma(t);
  function r(e12, t2) {
    var r2 = n((e12 = rgb(e12)).r, (t2 = rgb(t2)).r), a = n(e12.g, t2.g), o = n(e12.b, t2.b), s = nogamma(e12.opacity, t2.opacity);
    return function(t3) {
      return e12.r = r2(t3), e12.g = a(t3), e12.b = o(t3), e12.opacity = s(t3), e12 + "";
    };
  }
  return r.gamma = e11, r;
}(1);
function numberArray_default(e12, t) {
  t ||= [];
  var n = e12 ? Math.min(t.length, e12.length) : 0, r = t.slice(), a;
  return function(o) {
    for (a = 0; a < n; ++a)
      r[a] = e12[a] * (1 - o) + t[a] * o;
    return r;
  };
}
function isNumberArray(e12) {
  return ArrayBuffer.isView(e12) && !(e12 instanceof DataView);
}
function genericArray(e12, t) {
  var n = t ? t.length : 0, r = e12 ? Math.min(n, e12.length) : 0, a = Array(r), o = Array(n), s;
  for (s = 0; s < r; ++s)
    a[s] = value_default(e12[s], t[s]);
  for (; s < n; ++s)
    o[s] = t[s];
  return function(e13) {
    for (s = 0; s < r; ++s)
      o[s] = a[s](e13);
    return o;
  };
}
function date_default(e12, t) {
  var n = /* @__PURE__ */ new Date();
  return e12 = +e12, t = +t, function(r) {
    return n.setTime(e12 * (1 - r) + t * r), n;
  };
}
function number_default(e12, t) {
  return e12 = +e12, t = +t, function(n) {
    return e12 * (1 - n) + t * n;
  };
}
function object_default(e12, t) {
  var n = {}, r = {}, a;
  for (a in (typeof e12 != "object" || !e12) && (e12 = {}), (typeof t != "object" || !t) && (t = {}), t)
    a in e12 ? n[a] = value_default(e12[a], t[a]) : r[a] = t[a];
  return function(e13) {
    for (a in n)
      r[a] = n[a](e13);
    return r;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(e12) {
  return function() {
    return e12;
  };
}
function one(e12) {
  return function(t) {
    return e12(t) + "";
  };
}
function string_default(e12, t) {
  var n = reA.lastIndex = reB.lastIndex = 0, r, a, o, s = -1, c = [], l = [];
  for (e12 += "", t += ""; (r = reA.exec(e12)) && (a = reB.exec(t)); )
    (o = a.index) > n && (o = t.slice(n, o), c[s] ? c[s] += o : c[++s] = o), (r = r[0]) === (a = a[0]) ? c[s] ? c[s] += a : c[++s] = a : (c[++s] = null, l.push({
      i: s,
      x: number_default(r, a)
    })), n = reB.lastIndex;
  return n < t.length && (o = t.slice(n), c[s] ? c[s] += o : c[++s] = o), c.length < 2 ? l[0] ? one(l[0].x) : zero(t) : (t = l.length, function(e13) {
    for (var n2 = 0, r2; n2 < t; ++n2)
      c[(r2 = l[n2]).i] = r2.x(e13);
    return c.join("");
  });
}
function value_default(e12, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? constant_default(t) : (n === "number" ? number_default : n === "string" ? (r = color(t)) ? (t = r, rgb_default) : string_default : t instanceof color ? rgb_default : t instanceof Date ? date_default : isNumberArray(t) ? numberArray_default : Array.isArray(t) ? genericArray : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? object_default : number_default)(e12, t);
}
function round_default(e12, t) {
  return e12 = +e12, t = +t, function(n) {
    return Math.round(e12 * (1 - n) + t * n);
  };
}
function constants(e12) {
  return function() {
    return e12;
  };
}
function number(e12) {
  return +e12;
}
var unit = [0, 1];
function identity(e12) {
  return e12;
}
function normalize(e12, t) {
  return (t -= e12 = +e12) ? function(n) {
    return (n - e12) / t;
  } : constants(isNaN(t) ? NaN : 0.5);
}
function clamper(e12, t) {
  var n;
  return e12 > t && (n = e12, e12 = t, t = n), function(n2) {
    return Math.max(e12, Math.min(t, n2));
  };
}
function bimap(e12, t, n) {
  var r = e12[0], a = e12[1], o = t[0], s = t[1];
  return a < r ? (r = normalize(a, r), o = n(s, o)) : (r = normalize(r, a), o = n(o, s)), function(e13) {
    return o(r(e13));
  };
}
function polymap(e12, t, n) {
  var r = Math.min(e12.length, t.length) - 1, a = Array(r), o = Array(r), s = -1;
  for (e12[r] < e12[0] && (e12 = e12.slice().reverse(), t = t.slice().reverse()); ++s < r; )
    a[s] = normalize(e12[s], e12[s + 1]), o[s] = n(t[s], t[s + 1]);
  return function(t2) {
    var n2 = bisect_default(e12, t2, 1, r) - 1;
    return o[n2](a[n2](t2));
  };
}
function copy(e12, t) {
  return t.domain(e12.domain()).range(e12.range()).interpolate(e12.interpolate()).clamp(e12.clamp()).unknown(e12.unknown());
}
function transformer() {
  var e12 = unit, t = unit, n = value_default, r, a, o, s = identity, c, l, u;
  function d() {
    var n2 = Math.min(e12.length, t.length);
    return s !== identity && (s = clamper(e12[0], e12[n2 - 1])), c = n2 > 2 ? polymap : bimap, l = u = null, f;
  }
  function f(a2) {
    return a2 == null || isNaN(a2 = +a2) ? o : (l ||= c(e12.map(r), t, n))(r(s(a2)));
  }
  return f.invert = function(n2) {
    return s(a((u ||= c(t, e12.map(r), number_default))(n2)));
  }, f.domain = function(t2) {
    return arguments.length ? (e12 = Array.from(t2, number), d()) : e12.slice();
  }, f.range = function(e13) {
    return arguments.length ? (t = Array.from(e13), d()) : t.slice();
  }, f.rangeRound = function(e13) {
    return t = Array.from(e13), n = round_default, d();
  }, f.clamp = function(e13) {
    return arguments.length ? (s = e13 ? true : identity, d()) : s !== identity;
  }, f.interpolate = function(e13) {
    return arguments.length ? (n = e13, d()) : n;
  }, f.unknown = function(e13) {
    return arguments.length ? (o = e13, f) : o;
  }, function(e13, t2) {
    return r = e13, a = t2, d();
  };
}
function continuous() {
  return transformer()(identity, identity);
}
function formatDecimal_default(e12) {
  return Math.abs(e12 = Math.round(e12)) >= 1e21 ? e12.toLocaleString("en").replace(/,/g, "") : e12.toString(10);
}
function formatDecimalParts(e12, t) {
  if (!isFinite(e12) || e12 === 0)
    return null;
  var n = (e12 = t ? e12.toExponential(t - 1) : e12.toExponential()).indexOf("e"), r = e12.slice(0, n);
  return [r.length > 1 ? r[0] + r.slice(2) : r, +e12.slice(n + 1)];
}
function exponent_default(e12) {
  return e12 = formatDecimalParts(Math.abs(e12)), e12 ? e12[1] : NaN;
}
function formatGroup_default(e12, t) {
  return function(n, r) {
    for (var a = n.length, o = [], s = 0, c = e12[0], l = 0; a > 0 && c > 0 && (l + c + 1 > r && (c = Math.max(1, r - l)), o.push(n.substring(a -= c, a + c)), !((l += c + 1) > r)); )
      c = e12[s = (s + 1) % e12.length];
    return o.reverse().join(t);
  };
}
function formatNumerals_default(e12) {
  return function(t) {
    return t.replace(/[0-9]/g, function(t2) {
      return e12[+t2];
    });
  };
}
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(e12) {
  if (!(t = re.exec(e12)))
    throw Error("invalid format: " + e12);
  var t;
  return new FormatSpecifier({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(e12) {
  this.fill = e12.fill === void 0 ? " " : e12.fill + "", this.align = e12.align === void 0 ? ">" : e12.align + "", this.sign = e12.sign === void 0 ? "-" : e12.sign + "", this.symbol = e12.symbol === void 0 ? "" : e12.symbol + "", this.zero = !!e12.zero, this.width = e12.width === void 0 ? void 0 : +e12.width, this.comma = !!e12.comma, this.precision = e12.precision === void 0 ? void 0 : +e12.precision, this.trim = !!e12.trim, this.type = e12.type === void 0 ? "" : e12.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim_default(e12) {
  out:
    for (var t = e12.length, n = 1, r = -1, a; n < t; ++n)
      switch (e12[n]) {
        case ".":
          r = a = n;
          break;
        case "0":
          r === 0 && (r = n), a = n;
          break;
        default:
          if (!+e12[n])
            break out;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? e12.slice(0, r) + e12.slice(a + 1) : e12;
}
var prefixExponent;
function formatPrefixAuto_default(e12, t) {
  var n = formatDecimalParts(e12, t);
  if (!n)
    return prefixExponent = void 0, e12.toPrecision(t);
  var r = n[0], a = n[1], o = a - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, s = r.length;
  return o === s ? r : o > s ? r + Array(o - s + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + Array(1 - o).join("0") + formatDecimalParts(e12, Math.max(0, t + o - 1))[0];
}
function formatRounded_default(e12, t) {
  var n = formatDecimalParts(e12, t);
  if (!n)
    return e12 + "";
  var r = n[0], a = n[1];
  return a < 0 ? "0." + Array(-a).join("0") + r : r.length > a + 1 ? r.slice(0, a + 1) + "." + r.slice(a + 1) : r + Array(a - r.length + 2).join("0");
}
var formatTypes_default = {
  "%": (e12, t) => (e12 * 100).toFixed(t),
  b: (e12) => Math.round(e12).toString(2),
  c: (e12) => e12 + "",
  d: formatDecimal_default,
  e: (e12, t) => e12.toExponential(t),
  f: (e12, t) => e12.toFixed(t),
  g: (e12, t) => e12.toPrecision(t),
  o: (e12) => Math.round(e12).toString(8),
  p: (e12, t) => formatRounded_default(e12 * 100, t),
  r: formatRounded_default,
  s: formatPrefixAuto_default,
  X: (e12) => Math.round(e12).toString(16).toUpperCase(),
  x: (e12) => Math.round(e12).toString(16)
};
function identity_default(e12) {
  return e12;
}
var map = Array.prototype.map, prefixes = [
  "y",
  "z",
  "a",
  "f",
  "p",
  "n",
  "\xB5",
  "m",
  "",
  "k",
  "M",
  "G",
  "T",
  "P",
  "E",
  "Z",
  "Y"
];
function locale_default(e12) {
  var t = e12.grouping === void 0 || e12.thousands === void 0 ? identity_default : formatGroup_default(map.call(e12.grouping, Number), e12.thousands + ""), n = e12.currency === void 0 ? "" : e12.currency[0] + "", r = e12.currency === void 0 ? "" : e12.currency[1] + "", a = e12.decimal === void 0 ? "." : e12.decimal + "", o = e12.numerals === void 0 ? identity_default : formatNumerals_default(map.call(e12.numerals, String)), s = e12.percent === void 0 ? "%" : e12.percent + "", c = e12.minus === void 0 ? "\u2212" : e12.minus + "", l = e12.nan === void 0 ? "NaN" : e12.nan + "";
  function u(e13, u2) {
    e13 = formatSpecifier(e13);
    var d2 = e13.fill, f = e13.align, p = e13.sign, m = e13.symbol, h = e13.zero, g = e13.width, _ = e13.comma, v = e13.precision, y = e13.trim, b = e13.type;
    b === "n" ? (_ = true, b = "g") : formatTypes_default[b] || (v === void 0 && (v = 12), y = true, b = "g"), (h || d2 === "0" && f === "=") && (h = true, d2 = "0", f = "=");
    var S = (u2 && u2.prefix !== void 0 ? u2.prefix : "") + (m === "$" ? n : m === "#" && /[boxX]/.test(b) ? "0" + b.toLowerCase() : ""), C = (m === "$" ? r : /[%p]/.test(b) ? s : "") + (u2 && u2.suffix !== void 0 ? u2.suffix : ""), w = formatTypes_default[b], T = /[defgprs%]/.test(b);
    v = v === void 0 ? 6 : /[gprs]/.test(b) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v));
    function E(e14) {
      var n2 = S, r2 = C, s2, u3, m2;
      if (b === "c")
        r2 = w(e14) + r2, e14 = "";
      else {
        e14 = +e14;
        var E2 = e14 < 0 || 1 / e14 < 0;
        if (e14 = isNaN(e14) ? l : w(Math.abs(e14), v), y && (e14 = formatTrim_default(e14)), E2 && +e14 == 0 && p !== "+" && (E2 = false), n2 = (E2 ? p === "(" ? p : c : p === "-" || p === "(" ? "" : p) + n2, r2 = (b === "s" && !isNaN(e14) && prefixExponent !== void 0 ? prefixes[8 + prefixExponent / 3] : "") + r2 + (E2 && p === "(" ? ")" : ""), T) {
          for (s2 = -1, u3 = e14.length; ++s2 < u3; )
            if (m2 = e14.charCodeAt(s2), 48 > m2 || m2 > 57) {
              r2 = (m2 === 46 ? a + e14.slice(s2 + 1) : e14.slice(s2)) + r2, e14 = e14.slice(0, s2);
              break;
            }
        }
      }
      _ && !h && (e14 = t(e14, Infinity));
      var D = n2.length + e14.length + r2.length, O = D < g ? Array(g - D + 1).join(d2) : "";
      switch (_ && h && (e14 = t(O + e14, O.length ? g - r2.length : Infinity), O = ""), f) {
        case "<":
          e14 = n2 + e14 + r2 + O;
          break;
        case "=":
          e14 = n2 + O + e14 + r2;
          break;
        case "^":
          e14 = O.slice(0, D = O.length >> 1) + n2 + e14 + r2 + O.slice(D);
          break;
        default:
          e14 = O + n2 + e14 + r2;
          break;
      }
      return o(e14);
    }
    return E.toString = function() {
      return e13 + "";
    }, E;
  }
  function d(e13, t2) {
    var n2 = Math.max(-8, Math.min(8, Math.floor(exponent_default(t2) / 3))) * 3, r2 = 10 ** -n2, a2 = u((e13 = formatSpecifier(e13), e13.type = "f", e13), { suffix: prefixes[8 + n2 / 3] });
    return function(e14) {
      return a2(r2 * e14);
    };
  }
  return {
    format: u,
    formatPrefix: d
  };
}
var locale, format, formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale(e12) {
  return locale = locale_default(e12), format = locale.format, formatPrefix = locale.formatPrefix, locale;
}
function precisionFixed_default(e12) {
  return Math.max(0, -exponent_default(Math.abs(e12)));
}
function precisionPrefix_default(e12, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent_default(t) / 3))) * 3 - exponent_default(Math.abs(e12)));
}
function precisionRound_default(e12, t) {
  return e12 = Math.abs(e12), t = Math.abs(t) - e12, Math.max(0, exponent_default(t) - exponent_default(e12)) + 1;
}
function tickFormat(e12, t, n, r) {
  var a = tickStep(e12, t, n), o;
  switch (r = formatSpecifier(r ?? ",f"), r.type) {
    case "s":
      var s = Math.max(Math.abs(e12), Math.abs(t));
      return r.precision == null && !isNaN(o = precisionPrefix_default(a, s)) && (r.precision = o), formatPrefix(r, s);
    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      r.precision == null && !isNaN(o = precisionRound_default(a, Math.max(Math.abs(e12), Math.abs(t)))) && (r.precision = o - (r.type === "e"));
      break;
    case "f":
    case "%":
      r.precision == null && !isNaN(o = precisionFixed_default(a)) && (r.precision = o - (r.type === "%") * 2);
      break;
  }
  return format(r);
}
function linearish(e12) {
  var t = e12.domain;
  return e12.ticks = function(e13) {
    var n = t();
    return ticks(n[0], n[n.length - 1], e13 ?? 10);
  }, e12.tickFormat = function(e13, n) {
    var r = t();
    return tickFormat(r[0], r[r.length - 1], e13 ?? 10, n);
  }, e12.nice = function(n) {
    n ??= 10;
    var r = t(), a = 0, o = r.length - 1, s = r[a], c = r[o], l, u, d = 10;
    for (c < s && (u = s, s = c, c = u, u = a, a = o, o = u); d-- > 0; ) {
      if (u = tickIncrement(s, c, n), u === l)
        return r[a] = s, r[o] = c, t(r);
      if (u > 0)
        s = Math.floor(s / u) * u, c = Math.ceil(c / u) * u;
      else if (u < 0)
        s = Math.ceil(s * u) / u, c = Math.floor(c * u) / u;
      else
        break;
      l = u;
    }
    return e12;
  }, e12;
}
function linear() {
  var e12 = continuous();
  return e12.copy = function() {
    return copy(e12, linear());
  }, initRange.apply(e12, arguments), linearish(e12);
}
function vtkTexture(e12, t) {
  t.classHierarchy.push("vtkTexture"), e12.imageLoaded = () => {
    t.image.removeEventListener("load", e12.imageLoaded), t.imageLoaded = true, e12.modified();
  }, e12.setJsImageData = (n) => {
    t.jsImageData !== n && (n !== null && (e12.setInputData(null), e12.setInputConnection(null), t.image = null, t.canvas = null, t.imageBitmap = null), t.jsImageData = n, t.imageLoaded = true, e12.modified());
  }, e12.setImageBitmap = (n) => {
    t.imageBitmap !== n && (n !== null && (e12.setInputData(null), e12.setInputConnection(null), t.image = null, t.canvas = null, t.jsImageData = null), t.imageBitmap = n, t.imageLoaded = true, e12.modified());
  }, e12.setCanvas = (n) => {
    t.canvas !== n && (n !== null && (e12.setInputData(null), e12.setInputConnection(null), t.image = null, t.imageBitmap = null, t.jsImageData = null), t.canvas = n, e12.modified());
  }, e12.setImage = (n) => {
    t.image !== n && (n !== null && (e12.setInputData(null), e12.setInputConnection(null), t.canvas = null, t.jsImageData = null, t.imageBitmap = null), t.image = n, t.imageLoaded = false, n.complete ? e12.imageLoaded() : n.addEventListener("load", e12.imageLoaded), e12.modified());
  }, e12.getDimensionality = () => {
    let n = 0, r = 0, a = 1;
    if (e12.getInputData()) {
      let t2 = e12.getInputData();
      n = t2.getDimensions()[0], r = t2.getDimensions()[1], a = t2.getDimensions()[2];
    }
    return t.jsImageData && (n = t.jsImageData.width, r = t.jsImageData.height), t.canvas && (n = t.canvas.width, r = t.canvas.height), t.image && (n = t.image.width, r = t.image.height), t.imageBitmap && (n = t.imageBitmap.width, r = t.imageBitmap.height), (n > 1) + (r > 1) + (a > 1);
  }, e12.getInputAsJsImageData = () => {
    if (!t.imageLoaded || e12.getInputData())
      return null;
    if (t.jsImageData)
      return t.jsImageData;
    if (t.imageBitmap)
      return t.imageBitmap;
    if (t.canvas)
      return t.canvas.getContext("2d").getImageData(0, 0, t.canvas.width, t.canvas.height);
    if (t.image) {
      let e13 = t.image.width, n = t.image.height, r = new OffscreenCanvas(e13, n).getContext("2d");
      return r.translate(0, n), r.scale(1, -1), r.drawImage(t.image, 0, 0, e13, n), r.getImageData(0, 0, e13, n);
    }
    return null;
  };
}
var generateMipmaps = (e12, t, n) => {
  let r = e12.createShaderModule({ code: "\n    @group(0) @binding(0) var inputTexture: texture_2d<f32>;\n    @group(0) @binding(1) var outputTexture: texture_storage_2d<rgba8unorm, write>;\n\n    @compute @workgroup_size(8, 8)\n    fn main(@builtin(global_invocation_id) global_id: vec3<u32>) {\n      let texelCoord = vec2<i32>(global_id.xy);\n      let outputSize = textureDimensions(outputTexture);\n\n      if (texelCoord.x >= i32(outputSize.x) || texelCoord.y >= i32(outputSize.y)) {\n        return;\n      }\n\n      let inputSize = textureDimensions(inputTexture);\n      let scale = vec2<f32>(inputSize) / vec2<f32>(outputSize);\n\n      // Compute the floating-point source coordinate\n      let srcCoord = (vec2<f32>(texelCoord) + 0.5) * scale - 0.5;\n\n      // Get integer coordinates for the four surrounding texels\n      let x0 = i32(floor(srcCoord.x));\n      let x1 = min(x0 + 1, i32(inputSize.x) - 1);\n      let y0 = i32(floor(srcCoord.y));\n      let y1 = min(y0 + 1, i32(inputSize.y) - 1);\n\n      // Compute the weights\n      let wx = srcCoord.x - f32(x0);\n      let wy = srcCoord.y - f32(y0);\n\n      // Fetch the four texels\n      let c00 = textureLoad(inputTexture, vec2<i32>(x0, y0), 0);\n      let c10 = textureLoad(inputTexture, vec2<i32>(x1, y0), 0);\n      let c01 = textureLoad(inputTexture, vec2<i32>(x0, y1), 0);\n      let c11 = textureLoad(inputTexture, vec2<i32>(x1, y1), 0);\n\n      // Bilinear interpolation\n      let color = mix(\n        mix(c00, c10, wx),\n        mix(c01, c11, wx),\n        wy\n      );\n\n      textureStore(outputTexture, texelCoord, color);\n    }\n  " }), a = e12.createBindGroupLayout({ entries: [
    {
      binding: 0,
      visibility: GPUShaderStage.COMPUTE,
      texture: { sampleType: "float" }
    },
    {
      binding: 1,
      visibility: GPUShaderStage.COMPUTE,
      storageTexture: {
        format: "rgba8unorm",
        access: "write-only"
      }
    },
    {
      binding: 2,
      visibility: GPUShaderStage.COMPUTE,
      sampler: { type: "filtering" }
    }
  ] }), o = e12.createPipelineLayout({ bindGroupLayouts: [a] }), s = e12.createComputePipeline({
    label: "ComputeMipmapPipeline",
    layout: o,
    compute: {
      module: r,
      entryPoint: "main"
    }
  }), c = e12.createSampler({
    magFilter: "linear",
    minFilter: "linear"
  });
  for (let r2 = 1; r2 < n; r2++) {
    let n2 = t.createView({
      baseMipLevel: r2 - 1,
      mipLevelCount: 1
    }), a2 = t.createView({
      baseMipLevel: r2,
      mipLevelCount: 1
    }), o2 = e12.createBindGroup({
      layout: s.getBindGroupLayout(0),
      entries: [
        {
          binding: 0,
          resource: n2
        },
        {
          binding: 1,
          resource: a2
        },
        {
          binding: 2,
          resource: c
        }
      ]
    }), l = e12.createCommandEncoder({ label: "MipmapGenerateCommandEncoder" }), u = l.beginComputePass();
    u.setPipeline(s), u.setBindGroup(0, o2);
    let d = Math.max(1, t.width >> r2), f = Math.max(1, t.height >> r2), p = Math.ceil(d / 8), m = Math.ceil(f / 8);
    u.dispatchWorkgroups(p, m), u.end(), e12.queue.submit([l.finish()]);
  }
}, DEFAULT_VALUES$13 = {
  image: null,
  canvas: null,
  jsImageData: null,
  imageBitmap: null,
  imageLoaded: false,
  repeat: false,
  interpolate: false,
  edgeClamp: false,
  mipLevel: 0,
  resizable: false
};
function extend$16(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$13, n), macro.obj(e12, t), macro.algo(e12, t, 6, 0), macro.get(e12, t, [
    "canvas",
    "image",
    "jsImageData",
    "imageBitmap",
    "imageLoaded",
    "resizable"
  ]), macro.setGet(e12, t, [
    "repeat",
    "edgeClamp",
    "interpolate",
    "mipLevel"
  ]), vtkTexture(e12, t);
}
var newInstance$17 = macro.newInstance(extend$16, "vtkTexture"), STATIC = { generateMipmaps }, vtkTexture$1 = {
  newInstance: newInstance$17,
  extend: extend$16,
  ...STATIC
}, faceNormals = [
  [
    -1,
    0,
    0
  ],
  [
    1,
    0,
    0
  ],
  [
    0,
    -1,
    0
  ],
  [
    0,
    1,
    0
  ],
  [
    0,
    0,
    -1
  ],
  [
    0,
    0,
    1
  ]
], faceEdges = [
  [
    8,
    7,
    11,
    3
  ],
  [
    9,
    1,
    10,
    5
  ],
  [
    4,
    9,
    0,
    8
  ],
  [
    2,
    11,
    6,
    10
  ],
  [
    0,
    3,
    2,
    1
  ],
  [
    4,
    5,
    6,
    7
  ]
], edgePoints = [
  [0, 1],
  [1, 3],
  [2, 3],
  [0, 2],
  [4, 5],
  [5, 7],
  [6, 7],
  [4, 6],
  [0, 4],
  [1, 5],
  [3, 7],
  [2, 6]
], edgeAxes = [
  0,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  2,
  2,
  2,
  2
], faceAxes = [
  [1, 2],
  [1, 2],
  [0, 2],
  [0, 2],
  [0, 1],
  [0, 1]
], ptv3 = new Float64Array(3), pt2v3 = new Float64Array(3), tmpv3 = new Float64Array(3), tmp2v3 = new Float64Array(3), xDir = new Float64Array(3), yDir = new Float64Array(3), invmat = new Float64Array(16);
function applyTextStyle$1(e12, t) {
  e12.strokeStyle = t.strokeColor, e12.lineWidth = t.strokeSize, e12.fillStyle = t.fontColor, e12.font = `${t.fontStyle} ${t.fontSize}px ${t.fontFamily}`;
}
function defaultGenerateTicks$1(e12) {
  let t = [], n = [];
  for (let r = 0; r < 3; r++) {
    let a = linear().domain([e12[r * 2], e12[r * 2 + 1]]);
    t[r] = a.ticks(5);
    let o = a.tickFormat(5);
    n[r] = t[r].map(o);
  }
  return {
    ticks: t,
    tickStrings: n
  };
}
function vtkCubeAxesActorHelper(e12, t) {
  t.classHierarchy.push("vtkCubeAxesActorHelper"), e12.setRenderable = (n) => {
    t.renderable !== n && (t.renderable = n, t.tmActor.addTexture(t.renderable.getTmTexture()), t.tmActor.setProperty(n.getProperty()), t.tmActor.setParentProp(n), e12.modified());
  }, e12.createPolyDataForOneLabel = (e13, n, r, a, o, s, c) => {
    let l = t.renderable.get_tmAtlas().get(e13);
    if (!l)
      return;
    let u = t.renderable.getTextPolyData().getPoints().getData(), d = t.lastSize;
    ptv3[0] = u[n * 3], ptv3[1] = u[n * 3 + 1], ptv3[2] = u[n * 3 + 2], transformMat4$1(tmpv3, ptv3, r), tmpv3[0] += 0.1, transformMat4$1(pt2v3, tmpv3, a), subtract$3(xDir, pt2v3, ptv3), tmpv3[0] -= 0.1, tmpv3[1] += 0.1, transformMat4$1(pt2v3, tmpv3, a), subtract$3(yDir, pt2v3, ptv3);
    for (let e14 = 0; e14 < 3; e14++)
      xDir[e14] /= 0.5 * 0.1 * d[0], yDir[e14] /= 0.5 * 0.1 * d[1];
    let f = c.ptIdx, p = c.cellIdx;
    ptv3[0] = u[n * 3], ptv3[1] = u[n * 3 + 1], ptv3[2] = u[n * 3 + 2], o[0] < -0.5 ? scale$3(tmpv3, xDir, o[0] * s - l.width) : o[0] > 0.5 ? scale$3(tmpv3, xDir, o[0] * s) : scale$3(tmpv3, xDir, o[0] * s - l.width / 2), add$4(ptv3, ptv3, tmpv3), scale$3(tmpv3, yDir, o[1] * s - l.height / 2), add$4(ptv3, ptv3, tmpv3), c.points[f * 3] = ptv3[0], c.points[f * 3 + 1] = ptv3[1], c.points[f * 3 + 2] = ptv3[2], c.tcoords[f * 2] = l.tcoords[0], c.tcoords[f * 2 + 1] = l.tcoords[1], f++, scale$3(tmpv3, xDir, l.width), add$4(ptv3, ptv3, tmpv3), c.points[f * 3] = ptv3[0], c.points[f * 3 + 1] = ptv3[1], c.points[f * 3 + 2] = ptv3[2], c.tcoords[f * 2] = l.tcoords[2], c.tcoords[f * 2 + 1] = l.tcoords[3], f++, scale$3(tmpv3, yDir, l.height), add$4(ptv3, ptv3, tmpv3), c.points[f * 3] = ptv3[0], c.points[f * 3 + 1] = ptv3[1], c.points[f * 3 + 2] = ptv3[2], c.tcoords[f * 2] = l.tcoords[4], c.tcoords[f * 2 + 1] = l.tcoords[5], f++, scale$3(tmpv3, xDir, l.width), subtract$3(ptv3, ptv3, tmpv3), c.points[f * 3] = ptv3[0], c.points[f * 3 + 1] = ptv3[1], c.points[f * 3 + 2] = ptv3[2], c.tcoords[f * 2] = l.tcoords[6], c.tcoords[f * 2 + 1] = l.tcoords[7], f++, c.polys[p * 4] = 3, c.polys[p * 4 + 1] = f - 4, c.polys[p * 4 + 2] = f - 3, c.polys[p * 4 + 3] = f - 2, p++, c.polys[p * 4] = 3, c.polys[p * 4 + 1] = f - 4, c.polys[p * 4 + 2] = f - 2, c.polys[p * 4 + 3] = f - 1, c.ptIdx += 4, c.cellIdx += 2;
  }, e12.updateTexturePolyData = () => {
    let n = t.camera.getCompositeProjectionMatrix(t.lastAspectRatio, -1, 1);
    transpose(n, n);
    let r = t.renderable.getTextValues().length, a = r * 4, o = r * 2, s = new Float64Array(a * 3), c = new Uint16Array(o * 4), l = new Float32Array(a * 2);
    invert(invmat, n);
    let u = {
      ptIdx: 0,
      cellIdx: 0,
      polys: c,
      points: s,
      tcoords: l
    }, d = 0, f = 0, p = 0, m = t.renderable.getTextPolyData().getPoints().getData(), h = t.renderable.getTextValues();
    for (; d < m.length / 3; ) {
      ptv3[0] = m[d * 3], ptv3[1] = m[d * 3 + 1], ptv3[2] = m[d * 3 + 2], transformMat4$1(tmpv3, ptv3, n), ptv3[0] = m[d * 3 + 3], ptv3[1] = m[d * 3 + 4], ptv3[2] = m[d * 3 + 5], transformMat4$1(tmp2v3, ptv3, n), subtract$3(tmpv3, tmpv3, tmp2v3);
      let r2 = [tmpv3[0], tmpv3[1]];
      normalize2D(r2), e12.createPolyDataForOneLabel(h[f], d, n, invmat, r2, t.renderable.getAxisTitlePixelOffset(), u), d += 2, f++;
      for (let a2 = 0; a2 < t.renderable.getTickCounts()[p]; a2++)
        e12.createPolyDataForOneLabel(h[f], d, n, invmat, r2, t.renderable.getTickLabelPixelOffset(), u), d++, f++;
      p++;
    }
    let g = vtkDataArray$1.newInstance({
      numberOfComponents: 2,
      values: l,
      name: "TextureCoordinates"
    });
    t.tmPolyData.getPointData().setTCoords(g), t.tmPolyData.getPoints().setData(s, 3), t.tmPolyData.getPoints().modified(), t.tmPolyData.getPolys().setData(c, 1), t.tmPolyData.getPolys().modified(), t.tmPolyData.modified();
  }, e12.updateAPISpecificData = (n, r, a) => {
    (t.lastSize[0] !== n[0] || t.lastSize[1] !== n[1]) && (t.lastSize[0] = n[0], t.lastSize[1] = n[1], t.lastAspectRatio = n[0] / n[1], t.forceUpdate = true), t.camera = r, e12.updateTexturePolyData();
  };
}
var newCubeAxesActorHelper = macro.newInstance(function(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { renderable: null };
  Object.assign(t, {}, n), macro.obj(e12, t), t.tmPolyData = vtkPolyData$1.newInstance(), t.tmMapper = vtkMapper$1.newInstance(), t.tmMapper.setInputData(t.tmPolyData), t.tmActor = vtkActor$1.newInstance({ parentProp: e12 }), t.tmActor.setMapper(t.tmMapper), macro.setGet(e12, t, ["renderable"]), macro.get(e12, t, [
    "lastSize",
    "lastAspectRatio",
    "axisTextStyle",
    "tickTextStyle",
    "tmActor",
    "ticks"
  ]), t.forceUpdate = false, t.lastRedrawTime = {}, macro.obj(t.lastRedrawTime, { mtime: 0 }), t.lastRebuildTime = {}, macro.obj(t.lastRebuildTime, { mtime: 0 }), t.lastSize = [-1, -1], t.lastTickBounds = [], vtkCubeAxesActorHelper(e12, t);
}, "vtkCubeAxesActorHelper");
function vtkCubeAxesActor(e12, t) {
  t.classHierarchy.push("vtkCubeAxesActor"), e12.setCamera = (n2) => {
    t.camera !== n2 && (t.cameraModifiedSub &&= (t.cameraModifiedSub.unsubscribe(), null), t.camera = n2, n2 && (t.cameraModifiedSub = n2.onModified(e12.update)), e12.update(), e12.modified());
  }, e12.computeFacesToDraw = () => {
    let e13 = t.camera.getViewMatrix();
    transpose(e13, e13);
    let n2 = false, r = vtkBoundingBox.getDiagonalLength(t.dataBounds), a = Math.sin(t.faceVisibilityAngle * Math.PI / 180);
    for (let o = 0; o < 6; o++) {
      let s = false, c = Math.floor(o / 2), l = (c + 1) % 3, u = (c + 2) % 3;
      t.dataBounds[l * 2] !== t.dataBounds[l * 2 + 1] && t.dataBounds[u * 2] !== t.dataBounds[u * 2 + 1] && (ptv3[c] = t.dataBounds[o] - 0.1 * r * faceNormals[o][c], ptv3[l] = 0.5 * (t.dataBounds[l * 2] + t.dataBounds[l * 2 + 1]), ptv3[u] = 0.5 * (t.dataBounds[u * 2] + t.dataBounds[u * 2 + 1]), transformMat4$1(tmpv3, ptv3, e13), ptv3[c] = t.dataBounds[o], transformMat4$1(tmp2v3, ptv3, e13), subtract$3(tmpv3, tmp2v3, tmpv3), normalize$4(tmpv3, tmpv3), s = tmpv3[2] > a, t.camera.getParallelProjection() || (normalize$4(tmp2v3, tmp2v3), s = dot$3(tmp2v3, tmpv3) > a)), s !== t.lastFacesToDraw[o] && (t.lastFacesToDraw[o] = s, n2 = true);
    }
    return n2;
  }, e12.updatePolyData = (e13, n2, r) => {
    let a = 0, o = 0;
    a += 8;
    let s = 0;
    for (let e14 = 0; e14 < 12; e14++)
      n2[e14] > 0 && s++;
    if (o += s, t.gridLines)
      for (let t2 = 0; t2 < 6; t2++)
        e13[t2] && (a += r[faceAxes[t2][0]].length * 2 + r[faceAxes[t2][1]].length * 2, o += r[faceAxes[t2][0]].length + r[faceAxes[t2][1]].length);
    let c = new Float64Array(a * 3), l = new Uint32Array(o * 3), u = 0, d = 0;
    for (let e14 = 0; e14 < 2; e14++)
      for (let n3 = 0; n3 < 2; n3++)
        for (let r2 = 0; r2 < 2; r2++)
          c[u * 3] = t.dataBounds[r2], c[u * 3 + 1] = t.dataBounds[2 + n3], c[u * 3 + 2] = t.dataBounds[4 + e14], u++;
    for (let e14 = 0; e14 < 12; e14++)
      n2[e14] > 0 && (l[d * 3] = 2, l[d * 3 + 1] = edgePoints[e14][0], l[d * 3 + 2] = edgePoints[e14][1], d++);
    if (t.gridLines) {
      for (let n3 = 0; n3 < 6; n3++)
        if (e13[n3]) {
          let e14 = Math.floor(n3 / 2), a2 = r[faceAxes[n3][0]];
          for (let r2 = 0; r2 < a2.length; r2++)
            c[u * 3 + e14] = t.dataBounds[n3], c[u * 3 + faceAxes[n3][0]] = a2[r2], c[u * 3 + faceAxes[n3][1]] = t.dataBounds[faceAxes[n3][1] * 2], u++, c[u * 3 + e14] = t.dataBounds[n3], c[u * 3 + faceAxes[n3][0]] = a2[r2], c[u * 3 + faceAxes[n3][1]] = t.dataBounds[faceAxes[n3][1] * 2 + 1], u++, l[d * 3] = 2, l[d * 3 + 1] = u - 2, l[d * 3 + 2] = u - 1, d++;
          a2 = r[faceAxes[n3][1]];
          for (let r2 = 0; r2 < a2.length; r2++)
            c[u * 3 + e14] = t.dataBounds[n3], c[u * 3 + faceAxes[n3][1]] = a2[r2], c[u * 3 + faceAxes[n3][0]] = t.dataBounds[faceAxes[n3][0] * 2], u++, c[u * 3 + e14] = t.dataBounds[n3], c[u * 3 + faceAxes[n3][1]] = a2[r2], c[u * 3 + faceAxes[n3][0]] = t.dataBounds[faceAxes[n3][0] * 2 + 1], u++, l[d * 3] = 2, l[d * 3 + 1] = u - 2, l[d * 3 + 2] = u - 1, d++;
        }
    }
    t.polyData.getPoints().setData(c, 3), t.polyData.getPoints().modified(), t.polyData.getLines().setData(l, 1), t.polyData.getLines().modified(), t.polyData.modified();
  }, e12.updateTextData = (e13, n2, r, a) => {
    let o = 0;
    for (let e14 = 0; e14 < 12; e14++)
      n2[e14] === 1 && (o += 2, o += r[edgeAxes[e14]].length);
    let s = t.polyData.getPoints().getData(), c = new Float64Array(o * 3), l = 0, u = 0, d = 0;
    for (let o2 = 0; o2 < 6; o2++)
      if (e13[o2])
        for (let e14 = 0; e14 < 4; e14++) {
          let f = faceEdges[o2][e14];
          if (n2[f] === 1) {
            let e15 = edgeAxes[f], n3 = edgePoints[f][0] * 3, p = edgePoints[f][1] * 3;
            c[l * 3] = 0.5 * (s[n3] + s[p]), c[l * 3 + 1] = 0.5 * (s[n3 + 1] + s[p + 1]), c[l * 3 + 2] = 0.5 * (s[n3 + 2] + s[p + 2]), l++;
            let m = Math.floor(o2 / 2);
            c[l * 3 + m] = t.dataBounds[o2], c[l * 3 + faceAxes[o2][0]] = 0.5 * (t.dataBounds[faceAxes[o2][0] * 2] + t.dataBounds[faceAxes[o2][0] * 2 + 1]), c[l * 3 + faceAxes[o2][1]] = 0.5 * (t.dataBounds[faceAxes[o2][1] * 2] + t.dataBounds[faceAxes[o2][1] * 2 + 1]), l++, t.textValues[u] = t.axisLabels[e15], u++;
            let h = (e15 + 1) % 3, g = (e15 + 2) % 3, _ = r[e15], v = a[e15];
            t.tickCounts[d] = _.length;
            for (let r2 = 0; r2 < _.length; r2++)
              c[l * 3 + e15] = _[r2], c[l * 3 + h] = s[n3 + h], c[l * 3 + g] = s[n3 + g], l++, t.textValues[u] = v[r2], u++;
            d++;
          }
        }
    t.textPolyData.getPoints().setData(c, 3), t.textPolyData.modified();
  }, e12.update = () => {
    if (!t.camera)
      return;
    let n2 = e12.computeFacesToDraw(), r = t.lastFacesToDraw, a = false;
    for (let e13 = 0; e13 < 6; e13++)
      t.dataBounds[e13] !== t.lastTickBounds[e13] && (a = true, t.lastTickBounds[e13] = t.dataBounds[e13]);
    if (n2 || a || t.forceUpdate) {
      let n3 = Array(12).fill(0);
      for (let e13 = 0; e13 < 6; e13++)
        if (r[e13])
          for (let t2 = 0; t2 < 4; t2++)
            n3[faceEdges[e13][t2]]++;
      let o = t.generateTicks(t.dataBounds);
      e12.updatePolyData(r, n3, o.ticks), e12.updateTextData(r, n3, o.ticks, o.tickStrings), (a || t.forceUpdate) && e12.updateTextureAtlas(o.tickStrings);
    }
    t.forceUpdate = false;
  }, e12.updateTextureAtlas = (e13) => {
    t.tmContext.textBaseline = "bottom", t.tmContext.textAlign = "left", t._tmAtlas.clear();
    let n2 = 0, r = 1;
    for (let a = 0; a < 3; a++) {
      if (!t._tmAtlas.has(t.axisLabels[a])) {
        applyTextStyle$1(t.tmContext, t.axisTextStyle);
        let e14 = t.tmContext.measureText(t.axisLabels[a]), o = {
          height: e14.actualBoundingBoxAscent + 2,
          startingHeight: r,
          width: e14.width + 2,
          textStyle: t.axisTextStyle
        };
        t._tmAtlas.set(t.axisLabels[a], o), r += o.height, n2 < o.width && (n2 = o.width);
      }
      applyTextStyle$1(t.tmContext, t.tickTextStyle);
      for (let o = 0; o < e13[a].length; o++)
        if (!t._tmAtlas.has(e13[a][o])) {
          let s = t.tmContext.measureText(e13[a][o]), c = {
            height: s.actualBoundingBoxAscent + 2,
            startingHeight: r,
            width: s.width + 2,
            textStyle: t.tickTextStyle
          };
          t._tmAtlas.set(e13[a][o], c), r += c.height, n2 < c.width && (n2 = c.width);
        }
    }
    n2 = nearestPowerOfTwo(n2), r = nearestPowerOfTwo(r), t._tmAtlas.forEach((e14) => {
      e14.tcoords = [
        0,
        (r - e14.startingHeight - e14.height) / r,
        e14.width / n2,
        (r - e14.startingHeight - e14.height) / r,
        e14.width / n2,
        (r - e14.startingHeight) / r,
        0,
        (r - e14.startingHeight) / r
      ];
    }), t.tmCanvas.width = n2, t.tmCanvas.height = r, t.tmContext.textBaseline = "bottom", t.tmContext.textAlign = "left", t.tmContext.clearRect(0, 0, n2, r), t._tmAtlas.forEach((e14, n3) => {
      applyTextStyle$1(t.tmContext, e14.textStyle), t.tmContext.fillText(n3, 1, e14.startingHeight + e14.height - 1);
    }), t.tmTexture.setCanvas(t.tmCanvas), t.tmTexture.modified();
  }, e12.onModified(() => {
    t.forceUpdate = true, e12.update();
  }), e12.setTickTextStyle = (n2) => {
    t.tickTextStyle = {
      ...t.tickTextStyle,
      ...n2
    }, e12.modified();
  }, e12.setAxisTextStyle = (n2) => {
    t.axisTextStyle = {
      ...t.axisTextStyle,
      ...n2
    }, e12.modified();
  }, e12.get_tmAtlas = () => t._tmAtlas, e12.getBounds = () => (e12.update(), vtkBoundingBox.setBounds(t.bounds, t.gridActor.getBounds()), vtkBoundingBox.scaleAboutCenter(t.bounds, t.boundsScaleFactor, t.boundsScaleFactor, t.boundsScaleFactor), t.bounds);
  let n = macro.chain(e12.setProperty, t.gridActor.setProperty);
  e12.setProperty = (e13) => n(e13)[0];
}
function defaultValues$2(e12, t, n) {
  return {
    boundsScaleFactor: 1.3,
    camera: null,
    dataBounds: [...vtkBoundingBox.INIT_BOUNDS],
    faceVisibilityAngle: 8,
    gridLines: true,
    axisLabels: null,
    axisTitlePixelOffset: 35,
    tickLabelPixelOffset: 12,
    generateTicks: defaultGenerateTicks$1,
    ...n,
    axisTextStyle: {
      fontColor: "white",
      fontStyle: "normal",
      fontSize: 18,
      fontFamily: "serif",
      ...n?.axisTextStyle
    },
    tickTextStyle: {
      fontColor: "white",
      fontStyle: "normal",
      fontSize: 14,
      fontFamily: "serif",
      ...n?.tickTextStyle
    }
  };
}
function extend$15(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  vtkActor$1.extend(e12, t, defaultValues$2(e12, t, n)), t.lastFacesToDraw = [
    false,
    false,
    false,
    false,
    false,
    false
  ], t.axisLabels = [
    "X-Axis",
    "Y-Axis",
    "Z-Axis"
  ], t.tickCounts = [], t.textValues = [], t.lastTickBounds = [], t.tmCanvas = document.createElement("canvas"), t.tmContext = t.tmCanvas.getContext("2d"), t._tmAtlas = /* @__PURE__ */ new Map(), t.tmTexture = vtkTexture$1.newInstance({ resizable: true }), t.tmTexture.setInterpolate(false), e12.getProperty().setDiffuse(0), e12.getProperty().setAmbient(1), t.gridMapper = vtkMapper$1.newInstance(), t.polyData = vtkPolyData$1.newInstance(), t.gridMapper.setInputData(t.polyData), t.gridActor = vtkActor$1.newInstance(), t.gridActor.setMapper(t.gridMapper), t.gridActor.setProperty(e12.getProperty()), t.gridActor.setParentProp(e12), t.textPolyData = vtkPolyData$1.newInstance(), macro.setGet(e12, t, [
    "axisTitlePixelOffset",
    "boundsScaleFactor",
    "faceVisibilityAngle",
    "gridLines",
    "tickLabelPixelOffset",
    "generateTicks"
  ]), macro.setGetArray(e12, t, ["dataBounds"], 6), macro.setGetArray(e12, t, ["axisLabels"], 3), macro.get(e12, t, [
    "axisTextStyle",
    "tickTextStyle",
    "camera",
    "tmTexture",
    "textValues",
    "textPolyData",
    "tickCounts",
    "gridActor"
  ]), vtkCubeAxesActor(e12, t);
}
var vtkCubeAxesActor$1 = {
  newInstance: macro.newInstance(extend$15, "vtkCubeAxesActor"),
  extend: extend$15,
  newCubeAxesActorHelper,
  defaultGenerateTicks: defaultGenerateTicks$1
};
function vtkOpenGLCubeAxesActor(e12, t) {
  t.classHierarchy.push("vtkOpenGLCubeAxesActor"), e12.buildPass = (n) => {
    n && (t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.CubeAxesActorHelper.getRenderable() || t.CubeAxesActorHelper.setRenderable(t.renderable), e12.prepareNodes(), e12.addMissingNode(t.CubeAxesActorHelper.getTmActor()), e12.addMissingNode(t.renderable.getGridActor()), e12.removeUnusedNodes());
  }, e12.opaquePass = (e13, n) => {
    if (e13) {
      let e14 = t._openGLRenderer ? t._openGLRenderer.getRenderable().getActiveCamera() : null, n2 = t._openGLRenderer.getTiledSizeAndOrigin();
      t.CubeAxesActorHelper.updateAPISpecificData([n2.usize, n2.vsize], e14, t._openGLRenderWindow.getRenderable());
    }
  };
}
var DEFAULT_VALUES$12 = {};
function extend$14(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$12, n), vtkViewNode$1.extend(e12, t, n), t.CubeAxesActorHelper = vtkCubeAxesActor$1.newCubeAxesActorHelper(), vtkOpenGLCubeAxesActor(e12, t);
}
registerOverride$1("vtkCubeAxesActor", newInstance(extend$14, "vtkOpenGLCubeAxesActor"));
var vtkPolyData2DFS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkPolyData2DFS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n\nuniform int PrimitiveIDOffset;\n\n// Texture coordinates\n//VTK::TCoord::Dec\n\n// Scalar coloring\n//VTK::Color::Dec\n\n// Depth Peeling\n//VTK::DepthPeeling::Dec\n\n// picking support\n//VTK::Picking::Dec\n\n// the output of this shader\n//VTK::Output::Dec\n\n// Apple Bug\n//VTK::PrimID::Dec\n\nvoid main()\n{\n  // Apple Bug\n  //VTK::PrimID::Impl\n\n  //VTK::Color::Impl\n  //VTK::TCoord::Impl\n\n  //VTK::DepthPeeling::Impl\n  //VTK::Picking::Impl\n\n  if (gl_FragData[0].a <= 0.0)\n    {\n    discard;\n    }\n}\n", vtkPolyData2DVS = "//VTK::System::Dec\n\n/*=========================================================================\n\n  Program:   Visualization Toolkit\n  Module:    vtkPolyData2DVS.glsl\n\n  Copyright (c) Ken Martin, Will Schroeder, Bill Lorensen\n  All rights reserved.\n  See Copyright.txt or http://www.kitware.com/Copyright.htm for details.\n\n     This software is distributed WITHOUT ANY WARRANTY; without even\n     the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR\n     PURPOSE.  See the above copyright notice for more information.\n\n=========================================================================*/\n\n// all variables that represent positions or directions have a suffix\n// indicating the coordinate system they are in. The possible values are\n// MC - Model Coordinates\n// WC - WC world coordinates\n// VC - View Coordinates\n// DC - Display Coordinates\n\nin vec4 vertexWC;\n\n// frag position in VC\n//VTK::PositionVC::Dec\n\n// material property values\n//VTK::Color::Dec\n\n// Texture coordinates\n//VTK::TCoord::Dec\n\n// Apple Bug\n//VTK::PrimID::Dec\n\nuniform mat4 WCVCMatrix;  // World to view matrix\n\nvoid main()\n{\n  // Apple Bug\n  //VTK::PrimID::Impl\n\n  gl_Position = WCVCMatrix*vertexWC;\n\n  //VTK::TCoord::Impl\n\n  //VTK::Color::Impl\n\n  //VTK::PositionVC::Impl\n}\n", DisplayLocation$2 = {
  BACKGROUND: 0,
  FOREGROUND: 1
}, Constants = { DisplayLocation: DisplayLocation$2 }, { primTypes } = vtkHelper, { Filter, Wrap } = vtkOpenGLTexture$1, { vtkErrorMacro: vtkErrorMacro$1 } = macro$1, StartEvent = { type: "StartEvent" }, EndEvent = { type: "EndEvent" };
function vtkOpenGLPolyDataMapper2D(e12, t) {
  t.classHierarchy.push("vtkOpenGLPolyDataMapper2D"), e12.buildPass = (n2) => {
    n2 && (t.openGLActor2D = e12.getFirstAncestorOfType("vtkOpenGLActor2D"), t._openGLRenderer = t.openGLActor2D.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getLastAncestorOfType("vtkOpenGLRenderWindow"), t.openGLCamera = t._openGLRenderer.getViewNodeFor(t._openGLRenderer.getRenderable().getActiveCamera()));
  }, e12.overlayPass = (t2) => {
    t2 && e12.render();
  }, e12.getShaderTemplate = (e13, t2, n2) => {
    e13.Vertex = vtkPolyData2DVS, e13.Fragment = vtkPolyData2DFS, e13.Geometry = "";
  }, e12.render = () => {
    let n2 = t._openGLRenderWindow.getContext();
    if (t.context !== n2) {
      t.context = n2;
      for (let e13 = primTypes.Start; e13 < primTypes.End; e13++)
        t.primitives[e13].setOpenGLRenderWindow(t._openGLRenderWindow);
    }
    let r = t.openGLActor2D.getRenderable(), a = t._openGLRenderer.getRenderable();
    e12.renderPiece(a, r);
  }, e12.renderPiece = (n2, r) => {
    if (e12.invokeEvent(StartEvent), t.renderable.getStatic() || t.renderable.update(), t.currentInput = t.renderable.getInputData(), e12.invokeEvent(EndEvent), !t.currentInput) {
      vtkErrorMacro$1("No input!");
      return;
    }
    if (!t.currentInput.getPoints || !t.currentInput.getPoints().getNumberOfValues())
      return;
    let a = t.context;
    t._openGLRenderWindow.enableCullFace(), a.cullFace(a.BACK), e12.renderPieceStart(n2, r), e12.renderPieceDraw(n2, r), e12.renderPieceFinish(n2, r);
  }, e12.renderPieceStart = (n2, r) => {
    if (t.primitiveIDOffset = 0, t._openGLRenderer.getSelector())
      switch (t._openGLRenderer.getSelector().getCurrentPass()) {
        default:
          t._openGLRenderer.getSelector().renderProp(r);
      }
    t.renderable.getColorTextureMap() && t.internalColorTexture.activate(), e12.updateBufferObjects(n2, r), t.lastBoundBO = null;
  }, e12.getNeedToRebuildShaders = (e13, n2, r) => e13.getShaderSourceTime().getMTime() < t.renderable.getMTime() || e13.getShaderSourceTime().getMTime() < t.currentInput.getMTime(), e12.updateBufferObjects = (t2, n2) => {
    e12.getNeedToRebuildBufferObjects(t2, n2) && e12.buildBufferObjects(t2, n2);
  }, e12.getNeedToRebuildBufferObjects = (n2, r) => {
    let a = t.VBOBuildTime.getMTime();
    return !!(a < e12.getMTime() || a < t._openGLRenderWindow.getMTime() || a < t.renderable.getMTime() || a < r.getMTime() || a < t.currentInput.getMTime() || t.renderable.getTransformCoordinate() && a < n2.getMTime());
  }, e12.buildBufferObjects = (e13, n2) => {
    let r = t.currentInput;
    if (r === null)
      return;
    t.renderable.mapScalars(r, n2.getProperty().getOpacity());
    let a = t.renderable.getColorMapColors(), o = n2.getProperty().getRepresentation(), s = r.getPointData().getTCoords();
    t.openGLActor2D.getActiveTextures() || (s = null);
    let c = false;
    if (t.renderable.getColorCoordinates()) {
      s = t.renderable.getColorCoordinates(), c = t.renderable.getAreScalarsMappedFromCells(), t.internalColorTexture ||= vtkOpenGLTexture$1.newInstance({ resizable: true });
      let e14 = t.internalColorTexture;
      e14.setMinificationFilter(Filter.NEAREST), e14.setMagnificationFilter(Filter.NEAREST), e14.setWrapS(Wrap.CLAMP_TO_EDGE), e14.setWrapT(Wrap.CLAMP_TO_EDGE), e14.setOpenGLRenderWindow(t._openGLRenderWindow);
      let n3 = t.renderable.getColorTextureMap(), r2 = n3.getExtent(), a2 = n3.getPointData().getScalars();
      e14.create2DFromRaw({
        width: r2[1] - r2[0] + 1,
        height: r2[3] - r2[2] + 1,
        numComps: a2.getNumberOfComponents(),
        dataType: a2.getDataType(),
        data: a2.getData()
      }), e14.activate(), e14.sendParameters(), e14.deactivate();
    }
    let l = t.renderable.getTransformCoordinate(), u = e13.getRenderWindow().getViews()[0].getViewportSize(e13), d = `${r.getMTime()}A${o}B${r.getMTime()}C${a ? a.getMTime() : 1}D${s ? s.getMTime() : 1}E${l ? e13.getMTime() : 1}F${u}`;
    if (t.VBOBuildString !== d) {
      let n3 = r.getPoints();
      if (l) {
        let t2 = vtkPoints$1.newInstance(), r2 = n3.getNumberOfPoints();
        t2.setNumberOfPoints(r2);
        let a2 = [];
        for (let o2 = 0; o2 < r2; ++o2) {
          n3.getPoint(o2, a2), l.setValue(a2);
          let r3 = l.getComputedDoubleViewportValue(e13);
          t2.setPoint(o2, r3[0], r3[1], 0);
        }
        n3 = t2;
      }
      let u2 = {
        points: n3,
        tcoords: s,
        colors: a,
        cellOffset: 0,
        useTCoordsPerCell: c,
        haveCellScalars: t.renderable.getAreScalarsMappedFromCells(),
        customAttributes: t.renderable.getCustomShaderAttributes().map((e14) => r.getPointData().getArrayByName(e14))
      };
      u2.cellOffset += t.primitives[primTypes.Points].getCABO().createVBO(r.getVerts(), "verts", o, u2), u2.cellOffset += t.primitives[primTypes.Lines].getCABO().createVBO(r.getLines(), "lines", o, u2), u2.cellOffset += t.primitives[primTypes.Tris].getCABO().createVBO(r.getPolys(), "polys", o, u2), u2.cellOffset += t.primitives[primTypes.TriStrips].getCABO().createVBO(r.getStrips(), "strips", o, u2), t.VBOBuildTime.modified(), t.VBOBuildString = d;
    }
  }, e12.renderPieceDraw = (n2, r) => {
    let a = r.getProperty().getRepresentation();
    t.context.depthMask(true);
    for (let o = primTypes.Start; o < primTypes.End; o++)
      t.primitives[o].getCABO().getElementCount() && (t.lastBoundBO = t.primitives[o], t.primitiveIDOffset += t.primitives[o].drawArrays(n2, r, a, e12));
  }, e12.renderPieceFinish = (e13, n2) => {
    t.lastBoundBO && t.lastBoundBO.getVAO().release(), t.renderable.getColorTextureMap() && t.internalColorTexture.deactivate();
  }, e12.replaceShaderValues = (t2, n2, r) => {
    e12.replaceShaderColor(t2, n2, r), e12.replaceShaderTCoord(t2, n2, r), e12.replaceShaderPicking(t2, n2, r), e12.replaceShaderPositionVC(t2, n2, r);
  }, e12.replaceShaderColor = (e13, n2, r) => {
    let a = e13.Vertex, o = e13.Geometry, s = e13.Fragment, c = ["uniform vec3 diffuseColorUniform;", "uniform float opacityUniform;"], l = ["vec3 diffuseColor = diffuseColorUniform;", "float opacity = opacityUniform;"];
    t.lastBoundBO.getCABO().getColorComponents() === 0 ? t.renderable.getAreScalarsMappedFromCells() && (l = l.concat([
      "  vec4 texColor = texture2D(texture1, tcoordVCVSOutput.st);",
      "  diffuseColor = texColor.rgb;",
      "  opacity = opacity*texColor.a;"
    ])) : (c = c.concat(["varying vec4 vertexColorVSOutput;"]), a = vtkShaderProgram$1.substitute(a, "//VTK::Color::Dec", ["attribute vec4 scalarColor;", "varying vec4 vertexColorVSOutput;"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::Color::Impl", ["vertexColorVSOutput =  scalarColor;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Color::Dec", ["in vec4 vertexColorVSOutput[];", "out vec4 vertexColorGSOutput;"]).result, o = vtkShaderProgram$1.substitute(o, "//VTK::Color::Impl", ["vertexColorGSOutput = vertexColorVSOutput[i];"]).result, s = vtkShaderProgram$1.substitute(s, "//VTK::Color::Impl", l.concat(["  diffuseColor = vertexColorVSOutput.rgb;", "  opacity = opacity*vertexColorVSOutput.a;"])).result), l = l.concat(["gl_FragData[0] = vec4(diffuseColor, opacity);"]), s = vtkShaderProgram$1.substitute(s, "//VTK::Color::Dec", c).result, s = vtkShaderProgram$1.substitute(s, "//VTK::Color::Impl", l).result, e13.Vertex = a, e13.Geometry = o, e13.Fragment = s;
  }, e12.replaceShaderTCoord = (e13, n2, r) => {
    if (t.lastBoundBO.getCABO().getTCoordOffset()) {
      let n3 = e13.Vertex, r2 = e13.Geometry, a = e13.Fragment, o = t.lastBoundBO.getCABO().getTCoordComponents();
      o === 1 ? (n3 = vtkShaderProgram$1.substitute(n3, "//VTK::TCoord::Dec", ["in float tcoordMC;", "out float tcoordVCVSOutput;"]).result, n3 = vtkShaderProgram$1.substitute(n3, "//VTK::TCoord::Impl", ["tcoordVCVSOutput = tcoordMC;"]).result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::TCoord::Dec", ["in float tcoordVCVSOutput[];\n", "out float tcoordVCGSOutput;"]).result, r2 = vtkShaderProgram$1.substitute(r2, ["//VTK::TCoord::Impl", "tcoordVCGSOutput = tcoordVCVSOutput[i];"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Dec", ["in float tcoordVCVSOutput;", "uniform sampler2D texture1;"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Impl", ["gl_FragData[0] = gl_FragData[0]*texture2D(texture1, vec2(tcoordVCVSOutput,0));"]).result) : o === 2 && (n3 = vtkShaderProgram$1.substitute(n3, "//VTK::TCoord::Dec", ["in vec2 tcoordMC;", "out vec2 tcoordVCVSOutput;"]).result, n3 = vtkShaderProgram$1.substitute(n3, "//VTK::TCoord::Impl", ["tcoordVCVSOutput = tcoordMC;"]).result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::TCoord::Dec", ["in vec2 tcoordVCVSOutput[];\n", "out vec2 tcoordVCGSOutput;"]).result, r2 = vtkShaderProgram$1.substitute(r2, "//VTK::TCoord::Impl", ["tcoordVCGSOutput = tcoordVCVSOutput[i];"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Dec", ["in vec2 tcoordVCVSOutput;", "uniform sampler2D texture1;"]).result, a = vtkShaderProgram$1.substitute(a, "//VTK::TCoord::Impl", ["gl_FragData[0] = gl_FragData[0]*texture2D(texture1, tcoordVCVSOutput.st);"]).result), t.renderable.getAreScalarsMappedFromCells() && (r2 = vtkShaderProgram$1.substitute(r2, "//VTK::PrimID::Impl", ["gl_PrimitiveID = gl_PrimitiveIDIn;"]).result), e13.Vertex = n3, e13.Geometry = r2, e13.Fragment = a;
    }
  }, e12.replaceShaderPicking = (e13, t2, n2) => {
    let r = e13.Fragment;
    r = vtkShaderProgram$1.substitute(r, "//VTK::Picking::Dec", ["uniform vec3 mapperIndex;", "uniform int picking;"]).result, r = vtkShaderProgram$1.substitute(r, "//VTK::Picking::Impl", "  gl_FragData[0] = picking != 0 ? vec4(mapperIndex,1.0) : gl_FragData[0];").result, e13.Fragment = r;
  }, e12.replaceShaderPositionVC = (e13, n2, r) => {
    t.lastBoundBO.replaceShaderPositionVC(e13, n2, r);
  }, e12.invokeShaderCallbacks = (e13, n2, r) => {
    let a = t.renderable.getViewSpecificProperties().ShadersCallbacks;
    a && a.forEach((t2) => {
      t2.callback(t2.userData, e13, n2, r);
    });
  }, e12.setMapperShaderParameters = (e13, n2, r) => {
    if (e13.getProgram().isUniformUsed("PrimitiveIDOffset") && e13.getProgram().setUniformi("PrimitiveIDOffset", t.primitiveIDOffset), e13.getProgram().isAttributeUsed("vertexWC") && (e13.getVAO().addAttributeArray(e13.getProgram(), e13.getCABO(), "vertexWC", e13.getCABO().getVertexOffset(), e13.getCABO().getStride(), t.context.FLOAT, 3, false) || vtkErrorMacro$1("Error setting vertexWC in shader VAO.")), e13.getCABO().getElementCount() && (t.VBOBuildTime.getMTime() > e13.getAttributeUpdateTime().getMTime() || e13.getShaderSourceTime().getMTime() > e13.getAttributeUpdateTime().getMTime())) {
      t.renderable.getCustomShaderAttributes().forEach((n3, r2) => {
        e13.getProgram().isAttributeUsed(`${n3}MC`) && (e13.getVAO().addAttributeArray(e13.getProgram(), e13.getCABO(), `${n3}MC`, e13.getCABO().getCustomData()[r2].offset, e13.getCABO().getStride(), t.context.FLOAT, e13.getCABO().getCustomData()[r2].components, false) || vtkErrorMacro$1(`Error setting ${n3}MC in shader VAO.`));
      }), e13.getProgram().isAttributeUsed("tcoordMC") && e13.getCABO().getTCoordOffset() ? e13.getVAO().addAttributeArray(e13.getProgram(), e13.getCABO(), "tcoordMC", e13.getCABO().getTCoordOffset(), e13.getCABO().getStride(), t.context.FLOAT, e13.getCABO().getTCoordComponents(), false) || vtkErrorMacro$1("Error setting tcoordMC in shader VAO.") : e13.getVAO().removeAttributeArray("tcoordMC"), e13.getProgram().isAttributeUsed("scalarColor") && e13.getCABO().getColorComponents() ? e13.getVAO().addAttributeArray(e13.getProgram(), e13.getCABO().getColorBO(), "scalarColor", e13.getCABO().getColorOffset(), e13.getCABO().getColorBOStride(), t.context.UNSIGNED_BYTE, 4, true) || vtkErrorMacro$1("Error setting scalarColor in shader VAO.") : e13.getVAO().removeAttributeArray("scalarColor"), t.internalColorTexture && e13.getProgram().isUniformUsed("texture1") && t.internalColorTexture.getTextureUnit() > -1 && e13.getProgram().setUniformi("texture1", t.internalColorTexture.getTextureUnit());
      let a = t.openGLActor2D.getActiveTextures();
      if (a)
        for (let t2 = 0; t2 < a.length; ++t2) {
          let n3 = a[t2].getTextureUnit(), r2 = `texture${n3 + 1}`;
          e13.getProgram().isUniformUsed(r2) && e13.getProgram().setUniformi(r2, n3);
        }
      e13.setMapperShaderParameters(n2, r, t._openGLRenderer.getTiledSizeAndOrigin());
      let o = t._openGLRenderer.getSelector();
      e13.getProgram().setUniform3fArray("mapperIndex", o ? o.getPropColorValue() : [
        0,
        0,
        0
      ]), e13.getProgram().setUniformi("picking", o ? o.getCurrentPass() + 1 : 0);
    }
  }, e12.setPropertyShaderParameters = (e13, n2, r) => {
    let a = t.renderable.getColorMapColors();
    if (!a || a.getNumberOfComponents() === 0) {
      let t2 = e13.getProgram(), n3 = r.getProperty(), a2 = n3.getOpacity();
      t2.setUniformf("opacityUniform", a2);
      let o = n3.getColor();
      t2.setUniform3fArray("diffuseColorUniform", o);
    }
  }, e12.setLightingShaderParameters = (e13, t2, n2) => {
  };
  function n(e13, t2, n2) {
    return t2.identity(n2), e13.reduce((e14, n3, r) => r === 0 ? n3 ? t2.copy(e14, n3) : t2.identity(e14) : n3 ? t2.multiply(e14, e14, n3) : e14, n2);
  }
  e12.setCameraShaderParameters = (e13, r, a) => {
    let o = e13.getProgram(), s = e13.getCABO().getCoordShiftAndScaleEnabled() ? e13.getCABO().getInverseShiftAndScaleMatrix() : null, c = r.getRenderWindow().getViews()[0].getViewportSize(r), l = r.getViewport(), u = a.getActualPositionCoordinate().getComputedDoubleViewportValue(r), d = [
      0,
      0,
      1,
      1
    ], f = [
      0,
      0,
      1,
      1
    ];
    if (f[0] = l[0] >= d[0] ? l[0] : d[0], f[1] = l[1] >= d[1] ? l[1] : d[1], f[2] = l[2] <= d[2] ? l[2] : d[2], f[3] = l[3] <= d[3] ? l[3] : d[3], f[0] >= f[2] || f[1] >= f[3])
      return;
    c[0] = round(c[0] * (f[2] - f[0]) / (l[2] - l[0])), c[1] = round(c[1] * (f[3] - f[1]) / (l[3] - l[1]));
    let p = t._openGLRenderer.getParent().getSize(), m = round(u[0] - (f[0] - l[0]) * p[0]), h = round(u[1] - (f[1] - l[1]) * p[1]), g = -m, _ = -m + c[0], v = -h, y = -h + c[1];
    g === _ && (_ = g + 1), v === y && (y = v + 1);
    let b = identity$2(new Float64Array(16));
    b[0] = 2 / (_ - g), b[5] = 2 / (y - v), b[3] = -1 * (_ + g) / (_ - g), b[7] = -1 * (y + v) / (y - v), b[10] = 0, b[11] = a.getProperty().getDisplayLocation() === DisplayLocation$2.FOREGROUND ? -1 : 1, b[15] = 1, transpose(b, b), o.setUniformMatrix("WCVCMatrix", n([b, s], mat4_exports, t.tmpMat4));
  }, e12.getAllocatedGPUMemoryInBytes = () => {
    let e13 = 0;
    return t.primitives.forEach((t2) => {
      e13 += t2.getAllocatedGPUMemoryInBytes();
    }), e13;
  };
}
var DEFAULT_VALUES$11 = {
  context: null,
  VBOBuildTime: 0,
  VBOBuildString: null,
  primitives: null,
  primTypes: null,
  shaderRebuildString: null
};
function extend$13(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$11, n), vtkViewNode$1.extend(e12, t, n), vtkReplacementShaderMapper.implementReplaceShaderCoincidentOffset(e12, t, n), vtkReplacementShaderMapper.implementBuildShadersWithReplacements(e12, t, n), t.primitives = [], t.primTypes = primTypes, t.tmpMat4 = identity$2(new Float64Array(16));
  for (let e13 = primTypes.Start; e13 < primTypes.End; e13++)
    t.primitives[e13] = vtkHelper.newInstance(), t.primitives[e13].setPrimitiveType(e13), t.primitives[e13].set({
      lastLightComplexity: 0,
      lastLightCount: 0,
      lastSelectionPass: false
    }, true);
  setGet(e12, t, ["context"]), t.VBOBuildTime = {}, obj(t.VBOBuildTime, { mtime: 0 }), vtkOpenGLPolyDataMapper2D(e12, t);
}
registerOverride$1("vtkMapper2D", newInstance(extend$13, "vtkOpenGLPolyDataMapper2D"));
var Constants$1 = { Orientation: {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
  AUTO: "auto"
} }, { VectorMode } = vtkScalarsToColors$1, { Orientation } = Constants$1;
function applyTextStyle(e12, t, n) {
  e12.strokeStyle = t.strokeColor, e12.lineWidth = t.strokeSize, e12.fillStyle = t.fontColor;
  let r = t.fontSize ?? n;
  e12.font = `${t.fontStyle} ${r}px ${t.fontFamily}`;
}
function defaultAutoLayout(e12, t) {
  return (e13) => {
    let n = e13.getLastSize(), r = (n[0] / 700) ** 0.8, a = (n[1] / 700) ** 0.8, o = Math.min(r, a), s = e13.getAxisTextStyle(), c = e13.getTickTextStyle();
    Object.assign(s, t.axisTextStyle), Object.assign(c, t.tickTextStyle), s.fontSize === void 0 && (s.fontSize = Math.max(24 * o, 12)), c.fontSize === void 0 && (e13.getLastAspectRatio() > 1 ? c.fontSize = Math.max(20 * o, 10) : c.fontSize = Math.max(16 * o, 10));
    let l = e13.updateTextureAtlas();
    e13.setTopTitle(false);
    let u = e13.getBoxSizeByReference(), d = false;
    if (d = t.orientation === Orientation.VERTICAL ? true : t.orientation === Orientation.HORIZONTAL ? false : e13.getLastAspectRatio() > 1, d)
      e13.setTickLabelPixelOffset(0.3 * c.fontSize), l.titleWidth <= l.tickWidth + e13.getTickLabelPixelOffset() + 0.8 * c.fontSize ? (e13.setTopTitle(true), e13.setAxisTitlePixelOffset(0.2 * c.fontSize), u[0] = 2 * (l.tickWidth + e13.getTickLabelPixelOffset() + 0.8 * c.fontSize) / n[0], e13.setBoxPosition([0.98 - u[0], -0.92])) : (e13.setAxisTitlePixelOffset(0.2 * c.fontSize), u[0] = 2 * (l.titleHeight + e13.getAxisTitlePixelOffset() + l.tickWidth + e13.getTickLabelPixelOffset() + 0.8 * c.fontSize) / n[0], e13.setBoxPosition([0.99 - u[0], -0.92])), u[1] = Math.max(1.2, Math.min(1.84 / a, 1.84));
    else {
      e13.setAxisTitlePixelOffset(1.2 * c.fontSize), e13.setTickLabelPixelOffset(0.1 * c.fontSize);
      let t2 = 2 * (0.8 * c.fontSize + l.titleHeight + e13.getAxisTitlePixelOffset()) / n[1], r2 = 2 * l.tickWidth / n[0];
      u[0] = Math.min(1.9, Math.max(1.4, 1.4 * r2 * (e13.getTicks().length + 3))), u[1] = t2, e13.setBoxPosition([-0.5 * u[0], -0.97]);
    }
    e13.recomputeBarSegments(l);
  };
}
function defaultGenerateTicks(e12, t) {
  return (e13) => {
    let t2 = e13.getLastTickBounds(), n = linear().domain([t2[0], t2[1]]), r = n.ticks(5), a = n.tickFormat(5);
    e13.setTicks(r), e13.setTickStrings(r.map(a));
  };
}
function vtkScalarBarActorHelper(e12, t) {
  t.classHierarchy.push("vtkScalarBarActorHelper"), e12.setRenderable = (n2) => {
    t.renderable !== n2 && (t.renderable = n2, t.barActor.setProperty(n2.getProperty()), t.barActor.setParentProp(n2), t.barActor.setCoordinateSystemToDisplay(), t.tmActor.setProperty(n2.getProperty()), t.tmActor.setParentProp(n2), t.tmActor.setCoordinateSystemToDisplay(), t.generateTicks = n2.generateTicks, t.axisTextStyle = { ...n2.getAxisTextStyle() }, t.tickTextStyle = { ...n2.getTickTextStyle() }, e12.modified());
  }, e12.updateAPISpecificData = (n2, r2, a) => {
    (t.lastSize[0] !== n2[0] || t.lastSize[1] !== n2[1]) && (t.lastSize[0] = n2[0], t.lastSize[1] = n2[1], t.lastAspectRatio = n2[0] / n2[1], t.forceUpdate = true);
    let o = t.renderable.getScalarsToColors();
    if (!(!o || !t.renderable.getVisibility()) && (t.barMapper.setLookupTable(o), t.camera = r2, t.renderWindow = a, t.forceUpdate || Math.max(o.getMTime(), e12.getMTime(), t.renderable.getMTime()) > t.lastRebuildTime.getMTime())) {
      if (t.lastTickBounds = [...o.getMappingRange()], t.renderable.getGenerateTicks()(e12), t.renderable.getAutomated())
        t.renderable.getAutoLayout()(e12);
      else {
        t.axisTextStyle = { ...t.renderable.getAxisTextStyle() }, t.tickTextStyle = { ...t.renderable.getTickTextStyle() }, t.barPosition = [...t.renderable.getBarPosition()], t.barSize = [...t.renderable.getBarSize()], t.boxPosition = [...t.renderable.getBoxPosition()], t.boxSize = [...t.renderable.getBoxSize()], t.axisTitlePixelOffset = t.renderable.getAxisTitlePixelOffset(), t.tickLabelPixelOffset = t.renderable.getTickLabelPixelOffset();
        let n3 = e12.updateTextureAtlas();
        e12.recomputeBarSegments(n3);
      }
      e12.updatePolyDataForLabels(), e12.updatePolyDataForBarSegments(), t.lastRebuildTime.modified(), t.forceUpdate = false;
    }
  }, e12.updateTextureAtlas = () => {
    t.tmContext.textBaseline = "bottom", t.tmContext.textAlign = "left";
    let n2 = {}, r2 = /* @__PURE__ */ new Map(), a = 0, o = 1;
    applyTextStyle(t.tmContext, t.axisTextStyle, 18);
    let s = t.tmContext.measureText(t.renderable.getAxisLabel()), c = {
      height: s.actualBoundingBoxAscent + 2,
      startingHeight: o,
      width: s.width + 2,
      textStyle: t.axisTextStyle
    };
    r2.set(t.renderable.getAxisLabel(), c), o += c.height, a = c.width, n2.titleWidth = c.width, n2.titleHeight = c.height, n2.tickWidth = 0, n2.tickHeight = 0, applyTextStyle(t.tmContext, t.tickTextStyle, 14);
    let l = [
      ...e12.getTickStrings(),
      "NaN",
      "Below",
      "Above"
    ];
    for (let e13 = 0; e13 < l.length; e13++)
      r2.has(l[e13]) || (s = t.tmContext.measureText(l[e13]), c = {
        height: s.actualBoundingBoxAscent + 2,
        startingHeight: o,
        width: s.width + 2,
        textStyle: t.tickTextStyle
      }, r2.set(l[e13], c), o += c.height, a < c.width && (a = c.width), n2.tickWidth < c.width && (n2.tickWidth = c.width), n2.tickHeight < c.height && (n2.tickHeight = c.height));
    return a = nearestPowerOfTwo(a), o = nearestPowerOfTwo(o), r2.forEach((e13) => {
      e13.tcoords = [
        0,
        (o - e13.startingHeight - e13.height) / o,
        e13.width / a,
        (o - e13.startingHeight - e13.height) / o,
        e13.width / a,
        (o - e13.startingHeight) / o,
        0,
        (o - e13.startingHeight) / o
      ];
    }), t.tmCanvas.width = a, t.tmCanvas.height = o, t.tmContext.textBaseline = "bottom", t.tmContext.textAlign = "left", t.tmContext.clearRect(0, 0, a, o), r2.forEach((e13, n3) => {
      let r3 = e13.textStyle === t.axisTextStyle ? 18 : 14;
      applyTextStyle(t.tmContext, e13.textStyle, r3), t.tmContext.fillText(n3, 1, e13.startingHeight + e13.height - 1);
    }), t.tmTexture.setCanvas(t.tmCanvas), t.tmTexture.modified(), t._tmAtlas = r2, n2;
  }, e12.computeBarSize = (e13) => {
    t.vertical = t.boxSize[1] > t.boxSize[0];
    let n2 = 2 * e13.tickHeight / t.lastSize[1], r2 = [1, 1];
    if (t.vertical) {
      let a = 2 * (e13.tickWidth + t.tickLabelPixelOffset) / t.lastSize[0];
      if (t.topTitle) {
        let n3 = 2 * (e13.titleHeight + t.axisTitlePixelOffset) / t.lastSize[1];
        t.barSize[0] = t.boxSize[0] - a, t.barSize[1] = t.boxSize[1] - n3;
      } else {
        let n3 = 2 * (e13.titleHeight + t.axisTitlePixelOffset) / t.lastSize[0];
        t.barSize[0] = t.boxSize[0] - n3 - a, t.barSize[1] = t.boxSize[1];
      }
      t.barPosition[0] = t.boxPosition[0] + a, t.barPosition[1] = t.boxPosition[1], r2[1] = n2;
    } else {
      let n3 = (2 * e13.tickWidth - 8) / t.lastSize[0], a = 2 * (e13.titleHeight + t.axisTitlePixelOffset) / t.lastSize[1];
      t.barSize[0] = t.boxSize[0], t.barPosition[0] = t.boxPosition[0], t.barSize[1] = t.boxSize[1] - a, t.barPosition[1] = t.boxPosition[1], r2[0] = n3;
    }
    return r2;
  }, e12.recomputeBarSegments = (n2) => {
    let r2 = e12.computeBarSize(n2);
    t.barSegments = [];
    let a = [0, 0], o = t.vertical ? 1 : 0, s = t.vertical ? 0.01 : 0.02;
    function c(e13, n3) {
      t.barSegments.push({
        corners: [
          [...a],
          [a[0] + r2[0], a[1]],
          [a[0] + r2[0], a[1] + r2[1]],
          [a[0], a[1] + r2[1]]
        ],
        scalars: n3,
        title: e13
      }), a[o] += r2[o] + s;
    }
    t.renderable.getDrawNanAnnotation() && t.renderable.getScalarsToColors().getNanColor() && c("NaN", [
      NaN,
      NaN,
      NaN,
      NaN
    ]), t.renderable.getDrawBelowRangeSwatch() && t.renderable.getScalarsToColors().getUseBelowRangeColor?.() && c("Below", [
      -0.1,
      -0.1,
      -0.1,
      -0.1
    ]);
    let l = t.renderable.getScalarsToColors().getUseAboveRangeColor?.();
    a[o] += s;
    let u = r2[o];
    r2[o] = l ? 1 - 2 * s - r2[o] - a[o] : 1 - s - a[o], c("ticks", t.vertical ? [
      0,
      0,
      0.995,
      0.995
    ] : [
      0,
      0.995,
      0.995,
      0
    ]), t.renderable.getDrawAboveRangeSwatch() && l && (r2[o] = u, a[o] += s, c("Above", [
      1.1,
      1.1,
      1.1,
      1.1
    ]));
  };
  let n = new Float64Array(3);
  e12.createPolyDataForOneLabel = (e13, r2, a, o, s, c) => {
    let l = t._tmAtlas.get(e13);
    if (!l)
      return;
    let u = c.ptIdx, d = c.cellIdx;
    n[0] = (0.5 * r2[0] + 0.5) * t.lastSize[0], n[1] = (0.5 * r2[1] + 0.5) * t.lastSize[1], n[2] = r2[2], n[0] += s[0], n[1] += s[1];
    let f = [], p = o === "vertical" ? [1, 0] : [0, 1];
    o === "vertical" ? (f[0] = l.width, f[1] = -l.height, a[0] === "middle" ? n[1] -= l.width / 2 : a[0] === "right" && (n[1] -= l.width), a[1] === "middle" ? n[0] += l.height / 2 : a[1] === "top" && (n[0] += l.height)) : (f[0] = l.width, f[1] = l.height, a[0] === "middle" ? n[0] -= l.width / 2 : a[0] === "right" && (n[0] -= l.width), a[1] === "middle" ? n[1] -= l.height / 2 : a[1] === "top" && (n[1] -= l.height)), c.points[u * 3] = n[0], c.points[u * 3 + 1] = n[1], c.points[u * 3 + 2] = n[2], c.tcoords[u * 2] = l.tcoords[0], c.tcoords[u * 2 + 1] = l.tcoords[1], u++, n[p[0]] += f[0], c.points[u * 3] = n[0], c.points[u * 3 + 1] = n[1], c.points[u * 3 + 2] = n[2], c.tcoords[u * 2] = l.tcoords[2], c.tcoords[u * 2 + 1] = l.tcoords[3], u++, n[p[1]] += f[1], c.points[u * 3] = n[0], c.points[u * 3 + 1] = n[1], c.points[u * 3 + 2] = n[2], c.tcoords[u * 2] = l.tcoords[4], c.tcoords[u * 2 + 1] = l.tcoords[5], u++, n[p[0]] -= f[0], c.points[u * 3] = n[0], c.points[u * 3 + 1] = n[1], c.points[u * 3 + 2] = n[2], c.tcoords[u * 2] = l.tcoords[6], c.tcoords[u * 2 + 1] = l.tcoords[7], u++, c.polys[d * 4] = 3, c.polys[d * 4 + 1] = u - 4, c.polys[d * 4 + 2] = u - 3, c.polys[d * 4 + 3] = u - 2, d++, c.polys[d * 4] = 3, c.polys[d * 4 + 1] = u - 4, c.polys[d * 4 + 2] = u - 2, c.polys[d * 4 + 3] = u - 1, c.ptIdx += 4, c.cellIdx += 2;
  };
  let r = new Float64Array(3);
  e12.updatePolyDataForLabels = () => {
    let n2 = e12.getTickStrings().length + t.barSegments.length, a = n2 * 4, o = n2 * 2, s = new Float64Array(a * 3), c = new Uint16Array(o * 4), l = new Float32Array(a * 2), u = {
      ptIdx: 0,
      cellIdx: 0,
      polys: c,
      points: s,
      tcoords: l
    }, d = t.vertical ? 0 : 1, f = t.vertical ? 1 : 0;
    r[2] = -0.99;
    let p = t.vertical ? ["right", "middle"] : ["middle", "bottom"], m = [0, 1], h = [0, 0];
    t.vertical ? (h[0] = -t.tickLabelPixelOffset, t.topTitle ? (r[0] = t.boxPosition[0] + 0.5 * t.boxSize[0], r[1] = t.barPosition[1] + t.barSize[1], e12.createPolyDataForOneLabel(t.renderable.getAxisLabel(), r, ["middle", "bottom"], "horizontal", [0, t.axisTitlePixelOffset], u)) : (r[0] = t.barPosition[0] + t.barSize[0], r[1] = t.barPosition[1] + 0.5 * t.barSize[1], e12.createPolyDataForOneLabel(t.renderable.getAxisLabel(), r, ["middle", "top"], "vertical", [t.axisTitlePixelOffset, 0], u)), m = [-1, 0]) : (h[1] = t.tickLabelPixelOffset, r[0] = t.barPosition[0] + 0.5 * t.barSize[0], r[1] = t.barPosition[1] + t.barSize[1], e12.createPolyDataForOneLabel(t.renderable.getAxisLabel(), r, ["middle", "bottom"], "horizontal", [0, t.axisTitlePixelOffset], u)), r[d] = t.barPosition[d] + (0.5 * m[d] + 0.5) * t.barSize[d], r[f] = t.barPosition[f] + t.barSize[f] * 0.5;
    let g = null;
    for (let n3 = 0; n3 < t.barSegments.length; n3++) {
      let a2 = t.barSegments[n3];
      a2.title === "ticks" ? g = a2 : (r[f] = t.barPosition[f] + 0.5 * t.barSize[f] * (a2.corners[2][f] + a2.corners[0][f]), e12.createPolyDataForOneLabel(a2.title, r, p, "horizontal", h, u));
    }
    let _ = t.barPosition[f] + t.barSize[f] * g.corners[0][f], v = t.barSize[f] * (g.corners[2][f] - g.corners[0][f]), y = e12.getTicks(), b = e12.getTickStrings(), S = e12.getTickPositions();
    for (let n3 = 0; n3 < y.length; n3++)
      r[f] = _ + v * (S ? S[n3] : (y[n3] - t.lastTickBounds[0]) / (t.lastTickBounds[1] - t.lastTickBounds[0])), e12.createPolyDataForOneLabel(b[n3], r, p, "horizontal", h, u);
    let C = vtkDataArray$1.newInstance({
      numberOfComponents: 2,
      values: l,
      name: "TextureCoordinates"
    });
    t.tmPolyData.getPointData().setTCoords(C), t.tmPolyData.getPoints().setData(s, 3), t.tmPolyData.getPoints().modified(), t.tmPolyData.getPolys().setData(c, 1), t.tmPolyData.getPolys().modified(), t.tmPolyData.modified();
  }, e12.updatePolyDataForBarSegments = () => {
    let e13 = t.renderable.getScalarsToColors(), n2 = 0;
    t.renderable.getDrawNanAnnotation() && e13.getNanColor() && (n2 += 1), t.renderable.getDrawBelowRangeSwatch() && e13.getUseBelowRangeColor?.() && (n2 += 1), t.renderable.getDrawAboveRangeSwatch() && e13.getUseAboveRangeColor?.() && (n2 += 1);
    let a = 4 * (1 + n2), o = a, s = 1;
    e13.getVectorMode() === VectorMode.COMPONENT && (s = e13.getVectorComponent() + 1);
    let c = new Float64Array(a * 3), l = new Uint16Array(o * 5), u = new Float32Array(a * s), d = 0, f = 0;
    for (let e14 = 0; e14 < t.barSegments.length; e14++) {
      let n3 = t.barSegments[e14];
      for (let e15 = 0; e15 < 4; e15++) {
        r[0] = t.barPosition[0] + n3.corners[e15][0] * t.barSize[0], r[1] = t.barPosition[1] + n3.corners[e15][1] * t.barSize[1], c[d * 3] = (0.5 * r[0] + 0.5) * t.lastSize[0], c[d * 3 + 1] = (0.5 * r[1] + 0.5) * t.lastSize[1], c[d * 3 + 2] = r[2];
        for (let r2 = 0; r2 < s; r2++)
          u[d * s + r2] = t.lastTickBounds[0] + n3.scalars[e15] * (t.lastTickBounds[1] - t.lastTickBounds[0]);
        d++;
      }
      l[f * 5] = 4, l[f * 5 + 1] = d - 4, l[f * 5 + 2] = d - 3, l[f * 5 + 3] = d - 2, l[f * 5 + 4] = d - 1, f++;
    }
    let p = vtkDataArray$1.newInstance({
      numberOfComponents: s,
      values: u,
      name: "Scalars"
    });
    t.polyData.getPointData().setScalars(p), t.polyData.getPoints().setData(c, 3), t.polyData.getPoints().modified(), t.polyData.getPolys().setData(l, 1), t.polyData.getPolys().modified(), t.polyData.modified();
  };
}
var newScalarBarActorHelper = macro.newInstance(function(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { renderable: null };
  Object.assign(t, {}, n), macro.obj(e12, t), macro.setGet(e12, t, [
    "axisTitlePixelOffset",
    "tickLabelPixelOffset",
    "renderable",
    "topTitle",
    "ticks",
    "tickStrings",
    "tickPositions"
  ]), macro.get(e12, t, [
    "lastSize",
    "lastAspectRatio",
    "lastTickBounds",
    "axisTextStyle",
    "tickTextStyle",
    "barActor",
    "tmActor"
  ]), macro.getArray(e12, t, ["boxPosition", "boxSize"]), macro.setArray(e12, t, ["boxPosition", "boxSize"], 2), t.forceUpdate = false, t.lastRebuildTime = {}, macro.obj(t.lastRebuildTime, { mtime: 0 }), t.lastSize = [-1, -1], t.tmCanvas = document.createElement("canvas"), t.tmContext = t.tmCanvas.getContext("2d"), t._tmAtlas = /* @__PURE__ */ new Map(), t.barMapper = vtkMapper$1.newInstance(), t.barMapper.setInterpolateScalarsBeforeMapping(true), t.barMapper.setUseLookupTableScalarRange(true), t.polyData = vtkPolyData$1.newInstance(), t.barMapper.setInputData(t.polyData), t.barActor = vtkActor$1.newInstance(), t.barActor.setMapper(t.barMapper), t.tmPolyData = vtkPolyData$1.newInstance(), t.tmMapper = vtkMapper$1.newInstance(), t.tmMapper.setInputData(t.tmPolyData), t.tmTexture = vtkTexture$1.newInstance({ resizable: true }), t.tmTexture.setInterpolate(false), t.tmActor = vtkActor$1.newInstance({ parentProp: e12 }), t.tmActor.setMapper(t.tmMapper), t.tmActor.addTexture(t.tmTexture), t.barPosition = [0, 0], t.barSize = [0, 0], t.boxPosition = [0.88, -0.92], t.boxSize = [0.1, 1.1], t.lastTickBounds = [], vtkScalarBarActorHelper(e12, t);
}, "vtkScalarBarActorHelper");
function vtkScalarBarActor(e12, t) {
  t.classHierarchy.push("vtkScalarBarActor"), e12.setTickTextStyle = (n) => {
    t.tickTextStyle = {
      ...t.tickTextStyle,
      ...n
    }, e12.modified();
  }, e12.setAxisTextStyle = (n) => {
    t.axisTextStyle = {
      ...t.axisTextStyle,
      ...n
    }, e12.modified();
  }, e12.setOrientationToHorizontal = () => e12.setOrientation(Orientation.HORIZONTAL), e12.setOrientationToVertical = () => e12.setOrientation(Orientation.VERTICAL), e12.resetAutoLayoutToDefault = () => {
    e12.setAutoLayout(defaultAutoLayout(e12, t));
  }, e12.resetGenerateTicksToDefault = () => {
    e12.setGenerateTicks(defaultGenerateTicks());
  };
}
function defaultValues$1(e12) {
  return {
    automated: true,
    autoLayout: null,
    axisLabel: "Scalar Value",
    barPosition: [0, 0],
    barSize: [0, 0],
    boxPosition: [0.88, -0.92],
    boxSize: [0.1, 1.1],
    scalarToColors: null,
    axisTitlePixelOffset: 36,
    axisTextStyle: {
      fontColor: "white",
      fontStyle: "normal",
      fontSize: void 0,
      fontFamily: "serif"
    },
    tickLabelPixelOffset: 14,
    tickTextStyle: {
      fontColor: "white",
      fontStyle: "normal",
      fontSize: void 0,
      fontFamily: "serif"
    },
    generateTicks: null,
    drawNanAnnotation: true,
    drawBelowRangeSwatch: true,
    drawAboveRangeSwatch: true,
    orientation: null,
    ...e12
  };
}
function extend$12(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, defaultValues$1(n)), t.autoLayout ||= defaultAutoLayout(e12, t), t.generateTicks ||= defaultGenerateTicks(), vtkActor$1.extend(e12, t, n), e12.getProperty().setDiffuse(0), e12.getProperty().setAmbient(1), macro.setGet(e12, t, [
    "automated",
    "autoLayout",
    "axisTitlePixelOffset",
    "axisLabel",
    "scalarsToColors",
    "tickLabelPixelOffset",
    "generateTicks",
    "drawNanAnnotation",
    "drawBelowRangeSwatch",
    "drawAboveRangeSwatch",
    "orientation"
  ]), macro.get(e12, t, ["axisTextStyle", "tickTextStyle"]), macro.getArray(e12, t, [
    "barPosition",
    "barSize",
    "boxPosition",
    "boxSize"
  ]), macro.setArray(e12, t, [
    "barPosition",
    "barSize",
    "boxPosition",
    "boxSize"
  ], 2), vtkScalarBarActor(e12, t);
}
var vtkScalarBarActor$1 = {
  newInstance: macro.newInstance(extend$12, "vtkScalarBarActor"),
  extend: extend$12,
  newScalarBarActorHelper,
  ...Constants$1
};
function vtkOpenGLScalarBarActor(e12, t) {
  t.classHierarchy.push("vtkOpenGLScalarBarActor"), e12.buildPass = (n) => {
    n && (t._openGLRenderer = e12.getFirstAncestorOfType("vtkOpenGLRenderer"), t._openGLRenderWindow = t._openGLRenderer.getParent(), t.scalarBarActorHelper.getRenderable() || t.scalarBarActorHelper.setRenderable(t.renderable), e12.prepareNodes(), e12.addMissingNode(t.scalarBarActorHelper.getBarActor()), e12.addMissingNode(t.scalarBarActorHelper.getTmActor()), e12.removeUnusedNodes());
  }, e12.opaquePass = (e13, n) => {
    if (e13) {
      let e14 = t._openGLRenderer ? t._openGLRenderer.getRenderable().getActiveCamera() : null, n2 = t._openGLRenderer.getTiledSizeAndOrigin();
      t.scalarBarActorHelper.updateAPISpecificData([n2.usize, n2.vsize], e14, t._openGLRenderWindow.getRenderable());
    }
  };
}
var DEFAULT_VALUES$10 = {};
function extend$11(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$10, n), vtkViewNode$1.extend(e12, t, n), t.scalarBarActorHelper = vtkScalarBarActor$1.newScalarBarActorHelper(), vtkOpenGLScalarBarActor(e12, t);
}
registerOverride$1("vtkScalarBarActor", newInstance(extend$11, "vtkOpenGLScalarBarActor"));
var { CoordinateSystem: CoordinateSystem$2 } = vtkProp$1;
function vtkWebGPUActor(e12, t) {
  t.classHierarchy.push("vtkWebGPUActor"), e12.buildPass = (n) => {
    n && (t.WebGPURenderer = e12.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getFirstAncestorOfType("vtkWebGPURenderWindow"), t.propID === void 0 && (t.propID = t.WebGPURenderWindow.getUniquePropID()), e12.prepareNodes(), e12.addMissingNode(t.renderable.getMapper()), e12.removeUnusedNodes());
  }, e12.traverseOpaquePass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children[0] && t.children[0].traverse(n), e12.apply(n, false));
  }, e12.traverseTranslucentPass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children[0] && t.children[0].traverse(n), e12.apply(n, false));
  }, e12.queryPass = (e13, n) => {
    if (e13) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, e12.getBufferShift = (n) => (e12.getKeyMatrices(n), t.bufferShift), e12.getKeyMatrices = (e13) => {
    if (Math.max(t.renderable.getMTime(), e13.getStabilizedTime()) > t.keyMatricesTime.getMTime()) {
      t.renderable.computeMatrix();
      let n = t.renderable.getMatrix();
      t.bufferShift[0] = n[3], t.bufferShift[1] = n[7], t.bufferShift[2] = n[11];
      let r = e13.getStabilizedCenterByReference();
      t.renderable.getCoordinateSystem() === CoordinateSystem$2.WORLD && (t.bufferShift[0] -= r[0], t.bufferShift[1] -= r[1], t.bufferShift[2] -= r[2]), transpose(t.keyMatrices.bcwc, n), t.renderable.getIsIdentity() ? identity$2(t.keyMatrices.normalMatrix) : (copy$4(t.keyMatrices.normalMatrix, t.keyMatrices.bcwc), t.keyMatrices.normalMatrix[3] = 0, t.keyMatrices.normalMatrix[7] = 0, t.keyMatrices.normalMatrix[11] = 0, invert(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix), transpose(t.keyMatrices.normalMatrix, t.keyMatrices.normalMatrix)), translate(t.keyMatrices.bcwc, t.keyMatrices.bcwc, [
        -t.bufferShift[0],
        -t.bufferShift[1],
        -t.bufferShift[2]
      ]), t.renderable.getCoordinateSystem() === CoordinateSystem$2.WORLD ? translate(t.keyMatrices.bcsc, t.keyMatrices.bcwc, [
        -r[0],
        -r[1],
        -r[2]
      ]) : copy$4(t.keyMatrices.bcsc, t.keyMatrices.bcwc), t.keyMatricesTime.modified();
    }
    return t.keyMatrices;
  };
}
var DEFAULT_VALUES$9 = {
  keyMatricesTime: null,
  keyMatrices: null,
  propID: void 0,
  bufferShift: void 0
};
function extend$10(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$9, n), vtkViewNode$1.extend(e12, t, n), t.keyMatricesTime = {}, macro.obj(t.keyMatricesTime, { mtime: 0 }), t.keyMatrices = {
    normalMatrix: new Float64Array(16),
    bcwc: new Float64Array(16),
    bcsc: new Float64Array(16)
  }, macro.get(e12, t, ["propID", "keyMatricesTime"]), t.bufferShift = [
    0,
    0,
    0,
    0
  ], vtkWebGPUActor(e12, t);
}
registerOverride("vtkActor", macro.newInstance(extend$10));
var { CoordinateSystem: CoordinateSystem$1 } = vtkProp$1;
function vtkWebGPUActor2D(e12, t) {
  t.classHierarchy.push("vtkWebGPUActor2D"), e12.buildPass = (n) => {
    n && (t.WebGPURenderer = e12.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getFirstAncestorOfType("vtkWebGPURenderWindow"), t.propID === void 0 && (t.propID = t.WebGPURenderWindow.getUniquePropID()), e12.prepareNodes(), e12.addMissingNode(t.renderable.getMapper()), e12.removeUnusedNodes());
  }, e12.traverseOpaquePass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || !t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children[0] && t.children[0].traverse(n), e12.apply(n, false));
  }, e12.traverseTranslucentPass = (n) => {
    !t.renderable || !t.renderable.getNestedVisibility() || t.renderable.getIsOpaque() || t.WebGPURenderer.getSelector() && !t.renderable.getNestedPickable() || (e12.apply(n, true), t.children[0] && t.children[0].traverse(n), e12.apply(n, false));
  }, e12.queryPass = (e13, n) => {
    if (e13) {
      if (!t.renderable || !t.renderable.getVisibility())
        return;
      t.renderable.getIsOpaque() ? n.incrementOpaqueActorCount() : n.incrementTranslucentActorCount();
    }
  }, e12.getBufferShift = (n) => (e12.getKeyMatrices(n), t.bufferShift), e12.getKeyMatrices = (e13) => {
    if (Math.max(t.renderable.getMTime(), e13.getStabilizedTime()) > t.keyMatricesTime.getMTime()) {
      t.bufferShift[0] = 0, t.bufferShift[1] = 0, t.bufferShift[2] = 0;
      let n = e13.getStabilizedCenterByReference();
      t.renderable.getCoordinateSystem() === CoordinateSystem$1.WORLD && (t.bufferShift[0] -= n[0], t.bufferShift[1] -= n[1], t.bufferShift[2] -= n[2]), identity$2(t.keyMatrices.bcwc), identity$2(t.keyMatrices.normalMatrix), translate(t.keyMatrices.bcwc, t.keyMatrices.bcwc, [
        -t.bufferShift[0],
        -t.bufferShift[1],
        -t.bufferShift[2]
      ]), t.renderable.getCoordinateSystem() === CoordinateSystem$1.WORLD ? translate(t.keyMatrices.bcsc, t.keyMatrices.bcwc, [
        -n[0],
        -n[1],
        -n[2]
      ]) : copy$4(t.keyMatrices.bcsc, t.keyMatrices.bcwc), t.keyMatricesTime.modified();
    }
    return t.keyMatrices;
  };
}
var DEFAULT_VALUES$8 = {
  keyMatricesTime: null,
  keyMatrices: null,
  propID: void 0,
  bufferShift: void 0
};
function extend$9(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$8, n), vtkViewNode$1.extend(e12, t, n), t.keyMatricesTime = {}, macro.obj(t.keyMatricesTime, { mtime: 0 }), t.keyMatrices = {
    normalMatrix: new Float64Array(16),
    bcwc: new Float64Array(16),
    bcsc: new Float64Array(16)
  }, macro.get(e12, t, ["propID", "keyMatricesTime"]), t.bufferShift = [
    0,
    0,
    0,
    0
  ], vtkWebGPUActor2D(e12, t);
}
registerOverride("vtkActor2D", macro.newInstance(extend$9));
function vtkWebGPUCubeAxesActor(e12, t) {
  t.classHierarchy.push("vtkWebGPUCubeAxesActor"), e12.buildPass = (n) => {
    n && (t.WebGPURenderer = e12.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent(), t.CubeAxesActorHelper.getRenderable() || t.CubeAxesActorHelper.setRenderable(t.renderable), e12.prepareNodes(), e12.addMissingNode(t.CubeAxesActorHelper.getTmActor()), e12.addMissingNode(t.renderable.getGridActor()), e12.removeUnusedNodes());
  }, e12.opaquePass = (e13, n) => {
    if (e13) {
      let e14 = t.WebGPURenderer ? t.WebGPURenderer.getRenderable().getActiveCamera() : null, n2 = t.WebGPURenderer.getTiledSizeAndOrigin();
      t.CubeAxesActorHelper.updateAPISpecificData([n2.usize, n2.vsize], e14, t.WebGPURenderWindow.getRenderable());
    }
  };
}
var DEFAULT_VALUES$7 = {};
function extend$8(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$7, n), vtkViewNode$1.extend(e12, t, n), t.CubeAxesActorHelper = vtkCubeAxesActor$1.newCubeAxesActorHelper(), vtkWebGPUCubeAxesActor(e12, t);
}
registerOverride("vtkCubeAxesActor", newInstance(extend$8, "vtkWebGPUCubeAxesActor"));
var { DisplayLocation: DisplayLocation$1 } = Constants;
function vtkProperty2D(e12, t) {
  t.classHierarchy.push("vtkProperty2D"), e12.setDisplayLocationToBackground = () => e12.setDisplayLocation(DisplayLocation$1.BACKGROUND), e12.setDisplayLocationToForeground = () => e12.setDisplayLocation(DisplayLocation$1.FOREGROUND), e12.setRepresentationToWireframe = () => e12.setRepresentation(Representation$1.WIREFRAME), e12.setRepresentationToSurface = () => e12.setRepresentation(Representation$1.SURFACE), e12.setRepresentationToPoints = () => e12.setRepresentation(Representation$1.POINTS), e12.getRepresentationAsString = () => macro.enumToString(Representation$1, t.representation);
}
var DEFAULT_VALUES$6 = {
  color: [
    1,
    1,
    1
  ],
  opacity: 1,
  pointSize: 1,
  lineWidth: 1,
  representation: Representation$1.SURFACE,
  displayLocation: DisplayLocation$1.FOREGROUND
};
function extend$7(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$6, n), macro.obj(e12, t), macro.setGet(e12, t, [
    "opacity",
    "lineWidth",
    "pointSize",
    "displayLocation",
    "representation"
  ]), macro.setGetArray(e12, t, ["color"], 3), vtkProperty2D(e12, t);
}
var vtkProperty2D$1 = {
  newInstance: macro.newInstance(extend$7, "vtkProperty2D"),
  extend: extend$7,
  ...Constants
}, { BufferUsage, PrimitiveTypes: PrimitiveTypes$2 } = vtkWebGPUBufferManager$1, { Representation } = vtkProperty$1, { ScalarMode } = vtkMapper$1, { CoordinateSystem } = vtkProp$1, { DisplayLocation } = vtkProperty2D$1, vtkWebGPUPolyDataVS = "\n//VTK::Renderer::Dec\n\n//VTK::Color::Dec\n\n//VTK::Normal::Dec\n\n//VTK::TCoord::Dec\n\n//VTK::Select::Dec\n\n//VTK::Mapper::Dec\n\n//VTK::IOStructs::Dec\n\n@vertex\nfn main(\n//VTK::IOStructs::Input\n)\n//VTK::IOStructs::Output\n{\n  var output : vertexOutput;\n\n  var vertex: vec4<f32> = vertexBC;\n\n  //VTK::Color::Impl\n\n  //VTK::Normal::Impl\n\n  //VTK::TCoord::Impl\n\n  //VTK::Select::Impl\n\n  //VTK::Position::Impl\n\n  return output;\n}\n", vtkWebGPUPolyDataFS = '\nstruct PBRData {\n  diffuse: vec3<f32>,\n  specular: vec3<f32>,\n}\n\nstruct Material {\n  ior: f32,\n  roughness: f32,\n  metallic: f32,\n  base: vec3<f32>,\n};\n\nstruct DirectionalLight {\n  direction: vec3<f32>,\n  color: vec3<f32>,\n};\n\nstruct PointLight {\n  position: vec3<f32>,\n  color: vec3<f32>,\n};\n\nstruct SpotLight {\n  position: vec3<f32>,\n  direction: vec3<f32>,\n  cones: vec2<f32>,\n  color: vec3<f32>,\n};\n\nconst pi: f32 = 3.14159265359;\n\n// Dot product with the max already in it\nfn mdot(a: vec3<f32>, b: vec3<f32>) -> f32 {\n  return max(0.0, dot(a, b));\n}\n// Dot product with a max in it that does not allow for negative values\n// Physically based rendering is accurate as long as normals are accurate,\n// however this is pretty often not the case. In order to prevent negative\n// values from ruining light calculations and creating zones of zero light,\n// this remapping is used, which smoothly clamps the dot product between\n// zero and one while still maintaining a good amount of accuracy.\nfn cdot(a: vec3<f32>, b: vec3<f32>) -> f32 {\n  var d: f32 = max(0.0, dot(a, b));\n  d = pow((d + 1.0) / 2.0, 2.6);\n  return d;\n}\n\n// Lambertian diffuse model\nfn lambertDiffuse(base: vec3<f32>, N: vec3<f32>, L: vec3<f32>) -> vec3<f32> {\n  var NdotL: f32 = mdot(N, L);\n  NdotL = pow(NdotL, 1.5);\n  return (base/pi)*NdotL;\n}\n\n// Yasuhiro Fujii improvement on the Oren-Nayar model\n// https://mimosa-pudica.net/improved-oren-nayar.html\n// p is surface color, o is roughness\nfn fujiiOrenNayar(p: vec3<f32>, o: f32, N: vec3<f32>, L: vec3<f32>, V: vec3<f32>) -> vec3<f32> {\n  var invpi: f32 = 0.31830988618; // 1/pi\n\n  var o2 = o*o;\n  var NdotL: f32 = mdot(N, L);\n  NdotL = pow(NdotL, 1.5); // Less physically accurate, but hides the "seams" between lights better\n\n  var NdotV: f32 = mdot(N, V);\n  var LdotV: f32 = mdot(L, V);\n\n  var s: f32 = LdotV - NdotL*NdotV;\n  var t: f32 = mix(1.0, max(NdotL, NdotV), step(0.0, s)); // Mix with step is the equivalent of an if statement\n  var A: vec3<f32> = 0.5*(o2 / (o2 + 0.33)) + 0.17*p*(o2 / (o2 + 0.13));\n  A = invpi*(1 - A);\n  var B: f32 = 0.45*(o2 / (o2 + 0.09));\n  B = invpi*B;\n\n  return p*NdotL*(A + B*(s/t));\n}\n\n// Fresnel portion of BRDF (IOR only, simplified)\nfn schlickFresnelIOR(V: vec3<f32>, N: vec3<f32>, ior: f32, k: f32) -> f32 {\n  var NdotV: f32 = mdot(V, N);\n  var F0: f32 = (pow((ior - 1.0), 2.0) + k*k) / (pow((ior + 1.0), 2.0) + k*k); // This takes into account the roughness, which the other one does not\n  return F0 + (1.0 - F0) * pow((1.0-NdotV), 5.0);\n}\n\n// Fresnel portion of BRDF (Color ior, better)\nfn schlickFresnelRGB(V: vec3<f32>, N: vec3<f32>, F0: vec3<f32>) -> vec3<f32> {\n  var NdotV: f32 = mdot(V, N);\n  return F0 + (1.0 - F0) * pow((1-NdotV), 5.0);\n}\n\n// Normal portion of BRDF\n// https://learnopengl.com/PBR/Theory\n// Trowbridge-Reitz GGX functions: normal, halfway, roughness^2\nfn trGGX(N: vec3<f32>, H: vec3<f32>, a: f32) -> f32 {\n  var a2: f32 = a*a;\n  var NdotH = mdot(N, H);\n  var NdotH2 = NdotH*NdotH;\n\n  var denom: f32 = NdotH2 * (a2 - 1.0) + 1.0;\n\n  return a2 / max((pi*denom*denom), 0.000001);\n}\n\n// A VERY bad approximation of anisotropy. Real anisotropic calculations require tangent and bitangent\nfn anisotrophicTrGGX(N: vec3<f32>, H: vec3<f32>, O: vec3<f32>, s: f32, a: f32) -> f32 {\n  var Op: vec3<f32> = (rendererUBO.WCVCNormals * vec4<f32>(normalize(O) * s, 0.)).xyz;\n\n  var ggx1: f32 = trGGX(N + Op*s, H, a);\n  var ggx2: f32 = trGGX(N - Op*s, H, a);\n  return (0.5 * ggx1 + 0.5 * ggx2);\n}\n\n// Geometry portion of BRDF\nfn schlickGGX(N: vec3<f32>, X: vec3<f32>, k: f32) -> f32 {\n  var NdotX = cdot(N, X);\n  return NdotX / max(0.000001, (NdotX*(1.0-k) + k));\n}\n\nfn smithSurfaceRoughness(N: vec3<f32>, V: vec3<f32>, L: vec3<f32>, k: f32) -> f32 {\n  var ggx1: f32 = min(1.0, schlickGGX(N, V, k));\n  var ggx2: f32 = min(1.0, schlickGGX(N, L, k));\n  return ggx1*ggx2;\n}\n\n// BRDF Combination\nfn cookTorrance(D: f32, F: f32, G: f32, N: vec3<f32>, V: vec3<f32>, L: vec3<f32>) -> f32 {\n  var num: f32 = D*F*G;\n  var denom: f32 = 4*cdot(V, N)*cdot(L, N);\n\n  return num / max(denom, 0.000001);\n}\n\n// Different lighting calculations for different light sources\nfn calcDirectionalLight(N: vec3<f32>, V: vec3<f32>, mat: Material, light: DirectionalLight) -> PBRData {\n  var L: vec3<f32> = normalize(light.direction); // Light Vector\n  var H: vec3<f32> = normalize(L + V); // Halfway Vector\n\n  var alpha = mat.roughness * mat.roughness;\n  var k: f32 = alpha * alpha / 2.0;\n\n  var D: f32 = trGGX(N, H, alpha); // Distribution\n  // var F: f32 = schlickFresnelIOR(V, N, ior, k); // Fresnel\n  var G: f32 = smithSurfaceRoughness(N, V, L, k); // Geometry\n\n  var brdf: f32 = cookTorrance(D, 1.0, G, N, V, L); // Fresnel term is replaced with 1 because it is added later\n  var incoming: vec3<f32> = light.color;\n  var angle: f32 = mdot(L, N);\n  angle = pow(angle, 1.5);\n\n  var specular: vec3<f32> = brdf * incoming * angle;\n  // Oren-Nayar gives a clay-like effect when fully rough which some people may not want, so it might be better to give a separate\n  // control property for the diffuse vs specular roughness\n  var diffuse: vec3<f32> = incoming * fujiiOrenNayar(mat.base, mat.roughness, N, L, V);\n  // Stores the specular and diffuse separately to allow for finer post processing\n  var out = PBRData(diffuse, specular);\n\n  return out; // Returns angle along with color of light so the final color can be multiplied by angle as well (creates black areas)\n}\n\nfn calcPointLight(N: vec3<f32>, V: vec3<f32>, fragPos: vec3<f32>, mat: Material, light: PointLight) -> PBRData {\n  var L: vec3<f32> = normalize(light.position - fragPos);\n  var H: vec3<f32> = normalize(L + V);\n  var dist = distance(light.position, fragPos);\n\n  var alpha = mat.roughness * mat.roughness;\n  var k: f32 = alpha * alpha / 2.0;\n\n  var D: f32 = trGGX(N, H, alpha); // Distribution\n  var F: f32 = schlickFresnelIOR(V, N, mat.ior, k); // Fresnel\n  var G: f32 = smithSurfaceRoughness(N, V, L, k); // Geometry\n\n  var brdf: f32 = cookTorrance(D, 1.0, G, N, V, L);\n  var incoming: vec3<f32> = light.color * (1.0 / (dist * dist));\n  var angle: f32 = mdot(L, N);\n  angle = pow(angle, 1.5); // Smoothing factor makes it less accurate, but reduces ugly "seams" between light sources\n\n  var specular: vec3<f32> = brdf * incoming * angle;\n  var diffuse: vec3<f32> = incoming * fujiiOrenNayar(mat.base, mat.roughness, N, L, V);\n  // Stores the specular and diffuse separately to allow for finer post processing\n  // Could also be done (propably more properly) with a struct\n  var out = PBRData(diffuse, specular);\n\n  return out; // Returns angle along with color of light so the final color can be multiplied by angle as well (creates black areas)\n}\n\n// For a reason unknown to me, spheres dont seem to behave propperly with head-on spot lights\nfn calcSpotLight(N: vec3<f32>, V: vec3<f32>, fragPos: vec3<f32>, mat: Material, light: SpotLight) -> PBRData {\n  var L: vec3<f32> = normalize(light.position - fragPos);\n  var H: vec3<f32> = normalize(L + V); // Halfway Vector\n  var dist = distance(light.position, fragPos);\n\n  var alpha = mat.roughness * mat.roughness;\n  var k: f32 = alpha * alpha / 2.0; // could also be pow(alpha + 1.0, 2) / 8\n\n  var D: f32 = trGGX(N, H, alpha); // Distribution\n  // var F: f32 = schlickFresnelIOR(V, N, ior, k); // Fresnel\n  var G: f32 = smithSurfaceRoughness(N, V, L, k); // Geometry\n\n  var brdf: f32 = cookTorrance(D, 1.0, G, N, V, L);\n\n  var theta: f32 = mdot(normalize(light.direction), L);\n  var epsilon: f32 = light.cones.x - light.cones.y;\n  var intensity: f32 = (theta - light.cones.y) / epsilon;\n  intensity = clamp(intensity, 0.0, 1.0);\n  intensity /= dist * dist;\n\n  var incoming: vec3<f32> = light.color * intensity;\n\n  var angle: f32 = mdot(L, N);\n  angle = pow(angle, 1.5); // Smoothing factor makes it less accurate, but reduces ugly "seams" between light sources\n\n  var specular: vec3<f32> = brdf * incoming * angle;\n  var diffuse: vec3<f32> = incoming * fujiiOrenNayar(mat.base, mat.roughness, N, L, V);\n\n  // Stores the specular and diffuse separately to allow for finer post processing\n  // Could also be done (propably more properly) with a struct\n  var out = PBRData(diffuse, specular);\n\n  return out; // Returns angle along with color of light so the final color can be multiplied by angle as well (creates black areas)\n}\n\n// Environment mapping stuff\n// Takes in a vector and converts it to an equivalent coordinate in a rectilinear texture. Should be replaced with cubemaps at some point\nfn vecToRectCoord(dir: vec3<f32>) -> vec2<f32> {\n  var tau: f32 = 6.28318530718;\n  var out: vec2<f32> = vec2<f32>(0.0);\n\n  out.x = atan2(dir.z, dir.x) / tau;\n  out.x += 0.5;\n\n  var phix: f32 = length(vec2(dir.x, dir.z));\n  out.y = atan2(dir.y, phix) / pi + 0.5;\n\n  return out;\n}\n\n//VTK::Renderer::Dec\n\n//VTK::Color::Dec\n\n//VTK::TCoord::Dec\n\n// optional surface normal declaration\n//VTK::Normal::Dec\n\n//VTK::Select::Dec\n\n//VTK::RenderEncoder::Dec\n\n//VTK::Mapper::Dec\n\n//VTK::IOStructs::Dec\n\n@fragment\nfn main(\n//VTK::IOStructs::Input\n)\n//VTK::IOStructs::Output\n{\n  var output : fragmentOutput;\n\n  // Temporary ambient, diffuse, and opacity\n  var ambientColor: vec4<f32> = mapperUBO.AmbientColor;\n  var diffuseColor: vec4<f32> = mapperUBO.DiffuseColor;\n  var opacity: f32 = mapperUBO.Opacity;\n  var ior: f32 = mapperUBO.BaseIOR;\n\n  // This should be declared somewhere else\n  var _diffuseMap: vec4<f32> = vec4<f32>(1.0);\n  var _roughnessMap: vec4<f32> = vec4<f32>(1.0);\n  var _metallicMap: vec4<f32> = vec4<f32>(1.0);\n  var _normalMap: vec4<f32> = vec4<f32>(0.0, 0.0, 1.0, 0.0); // normal map was setting off the normal vector detection in fragment\n  var _ambientOcclusionMap: vec4<f32> = vec4<f32>(1.);\n  var _emissionMap: vec4<f32> = vec4<f32>(0.);\n\n  //VTK::Color::Impl\n\n  //VTK::TCoord::Impl\n\n  //VTK::Normal::Impl\n\n  var computedColor: vec4<f32> = vec4<f32>(diffuseColor.rgb, 1.0);\n\n  //VTK::Light::Impl\n\n  //VTK::Select::Impl\n\n  // Use texture alpha for transparency\n  computedColor.a = mapperUBO.Opacity * _diffuseMap.a;\n  if (computedColor.a == 0.0) { discard; };\n\n  //VTK::Position::Impl\n\n  //VTK::RenderEncoder::Impl\n\n  return output;\n}\n';
function isEdges(e12) {
  return e12.indexOf("edge") >= 0;
}
function vtkWebGPUCellArrayMapper(e12, t) {
  t.classHierarchy.push("vtkWebGPUCellArrayMapper"), e12.buildPass = (n) => {
    n && (t.is2D ? (t.WebGPUActor = e12.getFirstAncestorOfType("vtkWebGPUActor2D"), t.forceZValue = true) : (t.WebGPUActor = e12.getFirstAncestorOfType("vtkWebGPUActor"), t.forceZValue = false), t.coordinateSystem = t.WebGPUActor.getRenderable().getCoordinateSystem(), t.useRendererMatrix = t.coordinateSystem !== CoordinateSystem.DISPLAY, t.WebGPURenderer = t.WebGPUActor.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent(), t.device = t.WebGPURenderWindow.getDevice());
  }, e12.translucentPass = (n) => {
    n && (e12.prepareToDraw(t.WebGPURenderer.getRenderEncoder()), t.renderEncoder.registerDrawCallback(t.pipeline, e12.draw));
  }, e12.opaquePass = (n) => {
    n && (e12.prepareToDraw(t.WebGPURenderer.getRenderEncoder()), t.renderEncoder.registerDrawCallback(t.pipeline, e12.draw));
  }, e12.updateUBO = () => {
    let n = t.WebGPUActor.getRenderable().getProperty(), r = t.UBO.getSendTime();
    if (e12.getMTime() <= r && n.getMTime() <= r && t.renderable.getMTime() <= r)
      return;
    let a = t.WebGPUActor.getKeyMatrices(t.WebGPURenderer);
    if (t.UBO.setArray("BCWCMatrix", a.bcwc), t.UBO.setArray("BCSCMatrix", a.bcsc), t.UBO.setArray("MCWCNormals", a.normalMatrix), t.is2D) {
      let e13 = n.getDisplayLocation?.() ?? DisplayLocation.BACKGROUND;
      t.UBO.setValue("ZValue", e13 === DisplayLocation.FOREGROUND ? 1 : 0);
      let r2 = n.getColorByReference();
      t.UBO.setValue("AmbientIntensity", 1), t.UBO.setArray("DiffuseColor", [...r2, 1]), t.UBO.setValue("DiffuseIntensity", 0), t.UBO.setValue("SpecularIntensity", 0);
    } else
      t.UBO.setValue("AmbientIntensity", n.getAmbient()), t.UBO.setArray("AmbientColor", [...n.getAmbientColorByReference(), 1]), t.UBO.setValue("DiffuseIntensity", n.getDiffuse()), t.UBO.setArray("DiffuseColor", [...n.getDiffuseColorByReference(), 1]), t.UBO.setValue("Roughness", n.getRoughness()), t.UBO.setValue("BaseIOR", n.getBaseIOR()), t.UBO.setValue("Metallic", n.getMetallic()), t.UBO.setValue("NormalStrength", n.getNormalStrength()), t.UBO.setValue("Emission", n.getEmission()), t.UBO.setValue("SpecularIntensity", n.getSpecular()), n.getSpecularColorByReference() && t.UBO.setArray("SpecularColor", [...n.getSpecularColorByReference(), 1]);
    let o = n.getEdgeColorByReference?.();
    o && t.UBO.setArray("EdgeColor", [...o, 1]), t.UBO.setValue("LineWidth", n.getLineWidth()), t.UBO.setValue("Opacity", n.getOpacity()), t.UBO.setValue("PropID", t.WebGPUActor.getPropID()), t.UBO.sendIfNeeded(t.WebGPURenderWindow.getDevice());
  }, e12.haveWideLines = () => {
    let e13 = t.WebGPUActor.getRenderable(), n = e13.getProperty().getRepresentation();
    return e13.getProperty().getLineWidth() <= 1 || t.primitiveType === PrimitiveTypes$2.Verts ? false : t.primitiveType === PrimitiveTypes$2.Triangles || t.primitiveType === PrimitiveTypes$2.TriangleStrips ? n === Representation.WIREFRAME : true;
  }, e12.replaceShaderPosition = (n, r, a) => {
    let o = r.getShaderDescription("vertex");
    o.addBuiltinOutput("vec4<f32>", "@builtin(position) Position"), o.hasOutput("vertexVC") || o.addOutput("vec4<f32>", "vertexVC");
    let s = o.getCode();
    t.useRendererMatrix ? (s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Position::Impl", [
      "    var pCoord: vec4<f32> = rendererUBO.SCPCMatrix*mapperUBO.BCSCMatrix*vertexBC;",
      "    output.vertexVC = rendererUBO.SCVCMatrix * mapperUBO.BCSCMatrix * vec4<f32>(vertexBC.xyz, 1.0);",
      "//VTK::Position::Impl"
    ]).result, t.forceZValue && (s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Position::Impl", [
      "pCoord = vec4<f32>(pCoord.xyz/pCoord.w, 1.0);",
      "pCoord.z = mapperUBO.ZValue;",
      "//VTK::Position::Impl"
    ]).result)) : (s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Position::Impl", [
      "    var pCoord: vec4<f32> = mapperUBO.BCSCMatrix*vertexBC;",
      "    pCoord.x = 2.0* pCoord.x / rendererUBO.viewportSize.x - 1.0;",
      "    pCoord.y = 2.0* pCoord.y / rendererUBO.viewportSize.y - 1.0;",
      "    pCoord.z = 0.5 - 0.5 * pCoord.z;",
      "//VTK::Position::Impl"
    ]).result, t.forceZValue && (s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Position::Impl", ["    pCoord.z = mapperUBO.ZValue;", "//VTK::Position::Impl"]).result)), e12.haveWideLines() && (o.addBuiltinInput("u32", "@builtin(instance_index) instanceIndex"), s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Position::Impl", [
      "    var tmpPos: vec4<f32> = pCoord;",
      "    var numSteps: f32 = ceil(mapperUBO.LineWidth - 1.0);",
      "    var offset: f32 = (mapperUBO.LineWidth - 1.0) * (f32(input.instanceIndex / 2u) - numSteps/2.0) / numSteps;",
      "    var tmpPos2: vec3<f32> = tmpPos.xyz / tmpPos.w;",
      "    tmpPos2.x = tmpPos2.x + 2.0 * (f32(input.instanceIndex) % 2.0) * offset / rendererUBO.viewportSize.x;",
      "    tmpPos2.y = tmpPos2.y + 2.0 * (f32(input.instanceIndex + 1u) % 2.0) * offset / rendererUBO.viewportSize.y;",
      "    tmpPos2.z = min(1.0, tmpPos2.z + 0.00001);",
      "    pCoord = vec4<f32>(tmpPos2.xyz * tmpPos.w, tmpPos.w);",
      "//VTK::Position::Impl"
    ]).result), s = vtkWebGPUShaderCache$1.substitute(s, "//VTK::Position::Impl", ["    output.Position = pCoord;"]).result, o.setCode(s);
  }, t.shaderReplacements.set("replaceShaderPosition", e12.replaceShaderPosition), e12.replaceShaderNormal = (e13, n, r) => {
    let a = r.getBuffer("normalMC"), o = t.WebGPUActor.getRenderable();
    if (a) {
      let e14 = n.getShaderDescription("vertex");
      e14.hasOutput("normalVC") || e14.addOutput("vec3<f32>", "normalVC", a.getArrayInformation()[0].interpolation), e14.hasOutput("tangentVC") || e14.addOutput("vec3<f32>", "tangentVC", a.getArrayInformation()[0].interpolation), e14.hasOutput("bitangentVC") || e14.addOutput("vec3<f32>", "bitangentVC", a.getArrayInformation()[0].interpolation);
      let t2 = e14.getCode();
      t2 = vtkWebGPUShaderCache$1.substitute(t2, "//VTK::Normal::Impl", [
        "  output.normalVC = normalize((rendererUBO.WCVCNormals * mapperUBO.MCWCNormals * normalMC).xyz);",
        "  var c1: vec3<f32> = cross(output.normalVC, vec3<f32>(0, 0, 1));",
        "  var c2: vec3<f32> = cross(output.normalVC, vec3<f32>(0, 1, 0));",
        "  var tangent: vec3<f32> = mix(c1, c2, distance(c1, c2));",
        "  output.tangentVC = normalize(tangent);",
        "  output.bitangentVC = normalize(cross(output.normalVC, tangent));"
      ]).result, e14.setCode(t2);
      let r2 = n.getShaderDescription("fragment");
      t2 = r2.getCode(), t2 = o.getProperty().getNormalTexture() ? vtkWebGPUShaderCache$1.substitute(t2, "//VTK::Normal::Impl", [
        "  var normal: vec3<f32> = input.normalVC;",
        "  if (!input.frontFacing) { normal = -normal; }",
        "  var tangent: vec3<f32> = input.tangentVC;",
        "  var bitangent: vec3<f32> = input.bitangentVC;",
        "  var TCVCMatrix: mat3x3<f32> = mat3x3<f32>(",
        "    tangent.x, bitangent.x, normal.x,",
        "    tangent.y, bitangent.y, normal.y,",
        "    tangent.z, bitangent.z, normal.z,",
        "  );",
        "  var mappedNormal: vec3<f32> = TCVCMatrix * (_normalMap.xyz * 2 - 1);",
        "  normal = mix(normal, mappedNormal, mapperUBO.NormalStrength);",
        "  normal = normalize(normal);"
      ]).result : vtkWebGPUShaderCache$1.substitute(t2, "//VTK::Normal::Impl", [
        "  var normal: vec3<f32> = input.normalVC;",
        "  if (!input.frontFacing) { normal = -normal; }",
        "  normal = normalize(normal);"
      ]).result, r2.setCode(t2);
    }
  }, t.shaderReplacements.set("replaceShaderNormal", e12.replaceShaderNormal), e12.replaceShaderLight = (e13, n, r) => {
    if (e13.includes("sel"))
      return;
    let a = n.getShaderDescription("vertex");
    a.hasOutput("vertexVC") || a.addOutput("vec4<f32>", "vertexVC");
    let o = t.WebGPURenderer.getRenderable(), s = n.getShaderDescription("fragment"), c = s.getCode();
    if (c.includes("var normal:") && t.useRendererMatrix && !isEdges(e13) && !t.is2D && !e13.includes("sel")) {
      let e14 = [
        "  let fragPos = vec3<f32>(input.vertexVC.xyz);",
        "  let V = mix(normalize(-fragPos), vec3<f32>(0, 0, 1), f32(rendererUBO.cameraParallel)); // View Vector",
        "  let baseColor = _diffuseMap.rgb * diffuseColor.rgb;",
        "  let roughness = max(0.000001, mapperUBO.Roughness * _roughnessMap.r);",
        "  let metallic = mapperUBO.Metallic * _metallicMap.r;",
        "  let alpha = roughness * roughness;",
        "  let k = alpha * alpha / 2.0;",
        "  var diffuse = vec3<f32>(0.);",
        "  var specular = vec3<f32>(0.);",
        "  let emission = _emissionMap.rgb * mapperUBO.Emission;",
        "",
        "  // Material struct",
        "  let mat = Material(ior, roughness, metallic, baseColor);",
        "",
        "  {",
        "    var i = 0;",
        "    loop {",
        "      if (!(i < rendererUBO.LightCount)) { break; }",
        "      switch (i32(rendererLightSSBO.values[i].LightData.x)) {",
        "         // Point Light",
        "         case 0 {",
        "           let color = rendererLightSSBO.values[i].LightColor.rgb * rendererLightSSBO.values[i].LightColor.w;",
        "           let pos = (rendererLightSSBO.values[i].LightPos).xyz;",
        "           let pointLight = PointLight(pos, color);",
        "           let result = calcPointLight(normal, V, fragPos, mat, pointLight);",
        "           diffuse += max(vec3<f32>(0), result.diffuse);",
        "           specular += max(vec3<f32>(0), result.specular);",
        "          }",
        "         // Directional light",
        "         case 1 {",
        "           let dir = normalize((rendererUBO.WCVCNormals * vec4<f32>(normalize(rendererLightSSBO.values[i].LightDir.xyz), 0.)).xyz);",
        "           let color = rendererLightSSBO.values[i].LightColor.rgb * rendererLightSSBO.values[i].LightColor.w;",
        "           let dirLight = DirectionalLight(dir, color);",
        "           let result = calcDirectionalLight(normal, V, mat, dirLight); // diffuseColor.rgb needs to be fixed with a more dynamic diffuse color",
        "           diffuse += max(vec3<f32>(0), result.diffuse);",
        "           specular += max(vec3<f32>(0), result.specular);",
        "         }",
        "         // Spot Light",
        "         case 2 {",
        "           let color = rendererLightSSBO.values[i].LightColor.rgb * rendererLightSSBO.values[i].LightColor.w;",
        "           let pos = (rendererLightSSBO.values[i].LightPos).xyz;",
        "           let dir = normalize((rendererUBO.WCVCNormals * vec4<f32>(normalize(rendererLightSSBO.values[i].LightDir.xyz), 0.)).xyz);",
        "           let cones = vec2<f32>(rendererLightSSBO.values[i].LightData.y, rendererLightSSBO.values[i].LightData.z);",
        "           let spotLight = SpotLight(pos, dir, cones, color);",
        "           let result = calcSpotLight(normal, V, fragPos, mat, spotLight);",
        "           diffuse += max(vec3<f32>(0), result.diffuse);",
        "           specular += max(vec3<f32>(0), result.specular);",
        "         }",
        "         default { continue; }",
        "       }",
        "      continuing { i++; }",
        "    }",
        "  }",
        "  let fresnel = min(1.0, schlickFresnelIOR(V, normal, ior, k)); // Fresnel",
        "  // This could be controlled with its own variable (that isnt base color) for better artistic control",
        "  let fresnelMetallic = schlickFresnelRGB(V, normal, baseColor); // Fresnel for metal, takes color into account",
        "  let kS = min(vec3<f32>(1.0), mix(vec3<f32>(fresnel), fresnelMetallic, metallic));",
        "  let kD = (1.0 - kS) * (1.0 - metallic);",
        "  let PBR = mapperUBO.DiffuseIntensity * kD * diffuse + kS * specular;",
        "  computedColor = vec4<f32>(PBR + emission, mapperUBO.Opacity);"
      ];
      o.getEnvironmentTexture()?.getImageLoaded() && e14.push("  // To get diffuse IBL, the texture is sampled with normals in worldspace", "  let diffuseIBLCoords = (transpose(rendererUBO.WCVCNormals) * vec4<f32>(normal, 1.)).xyz;", "  let diffuseCoords = vecToRectCoord(diffuseIBLCoords);", "  // To get specular IBL, the texture is sampled as the worldspace reflection between the normal and view vectors", "  // Reflections are first calculated in viewspace, then converted to worldspace to sample the environment", "  let VreflN = normalize(reflect(-V, normal));", "  let reflectionIBLCoords = (transpose(rendererUBO.WCVCNormals) * vec4<f32>(VreflN, 1.)).xyz;", "  let specularCoords = vecToRectCoord(reflectionIBLCoords);", "  let diffuseIBL = textureSampleLevel(EnvironmentTexture, EnvironmentTextureSampler, diffuseCoords, rendererUBO.MaxEnvironmentMipLevel);", "  let level = roughness * rendererUBO.MaxEnvironmentMipLevel;", "  let specularIBL = textureSampleLevel(EnvironmentTexture, EnvironmentTextureSampler, specularCoords, level);", "  let specularIBLContribution = specularIBL.rgb * rendererUBO.BackgroundSpecularStrength;", "  computedColor += vec4<f32>(specularIBLContribution * kS, 0);", "  let diffuseIBLContribution = diffuseIBL.rgb * rendererUBO.BackgroundDiffuseStrength;", "  computedColor += vec4<f32>(diffuseIBLContribution * baseColor * _ambientOcclusionMap.rgb * kD, 0);"), c = vtkWebGPUShaderCache$1.substitute(c, "//VTK::Light::Impl", e14).result, s.setCode(c);
    } else
      c = vtkWebGPUShaderCache$1.substitute(c, "//VTK::Light::Impl", [
        "  let diffuse = diffuseColor.rgb;",
        "  let specular = mapperUBO.SpecularColor.rgb * mapperUBO.SpecularColor.a;",
        "  computedColor = vec4<f32>(diffuse * _diffuseMap.rgb, mapperUBO.Opacity);"
      ]).result, s.setCode(c);
  }, t.shaderReplacements.set("replaceShaderLight", e12.replaceShaderLight), e12.replaceShaderColor = (e13, t2, n) => {
    if (isEdges(e13)) {
      let e14 = t2.getShaderDescription("fragment"), n2 = e14.getCode();
      n2 = vtkWebGPUShaderCache$1.substitute(n2, "//VTK::Color::Impl", ["ambientColor = mapperUBO.EdgeColor;", "diffuseColor = mapperUBO.EdgeColor;"]).result, e14.setCode(n2);
      return;
    }
    let r = n.getBuffer("colorVI");
    if (!r)
      return;
    let a = t2.getShaderDescription("vertex");
    a.addOutput("vec4<f32>", "color", r.getArrayInformation()[0].interpolation);
    let o = a.getCode();
    o = vtkWebGPUShaderCache$1.substitute(o, "//VTK::Color::Impl", ["  output.color = colorVI;"]).result, a.setCode(o);
    let s = t2.getShaderDescription("fragment");
    o = s.getCode(), o = vtkWebGPUShaderCache$1.substitute(o, "//VTK::Color::Impl", [
      "ambientColor = input.color;",
      "diffuseColor = input.color;",
      "opacity = mapperUBO.Opacity * input.color.a;"
    ]).result, s.setCode(o);
  }, t.shaderReplacements.set("replaceShaderColor", e12.replaceShaderColor), e12.replaceShaderTCoord = (e13, n, r) => {
    if (!r.hasAttribute("tcoord"))
      return;
    let a = n.getShaderDescription("vertex"), o = r.getBuffer("tcoord"), s = vtkWebGPUTypes.getNumberOfComponentsFromBufferFormat(o.getArrayInformation()[0].format), c = a.getCode();
    a.addOutput(`vec${s}<f32>`, "tcoordVS"), c = vtkWebGPUShaderCache$1.substitute(c, "//VTK::TCoord::Impl", ["  output.tcoordVS = tcoord;"]).result, a.setCode(c);
    let l = n.getShaderDescription("fragment");
    c = l.getCode();
    let u = t.WebGPUActor.getRenderable(), d = u.getProperty(), f = (e14) => e14 ? e14.getDimensionality() === s : false, p = [], m = d.getDiffuseTexture?.();
    (m?.getImageLoaded() || u.getTextures()[0] || t.colorTexture) && (f(m) || f(u.getTextures()[0]) || f(t.colorTexture)) && p.push("_diffuseMap = textureSample(DiffuseTexture, DiffuseTextureSampler, input.tcoordVS);");
    let h = d.getORMTexture?.(), g = d.getRMTexture?.(), _ = d.getRoughnessTexture?.(), v = d.getMetallicTexture?.(), y = d.getAmbientOcclusionTexture?.(), b = d.getEmissionTexture?.(), S = d.getNormalTexture?.();
    h?.getImageLoaded() ? f(h) && p.push("_ambientOcclusionMap = textureSample(ORMTexture, ORMTextureSampler, input.tcoordVS).rrra;", "_roughnessMap = textureSample(ORMTexture, ORMTextureSampler, input.tcoordVS).ggga;", "_metallicMap = textureSample(ORMTexture, ORMTextureSampler, input.tcoordVS).bbba;") : g?.getImageLoaded() ? f(g) && p.push("_roughnessMap = textureSample(RMTexture, RMTextureSampler, input.tcoordVS).ggga;", "_metallicMap = textureSample(RMTexture, RMTextureSampler, input.tcoordVS).bbba;") : (_?.getImageLoaded() && f(_) && p.push("_roughnessMap = textureSample(RoughnessTexture, RoughnessTextureSampler, input.tcoordVS).ggga;"), v?.getImageLoaded() && f(v) && p.push("_metallicMap = textureSample(MetallicTexture, MetallicTextureSampler, input.tcoordVS).bbba;"), y?.getImageLoaded() && f(y) && p.push("_ambientOcclusionMap = textureSample(AmbientOcclusionTexture, AmbientOcclusionTextureSampler, input.tcoordVS).rrra;")), b?.getImageLoaded() && f(b) && p.push("_emissionMap = textureSample(EmissionTexture, EmissionTextureSampler, input.tcoordVS);"), S?.getImageLoaded() && f(S) && p.push("_normalMap = textureSample(NormalTexture, NormalTextureSampler, input.tcoordVS);"), c = vtkWebGPUShaderCache$1.substitute(c, "//VTK::TCoord::Impl", p).result, l.setCode(c);
  }, t.shaderReplacements.set("replaceShaderTCoord", e12.replaceShaderTCoord), e12.replaceShaderSelect = (e13, t2, n) => {
    if (e13.includes("sel")) {
      let e14 = t2.getShaderDescription("fragment"), n2 = e14.getCode();
      n2 = vtkWebGPUShaderCache$1.substitute(n2, "//VTK::Select::Impl", ["  var compositeID: u32 = 0u;"]).result, e14.setCode(n2);
    }
  }, t.shaderReplacements.set("replaceShaderSelect", e12.replaceShaderSelect), e12.getUsage = (e13, t2) => e13 === Representation.POINTS || t2 === PrimitiveTypes$2.Points ? BufferUsage.Verts : t2 === PrimitiveTypes$2.Lines ? BufferUsage.Lines : e13 === Representation.WIREFRAME ? t2 === PrimitiveTypes$2.Triangles ? BufferUsage.LinesFromTriangles : BufferUsage.LinesFromStrips : t2 === PrimitiveTypes$2.Triangles ? BufferUsage.Triangles : t2 === PrimitiveTypes$2.TriangleStrips ? BufferUsage.Strips : t2 === PrimitiveTypes$2.TriangleEdges ? BufferUsage.LinesFromTriangles : BufferUsage.LinesFromStrips, e12.getHashFromUsage = (e13) => `pt${e13}`, e12.getTopologyFromUsage = (e13) => {
    switch (e13) {
      case BufferUsage.Triangles:
        return "triangle-list";
      case BufferUsage.Verts:
        return "point-list";
      case BufferUsage.Lines:
      default:
        return "line-list";
    }
  }, e12.buildVertexInput = () => {
    let n = t.currentInput, r = t.cellArray, a = t.primitiveType, o = t.WebGPUActor.getRenderable().getProperty().getRepresentation(), s = t.WebGPURenderWindow.getDevice(), c = false;
    a === PrimitiveTypes$2.TriangleEdges && (c = true, o = Representation.WIREFRAME);
    let l = t.vertexInput, u = n.getPoints(), d = null;
    if (r ? (d = s.getBufferManager().getBuffer({
      hash: `R${o}P${a}${r.getMTime()}`,
      usage: BufferUsage.Index,
      cells: r,
      numberOfPoints: u.getNumberOfPoints(),
      primitiveType: a,
      representation: o
    }), l.setIndexBuffer(d)) : l.setIndexBuffer(null), u) {
      let e13 = t.WebGPUActor.getBufferShift(t.WebGPURenderer);
      l.addBuffer(s.getBufferManager().getBuffer({
        hash: `${u.getMTime()}I${d?.getMTime?.() ?? 0}${e13.join()}float32x4`,
        usage: BufferUsage.PointArray,
        format: "float32x4",
        dataArray: u,
        indexBuffer: d,
        shift: e13,
        packExtra: true
      }), ["vertexBC"]);
    } else
      l.removeBufferIfPresent("vertexBC");
    let f = e12.getUsage(o, a);
    if (t._usesCellNormals = false, !t.is2D && (f === BufferUsage.Triangles || f === BufferUsage.Strips)) {
      let e13 = n.getPointData().getNormals(), o2 = {
        format: "snorm8x4",
        indexBuffer: d,
        packExtra: true,
        shift: 0,
        scale: 127
      };
      e13 ? (o2.hash = `${e13.getMTime()}I${d.getMTime()}snorm8x4`, o2.dataArray = e13, o2.usage = BufferUsage.PointArray, l.addBuffer(s.getBufferManager().getBuffer(o2), ["normalMC"])) : a === PrimitiveTypes$2.Triangles ? (t._usesCellNormals = true, o2.hash = `PFN${u.getMTime()}I${d.getMTime()}snorm8x4`, o2.dataArray = u, o2.cells = r, o2.usage = BufferUsage.NormalsFromPoints, l.addBuffer(s.getBufferManager().getBuffer(o2), ["normalMC"])) : l.removeBufferIfPresent("normalMC");
    } else
      l.removeBufferIfPresent("normalMC");
    let p = false;
    if (t.renderable.getScalarVisibility()) {
      let e13 = t.renderable.getColorMapColors();
      if (e13 && !c) {
        let r2 = t.renderable.getScalarMode(), a2 = (r2 === ScalarMode.USE_CELL_DATA || r2 === ScalarMode.USE_CELL_FIELD_DATA || r2 === ScalarMode.USE_FIELD_DATA || !n.getPointData().getScalars()) && r2 !== ScalarMode.USE_POINT_FIELD_DATA && e13;
        l.addBuffer(s.getBufferManager().getBuffer({
          usage: BufferUsage.PointArray,
          format: "unorm8x4",
          hash: `${a2}${e13.getMTime()}I${d.getMTime()}unorm8x4`,
          dataArray: e13,
          indexBuffer: d,
          cellData: a2,
          cellOffset: 0
        }), ["colorVI"]), p = true;
      }
    }
    p || l.removeBufferIfPresent("colorVI");
    let m = null;
    m = t.renderable.getInterpolateScalarsBeforeMapping?.() && t.renderable.getColorCoordinates() ? t.renderable.getColorCoordinates() : n.getPointData().getTCoords(), m && !c ? l.addBuffer(s.getBufferManager().getBufferForPointArray(m, l.getIndexBuffer()), ["tcoord"]) : l.removeBufferIfPresent("tcoord");
  }, e12.updateTextures = () => {
    let e13 = [], n = [], r = t.renderable.getColorTextureMap?.();
    r && !t.colorTexture && (t.colorTexture = vtkTexture$1.newInstance({ label: "polyDataColor" })), r && (t.colorTexture.setInputData(r), n.push(["DiffuseTexture", t.colorTexture]));
    let a = t.WebGPUActor.getRenderable(), o = t.WebGPURenderer.getRenderable();
    [
      ["DiffuseTexture", a.getProperty().getDiffuseTexture?.()],
      ["DiffuseTexture", a.getTextures()[0]],
      ["DiffuseTexture", t.colorTexture],
      ["ORMTexture", a.getProperty().getORMTexture?.()],
      ["RMTexture", a.getProperty().getRMTexture?.()],
      ["RoughnessTexture", a.getProperty().getRoughnessTexture?.()],
      ["MetallicTexture", a.getProperty().getMetallicTexture?.()],
      ["NormalTexture", a.getProperty().getNormalTexture?.()],
      ["AmbientOcclusionTexture", a.getProperty().getAmbientOcclusionTexture?.()],
      ["EmissionTexture", a.getProperty().getEmissionTexture?.()],
      ["EnvironmentTexture", o.getEnvironmentTexture?.()]
    ].forEach((e14) => {
      let [t2, r2] = e14;
      r2 && ((r2.getInputData() || r2.getJsImageData() || r2.getCanvas() || r2.getImageBitmap()) && n.push([t2, r2]), r2.getImage() && r2.getImageLoaded() && n.push([t2, r2]));
    }), n.forEach((n2) => {
      let [r2, a2] = n2, o2 = t.device.getTextureManager().getTextureForVTKTexture(a2, r2);
      if (!o2.getReady())
        return;
      let s = false;
      for (let n3 = 0; n3 < t.textures.length; ++n3)
        if (t.textures[n3] === o2) {
          s = true, e13[n3] = true;
          break;
        }
      if (!s) {
        e13[t.textures.length] = true;
        let n3 = o2.createView(r2);
        t.textures.push(o2), t.textureViews.push(n3);
        let s2 = a2.getInterpolate() ? "linear" : "nearest", c = null;
        a2.getEdgeClamp() && a2.getRepeat() ? c = "mirror-repeat" : a2.getEdgeClamp() ? c = "clamp-to-edge" : a2.getRepeat() && (c = "repeat");
        let l = {
          addressModeU: c,
          addressModeV: c,
          addressModeW: c,
          minFilter: s2,
          magFilter: s2
        };
        r2 === "EnvironmentTexture" && (l = {
          addressModeU: "repeat",
          addressModeV: "clamp-to-edge",
          addressModeW: "repeat",
          minFilter: s2,
          magFilter: s2,
          mipmapFilter: "linear"
        }), n3.addSampler(t.device, l);
      }
    });
    for (let n2 = t.textures.length - 1; n2 >= 0; n2--)
      e13[n2] || (t.textures.splice(n2, 1), t.textureViews.splice(n2, 1));
  }, e12.computePipelineHash = () => {
    let n = `pd${t.useRendererMatrix ? "r" : ""}${t.forceZValue ? "z" : ""}`;
    if (t.primitiveType === PrimitiveTypes$2.TriangleEdges || t.primitiveType === PrimitiveTypes$2.TriangleStripEdges)
      n += "edge";
    else {
      if (t.vertexInput.hasAttribute("normalMC") && (n += "n"), t.vertexInput.hasAttribute("colorVI") && (n += "c"), t.vertexInput.hasAttribute("tcoord")) {
        let e13 = t.vertexInput.getBuffer("tcoord"), r2 = vtkWebGPUTypes.getNumberOfComponentsFromBufferFormat(e13.getArrayInformation()[0].format);
        n += `t${r2}`;
      }
      t.textures.length && (n += `tx${t.textures.length}`);
    }
    t._usesCellNormals && (n += "cn"), t.SSBO && (n += "ssbo");
    let r = e12.getHashFromUsage(t.usage);
    n += r, n += t.renderEncoder.getPipelineHash(), t.pipelineHash = n;
  }, e12.updateBuffers = () => {
    t.primitiveType !== PrimitiveTypes$2.TriangleEdges && t.primitiveType !== PrimitiveTypes$2.TriangleStripEdges && e12.updateTextures();
    let n = t.WebGPUActor.getRenderable(), r = n.getProperty().getRepresentation();
    t.usage = e12.getUsage(r, t.primitiveType), e12.buildVertexInput();
    let a = t.vertexInput.getBuffer("vertexBC");
    if (e12.setNumberOfVertices(a.getSizeInBytes() / a.getStrideInBytes()), e12.setTopology(e12.getTopologyFromUsage(t.usage)), e12.updateUBO(), e12.haveWideLines()) {
      let t2 = n.getProperty();
      e12.setNumberOfInstances(Math.ceil(t2.getLineWidth() * 2));
    } else
      e12.setNumberOfInstances(1);
  };
}
var DEFAULT_VALUES$5 = {
  is2D: false,
  cellArray: null,
  currentInput: null,
  cellOffset: 0,
  primitiveType: 0,
  colorTexture: null,
  renderEncoder: null,
  textures: null
};
function extend$6(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$5, n), vtkWebGPUSimpleMapper$1.extend(e12, t, n), t.fragmentShaderTemplate = vtkWebGPUPolyDataFS, t.vertexShaderTemplate = vtkWebGPUPolyDataVS, t._tmpMat3 = identity$3(new Float64Array(9)), t._tmpMat4 = identity$2(new Float64Array(16)), t.UBO = vtkWebGPUUniformBuffer$1.newInstance({ label: "mapperUBO" }), t.UBO.addEntry("BCWCMatrix", "mat4x4<f32>"), t.UBO.addEntry("BCSCMatrix", "mat4x4<f32>"), t.UBO.addEntry("MCWCNormals", "mat4x4<f32>"), t.UBO.addEntry("AmbientColor", "vec4<f32>"), t.UBO.addEntry("DiffuseColor", "vec4<f32>"), t.UBO.addEntry("EdgeColor", "vec4<f32>"), t.UBO.addEntry("SpecularColor", "vec4<f32>"), t.UBO.addEntry("AmbientIntensity", "f32"), t.UBO.addEntry("DiffuseIntensity", "f32"), t.UBO.addEntry("Roughness", "f32"), t.UBO.addEntry("Metallic", "f32"), t.UBO.addEntry("Ambient", "f32"), t.UBO.addEntry("Normal", "f32"), t.UBO.addEntry("Emission", "f32"), t.UBO.addEntry("NormalStrength", "f32"), t.UBO.addEntry("BaseIOR", "f32"), t.UBO.addEntry("SpecularIntensity", "f32"), t.UBO.addEntry("LineWidth", "f32"), t.UBO.addEntry("Opacity", "f32"), t.UBO.addEntry("ZValue", "f32"), t.UBO.addEntry("PropID", "u32"), t.UBO.addEntry("ClipNear", "f32"), t.UBO.addEntry("ClipFar", "f32"), t.UBO.addEntry("Time", "u32"), setGet(e12, t, [
    "cellArray",
    "currentInput",
    "cellOffset",
    "is2D",
    "primitiveType",
    "renderEncoder"
  ]), t.textures = [], vtkWebGPUCellArrayMapper(e12, t);
}
var vtkWebGPUCellArrayMapper$1 = {
  newInstance: newInstance(extend$6, "vtkWebGPUCellArrayMapper"),
  extend: extend$6
}, { PrimitiveTypes: PrimitiveTypes$1 } = vtkWebGPUBufferManager$1;
function vtkWebGPUPolyDataMapper(e12, t) {
  t.classHierarchy.push("vtkWebGPUPolyDataMapper"), e12.createCellArrayMapper = () => vtkWebGPUCellArrayMapper$1.newInstance(), e12.buildPass = (n) => {
    if (n) {
      t.WebGPUActor = e12.getFirstAncestorOfType("vtkWebGPUActor"), t.renderable.getStatic() || t.renderable.update();
      let n2 = t.renderable.getInputData();
      t.renderable.mapScalars(n2, 1), e12.updateCellArrayMappers(n2);
    }
  }, e12.updateCellArrayMappers = (n) => {
    if (!n) {
      vtkErrorMacro("No input!");
      return;
    }
    let r = [
      n.getVerts(),
      n.getLines(),
      n.getPolys(),
      n.getStrips()
    ], a = [], o = 0;
    for (let s = PrimitiveTypes$1.Points; s <= PrimitiveTypes$1.TriangleStrips; s++)
      if (r[s].getNumberOfValues() > 0) {
        t.primitives[s] || (t.primitives[s] = e12.createCellArrayMapper());
        let c = t.primitives[s];
        c.setCellArray(r[s]), c.setCurrentInput(n), c.setCellOffset(o), c.setPrimitiveType(s), c.setRenderable(t.renderable), o += r[s].getNumberOfCells(), a.push(c);
      } else
        t.primitives[s] = null;
    if (t.WebGPUActor.getRenderable().getProperty().getEdgeVisibility()) {
      if (r[PrimitiveTypes$1.Triangles].getNumberOfValues() > 0) {
        let o2 = PrimitiveTypes$1.TriangleEdges;
        t.primitives[o2] || (t.primitives[o2] = e12.createCellArrayMapper());
        let s = t.primitives[o2];
        s.setCellArray(r[PrimitiveTypes$1.Triangles]), s.setCurrentInput(n), s.setCellOffset(t.primitives[PrimitiveTypes$1.Triangles].getCellOffset()), s.setPrimitiveType(o2), s.setRenderable(t.renderable), a.push(s);
      } else
        t.primitives[PrimitiveTypes$1.TriangleEdges] = null;
      if (r[PrimitiveTypes$1.TriangleStrips].getNumberOfValues() > 0) {
        let o2 = PrimitiveTypes$1.TriangleStripEdges;
        t.primitives[o2] || (t.primitives[o2] = e12.createCellArrayMapper());
        let s = t.primitives[o2];
        s.setCellArray(r[PrimitiveTypes$1.TriangleStrips]), s.setCurrentInput(n), s.setCellOffset(t.primitives[PrimitiveTypes$1.TriangleStrips].getCellOffset()), s.setPrimitiveType(o2), s.setRenderable(t.renderable), a.push(s);
      } else
        t.primitives[PrimitiveTypes$1.TriangleStripEdges] = null;
    }
    e12.prepareNodes(), e12.addMissingChildren(a), e12.removeUnusedNodes();
  };
}
var DEFAULT_VALUES$4 = { primitives: null };
function extend$5(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$4, n), vtkViewNode$1.extend(e12, t, n), t.primitives = [], vtkWebGPUPolyDataMapper(e12, t);
}
registerOverride("vtkMapper", newInstance(extend$5, "vtkWebGPUPolyDataMapper"));
var { PrimitiveTypes } = vtkWebGPUBufferManager$1;
function vtkWebGPUPolyDataMapper2D(e12, t) {
  t.classHierarchy.push("vtkWebGPUPolyDataMapper2D"), e12.createCellArrayMapper = () => vtkWebGPUCellArrayMapper$1.newInstance(), e12.buildPass = (n) => {
    if (n) {
      t.WebGPUActor = e12.getFirstAncestorOfType("vtkWebGPUActor2D"), t.renderable.getStatic() || t.renderable.update();
      let n2 = t.renderable.getInputData();
      t.renderable.mapScalars(n2, 1), e12.updateCellArrayMappers(n2);
    }
  }, e12.updateCellArrayMappers = (n) => {
    let r = [
      n.getVerts(),
      n.getLines(),
      n.getPolys(),
      n.getStrips()
    ], a = [], o = 0;
    for (let s = PrimitiveTypes.Points; s <= PrimitiveTypes.Triangles; s++)
      if (r[s].getNumberOfValues() > 0) {
        t.primitives[s] || (t.primitives[s] = e12.createCellArrayMapper());
        let c = t.primitives[s];
        c.setCellArray(r[s]), c.setCurrentInput(n), c.setCellOffset(o), c.setPrimitiveType(s), c.setRenderable(t.renderable), c.setIs2D(true), o += r[s].getNumberOfCells(), a.push(c);
      } else
        t.primitives[s] = null;
    e12.prepareNodes(), e12.addMissingChildren(a), e12.removeUnusedNodes();
  };
}
function defaultValues(e12) {
  return {
    primitives: [],
    ...e12
  };
}
function extend$4(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, defaultValues(n)), vtkViewNode$1.extend(e12, t, n), t.primitives = [], vtkWebGPUPolyDataMapper2D(e12, t);
}
registerOverride("vtkMapper2D", newInstance(extend$4, "vtkWebGPUPolyDataMapper2D"));
function vtkWebGPUScalarBarActor(e12, t) {
  t.classHierarchy.push("vtkWebGPUScalarBarActor"), e12.buildPass = (n) => {
    n && (t.WebGPURenderer = e12.getFirstAncestorOfType("vtkWebGPURenderer"), t.WebGPURenderWindow = t.WebGPURenderer.getParent(), t.scalarBarActorHelper.getRenderable() || t.scalarBarActorHelper.setRenderable(t.renderable), e12.prepareNodes(), e12.addMissingNode(t.scalarBarActorHelper.getBarActor()), e12.addMissingNode(t.scalarBarActorHelper.getTmActor()), e12.removeUnusedNodes());
  }, e12.opaquePass = (e13, n) => {
    if (e13) {
      let e14 = t.WebGPURenderer ? t.WebGPURenderer.getRenderable().getActiveCamera() : null, n2 = t.WebGPURenderer.getTiledSizeAndOrigin();
      t.scalarBarActorHelper.updateAPISpecificData([n2.usize, n2.vsize], e14, t.WebGPURenderWindow.getRenderable());
    }
  };
}
var DEFAULT_VALUES$3 = {};
function extend$3(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$3, n), vtkViewNode$1.extend(e12, t, n), t.scalarBarActorHelper = vtkScalarBarActor$1.newScalarBarActorHelper(), vtkWebGPUScalarBarActor(e12, t);
}
registerOverride("vtkScalarBarActor", newInstance(extend$3, "vtkWebGPUScalarBarActor"));
function vtkWebGPUTextureView(e12, t) {
  t.classHierarchy.push("vtkWebGPUTextureView"), e12.create = (e13, n) => {
    t.texture = e13, t.options = n, t.options.dimension = t.options.dimension || "2d", t.options.label = t.label, t.textureHandle = e13.getHandle(), t.handle = t.textureHandle.createView(t.options), t.bindGroupLayoutEntry.texture.viewDimension = t.options.dimension;
    let r = vtkWebGPUTypes.getDetailsFromTextureFormat(t.texture.getFormat());
    t.bindGroupLayoutEntry.texture.sampleType = r.sampleType;
  }, e12.createFromTextureHandle = (e13, n) => {
    t.texture = null, t.options = n, t.options.dimension = t.options.dimension || "2d", t.options.label = t.label, t.textureHandle = e13, t.handle = t.textureHandle.createView(t.options), t.bindGroupLayoutEntry.texture.viewDimension = t.options.dimension;
    let r = vtkWebGPUTypes.getDetailsFromTextureFormat(n.format);
    t.bindGroupLayoutEntry.texture.sampleType = r.sampleType, t.bindGroupTime.modified();
  }, e12.getBindGroupEntry = () => ({ resource: e12.getHandle() }), e12.getShaderCode = (e13, n) => {
    let r = "f32";
    t.bindGroupLayoutEntry.texture.sampleType === "sint" ? r = "i32" : t.bindGroupLayoutEntry.texture.sampleType === "uint" && (r = "u32");
    let a = `@binding(${e13}) @group(${n}) var ${t.label}: texture_${t.options.dimension}<${r}>;`;
    return t.bindGroupLayoutEntry.texture.sampleType === "depth" && (a = `@binding(${e13}) @group(${n}) var ${t.label}: texture_depth_${t.options.dimension};`), a;
  }, e12.addSampler = (n, r) => {
    let a = vtkWebGPUSampler$1.newInstance({ label: `${t.label}Sampler` });
    a.create(n, r), e12.setSampler(a);
  }, e12.getBindGroupTime = () => (t.texture && t.texture.getHandle() !== t.textureHandle && (t.textureHandle = t.texture.getHandle(), t.handle = t.textureHandle.createView(t.options), t.bindGroupTime.modified()), t.bindGroupTime), e12.getHandle = () => (t.texture && t.texture.getHandle() !== t.textureHandle && (t.textureHandle = t.texture.getHandle(), t.handle = t.textureHandle.createView(t.options), t.bindGroupTime.modified()), t.handle);
}
var DEFAULT_VALUES$2 = {
  texture: null,
  handle: null,
  sampler: null,
  label: null
};
function extend$2(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$2, n), macro.obj(e12, t), t.bindGroupLayoutEntry = {
    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
    texture: {
      sampleType: "float",
      viewDimension: "2d"
    }
  }, t.bindGroupTime = {}, macro.obj(t.bindGroupTime, { mtime: 0 }), macro.get(e12, t, ["bindGroupTime", "texture"]), macro.setGet(e12, t, [
    "bindGroupLayoutEntry",
    "label",
    "sampler"
  ]), vtkWebGPUTextureView(e12, t);
}
var vtkWebGPUTextureView$1 = {
  newInstance: macro.newInstance(extend$2),
  extend: extend$2
};
function vtkWebGPUTexture(e12, t) {
  t.classHierarchy.push("vtkWebGPUTexture"), e12.create = (e13, n) => {
    t.device = e13, t.width = n.width, t.height = n.height, t.depth = n.depth ? n.depth : 1;
    let r = t.depth === 1 ? "2d" : "3d";
    t.format = n.format ? n.format : "rgba8unorm", t.mipLevel = n.mipLevel ? n.mipLevel : 0, t.usage = n.usage ? n.usage : GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST, t.handle = t.device.getHandle().createTexture({
      size: [
        t.width,
        t.height,
        t.depth
      ],
      format: t.format,
      usage: t.usage,
      label: t.label,
      dimension: r,
      mipLevelCount: t.mipLevel + 1
    });
  }, e12.assignFromHandle = (e13, n, r) => {
    t.device = e13, t.handle = n, t.width = r.width, t.height = r.height, t.depth = r.depth ? r.depth : 1, t.format = r.format ? r.format : "rgba8unorm", t.usage = r.usage ? r.usage : GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST;
  }, e12.writeImageData = (n) => {
    let r = [], a = (r2) => {
      t.device.getHandle().queue.copyExternalImageToTexture({
        source: r2,
        flipY: n.flip
      }, {
        texture: t.handle,
        premultipliedAlpha: true,
        mipLevel: 0,
        origin: {
          x: 0,
          y: 0,
          z: 0
        }
      }, [
        r2.width,
        r2.height,
        t.depth
      ]), e12.getDimensionality() !== 3 && t.mipLevel > 0 && vtkTexture$1.generateMipmaps(t.device.getHandle(), t.handle, t.mipLevel + 1), t.ready = true;
    };
    if (n.canvas) {
      a(n.canvas);
      return;
    }
    if (n.imageBitmap) {
      n.width = n.imageBitmap.width, n.height = n.imageBitmap.height, n.depth = 1, n.format = "rgba8unorm", n.flip = true, a(n.imageBitmap);
      return;
    }
    if (n.jsImageData) {
      n.width = n.jsImageData.width, n.height = n.jsImageData.height, n.depth = 1, n.format = "rgba8unorm", n.flip = true, a(n.jsImageData);
      return;
    }
    if (n.image) {
      n.width = n.image.width, n.height = n.image.height, n.depth = 1, n.format = "rgba8unorm", n.flip = true, a(n.image);
      return;
    }
    let o = vtkWebGPUTypes.getDetailsFromTextureFormat(t.format), s = t.width * o.stride, c = (e13, t2, n2) => {
      let r2 = o.elementSize === 2 && o.sampleType === "float", a2 = e13.BYTES_PER_ELEMENT, s2 = e13.length / (t2 * n2) * a2;
      if (!r2 && s2 % 256 == 0)
        return [e13, s2];
      let c2 = s2 / a2, l2 = o.elementSize, u2 = 256 * Math.floor((c2 * l2 + 255) / 256), d2 = u2 / l2, f = macro.newTypedArray(r2 ? "Uint16Array" : e13.constructor.name, d2 * t2 * n2), p = t2 * n2;
      if (r2)
        for (let t3 = 0; t3 < p; t3++) {
          let n3 = t3 * c2, r3 = t3 * d2;
          for (let t4 = 0; t4 < c2; t4++)
            f[r3 + t4] = HalfFloat.toHalf(e13[n3 + t4]);
        }
      else if (d2 === c2)
        f.set(e13);
      else
        for (let t3 = 0; t3 < p; t3++)
          f.set(e13.subarray(t3 * c2, (t3 + 1) * c2), t3 * d2);
      return [f, u2];
    };
    n.nativeArray && (r = n.nativeArray);
    let l = e12.getDimensionality() === 3, u = c(r, t.height, l ? t.depth : 1);
    s = u[1];
    let d = u[0];
    t.device.getHandle().queue.writeTexture({
      texture: t.handle,
      mipLevel: 0,
      origin: {
        x: 0,
        y: 0,
        z: 0
      }
    }, d, {
      offset: 0,
      bytesPerRow: s,
      rowsPerImage: t.height
    }, {
      width: t.width,
      height: t.height,
      depthOrArrayLayers: l ? t.depth : 1
    }), !l && t.mipLevel > 0 && vtkTexture$1.generateMipmaps(t.device.getHandle(), t.handle, t.mipLevel + 1), t.ready = true;
  }, e12.getScale = () => {
    let e13 = vtkWebGPUTypes.getDetailsFromTextureFormat(t.format);
    return e13.elementSize === 2 && e13.sampleType === "float" ? 1 : 255;
  }, e12.getNumberOfComponents = () => vtkWebGPUTypes.getDetailsFromTextureFormat(t.format).numComponents, e12.getDimensionality = () => {
    let e13 = 0;
    return t.width > 1 && e13++, t.height > 1 && e13++, t.depth > 1 && e13++, e13;
  }, e12.resizeToMatch = (e13) => {
    (e13.getWidth() !== t.width || e13.getHeight() !== t.height || e13.getDepth() !== t.depth) && (t.width = e13.getWidth(), t.height = e13.getHeight(), t.depth = e13.getDepth(), t.handle = t.device.getHandle().createTexture({
      size: [
        t.width,
        t.height,
        t.depth
      ],
      format: t.format,
      usage: t.usage,
      label: t.label
    }));
  }, e12.resize = function(e13, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    (e13 !== t.width || n !== t.height || r !== t.depth) && (t.width = e13, t.height = n, t.depth = r, t.handle = t.device.getHandle().createTexture({
      size: [
        t.width,
        t.height,
        t.depth
      ],
      format: t.format,
      usage: t.usage,
      label: t.label
    }));
  }, e12.createView = function(n) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    r.dimension ||= t.depth === 1 ? "2d" : "3d";
    let a = vtkWebGPUTextureView$1.newInstance({ label: n });
    return a.create(e12, r), a;
  };
}
var DEFAULT_VALUES$1 = {
  device: null,
  handle: null,
  buffer: null,
  ready: false,
  label: null
};
function extend$1(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES$1, n), macro.obj(e12, t), macro.get(e12, t, [
    "handle",
    "ready",
    "width",
    "height",
    "depth",
    "format",
    "usage"
  ]), macro.setGet(e12, t, ["device", "label"]), vtkWebGPUTexture(e12, t);
}
macro.newInstance(extend$1);
function validateContourSet(e12) {
  if (!e12 || e12.data.length === 0)
    throw Error("Invalid contour set data, see publicContourSetData type for more info");
  if (!e12.id)
    throw Error("Invalid contour set data, each contour set must have an id");
  if (!e12.data || !Array.isArray(e12.data))
    throw Error("Invalid contour set data, each contour set must have an array of contours");
  e12.data.forEach((e13) => {
    if (!e13.points || !Array.isArray(e13.points))
      throw Error("Invalid contour set data, each contour must have an array of points");
    e13.points.forEach((e14) => {
      if (!e14 || !Array.isArray(e14) || e14.length !== 3)
        throw Error("Invalid contour set data, each point must be an array of length 3");
    });
  });
}
var Contour_default = class {
  constructor(e12) {
    let { points: t, type: n } = e12.data;
    this.id = e12.id, this._points = t, this._type = n, this._color = e12.color, this._segmentIndex = e12.segmentIndex, this.sizeInBytes = this._getSizeInBytes();
  }
  _getSizeInBytes() {
    return this._points.length * 3;
  }
  get points() {
    return this._points;
  }
  set points(e12) {
    this._points = e12;
  }
  get color() {
    return this._color;
  }
  set color(e12) {
    this._color = e12;
  }
  get type() {
    return this._type;
  }
  set type(e12) {
    this._type = e12;
  }
  get segmentIndex() {
    return this._segmentIndex;
  }
  set segmentIndex(e12) {
    this._segmentIndex = e12;
  }
  get flatPointsArray() {
    return this._points.map((e12) => [...e12]).flat();
  }
}, ContourSet = class {
  constructor(e12) {
    this._color = [
      200,
      0,
      0
    ], this.id = e12.id, this._contours = [], this._color = e12.color ?? this._color, this.frameOfReferenceUID = e12.frameOfReferenceUID, this._segmentIndex = e12.segmentIndex, this._createEachContour(e12.data), this.sizeInBytes = this._getSizeInBytes();
  }
  _createEachContour(e12) {
    e12.forEach((e13) => {
      let { points: t, type: n, color: r } = e13, a = new Contour_default({
        id: `${this.id}-segment-${this._segmentIndex}`,
        data: {
          points: t,
          type: n,
          segmentIndex: this._segmentIndex,
          color: r ?? this._color
        },
        segmentIndex: this._segmentIndex,
        color: r ?? this._color
      });
      this._contours.push(a);
    }), this._updateContourSetCentroid();
  }
  _updateContourSetCentroid() {
    let e12 = this.totalNumberOfPoints, t = this.flatPointsArray, n = t.reduce((e13, t2) => [
      e13[0] + t2[0],
      e13[1] + t2[1],
      e13[2] + t2[2]
    ], [
      0,
      0,
      0
    ]), r = [
      n[0] / e12,
      n[1] / e12,
      n[2] / e12
    ];
    this._centroid = t.reduce((e13, t2) => this._getDistance(r, t2) < this._getDistance(r, e13) ? t2 : e13, t[0]);
  }
  _getSizeInBytes() {
    return this._contours.reduce((e12, t) => e12 + t.sizeInBytes, 0);
  }
  _getDistance(e12, t) {
    return Math.sqrt((e12[0] - t[0]) ** 2 + (e12[1] - t[1]) ** 2 + (e12[2] - t[2]) ** 2);
  }
  get centroid() {
    return this._centroid;
  }
  get segmentIndex() {
    return this._segmentIndex;
  }
  get color() {
    return this._color;
  }
  set color(e12) {
    this._color = e12, this._contours.forEach((t) => {
      t instanceof Contour_default && (t.color = e12);
    });
  }
  get contours() {
    return this._contours;
  }
  get flatPointsArray() {
    return this._contours.flatMap((e12) => e12.points);
  }
  get numberOfContours() {
    return this._contours.length;
  }
  get totalNumberOfPoints() {
    return this._contours.reduce((e12, t) => e12 + t.points.length, 0);
  }
  get numberOfPointsArray() {
    return this._contours.map((e12) => e12.points.length);
  }
  getPointsInContour(e12) {
    return this._contours[e12].points;
  }
  getNumberOfPointsInAContour(e12) {
    return this.getPointsInContour(e12).length;
  }
};
function createContourSet(e12, t) {
  validateContourSet(t);
  let n = new ContourSet({
    id: t.id,
    data: t.data,
    color: t.color,
    frameOfReferenceUID: t.frameOfReferenceUID,
    segmentIndex: t.segmentIndex ?? 1
  });
  return {
    id: e12,
    type: GeometryType_default.CONTOUR,
    data: n,
    sizeInBytes: n.sizeInBytes
  };
}
function validateSurface(e12) {
  if (!e12.id)
    throw Error("Surface must have an id");
  if (e12.points?.length === 0)
    throw Error("Surface must have non-empty points array");
  if (e12.polys?.length === 0)
    throw Error("Surface must have non-empty polys array");
  if (!e12.frameOfReferenceUID)
    throw Error("Surface must have a frameOfReferenceUID");
}
function createSurface(e12, t) {
  validateSurface(t);
  let n = new Surface({
    id: t.id,
    points: t.points,
    polys: t.polys,
    color: t.color,
    frameOfReferenceUID: t.frameOfReferenceUID,
    segmentIndex: t.segmentIndex ?? 1
  });
  return {
    id: e12,
    type: GeometryType_default.SURFACE,
    data: n,
    sizeInBytes: n.sizeInBytes
  };
}
function validateMesh(e12) {
  if (!e12.id)
    throw Error("Mesh must have an id");
  if (!e12.arrayBuffer)
    throw Error("Mesh must have an arrayBuffer");
  if (!(e12.format in MeshType_default))
    throw Error(`Mesh format must be one of the following: ${Object.values(MeshType_default).join(", ")}`);
}
function vtkMTLReader(e12, t) {
  t.classHierarchy.push("vtkMTLReader");
  function n() {
    t.requestCount--, t.requestCount === 0 && e12.invokeBusy(false);
  }
  function r(e13) {
    if (e13[0] === "#" || e13.length === 0)
      return;
    let r2 = e13.split(/[ \t]+/).map((e14) => e14.trim()).filter((e14) => e14.length);
    if (r2[0] === "newmtl")
      r2.shift(), t.currentMaterial = r2.join(" ").trim();
    else if (t.currentMaterial) {
      if (r2.length < 2)
        return;
      if (t.materials[t.currentMaterial] || (t.materials[t.currentMaterial] = {}), t.materials[t.currentMaterial][r2[0]] = r2.slice(1), r2[0] === "map_Kd") {
        let e14 = new Image();
        e14.onload = () => setTimeout(n, 0), e14.src = [t.baseURL, r2[1]].join("/"), t.materials[t.currentMaterial].image = e14, t.requestCount++;
      }
    }
  }
  t.dataAccessHelper ||= DataAccessHelper.get("http");
  function a(n2, r2) {
    return t.dataAccessHelper.fetchText(e12, n2, r2);
  }
  e12.setUrl = function(n2) {
    let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (n2.indexOf(".mtl") === -1 && !r2.fullpath)
      t.baseURL = n2, t.url = `${n2}/index.mtl`;
    else {
      t.url = n2;
      let e13 = n2.split("/");
      e13.pop(), t.baseURL = e13.join("/");
    }
    return e12.loadData(r2);
  }, e12.loadData = (n2) => new Promise((r2, o) => {
    a(t.url, n2).then((t2) => {
      e12.parseAsText(t2), r2();
    }, (e13) => {
      o();
    });
  }), e12.parseAsText = (n2) => {
    e12.modified(), t.materials = {}, n2.split("\n").forEach(r);
  }, e12.isBusy = () => !!t.requestCount, e12.getMaterialNames = () => Object.keys(t.materials), e12.getMaterial = (e13) => t.materials[e13], e12.listImages = () => Object.keys(t.materials).map((e13) => t.materials[e13].map_Kd).filter((e13) => !!e13).map((e13) => e13[0].trim()), e12.setImageSrc = (e13, n2) => new Promise((r2, a2) => {
    let o = Object.keys(t.materials).find((n3) => t.materials[n3].map_Kd && t.materials[n3].map_Kd[0].trim() === e13.trim()), s = t.materials[o];
    s && s.image ? (s.image.src = n2, s.image.onload = () => setTimeout(r2, 0)) : r2();
  }), e12.applyMaterialToActor = (e13, n2) => {
    let r2 = t.materials[e13];
    if (r2 && n2) {
      let e14 = [
        1,
        1,
        1
      ], a2 = {
        ambientColor: r2.Ka ? r2.Ka.map((e15) => Number(e15)) : e14,
        specularColor: r2.Ks ? r2.Ks.map((e15) => Number(e15)) : e14,
        diffuseColor: r2.Kd ? r2.Kd.map((e15) => Number(e15)) : e14,
        opacity: r2.d ? Number(r2.d) : 1,
        specularPower: r2.Ns ? Number(r2.Ns) : 1
      }, o = Number(r2.illum || 2);
      if ([
        "ambient",
        "diffuse",
        "specular"
      ].forEach((e15, t2) => {
        a2[e15] = t2 <= o ? 1 : 0;
      }), r2.image) {
        let e15 = vtkTexture$1.newInstance({ interpolate: t.interpolateTextures });
        e15.setImage(r2.image), n2.addTexture(e15);
      }
      n2.getProperty().set(a2);
    }
  };
}
var DEFAULT_VALUES = {
  numberOfOutputs: 1,
  requestCount: 0,
  materials: {},
  interpolateTextures: true
};
function extend(e12, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Object.assign(t, DEFAULT_VALUES, n), obj(e12, t), get(e12, t, ["url", "baseURL"]), setGet(e12, t, [
    "dataAccessHelper",
    "interpolateTextures",
    "splitGroup"
  ]), event(e12, t, "busy"), vtkMTLReader(e12, t);
}
var vtkMTLReader$1 = {
  newInstance: newInstance(extend, "vtkMTLReader"),
  extend
};
function createMesh(e12, t) {
  validateMesh(t);
  let n = new Mesh({ ...t }), r = {
    id: e12,
    type: GeometryType_default.MESH,
    data: n,
    sizeInBytes: n.sizeInBytes
  };
  switch (t.format) {
    case MeshType_default.PLY:
      if (t.materialUrl) {
        let e13 = new Image();
        return new Promise((a, o) => {
          e13.onload = () => {
            try {
              let t2 = vtkTexture$1.newInstance();
              t2.setInterpolate(true), t2.setImage(e13), n.defaultActor.addTexture(t2), a(r);
            } catch (e14) {
              o(e14);
            }
          }, e13.onerror = (e14) => o(e14), e13.src = t.materialUrl;
        });
      }
      return Promise.resolve(r);
    case MeshType_default.OBJ:
      if (t.materialUrl) {
        let e13 = vtkMTLReader$1.newInstance();
        return e13.setUrl(t.materialUrl).then(() => {
          for (let t2 = 0; t2 < n.actors.length; t2++) {
            let r2 = n.actors[t2], a = r2.getMapper();
            if (a) {
              let t3 = a.getInputData();
              if (t3) {
                let n2 = t3.get("name").name;
                e13.applyMaterialToActor(n2, r2);
              }
            }
          }
          return r;
        }).catch((e14) => {
          throw Error(`Failed to load material: ${e14}`);
        });
      }
      return Promise.resolve(r);
    case MeshType_default.STL:
    case MeshType_default.VTP:
      return Promise.resolve(r);
    default:
      return Promise.reject(/* @__PURE__ */ Error(`Unsupported format: ${t.format}`));
  }
}
function fetchArrayBuffer({ url: e12, signal: t, onload: n, loaderOptions: r }) {
  return new Promise(async (o, s) => {
    let c = new XMLHttpRequest();
    c.open("GET", e12, true);
    let l = {}, u = await r.beforeSend(c, l), d = Object.assign({}, l, u);
    c.responseType = "arraybuffer", Object.keys(d).forEach(function(e13) {
      d[e13] !== null && c.setRequestHeader(e13, d[e13]);
    });
    let f = function(e13) {
      n && typeof n == "function" && n(), t && t.removeEventListener("abort", p), o(c.response);
    }, p = () => {
      c.abort(), c.removeEventListener("load", f), s(/* @__PURE__ */ Error("Request aborted"));
    };
    c.addEventListener("load", f);
    let m = (t2, n2) => {
      let r2 = {
        url: e12,
        loaded: t2,
        total: n2
      };
      triggerEvent(eventTarget_default, Events_default.GEOMETRY_LOAD_PROGRESS, { data: r2 });
    };
    c.onprogress = function(e13) {
      m(e13.loaded, e13.total);
    }, t && t.aborted ? (c.abort(), s(/* @__PURE__ */ Error("Request aborted"))) : t && t.addEventListener("abort", p), c.send();
  });
}
function cornerstoneMeshLoader(e12, t, n) {
  return {
    promise: new Promise((r, a) => {
      fetchAndProcessMeshData(e12, t, n).then(r).catch(a);
    }),
    cancelFn: void 0,
    decache: () => {
    }
  };
}
async function fetchAndProcessMeshData(e12, t, n) {
  let r = e12.split(":").slice(1).join(":"), a = await fetchArrayBuffer({
    url: r,
    loaderOptions: n
  });
  if (!t || !("geometryData" in t))
    throw Error("Mesh must have a geometryData");
  return createMesh(r, {
    ...t.geometryData,
    arrayBuffer: a
  });
}
var loaderOptions = { beforeSend(e12) {
} }, geometryLoaders = {}, unknownGeometryLoader;
function loadGeometryFromGeometryLoader(e12, t) {
  let n = e12.indexOf(":"), r = e12.substring(0, n), o = geometryLoaders[r];
  if (o == null) {
    if (unknownGeometryLoader == null || typeof unknownGeometryLoader != "function")
      throw Error(`No geometry loader for scheme ${r} has been registered`);
    o = unknownGeometryLoader;
  }
  let s = o(e12, t, loaderOptions);
  return s.promise.then(function(e13) {
    triggerEvent(eventTarget_default, Events_default.GEOMETRY_LOADED, { geometry: e13 });
  }, function(t2) {
    let n2 = {
      geometryId: e12,
      error: t2
    };
    triggerEvent(eventTarget_default, Events_default.GEOMETRY_LOADED_FAILED, n2);
  }), s;
}
async function loadAndCacheGeometry(e12, t) {
  if (e12 === void 0)
    throw Error("createAndCacheGeometry: parameter geometryId must not be undefined");
  let n = cache_default.getGeometryLoadObject(e12);
  return n === void 0 ? (n = loadGeometryFromGeometryLoader(e12, t), await cache_default.putGeometryLoadObject(e12, n), n.promise) : n.promise;
}
function createAndCacheGeometry(e12, t) {
  if (e12 === void 0)
    throw Error("createAndCacheGeometry: parameter geometryId must not be undefined");
  let n = cache_default.getGeometry(e12);
  if (n)
    return n;
  if (t.type === GeometryType_default.CONTOUR)
    n = createContourSet(e12, t.geometryData);
  else if (t.type === GeometryType_default.SURFACE)
    n = createSurface(e12, t.geometryData);
  else if (t.type === GeometryType_default.MESH)
    createMesh(e12, t.geometryData).then((e13) => {
      n = e13;
    });
  else
    throw Error(`Unknown geometry type: ${t.type}`);
  return cache_default.putGeometrySync(e12, n), n;
}
function registerGeometryLoader(e12, t) {
  geometryLoaders[e12] = t;
}
registerGeometryLoader("mesh", cornerstoneMeshLoader);
function applyDecimatedVolumeModifiers(e12, t, n) {
  return t.reduce((e13, t2) => t2.apply(e13, n), e12);
}
const inPlaneDecimationModifier = {
  name: "InPlaneDecimationModifier",
  apply(e12, t) {
    let [n = 1, r = n] = t.options.ijkDecimation ?? [], a = Math.max(1, Math.floor(n)), o = Math.max(1, Math.floor(r));
    if (a === 1 && o === 1)
      return e12;
    let [s, c] = e12.dimensions, l = Math.max(1, Math.floor(s / a)), u = Math.max(1, Math.floor(c / o)), d = [
      l,
      u,
      e12.dimensions[2]
    ], f = [
      e12.spacing[0] * a,
      e12.spacing[1] * o,
      e12.spacing[2]
    ], p = {
      ...e12.metadata,
      Columns: l,
      Rows: u,
      PixelSpacing: [f[1], f[0]]
    };
    return {
      ...e12,
      dimensions: d,
      spacing: f,
      metadata: p
    };
  }
};
function decimatedVolumeLoader(e12, t) {
  if (!t || !t.imageIds || !t.imageIds.length)
    throw Error("ImageIds must be provided to create a streaming image volume ");
  let [n = 1, r = n, a = 1] = t.ijkDecimation ?? [], o = Math.max(1, Math.floor(n)), s = r > 1 ? Math.max(1, Math.floor(r)) : o, c = Math.max(1, Math.floor(a)), l = o > 1 || s > 1, u = { ijkDecimation: [
    o,
    s,
    c
  ] }, d = [inPlaneDecimationModifier];
  function f(e13, t2) {
    return t2 === 1 ? e13 : `${e13}#decimation=${t2}`;
  }
  let p = Math.floor(t.imageIds.length / c), m = c > 1 && t.imageIds.length <= p + 1;
  if (c > 1 && !m) {
    let e13 = decimate(t.imageIds, c);
    t.imageIds = Array.isArray(e13) && e13.length && typeof e13[0] == "number" ? e13.map((e14) => t.imageIds[e14]) : e13;
  }
  o > 1 && (t.imageIds = t.imageIds.map((e13) => f(e13, o)));
  async function h() {
    let { dimensions: n2, spacing: r2, origin: a2, direction: o2, metadata: s2, imageIds: c2, dataType: f2, numberOfComponents: p2 } = applyDecimatedVolumeModifiers(generateVolumePropsFromImageIds(t.imageIds, e12), d, {
      volumeId: e12,
      imageIds: t.imageIds,
      options: u
    }), m2 = new StreamingImageVolume({
      volumeId: e12,
      metadata: s2,
      dimensions: n2,
      spacing: r2,
      origin: a2,
      direction: o2,
      imageIds: c2,
      dataType: f2,
      numberOfComponents: p2
    }, {
      imageIds: c2,
      loadStatus: {
        loaded: false,
        loading: false,
        cancelled: false,
        cachedFrames: [],
        callbacks: []
      }
    });
    if (l) {
      let e13 = m2.imageData;
      e13 && (e13.setDimensions(m2.dimensions), e13.setSpacing(m2.spacing), e13.modified());
      let t2 = VoxelManager.createImageVolumeVoxelManager({
        dimensions: m2.dimensions,
        imageIds: m2.imageIds,
        numberOfComponents: p2
      });
      m2.voxelManager = t2, e13 && e13.set({ voxelManager: t2 });
    }
    return m2;
  }
  let g = h();
  return {
    promise: g,
    decache: () => {
      g.then((e13) => {
        e13.destroy(), e13 = null;
      });
    },
    cancel: () => {
      g.then((e13) => {
        e13.cancelLoading();
      });
    }
  };
}
export {
  ContextPoolRenderingEngine_default as $,
  copy$3 as $n,
  ViewportStatus_default as $r,
  loadImage as $t,
  getEnabledElementByViewportId as A,
  vtkCellArray$1 as An,
  vtkMath as Ar,
  getTargetVolumeAndSpacingInNormalDir as At,
  DefaultHistoryMemo as B,
  toWindowLevel as Bn,
  isCornerstoneInitialized as Br,
  createLocalVolume as Bt,
  convertToGrayscale as C,
  vtkPolyLine$1 as Cn,
  degreesFromRadians as Cr,
  Viewport_default as Ct,
  isValidVolume as D,
  vtkCellTypes$1 as Dn,
  normalize$1 as Dr,
  planeDistanceToPoint as Dt,
  isVideoTransferSyntax as E,
  vtkLine$1 as En,
  norm as Er,
  linePlaneIntersection as Et,
  getCurrentVolumeViewportSlice as F,
  vtkPlane as Fn,
  canRenderFloatTextures as Fr,
  createVolumeMapper as Ft,
  getMinMax as G,
  isNumber as Gn,
  deepMerge_default as Gr,
  StreamingImageVolume as Gt,
  indexWithinDimensions as H,
  isImageActor as Hn,
  setPreferSizeOverAccuracy as Hr,
  registerVolumeLoader as Ht,
  getClosestStackImageIndexForPoint as I,
  vtkPlane$1 as In,
  getConfiguration as Ir,
  createAndCacheDerivedLabelmapVolume as It,
  vtkXMLPolyDataReader$1 as J,
  create$2 as Jn,
  constants_exports as Jr,
  generateVolumePropsFromImageIds as Jt,
  MultiTargetEventListenerManager as K,
  cache_default as Kn,
  getRenderingEngine as Kr,
  ProgressiveRetrieveImages_default as Kt,
  getViewportsWithImageURI as L,
  vtkImplicitFunction$1 as Ln,
  getShouldUseCPURendering as Lr,
  createAndCacheVolume as Lt,
  getViewportImageCornersInWorld as M,
  STATIC$13 as Mn,
  macro as Mr,
  getSpacingInNormalDirection as Mt,
  calculateViewportsSpatialRegistration_default as N,
  extend$136 as Nn,
  triggerEvent as Nr,
  createVolumeActor_default as Nt,
  getEnabledElement as O,
  CellType as On,
  radiansFromDegrees as Or,
  planeEquation as Ot,
  spatialRegistrationMetadataProvider_default as P,
  newInstance$130 as Pn,
  eventTarget_default as Pr,
  convertMapperToNotSharedMapper as Pt,
  RenderingEngine_default as Q,
  transformMat4 as Qn,
  MetadataModules_default as Qr,
  loadAndCacheImages as Qt,
  imageToWorldCoords as R,
  transformWorldToIndex as Rn,
  getWebWorkerManager as Rr,
  createAndCacheVolumeFromImages as Rt,
  getViewportImageIds_default as S,
  vtkTriangle$1 as Sn,
  VtkDataTypes as Sr,
  getVolumeViewportScrollInfo_default as St,
  roundToPrecision as T,
  DesiredOutputPrecision as Tn,
  dot as Tr,
  isPointOnPlane as Tt,
  isOpposite as U,
  isEqual as Un,
  uuidv4 as Ur,
  volumeLoader_exports as Ut,
  historyMemo_exports as V,
  windowLevel_exports as Vn,
  peerImport as Vr,
  loadVolume as Vt,
  getRuntimeId as W,
  isEqualAbs as Wn,
  expose as Wr,
  cornerstoneStreamingImageVolumeLoader as Wt,
  BinaryHelper as X,
  normalize$2 as Xn,
  enums_exports as Xr,
  createAndCacheDerivedLabelmapImages as Xt,
  DataAccessHelper as Y,
  getAxisAngle as Yn,
  epsilon_default as Yr,
  createAndCacheDerivedImage as Yt,
  Surface as Z,
  slerp as Zn,
  GenerateImageType as Zr,
  loadAndCacheImage as Zt,
  jumpToSlice as _,
  vtkTransform$1 as _n,
  multiply$2 as _r,
  getOrCreateCanvas as _t,
  STATIC as a,
  ViewportType_default as ai,
  metaData_exports as an,
  length$2 as ar,
  VideoViewport_default as at,
  deepEqual as b,
  vtkPolyData$1 as bn,
  vtkColorTransferFunction$1 as br,
  getImageDataMetadata as bt,
  vtkTexture$1 as c,
  getProjectionScaleMatrix as cn,
  scale$3 as cr,
  setVolumesForViewports_default as ct,
  imageRetrievalPoolManager_default as d,
  vtkLight$1 as dn,
  transformMat4$1 as dr,
  transformIndexToWorld as dt,
  CalibrationTypes_default as ei,
  registerImageLoader as en,
  create$4 as er,
  TiledRenderingEngine_default as et,
  getViewportModality as f,
  vtkCamera$1 as fn,
  clone$3 as fr,
  StackViewport_default as ft,
  createSubVolume as g,
  vtkImageData$1 as gn,
  invert as gr,
  createViewportElement as gt,
  getVolumeDirectionVectors as h,
  pointInShapeCallback as hn,
  getScaling as hr,
  createCanvas as ht,
  cornerstoneMeshLoader as i,
  BlendModes_default as ii,
  getNormalized as in,
  fromValues$3 as ir,
  WSIViewport_default as it,
  getEnabledElements as j,
  vtkBoundingBox as jn,
  require___vite_browser_external as jr,
  getVolumeId as jt,
  getEnabledElementByIds as k,
  vtkPoints$1 as kn,
  subtract as kr,
  threePlaneIntersection as kt,
  basis_default as l,
  vtkActor$1 as ln,
  set$4 as lr,
  VolumeViewport3D_default as lt,
  calculateNeighborhoodStats as m,
  VoxelManager as mn,
  fromRotationTranslationScale as mr,
  EPSILON as mt,
  createAndCacheGeometry as n,
  GeometryType_default as ni,
  addProvider as nn,
  dot$3 as nr,
  convertColorArrayToRgbString as nt,
  extend$16 as o,
  RequestType_default as oi,
  removeProvider as on,
  lerp$2 as or,
  addImageSlicesToViewports_default as ot,
  utilities_exports as p,
  vtkMapper$1 as pn,
  create$5 as pr,
  getClosestImageId as pt,
  vtkPolyDataNormals$1 as q,
  imageIdToURI as qn,
  getRenderingEngines as qr,
  getViewportsWithVolumeId_default as qt,
  loadAndCacheGeometry as r,
  OrientationAxis_default as ri,
  getMetaData as rn,
  equals$3 as rr,
  ECGViewport_default as rt,
  newInstance$17 as s,
  Events_default as si,
  ImageVolume_default as sn,
  normalize$4 as sr,
  addVolumesToViewports_default as st,
  decimatedVolumeLoader as t,
  MeshType_default as ti,
  imageLoadPoolManager_default as tn,
  cross$1 as tr,
  BaseRenderingEngine_default as tt,
  Settings as u,
  vtkRenderer$1 as un,
  subtract$3 as ur,
  VolumeViewport_default as ut,
  scroll as v,
  vtkCubeSource$1 as vn,
  transpose as vr,
  updateCanvasSizeAndAspectRatio as vt,
  roundNumber_default as w,
  AttributeTypes$1 as wn,
  distance2BetweenPoints as wr,
  deepClone as wt,
  getRandomSampleFromArray as x,
  vtkQuad$1 as xn,
  vtkDataArray$1 as xr,
  BaseVolumeViewport_default as xt,
  clip_default as y,
  vtkMatrixBuilder as yn,
  vtkPiecewiseFunction$1 as yr,
  updateVTKImageDataWithCornerstoneImage as yt,
  worldToImageCoords_default as z,
  toLowHighRange as zn,
  init as zr,
  createAndCacheVolumeFromImagesSync as zt
};
